/*! For license information please see skyward.bundle_entry.js.LICENSE.txt */
(()=>{var __webpack_modules__={85596(e,t,n){"use strict";n.r(t),n.d(t,{logAjaxError:()=>d,processAjaxError:()=>c});var a=n(79126),o=n(88157),r=n(92214);const i=window.skyward;let s=!1;$(document).ajaxError(c);const l={dialog:function(){const e=$(this).data();(0,o.showErrorDialog)(e.message,e.description)}};function c(e,t,n){if(null==n||!(!0===n.suppressErrors||"function"==typeof n.suppressErrors&&n.suppressErrors(t)))switch(t.status){case 401:"Invalid session"===t.responseText?window.location.replace(window.location.href):u(t.responseText);break;case 403:var a=null!=n&&null!=n.activityIndicator&&n.activityIndicator.isWorkflowAjaxRequest;if("SessionChanged"===t.getResponseHeader("X-Forbidden-Reason")){if(s)break;s=!0,u(t.responseText,a).always(()=>{s=!1})}else u(t.responseText,a);break;case 500:const e=d(t);e.primaryKey&&e.primaryKey>0?(0,o.showErrorDialog)("Internal Server Error","There was an error processing your request ("+e.primaryKey+"):\n"+e.message):(0,o.showErrorDialog)("Internal Server Error","There was an error processing your request:\n"+e.message)}}function d(e){const t={message:"Unknown error.",severity:"",primaryKey:null};if(e.responseText){try{const n=JSON.parse(e.responseText);null!==n&&(t.message=n.message,t.severity=n.severity,t.primaryKey=n.primaryKey,t.showViewLog=n.showViewLog)}catch(n){t.message="An additional error occurred while processing the error data.",console.warn("Unparsable error data",e.responseText)}let n=new a.SkywardException("A server-side error occurred");t.primaryKey?n.details=JSON.stringify({primaryKey:t.primaryKey}):n.details=JSON.stringify(t),(0,a.reportException)(n)}return t}function u(e,t){let n={};var a;t&&(n={afterClose:null===(a=i.workflow)||void 0===a?void 0:a.closeWorkflowPopup});return(0,o.showErrorDialog)("Forbidden Access",null!=e?e:"You do not have the correct permissions to perform this task.",n)}(0,r.registerEvents)("error",l)},60977(e,t,n){"use strict";n.r(t),n.d(t,{DUPLICATE_REQUEST_HANDLING:()=>a,createAjaxManager:()=>i});let a=function(e){return e[e.ABORT_PRIOR=1]="ABORT_PRIOR",e[e.ABORT_NEW=2]="ABORT_NEW",e[e.QUEUE=3]="QUEUE",e}({});const o={requestsStarted:function(){},update:function(){},requestsCompleted:function(){},defaultDuplicateRequestHandling:a.ABORT_PRIOR},r={requestID:null,duplicateRequestHandling:null};function i(e){const t={ajax:function(e,t){const o=$.extend({},r,t);return function(e,t){const o=$.Deferred();let r;const c=function(e){const t=[];if(null==e.requestID)return t;const n=i.getCurrentRequests();for(let a=0;a<n.length;a++)n[a]._requestID==e.requestID&&t.push(n[a]);return t}(t),d=null!=t.duplicateRequestHandling?t.duplicateRequestHandling:n.defaultDuplicateRequestHandling;r=d==a.QUEUE?function(e,t,n){const a=t.promise();let o=!1;return a.abort=function(){o=!0,s(t,n)},$.when.apply($,e).always(function(){o||l(t,n)}),a}(c,o,e):d==a.ABORT_PRIOR?l(o,e):c.length>0?s(o,e):l(o,e);if(r._requestID=t.requestID,i.add(r),d==a.ABORT_PRIOR)for(var u=0;u<c.length;u++)c[u].abort();return r}(e,o)}},n=$.extend({},o,e),i=function(){const e={getCurrentRequests:function(){const e=[];for(let t=0;t<a.length;t++)"pending"==a[t].state()&&e.push(a[t]);return e},add:function(e){t||(t=!0,n.requestsStarted(r()));a.push(e),e.always(function(){o++,n.update(r()),o==a.length&&(n.requestsCompleted(r()),t=!1,a=[],o=0)})}};let t=!1,a=[],o=0;return e;function r(){return{numberOfCurrentRequests:e.getCurrentRequests().length,numberOfCompletedRequests:o,numberOfTotalRequests:a.length}}}();return t;function s(e,t){return l(e,$.extend({},t,{beforeSend:function(){return!1}}))}function l(e,t){const n=e.promise(),a=$.ajax(t);return a.done(function(){e.resolve.apply(this,arguments)}),a.fail(function(){e.reject.apply(this,arguments)}),n.abort=function(){a.abort()},n}}},92599(e,t,n){"use strict";n.r(t),n.d(t,{activeThemeRef:()=>g,changeAlpha:()=>r,hexToRGBA:()=>i,isDarkColor:()=>f,makeThemeColorGetter:()=>p,parseHexColor:()=>o,rgbToHex:()=>s,setColorAlpha:()=>u});var a=n(74061);function o(e){let t=String(e).replace(/[^0-9a-f]/gi,"");t.length<6&&(t=t[0]+t[0]+t[1]+t[1]+t[2]+t[2]);return{red:c(t,0),green:c(t,2),blue:c(t,4),luminate:function(e,t){var n=e||0;this.red=d(this.red,n,t),this.green=d(this.green,n,t),this.blue=d(this.blue,n,t)},toHex:function(){return"#"+l(this.red)+l(this.green)+l(this.blue)}}}function r(e,t){if(0===e.indexOf("#"))return i(e,t);const n=e.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);return n?"rgba(".concat(n[1],", ").concat(n[2],", ").concat(n[3],", ").concat(t,")"):e}function i(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;if(3!==(e=e.replace("#","")).length&&6!==e.length)throw new Error("Invalid HEX color.");3===e.length&&(e=e.split("").map(e=>e+e).join(""));const n=parseInt(e.substring(0,2),16),a=parseInt(e.substring(2,4),16),o=parseInt(e.substring(4,6),16);return"rgba(".concat(n,", ").concat(a,", ").concat(o,", ").concat(t,")")}function s(e){const t=[...e.matchAll(/\d+/g)].map(e=>e[0]),n=parseInt(t[0]),a=parseInt(t[1]),o=parseInt(t[2]),r=null!=t[3]?parseInt(t[3]):1,i=l(n),s=l(a),c=l(o);return{Red:i,Green:s,Blue:c,Alpha:r,Value:"#".concat(i).concat(s).concat(c)}}function l(e){return e.toString(16).padStart(2,"0")}function c(e,t){return parseInt(e.substr(t,2),16)}function d(e,t,n){let a=e*t;return Math.abs(a)<n&&(a=a<0?-1*n:n),Math.round(Math.min(Math.max(0,e+a),255))}function u(e,t){const n=h(e);return n?"rgba(".concat(n.r,",").concat(n.g,",").concat(n.b,",").concat(t,")"):e}function f(e){const t=h(e);if(!t)return!1;return(.299*t.r+.587*t.g+.114*t.b)/255<.5}function h(e){const t=e.slice(0,1);return"#"===t?function(e){let t;if(4===e.length)return t=e.replace("#","").split(""),{r:n(t[0]+t[0]),g:n(t[1]+t[1]),b:n(t[2]+t[2])};return{r:n(e.slice(1,3)),g:n(e.slice(3,5)),b:n(e.slice(5))};function n(e){return parseInt(e,16)}}(e):"r"===t.toLowerCase()?function(e){let t,n=e.slice(e.indexOf("(")+1,e.indexOf(")")).split(","),a=!1;n=n.map(function(e,t){return 3!==t?parseInt(e,10):a=!0,parseFloat(e)}),t={r:n[0],g:n[1],b:n[2]},a&&(t.a=n[3]);return t}(e):void 0}function p(e){const t=getComputedStyle(e);return new Proxy(t,{get:(e,n)=>(n.includes("-")||(n="--sky-"+n.toDisplayName().toLowerCase().replace(/ /g,"-")),t.getPropertyValue(n))})}const m=p(document.body),g=(0,a.shallowRef)(m);$(document.body).on("themeSwap",()=>{(0,a.triggerRef)(g)})},79126(e,t,n){"use strict";function a(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function o(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?a(Object(n),!0).forEach(function(t){r(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):a(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function r(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}n.r(t),n.d(t,{CancellationError:()=>x,Severity:()=>s,SkywardException:()=>i,getCallerLocation:()=>P,registerErrorDataGatherer:()=>k,reportException:()=>S});class i extends Error{constructor(e,t,n,a){super(e),r(this,"details",void 0),r(this,"severity",s.Error),r(this,"applicationMonitoringIdentifier",void 0),this.details=t,this.applicationMonitoringIdentifier=a,n&&(this.severity=n)}}let s=function(e){return e.Debug="Debug",e.Info="Info",e.Error="Error",e.SupportInfo="SupportInfo",e}({});const l=[/debugger eval code/,/evaluateWithScopeExtension@[native code]/,/extension:\/\//],c=[/^Script error\.?$/,/^Javascript error: Script error\.? on line 0$/,/^Cannot redefine property: googletag$/,/undefined is not an object \(evaluating 'a.L'\)/],d=/^\[object \w+\]$/,u=4e3,f=/(?:^|[ \t(])[^()\s?]*\.(?:js|tsx?)(?:\?[^\s():]*)?:\d+:\d+/i,h="__skywardChunkLoadReloadTimestamp",p=3e5;let m=0;const g=Object.create(null),w=Object.create(null);let v=[];function b(e,t,n){var a;const o=e instanceof Error?e:{message:String(e),stack:void 0};return{message:null!=t?t:null==o?void 0:o.message,location:null!=n?n:E(null==o?void 0:o.stack),stack:null==o||null===(a=o.stack)||void 0===a?void 0:a.toString()}}function y(e,t){if(!function(e,t){var n,a;if(!(e instanceof Error))return!1;const o="".concat(null!==(n=e.name)&&void 0!==n?n:""," ").concat(null!==(a=e.message)&&void 0!==a?a:""," ").concat(null!=t?t:"");return/chunkloaderror|loading chunk \d+ failed|runtime-13/i.test(o)}(e,t))return!1;if(!function(){try{const e=sessionStorage.getItem(h);if(null===e)return!0;const t=Number(e);return!!Number.isNaN(t)||Date.now()-t>p}catch(e){return!1}}())return!1;try{sessionStorage.setItem(h,String(Date.now()))}catch(e){}const n=o(o({},b(e)),void 0!==t?{context:t}:{});return function(e){let t=!1,n=0;const a=()=>{if(window.clearTimeout(n),!t){t=!0;try{window.location.reload()}catch(e){}}};n=window.setTimeout(a,1500);try{const t=S(e);void 0!==t&&"function"==typeof t.then?t.then(a,a):a()}catch(e){a()}}(new i("Detected webpack chunk load failure. Reloading page to recover from stale asset references (limited to once per ".concat(5," minutes)."),JSON.stringify(n),s.Info)),!0}function _(e){const t=document.createElement("span");return t.textContent=e,t.innerHTML}function C(){return{then:C}}function k(e,t){g[e]?console.warn('There is already an error data gatherer registered as "'.concat(e,'"')):g[e]=t}function S(e,t){try{return O(e,void 0,t)}catch(e){return n=null,null!==(a=null!==(o=null===(r=window.Promise)||void 0===r?void 0:r.reject(n))&&void 0!==o?o:null===(i=window.jQuery)||void 0===i?void 0:i.Deferred().reject(n))&&void 0!==a?a:C()}var n,a,o,r,i}function D(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];const n=function(e){return-1!==e.indexOf("skyward.base.error.")?4:t.some(t=>-1!==e.indexOf(t))?3:-1===e.indexOf(".ts")&&-1===e.indexOf(".js")?5:-1===e.indexOf("skyward")?-1!==e.indexOf(".ts")||-1!==e.indexOf(".js")?1:2:0};let a=1/0,o="";for(let t of e){const e=n(t);e<a&&(a=e,o=t)}return o}function E(e){if(!e)return;return D(e.split("\n").filter(e=>-1!=e.indexOf(":")))}function P(){try{const e=(new Error).stack;if(!e)return;const t=e.split("\n").filter(e=>-1!=e.indexOf(":")),n=[];if(t.length<3)return t[0];const a=/(skyward[.\w]+.js[\w=?&%]*):(\d+):\d+/.exec(t[1]);if(a){const[,e,t]=a;-1!==e.indexOf("bundle.js")?n.push("".concat(e,":").concat(t,":")):n.push(e)}return D(t,n)}catch(e){return""}}function O(e,t,n){var a,o,r;const d=e instanceof i?e.severity:null;if(e.hasOwnProperty("reported"))return;Object.assign(e,{reported:!0}),d===s.Error||null===d?console.error(e):console.info(e);const u=null!==(a=null!=t?t:E(e.stack))&&void 0!==a?a:"",f=null===(o=e.stack)||void 0===o?void 0:o.toString(),h=JSON.stringify(function(e){const t={};for(let n in g)try{const a=g[n](e);JSON.stringify(a),t[n]=a}catch(e){t[n]="Error while gathering data: ".concat(e,"\n").concat(e.stack)}return t}(e));if(function(e,t,n){var a;if(!window.skyward.error._enableLogging)return!0;if("string"==typeof(null==n?void 0:n.stack)&&l.some(e=>-1!==n.stack.indexOf(e)))return!0;if("string"==typeof e&&c.some(t=>t.test(e)))return!0;if("string"==typeof e&&"string"==typeof(null==n?void 0:n.stack)&&"TypeError: Failed to fetch"===e&&/^at L6b \(<anonymous>:\d+:\d+\)\s*at m_u \(<anonymous>:\d+:\d+\)\s*at W9 \(<anonymous>:\d+:\d+\)\s*at <anonymous>:\d+:\d+$/.test(n.stack))return!0;const o=null==n?void 0:n.stack,r=function(e){let t=e;const n=/(https?:\/\/[^\s]+:\d+:\d+)/,a=null==e?void 0:e.match(n);if(a&&(t=a[0].substring(a[0].lastIndexOf("/")+1),t.includes("?"))){const e=t.substring(0,t.indexOf("?")),n=t.substring(t.indexOf(":"),t.length);t=e+n}return t}(t),i="".concat(r,"\n").concat(e,"\n").concat(String(n),"\n").concat(o);if((w[i]=(null!==(a=w[i])&&void 0!==a?a:0)+1)>3)return!0;const s=new Date(Date.now()-6e4);return v=v.filter(e=>e>=s),v.length>=10||m>=1e3}(e.message,u,e))return p=null,null!==(b=null!==(y=null===(k=window.Promise)||void 0===k?void 0:k.resolve(p))&&void 0!==y?y:null===(S=window.jQuery)||void 0===S?void 0:S.Deferred().resolve(p))&&void 0!==b?b:C();var p,b,y,k,S;const D=m++,P=new XMLHttpRequest;let O=null===(r=window.skyward)||void 0===r||null===(r=r.global)||void 0===r?void 0:r.virtualDir;void 0===O&&(O="/"+window.location.pathname.split("/")[1]+"/");let B=e instanceof i?e.applicationMonitoringIdentifier:void 0;return e.message&&"undefined"!=e.message||null!=B||(B="C3D08DF9-B369-4316-9B73-4E6461BE95AD"),function(e){var t;if(window.Promise)return new Promise(e);if(null!==(t=window.jQuery)&&void 0!==t&&t.Deferred){const t=window.jQuery.Deferred();return e(t.resolve.bind(t),t.reject.bind(t)),t.promise()}return e(e=>{},e=>{}),C()}(function(t,a){var o,r,i,s,l,c,p;const m=function(e){const t=e.split(/[?&]/).filter(e=>e.length>0).map(e=>e.split("=")),n={};for(let e=0;e<t.length;e++)n[t[e][0]]=t[e][1];return n}(window.location.search);let g=null!==(o=null===(r=window.skyward)||void 0===r||null===(r=r.global)||void 0===r?void 0:r.windowGuid)&&void 0!==o?o:m.w,w=null!==(i=null===(s=window.skyward)||void 0===s||null===(s=s.global)||void 0===s?void 0:s.pageStateGuid)&&void 0!==i?i:m.p,b=null!==(l=null===(c=window.skyward)||void 0===c||null===(c=c.global)||void 0===c?void 0:c.sessionGuidHash)&&void 0!==l?l:m.sgh;P.open("POST","".concat(O,"SkySys/Log/LogClientSideException?w=").concat(g,"&p=").concat(w)),P.responseType="json",P.onload=function(){var e;"number"==typeof(null==this||null===(e=this.response)||void 0===e?void 0:e.id)?console.log("Exception logged as id ".concat(this.response.id," with severity ").concat(this.response.severity)):console.log("Exception not logged"),v.push(new Date),t(this.response)},P.onerror=function(){console.log("Failed to report exception"),t(null)},P.setRequestHeader("X-CSRF-TOKEN",null!=b?b:""),P.setRequestHeader("X-Requested-With","XMLHttpRequest");var y={errorNumber:D.toString(),message:null!==(p=e.message)&&void 0!==p?p:"",location:u,stack:null!=f?f:"",details:h,severity:null==d?void 0:d.toString(),applicationMonitoringIdentifier:B,applicationMonitoringIdentifierParts:n?JSON.stringify(n):""},C=new FormData;for(var k in y)C.append(k,_(y[k]));P.send(C)})}if(k("performance",function(){var e,t,n,a,o,r,i;return{pageLoadedAt:new Date(null===(e=window.performance)||void 0===e?void 0:e.timeOrigin),pageLoadComplete:(null===(t=window.performance)||void 0===t||null===(t=t.timing)||void 0===t?void 0:t.domComplete)-(null===(n=window.performance)||void 0===n?void 0:n.timeOrigin),initialNotifyDOMLoadComplete:null===(a=window.performance)||void 0===a||null===(a=a.getEntriesByName)||void 0===a||null===(a=a.call(window.performance,"initialNotifyDOMLoadComplete")[0])||void 0===a?void 0:a.startTime,initialLoadComplete:null===(o=window.performance)||void 0===o||null===(o=o.getEntriesByName)||void 0===o||null===(o=o.call(window.performance,"initialLoadComplete")[0])||void 0===o?void 0:o.startTime,jsHeapSize:null===(r=window.performance)||void 0===r||null===(r=r.memory)||void 0===r?void 0:r.jsHeapSizeLimit,usedJsHeapSize:null===(i=window.performance)||void 0===i||null===(i=i.memory)||void 0===i?void 0:i.usedJsHeapSize}}),k("exception",function(e){return{details:e.details}}),k("AggregateError",function e(t){if(window.AggregateError&&t instanceof window.AggregateError){return t.errors.map(t=>{const n=e(t);return o(o({},b(t)),{},{innerErrors:n})})}}),k("cause",function(e){if(e.cause)return b(e.cause)}),k("scripts",function(e){return $("script").toArray().filter(e=>{const t=e.src;var n;if(!t)return!/\\n\/\/# sourceURL=.*skyward/.test(null!==(n=e.textContent)&&void 0!==n?n:"");const a=new URL(t,location.href).host;return a!==location.host&&"apis.google.com"!==a&&"cdn.jsdelivr.net"!==a}).map(e=>e.outerHTML.slice(0,1e3))}),window.Vue){const e=window.Vue.createApp;window.Vue.createApp=function(){const t=e.apply(this,arguments),n=t.config.errorHandler;return t.config.errorHandler=function(e,a,o){y(e,o)||(e instanceof Error?(e.message="Error during Vue render: ".concat(o,"\n").concat(e.message),S(e)):S(new i("Error during Vue render: ".concat(o),JSON.stringify(e))),"function"==typeof n&&n.apply(t.config,arguments))},t}}if(window.jQuery){const e=window.jQuery.Deferred.exceptionHook;window.jQuery.Deferred.exceptionHook=function(t){if(!(t instanceof x)&&(null==t||t.statusCode||(t instanceof Error?(t.message="Uncaught exception in Deferred: ".concat(t.message),S(t)):S(new i("Uncaught exception in Deferred: ".concat(t.message),JSON.stringify(t)))),"function"==typeof e)){if(2===arguments.length&&arguments[0]===t)return;e.apply(window.jQuery.Deferred,arguments)}}}function B(e){try{return String(e)}catch(t){try{return Object.prototype.toString.call(e)}catch(e){return"<unstringifiable reason>"}}}function T(e){return null===e?"null":"object"!=typeof e?typeof e:Object.prototype.toString.call(e).slice(8,-1)}window.addEventListener("error",function(e){if(function(e){return 0===e.lineno&&0===e.colno||""===e.filename||"Script error."===e.message}(e))return;let t;(null==e?void 0:e.error)instanceof Error?(t=e.error,e.message&&(t.message=e.message)):t=new i(e.message,"onError",s.Error),O(t,"".concat(e.filename,":").concat(e.lineno,":").concat(e.colno))}),window.addEventListener("unhandledrejection",function(e){var t;if(e.reason instanceof x||"number"==typeof(null===(t=e.reason)||void 0===t?void 0:t.status)&&e.reason.status>=400||e.reason instanceof ProgressEvent||function(e){const t=e;return null!=t&&"number"==typeof t.status&&"number"==typeof t.readyState&&"function"==typeof t.getAllResponseHeaders}(e.reason))e.stopPropagation(),e.preventDefault();else if(e.reason instanceof Error){if(y(e.reason,"onUnhandledRejection"))return e.stopPropagation(),void e.preventDefault();if(function(e){var t,n;if("failed to fetch"!==(null===(t=e.message)||void 0===t?void 0:t.toLowerCase()))return!1;const a=null!==(n=e.stack)&&void 0!==n?n:"";if(0===a.length)return!1;return!f.test(a)}(e.reason))return e.stopPropagation(),void e.preventDefault();const t=e.reason;t.message="Error caught in onUnhandledRejection: ".concat(t.message),S(t)}else{const t=B(e.reason);if(t&&"undefined"!==t){const n=d.test(t)?"Unhandled promise rejection with a non-Error reason (".concat(T(e.reason),")."):t;S(new i(n,function(e){const t={context:"onUnhandledRejection",type:T(e),reason:e};let n;try{var a;n=null!==(a=JSON.stringify(t,function(){const e=new WeakSet;return function(t,n){if(n instanceof Error)return{name:n.name,message:n.message,stack:n.stack};if("undefined"!=typeof Event&&n instanceof Event)return{eventType:n.type,isTrusted:n.isTrusted};if("object"==typeof n&&null!==n){if(e.has(n))return"[circular or duplicate reference]";e.add(n)}return n}}()))&&void 0!==a?a:B(e)}catch(e){n=JSON.stringify({context:t.context,type:t.type,serializationError:String(e)})}n.length>u&&(n="".concat(n.slice(0,u),"...(truncated)"));return n}(e.reason),s.Error))}else{const t=void 0===e.reason?"undefined":"a ".concat(T(e.reason)," that stringifies to an empty string");S(new i("unhandledrejection event occurred without a specified reason.","event.reason was ".concat(t,". event.type: ").concat(e.type,". No stack is available for a rejection without a reason."),s.Error,"1F000E6F-DCF1-4AE3-A77E-FD2F1018D4F9"))}}}),window.skyward||(window.skyward={});class x extends Error{constructor(e){super(e)}}window.SkywardException=i,window.Severity=s,window.skyward.error=window.skyward.error||{registerErrorDataGatherer:k,reportException:S,getCallerLocation:P,_enableLogging:!0,CancellationError:x};const M=Promise;if(void 0===M._nativeReject){const e=Promise.reject;M._nativeReject=e,Promise.reject=function(t){const n=t instanceof Error?t:new i("Promise rejection without specific error",JSON.stringify(t));return e.call(this,n)}}},81484(e,t,n){"use strict";function a(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,a=Number.isInteger(n)?n:0;return{get id(){return"".concat(e).concat(a).concat(t)},getNewId:function(){return++a,this.id}}}n.r(t),n.d(t,{getIdGenerator:()=>a})},94382(e,t,n){"use strict";n.r(t),n.d(t,{lazy:()=>a});let a=function(e){var t,n=!1;return function(){return n||(t=e(),n=!0),t}}},65747(e,t,n){"use strict";n.r(t),n.d(t,{isDeferred:()=>a});let a=function(e){return e&&"function"==typeof e.done}},66952(e,t,n){"use strict";n.r(t),n.d(t,{SequentialOperationHandler:()=>U,camelCase:()=>q,containsHtml:()=>j,createCache:()=>H,decodeHtml:()=>F,encodeHtml:()=>N,ensureLiveAreaAnnounced:()=>z,getAccessibleName:()=>ee,getIdGenerator:()=>D.getIdGenerator,getSingleRequestHandler:()=>W,isJQuery:()=>Z,isNullOrEmpty:()=>X,isNumeric:()=>V,lazy:()=>O.lazy,maxBy:()=>R,minBy:()=>L,nextAutoId:()=>G,partitionArray:()=>A,rawData:()=>K});var a,o,r,i,s,l,c,d,u,f,h,p,m,g,w,v,b,y,_=n(79126),C=n(2894),k=n(49343),S=n(74061),D=n(81484),E=n(65747),P=n(16140),O=n(94382);n(66952);function B(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const T=null!==(a=window.skyward)&&void 0!==a?a:window.skyward={},x=(0,D.getIdGenerator)("autoid");function M(){return this.toString().replace(/^\s+/,"")}function I(){return this.toString().replace(/\s+$/,"")}function A(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Boolean;const n=Array.isArray(e)?e:Array.from(e),a=n.constructor(),o=n.constructor();for(const e of n){(t(e)?o:a).push(e)}return[a,o]}function L(e,t){let n,a=1/0;for(const r of e){var o;const e=null!==(o=t(r))&&void 0!==o?o:NaN;e<a&&(n=r,a=e)}return n}function R(e,t){return L(e,e=>{const n=t(e);return void 0===n?void 0:-n})}function N(e){return $("<div/>").text(null!=e?e:"").html()}function F(e){return $("<div/>").html(null!=e?e:"").text()}!function(e){e.safeRound=function(e){var t=Math.round(e);return isNaN(t)?null:t},e.nullCoalesce=function(){for(var e=arguments.length,t=0;t<e;t++)if(null!=arguments[t])return arguments[t];return null},e.fn.setAllDataToNull=function(){return this.each(function(){var t=e(this),n=t.data();e.each(n,function(e){n[e]=null}),t.data(n)})},e.fn.encodedVal=function(){let e=this.val();return Array.isArray(e)&&(e=e.join(",")),N(null!=e?e:"")},e.fn.sortChildrenByAction=function(t,n){let a,o=this.children().toArray().sort(function(e,a){return t(e,a,n)});for(a=0;a<o.length;a++)this.prepend(e(o[a]).detach());return this},e.propHooks.checked={set:function(t,n){const a=t;a.checked!==n&&(a.checked=n,e(a).trigger("jschange"))}},e.attrHooks.checked={set:function(t,n){const a=t;a.checked!==n&&(a.checked=n,e(a).trigger("jschange"))}},e.wait=function(t,n){return e.Deferred(function(e){if(n)var a=setInterval(function(){e.notify()},n);setTimeout(function(){clearInterval(a),e.resolve()},t)})},e.fn.selectRange=function(e,t){return t||(t=e),this.each(function(){this.setSelectionRange&&(this.focus(),this.setSelectionRange(e,t))})},e.fn.replaceTagNames=function(e){let t=this.length;for(;t--;){const n=this[t],a=this.eq(t),o=n.attributes,r=document.createElement(e);for(let e=o.length-1;e>=0;e--){const t=o[e];r.setAttribute(t.name,t.value)}r.innerHTML=n.innerHTML,a.after(r).remove(),this[t]=r}return this},e.fn.addIds=function(){for(let e=0;e<this.length;e++)""===this[e].id&&(this[e].id=x.getNewId());return this},e.fn.findLabel=function(){const t=this.parents().last();return e.findLabel(this.attr("id"),t)},e.fn.isLink=function(){const e=this.attr("role");return!("link"!==e&&(!this.is("a")||e&&"menuitem"!==e))},e.findLabel=function(t,n){let a=e();return t?(n&&0!==n.length||(n=e(document.body)),a=n.find('label[for="'.concat(CSS.escape(t),'"]')),0===a.length&&(a=n.find('.decorativeLabel[data-validate-text-for="'.concat(CSS.escape(t),'"]'))),0===a.length&&(a=n.find('.decorativeLabel[data-group-id="'.concat(CSS.escape(t),'"]'))),a):a},e.fn.toOuterHtmlString=function(){return this.map(function(){return this.outerHTML}).get().join("")},e.fn.getIdAndPrefix=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;var t=this.attr("id"),n=null!=e?e:this.getPrefix();return t?t.startsWith(n)?{id:t.slice(n.length),prefix:n}:(console.warn('something is weird: expected the prefix "'.concat(n,'" but couldn\'t find one on the id "').concat(t,'"'),this),{id:t,prefix:""}):{id:null,prefix:n}},function(){const t=new RegExp("\\[ *id *([^|!]?=) *('(?:\\\\.|[^\\\\'])*'|\"(?:\\\\.|[^\\\\\"])*\"|(?:\\\\[\\da-fA-F]{1,6} ?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+) *\\]".replace(/ /g,"[\\x20\\t\\r\\n\\f]"),"g");e.fn.findPrefixed=function(e){let n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;const a=null!=n?n:this.getPrefix();return this.find(e.replace(/#/g,"#".concat(a)).replace(t,(e,t,n)=>{const o=n[0];return"'"==o||'"'==o?"[id".concat(t).concat(o).concat(a).concat(n.slice(1,-1)).concat(o,"]"):"[id".concat(t).concat(a).concat(n,"]")}))},e.fn.findByIdWithUnknownPrefix=function(t){const n=this.find("[id$=".concat(CSS.escape(t),"]"));return 0===n.length?n:n.filter(function(){return e(this).getIdAndPrefix().id===t})}}(),e.fn.getPrefix=function(){var e;return null!==(e=this.closest("[data-id-prefix]").data("idPrefix"))&&void 0!==e?e:""};const t=window._skyward.global.isAndroidApp?"keyup":"keydown";e.event.special.enter={delegateType:t,bindType:t,handle:function(e){const t=e.handleObj;if(13===(e.keyCode||e.which))return t.handler.apply(this,arguments)}},e.whenAll=function(t){var n=t.length,a=new Array(t.length),o=e.Deferred();return t.forEach(function(e,t){(0,E.isDeferred)(e)?(e.done(function(e){a[t]=e,0===(n-=1)&&o.resolve(a)}),e.fail(function(e){o.reject(e)})):e instanceof Promise?e.then(function(e){a[t]=e,0===(n-=1)&&o.resolve(a)},function(e){o.reject(e)}):(a[t]=e,n-=1)}),0===n&&o.resolve(a),o.promise()},e.whenAllSettled=function(t){const n=e.Deferred();return 0==t.length?(n.resolve(),n.promise()):(Promise.all(t.map(function(e){return Promise.resolve(e).then(function(e){return{data:e,status:"fulfilled"}},function(e){return{data:e,status:"rejected"}})})).then(function(e){e.filter(e=>"fulfilled"===e.status).length>0?n.resolve(e):n.reject(new AggregateError(e.map(e=>e.data)))}),n.promise())}}(jQuery),window.AggregateError||(window.AggregateError=class extends Error{constructor(e){var t;if(super(arguments.length>1&&void 0!==arguments[1]?arguments[1]:""),B(this,"errors",void 0),!(Array.isArray(e)||null!==(t=window)&&void 0!==t&&null!==(t=t.Symbol)&&void 0!==t&&t.iterator&&"function"==typeof(null==e?void 0:e[window.Symbol.iterator])))throw new TypeError("".concat(e," is not an iterable"));this.errors=Array.from(e)}}),String.prototype.padRight=function(e,t){for(var n=""+this;n.length<e;)n+=t;return n},String.prototype.padLeft=function(e,t){for(var n=""+this;n.length<e;)n=t+n;return n},String.prototype.replaceAt=function(e,t){return this.substr(0,e)+t+this.substr(e+t.length)},String.prototype.toDisplayName=function(){return this.replace(/([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g,"$1$4 $2$3$5")},String.prototype.pluralize=function(e,t){if(void 0===e||void 0===t)return String(this);var n=parseInt(t);return isNaN(n)||1===n?String(this):e},null!==(r=(o=String.prototype).trimStart)&&void 0!==r||(o.trimStart=M),null!==(s=(i=String.prototype).trimLeft)&&void 0!==s||(i.trimLeft=M),null!==(c=(l=String.prototype).trimEnd)&&void 0!==c||(l.trimEnd=I),null!==(u=(d=String.prototype).trimRight)&&void 0!==u||(d.trimRight=I),String.prototype.capitalize=function(){return this.charAt(0).toUpperCase()+this.slice(1)},String.prototype.uncapitalize=function(){return this.charAt(0).toLowerCase()+this.slice(1)},String.prototype.dot=function(){return"."+this},Date.prototype.isValidDate=function(){return!isNaN(this.getTime())},Date.prototype.safeToISOString=function(){return this.isValidDate()?this.toISOString():""},Date.prototype.safeToDateString=function(){return this.safeToISOString().slice(0,10)},Date.prototype.addDays=function(e){var t=new Date(this.valueOf());return t.setDate(t.getDate()+e),t},Date.prototype.daysUntil=function(e){var t=this.getTime(),n=e.getTime()-t;return Math.round(n/864e5)},Boolean.prototype.toDisplayString=function(){return!0===this.valueOf()?"True":"False"},null!==(f=Promise.withResolvers)&&void 0!==f||(Promise.withResolvers=function(){let e=e=>{},t=()=>{};return{promise:new Promise((n,a)=>{e=n,t=a}),resolve:e,reject:t}}),null!==(p=(h=Array.prototype).at)&&void 0!==p||(h.at=function(e){return this[e<0?this.length+e:e]}),null!==(g=(m=Array.prototype).findLastIndex)&&void 0!==g||(m.findLastIndex=function(e,t){for(let n=this.length-1;n>=0;n-=1)if(e.call(t,this[n],n,this))return n;return-1}),null!==(v=(w=Array.prototype).findLast)&&void 0!==v||(w.findLast=function(e,t){const n=this.findLastIndex(e,t);return-1!==n?this[n]:void 0}),(0,C.getPrefersReducedMotion)()&&($.fx.off=!0),function(){var e={duration:230,easing:"swing"},t=(0,P.default)(k.notifyResize,10);const n={open:new Map,close:new Map,promise:null};var a=function(e){return"none"===e.style.display||""===e.style.display&&$.contains(document.documentElement,e)&&"none"===$.css(e,"display")};let o;$.expr.pseudos.inherentlyHidden=a;const r=function(){n.close.forEach(function(a,o){var r=$(o);0===n.open.size||!r.siblings().toArray().some(function(e){return n.open.has(e)})?r.stop().slideUp($.extend({},e,a)).promise().done(t):r.hide(a).finish().promise().done(t)}),n.open.forEach(function(n,a){$(a).stop().slideDown($.extend({},e,n)).promise().done(t)}),n.open.clear(),n.close.clear(),n.promise&&(n.promise.resolve(),n.promise=null),o=void 0},i=function(e,t,n){e.set(t,n),void 0===o&&(o=window.setTimeout(r,0))},s=function(e,t){if(e.has(t)){var n=e.get(t);$.isEmptyObject(n)||(a(t)?$(t).hide(n):$(t).show(n)),e.delete(t)}};$.fn.extend({viewpartHtml:async function(e){if(void 0===e)return;const t=await(0,C.processViewPartHtml)(e);return this.html(t)}}),$.fn.extend({animateOpen:function(e){return $.isEmptyObject(e)&&(e=void 0),$.fx.off||(0,k.isContentLoading)()?this.show(e).finish():this.each(function(){var t=$(this).finish();s(n.close,this),a(this)?i(n.open,this,e):t.show(e).finish()})},animateClose:function(e){return $.isEmptyObject(e)&&(e=void 0),$.fx.off||(0,k.isContentLoading)()?this.hide(e).finish():this.each(function(){var t=$(this).finish();s(n.open,this),a(this)?t.hide(e).finish():i(n.close,this,e)})},animateToggle:function(e,t){return"boolean"==typeof e&&(t=e,e=void 0),this.each(function(){var o="boolean"==typeof t?t:a(this);i(o?n.open:n.close,this,e)})},animationPromise:function(){if(this.toArray().some(function(e){return n.open.has(e)||n.close.has(e)})){n.promise||(n.promise=$.Deferred());var e=this;return n.promise.then(function(){return e.promise("fx")})}return this.promise("fx")},isAnimatingClosed:function(){return this.toArray().some(function(e){return n.close.has(e)})},isAnimatingOpen:function(){return this.toArray().some(function(e){return n.open.has(e)})},isAnimating:function(){return this.toArray().some(function(e){return n.open.has(e)||n.close.has(e)})}})}(),crypto.randomUUID||(crypto.randomUUID=function(){const e=new Uint8Array(16);window.crypto.getRandomValues(e),e[6]=15&e[6]|64,e[8]=63&e[8]|128;return Array.prototype.map.call(e,function(e){return("0"+e.toString(16)).slice(-2)}).join("").replace(/^(........)(....)(....)(....)(............)$/,"$1-$2-$3-$4-$5")}),null!==(b=Object.groupBy)&&void 0!==b||(Object.groupBy=function(e,t){const n=Object.create(null);let a=0;for(const o of e){const e=t(o,a++);e in n?n[e].push(o):n[e]=[o]}return n}),null!==(y=Map.groupBy)&&void 0!==y||(Map.groupBy=function(e,t){const n=new Map;let a=0;for(const o of e){const e=t(o,a++),r=n.get(e);r?r.push(o):n.set(e,[o])}return n}),Array.chunk=function(e,t){let n=[],a=[];for(const o of e)a.push(o),a.length===t&&(n.push(a),a=[]);return a.length>0&&n.push(a),n},function(){let e;function t(t){return $.expr.createPseudo(function(n){if(n.includes(":scope"))throw new Error("The :scope selector is not supported by the :is polyfill");const a=r(n);if(a)return a;const o=$.find.tokenize(n).map(e=>e.reduce((e,t)=>e+t.value,"")).filter(e=>!!r(e)).join(",");return r(o);function r(n){e||(e=document.createElement("div"));try{return e.querySelector(n),function(e){return e.matches(n)}}catch(e){}if(t)try{return $.find.matchesSelector(e,n),function(e){return $.find.matchesSelector(e,n)}}catch(e){}return null}})}const n=t(!1),a=$.expr.pseudos;a.is=n,a.where=n,a.jqIs=t(!0)}(),$.ui&&$.extend($.ui.resizable.prototype.options,{zIndex:"auto"});let j=function(e){return T.extensions.decodeHtml(e)!==e},V=function(e){var t=typeof e;return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},H=function(e){const t=new Map,n=function(n){return t.has(n)||t.set(n,e.apply(this,arguments)),t.get(n)};return n.insert=function(e,n){t.set(e,n)},n.remove=function(e){t.delete(e)},n},W=function(){let e=null;return{get request(){return e},set request(n){this.closeOpenRequest(),e=t(n)?n:null},closeOpenRequest:function(){t(e)&&4!==e.readyState&&e.abort(),e=null}};function t(e){return(e||{}).hasOwnProperty("readyState")}};class U{constructor(){let e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];B(this,"detached",void 0),B(this,"scope",void 0),this.detached=e}async run(e){this.close(),this.scope=(0,S.effectScope)(this.detached);const t=this.scope,n=await this.scope.run(async()=>{const t=new AbortController;(0,S.onScopeDispose)(()=>{t.abort()});try{return await e(t.signal)}catch(e){const t="abort"===(null==e?void 0:e.statusText);if(!(e instanceof _.CancellationError||t))throw e;return null}});return t===this.scope&&this.close(),n}close(){var e;null===(e=this.scope)||void 0===e||e.stop(),this.scope=void 0}}let K=function(e){const t=e instanceof $?e[0]:e;if(void 0!==t){for(var n={},a=0;a<t.attributes.length;a++){var o=t.attributes[a];o.name.startsWith("data-")&&(n[q(o.name.slice(5))]=o.value)}return n}};function q(e){return e.replace(/-([a-z])/g,function(e,t){return t.toUpperCase()})}function G(){return x.getNewId()}function z(e,t){const n=e.text();let a=t.trim();if(n.trim()==a){const e=" ";a=n.endsWith(e)?n.slice(0,-1):n+e}e.text(a)}let J=!1;$._evalUrl=function(e,t,n){let a;return J||(J=!0,(0,_.reportException)(new _.SkywardException('Asynchronous HTML request was not sent using `viewparthtml`. This will lead to slowdowns or errors when loading the page. To fix this, change the `dataType` parameter in your ajax request to "viewparthtml", or pass your html string to skyward.global.processViewPartHtml().')),window.setTimeout(()=>J=!1,0)),$.ajax({url:e,xhr:()=>{var e,t,n;return a=null!==(e=null===(t=(n=$.ajaxSettings).xhr)||void 0===t?void 0:t.call(n))&&void 0!==e?e:new XMLHttpRequest,a},type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(o){if(!/\n\/\/# (sourceMappingURL|sourceURL)[^\n]*\n?$/.test(o)){const t=a.getResponseHeader("SourceMap");if(t){const e=new URL(t,window.location.href);o+="\n//# sourceMappingURL=".concat(e)}else o+="\n//# sourceURL=".concat(e)}jQuery.globalEval(o,t,n)}})};const Y=jQuery.removeData,Q=jQuery.fn.removeData;function X(e){return null==e||""===e.trim()}function Z(e){return e instanceof $}function ee(e){var t;const n=$(e);if(!n.length)return null;const a=null===(t=n.attr("aria-label"))||void 0===t?void 0:t.trim();if(a)return a;const o=i("aria-labelledby");if(o)return o;const r=i("aria-describedby");return r||null;function i(e){const t=n.attr(e);if(!t)return null;const a=t.split(/\s+/).filter(Boolean).map(e=>document.getElementById(e)).filter(e=>null!==e);if(0===a.length)return null;const o=[];for(const e of a){const t=e.getAttribute("aria-label");t?o.push(t.trim()):o.push(e.innerText.trim())}return o.join(" ")}}jQuery.removeData=function(e,t){Y.apply(jQuery,arguments),void 0===t&&jQuery._removeData(e,"hasDataAttrs")},jQuery.fn.removeData=function(e){return Q.apply(this,arguments),void 0===e&&this.each(function(){jQuery._removeData(this,"hasDataAttrs")}),this}},83972(e,t,n){"use strict";n.r(t),n.d(t,{insertTextToken:()=>o});var a=n(917);n(66952);function o(e,t,n,o){e.trigger("focus");var r=String(e.val()),i=e.prop("selectionStart"),s=e.prop("selectionEnd")||i,l=r.slice(0,i),c=r.slice(s);if(null==t&&(t=""),n){var d=l.charAt(l.length-1),u=c.charAt(0);" "!==d&&l.length>0&&(t=" "+t)," "!==u&&c.length>0&&(t=t+=" ")}var f=i+t.length,h=l+t+c;(0,a.setValue)(e,h,o),e.selectRange(f)}},2894(e,t,n){"use strict";n.r(t),n.d(t,{addRequiredQuerystringParams:()=>Fe,calculateTextWidthPx:()=>U,createHiddenInputForm:()=>q,deepDifference:()=>J,deepEquals:()=>z,froalaLicenseKey:()=>Me,getPrefersReducedMotion:()=>Ne,initialModulesLoaded:()=>ae,isAndroidApp:()=>Be,isDebug:()=>de,isInHouse:()=>De,isIosApp:()=>Te,isReadOnlyImpersonation:()=>xe,isRealSuperUser:()=>Ce,isRealSupportAccount:()=>Se,isSuperUser:()=>_e,isSupportAccount:()=>ke,loadSkywardModuleByNamespace:()=>oe,loadViewpartModule:()=>se,loggedIn:()=>be,mobileAccess:()=>Pe,mobileAccessEmulation:()=>Oe,pageStateGuid:()=>ve,processViewPartHtml:()=>le,processViewPartHtmlSeparately:()=>ce,readOnlyAnnouncementID:()=>Re,sessionClientPingSeconds:()=>Ae,sessionGuidHash:()=>fe,sessionTimeoutSeconds:()=>Ee,sessionWarnSeconds:()=>Ie,submitAndRemoveHiddenInputForm:()=>G,tooltipsEnabled:()=>Le,userIdHash:()=>ye,validateDataParameter:()=>K,virtualDir:()=>ue,windowDistrictID:()=>me,windowEntityID:()=>pe,windowFiscalYearID:()=>we,windowGuid:()=>he,windowSchoolYearID:()=>ge});var a,o,r,i,s,l,c,d,u,f,h,p,m,g,w,v,b,y,_,C,k,S,D,E,P,O,B,T,x,M,I,A,L,R,N,F=n(79126),j=n(74061),V=n(94382);function H(e){switch(e){case"ajaxError":return Promise.all([n.e(9343),n.e(833)]).then(n.bind(n,85596));case"ajaxManager":return n.e(8102).then(n.bind(n,60977));case"color":return n.e(3064).then(n.bind(n,92599));case"error":return Promise.resolve().then(n.bind(n,79126));case"extensions.idGenerator":return n.e(5325).then(n.bind(n,81484));case"extensions.lazy":return Promise.resolve().then(n.bind(n,94382));case"extensions.promise":return n.e(6580).then(n.bind(n,65747));case"extensions":return Promise.all([n.e(9343),n.e(5607)]).then(n.bind(n,66952));case"global.text":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4629)]).then(n.bind(n,83972));case"global":return Promise.resolve().then(n.bind(n,2894));case"idleMonitor":return Promise.all([n.e(9343),n.e(4901)]).then(n.bind(n,584));case"iframeListener":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1999)]).then(n.bind(n,49698));case"networkTests":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2790)]).then(n.bind(n,85969));case"performanceMonitor":return n.e(1080).then(n.bind(n,19802));case"requestDataHash":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(421)]).then(n.bind(n,82441));case"searchCondition":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5362),n.e(1934)]).then(n.bind(n,38953));case"session":return Promise.all([n.e(9343),n.e(4901)]).then(n.bind(n,28640));case"skyVue":return Promise.all([n.e(9857),n.e(9165),n.e(1514),n.e(9343),n.e(9050)]).then(n.bind(n,33661));case"tabbing":return Promise.all([n.e(9343),n.e(9394)]).then(n.bind(n,41709));case"time":return n.e(9052).then(n.bind(n,81975));case"volatileStorage":return n.e(6820).then(n.bind(n,82893));case"fieldRestriction":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1265)]).then(n.bind(n,51353));case"aboutPopup":return Promise.all([n.e(9343),n.e(9768)]).then(n.bind(n,18290));case"absenceRequest":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(3531)]).then(n.bind(n,29427));case"academicStandardHierarchy":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5594)]).then(n.bind(n,56826));case"accountsPayableDirectDepositNotification":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6071)]).then(n.bind(n,29903));case"accountsPayableInvoiceSelector":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1219)]).then(n.bind(n,2615));case"accountsReceivable":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9685)]).then(n.bind(n,89441));case"activity":return Promise.all([n.e(9343),n.e(8788)]).then(n.bind(n,40782));case"activityIndicator":return Promise.all([n.e(9343),n.e(9119)]).then(n.bind(n,7317));case"activityVsBudgetedWidget":return Promise.all([n.e(9857),n.e(5468),n.e(9343),n.e(7757),n.e(4124),n.e(9372),n.e(6622),n.e(673)]).then(n.bind(n,4917));case"ajax":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6882),n.e(2249)]).then(n.bind(n,90265));case"ajaxRepeater":return Promise.all([n.e(9343),n.e(8969)]).then(n.bind(n,44061));case"api":return Promise.all([n.e(9343),n.e(7381)]).then(n.bind(n,44695));case"applicantTracking":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(894),n.e(64)]).then(n.bind(n,17028));case"applicationClaim":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1181)]).then(n.bind(n,60981));case"approval":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8050)]).then(n.bind(n,82080));case"asset":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(97)]).then(n.bind(n,40583));case"assetPopup":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6882),n.e(8073)]).then(n.bind(n,23689));case"attachment":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1592)]).then(n.bind(n,46478));case"attachmentPopup":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6190)]).then(n.bind(n,62686));case"attendanceByClassActivityRangeEntry":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(7653)]).then(n.bind(n,29355));case"attendanceCommentPrivacy":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8699)]).then(n.bind(n,33915));case"attendanceEntryGrid":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(7830)]).then(n.bind(n,7730));case"attendanceEntryStudentEEL":return Promise.all([n.e(9343),n.e(4567)]).then(n.bind(n,99249));case"attendanceHelper":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5218)]).then(n.bind(n,52128));case"attendanceLetter":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2202)]).then(n.bind(n,61440));case"bankReconciliation":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(18)]).then(n.bind(n,75064));case"bankReconciliationLoading":return Promise.all([n.e(9343),n.e(2590)]).then(n.bind(n,83290));case"bellschedulingperiodmatrix":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9550)]).then(n.bind(n,47928));case"benefitManagement":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4237)]).then(n.bind(n,49539));case"benefitManagementAllowPlanChange":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(3709)]).then(n.bind(n,32281));case"benefitManagementBuildInvoices":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1835)]).then(n.bind(n,95759));case"benefitManagementConfigDistrictDetails":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2253)]).then(n.bind(n,989));case"binding":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6470)]).then(n.bind(n,12110));case"birthDateAgeTextBox":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1825)]).then(n.bind(n,93695));case"birthHistory":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4914)]).then(n.bind(n,45232));case"browse.fieldTree":return n.e(7903).then(n.bind(n,39411));case"browse.list":return n.e(8553).then(n.bind(n,3543));case"browse":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(421)]).then(n.bind(n,62521));case"browseFieldPath":return Promise.all([n.e(9857),n.e(9343),n.e(2528),n.e(2980),n.e(9526)]).then(n.bind(n,7610));case"browseFilters":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(421)]).then(n.bind(n,6722));case"browseFilterSelector":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(7584)]).then(n.bind(n,15334));case"browseLoadTimer":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(421)]).then(n.bind(n,40044));case"browsePreferences":return n.e(3329).then(n.bind(n,939));case"browseSeekInfo":return n.e(5653).then(n.bind(n,50573));case"budgetAmendmentSelector":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8774)]).then(n.bind(n,4642));case"buildingDetailWA":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6520)]).then(n.bind(n,34242));case"buttonManager":return n.e(4592).then(n.bind(n,40096));case"calendarDay":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6641)]).then(n.bind(n,2495));case"calendarview":return Promise.all([n.e(9857),n.e(8939),n.e(5550)]).then(n.bind(n,11340));case"callbackStore":return n.e(1157).then(n.bind(n,29711));case"careerPlan":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1548)]).then(n.bind(n,35946));case"cashReceipt":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(846)]).then(n.bind(n,15554));case"cashReceiptChildRecordQuickEntry":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6882),n.e(9296)]).then(n.bind(n,80810));case"cashReceiptSelector":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6477)]).then(n.bind(n,39699));case"cctPurchaseOrders":return n.e(3185).then(n.bind(n,72127));case"changeTracking":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(421)]).then(n.bind(n,40346));case"charactersRemaining":return Promise.all([n.e(9343),n.e(757)]).then(n.bind(n,92723));case"chartWidgetContextMenuPlugin":return Promise.all([n.e(9857),n.e(9343),n.e(7757),n.e(4124),n.e(9372),n.e(6622)]).then(n.bind(n,69140));case"checkbox":return n.e(1224).then(n.bind(n,67934));case"checkboxBrowse":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(421)]).then(n.bind(n,46740));case"checkboxGroup":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9745)]).then(n.bind(n,16023));case"checkBoxMassSelectButton":return n.e(7452).then(n.bind(n,20986));case"clock":return n.e(4247).then(n.bind(n,51269));case"codeeel":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(421)]).then(n.bind(n,65302));case"collapsePanel":return Promise.all([n.e(9343),n.e(2676)]).then(n.bind(n,78036));case"colorPicker":return Promise.all([n.e(9343),n.e(4718)]).then(n.bind(n,53054));case"comboBox":return n.e(2506).then(n.bind(n,19092));case"configDistrictPA":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8574)]).then(n.bind(n,97152));case"configSystem":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2210)]).then(n.bind(n,15492));case"contentMessageArea":return Promise.all([n.e(9343),n.e(2704)]).then(n.bind(n,92566));case"controls":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(421)]).then(n.bind(n,917));case"countdown":return n.e(416).then(n.bind(n,98392));case"creditCardTransactionSelector":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5577)]).then(n.bind(n,54543));case"criticalAlert":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5266)]).then(n.bind(n,15714));case"crystalReportPromptEntry":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8913)]).then(n.bind(n,18753));case"customfieldvalidation":return n.e(9451).then(n.bind(n,16797));case"customization":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5970)]).then(n.bind(n,62270));case"dashboardItemConfig.chartTiles":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4124),n.e(9372),n.e(3227)]).then(n.bind(n,60019));case"dashboardItemConfig.default":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4124),n.e(643)]).then(n.bind(n,13793));case"dashboardItemConfig":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4124),n.e(9372),n.e(6526)]).then(n.bind(n,7210));case"dashboardItemConfig.types":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2335)]).then(n.bind(n,87029));case"dashboardItemSizer":return Promise.all([n.e(9857),n.e(9871)]).then(n.bind(n,70041));case"dashboardItemStatus":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9378)]).then(n.bind(n,23370));case"dashboardLibrary":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4124),n.e(9372),n.e(60),n.e(5402)]).then(n.bind(n,11668));case"dashboardWidgetChart":return Promise.all([n.e(9857),n.e(5468),n.e(9343),n.e(7757),n.e(4124),n.e(9372),n.e(6622),n.e(9135)]).then(n.bind(n,81299));case"databysubject":return Promise.all([n.e(9857),n.e(9343),n.e(7757),n.e(2788)]).then(n.bind(n,29064));case"datamask":return Promise.all([n.e(6721),n.e(779)]).then(n.bind(n,83787));case"dataobjectviewer.getFieldValues":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(421)]).then(n.bind(n,14144));case"dataobjectviewer.preSaveValidation":return Promise.all([n.e(9343),n.e(2528),n.e(8631)]).then(n.bind(n,1251));case"dataPath":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8950),n.e(4398),n.e(9522)]).then(n.bind(n,65248));case"dataScrambleApproval":return Promise.all([n.e(9343),n.e(7551)]).then(n.bind(n,59107));case"datePicker":return Promise.all([n.e(9857),n.e(9343),n.e(469),n.e(631),n.e(7969)]).then(n.bind(n,21701));case"dateTimePicker":return Promise.all([n.e(9857),n.e(9343),n.e(469),n.e(8950),n.e(1606)]).then(n.bind(n,38950));case"debounce":return n.e(8246).then(n.bind(n,16140));case"dependents":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4477),n.e(5035)]).then(n.bind(n,51063));case"detailsPanel":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5503)]).then(n.bind(n,6927));case"developerIsland":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8924)]).then(n.bind(n,55208));case"dialogFocusManager":return n.e(1098).then(n.bind(n,1380));case"displayPeriodCheckboxGrid":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5475)]).then(n.bind(n,21109));case"distinctMultiSelectEEL":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(421)]).then(n.bind(n,62894));case"distinctMultiSelectEEL.values":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(421)]).then(n.bind(n,25560));case"dock":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4462)]).then(n.bind(n,50196));case"durationPicker":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1605)]).then(n.bind(n,43965));case"dynamicSectionHeader":return n.e(1836).then(n.bind(n,17666));case"earlyChildhoodMI":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6118)]).then(n.bind(n,18164));case"ecommerce":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(7425)]).then(n.bind(n,52995));case"edfi-ts":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8063)]).then(n.bind(n,52721));case"editableBrowse":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(421)]).then(n.bind(n,83289));case"eel":return Promise.all([n.e(9343),n.e(7915)]).then(n.bind(n,51325));case"eISExtractEntry":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1237)]).then(n.bind(n,86807));case"electronicSignature":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5505)]).then(n.bind(n,65259));case"employee":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4083)]).then(n.bind(n,83519));case"employeeAccess":return Promise.all([n.e(9343),n.e(397)]).then(n.bind(n,11105));case"employeeDistrictWorkStatusPA":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6825)]).then(n.bind(n,22273));case"employeeExperienceWAMassAdd":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2960)]).then(n.bind(n,4732));case"employeePlanEnrollmentEntry":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6394)]).then(n.bind(n,68426));case"employeeStaffActivityPA":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2725)]).then(n.bind(n,1343));case"employeeStaffInterchangeEvaluationCO":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8007)]).then(n.bind(n,25515));case"employeeWeeklySchedule":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9133)]).then(n.bind(n,21841));case"endorsements":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2364)]).then(n.bind(n,12630));case"enrollmentKS":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4905)]).then(n.bind(n,52545));case"enrollmentRequestSubmit":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6882),n.e(4582)]).then(n.bind(n,47158));case"events":return n.e(4268).then(n.bind(n,92214));case"expandingLabel":return n.e(1813).then(n.bind(n,93625));case"expenseReimbursementSelector":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2744)]).then(n.bind(n,63834));case"externalLinkPopup":return Promise.all([n.e(9343),n.e(7660)]).then(n.bind(n,39732));case"externalLinks":return Promise.all([n.e(9857),n.e(9343),n.e(60),n.e(1193)]).then(n.bind(n,28468));case"familyAccess":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(869)]).then(n.bind(n,22441));case"familyAccessAttendance":return Promise.all([n.e(9343),n.e(3560)]).then(n.bind(n,70010));case"familyEntityConfigControls":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2718)]).then(n.bind(n,76992));case"favorites":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4062)]).then(n.bind(n,39094));case"feeManagement":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6936)]).then(n.bind(n,57232));case"fieldGroup.emergencyContact":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1764),n.e(913)]).then(n.bind(n,93227));case"fieldGroup.nseFamilyInfo":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(250)]).then(n.bind(n,57156));case"fieldGroup.raceEthnicityVerification":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6375)]).then(n.bind(n,54791));case"fieldInformation":return Promise.all([n.e(9343),n.e(193)]).then(n.bind(n,51809));case"fieldSelector":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6762)]).then(n.bind(n,77586));case"fieldWrapper":return Promise.all([n.e(9343),n.e(2250)]).then(n.bind(n,30368));case"fileDestinationSelector":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6840)]).then(n.bind(n,64432));case"fileDestinationTester":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6882),n.e(3262)]).then(n.bind(n,93974));case"filemanagement":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9e3)]).then(n.bind(n,45230));case"fileUpload":return Promise.all([n.e(9857),n.e(9343),n.e(6050)]).then(n.bind(n,72178));case"filterOptionSelector":return n.e(1253).then(n.bind(n,48594));case"filterSetViewer":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(3365)]).then(n.bind(n,56799));case"filterViewer":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5362),n.e(2703)]).then(n.bind(n,99738));case"foodService.onlineApplication":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(699)]).then(n.bind(n,11297));case"foodService.onlineApplicationApproval":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8054)]).then(n.bind(n,24506));case"framedHTMLViewer":return n.e(3291).then(n.bind(n,45579));case"globalSearch":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4122)]).then(n.bind(n,49680));case"gradebookMassCommentEntry":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2826)]).then(n.bind(n,86298));case"gradingUI":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(7959)]).then(n.bind(n,22177));case"groupTemplate":return n.e(8274).then(n.bind(n,43178));case"headerSelect":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2136)]).then(n.bind(n,12554));case"health.nameWellnessScreening":return Promise.all([n.e(9343),n.e(8643)]).then(n.bind(n,29763));case"health":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6882),n.e(77)]).then(n.bind(n,35233));case"healthDashboardPopup":return Promise.all([n.e(9343),n.e(3211)]).then(n.bind(n,839));case"homeLanguageSurveyWI":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(126)]).then(n.bind(n,98288));case"htmlComboBox":return Promise.all([n.e(9343),n.e(2041)]).then(n.bind(n,64801));case"htmlEditor":return Promise.all([n.e(9857),n.e(9343),n.e(7757),n.e(6667)]).then(n.bind(n,64611));case"htmlGatherer":return Promise.all([n.e(9343),n.e(6788)]).then(n.bind(n,63490));case"iEPWA":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1507)]).then(n.bind(n,75809));case"iEPWriterDocument":return Promise.all([n.e(9343),n.e(705)]).then(n.bind(n,26935));case"iframe":return Promise.all([n.e(9343),n.e(6995)]).then(n.bind(n,69315));case"importColumnViewer":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6612)]).then(n.bind(n,65942));case"indentToggle":return Promise.all([n.e(9857),n.e(6317)]).then(n.bind(n,95182));case"infoButton":return Promise.all([n.e(9343),n.e(6771)]).then(n.bind(n,57523));case"informationPopup":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1047)]).then(n.bind(n,86431));case"keyboardNavigation":return n.e(3458).then(n.bind(n,78744));case"labeledDataList":return Promise.all([n.e(9857),n.e(9343),n.e(8236)]).then(n.bind(n,59588));case"LDAP":return n.e(852).then(n.bind(n,99394));case"linkPanelButton":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5095)]).then(n.bind(n,8181));case"listSorter":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5450)]).then(n.bind(n,9720));case"mainmenuvue":return Promise.all([n.e(9857),n.e(9343),n.e(4231)]).then(n.bind(n,2658));case"maskCreator":return n.e(5569).then(n.bind(n,7719));case"massupdatecontrol":return Promise.all([n.e(9343),n.e(2079)]).then(n.bind(n,65237));case"massUpdateS275":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2252)]).then(n.bind(n,54459));case"maximizeContainer":return Promise.all([n.e(9343),n.e(4926)]).then(n.bind(n,87422));case"media":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8201)]).then(n.bind(n,12787));case"messageCenter.carbonCopyFilterPanel":return n.e(781).then(n.bind(n,31971));case"messageCenter.messageDisplay":return Promise.all([n.e(9343),n.e(445)]).then(n.bind(n,42016));case"messagecenter.messageSettings":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8535)]).then(n.bind(n,7117));case"messagecenter.myMessages":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2741)]).then(n.bind(n,54017));case"messagecenter":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4503)]).then(n.bind(n,78465));case"messagesubjectandcontent":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5310)]).then(n.bind(n,24960));case"mobileselector":return n.e(5850).then(n.bind(n,61776));case"modalLayer":return Promise.all([n.e(9343),n.e(5607)]).then(n.bind(n,88157));case"moduleNotification":return n.e(2618).then(n.bind(n,67908));case"multipleSelectBox":return Promise.all([n.e(9343),n.e(5666)]).then(n.bind(n,83874));case"nameMerge":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9106)]).then(n.bind(n,49154));case"newGuardianLoginRequestConfig":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9282)]).then(n.bind(n,32094));case"notificationBubble":return n.e(6768).then(n.bind(n,21314));case"officeVisit":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5552)]).then(n.bind(n,94504));case"onlineForm.approvalDetails":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1764),n.e(8647)]).then(n.bind(n,6491));case"onlineForm.elementCRQE":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9703)]).then(n.bind(n,71335));case"onlineForm.elementRuleCRQE":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8917)]).then(n.bind(n,41605));case"onlineForm.htmlElement":return n.e(2231).then(n.bind(n,90843));case"onlineform.massDeleteOnlineFormResponses":return n.e(2396).then(n.bind(n,94906));case"onlineForm.massPrint":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(7051)]).then(n.bind(n,77523));case"onlineForm.reorderElement":return n.e(1501).then(n.bind(n,35703));case"onlineForm.statusSaveManager":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1764)]).then(n.bind(n,84626));case"onlineForm.stepDetails":return n.e(6966).then(n.bind(n,94988));case"onlineForm.stepNavigation":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1764),n.e(1122)]).then(n.bind(n,16474));case"onlineForm.stepStatusContent":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1821)]).then(n.bind(n,48665));case"pageLoading":return Promise.all([n.e(9343),n.e(7006)]).then(n.bind(n,6042));case"pALocalTaxSubmission":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(3478)]).then(n.bind(n,26216));case"panelSelection":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8719)]).then(n.bind(n,80271));case"parameterDataSourcePopulator":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4147)]).then(n.bind(n,37491));case"passwordCriteria":return Promise.all([n.e(9857),n.e(9327)]).then(n.bind(n,40549));case"payloadViewer":return n.e(7709).then(n.bind(n,47571));case"payroll.assignmentPayTypeSalaryPays":return n.e(7500).then(n.bind(n,63176));case"payroll.timesheetQuickEntry":return n.e(9091).then(n.bind(n,81681));case"payroll":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6734)]).then(n.bind(n,9910));case"persistentTab":return Promise.all([n.e(9343),n.e(60),n.e(9677)]).then(n.bind(n,35071));case"positionNumberLookupSearch":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5895)]).then(n.bind(n,32767));case"printScreen":return Promise.all([n.e(9343),n.e(6260)]).then(n.bind(n,44992));case"processgrouputil":return n.e(2435).then(n.bind(n,7651));case"processingList.import":return n.e(5355).then(n.bind(n,34177));case"processingList.report":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6882),n.e(2610)]).then(n.bind(n,88046));case"processingList":return Promise.all([n.e(9343),n.e(2342)]).then(n.bind(n,5172));case"processingListSelector":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5013)]).then(n.bind(n,92901));case"processlinkinfodialog":return Promise.all([n.e(9343),n.e(9486)]).then(n.bind(n,98066));case"processmanagementsubjectselector":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9918)]).then(n.bind(n,4120));case"processReorder":return Promise.all([n.e(9857),n.e(6721),n.e(7924),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2363)]).then(n.bind(n,5473));case"profile":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8138)]).then(n.bind(n,25246));case"profileAddSearch":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9875)]).then(n.bind(n,37555));case"promptbuilder":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(3070)]).then(n.bind(n,38581));case"promptDataSourcePopulator":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5496)]).then(n.bind(n,73680));case"quickEntryText":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8869)]).then(n.bind(n,37277));case"raceVerifiedByDateControl":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(730)]).then(n.bind(n,9038));case"radioButtonGroup":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8153)]).then(n.bind(n,1445));case"reference":return Promise.all([n.e(9343),n.e(6078)]).then(n.bind(n,63302));case"relativedatepicker":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(857)]).then(n.bind(n,57365));case"reorderDraggable":return Promise.all([n.e(9857),n.e(6721),n.e(7924),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6281)]).then(n.bind(n,68913));case"repeater":return n.e(5959).then(n.bind(n,71983));case"repeaterAccessibility":return n.e(5746).then(n.bind(n,93879));case"reportDefinitionViewer":return Promise.all([n.e(9857),n.e(9343),n.e(8471)]).then(n.bind(n,30092));case"reportdefinitionviewersectionselector":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(7966)]).then(n.bind(n,72866));case"reporting.calculatedfields":return n.e(3076).then(n.bind(n,60990));case"reporting.details":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5971)]).then(n.bind(n,74977));case"reporting.fieldselectionpanels":return Promise.all([n.e(9857),n.e(9343),n.e(2528),n.e(2980),n.e(9484)]).then(n.bind(n,48894));case"reporting.preview":return Promise.all([n.e(9343),n.e(4009)]).then(n.bind(n,80583));case"reporting.previewexpensereimbursement":return n.e(1337).then(n.bind(n,71475));case"reporting.scheduledReport":return Promise.all([n.e(9343),n.e(6210)]).then(n.bind(n,11310));case"reportingTableViewer":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9551)]).then(n.bind(n,96111));case"reportViewer":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5723)]).then(n.bind(n,50611));case"responsiveToolbar":return Promise.all([n.e(9343),n.e(894)]).then(n.bind(n,54922));case"rotationSelector":return n.e(6930).then(n.bind(n,46676));case"s275ExtractEntry":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2477)]).then(n.bind(n,91493));case"saveAndNextDetails":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2110)]).then(n.bind(n,70112));case"screenselector":return n.e(3952).then(n.bind(n,8250));case"sebbThirdPartyImport":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8034)]).then(n.bind(n,33473));case"securityapplication":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(7473)]).then(n.bind(n,53171));case"securityUser":return Promise.all([n.e(9343),n.e(7560)]).then(n.bind(n,38798));case"selectorEEL":return Promise.all([n.e(9343),n.e(7254)]).then(n.bind(n,64558));case"seriesTotalizerPlugin":return n.e(3911).then(n.bind(n,57153));case"serverResponseTimeChart":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4124),n.e(4948)]).then(n.bind(n,86800));case"sifdatabysubject":return Promise.all([n.e(9857),n.e(9343),n.e(7757),n.e(7972)]).then(n.bind(n,84646));case"sizedContainer":return Promise.all([n.e(9343),n.e(1309)]).then(n.bind(n,48985));case"skysys.massImportAttachments":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2780)]).then(n.bind(n,20074));case"slidingContainer":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6812)]).then(n.bind(n,87766));case"sortable":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(7587)]).then(n.bind(n,54375));case"specialProgramSummary":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(428)]).then(n.bind(n,64264));case"specialProgramsWA":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6631)]).then(n.bind(n,41873));case"standardFilterDistrictVariables":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(99)]).then(n.bind(n,89761));case"standardFilterViewer":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4477),n.e(6947)]).then(n.bind(n,28646));case"statereportingid":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5643)]).then(n.bind(n,77275));case"stateReportingIL":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4816)]).then(n.bind(n,67299));case"stateReportingIN":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9041)]).then(n.bind(n,91621));case"stateReportingKS":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4126)]).then(n.bind(n,41060));case"stateReportingMI":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9698)]).then(n.bind(n,74676));case"stateReportingNM":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(3035)]).then(n.bind(n,3299));case"stateReportingPA":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(3669)]).then(n.bind(n,57237));case"statereportingRI":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(7731)]).then(n.bind(n,88819));case"statereportingSD":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(3033)]).then(n.bind(n,24641));case"statereportingtn":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(3470)]).then(n.bind(n,82612));case"stateReportingTX":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1528)]).then(n.bind(n,13986));case"statereportingut":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(655)]).then(n.bind(n,88263));case"statereportingvalidations":return Promise.all([n.e(9857),n.e(9343),n.e(7757),n.e(8916)]).then(n.bind(n,33344));case"stateReportingWA":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1320)]).then(n.bind(n,15634));case"stateReportingWI":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(9488)]).then(n.bind(n,34538));case"statuspoller":return n.e(2819).then(n.bind(n,16155));case"stepNavigator":return n.e(216).then(n.bind(n,92568));case"studentHealthScreeningEntry":return n.e(6634).then(n.bind(n,29862));case"studentInformationPopup":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(60),n.e(4856)]).then(n.bind(n,83856));case"studentSectionAttendanceMinutes":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(7803)]).then(n.bind(n,32473));case"support":return Promise.all([n.e(9343),n.e(3240)]).then(n.bind(n,78176));case"svg":return n.e(5875).then(n.bind(n,68337));case"tabContainer":return Promise.all([n.e(9343),n.e(1017)]).then(n.bind(n,59658));case"tablist":return Promise.all([n.e(9343),n.e(60),n.e(6796)]).then(n.bind(n,80060));case"texasTranscript":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1160)]).then(n.bind(n,56964));case"textArea":return n.e(1681).then(n.bind(n,48617));case"textAreaReset":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(462)]).then(n.bind(n,21086));case"themeSelector":return Promise.all([n.e(9857),n.e(9343),n.e(7757),n.e(7061)]).then(n.bind(n,4659));case"thirdPartyFormat":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(7563)]).then(n.bind(n,59091));case"tileBrowse":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(7721)]).then(n.bind(n,2885));case"tileViewEEL":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(421)]).then(n.bind(n,64078));case"timePicker":return Promise.all([n.e(9857),n.e(9343),n.e(4398),n.e(2058)]).then(n.bind(n,84398));case"timetracking.timesheetWeek":return Promise.all([n.e(9343),n.e(3257)]).then(n.bind(n,55929));case"timeTracking":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(8391)]).then(n.bind(n,11407));case"togglePassword":return n.e(6120).then(n.bind(n,9270));case"tooltip":return Promise.all([n.e(9343),n.e(1168)]).then(n.bind(n,81496));case"translationDetector":return n.e(6790).then(n.bind(n,742));case"treebrowse":return Promise.all([n.e(9857),n.e(9343),n.e(2528),n.e(2980),n.e(3077)]).then(n.bind(n,42980));case"userApproval":return Promise.all([n.e(9343),n.e(7619)]).then(n.bind(n,24023));case"usernameStructure":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(6882),n.e(8654)]).then(n.bind(n,1806));case"userPreferences":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(2448)]).then(n.bind(n,53148));case"validation":return Promise.all([n.e(9343),n.e(2528),n.e(62)]).then(n.bind(n,22528));case"vendorrequestapprovalmessage":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(3026)]).then(n.bind(n,45368));case"videoPopout":return Promise.all([n.e(13),n.e(9343),n.e(767)]).then(n.bind(n,25729));case"viewMoreBrowseButton":return n.e(4481).then(n.bind(n,21001));case"viewPopup":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(1550)]).then(n.bind(n,46482));case"whatsNew":return n.e(3142).then(n.bind(n,94956));case"whiteListFieldPath":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(599)]).then(n.bind(n,8451));case"widget":return Promise.all([n.e(9343),n.e(4303)]).then(n.bind(n,60575));case"window.domunloadcallback":return n.e(7157).then(n.bind(n,2441));case"window":return Promise.all([n.e(9343),n.e(5607)]).then(n.bind(n,49343));case"workflow":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(421)]).then(n.bind(n,53346));case"workflowTemplate":return Promise.all([n.e(9857),n.e(6721),n.e(9343),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(4477),n.e(6598)]).then(n.bind(n,16112));case"documentdiscarded":return t("skyward.base.documentdiscarded.js");case"keys":return t("skyward.base.keys.js");case"loadSpritesheet":return t("skyward.base.loadSpritesheet.js");case"observable":return t("skyward.base.observable.js");case"performancetest":return t("skyward.base.performancetest.js");case"academicStandardMaintenance":return t("skyward.ui.academicStandardMaintenance.js");case"accountDimensionEEL":return t("skyward.ui.accountDimensionEEL.js");case"accountlookupform":return t("skyward.ui.accountlookupform.js");case"arenascheduling":return t("skyward.ui.arenascheduling.js");case"assessment":return t("skyward.ui.assessment.js");case"assignmentImportTemplate":return t("skyward.ui.assignmentImportTemplate.js");case"attendanceentrytool":return t("skyward.ui.attendanceentrytool.js");case"authenticationmethod":return t("skyward.ui.authenticationmethod.js");case"autosavemanagers":return t("skyward.ui.autosavemanagers.js");case"benchmarking":return t("skyward.ui.benchmarking.js");case"breadcrumb":return t("skyward.ui.breadcrumb.js");case"calculatedfieldbuilder":return t("skyward.ui.calculatedfieldbuilder.js");case"calculatedfieldlist":return t("skyward.ui.calculatedfieldlist.js");case"calculationGroupCurriculumElement":return t("skyward.ui.calculationGroupCurriculumElement.js");case"calendar":return t("skyward.ui.calendar.js");case"calendardetails":return t("skyward.ui.calendardetails.js");case"childrecordquickentry":return t("skyward.ui.childrecordquickentry.js");case"ckeditor":return t("skyward.ui.ckeditor.js");case"conferencescheduler":return t("skyward.ui.conferencescheduler.js");case"courserequest":return t("skyward.ui.courserequest.js");case"crossreferencetableeditor":return t("skyward.ui.crossreferencetableeditor.js");case"dailyAttendance":return t("skyward.ui.dailyAttendance.js");case"dataminingcalculation":return t("skyward.ui.dataminingcalculation.js");case"dataminingsortsandsubtotals":return t("skyward.ui.dataminingsortsandsubtotals.js");case"dataobjectviewer":return t("skyward.ui.dataobjectviewer.js");case"demographics":return t("skyward.ui.demographics.js");case"dimensioncodetextbox":return t("skyward.ui.dimensioncodetextbox.js");case"disciplinepartialday":return t("skyward.ui.disciplinepartialday.js");case"disciplinequickentry":return t("skyward.ui.disciplinequickentry.js");case"dynamicnavigator":return t("skyward.ui.dynamicnavigator.js");case"easyiep":return t("skyward.ui.easyiep.js");case"edfi":return t("skyward.ui.edfi.js");case"employeedistrictpa":return t("skyward.ui.employeedistrictpa.js");case"entityclone":return t("skyward.ui.entityclone.js");case"entrywithdrawalspecialprogram":return t("skyward.ui.entrywithdrawalspecialprogram.js");case"examples":return t("skyward.ui.examples.js");case"family":return t("skyward.ui.family.js");case"fieldsearch":return t("skyward.ui.fieldsearch.js");case"filterbuilder":return t("skyward.ui.filterbuilder.js");case"foodservice":return t("skyward.ui.foodservice.js");case"foodservicepos":return t("skyward.ui.foodservicepos.js");case"form.ckeditor":return t("skyward.ui.form.ckeditor.js");case"form.editor":return t("skyward.ui.form.editor.js");case"form.inline":return t("skyward.ui.form.inline.js");case"form":return t("skyward.ui.form.js");case"form.print":return t("skyward.ui.form.print.js");case"form.textarea":return t("skyward.ui.form.textarea.js");case"formtexteditor":return t("skyward.ui.formtexteditor.js");case"gradebook":return t("skyward.ui.gradebook.js");case"gradebookAdvancedTextArea":return t("skyward.ui.gradebookAdvancedTextArea.js");case"gradebookanalytics":return t("skyward.ui.gradebookanalytics.js");case"gradebookassignment":return t("skyward.ui.gradebookassignment.js");case"gradebookcodeeel":return t("skyward.ui.gradebookcodeeel.js");case"gradebookmassbucketentry":return t("skyward.ui.gradebookmassbucketentry.js");case"gradebookquestion":return t("skyward.ui.gradebookquestion.js");case"gradebooksettings":return t("skyward.ui.gradebooksettings.js");case"gradeBucketCalculationSetup":return t("skyward.ui.gradeBucketCalculationSetup.js");case"grading":return t("skyward.ui.grading.js");case"gradingscalegroupgrademark":return t("skyward.ui.gradingscalegroupgrademark.js");case"graduationrequirements":return t("skyward.ui.graduationrequirements.js");case"header":return t("skyward.ui.header.js");case"headermenus":return t("skyward.ui.headermenus.js");case"health.wellnessscreeningquickentry":return t("skyward.ui.health.wellnessscreeningquickentry.js");case"hierarchy":return t("skyward.ui.hierarchy.js");case"iconifiedinputs":return t("skyward.ui.iconifiedinputs.js");case"importing":return t("skyward.ui.importing.js");case"importingapproval":return t("skyward.ui.importingapproval.js");case"importprofilephotosfilecounttester":return t("skyward.ui.importprofilephotosfilecounttester.js");case"journalentrydetails":return t("skyward.ui.journalentrydetails.js");case"journalentryselector":return t("skyward.ui.journalentryselector.js");case"mainmenu":return t("skyward.ui.mainmenu.js");case"massaddspecialprogramstx":return t("skyward.ui.massaddspecialprogramstx.js");case"massapprovebrowse":return t("skyward.ui.massapprovebrowse.js");case"massassignschedulingteams":return t("skyward.ui.massassignschedulingteams.js");case"massmovesectionstotargetcourse":return t("skyward.ui.massmovesectionstotargetcourse.js");case"massupdatecoursemaster":return t("skyward.ui.massupdatecoursemaster.js");case"matrix":return t("skyward.ui.matrix.js");case"matrixtable":return t("skyward.ui.matrixtable.js");case"mccccourseoffering":return t("skyward.ui.mccccourseoffering.js");case"menusecurity":return t("skyward.ui.menusecurity.js");case"menusecuritylayout":return t("skyward.ui.menusecuritylayout.js");case"mtss":return t("skyward.ui.mtss.js");case"multiselectcolumnbuilder":return t("skyward.ui.multiselectcolumnbuilder.js");case"oldDatePicker":return t("skyward.ui.oldDatePicker.js");case"onlineform":return t("skyward.ui.onlineform.js");case"onlineformelement":return t("skyward.ui.onlineformelement.js");case"onlinestudentassignment":return t("skyward.ui.onlinestudentassignment.js");case"parametermapper":return t("skyward.ui.parametermapper.js");case"payrollcode":return t("skyward.ui.payrollcode.js");case"printreceipt":return t("skyward.ui.printreceipt.js");case"programandrelatedservicetx":return t("skyward.ui.programandrelatedservicetx.js");case"progressreport":return t("skyward.ui.progressreport.js");case"promptsview":return t("skyward.ui.promptsview.js");case"prompttemplateselector":return t("skyward.ui.prompttemplateselector.js");case"proration":return t("skyward.ui.proration.js");case"purchaseorderselector":return t("skyward.ui.purchaseorderselector.js");case"recaptchatester":return t("skyward.ui.recaptchatester.js");case"reporting.aggregateCalculationBuilder":return t("skyward.ui.reporting.aggregateCalculationBuilder.js");case"reporting.column":return t("skyward.ui.reporting.column.js");case"reporting.customprompts":return t("skyward.ui.reporting.customprompts.js");case"reporting":return t("skyward.ui.reporting.js");case"reporting.multicolumnsection":return t("skyward.ui.reporting.multicolumnsection.js");case"reporting.searchparameters":return t("skyward.ui.reporting.searchparameters.js");case"reporting.treebrowse":return t("skyward.ui.reporting.treebrowse.js");case"reporting.userconditionselection":return t("skyward.ui.reporting.userconditionselection.js");case"reporting.variables":return t("skyward.ui.reporting.variables.js");case"reportingsorts":return t("skyward.ui.reportingsorts.js");case"rolemodulepath":return t("skyward.ui.rolemodulepath.js");case"scheduledays":return t("skyward.ui.scheduledays.js");case"scheduling":return t("skyward.ui.scheduling.js");case"schedulingboard":return t("skyward.ui.schedulingboard.js");case"seatingchart":return t("skyward.ui.seatingchart.js");case"sebbwa":return t("skyward.ui.sebbwa.js");case"sectionscheduler":return t("skyward.ui.sectionscheduler.js");case"securityrolecloneapproval":return t("skyward.ui.securityrolecloneapproval.js");case"selectPaddingFix":return t("skyward.ui.selectPaddingFix.js");case"sendProgressReportRunHistory":return t("skyward.ui.sendProgressReportRunHistory.js");case"specialeducation":return t("skyward.ui.specialeducation.js");case"specialeducationmi":return t("skyward.ui.specialeducationmi.js");case"specialeducationwi":return t("skyward.ui.specialeducationwi.js");case"specialprograms":return t("skyward.ui.specialprograms.js");case"specialprogramsks":return t("skyward.ui.specialprogramsks.js");case"specialprogramstn":return t("skyward.ui.specialprogramstn.js");case"specialprogramswi":return t("skyward.ui.specialprogramswi.js");case"staarfieldoverride":return t("skyward.ui.staarfieldoverride.js");case"staffactivity":return t("skyward.ui.staffactivity.js");case"staffresponsibilitytx":return t("skyward.ui.staffresponsibilitytx.js");case"staremployment":return t("skyward.ui.staremployment.js");case"stateassessmentsloginform":return t("skyward.ui.stateassessmentsloginform.js");case"stateassignedalternativeid":return t("skyward.ui.stateassignedalternativeid.js");case"statecountyreporting":return t("skyward.ui.statecountyreporting.js");case"statecoursedesignatorwa":return t("skyward.ui.statecoursedesignatorwa.js");case"stateReportingConfigDistrictWI":return t("skyward.ui.stateReportingConfigDistrictWI.js");case"statereportingdistribution":return t("skyward.ui.statereportingdistribution.js");case"statereportingfl":return t("skyward.ui.statereportingfl.js");case"structuredimensionpositionselector":return t("skyward.ui.structuredimensionpositionselector.js");case"studentapplication":return t("skyward.ui.studentapplication.js");case"studentCourseRecommendations":return t("skyward.ui.studentCourseRecommendations.js");case"studentguardian":return t("skyward.ui.studentguardian.js");case"studentLocker":return t("skyward.ui.studentLocker.js");case"studentsectioncalculatecreditscontrols":return t("skyward.ui.studentsectioncalculatecreditscontrols.js");case"studenttest":return t("skyward.ui.studenttest.js");case"successed":return t("skyward.ui.successed.js");case"taskstatus":return t("skyward.ui.taskstatus.js");case"teacheraccess":return t("skyward.ui.teacheraccess.js");case"teacherclasslist":return t("skyward.ui.teacherclasslist.js");case"temptableaddremove":return t("skyward.ui.temptableaddremove.js");case"thresholds":return t("skyward.ui.thresholds.js");case"timeoff":return t("skyward.ui.timeoff.js");case"timetrackingchangestatus":return t("skyward.ui.timetrackingchangestatus.js");case"transferGrades":return t("skyward.ui.transferGrades.js");case"transportation":return t("skyward.ui.transportation.js");case"trex":return t("skyward.ui.trex.js");case"trs2submissionimport":return t("skyward.ui.trs2submissionimport.js");case"updatemultipleactiondetailstatusesentry":return t("skyward.ui.updatemultipleactiondetailstatusesentry.js");case"user":return t("skyward.ui.user.js");case"userform":return t("skyward.ui.userform.js");case"userstudenttilesetting":return t("skyward.ui.userstudenttilesetting.js");case"visionscreening":return t("skyward.ui.visionscreening.js");case"w2csubmission":return t("skyward.ui.w2csubmission.js");case"w2submission":return t("skyward.ui.w2submission.js");case"warehouserequestapprovalmessage":return t("skyward.ui.warehouserequestapprovalmessage.js");case"workflowprocess":return t("skyward.ui.workflowprocess.js");case"yearend":return t("skyward.ui.yearend.js");default:throw new Error("unknown import ".concat(e))}function t(e){const t=$.Deferred(),n=document.createElement("script"),a=window.location.origin+skyward.global.virtualDir+"Scripts/"+e;return n.onload=function(){return t.resolve(a)},n.onerror=function(){return t.reject()},n.src=a,document.head.appendChild(n),t.promise()}}const W=window.skyward;W.global=W.global||{};$.ajaxPrefilter(function(e,t,n){if(e.global||"script"!==e.dataType||"GET"!==e.type||-1===e.url.indexOf("/Scripts/")){if(e.url=Fe(e.url),function(e){var t;if("jsonp"!==e.dataType||!e.url)return!1;const n=null===(t=$.skyserial)||void 0===t||null===(t=t.defaults)||void 0===t?void 0:t.host;if(!n)return!1;try{return new URL(e.url,window.location.href).origin===new URL(n,window.location.href).origin}catch(t){return 0===e.url.indexOf(n)}}(e)||(e.headers=e.headers||{},e.headers["X-CSRF-TOKEN"]=fe),e.signal)if(e.signal.aborted)n.abort();else{const t=()=>n.abort();e.signal.addEventListener("abort",t),n.always(()=>{e.signal.removeEventListener("abort",t)})}!0===e.useVueScope&&void 0!==(0,j.getCurrentScope)()&&(0,j.onScopeDispose)(()=>{4!==n.readyState&&n.abort()})}});let U=function(e){var t=$("<div />",{style:"position:absolute; display:none;"});t.text(e),$(document.body).append(t);var n=t.width();return t.remove(),n},K=function(e){return e?"object"==typeof e?e:((0,F.reportException)(new F.SkywardException('The "data" parameter should be an object or null/undefined. (Got a '.concat(typeof e,")"))),{}):{}},q=function(e,t,n,a){let o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:"POST";const r=K(t);a||(e=Fe(e,n),r.sgh=fe);var i=$("<form>",{action:e,method:o,target:n?"_blank":"_self"});return Object.keys(r).forEach(function(e){var t=$("<input>",{type:"hidden",name:e});"object"==typeof r[e]?t.val(JSON.stringify(r[e])):t.val(r[e]),i.append(t)}),i},G=function(e){$(document.body).append(e),e.submit(),e.remove()},z=function(e,t){if(null===e||null===t)return e===t;if(void 0===e||void 0===t)return e===t;var n=Object.keys(e),a=Object.keys(t);if(n.length!==a.length)return!1;var o=n.concat(a);o=o.filter(function(e,t){return o.indexOf(e)===t});for(var r=0;r<o.length;r++){var i=o[r],s=e[i],l=t[i];if((void 0===s||void 0===l)&&s!==l)return!1;var c=typeof s;if(c!==typeof l)return!1;if("object"===c){var d=$.isEmptyObject(s),u=$.isEmptyObject(l);if(d||u){if(d!==u)return!1}else if(!z(s,l))return!1}else if(s!==l)return!1}return!0},J=function(e,t){const n=[];if(null===e||null===t)return{areEqual:e===t,differences:n};if(void 0===e||void 0===t)return{areEqual:e===t,differences:n};const a=Object.keys(e),o=Object.keys(t);if(a.length!==o.length)return n.push(...a.filter(e=>!o.includes(e))),n.push(...o.filter(e=>!a.includes(e))),{areEqual:!1,differences:n};const r=[...new Set([...a,...o])];for(const a of r){const o=e[a],r=t[a];if((void 0===o||void 0===r)&&o!==r){n.push(a);continue}const i=typeof o;if(i===typeof r)if("object"===i){const e=$.isEmptyObject(o),t=$.isEmptyObject(r);if(e||t)e!==t&&n.push(a);else{const e=J(o,r);e.areEqual||(n.push(a),n.push(...e.differences.map(e=>"".concat(a,".").concat(e))))}}else o!==r&&n.push(a);else n.push(a)}return{areEqual:0===n.length,differences:n}};const Y=new Set,Q={},X=new Set,Z={},ee={};let te=!1;const ne=new Set,ae=(async()=>{for(await new Promise(e=>$(e)),$("script[src]").each(function(){const e=this;var t;(X.add(e.src),e.hasAttribute("data-included-scripts"))&&(null===(t=e.getAttribute("data-included-scripts"))||void 0===t||t.split(",").forEach(e=>X.add(window.location.origin+e),X))}),$("link[href].xRefStylesheet").each(function(){Y.add(this.href)}),te=!0;ne.size;)await Promise.all(ne)})();function oe(e){return ee[e]||(ee[e]=H(e).then(t=>{(function(e){try{return new URL(e),!0}catch(e){return!1}})(t)&&(X.add(t),delete ee[e])})),ee[e]}function re(e){const t=e.not(function(){return this instanceof HTMLScriptElement&&X.has(this.src)}).toArray();return Promise.all(t.map(function(e){const t=e.dataset.webpackModule;return t?H(t):function(e){const t=Z[e.src];if(t)return t;const n=$.Deferred();Z[e.src]=n.promise();var a=document.createElement("script");a.async=!1;for(var o=0;o<e.attributes.length;o++){var r=e.attributes[o];null===r.namespaceURI?a.setAttribute(r.name,r.value):a.setAttributeNS(r.namespaceURI,r.name,r.value)}return a.addEventListener("load",function t(){a.removeEventListener("load",t),X.add(e.src),n.resolve(),delete Z[e.src]}),document.body.appendChild(a),n.promise()}(e)}))}function ie(e){const t=e.not(function(){return this instanceof HTMLLinkElement&&Y.has(this.href)}).toArray();return Promise.all(t.map(function(e){return function(e){const t=Q[e.href];if(t)return t;const n=$.Deferred();Q[e.href]=n.promise();const a=document.createElement("link");a.rel="stylesheet";for(var o=0;o<e.attributes.length;o++){var r=e.attributes[o];null===r.namespaceURI?a.setAttribute(r.name,r.value):a.setAttributeNS(r.namespaceURI,r.name,r.value)}return a.addEventListener("load",function t(){a.removeEventListener("load",t),Y.add(e.href),n.resolve(),delete Q[e.href]}),document.head.appendChild(a),n.promise()}(e)}))}function se(e){var t;if(te&&(0,F.reportException)(new F.SkywardException('Asynchronous HTML request was not sent using `viewparthtml`. This will lead to slowdowns or errors when loading the page. To fix this, change the `dataType` parameter in your ajax request to "viewparthtml", or pass your html string to skyward.global.processViewPartHtml().')),"SCRIPT"===(null===(t=document.currentScript)||void 0===t?void 0:t.tagName.toUpperCase())){const t=H(null!=e?e:document.currentScript.dataset.webpackModule);return te||(ne.add(t),t.then(()=>{ne.delete(t)})),t}return(0,F.reportException)(new F.SkywardException("Could not load module. Element (document.currentScript) is not of type script.")),Promise.reject()}async function le(e){if("string"==typeof e&&!/<script /.test(e)&&!/<link /.test(e))return e;const t=$(document.createDocumentFragment());t.append(e);const n=t.find("link[href].xRefStylesheet");n.remove();const a=t.find("script[src],script[data-webpack-module]");a.remove();try{await ie(n)}catch(t){(0,F.reportException)(new F.SkywardException("Error loading ViewPart partials.",JSON.stringify({exception:t,html:e,scripts:Array.from(a).map(e=>e.src),links:Array.from(n).map(e=>e.href)})))}try{await re(a)}catch(t){(0,F.reportException)(new F.SkywardException("Error loading ViewPart scripts.",JSON.stringify({exception:t,html:e,scripts:Array.from(a).map(e=>e.src),links:Array.from(n).map(e=>e.href)})))}return t.children()}function ce(e){if("string"==typeof e&&!/<script /.test(e)&&!/<link /.test(e))return{html:e,loaded:$.Deferred().resolve()};const t=$(document.createDocumentFragment());t.append(e);const n=t.find("script[src],script[data-webpack-module]");n.remove();const a=t.find("link[href].xRefStylesheet");return a.remove(),{html:t.children(),loaded:Promise.all([re(n),ie(a)])}}$.ajaxTransport("viewparthtml",function(e){let t;e.responseFields.viewparthtml="responseText";return{send:function(n,a){var o;t=e.xhr(),t.open(null!==(o=e.method)&&void 0!==o?o:e.type,e.url,e.async,e.username,e.password),e.xhrFields&&$.extend(t,e.xhrFields),e.mimeType&&t.overrideMimeType(e.mimeType),n.Accept="text/plain",e.crossDomain||"X-Requested-With"in n||(n["X-Requested-With"]="XMLHttpRequest"),$.each(n,function(e,n){t.setRequestHeader(String(e),n)}),t.onloadend=async function(){if(0!==t.status){var e=t.getResponseHeader("content-type");if(e&&"text/html"===e.split(";").shift()){const e=await le(t.responseText);a(t.status,t.statusText,{viewparthtml:e},t.getAllResponseHeaders())}else a(t.status,t.statusText,{text:t.responseText},t.getAllResponseHeaders())}},t.send(e.hasContent?e.data:void 0)},abort:function(){t&&t.abort()}}});let de=W.global.isDebug||(null===(a=window._skyward)||void 0===a||null===(a=a.global)||void 0===a?void 0:a.isDebug)||!1,ue=W.global.virtualDir||(null===(o=window._skyward)||void 0===o||null===(o=o.global)||void 0===o?void 0:o.virtualDir)||"",fe=W.global.sessionGuidHash||(null===(r=window._skyward)||void 0===r||null===(r=r.global)||void 0===r?void 0:r.sessionGuidHash)||"",he=W.global.windowGuid||(null===(i=window._skyward)||void 0===i||null===(i=i.global)||void 0===i?void 0:i.windowGuid)||"",pe=W.global.windowEntityID||(null===(s=window._skyward)||void 0===s||null===(s=s.global)||void 0===s?void 0:s.windowEntityID)||0,me=W.global.windowDistrictID||(null===(l=window._skyward)||void 0===l||null===(l=l.global)||void 0===l?void 0:l.windowDistrictID)||0,ge=W.global.windowSchoolYearID||(null===(c=window._skyward)||void 0===c||null===(c=c.global)||void 0===c?void 0:c.windowSchoolYearID)||0,we=W.global.windowFiscalYearID||(null===(d=window._skyward)||void 0===d||null===(d=d.global)||void 0===d?void 0:d.windowFiscalYearID)||0,ve=W.global.pageStateGuid||(null===(u=window._skyward)||void 0===u||null===(u=u.global)||void 0===u?void 0:u.pageStateGuid)||"",be=W.global.loggedIn||(null===(f=window._skyward)||void 0===f||null===(f=f.global)||void 0===f?void 0:f.loggedIn)||!1,ye=W.global.userIdHash||(null===(h=window._skyward)||void 0===h||null===(h=h.global)||void 0===h?void 0:h.userIdHash)||"",_e=null!==(p=null!==(m=W.global.isSuperUser)&&void 0!==m?m:null===(g=window._skyward)||void 0===g||null===(g=g.global)||void 0===g?void 0:g.isSuperUser)&&void 0!==p&&p,Ce=null!==(w=null!==(v=W.global.isRealSuperUser)&&void 0!==v?v:null===(b=window._skyward)||void 0===b||null===(b=b.global)||void 0===b?void 0:b.isRealSuperUser)&&void 0!==w&&w,ke=null!==(y=null!==(_=W.global.isSupportAccount)&&void 0!==_?_:null===(C=window._skyward)||void 0===C||null===(C=C.global)||void 0===C?void 0:C.isSupportAccount)&&void 0!==y&&y,Se=null!==(k=null!==(S=W.global.isRealSupportAccount)&&void 0!==S?S:null===(D=window._skyward)||void 0===D||null===(D=D.global)||void 0===D?void 0:D.isRealSupportAccount)&&void 0!==k&&k,De=null!==(E=null!==(P=W.global.isInHouse)&&void 0!==P?P:null===(O=window._skyward)||void 0===O||null===(O=O.global)||void 0===O?void 0:O.isInHouse)&&void 0!==E&&E,Ee=W.global.sessionTimeoutSeconds||"",Pe=W.global.mobileAccess||(null===(B=window._skyward)||void 0===B||null===(B=B.global)||void 0===B?void 0:B.mobileAccess)||!1,Oe=W.global.mobileAccessEmulation||(null===(T=window._skyward)||void 0===T||null===(T=T.global)||void 0===T?void 0:T.mobileAccessEmulation)||!1,Be=W.global.isAndroidApp||(null===(x=window._skyward)||void 0===x||null===(x=x.global)||void 0===x?void 0:x.isAndroidApp)||!1,Te=W.global.isIosApp||(null===(M=window._skyward)||void 0===M||null===(M=M.global)||void 0===M?void 0:M.isIosApp)||!1,xe=W.global.isReadOnlyImpersonation||(null===(I=window._skyward)||void 0===I||null===(I=I.global)||void 0===I?void 0:I.isReadOnlyImpersonation)||!1,Me=W.global.froalaLicenseKey||(null===(A=window._skyward)||void 0===A||null===(A=A.global)||void 0===A?void 0:A.froalaLicenseKey)||"",Ie=W.global.sessionWarnSeconds||"",Ae=W.global.sessionClientPingSeconds||"";const Le=null===(L=null!==(R=W.global.tooltipsEnabled)&&void 0!==R?R:null===(N=window._skyward)||void 0===N||null===(N=N.global)||void 0===N?void 0:N.tooltipsEnabled)||void 0===L||L,Re="ReadOnlyScreenReaderAnnouncement";let Ne=(0,V.lazy)(()=>window.matchMedia("(prefers-reduced-motion: reduce)").matches||!1);Object.defineProperty(W.global,"prefersReducedMotion",{get:Ne,configurable:!0,enumerable:!0});let Fe=function(e,t){var n={w:he,p:ve};return t&&(n.generateNewDefaultWindow="true"),Object.keys(n).forEach(function(t){n[t].length&&(e=function(e,t,n){var a=new RegExp("([?&])"+t+"=.*?(&|$)","i"),o=-1!==e.indexOf("?")?"&":"?";return e.match(a)?e.replace(a,"$1"+t+"="+n+"$2"):e+o+t+"="+n}(e,t,n[t]))}),e};const je=n(20589),$e=n(12750),Ve=n(58687),He=n(22091);je.extend($e),je.extend(Ve),je.extend(He),window.dayjs=je,(0,F.registerErrorDataGatherer)("global",function(){return{viewpartScripts:$("script[src]:not([data-packaged])").toArray().map(function(e){return e.src})}})},584(e,t,n){"use strict";n.r(t),n.d(t,{disable:()=>b,enable:()=>w,startWarningTimers:()=>v});var a=n(2894),o=n(88157),r=n(28640),i=n(49343);let s="monitor not enabled";const l="keydown click";let c=!1;const d=[];let u,f,h,p=3e4,m=6e5,g=9e5;function w(e,t,n){p=e||p,m=t||m,g=n||g,a.mobileAccess||v(),c||($(document).on(l,_),(0,r.enable)(e),c=!0)}function v(e){k(),(null==e||null==e||isNaN(e))&&(e=0),clearTimeout(u),u=setTimeout(C,g-e),m-e>0?(y(),d.push(setTimeout(S,m-e))):S(e),d.push(setTimeout(D,g-e))}function b(){(0,r.disable)(),k(),$(document).off(l,_),s="monitor not enabled",c=!1}function y(){h&&(h.close(),h=null)}function _(){s="Active",(0,r.setState)(s)}function C(){(0,r.postState)(r.SessionState.ClientTimedOut)}function k(){for(;d.length>0;)clearTimeout(d.pop())}function S(e){e||(e=0);const t=e>m?Math.floor(e/6e4):Math.floor(m/6e4);if(clearTimeout(f),f=setTimeout(function(){var e;e=t+1,$("#idleTimeMinutes").text(e)},6e4-e%6e4),h)return void("Active"==(0,r.currentState)()&&y());const n=$(document.activeElement);h=(0,o.showDialog)("Session Timeout Warning","<p>Your session has been inactive for over <span id='idleTimeMinutes'>"+t+"</span> minutes.</p><br/>For security purposes, inactive sessions are automatically signed out after "+Math.ceil(g/6e4)+" minutes.<br/>",[{text:"Stay Signed In",icon:"SignIn",click:function(){h.close(),n.trigger("focus"),(0,r.postState)(r.SessionState.Active)},focus:!0},{text:"Sign Out",icon:"SignOut",click:function(){h.close(),(0,i.loadContent)("full","security","SignIn","index",null,void 0)}}],{forceClose:!0,additionalClasses:"critical",role:"alertdialog"})}function D(){(0,r.postState)(r.SessionState.ClientTimedOut),k(),y()}},49698(e,t,n){"use strict";n.r(t);var a=n(79126),o=n(66952),r=n(40346),i=n(14144),s=n(22528);n(75618);function l(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function c(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var d=function(e){return e[e.Complete=0]="Complete",e[e.Error=1]="Error",e[e.Aborted=2]="Aborted",e}(d||{});window.skyward.base.registerScript("iframeListener",function(e,t){if(window.self!==window.top)try{if(window.origin===window.parent.origin){var n;const e=Array.from(window.parent.document.getElementsByTagName("iframe")).find(e=>e.contentWindow===window);if("true"===(null==e||null===(n=e.dataset.ignoreIframeListener)||void 0===n?void 0:n.toLowerCase()))return}}catch(e){}const u=t.Deferred(),f=t.Deferred(),h=Promise.withResolvers(),p=function(e,t){if("function"==typeof e){const n=new MessageChannel;return n.port1.onmessage=function(t){e.apply(void 0,t.data)},t.push(n.port2),{type:"function",port:n.port2}}if(e instanceof Promise){const n=new MessageChannel;return e.then(e=>n.port1.postMessage({success:!0,value:e}),e=>n.port1.postMessage({success:!1,error:e})),t.push(n.port2),{type:"promise",port:n.port2}}return e instanceof ArrayBuffer&&t.push(e),e};const m={create(e,t,n){var a;const o=null!==(a=window._skyward.global.host)&&void 0!==a?a:"https?://".concat(window.location.host).concat(window.skyward.global.virtualDir),r=e=>e&&"*"!==e?e:"[^/]*",i="".concat(o).concat(r(e),"/").concat(r(t),"/").concat(r(n),"(?:\\?.*)?$"),s=new RegExp(i,"i"),l=e=>s.test(e);return l.pattern=s,l},any:e=>t=>e.some(e=>e(t))},g={CodeEEL:m.any([m.create("*","*","PerformCodeEELSearch"),m.create("*","*","CodeEEL/\\d+"),m.create("*","*","ChangeBrowsePage"),m.create("*","*","GetRecordCount"),m.create("SkySys","Browse","MonitorBrowsePerformance")]),Upload:m.any([m.create("Security","SessionFileUpload","(?:Create|Delete)SessionFileUpload"),m.create("SkySys","Media","Download\\w+/\\d+")]),UserForm:m.create("Form","FormField","ReplaceRelationshipDisplay"),UserFormRelationship:m.any([m.create("Form","UserForm","MapRelationship"),m.create("Form","UserForm","SubmitSetRelationship"),m.create("Form","UserForm","MapRelationshipStudentServices"),m.create("Form","UserForm","SubmitSetRelationshipStudentServices")]),UserFormSpecification:m.create("Form","FormField","GetFormFieldSpecification"),SaveFormFieldVersionFromSpecifications:m.create("Form","FormFieldVersion","SaveFormFieldVersionFromSpecifications"),SaveUserFormFieldVersionFromSpecifications:m.create("Form","FormFieldVersion","SaveUserFormFieldVersionFromSpecifications"),SaveUserFormFieldVersionFromSpecificationsStudentServices:m.create("Form","FormFieldVersion","SaveUserFormFieldVersionFromSpecificationsStudentServices"),OnlineForm:m.create("SkySys","Media","DownloadMedia/\\d+")},w=function(e){return function(e){return"object"==typeof e&&e.port instanceof MessagePort}(e)?"function"===e.type?function(){const t=[];for(var n=arguments.length,a=new Array(n),o=0;o<n;o++)a[o]=arguments[o];for(const e of a)e instanceof ArrayBuffer&&t.push(e);e.port.postMessage(a,t)}:new Promise((t,n)=>{e.port.onmessage=function(e){const a=e.data;a.success?t(a.value):n(a.error)}}):e},v=function(e){const t=new Error("Iframe does not have a content window");return t.details={connected:e.isConnected,hasSrc:Boolean(e.src),hasSrcdoc:Boolean(e.srcdoc)},t};if(window===window.parent){e.iframeListener=window.skyward.iframeListener||{};const n=new WeakMap,o=new WeakMap,r=new WeakMap,i=function(e,t,a){const i=new Promise((r,i)=>{if(!e.contentWindow)return o.delete(e),n.delete(e),console.warn("called method on detached iframe?"),void i(v(e));const s=new MessageChannel,l=[s.port2],c=a.map(e=>p(e,l)),d={type:t,data:c,reply:s.port2},u=n.get(e);s.port1.onmessage=function(e){const t=e.data;f(t)?r(w(t.value)):i(t.error)},u?u.postMessage(d,l):e.contentWindow.postMessage(d,"*",l)});return Promise.race([i,r.get(e)])},s=function(e,t){for(var n=arguments.length,a=new Array(n>2?n-2:0),o=2;o<n;o++)a[o-2]=arguments[o];return l(e).then(e=>i(e,t,a))},l=function(e){const n=t(e)[0];return n instanceof HTMLIFrameElement?document.documentElement.contains(n)?c(n):Promise.reject(new Error("Iframe no longer exists in the document")):Promise.reject(new Error("Not an iframe"))},c=function(e){var s,l;const d=o.get(e);if(d)return d;if((null===(s=e.src)||void 0===s?void 0:s.length)>0&&new URL(e.src,window.location.href).origin!=new URL(window.location.href).origin)return Promise.reject(new Error("Iframe is from a different domain"));let f,p=!1;if(e.sandbox&&!e.sandbox.contains("allow-scripts")&&(p=!0,!e.sandbox.contains("allow-same-origin")))return Promise.reject(new Error("No way to communicate with iframe"));const m=new Promise((t,n)=>{f=new MutationObserver(()=>{n(new a.CancellationError("iframe src changed"))}),f.observe(e,{attributeFilter:["src","srcdoc"],attributes:!0})}),g=_()(e).then(()=>Promise.reject(new a.CancellationError("iframe removed from DOM"))),w=Promise.race([m,g]).finally(()=>{o.delete(e),n.delete(e),f.disconnect()});w.catch(()=>{}),r.set(e,w);const b=(null!==(l=t(e).data("loadPromise"))&&void 0!==l?l:Promise.resolve()).then(()=>{let t;return new Promise((a,r)=>{if(!e.contentWindow)return o.delete(e),void r(v(e));if(p){const{port1:t,port2:a}=new MessageChannel;n.set(e,t),a.onmessage=y(e.contentWindow,!0)}let s=100;t=setInterval(()=>{if(s--<=0)return o.delete(e),void r(new Error('Timed out connecting to iframe "'.concat(e.id,'"')));i(e,"ping",[]).then(a).catch(r)},50)}).then(()=>(u.then(()=>{i(e,"iFrameCanPostMessage",[])}),h(e).then(()=>e))).finally(()=>{void 0!==t&&clearInterval(t)}).catch(t=>document.documentElement.contains(e)?c(e):Promise.reject(t))});return o.set(e,b),b};window.addEventListener("message",function(e){const n=e.data;if(!n||!n.type||!n.nonce)return;const o=t("iframe").filter(function(){return this.contentWindow===e.source});var r,i;if(o.length)if(o[0].hasAttribute("srcdoc")||new URL(o.attr("src"),window.location.href).host===window.location.host)if(o.data("messageNonce")===n.nonce)switch(n.type){case"log":(0,a.reportException)(new a.SkywardException(n.data));break;case"ajax":const e=n.data;if(r=o,i=e.url,!r.data("allowedEndpoints").split(",").some(e=>g[e](i)))throw new Error("iframe attempting to forward ajax request to url not in allowed list: ".concat(e.url));e.onComplete=w(e.onComplete),e.onError=w(e.onError),e.onUploadProgress=w(e.onUploadProgress),e.abort=w(e.abort),d(e)}else(0,a.reportException)(new a.SkywardException("message received from iframe with incorrect/missing nonce"));else console.log("message received from external iframe")}),u.resolve();const d=function(e){var t=new XMLHttpRequest;t.open(e.method,e.url),e.timeout&&(t.timeout=e.timeout);for(let n in e.headers)t.setRequestHeader(n,e.headers[n]);e.mimeType&&t.overrideMimeType(e.mimeType),t.responseType=e.responseType,t.onabort=t.onerror=t.ontimeout=function(){e.onError()},t.onload=function(){e.onComplete(t.status,t.response,t.getAllResponseHeaders())},t.upload.onprogress=function(t){e.onUploadProgress(t.lengthComputable,t.loaded,t.total)},e.abort.then(()=>{t.abort()});let n=e.body;if("FormData"===e.bodyType){const t=new FormData;for(let[n,a]of Object.entries(e.body))for(let e of a)if(e instanceof File){const a=new File([e],e.name,{lastModified:e.lastModified,type:e.type});t.append(n,a)}else t.append(n,e);n=t}t.send(n)},f=function(e){return void 0===e.error},h=async function(n){const a=await t.ajax({url:"".concat(e.global.virtualDir,"skysys/svg/spritesheet?v=6"),dataType:"text",cache:!0});await i(n,"setupSvgs",[a])};e.iframeListener.ready=function(e){return l(e).then(function(){})};const m=Object.keys(b(window));for(const t of m)e.iframeListener[t]=function(e){for(var n=arguments.length,a=new Array(n>1?n-1:0),o=1;o<n;o++)a[o-1]=arguments[o];return s(e,t,...a)};e.iframeListener.connect=function(e){return l(e).then(e=>{const t=r.get(e),n={};for(const a of m)n[a]=function(){for(var n=arguments.length,o=new Array(n),r=0;r<n;r++)o[r]=arguments[r];return Promise.race([t,i(e,a,o)])};return n})}}else window.addEventListener("message",y(window,!1)),function(){window.addEventListener("unhandledrejection",function(e){n(e.reason)}),window.addEventListener("error",function(e){n(e.error,{filename:e.filename,lineno:e.lineno,colno:e.colno})});const n=function(e,t){const n=e instanceof Error?e:String(e),a=function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?l(Object(n),!0).forEach(function(t){c(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):l(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}({error:n},null!=t?t:{});try{window._skyward.global.postMessage({type:"log",data:a})}catch(e){var o;a.error="Error in iframe: ".concat(null!==(o=n.message)&&void 0!==o?o:n),window._skyward.global.postMessage({type:"log",data:a})}};class o extends XMLHttpRequest{constructor(){super(),c(this,"_requestUrl",void 0),c(this,"_method",void 0),c(this,"_unsupported",void 0),c(this,"_status",void 0),c(this,"_statusCode",void 0),c(this,"_response",void 0),c(this,"_rawResponse",void 0),c(this,"_responseText",void 0),c(this,"_responseXml",void 0),c(this,"_responseHeaders",void 0),c(this,"_headers",void 0),c(this,"_forwarded",void 0),c(this,"_abort",void 0),c(this,"_mimeType",void 0),this._unsupported=[],this._headers={},this._forwarded=!1}get status(){if(!this._forwarded)return super.status;switch(this._status){case d.Complete:return this._statusCode;case d.Error:case d.Aborted:return 400;default:return 0}}get statusText(){if(!this._forwarded)return super.statusText;switch(this._status){case d.Complete:return"OK";case d.Error:return"Error";case d.Aborted:return"Aborted";default:return""}}get readyState(){return this._forwarded?void 0!==this._status?4:0:super.readyState}get response(){if(!this._forwarded)return super.response;if(void 0!==this._rawResponse&&void 0===this._response)switch(this.responseType){case"arraybuffer":case"blob":case"json":case"text":this._response=this._rawResponse;break;case"document":this._response=(new DOMParser).parseFromString(this.responseText,"text/html");break;default:throw new Error("unimplemented response type: ".concat(this.responseType))}return this._response}get responseXML(){var e;return this._forwarded?(void 0!==this._responseText&&void 0===this._responseXml&&(this._responseXml=(new DOMParser).parseFromString(this._responseText,"text/xml")),null!==(e=this._responseXml)&&void 0!==e?e:null):super.responseXML}get responseText(){var e;if(!this._forwarded)return super.responseText;if("string"!=typeof this._responseText){if(this._rawResponse instanceof Blob||this._rawResponse instanceof ArrayBuffer||this._rawResponse instanceof Document)throw new Error("responseText is not supported for responseType blob or arraybuffer");"object"==typeof this._rawResponse?this._responseText=JSON.stringify(this._rawResponse):this._responseText=this._rawResponse}return null!==(e=this._responseText)&&void 0!==e?e:""}setRequestHeader(e,t){if(!this._forwarded)return super.setRequestHeader(e,t);"X-CSRF-TOKEN"===e||"X-Requested-With"===e||"Accept"===e||"Content-Type"===e?this._headers[e]=t:this._unsupported.push('custom headers: "'.concat(e,'"'))}getAllResponseHeaders(){var e;return this._forwarded?null!==(e=this._responseHeaders)&&void 0!==e?e:"":super.getAllResponseHeaders()}getResponseHeader(e){var t,n,a;if(!this._forwarded)return super.getResponseHeader(e);const o=(null!==(t=this._responseHeaders)&&void 0!==t?t:"").trim().split(/\r?\n/),r=e.toLowerCase()+": ";return null!==(n=null===(a=o.find(e=>e.startsWith(r)))||void 0===a?void 0:a.slice(r.length))&&void 0!==n?n:null}addEventListener(e,t,n){"load"!==e&&"abort"!==e&&"error"!==e&&"loadend"!==e&&this._unsupported.push('unusual event listeners: "'.concat(e,'"')),super.addEventListener(e,t,n)}open(e,t,n,a,o){n||this._unsupported.push("sync"),(a||o)&&this._unsupported.push("credentials"),this._method=e;let r=t;try{r=new URL(t,window._skyward.global.host).href}catch(e){}this._requestUrl=r,!function(e){var t;return null===(t=window._skyward.global.allowedEndpoints)||void 0===t?void 0:t.some(t=>g[t](e))}(r)?super.open(e,t,null!=n&&n,a,o):this._forwarded=!0}send(e){if(this._unsupported.length>0&&console.warn("AJAX request in iframe uses unsupported features: ".concat(this._unsupported.join(", "))),!this._forwarded)return super.send(e);const t=(e,t,n)=>{this._status=d.Complete,this._statusCode=e,this._rawResponse=t,this._responseHeaders=n,this.dispatchEvent(new ProgressEvent("load")),this.dispatchEvent(new ProgressEvent("loadend"))},n=()=>{this._status=d.Error,this.dispatchEvent(new ProgressEvent("error")),this.dispatchEvent(new ProgressEvent("loadend"))},a=(e,t,n)=>{this.upload.dispatchEvent(new ProgressEvent("progress",{lengthComputable:e,loaded:t,total:n}))},o=new Promise(e=>{this._abort=e});let r,i="";const s=[];if(!("string"==typeof e||null==e||e instanceof FormData||window.ReadableStream&&e instanceof ReadableStream||e instanceof Blob||e instanceof ArrayBuffer))throw new Error("Unsupported body type");e instanceof ArrayBuffer&&s.push(e),e instanceof FormData&&(r={},i="FormData",e.forEach((e,t)=>{var n;r[t]=null!==(n=r[t])&&void 0!==n?n:[],r[t].push(e)})),window._skyward.global.postMessage({type:"ajax",data:{method:this._method,url:this._requestUrl,timeout:this.timeout,responseType:"document"===this.responseType?"text":this.responseType,mimeType:this._mimeType,bodyType:i,body:null!=r?r:e,headers:this._headers,onComplete:p(t,s),onError:p(n,s),onUploadProgress:p(a,s),abort:p(o,s)}},s)}abort(){var e;this._forwarded||super.abort(),null===(e=this._abort)||void 0===e||e.call(this)}overrideMimeType(e){this._forwarded||super.overrideMimeType(e),this._mimeType=e}}window.jQuery.ajaxSettings.xhr=()=>new o;const r=function(e){const t="object"==typeof e&&null!==e?e.status:void 0;return e instanceof Error&&"Failed to fetch"===e.message||"number"==typeof t&&t>=400},i=function(e){if(e instanceof Error)return e;const t="object"==typeof e&&null!==e?JSON.stringify({status:e.status,statusText:e.statusText,responseText:e.responseText}):String(e);return new a.SkywardException("Unexpected iframe image fetch error.",t)},s=function(e){return Promise.resolve(e).then(function(e){return{data:e,status:"fulfilled"}},function(e){return{data:e,status:"rejected"}})};e.window.registerLoadDOMCallback(async function(){try{await f;const e=this.find('img:is([src^="'.concat(window.skyward.global.virtualDir,'SkySys/Media/"], [src^="').concat(window.skyward.global.virtualDir,'SkySys/Media/DownloadMedia/"])')).toArray().map(async e=>{let n;try{const a=await t.ajax({url:e.src,method:"GET",xhr:()=>{const e=new o;return e.responseType="blob",e}});n=URL.createObjectURL(a);const r=new Promise(t=>{e.onload=t,e.onerror=t});e.src=n,await r}catch(e){r(e)||(0,a.reportException)(i(e))}finally{void 0!==n&&URL.revokeObjectURL(n)}});await Promise.all(e.map(s))}finally{h.resolve()}}),e.window.registerLoadDOMCallback(function(){this.find("svg use").each(function(){const e=/#svg-\w+/.exec(this.getAttribute("href"))[0];this.setAttribute("href",e)})})}();function b(t){const n=t.jQuery,a={getHeight(){const a=t.document.documentElement;let o=n(a).outerHeight(!0);return o+=e.window.scrollbarHeight,o},setupElements(){n("textarea").attr("style","resize: none; overflow: auto;")},setupChangeTracking(e){n("input,select,textarea").each(function(){var e=n(this);e.attr("data-original-value",e.val())}),(0,r.setUpChangeTracking)(t.document.documentElement,()=>{e((0,r.isDirty)(t.document.documentElement))})},setDocumentOverflow(e){n(t.document.documentElement).css("overflow-y",e)},preSave(){n("input,select,textarea").removeAttr("data-original-value")},getHtml:()=>e.htmlGatherer.getHtml(t.document.documentElement),getFieldValues:()=>(0,i.getFieldValues)(n(t.document.documentElement)),displayValidationMessages:e=>(0,s.displayValidationMessages)(e,n(t.document.documentElement)),clearDirtyList:()=>(0,r.clearDirtyList)(void 0,t),getBoundingClientRect:()=>t.document.body.getBoundingClientRect(),getScrollHeight:()=>t.document.body.scrollHeight,waitForLoadedAndNonEmpty:()=>new Promise(e=>{!function a(){if("complete"!==t.document.readyState)return void n(t.document).one("load",a);if(0===t.document.body.children.length)return void setTimeout(a,100);e()}()}),getHtmlValues:()=>e.htmlGatherer.getValues(n(t.document)),setHtmlValues:a=>e.htmlGatherer.setValues(a,n(t.document)),async getOuterHtml(a){var o=await e.htmlGatherer.getNode(n(t.document.documentElement),a);return e.htmlGatherer.getOuterHtml(o)},setupSvgs(e){const n=t.document.createElement("div");n.innerHTML=e,t.document.head.appendChild(n.firstChild);for(const e of Array.from(t.document.getElementsByTagName("use"))){var a,o=e.getAttribute("href"),r=null===(a=/#svg-.*$/.exec(o))||void 0===a?void 0:a[0];r&&e.setAttribute("href",r)}},initForm:()=>e.form.initInIframe(),ping:async()=>("complete"!==t.document.readyState&&"uninitialized"!==t.document.readyState&&await new Promise(e=>n(t.document).one("load",e)),new Promise(e=>n(e))),iFrameCanPostMessage:()=>(f.resolve(),Promise.resolve()),imagesAreLoaded:()=>h.promise};return Object.assign(Object.create(null),a)}function y(n,a){if(!n.jQuery){const a=t.extend(function(e){return"string"==typeof e&&1===arguments.length?t.call(this,e,n.document):t.apply(this,arguments)},t);a.prototype=t.extend({},t.prototype),n.$=n.jQuery=a,n.skyward=e}const o=b(n);return function(e){if(!(a||e.source===n.parent&&e.isTrusted))return;let t=e.data;if(t&&t.type&&t.data&&t.reply)try{var r;const e=t.data.map(e=>w(e));if(!o[t.type])throw new Error("Unknown type ".concat(t.type));const n=null===(r=o[t.type])||void 0===r?void 0:r.call(o,...e);Promise.resolve(n).then(e=>{const n=[],a=p(e,n);t.reply.postMessage({value:a},n)})}catch(e){console.log("replying to iframe message ".concat(t.type," with error"),e);try{t.reply.postMessage({error:e})}catch(n){var i;t.reply.postMessage({error:null!==(i=null==e?void 0:e.message)&&void 0!==i?i:String(e)})}}}}const _=(0,o.lazy)(function(){if(window.CustomElementRegistry){class t extends HTMLElement{constructor(){super(),c(this,"disconnectedPromise",void 0),c(this,"_res",void 0),this.disconnectedPromise=new Promise(e=>{this._res=e})}disconnectedCallback(){this._res(),this.remove()}}window.customElements.define("disconnect-watcher",t);const n=e.extensions.createCache(e=>{const a=new t;return e.appendChild(a),a.disconnectedPromise.finally(()=>{n.remove(e)})});return n}{const n=e.extensions.createCache(e=>new Promise(a=>{t(e).one("DOMNodeRemovedFromDocument",()=>{n.remove(e),a()})}));return n}})})},19802(e,t,n){"use strict";n.r(t),n.d(t,{completePerformanceMonitoring:()=>o});var a=n(2894);function o(e,t){$.ajax({url:"".concat(a.virtualDir,"SkySys/UsageHistory/CompletePerformanceMonitoring"),type:"POST",dataType:"JSON",data:{id:e,totalActionTimeMilliseconds:t}})}},82441(e,t,n){"use strict";n.r(t),n.d(t,{BUSY_HASH_PREFIX:()=>l,HashTransaction:()=>y,INITIALIZING_HASH:()=>c,getDependencyDataWithoutWaiting:()=>h,getRequestDataHash:()=>f,getRequestDataHashes:()=>u,isBusyHash:()=>_,isBusyOrInitializing:()=>C,isNotEmpty:()=>m,setupDependency:()=>b,waitForDependencies:()=>g});var a=n(79126),o=n(81975),r=n(917),i=n(25560);function s(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const l="__BUSY__",c="__INITIALIZING__",d=Symbol("requestDataCache");function u(e){var t,n;let a=document;const o=function(){try{return window.self!==window.parent}catch(e){return!1}}();o&&(a=window.parent.document);let r=a.getElementById(e);if(o&&null==r&&(r=document.getElementById(e)),null!=r)return null!==(n=(t=r)[d])&&void 0!==n?n:t[d]=JSON.parse(r.textContent);console.warn("Unable to find requestDataHash script with ID ".concat(e))}function f(e,t){const n=u(e);if(!n)return;const a=n[t];return a||console.warn("Unable to find requestDataHash for control with ID ".concat(t)),a}function h(e,t){return p(e,t)}function p(e,t){var n;const a={};if(null==e||!e.dynamicfiltervalue)return a;const s=e.dynamicfilterfield.split(","),l=e.dynamicfiltervalue.split(","),c=null===(n=e.dynamicfilterattribute)||void 0===n?void 0:n.split(",");null!=t||(t=$(document.documentElement));for(let e=0;e<s.length;e++){if(0===l[e].length)continue;const n=s[e],d=k(l[e],t),u=null==c?void 0:c[e].split("-");if(u&&u.length>=3&&u[2].length>0){const e=u[1]+u[2].charAt(0).toUpperCase()+u[2].slice(1);void 0!==d.data(e)&&(a[n]=d.data(e))}else{if(d.hasClass("dmsBackingData"))a[n]=(0,i.getSearchParameters)(d);else{let e=(0,r.getValue)(d);e instanceof Date&&(e=e.isValidDate()?(0,o.formatServerDate)(e,!d.hasClass("datepicker")):null),a[n]=e}const e=(0,r.getRowDataHash)(d);m(a[n])&&null!=e&&!C(e)&&(a["".concat(n,"_hash")]=e)}}return a}function m(e){return null!=e&&""!==e}async function g(e,t,n){null!=t||(t=$(document.documentElement));const o=new Set;let r=w(e,t,o);for(let i=0;i<25;i++){if(await v(r,o,n),null!=n&&n.aborted)throw new a.CancellationError;if(r=w(e,t,o),0===r.length)return p(e,t)}throw new a.SkywardException("Dependencies are stuck in a loop",JSON.stringify({loadingElements:r.map(e=>{var t;return null!==(t=e.attr("name"))&&void 0!==t?t:e.attr("id")})}))}function w(e,t,n){const a=[];if(null==e||!e.dynamicfiltervalue)return a;const o=e.dynamicfiltervalue.split(",");for(const e of o){if(0===e.length)continue;const o=k(e,t),i=(0,r.getRowDataHash)(o);0===o.length||!C(i)||i===c&&n.has(o[0])||a.push(o)}return a}async function v(e,t,n){const a=[];for(const n of e){const e=_((0,r.getRowDataHash)(n)),o=new Promise(t=>{e?n.one("controlLoaded",()=>t()):n.one("controlLoaded",()=>{null===(0,r.getRowDataHash)(n)&&console.warn("filterable control hash is still null after loading",n),t()})});if(e)a.push(o);else{const e=new Promise((e,t)=>{setTimeout(t,1e3)});a.push(Promise.race([o,e]).catch(()=>{console.warn("filterable control hash timed out",n),t.add(n[0])}))}}if(null!=n&&n.aborted)return;const{promise:o,resolve:i}=Promise.withResolvers(),s=()=>i();return null==n||n.addEventListener("abort",s),Promise.race([Promise.all(a),o]).finally(()=>null==n?void 0:n.removeEventListener("abort",s))}function b(e,t,n){if(null==e||!e.dynamicfiltervalue)return;const a=e.dynamicfilterfield.split(","),o=e.dynamicfiltervalue.split(",");for(let e=0;e<a.length;e++){var r;if(0===o[e].length)continue;let a=k(o[e],n);if(0===a.length&&(a=n.findByIdWithUnknownPrefix(o[e])),0===a.length)continue;const i=null!==(r=a.data("dependents"))&&void 0!==r?r:{dependents:[]},s=i.dependents.find(e=>e.Id===t.Id);s?Object.assign(s,t):i.dependents.push(t),a.data("dependents",i)}}class y{constructor(e){s(this,"element",void 0),s(this,"data",void 0),s(this,"counter",void 0),this.element=e,this.data=e.data(),this.counter=0}async run(e,t){const n=this.data.selectedValueHash;if(_(n))throw new Error("Cannot nest transactions");const a=this.element.val(),o="".concat(l).concat(this.counter++);let r;this.data.selectedValueHash=o;const i={setValue:e=>{this.element.val(e),r=this.element.val()},rollback:()=>{this.data.selectedValueHash===o&&(this.data.selectedValueHash=n,this.element.val()===r&&this.element.val(a))}};try{e.addEventListener("abort",i.rollback);const n=await t(i);return e.removeEventListener("abort",i.rollback),n}finally{if(i.rollback(),!_(this.data.selectedValueHash)){const t=e.aborted?"aborted":"done";this.element.trigger("controlLoaded",t)}}}}function _(e){var t;return null!==(t=null==e?void 0:e.startsWith(l))&&void 0!==t&&t}function C(e){return _(e)||e===c}function k(e,t){var n;const a=CSS.escape(e);let o=t.find('[name="'.concat(a,'"]'));return o.length>0?o:(o=t.find("#".concat(a)).find("".concat(".dmsBackingData,.tileViewEEL_value,.accountDimensionEELValue,.codeEELValue,.htmlComboBox_value")).first(),o.length>0?o:"HTML"!==(null===(n=t[0])||void 0===n?void 0:n.tagName)?k(e,$(document.documentElement)):$())}},38953(e,t,n){"use strict";n.r(t),n.d(t,{ConditionGroupType:()=>c,ConditionType:()=>d,FieldTypes:()=>f,SearchCondition:()=>m,SearchConditionGroup:()=>g,TokenType:()=>l,Types:()=>u,getFromJson:()=>p,getSearchConditionTypeByFieldType:()=>h});var a=n(81975),o=n(57365);function r(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const i=["IsRestricted","Parameters","FieldPath","LeftFieldPath","RightFieldPath","FieldType","LeftFieldType","RightFieldType","FieldIsOperation","LeftFieldIsOperation","RightFieldIsOperation","FieldPathDisplay","LeftFieldPathDisplay","RightFieldPathDisplay"],s=["List","SearchCondition"];let l=function(e){return e.SearchCondition="SearchCondition",e.GroupType="GroupType",e.Exist="Exist",e.NestedTokens="NestedTokens",e}({}),c=function(e){return e.And="And",e.Or="Or",e}({}),d=function(e){return e.Exists="Exists",e.NotExists="NotExists",e.True="True",e.False="False",e.Null="Null",e.NotNull="NotNull",e.BetweenInclusive="BetweenInclusive",e.BetweenExclusive="BetweenExclusive",e.NotBetweenInclusive="NotBetweenInclusive",e.NotBetweenExclusive="NotBetweenExclusive",e.Equal="Equal",e.NotEqual="NotEqual",e.List="List",e.NotList="NotList",e}({}),u=function(e){return e.FieldToFieldSearchCondition="FieldToFieldSearchCondition",e.SchemaObjectFilterSearchCondition="SchemaObjectFilterSearchCondition",e.DateTimeSearchCondition="DateTimeSearchCondition",e.TimeSpanSearchCondition="TimeSpanSearchCondition",e.TypedStandardFilterSearchCondition="TypedStandardFilterSearchCondition",e.SearchConditionGroup="SearchConditionGroup",e.AndSearchConditionGroup="AndSearchConditionGroup",e.OrSearchConditionGroup="OrSearchConditionGroup",e.LongSearchCondition="LongSearchCondition",e.IntSearchCondition="IntSearchCondition",e.ShortSearchCondition="ShortSearchCondition",e.ByteSearchCondition="ByteSearchCondition",e.BoolSearchCondition="BoolSearchCondition",e.StringSearchCondition="StringSearchCondition",e.DecimalSearchCondition="DecimalSearchCondition",e.EnumSearchCondition="EnumSearchCondition",e.ExistsSearchCondition="ExistsSearchCondition",e.SubquerySearchCondition="SubquerySearchCondition",e}({}),f=function(e){return e.NumberLong="number long",e.NumberInt="number int",e.NumberShort="number short",e.NumberByte="number byte",e.NumberDecimal="number decimal",e.Boolean="boolean",e.String="string",e.Time="time",e.DateTime="datetime",e.TimeSpan="timespan",e}({});function h(e){switch(e.toLowerCase()){case f.NumberLong:return u.LongSearchCondition;case f.NumberInt:return u.IntSearchCondition;case f.NumberShort:return u.ShortSearchCondition;case f.NumberByte:return u.ByteSearchCondition;case f.NumberDecimal:return u.DecimalSearchCondition;case f.Boolean:return u.BoolSearchCondition;case f.String:return u.StringSearchCondition;case f.Time:case f.DateTime:return u.DateTimeSearchCondition;case f.TimeSpan:return u.TimeSpanSearchCondition;case"onetomany":case"manytoone":return u.ExistsSearchCondition;case"standardfilter":return u.TypedStandardFilterSearchCondition;default:return u.EnumSearchCondition}}function p(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if(null!=e&&""!==e){const n="string"==typeof e?JSON.parse(e):e,a=n["@Type"],o=a===u.SearchConditionGroup||a===u.AndSearchConditionGroup||a===u.OrSearchConditionGroup?new g:new m,r={};o.ConvertBindingToDisplayName=t;for(const e in n){r[0===e.indexOf("@")?e.substring(1):e]=n[e]}return o.set(r),o}return new m}class m{constructor(){r(this,"_searchCondition",{Type:"",IsRestricted:!1,DataObjectType:"",Version:1}),r(this,"_existsCondition",null),r(this,"ConvertBindingToDisplayName",null)}_safeConvertBindingToDisplayName(e){var t;return(null===(t=this.ConvertBindingToDisplayName)||void 0===t?void 0:t.call(this,e))||e}_convertCalculatedFieldIDToDisplayName(e){if(e){const t="{".concat(e,"}");return this._safeConvertBindingToDisplayName(t)}return null}setType(e){this._searchCondition.Type=e}set IsRestricted(e){this._searchCondition.IsRestricted=e}toJSON(){return JSON.stringify(this.get())}removeWhen(e){if(!e(this))return this._existsCondition&&(this._existsCondition=this._existsCondition.removeWhen(e)||null),this}get(){const e={};for(const t of Object.keys(this._searchCondition))if(!i.includes(t)){const n=this._searchCondition[t];if(void 0!==n){e[s.indexOf(t)>=0?t:"@".concat(t)]=n}}return this._existsCondition&&(e.SearchCondition=this._existsCondition.get()),e}getFieldsFromCondition(e){var t;if(this._searchCondition.IsRestricted||this._searchCondition.Type===u.TypedStandardFilterSearchCondition)return[];const n=[],a=null!==(t=this._searchCondition.FieldName)&&void 0!==t?t:this._searchCondition.LeftFieldName;if(a){var o,r,i,s,l,c,f;const e=null!==(o=null!==(r=null!==(i=this._searchCondition.FieldNameDisplay)&&void 0!==i?i:this._searchCondition.LeftFieldNameDisplay)&&void 0!==r?r:this._searchCondition.FieldName)&&void 0!==o?o:this._searchCondition.LeftFieldName,t=null!==(s=this._searchCondition.FieldPathDisplay)&&void 0!==s?s:this._searchCondition.LeftFieldPathDisplay,d=null!==(l=this._searchCondition.FieldPath)&&void 0!==l?l:this._searchCondition.LeftFieldPath,u=null!==(c=this._searchCondition.FieldType)&&void 0!==c?c:this._searchCondition.LeftFieldType,h=null!==(f=this._searchCondition.FieldIsOperation)&&void 0!==f?f:this._searchCondition.LeftFieldIsOperation;n.push({fieldName:a,fieldPath:d,dataObjectType:this._searchCondition.DataObjectType,displayName:e,displayPath:t,fieldType:u,calculatedFieldName:this._searchCondition.CalculatedFieldName,isOperation:h,parameters:this._searchCondition.Parameters})}const h=this._searchCondition.RightFieldName;if(h){var p;const e=null!==(p=this._searchCondition.RightFieldNameDisplay)&&void 0!==p?p:this._searchCondition.RightFieldName,t=this._searchCondition.RightFieldPathDisplay,a=this._searchCondition.RightFieldPath,o=this._searchCondition.RightFieldType,r=this._searchCondition.RightFieldIsOperation;n.push({fieldName:h,fieldPath:a,dataObjectType:this._searchCondition.DataObjectType,displayName:e,displayPath:t,fieldType:o,calculatedFieldName:this._searchCondition.RightCalculatedFieldName,isOperation:r,parameters:this._searchCondition.Parameters})}const m=this._searchCondition.ConditionType;return e&&(m===d.Exists||m===d.NotExists)&&this._existsCondition&&n.push(...this._existsCondition.getFieldsFromCondition(e)),n}toFriendlyQuery(){return function e(t){let n=[];t.forEach(t=>{switch(t.Type){case l.SearchCondition:case l.GroupType:case l.Exist:n.push("".concat(t.Value," "));break;case l.NestedTokens:n.push("".concat(e(t.Value)," "))}});let a=n.join("").trim();if(a.length>0)return"( ".concat(a," )");return""}(this.toTokenizedFriendlyQuery())}toTokenizedFriendlyQuery(){const e=[];if(this._searchCondition.Type&&""!=this._searchCondition.Type)if(this._searchCondition.IsRestricted)e.push({Type:l.SearchCondition,Value:"***"});else{const a=!(this._searchCondition.Version>1);if(this._searchCondition.Type===u.TypedStandardFilterSearchCondition){const t=this._searchCondition;e.push({Type:l.SearchCondition,Value:"'".concat(t.DisplayName||"","'")})}else if(this._searchCondition.Type===u.SchemaObjectFilterSearchCondition){const t=this._searchCondition;e.push({Type:l.SearchCondition,Value:"'".concat(t.DisplayName||"","' Equal 'True'")})}else if(this._searchCondition.Type===u.ExistsSearchCondition){var t,n;const o=this._searchCondition,r=null!==(t=this._searchCondition.ConditionType)&&void 0!==t?t:d.Exists,i=a?o.RelationshipName:o.RelationshipNameDisplay,s=null!==(n=o.RelationshipNameUIDisplay)&&void 0!==n?n:i,c=r===d.Exists?"At Least One":"No",u=null==this._existsCondition?"Exist":"Exist Where";if(e.push({Type:l.SearchCondition,Value:"".concat(c," '").concat(s,"'")}),e.push({Type:l.Exist,Value:u}),this._existsCondition){let t=this._existsCondition;if(t instanceof m){const e=new g;e.ConvertBindingToDisplayName=t.ConvertBindingToDisplayName,e.addCondition(t),t=e}for(let n of t.toTokenizedFriendlyQuery())e.push(n)}}else{var r;const t=this._searchCondition,n=this._convertCalculatedFieldIDToDisplayName(this._searchCondition.CalculatedFieldName);let o;var i,s,c,f,h,p,w,v;if(a)o=null!==(i=null!==(s=null!==(c=null!==(f=t.FieldNameUIDisplay)&&void 0!==f?f:t.FieldName)&&void 0!==c?c:n)&&void 0!==s?s:t.LeftFieldName)&&void 0!==i?i:"";else o=null!==(h=null!==(p=null!==(w=null!==(v=t.FieldNameUIDisplay)&&void 0!==v?v:t.FieldNameDisplay)&&void 0!==w?w:n)&&void 0!==p?p:t.LeftFieldNameDisplay)&&void 0!==h?h:"";let d,m,g="'".concat(o,"' ").concat((null!==(r=this._searchCondition.ConditionType)&&void 0!==r?r:"").toDisplayName());if(this._searchCondition.Type===u.FieldToFieldSearchCondition){var b,y,_;const e=this._searchCondition,t=this._convertCalculatedFieldIDToDisplayName(e.RightCalculatedFieldName);d=null!==(b=null!==(y=null!==(_=e.RightFieldNameUIDisplay)&&void 0!==_?_:e.RightFieldNameDisplay)&&void 0!==y?y:e.RightFieldName)&&void 0!==b?b:t}else if(this._searchCondition.Type===u.SubquerySearchCondition){var C;d=null!==(C=this._searchCondition.OperandDisplayValue)&&void 0!==C?C:"Inner Search Results"}else if(this._searchCondition.Type===u.DateTimeSearchCondition){var k,S,D;const e=null!==(k=null!==(S=t.LowBinding)&&void 0!==S?S:t.ValueBinding)&&void 0!==k?k:t.ListBinding,n=null!==(D=t.Low)&&void 0!==D?D:t.Value,a=t.List;if(e)d=e;else if(n){const e=A(n);d=null!==e?e:n}else if(a&&a.Value){const e=[];for(let t of a.Value){const n=A(t);e.push(null!==n?n:t)}d=e.join(";")}const o=t.High,r=t.HighBinding;if(r)m=r;else if(o){const e=A(o);m=null!==e?e:o}}else{var E,P,O,B,T,x,M,I;d=null!==(E=null!==(P=null!==(O=null!==(B=null!==(T=null!==(x=t.LowBinding)&&void 0!==x?x:t.ValueBinding)&&void 0!==T?T:t.Low)&&void 0!==B?B:t.Value)&&void 0!==O?O:t.ListBinding)&&void 0!==P?P:null==t||null===(M=t.List)||void 0===M||null===(M=M.Value)||void 0===M?void 0:M.join(";"))&&void 0!==E?E:t.List,m=null!==(I=t.HighBinding)&&void 0!==I?I:t.High}if(null!=d){const e=this._safeConvertBindingToDisplayName(d);if(null!=m){const t=this._safeConvertBindingToDisplayName(m);g+=" '".concat(e,"' And '").concat(t,"'")}else g+=" '".concat(e,"'")}e.push({Type:l.SearchCondition,Value:g})}}return e;function A(e){if(null!=e&&""!==e){const t=(0,a.parseDate)(e);if((0,a.isDate)(t,!1))return t.toLocaleDateString();{const t=o.RelativeDate.parse(e);return null!=t?t.toString():e}}return null}}getValidationMessage(){const e=[d.True,d.False,d.Null,d.NotNull,d.List,d.NotList],t=this._convertCalculatedFieldIDToDisplayName(this._searchCondition.CalculatedFieldName);let n;var a;if(this._searchCondition.Type===u.FieldToFieldSearchCondition)n=null!==(a=this._searchCondition.LeftFieldName)&&void 0!==a?a:t;else if(this._searchCondition.Version>1){var o;n=null!==(o=this._searchCondition.FieldNameDisplay)&&void 0!==o?o:t}else{var r;n=null!==(r=this._searchCondition.FieldName)&&void 0!==r?r:t}switch(null!=n&&(n=this._safeConvertBindingToDisplayName(n)),this._searchCondition.Type){case u.TypedStandardFilterSearchCondition:case u.SchemaObjectFilterSearchCondition:return null;default:if(!this._searchCondition.ConditionType)return n?"Condition Type must be set for ".concat(n,"."):"Condition Type must be set.";if(this._searchCondition.Type!==u.StringSearchCondition&&this._searchCondition.Type!==u.ExistsSearchCondition&&e.indexOf(this._searchCondition.ConditionType)<0){const e=Boolean(this._searchCondition.Value||!1===this._searchCondition.Value||this._searchCondition.ValueBinding),t=Boolean(this._searchCondition.Low||this._searchCondition.LowBinding),a=Boolean(this._searchCondition.High||this._searchCondition.HighBinding),o=Boolean(this._searchCondition.RightFieldName||this._searchCondition.RightCalculatedFieldName);if(!(e||o||t&&a))return n?"Condition must have a value for ".concat(n,"."):"Condition must have a value.";const r=this.getMaxNumericValue();if(r){const e=" is an invalid value. Condition value must be between -".concat(r," and ").concat(r,".");if(this._searchCondition.Value&&Math.abs(this._searchCondition.Value)>r)return this._searchCondition.Value+e;if(this._searchCondition.Low&&Math.abs(this._searchCondition.Low)>r)return this._searchCondition.Low+e;if(this._searchCondition.High&&Math.abs(this._searchCondition.High)>r)return this._searchCondition.High+e}}return null}}getMaxNumericValue(){switch(this._searchCondition.Type){case u.IntSearchCondition:return 2147483647;case u.ShortSearchCondition:return 32767;case u.ByteSearchCondition:return 255}return null}set(e){for(const n in e)if("SearchCondition"===n||"Condition"===n)this._existsCondition=p(e[n],this.ConvertBindingToDisplayName);else if("List"===n){var t;null!==(t=e[n])&&void 0!==t&&t.Value&&!Array.isArray(e[n].Value)?this._searchCondition.List={Value:[e.List.Value]}:this._searchCondition.List=e.List}else null!=e[n]?this._searchCondition[n]=e[n]:void 0!==this._searchCondition[n]&&delete this._searchCondition[n]}}class g{constructor(){r(this,"_searchConditionGroup",{Type:u.SearchConditionGroup,ConditionGroupType:c.And}),r(this,"_conditions",[]),r(this,"ConvertBindingToDisplayName",null)}removeEmptyConditions(){const e=[];return this._conditions.forEach(t=>{if(t instanceof g){const n=t.removeEmptyConditions();null!=n&&e.push(n)}else e.push(t)}),0===e.length?null:(this._conditions=e,this)}removeWhen(e){if(!e(this)){for(const t in this._conditions){const n=this._conditions[t].removeWhen(e);void 0!==n?this._conditions[t]=n:delete this._conditions[t]}return this}}getFieldsFromCondition(e){if(0===this._conditions.length)return[];const t=[];return this._conditions.forEach(n=>{const a=n.getFieldsFromCondition(e);null!=a&&a.length&&t.push(...a)}),t}toTokenizedFriendlyQuery(){const e=[];if(this._conditions.length>0){let t=!0;this._conditions.forEach(n=>{n instanceof m&&t?e.push({Type:l.GroupType,Value:""}):t||e.push({Type:l.GroupType,Value:this._searchConditionGroup.ConditionGroupType});for(const t of n.toTokenizedFriendlyQuery())e.push(t);t=!1})}return e.length>0?[{Type:l.NestedTokens,Value:e}]:[]}toFriendlyQuery(){if(0===this._conditions.length)return"";if(1===this._conditions.length)return this._conditions[0].toFriendlyQuery()||"";const e=[];this._conditions.forEach(t=>{const n=t.toFriendlyQuery();n&&e.push(n)});const t=" ".concat(this._searchConditionGroup.ConditionGroupType," ");return"( ".concat(e.join(t)," )")}toJSON(){return 0===this._conditions.length?"":1===this._conditions.length?this._conditions[0].toJSON():JSON.stringify(this.get())}getValidationMessage(){const e=[];return this._conditions.forEach(t=>{const n=t.getValidationMessage();n&&e.push(n)}),e.join("\r\n")}get(){const e={};for(const t of Object.keys(this._searchConditionGroup))if(!i.includes(t)){const n=this._searchConditionGroup[t];if(void 0!==n){e[s.indexOf(t)>=0?t:"@".concat(t)]=n}}e.SearchCondition=[];for(const t of this._conditions)null!==t&&e.SearchCondition.push(t.get());return e}set(e){for(const t in e)"SearchCondition"===t?Array.isArray(e[t])?e[t].forEach(e=>this.addCondition(p(e,this.ConvertBindingToDisplayName))):this.addCondition(p(e[t],this.ConvertBindingToDisplayName)):null!=e[t]?this._searchConditionGroup[t]=e[t]:void 0!==this._searchConditionGroup[t]&&delete this._searchConditionGroup[t]}addCondition(e){let t=e;e instanceof g&&(t=e.removeEmptyConditions()),null!=t&&(t.ConvertBindingToDisplayName=this.ConvertBindingToDisplayName,this._conditions.push(t))}}},28640(e,t,n){"use strict";n.r(t),n.d(t,{SessionState:()=>c,currentState:()=>P,disable:()=>B,enable:()=>O,enabled:()=>u,postState:()=>x,setState:()=>T});var a=n(2894),o=n(88157),r=n(49343),i=n(584),s=n(81975);let l,c=function(e){return e.Active="Active",e.Inactive="Inactive",e.ClientTimedOut="ClientTimedOut",e.ClientTimedOut_Posted="ClientTimedOut_Posted",e}({}),d=!1;function u(){return d}let f=5e3,h=c.Active;const p=$(".systemwideMessageBar"),m=p.find("#systemNoticeNoticeBar");let g=m.data("hasseenupdatemessage")||!1;const w=m.data(),v=Date.now();let b,y=null!=w&&w.utcLockTime?new Date(w.utcLockTime).getTime():null,_=(null!=w&&w.utcServerTime?new Date(w.utcServerTime).getTime():v)-v,C=null;const k=p.find("#environmentPurposeNoticeBar"),S=p.find("#trainingModeNoticeBar"),D=p.find("#alteredTimeNoticeBar");b=setTimeout(M,1e3);let E=0;function P(){return h}function O(e){l&&clearTimeout(l),f=e||5e3,h=c.Inactive,l=setTimeout(x,f),d=!0}function B(){clearTimeout(l),d=!1}function T(e){d&&(h=e)}function x(e){if(clearTimeout(l),h!=c.ClientTimedOut_Posted){if(h=e||h,E++,h==c.Active)$.ajax({url:"".concat(a.virtualDir,"Security/Session/Active"),type:"POST",dataType:"JSON",activityIndicator:{silent:!0},data:{transmissionNumber:E,hasSeenUpdateMessage:g},global:!1,success:L,error:function(){A("ServerError")}});else if("Inactive"==h)$.ajax({url:"".concat(a.virtualDir,"Security/Session/Inactive"),type:"POST",dataType:"JSON",activityIndicator:{silent:!0},data:{transmissionNumber:E,hasSeenUpdateMessage:g},global:!1,success:L,error:function(){A("Inactive")}});else if("ClientTimedOut"==h)return(0,i.disable)(),void $.ajax({url:"".concat(a.virtualDir,"Security/Session/ClientTimedOut"),type:"POST",activityIndicator:{silent:!0},data:{transmissionNumber:E},global:!1,success:function(){a.mobileAccess||A("TimedOut")},error:function(){a.mobileAccess||A("TimedOut")}});l=setTimeout(x,f),h=c.Inactive}}function M(){clearTimeout(b),y&&($(m).find(".lockCountdown").html((0,s.getDisplayTimespan)(y-I())),N(m,{html:$(m).html()}),b=setTimeout(M,1e3))}function I(){return new Date(Date.now()+_).getTime()}function A(e){(0,r.setSkipUnloadCheck)(!0),window.location.href="".concat(a.virtualDir,"Security/SignIn/NotAuthenticated?status=").concat(e,"&cont=").concat(encodeURIComponent(window.location.href))}async function L(e){if(e.transmissionNumber<E)return;"Active"!==e.status&&(a.mobileAccess||A(e.status));const t=e.utcLockTime;if(y=t?new Date(t).getTime():null,g=e.hasSeenUpdateMessage,e.lockMessageContent&&y){const t=await $("<div />").viewpartHtml(e.lockMessageContent.html);t.find(".lockCountdown").html((0,s.getDisplayTimespan)(y-I())),N(m,{html:t.html()})}else N(m);if(N(S,e.trainingMode?{html:"System is in Training Mode"}:void 0),N(D,null!=e.trainingTimeOffset?{html:"System time has been altered"}:void 0),R(),e.environmentPurpose){const t=await(0,a.processViewPartHtml)(e.environmentPurpose.html);N(k,{html:t,css:e.environmentPurpose.css})}else N(k);if(e.lockMessageContent){if(null!=y&&(clearTimeout(b),b=setTimeout(M,1e3),!g)){const e={closeOnClick:!1,closeOnEscape:!1};let t;const n=[{text:"Sign Out Now",icon:"SignOut",click:function(){t.close(),(0,r.loadContent)("full","security","SignIn","index",null,void 0)}},{text:"Keep Working",icon:"SignIn",click:"close"}];t=(0,o.showDialog)("Update Pending",function(){g=!0;const e=$("<div />").html(m.html());return setInterval(function(){e.html(m.html())},1e3),e},n,e)}O(1e4)}a.mobileAccess||(0,i.startWarningTimers)(e.offset),(0,s.setCurrentTime)(e.currentTime)}function R(){D.html("<span>System time has been altered; the effective time is <span id='alteredTimeBarTimeDisplay'></span></span>"),null!=C&&(clearTimeout(C),C=null);const e=$("#alteredTimeBarTimeDisplay");function t(){e.html((0,s.now)().toLocaleString())}D.is(":visible")&&(t(),C=setInterval(t,1e3))}function N(e,t){t?(e.html(t.html),e.css(t.css||[]),e.addClass("noticeBar"),e.removeClass("noticeBar--hidden")):e.addClass("noticeBar--hidden")}$(function(){R(),m.length&&m[0].hasAttribute("data-locktime")&&x()})},41709(e,t,n){"use strict";n.r(t),n.d(t,{focusAfter:()=>r,focusBefore:()=>i});var a=n(2894),o=n(49343);function r(e,t){if(a.mobileAccess)return;let n=$(e);0===n.length&&(n=$(document.activeElement));const o=s(c(n));if(0===o.length)return;(isNaN(parseInt(t))||t<0)&&(t=1);const r={};let i=0,d=0;o.each(function(){const e=$(this);let t=e.attr("tabindex");void 0===t&&(t="0");const a=parseInt(t);a>=0&&(r[a]||(r[a]=[]),n[0]===e[0]&&(i=r[a].length,d=a),r[a].push(e))});let u,f=t;const h=i+t,p=r[d].length;if(h<p)return u=r[d][h],void l(u);f-=p-i;const m=Object.keys(r);for(let e=m.indexOf(d+"")+1;e<m.length;e++){const t=r[parseInt(m[e])].length;if(f<=t)return u=r[parseInt(m[e])][f],void l(u);f-=t}l(r[parseInt(m[0])][0])}function i(e){if(a.mobileAccess)return;const t=$(e).get(0),n=s(c(t));if(0===n.length)return;let o=null;for(let e=0;e<n.length;e++)if(n[e]===t){o=$(0===e?n[n.length-1]:n[e-1]),l(o);break}null===o&&(o=$(n[0]),l(o))}function s(e){return $(e).find(":focusable")}function l(e){const t=$(e);if(0!==t.length&&(t.trigger("focus"),t.is("input[type='text'], input[type='search'], input[type='url'], input[type='tel'], input[type='password'], textarea"))){const e=t[0];e.value.length>0&&e.setSelectionRange(0,e.value.length)}}function c(e){const t=$(e);return"HTML"===t.prop("nodeName")?t.find(".skywardContentPanel").first():(0,o.getClosestContentPanel)(t)}a.mobileAccess||(0,o.registerLoadDOMCallback)(function(e,t){if(t.skywardContentPanel&&"#detailsPanel"!==e){const t=c(e);if(t.length>0){let e=t.find("[autofocus]").first();if(0===e.length){let n,a=Number.POSITIVE_INFINITY;s(t).each(function(){const e=parseInt(this.getAttribute("tabindex"),10);e>0&&e<a&&(n=this,a=e)}),e=void 0!==n?$(n):$()}e.length>0&&(l(e),e.trigger("select"))}}})},81975(e,t,n){"use strict";let a,o;n.r(t),n.d(t,{DAYS_OF_WEEK:()=>i,breakTimeIntoPeriods:()=>m,convertTo12Hour:()=>c,formatServerDate:()=>v,getDisplayTimespan:()=>g,isDate:()=>b,isValidYearMonthDay:()=>u,newDate:()=>w,now:()=>f,parseDate:()=>d,parseISODate:()=>s,parseServerDate:()=>l,setCurrentTime:()=>h,stopwatch:()=>p});const r=Date,i=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];let s=function(e){const t=/^(\d{4}|[-+]\d{6})(?:-(\d{2})(?:-(\d{2}))?)?(?:T(\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?(Z|[-+]\d{2}:\d{2})?)?$/.exec(e);if(null===t)return NaN;const n=parseInt(t[1],10),a=parseInt(t[2]||"1",10),o=parseInt(t[3]||"1",10),r=void 0!==t[4],i=parseInt(t[4]||"0",10),s=parseInt(t[5]||"0",10),l=parseInt(t[6]||"0",10),c=parseInt((t[7]||"").padRight(3,"0").slice(0,3),10);let d=t[8];const f=a-1;if(!u(n,a,o))return NaN;if(i>24||s>=60||l>=60||24===i&&(s>0||l>0))return NaN;if(r||(d="Z"),void 0===d)return w(n,f,o,i,s,l,c).getTime();const h=new Date(Date.UTC(n,f,o,i,s,l,c));n<=99&&n>=0&&h.setUTCFullYear(h.getUTCFullYear()-1900);const p=h.getTime();if("Z"===d)return p;const m=d.slice(1).split(":",2),g=parseInt(m[0],10),v=parseInt(m[1],10);if(g>=24||v>=60)return NaN;return p+60*(60*g+v)*1e3*("+"===d[0]?-1:1)},l=function(e){const t=/^(\d{1,2})\/(\d{1,2})\/(\d{4,6})(?: (?:(\d{1,2}):(\d{2})(?::(\d{2}))?(?: ([AP]M))?|\[a-z]+))?$/i.exec(e);if(null===t)return NaN;const n=parseInt(t[3],10),a=parseInt(t[1],10),o=parseInt(t[2],10);let r=parseInt(t[4]||"0",10);const i=parseInt(t[5]||"0",10),s=parseInt(t[6]||"0",10),l=t[7];if(i>=60||s>=60)return NaN;if(void 0!==l){if(r>12)return NaN;r=r%12+("am"===l.toLowerCase()?0:12)}else if(r>24||24===r&&(i>0||s>0))return NaN;return u(n,a,o)?w(n,a-1,o,r,i,s).getTime():NaN};function c(e){return 0===e?12:e>12?e%12:e}let d=function(e,t){if("number"==typeof e)return new Date(e);if(e instanceof Date)return e;if(""===e||null==e)return new Date(NaN);e=e.toString();var n=s(e);if(!isNaN(n))return new Date(n);var a=l(e);return isNaN(a)?t?(console.warn("Non-standard date passed to parseDate()",e),new Date(Date.parse(e))):new Date(NaN):new Date(a)},u=function(e,t,n){if(t<1||t>12)return!1;return!(n<1||n>[31,28,31,30,31,30,31,31,30,31,30,31][t-1]&&(2!==t||29!==n||e%4!=0||e%100==0&&e%400!=0))},f=function(){var e=Date.now()-o;return new Date(a.getTime()+e)},h=function(e){a=new Date(e),o=Date.now()},p=function(){var e=Date.now(),t={duration:function(){return Date.now()-e},stop:function(){var n=Date.now();t.duration=function(){return n-e}},restart:function(){e=Date.now(),t.duration=function(){return Date.now()-e}}};return t},m=function(e,t){return isNaN(e)||e<=0?[0,0]:[Math.floor(e/t),Math.floor(e%t)]},g=function(e){if(isNaN(e)||e<0)return"0:00";var t=e/1e3;return Math.floor(t/60)+":"+Math.floor(t%60).toString().padLeft(2,"0")},w=function(e,t){let n,a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,s=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,l=arguments.length>6&&void 0!==arguments[6]?arguments[6]:0;switch(arguments.length){case 0:return new r;case 1:return new r(e);default:n=new r(e,t,a,o,i,s,l)}return e>=0&&e<=99&&n.setFullYear(n.getFullYear()-1900),n},v=function(e){let t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(!e.isValidDate())return"Invalid Date";const n=(e.getMonth()+1).toString().padLeft(2,"0"),a=e.getDate().toString().padLeft(2,"0"),o=e.getFullYear().toString().padLeft(4,"0");var r;t?r=e.getHours().toString().padLeft(2,"0")+":"+e.getMinutes().toString().padLeft(2,"0")+":"+e.getSeconds().toString().padLeft(2,"0")+"."+e.getMilliseconds().toString().padLeft(3,"0").slice(0,3):r="00:00:00.000";return"".concat(o,"-").concat(n,"-").concat(a,"T").concat(r)};function b(e){return e instanceof Date&&(!(arguments.length>1&&void 0!==arguments[1])||arguments[1]||!isNaN(e))}a=d($("#pageRenderTime").val()),o=Date.now()},75618(e,t,n){"use strict";n.r(t),n.d(t,{registerScript:()=>r});var a=n(92214);const o=Object.create(null);function r(e,t){o[e]||"function"==typeof t&&(o[e]=!0,(0,a.registerEvents)(e,t(window.skyward,window.jQuery)))}},82893(e,t,n){"use strict";n.r(t),n.d(t,{getEmptyStorage:()=>a,getLocalStorage:()=>o,getSessionStorage:()=>r});let a=function(e){return i(s(),e)},o=function(e){return i(function(){try{return"localStorage"in window&&null!==window.localStorage}catch(e){return!1}}()?window.localStorage:s(),e)},r=function(e){return i(function(){try{return"sessionStorage"in window&&null!==window.sessionStorage}catch(e){return!1}}()?window.sessionStorage:s(),e)};function i(e,t){const n="-",a="ts",o=e||s(),r=t||"VS";let i=!1;const l={set:function(e,t){var n=h(e);c(n,t)&&(c(p(n),(new Date).getTime())||u(n))},get:function(e){var t=h(e),n=d(t);return null===n||c(p(t),(new Date).getTime())?n:(u(t),null)},remove:function(e){return u(h(e))}};return l;function c(e,t){if("string"!=typeof e||""===e||null==t)return!1;var n,r;try{n=JSON.stringify(t)}catch(e){return!1}try{f("Attempting Set: [Key: ".concat(e,"] [Length: ").concat(n.length,"]")),o.setItem(e,n)}catch(s){if(!((r=s)instanceof DOMException)||22!==r.code&&1014!==r.code&&"QUOTA_EXCEEDED_ERR"!==r.name&&"QuotaExceededError"!==r.name&&"NS_ERROR_DOM_QUOTA_REACHED"!==r.name)return!1;f("Storage Full: Attempting to Clear Data");var i=n.length+2e3;return f("Required Data To Clear: ".concat(i)),function(e){var t=function(){for(var e=3,t=Object.keys(o),n=[],r=0;r<t.length;r++){var i=t[r];if(i.endsWith(a)){var s={key:i.substring(0,i.length-e),timestamp:d(i)};n.push(s)}}return n}();t.sort(function(e,t){return t.timestamp-e.timestamp});var n=e;for(;t.length>0&&n>0;){var r=t.pop();n-=u(r.key).length,n-=JSON.stringify(r.timestamp).length}return n<=0}(i)?(f("Space Cleared: Attempting Set"),c(e,t)):(f("Could Not Clear Enough Space"),!1)}return!0}function d(e){var t=o.getItem(e);try{return JSON.parse(t)}catch(e){return}}function u(e){var t=p(e),n=o.getItem(e);return o.removeItem(e),o.removeItem(t),n}function f(e){i}function h(e){return r+n+e}function p(e){return e+n+a}}function s(){var e={length:0};return e.clear=t,e.getItem=n,e.key=n,e.removeItem=t,e.setItem=t,e;function t(){}function n(){return null}}},77545(e,t,n){"use strict";n.r(t);var a=n(2894),o=n(88157),r=n(92214),i=n(49343),s=n(917);$(function(){$(document.body).on("keydown.altF6Listener",function(e){if(e.altKey&&117===e.which&&$(".f6AuditContent").length<=0){var t,n;const e={routeHash:$("#RouteHash").val(),dovPrimaryID:null===(t=$(".dataObjectViewer:not(.detailsPanel .dataObjectViewer)"))||void 0===t?void 0:t.data("primaryid"),dovPrimaryIDHash:null===(n=$(".dataObjectViewer:not(.detailsPanel .dataObjectViewer"))||void 0===n?void 0:n.data("primaryidhash")};$.post(a.virtualDir+"SkySys/F6Audit/GetF6Audit?renderType=contentOnly",e,null,"viewparthtml").done(function(e){e&&(0,o.showInformationDialog)("Audit Information",e)})}})});const l={exportF6Audit:function(){const e=$(this),t=a.virtualDir+"SkySys/F6Audit/ExportData";var n={fileName:e.data("filename"),isBase:e.data("isbase"),objectID:(0,s.getValue)($("#AuditObjectID")),id:(0,s.getValue)($("#F6AuditID")),auditObjectIDHash:(0,s.getValue)($("#AuditObjectIDHash")),f6AuditIDHash:(0,s.getValue)($("#F6AuditIDHash"))};(0,i.submitForm)(t,n,{openNewWindow:!1,downloadOnMobile:!0})},loadF6Audit:function(){var e,t,n;const o=$(this).closest(".auditSubmitDiv"),r={objectID:(0,s.getValue)($("#AuditObjectID")),id:null===(e=$("#F6AuditID"))||void 0===e?void 0:e.val(),auditObjectIDHash:null===(t=$("#AuditObjectIDHash"))||void 0===t?void 0:t.val(),f6AuditIDHash:null===(n=$("#F6AuditIDHash"))||void 0===n?void 0:n.val()};$.post(a.virtualDir+"SkySys/F6Audit/LoadF6Audit/",r,null,"viewparthtml").done(function(e){const t=o.siblings(".f6AuditContent");e?(t.html(e),(0,i.notifyDOMLoad)(t)):t.html("")})}};(0,r.registerEvents)("f6AuditWindow",l)},95326(e,t,n){"use strict";n.r(t);const a={init:function(){const e=$(this);$("<input>",{attr:{style:"display:none",type:"text",name:"ChromeAutocompleteFix",autocomplete:"phone"}}).appendTo(e)}};(0,n(92214).registerEvents)("autocompleteFix",a)},18290(e,t,n){"use strict";n.r(t),n.d(t,{buildAboutPopup:()=>r});var a=n(2894),o=n(88157);function r(){const e=$.ajax({url:"".concat(a.virtualDir,"SkySys/About/GetAboutPopup?renderType=contentOnly")});(0,o.showDialog)("About",e,void 0,{width:"15%",transparentGlass:!0,draggable:!0})}},7317(e,t,n){"use strict";n.r(t),n.d(t,{waitForAllActivitiesToComplete:()=>v});var a=n(79126),o=n(66952);const r="initialLoad",i="loading",s="longLoad",l=function(){const e="Loading...",t=$("<div>",{"aria-live":"polite",class:"sr-only",id:"loadingAnnouncer"});let n;return t.appendTo(document.body),{start(){void 0===n&&(n=window.setTimeout(function a(){(0,o.ensureLiveAreaAnnounced)(t,e),n=window.setTimeout(a,5e3)},1e3))},complete(){window.clearTimeout(n),n=void 0,null!=t&&t.text().startsWith(e)&&t.text("Loading complete.")}}}(),c=function(){const e="noGlass";let t,n=!1,a=!1,o=!1,r=!1,i=0;const s=[];return{startTime:(new Date).getTime(),domReady:!1,startActivity(){window.clearTimeout(t),n&&(r=!0,m.start())},waitForActivity(){window.clearTimeout(t),a=!0,t=window.setTimeout(function(){a=!1,function(){if(r=!1,!l())return;m.complete(),u()}()},100)},toggleGlass(t){const n=null!=t?t:d.hasClass(e);d.toggleClass(e,!n)},startManualOverride(){o=!0,p.start()},completeManualOverride(){o=!1,l()&&(p.complete(),u())},forceComplete(){n=!0,o=!1,r=!1,a=!1,void 0!==t&&(window.clearTimeout(t),t=void 0),f.complete(),m.complete(),p.complete(),u()},completeInitialLoad(){n=!0,u()},async waitForAllActivitiesToComplete(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=e;for(;;){const n=new Promise(e=>setTimeout(e,t)),a=l()?Promise.resolve():new Promise(e=>{s.push(e)});await Promise.all([n,a]);const o=performance.now()-i;if(o>=e)return;t=e-o}}};function l(){return c.domReady&&!a&&!o&&n&&!r}function u(){if(l()){i=performance.now();for(const e of s)e();s.length=0}}}(),d=function(){let e;return{addClass(e){t().addClass(e)},removeClass(e){t().removeClass(e)},toggleClass(e,n){t().toggleClass(e,n)},hasClass:e=>t().hasClass(e),setAttribute(e,n){t().attr(e,n)}};function t(){return void 0===e&&(e=$("#LoadingIndicator")),e}}(),u=function(){const e={silent:!1,hideGlass:!1};let t=0,n=0;return{requestSent(a,o,r){const i=$.extend({},e,r.activityIndicator);if(i.silent)return;i.hideGlass||n++,t++;const s=0!==n;c.toggleGlass(s),c.startActivity()},requestComplete(a,o,r){const i=$.extend({},e,r.activityIndicator);if(i.silent)return;t=Math.max(t-1,0),i.hideGlass||(n=Math.min(Math.max(n-1,0),t));const s=0===n;c.toggleGlass(!s),u.hasOpenRequest()||c.waitForActivity()},hasOpenRequest:()=>t>0,get openRequests(){return t},get numActivitiesWithGlass(){return n}}}(),f=function(){return{start(){$(document.body).on("keydown",e),g.start(),$(function(){var e,t;c.domReady=!0,null===(e=window.performance)||void 0===e||null===(t=e.mark)||void 0===t||t.call(e,"initialLoadComplete"),f.complete(),c.completeInitialLoad(),u.hasOpenRequest()&&m.start()})},complete(){$(document.body).off("keydown",e),b(r,!1),w((new Date).getTime()-c.startTime>1600),l.complete()}};function e(e){"Tab"===e.key&&(e.stopPropagation(),e.preventDefault())}}(),h=function(){let e,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:600;return{start(){e=(new Date).getTime(),b(i,!0),g.start(),l.start()},complete(){b(i,!1),w((new Date).getTime()-e>t),l.complete()}}},p=h(),m=h(),g=function(){let e;return{start(){window.clearTimeout(e),e=window.setTimeout(()=>{b(s,!0)},25e3)},complete(){window.clearTimeout(e),e=void 0,b(s,!1)}}}(),w=function(){let e;const t="done";return function(n){window.clearTimeout(e),g.complete(),n?(d.addClass(t),e=window.setTimeout(()=>{d.removeClass(t)},300)):d.removeClass(t)}}();(0,a.registerErrorDataGatherer)("activityindicator",function(){return{openRequests:u.openRequests,numActivitiesWithGlass:u.numActivitiesWithGlass}}),$(document).ajaxSend(u.requestSent).ajaxComplete(u.requestComplete).on("showLoadingIndicator",c.startManualOverride).on("hideLoadingIndicator",c.completeManualOverride),f.start();const v=e=>c.waitForAllActivitiesToComplete(e);function b(e,t){d.toggleClass(e,t)}window.onpageshow=function(e){e.persisted&&(c.forceComplete(),l.complete())}},90265(e,t,n){"use strict";n.r(t),n.d(t,{getAllInputElements:()=>w,handleResponse:()=>v,registerControlForAjax:()=>b,unregisterControlAjax:()=>y});var a=n(62521),o=n(3543),r=n(2894),i=n(88157),s=n(49343),l=n(60977),c=n(40096),d=n(917),u=n(83787),f=n(14144),h=n(83289),p=n(30368);const m=window.skyward,g=(0,l.createAjaxManager)({requestsStarted:function(){(0,c.setClickInProgress)(!0)},requestsCompleted:function(){(0,c.setClickInProgress)(!1)}});function w(e){return(0,f.getFieldValues)($(e))}async function v(e,t,n,a){await _(e,t,n,a)}function b(e){const t=$(e),n=t.data("ajaxselectoroverride")||"";t.on(t.data("ajaxevent"),function(e){!function(e,t,n){var a;const i=$(e);if(i.hasClass("ui-disabled")&&i.hasClass("button"))return;i.hasClass("ajaxDisableMultipleClicks")&&i.addClass("ui-disabled");const l=null===(a=i.getPrefix())||void 0===a?void 0:a.slice(0,-1),c=i.data("ajaxarea"),d=i.data("ajaxcontroller"),u=i.data("ajaxaction");let f=$(i.data("ajaxcontext")||t);f.length||(f=(0,s.getClosestContentPanel)(i),f.length||(f=$(document.body)));w(f).then(e=>{e._controlAjaxFiredFrom=n.target.name?n.target.name:n.target.id;const t=(0,o.getBrowseById)((0,o.getCurrentBrowseName)());t&&t.browseName&&(e[t.browseName]=(0,h.getEditableData)(t.browseName)),g.ajax({url:"".concat(r.virtualDir).concat(c,"/").concat(d,"/").concat(u),type:"POST",dataType:"JSON",data:e,success:async function(e){await _(e,l,!1,$(f)),i.hasClass("ajaxDisableMultipleClicks")&&i.removeClass("ui-disabled")}},{requestID:i.attr("id")})})}(t,n,e)}),"ready"==t.data("ajaxevent")&&$(document).ready(function(){t.trigger("ready")})}function y(e){const t=$(e),n=t.data("ajaxevent");n&&t.off(n)}async function _(e,t,n,l){if(null===e)return;const c=t?t+"_":"";if(!l||!l.length){const e=(0,s.getCurrentPopupId)();l=e>-1?$("#popup"+e):$(document.body)}let f;const h=e.CRQERecords||{};for(f in h){const t=e.CRQERecords[f];m.childrecordquickentry.SetCRQERecordValues(t,l,c)}const g=e.Remove||{};for(f in g)l.find(g[f]).remove(),l.find(g[f].replace("#","#".concat(c))).remove();const w=e.CRQERemoves||{};for(f in w){const t=l.find("#"+c+e.CRQERemoves[f]+" > #"+c+"ClearButton > a");1==t.length&&t.trigger("click")}const v=e.Update||{};for(f in v){if("suppresschangeevent"==f.toLowerCase()){await _({Update:v[f]},t,!0,l);continue}const e=$('[name="'.concat(f,'"]'),l);if(null!=v[f]&&"object"==typeof v[f]){if(e.hasClass("dmsBackingData")){P(e);continue}if("browse"==f.toLowerCase()){const e={currentPage:1};for(const t in v[f]){e[t.charAt(0).toLowerCase()+t.slice(1)]=v[f][t]}(0,a.changePage)(null,(0,o.getCurrentBrowseName)(),e);continue}const t=v[f];for(const a in t)"options"==a.toLowerCase()?(0,d.setComboBoxOptions)(f,v[f][a],c):(0,d.setValue)(e.filter("."+a),v[f][a],n)}else P(e)}const b=e.ReadOnly||{};for(f in b){let e=$("[name='".concat(f,"']"),l);e.length<1&&(e=$("#".concat(f),l),e.length<1&&(e=$("#".concat(c).concat(f),l)),e.length<1)||(b[f]?(0,d.disable)(e,c):(0,d.enable)(e,c))}const y=e.FieldData||{};for(f in y){let e=$('[name="'.concat(f,'"]'),l);if(!(e.length<1&&(e=$("#".concat(f),l),e.length<1&&(e=$("#".concat(c).concat(f),l)),e.length<1)))for(const t in y[f])e.data(t,y[f][t])}const C=e.Hidden||{},k=e.AnimateHidden||{};for(f in C)C[f]?(0,d.hide)(f,!1!==k[f],c):(0,d.show)(f,!1!==k[f],c);const S=e.Message;S&&(0,i.showDialog)(S.Title||"",S.Text||"",[]);const D=e.Append||{};for(f in D){const e=D[f],t=l.find(f).add(l.find(f.replace("#","#".concat(c)))),n=t.getPrefix();let a=$();if(e.Content){const t=await(0,r.processViewPartHtml)(e.Content);a=$(t)}for(const e of a){const t=$(e);if(void 0!==t.data("idPrefix"))continue;const a=t.closest("[data-id-prefix]");t.find("[id]").addBack("[id]").each(function(){var e;const t=$(this),o=t.closest("[data-id-prefix]");o.length==a.length&&(o.length>0&&o[0]!=a[0]||null!==(e=t.attr("id"))&&void 0!==e&&e.startsWith(n)||(this.id=n+this.id))})}e.Content&&e.Class?t.append($("<div />").html(a).attr("id",n+e.Id).addClass(e.Class)):e.Content&&(e.NoDiv?t.append(a):t.append($("<div />").html(a).attr("id",n+e.Id))),e.Id&&(0,s.notifyDOMLoad)("#".concat(c).concat(e.Id))}const E=e.ResetDatePicker||{};for(f in E){let e=$("#".concat(f,",#").concat(c).concat(f),l);0==e.length&&(e=$('[name="'.concat(f,'"]'),l)),e.val("").trigger("change")}function P(e){0==e.length&&(e=$("#".concat(c).concat(f),l));const t=e[0]&&document.activeElement&&e[0]==document.activeElement&&-1!=["text","search","url","tel","password"].indexOf(e[0].type)&&"number"==typeof e[0].selectionStart&&0==e[0].selectionStart&&e[0].selectionEnd>0&&e[0].selectionEnd==e[0].value.length;(0,d.setValue)(e,v[f],n);const a=e.data();e.is("[data-mask]")&&(0,u.addMask)(e,a.mask),t&&e.trigger("select")}(e.Remove||e.Update)&&(0,p.alignTitles)(l)}(0,s.registerLoadDOMCallback)(function(e){$(e).find("[data-ajaxaction]").each(function(e,t){b(t)})})},44061(e,t,n){"use strict";n.r(t),n.d(t,{load:()=>s});var a=n(92214),o=n(49343);const r=window.skyward;r.ajaxRepeater=r.ajaxRepeater||{};const i={init:function(e){s($(e))}};function s(e){const t=e.data();t.templateModule&&t.templateController&&t.templateAction&&t.primaryKey&&(e.text("Loading..."),$.when((0,o.loadContent)(e.attr("id"),t.templateModule,t.templateController,t.templateAction,t.primaryKey,t.postdata).done(function(){e.trigger("ajaxRepeaterTemplateLoaded",e)})))}(0,a.registerEvents)("ajaxRepeater",i),r.ajaxRepeater.load=s},12110(e,t,n){"use strict";n.r(t),n.d(t,{openBindingDialog:()=>u});var a=n(2894),o=n(88157),r=n(83972),i=n(92214),s=n(42980);const l="js-bindingDialogSave",c={bindingButtonClick:function(){const e=$(this).data();e.bindingTargetSelector&&e.bindingValueOverride&&(0,r.insertTextToken)($(e.bindingTargetSelector),e.bindingValueOverride,e.addSpace);if(!e.bindingModule||!e.bindingObject)return;const t={onGetBinding:function(t){e.bindingTargetSelector&&(0,r.insertTextToken)($(e.bindingTargetSelector),t,e.addSpace)},removeBaseFromBinding:e.removeBaseFromBinding};u(e.bindingModule,e.bindingObject,t)}};(0,i.registerEvents)("binding",c);const d={title:"Insert Field",renderProxies:!1,removeBaseFromBinding:!1,onGetBinding:function(){},onCancel:function(){}};function u(e,t,n){const r=$.extend({},d,n),i={text:o.ButtonText.Select,icon:o.ButtonIcon.Select,click:p,additionalClasses:l},c={text:o.ButtonText.Cancel,icon:o.ButtonIcon.Cancel,click:function(){u.close(),r.onCancel()}},u=(0,o.showDialog)(r.title,function(e,t,n){return $.ajax({url:"".concat(a.virtualDir,"SkySys/Binding/BuildTreeBrowse/"),type:"POST",dataType:"viewparthtml",data:{module:e,object:t,renderProxies:n.renderProxies}})}(e,t,r),[i,c],r),h=u.footer.find(".".concat(l));function p(){const e=function(e,t){const n=(0,s.getSelectedFieldData)(e.content);if(!n||!n.fieldName||!n.fieldType)return f("");if("ManyToOne"!=n.fieldType.toString()){let e=n.fieldName;if(t.removeBaseFromBinding){const t=n.fieldName.indexOf(".");e=t<=0?n.fieldName:n.fieldName.substring(t+1,n.fieldName.length)}return f(e)}return f("")}(u,r);u.close(),r.onGetBinding(e)}u.content.on("treeBrowseSave",p),u.content.on("treeBrowseRowChange",function(e,t,n){h.toggle(!n.isRelationship)})}function f(e){return"{".concat(e,"}")}},39411(e,t,n){"use strict";function a(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}n.r(t),n.d(t,{default:()=>o});class o{constructor(e){a(this,"repeat",void 0),a(this,"nullable",void 0),a(this,"iterators",{});for(const[t,n]of Object.entries(e))"$nullable"===t?this.nullable=r(n)[Symbol.iterator]():"$repeat"===t?this.repeat=n[Symbol.iterator]():Array.isArray(n)?this.iterators[t]=n[Symbol.iterator]():this.iterators[t]=new o(n)}nextObj(){var e;if(!0===(null===(e=this.nullable)||void 0===e?void 0:e.next().value))return null;const t=Object.create(null);for(const[e,a]of Object.entries(this.iterators)){var n;t[e]=!0===(null===(n=this.nullable)||void 0===n?void 0:n.next().value)?null:a.next().value}return t}next(){if(this.repeat){const e=[],t=this.repeat.next().value;for(let n=0;n<t;n+=1)e.push(this.nextObj());return{value:e}}return{value:this.nextObj()}}}function r(e){return e.flatMap((e,t)=>new Array(e).fill(t%2==0))}},3543(e,t,n){"use strict";n.r(t),n.d(t,{addBrowse:()=>s,addOpenBrowse:()=>m,browseListContains:()=>f,filterOpenBrowses:()=>w,getAllBrowseIds:()=>d,getAllBrowses:()=>u,getBrowseById:()=>c,getBrowseList:()=>_,getContainingBrowse:()=>h,getCurrentBrowseName:()=>k,getInnerBrowse:()=>p,getOpenBrowses:()=>C,indexOfOpenBrowse:()=>v,prependOpenBrowse:()=>g,removeBrowse:()=>l,removeOpenBrowse:()=>b,setCurrentOpenBrowse:()=>y});const a="browse",o="modalLayerContainer",r={},i=[];function s(e,t){const n=null!=t?t:e.id;r[n]=e}function l(e){delete r[e]}function c(e){return null==e?void 0:r[e]}function d(){return Object.keys(r)}function u(){return Object.values(r)}function f(e){return e in r}function h(e){return c($(e).closest(".".concat(a)).attr("id"))}function p(e){return c($(e).find(".".concat(a)).first().attr("id"))}function m(e){i.includes(e)||i.push(e)}function g(e){i.includes(e)||i.unshift(e)}function w(e){i.splice(0,i.length,...i.filter(e))}function v(e){return i.indexOf(e)}function b(e){const t=v(e);return-1!==t&&(i.splice(t,1),!0)}function y(e){return!!b(e)&&(m(e),!0)}function _(){return r}function C(){return i}function k(){w(e=>!!document.getElementById(e)&&"ProfileControlsBrowse"!==e);const e=h(document.activeElement);if(e&&!t(e.browse)&&!function(e){if(!e)return!0;return!e.is(":visible")}(e.browse))return e.id;for(let e=i.length-1;e>=0;e--){const n=i[e];if(!t($(document.getElementById(n))))return n}return null;function t(e){return!!e&&0!==e.closest("#master, .".concat(o)).nextAll(".".concat(o)).length}}},62521(__unused_webpack_module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__),__webpack_require__.d(__webpack_exports__,{addBrowseScrollEvents:()=>addBrowseScrollEvents,addBrowseScrollEventsGeneric:()=>addBrowseScrollEventsGeneric,applyMobileLockedColumn:()=>applyMobileLockedColumn,bindLockedBodySimulatedFocus:()=>bindLockedBodySimulatedFocus,browseColumnSuperUserClick:()=>browseColumnSuperUserClick,browseLinkColumnPopup:()=>browseLinkColumnPopup,browseList:()=>browseList,changeFilter:()=>changeFilter,changePage:()=>changePage,changeRowsPerPage:()=>changeRowsPerPage,changeView:()=>changeView,deregisterDeselectPreviousRecordOverrideListener:()=>deregisterDeselectPreviousRecordOverrideListener,detailsPanelSaveUpdateRow:()=>detailsPanelSaveUpdateRow,eventCallbacks:()=>eventCallbacks,get:()=>get,getBrowseStats:()=>getBrowseStats,getContainingBrowse:()=>_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getContainingBrowse,getCurrentBrowseName:()=>_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getCurrentBrowseName,getCurrentRowElement:()=>getCurrentRowElement,getDebugName:()=>getDebugName,getInnerBrowse:()=>_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getInnerBrowse,getParentBrowse:()=>getParentBrowse,getRequiredBrowseData:()=>getRequiredBrowseData,getSelectedRecordValue:()=>getSelectedRecordValue,getSql:()=>getSql,handlePopupBrowseTabPress:()=>handlePopupBrowseTabPress,hide:()=>hide,isInWorkflow:()=>isInWorkflow,maxColumnWidth:()=>maxColumnWidth,minColumnWidth:()=>minColumnWidth,openBrowses:()=>openBrowses,performCodeEELSearch:()=>performCodeEELSearch,performDistinctMultiSelectEELSearch:()=>performDistinctMultiSelectEELSearch,performGradebookCodeEELSearch:()=>performGradebookCodeEELSearch,prepMobileBrowseData:()=>prepMobileBrowseData,primaryButtonClick:()=>primaryButtonClick,registerBrowse:()=>registerBrowse,registerDeselectPreviousRecordOverrideListener:()=>registerDeselectPreviousRecordOverrideListener,resetViewAndFilter:()=>resetViewAndFilter,resize:()=>resize,resizeBrowseList:()=>resizeBrowseList,resizeLockedBrowseBodyForHorizontalScrollBar:()=>resizeLockedBrowseBodyForHorizontalScrollBar,rowPopupMenu:()=>rowPopupMenu,selectRowByElement:()=>selectRowByElement,setCurrentBrowseName:()=>setCurrentBrowseName,setCurrentRecord:()=>setCurrentRecord,setDetailsPanelTabData:()=>setDetailsPanelTabData,shouldIgnoreKeyboardEvent:()=>shouldIgnoreKeyboardEvent,show:()=>show,tryRefreshDetailsPanel:()=>tryRefreshDetailsPanel,updateQuickFilter:()=>updateQuickFilter});var _skyward_browseList__WEBPACK_IMPORTED_MODULE_0__=__webpack_require__(3543),_skyward_error__WEBPACK_IMPORTED_MODULE_1__=__webpack_require__(79126),_skyward_global__WEBPACK_IMPORTED_MODULE_2__=__webpack_require__(2894),_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__=__webpack_require__(88157),_skyward_window__WEBPACK_IMPORTED_MODULE_4__=__webpack_require__(49343),_skyward_base_extensions__WEBPACK_IMPORTED_MODULE_5__=__webpack_require__(66952),_skyward_base_performanceMonitor__WEBPACK_IMPORTED_MODULE_6__=__webpack_require__(19802),_skyward_base_requestDataHash__WEBPACK_IMPORTED_MODULE_7__=__webpack_require__(82441),_skyward_base_time__WEBPACK_IMPORTED_MODULE_8__=__webpack_require__(81975),_skyward_ui_browse_fieldTree__WEBPACK_IMPORTED_MODULE_9__=__webpack_require__(39411),_skyward_ui_browseFilters__WEBPACK_IMPORTED_MODULE_10__=__webpack_require__(6722),_skyward_ui_browseLoadTimer__WEBPACK_IMPORTED_MODULE_11__=__webpack_require__(40044),_skyward_ui_browseSeekInfo__WEBPACK_IMPORTED_MODULE_12__=__webpack_require__(50573),_skyward_ui_changeTracking__WEBPACK_IMPORTED_MODULE_13__=__webpack_require__(40346),_skyward_ui_checkboxBrowse__WEBPACK_IMPORTED_MODULE_14__=__webpack_require__(46740),_skyward_ui_contentMessageArea__WEBPACK_IMPORTED_MODULE_15__=__webpack_require__(92566),_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__=__webpack_require__(917),_skyward_ui_debounce__WEBPACK_IMPORTED_MODULE_17__=__webpack_require__(16140),_skyward_ui_distinctMultiSelectEEL__WEBPACK_IMPORTED_MODULE_18__=__webpack_require__(62894),_skyward_ui_editableBrowse__WEBPACK_IMPORTED_MODULE_19__=__webpack_require__(83289),_skyward_ui_events__WEBPACK_IMPORTED_MODULE_20__=__webpack_require__(92214),_skyward_ui_svg__WEBPACK_IMPORTED_MODULE_21__=__webpack_require__(68337),_skyward_ui_treebrowse__WEBPACK_IMPORTED_MODULE_22__=__webpack_require__(42980),_skyward_ui_validation__WEBPACK_IMPORTED_MODULE_23__=__webpack_require__(22528),_skyward_ui_workflow__WEBPACK_IMPORTED_MODULE_24__=__webpack_require__(53346);const skyward=window.skyward,eventCallbacksInternal={updateActiveBrowseClasses:(0,_skyward_ui_events__WEBPACK_IMPORTED_MODULE_20__.getCallbackStore)(),recordSelectionMade:(0,_skyward_ui_events__WEBPACK_IMPORTED_MODULE_20__.getCallbackStore)()},eventCallbacks=(0,_skyward_ui_events__WEBPACK_IMPORTED_MODULE_20__.getCallbackStoreFacadeCollection)(eventCallbacksInternal),classNames={addDashboardTile:"js-addDashboardTile",allowColumnSort:"js-allowColumnSort",anchorText:"anchorText",appendMobileBrowseFooter:"js-appendMobileBrowseFooter",appendMobileBrowseHeader:"js-appendMobileBrowseHeader",bottomBrowsesCollapsed:"bottomBrowsesCollapsed",bottomCollapsibleBrowseContainer:"bottomCollapsibleBrowseContainer",browse:"browse",browseBody:"browseBody",browseBodyLoading:"browseBodyLoading",browseBodyLockedTotalColumn:"browseBody__lockedTotalColumn",browseBodyShadowColumn:"browseBody__shadowColumn",browseBodySortablePlaceholder:"browseBodySortablePlaceholder",browseBodyTotalButtonsFiller:"browseBody__totalButtonsFiller",browseBodyTotalColumn:"browseBody__totalColumn",browseBodyTotalColumnHasData:"js-browseBody__totalColumn--hasData",browseBodyTotalScrollbarFiller:"js-browseBody__totalScrollbarFiller",browseBodyTotalsSection:"browseBody__totalsSection",browseBodyTotalsSectionLocked:"browseBody__totalsSection--locked",browseBodyTotalsSectionLockedWrapper:"browseBody__totalsSectionLockedWrapper",browseBodyTotalsSectionNotReady:"browseBody__totalsSection--notReady",browseColumnFilterMenuLaunch:"browseColumnFilterMenuLaunch",browseColumnHeaderSort:"browseColumnHeaderSort",browseColumnSortSpan:"browseColumnSortSpan",browseColumnSuperUser:"browseColumnSuperUser",browseColumnIconSpan:"browseColumnIconSpan",browseDataCell:"browseDataCell",browseExpandCollapseButton:"browseExpandCollapseButton",browseHeader:"browseHeader",browseHeaderColumn:"browseHeaderColumn",browseHeaderDraggable:"browseHeaderDraggable",browseHeaderDraggablePlaceholder:"browseHeaderDraggablePlaceholder",browseHeaderSpacer:"browseHeaderSpacer",browseRow:"browseRow",browseRowContent:"browseRowContent",browseRowOptions:"browseRowOptions",browseSearch:"browseSearch",browseSearchBox:"browseSearchBox",browseSectionHeader:"browse__sectionHeader",button:"button",buttonSelectedValueLabel:"buttonSelectedValueLabel",buttonParenthesisLabel:"buttonParenthesisLabel",cmaErrorMessage:"cmaErrorMessage",columnDragging:"columnDragging",containerToolbar:"containerToolbar",contentArea:"contentArea",current:"current",currentRecordContentBaseError:"currentRecordContentBaseError",customBrowse:"js-custombrowse",dataObjectViewer:"dataObjectViewer",datepicker:"datepicker",dateTimePickerModal:"dateTimePickerModal",deleteColumnButton:"js-deleteColumnButton",dmsBackingData:"dmsBackingData",expandableQuickFilter:"js-expandableQuickFilter",expandCollapseBrowsePanel:"js-expandCollapseBrowsePanel",hasInitialHeader:"js-hasInitialHeader",hideHeaderMobile:"hideHeaderMobile",iconContainerDiv:"iconContainerDiv",insertColumnButton:"js-insertColumnButton",isInDetailsPanel:"js-isInDetailsPanel",isSelectionFiltered:"isSelectionFiltered",locked:"locked",lockedBrowseBody:"lockedBrowseBody",lockedBrowseBodyScrollWrapper:"lockedBrowseBody_scrollwrapper",lockedBrowseShadow:"lockedBrowseShadow",lockedHeader:"lockedHeader",lockedHeaderTableRow:"lockedHeaderTableRow",mainSelectedBrowse:"mainSelectedBrowse",massSelectCell:"js-massSelectCell",modalLayerContainer:"modalLayerContainer",newWindow:"newWindow",noRecordsInBrowse:"noRecordsInBrowse",noSearchAvailable:"js-noSearchAvailable",pagingButton:"pagingButton",pagingButtonDisabled:"pagingButtonDisabled",quickFilterActive:"quickFilterActive",repeater:"repeater",reset:"reset",rowAction:"rowAction",saveBoolFilterSort:"js-saveBoolFilterSort",saveColumnFilterSort:"js-saveColumnFilterSort",searchBoxButton:"searchBoxButton",sectionHeader:"sectionHeader",sectionHeaderText:"sectionHeader__text",selectedDetailsRow:"selectedDetailsRow",selectedPK:"selectedPK",selectRecord:"js-selectRecord",settingsIcon:"Settings",simulateFocus:"simulateFocus",skyVue:"skyVue",svg:"svg",svgAnchor:"svgAnchor",svgBrowseColumnHeader:"svgBrowseColumnHeader",tdResizeDiv:"tdResizeDiv",topExpandableBrowseContainer:"topExpandableBrowseContainer",totalRecordsButton:"totalRecordsButton",totalRecordsButtonDisabled:"totalRecordsButtonDisabled",translateZ:"translateZ",uiDisabled:"ui-disabled",unlockedBrowseBody:"unlockedBrowseBody",unlockedBrowseTable:"unlockedBrowseTable",unlockedHeader:"unlockedHeader",unlockedHeaderTableRow:"unlockedHeaderTableRow",viewAndFilter:"viewAndFilter",workflow:"workflow"},valueNames={detailsPanelIdentifier:"browse"},mobileBrowseClasses={mobileBrowseContainer:"mobileBrowseContainer",mobileBrowseBody:"mobileBrowseBody",hasHeaderShadow:"hasHeaderShadow",hasColumnShadow:"hasColumnShadow",lockedColumnCell:"lockedColumnCell"},browseList=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseList)(),openBrowses=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getOpenBrowses)(),minColumnWidth=65,maxColumnWidth=999,defaultUpdateCurrentRecordSettings={loadRelatedBrowses:!0,updateBrowseSeekInfo:!0,setCurrentBrowseName:!1},allBrowseStats={};let refreshTimeout=null;const deselectPreviousRecordOverrides={},keyUpHandler={_keyUpListeners:{},_boundSharedKeyUpHandler:null,sharedKeyUpHandler(e){const t=this._keyUpListeners[e.which];t&&(delete this._keyUpListeners[e.which],$.isEmptyObject(this._keyUpListeners)&&$(document.documentElement).off("keyup",this._boundSharedKeyUpHandler),t.call(this,e))},addKeyUpHandler(e,t){if(!this._keyUpListeners[e]){var n;if($.isEmptyObject(this._keyUpListeners))null!==(n=this._boundSharedKeyUpHandler)&&void 0!==n||(this._boundSharedKeyUpHandler=this.sharedKeyUpHandler.bind(this)),$(document.documentElement).on("keyup",this._boundSharedKeyUpHandler);this._keyUpListeners[e]=function(e){const n=getCurrentBrowse();if((null==n?void 0:n.id)!==t)return;n.primaryKeys&&n.primaryKeys.length>1&&rowChange(n.id,n.currentRow,!0);e.stopPropagation()}}}},browseDetailsPanel={_currentDetailsBrowse:null,get currentDetailsBrowse(){return this._currentDetailsBrowse},set currentDetailsBrowse(e){this._currentDetailsBrowse=null!==e&&(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.browseListContains)(e)?e:null},detailsPanelTypes:Object.freeze({cell:"cell",row:"row"}),getSelectedRow:e=>e?$(".".concat(classNames.selectedDetailsRow)):$(".".concat(classNames.unlockedBrowseBody)).find(".".concat(classNames.selectedDetailsRow)),setSelectedRow(e){this.resetSelectedRow();const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);t&&getRowElements(t).addClass(classNames.selectedDetailsRow)},resetSelectedRow(){this.getSelectedRow(!0).removeClass(classNames.selectedDetailsRow)},init(){var e;const t=null===(e=skyward.detailsPanel)||void 0===e?void 0:e.eventCallbacks;t&&(t.open.registerCallback((e,t)=>{const n=t.browseName;this.currentDetailsBrowse=n,this.setSelectedRow(this.currentDetailsBrowse)}),t.close.registerCallback(()=>{const e=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getCurrentBrowseName)();browseDetailsPanel.currentDetailsBrowse=null,browseDetailsPanel.resetSelectedRow(),this.shouldShowDetailsPanelForBrowse(e)&&window.setTimeout(function(){browseDetailsPanel.showDetailsPanel(e,!0)},500)}),t.empty.registerCallback(()=>{this.resetSelectedRow(),this.removeDetailsPanelBrowsesFromOpenBrowses()}),t.resizeClose.registerCallback(()=>{this.currentDetailsBrowse=null,this.resetSelectedRow()}),t.resizeOpen.registerCallback((e,t)=>{const n=t;if(n.identifier!==valueNames.detailsPanelIdentifier)return;const a=n.browseName,o=n.primaryKey,r=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.browseListContains)(a),i=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getCurrentBrowseName)();r&&a===i&&getCurrentRecordTargetId(a)===o?(this.currentDetailsBrowse=a,this.setSelectedRow(a)):this.shouldShowDetailsPanelForBrowse(i)&&this.showDetailsPanel(i,!1)}),t.contentLoaded.registerCallback((e,t)=>{const n=t.browseName;this.currentDetailsBrowse=n,this.setSelectedRow(n)}),t.resizeCanOpen.registerCallback(()=>{const e=getCurrentBrowse();e&&this.shouldShowDetailsPanelForBrowse(e.id)&&(!0===e.isRegistered?this.showDetailsPanel(e.id,!1):this.currentDetailsBrowse=e.id)}))},showDetailsPanel(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];const n=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!n||!this.shouldShowDetailsPanelForBrowse(e))return $.Deferred().reject();const a=getCurrentRecordTargetId(e);if(!(n.rowModule&&n.rowObject&&n.rowScreen&&null!==a))return $.Deferred().reject();const o=getUnlockedRowElement(n).data();setCurrentBrowseName(e);const r=o.rowmodule,i=o.rowobject,s=o.rowscreen,l=this.getDetailsPanelPostData(n);n.confirmationMessage=null,n.confirmationMessageContainer=null;const c={shouldAnimate:t,panelWidth:o.panelwidth,additionalData:{identifier:valueNames.detailsPanelIdentifier,browseName:e,primaryKey:a}};return this.currentDetailsBrowse=e,skyward.detailsPanel.openDetailsPanel(r,i,s,a,l,c).fail(()=>{this.currentDetailsBrowse=null})},hideDetailsPanel:e=>skyward.detailsPanel.closeDetailsPanel(e),toggleDetailsPanel(e,t){var n;const a=skyward.detailsPanel.isDetailsPanelOpen();let o;skyward.detailsPanel.setDetailsPanelSessionState(!a),a?skyward.detailsPanel.tryCloseDetailsPanel(e=>{if(e){const e=$.Deferred();o=this.hideDetailsPanel(t).then(()=>e.resolve(),()=>e.reject())}else o=this.hideDetailsPanel(t)}):o=this.showDetailsPanel(e,t),null===(n=o)||void 0===n||n.fail(()=>{skyward.detailsPanel.setDetailsPanelSessionState(a)})},tryRefreshDetailsPanel(e){const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(null==t||!t.browse||t.detailsPanelType!==this.detailsPanelTypes.row)return;const n=!!this.currentDetailsBrowse,a=t.browse.hasClass(classNames.mainSelectedBrowse),o=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getCurrentBrowseName)(),r=e===this.currentDetailsBrowse&&(e===o||null===o);(a&&!n||r)&&this.refreshDetailsPanel(e)},refreshDetailsPanel(e){const t=!1;this.shouldShowDetailsPanelForBrowse(e)?this.showDetailsPanel(e,t):this.hideDetailsPanel(t)},tryRowChange(e,t,n){if(!this.shouldShowDetailsPanelForBrowse(e))return void(this.shouldHideDetailsPanelForBrowse(e)?skyward.detailsPanel.tryCloseDetailsPanel(()=>{this.hideDetailsPanel(!0),t()}):t());const a=()=>{t(),n&&this.showDetailsPanel(e)};skyward.detailsPanel.tryCloseDetailsPanel(e=>{e||skyward.detailsPanel.getDetailsPanelSessionState()?a():t()})},detailsPanelSaveUpdateRow(e){const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(this.currentDetailsBrowse);if(!t)return;const n=$.extend({},this.getDetailsPanelPostData(t),e);return get(this.currentDetailsBrowse,{seekId:t.primaryKeys[t.currentRow]},n)},setDetailsPanelTabData(e){const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(this.currentDetailsBrowse);t&&(t.tabData=e)},shouldShowDetailsPanelForBrowse(e){const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!t)return!1;return![t.hidePreviewDetailsButton,isInWorkflow(t),t.isInDetailsPanel,(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.elementIsInModalLayer)(t.browse),!skyward.detailsPanel.getDetailsPanelSessionState(),!skyward.detailsPanel.canShowDetailsPanel(),t.detailsPanelType!==this.detailsPanelTypes.row,!(t.rowModule&&t.rowObject&&t.rowScreen)].includes(!0)},shouldHideDetailsPanelForBrowse(e){const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!t)return!1;const n=skyward.detailsPanel.getData();return![isInWorkflow(t),t.isInDetailsPanel,(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.elementIsInModalLayer)(t.browse),!$.isEmptyObject(n)&&!$.isEmptyObject(n.options)&&!0===n.options.useCloseButton].includes(!0)},removeDetailsPanelBrowsesFromOpenBrowses(){(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.filterOpenBrowses)(e=>!e.startsWith("detailsPanel_"))},getDetailsPanelPostData(e){var t;const n={renderInDetailsPanel:!0,confirmationMessage:e.confirmationMessage,confirmationMessageContainer:e.confirmationMessageContainer},a=getUnlockedRowElement(e);return a.length>0&&$.extend(n,a.data("postdata")),"details"===(null===(t=e.tabData)||void 0===t?void 0:t.tabType)&&(n.tab=e.tabData.tab),n}},detailsPanelSaveUpdateRow=browseDetailsPanel.detailsPanelSaveUpdateRow.bind(browseDetailsPanel),tryRefreshDetailsPanel=browseDetailsPanel.tryRefreshDetailsPanel.bind(browseDetailsPanel),rowClickThrottler={_rateLimit:10,_timeOutHandler:null,throttleRowClick(e,t){this._timeOutHandler||(rowClick(e,t),this._timeOutHandler=window.setTimeout(()=>{this._timeOutHandler=null},this._rateLimit))}};function resizeBrowseList(){for(const e of(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getAllBrowseIds)())try{const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);null!=t&&t.resize&&t.resize()}catch(t){(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.removeBrowse)(e)}}function isInWorkflow(e){return!!e.taskName}function setDetailsPanelTabData(e){browseDetailsPanel.setDetailsPanelTabData(e)}function getCurrentRowElement(e,t,n,a){const o="#".concat(t,"_");return"Tile"===a?$("".concat(o,"Tile").concat(n)):"DistinctMultiSelect"===a&&-1===n?$("".concat(o).concat(e,"Header")).find(".".concat(classNames.massSelectCell)):$("".concat(o).concat(e,"Row").concat(n))}function registerDeselectPreviousRecordOverrideListener(e,t){deselectPreviousRecordOverrides[e]=t}function deregisterDeselectPreviousRecordOverrideListener(e){delete deselectPreviousRecordOverrides[e]}function setCurrentRecord(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};const a=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e),o=parseInt(t);if(!(!$.isEmptyObject(a)&&void 0!==a.currentRow&&!isNaN(o)&&(o>=0||"DistinctMultiSelect"===a.browseType)))return;const r=$.extend({},defaultUpdateCurrentRecordSettings,n),i=o!==a.currentRow,s=getLockedRowElement(a,o),l=getUnlockedRowElement(a,o),c=$("#".concat(e,"_unlockedBody"));if(c.length>0&&l.length>0){const e=c.scrollTop(),t=e+c.height(),n=l.offset().top-c.offset().top+e,a=n+l.height();n<e?f(!0):a>t&&f(!1)}let d=!1;i&&!isDeselectPreviousRecordOverridden(e)&&(deselectPreviousRecord(e),d=!a.disableRowHighlighting),a.currentRow=o;const u=$("#".concat(e));if(u.children(".".concat(classNames.selectedPK)).val(a.primaryKeys[o]),d){const e=s.add(l);e.length>0&&(e.addClass(classNames.current),e.find("svg").addClass(classNames.browseRowContent),e.eq(-1).attr("aria-selected","true"))}return a.relatedBrowses&&r.loadRelatedBrowses&&getRelatedBrowses(a),r.updateBrowseSeekInfo&&(0,_skyward_ui_browseSeekInfo__WEBPACK_IMPORTED_MODULE_12__.save)(a),r.setCurrentBrowseName&&setCurrentBrowseName(e),i&&u.trigger("rowChanged",a),i;function f(e){l[0].scrollIntoView(e),s.length&&s[0].scrollIntoView(e)}}function registerBrowse(e){var t,n;const a=e.browseName,o=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(a);if(!o)return;null!==(t=o.data)&&void 0!==t||(o.data={});const r="#".concat(a),i=o.browse?$(o.browse):$(r);if(shouldProcessMobileBrowse(o)){const e=i.find("script");document.body.append(...e.get()),initMobileBrowse(i,i.html(),o)}const s=null!==(n=o.totals)&&void 0!==n?n:{},l=i.hasClass(classNames.isInDetailsPanel);void 0!==o.isRegistered&&o.isRegistered||bindBrowseCleanupEvents(a,o,i,l),$.extend(o,{browse:i,controls:$("".concat(r,"_controls")),quickFilter:i.find(".".concat(classNames.expandableQuickFilter)),seek:$("".concat(r,"_seek")),searchContainer:i.find(".".concat(classNames.browseSearch)),header:$("".concat(r,"_header")),lockedHeader:$("".concat(r,"_lockedHeader")),unlockedHeader:$("".concat(r,"_unlockedHeader")),body:$("".concat(r,"_body")),lockedBody:$("".concat(r,"_lockedBody")),unlockedBody:$("".concat(r,"_unlockedBody")),footer:$("".concat(r,"_footer")),baseErrorDiv:i.find(".".concat(classNames.currentRecordContentBaseError)),viewId:e.browseViewId,browseId:e.browseId,browseName:e.browseRequestName,recordCount:e.recordCount,currentRow:e.currentRow,primaryKeys:e.primaryKeys,columnFieldNames:e.columnFieldNames,contentMessageArea:void 0,browseFilterId:e.browseFilterId,browseFilterIdHash:e.browseFilterIdHash,browseSearchCondition:e.browseSearchCondition,browseSearchConditionHash:e.browseSearchConditionHash,userSearchCondition:e.userSearchCondition,userSearchConditionHash:e.userSearchConditionHash,selectMode:e.selectMode,sectionHeaderContainer:i.find(".".concat(classNames.sectionHeader)),hidePreviewDetailsButton:e.hidePreviewDetailsButton,rowModule:e.rowModule,rowObject:e.rowObject,rowScreen:e.rowScreen,taskName:e.taskName,hideBrowseControl:e.hideBrowseControl,hideSelectListTotals:e.hideSelectListTotals,rowsPerPageCap:e.rowsPerPageCap,hasCollapseExpandButton:e.hasCollapseExpandButton,rowData:e.rowData?new _skyward_ui_browse_fieldTree__WEBPACK_IMPORTED_MODULE_9__.default(e.rowData).next().value.values:[],rowDataHash:e.rowDataHash,codeEELSearchText:e.codeEelSearchText,renderLeftControls:e.renderLeftControls,renderSearchBox:e.renderSearchBox,renderViewButton:e.renderViewButton,renderFilterButton:e.renderFilterButton,renderLiveTileAddButton:e.renderLiveTileAddButton,renderChartTileAddButton:e.renderChartTileAddButton,disableBrowseSort:e.disableBrowseSort,hideOptionsButton:e.hideOptionsButton,hideReportsFromRelatedScreen:e.hideReportsFromRelatedScreen,tempTableName:e.tempTableName,confirmationMessageContainer:e.confirmationMessageContainer,confirmationMessage:e.confirmationMessage,renderHeaderSettings:e.renderHeaderSettings,renderSortableHeader:e.renderSortableHeader,preventColumnResize:e.preventColumnResize,isInDetailsPanel:l,detailsPanelType:e.detailsPanelType,firstRowIdentityFieldValues:e.firstRowIdentityFieldValues,lastRowIdentityFieldValues:e.lastRowIdentityFieldValues,renderRowsPerPageOption:e.renderRowsPerPageOption,forceSingleThread:e.forceSingleThread,hasShadow:!1,totals:$.extend(s,{container:i.find(".".concat(classNames.browseBodyTotalsSection))}),cachedSql:null,skywardID:e.skywardID,isRegistered:!1,rowCount:null,isRelatedBrowse:e.isRelatedBrowse}),(0,_skyward_ui_browseFilters__WEBPACK_IMPORTED_MODULE_10__.preInitQuickFilter)(o);i.find(".".concat(classNames.browseSearchBox)).on("keydown",function(e){if(skyward.keys.getKeyNamesFromEvent(e).ENTER){if($(".".concat(classNames.dateTimePickerModal)).length>0)return;const t=$(this);d.apply(t),e.stopPropagation(),e.preventDefault()}}),i.find(".".concat(classNames.searchBoxButton)).on("click",d),setupBrowseDependency(o),updateBrowseTotalsRequest(o),addBrowseScrollEvents(o),wireUpExpandCollapseBrowseButton(o.browse),addBrowseControlsClickEvents(o),addBrowseBodyClickEvents(o),addQuickSelectionFilter(o),addColumnHeaderClickEvents(o),addColumnHeaderResizeHandler(o),!0!==o.preventColumnResize&&addColumnHeaderResizeEvents(o.browse,a),addPagingButtonClickEvents(a),addTotalRecordsClickEvents(a),o.params=[],i.append('<input id="'.concat(a,'_selectedPK" name="').concat(a,'_selectedPK" class="').concat(classNames.selectedPK,'" type="hidden" />')),i.off("click",".".concat(classNames.browseRow," .").concat(classNames.browseDataCell)),i.on("click",".".concat(classNames.browseRow," .").concat(classNames.browseDataCell),function(){rowClickThrottler.throttleRowClick(a,$(this))}),i.off("click",".".concat(classNames.lockedBrowseBody," .").concat(classNames.browseRow," .").concat(classNames.browseRowOptions)),i.on("click",".".concat(classNames.lockedBrowseBody," .").concat(classNames.browseRow," .").concat(classNames.browseRowOptions),function(e){if(e.target){const t=$(e.target);if(t.hasClass(classNames.button)||t.parents(".".concat(classNames.button)).length>0)return}const t=$(this).parent();if(t.length>0){var n;const e=null===(n=t.attr("id"))||void 0===n?void 0:n.replace("locked","unlocked"),o=$("#".concat(e)).find(".".concat(classNames.browseRowOptions));rowClick(a,o)}}),i.off("click",".".concat(classNames.insertColumnButton),noColumnsInsertColumnButtonClick),i.on("click",".".concat(classNames.insertColumnButton),noColumnsInsertColumnButtonClick);const c=new URLSearchParams(window.location.search).get("openBrowseFilterDialogFor");function d(){const e=getSearchTextValue(a);let t=null;const n=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(a);n&&(t=n.tempTableName),performSearch(a,{seekText:e,tempTableName:t})}c&&o.browseName===c&&$("#".concat(o.browseName,"_filterButton")).trigger("click")}function hide(e){const t=$("#".concat(e));t.length>0&&t.parent().css("display","none")}function show(e){const t=$("#".concat(e));t.length>0&&t.parent().css("display","")}const resize=browseResize;function rowPopupMenu(e,t,n,a){const o=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(t);function r(){n=$(n);const o=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getCurrentBrowseName)()!==t;setCurrentBrowseName(t);const r=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(t);(null==r?void 0:r.detailsPanelType)!==browseDetailsPanel.detailsPanelTypes.row||r.currentRow===a&&!o||(r.currentRow!==a&&setCurrentRecord(t,a),r.hidePreviewDetailsButton||browseDetailsPanel.showDetailsPanel(t));const i=[];$.each(e,function(e,t){"title"===t.type?i.push(t):function(e){const t={};for(const[a,o]of Object.entries(null!==(n=e.data)&&void 0!==n?n:{})){var n;t["data-".concat(a)]=o}const a={type:"item",text:e.text,icon:e.icon,click:function(t){var n;const a=null!==(n=e.data)&&void 0!==n?n:{},o=a["click-target-id"],r=a["click-action"];o&&""!==o?$("#".concat(o)).trigger("click"):r&&""!==r?_skyward_ui_events__WEBPACK_IMPORTED_MODULE_20__.clickEvent.call(this,t):(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.loadContent)(e.target,e.module,e.object,e.screen,e.id,a,null,void 0)},attributes:t};i.push(a)}(t)}),(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.showMenu)(i,n,{})}o&&o.currentRow!==a?skyward.detailsPanel.tryCloseDetailsPanel(function(){r()}):r()}function handlePopupBrowseTabPress(){const e=getCurrentBrowse();e&&(void 0!==e.recordCount&&e.recordCount>0?$(e.body).find(".".concat(classNames.browseRow,".").concat(classNames.current," a.").concat(classNames.button)).first().trigger("focus"):$(e.browse).find("a.".concat(classNames.button)).first().trigger("focus"))}function getRequiredBrowseData(e){var t,n,a,o,r,i,s,l,c,d,u,f,h;let p=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},m=arguments.length>2?arguments[2]:void 0;const g=getParentBrowse(e),w={pageModule:e.pageModule,pageObject:e.pageObject,pageScreen:e.pageScreen,pageTab:e.pageTab,routeModule:e.routeModule,routeObject:e.routeObject,dataModule:e.dataModule,dataObject:e.dataObject,taskName:null!==(t=e.taskName)&&void 0!==t?t:void 0,browseName:e.browseName,hidePrimaryBrowseButton:!!p.hidePrimaryBrowseButton||e.hidePrimaryBrowseButton,labelID:e.labelID,hideIfEmpty:!!e.hideIfEmpty||!(null==g||!g.hideIfEmpty),selectMode:e.selectMode,browseId:e.id,isCodeEel:null!==(n=e.isCodeEel)&&void 0!==n&&n,codeEelName:null!==(a=e.codeEelName)&&void 0!==a?a:void 0,codeEelCode:null!==(o=e.codeEelCode)&&void 0!==o?o:void 0,codeEelDescription:null!==(r=p.codeEelDescription)&&void 0!==r?r:void 0,codeEELSearchText:null!==(i=e.codeEELSearchText)&&void 0!==i?i:void 0,relatedBrowses:null!=e.relatedBrowses?JSON.stringify(e.relatedBrowses):void 0,rowDataDefinitions:null!=e.rowDataDefinitions?JSON.stringify(e.rowDataDefinitions):void 0,queryParameterData:null!=e.queryParameterData?JSON.stringify(e.queryParameterData):void 0,queryParameterDataHash:null!==(s=e.queryParameterDataHash)&&void 0!==s?s:void 0,timestamp:(new Date).getTime(),tempTableName:null!==(l=null!==(c=p.tempTableName)&&void 0!==c?c:e.tempTableName)&&void 0!==l?l:void 0,displayName:null!==(d=e.displayName)&&void 0!==d?d:p.displayName,dynamicHeight:e.dynamicHeight,readNoLock:!!p.readNoLock,hideBrowseControl:e.hideBrowseControl,hideSelectListTotals:e.hideSelectListTotals,rowsPerPageCap:e.rowsPerPageCap,renderSearchBox:e.renderSearchBox,performSearch:!0,getBrowseSearchMode:e.getBrowseSearchMode,multiSelectBrowseObjectRelationship:e.multiSelectBrowseObjectRelationship,multiSelectBrowseObjectRelationshipField:e.multiSelectBrowseObjectRelationshipField,multiSelectBrowseContextId:e.multiSelectBrowseContextId,multiSelectBrowseIsReverseRelationship:e.multiSelectBrowseIsReverseRelationship,segmentedBrowseParentField:e.segmentedBrowseParentField,segmentedRowHeaderDisplayData:null!=e.segmentedRowHeaderDisplayData?JSON.stringify(e.segmentedRowHeaderDisplayData):void 0,dataType:p.dataType,browseFilterId:p.browseFilterId,hasCollapseExpandButton:e.hasCollapseExpandButton,requestDataHash:e.requestDataHash,disableRowHighlighting:e.disableRowHighlighting,preventColumnResize:e.preventColumnResize,preventColumnSort:e.preventColumnSort,renderLeftControls:e.renderLeftControls,renderViewButton:e.renderViewButton,renderFilterButton:e.renderFilterButton,renderLiveTileAddButton:e.renderLiveTileAddButton&&!e.isRelatedBrowse,renderChartTileAddButton:e.renderChartTileAddButton&&!e.isRelatedBrowse,renderRowsPerPageOption:e.renderRowsPerPageOption,disableBrowseSort:e.disableBrowseSort,hideOptionsButton:e.hideOptionsButton,hideReportsFromRelatedScreen:e.hideReportsFromRelatedScreen,additionalfieldinfo:e.additionalfieldinfo,sortfieldinfo:e.sortfieldinfo,distinctfield:e.distinctfield,hidedistinctfield:e.hidedistinctfield,rendernodatarow:e.rendernodatarow,distinctfieldwidth:e.distinctfieldwidth,selectedItemKeys:e.selectedItemKeys,dependentFilterPromptValues:e.dependentFilterPromptValues,promptIsList:e.promptIsList,filter:e.filter,renderDesignReportButton:e.renderDesignReportButton,parentPrimaryKeyID:null!==(u=p.parentPrimaryKeyID)&&void 0!==u?u:void 0,hideMoreMenuArea:!!e.hideMoreMenuArea,renderSortableHeader:e.renderSortableHeader,renderHeaderSettings:e.renderHeaderSettings,isOnTheFly:e.isOnTheFly,hiddenBackingDataId:e.hiddenBackingDataId,detailsPanelType:e.detailsPanelType,pagingType:p.pagingType,identifyingFieldsAndValues:(0,_skyward_base_extensions__WEBPACK_IMPORTED_MODULE_5__.encodeHtml)(getIdentityFieldValuesBasedOnType(p.pagingType,e)),identityFieldValuesOfTopRecord:(0,_skyward_base_extensions__WEBPACK_IMPORTED_MODULE_5__.encodeHtml)(e.firstRowIdentityFieldValues),seekText:getSearchTextValue(e.id),renderQuickFilter:e.renderQuickFilter&&!e.isRelatedBrowse&&!e.isInDetailsPanel&&0===(null===(f=e.browse)||void 0===f?void 0:f.closest(".".concat(classNames.workflow)).length),headerNumber:getHeaderNumber(e),parentBrowseRequestDataHash:null==g?void 0:g.requestDataHash,forceSingleThread:!!e.forceSingleThread||!!p.forceSingleThread,rowDataNonce:e.rowDataNonce,isRelatedBrowse:null!==(h=p.isRelatedBrowse)&&void 0!==h?h:e.isRelatedBrowse},v=null==g?void 0:g.currentRow;if("number"==typeof v&&v>=0&&null!=g&&g.rowData){const e=g.rowData[v];$.isEmptyObject(e)||(w.rowData=JSON.stringify(e),w.rowDataHash=g.rowDataHash[v])}else g&&(w.rowDataHash=g.rowDataHash[0]);if(e.dynamicFilterValues||e.dynamicFilterData){var b;const t=null!=m?m:(0,_skyward_base_requestDataHash__WEBPACK_IMPORTED_MODULE_7__.getDependencyDataWithoutWaiting)(e.dynamicFilterData,(0,_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__.getScopeContainer)(e.browse));w.dynamicFilterValues=JSON.stringify($.extend({},e.dynamicFilterValues,t)),w.dynamicFilterHashes=JSON.stringify(null!==(b=e.dynamicFilterHashes)&&void 0!==b?b:{})}if(e.data){const t=e.data;w.postData=JSON.stringify(t)}if($.extend(w,getBrowseTypeSpecificData(e)),$.extend(w,(0,_skyward_ui_browseSeekInfo__WEBPACK_IMPORTED_MODULE_12__.setAndGet)(e,p)),!w.hidePrimaryBrowseButton){var y;const e=g&&0===(null===(y=g.primaryKeys)||void 0===y?void 0:y.length);w.hidePrimaryBrowseButton=e}return w}async function get(e,t,n){var a;const o=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!o)return $.Deferred().reject().promise();let r;null!==(a=o.data)&&void 0!==a&&a.filter&&(o.data.filter=(0,_skyward_base_extensions__WEBPACK_IMPORTED_MODULE_5__.encodeHtml)(o.data.filter)),(o.dynamicFilterValues||o.dynamicFilterData)&&(r=await(0,_skyward_base_requestDataHash__WEBPACK_IMPORTED_MODULE_7__.waitForDependencies)(o.dynamicFilterData,(0,_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__.getScopeContainer)(o.browse)));let i=getRequiredBrowseData(o,t,r);n&&(i=$.extend({},i,n)),i.performSearch=void 0===o.getBrowseSearchMode||"Always"===o.getBrowseSearchMode;const s=new URLSearchParams(window.location.search);i.returnSearchCondition="true"===s.get("returnSearchCondition");const l=s.get("browseFilterId");return l&&!isNaN(l)&&(i.browseFilterId=l),requestBrowse(e,o,i,"GetBrowse")}function changeView(e,t,n){const a=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!a)return $.Deferred().reject().promise();const o=getRequiredBrowseData(a,t);let r=o;return $.isEmptyObject(n)||(r=$.extend({},n,o)),r.viewId=null==t?void 0:t.viewId,r.seekId=-1,requestBrowse(e,a,r,"ChangeBrowseView")}function changeFilter(e,t){const n=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!n)return $.Deferred().reject().promise();const a=getRequiredBrowseData(n,t);return a.currentPage=t.currentPage,a.seekId=-1,requestBrowse(e,n,a,"ChangeBrowseFilter")}function updateQuickFilter(e,t){const n=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!n)return $.Deferred().reject().promise();const a=getRequiredBrowseData(n);return a.seekId=-1,a.filter=t,requestBrowse(e,n,a,"UpdateFilterAndView")}function changePage(e,t,n){let a,o=n;if(void 0===o){o=$(e).data(),a=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getContainingBrowse)(e)}else a=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(t);if(!a)return $.Deferred().reject().promise();const r=getRequiredBrowseData(a,o);return r.seekId=-1,r.currentPage=o.currentPage,requestBrowse(a.id,a,r,"ChangeBrowsePage")}function updateDependency(e){var t,n,a,o;let r,i;if(this){i=$(this).data(),r=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getContainingBrowse)(this)}else r=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!r)return $.Deferred().reject().promise();if(null===(t=r.browse)||void 0===t||!t.children().length)return $.Deferred().resolve().promise();null!==(a=(n=r).dynamicFilterValues)&&void 0!==a||(n.dynamicFilterValues={});for(const[e,t]of Object.entries(null!==(s=null===(l=i)||void 0===l?void 0:l.dependencyPostData)&&void 0!==s?s:{})){var s,l;r.dynamicFilterValues[e]=t}const c=getRequiredBrowseData(r,i);return c.seekId=-1,c.currentPage=null===(o=i)||void 0===o?void 0:o.currentPage,"Checkbox"===r.browseType&&(c.resetValues=!0),requestBrowse(r.id,r,c,"ChangeBrowsePage").then(()=>{})}function changeRowsPerPage(e,t){const n=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!n)return $.Deferred().reject().promise();const a=getRequiredBrowseData(n,t);return n.rowsPerPage=t.rowsPerPage,a.rowsPerPage=t.rowsPerPage,requestBrowse(e,n,a,"ChangeBrowseRowsPerPage")}async function resetViewAndFilter(e,t,n,a){const o=$.extend({},a,{browseViewID:e,browseFilterID:t}),r=await $.ajax({url:"".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"SkySys/BrowseView/ResetViewAndFilter"),type:"POST",dataType:"JSON",data:o});r.success&&changeView(n,{viewId:r.browseViewId})}function resizeLockedBrowseBodyForHorizontalScrollBar(e){var t,n;if(null!==(t=e.unlockedBody)&&void 0!==t&&t.length&&null!==(n=e.lockedBody)&&void 0!==n&&n.length){const t=e.unlockedBody,n=e.lockedBody.parent();(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.hasHorizontalScrollBar)(t)?n.css("bottom","".concat(_skyward_window__WEBPACK_IMPORTED_MODULE_4__.scrollbarHeight,"px")):n.css("bottom","0px")}}function performGradebookCodeEELSearch(e,t,n){const a=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!a)return $.Deferred().reject().promise();const o=getRequiredBrowseData(a,t);return $.extend(o,t),o.codeEELSearchText=(0,_skyward_base_extensions__WEBPACK_IMPORTED_MODULE_5__.encodeHtml)(n),requestBrowse(e,a,o,"GradebookCodeEELViewSearchResults")}function performCodeEELSearch(e,t,n){const a=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!a)return $.Deferred().reject().promise();const o=getRequiredBrowseData(a,t);o.codeEELSearchText=(0,_skyward_base_extensions__WEBPACK_IMPORTED_MODULE_5__.encodeHtml)(t.codeEELSearchText);return(void 0===o.seekId||"string"==typeof t.codeEELSearchText)&&(o.seekId=-1,o.pagingType="FirstPage"),requestBrowse(e,a,o,"PerformCodeEELSearch",n)}function performDistinctMultiSelectEELSearch(e,t,n){const a=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!a)return $.Deferred().reject().promise();a.displayName=t.isSingleSelect?"Single Select EEL":"Multi Select EEL";const o=getRequiredBrowseData(a,t);return o.distinctMultiSelectEELSearchText=t.distinctMultiSelectEELSearchText,o.isSingleSelect=t.isSingleSelect,o.allowMassSelect=t.allowMassSelect,requestBrowse(e,a,o,"PerformDistinctMultiSelectEELSearch",n)}function getSelectedRecordValue(e){const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);return null!=t&&t.primaryKeys&&t.primaryKeys.length>t.currentRow?t.primaryKeys[t.currentRow]:null}function shouldIgnoreKeyboardEvent(e){return!!e&&$(e).is("input:not(.eELInputContainer__textBox):not(.distinctMultiSelectUserInput):not(.accountDimensionEELCode), textarea, select, .tabListNavigator *")}function setCurrentBrowseName(e){(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.setCurrentOpenBrowse)(e)&&updateActiveBrowseClasses()}function getBrowseStats(e){return allBrowseStats[e]}function getSql(e){const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!t)return null;if(!t.cachedSql){const e=getRequiredBrowseData(t);t.cachedSql=$.ajax({url:"".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir+t.routeModule,"/").concat(t.routeObject,"/GetBrowseSQL"),activityIndicator:{hideGlass:!0},type:"POST",dataType:"JSON",data:e}).then(function(e){return e.success&&e.query?e.query:"Unable to retrieve query."})}return t.cachedSql}function primaryButtonClick(e,t,n,a,o,r,i,s,l,c,d){if(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.mobileAccess&&!d&&$(null==c?void 0:c.target).closest("a[data-click-action]").length)return;const u=$(null==c?void 0:c.target).closest(".".concat(classNames.button));if(u.length){if(u.hasClass(classNames.uiDisabled))return;u.addClass(classNames.uiDisabled),setTimeout(function(){u.removeClass(classNames.uiDisabled)},500)}skyward.detailsPanel.tryCloseDetailsPanel(function(c){c&&(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.setSkipUnloadCheck)(!0),setCurrentRecord(e,t,{setCurrentBrowseName:!0,loadRelatedBrowses:!0}),""!==n&&""!==a&&""!==o&&""!==r&&(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.loadContent)(n,a,o,r,i,l,null,void 0,null,!1,null,null,s,null,null,void 0,u)})}function bindLockedBodySimulatedFocus(e){const t=".".concat(classNames.unlockedBrowseBody," :focusable, .").concat(classNames.unlockedHeader," :focusable");e.off("focus",t,addSimulatedFocus).on("focus",t,addSimulatedFocus).off("blur",t,removeSimulatedFocus).on("blur",t,removeSimulatedFocus)}function browseLinkColumnPopup(e,t,n,a,o){var r,i,s,l;const c=JSON.parse(null!=o?o:"{}"),d=JSON.parse(null!==(r=c["browse.options"])&&void 0!==r?r:"{}");d.draggable=!0;const u=null!==(i=c["browse.headertext"])&&void 0!==i?i:a,f=c["browse.button"]?JSON.parse(c["browse.button"]):null,h=[];if(null!=f&&f.click){try{const e=window.eval('"use strict";\n('.concat(f.click,")"));f.click="function"==typeof e?e:()=>{}}catch(e){f.click=()=>{}}h.push(f)}const p={id:"cancelButton",text:null!==(s=c["browse.cancelButtonText"])&&void 0!==s?s:_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.ButtonText.Cancel,icon:null!==(l=c["browse.cancelButtonIcon"])&&void 0!==l?l:_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.ButtonIcon.Cancel,click:()=>{m.close("cancel")}};h.push(p);const m=(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.showDialog)(u,function(){return $.ajax({url:"".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir+e,"/").concat(t,"/").concat(n,"?renderType=contentOnly"),type:"POST",dataType:"viewparthtml",data:c})},h,d);function g(e){$(document.body).one("browseLoaded.".concat(e),function(){const t=$("#".concat(e)),n=t.find(".".concat(classNames.browseBody));let a=t.find(".".concat(classNames.unlockedBrowseTable)).height();if(0===a){const e=t.find(".".concat(classNames.noRecordsInBrowse));e.length>0&&(a=e.height())}n.css("max-height","55vh"),n.css("height",a),m.animateModalContents()})}c.browseNameToTriggerResize?g(c.browseNameToTriggerResize):m.bodyPromise.done(function(){m.content.find(".".concat(classNames.browse)).each(function(){g(this.id)})})}function selectRowByElement(e){const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getContainingBrowse)(e),n=$(e).closest(".".concat(classNames.browseRow));if(!t||n.length<1)return;const a=n.find(".".concat(classNames.browseRowOptions,", .").concat(classNames.browseDataCell)).first().data("row");setCurrentRecord(t.id,a)}function addBrowseScrollEvents(e){addBrowseScrollEventsGeneric({unlockedBody:e.unlockedBody,lockedBody:e.lockedBody,unlockedHeader:e.unlockedHeader,totals:e.totals,scrollCallback:function(){updateDropShadows(e)}})}function addBrowseScrollEventsGeneric(e){function t(t,n){function a(){if(n.prop("scrollTop",t[0].scrollTop),t===e.unlockedBody){const n=t[0].scrollLeft;e.unlockedHeader.prop("scrollLeft",n),e.totals&&e.totals.container.prop("scrollLeft",n)}if("function"==typeof e.scrollCallback){for(var a=arguments.length,o=new Array(a),r=0;r<a;r++)o[r]=arguments[r];e.scrollCallback.apply(this,o)}}t.on("scroll",a),t.debounce("scroll",a,50)}t(e.lockedBody,e.unlockedBody),t(e.unlockedBody,e.lockedBody),function(){if(void 0===e.unlockedHeader||void 0===e.unlockedBody)return;e.unlockedHeader.on("focusin",":focusable",function(){const t=e.unlockedBody.get(0),n=t.getBoundingClientRect(),a=this.getBoundingClientRect();a.left<n.left+25?t.scrollLeft-=Math.max(0,n.left+25-a.left):a.right>n.right-25&&(t.scrollLeft+=a.right-(n.right-25)),e.unlockedHeader.prop("scrollLeft",t.scrollLeft),e.totals&&e.totals.container&&e.totals.container.prop("scrollLeft",t.scrollLeft)})}()}function prepMobileBrowseData(e){return $(e.replace(/width:/gi,"x:"))}function applyMobileLockedColumn(e,t,n){const a=$(e);if(!a.length)return;const o=null!=t?t:a.find(".".concat(classNames.browseBody)),r=null!=n?n:a.find(".".concat(classNames.unlockedBrowseBody));let i;const s=a.attr("id"),l="".concat(s,"_mobileBrowseStyles"),c=o.is(":scrollable"),d="#".concat(s,".").concat(mobileBrowseClasses.mobileBrowseContainer),u=[];if($(document.head).find("#".concat(l)).remove(),r.find(".".concat(mobileBrowseClasses.lockedColumnCell)).removeClass(mobileBrowseClasses.lockedColumnCell),r.find("td:first-child").each(function(){const e=$(this);let t=this.id;var n;t||(t="".concat(null===(n=this.parentElement)||void 0===n?void 0:n.id,"_cell").concat(this.cellIndex),this.id=t);void 0===i&&(i=e.outerWidth());const a="".concat(d," .").concat(classNames.browseBody," #").concat(CSS.escape(t)),o=e.closest("tr"),r="".concat(d," .").concat(classNames.browseBody," #").concat(CSS.escape(o[0].id));u.push("".concat(a,", ").concat(a," td, ").concat(r," {height:").concat(o.outerHeight(),"px;}")),e.addClass(mobileBrowseClasses.lockedColumnCell)}),r.children("table").children("thead").children("tr").children("td").each(function(){const e=$(this),t=this.offsetWidth;if(0===this.cellIndex){if(c){const t=e.closest("tr"),n="".concat(d," .").concat(classNames.browseHeader," #").concat(CSS.escape(t[0].id));u.push("".concat(n," {height:").concat(t.outerHeight(),"px;}")),e.addClass(mobileBrowseClasses.lockedColumnCell);const a="".concat(d," .").concat(classNames.unlockedHeader," td:nth-child(").concat(this.cellIndex+1,")");u.push("".concat(a," {position: fixed;background-color: inherit;z-index: 1;height:").concat(e.parent().height(),"px;}"));const o="".concat(d," .").concat(classNames.browseBodyTotalsSectionLocked," td:nth-child(").concat(this.cellIndex+1,")");u.push("".concat(o," {position: fixed;z-index: 1}"))}}else u.push("".concat(d," td:nth-child(").concat(this.cellIndex+1,") {width:").concat(t,"px;min-width:").concat(t,"px;}"))}),u.push("".concat(d," td:nth-child(1) {width:").concat(i,"px;min-width:").concat(i,"px;}")),c){a.find(".".concat(classNames.unlockedHeader," td:first-child")).addClass(mobileBrowseClasses.lockedColumnCell);const e=a.find(".".concat(classNames.browseBodyTotalsSectionLockedWrapper," .").concat(classNames.browseBodyTotalsSection));e.length&&(e.addClass(classNames.browseBodyTotalsSectionLocked),e.css("padding-bottom","".concat(e[0].getBoundingClientRect().height,"px"))),u.push("".concat(d," .").concat(classNames.browseHeader," .").concat(classNames.unlockedHeader," {margin-top:1px;right:").concat(_skyward_window__WEBPACK_IMPORTED_MODULE_4__.scrollbarHeight,"px;}"))}else a.find(".".concat(classNames.browseHeader)).remove(),a.find(".".concat(classNames.browseBodyTotalsSectionLockedWrapper)).remove();_skyward_global__WEBPACK_IMPORTED_MODULE_2__.isIosApp&&u.push("body { transform: -webkit-transform: translate3d(0,0,0); transform: translate3d(0,0,0); }"),$(document.head).append($('<style id="'.concat(l,'" type="text/css">').concat(u.join("\n"),"</style>")))}function getDebugName(e){var t,n;let a=null!==(t=e.displayName)&&void 0!==t?t:"No Name Browse";return void 0!==e.codeEelName&&(a+=" EEL"),"".concat(a,": {").concat(null!==(n=e.skywardID)&&void 0!==n?n:"Custom or On The Fly","}")}function browseColumnSuperUserClick(){const e=$(this);(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.showDialog)("Additional Information","Field visibility is restricted to Super Users.",[_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_CLOSE_BUTTON],{anchorTo:e})}function bindBrowseCleanupEvents(e,t,n,a){if(a){const s=skyward.detailsPanel.eventCallbacks;function l(){(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.removeBrowse)(e),s.empty.deregisterCallback(l)}s.empty.registerCallback(l)}else{var o;null===(o=skyward.window.registerDOMUnloadCallback(n))||void 0===o||o.then(i).catch(()=>{}),$(document.body).on("DOMInsertionPreLoad",r)}function r(e){const t=e.target,a=n.get(0);t&&a&&t.contains(a)&&i()}function i(){(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e)===t&&(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.removeBrowse)(e),skyward.window.removeDOMUnloadCallback(n),$(document.body).off("DOMInsertionPreLoad",r)}}function addSimulatedFocus(){$("#".concat(this.id,"_lockedMirror")).addClass(classNames.simulateFocus),selectRowByElement(this)}function removeSimulatedFocus(){$("#".concat(this.id,"_lockedMirror")).removeClass(classNames.simulateFocus)}function changeRow(e,t,n){if((0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getCurrentBrowseName)()!==e)setCurrentBrowseName(e);else if(t.currentRow===n)return;browseDetailsPanel.tryRowChange(e,function(){setCurrentRecord(e,n,{loadRelatedBrowses:!1,setCurrentBrowseName:!0,updateBrowseSeekInfo:!1})},!1)}function getSearchTextValue(e){const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!t)return"";const n=t.seek,a=t.searchContainer;if(!n||!a||n.hasClass(classNames.noSearchAvailable))return"";let o;switch(a.data("fieldType")){case"date":const e=(0,_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__.getValue)(n);if(!(e instanceof Date&&(0,_skyward_ui_validation__WEBPACK_IMPORTED_MODULE_23__.validDate)(e)))return;o=e.toLocaleDateString("en-US",{month:"2-digit",day:"2-digit",year:"numeric"});break;case"number":if(o=(0,_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__.getValue)(n),!(0,_skyward_ui_validation__WEBPACK_IMPORTED_MODULE_23__.validNumber)(o))return;break;default:o=(0,_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__.getValue)(n)}return o}function browseLoadedSuccess(browse,data,localStopwatch,totalStopwatch,downloadTime,doRequest){var _browse$body;const browseStats={};browseStats["Server Response"]=downloadTime,browseStats["DOM Insertion"]=localStopwatch.duration(),localStopwatch.restart();let script=data.script;const urlInText=/\n\/\/# (sourceMappingURL|sourceURL)[^\n]*\n?$/.test(script);urlInText||(script+="\n//# sourceURL=registerBrowse_".concat(browse.id,"_eval.js")),(0,_skyward_ui_events__WEBPACK_IMPORTED_MODULE_20__.reapplyLoadActionClasses)($("#".concat(browse.id))),eval(script),(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.notifyDOMLoad)("#".concat(browse.id)),browseStats["Script Execution"]=localStopwatch.duration(),browseStats.Total=totalStopwatch.duration(),allBrowseStats[browse.id]=browseStats,browseDetailsPanel.currentDetailsBrowse===browse.id&&($("#".concat(browse.id," .").concat(classNames.browseRow,".").concat(classNames.noRecordsInBrowse)).length||null!==(_browse$body=browse.body)&&void 0!==_browse$body&&_browse$body.find(".".concat(classNames.cmaErrorMessage)).length)&&browseDetailsPanel.hideDetailsPanel(!1),null==browse.currentRow&&browse.relatedBrowses&&$.each(browse.relatedBrowses,function(e,t){getRelatedBrowse(t.BrowseID)}),-1!==browse.refreshTimeout&&(null!==refreshTimeout&&clearTimeout(refreshTimeout),browse.timestamp=0,refreshTimeout=window.setTimeout(doRequest,browse.refreshTimeout))}function browseResize(e){var t,n,a,o,r,i;const s=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!s)return;const l=s.browse,c=null!==(t=s.lockedBody)&&void 0!==t?t:$(),d=null!==(n=s.unlockedBody)&&void 0!==n?n:$(),u=null!==(a=s.unlockedHeader)&&void 0!==a?a:$(),f=null!==(o=s.lockedHeader)&&void 0!==o?o:$(),h=null!==(r=s.baseErrorDiv)&&void 0!==r?r:$();let p;if(h.length>0){var m;let e=0;const t=(0,_skyward_ui_contentMessageArea__WEBPACK_IMPORTED_MODULE_15__.getContentMessageArea)($("#".concat(s.id)).parent()),n=null==t?void 0:t.getContentMessageAreaElement();void 0!==n&&(e=n.height());const a=(null!==(m=h.outerHeight(!0))&&void 0!==m?m:0)+e;null==l||l.css({top:"".concat(a,"px")})}f.height(u.height()),s.resize=function(){browseResize(e)},resizeLockedBrowseBodyForHorizontalScrollBar(s),null!==(i=s.totals)&&void 0!==i&&i.container.length&&s.totals.container.find(".".concat(classNames.browseBodyTotalScrollbarFiller)).css("width","".concat(_skyward_window__WEBPACK_IMPORTED_MODULE_4__.scrollbarHeight,"px"));const g=c.find(".".concat(classNames.browseRow));if(g.length>0){const e=[],t=d.find(".".concat(classNames.browseRow));for(p=0;p<t.length;p++){const n=t[p],a=g[p];if(!a)break;{const t=n.getBoundingClientRect().height,o=a.getBoundingClientRect().height;t!==o&&e.push(t>o?{height:t,elem:a}:{height:o,elem:n})}}for(const t of e)$(t.elem).css("height","".concat(t.height,"px"))}null==l||l.trigger("browseResize.".concat(e))}function getRelatedBrowses(e){const t=[];return $.each(e.relatedBrowses,function(e,n){const a=getRelatedBrowse(n.BrowseID);t.push(a)}),$.when.apply($,t)}function getCurrentRecordTargetId(e){const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!t)return null;const n=getUnlockedRowElement(t);return 0===n.length?null:n.data("targetid")}function noColumnsInsertColumnButtonClick(){const e=$(this);popInsertColumnView((0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getContainingBrowse)(e),-1,e)}function updateDropShadows(e){var t,n;const a=null!==(t=e.hasShadow)&&void 0!==t&&t,o=0!==(null===(n=e.unlockedBody)||void 0===n?void 0:n.scrollLeft());var r,i;o!==a&&(null===(r=e.lockedBody)||void 0===r||r.toggleClass(classNames.lockedBrowseShadow,o),null===(i=e.lockedHeader)||void 0===i||i.toggleClass(classNames.lockedBrowseShadow,o),e.totals&&e.totals.container.toggleClass(classNames.lockedBrowseShadow,o));e.hasShadow=o}function updateActiveBrowseClasses(){let e=$(".".concat(classNames.modalLayerContainer)).last();0===e.length&&(e=$("#master"));const t=[];e.find(".".concat(classNames.browse)).each(function(){t.push($(this))});const n=e.find(".".concat(classNames.mainSelectedBrowse)),a=findActiveBrowseInLayer(t);0!==n.length&&n.attr("id")===(null==a?void 0:a.attr("id"))||(n.removeClass(classNames.mainSelectedBrowse),a&&a.addClass(classNames.mainSelectedBrowse),eventCallbacksInternal.updateActiveBrowseClasses.dispatchCallbacks())}function findActiveBrowseInLayer(e){if(e.length>0){const t=e[0].attr("id");let n=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.indexOfOpenBrowse)(t),a=e[0];for(let t=1;t<e.length;t++){const o=e[t].attr("id"),r=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.indexOfOpenBrowse)(o);r>n&&(n=r,a=e[t])}return a}return null}function deselectPreviousRecord(e){const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);t&&getRowElements(t).removeClass(classNames.current).attr("aria-selected",null)}function isDeselectPreviousRecordOverridden(e){const t=deselectPreviousRecordOverrides[e];return void 0!==t&&!t(e)}function getIdentityFieldValuesBasedOnType(e,t){return"FollowingPage"===e?t.lastRowIdentityFieldValues:"PrecedingPage"===e?t.firstRowIdentityFieldValues:null}function browseHeaderColumnClick(){var e;const t=$(this),n=t.data();if(null==n)return;const a=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getContainingBrowse)(this);if(!a)return;const o=n.columnViewIndex,r=getRequiredBrowseData(a,n);r.seekId=-1;const i={browseName:a.browseName,routeModule:a.routeModule,routeObject:a.routeObject,dataModule:a.dataModule,dataObject:a.dataObject,pageModule:a.pageModule,pageObject:a.pageObject,pageScreen:a.pageScreen,taskName:a.taskName,routeHash:a.routeHash,columnViewIndex:o,fieldName:n.sortField,browseSearchCondition:a.browseSearchCondition,browseSearchConditionHash:a.browseSearchConditionHash,userSearchCondition:a.userSearchCondition,userSearchConditionHash:a.userSearchConditionHash,preventColumnSort:a.preventColumnSort,preventColumnResize:a.preventColumnResize,renderFilterOptions:!a.isCodeEel&&a.renderFilterButton};let s,l;null!==(e=a.data)&&void 0!==e&&e.browseViewEditorHash?(s="".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"Skysys/Filter/BuildColumnFilterViewpartForBrowseViewEditor/"),i.postData=JSON.stringify(a.data),l="Options"):(s="".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"skysys/filter/buildcolumnfilterviewpart/"),i.browseTempTableName=a.tempTableName,l="Column Options");const c=t.find(".".concat(classNames.svg,".").concat(classNames.settingsIcon,".").concat(classNames.svgBrowseColumnHeader)),d={id:"saveColumnFilter",text:_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.ButtonText.Save,icon:_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.ButtonIcon.Save,click:()=>{saveColumn(a.id,a,r,n.sortField,h)}},u={id:"cancelColumnFilter",text:_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.ButtonText.Cancel,icon:_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.ButtonIcon.Cancel,click:()=>{h.close("cancel")}},f={afterClose:()=>{c.css("visibility","")},anchorTo:_skyward_global__WEBPACK_IMPORTED_MODULE_2__.mobileAccess?null:t,id:"BrowseColumnOptionsModal"},h=(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.showDialog)(l,function(){return $.ajax({url:s,type:"POST",dataType:"viewparthtml",activityIndicator:{hideGlass:!0},data:$.extend({},r,i)})},[d,u],f);c.css("visibility","visible"),h.content.on("contentLoaded",function(){h.content.find(".".concat(classNames.insertColumnButton)).on("click",function(){h.close(),popInsertColumnView(a,o,t)}),h.content.find(".".concat(classNames.deleteColumnButton)).on("click",function(){h.close(),deleteColumn(a,n.sortField,o)})})}function saveColumn(e,t,n,a,o){saveColumnData(t).then(function(r){r.success?(saveColumnFilter(e,t,n,a),o.close()):(0,_skyward_ui_validation__WEBPACK_IMPORTED_MODULE_23__.displayValidationMessages)(r,"BrowseColumnOptions",$("#BrowseViewColumnOptionsBaseErrors"))})}function saveColumnData(e){var t;const n={headerText:$("#BrowseColumnOptions_HeaderText").val(),width:$("#BrowseColumnOptions_Width").val(),columnIndex:$("#BrowseColumnOptions_ColumnIndex").val(),locked:$("#BrowseColumnOptions_Locked").is(":checked"),wrapData:$("#BrowseColumnOptions_WrapData").is(":checked"),columnViewIndex:$("#BrowseColumnOptions_ColumnViewIndex").val(),visibilityRestrictedToSuperUsers:(0,_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__.getValue)($("#BrowseColumnOptions_SuperUserVisibility"))};let a;return null!==(t=e.data)&&void 0!==t&&t.browseViewEditorHash?(a="".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"Skysys/BrowseView/UpdateBrowseViewEditorBrowseColumn/"),n.postData=JSON.stringify(e.data)):(a="".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"Skysys/BrowseView/UpdateBrowseColumn/"),n.pageModule=e.pageModule,n.pageObject=e.pageObject,n.pageScreen=e.pageScreen,n.pageTab=e.pageTab,n.browseName=e.browseName,n.taskName=e.taskName),$.ajax({url:a,type:"POST",dataType:"JSON",activityIndicator:{hideGlass:!0},data:n})}function saveColumnFilter(e,t,n,a){var o;const r=(0,_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__.getValue)($(".".concat(classNames.saveColumnFilterSort))),i=(0,_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__.getValue)($(".".concat(classNames.saveBoolFilterSort))),s=$("#filterSection").data("data-type"),l={},c="null"===r?null:"descending"===r;let d;if(i.length?(d="bool",l.TrueOnly="trueOnly"===i||"falseOnly"!==i&&null,l.FilterType=null!==l.TrueOnly?"selection":"none"):(d="Enumeration"===s?"selection":(0,_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__.getValue)($("#rangeOrSelect")),l.FilterType=d),"range"===d){const e=$("#txtLowRange"),t=$("#txtHighRange");l.RangeLow=(0,_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__.getValue)(e),l.RangeHigh=(0,_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__.getValue)(t),(0,_skyward_base_time__WEBPACK_IMPORTED_MODULE_8__.isDate)(l.RangeLow,!1)&&(l.RangeLow=(0,_skyward_base_time__WEBPACK_IMPORTED_MODULE_8__.formatServerDate)(l.RangeLow)),(0,_skyward_base_time__WEBPACK_IMPORTED_MODULE_8__.isDate)(l.RangeHigh,!1)&&(l.RangeHigh=(0,_skyward_base_time__WEBPACK_IMPORTED_MODULE_8__.formatServerDate)(l.RangeHigh))}else if("selection"===d){const e=$("#selectFilterSection .".concat(classNames.dmsBackingData)),t=(0,_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__.getValue)(e);l.DmsJson=JSON.stringify(t).replaceAll(new RegExp(/(\\+r\\+n)/,"g"),"\\r\\n")}const u={};u[a]=l,n.filter=JSON.stringify(u);const f={};let h;if(f[a]=c,n.sort=JSON.stringify(f),null!==(o=t.data)&&void 0!==o&&o.browseViewEditorHash){h="UpdateBrowseViewEditorView",n.postData=JSON.stringify(t.data);(0,_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__.getOriginalValue)($(".".concat(classNames.saveColumnFilterSort)))!==r&&(n.browseViewSortChange=!0)}else h="UpdateFilterAndView";return requestBrowse(e,t,n,h)}function performSearch(e,t){const n=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!n)return;const a=getRequiredBrowseData(n,t);return a.seekId=-1,requestBrowse(e,n,a,"PerformBrowseSearch")}function initActiveBrowseClass(e){$(e).hasClass(classNames.browse)&&updateActiveBrowseClasses()}function initSortableColumns(e){$(e).find(".".concat(classNames.allowColumnSort)).each(function(){const e=$(this),t=e.find(".".concat(classNames.browseHeaderDraggable));if(t.length<=1)return;const n=e.closest(".".concat(classNames.browseHeader)),a=n.siblings(".".concat(classNames.browseBody)),o=a.find(".".concat(classNames.lockedBrowseBody)),r=a.find(".".concat(classNames.unlockedBrowseBody)),i=e.hasClass(classNames.lockedHeaderTableRow),s=i?n.find(".".concat(classNames.unlockedHeaderTableRow)):e,l={};for(let p=0;p<t.length;p++){const m=$(t[p]).data().columnIndex,g="[data-column-index='".concat(m,"']"),w=t.filter(g),v=t.filter(g),b=v.first().data().columnIndex,y=v.last().data().columnIndex;if(l[m]={startingIndex:b,endingIndex:y},w.length>1){const _=$("<td/>",{class:"browseHeaderDraggable groupColumnWrapper",data:{fieldName:w[0].dataset.groupColumnName,columnIndex:m,groupColumn:!0,numberOfColumns:v.length}});v.replaceTagNames("div"),v.wrapAll(_),p+=w.length-1}}if(e.sortable({axis:"x",opacity:.7,distance:15,scroll:!1,forcePlaceholderSize:!0,items:"> .".concat(classNames.browseHeaderDraggable),cancel:".".concat(classNames.browseColumnFilterMenuLaunch),helper:function(e,t){const n=$(t).clone(),a=n.find(".".concat(classNames.iconContainerDiv));return a.length&&a.children().remove(),n},placeholder:"browseHeaderColumn browseColumnSortablePlaceHolder",start:function(t,n){e.sortable("refreshPositions"),function(e,t){const n=t.item.data().columnIndex;i&&(d(n,o),u(n,o,t,!0),a=n,s.find("[data-field-index='".concat(a,"']")).addClass(classNames.columnDragging),h(n,t,!0));var a;d(n,r),u(n,r,t,!0)}(0,n)},update:function(t,n){var a,o,r,i,s;e.sortable("option","disabled",!0);const l=n.item,c=n.item.prev(),d=l.data(),u=c.data(),f=d.columnIndex,h=null!==(a=u.columnIndex)&&void 0!==a?a:null,p=d.fieldName,m=null!==(o=u.fieldName)&&void 0!==o?o:null,g=e.data("browseId"),w=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(g);null!==(r=w.columnFieldNames)&&void 0!==r||(w.columnFieldNames=[]);const v=w.columnFieldNames.splice(f,1)[0];let b=null!=h?h:-1;b<f&&(b+=1),w.columnFieldNames.splice(b,0,v),null!==(i=w.totals)&&void 0!==i&&i.container.length&&function(){const e=w.totals.container,t=e.find(".".concat(classNames.browseBodyTotalColumn,"[data-column='").concat(f,"']")),n=null!==h?e.find(".".concat(classNames.browseBodyTotalColumn,"[data-column='").concat(h,"']")):e.find(".".concat(classNames.browseBodyTotalButtonsFiller));n.after(t),t.hasClass(classNames.browseBodyLockedTotalColumn)?(t.add(n).removeClass(classNames.browseBodyShadowColumn),e.find(".".concat(classNames.browseBodyLockedTotalColumn)).last().addClass(classNames.browseBodyShadowColumn)):t.add(t.next()).css("margin-left","");updateTotalColumnOffsets(e.find(".".concat(classNames.browseBodyTotalColumn,", .").concat(classNames.browseBodyTotalButtonsFiller)),0)}();const y=e.closest(".".concat(classNames.browse)).data(),_=getRequiredBrowseData(w,y);let C="ChangeBrowseColumnOrder";null!==(s=w.data)&&void 0!==s&&s.browseViewEditorHash&&(_.postdata=w.data,C="ChangeBrowseViewEditorColumnOrder"),_.currentColumnIndex=f,_.newPrecedingColumnIndex=h,_.currentFieldName=p,_.newPrecedingFieldName=m,requestBrowse(g,w,_,C)},change:function(e,t){!function(e,t){let n,a=t.placeholder.prev(".".concat(classNames.browseHeaderDraggable)),s=!1;a.length>0?(n=a.data().columnIndex,s=!0):(a=t.placeholder.next(".".concat(classNames.browseHeaderDraggable)),n=a.data().columnIndex);i&&(c(o),u(n,o,t,s),f(),h(n,t,s));c(r),u(n,r,t,s)}(0,t)},stop:function(){!function(){i&&(c(o),o.find(".".concat(classNames.columnDragging)).removeClass(classNames.columnDragging),f(),s.find(".".concat(classNames.columnDragging)).removeClass(classNames.columnDragging));c(r),r.find(".".concat(classNames.columnDragging)).removeClass(classNames.columnDragging)}()}}),!i){const C=e.closest(".".concat(classNames.browse)).find(".".concat(classNames.unlockedBrowseBody)),k=e.closest(".".concat(classNames.unlockedHeader)),S=k.siblings(".".concat(classNames.lockedHeader));let D=0;S.length>0&&(D=S.width());let E,P=!1;function O(e){if(0===k.length)return;const t=e.originalEvent,n=k.offset().left+D,a=n+k.width()-D;let o=0,r=1;const i=25;if(t.pageX<n+i&&t.pageX>n-i?(o=n-(t.pageX-i),r=-1):t.pageX<a+i&&t.pageX>a-i&&(o=t.pageX-(a-i),r=1),0!==o){const e=1.75,t=.1;P=!0,clearTimeout(E),B(Math.pow(Math.abs(o),e)*t*r)}else P=!1}function B(e){P&&(C.scrollLeft(C.scrollLeft()+e),E=window.setTimeout(function(){B(e)},10))}e.on("sort",O),e.on("focusin",t=>{const n=e.closest(".".concat(classNames.browse)).find(".".concat(classNames.unlockedBrowseBody)),a=e.closest(".".concat(classNames.unlockedHeader)),o=a.siblings(".".concat(classNames.lockedHeader));window.setTimeout(()=>{const e=$(t.target).parent().parent().get(0);if(null==e)return;const r=n.get(0),i=o.get(0);if(!r||!i)return;const s=r.getBoundingClientRect(),l=e.getBoundingClientRect(),c=Math.round(r.scrollLeft+(l.left-s.left)),d=c+Math.round(l.width),u=Math.max(0,r.scrollWidth-r.clientWidth),f=o&&o.length?Math.round(o[0].getBoundingClientRect().width):0;let h=r.scrollLeft;c<r.scrollLeft+f+8?h=Math.max(0,Math.round(c-f-8)):d>r.scrollLeft+r.clientWidth-8&&(h=Math.min(u,Math.round(d-(r.clientWidth-8)))),Math.abs(h-r.scrollLeft)>=1&&(r.scrollLeft=h,null==a||a.prop("scrollLeft",h),null==o||o.prop("scrollLeft",h))},0)})}function c(e){e.find(".".concat(classNames.browseBodySortablePlaceholder)).remove()}function d(e,t){const n=function(e,t){const n=t.find(".".concat(classNames.browseRow)),a=l[e];return n.find(function(e){const t=[];for(let n=e.startingIndex;n<=e.endingIndex;n++)t.push(".browseDataCell[data-column='".concat(n,"']"));return t.join(", ")}(a))}(e,t);n.addClass(classNames.columnDragging)}function u(e,t,n,a){const o=l[e],r=n.placeholder.clone().addClass(classNames.browseBodySortablePlaceholder);t.find(".".concat(classNames.browseRow)).each(function(){const e=$(this).find(".".concat(classNames.browseDataCell,"[data-column='").concat(o.endingIndex,"']"));a?e.last().after(r.clone()):e.first().before(r.clone())})}function f(){s.find(".".concat(classNames.browseHeaderDraggablePlaceholder)).remove()}function h(e,t,n){const a=s.find("[data-field-index='".concat(e,"']"));n?a.after(t.placeholder.clone().addClass(classNames.browseHeaderDraggablePlaceholder)):a.before(t.placeholder.clone().addClass(classNames.browseHeaderDraggablePlaceholder))}})}function exportBrowse(){const e=$(this),t=e.closest(".".concat(classNames.dataObjectViewer));let n;if(t.length>0&&(0,_skyward_ui_changeTracking__WEBPACK_IMPORTED_MODULE_13__.isDirty)(t)){const e=[{text:"Export without Saving",icon:_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.ButtonIcon.Check,click:a},{text:_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.ButtonText.Cancel,icon:_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.ButtonIcon.Cancel}];n=(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.showCriticalDialog)("Warning",'<span style="font-weight:bold">Are you sure you want to export without saving?</span>\nAny unsaved changes will not be included in the export.',e,{})}else a();function a(){var t;null===(t=n)||void 0===t||t.close();const a=_skyward_window__WEBPACK_IMPORTED_MODULE_4__.skipUnloadCheck;(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.setSkipUnloadCheck)(!0),transformBrowse(e,"GetBrowseExport",{openNewWindow:!1,downloadOnMobile:!0}),(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.setSkipUnloadCheck)(a)}}function showAuditLegend(){const e=$(this);(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.showDialog)("Legend",function(){return $.ajax({url:"".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"SkySys/Browse/AuditBrowseLegend/"),type:"POST",dataType:"viewparthtml",activityIndicator:{hideGlass:!0}})},[_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_CLOSE_BUTTON],{anchorTo:e})}function transformBrowse(e,t,n){var a,o;const r=e.data();if($.isEmptyObject(r))return;const i=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(r.browseId);if(!i)return;const s=$.extend({},r,getRequiredBrowseData(i,{}));n.openNewWindow&&(s.selectMode=void 0);const l=null!==(a=null===(o=i.columnFieldNames)||void 0===o?void 0:o.length)&&void 0!==a?a:0,c=1048576;function d(){const e="".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir).concat(i.routeModule,"/").concat(i.routeObject,"/").concat(t);(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.submitForm)(e,s,n)}"XLSX"===r.exportType?0===l?(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.showErrorDialog)("Unable to export to XLSX when the list has zero columns.","Please add columns and try exporting again, or export as a CSV instead."):l>16384?(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.showErrorDialog)("Unable to export to XLSX when the list has more than ".concat(16384..toLocaleString()," columns."),"Please remove columns and try exporting again, or export as a CSV instead."):getBrowseRowCount(i,s).then(function(e){e>c?(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.showErrorDialog)("Unable to export to XLSX when the list has more than ".concat(c.toLocaleString()," rows."),"Please filter the list to reduce the number of rows, or export as a CSV instead."):d()}):d()}async function getBrowseRowCount(e,t){if(null!==e.rowCount&&void 0!==e.rowCount)return e.rowCount;const n=await $.ajax({url:"".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir).concat(e.routeModule,"/").concat(e.routeObject,"/GetRecordCount"),type:"POST",dataType:"JSON",data:t,activityIndicator:{hideGlass:!0}});return e.rowCount=n.RecordCount,e.rowCount}function wireUpExpandCollapseBrowseButton(e){const t=e.attr("id");e.find(".".concat(classNames.expandCollapseBrowsePanel)).each(function(){const e=$(this),n=e.closest(".".concat(classNames.bottomCollapsibleBrowseContainer)),a=n.siblings(".".concat(classNames.topExpandableBrowseContainer)),o=a.find(".".concat(classNames.browse)),r=o.attr("id");function i(){e.on("click",function(){const t=n.hasClass(classNames.bottomBrowsesCollapsed);skyward.detailsPanel.tryCloseDetailsPanel(function(a){var o,r;a&&(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.setSkipUnloadCheck)(!0),o=t,$.ajax({url:"".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"SkySys/Browse/UpdateCollapsibleBrowseState"),type:"POST",dataType:"JSON",activityIndicator:{hideGlass:!0},data:{IsNormalHeight:o}}),n.trigger("BrowseExpandCollapseEvent",t),r=t,e.find("svg").replaceWith((0,_skyward_ui_svg__WEBPACK_IMPORTED_MODULE_21__.getSvg)(r?"ChevronDown":"ChevronUp","BrowseExpandCollapse"))})})}n.off("BrowseExpandCollapseEvent.".concat(t)).on("BrowseExpandCollapseEvent.".concat(t),function(t,s){if(n.length>0){if(n.find(".".concat(classNames.mainSelectedBrowse)).length>0){const e=n.prev().find(".".concat(classNames.browse)).first().attr("id"),t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(t){const n={loadRelatedBrowses:!1,updateBrowseSeekInfo:!1,setCurrentBrowseName:!0};setCurrentRecord(e,t.currentRow,n)}}!function(t){let s,l;e.off("click"),t?(s=a.switchClass("topBrowseExpanded","topBrowseNormalHeight","fast").promise(),l=n.switchClass("bottomBrowsesCollapsed","bottomBrowsesNormalHeight","fast",void 0,function(){$(window).trigger("resize")}).promise()):(s=a.switchClass("topBrowseNormalHeight","topBrowseExpanded","fast").promise(),l=n.switchClass("bottomBrowsesNormalHeight","bottomBrowsesCollapsed","fast",void 0,function(){n.find(".".concat(classNames.selectedDetailsRow)).length>0&&browseDetailsPanel.refreshDetailsPanel(r)}).promise());$.when(s,l).done(function(){!function(e){const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(r);e.css("overflow",""),i(),resizeLockedBrowseBodyForHorizontalScrollBar(t),function(){const e=o.find(".".concat(classNames.lockedBrowseBody," .").concat(classNames.current,", .").concat(classNames.unlockedBrowseBody," .").concat(classNames.current));0!==e.length&&e.each(function(){this.scrollIntoView()})}()}(n)})}(s)}}),i()})}function initMobileBrowse(e,t,n){var a;if(!t||t.startsWith("<input")||e.find(".".concat(mobileBrowseClasses.mobileBrowseBody)).length)return Promise.resolve();let o;e.html(""),e.removeClass([mobileBrowseClasses.mobileBrowseContainer,mobileBrowseClasses.hasHeaderShadow,mobileBrowseClasses.hasColumnShadow].join(" ")),e.is(":visible")||(o=$("<div>",{css:{display:"none"}}),o.insertBefore(e),e.appendTo(document.body));const r=function(){const{html:n,loaded:a}=(0,_skyward_global__WEBPACK_IMPORTED_MODULE_2__.processViewPartHtmlSeparately)(prepMobileBrowseData(t)),o=$("<div>").append(n);o.find("#browse_lockedHeader, .".concat(classNames.lockedBrowseBodyScrollWrapper,", .").concat(classNames.browseHeaderSpacer)).remove();((0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.getClosestContentPanel)(e).find(".".concat(classNames.browse)).length<=1||e.hasClass(classNames.hideHeaderMobile))&&o.find(".".concat(classNames.browseSectionHeader)).closest(".".concat(classNames.containerToolbar)).remove();$("<thead>".concat(o.find(".".concat(classNames.unlockedHeader," tbody")).html(),"</thead>")).insertBefore(o.find(".".concat(classNames.appendMobileBrowseHeader)));const r=o.find(".".concat(classNames.browseBodyTotalsSection));if(r.length){$("<tfoot>",{class:r.attr("class")}).append(r.find("tr").clone()).insertAfter(o.find(".".concat(classNames.appendMobileBrowseFooter)))}return e.addClass(mobileBrowseClasses.mobileBrowseContainer),e.append(o.children()),a}();void 0!==(null===(a=n.totals)||void 0===a?void 0:a.data)&&displayBrowseTotals(n,e.find(".".concat(classNames.browseBodyTotalsSection)));const i=e.find(".".concat(classNames.browseBody)),s=e.find(".".concat(classNames.unlockedBrowseBody));i.addClass(mobileBrowseClasses.mobileBrowseBody),function(){const t=s.find(".".concat(classNames.unlockedBrowseTable))[0];if(!t)return;const n=[];let a=!1;for(const e of t.rows){const t=$(e.cells[0]);if(o(t)){a=!0;break}n.push(t)}if(!a){const t=e.find(".".concat(classNames.browseHeader," > .").concat(classNames.unlockedHeader," > table"))[0];void 0!==t&&t.rows.length>0&&t.rows[0].cells.length>0&&n.push($(t.rows[0].cells[0])),n.map(function(e){e.remove()})}function o(e){return e.length&&(e.text().trim().length||e.find("svg,img,:input:not([type=hidden])").length)}}(),s.find(".".concat(classNames.svg,".").concat(classNames.newWindow)).each(function(){$(this).closest(".".concat(classNames.svgAnchor)).remove()}),s.find("svg.".concat(classNames.rowAction)).each(function(){const e=$(this).parent(".".concat(classNames.svgAnchor));if(!e.length)return;let t=e.attr("onclick");e.closest("td").find(".".concat(classNames.svgAnchor)).not(e).each(function(){var e;const n=$(this),a=this.id,o=n.find("use").attr("href"),r=null===(e=/#svg-(\w+)/.exec(o))||void 0===e?void 0:e[1];let i=n.find(".".concat(classNames.anchorText)).text();if(""===i)switch(r){case"RowOpen":i="Details";break;case"RunReport":i="Run Report";break;case"Info":i="Info";break;default:i=r}const s={text:i,icon:r,data:{"click-target-id":a}};t=t.replace("skyward.browse.rowPopupMenu([","skyward.browse.rowPopupMenu([".concat(JSON.stringify(s),",")),n.hide()}),e.attr("onclick",t)}),applyMobileLockedColumn(e,i,s),s.on("scroll",function(){c(mobileBrowseClasses.hasColumnShadow,this.scrollLeft,e)}),i.on("scroll",function(){c(mobileBrowseClasses.hasHeaderShadow,this.scrollTop,e)}),$(window).on("orientationchange",function(){$(document.body).addClass(classNames.translateZ),window.setTimeout(function(){$(document.body).removeClass(classNames.translateZ)},10)}),$().add(i.find(".".concat(classNames.unlockedHeaderTableRow))).add(e.find(".".concat(classNames.browseHeader))).on("click",".".concat(classNames.browseHeaderColumn),function(){const e=$(this),t=e.find(".".concat(classNames.browseColumnFilterMenuLaunch));if(t.length)return void browseHeaderColumnClick.apply(t);const n=e.find(".".concat(classNames.browseColumnHeaderSort));n.length&&changeSort.apply(n)}),e.find(".".concat(classNames.unlockedHeader)).trigger("swipe",function(e,t,n,a){let o=a;switch("right"===n&&(o*=-1),t){case"start":l.origScroll=s.stop().scrollLeft(),l.isScrollable=s.is(":scrollable"),l.distances=[],l.times=[];break;case"move":if("right"!==n&&"left"!==n)return;if(!l.isScrollable)return;s.scrollLeft(l.origScroll+o),window.cancelTouchSwipe=!0,i(l.distances,o),i(l.times,(new Date).getTime());break;case"end":case"cancel":{s.on("touchstart",r);const e=function(e,t){let n=0;if(2===e.length&&2===t.length){const a=(e[1]-e[0])/(t[1]-t[0]),o=150;n=Math.min(4*o,a*o)||0}return n}(l.distances,l.times);0!==e&&s.stop().animate({scrollLeft:s.scrollLeft()+e},800,"easeOutExpo",function(){s.off("touchstart",r)});break}}function r(){s.stop()}function i(e,t){e.length>1&&e.shift(),e.push(t)}}),o&&(e.insertAfter(o),o.remove());const l={origScroll:void 0,isScrollable:void 0,distances:[],times:[]};return r;function c(e,t,n){t>0?n.hasClass(e)||(n.css("willChange","box-shadow"),n.addClass(e),n.css("willChange","")):n.hasClass(e)&&(n.css("willChange","box-shadow"),n.removeClass(e),n.css("willChange",""))}}function getBrowseTypeSpecificData(e){const t=e.browseType,n={browseType:t};return"Editable"===t?$.extend(n,(0,_skyward_ui_editableBrowse__WEBPACK_IMPORTED_MODULE_19__.getData)(e)):"DistinctMultiSelect"===t?$.extend(n,(0,_skyward_ui_distinctMultiSelectEEL__WEBPACK_IMPORTED_MODULE_18__.getData)(e)):"Checkbox"===t&&$.extend(n,(0,_skyward_ui_checkboxBrowse__WEBPACK_IMPORTED_MODULE_14__.getData)(e)),n}function getRelatedBrowse(e){var t;const n=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!n)return $.Deferred().reject().promise();if(!(n.browse&&n.browse.length>0&&$.contains(document.body,n.browse[0])))return $.Deferred().reject().promise();const a=getParentBrowse(n),o=0===a.primaryKeys.length,r=getCurrentRecordTargetId(a.browseName);null!==(t=n.totals)&&void 0!==t&&t.container.length&&(n.totals.data=void 0,void 0!==n.totals.ajaxRequest&&(n.totals.ajaxRequest.abort(),n.totals.ajaxRequest=void 0));return get(e,{seekId:-1,pagingType:"FirstPage",isRelatedBrowse:"true",hidePrimaryBrowseButton:o,parentPrimaryKeyID:r,parentBrowseRequestDataHash:a.requestDataHash})}function shouldProcessMobileBrowse(e){let t=_skyward_global__WEBPACK_IMPORTED_MODULE_2__.mobileAccess;if(e){var n;const a=null!==(n=e.browse)&&void 0!==n?n:$("#".concat(e.id));("Tile"===e.browseType||a.length&&a.is("[data-skip-mobile-processing]"))&&(t=!1)}return t}function requestBrowse(e,t,n,a,o){const r=$.Deferred();isInWorkflow(t)&&(0,_skyward_ui_workflow__WEBPACK_IMPORTED_MODULE_24__.addDisableNavigationPromise)(r,!1);const i=null!=n.codeEelName,s=getCurrentBrowse(),l=!i&&browseDetailsPanel.currentDetailsBrowse===n.browseName||t.relatedBrowses&&s&&t.relatedBrowses.some(e=>e.BrowseID===s.browseId);return l?skyward.detailsPanel.tryCloseDetailsPanel(function(e){return e&&(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.setSkipUnloadCheck)(!0),c()}):c();function c(){var i;if(null!==t.currentRow){const t=$("#".concat(e,"_newButton"));if(t.length>0){const e=t.data();$.isEmptyObject(e)||(n.pageStateControlValues=JSON.stringify(e))}}const s=(0,_skyward_base_time__WEBPACK_IMPORTED_MODULE_8__.stopwatch)(),d=(0,_skyward_base_time__WEBPACK_IMPORTED_MODULE_8__.stopwatch)();null!==(i=t.timestamp)&&void 0!==i||(t.timestamp=0);const u=t.browse?t.browse.closest(".".concat(classNames.repeater)):$();if(u.length){var f;const e=null!==(f=u.data("renderedBrowses"))&&void 0!==f?f:{};e[t.routeHash]?n.isRepeatedBrowse=!0:(e[t.routeHash]=!0,u.data("renderedBrowses",e))}const h="".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir).concat(t.routeModule,"/").concat(t.routeObject,"/").concat(a);n.hidePreviewDetailsButton=!!t.hidePreviewDetailsButton||skyward.detailsPanel.containsElement(t.browse),n.detailsPanelType=t.detailsPanelType;const p=(0,_skyward_base_time__WEBPACK_IMPORTED_MODULE_8__.stopwatch)(),m=$.ajax({url:h,type:"POST",dataType:"JSON",data:n,activityIndicator:{hideGlass:!0},signal:o,error:function(e,t,a){var o;(console.error("AJAX error:",t,a,e.responseText),n.returnSearchCondition)&&(null===(o=window.parent)||void 0===o||o.postMessage({type:"forbidden",data:{error:"Unable to retrieve browse."}},"*"))},success:function(o){var i,l;if(n.returnSearchCondition)return null!=o&&o.success?void(null===(i=window.parent)||void 0===i||i.postMessage({type:"gatherSearchCondition",data:{condition:null==o?void 0:o.condition,conditionHash:null==o?void 0:o.conditionHash,browseFilterID:n.browseFilterId,pageModule:n.pageModule,pageObject:n.pageObject,dataModule:n.dataModule,dataObject:n.dataObject,routeModule:n.routeModule,routeObject:n.routeObject,browseName:n.browseName}},"*")):void(null===(l=window.parent)||void 0===l||l.postMessage({type:"cannotRecover"},"*"));const u=p.duration();if(!o)return void(0,_skyward_error__WEBPACK_IMPORTED_MODULE_1__.reportException)(new _skyward_error__WEBPACK_IMPORTED_MODULE_1__.SkywardException("Browse response data was undefined"));o.usageHistoryID&&(0,_skyward_base_performanceMonitor__WEBPACK_IMPORTED_MODULE_6__.completePerformanceMonitoring)(o.usageHistoryID,u);const f=s.duration(),h=$("#".concat(t.id));h.find(".".concat(classNames.skyVue)).remove(),$(function(){if(o.timestamp>t.timestamp){if(t.timestamp=o.timestamp,s.restart(),h.length<1)return;shouldProcessMobileBrowse(t)?(h.empty(),initMobileBrowse(h,o.html,t).then(()=>{h.attr("aria-label",t.displayName),r.resolve()})):(0,_skyward_global__WEBPACK_IMPORTED_MODULE_2__.processViewPartHtml)(o.html).then(function(e){const n=$(e).find(".".concat(classNames.sectionHeaderText));if(n.length>0){t.displayName=n[0].textContent;const e=h.attr("aria-labelledby"),a=void 0!==e?"".concat(e," ").concat(n.attr("id")):n.attr("id");h.attr("aria-labelledby",a)}else h.removeAttr("role");h.html(e),r.resolve()}),r.done(function(){browseLoadedSuccess(t,o,s,d,f,c)})}else r.resolve();"function"==typeof t.successCallback&&r.done(function(){var e;null===(e=t.successCallback)||void 0===e||e.call(t)}),"AfterRequest"===n.getBrowseSearchMode&&"GetBrowse"===a&&r.done(function(){performSearch(e,n)}),r.done(()=>{$(window).trigger("resize")})})}});var g;((0,_skyward_ui_browseLoadTimer__WEBPACK_IMPORTED_MODULE_11__.monitorRequest)(m,t,n,t.routeModule,t.routeObject,a),t.body)&&(t.body.html('<div class="'.concat(classNames.browseBodyLoading,'">').concat((0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.getImageHtml)("getRecordCountPageLoadingGif")," Loading...</div>")),null===(g=t.totals)||void 0===g||g.container.addClass(classNames.browseBodyTotalsSectionNotReady),$.cleanData(t.browse[0].getElementsByTagName("*")),t.contentMessageArea=void 0);return l&&skyward.detailsPanel.emptyDetailsPanel(),m}}function setupBrowseDependency(e){var t;const n=e.dynamicFilterData,a=(0,_skyward_ui_controls__WEBPACK_IMPORTED_MODULE_16__.getScopeContainer)(e.browse),o={Id:e.browseName,Refresh:"true"};(0,_skyward_base_requestDataHash__WEBPACK_IMPORTED_MODULE_7__.setupDependency)(n,o,a),null===(t=e.browse)||void 0===t||t.off("refresh").on("refresh",()=>(updateDependency(e.browseName),!1))}function updateBrowseTotalsRequest(e){e.totals&&(e.totals.container.length?requestBrowseTotals(e):(void 0!==e.totals.ajaxRequest&&(e.totals.ajaxRequest.abort(),e.totals.ajaxRequest=void 0),void 0!==e.totals.nextTimeoutId&&(clearTimeout(e.totals.nextTimeoutId),e.totals.nextTimeoutId=void 0)))}function getBrowseTotals(e){return $.ajax({url:"".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir).concat(e.routeModule,"/").concat(e.routeObject,"/GetBrowseTotals"),type:"POST",dataType:"JSON",activityIndicator:{hideGlass:!0},data:getRequiredBrowseData(e)})}function requestBrowseTotals(e){const t=e.totals;if(!t||void 0!==t.nextTimeoutId||void 0!==t.ajaxRequest)return;const n=void 0!==t.nextRequestTime?t.nextRequestTime.getTime()-(new Date).getTime():0;t.nextTimeoutId=window.setTimeout(function(){t.nextTimeoutId=void 0,t.ajaxRequest=getBrowseTotals(e),t.ajaxRequest.then(function(n){t.ajaxRequest=void 0;const a=new Date;if(a.setSeconds(a.getSeconds()+3),t.nextRequestTime=a,!1===n.success)return t.data=void 0,void displayBrowseTotalsError(e,n);const o=t.data;t.data=n,displayBrowseTotals(e),updateMobileTotalColumnWidths(e,o,n)})},n)}function displayBrowseTotalsError(e,t){const n=getTotalsContainer(e);if(void 0===n)return;const a=getTotalColumns(n);for(let e=0;e<a.length;e++){const t=a.eq(e),n=(0,_skyward_ui_svg__WEBPACK_IMPORTED_MODULE_21__.getSvg)("RowError","Error");n.addClass("browseBody__totalColumnError"),n.attr("role","button"),n.attr("aria-haspopup","dialog"),n.attr("aria-label","List Totals Error Information"),n.attr("tabindex","0"),t.text(""),t.append(n),n.on("click",o)}function o(){const n=[];!0===e.renderViewButton&&n.push({text:"Select List Totals",icon:"Selection",click:async()=>(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.checkLoadContent)("popup","Workflow","WorkflowInstance","Create/SkySys/BrowseView/SelectListTotals",null,null==t?void 0:t.totalsPostData,null,void 0,null,!1,null,null,null)}),n.push(_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_CLOSE_BUTTON);const a=["Adjust your List Totals to pull less data."];!0===(null==t?void 0:t.hasReportingAccess)&&a.push("Consider creating a report to summarize large amounts of data.");const o=(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.buildRecommendationModalContent)("There was a problem during the request. This could be caused by List Totals attempting to pull too much data. Review the recommendations below to avoid further disruptions.",a,!1,!0);(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.showDialog)("More Information",o,n).container.css({maxWidth:"min(600px,90%)"})}finishTotalsDisplay(e,n)}function displayBrowseTotals(e,t){var n;const a=getTotalsContainer(e,t);if(void 0===a)return;const o=null===(n=e.totals)||void 0===n?void 0:n.data;if(void 0!==o){const t=getTotalColumns(a);for(let n=0;n<t.length;n++){const a=t.eq(n),r=parseInt(a.attr("data-display-column"));a.text(o[e.columnFieldNames[r]])}}finishTotalsDisplay(e,a)}function getTotalsContainer(e,t){var n;const a=null!=t?t:null===(n=e.totals)||void 0===n?void 0:n.container;return void 0!==a&&a.length>0?a:void 0}function getTotalColumns(e){return e.find(".".concat(classNames.browseBodyTotalColumn,".").concat(classNames.browseBodyTotalColumnHasData))}function finishTotalsDisplay(e,t){var n;void 0===(null===(n=e.totals)||void 0===n?void 0:n.nextTimeoutId)&&t.removeClass(classNames.browseBodyTotalsSectionNotReady)}function updateMobileTotalColumnWidths(e,t,n){shouldProcessMobileBrowse(e)&&(t&&n&&t.length===n.length&&Object.keys(n).every(function(e){return t[e]===n[e]})||applyMobileLockedColumn(e.browse))}function getParentBrowse(e){for(const t of(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getAllBrowses)())if(null!=t&&t.relatedBrowses&&!$.isEmptyObject(t.relatedBrowses)&&t.relatedBrowses.find(t=>t.BrowseID===e.id))return t}function getHeaderNumber(e){if(e.headerNumber)return e.headerNumber;if(!e.browse)return 2;let t;const n=getParentBrowse(e);return n?t=getRequiredBrowseData(n).headerNumber+1:(t=2,e.browse.closest(".".concat(classNames.contentArea)).find(".".concat(classNames.hasInitialHeader)).length&&t++),t}function updateTotalColumnOffsets(e,t){let n=t;const a=[t];let o;for(const t of e){if(o=$(t),!o.hasClass(classNames.browseBodyLockedTotalColumn))break;n+=parseFloat(o.css("width")),a.push(n)}for(let t=0;t<a.length-1;t++)o=$(e[t]),o.css("left","".concat(a[t],"px"));$(e[a.length-1]).css("marginLeft","".concat(a[a.length-1],"px"))}function getMainSelectedBrowse(){const e=$(".".concat(classNames.modalLayerContainer)).last().find(".".concat(classNames.mainSelectedBrowse)).add("#master .".concat(classNames.mainSelectedBrowse)).first();return(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getContainingBrowse)(e)}function gatherDataForError(){var e;const t={};for(const e of(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getAllBrowseIds)()){const n=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);t[e]={title:getDebugName(n),attached:!!document.getElementById(e)}}return{browses:t,detailsPanelOpen:!!browseDetailsPanel.currentDetailsBrowse,mainSelectedBrowseId:null===(e=getMainSelectedBrowse())||void 0===e?void 0:e.id}}function rowClick(e,t){var n;const a=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!a)return;if(t.closest(".".concat(classNames.browseRow)).hasClass(classNames.current)&&(null===(n=a.browse)||void 0===n?void 0:n.hasClass(classNames.mainSelectedBrowse)))return;const o=t.data();rowChange(e,o.row,a.currentRow!==o.row)}function changeSort(){const e=$(this).data(),t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getContainingBrowse)(this);if(!t)return;const n=getRequiredBrowseData(t,e);n.sortField=e.sortField,n.sortAction=skyward.keys.globalShiftPressed?"add":"set",n.seekId=-1,n.browseViewSortChange=!0,n.descending=null!=e.sortDescending&&!e.sortDescending,requestBrowse(t.id,t,n,"ChangeBrowseSort")}function addBrowseControlsClickEvents(e){var t;null===(t=e.controls)||void 0===t||t.on("click",".".concat(classNames.addDashboardTile),function(){addTileListener(e)})}function addTileListener(e){$(document.body).one("WorkflowCompleted.SkySys.DashboardItem.DashboardItemConfigurationWorkflow",function(){e.contentMessageArea&&(e.contentMessageArea.setConfirmationMessage("Your tile has been successfully added to your dashboard!"),e.contentMessageArea.showConfirmation())})}function addBrowseBodyClickEvents(e){var t;const n=e.unlockedBody;var a;n&&$(n[0]).find(".".concat(classNames.noRecordsInBrowse,".").concat(classNames.browseRow)).length>0?$(e.unlockedHeader[0]).find("caption").remove():(null===(t=e.body)||void 0===t||t.on("click",".".concat(classNames.viewAndFilter,".").concat(classNames.reset),function(){const e=$(this).data();resetViewAndFilter(e.browseViewId,e.browseFilterId,e.browseName)}),e.selectMode&&(null===(a=e.body)||void 0===a||a.on("click",".".concat(classNames.selectRecord),function(){const t=$(this).data("select-id");selectRecord(e.id,t)})))}function addQuickSelectionFilter(e){var t,n,a,o,r,i,s;if(!e.renderFilterButton||null===(t=e.body)||void 0===t||!t.length)return;null===(n=e.browse)||void 0===n||n.addClass("quickFilterEnabled").addClass(classNames.quickFilterActive);const l="selectionchange.quickSelectionFilter".concat(e.id);$(document).off(l,g).on(l,g),null===(a=skyward.window.registerDOMUnloadCallback(e.body))||void 0===a||a.then(function(){$(document).off(l,g)}).catch(()=>{});let c={};const d="TrueOnly",u="DmsJson";let f,h;null===(o=e.body)||void 0===o||o.find(".unlockedBrowseBody").add(null!==(r=null==e?void 0:e.lockedBody)&&void 0!==r?r:$()).on("wheel",function(t){var n;const a=t.originalEvent;var o,r;skyward.keys.isPrimaryModifierPressed(a)&&(r=this).scrollHeight-r.clientHeight>1&&(o=a.target,$(o).closest(".".concat(classNames.browseDataCell)).length>0)&&(a.preventDefault(),a.target!==(null===(n=e.lockedBody)||void 0===n?void 0:n.get(0))&&(this.scrollTop+=a.deltaY))}),null===(i=e.header)||void 0===i||i.find(".browseHeaderColumn[data-selected-values]").each(function(){const e=$(this),t=e.data("field-name");if(!t)return;const n=e.data("selected-values"),a=!0===e.data("is-boolean");for(const[e,o]of Object.entries(n))m(t,e,o,a)});let p=!1;function m(e,t,n,a){if(c.hasOwnProperty(e)||(c[e]={FilterType:"selection"}),a)c[e][d]=null==t?void 0:t.toLowerCase();else{let a={};c[e].hasOwnProperty(u)&&(a=JSON.parse(c[e][u])),a[t]=n,c[e][u]=JSON.stringify(a)}}function g(){var t,n,a;!p&&skyward.keys.globalPrimaryModifierPressed&&function(){var t;const n=document.getSelection();if(null===n||n.isCollapsed||0===n.rangeCount)return!1;const a=null===(t=e.browse)||void 0===t?void 0:t.get(0);return null!=a&&a.contains(n.getRangeAt(0).commonAncestorContainer)}()&&(p=!0,c=JSON.parse(null!=f?f:"{}"),null===(n=e.body)||void 0===n||n.find(".".concat(classNames.isSelectionFiltered)).removeClass(classNames.isSelectionFiltered),null===(a=h)||void 0===a||a.addClass(classNames.isSelectionFiltered));null===(t=e.browse)||void 0===t||t.toggleClass(classNames.quickFilterActive,!p)}$(document.body).on("keyStateChanged",function(t,n){if("keyDown"===n.eventType&&n.primaryModifierKey)return f=JSON.stringify(c),h=null===(a=e.body)||void 0===a?void 0:a.find(".".concat(classNames.isSelectionFiltered)),p=!1,void g();if("keyUp"!==n.eventType||!n.primaryModifierKey||void 0===f||f===JSON.stringify(c))return;var a;const o=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e.id);if(!o)return void(c={});const r=getRequiredBrowseData(o);r.seekId=-1,r.filter=JSON.stringify(c),requestBrowse(e.id,o,r,"UpdateFilterAndView").then(()=>{c={}})}),null===(s=e.body)||void 0===s||s.on("click",".".concat(classNames.browseDataCell," div:first-of-type"),function(t){var n,a,o,r,i,s,l,f;if(g(),!skyward.keys.globalPrimaryModifierPressed||!skyward.keys.isPrimaryModifierPressed(t)||p)return;if(f=t.target,$(f).closest("a, input, textarea, select, [contenteditable]").length>0)return;t.preventDefault(),t.stopPropagation();const h=$(t.target),w=h.closest(".".concat(classNames.browseDataCell)),v=w.data("column"),b=null!==(n=null===(a=e.header)||void 0===a?void 0:a.find(".".concat(classNames.unlockedHeaderTableRow,' td[data-field-index="').concat(v,'"]')))&&void 0!==n?n:$();if(0===b.length||w.hasClass("sortDisabled"))return;const y=b.data("field-name");if(!y)return;if(void 0===w.attr("data-field-value"))return;const _=(h.is(".checkbox")?h:h.find(".checkbox").first()).length>0,C=String(null!==(o=w.data("field-value"))&&void 0!==o?o:""),k=h.text(),S=".column".concat(v),D=(null!==(r=null===(i=e.unlockedBody)||void 0===i?void 0:i.find(S))&&void 0!==r?r:$()).add(null!==(s=null===(l=e.lockedBody)||void 0===l?void 0:l.find(S))&&void 0!==s?s:$()),E=D.filter('[data-field-value="'.concat(C,'"]'));w.hasClass(classNames.isSelectionFiltered)?(E.removeClass(classNames.isSelectionFiltered),function(e,t,n){if(!c.hasOwnProperty(e))return;if(n)return delete c[e][d],void(c[e][u]="{}");if(!c[e].hasOwnProperty(u))return;const a=JSON.parse(c[e][u]);delete a[""===t?"[No Data]":t],c[e][u]=JSON.stringify(a)}(y,C,_)):(_&&D.removeClass(classNames.isSelectionFiltered),E.addClass(classNames.isSelectionFiltered),m(y,C,k,_))})}function addColumnHeaderResizeHandler(e){var t;if(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.mobileAccess||null===(t=e.header)||void 0===t||!t.length)return;const n=e.header.find(".".concat(classNames.iconContainerDiv));if(!n.length)return;const a=new ResizeObserver(e=>{for(const t of e){const e=$(t.target),n=e.closest(".".concat(classNames.browseHeaderColumn));if(!n.length)continue;const a=[e.find(".".concat(classNames.browseColumnIconSpan,".").concat(classNames.browseColumnSortSpan," .sortNumberLabel")),e.find(".".concat(classNames.browseColumnIconSpan,".").concat(classNames.browseColumnSuperUser)),e.find(".".concat(classNames.browseColumnIconSpan,".").concat(classNames.browseColumnSortSpan)),e.find(".".concat(classNames.browseColumnIconSpan,".browseColumnFiltered"))],o=e.find(".".concat(classNames.browseColumnFilterMenuLaunch)).first(),r=()=>{if(!o.length)return!1;return o[0].getBoundingClientRect().right>n[0].getBoundingClientRect().right};if(r()){for(const e of a)if(e.length&&e.is(":visible")&&(e.css("display","none"),!r()))break}else for(const e of[...a].reverse())if(e.length&&!e.is(":visible")&&(e.css("display",""),r())){e.css("display","none");break}}});n.each(function(){a.observe(this)})}function addColumnHeaderClickEvents(e){var t;!_skyward_global__WEBPACK_IMPORTED_MODULE_2__.mobileAccess&&null!==(t=e.header)&&void 0!==t&&t.length&&(e.header.on("click",".".concat(classNames.browseColumnSuperUser),browseColumnSuperUserClick),e.header.on("click",".".concat(classNames.browseColumnFilterMenuLaunch),browseHeaderColumnClick),e.header.on("click",".".concat(classNames.browseColumnHeaderSort),changeSort),!1!==e.renderSortableHeader&&e.header.on("click",".".concat(classNames.browseColumnSortSpan),changeSort))}function addPagingButtonClickEvents(e){$("#".concat(e,"_footer")).on("click",".".concat(classNames.pagingButton,":not(.").concat(classNames.pagingButtonDisabled,")"),function(){changePage(this,e,$(this).data())})}function totalRecordsButtonClicked(){const e=$(this);if(e.hasClass(classNames.totalRecordsButtonDisabled))return;const t=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e.parents(".".concat(classNames.browse))[0].id);if(!t)return;const n=[{type:"title",text:"Total Records"},{type:"custom",content:function(){const n=$("<div class='customMenuPopupItem totalRecordsCount' aria-live='polite'>".concat((0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.getImageHtml)("getRecordCountPageLoadingGif"),"Loading Total Records</div>")),a=getRequiredBrowseData(t,e.closest(".".concat(classNames.browse)).data());return getBrowseRowCount(t,a).then(function(e){n.html("".concat(e," ").concat("Total Record".pluralize("Total Records",e)))}),n}}];e.addClass(classNames.totalRecordsButtonDisabled),(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.showMenu)(n,e,{beforeClose:function(){e.trigger("focus"),e.removeClass(classNames.totalRecordsButtonDisabled)}})}function addTotalRecordsClickEvents(e){$("#".concat(e,"_footer")).on("click",".".concat(classNames.totalRecordsButton),totalRecordsButtonClicked)}function addColumnHeaderResizeEvents(e,t){if(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.mobileAccess)return;const n=e.attr("id"),a=[];e.find(".".concat(classNames.tdResizeDiv)).each(function(){const n=$(this),r=n.data(),i=r.column,s=!!r.updateBrowseView,l={minWidth:minColumnWidth,maxWidth:maxColumnWidth,handles:"e"};n.hasClass(classNames.locked)?(l.resize=function(n,a){e.find("#".concat(t,"_unlockedHeaderColumn_").concat(i)).css("width",a.size.width)},l.stop=function(e,t){o(s,i,t.size.width,!0)}):l.stop=function(e,t){o(s,i,t.size.width,!1)},a.push({element:n,resizable:l})});for(const e of a)e.element.resizable(e.resizable);async function o(e,a,o,r){const i=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(t);if(!i)return;if(null!==a){var s;const e="#".concat(t," .").concat(classNames.browseDataCell,".column").concat(a);if($(e).each(function(){const e=$(this),t=e.attr("data-column");t&&t===a.toString()&&e.children().css("width",o)}),null!==(s=i.totals)&&void 0!==s&&s.container.length){const e=i.totals.container.find(".".concat(classNames.browseBodyTotalColumn)),t=e.filter("[data-column='".concat(a,"']"));if(r){const n=parseFloat(t[0].style.left)+o;updateTotalColumnOffsets(e.slice(e.index(t)+1),n)}t.css("width",o)}}r&&function(){let e=13;$("#".concat(t," .").concat(classNames.lockedBrowseBody," tr:first-child td")).each(function(){e+=$(this).width()});const n=$("#".concat(t," .").concat(classNames.lockedBrowseBody)),a=n.parent(),o=n.width()-a.width();n.css("width",e+o),a.css("width",e)}(),browseResize(n);const l=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(n);if(e&&l){var c,d;const e={columnIndex:a,columnWidth:o,fieldName:null===(c=l.browse)||void 0===c?void 0:c.find("[data-column-index=".concat(a,"]")).data("fieldName")};let t;null!==(d=l.data)&&void 0!==d&&d.browseViewEditorHash?(t="".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"SkySys/BrowseView/ResizeBrowseViewEditorColumn"),e.postData=JSON.stringify(l.data)):(t="".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"SkySys/BrowseView/ResizeColumn"),e.pageModule=l.pageModule,e.pageObject=l.pageObject,e.pageScreen=l.pageScreen,e.pageTab=l.pageTab,e.browseName=l.browseName.replace("detailsPanel_",""),e.taskName=l.taskName,e.browseId=l.browseId);const r=await $.ajax({url:t,type:"POST",dataType:"JSON",data:e,activityIndicator:{hideGlass:!0}});if(r.success&&r.browseViewID&&r.browseViewName){l.viewId=r.browseViewID;const e=$("#".concat(n,"_viewButton")),t=e.find(".".concat(classNames.buttonSelectedValueLabel)),a=t.find(".".concat(classNames.buttonParenthesisLabel));if(r.isModifiedBrowseView&&0===a.length){const n=(0,_skyward_ui_svg__WEBPACK_IMPORTED_MODULE_21__.getSvg)("ViewModified","BrowseLevel");e.find("svg").replaceWith(n),t.empty().text("".concat(r.browseViewName," (")).append($("<span>",{class:classNames.buttonParenthesisLabel,text:"Modified"})).append(")")}else!r.isModifiedBrowseView&&a.length>0&&t.empty().text(r.browseViewName)}}}}function selectRecord(e,t){void 0!==(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e)&&eventCallbacksInternal.recordSelectionMade.dispatchCallbacks({browseId:e,selectedId:t}),(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.closePopup)(void 0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.CloseReasons.SelectedItem)}function finishRegistration(e){var t,n;const a=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e);if(!a)return;const o=(0,_skyward_ui_debounce__WEBPACK_IMPORTED_MODULE_17__.default)(function(){browseResize(e)},50);if($(window).trigger("resize"),o(),a.isRegistered=!0,null!==(t=a.totals)&&void 0!==t&&t.container.length&&displayBrowseTotals(a),null!==a.currentRow&&void 0!==a.currentRow)setCurrentRecord(e,a.currentRow);else if(a.relatedBrowse){const e=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(a.relatedBrowse);null!=e&&e.body&&e.body.empty()}null===(n=a.browse)||void 0===n||n.trigger("browseLoaded.".concat(e),a),a.isInDetailsPanel||a.detailsPanelType===browseDetailsPanel.detailsPanelTypes.row&&!(a.rowModule&&a.rowObject&&a.rowScreen)?$("#".concat(e,"_previewDetails")).remove():browseDetailsPanel.tryRefreshDetailsPanel(e)}function getCurrentBrowse(){const e=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getCurrentBrowseName)();return(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(e)}function getLockedRowElement(e,t){return getCurrentRowElement("locked",e.id,null!=t?t:e.currentRow,e.browseType)}function getUnlockedRowElement(e,t){return getCurrentRowElement("unlocked",e.id,null!=t?t:e.currentRow,e.browseType)}function getRowElements(e,t){return getLockedRowElement(e,t).add(getUnlockedRowElement(e,t))}function keyDown(e){const t=getCurrentBrowse();if(null==t||!t.keyEventsEnabled||shouldIgnoreKeyboardEvent(document.activeElement))return;const n=skyward.keys.getKeyNamesFromEvent(e);let a=n.ARROW_UP,o=n.ARROW_DOWN;if(t.selectMode&&(a||o)){const e=(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.getLayerFromElement)(t.browse);e&&$(e.originalActiveElement).trigger("focus")}if("Tile"===t.browseType&&(a=a||n.ARROW_LEFT,o=o||n.ARROW_RIGHT),a||o){let n;if(o){if(null===t.currentRow||void 0===t.currentRow)return void e.preventDefault();n=t.currentRow<t.recordCount-1?t.currentRow+1:"DistinctMultiSelect"===t.browseType&&t.currentRow===t.recordCount-1?-1:0}else if(a){if(null===t.currentRow||void 0===t.currentRow)return void e.preventDefault();n=t.currentRow>0?t.currentRow-1:"DistinctMultiSelect"===t.browseType&&0===t.currentRow?-1:t.recordCount-1}return void 0!==n&&t.currentRow!==n&&changeRow(t.id,t,n),keyUpHandler.addKeyUpHandler(e.which,t.id),e.preventDefault(),void e.stopPropagation()}if(n.ENTER){if("DistinctMultiSelect"!==t.browseType){const e=$(document.activeElement);if(e.hasClass(classNames.browseExpandCollapseButton))return;if(e.length>0&&(["A","BUTTON"].includes(e[0].nodeName)||"button"===e.attr("role")))e.trigger("click");else if(t.selectMode)t.body&&$(t.body).find(".".concat(classNames.current)).first().length>0&&selectRecord(t.id,t.primaryKeys[t.currentRow]);else{const e=getUnlockedRowElement(t),n=e.data("targetid");if(t.primaryKeys[t.currentRow]!==n){let n;n="Tile"===t.browseType?e:e.find("td.".concat(classNames.browseRowOptions," div a.").concat(classNames.button)).first(),n.length>0&&n[0].click()}}}e.preventDefault(),e.stopPropagation()}}function rowChange(e,t,n){browseDetailsPanel.tryRowChange(e,function(){setCurrentRecord(e,t,{setCurrentBrowseName:!0,loadRelatedBrowses:n})},!0)}function repositionMoreMenu(){const e=Object.keys(allBrowseStats);for(const t of e){const e=$("#".concat(t,"_moreButton")),n=$("#".concat(t,"MenuPopup")),a=e.offset();a&&(a.top+=e.outerHeight(),a.left=a.left+e.outerWidth(!0)-n.outerWidth(!0)-2,n.offset({left:a.left,top:a.top}))}}function init(e){const t=$(e),n=t.find(".".concat(classNames.browse)).add(t.filter(".".concat(classNames.browse)));n.length&&(bindLockedBodySimulatedFocus(n),n.each(function(){const e=(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.getBrowseById)(this.id);e&&!1===e.isRegistered&&finishRegistration(this.id)})),t.find(".".concat(classNames.customBrowse)).each(function(){const e=$(this),t=e.data("browseName"),n={browseType:"default",id:t,refreshTimeout:-1,keyEventsEnabled:!0,dynamicFilterHashes:{},dynamicFilterValues:{}};e.data("isSimpleBrowse")&&$.extend(n,{preventColumnSort:!0,preventColumnResize:!0,hidePreviewDetailsButton:!0,hideBrowseControl:!0,renderSearchBox:!1,renderViewButton:!1,renderFilterButton:!1,renderHeaderSettings:!1,renderSortableHeader:!1,renderRowsPerPageOption:!1});const a=Object.assign({},n,e.data(),{isSimpleBrowse:void 0});(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.addBrowse)(a,t),(0,_skyward_browseList__WEBPACK_IMPORTED_MODULE_0__.prependOpenBrowse)(t),get(t,{})})}function popInsertColumnView(e,t,n){const a={anchorTo:n,beforeClose:function(){(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.removeBrowseResizeCallback)(o.close)}},o=(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.showDialog)("Insert Column",buildInsertColumnPopup(e),[_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.DEFAULT_CLOSE_BUTTON],a);o.content.on("treeBrowseLevelChanged",o.animateModalContents),o.content.on("treeBrowseSave",async function(a,r){if(!treeBrowseHasSelectedField(r))return;o.content.off("treeBrowseSave");const i=n.closest("#".concat(e.browseName,"_lockedHeader")).length>0,s=(0,_skyward_ui_treebrowse__WEBPACK_IMPORTED_MODULE_22__.getSelectedFieldData)(o.content);await insertColumn(e,t,i,s),o.close()})}async function deleteColumn(e,t,n){var a;const o={columnIndex:n,fieldName:t};let r;null!==(a=e.data)&&void 0!==a&&a.browseViewEditorHash?(r="".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"SkySys/BrowseViewEditor/DeleteColumnFromBrowseViewEditor"),o.postData=JSON.stringify(e.data)):(r="".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"SkySys/BrowseView/DeleteColumn"),o.pageModule=e.pageModule,o.pageObject=e.pageObject,o.pageScreen=e.pageScreen,o.browseName=e.browseName.replace("detailsPanel_",""),o.taskName=e.taskName);const i=await $.ajax({url:r,type:"POST",dataType:"JSON",data:o});if(null!=i&&i.success){const t=e.primaryKeys[e.currentRow];get(e.id,{seekId:t})}else(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.showErrorDialog)("An error occurred while deleting the column.",'There was an error when attempting to delete the "'.concat(t,'" column.'))}function buildInsertColumnPopup(e){var t;const n={browseName:e.browseName};let a;return null!==(t=e.data)&&void 0!==t&&t.browseViewEditorHash?(a="".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"SkySys/BrowseViewEditor/BuildTreeBrowse/"),n.postData=JSON.stringify(e.data)):(a="".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"SkySys/BrowseView/BuildTreeBrowse/"),n.lookupModule=e.dataModule,n.lookupObject=e.dataObject,n.browseId=e.browseId),$.ajax({url:a,type:"POST",dataType:"viewparthtml",data:n})}async function insertColumn(e,t,n,a){var o;if(void 0===(null==a?void 0:a.fieldName))return;const r=a.fieldName.indexOf(".");let i;i=r>0?a.fieldName.substring(r+1,a.fieldName.length):a.fieldName;const s={columnIndexToInsertAfter:t,fieldIsDynamic:a.isDynamicColumn,columnFieldName:i,isLockedColumn:n};let l;null!==(o=e.data)&&void 0!==o&&o.browseViewEditorHash?(l="".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"SkySys/BrowseViewEditor/InsertColumnFromBrowseViewEditor"),s.postData=JSON.stringify(e.data)):(l="".concat(_skyward_global__WEBPACK_IMPORTED_MODULE_2__.virtualDir,"SkySys/BrowseView/InsertColumn"),s.pageModule=e.pageModule,s.pageObject=e.pageObject,s.pageScreen=e.pageScreen,s.browseName=e.browseName.replace("detailsPanel_",""),s.taskName=e.taskName,s.browseId=e.browseId);const c=await $.ajax({url:l,type:"POST",dataType:"JSON",data:s});if(null!=c&&c.success){const t=e.primaryKeys[e.currentRow];get(e.id,{seekId:t})}else(0,_skyward_modalLayer__WEBPACK_IMPORTED_MODULE_3__.showErrorDialog)("An error occurred while inserting the column.",'There was an error when attempting to insert the "'.concat(i,'" column.'))}function treeBrowseHasSelectedField(e){const t=e.getSelectedFieldData();if(void 0!==t)return!!t.fieldName}function initialize(){(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.registerLoadDOMCallback)(init),(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.registerLoadDOMCallback)(initActiveBrowseClass),(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.registerBrowseResizeCallback)(resizeBrowseList),(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.registerLayoutResizeCallback)(repositionMoreMenu),_skyward_global__WEBPACK_IMPORTED_MODULE_2__.mobileAccess||(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.registerLoadDOMCallback)(initSortableColumns);const e={getBrowseExport:exportBrowse,showAuditLegend,browseLinkColumnPopup,forceToggleDetailsPanel:function(){const e=$(this).attr("data-browse-id");browseDetailsPanel.toggleDetailsPanel(e,!0)}};(0,_skyward_ui_events__WEBPACK_IMPORTED_MODULE_20__.registerEvents)("browse",e),(0,_skyward_error__WEBPACK_IMPORTED_MODULE_1__.registerErrorDataGatherer)("browse",gatherDataForError),(0,_skyward_window__WEBPACK_IMPORTED_MODULE_4__.registerLoadDOMCallback)(()=>{browseDetailsPanel.init()}),$(document.documentElement).on("keydown",keyDown)}initialize()},6722(e,t,n){"use strict";n.r(t),n.d(t,{events:()=>C,openFilterMaintenanceDialog:()=>S,preInitQuickFilter:()=>k});var a=n(62521),o=n(3543),r=n(917),i=n(79126),s=n(2894),l=n(88157),c=n(49343),d=n(66952),u=n(81975),f=n(939),h=n(40096),p=n(40346),m=n(62894),g=n(92214),w=n(30368),v=n(68337),b=n(22528);const y=".js-browseFilterFieldControl [data-original-value]",_={initLogicalCheckbox:function(e){const t=$(e);t.find(":checkbox").on("change",function(){const e=$(this);e.is(":checked")&&e.closest(".js-browseFilterFieldControl").find(":checkbox:checked").not(e).prop("checked",!1).trigger("dirty")})},openMaintenanceDialog:function(){const e=$(this);S(e.data())},initQuickFilter:function(){P(this).init()},quickFilterClear:function(){P(this).clear()},quickFilterUndo:function(){P(this).undo()},quickFilterApply:function(){P(this).apply()},quickFilterReset:function(){P(this).reset()},quickFilterToggle:function(){P(this).toggle()}};(0,g.registerEvents)("browseFilters",_);const C=Object.freeze({filterChanged:"browseFilters_filterChanged"});function k(e){E(e).preInit()}function S(e){return function(e){var t,n,c,d,u,f,p;const g=e.browseId,w=e.browseFilterId,v=e.action;let _,C,k;e.browseOverride?_=C=e.browseOverride:(_=(0,o.getBrowseById)(g),C=(0,a.getRequiredBrowseData)(_));const S=$.Deferred();switch(v){case"new":k="Add Filter";break;case"clone":k="Clone Filter";break;default:k="Edit Filter"}const E={draggable:!0,closeOnClick:!1,afterClose:function(){S.reject(new i.CancellationError("closed"))}},P={maintentanceMode:v,browseFilterId:w,filterData:e.filterData,hideUserFilters:null!==(t=null===(n=e.browseOverride)||void 0===n?void 0:n.hideUserFilters)&&void 0!==t&&t,hideActionButtons:null!==(c=null===(d=e.browseOverride)||void 0===d?void 0:d.hideActionButtons)&&void 0!==c&&c,additionalFilterFields:null!==(u=e.browseOverride)&&void 0!==u&&u.additionalFilterFields?JSON.stringify(e.browseOverride.additionalFilterFields):null,excludeNonDefaultBrowseFilters:null===(f=e.browseOverride)||void 0===f?void 0:f.excludeNonDefaultBrowseFilters,selectedBrowseFilterId:null===(p=e.browseOverride)||void 0===p?void 0:p.selectedBrowseFilterId},B=$.ajax({url:"".concat(s.virtualDir).concat(_.routeModule,"/").concat(_.routeObject,"/GetBrowseFilterMaintenanceScreen"),type:"POST",dataType:"viewparthtml",activityIndicator:{hideGlass:!0},data:$.extend({},C,P)}).promise(),T=(0,l.showInformationBubble)(k,B,[],E);return T.content.css("overflow","hidden"),T.content.on("contentLoaded",function(){const t=$(this),n=t.find(".js-filterMaintenance"),o=n.data();n.find(".browseColumnSuperUser").on("click",a.browseColumnSuperUserClick);n.find(".browseColumnInfo").on("click",O),t.find(".js-filterMaintenance__cancel").on("click",T.close);const i=function(){var n,r;const i=$(this),l=t.find(".js-filterMaintenance__filter_name"),c="saveasnew"===i.data().action?"BrowseFilterMaintenanceSaveAsNew":"BrowseFilterMaintenanceSave",d={name:l.val(),routeHash:_.routeHash,browseFilterId:o.browsefilterid,browseFilterId_hash:o.browsefilterid_hash,filterData:p(),isWidget:null!==(n=null===(r=e.browseOverride)||void 0===r?void 0:r.isWidget)&&void 0!==n&&n},u=$.extend({},C,d);return u.defaultBrowseFilterGuids&&(u.defaultBrowseFilterGuids=JSON.stringify(u.defaultBrowseFilterGuids)),h(),$.ajax({url:"".concat(s.virtualDir,"skysys/filter/").concat(c),type:"POST",dataType:"JSON",data:u,activityIndicator:{hideGlass:!0},success:function(e){e.success?(S.resolve(e),T.close(),(0,a.changeFilter)(g,{browseFilterId:e.id})):f(e)}}).promise();function f(e){(0,b.displayValidationMessages)(e,t,t.find(".filterMaintenance__header .help"))}function h(){f(null)}function p(){return D(t.find(".js-filterMaintenance__filterRow"),function(e){return(e.find(".js-filterMaintenance__filterTypeRadio :radio:checked").val()||"none").toLowerCase()})}};t.find(".js-filterMaintenance__save").on("click",(0,h.manageButtonClick)(i)),t.find(".viewAndFilter.reset").on("click",async function(){const e=$(this).data();await(0,a.resetViewAndFilter)(e.browseViewId,e.browseFilterId,e.browseName),(0,l.getOpenModalLayers)().each(function(){$(this).data("layer").close()})});const c=function(){const e=$(this).closest(".js-filterMaintenance__filterTypeRadio"),t=e.closest(".js-filterMaintenance__filterRow"),n=e.data("selection-type"),a=t.find(".js-filterMaintenance__filterField--range"),o=t.find(".js-filterMaintenance__filterField--selection");a.toggle("range"===n),o.toggle("selection"===n)};t.find(".js-filterMaintenance__filterTypeRadio :radio").on("change",c);const d=t.find(".js-filterMaintenance__clearAll"),u=new Set,f=function(e){function t(e){return"checkbox"===e.getAttribute("type")?!e.checked:e.classList.contains("dmsBackingData")?(0,m.isEmpty)($(e)):e.classList.contains("relativeDate")?!$(e).data("relativeDate"):!e.value}t(e)?u.delete(e):u.add(e)},p=function(){d.css("visibility",u.size>0?"":"hidden")};t.on("change dirty keyup",y,function(){f(this),p()}),d.on("click",function(){u.forEach(function(e){(0,r.clearValue)(e)})}),t.find(y).each(function(){f(this)}),p()}),S.promise()}(e).done(function(t){if(e.browseOverride){var n,a;null===(n=(a=e.browseOverride).onFilterChanged)||void 0===n||n.call(a,t.id,t.browseFilterDisplayName)}else{const t=(0,o.getBrowseById)(e.browseId).browse;t.trigger(C.filterChanged,{browse:t})}})}function D(e,t){const n={};return e.each(function(){const e=$(this),a=t(e);n[e.data("fieldpath")]=function(e,t){const n={FilterType:t};if("range"===t){const t=e.find(".js-browseFilterFieldControl__rangeLow"),a=e.find(".js-browseFilterFieldControl__rangeHigh");n.RangeLow=(0,r.getValue)(t),n.RangeHigh=(0,r.getValue)(a),(0,u.isDate)(n.RangeLow,!1)&&(n.RangeLow=(0,u.formatServerDate)(n.RangeLow)),(0,u.isDate)(n.RangeHigh,!1)&&(n.RangeHigh=(0,u.formatServerDate)(n.RangeHigh))}else if("selection"===t){const t=e.find(".js-browseFilterFieldControl--logical").addBack(".js-browseFilterFieldControl--logical").find(":checkbox:checked");if(t.length)n.TrueOnly="True"===t.data("type");else{const t=e.find(".dmsBackingData"),a=(0,r.getValue)(t);n.DmsJson=JSON.stringify(a)}}return n}(e,a)}),JSON.stringify(n)}function E(e,t){const n=e,o=null!=t?t:n.browse;return{preInit:function(){var t,a,o;if(0===n.quickFilter.length)return;const r=(0,f.getPreferences)(n.id),i=null!==(t=null!==(a=r.quickFilterOpen)&&void 0!==a?a:null===(o=e.browse)||void 0===o?void 0:o.data("openQuickFilter"))&&void 0!==t&&t;i||(n.quickFilter[0].style.display="none");l(i)},init:function(){const e=n.quickFilter,t=e.find(".js-expandableQuickFilter__fields"),a=e.find(".js-change");(0,p.setUpChangeTracking)(t,function(){a.toggleClass("expandableQuickFilter__control--hidden",!(0,p.isDirty)(t))});t.find("[name]").addClass("doNotPost")},apply:function(){return(0,a.updateQuickFilter)(n.id,(e=n.quickFilter,D(e.find(".js-browseFilterFieldControl"),function(e){return e.hasClass("js-browseFilterFieldControl--range")?"range":e.hasClass("js-browseFilterFieldControl--selection")||e.hasClass("js-browseFilterFieldControl--logical")?"selection":null}))).done(i).then(function(){const e=n.quickFilter.find(".js-expandableQuickFilter__fields").scrollTop();$(document.body).one("browseLoaded.".concat(n.id),function(){n.quickFilter.find(".js-expandableQuickFilter__fields").scrollTop(e)})});var e},reset:function(){return $.ajax({url:"".concat(s.virtualDir,"skysys/browsefilter/reset/").concat(n.browseFilterId),type:"POST",success:function(e){(0,a.changeFilter)(n.id,{browseFilterId:String(e.id)}).done(i)}}).promise()},clear:function(){n.quickFilter.find(y).each(function(){(0,r.clearValue)(this)})},undo:function(){n.quickFilter.find(".js-browseFilterFieldControl [data-original-value][data-dirty='true']").each(function(){(0,r.setValue)(this,(0,r.getOriginalValue)(this))})},toggle:function(){const e=n.quickFilter.is(":visible");!function(e){const t=n.quickFilter;if(0===t.length)return;if(e&&!t.hasClass("js-expandableQuickFilter--empty")){const n={start:function(){u(t)}};t.animateToggle(n,e)}else t.animateToggle(e);l(e)}(!e);const t=(0,f.getPreferences)(n.id);t.quickFilterOpen=!e,(0,f.setPreferences)(n.id,t)},resize:function(){const e=n.quickFilter;void 0!==e&&e.length>0&&"none"!==e[0].style.display&&!e[0].classList.contains("js-expandableQuickFilter--empty")&&u(e)}};function i(){null==o||o.trigger(C.filterChanged,{browse:n.browse})}function l(e){n.controls.find(".js-browseQuickFilterButton").attr("aria-expanded",e.toString()),(0,v.swapSvg)(n.controls.find(".js-browseQuickFilterButton svg"),e?"ChevronUp":"ChevronDown","BrowseLevel")}function u(e){const t=$.data(e[0]),n=e[0].querySelector(".js-expandableQuickFilter__fields"),a=function(e,t){const n=e.getBoundingClientRect().width-c.scrollbarHeight;if(!t.getColumnWidths){const n=Array.from(e.children).filter(function(e){return!e.classList.contains("expandableQuickFilter__fieldLineBreak")}).map(function(e){return parseFloat($.css(e,"width"))});t.getColumnWidths=(0,d.createCache)(function(e){return function(e,t){const n=[];let a=0;for(let o=0;o<t;o++){let r=e[o];for(let n=o+t;n<e.length;n+=t)r=Math.max(r,e[n]);n.push(r),a+=r}return{widths:n,total:a}}(n,2*e)})}let a=1;for(;t.getColumnWidths(a+1).total<n;)a+=1;return t.getColumnWidths(a).widths}(n,t);if(t.columns===a.length)return;t.columns=a.length;const o=$(n);t.labelsLaidOut||(!function(e){const t=e.children(".js-expandableQuickFilter__label");(0,w.getWidthsAndSetTwoLineMode)(t)}(o),t.labelsLaidOut=!0),function(e,t){const n=e.children();let a=0;for(let e=0;e<n.length;e+=3)$(n[e]).css("width",t[a]),$(n[e+1]).css("width",t[a+1]),a+=2,a===t.length?($(n[e+2]).css("display","block"),a=0):$(n[e+2]).css("display","")}(o,a)}}function P(e){return E((0,o.getContainingBrowse)(e),$(e))}function O(){var e;const t=$(this),n=null!==(e=t.data().fieldPath)&&void 0!==e?e:"Unable to find field path.";(0,l.showDialog)("Field Path",n,[l.DEFAULT_CLOSE_BUTTON],{anchorTo:t})}(0,c.registerBrowseResizeCallback)(function(){(0,o.getAllBrowseIds)().forEach(function(e){E((0,o.getBrowseById)(e)).resize()})})},40044(e,t,n){"use strict";n.r(t),n.d(t,{initValues:()=>f,monitorRequest:()=>h});var a=n(62521),o=n(2894),r=n(49343);let i,s,l;const c="js-browseLongLoadBanner",d="js-browseLongLoadResetButton",u="browseBody";function f(e,t,n){i=e,s=t,l=n}function h(e,t,n,a,r,i){const c=p(e,t);c.timeoutHandle=window.setTimeout(g,1e3*(o.mobileAccess?l:s),c,t,n,a,r,i),e.always(function(){c.resetHandles()&&m(t)})}const p=function(){const e=new WeakMap;return function(t,n){const a=e.get(n)||{};return{get timeoutHandle(){return a.timeoutHandle},set timeoutHandle(r){a.browseRequest=t,o(),a.timeoutHandle=r,e.set(n,a)},get monitorRequestAjaxHandle(){return a.monitorRequestAjaxHandle},set monitorRequestAjaxHandle(t){a.monitorRequestAjaxHandle=t,e.set(n,a)},resetHandles:o};function o(){return a.browseRequest===t&&(void 0!==a.timeoutHandle&&window.clearTimeout(a.timeoutHandle),void 0!==a.monitorRequestAjaxHandle&&a.monitorRequestAjaxHandle.abort(),!0)}}}();function m(e){w(e).find(".".concat(c)).remove()}function g(e,t,n,a,s,l){const u=$.extend({routeModule:a,routeObject:s,routeAction:l},n);e.monitorRequestAjaxHandle=$.ajax({url:"".concat(o.virtualDir,"SkySys/Browse/MonitorBrowsePerformance"),type:"POST",dataType:"JSON",data:u,activityIndicator:{hideGlass:!0},success:async function(e){i&&e.allowReset&&await async function(e,t){const n=await(0,o.processViewPartHtml)(t.banner),a=$(n);if(0===a.length)return;m(e),a.addClass(c);const i=w(e);a.find(".".concat(d)).one("click",{browse:e,data:t},v),i.prepend(a),(0,r.notifyResize)()}(t,e)}})}function w(e){let t;return void 0!==e.browse?(t=e.browse.find(".".concat(u)),0===t.length&&(t=e.browse)):t=$("#".concat(e.id)),t}function v(e){const t=e.data.browse,n=e.data.data,o={isLongLoad:!0,routeModule:t.pageModule||t.routeModule,routeObject:t.pageObject||t.routeObject,browseScreen:t.pageScreen,browseName:t.browseName,taskName:t.taskName,browseType:t.browseType};(0,a.resetViewAndFilter)(n.browseViewId,n.browseFilterId,t.id,o)}},939(e,t,n){"use strict";n.r(t),n.d(t,{getPreferences:()=>c,setPreferences:()=>d});var a=n(3543),o=n(82893);const r=window.skyward,i=(0,o.getLocalStorage)("BrowsePreference"),s=Object.create(null),l={quickFilterOpen:null,seekId:null,prevSeekId:null,nextSeekId:null};function c(e){const t=u(e);return t?f(String(t)):Object.assign({},l)}function d(e,t){const n=u(e);if(!n)return;const a=String(n),o=function(e){const t={};void 0!==e.quickFilterOpen&&(t.quickFilterOpen=e.quickFilterOpen);void 0!==e.seekId&&(t.seekId=e.seekId);void 0!==e.prevSeekId&&(t.prevSeekId=e.prevSeekId);void 0!==e.nextSeekId&&(t.nextSeekId=e.nextSeekId);return t}(t);if(0===Object.keys(o).length)return;const r=Object.assign(f(a),o);!function(e,t){if(null===e||null===t)return null===e&&null===t;const n=Object.keys(e),a=Object.keys(t);if(n.length!==a.length)return!1;n.sort(),a.sort();for(let o=0;o<n.length;o++){const r=n[o];if(r!==a[o])return!1;if(e[r]!==t[r])return!1}return!0}(r,l)?function(e,t){i.set(e,t),s[e]=t}(a,r):function(e){i.remove(e),delete s[e]}(a)}function u(e){if("string"==typeof e){const t=(0,a.getBrowseById)(e);return null!=t&&t.browseId?h(t.browseId):void console.warn("Browse Not Found in BrowseList",e)}return"object"==typeof e&&e.browseId?h(e.browseId):"number"==typeof e?h(e):void console.warn("Browse Not Found in BrowseList",e)}function f(e){const t=i.get(e)||s[e];return Object.assign({},l,t)}function h(e){return function(e){let t=0;for(let n=0;n<e.length;n++){t=(t<<5)-t+e.charCodeAt(n),t|=0}return t}([r.global.userIdHash,r.global.windowGuid,e].join(","))}},50573(e,t,n){"use strict";n.r(t),n.d(t,{clear:()=>s,get:()=>r,save:()=>l,setAndGet:()=>i});var a=n(3543),o=n(939);function r(e){return c((0,o.getPreferences)(e))}function i(e,t){const n=c(t);return d(e)?n?null==n.seekId||isNaN(Number(n.seekId))?void s(e):((0,o.setPreferences)(e,n),n):r(e):n}function s(e){d(e)&&(0,o.setPreferences)(e,{seekId:null,prevSeekId:null,nextSeekId:null,quickFilterOpen:null})}function l(e,t){if(!d(e))return;if(void 0!==t)return i(e,t);const n=Array.isArray(e.primaryKeys),a="number"==typeof e.currentRow&&Number.isInteger(e.currentRow)?e.currentRow:void 0;return i(e,{seekId:n&&void 0!==a&&Array.isArray(e.primaryKeys)&&"number"==typeof e.primaryKeys[a]?e.primaryKeys[a]:void 0,prevSeekId:n&&void 0!==a&&Array.isArray(e.primaryKeys)&&"number"==typeof e.primaryKeys[a-1]?e.primaryKeys[a-1]:void 0,nextSeekId:n&&void 0!==a&&Array.isArray(e.primaryKeys)&&"number"==typeof e.primaryKeys[a+1]?e.primaryKeys[a+1]:void 0})}function c(e){if(e&&null!=e.seekId)return{seekId:e.seekId,prevSeekId:e.prevSeekId,nextSeekId:e.nextSeekId,quickFilterOpen:e.quickFilterOpen}}function d(e){let t;return t="string"==typeof e?(0,a.getBrowseById)(e):e,!(!t||$.isEmptyObject(t)||!t.trackSeekInfo||t.isInDetailsPanel||"string"==typeof t.id&&0===t.id.indexOf("detailsPanel_"))&&-1!==t.browseId}},40096(e,t,n){"use strict";n.r(t),n.d(t,{isClickInProgress:()=>o,isElementDisabled:()=>d,manageButtonClick:()=>s,manageFunction:()=>i,setClass:()=>c,setClickInProgress:()=>l,waitForFunction:()=>r});let a=!1;function o(){return a}function r(e,t){const n=$.when(t);return n.done(function(){e.resolve()}),n.fail(function(){e.reject()}),n}function i(e){let t=null;return function(){return t||(t=(async()=>{try{return await e.apply(this,arguments)}finally{t=null}})()),t}}function s(e){const t=function(){return u(e,this,arguments)};return t.force=function(t){return u(e,t,arguments,!0)},t}function l(e){a=e,c("#moduleContent a.button, #detailsPanel a.button, .workflowPopup a.button, .messageBox a.button",a)}function c(e,t){$(e).toggleClass("frmwrk-disabled",t)}function d(e){return e.hasClass("ui-disabled")||e.hasClass("frmwrk-disabled")}async function u(e,t,n){let a=arguments.length>3&&void 0!==arguments[3]&&arguments[3];if(d($(t)))return;const r=()=>l(!1);if(o())return a?Promise.resolve(e.apply(t,n)):Promise.reject(new Error("Click already in progress"));{l(!0);let a=!0;try{const o=e.apply(t,n);if("function"==typeof(null==o?void 0:o.always))return a=!1,o.always(r);return"function"==typeof(null==o?void 0:o.then)?await o:o}finally{a&&r()}}}},29711(e,t,n){"use strict";n.r(t),n.d(t,{getCallbackStore:()=>o,getCallbackStoreFacade:()=>r,getCallbackStoreFacadeCollection:()=>i});var a=n(79126);const o=function(){const e=[],t={registerCallback:function(t,n){const a=null!=n?n:Number.MAX_SAFE_INTEGER;let o=e.length;for(let t=0;t<e.length;t++)if(e[t].priority>a){o=t;break}e.splice(o,0,{callback:t,priority:a})},deregisterCallback:function(t){for(let n=e.length-1;n>=0;n--)e[n].callback===t&&e.splice(n,1)},getCallbacks:function(){return e.map(e=>e.callback)},dispatchCallbacks:function(){for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];for(let t=0;t<e.length;t++)try{e[t].callback.call(this,...n)}catch(e){e instanceof Error?(0,a.reportException)(e):(0,a.reportException)(new a.SkywardException(e.toString()))}}};return t};let r=function(e){return{registerCallback:e.registerCallback,deregisterCallback:e.deregisterCallback}},i=function(e){const t={};for(let n in e)t[n]=r(e[n]);return Object.freeze(t)}},39699(e,t,n){"use strict";n.r(t);var a=n(917);const o={resetWaitingMessage:function(){const e=$("#editCashReceiptRequest_CashReceiptRequestWaitingMessageSubject"),t=$("#editCashReceiptRequest_CashReceiptRequestWaitingMessageContent");(0,a.setValue)(e,"Cash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} is waiting for your approval",!1),(0,a.setValue)(t,"{User.Name.FirstName},\n\nCash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} of batch {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Batch} is waiting for your approval at {TaskInstance.CashReceiptApproval.LevelDescription}.",!1)},resetApprovedMessage:function(){const e=$("#editCashReceiptRequest_CashReceiptRequestApprovedMessageSubject"),t=$("#editCashReceiptRequest_CashReceiptRequestApprovedMessageContent");(0,a.setValue)(e,"Cash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} has been approved",!1),(0,a.setValue)(t,"{CashReceiptDeposit.UserCreatedBy.Name.FirstName},\n\nCash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} of batch {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Batch} has been approved at {TaskInstance.CashReceiptApproval.LevelDescription}.",!1)},resetDeniedMessage:function(){const e=$("#editCashReceiptRequest_CashReceiptRequestDeniedMessageSubject"),t=$("#editCashReceiptRequest_CashReceiptRequestDeniedMessageContent");(0,a.setValue)(e,"Cash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} has been denied",!1),(0,a.setValue)(t,"CashReceiptDeposit.UserCreatedBy.Name.FirstName},\n\nCash receipt deposit request {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Description} of batch {TaskInstance.CashReceiptApproval.CashReceiptDeposit.Batch} has been denied at {TaskInstance.CashReceiptApproval.LevelDescription}.\n\nDenial Reason: {Comment}",!1)}};(0,n(92214).registerEvents)("cashReceiptSelector",o)},40346(e,t,n){"use strict";n.r(t),n.d(t,{clearDirtyList:()=>m,getChangeTracker:()=>w,isDirty:()=>h,overrideGlobalDirtyState:()=>p,removeFromDirtyList:()=>g,setIgnoreDirtyFieldComparison:()=>_,setUpChangeTracking:()=>y,showDirtyScreenModal:()=>v,showDirtyScreenModalAsync:()=>b});var a=n(88157),o=n(66952),r=n(92566),i=n(917),s=n(14144),l=n(62894),c=n(22528);const d=window.skyward,u=c.classNames;let f;function h(e){if("boolean"==typeof f)return f;if(e){const t=$(e),n=t.data("dirty-override");return"boolean"==typeof n?n:C(t)}return!!document.querySelector('[data-dirty="true"]')||$(".js-changeTrackingRoot").toArray().some(function(e){return $(e).data("dirty-override")})}function p(e){f=e}function m(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:window,n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return k(e?$("#".concat(e),t.document):$(t.document.body),n)}function g(e){$.each(e,function(){$(this).attr("data-dirty","false")})}function w(e){const t=$(e).closest(".js-changeTrackingRoot");if(0===t.length)return;const n={isDirty:function(){return h(t)},overrideDirtyState:function(e){!function(e,t){const n=$(e);void 0===t?n.removeData("dirty-override"):(n.data("dirty-override",t),n.trigger("notifyDirty"))}(t,e)},clearDirtyList:function(){return k(t,arguments.length>0&&void 0!==arguments[0]&&arguments[0])}};return n}function v(e){return(0,a.showWarningDialog)("leave this record","You have unsaved data that will be lost if you leave this record.",{onConfirm:e})}function b(){return v().then(()=>!0,()=>!1)}function y(e,t){const n="function"==typeof t?t:S;$(e).each(function(){const e=$(this);e.on("notifyDirty",function(t){const a=$(t.target),o="true"===a.attr("data-dirty");n(e,a,o)}),e.on("change dirty keyup","[data-original-value]:not([excludefromdataobjectviewer], .browseSearchBox, .browseRowsPerPage)",function(t){if(t.trackedChanges)return;t.trackedChanges=!0;const a=$(this);let r=(0,i.getValue)(a),s=(0,i.getOriginalValue)(a);const c=a.is("[override-dirty-string-logic]"),d=a.is("[ignoredirtyfieldcomparison]");if(a.hasClass("multiSelectBackingData"))r=r.length===s.length&&0===$(r).not(s).length&&0===$(s).not(r).length,s=!0;else if(a.hasClass("dmsBackingData"))r=(0,l.changeTracking)(a,r,s),s=!0;else if(a.hasClass("datepicker")&&!a.hasClass("relativeDate")){var u,f,h;r=a.val().substring(0,10).trim().replace(/\b0/g,""),s=null!==(u=null!==(f=null===(h=a.data("original-value"))||void 0===h?void 0:h.substring(0,10))&&void 0!==f?f:a.data("originalRelativeDate"))&&void 0!==u?u:"",s=s.trim().replace(/\b0/g,"")}else if(c||!a.is("input[type=number],input[type=range]")&&!a.is("[data-decimal-mask].masked")){var p,m;r=null!==(p=D(r))&&void 0!==p?p:"",s=(0,o.encodeHtml)(null!==(m=D(s))&&void 0!==m?m:"")}else r=E(r),s=E(s);let g;g=a.hasClass("ckeditor")?window.CKEDITOR.instances[a.attr("id")].checkDirty():!d&&r!==s,a.is("sky-timepicker,sky-datepicker,sky-datetimepicker")?a.find(":input").first().attr("data-dirty",g.toString()):a.attr("data-dirty",g.toString()),n(e,a,g)})})}function _(e,t){$(e).attr("ignoredirtyfieldcomparison",t?"":null)}function C(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:'[data-dirty="true"]';return e.find(t).not(e.find(".js-changeTrackingRoot").find(t)).length>0}function k(e,t){return t&&function(e){const t=e.find("[data-dirty='true']");t.each(function(){let e=$(this);if(!e.is("[data-original-value]")){const t=e.closest("[data-original-value]");t.length&&(e=t)}const t=(0,i.getOriginalValue)(e);(0,i.setValue)(e,t)})}(e),e.find("[data-dirty='true']").attr("data-dirty","false"),Promise.all((0,c.getHtmlViewers)(e).toArray().map(function(e){return d.iframeListener.clearDirtyList(e)}))}function S(e,t,n){const a=e.attr("id");if(n||f||e.data("dirty-override"))(0,s.enableButtons)(a);else if(!t.is("[data-original-value-invalid]")){!function(){const n=(0,r.getContentMessageArea)(e.parent()),a=t.attr("name");if(!a)return;const o=(0,c.getControl)(a,e),i=o.hasClass(u.errorControl),s=o.hasClass(u.warningControl);if(!i&&!s)return;o.removeClass([u.errorControl,u.warningControl]),(0,c.setAriaInvalid)(o,!1);(0,c.getHelpMessage)(a,e).find(".".concat(u.errorText,",.").concat(u.warningText)).not(u.persist.dot()).removeClass([u.errorText,u.warningText]).empty();(0,c.getLabel)(a,e).filter(".".concat(u.errorText,",.").concat(u.warningText)).not(u.persist.dot()).removeClass([u.errorText,u.warningText]),n&&n.modifyValidationCount(i?-1:0,s?-1:0)}();const n=e.is(".workflowContent");C(e,n?':is([data-dirty="true"],[data-original-value-invalid])':'[data-dirty="true"]')||((0,s.disableButtons)(a),function(){e.find(u.errorControl.dot()).removeClass(u.errorControl).removeAttr("aria-invalid"),e.find(u.errorText.dot()).not(u.persist.dot()).removeClass(u.errorText),e.find(u.warningControl.dot()).removeClass(u.warningControl),e.find(u.warningText.dot()).not(u.persist.dot()).removeClass(u.warningText),e.find(".currentRecordContentBaseError").not(".persist").empty(),e.find(".warning-list").empty(),e.find(".help").not(u.persist.dot()).empty();const t=(0,r.getContentMessageArea)(e.parent());null==t||t.resetValidation()}())}}function D(e){return null==e||"string"==typeof e?e:JSON.stringify(e)}function E(e){const t=D(e);if(null==t)return t;let n="",a=t.replace(/,/g,"").trim();if(a.startsWith("-")&&(a=a.slice(1),n="-"),"."===a||""===a)return"";a=function(e){let t=0,n=e.length;for(;"0"===e[t];)t++;if(t===n)return e;if(e.includes("."))for(;"0"===e[n-1];)n--;return e.slice(t,n)}(a);const o=/^(\d*)(\.\d*)?$/.exec(a);if(null===o)return"";return n+"".concat(o[1]||"0").concat(o[2]||".")}},67934(e,t,n){"use strict";n.r(t);var a=n(92214);const o="ui-disabled",r="SelectAllCheckBoxControl",i={init:function(e){const t=$(e);t.filter("[indeterminate]").prop("indeterminate",!0),t.on("click keydown",function(e){this.classList.contains(o)&&"Tab"!==e.key&&!this.classList.contains(r)&&e.preventDefault()})}};(0,a.registerEvents)("checkbox",i)},46740(e,t,n){"use strict";n.r(t),n.d(t,{getData:()=>d,getSerializedOverriddenCheckboxDatas:()=>u});var a=n(3543),o=n(917);const r={init:function(){const e=$(this);if(!0===e.data("checkboxBrowseLoaded"))return;const t=e.attr("id");e.on("browseLoaded.".concat(t),function(){!function(e){const t=e.attr("id"),n=(0,a.getBrowseById)(t),o=e.find(".".concat(i)),r=e.find(".".concat(s)).not(o);n.deserializedOverriddenCheckboxDatas=void 0,o.off("click",g);const d={browse:n,checkboxes:r};o.on("click",d,g),e.off("change",".".concat(l,".").concat(c,".").concat(s),p),e.on("change",".".concat(l,".").concat(c,".").concat(s),{browse:n,checkboxes:r,selectAllCheckbox:o},p)}(e),e.data("checkboxBrowseLoaded",!0)})}};(0,n(92214).registerEvents)("checkboxBrowse",r);const i="selectAll",s="rowSelectCheckbox",l="checkbox",c="checkboxBrowseContent";function d(e){return{id:e.id,data:e.data,browseName:e.browseName,originalDefaultChecked:e.originalDefaultChecked,defaultChecked:e.defaultChecked,checkboxColumnHeaderText:e.checkboxColumnHeaderText,checkboxColumnWidth:e.checkboxColumnWidth,workflowVariableName:e.workflowVariableName,serializedOverriddenCheckboxDatas:u(e),taskInstanceID:e.taskInstanceID,dynamicFilterData:JSON.stringify(e.dynamicFilterData)}}function u(e){return void 0!==e.deserializedOverriddenCheckboxDatas?JSON.stringify(e.deserializedOverriddenCheckboxDatas):e.serializedOverriddenCheckboxDatas}function f(e){if(e.deserializedOverriddenCheckboxDatas)return e.serializedOverriddenCheckboxDatas=void 0,e.deserializedOverriddenCheckboxDatas;const t=JSON.parse(e.serializedOverriddenCheckboxDatas);return null!=t?t:[]}function h(e,t,n,a){e.prop("checked",a),t.each(function(){const e=$(this),t=e.is(":checked");e.prop("checked",a),t!=a&&e.data("dependents")&&e.trigger("change")}),e.prop("indeterminate",!1),n.deserializedOverriddenCheckboxDatas=[],n.defaultChecked=a}function p(e){const t=$(this),n=e.data.browse,a=e.data.selectAllCheckbox,r=t.data("target-id"),i=f(n);if((0,o.getValue)(t)!==n.defaultChecked){const e={Id:r};i.push(e)}else for(let e=0;e<i.length;e++)if(i[e].Id===r){i.splice(e,1);break}0===i.length?h(a,e.data.checkboxes,n,n.defaultChecked):i.length===parseInt(a.data("checkbox-count"))?h(a,e.data.checkboxes,n,!n.defaultChecked):(n.deserializedOverriddenCheckboxDatas=i,a.prop("indeterminate",!0)),t.trigger("focus")}function m(e,t,n){return n=null!=n?n:function(e,t){return 0!==t.length&&t.length!==parseInt(e.data("checkbox-count"))}(e,t),!n&&e.is(":checked")}function g(e){const t=$(this),n=e.data.checkboxes,a=e.data.browse;h(t,n,a,m(t,f(a),void 0))}},16023(e,t,n){"use strict";n.r(t),n.d(t,{toggleAll:()=>f});var a=n(917),o=n(92214);const r=window.skyward;r.checkboxGroup=r.checkboxGroup||{};const i="ui-disabled",s="js-checkboxGroup__row",l="js-checkboxGroup__selectAll",c=m(h),d=m(function(e){const t=e.find(".".concat(s,":not(.checkboxGroup__selectAll)")),n=e.closest(".fieldWrapper"),a=i(n),o=t.toArray().filter(function(e){return i($(e))}),r=0!==o.length;if(a!==r){o.some(function(e){return $(e).isAnimating()})?n.animateToggle(r):n.toggle(r)}function i(e){return e.isAnimatingOpen()||!e.is(":inherentlyHidden")&&!e.isAnimatingClosed()}}),u={init:function(e){if(!e.attr("aria-label")&&!e.attr("aria-labelledby")){let t=e.findLabel();if(t.length>0){const n=t.addIds().attr("id");e.attr("aria-labelledby",n)}}e.on("change readonly","input:not(.".concat(l,")"),function(){c(e)});const t=r.debounce(f,10);e.find(".".concat(l)).filter((e,t)=>!$(t).attr("onchange")).on("change",function(n,a){$(this).hasClass(i)||a||t(e)}),e.on("visible",".".concat(s),function(t){$(t.target).animationPromise().done(function(){c(e)}),d(e)}),h(e)}};function f(e,t){const n=e.find(".".concat(l)),o=e.find(".".concat(s,':not(:inherentlyHidden) input[type="checkbox"]:not(:inherentlyHidden)')).not(n).filter(function(){return!$(this).hasClass(i)&&"none"!==this.style.display}),r=void 0!==t?t:!1===p(o);o.each(function(){(this.indeterminate||this.checked!==r)&&($(this).hasClass(i)||0!==$(this).closest(".".concat(s,":inherentlyHidden")).length||(0,a.setValue)(this,r))})}function h(e){const t=e.find(".".concat(l)),n=e.find(".".concat(s,':not(:inherentlyHidden) input[type="checkbox"]:not(:inherentlyHidden)')).not(t);!function(e,t){const n=e[0].checked;if(void 0===t?(e[0].indeterminate=!0,e[0].checked=!0):(e[0].indeterminate=!1,e[0].checked=!!t),n!==e[0].checked){const t=!0;e.trigger("change",[t])}}(t,p(n));const a=n.filter(function(){return!$(this).hasClass(i)});t.first().toggleClass(i,0===a.length)}function p(e){if(0===e.length)return!1;if(e[0].indeterminate)return;const t=e[0].checked;for(let n=1;n<e.length;n++)if(e[n].indeterminate||e[n].checked!==t)return;return t}function m(e){const t=new Set,n=window.queueMicrotask||setTimeout;return function(a){0===t.size&&n(function(){t.forEach(e),t.clear()}),t.add(a)}}(0,o.registerEvents)("checkboxGroup",u),r.checkboxGroup.toggleAll=f},51269(e,t,n){"use strict";n.r(t),n.d(t,{formatTime:()=>l,setupClock:()=>s});var a=n(81975);function o(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function r(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?o(Object(n),!0).forEach(function(t){i(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):o(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function i(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function s(e,t){c(e,t),setInterval(()=>{c(e,t)},1e3)}function l(e,t){const n=r(r({},{useSeconds:!1}),t);let a=e.getHours(),o=e.getMinutes();const i=a>=12;a%=12,a=0===a?12:a;const s=a.toString().padStart(2,"0"),l=o.toString().padStart(2,"0");let c="".concat(s,":").concat(l);if(n.useSeconds){const t=e.getSeconds().toString().padStart(2,"0");c+=":".concat(t)}return"".concat(c," ").concat(i?"PM":"AM")}function c(e,t){const n=(0,a.now)(),o=l(n,{useSeconds:!0});e.text(n.toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric"})),t.text(o)}},65302(e,t,n){"use strict";n.r(t),n.d(t,{clear:()=>D,copyValue:()=>B,getQueryParameterData:()=>E,populateBoxes:()=>S,registerCodeEEL:()=>_,reinitializeCodeEEL:()=>C,setCodeEELValue:()=>O,setQueryParameterData:()=>P,shouldUpdateBoxesOnClose:()=>k});var a=n(62521),o=n(3543),r=n(88157),i=n(49343),s=n(66952),l=n(2894),c=n(82441),d=n(41709),u=n(917),f=n(16140),h=n(1380),p=n(51325),m=n(92214);function g(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function w(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const v=(0,s.getIdGenerator)("popup","_codeEelBrowse"),b={init:function(e){const t=$(e);t.hasClass("eventsBound")||_(t)}};(0,m.registerEvents)("codeEEL",b);class y{get isInited(){return Boolean(this.codeEELValueData.eelData)}constructor(e){w(this,"codeEEL",void 0),w(this,"codeEELCode",void 0),w(this,"codeEELCodeButton",void 0),w(this,"codeEELDescription",void 0),w(this,"codeEELSelectedValueDisplayField",void 0),w(this,"codeEELDescriptionButton",void 0),w(this,"codeEELValue",void 0),w(this,"filter",void 0),w(this,"postData",void 0),w(this,"tempTableName",void 0),w(this,"additionalFieldsControls",void 0),w(this,"hidePrimaryBrowseButton",void 0),w(this,"hideOptionsButton",void 0),w(this,"hideBrowseControl",void 0),w(this,"layer",void 0),w(this,"codeEELValueData",void 0),w(this,"additionalDynamicFilterValues",void 0),w(this,"lastValue",void 0),w(this,"selectedValue",null),w(this,"singleRequestHandler",void 0),w(this,"transaction",void 0),this.codeEEL=e;const t=e.find(".codeEELCode");t.length>0&&(t.data().lastValidatedValue=t.val()),this.codeEELCode=t,this.codeEELCodeButton=e.find(".codeEELCodeButton");const n=e.find(".codeEELDescription");if(n.length>0&&(n.data().lastValidatedValue=n.val()),this.codeEELDescription=n,this.codeEELSelectedValueDisplayField=e.find(".codeEELSelectedValueDisplayField"),this.codeEELDescriptionButton=e.find(".codeEELDescriptionButton"),this.codeEELValue=e.find(".codeEELValue"),this.filter=e.data("filter"),this.postData=e.data("postdata"),this.tempTableName=e.data("tempTableName"),this.additionalFieldsControls=e.data("additional-fields-controls"),this.hidePrimaryBrowseButton=e.data("hidePrimaryBrowseButton"),this.hideOptionsButton=e.data("hideOptionsButton"),this.hideBrowseControl=e.data("hideBrowseControl"),this.layer=null,this.additionalDynamicFilterValues=e.data("additional-dynamic-filter-values"),this.lastValue=null,this.singleRequestHandler=new s.SequentialOperationHandler,this.transaction=new c.HashTransaction(this.codeEELValue),this.codeEELValueData=this.codeEELValue.data(),this.codeEELValueData.eelData)return this.codeEELValueData.eelData}init(){if(this.isInited)return this;const e=this.codeEEL.findLabel();if(e.length){const t=e.clone();t.remove(".requiredAsterisk");const n=t.find(".sr-only");let a="";n.length>0&&(a="".concat(n.text()," "),n.remove()),a+=t.text().replace(/\*/g,""),this.codeEELCode.attr("aria-label",a+" code"),this.codeEELDescription.attr("aria-label",a+" description");const o=(this.codeEELCode.length?this.codeEELCode:this.codeEELDescription).attr("id");o&&e.attr("for",o)}return this.codeEELValueData.eelData=this,function(e){var t,n,a,o;if(e.requestDataHashReadonly)return;const r=e.requestDataHashKey,i=(0,c.getRequestDataHashes)(e.requestDataHashSrc);if(!i)return;if(e.eelData.codeEELCode.length>0){var s,l;e.codeRequestDataHash=null===(s=i[r+"_code"])||void 0===s?void 0:s.hash,e.dynamicFilterHashes=null===(l=i[r+"_code"])||void 0===l?void 0:l.dependencies}if(e.eelData.codeEELDescription.length>0){var d,u;if(e.descriptionRequestDataHash=null===(d=i[r+"_description"])||void 0===d?void 0:d.hash,!e.dynamicFilterHashes)e.dynamicFilterHashes=null===(u=i[r+"_description"])||void 0===u?void 0:u.dependencies}e.rowDataNonce=null!==(t=null===(n=i[r])||void 0===n?void 0:n.hash)&&void 0!==t?t:"",e.originalSelectedValueHash=e.selectedValueHash=null!==(a=null===(o=i[r])||void 0===o?void 0:o.initialValue)&&void 0!==a?a:""}(this.codeEELValueData),(0,p.setFocusToTextBoxOnClick)(this.codeEEL),this.codeEEL.on("click",".codeEELButton:not(.ui-disabled):not(.mobile-eel-button)",this.bindEventListener(e=>{if(this.selectedValue=this.codeEELValue.val(),void 0!==this.layer&&null!==this.layer&&this.layer.onscreen)l.mobileAccess||this.layer.close(r.CloseReasons.SelectedItem);else{const t=$(e).siblings("input.eELInputContainer__textBox");this.showPopup(t),this.doSearch()}})),this.codeEEL.on("keydown","input:not([readonly],.ui-disabled)",this.bindEventListener(this.keydownEvent)),this.codeEEL.off("refresh").on("refresh",this.bindEventListener(this.refreshEvent)),(0,c.setupDependency)(this.codeEELCode.data(),{Id:this.codeEEL.attr("id"),Refresh:"true"},(0,u.getScopeContainer)(this.codeEEL)),(0,c.setupDependency)(this.codeEELDescription.data(),{Id:this.codeEEL.attr("id"),Refresh:"true"},(0,u.getScopeContainer)(this.codeEEL)),this.addInitialInputEvent(),this.codeEEL.addClass("eventsBound"),this.codeEELValue.trigger("controlLoaded"),this}getBrowsePostData(){return function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?g(Object(n),!0).forEach(function(t){w(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):g(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}({filter:JSON.stringify(this.filter)},this.postData)}closeOpenEelBrowse(e,t){this.layer=null,this.lastValue=null,this.singleRequestHandler.close(),l.mobileAccess||t.trigger("focus"),this.addInitialInputEvent(),(0,o.removeBrowse)(e),(0,o.removeOpenBrowse)(e),t.trigger("CodeEelClosed")}handleTabPress(e,t){this.codeEEL.is(".quickEntryText")?((0,i.closePopup)(void 0,r.CloseReasons.Tab),this.closeOpenEelBrowse(e,t),(0,d.focusAfter)(t)):(0,a.handlePopupBrowseTabPress)()}bindEventListener(e){const t=this;return function(n){return e.call(t,this,n)}}createModalLayer(e,t){const n=t.attr("id"),c=$("<div>",{class:"popup--browse",id:n+"_popup"}),d=$("<div>",{id:e,class:"browse browseStaticHeight"});c.append(d);const u=$("<div>",{class:"popup--announcement sr-only","aria-live":"polite",role:"status"});c.append(u);const h=t.closest(".js-showEELContainer"),p=t=>{(null==t?void 0:t.browseId)===e&&(this.selectedValue=t.selectedId)};a.eventCallbacks.recordSelectionMade.registerCallback(p),t.attr("aria-expanded","true");const m=[{onEvents:"keydown",bindTo:d,runFunction:this.bindEventListener((n,a)=>{if(t.length>0&&a.currentTarget!==t[0]&&a.altKey&&("ArrowDown"===a.key||"ArrowUp"===a.key))return t.trigger("focus"),a.preventDefault(),void a.stopPropagation();"Esc"===a.key&&((0,i.closePopup)(void 0,r.CloseReasons.Escape),this.closeOpenEelBrowse(e,t))})},{onEvents:"keydown",bindTo:t,runFunction:this.bindEventListener((t,n)=>{"Tab"===n.key&&(this.handleTabPress(e,$(t)),n.preventDefault())})},{onEvents:l.isAndroidApp?"keyup":"input",bindTo:t,runFunction:(0,f.default)(this.bindEventListener(this.inputEvent))},{onEvents:"rowChanged browseLoaded.".concat(e),bindTo:d,runFunction:this.bindEventListener((n,r)=>{const i=(0,o.getBrowseById)(e),s=(0,a.getCurrentRowElement)("unlocked",e,i.currentRow);t.attr("aria-activedescendant",s.addIds().attr("id")),s.attr("aria-selected","true")})},{onEvents:"browseLoaded.".concat(e),bindTo:d,runFunction:this.bindEventListener((n,r)=>{var i,l,c;const d=(0,o.getBrowseById)(e),u=null===(i=this.layer)||void 0===i?void 0:i.container.find(".unlockedBrowseTableBody[role='listbox']");u&&u.length>0&&(u.addIds(),t.attr("aria-controls",u.attr("id")));const f=null===(l=this.layer)||void 0===l?void 0:l.container.find(".popup--announcement");f&&0===(null===(c=d.primaryKeys)||void 0===c?void 0:c.length)?(0,s.ensureLiveAreaAnnounced)(f,"No records to display"):null==f||f.text("");const h=this.codeEELValue.val();if(!h||""===h)return;const p=(0,a.getCurrentRowElement)("unlocked",e,d.currentRow),m=(0,a.getCurrentRowElement)("locked",e,d.currentRow);p.attr("aria-checked","true"),p.addClass("codeEEL__browseRow--selected"),m.addClass("codeEEL__browseRow--selected")})}];this.layer=(0,r.showCodeEELDialog)(c,t,h,(n,r)=>{let i=!1,s=!1;if(this.selectedValue!=this.codeEELValue.val()){const t=(0,o.getBrowseById)(e),n=t.primaryKeys.indexOf(parseInt(this.selectedValue,10));this.codeEELValueData.selectedValueHash=n>-1?t.rowDataHash[n]:null,this.codeEELValue.val(this.selectedValue),i=!0}if(k(this.codeEEL,this.selectedValue,r)){s=!0;const e=this.updateBoxes(!1);i&&e.then(()=>{this.codeEELValue.trigger("change")})}i&&!s&&this.codeEELValue.trigger("change"),a.eventCallbacks.recordSelectionMade.deregisterCallback(p),this.closeOpenEelBrowse(e,t),t.attr("aria-controls",null),t.attr("aria-activedescendant",null),t.attr("aria-expanded","false")},this,m)}getEELBrowseData(e,t,n){var a;const o=t.hasClass("codeEELCode"),r=t.data("action");return{id:e,pageModule:this.codeEELValueData.area,pageObject:this.codeEELValueData.controller,displayName:this.codeEELValueData.displayName,pageScreen:r,browseType:"Default",routeModule:this.codeEELValueData.area,routeObject:this.codeEELValueData.controller,dataModule:this.codeEELValueData.area,dataObject:this.codeEELValueData.controller,browseName:"browse",selectMode:!0,codeEelName:this.codeEELValue.attr("name"),codeEelDescription:this.codeEELDescription.attr("id"),hidePrimaryBrowseButton:this.hidePrimaryBrowseButton,routeHash:o?this.codeEELValueData.codeRouteHash:this.codeEELValueData.descriptionRouteHash,requestDataHash:o?this.codeEELValueData.codeRequestDataHash:this.codeEELValueData.descriptionRequestDataHash,rowDataDefinitions:{value:null!==(a=this.codeEELValueData.primaryKeyName)&&void 0!==a?a:""},dynamicFilterHashes:this.codeEELValueData.dynamicFilterHashes,dynamicFilterValues:$.extend({},this.additionalDynamicFilterValues,n),rowDataNonce:this.codeEELValueData.rowDataNonce,taskName:"",hideBrowseControl:this.hideBrowseControl,refreshTimeout:-1,data:this.getBrowsePostData(),keyEventsEnabled:!0,renderViewButton:!0,disableBrowseSort:!0,hideOptionsButton:this.hideOptionsButton,preventColumnResize:!1,renderQuickFilter:!1,queryParameterData:this.codeEEL.data("codeEelQueryParameterData"),queryParameterDataHash:o?this.codeEELValueData.codeQueryParameterDataHash:this.codeEELValueData.descriptionQueryParameterDataHash,primaryKeys:[],resize(){}}}addToBrowseList(e,t){const n=(0,c.getDependencyDataWithoutWaiting)(t.data(),(0,u.getScopeContainer)(t));(0,o.addBrowse)(this.getEELBrowseData(e,t,n),e),(0,o.prependOpenBrowse)(e)}showPopup(e){const t=v.getNewId();this.addToBrowseList(t,e),this.createModalLayer(t,e)}doSearch(e){const t=(0,o.getInnerBrowse)(this.layer.container);if(!t)return;const n={codeEELSearchText:e,seekId:Number(this.codeEELValue.val()),tempTableName:this.tempTableName};this.singleRequestHandler.run(e=>(0,a.performCodeEELSearch)(t.id,n,e))}async updateBoxes(e){if(!this.getFirstTextBox())return void console.warn("Tried to set value on codeeel with no inputs");e=0!=e;const t=await this.getBoxValues(this.codeEELValue.val(),{hideGlass:!0});S(this.codeEEL,t,e),t.additionalFields&&this.codeEEL.data("additionalFields",t.additionalFields),t.deniedAdditionalFields&&this.codeEEL.data("deniedFields",t.deniedAdditionalFields),this.layer&&!this.layer.closing||this.codeEEL.trigger("eelComplete"),M(this.codeEEL,this.additionalFieldsControls,t.additionalFields)}keydownEvent(e,t){const n=$(e);if(null!=this.layer)return void(!t.altKey||"ArrowUp"!==t.key&&"ArrowDown"!==t.key||(t.preventDefault(),t.stopPropagation(),(0,h.setFocus)(this.layer)));const a=(0,u.getValue)(this.codeEEL);if("Escape"===t.key&&a&&null==this.layer)return t.stopPropagation(),D(this.codeEEL,!0),void(this.selectedValue=null);if("ArrowUp"===t.key||"ArrowDown"===t.key||"Enter"===t.key){if(l.mobileAccess&&n.is(":animated"))return;return this.showPopup(n),this.doSearch(),void(this.selectedValue=null)}}refreshEvent(e,t){const n=this.codeEELValue.val();return void 0!==n&&""!==n&&this.setValue(n,!1,!0,!0),!1}inputEvent(e){const t=$(e),n=t.val();l.mobileAccess&&t.is(":animated")||null!=this.lastValue&&n.toLowerCase()===this.lastValue.toLowerCase()||(null==this.layer&&this.showPopup(t),this.doSearch(n),this.lastValue=t.val(),this.selectedValue=null)}addInitialInputEvent(){this.codeEEL.one(l.isAndroidApp?"keyup":"input","input:not([readonly],.ui-disabled)",this.bindEventListener(this.inputEvent))}getFirstTextBox(){return this.codeEELValueData.codeRequestDataHash&&this.codeEELCode.length?this.codeEELCode:this.codeEELValueData.descriptionRequestDataHash&&this.codeEELDescription.length?this.codeEELDescription:null}copyTo(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];e.codeEELValue.val(this.codeEELValue.val());const a={code:this.codeEELCode.val(),description:this.codeEELDescription.val(),selectedValueDisplayData:this.codeEEL.find(".codeEELSelectedValueDisplayField").val(),selectedValueHash:this.codeEELValueData.selectedValueHash};n&&S(e.codeEEL,a,!t),e.codeEELValueData.selectedValueHash=a.selectedValueHash}async setValue(e){var t,n,a;let o=arguments.length>1&&void 0!==arguments[1]&&arguments[1],r=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],i=arguments.length>3&&void 0!==arguments[3]&&arguments[3],s=(null!==(t=null===(n=e)||void 0===n?void 0:n.toString())&&void 0!==t?t:"")===(null!==(a=this.codeEELValue.val())&&void 0!==a?a:"");if(s&&!i)return;if(this.getFirstTextBox())return this.singleRequestHandler.run(t=>this.transaction.run(t,async n=>{let a;if(n.setValue(e),null!=e&&isNaN(e)&&(e=""),(0,c.isNotEmpty)(e)){if(a=await this.getBoxValues(e,{signal:t,useOriginalValueHash:!i}),t.aborted)return;void 0===a&&(n.setValue(""),s=!1)}void 0===a&&(a={code:"",description:"",selectedValueDisplayData:"",selectedValueHash:void 0}),r&&S(this.codeEEL,a,!o&&!s),this.codeEELValueData.selectedValueHash=a.selectedValueHash}));console.warn("Tried to set value on codeeel with no inputs")}async getBoxValues(e,t){var n;const o=this.getFirstTextBox(),r=await(0,c.waitForDependencies)(o.data(),(0,u.getScopeContainer)(o),null==t?void 0:t.signal),i=this.getEELBrowseData("temp",o,r),s=(0,a.getRequiredBrowseData)(i,{tempTableName:this.tempTableName});e!=this.codeEELValueData.originalValue||null!==(n=null==t?void 0:t.useOriginalValueHash)&&void 0!==n&&!n||(s.selectedValueHash=this.codeEELValueData.originalSelectedValueHash);return $.ajax({url:"".concat(l.virtualDir).concat(this.codeEELValueData.area,"/").concat(this.codeEELValueData.controller,"/codeeel/").concat(e),type:"POST",dataType:"JSON",data:s,activityIndicator:{hideGlass:null==t?void 0:t.hideGlass},suppressErrors:e=>d(e),signal:null==t?void 0:t.signal}).catch(e=>{if(!d(e))throw e});function d(e){var t;return 500===e.status&&"9C3EDFF2-8532-4428-9FA9-493B64285989"===(null===(t=e.responseJSON)||void 0===t?void 0:t.clientIdentifier)}}}function _(e){T(e)}function C(e){const t=e.find(".codeEELValue"),n=t.data("selectedValueHash");e.find("*").addBack().removeData().off(),_(e),t.data("selectedValueHash",n)}function k(e,t,n){const a=null!==t&&""!==t;if(!a&&!0===e.data("allow-freeform-text"))return!1;return n===r.CloseReasons.SelectedItem&&(a||!0!==e.data("keep-invalid-values"))||o(e.find(".codeEELCode"))||o(e.find(".codeEELDescription"));function o(e){return e.length>0&&e.val()!==e.data().lastValidatedValue}}function S(e,t,n){const a=e.find(".codeEELCode"),o=t.code||"";a.val(o),a.length>0&&(a.data().lastValidatedValue=o);const r=e.find(".codeEELDescription"),i=t.description||"";r.val(i),r.length>0&&(r.data().lastValidatedValue=i),e.find(".codeEELSelectedValueDisplayField").val(t.selectedValueDisplayData||""),e.trigger("codeEELValuesUpdated"),e.find(".codeEELValue").data("selectedValueHash",t.selectedValueHash),n&&(x(e),M(e,null,t.additionalFields)),0!==e.closest(".quickEntryText").length&&e.find(".codeEELDescription").trigger("dirty")}function D(e,t){e.find(".codeEELCode").val(""),e.find(".codeEELDescription").val(""),e.find(".codeEELSelectedValueDisplayField").val(""),e.find(".codeEELValue").val(""),e.trigger("codeEELValuesUpdated"),t&&x(e)}function E(e){let t=e.data("codeEelQueryParameterData");if("string"==typeof t)try{t=JSON.parse(t)}catch(e){t={}}return $.extend({},t)}function P(e,t){let n=t;"string"==typeof n&&""!==n?n=JSON.parse(n):"object"!=typeof n&&(n=""),e.data("codeEelQueryParameterData",n)}function O(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],a=!(arguments.length>3&&void 0!==arguments[3])||arguments[3];return T(e).setValue(t,n,a)}function B(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],a=!(arguments.length>3&&void 0!==arguments[3])||arguments[3];const o=T(e),r=T(t.closest(".codeEEL"));o.copyTo(r,n,a)}function T(e){return new y(e).init()}function x(e){e.find(".codeEELValue").trigger("change"),!0===e.data("keep-invalid-values")&&(e.find(".codeEELCode").trigger("change"),e.find(".codeEELDescription").trigger("change"))}function M(e,t,n){if(e&&(t||(t=e.data("additional-fields-controls")),t)){const a=(0,u.getScopeContainer)(e);a.length>0&&$.each(t,function(e,t){let o=null;if(n){const t=n[e];t&&(o=t)}const r=a.find("[name='"+JSON.parse(t)+"']");(0,u.setValue)(r,o)})}}},78036(e,t,n){"use strict";n.r(t),n.d(t,{collapseAll:()=>C,expandAll:()=>_,show:()=>b,toggle:()=>y});var a=n(92214),o=n(68337),r=n(49343);const i="unlockedHeader",s="toolbar--browseControls",l="unlockedBrowseBody",c="collapsePanelHeader",d="collapsePanelContents",u="toCollapse",f="collapsePanel",h="browseFooter",p="collapsed",m="collapse",g="expanded",w="expand",v={init:k,toggle:y,collapseAll:C,expandAll:_};function b(e){const t=e.find(".".concat(c)),n=e.find(".".concat(d));n.hasClass(p)&&(S(n,t,!1),D())}function y(){const e=$(this),t=e.siblings(".".concat(d));S(t,e,t.hasClass(g)),D()}function _(){$(".".concat(f)).each(function(){const e=$(this).children(".".concat(d)),t=$(this).children(".".concat(c));e.hasClass(p)&&S(e,t,!1)})}function C(){$(".".concat(f)).each(function(){const e=$(this).children(".".concat(d)),t=$(this).children(".".concat(c));e.hasClass(g)&&S(e,t,!0)})}function k(e){const t=$(e);var n;(t.find(".".concat(u)).removeClass("expanded ".concat(u)).addClass(p),!0===t.data("dirty"))&&(null===(n=skyward.changeTracking.getChangeTracker(t))||void 0===n||n.overrideDirtyState(!0))}function S(e,t,n){const a="".concat(n?g:p),r="".concat(n?p:g),i=n?"Expand":"Collapse",s=".".concat(n?m:w),l=(0,o.swapSvg)(t.find(s),i,"CollapsePanel");e.removeClass(a),e.addClass(r),l.attr("aria-label",i),e.trigger("collapsepanel:toggled",{expanded:!n}),$(window).trigger("resize")}function D(){$(".".concat(f)).each(function(){const e=$(this),t=e.find(".".concat(i));t.length>0&&t.width(e.width()-5);const n=e.find(".".concat(l));n.length>0&&n.width(e.width()-5);const a=e.find(".".concat(h));a.length>0&&a.width(e.width()-5);const o=e.find(".".concat(s));o.length>0&&(o.width(e.width()-5),o.width(e.width()-5))})}(0,a.registerEvents)("collapsePanel",v),(0,r.registerLoadDOMCallback)(k),(0,r.registerLayoutResizeCallback)(D)},53054(e,t,n){"use strict";n.r(t),n.d(t,{toggle:()=>m});var a=n(2894),o=n(88157),r=n(16140),i=n(92214),s=n(68337);const l=window.skyward,c={color:"",preferredFormat:"hex",theme:"sp-skyward ui-control-container",palette:[["rgb(0, 0, 0)","rgb(67, 67, 67)","rgb(102, 102, 102)","rgb(153, 153, 153)","rgb(183, 183, 183)","rgb(204, 204, 204)","rgb(217, 217, 217)","rgb(239, 239, 239)","rgb(243, 243, 243)","rgb(255, 255, 255)"],["rgb(152, 0, 0)","rgb(255, 0, 0)","rgb(255, 153, 0)","rgb(255, 255, 0)","rgb(0, 255, 0)","rgb(0, 255, 255)","rgb(74, 134, 232)","rgb(0, 0, 255)","rgb(153, 0, 255)","rgb(255, 0, 255)"],["rgb(230, 184, 175)","rgb(244, 204, 204)","rgb(252, 229, 205)","rgb(255, 242, 204)","rgb(217, 234, 211)","rgb(208, 224, 227)","rgb(201, 218, 248)","rgb(207, 226, 243)","rgb(217, 210, 233)","rgb(234, 209, 220)"],["rgb(221, 126, 107)","rgb(234, 153, 153)","rgb(249, 203, 156)","rgb(255, 229, 153)","rgb(182, 215, 168)","rgb(162, 196, 201)","rgb(164, 194, 244)","rgb(159, 197, 232)","rgb(180, 167, 214)","rgb(213, 166, 189)"],["rgb(204, 65, 37)","rgb(224, 102, 102)","rgb(246, 178, 107)","rgb(255, 217, 102)","rgb(147, 196, 125)","rgb(118, 165, 175)","rgb(109, 158, 235)","rgb(111, 168, 220)","rgb(142, 124, 195)","rgb(194, 123, 160)"],["rgb(166, 28, 0)","rgb(204, 0, 0)","rgb(230, 145, 56)","rgb(241, 194, 50)","rgb(106, 168, 79)","rgb(69, 129, 142)","rgb(60, 120, 216)","rgb(61, 133, 198)","rgb(103, 78, 167)","rgb(166, 77, 121)"],["rgb(133, 32, 12)","rgb(153, 0, 0)","rgb(180, 95, 6)","rgb(191, 144, 0)","rgb(56, 118, 29)","rgb(19, 79, 92)","rgb(17, 85, 204)","rgb(11, 83, 148)","rgb(53, 28, 117)","rgb(116, 27, 71)"],["rgb(91, 15, 0)","rgb(102, 0, 0)","rgb(120, 63, 4)","rgb(127, 96, 0)","rgb(39, 78, 19)","rgb(12, 52, 61)","rgb(28, 69, 135)","rgb(7, 55, 99)","rgb(32, 18, 77)","rgb(76, 17, 48)"]]},d=$.extend({},c,{showPalette:!0,showInput:!0,palette:[["#FFFFCC","#FFFF99","#CCCC99","#CCFFCC","#99FF99"],["#99CC99","#CCFFFF","#99FFFF","#99CCCC","#CCCCFF"],["#9999FF","#9999CC","#FFCCFF","#FF99FF","#CC99CC"],["#FFCCCC","#FF9999","#CC9999","#FFFFFF","#CCCCCC"]],chooseText:"Select"}),u=$.extend({},c,{showPaletteOnly:!0,hideAfterPaletteSelect:!0,palette:[["#CCFF00","#FF9966","#FF99CC","#5575B4","#66CCCC"],["#CCCCFF","#A30000","#009999","#5BCF57","#FFCC33"]],chooseText:"Select"}),f=$.extend({},c,{showPaletteOnly:!0,hideAfterPaletteSelect:!0,palette:[["#FFFFFF","#000000"]]}),h=$.extend({},c,{showPalette:!0,showInput:!0,palette:[["#aafaa8","#f4fe8f","#fc9e6e","#faaaa8"],["#049c00","#e8ff00","#ff9a00","#ff0000"]],chooseText:"Select"}),p={init:function(e){const t=$(e),n=function(e){let t;t=e.hasClass("textColorPicker")?f:e.hasClass("partialPaletteOnly")?u:e.hasClass("teacherInputPaletteSettings")?h:d;const n=$.extend({},t),a=e.data();if(a.colorPalette){const e=w(a.colorPalette);n.palette=e}if(a.additionalColorPalette){const e=w(a.additionalColorPalette);void 0!==n.palette&&(n.palette=n.palette.concat(e))}n.disabled=e.is("[readonly]"),n.allowEmpty=a.enableTransparent,a.color&&(n.color=a.color);return function(e,t){let n,a=!1;function i(t){const r=e.spectrum("container");a||(!function(e){const t=e.find(".sp-button-container");v(t,".sp-choose","Save","Save"),v(t,".sp-cancel","Cancel","Cancel")}(r),a=!0);const i=function(e,t){"escape"===t&&r.find(".sp-cancel").trigger("click"),e.container.find(r).detach()},s={closeOnClick:!1,initialFocusElement:".sp-thumb-active",preserveFocus:()=>!0};n=(0,o.newModalLayer)(r,i,s),n.container.attr("tabindex","-1")}function s(a){const o=e.spectrum("container");t.showPaletteOnly||$(e[0].ownerDocument).off("click.spectrum");tinycolor(a);b(o),f(o),(0,r.default)(()=>{l.dialogFocusManager.setFocus(n)},1)()}function c(t){const n=e.next(".sp-skyward");if(0===n.length)return;const a=g(t);n.attr("aria-label",a)}function d(t){n.container.trigger("focus");f(e.spectrum("container")),(0,r.default)(()=>{l.dialogFocusManager.setFocus(n)},1)(),b(e.spectrum("container"))}function u(t){n&&!n.closing&&n.close();const a=e.next(".sp-replacer");a.attr("aria-expanded","false"),a.removeAttr("aria-controls")}function f(t){const n=e.next(".sp-replacer");n.attr("aria-expanded","true");const a="colorPickerDialogContainer";t.attr("id",a),t.removeAttr("tabindex"),n.attr("aria-controls",a),t.attr("aria-label","Color Options");const o=t.find(".sp-palette-container");o.attr("aria-label","Select a color"),o.attr("role","listbox");o.find(".sp-thumb-el").each(function(){const e=$(this);e.attr("tabindex","0"),e.attr("role","option");const t=e.attr("title");e.attr("aria-label",t);let n=!1;e.hasClass("sp-thumb-active")&&(n=!0),e.attr("aria-selected",n.toString())});const r=t.find(".sp-input");r.length>0&&r.attr("aria-label","HEX Color Value")}t.beforeShow=i,t.show=s,t.move=d,t.change=c,t.hide=u}(e,n),n}(t);t.spectrum(n),function(e,t){const n=e.next(".sp-skyward");if(0===n.length)return;n.attr("tabindex",0);const o=e.attr("id");let r,i;if(o){const t="".concat(o,"_picker");n.attr("id",t);const a=e.closest(".togglableColorPicker");if(a.length>0){const t=e.data("id");i=$.findLabel(t);const n=a.find(".checkbox"),o=n.findLabel().getIdAndPrefix().id;let r=i.getIdAndPrefix().id;r||(r="".concat(a.attr("id"),"label"),i.attr("id",r)),n.attr("aria-labelledby","".concat(r," ").concat(o))}else if(i=e.findLabel(),0===i.length){const t=e.getIdAndPrefix().id;t&&(i=$.findLabel(t))}i.length>0&&(i.removeAttr("for"),r=i[0].textContent,i.on("click",()=>{n.trigger("focus")}))}n.attr("role","combobox"),n.attr("aria-haspopup","dialog"),n.attr("aria-expanded","false");const s=g(e.spectrum("get"),r);n.attr("aria-label",s);n.find(".sp-dd").attr("aria-hidden","true"),n.on("enter",function(){n.trigger("click")});const l=e.spectrum("container");l.on("enter",".sp-thumb-el",function(){const e=$(this),n=l.find(".sp-choose:visible").length>0;e.trigger("click"),n&&t.show&&t.show()}),t.disabled&&(n.attr("aria-readonly","true"),n.attr("aria-describedby",a.readOnlyAnnouncementID))}(t,n)}};function m(e,t){const n=$(e),o=n.next(".sp-skyward");0!==o.length&&(t?(n.spectrum("disable"),o.attr("aria-readonly","true"),o.attr("aria-describedby",a.readOnlyAnnouncementID)):(n.spectrum("enable"),o.removeAttr("aria-readonly"),o.removeAttr("aria-describedby")))}function g(e,t){let n="Open color picker";return t&&(n="".concat(t,", ").concat(n)),e&&(n+=", selected color ".concat(e.toHexString())),n}function w(e){let t=[];const n=[];for(let a=0;a<e.length;a++)a%5==0&&(t=[],n.push(t)),t.push(e[a]);return n}function v(e,t,n,a){const o=e.find(t);o.css("display","none"),e.append(function(e,t,n){const a=(0,s.getSvg)(t).addClass("buttonSvg svgNoHover"),o=$("<span>",{class:"sp-buttonText"}).html(n),r=$("<a>",{role:"button",href:"javascript:void(0)",class:e.attr("class")+" sp-skyward-button"}).html(a).append(o);return r.on("click",function(){e.trigger("click")}),r}(o,n,a))}function b(e){const t=e.find(".sp-thumb-active");if(!t.length)return;const n=t.data("color");if(!n)return;0===tinycolor(n).getAlpha()&&(t.removeClass("sp-thumb-dark"),t.addClass("sp-thumb-light"))}(0,i.registerEvents)("colorPicker",p)},19092(e,t,n){"use strict";n.r(t);var a=n(92214);const o="ui-disabled",r={init:function(e){i($(e))},initSXL2:function(e){const t=$(e);t.is(":disabled")&&(t.removeAttr("disabled").addClass(o),t.attr("aria-readonly","true"));i(t)}};function i(e){e.on("mousedown touchstart click keydown wheel",function(e){this.classList.contains(o)&&"Tab"!==e.key&&("wheel"!==e.type&&"keydown"!==e.type&&this.focus(),e.preventDefault(),e.stopPropagation())})}(0,a.registerEvents)("comboBox",r)},92566(e,t,n){"use strict";n.r(t),n.d(t,{getContentMessageArea:()=>d,getDefaultConfirmationMessage:()=>c});var a=n(2894),o=n(88157),r=n(66952);const i={init:function(){var e,t;const n=$(this),a=m(n),o=null===(e=skyward.browse)||void 0===e||null===(t=e.getContainingBrowse)||void 0===t?void 0:t.call(e,n);o&&!o.contentMessageArea&&(o.contentMessageArea=a);n.parent().find(".toolbar a.button:not(.cancel)").off("click.cma").on("click.cma",function(){null==a||a.getContentMessageAreaElement().attr("data-last-button-clicked-name",$(this).find("span.anchorText").text())})},showDetails:function(e){const t=$(e.currentTarget);if(0!==t.closest("a,button").length)return;const n=t.find(".cmaMessage"),a=n.find(".cmaMessageText"),i=0===a.length?n.text():a.text();(0,o.showDialog)("Additional Information",(0,r.encodeHtml)(i),[],{anchorTo:t.find(".svg")})}};(0,n(92214).registerEvents)("contentMessageArea",i);const s=new WeakMap,l=new WeakMap;function c(){return"The information has been successfully saved."}function d(e){const t=l.get(e[0]);return t||m(e.children(".contentMessageArea").first())}function u(){const e={message:void 0,show:function(){e.message&&e.message.removeClass("cmaHidden");return e},hide:function(t){e.message&&(t?e.message.animate({opacity:0},{complete:function(){e.message.addClass("cmaHidden")}}):e.message.addClass("cmaHidden"));return e},reset:function(){return e.hide()},isVisible:function(){return e.message&&!e.message.hasClass("cmaHidden")}};return e}function f(){const e=u();e.countSpan=void 0,e.confirmButtonNameSpan=void 0;let t=0,n="Save";return e.setCount=function(n){if(e.countSpan){var a;e.countSpan.text(n),t=n,null===(a=e.message)||void 0===a||a.find(".subjectVerbAgreementSpan").each(function(){const e=$(this),t=e.data();n>1?e.text(t.plural):e.text(t.singular)})}return e},e.getCount=function(){return t},e.setConfirmButtonName=function(t){e.confirmButtonNameSpan&&(e.confirmButtonNameSpan.text(t),n=t);return e},e.getConfirmButtonName=function(){return n},e.reset=function(){return e.hide().setCount(0).setConfirmButtonName("Save")},e}function h(e,t){const n=u(),a=e.find(t);if(0===a.length)return n;n.message=a;const o=a.find(".cmaMessage");return n.setMessage=function(e){return o.html(e),n},n.reset=function(){return n.hide(),o.html(""),n},n}function p(e,t){const n=e,o=function(e){const t=f(),n=e.find(".cmaErrorMessage"),a=t.reset.bind(t);return 0===n.length||(t.message=n,t.countSpan=t.message.find(".countSpan"),t.confirmButtonNameSpan=t.message.find(".confirmButtonNameSpan"),t.allErrorsAreHidden=!1,t.reset=function(){return t.allErrorsAreHidden=!1,a()}),t}(n),r=function(e){const t=f(),n=e.find(".cmaWarningMessage");return 0===n.length||(t.message=n,t.countSpan=t.message.find(".countSpan"),t.confirmButtonNameSpan=t.message.find(".confirmButtonNameSpan")),t}(n),i=function(e,t){const n=u();n.hasValue=!1,n.isStandalone=!1;let o=e.find(".cmaConfirmationMessage");if(0===o.length&&(n.isStandalone=!0,o=t.find(".cmaConfirmationMessage").filter(function(){return!s.has(this)}).first()),0===o.length)return n;s.set(o[0],n),n.message=o;const r=o.find(".cmaMessage");n.hasValue=o.hasClass("cmaHasValue");const i=o.hasClass("js-animateConfirmationMessage"),l={show:n.show.bind(n),hide:n.hide.bind(n),isVisible:n.isVisible.bind(n)};return n.hide=function(){return i?(n.message.animate({opacity:0},{complete:function(){n.isStandalone&&(l.hide(!1),c(!0)),e.trigger("CMAConfirmationHidden")}}),n):(l.hide(),c(!0),n)},n.show=function(){return i&&(n.message.attr("aria-hidden","true"),n.message.attr("aria-busy","true")),!n.isStandalone&&i||(c(!1),l.show()),i?(n.message.animate({opacity:1},{complete:function(){n.message.attr("aria-busy","false"),n.message.attr("aria-hidden","false"),window.setTimeout(function(){n.hide(),e.trigger("SaveAnimationRedirect")},3e3)}}),n):n},n.reset=function(){var e;return n.hide(),r.html(""),null===(e=n.message)||void 0===e||e.removeClass("cmaHasValue"),n.hasValue=!1,n},n.isVisible=function(){return!n.isStandalone&&l.isVisible()},n.setMessage=function(e){var t;return r.html(e),null===(t=n.message)||void 0===t||t.addClass("cmaHasValue"),n.hasValue=!0,n},n;function c(e){a.mobileAccess||n.message.siblings().toggle(e)}}(n,t),l=h(n,".cmaScopeMessage"),c=h(n,".cmaInformationMessage");p();const d={getContentMessageAreaElement:function(){return n},resetValidation:function(){return o.reset(),r.reset(),p(),d},resetConfirmation:function(){return i.reset(),p(),d},resetInformation:function(){return c.reset(),p(),d},hideScope:function(e){l.hide(e),p()},hideInformation:function(e){c.hide(e),p()},setScopeMessage:function(e){l.setMessage(e),p()},setInformationMessage:function(e){c.setMessage(e),p()},setConfirmationMessage:function(e){i.setMessage&&i.setMessage(e);p()},setValidationCount:function(e,t){return o.setCount(e),r.setCount(t),d},getValidationCount:function(){return{errorCount:o.getCount(),warningCount:r.getCount()}},modifyValidationCount:function(e,t){const n=isFinite(e)?e:0,a=isFinite(t)?t:0,{errorCount:o,warningCount:r}=this.getValidationCount();o+n<0&&console.warn("Reducing error count by ".concat(n," but there are only ").concat(o," errors"));r+a<0&&console.warn("Reducing warning count by ".concat(a," but there are only ").concat(r," warnings"));const i=Math.max(o+n,0),s=Math.max(r+a,0);this.setValidationCount(i,s),0===i&&0===s&&this.resetValidation();return{errorCount:i,warningCount:s}},setConfirmButtonName:function(e){return o.setConfirmButtonName(e),r.setConfirmButtonName(e),d},setAllErrorsAreHidden:function(e){return o.allErrorsAreHidden=e,d},showValidation:function(){(0===o.getCount()&&!0===o.allErrorsAreHidden||o.getCount()>0)&&(!0===o.allErrorsAreHidden&&o.message.find(".cmaMessageText").text("Errors were encountered while attempting to Save. Please contact your Skyward Administrator."),o.setConfirmButtonName(n.attr("data-last-button-clicked-name")),o.show());r.getCount()>0&&(r.setConfirmButtonName(n.attr("data-last-button-clicked-name")),r.show());return p(),d},showConfirmation:function(){i.hasValue&&i.show();return p(),d},showScope:function(){return l.show(),p(),d},showInformation:function(){return c.show(),p(),d}};return d;function p(){const e=n.hasClass("cmaHidden"),t=n.is(":visible"),a=!!(o.isVisible()||r.isVisible()||i.isVisible()||l.isVisible()||c.isVisible());e||t===a||(n.toggle(a),$(window).trigger("resize"))}}function m(e){if(0===e.length)return null;const t=e.parent();let n;if(l.delete(t[0]),n=a.mobileAccess&&t.hasClass("js-mobileToolbarControlledContent")?t.siblings(".js-mobileDetailsCMA").first():e,n.length>0){const e=p(n,t);return l.set(t[0],e),e.showConfirmation(),e}return null}},917(e,t,n){"use strict";n.r(t),n.d(t,{changeCheckBoxWithSelectAll:()=>j,changeId:()=>F,clearValue:()=>N,copyValue:()=>D,disable:()=>E,enable:()=>P,getCurrentValuesData:()=>R,getEditableFields:()=>A,getOriginalValue:()=>C,getOriginalValuesData:()=>I,getRowDataHash:()=>y,getScopeContainer:()=>V,getUnencodedValue:()=>_,getValue:()=>b,getValueToString:()=>v,hide:()=>B,setComboBoxOptions:()=>M,setDataAttribute:()=>k,setValue:()=>S,show:()=>T,toggle:()=>O,toggleOption:()=>W,toggleVisible:()=>x,valueHasChanged:()=>L});var a=n(2894),o=n(81975),r=n(65302),i=n(53054),s=n(83787),l=n(25560),c=n(92214),d=n(30368),u=n(64801),f=n(64611),h=n(83874),p=n(48617),m=n(64078),g=n(10631);n(66952);const w=window.skyward;function v(e){const t=b(e);return"function"==typeof t.safeToDateString?t.safeToDateString():t.toString()}function b(e){const t=$(e),n=t.data();let a;if(t.is(":radio"))t.is(":checked")&&(a=t.val());else if(t.is(":checkbox"))t.hasClass("valuecheckbox")?t.is(":checked")&&(a=t.val()):a=t.is(":checked");else if(t.hasClass("masked"))a=(0,s.getUnmaskedValue)(t);else if(t.hasClass("relativeDate"))a=n.relativeDate;else{if(t.is("[type=date]")){const e=t.val();let n=e?(0,o.parseDate)(e+"T00:00:00"):new Date(NaN);return n.toString()===new Date(NaN).toString()&&(n=w.datepicker.parseDateString(e)),n}if(t.hasClass("datepicker"))a=w.datepicker.parseDateString(t.val());else if(t.is("sky-datepicker")||t.is("sky-datetimepicker"))a=t.prop("valueAsDate");else if(t.hasClass("datePicker")||t.hasClass("dateTimePicker")){a=t.parent().prop("valueAsDate")}else if(0!==t.closest(".quickEntryText").length)a=t.closest(".quickEntryText").find(".codeEELDescription").encodedVal();else if(t.hasClass("codeEEL"))a=t.find(".codeEELValue").val();else if(t.hasClass("tileViewEEL"))a=t.find(".tileViewEEL_value").val();else if(t.hasClass("htmlComboBox"))a=t.find(".htmlComboBox_value").val();else if(t.is(".radioButtonGroupValue,.radioButtonGroup"))a=w.radioButtonGroup.getValue(t);else if(t.hasClass("distinctMultiSelectEEL")){const e=t.find(".dmsBackingData");a=l.get(e)}else if(t.hasClass("dmsBackingData"))a=l.get(t);else if(t.hasClass("multiSelectBackingData"))a=h.getValue(t);else if(t.hasClass("raceEthnicityVerification"))a=w.onlineform.raceEthnicityGetValue(t);else if(t.hasClass("button")&&t.hasClass("useChangeTracking"))a=n.value;else if(t.hasClass("colorPicker")){const e=t.spectrum("get");a=null==e?"":e.toString(n.colorFormat).replace(/\s/g,"")}else a=t.hasClass("parametermapper")?w.parametermapper.getValue(t):t.hasClass("ckeditor")?CKEDITOR.instances[t.attr("id")]?w.extensions.encodeHtml(CKEDITOR.instances[t.attr("id")].getData()):t.encodedVal():t.hasClass("dashboardItemSizer__inner")||t.hasClass("dashboardItemSizer__container")?t.find("#DashboardItemSize").val():t.hasClass("accountDimensionEEL")?t.find(".accountDimensionEELValue").val():f.isHtmlEditorElement(t)?f.getEncodedValue(t):null===t.val()?null:t.encodedVal()}return a}function y(e){var t;const n=$(e);let a;if(n.hasClass("codeEEL"))a=n.find(".codeEELValue");else if(n.hasClass("distinctMultiSelectEEL"))a=n.find(".dmsBackingData");else if(n.hasClass("tileViewEEL"))a=n.find(".tileViewEEL_value");else if(n.hasClass("accountDimensionEEL"))a=n.find(".accountDimensionEELValue");else{if(!(n.hasClass("codeEELValue")||n.hasClass("dmsBackingData")||n.hasClass("tileViewEEL_value")||n.hasClass("accountDimensionEELValue")))return;a=n}return null!==(t=a.data("selectedValueHash"))&&void 0!==t?t:null}function _(e){const t=$(e),n=b(t);if(null==n)return null;if(n instanceof Date){if(isNaN(n.getTime()))return null;const e=t.is(".datepicker,.datePicker")||t.is("sky-datepicker");return(0,o.formatServerDate)(n,!e)}if(Array.isArray(n))return n.map(e=>w.extensions.decodeHtml(e));if("object"==typeof n){const e={};for(const t in n){e[w.extensions.decodeHtml(t)]=w.extensions.decodeHtml(n[t])}return e}return w.extensions.decodeHtml(n)}function C(e){const t=$(e),n=t.data();let a;if(t.hasClass("datepicker"))a=(0,o.parseDate)(t.data("original-value")),!w.datepicker.isValidDateObject(a)&&t.hasClass("hasRelativeDatePicker")&&(a=t.data("originalRelativeDate"));else if(t.is("sky-datepicker,sky-datetimepicker")){const e=t.data().originalValue;a=e?(0,g.qE)(e):null}else if(t.is(".datePicker,.dateTimePicker")){const e=t.closest(".dateTimePickerWrapper").data().originalValue;a=e?(0,g.qE)(e):null}else if(t.is(".timePicker")){a=t.closest(".dateTimePickerWrapper").data().originalValue}else if(t.is(":checkbox")&&t.hasClass("valuecheckbox"))a=-1===$.inArray(t.attr("data-original-value"),["true","indeterminate"])?void 0:t.attr("data-original-value");else if(t.is("[data-mask]")){const e=t.attr("data-original-value"),o=t.clone();(0,s.addMask)(o,n.mask),(0,s.setValue)(o,e),a=(0,s.getUnmaskedValue)(o)}else if(t.is(".radioButtonGroupValue,.radioButtonGroup"))a=w.radioButtonGroup.getOriginalValue(t);else if(t.hasClass("distinctMultiSelectEEL")){const e=t.find(".dmsBackingData");a=l.getOriginal(e)}else if(t.hasClass("dmsBackingData"))a=l.getOriginal(t);else if(t.hasClass("multiSelectBackingData"))a=h.getOriginalValue(t);else if(t.hasClass("listSortOrder"))a=JSON.stringify(t.data("originalValue"));else if(t.hasClass("codeEEL"))a=t.find(".codeEELValue").data("original-value");else if(f.isHtmlEditorElement(t))a=f.getOriginalValue(t);else if(a=t.data("original-value"),a instanceof Object&&null!==a)try{const e=t.attr("data-original-value"),n=JSON.parse(e||"");w.global.deepEquals(n,a)&&(a=e)}catch(e){}return a}function k(e,t,n){const a=$(e);void 0!==t&&void 0!==a.data(t)&&a.data(t,n)}function S(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];const a=$(e);if(!n&&a.hasClass("suppressChangeEvent")&&(n=!0),a.is("img"))a.prop("src",t),n||a.trigger("change");else if(a.is(":radio"))for(let e=0;e<a.length;e++){const o=$(a[e]);o.val()==t&&(o.prop("checked",!0),n||o.trigger("change"))}else if(a.hasClass("radioSet"))a.find(":radio").each(function(){const e=$(this);e.val()==t?1!=e.prop("checked")&&(e.prop("checked",!0),n||e.trigger("change")):0!=e.prop("checked")&&(e.prop("checked",!1),n||e.trigger("change"))});else if(a.is(":checkbox"))a.prop("checked","string"==typeof t?"true"===t.toLowerCase():t),n||(a.hasClass("labeledToggleSwitch__input")?a[0].dispatchEvent(new Event("change")):a.trigger("change"));else if(a.is("[type=date]")){if(!t)return void a.val("");const e=(0,o.parseDate)(t),n=e.getFullYear(),r=("0"+(e.getMonth()+1)).slice(-2),i=("0"+e.getDate()).slice(-2);a.val([n,r,i].join("-"))}else if(a.is(".datePicker,.dateTimePicker,sky-datepicker,sky-dateTimePicker")){const e=a.is("sky-datepicker,sky-dateTimePicker")?a.filter("sky-datepicker,sky-dateTimePicker"):a.parent(),r=a.is("sky-datepicker,sky-dateTimePicker")?a.find("input"):a.filter("input"),i=(0,o.parseDate)(t);e.prop("valueAsDate",i.isValidDate()?i:null),n||r.trigger("change")}else if(a.closest(".dateTimePickerModal").length>0)a.val(t),n||a[0].dispatchEvent(new Event("change"));else if(a.hasClass("datepicker")){const e=(0,o.parseDate)(t);if(w.datepicker.isValidDateObject(e))a.val($.datepicker.formatDate(a.hasClass("browseSearchBox")?"mm/dd/yy":"mm/dd/yy DD",e));else{if(a.hasClass("hasRelativeDatePicker")){const e=w.relativedatepicker.parseRelativeDateString(t);if(null!==e){const t=a.attr("id");return w.relativedatepicker.setValue(t,e),void(n||w.relativedatepicker.getRelativeDateDisplay(t).trigger("change"))}}a.val("")}n||a.trigger("change")}else if(a.is("label")||a.hasClass("visualLabel")||a.hasClass("fieldValidationMessage"))a.text(t),n||((0,d.alignTitles)(a),a.trigger("change"));else if(a.is("[type=time]")){if(!t)return void a.val("");let e,n,r;const i=(0,o.parseDate)(t);isNaN(i.getTime())?t&&(t.split(" ").map(function(t){if(2===t.indexOf(":")){const a=t.split(":");e=parseInt(a[0]),n=parseInt(a[1])}else r="pm"===t.toLowerCase()}),r&&e&&!isNaN(e)&&(e+=12)):(e=i.getHours(),n=i.getMinutes()),t=("0"+e).slice(-2)+":"+("0"+n).slice(-2),a.val(t)}else{if(a.hasClass("codeEEL"))return r.setCodeEELValue(a,t,n);if(a.hasClass("codeEELValue"))return r.setCodeEELValue(a.closest(".codeEEL"),t,n);if(a.hasClass("tileViewEEL"))return m.setValue(a,t,n);if(a.hasClass("tileViewEEL_value"))return m.setValue(a.parent(),t,n);if(a.hasClass("htmlComboBox"))u.populateBoxes(a,t);else if(a.hasClass("radioButtonGroupValue")||a.hasClass("radioButtonGroup"))w.radioButtonGroup.setValue(a,t,n);else{if(a.hasClass("distinctMultiSelectEEL")){const e=a.find(".dmsBackingData");return l.set(e,t,n)}if(a.hasClass("dmsBackingData"))return l.set(a,t,n);if(a.hasClass("multiSelectBackingData"))h.populate(a,t,n);else if(a.hasClass("dashboardItemSizer__inner")||a.hasClass("dashboardItemSizer__container")){const e=a.find("#DashboardItemSize");e.val(t),n||e.trigger("change")}else a.hasClass("filterViewValue")?(H(a,t),null===t||""===t?(a.data("filterCondition",""),w.filterbuilder.updateFilterViewerDisplay(a),n||a.trigger("change")):$.ajax({url:w.global.virtualDir+"SkySys/Filter/ConvertToJSON",type:"POST",dataType:"JSON",data:{xml:w.extensions.encodeHtml(t)},success:function(e){a.data("filterCondition",e||""),w.filterbuilder.updateFilterViewerDisplay(a),n||a.trigger("change")}})):f.isHtmlEditorElement(a)?f.setValue(a,t,n):a.is("textarea")?(p.setValuePreservingUndo(a,t)||H(a,t),n||a.trigger("change")):(void 0!==a.data("spectrum.id")?$(a).spectrum("set",t):H(a,t),n||a.trigger("change"))}}}function D(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];const a=$(e),o=$(t);a.hasClass("codeEEL")?r.copyValue(a,o,n):a.hasClass("tileViewEEL")?m.copyValue(a,o,n):a.hasClass("dmsBackingData")?l.copyValue(a,o,n):S(o,b(a),n)}function E(e,t){return O(e,!1,t)}function P(e,t){return O(e,!0,t)}function O(e,t,n){let o=e;o instanceof $||(o=$(o),0===o.length&&"string"==typeof e&&n&&n.length>0&&(o=$(e.replace(/#/g,"#".concat(n)))));const r=$(o);let s,l=$();if(r.is(".codeEELValue,.tileViewEEL_value,.selectorEELInput,.codeEEL,.tileViewEEL,.selectorEEL"))l=l.add(r.closest(".codeEEL,.tileViewEEL,.selectorEEL").find(".eELInputContainer__textBox,.ui-control-container,.eELInputContainer__button"));else if(r.is(".htmlComboBox_value,.htmlComboBox"))s=r.closest(".htmlComboBox"),l=l.add(s),l=l.add(s.find(".htmlComboBox_input,.htmlComboBox_button"));else if(r.is(".dmsBackingData,.distinctMultiSelectEEL"))s=r.closest(".distinctMultiSelectEEL"),l=l.add(s),l=l.add(s.find(".ui-control-container,.distinctMultiSelectUserInput"));else if(r.is(".datepicker,.datepicker-wrapper")){let e=r;if(r.hasClass("datepicker-wrapper")&&(e=r.find(".datepicker")),e.siblings(".datepicker-trigger").toggle(t),e.hasClass("hasRelativeDatePicker")){e.prop("readonly",!t);const n=e.closest(".datepicker-wrapper").siblings(".relativeDateDisplay");n.toggleClass("readonly",!t),l=l.add(n),e.closest(".datepicker-wrapper").siblings(".launchRelativeDatePicker").toggle(t)}else e.datepicker("option","disabled",!t),l=l.add(e)}else if(r.is(".relativeDate__positioning")){const e=r.find(".datepicker"),n=r.find(".launchRelativeDatePicker"),a=r.find(".relativeDateDisplay");e.prop("readonly",!t),e.siblings(".datepicker-trigger").toggle(t),l=l.add(a),t?(a.removeClass("readonly"),n.show()):(a.addClass("readonly"),n.hide())}else if(r.is("sky-datepicker,sky-timepicker,sky-datetimepicker"))t?(r.removeClass("ui-disabled"),r.removeAttr("aria-readonly")):(r.addClass("ui-disabled"),r.attr("aria-readonly","true"));else if(r.is(".radioButtonGroupValue,.radioButtonGroup"))l=l.add(r.find(":input")),t?w.radioButtonGroup.enable(r):w.radioButtonGroup.disable(r);else if(r.is(".radioButtonContent"))l=l.add(r),t?$.each(r,function(){$(this).parent().removeClass("disabled")}):$.each(r,function(){$(this).parent().addClass("disabled")});else if(r.hasClass("colorPicker"))l=l.add(r.filter(".colorPicker")),t?i.toggle(r,!1):i.toggle(r,!0);else if(r.hasClass("multipleSelectBox")){const e=r.find("input[type='checkbox']"),t=r.find(".multiSelectBackingData"),n=r.siblings(".customValueEntry");n.length>0&&(l=l.add(n.find("input, a"))),l=l.add(r),l=l.add(e),l=l.add(t)}else r.is("a")?(r.css({"pointer-events":t?"":"none"}),l=l.add(r)):r.is(".codeEELSelectedValueDisplayField")||(f.isHtmlEditorElement(r)?f.toggle(r,t):r.is(":input")?l=l.add(r):r.hasClass("checkboxGroup")&&(l=l.add(r),l=l.add(r.find("input[type='checkbox']"))));const c="select,.htmlComboBox,.radioButtonGroup,.radioButtonGroup__button,input[type='radio'],.checkboxGroup,.multipleSelectBox,input[type='checkbox'],sky-datepicker,sky-timepicker,sky-datetimepicker",d=c+",.colorPicker,input[type='text'],input[type='password'],input[type='number'],input[type='email'],input[type='time'],textarea,.durationpicker";if(l.length){l.not(c).prop("readonly",!t),l.not(d).prop("disabled",!t),l.toggleClass("ui-disabled",!t),l.not(d).attr("aria-disabled",(!t).toString()),l.filter(c).attr("aria-readonly",(!t).toString());const e="0";t?l.filter(c).each(function(){const e=$(this),t=e.attr("aria-describedby");if(!t)return;const n=t.split(" ").filter(e=>e!==a.readOnlyAnnouncementID).join(" ");e.attr("aria-describedby",n)}):l.filter(c).each(function(){const e=$(this),t=e.attr("aria-describedby");if(t){if(t.includes(a.readOnlyAnnouncementID))return;e.attr("aria-describedby","".concat(t," ").concat(a.readOnlyAnnouncementID))}else e.attr("aria-describedby",a.readOnlyAnnouncementID)}),l.not(d).filter(":input,a").each(function(){const n=$(this);let a=n.data("origTabIndex");void 0===a&&(a=n.is(":input")?e:n.attr("tabindex")||e,n.data("origTabIndex",a)),n.attr("tabindex",t?a:"-1")}),l.trigger("readonly",t)}return l.length>0}function B(e,t,n){const a=U(e,n);if(a&&a.get(0))if(a.is(".radioButtonGroupValue,.radioButtonGroup"))w.radioButtonGroup.hide(a);else if(a.hasClass("datepicker"))w.datepicker.hide(a,t);else if(a.is(".datePicker,.timePicker,.dateTimePicker")){o(a.closest(".dateTimePickerWrapper"))}else if(a.is("option,optgroup"))W(a,!1);else if(a.is(".codeEELValue,.tileViewEEL_value,.selectorEELInput")){o(a.closest(".codeEEL,.tileViewEEL,.selectorEEL"))}else a.hasClass("contentMessageArea")?a.addClass("cmaHidden"):f.isHtmlEditorElement(a)?f.toggleVisible(a,!1,t):(o(a),a.trigger("visible",!1));function o(e){!1!==t?e.animateClose():e.hide()}}function T(e,t,n){const a=U(e,n);if(!a||!a.get(0))return;let o;if(a.is(".radioButtonGroupValue,.radioButtonGroup"))o=w.radioButtonGroup.show(a);else if(a.hasClass("datepicker"))o=w.datepicker.show(a,t);else if(a.is(".datePicker,.timePicker,.dateTimePicker")){const e=a.closest(".dateTimePickerWrapper");i(e),o=e}else if(a.is("option,optgroup"))W(a,!0),o=a;else if(a.is(".codeEELValue,.tileViewEEL_value,.selectorEELInput")){const e=a.closest(".codeEEL,.tileViewEEL,.selectorEEL");i(e),o=e}else if(a.hasClass("contentMessageArea"))a.removeClass("cmaHidden"),o=a;else if(f.isHtmlEditorElement(a)){var r;o=null!==(r=f.toggleVisible(a,!0,t))&&void 0!==r?r:a}else i(a),o=a;function i(e){!1!==t?e.animateOpen():e.show()}o.trigger("visible",!0),o.animationPromise().done(function(){w.events.processVisibleActions(a)})}function x(e,t){let n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=arguments.length>3?arguments[3]:void 0;t?T(e,n,a):B(e,n,a)}function M(e,t,n){let a="string"==typeof e?$("[name='".concat(e,"']")):e;0===a.length&&(a=$('[id="'.concat(e,'"]'))),0===a.length&&n&&n.length>0&&(a=$('[id="'.concat(n).concat(e,'"]'))),a.empty(),$.each(t,function(e,t){if("string"==typeof t.Value)a.append($("<option></option>").attr("value",t.Key).text(t.Value));else{const e=$("<option></option>").attr("value",t.Key).text(t.Value.Value);t.Value.Dependents&&e.attr("data-dependents",JSON.stringify(t.Value.Dependents)),t.Value.Selected&&e.attr("Selected","Selected"),a.append(e)}})}function I(e){const t=R(e);return{controls:JSON.stringify(t)}}function A(e){const t={};return e.find(".editableFields").each(function(){const e=$(this),n=e.data("hash"),a=e.val();if(a){const e=JSON.parse(a);t[n]=e}}),JSON.stringify(t)}function L(e){const t=$(e),n=b(t),a=t.data();return!$.isEmptyObject(a)&&a.originalValue!=n}function R(e){const t=[];return $(e+" [data-original-value]").each(function(){const n=$(this),a=n.attr("name");if(null!=a){let o=null;if(".workflowPopup"==e){const t=n.data();o=n.is(":radio")?$(e+" input[name='"+a+"']:checked").val():n.is(":checkbox")?n.is(":checked"):n.hasClass("masked")?w.datamask.getUnmaskedValue(n):n.encodedVal(),null!=o&&o==t.originalValue&&(o=null)}t.push({id:a,items:[{key:"value",value:o,skip:!1}]})}}),t}function N(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];const n=$(e);if(!t&&n.hasClass("suppressChangeEvent")&&(t=!0),n.is(":checkbox"))n.prop("checked",!1),t||n.trigger("change");else if(n.hasClass("datepicker"))n.val(""),t||n.trigger("change");else if(n.is(".datePicker,.dateTimePicker,sky-datepicker,sky-dateTimePicker")){const e=n.is("sky-datepicker,sky-dateTimePicker")?n:n.parent(),a=n.is("sky-datepicker,sky-dateTimePicker")?n.find("input"):n;e.prop("valueAsDate",null),t||a.trigger("change")}else if(n.is("label")||n.hasClass("visualLabel"))n.text(""),t||n.trigger("change");else if(n.hasClass("codeEEL"))r.setCodeEELValue(n,"",t);else if(n.hasClass("distinctMultiSelectEEL")||n.hasClass("dmsBackingData"))l.clear(n,t);else if(n.hasClass("multiSelectBackingData"))h.clearValue(n,t);else if(n.hasClass("tileViewEEL")){const e=n.find(".tileViewEEL_search").data();m.populateBoxes(n,e,"")}else n.hasClass("htmlComboBox")?u.populateBoxes(n,null):n.hasClass("raceEthnicityVerification")?(n.find(":checkbox").prop("checked",!1),n.trigger("change")):n.hasClass("listSortOrder")?(n.val("[]"),t||n.trigger("change")):f.isHtmlEditorElement(n)?f.clearValue(n,t):(H(n,""),t||n.trigger("change"))}function F(e,t,n){const a=$(e);!a.data("original-id")&&a.attr("id")&&a.data("original-id",a.attr("id")),a.attr("id",t),n||(n=t),a.attr("name")&&(a.data("original-name")||a.data("original-name",a.attr("name")),a.attr("name",n)),a.hasClass("radioButtonGroup")&&(a.attr("data-name",n),a.find("input[type='radio']").attr("name",n+"child"))}function j(e,t){const n=e.is(":checked");!e.hasClass("allowCodeChangesWhenReadonly")&&e.hasClass("ui-disabled")||(e.prop("checked",t),(!n&&t||n&&!t)&&e.trigger("change"))}function V(e){const t=$(e),n=t.closest("#moduleContent, #detailsPanel, .workflowContent, body");return n.length?n:t.parents().last()}function H(e,t){(e.data("mask")||e.data("decimalMask"))&&e.hasClass("masked")?(0,s.setValue)(e,t):e.val(null!=t?t:""),e.is("[data-year-mask]")&&(0,s.applyYearMask)(e)}function W(e,t){if(t){e.prop("disabled",!1).css("display","");const t=e.closest("select");1==t.children("option:not(:disabled)").length&&S(t,e.val(),!0)}else if(e.prop("disabled",!0).css("display","none"),e.is(":selected")){e.removeAttr("selected");const t=e.closest("select"),n=t.find("option:not(:disabled)").first();S(t,n.val(),!0)}}function U(e,t){let n;if("string"==typeof e){try{n=$('[name="'+e+'"]')}catch(e){n=null}if(!n||0===n.length)try{n=$("#"+e),0===n.length&&t&&(null==t?void 0:t.length)>0&&(n=$("#"+t+e))}catch(e){n=null}}if(!n||0===n.length)try{n=$(e),0===n.length&&"string"==typeof e&&t&&(null==t?void 0:t.length)>0&&(n=$(e.replace("#","#".concat(t))))}catch(e){n=null}return n}(0,c.registerEvents)("controls",{hideoption:function(){W($(this),!1)}})},65248(e,t,n){"use strict";n.r(t);var a=n(62521),o=n(3543),r=n(2894),i=n(88157),s=n(49343),l=n(66952),c=n(917),d=n(21701),u=n(38950),f=n(1380),h=n(68337),p=n(84398);const m=window.skyward;function g(e,t,n){return function(a){const o=m.keys.getKeyNamesFromEvent(a);if(!o.ALT||!o.F2)return;const s=$(this),l=s.closest(".codeEEL"),c=s.closest(".distinctMultiSelectEEL"),f=s.closest("sky-datepicker"),h=s.closest("sky-timepicker"),g=s.closest("sky-datetimepicker");let w=s;l.length>0?w=l:c.length>0?w=c:f.length>0?w=f:h.length>0?w=h:g.length>0&&(w=g);const v={module:w.data("datapathoverridemodule"),object:w.data("datapathoverrideobject"),field:w.data("datapathoverridefield")};let b;if(v.field)b=$.Deferred().resolve(v);else if(c.length>0){const e=c.data().module,t=c.data().object;let a=c.data().distinctField;null==a&&(a=t+"ID");const o=$.extend({moduleName:e,objectName:t,fieldName:a},n);b=$.post("".concat(r.virtualDir,"SkySys/F2FieldInfo/GetF2FieldInfo"),o)}else{var y;let a=null===(y=s.attr("name"))||void 0===y?void 0:y.split("_")[0];var _;if(s.parent().is(".tileViewEEL"))a=null===(_=s.attr("name"))||void 0===_?void 0:_.split("_")[1];else if(f.length>0){var C;a=null===(C=f.attr("name"))||void 0===C?void 0:C.split("_")[0]}const o=$.extend({moduleName:e,objectName:t,fieldName:a},n);b=$.post("".concat(r.virtualDir,"SkySys/F2FieldInfo/GetF2FieldInfo"),o)}b.done(function(n){if(s.hasClass("datepicker")?s.datepicker("hide"):f.length>0?d.closeModal(f):h.length>0?p.closeModal(h):g.length>0&&u.closeModal(g),!n.field)return;const a=$(w).siblings("label.title").contents(":empty").text()||n.field;!function(e){const t=$("<div class='informationPopup'>").append([a("Module",e.module),a("Object",e.object),a("Field",e.field),a("Type",e.type),a("Default Value",e.defaultValue)]),n={anchorTo:e.elem,id:"dataPathPopup"};function a(e,t){const n=$("<span class='boldFont'>").text(e+": "),a=$("<span>").text(t);return $("<div class='datapathPopupRow'>").append([n,a])}(0,i.showInformationDialog)(e.label+" Data Path",t,null,n)}($.extend({},{module:e,object:t,label:a,elem:s},n))})}}(0,s.registerLoadDOMCallback)(function(e){$(e).find(".dataObjectViewer").each(function(){var e=$(this);e.on("keydown","input,textarea,select",g(e.data("module"),e.data("object")))}),$(e).find(".workflowContent").each(function(){const e=$(this),t={taskInstanceID:e.data("workflow-task-instance-id")};null!=t.taskInstanceID&&e.off("keydown.altF2Listener").on("keydown.altF2Listener","input,textarea,select",g("Workflow","TaskInstance",t))})}),$(function(){let e=!1;const t=(0,l.createCache)(function(e){return $.ajax({url:"".concat(r.virtualDir,"SkySys/ModulePath/Screen"),type:"POST",dataType:"viewparthtml",data:{module:e.module,object:e.object,screen:e.screen,secondaryId:e.secondaryId,secondaryUrl:e.secondaryUrl,secondaryLabelPrefix:e.secondaryLabelPrefix}})});$(document.body).on("keydown.altF3Listener",function(n){const s=m.keys.getKeyNamesFromEvent(n);if(!s.ALT||!s.F3||e)return;e=!0;const l=$("#master,.workflow.skywardContentPanel,.secondaryLocationData").last(),d={beforeClose:function(){e=!1}};let u;const p=t(l.data()).then(function(e){const t=$(e);l.find(".js-fieldRestrictionMarker").length>0&&t.append(function(){const e=$("<span>",{class:"boldFont",text:"Customized Screen: "}),t=$("<input>",{type:"checkbox",style:"margin: 0px; padding: 0px",checked:"checked"}),n=$("<span>",{text:"***"});return(0,c.disable)(t),y([e,t,n])}());const n=t.data("canViewBrowseSql"),s=(0,o.getAllBrowseIds)().filter(function(e){return document.getElementById(e)}).map(function(e){return function(e,t){const n=(0,o.getBrowseById)(e),s=(0,a.getBrowseStats)(e),l=(0,a.getDebugName)(n);let c="".concat(r.virtualDir,"SkySys/Browse/Details/").concat(n.browseId),d=[$("<p>",{addClass:"boldFont datapathPopupRow__text",text:l})];null!=n.browseId&&n.browseId>=0&&d.push($("<a>",{addClass:"boldFont datapathPopupRow__text",text:"ID: ".concat(n.browseId,", View ID: ").concat(n.viewId),href:c}));void 0!==s?d=d.concat(Object.keys(s).map(function(e){return $("<p>",{addClass:"datapathPopupRow__text",text:e+": "+s[e]+"ms"})})):d.push($("<p>",{addClass:"datapathPopupRow__text",text:"No browse load times available."}));if(t){const e=_("Show Query Text","Eye").on("click",function(){p(l)});d.push($("<p>",{addClass:"datapathPopupRow__text",append:e}))}const h=n.browse[0];return y(d).on("mouseenter",w).on("mouseleave",k);function p(t){const n=(0,a.getSql)(e);let o;o="string"==typeof n?r(n):n.then(function(e){return r(e)});function r(e){return[$("<textarea>",{attr:{readonly:""},css:{width:"80vw",height:"60vh"},text:e}),_("Copy Query Text","ClipboardPencil").on("click",function(){m(e)})]}(0,i.showInformationDialog)(t,o).content.addClass("datapathPopup__browseSql")}function m(e){const t=$("<textarea>",{css:{width:0,height:0,position:"fixed"},text:e});t.appendTo(document.body),(0,f.toggleIgnoreElement)(t,!0),t.trigger("focus"),t.trigger("select"),document.execCommand("copy"),t.remove()}function w(){const e=$(h);v=e.closest(":scrollable"),v.length?(b=v[0].getBoundingClientRect(),e.scrollintoview(),function(e){const t=$.timers.find(function(e){return"scrollintoview"===e.queue&&e.elem===v[0]});t&&t.anim.progress(function(){C(e)})}(h)):b={left:-1/0,right:1/0,top:-1/0,bottom:1/0},C(h),u.before(g)}function k(){v.stop(),g.remove()}}(e,n)});return t.append(s)});u=(0,i.showInformationDialog)("Security Location",p,null,d).container;const g=$((new DOMParser).parseFromString("<svg xmlns='http://www.w3.org/2000/svg' class='svgNoHover datapathPopupRow__browseHighlight'><defs><mask id='cutout'><rect x='0' y='0' width='100%' height='100%' fill='white' /><rect class='cutoutRect' fill='black' /></mask></defs><rect x='0' y='0' width='100%' height='100%' fill='rgba(0,0,0,0.4)' mask='url(#cutout)' /></svg>","text/xml").childNodes[0]),w=g.find(".cutoutRect");let v,b;function y(e){return $("<div>",{class:"datapathPopupRow",append:e})}function _(e,t){return $("<a>",{addClass:"button chromeless toolbarButton svgAnchor",attr:{href:"#",alt:e},append:[(0,h.getSvg)(t),$("<span>",{class:"buttonNameLabel",text:e})]})}function C(e){const t=e.getBoundingClientRect(),n=Math.max(t.left,b.left),a=Math.max(t.top,b.top),o=Math.min(t.right,b.right),r=Math.min(t.bottom,b.bottom);w.attr({x:n,y:a,width:Math.max(o-n,0),height:Math.max(r-a,0)})}})})},83787(e,t,n){"use strict";n.r(t),n.d(t,{addDecimalMask:()=>h,addMask:()=>f,applyMaskOnContainer:()=>u,applyYearMask:()=>d,getUnmaskedValue:()=>p,removeMask:()=>g,setValue:()=>m});var a=n(26721),o=n(92214);const r="js-skipMask",i="js-maskInitialized",s="masked",l=window.skyward,c=new WeakMap;let d=function(e){var t;const n=c.get(e[0]);let a=null==n?void 0:n.value.replace(/_/g,"");switch(null===(t=a)||void 0===t?void 0:t.length){case 1:a="000"+a;break;case 2:a=parseInt(a)>=60?"19"+a:"20"+a;break;case 3:a="0"+a;break;default:return}m(e,a),e.trigger("change")},u=function(e){e.each(function(){const e=$(this),t=e.data();void 0===t.mask&&void 0===t.decimalMask&&void 0===t.yearMask||v(e)})},f=function(e,t,n){if(!e.hasClass(i))return void v(e);if(0===e.length)return;switch(e.prop("type")){case"text":case"tel":break;default:return}const o=e.val();g(e);const r={mask:t,lazy:!0,placeholderChar:"_",definitions:{9:/\d/,"^":/[A-Z]/}};"string"==typeof n&&(r.placeholderChar=""==n?" ":n);const u=(0,a.Ay)(e[0],r);e.addClass(s);const f=l.debounce(function(){document.activeElement===e[0]&&u.el&&(u.updateOptions({lazy:!1}),u.alignCursorFriendly())},10);e.on("focus.placeholder",f),e.on("focusout.placeholder",function(){u.updateOptions({lazy:!0})}),l.window.isSafari&&e.on("blur",C),c.set(e[0],u),m(e,o),e.data("yearMask")&&d(e)},h=function(e,t){var n;if(!e.hasClass(i))return void v(e);if("text"!=e.prop("type"))return void("number"==e.prop("type")&&((t=t.replace(",","")).includes("-")?(e.prop("min",Number.parseFloat(t)),e.prop("max",Number.parseFloat(t.replace("-","")))):(e.prop("min",0),e.prop("max",Number.parseFloat(t))),e.on("change",y),e.on("keyup",y)));const o=null!==(n=e.val())&&void 0!==n?n:"",r={mask:Number,padFractionalZeros:!0,definitions:{9:/\d/,"^":/[A-Z]/}};if(g(e),r.radix=".",r.scale=0,t.includes(".")){const n=t.split(".")[1].length;r.scale=n,r.mapToRadix=["."];const a=e.data().hideFractionalZeros;a&&"true"===a.toString().toLowerCase()&&(r.padFractionalZeros=!1)}t.includes(",")&&(r.thousandsSeparator=",");let d=!1;t.includes("-")?(r.min=t.replace(/,/g,""),d=!0):r.min="0",r.max=t.replace(/,/g,"").replace("-",""),r.normalizeZeros=!1;const u=(0,a.Ay)(e[0],r);if(c.set(e[0],u),m(e,o),e.addClass(s),(void 0!==o||null!==o)&&_(o,r,d)){const t=function(e){const t=e.toString(),n=t.replace(/(\.[0-9]*[1-9])0+$/,"$1");return parseFloat(n)}(o);if(_(t,r,d))return g(e),void e.val(o);m(e,t)}l.window.isSafari&&e.on("blur",C),e.prop("maxlength",t.length)},p=function(e){if(e.hasClass(r)||!e.hasClass(s))return e.val();const t=c.get(e[0]);if(t&&e.data().decimalMask){const n=e.data().decimalMask.toString();if(!n.includes(".")&&!n.includes(","))return t.displayValue}return null==t?void 0:t.unmaskedValue},m=function(e,t){const n=c.get(e[0]);void 0!==n&&void 0!==t&&(n.value=null!==t?t.toString():"",n.updateControl())},g=function(e){const t=e[0];if(c.has(t)){e.off("focus.placeholder"),e.off("focusout.placeholder"),e.off("blur",C);const n=c.get(t),a=null==n?void 0:n.unmaskedValue;c.delete(t),n.destroy(),e.removeClass(s),e.val(a)}};const w={init:v,load:()=>{}};function v(e){const t=$(e),n=t.data();if(!t.hasClass(i)){if(t.addClass(i),void 0!==n.mask)n.mask=n.mask.toString(),null!=n.skipMask?function(e){const t=e.data(),n=e.getPrefix()+t.skipMask,a=$("#"+n.replace(/\./g,""));if(0===a.length)return;const o=a.is(":checked");b(e,o,t.mask,t.maskPlaceholder),a.on("change",function(){const n=a.is(":checked");b(e,n,t.mask,t.maskPlaceholder)})}(t):f(t,n.mask,n.maskPlaceholder);else if(void 0!==n.decimalMask){const e=String(n.decimalMask);if(e&&!t.prop("readonly")){const n=/^(-)?(?:9{1,3}(?:,9{3})*|9+)(?:\.9+)?$/;if(!n.exec(e))throw"decimalMask: Invalid mask (".concat(e,"), must be like ").concat(n);h(t,e)}return}void 0!==n.yearMask&&t.on("focusout",function(){d($(this))})}}function b(e,t,n,a){e.toggleClass(r,t),t?g(e):f(e,n,a)}function y(e){var t,n;const a=$(e.target),o=parseFloat(null!==(t=null===(n=a.val())||void 0===n?void 0:n.toString())&&void 0!==t?t:""),r=parseFloat(a.prop("min")),i=parseFloat(a.prop("max"));o<r?a.val(r):o>i&&a.val(i)}function _(e,t,n){var a,o,r;const i=e.toString(),s=i.split("."),l=null!==(a=null===(o=t.max)||void 0===o?void 0:o.split("."))&&void 0!==a?a:"",c=!n&&i.includes("-"),d=s[0].replace(/-/g,"").length>l[0].length,u=s.length>1&&s[1].length>(void 0!==t&&null!==(r=t.scale)&&void 0!==r?r:0),f=s.length>1&&0===s[1].length&&0===t.scale;return c||d||u||f}function C(e){var t;const n=$(e.target),a=null==n||null===(t=n.val())||void 0===t?void 0:t.toString(),o=n.data().originalValue.toString();void 0!==a&&a!=o&&n.trigger("change")}(0,o.registerEvents)("datamask",w)},14144(e,t,n){"use strict";n.r(t),n.d(t,{disableButtons:()=>f,enableButtons:()=>h,getFieldValueFromNamedInput:()=>c,getFieldValues:()=>l});var a=n(66952),o=n(82441),r=n(40346),i=n(917);const s=window.skyward;async function l(e){const t={},n=e.find("[name]").not(".doNotPost");$.extend(t,await f(n,c));const a=e.find(".editablebrowse");$.extend(t,await f(a,d));const r=e.find(".repeater");$.extend(t,await f(r,u));const i=e.find(".htmlViewer, .framedHTMLViewer").not(".js-ignoreIFrameContents").toArray().map(function(e){const t=$(e);return s.iframeListener.getFieldValues(t)}),l=await Promise.all(i);return $.extend(t,{},...l),t;async function f(e,t){const n=await Promise.all($.map(e,t)),a={};for(const e of n){if(!e)continue;a[e.name]=e.value;const t=(0,o.isNotEmpty)(e.value),n=!(0,o.isBusyOrInitializing)(e.hash);t&&n&&null!==e.hash&&void 0!==e.hash&&(a[e.name+"_hash"]=e.hash)}return a}}function c(e){const t=$(e),n=t.attr("name");if(!n)return;const o=t.hasClass("datepicker"),r=t.hasClass("datePicker")||t.is("sky-datepicker"),l=t.hasClass("dateTimePicker")||t.is("sky-datetimepicker"),c=t.hasClass("relativeDate");let d=(0,i.getValue)(t),u=(0,i.getRowDataHash)(t);o&&!c?(d=s.datepicker.isValidDateObject(d)?$.datepicker.formatDate("mm/dd/yy DD",d):""===t.val().trim()?"":new Date(NaN).toString(),d=(0,a.encodeHtml)(d)):d=r?d&&d.isValidDate()?d.toLocaleDateString("en-US",{year:"numeric",month:"2-digit",day:"2-digit"}):"":l?d&&d.isValidDate()?d.toLocaleString("en-US",{year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",hour12:!0}).replace(",",""):"":"object"==typeof d?JSON.stringify(d):d,u=Array.isArray(u)?u.join(","):u;return{name:n,value:d,hash:u}}function d(e){const t=$(e);return{name:t.attr("id"),value:JSON.stringify(t.data("editablebrowsedata"))}}function u(e){const t=$(e);if(t.hasClass("js-dovAdaptableRepeater"))return async function(e){const t=$(e),n=await Promise.all(t.children(".js-dovAdaptableRepeaterItem").filter(function(){return(0,r.isDirty)($(this))}).map(async function(){const e=$(this),t={Data:await l(e)},n=e.data("key");return void 0!==n&&(t.Key=n),t})),a={name:t.attr("name"),value:JSON.stringify(n)};return a}(t);const n={name:t.attr("id"),value:JSON.stringify(t.data("savedata"))};return Promise.resolve(n)}function f(e){$("#"+e+"_save").attr("disabled","disabled").removeClass("dirty"),$("#"+e+"_saveBack").attr("disabled","disabled").removeClass("dirty"),$("#"+e+"_cancel").attr("disabled","disabled").removeClass("dirty")}function h(e){$("#"+e+"_save").attr("disabled",null).addClass("dirty"),$("#"+e+"_saveBack").attr("disabled",null).addClass("dirty"),$("#"+e+"_cancel").attr("disabled",null).addClass("dirty")}},1251(e,t,n){"use strict";n.r(t),n.d(t,{getPreSaveValidationHelper:()=>K});var a=n(92566),o=n(16140),r=n(68337),i=n(22528);function s(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function l(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const c="js-error-control--preSaveValidation",d="js-warn-control--preSaveValidation",u="js-info-control--preSaveValidation",f="js-warn-control--preSaveIgnore",h="error-control",p="warning-control",m="info-control",g="error-text",w="warning-text",v="info-text",b="js-info-text--invalidField",y="js-warning-text--invalidField",_="js-error-text--invalidField",C="js-changeTrackingRoot",k="comboBoxSet",S="datepicker",D="dmsBackingData",E="validationList",P="validationSpan",O="blur.preSaveValidation",B="change.preSaveValidation",T="dirty.preSaveValidation",x=$("<li>",{addClass:[g,_],append:$("<span>",{append:[(0,r.getSvg)("Error","Error").addClass(["alertError","svgNoHover"]),$("<span>",{addClass:P})]})}),M=$("<li>",{addClass:[w,y],append:$("<span>",{append:[(0,r.getSvg)("Warning","Warning").addClass(["alertWarning","svgNoHover"]),$("<span>",{addClass:P})]})}),I=$("<li>",{addClass:[v,b],append:$("<span>",{append:[(0,r.getSvg)("Info").addClass(["alertInfo","svgNoHover"]),$("<span>",{addClass:P})]})});function A(e,t){let n=[];return e.length>0&&e.each(function(){const e=$(this),a=e.find(".".concat(P)).text();if(""!==a){const o={severityType:t,message:a,toRemove:!0,liElement:e};n.push(o)}}),n}function L(e){const t=function(e){let t=!1,n=!1,a=!1,o=[],r=[],i=[];if(0!==e.length){const s=e.find(".".concat(b)),l=e.find(".".concat(y)),c=e.find(".".concat(_));t=e.find(".".concat(v)).not(s).length>0,n=e.find(".".concat(w)).not(l).length>0,a=e.find(".".concat(g)).not(c).length>0,o=A(s,"info"),r=A(l,"warning"),i=A(c,"error")}return{showInfo:t,showWarning:n,showError:a,preSaveInfoCount:o.length,preSaveErrorCount:r.length,preSaveWarnCount:i.length,existingPreSaveInfo:o,existingPreSaveWarn:r,existingPreSaveError:i}}(e);return{warnChange:0,errorChange:0,showInfo:t.showInfo,showWarning:t.showWarning,showError:t.showError,preSaveInfoCount:t.preSaveInfoCount,preSaveWarnCount:t.preSaveWarnCount,preSaveErrorCount:t.preSaveWarnCount,removeIgnoredWarningMarker:!0,existingPreSaveInfo:t.existingPreSaveInfo,existingPreSaveWarn:t.existingPreSaveWarn,existingPreSaveError:t.existingPreSaveError,liElementTemplateDetails:[]}}function R(e,t,n){const a=function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?s(Object(n),!0).forEach(function(t){l(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}({},e);let o=0,r=0;if(t)for(const t of n)switch(t.severityType){case"info":a.showInfo=!0;const n={template:I,message:t.message};a.liElementTemplateDetails.push(n);const i=N(e.existingPreSaveInfo,t.message);i&&(i.toRemove=!1);break;case"warning":a.showWarning=!0;const s={template:M,message:t.message};a.liElementTemplateDetails.push(s);const l=N(e.existingPreSaveWarn,t.message);l?l.toRemove=!1:(o++,a.removeIgnoredWarningMarker=!1);break;case"error":a.showError=!0;const c={template:x,message:t.message};a.liElementTemplateDetails.push(c);const d=N(e.existingPreSaveError,t.message);d?d.toRemove=!1:r++}for(const t of e.existingPreSaveWarn)t.toRemove&&o--;for(const t of e.existingPreSaveError)t.toRemove&&r--;return a.warnChange=o,a.errorChange=r,a}function N(e,t){for(const n of e)if(n.message===t)return n}function F(e,t,n,o){const r=(0,a.getContentMessageArea)(t.closest(".".concat(C)).parent());(e.existingPreSaveInfo.length>0||e.existingPreSaveWarn.length>0||e.existingPreSaveError.length>0)&&function(e,t,n,a){for(const e of t)e.liElement.remove();for(const e of n)e.liElement.remove();for(const e of a)e.liElement.remove();const o=e.find("ul.".concat(E));0===o.children().length&&o.remove()}(n,e.existingPreSaveInfo,e.existingPreSaveWarn,e.existingPreSaveError),e.liElementTemplateDetails.length>0&&function(e,t){let n=e.find("ul.".concat(E));0===n.length&&(n=$("<ul>",{addClass:E}).appendTo(e));for(const e of t){const t=e.template.clone();t.find(".".concat(P)).text(e.message),t.appendTo(n)}}(n,e.liElementTemplateDetails),null==r||r.modifyValidationCount(e.errorChange,e.warnChange),t.toggleClass([u,m],e.showInfo).toggleClass([d,p],e.showWarning).toggleClass([c,h],e.showError),(0,i.setAriaInvalid)(t,e.showError),o.toggleClass(v,e.showInfo).toggleClass(w,e.showWarning).toggleClass(g,e.showError),e.removeIgnoredWarningMarker&&t.removeClass(f)}function j(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[];const a=function(e){let t,n,a,o=e.closest(".fieldWrapper");if(0===o.length)return;let r=e.attr("id");return r&&(t=o.find('[data-validate-message-for="'.concat(r,'"]')),n=o.find('[for="'.concat(r,'"]'))),t&&0!==t.length||(r=e.attr("data-validate-control-for"),t=o.find('[data-validate-message-for="'.concat(r,'"]')),n=o.find('[data-validate-text-for="'.concat(r,'"]'))),t&&n&&(a={dataValidateMessageFor:t,dataValidateTextFor:n}),a}(e);if(!a)return;const o=a.dataValidateMessageFor,r=a.dataValidateTextFor;F(R(L(o),t,n),e,o,r)}function V(e,t){null!=t&&t.showValidation?j(t.fieldElement,!0,t.validation):j(e,!1)}function H(e,t){const n=(0,o.default)(()=>{!async function(e,t){V(e,await t(e))}(e,t)},300,1e3);U(e,n)}function W(e,t,n){const a=e.find(t),r=(0,o.default)(()=>{!async function(e,t){const n=[];e.each(function(){const e=$(this);n.push(e)});const a=await t(n);for(const e of a.validation)V(e.fieldElement,e)}(a,n)},300,1e3);a.each(function(){U($(this),r)})}function U(e,t){e.hasClass(S)?(e.off(T).on(T,t),e.off(B).on(B,t)):e.hasClass(k)||e.hasClass(D)?e.off(B).on(B,t):e.off(O).on(O,t)}function K(){return{showValidation:function(e,t){j(e,!0,t)},removeValidation:function(e){j(e,!1)},hasError:function(e){return e.hasClass(c)},hasWarning:function(e){return e.hasClass(d)},hasInfo:function(e){return e.hasClass(u)},registerFieldValidation:function(e,t){H(e,t)},registerContainerValidation:function(e,t,n){W(e,t,n)}}}},21701(e,t,n){"use strict";n.r(t),n.d(t,{closeModal:()=>o});var a=n(10631);function o(e){const t=e.closest("sky-datepicker");t.length>0&&t[0].closeModal&&t[0].closeModal()}customElements.define("sky-datepicker",a.Ay)},38950(e,t,n){"use strict";n.r(t),n.d(t,{closeModal:()=>P});var a=n(74061),o=n(2894),r=n(66952),i=n(81975),s=n(90121),l=n(98925),c=n(75552),d=n(6253),u=n(32529),f=n(97862),h=n(20960),p=n(50217);const m="dateTimePickerModal",g="dateTimePickerModal--dateTime",w=(0,a.defineComponent)({name:"datePickerModal",emits:{"update:value":e=>!0},props:{close:(0,c.oY)(Function),inputRef:(0,c.oY)(Object),value:(0,c.JJ)(Date,{default:()=>(0,i.now)()})},setup(e,t){const n=(0,a.useModel)(e,"value"),o=(0,a.ref)(new Date(n.value.getTime())),r=(0,i.now)(),s=e.value?e.value.getMonth()+1:r.getMonth()+1,l=e.value?e.value.getFullYear():r.getFullYear(),w=(0,a.ref)(s),v=(0,a.ref)(l),b=(0,a.computed)(()=>e.value&&e.value.getFullYear()>r.getFullYear()+10?e.value.getFullYear():r.getFullYear()+10),y=(0,a.computed)(()=>e.value&&e.value.getFullYear()<1900?e.value.getFullYear():1900),_=e.value?(0,i.convertTo12Hour)(e.value.getHours()):12,C=e.value?e.value.getMinutes():0,k=e.value&&e.value.getHours()>=12?"PM":"AM",S=(0,a.ref)(_),D=(0,a.ref)(C),E=(0,a.ref)(k),P=(0,a.ref)();(0,a.watch)(()=>n.value,e=>{o.value=e,I(e),D.value=e.getMinutes()}),(0,a.watch)(()=>S.value,e=>{let t=e;(void 0===t||isNaN(e))&&(t=0),"PM"===E.value&&(t+=12),o.value.setHours(t)}),(0,a.watch)(()=>D.value,e=>{let t=e;(void 0===t||isNaN(e))&&(t=0),o.value.setMinutes(null!=t?t:0)}),(0,a.watch)(()=>E.value,e=>{"AM"===e?o.value.setHours(o.value.getHours()-12):o.value.setHours(o.value.getHours()+12)}),(0,c.xF)(document.body,"keydown",async function(t){var r,s;const l=t.key.toUpperCase(),c=t.target;if(c.classList.contains("quickEELSelector__button"))return void("TAB"!==l&&t.preventDefault());"ARROWUP"!==l&&"ARROWDOWN"!==l&&"PAGEUP"!==l&&"PAGEDOWN"!==l&&"HOME"!==l&&"END"!==l||t.preventDefault();if(t.altKey&&("ARROWUP"===l||"ARROWDOWN"===l)){var d;return void(null===(d=e.inputRef.value)||void 0===d||d.focus())}if("ENTER"===l&&c.classList.contains(p.t.day)){var u;return void(null===(u=B.value)||void 0===u||u.focusHourInput())}if(["T","R","Y","C","N"].includes(l)){const e=(0,i.now)();let t=!0;switch(l){case"R":e.setDate(e.getDate()+1),null===(r=B.value)||void 0===r||r.focusHourInput(),t=!1;break;case"Y":e.setDate(e.getDate()-1),null===(s=B.value)||void 0===s||s.focusHourInput(),t=!1;break;case"T":e.setHours(n.value.getHours()),e.setMinutes(n.value.getMinutes()),e.setSeconds(n.value.getSeconds())}o.value=e,I(e),D.value=e.getMinutes(),w.value=e.getMonth()+1,v.value=e.getFullYear(),t&&(await(0,a.nextTick)(),M())}});const O=(0,a.ref)(),B=(0,a.ref)();return t.expose({focusCurrentDay(){var e;null===(e=O.value)||void 0===e||e.focusCurrentDay()},focusHourInput(){var e;null===(e=B.value)||void 0===e||e.focusHourInput()},focusMinuteInput(){var e;null===(e=B.value)||void 0===e||e.focusMinuteInput()},focusAmPmToggle(){var e;null===(e=B.value)||void 0===e||e.focusAmPmToggle()}}),()=>(0,a.createVNode)("div",{class:[m,g],ref:P},[(0,a.createVNode)(f.A,{month:w.value,year:v.value,yearLow:y.value,yearHigh:b.value,"onUpdate:month":e=>w.value=e,"onUpdate:year":e=>v.value=e},null,8,["month","year","yearLow","yearHigh","onUpdate:month","onUpdate:year"]),(0,a.createVNode)(d.A,{month:w.value,year:v.value,yearLow:y.value,yearHigh:b.value,selectedDate:o.value,"onUpdate:month":e=>w.value=e,"onUpdate:year":e=>v.value=e,"onUpdate:selectedDate":T,ref:O},null,8,["month","year","yearLow","yearHigh","selectedDate","onUpdate:month","onUpdate:year","onUpdate:selectedDate"]),(0,a.createVNode)(h.A,{ref:B,hour:S.value,minute:D.value,amPm:E.value,"onUpdate:hour":e=>S.value=e,"onUpdate:minute":e=>D.value=e,"onUpdate:amPm":e=>E.value=e},null,8,["hour","minute","amPm","onUpdate:hour","onUpdate:minute","onUpdate:amPm"]),(0,a.createVNode)(u.A,{buttonText:"Now",onButtonClick:x,onDoneClick:M},null,8,["onButtonClick","onDoneClick"])],2);function T(e){var t;o.value=e,null===(t=B.value)||void 0===t||t.focusHourInput()}async function x(){const e=(0,i.now)();w.value=e.getMonth()+1,v.value=e.getFullYear();const t=e.getHours();S.value=(0,i.convertTo12Hour)(t),E.value=t>=12?"PM":"AM",D.value=e.getMinutes(),o.value=e,await(0,a.nextTick)(),M()}function M(){n.value.getTime()===o.value.getTime()?t.emit("update:value",o.value):n.value=o.value,e.close()}function I(e){let t=e.getHours();E.value=t>=12?"PM":"AM",0===t?t=12:t>12&&(t%=12),S.value=t}}}),v="dateTimePicker",b="dateTimePicker__svg",y="datePicker__helpText";var _=function(e){return e.Month="M",e.Day="D",e.Year="Y",e.Hour="H",e.Minute="MM",e.AmPm="X",e}(_||{});const C=(0,a.defineCustomElement)({name:"sky-datetimepicker",shadowRoot:!1,inheritAttrs:!1,props:{name:(0,c.uh)(String),value:{type:String,required:!1,default:null,validator:e=>!e||"string"==typeof e&&(0,i.parseDate)(e).isValidDate()},autocomplete:(0,c.uh)(String),dependents:(0,c.uh)(Object),ariaLabelledby:(0,c.uh)(String),contained:(0,c.uh)(Boolean)},setup(e,t){const n=(0,a.ref)(),c=(0,a.ref)(!1);let d=(0,a.useHost)();const u=()=>{var e;d||(d=null===(e=n.value)||void 0===e?void 0:e.closest("sky-datetimepicker"));return d},f=()=>{var e;return"true"===(null===(e=u())||void 0===e||null===(e=e.getAttribute("aria-readonly"))||void 0===e?void 0:e.toLowerCase())},h=(0,a.ref)(f()),p=()=>{var e;return(null===(e=u())||void 0===e?void 0:e.id)||void 0},m=(0,a.ref)(p()),g=(0,a.computed)({get:()=>e.value,set:e=>{const t=u();t&&(t.value=e)}});(0,a.watch)(()=>e.value,e=>{!e||"string"==typeof e&&(0,i.parseDate)(e).isValidDate()||(g.value="")},{flush:"sync",immediate:!0});const C=(0,a.computed)({get:()=>{if(""!==e.value&&null!==e.value&&void 0!==e.value)return(0,i.parseDate)(e.value)},set:e=>{g.value=null!=e&&e.isValidDate()?(0,i.formatServerDate)(e):""}});t.expose({_valueAsDateRef:()=>C,_closeModal:M});const k=(0,a.ref)(!1);(0,a.onBeforeMount)(()=>{m.value&&$.findLabel(m.value).attr("for","".concat(m.value,"_input"))});const P=new MutationObserver(()=>{h.value=f(),m.value=p()});(0,a.onMounted)(()=>{var t,a;e.ariaLabelledby&&(null===(t=n.value)||void 0===t||t.setAttribute("aria-labelledby",e.ariaLabelledby),null===(a=u())||void 0===a||a.removeAttribute("aria-labelledby"));const o=u();o&&P.observe(o,{attributes:!0,attributeFilter:["aria-readonly","id"]})}),(0,a.onUnmounted)(()=>{P.disconnect()});const O=(0,r.nextAutoId)(),B=(0,r.nextAutoId)(),T=(0,a.ref)();return()=>{var t;return(0,a.createVNode)(a.Fragment,null,[(0,a.createVNode)("input",{type:"text",class:v,placeholder:"MM/DD/YYYY HH:MM XM",readonly:h.value,autocomplete:null!==(t=e.autocomplete)&&void 0!==t?t:"off",ref:n,onClick:H,onFocusin:A,onBeforeinput:U,onInput:K,onChange:W,onKeyup:j,onKeydown:R,onPaste:I,value:D(C.value),id:m.value?"".concat(m.value,"_input"):void 0,"data-dependents":JSON.stringify(e.dependents),role:"combobox","aria-expanded":0!=k.value,"aria-haspopup":"dialog","aria-controls":O,"aria-autocomplete":"none","aria-describedby":h.value?o.readOnlyAnnouncementID:B},null,42,["readonly","autocomplete","onClick","onFocusin","onBeforeinput","onInput","onChange","onKeyup","onKeydown","onPaste","value","id","data-dependents","aria-expanded","aria-controls","aria-describedby"]),!0===k.value&&(0,a.createVNode)(s.A,{containerId:O,expose:[x()],anchorTo:x(),preserveFocus:e=>"escape"===e,ariaLabel:"Choose date",onClose:M},{default:()=>[(0,a.createVNode)(w,{ref:T,inputRef:n,close:M,value:C.value,"onUpdate:value":e=>{q(e)}},null,8,["inputRef","close","value","onUpdate:value"])]},8,["containerId","expose","anchorTo","preserveFocus","onClose"]),(0,a.createVNode)(l.A,{name:"DateTime","aria-haspopup":"menu",role:"button",showHoverEffect:!1,class:b,onClick:()=>function(e){if(!0===k.value)return void M();V(e)}("svg click"),isButton:!h.value,"aria-label":"Date Time Picker"},null,8,["class","onClick","isButton"]),(0,a.createVNode)("div",{id:B,class:y},[(0,a.createTextVNode)("Type a date and time or use the down arrow key to navigate to the date time picker")],10,["id"])])};function x(){const t=n.value.parentElement;return e.contained?t.parentElement:t}async function M(e){var t;(k.value="closing",await(0,a.nextTick)(),k.value=!1,document.activeElement!==n.value)&&(c.value=!0,null===(t=n.value)||void 0===t||t.focus());g.value&&L(_.Month)}function I(e){var t;e.preventDefault();const n=null===(t=e.clipboardData)||void 0===t?void 0:t.getData("text/plain").replace(new RegExp("\\b(?:".concat(i.DAYS_OF_WEEK.join("|"),")\\b"),"g"),""),a=new Date(null!=n?n:"");return!(!n||!a.isValidDate())&&(q(a),!1)}function A(e){var t;const n=e.target;var a;if("true"===n.getAttribute("data-suppress-focus")||"true"===(null===(t=u())||void 0===t?void 0:t.getAttribute("data-suppress-focus")))return n.removeAttribute("data-suppress-focus"),void(null===(a=u())||void 0===a||a.removeAttribute("data-suppress-focus"));c.value?c.value=!1:V("focusin")}function L(e){const t=n.value,a=t.value,o=a.indexOf("/"),r=a.indexOf("/",o+1),i=a.indexOf(" "),s=a.indexOf(" ",i+1),l=a.indexOf(":"),c=a.lastIndexOf(" "),d=E(a);let u=null,f=null;switch(e){case _.Month:u=0,f=-1!==o?o:a.length;break;case _.Day:-1!==o&&(u=o+1,f=-1!==r?r:a.length);break;case _.Year:-1!==r&&(u=r+1,f=-1!==i?i:a.length);break;case _.Hour:-1!==l&&(u=-1!==s&&d?s+1:i+1,f=l);break;case _.Minute:-1!==l&&(u=l+1,f=Math.min(l+3,a.length));break;case _.AmPm:-1!==c&&c>l&&(u=c+1,f=a.length)}null!==u&&null!==f&&t.setSelectionRange(u,f)}async function R(e){const t=window.skyward.keys.getKeyNamesFromEvent(e);if(t.ARROW_RIGHT||t.ARROW_LEFT){e.preventDefault(),e.stopPropagation();const n=e.target.selectionStart,a=e.target.selectionEnd;return void F(t.ARROW_LEFT,t.ARROW_RIGHT,n,a)}if(!k.value&&t.ALT&&(t.ARROW_DOWN||t.ARROW_UP)&&V("keydown"),t.ENTER){e.preventDefault(),e.stopPropagation(),k.value&&(k.value=!1);return void q(S(n.value.value))}if(k.value&&t.TAB){k.value=!1;return void q(S(n.value.value))}var o;(t.ARROW_UP||t.ARROW_DOWN)&&(e.preventDefault(),e.stopPropagation(),k.value||(V("keydown"),await(0,a.nextTick)()),null===(o=T.value)||void 0===o||o.focusCurrentDay())}function N(e,t){const a=n.value.value,o=a.indexOf("/"),r=a.indexOf("/",o+1),i=a.indexOf(" "),s=a.indexOf(" ",i+1),l=E(a),c=a.indexOf(":"),d=a.lastIndexOf(" "),u=-1!==o?[0,o]:null,f=-1!==r?[o+1,r]:null,h=-1!==r?[r+1,-1!==i?i:a.length]:null;let p=null;-1!==c&&(p=-1!==s&&l?[s+1,c]:[i+1,c]);const m=-1!==c?[c+1,Math.min(c+3,a.length)]:null,g=d>c?[d+1,a.length]:null,w=[{range:u,part:_.Month},{range:f,part:_.Day},{range:h,part:_.Year},{range:p,part:_.Hour},{range:m,part:_.Minute},{range:g,part:_.AmPm}].filter(e=>e.range).find(n=>{return(a=n.range)&&e>=a[0]&&t<=a[1];var a});return w?w.part:h&&p&&e>h[1]&&e<p[0]?_.Day:void 0}function F(e,t,n,a){const o=[_.Month,_.Day,_.Year,_.Hour,_.Minute,_.AmPm],r=N(n,a),i=void 0!==r?o.indexOf(r):-1;if(t){return void L(o[-1===i?0:(i+1)%o.length])}if(e){return void L(o[-1===i?o.length-1:(i-1+o.length)%o.length])}void 0!==r&&L(r)}async function j(e){if(h.value)return;const t=window.skyward.keys.getKeyNamesFromEvent(e),n=(0,i.now)();function o(){C.value&&(n.setHours(C.value.getHours()),n.setMinutes(C.value.getMinutes()),n.setSeconds(C.value.getSeconds()))}(t.T||t.R||t.Y||t.C||t.N)&&(t.R?(n.setDate(n.getDate()+1),o()):t.Y?(n.setDate(n.getDate()-1),o()):t.T&&o(),q(n),await(0,a.nextTick)(),L(_.Hour))}function V(e){var t;h.value||!1!==k.value||(k.value=!0,null===(t=d)||void 0===t||t.scrollIntoView({block:"nearest"}),"svg click"===e&&n.value&&n.value.focus())}function H(e){F(!1,!1,e.target.selectionStart,e.target.selectionEnd)}function W(e){e.preventDefault(),e.stopPropagation();q(S(n.value.value.slice(0,19)))}function U(e){var t;const n=e,a=null===(t=n.data)||void 0===t?void 0:t.toUpperCase(),o=e.target;if(a){if(isNaN(parseInt(a))){if(":"===a&&!o.value.includes(":")&&o.value.length>0)return;if("P"===a&&!o.value.includes("P")&&o.value.length>0)return void(o.value.includes("A")&&(o.value=o.value.replace("AM","PM"),n.preventDefault()));if("A"===a&&!o.value.includes("A")&&o.value.length>0)return void(o.value.includes("P")&&(o.value=o.value.replace("PM","AM"),n.preventDefault()));if("/"===a&&!function(e){return e.split("/").length-1>=2}(o.value))return;n.preventDefault()}}else{if("deleteContentForward"===n.inputType&&o.selectionEnd===o.selectionStart){var r;const e=null!==(r=o.selectionEnd)&&void 0!==r?r:0;" "===o.value[e]&&o.setSelectionRange(e+1,e+1)}if("deleteContentBackward"===n.inputType&&o.selectionEnd===o.selectionStart&&!E(o.value)){var i;const e=null!==(i=o.selectionEnd)&&void 0!==i?i:0;" "===o.value[e-1]&&o.setSelectionRange(e-1,e-1)}}}async function K(e){const t=e.target;let n=t.selectionEnd,o=!1;E(t.value)&&n>=14&&(o=!0);const r=t.value.replace(/[^\dap:/ ]/gi,""),[i,...s]=r.trim().split(/\s+/);let l=s.join(" ");const c=i?i.split("/"):[],d=l?l.replace(/[^0-9:]/g,"").split(":"):[];let u="",f="",h="";if(c.length>0){u=c[0].slice(2),c[0]=c[0].slice(0,2);parseInt(c[0])>12&&(u=c[0].slice(1),c[0]="0"+c[0].slice(0,1)),u.length>0&&c.length<2&&c.push(u)}if(c.length>1)if(u.length>0)c[1]=u+c[1].slice(1,2),n=4;else{5!==n&&(f=c[1].slice(2)),c[1]=c[1].slice(0,2);const e=new Date(2e3,parseInt(c[0]),0).getDate();parseInt(c[1])>e&&(f=c[1].slice(1),c[1]="0"+c[1].slice(0,1)),f.length>0&&c.length<3&&c.push(f)}if(c.length>2){let e=c[2].toLowerCase();e.includes("a")?(c[2]=e.replace("a",""),l+="a"):e.includes("p")&&(c[2]=e.replace("p",""),l+="p"),f.length>0?(c[2]=f+c[2].slice(1,4),n=7):(h=c[2].slice(4),c[2]=c[2].slice(0,4)),h.length>0&&d.length<1&&d.push(h)}let p="",m="";d.length>0&&(h.length>0?(m=h+d[0].slice(1,2),n=12):(p=d[0].slice(2),m=d[0].slice(0,2)),p.length>0&&d.length<2&&d.push(p));let g="";d.length>1&&(p.length>0?(g=p+d[1].slice(1,2),n=15):g=d[1].slice(0,2));let w="";if(l){const a=l.match(/(am|pm|a|p)$/i);if(a)if(w=a[0].toUpperCase(),1===w.length&&e.inputType.startsWith("delete"))w="";else{let e=!1;"A"===w?(w="AM",e=!0):"P"===w&&(w="PM",e=!0),e&&(0===g.length&&(g="00"),0===m.length&&(m="12")),n==t.value.length&&(n=19,o=!1)}}let v=c.join("/");(m||g||w)&&(v+=" ",m&&(v+=m),g&&(v+=":"+g),w&&(v+=" "+w)),o&&(n-=4),t.value=v,await(0,a.nextTick)(),t.setSelectionRange(n,n)}function q(e){var t,a;const o=e?new Date(e):void 0;if(null==o||o.setSeconds(0),n.value.value=null!==(t=D(o))&&void 0!==t?t:"",(null===(a=C.value)||void 0===a?void 0:a.valueOf())!==(null==o?void 0:o.valueOf())){var r;C.value=o;const e=new CustomEvent("change",{bubbles:!0,detail:{internal:!0}});null===(r=u())||void 0===r||r.dispatchEvent(e)}}}});const k=class extends C{connectedCallback(){this._instance||(this.innerHTML=""),super.connectedCallback()}get valueAsDate(){return this._valueAsDateRef().value}set valueAsDate(e){this._valueAsDateRef().value=e}closeModal(){const e=this._closeModal;if("function"==typeof e)return e()}};function S(e){if(!e||""===e.trim())return;const t=(0,i.now)(),[n,a,o]=e.trim().split(/\s+/),r=n?n.split("/"):[];let s,l,c=t.getFullYear(),d=0,u=0;if(!(r.length>0))return;if(s=parseInt(r[0]),isNaN(s))return;if(s=Math.min(Math.max(s,1),12),r.length>1?(l=parseInt(r[1]),(isNaN(l)||l<1)&&(l=1)):l=1,r.length>2){const e=r[2];if(e.length<3&&e.length>0){if(parseInt(e)>55)r[2]="19".concat(e);else{const t=2===e.length?"20":"200";r[2]=t+e}}c=parseInt(r[2]),isNaN(c)&&(c=t.getFullYear())}const f=new Date(c,s,0).getDate();if(l=Math.min(l,f),a){const e=a.split(":");e.length>0&&(d=parseInt(e[0]),isNaN(d)&&(d=0)),e.length>1&&(u=parseInt(e[1]),isNaN(u)&&(u=0))}const h=o?o.toUpperCase():"";"PM"===h&&d<12?d+=12:"AM"===h&&12===d&&(d=0);const p=new Date(c,s-1,l,d,u);return p.setUTCFullYear(c),p}function D(e){if(!e)return;const t=String(e.getMonth()+1).padStart(2,"0"),n=String(e.getDate()).padStart(2,"0"),a=e.getFullYear(),o=i.DAYS_OF_WEEK[e.getDay()];let r=e.getHours(),s="AM";r>=12?(s="PM",12!==r&&(r%=12)):0==r&&(r=12);const l=String(r).padStart(2,"0"),c=String(e.getMinutes()).padStart(2,"0");return"".concat(t,"/").concat(n,"/").concat(String(a).padStart(4,"0")," ").concat(o," ").concat(l,":").concat(c," ").concat(s)}function E(e){return i.DAYS_OF_WEEK.some(t=>e.includes(t))}function P(e){const t=e.closest("sky-datetimepicker");t.length>0&&t[0].closeModal&&t[0].closeModal()}customElements.define("sky-datetimepicker",k)},16140(e,t,n){"use strict";n.r(t),n.d(t,{default:()=>o});let a=0;function o(e,t,n){let a,o;function r(){const r=this,i=arguments;function s(){a=null,e.apply(r,i)}a?window.clearTimeout(a):n&&(o=Date.now()),n&&a&&Date.now()-o>n?s():a=window.setTimeout(s,t)}return t&&!isNaN(t)||(t=300),(!n||isNaN(n)||n<t)&&(n=!1),r.force=function(){a&&(window.clearTimeout(a),a=null),e.apply(this,arguments)},Object.defineProperty(r,"isActive",{get:()=>null!=a}),r}$.fn.debounce=function(e,t,n,r,i,s){const l=typeof e,c=typeof t,d=typeof n,u=typeof r;"string"===l&&"function"===c?(r=t,i=n&&!isNaN(n)?n:null,s=r&&!isNaN(r)?r:void 0,t=null,n=null):"string"===l&&"string"===c&&"function"===d?(i=r&&!isNaN(r)?r:null,r=n,s=i&&!isNaN(i)?i:void 0,n=null):"string"===l&&"string"===c&&"function"===u&&(i=i&&!isNaN(i)?i:null,s=s&&!isNaN(s)?s:void 0);const f=o(r,i,s);return f.guid=r.guid||(r.guid=a++),this.on(e,t,n,f),this},window.skyward.debounce=o},51063(e,t,n){"use strict";n.r(t);var a=n(917),o=n(49343),r=n(41709),i=n(16023),s=n(83787),l=n(25560),c=n(92214),d=n(30368),u=n(64611),f=n(1445),h=n(28646),p=n(22528);const m=window.skyward;function g(e,t,n){e.find(t).each(function(){const t=$(this);t.find(n).on("change",function(){w(e,t,!0)}),w(e,t,!1,!0)})}function w(e,t,n,r){const i=t.is("option")?t.parent():t;if(t.hasClass("editableFields")||n&&i.hasClass("js-disableTriggerOnChange"))return;const s=$("#FauxFormLoad");s.length>0&&(r="true"===s.val());let d=t.data("dependents");if(void 0===d&&t.is("option")&&(d=i.data("dependents")),d){const i=document.body.querySelector("#screenReaderDependentAnnouncement"),s="screenReaderDependentAnnouncement";if(i)i.innerHTML=i.textContent+"&nbsp";else{const e=document.createElement("div");e.id=s,e.className="sr-only dependentAnnouncement",e.setAttribute("aria-live","polite"),document.body.append(e),setTimeout(()=>{e.textContent="Options on this page may change based on your selections."},0)}let u=(0,o.getClosestContentPanel)(t);const h=u.closest(".popup");h.length>0&&(u=h);const m=d.triggerOnLoad||n&&!r;m&&$.each(d.dependents,function(){let i=(0,o.getClosestContentPanel)(e);0==i.length&&(i=e);let s=i.find('[id="'+this.Id+'"]');0===s.length&&(s=i.find('[data-prefixed-id="'.concat(this.Id,'"]')));const d=this;function u(o,i){if(o.hasClass("editableFields"))return;let s=!0;if(r&&"true"!==i.TriggerOnLoad||!n&&"true"!==d.TriggerOnLoad)return;let u=(0,a.getValue)(t);u=null!=u?u.toString():"";const h="string"==typeof d.OnValue?d.OnValue.split(","):[],g="string"==typeof d.NotOnValue?d.NotOnValue.split(","):[];(void 0===d.OnValue||h.includes(u))&&(void 0!==d.NotOnValue&&g.includes(u)||(d.Clear&&"true"===d.Clear&&(t.hasClass("setByWorkflowTemplate")?t.removeClass("setByWorkflowTemplate"):b(o)),o.is(":checkbox")&&("true"===d.Toggle&&(C(o,!o.prop("checked")),s=!1),"false"===d.Clear&&(C(o,!0),s=!1)),t.is(":checkbox, input:radio")&&t.prop("checked")||t.is("option")||t.is("div.codeEEL")&&t.find(".codeEELValue").val()||t.is("div.accountDimensionEEL")&&t.find(".accountDimensionEELValue").val()||t.is(".distinctMultiSelectEEL")&&(0,l.getSearchParameters)(t.find(".dmsBackingData")).length>0||t.is("input")&&t.is(".datepicker,.text,.number,.durationpicker")&&""!==t.val()||t.is('input[type="hidden"]')&&""!==t.val()||t.is(".dateTimePickerWrapper")&&u||t.is("input")&&(t.is(".datePicker")||t.is(".timePicker")||t.is(".dateTimePicker"))&&u||t.hasClass("tileViewEEL")&&t.find(".tileViewEEL_value").val()?(d.Visibility&&y(o,"true"===d.Visibility,"false"!==d.AnimateVisibilityChange),d.ReadOnly&&(_(o,"true"===d.ReadOnly),o.is(":text")&&k(o,t.is(":checked"))),o.is(":checkbox")&&m&&d.Value&&(C(o,"string"==typeof d.Value&&"true"===d.Value.toLowerCase()),s=!1),o.is(":text")&&m&&d.Mask&&d.showMask&&k(o,d.showMask==t.is(":checked")),m&&d.ClearErrors&&(0,p.displayValidationMessages)(null,d.ClearErrors),o.is(":radio")&&m&&d.Value&&(!function(e,t){e.is(":radio")&&(e.prop("checked",t),e.trigger("change"))}(o,"true"===d.Value),s=!1)):(d.Visibility&&y(o,"true"!==d.Visibility),d.ReadOnly&&(_(o,"true"!==d.ReadOnly),o.is(":text")&&k(o,t.is(":checked")||!0===d.showMask)),o.is(":checkbox")&&m&&d.Value&&(C(o,"true"!==d.Value),s=!1),o.is(":text")&&m&&d.Mask&&d.showMask&&k(o,d.showMask==t.is(":checked"))),m&&d.Value&&(o.is(":text")||o.is(".dateTimePickerWrapper")||o.hasClass("radioSet")||o.hasClass("comboBoxSet")||o.hasClass("codeEEL"))?((0,a.setValue)(o,d.Value),s=!1):m&&o.hasClass("radioButtonGroup")&&void 0!==d.Value&&(void 0===d.OnValue||h.includes(u))&&((0,f.setValue)(o.find(".radioButtonGroupValue"),d.Value),s=!1),d.CopyParentValue?D(o,(0,a.getValue)(t)):d.DependentValue&&D(o,d.DependentValue),o.is(":input")&&d.Placeholder&&o.attr("placeholder",d.Placeholder),"true"===d.Refresh&&o.trigger("refresh"),!d.DependentValue&&d.ValueFunction&&(void 0===d.ValueFunctionArgs&&(d.ValueFunctionArgs=""),function(e,t,n){const a="keyup";let o=(0,c.getActionFunction)(t);if(void 0===o){const e=t.split(".");o=window[e[0]];for(let t=1;t<e.length;t++)o=o[e[t]]}const r=n.split(","),i=r.filter(e=>"#"===e.charAt(0)).map(e=>$(e));if(i.length>0)for(const s of i){const i="data-example-codependent-"+e.attr("id")+"-"+t+"-"+n.split("#").join("").split(",").join("-")+"-bound";void 0===s.attr(i)&&(s.debounce(a,function(){const t=r.map(e=>"#"===e.charAt(0)?$(e).val():e);D(e,o.apply(null,t))}),s.attr(i,"true"))}else D(e,o.apply(null,arguments));i[0]&&i[0].trigger(a)}(o,d.ValueFunction,d.ValueFunctionArgs)),(0,a.valueHasChanged)(o)&&(s||w(e,o,!0,r))))}if(0!==s.length)u(s,this);else{const e=$('.disciplineQuickEntryColumn [id^="'+this.Id+'-add-"]');if(1===e.length)u(e,this);else if(e.length>1)e.each(function(){u($(this),this)});else{if(i.is(".workflow")){const e=i.closest(".popup").attr("id"),t="".concat(e,"_").concat(this.Id);s=i.find('[id="'.concat(t,'"]'))}0!==s.length&&u(s,this)}}}),(0,o.notifyResize)()}else t.hasClass("setByWorkflowTemplate")&&t.removeClass("setByWorkflowTemplate")}function v(){this.find(".tabContainer").each(function(){const e=$(this),t=e.find(".tabStrip .tabButton"),n=e.find(".tabContents");t.each(function(e){const a=$(this),o=$(n[e]);if(a.is(":visible"))return t.removeClass("current"),a.addClass("current"),n.removeClass("current"),o.addClass("current"),!1})})}function b(e){if(e.hasClass("setByWorkflowTemplate"))e.removeClass("setByWorkflowTemplate");else if(!e.hasClass("editableFields")&&!e.hasClass("DefaultComboBoxSet"))if(e.hasClass("standardFilterViewer"))(0,h.clear)(e);else if(e.is(":checkbox"))C(e,!1);else if(e.hasClass("checkboxGroup"))(0,i.toggleAll)(e,!1);else if(e.is(".radioButtonGroupValue"))e.closest(".radioButtonGroup").find("[type='radio']").prop("checked",!1),(0,a.setValue)(e,null);else if(e.is(":radio"))e.prop("checked",!1);else if(e.is("div.codeEEL")){const t=e.find(".suppressChangeEvent").length>0;(0,a.clearValue)(e,t)}else if(e.hasClass("tileViewEEL")||e.hasClass("dateTimePickerWrapper"))(0,a.clearValue)(e);else if(e.is(".distinctMultiSelectEEL"))e.children(".selectedItems").find(".selectedItem:not(.dummyTile)").remove(),(0,a.clearValue)(e);else if(e.hasClass("multipleSelectBox"))e.children().each(function(){const e=$(this);if(e.hasClass("multiSelectBackingData"))e.data("searchParameters").length=0,e.trigger("change");else if(e.hasClass("multipleSelectOption")){e.find(".multipleSelectOptionCheckbox").prop("checked",!1)}});else if(e.hasClass("filterContainer")){const t=e.find(".filterBuilderLaunchButton");m.filterbuilder.updateFilter(t,null)}else(0,u.isHtmlEditorElement)(e)?(0,u.clearValue)(e):e.is("div")||e.is("fieldset")?e.hasClass("setByWorkflowTemplate")?e.removeClass("setByWorkflowTemplate"):e.children().each(function(){b($(this))}):e.is("input")||e.is("textarea")||e.is("select")?(0,a.setValue)(e,null):e.val(null)}function y(e,t,n){e&&!e.hasClass("tabContents")&&(0,a.toggleVisible)(e,t,n)}function _(e,t){!(0,a.toggle)(e,!t)&&e.is("div,fieldset")&&e.children().each(function(){_($(this),t)})}function C(e,t){e.is(":checkbox")&&(e.prop("checked",t),e.trigger("change"))}function k(e,t){const n=e.data();t?null!=n.decimalMask?(0,s.addDecimalMask)(e,e.data().decimalMask.toString()):null!=n.mask&&(0,s.addMask)(e,e.data().mask):(n.mask||n.decimalMask)&&(0,s.removeMask)(e)}function S(e,t,n){e.children(t).each(function(){$(this).val(n)})}function D(e,t){if(!e.hasClass("DefaultComboBoxSet"))if(e.is(":checkbox"))C(e,t);else if(e.is("div.codeEEL"))S(e,".codeEELValue, .codeEELCode, .codeEELDescription",t);else if(e.hasClass("tileViewEEL"))S(e,".tileViewEEL_value, .tileViewEEL_search",t);else if(e.is("label")||e.hasClass("visualLabel"))e.text(t),(0,d.alignTitles)("#"+e.attr("id"));else{const n=e.prop("maxLength");-1!==n&&!isNaN(n)&&"string"==typeof t&&t.length>n&&(t=t.substring(0,n)),(0,a.setValue)(e,t),(e.is("select")||e.is("input"))&&e.trigger("change"),e.hasClass("datepicker")&&m.datepicker.setDatePicker(e)}}(0,o.registerLoadDOMCallback)(function(){g(this,".codeEEL",".codeEELValue"),g(this,".tileViewEEL",".tileViewEEL_value")}),(0,o.registerLoadDOMCallback)(function(){const e=this;e.find(".radioSet, .radioButtonGroup").each(function(){const t=$(this);t.find("input:radio").on("change",function(){const t=$(this);w(e,t,!0),v.apply(e)});const n=t.find("input:checked");w(e,n,!1,!0),v.apply(e)})}),(0,o.registerLoadDOMCallback)(function(){const e=this;e.find(".comboBoxSet").each(function(){const t=$(this);if(!t.hasClass("DefaultComboBoxSet")){t.on("change",function(){const t=$(this).find("option:selected");w(e,t,!0)});const n=t.find("option:selected");w(e,n,!1,!0)}})}),(0,o.registerLoadDOMCallback)(function(){const e=this;e.find(".clearSpecialDependents").each(function(){const t=$(this);t.on("change",function(){w(e,t,!0)}),w(e,t,!1,!0)})}),(0,o.registerLoadDOMCallback)(function(){const e=this;function t(){const t=$(this);w(e,t,!0)}e.find("input[type='checkbox']").each(function(){const n=$(this);n.off("change",t),n.on("change",t),w(e,n,!1,!0)})}),(0,o.registerLoadDOMCallback)(function(){const e=this;e.find(".accountDimensionEEL").each(function(){const t=$(this),n=t.children(".accountDimensionEELValue"),a=t.children(".accountDimensionEELCode");t.on("change",function(){w(e,t,!0),a.hasClass("IsFund")&&""!==n.val()&&(0,r.focusAfter)(a)}),w(e,t,!1,!0)})}),(0,o.registerLoadDOMCallback)(function(){const e=this;e.find(".dateTimePickerWrapper").each(function(){const t=$(this);t.on("change",function(t){w(e,$(t.currentTarget),!0)}),w(e,t,!1,!0)})}),(0,o.registerLoadDOMCallback)(function(){const e=this;e.find(".distinctMultiSelectEEL").each(function(){const t=$(this);t.find(".dmsBackingData").on("change",function(){w(e,t,!0)}),w(e,t,!1,!0)})}),(0,o.registerLoadDOMCallback)(function(){const e=this;e.find('.datepicker,input[type="text"],input[type="hidden"]').each(function(){const t=$(this);t.on("change",function(){w(e,t,!0)}),w(e,t,!1,!0)})})},6927(e,t,n){"use strict";n.r(t);var a=n(88157),o=n(40096),r=n(40346),i=n(68337);n(75618),n(66952),n(49343);function s(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function l(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}window.skyward.base.registerScript("detailsPanel",function(e,t){let n,c,d,u,f=null,h=0,p=null,m=!1;const g={detailsPanelCloseBar:"detailsPanel__closeBar",previewModeOn:"previewModeOn",detailsPanel:"detailsPanel",skywardContentPanel:"skywardContentPanel",changeTrackingRoot:"js-changeTrackingRoot",currentRecordContent:"currentRecordContent",button:"button"},w="show-details-panel",v="detailsPanel",b="moduleContent",y="DirtyDetailsResizeWarning",_=e.extensions.lazy(function(){return t("<div>",{class:g.detailsPanelCloseBar,append:t("<a>",{class:"button chromeless svgAnchor",href:"javascript:void(0)",append:[(0,i.getSvg)("Close")," Close"],"data-click-action":"detailsPanel.close"})})}),C={open:e.events.getCallbackStore(),close:e.events.getCallbackStore(),resizeClose:e.events.getCallbackStore(),resizeOpen:e.events.getCallbackStore(),resizeCanOpen:e.events.getCallbackStore(),empty:e.events.getCallbackStore(),contentLoaded:e.events.getCallbackStore(),resizeThresholdCrossed:e.events.getCallbackStore()},k={init:function(){if(D())return void console.warn("Multiple calls to detailsPanel.init, which should only be called once.",u,this);u=t(this),d=u.find("#"+b),m="True"===u.data(w),C.open.registerCallback(function(e,t){t.opener&&t.opener.scrollintoview({duration:0})}),c=t("<div>",{id:v,class:[g.detailsPanel,g.skywardContentPanel].join(" ")}),c.on("DOMInsertionPostLoad",function(e){c.is(e.target)&&E(C.contentLoaded)}),e.window.registerLayoutResizeCallback(L)},close:function(){const t=R();e.detailsPanel.closeDetailsPanel(!0).then(function(){t.opener&&t.opener.focus()})}},S={shouldAnimate:!0,panelWidth:void 0,forcePopup:!1,useCloseButton:!1,additionalData:{}};return e.detailsPanel=e.detailsPanel||{},e.detailsPanel.eventCallbacks=e.events.getCallbackStoreFacadeCollection(C),e.detailsPanel.getDetailsPanelSessionState=function(){return m},e.detailsPanel.setDetailsPanelSessionState=function(n){D()&&(m=!!n,t.ajax(e.global.virtualDir+"Security/Session/UpdateDetailsPanelDisplay",{type:"POST",dataType:"JSON",data:{showDetailsPanel:m}}))},e.detailsPanel.isDetailsPanelOpen=function(){return D()&&A()},e.detailsPanel.getData=O,e.detailsPanel.getAdditionalData=R,e.detailsPanel.openDetailsPanel=function(a,r,i,s,l,d){const u=t.Deferred();if(!D()||null==a||null==r||null==i)return u.reject().promise();const f=t.extend({},S,d);return M()&&!f.forcePopup?e.detailsPanel.tryCloseDetailsPanel(()=>{var t;return B(),P(a,r,i,s,l,f),I(!0,f.shouldAnimate,f.panelWidth),"object"==typeof(t=n)&&"function"==typeof t.abort&&n.abort(),n=e.window.loadContent("detailsPanel",a,r,i,s,l),n.then(function(){!0===f.useCloseButton&&c.prepend(function(){const e=_();return(0,o.setClass)(e.find(g.button.dot()),!1),e}())}),n.promise()}):(e.window.loadContent("popout",a,r,i,s,l),u.reject().promise())},e.detailsPanel.closeDetailsPanel=function(n){return D()&&A()?e.detailsPanel.tryCloseDetailsPanel(function(){return I(!1,n)}):t.Deferred().reject().promise()},e.detailsPanel.canShowDetailsPanel=M,e.detailsPanel.emptyDetailsPanel=B,e.detailsPanel.detailsPanelIsDirty=function(){if(!D()||!A())return!1;const e=c.find(g.currentRecordContent.dot());return!(e.length<1)&&(0,r.isDirty)(e)},e.detailsPanel.tryCloseDetailsPanel=function(){let n,o=[];return function(i){if(o.push(i),void 0!==n)return n.promise();n=t.Deferred();let s=!1;return e.detailsPanel.detailsPanelIsDirty()?function(e){const n=t.Deferred();if(!D())return n.reject().promise();const o="leave this record",r="You have unsaved data that will be lost if you "+o+".";return(0,a.showWarningDialog)(o,r).then(()=>{if("function"==typeof e){const a=e();t.when(a).done(n.resolve)}else n.resolve()}).catch(()=>{const e=c.find(".toolbar .save");e.length>0&&e.first().focus(),n.reject()}),n.promise()}(async function(){s=!0,await async function(){if(!D())return;const e=c.find(g.changeTrackingRoot.dot());if(e.length<1)return;const t=e.attr("id");void 0!==t&&await(0,r.clearDirtyList)(t)}(),d()}).fail(l):d(),(n||t.Deferred().reject()).promise();function l(){var e;o=[],null===(e=n)||void 0===e||e.reject(s),n=void 0}function d(){let e=[],a=o;o=[];for(let t=0;t<a.length;t++)if("function"==typeof a[t]){const n=a[t]();"object"==typeof n&&"function"==typeof n.done&&e.push(n)}t.whenAllSettled(e).done(function(){var e;o.length>0?d():(null===(e=n)||void 0===e||e.resolve(s),n=void 0)}).fail(l)}}}(),e.detailsPanel.containsElement=function(e){var n,a;return!(!D()||t.isEmptyObject(e))&&(A()&&(null===(n=c.get(0))||void 0===n?void 0:n.contains(null!==(a=e.get(0))&&void 0!==a?a:null))||!1)},e.detailsPanel.setPanelWidth=function(e){D()&&A()&&c.css("width",e)},e.detailsPanel.addClassToDetailsPanel=function(e){c.addClass(e)},e.detailsPanel.addClassToModuleContent=function(e){d.addClass(e)},e.detailsPanel.setDetailsPanelData=function(e,t,n,a,o){var r,i;P(e,t,n,a,o,null!==(r=null===(i=p)||void 0===i?void 0:i.options)&&void 0!==r?r:function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?s(Object(n),!0).forEach(function(t){l(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):s(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}({},S))},k;function D(){return u&&d&&c}function E(e,n){const a=t.extend(O(),n),o=R();e.dispatchCallbacks(a,o)}function P(e,n,a,o,r,i){p=t.extend({},r,i,{renderInDetailsPanel:!0,module:e,object:n,screen:a,primarykey:o,postData:r,options:i})}function O(){return t.extend({},p)}function B(){D()&&!c.is(":empty")&&(c.empty(),E(C.empty))}function T(){A()||(d.addClass(g.previewModeOn),u.append(c))}function x(e){A()&&(c.detach(),d.removeClass(g.previewModeOn),e||B())}function M(){return e.window.clientWidth>=1200}function I(e,n,a){const o=t.Deferred();if(e&&!M())return o.reject().promise();e&&T();const r=n?230:0,i=e?null!=a?a:"50%":0;return c.stop().animate({width:i},r,function(){e||x();t(window).trigger("resize"),e?E(C.open):(E(C.close),p=null);o.resolve()}),o.promise()}function A(){var e,t;return d.hasClass(g.previewModeOn)||(null===(e=document.documentElement)||void 0===e?void 0:e.contains(null!==(t=c.get(0))&&void 0!==t?t:null))||!1}function L(){if(h===e.window.clientWidth)return;const n=M(),o=h>=1200;if(h=e.window.clientWidth,n===o)return;E(C.resizeThresholdCrossed,{canShowDetailsPanel:n});const r=A();r&&!n?(null===f&&e.detailsPanel.detailsPanelIsDirty()&&(f=function(){const e="use a smaller window size",t="The record details has unsaved changes and cannot display at this window size.\n\nYour unsaved data will be lost if you "+e+".\n\nResize your window to be wider to keep these changes.\n\nThis message will close when your window is wide enough to show the record details.";return(0,a.showWarningDialog)(e,t,{id:y})}()),x(!0),E(C.resizeClose)):!r&&n&&(c.is(":empty")?m&&E(C.resizeCanOpen):(null!==f&&function(){f=null;const e=(0,a.getLayerFromElement)(t("#"+y));e&&"function"==typeof e.close&&e.close()}(),T(),E(C.resizeOpen)))}function R(){const e=O();var t;return Object.prototype.hasOwnProperty.call(e,"options")&&null!==(t=e.options.additionalData)&&void 0!==t?t:{}}})},1380(e,t,n){"use strict";n.r(t),n.d(t,{registerLayer:()=>s,setFocus:()=>c,toggleIgnoreElement:()=>d,unregisterLayer:()=>l});const a=[],o="js-dialogFocusManagerIgnore",r=$("<div>",{tabindex:0}),i=new WeakMap;function s(e){a.push(e),function(e){const t=r.clone(),n=r.clone();t.insertBefore(e.contents),n.insertAfter(e.contents),i.set(e,{before:t,after:n})}(e)}function l(e,t){const n=a.indexOf(e);if(n>-1&&a.splice(n,1),i.has(e)){const t=i.get(e);t.before.remove(),t.after.remove(),i.delete(e)}!0===t&&document.activeElement!==e.originalActiveElement&&$(e.originalActiveElement).trigger("focus")}function c(e){const t=u(e),n=t.get(0);if(n){var a;if((n.matches(".dateTimePickerWrapper")||null!==(a=n.parentElement)&&void 0!==a&&a.matches(".dateTimePickerWrapper"))&&n.setAttribute("data-suppress-focus","true"),"input"===(o=n).tagName.toLowerCase()&&"text"===o.type){const e=n.value.length;n.setSelectionRange(e,e)}n.focus()}var o;return t}$(document).on("focusin",function(e){if(e.generatedByFocusManager)return;const t=function(){for(let e=a.length-1;e>=0;e--)if(f(a[e]))return a[e];return}();if(!t)return;const n=$(e.target);if(n.length){if(n.hasClass(o))return;if(t.contents.get(0).contains(n[0]))return;if(n.closest(".exposedToModalLayer_"+t.uniqueId).length>0)return;if(n.closest(".fr-popup,.fr-modal").length>0)return}const r=i.get(t);let s;n.is(r.before)?s=t.contents.find(":tabbable").last():n.is(r.after)&&(s=t.contents.find(":tabbable").first());void 0!==s&&0!==s.length||(s=u(t));s.trigger({type:"focus",generatedByFocusManager:!0})});const d=function(e,t){e.toggleClass(o,t)};function u(e){let t;if(!0===e.options.preserveFocus?t=$(e.originalActiveElement).closest(":focusable"):e.options.initialFocusElement&&(t=e.container.find($(e.options.initialFocusElement))),!t||0===t.length){const n=e.contents.find(".content"),a=n.find(":tabbable").not(".ui-disabled").not("[readonly]"),o=n.find("input:not([type='hidden']), textarea, select, table, ul, dl, ol, h1, h2, h3, h4, h5, h6").length>0,r=e.contents.find(".modalHeaderText");if(a.length>0)t=a.first();else if(o&&r.length>0)r.attr("tabindex","-1"),t=r.first();else{const n=e.contents.find(":tabbable");n.length>0&&(t=n.first())}}return t&&0!==t.length?e.contents.removeAttr("tabindex"):t=e.contents.attr("tabindex","0"),t}function f(e){return"object"==typeof e&&e.onscreen&&e.container.length&&e.contents.length&&document.body.contains(e.contents[0])}},62894(e,t,n){"use strict";n.r(t),n.d(t,{changeTracking:()=>oe,getData:()=>se,isEmpty:()=>re,massSelect:()=>ie,registerDistinctMultiSelectEEL:()=>ae,set:()=>le});var a=n(62521),o=n(3543),r=n(79126),i=n(2894),s=n(88157),l=n(49343),c=n(66952),d=n(82441),u=n(917),f=n(16140),h=n(92214),p=n(53346);function m(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function g(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?m(Object(n),!0).forEach(function(t){w(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):m(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function w(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const v="distinctMultiSelectEEL",b="distinctMultiSelectSearchButton",y="distinctMultiSelectUserInput",_="distinctMultiSelectClearButton",C="distinctMultiSelectContainer",k="dmsBackingData",S="dummyTile",D="selectedItems",E="selectedItem",P="selectedItem__removeIcon",O="eventsBound--DMSE",B="unlockedBrowseBody",T="selectDistinctMultiSelectEELBrowseRow",x="browse",M="checkbox-mass-select-button",I="js-massSelectCell",A="current",L="browseRow",R="checkbox-button",N="browseDataCell",F="checkbox",j="ui-disabled",V="browseBody",H="noneChecked",W="returnValueListAsKeys",U="modalLayerContainer",K="hasDependentPrompts",q="workflowContent",G="currentRecordContent",z="carbonCopyOptionFilterWrapper",J="filterValue",Y="multipleSelectBox",Q="multiSelectBackingData",X="promptFieldSet",Z=window.skyward,ee=new WeakMap,te=(0,c.getIdGenerator)("popup","_distinctMultiSelectEELBrowse"),ne={init:function(e){ae($(e))}};function ae(e){var t;if(e.hasClass("dmsBackingData")&&(e=e.closest(".distinctMultiSelectEEL")),e.hasClass(O)&&(null===(t=e.data("dmseInstance"))||void 0===t?void 0:t.distinctMultiSelectEELData.hiddenBackingData.parent()[0])===e[0])return e.data("dmseInstance");let n=null,h={onscreen:!1};const m=e.data();let w;m.additionalfieldinfo=e.attr("data-additionalfieldinfo"),m.sortfieldinfo=e.attr("data-sortfieldinfo");const v=e.find("ul.".concat(D));v.find("a").prop("tabIndex",-1);const k=v.children(".".concat(b)),W=v.find(".".concat(y)),U=W&&W.length>0?W[0].placeholder:null,K=e.children(".".concat(_)),q=e.find(".".concat(C));ye(),be();const G=e.findLabel();if(G.length){G.on("click",function(){W.is(document.activeElement)||W.trigger("focus")});const t=G.addIds().attr("id");e.attr("aria-labelledby",t);const n=W.attr("id");"LABEL"===G[0].tagName&&n?G.attr("for",n):W.attr("aria-labelledby",t)}v.find(".selectedItem").off("click").on("click",ae),v.on("click",function(){W.is(document.activeElement)||W.trigger("focus")});const z=v.find("li.".concat(S)),J=g(g({},m),{},{selectedItemKeys:[],selectedItemHashes:[],selectedKeyValuePairs:{},selectedKeyValueHashes:{},filter:JSON.stringify(m.filter),hiddenBackingData:e.find(".dmsBackingData"),readOnlySelectedItemIDs:m.readonlyselecteditemids,textbox:W,layer:null,forceSingleThread:m.forceSingleThread||!1,dynamicFilterHashes:{}}),Y=new c.SequentialOperationHandler(!0),Q=new d.HashTransaction(J.hiddenBackingData);m.requestDataHashReadonly||function(e,t,n){var a;const o=null!==(a=n.hiddenBackingData.data("original-name"))&&void 0!==a?a:n.hiddenBackingData.attr("name"),r=(0,d.getRequestDataHash)(e,o);if(!r)return;n.requestDataHash=r.hash;const i=r.initialValues,s=n.hiddenBackingData.data();n.dynamicFilterHashes=g({},r.dependencies);const l={};for(const e of t.find("[data-targetid]")){const t=$(e).data();l[t.targetid]=t}const c=Object.keys(JSON.parse(n.hiddenBackingData.val())),u=[];for(let e=0;e<c.length;e+=1){const t=i[c[e]];l[c[e]].targethash=t,u.push(t)}s.selectedValueHash=s.originalSelectedValueHash=u.join(",")}(m.requestDataHashSrc,e,J),v.find("li.".concat(E)).not(".".concat(S)).each(function(){const e=$(this),t=e.data("targetid")+"",n=e.data("targethash");-1===J.selectedItemKeys.indexOf(t)&&(J.selectedItemKeys.push(t),J.selectedItemHashes.push(n),J.selectedKeyValuePairs[t]=e.text().trim().replace(/\r\n|\r|\n|\u0085|\u2028|\u2029/g," "),J.selectedKeyValueHashes[t]=n)}),e.find(".".concat(b)).off("click").on("click",function(){if($(this).is(".".concat(j)))return!1;h.onscreen?h.close():(he(),ce(W.val(),void 0))}),e.children(".".concat(_)).off("click").on("click",function(){h.onscreen&&!i.mobileAccess&&h.close(),ie()}),pe(),J.hiddenBackingData.on("workflowEnd",function(e,t){return!$.isEmptyObject(t.updateControl)&&J.hiddenBackingData.attr("id")===t.updateControl.pageStateControl&&(he(),ce("",t.updateControl.primaryKey).then(function(){const e=(0,o.getInnerBrowse)(J.layer.container);if(null==e)return;const n=e.id;$(document).one("browseLoaded."+n,function(){const e=(0,o.getBrowseById)(n),a=""!==t.redirectURL;let r=!1;if(e&&e.browse){var i;const n=e.browse.find(".".concat(R).concat(ve(null===(i=t.updateControl)||void 0===i?void 0:i.primaryKey))).find(".".concat(F));r=n.length>0,r&&!n.is(":checked")&&n.trigger("click")}(0,p.getTopMostWorkflow)().length&&J.layer.close();let l=$.Deferred().resolve().promise();if(!r){const t="There is a Filter applied to this List that is preventing the item from being selected. Try adding a new item or go to the ".concat(e.routeObject," List to modify your item.");l=(0,s.showErrorDialog)("The item you added cannot be made available for this list.",t)}a&&l.then(function(){(0,p.callLoadContentFromUrl)(t)})})}),!0)}),J.hiddenBackingData.on("change",ke),J.hiddenBackingData.on("forceRebuild",ke),W.on("keydown",function(e){const t=Z.keys.getKeyNamesFromEvent(e),n=Z.keys.isPrintableCharacter(e.keyCode),a=t.ENTER||t.ARROW_DOWN||t.ARROW_UP||t.SPACE;if(!(a||n)||t.TAB)return;let o=!0;const r=W.val(),i=0===r.length;return h.onscreen?t.ENTER&&(o=!1):(he(),a&&(ce(r,void 0),e.preventDefault(),o=!1)),t.BACKSPACE&&i&&(W.parent().prevAll().not(".".concat(S)).first().find(".".concat(P)).trigger("click"),ge(),W.trigger("focus")),o}),e.on("clearAll",(e,t)=>ie(t));const X=e.data("clear");void 0!==X&&(ie(X),e.removeData("clear")),e.addClass(O);const ne={remove:oe,unselectAll:ie,add:se,doSearch:ce,showPopup:he,selectedItems:v,setBackingData:_e,distinctMultiSelectEELData:J};return m.dmseInstance=ne,J.hiddenBackingData.trigger("controlLoaded"),ne;function ae(){const e=$(this),t=e.closest(".ui-disabled").length>0,n=e.has(".".concat(P)).length>0;if(t||!n)return;const a=e.closest("li").data("targetid");return oe(a),re(a,!1),_e(J.selectedKeyValuePairs,J.selectedKeyValueHashes,!0),Se(),!1}function oe(e){const t=J.selectedItemKeys.findIndex(t=>{const n="number"==typeof e?parseInt(t):t;return e===n});-1!==t&&(J.selectedItemKeys.splice(t,1),J.selectedItemHashes.splice(t,1)),delete J.selectedKeyValuePairs[e],delete J.selectedKeyValueHashes[e];v.find(ve(e)).remove(),le()}function re(e,t){if(h.onscreen&&h.container instanceof $){h.container.find(".".concat(B," .").concat(T)).filter(ve(e)).children("input").prop("checked",t)}}function ie(){let e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];const t={},n={};if((J.readOnlySelectedItemIDs||[]).length>0){var a;const e=Object.entries(JSON.parse(J.hiddenBackingData.val())),o=(null!==(a=J.hiddenBackingData.data("selectedValueHash"))&&void 0!==a?a:"").split(",");for(let a=0;a<e.length;a+=1){const[r,i]=e[a],s=o[a];J.readOnlySelectedItemIDs.some(e=>r==e)&&(t[r]=i,n[r]=s)}}J.selectedKeyValuePairs=t,J.selectedKeyValueHashes=n,_e(t,n,!1,e),h.onscreen&&h.container instanceof $&&h.container.find(".".concat(B," .").concat(T)).children("input").prop("checked",!1)}function se(e,t,n){let a=arguments.length>3&&void 0!==arguments[3]&&arguments[3];if((J.isSingleSelect||-1===J.selectedItemKeys.indexOf(e))&&(J.selectedItemKeys.push(e),J.selectedItemHashes.push(t)),J.selectedKeyValuePairs[e]=n,J.selectedKeyValueHashes[e]=t,!v.has(ve(e)).length){const o=z.clone();o.attr("data-targetid",e),o.attr("data-targethash",t),o.find("span").text((n||"").replace(/\r\n|\r|\n|\u0085|\u2028|\u2029/g," ")),o.removeClass(S),o.insertBefore(z),o.off("click").on("click",ae),a||le()}}function le(){W.trigger("select"),W.scrollintoview({duration:0}),e.scrollintoview({duration:0})}function ce(e,t){if($.isEmptyObject(J.layer)||!J.layer.container)return Promise.reject();const n=J.layer.container.find(".".concat(x));w=n.attr("id"),ee.set(n[0],J);const o=$.extend({},J);return void 0!==t?$.extend(o,{seekId:t}):$.extend(o,{distinctMultiSelectEELSearchText:(0,c.encodeHtml)(e)}),Y.run(e=>(0,a.performDistinctMultiSelectEELSearch)(w,o,e).promise())}function de(){!$.isEmptyObject(h)&&h.container instanceof $&&(J.button=h.container.find(".".concat(M)),J.button.on("click",function(){ue(-1)}))}function ue(e){(0,a.setCurrentRecord)(w,e,{loadRelatedBrowses:!1})}function fe(e,t,n){return{id:e,browse:t,browseType:"DistinctMultiSelect",routeModule:J.routeModule,routeObject:J.routeObject,pageModule:J.dataModule,pageObject:J.dataObject,pageScreen:"",dataModule:J.dataModule,dataObject:J.dataObject,routeHash:J.routeHash,requestDataHash:J.requestDataHash,refreshTimeout:-1,filter:J.filter,keyEventsEnabled:!0,additionalfieldinfo:J.additionalfieldinfo,sortfieldinfo:J.sortfieldinfo,distinctfield:J.distinctfield,rendernodatarow:J.rendernodatarow,hidedistinctfield:J.hidedistinctfield,distinctfieldwidth:J.distinctfieldwidth,selectedItemKeys:J.selectedItemKeys,browseName:J.browseName,browseId:J.browseId,isOnTheFly:J.isOnTheFly,successCallback:de,data:q.data("postdata"),dynamicFilterHashes:J.dynamicFilterHashes,dynamicFilterValues:n,queryParameterData:J.queryParameterData,hidePrimaryBrowseButton:J.hidePrimaryBrowseButton,hiddenBackingDataId:J.hiddenBackingData.attr("id"),rowsPerPage:J.rowsPerPage,taskName:"",primaryKeys:[],resize:function(){}}}function he(){(0,o.removeBrowse)(w),w=te.getNewId(),W.attr("aria-expanded","true");const t=$("<div>",{class:"popup--browse",id:w+"_popup"}),r=$("<div>",{id:w,class:"".concat(x," browseStaticHeight")});t.append(r);const c=(0,d.getDependencyDataWithoutWaiting)(J,(0,u.getScopeContainer)(e)),p=fe(w,r,c);(0,o.addBrowse)(p,w),(0,o.prependOpenBrowse)(w);const m=[{onEvents:"input",bindTo:W,runFunction:pe},{onEvents:"input",bindTo:W,runFunction:(0,f.default)(ge)},{onEvents:"keydown",bindTo:W,runFunction:function(e){const t=Z.keys.getKeyNamesFromEvent(e);if(t.TAB)h.close();else if(t.ENTER){h.contents.find(".".concat(I,".").concat(A)).length>0?J.button&&J.button.trigger("click"):h.contents.find(".".concat(L,".").concat(A," .").concat(T)).first().trigger("click"),e.preventDefault()}}},{onEvents:"click",bindTo:k,runFunction:function(){h.close()}},{onEvents:"rowChanged browseLoaded.".concat(w),bindTo:r,runFunction:function(e){const t=(0,o.getBrowseById)(w),n=(0,a.getCurrentRowElement)("unlocked",w,t.currentRow,"DistinctMultiSelect");W.attr("aria-activedescendant",n.addIds().attr("id"))}}];h=(0,s.showCodeEELDialog)(t,W,q,function(){Y.close(),W.val(""),i.mobileAccess||W.trigger("focus"),n=null,p.rowsPerPage&&(J.rowsPerPage=p.rowsPerPage),h={onscreen:!1},J.layer=null,q.off("wheel",b)},J,m,function(){e.trigger("modalClosed"),W.attr("aria-expanded","false")});const g=v.get(0);function b(e){if(!(0,l.hasVerticalScrollBar)(v))return void e.preventDefault();const t=0===g.scrollTop,n=e.originalEvent,a=n.deltaY<0;if(t&&a)return void e.preventDefault();const o=g.scrollTop+v.outerHeight()===g.scrollHeight,r=n.deltaY>0;if(o&&r)return void e.preventDefault();const i=e.target;g!==i&&!$.contains(g,i)&&e.preventDefault()}q.on("wheel",b),h.container.off("change").on("change",".".concat(F),null,me),h.container.data("scopedMassSelect",we),W.trigger("focus")}function pe(){var e;const t=(0,i.calculateTextWidthPx)(W.val())+20,n=(0,i.calculateTextWidthPx)(null!==(e=W.attr("placeholder"))&&void 0!==e?e:"")+20;W.css({width:Math.max(t,n)+"px"})}function me(){const e=$(this),t=$(this).closest(".".concat(R));let n=t.data("targetid");n=null!==n?n.toString():"";const a=e.closest("[data-row]").data("row"),r=(0,o.getBrowseById)(w).rowDataHash[a],i=t.closest("tr"),s=i.find(".".concat(N)).first().text(),l=e.is(":checked");l?(J.isSingleSelect&&ie(!0),se(n,r,s,!1)):oe(n),J.isSingleSelect&&h.close(),ue(i.prevAll().length),_e(J.selectedKeyValuePairs,J.selectedKeyValueHashes,!0),function(e,t,n){e.find(".".concat(R)).each(function(){const e=$(this);e.data("targetid")===t&&(0,u.setValue)(e.children(".".concat(F)),n,!0)})}(i.closest(".".concat(V)),n,l),Se()}function ge(){if(document.activeElement!=W.get(0))return;const e=W.val();pe(),null!==n&&e.toLowerCase()===n.toLowerCase()||(null==J.layer&&he(),n=e,ce(e,void 0))}function we(e){const t=$(e),n=(0,o.getBrowseById)(w);if(!n)return null;if(t.hasClass(H)){const e=(0,a.getRequiredBrowseData)(n,{}),t=i.virtualDir+n.routeModule+"/"+n.routeObject+"/SelectAll",o={distinctMultiSelectEELSearchText:(0,c.encodeHtml)(W.val())};$.extend(e,o),$.ajax({url:t,type:"POST",dataType:"JSON",activityIndicator:{hideGlass:!0},data:e,success:function(e){for(const{id:t,hash:n,name:a}of e)se(t,n,a,!1),re(t,!0);!async function(){J.selectedKeyValuePairs={},J.selectedKeyValueHashes={},J.selectedItemKeys=[],J.selectedItemHashes=[],e=J.hiddenBackingData,t=function(e,t,n){J.selectedItemKeys.push(e),J.selectedKeyValuePairs[e]=t,J.selectedKeyValueHashes[e]=n},e.siblings(".".concat(C)).find(".".concat(D)).find(".".concat(E)).not(".".concat(S)).each(function(){const e=$(this);let n=e.data().targetid;n="number"==typeof n?n.toString():n;const a=e.text().trim(),o=e.data().targethash;t(n,a,o)}),await _e(J.selectedKeyValuePairs,J.selectedKeyValueHashes,!0);var e,t}(),Se()}})}else ie();return $.Deferred().reject()}function ve(e){return"[data-targetid='"+CSS.escape(e.toString())+"']"}function be(){v.has("[data-targetid]").length>0?K.show():K.hide()}function ye(){!function(e,t,n){if(!n)return;e.has("[data-targetid]").length?t[0].placeholder="":t[0].placeholder=n}(v,W,U),pe()}async function _e(e,t,n){let a=arguments.length>3&&void 0!==arguments[3]&&arguments[3];const o=null!=e?e:{};n&&J.hiddenBackingData.off("change",ke);const i=Object.fromEntries(Object.entries(o).sort((e,t)=>o[e[0]].localeCompare(o[t[0]]))),s=Object.keys(i);let l=t?s.map(e=>t[e]):[];if(s.length>0&&(l.length!==s.length||l.some(c.isNullOrEmpty))){const e=await Y.run(e=>Q.run(e,async()=>Ce(e,s)));if(null===e)return void(0,r.reportException)(new Error("validateValues returned null due to a cancelled request"));var d;if(l=s.map(t=>e[t]),l.some(c.isNullOrEmpty))(0,r.reportException)(new r.SkywardException("Distinct multi select values are missing hashes.",JSON.stringify({controlName:null!==(d=J.hiddenBackingData.data("original-name"))&&void 0!==d?d:J.hiddenBackingData.attr("name"),dataModule:J.dataModule,dataObject:J.dataObject,distinctField:J.distinctfield,hashesProvided:null!==t,valueKeys:s,returnedKeys:Object.keys(e),keysWithoutHash:s.filter((e,t)=>(0,c.isNullOrEmpty)(l[t]))})))}const u=J.hiddenBackingData,f=JSON.stringify(i);u.val(f),u.data("selectedValueHash",l.join(",")),a?u.trigger("forceRebuild",{suppressChangeEvent:a,suppressRebuildHashes:!0}):u.trigger("change",{suppressChangeEvent:a,suppressRebuildHashes:!0}),n&&J.hiddenBackingData.on("change",ke)}async function Ce(t,n){const o=await(0,d.waitForDependencies)(J,(0,u.getScopeContainer)(e),t),r=fe("temp",$(),o),s=(0,a.getRequiredBrowseData)(r,{tempTableName:J.tempTableName});s.selectedValues=JSON.stringify(n);const l=await $.ajax({url:"".concat(i.virtualDir).concat(J.routeModule,"/").concat(J.routeObject,"/ValidateDistinctMultiSelectEEL"),type:"POST",dataType:"JSON",data:s,activityIndicator:{hideGlass:!0},signal:t});if(!l)return null;const c={};for(const e of l)c[e.id]=e.hash;return c}async function ke(e,t){const{suppressChangeEvent:n=!1,suppressRebuildHashes:a=!1}=null!=t?t:{},o=J.hiddenBackingData.data().selectedValueHash;return Y.run(e=>Q.run(e,async()=>{J.selectedItemKeys=[],J.selectedItemHashes=[],J.selectedKeyValuePairs={},J.selectedKeyValueHashes={},$("#".concat(w)).data("selectedItemKeys",J.selectedItemKeys);v.find("li:not(.".concat(S,")")).has(".".concat(P)).remove();let t=[];const r=Object.entries(JSON.parse(J.hiddenBackingData.val()));var s;if($.isEmptyObject(r)||a)t=(null!==(s=o)&&void 0!==s?s:"").split(",");else if((0,i.deepEquals)(r,Object.entries(J.hiddenBackingData.data("originalValue"))))t=J.hiddenBackingData.data("originalSelectedValueHash").split(",");else{const n=r.map(e=>e[0]),a=await Ce(e,n);if(null===a)return;t=n.map(e=>a[e])}for(let e=0;e<r.length;e+=1){const[a,o]=r[e];se(a,t[e],o,n),re(a,!0)}J.hiddenBackingData.data("selectedValueHash",t.join(",")),Se()}))}function Se(){var t;h.onscreen&&"function"==typeof(null===(t=h.options)||void 0===t?void 0:t.resizeCallback)&&h.options.resizeCallback(),J.button&&J.button.data("selectedRecordCount",J.selectedItemKeys.length).trigger("selectedRecordCountChanged"),e.hasClass("ui-disabled")||(be(),ye())}}function oe(e,t,n){let a,o;return e.hasClass(W)?(a=t,o=n):(a=Object.keys(t),o=Object.keys(n)),a.length===o.length&&0===$(a).not(o).length&&0===$(o).not(a).length}function re(e){const t=e.val();return!t||"{}"===t}function ie(e){const t=$(e).closest("div.".concat(U)).data("scopedMassSelect");if("function"==typeof t)return t(e)}function se(e){var t,n;const a=e.browse,o=ee.get(null==a?void 0:a[0]),r={browseType:"DistinctMultiSelect",refreshTimeout:-1,selectedItemKeys:(0,c.encodeHtml)(JSON.stringify(null!==(t=null==o?void 0:o.selectedItemKeys)&&void 0!==t?t:[])),filter:(0,c.encodeHtml)(e.filter),sortfieldinfo:e.sortfieldinfo,distinctMultiSelectEELSearchText:(0,c.encodeHtml)(null!==(n=null==o?void 0:o.textbox.val())&&void 0!==n?n:"")};if(e.rowsPerPage&&(r.rowsPerPage=e.rowsPerPage),e.hiddenBackingDataId&&e.hiddenBackingDataId.length>0){const t=function(e){const t=$("#"+e),n=[];if(t.hasClass(K)){const e=t.data().dependentPromptUniqueIds;let a=".".concat(q,", .").concat(G);t.parents().hasClass(z)&&(a=".".concat(z));const o=t.closest(a);for(let t=0;t<e.length;t++){const a=e[t],r=o.find(".".concat(J,"[data-prompt-unique-id='").concat(a,"']")),i=r.hasClass(v),s=r.hasClass(Y);let l=null;l=i?(0,u.getValue)(r.find(".".concat(k))):s?(0,u.getValue)(r.find(".".concat(Q))):(0,u.getValue)(r);let c=r.data(),d=r.closest(".".concat(X)).is(":hidden");n.push({UniqueID:a,BoundValue:d?null:l,Type:c.promptType,PresenceType:c.presenceType,DataType:c.fieldType,IsHidden:d})}}return n}(e.hiddenBackingDataId);r.promptDataCollection=JSON.stringify(t)}return r}function le(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];const a=ae(e),o="string"==typeof t?JSON.parse(t):t;return a.setBackingData(o,null,!1,n)}(0,h.registerEvents)("distinctMultiSelectEEL",ne)},25560(e,t,n){"use strict";n.r(t),n.d(t,{clear:()=>m,copyValue:()=>h,get:()=>u,getOriginal:()=>p,getSearchParameters:()=>w,set:()=>f});var a=n(66952),o=n(62894);function r(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function i(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?r(Object(n),!0).forEach(function(t){s(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):r(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function s(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const l="distinctMultiSelectEEL",c="eventsBound--DMSE",d="returnValueListAsKeys";function u(e){const t=[],n={};return g(e,function(e,o){const r=(0,a.encodeHtml)(e),i=(0,a.encodeHtml)(o);t.push(r),n[r]=i}),e.hasClass(d)?t:n}function f(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return(0,o.set)(e,t,n)}function h(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];const a=(0,o.registerDistinctMultiSelectEEL)(e);(0,o.registerDistinctMultiSelectEEL)(t).setBackingData(i({},a.distinctMultiSelectEELData.selectedKeyValuePairs),i({},a.distinctMultiSelectEELData.selectedKeyValueHashes),!1,n)}function p(e){const t=e.data("original-value"),n=[],o={};for(const e of Object.keys(t).sort()){const r=(0,a.encodeHtml)(e);n.push(r),o[r]=(0,a.encodeHtml)(t[e])}return e.hasClass(d)?n:o}function m(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=e;const a=e.closest(".".concat(l));a.length>0&&(n=a),n.hasClass(c)?n.trigger("clearAll",t):n.data("clear",t)}function g(e,t){const n=e.val(),a=JSON.parse(n||"{}");for(const e in a)t(e,a[e])}function w(e){const t=[];return g(e,function(e,n){t.push(e)}),t}},50196(e,t,n){"use strict";n.r(t);var a=n(62521),o=n(3543),r=n(2894),i=n(49343),s=n(92214);const l="sortable",c="show",d="hide",u=$("#dockBar"),f=$("#dockBarInnerContainer");let h=u.hasClass(c);const p={init:function(){const e=$(this),t={cursor:"move",scroll:!0,containment:"parent",items:"> .".concat(l),tolerance:"pointer",distance:5,start:function(e,t){t.item[0].oldclick=t.item[0].onclick,t.item[0].onclick=null},stop:function(e,t){setTimeout(function(){t.item[0].onclick=t.item[0].oldclick},500)},update:function(){w()}};f.sortable(t),f.disableSelection(),e.debounce("click",_)},click:function(){const e=$(this);h?b.apply(e):y.apply(e);e.attr("aria-expanded",h),$(window).trigger("resize")},add:function(){return $(this).hide(),m().done(function(e){f.append(e),v()})},edit:function(){return w(),g()}};function m(){return $.ajax({url:"".concat(r.virtualDir,"SkySys/UserDock/AddToDock"),type:"POST",dataType:"viewparthtml",data:{DisplayOrder:f[0].children.length-1,ScreenFriendlyName:$("#friendlyNameContents").text()}}).promise()}function g(){return(0,i.loadContent)("full","SkySys","UserDock","List",null,null)}function w(){const e={};let t=1;return f.children(".".concat(l)).each(function(){const n=$(this).data();n&&(e[n.primarykeyid]=t,t++)}),$.ajax({url:"".concat(r.virtualDir,"SkySys/UserDock/UpdateDock"),type:"POST",dataType:"JSON",data:{DockItems:JSON.stringify(e)},success:v}).promise()}function v(){const e=(0,o.getCurrentBrowseName)(),t=(0,o.getBrowseById)(e);t&&"SkySys"===t.routeModule&&"UserDock"===t.routeObject&&(0,a.get)("browse")}function b(){u.removeClass(c).addClass(d),this.removeClass(c).addClass(d),h=!1}function y(){u.removeClass(d).addClass(c),this.removeClass(d).addClass(c),h=!0}function _(){return $.ajax("".concat(r.virtualDir,"SkySys/UserDock/UpdateDockDisplay"),{type:"POST",dataType:"JSON",activityIndicator:{hideGlass:!0},data:{showDockToolbar:h}}).promise()}(0,s.registerEvents)("dock",p)},83289(e,t,n){"use strict";n.r(t),n.d(t,{calculateTotalPercentage:()=>p,disableRow:()=>b,enableRow:()=>y,getData:()=>m,getEditableData:()=>g,isCurrentlySelectingAll:()=>w,selectAllCheckBox:()=>v});var a=n(62521),o=n(3543),r=n(2894),i=n(49343),s=n(50573),l=n(917),c=n(92214),d=n(53346);const u=window.skyward;let f=!1;const h={init:function(e){var t,n;const a=$(e),r=a.data();a.find(".unlockedBrowseBody").scrollTop(0),null!==(t=r.editablebrowsedata)&&void 0!==t||(r.editablebrowsedata=[]);const c=null!==(n=r.originalcustomsavedata)&&void 0!==n?n:[];if(c.length){const e={};a.find("[name]").each(function(){e[this.name]=$(this)}),$.each(c,function(){let t=e[this.Key];t?((0,l.setValue)(t,this.Value,!0),t.attr("data-original-value",(0,l.getValue)(t))):t={saveJson:!0,name:this.Key,value:this.Value,data:{}},u.dataobjectviewer.updateCustomSaveData(t,r.editablebrowsedata,!0)}),a.data("originalCustomSaveData",""),r.originalcustomsavedata=[]}a.find("input, select, textarea, .dateTimePickerWrapper").not(".browseSearchBox, .browseRowsPerPage, .doNotPost, .doNotPost *").each(function(){const e=$(this);if(e.on("change",function(){u.dataobjectviewer.updateCustomSaveData(e,r.editablebrowsedata,!0),(0,s.save)((0,o.getBrowseById)((0,o.getCurrentBrowseName)()))}),e.data("selectpercent")&&e.on("change",function(){e.is(":checkbox")&&!e.is(":checked")&&(0,l.setValue)(a.find("#".concat(e.attr("data-selectPercent"))),"")}),e.data("includefieldforsectionheaderpercenttotal")){const t=function(){p(a,a.find(".sectionHeader__text"),"includefieldforsectionheaderpercenttotal","true")};e.on("change",t),$(function(){t()})}if(e.data("includefieldforsegmentedrowheaderpercenttotal")){const t=e.data("includefieldforsegmentedrowheaderpercenttotal"),n=function(){p(a,a.find("div .parentDataCell.segmentedRowHeaderTotalPercent.".concat(t)),"includefieldforsegmentedrowheaderpercenttotal",t)};e.on("change",n),$(function(){n()})}}),_(a),(0,i.registerLoadDOMCallback)(e=>{a.is(e)&&_(a)})},autosizeHeadersAndFooters:C};function p(e,t,n,a){if(null!=t&&t.get(0)){const o=t.html()||"Total",r=o.lastIndexOf("-");let i=o;r>-1&&(i=o.substring(0,r-1));let s=0;e.find("input[data-".concat(n,"='").concat(a,"']")).each(function(){const e=parseFloat($(this).val());e&&!isNaN(e)&&(s+=e)});const l=new Number(s).toFixed(2);t.html("".concat(i," - ").concat(l,"%"))}}function m(e){return{editableData:g(e.id),renderFilter:$("#".concat(e.id,"_filterButton")).length>0,renderView:$("#".concat(e.id,"_viewButton")).length>0,disableDataLossWarning:e.disableDataLossWarning,renderFooter:e.renderFooter,readOnly:e.readOnly,currentTaskInstanceId:e.currentTaskInstanceId,readOnlyHash:e.readOnlyHash,renderSortableHeader:e.renderSortableHeader,renderHeaderSettings:e.renderHeaderSettings,renderControls:e.renderControls,dataObjectViewerID:e.dataObjectViewerID}}function g(e){return JSON.stringify($("#".concat(e)).data("editablebrowsedata"))}function w(){return f}function v(e,t,n){f=!0;const i=$("#".concat(e)),s=i.find("#".concat(t));if(s.get(0)){if(s.hasClass("ui-disabled"))return;const t=s.is(":checked");i.find('td[data-column="'.concat(n,'"]')).each(function(){const e=$(this).find("input:checkbox");null!=e&&e.get(0)&&(0,l.changeCheckBoxWithSelectAll)(e,t)}).promise().done(function(){if(f=!1,s.data("checkboxidformat")&&""!==s.data("checkboxidformat")){const n=(0,o.getBrowseById)(e);if(!n)return null;const c=(0,a.getRequiredBrowseData)(n,n.data||i.data()),f="".concat(r.virtualDir).concat(n.routeModule,"/").concat(n.routeObject,"/SelectAll");(0,l.disable)(s);const h=$.Deferred();return(0,d.addDisableNavigationPromise)(h,!1),$.ajax({url:f,type:"POST",dataType:"JSON",complete:function(){(0,l.enable)(s),h.resolve()},success:function(e){const n=i.data().editablebrowsedata||[];$.each(e,function(){const e=s.data("checkboxidformat").replace("{0}",this.toString());let a=i.find("[name='".concat(e,"']"));0===a.length&&(a={saveJson:!0,name:e,value:t,data:{}}),u.dataobjectviewer.updateCustomSaveData(a,n,!0)})},data:c})}return null})}else f=!1}function b(e){e.find("input").each(function(){const e=$(this);(0,l.setValue)(e,e.data().originalValue),(0,l.disable)(e)}),e.find(".browseDataCell").addClass("disabled")}function y(e){e.find("input").each(function(){(0,l.enable)($(this))}),e.find(".browseDataCell").removeClass("disabled")}function _(e){e.is(":visible")&&(e.attr("aria-labelledby",e.find(".sectionHeader__text").attr("id")),C(e))}function C(e){var t;const n=(0,o.getContainingBrowse)(e);if(!n)return;const r=null===(t=n.header)||void 0===t?void 0:t.find(".js-browseHeader__cellContentContainer--autosize");if(r&&r.length>0){if(r.removeClass(".js-browseHeader__cellContentContainer--autosize"),n.browse&&n.browse.find(".noRecordsInBrowse").length>0)return;const e=[],t=[];r.each(function(){var o;const r=$(this).data("column"),i=n.footer.find("div[data-column='".concat(CSS.escape(r),"']")),s=$(this).data(),l=s.preferredWidth,c=s.fitColumn,d=null===(o=n.body)||void 0===o?void 0:o.find(".browseRow .browseDataCell.column".concat(r," > div")),u=null==d?void 0:d[0];if(!u)return;const f=parseInt(getComputedStyle(u).width,10),h="number"==typeof l?l:parseInt(getComputedStyle(this).width,10),p=Math.max(h,f),m=c?null:Math.max(f,a.minColumnWidth);e.push({width:p,minWidth:m,header:$(this),footer:i}),t[r]={width:p,fitColumn:c,cells:d}}),e.forEach(function(e){const t=e.header,n=e.footer;t[0].style.width="".concat(e.width,"px"),n.length>0&&(n[0].style.width="".concat(e.width,"px")),e.minWidth&&t.is(".tdResizeDiv.ui-resizable")&&t.resizable("option","minWidth",e.minWidth)}),t.forEach(function(e){e.cells.css("width",e.width),e.fitColumn&&e.cells.children().css("width","100%")})}}(0,c.registerEvents)("editableBrowse",h)},51325(e,t,n){"use strict";n.r(t),n.d(t,{createEel:()=>f,setFocusToTextBoxOnClick:()=>d});var a=n(2894),o=n(88157),r=n(49343),i=n(41709);function s(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const l="js-showEELContainer",c={input:null,button:null,customKeyDownHandler:function(){}};function d(e){e.find(".eELInputContainer").on("click",function(){const e=$(this).find(".eELInputContainer__textBox");e.length>0&&e[0].focus()})}function u(e,t){t?(0,i.focusBefore)(e):(0,i.focusAfter)(e)}function f(e){const t={userInputs:[],getSelectionListContainer:function(){return $()},getSelectionList:function(e){return $.Deferred()},selectionListPositioningOptions:{},setCurrentEnteredValue:function(){},setCurrentHighlightedValue:function(){},clearValues:function(){},alwaysExpose:[],beforeClose:function(){},beforeOpen:function(){},onSelectionListLoad:function(){}},n=$.extend({},t,e);let o,r,i=!1,s=!0;const d=()=>o,f=()=>r,m=new h(d,e=>{o=e},f,e=>{r=e},n,function(){s||n.clearValues();g.hide(),m.hide(!0),i=!1,s=!0,n.beforeClose()}),g=new p(m,d,f,n,()=>s),w={selectCurrentHighlightedValue:function(){s=!0,n.setCurrentHighlightedValue(),m.hide()},showSelectionList:function(e){s=!1,g.show(e,e.closest(".".concat(l)),!1)},hideSelectionList:function(){g.hide(),m.hide(!1)}};return $.each(n.userInputs,function(e,t){const r=$.extend({},c,t),d=r.input,f=r.button;let h=d.val().toLowerCase();d.on("input",function(){v($(this),h)&&(i=!0,s=!1,g.hide())}),d.debounce("input",function(){const e=$(this);v(e,h)&&(g.show(e,e.closest(".".concat(l))),h=e.val().toLowerCase())}),d.on("keydown",function(e){const t=$(this);if(v(t,null))return m.isShowing()||i||39!==e.which&&40!==e.which&&13!==e.which?g.isShowing()||!i||9!==e.which&&13!==e.which?!g.isShowing()||9!==e.which&&13!==e.which?r.customKeyDownHandler.apply(this,arguments):(w.selectCurrentHighlightedValue(),9===e.which&&u(t,e.shiftKey),!1):(function(e){s=!0,n.setCurrentEnteredValue(e),m.hide()}(t),9===e.which&&u(t,e.shiftKey),!1):(s=!1,g.show(t,t.closest(".".concat(l)),!0),!1)}),f.on("click",function(){if(null!=o&&o.onscreen){if(!a.mobileAccess)return void o.close()}else{const e=$(this),t=$(r.input);if(e.hasClass("ui-disabled")||!v(t))return;s=!1,g.show(t,t.closest(".".concat(l)),!0)}})}),w;function v(e,t){return!e.is("[disabled],[readonly],.ui-disabled")}}class h{constructor(e,t,n,a,o,r){s(this,"glassIsShowing",!1),s(this,"getModalLayer",void 0),s(this,"setModalLayer",void 0),s(this,"getEelValueListContainer",void 0),s(this,"setEelValueListContainer",void 0),s(this,"settings",void 0),s(this,"beforeClose",void 0),this.getModalLayer=e,this.setModalLayer=t,this.getEelValueListContainer=n,this.setEelValueListContainer=a,this.settings=o,this.beforeClose=r}isShowing(){return this.glassIsShowing}hide(e){this.glassIsShowing&&!e&&this.getModalLayer().close(),this.glassIsShowing=!1}show(e){this.glassIsShowing||(this.setEelValueListContainer(this.settings.getSelectionListContainer()),this.setModalLayer((0,o.newModalLayer)(this.getEelValueListContainer(),this.beforeClose,{expose:this.settings.alwaysExpose.concat([e]),role:"listbox"}))),this.glassIsShowing=!0}}class p{constructor(e,t,n,a,o){s(this,"eelValueListIsShowing",!1),s(this,"eelGlass",void 0),s(this,"getModalLayer",void 0),s(this,"getEelValueListContainer",void 0),s(this,"settings",void 0),s(this,"userSelectedValue",void 0),this.eelGlass=e,this.getModalLayer=t,this.getEelValueListContainer=n,this.settings=a,this.userSelectedValue=o}isShowing(){return this.eelValueListIsShowing}hide(){this.eelGlass.isShowing()&&(this.getEelValueListContainer().hide(),this.getEelValueListContainer().html(""),this.eelValueListIsShowing=!1)}show(e,t,n){this.userSelectedValue()||(this.settings.beforeOpen(),this.eelGlass.show(t),$.when(this.settings.getSelectionList(n)).done(n=>{if(!this.eelGlass.isShowing()||this.userSelectedValue())return;e.length>0&&e[0].focus(),this.getEelValueListContainer().html(n),this.getEelValueListContainer().show(),this.eelValueListIsShowing=!0;const a=(0,o.createModalPositioningManager)(this.getModalLayer(),t,this.getModalLayer().contents,this.settings.selectionListPositioningOptions);this.getModalLayer().options.resizeCallback=a.positionEELContents,this.getModalLayer().options.resizeCallback&&"function"==typeof this.getModalLayer().options.resizeCallback&&((0,r.registerLayoutResizeCallback)(this.getModalLayer().options.resizeCallback),this.getModalLayer().options.resizeCallback()),this.settings.onSelectionListLoad()}).fail(()=>{this.eelGlass.hide()}))}}},65259(e,t,n){"use strict";n.r(t),n.d(t,{registerElectronicSignatureAgreeCheckboxEvent:()=>v,selectErrorListForElectronicSignatureMessageValidation:()=>w});var a=n(2894),o=n(917),r=n(92214);const i=".electronicSignatureAgreeCheckbox",s=".electronicsignature",l=".electronicSignatureSignedBy",c=".electronicSignatureDateSigned",d=".electronicSignatureToggledByCurrentUser",u="SkySys/ConfigSystem/GetSystemDateTime",f="POST",h="error-control",p="checked",m="change",g={registerElectronicSignatureAgreeCheckboxEvent:v,selectErrorListForElectronicSignatureMessageValidation:w};function w(e){$(e).each(function(){$(this).remove()})}function v(e){$(e).on(m,function(){!function(e){const t=e.find(i),n=e.find(l),r=e.find(c),s=e.find(d);(0,o.setValue)(s,!0);t.prop(p)?((0,o.disable)(t),$.ajax({url:a.virtualDir+u,type:f,success:function(t){(0,o.setValue)(n,e.data().userName),(0,o.setValue)(r,t.systime)},complete:function(){(0,o.enable)(t),t.trigger("focus")}})):((0,o.clearValue)(n),(0,o.clearValue)(r),r.removeClass(h).removeAttr("aria-invalid"))}($(this).closest(s))})}(0,r.registerEvents)("electronicSignature",g)},92214(e,t,n){"use strict";n.r(t),n.d(t,{applyLoadActionClass:()=>l,clickEvent:()=>u,getActionFunction:()=>f,getCallbackStore:()=>r.getCallbackStore,getCallbackStoreFacadeCollection:()=>r.getCallbackStoreFacadeCollection,processLoadActions:()=>w,processVisibleActions:()=>h,reapplyLoadActionClasses:()=>c,registerEvents:()=>p,removeLoadActionClass:()=>d});var a=n(40096),o=n(65747),r=n(29711);const i={},s={loadActionMarkerClass:"js-load-action",visibleActionMarkerClass:"js-visible-action"};let l=function(e){const t="[data-load-action]";$(e).find(t).addBack(t).addClass(s.loadActionMarkerClass)};function c(e){const t=e.data();null!=t&&t.loadAction&&e.addClass(s.loadActionMarkerClass),null!=t&&t.visibleAction&&e.addClass(s.visibleActionMarkerClass)}let d=function(e){$(e).find(s.loadActionMarkerClass.dot()).addBack(s.loadActionMarkerClass.dot()).removeClass(s.loadActionMarkerClass)},u=(0,a.manageButtonClick)(function(){const e=$(this).addIds();for(var t=arguments.length,n=new Array(t),a=0;a<t;a++)n[a]=arguments[a];return m(this,e.data("clickAction"),n)}),f=e=>{var t;const[n,a]=e.split("."),o=null==i||null===(t=i[n])||void 0===t?void 0:t[a];if(void 0!==o)return"function"==typeof o?o:o.function},h=function(e){g(e,s.visibleActionMarkerClass,"visibleAction")};function p(e,t){i[e]=$.extend(i[e]||{},t)}function m(e,t,n){const a=$.Deferred(),r=t.split(";");for(let t=0;t<r.length;t++){var s;const[a,l]=r[t].split(".");if(!l)continue;const c=null==i||null===(s=i[a])||void 0===s?void 0:s[l];if(void 0!==c){const t=("function"==typeof c?c:c.function).apply(e,n);if((0,o.isDeferred)(t))return t}else console.warn("No action ".concat(r[t]))}return a.resolve(),a.promise()}function g(e,t,n){e.find(t.dot()).addBack(t.dot()).each(function(){const e=$(this).addIds();e.removeClass(t),m(e,e.data(n),[e])})}$(document.body).on("click","[data-click-action]",u).on("click","a.button:not(.js-button--link), a[href^='javascript:']",function(e){e.preventDefault()});let w=function(e){g(this,s.loadActionMarkerClass,"loadAction")}},28468(e,t,n){"use strict";var a=n(2894),o=n(88157),r=n(49343),i=n(92214),s=n(80060),l=n(74061),c=n(75552),d=n(98925);function u(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function f(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?u(Object(n),!0).forEach(function(t){h(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):u(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function h(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const p=(0,l.defineComponent)({name:"ExternalLinkCard",props:{container:(0,c.oY)(Object),applicationid:(0,c.uh)(Number),externallinkid:(0,c.uh)(Number),name:(0,c.oY)(String),description:(0,c.oY)(String),action:(0,c.oY)(String),iconurl:(0,c.oY)(String),url:(0,c.oY)(String),iconcode:(0,c.oY)(String),ispinned:(0,c.oY)(Boolean),isMobile:(0,c.uh)(Boolean),loadAction:(0,c.uh)(String),showpin:{type:Boolean,required:!1,default:!0}},render(){return[(0,l.createVNode)(l.Fragment,null,[this.getCardBody()]),this.applicationid&&(0,l.createVNode)("a",{class:"externalLinkCardCornerIcon externalLinkCardKeyIcon",href:"javascript:void(0)",tabindex:"-1"},[(0,l.createVNode)(d.A,{name:"Key",svgClasses:["buttonSvg","externalLinkCardCornerIcon","svgNoHover"],tabindex:"-1"},null)]),this.showpin&&(0,l.createVNode)("a",{class:"externalLinkCardCornerIcon externalLinkCardPinIcon",role:"button","aria-label":"Pin ".concat(this.name," tile"),"aria-pressed":this.pinnedStatus,onClick:e=>this.togglePinButtonClick(e),href:"javascript:void(0)"},[(0,l.createVNode)(d.A,{name:this.pinnedStatus?"PinFilled":"Pin",svgClasses:["buttonSvg","externalLinkCardCornerIcon","svgNoHover"],tabindex:"-1"},null,8,["name"])],8,["aria-label","aria-pressed","onClick"])].filter(Boolean)},data(){return{pinnedStatus:this.ispinned}},mounted(){const e=this.container.find(".externalLinkCardContent"),t=$(this.$refs.nameSpan);e.attr("aria-labelledby",t.addIds().attr("id"));const n=$(this.$refs.descriptionSpan);e.attr("aria-describedby",n.addIds().attr("id"));const a=this;e.on("keydown",function(e){"Enter"!==e.key&&13!==e.keyCode||e.target!==this||(e.preventDefault(),a.openLink())})},computed:{smallTileBodyClasses(){let e="widgetTileBody";return this.iconcode&&(e+=" widgetTileBorderHolder"),e}},methods:{getCardBody(){return this.description?this.getDescriptionCard():this.getIconCard()},getDescriptionCard(){const e=this.applicationid?(0,l.createVNode)("div",{class:"widgetWideTileBody","aria-label":"App with automatic sign-in"},[(0,l.createTextVNode)(" "),this.getIcon(),(0,l.createTextVNode)(" ")]):(0,l.createVNode)("div",{class:"widgetWideTileBody"},[(0,l.createTextVNode)(" "),this.getIcon(),(0,l.createTextVNode)(" ")]);return(0,l.createVNode)("a",{class:"externalLinkCardContent externalLinkDescriptionCard",role:"link",onClick:()=>this.openLink(),tabindex:"0"},[(0,l.createVNode)("div",{class:"widgetWideContent"},[(0,l.createVNode)("div",{class:"widgetWideContentInner"},[e,(0,l.createVNode)("div",{class:"widgetWideTileFooter"},[(0,l.createVNode)("div",{class:"widgetTileFooterLabel"},[(0,l.createVNode)("span",{ref:"nameSpan",class:"widgetTileFooterText"},[this.name],512)]),(0,l.createVNode)("span",{ref:"descriptionSpan",class:"externalLinkCardDescription"},[this.description],512)])])])],8,["onClick"])},getIconCard(){const e=this.applicationid?(0,l.createVNode)("div",{class:this.smallTileBodyClasses,"aria-label":"App with automatic sign-in"},[this.getIcon()],2):(0,l.createVNode)("div",{class:this.smallTileBodyClasses},[this.getIcon()],2);return(0,l.createVNode)("a",{class:"externalLinkCardContent externalLinkIconCard",role:"link",onClick:()=>this.openLink(),tabindex:"0"},[e,(0,l.createVNode)("div",{class:"widgetTileFooter"},[(0,l.createVNode)("div",{class:"widgetTileFooterLabel"},[(0,l.createVNode)("span",{ref:"nameSpan",class:"widgetTileFooterText"},[this.name],512)])])],8,["onClick"])},getIcon(){return this.iconcode?(0,l.createVNode)(d.A,{name:this.iconcode,class:"svgWidget svgNoHover",preserveAspectRatio:"xMidYMin meet"},null,8,["name"]):(0,l.createVNode)("img",{src:this.iconurl,class:"svgWidget widgetIcon svgNoHover"},null,8,["src"])},async togglePinButtonClick(e){e.stopImmediatePropagation(),await this.togglePin()},async togglePin(){let e={};e.pin=!this.pinnedStatus,this.pinnedStatus=!this.pinnedStatus,this.applicationid?e.applicationID=this.applicationid:e.externalLinkID=this.externallinkid;const t=await $.ajax({url:"".concat(window.skyward.global.virtualDir,"Security/PinnedApplication/PinExternalLink"),data:e,type:"POST",dataType:"JSON"});var n;t.success&&(this.pinnedStatus=null!==(n=t.isPinned)&&void 0!==n&&n)},openLink(){let e=this.url;e.startsWith("http")||e.startsWith("/")||(e="//".concat(e)),window.open(e)}}}),m={buildVue:e=>(0,c.VZ)(p,f(f({},e.containerData),{},{container:$(e.container),isMobile:e.isMobile})).mount(e.container)},g=window.skyward,w="externalLinksModal__container",v="externalLinksModal__right",b="tabListContainer",y="tabListItem",_="current";async function C(e){const t=$(e),n=t.closest(".".concat(b)).closest(".".concat(w)),o=t.data("tab");if(0===t.length||void 0===o)return;const i=t.closest(".".concat(b)).find(".".concat(_)),s=t.data("collection-id"),l=t.data("entity-id"),c=$(await async function(e,t){return $.ajax({url:"".concat(a.virtualDir,"SkySys/ExternalLink/GetExternalLinksCollection?collectionID=").concat(e),type:"POST",dataType:"viewparthtml",data:{entityID:t}})}(s,l)),d=n.find(".".concat(v));d.empty(),d.append(c),(0,r.notifyDOMLoad)(d),n.trigger("resize"),i.removeClass(_).attr("aria-selected","false"),t.addClass(_).attr("aria-selected","true")}(0,i.registerEvents)("externalLinks",{openModal:async function(){const e=$(this).data("entity-id"),t=await $.ajax({url:"".concat(a.virtualDir,"SkySys/ExternalLink/GetExternalLinks/"),type:"POST",dataType:"viewparthtml",data:{EntityID:e}});(0,o.showDialog)("Apps & External Links",$(t),void 0,{height:"95%",width:"90%",additionalContainerClasses:"externalLinksModal__modalLayer",closeOnClick:!0,allowNoButtons:!0,useMobileAccessStyles:!0})},init:async function(){(0,s.registerTabFunction)("externalLinks.setCurrentTab",C);const e=$(this);C(e.find(".".concat(y,".").concat(_)))},initCard:async function(){const e=$(this),t=$.extend({},e.data()),n={container:e[0],isMobile:g.global.mobileAccess,containerData:t};m.buildVue(n)},setCurrentTab:C,buildLegendPopup:async function(){const e=$(this),t=await $.ajax({url:"".concat(a.virtualDir,"SkySys/ExternalLink/Legend"),type:"POST",dataType:"viewparthtml",activityIndicator:{hideGlass:!0}});(0,o.showDialog)("Legend",t,[o.DEFAULT_CLOSE_BUTTON],{anchorTo:e,titleTag:"h1"})}})},22441(e,t,n){"use strict";n.r(t);var a=n(79126),o=n(2894),r=n(88157),i=n(49343),s=n(917),l=n(92214),c=n(48594),d=n(44992);const u={initDateRangeModeFoodService:function(){$(this).off("change.dateRangeModeFoodService").on("change.dateRangeModeFoodService",v)},initAssignmentSortMode:function(){$(this).off("change.assignmentSortMode").on("change.assignmentSortMode",y)},initDateRangeModeAssignment:function(){$(this).off("change.dateRangeModeAssignment").on("change.dateRangeModeAssignment",w)},initDateRangeMode:function(){$(this).off("change.dateRangeMode").on("change.dateRangeMode",f)},initSchoolYearRangeMode:function(){$(this).off("change.schoolYearRangeMode").on("change.schoolYearRangeMode",h)},initMissingAssignmentMode:function(){$(this).off("change.missingAssignmentMode").on("change.missingAssignmentMode",b)},printScheduleList:function(){const e=$(this).parents("#StudentScheduleDisplayWrapper"),t=$("#accessmode").val(),n=$("input[name=DateRangeModechild]:checked").val();let a;const o=(0,s.getValue)(e.find("#StudentID")),r=(0,s.getValue)(e.find("#GuardianNameID")),l=(0,s.getValue)(e.find("#SelectedStudentMode"));a="FamilyAccess"===t?{SelectedStudentMode:l,GuardianNameID:r,DateRangeMode:n}:{DateRangeMode:n};(0,i.loadContent)("popout","Scheduling","StudentScheduleDisplay","PrintScheduleList"+t,o,a)},printAssignmentList:function(){const e=$(this).parents("#StudentAssignmentWrapper"),t=$("#accessmode").val(),n=$("input[name=DateRangeModeAssignment]:checked").val();let a;const r=(0,s.getValue)(e.find("#GuardianNameID")),i=(0,s.getValue)(e.find("#GuardianNameIDHash")),l=(0,s.getValue)(e.find("#SelectedStudentMode")),c=(0,s.getValue)(e.find("#StudentID"));a="FamilyAccess"===t?{SelectedStudentMode:l,GuardianNameID:r,GuardianNameIDHash:i,DateRangeMode:n,StudentID:c}:{DateRangeMode:n,StudentID:c};const u="".concat(o.virtualDir,"Gradebook/StudentAssignment/PrintAssignmentList").concat(t);(0,d.launchWorkflow)(u,a)},printAllAssignmentList:function(){const e=$(this).parents("#StudentAssignmentWrapper"),t=$("#accessmode").val();let n;const a=(0,s.getValue)(e.find("#GuardianNameID")),r=(0,s.getValue)(e.find("#GuardianNameIDHash")),i=(0,s.getValue)(e.find("#SelectedStudentMode")),l=(0,s.getValue)(e.find("#StudentID"));n="FamilyAccess"===t?{SelectedStudentMode:i,GuardianNameID:a,GuardianNameIDHash:r,StudentID:l}:{StudentID:l};const c="".concat(o.virtualDir,"Gradebook/StudentAssignment/PrintAllAssignmentList").concat(t);(0,d.launchWorkflow)(c,n)}};async function f(e){const t=$("#accessmode").val(),n=$(e.target).attr("name"),r={};r[n]=(0,c.getValue)($(this));try{await $.ajax({url:"".concat(o.virtualDir,"Grading/StudentSection/Set").concat(n).concat(t),type:"POST",dataType:"JSON",data:r}),location.reload()}catch(e){(0,a.reportException)(e)}}async function h(){const e=$("#accessmode").val(),t={SchoolYearRangeMode:(0,c.getValue)($(this))};try{await $.ajax({url:"".concat(o.virtualDir,"Grading/StudentSection/SetSchoolYearRangeMode").concat(e),type:"POST",dataType:"JSON",data:t}),location.reload()}catch(e){(0,a.reportException)(e)}}function p(){C("FoodService","Customer",$(this).text())}function m(){C("Grading","StudentSection",$(this).text())}function g(){C("Attendance","StudentAttendance",$(this).text())}async function w(){const e=$("#accessmode").val(),t={DateRangeMode:(0,c.getValue)($(this))};try{await $.ajax({url:"".concat(o.virtualDir,"Gradebook/StudentAssignment/SetDateRangeMode").concat(e),type:"POST",dataType:"JSON",data:t}),location.reload()}catch(e){(0,a.reportException)(e)}}async function v(){const e=$("#accessmode").val(),t={DateRangeMode:(0,c.getValue)($(this))};try{await $.ajax({url:"".concat(o.virtualDir,"FoodService/Customer/SetDateRangeMode").concat(e),type:"POST",dataType:"JSON",data:t}),location.reload()}catch(e){(0,a.reportException)(e)}}async function b(){const e=$(this);let t=e.parents(".missingAssignmentToolbar").data();(null==t||$.isEmptyObject(t))&&e.hasClass("missingAssignmentToolbar")&&(t=e.data());let n=t.portal;null==n&&(n=$("#accessmode").val());let r=(0,c.getValue)(e);null==r&&(r=(0,s.getValue)(e));const i={MissingAssignmentMode:r,StudentID:t.studentId};let l;if("TeacherAccess"===n||"TeacherTracker"===n||"Administrative"===n||"ActivitiesAccess"===n||"StudentServices"===n){const e="True"===t.isstudentinfopopup;l=e||"Administrative"!==n?e&&"TeacherAccess"===n?"Gradebook/ProgressReport/SetMissingAssignmentModeTeacherAccessStudentInfoPopup":e&&"TeacherTracker"===n?"Gradebook/ProgressReport/SetMissingAssignmentModeTeacherTrackerStudentInfoPopup":"Gradebook/ProgressReport/SetMissingAssignmentMode"+n:"Gradebook/ProgressReport/SetMissingAssignmentModeSelectedYear"}else l="Grading/StudentSection/SetMissingAssignmentMode"+n;try{if(await $.ajax({url:o.virtualDir+l,type:"POST",dataType:"JSON",data:i}),e.parents(".radioButtonGroup").first().hasClass("js-studentInfoPopup")||e.hasClass("js-studentInfoPopup")){const t=e.parents(".informationPopup").first().find(".tabListItem.current");null!=t&&t.length>0&&(t.removeClass("current"),t.trigger("click"))}else location.reload()}catch(e){(0,a.reportException)(e)}}async function y(){const e=$(this),t=$("#accessmode").val(),n={AssignmentSortMode:(0,c.getValue)(e)},r="Gradebook/StudentAssignment/SetAssignmentSortMode".concat(t);try{await $.ajax({url:o.virtualDir+r,type:"POST",dataType:"JSON",data:n}),location.reload()}catch(e){(0,a.reportException)(e)}}function _(e,t){let n=15;const a=$(e).find(t);a.each(function(){const e=$(this).height();e>n&&(n=e)}),a.height(n)}function C(e,t,n){const a=$("#accessmode").val(),r={UpdatedTabMode:n};$.ajax({url:"".concat(o.virtualDir).concat(e,"/").concat(t,"/Set").concat(e,"TabMode").concat(a),type:"POST",dataType:"JSON",data:r})}function k(){const e=$(this),t=$("#accessmode").val(),n=$(this).text()[0];let a=null;const r=e.parent().siblings(".tabbedContent__allTabbedContents").find(".browse");null!=r&&(a=r.attr("id").split("-")[1]);const i={AssignmentTabMode:n,StudentEntityYearID:a},s="Gradebook/StudentAssignment/SetAssignmentTabMode".concat(t);$.ajax({url:o.virtualDir+s,type:"POST",dataType:"JSON",data:i})}function S(){const e={SkylertTabMode:$(this).text()[0]};$.ajax({url:o.virtualDir+"Family/FamilyGuardian/SetSkylertTabModeFamilyAccess",type:"POST",dataType:"JSON",data:e})}function D(){const e=$(this),t=e.data("viewmode");let n=e.data("screentype");n&&void 0!==n||(n="");const a=[""],i=$("#gradinglegendbrowse").val();let s=".browse[id^='"+i+"-']";0===$(s).length&&(s=".hiddenReportCardData[id^='"+i+"-']"),$(s).each(function(){a[a.length]=$(this).attr("id").split("-")[1]});const l={};$(".historicSchoolYear").each(function(){const e=$(this).attr("data-schoolyearid"),t=$(this).attr("data-entityid");if(e in l){let n=!1;for(let a=0;a<l[e].length;a++)if(l[e][a]===t){n=!0;break}n||l[e].push(t)}else l[e]=[t]});const c=$.ajax({url:"".concat(o.virtualDir,"Grading/StudentSection/BuildGradingLegendPopup").concat(n).concat(t,"/"),type:"POST",dataType:"viewparthtml",data:{studentEntityYearIDsString:JSON.stringify(a),schoolYearAndEntityIDsString:JSON.stringify(l)}});e.off("click",D),(0,r.showDialog)("Grading Legend",c,[r.DEFAULT_CLOSE_BUTTON],{anchorTo:e,beforeClose:function(){e.off().on("click",D)},titleTag:"h1"})}function E(){const e=$(this),t=e.data("viewmode"),n=e.data("nameid"),a=e.data("entityid"),i=e.data("nameid_securityhash"),s=e.data("entityid_securityhash"),l=$.ajax({url:"".concat(o.virtualDir,"Family/StudentGuardian/BuildChangesPendingPopup").concat(t,"/"),type:"POST",dataType:"viewparthtml",data:{NameID:n,EntityID:a,nameid_securityhash:i,entityid_securityhash:s}});e.off("click",E),(0,r.showDialog)("Pending Changes",l,[r.DEFAULT_CLOSE_BUTTON],{anchorTo:e,beforeClose:function(){e.off("click",E).on("click",E)}})}(0,l.registerEvents)("familyAccess",u),(0,i.registerLoadDOMCallback)(function(e){$("#btnGradingLegend").off("click",D).on("click",D);const t=$(e);t.find(".FamilyAccessChangesPending").on("click",E),t.find("div.UserAccessProfileTile").length>0&&t.find("#repeaterDiv").children("div.repeater").children("div.template").find("div.FamilyAccessStudentProfileTileRow").each(function(){_(this,"div.FamilyAccessStudentProfileTileFamilyInformation"),_(this,"div.FamilyAccessStudentProfileTileEmergencyContact")});$("#StudentAssignments .js-tabbedContainerButton").off("click",k).on("click",k),$(".SkylertContactTabs .js-tabbedContainerButton").off("click",S).on("click",S),$("#CustomerTabbedContent .js-tabbedContainerButton").off("click",p).on("click",p),$("#StudentGradingTabs .js-tabbedContainerButton").off("click",m).on("click",m),$("#StudentAttendanceTabs .js-tabbedContainerButton").off("click",g).on("click",g),$(".familyStudentAccessDisciplineBrowses").each(function(){const e=$(this);$("body").on("browseLoaded."+e.attr("id"),function(e){const t=e.target;(0,i.notifyDOMLoad)("#incidentoffensenamedetailwrapper"),(0,i.notifyDOMLoad)($(t).attr("id"))})}),t.find("p.studentIDCardBarcode").length>0&&t.find("p.studentIDCardBarcode").each(function(){var e,t=null===(e=$(this).text())||void 0===e?void 0:e.length;null!=t&&0!=t&&$(this).css("font-size","clamp(1rem, 60px, calc((min(440px, 100vw - 20px) - 32px) / "+t+" * 2.344322344322344))")})}),(0,i.registerLoadDOMCallback)(function(e){const t=$(e),n=t.find(".familyConfigRetainCheckbox"),a=t.find(".familyConfigRetainTextbox");if(0===n.length||0===a.length)return;n.on("change",function(){n.is(":checked")?((0,s.enable)(a),a.each(function(){const e=$(this),t=(0,s.getOriginalValue)(e);(0,s.setValue)(e,t)})):((0,s.disable)(a),(0,s.clearValue)(a))}),n.trigger("change")})},39094(e,t,n){"use strict";n.r(t);var a=n(62521),o=n(2894),r=n(88157),i=n(49343),s=n(92214);const l="existsAsFavorite",c="favorite-id";function d(e,t,n,o){t?(e.addClass(l),e.data(c,n),e.attr("aria-label","Remove Favorite")):(e.removeClass(l),e.removeData(c),e.attr("aria-label","Add Favorite")),o.includes("SkySys/UserFavorite/List")&&(0,a.get)("browse")}(0,s.registerEvents)("favorites",{openMenu:function(){const e=$(this);return $.ajax({url:"".concat(o.virtualDir,"SkySys/UserFavorite/PopulateFavorites/"),type:"POST",dataType:"JSON"}).done(async function(t){const n=t.content.Content,a=await(0,o.processViewPartHtml)(t.footer.Content);(0,r.showInformationBubble)("Favorites",n,void 0,{anchorTo:e,useSmallWidth:!0}).container.append(a)})},addOrRemoveFavorite:function(){const e=$(this);if(e.hasClass(l)){const t=e.data(c);return function(e){return $.ajax({url:"".concat(o.virtualDir,"SkySys/UserFavorite/DeleteFavorite"),type:"POST",dataType:"JSON",data:{id:e}})}(t).done(function(){d(e,!1,t,window.location.href)})}return $.ajax({url:"".concat(o.virtualDir,"SkySys/UserFavorite/AddFavorite"),type:"POST",dataType:"JSON",data:{ScreenFriendlyName:$("#friendlyNameContents").text()}}).done(function(t){t.alreadyExists||d(e,!0,t.id,window.location.href)})},edit:function(){return(0,i.loadContent)("full","SkySys","UserFavorite","List",null)}})},30368(e,t,n){"use strict";n.r(t),n.d(t,{alignTitles:()=>p,getWidthsAndSetTwoLineMode:()=>m});var a=n(2894),o=n(49343),r=n(16140);const i=".workflow, .messageBox, .templateView, .menuContentArea, .js-fieldset, .dynamicNavigatorContent, .workflowTemplateEditingInner, .js-printContainer",s="label.title, .unstyledTitle, .js-title-margin",l=".fieldValidationMessage, label.help, .example, .addTitleMargin",c=".currentRecordContent, .workflowContent, .pseudoContentArea, .js-alignTitlesContainer",d=".js-ignoreAlignmentContainer,.gridContentArea",u=".noJsAlignment,.gridContentArea *:not(.title)",f="twoLines",h="inlineLabel";function p(e){const t=$(e);let n=t.closest(i).not(d);if(0===n.length&&(n=t.find(i).not(d),0===n.length))return;const o=n.find(s).not(u);a.mobileAccess?function(e){e.each(function(){const e=$(this),t=e.next();t.is(":checkbox")?e.addClass(h):(e.removeAttr("for"),t.is("table.inlineBlock")&&t.css("margin-left","1.5rem")),e.addClass(f),e.css("margin-left",0)})}(o):function(e){if(0===e.length)return;const t=m(e),a=Math.max.apply(void 0,Array.from(t.values()));t.forEach(function(e,t){const n=a-e;$(t).css("margin-left",n>0?n:"")}),n.find(l).not(u).css("margin-left","".concat(a,"px"))}(o);$(c).filter(function(){return"hidden"===$(this).css("visibility")}).css("visibility","inherit")}function m(e){const t=new Map;return e.each(function(){const e=$(this),n=function(e){const t=e.is(":visible")?e.outerWidth():function(e){const t=e.clone().css({position:"absolute",display:"block",visibility:"hidden"}).appendTo(document.body),n=t.outerWidth();return t.remove(),n}(e);return Math.round(t)}(e);if(!e.hasClass(f)&&n>=234){const n=e.height();e.addClass(f);n===e.height()&&e.removeClass(f),t.set(this,234)}else t.set(this,n)}),t}Promise.resolve().then(()=>{if(!n.m[742]){var e=new Error("Module '742' is not available (weak dependency)");throw e.code="MODULE_NOT_FOUND",e}return n(742)}).then(e=>{let{onTranslated:t}=e;t.registerCallback(()=>{const e=(0,r.default)(()=>{p(document.body),t.disconnect()},250),t=new MutationObserver(()=>{e()});$(i).each(function(){t.observe(this,{characterData:!0,subtree:!0,childList:!0})})})}).catch(()=>{}),(0,o.registerLoadDOMCallback)(p)},45230(e,t,n){"use strict";n.r(t);var a=n(3543),o=n(79126),r=n(2894),i=n(88157),s=n(49343),l=n(40346),c=n(917),d=n(83289),u=n(68337);!function(e,t){e.fileManagement=e.fileManagement||{};let n=0;const f=1024,h=1048576,p=[];e.fileManagement.fileIsUploading=function(){return p.some(e=>!e.ignoreRequest&&e.requestIsRunning&&4!=e.requestIsRunning.readyState)},e.fileManagement.export=function(e){var n=t(e.currentTarget),o=n.data("export-area"),r=n.data("export-controller"),i=n.data("export-action"),l=n.data("export-data")||{},c=n.data("media-verification-token"),u=n.data("media-id"),f={};for(var h in l)f[h]=l[h];const p=(0,a.getBrowseById)((0,a.getCurrentBrowseName)());p&&p.browseName&&(f[p.browseName]=(0,d.getEditableData)(p.browseName)),(0,s.loadContent)("popout",o,r,i,u,f,null,void 0,null,!1,null,null,c)},e.fileManagement.getFileData=function(e){var t=e.find(".fileID[data-dirty='true']").length>0,n=e.find(".fileUploadElement");if(n.length>0){var a=n.data().files;if(a&&!t)return{name:n.attr("name"),file:a[a.length-1]}}return null},(0,s.registerLoadDOMCallback)(function(e){n++,t(e+" input.fileUploadElement").each(function(){let e=t(this);const a=S(e.attr("id"));let{fileUploadInputPrefix:s,fileUploadInputScoping:d}=a,m=a.fileUploadCount;""==m&&(m=n);var g=e.siblings(".uploadButton"),w=Number(e.attr("data-size-limit")),v=t("#"+s+"fileList"+d);g.off("click").on("click",function(){var n=t(this),a=function(t){e=t.parent().find(".fileUploadElement"),e.val(""),e.trigger("click")};if(b>0&&!R()&&!e.hasClass("skipFileLimitError")){t.when(function(){var e=t.Deferred();const n=[{text:i.ButtonText.Ok,icon:i.ButtonIcon.Check,click:function(){a.close(),e.resolve()}},{text:i.ButtonText.Cancel,icon:i.ButtonIcon.Cancel,click:function(){a.close(),e.reject()}}],a=(0,i.showCriticalDialog)("Warning","Uploading a new document will overwrite the current document.",n);return e.promise()}()).done(function(){a(n)})}else a(n);return!1});var b=0,y=t("#"+s+"fNumber"+d);const _=y.get(0);_&&(_.id=s+"fileUpload"+m+"fNumber"+d);var C=e.data().files;void 0!==C&&0!==C.length&&(t.each(C,function(){A(this.FileName,N(this.FileSize),this.SessionFileUploadID,a,e,null,void 0,this.MediaID)}),y.length>0&&(0,c.setValue)(y,C.length));var k=function(n){const{fileUploadInputPrefix:o,fileUploadInputScoping:i}=S(t(e).attr("id")),s=n.files;let l;var c=t("#"+o+"massImportProgress"+i);c.length>0&&(t(".completedWrapper").hide(),c.parent().append(t("<div>",{class:"uploadLoadingGifWrapper"}).append(t("<img>",{class:"uploadLoadingGif",src:r.virtualDir+"content/loading.gif?v=2"})).append("Loading...")));var d=0;t.when(t(s).each(function(o){t.wait(1).then(function(){d++;var i=s[o].size;if(l=N(i),0==i){const e="This file is empty";return void L(s[o].name,l,e,a)}if(i>w){const e="This file exceeded the "+N(w)+" limit";return void L(s[o].name,l,e,a)}!function(n,a,o,i,s,l){const{fileUploadInputPrefix:c,fileUploadInputScoping:d,fileUploadCount:f}=i;if(o&&0!==n.type.indexOf("image/"))return;(function(e,t,n,a,o){b>0&&!R()&&I(n);A(e.name,t,void 0,n,a,e,o,void 0)})(n,a,i,s,l),t(D(c+"fileUpload"+f+"fNumber"+d)).val(b);var h=new FormData;h.append("file",n),h.append("fileCount",b.toString()),h.append("securityHash",e.data("securityHash")),h.append("encryptFiles",(!0===e.data("encryptFileData")).toString()),t.when(function(e,n,a,o,r){var i=t.Deferred();if(n){var s=new FileReader,l=new Image;s.readAsDataURL(e),s.onload=function(e){l.src=e.target.result,l.addEventListener("load",function(){a.append("xDimension",this.width.toString()),a.append("yDimension",this.height.toString()),i.resolve({img:l,formData:a,fileUploadCount:o,fileCount:r})})}}else i.resolve({formData:a,fileUploadCount:o,fileCount:r});return i.promise()}(n,o,h,f,b)).done(function(e){var n={};n.cancelID=c+"Cancel"+e.fileUploadCount+e.fileCount+d,n.deleteID=c+"Delete"+e.fileUploadCount+e.fileCount+d,n.requestIsRunning=t.ajax({url:r.virtualDir+"Security/SessionFileUpload/CreateSessionFileUpload",type:"POST",xhr:function(){var n=t.ajaxSettings.xhr();if(n.upload){const t=n.upload;t.elementNumber=""+e.fileUploadCount+e.fileCount,t.addEventListener("progress",M,!1)}return n},success:function(n){var a=c+"file"+e.fileUploadCount+n.fileNumber+d,o=t(D(a));o.find(".button").remove(),o.find(".fileID").val(n.id);var r=t(D(c+"fileUploadInputSelectorName"));r.length>0&&r.val(a);var l=t("<span/>");t.when((0,u.getSvg)("Delete","Control")).done(function(a){l.append(a),P(e.fileUploadCount+n.fileNumber,l.html(),i).appendTo(t("#"+c+"file"+f+n.fileNumber+d)).on("click",x)}),s.data().massImportMode||(t(".uploadLoadingGifWrapper").hide(),t(".completedWrapper").show())},data:e.formData,contentType:!1,processData:!1,async:!0}),p.push(n)})}(s[o],l,t(n).data().imageMode,a,t(n),d)})}))};function S(e,n){let a="files";n&&0!=n.length||(n=function(e,t){let n=t;if(e&&0!=e.length){let a=e.indexOf(t);n=a>0?e.substring(0,a)+t:t}else n=t;return n}(e,a));var o="",r="",i=!0;if(e&&0!=e.length){var s;const t=e.split("-");if(t.length>1)for(var l=0;l<t.length;l++)t[l]!=n&&t[l]!=a?i?r+=t[l]+"-":o+="-"+t[l]:i=!1;var c=null!==(s=null==e?void 0:e.indexOf("_"))&&void 0!==s?s:-1;c>0&&e.substring(0,c+1)!=r.substring(0,c+1)&&(r=e.substring(0,c+1)+r)}let d="";const u=t("[name="+r+"fNumber"+o+"]");if(u.length>0){const e=t(u[0]).attr("id").split("-");for(let t=0;t<e.length;t++){var f,h=e[t];(null===(f=h)||void 0===f?void 0:f.indexOf("fileUpload"))>-1&&(d=h.substring(10,h.lastIndexOf("fNumber")))}}return{fileUploadInputPrefix:r,fileUploadInputScoping:o,fileUploadCount:d}}t(this).off("change").on("change",function(){k(this)});var D=function(e){return"#"+CSS.escape(e)};function E(e,n,a,o,r){const{fileUploadInputPrefix:i,fileUploadInputScoping:s}=o;var l=t.extend({},{title:"Deletes the selected file",href:"javascript:void(0)",class:"fileUpload__deleteButton",text:"Delete File"},r),c=t("<a>",{id:i+e+n+s,class:"fileUpload__deleteButton button",title:l.title,alt:l.title,"data-value-input-id":i+"fileInput"+n+s,href:l.href,html:a});return c.append(document.createTextNode(l.text)),c}function P(e,t,n,a){return E("Delete",e,t,n,a)}function O(e){for(var n=e.split("-"),a="",o=0;o<n.length;o++)n[o].indexOf("Delete")>-1&&(a=n[o]);const r=S(e,a),i=t("#"+e).parent();var s=i.find("input");s.data("original-value",s.val()),s.trigger("dirty"),i.remove(),b--,function(e){const{fileUploadInputPrefix:n,fileUploadInputScoping:a,fileUploadCount:o}=e;var r=t("#"+n+"fileUpload"+o+"fNumber"+a);r.length>0&&(r.val(parseInt(r.val(),10)-1),r.trigger("change"))}(r)}function B(e){for(var t,n=e.target.id,a=0;a<p.length;a++)p[a].cancelID==n&&(t=p[a],p.splice(a,1));null!=t&&(t.requestIsRunning&&4!=t.requestIsRunning.readyState?(t.requestIsRunning.abort(),O(n)):(0,i.showCriticalDialog)("Error","The upload has completed or no files are being uploaded currently"))}function T(e){const t=e.attr("name");return(null==t?void 0:t.indexOf("media"))>=0?void 0:e.val()}function x(n){const a=t(n.target).closest(".button"),o=a.attr("id");var s;for(let e=0;e<p.length;e++)p[e].deleteID==o&&(s=p[e],p.splice(e,1));var l={sessionFileUploadID:T(t("#"+o).siblings(".fileID")),securityHash:e.data("securityHash")};if(null!=s&&l.sessionFileUploadID){var c=t(a.data().valueInputId);a.data().deletingValue=c.val(),c.val(""),s.ignoreRequest||s.requestIsRunning&&4==s.requestIsRunning.readyState?t.ajax({url:r.virtualDir+"Security/SessionFileUpload/DeleteSessionFileUpload",type:"POST",data:l,success:function(){O(o)},error:function(){c.val(a.data().deletingValue),(0,i.showCriticalDialog)("Error","File failed to delete")}}):(0,i.showCriticalDialog)("Error","There is no file to delete")}}function M(e){e.lengthComputable&&t("#progressbar"+this.elementNumber).progressbar({value:Math.round(e.loaded/e.total*100)})}function I(n){const{fileUploadInputPrefix:a,fileUploadInputScoping:o}=n;for(var s,l=t("#"+a+"fileList"+o),c=l.children(".file").children(".button").attr("id"),d=0;d<p.length;d++)p[d].deleteID!=c&&p[d].cancelID!=c||(s=p[d],p.splice(d,1));var u={sessionFileUploadID:T(l.find(".fileID")),securityHash:e.data("securityHash")};O(c),null!=s&&u.sessionFileUploadID&&(s.ignoreRequest||s.requestIsRunning&&4==s.requestIsRunning.readyState?t.ajax({url:r.virtualDir+"Security/SessionFileUpload/DeleteSessionFileUpload",type:"POST",data:u,error:function(){(0,i.showCriticalDialog)("Error","File failed to delete")}}):(0,i.showCriticalDialog)("Error","There is no file to delete"))}function A(e,n,a,o,i,s,d,f){const{fileUploadInputPrefix:h,fileUploadInputScoping:m,fileUploadCount:g}=o;var w=t("#"+h+"fileList"+m),v=null!=a,y=null!=f,_=y?"media":"",C=v||y;b++;var k=g.toString()+b.toString(),S=t("<input>",{id:h+"fileInput"+k+m,class:"fileID",type:"hidden",name:h+"file"+k+m+_,"data-original-value":""});if(i.data().massImportMode){(T=t("<div>",{id:h+"file"+k+m,class:"file hidden"})).append(S),w.append(T);var D=t("#"+h+"massImportProgress"+m);if(D.length>0){D.val(b);const e=i.get(0);void 0!==e&&d==e.files.length&&(t(".uploadLoadingGifWrapper").hide(),D.parent().append(t("<div>",{class:"completedWrapper"}).append(t("<span>",{class:"checkmarkIcon"})).append("Completed")),t.when((0,u.getSvg)("Check","MessageBox")).done(function(e){t(".checkmarkIcon").html(e[0])}))}}else{if(C){var O={};O.deleteID=h+"Delete"+k+m,O.ignoreRequest=!0,p.push(O),y?S.val(f):S.val(a)}else t("#progressbar"+k).progressbar({value:0}),S.val("noFileId");var T=t("<div>",{id:h+"file"+k+m,class:"file"});i.hasClass("showEmbeddedImage")?T.append(t("<img>",{class:"embeddedImageDisplay displayBlock"})):T.append(t("<span>",{class:"defaultIcon"})),i.hasClass("hideFileUploadName")||T.append(t("<span>",{class:"fileuploadname"}).text(e)),T.append(t("<span>",{class:"fileSizeDisplay"}).text("("+n+")")),T.append(t("<div>",{class:"completedWrapper"}).append(t("<span>",{class:"checkmarkIcon"})).append("Completed")),T.append(S),T.append(t("<div>",{class:"uploadLoadingGifWrapper"}).append(t("<img>",{class:"uploadLoadingGif",src:r.virtualDir+"content/loading.gif?v=2"})).append("Loading..."));var M=function(e,n,a){const o=e?P(n,t("<span>",{class:"deleteIcon"}),a):function(e,t,n,a){return E("Cancel",e,t,n,a)}(n,t("<span>",{class:"cancelIcon"}),a,{title:"Cancels the upload of selected file",text:"Cancel Upload"});return o}(C,k,o);if(i.data().replaceFileMode&&M.css("display","none"),T.append(M),i.hasClass("showEmbeddedImage")){var I=new Image;I.addEventListener("load",function(){var e=i.data();if(e.embeddedImageMaxWidth&&this.width>parseInt(e.embeddedImageMaxWidth)){var t=this.width;this.width=parseInt(e.embeddedImageMaxWidth);var n=this.width/t;this.height=n*this.height}if(e.embeddedImageMaxHeight&&this.width>parseInt(e.embeddedImageMaxHeight)){var a=this.height;this.height=parseInt(e.embeddedImageMaxHeight);n=this.height/a;this.width=n*this.width}T.find(".embeddedImageDisplay").attr("src",this.src).width(this.width).height(this.height),i.trigger("embeddedImagedLoaded")}),I.src=window.URL.createObjectURL(s)}w.append(T),i.hasClass("showEmbeddedImage")||t.when((0,u.getSvg)("Default","Reporting")).done(function(e){t(".defaultIcon").html(e[0])}),t.when((0,u.getSvg)("Check","MessageBox")).done(function(e){t(".checkmarkIcon").html(e[0])}),C?t.when((0,u.getSvg)("Delete","Control")).done(function(e){t(".deleteIcon").html(e[0])}):t.when((0,u.getSvg)("Cancel","Control")).done(function(e){t(".cancelIcon").html(e[0])}),t("#"+h+"Delete"+k+m).on("click",x),t("#"+h+"Cancel"+k+m).on("click",B),w.find(".CheckBox").addClass("svgNoHover"),C?w.find(".uploadLoadingGifWrapper").hide():w.find(".completedWrapper").hide(),v||((0,l.setUpChangeTracking)(h+"fileInput"+k+m),S.trigger("dirty")),(0,c.getScopeContainer)(w).trigger("fileAdded",[o])}}function L(e,n,a,r){const{fileUploadInputPrefix:i,fileUploadInputScoping:s,fileUploadCount:l}=r;var c=l.toString()+b.toString();b>0&&!R()&&I(r);var d=t("<span/>");t.when((0,u.getSvg)("Delete","Control")).done(function(e){d.append(e)}),b++;var f=t("<div>",{id:i+"file"+c+s,class:"file"});f.append(t("<span>",{class:"badfileuploadname"}).text(e)),f.append(t("<span>",{class:"badFileSizeDisplay"}).text("("+n+")")),f.append(t("<span>",{class:"filetoolargemessage"}).text(a)),f.append(P(c,d,r)),v.append(f),t("#"+i+"Delete"+c+s).on("click",function(){if(this.id)return O(this.id),!1;(0,o.reportException)(new o.SkywardException("File has invalid or missing ID and couldn't be removed.","File: ".concat(e)))})}function R(){return e.prop("multiple")}function N(e){return 0===e?"0KB":e/f<1?"1KB":e/f>=1&&e/f<1024?Math.round(e/f)+"KB":e/h>=1&&e/h<1024?Math.round(e/h)+"MB":Math.round(e/1073741824)+"GB"}})})}(window.skyward=window.skyward||{},window.jQuery)},48594(e,t,n){"use strict";n.r(t),n.d(t,{getValue:()=>d});var a=n(92214),o=n(74061);const r="filterOptionSelector__option",i="filterOptionSelector__radio",s="filterOptionSelector__option--disabled",l="filterOptionSelector__option--selected",c=(0,o.defineCustomElement)({name:"sky-filteroptionselector",shadowRoot:!1,inheritAttrs:!1,setup(e,t){var n;let{emit:a,attrs:c}=t;const d=(0,o.ref)(c.dataSelected),u=JSON.parse(c.dataOptions),f=c.dataName,h="true"===(null===(n=c.dataTriggersPageRefresh)||void 0===n?void 0:n.toLowerCase()),p=h?"link":"button",m=(0,o.ref)(),g=(0,o.ref)();(0,o.onMounted)(()=>{const e=(0,o.getCurrentInstance)().vnode.el.parentElement,t=null!=c["aria-label"],n=null!=c["aria-labelledby"];if(!t&&!n){let t=$.findLabel(f);if(0==t.length&&c.id&&(t=$.findLabel(c.id)),t.length>0){const n=t.addIds().attr("id");e.setAttribute("aria-labelledby",n),g.value=t.text()}}});const w=(0,o.computed)(()=>u.map((e,t)=>{const n=d.value===e.value,a="".concat(f,"_").concat(t);return(0,o.createVNode)("label",{tabindex:"0",role:p,"aria-current":n,"aria-disabled":e.disabled,class:{[r]:!0,[s]:e.disabled,[l]:n},onKeyup:t=>{e.disabled||function(e){if("Enter"===e.key||" "===e.key){const t=e.target,n=null==t?void 0:t.firstChild;n&&n.click()}}(t)}},[(0,o.createVNode)("input",{type:"radio",class:i,name:f,value:e.value,checked:n,onClick:()=>{d.value===e.value||e.disabled||(d.value=e.value,!h&&m.value&&(m.value.textContent="".concat(g.value," ").concat(e.label," selected")))}},null,10,["name","value","checked","onClick"]),(0,o.createVNode)("span",{id:a},[e.label],8,["id"])],42,["role","aria-current","aria-disabled","onKeyup"])}));return()=>(0,o.createVNode)(o.Fragment,null,[w.value,!h&&(0,o.createVNode)("span",{ref:m,"aria-live":"polite",class:"sr-only"},null,512)])}});customElements.define("sky-filteroptionselector",c);function d(e){const t=$(e);if(0==t.length||"sky-filteroptionselector"!==t[0].tagName.toLowerCase())return;const n=t.find('input[type="radio"]:checked');return 0!=n.length?n.val():void 0}(0,a.registerEvents)("filterOptionSelector",{load:()=>{}})},49680(e,t,n){"use strict";n.r(t);var a=n(2894),o=n(88157),r=n(49343),i=n(66952),s=n(917),l=n(92214),c=n(68337);const d=function(){let e,t,n,l,d=!0;function O(){const e=$("<div>"),a=$("<div>",{class:"".concat(u," ").concat(h),role:"search"});t=$("<input>",{type:"text",class:"".concat(f," ").concat(p),autofocus:"true",role:"searchbox","aria-label":"Global Search"}),n=$("<a>",{href:"javascript:void(0)",class:"".concat(D," ").concat(E),role:"button","aria-label":"Perform Search"}),l=$("<div>",{class:m,role:"region","aria-label":"Search Results","aria-live":"polite"});const o=(0,c.getSvg)("Search","BrowseFooter");return n.append(o),a.append(t).append(n),e.append(a).append(l),e}function B(e){const t=$("<div>",{class:g}),n=$("<h3>",{class:w}).text(e);return t.append(n)}function T(t){const n=$.ajax({url:"".concat(a.virtualDir,"SkySys/GlobalSearch/Search"),type:"POST",dataType:"JSON",data:{searchText:(0,i.encodeHtml)(t)},activityIndicator:{hideGlass:!0},success:function(t){!async function(t){var n;const o=null!==(n=t.result)&&void 0!==n?n:[],i=$("<div>"),s="searchResult-";if(0===o.length){const e=$("<div>",{class:"".concat(P," ").concat(y)}),t=$("<p>",{text:"No results found"});return e.append(t),void l.html(e)}for(const e of o){i.append(B(e.header));for(const t of e.results){const n=$("<a>",{class:_,attr:t.Data,href:"javascript:void(0)",target:"_blank"});n.attr("data-click-action",e.clickAction);const o=await(0,a.processViewPartHtml)(t.Html);n.append(o);const r=n.data("id"),l="".concat(s).concat(r),c=n.find(".".concat(v));if(c.length){const e="".concat(l,"-label");c.attr("id",e),n.attr("aria-labelledby",e)}const d=n.find(".".concat(b));if(d.length){const e="".concat(l,"-desc");d.attr("id",e),n.attr("aria-describedby",e)}i.append(n)}}await l.viewpartHtml(i.html()),(0,r.notifyDOMLoad)(l),e.animateModalContents()}(t)}});return $.wait(500).done(function(){"pending"===n.state()&&l.html(function(){const e=$("<div>",{class:C}),t=$("<img>",{class:k,src:"".concat(a.virtualDir,"content/loading.gif?v=2"),alt:"Loading Image"}),n=$("<p>",{class:S,text:"Searching, please wait."});return e.append(t).append(n)}())}),n}return{show:function(){e=(0,o.showDialog)("Global Search",O,[o.DEFAULT_CLOSE_BUTTON],{draggable:!0,closeOnClick:!1,width:"95%"}),t.attr("placeholder","Search"),n.on("click",async function(){d&&(d=!1,(0,s.disable)(t),(0,s.disable)(n),await T(t.val()),d=!0,(0,s.enable)(t),(0,s.enable)(n),t.trigger("focus"))}),t.on("keyup",function(e){d&&"Enter"===e.key&&n.trigger("click")})}}}(),u="globalSearchBoxWrapper",f="globalSearchBox",h="browseSearch",p="browseSearchBox",m="searchResultsContainer",g="sectionHeader",w="sectionHeader__text",v="js-labelArea",b="js-descriptionArea",y="browseRow",_="searchResult",C="skywardLoadContainer",k="skywardLoadContainer__spinner",S="skywardLoadContainer__message",D="button",E="ButtonIconOnly",P="noRecordsInBrowse",O={showSearch:function(){d.show()},openNewWindow:function(){const e=$(this).data(),t="".concat(a.virtualDir).concat(e.url).concat(void 0!==e.id?"/".concat(e.id):""),n=$.extend({},e);(0,r.submitForm)(t,n,{openNewWindow:!0})}};(0,l.registerEvents)("globalSearch",O)},64801(e,t,n){"use strict";n.r(t),n.d(t,{populateBoxes:()=>l});var a=n(88157),o=n(92214);const r=window.skyward,i={htmlComboBox:"htmlComboBox",uiDisabled:"ui-disabled",templatedResult:"templatedResult",selected:"selected"},s={register:function(e){const t=e.find(i.htmlComboBox.dot()+"_button"),n=e.find(i.htmlComboBox.dot()+"_value"),o=e.find(i.htmlComboBox.dot()+"_input"),s=e.find(i.htmlComboBox.dot()+"_hiddenSelectionList");let c=n.val(),d=null,u=null;const f=e.findLabel();f.length>0&&(e.attr("aria-labelledby",f.addIds().attr("id")),f.on("click",()=>{e.trigger("focus")}));function h(){if(u)return void u.close();e.attr("aria-expanded","true");d=$("<div>",{id:o.attr("id")+"_popup",class:"verticalScroll anchored noAnchoredTail popup"}),d.append(s.children().clone(!0)),d.on("click enter",i.templatedResult.dot(),function(t){const n=$(this),a=n.find("a").first();a.length&&a.hasClass(i.uiDisabled.dot())||("keydown"===t.type&&a.length?a.trigger("click"):(c=n.data().value,l(e,c),u.close(),e.trigger("focus")))}),d.on("keydown",i.templatedResult.dot(),p),u=(0,a.showTileViewResults)(d,e,function(){t.trigger("focus"),u=null,e.attr("aria-expanded","false")}),u.options.resizeCallback(),m(c?d.find("[data-value='"+n.val()+"']"):d.find(i.templatedResult.dot()).first())}function p(e){var t,n;if(!$.contains(document.body,e.target))return;const a=r.keys.getKeyNamesFromEvent(e);let o;if(!(a.ARROW_LEFT||a.ARROW_UP||a.ARROW_RIGHT||a.ARROW_DOWN||a.TAB||a.ENTER))return;var s;(a.ARROW_RIGHT||a.ARROW_DOWN||a.ENTER)&&(null!=u&&u.onscreen||(h(),null===(s=u)||void 0===s||s.close()));const l=null!==(t=null===(n=u)||void 0===n?void 0:n.contents.find("".concat(i.templatedResult.dot()).concat(i.selected.dot())))&&void 0!==t?t:$();if(0!==l.length&&(a.ARROW_LEFT||a.ARROW_UP||a.ARROW_RIGHT||a.ARROW_DOWN||a.TAB)){var c,f,p,m;if(a.ARROW_LEFT||a.ARROW_UP||a.TAB&&a.SHIFT){if(o=l.prev(),!o.length)o=null!==(c=null===(f=u)||void 0===f?void 0:f.contents.find(i.templatedResult.dot()).last())&&void 0!==c?c:$()}else if(o=l.next(),!o.length)o=null!==(p=null===(m=u)||void 0===m?void 0:m.contents.find(i.templatedResult.dot()).first())&&void 0!==p?p:$();!function(){if(null==o||o.length<1||null==d)return;l.removeClass(i.selected),l.removeAttr("aria-selected"),o.addClass(i.selected),o.attr("aria-selected","true"),o.trigger("focus");const e=d.height()<o.position().top+o.height(),t=o.position().top<0;e?d.scrollTop(d.scrollTop()+o.height()):t&&d.scrollTop(d.scrollTop()+o.position().top)}(),e.preventDefault()}}function m(e){e.addClass(i.selected),e.attr("aria-selected","true"),e.trigger("focus")}e.on("click",function(){t.is(i.uiDisabled.dot())||h()}),e.on("keydown",function(e){const n=r.keys.getKeyNamesFromEvent(e);!t.is(i.uiDisabled.dot())&&(n.ARROW_UP||n.ARROW_DOWN||n.ENTER)&&h()})}};function l(e,t){const n=e.find(i.htmlComboBox.dot()+"_value"),a=e.find(i.htmlComboBox.dot()+"_input"),o=e.find("".concat(i.templatedResult.dot(),'[data-value="').concat(t,'"]')),r=o.html(),s=$("<li>",{class:i.templatedResult,tabIndex:-1,dataValue:o.data("value"),html:r}),l=$(i.htmlComboBox.dot()).data("list-item-class");l&&s.addClass(l),a.empty(),a.append(s);const c=$(i.htmlComboBox.dot()).data("selected-item-class");c&&a.find(i.templatedResult.dot()).addClass(c),t||(t=""),n.val(t),n.trigger("change")}(0,o.registerEvents)("htmlComboBox",s)},64611(e,t,n){"use strict";n.r(t),n.d(t,{clearValue:()=>p,containsHtmlEditorElement:()=>d,getEncodedValue:()=>f,getOriginalValue:()=>m,isHtmlEditorElement:()=>c,setValue:()=>h,toggle:()=>g,toggleVisible:()=>w});var a=n(66952),o=n(92214),r=n(79098),i=n(30279);(0,o.registerEvents)("htmlEditor",{});const s={htmlEditorWrapper:{className:r.v.Container,getOuterWrapper:e=>e},htmlEditorBackingInput:{className:r.v.HiddenInput,getOuterWrapper:e=>e.parents(".".concat(s.htmlEditorWrapper.className))},froalaWrapperBox:{className:r.v.FroalaBox,getOuterWrapper:e=>e.parents(".".concat(s.htmlEditorWrapper.className))}};function l(e){let t=null;for(const n of Object.values(s))if(e.hasClass(n.className)){if(t=n.getOuterWrapper(e),null!==t&&t.length>0)break;t=null}return t}function c(e){return null!==l(e)}function d(e){for(const t of Object.values(s)){const n=e.find(".".concat(t.className));if(e.hasClass(t.className)||n.length>0)return!0}return!1}function u(e){if(e&&e.length>0){const t=e.data("skyvue");if(t&&i.Q.hasState(t.id))return i.Q.getState(t.id)}return null}function f(e){const t=function(e){const t=u(l(e));return t?t.features.settings.value:null}(e);return null!==t?(0,a.encodeHtml)(t):null}function h(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];const a=l(e),o=u(a);return o&&(o.features.settings.value=t,n||null==a||a.trigger("change")),null!=a?a:void 0}function p(e){return h(e,"",arguments.length>1&&void 0!==arguments[1]&&arguments[1])}function m(e){const t=l(e),n=null==t?void 0:t.find(".".concat(s.htmlEditorBackingInput.className));return n&&n.length>0?n.data("originalValue"):null}function g(e,t){const n=l(e),a=u(n);return a&&(a.features.settings.readOnly=!t),null!=n?n:void 0}function w(e,t,n){const a=l(e);return u(a)&&(n?null==a||a.animateToggle(t):null==a||a.toggle(t)),null!=a?a:void 0}},63490(e,t,n){"use strict";n.r(t),n.d(t,{getHtml:()=>i,getNode:()=>s,getOuterHtml:()=>l,getValues:()=>c,setValues:()=>d});var a=n(66952);const o=window.skyward,r={stripJavaScript:!1,isMassPrintOnlineForm:!1};function i(e,t){return s(e,t).then(e=>e.html())}async function s(e,t){const n=$.extend({},r,t),a=$(e);if(n.isMassPrintOnlineForm)return a;const o=a.clone();return n.stripJavaScript&&o.find("script").remove(),f(u(a),o),p(h(a),o),g(a,o),await m(a,o,n),o}function l(e){let t=(0,a.isJQuery)(e)?e[0]:e;if(!t)return;const n=t.nodeType===Node.DOCUMENT_NODE?t.documentElement:t,o=n.ownerDocument?n.ownerDocument.doctype:void 0;return(o?(new XMLSerializer).serializeToString(o):"")+n.outerHTML}async function c(e){var t;return{inputs:u(e),selects:h(e),iframes:await(t=e,Promise.all(t.find("iframe").toArray().map(async function(e){try{return await o.iframeListener.getHtmlValues(e)}catch(e){return{inputs:[],selects:[],iframes:[]}}})))}}async function d(e,t){f(e.inputs,t),p(e.selects,t),await function(e,t){return Promise.all(t.find("iframe").toArray().map(function(t,n){return o.iframeListener.setHtmlValues(t,e[n])}))}(e.iframes,t)}function u(e){return e.find(":is(input,textarea):not(.doNotPost:hidden)").toArray().map(function(e){const t=$(e);return t.is(":checkbox")||t.is(":radio")?t.is(":checked"):t.val()})}function f(e,t){t.find(":is(input,textarea):not(.doNotPost:hidden)").each(function(t){const n=e[t],a=$(this);a.is(":checkbox")||a.is(":radio")?a.attr("checked",n?"checked":null):a.is("input")?a.attr("value",n):a.text(n)})}function h(e){return e.find("select:not(.doNotPost:hidden)").toArray().map(function(e){return e.selectedIndex})}function p(e,t){t.find("select:not(.doNotPost:hidden)").each(function(t){const n=e[t];$(this).find("option").each(function(e){const t=$(this);if(n===e){t.attr("selected","selected");const e=t.attr("label");void 0!==e&&t.text(e)}else t.removeAttr("selected")})})}const m=async function(e,t,n){const a=e.find("iframe");return await Promise.all(t.find("iframe").toArray().map(async function(e,t){let r;try{r=await o.iframeListener.getOuterHtml(a[t],n)}catch(e){}r&&$(e).attr("srcdoc",r)}))},g=function(e,t){const n=e.find("canvas");t.find("canvas").toArray().forEach((e,t)=>{const a=n[t];try{const t=a.toDataURL(),n=a.getBoundingClientRect(),o=$("<img>").attr({width:n.width||a.width,height:n.height||a.height,src:t});$(e).replaceWith(o)}catch(e){}})}},78744(e,t,n){"use strict";function a(e){let t=-1;const n=e||[];return{getCurrentItem:function(){return-1===t&&(t=0),n[t]},setCurrentItem:function(e){t=$.inArray(e,n)},hasItem:function(e){return $.inArray(e,n)>-1},getNextItem:function(e){let a=$.inArray(e,n);return-1===a&&(a=t),-1===a||a>=n.length-1?a=0:a++,t=a,n[t]},getPreviousItem:function(e){let a=$.inArray(e,n);return-1===a&&(a=t),-1===a?a=0:a<=0?a=n.length-1:a--,t=a,n[t]}}}function o(e,t){let n=-1,a=-1;const o=e||[],r=t;function i(e){if(void 0===e)return null;for(let t=0;t<o.length;t++){const n=$.inArray(e,o[t]);if(n>-1)return{row:t,column:n}}return null}function s(e){var t,n;const a=null!==(t=null===(n=o[e.row])||void 0===n?void 0:n.length)&&void 0!==t?t:0;return e.column>=0&&e.column<a}function l(e){const t=o.length;return e.row>=0&&e.row<t}return{getCurrentItem:function(){var e;return-1===n&&(n=0),-1===a&&(a=0),null===(e=o[n])||void 0===e?void 0:e[a]},setCurrentItem:function(e){const t=i(e);null!==t?(n=t.row,a=t.column):(n=-1,a=-1)},hasItem:function(e){return null!==i(e)},getNextItem:function(e){let t=i(e);return null===t&&(t={row:n,column:a}),t.column++,s(t)||r||(t.column=a),l(t)||(t.row=n),t.column>=o[t.row].length&&r&&(t.column=0),a=t.column,n=t.row,o[n][a]},getPreviousItem:function(e){let t=i(e);return null===t&&(t={row:n,column:a}),t.column--,s(t)||r||(t.column=a),l(t)||(t.row=n),t.column<0&&r&&(t.column=o[t.row].length-1),a=t.column,n=t.row,o[n][a]},getNextRowItem:function(e){let t=i(e);return null===t&&(t={row:n,column:a}),t.row++,l(t)||r||(t.row=n),t.row>=o.length&&r&&(t.row=0),s(t)||(t.column=a),a=t.column,n=t.row,o[n][a]},getPreviousRowItem:function(e){let t=i(e);return null===t&&(t={row:n,column:a}),t.row--,l(t)||r||(t.row=n),t.row<0&&r&&(t.row=o.length-1),s(t)||(t.column=a),a=t.column,n=t.row,o[n][a]},hasPreviousRow:function(){return n>0},hasNextRow:function(){return n<o.length-1}}}n.r(t),n.d(t,{createCollectionHandler:()=>a,createCollectionHandler2D:()=>o})},59588(e,t,n){"use strict";var a=n(2894),o=n(92214),r=n(30368),i=n(74061),s=n(66952),l=n(75552);const c=Object.freeze({labeledDataList:"labeledDataList",labeledData:"labeledData",labeledDataPart:"labeledData__part",labeledDataLabel:"labeledData__label",labeledDataData:"labeledData__data",vertical:"labeledDataList--vertical",horizontal:"labeledDataList--horizontal",centered:"labeledData--centered",noSpacing:"labeledDataList--noSpacing",inline:"labeledData--inline",decorativeLabel:"decorativeLabel",visualLabel:"visualLabel",titleMargin:"js-title-margin",srOnly:"sr-only",selectorLabel:"selectorLabel",selectorData:"selectorData",legendOption:"legendOption",legendOptionLabel:"legendOptionLabel",legendOptionData:"legendOptionData"});var d=n(49343);let u=function(e){return e.Vertical="vertical",e.Horizontal="horizontal",e}({});const f=Symbol("labeledDataListOptions"),h=(0,i.defineComponent)({name:"sky-labeleddatalist",props:{layout:{type:String,default:u.Vertical,validator:e=>Object.values(u).includes(e)},isForSelector:{type:Boolean,default:!1},isForLegend:{type:Boolean,default:!1},noSpacing:{type:Boolean,default:!1},alignLabels:{type:Boolean,default:!1},centered:{type:Boolean,default:!1}},setup(e,t){let{slots:n}=t;return(0,i.provide)(f,e),(0,i.onMounted)(()=>{(0,d.notifyResize)()}),(0,i.onUpdated)(()=>{(0,d.notifyResize)()}),()=>{var t;return(0,i.createVNode)("dl",{class:{[c.labeledDataList]:!0,[c.horizontal]:e.layout===u.Horizontal,[c.vertical]:e.layout===u.Vertical,[c.noSpacing]:e.noSpacing,[c.centered]:e.centered}},[null===(t=n.default)||void 0===t?void 0:t.call(n)],2)}}}),p=(0,i.defineComponent)({name:"DataPart",props:{html:(0,l.uh)(String)},setup(e,t){let{slots:n}=t;const a=(0,i.inject)(f,{});return()=>{var t;const o={[c.labeledDataPart]:!0,[c.labeledDataData]:!0,[c.visualLabel]:!0,[c.selectorData]:a.isForSelector,[c.legendOptionData]:a.isForLegend};if(!(0,s.isNullOrEmpty)(e.html))return(0,i.createVNode)("dd",{class:o,innerHTML:e.html},null,10,["innerHTML"]);const r=(0,i.createVNode)(i.Fragment,null,[(0,i.createVNode)("span",{"aria-hidden":"true"},["-"]),(0,i.createVNode)("span",{class:c.srOnly},["Blank"],2)]);return(0,i.createVNode)("dd",{class:o},[(0,l.E8)(null===(t=n.default)||void 0===t?void 0:t.call(n),r)],2)}}}),m=(0,i.defineComponent)({name:"LabeledData",props:{inline:{type:Boolean,default:!1}},setup(e,t){let{slots:n}=t;const a=(0,i.inject)(f,{});return()=>{var t;return(0,i.createVNode)("div",{class:{[c.labeledData]:!0,[c.inline]:e.inline,[c.legendOption]:a.isForLegend}},[null===(t=n.default)||void 0===t?void 0:t.call(n)],2)}}}),g=(0,i.defineComponent)({name:"LabelPart",props:{html:(0,l.uh)(String)},setup(e,t){let{slots:n}=t;const a=(0,i.inject)(f,{});return()=>{var t;const o={[c.labeledDataPart]:!0,[c.labeledDataLabel]:!0,[c.decorativeLabel]:!0,[c.visualLabel]:!0,[c.selectorLabel]:a.isForSelector,[c.legendOptionLabel]:a.isForLegend,[c.titleMargin]:a.alignLabels};return(0,s.isNullOrEmpty)(e.html)?(0,i.createVNode)("dt",{class:o},[null===(t=n.default)||void 0===t?void 0:t.call(n)],2):(0,i.createVNode)("dt",{class:o,innerHTML:e.html},null,10,["innerHTML"])}}}),w=["labeledData"],v=["labelPart","dataPart"],b=["text"],y=["text"];function _(e,t){if(null==e)return{};var n,a,o=function(e,t){if(null==e)return{};var n={};for(var a in e)if({}.hasOwnProperty.call(e,a)){if(-1!==t.indexOf(a))continue;n[a]=e[a]}return n}(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(a=0;a<r.length;a++)n=r[a],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}const C={buildVue:function(e){const t=e.props,{labeledData:n}=t,a=_(t,w),o=(0,i.defineComponent)({setup:()=>()=>(0,i.createVNode)(h,a,{default:()=>[null==n?void 0:n.map((e,t)=>{let{labelPart:n,dataPart:a}=e,o=_(e,v);const{text:r}=n,l=_(n,b),{text:c}=a,d=_(a,y);return(0,i.createVNode)(m,(0,i.mergeProps)({key:t},o),{default:()=>[(0,i.createVNode)(g,l,{default:()=>[r],_:2},16),(0,i.createVNode)(p,d,{default:()=>[(0,s.isNullOrEmpty)(c)?null:c]},16)],_:2},16)})]},16)});return(0,l.VZ)(o).mount(e.container)}},k={init:function(){const e=$(this),t=$.extend({},e.data());delete t.loadAction,C.buildVue({container:e[0],isMobile:a.mobileAccess,props:t}),(0,r.alignTitles)(e)}};(0,o.registerEvents)("labeledDataList",k)},2658(e,t,n){"use strict";var a=n(88157),o=n(60977),r=n(74061),i=n(75552);const s={menuSource:"skywardMainMenu__menuSource",menu:"skywardMainMenu__menuPanel",menuClosed:"skywardMainMenu__menuPanel--closed",menuOpen:"skywardMainMenu__menuPanel--open",menuTransitioning:"skywardMainMenu__menuPanel--transitioning",portalBar:"skywardMainMenu__portalBar",portalButton:"skywardMainMenu__portalButton",currentPortalButton:"skywardMainMenu__portalButton--selected",portalButtonTextContainer:"portalButton__textContainer",portalButtonText:"portalButton__text",portalContent:"skywardMainMenu__portalContent",moduleContainer:"skywardMainMenu__moduleContainer",moduleListItem:"skywardMainMenu__moduleListItem",moduleButton:"skywardMainMenu__moduleButton",moduleButtonText:"skywardMainMenu__moduleText",moduleButtonSvg:"menuModuleSvg",moduleButtonSelected:"skywardMainMenu__moduleButton--selected",moduleScreens:"skywardMainMenu__moduleScreens",moduleScreensContainer:"skywardMainMenu__moduleScreensContainer",centerPanel:"moduleScreens__centerPanel",centerPanelCategory:"moduleScreens__centerPanelCategory",centerPanelScreen:"moduleScreens__centerPanelScreen",centerPanelScreenSelected:"moduleScreens__centerPanelScreen--selected",centerPanelScreenText:"moduleScreens__centerPanelScreenText",centerPanelCategoryListItem:"moduleScreens__centerPanelCategoryListItem",centerPanelCategoryListItemNoCategoryHeader:"moduleScreens__centerPanelCategoryListItem--noCategoryHeader",centerPanelCategoryListItemHeader:"moduleScreens__centerPanelCategoryListItem--header",centerPanelCategoryText:"moduleScreens__centerPanelCategoryText",centerPanelCategoryTextExpanded:"moduleScreens__centerPanelCategoryText--expanded",rightPanel:"moduleScreens__rightPanel",rightPanelCategory:"moduleScreens__rightPanelCategory",rightPanelCategoryText:"moduleScreens__rightPanelCategoryText",rightPanelScreen:"moduleScreens__rightPanelScreen",rightPanelScreenSelected:"moduleScreens__rightPanelScreen--selected",rightPanelScreenText:"moduleScreens__rightPanelScreenText",moduleScreensNewWindowButton:"moduleScreens__newWindowButton",moduleScreensNewWindowButtonShown:"moduleScreens__newWindowButton--shown",portalButtonIcon:"portalButton__icon",mobileHeader:"mobileHeader",mobileBottomBar:"mobileBottomBar",mobileMenuButton:"mobileBottomBar__menuButton",mobileBackButton:"mobileBottomBar__backButton",mobileBackButtonDisabled:"mobileBarButton--disabled",mobileHomeButton:"mobileBottomBar__homeButton",mobileMessagesButton:"mobileBottomBar__messagesButton",mobileFriendlyName:"mobileHeader__friendlyName",mobileMenu:"skywardMainMenu",mobileMenuExpanded:"skywardMainMenu--expanded",moduleList:"skywardMainMenu__moduleList",messageCounter:"mobileBottomBar__userMessagesCounter",messageCounterVisible:"mobileBottomBar__userMessagesCounter--visible",mobileGlass:"glass",menuHomeButton:"menu-home-button",menuHomeButtonText:"menu-home-button-text",menuGroup:"menu-expand-group",menuGroupExpanded:"menu-expand-group--expanded",menuGroupBusy:"menu-expand-group--busy",menuGroupItem:"menu-expand-group__item",menuGroupItemHasMenu:"menu-expand-group__item--has-menu",menuGroupHeader:"menu-expand-group__header",menuGroupSvg:"menu-expand-group__svg",menuGroupTitle:"menu-expand-group__title",menuGroupLabel:"menu-expand-group__label",menuGroupChevron:"menu-expand-group__chevron",menuGroupSearch:"menu-expand-group--search",menuGroupSearchBox:"menu-expand-group--search-box",menuGroupSearchSvg:"menu-expand-group--search-svg",menuGroupSearchMessage:"menu-expand-group--search-message",menuGroupSearchClear:"menu-expand-group--search-clear",menuGroupSearchHasMessage:"menu-expand-group--search-has-message",menuGroupSearchItemHidden:"menu-expand-group--search-item-hidden",menuGroupUserMenu:"menu-expand-group--user-menu",menuGroupUserMenuHasDetails:"menu-expand-group--user-menu-has-details",menuGroupUserName:"menu-expand-group--user-name",menuGroupUserDetail:"menu-expand-group--user-detail",menuGroupSelectionMenu:"menu-expand-group--selection-menu",menuGroupSelectionTitle:"menu-expand-group--selection-title",menuGroupSelectionItem:"menu-expand-group--selection-item",menuGroupSelectionNoIndent:"menu-expand-group--no-indent",menuGroupPortalMenu:"menu-expand-group--portal-menu",menuGroupPortalUnsupported:"menu-expand-group--portal-unsupported",menuGroupModuleMenu:"menu-expand-group--module-menu",menuGroupForcedClosed:"menu-expand-group--forced-closed",jsDesktopMenuVisibilityToggle:"js-skywardMainMenuVisibilityToggle",jsSetSelectedPortal:"js-setSelectedPortal",jsModuleClick:"js-skywardMainMenuModuleButtonClick",jsPortalButtonKeyboardCacheMarker:"js-portalButtonKeyboardCacheMarker",jsModuleButtonKeyboardCacheMarker:"js-moduleButtonKeyboardCacheMarker",jsScreenButtonKeyBoardCacheMarker:"js-moduleScreenButtonKeyboardCacheMarker",jsScreenButtonClick:"js-skywardMainMenuModuleScreenScreenClick",jsCenterPanelKeyboardCacheMarker:"js-skywardMainMenuCenterPanelKeyboardCacheMarker",jsRightPanelKeyboardCacheMarker:"js-skywardMainMenuRightPanelKeyboardCacheMarker",jsPortalSpecificButtonMarker:"js-portalButtonForSpecificPortal--"};var l=n(98925);const c=(0,r.defineComponent)({name:"menuNewWindowButton",props:{moduleMenuScreenData:(0,i.oY)(),iconClass:(0,i.oY)(String),forceShown:(0,i.uh)(Boolean)},render(){return(0,r.createVNode)("a",{class:{[s.moduleScreensNewWindowButton]:!0,[s.moduleScreensNewWindowButtonShown]:this.forceShown},"aria-label":"Go to "+this.moduleMenuScreenData.displayText+" in a new window",href:"javascript:void(0)","data-target":"popout",role:"none"},[(0,r.createVNode)(l.A,{class:this.iconClass,name:"NewWindow",showHoverEffect:!1},null,8,["class"])],10,["aria-label"])}}),d=(0,r.defineComponent)({name:"screenButton",props:{moduleMenuScreenData:(0,i.oY)(),screenButtonClasses:(0,i.oY)(),focusHandler:(0,i.oY)()},emits:{selectScreen:(0,i.c5)()},data:()=>({forceNewWindowButtonShown:!1,anchorEl:null}),computed:{isUtility(){if(null===this.moduleMenuScreenData.module||null===this.moduleMenuScreenData||null===this.moduleMenuScreenData.screen)return!1;return"Workflow"===this.moduleMenuScreenData.module&&"WorkflowInstance"===this.moduleMenuScreenData.object&&/^Create\/.+\/.+\/.+$/i.test(this.moduleMenuScreenData.screen)}},render(){return(0,r.createVNode)("a",{ref:(0,i.Ti)(e=>{this.focusHandler.setScreenButton(this.moduleMenuScreenData,e),this.anchorEl=e}),class:this.moduleMenuScreenData.selected?this.screenButtonClasses.selectedClass:this.screenButtonClasses.unselectedClass,"aria-label":"Go to "+this.moduleMenuScreenData.displayText,href:"javascript:void(0)","aria-haspopup":this.isUtility?"dialog":void 0,onClick:e=>this._onClick(this.moduleMenuScreenData,e),onKeydown:e=>this._onKeyDown(this.moduleMenuScreenData,e),onBlur:e=>this._onBlur(e),onFocusin:e=>this._onFocusIn(e),onKeyup:e=>this._onKeyUp(e),role:"menuitem"},[(0,r.createVNode)("span",{class:this.screenButtonClasses.labelClass},[this.moduleMenuScreenData.displayText],2),this.moduleMenuScreenData.renderNewWindowButton&&(0,r.createVNode)(c,{moduleMenuScreenData:this.moduleMenuScreenData,iconClass:this.screenButtonClasses.newWindowIconClass,forceShown:this.forceNewWindowButtonShown},null,8,["moduleMenuScreenData","iconClass","forceShown"])],42,["aria-label","aria-haspopup","onClick","onKeydown","onBlur","onFocusin","onKeyup"])},methods:{_onClick(e,t){const n=t.target.classList.contains(s.moduleScreensNewWindowButton);this.$emit("selectScreen",e,n,this.anchorEl)},_onKeyDown(e,t){this.focusHandler.moveFocusFromScreen(e,t)&&t.preventDefault();const n=window.skyward.keys.getKeyNamesFromEvent(t);let a=(n.CTRL||n.SHIFT)&&!n.ARROW_DOWN&&!n.ARROW_UP&&!n.ARROW_LEFT&&!n.ARROW_RIGHT;this.moduleMenuScreenData.renderNewWindowButton&&a&&(this.forceNewWindowButtonShown=!0)},_onKeyUp(e){let t=!e.ctrlKey&&!e.shiftKey;this.moduleMenuScreenData.renderNewWindowButton&&t&&(this.forceNewWindowButtonShown=!1)},_onBlur(e){this.moduleMenuScreenData.renderNewWindowButton&&(this.forceNewWindowButtonShown=!1)},_onFocusIn(e){this.moduleMenuScreenData.renderNewWindowButton&&(window.skyward.keys.globalCtrlPressed||window.skyward.keys.globalShiftPressed)&&(this.forceNewWindowButtonShown=!0)}}}),u=(0,r.defineComponent)({name:"categoryList",props:{moduleMenuScreenCategoryData:(0,i.oY)(),labelClass:(0,i.oY)(String),screenButtonClasses:(0,i.oY)(),focusHandler:(0,i.oY)()},emits:{selectScreen:null},render(){var e;const t=this.moduleMenuScreenCategoryData.menus.length+1;return(0,r.createVNode)("ul",{role:"menu","aria-label":null!==(e=this.moduleMenuScreenCategoryData.label)&&void 0!==e?e:void 0},[(0,r.createVNode)("li",{ref:(0,i.Ti)(e=>this.focusHandler.setCategoryButton(this.moduleMenuScreenCategoryData,e)),class:this.labelClass,tabindex:"0",role:"menuItem","aria-setsize":t,"aria-posinset":"1",onKeydown:e=>function(e,t,n){n.preventDefault(),e.moveFocusFromCategory(t,n)}(this.focusHandler,this.moduleMenuScreenCategoryData,e),onFocus:()=>{return e=this.focusHandler,t=this.moduleMenuScreenCategoryData,void e.setSelectedCategory(t);var e,t}},[this.moduleMenuScreenCategoryData.label],42,["aria-setsize","onKeydown","onFocus"]),this.moduleMenuScreenCategoryData.menus.map((e,n)=>(0,r.createVNode)("li",{role:"none"},[(0,r.createVNode)(d,{moduleMenuScreenData:e,screenButtonClasses:this.screenButtonClasses,focusHandler:this.focusHandler,"aria-setsize":t,"aria-posinset":n+2,onSelectScreen:(e,t,n)=>{this.$emit("selectScreen",e,t,n)}},null,8,["moduleMenuScreenData","screenButtonClasses","focusHandler","aria-setsize","aria-posinset","onSelectScreen"])]))],8,["aria-label"])}});const f=(0,r.defineComponent)({name:"menuModuleButton",props:{moduleButtonData:(0,i.oY)(),isSelected:(0,i.JJ)(!1),focusHandler:(0,i.oY)()},emits:{selectModule:(0,i.c5)()},render(){return(0,r.createVNode)("a",{ref:(0,i.Ti)(e=>this.focusHandler.setModuleButton(this.moduleButtonData,e)),class:this.isSelected?s.moduleButtonSelected:s.moduleButton,href:"javascript:void(0)","aria-label":"View sub-menus for "+this.moduleButtonData.displayText,role:"tab","aria-controls":s.moduleScreens,"aria-selected":this.isSelected,onClick:()=>{this.$emit("selectModule",this.moduleButtonData)},onKeydown:e=>function(e,t,n){e.moveFocusFromModule(t,n)&&n.preventDefault()}(this.focusHandler,this.moduleButtonData,e)},[(0,r.createVNode)(l.A,{name:this.moduleButtonData.icon,class:s.moduleButtonSvg,"aria-hidden":"true",isButton:!0},null,8,["name","class"]),(0,r.createVNode)("span",{class:s.moduleButtonText},[this.moduleButtonData.displayText],2)],42,["aria-label","aria-controls","aria-selected","onClick","onKeydown"])}});const h=(0,r.defineComponent)({name:"menuModuleList",props:{selectedModuleID:(0,i.uh)(Number),moduleButtonDatas:(0,i.oY)(Array),focusHandler:(0,i.oY)()},emits:{selectModule:null},render(){return(0,r.createVNode)("ul",{class:s.moduleList,role:"tablist"},[this.moduleButtonDatas.map(e=>(0,r.createVNode)("li",{class:s.moduleListItem,role:"none",key:e.moduleID},[(0,r.createVNode)(f,{isSelected:this.selectedModuleID===e.moduleID,moduleButtonData:e,focusHandler:this.focusHandler,onSelectModule:e=>{this.$emit("selectModule",e)}},null,8,["isSelected","moduleButtonData","focusHandler","onSelectModule"])],2))],2)}}),p=(0,r.defineComponent)({name:"portalButton",props:{portalButtonData:(0,i.oY)(),isSelected:(0,i.JJ)(!1),focusHandler:(0,i.oY)()},emits:{selectPortal:null},render(){let e=[];null!==this.portalButtonData.displayText&&(e=this.portalButtonData.displayText.split(" "));const t=e.pop(),n=e.join(" ");return(0,r.createVNode)("a",{ref:(0,i.Ti)(e=>this.focusHandler.setPortalButton(this.portalButtonData,e)),class:[this.isSelected?s.currentPortalButton:s.portalButton,"light-focus"],href:"javascript:void(0)","aria-label":"View modules for "+this.portalButtonData.displayText,role:"tab","aria-controls":s.portalContent,"aria-selected":this.isSelected,onClick:()=>{this.$emit("selectPortal",this.portalButtonData)},onKeydown:e=>function(e,t,n){e.moveFocusFromPortal(t,n)&&n.preventDefault()}(this.focusHandler,this.portalButtonData,e)},[(0,r.createVNode)(l.A,{class:s.portalButtonIcon,name:this.portalButtonData.icon,"aria-hidden":"true",type:"PortalButtons",showHoverEffect:!1},null,8,["class","name"]),(0,r.createVNode)("span",{class:s.portalButtonTextContainer},[(0,r.createVNode)("span",{class:s.portalButtonText},[n],2),(0,r.createVNode)("span",{class:s.portalButtonText},[t],2)],2)],42,["aria-label","aria-controls","aria-selected","onClick","onKeydown"])}});const m=(0,r.defineComponent)({name:"portalBar",props:{selectedPortalCode:(0,i.oY)(String),portalButtonDatas:(0,i.oY)(Array),focusHandler:(0,i.oY)()},emits:{selectPortal:null},render(){return(0,r.createVNode)("div",{role:"region","aria-label":"Portals"},[(0,r.createVNode)("div",{class:s.portalBar,role:"tabList"},[this.portalButtonDatas.map(e=>(0,r.createVNode)(p,{ref:(0,i.Ti)(t=>this.focusHandler.setPortalButton(e,null==t?void 0:t.$el)),portalButtonData:e,isSelected:this.selectedPortalCode===e.portalCode,focusHandler:this.focusHandler,onSelectPortal:e=>{this.$emit("selectPortal",e)}},null,8,["portalButtonData","isSelected","focusHandler","onSelectPortal"]))],2)])}}),g={unselectedClass:s.centerPanelScreen,selectedClass:s.centerPanelScreenSelected,labelClass:s.centerPanelScreenText,newWindowIconClass:"menuCenterPanel"},w={unselectedClass:s.rightPanelScreen,selectedClass:s.rightPanelScreenSelected,labelClass:s.rightPanelScreenText,newWindowIconClass:"menuRightPanel"},v=(0,r.defineComponent)({name:"desktopMainMenu",props:{selectedPortalCode:(0,i.oY)(String),portalButtonDatas:(0,i.oY)(Array),selectedPortal:(0,i.oY)(),moduleMenuScreenCategoryDatas:(0,i.oY)(Array),focusHandler:(0,i.oY)()},emits:{selectPortal:(0,i.c5)(),selectModule:(0,i.c5)(),selectScreen:(0,i.c5)()},render(){const e=[],t=[];this.moduleMenuScreenCategoryDatas.forEach(function(n){null===n.displayOrder||n.displayOrder<=2?e.push(n):t.push(n)});const n=(0,r.createVNode)(m,{selectedPortalCode:this.selectedPortalCode,portalButtonDatas:this.portalButtonDatas,focusHandler:this.focusHandler,onSelectPortal:e=>{this.$refs.modules.scrollTop=0,this.$refs.centerPanel.scrollTop=0,this.$refs.rightPanel.scrollTop=0,this.$emit("selectPortal",e)}},null,8,["selectedPortalCode","portalButtonDatas","focusHandler","onSelectPortal"]),a=(0,r.createVNode)(h,{selectedModuleID:this.selectedPortal.selectedModuleID,moduleButtonDatas:this.selectedPortal.moduleButtons,focusHandler:this.focusHandler,onSelectModule:e=>{this.$refs.centerPanel.scrollTop=0,this.$refs.rightPanel.scrollTop=0,this.$emit("selectModule",e)}},null,8,["selectedModuleID","moduleButtonDatas","focusHandler","onSelectModule"]),o=e.map(e=>(0,r.createVNode)(u,{class:s.centerPanelCategory,moduleMenuScreenCategoryData:e,labelClass:s.centerPanelCategoryText,screenButtonClasses:g,focusHandler:this.focusHandler,onSelectScreen:(e,t,n)=>this.$emit("selectScreen",e,t,n)},null,8,["class","moduleMenuScreenCategoryData","labelClass","screenButtonClasses","focusHandler","onSelectScreen"])),i=t.map(e=>(0,r.createVNode)(u,{class:s.rightPanelCategory,moduleMenuScreenCategoryData:e,labelClass:s.rightPanelCategoryText,screenButtonClasses:w,focusHandler:this.focusHandler,onSelectScreen:(e,t,n)=>this.$emit("selectScreen",e,t,n)},null,8,["class","moduleMenuScreenCategoryData","labelClass","screenButtonClasses","focusHandler","onSelectScreen"]));return(0,r.createVNode)("nav",{class:s.menu,"aria-label":"Main Menu"},[n,(0,r.createVNode)("div",{id:s.portalContent,class:s.portalContent,role:"tabpanel"},[(0,r.createVNode)("div",{class:s.moduleContainer,role:"region","aria-label":"Modules",ref:"modules"},[a],2),(0,r.createVNode)("div",{class:s.moduleScreensContainer,role:"region","aria-label":"Module Links"},[(0,r.createVNode)("div",{id:s.moduleScreens,class:s.moduleScreens,role:"menubar"},[(0,r.createVNode)("div",{class:s.centerPanel,ref:"centerPanel"},[o],2),(0,r.createVNode)("div",{class:s.rightPanel,ref:"rightPanel"},[i],2)],10,["id"])],2)],10,["id"])],2)}});var b=n(83303),y=function(e){return e[e.TAB=9]="TAB",e[e.ARROW_LEFT=37]="ARROW_LEFT",e[e.ARROW_UP=38]="ARROW_UP",e[e.ARROW_RIGHT=39]="ARROW_RIGHT",e[e.ARROW_DOWN=40]="ARROW_DOWN",e}(y||{}),_=function(e){return e[e.FORWARD=0]="FORWARD",e[e.BACKWARD=1]="BACKWARD",e}(_||{});function C(e){const t={buttonMap:new Map,getFocusMoveDefinition:function(e){switch(e.keyCode){case y.TAB:return{nextFocusArea:e.shiftKey?a:n,direction:e.shiftKey?_.BACKWARD:_.FORWARD,skipCount:0};case y.ARROW_LEFT:return{nextFocusArea:t,direction:_.BACKWARD,skipCount:0};case y.ARROW_RIGHT:return{nextFocusArea:t,direction:_.FORWARD,skipCount:0};default:return null}},getFirstFocusItem:function(t){return l(e.portalButtons,t=>t.portalCode===e.selectedPortalCode,t)},getKey:e=>e.portalCode},n={buttonMap:new Map,getFocusMoveDefinition:function(e){switch(e.keyCode){case y.TAB:return{nextFocusArea:e.shiftKey?t:a,direction:e.shiftKey?_.BACKWARD:_.FORWARD,skipCount:0};case y.ARROW_UP:return{nextFocusArea:n,direction:_.BACKWARD,skipCount:0};case y.ARROW_DOWN:return{nextFocusArea:n,direction:_.FORWARD,skipCount:0};default:return null}},getFirstFocusItem:function(t){return l(e.selectedModuleButtonDatas,t=>t.moduleID===e.selectedModuleID,t)},getKey:e=>e.moduleID},a={buttonMap:new Map,getFocusMoveDefinition:function(e){switch(e.keyCode){case y.TAB:return{nextFocusArea:e.shiftKey?n:t,direction:e.shiftKey?_.BACKWARD:_.FORWARD,skipCount:0};case y.ARROW_LEFT:return{nextFocusArea:a,direction:_.BACKWARD,skipCount:0};case y.ARROW_RIGHT:return{nextFocusArea:a,direction:_.FORWARD,skipCount:0};case y.ARROW_UP:return{nextFocusArea:o,direction:_.BACKWARD,skipCount:0};case y.ARROW_DOWN:return{nextFocusArea:o,direction:_.FORWARD,skipCount:0};default:return null}},getFirstFocusItem:function(e){const t=c();return null===t||0===t.length?null:l(t,e=>{var t;return e.menuCategoryID===(null===(t=r)||void 0===t?void 0:t.menuCategoryID)},e)||t[0]},getKey:function(e){return e.menuCategoryID}},o={buttonMap:new Map,getFocusMoveDefinition:function(e){switch(e.keyCode){case y.TAB:return{nextFocusArea:e.shiftKey?n:t,direction:e.shiftKey?_.BACKWARD:_.FORWARD,skipCount:0};case y.ARROW_LEFT:return{nextFocusArea:a,direction:_.BACKWARD,skipCount:-1};case y.ARROW_RIGHT:return{nextFocusArea:a,direction:_.FORWARD,skipCount:1};case y.ARROW_UP:return{nextFocusArea:o,direction:_.BACKWARD,skipCount:0};case y.ARROW_DOWN:return{nextFocusArea:o,direction:_.FORWARD,skipCount:0};default:return null}},getFirstFocusItem:function(e){const t=a.getFirstFocusItem(0);return null===t||0===t.menus.length?null:t.menus[0]},getKey:e=>e.menuScreenID};let r=null;return{setPortalButton:(e,n)=>d(t,e,n),setModuleButton:(e,t)=>d(n,e,t),setCategoryButton:(e,t)=>d(a,e,t),setScreenButton:(e,t)=>d(o,e,t),setSelectedCategory:e=>r=e,focusFirstItem:function(){const e=s(t,0);if(null===e)return;e.focus()},moveFocusFromPortal:function(n,a){return i(n,e.portalButtons,t,a)},moveFocusFromModule:function(t,a){return i(t,e.selectedModuleButtonDatas,n,a)},moveFocusFromCategory:function(e,t){const n=c();if(null===n)return;i(e,n,a,t)},moveFocusFromScreen:function(e,t){const n=c();if(null===n)return!1;const a=n.find(t=>t.menus.some(t=>t.menuScreenID===e.menuScreenID));if(void 0===a)return!1;return i(e,a.menus,o,t)}};function i(e,t,n,a){const o=n.getKey(e),r=n.getFocusMoveDefinition(a);if(null===r)return!1;const i=n===r.nextFocusArea?function(e,t,n,a,o){let r=0;switch(n){case _.FORWARD:r=1;break;case _.BACKWARD:r=-1;break;default:return null}const i=l(t,t=>o.getKey(t)===e,r+a)||t[0],s=o.buttonMap.get(o.getKey(i));return s||null}(o,t,r.direction,r.skipCount,n):s(r.nextFocusArea,r.skipCount);return null!==i&&(i.focus(),!0)}function s(e,t){const n=e.getFirstFocusItem(t);return null===n?null:e.buttonMap.get(e.getKey(n))||null}function l(e,t,n){let a=e.findIndex(t);return-1===a?null:(a=(0,b.z)(a+n,e.length),e[a]||null)}function c(){var t;return null===e.selectedModuleID?null:(null===(t=e.portals[e.selectedPortalCode])||void 0===t||null===(t=t.modules[e.selectedModuleID])||void 0===t?void 0:t.categories)||null}function d(e,t,n){const a=e.getKey(t);null==n?e.buttonMap.delete(a):e.buttonMap.set(a,n)}}const k=(0,r.defineComponent)({name:"mainMenu",props:{isMobile:(0,i.oY)(Boolean),menuData:(0,i.oY)(),window:(0,i.oY)(),newWindowOpened:(0,i.oY)(Function)},data:()=>({isOpen:!1,top:0,selectedPortal:{selectedModuleID:null,moduleButtons:[],modules:{}},moduleCategories:[]}),computed:{focusHandler(){return C(this.menuData)}},created(){const e=this;e.menuData.getPortal(e.menuData.selectedPortalCode).then(function(t){null!==t.selectedModuleID&&e.menuData.getModuleCategories(e.menuData.selectedPortalCode,t.selectedModuleID).then(function(n){e.selectedPortal=t,e.moduleCategories=n})})},render(){const e=this,t=e.isOpen?this.isMobile?(0,r.createVNode)("span",null,null):(0,r.createVNode)(v,{selectedPortalCode:e.menuData.selectedPortalCode,portalButtonDatas:e.menuData.portalButtons,selectedPortal:e.selectedPortal,moduleMenuScreenCategoryDatas:e.moduleCategories,focusHandler:e.focusHandler,style:"top:"+e.top+"px",onSelectPortal:t=>e.__selectPortal(t),onSelectModule:t=>e.__selectModule(t),onSelectScreen:(t,n,a)=>function(e,t,n,a,o){const r=n?"popout":t.target;e.loadContent(r,t.module,t.object,t.screen,null,t.data,null,null,null,!0,null,null,null,null,null,void 0,o),(n||window.skyward.keys.globalCtrlPressed||window.skyward.keys.globalShiftPressed)&&a()}(e.window,t,n,e.newWindowOpened,a)},null,8,["selectedPortalCode","portalButtonDatas","selectedPortal","moduleMenuScreenCategoryDatas","focusHandler","style","onSelectPortal","onSelectModule","onSelectScreen"]):null;return(0,r.createVNode)(r.Transition,{name:s.menu,"enter-from-class":s.menuClosed,"enter-active-class":s.menuTransitioning,"enter-to-class":s.menuOpen,"leave-from-class":s.menuOpen,"leave-active-class":s.menuTransitioning,"leave-to-class":s.menuClosed,onAfterEnter:()=>{this.focusHandler.focusFirstItem(),$(".".concat(s.moduleButtonSelected)).scrollintoview({duration:0})}},{default:()=>t},8,["name","enter-from-class","enter-active-class","enter-to-class","leave-from-class","leave-active-class","leave-to-class","onAfterEnter"])},methods:{toggleOpen(e){this.isOpen=void 0===e?!this.isOpen:e},setTopPosition(e){this.top=e},__selectPortal(e){const t=e.portalCode;if(null===t)return;const n=this,a=n.menuData;D(a,t,null,function(e,o){a.selectedPortalCode=t,n.__setSelectedValues(e,o)})},__selectModule(e){const t=this,n=t.menuData;D(n,n.selectedPortalCode,e.moduleID,function(n,a){n.selectedModuleID=e.moduleID,t.__setSelectedValues(n,a)})},__setSelectedValues(e,t){this.selectedPortal=e,this.moduleCategories=t}}}),S={buildVue:function(e){return(0,i.VZ)(k,{isMobile:e.isMobile,window:e.window,menuData:e.menuData,newWindowOpened:e.newWindowOpened}).mount(e.container)}};function D(e,t,n,a){e.getPortal(t).then(function(o){if(null===o.selectedModuleID)return;const r=null!==n?n:o.selectedModuleID;e.getModuleCategories(t,r).then(function(e){a(o,e)})})}var E=n(79126);function P(e,t,n){let o=null,r=[],i="",s={};return{get menuLocation(){return o},set menuLocation(e){o=e},get selectedPortalCode(){return i},set selectedPortalCode(e){i=e},get portalButtons(){return r},set portalButtons(e){r=e},get selectedModuleID(){var e;return(null===(e=s[i])||void 0===e?void 0:e.selectedModuleID)||null},set selectedModuleID(e){const t=s[i];void 0!==t&&(t.selectedModuleID=e)},get portals(){return s},set portals(e){s=e},get selectedModuleButtonDatas(){var e;return(null===(e=s[i])||void 0===e?void 0:e.moduleButtons)||[]},initializeOnDomLoad:function(e,t){o=e,r=t.portalBar.buttons;const n=t.portalContent.selectedModuleID,a=t.portalCode;if(null===n||null===a)return;i=a;const c=t.portalContent.moduleMenu?t.portalContent.moduleMenu.buttons:[],d=t.portalContent.screenCategories?t.portalContent.screenCategories.categories:[];!function(e,t,n,a){s[e]=l(t,n,a)}(a,c,d,n)},getPortal:function(t){const n=s[t];if(void 0!==n)return e.Deferred().resolve(n).promise();return c("getPortalContent","SkySys/MenuModule/GetPortalContent",{portalCode:t}).then(function(n){if(null===n||null===n.selectedModuleID)return e.Deferred().reject();const a=l(n.moduleMenu.buttons,n.screenCategories.categories,n.selectedModuleID);return s[t]=a,a})},getModuleCategories:function(t,n){var o;if(!s||void 0===t||!s[t]){const o=s?Object.keys(s).join(","):"null";return(0,E.reportException)(new E.SkywardException("Unknown portal. Possible PortalCodes: ".concat(o,". PortalCode: ").concat(t,". Menu Module ID: ").concat(n,"."))),(0,a.showErrorDialog)("There was an error retrieving the menu modules.","Please try refreshing your browser.",{}),e.Deferred().reject().promise()}const r=null===(o=s[t])||void 0===o||null===(o=o.modules[n])||void 0===o?void 0:o.categories;if(void 0!==r)return e.Deferred().resolve(r).promise();return c("getMenusForModule","SkySys/MenuModule/GetMenusForModule",{moduleID:n,portalCode:t}).then(function(a){var o;const r=null===(o=s[t])||void 0===o?void 0:o.modules;return void 0===r?e.Deferred().reject():(r[n]=a,a.categories)})}};function l(e,t,n){const a={categories:t},o=Object.create(null);o[n]=a;return{selectedModuleID:n,moduleButtons:e,modules:o}}function c(e,a,o){const r={url:t.virtualDir+a,type:"POST",dataType:"JSON",activityIndicator:{hideGlass:!0},data:o},i={requestID:e};return n.ajax(r,i)}}let O=null;const B=window.skyward;B.mainMenuVueBuilder={getMainMenuVue:function(e,t){let n;const o=$(t),r=$(e).data().menu,i=B.mainMenuVueBuilder.getCache();i.initializeOnDomLoad(e,r);const s={container:document.createElement("div"),isMobile:B.global.mobileAccess,menuData:i,window:B.window,newWindowOpened:f},l=S.buildVue(s);let c=!1;o.on("click",d);return{isMenuOpen:()=>c,toggleMenu:d,openMenu:u,closeMenu:f};function d(){c?f():u()}function u(){l.setTopPosition(function(e){var t,n;const a=null!==(t=null===(n=e[0])||void 0===n?void 0:n.getBoundingClientRect().bottom)&&void 0!==t?t:0;return a+2}(o)),l.toggleOpen(!0),n=(0,a.newModalLayer)(l.$el,f),c=!0,o.attr("aria-expanded",c.toString())}function f(){l.toggleOpen(!1),c=!1,document.body.append(l.$el),n.close(),o.attr("aria-expanded",c.toString())}},getCache:()=>null===O?O=P($,B.global,(0,o.createAjaxManager)()):O,getClasses:()=>s}},78465(e,t,n){"use strict";n.r(t),n.d(t,{resetTemplate:()=>M});var a=n(2894),o=n(88157),r=n(83972),i=n(12110),s=n(917),l=n(92214);const c=["TimeOffTransactionRequest"],d="messageCenterWrapper",u="MessageCenterMode",f="messageSubjectAndContent",h="messageMasterSubject",p="messageMasterContent",m="messageMasterFromAlias",g="messageMasterAllowReplies",w="messageType",v="notificationSubType",b="includeMessageBool",y="insertPrimaryBindingButton",_="jsMessageCenterToWhomCode",C="js-standardFilterViewer",k="js-filterViewer",S="js-relationshipConditionStandardFilterViewer",D="dataObjectViewer",E="workflow",P="skywardContentPanel";let O;const B={init:function(){const e=$(this);e.find(".".concat(h)).on("click focus",function(){O=!0}),e.find(".".concat(p)).on("click focus",function(){O=!1}),I(e),0===e.find(".".concat(f)).length&&e.each(function(){!function(e){const t=e.find(".".concat(u)),n=-1!==c.indexOf((0,s.getValue)(t));e.find(".".concat(_)).on("change.recipient",function(){var t;$(this).attr("aria-readonly")||(t=e,(0,s.setValue)(t.find(".".concat(h)),""),(0,s.setValue)(t.find(".".concat(p)),"")),I(e)}),e.find(".".concat(y)).on("click.insertBinding",function(){let t=e.find(".".concat(_)).find("option:selected");0===t.length&&(t=e);const a=t.data();!function(e,t,n,a,o){const s={anchorTo:a,renderProxies:o,removeBaseFromBinding:!0,onGetBinding:function(t){!function(e,t){let n;n=1==O||null==O?e.find(".".concat(h)):e.find(".".concat(p));(0,r.insertTextToken)(n,t,!0)}(e,t)}};(0,i.openBindingDialog)(t,n,s)}(e,a.module,a.object,$(this),n)})}($(this))})},displayMessagePreview:function(e){const t=$(this),n=t.data(),r=t.parents(".".concat(d)),i=r.data(),l=(0,s.getValue)(r.find(".".concat(u))),c=(0,s.getValue)(r.find(".".concat(h))),f=(0,s.getValue)(r.find(".".concat(p))),y=(0,s.getValue)(r.find(".".concat(m))),O=(0,s.getValue)(r.find(".".concat(_)));let B=r;const T=i.filterselector;T&&(B=$(T));const x=(0,s.getValue)(B.find(".".concat(C,", .").concat(k))),M=(0,s.getValue)(B.find(".".concat(S," .").concat(C))),I=(0,s.getValue)(r.find(".".concat(b))),A=r.find(".".concat(g)),L=!!A&&(0,s.getValue)(A),R=(0,s.getValue)(r.find(".".concat(w))),N=(0,s.getValue)(r.find(".".concat(v))),F=this.closest(".".concat(E,".").concat(P)),j=this.closest(".".concat(D)),V=F||j,H=V?$(V).data():{};let W;const U=i.previewactionpopupmodulepath;W=n.previewAction?n.previewAction:U||"MessageCenter/MessageMaster/GetMessagePreviewPopup".concat(l);W+="/";const K=$.ajax({url:a.virtualDir+W,type:"POST",dataType:"viewparthtml",data:{subject:c,content:f,recipientType:O,filter:x,relationshipconditionfilter:M,typeID:R,notificationSubType:N,securityScreen:H.screen,allowReplies:L,includeAutoGeneratedMessage:I,fromAlias:y,extrafilterjson:JSON.stringify(i.extrafilterjson),extrafilterjsonhash:i.extrafilterjsonhash}});(0,o.showDialog)("Preview Message",K,[o.DEFAULT_CLOSE_BUTTON],{anchorTo:this,automationID:"message-preview-dialog"})}},T=Object.freeze({blank:"B",guardians:"G",students:"S",staff:"T",employee:"E",users:"U",applicants:"A",activityPersonnel:"P"}),x=new Map([[T.blank,new Set(T.blank)],[T.students,new Set(T.students)],[T.guardians,new Set([T.students,T.guardians])],[T.activityPersonnel,new Set([T.activityPersonnel])]]);function M(e,t,n){const a=$(e).closest(".".concat(d));(0,s.setValue)(a.find(".".concat(h)),t,!1),(0,s.setValue)(a.find(".".concat(p)),n,!1)}function I(e){const t=e.find("[id$=MessageBindingFields]");if(t.length>0){const n=t.find("option"),a=(0,s.getValue)(e.find(".".concat(_)))||T.blank,o=x.get(a);n.each((e,t)=>{const n=t.dataset.type||T.blank,a=(null==o?void 0:o.has(n))||!1;(0,s.toggleVisible)(t,a)})}}(0,l.registerEvents)("messagecenter",B)},88157(e,t,n){"use strict";n.r(t),n.d(t,{ButtonIcon:()=>v,ButtonText:()=>w,CloseReasons:()=>m,DEFAULT_CANCEL_BUTTON:()=>y,DEFAULT_CLOSE_BUTTON:()=>b,DEFAULT_OK_BUTTON:()=>_,buildRecommendationModalContent:()=>K,closeButton:()=>C,closeModalLayer:()=>B,confirmDelete:()=>T,createModalPositioningManager:()=>W,elementIsInModalLayer:()=>U,getLayerFromElement:()=>H,getOpenModalLayers:()=>O,getReferenceAreaHTML:()=>x,newModalLayer:()=>V,setupDraggableLimits:()=>j,showCodeEELDialog:()=>I,showCriticalDialog:()=>S,showDialog:()=>P,showErrorDialog:()=>E,showInformationBubble:()=>R,showInformationDialog:()=>L,showMenu:()=>F,showProcessingDialog:()=>N,showReloadDialog:()=>k,showTileViewResults:()=>A,showTouchFriendlyDialog:()=>M,showWarningDialog:()=>D});var a=n(3543),o=n(79126),r=n(2894),i=n(49343),s=n(66952),l=n(16140),c=n(1380),d=n(68337);function u(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function f(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?u(Object(n),!0).forEach(function(t){h(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):u(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function h(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const p=window.skyward;let m=function(e){return e.Escape="escape",e.Tab="tab",e.GlassClick="glassClick",e.SelectedItem="selectedItem",e}({});const g=["dialog","alertdialog","menu","listbox"];let w=function(e){return e.Save="Save",e.Cancel="Cancel",e.Close="Close",e.Done="Done",e.Ok="Ok",e.Select="Select",e}({}),v=function(e){return e.Save="Save",e.Cancel="Cancel",e.Close="Close",e.Check="Check",e.Select="Select",e}({});const b=Object.freeze({text:w.Close,icon:v.Close,click:"close"}),y=Object.freeze({text:w.Cancel,icon:v.Cancel,click:"close"}),_=Object.freeze({text:w.Ok,icon:v.Check,click:"close"}),C=f(f({},b),{},{id:null,disabled:!1,focus:!0,additionalClasses:""});function k(e,t){null!=t||(t="An error occurred. Please try reloading the screen.");const n=P(e,t,[{text:"Reload",icon:"Redo",click:function(){(0,i.reloadScreen)()}},{text:w.Close,icon:v.Close,click:function(){n.close()}}],{closeOnClick:!1})}function S(e,t,n,a){return(a=q(a,"critical")).role="alertdialog",Y(e,t,n,a)}function D(e,t,n){const a=$.extend({width:450},n),r=(0,s.encodeHtml)(t).replace(/\n/g,"<br/>"),i=[$("<p>",{addClass:"bold",text:"Are you sure you want to "+e+"?"}),$("<p>&nbsp;</p>"),$("<p>",{html:r})],l="approve",c=$.Deferred(),d=Y("Warning",i,[{text:e.capitalize(),icon:v.Check,click:function(){d.close(l)}},{text:w.Cancel,icon:v.Cancel,click:function(){d.close("cancel")}}],{id:a.id,width:a.width.toString(),additionalClasses:"warning",debugName:"Warning",role:"alertdialog",afterClose:function(e){if((null==e?void 0:e.reasonForClose)===l)return"function"==typeof a.onConfirm&&a.onConfirm(),void c.resolve();c.reject(new o.CancellationError("Canceled warning dialog"))}});return c.promise()}function E(e,t,n){const a=$.extend({width:"450"},n),o=(0,s.encodeHtml)(t).replace(/\n/g,"<br/>"),r=[$("<p>",{addClass:"bold",text:e}),$("<p>&nbsp;</p>"),$("<p>",{html:o})],i=$.Deferred();return Y("Error",r,[{text:w.Close,icon:v.Close,click:function(e,t){t.close(),i.resolve(!0)}}],{id:a.id,width:a.width,additionalClasses:"critical",debugName:"Error",role:"alertdialog",beforeClose:function(e,t){t!==m.Escape&&t!==m.GlassClick||i.resolve(!1)},afterClose:a.afterClose}),i.promise()}function P(e,t,n,a){return Y(e,t,n,a=q(a,"standard"))}function O(){return $(".modalLayerContainer")}function B(e){const t=$(e);if(!t.length)return!1;const n=t.find("#cancelButton,.informationDialogClose,.modalContentFooter svg.close,.glass").last();return!!n.length&&(n.trigger("click"),!0)}function T(e,t,n){let a=$.extend({},n);const r=$.Deferred(),i={text:"Yes, Delete",icon:"CheckmarkConfirm",click:r.resolve,additionalClasses:"confirmDelete_doDelete",additionalSvgClasses:"confirmDelete_doDeletePart",additionalTextClasses:"confirmDelete_doDeletePart"},s={text:"No, Cancel",icon:v.Cancel,click:()=>r.reject(new o.CancellationError("Delete cancelled")),additionalClasses:"confirmDelete_cancel",additionalSvgClasses:"confirmDelete_cancelPart",additionalTextClasses:"confirmDelete_cancelPart"};let l='<span class="modalContent__deleteHeading">Are you sure you want to delete this '.concat(e,"?</span>");null!=t&&(l+='<div class="modalContent__deleteAdditionalText">'.concat(t,"</div>"));const c=x(a.referenceItems);null!=c&&(l="".concat(c).concat(l));const d=S("CONFIRM DELETE",l,[i,s],{closeOnClick:!1,closeOnEscape:!1});return r.always(d.close).promise()}function x(e){if(e&&Array.isArray(e)&&e.length>0){const t=e.map(e=>'<span class="reference-slats static"><span class="slatLabel">'.concat(e.label,'</span><span class="slatData">').concat(e.data,"</span></span>"));return'<div class="referenceBar">'.concat(t.join(""),"</div>")}return null}function M(e,t,n,a,o){const r=[];return null!==n&&i(n,"left"),i(a,"right"),o=q(o,"standard"),Y(e,t,r,o);function i(e,t){const n=" modalContentFooter__button--touchFriendly js--modalContentFooter__button--"+t;$(e).each(function(){r.push(this),q(this,n)})}}function I(e,t,n,a,o,i,s){if(r.mobileAccess)return G.apply(void 0,arguments);let l;if("codeEELValue"in o){const e=o.codeEELValue.val();l=e&&""!==e?".browseRow.codeEEL__browseRow--selected .button.js-selectRecord":".browseRow.current .button.js-selectRecord"}o.layer=V(e,a,{initialFocusElement:l,bindings:i,expose:[n],tailessAnchored:!0,afterClose:s});const c=W(o.layer,n,o.layer.contents,{minRowsToShow:3,minimumBrowseWidth:500,maintainRelativePosition:!0});return o.layer.options.loadDOMCallback=c.positionEELContents,o.layer.options.resizeCallback=c.positionEELContents,o.layer.show(),t&&t.trigger("focus"),o.layer}function A(e,t,n,a){const o=V(e,n,{bindings:a,expose:[t],preserveFocus:!0,role:"listbox"}),r={getRows:function(){return o.contents.find(".templatedResult, .toolbar--browseControls.tileviewEEL")},getHeaderRow:function(){return o.contents.find(".templatedResult").first()}},s=W(o,t,o.contents,r);return o.options.resizeCallback=s.positionEELContents,(0,i.registerLayoutResizeCallback)(function(){o.options.resizeCallback&&o.options.resizeCallback()}),o}function L(e,t,n,a){const o=Y(e,t,n,q(a,"standard"));if(!o.title.find(".informationDialogClose").length){const e=$("<a>",{href:"javascript:void(0)",class:"informationDialogClose",role:"button","aria-label":"Close"});e.attr("tabindex",0);const t=te("Close","MessageBox").addClass("svgNoHover");e.append(t),o.title.addClass("hasClose"),o.title.append(e),e.on("click",function(){o.close()}),e.on("keydown",function(e){p.keys.getKeyNamesFromEvent(e).ENTER&&(o.close(),e.preventDefault(),e.stopPropagation())})}return o.content.addClass("noFooter informationDialogContent"),o.footer.remove(),o}function R(e,t,n,a){const o=Y(e,t,n,a=q(a,"standard"));return o.content.addClass("noFooter"),o.footer.remove(),o.container.addClass("noFooter"),o}function N(e,t,n,a){(a=q(a,"standard")).automationID="processingDialog";const o=Y(e,t,n,a);if(!r.mobileAccess){const e=$(".js-workflowHelpCenterButton"),t=$("<div>",{class:"messageBoxTitle__buttonContainer"});if(e.length>0){var s;const n=$("<a>",{class:"messageBoxTitleButton",href:null!==(s=e.prop("href"))&&void 0!==s?s:"https://hub.skyward.com/sso/helpcenter/qproxy",target:"_blank"}),a=$('<div class="messageBoxTitleButton__text">Help<br/>Center</div>');n.append(a);const o=te("Help","MessageBox").addClass("messageBoxTitleButton__svg svgNoHover");n.prepend(o),t.append(n)}const n=$("<a>",{class:"messageBoxTitleButton",href:"javascript:void(0)"}),a=$('<div class="messageBoxTitleButton__text">New<br/>Window</div>');n.append(a);const r=te("NewWindow","MessageBox").addClass("messageBoxTitleButton__svg svgNoHover");n.prepend(r),t.append(n),o.title.append(t),n.on("click",function(){const e=window.location.pathname;let t=[];null!=e&&(t=e.split("/"),t.length<=5&&(t[5]=null)),(0,i.loadContent)("popout",t[2],t[3],t[4]||"index",t[5])})}return o}function F(e,t,n){return function(e,t,n){const a=$.extend({},{beforeClose:null,afterClose:null,debugName:null},n),o={container:$("<div>",{class:"menuPopup"}),content:$("<div>",{class:"menuPopup modal content"}),close:function(){return o.modalLayer.options.forceClose=!0,o.modalLayer.close(),o.closed=!0,!0},closed:!1};t=$(t),o.container.append(o.content);const r=e.map(e=>function(e,t,n){var a,o;if(null==e)return null;if(e=$.extend({},{type:"item",id:null,icon:null,click:null,data:null,attributes:null,disabled:!1,selected:!1},e),"custom"===(null===(a=e.type)||void 0===a?void 0:a.toLowerCase()))return null==e.content?null:"function"==typeof e.content?e.content():e.content;const r="title"==(null===(o=e.type)||void 0===o?void 0:o.toLowerCase()),i=$("<span>",{class:"menuPopupItemIcon","aria-hidden":!0}),s=$(r?"<h1>":"<span>",{class:"anchorText textAfter svgGroup"}).text(e.text),l=te(e.icon,"MessageBox");let c;null==l||l.addClass("svgNoHover"),i.append(l),c="popup"===e.target?"dialog":"false";const d={id:e.id,href:"javascript:void(0);",class:r?"menuPopupTitle":"menuPopupItem",role:r?void 0:"menuitem","aria-haspopup":e.hasPopup||c};e.selected&&(d.class+=" selected");if(e.attributes)for(const t in e.attributes)d[t]=e.attributes[t];const u=r?$("<div>",d):$("<a>",d);u.append(i,s),e.disabled&&u.addClass("ui-disabled");null!=e.data&&u.data(e.data);return ne(u,e.click,t,n),u.on("click",function(){u.prop("disabled")||u.hasClass("ui-disabled")||t()}),u}(e,o.close,o)).filter(e=>null!==e);o.content.append(r),e.length>0&&"title"===e[0].type&&o.container.attr("aria-labelledby",r[0].addIds().attr("id"));const i=W(o,t,o.content);return o.modalLayer=V(o.container,a.beforeClose,{afterClose:a.afterClose,resizeCallback:function(){i.positionModalContents(),J(o.container)},debugName:a.debugName,role:"menu"}),i.positionModalContents(),J(o.container),o.modalLayer.show(),o}(e,t,n)}function j(e){e.on("mousedown",function(t){const n=$("#master"),a=e.find(".modalHeader").outerHeight(),o=e.offset(),r=t.pageY-o.top,i=t.pageX-o.left,s=n.width(),l=n.height(),c=-1*(e.width()-a),d=s-a,u=l-a;let f=-1*i;let h=s-i,p=l-r;f<c&&(f=c),h>d&&(h=d),p>u&&(p=u),e.draggable("option","containment",[f,0,h,p])})}function V(e,t,n){var a,s,l;const d=$(document.body).children(".modalLayerContainer").length,u=$.extend({},{titleTag:"h1",bindings:[],closeOnClick:!0,closeOnRecordSelected:!0,closeOnEscape:!0,glass:"<div class='glass' >",initialFocusElement:void 0,preserveFocus:!1,transparent:!1,anchored:!1,tailessAnchored:!1,resizeCallback:null,debugName:null,role:"dialog"},n);let f,h={_bindingPoints:[],_exposedByUnderlyingLayer:[],_exposedElements:[],setupContent:_,addContent:function(e){_.call(this,e).append(e),$.extend(h.contents,e)},beforeClose:t,close:function(e){if(!h||h.closing)return!1;if(h.reasonForClose=e,h.closing=!0,"function"==typeof h.beforeClose&&!1===h.beforeClose(h,e))return h.reasonForClose=void 0,h.closing=!1,!1;if(h.options.bindings)for(const e of h.options.bindings){var t;let o;var n,a;if(void 0!==e.bindTo&&(o=$(e.bindTo)),0===(null===(t=o)||void 0===t?void 0:t.length)&&(o=h._bindingPoints),e.inSelectors)null===(n=o)||void 0===n||n.off(e.onEvents,e.inSelectors,e.runFunction);else null===(a=o)||void 0===a||a.off(e.onEvents,e.runFunction)}let o;for(const e of h._exposedElements)o=e,$(o.element).css({zIndex:o.previousZIndex,position:o.previousPosition,opacity:o.previousOpacity}).removeClass("exposedToModalLayer_"+h.uniqueId).removeClass("currentlyExposed"),$(o.element).off("wheel",z);for(const e of h._exposedByUnderlyingLayer)o=e,$(o.element).css({zIndex:o.previousZIndex}).addClass("currentlyExposed");if(!r.mobileAccess){const t="function"==typeof h.options.preserveFocus?h.options.preserveFocus.call(h,e):h.options.preserveFocus;(0,c.unregisterLayer)(h,t)}h.container.removeData("layer"),h.container.off(),h.container.remove(),h.onscreen=!1,"function"==typeof h.options.afterClose&&h.options.afterClose(h,e);h.options.resizeCallback&&"function"==typeof h.options.resizeCallback&&(0,i.removeLayoutResizeCallback)(h.options.resizeCallback);h.options.loadDOMCallback&&"function"==typeof h.options.loadDOMCallback&&(0,i.removeLoadDOMCallback)(h.options.loadDOMCallback);return h=null,!0},container:$("<div>",{class:"modalLayerContainer","data-layerid":d}),contents:$(),glass:$(u.glass).attr("id","modalLayerGlass"+d),onscreen:!1,closing:!1,options:u,originalActiveElement:document.activeElement,show:function(){if(!h)return void(0,o.reportException)(new o.SkywardException("layer is undefined within show function.","layerId: ".concat(d)));h.options.anchored&&(h.contents.addClass("anchored"),h.options.tailessAnchored&&h.contents.addClass("noAnchoredTail"));h.contents.addClass("columnLayoutWrapper--modalLayer"),h.container.show(),h.options.loadDOMCallback&&"function"==typeof h.options.loadDOMCallback&&(0,i.registerLoadDOMCallback)(h.options.loadDOMCallback);h.options.resizeCallback&&"function"==typeof h.options.resizeCallback&&(0,i.registerLayoutResizeCallback)(h.options.resizeCallback);r.mobileAccess||(0,c.setFocus)(h)},uniqueId:d};if("button"===(null===(a=h.originalActiveElement)||void 0===a?void 0:a.getAttribute("role"))||null!==(null===(s=h.originalActiveElement)||void 0===s?void 0:s.getAttribute("aria-haspopup"))){const e=h.originalActiveElement.getAttribute("aria-haspopup");h.options.role!==e&&r.isDebug}if(h.options.tailessAnchored&&(h.options.anchored=!0),h.options.loadDOMCallback&&(0,i.registerLoadDOMCallback)(h.options.loadDOMCallback),null!=n&&1==n.transparent&&$(h.glass).addClass("transparent"),h.container.appendTo(document.body),h.container.data("_modalLayerDebug",{name:h.options.debugName,creator:(0,o.getCallerLocation)()}),h.addContent($(h.glass)),$(".currentlyExposed").each(function(){const e=$(this);h._exposedByUnderlyingLayer.push({element:e,previousZIndex:e.css("z-index")}),e.css("z-index","auto").removeClass("currentlyExposed")}),h.options.expose)for(const e of h.options.expose){const t="exposedToModalLayer_"+h.uniqueId;$(e).addClass(t).addClass("currentlyExposed").each(function(){const e=$(this);h._exposedElements.push({element:e,previousOpacity:e.css("opacity"),previousPosition:e.css("position"),previousZIndex:e.css("z-index")}),e.css({"z-index":1,position:"relative",opacity:.999999}),e.find(":focusable").addClass(t),h._bindingPoints.push(e.parent()),e.on("wheel",z)})}var m,w;(h.contents=$(e),h.addContent(h.contents),!0!==h.options.closeOnClick&&r.mobileAccess||h.glass.on("click",function(){h&&(!0===h.options.closeOnClick?h.close("glassClick"):r.mobileAccess||(0,c.setFocus)(h))}),h.options.preventKeyBubbling&&h.container.on("keydown keyup",function(e){const t=p.keys.getKeyNamesFromEvent(e);return t.TAB||t.ENTER}),!0===h.options.closeOnEscape)&&(h.options.bindings=null===(m=h.options.bindings)||void 0===m?void 0:m.slice(),null===(w=h.options.bindings)||void 0===w||w.push({onEvents:"keydown",bindTo:document.body,runFunction:function(e){if(p.keys.getKeyNamesFromEvent(e).ESC){const t=e;return void 0!==t.currentPopupId&&null!==t.currentPopupId||(t.currentPopupId=(0,i.getCurrentPopupId)()),h.uniqueId===t.currentPopupId&&(h.close("escape"),e.stopImmediatePropagation()),!1}return!0}}));if(null!==(l=h.options.bindings)&&void 0!==l&&l.length){h._bindingPoints.push(h.container),h._bindingPoints=$($.uniqueSort(h._bindingPoints));for(const e of h.options.bindings){var v;let t;var b,y;if(void 0!==e.bindTo&&(t=$(e.bindTo)),0===(null===(v=t)||void 0===v?void 0:v.length)&&(t=h._bindingPoints),e.inSelectors)null===(b=t)||void 0===b||b.on(e.onEvents,e.inSelectors,null,e.runFunction);else null===(y=t)||void 0===y||y.on(e.onEvents,e.runFunction)}}return h.container.data("layer",h),h.onscreen=!0,r.mobileAccess||(0,c.registerLayer)(h),h;function _(e){return e.hasClass("glass")||(e.addClass("modalLayer"),null!=n&&n.additionalContainerClasses&&e.addClass(n.additionalContainerClasses),e.attr("role")||e.attr("role",function(e){if(!g.includes(e))return console.warn("A modal popup's ARIA role must be ".concat(g.slice(0,-1).join(", "),", or ").concat(g[g.length-1],", not ").concat(e,".")),"dialog";return e}(h.options.role)),e.attr("aria-modal")||e.attr("aria-modal","true"),void 0!==f)?this.container:(f=$("<div>",{class:"layerPseudoForm"}),this.container.append(f),f)}}function H(e){const t=$(e);return(t.hasClass("modalLayerContainer")?t:t.closest(".modalLayerContainer")).data("layer")}function W(e,t,n,o){const r=20,s=$.extend({maintainRelativePosition:!1},o),l={},c=e.container,d=parseInt(n.css("min-height"));let u=!1,f=null;const h=$(t),p={measurements:{allowedContentHeight:0,contentOnly:0,containerWithoutContent:0,entireContainer:0,top:0},isAnchored:function(){return h.length&&h.is(":visible")},positionModalContents:function(){p.isAnchored()?function(){m(),c.css("display","inherit"),c.addClass("anchored"),e.container.css("position","");let t=!1,a=!1;const o=14,s=5,l=h.outerWidth(),v=c.outerWidth(!0),b=v*(s/100)+o,y=10;function _(){c.removeClass("topLeft topRight bottomLeft bottomRight")}function C(){const e=["topLeft","topRight","bottomLeft","bottomRight"];return t&&a?e[3]:t&&!a?e[2]:!t&&a?e[1]:e[0]}function k(){const e={},s=document.documentElement.scrollTop,h=document.documentElement.scrollLeft;if(p.anchorToOffset.left-h>=(0,i.getClientWidth)()||p.anchorToOffset.left<0||p.anchorToOffset.top-s>=(0,i.getClientHeight)()||p.anchorToOffset.top<0||p.anchorToOffset.left-h+b+y>(0,i.getClientWidth)())return void S();var m,w;(function(){const e=n.height(),t=n.scrollTop();n.height(""),p.measurements.contentOnly=Math.ceil(n.outerHeight(!0)),p.measurements.containerWithoutContent=0,c.contents().not(".modal.content").each(function(){p.measurements.containerWithoutContent+=$(this).outerHeight(!0)});const a=c.outerWidth(!0),o=n.outerWidth(!0);p.measurements.containerOuterWidth=a>o?a:o,p.measurements.entireContainer=p.measurements.contentOnly+p.measurements.containerWithoutContent,n.height(e),n.scrollTop(t)}(),f=g(),function(e){let t,n,a,o,s;const l=p.measurements.entireContainer,c=function(){let e=d||60;return e+=p.measurements.containerWithoutContent,e}();if(e){var u,f;o=(0,i.getClientHeight)()-(null!==(u=null===(f=p.anchorToOffset)||void 0===f?void 0:f.bottom)&&void 0!==u?u:0)-r,n=l<o,a=o-p.measurements.containerWithoutContent}else n=l<p.anchorToOffset.top,t=l-p.anchorToOffset.top;n?p.measurements.allowedContentHeight=p.measurements.contentOnly:(s=e?a:p.measurements.contentOnly-t,s-=r,p.measurements.allowedContentHeight=c>s?c:s)}(f),f)?e.top=(null!==(m=null===(w=p.anchorToOffset)||void 0===w?void 0:w.bottom)&&void 0!==m?m:0)+13:(t=!0,e.top=p.anchorToOffset.top-(p.measurements.containerWithoutContent+p.measurements.allowedContentHeight+13));if(p.measurements.top=e.top,u&&n.outerHeight(p.measurements.allowedContentHeight||"auto"),(0,i.getClientWidth)()<p.anchorToOffset.left+v){if(p.anchorToOffset.left<v)return void S();a=!0;const t=2,n=(0,i.getClientWidth)()-t-(p.anchorToOffset.left+l/2)-b;e.left=(0,i.getClientWidth)()-n-v}else{const t=10;a=!1;let n=p.anchorToOffset.left+l/2-b;if(n<t){n=t;const e=p.anchorToOffset.left+l/2-n-o;c.hasClass("customArrowPosition")||($("<style type='text/css'> #"+c[0].id+":before, #"+c[0].id+":after { left: "+e+"px; } </style>").appendTo(".modalLayerContainer"),c.addClass("customArrowPosition"))}const s=n+v;if(s<(0,i.getClientWidth)())e.left=n;else{const t=s-(0,i.getClientWidth)();e.left=n-t-r}}c.css(e);const k=C();_(),c.addClass(k)}function S(){_(),w()}k()}():w()},positionEELContents:function(){p.isAnchored()?m():e.close();const t=$.extend({getHeaderRow:function(){return void 0===w.header||null===w.header?$():w.header.find(".unlockedHeaderTableRow")},getRows:function(){return void 0===w.browse||null===w.browse?$():w.browse.find(".js-eelPositionManagerGetRowsForHeight")},minimumBrowseWidth:0,minContentHeight:50},s);n.width(""),c.css("display","inherit"),c.addClass("anchored");const o={};let d,u,h=0;const w=function(e){if(void 0===l.browseID){const t=(0,a.getInnerBrowse)(e);void 0!==t&&(l.browseID=t.id)}return(0,a.getBrowseById)(l.browseID)}(n),v=function(e){let t=0;if(void 0===l.browseControlsHeight||null===l.browseControlsHeight){var n;if(null!=e){if(void 0!==e.controls&&null!==e.controls)l.browseControlsHeight=parseInt((null===(n=e.controls.outerHeight(!0))||void 0===n?void 0:n.toString())||"0")}else l.browseControlsHeight=0}if(void 0===l.browseHeaderHeight||null===l.browseHeaderHeight){var a;if(null!=e){if(void 0!==e.header&&null!==e.header)l.browseHeaderHeight=parseInt((null===(a=e.header.outerHeight(!0))||void 0===a?void 0:a.toString())||"0")}else l.browseHeaderHeight=0}var o;null!=e&&void 0!==e.footer&&null!==e.footer&&(t=parseInt((null===(o=e.footer.outerHeight(!0))||void 0===o?void 0:o.toString())||"0"));const r=(l.browseControlsHeight||0)+(l.browseHeaderHeight||0)+t;return r}(w),b=t.getHeaderRow(),y=t.getRows();if(y.length>0){let e={rowsFoundForMinHeight:0,heightOfOneRow:0,heightOfFoundMinRows:0};if(y.each(function(){const n=$(this).outerHeight(!0);t.minRowsToShow&&e.rowsFoundForMinHeight<t.minRowsToShow&&(e=function(e,t){const n={};e>0&&(n.heightOfFoundMinRows=t.heightOfFoundMinRows+=e,n.rowsFoundForMinHeight=t.rowsFoundForMinHeight+=1,n.heightOfOneRow=e);return n}(n,e)),h+=n}),t.minRowsToShow&&e.rowsFoundForMinHeight)if(e.heightOfOneRow&&e.rowsFoundForMinHeight>0&&e.rowsFoundForMinHeight<t.minRowsToShow){const n=t.minRowsToShow-e.rowsFoundForMinHeight;t.minContentHeight=e.heightOfFoundMinRows,t.minContentHeight+=e.heightOfOneRow*n}else if(e.rowsFoundForMinHeight!==t.minRowsToShow){const e=33;t.minContentHeight=e*t.minRowsToShow}}if(h<t.minContentHeight&&(h=t.minContentHeight),f=g(),f){var _,C,k,S;d=(0,i.getClientHeight)()-(null!==(_=null===(C=p.anchorToOffset)||void 0===C?void 0:C.bottom)&&void 0!==_?_:0)-r;let e=0;null!=w&&(0,i.hasHorizontalScrollBar)(w.unlockedBody)&&(e=i.scrollbarHeight);const t=v+h+e;if(d>t)n.height(t);else{const e=n.width();n.height(d),n.width()==e&&n.width(n.width()+i.scrollbarHeight)}o.top=null!==(k=null===(S=p.anchorToOffset)||void 0===S?void 0:S.bottom)&&void 0!==k?k:0}else{d=p.anchorToOffset.top-r;const e=v+h;if(d>=v+h)n.height(e),o.top=p.anchorToOffset.top-e;else{u=e-d;const t=e-u;n.height(t),o.top=p.anchorToOffset.top-t}}const D=(0,i.getClientWidth)()-p.anchorToOffset.left<(0,i.getClientWidth)()/2,E=b.outerWidth(!0)+2;let P;if(P=!E||E<t.minimumBrowseWidth?t.minimumBrowseWidth:E,D){const e=p.anchorToOffset.right-r;e<t.minimumBrowseWidth||e<E?(n.outerWidth(e),o.left=r):(n.outerWidth(P),o.left=p.anchorToOffset.right-P)}else{const e=(0,i.getClientWidth)()-p.anchorToOffset.left-r;e<t.minimumBrowseWidth||e<E?n.outerWidth(e):n.outerWidth(Math.ceil((0,i.hasVerticalScrollBar)(n)?P+i.scrollbarHeight:P)),o.left=p.anchorToOffset.left}n.css(o)}};return"animationPromise"in e&&e.animationPromise?e.animationPromise.done(function(){u=!0}):u=!0,p;function m(){p.anchorToOffset=h.offset(),p.anchorToOffset.right=p.anchorToOffset.left+h.outerWidth(),p.anchorToOffset.bottom=p.anchorToOffset.top+h.outerHeight()}function g(){return!0!==s.maintainRelativePosition?e():(void 0===l.positionBelowAnchorTo&&(l.positionBelowAnchorTo=e()),l.positionBelowAnchorTo);function e(){var e,t;return(0,i.getClientHeight)()-(null!==(e=null===(t=p.anchorToOffset)||void 0===t?void 0:t.bottom)&&void 0!==e?e:0)>=p.anchorToOffset.top}}function w(){e.container.css("top",""),e.container.css("left",""),e.container.css("position","relative"),"content"in e&&e.content&&e.content.css("height","")}}function U(e){return $(e).closest(".modalLayerContainer").length>0}function K(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],a=arguments.length>3&&void 0!==arguments[3]&&arguments[3];const o=$("<div/>");if(n&&($("<p/>",{class:"bold",text:"WARNING:"}).appendTo(o),$("<br>").appendTo(o)),$("<div/>",{class:"recommendationDialog__text",text:e}).appendTo(o),$("<br>").appendTo(o),t&&t.length>0){$("<p/>",{class:"bold",text:"RECOMMENDATIONS:"}).appendTo(o),$("<br>").appendTo(o);const e=$(a?"<ol/>":"<ul/>",{class:"recommendationDialog__list"}).appendTo(o);t.forEach(t=>{$("<li/>",{class:"recommendationDialog__text",text:t}).appendTo(e)})}return o}function q(e,t){var n;return null!=e||(e={}),e.additionalClasses="".concat(null!==(n=e.additionalClasses)&&void 0!==n?n:""," ").concat(t).trim(),e}function G(e,t,n,a,o,i){const s=$(n);if(s.is(":animated"))return;let c;const d=1===s.closest(".distinctMultiSelectEEL").addBack(".distinctMultiSelectEEL").length,u=(0,l.default)(function(){c.modal.element.find(".modalHeader").css("margin-bottom","calc("+c.textbox.element.outerHeight()+"px + 1.5rem)")},10);return function(){const t={bindings:i,expose:[s],tailessAnchored:!0,afterClose:g,resizeCallback:function(){d&&u()}},n=s.offset(),r=s.css("width");c={modal:{origPosition:{opacity:"0"},newPosition:{opacity:"1"},skipAfterClose:!0},textbox:{element:s,origStyle:s.attr("style")||"",placeholder:s.clone(),afterShowAnimate:function(){d&&(c.textbox.element.css("width","calc(100% - 7.75rem)"),u())},origPosition:{position:"fixed",top:n.top.toString(),left:n.left.toString(),width:r,margin:"0"},newPosition:{position:"fixed",top:"4.7rem",left:"0.7rem",width:r,margin:"0"}}},o.layer=V(e,function(e,t){if("function"==typeof a)return a(e,t)},t),c.modal.element=o.layer.container.addClass("modalLayer-mobile-eel"),d&&o.layer.container.addClass("modalLayer-mobile-eel-dmse");$("<div>",{class:"title modalHeader"}).append($("<h1>",{class:"modalHeaderText",html:f()})).prependTo(c.modal.element.find(".modalLayer")),d&&u()}(),function(){var e;c.modal.element.css({top:"0",bottom:"0",height:"auto"}),$(document.body).addClass("mobileEelOpen"),void p.mobile.scrollToTop(),Object.keys(c).forEach(e=>{const t=c[e];"placeholder"in t&&t.placeholder&&t.placeholder.addClass("mobile-eel-placeholder").insertAfter(t.element),t.element.css(t.origPosition).stop().animate(t.newPosition,300,null,()=>{"afterShowAnimate"in t&&"function"==typeof t.afterShowAnimate&&t.afterShowAnimate()})}),r.isIosApp&&$(document.scrollingElement).animate({scrollTop:0},300);null===(e=o.layer)||void 0===e||e.show()}(),o.layer;function f(){let e="";const t=s.attr("data-validate-control-for");if(t){const n=s.closest(".fieldWrapper").find("[data-validate-text-for="+t.replace(/\./g,"\\.")+"]");n.length&&(e=n.text().replace(/\*/g,""))}return 0!=e.indexOf("Select")&&(e="Select "+e),e}function h(e){e.data.layer.glass.trigger("click")}function m(){$(document.body).off("click",".distinctMultiSelectSearchButton",h).removeClass("mobileEelOpen")}function g(){const e=(0,l.default)(m,10),t=new WeakMap;Object.keys(c).forEach(n=>{const a=c[n];"skipAfterClose"in a&&a.skipAfterClose||(t.set(a.element[0],a),a.element.css(a.newPosition).stop().animate(a.origPosition,300,function(){const n=t.get(this);n&&("placeholder"in n&&n.placeholder&&n.placeholder.remove(),"origStyle"in n&&n.element.attr("style",n.origStyle)),e()}))})}}function z(e){return e.preventDefault(),!1}function J(e){const t=e.find(".content");let n=0;e.children().each(function(){const e=$(this);e.width("");const t=e.outerWidth(!0)+1;t>n&&(n=t)}),Math.ceil(t.height())!=t[0].scrollHeight&&(n+=20),t.width(n)}function Y(e,t,n,a){const o=$.extend({},{titleTag:"h1",allowNoButtons:!1,useMobileAccessStyles:!1,anchorTo:null,afterClose:null,beforeClose:null,closeOnClick:!0,closeOnEscape:!0,draggable:!1,id:null,transparentGlass:!1,forceClose:!1,width:null,animationDuration:100,beforeShowContentPromise:null,dynamicDialogContentSelector:void 0,additionalClasses:"",closeOnRecordSelected:!0,automationID:void 0,role:"dialog"},a);n&&$.each(n,function(e,t){return(null==t?void 0:t.text)!==w.Save||(o.closeOnClick=!1,!1)}),!o.anchorTo||o.anchorTo instanceof $||(o.anchorTo=$(o.anchorTo));const s=$.Deferred(),l=$.Deferred(),c=$.Deferred(),d={title:$("<div>",{class:("messageBox title modalHeader "+o.additionalClasses).trim()}).append($("<".concat(o.titleTag,">"),{class:"modalHeaderText",html:e})).addIds(),content:$("<div>",{class:"messageBox modal content"}).addIds(),footer:$("<div>",{class:("modalContentFooter "+o.additionalClasses).trim()}).addIds(),close:function(e){if(!d.modalLayer.close(e))return!1;return d.closed=!0,(0,i.removeLoadDOMCallback)(g),!0},animateModalContents:function(){u.positionModalContents(),u.isAnchored()&&d.content.outerHeight(u.measurements.allowedContentHeight||"auto");return s.resolve(),s.promise()},closed:!1,animationPromise:s.promise(),bodyPromise:l.promise(),dynamicContentLoadedPromise:c.promise()};d.container=$("<div>",{id:o.id,class:"messageBox skywardContentPanel skywardSizedContainer","data-automation-id":o.automationID,"aria-labelledby":d.title.attr("id"),"aria-modal":!0,append:[d.title,d.content,d.footer]}),"alertdialog"==o.role&&d.container.attr("aria-describedby",d.content.attr("id")),o.hideOverflow&&d.content.css("overflow","hidden"),o.useSmallWidth&&(d.container.addClass("smallWidth"),d.content.addClass("contentSmallWidth"));const u=W(d,o.anchorTo,d.content),f=function(e,t,n,a){const o=a.footer,i=a.title;return $.when(function(e,t,n,a){const o=$.Deferred(),i=[];!r.mobileAccess&&!n.useMobileAccessStyles||e||i.push({text:w.Close});if(e){if("function"==typeof e)return $.when(e()).done(function(e){i.push(...e),o.resolve(X(i,t,n,a))}),o.promise();Array.isArray(e)?i.push(...e):i.push(e)}return o.resolve(X(i,t,n,a)),o.promise()}(e,t,n,a)).done(function(e){return!!e&&(e&&e.mobileClose&&(i.addClass("hasClose"),i.append(e.mobileClose)),$(e.left).each(function(){o.append($(this))}),o.append($("<div>",{class:"modalContentFooter__leftRightButtonGroupSeparator"})),$(e.right).each(function(){o.append($(this))}),!0)})}(n,d.close,o,d);$.when(f).then(function(){!r.mobileAccess&&!o.useMobileAccessStyles||d.footer.children("button").length||d.footer.remove()}),d.modalLayer=V(d.container,o.beforeClose,{afterClose:o.afterClose,closeOnClick:o.closeOnClick,closeOnEscape:o.closeOnEscape,forceClose:o.forceClose,transparent:o.transparentGlass,resizeCallback:u.positionModalContents,loadDOMCallback:!!o.dynamicDialogContentSelector&&function(e){e===o.dynamicDialogContentSelector&&d.animateModalContents().then(function(){c.resolve(),d.content.show(),(0,i.notifyResize)()})},closeOnRecordSelected:o.closeOnRecordSelected,expose:o.expose,role:o.role,initialFocusElement:o.initialFocusElement,preserveFocus:o.preserveFocus,additionalContainerClasses:o.additionalContainerClasses}),d.container.css("display","none");const h=function(e,t){if(!t)return $.Deferred().resolve().promise();if("function"==typeof t){return n(t())}if("string"!=typeof t&&"function"==typeof t.then)return n(t);{if("string"==typeof t){const e=t.split("<textarea");let n="";n=e[0].replace(/\n/gi,"<br />");for(let t=1;t<e.length;t++){const a=e[t].split("</textarea>");n+="<textarea"+a[0],a.length>1&&(n+="</textarea>"+a[1].replace(/\n/gi,"<br />"))}t=n}const n=(0,r.processViewPartHtmlSeparately)(t);return e.append(n.html),n.loaded}function n(t){return $.when(t).then(r.processViewPartHtml).then(function(t){e.append(t)})}}(d.content,t);return $.when(h).then(function(){var e;null!==(e=d.modalLayer)&&void 0!==e&&e.closing||(o.beforeShowContentPromise?$.when(o.beforeShowContentPromise).then(function(){m()}):m(),o.dynamicDialogContentSelector||(d.content.css("visibility","visible"),d.animateModalContents()),d.content.on("treeBrowseContentLoaded",function(){d.animateModalContents()}),r.mobileAccess||l.then(function(){p.dialogFocusManager.setFocus(d.modalLayer)})),l.resolve()},function(){d.close()}),o.draggable&&!r.mobileAccess&&function(e,t){const n=$.extend({},{scroll:!1,handle:".title"},t);e.draggable({scroll:n.scroll,handle:n.handle,cancel:n.cancel}),j(e),e.find(n.handle).css("cursor","move")}(d.container,{handle:".modalHeader.title"}),$.when(f,h).done(v),(0,i.registerLoadDOMCallback)(g),o.width&&d.container.css("width",o.width),o.height&&d.container.css("height",o.height),d;function m(){d.modalLayer.show(),d.container.css("display",""),d.content.trigger("contentLoaded",d),d.container.attr("id")||d.container.attr("id","modalLayerDialog"+d.modalLayer.uniqueId);const e="#"+d.container.attr("id");var t;((0,i.notifyDOMLoad)(e+" > .content"),r.mobileAccess)||(o.dynamicDialogContentSelector?null===(t=d.dynamicContentLoadedPromise)||void 0===t||t.done(()=>{ee(d)}):ee(d))}function g(){var e;if(!d||null===(e=d.modalLayer)||void 0===e||!e.onscreen)return void(0,i.removeLoadDOMCallback)(g);const t=$(this).get(0);t&&d.container.length&&d.container[0].contains(t)&&!1!==v()&&(0,i.removeLoadDOMCallback)(g)}function v(){var e;if(!d||null===(e=d.modalLayer)||void 0===e||!e.onscreen)return;let t;if(t=d.content.hasClass("noFooter")?d.content.find(".save").length>0:d.footer.find(".save").length>0,t&&d.content.find(":input").not("[type=hidden]").length){const e=d.content.closest(".layerPseudoForm"),t=d.title.find(".modalHeaderText").addIds().attr("id");return e.attr("role","form"),e.attr("aria-labelledby",t),!0}return!1}}(0,o.registerErrorDataGatherer)("modallayer",function(){const e=[];return $(".modalLayerContainer").toArray().forEach(function(t){const n=$(t).data()||{};void 0!==n.layerid&&(e[n.layerid]=n._modalLayerDebug||{})}),e});const Q=[w.Close,w.Cancel,w.Done,w.Ok];function X(e,t,n,a){const o={right:[],left:[]};let i=!0;const s=function(e,t){let n,a,o,r;const i=[],s=e;for(const e of s){if("string"==typeof e){e.toLowerCase()===w.Close.toLowerCase()&&i.push(e);continue}if(null==e||!e.text)continue;const t=f({},e);if(i.push(t),t.text.startsWith(w.Save))n=t;else switch(t.text){case w.Cancel:a=t;break;case w.Close:o=t;break;case w.Ok:r=t}}n&&o&&!a?(o.text=w.Cancel,o.icon=v.Cancel):a&&1===e.length?(a.text=w.Close,a.icon=v.Close):r&&1===e.length&&!t.isConfirmationStep&&(r.text=w.Close,r.icon=v.Close);return i}(e,n);if(r.mobileAccess||n.useMobileAccessStyles)for(let e=s.length-1;e>=0;e--){const t=s[e];if(Q.includes(t.text)){l(t),s.splice(e,1);break}}for(const e of s)if(e){const r=Z(e,t,n,a,!1);null!==r&&(i=!1,r.hasClass("js--modalContentFooter__button--left")?o.left.push(r):o.right.push(r))}if(i&&!n.allowNoButtons)if(r.mobileAccess||n.useMobileAccessStyles)l();else{const e=Z({},t,void 0,void 0,!1);e&&o.right.push(e)}function l(e){const r=Z(f(f({},e),{},{text:w.Close,icon:v.Close}),t,n,a,!0);r&&(i=!1,o.mobileClose=r)}return o}function Z(e,t,n,a,o){if(null==e)return null;const r={id:(e=$.extend(!0,{},C,e)).id,class:(o?"informationDialogClose ":"modalContentFooter__button ")+e.additionalClasses},i=$("<button>",r);if(e.data&&i.data(e.data),e.automationID?i.attr("data-automation-id",e.automationID):n&&n.automationID&&e.text&&i.attr("data-automation-id","".concat(n.automationID,"-").concat(e.text.toLowerCase().replace(/ /g,"_"),"-button")),o){const t=te(e.icon,"MessageBox");t&&(t.addClass("svgNoHover"),t.addClass("buttonSvg"),i.append(t)),i.attr("aria-label","Close")}else{const t=$("<div>",{class:"button__fireFoxFlexContentFixForButton"});i.append(t);const n=te(e.icon,"MessageBox");n&&(n.addClass("svgNoHover"),n.addClass("buttonSvg"),t.append(n));const a=$("<span>",{class:null!=e.icon?"modalContentFooter__buttonText":"modalContentFooter__buttonText--noIcon"}).append(e.text);e.additionalTextClasses&&a.addClass(e.additionalTextClasses),t.append(a)}return ne(i,e.click,t,a),e.focus&&i.attr("autofocus","true"),i}function ee(e){const t=(0,c.setFocus)(e.modalLayer);if(0===e.content.find("input:not([type='hidden']), textarea, select, table, ul, dl, ol").length)if(0===e.content.has(t).length)e.container.attr("aria-describedby",e.content.addIds().attr("id"));else{const t=$(function(e,t){if(!t||!e||(e.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_PRECEDING)!=Node.DOCUMENT_POSITION_PRECEDING)return[];const n=[];for(let a=e;a!=t;a=a.parentElement)for(;null!=a.previousElementSibling;a=a.previousElementSibling)n.push(a.previousElementSibling);return n.reverse(),n}(e.content.find(":focusable").get(0),e.content.get(0))).filter(":visible:not(.fieldWrapper *, .contentMessageArea)").toArray();e.container.attr("aria-describedby",t.map(e=>$(e).addIds().attr("id")).join(" "))}}function te(e,t){return"string"==typeof e?(0,d.getSvg)(e,t):e&&"object"==typeof e?$(e).clone():null}function ne(e,t,n,a){"function"==typeof t?e.on("click",function(n){e.prop("disabled")||e.hasClass("ui-disabled")||t.call(e,n,a)}):"string"==typeof t&&"close"!==t.toLowerCase()?e.attr("onclick",t):e.on("click",n)}},83874(e,t,n){"use strict";n.r(t),n.d(t,{clearValue:()=>w,getOriginalValue:()=>g,getValue:()=>m,populate:()=>p});var a=n(92214),o=n(66952);const r=window.skyward;r.multipleSelectBox=r.multipleSelectBox||{};const i={init:function(){const e=$(this);if(e.on("change",".customValue",b),!e.attr("aria-label")&&!e.attr("aria-labelledby")){const t=e.findLabel();if(t.length>0){const n=t.addIds().attr("id");e.attr("aria-labelledby",n)}}},click:function(){const e=$(this),t=e.data(),n=e.find(".".concat(l,":checked:visible"));e.find(".".concat(c)).text(n.length>0?t.headerTextSome:t.headerTextNone);const a=e.find(".".concat(d)),o=[];n.each(function(){const e=$(this);o.push(e.val())}),y(a,o,!0)},addCustomClick:function(){const e=$(this),t=$("#"+e.data("forId")),n=e.prev(),a=n.val();v(t,a),n.val("").trigger("focus")},enterKeyDown:function(){const e=$(this);if(e.hasClass("bound"))return;const t=e.find("input");t.on("keydown",function(e){r.keys.getKeyNamesFromEvent(e).ENTER&&t.next().click()}),e.addClass("bound")}};(0,a.registerEvents)("multipleSelectBox",i);const s="multipleSelectBox",l="multipleSelectOptionCheckbox",c="multipleSelectHeader",d="multiSelectBackingData",u="customValue",f="customValueTemplate",h="multipleSelectOption";function p(e,t,n){const a=e.closest(".".concat(s)).find(".".concat(l)),o="object"!=typeof t?JSON.parse(t):null!=t?t:[],r=Array.isArray(o)?o:Object.keys(o);y(e,r,n);const i=new Map;$.each(a,function(){const e=$(this);e.prop("checked",!1),i.set(e.val(),e)});const c=$("#".concat(e.data("forId")));for(const e of r)i.has(e)?i.get(e).prop("checked",!0):v(c,e)}function m(e){return e.data().searchParameters.map(e=>(0,o.encodeHtml)(e))}function g(e){const t=e.data().originalValue;if(!Array.isArray(t)){return[]}return t.map(e=>(0,o.encodeHtml)(e))}function w(e,t){p(e,[],t)}function v(e,t){const n=e.find(".".concat(f));if(e.length&&n.length&&t){t=t.toString();for(const n of e.find(".".concat(h," input")))if($(n).val()==t)return;const a=n.clone().removeClass(f).addClass(u);a.find("input").val(t).prop("checked",!0),a.find("label").text(t);const o=e.find(".".concat(d)),r=o.data().searchParameters;r.push(t),y(o,r,!0),a.appendTo(e).show()}}function b(){const e=$(this);if(!e.find(".checkbox").prop("checked")){const t=e.find(".".concat(l)).val();let n=e.next(".".concat(h,":not(.").concat(f,")"));n.length||(n=e.prev(".".concat(h,":not(.").concat(f,")"))),n.find("input").trigger("focus");const a=e.parent(".".concat(s)).find(".".concat(d));let o=a.data().searchParameters;o=o.filter(e=>e!=t),y(a,o),e.remove()}}function y(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];e.data("searchParameters",t),n&&e.trigger("change")}r.multipleSelectBox.populate=p,r.multipleSelectBox.getValue=m,r.multipleSelectBox.getOriginalValue=g,r.multipleSelectBox.clearValue=w},21314(e,t,n){"use strict";n.r(t),n.d(t,{decrement:()=>i,increment:()=>r,updateNumber:()=>o});const a="notificationBubble";function o(e,t,n){const a=$("#"+e);d(a,s(a),t,n)}function r(e,t,n){const a=$("#"+e),o=s(a);if(!o)return;t=c(t);d(a,o,l(o)+t,n)}function i(e,t,n){const a=$("#"+e),o=s(a);if(!o)return;t=c(t);d(a,o,l(o)-t,n)}function s(e){const t=e.find(".".concat(a));return 0==t.length?null:t}function l(e){const t=e.data("count");return parseInt(t)}function c(e){return null==e||isNaN(e)?1:e}function d(e,t,n,a){const o=n>99?"99+":n.toString();null==a&&(a=!0),t&&(0==n?t.fadeOut(function(){t.text(""),u(e,t,n)}):a?t.fadeOut(300,function(){t.text(o).fadeIn(300),u(e,t,n)}):(t.text(o),u(e,t,n)))}function u(e,t,n){t.data("count",n),function(e,t){const n=e.data("ariaLabelSuffix");if(n){if(0===t)return void e.removeAttr("aria-label");const a=1==t?"1 ".concat(n):"".concat(t," ").concat(n,"s");e.attr("aria-label",a)}}(e,n)}},44992(e,t,n){"use strict";n.r(t),n.d(t,{launchWorkflow:()=>d});var a=n(2894),o=n(88157),r=n(49343),i=n(66952),s=n(92214),l=n(63490);const c={customPrintScreen:async function(){const e=$(this).data(),t=e;if(1==e.includePageHtml){const e=$(window.document),n=await u(e);t.html=(0,i.encodeHtml)((0,l.getOuterHtml)(n))}d("".concat(a.virtualDir).concat(e.module,"/").concat(e.controller,"/").concat(e.action),t)},capture:async function(){const e=$(window.document),t=function(e){return n(e);function t(e){const t=[];for(let a=e;null!==a.parentElement;a=a.parentElement){const e=a.getAttribute("id");if(null!==e)return t.unshift("#"+e),t.join(">");t.unshift(":nth-child(".concat(n(a)+1,")"))}return t.unshift(":root"),t.join(">");function n(e){const t=e.parentElement;for(let n=0;n<t.childElementCount;n++)if(t.children[n]===e)return n;return-1}}function n(e){const n=[];function a(e,t){const a=$(e),o=a.scrollTop(),r=a.scrollLeft();0===o&&0===r||n.push({Selector:t,Top:Math.trunc(o),Left:Math.trunc(r)})}return e.find("*").each(function(){a(this,t(this))}),a(e,"body"),n}}(e),n=(0,r.getClientWidth)(),o=(0,r.getClientHeight)(),s={html:(0,i.encodeHtml)((0,l.getOuterHtml)(await u(e))),windowWidth:n>0?n:$(window).width(),windowHeight:o>0?o:$(window).height(),ScrollableElements:t};d(a.virtualDir+"Common/PrintScreen/PrintScreen",{data:JSON.stringify(s)})}};function d(e,t){return $.ajax({url:e,type:"POST",dataType:"viewparthtml",data:t,success:function(e){const t="popup"+(0,r.getNextPopupId)(),n=$("<div/>",{class:"popup workflowPopup",id:t,html:e});(0,o.newModalLayer)(n,null,{closeOnClick:!1,closeOnEscape:!1,closeOnRecordSelected:!1}),r.popupList.push(n),(0,r.notifyDOMLoad)("#"+t)}})}async function u(e){const t=e.find("html"),n=await(0,l.getNode)(t,{stripJavaScript:!0,isMassPrintOnlineForm:!1});return function(e,t){const n=".toolbar--flexed .toolbarLeft, .toolbar--flexed .toolbarRight",a=e.find(n),o=t.find(n);a.each(function(e){const t=$(this),n=o.eq(e);if(!n.length)return;if(!f(t))return void n.css("gap","0");f(t.find(".moreMenuArea"))||n.find(".moreMenuArea").css("gap","0")})}(t,n),n}function f(e){return e.children().filter(":visible").length>0}(0,s.registerEvents)("printScreen",c)},1445(e,t,n){"use strict";n.r(t),n.d(t,{disable:()=>h,enable:()=>f,getOriginalValue:()=>w,getRadioButtonGroup:()=>u,getValue:()=>g,hide:()=>p,setValue:()=>v,show:()=>m});var a=n(917),o=n(92214);const r=window.skyward;r.radioButtonGroup=r.radioButtonGroup||{};const i="radioButtonGroup",s="radioButtonGroupValue",l="radioButton",c="ui-disabled",d={init:function(e){let t=$(e),n=t.find(".".concat(s));const o=t.attr("data-name"),r='input:radio[name="'+o+'child"]',l=$(r);if(d(),l.on("click keydown",function(e){if(this.classList.contains(c)&&"Tab"!==e.key)if(e.preventDefault(),"click"===e.type)$(this).trigger("focus");else if("ArrowDown"===e.key||"ArrowRight"===e.key){const e=(l.index(this)+1)%l.length;l.eq(e).trigger("focus")}else if("ArrowUp"===e.key||"ArrowLeft"===e.key){const e=(l.index(this)-1+l.length)%l.length;l.eq(e).trigger("focus")}}),l.on("change",function(){const e=$(this);t=e.parents(".".concat(i)),n=t.find(".".concat(s)),(0,a.setValue)(n,e.val()),d()}),!t.attr("aria-label")&&!t.attr("aria-labelledby")){let e=$.findLabel(o);if(0==e.length&&(e=n.findLabel()),e.length>0){const n=e.addIds().attr("id");t.attr("aria-labelledby",n)}}function d(){const e=$(r+":checked").data();for(const t in e)0===t.lastIndexOf("dependencyattribute",0)&&(0,a.setDataAttribute)(n,t,e[t])}}};function u(e){const t=e.find(".".concat(s)),n=e.data().name;return function(e,t,n){const a={groupElement:e,valueElement:t,radioInputs:n,radioButtons:n.closest(".".concat(l)),originalValue:t.data().originalValue,getCheckedRadioButton:function(){return a.radioInputs.filter(":checked")},getValue:function(){return a.valueElement.val()}};return a}(e,t,$('input:radio[name="'+n+'child"]'))}function f(e){const t=u(b(e));t&&(0,a.enable)(t.radioInputs)}function h(e){const t=u(b(e));t&&(0,a.disable)(t.radioInputs)}function p(e){const t=u(b(e));t&&t.radioButtons.hide()}function m(e){const t=u(b(e));return t?(t.radioButtons.show(),t.radioButtons):$()}function g(e){const t=u(b(e));if(t)return t.getValue()}function w(e){const t=u(b(e));if(t)return t.originalValue}function v(e,t,n){const o=u(b(e));if(o){o.getCheckedRadioButton().val()!=t&&(0,a.setValue)(o.radioInputs,t,n),o.valueElement.val(t),n||o.valueElement.trigger("change")}}function b(e){return e.hasClass(i)?e:e.closest(".".concat(i))}(0,o.registerEvents)("radioButtonGroup",d),r.radioButtonGroup.getRadioButtonGroup=u,r.radioButtonGroup.enable=f,r.radioButtonGroup.disable=h,r.radioButtonGroup.hide=p,r.radioButtonGroup.show=m,r.radioButtonGroup.getValue=g,r.radioButtonGroup.getOriginalValue=w,r.radioButtonGroup.setValue=v},63302(e,t,n){"use strict";n.r(t),n.d(t,{reloadReferenceByButton:()=>s,reloadReferenceByControlId:()=>i});var a=n(92214),o=n(49343);const r={referenceView:"referenceview",referenceSlats:"reference-slats",slatDataImage:"slatDataImage",slatDataIcon:"slatDataIcon",dynamic:"dynamic"};function i(e){let t;const n=$("#moduleContent"),a=$("#detailsPanel");let o=!1;a.length>0&&a.find("#"+e).length>0?(t=a.find(r.referenceView.dot()),o=!0):t=n.find(r.referenceView.dot()),l(t,o)}function s(e){const t=e.parents(r.referenceView.dot());let n=!1;$("#detailsPanel").find(t).length>0&&(n=!0),l(t,n)}function l(e,t){if(0==e.length)return;const n=e.attr("id"),a=e.data();if(null==n||null==a)return;const r={module:a.module,object:a.object,screen:a.screen,task:a.task,renderInDetailsPanel:t,securityhash:a.securityhash,name:a.name};(0,o.loadContent)(n,"SkySys","Browse","UpdateReferenceArea",a.dataObjectPrimaryKey,r)}(0,a.registerEvents)("reference",{openDetails:function(){!function(e){if(!(e.area&&e.controller&&e.action&&e.primarykeyvalue))return;(0,o.loadContent)("popout",e.area,e.controller,e.action,e.primarykeyvalue,{tab:e.tab})}($(this).data())}})},57365(e,t,n){"use strict";n.r(t),n.d(t,{RelativeDate:()=>O,getRelativeDateDisplay:()=>I,parseRelativeDateString:()=>T,setValue:()=>B,showDatePicker:()=>M,showRelativeDateDisplay:()=>x});var a=n(2894),o=n(88157),r=n(49343),i=n(917);function s(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const l="Maximum Date",c="Minimum Date",d="Current Date",u="From Now",f="Ago",h="Year",p="Day",m="datepicker",g="datepicker-wrapper",w="hidden",v="launchRelativeDatePicker",b="launchRelativeDatePickerUnbound",y="masked",_="predefinedDateSelector",C="readonly",k="relativeDate",S="relativeDateUnit",D="relativeDateDatePart",E="relativeDateDirection",P="relativeDateDisplayUnbound";class O{constructor(e,t,n){s(this,"Unit",void 0),s(this,"DatePart",void 0),s(this,"Direction",void 0),this.Unit=e,this.DatePart=t,this.Direction=n,Object.freeze(this)}toString(){if(isNaN(this.Unit))return"";if(0===this.Unit)return d;if(250===this.Unit&&this.DatePart===h)return this.Direction===u?l:c;const e=this.formatDatePartForDisplay();return"".concat(this.Unit," ").concat(e," ").concat(this.Direction)}formatDatePartForDisplay(){let e=this.DatePart;return"WeekDay"===e&&(e="Weekday"),1===this.Unit?e:"".concat(e,"s")}static parse(e){if(e instanceof O)return e;if(null==e)return null;const t=e.toString();if(t===l)return new O(250,h,u);if(t===c)return new O(250,h,f);if(t===d)return new O(0,p,f);const n=/^(\d+) (Weekday|Day|Week|Month|Year)s? (Ago|From Now)$/i.exec(t);return null===n?null:new O(parseInt(n[1]),n[2],n[3])}}function B(e,t){const n=O.parse(t);$("#"+e).val(""),null!==n?(x(e,n.toString()),R(e,n)):M(e)}function T(e){return O.parse(e)}function x(e,t){I(e).text(t).removeClass(w);const n=$("#"+e);n.addClass(k),n.data("relativeDate",t),n.addClass(w),n.trigger("dirty"),n.attr("data-relative-date",t),$("#"+e+"-errorLabel").addClass(w).empty()}function M(e){const t=I(e);if(0===t.length)return $();const n=$("#"+e);return t.addClass(w),n.removeClass(k),n.removeClass(w),n.data("relativeDate",null),$("#"+e+"-errorLabel").removeClass(w),n}function I(e){return $("#"+e+"-relativeDateDisplay")}function A(e){const t=j.keys.getKeyNamesFromEvent(e);(t.ENTER||t.SPACE)&&L.call(this)}function L(){const e=$(this);if(e.hasClass(C))return;const t=e.data("relatedDatePicker"),n=function(e){return $("#"+e+"-relativeDateBuilder")}(t),r=e.data(),s=n.find(".".concat(S)),d=null===r.unit||void 0===r.unit||isNaN(r.unit)?"":r.unit;(0,i.setValue)(s,d,!0),s.removeClass(y),n.find(".".concat(D," > [selected], .").concat(E," > [selected]")).removeAttr("selected"),n.find(".".concat(D," > [value='").concat(r.datePart||p,"']")).attr("selected","selected"),n.find(".".concat(E," > [value='").concat(r.direction||f,"']")).attr("selected","selected");const m={closeOnClick:!0,closeOnEscape:!0,closeOnGlassClick:!0,anchorTo:a.mobileAccess?null:e},g=[{text:o.ButtonText.Save,click:N,icon:o.ButtonIcon.Save},{text:o.ButtonText.Cancel,click:F,icon:o.ButtonIcon.Cancel}],w=(0,o.showDialog)("Select Relative Date",n.children().clone(),g,m);w.content.data("relatedDatePicker",t),w.content.find(".".concat(S)).trigger("focus"),w.content.find(".".concat(_)).on("click",function(){!function(e,t){const n=e.content.data("relatedDatePicker");let a;a=t===l?new O(250,h,u):t===c?new O(250,h,f):new O(0,p,f);x(n,a.toString()),R(n,a),e.close()}(w,$(this).text().trim())})}function R(e,t){const n=function(e){return $("#"+e+"-relativeDateBuilderLaunchButton")}(e).data();n.unit=t.Unit,n.datePart=t.DatePart,n.direction=t.Direction;const a=I(e).data();a.unit=t.Unit,a.datePart=t.DatePart,a.direction=t.Direction}function N(e,t){const n=t.content.data("relatedDatePicker"),a=t.content.find(".".concat(S)).val(),o=parseInt(a),r=t.content.find(".".concat(D)).val(),i=t.content.find(".".concat(E)).val(),s=new O(o,r,i);$("#"+n).val(""),x(n,s.toString()),R(n,s),t.close()}function F(e,t){t.close()}const j=window.skyward;j.relativedatepicker={setValue:B,parseRelativeDateString:T,showRelativeDateDisplay:x,showDatePicker:M,getRelativeDateDisplay:I},(0,r.registerLoadDOMCallback)(function(e){$("".concat(e," .").concat(b)).removeClass(b).on("click",L).on("keydown",A),$("".concat(e," .").concat(P)).removeClass(P).each(function(){const e=$(this);e.on("click",L),e.on("keydown",A);const t=e.siblings(".".concat(g)).children(".".concat(m)),n=t.findLabel();n.length>0&&e.attr("aria-labelledby",n.addIds().attr("id")),t.is("[readonly]")&&e.siblings(".".concat(v)).hide()})})},60990(e,t,n){"use strict";n.r(t);n(75618);window.skyward.base.registerScript("reportingCalculatedFields",function(e,t){e.reporting=e.reporting||{},e.reporting.calculatedFields=function(){let e="",n={},a={expression:null,id:null,module:null,object:null,fieldName:null,relationshipPath:null,dataType:null,parameters:null,schemaObject:null};const o={Get:function(e){return n[e]},Set:function(e){n[e.id]=t.extend({},a,e)},Delete:function(e){delete n[e]},Reset:function(a){n=t.extend({},a),e=JSON.stringify(n)},AllFields:function(){return t.extend({},n)},AllFieldsOfType:function(e){let n={};return t.each(o.AllFields(),function(){const t=this;t.dataType&&0===t.dataType.indexOf(e)&&(n[t.id]=t)}),n},AllFieldsOfModuleAndObject:function(e,n,a){let r={},i=e+"."+n;return t.each(o.AllFields(),function(){var e;const t=this;t.schemaObject===i&&(null!==(e=t.relationshipPath)&&void 0!==e?e:"")===(null!=a?a:"")&&(r[t.id]=t)}),r},IsDirty:function(){return e!=JSON.stringify(n)},NameExists:function(e){e=(e||"").toLowerCase();let a=!1;return t.each(n,function(){if(this.fieldName.toLowerCase()==e)return a=!0,!1}),a},Parameters:function(){let e=[];return t.each(o.AllFields(),function(){t.each(this.parameters,function(){e.push(this)})}),e},ConvertBindingsToFriendlyNames:function(e){if("string"!=typeof e)return"";let t=e;for(let e in n)t=t.split("{"+e+"}").join("{C:"+n[e].fieldName+"}");return t},ConvertFriendlyNamesToBindings:function(e){if("string"!=typeof e)return"";let t=e;for(let e in n)t=t.split("{C:"+n[e].fieldName+"}").join("{"+e+"}");return t}};return o}()})},64558(e,t,n){"use strict";n.r(t);var a=n(2894),o=n(88157),r=n(49343),i=n(66952),s=n(51325),l=n(92214);const c=window.skyward,d={init:function(e){const t=$(e),n=t.find(".selectorEELInput"),l=t.find(".selectorEELSearch"),d=t.find(".selectorEELValue"),u=d.data(),f=u.searchModule,h=u.searchObject,p=u.redirectModule,m=u.redirectObject,g=u.redirectScreen;let w,v,b,y="";function _(){void 0!==b&&b.abort(),b=$.ajax({url:a.virtualDir+f+"/"+h+"/SelectorTemplate",type:"POST",dataType:"JSON",data:{seekText:(0,i.encodeHtml)(n.val())},success:async function(e){if($.isEmptyObject(w))return;const t=$(w);if(e.templatedResults.length>0){const o=[],i=d.attr("id")+"-item-";for(const t of e.templatedResults){const e=i+t.Key,n=e+"-label",r=e+"-description",s=await(0,a.processViewPartHtml)(t.Value);let l=s;"string"!=typeof s&&(l=s.toOuterHtmlString());const c=$("<div>",{id:e,class:"templatedResult selectorElementsCenter","data-key":t.Key,html:l,role:"menuitem"}),d=c.find(".js-labelArea");d.length&&(d.attr("id",n),c.attr("aria-labelledby",n));const u=c.find(".js-descriptionArea");u.length&&(u.attr("id",r),c.attr("aria-describedby",r)),o.push(c)}t.empty().append(o);const s=t.find(".templatedResult:first").addClass("selected");n.attr("aria-activedescendant",s.addIds().attr("id")),a.mobileAccess?k():C(s),(0,r.notifyDOMLoad)("#"+t.attr("id"))}else t.empty().append($("<div>",{class:"noRecordsInBrowse browseRow templatedResult ignoreClickEvent selectorElementsCenter",html:"<p>No records to display</p>"}))}})}function C(e){if($.isEmptyObject(w))return;const t=parseInt(w.css("maxHeight"));let n=0;const a=$(w).children().length,o=e.outerHeight(!0);n=a*o>t?Math.floor(t/o)*o:a*o,w.height(n)}function k(){if($.isEmptyObject(w))return;const e=w.offset().top;window.innerHeight;w.css({maxHeight:"calc(100vh - ".concat(e,"px)")})}function S(){(0,r.loadContent)("full",p,m,g,$(this).data("key"))}function D(){if(n.attr("readonly"))return;let e;const t=n.offset(),i=n.outerHeight(),s=n.attr("id")+"_popup",l=.85*(0,r.getClientHeight)()-t.top-i;w=$("<div>",{id:s,class:"verticalScroll popup anchored noAnchoredTail",css:{maxHeight:a.mobileAccess?"none":l+"px",left:t.left,top:t.top+i}}),w.on("click",".templatedResult:not(.ignoreClickEvent)",S);const c={expose:[n.closest(".js-showEELContainer")],role:"menu"};a.mobileAccess&&(e=$(document.body),e.addClass("mobileEelOpen"),c.afterClose=function(){e.removeClass("mobileEelOpen")}),v=(0,o.newModalLayer)(w,function(){w=null},c),_(),n.trigger("focus")}(0,s.setFocusToTextBoxOnClick)(t),n.on("keydown",function(e){const t=c.keys.getKeyNamesFromEvent(e),a=t.ARROW_LEFT||t.ARROW_UP,o=t.ARROW_RIGHT||t.ARROW_DOWN,r=t.ENTER,i=t.TAB;if(v&&v.onscreen)if(a||o||r){const t=v.contents.find(".templatedResult.selected");if(0===t.length)return;if(a||o){let o;o=a?t.prev():t.next(),function(e,t){$.isEmptyObject(t)||0===t.length||$.isEmptyObject(w)||(e.removeClass("selected"),t.addClass("selected"),t.scrollintoview({duration:0,direction:"vertical",viewPadding:{y:0}}),n.attr("aria-activedescendant",t.addIds().attr("id")))}(t,o),e.preventDefault()}else t.trigger("click")}else i&&v.close();else(a||o)&&D()}),n.debounce("keyup",function(e){n.attr("readonly")||n.val()===y||(y=n.val(),v&&v.onscreen?_():D())}),l.on("click",function(){null!=v&&v.onscreen?a.mobileAccess||v.close():D()}),(0,r.registerLayoutResizeCallback)(function(){if(v&&v.onscreen&&!$.isEmptyObject(w))if(a.mobileAccess)k();else{const e=$(w),t=e.find(".templatedResult.selected").first(),n=t.length>0?t:e.find(".templatedResult").first();if(0===n.length)return;C(n)}})}};(0,l.registerEvents)("selectorEEL",d)},48985(e,t,n){"use strict";n.r(t),n.d(t,{getClosestSizedContainer:()=>f});var a=n(2894),o=n(49343);const r="skywardSizedContainer",i="skywardSizedContainer--XS",s="skywardSizedContainer--S",l="skywardSizedContainer--M",c="skywardSizedContainer--L",d="skywardSizedContainer--XL",u="skywardSizedContainer--XXL";function f(e){const t=$(e);return 0===t.length?$("body.".concat(r)):t.closest(".".concat(r))}function h(e){switch(!0){case e>=2560:return"XXL";case e>=1920:return"XL";case e>=1280:return"L";case e>=640:return"M";case e>=480:return"S";default:return"XS"}}async function p(e){for(const t of e){const e=$(t.target);if(0===e.length)continue;const n=e.data("window-size-code"),o=h(t.contentRect.width);if(n!==o)try{const t=new CustomEvent("sizedContainer:change",{bubbles:!1,detail:{oldSize:n,newSize:o}});if(e[0].dispatchEvent(t),e.data("window-size-code",o),!a.loggedIn)return;await $.ajax("".concat(a.virtualDir,"Security/Window/UpdateWindowSize"),{type:"POST",dataType:"JSON",data:{sizeCode:o}})}catch(e){console.error("Failed to update window size code:",e)}}}function m(e){for(const t of e){const e=t.contentRect.width,n=$(t.target);n.data("skyward-sized-container-width",e),n.toggleClass(i,!0),n.toggleClass(s,e>=480),n.toggleClass(l,e>=640),n.toggleClass(c,e>=1280),n.toggleClass(d,e>=1920),n.toggleClass(u,e>=2560)}}(0,o.registerLoadDOMCallback)(function(e){let t=$(e);t.is(".messageBox.modal.content")&&(t=t.closest(".modalLayerContainer"));const n=t.find("body.".concat(r)),a=t.find(".".concat(r)),o=new ResizeObserver(m),i=new ResizeObserver(p);a.each(function(){$(this).data().skywardSizedContainerWidth||o.observe(this)}),n.length>0&&i.observe(n[0])},1)},54375(e,t,n){"use strict";n.r(t),n.d(t,{initialize:()=>d});var a=n(62521),o=n(3543),r=n(2894),i=n(88157),s=n(49343),l=n(917),c=n(22528);window.skyward;let d=function(e,t,n,d,u){let f,h,p,m,g;const w={cancel:".sortableDelete",cursor:"move",scroll:!0,start:function(e,t){p=t.item.index()+1},update:function(e,t){C(t?t.item:null)},items:".sortableRow",sort:function(e,t){k()},containment:"parent",tolerance:"pointer",axis:"y"},v=t,b=n;!function(){const t=[{text:i.ButtonText.Save,icon:i.ButtonIcon.Save,click:u?E:D},{text:i.ButtonText.Cancel,icon:i.ButtonIcon.Cancel,click:function(){h.close()}}];(0,s.closePopup)(),h=(0,i.showDialog)($(e).find("#sortableTitle").val(),e,t,{closeOnClick:!1,hideOverflow:!0}),h.bodyPromise.then(P)}(),f=h.content.find(".sortable").first();const y=h.content.find("tbody");function _(){$("div.modalLayerContainer").last().length<=0&&(0,s.removeLayoutResizeCallback)(_)}function C(e){!function(e){const t=e?e.index():0,n=Math.min(t,p-1),a=Math.max(t,p-1)+1;f.find("td.sortColumn div").slice(n,a).each(function(e,t){$(t).html(String(n+e+1))})}(e),k(),P(),function(e){var t;if(!e)return;const n=e.find(".browseDataCell");if(n.length<2)return;const a=n[1].textContent,o=h.content.find(".sortableHeaderRow").find("th");if(o.length<3)return;const r=null!==(t=o[1].textContent)&&void 0!==t?t:"Position";g.text("".concat(a," moved to ").concat(r," ").concat(e.index()+1))}(e)}function k(){$(".sortableRow.ui-sortable-placeholder").not(".ui-sortable-helper").each(function(e,t){const n=$(t);n.html("<td colspan='".concat(m,"'></td>")),n.css({visibility:"visible"})})}function S(){const e=[];return f.find("tbody tr").each(function(t,n){e[t]={id:$(n).data("id")}}),JSON.stringify(e)}function D(){const e=$("#saveAction"),t=$("#sortablecontentmessagearea"),n=$.extend({},d,{sortOrder:S(),SortableID_SecurityHash:e.data("sortableid_securityhash"),warninghashes:JSON.stringify(t.data("warninghashes"))});return $.ajax({url:"".concat(r.virtualDir).concat(v,"/").concat(b,"/").concat(e.val()),type:"POST",data:n,success:function(n){if(n.success)h.close(),function(e){const t="detailsPanel_".concat(e);let n=!1;e&&((0,o.getBrowseById)(e)&&((0,a.get)(e),n=!0),(0,o.getBrowseById)(t)&&((0,a.get)(t),n=!0));n||window.location.reload()}(e.data("browsetorefreshaftersave"));else{let e=$(h.modalLayer.contents).find("#CurrentRecordContentBaseError");(void 0===e||null==e||e.length<1)&&(e=$("#CurrentRecordContentBaseError")),(0,c.displayValidationMessages)(n,t,e)}}})}function E(){u(h)}function P(){const e=f.find(".js-sortableUp,.js-sortableDown"),t=e.filter(".js-sortableUp"),n=e.filter(".js-sortableDown"),a=t.first(),o=n.last(),r=a.is(":focus"),i=o.is(":focus");(0,l.disable)(a),(0,l.disable)(o),(0,l.enable)(t.not(a)),(0,l.enable)(n.not(o));const s=e.not(a).not(o);r?s.first().trigger("focus"):i&&s.last().trigger("focus")}!function(e){const t=e.closest("table");let n=t.find("thead");0===n.length&&(n=$("<thead>"),t.prepend(n));const a=e.find(".sortableHeaderRow");if(a.length>0){a.find("td").each(function(){$(this).replaceTagNames("th")}),n.append(a)}}(y),y.find("tr").each(function(){const e=$(this),t=e.find(".browseDataCell");if(t.length>2){const n=t[1];e.find("a.button.js-sortableUp").attr("aria-label","Move ".concat(n.textContent," Up")),e.find("a.button.js-sortableDown").attr("aria-label","Move ".concat(n.textContent," Down"))}}),g=$("<div>",{class:"sr-only","aria-live":"assertive"}),h.content.append(g),r.mobileAccess||y.sortable(w),y.disableSelection(),f.addClass("sortable__modal"),_(),m=$("tr.sortableHeaderRow th").length,f.on("click",".sortableDelete",function(){$(this).closest("tr").first().remove(),p=f.find(".sortableDelete").length+1,C()}),f.on("click",".js-sortableUp",function(){const e=$(this),t=e.closest(".sortableRow");p=t.index()+1,t.insertBefore(t.prev()),e.trigger("focus"),C(t)}),f.on("click",".js-sortableDown",function(){const e=$(this),t=e.closest(".sortableRow");p=t.index()+1,t.insertAfter(t.next()),e.trigger("focus"),C(t)}),(0,s.registerLayoutResizeCallback)(_)}},28646(e,t,n){"use strict";n.r(t),n.d(t,{clear:()=>B,removeCollapsePanels:()=>T});var a=n(2894),o=n(49343),r=n(40346),i=n(917),s=n(1251),l=n(92214),c=n(83874);const d=window.skyward,u="advancedFilterUnbound",f="collapsePanel",h="collapsePanelContents",p="comboBoxSet",m="dataSource",g="dmsBackingData",w="filterProcessingListValue",v="filterValue",b="filterViewValue",y="multiSelectBackingData",_="newFilter",C="standardFilterAddButton",k="standardFilterRemoveButton",S="standardFilterViewer",D="standardFilterViewerUnbound",E="js-validatedPrompt",P="workflowContent",O={initializeStandardFilterViewer:function(){const e=$(this);e.removeClass(D);const t=e.find(".".concat(m)),n=JSON.parse(t.val());n.values=n.values||{},n.values.promptboundvalues=n.values.promptboundvalues||{},t.data("currentValue",n),e.on("change",".".concat(b),null,function(){!function(e){const t=e.find(".".concat(b)),n=N(e),a=JSON.parse(n.val()),o=t.data("filterCondition");a.values.advancedfilter=o,n.val(JSON.stringify(a))}(e)}),e.on("change dirty",".".concat(v,", .").concat(w),null,function(){!function(e,t){const n=N(t),a=JSON.parse(n.val()),o=$(e),r=o.data("promptUniqueId").toLowerCase();a.values.promptboundvalues=a.values.promptboundvalues||{};const s=(0,i.getUnencodedValue)(o);d.promptsview.isNonEmptyPromptValue(s)?a.values.promptboundvalues[r]=s:delete a.values.promptboundvalues[r];n.val(JSON.stringify(a))}(this,e)}),e.on("click",".".concat(C),null,M),e.on("click",".".concat(k),null,I)},initializeStandardFilter:x,initializeAdvancedFilter:function(){const e=$(this);e.removeClass(u),e.on("change dirty",".".concat(b),null,d.promptsview.setModifiedNotification),e.each(d.promptsview.setModifiedNotification)}};function B(e){e.find(".".concat(v)).each(function(){this.readOnly||(0,i.setValue)(this,null)}),T(e)}function T(e){e.find(".".concat(f)).each(function(){const e=$(this);e.data().filterIndex>0&&A(e)})}function x(){const e=$(this);e.removeClass(D),e.on("change dirty",".".concat(v,", .").concat(w),null,d.promptsview.setModifiedNotification),e.each(d.promptsview.setModifiedNotification),function(e){(0,s.getPreSaveValidationHelper)().registerContainerValidation(e,".".concat(E,".").concat(v),t=>{const n=function(e){const t={};return e.find(".".concat(v)).each(function(){const e=$(this),n=e.data().promptUniqueId;if(n){const a=(0,i.getValue)(e);t[n]=a}}),t}(e);return async function(e,t){const n={validation:[]},o=await async function(e,t){const n=new Map,o=[];for(const t of e){const e=t.data();n.set(e.promptUniqueId,t);const a={PromptUniqueID:e.promptUniqueId,PromptUniqueIDHash:e.promptUniqueIdHash};o.push(a)}const r=await $.ajax({url:"".concat(a.virtualDir,"SkySys/Prompt/ValidatePrompts"),type:"POST",data:{promptUniqueIDData:JSON.stringify(o),promptData:JSON.stringify(t)},dataType:"JSON"}),i=[];for(const e of r.validation){const t=n.get(e.PromptUniqueID);if(t){n.delete(e.PromptUniqueID);const a=[];for(const t of e.ValidationDetails){const e={severityType:t.SeverityType,message:t.Message};a.push(e)}const o={showValidation:a.length>0,validation:a,fieldElement:t};i.push(o)}}for(const[e,t]of n){const e={showValidation:!1,validation:[],fieldElement:t};i.push(e)}return i}(e,t);if(o&&o.length>0)for(const e of o)n.validation.push(e);return n}(t,n)})}(e)}function M(){var e;const t=$(this).closest(".".concat(f)),n=t.data(),r=null!==(e=n.promptUniqueId)&&void 0!==e?e:n.skywardId,i=j(t),s=F(i),l=i.data(),c=L(s.standardfilters,r),d=Math.max(...c.standardfilterindexes)+1,u=c.standardfilterindexes.length;$.ajax({url:"".concat(a.virtualDir,"SkySys/StandardFilter/AddStandardFilter"),type:"POST",dataType:"JSON",success:async function(e){const i=await(0,a.processViewPartHtml)(e.html);!function(e,t,n,a,r,i){const s=$(t);s.insertAfter(e);const l=e.find(".".concat(h)),c=e.data();l.find(".".concat(C)).hide();const d=j(e),u=d.find(".".concat(m));(function(e,t,n){const a=JSON.parse(e),o=JSON.parse(t.val()),r=R(o.standardfilters,n),i=R(a.standardfilters,n);o.standardfilters[r].standardfilterindexes=o.standardfilters[r].standardfilterindexes.concat(a.standardfilters[i].standardfilterindexes),$.extend(o.values.promptboundvalues,a.values.promptboundvalues),t.val(JSON.stringify(o))})(n,u,a),(0,o.notifyDOMLoad)("#"+function(e,t,n,a){let o="standardfilter-"+t+"-";n&&(o=o+n+"-");if(o+=a,e)return e+o;return o}(i,c.skywardId,a,r)),s.each(x),s[0].scrollIntoView(),s.find(".".concat(v)).first().trigger("focus"),s.on("ready",function(){e.trigger("standardFilterAdd",[s])})}(t,i,e.standardfilterdata,r,d,n.idPrefix)},data:{currentCount:u,filterIndex:d,dataObjectType:c.type,skywardID:c.skywardid,relationshipPath:c.relationshippath,promptValuesJson:JSON.stringify(s.values.promptboundvalues),label:n.label,promptUniqueID:r,idPrefix:n.idPrefix,defaultPromptsJson:JSON.stringify(l.defaultPrompts),readonlyIdsJson:JSON.stringify(l.readonlyIds),isRequired:l.isRequired,allowProcessingLists:c.allowprocessinglists}})}function I(){A($(this).closest(".".concat(f)))}function A(e){const t=j(e),n=e.data(),a=n.promptUniqueId,o=n.filterIndex;if(o<=0)return;const s=[];e.find(".".concat(v,", .").concat(w)).each(function(){const e=$(this).data().promptUniqueId;s.push(e)});const l=(0,r.isDirty)(e),d=e.hasClass(_);l&&d?(e.remove(),function(e,t){const n=e.find("[data-dirty]");n.length>0&&$.each(n,function(){$(this).removeAttr("data-dirty")});const a=t.find(".".concat(v)).eq(0),o=t.parent().hasClass(P);a.trigger(o?"update":"change")}(e,t)):(e.find(".".concat(v,", .").concat(w)).each(function(){!function(e){const t=e.val();if(e.is("[ignoredirtyfieldcomparison]")||""==t||"{}"==t||"[]"==t)return;e.hasClass(p)?(0,i.setValue)(e,"",!1):e.hasClass(y)?(0,c.populate)(e,[],!0):e.hasClass(g)?(0,i.setValue)(e,"{}",!1):(0,i.setValue)(e,"true",!1)}($(this))}),e.remove());t.find(".".concat(f,"[data-prompt-unique-id='").concat(a,"']")).last().find(".".concat(C)).show(),function(e,t,n,a){const o=F(e),r=N(e);for(const e of a){var i;null!==(i=o.values.promptboundvalues)&&void 0!==i&&i.hasOwnProperty(e)&&delete o.values.promptboundvalues[e]}const s=L(o.standardfilters,t);s.standardfilterindexes=s.standardfilterindexes.filter(function(e){return e!=n}),s.standardfilterindexes.length<=0&&(s.standardfilterindexes=[1]);r.val(JSON.stringify(o))}(t,a,o,s)}function L(e,t){return e.find(e=>e.uniqueid==t)}function R(e,t){return e.findIndex(e=>e.uniqueid==t)}function N(e){return e.find(".".concat(m))}function F(e){const t=N(e);return JSON.parse(t.val())}function j(e){return e.closest(".".concat(S))}(0,l.registerEvents)("standardFilterViewer",O)},15634(e,t,n){"use strict";n.r(t);var a=n(2894),o=n(88157),r=n(65302),i=n(917),s=n(92214);const l="dataObjectViewer",c="workflowContent",d="codeEEL",u="codeEELCode",f={displayStudentEntityFTEWACalculationPopup:function(){let e=$(this);const t=e.data().studentid,n=e.data().entityid,r=e.data().schoolyearid,i=$.ajax({url:"".concat(a.virtualDir,"Enrollment/StudentEntityFTEWA/DisplayStudentEntityFTEWACalculation"),type:"POST",dataType:"viewparthtml",data:{studentid:JSON.stringify(t),entityid:JSON.stringify(n),schoolyearid:JSON.stringify(r)}});(0,o.showDialog)("Calculated FTE",i,[o.DEFAULT_CLOSE_BUTTON],{anchorTo:e})},handleStatePlacementTestWAIDLoad:function(e){let t=e.closest(".".concat(l)),n="";t.length||(t=e.closest(".".concat(c)),n="EnglishLearnerWA.");if(!t)return;const a=t.find("[name='".concat(n,"PlacementTestScore']")),o=t.find("[name='".concat(n,"StateOverallPlacementTestScoreWAID']")).closest("fieldset"),s=o.find(".".concat(d)),f=[{name:"Listening",placeValue:1e3},{name:"Reading",placeValue:100},{name:"Speaking",placeValue:10},{name:"Writing",placeValue:1}];for(const e of f)e.fieldSet=t.find("[name='".concat(n,"StateWIDAScoreWAID").concat(e.name,"']")).closest("fieldset"),e.div=e.fieldSet.find(".".concat(d)),e.codeInput=e.div.find(".".concat(u)),e.div.on("eelComplete",h);function h(){let e=0;for(const t of f){const n=Number.parseInt((0,i.getValue)(t.codeInput),10);if("number"!=typeof n||Number.isNaN(n))return;e+=n*t.placeValue}(0,i.setValue)(a,p(e))}function p(e){return e.toString().padStart(4,"0")}e.on("eelComplete",function(){const t=(0,i.getValue)(e.find(".codeEELCode"));if("10"==t||"11"==t){(0,i.disable)(a);const e=Number.parseInt((0,i.getValue)(a));Number.isNaN(e)||(0,i.setValue)(a,p(e));for(const e of f)(0,i.show)(e.fieldSet);(0,i.show)(o)}else{(0,i.enable)(a);const e=Number.parseInt((0,i.getValue)(a));Number.isNaN(e)||(0,i.setValue)(a,e);for(const e of f)(0,i.getValue)(e.div)&&(0,r.clear)(e.div,!0),(0,i.hide)(e.fieldSet);(0,r.clear)(s,!0),(0,i.hide)(o)}})},onIsSubstituteInstructionalStaffLoaded:function(){$(document).on("browseLoaded.TempSubstituteAssignments",function(){$('#TempSubstituteAssignments input[id^="IsInstructionalStaff-"]').each(function(e,t){const n=$(t);n.data().hasStateReportingWAChangeEventHandler||(n.data("hasStateReportingWAChangeEventHandler","true"),n.on("change",function(){const e=t.id.split("-");if(e.length>0){const n=$("#StateTeacherIndicatorWAID-"+e[1]),a=$("#StateTeacherIndicatorWAID-"+e[1]+"_value");t.checked?t.checked&&(0,i.enable)(a):((0,i.clearValue)(n),(0,i.disable)(a))}}))})})}};(0,s.registerEvents)("statereportingwa",f)},78176(e,t,n){"use strict";n.r(t),n.d(t,{build:()=>i});var a=n(2894),o=n(88157);const r={clearCaches:function(){var e;null===(e=(0,o.getLayerFromElement)(this))||void 0===e||e.close();const t=$.ajax({url:"".concat(a.virtualDir,"SkySys/CacheVersion/ClearCaches?renderType=contentOnly"),method:"GET",dataType:"viewpartHtml"});(0,o.showDialog)("Clear Caches",t)},toggleMobileSession:async function(){await $.ajax({url:"".concat(a.virtualDir,"Security/Session/MobileSession"),type:"PATCH",data:{toggle:!a.mobileAccess}}),window.location.reload()}};function i(){const e=$.ajax({url:"".concat(a.virtualDir,"SkySys/Support/SupportTools?renderType=contentOnly"),method:"GET",dataType:"viewpartHtml"});(0,o.showDialog)("Support Tools",e,[],{draggable:!0,closeOnClick:!1,dynamicDialogContentSelector:".supportTools"})}(0,n(92214).registerEvents)("support",r)},68337(e,t,n){"use strict";n.r(t),n.d(t,{getSvg:()=>r,swapSvg:()=>i});const a={forceReload:function(){const e=this[0].querySelector("use");e.setAttribute("href",e.getAttribute("href"))}};(0,n(92214).registerEvents)("svg",a);const o="http://www.w3.org/2000/svg";function r(e,t,n){const a=function(e){const t=document.createElementNS(o,"svg"),n=document.createElementNS(o,"use");return n.setAttribute("href","#svg-".concat(e)),t.appendChild(n),$(t)}(e);return a.addClass(e.replaceAt(0,e[0].toLowerCase())).addClass("svg"),t&&a.addClass("svg"+t.replaceAt(0,t[0].toUpperCase())),n&&a.css("fill",n),a}function i(e,t,n){const a=r(t,n);return $(e).replaceWith(a),a}},80060(e,t,n){"use strict";n.r(t),n.d(t,{eventCallbacks:()=>x,registerTabFunction:()=>M});var a,o,r=n(2894),i=n(92214),s=n(49343),l=n(68337),c=n(78744);const d=window.skyward,u={},f="js-tabListItems",h="tabListItemGroupName",p="tabListItemGroup",m="tabListItem",g="current",w="js-leftMenuSidebarHeader",v="js-leftMenuSidebarSliderButton",b="js-expandAllTabListItemGroup",y="js-collapseAllTabListItemGroup",_="menuContentArea",C="contentArea",k="js-mobileToolbarControlledContent",S="tablist--collapsed",D="id",E="profileModule",P="profileId",O="clickTarget",B="isForNavigation",T={toggleLeftMenuSidebar:d.events.getCallbackStore()},x=d.events.getCallbackStoreFacadeCollection(T);function M(e,t){u[e]=t}$.extend(null!==(o=(a=d).tablist)&&void 0!==o?o:a.tablist={},{eventCallbacks:x,registerTabFunction:M});const I={init:function(e){const t=e.find(".".concat(f)),n=e.find(".".concat(h)),a=(0,c.createCollectionHandler)(n),o=e.data(B);if(r.mobileAccess){const n=e.find(".".concat(p));!function(e,n,a){const o=$("<div />",{class:"mobileTabList"}),r=$("<div />",{class:"mobileTabList__content"}),i=$("<select />",{class:"mobileTabList__select"});if(a.length){const e=$("<span />",{class:"mobileTabList__label"});a.each(function(){const t=$(this).find(".".concat(h)),n=$("<optgroup />",{label:t.text()}),a=t.attr("aria-controls");$(document.getElementById(a)).find("li.".concat(m)).each(function(){const t=$(this);t.hasClass("current")&&e.text(n.attr("label")),s(t,n)}),i.append(n)}),r.append(e)}else t.find("li.".concat(m)).each(function(){s($(this),i)});if(i.children().length){r.append(i),o.append(r);const t=e.find(".".concat(C)),a=t.find(".".concat(k));a.length?a.prepend(o):t.length?t.prepend(o):o.insertBefore(n),i.on("change",function(){const e=$(this.selectedOptions).first().data(O);e&&e.click()})}function s(e,t){const n=$("<option />").html(e.text());e.hasClass("current")&&n.prop("selected",!0),n.data(O,e),t.append(n)}}(e,e,n)}const i=parseFloat(e[0].getAttribute("data-scroll-top")||"");if(i&&!isNaN(i))t.scrollTop(i);else{const n=e.find(".".concat(m,".").concat(g)).closest(".".concat(p))[0];n&&(t[0].scrollTop=n.getBoundingClientRect().top-t[0].getBoundingClientRect().top)}t.css("visibility","visible"),N(),t.on("click",".".concat(h),function(){t.off("scroll");const e=$(this);"true"===e.attr("aria-expanded")?I(e).done(function(){j(),F(),N()}):A(e).done(function(){(function(e,t){const n=$.Deferred();t.is(":scrollable")?e.scrollintoview({duration:500,direction:"vertical",complete:function(){n.resolve()}}):n.resolve();return n.promise()})(e.closest(".".concat(p)),t).done(function(){j(),F(),N()})})}),t.on("click",".".concat(m),function(){const e=$(this).data();if(e.function.length>0)return u[e.function](this);j().then(function(t){"object"==typeof t&&null!==t&&(t.tab=e.tab,t.UrlReferrer=e.urlreferrer);return(0,s.checkLoadContent)(e.target,e.area,e.controller,e.action,e.primarykey,t,null,void 0,null,void 0,e.profilescreenid,null,null,null,{activityIndicator:{hideGlass:!0}})})});const x={getPreviousItem:function(e){var t;return(null==e?void 0:e.previousElementSibling)||(null==e||null===(t=e.parentElement)||void 0===t?void 0:t.lastElementChild)},getNextItem:function(e){var t;return(null==e?void 0:e.nextElementSibling)||(null==e||null===(t=e.parentElement)||void 0===t?void 0:t.firstElementChild)}};function M(e,t){let n;const a=d.keys.getKeyNamesFromEvent(e);switch(!0){case a.ARROW_UP:n=t.getPreviousItem(this);break;case a.ARROW_DOWN:n=t.getNextItem(this)}if(n)return n.focus(),e.preventDefault(),!1}function I(e){const t=$.Deferred();if(!("true"===e.attr("aria-expanded")))return t.resolve().promise();return $(document.getElementById(e.attr("aria-controls"))).animateClose({complete:function(){e.attr("aria-expanded","false"),(0,l.swapSvg)(e.find("svg"),"Expand","LeftMenuSidebarLI").attr("aria-hidden","true"),t.resolve()}}),t}function A(e){const t=$.Deferred();if("true"===e.attr("aria-expanded"))return t.resolve().promise();return $(document.getElementById(e.attr("aria-controls"))).animateOpen({complete:function(){e.attr("aria-expanded","true"),(0,l.swapSvg)(e.find("svg"),"Collapse","LeftMenuSidebarLI").attr("aria-hidden","true"),t.resolve()}}),t}function L(){const t=$(this);t.off("click",L);const a=[];n.each(function(){a.push(A($(this)))}),$.whenAll(a).done(function(){j(),F(),e.trigger("sidebarStateChanged"),t.on("click",L)})}function R(){const t=$(this);t.off("click",R);const a=[];n.each(function(){a.push(I($(this)))}),$.whenAll(a).done(function(){j(),F(),e.trigger("sidebarStateChanged"),t.on("click",R)})}function N(){t.debounce("scroll",function(){j()},250)}function F(){const t=e.find(".".concat(h,'[aria-expanded="true"]')).closest(".".concat(p)).toArray().map(function(e){return $(e).data(E)}),n=e.data(P);return n?$.ajax({url:"".concat(r.virtualDir,"Security/UserProfileTabStatus/Update"),type:"POST",dataType:"JSON",activityIndicator:{silent:!0},data:{profileID:n,openTabs:JSON.stringify(t)}}).promise():$.Deferred().resolve().promise()}function j(){const n=[],a=[],o=e.find(".".concat(m,".").concat(g)).data();if(null==o)return $.Deferred().resolve(void 0);const r=function(){let n={};if("detailsPanel"===o.target){const e=d.detailsPanel.getData();n=$.extend(e,n)}if(n.profileScroll=t.scrollTop(),!e.data(P)){const t=e.find(".".concat(h,'[aria-expanded="true"]')).closest(".".concat(p)),a=[];for(let e=0;e<t.length;e++)if(o.profilescreenid){const n=t.eq(e).data(E);a.push(n)}else{const n=t.eq(e).data(D);a.push(n)}a.length>0&&(n.expandedModules=a)}return n}();a.push({key:"expandedModules",value:null==r.expandedModules?null:r.expandedModules}),null!=r.profileScroll&&r.profileScroll>-1&&a.push({key:"profileScroll",value:r.profileScroll});const i=e.data();null!=i&&null!=i.profile&&a.push({key:"profile",value:i.profile});const l={id:"tabList",items:a};return n.push(l),(0,s.updatePageState)(n).then(function(){return r})}t.on("keydown",".".concat(h),function(e){return M.call(this,e,a)}),t.on("keydown",".".concat(m),function(e){const t=d.keys.getKeyNamesFromEvent(e);return t.ENTER||t.SPACE&&!o?($(this).trigger("click"),e.preventDefault(),!1):M.call(this,e,x)}),function(){const t=e.find(".".concat(w));let n=t.find(".".concat(v));if(0===t.length)return;function a(){!function(t){const i="expandedLeftMenuSidebar",s="collapsedLeftMenuSidebar";let c,d,u;t?(d=s,c=i,u="ChevronLeft"):(d=i,c=s,u="ChevronRight"),o.switchClass(d,c,r,void 0,function(){n.find("svg").replaceWith((0,l.getSvg)(u,"LeftMenuSidebar")),e.length&&e.toggleClass(S,!t),n.one("click",a),n.attr("aria-expanded",t.toString()),o.trigger("resize"),T.toggleLeftMenuSidebar.dispatchCallbacks()})}("false"===n.attr("aria-expanded"))}t.find(".".concat(b)).on("click",L),t.find(".".concat(y)).on("click",R);const o=n.closest(".".concat(_)),r=230;n.one("click",a)}()}};(0,i.registerEvents)("tablist",I)},48617(e,t,n){"use strict";n.r(t),n.d(t,{setValuePreservingUndo:()=>i});var a=n(92214);const o=new WeakSet,r={init:function(e){$(e).on("input",function(){o.add(this)})}};function i(e,t){if(!(e.length>0&&e.is("textarea")&&!e.is(":disabled,[readonly]")))return!1;const n=e[0],a=String(null!=t?t:""),r=document.activeElement;if(!o.has(n))return!1;if(n.focus({preventScroll:!0}),document.activeElement!==n)return!1;n.setSelectionRange(0,n.value.length);const i=document.execCommand("insertText",!1,a);return null!==r&&r!==n&&(r.setAttribute("data-suppress-focus","true"),r.focus({preventScroll:!0}),r.removeAttribute("data-suppress-focus")),i}(0,a.registerEvents)("textArea",r)},4659(e,t,n){"use strict";n.r(t),n.d(t,{build:()=>u});var a=n(2894),o=n(88157),r=n(49343),i=n(92214),s=n(45502),l=n(74180);const c={build:function(){u(this)}};(0,i.registerEvents)("themeSelector",c);let d=$(".".concat(s.b.ThemeStyleSheet));async function u(e){const t=$(e),n={text:"Reset to Default Theme",click:function(){const e=p.content.find(".".concat(s.b.Container));e.length>0&&e[0].dispatchEvent(new CustomEvent("resetTheme"))},icon:"Undo"},i={text:o.ButtonText.Save,click:async function(){const e=await l.s.getStateAsync("ThemeSelector");if(!e||!e.data.isLoaded)return void p.close();const n=$(".".concat(s.b.TempCSS)),o="grayscale(1)"===document.documentElement.style.filter,i=o!=e.data.nonPageableValues.applyGrayScaleFilter;if(0===n.length&&!i)return void p.close();const c=n.length>0?n.last().data(s.B.ThemeID):d.data(s.B.ThemeID);if(await $.ajax({type:"POST",dataType:"text",url:"".concat(a.virtualDir,"Common/Css/SaveUsersTheme"),data:{tid:c,applyGrayScaleFilter:o}}),n.length>0){const e=n.last();d.remove(),e.removeClass(s.b.TempCSS),e.addClass(s.b.ThemeStyleSheet),e.attr("id","ThemeCSS"),d=e}p.close();const u=t.data();u.reloadAfterSave&&(0,r.loadContent)(u.target,u.area,u.controller,u.action,u.id)},icon:o.ButtonIcon.Save},c={text:o.ButtonText.Cancel,click:"close",icon:o.ButtonIcon.Cancel},u={draggable:!0,closeOnClick:!1,dynamicDialogContentSelector:".".concat(s.b.Container),additionalContainerClasses:s.b.Modal,initialFocusElement:".".concat(s.b.ItemSelected),beforeClose:async function(){const e=await l.s.getStateAsync("ThemeSelector");if(e&&e.data.isLoaded){const t=e.data.nonPageableValues.applyGrayScaleFilter;document.documentElement.style.filter=t?"grayscale(1)":"grayscale(0)",$(".".concat(s.b.TempCSS)).remove(),$(document.body).trigger("themeSwap")}}},f=await $.ajax({type:"POST",url:"".concat(a.virtualDir,"SkySys/Theme/GetThemeSelector")}),h=$(f),p=(0,o.showDialog)("Themes",()=>h,[n,i,c],u)}},2885(e,t,n){"use strict";n.r(t),n.d(t,{setupClickEvent:()=>g});var a=n(62521),o=n(2894),r=n(88157),i=n(49343),s=n(92214);const l="dailyAttendanceTileFooter",c="dailyAttendanceMarkPresentButton",d="dailyAttendanceTakenButton",u="processing",f="anchorText",h="svg",p="tileBrowseIgnoreTileClick",m={init:function(e){const t=$(e),n=t.data();if($.isEmptyObject(n))return;g(t);const s=t.parent().find(".".concat(l," .").concat(c)),p=$("#TeacherAccessGrouping").val();if(s.length){let w=!1;var m;if($("#ConfirmPerfectAttendance").length)w="true"===(null===(m=$("#ConfirmPerfectAttendance").val())||void 0===m?void 0:m.toString().toLowerCase());function v(){var e;const t=s.parent(),o=null!==(e=t.attr("id"))&&void 0!==e?e:"";s.addClass(u);const l="#B0B0B0",c=s.find(".".concat(f));c.text("Taking Attendance..."),c.css("color",l);s.find(".".concat(h)).css("fill",l),$.when((0,i.loadContent)(o,"Attendance","DailyAttendance","MarkStudentsPresent",n.defaultrowkey,{CourseGrouping:p})).done(function(){s.remove();const e=t.find(".".concat(d));e.length&&e.one("click",function(e){(0,a.primaryButtonClick)(n.browseid,n.tilenumber,n.target,n.module,n.object,n.screen,n.defaultrowkey,null,n.postdata,e,!1)})}).fail(function(e){const t={id:"closeButton",text:r.ButtonText.Close,icon:r.ButtonIcon.Close,click:function(){n.close()}},n=(0,r.showDialog)("Error",e,[t],{id:"options"})})}function b(){w?$.ajax({url:"".concat(o.virtualDir,"Attendance/DailyAttendance/GetNumberOfOfficeAbsences/").concat(n.defaultrowkey),method:"POST",data:{CourseGrouping:p},success:function(e){if(e.isPerfectAttendance){const e={id:"confirmPerfectAttendance",text:"Yes, Confirm",click:function(){v(),a.close()},icon:r.ButtonIcon.Check},t={id:"cancelPerfectAttendance",text:"No, Cancel",click:function(){s.one("click",b),a.close()},icon:r.ButtonIcon.Cancel},n={id:"confirmPerfectAttendancePopup",width:550,closeOnClick:!1,closeOnEscape:!1},a=(0,r.showDialog)("Confirm Perfect Attendance","Are you sure you want to confirm Perfect Attendance?",[e,t],n)}else v()}}):v()}s.one("click",b)}}};function g(e){const t=e.data();e.one("click",function(n){n.target&&$(n.target).hasClass(p)?g(e):(0,a.primaryButtonClick)(t.browseid,t.tilenumber,t.target,t.module,t.object,t.screen,t.defaultrowkey,null,t.postdata,n,!1)})}(0,s.registerEvents)("tileBrowse",m)},64078(e,t,n){"use strict";n.r(t),n.d(t,{copyValue:()=>b,getParts:()=>g,getPostData:()=>v,populateBoxes:()=>w,registerTileViewEEL:()=>m,setValue:()=>y});var a=n(2894),o=n(66952),r=n(82441),i=n(917),s=n(51325),l=n(92214),c=n(49343);function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function u(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(Object(n),!0).forEach(function(t){f(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function f(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const h=window.skyward,p={init:function(e){if($(e).hasClass("eventsBound"))return;m(e)}};function m(e,t,n){var l;const d=$(e),f=d.find(".tileViewEEL_value"),p=d.find(".tileViewEEL_search"),m=d.find(".tileViewEEL_searchButton"),g=p.data();let b;const y=p.attr("id")+"_popup",_=new o.SequentialOperationHandler,C=new r.HashTransaction(f),k=f.data();k.updateBoxes=T;let S={input:p,button:m,customKeyDownHandler:function(e){const t=$("#"+y).find(".templatedResult.selected");if(0===t.length)return;const n=h.keys.getKeyNamesFromEvent(e),a=n.ARROW_LEFT||n.ARROW_UP,o=n.ARROW_RIGHT||n.ARROW_DOWN;if(!a&&!o)return;let r;r=a?t.prevAll(".templatedResult").not(".js-nonSelectableOption").first():t.nextAll(".templatedResult").not(".js-nonSelectableOption").first();return O(t,r),e.preventDefault(),!1}};S=$.extend(S,t),a.mobileAccess||(0,s.setFocusToTextBoxOnClick)(d);const D=d.findLabel();D.length&&D.attr("for",p.addIds().attr("id"));let E={key:d,valueInput:f,userInputs:[S],getSelectionListContainer:function(){const e=$("<div />",{id:y,class:"tileViewEELModalContainer anchored popup noAnchoredTail"});return e.on("click",".templatedResult:not(.ignoreClickEvent)",function(){const e=$(this);$("#"+y).find(".templatedResult.selected").removeClass("selected"),e.addClass("selected"),b.selectCurrentHighlightedValue()}),e},getSelectionList:function(e){const t=$.Deferred();return $.ajax({url:"".concat(a.virtualDir,"Common/TileViewEEL/ViewSearchResults/"),type:"POST",dataType:"JSON",activityIndicator:{hideGlass:!0},data:v(g,p,f.val(),e),success:async function(e){const n=$("<div>",{class:"columnLayoutWrapper--tileViewEEL"});if(e.toolbarHtml){const t=await(0,a.processViewPartHtml)(e.toolbarHtml),o=$("<div>",{class:"toolbar--browseControls tileviewEEL"}).append(t);n.append(o)}const o=$("<div>",{role:"listbox"}),r=p.attr("aria-labelledby");if(r&&o.attr("aria-labelledby",r),e.templatedItems.length>0){const t=d.attr("data-selected-item-key");let n=null,r=!1;const i=f.attr("id")+"-item-",s=[];for(const t of e.templatedItems){const e=await(0,a.processViewPartHtml)(t);s.push($(e))}let l=-1;for(const a of s){l++;const s=a.attr("data-id"),c=i+s;a.data("hash",e.templatedItemHashes[l]);const d=a.find(".js-labelArea");if(d.length){const e=c+"-label";d.attr("id",e),a.attr("aria-labelledby",e)}const u=a.find(".js-descriptionArea");if(u.length){const e=c+"-description";u.attr("id",e),a.attr("aria-describedby",e)}r||(s===e.selectedItemId?(n=a,r=!0):null!==n&&s!==t||(n=a)),o.append(a)}n&&(n.addClass("selected"),p.attr("aria-activedescendant",n.addIds().attr("id")))}else{const e=$("<p>",{text:"No records to display"}),t=$("<div>",{class:"noRecordsInBrowse browseRow templatedResult ignoreClickEvent selectorElementsCenter"}).append(e);o.append(t)}n.append(o),t.resolve(n)},error:function(){t.reject()}}),t.promise()},selectionListPositioningOptions:{getRows:function(){return $("#"+y).find(".templatedResult, .toolbar--browseControls.tileviewEEL")},getHeaderRow:function(){return $("#"+y).find(".templatedResult").first()}},setCurrentEnteredValue:function(e){return _.run(e=>C.run(e,async()=>{const t=await(0,r.waitForDependencies)(p.data(),(0,i.getScopeContainer)(p),e);await $.ajax({url:"".concat(a.virtualDir,"Common/TileViewEEL/ValidateText/"),type:"POST",dataType:"JSON",data:v(g,p,void 0,void 0,t),signal:e,success:function(e){if(!e.isValid)return f.data().selectedValueHash="",void T(null);w(d,e,e.id),d.trigger("eelComplete")},error:function(){e.aborted||T(null)}})}))},setCurrentHighlightedValue:function(){T($("#"+y).find(".templatedResult.selected").attr("data-id"))},clearValues:function(){p.val()?T(f.val()):T(null)}};const P=(null!==(l=f.data("original-name"))&&void 0!==l?l:f.attr("name")).replace(/_value$/,"");f[0].readOnly||function(e,t,n,a){var o,i;const s=(0,r.getRequestDataHash)(e,t);if(!s)return;n.requestDataHash=s.hash,n.dynamicFilterHashes=u({},s.dependencies),a.originalSelectedValueHash=null!==(o=s.initialValueHash)&&void 0!==o?o:"",a.selectedValueHash=null!==(i=s.initialValueHash)&&void 0!==i?i:""}(g.requestDataHashSrc,P,g,f.data()),E=$.extend(E,n),E.onSelectionListLoad=function(){var e;const t=$("#"+y),a=t.find(".templatedResult.selected");t.outerHeight(t.outerHeight()+2),B(a),(0,c.notifyDOMLoad)(t),null==n||null===(e=n.onSelectionListLoad)||void 0===e||e.call(n)},E.beforeOpen=function(){var e;p.attr("aria-expanded","true"),p.attr("aria-controls",y),m.attr("aria-controls",y),null==n||null===(e=n.beforeOpen)||void 0===e||e.call(n)},E.beforeClose=function(){var e;p.attr("aria-expanded","false"),p.removeAttr("aria-controls"),m.removeAttr("aria-controls"),null==n||null===(e=n.beforeClose)||void 0===e||e.call(n)},b=(0,s.createEel)(E),d.addClass("eventsBound"),f.trigger("controlLoaded");return{tileViewEEL:d,hiddenValue:f,searchBox:p,searchButton:m,eel:b};function O(e,t){const n=$("#"+y);t&&0!==t.length&&0!==n.length&&(e.removeClass("selected"),t.addClass("selected"),p.attr("aria-activedescendant",t.addIds().attr("id")),B(t))}function B(e){e.scrollintoview({duration:0,direction:"vertical",viewPadding:{y:0}})}function T(e){return _.run(async function(t){if(!e)return f.data().selectedValueHash="",void w(d,{search:""},"");if(e==k.originalValue)return void w(d,{search:g.originalValue,selectedValueHash:k.originalSelectedValueHash},e);const n=await(0,r.waitForDependencies)(p.data(),(0,i.getScopeContainer)(p),t);await $.ajax({url:"".concat(a.virtualDir,"Common/TileViewEEL/ValidateSelection/"),type:"POST",dataType:"JSON",data:v(g,p,e,void 0,n),signal:t,success:function(n){t.aborted||(w(d,n,e),d.trigger("eelComplete"))},error:function(){t.aborted||w(d,{search:""},"")}})})}}function g(e){return{value:e.find(".tileViewEEL_value"),searchBox:e.find(".tileViewEEL_search")}}function w(e,t,n){var a;let o=arguments.length>3&&void 0!==arguments[3]&&arguments[3];const r=e.find(".tileViewEEL_search");r.val(t.search||""),r.data().currentValue=t.search||"";const i=e.find(".tileViewEEL_value");i.val(n),i.data().selectedValueHash=null!==(a=t.selectedValueHash)&&void 0!==a?a:"",o||i.trigger("change")}function v(e,t,n,a){let s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:(0,r.getDependencyDataWithoutWaiting)(t.data(),(0,i.getScopeContainer)(t));return{requestDataHash:e.requestDataHash,area:e.area,controller:e.controller,templateName:e.templateName,postData:JSON.stringify(u(u({},e.postdata),{},{filter:JSON.stringify(e.filter)})),pageStateControlValues:t.attr("name"),searchText:(0,o.encodeHtml)(t.val()),dynamicFilterHashes:JSON.stringify(e.dynamicFilterHashes),dynamicFilterValues:JSON.stringify(s),id:n,includeSubsequentRecords:a,queryParameterData:JSON.stringify(e.queryParameterData)}}function b(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];const a=e.find(".tileViewEEL_search"),o=e.find(".tileViewEEL_value"),r=o.data("selectedValueHash"),i={search:a.val(),selectedValueHash:r},s=o.val();w(t.closest(".tileViewEEL"),i,s,n)}async function y(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];const a=$(e),o=a.find(".tileViewEEL_value");if(null==t||"string"==typeof t&&""===t.trim())return o.data().selectedValueHash="",void w(a,{search:""},"",n);const r=o.data();await r.updateBoxes(t,n),n||o.trigger("change")}(0,l.registerEvents)("tileViewEEL",p)},84398(e,t,n){"use strict";n.r(t),n.d(t,{closeModal:()=>S});var a=n(74061),o=n(81484),r=n(81975),i=n(90121),s=n(98925),l=n(75552),c=n(32529),d=n(20960);const u="dateTimePickerModal",f="dateTimePickerModal--time",h=(0,a.defineComponent)({name:"timePickerModal",emits:{"update:time":e=>!0},props:{close:(0,l.oY)(Function),inputRef:(0,l.oY)(Object),time:(0,l.oY)(Object)},setup(e,t){var n;const o=(0,a.useModel)(e,"time"),i=(0,a.ref)(o.value.hour),s=(0,a.ref)(o.value.minute),h=(0,a.ref)(null!==(n=o.value.amPm)&&void 0!==n?n:"AM"),p=(0,a.ref)(),m=(0,a.ref)();return t.expose({focusHourInput(){var e;null===(e=m.value)||void 0===e||e.focusHourInput()},focusMinuteInput(){var e;null===(e=m.value)||void 0===e||e.focusMinuteInput()},focusAmPmToggle(){var e;null===(e=m.value)||void 0===e||e.focusAmPmToggle()}}),(0,l.xF)(document.body,"keydown",async function(t){const n=t.key.toUpperCase();switch(n){case"ARROWUP":case"ARROWDOWN":case"PAGEUP":case"PAGEDOWN":case"HOME":case"END":t.preventDefault();break;case"C":case"T":case"N":return void await v()}if(t.altKey&&("ARROWUP"===n||"ARROWDOWN"===n)){var a;return void(null===(a=e.inputRef.value)||void 0===a||a.focus())}}),(0,l.xF)(document.body,"keypress",function(e){"ENTER"===e.key.toUpperCase()&&g()}),()=>(0,a.createVNode)("div",{class:[u,f],ref:p},[(0,a.createVNode)(d.A,{ref:m,hour:i.value,minute:s.value,amPm:h.value,"onUpdate:hour":e=>i.value=e,"onUpdate:minute":e=>s.value=e,"onUpdate:amPm":e=>h.value=e},null,8,["hour","minute","amPm","onUpdate:hour","onUpdate:minute","onUpdate:amPm"]),(0,a.createVNode)(c.A,{buttonText:"Now",onButtonClick:w,onDoneClick:g},null,8,["onButtonClick","onDoneClick"])],2);function g(){!function(){if((void 0===i.value||isNaN(i.value))&&(void 0===s.value||isNaN(s.value))){const e={hour:void 0,minute:void 0,amPm:void 0};return void(o.value=e)}const e={hour:void 0===i.value||isNaN(i.value)?12:i.value,minute:void 0===s.value||isNaN(s.value)?0:s.value,amPm:h.value};o.value=e}(),e.close()}async function w(){await v(),g()}async function v(){const e=(0,r.now)(),t=e.getHours();i.value=(0,r.convertTo12Hour)(t),h.value=t>=12?"PM":"AM",s.value=e.getMinutes(),await(0,a.nextTick)()}}}),p="timePicker",m="dateTimePicker__svg";var g=function(e){return e.Hour="H",e.Minute="M",e.AmPm="X",e}(g||{});const w=(0,a.defineCustomElement)({name:"sky-timepicker",shadowRoot:!1,inheritAttrs:!1,props:{name:(0,l.uh)(String),value:{type:String,required:!1,default:null,validator(e){const t=b(e);return!e||"string"==typeof e&&t}},autocomplete:(0,l.uh)(String),dependents:(0,l.uh)(Object),ariaLabelledby:(0,l.uh)(String),contained:(0,l.uh)(Boolean)},setup(e,t){const n=(0,a.ref)(),l=(0,a.ref)(),c=(0,o.getIdGenerator)("popup","_timePicker");let d=(0,a.useHost)();const u=()=>{var e;d||(d=null===(e=n.value)||void 0===e?void 0:e.closest("sky-timepicker"));return d},f=()=>{var e;return"true"===(null===(e=u())||void 0===e||null===(e=e.getAttribute("aria-readonly"))||void 0===e?void 0:e.toLowerCase())},w=(0,a.ref)(f()),v=()=>{var e;return(null===(e=u())||void 0===e?void 0:e.id)||void 0},S=(0,a.ref)(v()),D=(0,a.computed)({get:()=>e.value,set:e=>{const t=u();t&&(t.value=e)}});(0,a.watch)(()=>e.value,e=>{!e||"string"==typeof e&&b(e)||(D.value="")},{flush:"sync",immediate:!0});const E=(0,a.ref)(function(e){let t=e;if(t.includes("/")){const e=t.indexOf(" ");t=t.substring(e)}const n={hour:y(t),minute:_(t),amPm:C(t)};return n}(e.value));(0,a.watch)(()=>E.value,async e=>{var t;if(void 0===e.hour||null==e.minute||null==e.amPm)e.amPm=void 0,e.hour=void 0,e.minute=void 0,D.value="";else{const t=k(e);D.value=t}await(0,a.nextTick)();const n=new CustomEvent("change",{bubbles:!0,detail:{internal:!0}});null===(t=u())||void 0===t||t.dispatchEvent(n)},{deep:!0});const P=(0,a.ref)(!1);(0,a.watch)(()=>P.value,e=>{l.value=e?c.getNewId():void 0});const O=async()=>{var e,t;P.value="closing",await(0,a.nextTick)(),null===(e=n.value)||void 0===e||e.focus(),P.value=!1,null===(t=n.value)||void 0===t||t.setSelectionRange(0,n.value.value.length)};t.expose({_closeModal:O}),(0,a.onBeforeMount)(()=>{S.value&&$.findLabel(S.value).attr("for","".concat(S.value,"_input"))});const B=new MutationObserver(()=>{w.value=f(),S.value=v()});(0,a.onMounted)(()=>{var t,a;e.ariaLabelledby&&(null===(t=n.value)||void 0===t||t.setAttribute("aria-labelledby",e.ariaLabelledby),null===(a=u())||void 0===a||a.removeAttribute("aria-labelledby"));const o=u();o&&B.observe(o,{attributes:!0,attributeFilter:["aria-readonly","id"]})}),(0,a.onUnmounted)(()=>{B.disconnect()});const T=(0,a.ref)();return()=>{var t;return(0,a.createVNode)(a.Fragment,null,[(0,a.createVNode)("input",{type:"text",class:p,placeholder:"HH:MM XM",readonly:w.value,autocomplete:null!==(t=e.autocomplete)&&void 0!==t?t:"off",ref:n,onClick:H,onFocusin:L,onInput:V,onBeforeinput:j,onChange:R,onKeydown:F,onKeypress:N,onPaste:A,value:D.value,id:S.value?"".concat(S.value,"_input"):void 0,"data-dependents":JSON.stringify(e.dependents),"aria-expanded":!0===P.value,"aria-haspopup":"dialog","aria-controls":l.value},null,42,["readonly","autocomplete","onClick","onFocusin","onInput","onBeforeinput","onChange","onKeydown","onKeypress","onPaste","value","id","data-dependents","aria-expanded","aria-controls"]),!0===P.value&&(0,a.createVNode)(i.A,{expose:[x()],anchorTo:x(),preserveFocus:e=>"escape"===e,onClose:()=>{O()}},{default:()=>[(0,a.createVNode)(h,{ref:T,id:l.value,inputRef:n,close:O,time:E.value,"onUpdate:time":e=>{E.value=e}},null,8,["id","inputRef","close","time","onUpdate:time"])]},8,["expose","anchorTo","preserveFocus","onClose"]),(0,a.createVNode)(s.A,{name:"Time","aria-haspopup":"menu",role:"button",showHoverEffect:!1,class:m,onClick:()=>function(e){if(!0===P.value)return void O();G(e)}("svg click"),isButton:!w.value,"aria-label":"Time Picker"},null,8,["class","onClick","isButton"])])};function x(){const t=n.value.parentElement;return e.contained?t.parentElement:t}function M(e){if(""===e){const e={hour:void 0,minute:void 0,amPm:void 0};return E.value=e,void(n.value.value="")}const{hour:t,minute:a}=I(e),o=e.split(" "),i=e.split(":");let s;const l=(0,r.convertTo12Hour)(t);if(l!==t&&(s=t>=12?"PM":"AM"),2==o.length){const e=o[1];"PM"!==e&&"AM"!==e||(s=e)}else s||(s=i[0].startsWith("0")||l>5&&12!==l?"AM":"PM");const c={hour:l,minute:a,amPm:null!=s?s:"PM"};E.value=c,n.value.value=k(c)}function I(e){const t=e.replace(/[^\d:]/g,"").split(":");let n=0,a=0;return t.length>0&&(n=parseInt(t[0])),t.length>1&&(a=parseInt(t[1].padEnd(2,"0"))),{hour:n,minute:a}}function A(e){var t;e.preventDefault();const n=null===(t=e.clipboardData)||void 0===t?void 0:t.getData("text/plain"),a=new Date("1/1/2000 "+n);if(!n||!a.isValidDate())return!1;const o=a.getHours(),r=o>=12?"PM":"AM";return M("".concat(o%12||12,":").concat(a.getMinutes()," ").concat(r)),!1}function L(e){var t;const n=e.target;var a;if("true"===n.getAttribute("data-suppress-focus")||"true"===(null===(t=u())||void 0===t?void 0:t.getAttribute("data-suppress-focus")))return n.removeAttribute("data-suppress-focus"),void(null===(a=u())||void 0===a||a.removeAttribute("data-suppress-focus"));G("focusin")}function R(e){e.preventDefault(),e.stopPropagation();M(n.value.value)}function N(e){const t=e.key.toUpperCase();e.target===n.value&&("P"!==t&&"A"!==t||e.stopPropagation())}function F(e){var t,a,o;const i=e.key.toUpperCase();if(!P.value&&e.altKey&&("ARROWDOWN"===i||"ARROWUP"===i))return e.preventDefault(),void G("keypress");if(w.value)return;const s=e.target.selectionStart,l=e.target.selectionEnd,{hour:c,minute:d}=I(e.target.value);switch(i){case"P":if(c!=E.value.hour||d!=E.value.minute)return;return void(E.value.amPm="PM");case"A":if(c!=E.value.hour||d!=E.value.minute)return;return void(E.value.amPm="AM");case"C":case"T":case"N":return function(){const e=(0,r.now)(),t=e.getHours(),n={hour:(0,r.convertTo12Hour)(t),minute:e.getMinutes(),amPm:t>=12?"PM":"AM"};E.value=n}(),void e.stopPropagation();case"ARROWRIGHT":case"ARROWLEFT":return e.preventDefault(),e.stopPropagation(),void W("ARROWLEFT"===i,"ARROWRIGHT"===i,s,l);case"ENTER":return e.preventDefault(),e.stopPropagation(),P.value=!1,void M(n.value.value);case"TAB":return P.value=!1,void M(n.value.value);case"ARROWUP":case"ARROWDOWN":if(e.preventDefault(),e.stopPropagation(),s>0&&l>0){switch(U(s,l)){case g.Hour:null===(t=T.value)||void 0===t||t.focusHourInput();break;case g.Minute:null===(a=T.value)||void 0===a||a.focusMinuteInput();break;case g.AmPm:null===(o=T.value)||void 0===o||o.focusAmPmToggle()}}else{var u;null===(u=T.value)||void 0===u||u.focusHourInput()}}}function j(e){var t;const n=e,a=null===(t=n.data)||void 0===t?void 0:t.toUpperCase(),o=e.target;if(a){if(isNaN(parseInt(a))){if(":"===a&&!o.value.includes(":")&&o.value.length>0)return;if("P"===a&&!o.value.includes("P")&&o.value.length>0)return;if("A"===a&&!o.value.includes("A")&&o.value.length>0)return;return void n.preventDefault()}{const e=o.value.replace(/[^\d:]/g,""),t=o.selectionEnd,r=o.selectionStart;if(t-r===o.value.length)return;const i=e.split(":");let s=3,l=5;i.length>0&&(s=i[0].length+1,l=s+2);const c=U(r,t);if(i.length>1&&r>=s&&t<=l){parseInt(i[1]);const e=parseInt(a);if(r===s&&t===l&&e<6)return}else if(c===g.AmPm&&"P"!==a&&"A"!==a)return void n.preventDefault()}}}async function V(e){var t;const n=e.target;let o=n.selectionEnd;const r=n.value.replace(/[^\d:]/g,""),i=null!==(t=e.data)&&void 0!==t?t:"",s=i.toUpperCase(),l=n.value.split(" ");let c,d=!1;if("P"===s)d=!0,c="PM";else if("A"===s)d=!0,c="AM";else if(2==l.length){const e=l[1];"PM"!==e&&"AM"!==e||(c=e)}else n.value.toUpperCase().endsWith("P")?(d=!0,c="PM"):n.value.toUpperCase().endsWith("A")&&(d=!0,c="AM");const u=r.split(":");if(d&&(u.length>0&&(u[0]=u[0].padStart(2,"0")),u.length>1?u[1]=u[1].padStart(2,"0"):u[1]="00"),u.length>2){e.preventDefault();let t=r.slice(0,o);return t=t.slice(0,t.length-i.length)+r.slice(o),n.value=t,o-=i.length,void n.setSelectionRange(o,o)}let f="";if(u.length>0){const e=u[0];if(e.startsWith("0")||e.startsWith("1")||e.startsWith("2"))if(e.startsWith("2")){const t=e.slice(1);let n=!1;if(t&&1===t.length){parseInt(t)>3&&(n=!0,f=e.slice(1),u[0]=e.slice(0,1),f.length>0&&u.length>=2&&(u[1]="".concat(f).concat(u[1])))}n||(f=e.slice(2),u[0]=e.slice(0,2))}else f=e.slice(2),u[0]=e.slice(0,2);else f=e.slice(1),u[0]=e.slice(0,1),f.length>0&&u.length>=2&&(u[1]="".concat(f).concat(u[1]));f.length>0&&u.length<2&&u.push(f)}u.length>1&&(f.length>0?(u[1]=f+u[1].slice(1,2),o=4):u[1]=u[1].slice(0,2),1===u[1].length&&parseInt(u[1])>5?(u[1]=u[1].padStart(2,"0"),o++):2===u[1].length&&parseInt(u[1])>59&&(u[1]=i.padStart(2,"0"),o++));let h=o,p=u.join(":");c&&(p+=" ".concat(c)),n.value=p,await(0,a.nextTick)(),"P"!==s&&"A"!==s||(h=n.value.length,o=n.value.length),n.setSelectionRange(h,o)}function H(e){W(!1,!1,e.target.selectionStart,e.target.selectionEnd)}function W(e,t,a,o){if(-1===n.value.value.replace(/[^\d:]/g,"").indexOf(":"))return;const r=U(a,o);if(a!=o)if(t)switch(r){case g.Hour:K(g.Minute);break;case g.Minute:K(g.AmPm);break;case g.AmPm:K(g.Hour)}else if(e)switch(r){case g.Hour:K(g.AmPm);break;case g.Minute:K(g.Hour);break;case g.AmPm:K(g.Minute)}else K(r);else K(r)}function U(e,t){const a=n.value,o=a.value.replace(/[^\d:]/g,"").indexOf(":"),r=a.value.indexOf(" ");return q(a,e,t,0,o)?g.Hour:-1!==r&&q(a,e,t,r+1,a.value.length)?g.AmPm:g.Minute}function K(e){const t=n.value,a=t.value.replace(/[^\d:]/g,""),o=a.indexOf(":"),r=t.value.indexOf(" "),i=a.length;let s=null,l=null;switch(e){case g.Hour:s=0,l=-1!==o?o:i,t.setSelectionRange(s,l);break;case g.Minute:-1!==o&&(s=o+1,t.setSelectionRange(s,-1===r?i:r));break;case g.AmPm:-1!==r&&(s=r+1,t.setSelectionRange(s,t.value.length))}}function q(e,t,n,a,o){return t>=a&&n<=o}function G(e){var t;w.value||!1!==P.value||(P.value=!0,null===(t=d)||void 0===t||t.scrollIntoView({block:"nearest"}),"svg click"===e&&n.value&&n.value.focus())}}});const v=class extends w{connectedCallback(){this._instance||(this.innerHTML=""),super.connectedCallback()}closeModal(){const e=this._closeModal;if("function"==typeof e)return e()}};function b(e){if(""==e)return!0;return/^(0[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/.test(e)}function y(e){const t=e.replace(/[^\d:]/g,"").split(":");if(t.length>0)return parseInt(t[0])}function _(e){const t=e.replace(/[^\d:]/g,"").split(":");if(t.length>1)return parseInt(t[1])}function C(e){const t=e.split(" ");if(t.length>1)return t[1]}function k(e){return"".concat(String(e.hour).padStart(2,"0"),":").concat(String(e.minute).padStart(2,"0")," ").concat(e.amPm)}function S(e){const t=e.closest("sky-timepicker");t.length>0&&t[0].closeModal&&t[0].closeModal()}customElements.define("sky-timepicker",v)},742(e,t,n){"use strict";n.r(t),n.d(t,{englishCanaryText:()=>c,onTranslated:()=>l});var a,o=n(2894),r=n(29711);const i=window.skyward,s=(0,r.getCallbackStore)(),l=(0,r.getCallbackStoreFacade)(s),c="My hovercraft is full of eels.";(null!==(a=window.requestIdleCallback)&&void 0!==a?a:e=>setTimeout(e,2500))(()=>{const e=$("title"),t=$("#translationCanary");let n=document.documentElement.lang,a=t.text(),r=null;const l=new MutationObserver(u);let d;function u(){var o;const l=document.documentElement.lang,u=null!==(o=e.attr("_msttexthash"))&&void 0!==o?o:null,m=t.text();if(n!==l||r!==u||a!==m){n=l,r=u,a=m;const e=!/en\b/.test(n)&&"auto"!=n,t=a!==c,o=e||t||null!=r;(e||t)&&(d={lang:n,canary:m},p(),i.detailsPanel&&(h(),i.detailsPanel.eventCallbacks.contentLoaded.registerCallback(e=>h(e))),i.workflow&&(f(),$(window).on("workflow-contentLoaded.translationDetector",()=>{f()}))),o&&s.dispatchCallbacks()}}function f(){const e=i.workflow.getTopMostWorkflowData();if(e){const{module:t,object:n,screen:a}=e;p({module:t,object:n,screen:a})}}function h(e){if(null!=e||(e=i.detailsPanel.isDetailsPanelOpen()?i.detailsPanel.getData():null),e){const{module:t,object:n,screen:a}=e;p({module:t,object:n,screen:a})}}function p(e){$.ajax("".concat(o.virtualDir,"SkySys/UserTranslation/Log"),{method:"POST",data:$.extend({},d,e),suppressErrors:!0,activityIndicator:{silent:!0}})}l.observe(document.documentElement,{attributes:!0,attributeFilter:["lang"]}),l.observe(e[0],{attributes:!0,attributeFilter:["_msthash"]}),l.observe(t[0],{characterData:!0,subtree:!0}),u()})},42980(e,t,n){"use strict";n.r(t),n.d(t,{clearSelectedRecord:()=>he,getSelectedFieldData:()=>fe,getTreeBrowseContainer:()=>se,getTreeBrowseData:()=>de,getTreeBrowseDataByName:()=>ue,seekToField:()=>ce,setBrowseTarget:()=>le});var a=n(2894),o=n(88157),r=n(49343),i=n(66952),s=n(92214),l=n(22528),c=n(74061),d=n(79126),u=n(75552);const f="treebrowserow",h="jsDraggable",p="fieldspan",m="selected",g="column_content",w="treeBrowse",v="treeBrowseSectionHeader",b="selectable",y="nowrap",_="field",C="jsOneToManyDraggable",k="relationship",S="treebrowse__treeGridTable",D="js-treebrowse__treeGridTable",E="breadcrumbspan",P="breadcrumblabel",O="treebreadcrumb",B="breadcrumbList",T="js-breadcrumbList",x="recordDoubleClick",M="recordSelected",I="recordMounted";function A(e){return(0,c.defineComponent)({name:e.name,props:{field:(0,u.oY)(),originalField:(0,u.oY)(),selected:(0,u.JJ)(!1)},emits:{[I]:(0,u.c5)(),[M]:(0,u.c5)(),[x]:(0,u.c5)()},setup(t,n){const a=t,o=(0,c.ref)();return(0,c.onMounted)(()=>{n.emit(I,o.value)}),n.expose({field:(0,c.toRef)(a,"field"),originalField:(0,c.toRef)(a,"originalField"),fieldKey:()=>e.fieldKey(a.field),formatField:()=>e.formatField(a.field)}),()=>{var t;return(0,c.createVNode)("tr",(0,c.mergeProps)({class:{[m]:a.selected},onClick:()=>n.emit(M,a.field),onDblclick:()=>n.emit(x,a.field),ref:o,style:{fontWeight:a.field!==a.originalField?"bold":"normal"}},e.additionalRowAttributes(a.field)),[n.slots.default({field:a.field,nameCell:e.nameCell(a.field),parametersCell:null===(t=e.parametersCell)||void 0===t?void 0:t.call(e,a.field),typeIcon:e.typeIcon(a.field)})],16,["onClick","onDblclick"])}},fieldKey:e.fieldKey})}const L=A({name:"aggregateField",additionalRowAttributes:()=>({class:[f,h,p]}),nameCell:e=>(0,c.createVNode)("td",null,[(0,c.createVNode)("span",{class:{[g]:!0,[w]:!0,[v]:!0,[b]:!0,[y]:!0,[_]:!0}},[R(e)])]),typeIcon:e=>window.skyward.reporting.getSvgNameByDataType(e.fieldType),fieldKey:e=>"aggregate_"+e.columnId,formatField:function(e){return{sourceColumnId:e.columnId,columnFieldType:e.fieldType,heightMultiplier:e.maxWidth/e.maxHeight,widthMultiplier:e.maxHeight/e.maxWidth,displayName:e.designerText,fieldName:e.absoluteFieldPath}}});function R(e){return e.aggregateType?"".concat(e.aggregateType,": ").concat(e.designerText):e.designerText}const N=A({name:"calculatedField",additionalRowAttributes:e=>({class:[f,h,"calculatedField"],"data-fieldid":e.id,"data-field-type":e.dataType,"data-display-path-text":e.fieldName,"data-svg-class":F(e.dataType)}),nameCell:e=>(0,c.createVNode)("td",null,[(0,c.createVNode)("span",null,[e.fieldName])]),typeIcon:e=>F(e.dataType),fieldKey:e=>e.id,formatField:function(e){return{fieldType:e.dataType,displayPathText:e.fieldName,isCalculatedField:!0}}});function F(e){if(-1!=(null==e?void 0:e.indexOf("GroupColumn")))return"Columns";switch(null==e?void 0:e.split(" ")[0]){case"Number":return"Number";case"String":return"TextCharacter";case"OneToMany":return"OneToMany";case"ManyToOne":return"ClosedFolderAlt";case"Boolean":return"CheckBox";case"Time":case"DateTime":return"Date";case"TimeSpan":return"Timespan";case"Image":return"InsertImage";case"List":return"List";default:return"NoImage"}}const j=A({name:"dataField",additionalRowAttributes:()=>({class:["treebrowserow","jsDraggable","fieldspan"]}),nameCell:e=>(0,c.createVNode)("td",null,[(0,c.createVNode)("span",{class:{[g]:!0,[w]:!0,[v]:!0,[b]:!0,[y]:!0,[_]:!0}},[e.displayName]),e.isCalculated||e.isOperation?"*":null]),parametersCell:e=>{var t;return(0,c.createVNode)("td",null,[(0,c.createVNode)("input",{type:"checkbox",disabled:!0,checked:(null===(t=e.parameters)||void 0===t?void 0:t.length)>0},null,8,["checked"])])},typeIcon:e=>e.svgClass,fieldKey:e=>e.fieldPath,formatField:function(e){return{fieldType:e.format,fieldName:e.fieldPath,fieldModule:e.moduleName,fieldObject:e.objectName}}});const V=A({name:"environmentVariableField",additionalRowAttributes:()=>({class:[f,h,p]}),nameCell:e=>(0,c.createVNode)("td",null,[(0,c.createVNode)("span",null,[e.displayName])]),parametersCell:()=>(0,c.createVNode)("td",null,[(0,c.createVNode)("input",{type:"checkbox",disabled:!0,checked:!1},null)]),typeIcon:e=>e.svgClass,fieldKey:e=>e.fieldName,formatField:function(e){return{fieldType:e.format,fieldName:e.fieldName,pageSectionColumnType:"EnvironmentVariable",fieldWidth:void 0,fieldHeight:void 0}}});var H=n(98925);const W=(0,c.defineComponent)({name:"treeBrowseSection",props:{showHeader:(0,u.JJ)(!0),columns:(0,u.oY)(Array)},render(){var e,t;const n=(0,c.createVNode)("thead",null,[this.columns.map(e=>(0,c.createVNode)("th",{class:["treebrowse__headerCell",e.class],colspan:e.columns.length,style:{width:e.width}},[e.header],14,["colspan"]))]);return(0,c.createVNode)("table",{class:{[S]:!0,[D]:!0}},[this.showHeader?n:null,(0,c.createVNode)("tbody",null,[null===(e=(t=this.$slots).default)||void 0===e?void 0:e.call(t)])])}});function U(){return"".concat(25*(arguments.length>0&&void 0!==arguments[0]?arguments[0]:1),"px")}function K(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function q(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?K(Object(n),!0).forEach(function(t){G(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):K(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function G(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const z={dataField:j,relationshipField:A({name:"relationshipField",additionalRowAttributes(e){const t="OneToMany"===e.relationshipType;return{class:{[f]:!0,[C]:t}}},nameCell:e=>(0,c.createVNode)("td",null,[(0,c.createVNode)("span",{class:{[b]:!0,[k]:!0,[v]:!0}},[e.relationshipName])]),typeIcon:e=>e.svgClass,fieldKey:e=>e.fieldPath,formatField:function(e){return{fieldType:e.relationshipType,fieldName:e.fieldPath,fieldModule:e.moduleName,fieldObject:e.objectName,isOneToMany:"OneToMany"===e.relationshipType,relationshipPath:e.fieldPath.substring(e.fieldPath.indexOf(".")+1),isRelationship:!0}}}),environmentVariableField:V,calculatedField:N,aggregateField:L},J={showHeader:!0,showParametersColumn:!1,showEyeColumn:!1,sections:[],additionalSections:[],onRowMounted:e=>{}},Y=(0,c.defineComponent)({name:"treeBrowse",props:{},emits:{recordDoubleClick:(0,u.c5)(),recordSelected:(0,u.c5)()},computed:{allSections(){return this.sections.concat(this.additionalSections)},selectedField(){var e;return null===(e=this.__selectedRecord)||void 0===e?void 0:e.field},__selectedRecord(){return this.__allRecordsByFieldKey.get(this.selectedFieldKey)},modifiedFields(){return this.__modifiedFields}},data:()=>q({selectedFieldKey:void 0,__allRecordsByFieldKey:new Map,__modifiedFields:new Map},J),watch:{onRowMounted:function(e){e&&this.__allRecordsByFieldKey.forEach(t=>{e(t.$el)})},__selectedRecord:{handler:function(e,t){t&&!e&&(this.selectedFieldKey=void 0)},flush:"post"}},render(){const e=[],t=this.allSections.some(e=>{var t;return null===(t=e.rows)||void 0===t?void 0:t.some(e=>e.showShield)}),n=this.allSections.some(e=>{var t;return null===(t=e.rows)||void 0===t?void 0:t.some(e=>e.hasDescription)}),a=function(e){let{showEyeColumn:t,anyRowHasShield:n,anyRowHasDescription:a,showParametersColumn:o}=e;const r={header:"",columns:[]},i=[r];return n&&r.columns.push(e=>{let{field:t}=e;return(0,c.createVNode)("td",{style:{width:U()}},[(0,c.createVNode)(H.A,{name:"AdvancedSecurity",type:"TreeBrowse",style:{visibility:t.showShield?"visible":"hidden"}},null,8,["style"])],4)}),t&&r.columns.push(e=>{let{field:t}=e;const n=t;return(0,c.createVNode)("td",{style:{width:U()}},[(0,c.createVNode)(H.A,{name:n.showEye?"Eye":"Hide",style:{visibility:"boolean"==typeof n.showEye?"visible":"hidden"}},null,8,["name","style"])],4)}),a&&r.columns.push(e=>{let{field:t}=e;return void 0===t?(0,c.createVNode)("td",{style:{width:U()}},[(0,c.createVNode)(H.A,{name:"Info",type:"TreeBrowse",style:{visibility:"hidden"}},null),(0,c.createTextVNode)(";")],4):(0,c.createVNode)("td",{style:{width:U()}},[(0,c.createVNode)("span",null,[(0,c.createTextVNode)(" "),(0,c.createVNode)(H.A,{name:"Info",type:"TreeBrowse",style:{visibility:t.hasDescription?"visible":"hidden"},"data-click-action":"fieldInformation.click","data-module":"SkySys","data-object":"Browse","data-screen":"FieldInformationPopup","data-field-module":t.moduleName,"data-field-object":t.objectName,"data-field":t.fieldName},null,8,["style","data-field-module","data-field-object","data-field"])])],4)}),r.columns.push(e=>{let{typeIcon:t}=e;return(0,c.createVNode)("td",{style:{width:U()}},[(0,c.createVNode)(H.A,{name:t||"NoImage",type:"TreeBrowse",showHoverEffect:!1,style:{visibility:t?"visible":"hidden"}},null,8,["name","style"])],4)}),r.width=U(r.columns.length),i.push({header:"Field",columns:[e=>{let{nameCell:t}=e;return t}]}),o&&i.push({header:"Has Parameters",width:U(),columns:[e=>{let{parametersCell:t}=e;return null!=t?t:(0,c.createVNode)("td",null,null)}]}),i}({showEyeColumn:this.showEyeColumn,anyRowHasShield:t,anyRowHasDescription:n,showParametersColumn:this.showParametersColumn}),o=a.reduce((e,t)=>e+t.columns.length,0);for(let t=0;t<this.allSections.length;t+=1){const n=this.allSections[t];if(!n.rows)continue;const r="string"==typeof n.component?z[n.component]:n.component,i=n.rows.map(e=>{const t=r.fieldKey(e),o=this.__modifiedFields.get(t);return(0,c.h)(r,{key:"".concat(n.key,"-").concat(t),ref:e=>{e?this.__allRecordsByFieldKey.set(t,e):this.__allRecordsByFieldKey.delete(t)},field:null!=o?o:e,originalField:e,selected:this.selectedFieldKey===t,onRecordSelected:()=>this.__handleRecordSelected(t),onRecordDoubleClick:()=>this.$emit(x,this.__formatFieldData(t)),onRecordMounted:e=>{var t;return null===(t=this.onRowMounted)||void 0===t?void 0:t.call(this,e)}},{default:e=>a.flatMap(e=>e.columns).map(t=>t(e))})});n.container?e.push((0,c.createVNode)(c.Teleport,{to:n.container,key:n.key},{default:()=>[(0,c.createVNode)(W,{showHeader:!1,columns:a},{default:()=>[this.__buildTitle(n,o),i],_:2},8,["columns"])]},8,["to"])):(e.length>0&&n.rows.length&&e.push(this.__buildTitle(n,o)),e.push(...i))}return(0,c.createVNode)(W,{showHeader:this.showHeader,columns:a},{default:()=>[e],_:2},8,["showHeader","columns"])},methods:{selectRecord(e){var t;let n,a=e,o=!1;if(null!==e){if(0===arguments.length&&console.warn("Calling treebrowse.selectRecord(undefined) is deprecated. Use selectFirstRecord() instead."),n=this.__allRecordsByFieldKey.get(e),o=void 0!==n,!o)return void 0!==e&&window.skyward.error.reportException(new d.SkywardException("Could not find field ".concat(e," on treebrowse."))),q(q({},this.selectFirstRecord()),{},{foundField:!1});$(n.$el).scrollintoview({direction:"vertical"})}else o=!0,n=void 0,a=void 0;return this.selectedFieldKey=a,{foundField:o,element:null===(t=n)||void 0===t?void 0:t.$el,rowData:this.__formatRecordData(n)}},selectFirstRecord(){var e;let t,n,a=!1;const o=this.allSections.find(e=>{var t,n;return(null!==(t=null===(n=e.rows)||void 0===n?void 0:n.length)&&void 0!==t?t:0)>0});if(o){n=("string"==typeof o.component?z[o.component]:o.component).fieldKey(o.rows[0]),t=this.__allRecordsByFieldKey.get(n),t&&(a=!0,$(t.$el).scrollintoview({direction:"vertical"}))}return this.selectedFieldKey=n,{foundField:a,element:null===(e=t)||void 0===e?void 0:e.$el,rowData:this.__formatRecordData(t)}},getSelectedElement(){var e;return null===(e=this.__selectedRecord)||void 0===e?void 0:e.$el},getSelectedFieldData(){return this.__formatRecordData(this.__selectedRecord)},clearSelectedRecord(){this.selectedFieldKey=void 0},getFieldData(e){const t="string"==typeof e?this.__allRecordsByFieldKey.get(e):Array.from(this.__allRecordsByFieldKey.values()).find(t=>t.$el===e);return this.__formatRecordData(t)},getFieldElement(e){const t=this.__allRecordsByFieldKey.get(e);return null==t?void 0:t.$el},__handleRecordSelected(e){this.selectedFieldKey=e,this.$emit(M,this.getSelectedFieldData())},__formatRecordData(e){if(!e)return;const t=e.formatField();return q(q(q({},e.field),t),{},{isTreeBrowseRow:!0,fieldKey:e.fieldKey()})},modifyField(e,t){var n;const a=this.__allRecordsByFieldKey.get(e);window.skyward.global.deepEquals(null!==(n=null==a?void 0:a.originalField)&&void 0!==n?n:null,t)?this.__modifiedFields.delete(e):this.__modifiedFields.set(e,t)},__formatFieldData(e){const t=this.__allRecordsByFieldKey.get(e);return this.__formatRecordData(t)},__buildTitle:(e,t)=>e.title?(0,c.createVNode)("tr",null,[(0,c.createVNode)("td",{class:"treeListItemHeader",colspan:t},[e.title],10,["colspan"])]):null}}),Q={buildVue(e){var t;const n=(0,u.VZ)(Y,e.events).mount(e.container);return Object.assign(n,J,null!==(t=e.props)&&void 0!==t?t:{}),n}};function X(e){return!!e.isRelationship}const Z=(0,c.defineComponent)({name:"treebrowseBreadcrumb",props:{moduleName:(0,u.oY)(String),objectName:(0,u.oY)(String),positionObjectPath:(0,u.oY)(String),displayName:(0,u.oY)(String),isOneToMany:(0,u.oY)(Boolean),index:(0,u.oY)(Number)},emits:{breadcrumbClicked:(0,u.c5)()},render(){const e=this.isOneToMany?"OneToMany":"OpenFolderAlt";return(0,c.createVNode)("span",{class:{[E]:!0},onClick:()=>this.$emit("breadcrumbClicked",this.index)},[(0,c.createVNode)(H.A,{name:e,type:"TreeBrowse",showHoverEffect:!1},null,8,["name"]),(0,c.createVNode)("span",{class:{[P]:!0,[O]:!0,[b]:!0,[v]:!0}},[this.displayName])],8,["onClick"])}}),ee={[B]:!0,[T]:!0},te=(0,c.defineComponent)({name:"treebrowseBreadcrumbContainer",props:{},emits:{browseBack:(0,u.c5)()},data:()=>({breadcrumbs:[]}),methods:{__handleCrumbClick(e){this.$emit("browseBack",e,this.breadcrumbs[e])}},render(){const e=this.breadcrumbs.map((e,t)=>{var n;const a={"margin-left":5*t+"px"},o=(0,c.createVNode)(Z,{moduleName:e.moduleName,objectName:e.objectName,positionObjectPath:e.positionObjectPath,displayName:e.displayName,isOneToMany:null!==(n=e.isOneToMany)&&void 0!==n&&n,index:t,onBreadcrumbClicked:e=>this.__handleCrumbClick(e)},null,8,["moduleName","objectName","positionObjectPath","displayName","isOneToMany","index","onBreadcrumbClicked"]);return(0,c.createVNode)("li",{style:a},[o],4)});return(0,c.createVNode)("ul",{class:ee},[e],2)}}),ne={buildVue:e=>(0,u.VZ)(te,e.props).mount(e.container)};function ae(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function oe(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ae(Object(n),!0).forEach(function(t){re(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ae(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function re(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const ie=window.skyward;function se(e){let t=$("#".concat(e));return 0===t.length&&(t=$(".treeBrowse[data-lookup-id='".concat(e,"']"))),t}function le(e,t,n,a,o,r,i,s,l,c,d){var u=se(a).data();if("function"==typeof u.replaceTreeBrowseData){let a={moduleName:e,objectName:t,displayName:r,positionObjectPath:n,isOneToMany:!1};u.fieldSearchButton.data("startModule",e),u.fieldSearchButton.data("startObject",t),u.fieldSearchButton.data("absoluteTreeBrowseObjectPath",c);var f=u.replaceTreeBrowseData(e,t,n,o,r,[a],s,l,c,d);return i?f.then(function(){u.fieldSearchBar.hide()}):u.fieldSearchBar.show(),f}}function ce(e,t){const n=se(e);if(n.length){const a=n.data();if(!a)throw new ReferenceError("".concat(e," is not a treebrowse"));void 0!==t?a.seekToField(t):a.selectFirstRecord()}}function de(e){var t=$(e);return t.is(".treeBrowse.treeBrowseContainer")||(t=t.find(".treeBrowse.treeBrowseContainer").first()),pe(t)}function ue(e){return de(se(e))}function fe(e){var t=de(e);return null==t?void 0:t.getSelectedFieldData()}function he(e){let t=de(e);return null==t?void 0:t.clearSelectedRecord()}function pe(e){const t=e.data();if(t.vueList)return t;const n=t;return Object.defineProperties(n,{selectedRecord:{get:function(){var e=this.vueList.getSelectedElement();return e?$(e):$()}},isDataField:{get:function(){const e=this.vueList.getSelectedFieldData();return void 0!==e&&!e.isRelationship&&!e.isCalculatedField}},isCalculatedField:{get:function(){const e=this.vueList.getSelectedFieldData();return null==e?void 0:e.isCalculatedField}},isOneToMany:{get:function(){const e=this.vueList.getSelectedFieldData();return e&&X(e)&&"OneToMany"===e.relationshipType}},additionalSections:{get:function(){return this.vueList.additionalSections},set:function(e){this.vueList.additionalSections=e}},onRowMounted:{get:function(){return this.vueList.onRowMounted},set:function(e){this.vueList.onRowMounted=e}},breadcrumbs:{get:function(){return this.breadcrumbContainer.breadcrumbs},set:function(e){this.breadcrumbContainer.breadcrumbs=e}}}),n}function me(e){return null==e?void 0:e.split(".").slice(1).join(".")}ie.treebrowse=ie.treebrowse||{},(0,r.registerLoadDOMCallback)(function(e){$(e).find(".treeBrowse.treeBrowseContainer").each(function(){!function(e){var t=pe(e),n=t.lookupId,o=a.virtualDir+t.expandUrl;t.mainContainer=e,t.mainContainer.css("height","100%"),t.treeBrowseList=e.find(".treebrowse__treeGridDiv");var i=!1,s=t.treeBrowseList,l=function(){if((0,r.getCurrentPopupId)()>0){var e=ie.filterbuilder.dialogs.getCurrent();if(e){var t=e.content.find(".filterBuilder").data();return{routehash:t.routehash,securityScreen:t.securityscreen,securityObject:t.securityobject,securityModule:t.securitymodule}}}return null}();let c=!1;const d=$("<table />");let u=!1;const f={sections:[],additionalSections:[],showParametersColumn:t.showParametersColumn,showEyeColumn:t.renderSuperUserColumn};t.vueList=Q.buildVue({props:f,container:d[0],isMobile:a.mobileAccess,events:{onRecordDoubleClick:function(e){if(!X(e)||e.isOneToMany&&!u){const{foundField:n}=t.vueList.selectRecord(e.fieldKey);n&&t.treeBrowseList.trigger("treeBrowseSave",[t,e])}else b(e).done(function(){t.selectFirstRecord()})},onRecordSelected:function(e){s.trigger("treeBrowseRowChange",[t,e])}}}),Object.assign(t.vueList,f);let h=e.find(".breadcrumbList");t.breadcrumbContainer=ne.buildVue({isMobile:a.mobileAccess,container:h.get(0),props:{onBrowseBack:(e,n)=>{t.breadcrumbs.splice(e+1,t.breadcrumbs.length),_.call(n,t.absoluteTreeBrowseObjectPath)}}}),t.breadcrumbContainer.breadcrumbs=h.data().breadcrumbs,t.parentSectionDiv=e.find(".parentSectionDiv"),t.fieldSearchBar=e.find(".js-treebrowse__fieldSearch"),t.fieldSearchButton=t.fieldSearchBar.find(".js-searchBoxButton");var p=e.find(".js-treebrowse__fieldSearchInput");async function m(a){u=("true"==t.allowOneToManyBrowse||1==t.allowOneToManyBrowse)&&(0==t.maxOneToManyNestedLevels||i()<(t.maxOneToManyNestedLevels||1));const o=[{key:"fields",rows:a.fields,component:"dataField"},{key:"relationships",rows:a.relationships,component:"relationshipField"},{key:"envvars",rows:a.environmentVariables,component:"environmentVariableField",container:a.environmentVariableContainer,title:a.environmentVariableContainer?void 0:"Environment Variables"},{key:"special",rows:a.specialFields,component:"dataField",container:a.specialFieldsContainer,title:a.specialFieldsContainer?void 0:"Special Fields"}];return t.vueList.sections=o,c||(c=!0,t.treeBrowseList.html("").append(d.children())),t.mainContainer.scrollParent().scrollTop(0),a.parentSectionHTML&&(await t.parentSectionDiv.viewpartHtml(a.parentSectionHTML),e.find(".parentSectionComboBox").on("change",y)),t.standardFilterName=a.standardFilterName,t.standardFilterId=a.standardFilterId,t.vueList.$nextTick().then(function(){s.trigger("treeBrowseLevelChanged",[t]),a.selector?(0,r.notifyDOMLoad)(a.selector):((0,r.notifyDOMLoad)(n+"_grid"),t.treeBrowseList.closest(".content").trigger("treeBrowseContentLoaded"))});function i(){return t.breadcrumbs.length-1}}function g(){var t=e.find(".parentSectionComboBox");return!(t.length>0)||t.find(":selected").index()==t.find("option").length-1}function w(e,n){let a=t.getExistingBreadcrumbIndex(n);a>=0?t.breadcrumbs=t.breadcrumbs.slice(0,a+1):v(n).forEach(function(n){if(-1===t.getExistingBreadcrumbIndex(n)){var a=e.find('[data-field-path="'+n+'"]').data();a&&t.breadcrumbs.push({moduleName:a.moduleName,objectName:a.objectName,displayName:a.displayName,isOneToMany:a.isOneToMany,positionObjectPath:n})}})}function v(e){let t=e.split(".");return t.map(function(e,n){return t.slice(0,n+1).join(".")})}function b(a){const r=e.find(".parentSectionComboBox > option:first-child").first().data(),s=(null==r?void 0:r.moduleName)||t.rootModule||t.lookupModule,c=(null==r?void 0:r.objectName)||t.rootObject||t.lookupObject;let d,u,f,h,p,w=!1,v=null;const b=!a;return b?(d=t.seekModule||t.lookupModule,u=t.seekObject||t.lookupObject,t.seekPath&&(h=t.seekPath,"."===h[h.length-1]&&(h=h.substring(0,h.length-1))),p=t.absoluteTreeBrowseObjectPath):(d=a.moduleName,u=a.objectName,h=a.fieldPath,f=a.relationshipName,w=a.isOneToMany,i=i||w,p=a.absoluteTreeBrowseObjectPath,v=a.relationshipPath),$.ajax(o,{type:"POST",dataType:"JSON",data:{positionObjectPath:h,lookupModule:d,lookupObject:u,controlName:n,insideOneToMany:i,routehash:null!=l?l.routehash:null,securitymodule:null!=l?l.securityModule:null,securityobject:null!=l?l.securityObject:null,securityscreen:null!=l?l.securityScreen:null,renderFields:t.renderFields,renderColumnGroups:!1!==t.renderColumnGroups&&g(),renderStandardRelationships:t.renderStandardRelationships,renderOneToManyRelationships:t.renderOneToMany,rendersecuritydataobjectfieldsonly:t.renderSecurityDataObjectFieldsOnly,hideFieldsWithAnyRestriction:t.hideFieldsWithAnyRestriction,browseId:t.browseId,renderProxies:t.renderProxies,absoluteTreeBrowseObjectPath:p,fieldsOnlyOfType:t.fieldsOnlyOfType,rootModuleName:s,rootObjectName:c,renderOperationFields:t.renderOperationFields,updateParentSectionComboBox:""===t.parentSectionDiv.html(),renderEnvironmentVariables:t.renderEnvironmentVariables,filterEnvironmentVariablesByLicense:t.filterEnvironmentVariablesByLicense,renderRowForImageReferences:t.renderRowForImageReferences,relationshipPath:v,renderSuperUserColumn:t.renderSuperUserColumn,additionalFilterTypeName:t.additionalFilterTypeName}}).then(function(e){return b?e.seekFieldPath=t.seekFieldPath:t.breadcrumbs.push({displayName:f,isOneToMany:w,moduleName:d,objectName:u,positionObjectPath:null!=h?h:""}),m(e).then(function(){return e})})}function y(){var e;let a=$(this),o=$(a[0]).find(":selected").data(),r=me(o.fieldPath),i=function(){var e;"True"===a.data().reparentTreebrowseOnChange?(t.breadcrumbs.splice(0,t.breadcrumbs.length,{moduleName:o.moduleName,objectName:o.objectName,isOneToMany:"OneToMany"===(null===(e=o.relationshipData)||void 0===e?void 0:e.relationshipType),displayName:o.displayName,positionObjectPath:o.fieldPath}),t.absoluteTreeBrowseObjectPath=o.absoluteTreeBrowseObjectPath,le(o.moduleName,o.objectName,o.fieldPath,n,null,o.displayName,!1,t.rootModule,t.rootObject,t.absoluteTreeBrowseObjectPath,!1)):w(a,o.fieldPath)};C(o.moduleName,o.objectName,o.fieldPath,null!==(e=o.absoluteTreeBrowseObjectPath)&&void 0!==e?e:"",r,i)}function _(e){const t=me(this.positionObjectPath);return C(this.moduleName,this.objectName,this.positionObjectPath,e,t,null)}function C(a,r,s,c,d,u){const f=e.find(".parentSectionComboBox > option:first-child").first().data(),h=(null==f?void 0:f.moduleName)||t.rootModule||t.lookupModule,p=(null==f?void 0:f.objectName)||t.rootObject||t.lookupObject;let w=$.ajax(o,{type:"POST",dataType:"JSON",data:{positionObjectPath:s,lookupModule:a,lookupObject:r,controlName:n,insideOneToMany:i,routehash:null!=l?l.routehash:null,securitymodule:null!=l?l.securityModule:null,securityobject:null!=l?l.securityObject:null,securityscreen:null!=l?l.securityScreen:null,renderFields:t.renderFields,renderColumnGroups:t.renderColumnGroups&&g(),renderStandardRelationships:t.renderStandardRelationships,renderOneToManyRelationships:t.renderOneToMany,rendersecuritydataobjectfieldsonly:t.renderSecurityDataObjectFieldsOnly,hideFieldsWithAnyRestriction:t.hideFieldsWithAnyRestriction,browseId:t.browseId,renderProxies:t.renderProxies,absoluteTreeBrowseObjectPath:c,fieldsOnlyOfType:t.fieldsOnlyOfType,rootModuleName:h,rootObjectName:p,renderOperationFields:t.renderOperationFields,updateParentSectionComboBox:""===t.parentSectionDiv.html(),renderEnvironmentVariables:t.renderEnvironmentVariables,filterEnvironmentVariablesByLicense:t.filterEnvironmentVariablesByLicense,renderRowForImageReferences:t.renderRowForImageReferences,relationshipPath:d,renderSuperUserColumn:t.renderSuperUserColumn,additionalFilterTypeName:t.additionalFilterTypeName}});return u&&w.then(u()),w.then(e=>m(e)).then(()=>{t.selectFirstRecord()})}p.on("enter",function(){t.fieldSearchButton.trigger("click")}),b().done(function(e){s.trigger("treeBrowseInitialize",[t,e]),t.treeBrowseList.closest(".content").trigger("treeBrowseContentLoaded",[t,e]),t.selectRecord(e.seekFieldPath)}),t.getExistingBreadcrumbIndex=function(e){return t.breadcrumbs.findIndex(t=>t.positionObjectPath==e)},t.getCurrentBreadcrumb=function(){return this.breadcrumbs[this.breadcrumbs.length-1]},t.seekToField=function(e){var n,a;const o=null!==(n=t.rootModule)&&void 0!==n?n:t.lookupModule,r=null!==(a=t.rootObject)&&void 0!==a?a:t.lookupObject;var i=e.fieldPathToParent||e.positionObjectPath,s=t.fieldSearchButton.data(),l="";s.absoluteTreeBrowseObjectPath&&(l=s.absoluteTreeBrowseObjectPath),t.replaceTreeBrowseData(e.moduleName,e.objectName,i,null,null,e.breadcrumbData,o,r,l,!1,!1).done(function(){(t.selectRecord(e.fieldPath)&&t.isDataField||t.isCalculatedField||t.isOneToMany)&&t.treeBrowseList.trigger("treeBrowseSave",[t,t.getSelectedFieldData()])})},t.selectRecord=function(e){let{foundField:n,rowData:a}=t.vueList.selectRecord(e);return s.trigger("treeBrowseRowChange",[t,a]),n},t.selectFirstRecord=function(){let{rowData:e}=t.vueList.selectFirstRecord();s.trigger("treeBrowseRowChange",[t,e])},t.clearSelectedRecord=function(){t.vueList.clearSelectedRecord()},t.getSelectedFieldData=function(){return t.vueList.getSelectedFieldData()},t.getFieldData=function(e){return t.vueList.getFieldData($(e)[0])},t.getFieldElement=function(e){return t.vueList.getFieldElement(e)},t.replaceTreeBrowseData=function(e,r,s,c,d,u,f,h,p){let w=!(arguments.length>9&&void 0!==arguments[9])||arguments[9],v=!(arguments.length>10&&void 0!==arguments[10])||arguments[10];const b={positionObjectPath:s,lookupModule:e,lookupObject:r,controlName:n,insideOneToMany:i,routehash:null!=l?l.routehash:null,securitymodule:null!=l?l.securityModule:null,securityobject:null!=l?l.securityObject:null,securityscreen:null!=l?l.securityScreen:null,renderFields:t.renderFields,renderColumnGroups:t.renderColumnGroups&&g(),renderStandardRelationships:t.renderStandardRelationships,renderOneToManyRelationships:t.renderOneToMany,rendersecuritydataobjectfieldsonly:t.renderSecurityDataObjectFieldsOnly,hideFieldsWithAnyRestriction:t.hideFieldsWithAnyRestriction,browseId:t.browseId,renderProxies:t.renderProxies,absoluteTreeBrowseObjectPath:p,fieldsOnlyOfType:t.fieldsOnlyOfType,rootModuleName:f,rootObjectName:h,renderOperationFields:t.renderOperationFields,updateParentSectionComboBox:w,renderEnvironmentVariables:t.renderEnvironmentVariables,filterEnvironmentVariablesByLicense:t.filterEnvironmentVariablesByLicense,renderRowForImageReferences:t.renderRowForImageReferences,relationshipPath:me(s),renderSuperUserColumn:t.renderSuperUserColumn,additionalFilterTypeName:t.additionalFilterTypeName};return $.ajax(c?a.virtualDir+c:o,{type:"POST",dataType:"JSON",data:b}).then(function(n){return v&&(t.lookupModule=e,t.lookupObject=r,t.rootModule=f,t.rootObject=h,t.absoluteTreeBrowseObjectPath=p),t.breadcrumbs.splice(0,t.breadcrumbs.length,...u),m(n)})},t.refresh=function(){const e=t.getCurrentBreadcrumb();return t.replaceTreeBrowseData(e.moduleName,e.objectName,e.positionObjectPath,null,null,t.breadcrumbs,t.rootModule,t.rootObject,t.absoluteTreeBrowseObjectPath,!1)}}($(this))})}),(0,s.registerEvents)("treebrowse",{editSuperUserFieldVisibility:function(e){const t=$(this).closest(".treeBrowse"),n=de(t),r=(0,i.rawData)(t);let s;const c=(0,o.showDialog)("Edit Super User Field Visibility",$.ajax({url:a.virtualDir+"Common/TreeBrowse/GetPopup",method:"POST",type:"viewparthtml",data:oe(oe({},r),{},{renderSuperUserColumn:!0})}),[{text:o.ButtonText.Save,icon:o.ButtonIcon.Save,click:()=>{(function(e){return $.ajax({url:a.virtualDir+"Security/BrowseFieldPath/MassUpdate",type:"POST",data:{browseID:null==r?void 0:r.browseId,updates:JSON.stringify(Object.fromEntries(Array.from(s.vueList.modifiedFields.entries()).map(e=>{let[t,n]=e;return[n.absoluteFieldPath,n.showEye]}))),preSaveWarningHash:e.container.data("preSaveWarningHash")||""},success:function(t){t?((0,l.displayValidationMessages)(t,e.content.find(".treeBrowseContainer"),$("#baseTreeBrowseErrorContainer"),!0),e.container.data("preSaveWarningHash",t.preSaveWarningHash),e.content.scrollTop(0)):(e.container.removeData("preSaveWarningHash"),e.close())}})})(c).then(()=>n.refresh())}},o.closeButton],{});c.content.one("treeBrowseInitialize",(e,t)=>{s=t;const a=n.getCurrentBreadcrumb();s.replaceTreeBrowseData(a.moduleName,a.objectName,a.positionObjectPath,null,null,$.extend(!0,[],n.breadcrumbs),n.rootModule,n.rootObject,n.absoluteTreeBrowseObjectPath)}),c.content.on("treeBrowseSave",(e,t,n)=>{const a=t.vueList.selectedField;a&&"boolean"==typeof a.showEye&&t.vueList.modifyField(t.vueList.selectedFieldKey,oe(oe({},a),{},{showEye:!a.showEye}))})}})},24023(e,t,n){"use strict";n.r(t);var a=n(2894),o=n(88157),r=n(49343);function i(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function s(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?i(Object(n),!0).forEach(function(t){l(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):i(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function l(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function c(e,t){const n=s(s({},t),e);if(e.html){const t={text:"I Consent",icon:o.ButtonIcon.Check,click:d,data:n},a=e.title||"APPROVAL REQUIRED";(0,o.showCriticalDialog)(a,e.html,[t,o.DEFAULT_CANCEL_BUTTON],{width:600,automationID:"approval-consent-dialog"})}else u(n)}function d(){const e=$(this).data();$.ajax({url:"".concat(a.virtualDir,"SkySys/UserApproval/ApproveAndRedirect"),type:"POST",dataType:"JSON",data:e,success:function(e){u(e)}})}function u(e){if(e.success)switch(e.redirectAction){case"MassImportAttachmentTemplateRunImport":(0,r.checkLoadContent)("popup","Workflow","WorkflowInstance","Create/SkySys/MassImportAttachmentRun/RunImport",null,e.workflowData,null,void 0,null,!1,null,null,null);break;case"MassImportAttachmentTemplateAddTemplate":(0,r.checkLoadContent)("popup","Workflow","WorkflowInstance","Create/SkySys/MassImportAttachmentTemplate/Add",null,e.workflowData,null,void 0,null,!1,null,null,null);break;case"MassDelete":(0,r.checkLoadContent)("popup","Workflow","WorkflowInstance","Create/WSIPCOnly/WSIPCOnly/MassDelete",null,e.workflowData,null,void 0,null,!1,null,null,null)}}(0,n(92214).registerEvents)("userApproval",{getConsent:async function(){const e=$(this).data();try{c(await $.ajax({url:"".concat(a.virtualDir,"SkySys/UserApproval/GetConsent"),type:"POST",dataType:"JSON",data:e}),e)}catch(e){console.error("Error requesting approval:",e)}},getConsentForAdd:async function(){const e=$(this).data();let t;if("MassImportAttachmentTemplateAddTemplate"===e.redirectAction)t="".concat(a.virtualDir,"SkySys/UserApproval/GetConsentForAdd");try{c(await $.ajax({url:t,type:"POST",dataType:"JSON",data:e}),e)}catch(e){console.error("Error requesting approval:",e)}}})},22528(e,t,n){"use strict";n.r(t),n.d(t,{classNames:()=>c,clearValidationMessages:()=>h,displayValidationMessages:()=>p,getControl:()=>v,getHelpMessage:()=>b,getHtmlViewers:()=>f,getLabel:()=>y,setAriaInvalid:()=>m,validDate:()=>g,validNumber:()=>w});var a=n(49343),o=n(81975),r=n(78036),i=n(92566),s=n(68337),l=function(e){return e.Error="Error",e.Warning="Warning",e}(l||{});const c=Object.freeze({errorControl:"error-control",errorText:"error-text",warningText:"warning-text",warningControl:"warning-control",persist:"persist"}),d=window.skyward,u={[l.Error]:{Severity:l.Error,SkipStyling:function(){return!1}},[l.Warning]:{Severity:l.Warning,SkipStyling:function(e){return!!e}}};function f(e){return e.find(".htmlViewer, .framedHTMLViewer").not(".js-ignoreIFrameContents")}function h(e,t){p({errors:{},warnings:{}},e,t)}function p(e,t,n){let o=arguments.length>3&&void 0!==arguments[3]&&arguments[3];const s="string"==typeof t?$("#".concat(t)):t,l=(0,i.getContentMessageArea)(s.parent());s.find(".objectErrors").html(""),s.find(c.errorControl.dot()).removeClass(c.errorControl).removeAttr("aria-invalid"),s.find(c.errorText.dot()).not(c.persist.dot()).removeClass(c.errorText),s.find(c.warningControl.dot()).removeClass(c.warningControl),s.find(c.warningText.dot()).not(c.persist.dot()).removeClass(c.warningText),s.find(".help").empty(),s.find(".js-htmlViewerWrapper").each(function(){const e=$(this),t=e.children().not(".js-htmlViewerOverlay");e.replaceWith(t)}),l&&l.resetValidation();const h=[];if(null!==e&&"object"==typeof e){const t=$("<ul/>"),o=g(!1);"string"==typeof e.errors&&(e.errors={Base:[e.errors]});const{found:r,notFound:i}=p(e.errors),{found:h,notFound:m}=p(e.warnings),v=$.extend({},r,i),b=$.extend({},h,m),y=f(s);return Promise.all(y.toArray().map(function(e){return d.iframeListener.displayValidationMessages(e,{errors:_(i,e=>e.messages),warnings:_(m,e=>e.messages)})})).then(d=>{var f,p;const y=new Set([].concat(Object.keys(h),Object.keys(r),...d));if(window===window.parent){for(const e of Object.keys(m))y.has(e)||(h[e]=m[e]);for(const e of Object.keys(i))y.has(e)||(r[e]=i[e])}let _=Object.values(v).reduce(o,0);w(r,r,t,u.Error);let C=Object.values(b).reduce(o,0);if(w(h,r,t,u.Warning),s.data("warninghash",null!==(f=e.warninghash)&&void 0!==f?f:null),s.data("warninghashes",e.warninghashes),s.data("preSaveWarningHash",null!==(p=e.preSaveWarningHash)&&void 0!==p?p:null),n&&(n.attr("role","alert").html(t[0]),_+=n.find(c.errorText.dot()).length,C+=n.find(c.warningText.dot()).length),l){const e=g(!0);Object.values(v).reduce(e,0)>0&&0===_&&l.setAllErrorsAreHidden(!0),l.setValidationCount(_,C).showValidation()}return(0,a.notifyResize)(),Array.from(y)})}return(0,a.notifyResize)(),Promise.resolve([]);function p(e){const t={},n={};for(const a in e){const o=m(a,e);o.hasTarget?t[a]=o:n[a]=o}return{found:t,notFound:n}}function m(e,t){let n=e,a=b(e,s),i=s.find('[name="'.concat(n,'"]'));if(a.length<=0){const t=e.split(".")[1],o=b(t,s);o.length>0&&(n=t,a=o,i=s.find('[name="'.concat(t,'"]')))}const l="base"===n.toLowerCase()||o;return a.is(".collapsePanelContents.collapsed *")&&a.parents(".collapsePanelContents.collapsed").each(function(){(0,r.show)($(this).closest(".collapsePanel"))}),{resultControlName:n,target:a,hasTarget:a.length>0&&!l,control:i,isVisible:a.is(":visible"),messages:t[e],isBase:l}}function g(e){return function(t,n){return e||n.isVisible||n.isBase?t+n.messages.length:t}}function w(e,t,n,a){const r=[],i=new Set;for(const l in e){const c=e[l],d=c.isBase;let u=null;if(c.target.length>0&&c.target.parents(".collapsePanel:not(.error-control)").addClass("".concat(a.Severity.toLowerCase(),"-control")),!d&&(u=c.target,u.length>0&&!c.isVisible))continue;const f=k(c.messages,c.resultControlName,s,a.Severity,a.SkipStyling(t[l]),o);if(d)n.append(f),r.push(f);else{const e=c.messages.map(e=>"string"==typeof e?e:e.message).join("\n");if(null!==u&&u.length>0){v(u,f,l);const e=c.control.attr("data-dirty");void 0!==e&&"false"!==e||c.control.attr("data-original-value-invalid","")}else i.has(e)||(n.append(f),r.push(f),i.add(e))}}}function v(e,t,n){const a="".concat(n,"-validationList"),o=$("<ul>",{class:"validationList",id:a,append:t}),r={target:e.append(o),validationList:o};h.push({key:n,value:r});const i=s.find('[data-validate-control-for="'.concat(n,'"], .electronicsignature[id="').concat(n,'"]'));for(const e of i){const t=C($(e));null!=t&&t.length&&(t.attr("aria-describedby",a),t.attr("aria-invalid","true"))}}}function m(e,t){const n=C(e);null!=n&&n.length&&(t&&n.is(":input, .radioButtonGroup")?n.attr("aria-invalid","true"):n.removeAttr("aria-invalid"))}function g(e){const t=(0,o.parseDate)(e,!1);return n=t.getFullYear(),!isNaN(n)&&n>=1&&n<=9999;var n}function w(e){return!isNaN("number"==typeof e?e:parseFloat(e))&&isFinite(e)}function v(e,t){const n='[data-validate-control-for="'.concat(e,'"]');return t?t.find(n):$(n)}function b(e,t){const n='[data-validate-message-for="'.concat(e,'"]');return t?t.find(n):$(n)}function y(e,t){const n='[data-validate-text-for="'.concat(e,'"]');return t?t.find(n):$(n)}function _(e,t){const n={};for(const a in e)if(Object.prototype.hasOwnProperty.call(e,a)){const o=a;n[o]=t(e[o],o,e)}return n}function C(e){return e.is(":input,.radioButtonGroup")?e:e.hasClass("eELInputContainer")?e.find(".eELInputContainer__textBox"):e.is(".checkboxGroup,.multipleSelectBox,.electronicsignature")?e.find(".checkbox"):e.hasClass("fileUpload2")?e.find(".fileUpload2__selectButton"):void 0}function k(e,t,n,a,o,r){const i=[],c=a.toLowerCase();for(const d of e){let e=d;if("string"!=typeof d&&(e=d.message),""!==e){const d=(0,s.getSvg)(a,a).addClass(["alert".concat(a),"svgNoHover"]).attr("aria-role","img"),u=$("<span>",{class:"sr-only",text:a}),f=$("<span>",{addClass:"validationSpan",text:e}),h=$("<li>",{addClass:"".concat(c).concat("base"===t.toLowerCase()||r?"-list":"-text"),append:$("<span>",{append:[d,u,f]})});if(i.push(h[0]),!o&&"base"!==t.toLowerCase()&&!r){y(t,n).addClass("".concat(c,"-text"));const e=v(t,n);e.addClass("".concat(c,"-control")).trigger("errorChange"),a===l.Error&&e.each(function(){const e=C($(this));void 0!==e&&e.attr("aria-invalid","true")}),o=!0}}}return i}},46482(e,t,n){"use strict";n.r(t);var a=n(88157),o=n(62521),r=n(22528),i=n(92214),s=n(3543),l=n(2894),c=n(79126);const d={open:function(){var e;const t=$(this),n=t.data().browseId,o=(0,s.getBrowseById)(n);if(void 0===o)return void(0,c.reportException)(new c.SkywardException("Cannot open the view popup: no browse was found for id '".concat(n,"'.")));const r=null===(e=o.data)||void 0===e?void 0:e.browseViewEditorHash,i={pageModule:o.pageModule,pageObject:o.pageObject,pageScreen:o.pageScreen,browseName:o.browseName,taskName:o.taskName,browseId:o.id,browseViewEditorHash:r};r&&(i.postData=JSON.stringify(o.data));!function(e,t){const n=o();function o(){let o="BuildViewOptionsViewpart";const r="Views",i={id:"close",text:"Close",click:()=>n.close(),icon:a.ButtonIcon.Close},s={anchorTo:e};t.browseViewEditorHash&&(o+="ForBrowseViewEditor");const c=function(e,t){const n={pageScreen:e.pageScreen,browseName:e.browseName.replace("detailsPanel_",""),taskName:e.taskName,browseId:e.browseId,moduleName:e.pageModule,objectName:e.pageObject,postData:e.postData};return()=>$.ajax({url:"".concat(l.virtualDir,"SkySys/BrowseView/").concat(t),type:"POST",dataType:"viewparthtml",activityIndicator:{hideGlass:!0},data:n})}(t,o);return(0,a.showDialog)(r,c,[i],s)}function r(){const e=$(this),a=e.find("#browseViewOptions").data(),o=e.find("#browseViewBaseErrors"),r=[e,n,a.browseId,o,t];let i=!1;const s=[{selector:"#resetAndApplyButton",clickFunc:u},{selector:"#browseViewSaveChangesButton",clickFunc:f},{selector:"#browseViewSaveAsButton",clickFunc:h},{selector:"a.delete",clickFunc:p},{selector:"a.apply.view",clickFunc:m},{selector:"a.reset.view",clickFunc:g}];for(const t of s)e.on("click",t.selector,t,l);function l(e){const t=$(this);if(!t.hasClass("ui-disabled")&&!t.hasClass("hidden")&&!i){i=!0;e.data.clickFunc.apply(t,r).always(function(){i=!1})}}}n.content.on("contentLoaded",r)}(t,i)}};function u(e,t,n,a,o){return w(this,null,t,n,a)}function f(e,t,n,a,o){const r={name:e.find("#currentNameTextbox").val(),warninghash:JSON.stringify(t.content.data("warninghash"))};return o.browseViewEditorHash&&(r.postData=o.postData),w(this,r,t,n,a)}function h(e,t,n,a,o){return w(this,{name:e.find(".saveAsTextbox").val()},t,n,a)}function p(e,t,n,a,o){const r=this.data();return w(this,{skywardIsDefaultId:r.skywardIsDefaultId,browsePrimaryKey:r.browsePrimaryKey},t,n,a)}function m(e,t,n,a,r){const i=this.data();return(0,o.changeView)(n,{viewId:i.id}).always(function(){t.close()})}function g(e,t,n,a,o){const i=this,s=i.data();return $.ajax({url:"".concat(l.virtualDir,"SkySys/").concat(s.controller,"/").concat(s.action,"/").concat(s.id),type:"POST",dataType:"JSON",activityIndicator:{hideGlass:!0},success:e=>{!0===e.success?($(s.modifiedTextRowId).hide(),i.css("visibility","hidden"),$(s.applyButtonRowId).data().id=e.id):(0,r.displayValidationMessages)(e,t.content,a)}})}function w(e,t,n,a,i){const s=e.data();return $.ajax({url:"".concat(l.virtualDir,"SkySys/").concat(s.controller,"/").concat(s.action,"/").concat(s.id),type:"POST",dataType:"JSON",data:null!=t?t:void 0,activityIndicator:{hideGlass:!0},success:t=>{let l;!0===t.success?(n.close(),(0,o.changeView)(a,{viewId:t.id})):(!0===s.disableDuplicateValidation&&(l=function(e){var t,n;const a=e.data(),o=$(a.disableOtherHelpLabelValidationId);o.attr("data-original-validate-message-for",null!==(t=o.attr("data-validate-message-for"))&&void 0!==t?t:""),o.attr("data-validate-message-for","");const r=$(a.disableOtherTextboxValidationId);return r.attr("data-original-validate-control-for",null!==(n=r.attr("data-validate-control-for"))&&void 0!==n?n:""),r.attr("data-validate-control-for",""),e}(e)),(0,r.displayValidationMessages)(t,n.content,i),void 0!==l&&function(e){var t,n;const a=e.data(),o=$(a.disableOtherHelpLabelValidationId);o.attr("data-validate-message-for",null!==(t=o.attr("data-original-validate-message-for"))&&void 0!==t?t:"");const r=$(a.disableOtherTextboxValidationId);r.attr("data-validate-control-for",null!==(n=r.attr("data-original-validate-control-for"))&&void 0!==n?n:"")}(l))}})}(0,i.registerEvents)("viewPopup",d)},2441(e,t,n){"use strict";n.r(t),function(e,t){const n=new Map,a=new MutationObserver(function(e,t){if(!e.some(e=>function(e){let{removedNodes:t}=e;for(let e=0;e<t.length;e+=1){const n=t[e];if((n.nodeType===Node.ELEMENT_NODE||n.nodeType===Node.DOCUMENT_NODE||n.nodeType===Node.DOCUMENT_FRAGMENT_NODE)&&!n.isConnected)return!0}return!1}(e)))return;n.forEach((e,t)=>{t.isConnected||(n.delete(t),e.resolve(t))}),0===n.size&&t.disconnect()});e.window.registerDOMUnloadCallback=function(e){const o=t(e).get(0);if(!o)return;let r,i;o.classList.add("js-unload-action-applied");const s=new Promise((e,t)=>{r=e,i=t});n.set(o,{promise:s,resolve:r,reject:i}),1===n.size&&a.observe(document,{childList:!0,subtree:!0});return s},e.window.removeDOMUnloadCallback=function(e){const o=t(e).get(0);if(!o)return;o.classList.remove("js-unload-action-applied");const r=n.get(o);if(!r)return!1;r.reject(o),n.delete(o),0===n.size&&a.disconnect();return!0}}(window.skyward,window.jQuery)},49343(e,t,n){"use strict";n.r(t),n.d(t,{checkDirtyScreen:()=>de,checkLoadContent:()=>te,clientHeightRef:()=>L,clientWidthRef:()=>A,closePopup:()=>X,device:()=>k,getClientHeight:()=>I,getClientWidth:()=>M,getClosestContentPanel:()=>fe,getCurrentPopupId:()=>T,getImage:()=>Z,getImageHtml:()=>ee,getNextPopupId:()=>x,glassList:()=>P,hasHorizontalScrollBar:()=>j,hasVerticalScrollBar:()=>V,isContentLoading:()=>J,isSafari:()=>D,isSafariBrowser:()=>S,isTouchDevice:()=>B,loadContent:()=>ne,loadContentWithPageLoading:()=>ae,moduleContent:()=>C,notifyDOMLoad:()=>z,notifyResize:()=>Q,popupCloseFunctionList:()=>E,popupList:()=>O,registerBrowseResizeCallback:()=>U,registerLayoutResizeCallback:()=>q,registerLoadDOMCallback:()=>H,reloadScreen:()=>ue,removeBrowseResizeCallback:()=>K,removeLayoutResizeCallback:()=>G,removeLoadDOMCallback:()=>W,returnToPrevious:()=>le,scrollbarHeight:()=>F,setSkipUnloadCheck:()=>N,skipUnloadCheck:()=>R,submitForm:()=>ce,toggleResizeEvents:()=>_,updateEntitySelector:()=>ie,updateFiscalYearSelector:()=>re,updatePageState:()=>Y,updateRelatedRecord:()=>oe,updateSchoolYearSelector:()=>se});var a=n(79126),o=n(2894),r=n(88157),i=n(74061),s=n(939),l=n(29711),c=n(92214);n(49343);function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function u(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const f=window.skyward;f.window=f.window||{};const h=$(window),p=(0,l.getCallbackStore)(),m=(0,l.getCallbackStore)(),g=(0,l.getCallbackStore)();let w=!1,v=!0;const b={checkLoadContent:function(){const e=$(this).data();te(e.target,e.area,e.controller,e.action,e.id,e.data)},reload:ue,postForbidden:function(){const e=$(this).data("error");window.parent&&window.parent!==window&&window.parent.postMessage({type:"forbidden",data:{error:e}},"*")}};if((0,c.registerEvents)("window",b),(0,a.registerErrorDataGatherer)("window",function(){return{currentPopupId:T(),domLoadReady:w,windowSize:{width:f.window.clientWidth,height:f.window.clientHeight}}}),$(()=>{H(c.processLoadActions)}),o.mobileAccess){const e={},t={status:200,statusText:"OK",headers:"X-Externally-Downloaded: \r\n"},n=function(t,n,a){const o=e[t];void 0!==o&&(delete e[t],o(a,n))};$.ajaxTransport("maybebinary",function(t,n,a){return{key:btoa(crypto.randomUUID()),send:function(n,a){let r="";$.each(n,function(e,t){r+="".concat(e,": ").concat(t,"\n")}),void 0===n.Referer&&new URL(t.url,window.location.href).host===window.location.host&&(r+="Referer: ".concat(window.location,"\n")),"X-Requested-With"in n||(r+="X-Requested-With: XMLHttpRequest\n"),e[this.key]=function(e,t){a(t.status,t.statusText,{maybebinary:e},t.headers)};const i=new URL(t.url,window.location.href).href;window.ReactNativeWebView?window.ReactNativeWebView.postMessage(JSON.stringify({key:this.key,type:"qmlativDownloadRequest",method:t.type,url:i,headers:r,body:t.data})):o.isAndroidApp?window._androidAjaxHelper.request(this.key,t.type,i,r,t.data):o.isIosApp&&window.webkit.messageHandlers.ajaxHelper.postMessage({key:this.key,type:"request",method:t.type,url:i,headers:r,body:t.data})},abort:function(){delete e[this.key]}}});const a=function(e){n(e,{status:500,statusText:"Internal Server Error",headers:"X-Externally-Downloaded: \r\n"},"")},r=f.window;window.ReactNativeWebView?(r._mobileAjaxReady=function(e,a,o){let r;try{r=JSON.parse(a)}catch(e){}const i=atob(null!=o?o:"");n(e,null!=r?r:t,i)},r._mobileAjaxFail=a):o.isAndroidApp&&window._androidAjaxHelper?(r._androidAjaxReady=function(e){var a,o,r,i,s;const l=null===(a=window._androidAjaxHelper)||void 0===a||null===(o=a.getMetaData)||void 0===o?void 0:o.call(a,e),c=l?JSON.parse(l):t,d=null!==(r=null===(i=window._androidAjaxHelper)||void 0===i||null===(s=i.getResponseBodyAndRemove)||void 0===s?void 0:s.call(i,e))&&void 0!==r?r:"";n(e,c,d)},r._androidAjaxFail=a):o.isIosApp&&window.webkit?(r._iosAjaxReady=function(e,a,o){const r=atob(null!=o?o:"");n(e,null!=a?a:t,r)},r._iosAjaxFail=a):$.ajaxTransport("maybebinary",function(e,t,n){const a=e.xhr();a.responseType="blob",a.open(e.type,e.url,e.async);return{send:function(t,n){$.each(t,function(e,t){a.setRequestHeader(String(e),t)}),"X-Requested-With"in t||a.setRequestHeader("X-Requested-With","XMLHttpRequest");const o=t["X-Default-Filename"]||function(e){const t=e.lastIndexOf("/"),n=-1!==t?t:0,a=e.indexOf("?",n),o=-1!==a?a:void 0,r=e.slice(n,o);return""!==r?r:"index"}(e.url);delete t["X-Default-Filename"],a.onloadend=function(){const e="x-externally-downloaded: \r\n"+(this.getAllResponseHeaders()||"");n(this.status,this.statusText,{maybebinary:""},e);const t=function(e){if(!e)return;const t=/filename\s*=\s*(.*)/.exec(e);if(null===t)return;const n=t[1],a=(n.startsWith('"')?/"((?:[^\"]|\\.)*)"/:/([^\u0000-\u001f\u007f()<>@,;:\\\/\[\]?={} \"]*)/).exec(n);return null!==a?a[1]:void 0}(this.getResponseHeader("Content-Disposition"))||o,a=this.getResponseHeader("Content-Type")||"application/octet-stream";!function(e,t,n){const a=new Blob([e],{type:t}),o=URL.createObjectURL(a),r=$('<a style="display: none;">');n&&(r[0].download=n);r[0].href=o,$(document.body).append(r),r[0].click(),r.remove(),URL.revokeObjectURL(o)}(this.response,a,t)},a.onerror=function(){n(this.status,this.statusText,{maybebinary:""},this.getAllResponseHeaders())},a.send(e.data)},abort:function(){a.abort()}}})}let y=!0;const _=e=>{y=e};h.on("resize",function(){y&&pe()}),$(async function(){w=!0;const e=$(window);C=$("#moduleContent"),e.resize(),await o.initialModulesLoaded,z("html",{skywardContentPanel:!0}),window.performance&&"function"==typeof window.performance.mark&&window.performance.mark("initialNotifyDOMLoadComplete"),e.on("beforeunload",function(){const e=function(){var e;let t=null;if(f.workflow){var n;const e=null!==(n=f.workflow.getPendingWorkflowInstances())&&void 0!==n?n:[];e[0]&&e[0].items&&e[0].items.length&&$.ajax("".concat(o.virtualDir,"Security/PageState/Update"),{type:"POST",dataType:"JSON",async:!1,data:{controls:JSON.stringify(e)}})}null!==(e=f.changeTracking)&&void 0!==e&&e.isDirty()&&!R&&(t="Unsaved changes on the page. Remain on page and click save to preserve changes.");return t}();if("string"==typeof e)return window.setTimeout(function(){$(document).trigger("hideLoadingIndicator")},1e3),e}),k&&$("#master").addClass("device")}),window.onunload=function(){};let C=null;const k=/android|applewebkit|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()),S=/^((?!chrome|android).)*safari/i.test(navigator.userAgent),D=o.isIosApp||S,E=[],P=[],O=[];function B(){return"ontouchstart"in window||"onmsgesturechange"in window&&"msMaxTouchPoints"in window.navigator&&window.navigator.msMaxTouchPoints}function T(){return $(document.body).children(".modalLayerContainer").length-1}function x(){return $(document.body).children(".modalLayerContainer").length}f.window=f.window||{},f.window.clientWidth=h.width(),f.window.clientHeight=h.height();const M=()=>f.window.clientWidth,I=()=>f.window.clientHeight,A=(0,i.ref)(f.window.clientWidth),L=(0,i.ref)(f.window.clientHeight);let R;function N(e){R=e}const F=function(){const e=$('<div style="visibility: hidden; height: 100px;">');$(document.body).append(e);const t=e[0].offsetHeight;e.css({overflow:"scroll"});const n=$('<div style="height: 100%">');e.append(n);const a=n[0].offsetHeight;return e.remove(),t-a}();function j(e){const t=window.jQuery(e);if(t.length){const e=t[0].scrollWidth,n=t[0].clientWidth;if(e<=n)return!1;if(e-n>1)return!0;let a;const o=getComputedStyle(t[0]),r="auto"!==o.overflowX,i=parseFloat(o.borderTopWidth)+parseFloat(o.borderBottomWidth);r&&(a=t[0].style.overflowX,t[0].style.overflowX="auto");const s=Math.round(t[0].clientHeight+i)<t[0].offsetHeight;return r&&(t[0].style.overflowX=a),s}return!1}function V(e){const t=$(e);return!!t.length&&t.get(0).scrollHeight>t.get(0).clientHeight}const H=p.registerCallback,W=p.deregisterCallback,U=m.registerCallback,K=m.deregisterCallback,q=g.registerCallback,G=g.deregisterCallback;function z(e,t){if(!w)try{console.group("notifyDOMLoad"),console.warn("NotifyDOMLoad called on ".concat(e," before document was ready. This may cause duplicate event handlers or other problems.")),console.trace(),console.groupEnd()}catch(e){}const n={skywardContentPanel:!1};t&&$.extend(n,t);const a=$(e),o=a.addIds();if("string"!=typeof e){const t=[];a.each(function(){t.push("#"+this.id)}),e=t.join(",")}v=!0,p.dispatchCallbacks.call(o,e,n),v=!1}function J(){return v}function Y(e){return $.ajax(o.virtualDir+"Security/PageState/Update",{type:"POST",dataType:"JSON",activityIndicator:{hideGlass:!0},data:{controls:JSON.stringify(e)}})}function Q(){if(!w)try{console.group("notifyResize"),console.warn("NotifyResize called before document was ready. This may cause duplicate event handlers or other problems."),console.trace(),console.groupEnd()}catch(e){}g.dispatchCallbacks(),m.dispatchCallbacks()}function X(e,t){if(e&&"function"==typeof e.close)return e.close(t);const n=(0,r.getLayerFromElement)("div.modalLayerContainer:last");return n&&"function"==typeof n.close&&n.options.closeOnRecordSelected?n.close(t):null}function Z(e){null!=e||(e="pageLoadingGif");const t=document.createElement("img");return t.src="".concat(o.virtualDir,"content/loading.gif?v=2"),t.className=e,$(t)}function ee(e){return Z(e)[0].outerHTML}function te(e,t,n,a,o,r,i,s,l,c,d,u,p,m,g,w){const v=$.Deferred();return void 0!==w&&!0!==$(w).data().ignoreDirtyDov&&f.changeTracking.isDirty(fe(w).find(".dataObjectViewer").first())||"full"===e&&f.changeTracking.isDirty()?f.changeTracking.showDirtyScreenModal(function(){h.off("beforeunload"),ne(e,t,n,a,o,r,i,s,l,c,d,u,p,null,m,g,w).then(v.resolve)}).catch(v.reject):("boolean"==typeof m||"object"!=typeof r||$.isEmptyObject(r)||(m=r.PersistModalLayer),"popout"===e||m||X(),f.detailsPanel.tryCloseDetailsPanel(function(){ne(e,t,n,a,o,r,i,s,l,c,d,u,p,null,m,g,w).then(v.resolve)})),v.promise()}const ne=function(e,t,a,i,l,c,h,p,m,g,w,v,b,y,_,C,k){let S=h,D=$.Deferred().resolve().promise();const E=(0,o.validateDataParameter)(c),P={enableOpenInNewWindowModifiers:!0,activityIndicator:{silent:!1,hideGlass:!1},downloadOnMobile:!1},B=$.extend({},P,C);"boolean"==typeof _||"object"!=typeof E||$.isEmptyObject(E)||(_=E.PersistModalLayer);const M=k?$(k):void 0;if(B.enableOpenInNewWindowModifiers&&M&&M.isLink()&&"full"===e&&(f.keys.globalPrimaryModifierPressed||f.keys.globalShiftPressed)){const N=$.extend({},B,{enableOpenInNewWindowModifiers:!1,forceNewBrowserWindowOnPopout:f.keys.globalShiftPressed});return setTimeout(()=>ne("popout",t,a,i,l,c,S,p,m,g,w,v,b,y,_,N,k),0),D}let I=o.virtualDir;function A(){const e=b||(E.mediaVerificationToken?E.mediaVerificationToken:null);return!!e&&(L.mediaVerificationToken=e,E.preview&&(L.preview=E.preview),E.filenameOverride&&(L.filenameOverride=E.filenameOverride),!0)}"string"==typeof t&&t.length>0&&"string"==typeof a&&a.length>0&&(I+=t+"/"+a,"string"==typeof i&&i.length>0&&(I+="/"+i),l=function(t,n,a){if("full"===e&&null==n&&$.isEmptyObject(a)){const e=f.volatileStorage.getLocalStorage("ProfileBrowse").get(t);if(e){const t=(0,s.getPreferences)(e),n=t&&!isNaN(parseInt(t.seekId))?t.seekId:-1;if(e.goDirectlyToRecord)return n;a.browseSeekId=n,a.browseId=e.browseId}}return n}(I,l,E),("number"==typeof l||"string"==typeof l&&l.length>0)&&(I+="/"+l));const L=function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(Object(n),!0).forEach(function(t){u(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}({},null==C?void 0:C.additionalUrlParams),R={};if("popup"===e||"select"===e){const F=x();for(let K=$(".workflowPopup").length;K<F;K++)_||X();S="popup".concat(x());const j=$("<div>",{id:S,class:"popup"});let V,H=!1;"workflow"===t||"Workflow"===t?(H=!0,B.activityIndicator.isWorkflowAjaxRequest=!0,j.addClass("workflowPopup"),j.attr("aria-labelledby","".concat(S,"_labelWorkflow")),j.attr("aria-describedby","".concat(S,"_describeWorkflow")),V="dialog"):(j.addClass("window"),V=void 0!==B.popupRole&&null!==B.popupRole?B.popupRole:null==M?void 0:M.attr("aria-haspopup"));const W=(0,r.newModalLayer)(j,p,{closeOnClick:!1,closeOnEscape:!1,closeOnRecordSelected:!H,role:V}),U=T();L.renderType="contentOnly",L.popupId=U,"select"===e&&(L.selectMode=!0),A(),$.isEmptyObject(L)||(I+="?"+$.param(L)),D=$.ajax({url:I,type:"POST",dataType:"viewpartHtml",activityIndicator:B.activityIndicator,success:function(e){j.html(e),"function"==typeof m&&m(),z("#popup"+U),O.push(j),y||pe()},statusCode:{404:function(e){try{if(void 0!==(null==e?void 0:e.responseText)){const t=JSON.parse(e.responseText);if(!$.isEmptyObject(t)&&t.message&&t.synchronousLockWaiting)return}}catch(e){}(0,r.showCriticalDialog)("404: Not Found","Could not locate the URL:\n"+I,null)}},error:function(e){v&&v(W,e),W.close()},data:E})}else if("popout"===e){if(E.tab&&(I+="/"+E.tab),h){const J=T();S="popup".concat(J),L.popupId=J}const q=A(),G={openNewWindow:!0,forceNewBrowserWindow:!0===B.forceNewBrowserWindowOnPopout,downloadOnMobile:q||B.downloadOnMobile};o.mobileAccess&&(L.blah=(new Date).getTime()),I+="?"+$.param(L),ce(I,E,G)}else{if("full"===e){if(E.openBrowseFilterDialogFor&&(L.openBrowseFilterDialogFor=E.openBrowseFilterDialogFor),E.dashboardItemId){const Q=(0,r.showInformationBubble)("Dashboard Item Loading","Please wait while the Dashboard Item data loads",void 0,{closeOnClick:!1,closeOnEscape:!1});$.ajax({url:o.virtualDir+"SkySys/DashboardItem/DashboardItemPreRedirect",type:"POST",dataType:"JSON",activityIndicator:B.activityIndicator,data:{data:JSON.stringify(E)},success:Y,error:function(){Q.close("The Dashboard Item could not be loaded"),(0,r.showErrorDialog)("Error Loading Dashboard Item","The Dashboard Item could not be loaded")}})}else Y();return $.Deferred().promise();function Y(){E.tab&&(I+="/"+E.tab),g&&(E.resetBreadcrumbs=g),w&&(E.profileObject=w);const e={openNewWindow:!1,downloadOnMobile:A()||B.downloadOnMobile};$.isEmptyObject(L)||(I+="?"+$.param(L)),"string"!=typeof i||/download|export|render|getfile/i.test(i)||$(document.body).trigger("showLoadingIndicator"),ce(I,E,e)}}if("previous"===e)return"cancel"===i.toLowerCase()?(le(i),D):($.ajax({url:I,type:"POST",activityIndicator:B.activityIndicator,data:E,success:function(){le(i)}}),$.Deferred().promise());if("sortable"===e){I+="?renderType=contentOnly";const Z=$.ajax({url:I,type:"POST",dataType:"viewparthtml",activityIndicator:B.activityIndicator,data:E});D=$.whenAll([Z,Promise.all([n.e(9857),n.e(6721),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(5652)]).then(n.bind(n,54375))]).done(function(e){let[n,o]=e;const r=$(n);o.initialize(r,t,a,E)})}else if("reorderdraggable"===e)Promise.all([n.e(9857),n.e(6721),n.e(7924),n.e(7757),n.e(2528),n.e(2980),n.e(469),n.e(631),n.e(917),n.e(7658)]).then(n.bind(n,68913)).then(function(e){e.buildReorderDraggablePopUp(I,t,a,E)});else{if(E.tab&&(I+="/"+E.tab,"detailsPanel"===e&&!w)){const oe={tabType:"details",tab:E.tab};f.browse.setDetailsPanelTabData(oe)}L.renderType="contentOnly";const ee=$((null==e?void 0:e.length)>0?"#".concat(e):"");0===ee.length&&console.log('Could not find window.load() target with ID "'.concat(e,'"'));if(ee.closest(".modalLayerContainer").length>0){const re=T();S="popup".concat(re),L.popupId=re}L.blah=(new Date).getTime(),"detailsPanel"===e&&(L.renderInDetailsPanel=!0,R.skywardContentPanel=!0,f.detailsPanel.emptyDetailsPanel(),f.detailsPanel.setDetailsPanelData(t,a,i,l,E)),$.isEmptyObject(L)||(I+="?"+$.param(L));const te=$.ajaxSettings.xhr();function ae(e){if(!e)return;const t=new URL(e),[,,n,a,o,r,i]=t.pathname.split(/\//g);f.detailsPanel.setDetailsPanelData(n,a,o,r,E)}D=$.ajax({url:I,type:"POST",dataType:"viewpartHtml",activityIndicator:B.activityIndicator,xhr:()=>te,success:function(t){"detailsPanel"===e&&ae(te.responseURL),ee.trigger("ServerResponsePostLoad"),ee.trigger("DOMInsertionPreLoad"),ee.html(t),"function"==typeof m&&m(),"string"==typeof e&&e.length>0&&(z("#".concat(e),R),ee.trigger("DOMInsertionPostLoad")),y||pe(),"function"==typeof p&&p(),ee.find(".contentArea").addBack(".contentArea").trigger("contentReloaded")},error:function(){},data:E})}}return D.skyward={popupId:S},D};function ae(e,t,n,a,o,r,i,s){const l={area:t,controller:n,id:o,action:a,target:e,loadingAction:s,message:r,data:JSON.stringify(i)};ne(e,"Security","Window","GetPageLoading",null,l)}function oe(e){$.ajax(o.virtualDir+"Security/Window/UpdateRelatedRecord",{type:"POST",dataType:"JSON",async:!1,data:e})}function re(e){he(e,"FiscalYear")}function ie(e){he(e,"Entity")}function se(e){he(e,"SchoolYear")}function le(e,t){e.toLowerCase().includes("dodelete")?t?window.location.replace(t):ne("full","home","home","index"):""===document.referrer?ne("full","home","home","index"):window.location.replace(document.referrer)}function ce(e,t,n){const a=(0,o.validateDataParameter)(t),i=$.extend({openNewWindow:!1,forceNewBrowserWindow:!1,downloadOnMobile:!1,mobileFilename:void 0,actionVerb:"POST"},n),s=new URL(e,window.location.href),l=s.host!==window.location.host||!s.pathname.startsWith(o.virtualDir.slice(0,-1));if(o.mobileAccess){const e=s.search.split(/[?&]/);(a.mfwOpenAttachment||e.includes("mfwOpenAttachment=true"))&&(i.downloadOnMobile=!0),i.openNewWindow&&(a.mfwOpenExternal||e.includes("mfwOpenExternal=true")||l)&&(i.openNewWindow=!1)}if(o.mobileAccess&&i.downloadOnMobile)$.ajax({url:e+(-1===e.lastIndexOf("?")?"?":"&")+$.param({mfwMaybeDownload:!0}),type:i.actionVerb,dataType:"maybebinary",data:a,headers:{Accept:"","X-Default-Filename":i.mobileFilename}});else if(o.mobileAccess&&i.openNewWindow)e+=(-1===e.lastIndexOf("?")?"?":"&")+$.param({renderType:"contentOnly",mfwMaybeDownload:!0}),$.ajax({url:e,type:i.actionVerb,data:a,headers:{Accept:"text/html, text/plain","X-Default-Filename":i.mobileFilename},success:function(e,t,n){if(null!==n.getResponseHeader("X-Externally-Downloaded"))return;const a=$("<div>").append(e);a.find(".menuContentArea").attr("class","menuContentAreaMobile"),(0,r.showInformationDialog)("",a.html(),void 0,{allowNoButtons:!0,height:"90%",width:"90%",resizable:!1})}});else{const t=(0,o.createHiddenInputForm)(e,a,i.openNewWindow,l,i.actionVerb);if(i.openNewWindow&&i.forceNewBrowserWindow){const e="skyward_new_window_"+Math.random().toString(36).substring(2);window.open("",e,"width="+screen.width+",height="+screen.height+",left=0,top=0,toolbar=yes,location=yes,resizable=yes,scrollbars=yes"),t.prop("target",e)}(0,o.submitAndRemoveHiddenInputForm)(t)}}function de(e){const t=$.Deferred();return f.changeTracking.isDirty()?f.changeTracking.showDirtyScreenModal(e).then(t.resolve).catch(t.reject):(e(),t.resolve()),t.promise()}function ue(){location.reload()}function fe(e){return $(e).closest(".skywardContentPanel")}function he(e,t){const n="".concat(o.virtualDir,"Security/Window/Update").concat(t);$.ajax({url:n,type:"POST",data:{newValue:e},success:function(){window.location.reload()}})}function pe(){f.window.clientWidth=document.documentElement.clientWidth,f.window.clientHeight=document.documentElement.clientHeight,A.value=f.window.clientWidth,L.value=f.window.clientHeight,Q()}},53346(e,t,n){"use strict";n.r(t),n.d(t,{addDisableNavigationPromise:()=>M,callLoadContentFromUrl:()=>R,closeWorkflowPopup:()=>L,customButtonAction:()=>N,getPendingWorkflowInstances:()=>B,getSavedData:()=>I,getScreenValues:()=>A,getTopMostWorkflow:()=>T,getTopMostWorkflowData:()=>x,workflowList:()=>P});var a=n(79126),o=n(2894),r=n(88157),i=n(49343),s=n(66952),l=n(81975),c=n(44061),d=n(62521),u=n(3543),f=n(40096),h=n(40346),p=n(46740),m=n(65302),g=n(917),w=n(1380),v=n(83289),b=n(92214),y=n(63302),_=n(64078),C=n(22528);function k(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function S(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?k(Object(n),!0).forEach(function(t){D(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):k(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function D(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const E=window.skyward,P={},O={primaryButtonPressed:function(){const e=$(this);(0,d.selectRowByElement)(e);const t=e.closest(".workflow").data("workflow-instance-id"),n=e.data(),a=P[t];if(!a)return $.Deferred().reject(new Error("Workflow not found for id ".concat(t))).promise();if(void 0!==n.workflowVariableValue&&void 0!==n.workflowVariableToSet){const e={};return e[n.workflowVariableToSet]=n.workflowVariableValue,a.saveData(e)}if(void 0!==n.workflowCustomButtonName)return a.customButtonAction(n.workflowCustomButtonName);return $.Deferred().resolve().promise()},closeWorkflowPopup:L};function B(){const e=[],t=[];$("[data-workflow-instance-id]").each(function(){const e=$(this),n=e.attr("data-workflow-instance-id"),a=e.find(".workflowContent").attr("data-workflow-task-instance-id");n&&a&&t.push({workflowInstanceId:n,taskInstanceId:a})});const n={id:"pendingWorkflows",items:t,skip:!0};return e.push(n),e}function T(){return $(".modalLayerContainer .workflowPopup").last()}function x(){return T().find(".workflow").data()}function M(e){let t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];const n=T(),a=n.find(".toolbar"),o=n.find(".workflowContent:first");let i=n.data("disableWorkflowNavigationPromiseCount")||0;(0,g.toggle)(a.find(".button"),!1),i+=1,n.data("disableWorkflowNavigationPromiseCount",i),e=$.when(e).always(()=>{if(i=n.data("disableWorkflowNavigationPromiseCount")||0,i-=1,n.data("disableWorkflowNavigationPromiseCount",i),0===i&&((0,g.toggle)(a.find(".button"),!0),t)){const e=(0,r.getLayerFromElement)(o);e&&(0,w.setFocus)(e)}})}function I(e,t){const n=e||{};return t.find("[name]:not(.doNotPost, .doNotPost *)").each(function(){const e=$(this),t=e.attr("name");if(""!==t){let o=(0,g.getValue)(e);var a;if(o instanceof Date||e.is("sky-datepicker"))o=e.is(".datepicker")&&E.datepicker.isValidDateObject(o)?(0,l.formatServerDate)(o,!e.is(".datepicker")):!e.is(".datepicker")&&(0,l.isDate)(o)?(0,l.formatServerDate)(o,!e.is("sky-datepicker")):""===(null===(a=e.val())||void 0===a?void 0:a.trim())?"":new Date(NaN);e.is(":radio")&&!o||(n[t]=o)}}),t.find(".checkboxBrowse").each(function(){const e=$(this),t=(0,u.getBrowseById)(e.attr("id"));n[t.workflowVariableName]=JSON.stringify({defaultChecked:t.defaultChecked,datas:(0,p.getSerializedOverriddenCheckboxDatas)(t),hash:t.workflowCheckboxHash,search:(0,s.decodeHtml)(t.browseSearchCondition)})}),t.find(".editablebrowse").each(function(){const e=$(this).attr("id"),t=(0,v.getEditableData)(e);n[e]=t}),n}function A(e,t){let n=e.data("warninghash");void 0!==n&&"string"!=typeof n&&(n=JSON.stringify(e.data("warninghash")));const a=e.data("workflow-task-instance-id"),o=(0,g.getOriginalValuesData)("[data-workflow-task-instance-id='"+a+"']");return{id:a,warninghash:n,warninghashes:JSON.stringify(e.data("warninghashes")||{}),json:JSON.stringify(I(t,e)),controls:o.controls,editableFields:(0,g.getEditableFields)(e)}}function L(){const e=T();if(e.length>0){const t=e.find(".workflow").data("workflow-instance-id");delete P[t];const n=(0,r.getLayerFromElement)(e);if(n)return i.popupList.shift(),n.options.forceClose=!0,n.close()}return!0}function R(e){return F(e.redirectURL,e.referrerURL,e.loadContentSettings)}function N(e){const t=T().find(".workflow").data("workflow-instance-id"),n=P[t];return n?n.customButtonAction(e):$.Deferred().reject().promise()}function F(e,t,n,a){if(!e&&!t)return $.Deferred().resolve().promise();let r;if(e&&""!==e)r=e;else if(r=t,window.location.origin+o.virtualDir+r===window.location.href.replace(window.location.hash,""))return $.Deferred().resolve().promise();let s=null;if(r.indexOf("?")>0){const e=r.substring(r.indexOf("?")+1),t=new URLSearchParams(e);t.delete("w"),t.delete("p"),t.size&&(s={},t.forEach((e,t)=>{s[t]=e})),r=r.substring(0,r.indexOf("?"))}const l=r.split("/"),c=l.length>0?l[0]:null,d=l.length>1?l[1]:null,u=l.length>2?l[2]:null,f=l.length>3?l[3]:null,h=l.length>4?l[4]:null;h&&(s=S(S({},s),{},{tab:h}));let p="";p="workflow"===(null==c?void 0:c.toLowerCase())&&"workflowinstance"===(null==d?void 0:d.toLowerCase())&&$("[data-workflow-instance-id='"+f+"']").length<=0?"popup":$(".workflowPopup").length<=0?"full":null!=a?a:"";const m="string"==typeof n?JSON.parse(n):n;return(0,i.loadContent)(p,c,d,u,f,s,void 0,void 0,void 0,void 0,void 0,void 0,void 0,void 0,void 0,m)}(0,b.registerEvents)("workflow",O),(0,a.registerErrorDataGatherer)("workflow",function(){return{openWorkflows:$(".workflowPopup .workflow").toArray().map(function(e){const t=$(e),n=t.data(),a=t.parent(".workflowPopup").attr("id"),o=t.find(".workflowFriendlyName").text(),r=t.find(".taskDescription").text(),i=t.find(".workflowContent").data();return{workflowInstanceId:n.workflowInstanceId,popupId:a,taskInstanceId:i.taskInstanceId,taskInstanceDynamicPath:i.taskInstanceDynamicPath,name:o,description:r}}),pendingWorkflows:B()[0].items}}),(0,i.registerLoadDOMCallback)(function(){this.find(".workflow").each(function(e){const t=$(this),n=t.find(".toolbar"),s=t.find(".workflowContent:first"),l=t.find(".js-workflowNewWindowButton"),p=t.data("workflowInstanceId"),v={currentTaskInstanceId:null},b=t.parent(".workflowPopup"),k=b.attr("id");o.mobileAccess?l.hide():(!function(){const e=window.location.pathname;let t;$.isEmptyObject(e)||(t=e.split("/"),t.length<=5&&(t[5]=null));l.on("click",function(){(0,i.loadContent)("popout",t[2],t[3],t[4]||"index",t[5])})}(),b.draggable({cancel:".workflowHeader > a",handle:".workflowHeader",scroll:!1}),(0,r.setupDraggableLimits)(b)),(0,i.registerLoadDOMCallback)(()=>{this===t[0]&&function(){const e=[".button .save",".button .saveAndForward",".button .update",".button .arrowRight"],a=n.find(e.join(",")).filter(":visible").length>0,o=s.find(":input").not("[type=hidden]").length>0,r=t.closest(".layerPseudoForm");if(!a||!o)return void r.removeAttr("role");const i=t.find(".workflowFriendlyName").addIds().attr("id");r.attr("aria-labelledby",i),r.attr("role","form")}()}),$("#currentPage label").css("display","inline-block");const S=(0,f.manageButtonClick)(function(){const e=$.Deferred();return $.ajax(o.virtualDir+"workflow/TaskInstance/partialcommit",{type:"POST",dataType:"JSON",data:{id:v.currentTaskInstanceId,editableFields:(0,g.getEditableFields)(s)},activityIndicator:{isWorkflowAjaxRequest:!0},success:function(n){if(t.find(".dirty.workflowButton").each(function(){$(this).remove()}),n.previousTaskInstanceID){var a=T().attr("id");(0,f.waitForFunction)(e,(0,i.loadContent)(a,"workflow","taskinstance","currentinstance",n.previousTaskInstanceID))}else F(n.redirectURL,void 0,n.redirectSettings,k),e.resolve()},error:function(){e.resolve()}}),e.promise()}),D=(0,f.manageButtonClick)(function(){return H(null)}),O=(0,f.manageButtonClick)(function(){var e=(0,g.getOriginalValuesData)("[data-workflow-task-instance-id='"+v.currentTaskInstanceId+"']");return $("[data-pending-task-instance='"+v.currentTaskInstanceId+"']").remove(),$.ajax(o.virtualDir+"workflow/TaskInstance/cancel/"+v.currentTaskInstanceId,{type:"POST",data:e,activityIndicator:{hideGlass:!0,isWorkflowAjaxRequest:!0},success:function(e){L(),$(document.body).trigger(e.cancelEventName),e.redirectOnCancel&&F(e.redirectURL,void 0,e.redirectSettings,k)}})}),B=(0,f.manageButtonClick)(function(){const e=$(this);if("true"!==e.attr("data-prevent-task-completion")){const t="false"===e.attr("data-go-to-next-task"),n="true"===e.attr("data-task-instance-redirect");return N(e.attr("data-custom-button-name"),t,n,v,s)}});n.on("click",".js-workflow__previous.dirty:not([ui-disabled])",null,S).on("click",".js-workflow__confirm.dirty:not([ui-disabled])",null,D).on("click",".js-workflow__cancel",null,O).on("click","a.workflowButton.dirty:not([ui-disabled])",null,B),(0,h.setUpChangeTracking)(s.filter(".js-changeTrackingRoot"));const x=s.data("workflowTaskInstanceId"),A=$("#pendingWorkflows .instance"),R={};if(x)!function(e,n){v.currentTaskInstanceId=e;const a=(new Date).getTime();let l="workflow/TaskInstance/DetailsContent/";n&&(l=n);let c=$.Deferred();M(c),$.ajax(o.virtualDir+l+v.currentTaskInstanceId+"?renderType=contentOnly&blah="+a,{type:"POST",dataType:"viewpartHtml",activityIndicator:{isWorkflowAjaxRequest:!0},data:{inWorkflow:!0,currentTaskInstanceId:v.currentTaskInstanceId},complete:function(){c.resolve()},success:function(e){const n=$("<div>").append(e);if(function(e,t){const n=".js-refArea--dont-move",a=e.find('.contentReference:not("'+n+'"), .refArea:not("'+n+'")');a.length&&(a.addClass("refArea--workflow").insertBefore(t),a.hasClass("contentReference")&&(0,i.notifyDOMLoad)("[data-workflow-instance-id='"+p+"'] .contentReference"),a.hasClass("refArea")&&(0,i.notifyDOMLoad)("[data-workflow-instance-id='"+p+"'] .refArea"))}(n,s),s.append(n.children()),function(){const e=t.find("#baseWorkflowErrorContainer");e.length>0&&e.parent().prepend(e)}(),(0,i.notifyDOMLoad)("[data-workflow-instance-id='"+p+"'] .workflowContent",{skywardContentPanel:!0}),t.trigger("workflow-contentLoaded"),!o.mobileAccess){const e=(0,r.getLayerFromElement)(s);if(e){const t=$(e.options.initialFocusElement);t.length&&e.container.get(0).contains(t[0])||(e.options.initialFocusElement=s.find(":tabbable").first()),(0,w.setFocus)(e),function(e){const t=e.beforeClose;function n(t){if(E.keys.getKeyNamesFromEvent(t).ESC&&o(e)){const t=a(e)?O:L;(0,r.showWarningDialog)("close this Workflow","Any changes will not be saved.",{onConfirm:t})}}function a(e){return!!("object"==typeof e&&e.container instanceof $&&e.contents instanceof $)&&e.contents.find(".js-workflow__cancel").not(".ui-disabled").not(".workflow-disabled").length>0}function o(e){if("object"==typeof e&&e.container instanceof $&&e.contents instanceof $){return(0,r.getOpenModalLayers)().last().is(e.container)}return!1}e.beforeClose=function(){if($(document).off("keydown",n),"function"==typeof t)return t.apply(null,arguments)},$(document).on("keydown",n)}(e)}}}})}(x,s.data("taskInstanceDynamicPath"));else if(A.length>0){for(const e of A){W($(e))}A.remove()}else p&&E.taskstatus.beginAsyncStatusReport(p,V,j,null);function N(e,t,n,a,r){const i=$.Deferred();return $.ajax("".concat(o.virtualDir,"workflow/TaskInstance/setcustombuttonvariable/"),{type:"POST",dataType:"JSON",data:{id:a.currentTaskInstanceId,customButtonName:e},activityIndicator:{isWorkflowAjaxRequest:!0},success:function(e){const a={};a[e.variableName]=e.variableValue,(0,f.waitForFunction)(i,H(a,t,n))},error:function(){i.resolve()}}),i.promise()}function j(e){const t=e||{},n=k;return(0,i.loadContent)(n,"workflow","taskinstance","currentinstance",t.taskInstanceId)}function V(e,t){const n=e||{};let r;$("[data-pending-task-instance='"+v.currentTaskInstanceId+"']").remove(),L(),n.completeEventName&&$(document.body).trigger(n.completeEventName,n);const s=n.updateControl?function(e){const t=["#moduleContent .toolContents","#moduleContent .contentArea","#moduleContent .dataObjectViewer","#detailsPanel .contentArea","#detailsPanel .dataObjectViewer",".filterBuilder"],n=(0,i.getCurrentPopupId)();n>=0&&t.unshift("#popup"+n);let a,o;for(const n of t){var r;if(o=$(n),o.length)if(a=o.find("[name='"+(null===(r=e.updateControl)||void 0===r?void 0:r.pageStateControl)+"']"),a.length)break}return a}(n):void 0;if(void 0!==s&&0!==s.length||!(n.redirectURL||n.referrerURL||n.externalRedirectTargetBlankURL)||(r=function(){n.externalRedirectTargetBlankURL?window.open(n.externalRedirectTargetBlankURL,"_blank"):F(n.redirectURL,n.referrerURL,n.redirectSettings,k)},!0!==t&&r()),n.updateControl){const e=$("#"+n.updateControl.pageStateControl);if(n.popoutURL){const e=n.popoutURL.split("/"),t=e.length>4?{tab:e[4]}:{};(0,i.loadContent)("popout",e[0],e[1],e[2],n.updateControl.primaryKey,t)}const t=void 0!==(0,u.getBrowseById)(n.updateControl.pageStateControl),r=void 0!==(0,u.getBrowseById)("detailsPanel_"+n.updateControl.pageStateControl);if(t||r){let e,a;t&&(e=n.updateControl.pageStateControl,a={},a.seekId=n.updateControl.primaryKey,(0,d.get)(e,a),(0,y.reloadReferenceByControlId)(e)),r&&(e="detailsPanel_"+n.updateControl.pageStateControl,a={},a.seekId=n.updateControl.primaryKey,(0,d.get)(e,a),(0,y.reloadReferenceByControlId)(e))}else if(e.hasClass("ajaxRepeaterPlaceHolder"))(0,c.load)(e);else if(s&&s.length>0){s.triggerHandler("workflowEnd",n)||(!async function(e,t){var n;const r=null===(n=e.updateControl)||void 0===n?void 0:n.primaryKey,i=t.data();let s=i.area,l=i.controller,c=i.action,d=!1;if(t.hasClass("codeEELValue"))return void(0,g.setValue)(t.closest(".codeEEL"),r);let u={};u.securityHash=i.securityHash,t.hasClass("tileViewEEL_search")&&(d=!0,s=i.updateControlAfterWorkflowArea,l=i.updateControlAfterWorkflowController,c=i.updateControlAfterWorkflowAction,$.extend(u,_.getPostData(i,t)));if(!s||!l||!c){var f;return(0,a.reportException)(new a.SkywardException("Control ".concat(null!==(f=t.attr("name"))&&void 0!==f?f:t.attr("id")," was set to update after the workflow ").concat(e.completeEventName," id ").concat(e.workflowInstanceID," ")+"completed, but it is missing required URL path parameters.","",a.Severity.Error,"fafa5ed8-d71e-48e6-a3e9-c448d64bd3e4")),void t.find(".codeEELValue").val(r)}const h=await $.ajax({url:"".concat(o.virtualDir).concat(s,"/").concat(l,"/").concat(c,"/").concat(r),type:"POST",data:u,dataType:"JSON"});if(d)return void _.populateBoxes(t.parent().parent(),h,r);(0,a.reportException)(new a.SkywardException("Reached fallback code in workflow.js updateControlWithValue()",void 0,a.Severity.Info,"2c72d112-87df-45a7-adfb-11e8abf62d57"));const p=t.hasClass("codeEELValue")?t:t.find(".codeEELValue"),w=p.parent();p.val(r),"AccountDimensionEEL"===i.action?E.accountDimensionEEL.populateBoxes(w,h):(0,m.populateBoxes)(w,h,!0)}(n,s),(n.redirectURL||n.referrerURL)&&F(n.redirectURL,n.referrerURL,n.redirectSettings))}else e&&e.length>0&&e.triggerHandler("workflowEnd",n)}if(!0===t)return r}function H(e,n,a){const r=(0,g.getOriginalValuesData)("[data-workflow-task-instance-id='"+v.currentTaskInstanceId+"']"),i=I(e,s),l=$.Deferred();if(!E.dataobjectviewer.preSaveValidation(s))return l.resolve();let c=s.data("warninghash");return void 0!==c&&"string"!=typeof c&&(c=JSON.stringify(s.data("warninghash"))),$.ajax(o.virtualDir+"workflow/TaskInstance/commit",{type:"POST",dataType:"JSON",data:{id:v.currentTaskInstanceId,warninghash:c,warninghashes:JSON.stringify(s.data("warninghashes")||{}),json:JSON.stringify(i),controls:r.controls,editableFields:(0,g.getEditableFields)(s),workflowTemplateID:t.find(".js-workflowTemplateMenu-TemplateEEL").val()},activityIndicator:{isWorkflowAjaxRequest:!0},success:function(e){if("F"===e.workflowStatus){const n=t.find("#baseWorkflowErrorContainer");(0,C.displayValidationMessages)(e,s,n),l.resolve()}else s.data("workflowTaskInstanceId",""),a&&e.redirectURL?(0,f.waitForFunction)(l,F(e.redirectURL,void 0,void 0,k)):n?(L(),window.location.reload()):(0,f.waitForFunction)(l,E.taskstatus.beginAsyncStatusReport(p,V,j,null))},error:function(){l.resolve()}}),l.promise()}function W(e){const t=e.data("pendingTaskInstance"),n=e.data("pendingWorkflowInstance");$("[data-workflow-instance-id='"+n+"']").length<=0&&(0,i.loadContent)("popup","Workflow","WorkflowInstance","CurrentInstance",n,void 0,void 0,void 0,function(){$("[data-workflow-task-instance-id='"+t+"']").length>=0&&(R.taskInstanceId=t,j(R))},void 0,void 0,function(t){(0,i.closePopup)(t),e.remove()})}void 0!==p&&(P[p]={customButtonAction:(e,t,n)=>N(e,t,n,v,s),saveData:H})})})},10631(e,t,n){"use strict";n.d(t,{Ay:()=>_,qE:()=>C});var a=n(74061),o=n(2894),r=n(66952),i=n(81975),s=n(90121),l=n(98925),c=n(75552),d=n(6253),u=n(32529),f=n(97862);const h="dateTimePickerModal",p="dateTimePickerModal--date",m=(0,a.defineComponent)({name:"datePickerModal",emits:{"update:value":e=>!0},props:{close:(0,c.oY)(Function),inputRef:(0,c.oY)(Object),value:(0,c.JJ)(Date,{default:()=>(0,i.now)()})},setup(e,t){const n=(0,a.useModel)(e,"value"),o=(0,i.now)(),r=e.value?e.value.getMonth()+1:o.getMonth()+1,s=e.value?e.value.getFullYear():o.getFullYear(),l=(0,a.ref)(r),m=(0,a.ref)(s),g=(0,a.computed)(()=>e.value&&e.value.getFullYear()>o.getFullYear()+10?e.value.getFullYear():o.getFullYear()+10),w=(0,a.computed)(()=>e.value&&e.value.getFullYear()<1900?e.value.getFullYear():1900),v=(0,a.ref)();(0,c.xF)(document.body,"keydown",function(t){var a;const o=t.key.toUpperCase();if(null!==(a=t.target.getAttribute("class"))&&void 0!==a&&a.includes("quickEELSelector"))return void("TAB"!==o&&t.preventDefault());"ARROWUP"!==o&&"ARROWDOWN"!==o&&"PAGEUP"!==o&&"PAGEDOWN"!==o&&"HOME"!==o&&"END"!==o||t.preventDefault();if(t.altKey&&("ARROWUP"===o||"ARROWDOWN"===o)){var r;return void(null===(r=e.inputRef.value)||void 0===r||r.focus())}if("T"===o||"R"===o||"Y"===o){t.preventDefault(),t.stopPropagation();const e=(0,i.now)();"R"===o&&e.setDate(e.getDate()+1),"Y"===o&&e.setDate(e.getDate()-1),l.value=e.getMonth()+1,m.value=e.getFullYear(),n.value=e}});const b=(0,a.ref)();return t.expose({focusCurrentDay(){var e;null===(e=b.value)||void 0===e||e.focusCurrentDay()}}),()=>(0,a.createVNode)("div",{class:[h,p],ref:v},[(0,a.createVNode)(f.A,{month:l.value,year:m.value,yearLow:w.value,yearHigh:g.value,"onUpdate:month":e=>l.value=e,"onUpdate:year":e=>m.value=e},null,8,["month","year","yearLow","yearHigh","onUpdate:month","onUpdate:year"]),(0,a.createVNode)(d.A,{month:l.value,year:m.value,yearLow:w.value,yearHigh:g.value,selectedDate:n.value,"onUpdate:month":e=>l.value=e,"onUpdate:year":e=>m.value=e,"onUpdate:selectedDate":e=>n.value=e,ref:b},null,8,["month","year","yearLow","yearHigh","selectedDate","onUpdate:month","onUpdate:year","onUpdate:selectedDate"]),(0,a.createVNode)(u.A,{buttonText:"Today",onButtonClick:y,onDoneClick:e.close},null,8,["onButtonClick","onDoneClick"])],2);function y(){const t=(0,i.now)();t.setHours(0,0,0,0),l.value=t.getMonth()+1,m.value=t.getFullYear(),n.value=t,e.close()}}}),g="datePicker",w="dateTimePicker__svg",v="datePicker__helpText";var b=function(e){return e.Month="M",e.Day="D",e.Year="Y",e}(b||{});const y=(0,a.defineCustomElement)({name:"sky-datepicker",shadowRoot:!1,inheritAttrs:!1,props:{name:(0,c.uh)(String),value:{type:String,required:!1,default:null,validator:e=>!e||"string"==typeof e&&(0,i.parseDate)(e).isValidDate()},autocomplete:(0,c.uh)(String),dependents:(0,c.uh)(Object),ariaLabelledby:(0,c.uh)(String),tabindex:(0,c.uh)(Number),contained:(0,c.uh)(Boolean),hideDayOfWeek:{type:Boolean,default:!1}},setup(e,t){const n=(0,a.ref)(),c=(0,a.ref)(!1);let d=(0,a.useHost)();const u=()=>{var e;d||(d=null===(e=n.value)||void 0===e?void 0:e.closest("sky-datepicker"));return d},f=()=>{var e;return"true"===(null===(e=u())||void 0===e||null===(e=e.getAttribute("aria-readonly"))||void 0===e?void 0:e.toLowerCase())},h=(0,a.ref)(f()),p=()=>{var e;return(null===(e=u())||void 0===e?void 0:e.id)||void 0},y=(0,a.ref)(p()),_=(0,a.computed)({get:()=>e.value,set:e=>{const t=u();t&&(t.value=e)}});(0,a.watch)(()=>e.value,e=>{!e||"string"==typeof e&&(0,i.parseDate)(e).isValidDate()||(_.value="")},{flush:"sync",immediate:!0});const S=(0,a.computed)({get:()=>{if(""===e.value||null===e.value||void 0===e.value)return;const t=(0,i.parseDate)(e.value);return t.isValidDate()?t:void 0},set:e=>{let t="";null!=e&&e.isValidDate()&&(e.setHours(0),e.setMinutes(0),e.setSeconds(0),e.setMilliseconds(0),t=(0,i.formatServerDate)(e,!1)),_.value=t}});t.expose({_valueAsDateRef:()=>S,_closeModal:x});const D=(0,a.ref)(!1);(0,a.onBeforeMount)(()=>{y.value&&$.findLabel(y.value).attr("for","".concat(y.value,"_input"))});const E=new MutationObserver(()=>{h.value=f(),y.value=p()});(0,a.onMounted)(()=>{var t,a;e.ariaLabelledby&&(null===(t=n.value)||void 0===t||t.setAttribute("aria-labelledby",e.ariaLabelledby),null===(a=u())||void 0===a||a.removeAttribute("aria-labelledby"));const o=u();o&&E.observe(o,{attributes:!0,attributeFilter:["aria-readonly","id"]})}),(0,a.onUnmounted)(()=>{E.disconnect()});const P=(0,r.nextAutoId)(),O=(0,r.nextAutoId)(),B=(0,a.ref)();return()=>{var t;return(0,a.createVNode)(a.Fragment,null,[(0,a.createVNode)("input",{type:"text",class:g,placeholder:"MM/DD/YYYY",readonly:h.value,autocomplete:null!==(t=e.autocomplete)&&void 0!==t?t:"off",ref:n,onClick:j,onFocusin:I,onInput:W,onChange:H,onKeyup:N,onKeydown:L,onPaste:M,value:k(S.value,e.hideDayOfWeek),id:y.value?"".concat(y.value,"_input"):void 0,"data-dependents":JSON.stringify(e.dependents),role:"combobox","aria-expanded":"closing"===D.value||D.value,"aria-haspopup":"dialog","aria-controls":P,"aria-autocomplete":"none","aria-describedby":h.value?o.readOnlyAnnouncementID:O,tabindex:e.tabindex},null,42,["readonly","autocomplete","onClick","onFocusin","onInput","onChange","onKeyup","onKeydown","onPaste","value","id","data-dependents","aria-expanded","aria-controls","aria-describedby","tabindex"]),!0===D.value&&(0,a.createVNode)(s.A,{containerId:P,expose:[T()],anchorTo:T(),preserveFocus:e=>"escape"===e,ariaLabel:"Choose date",onClose:x},{default:()=>[(0,a.createVNode)(m,{ref:B,inputRef:n,close:x,value:S.value,"onUpdate:value":e=>{U(e),x()}},null,8,["inputRef","close","value","onUpdate:value"])]},8,["containerId","expose","anchorTo","preserveFocus","onClose"]),(0,a.createVNode)(l.A,{name:"Date","aria-haspopup":"menu",role:"button",showHoverEffect:!1,class:w,onClick:()=>function(e){if(!0===D.value)return void x();F(e)}("svg click"),isButton:!h.value,"aria-label":"Date Picker"},null,8,["class","onClick","isButton"]),(0,a.createVNode)("div",{id:O,class:v},[(0,a.createTextVNode)("Type a date or use the down arrow key to navigate to the date picker")],10,["id"])])};function T(){const t=n.value.parentElement;return e.contained?t.parentElement:t}async function x(){var e;(D.value="closing",await(0,a.nextTick)(),D.value=!1,document.activeElement!==n.value)&&(c.value=!0,null===(e=n.value)||void 0===e||e.focus());_.value&&A(b.Month)}function M(e){var t;e.preventDefault();const n=null===(t=e.clipboardData)||void 0===t?void 0:t.getData("text/plain").replace(new RegExp("\\b(?:".concat(i.DAYS_OF_WEEK.join("|"),")\\b"),"g"),""),a=new Date(null!=n?n:"");return!(!n||!a.isValidDate())&&(U(a),!1)}function I(e){var t;const n=e.target;var a;if("true"===n.getAttribute("data-suppress-focus")||"true"===(null===(t=u())||void 0===t?void 0:t.getAttribute("data-suppress-focus")))return n.removeAttribute("data-suppress-focus"),void(null===(a=u())||void 0===a||a.removeAttribute("data-suppress-focus"));c.value?c.value=!1:F("focusin")}function A(e){const t=n.value,a=t.value.replace(/[^\d/]/g,""),o=a.indexOf("/"),r=a.indexOf("/",o+1),i=a.length;let s=null,l=null;switch(e){case b.Month:s=0,l=-1!==o?o:i,t.setSelectionRange(s,l);break;case b.Day:-1!==o&&(s=o+1,l=-1!==r?r:s,t.setSelectionRange(s,l));break;case b.Year:-1!==r&&(s=r+1,l=i,t.setSelectionRange(s,l))}}async function L(e){const t=window.skyward.keys.getKeyNamesFromEvent(e);if(t.ARROW_RIGHT||t.ARROW_LEFT){e.preventDefault(),e.stopPropagation();const n=e.target.selectionStart,a=e.target.selectionEnd;return void R(t.ARROW_LEFT,t.ARROW_RIGHT,n,a)}if(!D.value&&t.ALT&&(t.ARROW_DOWN||t.ARROW_UP)&&F("keydown"),t.ENTER){e.preventDefault(),e.stopPropagation(),D.value&&(D.value=!1);return void U(C(n.value.value.slice(0,10)))}if(D.value&&t.TAB){D.value=!1;return void U(C(n.value.value.slice(0,10)))}var o;(t.ARROW_UP||t.ARROW_DOWN)&&(e.preventDefault(),e.stopPropagation(),D.value||(F("keydown"),await(0,a.nextTick)()),null===(o=B.value)||void 0===o||o.focusCurrentDay())}function R(e,t,a,o){const r=n.value,i=r.value.replace(/[^\d/]/g,""),s=i.indexOf("/"),l=i.indexOf("/",s+1);if(-1!==s)if(t)V(r,a,o,0,s)?A(b.Day):-1!==l&&V(r,a,o,s+1,l)?A(b.Year):-1!==l&&V(r,a,o,l+1,r.value.length)&&A(b.Month);else if(e){if(V(r,a,o,0,s))A(b.Year);else if(V(r,a,o,s+1,r.value.length)){if(-1!==l&&V(r,a,o,l+1,r.value.length))return void A(b.Day);A(b.Month)}}else if(V(r,a,o,0,s))A(b.Month);else if(V(r,a,o,s+1,r.value.length)){if(-1!==l&&V(r,a,o,l+1,r.value.length))return void A(b.Year);A(b.Day)}}function N(e){if(D.value||h.value)return;const t=window.skyward.keys.getKeyNamesFromEvent(e);if(t.T||t.R||t.Y){const e=(0,i.now)();t.R?e.setDate(e.getDate()+1):t.Y&&e.setDate(e.getDate()-1),U(e)}}function F(e){var t;h.value||!1!==D.value||(D.value=!0,null===(t=d)||void 0===t||t.scrollIntoView({block:"nearest"}),"svg click"===e&&n.value&&n.value.focus())}function j(e){R(!1,!1,e.target.selectionStart,e.target.selectionEnd)}function V(e,t,n,a,o){return t>=a&&n<=o}function H(e){e.preventDefault(),e.stopPropagation();U(C(n.value.value.slice(0,10)))}async function W(e){const t=e.target;let n=t.selectionEnd;const o=t.value.replace(/[^\d/]/g,""),r=o.split("/");if(r.length>3){e.preventDefault();const a=e.data;let r=o.slice(0,n);return r=r.slice(0,r.length-a.length)+o.slice(n),t.value=r,n-=a.length,void t.setSelectionRange(n,n)}let i="",s="";if(r.length>0){i=r[0].slice(2),r[0]=r[0].slice(0,2);parseInt(r[0])>12&&(i=r[0].slice(1),r[0]="0"+r[0].slice(0,1)),i.length>0&&r.length<2&&r.push(i)}if(r.length>1)if(i.length>0)r[1]=i+r[1].slice(1,2),n=4;else{5!=n&&(s=r[1].slice(2)),r[1]=r[1].slice(0,2);const e=new Date(2e3,parseInt(r[0]),0).getDate();parseInt(r[1])>e&&(s=r[1].slice(1),r[1]="0"+r[1].slice(0,1)),s.length>0&&r.length<3&&r.push(s)}r.length>2&&(s.length>0?(r[2]=s+r[2].slice(1,4),n=7):r[2]=r[2].slice(0,4)),t.value=r.join("/"),await(0,a.nextTick)(),t.setSelectionRange(n,n)}function U(t){var a,o;if(n.value.value=null!==(a=k(t,e.hideDayOfWeek))&&void 0!==a?a:"",(null===(o=S.value)||void 0===o?void 0:o.valueOf())!==(null==t?void 0:t.valueOf())){var r;S.value=t;const e=new CustomEvent("change",{bubbles:!0,detail:{internal:!0}});null===(r=u())||void 0===r||r.dispatchEvent(e)}}}});const _=class extends y{connectedCallback(){this._instance||(this.innerHTML=""),super.connectedCallback()}get valueAsDate(){return this._valueAsDateRef().value}set valueAsDate(e){this._valueAsDateRef().value=e}closeModal(){const e=this._closeModal;if("function"==typeof e)return e()}};function C(e){const t=e.split("/"),n=(0,i.now)();let a,o,r=n.getFullYear();if(!(t.length>0))return;if(a=parseInt(t[0]),isNaN(a))return;if(a<1?a=1:a>12&&(a=12),t.length>1?(o=parseInt(t[1]),(isNaN(o)||o<1)&&(o=1)):o=1,t.length>2){const e=t[2];if(e.length<3&&e.length>0){if(parseInt(e)>55)t[2]="19".concat(e);else{const n=2===e.length?"20":"200";t[2]=n+e}}r=parseInt(t[2]),isNaN(r)&&(r=n.getFullYear())}const s=new Date(r,a,0).getDate();o>s&&(o=s);const l=new Date(r,a-1,o);return l.setUTCFullYear(r),l}function k(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(!e||!e.isValidDate())return;const n=String(e.getMonth()+1).padStart(2,"0"),a=String(e.getDate()).padStart(2,"0"),o=String(e.getFullYear()).padStart(4,"0"),r="".concat(n,"/").concat(a,"/").concat(o);return t?r:"".concat(r," ").concat(i.DAYS_OF_WEEK[e.getDay()])}},6253(e,t,n){"use strict";n.d(t,{A:()=>u});var a=n(74061),o=n(75552),r=n(50217),i=n(97862);const s="datePickerCalendar",l="datePickerCalendar__table",c="datePickerCalendar__weeksHeader",d="datePickerCalendar__weeksHeaderText",u=(0,a.defineComponent)({name:"calendar",emits:{"update:selectedDate":e=>!0,"update:month":e=>!0,"update:year":e=>!0},props:{month:(0,o.oY)(Number),year:(0,o.oY)(Number),yearHigh:(0,o.oY)(Number),yearLow:(0,o.oY)(Number),selectedDate:(0,o.uh)(Date)},setup(e,t){const n=(0,a.useModel)(e,"month"),u=(0,a.useModel)(e,"year"),f=(0,a.ref)(),h=(0,a.useModel)(e,"selectedDate"),p=(0,a.ref)(),m=(0,a.computed)(()=>function(e,t){const n=[],a=new Date(e,t-1,1);a.setDate(a.getDate()-a.getDay());const o=new Date(e,t,0);o.setDate(o.getDate()+(6-o.getDay()));for(let e=new Date(a);e<=o;e.setDate(e.getDate()+1))n.push(new Date(e));return n}(u.value,n.value));return t.expose({focusCurrentDay(){var e;null===(e=p.value)||void 0===e||e.$el.focus()}}),(0,o.xF)(document.body,"keydown",async function(t){const o=window.skyward.keys.getKeyNamesFromEvent(t);if(o.ENTER){t.preventDefault();const e=t.target;if(e&&e.classList.contains(r.t.day)){const t=new Date(e.dataset.date);t.isValidDate()&&(g(t),u.value=t.getFullYear(),n.value=t.getMonth()+1)}}else if(!o.ALT&&(o.ARROW_UP||o.ARROW_DOWN||o.ARROW_LEFT||o.ARROW_RIGHT)){t.preventDefault();const s=t.target;if(s&&s.classList.contains(r.t.dayContainer)){const t=new Date(s.dataset.date);if(!t.isValidDate())return;o.ARROW_DOWN?t.setDate(t.getDate()+7):o.ARROW_UP?t.setDate(t.getDate()-7):o.ARROW_LEFT?t.setDate(t.getDate()-1):o.ARROW_RIGHT&&t.setDate(t.getDate()+1);const r=t.toISOString();if(f.value){const e=f.value.querySelector('[data-date="'.concat(r,'"]'));if(e)return void e.focus()}if(o.ARROW_DOWN||o.ARROW_RIGHT){const{month:t,year:a}=(0,i.Z)(n.value,u.value,1,e.yearHigh,e.yearLow);n.value=t,u.value=a}else if(o.ARROW_UP||o.ARROW_LEFT){const{month:t,year:a}=(0,i.Z)(n.value,u.value,-1,e.yearHigh,e.yearLow);n.value=t,u.value=a}if(await(0,a.nextTick)(),f.value){const e=f.value.querySelector('[data-date="'.concat(r,'"]'));e&&e.focus()}}}}),()=>{const e=new Date;let t;e.setHours(0,0,0,0);const o=new Date(h.value.getTime());return o.setHours(0),o.setMinutes(0),o.setSeconds(0),t=m.value.some(e=>e.valueOf()===o.valueOf())?o:m.value.some(t=>t.valueOf()===e.valueOf())&&e.getFullYear()===u.value&&e.getMonth()===n.value-1?e:new Date(u.value,n.value-1,1),(0,a.createVNode)("div",{class:s},[(0,a.createVNode)("table",{class:l,ref:f,role:"grid"},[(0,a.createVNode)("thead",{class:c},[(0,a.createVNode)("tr",null,[(0,a.createVNode)("th",{class:d},[(0,a.createVNode)("span",{"aria-hidden":"true"},[(0,a.createTextVNode)("S")]),(0,a.createVNode)("span",{class:"sr-only"},[(0,a.createTextVNode)("Sunday")])],2),(0,a.createVNode)("th",{class:d},[(0,a.createVNode)("span",{"aria-hidden":"true"},[(0,a.createTextVNode)("M")]),(0,a.createVNode)("span",{class:"sr-only"},[(0,a.createTextVNode)("Monday")])],2),(0,a.createVNode)("th",{class:d},[(0,a.createVNode)("span",{"aria-hidden":"true"},[(0,a.createTextVNode)("T")]),(0,a.createVNode)("span",{class:"sr-only"},[(0,a.createTextVNode)("Tuesday")])],2),(0,a.createVNode)("th",{class:d},[(0,a.createVNode)("span",{"aria-hidden":"true"},[(0,a.createTextVNode)("W")]),(0,a.createVNode)("span",{class:"sr-only"},[(0,a.createTextVNode)("Wednesday")])],2),(0,a.createVNode)("th",{class:d},[(0,a.createVNode)("span",{"aria-hidden":"true"},[(0,a.createTextVNode)("T")]),(0,a.createVNode)("span",{class:"sr-only"},[(0,a.createTextVNode)("Thursday")])],2),(0,a.createVNode)("th",{class:d},[(0,a.createVNode)("span",{"aria-hidden":"true"},[(0,a.createTextVNode)("F")]),(0,a.createVNode)("span",{class:"sr-only"},[(0,a.createTextVNode)("Friday")])],2),(0,a.createVNode)("th",{class:d},[(0,a.createVNode)("span",{"aria-hidden":"true"},[(0,a.createTextVNode)("S")]),(0,a.createVNode)("span",{class:"sr-only"},[(0,a.createTextVNode)("Saturday")])],2)])],2),Array.chunk(m.value.map(o=>{const i=o.getMonth()+1!==n.value,s=o.getFullYear()===h.value.getFullYear()&&o.getMonth()===h.value.getMonth()&&o.getDate()===h.value.getDate(),l=o.valueOf()===e.valueOf(),c=t.valueOf()===o.valueOf(),d=c?"0":"-1",f=c?p:void 0;return(0,a.createVNode)(r.A,{date:o,outsideMonth:i,selected:s,handleClick:function(){g(o),i&&(n.value=o.getMonth()+1,u.value=o.getFullYear())},tabIndex:d,isToday:l,ref:f},null,8,["date","outsideMonth","selected","handleClick","tabIndex","isToday"])}),7).map(e=>(0,a.createVNode)("tr",{role:"row"},[e]))],2)],2)};function g(e){const t=e;t.setHours(h.value.getHours()),t.setMinutes(h.value.getMinutes()),t.setSeconds(h.value.getSeconds()),h.value=t}}})},50217(e,t,n){"use strict";n.d(t,{A:()=>i,t:()=>r});var a=n(74061),o=n(75552);const r={dayContainer:"datePickerCalendar__dayContainer",dayContainerToday:"datePickerCalendar__dayContainer--today",dayContainerSelected:"datePickerCalendar__dayContainer--selected",day:"datePickerCalendar__day",dayToday:"datePickerCalendar__day-today",daySelected:"datePickerCalendar__day--selected",dayWeekend:"datePickerCalendar__day-weekend",dayOutsideMonth:"datePickerCalendar__day--outsideMonth",text:"datePickerCalendar__dayText"},i=(0,a.defineComponent)({name:"day",props:{date:(0,o.oY)(Date),selected:(0,o.uh)(Boolean),outsideMonth:(0,o.uh)(Boolean),handleClick:(0,o.oY)(Function),tabIndex:(0,o.oY)(String),isToday:(0,o.oY)(Boolean)},setup(e){const t=0===e.date.getDay()||6===e.date.getDay();return()=>{var i;return(0,a.createVNode)("td",{class:{[r.dayContainer]:!0,[r.dayContainerToday]:e.isToday,[r.dayContainerSelected]:e.selected},role:"gridcell",tabindex:e.tabIndex,"data-date":e.date.toISOString(),onKeydown:o,"aria-selected":null!==(i=e.selected)&&void 0!==i&&i,onClick:e.handleClick},[(0,a.createVNode)("div",{"aria-label":n(e.date),class:{[r.day]:!0,[r.dayToday]:e.isToday,[r.dayWeekend]:t&&!e.outsideMonth,[r.daySelected]:e.selected,[r.dayOutsideMonth]:e.outsideMonth}},[(0,a.createVNode)("span",{"aria-hidden":"true",class:r.text},[e.date.getDate()],2)],10,["aria-label"])],42,["tabindex","data-date","onKeydown","aria-selected","onClick"])};function n(t){const n=t.getDate(),a=t.toLocaleDateString("en-US",{month:"long"}),o=t.getFullYear();let r="".concat(n,", ").concat(a,", ").concat(o);return e.selected&&(r+=" selected"),r}function o(t){if("Enter"!==t.key){if("Tab"===t.key){const e=t.target.closest(".datePickerCalendar__table");if(e){const n="a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])";let a=e;for(;a;){let e=a.nextElementSibling;for(;e;){const a=e.matches(n)?e:e.querySelector(n);if(a)return t.preventDefault(),void a.focus();e=e.nextElementSibling}a=a.parentElement}}}}else e.handleClick()}}})},32529(e,t,n){"use strict";n.d(t,{A:()=>s});var a=n(74061),o=n(75552);const r="calendarFooterToolbar",i="footerToolbar__button",s=(0,a.defineComponent)({name:"footerToolbar",props:{buttonText:(0,o.oY)(String),onButtonClick:(0,o.oY)(Function),onDoneClick:(0,o.oY)(Function)},setup(e){return()=>(0,a.createVNode)("div",{class:r},[(0,a.createVNode)("button",{class:i,onClick:e.onButtonClick,onKeydown:t},[e.buttonText],42,["onClick","onKeydown"]),(0,a.createVNode)("button",{class:i,onClick:e.onDoneClick,onKeydown:t},[(0,a.createTextVNode)("Done")],42,["onClick","onKeydown"])],2);async function t(e){if(window.skyward.keys.getKeyNamesFromEvent(e).ENTER){e.preventDefault();document.activeElement.click()}}}})},97862(e,t,n){"use strict";n.d(t,{A:()=>u,Z:()=>f});var a=n(74061),o=n(98925),r=n(75552),i=n(62492);const s="datePickerMonthSelector",l="datePickerMonthSelector__button",c="datePickerMonthSelector__selector",d="datePickerMonthSelector__selectorButton",u=(0,a.defineComponent)({name:"monthSelector",emits:{"update:month":e=>!0,"update:year":e=>!0},props:{yearHigh:(0,r.oY)(Number),yearLow:(0,r.oY)(Number),month:(0,r.oY)(Number),year:(0,r.oY)(Number)},setup(e){var t,n,u,h;const p="combobox",m=(0,a.useModel)(e,"month"),g=(0,a.useModel)(e,"year"),w=[{value:1,text:"January"},{value:2,text:"February"},{value:3,text:"March"},{value:4,text:"April"},{value:5,text:"May"},{value:6,text:"June"},{value:7,text:"July"},{value:8,text:"August"},{value:9,text:"September"},{value:10,text:"October"},{value:11,text:"November"},{value:12,text:"December"}],v=(new Date).getFullYear(),b=(0,a.computed)(()=>{const t=[];for(let a=null!==(n=e.yearHigh)&&void 0!==n?n:v+10;a>=e.yearLow;a--){var n;const e={value:a,text:a.toString()};t.push(e)}return t}),y=(0,a.computed)(()=>12===m.value&&g.value>=e.yearHigh),_=(0,a.computed)(()=>1===m.value&&g.value<=e.yearLow),C=(0,a.ref)(null!==(t=null===(n=w.find(e=>e.value===m.value))||void 0===n?void 0:n.text)&&void 0!==t?t:"");(0,a.watch)(m,e=>{var t,n;C.value=null!==(t=null===(n=w.find(t=>t.value===e))||void 0===n?void 0:n.text)&&void 0!==t?t:""});const k=(0,a.ref)(null!==(u=null===(h=b.value.find(e=>e.value===g.value))||void 0===h?void 0:h.text)&&void 0!==u?u:"");(0,a.watch)(g,e=>{var t,n;k.value=null!==(t=null===(n=b.value.find(t=>t.value===e))||void 0===n?void 0:n.text)&&void 0!==t?t:""}),(0,a.watch)(b,e=>{var t,n;k.value=null!==(t=null===(n=e.find(e=>e.value===g.value))||void 0===n?void 0:n.text)&&void 0!==t?t:""});const S=(0,a.computed)(()=>"".concat(D(0)," ").concat(k.value));return(0,r.xF)(document.body,"keydown",function(t){const n=window.skyward.keys.getKeyNamesFromEvent(t);if(n.PAGE_UP){if(t.preventDefault(),n.SHIFT){const t=g.value+1;return void(e.yearHigh>t&&(g.value=t))}const{month:a,year:o}=f(m.value,g.value,1,e.yearHigh,e.yearLow);m.value=a,g.value=o}else if(n.PAGE_DOWN){if(t.preventDefault(),n.SHIFT){const t=g.value-1;return void(e.yearLow<t&&(g.value=t))}const{month:a,year:o}=f(m.value,g.value,-1,e.yearHigh,e.yearLow);m.value=a,g.value=o}if(t.target.classList&&t.target.classList.contains(d))if(n.ARROW_DOWN)if(t.preventDefault(),"Month"===t.target.title){const{month:t,year:n}=f(m.value,g.value,-1,e.yearHigh,e.yearLow);m.value=t,g.value=n}else{const t=g.value-1;e.yearLow<t&&(g.value=t)}else if(n.ARROW_UP)if(t.preventDefault(),"Month"===t.target.title){const{month:t,year:n}=f(m.value,g.value,1,e.yearHigh,e.yearLow);m.value=t,g.value=n}else{const t=g.value+1;e.yearHigh>t&&(g.value=t)}}),()=>(0,a.createVNode)("div",{class:s},[(0,a.createVNode)("span",{class:"sr-only","aria-atomic":!0,"aria-live":"polite"},[S.value]),(0,a.createVNode)("div",{role:"button",class:l,title:"Previous Month","aria-label":"Go to ".concat(D(-1)),"aria-disabled":_.value,onClick:()=>{const{month:t,year:n}=f(m.value,g.value,-1,e.yearHigh,e.yearLow);m.value=t,g.value=n},tabindex:_.value?-1:0},[(0,a.createVNode)(o.A,{name:"ArrowLeft",ignoreTabIndex:!0,showHoverEffect:!1,svgClasses:{"ui-disabled":_.value},isButton:!0},null,8,["svgClasses"])],10,["aria-label","aria-disabled","onClick","tabindex"]),(0,a.createVNode)(i.A,{class:c,additionalButtonClasses:d,text:C,title:"Month",ariaLabel:"Search Month",options:w,value:m.value,"onUpdate:value":e=>m.value=e,popupMaxHeight:"16rem",role:p},null,8,["class","additionalButtonClasses","text","options","value","onUpdate:value","role"]),(0,a.createVNode)(i.A,{class:c,additionalButtonClasses:d,text:k,title:"Year",ariaLabel:"Search Year",options:b.value,value:g.value,"onUpdate:value":e=>g.value=e,popupMaxHeight:"16rem",role:p},null,8,["class","additionalButtonClasses","text","options","value","onUpdate:value","role"]),(0,a.createVNode)("div",{role:"button",class:l,title:"Next Month","aria-label":"Go to ".concat(D(1)),"aria-disabled":y.value,onClick:()=>{const{month:t,year:n}=f(m.value,g.value,1,e.yearHigh,e.yearLow);m.value=t,g.value=n},tabindex:y.value?-1:0},[(0,a.createVNode)(o.A,{name:"ArrowRight",ignoreTabIndex:!0,showHoverEffect:!1,svgClasses:{"ui-disabled":y.value},isButton:!0},null,8,["svgClasses"])],10,["aria-label","aria-disabled","onClick","tabindex"])],2);function D(e){var t;let n=(m.value-1+e)%12+1;return 0===n&&(n=12),null===(t=w.find(e=>e.value===n))||void 0===t?void 0:t.text}}});function f(e,t,n,a,o){const{month:r,year:i}=function(e,t,n){const a=new Date(t,e-1+n);return{month:a.getMonth()+1,year:a.getFullYear()}}(e,t,n);return o<=i&&i<=a?{month:r,year:i}:{month:e,year:t}}},62492(e,t,n){"use strict";n.d(t,{A:()=>O});var a=n(74061),o=n(79126),r=n(80967),i=n(66015),s=n(98925),l=n(75552),c=n(66952);function d(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function u(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?d(Object(n),!0).forEach(function(t){f(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):d(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function f(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const h="quickEELSelector__container",p="quickEELSelector__container--open",m="quickEELSelector__button",g="quickEELSelector__menuContainer",w="ui-control-container",v="quickEELSelector__searchContainer",b="quickEELSelector__searchbox",y="quickEELSelector__searchSvg",_="quickEELSelector__listContainer",C="quickEELSelector__listItem",k="quickEELSelector__listItem--indented",S="quickEELSelector__listItem--selected",D="quickEELSelector__listItem--disabled",E="quickEELSelector__link",P="quickEELSelector__noResults",O=(0,a.defineComponent)({props:{value:(0,l.uh)([String,Number,Object]),text:(0,l.uh)([String,Object]),title:(0,l.uh)([String,Object]),ariaLabel:(0,l.uh)(String),readonly:(0,l.uh)(Boolean),options:(0,l.uh)([Function,Array]),additionalButtonClasses:(0,l.uh)(String),popupMaxHeight:(0,l.uh)(String),role:(0,l.JJ)("combobox")},emits:{"update:value":(0,l.c5)()},setup(e,t){var n,l,d,f;const O=(0,a.ref)(),B=(0,a.ref)(),T=(0,a.ref)(null!==(n=e.value)&&void 0!==n?n:""),x=(0,a.ref)(null!==(l=e.value)&&void 0!==l?l:""),M=(0,a.ref)(null!==(d=e.text)&&void 0!==d?d:""),I=(0,a.ref)(null!==(f=e.title)&&void 0!==f?f:""),A=(0,a.ref)(new Array),L=(0,a.ref)(!1),R=(0,a.ref)(),N=(0,a.ref)(),F=(0,a.ref)(!1),j=(0,a.useModel)(e,"value"),V=(0,a.ref)(new Map);Array.isArray(e.options)&&(A.value=e.options),(0,a.watch)(L,e=>{e?setTimeout(()=>{document.body.addEventListener("click",X)},0):document.body.removeEventListener("click",X)},{immediate:!0}),(0,a.onBeforeUnmount)(()=>{document.body.removeEventListener("click",X)});const H=(0,a.computed)(()=>{const e=A.value.map(e=>{const t=!N.value||e.text.toLowerCase().includes(N.value.toLowerCase());let n=V.value.get(e.value);return n||(n="quickeel-option-".concat(e.value,"-").concat((0,c.nextAutoId)()),V.value.set(e.value,n)),u(u({},e),{},{visible:t,id:n})});let t=!1;for(let n=e.length-1;n>=0;n--)!e[n].visible||e[n].heading?e[n].heading&&t&&(e[n].visible=!0,t=!1):t=!0;return e}),W=(0,a.computed)(()=>{const e=H.value.find(e=>"".concat(e.value)==="".concat(x.value));return(null==e?void 0:e.id)||""});let U=m;e.additionalButtonClasses&&(U=U.concat(" ".concat(e.additionalButtonClasses)));const K={};e.popupMaxHeight&&(K.maxHeight=e.popupMaxHeight);const q=(0,c.nextAutoId)();return()=>{var t;return(0,a.createVNode)("div",{ref:O,class:{[h]:!0,[p]:L.value}},[(0,a.createVNode)(r.A,{ref:B,svgName:"ArrowTriangleDown",class:U,clickFunc:Z,svgShowHoverEffect:!1,svgOnRight:!0,title:I.value,disabled:!0===e.readonly,role:e.role,"aria-expanded":L.value,"aria-label":e.ariaLabel,"aria-controls":q,"aria-activedescendant":W.value},{default:()=>[M.value]},8,["class","clickFunc","title","disabled","role","aria-expanded","aria-label","aria-controls","aria-activedescendant"]),(0,a.createVNode)("div",{class:{[g]:!0,popup:!0}},[(0,a.createVNode)("div",{id:q,class:{[v]:!0,[w]:!0}},[(0,a.createVNode)("input",{role:"searchbox",class:b,ref:R,type:"text",autocomplete:"none","aria-autocomplete":"list","aria-activedescendant":W.value,onKeyup:J,onKeypress:e=>{e.stopPropagation()},onKeydown:Y},null,42,["aria-activedescendant","onKeyup","onKeypress","onKeydown"]),(0,a.createVNode)(s.A,{svgClasses:[y],name:"Search",tabindex:"-1",showHoverEffect:!1},null,8,["svgClasses"])],8,["id"]),!F.value&&(0,a.createVNode)(i.A,null,null),(0,a.createVNode)("ul",{class:_,style:K,role:"listbox"},[null===(t=H.value)||void 0===t?void 0:t.map(e=>{var t;const n="".concat(x.value)==="".concat(e.value),o="".concat(T.value)==="".concat(e.value);return(0,a.createVNode)("li",{class:{[C]:!0,[S]:n,[k]:e.indent,[D]:e.disabled},role:"option",id:e.id,"aria-label":null!==(t=e.ariaLabel)&&void 0!==t?t:e.text,"aria-selected":o,style:{display:e.visible?"block":"none"},"data-value":"".concat(e.value)},[(0,a.createVNode)("a",{class:E,href:"javascript:void(0)",tabindex:"-1",onClick:G.bind(e)},[e.text],10,["onClick"])],14,["id","aria-label","aria-selected","data-value"])})],6),(0,a.createVNode)("div",{class:P,style:{display:void 0===x.value?"block":"none"}},[(0,a.createTextVNode)("No records to display")],6)])],2)};function G(){if(!0===this.disabled)return;const e=T.value!=this.value,t=parseInt(this.value);var n;(T.value=isNaN(t)?this.value:t,M.value=this.text,j.value=T.value,e)&&$(O.value).trigger("change",{value:T.value,isDistrict:null!==(n=this.isDistrict)&&void 0!==n&&n});Q(!0)}function z(e){const t=A.value.find(t=>{var n;return(null===(n=t.value)||void 0===n?void 0:n.toString())===(null==e?void 0:e.toString())});t&&G.call(t)}function J(e){var t,n;e.stopPropagation(),N.value=null!==(t=null===(n=R.value)||void 0===n?void 0:n.value)&&void 0!==t?t:"",(0,a.nextTick)(()=>{const e=$(O.value);e.find(".".concat(S)).is(":visible")||(x.value=e.find(".".concat(C,":visible")).not(".".concat(D)).first().data("value"))})}function Y(e){e.stopPropagation();const t=$(O.value);let n,a=t.find(".".concat(S));switch(e.key){case"ArrowDown":n=a.nextAll(":visible").not(".".concat(D)).first(),n.length||(n=t.find(".".concat(C,":visible")).not(".".concat(D)).last()),x.value=n.data("value"),n.scrollintoview();break;case"ArrowUp":n=a.prevAll(":visible").not(".".concat(D)).first(),n.length||(n=t.find(".".concat(C,":visible")).not(".".concat(D)).first()),x.value=n.data("value"),n.scrollintoview();break;case"Escape":x.value=T.value,Q(!1);break;case"Tab":void 0!==x.value&&z(x.value);break;case"Enter":e.preventDefault(),void 0!==x.value&&z(x.value)}}function Q(){let e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];L.value=!1,x.value=T.value,N.value="",null!=R&&R.value&&(R.value.value=""),e&&(0,a.nextTick)(()=>{var e;null===(e=B.value)||void 0===e||e.focus()})}function X(e){var t;null!==(t=O.value)&&void 0!==t&&t.contains(e.target)||Q(!1)}function Z(){L.value?Q(!1):async function(){if(!0===e.readonly)return;if(L.value=!0,x.value=T.value,(0,a.nextTick)(()=>{var e;return null===(e=R.value)||void 0===e?void 0:e.focus()}),A.value.length)F.value=!0;else{if(!e.options)throw new o.SkywardException("Options were not provided to the QuickEELSelector");"function"==typeof e.options?A.value=await e.options():A.value=e.options,F.value=!0}await(0,a.nextTick)(),$(O.value).find(".".concat(S)).scrollintoview()}()}}})},31271(e,t,n){"use strict";n.d(t,{d:()=>a,z:()=>o});const a={};function o(e){return Boolean(e.skyVueData)}},17757(e,t,n){"use strict";n.d(t,{t:()=>B});var a=n(79126),o=n(2894),r=n(74061),i=n(85596),s=n(39411),l=n(29711);function c(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}class d{constructor(){c(this,"_resolveSelf",e=>{}),c(this,"_rejectSelf",e=>{}),c(this,"promise",void 0),c(this,Symbol.toStringTag,"Promise"),this.promise=new Promise((e,t)=>{this._resolveSelf=e,this._rejectSelf=t})}then(e,t){return this.promise.then(e,t)}catch(e){return this.promise.catch(e)}resolve(e){this._resolveSelf(e)}reject(e){this._rejectSelf(e)}finally(e){return this.promise.finally(e)}}var u=n(75552),f=n(31271);function h(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function p(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?h(Object(n),!0).forEach(function(t){m(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):h(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function m(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const g={getPostData:(e,t)=>{var n;return{dataSourceType:e.typeIdentifier,identifierField:e.identifierField,dataSourceParametersHash:t.hashes.dataSource,dataSourceParameters:JSON.stringify(p(p({},e),{},{searchValue:window.skyward.extensions.encodeHtml(null!==(n=e.searchValue)&&void 0!==n?n:"")}))}}},w={getPostData:(e,t)=>({dataSourceFields:JSON.stringify(e),dataSourceFieldsHash:t.hashes.fields})},v={getPostData:(e,t)=>({filterTypeIdentifier:e.typeIdentifier,filterType:JSON.stringify(e),filterTypeHash:t.hashes.filterType})},b={getPostData:(e,t)=>{let n="",a="first";t.data.isLoaded&&void 0!==t.data.identifyingFieldValues.at(-1)&&(n=t.data.identifyingFieldValues.at(-1),a="next");return{pagingTypeIdentifier:e.typeIdentifier,pagingType:JSON.stringify(e),pagingPage:a,pagingIdentifierValue:n}}},y={components:f.d,dataSource:g,fields:w,filterType:v,pagingType:b,props:{},securityData:{},template:{}};var _,C,k=n(92422);function S(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function D(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?S(Object(n),!0).forEach(function(t){E(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):S(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function E(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const P={};null!==(C=(_=window.skyward).skyVue)&&void 0!==C||(_.skyVue={}),window.skyward.skyVue._storeCollection=(0,r.shallowReadonly)(P);const O=Symbol("writableParent");function B(e,t,n,c,h){var p;const m=String(e);m in P&&window.skyward.error.reportException(new a.SkywardException("Store has already been registered.","The store with the key of '".concat(e,"' has already been registered.")));const g=Object.assign(Object.create(null!==(p=n())&&void 0!==p?p:Object.prototype),{key:m,symbolKey:e,setup:c,features:Object.assign({},t,y),states:new Map,awaitedStates:new Map,addState:function(e,t){var n,a;let{skyVueData:c,parent:d}=e;const h=c.id;if(g.states.has(h))throw new Error("The ".concat("id"," of '").concat(h,"' has already been added."));let p,w,v,b,y,_,C="";const S=function e(t){if(t.features.securityData)return"OK"!==t.features.securityData.errorType&&(C=t.features.securityData.userMessage,!0);return t.features.components.some(t=>(0,f.z)(t)&&e(t.skyVueData))}(c);const E=(0,l.getCallbackStore)(),P=(0,l.getCallbackStore)();let B;const T={features:(0,r.reactive)($.extend(!0,{},c.features)),data:(0,r.reactive)({isLoaded:!1,isInitiallyLoaded:!1,get hasNoData(){return!0===A.value},get isErrored(){return y.value===k.x.ServerError},values:[],nonPageableValues:{},get length(){return w.value},getIndexByIdentifyingField:L,getRowByIdentifyingField:function(e){const t=L(e);return-1!==t?M.data.values[t]:void 0},get identifyingFieldValues(){return v.value},fetch:(e,n)=>(clearTimeout(B),new Promise(a=>{B=setTimeout(()=>{a(async function(e,n){var a,r;if(!M.features.dataSource||M.errorState===k.x.FatalNotSecure)return M.data.isLoaded=!0,void(M.data.isInitiallyLoaded=!0);const l=D({},n);let c;const d={ajaxSettings:{}};c="object"==typeof e?D(D({},d),e):D(D({},d),{},{fetchDataBehavior:e});const u=c.fetchDataBehavior===k.b.Replace;u&&(M.data.values=[]);Object.assign(l,R()),M.data.isLoaded=!1,p&&"pending"===p.state()&&p.abort();const f=window.jQuery.ajax(D(D({suppressErrors:e=>500===e.status||403===e.status&&"SessionChanged"!==e.getResponseHeader("X-Forbidden-Reason"),activityIndicator:{silent:u}},c.ajaxSettings),{},{skyvueKey:m,skyvueId:h,url:window.skyward.global.virtualDir+"SkySys/VueData/GetData/",type:"POST",dataType:"skyvuefetch",converters:{"json skyvuefetch":function(e){return e}},cache:!1,data:l}));p=f;try{var g;const e=b(await f);switch(await _(null===(g=e.nonPageableValues)||void 0===g?void 0:g.NamespaceDependencies),c.fetchDataBehavior){case k.b.Replace:M.data.values=null!==(a=e.values)&&void 0!==a?a:[],M.data.nonPageableValues=null!==(r=e.nonPageableValues)&&void 0!==r?r:{};break;case k.b.Append:case k.b.Prepend:M.data.values=y(M.features.dataSource.identifierField,M.data.values,e.values,c.fetchDataBehavior),e.nonPageableValues&&Object.assign(M.data.nonPageableValues,e.nonPageableValues);break;default:throw new Error("The ".concat("FetchDataBehavior"," of '").concat(c.fetchDataBehavior,"' is not supported in this context."))}return M.features.securityData.errorType="OK",M.features.securityData.securityMessage="",e}catch(e){if("abort"===f.statusText)return{};const t="An error occurred and the browse could not be loaded.";if(403===f.status){const e=f.responseJSON;var w,v;M.data.values.length=0,Object.keys(M.data.nonPageableValues).forEach(e=>delete M.data.nonPageableValues[e]),"SessionChanged"===f.getResponseHeader("X-Forbidden-Reason")?(M.features.securityData.errorType="NoSecurity",M.features.securityData.securityMessage=f.responseText):(M.features.securityData.errorType=null!==(w=e.errorType)&&void 0!==w?w:"InternalError",M.features.securityData.securityMessage=null!==(v=e.securityMessage)&&void 0!==v?v:t)}else 500===f.status&&(0,i.logAjaxError)(f),M.features.securityData.errorType="InternalError",M.features.securityData.securityMessage=t;return{}}finally{"abort"!==f.statusText&&"error"!==f.statusText&&(E.dispatchCallbacks(),t.emit("afterFetch",M),M.data.isLoaded=!0,M.data.isInitiallyLoaded=!0)}function b(e){return new s.default(e).next().value}function y(e,t,n,a){var o,r;if(!t)return n;let i=null!==(o=null==t?void 0:t.slice())&&void 0!==o?o:[];switch(i=null===(r=i)||void 0===r?void 0:r.filter(t=>-1===n.findIndex(n=>n[e]===t[e])),a){case k.b.Append:i.push(...n);break;case k.b.Prepend:i.unshift(...n);break;default:throw"The ".concat("FetchDataBehavior"," of '").concat(a,"' is not supported in this context.")}return i}async function _(e){if(!Array.isArray(e))return;const t=new Set;for(let n=0;n<e.length;n++)t.add(e[n].split(".")[0]);let n=[];for(let e of t)n.push((0,o.loadSkywardModuleByNamespace)(e));return Promise.all(n)}}(e,n))},0)})),onAfterFetch:(0,l.getCallbackStoreFacade)(E),get canRefresh(){return!S},get postData(){return b.value}}),hashes:$.extend(!0,{},null!==(n=c.hashes)&&void 0!==n?n:{}),parent:d?(0,r.readonly)(d):void 0,[O]:d,children:(0,r.reactive)([]),get errorState(){return y.value},get errorUserMessage(){return _.value},refresh:async function(){if(!T.data.canRefresh)return Promise.resolve();T.features.securityData={errorType:"OK",securityMessage:"",userMessage:""},T.features.dataSource?await T.data.fetch(k.b.Replace):await Promise.all(T.children.map(e=>e.refresh()));P.dispatchCallbacks()},onRefresh:(0,l.getCallbackStoreFacade)(P),get storeKey(){return g.key},get stateId(){return h}};w=(0,r.computed)(()=>{var e,t;return null!==(e=null===(t=T.data.values)||void 0===t?void 0:t.length)&&void 0!==e?e:0}),v=(0,r.computed)(()=>{var e,t,n;const a=null===(e=T.features.dataSource)||void 0===e?void 0:e.identifierField;return null!==(t=null===(n=T.data.values)||void 0===n?void 0:n.map(e=>e[a]))&&void 0!==t?t:[]}),y=(0,r.computed)(function(){if(S)return k.x.FatalNotSecure;if(T.features.dataSource){if("OK"!==T.features.securityData.errorType)switch(T.features.securityData.errorType){case"InternalError":return k.x.ServerError;case"NoSecurity":return k.x.NotSecure;default:throw new Error("not implemented")}}else for(const e of T.children)if(e.errorState!==k.x.OK)return e.errorState;return k.x.OK}),_=(0,r.computed)(function(){var e;return C||(null===(e=T.features.securityData)||void 0===e?void 0:e.userMessage)}),b=(0,u._w)(function(){return R("pagingType")});const x=g.setup(h,T),M=Object.defineProperties({},D(D({},Object.getOwnPropertyDescriptors(T)),Object.getOwnPropertyDescriptors(x)));if(g.awaitedStates.has(h)){var I=g.awaitedStates.get(h);void 0!==I&&(null==I||I.resolve(M)),g.awaitedStates.delete(h)}const A=(0,r.computed)(()=>{var e;return T.data.isLoaded&&T.data.isInitiallyLoaded&&!((null===(e=T.data)||void 0===e||null===(e=e.nonPageableValues)||void 0===e||null===(e=e.series)||void 0===e?void 0:e.length)>0)});return g.states.set(h,M),null===(a=M[O])||void 0===a||null===(a=a.children)||void 0===a||a.push(M),t.expose({state:M}),M;function L(e){const t=M.data.identifyingFieldValues.indexOf(e);if(-1!==t||null==e)return t;const n=String(e);return M.data.identifyingFieldValues.findIndex(e=>String(e)===n)}function R(e){let t={};for(const[n,a]of Object.entries(g.features))if("function"==typeof a.getPostData&&n!==e){const e=M.features;e[n]&&Object.assign(t,a.getPostData(e[n],M))}return t}},getState:function(e){if(!g.states.has(e))throw"Could not retrieve store '".concat(e,"': Invalid ID");return g.states.get(e)},getStateAsync:function(e){if(g.hasState(e))return Promise.resolve(g.getState(e));if(g.awaitedStates.has(e))return g.awaitedStates.get(e);const t=new d;return g.awaitedStates.set(e,t),t},hasState:function(e){return!!g.states.get(e)},deleteState:function(e){"function"==typeof h&&h(e);if(g.awaitedStates.has(e)){var t=g.awaitedStates.get(e);void 0!==t&&(null==t||t.reject("deleteState")),g.awaitedStates.delete(e)}const n=g.states.get(e);if(n){var a;const e=null===(a=n[O])||void 0===a?void 0:a.children;if(e){const t=e.indexOf(n);t>=0&&e.splice(t,1)}}else console.warn("No state ".concat(e," to delete"));g.states.delete(e)}});return P[m]=g,g}},92422(e,t,n){"use strict";n.d(t,{b:()=>a,x:()=>o});let a=function(e){return e[e.Replace=0]="Replace",e[e.Append=1]="Append",e[e.Prepend=2]="Prepend",e}({}),o=function(e){return e.OK="OK",e.NotSecure="NotSecure",e.ServerError="ServerError",e.FatalNotSecure="FatalNotSecure",e}({})},79098(e,t,n){"use strict";n.d(t,{v:()=>a});const a={Container:"htmlEditorWrapper",HiddenInput:"htmlEditorBackingInput",FroalaBox:"fr-box"};Object.freeze(a)},30279(e,t,n){"use strict";n.d(t,{Q:()=>s,X:()=>i});var a=n(74061),o=n(17757);const r={plugins:{},settings:{}},i=Symbol("htmlEditorStore"),s=(0,o.t)(i,r,function(){return{defaultHTMLEditorId:"HTMLEditor",get defaultHTMLEditorPromise(){return s.getStateAsync(this.defaultHTMLEditorId)},injectHTMLEditorState:function(){return(0,a.inject)(i,void 0)}}},function(e,t){return{get htmlEditorID(){return e}}})},45502(e,t,n){"use strict";n.d(t,{B:()=>o,b:()=>a});const a={Modal:"themeSelector__modal",Container:"themeSelector__container",Item:"themeSelector__item",ItemSelected:"themeSelector__item--selected",ItemHeader:"themeSelector__itemHeader",ItemHeaderSvg:"themeSelector__itemHeaderSvg",ItemDivider:"themeSelector__itemDivider",ColorContainer:"themeSelector__colorContainer",Color:"themeSelector__color",Color1:"themeSelector__color1",Color2:"themeSelector__color2",Color3:"themeSelector__color3",Color4:"themeSelector__color4",ItemFooter:"themeSelector__itemFooter",RadioButton:"themeSelector__radioButton",TempCSS:"tempCss",ThemeStyleSheet:"themeStyleSheet"};Object.freeze(a);const o={ThemeID:"themeId",CSSHash:"cssHash"};Object.freeze(o)},74180(e,t,n){"use strict";n.d(t,{s:()=>i,D:()=>r});var a=n(74061),o=n(17757);const r=Symbol("themeSelectorStore"),i=(0,o.t)(r,{},function(){return{defaultThemeSelectorId:"ThemeSelector",get defaultThemeSelectorPromise(){return i.getStateAsync(this.defaultThemeSelectorId)},injectThemeSelectorState:function(){return(0,a.inject)(r,void 0)}}},function(e,t){return{get themeSelectorID(){return e}}})},20960(e,t,n){"use strict";n.d(t,{A:()=>f});var a=n(74061),o=n(98925),r=n(75552),i=n(81975),s=n(99814);const l="timeSelector",c="timeSelector__select",d="timeSelector__button",u="timeSelector__svg",f=(0,a.defineComponent)({name:"timeSelector",emits:{"update:hour":e=>!0,"update:minute":e=>!0,"update:amPm":e=>!0},props:{hour:(0,r.uh)(Number),minute:(0,r.uh)(Number),amPm:(0,r.oY)(String)},setup(e,t){const n=(0,a.ref)(),f=(0,a.ref)(),h=(0,a.ref)(),p=(0,a.ref)(),m=(0,a.useModel)(e,"hour"),g=(0,a.useModel)(e,"minute"),w=(0,a.useModel)(e,"amPm"),v=(0,a.ref)("PM"===w.value);return(0,a.watch)(w,e=>{v.value="AM"!==e}),(0,a.watch)(v,e=>{w.value=e?"PM":"AM"}),t.expose({focusHourInput(){var e;null===(e=n.value)||void 0===e||e.focus()},focusMinuteInput(){var e;null===(e=f.value)||void 0===e||e.focus()},focusAmPmToggle(){var e;null===(e=h.value)||void 0===e||e.focus()}}),(0,r.xF)(document.body,"keypress",function(e){const t=e.key.toUpperCase();"A"===t?w.value="AM":"P"===t&&(w.value="PM");e.target!==n.value&&e.target!==f.value||"ENTER"===t&&e.preventDefault()}),(0,r.xF)(document.body,"keydown",function(e){const t=e.key.toUpperCase();if(e.target===n.value){if("ARROWRIGHT"===t||"ARROWLEFT"===t)return void e.preventDefault();e.altKey||("ARROWDOWN"===t?null==m.value||isNaN(m.value)||12===m.value?m.value=1:m.value++:"ARROWUP"===t&&(null==m.value||1===m.value?m.value=12:m.value--))}else if(e.target===f.value){if("ARROWRIGHT"===t||"ARROWLEFT"===t)return void e.preventDefault();e.altKey||("ARROWDOWN"===t?null==g.value||isNaN(g.value)||59===g.value?g.value=0:g.value++:"ARROWUP"===t&&(null==g.value||0===g.value?g.value=59:g.value--))}}),()=>{var e,t;return(0,a.createVNode)("div",{class:l},[(0,a.createVNode)("select",{ref:n,name:"TimeHour","aria-label":"Select Hour",value:null!==(e=m.value)&&void 0!==e?e:"",onChange:b,class:c},[(0,a.createVNode)("option",{"aria-label":"No selection",value:""},null),[...Array(12)].map((e,t)=>{const n=t+1;return(0,a.createVNode)("option",{value:n},[n],8,["value"])})],42,["value","onChange"]),(0,a.createVNode)("span",{"aria-hidden":!0},[(0,a.createTextVNode)(":")]),(0,a.createVNode)("select",{ref:f,name:"TimeMinute","aria-label":"Select Minutes",value:null!==(t=g.value)&&void 0!==t?t:"",onChange:y,class:c},[(0,a.createVNode)("option",{"aria-label":"No selection",value:""},null),[...Array(60)].map((e,t)=>{const n=t,o=n.toString().padStart(2,"0");return(0,a.createVNode)("option",{value:n},[o],8,["value"])})],42,["value","onChange"]),(0,a.createVNode)(s.A,{name:"TimeToggle",ref:h,checked:v.value,"onUpdate:checked":e=>v.value=e,ariaLabel:"Select AM or PM",CheckedStateLabel:"PM",UncheckedStateLabel:"AM",containerClassOverride:"timeSelectorToggleSwitch",itemClassOverride:"timeSelectorToggleSwitch__item",toggleClassOverride:"timeSelectorToggleSwitch__toggle"},null,8,["checked","onUpdate:checked"]),(0,a.createVNode)("button",{class:d,onClick:_,onKeydown:C,"aria-label":"Select Current Time"},[(0,a.createVNode)(o.A,{name:"Time",showHoverEffect:!1,svgClasses:{[u]:!0},isButton:!0},null)],42,["onClick","onKeydown"]),(0,a.createVNode)("span",{ref:p,class:"sr-only","aria-live":"polite"},null,512)],2)};function b(e){const t=e.target.value;m.value=parseInt(t)}function y(e){const t=e.target.value;g.value=parseInt(t)}function _(){const e=new Date,t=e.getHours();let n="AM";t>=12&&(n="PM");const a=(0,i.convertTo12Hour)(t),o=e.getMinutes();m.value=a,g.value=o,w.value=n;const r="".concat(a,":").concat(o.toString().padStart(2,"0")," ").concat(n," Selected");p.value&&(p.value.innerHTML&&r===p.value.innerHTML?p.value.innerHTML+="&nbsp":p.value.innerHTML=r)}function C(e){"Enter"===e.key&&(e.preventDefault(),_())}}})},20589(e){e.exports=function(){"use strict";var e=1e3,t=6e4,n=36e5,a="millisecond",o="second",r="minute",i="hour",s="day",l="week",c="month",d="quarter",u="year",f="date",h="Invalid Date",p=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,m=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,g={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(e){var t=["th","st","nd","rd"],n=e%100;return"["+e+(t[(n-20)%10]||t[n]||t[0])+"]"}},w=function(e,t,n){var a=String(e);return!a||a.length>=t?e:""+Array(t+1-a.length).join(n)+e},v={s:w,z:function(e){var t=-e.utcOffset(),n=Math.abs(t),a=Math.floor(n/60),o=n%60;return(t<=0?"+":"-")+w(a,2,"0")+":"+w(o,2,"0")},m:function e(t,n){if(t.date()<n.date())return-e(n,t);var a=12*(n.year()-t.year())+(n.month()-t.month()),o=t.clone().add(a,c),r=n-o<0,i=t.clone().add(a+(r?-1:1),c);return+(-(a+(n-o)/(r?o-i:i-o))||0)},a:function(e){return e<0?Math.ceil(e)||0:Math.floor(e)},p:function(e){return{M:c,y:u,w:l,d:s,D:f,h:i,m:r,s:o,ms:a,Q:d}[e]||String(e||"").toLowerCase().replace(/s$/,"")},u:function(e){return void 0===e}},b="en",y={};y[b]=g;var _=function(e){return e instanceof D},C=function e(t,n,a){var o;if(!t)return b;if("string"==typeof t){var r=t.toLowerCase();y[r]&&(o=r),n&&(y[r]=n,o=r);var i=t.split("-");if(!o&&i.length>1)return e(i[0])}else{var s=t.name;y[s]=t,o=s}return!a&&o&&(b=o),o||!a&&b},k=function(e,t){if(_(e))return e.clone();var n="object"==typeof t?t:{};return n.date=e,n.args=arguments,new D(n)},S=v;S.l=C,S.i=_,S.w=function(e,t){return k(e,{locale:t.$L,utc:t.$u,x:t.$x,$offset:t.$offset})};var D=function(){function g(e){this.$L=C(e.locale,null,!0),this.parse(e)}var w=g.prototype;return w.parse=function(e){this.$d=function(e){var t=e.date,n=e.utc;if(null===t)return new Date(NaN);if(S.u(t))return new Date;if(t instanceof Date)return new Date(t);if("string"==typeof t&&!/Z$/i.test(t)){var a=t.match(p);if(a){var o=a[2]-1||0,r=(a[7]||"0").substring(0,3);return n?new Date(Date.UTC(a[1],o,a[3]||1,a[4]||0,a[5]||0,a[6]||0,r)):new Date(a[1],o,a[3]||1,a[4]||0,a[5]||0,a[6]||0,r)}}return new Date(t)}(e),this.$x=e.x||{},this.init()},w.init=function(){var e=this.$d;this.$y=e.getFullYear(),this.$M=e.getMonth(),this.$D=e.getDate(),this.$W=e.getDay(),this.$H=e.getHours(),this.$m=e.getMinutes(),this.$s=e.getSeconds(),this.$ms=e.getMilliseconds()},w.$utils=function(){return S},w.isValid=function(){return!(this.$d.toString()===h)},w.isSame=function(e,t){var n=k(e);return this.startOf(t)<=n&&n<=this.endOf(t)},w.isAfter=function(e,t){return k(e)<this.startOf(t)},w.isBefore=function(e,t){return this.endOf(t)<k(e)},w.$g=function(e,t,n){return S.u(e)?this[t]:this.set(n,e)},w.unix=function(){return Math.floor(this.valueOf()/1e3)},w.valueOf=function(){return this.$d.getTime()},w.startOf=function(e,t){var n=this,a=!!S.u(t)||t,d=S.p(e),h=function(e,t){var o=S.w(n.$u?Date.UTC(n.$y,t,e):new Date(n.$y,t,e),n);return a?o:o.endOf(s)},p=function(e,t){return S.w(n.toDate()[e].apply(n.toDate("s"),(a?[0,0,0,0]:[23,59,59,999]).slice(t)),n)},m=this.$W,g=this.$M,w=this.$D,v="set"+(this.$u?"UTC":"");switch(d){case u:return a?h(1,0):h(31,11);case c:return a?h(1,g):h(0,g+1);case l:var b=this.$locale().weekStart||0,y=(m<b?m+7:m)-b;return h(a?w-y:w+(6-y),g);case s:case f:return p(v+"Hours",0);case i:return p(v+"Minutes",1);case r:return p(v+"Seconds",2);case o:return p(v+"Milliseconds",3);default:return this.clone()}},w.endOf=function(e){return this.startOf(e,!1)},w.$set=function(e,t){var n,l=S.p(e),d="set"+(this.$u?"UTC":""),h=(n={},n[s]=d+"Date",n[f]=d+"Date",n[c]=d+"Month",n[u]=d+"FullYear",n[i]=d+"Hours",n[r]=d+"Minutes",n[o]=d+"Seconds",n[a]=d+"Milliseconds",n)[l],p=l===s?this.$D+(t-this.$W):t;if(l===c||l===u){var m=this.clone().set(f,1);m.$d[h](p),m.init(),this.$d=m.set(f,Math.min(this.$D,m.daysInMonth())).$d}else h&&this.$d[h](p);return this.init(),this},w.set=function(e,t){return this.clone().$set(e,t)},w.get=function(e){return this[S.p(e)]()},w.add=function(a,d){var f,h=this;a=Number(a);var p=S.p(d),m=function(e){var t=k(h);return S.w(t.date(t.date()+Math.round(e*a)),h)};if(p===c)return this.set(c,this.$M+a);if(p===u)return this.set(u,this.$y+a);if(p===s)return m(1);if(p===l)return m(7);var g=(f={},f[r]=t,f[i]=n,f[o]=e,f)[p]||1,w=this.$d.getTime()+a*g;return S.w(w,this)},w.subtract=function(e,t){return this.add(-1*e,t)},w.format=function(e){var t=this,n=this.$locale();if(!this.isValid())return n.invalidDate||h;var a=e||"YYYY-MM-DDTHH:mm:ssZ",o=S.z(this),r=this.$H,i=this.$m,s=this.$M,l=n.weekdays,c=n.months,d=function(e,n,o,r){return e&&(e[n]||e(t,a))||o[n].slice(0,r)},u=function(e){return S.s(r%12||12,e,"0")},f=n.meridiem||function(e,t,n){var a=e<12?"AM":"PM";return n?a.toLowerCase():a},p={YY:String(this.$y).slice(-2),YYYY:this.$y,M:s+1,MM:S.s(s+1,2,"0"),MMM:d(n.monthsShort,s,c,3),MMMM:d(c,s),D:this.$D,DD:S.s(this.$D,2,"0"),d:String(this.$W),dd:d(n.weekdaysMin,this.$W,l,2),ddd:d(n.weekdaysShort,this.$W,l,3),dddd:l[this.$W],H:String(r),HH:S.s(r,2,"0"),h:u(1),hh:u(2),a:f(r,i,!0),A:f(r,i,!1),m:String(i),mm:S.s(i,2,"0"),s:String(this.$s),ss:S.s(this.$s,2,"0"),SSS:S.s(this.$ms,3,"0"),Z:o};return a.replace(m,function(e,t){return t||p[e]||o.replace(":","")})},w.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},w.diff=function(a,f,h){var p,m=S.p(f),g=k(a),w=(g.utcOffset()-this.utcOffset())*t,v=this-g,b=S.m(this,g);return b=(p={},p[u]=b/12,p[c]=b,p[d]=b/3,p[l]=(v-w)/6048e5,p[s]=(v-w)/864e5,p[i]=v/n,p[r]=v/t,p[o]=v/e,p)[m]||v,h?b:S.a(b)},w.daysInMonth=function(){return this.endOf(c).$D},w.$locale=function(){return y[this.$L]},w.locale=function(e,t){if(!e)return this.$L;var n=this.clone(),a=C(e,t,!0);return a&&(n.$L=a),n},w.clone=function(){return S.w(this.$d,this)},w.toDate=function(){return new Date(this.valueOf())},w.toJSON=function(){return this.isValid()?this.toISOString():null},w.toISOString=function(){return this.$d.toISOString()},w.toString=function(){return this.$d.toUTCString()},g}(),E=D.prototype;return k.prototype=E,[["$ms",a],["$s",o],["$m",r],["$H",i],["$W",s],["$M",c],["$y",u],["$D",f]].forEach(function(e){E[e[1]]=function(t){return this.$g(t,e[0],e[1])}}),k.extend=function(e,t){return e.$i||(e(t,D,k),e.$i=!0),k},k.locale=C,k.isDayjs=_,k.unix=function(e){return k(1e3*e)},k.en=y[b],k.Ls=y,k.p={},k}()},22091(e){e.exports=function(){"use strict";return function(e,t){var n=t.prototype,a=n.format;n.format=function(e){var t=this,n=this.$locale();if(!this.isValid())return a.bind(this)(e);var o=this.$utils(),r=(e||"YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g,function(e){switch(e){case"Q":return Math.ceil((t.$M+1)/3);case"Do":return n.ordinal(t.$D);case"gggg":return t.weekYear();case"GGGG":return t.isoWeekYear();case"wo":return n.ordinal(t.week(),"W");case"w":case"ww":return o.s(t.week(),"w"===e?1:2,"0");case"W":case"WW":return o.s(t.isoWeek(),"W"===e?1:2,"0");case"k":case"kk":return o.s(String(0===t.$H?24:t.$H),"k"===e?1:2,"0");case"X":return Math.floor(t.$d.getTime()/1e3);case"x":return t.$d.getTime();case"z":return"["+t.offsetName()+"]";case"zzz":return"["+t.offsetName("long")+"]";default:return e}});return a.bind(this)(r)}}}()},58687(e){e.exports=function(){"use strict";return function(e,t){t.prototype.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)}}}()},12750(e){e.exports=function(){"use strict";var e="minute",t=/[+-]\d\d(?::?\d\d)?/g,n=/([+-]|\d\d)/g;return function(a,o,r){var i=o.prototype;r.utc=function(e){return new o({date:e,utc:!0,args:arguments})},i.utc=function(t){var n=r(this.toDate(),{locale:this.$L,utc:!0});return t?n.add(this.utcOffset(),e):n},i.local=function(){return r(this.toDate(),{locale:this.$L,utc:!1})};var s=i.parse;i.parse=function(e){e.utc&&(this.$u=!0),this.$utils().u(e.$offset)||(this.$offset=e.$offset),s.call(this,e)};var l=i.init;i.init=function(){if(this.$u){var e=this.$d;this.$y=e.getUTCFullYear(),this.$M=e.getUTCMonth(),this.$D=e.getUTCDate(),this.$W=e.getUTCDay(),this.$H=e.getUTCHours(),this.$m=e.getUTCMinutes(),this.$s=e.getUTCSeconds(),this.$ms=e.getUTCMilliseconds()}else l.call(this)};var c=i.utcOffset;i.utcOffset=function(a,o){var r=this.$utils().u;if(r(a))return this.$u?0:r(this.$offset)?c.call(this):this.$offset;if("string"==typeof a&&(a=function(e){void 0===e&&(e="");var a=e.match(t);if(!a)return null;var o=(""+a[0]).match(n)||["-",0,0],r=o[0],i=60*+o[1]+ +o[2];return 0===i?0:"+"===r?i:-i}(a),null===a))return this;var i=Math.abs(a)<=16?60*a:a,s=this;if(o)return s.$offset=i,s.$u=0===a,s;if(0!==a){var l=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();(s=this.local().add(i+l,e)).$offset=i,s.$x.$localOffset=l}else s=this.utc();return s};var d=i.format;i.format=function(e){var t=e||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return d.call(this,t)},i.valueOf=function(){var e=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||this.$d.getTimezoneOffset());return this.$d.valueOf()-6e4*e},i.isUTC=function(){return!!this.$u},i.toISOString=function(){return this.toDate().toISOString()},i.toString=function(){return this.toDate().toUTCString()};var u=i.toDate;i.toDate=function(e){return"s"===e&&this.$offset?r(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():u.call(this)};var f=i.diff;i.diff=function(e,t,n){if(e&&this.$u===e.$u)return f.call(this,e,t,n);var a=this.local(),o=r(e).local();return f.call(a,o,t,n)}}}()},17009(e,t,n){function a(e,t,n){const a=t.split(/\./g).reduce((e,t)=>e[t]||(e[t]={}),e);Object.assign(a,n)}a(window,"skyward.error",n(79126)),a(window,"skyward.base",n(75618)),a(window,"skyward.events",n(92214)),a(window,"skyward.callbackStore",n(29711)),a(window,"skyward.extensions",n(66952)),a(window,"skyward.color",n(92599)),a(window,"skyward.global",n(2894)),a(window,"skyward.global.text",n(83972)),a(window,"skyward.detailsPanel",n(6927)),a(window,"skyward.debounce",n(16140)),a(window,"skyward.window",n(49343)),a(window,"skyward.window.domunloadcallback",n(2441)),a(window,"skyward.sizedContainer",n(48985)),a(window,"skyward.buttonManager",n(40096)),a(window,"skyward.datamask",n(83787)),a(window,"skyward.dataobjectviewer.getFieldValues",n(14144)),a(window,"skyward.volatileStorage",n(82893)),a(window,"skyward.activityIndicator",n(7317)),a(window,"skyward.svg",n(68337)),a(window,"skyward.ajaxError",n(85596)),a(window,"skyward.time",n(81975)),a(window,"skyward.session",n(28640)),a(window,"skyward.idleMonitor",n(584)),a(window,"skyward.performanceMonitor",n(19802)),a(window,"skyward.dataPath",n(65248)),a(window,"skyward.requestDataHash",n(82441)),a(window,"skyward.browse.fieldTree",n(39411)),a(window,"skyward.browse.list",n(3543)),a(window,"skyward.browse",n(62521)),a(window,"skyward.browsePreferences",n(939)),a(window,"skyward.browseLoadTimer",n(40044)),a(window,"skyward.browseSeekInfo",n(50573)),a(window,"skyward.browseFilters",n(6722)),a(window,"skyward.eel",n(51325)),a(window,"skyward.selectorEEL",n(64558)),a(window,"skyward.tileViewEEL",n(64078)),a(window,"skyward.codeeel",n(65302)),a(window,"skyward.ajaxManager",n(60977)),a(window,"skyward.ajax",n(90265)),a(window,"skyward.fieldWrapper",n(30368)),a(window,"skyward.themeSelector",n(4659)),a(window,"skyward.aboutPopup",n(18290)),a(window,"skyward.tabbing",n(41709)),a(window,"skyward.distinctMultiSelectEEL",n(62894)),a(window,"skyward.distinctMultiSelectEEL.values",n(25560)),a(window,"skyward.dependents",n(51063)),a(window,"skyward.workflow",n(53346)),a(window,"skyward.validation",n(22528)),a(window,"skyward.controls",n(917)),a(window,"skyward.collapsePanel",n(78036)),a(window,"skyward.changeTracking",n(40346)),a(window,"skyward.treebrowse",n(42980)),a(window,"skyward.mainmenuvue",n(2658)),a(window,"skyward.sortable",n(54375)),a(window,"skyward.comboBox",n(19092)),a(window,"skyward.reference",n(63302)),a(window,"skyward.filemanagement",n(45230)),a(window,"skyward.reporting.calculatedfields",n(60990)),a(window,"skyward.dock",n(50196)),a(window,"skyward.favorites",n(39094)),a(window,"skyward.globalSearch",n(49680)),a(window,"skyward.tileBrowse",n(2885)),a(window,"skyward.editableBrowse",n(83289)),a(window,"skyward.dialogFocusManager",n(1380)),a(window,"skyward.modalLayer",n(88157)),a(window,"skyward.familyAccess",n(22441)),a(window,"skyward.contentMessageArea",n(92566)),a(window,"skyward.radioButtonGroup",n(1445)),a(window,"skyward.printScreen",n(44992)),a(window,"skyward.htmlComboBox",n(64801)),a(window,"skyward.notificationBubble",n(21314)),a(window,"skyward.searchCondition",n(38953)),a(window,"skyward.electronicSignature",n(65259)),a(window,"skyward.relativedatepicker",n(57365)),a(window,"skyward.htmlGatherer",n(63490)),a(window,"skyward.checkbox",n(67934)),a(window,"skyward.standardFilterViewer",n(28646)),a(window,"skyward.checkboxBrowse",n(46740)),a(window,"skyward.clock",n(51269)),a(window,"skyward.cashReceiptSelector",n(39699)),a(window,"skyward.stateReportingWA",n(15634)),a(window,"skyward.viewPopup",n(46482)),a(window,"skyward.support",n(78176)),a(window,"skyward.misc.autocompleteFix",n(95326)),a(window,"skyward.iframeListener",n(49698)),a(window,"skyward.translationDetector",n(742)),a(window,"skyward.externalLinks",n(28468)),a(window,"skyward.messagecenter",n(78465)),a(window,"skyward.userApproval",n(24023)),a(window,"skyward.labeledDataList",n(59588)),a(window,"skyward.dev.f6AuditWindow",n(77545))},9748(e){"use strict";e.exports=FullCalendar},74061(e){"use strict";e.exports=Vue},26721(e,t,n){"use strict";function a(e){return"string"==typeof e||e instanceof String}function o(e){var t;return"object"==typeof e&&null!=e&&"Object"===(null==e||null==(t=e.constructor)?void 0:t.name)}function r(e,t){return Array.isArray(t)?r(e,(e,n)=>t.includes(n)):Object.entries(e).reduce((e,n)=>{let[a,o]=n;return t(o,a)&&(e[a]=o),e},{})}n.d(t,{Ay:()=>p});const i="NONE",s="LEFT",l="FORCE_LEFT",c="RIGHT",d="FORCE_RIGHT";function u(e){return e.replace(/([.*+?^=!:${}()|[\]/\\])/g,"\\$1")}function f(e,t){if(t===e)return!0;const n=Array.isArray(t),a=Array.isArray(e);let o;if(n&&a){if(t.length!=e.length)return!1;for(o=0;o<t.length;o++)if(!f(t[o],e[o]))return!1;return!0}if(n!=a)return!1;if(t&&e&&"object"==typeof t&&"object"==typeof e){const n=t instanceof Date,a=e instanceof Date;if(n&&a)return t.getTime()==e.getTime();if(n!=a)return!1;const r=t instanceof RegExp,i=e instanceof RegExp;if(r&&i)return t.toString()==e.toString();if(r!=i)return!1;const s=Object.keys(t);for(o=0;o<s.length;o++)if(!Object.prototype.hasOwnProperty.call(e,s[o]))return!1;for(o=0;o<s.length;o++)if(!f(e[s[o]],t[s[o]]))return!1;return!0}return!(!t||!e||"function"!=typeof t||"function"!=typeof e)&&t.toString()===e.toString()}class h{constructor(e){for(Object.assign(this,e);this.value.slice(0,this.startChangePos)!==this.oldValue.slice(0,this.startChangePos);)--this.oldSelection.start;if(this.insertedCount)for(;this.value.slice(this.cursorPos)!==this.oldValue.slice(this.oldSelection.end);)this.value.length-this.cursorPos<this.oldValue.length-this.oldSelection.end?++this.oldSelection.end:++this.cursorPos}get startChangePos(){return Math.min(this.cursorPos,this.oldSelection.start)}get insertedCount(){return this.cursorPos-this.startChangePos}get inserted(){return this.value.substr(this.startChangePos,this.insertedCount)}get removedCount(){return Math.max(this.oldSelection.end-this.startChangePos||this.oldValue.length-this.value.length,0)}get removed(){return this.oldValue.substr(this.startChangePos,this.removedCount)}get head(){return this.value.substring(0,this.startChangePos)}get tail(){return this.value.substring(this.startChangePos+this.insertedCount)}get removeDirection(){return!this.removedCount||this.insertedCount?i:this.oldSelection.end!==this.cursorPos&&this.oldSelection.start!==this.cursorPos||this.oldSelection.end!==this.oldSelection.start?s:c}}function p(e,t){return new p.InputMask(e,t)}const m=["mask"];function g(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function w(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?g(Object(n),!0).forEach(function(t){v(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):g(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function v(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function b(e){if(null==e)throw new Error("mask property should be defined");return e instanceof RegExp?p.MaskedRegExp:a(e)?p.MaskedPattern:e===Date?p.MaskedDate:e===Number?p.MaskedNumber:Array.isArray(e)||e===Array?p.MaskedDynamic:p.Masked&&e.prototype instanceof p.Masked?e:p.Masked&&e instanceof p.Masked?e.constructor:e instanceof Function?p.MaskedFunction:(console.warn("Mask not found for mask",e),p.Masked)}function y(e){if(!e)throw new Error("Options in not defined");if(p.Masked){if(e.prototype instanceof p.Masked)return{mask:e};const t=e instanceof p.Masked?{mask:e}:o(e)&&e.mask instanceof p.Masked?e:{},{mask:n}=t,a=function(e,t){if(null==e)return{};var n,a,o=function(e,t){if(null==e)return{};var n={};for(var a in e)if({}.hasOwnProperty.call(e,a)){if(-1!==t.indexOf(a))continue;n[a]=e[a]}return n}(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(a=0;a<r.length;a++)n=r[a],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(t,m);if(n){const e=n.mask;return w(w({},r(n,(e,t)=>!t.startsWith("_"))),{},{mask:n.constructor,_mask:e},a)}}return o(e)?w({},e):{mask:e}}function _(e){if(p.Masked&&e instanceof p.Masked)return e;const t=y(e),n=b(t.mask);if(!n)throw new Error("Masked class is not found for provided mask "+t.mask+", appropriate module needs to be imported manually before creating mask.");return t.mask===n&&delete t.mask,t._mask&&(t.mask=t._mask,delete t._mask),new n(t)}p.createMask=_;class C{get selectionStart(){let e;try{e=this._unsafeSelectionStart}catch(e){}return null!=e?e:this.value.length}get selectionEnd(){let e;try{e=this._unsafeSelectionEnd}catch(e){}return null!=e?e:this.value.length}select(e,t){if(null!=e&&null!=t&&(e!==this.selectionStart||t!==this.selectionEnd))try{this._unsafeSelect(e,t)}catch(e){}}get isActive(){return!1}}p.MaskElement=C;class k extends C{constructor(e){super(),this.input=e,this._onKeydown=this._onKeydown.bind(this),this._onInput=this._onInput.bind(this),this._onBeforeinput=this._onBeforeinput.bind(this),this._onCompositionEnd=this._onCompositionEnd.bind(this)}get rootElement(){var e,t,n;return null!=(e=null==(t=(n=this.input).getRootNode)?void 0:t.call(n))?e:document}get isActive(){return this.input===this.rootElement.activeElement}bindEvents(e){this.input.addEventListener("keydown",this._onKeydown),this.input.addEventListener("input",this._onInput),this.input.addEventListener("beforeinput",this._onBeforeinput),this.input.addEventListener("compositionend",this._onCompositionEnd),this.input.addEventListener("drop",e.drop),this.input.addEventListener("click",e.click),this.input.addEventListener("focus",e.focus),this.input.addEventListener("blur",e.commit),this._handlers=e}_onKeydown(e){return this._handlers.redo&&(90===e.keyCode&&e.shiftKey&&(e.metaKey||e.ctrlKey)||89===e.keyCode&&e.ctrlKey)?(e.preventDefault(),this._handlers.redo(e)):this._handlers.undo&&90===e.keyCode&&(e.metaKey||e.ctrlKey)?(e.preventDefault(),this._handlers.undo(e)):void(e.isComposing||this._handlers.selectionChange(e))}_onBeforeinput(e){return"historyUndo"===e.inputType&&this._handlers.undo?(e.preventDefault(),this._handlers.undo(e)):"historyRedo"===e.inputType&&this._handlers.redo?(e.preventDefault(),this._handlers.redo(e)):void 0}_onCompositionEnd(e){this._handlers.input(e)}_onInput(e){e.isComposing||this._handlers.input(e)}unbindEvents(){this.input.removeEventListener("keydown",this._onKeydown),this.input.removeEventListener("input",this._onInput),this.input.removeEventListener("beforeinput",this._onBeforeinput),this.input.removeEventListener("compositionend",this._onCompositionEnd),this.input.removeEventListener("drop",this._handlers.drop),this.input.removeEventListener("click",this._handlers.click),this.input.removeEventListener("focus",this._handlers.focus),this.input.removeEventListener("blur",this._handlers.commit),this._handlers={}}}p.HTMLMaskElement=k;class S extends k{constructor(e){super(e),this.input=e}get _unsafeSelectionStart(){return null!=this.input.selectionStart?this.input.selectionStart:this.value.length}get _unsafeSelectionEnd(){return this.input.selectionEnd}_unsafeSelect(e,t){this.input.setSelectionRange(e,t)}get value(){return this.input.value}set value(e){this.input.value=e}}p.HTMLMaskElement=k;class D extends k{get _unsafeSelectionStart(){const e=this.rootElement,t=e.getSelection&&e.getSelection(),n=t&&t.anchorOffset,a=t&&t.focusOffset;return null==a||null==n||n<a?n:a}get _unsafeSelectionEnd(){const e=this.rootElement,t=e.getSelection&&e.getSelection(),n=t&&t.anchorOffset,a=t&&t.focusOffset;return null==a||null==n||n>a?n:a}_unsafeSelect(e,t){if(!this.rootElement.createRange)return;const n=this.rootElement.createRange();n.setStart(this.input.firstChild||this.input,e),n.setEnd(this.input.lastChild||this.input,t);const a=this.rootElement,o=a.getSelection&&a.getSelection();o&&(o.removeAllRanges(),o.addRange(n))}get value(){return this.input.textContent||""}set value(e){this.input.textContent=e}}p.HTMLContenteditableMaskElement=D;class E{constructor(){this.states=[],this.currentIndex=0}get currentState(){return this.states[this.currentIndex]}get isEmpty(){return 0===this.states.length}push(e){this.currentIndex<this.states.length-1&&(this.states.length=this.currentIndex+1),this.states.push(e),this.states.length>E.MAX_LENGTH&&this.states.shift(),this.currentIndex=this.states.length-1}go(e){return this.currentIndex=Math.min(Math.max(this.currentIndex+e,0),this.states.length-1),this.currentState}undo(){return this.go(-1)}redo(){return this.go(1)}clear(){this.states.length=0,this.currentIndex=0}}E.MAX_LENGTH=100;const P=["mask"];p.InputMask=class{constructor(e,t){this.el=e instanceof C?e:e.isContentEditable&&"INPUT"!==e.tagName&&"TEXTAREA"!==e.tagName?new D(e):new S(e),this.masked=_(t),this._listeners={},this._value="",this._unmaskedValue="",this._rawInputValue="",this.history=new E,this._saveSelection=this._saveSelection.bind(this),this._onInput=this._onInput.bind(this),this._onChange=this._onChange.bind(this),this._onDrop=this._onDrop.bind(this),this._onFocus=this._onFocus.bind(this),this._onClick=this._onClick.bind(this),this._onUndo=this._onUndo.bind(this),this._onRedo=this._onRedo.bind(this),this.alignCursor=this.alignCursor.bind(this),this.alignCursorFriendly=this.alignCursorFriendly.bind(this),this._bindEvents(),this.updateValue(),this._onChange()}maskEquals(e){var t;return null==e||(null==(t=this.masked)?void 0:t.maskEquals(e))}get mask(){return this.masked.mask}set mask(e){if(this.maskEquals(e))return;if(!(e instanceof p.Masked)&&this.masked.constructor===b(e))return void this.masked.updateOptions({mask:e});const t=e instanceof p.Masked?e:_({mask:e});t.unmaskedValue=this.masked.unmaskedValue,this.masked=t}get value(){return this._value}set value(e){this.value!==e&&(this.masked.value=e,this.updateControl("auto"))}get unmaskedValue(){return this._unmaskedValue}set unmaskedValue(e){this.unmaskedValue!==e&&(this.masked.unmaskedValue=e,this.updateControl("auto"))}get rawInputValue(){return this._rawInputValue}set rawInputValue(e){this.rawInputValue!==e&&(this.masked.rawInputValue=e,this.updateControl(),this.alignCursor())}get typedValue(){return this.masked.typedValue}set typedValue(e){this.masked.typedValueEquals(e)||(this.masked.typedValue=e,this.updateControl("auto"))}get displayValue(){return this.masked.displayValue}_bindEvents(){this.el.bindEvents({selectionChange:this._saveSelection,input:this._onInput,drop:this._onDrop,click:this._onClick,focus:this._onFocus,commit:this._onChange,undo:this._onUndo,redo:this._onRedo})}_unbindEvents(){this.el&&this.el.unbindEvents()}_fireEvent(e,t){const n=this._listeners[e];n&&n.forEach(e=>e(t))}get selectionStart(){return this._cursorChanging?this._changingCursorPos:this.el.selectionStart}get cursorPos(){return this._cursorChanging?this._changingCursorPos:this.el.selectionEnd}set cursorPos(e){this.el&&this.el.isActive&&(this.el.select(e,e),this._saveSelection())}_saveSelection(){this.displayValue!==this.el.value&&console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."),this._selection={start:this.selectionStart,end:this.cursorPos}}updateValue(){this.masked.value=this.el.value,this._value=this.masked.value,this._unmaskedValue=this.masked.unmaskedValue,this._rawInputValue=this.masked.rawInputValue}updateControl(e){const t=this.masked.unmaskedValue,n=this.masked.value,a=this.masked.rawInputValue,o=this.displayValue,r=this.unmaskedValue!==t||this.value!==n||this._rawInputValue!==a;this._unmaskedValue=t,this._value=n,this._rawInputValue=a,this.el.value!==o&&(this.el.value=o),"auto"===e?this.alignCursor():null!=e&&(this.cursorPos=e),r&&this._fireChangeEvents(),this._historyChanging||!r&&!this.history.isEmpty||this.history.push({unmaskedValue:t,selection:{start:this.selectionStart,end:this.cursorPos}})}updateOptions(e){const{mask:t}=e,n=function(e,t){if(null==e)return{};var n,a,o=function(e,t){if(null==e)return{};var n={};for(var a in e)if({}.hasOwnProperty.call(e,a)){if(-1!==t.indexOf(a))continue;n[a]=e[a]}return n}(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(a=0;a<r.length;a++)n=r[a],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,P),a=!this.maskEquals(t),o=this.masked.optionsIsChanged(n);a&&(this.mask=t),o&&this.masked.updateOptions(n),(a||o)&&this.updateControl()}updateCursor(e){null!=e&&(this.cursorPos=e,this._delayUpdateCursor(e))}_delayUpdateCursor(e){this._abortUpdateCursor(),this._changingCursorPos=e,this._cursorChanging=setTimeout(()=>{this.el&&(this.cursorPos=this._changingCursorPos,this._abortUpdateCursor())},10)}_fireChangeEvents(){this._fireEvent("accept",this._inputEvent),this.masked.isComplete&&this._fireEvent("complete",this._inputEvent)}_abortUpdateCursor(){this._cursorChanging&&(clearTimeout(this._cursorChanging),delete this._cursorChanging)}alignCursor(){this.cursorPos=this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos,s))}alignCursorFriendly(){this.selectionStart===this.cursorPos&&this.alignCursor()}on(e,t){return this._listeners[e]||(this._listeners[e]=[]),this._listeners[e].push(t),this}off(e,t){if(!this._listeners[e])return this;if(!t)return delete this._listeners[e],this;const n=this._listeners[e].indexOf(t);return n>=0&&this._listeners[e].splice(n,1),this}_onInput(e){this._inputEvent=e,this._abortUpdateCursor();const t=new h({value:this.el.value,cursorPos:this.cursorPos,oldValue:this.displayValue,oldSelection:this._selection}),n=this.masked.rawInputValue,a=this.masked.splice(t.startChangePos,t.removed.length,t.inserted,t.removeDirection,{input:!0,raw:!0}).offset,o=n===this.masked.rawInputValue?t.removeDirection:i;let r=this.masked.nearestInputPos(t.startChangePos+a,o);o!==i&&(r=this.masked.nearestInputPos(r,i)),this.updateControl(r),delete this._inputEvent}_onChange(){this.displayValue!==this.el.value&&this.updateValue(),this.masked.doCommit(),this.updateControl(),this._saveSelection()}_onDrop(e){e.preventDefault(),e.stopPropagation()}_onFocus(e){this.alignCursorFriendly()}_onClick(e){this.alignCursorFriendly()}_onUndo(){this._applyHistoryState(this.history.undo())}_onRedo(){this._applyHistoryState(this.history.redo())}_applyHistoryState(e){e&&(this._historyChanging=!0,this.unmaskedValue=e.unmaskedValue,this.el.select(e.selection.start,e.selection.end),this._saveSelection(),this._historyChanging=!1)}destroy(){this._unbindEvents(),this._listeners.length=0,delete this.el}};class O{static normalize(e){return Array.isArray(e)?e:[e,new O]}constructor(e){Object.assign(this,{inserted:"",rawInserted:"",tailShift:0,skip:!1},e)}aggregate(e){return this.inserted+=e.inserted,this.rawInserted+=e.rawInserted,this.tailShift+=e.tailShift,this.skip=this.skip||e.skip,this}get offset(){return this.tailShift+this.inserted.length}get consumed(){return Boolean(this.rawInserted)||this.skip}equals(e){return this.inserted===e.inserted&&this.tailShift===e.tailShift&&this.rawInserted===e.rawInserted&&this.skip===e.skip}}p.ChangeDetails=O;class B{constructor(e,t,n){void 0===e&&(e=""),void 0===t&&(t=0),this.value=e,this.from=t,this.stop=n}toString(){return this.value}extend(e){this.value+=String(e)}appendTo(e){return e.append(this.toString(),{tail:!0}).aggregate(e._appendPlaceholder())}get state(){return{value:this.value,from:this.from,stop:this.stop}}set state(e){Object.assign(this,e)}unshift(e){if(!this.value.length||null!=e&&this.from>=e)return"";const t=this.value[0];return this.value=this.value.slice(1),t}shift(){if(!this.value.length)return"";const e=this.value[this.value.length-1];return this.value=this.value.slice(0,-1),e}}function T(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function x(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?T(Object(n),!0).forEach(function(t){M(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):T(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function M(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}class I{constructor(e){this._value="",this._update(x(x({},I.DEFAULTS),e)),this._initialized=!0}updateOptions(e){this.optionsIsChanged(e)&&this.withValueRefresh(this._update.bind(this,e))}_update(e){Object.assign(this,e)}get state(){return{_value:this.value,_rawInputValue:this.rawInputValue}}set state(e){this._value=e._value}reset(){this._value=""}get value(){return this._value}set value(e){this.resolve(e,{input:!0})}resolve(e,t){void 0===t&&(t={input:!0}),this.reset(),this.append(e,t,""),this.doCommit()}get unmaskedValue(){return this.value}set unmaskedValue(e){this.resolve(e,{})}get typedValue(){return this.parse?this.parse(this.value,this):this.unmaskedValue}set typedValue(e){this.format?this.value=this.format(e,this):this.unmaskedValue=String(e)}get rawInputValue(){return this.extractInput(0,this.displayValue.length,{raw:!0})}set rawInputValue(e){this.resolve(e,{raw:!0})}get displayValue(){return this.value}get isComplete(){return!0}get isFilled(){return this.isComplete}nearestInputPos(e,t){return e}totalInputPositions(e,t){return void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),Math.min(this.displayValue.length,t-e)}extractInput(e,t,n){return void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),this.displayValue.slice(e,t)}extractTail(e,t){return void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),new B(this.extractInput(e,t),e)}appendTail(e){return a(e)&&(e=new B(String(e))),e.appendTo(this)}_appendCharRaw(e,t){return e?(this._value+=e,new O({inserted:e,rawInserted:e})):new O}_appendChar(e,t,n){void 0===t&&(t={});const a=this.state;let o;if([e,o]=this.doPrepareChar(e,t),e&&(o=o.aggregate(this._appendCharRaw(e,t)),!o.rawInserted&&"pad"===this.autofix)){const n=this.state;this.state=a;let r=this.pad(t);const i=this._appendCharRaw(e,t);r=r.aggregate(i),i.rawInserted||r.equals(o)?o=r:this.state=n}if(o.inserted){let e,r=!1!==this.doValidate(t);if(r&&null!=n){const t=this.state;if(!0===this.overwrite){e=n.state;for(let e=0;e<o.rawInserted.length;++e)n.unshift(this.displayValue.length-o.tailShift)}let a=this.appendTail(n);if(r=a.rawInserted.length===n.toString().length,!(r&&a.inserted||"shift"!==this.overwrite)){this.state=t,e=n.state;for(let e=0;e<o.rawInserted.length;++e)n.shift();a=this.appendTail(n),r=a.rawInserted.length===n.toString().length}r&&a.inserted&&(this.state=t)}r||(o=new O,this.state=a,n&&e&&(n.state=e))}return o}_appendPlaceholder(){return new O}_appendEager(){return new O}append(e,t,n){if(!a(e))throw new Error("value should be string");const o=a(n)?new B(String(n)):n;let r;null!=t&&t.tail&&(t._beforeTailState=this.state),[e,r]=this.doPrepare(e,t);for(let n=0;n<e.length;++n){const a=this._appendChar(e[n],t,o);if(!a.rawInserted&&!this.doSkipInvalid(e[n],t,o))break;r.aggregate(a)}return(!0===this.eager||"append"===this.eager)&&null!=t&&t.input&&e&&r.aggregate(this._appendEager()),null!=o&&(r.tailShift+=this.appendTail(o).tailShift),r}remove(e,t){return void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),this._value=this.displayValue.slice(0,e)+this.displayValue.slice(t),new O}withValueRefresh(e){if(this._refreshing||!this._initialized)return e();this._refreshing=!0;const t=this.rawInputValue,n=this.value,a=e();return this.rawInputValue=t,this.value&&this.value!==n&&0===n.indexOf(this.value)&&(this.append(n.slice(this.displayValue.length),{},""),this.doCommit()),delete this._refreshing,a}runIsolated(e){if(this._isolated||!this._initialized)return e(this);this._isolated=!0;const t=this.state,n=e(this);return this.state=t,delete this._isolated,n}doSkipInvalid(e,t,n){return Boolean(this.skipInvalid)}doPrepare(e,t){return void 0===t&&(t={}),O.normalize(this.prepare?this.prepare(e,this,t):e)}doPrepareChar(e,t){return void 0===t&&(t={}),O.normalize(this.prepareChar?this.prepareChar(e,this,t):e)}doValidate(e){return(!this.validate||this.validate(this.value,this,e))&&(!this.parent||this.parent.doValidate(e))}doCommit(){this.commit&&this.commit(this.value,this)}splice(e,t,n,a,o){void 0===n&&(n=""),void 0===a&&(a=i),void 0===o&&(o={input:!0});const r=e+t,u=this.extractTail(r),f=!0===this.eager||"remove"===this.eager;let h;f&&(a=function(e){switch(e){case s:return l;case c:return d;default:return e}}(a),h=this.extractInput(0,r,{raw:!0}));let p=e;const m=new O;if(a!==i&&(p=this.nearestInputPos(e,t>1&&0!==e&&!f?i:a),m.tailShift=p-e),m.aggregate(this.remove(p)),f&&a!==i&&h===this.rawInputValue)if(a===l){let e;for(;h===this.rawInputValue&&(e=this.displayValue.length);)m.aggregate(new O({tailShift:-1})).aggregate(this.remove(e-1))}else a===d&&u.unshift();return m.aggregate(this.append(n,o,u))}maskEquals(e){return this.mask===e}optionsIsChanged(e){return!f(this,e)}typedValueEquals(e){const t=this.typedValue;return e===t||I.EMPTY_VALUES.includes(e)&&I.EMPTY_VALUES.includes(t)||!!this.format&&this.format(e,this)===this.format(this.typedValue,this)}pad(e){return new O}}I.DEFAULTS={skipInvalid:!0},I.EMPTY_VALUES=[void 0,null,""],p.Masked=I;const A=["chunks"];class L{constructor(e,t){void 0===e&&(e=[]),void 0===t&&(t=0),this.chunks=e,this.from=t}toString(){return this.chunks.map(String).join("")}extend(e){if(!String(e))return;e=a(e)?new B(String(e)):e;const t=this.chunks[this.chunks.length-1],n=t&&(t.stop===e.stop||null==e.stop)&&e.from===t.from+t.toString().length;if(e instanceof B)n?t.extend(e.toString()):this.chunks.push(e);else if(e instanceof L){if(null==e.stop){let t;for(;e.chunks.length&&null==e.chunks[0].stop;)t=e.chunks.shift(),t.from+=e.from,this.extend(t)}e.toString()&&(e.stop=e.blockIndex,this.chunks.push(e))}}appendTo(e){if(!(e instanceof p.MaskedPattern)){return new B(this.toString()).appendTo(e)}const t=new O;for(let n=0;n<this.chunks.length;++n){const a=this.chunks[n],o=e._mapPosToBlock(e.displayValue.length),r=a.stop;let i;if(null!=r&&(!o||o.index<=r)&&((a instanceof L||e._stops.indexOf(r)>=0)&&t.aggregate(e._appendPlaceholder(r)),i=a instanceof L&&e._blocks[r]),i){const n=i.appendTail(a);t.aggregate(n);const o=a.toString().slice(n.rawInserted.length);o&&t.aggregate(e.append(o,{tail:!0}))}else t.aggregate(e.append(a.toString(),{tail:!0}))}return t}get state(){return{chunks:this.chunks.map(e=>e.state),from:this.from,stop:this.stop,blockIndex:this.blockIndex}}set state(e){const{chunks:t}=e,n=function(e,t){if(null==e)return{};var n,a,o=function(e,t){if(null==e)return{};var n={};for(var a in e)if({}.hasOwnProperty.call(e,a)){if(-1!==t.indexOf(a))continue;n[a]=e[a]}return n}(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(a=0;a<r.length;a++)n=r[a],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,A);Object.assign(this,n),this.chunks=t.map(e=>{const t="chunks"in e?new L:new B;return t.state=e,t})}unshift(e){if(!this.chunks.length||null!=e&&this.from>=e)return"";const t=null!=e?e-this.from:e;let n=0;for(;n<this.chunks.length;){const e=this.chunks[n],a=e.unshift(t);if(e.toString()){if(!a)break;++n}else this.chunks.splice(n,1);if(a)return a}return""}shift(){if(!this.chunks.length)return"";let e=this.chunks.length-1;for(;0<=e;){const t=this.chunks[e],n=t.shift();if(t.toString()){if(!n)break;--e}else this.chunks.splice(e,1);if(n)return n}return""}}class R{constructor(e,t){this.masked=e,this._log=[];const{offset:n,index:a}=e._mapPosToBlock(t)||(t<0?{index:0,offset:0}:{index:this.masked._blocks.length,offset:0});this.offset=n,this.index=a,this.ok=!1}get block(){return this.masked._blocks[this.index]}get pos(){return this.masked._blockStartPos(this.index)+this.offset}get state(){return{index:this.index,offset:this.offset,ok:this.ok}}set state(e){Object.assign(this,e)}pushState(){this._log.push(this.state)}popState(){const e=this._log.pop();return e&&(this.state=e),e}bindBlock(){this.block||(this.index<0&&(this.index=0,this.offset=0),this.index>=this.masked._blocks.length&&(this.index=this.masked._blocks.length-1,this.offset=this.block.displayValue.length))}_pushLeft(e){for(this.pushState(),this.bindBlock();0<=this.index;--this.index,this.offset=(null==(t=this.block)?void 0:t.displayValue.length)||0){var t;if(e())return this.ok=!0}return this.ok=!1}_pushRight(e){for(this.pushState(),this.bindBlock();this.index<this.masked._blocks.length;++this.index,this.offset=0)if(e())return this.ok=!0;return this.ok=!1}pushLeftBeforeFilled(){return this._pushLeft(()=>{if(!this.block.isFixed&&this.block.value)return this.offset=this.block.nearestInputPos(this.offset,l),0!==this.offset||void 0})}pushLeftBeforeInput(){return this._pushLeft(()=>{if(!this.block.isFixed)return this.offset=this.block.nearestInputPos(this.offset,s),!0})}pushLeftBeforeRequired(){return this._pushLeft(()=>{if(!(this.block.isFixed||this.block.isOptional&&!this.block.value))return this.offset=this.block.nearestInputPos(this.offset,s),!0})}pushRightBeforeFilled(){return this._pushRight(()=>{if(!this.block.isFixed&&this.block.value)return this.offset=this.block.nearestInputPos(this.offset,d),this.offset!==this.block.value.length||void 0})}pushRightBeforeInput(){return this._pushRight(()=>{if(!this.block.isFixed)return this.offset=this.block.nearestInputPos(this.offset,i),!0})}pushRightBeforeRequired(){return this._pushRight(()=>{if(!(this.block.isFixed||this.block.isOptional&&!this.block.value))return this.offset=this.block.nearestInputPos(this.offset,i),!0})}}class N{constructor(e){Object.assign(this,e),this._value="",this.isFixed=!0}get value(){return this._value}get unmaskedValue(){return this.isUnmasking?this.value:""}get rawInputValue(){return this._isRawInput?this.value:""}get displayValue(){return this.value}reset(){this._isRawInput=!1,this._value=""}remove(e,t){return void 0===e&&(e=0),void 0===t&&(t=this._value.length),this._value=this._value.slice(0,e)+this._value.slice(t),this._value||(this._isRawInput=!1),new O}nearestInputPos(e,t){void 0===t&&(t=i);const n=this._value.length;switch(t){case s:case l:return 0;default:return n}}totalInputPositions(e,t){return void 0===e&&(e=0),void 0===t&&(t=this._value.length),this._isRawInput?t-e:0}extractInput(e,t,n){return void 0===e&&(e=0),void 0===t&&(t=this._value.length),void 0===n&&(n={}),n.raw&&this._isRawInput&&this._value.slice(e,t)||""}get isComplete(){return!0}get isFilled(){return Boolean(this._value)}_appendChar(e,t){if(void 0===t&&(t={}),this.isFilled)return new O;const n=!0===this.eager||"append"===this.eager,a=this.char===e&&(this.isUnmasking||t.input||t.raw)&&(!t.raw||!n)&&!t.tail,o=new O({inserted:this.char,rawInserted:a?this.char:""});return this._value=this.char,this._isRawInput=a&&(t.raw||t.input),o}_appendEager(){return this._appendChar(this.char,{tail:!0})}_appendPlaceholder(){const e=new O;return this.isFilled||(this._value=e.inserted=this.char),e}extractTail(){return new B("")}appendTail(e){return a(e)&&(e=new B(String(e))),e.appendTo(this)}append(e,t,n){const a=this._appendChar(e[0],t);return null!=n&&(a.tailShift+=this.appendTail(n).tailShift),a}doCommit(){}get state(){return{_value:this._value,_rawInputValue:this.rawInputValue}}set state(e){this._value=e._value,this._isRawInput=Boolean(e._rawInputValue)}pad(e){return this._appendPlaceholder()}}const F=["parent","isOptional","placeholderChar","displayChar","lazy","eager"];function j(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function $(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?j(Object(n),!0).forEach(function(t){V(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):j(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function V(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}class H{constructor(e){const{parent:t,isOptional:n,placeholderChar:a,displayChar:o,lazy:r,eager:i}=e,s=function(e,t){if(null==e)return{};var n,a,o=function(e,t){if(null==e)return{};var n={};for(var a in e)if({}.hasOwnProperty.call(e,a)){if(-1!==t.indexOf(a))continue;n[a]=e[a]}return n}(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(a=0;a<r.length;a++)n=r[a],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,F);this.masked=_(s),Object.assign(this,{parent:t,isOptional:n,placeholderChar:a,displayChar:o,lazy:r,eager:i})}reset(){this.isFilled=!1,this.masked.reset()}remove(e,t){return void 0===e&&(e=0),void 0===t&&(t=this.value.length),0===e&&t>=1?(this.isFilled=!1,this.masked.remove(e,t)):new O}get value(){return this.masked.value||(this.isFilled&&!this.isOptional?this.placeholderChar:"")}get unmaskedValue(){return this.masked.unmaskedValue}get rawInputValue(){return this.masked.rawInputValue}get displayValue(){return this.masked.value&&this.displayChar||this.value}get isComplete(){return Boolean(this.masked.value)||this.isOptional}_appendChar(e,t){if(void 0===t&&(t={}),this.isFilled)return new O;const n=this.masked.state;let a=this.masked._appendChar(e,this.currentMaskFlags(t));return a.inserted&&!1===this.doValidate(t)&&(a=new O,this.masked.state=n),a.inserted||this.isOptional||this.lazy||t.input||(a.inserted=this.placeholderChar),a.skip=!a.inserted&&!this.isOptional,this.isFilled=Boolean(a.inserted),a}append(e,t,n){return this.masked.append(e,this.currentMaskFlags(t),n)}_appendPlaceholder(){return this.isFilled||this.isOptional?new O:(this.isFilled=!0,new O({inserted:this.placeholderChar}))}_appendEager(){return new O}extractTail(e,t){return this.masked.extractTail(e,t)}appendTail(e){return this.masked.appendTail(e)}extractInput(e,t,n){return void 0===e&&(e=0),void 0===t&&(t=this.value.length),this.masked.extractInput(e,t,n)}nearestInputPos(e,t){void 0===t&&(t=i);const n=this.value.length,a=Math.min(Math.max(e,0),n);switch(t){case s:case l:return this.isComplete?a:0;case c:case d:return this.isComplete?a:n;default:return a}}totalInputPositions(e,t){return void 0===e&&(e=0),void 0===t&&(t=this.value.length),this.value.slice(e,t).length}doValidate(e){return this.masked.doValidate(this.currentMaskFlags(e))&&(!this.parent||this.parent.doValidate(this.currentMaskFlags(e)))}doCommit(){this.masked.doCommit()}get state(){return{_value:this.value,_rawInputValue:this.rawInputValue,masked:this.masked.state,isFilled:this.isFilled}}set state(e){this.masked.state=e.masked,this.isFilled=e.isFilled}currentMaskFlags(e){var t;return $($({},e),{},{_beforeTailState:(null==e||null==(t=e._beforeTailState)?void 0:t.masked)||(null==e?void 0:e._beforeTailState)})}pad(e){return new O}}H.DEFAULT_DEFINITIONS={0:/\d/,a:/[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,"*":/./};p.MaskedRegExp=class extends I{updateOptions(e){super.updateOptions(e)}_update(e){const t=e.mask;t&&(e.validate=e=>e.search(t)>=0),super._update(e)}};const W=["expose","repeat"],U=["_blocks"];function K(e,t){if(null==e)return{};var n,a,o=function(e,t){if(null==e)return{};var n={};for(var a in e)if({}.hasOwnProperty.call(e,a)){if(-1!==t.indexOf(a))continue;n[a]=e[a]}return n}(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(a=0;a<r.length;a++)n=r[a],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}function q(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function G(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?q(Object(n),!0).forEach(function(t){z(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):q(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function z(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}class J extends I{constructor(e){super(G(G(G({},J.DEFAULTS),e),{},{definitions:Object.assign({},H.DEFAULT_DEFINITIONS,null==e?void 0:e.definitions)}))}updateOptions(e){super.updateOptions(e)}_update(e){e.definitions=Object.assign({},this.definitions,e.definitions),super._update(e),this._rebuildMask()}_rebuildMask(){const e=this.definitions;this._blocks=[],this.exposeBlock=void 0,this._stops=[],this._maskedBlocks={};const t=this.mask;if(!t||!e)return;let n=!1,a=!1;for(let o=0;o<t.length;++o){if(this.blocks){const e=t.slice(o),n=Object.keys(this.blocks).filter(t=>0===e.indexOf(t));n.sort((e,t)=>t.length-e.length);const a=n[0];if(a){const e=y(this.blocks[a]),{expose:t,repeat:n}=e,r=K(e,W),i=G(G({lazy:this.lazy,eager:this.eager,placeholderChar:this.placeholderChar,displayChar:this.displayChar,overwrite:this.overwrite,autofix:this.autofix},r),{},{repeat:n,parent:this}),s=null!=n?new p.RepeatBlock(i):_(i);s&&(this._blocks.push(s),t&&(this.exposeBlock=s),this._maskedBlocks[a]||(this._maskedBlocks[a]=[]),this._maskedBlocks[a].push(this._blocks.length-1)),o+=a.length-1;continue}}let r=t[o],i=r in e;if(r===J.STOP_CHAR){this._stops.push(this._blocks.length);continue}if("{"===r||"}"===r){n=!n;continue}if("["===r||"]"===r){a=!a;continue}if(r===J.ESCAPE_CHAR){if(++o,r=t[o],!r)break;i=!1}const s=i?new H(G(G({isOptional:a,lazy:this.lazy,eager:this.eager,placeholderChar:this.placeholderChar,displayChar:this.displayChar},y(e[r])),{},{parent:this})):new N({char:r,eager:this.eager,isUnmasking:n});this._blocks.push(s)}}get state(){return G(G({},super.state),{},{_blocks:this._blocks.map(e=>e.state)})}set state(e){if(!e)return void this.reset();const{_blocks:t}=e,n=K(e,U);this._blocks.forEach((e,n)=>e.state=t[n]),super.state=n}reset(){super.reset(),this._blocks.forEach(e=>e.reset())}get isComplete(){return this.exposeBlock?this.exposeBlock.isComplete:this._blocks.every(e=>e.isComplete)}get isFilled(){return this._blocks.every(e=>e.isFilled)}get isFixed(){return this._blocks.every(e=>e.isFixed)}get isOptional(){return this._blocks.every(e=>e.isOptional)}doCommit(){this._blocks.forEach(e=>e.doCommit()),super.doCommit()}get unmaskedValue(){return this.exposeBlock?this.exposeBlock.unmaskedValue:this._blocks.reduce((e,t)=>e+t.unmaskedValue,"")}set unmaskedValue(e){if(this.exposeBlock){const t=this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock))+this.exposeBlock.displayValue.length);this.exposeBlock.unmaskedValue=e,this.appendTail(t),this.doCommit()}else super.unmaskedValue=e}get value(){return this.exposeBlock?this.exposeBlock.value:this._blocks.reduce((e,t)=>e+t.value,"")}set value(e){if(this.exposeBlock){const t=this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock))+this.exposeBlock.displayValue.length);this.exposeBlock.value=e,this.appendTail(t),this.doCommit()}else super.value=e}get typedValue(){return this.exposeBlock?this.exposeBlock.typedValue:super.typedValue}set typedValue(e){if(this.exposeBlock){const t=this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock))+this.exposeBlock.displayValue.length);this.exposeBlock.typedValue=e,this.appendTail(t),this.doCommit()}else super.typedValue=e}get displayValue(){return this._blocks.reduce((e,t)=>e+t.displayValue,"")}appendTail(e){return super.appendTail(e).aggregate(this._appendPlaceholder())}_appendEager(){var e;const t=new O;let n=null==(e=this._mapPosToBlock(this.displayValue.length))?void 0:e.index;if(null==n)return t;this._blocks[n].isFilled&&++n;for(let e=n;e<this._blocks.length;++e){const n=this._blocks[e]._appendEager();if(!n.inserted)break;t.aggregate(n)}return t}_appendCharRaw(e,t){void 0===t&&(t={});const n=this._mapPosToBlock(this.displayValue.length),a=new O;if(!n)return a;for(let r,i=n.index;r=this._blocks[i];++i){var o;const n=r._appendChar(e,G(G({},t),{},{_beforeTailState:null==(o=t._beforeTailState)||null==(o=o._blocks)?void 0:o[i]}));if(a.aggregate(n),n.consumed)break}return a}extractTail(e,t){void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length);const n=new L;return e===t||this._forEachBlocksInRange(e,t,(e,t,a,o)=>{const r=e.extractTail(a,o);r.stop=this._findStopBefore(t),r.from=this._blockStartPos(t),r instanceof L&&(r.blockIndex=t),n.extend(r)}),n}extractInput(e,t,n){if(void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),void 0===n&&(n={}),e===t)return"";let a="";return this._forEachBlocksInRange(e,t,(e,t,o,r)=>{a+=e.extractInput(o,r,n)}),a}_findStopBefore(e){let t;for(let n=0;n<this._stops.length;++n){const a=this._stops[n];if(!(a<=e))break;t=a}return t}_appendPlaceholder(e){const t=new O;if(this.lazy&&null==e)return t;const n=this._mapPosToBlock(this.displayValue.length);if(!n)return t;const a=n.index,o=null!=e?e:this._blocks.length;return this._blocks.slice(a,o).forEach(n=>{var a;n.lazy&&null==e||t.aggregate(n._appendPlaceholder(null==(a=n._blocks)?void 0:a.length))}),t}_mapPosToBlock(e){let t="";for(let n=0;n<this._blocks.length;++n){const a=this._blocks[n],o=t.length;if(t+=a.displayValue,e<=t.length)return{index:n,offset:e-o}}}_blockStartPos(e){return this._blocks.slice(0,e).reduce((e,t)=>e+t.displayValue.length,0)}_forEachBlocksInRange(e,t,n){void 0===t&&(t=this.displayValue.length);const a=this._mapPosToBlock(e);if(a){const e=this._mapPosToBlock(t),o=e&&a.index===e.index,r=a.offset,i=e&&o?e.offset:this._blocks[a.index].displayValue.length;if(n(this._blocks[a.index],a.index,r,i),e&&!o){for(let t=a.index+1;t<e.index;++t)n(this._blocks[t],t,0,this._blocks[t].displayValue.length);n(this._blocks[e.index],e.index,0,e.offset)}}}remove(e,t){void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length);const n=super.remove(e,t);return this._forEachBlocksInRange(e,t,(e,t,a,o)=>{n.aggregate(e.remove(a,o))}),n}nearestInputPos(e,t){if(void 0===t&&(t=i),!this._blocks.length)return 0;const n=new R(this,e);if(t===i)return n.pushRightBeforeInput()?n.pos:(n.popState(),n.pushLeftBeforeInput()?n.pos:this.displayValue.length);if(t===s||t===l){if(t===s){if(n.pushRightBeforeFilled(),n.ok&&n.pos===e)return e;n.popState()}if(n.pushLeftBeforeInput(),n.pushLeftBeforeRequired(),n.pushLeftBeforeFilled(),t===s){if(n.pushRightBeforeInput(),n.pushRightBeforeRequired(),n.ok&&n.pos<=e)return n.pos;if(n.popState(),n.ok&&n.pos<=e)return n.pos;n.popState()}return n.ok?n.pos:t===l?0:(n.popState(),n.ok?n.pos:(n.popState(),n.ok?n.pos:0))}return t===c||t===d?(n.pushRightBeforeInput(),n.pushRightBeforeRequired(),n.pushRightBeforeFilled()?n.pos:t===d?this.displayValue.length:(n.popState(),n.ok?n.pos:(n.popState(),n.ok?n.pos:this.nearestInputPos(e,s)))):e}totalInputPositions(e,t){void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length);let n=0;return this._forEachBlocksInRange(e,t,(e,t,a,o)=>{n+=e.totalInputPositions(a,o)}),n}maskedBlock(e){return this.maskedBlocks(e)[0]}maskedBlocks(e){const t=this._maskedBlocks[e];return t?t.map(e=>this._blocks[e]):[]}pad(e){const t=new O;return this._forEachBlocksInRange(0,this.displayValue.length,n=>t.aggregate(n.pad(e))),t}}J.DEFAULTS=G(G({},I.DEFAULTS),{},{lazy:!0,placeholderChar:"_"}),J.STOP_CHAR="`",J.ESCAPE_CHAR="\\",J.InputDefinition=H,J.FixedDefinition=N,p.MaskedPattern=J;const Y=["to","from","maxLength","autofix"];class Q extends J{get _matchFrom(){return this.maxLength-String(this.from).length}constructor(e){super(e)}updateOptions(e){super.updateOptions(e)}_update(e){const{to:t=this.to||0,from:n=this.from||0,maxLength:a=this.maxLength||0,autofix:o=this.autofix}=e,r=function(e,t){if(null==e)return{};var n,a,o=function(e,t){if(null==e)return{};var n={};for(var a in e)if({}.hasOwnProperty.call(e,a)){if(-1!==t.indexOf(a))continue;n[a]=e[a]}return n}(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(a=0;a<r.length;a++)n=r[a],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,Y);this.to=t,this.from=n,this.maxLength=Math.max(String(t).length,a),this.autofix=o;const i=String(this.from).padStart(this.maxLength,"0"),s=String(this.to).padStart(this.maxLength,"0");let l=0;for(;l<s.length&&s[l]===i[l];)++l;r.mask=s.slice(0,l).replace(/0/g,"\\0")+"0".repeat(this.maxLength-l),super._update(r)}get isComplete(){return super.isComplete&&Boolean(this.value)}boundaries(e){let t="",n="";const[,a,o]=e.match(/^(\D*)(\d*)(\D*)/)||[];return o&&(t="0".repeat(a.length)+o,n="9".repeat(a.length)+o),t=t.padEnd(this.maxLength,"0"),n=n.padEnd(this.maxLength,"9"),[t,n]}doPrepareChar(e,t){let n;return void 0===t&&(t={}),[e,n]=super.doPrepareChar(e.replace(/\D/g,""),t),e||(n.skip=!this.isComplete),[e,n]}_appendCharRaw(e,t){if(void 0===t&&(t={}),!this.autofix||this.value.length+1>this.maxLength)return super._appendCharRaw(e,t);const n=String(this.from).padStart(this.maxLength,"0"),a=String(this.to).padStart(this.maxLength,"0"),[o,r]=this.boundaries(this.value+e);return Number(r)<this.from?super._appendCharRaw(n[this.value.length],t):Number(o)>this.to?!t.tail&&"pad"===this.autofix&&this.value.length+1<this.maxLength?super._appendCharRaw(n[this.value.length],t).aggregate(this._appendCharRaw(e,t)):super._appendCharRaw(a[this.value.length],t):super._appendCharRaw(e,t)}doValidate(e){const t=this.value;if(-1===t.search(/[^0]/)&&t.length<=this._matchFrom)return!0;const[n,a]=this.boundaries(t);return this.from<=Number(a)&&Number(n)<=this.to&&super.doValidate(e)}pad(e){const t=new O;if(this.value.length===this.maxLength)return t;const n=this.value,a=this.maxLength-this.value.length;if(a){this.reset();for(let n=0;n<a;++n)t.aggregate(super._appendCharRaw("0",e));n.split("").forEach(e=>this._appendCharRaw(e))}return t}}p.MaskedRange=Q;const X=["mask","pattern"],Z=["mask","pattern","blocks"];function ee(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function te(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ee(Object(n),!0).forEach(function(t){ne(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ee(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function ne(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function ae(e,t){if(null==e)return{};var n,a,o=function(e,t){if(null==e)return{};var n={};for(var a in e)if({}.hasOwnProperty.call(e,a)){if(-1!==t.indexOf(a))continue;n[a]=e[a]}return n}(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(a=0;a<r.length;a++)n=r[a],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}class oe extends J{static extractPatternOptions(e){const{mask:t,pattern:n}=e;return te(te({},ae(e,X)),{},{mask:a(t)?t:n})}constructor(e){super(oe.extractPatternOptions(te(te({},oe.DEFAULTS),e)))}updateOptions(e){super.updateOptions(e)}_update(e){const t=te(te({},oe.DEFAULTS),e),{mask:n,pattern:o,blocks:r}=t,i=ae(t,Z),s=Object.assign({},oe.GET_DEFAULT_BLOCKS());e.min&&(s.Y.from=e.min.getFullYear()),e.max&&(s.Y.to=e.max.getFullYear()),e.min&&e.max&&s.Y.from===s.Y.to&&(s.m.from=e.min.getMonth()+1,s.m.to=e.max.getMonth()+1,s.m.from===s.m.to&&(s.d.from=e.min.getDate(),s.d.to=e.max.getDate())),Object.assign(s,this.blocks,r),super._update(te(te({},i),{},{mask:a(n)?n:o,blocks:s}))}doValidate(e){const t=this.date;return super.doValidate(e)&&(!this.isComplete||this.isDateExist(this.value)&&null!=t&&(null==this.min||this.min<=t)&&(null==this.max||t<=this.max))}isDateExist(e){return this.format(this.parse(e,this),this).indexOf(e)>=0}get date(){return this.typedValue}set date(e){this.typedValue=e}get typedValue(){return this.isComplete?super.typedValue:null}set typedValue(e){super.typedValue=e}maskEquals(e){return e===Date||super.maskEquals(e)}optionsIsChanged(e){return super.optionsIsChanged(oe.extractPatternOptions(e))}}oe.GET_DEFAULT_BLOCKS=()=>({d:{mask:Q,from:1,to:31,maxLength:2},m:{mask:Q,from:1,to:12,maxLength:2},Y:{mask:Q,from:1900,to:9999}}),oe.DEFAULTS=te(te({},J.DEFAULTS),{},{mask:Date,pattern:"d{.}`m{.}`Y",format:(e,t)=>{if(!e)return"";return[String(e.getDate()).padStart(2,"0"),String(e.getMonth()+1).padStart(2,"0"),e.getFullYear()].join(".")},parse:(e,t)=>{const[n,a,o]=e.split(".").map(Number);return new Date(o,a-1,n)}}),p.MaskedDate=oe;const re=["expose"],ie=["compiledMasks","currentMaskRef","currentMask"],se=["mask"];function le(e,t){if(null==e)return{};var n,a,o=function(e,t){if(null==e)return{};var n={};for(var a in e)if({}.hasOwnProperty.call(e,a)){if(-1!==t.indexOf(a))continue;n[a]=e[a]}return n}(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(a=0;a<r.length;a++)n=r[a],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}function ce(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function de(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ce(Object(n),!0).forEach(function(t){ue(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ce(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function ue(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}class fe extends I{constructor(e){super(de(de({},fe.DEFAULTS),e)),this.currentMask=void 0}updateOptions(e){super.updateOptions(e)}_update(e){super._update(e),"mask"in e&&(this.exposeMask=void 0,this.compiledMasks=Array.isArray(e.mask)?e.mask.map(e=>{const t=y(e),{expose:n}=t,a=le(t,re),o=_(de({overwrite:this._overwrite,eager:this._eager,skipInvalid:this._skipInvalid},a));return n&&(this.exposeMask=o),o}):[])}_appendCharRaw(e,t){void 0===t&&(t={});const n=this._applyDispatch(e,t);return this.currentMask&&n.aggregate(this.currentMask._appendChar(e,this.currentMaskFlags(t))),n}_applyDispatch(e,t,n){void 0===e&&(e=""),void 0===t&&(t={}),void 0===n&&(n="");const a=t.tail&&null!=t._beforeTailState?t._beforeTailState._value:this.value,o=this.rawInputValue,r=t.tail&&null!=t._beforeTailState?t._beforeTailState._rawInputValue:o,i=o.slice(r.length),s=this.currentMask,l=new O,c=null==s?void 0:s.state;return this.currentMask=this.doDispatch(e,de({},t),n),this.currentMask&&(this.currentMask!==s?(this.currentMask.reset(),r&&(this.currentMask.append(r,{raw:!0}),l.tailShift=this.currentMask.value.length-a.length),i&&(l.tailShift+=this.currentMask.append(i,{raw:!0,tail:!0}).tailShift)):c&&(this.currentMask.state=c)),l}_appendPlaceholder(){const e=this._applyDispatch();return this.currentMask&&e.aggregate(this.currentMask._appendPlaceholder()),e}_appendEager(){const e=this._applyDispatch();return this.currentMask&&e.aggregate(this.currentMask._appendEager()),e}appendTail(e){const t=new O;return e&&t.aggregate(this._applyDispatch("",{},e)),t.aggregate(this.currentMask?this.currentMask.appendTail(e):super.appendTail(e))}currentMaskFlags(e){var t,n;return de(de({},e),{},{_beforeTailState:(null==(t=e._beforeTailState)?void 0:t.currentMaskRef)===this.currentMask&&(null==(n=e._beforeTailState)?void 0:n.currentMask)||e._beforeTailState})}doDispatch(e,t,n){return void 0===t&&(t={}),void 0===n&&(n=""),this.dispatch(e,this,t,n)}doValidate(e){return super.doValidate(e)&&(!this.currentMask||this.currentMask.doValidate(this.currentMaskFlags(e)))}doPrepare(e,t){void 0===t&&(t={});let[n,a]=super.doPrepare(e,t);if(this.currentMask){let e;[n,e]=super.doPrepare(n,this.currentMaskFlags(t)),a=a.aggregate(e)}return[n,a]}doPrepareChar(e,t){void 0===t&&(t={});let[n,a]=super.doPrepareChar(e,t);if(this.currentMask){let e;[n,e]=super.doPrepareChar(n,this.currentMaskFlags(t)),a=a.aggregate(e)}return[n,a]}reset(){var e;null==(e=this.currentMask)||e.reset(),this.compiledMasks.forEach(e=>e.reset())}get value(){return this.exposeMask?this.exposeMask.value:this.currentMask?this.currentMask.value:""}set value(e){this.exposeMask?(this.exposeMask.value=e,this.currentMask=this.exposeMask,this._applyDispatch()):super.value=e}get unmaskedValue(){return this.exposeMask?this.exposeMask.unmaskedValue:this.currentMask?this.currentMask.unmaskedValue:""}set unmaskedValue(e){this.exposeMask?(this.exposeMask.unmaskedValue=e,this.currentMask=this.exposeMask,this._applyDispatch()):super.unmaskedValue=e}get typedValue(){return this.exposeMask?this.exposeMask.typedValue:this.currentMask?this.currentMask.typedValue:""}set typedValue(e){if(this.exposeMask)return this.exposeMask.typedValue=e,this.currentMask=this.exposeMask,void this._applyDispatch();let t=String(e);this.currentMask&&(this.currentMask.typedValue=e,t=this.currentMask.unmaskedValue),this.unmaskedValue=t}get displayValue(){return this.currentMask?this.currentMask.displayValue:""}get isComplete(){var e;return Boolean(null==(e=this.currentMask)?void 0:e.isComplete)}get isFilled(){var e;return Boolean(null==(e=this.currentMask)?void 0:e.isFilled)}remove(e,t){const n=new O;return this.currentMask&&n.aggregate(this.currentMask.remove(e,t)).aggregate(this._applyDispatch()),n}get state(){var e;return de(de({},super.state),{},{_rawInputValue:this.rawInputValue,compiledMasks:this.compiledMasks.map(e=>e.state),currentMaskRef:this.currentMask,currentMask:null==(e=this.currentMask)?void 0:e.state})}set state(e){const{compiledMasks:t,currentMaskRef:n,currentMask:a}=e,o=le(e,ie);t&&this.compiledMasks.forEach((e,n)=>e.state=t[n]),null!=n&&(this.currentMask=n,this.currentMask.state=a),super.state=o}extractInput(e,t,n){return this.currentMask?this.currentMask.extractInput(e,t,n):""}extractTail(e,t){return this.currentMask?this.currentMask.extractTail(e,t):super.extractTail(e,t)}doCommit(){this.currentMask&&this.currentMask.doCommit(),super.doCommit()}nearestInputPos(e,t){return this.currentMask?this.currentMask.nearestInputPos(e,t):super.nearestInputPos(e,t)}get overwrite(){return this.currentMask?this.currentMask.overwrite:this._overwrite}set overwrite(e){this._overwrite=e}get eager(){return this.currentMask?this.currentMask.eager:this._eager}set eager(e){this._eager=e}get skipInvalid(){return this.currentMask?this.currentMask.skipInvalid:this._skipInvalid}set skipInvalid(e){this._skipInvalid=e}get autofix(){return this.currentMask?this.currentMask.autofix:this._autofix}set autofix(e){this._autofix=e}maskEquals(e){return Array.isArray(e)?this.compiledMasks.every((t,n)=>{if(!e[n])return;const a=e[n],{mask:o}=a;return f(t,le(a,se))&&t.maskEquals(o)}):super.maskEquals(e)}typedValueEquals(e){var t;return Boolean(null==(t=this.currentMask)?void 0:t.typedValueEquals(e))}}fe.DEFAULTS=de(de({},I.DEFAULTS),{},{dispatch:(e,t,n,a)=>{if(!t.compiledMasks.length)return;const o=t.rawInputValue,r=t.compiledMasks.map((r,i)=>{const s=t.currentMask===r,c=s?r.displayValue.length:r.nearestInputPos(r.displayValue.length,l);return r.rawInputValue!==o?(r.reset(),r.append(o,{raw:!0})):s||r.remove(c),r.append(e,t.currentMaskFlags(n)),r.appendTail(a),{index:i,weight:r.rawInputValue.length,totalInputPositions:r.totalInputPositions(0,Math.max(c,r.nearestInputPos(r.displayValue.length,l)))}});return r.sort((e,t)=>t.weight-e.weight||t.totalInputPositions-e.totalInputPositions),t.compiledMasks[r[0].index]}}),p.MaskedDynamic=fe;const he=["enum"];function pe(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function me(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?pe(Object(n),!0).forEach(function(t){ge(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):pe(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function ge(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}class we extends J{constructor(e){super(me(me({},we.DEFAULTS),e))}updateOptions(e){super.updateOptions(e)}_update(e){const{enum:t}=e,n=function(e,t){if(null==e)return{};var n,a,o=function(e,t){if(null==e)return{};var n={};for(var a in e)if({}.hasOwnProperty.call(e,a)){if(-1!==t.indexOf(a))continue;n[a]=e[a]}return n}(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(a=0;a<r.length;a++)n=r[a],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(e,he);if(t){const e=t.map(e=>e.length),a=Math.min(...e),o=Math.max(...e)-a;n.mask="*".repeat(a),o&&(n.mask+="["+"*".repeat(o)+"]"),this.enum=t}super._update(n)}_appendCharRaw(e,t){void 0===t&&(t={});const n=Math.min(this.nearestInputPos(0,d),this.value.length),a=this.enum.filter(t=>this.matchValue(t,this.unmaskedValue+e,n));if(a.length){1===a.length&&this._forEachBlocksInRange(0,this.value.length,(e,n)=>{const o=a[0][n];n>=this.value.length||o===e.value||(e.reset(),e._appendChar(o,t))});const e=super._appendCharRaw(a[0][this.value.length],t);return 1===a.length&&a[0].slice(this.unmaskedValue.length).split("").forEach(t=>e.aggregate(super._appendCharRaw(t))),e}return new O({skip:!this.isComplete})}extractTail(e,t){return void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),new B("",e)}remove(e,t){if(void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),e===t)return new O;const n=Math.min(super.nearestInputPos(0,d),this.value.length);let a;for(a=e;a>=0;--a){if(this.enum.filter(e=>this.matchValue(e,this.value.slice(n,a),n)).length>1)break}const o=super.remove(a,t);return o.tailShift+=a-e,o}get isComplete(){return this.enum.indexOf(this.value)>=0}}function ve(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function be(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?ve(Object(n),!0).forEach(function(t){ye(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):ve(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function ye(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}we.DEFAULTS=me(me({},J.DEFAULTS),{},{matchValue:(e,t,n)=>e.indexOf(t,n)===n}),p.MaskedEnum=we;function _e(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function Ce(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?_e(Object(n),!0).forEach(function(t){ke(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):_e(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function ke(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var Se;p.MaskedFunction=class extends I{updateOptions(e){super.updateOptions(e)}_update(e){super._update(be(be({},e),{},{validate:e.mask}))}};class De extends I{constructor(e){super(Ce(Ce({},De.DEFAULTS),e))}updateOptions(e){super.updateOptions(e)}_update(e){super._update(e),this._updateRegExps()}_updateRegExps(){const e="^"+(this.allowNegative?"[+|\\-]?":""),t=(this.scale?"("+u(this.radix)+"\\d{0,"+this.scale+"})?":"")+"$";this._numberRegExp=new RegExp(e+"\\d*"+t),this._mapToRadixRegExp=new RegExp("["+this.mapToRadix.map(u).join("")+"]","g"),this._thousandsSeparatorRegExp=new RegExp(u(this.thousandsSeparator),"g")}_removeThousandsSeparators(e){return e.replace(this._thousandsSeparatorRegExp,"")}_insertThousandsSeparators(e){const t=e.split(this.radix);return t[0]=t[0].replace(/\B(?=(\d{3})+(?!\d))/g,this.thousandsSeparator),t.join(this.radix)}doPrepareChar(e,t){void 0===t&&(t={});const[n,a]=super.doPrepareChar(this._removeThousandsSeparators(this.scale&&this.mapToRadix.length&&(t.input&&t.raw||!t.input&&!t.raw)?e.replace(this._mapToRadixRegExp,this.radix):e),t);return e&&!n&&(a.skip=!0),!n||this.allowPositive||this.value||"-"===n||a.aggregate(this._appendChar("-")),[n,a]}_separatorsCount(e,t){void 0===t&&(t=!1);let n=0;for(let a=0;a<e;++a)this._value.indexOf(this.thousandsSeparator,a)===a&&(++n,t&&(e+=this.thousandsSeparator.length));return n}_separatorsCountFromSlice(e){return void 0===e&&(e=this._value),this._separatorsCount(this._removeThousandsSeparators(e).length,!0)}extractInput(e,t,n){return void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),[e,t]=this._adjustRangeWithSeparators(e,t),this._removeThousandsSeparators(super.extractInput(e,t,n))}_appendCharRaw(e,t){void 0===t&&(t={});const n=t.tail&&t._beforeTailState?t._beforeTailState._value:this._value,a=this._separatorsCountFromSlice(n);this._value=this._removeThousandsSeparators(this.value);const o=this._value;this._value+=e;const r=this.number;let i,s=!isNaN(r),l=!1;if(s){let e;null!=this.min&&this.min<0&&this.number<this.min&&(e=this.min),null!=this.max&&this.max>0&&this.number>this.max&&(e=this.max),null!=e&&(this.autofix?(this._value=this.format(e,this).replace(De.UNMASKED_RADIX,this.radix),l||(l=o===this._value&&!t.tail)):s=!1),s&&(s=Boolean(this._value.match(this._numberRegExp)))}s?i=new O({inserted:this._value.slice(o.length),rawInserted:l?"":e,skip:l}):(this._value=o,i=new O),this._value=this._insertThousandsSeparators(this._value);const c=t.tail&&t._beforeTailState?t._beforeTailState._value:this._value,d=this._separatorsCountFromSlice(c);return i.tailShift+=(d-a)*this.thousandsSeparator.length,i}_findSeparatorAround(e){if(this.thousandsSeparator){const t=e-this.thousandsSeparator.length+1,n=this.value.indexOf(this.thousandsSeparator,t);if(n<=e)return n}return-1}_adjustRangeWithSeparators(e,t){const n=this._findSeparatorAround(e);n>=0&&(e=n);const a=this._findSeparatorAround(t);return a>=0&&(t=a+this.thousandsSeparator.length),[e,t]}remove(e,t){void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length),[e,t]=this._adjustRangeWithSeparators(e,t);const n=this.value.slice(0,e),a=this.value.slice(t),o=this._separatorsCount(n.length);this._value=this._insertThousandsSeparators(this._removeThousandsSeparators(n+a));const r=this._separatorsCountFromSlice(n);return new O({tailShift:(r-o)*this.thousandsSeparator.length})}nearestInputPos(e,t){if(!this.thousandsSeparator)return e;switch(t){case i:case s:case l:{const n=this._findSeparatorAround(e-1);if(n>=0){const a=n+this.thousandsSeparator.length;if(e<a||this.value.length<=a||t===l)return n}break}case c:case d:{const t=this._findSeparatorAround(e);if(t>=0)return t+this.thousandsSeparator.length}}return e}doCommit(){if(this.value){const e=this.number;let t=e;null!=this.min&&(t=Math.max(t,this.min)),null!=this.max&&(t=Math.min(t,this.max)),t!==e&&(this.unmaskedValue=this.format(t,this));let n=this.value;this.normalizeZeros&&(n=this._normalizeZeros(n)),this.padFractionalZeros&&this.scale>0&&(n=this._padFractionalZeros(n)),this._value=n}super.doCommit()}_normalizeZeros(e){const t=this._removeThousandsSeparators(e).split(this.radix);return t[0]=t[0].replace(/^(\D*)(0*)(\d*)/,(e,t,n,a)=>t+a),e.length&&!/\d$/.test(t[0])&&(t[0]=t[0]+"0"),t.length>1&&(t[1]=t[1].replace(/0*$/,""),t[1].length||(t.length=1)),this._insertThousandsSeparators(t.join(this.radix))}_padFractionalZeros(e){if(!e)return e;const t=e.split(this.radix);return t.length<2&&t.push(""),t[1]=t[1].padEnd(this.scale,"0"),t.join(this.radix)}doSkipInvalid(e,t,n){void 0===t&&(t={});const a=0===this.scale&&e!==this.thousandsSeparator&&(e===this.radix||e===De.UNMASKED_RADIX||this.mapToRadix.includes(e));return super.doSkipInvalid(e,t,n)&&!a}get unmaskedValue(){return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix,De.UNMASKED_RADIX)}set unmaskedValue(e){super.unmaskedValue=e}get typedValue(){return this.parse(this.unmaskedValue,this)}set typedValue(e){this.rawInputValue=this.format(e,this).replace(De.UNMASKED_RADIX,this.radix)}get number(){return this.typedValue}set number(e){this.typedValue=e}get allowNegative(){return null!=this.min&&this.min<0||null!=this.max&&this.max<0}get allowPositive(){return null!=this.min&&this.min>0||null!=this.max&&this.max>0}typedValueEquals(e){return(super.typedValueEquals(e)||De.EMPTY_VALUES.includes(e)&&De.EMPTY_VALUES.includes(this.typedValue))&&!(0===e&&""===this.value)}}Se=De,De.UNMASKED_RADIX=".",De.EMPTY_VALUES=[...I.EMPTY_VALUES,0],De.DEFAULTS=Ce(Ce({},I.DEFAULTS),{},{mask:Number,radix:",",thousandsSeparator:"",mapToRadix:[Se.UNMASKED_RADIX],min:Number.MIN_SAFE_INTEGER,max:Number.MAX_SAFE_INTEGER,scale:2,normalizeZeros:!0,padFractionalZeros:!1,parse:Number,format:e=>e.toLocaleString("en-US",{useGrouping:!1,maximumFractionDigits:20})}),p.MaskedNumber=De;const Ee={MASKED:"value",UNMASKED:"unmaskedValue",TYPED:"typedValue"};function Pe(e,t,n){void 0===t&&(t=Ee.MASKED),void 0===n&&(n=Ee.MASKED);const a=_(e);return e=>a.runIsolated(a=>(a[t]=e,a[n]))}p.PIPE_TYPE=Ee,p.createPipe=Pe,p.pipe=function(e,t,n,a){return Pe(t,n,a)(e)};const Oe=["repeat"];function Be(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,a)}return n}function Te(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Be(Object(n),!0).forEach(function(t){xe(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Be(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function xe(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var a=n.call(e,t||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}p.RepeatBlock=class extends J{get repeatFrom(){var e;return null!=(e=Array.isArray(this.repeat)?this.repeat[0]:this.repeat===1/0?0:this.repeat)?e:0}get repeatTo(){var e;return null!=(e=Array.isArray(this.repeat)?this.repeat[1]:this.repeat)?e:1/0}constructor(e){super(e)}updateOptions(e){super.updateOptions(e)}_update(e){var t,n,a;const o=y(e),{repeat:r}=o,i=function(e,t){if(null==e)return{};var n,a,o=function(e,t){if(null==e)return{};var n={};for(var a in e)if({}.hasOwnProperty.call(e,a)){if(-1!==t.indexOf(a))continue;n[a]=e[a]}return n}(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(a=0;a<r.length;a++)n=r[a],-1===t.indexOf(n)&&{}.propertyIsEnumerable.call(e,n)&&(o[n]=e[n])}return o}(o,Oe);this._blockOpts=Object.assign({},this._blockOpts,i);const s=_(this._blockOpts);this.repeat=null!=(t=null!=(n=null!=r?r:s.repeat)?n:this.repeat)?t:1/0,super._update({mask:"m".repeat(Math.max(this.repeatTo===1/0&&(null==(a=this._blocks)?void 0:a.length)||0,this.repeatFrom)),blocks:{m:s},eager:s.eager,overwrite:s.overwrite,skipInvalid:s.skipInvalid,lazy:s.lazy,placeholderChar:s.placeholderChar,displayChar:s.displayChar})}_allocateBlock(e){return e<this._blocks.length?this._blocks[e]:this.repeatTo===1/0||this._blocks.length<this.repeatTo?(this._blocks.push(_(this._blockOpts)),this.mask+="m",this._blocks[this._blocks.length-1]):void 0}_appendCharRaw(e,t){void 0===t&&(t={});const n=new O;for(let s,l,c=null!=(a=null==(o=this._mapPosToBlock(this.displayValue.length))?void 0:o.index)?a:Math.max(this._blocks.length-1,0);s=null!=(r=this._blocks[c])?r:l=!l&&this._allocateBlock(c);++c){var a,o,r,i;const d=s._appendChar(e,Te(Te({},t),{},{_beforeTailState:null==(i=t._beforeTailState)||null==(i=i._blocks)?void 0:i[c]}));if(d.skip&&l){this._blocks.pop(),this.mask=this.mask.slice(1);break}if(n.aggregate(d),d.consumed)break}return n}_trimEmptyTail(e,t){var n,a;void 0===e&&(e=0);const o=Math.max((null==(n=this._mapPosToBlock(e))?void 0:n.index)||0,this.repeatFrom,0);let r;null!=t&&(r=null==(a=this._mapPosToBlock(t))?void 0:a.index),null==r&&(r=this._blocks.length-1);let i=0;for(let e=r;o<=e&&!this._blocks[e].unmaskedValue;--e,++i);i&&(this._blocks.splice(r-i+1,i),this.mask=this.mask.slice(i))}reset(){super.reset(),this._trimEmptyTail()}remove(e,t){void 0===e&&(e=0),void 0===t&&(t=this.displayValue.length);const n=super.remove(e,t);return this._trimEmptyTail(e,t),n}totalInputPositions(e,t){return void 0===e&&(e=0),null==t&&this.repeatTo===1/0?1/0:super.totalInputPositions(e,t)}get state(){return super.state}set state(e){this._blocks.length=e._blocks.length,this.mask=this.mask.slice(0,this._blocks.length),super.state=e}};try{globalThis.IMask=p}catch(e){}}},__webpack_module_cache__={},deferred,inProgress,dataWebpackPrefix;function __webpack_require__(e){var t=__webpack_module_cache__[e];if(void 0!==t)return t.exports;var n=__webpack_module_cache__[e]={exports:{}};return __webpack_modules__[e].call(n.exports,n,n.exports,__webpack_require__),n.exports}__webpack_require__.m=__webpack_modules__,deferred=[],__webpack_require__.O=(e,t,n,a)=>{if(!t){var o=1/0;for(l=0;l<deferred.length;l++){for(var[t,n,a]=deferred[l],r=!0,i=0;i<t.length;i++)(!1&a||o>=a)&&Object.keys(__webpack_require__.O).every(e=>__webpack_require__.O[e](t[i]))?t.splice(i--,1):(r=!1,a<o&&(o=a));if(r){deferred.splice(l--,1);var s=n();void 0!==s&&(e=s)}}return e}a=a||0;for(var l=deferred.length;l>0&&deferred[l-1][2]>a;l--)deferred[l]=deferred[l-1];deferred[l]=[t,n,a]},__webpack_require__.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return __webpack_require__.d(t,{a:t}),t},__webpack_require__.d=(e,t)=>{for(var n in t)__webpack_require__.o(t,n)&&!__webpack_require__.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},__webpack_require__.f={},__webpack_require__.e=e=>Promise.all(Object.keys(__webpack_require__.f).reduce((t,n)=>(__webpack_require__.f[n](e,t),t),[])),__webpack_require__.u=e=>(({18:"bankReconciliation",62:"validation",64:"applicantTracking",77:"health",88:"browse.jobBoard.listBody",95:"dashboardItem.section.tile.body",97:"asset",99:"standardFilterDistrictVariables",122:"browse.SpecialProgramSummary.svgListBody",126:"homeLanguageSurveyWI",181:"browse.dashboardItemSecurityAccess.listToolbar",193:"fieldInformation",216:"stepNavigator",250:"fieldGroup.nseFamilyInfo",397:"employeeAccess",416:"countdown",421:"browse",428:"specialProgramSummary",442:"skyVue.piechart",445:"messageCenter.messageDisplay",462:"textAreaReset",505:"dashboardItem.chartWidgetGroupBySubHeader",599:"whiteListFieldPath",643:"dashboardItemConfig.default",655:"statereportingut",673:"activityVsBudgetedWidget",680:"skyVue.VueHTMLEditor",699:"foodService.onlineApplication",705:"iEPWriterDocument",730:"raceVerifiedByDateControl",757:"charactersRemaining",767:"videoPopout",779:"datamask",781:"messageCenter.carbonCopyFilterPanel",833:"ajaxError",846:"cashReceipt",852:"LDAP",857:"relativedatepicker",869:"familyAccess",894:"responsiveToolbar",913:"fieldGroup.emergencyContact",960:"browse.myDevices.svgListBody",1017:"tabContainer",1047:"informationPopup",1080:"performanceMonitor",1098:"dialogFocusManager",1122:"onlineForm.stepNavigation",1157:"callbackStore",1160:"texasTranscript",1168:"tooltip",1181:"applicationClaim",1193:"externalLinks",1197:"dashboardItem.wellnessScreening.tile.body",1219:"accountsPayableInvoiceSelector",1224:"checkbox",1237:"eISExtractEntry",1253:"filterOptionSelector",1265:"fieldRestriction",1309:"sizedContainer",1317:"themeSelector.default.content",1320:"stateReportingWA",1337:"reporting.previewexpensereimbursement",1419:"browse.jobBoard.listHeader",1422:"gauge.default.header",1501:"onlineForm.reorderElement",1507:"iEPWA",1528:"stateReportingTX",1548:"careerPlan",1550:"viewPopup",1592:"attachment",1605:"durationPicker",1606:"dateTimePicker",1681:"textArea",1764:"onlineForm.statusSaveManager",1806:"themeSelector.default.body",1813:"expandingLabel",1821:"onlineForm.stepStatusContent",1825:"birthDateAgeTextBox",1835:"benefitManagementBuildInvoices",1836:"dynamicSectionHeader",1934:"searchCondition",1999:"iframeListener",2041:"htmlComboBox",2058:"timePicker",2072:"dashboardItem.live.tile.body",2078:"skyVue.vuebrowse",2079:"massupdatecontrol",2110:"saveAndNextDetails",2136:"headerSelect",2161:"dashboard.default.header",2202:"attendanceLetter",2207:"htmlEditor.default.content",2210:"configSystem",2231:"onlineForm.htmlElement",2236:"templates.default.content",2249:"ajax",2250:"fieldWrapper",2252:"massUpdateS275",2253:"benefitManagementConfigDistrictDetails",2335:"dashboardItemConfig.types",2342:"processingList",2363:"processReorder",2364:"endorsements",2396:"onlineform.massDeleteOnlineFormResponses",2435:"processgrouputil",2448:"userPreferences",2454:"dashboardItem.timesheetWeekExceptions.timesheetWeekExceptionsCard",2477:"s275ExtractEntry",2506:"comboBox",2510:"browse.default.body",2590:"bankReconciliationLoading",2599:"browse.myApplications.listHeader",2610:"processingList.report",2618:"moduleNotification",2632:"gauge.systemPerformance.footer",2663:"browse.timesheetWeekViewPartTimeTransactions.listBody",2676:"collapsePanel",2687:"dashboardItem.portalEngagementWidgetTemplate",2703:"filterViewer",2704:"contentMessageArea",2718:"familyEntityConfigControls",2725:"employeeStaffActivityPA",2741:"messagecenter.myMessages",2744:"expenseReimbursementSelector",2768:"browse.scheduledReportNotificationRecipient.listBody",2780:"skysys.massImportAttachments",2788:"databysubject",2790:"networkTests",2819:"statuspoller",2826:"gradebookMassCommentEntry",2883:"browse.scheduledReportNotificationRecipient.listHeader",2960:"employeeExperienceWAMassAdd",3026:"vendorrequestapprovalmessage",3033:"statereportingSD",3035:"stateReportingNM",3045:"browse.default.header",3064:"color",3070:"promptbuilder",3076:"reporting.calculatedfields",3077:"treebrowse",3142:"whatsNew",3185:"cctPurchaseOrders",3211:"healthDashboardPopup",3227:"dashboardItemConfig.chartTiles",3240:"support",3257:"timetracking.timesheetWeek",3262:"fileDestinationTester",3291:"framedHTMLViewer",3329:"browsePreferences",3365:"filterSetViewer",3458:"keyboardNavigation",3470:"statereportingtn",3478:"pALocalTaxSubmission",3531:"absenceRequest",3560:"familyAccessAttendance",3611:"browse.myMessages.listBody",3669:"stateReportingPA",3709:"benefitManagementAllowPlanChange",3761:"gauge.systemPerformance.body",3794:"dashboardItem.default.widget.subheader",3911:"seriesTotalizerPlugin",3926:"dashboardItem.link.tile.body",3952:"screenselector",4009:"reporting.preview",4011:"browse.jobBoard.dataHeader",4062:"favorites",4083:"employee",4122:"globalSearch",4126:"stateReportingKS",4147:"parameterDataSourcePopulator",4231:"mainmenuvue",4237:"benefitManagement",4247:"clock",4268:"events",4270:"dashboardItem.default.widget.header",4303:"widget",4323:"browse.default.footer",4365:"dashboardItem.listOfRecords.body",4462:"dock",4481:"viewMoreBrowseButton",4503:"messagecenter",4567:"attendanceEntryStudentEEL",4582:"enrollmentRequestSubmit",4592:"buttonManager",4629:"global.text",4718:"colorPicker",4816:"stateReportingIL",4856:"studentInformationPopup",4901:"session",4905:"enrollmentKS",4914:"birthHistory",4926:"maximizeContainer",4948:"serverResponseTimeChart",5013:"processingListSelector",5035:"dependents",5095:"linkPanelButton",5218:"attendanceHelper",5266:"criticalAlert",5302:"dashboardItem.default.widget.defaultTileTemplate",5310:"messagesubjectandcontent",5325:"extensions.idGenerator",5355:"processingList.import",5402:"dashboardLibrary",5433:"dashboardItem.chartDrilldownBreadcrumbs",5450:"listSorter",5475:"displayPeriodCheckboxGrid",5496:"promptDataSourcePopulator",5503:"detailsPanel",5505:"electronicSignature",5508:"browse.default.sectionHeader",5550:"calendarview",5552:"officeVisit",5569:"maskCreator",5577:"creditCardTransactionSelector",5594:"academicStandardHierarchy",5607:"window",5643:"statereportingid",5653:"browseSeekInfo",5665:"dashboard.default.content",5666:"multipleSelectBox",5723:"reportViewer",5746:"repeaterAccessibility",5826:"browse.dataBySubject.detailsBody",5850:"mobileselector",5860:"browse.myMessages.listHeader",5875:"svg",5895:"positionNumberLookupSearch",5959:"repeater",5970:"customization",5971:"reporting.details",6050:"fileUpload",6071:"accountsPayableDirectDepositNotification",6078:"reference",6118:"earlyChildhoodMI",6120:"togglePassword",6129:"skyVue.barchart",6190:"attachmentPopup",6210:"reporting.scheduledReport",6260:"printScreen",6281:"reorderDraggable",6317:"indentToggle",6375:"fieldGroup.raceEthnicityVerification",6384:"browse.dashboardItemSecurityAccess.listBody",6394:"employeePlanEnrollmentEntry",6447:"dashboardItem.chartWidgetFilterHeader",6461:"browse.StateReportingStateCodes.svgListBody",6470:"binding",6477:"cashReceiptSelector",6494:"browse.dataBySubject.svgListBody",6520:"buildingDetailWA",6526:"dashboardItemConfig",6580:"extensions.promise",6598:"workflowTemplate",6612:"importColumnViewer",6622:"chartWidgetContextMenuPlugin",6631:"specialProgramsWA",6634:"studentHealthScreeningEntry",6641:"calendarDay",6667:"htmlEditor",6734:"payroll",6762:"fieldSelector",6768:"notificationBubble",6771:"infoButton",6788:"htmlGatherer",6790:"translationDetector",6796:"tablist",6812:"slidingContainer",6820:"volatileStorage",6825:"employeeDistrictWorkStatusPA",6840:"fileDestinationSelector",6930:"rotationSelector",6936:"feeManagement",6947:"standardFilterViewer",6966:"onlineForm.stepDetails",6969:"skyVue.vueGauge",6995:"iframe",7006:"pageLoading",7036:"dashboardItem.linkWidget.linkWidgetBody",7051:"onlineForm.massPrint",7061:"themeSelector",7157:"window.domunloadcallback",7170:"dashboardItem.default.tile.header",7254:"selectorEEL",7381:"api",7425:"ecommerce",7452:"checkBoxMassSelectButton",7473:"securityapplication",7500:"payroll.assignmentPayTypeSalaryPays",7551:"dataScrambleApproval",7560:"securityUser",7563:"thirdPartyFormat",7584:"browseFilterSelector",7587:"sortable",7619:"userApproval",7653:"attendanceByClassActivityRangeEntry",7660:"externalLinkPopup",7709:"payloadViewer",7721:"tileBrowse",7731:"statereportingRI",7753:"browse.districtPulseDataSets.svgListBody",7803:"studentSectionAttendanceMinutes",7830:"attendanceEntryGrid",7857:"dashboardItem.chart.tile.header",7902:"dashboardItem.default.widget.defaultWidgetTemplate",7903:"browse.fieldTree",7915:"eel",7940:"gauge.default.content",7959:"gradingUI",7966:"reportdefinitionviewersectionselector",7969:"datePicker",7972:"sifdatabysubject",8007:"employeeStaffInterchangeEvaluationCO",8034:"sebbThirdPartyImport",8050:"approval",8054:"foodService.onlineApplicationApproval",8063:"edfi-ts",8073:"assetPopup",8102:"ajaxManager",8138:"profile",8153:"radioButtonGroup",8198:"dashboardItem.timeOffApprovals.timeOffApprovalsCard",8201:"media",8236:"labeledDataList",8246:"debounce",8274:"groupTemplate",8391:"timeTracking",8471:"reportDefinitionViewer",8489:"gauge.default.body",8516:"skyVue.themeSelector",8535:"messagecenter.messageSettings",8553:"browse.list",8574:"configDistrictPA",8631:"dataobjectviewer.preSaveValidation",8643:"health.nameWellnessScreening",8647:"onlineForm.approvalDetails",8654:"usernameStructure",8681:"dashboardItem.approvalsHeader",8699:"attendanceCommentPrivacy",8706:"dashboardItem.cardListTemplate",8719:"panelSelection",8774:"budgetAmendmentSelector",8788:"activity",8843:"dashboardItem.cardListBody",8869:"quickEntryText",8913:"crystalReportPromptEntry",8916:"statereportingvalidations",8917:"onlineForm.elementRuleCRQE",8924:"developerIsland",8969:"ajaxRepeater",9e3:"filemanagement",9041:"stateReportingIN",9050:"skyVue",9052:"time",9091:"payroll.timesheetQuickEntry",9106:"nameMerge",9119:"activityIndicator",9133:"employeeWeeklySchedule",9135:"dashboardWidgetChart",9282:"newGuardianLoginRequestConfig",9296:"cashReceiptChildRecordQuickEntry",9327:"passwordCriteria",9328:"dashboardItem.timesheetApprovals.timeOffApprovalsCard",9372:"skyVue.vueDashboard",9378:"dashboardItemStatus",9394:"tabbing",9451:"customfieldvalidation",9484:"reporting.fieldselectionpanels",9486:"processlinkinfodialog",9488:"stateReportingWI",9522:"dataPath",9526:"browseFieldPath",9550:"bellschedulingperiodmatrix",9551:"reportingTableViewer",9677:"persistentTab",9685:"accountsReceivable",9698:"stateReportingMI",9703:"onlineForm.elementCRQE",9745:"checkboxGroup",9768:"aboutPopup",9871:"dashboardItemSizer",9875:"profileAddSearch",9918:"processmanagementsubjectselector",9946:"skyVue.linechart",9948:"browse.myApplications.listBody",9993:"dashboardItem.default.widget.body"}[e]||e)+".js?v="+{13:"264a79d108e3dd67f5a4",18:"7d60d8b0453a88e7fa27",60:"cc9a049dc10295e6953c",62:"a4fcbf7a5a4ff69c7694",64:"b6d72d89817b256bf80d",77:"262418f45e18c88350d3",88:"33086b1225db02e645ae",95:"cfeb8787c9a4ea4ce442",97:"a9057d4fb0be3ed0ad79",99:"fa51478ffe3cfc4af558",122:"b229f2bbe174840b5dc1",126:"46c9a14ea82ff16f742b",181:"a95ece09bacdf91c02d5",193:"2b495ae3cfd706dd5032",216:"541a3f719964d7f66fe2",250:"084337504c581fd45a9e",397:"48e7b12ca9d1e52c9dad",416:"422d496d8d5bd6388d9c",421:"2d4b454ba21b8a6f87a3",428:"a54775c0dd1f7c174dd8",442:"21b77bc65c6e952ca9ba",445:"655fd3a78f61c2422ee4",462:"4d7580c11dc4f9927fc6",469:"e322579c2ead996365ec",505:"c4f12fc31cb15e32dee7",599:"94916101eedd17408b08",631:"5cc9898d8403a599c188",643:"8b987387eacf073f36a7",655:"ecdef41e6112141352a7",673:"c81ce467ade08fa11e40",680:"7a09c6ce093bf2450541",699:"0d9dbe06d0d4016d7f8a",705:"d7e4604c92b209b81b00",730:"6e336dfb849dc91aac0a",757:"ab82f6a119284d664e97",767:"cca75c95723480301964",779:"d7c58913776e0e7a6f47",781:"2210a856245e39c6de6a",833:"e69ec69cc57cd390454b",846:"aef23d2e5ad2d2198d03",852:"fcc87c9c4b4069341259",857:"4a9379722b529b8ddb19",869:"babb85ce51ec9e08deb4",894:"ca4cee01c619ce7c41f7",913:"7540b665236915344d22",917:"11ad3bff201ff12447d4",960:"538968fa16272aec5e83",1017:"3078e563553d77f7bebd",1047:"f597aea47e0b9309ee2a",1080:"3c0f0846fa64b8978ff4",1098:"af693e976dee93d05bc4",1122:"efb5769dc99e6ccdc1a7",1157:"d18f89d4f7ab470a9b02",1160:"da65f7d2918ee637ee8c",1168:"195cd840106fbe43a7a0",1181:"b5f49d27e25476799e69",1193:"c894eabcd3840cceca72",1197:"ac5d6fba3d94ceb38789",1219:"af34a9dba37003196fe5",1224:"846229fa0674770bc24a",1237:"2776d4bf8bab61b9f085",1253:"31b1aadf388eb3fcfcfc",1265:"edfe13af9cb9675fffe3",1309:"629b61f1ba617549156c",1317:"72d1da48a85874096450",1320:"52363cf9028d549afc58",1337:"6c891cc1e59e1c7c0190",1419:"240f568bbd22cecb92cc",1422:"b8102b7dc89512808b21",1494:"35d45d3b42f0544bc1d5",1501:"2fd80a3de88acea40955",1507:"e0e951c6ddac7029884e",1514:"52bead57e3d2a6b69a13",1528:"bf3671820fbfc972a00f",1548:"695802a71dcac950dbd4",1550:"0ce06b15e64da1edc4b7",1592:"3629e9fdd10c3a617f25",1605:"3de2d516a8a91554e17d",1606:"56481312704c24259b46",1681:"888824b62f64cb0c31ed",1764:"533bbadbb5ac8e33a1f6",1806:"be03856ea1908647ed38",1813:"ddcfdd568ffdc7124049",1821:"32510f761f33b509d921",1825:"e444be0c93bb4719e6e1",1835:"703f3136666a839ee9e0",1836:"2201e455afb991aeb42f",1934:"1d4fa91f2932555f7c68",1999:"fb4012cd1c461d7361b9",2041:"e53bf2a61a3d930c6e84",2058:"a7e9927973a3ee8071e5",2072:"fa78a0aa67cd49b8f484",2078:"8612026cb8e1307d4418",2079:"e35ac6f22c19cdd0d9dc",2110:"0a9511d81224881ccf7f",2136:"3be1ff40055e4abfddfb",2161:"9129c0b38840fbfae6cb",2202:"e51df86382264677165a",2207:"b38588faf92b3b6c13bb",2210:"b11295e38f8e3c483185",2231:"5a3ab2561e6034e1509b",2236:"8483726c637ec1a8a4ff",2249:"b04acd4680d9f979f4b8",2250:"55b1dbc3bc6711727fdf",2252:"7fd7db22febb51f4a844",2253:"5a326dd531df18ec74eb",2335:"6915b643f71980ffd176",2342:"4842be353c7b876b1ae6",2363:"c944fee4946cdf46b6e4",2364:"23e40db940a6517c666c",2384:"95428815a02889e43081",2396:"80071456857041eb5748",2435:"be080d4a7c49ce38715d",2448:"b4842c6af44aa7738945",2454:"480c70ea8d7150641841",2477:"da018fade028a9e3f414",2506:"b875ec5b08268dc4084b",2510:"513ab65e2a504611e9d1",2528:"311547e6eeff5c04a8f5",2590:"a759911aefae00461815",2599:"93fa55b7c124c0c7882f",2610:"e264127c6b9286e232b0",2618:"dddbd8e291f02b8a45e5",2632:"2ebba9f7884e0dd6291e",2663:"416c62732eb2da04c036",2676:"001ea317f14526eba2b1",2687:"4fcabd223c0d0efc2a7e",2703:"103915f63f56b0c19aa3",2704:"92c64e8f3dcc51c86840",2718:"4cc0930ab3fcc68a9bef",2725:"8a2509bf4f6495be0e33",2741:"172fd9015405491abbb3",2744:"45f5d98a435bcd501d46",2768:"e9b3e4cc4d40736702eb",2780:"f2c2f91d5c0f78f9fcb0",2788:"8b0975d9c99bce551f75",2790:"f93b769949f090d43b43",2819:"1e66887f1cce34bab132",2826:"5a5ba7ee1a9d9130871b",2883:"7954f92b4cbf4d1387db",2960:"ddeb6e6f221c2bb3cc49",2980:"a93129c3f8524087b91c",3026:"7fe7dc6bce04b255bd6a",3033:"3861d35e879acd30a63b",3035:"6df8d4cdc884e72f3d19",3045:"5434a7d181290f3b4910",3064:"c08c875d76493a8db51d",3070:"576bdb11219b3811c23d",3076:"fe217a3007bbdab0d8d9",3077:"302d85aa62c41e6e0e43",3142:"e301af08a5170c7b267e",3185:"bb881d86fd54279ade61",3211:"66bb1617d9b7aa6fe719",3227:"afaf2938d5e2b6fa3e18",3240:"bbc6c23c48a058efefa5",3257:"71270bdbc50732339a03",3262:"6ef2f1595ed0d45dbd88",3291:"85084bab3611478b3746",3329:"ef878d6ca74444cc9715",3365:"812934c3092ba4564eca",3458:"22d59e6b533167351fe0",3470:"cafb83c1c319f5487ff6",3478:"250c64da4d9be11553f3",3531:"9080cb8c605659742370",3537:"cf03d0c487e5ab5a7fb4",3560:"3f652555cf073167e7ad",3611:"1639690493db55e88c56",3669:"160724addc11525fcc09",3709:"9964c88d89b9de792df0",3761:"abd85de68fb19417b347",3794:"e168e801236c5972dffe",3911:"59c68a4d650c9c96711d",3926:"8b53c1250e53ad8559a7",3952:"44354db45e7f2e5b008a",4009:"182fcebe50600851ef65",4011:"5a539542a562a4caba28",4062:"26482cc010c12f81e82c",4083:"8e6a90f40de4b0091623",4122:"9e6919d57d2300230906",4124:"3d195480b516e073fa5c",4126:"f8c06416ee92dea7755e",4147:"cbc6aca157c3d8d947ac",4231:"a811e2d25cf9c9522691",4237:"5ac6e694ce7134337f84",4247:"d3498c48b04389d29383",4268:"a2b85d829566f3fe7f61",4270:"d254da86a589eeb02e37",4303:"9564ea6cfec1ceef0f99",4323:"20998481500de298740a",4365:"3e05d132fd2cdf26ed28",4398:"d616fba949ee99aa5de5",4462:"f6716d7db9b1233335c6",4477:"11e5bf1eb03489ee4c78",4481:"56359c474b9b8dbcaf6f",4503:"a2ee2783aa3ebc373b90",4567:"affd9b1918f33647eb66",4582:"b97e77b368ab5a4c53f0",4592:"d410d8f8a25467522427",4629:"eabd5f9dd28ae62645bf",4718:"2ebd07bf1f979779f8ed",4816:"fe44d50ff535455a21bd",4856:"0d7725ad62bfd4fcf3bc",4901:"a178c70253a3b0dbf647",4905:"0073da01f42952e6a69b",4914:"41737b31a5d24667a987",4926:"50df73f0c08c301016e1",4948:"b6ecee00d7f6222412db",5013:"f1f130a1114e916982a3",5035:"a133ef70fac372340f81",5095:"0d39a4a36a43d0ff061b",5218:"c01213f2b2877eebe151",5266:"4e375321fa086a731a9f",5302:"836972a1c46e145ddd3e",5310:"34bac2305d8366fbccee",5325:"d44ed9b420d662df535c",5355:"95b085665e8d775b411c",5362:"aeda34eab55b98f9d6bd",5402:"e5f6ff68f88c1c727b3c",5433:"3e3ca64295bdde406733",5450:"61973785b9090c32b943",5468:"c056a504decd099dfa7a",5475:"ad0a1bd4a9a827984e25",5496:"a941d00347c8aa2f54f9",5503:"4be73d33e670d2b348e7",5505:"09403fdc971a7e5cfb62",5508:"67419fda5f0fc73a3170",5550:"284276ee54f02e59fb4e",5552:"c686c816d22aa2a86aec",5569:"d5a6b9c8888936cb968b",5577:"f2eefc4cef86bd0586f8",5594:"e60281f65869de21bfcd",5607:"0464eb36db75d25cfbeb",5643:"c75cfe37e9e7c0a68332",5652:"69a92a075b7bbe9e3134",5653:"d0d0727bac14a92c1bbd",5665:"5578de0369f8dcd2012d",5666:"8d29725379ce291aa77a",5723:"3003718538ab3ca43560",5746:"ba728c7a12189fa3df54",5826:"70318848a26ef1865d01",5850:"6cb0a2a65911395b065b",5860:"c974eb2885ea9462be02",5875:"795c904657f3c3138161",5895:"f1a86fc513b2276f7599",5959:"395ae59b553f71489826",5970:"0b3235c3ed02651ce4f6",5971:"8d0c17f9fa8ed1c6cdfd",6050:"0d323ce525fb241ee54b",6071:"e40976a5ffec52cdef20",6078:"13c10d20f53ccf39d127",6118:"67eb1bf84cfe76221254",6120:"caf1f342d9b6885b4d2e",6129:"17beab492325273b02fb",6190:"7e1a477dbf9e23161863",6210:"112b1cf02e02030054fe",6260:"a3dbd0cb44f03abce788",6281:"a72c82eb025cb626f481",6317:"12e03ee2c9fccb581060",6375:"670bed9ba4ddd3fc1638",6384:"97727f9ff1e47014be0d",6394:"f050e30ed77a6f5d098d",6447:"1fac6da996fd28c708b9",6461:"5b588fa726e8b26ee378",6470:"15ddf6dd31eecfbddb6f",6477:"7a061cf2b9cca1b7a4f6",6494:"eea627cc91cef612cf02",6520:"76bfc71fa055fb7c3b9d",6526:"95f95872de10b4b2916f",6580:"38993eb0e8c4399869e1",6598:"c27157de0d8360e62f58",6612:"9cfbc056cbd304db1b7d",6622:"e32104c57dedbb7ebfed",6631:"845be2e5d2a7bcabcd5c",6634:"0be7263f8631034f92d7",6641:"ddd94b1d500ecc20d4ce",6667:"ea3756a90ab7214dcec3",6721:"e36603eabc1fcdec554d",6734:"6e3d39d510d4e54e2174",6762:"acd78955bae5c44dd54e",6768:"cbda990317281395d841",6771:"86d9c38030abd089b392",6788:"d6ea630907c85e7297eb",6790:"b94242307a83e743145e",6796:"bc4e7547c5a0e986413c",6812:"143df9d7cc9b2c9787a0",6820:"b6982f998a8b5843af3e",6825:"6d2cb74bdd07fd885f7e",6840:"fea9faeb4cc79602f534",6882:"6006b337ebd189b6ae2f",6930:"cdc1ae099573667bf40a",6936:"c13fbfab2328976b93b4",6947:"b59474f1e60d06f86ac1",6966:"99afa3005eedd0849912",6969:"ffced6d265f02e69d8fa",6983:"d5c0353be9b44c85b8c1",6995:"dd002154c3cac483bc80",7006:"7a06bf876360a7947c1f",7036:"e180943e84f130308ec2",7051:"7b69c3fa49d3dfb10457",7061:"518f0d5b7012092bfde3",7157:"e367cb2c23abfa1810aa",7170:"dd14893381f08d54b5ef",7254:"07adf822e19166f53593",7381:"90c5f7363a3ea874d456",7425:"cc1a577c074b6759e44e",7452:"dcef2a1626e8338c4002",7473:"6b90cbc6f32fc17de2aa",7500:"ccaab6bb8bda2d0f47eb",7551:"2b3e3f04336fbeefc715",7560:"e9d651c67c1aabfe9619",7563:"d9948653eda411afca97",7584:"822397359eb68c844488",7587:"58e7d558222d59b8f31e",7619:"5e84ca4696774a5bd0b7",7653:"b3b4930570b41e7c9def",7658:"67e450a9d23c09098369",7660:"2bc8cfa2dd278c2963e6",7697:"3b006a1881801c712f19",7709:"955ce68e4d1a74fd1571",7721:"a0acc13a6e92974bdafe",7731:"bcd62d12dfcf5aa9e824",7753:"58e21a50aed0edd071a7",7757:"3a2d2d62c1824f82688a",7803:"6d5d3b054a31189fd0b3",7830:"f6fa2c3cfe1f09578bdd",7857:"4ac8b432fc2139ac1123",7902:"979f1c4b18bfb0e7a4e3",7903:"9a03877a2cfe91b7e925",7915:"337f78a76ffbadb463ae",7924:"b1e73f6067a8b9d11408",7927:"946e4de5721ed6848ae7",7940:"cf72a33f6de2eab87c4d",7959:"79d42813e57f91eff773",7966:"328bd2b58f689965836f",7969:"384dde3bf926ae0716eb",7972:"d953df4bdc1a0e765fdd",8007:"8f8c5bbc85f589d55015",8034:"779faf2810efbbf559fa",8050:"58467b3cfbbba47d6436",8054:"99d7d155b6fe173e3bc7",8063:"e6dac859e5031c5f8212",8073:"b1a68292cbc5b866f444",8102:"505281699d801067e649",8138:"1edd64646e07aa80165f",8153:"afd1a582392ac7be3c20",8198:"fa987b4fb08dcfbd9865",8201:"4fbd42736e1e15bd08d3",8236:"9402247a7be3a34d0399",8246:"cc18e1d0718a8f84dba4",8274:"5208e335e552e85cdb6a",8391:"344f42daf3d46a3e18de",8471:"41abb10d20d7905f705a",8489:"e8720f0369e0fb9cc9a0",8516:"3b670b5b847125c5229a",8535:"2c4e70f517761c78784c",8553:"21e1539a1ccd2d53bfb7",8574:"0caed99c3a76b44bd8ab",8631:"2671443248eaffaa71c9",8643:"ea64c637d8990f254b04",8647:"4e64ee586c65045159cf",8654:"a8d73bb08871270e1985",8681:"676f1a10c33bb8abf191",8699:"9e5448fd11e89181bf48",8706:"fa77392b69fc7b88e15d",8719:"05fd2a2a4d0e5b23c44f",8723:"52585126eab56f20cc50",8774:"80e78cd9569e81bff759",8788:"3affe7b42038ea1f5534",8843:"5c62d975e4f206196f1b",8869:"b1cbb1940d8621968dd0",8913:"fae1f969ac44e903a0f5",8916:"3b0c457fc84f3090d87c",8917:"d9ce291a56d1a899108c",8924:"f02d4e43d84f38a6b46a",8939:"4eaef5b8b3c2d383c374",8950:"d631ebe92704e41e2fb3",8969:"e86019f945912fab31c1",9e3:"f0258ff6f023367c4d6a",9041:"0850c64f139fda9f0260",9050:"393ab07d6a98015442fb",9052:"c4d34bea2c2c115f0628",9091:"4b024646bf242b2383cb",9106:"c8a60fa19c07073055a2",9119:"248476650034a800e45e",9133:"1b3ba21a6b5f1fc10a79",9135:"7289d61cb3a2d6a5dfc6",9165:"c4bd7d4dfd60af0d9d67",9282:"6f2264ff195a216d0dcc",9296:"a32328daacb36664975c",9327:"728f09a4f4d021ccf642",9328:"232dedbb13597e1dffa7",9343:"af1cf223e79fe770afe1",9372:"bdc7158fee8fa2c2ff12",9378:"b24b07621fa5caf559e8",9394:"579e68bf22d8d1e62034",9451:"84d5e53e17aacbcddd1b",9484:"77ed273b0392aeb611ef",9486:"d43b42f48498b4484075",9488:"fa50aa748ce5c4fc8af2",9522:"e94b45aed97eb9c37d45",9526:"419069816aa9348455ab",9550:"b1ddf048f491c1692a89",9551:"16471fb83e8724db00b2",9677:"314cc3ae81e6137a425d",9685:"1c41c1c54bc0894e8268",9698:"c3359910e3e59e07b8e5",9703:"97137be7caa4e252be33",9745:"667c78b9eade4b4f131c",9768:"f3d4c8fb3ef36f00ec5c",9871:"b704b777270c957da59d",9875:"dca61014fabcb3333175",9918:"1a9c861a6b112f80be81",9946:"20b99f932d9f973b095b",9948:"b5365465498e11298d59",9993:"83e400f98bf744de97c8"}[e]),__webpack_require__.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),__webpack_require__.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),inProgress={},dataWebpackPrefix="skyward_qmlativ_web:",__webpack_require__.l=(e,t,n,a)=>{if(inProgress[e])inProgress[e].push(t);else{var o,r;if(void 0!==n)for(var i=document.getElementsByTagName("script"),s=0;s<i.length;s++){var l=i[s];if(l.getAttribute("src")==e||l.getAttribute("data-webpack")==dataWebpackPrefix+n){o=l;break}}o||(r=!0,(o=document.createElement("script")).charset="utf-8",__webpack_require__.nc&&o.setAttribute("nonce",__webpack_require__.nc),o.setAttribute("data-webpack",dataWebpackPrefix+n),o.src=e),inProgress[e]=[t];var c=(t,n)=>{o.onerror=o.onload=null,clearTimeout(d);var a=inProgress[e];if(delete inProgress[e],o.parentNode&&o.parentNode.removeChild(o),a&&a.forEach(e=>e(n)),t)return t(n)},d=setTimeout(c.bind(null,void 0,{type:"timeout",target:o}),12e4);o.onerror=c.bind(null,o.onerror),o.onload=c.bind(null,o.onload),r&&document.head.appendChild(o)}},__webpack_require__.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},(()=>{var e;__webpack_require__.g.importScripts&&(e=__webpack_require__.g.location+"");var t=__webpack_require__.g.document;if(!e&&t&&(t.currentScript&&"SCRIPT"===t.currentScript.tagName.toUpperCase()&&(e=t.currentScript.src),!e)){var n=t.getElementsByTagName("script");if(n.length)for(var a=n.length-1;a>-1&&(!e||!/^http(s?):/.test(e));)e=n[a--].src}if(!e)throw new Error("Automatic publicPath is not supported in this browser");e=e.replace(/^blob:/,"").replace(/#.*$/,"").replace(/\?.*$/,"").replace(/\/[^\/]+$/,"/"),__webpack_require__.p=e})(),(()=>{var e={60:0,62:0,421:0,469:0,631:0,779:0,833:0,857:0,869:0,917:0,1080:0,1098:0,1157:0,1193:0,1224:0,1253:0,1309:0,1320:0,1550:0,1606:0,1681:0,1934:0,1999:0,2041:0,2058:0,2249:0,2250:0,2506:0,2528:0,2676:0,2704:0,2980:0,3064:0,3076:0,3077:0,3240:0,3329:0,3403:0,3458:0,4062:0,4122:0,4231:0,4247:0,4268:0,4398:0,4462:0,4477:0,4503:0,4592:0,4629:0,4718:0,4901:0,5035:0,5325:0,5362:0,5503:0,5505:0,5607:0,5652:0,5653:0,5666:0,5875:0,6078:0,6260:0,6470:0,6477:0,6580:0,6667:0,6721:0,6768:0,6788:0,6790:0,6796:0,6820:0,6882:0,6947:0,7061:0,7157:0,7254:0,7587:0,7619:0,7721:0,7757:0,7903:0,7915:0,7969:0,8102:0,8153:0,8236:0,8246:0,8553:0,8631:0,8950:0,8969:0,9e3:0,9052:0,9119:0,9343:0,9394:0,9522:0,9745:0,9768:0};__webpack_require__.f.j=(t,n)=>{var a=__webpack_require__.o(e,t)?e[t]:void 0;if(0!==a)if(a)n.push(a[2]);else{var o=new Promise((n,o)=>a=e[t]=[n,o]);n.push(a[2]=o);var r=__webpack_require__.p+__webpack_require__.u(t),i=new Error;__webpack_require__.l(r,n=>{if(__webpack_require__.o(e,t)&&(0!==(a=e[t])&&(e[t]=void 0),a)){var o=n&&("load"===n.type?"missing":n.type),r=n&&n.target&&n.target.src;i.message="Loading chunk "+t+" failed.\n("+o+": "+r+")",i.name="ChunkLoadError",i.type=o,i.request=r,a[1](i)}},"chunk-"+t,t)}},__webpack_require__.O.j=t=>0===e[t];var t=(t,n)=>{var a,o,[r,i,s]=n,l=0;if(r.some(t=>0!==e[t])){for(a in i)__webpack_require__.o(i,a)&&(__webpack_require__.m[a]=i[a]);if(s)var c=s(__webpack_require__)}for(t&&t(n);l<r.length;l++)o=r[l],__webpack_require__.o(e,o)&&e[o]&&e[o][0](),e[o]=0;return __webpack_require__.O(c)},n=self.webpackChunkskyward_qmlativ_web=self.webpackChunkskyward_qmlativ_web||[];n.forEach(t.bind(null,0)),n.push=t.bind(null,n.push.bind(n))})();var __webpack_exports__=__webpack_require__.O(void 0,[9857],()=>__webpack_require__(17009));__webpack_exports__=__webpack_require__.O(__webpack_exports__)})();
;
"use strict";(self.webpackChunkskyward_qmlativ_web=self.webpackChunkskyward_qmlativ_web||[]).push([[9857],{80967(e,o,t){t.d(o,{A:()=>s});var n=t(74061),a=t(98925);const r=function vButton(e,o){var t,r,s,l;const i=o.slots.default&&(0,n.createVNode)("span",{class:["anchorText",e.svgOnRight?"textBefore":"textAfter","buttonText",...null!==(t=e.spanClasses)&&void 0!==t?t:[]]},[o.slots.default()],2);return(0,n.createVNode)("a",(0,n.mergeProps)({role:null!==(r=e.role)&&void 0!==r?r:"button",onClick:function(o){var t;e.disabled||null===(t=e.clickFunc)||void 0===t||t.call(e,o)},class:{button:!0,chromeless:!0,svgAnchor:!0,"ui-disabled":!0===e.disabled},href:"javascript:void(0)",title:e.title},o.attrs),[e.svgOnRight&&i,(0,n.createVNode)(a.A,{name:e.svgName,svgClasses:[e.svgOnRight?"svgTextBefore":"svgTextAfter","buttonSvg",...null!==(s=e.svgClasses)&&void 0!==s?s:[]],tabindex:"-1",onMouseover:e.onMouseover,onMouseout:e.onMouseout,showHoverEffect:null===(l=e.svgShowHoverEffect)||void 0===l||l,style:e.svgColor?{fill:e.svgColor}:void 0},null,8,["name","svgClasses","onMouseover","onMouseout","showHoverEffect","style"]),!e.svgOnRight&&i],16,["role","onClick","title"])};r.props=["svgName","spanClasses","title","disabled","svgClasses","svgShowHoverEffect","svgColor","svgOnRight","clickFunc"];const s=r},36674(e,o,t){t.d(o,{A:()=>l,a:()=>s});var n=t(74061),a=t(98925),r=t(75552);let s=function(e){return e.Error="Error",e.Confirmation="Confirmation",e.Information="Information",e}({});const l=(0,n.defineComponent)({name:"contentMessageArea",props:{message:(0,r.oY)(String),cmaType:(0,r.oY)(String),hidden:(0,r.uh)(Boolean)},mounted(){const e=this.$el;window.skyward.events.applyLoadActionClass(e),window.skyward.window.notifyDOMLoad(e)},render(){let e="Error",o="cmaErrorMessage";switch(this.cmaType){case s.Error:e="Error",o="cmaErrorMessage";break;case s.Confirmation:e="Check",o="cmaConfirmationMessage";break;case s.Information:e="Info",o="cmaInformationMessage";break;default:console.warn("Unsupported CMA Type.")}return(0,n.createVNode)("div",{"data-load-action":"contentMessageArea.init",class:{contentMessageArea:!0,cmaHidden:this.hidden}},[(0,n.createVNode)("div",{class:"cmaMessageArea ".concat(o," pointer")},[(0,n.createVNode)(a.A,{name:e},null,8,["name"]),(0,n.createVNode)("div",{class:"cmaMessage cmaMessage--flexed js-eelPositionManagerGetRowsForHeight pointer"},[(0,n.createVNode)("span",{class:"cmaMessageText"},[this.message])])],2)],2)}})},15439(e,o,t){t.d(o,{A:()=>s});var n=t(74061),a=t(28877);const r=function vDragHandle(e,o){const t="radial-gradient(circle at 0.3rem 0.5rem, ".concat(e.color," 0.15rem, transparent 0),")+"radial-gradient(circle at 0.7rem 0.5rem, ".concat(e.color," 0.15rem, transparent 0),")+"radial-gradient(circle at 0.3rem 0.9rem, ".concat(e.color," 0.15rem, transparent 0),")+"radial-gradient(circle at 0.7rem 0.9rem, ".concat(e.color," 0.15rem, transparent 0),")+"radial-gradient(circle at 0.3rem 1.3rem, ".concat(e.color," 0.15rem, transparent 0),")+"radial-gradient(circle at 0.7rem 1.3rem, ".concat(e.color," 0.15rem, transparent 0),")+"radial-gradient(circle at 0.3rem 1.7rem, ".concat(e.color," 0.15rem, transparent 0),")+"radial-gradient(circle at 0.7rem 1.7rem, ".concat(e.color," 0.15rem, transparent 0)");return(0,n.createVNode)("div",{"aria-label":"Drag Handle","aria-describedby":"VueDashboardItem__dragHandleDesc",class:a.S5.DragHandle,tabindex:"0",onMousedown:e=>(null==e?void 0:e.target).focus(),style:{backgroundImage:t,cursor:"grab"}},null,46,["onMousedown"])};r.props=["color"];const s=r},81261(e,o,t){t.d(o,{A:()=>r});var n=t(74061);const a=function(e,o){return(0,n.createVNode)("span",(0,n.mergeProps)({class:{fieldValidationMessage:!0,help:!0,error:e.isError},"data-validate-message-for":e.forId},o.attrs),[o.slots.default&&o.slots.default()],16,["data-validate-message-for"])};a.props=["forId","isError"];const r=a},72186(e,o,t){t.d(o,{A:()=>r});var n=t(74061);const a=function(e,o){return(0,n.createVNode)("div",(0,n.mergeProps)({class:"fieldWrapper"},o.attrs),[o.slots.default&&o.slots.default()],16)};a.props=[];const r=a},76800(e,o,t){t.d(o,{_:()=>r});var n=t(74061),a=t(75552);const r=(0,n.defineComponent)({name:"KeptAlive",props:{tag:(0,a.JJ)("div")},setup(e,o){let{slots:t,attrs:a}=o;return()=>{var o;return(0,n.h)(e.tag,a,null===(o=t.default)||void 0===o?void 0:o.call(t))}}})},99814(e,o,t){t.d(o,{A:()=>c});var n=t(74061);const a="labeledToggleSwitch__container",r="labeledToggleSwitch__input",s="labeledToggleSwitch__toggle",l="labeledToggleSwitch__name",i="labeledToggleSwitch__name--selected",c=function vButton(e,o){var t;const c=(0,n.ref)(null!==(t=e.checked)&&void 0!==t&&t),d=(0,n.ref)(),u=(0,n.ref)();function v(t){e.disabled||(t&&(d.value.checked=!d.value.checked),c.value=d.value.checked,o.emit("update:checked",c.value),u.value&&(u.value.innerHTML=c.value?e.CheckedStateLabel:e.UncheckedStateLabel))}return(0,n.createVNode)("label",(0,n.mergeProps)({role:"checkbox",id:e.id?"".concat(e.id,"_labeledToggleSwitch"):void 0,tabindex:"0","aria-label":e.ariaLabel,"aria-checked":c.value,onFocus:function(){u.value&&(u.value.innerHTML+="&nbsp")},class:{[a]:null==e.containerClassOverride,[e.containerClassOverride]:null!=e.containerClassOverride,"ui-control":!0,"ui-disabled":!0===e.disabled}},o.attrs,{onKeydown:e=>{" "===e.key&&v(!0)}}),[(0,n.createVNode)("input",{ref:d,id:e.id,class:{[r]:!0},name:e.name,type:"checkbox","aria-hidden":!0,tabindex:"-1",checked:c.value,onChange:()=>v(!1)},null,40,["id","name","checked","onChange"]),(0,n.createVNode)("div",{class:{[s]:null==e.toggleClassOverride,[e.toggleClassOverride]:null!=e.toggleClassOverride}},null,2),(0,n.createVNode)("div",{class:{[l]:null==e.itemClassOverride,[e.itemClassOverride]:null!=e.itemClassOverride,[i]:!c.value}},[e.UncheckedStateLabel],2),(0,n.createVNode)("div",{class:{[l]:null==e.itemClassOverride,[e.itemClassOverride]:null!=e.itemClassOverride,[i]:c.value}},[e.CheckedStateLabel],2),(0,n.createVNode)("span",{ref:u,"aria-live":"polite",class:"sr-only"},[c.value?e.CheckedStateLabel:e.UncheckedStateLabel],512)],16,["id","aria-label","aria-checked","onFocus","onKeydown"])}},66015(e,o,t){t.d(o,{A:()=>a});var n=t(74061);const a=function vLoading(e,o){return(0,n.createVNode)("div",(0,n.mergeProps)({class:"loadingContainer"},o.attrs),[(0,n.createVNode)("img",{class:"loadingImage",src:"".concat(window.skyward.global.virtualDir,"content/loading.gif")},null,8,["src"])],16)}},83303(e,o,t){function n(e,o){return(e%o+o)%o}function a(e,o,t){return Math.min(t,Math.max(o,e))}t.d(o,{A:()=>a,z:()=>n})},90121(e,o,t){t.d(o,{A:()=>d});var n=t(74061),a=t(79126),r=t(2894),s=t(49343),l=t(1380),i=t(75552),c=t(16140);const d=(0,n.defineComponent)({name:"ModalLayer",emits:{close:e=>!0},props:{beforeClose:(0,i.uh)(Function),transparent:(0,i.uh)(Boolean),expose:(0,i.JJ)(Array,{default:()=>[]}),anchorTo:(0,i.uh)(),closeOnEscape:(0,i.JJ)(!0),containerId:(0,i.JJ)(""),preserveFocus:{type:[Boolean,Function],required:!1,default:!0},initialFocusElement:{required:!1,default:void 0,validator:e=>"string"==typeof e||void 0===e||e instanceof $||e instanceof HTMLElement},role:(0,i.JJ)("dialog"),ariaLabel:(0,i.uh)(String),bindings:(0,i.JJ)(Array,{default:()=>[]})},setup(e,o){const t=document.body.querySelectorAll(".modalLayerContainer").length,d=(0,n.ref)(),u=(0,n.ref)(),v=(0,n.ref)();let p;const g=(0,n.ref)({});let f;function m(){g.value=e.anchorTo?function(e){const o=e.getBoundingClientRect(),t=function(e){const o=e.getBoundingClientRect(),t=(0,s.getClientHeight)()-o.bottom,n=o.top;return t>=n}(e),n={position:"absolute"};if(t){const e=o.bottom+window.scrollY,t=o.left+window.scrollX;n.top="".concat(e,"px"),n.left="".concat(t,"px")}else{const e=(0,s.getClientHeight)()-(o.top+window.scrollY),t=o.left+window.scrollX;n.bottom="".concat(e,"px"),n.left="".concat(t,"px")}return n}(e.anchorTo):{}}function h(e){return e.preventDefault(),!1}(0,n.onBeforeMount)(()=>{p=document.activeElement,m(),(0,i.xF)(window,"resize",b),(0,i.xF)(window,"orientationchange",b)});const b=(0,c.default)(()=>{requestAnimationFrame(m)},120);return(0,n.onMounted)(()=>{var o;f={get container(){return $(d.value)},get contents(){return $(u.value)},get glass(){return $(v.value)},setupContent:()=>{},addContent:()=>{},show:y,uniqueId:t,onscreen:!0,options:e,originalActiveElement:p,closing:!1,close:C,_bindingPoints:[],_exposedByUnderlyingLayer:[],_exposedElements:[]};const a="exposedToModalLayer_"+f.uniqueId;null===(o=e.expose)||void 0===o||o.forEach(e=>{f._exposedElements.push({element:e,previousOpacity:e.style.opacity,previousZIndex:e.style.zIndex,previousPosition:e.style.position}),e.style.zIndex="1",e.style.position="relative",e.classList.add(a),e.addEventListener("wheel",h)}),r.mobileAccess||(0,l.registerLayer)(f),e.closeOnEscape&&(0,i.xF)(document.body,"keydown",e=>{if("Escape"===e.key){const o=(0,s.getCurrentPopupId)();f.uniqueId===o&&(C("escape"),e.stopImmediatePropagation())}}),(0,n.onUnmounted)(()=>{var o;null===(o=e.expose)||void 0===o||o.forEach(e=>{const o=f._exposedElements.find(o=>o.element===e);o.previousZIndex&&o.previousZIndex.length>0?e.style.zIndex=o.previousZIndex:e.style.removeProperty("z-index"),o.previousPosition&&o.previousPosition.length>0?e.style.position=o.previousPosition:e.style.removeProperty("position"),e.classList.remove("exposedToModalLayer_"+f.uniqueId,"currentlyExposed")}),r.mobileAccess||(0,l.unregisterLayer)(f,!0)})}),()=>{var a,r;return(0,n.createVNode)(n.Teleport,{to:"body"},{default:()=>[(0,n.createVNode)("div",{class:"modalLayerContainer","data-layer-id":t,id:e.containerId,ref:d},[(0,n.createVNode)("div",{class:{glass:!0,transparent:e.transparent},id:"modalLayerGlass".concat(t),ref:v,onClick:()=>C("glassClick")},null,10,["id","onClick"]),(0,n.createVNode)("div",{style:g.value,ref:u,"aria-modal":"true",role:e.role,"aria-label":e.ariaLabel},[null===(a=(r=o.slots).default)||void 0===a?void 0:a.call(r)],12,["role","aria-label"])],8,["data-layer-id","id"])]})};function y(){f?(f.options.anchored&&(f.contents.addClass("anchored"),f.options.tailessAnchored&&f.contents.addClass("noAnchoredTail")),f.contents.addClass("columnLayoutWrapper--modalLayer"),f.container.show(),f.options.loadDOMCallback&&"function"==typeof f.options.loadDOMCallback&&(0,s.registerLoadDOMCallback)(f.options.loadDOMCallback),f.options.resizeCallback&&"function"==typeof f.options.resizeCallback&&(0,s.registerLayoutResizeCallback)(f.options.resizeCallback),r.mobileAccess||(0,l.setFocus)(f)):(0,a.reportException)(new a.SkywardException("layer is undefined within show function.","layerId: ".concat(t)))}function C(t){var n;return!!f.closing||!1!==(null===(n=e.beforeClose)||void 0===n?void 0:n.call(e,f,t))&&(f.closing=!0,o.emit("close",t),!0)}}})},19429(e,o,t){t.d(o,{A:()=>l});var n=t(74061),a=t(88157),r=t(80967);const s=function vMoreMenu(e,o){return(0,n.createVNode)("div",{class:"moreMenuArea"},[(0,n.createVNode)(r.A,{svgName:"ArrowTriangleDown",svgColor:e.svgColor,svgClasses:e.svgClasses,"aria-haspopup":"menu","aria-label":"More options",clickFunc:function(o){const t=o.target;(0,a.showMenu)(e.items,t,{beforeClose:function(){t.focus()}})},onMouseover:e.onMouseover,onMouseout:e.onMouseout},null,8,["svgColor","svgClasses","clickFunc","onMouseover","onMouseout"])])};s.props=["items","svgClasses","svgColor","onMouseover","onMouseout"];const l=s},4861(e,o,t){t.d(o,{A:()=>s});var n=t(74061),a=t(28877);const r=function vResizeHandle(e,o){const t="background:"+"linear-gradient(135deg, transparent 60%, ".concat(e.color," 60%, ").concat(e.color," 70%, transparent 70%, transparent 80%, ").concat(e.color," 80%, ").concat(e.color," 90%, transparent 90%)");return(0,n.createVNode)(n.Fragment,null,[(0,n.createVNode)("div",{class:"ui-resizable-handle ".concat(a.S5.ResizeHandle," "),style:t},null,6),(0,n.createVNode)("div",{class:"ui-resizable-handle ui-resizable-e"},null),(0,n.createVNode)("div",{class:"ui-resizable-handle ui-resizable-s"},null)])};r.props=["color"];const s=r},98925(e,o,t){t.d(o,{A:()=>r});var n=t(74061);const a=function vSvg(e,o){let t=function(e){var o=["svg","svgGroup",e.name[0].toLowerCase()+e.name.slice(1)];!1===e.showHoverEffect&&o.push("svgNoHover");!0===e.isButton&&o.push("buttonSvg");void 0!==e.type&&o.push("svg"+e.type[0].toLocaleUpperCase()+e.type.slice(1));return o}(e);const a=e.svgClasses;return Array.isArray(a)?t.push(...a):"object"==typeof a&&null!==a&&t.push(...Object.keys(a).filter(e=>a[e])),(0,n.createVNode)("svg",(0,n.mergeProps)({class:t},e.ignoreTabIndex?{}:{tabindex:"-1"},o.attrs),[(0,n.createVNode)("use",{href:"#svg-".concat(e.name)},null,8,["href"]),o.attrs.title?(0,n.createVNode)("title",{"aria-hidden":!0},[o.attrs.title]):null],16)};a.props=["name","type","showHoverEffect","isButton","svgClasses","svgTitle","ignoreTabIndex"];const r=a},75552(e,o,t){t.d(o,{E8:()=>p,JJ:()=>i,QM:()=>d,Ti:()=>u,VZ:()=>v,Y2:()=>m,_w:()=>f,bV:()=>C,c5:()=>c,l8:()=>y,mM:()=>g,oY:()=>s,pH:()=>b,uh:()=>l,xF:()=>h});var n=t(2894),a=t(92214),r=t(74061);function s(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:Object,o=arguments.length>1?arguments[1]:void 0;return{type:(Array.isArray(e),e),required:!0,default:null,validator:null==o?void 0:o.validator}}function l(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:Object,o=arguments.length>1?arguments[1]:void 0;return{type:(Array.isArray(e),e),required:!1,default:null,validator:null==o?void 0:o.validator}}function i(){let e,o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:Object,t=arguments.length>1?arguments[1]:void 0;return e="function"==typeof o?{type:o,required:!1,default:t.default,validator:t.validator}:{type:Object.getPrototypeOf(o).constructor,required:!1,default:o,validator:void 0},e}function c(){return null}function d(e){return e}function u(e){return e}function v(e,o){return(0,r.createApp)(e,o)}function p(e){let o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;return"function"==typeof e&&(e=e()),null==e||e.type===r.Comment||Array.isArray(e)&&(0===e.length||1===e.length&&e[0].type===r.Comment)?o:e}function g(e,o){(0,r.onMounted)(()=>{e.registerCallback(o)}),(0,r.onUnmounted)(()=>{e.deregisterCallback(o)})}function f(e,o){let t;const a=null!=o?o:n.deepEquals;return(0,r.computed)(()=>{const o=e(t);return a(o,t)||(t=o),t})}function m(e,o,t){var a;const s=null!==(a=null==t?void 0:t.comparer)&&void 0!==a?a:n.deepEquals;return(0,r.watch)(e,(e,t)=>{s(e,t)||o(e)},t)}function h(e,o,t){$(e).on(o,t),(0,r.onScopeDispose)(()=>$(e).off(o,t))}function b(e,o){e.registerCallback(o),(0,r.onScopeDispose)(()=>{e.deregisterCallback(o)})}function y(e,o){const t=(0,r.getCurrentScope)();let n=(0,r.effectScope)();(0,r.onMounted)(()=>{n.run(o)}),b(e.onRefresh,()=>{n.stop(),t.run(()=>{n=(0,r.effectScope)(),n.run(o)})})}function C(e,o){null==e||e.split(";").forEach(e=>{var t;null===(t=(0,a.getActionFunction)(e))||void 0===t||t.apply(o)})}}}]);
;
/*!
 * jQuery UI Touch Punch 0.2.3
 *
 * Copyright 2011–2014, Dave Furfero
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * Depends:
 *  jquery.ui.widget.js
 *  jquery.ui.mouse.js
 */

!function (a) { function f(a, b) { if (!(a.originalEvent.touches.length > 1)) { a.preventDefault(); var c = a.originalEvent.changedTouches[0], d = document.createEvent("MouseEvents"); d.initMouseEvent(b, !0, !0, window, 1, c.screenX, c.screenY, c.clientX, c.clientY, !1, !1, !1, !1, 0, null), a.target.dispatchEvent(d) } } if (a.support.touch = "ontouchend" in document, a.support.touch) { var e, b = a.ui.mouse.prototype, c = b._mouseInit, d = b._mouseDestroy; b._touchStart = function (a) { var b = this; !e && b._mouseCapture(a.originalEvent.changedTouches[0]) && (e = !0, b._touchMoved = 0, f(a, "mouseover"), f(a, "mousemove"), f(a, "mousedown")) }, b._touchMove = function (a) { e && (this._touchMoved += 1, f(a, "mousemove")) }, b._touchEnd = function (a) { e && (f(a, "mouseup"), f(a, "mouseout"), this._touchMoved <= 5 && f(a, "click"), e = !1) }, b._mouseInit = function () { var b = this; b.element.on({ touchstart: a.proxy(b, "_touchStart"), touchmove: a.proxy(b, "_touchMove"), touchend: a.proxy(b, "_touchEnd") }), c.call(b) }, b._mouseDestroy = function () { var b = this; b.element.off({ touchstart: a.proxy(b, "_touchStart"), touchmove: a.proxy(b, "_touchMove"), touchend: a.proxy(b, "_touchEnd") }), d.call(b) } } }(jQuery);;
/*!
 * jQuery Placeholder Plugin v2.3.1
 * https://github.com/mathiasbynens/jquery-placeholder
 *
 * Copyright 2011, 2015 Mathias Bynens
 * Released under the MIT license
 */
(function (factory)
{
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($)
{

    /****
     * Allows plugin behavior simulation in modern browsers for easier debugging. 
     * When setting to true, use attribute "placeholder-x" rather than the usual "placeholder" in your inputs/textareas 
     * i.e. <input type="text" placeholder-x="my placeholder text" />
     */
    var debugMode = false;

    // Opera Mini v7 doesn't support placeholder although its DOM seems to indicate so
    var isOperaMini = Object.prototype.toString.call(window.operamini) === '[object OperaMini]';
    var isInputSupported = 'placeholder' in document.createElement('input') && !isOperaMini && !debugMode;
    var isTextareaSupported = 'placeholder' in document.createElement('textarea') && !isOperaMini && !debugMode;
    var valHooks = $.valHooks;
    var propHooks = $.propHooks;
    var hooks;
    var placeholder;
    var settings = {};

    if (isInputSupported && isTextareaSupported) {

        placeholder = $.fn.placeholder = function ()
        {
            return this;
        };

        placeholder.input = true;
        placeholder.textarea = true;

    } else {

        placeholder = $.fn.placeholder = function (options)
        {

            var defaults = { customClass: 'placeholder' };
            settings = $.extend({}, defaults, options);

            return this.filter((isInputSupported ? 'textarea' : ':input') + '[' + (debugMode ? 'placeholder-x' : 'placeholder') + ']')
                .not('.' + settings.customClass)
                .not(':radio, :checkbox, [type=hidden]')
                .on({
                    'focus.placeholder': clearPlaceholder,
                    'blur.placeholder': setPlaceholder
                })
                .data('placeholder-enabled', true)
                .trigger('blur.placeholder');
        };

        placeholder.input = isInputSupported;
        placeholder.textarea = isTextareaSupported;

        hooks = {
            'get': function (element)
            {

                var $element = $(element);
                var $passwordInput = $element.data('placeholder-password');

                if ($passwordInput) {
                    return $passwordInput[0].value;
                }

                return $element.data('placeholder-enabled') && $element.hasClass(settings.customClass) ? '' : element.value;
            },
            'set': function (element, value)
            {

                var $element = $(element);
                var $replacement;
                var $passwordInput;

                if (value !== '') {

                    $replacement = $element.data('placeholder-textinput');
                    $passwordInput = $element.data('placeholder-password');

                    if ($replacement) {
                        clearPlaceholder.call($replacement[0], true, value) || (element.value = value);
                        $replacement[0].value = value;

                    } else if ($passwordInput) {
                        clearPlaceholder.call(element, true, value) || ($passwordInput[0].value = value);
                        element.value = value;
                    }
                }

                if (!$element.data('placeholder-enabled')) {
                    element.value = value;
                    return $element;
                }

                if (value === '') {

                    element.value = value;

                    // Setting the placeholder causes problems if the element continues to have focus.
                    if (element != safeActiveElement()) {
                        // We can't use `triggerHandler` here because of dummy text/password inputs :(
                        setPlaceholder.call(element);
                    }

                } else {

                    if ($element.hasClass(settings.customClass)) {
                        clearPlaceholder.call(element);
                    }

                    element.value = value;
                }
                // `set` can not return `undefined`; see http://jsapi.info/jquery/1.7.1/val#L2363
                return $element;
            }
        };

        if (!isInputSupported) {
            valHooks.input = hooks;
            propHooks.value = hooks;
        }

        if (!isTextareaSupported) {
            valHooks.textarea = hooks;
            propHooks.value = hooks;
        }

        $(function ()
        {
            // Look for forms
            $(document).delegate('form', 'submit.placeholder', function ()
            {

                // Clear the placeholder values so they don't get submitted
                var $inputs = $('.' + settings.customClass, this).each(function ()
                {
                    clearPlaceholder.call(this, true, '');
                });

                setTimeout(function ()
                {
                    $inputs.each(setPlaceholder);
                }, 10);
            });
        });

        // Clear placeholder values upon page reload
        $(window).on('beforeunload.placeholder', function ()
        {

            var clearPlaceholders = true;

            try {
                // Prevent IE javascript:void(0) anchors from causing cleared values
                if (document.activeElement.toString() === 'javascript:void(0)') {
                    clearPlaceholders = false;
                }
            } catch (exception) { }

            if (clearPlaceholders) {
                $('.' + settings.customClass).each(function ()
                {
                    this.value = '';
                });
            }
        });
    }

    function args(elem)
    {
        // Return an object of element attributes
        var newAttrs = {};
        var rinlinejQuery = /^jQuery\d+$/;

        $.each(elem.attributes, function (i, attr)
        {
            if (attr.specified && !rinlinejQuery.test(attr.name)) {
                newAttrs[attr.name] = attr.value;
            }
        });

        return newAttrs;
    }

    function clearPlaceholder(event, value)
    {

        var input = this;
        var $input = $(this);

        if (input.value === $input.attr((debugMode ? 'placeholder-x' : 'placeholder')) && $input.hasClass(settings.customClass)) {

            input.value = '';
            $input.removeClass(settings.customClass);

            if ($input.data('placeholder-password')) {

                $input = $input.hide().nextAll('input[type="password"]:first').show().attr('id', $input.removeAttr('id').data('placeholder-id'));

                // If `clearPlaceholder` was called from `$.valHooks.input.set`
                if (event === true) {
                    $input[0].value = value;

                    return value;
                }

                $input.focus();

            } else {
                input == safeActiveElement() && input.select();
            }
        }
    }

    function setPlaceholder(event)
    {
        var $replacement;
        var input = this;
        var $input = $(this);
        var id = input.id;

        // If the placeholder is activated, triggering blur event (`$input.trigger('blur')`) should do nothing.
        if (event && event.type === 'blur' && $input.hasClass(settings.customClass)) {
            return;
        }

        if (input.value === '') {
            if (input.type === 'password') {
                if (!$input.data('placeholder-textinput')) {

                    try {
                        $replacement = $input.clone().prop({ 'type': 'text' });
                    } catch (e) {
                        $replacement = $('<input>').attr($.extend(args(this), { 'type': 'text' }));
                    }

                    $replacement
                        .removeAttr('name')
                        .data({
                            'placeholder-enabled': true,
                            'placeholder-password': $input,
                            'placeholder-id': id
                        })
                        .on('focus.placeholder', clearPlaceholder);

                    $input
                        .data({
                            'placeholder-textinput': $replacement,
                            'placeholder-id': id
                        })
                        .before($replacement);
                }

                input.value = '';
                $input = $input.removeAttr('id').hide().prevAll('input[type="text"]:first').attr('id', $input.data('placeholder-id')).show();

            } else {

                var $passwordInput = $input.data('placeholder-password');

                if ($passwordInput) {
                    $passwordInput[0].value = '';
                    $input.attr('id', $input.data('placeholder-id')).show().nextAll('input[type="password"]:last').hide().removeAttr('id');
                }
            }

            $input.addClass(settings.customClass);
            $input[0].value = $input.attr((debugMode ? 'placeholder-x' : 'placeholder'));

        } else {
            $input.removeClass(settings.customClass);
        }
    }

    function safeActiveElement()
    {
        // Avoid IE9 `document.activeElement` of death
        try {
            return document.activeElement;
        } catch (exception) { }
    }
}));;
/*!
 * jQuery scrollintoview() plugin and :scrollable selector filter
 *
 * Version 1.9.4 (06 April 2016)
 * Requires jQuery 1.4 or newer
 *
 * Copyright (c) 2011 Robert Koritnik
 * Licensed under the terms of the MIT license
 * http://www.opensource.org/licenses/mit-license.php
 */

!function (root, factory)
{
    if (typeof define === 'function' && define.amd)
    {
        define(['jquery'], factory);
    } else if (typeof exports === 'object')
    {
        factory(require('jquery'));
    } else
    {
        factory(root.jQuery);
    }
}
    (this, function ($)
    {
        var converter = {
            vertical: { x: false, y: true },
            horizontal: { x: true, y: false },
            both: { x: true, y: true },
            x: { x: true, y: false },
            y: { x: false, y: true }
        };

        var settings = {
            duration: "fast",
            direction: "both",
            viewPadding: 0
        };

        var rootrx = /^(?:html)$/i;

        // gets border dimensions
        var borders = function (domElement, styles)
        {
            styles = styles || (document.defaultView && document.defaultView.getComputedStyle ? document.defaultView.getComputedStyle(domElement, null) : domElement.currentStyle);
            var px = document.defaultView && document.defaultView.getComputedStyle ? true : false;
            var b = {
                top: (parseFloat(px ? styles.borderTopWidth : $.css(domElement, "borderTopWidth")) || 0),
                left: (parseFloat(px ? styles.borderLeftWidth : $.css(domElement, "borderLeftWidth")) || 0),
                bottom: (parseFloat(px ? styles.borderBottomWidth : $.css(domElement, "borderBottomWidth")) || 0),
                right: (parseFloat(px ? styles.borderRightWidth : $.css(domElement, "borderRightWidth")) || 0)
            };
            return {
                top: b.top,
                left: b.left,
                bottom: b.bottom,
                right: b.right,
                vertical: b.top + b.bottom,
                horizontal: b.left + b.right
            };
        };

        var dimensions = function ($element)
        {
            var elem = $element[0],
                isRoot = rootrx.test(elem.nodeName),
                $elem = isRoot ? $(window) : $element;
            return {
                border: isRoot ? { top: 0, left: 0, bottom: 0, right: 0 } : borders(elem),
                scroll: {
                    top: $elem.scrollTop(),
                    left: $elem.scrollLeft(),
                    maxtop: elem.scrollHeight - elem.clientHeight,
                    maxleft: elem.scrollWidth - elem.clientWidth
                },
                scrollbar: isRoot
                    ? { right: 0, bottom: 0 }
                    : {
                        right: $elem.innerWidth() - elem.clientWidth,
                        bottom: $elem.innerHeight() - elem.clientHeight
                    },
                rect: isRoot ? { top: 0, left: 0, bottom: elem.clientHeight, right: elem.clientWidth } : elem.getBoundingClientRect()
            };
        };

        $.fn.extend({
            scrollintoview: function (options)
            {
                /// <summary>Scrolls the first element in the set into view by scrolling its closest scrollable parent.</summary>
                /// <param name="options" type="Object">Additional options that can configure scrolling:
                ///        duration (default: "fast") - jQuery animation speed (can be a duration string or number of milliseconds)
                ///        direction (default: "both") - select possible scrollings ("vertical" or "y", "horizontal" or "x", "both")
                ///        complete (default: none) - a function to call when scrolling completes (called in context of the DOM element being scrolled)
                /// </param>
                /// <return type="jQuery">Returns the same jQuery set that this function was run on.</return>

                options = $.extend({}, settings, options);
                options.direction = converter[typeof (options.direction) === "string" && options.direction.toLowerCase()] || converter.both;

                if (typeof options.viewPadding == "number")
                {
                    options.viewPadding = { x: options.viewPadding, y: options.viewPadding };
                } else if (typeof options.viewPadding == "object")
                {
                    if (options.viewPadding.x == undefined)
                    {
                        options.viewPadding.x = 0;
                    }
                    if (options.viewPadding.y == undefined)
                    {
                        options.viewPadding.y = 0;
                    }
                }

                var dirStr = "";
                if (options.direction.x === true) dirStr = "horizontal";
                if (options.direction.y === true) dirStr = dirStr ? "both" : "vertical";

                var el = this.eq(0);
                var scroller = el.parent().closest(":scrollable(" + dirStr + ")");

                // check if there's anything to scroll in the first place
                if (scroller.length > 0)
                {
                    scroller = scroller.eq(0);

                    var dim = {
                        e: dimensions(el),
                        s: dimensions(scroller)
                    };

                    var rel = {
                        top: dim.e.rect.top - (dim.s.rect.top + dim.s.border.top + options.viewPadding.y),
                        bottom: (dim.s.rect.bottom - dim.s.border.bottom - dim.s.scrollbar.bottom - options.viewPadding.y) - dim.e.rect.bottom,
                        left: dim.e.rect.left - (dim.s.rect.left + dim.s.border.left + options.viewPadding.x),
                        right: (dim.s.rect.right - dim.s.border.right - dim.s.scrollbar.right - options.viewPadding.x) - dim.e.rect.right
                    };

                    var animProperties = {};

                    // vertical scroll
                    if (options.direction.y === true)
                    {
                        if (rel.top < 0)
                        {
                            animProperties.scrollTop = Math.max(0, dim.s.scroll.top + rel.top);
                        } else if (rel.top > 0 && rel.bottom < 0)
                        {
                            animProperties.scrollTop = Math.min(dim.s.scroll.top + Math.min(rel.top, -rel.bottom), dim.s.scroll.maxtop);
                        }
                    }

                    // horizontal scroll
                    if (options.direction.x === true)
                    {
                        if (rel.left < 0)
                        {
                            animProperties.scrollLeft = Math.max(0, dim.s.scroll.left + rel.left);
                        } else if (rel.left > 0 && rel.right < 0)
                        {
                            animProperties.scrollLeft = Math.min(dim.s.scroll.left + Math.min(rel.left, -rel.right), dim.s.scroll.maxleft);
                        }
                    }

                    // scroll if needed
                    if (!$.isEmptyObject(animProperties))
                    {
                        var scrollExpect = {},
                            scrollListener = scroller;

                        if (rootrx.test(scroller[0].nodeName))
                        {
                            scroller = $("html,body");
                            scrollListener = $(window);
                        }

                        function animateStep(now, tween)
                        {
                            scrollExpect[tween.prop] = Math.floor(now);
                        };

                        function onscroll(event)
                        {
                            $.each(scrollExpect, function (key, value)
                            {
                                if (Math.floor(scrollListener[key]()) != Math.floor(value))
                                {
                                    options.complete = null; // don't run complete function if the scrolling was interrupted
                                    scroller.stop('scrollintoview');
                                }
                            });
                        }

                        scrollListener.on('scroll', onscroll);

                        scroller
                            .stop('scrollintoview')
                            .animate(animProperties, { duration: options.duration, step: animateStep, queue: 'scrollintoview' })
                            .eq(0) // we want function to be called just once (ref. "html,body")
                            .queue('scrollintoview', function (next)
                            {
                                scrollListener.off('scroll', onscroll);
                                typeof options.complete === "function" && options.complete.call(scroller[0]);
                                next();
                            })

                        scroller.dequeue('scrollintoview');
                    } else
                    {
                        // when there's nothing to scroll, just call the "complete" function
                        typeof options.complete === "function" && options.complete.call(scroller[0]);
                    }
                }

                // return set back
                return this;
            }
        });

        var scrollValue = {
            auto: true,
            scroll: true,
            visible: false,
            hidden: false
        };

        var scroll = function (element, direction)
        {
            direction = converter[typeof (direction) === "string" && direction.toLowerCase()] || converter.both;
            var styles = (document.defaultView && document.defaultView.getComputedStyle ? document.defaultView.getComputedStyle(element, null) : element.currentStyle);
            var overflow = {
                x: scrollValue[styles.overflowX.toLowerCase()] || false,
                y: scrollValue[styles.overflowY.toLowerCase()] || false,
                isRoot: rootrx.test(element.nodeName)
            };

            // check if completely unscrollable (exclude HTML element because it's special)
            if (!overflow.x && !overflow.y && !overflow.isRoot)
            {
                return false;
            }

            var size = {
                height: {
                    scroll: element.scrollHeight,
                    client: element.clientHeight
                },
                width: {
                    scroll: element.scrollWidth,
                    client: element.clientWidth
                },
                // check overflow.x/y because iPad (and possibly other tablets) don't dislay scrollbars
                scrollableX: function ()
                {
                    return (overflow.x || overflow.isRoot) && this.width.scroll > this.width.client;
                },
                scrollableY: function ()
                {
                    return (overflow.y || overflow.isRoot) && this.height.scroll > this.height.client;
                }
            };
            return direction.y && size.scrollableY() || direction.x && size.scrollableX();
        };

        $.expr[":"].scrollable = $.expr.createPseudo(function (direction)
        {
            return function (element)
            {
                return scroll(element, direction);
            };
        });
    });;
// The changed functions from https://github.com/jquery/jquery-ui/pull/1908 have been extracted into this file.
// Once JQuery UI is updated, it can be removed.
$(function ()
{
    "use strict";

    if ($.datepicker === undefined)
    {
        // jQuery UI is not loaded, so there are no datepicker methods to patch. Bail out instead
        // of throwing inside this ready handler. The missing script is already reported from
        // skyward.ui.oldDatePicker.js, which ships in every bundle that includes this file, so
        // this does not need to report it a second time.
        return;
    }

	var originalDateConstructor = window.Date;
	var fixedDateConstructor = function ()
	{
		if (!this || this.constructor !== originalDateConstructor)
		{
			return originalDateConstructor();
		}
		return skyward.time.newDate.apply(undefined, arguments);
	};
    fixedDateConstructor.parse = Date.parse;
    fixedDateConstructor.now = Date.now;
    fixedDateConstructor.UTC = Date.UTC;
    fixedDateConstructor.prototype = Date.prototype;

	var wrapDateConstructor = function (wrappedFunction)
	{
		return function ()
		{
            var originalDateConstructor = window.Date;
			try
			{
				window.Date = fixedDateConstructor;
				return wrappedFunction.apply(this, arguments);
			}
			finally
			{
				window.Date = originalDateConstructor;
			}
		}
	};

	var methodsToReplace =
    [
        "_determineDate",
        "_getDate",
        "_generateHTML",
        "_adjustInstDate",
        "_getDaysInMonth",
        "_getFirstDayOfMonth",
        "_canAdjustMonth",
        "_formatDate"
    ];
	methodsToReplace.forEach(function (methodName)
	{
		$.datepicker[methodName] = wrapDateConstructor($.datepicker[methodName]);
	});

	var originalFormatDate = $.datepicker.formatDate;
	$.datepicker.formatDate = function (format, date, settings)
	{
		if (!date) // this matches the expectations of the original $.datepicker.formatDate function 
		{
			return "";
		}
		format = format.replace(/yy/g, $.datepicker._formatYear(date.getFullYear()));
		return originalFormatDate.call(this, format, date, settings);
	};

	$.datepicker.parseDate = function( format, value, settings ) {
		if ( format == null || value == null ) {
			throw "Invalid arguments";
		}
	
		value = ( typeof value === "object" ? value.toString() : value + "" );
		if ( value === "" ) {
			return null;
		}
	
		var iFormat, dim, extra,
			iValue = 0,
			shortYearCutoffTemp = ( settings ? settings.shortYearCutoff : null ) || this._defaults.shortYearCutoff,
			shortYearCutoff = ( typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
				new Date().getFullYear() % 100 + parseInt( shortYearCutoffTemp, 10 ) ),
			dayNamesShort = ( settings ? settings.dayNamesShort : null ) || this._defaults.dayNamesShort,
			dayNames = ( settings ? settings.dayNames : null ) || this._defaults.dayNames,
			monthNamesShort = ( settings ? settings.monthNamesShort : null ) || this._defaults.monthNamesShort,
			monthNames = ( settings ? settings.monthNames : null ) || this._defaults.monthNames,
			year = -1,
			isFullYear = false,
			month = -1,
			day = -1,
			doy = -1,
			literal = false,
			date,
	
			// Check whether a format character is doubled
			lookAhead = function( match ) {
				var matches = ( iFormat + 1 < format.length && format.charAt( iFormat + 1 ) === match );
				if ( matches ) {
					iFormat++;
				}
				return matches;
			},
	
			// Extract a number from the string value
			getNumber = function( match ) {
				var isDoubled = lookAhead( match ),
					size = ( match === "@" ? 14 : ( match === "!" ? 20 :
					( match === "y" && isDoubled ? 4 : ( match === "o" ? 3 : 2 ) ) ) ),
					minSize = ( match === "y" ? size : 1 ),
					digits = new RegExp( "^" + ( match === "@" ? "-?" : "" ) + "\\d{" + minSize + "," + size + "}" ),
					num = value.substring( iValue ).match( digits );
				if ( !num ) {
					throw "Missing number at position " + iValue;
				}
				if ( match === "y" ) {
					isFullYear = isDoubled;
				}
				iValue += num[ 0 ].length;
				return parseInt( num[ 0 ], 10 );
			},
	
			// Extract a name from the string value and convert to an index
			getName = function( match, shortNames, longNames ) {
				var index = -1,
					names = $.map( lookAhead( match ) ? longNames : shortNames, function( v, k ) {
						return [ [ k, v ] ];
					} ).sort( function( a, b ) {
						return -( a[ 1 ].length - b[ 1 ].length );
					} );
	
				$.each( names, function( i, pair ) {
					var name = pair[ 1 ];
					if ( value.substr( iValue, name.length ).toLowerCase() === name.toLowerCase() ) {
						index = pair[ 0 ];
						iValue += name.length;
						return false;
					}
				} );
				if ( index !== -1 ) {
					return index + 1;
				} else {
					throw "Unknown name at position " + iValue;
				}
			},
	
			// Confirm that a literal character matches the string value
			checkLiteral = function() {
				if ( value.charAt( iValue ) !== format.charAt( iFormat ) ) {
					throw "Unexpected literal at position " + iValue;
				}
				iValue++;
			};
	
		for ( iFormat = 0; iFormat < format.length; iFormat++ ) {
			if ( literal ) {
				if ( format.charAt( iFormat ) === "'" && !lookAhead( "'" ) ) {
					literal = false;
				} else {
					checkLiteral();
				}
			} else {
				switch ( format.charAt( iFormat ) ) {
					case "d":
						day = getNumber( "d" );
						break;
					case "D":
						getName( "D", dayNamesShort, dayNames );
						break;
					case "o":
						doy = getNumber( "o" );
						break;
					case "m":
						month = getNumber( "m" );
						break;
					case "M":
						month = getName( "M", monthNamesShort, monthNames );
						break;
					case "y":
						year = getNumber( "y" );
						break;
					case "@":
						date = new Date( getNumber( "@" ) );
						year = date.getFullYear();
						isFullYear = true;
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "!":
						date = new Date( ( getNumber( "!" ) - this._ticksTo1970 ) / 10000 );
						year = date.getFullYear();
						isFullYear = true;
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "'":
						if ( lookAhead( "'" ) ) {
							checkLiteral();
						} else {
							literal = true;
						}
						break;
					default:
						checkLiteral();
				}
			}
		}
	
		if ( iValue < value.length ) {
			extra = value.substr( iValue );
			if ( !/^\s+/.test( extra ) ) {
				throw "Extra/unparsed characters found in date: " + extra;
			}
		}
	
		if ( year === -1 ) {
			year = new Date().getFullYear();
		} else if ( year < 100 && !isFullYear ) {
			year += new Date().getFullYear() - new Date().getFullYear() % 100 +
				( year <= shortYearCutoff ? 0 : -100 );
		}
	
		if ( doy > -1 ) {
			month = 1;
			day = doy;
			do {
				dim = this._getDaysInMonth( year, month - 1 );
				if ( day <= dim ) {
					break;
				}
				month++;
				day -= dim;
			} while ( true );
		}

		date = this._daylightSavingAdjust( new fixedDateConstructor( year, month - 1, day ) );
		if ( date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day ) {
			throw "Invalid date"; // E.g. 31/02/00
		}
		return date;
	};
	$.datepicker._generateMonthYearHeader = function( inst, drawMonth, drawYear, minDate, maxDate,
			secondary, monthNames, monthNamesShort ) {
	
		var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
			changeMonth = this._get( inst, "changeMonth" ),
			changeYear = this._get( inst, "changeYear" ),
			showMonthAfterYear = this._get( inst, "showMonthAfterYear" ),
			html = "<div class='ui-datepicker-title'>",
			monthHtml = "";
	
		// Month selection
		if ( secondary || !changeMonth ) {
			monthHtml += "<span class='ui-datepicker-month'>" + monthNames[ drawMonth ] + "</span>";
		} else {
			inMinYear = ( minDate && minDate.getFullYear() === drawYear );
			inMaxYear = ( maxDate && maxDate.getFullYear() === drawYear );
			monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
			for ( month = 0; month < 12; month++ ) {
				if ( ( !inMinYear || month >= minDate.getMonth() ) && ( !inMaxYear || month <= maxDate.getMonth() ) ) {
					monthHtml += "<option value='" + month + "'" +
						( month === drawMonth ? " selected='selected'" : "" ) +
						">" + monthNamesShort[ month ] + "</option>";
				}
			}
			monthHtml += "</select>";
		}
	
		if ( !showMonthAfterYear ) {
			html += monthHtml + ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" );
		}
	
		// Year selection
		if ( !inst.yearshtml ) {
			inst.yearshtml = "";
			if ( secondary || !changeYear ) {
				html += "<span class='ui-datepicker-year'>" + this._formatYear( drawYear ) + "</span>";
			} else {
	
				// determine range of years to display
				years = this._get( inst, "yearRange" ).split( ":" );
				thisYear = new Date().getFullYear();
				determineYear = function( value ) {
					var year = ( value.match( /c[+\-].*/ ) ? drawYear + parseInt( value.substring( 1 ), 10 ) :
						( value.match( /[+\-].*/ ) ? thisYear + parseInt( value, 10 ) :
						parseInt( value, 10 ) ) );
					return ( isNaN( year ) ? thisYear : year );
				};
				year = determineYear( years[ 0 ] );
				endYear = Math.max( year, determineYear( years[ 1 ] || "" ) );
				year = ( minDate ? Math.max( year, minDate.getFullYear() ) : year );
				endYear = ( maxDate ? Math.min( endYear, maxDate.getFullYear() ) : endYear );
				inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
				for ( ; year <= endYear; year++ ) {
					inst.yearshtml += "<option value='" + year + "'" +
						( year === drawYear ? " selected='selected'" : "" ) +
						">" + this._formatYear( year ) + "</option>";
				}
				inst.yearshtml += "</select>";
	
				html += inst.yearshtml;
				inst.yearshtml = null;
			}
		}
	
		html += this._get( inst, "yearSuffix" );
		if ( showMonthAfterYear ) {
			html += ( secondary || !( changeMonth && changeYear ) ? "&#xa0;" : "" ) + monthHtml;
		}
		html += "</div>"; // Close datepicker_header
		return html;
	};
	$.datepicker._formatYear = function( year ) {
		return ( year < 0 ? "-" : "" ) + ( "0000" + Math.abs( year ) ).slice( -4 );
	};
});
;
// Spectrum Colorpicker v1.8.0
// https://github.com/bgrins/spectrum
// Author: Brian Grinstead
// License: MIT

!function (t) { "use strict"; "function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports && "object" == typeof module ? module.exports = t(require("jquery")) : t(jQuery) }(function (t, e) { "use strict"; var r = { beforeShow: f, move: f, change: f, show: f, hide: f, color: !1, flat: !1, showInput: !1, allowEmpty: !1, showButtons: !0, clickoutFiresChange: !0, showInitial: !1, showPalette: !1, showPaletteOnly: !1, hideAfterPaletteSelect: !1, togglePaletteOnly: !1, showSelectionPalette: !0, localStorageKey: !1, appendTo: "body", maxSelectionSize: 7, cancelText: "cancel", chooseText: "choose", togglePaletteMoreText: "more", togglePaletteLessText: "less", clearText: "Clear Color Selection", noColorSelectedText: "No Color Selected", preferredFormat: !1, className: "", containerClassName: "", replacerClassName: "", showAlpha: !1, theme: "sp-light", palette: [["#ffffff", "#000000", "#ff0000", "#ff8000", "#ffff00", "#008000", "#0000ff", "#4b0082", "#9400d3"]], selectionPalette: [], disabled: !1, offset: null }, a = [], n = !!/msie/i.exec(window.navigator.userAgent), i = function () { function t(t, e) { return !!~("" + t).indexOf(e) } var e = document.createElement("div").style; return e.cssText = "background-color:rgba(0,0,0,.5)", t(e.backgroundColor, "rgba") || t(e.backgroundColor, "hsla") }(), o = ["<div class='sp-replacer'>", "<div class='sp-preview'><div class='sp-preview-inner'></div></div>", "<div class='sp-dd'>&#9660;</div>", "</div>"].join(""), s = function () { var t = ""; if (n) for (var e = 1; e <= 6; e++)t += "<div class='sp-" + e + "'></div>"; return ["<div class='sp-container sp-hidden'>", "<div class='sp-palette-container'>", "<div class='sp-palette sp-thumb sp-cf'></div>", "<div class='sp-palette-button-container sp-cf'>", "<button type='button' class='sp-palette-toggle'></button>", "</div>", "</div>", "<div class='sp-picker-container'>", "<div class='sp-top sp-cf'>", "<div class='sp-fill'></div>", "<div class='sp-top-inner'>", "<div class='sp-color'>", "<div class='sp-sat'>", "<div class='sp-val'>", "<div class='sp-dragger'></div>", "</div>", "</div>", "</div>", "<div class='sp-clear sp-clear-display'>", "</div>", "<div class='sp-hue'>", "<div class='sp-slider'></div>", t, "</div>", "</div>", "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>", "</div>", "<div class='sp-input-container sp-cf'>", "<input class='sp-input' type='text' spellcheck='false'  />", "</div>", "<div class='sp-initial sp-thumb sp-cf'></div>", "<div class='sp-button-container sp-cf'>", "<a class='sp-cancel' href='#'></a>", "<button type='button' class='sp-choose'></button>", "</div>", "</div>", "</div>"].join("") }(); function l(e, r, a, n) { for (var o = [], s = 0; s < e.length; s++) { var l = e[s]; if (l) { var c = tinycolor(l), f = c.toHsl().l < .5 ? "sp-thumb-el sp-thumb-dark" : "sp-thumb-el sp-thumb-light"; f += tinycolor.equals(r, l) ? " sp-thumb-active" : ""; var h = c.toString(n.preferredFormat || "rgb"), u = i ? "background-color:" + c.toRgbString() : "filter:" + c.toFilter(); o.push('<span title="' + h + '" data-color="' + c.toRgbString() + '" class="' + f + '"><span class="sp-thumb-inner" style="' + u + ';"></span></span>') } else { o.push(t("<div />").append(t('<span data-color="" style="background-color:transparent;" class="sp-clear-display"></span>').attr("title", n.noColorSelectedText)).html()) } } return "<div class='sp-cf " + a + "'>" + o.join("") + "</div>" } function c(c, f) { var g, b, v, m, y, w, _, x = (y = f, w = c, (_ = t.extend({}, r, y)).callbacks = { move: u(_.move, w), change: u(_.change, w), show: u(_.show, w), hide: u(_.hide, w), beforeShow: u(_.beforeShow, w) }, _), k = x.flat, S = x.showSelectionPalette, C = x.localStorageKey, P = x.theme, A = x.callbacks, M = (g = Wt, b = 10, function () { var t = this, e = arguments; v && clearTimeout(m), !v && m || (m = setTimeout(function () { m = null, g.apply(t, e) }, b)) }), R = !1, H = !1, F = 0, T = 0, O = 0, q = 0, N = 0, j = 0, E = 0, D = 0, I = 0, z = 0, B = 1, L = [], K = [], V = {}, $ = x.selectionPalette.slice(0), W = x.maxSelectionSize, X = "sp-dragging", Y = null, G = c.ownerDocument, Q = (G.body, t(c)), J = !1, U = t(s, G).addClass(P), Z = U.find(".sp-picker-container"), tt = U.find(".sp-color"), et = U.find(".sp-dragger"), rt = U.find(".sp-hue"), at = U.find(".sp-slider"), nt = U.find(".sp-alpha-inner"), it = U.find(".sp-alpha"), ot = U.find(".sp-alpha-handle"), st = U.find(".sp-input"), lt = U.find(".sp-palette"), ct = U.find(".sp-initial"), ft = U.find(".sp-cancel"), ht = U.find(".sp-clear"), ut = U.find(".sp-choose"), dt = U.find(".sp-palette-toggle"), pt = Q.is("input"), gt = pt && "color" === Q.attr("type") && p(), bt = pt && !k, vt = bt ? t(o).addClass(P).addClass(x.className).addClass(x.replacerClassName) : t([]), mt = bt ? vt : Q, yt = vt.find(".sp-preview-inner"), wt = x.color || pt && Q.val(), _t = !1, xt = x.preferredFormat, kt = !x.showButtons || x.clickoutFiresChange, St = !wt, Ct = x.allowEmpty && !gt; function Pt() { if (x.showPaletteOnly && (x.showPalette = !0), dt.text(x.showPaletteOnly ? x.togglePaletteMoreText : x.togglePaletteLessText), x.palette) { L = x.palette.slice(0), K = Array.isArray(L[0]) ? L : [L], V = {}; for (var e = 0; e < K.length; e++)for (var r = 0; r < K[e].length; r++) { var a = tinycolor(K[e][r]).toRgbString(); V[a] = !0 } } U.toggleClass("sp-flat", k), U.toggleClass("sp-input-disabled", !x.showInput), U.toggleClass("sp-alpha-enabled", x.showAlpha), U.toggleClass("sp-clear-enabled", Ct), U.toggleClass("sp-buttons-disabled", !x.showButtons), U.toggleClass("sp-palette-buttons-disabled", !x.togglePaletteOnly), U.toggleClass("sp-palette-disabled", !x.showPalette), U.toggleClass("sp-palette-only", x.showPaletteOnly), U.toggleClass("sp-initial-disabled", !x.showInitial), U.addClass(x.className).addClass(x.containerClassName), Wt() } function At() { if (C && window.localStorage) { try { var e = window.localStorage[C].split(",#"); e.length > 1 && (delete window.localStorage[C], t.each(e, function (t, e) { Mt(e) })) } catch (t) { } try { $ = window.localStorage[C].split(";") } catch (t) { } } } function Mt(e) { if (S) { var r = tinycolor(e).toRgbString(); if (!V[r] && -1 === t.inArray(r, $)) for ($.push(r); $.length > W;)$.shift(); if (C && window.localStorage) try { window.localStorage[C] = $.join(";") } catch (t) { } } } function Rt() { var e = Bt(), r = t.map(K, function (t, r) { return l(t, e, "sp-palette-row sp-palette-row-" + r, x) }); At(), $ && r.push(l(function () { var t = []; if (x.showPalette) for (var e = 0; e < $.length; e++) { var r = tinycolor($[e]).toRgbString(); V[r] || t.push($[e]) } return t.reverse().slice(0, x.maxSelectionSize) }(), e, "sp-palette-row sp-palette-row-selection", x)), lt.html(r.join("")) } function Ht() { if (x.showInitial) { var t = _t, e = Bt(); ct.html(l([t, e], e, "sp-palette-row-initial", x)) } } function Ft() { (T <= 0 || F <= 0 || q <= 0) && Wt(), H = !0, U.addClass(X), Y = null, Q.trigger("dragstart.spectrum", [Bt()]) } function Tt() { H = !1, U.removeClass(X), Q.trigger("dragstop.spectrum", [Bt()]) } function Ot() { var t = st.val(); if (null !== t && "" !== t || !Ct) { var e = tinycolor(t); e.isValid() ? (zt(e), Lt(), $t()) : st.addClass("sp-validation-error") } else zt(null), Lt(), $t() } function qt() { R ? Dt() : Nt() } function Nt() { var e = t.Event("beforeShow.spectrum"); R ? Wt() : (Q.trigger(e, [Bt()]), !1 === A.beforeShow(Bt()) || e.isDefaultPrevented() || (!function () { for (var t = 0; t < a.length; t++)a[t] && a[t].hide() }(), R = !0, t(G).on("keydown.spectrum", jt), t(G).on("click.spectrum", Et), t(window).on("resize.spectrum", M), vt.addClass("sp-active"), U.removeClass("sp-hidden"), Wt(), Kt(), _t = Bt(), Ht(), A.show(_t), Q.trigger("show.spectrum", [_t]))) } function jt(t) { 27 === t.keyCode && Dt() } function Et(t) { 2 != t.button && (H || (kt ? $t(!0) : It(), Dt())) } function Dt() { R && !k && (R = !1, t(G).off("keydown.spectrum", jt), t(G).off("click.spectrum", Et), t(window).off("resize.spectrum", M), vt.removeClass("sp-active"), U.addClass("sp-hidden"), A.hide(Bt()), Q.trigger("hide.spectrum", [Bt()])) } function It() { zt(_t, !0), $t(!0) } function zt(t, e) { var r, a; tinycolor.equals(t, Bt()) ? Kt() : (!t && Ct ? St = !0 : (St = !1, a = (r = tinycolor(t)).toHsv(), D = a.h % 360 / 360, I = a.s, z = a.v, B = a.a), Kt(), r && r.isValid() && !e && (xt = x.preferredFormat || r.getFormat())) } function Bt(t) { return t = t || {}, Ct && St ? null : tinycolor.fromRatio({ h: D, s: I, v: z, a: Math.round(1e3 * B) / 1e3 }, { format: t.format || xt }) } function Lt() { Kt(), A.move(Bt()), Q.trigger("move.spectrum", [Bt()]) } function Kt() { st.removeClass("sp-validation-error"), Vt(); var t = tinycolor.fromRatio({ h: D, s: 1, v: 1 }); tt.css("background-color", t.toHexString()); var e = xt; B < 1 && (0 !== B || "name" !== e) && ("hex" !== e && "hex3" !== e && "hex6" !== e && "name" !== e || (e = "rgb")); var r = Bt({ format: e }), a = ""; if (yt.removeClass("sp-clear-display"), yt.css("background-color", "transparent"), !r && Ct) yt.addClass("sp-clear-display"); else { var o = r.toHexString(), s = r.toRgbString(); if (i || 1 === r.alpha ? yt.css("background-color", s) : (yt.css("background-color", "transparent"), yt.css("filter", r.toFilter())), x.showAlpha) { var l = r.toRgb(); l.a = 0; var c = tinycolor(l).toRgbString(), f = "linear-gradient(left, " + c + ", " + o + ")"; n ? nt.css("filter", tinycolor(c).toFilter({ gradientType: 1 }, o)) : (nt.css("background", "-webkit-" + f), nt.css("background", "-moz-" + f), nt.css("background", "-ms-" + f), nt.css("background", "linear-gradient(to right, " + c + ", " + o + ")")) } a = r.toString(e) } x.showInput && st.val(a), x.showPalette && Rt(), Ht() } function Vt() { var t = I, e = z; if (Ct && St) ot.hide(), at.hide(), et.hide(); else { ot.show(), at.show(), et.show(); var r = t * F, a = T - e * T; r = Math.max(-O, Math.min(F - O, r - O)), a = Math.max(-O, Math.min(T - O, a - O)), et.css({ top: a + "px", left: r + "px" }); var n = B * N; ot.css({ left: n - j / 2 + "px" }); var i = D * q; at.css({ top: i - E + "px" }) } } function $t(t) { var e = Bt(), r = "", a = !tinycolor.equals(e, _t); e && (r = e.toString(xt), Mt(e)), pt && Q.val(r), t && a && (A.change(e), Q.trigger("change", [e])) } function Wt() { var e, r, a, n, i, o, s, l, c, f, h, u; R && (F = tt.width(), T = tt.height(), O = et.height(), rt.width(), q = rt.height(), E = at.height(), N = it.width(), j = ot.width(), k || (U.css("position", "absolute"), x.offset ? U.offset(x.offset) : U.offset((r = mt, a = (e = U).outerWidth(), n = e.outerHeight(), i = r.outerHeight(), o = e[0].ownerDocument, s = o.documentElement, l = s.clientWidth + t(o).scrollLeft(), c = s.clientHeight + t(o).scrollTop(), f = r.offset(), h = f.left, u = f.top, u += i, h -= Math.min(h, h + a > l && l > a ? Math.abs(h + a - l) : 0), { top: u -= Math.min(u, u + n > c && c > n ? Math.abs(n + i - 0) : 0), bottom: f.bottom, left: h, right: f.right, width: f.width, height: f.height }))), Vt(), x.showPalette && Rt(), Q.trigger("reflow.spectrum")) } function Xt() { Dt(), J = !0, Q.attr("disabled", !0), mt.addClass("sp-disabled") } !function () { if (n && U.find("*:not(input)").attr("unselectable", "on"), Pt(), bt && Q.after(vt).hide(), Ct || ht.hide(), k) Q.after(U).hide(); else { var e = "parent" === x.appendTo ? Q.parent() : t(x.appendTo); 1 !== e.length && (e = t("body")), e.append(U) } function r(e) { return e.data && e.data.ignore ? (zt(t(e.target).closest(".sp-thumb-el").data("color")), Lt()) : (zt(t(e.target).closest(".sp-thumb-el").data("color")), Lt(), x.hideAfterPaletteSelect ? ($t(!0), Dt()) : $t()), !1 } At(), mt.on("click.spectrum touchstart.spectrum", function (e) { J || qt(), e.stopPropagation(), t(e.target).is("input") || e.preventDefault() }), (Q.is(":disabled") || !0 === x.disabled) && Xt(), U.click(h), st.change(Ot), st.on("paste", function () { setTimeout(Ot, 1) }), st.keydown(function (t) { 13 == t.keyCode && Ot() }), ft.text(x.cancelText), ft.on("click.spectrum", function (t) { t.stopPropagation(), t.preventDefault(), It(), Dt() }), ht.attr("title", x.clearText), ht.on("click.spectrum", function (t) { t.stopPropagation(), t.preventDefault(), St = !0, Lt(), k && $t(!0) }), ut.text(x.chooseText), ut.on("click.spectrum", function (t) { t.stopPropagation(), t.preventDefault(), n && st.is(":focus") && st.trigger("change"), st.hasClass("sp-validation-error") || ($t(!0), Dt()) }), dt.text(x.showPaletteOnly ? x.togglePaletteMoreText : x.togglePaletteLessText), dt.on("click.spectrum", function (t) { t.stopPropagation(), t.preventDefault(), x.showPaletteOnly = !x.showPaletteOnly, x.showPaletteOnly || k || U.css("left", "-=" + (Z.outerWidth(!0) + 5)), Pt() }), d(it, function (t, e, r) { B = t / N, St = !1, r.shiftKey && (B = Math.round(10 * B) / 10), Lt() }, Ft, Tt), d(rt, function (t, e) { D = parseFloat(e / q), St = !1, x.showAlpha || (B = 1), Lt() }, Ft, Tt), d(tt, function (t, e, r) { if (r.shiftKey) { if (!Y) { var a = I * F, n = T - z * T, i = Math.abs(t - a) > Math.abs(e - n); Y = i ? "x" : "y" } } else Y = null; var o = !Y || "y" === Y; (!Y || "x" === Y) && (I = parseFloat(t / F)), o && (z = parseFloat((T - e) / T)), St = !1, x.showAlpha || (B = 1), Lt() }, Ft, Tt), wt ? (zt(wt), Kt(), xt = x.preferredFormat || tinycolor(wt).format, Mt(wt)) : Kt(), k && Nt(); var a = n ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum"; lt.on(a, ".sp-thumb-el", r), ct.on(a, ".sp-thumb-el:nth-child(1)", { ignore: !0 }, r) }(); var Yt = { show: Nt, hide: Dt, toggle: qt, reflow: Wt, option: function (r, a) { return r === e ? t.extend({}, x) : a === e ? x[r] : (x[r] = a, "preferredFormat" === r && (xt = x.preferredFormat), void Pt()) }, enable: function () { J = !1, Q.attr("disabled", !1), mt.removeClass("sp-disabled") }, disable: Xt, offset: function (t) { x.offset = t, Wt() }, set: function (t) { zt(t), $t() }, get: Bt, destroy: function () { Q.show(), mt.off("click.spectrum touchstart.spectrum"), U.remove(), vt.remove(), a[Yt.id] = null }, container: U }; return Yt.id = a.push(Yt) - 1, Yt } function f() { } function h(t) { t.stopPropagation() } function u(t, e) { var r = Array.prototype.slice, a = r.call(arguments, 2); return function () { return t.apply(e, a.concat(r.call(arguments))) } } function d(e, r, a, i) { r = r || function () { }, a = a || function () { }, i = i || function () { }; var o = document, s = !1, l = {}, c = 0, f = 0, h = "ontouchstart" in window, u = {}; function d(t) { t.stopPropagation && t.stopPropagation(), t.preventDefault && t.preventDefault(), t.returnValue = !1 } function p(t) { if (s) { if (n && o.documentMode < 9 && !t.button) return g(); var a = t.originalEvent && t.originalEvent.touches && t.originalEvent.touches[0], i = a && a.pageX || t.pageX, u = a && a.pageY || t.pageY, p = Math.max(0, Math.min(i - l.left, f)), b = Math.max(0, Math.min(u - l.top, c)); h && d(t), r.apply(e, [p, b, t]) } } function g() { s && (t(o).off(u), t(o.body).removeClass("sp-dragging"), setTimeout(function () { i.apply(e, arguments) }, 0)), s = !1 } u.selectstart = d, u.dragstart = d, u["touchmove mousemove"] = p, u["touchend mouseup"] = g, t(e).on("touchstart mousedown", function (r) { (r.which ? 3 == r.which : 2 == r.button) || s || !1 !== a.apply(e, arguments) && (s = !0, c = t(e).height(), f = t(e).width(), l = t(e).offset(), t(o).on(u), t(o.body).addClass("sp-dragging"), p(r), d(r)) }) } function p() { return t.fn.spectrum.inputTypeColorSupport() } var g = "spectrum.id"; t.fn.spectrum = function (e, r) { if ("string" == typeof e) { var n = this, i = Array.prototype.slice.call(arguments, 1); return this.each(function () { var r = a[t(this).data(g)]; if (r) { var o = r[e]; if (!o) throw new Error("Spectrum: no such method: '" + e + "'"); "get" == e ? n = r.get() : "container" == e ? n = r.container : "option" == e ? n = r.option.apply(r, i) : "destroy" == e ? (r.destroy(), t(this).removeData(g)) : o.apply(r, i) } }), n } return this.spectrum("destroy").each(function () { var r = c(this, t.extend({}, t(this).data(), e)); t(this).data(g, r.id) }) }, t.fn.spectrum.load = !0, t.fn.spectrum.loadOpts = {}, t.fn.spectrum.draggable = d, t.fn.spectrum.defaults = r, t.fn.spectrum.inputTypeColorSupport = function e() { if (void 0 === e._cachedResult) { var r = t("<input type='color'/>")[0]; e._cachedResult = "color" === r.type && "" !== r.value } return e._cachedResult }, t.spectrum = {}, t.spectrum.localization = {}, t.spectrum.palettes = {}, t.fn.spectrum.processNativeColorInputs = function () { var e = t("input[type=color]"); e.length && !p() && e.spectrum({ preferredFormat: "hex6" }) }, function () { var t = /^[\s,#]+/, e = /\s+$/, r = 0, a = Math, n = a.round, i = a.min, o = a.max, s = a.random, l = function (s, c) { if (s = s || "", c = c || {}, s instanceof l) return s; if (!(this instanceof l)) return new l(s, c); var f = function (r) { var n = { r: 0, g: 0, b: 0 }, s = 1, l = !1, c = !1; "string" == typeof r && (r = function (r) { r = r.replace(t, "").replace(e, "").toLowerCase(); var a, n = !1; if (P[r]) r = P[r], n = !0; else if ("transparent" == r) return { r: 0, g: 0, b: 0, a: 0, format: "name" }; if (a = E.rgb.exec(r)) return { r: a[1], g: a[2], b: a[3] }; if (a = E.rgba.exec(r)) return { r: a[1], g: a[2], b: a[3], a: a[4] }; if (a = E.hsl.exec(r)) return { h: a[1], s: a[2], l: a[3] }; if (a = E.hsla.exec(r)) return { h: a[1], s: a[2], l: a[3], a: a[4] }; if (a = E.hsv.exec(r)) return { h: a[1], s: a[2], v: a[3] }; if (a = E.hsva.exec(r)) return { h: a[1], s: a[2], v: a[3], a: a[4] }; if (a = E.hex8.exec(r)) return { a: (i = a[1], F(i) / 255), r: F(a[2]), g: F(a[3]), b: F(a[4]), format: n ? "name" : "hex8" }; var i; if (a = E.hex6.exec(r)) return { r: F(a[1]), g: F(a[2]), b: F(a[3]), format: n ? "name" : "hex" }; if (a = E.hex3.exec(r)) return { r: F(a[1] + "" + a[1]), g: F(a[2] + "" + a[2]), b: F(a[3] + "" + a[3]), format: n ? "name" : "hex" }; return !1 }(r)); "object" == typeof r && (r.hasOwnProperty("r") && r.hasOwnProperty("g") && r.hasOwnProperty("b") ? (f = r.r, h = r.g, u = r.b, n = { r: 255 * R(f, 255), g: 255 * R(h, 255), b: 255 * R(u, 255) }, l = !0, c = "%" === String(r.r).substr(-1) ? "prgb" : "rgb") : r.hasOwnProperty("h") && r.hasOwnProperty("s") && r.hasOwnProperty("v") ? (r.s = O(r.s), r.v = O(r.v), n = function (t, e, r) { t = 6 * R(t, 360), e = R(e, 100), r = R(r, 100); var n = a.floor(t), i = t - n, o = r * (1 - e), s = r * (1 - i * e), l = r * (1 - (1 - i) * e), c = n % 6; return { r: 255 * [r, s, o, o, l, r][c], g: 255 * [l, r, r, s, o, o][c], b: 255 * [o, o, l, r, r, s][c] } }(r.h, r.s, r.v), l = !0, c = "hsv") : r.hasOwnProperty("h") && r.hasOwnProperty("s") && r.hasOwnProperty("l") && (r.s = O(r.s), r.l = O(r.l), n = function (t, e, r) { var a, n, i; function o(t, e, r) { return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + 6 * (e - t) * r : r < .5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t } if (t = R(t, 360), e = R(e, 100), r = R(r, 100), 0 === e) a = n = i = r; else { var s = r < .5 ? r * (1 + e) : r + e - r * e, l = 2 * r - s; a = o(l, s, t + 1 / 3), n = o(l, s, t), i = o(l, s, t - 1 / 3) } return { r: 255 * a, g: 255 * n, b: 255 * i } }(r.h, r.s, r.l), l = !0, c = "hsl"), r.hasOwnProperty("a") && (s = r.a)); var f, h, u; return s = M(s), { ok: l, format: r.format || c, r: i(255, o(n.r, 0)), g: i(255, o(n.g, 0)), b: i(255, o(n.b, 0)), a: s } }(s); this._originalInput = s, this._r = f.r, this._g = f.g, this._b = f.b, this._a = f.a, this._roundA = n(1e3 * this._a) / 1e3, this._format = c.format || f.format, this._gradientType = c.gradientType, this._r < 1 && (this._r = n(this._r)), this._g < 1 && (this._g = n(this._g)), this._b < 1 && (this._b = n(this._b)), this._ok = f.ok, this._tc_id = r++ }; function c(t, e, r) { t = R(t, 255), e = R(e, 255), r = R(r, 255); var a, n, s = o(t, e, r), l = i(t, e, r), c = (s + l) / 2; if (s == l) a = n = 0; else { var f = s - l; switch (n = c > .5 ? f / (2 - s - l) : f / (s + l), s) { case t: a = (e - r) / f + (e < r ? 6 : 0); break; case e: a = (r - t) / f + 2; break; case r: a = (t - e) / f + 4 }a /= 6 } return { h: a, s: n, l: c } } function f(t, e, r) { t = R(t, 255), e = R(e, 255), r = R(r, 255); var a, n, s = o(t, e, r), l = i(t, e, r), c = s, f = s - l; if (n = 0 === s ? 0 : f / s, s == l) a = 0; else { switch (s) { case t: a = (e - r) / f + (e < r ? 6 : 0); break; case e: a = (r - t) / f + 2; break; case r: a = (t - e) / f + 4 }a /= 6 } return { h: a, s: n, v: c } } function h(t, e, r, a) { var i = [T(n(t).toString(16)), T(n(e).toString(16)), T(n(r).toString(16))]; return a && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("") } function u(t, e, r, a) { var i; return [T((i = a, Math.round(255 * parseFloat(i)).toString(16))), T(n(t).toString(16)), T(n(e).toString(16)), T(n(r).toString(16))].join("") } function d(t, e) { e = 0 === e ? 0 : e || 10; var r = l(t).toHsl(); return r.s -= e / 100, r.s = H(r.s), l(r) } function p(t, e) { e = 0 === e ? 0 : e || 10; var r = l(t).toHsl(); return r.s += e / 100, r.s = H(r.s), l(r) } function g(t) { return l(t).desaturate(100) } function b(t, e) { e = 0 === e ? 0 : e || 10; var r = l(t).toHsl(); return r.l += e / 100, r.l = H(r.l), l(r) } function v(t, e) { e = 0 === e ? 0 : e || 10; var r = l(t).toRgb(); return r.r = o(0, i(255, r.r - n(-e / 100 * 255))), r.g = o(0, i(255, r.g - n(-e / 100 * 255))), r.b = o(0, i(255, r.b - n(-e / 100 * 255))), l(r) } function m(t, e) { e = 0 === e ? 0 : e || 10; var r = l(t).toHsl(); return r.l -= e / 100, r.l = H(r.l), l(r) } function y(t, e) { var r = l(t).toHsl(), a = (n(r.h) + e) % 360; return r.h = a < 0 ? 360 + a : a, l(r) } function w(t) { var e = l(t).toHsl(); return e.h = (e.h + 180) % 360, l(e) } function _(t) { var e = l(t).toHsl(), r = e.h; return [l(t), l({ h: (r + 120) % 360, s: e.s, l: e.l }), l({ h: (r + 240) % 360, s: e.s, l: e.l })] } function x(t) { var e = l(t).toHsl(), r = e.h; return [l(t), l({ h: (r + 90) % 360, s: e.s, l: e.l }), l({ h: (r + 180) % 360, s: e.s, l: e.l }), l({ h: (r + 270) % 360, s: e.s, l: e.l })] } function k(t) { var e = l(t).toHsl(), r = e.h; return [l(t), l({ h: (r + 72) % 360, s: e.s, l: e.l }), l({ h: (r + 216) % 360, s: e.s, l: e.l })] } function S(t, e, r) { e = e || 6, r = r || 30; var a = l(t).toHsl(), n = 360 / r, i = [l(t)]; for (a.h = (a.h - (n * e >> 1) + 720) % 360; --e;)a.h = (a.h + n) % 360, i.push(l(a)); return i } function C(t, e) { e = e || 6; for (var r = l(t).toHsv(), a = r.h, n = r.s, i = r.v, o = [], s = 1 / e; e--;)o.push(l({ h: a, s: n, v: i })), i = (i + s) % 1; return o } l.prototype = { isDark: function () { return this.getBrightness() < 128 }, isLight: function () { return !this.isDark() }, isValid: function () { return this._ok }, getOriginalInput: function () { return this._originalInput }, getFormat: function () { return this._format }, getAlpha: function () { return this._a }, getBrightness: function () { var t = this.toRgb(); return (299 * t.r + 587 * t.g + 114 * t.b) / 1e3 }, setAlpha: function (t) { return this._a = M(t), this._roundA = n(1e3 * this._a) / 1e3, this }, toHsv: function () { var t = f(this._r, this._g, this._b); return { h: 360 * t.h, s: t.s, v: t.v, a: this._a } }, toHsvString: function () { var t = f(this._r, this._g, this._b), e = n(360 * t.h), r = n(100 * t.s), a = n(100 * t.v); return 1 == this._a ? "hsv(" + e + ", " + r + "%, " + a + "%)" : "hsva(" + e + ", " + r + "%, " + a + "%, " + this._roundA + ")" }, toHsl: function () { var t = c(this._r, this._g, this._b); return { h: 360 * t.h, s: t.s, l: t.l, a: this._a } }, toHslString: function () { var t = c(this._r, this._g, this._b), e = n(360 * t.h), r = n(100 * t.s), a = n(100 * t.l); return 1 == this._a ? "hsl(" + e + ", " + r + "%, " + a + "%)" : "hsla(" + e + ", " + r + "%, " + a + "%, " + this._roundA + ")" }, toHex: function (t) { return h(this._r, this._g, this._b, t) }, toHexString: function (t) { return "#" + this.toHex(t) }, toHex8: function () { return u(this._r, this._g, this._b, this._a) }, toHex8String: function () { return "#" + this.toHex8() }, toRgb: function () { return { r: n(this._r), g: n(this._g), b: n(this._b), a: this._a } }, toRgbString: function () { return 1 == this._a ? "rgb(" + n(this._r) + ", " + n(this._g) + ", " + n(this._b) + ")" : "rgba(" + n(this._r) + ", " + n(this._g) + ", " + n(this._b) + ", " + this._roundA + ")" }, toPercentageRgb: function () { return { r: n(100 * R(this._r, 255)) + "%", g: n(100 * R(this._g, 255)) + "%", b: n(100 * R(this._b, 255)) + "%", a: this._a } }, toPercentageRgbString: function () { return 1 == this._a ? "rgb(" + n(100 * R(this._r, 255)) + "%, " + n(100 * R(this._g, 255)) + "%, " + n(100 * R(this._b, 255)) + "%)" : "rgba(" + n(100 * R(this._r, 255)) + "%, " + n(100 * R(this._g, 255)) + "%, " + n(100 * R(this._b, 255)) + "%, " + this._roundA + ")" }, toName: function () { return 0 === this._a ? "transparent" : !(this._a < 1) && (A[h(this._r, this._g, this._b, !0)] || !1) }, toFilter: function (t) { var e = "#" + u(this._r, this._g, this._b, this._a), r = e, a = this._gradientType ? "GradientType = 1, " : ""; t && (r = l(t).toHex8String()); return "progid:DXImageTransform.Microsoft.gradient(" + a + "startColorstr=" + e + ",endColorstr=" + r + ")" }, toString: function (t) { var e = !!t; t = t || this._format; var r = !1, a = this._a < 1 && this._a >= 0; return e || !a || "hex" !== t && "hex6" !== t && "hex3" !== t && "name" !== t ? ("rgb" === t && (r = this.toRgbString()), "prgb" === t && (r = this.toPercentageRgbString()), "hex" !== t && "hex6" !== t || (r = this.toHexString()), "hex3" === t && (r = this.toHexString(!0)), "hex8" === t && (r = this.toHex8String()), "name" === t && (r = this.toName()), "hsl" === t && (r = this.toHslString()), "hsv" === t && (r = this.toHsvString()), r || this.toHexString()) : "name" === t && 0 === this._a ? this.toName() : this.toRgbString() }, _applyModification: function (t, e) { var r = t.apply(null, [this].concat([].slice.call(e))); return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this }, lighten: function () { return this._applyModification(b, arguments) }, brighten: function () { return this._applyModification(v, arguments) }, darken: function () { return this._applyModification(m, arguments) }, desaturate: function () { return this._applyModification(d, arguments) }, saturate: function () { return this._applyModification(p, arguments) }, greyscale: function () { return this._applyModification(g, arguments) }, spin: function () { return this._applyModification(y, arguments) }, _applyCombination: function (t, e) { return t.apply(null, [this].concat([].slice.call(e))) }, analogous: function () { return this._applyCombination(S, arguments) }, complement: function () { return this._applyCombination(w, arguments) }, monochromatic: function () { return this._applyCombination(C, arguments) }, splitcomplement: function () { return this._applyCombination(k, arguments) }, triad: function () { return this._applyCombination(_, arguments) }, tetrad: function () { return this._applyCombination(x, arguments) } }, l.fromRatio = function (t, e) { if ("object" == typeof t) { var r = {}; for (var a in t) t.hasOwnProperty(a) && (r[a] = "a" === a ? t[a] : O(t[a])); t = r } return l(t, e) }, l.equals = function (t, e) { return !(!t || !e) && l(t).toRgbString() == l(e).toRgbString() }, l.random = function () { return l.fromRatio({ r: s(), g: s(), b: s() }) }, l.mix = function (t, e, r) { r = 0 === r ? 0 : r || 50; var a, n = l(t).toRgb(), i = l(e).toRgb(), o = r / 100, s = 2 * o - 1, c = i.a - n.a, f = 1 - (a = ((a = s * c == -1 ? s : (s + c) / (1 + s * c)) + 1) / 2), h = { r: i.r * a + n.r * f, g: i.g * a + n.g * f, b: i.b * a + n.b * f, a: i.a * o + n.a * (1 - o) }; return l(h) }, l.readability = function (t, e) { var r = l(t), a = l(e), n = r.toRgb(), i = a.toRgb(), o = r.getBrightness(), s = a.getBrightness(), c = Math.max(n.r, i.r) - Math.min(n.r, i.r) + Math.max(n.g, i.g) - Math.min(n.g, i.g) + Math.max(n.b, i.b) - Math.min(n.b, i.b); return { brightness: Math.abs(o - s), color: c } }, l.isReadable = function (t, e) { var r = l.readability(t, e); return r.brightness > 125 && r.color > 500 }, l.mostReadable = function (t, e) { for (var r = null, a = 0, n = !1, i = 0; i < e.length; i++) { var o = l.readability(t, e[i]), s = o.brightness > 125 && o.color > 500, c = o.brightness / 125 * 3 + o.color / 500; (s && !n || s && n && c > a || !s && !n && c > a) && (n = s, a = c, r = l(e[i])) } return r }; var P = l.names = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "0ff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000", blanchedalmond: "ffebcd", blue: "00f", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", burntsienna: "ea7e5d", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "0ff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkgrey: "a9a9a9", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "f0f", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", grey: "808080", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3", lightgreen: "90ee90", lightgrey: "d3d3d3", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslategray: "789", lightslategrey: "789", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "0f0", limegreen: "32cd32", linen: "faf0e6", magenta: "f0f", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370db", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "db7093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", rebeccapurple: "663399", red: "f00", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", slategrey: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", wheat: "f5deb3", white: "fff", whitesmoke: "f5f5f5", yellow: "ff0", yellowgreen: "9acd32" }, A = l.hexNames = function (t) { var e = {}; for (var r in t) t.hasOwnProperty(r) && (e[t[r]] = r); return e }(P); function M(t) { return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t } function R(t, e) { var r; "string" == typeof (r = t) && -1 != r.indexOf(".") && 1 === parseFloat(r) && (t = "100%"); var n, s = "string" == typeof (n = t) && -1 != n.indexOf("%"); return t = i(e, o(0, parseFloat(t))), s && (t = parseInt(t * e, 10) / 100), a.abs(t - e) < 1e-6 ? 1 : t % e / parseFloat(e) } function H(t) { return i(1, o(0, t)) } function F(t) { return parseInt(t, 16) } function T(t) { return 1 == t.length ? "0" + t : "" + t } function O(t) { return t <= 1 && (t = 100 * t + "%"), t } var q, N, j, E = (N = "[\\s|\\(]+(" + (q = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)") + ")[,|\\s]+(" + q + ")[,|\\s]+(" + q + ")\\s*\\)?", j = "[\\s|\\(]+(" + q + ")[,|\\s]+(" + q + ")[,|\\s]+(" + q + ")[,|\\s]+(" + q + ")\\s*\\)?", { rgb: new RegExp("rgb" + N), rgba: new RegExp("rgba" + j), hsl: new RegExp("hsl" + N), hsla: new RegExp("hsla" + j), hsv: new RegExp("hsv" + N), hsva: new RegExp("hsva" + j), hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/, hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/ }); window.tinycolor = l }(), t(function () { t.fn.spectrum.load && t.fn.spectrum.processNativeColorInputs() }) });;
(
    function (skyward, $, undefined)
    {
        skyward.keys = skyward.keys || {};

        var keysByCode =
        {
            0:
            {
                name: "That key has no keycode",
                value: undefined
            },
            3:
            {
                name: "break",
                value: undefined
            },
            8:
            {
                name: "backspace / delete",
                value: "\b"
            },
            9:
            {
                name: "tab",
                value: "\t"
            },
            12:
            {
                name: 'clear',
                value: undefined
            },
            13:
            {
                name: "enter",
                value: "\r\n"
            },
            16:
            {
                name: "shift",
                value: undefined
            },
            17:
            {
                name: "ctrl",
                value: undefined
            },
            18:
            {
                name: "alt",
                value: undefined
            },
            19:
            {
                name: "pause/break",
                value: undefined
            },
            20:
            {
                name: "caps lock",
                value: undefined
            },
            21:
            {
                name: "hangul",
                value: undefined
            },
            25:
            {
                name: "hanja",
                value: undefined
            },
            27:
            {
                name: "escape",
                value: undefined
            },
            28:
            {
                name: "conversion",
                value: undefined
            },
            29:
            {
                name: "non-conversion",
                value: undefined
            },
            32:
            {
                name: "spacebar",
                value: " "
            },
            33:
            {
                name: "page up",
                value: undefined
            },
            34:
            {
                name: "page down",
                value: undefined
            },
            35:
            {
                name: "end",
                value: undefined
            },
            36:
            {
                name: "home",
                value: undefined
            },
            37:
            {
                name: "left arrow",
                value: undefined
            },
            38:
            {
                name: "up arrow",
                value: undefined
            },
            39:
            {
                name: "right arrow",
                value: undefined
            },
            40:
            {
                name: "down arrow",
                value: undefined
            },
            41:
            {
                name: "select",
                value: undefined
            },
            42:
            {
                name: "print",
                value: undefined
            },
            43:
            {
                name: "execute",
                value: undefined
            },
            44:
            {
                name: "Print Screen",
                value: undefined
            },
            45:
            {
                name: "insert",
                value: undefined
            },
            46:
            {
                name: "delete",
                value: undefined
            },
            47:
            {
                name: "help",
                value: undefined
            },
            48:
            {
                name: "0",
                value: "0"
            },
            49:
            {
                name: "1",
                value: "1"
            },
            50:
            {
                name: "2",
                value: "2"
            },
            51:
            {
                name: "3",
                value: "3"
            },
            52:
            {
                name: "4",
                value: "4"
            },
            53:
            {
                name: "5",
                value: "5"
            },
            54:
            {
                name: "6",
                value: "6"
            },
            55:
            {
                name: "7",
                value: "7"
            },
            56:
            {
                name: "8",
                value: "8"
            },
            57:
            {
                name: "9",
                value: "9"
            },
            58:
            {
                name: ":",
                value: ":"
            },
            59:
            {
                name: "semicolon (firefox), equals",
                value: ";"
            },
            60:
            {
                name: "<",
                value: "<"
            },
            61:
            {
                name: "equals (firefox)",
                value: "="
            },
            63:
            {
                name: "ß",
                value: "ß"
            },
            64:
            {
                name: "@ (firefox)",
                value: "@"
            },
            65:
            {
                name: "a",
                value: "a"
            },
            66:
            {
                name: "b",
                value: "b"
            },
            67:
            {
                name: "c",
                value: "c"
            },
            68:
            {
                name: "d",
                value: "d"
            },
            69:
            {
                name: "e",
                value: "e"
            },
            70:
            {
                name: "f",
                value: "f"
            },
            71:
            {
                name: "g",
                value: "g"
            },
            72:
            {
                name: "h",
                value: "h"
            },
            73:
            {
                name: "i",
                value: "i"
            },
            74:
            {
                name: "j",
                value: "j"
            },
            75:
            {
                name: "k",
                value: "k"
            },
            76:
            {
                name: "l",
                value: "l"
            },
            77:
            {
                name: "m",
                value: "m"
            },
            78:
            {
                name: "n",
                value: "n"
            },
            79:
            {
                name: "o",
                value: "o"
            },
            80:
            {
                name: "p",
                value: "p"
            },
            81:
            {
                name: "q",
                value: "q"
            },
            82:
            {
                name: "r",
                value: "r"
            },
            83:
            {
                name: "s",
                value: "s"
            },
            84:
            {
                name: "t",
                value: "t"
            },
            85:
            {
                name: "u",
                value: "u"
            },
            86:
            {
                name: "v",
                value: "v"
            },
            87:
            {
                name: "w",
                value: "w"
            },
            88:
            {
                name: "x",
                value: "x"
            },
            89:
            {
                name: "y",
                value: "y"
            },
            90:
            {
                name: "z",
                value: "z"
            },
            91:
            {
                name: "Windows Key / Left looped square / Chromebook Search key",
                value: undefined
            },
            92:
            {
                name: "right window key",
                value: undefined
            },
            93:
            {
                name: "Windows Menu / Right looped square",
                value: undefined
            },
            95:
            {
                name: "sleep",
                value: undefined
            },
            96:
            {
                name: "numpad 0",
                value: "0"
            },
            97:
            {
                name: "numpad 1",
                value: "1"
            },
            98:
            {
                name: "numpad 2",
                value: "2"
            },
            99:
            {
                name: "numpad 3",
                value: "3"
            },
            100:
            {
                name: "numpad 4",
                value: "4"
            },
            101:
            {
                name: "numpad 5",
                value: "5"
            },
            102:
            {
                name: "numpad 6",
                value: "6"
            },
            103:
            {
                name: "numpad 7",
                value: "7"
            },
            104:
            {
                name: "numpad 8",
                value: "8"
            },
            105:
            {
                name: "numpad 9",
                value: "9"
            },
            106:
            {
                name: "multiply",
                value: "*"
            },
            107:
            {
                name: "add",
                value: "+"
            },
            108:
            {
                name: "numpad period (firefox)",
                value: "."
            },
            109:
            {
                name: "subtract",
                value: "-"
            },
            110:
            {
                name: "decimal point",
                value: "."
            },
            111:
            {
                name: "divide",
                value: "/"
            },
            112:
            {
                name: "f1",
                value: undefined
            },
            113:
            {
                name: "f2",
                value: undefined
            },
            114:
            {
                name: "f3",
                value: undefined
            },
            115:
            {
                name: "f4",
                value: undefined
            },
            116:
            {
                name: "f5",
                value: undefined
            },
            117:
            {
                name: "f6",
                value: undefined
            },
            118:
            {
                name: "f7",
                value: undefined
            },
            119:
            {
                name: "f8",
                value: undefined
            },
            120:
            {
                name: "f9",
                value: undefined
            },
            121:
            {
                name: "f10",
                value: undefined
            },
            122:
            {
                name: "f11",
                value: undefined
            },
            123:
            {
                name: "f12",
                value: undefined
            },
            124:
            {
                name: "f13",
                value: undefined
            },
            125:
            {
                name: "f14",
                value: undefined
            },
            126:
            {
                name: "f15",
                value: undefined
            },
            127:
            {
                name: "f16",
                value: undefined
            },
            128:
            {
                name: "f17",
                value: undefined
            },
            129:
            {
                name: "f18",
                value: undefined
            },
            130:
            {
                name: "f19",
                value: undefined
            },
            131:
            {
                name: "f20",
                value: undefined
            },
            132:
            {
                name: "f21",
                value: undefined
            },
            133:
            {
                name: "f22",
                value: undefined
            },
            134:
            {
                name: "f23",
                value: undefined
            },
            135:
            {
                name: "f24",
                value: undefined
            },
            144:
            {
                name: "num lock",
                value: undefined
            },
            145:
            {
                name: "scroll lock",
                value: undefined
            },
            160:
            {
                name: "^",
                value: "^"
            },
            161:
            {
                name: "!",
                value: "!"
            },
            163:
            {
                name: "#",
                value: "#"
            },
            164:
            {
                name: "$",
                value: "$"
            },
            165:
            {
                name: "u with grave accent",
                value: undefined
            },
            166:
            {
                name: "page backward",
                value: undefined
            },
            167:
            {
                name: "page forward",
                value: undefined
            },
            168:
            {
                name: "refresh",
                value: undefined
            },
            169:
            {
                name: "closing paren (AZERTY)",
                value: ")"
            },
            170:
            {
                name: "*",
                value: "*"
            },
            171:
            {
                name: "~ + * key",
                value: "~"
            },
            172:
            {
                name: "home key",
                value: undefined
            },
            173:
            {
                name: "minus (firefox), mute/unmute",
                value: "-"
            },
            174:
            {
                name: "decrease volume level",
                value: undefined
            },
            175:
            {
                name: "increase volume level",
                value: undefined
            },
            176:
            {
                name: "next",
                value: undefined
            },
            177:
            {
                name: "previous",
                value: undefined
            },
            178:
            {
                name: "stop",
                value: undefined
            },
            179:
            {
                name: "play/pause",
                value: undefined
            },
            180:
            {
                name: "e-mail",
                value: undefined
            },
            181:
            {
                name: "mute/unmute (firefox)",
                value: undefined
            },
            182:
            {
                name: "decrease volume level (firefox)",
                value: undefined
            },
            183:
            {
                name: "increase volume level (firefox)",
                value: undefined
            },
            186:
            {
                name: "semi-colon / n with tilde",
                value: ";"
            },
            187:
            {
                name: "equal sign",
                value: "="
            },
            188:
            {
                name: "comma",
                value: ","
            },
            189:
            {
                name: "dash",
                value: "-"
            },
            190:
            {
                name: "period",
                value: "."
            },
            191:
            {
                name: "forward slash / cedilla",
                value: "/"
            },
            192:
            {
                name: "grave accent / n with tilde / ash / o with umlaut mark",
                value: "`"
            },
            193:
            {
                name: "?, / or degree sign",
                value: "?"
            },
            194:
            {
                name: "numpad period (chrome)",
                value: "."
            },
            219:
            {
                name: "open bracket",
                value: "["
            },
            220:
            {
                name: "back slash",
                value: "\\"
            },
            221:
            {
                name: "close bracket / a with ring above",
                value: "]"
            },
            222:
            {
                name: "single quote / slashed o / a with umlaut mark",
                value: "\'"
            },
            223:
            {
                name: "`",
                value: "`"
            },
            224:
            {
                name: "left or right looped square key (firefox)",
                value: undefined
            },
            225:
            {
                name: "altgr",
                value: undefined
            },
            226:
            {
                name: "< /git >, left back slash",
                value: "//"
            },
            230:
            {
                name: "GNOME Compose Key",
                value: undefined
            },
            231:
            {
                name: "cedilla",
                value: undefined
            },
            233:
            {
                name: "XF86Forward",
                value: undefined
            },
            234:
            {
                name: "XF86Back",
                value: undefined
            },
            240:
            {
                name: "alphanumeric",
                value: undefined
            },
            242:
            {
                name: "hiragana/katakana",
                value: undefined
            },
            243:
            {
                name: "half-width/full-width",
                value: undefined
            },
            244:
            {
                name: "kanji",
                value: undefined
            },
            255:
            {
                name: "toggle touchpad",
                value: undefined
            }
            };

        skyward.keys.globalShiftPressed = false;
        skyward.keys.globalCtrlPressed = false;
        skyward.keys.globalAltPressed = false;
        skyward.keys.globalMetaPressed = false;
        skyward.keys.globalPrimaryModifierPressed = false;
        skyward.keys.lastKeyUp = null;

        const macPlatformPattern = /(MacIntel|Mac68K|MacPPC|Macintosh|macOS)/i;
        skyward.keys.isMac = macPlatformPattern.test(navigator.userAgentData?.platform ?? "") || macPlatformPattern.test(navigator.platform);

        // The modifier for "modify this click" gestures: Command on Mac, where Ctrl+click opens the
        // context menu instead of clicking, and Ctrl everywhere else.
        skyward.keys.isPrimaryModifierPressed = function (event)
        {
            const modifierKey = skyward.keys.isMac ? event.metaKey : event.ctrlKey;
            return modifierKey === true;
        };

        const debounceMainMenuToggle = skyward.debounce(function ()
        {
            skyward.mainMenu.toggleMenu();
        }, 200);

        const globalDown = function (event)
        {
            if (!event)
            {
                return;
            }
            const keyStateChanges = getKeyStateChanges(event);

            setGlobalKeyValues(event);
            setBodyKeyClasses(event);

            $(document.body).trigger("keyStateChanged", { ...keyStateChanges, eventType: "keyDown" });

            var mKey = 77; // m key code

            // pressing alt and m opens the navigation menu
            if (skyward.keys.globalAltPressed && event.which == mKey)
            {
                debounceMainMenuToggle();
            }
            switch (event.which)
            {
                case 13:
                {
                    const activeElement = document.activeElement;
                    if (activeElement !== null && (activeElement.tagName == 'A' || activeElement.getAttribute("role") === "button"))
                    {
                        activateElement(activeElement);
                        return false;
                    }
                    break;
                }
            }
        };
        const globalUp = function (event)
        {
            if (!event)
            {
                return;
            }

            if (event.which)

            {

                skyward.keys.lastKeyUp = event.which;

            }



            const keyStateChanges = getKeyStateChanges(event);

            if (!keyStateChanges.changed)
            {
                return;
            }

            setGlobalKeyValues(event);
            setBodyKeyClasses(event);

            $(document.body).trigger("keyStateChanged", { ...keyStateChanges, eventType: "keyUp" });
        };

        // click() is defined on HTMLElement, not on Element, so an element in the SVG namespace that
        // carries role="button" does not have it. The date, time and date-time picker icons render as
        // <svg role="button" tabindex="-1"> because the Svg component spreads its attrs onto the svg
        // root, and clicking one focuses it in Chrome - so Enter used to throw here rather than press
        // the button. Dispatch the event for those instead of skipping them.
        const activateElement = function (element)
        {
            if (typeof element.click === "function")
            {
                element.click();
                return;
            }

            element.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
        };

        const setGlobalKeyValues = function (event)
        {
            skyward.keys.globalShiftPressed = event.shiftKey === true;
            skyward.keys.globalCtrlPressed = event.ctrlKey === true;
            skyward.keys.globalAltPressed = event.altKey === true;
            skyward.keys.globalMetaPressed = event.metaKey === true;
            skyward.keys.globalPrimaryModifierPressed = skyward.keys.isPrimaryModifierPressed(event);
            if (event.type == "keyup" && event.which)
            {
                skyward.keys.lastKeyUp = event.which;
            }
        }

        const getKeyStateChanges = function (event)
        {
            const shiftKeyStateChanged = skyward.keys.globalShiftPressed !== (event.shiftKey ?? false);
            const ctrlKeyStateChanged = skyward.keys.globalCtrlPressed !== (event.ctrlKey ?? false);
            const altKeyStateChanged = skyward.keys.globalAltPressed !== (event.altKey ?? false);
            const metaKeyStateChanged = skyward.keys.globalMetaPressed !== (event.metaKey ?? false);

            return {
                shiftKey: shiftKeyStateChanged,
                ctrlKey: ctrlKeyStateChanged,
                altKey: altKeyStateChanged,
                metaKey: metaKeyStateChanged,
                primaryModifierKey: skyward.keys.isMac ? metaKeyStateChanged : ctrlKeyStateChanged,
                changed: shiftKeyStateChanged || ctrlKeyStateChanged || altKeyStateChanged || metaKeyStateChanged
            };
        };

        const setBodyKeyClasses = function (event)
        {
            if (event)
            {
                $(document.body).toggleClass("shiftKey", skyward.keys.globalShiftPressed)
                    .toggleClass("ctrlKey", skyward.keys.globalCtrlPressed)
                    .toggleClass("altKey", skyward.keys.globalAltPressed)
                    .toggleClass("metaKey", skyward.keys.globalMetaPressed)
                    .toggleClass("primaryModifierKey", skyward.keys.globalPrimaryModifierPressed);
            }
        };

        skyward.keys.keyIsNumberOrLetter = function (shiftKey, keyCode)
        {
            if ((keyCode >= 96 && keyCode <= 105 || //numpad
                    keyCode >= 48 && keyCode <= 57 || //digits
                    keyCode >= 65 && keyCode <= 90) && //letters
                !(shiftKey && (keyCode >= 48 || keyCode <= 57))) //exclude symbols
            {
                return true;
            }

            return false;
        };

        /**
         * Accepts a keyCode value and returns true if that value is defined in keysByCode.
         * Backspace/Delete is also considered a printable character.
         * @param {any} keyCode - the value of the key being pressed to compare
         */
        skyward.keys.isPrintableCharacter = function (keyCode)
        {
            if (keysByCode.hasOwnProperty(keyCode) && keysByCode[keyCode].value)
            {
                return true;
            }
            return false;
        }

        /**
         * Accepts a keyboard event and returns an object of named keys.
         * If key name has a value of true, the key was pressed.
         * NOTE: *** DONT USE THIS FUNCTION TO HANDLE KEYPRESS EVENTS ***
         *       Keypress events use different character code and don't trigger for non-character keys.
         * @param {event} keyboardEvent - An event that is generated by a keyboard event, such as keyDown/keyUp
         * @return {object} An object key names.  If the key name has a value of true, the key was pressed.
         * @example
         *
         *     var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
         *     if (eventKeys.ENTER)
         *     {
         *         // Do something when the Enter key is pressed
         *     }
         */
        skyward.keys.getKeyNamesFromEvent = (function ()
        {
            var initialized = false;
            var namedKeys = {};
            var keyDataTemplete = {};

            return function (keyboardEvent)
            {
                if (!initialized)
                {
                    init();
                }

                // normalize the eventKeyCode when using keypress
                if (keyboardEvent.type === "keypress")
                {
                    console.warn("[Warning] getKeyNamesFromEvent doesn't support the keypress event.");
                    return;
                }

                var eventKeyCode = keyboardEvent.keyCode || keyboardEvent.which; // Fallback depending on support

                var keyData = getKeyDataTemplete();
                var keyName = namedKeys[eventKeyCode];

                if (typeof keyData[keyName] !== "undefined")
                {
                    keyData[keyName] = true;
                }

                if (keyboardEvent.shiftKey) { keyData["SHIFT"] = true; }
                if (keyboardEvent.ctrlKey) { keyData["CTRL"] = true; }
                if (keyboardEvent.altKey) { keyData["ALT"] = true; }
                if (keyboardEvent.metaKey) { keyData["META"] = true; }

                return keyData;
            };

            function init()
            {
                namedKeys =
                {
                    8: "BACKSPACE",
                    9: "TAB",
                    13: "ENTER",
                    16: "SHIFT",
                    17: "CTRL",
                    18: "ALT",
                    20: "CAPS_LOCK",
                    27: "ESC",
                    32: "SPACE",
                    33: "PAGE_UP",
                    34: "PAGE_DOWN",
                    37: "ARROW_LEFT",
                    38: "ARROW_UP",
                    39: "ARROW_RIGHT",
                    40: "ARROW_DOWN",
                    46: "DELETE",
                    48: "ZERO",
                    49: "ONE",
                    50: "TWO",
                    51: "THREE",
                    52: "FOUR",
                    53: "FIVE",
                    54: "SIX",
                    55: "SEVEN",
                    56: "EIGHT",
                    57: "NINE",
                    65: "A",
                    66: "B",
                    67: "C",
                    68: "D",
                    69: "E",
                    70: "F",
                    71: "G",
                    72: "H",
                    73: "I",
                    74: "J",
                    75: "K",
                    76: "L",
                    77: "M",
                    78: "N",
                    79: "O",
                    80: "P",
                    81: "Q",
                    82: "R",
                    83: "S",
                    84: "T",
                    85: "U",
                    86: "V",
                    87: "W",
                    88: "X",
                    89: "Y",
                    90: "Z",
                    91: "META",
                    92: "META",
                    96: "ZERO",
                    97: "ONE",
                    98: "TWO",
                    99: "THREE",
                    100: "FOUR",
                    101: "FIVE",
                    102: "SIX",
                    103: "SEVEN",
                    104: "EIGHT",
                    105: "NINE",
                    112: "F1",
                    113: "F2",
                    114: "F3",
                    115: "F4"
                };

                for (const key in namedKeys)
                {
                    keyDataTemplete[namedKeys[key]] = false;
                }

                initialized = true;
            }

            function getKeyDataTemplete()
            {
                return Object.assign({}, keyDataTemplete);
            }
        })();

        skyward.keys.getKeyFromEvent = function (keyboardEvent)
        {
            let returnObj = { name: "unknown", value: undefined };

            const eventKey = keyboardEvent.key; // Not supported Safari 10.2 downward ( https://caniuse.com/#search=keyboardevent.key )
            if (eventKey)
            {
                returnObj =
                {
                    name: eventKey.toLowerCase(),
                    value: eventKey
                };
                return returnObj;
            }

            const eventKeyCode = keyboardEvent.keyCode || keyboardEvent.which; // Fallback depending on support

            // Use "keydown" and "keyup" if you care about what keyboard key was pressed
            if (keyboardEvent.type === "keydown" || keyboardEvent.type === "keyup")
            {
                // Return the key based on keybarod key code
                returnObj = keysByCode[eventKeyCode];
                return returnObj;
            }

            // Use "keypress" if you care about what character was actually typed
            if (keyboardEvent.type === "keypress")
            {
                const value = String.fromCharCode(eventKeyCode); // Return the key based on char code
                returnObj =
                {
                    name: value.toLowerCase(),
                    value: value
                };
                return returnObj;
            }

            return returnObj;
        };

        $(function ()
        {
            "use strict";
            const jqDocument = $(window);
            jqDocument.on('keydown', globalDown);
            jqDocument.on('keyup', globalUp);
            jqDocument.on('blur', globalUp);
        });

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    // This framework can be used in a similar fashion to the .NET INotifyPropertyChanged framework.  To use it, you will extend Observable.
    // When initializing an instance, you can load whatever processsing you want to happen when a property changes into the observers collection
    // in the form of a function.  Then, whenever a new change happens, you create an Event() to indicate that a new change is happening, and then
    // call Notify() on yourself with that event.  This will notify all observers (via calling that function) that a change has happened and 
    // provide the Event so the observer can decide if they have processed this event already or not.
    function (skyward, $, undefined) {
        skyward.observable = skyward.observable || {};

        var eventCounter = 0;
        skyward.observable.Event = function (eventID)
        {
            eventID = eventID || eventCounter++;
            this.EventID = eventID;
        };
        
        skyward.observable.Observable = function () { };
        skyward.observable.Observable.prototype.observers = {}; // function(observable, event)
        skyward.observable.Observable.prototype.notifying = []; // List of events the element is currently notifying for, to prevent infinite loops of notifying back and forth.
        skyward.observable.Observable.prototype.Initialize = function ()
        {
            // Inherited types must call this in their constructor so the references to these things aren't shared.
            this.observers = {};
            this.notifying = [];
        }
        skyward.observable.Observable.prototype.notify = function (propertyName, eventToken)
        {
            eventToken = eventToken || new Event();
            this.notifying.push(eventToken);

            if (this.observers.hasOwnProperty(propertyName))
            {
                for (var i = 0; i < this.observers[propertyName].length; i++) {
                    this.observers[propertyName][i](eventToken);
                }
            }
        };

        // An implementation of an observable can use this method to tell whether or not a given Event has already
        // been processed-- for example, if the observable is observing another observable, the function used to observe
        // can use this to see if this has already handled a given change event.
        skyward.observable.Observable.prototype.eventProcessed = function (eventToken)
        {
            for (var i = 0; i < this.notifying.length; i++)
            {
                if (this.notifying[i].EventID == eventToken.EventID)
                {
                    return true;
                }
            }
            return false;
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
function (skyward, $, undefined)
{
    "use strict";
    var _addReadOnlyProperties = function(target, properties)
    {
        var definitions = {};
        $.each(properties || {}, function (k) { definitions[k] = { value: this }; });
        return Object.defineProperties(target, definitions);
    };
    
    var _makePrototype = function (parentConstructor, target)
    {
        var base = parentConstructor;
        var result = function ()
        {
            var i = arguments.length, args = new Array(i); while (i--) args[i] = arguments[i];

            // Here, "arguments" refers to the arguments provided *later*, when "new" is called on the constructor returned by this utility
            var exposedActions = base.apply(this, args);
            exposedActions = $.extend(exposedActions, target.apply(this, args));
            // Unless we implement some "intelligent" way to merge exposed actions returned by parent and child 
            //  the functions returned from target.constructor don't "override" base functions of the same name.
            //  instead, they replace them, much like the way C# interprets "new" vs "override" method declarations
            //  (One solution would be a $.map that wraps duplicate ctors in a "wrapper function" that calls child.ctor(), then base.ctor())

            if (typeof (exposedActions) === "object")
            {
                _addReadOnlyProperties(this, exposedActions);
            }
        };
        result.prototype = Object.create(base.prototype);
        return result;
    };

    _addReadOnlyProperties(skyward, {
        "mvvm": _addReadOnlyProperties({}, {
            // Low-level prototypes for the Observer-Pattern. 
            // Only use these as a temporary solution when a full MVVM implementation is not feasible.
            "newObservable": function (optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_observable, optional_constructor) : _observable;
                return new prototype();
            },
            "newObserver": function (optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_observer, optional_constructor) : _observer;
                return new prototype();
            },
            "newObservableCollection": function (optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_observableCollection, optional_constructor) : _observableCollection;
                return new prototype();
            },
            // MVVM Prototypes
            // A constructor is optional.
            // If provided, the constructor can return a dictionary of functions, and they will automatically be exposed as public methods on the new object.
            "newModel": function (observableProperties, readOnlyProperties, optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_model, optional_constructor) : _model;
                return new prototype(observableProperties, readOnlyProperties);
            },
            "newView": function (optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_model, optional_constructor) : _model;
                return new prototype();
            },
            "newViewModel": function (optional_constructor) // This really needs to be a combination model/observer. Right now there's no way to listen to another viewModel's state (i.e. IsValid for a collection of viewModels)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_observer, optional_constructor) : _observer;
                return new prototype();
            },
            "newModelCollection": function (collectees, publicProperties, readOnlyProperties, optional_constructor)
            {
                var prototype = (typeof (optional_constructor) === "function") ? _makePrototype(_modelCollection, optional_constructor) : _modelCollection;
                return new prototype(collectees, publicProperties, readOnlyProperties);
            },
            "utilities": _addReadOnlyProperties({}, {
                "makePrototype": _makePrototype,
                "addReadOnlyProperties": _addReadOnlyProperties
            })
        })
	});

	var _currentObserverID = 1;
	function _observer()
	{
		var _self = this;
		var _callbacks = {};
		var _observables = {};

		Object.defineProperties(_self, {
		    "_observerID": {
		        value: _currentObserverID++,
		        writable: false,
		        configurable: false
		    }
		});

		_addReadOnlyProperties(_self,{ 
		    "notify": function ()
		    {
		        var i = arguments.length, args = new Array(i); while (i--) args[i] = arguments[i];

		        var observable = this;
		        var event = args[0];

		        if (observable instanceof _observable && _callbacks[observable._observableID])
		        {
		            var id = observable._observableID;
		            if (event != undefined && typeof (_callbacks[id][event]) === "function")
		            {
		                // event-specific handlers don't get passed the event name
		                i = arguments.length - 1;
		                var argsMinusEventName = new Array(i); while (i--) argsMinusEventName[i] = arguments[i + 1];
                        _callbacks[id][event].apply(observable, argsMinusEventName);
		            }

		            // [undefined] is where the "any change" observer lives
		            if (_callbacks[id] && typeof (_callbacks[id][undefined]) === "function")
		            {
		                _callbacks[id][undefined].apply(observable, args);
		            }
		        }
		        return _self;
		    },
		    "observe": function (observable, callback_OrEventName, callback_IfEventNameSpecified)
		    {
		        if (observable instanceof _observable)
		        {
		            var id = observable._observableID;

		            if (typeof (callback_OrEventName) === 'object') // Allow an event object, in the format { "event1": callback, "event 2": callback ... etc } to be passed in
		            {
		                $.each(callback_OrEventName, function (e, cb)
		                {
		                    _self.observe(observable, e, cb);
		                });
		            }
                    else if (typeof (callback_OrEventName) === "function") // "All events" observer is registered by passing in a callback as the first parameter
		            {
		                observable.registerObserver(_self);
		                _observables[id] = observable;
		                (_callbacks[id] = _callbacks[id] || {})[undefined] = callback_OrEventName;
		            }
                    else if (typeof (callback_OrEventName) === "string" && typeof (callback_IfEventNameSpecified) === "function") // Property watchers are registered by passing in the property name and a callback
		            {
		                observable.registerObserver(_self);
		                _observables[id] = observable;
		                (_callbacks[id] = _callbacks[id] || {})[callback_OrEventName] = callback_IfEventNameSpecified;
		            }
		        }
		        return _self;
		    },
		    "stopObserving": function (observable)
		    {
				if (observable instanceof _observable)
		        {
		            observable.unregisterObserver(_self);
		            delete _callbacks[observable._observableID];
		            delete _observables[observable._observableID];
		        }
		    },
		    // stopObservingEvent(observable, undefined) will stop the "all events" observer
		    // use stopObservingObject() to remove callbacks for a specific observable (this will also unregister the observer from the observable)
		    "stopObservingEvent": function (observable, /*optional*/event)
		    {
		        if (observable instanceof _observable && _callbacks[observable._observableID])
		        {
		            var id = observable._observableID;
		            if (typeof (event) === "object") // An event-collection { eventName : callback, [...] } may also be passed in here
		            {
		                $.each(event, function (e)
		                {
		                    _self.stopObservingEvent(observable, e);
		                });
		            }
		            else
		            {
		                delete _callbacks[id][event];

		                if (!Object.keys(_callbacks[id]).length) // unregister from the observable only if we no longer watch *any* events on the observable.
		                {
		                    observable.unregisterObserver(_self);
		                    delete _callbacks[id];
		                    delete _observables[id];
		                }
		            }
		        }
		        return _self;
		    },
		    "stopObservingEverything": function ()
		    {
		        Object.keys(_observables).forEach(function (id)
		        {
		            _observables[id].unregisterObserver(_self);
		            delete _callbacks[id];
		            delete _observables[id];
		        });
		    }
		});
	}

	var _currentObservableID = 1;
	function _observable()
	{
		var _self = this;
		var _observers = {};
		var _isMuted = false;

		Object.defineProperties(_self, {
		    "isMuted": {
		        get : function ()
		        {
		            return (_isMuted ? true : false);
		        },
		        set: function (value)
		        {
		            _isMuted = (value ? true : false);
		        }
		    }
		});

		_addReadOnlyProperties(_self, {
		    "_observableID": _currentObservableID++,
		    "registerObserver": function (observer)
		    {
		        if (observer instanceof _observer)
		        {
		            _observers[observer._observerID] = observer;
		        }
		        return _self;
		    },
		    "unregisterObserver": function (observer)
		    {
		        if (observer instanceof _observer)
		        {
		            delete _observers[observer._observerID];
		        }
		        return _self;
		    },
		    "announce": function (/* eventName, [params...] */) // parameters are handled dynamically via the arguments object.
		    {
		        if (!_isMuted)
		        {
		            var i = arguments.length, args = new Array(i); while (i--) args[i] = arguments[i];

		            $.each(_observers, function (i, o)
		            {
		                o.notify.apply(_self, args);
		            });
		            return _self;
		        }
		    }
		});
	}

	function _observableCollection(collectionContents)
	{
	    var _self = this;
	    if (!_self._observableID)
		{
			_observable.call(_self);
		}
		var _collection = [];
		var _collectionObserver = new _observer();

		var _contentChanged = function ()
		{
		    var i = arguments.length, args = new Array(i); while (i--) args[i] = arguments[i];

		    // 'this' points to the observable in the collection that announced
		    _self.announce("contentChanged", this, args);
		    // Callbacks are executed with "this" set to the observable collection, and are passed the following 3 values:
		    //  the event name: "contentChanged", 
		    //  the observable in the collection responsible for the announcement, 
		    //  an array containing the original values from that observable's announcement [argument 1, argument 2, etc]) ... 
		};

	    // Connect our collectionObserver to each of the passed-in observables
		$.each(collectionContents || [], function (i, o)
		{
			if (o instanceof _observable)
			{
				_collection.push(o);
				_collectionObserver.observe(o, _contentChanged);
			}
		});

		Object.defineProperties(_self, { "length": { get: function () { return _collection.length; } }});

		var actions = {
		    "add": function (observable)
		    {
		        var length;
		        if (observable instanceof _observable)
		        {
		            length = _collection.push(observable);
		            _collectionObserver.observe(observable, _contentChanged);
		            _self.announce("add", observable, length);
		        }
		        return length;
		    },
		    "remove": function (observable)
		    {
		        var removedObservable;
		        if (observable instanceof _observable)
		        {
		            var index = _collection.indexOf(observable);
		            if (index != -1)
		            {
		                removedObservable = _collection.splice(index, 1)[0];
		                _collectionObserver.stopObserving(observable);
		                _self.announce("remove", observable, index);
		            }
		        }
		        return removedObservable;
		    },
		    "elementAt": function (index) { return _collection[index]; },
		    "find": function (delegate, context)
		    {
		        var result;
		        $.each(_collection, function ()
		        {
		            if (delegate(this, context))
		            {
		                result = this;
		                return false;
		            }
		        });
		        return result;
		    },
		    "findMany": function (delegate, context)
		    {
		        var results = [];
		        $.each(_collection, function ()
		        {
		            if (delegate(this, context))
		            {
		                results.push(this);
		            }
		        });
		        return results;
		    },
		    "indexOf": function (observable) { return _collection.indexOf(observable); },
		    "forEach": function (delegate) { return _collection.forEach(delegate); },
		    "filter": function (delegate) { return _collection.filter(delegate); },
		    "sort": function (comparator) { _collection.sort(comparator); _self.announce("sort"); },
		    "some": function (condition) { return _collection.some(condition); }
		};

		_addReadOnlyProperties(_self, actions);
	}
	_observableCollection.prototype = Object.create(_observable.prototype);

	function _model(properties, readOnlyProperties)
	{
	    var _self = this;
	    _observable.call(_self, properties, readOnlyProperties);
		var _properties = {};
		var _originalValues = {};
		var _originalValuesJSON = {};
		var _dirtyProperties = {};

		this.notifyOnSetToSameValue = true;

		// Wrap properties in getters/setters
		$.each(properties || {}, function (propertyName, currentValue)
		{
			_properties[propertyName] = currentValue;

			Object.defineProperty(_originalValues, propertyName, { value: currentValue });
			Object.defineProperty(_originalValuesJSON, propertyName, { value: JSON.stringify(currentValue) });

			Object.defineProperty(_self, propertyName, {
			    get: function () { return _properties[propertyName]; },
				set: function (val)
				{
				    if (_originalValuesJSON[propertyName] != JSON.stringify(val))
				    {
				        _dirtyProperties[propertyName] = true;
				    }
				    else
				    {
				        delete _dirtyProperties[propertyName];
				    }

					var oldVal = _properties[propertyName];
					_properties[propertyName] = val;
					if (val != oldVal || val == oldVal && this.notifyOnSetToSameValue)
					{
						_self.announce(propertyName, val, oldVal);
					}
				},
				enumerable: true
			});
		});
		$.each(readOnlyProperties || {}, function (propertyName, value)
		{
			_properties[propertyName] = value;

			var propertyDefinition;
			if(typeof(value) === "function")
			{
				propertyDefinition = { value: value };
			}
			else
			{
				Object.defineProperty(_originalValues, propertyName, { value: value });
				propertyDefinition = {
				    get: function () { return _properties[propertyName]; },
					enumerable: true
				};
			}
			Object.defineProperty(_self, propertyName, propertyDefinition);
		});

		Object.defineProperties(_self, {
			"originalValues": {
				value: _originalValues
			},
			"revert": {
				value: function()
				{
					for (var propertyName in _dirtyProperties)
					{
						_self[propertyName] = _originalValues[propertyName];
					}
				},
				configurable:true // This property gets overridden by modelCollection
			},
			"isDirty": {
				value: function ()
				{
				    return !$.isEmptyObject(_dirtyProperties);
				},
				configurable: true
			}
		});
	}
	_model.prototype = Object.create(_observable.prototype);

	function _modelCollection(models, properties, readOnlyProperties)
	{
	    var _self = this;
	    _model.call(_self, properties, readOnlyProperties);
		
	    var _modelCollectionObserver = new _observer();
		var _originalCollection = [];
		var _typeFilteredModels = [];

		$.each(models || {}, function (i, m)
		{
			if (m instanceof _model)
			{
				_originalCollection.push(m);
				_typeFilteredModels.push(m);
			}
		});
		_observableCollection.call(_self, _typeFilteredModels);

		_modelCollectionObserver.observe(_self, function (eventName, nestedModel, nestedArguments) // This works for Models, not nested ModelCollections' Models. If this functionality is needed, see observableCollection for one possible way to solve this 
		{
		    var nestedEventName = (nestedArguments || [])[0];
		    // the first argument an observable passes is the event name 
		    if (eventName == "contentChanged" && nestedEventName && nestedArguments.length >= 3 &&
                (JSON.stringify(nestedArguments[1]) !=JSON.stringify( nestedArguments[2])))
		    {
		        _self.announce("model:" + nestedEventName, nestedModel);
		    }
		});

		delete _self.isDirty; // These methods get replaced.
		delete _self.revert;
		_addReadOnlyProperties(_self, {
		    "originalModels": function ()
		    {
		        return _originalCollection.concat([]);
		    },
		    "revert": function ()
		    {
		        _self.forEach(function (model) { _self.remove(model); });
		        _originalCollection.forEach(function (model) { self.add(model); model.revert(); });
		    },
		    "isDirty": function ()
		    {
		        return _self.some(function (model) { return (model.isDirty()); });
		    }
		});
	}
	_modelCollection.prototype = Object.create(_observableCollection.prototype);

}(window.skyward = window.skyward || {}, window.jQuery)
);
;
document.addEventListener("DOMContentLoaded", function ()
{
    "use strict";

    if (document.wasDiscarded)
    {
        $.ajax({
            url: skyward.global.virtualDir + "SkySys/Log/LogDiscardedTab",
            type: "POST",
            dataType: "JSON",
            success: function () { },
            error: function () { }
        });
    }
});;
skyward.base.registerScript("dataobjectviewer", function (skyward, $)
{
    "use strict";

    var eventNames =
    {
        DOVSaveValidationError: "DOVSaveValidationError",
        DOVSaveComplete: "DOVSaveComplete",
        DOVSaveCanceled: "DOVSaveCanceled",
        DOVSaveInDetailsPanel: "DOVSaveInDetailsPanel",
    };

    skyward.dataobjectviewer = skyward.dataobjectviewer || {};

    /**
     * Save the  Data Object Viewer using the parameters specified when the viewpart was rendered on the server.
     *
     * @param {string} dovId - The id of the  Data Object Viewer to save
     * @return {Promise} A promise that is resolved when the save completes.
     */
    skyward.dataobjectviewer.defaultSave = function (dovId)
    {
        var saveButton = $("#" + dovId + "_save");
        if (saveButton.length === 1 && saveButton.hasClass("dirty"))
        {
            return saveHandler(saveButton, false);
        }
        return $.Deferred().reject();
    };

    /**
    * Save the  Data Object Viewer using the parameters specified when the viewpart was rendered on the server.
    * Then return to the previous screen.
    *
    * @param {string} dovId - The id of the  Data Object Viewer to save
    * @return {Promise} A promise that is resolved when the save completes.
    */
    skyward.dataobjectviewer.defaultSaveAndBack = function (dovId)
    {
        var saveButton = $("#" + dovId + "_saveBack");
        if (saveButton.length === 1 && saveButton.hasClass("dirty"))
        {
            return saveHandler(saveButton, true, false);
        }
        return $.Deferred().reject();
    };

    skyward.dataobjectviewer.cancel = skyward.buttonManager.manageButtonClick(doCancel);

    skyward.dataobjectviewer.save = skyward.buttonManager.manageButtonClick(doSave);

    skyward.dataobjectviewer.delete = skyward.buttonManager.manageButtonClick(doDelete);

    skyward.dataobjectviewer.addNewControl = function (container, enableDOVButtons)
    {
        var saveButton = $("#" + container + "_save");

        if (saveButton.length > 0)
        {
            $('[id*="iconSave"]').addClass("dirty");

            if (typeof enableDOVButtons === 'undefined' || enableDOVButtons)
            {
                skyward.dataobjectviewer.getFieldValues.enableButtons(container);
            }
        }
    };

    skyward.dataobjectviewer.removeControl = function (container)
    {
        var saveButton = $("#" + container + "_save");

        if (saveButton.length > 0)
        {
            $('[id*="iconSave"]').addClass("dirty");
        }
    };

    skyward.dataobjectviewer.updateCustomSaveData = function (input, datadictionary, forceKeep)
    {
        var saveData = customSaveDataFetcher.fetch(input);
        if (!saveData)
        {
            return;
        }

        for (var i = 0; i < datadictionary.length; i++)
        {
            var storedSaveData = datadictionary[i];
            if (storedSaveData.name == saveData.name)
            {
                if (storedSaveData.originalValue == saveData.value && !forceKeep)
                {
                    //remove save data from array
                    datadictionary.splice(i, 1);
                }
                else
                {
                    //update existing save data
                    datadictionary[i] = saveData;
                }
                return;
            }
        }

        // add save data
        if (saveData.originalValue != saveData.value || forceKeep)
        {
            datadictionary.push(saveData);
        }
    };

    /**
     * Perform client-side validation on fields in the specified container
     * @param {JQyuery} container - workflow or details screen's container to run pre-save validation on
     * @returns {boolean} - True if the container has no invalid fields or if the CMA is not locatable
     */
    skyward.dataobjectviewer.preSaveValidation = function (container)
    {
        const contentArea = container.parent();
        const cma = skyward.contentMessageArea.getContentMessageArea(contentArea);

        if (cma)
        {
            // Targets with pre-save errors will have these classes 'error-control js-error-control--preSaveValidation', pre-save warnings will have these classes 'warning-text js-warn-control--preSaveValidation'
            const preSaveValidation = container.find('.js-error-control--preSaveValidation');
            const preSaveWarning = container.find('.js-warn-control--preSaveValidation:not(.js-warn-control--preSaveIgnore)');

            if (preSaveValidation.length > 0 || preSaveWarning.length > 0)
            {
                // Take into account all errors/warnings on the screens when updating the CMA
                const errorCount = container.find('.help .error-text').length;
                const warnCount = container.find('.help .warning-text').length;
                cma.setValidationCount(errorCount, warnCount).showValidation();

                if (preSaveWarning.length > 0)
                {
                    preSaveWarning.addClass('js-warn-control--preSaveIgnore');
                }

                return false;
            }
        }
        return true;
    }

    var customSaveDataFetcher = (function ()
    {
        var customSaveDataFetcher = {};

        customSaveDataFetcher.fetch = function (input)
        {
            return input.saveJson ? getSaveDataFromObj(input) : getSaveDataFromField(input);
        };

        return customSaveDataFetcher;

        function getSaveDataFromField(input)
        {
            if (input.length < 1)
            {
                return;
            }

            var fieldValue = skyward.dataobjectviewer.getFieldValues.getFieldValueFromNamedInput(input);
            if (!fieldValue)
            {
                return;
            }

            var saveData =
            {
                name: fieldValue.name,
                value: fieldValue.value == null ? "" : fieldValue.value
            };

            appendInputData(saveData, input.data());

            return saveData;
        }

        function getSaveDataFromObj(obj)
        {
            var saveData =
            {
                name: obj.name,
                value: obj.value
            };

            appendInputData(saveData, obj.data);

            return saveData;
        }

        function appendInputData(saveData, inputData)
        {
            var defaultInputData = { originalValue: "" };

            inputData = $.extend({}, defaultInputData, inputData);

            saveData.originalValue = inputData.originalValue;

            var saveDataDictionary = {};
            // Keep this in sync with the keys defined in CustomSaveData.cs
            const allowedKeys = [
                "originalValue",
                "calculationGroupGradeBucketId",
                "categoryId",
                "poquantity",
                "previouslyreceived",
                "poamount",
                "previouslyreceivedamount",
                "approvalobjectid",
                "comment"
            ];
            $.each(inputData, function (key, dataValue)
            {
                if (allowedKeys.includes(key))
                {
                    if (isPlainObject(dataValue))
                    {
                        // originalValue is an object in cases of DMSE
                        saveDataDictionary[key] = JSON.stringify(dataValue);
                    }
                    else
                    {
                        saveDataDictionary[key] = dataValue;
                    }
                }
            });

            saveData.datadictionary = saveDataDictionary;
        }

        function isPlainObject(value)
        {
            return (
                typeof value === 'object' &&
                value !== null &&
                !Array.isArray(value) &&
                Object.prototype.toString.call(value) === '[object Object]'
            );
        }
    })();

    var redirectAfterAsyncProcess = function (data, container, area, controller, refreshAction, id, popupId, goBack, tab, savingInDetailsPanel, urlReferrer)
    {
        var deferred = $.Deferred();

        if (data.goBack || goBack)
        {
            skyward.window.setSkipUnloadCheck(true);
            skyward.window.returnToPrevious(refreshAction, urlReferrer);
            deferred.resolve();
        }
        else
        {
            if (tab != null)
            {
                container = "moduleContent";
            }
            skyward.window.setSkipUnloadCheck(true);

            var loadContentdata = data;

            loadContentdata.tab = data.excludeTab ? null : tab;

            if (savingInDetailsPanel)
            {
                skyward.browse.detailsPanelSaveUpdateRow(loadContentdata);
                deferred.resolve();
            }
            else
            {
                container = data.container || container;
                area = data.area || area;
                controller = data.controller || controller;
                refreshAction = data.refreshAction || refreshAction;
                id = data.id || id;
                popupId = data.popupId || popupId;

                deferred = skyward.window.loadContent(container, area, controller, refreshAction, id, loadContentdata, popupId);
            }
        }

        return deferred.promise();
    };

    /**
    * Save the  Data Object Viewer by manually passing in the save parameters.
    *
    * @param {string} container - The id of the Data Object Viewer container
    * @param {string} area - The Area/Module part of the path to the save action
    * @param {string} controller - The Controller/Object part of the path to the save action
    * @param {string} refreshAction - The Screen/Action of the current screen
    * @param {string|number} id - The id/primaryKey of the object in the Data Object Viewer
    * @param {string} popupId - The id of the popup if the Data Object Viewer is within a popup
    * @param {string} saveAction - The name of the Save action
    * @param {boolean} goBack - Return to the previous url after the save completes?
    * @param {string} tab - The name of the current tab, if within a screen with a tab
    * @param {boolean} showingDetailsPanel - Is the Data Object Viewer displayed within a details panel?
    * @param {boolean} preventRedirect - Should the redirect after save be prevented?
    * @param {object} postData - Key/Value pairs to post with the save request
    * @param {object} settings - An object of save settings
    * @return {Promise} A promise that is resolved when the save completes successfully; rejected when the save fails for any reason.
    */
    function doSave(container, area, controller, refreshAction, id, popupId, saveAction, goBack, tab, showingDetailsPanel, preventRedirect, postData, settings)
    {
        var defaultSettings =
        {
            cmaContainerId: container,
            dirtyOverride: false,
            saveButtonSelector: "#" + container + "_save"
        };

        var saveSettings = $.extend({}, defaultSettings, settings);

        var saveButton = $(saveSettings.saveButtonSelector);
        if (!saveButton.hasClass("dirty") && !saveSettings.dirtyOverride)
        {
            return;
        }

        var jQContainer = $("#" + container);
        var jQBody = $(document.body);
        jQBody.addClass("cursor-progress");

        if (!skyward.dataobjectviewer.preSaveValidation(jQContainer))
        {
            jQContainer.trigger(eventNames.DOVSaveValidationError);
            jQBody.removeClass('cursor-progress');
            return;
        }

        var url = skyward.global.virtualDir + area + "/" + controller + "/" + saveAction + "/";
        var baseErrorContainer = jQContainer.find(".currentRecordContentBaseError");
        var deferredClick = $.Deferred();

        if (id)
        {
            url += id;
        }


        skyward.dataobjectviewer.getFieldValues.getFieldValues(jQContainer).then(fieldValues =>
        {
            var values = $.extend({}, postData, fieldValues);
            values['warninghash'] = jQContainer.data("warninghash") || "";
            values['preSaveWarningHash'] = jQContainer.data("preSaveWarningHash") || "";
            values['editableFields'] = skyward.controls.getEditableFields(jQContainer);
            values['goBack'] = goBack;
            values['dataObjectViewer_RefreshAction'] = refreshAction;
            values.skipFiscalYearScopeCheck = "true";

            $.ajax(
                {
                    url: url,
                    type: "POST",
                    success: async function (data)
                    {
                        if (data)
                        {
                            if (data.success)
                            {
                                // If deferred, then we process save using taskstatus.js
                                if (data.deferred)
                                {
                                    skyward.dataobjectviewer.getFieldValues.disableButtons(container);

                                    var onValidationError = function (data)
                                    {
                                        skyward.dataobjectviewer.getFieldValues.enableButtons(container);
                                        skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                                        jQContainer.trigger(eventNames.DOVSaveValidationError);
                                    };

                                    var OnCompleted = async function (deferredData)
                                    {
                                        // Called to clear out any existing validation messages
                                        skyward.validation.displayValidationMessages(deferredData, container, baseErrorContainer);
                                        await skyward.changeTracking.clearDirtyList(container);
                                        deferredData.confirmationMessage = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                        values['confirmationMessage'] = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                        deferredData.confirmationMessageContainer = container;
                                        deferredData.skipFiscalYearScopeCheck = "true";
                                        if (!preventRedirect)
                                        {
                                            redirectAfterAsyncProcess(deferredData, container, area, controller, refreshAction, id, popupId, goBack || data.goBack, tab, showingDetailsPanel);
                                        }

                                        jQContainer.trigger(eventNames.DOVSaveComplete);
                                    };

                                    // Deferred, ping and show status
                                    skyward.buttonManager.waitForFunction(deferredClick, skyward.taskstatus.beginAsyncStatusReport(data.workflowInstanceID, OnCompleted, null, onValidationError, 5000));

                                    return;
                                }
                                else
                                {
                                    data.skipFiscalYearScopeCheck = "true";
                                    jQBody.removeClass('cursor-progress');
                                    await skyward.changeTracking.clearDirtyList(container);
                                    skyward.dataobjectviewer.getFieldValues.enableButtons(container);

                                    var contentArea = jQContainer.parent();
                                    const cma = skyward.contentMessageArea.getContentMessageArea(contentArea);

                                    if (!$.isEmptyObject(data.settings))
                                    {
                                        if (cma)
                                        {
                                            var message = data.settings.redirectMessage ? data.settings.redirectMessage : skyward.contentMessageArea.getDefaultConfirmationMessage();
                                            cma.setConfirmationMessage(message);
                                            cma.showConfirmation();
                                        }

                                        contentArea.find('.contentMessageArea').on('SaveAnimationRedirect', function ()
                                        {
                                            skyward.window.loadContent(data.settings.target, data.settings.area, data.settings.controller, data.settings.action, data.settings.id ?? data.id);
                                        });
                                    }
                                    else
                                    {
                                        data.confirmationMessage = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                        values['confirmationMessage'] = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                        data.confirmationMessageContainer = container;

                                        if (cma)
                                        {
                                            var message = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                            cma.setConfirmationMessage(message);
                                            cma.showConfirmation();
                                        }

                                        if (!preventRedirect)
                                        {
                                            var deferred = redirectAfterAsyncProcess(data, container, area, controller, refreshAction, id, popupId, goBack, tab, showingDetailsPanel);
                                            jQContainer.trigger(eventNames.DOVSaveComplete);
                                            deferred.always(function () { deferredClick.resolve(); });
                                            return;
                                        }
                                    }
                                    jQContainer.trigger(eventNames.DOVSaveComplete);
                                }
                                deferredClick.resolve();
                            }
                            else
                            {
                                jQBody.removeClass("cursor-progress");
                                skyward.validation.displayValidationMessages(data, saveSettings.cmaContainerId, baseErrorContainer, false);
                                data = { Update: data.Update };
                                skyward.ajax.handleResponse(data, null, true, skyward.window.getClosestContentPanel(jQContainer));
                                jQContainer.trigger(eventNames.DOVSaveValidationError);
                                const error = new skyward.error.CancellationError("dataobjectviewer save unsuccessful");
                                error.statusCode = 200; // This is needed to bypass jQuery.Deferred.exceptionHook
                                deferredClick.reject(error);
                            }
                        }
                    },
                    error: function ()
                    {
                        deferredClick.reject();
                    },
                    data: values
                });
        });
        return deferredClick.promise();
    }

    /**
    * Cancel any pending changes within the Data Object Viewer by manually passing in the save parameters.
    *
    * @param {string} container - The id of the Data Object Viewer container
    * @param {string} area - The Area/Module part of the path to the save action
    * @param {string} controller - The Controller/Object part of the path to the save action
    * @param {string} action - The Screen/Action of the current screen
    * @param {string|number} id - The id/primaryKey of the object in the Data Object Viewer
    * @param {string} popupId - The id of the popup if the Data Object Viewer is within a popup
    * @param {string} tab - The name of the current tab, if within a screen with a tab
    * @param {boolean} showingDetailsPanel - Is the Data Object Viewer displayed within a details panel?
    * @param {boolean} skipCancelAction - Should the page be reloaded instead of reloading the action?
    * @param {boolean} preventRedirect - Should the redirect after save be prevented?
    */
    async function doCancel(container, area, controller, action, id, popupId, tab, showingDetailsPanel, skipCancelAction, preventRedirect)
    {
        var cancelButton = $("#" + container + "_cancel");

        if (cancelButton.hasClass("dirty"))
        {
            var target = "moduleContent";
            var data =
            {
                tab: tab,
                skipFiscalYearScopeCheck: "true"
            };

            if (showingDetailsPanel)
            {
                var postedData = skyward.detailsPanel.getData();
                data = $.extend({}, postedData, data);
                target = "detailsPanel";
            }

            await skyward.changeTracking.clearDirtyList(container, window, true);

            $("#" + container).trigger(eventNames.DOVSaveCanceled, [{ target: target, area: area, controller: controller, action: action, id: id, data: data, popupId: popupId }]);

            if (preventRedirect)
            {
                return;
            }

            if (skipCancelAction)
            {
                window.location.reload(true);
            }
            else
            {
                skyward.window.loadContent(target, area, controller, action, id, data, popupId);
            }
        }
    }

    /**
    * Delete the Data Object Viewer by manually passing in the save parameters.
    *
    * @param {string} area - The Area/Module part of the path to the delete action
    * @param {string} controller - The Controller/Object part of the path to the delete action
    * @param {string} action - The Screen/Action part of the path to the delete action
    * @param {string|number} id - The id/primaryKey of the object in the Data Object Viewer
    * @param {string} urlReferrer - The name url of the current page
    * @param {boolean} profileBrowseID - The browse id of the current profile, if within a profile
    * @return {Promise} A promise that is resolved when the save completes.
    */
    function doDelete(area, controller, action, id, urlReferrer, profileBrowseID)
    {
        var container = "moduleContent";
        var jQContainer = $("#" + container);
        var jQBody = $(document.body);
        jQBody.addClass("cursor-progress");

        var url = skyward.global.virtualDir + area + "/" + controller + "/" + action + "/";
        var baseErrorContainer = jQContainer.find(".currentRecordContentBaseError");
        var deferredClick = $.Deferred();

        if (id)
        {
            url += id;
        }

        if (profileBrowseID)
        {
            skyward.browsePreferences.setPreferences(parseInt(profileBrowseID), { seekId: null });
        }

        var warninghash = jQContainer.data("warninghash") || "";

        $.ajax(
            {
                url: url,
                type: "POST",
                success: function (data)
                {
                    if (data)
                    {
                        if (data.success)
                        {
                            // If deferred, then we process save using taskstatus.js
                            if (data.deferred)
                            {
                                var onValidationError = function (data)
                                {
                                    skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                                };

                                var OnCompleted = function (data)
                                {
                                    // Called to clear out any existing validation messages
                                    skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                                    skyward.breadcrumb.removeStaledBreadcrumbs(urlReferrer);
                                    redirectAfterAsyncProcess(data, container, area, controller, action, id, null, true, null, null, urlReferrer);
                                };

                                // Deferred, ping and show status
                                skyward.buttonManager.waitForFunction(deferredClick, skyward.taskstatus.beginAsyncStatusReport(data.workflowInstanceID, OnCompleted, null, onValidationError, 5000));

                                return;
                            }
                            else
                            {
                                jQBody.removeClass("cursor-progress");
                                skyward.breadcrumb.removeStaledBreadcrumbs(urlReferrer);
                                redirectAfterAsyncProcess(data, container, area, controller, action, id, null, true, null, null, urlReferrer);
                            }
                        }
                        else
                        {
                            jQBody.removeClass("cursor-progress");
                            skyward.validation.displayValidationMessages(data, container, baseErrorContainer, true);
                        }

                        deferredClick.resolve();
                    }
                },
                error: function ()
                {
                    deferredClick.resolve();
                },
                data: warninghash
            });

        return deferredClick.promise();
    }

    function saveHandler(button, goBack, preventRedirectOverride)
    {
        var toolbar = $(button).closest(".toolbar");
        var dovContainer = $("#" + toolbar.data().dovId);
        var data = dovContainer.data();
        var refreshAction = getRefreshAction(data, goBack);
        var preventRedirect = preventRedirectOverride !== undefined ? preventRedirectOverride : data.preventredirect;
        var tab = !goBack && data.tabtoroute !== null ? data.tabtoroute : data.tab;
        return doSave(dovContainer.attr("id"), data.module, data.object, refreshAction, data.primaryid, data.popupid + "", data.saveaction, goBack, tab, data.detailspanel, preventRedirect);
    }

    function cancelHandler()
    {
        var toolbar = $(this).closest(".toolbar");
        var dovContainer = $("#" + toolbar.data().dovId);
        var data = dovContainer.data();
        var refreshAction = getRefreshAction(data, false);
        var tab = data.tabtoroute !== null ? data.tabtoroute : data.tab;
        doCancel(dovContainer.attr("id"), data.module, data.object, refreshAction, data.primaryid, data.popupid + "", tab, data.detailspanel, data.skipcancelaction, data.preventredirect);
    }

    function getRefreshAction(data, goingBack)
    {
        var refreshAction = data.refreshaction.toLowerCase() === "edit" ? "Details" : data.refreshaction;
        if (goingBack)
        {
            return refreshAction;
        }
        if (data.routetodetails === true)
        {
            refreshAction = "Details";
        }
        else if (data.pagetoroute !== null)
        {
            refreshAction = data.pagetoroute;
        }
        return refreshAction;
    }

    var events =
    {
        save: function () { return saveHandler(this, false); },
        saveAndBack: function () { return saveHandler(this, true, false); },
        cancel: cancelHandler,
        initChangeTracking: function () { skyward.changeTracking.setUpChangeTracking(this); },
        initAccessibility: function ()
        {
            // Use the first section header label as the label of the DOV Form
            const dataObjectViewer = $(this)
            const firstHeaderId = dataObjectViewer.find(".sectionHeader .sectionHeader__text").first().addIds().attr("id");
            dataObjectViewer.attr("aria-labelledby", firstHeaderId);
        }
    };

    return events;
});
;
(
    function (skyward, $, undefined)
    {
        skyward.datepicker = skyward.datepicker || {};

        var _eventsBoundClassname = 'datepickerEventsBound';
        var _maxDatepickerHeight;
        var _revertToRelativeIfNoDateSelected = "revertToRelativeIfNoDateSelected";

        if (!$.datepicker)
        {
            skyward.error.reportException(new window.SkywardException("jquery ui datepicker script has not been initialized.", undefined, window.Severity.Error, "8C5A7AB5-8355-463C-9EBE-5AA373D7784A"));

            // jQuery UI is not loaded, so there is no datepicker to override. Returning leaves
            // skyward.datepicker with no methods, which is the same state the TypeError on the
            // next line produced, but without the uncaught exception that aborted this module
            // part way through defining itself.
            return;
        }

        // store datepicker's original functions for override
        var _baseGotoToday = $.datepicker._gotoToday;
        var _baseDoKeyDown = $.datepicker._doKeyDown;
        
        skyward.datepicker.setDatePicker = function (picker)
        {
            errorHelper.removeError(picker);
            
            var stringValue = picker.val();
            if (stringValue === "")
            {
                skyward.relativedatepicker.showDatePicker(picker.attr('id'));
                return;
            }

            if (!setDatepickerValue(picker, stringValue, false))
            {
                errorHelper.showError(picker);
            }

            skyward.relativedatepicker.showDatePicker(picker.attr('id'));
        };

        skyward.datepicker.destroy = function (picker)
        {
            picker.removeClass(_eventsBoundClassname);
            var dateIconSpan = picker.siblings(".datepicker-trigger");
            dateIconSpan.off();
            picker.off();
            picker.datepicker("destroy");
        };

        skyward.datepicker.registerDatepicker = function (picker)
        {
            picker = $(picker);
            if (picker.hasClass(_eventsBoundClassname))
            {
                return;
            }

            if (picker.is('[type=date]')) //currently only in mobile access
            {
                picker.on('change', function ()
                {
                    $(this).trigger("datePickerChangeComplete");
                });
                return;
            }
            
            setupDateIconSpan(picker);
            setDatepickerValue(picker, picker.val(), true);
            setDatepickerEvents(picker);
            setupModalControl(picker);
            setupVisibility(picker);

            picker.addClass(_eventsBoundClassname);
        };

        skyward.datepicker.getMaxDatepickerHeight = function (frameWindow = window)
        {
            if (_maxDatepickerHeight !== undefined)
            {
                return _maxDatepickerHeight;
            }
            // January 2000 spans six weeks, for the tallest possible datepicker
            _maxDatepickerHeight = getDatepickerHeight(new Date(2000, 0), frameWindow);
            return _maxDatepickerHeight;
        };

        skyward.datepicker.parseDateString = function (dateString)
        {
            return dateParsingHelper.parse(dateString);
        };

        skyward.datepicker.isValidDateObject = function (date)
        {
            return date instanceof Date && !isNaN(date); // Note: (new Date(null)) is a Valid Date
        };

        skyward.datepicker.show = function (picker, animate)
        {
            return toggleVisibility(picker, true, animate);
        };

        skyward.datepicker.hide = function (picker, animate)
        {
            return toggleVisibility(picker, false, animate);
        };

        function init()
        {
            this.find(".datepicker").each(function ()
            {
                skyward.datepicker.registerDatepicker(this);
            });
        }

        function setDatepickerValue(picker, value, clearOnInvalid)
        {
            // Remove potential trailing day string
            value = value.trim().split(" ", 1)[0];

            var dateValue = dateParsingHelper.parse(value);
            if (dateValue !== dateParsingHelper.getInvalidDate() && skyward.validation.validDate(dateValue))
            {
                internalSet(picker, dateValue);
                return true;
            }

            dateValue = skyward.time.parseDate(value);
            if (skyward.validation.validDate(dateValue))
            {
                internalSet(picker, dateValue);
                return true;
            }

            if (clearOnInvalid && !picker.has("promptHash") && !picker.has('environmentVariableBinding'))
            {
                skyward.controls.setValue(picker, "");
            }

            return false;

            function internalSet(pickerToSet, valueToSet)
            {
                picker.data(_revertToRelativeIfNoDateSelected, false);
                skyward.controls.setValue(pickerToSet, valueToSet, true);
            }
        }

        function setupDateIconSpan(picker)
        {
            var dateIconSpan = picker.siblings(".datepicker-trigger");

            if (dateIconSpan.length <= 0)
            {
                dateIconSpan = $('<span class="datepicker-trigger" id="' + picker.attr("id") + '-icon"/>');

                if (picker.is("[readonly]"))
                {
                    dateIconSpan.hide();
                }

                picker.wrap("<span class='datepicker-wrapper'></span>");
                picker.after(dateIconSpan);

                var svg = skyward.svg.getSvg('Date');
                var iconClass = picker.attr("data-datepicker-icon-class");
                if (iconClass)
                {
                    svg.addClass(iconClass);
                }

                dateIconSpan.append(svg);
            }

            dateIconSpan.on('click', function () { showDatepicker(picker); });
        }

        function setDatepickerEvents(picker)
        {
            picker.on("keypress", handleNewChar);
            picker.on("keyup", checkForDateHotkeys);
            picker.on("change", setDatePicker);
            picker.on("click", onClick);

            // We cancel normal input, so we have to trigger our own change
            setCustomChangeEvent(picker);

            function checkForDateHotkeys(keyboardEvent)
            {
                if (picker.is("[readonly]"))
                {
                    return;
                }

                var eventKeys = skyward.keys.getKeyNamesFromEvent(keyboardEvent);

                // Show the datepicker if it's not showing and tabbed into
                if (eventKeys.TAB && !picker.datepicker("widget").is(":visible"))
                {
                    picker.datepicker('show');
                }
                // Handle shortcut keys (T = Today, R = Tomorrow, Y = Yesterday)
                else if (eventKeys.T || eventKeys.R || eventKeys.Y)
                {
                    var shortcutDate = skyward.time.now();
                    if (eventKeys.R)
                    {
                        shortcutDate.setDate(shortcutDate.getDate() + 1);
                    }
                    else if (eventKeys.Y)
                    {
                        shortcutDate.setDate(shortcutDate.getDate() - 1);
                    }

                    const newDate = (shortcutDate.getMonth() + 1).toString().padLeft(2, '0') + '/' + shortcutDate.getDate().toString().padLeft(2, '0') + '/' + shortcutDate.getFullYear();
                    skyward.controls.setValue(picker, newDate);
                }
            }

            function handleNewChar(keyboardEvent)
            {
                var key = skyward.keys.getKeyFromEvent(keyboardEvent);
                var invalidCharsRegex = dateParsingHelper.getInvalidCharsRegex();

                // Handle unsupported keys
                if (!key || !key.value || invalidCharsRegex.test(key.value))
                {
                    return; // We allow default event handling
                }

                var value = picker.val();
                var coercedValue = replaceSelectionWithChar(value, key.value, keyboardEvent.target.selectionStart, keyboardEvent.target.selectionEnd);

                // Store cursor position, Set coerced value, Keep cursor position
                var cursorPosition = keyboardEvent.target.selectionStart + (value === coercedValue ? 0 : 1);
                picker.val(coercedValue);
                picker[0].setSelectionRange(cursorPosition, cursorPosition);

                // Stop the normal input from happening
                keyboardEvent.preventDefault();
            }

            function setCustomChangeEvent(picker)
            {
                let focusInValue;
                let focusInError = false;
                let isFocused = false;

                picker.on("focusin", onFocusin);
                picker.on("focusout", onFocusout);

                function onFocusin(focusEvent)
                {
                    // calling picker.val(coercedValue) in handleNewChart above will re focus the picker if the value is a complete formatted date, 
                    // causing the check in onFocusout to fail
                    if (isFocused)
                    {
                        return;
                    }

                    isFocused = true;
                    focusInValue = picker.val();
                    focusInError = errorHelper.hasError(picker);
                    errorHelper.toggleError(picker, false);
                }

                function onFocusout(focusEvent)
                {
                    isFocused = false;
                    if (focusInValue !== picker.val())
                    {
                        picker.trigger("change");
                    }
                    else
                    {
                        errorHelper.toggleError(picker, focusInError);
                    }
                }
            }
            
            function onClick(mouseEvent)
            {
                errorHelper.removeError(picker);
                picker.datepicker('show');
                selectDelimitedDatePart(mouseEvent);
            }

            function setDatePicker()
            {
                skyward.datepicker.setDatePicker(picker);
                picker.trigger("datePickerChangeComplete");
            }

            function replaceSelectionWithChar(currentValue, char, selectionStart, selectionEnd)
            {
                // Handle unsupported keys
                if (!char || dateParsingHelper.getInvalidCharsRegex().test(char))
                {
                    return currentValue;
                }

                // Handle the new character
                var newValue = currentValue.slice(0, selectionStart) + char + currentValue.slice(selectionEnd);

                // Remove potential trailing day string
                var dayStartIndex = newValue.search(dateParsingHelper.getInvalidCharsRegex());
                if (dayStartIndex !== -1 && dayStartIndex > 0)
                {
                    // The day is preceded by a space
                    newValue = newValue.substring(0, dayStartIndex - 1);
                }

                // The only character cannot be a delimiter
                if (newValue.length === 1 && dateParsingHelper.getDelimitersRegex().test(newValue))
                {
                    return currentValue;
                }

                // Dates cannot have more than 10 characters
                if (newValue.length > 10)
                {
                    return currentValue;
                }

                // Dates cannot have more than 8 digits
                var numDigits = newValue.replace(/[^0-9]/g, "").length;
                if (numDigits > 8)
                {
                    return currentValue;
                }

                // Dates cannot have more than 2 delimiters
                var delimiters = newValue.match(dateParsingHelper.getDelimitersRegex());
                if (delimiters && delimiters.length > 2)
                {
                    return currentValue;
                }

                // Delimiters should not touch
                var delimiterOneIndex = newValue.search(dateParsingHelper.getDelimitersRegex());
                var delimiterTwoIndex = delimiterOneIndex + newValue.substring(delimiterOneIndex + 1).search(dateParsingHelper.getDelimitersRegex()) + 1;
                if (delimiterOneIndex == delimiterTwoIndex + 1)
                {
                    return currentValue;
                }

                // Replace delimiters
                newValue = newValue.replace(dateParsingHelper.getDelimitersRegex(), '/');

                return newValue;
            }

            function selectDelimitedDatePart(mouseEvent)
            {
                // Ignore multiple character selections
                if (mouseEvent.target.selectionStart !== mouseEvent.target.selectionEnd)
                {
                    return;
                }

                var value = picker.val();

                // Remove potential trailing day string
                value = value.split(" ")[0];

                // Ignore invalid full-date formats
                var delimiters = value.match(dateParsingHelper.getDelimitersRegex());
                if (!delimiters || delimiters.length !== 2)
                {
                    return;
                }

                var delimiterOneIndex = value.search(dateParsingHelper.getDelimitersRegex());
                var delimiterTwoIndex = delimiterOneIndex + value.substring(delimiterOneIndex + 1).search(dateParsingHelper.getDelimitersRegex()) + 1;

                // Select the date portion clicked in
                var cursorPosition = mouseEvent.target.selectionStart;
                if (cursorPosition <= delimiterOneIndex)
                {
                    mouseEvent.target.selectionStart = 0;
                    mouseEvent.target.selectionEnd = delimiterOneIndex;
                }
                else if (cursorPosition > delimiterOneIndex && cursorPosition <= delimiterTwoIndex)
                {
                    mouseEvent.target.selectionStart = delimiterOneIndex + 1;
                    mouseEvent.target.selectionEnd = delimiterTwoIndex;
                }
                else
                {
                    mouseEvent.target.selectionStart = delimiterTwoIndex + 1;
                    mouseEvent.target.selectionEnd = value.length;
                }
            }
        }

        function setupModalControl(picker)
        {
            var modalLayer;

            picker.datepicker(
            {
                duration: 0,  // don't animate showing/hiding the picker. moving from one picker to another quickly will cause the second picker not to show
                defaultDate: skyward.time.now(), // ensure time traveling is honored
                onSelect: function ()
                {
                    $(this).change().focus();
                },
                beforeShow: function ()
                {
                    var control = $(this);

                    if (control.is("[readonly]"))
                    {
                        return false;
                    }

                    if (control.hasClass('relativeDate'))
                    {
                        control.data(_revertToRelativeIfNoDateSelected, true);
                        skyward.relativedatepicker.showDatePicker(this.id);
                    }

                    var datepickerPopup = $.datepicker.dpDiv;
                    setDatePickerPositioning(control, datepickerPopup);

                    skyward.window.registerLayoutResizeCallback(function ()
                    {
                        setDatePickerPositioning(control, datepickerPopup);
                    });

                    modalLayer = skyward.modalLayer.newModalLayer(datepickerPopup, function ()
                    {
                        datepickerPopup.appendTo(document.body);
                        control.datepicker("hide");
                    },
                    {
                        closeOnEscape: true,
                        expose: [control]
                    });
                           
                    return true;
                },
                onClose: function ()
                {
                    var control = $(this);
                    skyward.window.removeLayoutResizeCallback(setDatePickerPositioning);

                    if (control.data(_revertToRelativeIfNoDateSelected))
                    {
                        control.data(_revertToRelativeIfNoDateSelected, false);
                        skyward.relativedatepicker.showRelativeDateDisplay(this.id, control.attr('data-relative-date'));
                    }
                    if (!modalLayer.closing)
                    {
                        modalLayer.close();
                    }
                    
                }
            });
        }

        function setupVisibility(picker)
        {
            // When an absolute datepicker is intended to be hidden, the <input> element has the class "hidden", but the
            // wrapper we created in setupDateIconSpan() is still visible. We want to transfer the hidden-ness to the
            // wrapper, so the entire datepicker is hidden, and the <input> isn't hidden separately.
            // Relative datepickers come from the server already wrapped, and with the hidden class already applied to
            // their wrapper, so they don't have to do anything.
            if (picker.hasClass("hidden") && !picker.hasClass("hasRelativeDatePicker"))
            {
                picker.closest(".datepicker-wrapper").hide();
                picker.removeClass("hidden");
            }
        }

        var setDatePickerPositioning = function (control, datePickerPopup)
        {
            var offset = control.offset();
            var spaceAbove = offset.top;
            var spaceBelow = window.innerHeight - offset.top;

            var padding = 3;
            var top = spaceAbove > spaceBelow ? (spaceAbove - skyward.datepicker.getMaxDatepickerHeight() - padding) : spaceAbove + control.outerHeight() + padding;
            if (top < 0)
            {
                top = 0;
            }
            else if (top + skyward.datepicker.getMaxDatepickerHeight() > window.innerHeight)
            {
                top = window.innerHeight - skyward.datepicker.getMaxDatepickerHeight();
            }

            datePickerPopup.css(
                {
                    top: top,
                    left: offset.left,
                    position: 'absolute'
                });
        };

        function showDatepicker(picker)
        {
            picker.datepicker("show");
        }

        function getDatepickerHeight(date, frameWindow)
        {
            // Calling setDate() is necessary to get the height of the currently selected month (if you selected a month
            // with a different number of weeks, then opened the datepicker again, it would still have the old height).
            // Using a separate datepicker is necessary to keep setDate() from triggering unwanted change events.
            var body = $(frameWindow.document.body);
            var control = $('<input>');
            control.datepicker();
            control.datepicker('setDate', date);
            control.datepicker('refresh');
            var scrollContainer = $("<div style='height: 0; width: 0; position: absolute; overflow: hidden;'>", frameWindow);
            var widget = control.datepicker('widget');
            scrollContainer.append(widget);
            body.append(scrollContainer);
            var height = widget.outerHeight(true);
            body.append(widget);
            control.datepicker('destroy');
            scrollContainer.remove();
            return height;
        }

        /**
         * Override datepicker "today" button so that it both highlights *and* selects the date.
         * 
         * @param {any} id
         */
        function goToTodayDayOverride(id)
        {
            _baseGotoToday?.call(this, id);

            var target = $(id);
            var inst = this._getInst(target[0]);
            var now = skyward.time.now();
            this._selectDate(id, this._formatDate(inst, now.getDate(), now.getMonth(), now.getFullYear()));
        }

        function doKeyDownOverride(keyboardEvent)
        {
            var eventKeys = skyward.keys.getKeyNamesFromEvent(keyboardEvent);

            // Override datepicker keydown to prefer our date parsing on enter
            if (eventKeys.ENTER) // Copy how jquery-ui handles keys rather than skyward.ui.keys.js
            {
                var target = $(keyboardEvent.target);
                var date = dateParsingHelper.parse(target.val());

                if (date !== dateParsingHelper.getInvalidDate())
                {
                    target.datepicker("setDate", date);
                }
            }
            _baseDoKeyDown(keyboardEvent);
        }

        function toggleVisibility(picker, visibility, animate)
        {
            var outermostSelector = picker.hasClass("hasRelativeDatePicker") ? ".relativeDate__positioning" : ".datepicker-wrapper";
            var parentElem = picker.closest(outermostSelector);

            if (animate !== false)
            {
                parentElem.animateToggle(visibility);
            }
            else
            {
                parentElem.toggle(visibility);
            }
            return parentElem;
        }

        var dateParsingHelper = (function ()
        {
            var _invalidDate = new Date(NaN);

            var dateParsingHelper = {};

            dateParsingHelper.getInvalidDate = function ()
            {
                return _invalidDate;
            };

            dateParsingHelper.getInvalidCharsRegex = function ()
            {
                return /[^0-9.\/\\\- ]/g;
            };

            dateParsingHelper.getDelimitersRegex = function ()
            {
                return /[.\/\\\- ]/g;
            };

            dateParsingHelper.parse = function (value)
            {
                if (!value || typeof value !== "string")
                {
                    return _invalidDate;
                }

                value = value.trim();
                value = value.substring(0, 10);
                value = value.replace(dateParsingHelper.getInvalidCharsRegex(), '');

                var valueHasDelimiters = dateParsingHelper.getDelimitersRegex().test(value);
                return valueHasDelimiters ? parseDateWithDelimiters(value) : parseDateWithoutDelimiters(value);
            };

            return dateParsingHelper;

            function parseDateWithDelimiters(value)
            {
                var month;
                var day;
                var year;

                value = value.split(dateParsingHelper.getDelimitersRegex());
                switch (value.length)
                {
                    case 3:
                        month = parseMonthString(value[0]);
                        day = parseDayString(value[1]);
                        year = parseYearString(value[2]);
                        break;

                    case 2:
                        month = parseMonthString(value[0]);
                        day = parseDayString(value[1]);
                        year = new Date().getFullYear();
                        break;

                    default:
                        return _invalidDate;
                }                

                if (month === _invalidDate || day === _invalidDate || year === _invalidDate)
                {
                    return _invalidDate;
                }

                if (!skyward.validation.validDate(month + '/' + day + '/' + year.toString().padLeft(4, "0")))
                {
                    return _invalidDate;
                }

                return skyward.time.newDate(year, month - 1, day);
            }

            function parseDateWithoutDelimiters(value)
            {
                var dayMonth;
                var year;

                switch (value.length)
                {
                    case 4:
                        dayMonth = parseDayMonthString(value.slice(0, 2));
                        year = parseYearString(value.slice(2, 4));
                        break;

                    case 5:
                        dayMonth = parseDayMonthString(value.slice(0, 3));
                        year = parseYearString(value.slice(3, 5));
                        break;

                    case 6:
                        dayMonth = parseDayMonthString(value.slice(0, 4));
                        year = parseYearString(value.slice(4, 6));
                        break;

                    case 7:
                        dayMonth = parseDayMonthString(value.slice(0, 3));
                        year = parseYearString(value.slice(3, 7));
                        break;

                    case 8:
                        dayMonth = parseDayMonthString(value.slice(0, 4));
                        year = parseYearString(value.slice(4, 8));
                        break;
                    default:
                        return _invalidDate;
                }

                if (dayMonth.day === _invalidDate || dayMonth.month === _invalidDate || year === _invalidDate)
                {
                    return _invalidDate;
                }

                if (!skyward.validation.validDate(dayMonth.month + '/' + dayMonth.day + '/' + year.toString().padLeft(4, "0")))
                {
                    return _invalidDate;
                }

                return skyward.time.newDate(year, dayMonth.month - 1, dayMonth.day);
            }

            function parseDayMonthString(value)
            {
                var month;
                var day;

                switch (value.length)
                {
                    case 2:
                        month = '0' + value.charAt(0);
                        day = '0' + value.charAt(1);
                        break;

                    case 3:
                        if (value.charAt(0) === '0' || value.charAt(1) === '0')
                        {
                            month = value.charAt(0) + value.charAt(1);
                            day = '0' + value.charAt(2); // They didn't have a leading 0 for the month, so they probably didn't want one for the day
                        }
                        else
                        {
                            month = '0' + value.charAt(0);
                            day = value.charAt(1) + value.charAt(2);
                        }
                        break;

                    case 4:
                        month = value.charAt(0) + value.charAt(1);
                        day = value.charAt(2) + value.charAt(3);
                        break;
                }

                var dayMonth =
                {
                    month: parseMonthString(month),
                    day: parseDayString(day)
                };

                return dayMonth;
            }

            function parseDayString(value)
            {
                value = parseInt(value);
                return !isNaN(value) ? value : _invalidDate;
            }

            function parseMonthString(value)
            {
                value = parseInt(value);
                return !isNaN(value) ? value : _invalidDate;
            }

            function parseYearString(value)
            {
                var year;

                switch (value.length)
                {
                    case 2:
                        var currentYear = new Date().getFullYear();
                        var currentCentury = parseInt(currentYear.toString().slice(0, -2), 10);

                        var proposedYear = parseInt(currentCentury + value);
                        var minYear = currentYear - 70;
                        var maxYear = currentYear + 30;

                        if (minYear < proposedYear && maxYear >= proposedYear)
                        {
                            year = proposedYear;
                        }
                        else
                        {
                            year = (currentCentury - 1).toString() + value;
                        }
                        break;

                    case 4:
                        year = value;
                        break;
                }

                year = parseInt(year);
                return !isNaN(year) ? year : _invalidDate;
            }
        })();

        var errorHelper = (function ()
        {
            var _errorClass = "js-error-control--preSaveValidation";
            var _errorLi = $("<li>", {
                addClass: ["error-text", "js-error-text--invalidDate"],
                append: $("<span>", {
                    append: [
                        skyward.svg.getSvg("Error", "Error").addClass(["alertError", "svgNoHover"]),
                        $("<span>", {
                            addClass: "validationSpan",
                            text: "This is not a valid date."
                        })
                    ]
                })
            });

            var errorHelper = {};

            errorHelper.showError = function (picker)
            {
                errorHelper.toggleError(picker, true);
            };

            errorHelper.removeError = function (picker)
            {
                errorHelper.toggleError(picker, false);
            };

            errorHelper.hasError = function (picker)
            {
                return picker.hasClass(_errorClass);
            };

            errorHelper.toggleError = function (picker, toggle)
            {
                let dataValidateMessageFor = $();
                let dataValidateTextFor = $();
                let searchRoot = $(".workflowContent");
                if (searchRoot.length === 0)
                {
                    searchRoot = $(document)
                }

                var key = picker.attr("id");
                if (key)
                {
                    // DatePickers' ids within DataObjectViewers have the DataObjectViewer's id prepended to them
                    // with an underscore, so remove the final underscore and anything preceding it.
                    var datePickerID = key.split('_');
                    datePickerID = datePickerID[datePickerID.length - 1];

                    dataValidateMessageFor = searchRoot.find('[data-validate-message-for="' + datePickerID + '"]');
                    dataValidateTextFor = searchRoot.find('[for="' + key + '"]');
                }

                if (dataValidateMessageFor.length === 0)
                {
                    key = picker.attr('data-validate-control-for')
                    dataValidateMessageFor = searchRoot.find('[data-validate-message-for="' + key + '"]');
                    dataValidateTextFor = searchRoot.find(`[data-validate-text-for="${key}"]`);
                }
                let hasOtherErrors = false;

                if (dataValidateMessageFor.length !== 0)
                {
                    const oldErrorMessage = dataValidateMessageFor.find(".js-error-text--invalidDate");
                    const hadError = oldErrorMessage.length > 0;
                    hasOtherErrors = dataValidateMessageFor.find(".error-text").not(oldErrorMessage).length > 0;

                    if (toggle != hadError)
                    {
                        if (toggle)
                        {
                            let ul = dataValidateMessageFor.find("ul.validation-list");
                            if (ul.length === 0)
                            {
                                ul = $("<ul>", { addClass: "validation-list" }).appendTo(dataValidateMessageFor);
                            }
                            _errorLi.clone().appendTo(ul);
                        }
                        else
                        {
                            oldErrorMessage.remove();
                            const ul = dataValidateMessageFor.find("ul.validation-list");
                            if (ul.children().length === 0)
                            {
                                ul.remove();
                            }
                        }
                        const cma = skyward.contentMessageArea.getContentMessageArea(picker.closest(".js-changeTrackingRoot").parent());
                        cma?.modifyValidationCount(toggle ? 1 : -1, 0);
                    }
                }

                picker.toggleClass(_errorClass, toggle);
                picker.toggleClass("error-control", toggle || hasOtherErrors);
                dataValidateTextFor.toggleClass("error-text", toggle || hasOtherErrors);
            };

            return errorHelper;
        })();

        $.datepicker._triggerClass += "datepicker-trigger";
        $.datepicker._gotoToday = goToTodayDayOverride;
        $.datepicker._doKeyDown = doKeyDownOverride;
        $.datepicker.setDefaults(
        {
            dateFormat: "mm/dd/yy",
            prevText: "←",
            nextText: "→",
            dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
            constrainInput: true,
            showOtherMonths: true,
            selectOtherMonths: true,
            showButtonPanel: true,
            changeYear: true,
            changeMonth: true,
            showOn: "button",
            showAnim: "fadeIn",
            yearRange: "c-100:c+10",
            minDate: skyward.time.newDate(1, 0, 1),
            maxDate: skyward.time.newDate(9999, 11, 31)
        });

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        "use strict";

        skyward.accountDimensionEEL = skyward.accountDimensionEEL || {};
        skyward.accountDimensionEEL.popupModalLayer = null;
        skyward.accountDimensionEEL.popupModalLayerOpen = false;

        const idGenerator = skyward.extensions.getIdGenerator("popup", "_accountDimensionEELBrowse");

        var controlsTypeChangedCallback;
        var beforeKeyDownCallback;
        var afterKeyDownCallback;
        var beforeKeyUpCallback;
        var afterKeyUpCallback;

        skyward.accountDimensionEEL.setControlsTypeChangedCallback = function (callback)
        {
            controlsTypeChangedCallback = callback;
        };

        skyward.accountDimensionEEL.setBeforeKeyDownCallback = function (callback)
        {
            beforeKeyDownCallback = callback;
        };

        skyward.accountDimensionEEL.setAfterKeyDownCallback = function (callback)
        {
            afterKeyDownCallback = callback;
        };

        skyward.accountDimensionEEL.setBeforeKeyUpCallback = function (callback)
        {
            beforeKeyUpCallback = callback;
        };

        skyward.accountDimensionEEL.setAfterKeyUpCallback = function (callback)
        {
            afterKeyUpCallback = callback;
        };

        var init = function ()
        {
            var accountDimensionEEL = $(this);
            var accountDimensionEELCode = accountDimensionEEL.find(".accountDimensionEELCode");
            var accountDimensionEELCodeButton = accountDimensionEEL.find(".accountDimensionEELCodeButton");
            var accountDimensionEELDescription = accountDimensionEEL.find(".accountDimensionEELDescription");
            var accountDimensionEELValue = accountDimensionEEL.find(".accountDimensionEELValue"); //hidden id
            var accountDimensionEELCodeValue = accountDimensionEEL.find(".accountDimensionEELCodeValue"); //hidden code value
            var accountDimensionEELDescriptionValue = accountDimensionEEL.find(".accountDimensionEELDescriptionValue"); //hidden description value
            var accountDimensionEELpostData = accountDimensionEEL.data("postdata");
            var accountDimensionEELhidePrimaryBrowseButton = accountDimensionEEL.data("hideprimarybrowsebutton");
            //get the hidden values
            var accountDimensionEELValueData = accountDimensionEELValue.data();

            if (!accountDimensionEEL.data("requestDataHashReadonly"))
            {
                loadRequestDataHashes(accountDimensionEEL.data("requestDataHashSrc"), accountDimensionEEL.getIdAndPrefix().id, accountDimensionEELValueData);
            }
            
            let selectedValue = null;
            let selectedValueHash = null;
            
            const singleRequestHandler = new skyward.extensions.SequentialOperationHandler(true);
            const transaction = new skyward.requestDataHash.HashTransaction(accountDimensionEELValue);

            const label = accountDimensionEEL.findLabel();
            if (label.length)
            {
                const labelText = label.text().replace(/\*/g, "");
                accountDimensionEELCode.attr("aria-label", labelText + " Dimension Code");
                accountDimensionEELDescription.attr("aria-label", labelText + " Dimension Description");
                // The forID of accountDimensionEEL points to the container.
                // Assign the forID to the first textbox in the container for valid accessibility. 
                const firstInputId = (accountDimensionEELCode.length ? accountDimensionEELCode : accountDimensionEELDescription).attr("id");
                if (firstInputId)
                {
                    label.attr("for", firstInputId);
                }
            }

            //Selector filter
            var filter = accountDimensionEEL.data("filter");

            var popupModalLayer = null;
            
            skyward.eel.setFocusToTextBoxOnClick(accountDimensionEEL);

            var getBrowsePostData = function ()
            {
                var postData = {};
                postData.filter = JSON.stringify(filter);

                return $.extend({}, accountDimensionEELpostData, postData);
            }

            var addToBrowseList = function (browseId, textbox)
            {
                const isCode = textbox.hasClass("js-accountDimensionEELCode");
                skyward.browse.browseList[browseId] =
                {
                    id: browseId,
                    pageModule: accountDimensionEELValueData.area,
                    pageObject: accountDimensionEELValueData.controller,
                    pageScreen: accountDimensionEELValueData.action,
                    browseType: "Default",
                    routeModule: accountDimensionEELValueData.area,
                    routeObject: accountDimensionEELValueData.controller,
                    dataModule: accountDimensionEELValueData.area,
                    dataObject: accountDimensionEELValueData.controller,
                    browseName: "AccountDimensionBrowse",
                    selectMode: true,
                    codeEelName: accountDimensionEELValue.attr("name"),
                    codeEelDescription: accountDimensionEELDescription.attr("id"),
                    hidePrimaryBrowseButton: accountDimensionEELhidePrimaryBrowseButton,
                    routeHash: isCode ? accountDimensionEELValueData.codeRouteHash : accountDimensionEELValueData.descriptionRouteHash,
                    requestDataHash: isCode ? accountDimensionEELValueData.codeRequestDataHash : accountDimensionEELValueData.descriptionRequestDataHash,
                    refreshTimeout: -1,
                    data: getBrowsePostData(textbox),
                    rowDataDefinitions: {
                        value: accountDimensionEELValueData.primaryKeyName
                    },
                    dynamicFilterHashes: accountDimensionEELValueData.codeDynamicFilterHashes,
                    dynamicFilterData: textbox.data(),
                    keyEventsEnabled: true,
                    renderViewButton: false,
                    disableBrowseSort: true,
                    hideOptionsButton: true,
                    preventColumnResize: true,
                    queryParameterData: accountDimensionEEL.codeEELQueryParameterData
                };
                skyward.browse.openBrowses.push(browseId);
            };

            var createModalLayer = function (browseId, textbox)
            {
                const textBoxId = textbox.attr("id");
                const popupContent = $("<div>", { "class": "popup", id: textBoxId + "_popup" });
                popupContent.append($("<div>", { id: browseId, "class": "browse" }));

                skyward.browse.eventCallbacks.recordSelectionMade.registerCallback(selectionMadeHandler);

                const beforeClose = function ()
                {
                    textbox.attr("aria-expanded", "false")

                    if (selectedValue == null)
                    {
                        accountDimensionEELValue.val(null);
                        setSelectedValueHash(accountDimensionEELValue, undefined);
                        accountDimensionEELValue.change();
                    }
                    else if (selectedValue != accountDimensionEELValue.val())
                    {
                        accountDimensionEELValue.val(selectedValue);
                        setSelectedValueHash(accountDimensionEELValue, selectedValueHash);
                        accountDimensionEELValue.change();
                    }

                    skyward.browse.eventCallbacks.recordSelectionMade.deregisterCallback(selectionMadeHandler);

                    updateBoxes();
                    popupModalLayer = null;
                    skyward.accountDimensionEEL.popupModalLayer = null;
                    skyward.accountDimensionEEL.popupModalLayerOpen = false;
                    skyward.browse.openBrowses.splice(skyward.browse.openBrowses.indexOf(browseId), 1);
                };

                return skyward.modalLayer.showCodeEELDialog(popupContent, textbox, textbox.closest(".js-showEELContainer"), beforeClose, accountDimensionEELValueData);

                function selectionMadeHandler(eventData)
                {
                    if (eventData.browseId === browseId)
                    {
                        selectedValue = eventData.selectedId;
                        const browse = skyward.browse.browseList[browseId];
                        const selectedIndex = browse.primaryKeys.indexOf(eventData.selectedId);
                        selectedValueHash = browse.rowDataHash[selectedIndex];
                    }
                }
            };

            var showPopup = skyward.debounce(function (textBox)
            {
                textBox.attr("aria-expanded", "true");
                if (skyward.accountDimensionEEL.popupModalLayer == null)
                {
                    const browseId = idGenerator.getNewId();
                    addToBrowseList(browseId, textBox);
                    popupModalLayer = createModalLayer(browseId, textBox);
                    selectedValue = accountDimensionEELValue.val();
                    skyward.accountDimensionEEL.popupModalLayer = popupModalLayer;
                    skyward.accountDimensionEEL.popupModalLayerOpen = true;
                }
            }, 100);

            var doSearch = skyward.debounce(function (searchText)
            {
                const browse = skyward.browse.getInnerBrowse(accountDimensionEELValueData.layer?.container);
                if (browse === undefined)
                {
                    return;
                }
                return singleRequestHandler.run((signal) =>
                {
                    return skyward.browse.performCodeEELSearch(browse.id, { codeEELSearchText: searchText, codeEelName: accountDimensionEELCodeValue.attr("id"), seekId: accountDimensionEELValue.val() }, signal);
                });
            }, 100);

            var toggleCodePopup = function ()
            {
                if (!accountDimensionEELCode.attr("readonly"))
                {
                    if (popupModalLayer == null)
                    {
                        showPopup(accountDimensionEELCode);
                        doSearch();
                    }
                    else
                    {
                        popupModalLayer.close();
                    }
                }
            };

            var keydown = function (event)
            {
                if (!skyward.keys.keyIsNumberOrLetter(event.shiftKey, event.which))
                {
                    if (event.which == 27)
                    {
                        if (popupModalLayer != null && popupModalLayer.onscreen)
                        {
                            popupModalLayer.close();
                        }
                        else
                        {
                            skyward.window.closePopup();
                        }
                    }
                    else if (Array(8, 9, 13, 16, 27, 37, 38, 40, 116, 123).indexOf(event.which) == -1)
                    {
                        event.preventDefault();
                    }
                }

                //before callbacks
                if (typeof beforeKeyDownCallback === 'function')
                {
                    beforeKeyDownCallback(event);
                    if (event.isDefaultPrevented())
                    {
                        return;
                    }
                }

                var sender = $(this);
                var textBoxId = sender.attr("id");
                var codeValue = sender.val();
                var codeMaxLength = $("#" + textBoxId).attr('maxlength');

                if (event.which == 9) //Tab
                {
                    if (popupModalLayer && popupModalLayer.onscreen)
                    {
                        popupModalLayer.close();
                    }

                    accountDimensionEELCodeValue.val(codeValue);
                    accountDimensionEELCode.val(codeValue);
                }
                else if (event.shiftKey && event.which == 9)
                {
                    if (popupModalLayer && popupModalLayer.onscreen)
                    {
                        popupModalLayer.close();
                    }
                }
                else if (event.which == 13) //enter
                {
                    if (popupModalLayer == null && skyward.accountDimensionEEL.popupModalLayer == null)
                    {
                        if (codeValue.length != codeMaxLength)
                        {
                            codeValue = codeValue.padRight(codeMaxLength, '0');
                        }

                        accountDimensionEELCode.val(codeValue);
                        accountDimensionEELCodeValue.val(codeValue);
                        skyward.accountDimensionEEL.setDescription(sender, false);
                        skyward.tabbing.focusAfter(sender);
                        skyward.accountLookupForm.checkForSingleAccount(sender);
                    }
                }

                //after callbacks
                if (typeof afterKeyDownCallback === 'function')
                {
                    afterKeyDownCallback(event);
                    if (event.isDefaultPrevented())
                    {
                        return;
                    }
                }
            };

            var keyup = function (event)
            {                   
                if (typeof beforeKeyUpCallback === 'function')
                {
                    beforeKeyUpCallback(event);
                    if (event.isDefaultPrevented())
                    {
                        return;
                    }
                }

                var sender = $(this);
                var textBoxId = sender.attr("id");
                var codeValue = sender.val();
                if (codeValue != null)
                {
                    codeValue = codeValue.toString().toUpperCase();
                    sender.val(codeValue);
                }
                var codeMaxLength = $("#" + textBoxId).attr('maxlength');

                if (skyward.accountDimensionEEL.popupModalLayer != null && (popupModalLayer == null || !popupModalLayer.onscreen))
                {
                    return;
                }

                var shiftTab = false;
                if (event.which == 16 || event.which == 9 || event.shiftKey)
                {
                    shiftTab = true;
                }

                //set description when entered text is at the max length for this dimensions
                if ((popupModalLayer == null || (popupModalLayer && !popupModalLayer.onscreen)) && codeValue.length == codeMaxLength && event.which != 8 && event.which != 39 && event.which != 40)//8 = backspace, 39 = right arrow, 40 = down arrow
                {
                    //set the hidden code value
                    sender.siblings('.accountDimensionEELCodeValue').val(codeValue);
                    skyward.accountDimensionEEL.setDescription(sender, shiftTab);

                    // Don't run if shift tab is pressed or the enter key is pressed.
                    if (!shiftTab && event.which != 13) {
                        skyward.tabbing.focusAfter(sender);
                    }
                }

                //clear the current textbox's hidden id/value and description
                if (codeValue.length == 0)
                {
                    skyward.accountDimensionEEL.clear(sender.parent());
                }

                if (popupModalLayer == null && (event.which == 39 || event.which == 40) && codeValue.length <= codeMaxLength)//39 = right arrow, 40 = down arrow
                {
                    showPopup(sender);
                    if (codeValue.length == codeMaxLength)
                    {
                        doSearch();
                    }
                    else
                    {
                        doSearch(codeValue);
                    }
                }
                else if (popupModalLayer && popupModalLayer.onscreen)
                {
                    if (Array(27, 40, 38, 13, 9, 16).indexOf(event.which) == -1)
                    {
                        doSearch(codeValue);
                    }
                }

                if ((popupModalLayer == null || (popupModalLayer && !popupModalLayer.onscreen)) && codeValue.length == codeMaxLength)
                {
                    //do nothing
                }
                else if (codeValue.length == codeMaxLength && !(event.which == 16 || event.shiftKey || event.which == 9 || event.which == 39 || event.which == 40))
                {
                    skyward.accountDimensionEEL.setDescription(sender, false, true);
                    if (popupModalLayer != null)
                    {
                        popupModalLayer.close();
                    }
                    updateBoxes();
                }

                if (typeof afterKeyUpCallback === 'function')
                {
                    afterKeyUpCallback(event);
                    if (event.isDefaultPrevented())
                    {
                        return;
                    }
                }
            };

            var updateBoxes = function ()
            {
                return singleRequestHandler.run((signal) => transaction.run(signal, async () =>
                {
                    if (accountDimensionEELValue.val())
                    {
                        const browseContainer = accountDimensionEELValueData.layer?.container;
                        if (browseContainer === undefined)
                        {
                            return;
                        }

                        const browse = skyward.browse.getInnerBrowse(browseContainer);
                        const dependencies = await skyward.requestDataHash.waitForDependencies(browse.dynamicFilterData, skyward.controls.getScopeContainer(browse.browse), signal);
                        const postData = skyward.browse.getRequiredBrowseData(browse, {}, dependencies);

                        return $.ajax({
                            url: skyward.global.virtualDir + "Account/Dimension/CodeEEL/" + accountDimensionEELValue.val(),
                            type: "POST",
                            dataType: "JSON",
                            data: postData,
                            signal: signal,
                            success: function (data)
                            {
                                const description = (data != null && data.description != null) ? data.description : '';

                                accountDimensionEELCode.val(data.code);
                                skyward.accountLookupForm.checkForSingleAccount(accountDimensionEELCode);
                                accountDimensionEELCodeValue.val(data.code);
                                accountDimensionEELDescription.val(description).text(description);
                                accountDimensionEELDescriptionValue.val(description);

                                setSelectedValueHash(accountDimensionEELValue, data.selectedValueHash);

                                const dependents = accountDimensionEELCode.data('dependents');

                                if (dependents)
                                {
                                    updateDependents(dependents);
                                }

                                if (accountDimensionEELCode.hasClass('ControlsType') && typeof controlsTypeChangedCallback === 'function')
                                {
                                    controlsTypeChangedCallback(accountDimensionEELCode, true);
                                }
                                //only try moving focus if the screen with the eels is not closing (closing makes the eels not tabbable)
                                else if (accountDimensionEELCode.is(':tabbable'))
                                {
                                    skyward.tabbing.focusAfter(accountDimensionEELCode);
                                }
                            },
                        });
                    }
                    else
                    {
                        setSelectedValueHash(accountDimensionEELValue, "");
                    }
                }));
            };

            var updateDependents = function (dependents)
            {
                $.each(dependents.dependents, function (k, v)
                {
                    var dependentCode = $('#' + v.Id).children('.accountDimensionEELCode');
                    if (dependentCode.length > 0)
                    {
                        var maxLength = dependentCode.attr('maxlength');
                        var codeLength = dependentCode.val().length;

                        if (codeLength == maxLength)
                        {
                            skyward.accountDimensionEEL.setDescription(dependentCode, false);
                        }
                    }
                });
            };

            //public methods
            skyward.accountDimensionEEL.setDescription = function (sender, preventFocusChange, forceValueChangeEvent)
            {
                return singleRequestHandler.run((signal) => transaction.run(signal, async () =>
                {
                    const code = $(sender);
                    const codeContainer = code.parent();
                    const dimensionEELValue = codeContainer.siblings('.accountDimensionEELValue');

                    const codeValue = code.val();
                    const dimensionGroupId = code.parent().siblings('.accountDimensionEELDimensionGroup').val();
                    const fundId = $('.IsFund').parent().siblings('.accountDimensionEELValue').val();
                    const isFund = code.hasClass('IsFund');
                    let parentDimensionID = null;
                    const isWorkflow = $('input[name=IsOnWorkflow]').val() == 'true'; // This is a string coming from a hidden field

                    //parent dimension info
                    const parentDimensionName = code.data("parentname");
                    if (parentDimensionName)
                    {
                        const parentDimension = $('#' + parentDimensionName + '_hiddenid');
                        if (parentDimension.length > 0)
                        {
                            parentDimensionID = parentDimension.val();
                            parentDimensionID = (parentDimensionID != '') ? parentDimensionID : 0;
                        }
                    }
                    //child dimension info
                    const childDimensionName = accountDimensionEEL.prop("id") + "ChildDimension";

                    if (sender.hasClass('ControlsType') && typeof controlsTypeChangedCallback === 'function')
                    {
                        controlsTypeChangedCallback(sender, preventFocusChange);
                    }

                    await skyward.requestDataHash.waitForDependencies(code.data(), skyward.controls.getScopeContainer(code), signal);

                    return $.ajax(
                        {
                            url: skyward.global.virtualDir + "Account/Dimension/AccountDimensionEELDescriptionLookup",
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                code: codeValue,
                                dimensionGroupId: dimensionGroupId,
                                fundId: fundId,
                                isFund: isFund,
                                parentDimensionID: parentDimensionID,
                                dimensionFieldBaseHash: getHashFromEditableFields(dimensionEELValue.attr("id"))
                            },
                            signal: signal,
                            success: function (data)
                            {
                                const hiddenCode = codeContainer.siblings('.accountDimensionEELCodeValue');
                                const description = codeContainer.siblings('.accountDimensionEELDescription');
                                const hiddenDescription = codeContainer.siblings('.accountDimensionEELDescriptionValue');
                                const hiddenDimensionIDCopiedFrom = codeContainer.siblings('.accountDimensionEELDimensionIDCopiedFromValue');

                                const dimensionValueOld = dimensionEELValue.val();
                                const dimensionValueNew = data != null ? data.DimensionId : '';

                                hiddenCode.val(code.val());
                                hiddenDimensionIDCopiedFrom.val((data != null && data.DimensionIDCopiedFrom != null) ? data.DimensionIDCopiedFrom : '');
                                description.val((data != null && data.Description != null) ? data.Description : '');
                                hiddenDescription.val(description.text());

                                setSelectedValueHash(dimensionEELValue, data != null && data.selectedValueHash ? data.selectedValueHash : "");

                                const dependents = code.parent().data('dependents');

                                if (dimensionValueOld != dimensionValueNew)
                                {
                                    dimensionEELValue.val(dimensionValueNew);

                                    if (dependents)
                                    {
                                        updateDependents(dependents);
                                    }
                                }

                                if (forceValueChangeEvent)
                                {
                                    dimensionEELValue.change();
                                }

                                skyward.ajax.getAllInputElements(".workflowContent").then(postData =>
                                {
                                    const container = skyward.window.getClosestContentPanel(code);

                                    if (isWorkflow)
                                    {
                                        sendAjaxWorkflow(null, dimensionEELValue.prop("name"), postData, "Account/Dimension/SetSummaryDefaultsWorkflow", container);
                                    }
                                    else if (isFund)
                                    {
                                        sendAjaxWorkflow(null, dimensionEELValue.prop("name"), postData, "Account/Dimension/VerifyAndUpdateFundDependentDimensions", container);
                                    }

                                    if (code.siblings(childDimensionName))
                                    {
                                        sendAjaxWorkflow(null, dimensionEELValue.prop("name"), postData, "Account/Account/VerifyAndUpdateParentChildDimensions", container);
                                    }
                                });
                            }
                        }
                    );
                }));
            };

            var getHashFromEditableFields = function (dimensionEELValueId)
            {
                const editableFieldsInput = $(".editableFields");
                if (editableFieldsInput.length === 0)
                {
                    return "";
                }

                for (let i = 0; i < editableFieldsInput.length; i++)
                {
                    try
                    {
                        const input = $(editableFieldsInput[i]);
                        const dataStr = input.attr("data-original-value");
                        const securedData = JSON.parse(dataStr);

                        if (securedData.Fields && securedData.Fields[dimensionEELValueId])
                        {
                            return securedData.Fields[dimensionEELValueId].Hash;
                        }
                    }
                    catch (e)
                    {
                        continue;
                    }
                }

                return "";
            };

            var sendAjaxWorkflow = function (event, targetName, postData, ajaxPath, container)
            {
                if (!event) {
                    postData._controlAjaxFiredFrom = targetName
                }
                else {
                    postData._controlAjaxFiredFrom = event.target.name;
                }
                $.ajax({
                    url: skyward.global.virtualDir + ajaxPath,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        skyward.ajax.handleResponse(data, "", false, container);
                    }
                });
            };

            skyward.accountDimensionEEL.accountReloadPrefillValues = function (displayAccount)
            {
                skyward.accountlookupeel.makeReadOnly();
                var accountParts = displayAccount.split(" ");
                $('.accountDimensionEELCode').each(function (i, o)
                {
                    var codeField = $(o);
                    if (codeField.parent().siblings('.dimensionPosition').val() == 1)
                    {
                        codeField.val(accountParts[0]);
                    }
                    else
                    {
                        codeField.val(accountParts[codeField.parent().siblings('.dimensionPosition').val()]);
                    }
                });

                $('.accountDimensionEELCodeValue').each(function (i, o)
                {
                    var hiddenCode = $(o);
                    if (hiddenCode.parent().siblings('.dimensionPosition').val() == 1)
                    {
                        hiddenCode.val(accountParts[0]);
                    }
                    else
                    {
                        hiddenCode.val(accountParts[hiddenCode.parent().siblings('.dimensionPosition').val()]);
                    }
                });
            };

            //This function clears all but the non-fund and non-controls type dimensions
            skyward.accountDimensionEEL.clearValues = function ()
            {
                $('.accountDimensionEEL').children('.IsFund, .ControlsType').each(function ()
                {
                    skyward.accountDimensionEEL.clear($(this).parent());
                });
            };

            //This function clears all values, no matter the type of dimension
            skyward.accountDimensionEEL.clearAllValues = function ()
            {
                $('.accountDimensionEEL').each(function ()
                {
                    skyward.accountDimensionEEL.clear(this);
                });
            };

            skyward.accountDimensionEEL.clear = function (dimensionEEL)
            {
                dimensionEEL = dimensionEEL instanceof jQuery ? dimensionEEL : $(dimensionEEL);

dimensionEEL.children('.accountDimensionEELValue').val(''); setSelectedValueHash(dimensionEEL.children('.accountDimensionEELValue'), "");
                dimensionEEL.children('.accountDimensionEELCode').text('').val('');
                dimensionEEL.children('.accountDimensionEELCodeValue').val('');
                dimensionEEL.children('.accountDimensionEELDescription').text('').val('');
                dimensionEEL.children('.accountDimensionEELDescriptionValue').val('');
            };

            skyward.accountDimensionEEL.getDimensionData = function ()
            {
                var data = [];

                $.each($('.accountDimensionEELCode'), function (i, o)
                {
                    var obj = $(o);
                    data.push({ value: obj.val(), position: obj.parent().siblings('.dimensionPosition').val(), maxlength: obj.attr('maxlength'), isFund: obj.hasClass('IsFund'), isControlsType: obj.hasClass('ControlsType'), fieldSetClasses: obj.parent().parent().attr('class') });
                });

                return data;
            };

            skyward.accountDimensionEEL.populateBoxes = function (eel, ajaxData, changed)
            {
                changed = typeof changed !== 'undefined' ? changed : true;

                var codeBox = eel.children(".accountDimensionEELCode").val(ajaxData.code);
                if (codeBox.hasClass("ControlsType") && typeof controlsTypeChangedCallback === 'function')
                {
                    controlsTypeChangedCallback(codeBox);
                }

                eel.children(".accountDimensionEELDescription").text(ajaxData.description);

                if (changed)
                {
                    eel.children(".accountDimensionEELValue").trigger('change');
                }
            };

            //event hooks
            accountDimensionEELCode.change(function ()
            {
                var sender = $(this);
                //ensure the values clear out when the textbox is empty
                if (sender.val().length == 0)
                {
                    skyward.accountDimensionEEL.clear(sender.parent());
                }
            });

            accountDimensionEELCode.keydown(keydown);
            accountDimensionEELCode.keyup(keyup);

            accountDimensionEELCodeButton.on("click", toggleCodePopup);
            updateBoxes();
            // Not calling .trigger("controlLoaded") because updateBoxes() will do it
        };

        var setSelectedValueHash = function (valueElement, hash)
        {
            var normalizedHash = hash ?? "";
            valueElement.data("selectedValueHash", normalizedHash);
            valueElement.attr("data-selected-value-hash", normalizedHash);
        };

        function loadRequestDataHashes(requestDataHashSrc, eelId, data)
        {
            const requestData = skyward.requestDataHash.getRequestDataHash(requestDataHashSrc, eelId);
            if (!requestData)
            {
                return;
            }
            data.codeRequestDataHash = requestData.hash;
            data.codeDynamicFilterHashes = { ...requestData.dependencies };
            data.selectedValueHash = data.originalSelectedValueHash = requestData.initialValueHash;
        }

        //Bootstrap
        skyward.events.registerEvents("accountDimensionEEL",
        {
            init
        });

    }(window.skyward = window.skyward || {}, window.jQuery)
);

;
(
    function (skyward, $)
    {
        //global private variables
        var formStates = { "Load": 1, "NewTypeCode": 2, "NewTypeCodeFromControlsType": 3, "Reload": 4 };
        var formState;
        var dataIn = '';
        var dataInAfterControlsType = '';
        var defaultTypeCode = null;
        var reloadDisplayAccount = null;
        var focusManuallySetForControlsTypeChange = false;
        var typeCodeSetFromInitailEntry = null;
        var hasControlsType;

        //global public variables
        skyward.accountLookupForm = skyward.accountLookupForm || {};
        skyward.accountLookupForm.isInitialized = false;

        skyward.accountLookupForm.initialize = function (reloadTypeCode)
        {
            if (reloadTypeCode != null && reloadTypeCode != "")
            {
                defaultTypeCode = reloadTypeCode;
            }
            else
            {
                defaultTypeCode = 'E';
            }

            formState = formStates.Load;

            skyward.accountLookupForm.isInitialized = true;
        };

        skyward.accountLookupForm.destroy = function ()
        {
            skyward.accountDimensionEEL.clearAllValues();
            skyward.accountlookupeel.makeEditable();
            dataIn = '';
            dataInAfterControlsType = '';
            formState = '';
            skyward.accountLookupForm.isInitialized = false;
        };

        skyward.accountLookupForm.setInitialData = function (value, typeCodePosition, isControlsType)
        {
            if (dataIn.length + 1 == typeCodePosition && isControlsType.toLowerCase() == 'false' && typeCodeSetFromInitailEntry == null)
            {
                switch (value)
                {

                    case "A":
                    case "1":
                        typeCodeSetFromInitailEntry = "A";
                        break;
                    case "L":
                    case "2":
                        typeCodeSetFromInitailEntry = "L";
                        break;
                    case "Q":
                    case "3":
                        typeCodeSetFromInitailEntry = "Q";
                        break;
                    case "R":
                    case "4":
                        typeCodeSetFromInitailEntry = "R";
                        break;
                    case "E":
                    case "5":
                        typeCodeSetFromInitailEntry = "E";
                        break;
                    default:
                        break;
                }
            }
            else
            {
                dataIn += value;
            }
        };

        var init = function (selector)
        {
            //private variables
            var typeCodeComboBox = $(selector + ' .cbTypeCode');
            hasControlsType = $('.ControlsType').length > 0;

            if (typeCodeComboBox.length > 0)
            {
                var typeCodeCharacterMapping = [
                    49, // 1
                    50, // 2
                    51, // 3
                    52, // 4
                    53, // 5
                    97, // Numpad 1
                    98, // Numpad 2
                    99, // Numpad 3
                    100,// Numpad 4
                    101,// Numpad 5
                    65, // A
                    76, // L
                    81, // Q
                    82, // R
                    69  // E
                ];

                typeCodeComboBox.val(defaultTypeCode);
                if (formState == formStates.Reload)
                {
                    skyward.accountDimensionEEL.accountReloadPrefillValues(reloadDisplayAccount);
                }

                //event wireups
                $(typeCodeComboBox).change(function ()
                {
                    if (formState != formStates.NewTypeCodeFromControlsType)
                    {
                        if (hasControlsType)
                        {
                            skyward.accountDimensionEEL.clearValues();
                        }
                        formState = formStates.NewTypeCode;
                        dimensionDescriptionReload();
                        reloadAccountLookupForm();
                    }
                });

                //private methods
                var reloadAccountLookupForm = function ()
                {
                    $('.accountLookupFormFieldSet').addClass('hidden');

                    var typeCode;
                    if (formState == formStates.Load && typeCodeSetFromInitailEntry != null)
                    {
                        typeCode = typeCodeSetFromInitailEntry;
                        typeCodeComboBox.val(typeCodeSetFromInitailEntry);
                        typeCodeSetFromInitailEntry = null;
                        typeCodeComboBox.change();
                    }
                    else
                    {
                        typeCode = typeCodeComboBox.val();
                    }

                    $(skyward.accountLookupForm.controlsByType[typeCode].controls).each(function (i)
                    {
                        var control = $('.' + skyward.accountLookupForm.controlsByType[typeCode].controls[i]);
                        control.removeClass('hidden');
                        control.appendTo(control.parent());
                    });

                    if (formState == formStates.Reload)
                    {
                        var lastDimensionEEL = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:last');
                        skyward.tabbing.focusAfter(lastDimensionEEL);
                        dimensionDescriptionReload();
                    }
                    else
                    {
                        var dimensionEELs = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode');
                        var firstDimensionEEL = $(dimensionEELs[0]);
                        if (formState == formStates.NewTypeCode && dataIn != '')
                        {
                            var usedCharacters = 0;
                            $(dimensionEELs).each(function (i)
                            {
                                var control = $(dimensionEELs[i]);
                                var eelMaxLength = parseInt(control.attr('maxLength'));
                                control.val(dataIn.substring(usedCharacters, (usedCharacters + eelMaxLength)));
                                if(dataIn.length < (eelMaxLength + usedCharacters))
                                {
                                    control.focus();
                                    return false;
                                }
                                else if (dataIn.length > (eelMaxLength + usedCharacters))
                                {
                                    usedCharacters = eelMaxLength + usedCharacters;

                                    if (control.hasClass('ControlsType'))
                                    {
                                        dataInAfterControlsType = dataIn.substring(usedCharacters);
                                    }

                                    skyward.accountDimensionEEL.setDescription(control, false);
                                    return true;
                                }
                                else
                                {
                                    skyward.accountDimensionEEL.setDescription(control, false);
                                    skyward.tabbing.focusAfter(control);
                                    return false;
                                }
                            });
                            dataIn = '';
                        }
                        else if (formState == formStates.Load)
                        {
                            skyward.tabbing.focusAfter(firstDimensionEEL);
                        }
                        else if (formState == formStates.NewTypeCode)
                        {
                            skyward.tabbing.focusAfter(typeCodeComboBox);
                        }
                        else if (formState == formStates.NewTypeCodeFromControlsType)
                        {
                            var encounteredControlsTypeEEL;
                            var dataCharactersUsed = 0;
                            dimensionEELs.each(function (index)
                            {
                                var currentControl = $(dimensionEELs[index]);
                                var currentEelMaxLength = parseInt(currentControl.attr('maxLength'));

                                if (currentControl.hasClass('ControlsType'))
                                {
                                    encounteredControlsTypeEEL = true;

                                    if (dataInAfterControlsType.length == 0)
                                    {
                                        return false;
                                    }

                                    return true;
                                }
                                if (encounteredControlsTypeEEL)
                                {
                                    currentControl.val(dataInAfterControlsType.substring(dataCharactersUsed, (dataCharactersUsed + currentEelMaxLength)));
                                    if(dataInAfterControlsType.length < (currentEelMaxLength + dataCharactersUsed))
                                    {
                                        currentControl.focus();
                                        focusManuallySetForControlsTypeChange = true;
                                        return false;
                                    }
                                    else if (dataInAfterControlsType.length > (currentEelMaxLength + dataCharactersUsed))
                                    {
                                        dataCharactersUsed = currentEelMaxLength + dataCharactersUsed;
                                        skyward.accountDimensionEEL.setDescription(currentControl, true);
                                        return true;
                                    }
                                    else
                                    {
                                        focusManuallySetForControlsTypeChange = true;
                                        skyward.accountDimensionEEL.setDescription(currentControl, true);
                                        skyward.accountLookupForm.checkForSingleAccount(currentControl);
                                        return false;
                                    }
                                }
                                else
                                {
                                    return true;
                                }
                            });
                        }
                    }
                };

                $(typeCodeComboBox).keydown(function (event)
                {
                    if (event.which >= 37 && event.which <= 40) //arrow keys
                    {
                        event.preventDefault();
                        return;
                    }

                    var storedValue = typeCodeComboBox.val();
                    var eventWhich = event.which;

                    var setTypeCodeComboBoxValue = function (newValue)
                    {
                        event.preventDefault();
                        if (newValue != storedValue)
                        {
                            formState = formStates.NewTypeCode;
                            typeCodeComboBox.val(newValue);
                            typeCodeComboBox.change();
                        }
                        else
                        {
                            //make sure to tab if the type code didn't change
                            skyward.tabbing.focusAfter(typeCodeComboBox);
                        }
                    };

                    switch (eventWhich)
                    {
                        //1 A
                        case 49:
                        case 97:
                        case 65:
                            setTypeCodeComboBoxValue('A');
                            break;
                        //2 L
                        case 50:
                        case 98:
                        case 76:
                            setTypeCodeComboBoxValue('L');
                            break;
                        //3 Q
                        case 51:
                        case 99:
                        case 81:
                            setTypeCodeComboBoxValue('Q');
                            break;
                        //4 R
                        case 52:
                        case 100:
                        case 82:
                            setTypeCodeComboBoxValue('R');
                            break;
                        //5 E
                        case 53:
                        case 101:
                        case 69:
                            setTypeCodeComboBoxValue('E');
                            break;
                        //enter
                        case 13:
                            skyward.tabbing.focusAfter(typeCodeComboBox);
                    }
                });

                var beforeDimensionEELKeyUp = function (event)
                {
                    //return when eel has its popup open, or when shift/tabbing, entering, or backspacing
                    if (skyward.accountDimensionEEL.popupModalLayerOpen || event.shiftKey || event.which == 16 || event.which == 9 || event.which == 8 || event.which == 13)
                    {
                        return;
                    }

                    var sender = $(event.currentTarget);
                    var senderMaxLength = sender.attr('maxlength');
                    var senderLength = sender.val().length;
                    var accountDimensionEELs = $('.accountLookupFormFieldSet:not(.hidden)').find('.accountDimensionEELCode');
                    var secondDimensionDOM = accountDimensionEELs.get(1);
                    var lastDimensionEELDOM = accountDimensionEELs.get(accountDimensionEELs.length - 1);

                    if (sender.get(0) == secondDimensionDOM && typeCodeCharacterMapping.indexOf(event.which) > -1)
                    {
                        return;
                    }

                    if (senderMaxLength == senderLength)
                    {
                        if (sender.hasClass('IsFund'))
                        {
                            return;
                        }

                        if (sender.get(0) == lastDimensionEELDOM)
                        {
                            checkForSingleAccount(accountDimensionEELs, sender);
                            sender.blur();
                        }
                        else
                        {
                            skyward.tabbing.focusAfter(sender);
                        }
                        sender.siblings('.accountDimensionEELCodeValue').val(sender.val()); //set hidden value
                    }
                };

                var beforeDimensionEELKeyDown = function (event)
                {
                    if (event.which == 8 && !skyward.accountDimensionEEL.popupModalLayerOpen) //backspace
                    {
                        var sender = $(event.currentTarget);
                        var senderDOM = sender.get(0);

                        var firstDimensionDOM = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:first').get(0);

                        var secondDimension = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:eq(1)');
                        var secondDimensionDOM = secondDimension.get(0);

                        var eelPopup = skyward.accountDimensionEEL.popupModalLayer;

                        if (sender.val() == '' && senderDOM != firstDimensionDOM && (eelPopup == null || eelPopup && !eelPopup.onScreen))
                        {
                            if (senderDOM == secondDimensionDOM && !secondDimension.hasClass('ControlsType'))
                            {
                                skyward.tabbing.focusBefore(typeCodeComboBox);
                            }
                            else
                            {
                                skyward.tabbing.focusBefore(sender);
                            }
                        }
                    }
                };

                var checkForSingleAccount = function (sender)
                {
                    skyward.tabbing.focusAfter(sender);
                };

                skyward.accountLookupForm.checkForSingleAccount = function (sender)
                {
                    var accountDimensionEELs = $('.accountLookupFormFieldSet:not(.hidden)').find('.accountDimensionEELCode');
                    var lastDimensionEELDOM = accountDimensionEELs.get(accountDimensionEELs.length - 1);
                    if (sender.get(0) == lastDimensionEELDOM)
                    {
                        checkForSingleAccount(sender);
                        sender.blur();
                    }
                };

                skyward.accountLookupForm.checkForSingleAccountFromSelect = function ()
                {
                    checkForSingleAccount();
                };

                var dimensionDescriptionReload = function ()
                {
                    $('.accountDimensionEELCode').each(function (i, o)
                    {
                        var dimensionCode = $(o);
                        skyward.accountDimensionEEL.setDescription(dimensionCode, true);
                    });
                };

                var controlsTypeChanged = function (sender, preventFocusChange)
                {
                    var code = $(sender);
                    var codeValue = code.val();

                    for (var typeCode in skyward.accountLookupForm.controlsByType)
                    {
                        var doBreak = false;
                        for (var i = 0; i < skyward.accountLookupForm.controlsByType[typeCode].codeLow.length; i++)
                        {
                            if (codeValue >= skyward.accountLookupForm.controlsByType[typeCode].codeLow[i] &&
                                codeValue <= skyward.accountLookupForm.controlsByType[typeCode].codeHigh[i]) 
                            {
                                if (typeCodeComboBox.val() != typeCode)
                                {
                                    formState = formStates.NewTypeCodeFromControlsType;

                                    typeCodeComboBox.val(typeCode);
                                    typeCodeComboBox.change(); //trigger change event for dependencies

                                    reloadAccountLookupForm();
                                }
                                if ((!focusManuallySetForControlsTypeChange && !preventFocusChange) || !preventFocusChange)
                                {
                                    skyward.tabbing.focusAfter(code);
                                }
                                doBreak = true;
                                break;
                            }
                        }

                        if (doBreak)
                        {
                            break;
                        }
                    }
                };

                var setInitialFocus = function ()
                {
                    if (skyward.global.mobileAccess)
                    {
                        return;
                    }
                    var accountDimensionEELs = $('.accountLookupFormFieldSet:not(.hidden)').find('.accountDimensionEELCode');
                    var firstDimensionEEL = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:first');
                    var lastDimensionEEL = $('.accountLookupFormFieldSet:not(.hidden) .accountDimensionEELCode:last');
                    accountDimensionEELs.each(function ()
                    {
                        var currentEEL = $(this);

                        if (currentEEL.val().length < currentEEL.attr('maxLength'))
                        {
                            currentEEL.focus();
                            return false;
                        }
                        else if(currentEEL.val().length == currentEEL.attr('maxLength') && currentEEL.get(0) == lastDimensionEEL.get(0))
                        {
                            skyward.accountLookupForm.checkForSingleAccount(currentEEL);
                            return false;
                        }
                        else if (currentEEL.val().length == currentEEL.attr('maxLength') && currentEEL.get(0) == firstDimensionEEL.get(0))
                        {
                            typeCodeComboBox.focus();
                            return false;
                        }
                        else
                        {
                            return true;
                        }
                    });
                };

                //accountDimensionEEL callbacks
                skyward.accountDimensionEEL.setBeforeKeyUpCallback(beforeDimensionEELKeyUp);
                skyward.accountDimensionEEL.setBeforeKeyDownCallback(beforeDimensionEELKeyDown);
                skyward.accountDimensionEEL.setControlsTypeChangedCallback(controlsTypeChanged);

                //initialize form
                reloadAccountLookupForm();

                setInitialFocus();
            }
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        skyward.hierarchy = skyward.hierarchy || {};

        skyward.hierarchy.initiate = function (lookupId, url)
        {
            var fullURL = url.replace("~/", skyward.global.virtualDir);
            $.ajax(fullURL,
                {
                    type: "POST",
                    dataType: "JSON",
                    success: async function (data)
                    {
                        await $("#" + lookupId + "_main").viewpartHtml(data.html);
                        skyward.window.notifyDOMLoad("#" + data.selector);
                    }
                }
            );
        };

        skyward.hierarchy.toggle = function ()
        {
            var button = $(this);
            var controlName = button.data("controlname");
            var nodeValue = button.data("nodevalue");
            var main = $("#" + controlName + "_main");
            var lookupId = main.data("lookup-id");
            var expandUrl = main.data("expand-url");
            var buttonName = controlName + "_togglebutton_" + nodeValue;
            var rowName = controlName + "_row_" + nodeValue;
            var rowSelector = "#" + rowName;

            button.toggleClass("expanded");
            var svg = button.find('svg');
            if (!button.attr('disabled'))
            {
                if (button.hasClass("expanded"))
                {
                    skyward.svg.swapSvg(svg, "Collapse", "Hierarchy");
                    var row = $(rowSelector);
                    if (!row.data("childrenLoaded"))
                    {
                        button.attr('disabled', true);
                        var fullUrl = expandUrl.replace("~/", skyward.global.virtualDir) + "/" + lookupId + "/" + controlName + "/" + nodeValue;
                        $.ajax(fullUrl,
                            {
                                type: "POST",
                                dataType: "JSON",
                                success: async function (data)
                                {
                                    const processedHtml = await skyward.global.processViewPartHtml(data.html);
                                    $("#" + controlName + "_row_" + nodeValue).after(processedHtml);
                                    row.data("childrenLoaded", true);
                                    skyward.window.notifyDOMLoad(data.selector);
                                    button.attr('disabled', false);
                                }
                            }
                        );
                    }
                    else
                    {
                        // Row has been loaded.  Just display it.
                        $("[id^='" + rowName + "-'][data-depth='" + (1 + $(rowSelector).data("depth")) + "']").removeClass("collapsed");

                        $(".spacerRow[data-hierarchy-row-path=" + rowName + "]").removeClass("collapsed");
                        $(".objectSpacerRow[data-hierarchy-row-path=" + rowName + "]").removeClass("collapsed");
                    }
                }
                else
                {
                    skyward.svg.swapSvg(svg, "Expand", "Hierarchy");
                    // Collapsing.
                    $("[id^='" + rowName + "-']").addClass("collapsed");
                    $("[id^='" + buttonName + "-']").removeClass("expanded");

                    $(".spacerRow[data-hierarchy-row-path=" + rowName + "]").addClass("collapsed");
                    $(".objectSpacerRow[data-hierarchy-row-path^=" + rowName + "]").addClass("collapsed");
                }
            }
        };

        skyward.hierarchy.initializeOrganizationChart = function (containerID)
        {
            var hierarchy = $("#" + containerID);
            var hiddenField = hierarchy.siblings("#SelectedRecord").eq(0).val("null");
            var addOrMoveRecord = $("#AddOrMoveRecord").val("null");
            var newTopLevelButton = $("#btnAddNewTopLevelRelationship");
            var newButton = $("#btnAddNewRelationship");
            var moveButton = $("#btnMoveRelationship");
            var deleteButton = $("#btnDeleteRelationship");
            var openButton = $("#btnOpenRelationship");
            var massAddButton = $("#btnMassAddRelationship");
            var selectedRecord = hierarchy.find(".hierarchyrow .selected").eq(0);
            var hierarchyContainer = hierarchy.parents(".hierarchyContainer");

            if (selectedRecord.length > 0)
            {
                hiddenField.val(selectedRecord.attr("data-recordid"));
                toggleButtons(true);
            }

            hierarchyContainer.on("click", ".hierarchyrow .selectable", function ()
            {
                selectedRecord = $(this);

                hierarchy.find(".hierarchyrow .selectable").removeClass("selected");
                selectedRecord.addClass("selected");

                hiddenField.val(selectedRecord.attr("data-recordid"));
                hiddenField.change();

                toggleButtons(true);
            });

            hierarchyContainer.on("click", ".hierarchyButton", skyward.hierarchy.toggle);
            hierarchyContainer.debounce("click", ".hierarchyButton", updatePageState);

            if (hierarchyContainer.hasClass("js-hierarchyBindButtons")) {
                newTopLevelButton.click(function ()
                {
                    if (!newTopLevelButton.hasClass("ui-disabled"))
                    {
                        addOrMoveRecord.val(hiddenField.val());
                        skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/Add', null, { "Workflow.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.TopLevelRelationship": true }, null, null, null, false);
                    }
                });
            
                newButton.click(function ()
                {
                    if (!newButton.hasClass("ui-disabled"))
                    {
                        addOrMoveRecord.val(hiddenField.val());
                        skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/Add', null, { "Workflow.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.PositionIDSupervisor": hiddenField.val() }, null, null, null, false);
                    }
                });

                moveButton.click(function ()
                {
                    if (!moveButton.hasClass("ui-disabled"))
                    {
                        addOrMoveRecord.val(hiddenField.val());
                        var fiscalYearID = moveButton.data("organizationalchartfiscalyearid");
                        skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/Move', null, { "Workflow.OrganizationChartRelationship.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.OrganizationChartRelationship.PositionIDSupervisor": hiddenField.val(), "Workflow.FiscalYearID": fiscalYearID }, null, null, null, false);
                    }
                });

                deleteButton.click(function ()
                {
                    if (!deleteButton.hasClass("ui-disabled"))
                    {
                        if ($(".currentRecordContent .selected").attr("data-hasChildren") == "false")
                        {
                            skyward.window.loadContent('full', 'Position', 'OrganizationChartRelationship', 'Delete', $(".currentRecordContent .selected").attr("data-relationshipID"), null, null, null, null, false);
                        }
                        else
                        {
                            var fiscalYearID = deleteButton.data("organizationalchartfiscalyearid");
                            skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/DeleteSupervisor', null, { "Workflow.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.PositionIDSelected": hiddenField.val(), "Workflow.FiscalYearID": fiscalYearID }, null, null, null, false);
                        }
                    }
                });

                openButton.click(function ()
                {
                    if (!deleteButton.hasClass("ui-disabled"))
                    {
                        skyward.window.loadContent('full', 'Position', 'OrganizationChartRelationship', 'Details', $(".currentRecordContent .selected").attr("data-relationshipID"), null, null, null, null, false);
                    }
                });

                massAddButton.click(function ()
                {
                    if (!deleteButton.hasClass("ui-disabled"))
                    {
                        var fiscalYearID = massAddButton.data("organizationalchartfiscalyearid");
                        skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Position/OrganizationChartRelationship/MassAdd', null, { "Workflow.OrganizationChartID": hierarchy.attr("data-lookup-id"), "Workflow.PositionIDSupervisor": hiddenField.val(), "Workflow.FiscalYearID": fiscalYearID }, null, null, null, false);
                    }
                });
            }

            function toggleButtons(enabled)
            {
                const allButtons =
                    [newTopLevelButton, newButton, moveButton, deleteButton, openButton, massAddButton]
                    .reduce((a, b) => a.add(b));
                allButtons.toggleClass("ui-disabled", !enabled).attr("aria-disabled", !enabled);
            }

            function updatePageState()
            {
                var items = [];
                var expandedButtons = $("a.expanded");
                for (var i = 0, len = expandedButtons.length; i < len; i++)
                {
                    var expandedRecord = $(expandedButtons[i]).siblings(".selectable");
                    var recordID = expandedRecord.attr("data-recordid");
                    if (recordID && recordID !== "")
                    {
                        items.push(recordID);
                    }
                }

                if (addOrMoveRecord && addOrMoveRecord.length > 0)
                {
                    var value = addOrMoveRecord.val();
                    if (value !== "null" && items.indexOf(value) === -1)
                    {
                        items.push(value);
                    }
                }

                var pageState =
                {
                    id: "ExpandTo",
                    items: [{
                        key: "value",
                        value: items.join(","),
                        skip: false
                    }]
                };

                skyward.window.updatePageState([pageState]);
            };
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.rolemodulepath = skyward.rolemodulepath || {};

        var init = function (selector)
        {
            var modulePathGrids = $('#RoleModulePaths_grid, #EmployeeAccessRoleModulePaths_grid, #TeacherAccessRoleModulePaths_grid, #FamilyAccessRoleModulePaths_grid , #StudentAccessRoleModulePaths_grid, #ActivityAccessRoleModulePaths_grid, #NewStudentEnrollmentRoleModulePaths_grid, #DataMigrationManagerRoleModulePaths_grid, #StudentServicesRoleModulePaths_grid, #SMSToQmlativToolsRoleModulePaths_grid');
            var layer;

            modulePathGrids.off("click").on("click", ".hierarchyButton", skyward.hierarchy.toggle);

            var toggleViaAjax = function (cb, inputData, urlExtenstion)
            {
                $.ajax(skyward.global.virtualDir + urlExtenstion,
                    {
                        type: "POST",
                        dataType: "JSON",
                        context: { row: cb.parent().parent() },
                        data: { json: JSON.stringify(inputData.moduleStatus) },
                        success: function (data)
                        {
                            cb.data("bound", "False");
                            if (data != null)
                            {
                                // the server will return a dictionary of how all of the checkboxes in the module
                                // should display their value as (e.g. checked, unchecked, indeterminate)
                                modulePathGrids.find("[data-module='" + inputData.moduleData.module + "']").each(function ()
                                {
                                    var currentCB = $(this);
                                    var obj = currentCB.data("object");
                                    var screen = currentCB.data("screen");
                                    var operation = currentCB.data("operation");
                                    var modulePath = inputData.moduleData.module;

                                    if (obj != null)
                                    {
                                        modulePath += "/" + obj;
                                    }
                                    if (screen != null)
                                    {
                                        modulePath += "/" + screen;
                                    }

                                    if (modulePath in data.MenuStatus && operation in data.MenuStatus[modulePath])
                                    {
                                        currentCB.prop("checked", data.MenuStatus[modulePath][operation] == "checked");
                                        currentCB.data("checked", data.MenuStatus[modulePath][operation] == "checked" ? "True" : "False");
                                        currentCB.prop("indeterminate", data.MenuStatus[modulePath][operation] == "partial");
                                        currentCB.data("indeterminate", data.MenuStatus[modulePath][operation] == "partial" ? "True" : "False");
                                    }
                                });
                            }
                            layer.close();
                        },
                        error: function (data)
                        {
                            layer.close();
                        }
                    });
            };

            // screen level checkbox
            modulePathGrids.on('click', 'input.rolemodulepath-check', null, function (event)
            {
                var cb = $(this);
                if (cb.hasClass('ui-disabled') || cb.attr('aria-readonly') === 'true')
                {
                    return;
                }

                var data = getCheckboxData(cb);

                // for non-tri-state checkboxes get the status directly from the box
                data.moduleData.checked = this.checked;
                var urlExtension = "Security/AdvancedSecurity/ToggleScreen/" + data.moduleData.roleId + "/" + data.moduleData.modulePath + "/" +
                    data.moduleData.field + "/" + data.moduleData.checked + "/" + data.moduleData.portal;

                findOpenScreensForModule(cb, data, urlExtension);
            });

            // object level checkbox
            modulePathGrids.on('click', 'input.objectCheckbox', null, function (event)
            {
                var cb = $(this);
                if (cb.hasClass('ui-disabled') || cb.attr('aria-readonly') === 'true')
                {
                    return;
                }
                var data = getCheckboxData(cb);
                var urlExtension = "Security/AdvancedSecurity/ToggleObject/" + data.moduleData.roleId + "/" +
                    data.moduleData.module + "/" + data.moduleData.object + "/" + data.moduleData.operation + "/" + data.moduleData.checked + "/" + data.moduleData.portal;

                findOpenScreensForModule(cb, data, urlExtension);
            });

            //module level checkbox
            modulePathGrids.on('click', 'input.moduleCheckbox', null, function (event)
            {
                var cb = $(this);
                if (cb.hasClass('ui-disabled') || cb.attr('aria-readonly') === 'true')
                {
                    return;
                }
                var data = getCheckboxData(cb);
                var urlExtension = "Security/AdvancedSecurity/ToggleModule/" + data.moduleData.roleId + "/" +
                    data.moduleData.module + "/" + data.moduleData.operation + "/" + data.moduleData.checked + "/" + data.moduleData.portal;

                findOpenScreensForModule(cb, data, urlExtension);
            });

            // read the data attributes set from RoleModulePathController
            var getCheckboxData = function (cb)
            {
                var data = { moduleData: {}, moduleStatus: {} };
                data.moduleData.module = cb.data("module");
                data.moduleData.object = cb.data("object");
                data.moduleData.screen = cb.data("screen");
                data.moduleData.roleId = cb.data("roleId");
                data.moduleData.modulePath = cb.data("modulePath");
                data.moduleData.operation = cb.data("operation");
                data.moduleData.field = cb.data("field");
                data.moduleData.checked = cb.data("indeterminate") == "True" || cb.data("checked") == "False";
                data.moduleData.portal = cb.data("portal");
                return data;
            };

            // on page load go through all module level checkboxes and object level checkboxes
            // to set them to either indeterminate (square) or checked
            $(selector + " .moduleCheckbox, " + selector + " .objectCheckbox").each(function ()
            {
                var cb = $(this);
                if (cb.data("indeterminate") == "True")
                {
                    cb.prop("indeterminate", true);
                }
                else if (cb.data("checked") == "True")
                {
                    cb.prop("checked", true);
                }
            });

            var findOpenScreensForModule = function (cb, data, urlExtention)
            {

                // because the dom is changing during this, set an attribute when a click event
                // has been fired off and only do processing if the flag isn't set
                var bound = cb.data("bound");
                if (bound != "True")
                {
                    layer = skyward.modalLayer.newModalLayer(null, null, {
                        closeOnClick: false,
                        closeOnRecordSelected: false,
                        closeOnEscape: false
                    });

                    cb.data("bound", "True");

                    // clicking a checkbox can never make it indeterminate
                    cb.data("indeterminate", "False");
                    // checked attribute used because of issues in IE
                    cb.data("checked", data.moduleData.checked ? "True" : "False");
                    cb.prop("indeterminate", false);
                    cb.prop("checked", data.moduleData.checked);
                    cb.data("bound", "True");

                    // roll through all checkboxes that have the same module as the one checked. This includes
                    // all module, object, and screen checkboxes for that module. Build up a dictionary of how
                    // all of these checkboxes are currently displayed so the server can determine what will change
                    modulePathGrids.find("[data-module='" + cb.data('module') + "']").each(function ()
                    {
                        var currentCB = $(this);
                        var checkStyle;
                        // module level checkbox
                        if (currentCB.data('parent') == "Module")
                        {
                            checkStyle = currentCB.data("indeterminate") == "True" ? "partial" : this.checked ? "checked" : "unchecked";
                            if (!(currentCB.data('module') in data.moduleStatus))
                            {
                                data.moduleStatus[currentCB.data('module')] = {};
                            }
                            data.moduleStatus[currentCB.data('module')][currentCB.data('operation')] = checkStyle;
                        }
                            // object level checkbox
                        else if (currentCB.data('parent') == "Object")
                        {
                            checkStyle = currentCB.data("indeterminate") == "True" ? "partial" : this.checked ? "checked" : "unchecked";
                            if (!(currentCB.data('module') + '/' + currentCB.data('object') in data.moduleStatus))
                            {
                                data.moduleStatus[currentCB.data('module') + '/' + currentCB.data('object')] = {};
                            }
                            data.moduleStatus[currentCB.data('module') + '/' + currentCB.data('object')][currentCB.data('operation')] = checkStyle;
                        }
                            // screen level checkbox
                        else
                        {
                            checkStyle = this.checked ? "checked" : "unchecked";
                            if (!(currentCB.data('modulePath') in data.moduleStatus))
                            {
                                data.moduleStatus[currentCB.data('modulePath')] = {};
                            }
                            data.moduleStatus[currentCB.data('modulePath')][currentCB.data('operation')] = checkStyle;
                        }
                    });

                    toggleViaAjax(cb, data, urlExtention);
                }
            };
        };

        //Bootstrap
        skyward.rolemodulepath.monitorDOM = skyward.rolemodulepath.monitorDOM || function ()
        {
            skyward.window.registerLoadDOMCallback(init);
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    // TODO: [PR 4380821] Convert entire (mobile) Main Menu to Vue
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.mainMenu = skyward.mainMenu || {};

        var cache = skyward.mainMenuVueBuilder.getCache();

        var classes = skyward.mainMenuVueBuilder.getClasses();

        skyward.mainMenu.toggleMenu = function ()
        {
            if (skyward.mainMenu.isMenuOpen())
            {
                skyward.mainMenu.closeMenu();
            }
            else
            {
                skyward.mainMenu.openMenu();
            }
        };

        var mobileMenu = function ()
        {
            var htmlConstructor = function (layoutParts)
            {
                var constructor =
                {
                    layoutParts: layoutParts
                };

                var expandableMenu = (function ()
                {
                    $(document.body).on("click", classes.menuGroup.dot(), function (event)
                    {
                        if (event.isDefaultPrevented())
                        {
                            return;
                        }

                        event.preventDefault();

                        var li = $(event.target).closest([classes.menuGroupTitle.dot(), classes.menuGroupItem.dot()].join(","));

                        if (!li.length)
                        {
                            return;
                        }

                        var ul = $(this);
                        var shouldToggle = li.hasClass(classes.menuGroupTitle);
                        var afterToggleShow, afterToggleHide;
                        var dataOn = li.data("menu-on");

                        for (var on in dataOn)
                        {
                            switch (on)
                            {
                                case "click":
                                    dataOn[on].apply(li[0], [li]);
                                    break;
                            }
                        }

                        dataOn = ul.data("menu-on");

                        if (typeof dataOn === "object")
                        {
                            afterToggleShow = dataOn["after-toggle-show"];
                            afterToggleHide = dataOn["after-toggle-hide"];

                            if (dataOn["before-toggle-show"] && !ul.hasClass(classes.menuGroupExpanded))
                            {
                                shouldToggle = false;
                                ul.addClass(classes.menuGroupBusy);
                                $.when(dataOn["before-toggle-show"].apply(ul[0], [ul])).done(function ()
                                {
                                    ul.removeClass(classes.menuGroupBusy);
                                    toggleExpand(true);
                                });
                            }
                        }

                        if (shouldToggle)
                        {
                            toggleExpand(!ul.hasClass(classes.menuGroupExpanded));
                        }

                        function toggleExpand(expand)
                        {
                            if (expand)
                            {
                                var searchLi = ul.children(classes.menuGroupSearch.dot());
                                if (searchLi.length && searchLi.siblings(classes.menuGroupItem.dot()).length < searchLi.data("searchItemThreshold"))
                                {
                                    searchLi.hide();
                                }
                                ul.addClass(classes.menuGroupExpanded);
                                if (typeof afterToggleShow === "function")
                                {
                                    afterToggleShow.apply(ul[0], [ul]);
                                }
                            }
                            else
                            {
                                ul.removeClass(classes.menuGroupExpanded);
                                if (typeof afterToggleHide === "function")
                                {
                                    afterToggleHide.apply(ul[0], [ul]);
                                }
                            }
                        }
                    })
                        .on("keyup", classes.menuGroupSearchBox.dot(), function (event)
                        {
                            var input = $(this);
                            var searchLi = input.parent();
                            var messageLi = searchLi.find(classes.menuGroupSearchMessage.dot());
                            var clearDiv = searchLi.find(classes.menuGroupSearchClear.dot());
                            var searchText = input.val().toLowerCase();
                            var hiddenCount = 0, shownCount = 0, searchMessage = "";

                            searchLi.siblings(classes.menuGroupItem.dot()).each(function ()
                            {
                                var item = $(this);
                                var itemText = item.text().toLowerCase();
                                if (!searchText.length || itemText.indexOf(searchText) >= 0)
                                {
                                    item.removeClass(classes.menuGroupSearchItemHidden);
                                    shownCount++;
                                }
                                else
                                {
                                    item.addClass(classes.menuGroupSearchItemHidden);
                                    hiddenCount++;
                                }
                            });

                            if (searchText.length)
                            {
                                clearDiv.show();

                                if (shownCount === 0)
                                {
                                    searchMessage = "No matching results";
                                }
                                else if (hiddenCount > 0)
                                {
                                    searchMessage = "Hiding " + hiddenCount + " result" + (hiddenCount > 1 ? "s" : "");
                                }
                                else if (shownCount > 0)
                                {
                                    searchMessage = shownCount + " matching result" + (shownCount > 1 ? "s" : "");
                                }
                            }
                            else
                            {
                                clearDiv.hide();
                            }

                            if (searchMessage)
                            {
                                messageLi.html(searchMessage);
                                searchLi.addClass(classes.menuGroupSearchHasMessage);
                            }
                            else
                            {
                                searchLi.removeClass(classes.menuGroupSearchHasMessage);
                            }
                        })
                        .on("click", classes.menuGroupSearchClear.dot(), function (event)
                        {
                            $(this).siblings(classes.menuGroupSearchBox.dot()).val("").trigger("keyup");
                        });

                    function concatClasses()
                    {
                        var classes = [];
                        Array.from(arguments).map(function (arg)
                        {
                            if (typeof arg === "string")
                            {
                                classes.push(arg);
                            }
                            else if (typeof arg === "object" && arg !== null && arg.length)
                            {
                                classes = classes.concat(arg);
                            }
                        });
                        return classes.join(" ");
                    }

                    function createElement(tagName, className, options)
                    {
                        options = options || {};

                        if (typeof options.class === "function")
                        {
                            options.class = options.class();
                        }

                        var element = $("<" + tagName + ">",
                            {
                                class: concatClasses(className, options.class)
                            });

                        if (options.data)
                        {
                            element.data(options.data);
                        }

                        if (options.on)
                        {
                            element.data("menu-on", options.on);
                        }

                        if (options.svg)
                        {
                            if (typeof options.svg === "function")
                            {
                                options.svg = options.svg();
                            }
                            element.append($(options.svg).addClass(classes.menuGroupSvg));
                        }

                        if (options.label)
                        {
                            element.append($("<div>", { class: classes.menuGroupLabel, html: options.label }));
                        }

                        return element;
                    }

                    var expandableMenu =
                    {
                        create: function (options)
                        {
                            options = options || {};

                            var element = expandableMenu.createContainer(options.container || {});

                            if (options.title)
                            {
                                element.append(expandableMenu.createTitle(options.title));
                            }

                            if (options.searchable)
                            {
                                element.append(expandableMenu.createSearch(options.search));
                            }

                            if (options.items)
                            {
                                if (typeof options.items === "function")
                                {
                                    options.items = options.items();
                                }
                                options.items.map(function (item)
                                {
                                    if (item.isHeader)
                                    {
                                        element.append(expandableMenu.createHeader(item));
                                    }
                                    else
                                    {
                                        element.append(expandableMenu.createItem(item));
                                    }
                                });
                            }

                            return element;
                        },
                        createContainer: function (options)
                        {
                            return createElement("ul", classes.menuGroup, options);
                        },
                        createTitle: function (options)
                        {
                            return createElement("li", classes.menuGroupTitle, options).append($("<div>", { class: classes.menuGroupChevron }));
                        },
                        createItem: function (options)
                        {
                            return createElement("li", classes.menuGroupItem, options);
                        },
                        createHeader: function (options)
                        {
                            return createElement("li", classes.menuGroupHeader, options);
                        },
                        createSearch: function (options)
                        {
                            var li = expandableMenu.createItem($.extend(
                                {
                                    class: classes.menuGroupSearch,
                                    svg: skyward.svg.getSvg("Search").addClass(classes.menuGroupSearchSvg),
                                    data:
                                    {
                                        searchItemThreshold: 10
                                    }
                                }, options));

                            const inputProps = skyward.mobile.supportsInputMode ? { type: "text", inputmode: "numeric" } : { type: "numeric" };
                            li.prepend($("<input>", { class: classes.menuGroupSearchBox, ...inputProps }));

                            li.append($("<div>", { class: classes.menuGroupSearchMessage }));

                            li.append($("<div>", { class: classes.menuGroupSearchClear }));

                            return li;
                        }
                    };

                    return expandableMenu;
                })();

                function getMobileBackButton()
                {
                    var button = $(classes.mobileBackButton.dot());

                    if (window.location.href.match(/\/home\//i) || !window.history.length)
                    {
                        button.addClass(classes.mobileBackButtonDisabled);
                    }

                    return button;
                }

                function getScreenFriendlyName()
                {
                    var friendlyName = $(classes.mobileFriendlyName.dot());
                    if (friendlyName.length)
                    {
                        var friendlyNameText = $("#friendlyNameContents").text();
                        if (friendlyNameText)
                        {
                            friendlyName.text(friendlyNameText.split(" - ")[0]); //TODO: find a better way to remove student name
                        }
                    }
                    return friendlyName;
                }

                function getMobileUserMenu()
                {
                    var headerSelectContainerItems = $(".headerSelectContainer__item > .headerSelect").not(".headerSelect__mode--Section,.js-headerSelect--topLevel");
                    var hasDetails = false;
                    var userMenu = expandableMenu.create(
                        {
                            container:
                            {
                                class: classes.menuGroupUserMenu,
                                on:
                                {
                                    "before-toggle-show": getUserMenuItems,
                                    "after-toggle-hide": collapseMenusInContainer
                                }
                            },
                            title:
                            {
                                svg: function ()
                                {
                                    var graphic = $(".utilitiesButtonMain__svg--userImage");
                                    if (graphic.length)
                                    {
                                        graphic.removeClass("utilitiesButtonMain__svg--userImage");
                                    }
                                    else
                                    {
                                        graphic = $(".utilitiesButtonMain__img");
                                    }
                                    return graphic;
                                },
                                label: function ()
                                {
                                    var elements = $();
                                    var userName = [];

                                    $(".utilitiesButtonMain__text--username").each(function ()
                                    {
                                        userName.push($(this).text());
                                    });

                                    elements = elements.add($("<div>", { class: classes.menuGroupUserName, html: userName.join(" ") }));

                                    headerSelectContainerItems.each(function ()
                                    {
                                        var item = $(this);
                                        if (!item.is("[data-update-action]"))
                                        {
                                            return;
                                        }
                                        var text = item.text().trim();
                                        if (!text.length)
                                        {
                                            return;
                                        }
                                        elements = elements.add($("<div>", { class: classes.menuGroupUserDetail, html: text }));
                                    });

                                    hasDetails = elements.length > 1;

                                    return elements;
                                }
                            }
                        });

                    if (hasDetails)
                    {
                        userMenu.addClass(classes.menuGroupUserMenuHasDetails);
                    }

                    return userMenu;

                    function getUserMenuItems(ul)
                    {
                        var deferred = $.Deferred();

                        if (ul.data("has-items"))
                        {
                            deferred.resolve();
                        }
                        else
                        {
                            var items = $();
                            var myAccountButton = $("#myAccountButton");

                            headerSelectContainerItems.each(function ()
                            {
                                var headerSelect = $(this);
                                if (headerSelect.is(".headerSelect--readonly") || !headerSelect.is("[data-update-action]"))
                                {
                                    return;
                                }
                                var li = expandableMenu.createItem(
                                    {
                                        class: classes.menuGroupItemHasMenu
                                    });

                                var item = getSelectionMenu(this);
                                if (item)
                                {
                                    items = items.add(li.append(item));
                                }
                            });

                            items = items
                                .add(getChangePassword(myAccountButton))
                                .add(getStopImpersonation(myAccountButton))
                                .add(getUserPreferences(myAccountButton))
                                .add(getSupportTools(myAccountButton))
                                .add(getSignOut());

                            ul.append(items).data("has-items", true);

                            /* We need to use a timeout here to allow time for a css paint event to register the added list element.
                             * This is necessary to get the css transition to work properly (it needs to paint the before state before it can know to transition to the after state) */
                            window.setTimeout(deferred.resolve, 50);
                        }

                        collapseMenusInContainer($(classes.menuGroupUserMenu.dot()), ul);

                        return deferred.promise();
                    }

                    function getSignOut()
                    {
                        return expandableMenu.createItem(
                            {
                                svg: skyward.svg.getSvg("SignOut"),
                                label: "Sign Out",
                                on: { click: skyward.header.signOutButtonClick }
                            });
                    }

                    function getSupportTools(myAccountButton)
                    {
                        if (!myAccountButton.length || !((skyward.global.isInHouse && skyward.global.isRealSuperUser) || skyward.global.isRealSupportAccount) )
                        {
                            return $();
                        }

                        return expandableMenu.createItem(
                            {
                                svg: skyward.svg.getSvg("Build"),
                                label: "Support Tools",
                                on:
                                {
                                    click: function () { skyward.support.build(); }
                                }
                            });
                    }

                    function getUserPreferences(myAccountButton)
                    {
                        if (!myAccountButton.length)
                        {
                            return $();
                        }

                        var data = myAccountButton.data();

                        return expandableMenu.createItem(
                            {
                                svg: skyward.svg.getSvg("User"),
                                label: "User Preferences",
                                on: { click: function () { return skyward.window.loadContent("full", "Security", "UserPreference", "Details", data.userPreferencesPrimaryKeyValue); } }
                            });
                    }

                    function getStopImpersonation(myAccountButton)
                    {
                        if (!myAccountButton.length)
                        {
                            return $();
                        }

                        var data = myAccountButton.data();
                        if (!data.stopUserImpersonation)
                        {
                            return $();
                        }

                        return expandableMenu.createItem(
                            {
                                svg: skyward.svg.getSvg("Stop"),
                                label: "Stop User Impersonation",
                                on: { click: function () { return skyward.window.loadContent("full", "Security", "User", "StopImpersonation"); } }
                            });
                    }

                    function getChangePassword(myAccountButton)
                    {
                        if (!myAccountButton.data("changeMyPasswordIconCode"))
                        {
                            return $();
                        }

                        const data = myAccountButton.data();
                        const passwordData =
                        {
                            "Workflow.UserID": data.changeMyPasswordUserId,
                            "Workflow.UserID_securityhash": data.changeMyPasswordUserId_securityhash
                        };

                        return expandableMenu.createItem(
                            {
                                svg: skyward.svg.getSvg(data.changeMyPasswordIconCode),
                                label: "Change Password",
                                on:
                                {
                                    click: function ()
                                    {
                                        return skyward.window.loadContent("popup", "Workflow", "WorkflowInstance", "Create/Security/User/ChangeMyPassword", null, passwordData)
                                            .then(() =>
                                            {
                                                skyward.mainMenu.closeMenu();
                                            });
                                    }
                                }
                            });
                    }
                }

                function getSelectionMenu(item)
                {
                    item = $(item);
                    var text = item.text().trim();

                    if (!text.length)
                    {
                        return;
                    }

                    return expandableMenu.create(
                        {
                            searchable: true,
                            container:
                            {
                                class: classes.getSelectionMenu,

                                data:
                                {
                                    "update-action": $().add(item.find(".headerSelect")).add(item.filter(".headerSelect")).data("update-action"),
                                    "header-item": item
                                },
                                on:
                                {
                                    "before-toggle-show": getSelectionItems,
                                    "after-toggle-show": scrollMenuIntoView
                                }
                            },
                            title:
                            {
                                label: text,
                                class: classes.menuGroupSelectionTitle
                            }
                        });

                    function getSelectionItems(ul)
                    {
                        var deferred = $.Deferred();

                        if (ul.data("has-items"))
                        {
                            deferred.resolve();
                        }
                        else
                        {
                            var searchBox = ul.data("header-item").find(".tileViewEEL_search");

                            $.ajax(
                                {
                                    url: skyward.global.virtualDir + "Common/TileViewEEL/ViewSearchResults/" + searchBox.val(),
                                    type: "POST",
                                    dataType: "JSON",
                                    activityIndicator: { hideGlass: true },
                                    data: skyward.tileViewEEL.getPostData(searchBox.data(), searchBox),
                                    success: async function (data)
                                    {
                                        var items = $();

                                        var selectedItemKey = ul.data("header-item").find("[data-selected-item-key]").attr("data-selected-item-key");

                                        for (const itemHtml of data.templatedItems)
                                        {
                                            const processedItem = await skyward.global.processViewPartHtml(itemHtml);
                                            const item = $(processedItem);
                                            items = items.add(expandableMenu.createItem(
                                                {
                                                    label: item.text(),
                                                    class: function ()
                                                    {
                                                        var classList = [classes.menuGroupSelectionItem];

                                                        if (!item.find(".headerSelect__option--indented").length)
                                                        {
                                                            classList.push(classes.menuGroupSelectionNoIndent);
                                                        }
                                                        if (item.data("id") == selectedItemKey)
                                                        {
                                                            classList.push("fontBold");
                                                        }
                                                        return classList.join(" ");
                                                    },
                                                    data: { id: item.data("id") },
                                                    on:
                                                    {
                                                        click: function (li)
                                                        {
                                                            var updateAction = ul.data("update-action");

                                                            if (updateAction)
                                                            {
                                                                skyward.mainMenu.closeMenu();
                                                                $.ajax(
                                                                    {
                                                                        url: skyward.global.virtualDir + updateAction,
                                                                        type: "POST",
                                                                        data: { newValue: li.data("id") },
                                                                        success: function (data)
                                                                        {
                                                                            if (data.redirect)
                                                                            {
                                                                                window.location.href = skyward.global.virtualDir + data.redirect;
                                                                            }
                                                                            else
                                                                            {
                                                                                window.location.reload(true);
                                                                            }
                                                                        }
                                                                    });
                                                            }
                                                        }
                                                    }
                                                }));
                                        }

                                        ul.append(items).data("has-items", true);

                                        // We need to use a timeout here to allow time for a css paint event to register the added list element.
                                        //This is necessary to get the css transition to work properly (it needs to paint the before state before it can know to transition to the after state)
                                        window.setTimeout(deferred.resolve, 50);
                                    },
                                    error: function ()
                                    {
                                        deferred.reject();
                                    }
                                });
                        }

                        collapseMenusInContainer($(classes.menuGroupUserMenu.dot()), ul);

                        return deferred.promise();
                    }
                }

                function getMobileTopLevelHeaderSelectMenus()
                {
                    var headerSelect = $(".headerSelectContainer__item > .headerSelect.js-headerSelect--topLevel");
                    return headerSelect.toArray().map(getSelectionMenu).reduce((accum, menu) => accum.add(menu), $());
                }

                function getMobileMenuHomeButton()
                {
                    const homeButton = $("<div>", { class: classes.menuHomeButton });
                    homeButton.append(skyward.svg.getSvg("Home", "Group"));
                    homeButton.append($("<span>", { class: classes.menuHomeButtonText, text: "Home" }));
                    return homeButton;
                }

                function getMobilePortalMenu()
                {
                    if (cache.portalButtons.length <= 1)
                    {
                        return;
                    }

                    var portalButtons = [];
                    var selectedPortal;

                    cache.portalButtons.map(function (data)
                    {
                        var portal =
                        {
                            class: (!data.supported ? classes.menuGroupPortalUnsupported : ""),
                            "data":
                            {
                                "portal-code": data.portalCode,
                                "display-text": data.displayText
                            },
                            "svg": skyward.svg.getSvg(data.icon, "PortalButtons"),
                            "label": data.displayText,
                            "on":
                            {
                                click: function (li)
                                {
                                    if (li.hasClass(classes.menuGroupTitle))
                                    {
                                        return;
                                    }

                                    if (li.hasClass(classes.menuGroupPortalUnsupported))
                                    {
                                        showUnsupportedPortalMessage(li);
                                    }
                                    else
                                    {
                                        selectPortal(li);
                                    }
                                }
                            }
                        };

                        if (cache.selectedPortalCode === data.portalCode)
                        {
                            selectedPortal = portal;
                        }
                        else
                        {
                            portalButtons.push(portal);
                        }
                    });

                    if (!selectedPortal && portalButtons.length)
                    {
                        selectedPortal = portalButtons.shift();
                    }

                    return expandableMenu.create(
                        {
                            container:
                            {
                                class: classes.menuGroupPortalMenu
                            },
                            title: selectedPortal,
                            items: portalButtons
                        });

                    function selectPortal(li)
                    {
                        var portalCode = li.data().portalCode;
                        cache.selectedPortalCode = portalCode;

                        $(classes.menuGroupPortalMenu.dot()).replaceWith(getMobilePortalMenu);

                        $.when(cache.getPortal(portalCode)).then(function (portalData)
                        {
                            var portalContent = constructor.getPortalContentParts();
                            domHandler.appendModuleMenuParts(constructor, portalContent);
                        },
                        function ()
                        {
                            constructor.getMenuLayoutParts().menuModuleList.empty().append($("<div>", { class:"menu-no-results", text: "No Results to Display" }));
                        });
                    }

                    function showUnsupportedPortalMessage(li)
                    {
                        var data = li.data();
                        var content = $("<div>", { class: "modalContent" });
                        var header = $("<div>", { class: "modalContent__header" });

                        var svg = skyward.svg.getSvg("Utilities")
                            .addClass("modalContentHeader__svg")
                            .addClass("svgNoHover");

                        header.append(svg);
                        header.append($("<h1>", { class: "modalContentHeader__text", text: "We're Sorry!" }));

                        content.append(header);

                        content.append($("<p>", { class: "modalContent__text", text: data.displayText + " is currently unavailable within the mobile application." }));
                        content.append($("<p>", { class: "modalContent__text", text: "Until it is available, you can use " + data.displayText + " within a web browser." }));

                        skyward.modalLayer.showInformationDialog("Portal Unavailable", content);
                    }
                }

                function getMobileMessagesButton()
                {
                    const button = $(classes.mobileMessagesButton.dot());

                    const messageCounter = parseInt($("#MessageNotificationContainer").find(".notificationBubble").text());

                    if (messageCounter > 0)
                    {
                        const counterSpan = $("<span>", { class: classes.messageCounter, text: messageCounter });
                        button.append(counterSpan);

                        window.setTimeout(function ()
                        {
                            counterSpan.addClass(classes.messageCounterVisible); /* animate the message counter */
                        }, 200);
                    }

                    return button;
                }

                constructor.getModuleContentParts = function (categoryData)
                {
                    var moduleItems = [];
                    var showHeader = categoryData.length > 1;

                    categoryData.map(function (category)
                    {
                        if (showHeader)
                        {
                            moduleItems.push(expandableMenu.createHeader(
                                {
                                    label: category.label
                                }));
                        }

                        category.menus.map(function (menuItem)
                        {
                            moduleItems.push(expandableMenu.createItem(
                                {
                                    label: menuItem.displayText,
                                    data: menuItem,
                                    on:
                                    {
                                        click: function (li)
                                        {
                                            var data = li.data();
                                            skyward.window.loadContent(data.target, data.module, data.object, data.screen, null, data.data);
                                            $(classes.mobileMenuButton.dot()).trigger("click");
                                        }
                                    }
                                }));
                        });
                    });

                    return moduleItems;
                };

                constructor.getPortalContentParts = function ()
                {
                    var moduleMenus = [];

                    $(cache.selectedModuleButtonDatas).each(function (i, buttonData)
                    {
                        moduleMenus.push(expandableMenu.create(
                            {
                                container:
                                {
                                    class: classes.menuGroupModuleMenu,
                                    data:
                                    {
                                        "module-i-d": buttonData.moduleID
                                    },
                                    on:
                                    {
                                        "before-toggle-show": getModuleMenus,
                                        "after-toggle-show": scrollMenuIntoView
                                    }
                                },
                                title:
                                {
                                    svg: skyward.svg.getSvg(buttonData.icon),
                                    label: buttonData.displayText
                                }
                            }));
                    });
                    return moduleMenus;

                    function getModuleMenus(ul)
                    {
                        cache.selectedModuleID = ul.data().moduleID;

                        var deferred = $.Deferred();

                        collapseMenusInContainer(constructor.layoutParts.menuModuleList, ul);

                        if (!ul.data("hasModules"))
                        {
                            $.when(cache.getModuleCategories(cache.selectedPortalCode, cache.selectedModuleID)).done(function (moduleCategories)
                            {
                                var moduleParts = constructor.getModuleContentParts(moduleCategories);
                                ul.append(moduleParts).data("hasModules", true);
                                /* We need to use a timeout here to allow time for a css paint event to register the added list element.
                                    * This is necessary to get the css transition to work properly (it needs to paint the before state before it can know to transition to the after state) */
                                window.setTimeout(deferred.resolve, 50);
                            });
                        }
                        else
                        {
                            deferred.resolve();
                        }

                        return deferred.promise();
                    }
                };

                constructor.getMenuLayoutParts = function ()
                {
                    if (constructor.layoutParts)
                    {
                        return constructor.layoutParts;
                    }

                    constructor.layoutParts =
                    {
                        header: $(classes.mobileHeader.dot()),
                        menuButton: $(classes.mobileMenuButton.dot()),
                        backButton: getMobileBackButton(),
                        homeButton: $(classes.mobileHomeButton.dot()),
                        messagesButton: getMobileMessagesButton(),
                        friendlyName: getScreenFriendlyName(),
                        menu: $("<div>", { class: classes.mobileMenu }),
                        menuUserMenu: getMobileUserMenu(),
                        menuHeaderSelect: getMobileTopLevelHeaderSelectMenus(),
                        menuPortalMenu: getMobilePortalMenu(),
                        menuModuleList: $("<div>", { class: classes.moduleList }),
                        menuHomeButton: getMobileMenuHomeButton(),
                    };

                    return constructor.layoutParts;
                };

                return constructor;
            };

            var domHandler = (function ()
            {
                var handler = {};
                handler.appendLayoutPartsToDOM = function (layoutParts)
                {
                    layoutParts.header.append(layoutParts.friendlyName);
                    layoutParts.menu.append(layoutParts.menuHeader);
                    layoutParts.menu.append(layoutParts.menuUserMenu);
                    layoutParts.menu.append(layoutParts.menuHeaderSelect);
                    layoutParts.menu.append(layoutParts.menuPortalMenu);
                    layoutParts.menu.append(layoutParts.menuHomeButton);
                    layoutParts.menu.append(layoutParts.menuModuleList);
                    cache.menuLocation.append(layoutParts.menu);
                };
                handler.appendModuleMenuParts = function (constructor, layoutContent)
                {
                    constructor.getMenuLayoutParts().menuModuleList.empty().append(layoutContent);
                };

                return handler;
            })();

            var setEvents = function (constructor)
            {
                var layoutParts = constructor.layoutParts;

                skyward.mainMenu.openMenu = function ()
                {
                    $([classes.menuSource.dot(), classes.mobileGlass.dot()].join(" ")).remove();
                    $(classes.menuSource.dot()).prepend($("<a>", { class: classes.mobileGlass }));
                    layoutParts.menu.addClass(classes.mobileMenuExpanded);
                };

                skyward.mainMenu.closeMenu = function ()
                {
                    layoutParts.menu.removeClass(classes.mobileMenuExpanded);
                    $([classes.menuSource.dot(), classes.mobileGlass.dot()].join(" ")).remove();
                };

                $(document.body).swipe(
                    {
                        preventDefaultEvents: false,
                        swipeStatus: function (event, phase, direction, distance, duration, fingerCount)
                        {
                            if (direction === "up" || direction === "down")
                            {
                                return;
                            }
                            var MENU_COMPLETE_TOLERANCE = 130;
                            var MENU_START_TOLERANCE = 60;
                            var MENU_WIDTH = 300;
                            var startElement;
                            switch (phase)
                            {
                                case "start":
                                    window.cancelTouchSwipe = false;
                                    window.menuIsOpen = skyward.mainMenu.isMenuOpen(); //store as global reference to prevent hitting the dom over and over
                                    if (direction === "left" && !window.menuIsOpen)
                                    {
                                        return;
                                    }
                                    startElement = $(event.target);
                                    if (!window.menuIsOpen && (startElement.closest(".modalLayerContainer").length || hasXScrollingAncestor(event.target)))
                                    {
                                        window.cancelTouchSwipe = true;
                                    }
                                    break;
                                case "move":
                                    if (!window.cancelTouchSwipe)
                                    {
                                        if (window.menuIsOpen)
                                        {
                                            if (direction === "left" && distance > MENU_START_TOLERANCE)
                                            {
                                                layoutParts.menu.css("transform", "translateX(-" + Math.min(distance - MENU_START_TOLERANCE, layoutParts.menu.width()) + "px)");
                                            }
                                        }
                                        else if (direction === "right" && distance > MENU_START_TOLERANCE)
                                        {
                                            layoutParts.menu.css("transform", "translateX(-" + Math.min(MENU_WIDTH, MENU_WIDTH + (MENU_START_TOLERANCE * 2) - distance) + "px)");
                                        }
                                    }
                                    break;
                                case "end":
                                case "cancel":
                                    $(classes.mobileMenu.dot()).css("transform", "");
                                    if (!window.cancelTouchSwipe)
                                    {
                                        if (((window.menuIsOpen && direction === "left") || (!window.menuIsOpen && direction === "right")) && distance > MENU_COMPLETE_TOLERANCE)
                                        {
                                            skyward.mainMenu.toggleMenu();
                                        }
                                    }
                                    break;
                            }

                            function hasXScrollingAncestor(element)
                            {
                                if (!element)
                                {
                                    return false;
                                }
                                var scrollElement = $(element).closest(":scrollable")[0];
                                if (scrollElement)
                                {
                                    if (scrollElement.clientWidth < scrollElement.scrollWidth)
                                    {
                                        return true;
                                    }
                                    else
                                    {
                                        if (scrollElement === element)
                                        {
                                            scrollElement = element.parentNode;
                                        }
                                        return hasXScrollingAncestor(scrollElement);
                                    }
                                }
                                else
                                {
                                    return false;
                                }
                            }
                        }
                    });

                $(document.body).on("click", [classes.menuSource.dot(), classes.mobileGlass.dot()].join(" "), skyward.mainMenu.closeMenu);

                layoutParts.backButton.on("click", function (pEvent)
                {
                    if ($(this).hasClass(classes.mobileBackButtonDisabled))
                    {
                        return;
                    }

                    window.history.back();
                });

                layoutParts.menuButton.on("click", skyward.mainMenu.toggleMenu);

                layoutParts.messagesButton.on("click", function ()
                {
                    skyward.window.loadContent("full", "MessageCenter", "Message", "MyMessages");
                });

                layoutParts.homeButton.on("click", function ()
                {
                    skyward.window.loadContent("full", "home", "home", "index", null, undefined, null, null, null, false, null, null, null);
                });

                layoutParts.menuHomeButton.on("click", function ()
                {
                    let selectedPortal = $(`.${classes.menuGroupPortalMenu} .${classes.menuGroupLabel}`).first().text().replace(/ /g, '');
                    switch (selectedPortal)
                    {
                        case "AdministrativeAccess":
                            selectedPortal = "Administrative";
                            break;
                    }
                    skyward.window.loadContent("full", "home", selectedPortal, "home", null, undefined, null, null, null, false, null, null, null);
                });
            };

            function scrollMenuIntoView(ul)
            {
                /* use a timeout to allow the css transition to complete before checking if it is out of view */
                window.setTimeout(function ()
                {
                    ul.scrollintoview(
                        {
                            viewPadding: { y: -2 }
                        });
                }, 300);
            }

            function collapseMenusInContainer(container, nextMenu)
            {
                var expanded = container.find(classes.menuGroupExpanded.dot());

                if (!expanded.length)
                {
                    return;
                }

                expanded.addClass(classes.menuGroupForcedClosed);

                if (nextMenu && nextMenu.length)
                {
                    nextMenu.scrollintoview(
                        {
                            viewPadding: { y: -2 },
                            duration: 0
                        });
                }

                expanded.removeClass(classes.menuGroupExpanded);

                /* remove the class in a timeout to prevent css transitions from taking effect */
                window.setTimeout(function ()
                {
                    expanded.removeClass(classes.menuGroupForcedClosed);
                }, 200 /* the duration of the css animations */);
            }

            var menu = {};
            menu.initialize = function ()
            {
                $(document.body).addClass("hasMobileMenu");
                var constructor = htmlConstructor();
                var layoutParts = constructor.getMenuLayoutParts();
                domHandler.appendLayoutPartsToDOM(layoutParts);
                domHandler.appendModuleMenuParts(constructor, constructor.getPortalContentParts());
                setEvents(constructor);
            };

            skyward.mainMenu.isMenuOpen = function ()
            {
                return $(classes.mobileMenuExpanded.dot()).length > 0;
            };

            skyward.mainMenu.getBackButton = function ()
            {
                return $(classes.mobileBackButton.dot());
            };

            return menu;
        };

        var init = function ()
        {
            this.find(classes.menuSource.dot()).each(function ()
            {
                var menuSource = $(this);

                if (skyward.global.mobileAccess)
                {
                    cache.initializeOnDomLoad(menuSource, menuSource.data().menu);
                    mobileMenu().initialize();
                }
                else
                {
                    var menuButton = $(classes.jsDesktopMenuVisibilityToggle.dot());
                    skyward.mainMenu = skyward.mainMenuVueBuilder.getMainMenuVue(menuSource[0], menuButton[0]);
                }
            });
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
﻿// Visual Studio has support for JSDoc annotations like these, they make life a little easier
/**
 * @typedef AttendanceRow
 * @type {object}
 * @property {number} id - AttendancePeriodID
 * @property {object} controls - jQuery elements for attendanceTypeEel, attendanceTypeEelCodeTb, attendanceReasonEel, and commentTb
 */
/**
 * @typedef PeriodRowData
 * @type {object}
 * @property {AttendanceRow} Row
 * @property {number} AttendanceTypeID
 * @property {number} AttendanceReasonID
 * @property {string} Comment
 */
(
    function (skyward, $)
    {
        "use strict";

        skyward.attendanceEntryTools = skyward.attendanceEntryTools || {};

        var entryToolSelector = '#attendanceEntryTool_';
        var formControls;
        var allAttendancePeriodControls;
        var editableAttendancePeriodControls;
        var attendanceEntryErrorsDiv;
        var attendanceEntryContainerDiv;
        var attendancePeriodLowFilterHdn;
        var attendancePeriodHighFilterHdn;
        var attendancePeriodMinFilterHdn;
        var attendancePeriodMaxFilterHdn;
        var nameSelectorTb;
        var startPeriodAsteriskSpan;
        var endPeriodAsteriskSpan;
        var currentStudentAttendanceSelectedRow;
        var studentId;
        var studentAbsenceRequestId;
        var currentSchoolYearId;
        var studentNotEnrolledInDates = true;
        var dirtyPeriods;
        var controllerObject;
        var pageLoaded = false;
        var loadedWithAttendance;
        /** @type {{AttendancePeriodID: PeriodRowData}} */
        var validatePeriodAttendancePeriodIDs = {};

        /**
         * @param {JQuery} attendancePeriodRow - Attendance Period/Type/Reason/Comment
         * @returns {AttendanceRow} - collection of Attendance Period/Type/Reason/Comment
         */
        var getAttendancePeriodRowData = function (attendancePeriodRow)
        {
            var row = {};

            row.id = attendancePeriodRow.find('.attendancePeriodId').val();
            row.controls = {};

            row.controls.attendanceTypeEel = attendancePeriodRow.find('.codeEEL.attendanceEntryGridAttendanceType');
            row.controls.attendanceTypeEelCodeTb = row.controls.attendanceTypeEel.find('.codeEELCode'); // used for tabbing
            row.controls.attendanceReasonEel = attendancePeriodRow.find('.codeEEL.attendanceEntryGridAttendanceReason');
            row.controls.commentTb = attendancePeriodRow.find('.attendancePeriodCommentElement:not(.attendanceEntryGridAttendanceTeacherComment)');

            row.controls.OfficeCommentButtonsContainer = attendancePeriodRow.find('.officeCommentButtonsContainer');
            row.controls.HideCommentInTA = attendancePeriodRow.find('.hideInTAHidden');
            row.controls.HideCommentInAA = attendancePeriodRow.find('.hideInAAHidden');
            row.controls.HideCommentInSSA = attendancePeriodRow.find('.hideInSSAHidden');
            row.controls.HideCommentInFA = attendancePeriodRow.find('.hideInFAHidden:not(.hideInFAHiddenTeacher)');
            row.controls.HideCommentInSA = attendancePeriodRow.find('.hideInSAHidden:not(.hideInSAHiddenTeacher)');
            row.controls.HideTeacherCommentInFA = attendancePeriodRow.find('.hideInFAHidden.hideInFAHiddenTeacher');
            row.controls.HideTeacherCommentInSA = attendancePeriodRow.find('.hideInSAHidden.hideInSAHiddenTeacher');
            return row;
        };

        /**
         * @param {AttendanceRow} rowData - Attendance Period/Type/Reason/Comment
         * @returns {PeriodRowData} - collection of Attendance Period/Type/Reason/Comment
         */
        var getAttendancePeriodsValuesForRow = function (rowData)
        {
            return {
                Row: rowData,
                AttendanceTypeID: skyward.controls.getValue(rowData.controls.attendanceTypeEel),
                AttendanceReasonID: skyward.controls.getValue(rowData.controls.attendanceReasonEel),
                Comment: skyward.extensions.decodeHtml(skyward.controls.getValue(rowData.controls.commentTb)),
                HideCommentInTA: skyward.controls.getValue(rowData.controls.HideCommentInTA),
                HideCommentInAA: skyward.controls.getValue(rowData.controls.HideCommentInAA),
                HideCommentInSSA: skyward.controls.getValue(rowData.controls.HideCommentInSSA),
                HideCommentInFA: skyward.controls.getValue(rowData.controls.HideCommentInFA),
                HideCommentInSA: skyward.controls.getValue(rowData.controls.HideCommentInSA),
                HideTeacherCommentInFA: skyward.controls.getValue(rowData.controls.HideTeacherCommentInFA),
                HideTeacherCommentInSA: skyward.controls.getValue(rowData.controls.HideTeacherCommentInSA)
            };
        };

        var init = function (selector)
        {
            var jqSelector = $(selector);
            if (jqSelector.find(entryToolSelector + 'AttendanceTypeID').length != 0)
            {
                formControls = {};
                formControls.attendanceTypeEel = jqSelector.find(entryToolSelector + 'AttendanceTypeID');
                formControls.attendanceTypeEelCodeTb = formControls.attendanceTypeEel.find(entryToolSelector + 'AttendanceTypeID_code'); // used for tabbing
                formControls.attendanceReasonEel = jqSelector.find(entryToolSelector + 'AttendanceReasonID');
                formControls.startDateTb = jqSelector.find(entryToolSelector + 'StartDate');
                formControls.endDateTb = jqSelector.find(entryToolSelector + 'EndDate');
                formControls.startPeriodEel = jqSelector.find(entryToolSelector + 'StartPeriod');
                formControls.startPeriodEelCodeTb = formControls.startPeriodEel.find(entryToolSelector + 'StartPeriod_code'); // used for tabbing
                formControls.endPeriodEel = jqSelector.find(entryToolSelector + 'EndPeriod');
                formControls.endPeriodEelCodeTb = formControls.endPeriodEel.find(entryToolSelector + 'EndPeriod_code'); // used for tabbing
                formControls.allDayCkb = jqSelector.find(entryToolSelector + 'AllDay');

                formControls.commentTb = jqSelector.find(entryToolSelector + 'Comment');
                formControls.replyToGuardianTb = jqSelector.find(entryToolSelector + 'ReplyToGuardian');
                formControls.guardianComment = jqSelector.find(entryToolSelector + 'GuardianComment');
                formControls.dayComment = jqSelector.find(entryToolSelector + 'DayComment');
                formControls.dayCommentAttendanceCommentPrivacySettingContainer = jqSelector.find(entryToolSelector + 'DayCommentAttendanceCommentPrivacySettingContainer');
                formControls.commentAttendanceCommentPrivacySettingContainer = jqSelector.find(entryToolSelector + 'AttendanceCommentPrivacySettingContainer');
                formControls.dayCommentHideInFA = jqSelector.find(entryToolSelector + 'HideCommentInFA');
                formControls.dayCommentHideInSA = jqSelector.find(entryToolSelector + 'HideCommentInSA');
                formControls.dayCommentHideInTA = jqSelector.find(entryToolSelector + 'HideCommentInTA');
                formControls.dayCommentHideInAA = jqSelector.find(entryToolSelector + 'HideCommentInAA');
                formControls.dayCommentHideInSSA = jqSelector.find(entryToolSelector + 'HideCommentInSSA');

                formControls.periodCommentHideInFA = jqSelector.find(entryToolSelector + 'HideCommentInFA-PeriodComment');
                formControls.periodCommentHideInSA = jqSelector.find(entryToolSelector + 'HideCommentInSA-PeriodComment');
                formControls.periodCommentHideInTA = jqSelector.find(entryToolSelector + 'HideCommentInTA-PeriodComment');
                formControls.periodCommentHideInAA = jqSelector.find(entryToolSelector + 'HideCommentInAA-PeriodComment');
                formControls.periodCommentHideInSSA = jqSelector.find(entryToolSelector + 'HideCommentInSSA-PeriodComment');

                formControls.isGuardianNotifiedCkb = jqSelector.find(entryToolSelector + 'IsGuardianNotified');
                formControls.currentStudentBrowse = jqSelector.find(entryToolSelector + 'CurrentStudentBrowse');
                formControls.cancelBtn = jqSelector.find(entryToolSelector + 'cancel');
                formControls.saveBtn = jqSelector.find(entryToolSelector + 'save');
                formControls.saveAndBackBtn = jqSelector.find(entryToolSelector + 'saveBack');
                formControls.processRequestWithExistingAttendance = jqSelector.find(entryToolSelector + 'ProcessRequestWithExistingAttendance');
                formControls.attendanceEntryErrors = jqSelector.find(entryToolSelector + 'AttendanceEntryErrors');
                formControls.attachments = jqSelector.find(entryToolSelector + 'UploadFile');
                formControls.dayStatusOverrideEel = jqSelector.find(entryToolSelector + 'AttendanceTypeIDDayStatusOverride');
                formControls.dayStatusCalculatedEel = jqSelector.find(entryToolSelector + 'AttendanceTypeIDCalculatedDayStatus');
                formControls.useDayStatusOverrideCb = jqSelector.find(entryToolSelector + 'UseAttendanceTypeDayStatusOverride');
                formControls.useMetMinutesRequiredOverrideCb = jqSelector.find(entryToolSelector + 'UseMetMinutesRequiredOverride');
                formControls.metMinutesRequiredOverrideCb = jqSelector.find(entryToolSelector + 'MetMinutesRequiredOverride');
                formControls.getGeneratedAttendancePeriodsStartDate = function ()
                {
                    return jqSelector.find(entryToolSelector + 'GeneratedAttendancePeriods_StartDate');
                };
                formControls.getGeneratedAttendancePeriodsEndDate = function ()
                {
                    return jqSelector.find(entryToolSelector + 'GeneratedAttendancePeriods_EndDate');
                };

                var currentSchoolYearLbl = $('.currentSchoolYear');
                currentSchoolYearId = (currentSchoolYearLbl.hasClass('current')) ? currentSchoolYearLbl.attr('id') : null;
                studentId = jqSelector.find(entryToolSelector + 'StudentID').val();
                studentAbsenceRequestId = jqSelector.find(entryToolSelector + 'StudentAbsenceRequestID').val();
                attendanceEntryErrorsDiv = jqSelector.find(entryToolSelector + 'AttendanceEntryErrors');
                attendanceEntryContainerDiv = jqSelector.find(entryToolSelector + 'AttendanceQuickEntry');
                nameSelectorTb = jqSelector.find('#NameSelector_input');
                startPeriodAsteriskSpan = jqSelector.find(entryToolSelector + 'StartPeriodLabel > .requiredAsterisk');
                endPeriodAsteriskSpan = jqSelector.find(entryToolSelector + 'EndPeriodLabel > .requiredAsterisk');
                controllerObject = jqSelector.find(entryToolSelector + 'ControllerObject').val();

                formControls.attendanceTypeEel.on('eelComplete', setAttendancePeriodEels);
                formControls.attendanceReasonEel.on('eelComplete', setAttendancePeriodEels);
                formControls.startPeriodEel.on('eelComplete', setAttendancePeriodEels);
                formControls.endPeriodEel.on('eelComplete', setAttendancePeriodEels);
                formControls.commentTb.on('change', setAttendancePeriodEels);
                formControls.allDayCkb.on('change', setAttendancePeriodEels);
                formControls.commentAttendanceCommentPrivacySettingContainer.on('commentPrivacySettingsChanged', setAttendancePeriodEels);
                formControls.startDateTb.on('change', changeEndDate);
                formControls.endDateTb.on('change', validateDates);
                nameSelectorTb.on('keydown', tabOverride);
                formControls.cancelBtn.on('keydown', tabOverride);
                formControls.startDateTb.on('keydown', tabOverride);
                formControls.startPeriodEelCodeTb.on('keydown', tabOverride);
                formControls.isGuardianNotifiedCkb.on('keydown', tabOverride);
                formControls.cancelBtn.on('click', validateDates);
                jqSelector.find(entryToolSelector + 'CurrentStudentBrowse').on('click', 'tr.browseRow', toggleCurrentRow);
                var focusToAllDayHdn = jqSelector.find(entryToolSelector + 'FocusToAllDayOnLoad');
                if (focusToAllDayHdn && focusToAllDayHdn.val() === 'True')
                {
                    formControls.allDayCkb.focus();
                }
                else
                {
                    nameSelectorTb.focus();
                }

                if (isStudentAbsenceRequest())
                {
                    //This won't mess with tabbing, that only trigggers on the keydown event
                    $(this).off('change dirty keyup').on('change dirty keyup', toggleVisibilityProcessRequestWithExistingAttendance);
                }
                formControls.processRequestWithExistingAttendance.off().on('click', attendanceEntryToolAddEntryProcessRequestWithExistingAttendance)
                                                                       .on('keydown', tabOverride);
                formControls.saveBtn.off().on('click', attendanceEntryToolAddEntrySave);
                formControls.saveAndBackBtn.off().on('click', attendanceEntryToolAddEntrySaveAndBack);
                skyward.changeTracking.clearDirtyList();
                hideErrors();
            }

            // Register controls for the attendance period grid only on the attendance tool load
            if (jqSelector.find('.attendanceToolEntryTable').length > 0)
            {
                attendancePeriodLowFilterHdn = jqSelector.find(entryToolSelector + 'AttendancePeriodLowFilter');
                attendancePeriodHighFilterHdn = jqSelector.find(entryToolSelector + 'AttendancePeriodHighFilter');
                attendancePeriodMinFilterHdn = jqSelector.find(entryToolSelector + 'AttendancePeriodMinFilter');
                attendancePeriodMaxFilterHdn = jqSelector.find(entryToolSelector + 'AttendancePeriodMaxFilter');

                // Attach event handlers to ensure that the attendance period high & low filters can't have a value of ''
                // The framework does this when someone clicks out of the start/end period eels without selecting a value
                attendancePeriodLowFilterHdn.off("change", assertValueNotEmpty).on("change", assertValueNotEmpty);
                attendancePeriodHighFilterHdn.off("change", assertValueNotEmpty).on("change", assertValueNotEmpty);

                var attendancePeriodRows = $('.attendanceEntryTable .attendancePeriodRow');
                editableAttendancePeriodControls = [];
                allAttendancePeriodControls = [];

                attendancePeriodRows.each(function ()
                {
                    var attendancePeriodRow = getAttendancePeriodRowData($(this));
                    var attendanceTypeEEL = attendancePeriodRow.controls.attendanceTypeEel.find('input.attendancePeriodTypeElement');

                    if (getPartIsEnabled(attendanceTypeEEL))
                    {
                        attendanceTypeEEL.parents('.attendanceEntryGridAttendanceType').on('eelComplete', attendanceTypeUpdate);

                        editableAttendancePeriodControls.push(attendancePeriodRow);
                    }
                    allAttendancePeriodControls.push(attendancePeriodRow);
                });

                // custom tabbing
                if (editableAttendancePeriodControls[0])
                {
                    editableAttendancePeriodControls[0].controls.attendanceTypeEelCodeTb.on('keydown', tabOverride);
                    editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.attendanceTypeEelCodeTb.on('keydown', tabOverride);
                    editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.commentTb.on('keydown', tabOverride);
                }

                var formValues = getCurrentFormValues();
                if (!studentAbsenceRequestId && (formValues.allDay || formValues.startPeriodId && formValues.endPeriodId))
                {
                    setAttendancePeriodEels();
                }
            }

            // DOM element(s) loading contain the AttendancePeriodForm the element actually *is* the Form
            if (jqSelector.find('.attendancePeriodFormContainer').length || jqSelector.is('.attendancePeriodFormContainer'))
            {
                studentNotEnrolledInDates = (skyward.controls.getValue(jqSelector.find(entryToolSelector + 'DisablePeriodEELs')) || '').toLowerCase() === 'true';
                formControls.attendanceEntryTable = jqSelector.find('.attendanceEntryTable');
                formControls.attendanceEntryTable.off('change').on('change', attendanceEntryTableChange);
                periodEELControlsRenderManager();
                validateDates();
            }

            if (jqSelector.find('.currentStudentAttendanceTable').length > 0)
            {
                currentStudentAttendanceSelectedRow = jqSelector.find('.currentStudentAttendanceTable .current');
            }

            if (!pageLoaded && isStudentAbsenceRequest() && hasAttendanceValues())
            {
                loadedWithAttendance = true;
            }

            pageLoaded = true;
        };

        /**
         * This function is used to keep the hidden AttendancePeriod high/low filters
         * from having a value of an empty string as this causes the codeeel browses for the
         * start & end periods to break. It's called when the value of those filters change.
         */
        var assertValueNotEmpty = function ()
        {
            let currentValue = skyward.controls.getValue(this);
            if (typeof currentValue === "string" && currentValue.length === 0)
            {
                let origValue = skyward.controls.getOriginalValue(this);
                skyward.controls.setValue(this, origValue);
            }
        }

        var isStudentAbsenceRequest = function ()
        {
            return studentAbsenceRequestId && studentAbsenceRequestId !== "";
        };

        var hasAttendanceValues = function ()
        {
            var values = getCurrentAttendancePeriodValues();

            if (!values || !values.length)
            {
                return false;
            }

            var attendanceEntered = false;
            $.each(values, function (index, value)
            {
                if (value.attendanceTypeId)
                {
                    attendanceEntered = true;
                    return false;
                }
            });

            return attendanceEntered;
        };

        var dirtySaveControls = function ()
        {
            if (formControls === undefined || formControls.processRequestWithExistingAttendance.is(':visible') == true)
            {
                return {};
            }

            var checkAddDirtyClass = function (button)
            {
                if (button && !button.hasClass("dirty"))
                {
                    button.addClass("dirty");
                }
            };

            checkAddDirtyClass(formControls.saveBtn);
            checkAddDirtyClass(formControls.saveAndBackBtn);
            checkAddDirtyClass(formControls.cancelBtn);
        };

        var getCurrentFormValues = function ()
        {
            // Ensure formControls has been initalized
            if (formControls === undefined)
            {
                return {};
            }

            var values = {};
            values.attendanceTypeId = skyward.controls.getValue(formControls.attendanceTypeEel);
            values.attendanceReasonId = skyward.controls.getValue(formControls.attendanceReasonEel);
            values.startDate = formControls.startDateTb.encodedVal();
            values.endDate = formControls.endDateTb.encodedVal();
            values.startPeriodId = skyward.controls.getValue(formControls.startPeriodEel);
            values.endPeriodId = skyward.controls.getValue(formControls.endPeriodEel);
            values.allDay = skyward.controls.getValue(formControls.allDayCkb);
            values.isGuardianNotified = skyward.controls.getValue(formControls.isGuardianNotifiedCkb);
            values.useAttendanceTypeDayStatusOverride = skyward.controls.getValue(formControls.useDayStatusOverrideCb);
            values.attendanceTypeIDDayStatusOverride = skyward.controls.getValue(formControls.dayStatusOverrideEel);
            values.comment = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.commentTb));
            values.dayComment = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayComment));
            values.dayCommentHideInFA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInFA));
            values.dayCommentHideInSA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInSA));
            values.dayCommentHideInTA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInTA));
            values.dayCommentHideInAA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInAA));
            values.dayCommentHideInSSA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.dayCommentHideInSSA));

            values.useMetMinutesRequiredOverride = skyward.controls.getValue(formControls.useMetMinutesRequiredOverrideCb);
            values.metMinutesRequiredOverride = skyward.controls.getValue(formControls.metMinutesRequiredOverrideCb);
           
            values.periodCommentHideInFA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInFA));
            values.periodCommentHideInSA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInSA));
            values.periodCommentHideInTA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInTA));
            values.periodCommentHideInAA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInAA));
            values.periodCommentHideInSSA = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.periodCommentHideInSSA));

            values.replyToGuardian = skyward.extensions.decodeHtml(skyward.controls.getValue(formControls.replyToGuardianTb));

            values.warninghash = attendanceEntryContainerDiv.data('warninghash');

            return values;
        };

        /**
         * Note: Sets "dirtyPeriods" to true if any of the Attendance Period values found are dirty
         * @returns {attendancePeriodValues} - collection of Attendance Period/Type/Reason/Comment
         */
        var getCurrentAttendancePeriodValues = function ()
        {
            var attendancePeriodValues = [];
            if (!editableAttendancePeriodControls || editableAttendancePeriodControls.length < 1)
            {
                return;
            }
            $.each(editableAttendancePeriodControls, function (index, row)
            {
                var allValues = getAttendancePeriodsValuesForRow(row);

                // The values object is deliberately constructed as a copy of allValues (minus most properties) to avoid
                // including more than we need on it since it will be serialized and sent over the wire
                var values = {};
                values.attendancePeriodId = allValues.Row.id;
                values.attendanceTypeId = allValues.AttendanceTypeID;
                values.attendanceReasonId = allValues.AttendanceReasonID;
                values.comment = allValues.Comment
                values.HideCommentInFA = allValues.HideCommentInFA;
                values.HideCommentInSA = allValues.HideCommentInSA;
                values.HideCommentInTA = allValues.HideCommentInTA;
                values.HideCommentInAA = allValues.HideCommentInAA;
                values.HideCommentInSSA = allValues.HideCommentInSSA;
                values.HideTeacherCommentInFA = allValues.HideTeacherCommentInFA;
                values.HideTeacherCommentInSA = allValues.HideTeacherCommentInSA;

                attendancePeriodValues.push(values);
            });

            // not already dirty from Guardian Notified or End Date changing, check if anything in AttendancePeriodForm table is dirty
            if (!dirtyPeriods)
            {
                dirtyPeriods = skyward.changeTracking.isDirty(formControls.attendanceEntryTable);
            }

            return attendancePeriodValues;
        };

        var setAttendancePeriodEels = function (e)
        {
            // Don't update values if triggered from code (Return on Save & Clear) or if editableAttendancePeriodControls is currently empty
            if ((e && e.originalEvent === undefined && e.type == 'change') ||
                !editableAttendancePeriodControls || !editableAttendancePeriodControls.length)
            {
                return;
            }

            if (e && e.currentTarget)
            {
                var checkPeriodRange = function ()
                {
                    var startPeriod = skyward.controls.getValue(formControls.startPeriodEel);
                    var endPeriod = skyward.controls.getValue(formControls.endPeriodEel);
                    if (startPeriod === undefined || startPeriod === '' || endPeriod === undefined || endPeriod === '')
                    {
                        return false;
                    }
                    return true;
                }

                //wait for both start and end to be filled
                if (formControls.allDayCkb && e.currentTarget == formControls.allDayCkb[0] && !skyward.controls.getValue(formControls.allDayCkb) && !checkPeriodRange())
                {
                    return;
                }
                else if (((formControls.startPeriodEel && e.currentTarget == formControls.startPeriodEel[0]) || (formControls.endPeriodEel && e.currentTarget == formControls.endPeriodEel[0])) && !checkPeriodRange())
                {
                    return;
                }
            }

            var formValues = getCurrentFormValues();

            if (formValues.allDay)
            {
                formValues.startPeriodId = editableAttendancePeriodControls[0].id;
                formValues.endPeriodId = editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].id;
                if (startPeriodAsteriskSpan.get(0))
                {
                    startPeriodAsteriskSpan.hide();
                }

                if (endPeriodAsteriskSpan.get(0))
                {
                    endPeriodAsteriskSpan.hide();
                }
            }
            else
            {
                periodEELControlsRenderManager();
                if (startPeriodAsteriskSpan.get(0))
                {
                    startPeriodAsteriskSpan.show();
                }

                if (endPeriodAsteriskSpan.get(0))
                {
                    endPeriodAsteriskSpan.show();
                }
            }

            hideErrors();
            var isInRange = formValues.allDay;

            $.each(allAttendancePeriodControls, function (index, row)
            {
                isInRange = isInRange || row.id == formValues.startPeriodId;

                var attendancePeriodControlsContainsID = function (id)
                {
                    var collectionContainsValue = false;
                    $.each(editableAttendancePeriodControls, function (index, row)
                    {
                        if (row.id === id)
                        {
                            collectionContainsValue = true;
                            return;
                        }
                    });
                    return collectionContainsValue;
                };

                var getRowValues = function (id)
                {
                    var attendanceTypeId = null;
                    var attendanceReasonId = null;
                    var comment = null;
                    var hideCommentInTA = null;
                    var hideCommentInAA = null;
                    var hideCommentInSSA = null;
                    var hideCommentInFA = null;
                    var hideCommentInSA = null;
                    var hideTeacherCommentInFA = null;
                    var hideTeacherCommentInSA = null;
                    $.each(editableAttendancePeriodControls, function (index, row)
                    {
                        if (row.id === id)
                        {
                            attendanceTypeId = skyward.controls.getValue(row.controls.attendanceTypeEel);
                            attendanceReasonId = skyward.controls.getValue(row.controls.attendanceReasonEel);
                            comment = skyward.controls.getValue(row.controls.commentTb);

                            hideCommentInTA = skyward.controls.getValue(row.controls.HideCommentInTA);
                            hideCommentInAA = skyward.controls.getValue(row.controls.HideCommentInAA);
                            hideCommentInSSA = skyward.controls.getValue(row.controls.HideCommentInSSA);
                            hideCommentInFA = skyward.controls.getValue(row.controls.HideCommentInFA);
                            hideCommentInSA = skyward.controls.getValue(row.controls.HideCommentInSA);
                            hideTeacherCommentInFA = skyward.controls.getValue(row.controls.HideTeacherCommentInFA);
                            hideTeacherCommentInSA = skyward.controls.getValue(row.controls.HideTeacherCommentInSA);

                            if (hideTeacherCommentInFA == null || hideTeacherCommentInFA == "")
                            {
                                hideTeacherCommentInFA = false;
                            }
                            if (hideTeacherCommentInSA == null || hideTeacherCommentInSA == "")
                            {
                                hideTeacherCommentInSA = false;
                            }
                            return;
                        }
                    });

                    var values =
                    {
                        AttendanceTypeID: attendanceTypeId,
                        AttendanceReasonID: attendanceReasonId,
                        Comment: comment,
                        HideCommentInTA: hideCommentInTA,
                        HideCommentInAA: hideCommentInAA,
                        HideCommentInSSA: hideCommentInSSA,
                        HideCommentInFA: hideCommentInFA,
                        HideCommentInSA: hideCommentInSA,
                        HideTeacherCommentInFA: hideTeacherCommentInFA,
                        HideTeacherCommentInSA: hideTeacherCommentInSA
                    };
                    return values;
                };

                if (attendancePeriodControlsContainsID(row.id))
                {
                    var attendanceTypeId = formValues.attendanceTypeId;
                    var attendanceReasonId = formValues.attendanceReasonId;
                    var comment = formValues.comment;

                    if (e && e.currentTarget)
                    {
                        // if manually changing the type, reason or comment in the quick entry, only update the corresponding column
                        if (formControls.commentTb && e.currentTarget == formControls.commentTb[0])
                        {
                            var values = getRowValues(row.id);
                            attendanceTypeId = values.AttendanceTypeID || attendanceTypeId;
                            attendanceReasonId = values.AttendanceReasonID || attendanceReasonId;
                        }
                        else if (formControls.attendanceReasonEel && e.currentTarget == formControls.attendanceReasonEel[0])
                        {
                            var values = getRowValues(row.id);
                            attendanceTypeId = values.AttendanceTypeID || attendanceTypeId;
                            comment = values.Comment || comment;
                        }
                        else if (formControls.attendanceTypeEel && e.currentTarget == formControls.attendanceTypeEel[0])
                        {
                            var values = getRowValues(row.id);
                            attendanceReasonId = values.AttendanceReasonID || attendanceReasonId;
                            comment = values.Comment || comment;
                        }
                        else if (formControls.commentAttendanceCommentPrivacySettingContainer && e.currentTarget == formControls.commentAttendanceCommentPrivacySettingContainer[0])
                        {
                            var values = getRowValues(row.id);
                            attendanceTypeId = values.AttendanceTypeID || attendanceTypeId;
                            attendanceReasonId = values.AttendanceReasonID || attendanceReasonId;
                            if (e.commentUpdatedToEmpty !== true)
                            {
                                comment = values.Comment || comment;
                            }
                            var hideData;

                            if (formControls.periodCommentHideInFA.length > 0)
                            {
                                hideData = {
                                    hideInFA: formValues.periodCommentHideInFA,
                                    hideInSA: formValues.periodCommentHideInSA,
                                    hideInTA: formValues.periodCommentHideInTA,
                                    hideInAA: formValues.periodCommentHideInAA,
                                    hideInSSA: formValues.periodCommentHideInSSA,
                                };
                            }
                            else
                            {
                                hideData = {
                                    hideInFA: formValues.dayCommentHideInFA,
                                    hideInSA: formValues.dayCommentHideInSA,
                                    hideInTA: formValues.dayCommentHideInTA,
                                    hideInAA: formValues.dayCommentHideInAA,
                                    hideInSSA: formValues.dayCommentHideInSSA,
                                };
                            }
                            row.controls.OfficeCommentButtonsContainer.trigger("updateButtonStatus", hideData);
                        }
                    }

                    if (isInRange)
                    {
                        setAttendancePeriodControls(row, attendanceTypeId, attendanceReasonId, comment);
                    }
                    else
                    {
                        var onlySelectedPeriods = formValues.allDay === true;
                        if (onlySelectedPeriods)
                        {
                            clearAttendancePeriodValues(row);
                        }
                        else
                        {
                            restoreAttendancePeriodOriginalValues(row);
                        }
                    }
                }

                if (row.id == formValues.endPeriodId)
                {
                    isInRange = false;
                }
            });

            performValidatePeriodsAjax();
        };

        var clearAttendancePeriodValues = function (row)
        {
            setAttendancePeriodControls(
                row,
                null,
                null,
                null);
            hideAttendancePeriodControls(row);
        };

        var restoreAttendancePeriodOriginalValues = function (row)
        {
            var rowAttendanceTypeOriginalValue = skyward.controls.getOriginalValue(row.controls.attendanceTypeEel);
            setAttendancePeriodControls(
                row,
                rowAttendanceTypeOriginalValue,
                skyward.controls.getOriginalValue(row.controls.attendanceReasonEel),
                skyward.controls.getOriginalValue(row.controls.commentTb));

            if (!rowAttendanceTypeOriginalValue)
            {
                hideAttendancePeriodControls(row);
            }
            else
            {
                showAttendancePeriodControls(row, true);
            }
        };

        /**
         * @param {AttendanceRow} row - Attendance Period/Type/Reason/Comment
         * @param {number} attendanceTypeId - Attendance Type code eel value
         * @param {number} attendanceReasonId - Attendance Reason code eel value
         * @param {string} comment - Attendance Comment
         */
        var setAttendancePeriodControls = function (row, attendanceTypeId, attendanceReasonId, comment)
        {
            var typeViewPart = row.controls.attendanceTypeEel.find('input.attendancePeriodTypeElement');
            var reasonViewPart = row.controls.attendanceReasonEel.find('input.attendancePeriodReasonElement');
            var commentViewPart = row.controls.commentTb;

            var typeIsEnabled = getPartIsEnabled(typeViewPart, attendanceTypeId);
            var reasonIsEnabled = getPartIsEnabled(reasonViewPart, attendanceReasonId);
            var commentIsEnabled = getPartIsEnabled(commentViewPart, comment);

            if (typeIsEnabled === true && reasonIsEnabled === true && commentIsEnabled === true)
            {
                validatePeriodAttendancePeriodIDs[row.id] =
                {
                    Row: row,
                    AttendanceTypeID: attendanceTypeId,
                    AttendanceReasonID: attendanceReasonId,
                    Comment: comment
                };
            }
        };

        var getPartIsEnabled = function (part)
        {
            return part && part.is(':disabled,[readonly],.ui-disabled') === false;
        };

        var showAttendancePeriodControls = function (row, checkRowForHideValue)
        {
            var formValues = getCurrentFormValues();
            row.controls.commentTb.show();
            row.controls.attendanceReasonEel.show();
            row.controls.OfficeCommentButtonsContainer.show();
            var hideData = {};

            if (checkRowForHideValue)
            {
                var rowValues = getAttendancePeriodsValuesForRow(row);

                hideData = {
                    hideInFA: rowValues.HideCommentInFA,
                    hideInSA: rowValues.HideCommentInSA,
                    hideInTA: rowValues.HideCommentInTA,
                    hideInAA: rowValues.HideCommentInAA,
                    hideInSSA: rowValues.HideCommentInSSA,
                };
            }
            else
            {
                hideData = {
                    hideInFA: formValues.periodCommentHideInFA,
                    hideInSA: formValues.periodCommentHideInSA,
                    hideInTA: formValues.periodCommentHideInTA,
                    hideInAA: formValues.periodCommentHideInAA,
                    hideInSSA: formValues.periodCommentHideInSSA,
                };
            }

            row.controls.OfficeCommentButtonsContainer.trigger("updateButtonStatus", hideData);
        };

        var hideAttendancePeriodControls = function (row)
        {
            row.controls.commentTb.hide();
            row.controls.attendanceReasonEel.hide();
            row.controls.OfficeCommentButtonsContainer.hide();
        };

        var updateStudentAttendancePanels = function (errorData)
        {
            var data = {};
            data.StartDate = formControls.startDateTb.val();
            data.EndDate = formControls.endDateTb.val();

            // Only fire this ajax if dates have changed since these panels were rendered
            if (data.StartDate !== formControls.getGeneratedAttendancePeriodsStartDate().val() || data.EndDate !== formControls.getGeneratedAttendancePeriodsEndDate().val())
            {
                // disable controls while ajax is in flight
                hidePeriodEELs();
                skyward.window.loadContent('attendanceEntryTool_CurrentStudentBrowseArea', 'Attendance', controllerObject, 'GenerateCurrentStudentAttendanceBrowse', studentId, data);
                skyward.window.loadContent('attendanceEntryTool_GeneratedAttendancePeriods', 'Attendance', controllerObject, 'GeneratedAttendancePeriods', studentId, data).done(function ()
                {
                    // assign new entry table reference
                    formControls.attendanceEntryTable = $('.attendanceEntryTable');
                    formControls.attendanceEntryTable.off('change').on('change', attendanceEntryTableChange);

                    // re-enable controls
                    showPeriodEELs();
                    periodEELControlsRenderManager();
                    displayErrorMessages(errorData);
                });
            }
        };

        var changeEndDate = function (e)
        {
            var startDate = skyward.controls.getValue(formControls.startDateTb)
            var endDate = skyward.controls.getValue(formControls.endDateTb);

            if (e.target.id === formControls.startDateTb.attr('id') && startDate !== endDate)
            {
                // truthy start date means no empty string or NaN, set endDate
                if (startDate)
                {
                    skyward.controls.setValue(formControls.endDateTb, startDate);
                }
                else
                {
                    skyward.controls.clearValue(formControls.endDateTb);
                }
            }
        };

        var validateDates = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/ValidateDates',
                type: "POST",
                dataType: "JSON",
                data:
                {
                    StudentID: studentId,
                    StartDate: formControls.startDateTb.val(),
                    EndDate: formControls.endDateTb.val(),
                    CurrentYearId: currentSchoolYearId
                },
                success: function (data)
                {
                    studentNotEnrolledInDates = !data.success;
                    updateStudentAttendancePanels(data);
                    updateFromAjax(data);
                }
            });
        };

        var updateFromAjax = function (data)
        {
            if (data.Update)
            {
                for (var field in data.Update)
                {
                    var currentValue = skyward.controls.getValue("#" + field);
                    var newValue = data.Update[field];

                    if (currentValue != newValue)
                    {
                        skyward.controls.setValue("#" + field, newValue);
                    }
                }
            }
        }

        var displayErrorMessages = function (data)
        {
            skyward.validation.displayValidationMessages(data, attendanceEntryContainerDiv, attendanceEntryErrorsDiv);
        };

        var periodEELControlsRenderManager = function ()
        {
            // hold onto the date values last used to generated attendance periods
            formControls.getGeneratedAttendancePeriodsStartDate().val(formControls.startDateTb.val());
            formControls.getGeneratedAttendancePeriodsEndDate().val(formControls.endDateTb.val());

            if (studentNotEnrolledInDates)
            {
                hidePeriodEELs();
                showEnrollmentError();
                return true;
            }
            else
            {
                showPeriodEELs();
                hideErrors();
                return false;
            }
        };

        var hidePeriodEELs = function ()
        {
            skyward.controls.disable(formControls.startPeriodEel.children());
            formControls.startPeriodEel.children('.button').addClass('hidden');
            skyward.controls.disable(formControls.endPeriodEel.children());
            formControls.endPeriodEel.children('.button').addClass('hidden');
            skyward.controls.disable(formControls.allDayCkb);

            if (formControls.attendanceEntryTable)
            {
                formControls.attendanceEntryTable.hide();
            }
        };

        var showPeriodEELs = function ()
        {
            var allDay = skyward.controls.getValue(formControls.allDayCkb);

            if (!allDay)
            {
                skyward.controls.enable(formControls.startPeriodEel.children());
                formControls.startPeriodEel.children('.button').removeClass('hidden');
                skyward.controls.enable(formControls.endPeriodEel.children());
                formControls.endPeriodEel.children('.button').removeClass('hidden');
            }

            skyward.controls.enable(formControls.allDayCkb);

            formControls.attendanceEntryTable.show();
        };

        // Custom tab order for Attendance Entry by Student screen
        var tabOverride = function (e)
        {
            if (e.keyCode != 9)
            {
                return;
            }

            e.preventDefault();
            var formValues = getCurrentFormValues();

            switch (e.target.id)
            {
                case nameSelectorTb.attr('id'):
                case formControls.processRequestWithExistingAttendance.attr('id'):
                    if (e.shiftKey)
                    {
                        formControls.isGuardianNotifiedCkb.focus();
                    }
                    else
                    {
                        formControls.allDayCkb.focus();
                    }
                    break;
                case formControls.cancelBtn.attr('id'):
                    if (e.shiftKey)
                    {
                        (formControls.saveAndBackBtn.length > 0) ? formControls.saveAndBackBtn.focus() : formControls.saveBtn.focus();
                    }
                    else
                    {
                        formControls.allDayCkb.focus();
                    }
                    break;
                case formControls.startDateTb.attr('id'):
                    if (e.shiftKey)
                    {
                        if (formControls.cancelBtn.hasClass('dirty'))
                        {
                            formControls.cancelBtn.focus();
                        }
                        else if (formControls.processRequestWithExistingAttendance.is(':visible'))
                        {
                            formControls.processRequestWithExistingAttendance.focus();
                        }
                        else
                        {
                            nameSelectorTb.focus();
                        }
                    }
                    else
                    {
                        formControls.endDateTb.focus();
                    }
                    break;
                case formControls.startPeriodEelCodeTb.attr('id'):
                    if (e.shiftKey)
                    {
                        formControls.allDayCkb.focus();
                    }
                    else
                    {
                        if (formValues.startPeriodId == '' && formValues.endPeriodId == '')
                        {
                            editableAttendancePeriodControls[0].controls.attendanceTypeEelCodeTb.focus();
                        }
                        else
                        {
                            formControls.endPeriodEelCodeTb.focus();
                        }
                    }
                    break;
                case formControls.isGuardianNotifiedCkb.attr('id'):
                    if (e.shiftKey)
                    {
                        formControls.commentTb.focus();
                    }
                    else if (formControls.cancelBtn.hasClass('dirty'))
                    {
                        (formControls.saveAndBackBtn.length > 0) ? formControls.saveAndBackBtn.focus() : formControls.saveBtn.focus();
                    }
                    else if (formControls.processRequestWithExistingAttendance.is(':visible'))
                    {
                        formControls.processRequestWithExistingAttendance.focus();
                    }
                    else
                    {
                        formControls.allDayCkb.focus();
                    }
                    break;
                case editableAttendancePeriodControls[0].controls.attendanceTypeEelCodeTb.attr('id'):
                    if (e.shiftKey)
                    {
                        formControls.startPeriodEelCodeTb.focus();
                    }
                    else
                    {
                        skyward.tabbing.focusAfter(editableAttendancePeriodControls[0].controls.attendanceTypeEelCodeTb);
                    }
                    break;
                case editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.attendanceTypeEelCodeTb.attr('id'):
                    if (e.shiftKey)
                    {
                        skyward.tabbing.focusBefore(editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.attendanceTypeEelCodeTb);
                    }
                    else if (editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.commentTb.is(':visible'))
                    {
                        skyward.tabbing.focusAfter(editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.attendanceTypeEelCodeTb);
                    }
                    else
                    {
                        if (formControls.cancelBtn.hasClass('dirty'))
                        {
                            (formControls.saveAndBackBtn.length > 0) ? formControls.saveAndBackBtn.focus() : formControls.saveBtn.focus();
                        }
                        else if (formControls.processRequestWithExistingAttendance.is(':visible'))
                        {
                            formControls.processRequestWithExistingAttendance.focus();
                        }
                        else
                        {
                            formControls.allDayCkb.focus();
                        }
                    }
                    break;
                case editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.commentTb.attr('id'):
                    if (e.shiftKey)
                    {
                        skyward.tabbing.focusBefore(editableAttendancePeriodControls[editableAttendancePeriodControls.length - 1].controls.commentTb);
                    }
                    else
                    {
                        if (formControls.cancelBtn.hasClass('dirty'))
                        {
                            (formControls.saveAndBackBtn.length > 0) ? formControls.saveAndBackBtn.focus() : formControls.saveBtn.focus();
                        }
                        else if (formControls.processRequestWithExistingAttendance.is(':visible'))
                        {
                            formControls.processRequestWithExistingAttendance.focus();
                        }
                        else
                        {
                            formControls.allDayCkb.focus();
                        }
                    }
                    break;
            }
        };

        var toggleCurrentRow = function ()
        {
            var clickedRow = $(this);
            if (clickedRow.get(0) != currentStudentAttendanceSelectedRow.get(0))
            {
                clickedRow.addClass('current');
                currentStudentAttendanceSelectedRow.removeClass('current');
                currentStudentAttendanceSelectedRow = clickedRow;
            }
        };

        var showNoChangeError = function ()
        {
            formControls.attendanceEntryErrors.text('No changes were made to the Attendance Record').show();
        };

        var showEnrollmentError = function ()
        {
            formControls.attendanceEntryErrors.text('Student is not enrolled for all of the specified dates').show();
        };

        var showNoEditablePeriodsError = function ()
        {
            formControls.attendanceEntryErrors.text('No editable periods available').show();
        };

        var hideErrors = function ()
        {
            formControls.attendanceEntryErrors.text('').hide();
        };

        var attendanceEntryToolAddEntry = function (buttonName, button, parentMethod)
        {
            formControls.saveBtn.removeClass('dirty');
            formControls.cancelBtn.removeClass('dirty');

            if (formControls.saveAndBackBtn.is(':visible'))
            {
                formControls.saveAndBackBtn.removeClass('dirty');
            }

            button.off('click');
            $.when(skyward.attendanceEntryTools.addEntry(buttonName)).done(function ()
            {
                button.on('click', parentMethod);
            });
        };

        var attendanceEntryToolAddEntrySave = function ()
        {
            attendanceEntryToolAddEntry('save', formControls.saveBtn, attendanceEntryToolAddEntrySave);
        };

        var attendanceEntryToolAddEntrySaveAndBack = function ()
        {
            attendanceEntryToolAddEntry('saveandback', formControls.saveAndBackBtn, attendanceEntryToolAddEntrySaveAndBack);
        };

        var attendanceEntryToolAddEntryProcessRequestWithExistingAttendance = function ()
        {
            attendanceEntryToolAddEntry('processrequestwithexistingattendance', formControls.processRequestWithExistingAttendance, attendanceEntryToolAddEntryProcessRequestWithExistingAttendance);
        };

        var toggleVisibilityProcessRequestWithExistingAttendance = function (event)
        {
            if (formControls.processRequestWithExistingAttendance)
            {
                if (skyward.changeTracking.isDirty() == true || nonPeriodFormControlsThatAffectButtonsAreDirty(formControls, isSpanningMultipleDays(formControls)))
                {
                    formControls.processRequestWithExistingAttendance.addClass('displayNone');
                }
                else
                {
                    formControls.processRequestWithExistingAttendance.removeClass('displayNone');
                }
            }
        };

        var isSpanningMultipleDays = function (formControls)
        {
           return formControls.startDateTb.val() != formControls.endDateTb.val();
        };

        var nonPeriodFormControlsThatAffectButtonsAreDirty = function (formControls, multipleDays)
        {
           return skyward.changeTracking.isDirty(formControls.isGuardianNotifiedCkb.parent()) ||
                skyward.changeTracking.isDirty(formControls.useDayStatusOverrideCb.parent()) ||
                skyward.changeTracking.isDirty(formControls.dayStatusOverrideEel.parent()) ||
                skyward.changeTracking.isDirty(formControls.dayComment.parent()) ||
                skyward.changeTracking.isDirty(formControls.replyToGuardianTb.parent()) ||
                skyward.changeTracking.isDirty(formControls.useMetMinutesRequiredOverrideCb.parent()) ||
                skyward.changeTracking.isDirty(formControls.metMinutesRequiredOverrideCb.parent()) ||
                (multipleDays && skyward.changeTracking.isDirty(formControls.endDateTb.parent()));
        };

        var performAddEntryAjax = function (button)
        {
            var formValues = getCurrentFormValues();

            var multipleDays = isSpanningMultipleDays(formControls);

            // isDirty does a .find on the parameter, so we pass the Guardian Notified checkbox's parent to detect dirtiness
            dirtyPeriods = nonPeriodFormControlsThatAffectButtonsAreDirty(formControls, multipleDays);

            var periods = JSON.stringify(getCurrentAttendancePeriodValues());
            if (!periods)
            {
                dirtySaveControls();
                showNoEditablePeriodsError();
                return false;
            }

            var contentArea = $('.js-attendanceEntryByStudentAddEntry');
            var cmaObject = skyward.contentMessageArea.getContentMessageArea(contentArea);
            cmaObject.resetInformation();

            var attachmentSessionUploadIDs = [];

            var uploadFileInput = formControls.attachments.find("#UploadFile").first();

            if (uploadFileInput.length > 0 && uploadFileInput.val())
            {
                var fileData = JSON.parse(uploadFileInput.val());
                fileData.forEach(function (file)
                {
                    attachmentSessionUploadIDs.push(file.sessionFileUploadID);
                });
            }

            if (dirtyPeriods || attachmentSessionUploadIDs.length > 0 || button === 'processrequestwithexistingattendance')
            {
                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/AddEntry',
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            StudentID: studentId,
                            StartDate: formValues.startDate,
                            EndDate: formValues.endDate,
                            Comment: skyward.extensions.encodeHtml(formValues.comment),
                            DayComment: skyward.extensions.encodeHtml(formValues.dayComment),
                            DayCommentHideInFA: formValues.dayCommentHideInFA,
                            DayCommentHideInSA: formValues.dayCommentHideInSA,
                            DayCommentHideInTA: formValues.dayCommentHideInTA,
                            DayCommentHideInAA: formValues.dayCommentHideInAA,
                            DayCommentHideInSSA: formValues.dayCommentHideInSSA,
                            IsGuardianNotified: formValues.isGuardianNotified,
                            UseAttendanceTypeDayStatusOverride: formValues.useAttendanceTypeDayStatusOverride,
                            UseMetMinutesRequiredOverride: formValues.useMetMinutesRequiredOverride,
                            MetMinutesRequiredOverride: formValues.metMinutesRequiredOverride,
                            UseAttendanceTypeDayStatusOverride: formValues.useAttendanceTypeDayStatusOverride,
                            AttendanceTypeIDDayStatusOverride: formValues.attendanceTypeIDDayStatusOverride,
                            StudentAttendancePeriods: skyward.extensions.encodeHtml(periods),
                            StartPeriod: formValues.startPeriodId,
                            EndPeriod: formValues.endPeriodId,
                            AllDay: formValues.allDay,
                            CurrentYearId: currentSchoolYearId,
                            AttendanceReasonID: formValues.attendanceReasonId,
                            AttendanceTypeID: formValues.attendanceTypeId,
                            AttachmentSessionFileUploadIDs: JSON.stringify(attachmentSessionUploadIDs),
                            StudentAbsenceRequestID: studentAbsenceRequestId,
                            ReplyToGuardian: skyward.extensions.encodeHtml(formValues.replyToGuardian),
                            warninghash: formValues.warninghash
                        },
                        success: function (data)
                        {
                            if (data.success)
                            {
                                skyward.attendanceEntryTools.clearFields(data.deletedStudentAttendance);

                                if (button === 'saveandback')
                                {
                                    skyward.window.setSkipUnloadCheck(true);

                                    if (studentAbsenceRequestId)
                                    {
                                        skyward.window.loadContent('full', 'Attendance', 'StudentAbsenceRequest', 'GuardianEnteredRequests');
                                    }
                                    else
                                    {
                                        skyward.window.returnToPrevious('saveandback');
                                    }
                                }
                                else
                                {
                                    nameSelectorTb.focus();

                                    //show message for record saved
                                    cmaObject.setConfirmationMessage(skyward.contentMessageArea.getDefaultConfirmationMessage());

                                    if (data.showSomePeriodsWereNotUpdatedMessage === true)
                                    {
                                        cmaObject.setInformationMessage("Attendance records were only created for periods that did not previously have records");
                                        cmaObject.showInformation();
                                    }
                                    else if (data.showSomePeriodsWereNotCreatedMessage === true)
                                    {
                                        cmaObject.setInformationMessage("Attendance records were only updated for periods that previously had records");
                                        cmaObject.showInformation();
                                    }

                                    cmaObject.showConfirmation();

                                    if (studentAbsenceRequestId)
                                    {
                                        skyward.window.loadContent('full', 'Attendance', 'StudentAbsenceRequest', 'StudentAbsenceRequest_Next', studentAbsenceRequestId);
                                    }
                                }
                            }
                            else
                            {
                                dirtySaveControls();

                                if (!$.isEmptyObject(data.errors) || !$.isEmptyObject(data.warnings))
                                {
                                    displayErrorMessages(data);

                                    if (data.errors['Base'] || data.warnings['Base'])
                                    {
                                        formControls.attendanceEntryErrors.show();
                                    }
                                }
                            }
                        }
                    });
            }
            else
            {
                dirtySaveControls();
                showNoChangeError();
                return false;
            }
        };

        var performValidatePeriodsAjax = function ()
        {
            return $.ajax({
                url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/ValidatePeriods',
                type: 'POST',
                data: {
                    AttendancePeriodIDs: JSON.stringify(Object.keys(validatePeriodAttendancePeriodIDs)),
                    StartDate: formControls.startDateTb.encodedVal(),
                    EndDate: formControls.endDateTb.encodedVal(),
                    StudentID: studentId
                },
                success: function (data)
                {
                    // AttendancePeriod response is Object where Key is AttendancePeriodID and value is ReadOnly
                    if (data.AttendancePeriods)
                    {
                        $.each(data.AttendancePeriods, function (attendancePeriodID, readOnly)
                        {
                            /** @type {PeriodRowData} */
                            var rowData = validatePeriodAttendancePeriodIDs[attendancePeriodID];

                            if (rowData != null)
                            {
                                if (!readOnly)
                                {
                                    // For these code eels, if the value isn't changing we don't call setValue to avoid the redundant "codeeel" ajax that would otherwise send
                                    var attendanceTypeChanged = (rowData.AttendanceTypeID || "") != skyward.controls.getValue(rowData.Row.controls.attendanceTypeEel);
                                    if (attendanceTypeChanged) skyward.controls.setValue(rowData.Row.controls.attendanceTypeEel, rowData.AttendanceTypeID);
                                    var attendanceReasonChanged = (rowData.AttendanceReasonID || "") != skyward.controls.getValue(rowData.Row.controls.attendanceReasonEel);
                                    if (attendanceReasonChanged) skyward.controls.setValue(rowData.Row.controls.attendanceReasonEel, rowData.AttendanceReasonID);

                                    // For this textbox, suppressing the change event doesn't matter as much, fire away
                                    skyward.controls.setValue(rowData.Row.controls.commentTb, rowData.Comment);

                                    if (!rowData.AttendanceTypeID)
                                    {
                                        hideAttendancePeriodControls(rowData.Row);
                                    }
                                    else
                                    {
                                        showAttendancePeriodControls(rowData.Row, true);
                                    }
                                }
                                else
                                {
                                    hideAttendancePeriodControls(rowData.Row);
                                }
                            }
                        });

                        attendanceTypeUpdate();
                    }
                }
            });
        };

        /**
         * Calls setAttendancePeriodControls whenever anything in the right panel is updated (manually by the user or otherwise)
         * @param {Event} e - event of change
         */
        var attendanceEntryTableChange = function (e)
        {
            if (e && e.target)
            {
                var attendancePeriodRow = $(e.target).parents('.attendancePeriodRow').eq(0);
                var rowData = getAttendancePeriodRowData(attendancePeriodRow);
                var valuesData = getAttendancePeriodsValuesForRow(rowData);

                setAttendancePeriodControls(rowData, valuesData.AttendanceTypeID, valuesData.AttendanceReasonID, valuesData.Comment);
            }
        };

        var attendanceTypeUpdate = function (button)
        {
            var formValues = getCurrentFormValues();
            var periods = JSON.stringify(getCurrentAttendancePeriodValues());

            return $.ajax(
                {
                    url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/UpdateAttendanceType',
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        StudentAttendancePeriods: skyward.extensions.encodeHtml(periods),
                        StudentID: studentId,
                        StartDate: formValues.startDate,
                        EndDate: formValues.endDate,
                        Comment: skyward.extensions.encodeHtml(formValues.comment),
                        DayComment: skyward.extensions.encodeHtml(formValues.dayComment),
                        IsGuardianNotified: formValues.isGuardianNotified,
                        StartPeriod: formValues.startPeriodId,
                        EndPeriod: formValues.endPeriodId,
                        AllDay: formValues.allDay,
                        CurrentYearId: currentSchoolYearId,
                        AttendanceReasonID: formValues.attendanceReasonId,
                        AttendanceTypeID: formValues.attendanceTypeId,
                        StudentAbsenceRequestID: studentAbsenceRequestId,
                        ReplyToGuardian: skyward.extensions.encodeHtml(formValues.replyToGuardian),
                        warninghash: formValues.warninghash
                    },
                    success: function (data)
                    {
                        updateFromAjax(data);
                    }
                });
        };

        var attendanceTypeUpdate = function (button)
        {
            var formValues = getCurrentFormValues();
            var periods = JSON.stringify(getCurrentAttendancePeriodValues());

            return $.ajax(
                {
                    url: skyward.global.virtualDir + 'Attendance/' + controllerObject + '/UpdateAttendanceType',
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        StudentAttendancePeriods: skyward.extensions.encodeHtml(periods),
                        StudentID: studentId,
                        StartDate: formValues.startDate,
                        EndDate: formValues.endDate,
                        Comment: skyward.extensions.encodeHtml(formValues.comment),
                        DayComment: skyward.extensions.encodeHtml(formValues.dayComment),
                        IsGuardianNotified: formValues.isGuardianNotified,
                        StartPeriod: formValues.startPeriodId,
                        EndPeriod: formValues.endPeriodId,
                        AllDay: formValues.allDay,
                        CurrentYearId: currentSchoolYearId,
                        AttendanceReasonID: formValues.attendanceReasonId,
                        AttendanceTypeID: formValues.attendanceTypeId,
                        StudentAbsenceRequestID: studentAbsenceRequestId,
                        ReplyToGuardian: skyward.extensions.encodeHtml(formValues.replyToGuardian),
                        warninghash: formValues.warninghash
                    },
                    success: function (data)
                    {
                        updateFromAjax(data);
                    }
                });
        };

        skyward.attendanceEntryTools.addEntry = function (button)
        {
            performValidatePeriodsAjax()
                .done(function ()
                {
                    performAddEntryAjax(button);
                })
                .then(function () { validatePeriodAttendancePeriodIDs = {}; });
        };

        skyward.attendanceEntryTools.clearFields = function (deletingAttendance)
        {
            displayErrorMessages(null);

            $.each(formControls, function (index, control)
            {
                // instanceof Function handles the GeneratedAttendancePeriodStart/EndDate getters
                control = control instanceof Function ? control() : control;
                var originalValue = control.data('original-value');

                if (control.hasClass('codeEEL'))
                {
                    var codeEELValue = control.children('.codeEELValue');
                    skyward.controls.setDataAttribute(codeEELValue, 'original-value', deletingAttendance ? '' : codeEELValue.val());// codeEELValue.data('original-value'));
                    skyward.controls.setDataAttribute(codeEELValue, 'dirty', false);
                    if (codeEELValue.data != null && originalValue != (deletingAttendance ? '' : codeEELValue.val()))
                    {
                        codeEELValue.data("originalSelectedValueHash", null); //because we are changing the original value the hash is no longer good.
                    }
                }
                else if (control.is(':checkbox') && control.attr('name') !== 'AllDay')
                {
                    skyward.controls.setDataAttribute(control, 'original-value', deletingAttendance ? false : control.prop('checked'));
                    skyward.controls.setValue(control, deletingAttendance ? false : control.data('original-value'));
                }

                if (!control.hasClass('datePicker'))
                {
                    if (control.hasClass("commentPrivacyTextArea"))
                    {
                        skyward.controls.setDataAttribute(control, 'original-value', deletingAttendance ? '' : control.val());
                        control.trigger("clearButtonStatus");
                    }

                    skyward.controls.setValue(control, originalValue, true);
                }

                // make sure this works with day status
                skyward.controls.setDataAttribute(control, 'dirty', 'false');

                // reset dirty status (re-hides Save/Cancel buttons)
                if (control.hasClass('dirty'))
                {
                    control.removeClass('dirty');
                    skyward.controls.setDataAttribute(control, 'dirty', 'false');
                }
            });

            skyward.controls.enable(formControls.startPeriodEel.find("a.codeEELButton"));
            skyward.controls.enable(formControls.endPeriodEel.find("a.codeEELButton"));

            if (!studentNotEnrolledInDates)
            {
                skyward.controls.setValue(attendancePeriodLowFilterHdn, skyward.controls.getValue(attendancePeriodMinFilterHdn), true);
                skyward.controls.setValue(attendancePeriodHighFilterHdn, skyward.controls.getValue(attendancePeriodMaxFilterHdn), true);
            }

            validatePeriodAttendancePeriodIDs = {};
            updateStudentAttendancePanels(null);
            formControls.attachments.trigger('clearUploads');
            skyward.changeTracking.clearDirtyList();
            attendanceEntryErrorsDiv.html('');
            skyward.controls.setDataAttribute(attendanceEntryContainerDiv, 'warninghash', '');
            formControls.allDayCkb.focus();
            skyward.dataobjectviewer.getFieldValues.disableButtons('attendanceEntryTool');

            if (loadedWithAttendance)
            {
                dirtySaveControls();
            }
        };

        skyward.attendanceEntryTools.attendanceEntryCancel = function (button)
        {
            var toolbar = $(button.closest(".toolbar"));
            var dovContainer = $("#" + toolbar.data().dovId);
            var data = dovContainer.data();
            var tab = data.tabtoroute !== null ? data.tabtoroute : data.tab;

            var area = data.module;
            var controller = data.object;
            var action = data.screen;
            var id = data.primaryid;
            var popupId = data.popupId;
            var cancelButton = $(button);

            if (cancelButton.hasClass("dirty"))
            {
                var target = "moduleContent";
                var data =
                {
                    tab: tab,
                    skipFiscalYearScopeCheck: "true",
                    isSaveBackButtonVisible: $(entryToolSelector + "IsSaveBackButtonVisible").val()
                };

                skyward.window.loadContent(target, area, controller, action, id, data, popupId);
            }
        }

        skyward.attendanceEntryTools.copyFromGuardianComment = function ()
        {
            if (formControls.guardianComment && formControls.commentTb)
            {
                var guardianComment = skyward.controls.getValue(formControls.guardianComment);
                skyward.controls.setValue(formControls.commentTb, guardianComment, true);
                formControls.commentTb.trigger("keyup");
                var event = {};
                event.currentTarget = formControls.commentTb[0];
                setAttendancePeriodEels(event);
            }
        };

        skyward.attendanceEntryTools.copyFromGuardianCommentDayComment = function ()
        {
            if (formControls.guardianComment && formControls.dayComment)
            {
                var dayComment = skyward.controls.getValue(formControls.guardianComment);
                skyward.controls.setValue(formControls.dayComment, dayComment);
            }
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
)
;
(
    function (skyward, $)
    {
        "use strict";

        skyward.taskstatus = skyward.taskstatus || {};

        var requestUrl;
        var pingCount;
        var requestHandle;
        var messageBox;
        var waitingBox;
        var popupHandle;
        var workflowAborted;

        // If you created a status layer prior to initiating asynch status report, you MUST populate layer.statusDataContent before passing layer into this function.
        skyward.taskstatus.beginAsyncStatusReport = function (workflowInstanceID, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
        {
            requestUrl = skyward.global.virtualDir + "workflow/workflowinstance/nextview/" + workflowInstanceID;
            pingCount = 0;
            requestHandle = null;
            messageBox = null;
            waitingBox = null;
            popupHandle = null;
            workflowAborted = false;

            return requestStatus(null, onAllTasksCompleted, onNextTaskInprogress, onValidationError);
        };

        var requestStatus = function (deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
        {
            $(document.body).addClass("cursor-progress");

            if (popupHandle === null)
            {
                popupHandle = setTimeout(function ()
                {
                    popupHandle = 0;
                }, 1000);
            }

            if (requestHandle)
            {
                clearTimeout(requestHandle);
                requestHandle = null;
            }

            deferred = deferred || $.Deferred();

            $.ajax(requestUrl,
                {
                    type: "POST",
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        requestStatusSuccess(data, deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError);
                    },
                    statusCode:
                    {
                        404: function (data)
                        {
                            requestStatus404(data, deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
                        },
                        500: function ()
                        {
                            abortWorkflow();
                            deferred.reject();
                        }
                    }
                });

            return deferred.promise();
        };

        var requestStatusSuccess = function (data, deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
        {
            $(document.body).removeClass("cursor-progress");

            if (waitingBox)
            {
                waitingBox.close();
            }

            // if the popup isn't open already, prevent it from opening
            if (popupHandle)
            {
                clearTimeout(popupHandle);
            }

            if (messageBox)
            {
                messageBox.close();
            }

            switch (data.workflowStatus)
            {
                case "C":
                    //Completed
                    if (typeof onAllTasksCompleted === "function")
                    {
                        const hasBenchmarkSurvey = data.benchmarkingData !== null &&
                            data.benchmarkingData.redirectToSameWorkflow === false;
                        const postponeRedirect = hasBenchmarkSurvey;

                        const redirectFunction = onAllTasksCompleted(data, postponeRedirect);

                        if (hasBenchmarkSurvey)
                        {
                            processBenchmarkSurvey(data.benchmarkingData, redirectFunction || checkRefresh);
                        }
                        else
                        {
                            checkRefresh();
                        }

                        function checkRefresh()
                        {
                            if (data.refreshScreen || data.additionalValues.RefreshScreen)
                            {
                                var location = skyward.global.addRequiredQuerystringParams(skyward.global.virtualDir + data.referrerURL);
                                window.location.href = location;
                            }
                        }
                    }
                    deferred.resolve();
                    break;
                case "I":
                    //InProgress 
                    if (data.errors)
                    {
                        var workflow = $("#popup" + skyward.window.getCurrentPopupId()).find(".workflow");
                        workflow.find(".toolbar").find(".button.ui-disabled").addClass("dirty").removeClass("ui-disabled");
                        var baseErrorContainer = workflow.find("#baseWorkflowErrorContainer");
                        var container = workflow.find(".workflowContent");
                        skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                    }
                    else if (typeof onNextTaskInprogress === 'function')
                    {
                        $.when(onNextTaskInprogress(data)).always(function () { deferred.resolve(); });
                        return;
                    }
                    deferred.resolve();
                    break;
                case "E":
                    // Error
                    abortWorkflow();
                    if (typeof onValidationError === "function")
                    {
                        onValidationError(data);
                    }
                    deferred.resolve();
                    break;
                case "F":
                    // Invalid
                    abortWorkflow();
                    if (typeof onValidationError === "function")
                    {
                        onValidationError(data);
                    }
                    deferred.resolve();
                    break;
                default:
                    deferred.resolve();
                    break;
            }
        };

        var requestStatus404 = async function (jqXHR, deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError)
        {
            var timeout = 1000;
            pingCount++;
            if (!$.isEmptyObject(jqXHR) && jqXHR.responseText)
            {
                var statusData = JSON.parse(jqXHR.responseText);
                if (!$.isEmptyObject(statusData) && statusData.message)
                {
                    if (statusData.synchronousLockWaiting)
                    {
                        timeout = 5000;
                        if (!waitingBox)
                        {
                            showWaitMessage(deferred, statusData.taskInstanceID, statusData.message);
                        }
                        else
                        {
                            await waitingBox.content.viewpartHtml(statusData.message);
                            waitingBox.animateModalContents();
                        }
                    }
                    else
                    {
                        if (pingCount >= 54)
                        {
                            timeout = 5000;
                        }
                        else if (pingCount >= 30)
                        {
                            timeout = 2500;
                        }
                        if (waitingBox)
                        {
                            waitingBox.close();
                        }
                        if (!messageBox)
                        {
                            if (!popupHandle)
                            {
                                showStatusMessage(deferred, statusData);
                            }
                        }
                        else
                        {
                            await messageBox.content.viewpartHtml(statusData.message);
                            messageBox.animateModalContents();
                            skyward.controls.toggleVisible(messageBox.footer, statusData.allowAsyncCancel);
                        }
                    }
                }
            }
            requestHandle = setTimeout(function ()
            {
                if (!workflowAborted)
                {
                    requestStatus(deferred, onAllTasksCompleted, onNextTaskInprogress, onValidationError);
                }
            }, timeout);
        };

        var showStatusMessage = function (deferred, statusData)
        {
            if (waitingBox)
            {
                waitingBox.close();
            }

            let deferredBeforeShowContent = $.Deferred();
            let cancelButton = { id: "cancelButton", text: "Cancel", click: () => { voidWorkflowInstanceClick(deferred, statusData.taskInstanceID); }, icon: "Cancel", additionalClasses: "js-cancelProcess" };
            messageBox = skyward.modalLayer.showProcessingDialog(
                "Processing Request",
                statusData.message,
                [cancelButton], // If adding new buttons, be sure to update the footer hide logic, as currently it only expects there to be a cancel button
                {
                    allowNoButtons: true,
                    closeOnClick: false,
                    closeOnEscape: false,
                    forceClose: true,
                    afterClose: function ()
                    {
                        $(document.body).removeClass("cursor-progress");
                        messageBox = null;
                    },
                    beforeShowContentPromise: deferredBeforeShowContent.promise(),
                    width: "550px"
                });
            messageBox.bodyPromise.done(function ()
            {
                // Guards against messageBox already being closed before this async operation completes
                if (messageBox)
                {
                    skyward.controls.toggleVisible(messageBox.footer, statusData.allowAsyncCancel);
                }
                
                deferredBeforeShowContent.resolve();
            });
        };

        var showWaitMessage = function (deferred, taskInstanceID, contents)
        {
            if (messageBox)
            {
                messageBox.close();
            }

            let cancelButton = { id: "cancelButton", text: "Cancel", click: () => { voidWorkflowInstanceClick(deferred, taskInstanceID); }, icon: "Cancel" };
            waitingBox = skyward.modalLayer.showProcessingDialog(
                "Processing Request",
                contents,
                [cancelButton],
                {
                    closeOnClick: false,
                    closeOnEscape: false,
                    afterClose: function ()
                    {
                        $(document.body).removeClass("cursor-progress");
                        waitingBox = null;
                    },
                    width: "550px"
                });
        };

        var voidWorkflowInstanceClick = function (deferred, taskInstanceID)
        {
            $.ajax(skyward.global.virtualDir + "workflow/TaskInstance/cancel/" + taskInstanceID,
                {
                    type: "POST",
                    activityIndicator: { hideGlass: true },
                    success: function (data)
                    {
                        abortWorkflow();
                        deferred.reject();
                        $(document.body).trigger(data.cancelEventName);
                    }
                });
        };

        var abortWorkflow = function ()
        {
            workflowAborted = true;

            if (popupHandle)
            {
                clearTimeout(popupHandle);
            }

            if (requestHandle)
            {
                clearTimeout(requestHandle);
                requestHandle = null;
            }

            if (messageBox)
            {
                messageBox.close();
            }

            if (waitingBox)
            {
                waitingBox.close();
            }

            $("#pendingWorkflows :last-child").remove();
            skyward.workflow.closeWorkflowPopup();
            $(document.body).removeClass("cursor-progress");
        };

        function processBenchmarkSurvey(serverBenchmarkingData, afterSurveyCallback)
        {
            const localBenchmarkingData = {
                WorkflowDescription: serverBenchmarkingData.workflowDescription,
                MessageOverride: serverBenchmarkingData.endOfWorkflowMessage,
                CurrentUserID: serverBenchmarkingData.currentUserID,
                BenchmarkingSurveyID: serverBenchmarkingData.benchmarkingSurveyID,
                UserIDOwner_securityhash: serverBenchmarkingData.userIDOwner_securityhash,
                BenchmarkingSurveyID_securityhash: serverBenchmarkingData.benchmarkingSurveyID_securityhash,
            };

            skyward.benchmarking.showWorkflowSurvey(localBenchmarkingData, afterSurveyCallback);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(function (skyward, $, History, undefined)
{
    skyward.breadcrumb = skyward.breadcrumb || {};
    var crumbLayer;
    var breadcrumbs;
    var init = function (selector)
    {
        breadcrumbs = $(selector).find("#breadcrumbs");
        if (breadcrumbs.length)
        {
            $.ajax(skyward.global.virtualDir + "Security/Window/UpdateRelatedRecord",
            {
                type: "POST",
                dataType: "JSON",
                activityIndicator: { hideGlass: true },
                data: { breadcrumb: JSON.stringify(buildCrumb()) }
            });
            skyward.window.registerLayoutResizeCallback(function ()
            {
                truncate(breadcrumbs);
            });

            truncate(breadcrumbs);
        }
    };

    var buildCrumb = function ()
    {
        var crumb = {};
        crumb.id = "breadcrumb";
        crumb.items = [];
        var crumbItemObject = {};
        crumbItemObject.key = "DisplayName";
        var displayText = skyward.extensions.encodeHtml($("#friendlyNameContents").text());
        var displayName = displayText.indexOf(":") >= 0 ? displayText.split(" : ")[1] : displayText;
        crumbItemObject.value = displayName !== "" ? displayName : "Home";
        crumb.items.push(crumbItemObject);
        return crumb;
    };

    var truncate = function (breadcrumbs)
    {
        var historyIsShowing = (crumbLayer && !crumbLayer.closing) ? true : false;
        if (historyIsShowing)
        {
            hideHistoryCrumbs();
        }

        breadcrumbs.find(".overflowCrumb").removeClass("overflowCrumb");
        var maxCrumbWidth = skyward.window.clientWidth * .75;

        var breadcrumbsWidth = 0;
        breadcrumbs.find("li").each(function ()
        {
            breadcrumbsWidth += $(this).width();
        });

        var ellipsis = $("#ellipsis, #ellipsis + li.breadcrumbSeparator");
        var widthToHide = breadcrumbsWidth - maxCrumbWidth + ellipsis.width();

        if (widthToHide > 0)
        {

            var showEllipsis = false;
            breadcrumbs.find("li:not(.doNotTruncate)").each(function ()
            {
                var jQThis = $(this);
                var separator = jQThis.next('.breadcrumbSeparator');
                widthToHide -= jQThis.width();
                jQThis.addClass("overflowCrumb");
                separator.addClass("overflowCrumb");
                showEllipsis = true;
                return (widthToHide >= 0);
            });

            if (showEllipsis)
            {
                ellipsis.addClass("overflowCrumb");
            }
        }

        if (historyIsShowing)
        {
            skyward.breadcrumb.displayBreadcrumbHistory();
        }
    };

    skyward.breadcrumb.displayBreadcrumbHistory = function ()
    {
        var menuItems = [];
        menuItems.push(
        {
            type: 'title',
            text: 'History'
        });

        breadcrumbs.find(".crumb").each(function ()
        {
            var crumb = $(this);

            var menuItem =
            {
                type: 'item',
                text: crumb.text(),
                click: crumb.attr("onclick")
            };
            menuItems.push(menuItem);
        });
        crumbLayer = skyward.modalLayer.showMenu(menuItems, $("#ellipsis"), { afterClose: hideHistoryCrumbs });
    };

    var hideHistoryCrumbs = function ()
    {
        if (crumbLayer)
        {
            crumbLayer.close();
            crumbLayer = null;
        }
    };

    var navigateViaBreadcrumbs = function (postData, url)
    {
        $.ajax(skyward.global.virtualDir + "Security/Window/NavigateViaBreadcrumbs",
            {
                type: "POST",
                dataType: "JSON",
                async: false,
                data: postData,
                success: function (data)
                {
                    if (data.success && typeof(url) === "string")
                    {
                        window.location.href = url;
                    }
                }
            });
    }

    skyward.breadcrumb.breadcrumbClicked = function (index, url)
    {
        $(this).addClass("breadcrumbClicked");
        var data = { index: index };
        navigateViaBreadcrumbs(data, url);
    };

    /**
     * Sync breadcrumb trail with the screen we landed on after delete. 
     * @param {any} urlReferrer -the url of the breadcrumb we want to be in sync with
     */
    skyward.breadcrumb.removeStaledBreadcrumbs = function (urlReferrer)
    {
        var index;
        breadcrumbs.find(".crumb").each(function ()
        {
            var element = $(this);
            if (element.data("url") === urlReferrer)
            {
                index = element.data("index");
                return;
            }
        });

        var data = { index: index };
        // This is a work-around to remove staled crumbs from breadcrumb trail (until breadcrumbs are nicer to work with)
        navigateViaBreadcrumbs(data);
    }

    skyward.window.registerLoadDOMCallback(init);

}(window.skyward = window.skyward || {}, window.jQuery, window.History));;
(
    function (skyward, $)
    {
        skyward.reporting = skyward.reporting || {};
        skyward.reporting.aggregateCalculationBuilder = skyward.reporting.aggregateCalculationBuilder || {};

        var calculationInfoByColumnID = {};

        skyward.reporting.aggregateCalculationCollection = {
            populate: function (aggregateCalculationData)
            {
                calculationInfoByColumnID = {};
                for (var calculationData of aggregateCalculationData)
                {
                    skyward.reporting.aggregateCalculationCollection.add(calculationData.columnId, calculationData.calculation, calculationData.name, calculationData.sectionID, calculationData.lineID);
                };
            },
            add: function (columnID, expression, name, sectionID, lineID)
            {
                let columnIDsInCalculation = [];
                for (let bindingPartInfo of getBindingPartsInfo(expression))
                {
                    if (!bindingPartInfo.error)
                    {
                        columnIDsInCalculation.push(bindingPartInfo.columnID)
                    }
                }

                calculationInfoByColumnID[columnID] = {
                    name: name?.toString() ?? "null",
                    sectionID: sectionID,
                    lineID: lineID,
                    columnIDsInCalculation: columnIDsInCalculation
                };
            },
            remove: function (columnID)
            {
                delete calculationInfoByColumnID[columnID];
            },
            deleteColumnsUsingGivenColumnID: function (deletedColumnID, removeColumn)
            {
                for (var columnID in calculationInfoByColumnID)
                {
                    var columnIDsInCalculation = calculationInfoByColumnID[columnID].columnIDsInCalculation;

                    for (var innerColumnID of columnIDsInCalculation)
                    {
                        if (innerColumnID == deletedColumnID)
                        {
                            removeColumn(columnID);
                            skyward.reporting.aggregateCalculationCollection.deleteColumnsUsingGivenColumnID(columnID, removeColumn);
                            break;
                        }
                    }
                }
            }
        }

        var nameIdUniqueForSection = function (name, existingColumnID, sectionID, lineID)
        {
            var isUnique = true;
            for (let columnID in calculationInfoByColumnID)
            {
                let calculationInfo = calculationInfoByColumnID[columnID];

                if (calculationInfo.name.toLowerCase() === name.toLowerCase() && calculationInfo.sectionID === sectionID && calculationInfo.lineID === lineID &&
                    (!existingColumnID || columnID != existingColumnID))
                {
                    isUnique = false;
                }
            }

            return isUnique;
        }

        skyward.reporting.aggregateCalculationBuilder.validateAndGetValues = function (popup, existingAggregateCalculationColumnID, sectionID, lineID, availableColumns)
        {
            var errors = {};

            const nameInput = popup.find("#aggregateCalculationName");
            const nameValue = skyward.extensions.decodeHtml(skyward.controls.getValue(nameInput).trim().toString());
            const nameIsNullLiteral = (nameValue.toLowerCase() === "null");

            if (!nameValue)
            {
                errors["aggregateCalculationName"] = ["Name is a required field."]
            }

            if (nameIsNullLiteral)
            {
                errors["aggregateCalculationName"] = ["Name cannot be 'null'."]
            }

            if (!nameIdUniqueForSection(nameValue, existingAggregateCalculationColumnID, sectionID, lineID))
            {
                errors["aggregateCalculationName"] = ["Name must be unique in the current section's line."]
            }

            var expressionInput = expressionInput = popup.find("#aggregateCalculationExpression");
            var expressionValue = skyward.extensions.decodeHtml(skyward.controls.getValue(expressionInput).trim());

            if (!expressionValue)
            {
                errors["aggregateCalculationExpression"] = ["Expression is a required field."]
            }

            var reportFieldInput = popup.find("#aggregateCalculationReportField");

            var expressionWithBindingsAndDisplayExpression = convertExpressionIntoExpressionWithBindings(errors, expressionValue, expressionInput, reportFieldInput);
            var expressionWithBindings = expressionWithBindingsAndDisplayExpression.expression;
            expressionValue = expressionWithBindingsAndDisplayExpression.displayExpression;

            var deferred = $.Deferred();

            tryParseExpression(expressionWithBindings, availableColumns, expressionValue).then(function (data)
            {
                let calculationJson = null;
                let isFutureValue = false;
                let fieldType = skyward.reporting.DATA_TYPES.NUMBER_DECIMAL;
                if (data.success)
                {
                    expressionWithBindings = data.parsedExpression;
                    calculationJson = JSON.parse(data.calculationJson);
                    isFutureValue = data.isFutureValue;
                    fieldType = data.returnType;
                }
                else
                {
                    errors["aggregateCalculationExpression"] = [data.error];
                    highlightInvalidCharactersInExpression(expressionInput, data.startPosition, data.endPosition);
                }

                var hasErrors = !jQuery.isEmptyObject(errors);

                if (hasErrors)
                {
                    skyward.validation.displayValidationMessages({ errors: errors }, popup, $());
                }

                deferred.resolve({
                    isValid: !hasErrors,
                    name: nameValue,
                    expression: expressionWithBindings,
                    displayExpression: expressionValue,
                    isFutureValue: isFutureValue,
                    calculationJson: calculationJson,
                    fieldType: fieldType
                });
            });

            return deferred;
        };

        var highlightInvalidCharactersInExpression = function (expressionInput, start, end)
        {
            expressionInput.prop({ selectionStart: start, selectionEnd: end });
            expressionInput.focus();
        }

        var convertExpressionIntoExpressionWithBindings = function (errors, expression, expressionInput, reportFieldInput)
        {
            let expressionWithColumnIDBindings = expression;

            for (let bindingPartInfo of getBindingPartsInfo(expressionWithColumnIDBindings, reportFieldInput))
            {
                if (bindingPartInfo.error)
                {
                    errors["aggregateCalculationExpression"] = bindingPartInfo.error;

                    if (bindingPartInfo.endPosition)
                    {
                        highlightInvalidCharactersInExpression(expressionInput, bindingPartInfo.startPosition, bindingPartInfo.endPosition + 1);
                    }
                    else
                    {
                        highlightInvalidCharactersInExpression(expressionInput, bindingPartInfo.startPosition, bindingPartInfo.startPosition + 1);
                    }

                    //break out of loop because we found an error and can only highlight one error at a time.
                    break;
                }
                else
                {
                    expressionWithColumnIDBindings = expressionWithColumnIDBindings.replace(bindingPartInfo.displayBinding, bindingPartInfo.columnIDBinding);
                }
            }

            return {
                displayExpression: expression,
                expression: expressionWithColumnIDBindings
            };
        }

        var getBindingPartsInfo = function (expression, reportFieldInput)
        {
            let bindingPartsInfo = [];

            let bindingMaps = null;

            //if the inputs arent passed in this method will just not be able to populate certain values based
            //on if the binding is a display binding or a back end binding
            if (reportFieldInput)
            {
                bindingMaps = getColumnBindingMaps(reportFieldInput);
            }

            let bindingStartIndex = 0;
            let bindingEndIndex = 0;
            let failedToFindEndBracket = false;

            while (bindingStartIndex !== -1)
            {
                let bindingPartInfo = {
                    startPosition: null,
                    endPosition: null,
                    displayBinding: null,
                    columnIDBinding: null,
                    columnID: null,
                    error: null,
                };

                if (failedToFindEndBracket)
                {
                    bindingEndIndex = bindingStartIndex + 1;
                    failedToFindEndBracket = false;
                }

                bindingStartIndex = expression.indexOf("{", bindingEndIndex);
                if (bindingStartIndex !== -1)
                {
                    bindingPartInfo.startPosition = bindingStartIndex;
                    bindingEndIndex = expression.indexOf("}", bindingStartIndex);
                    if (bindingEndIndex !== -1)
                    {
                        bindingPartInfo.endPosition = bindingEndIndex;

                        let bindingWithBrackets = expression.substr(bindingStartIndex, bindingEndIndex - bindingStartIndex + 1);

                        if (bindingMaps)
                        {
                            if (bindingMaps.columnIDBinding[bindingWithBrackets])
                            {
                                bindingPartInfo.columnIDBinding = bindingMaps.columnIDBinding[bindingWithBrackets];
                                bindingPartInfo.displayBinding = bindingWithBrackets
                            }
                            else if (bindingMaps.displayBinding[bindingWithBrackets])
                            {
                                bindingPartInfo.columnIDBinding = bindingWithBrackets;
                                bindingPartInfo.displayBinding = bindingMaps.displayBinding[bindingWithBrackets];
                            }
                        }
                        else
                        {
                            bindingPartInfo.displayBinding = bindingWithBrackets
                            bindingPartInfo.columnIDBinding = bindingWithBrackets;
                        }

                        const bindingWithoutBrackets = bindingPartInfo.columnIDBinding.substr(1, bindingPartInfo.columnIDBinding.length - 2);
                        const columnBindingsParts = bindingWithoutBrackets.split(".");

                        if (columnBindingsParts.length == 2)
                        {
                            bindingPartInfo.columnID = Number.parseInt(columnBindingsParts[1]);
                        }
                        else
                        {
                            bindingPartInfo.error = ["Field is invalid. Try removing and re-adding."]
                            continue;
                        }
                    }
                    else
                    {
                        failedToFindEndBracket = true;
                        bindingPartInfo.error = ["Could not locate closing bracket."]
                        continue;
                    }

                    bindingPartsInfo.push(bindingPartInfo);
                }
            }

            return bindingPartsInfo;
        }

        function getColumnBindingMaps(reportFieldInput)
        {
            const bindings = {
                columnIDBinding: {},
                displayBinding: {}
            };

            reportFieldInput.find("option").each(function ()
            {
                const option = $(this);
                const binding = option.val();
                const displayBinding = option.data("displayBinding");

                //skip over the blank option
                if (displayBinding)
                {
                    bindings.displayBinding[binding] = displayBinding;
                    bindings.columnIDBinding[displayBinding] = binding;
                }
            });

            return bindings;
        }

        var tryParseExpression = function (expressionWithBindings, allSectionInfo, displayExpression)
        {
            var postedData =
            {
                expression: expressionWithBindings,
                allSectionInfo: skyward.extensions.encodeHtml(JSON.stringify(allSectionInfo)),
                displayExpression: displayExpression
            };
            var url = skyward.global.virtualDir + "Reporting/Report/TryParseAggregateColumnExpression";
            return $.ajax({
                type: "POST",
                dataType: "JSON",
                url: url,
                data: postedData
            });
        }

        var init = function (selector)
        {
            const selectorElement = $(selector);

            const aggregateCalculationBuilder = selectorElement.find("#aggregateCalculationBuilder");

            if (aggregateCalculationBuilder)
            {
                const reportSectionInput = aggregateCalculationBuilder.find("#aggregateCalculationReportSection");
                const reportFieldInput = aggregateCalculationBuilder.find("#aggregateCalculationReportField");
                const aggregateTypeInput = aggregateCalculationBuilder.find("#aggregateCalculationAggregateType");

                const insertFieldButton = aggregateCalculationBuilder.find("#aggregateCalculationInsert");

                const operationButtons = aggregateCalculationBuilder.find(".aggregateCalculationOperations .button");

                const expressionInput = aggregateCalculationBuilder.find("#aggregateCalculationExpression");

                reportSectionInput.on("change", function () { changeVisibleFields($(this).find(":selected").data("sectionId"), reportFieldInput); });

                reportFieldInput.on("change", function () { updateAggregateTypeInputBasedOnSelectedField(aggregateTypeInput, $(this).find(":selected").data()) });

                insertFieldButton.on("click", function ()
                {
                    let errors = {};
                    validateField(reportFieldInput, errors);
                    validateAggregateType(aggregateTypeInput, reportFieldInput, errors);
                    if (jQuery.isEmptyObject(errors))
                    {
                        skyward.validation.clearValidationMessages(aggregateCalculationBuilder, $())

                        insertFieldClick(expressionInput, reportFieldInput, aggregateTypeInput);

                        skyward.controls.setValue(reportFieldInput, "");
                        skyward.controls.setValue(aggregateTypeInput, "");
                    }
                    else
                    {
                        skyward.validation.displayValidationMessages({ errors: errors }, aggregateCalculationBuilder, $())
                    }
                });

                operationButtons.on("click", function () { operationClick(expressionInput, $(this)); });
            }
        }

        var changeVisibleFields = function (selectedSectionID, reportFieldInput)
        {
            skyward.controls.setValue(reportFieldInput, "");
            reportFieldInput.find("optgroup").each(function ()
            {
                const optionGroup = $(this);
                const sectionID = optionGroup.data('sectionId');

                skyward.controls.toggleVisible(optionGroup, sectionID === selectedSectionID, false);
            });
        }

        var updateAggregateTypeInputBasedOnSelectedField = function (aggregateTypeInput, selectedFieldData)
        {
            if (!selectedFieldData.isOnCurrentLine)
            {
                aggregateTypeInput.find("option").each(function ()
                {
                    const option = $(this);
                    //skip if its the blank option.
                    //We need the blank option to force people to choose change the value after changing the field so the selected value is correct.
                    if (option.val())
                    {
                        const availableForDataTypes = option.data("availableForDataTypes");
                        let showOption = availableForDataTypes.includes(selectedFieldData.dataType);
                        if (selectedFieldData.dataType && selectedFieldData.dataType.startsWith("String Enum"))
                        {
                            showOption = availableForDataTypes.some((dataType) => dataType.startsWith("String Enum"));
                        }

                        option.removeAttr("selected");
                        skyward.controls.toggleVisible(option, showOption, false);
                    }
                });
            }

            skyward.controls.setValue(aggregateTypeInput, "");
            skyward.controls.toggle(aggregateTypeInput, !selectedFieldData.isOnCurrentLine);
        }

        var validateField = function (reportFieldInput, errors)
        {
            if (!skyward.controls.getValue(reportFieldInput).trim())
            {
                errors["aggregateCalculationReportField"] = ["Report Field is required when inserting a field."]
            }
        };

        var validateAggregateType = function (aggregateTypeInput, reportFieldInput, errors)
        {
            if (reportFieldInput.find(":selected").data("isOnCurrentLine") === false && !skyward.controls.getValue(aggregateTypeInput).trim())
            {
                errors["aggregateCalculationAggregateType"] = ["Aggregate Type is required for columns not on the currently selected line when inserting a field."]
            }
        };

        var insertFieldClick = function(expressionInput, reportFieldInput, aggregateTypeInput)
        {
            const selectedField = reportFieldInput.find(":selected");
            const selectedAggregateType = aggregateTypeInput.find(":selected");
            const selectedAggregateTypeText = selectedAggregateType.val();

            const displayBinding = selectedField.data("displayBinding");

            if (selectedAggregateTypeText)
            {
                insertValue(expressionInput, selectedAggregateTypeText + "( " + displayBinding + " )");
            }
            else
            {
                insertValue(expressionInput, displayBinding);
            }
        };

        var operationClick = function (expressionInput, button)
        {
            var token = button.data("token");
            insertValue(expressionInput, token);
        };

        var insertValue = function (expressionInput, value)
        {
            skyward.global.text.insertTextToken(expressionInput, value, true);
        };

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
"use strict";

(function (skyward, $, undefined)
{
    skyward.reporting = skyward.reporting || {};
    skyward.reporting.multiColumnSection = skyward.reporting.multiColumnSection || {};

    skyward.reporting.multiColumnSection.init = function (data)
    {
        //data.columnWidth;
        //data.columnSpacing;
        //data.applyColumnsToDataLinesOnly;
        //data.balanceColumns;
        //data.columnDirection;
        //data.defaultWidth;
        //data.callBack();
        //data.currentSectionDisplayOnSingleLine

        var ok = function ()
        {
            var columnWidthVal = Number(columWidth.val());
            columnWidthVal = columnWidthVal === "" ? data.defaultWidth : +columnWidthVal;
            var columnSpacingVal = Number(columnSpacing.val());
            columnSpacingVal = columnSpacingVal === "" ? 0 : +columnSpacingVal;
            var unusableWidth = (data.defaultWidth - columnWidthVal) * 72;
            var newData =
            {
                columnWidth: columnWidthVal,
                columnSpacing: columnSpacingVal,
                applyColumnsToDataLinesOnly: skyward.radioButtonGroup.getValue(applyColumnsToDataLinesOnly).toLowerCase() === "true",
                balanceColumns: balanceColumns.prop("checked"),
                columnDirection: skyward.radioButtonGroup.getValue(columnDirection),
                unusableAreaBox: skyward.reporting.multiColumnSection.generateUnusableAreaBox(unusableWidth)
            };
            data.callBack(newData);
            modalLayer.close();
        };

        var reset = function ()
        {
            columWidth.val(data.defaultWidth);
            columnSpacing.val(0);
            skyward.radioButtonGroup.setValue(applyColumnsToDataLinesOnly, "false");
            balanceColumns.prop("checked", false);
            skyward.radioButtonGroup.setValue(columnDirection, "Down");
        };

        var multiColumnSectionEditorHTML = $(".multiColumnSectionEditorTemplate").html();

        var okButton = { text: "Save", icon: "Save", click: ok };
        var cancelButton = { text: "Cancel", icon: "Cancel", click: "close" };
        var resetButton = { text: "Reset", icon: "Undo", click: reset };
        var buttons = [resetButton, okButton, cancelButton];
        var modalLayer = skyward.modalLayer.showDialog("Multi-Column Section", multiColumnSectionEditorHTML, buttons, { closeOnClick: false });

        var multiColumnSectionEditor = modalLayer.content.children('.multiColumnSectionEditor');

        var columWidth = multiColumnSectionEditor.find(".columnWidth");
        var columnSpacing = multiColumnSectionEditor.find(".columnSpacing");
        var applyColumnsToDataLinesOnly = multiColumnSectionEditor.find(".applyColumnsToDataLinesOnly");
        var balanceColumns = multiColumnSectionEditor.find(".balanceColumns");
        var columnDirection = multiColumnSectionEditor.find(".columnDirection");
        var contentMessageArea = skyward.contentMessageArea.getContentMessageArea(multiColumnSectionEditor);

        skyward.controls.toggle(columWidth, !data.currentSectionDisplayOnSingleLine);
        skyward.controls.toggle(columnSpacing, !data.currentSectionDisplayOnSingleLine);
        skyward.controls.toggle(applyColumnsToDataLinesOnly, !data.currentSectionDisplayOnSingleLine);
        skyward.controls.toggle(balanceColumns, !data.currentSectionDisplayOnSingleLine);
        skyward.controls.toggle(columnDirection, !data.currentSectionDisplayOnSingleLine);
        if (data.currentSectionDisplayOnSingleLine)
        {
            contentMessageArea.showInformation();
        }

        columWidth.val(data.columnWidth === "" ? data.defaultWidth : data.columnWidth);
        columnSpacing.val(data.columnSpacing || 0);
        balanceColumns.prop("checked", data.balanceColumns);
        if (data.applyColumnsToDataLinesOnly)
        {
            skyward.radioButtonGroup.setValue(applyColumnsToDataLinesOnly, data.applyColumnsToDataLinesOnly.toString());
        }
        if (data.columnDirection)
        {
            skyward.radioButtonGroup.setValue(columnDirection, data.columnDirection);
        }

        var checkForNegativeNumber = function (event)
        {
            var input = event.target;

            if (input.value < 0)
            {
                input.value = 0;
            }
        };

        var toggleBalanceBasedOnDirection = function (direction)
        {
            if (direction === "Across")
            {
                balanceColumns.prop("checked", false);
                balanceColumns.parent().hide();
            }
            else
            {
                balanceColumns.parent().show();
            }
        };

        toggleBalanceBasedOnDirection(skyward.radioButtonGroup.getValue(columnDirection));

        columWidth.on("change", checkForNegativeNumber);
        columnSpacing.on("change", checkForNegativeNumber);
        columnDirection.on("change", function (event)
        {
            toggleBalanceBasedOnDirection(event.target.value);
        });
    };

    skyward.reporting.multiColumnSection.generateUnusableAreaBox = function (unusableWidth)
    {
        return $("<div/>").addClass("unusableArea").css("width", unusableWidth + "pt");
    };

})(skyward || {}, window.jQuery);;
(function (skyward, $, undefined)
{
    "use strict";

    skyward.reporting = skyward.reporting || {};
    skyward.reporting.searchParameters = skyward.reporting.searchParameters || {};

    var _view = skyward.mvvm.newView(function ()
    {
        var _self = this;
        var _templates, _viewParts, _layer;

        var _internal = {
            "loadTemplates": function ()
            {
                var deferred = $.Deferred();
                $.ajax({
                    url: skyward.global.virtualDir + "Reporting/Report/GetSearchParameterBuilderTemplate/",
                    type: "POST",
                    dataType: "JSON",
                    success: async function (data)
                    {
                        const [processedBuilder, processedAvailable, processedInUse, processedDynList, processedDynItem, processedIcons] = await Promise.all([
                            skyward.global.processViewPartHtml(data.builder),
                            skyward.global.processViewPartHtml(data.availableItem),
                            skyward.global.processViewPartHtml(data.inUseItems),
                            skyward.global.processViewPartHtml(data.dynamicValueList),
                            skyward.global.processViewPartHtml(data.dynamicValueItem),
                            skyward.global.processViewPartHtml(data.icons)
                        ]);

                        _templates = {
                            builder: $(processedBuilder),
                            availableItem: $(processedAvailable),
                            inUseItems: $(processedInUse),
                            dynamicValueList: $(processedDynList),
                            dynamicValueItem: $(processedDynItem),
                            icons: $(processedIcons)
                        };

                        _templates.inUseItems.find("input").attr("tabindex", 0);

                        _templates.inUseItems.find("input").removeProp("readonly");
                        deferred.resolve(data);
                    }
                });
                return deferred;
            },
            "getIndex": function (item)
            {
                return (item.hasClass(".searchParameterItem") ? item : item.closest(".searchParameterItem")).prevAll().length;
            },
            "getIcon": function (dataType, isPrompt)
            {
                var icon;
                if (isPrompt)
                {
                    icon = _templates.icons.find(".prompt");
                }
                else
                {
                    var where_dataTypeMatches = function ()
                    {
                        if (dataType.startsWith("String Enum-"))
                        {
                            return ($(this).data("show-for") || "").split(",").findIndex(function (item)
                            {
                                return item == "String Enum-System.Enum";
                            }) !== -1;
                        }
                        return ($(this).data("show-for") || "").split(",").indexOf(dataType) !== -1;
                    };

                    icon = _templates.icons.find(".parameterIcon").filter(where_dataTypeMatches);
                    if (!icon.length)
                    {
                        icon = _templates.icons.find(".other");
                    }
                }
                icon = icon.clone();

                return icon;
            },
            "setValueOnInUseItem": function (key, value, displayValue, dataType, isPrompt, required)
            {
                var itemViewPart = _viewParts.items[key];
                var container = itemViewPart.find(".searchParameterValueContainer");
                //Remove ends up here at which point the inputs are no longer there
                if (container.length)
                {
                    var input = container.find(".value");
                    var label = container.find(".searchParameterLabel");
                    var enumIcon = container.find(".enumParameterIcon");

                    var datepicker = itemViewPart.find(".datepicker");

                    input.val(value);
                    container.toggleClass("dynamic", displayValue ? true : false).children("svg").not(".enumParameterIcon").remove();
                    if (displayValue)
                    {
                        input.hide();
                        label.empty().text(displayValue).show();
                        _internal.getIcon(dataType, isPrompt).prependTo(label);
                        if (dataType === "DateTime")
                        {
                            var datepickerButton = itemViewPart.find(".datepicker-trigger");
                            datepickerButton.hide();
                        }

                        if (enumIcon.length)
                        {
                            enumIcon.hide();
                        }
                    }
                    else
                    {
                        input.show();
                        label.hide();
                        if (dataType === "DateTime" && datepicker.length)
                        {
                            skyward.datepicker.registerDatepicker(datepicker);
                        }
                    }
                    var asterisk = _viewParts.items[key].find(".requiredAsterisk");
                    asterisk.toggle(required);
                }
            },
            "itemIsInUse": function (item) { return item.closest(".searchParameterContainer").hasClass("inUse"); }
        };

        var _events = {
            "open": function ()
            {
                if (!_templates)
                {
                    _internal.loadTemplates().then(_events.open);
                    return;
                }

                var html = _templates.builder.clone();
                var buttons = [
                    { text: "Ok", icon: "Check", click: function () { _events.save(); if (!_events.Error()) { _events.close(); } } },
                    { text: "Cancel", icon: "Cancel", click: "close" }
                ];
                _layer = skyward.modalLayer.showDialog("Search Parameter Builder", html, buttons, { afterClose: _events.close, closeOnClick: false, automationID: "parameter-builder-dialog" });

                _layer.animationPromise.then(_layer.bodyPromise).done(function ()
                {
                    _viewParts = {
                        global: _layer.content,
                        inUseList: _layer.content.find(".inUse .searchParameterList"),
                        availableList: _layer.content.find(".available .searchParameterList"),
                        items: {},
                        actions: _layer.content.find(".searchParameterContainer.actions"),
                        addButton: _layer.content.find(".add"),
                        removeButton: _layer.content.find(".remove")
                    };

                    _viewParts.inUseList.on("change", ".value", null, _events.inputChanged);

                    _viewParts.inUseList.on("click", ".searchParameterItem", null, _events.inUseItemClicked);
                    _viewParts.availableList.on("click", ".searchParameterItem", null, _events.availableItemClicked);

                    _viewParts.actions.on("click", ".add", null, _events.addClicked);
                    _viewParts.availableList.on("dblclick", ".searchParameterItem", null, _events.addClicked);

                    _viewParts.actions.on("click", ".remove", null, _events.removeClicked);
                    _viewParts.inUseList.on("dblclick", ".searchParameterItem", null, _events.removeClicked);

                    _viewParts.global.on("click", ".selectValue", null, _events.valueSelectorClicked);

                    _self.announce('open');
                });
            },
            "close": function ()
            {
                if (_layer && _layer.modalLayer.onscreen)
                {
                    _layer.close();
                }

                $.each(_viewParts, function () { $(this).off(); });
                _viewParts = {};
                _self.announce('close');
            },
            "save": function ()
            {
                _self.announce('save');
            },
            "addClicked": function ()
            {
                _self.announce('add');
            },
            "removeClicked": function ()
            {
                _self.announce('remove');
            },
            "inUseItemClicked": function ()
            {
                _self.announce('select', true, _internal.getIndex($(this)));
            },
            "availableItemClicked": function ()
            {
                _self.announce('select', false, _internal.getIndex($(this)));
            },
            "inputChanged": function (event)
            {
                var item = $(this);
                var inUse = item.closest(".searchParameterContainer").hasClass("inUse");
                var value = $(event.target).val();
                _self.announce('change', inUse, _internal.getIndex(item), value);
            },
            "valueSelectorClicked": function ()
            {
                _self.announce("dynamicValues", _internal.getIndex($(this)));
            },
            "dynamicValueSelected": function (data)
            {
                _self.announce('change', true, _internal.getIndex(data.item), data.value, data.displayValue, data.displayValueType);
                var datePickerIcon = data.item.find(".datepicker-trigger");
                if (datePickerIcon.length)
                {
                    if (data.value === "")
                    {
                        datePickerIcon.show();
                    }
                    else
                    {
                        datePickerIcon.hide();
                    }
                }

                data.item.find("input:visible").focus();
            },
            "Error": function ()
            {
                var errors = skyward.reporting.searchParameters.viewModel.getErrors();
                if (!$.isEmptyObject(errors))
                {
                    skyward.validation.displayValidationMessages({ errors: errors }, _layer.content, $());
                    return true;
                }
                return false;
            }

        };

        var actions = {
            "init": function ()
            {
                $(".jsSearchParameterBuilder").on("click", _events.open);
                return _self;
            },
            "nothingToShow": function ()
            {
                const buttons = [{ text: "Close", icon: "Close", click: "close" }];
                skyward.modalLayer.showInformationDialog("No Parameters Available", "No fields that accept parameters are currently used in this report.", buttons, { afterClose: _events.close });
            },
            "invalidSearchParameters": function (keys)
            {
                var messageParts = ["The following parameters are no longer accepted by any of the fields used in this report:", ""];
                messageParts = messageParts.concat(keys);
                messageParts = messageParts.concat(["", "These parameters have been automatically removed."]);
                var message = messageParts.join('\n');

                skyward.modalLayer.showInformationDialog("Invalid Parameters", message);
            },
            "add": function (addToInUseList, key, value, displayValue, dataType, isPrompt, required)
            {
                var isEnum = dataType.startsWith("String Enum-");

                var where_dataTypeMatches = function ()
                {
                    if (isEnum)
                    {
                        return ($(this).data("show-for") || "").split(",").indexOf("String Enum-") !== -1;
                    }
                    return ($(this).data("show-for") || "").split(",").indexOf(dataType) !== -1;
                };

                var where_defaultDataType = function ()
                {
                    return ($(this).data("show-for") || "").indexOf("Default") !== -1;
                };

                var item;
                if (addToInUseList)
                {
                    item = _templates.inUseItems.filter(where_dataTypeMatches);
                    if (item.length === 0)
                    {
                        item = _templates.inUseItems.filter(where_defaultDataType);
                    }
                    item = item.first().clone();
                    var asterisk = item.find(".requiredAsterisk");
                    item.find(".key").text(key).prepend(asterisk).data("dataType", dataType);
                    item.find(".searchParameterLabel").attr("data-validate-text-for", key);
                    item.find(".value").attr("data-validate-control-for", key);
                    item.find(".error").attr("data-validate-message-for", key);

                    const dateTimePickers = item.find(".dateTimePickerWrapper");
                    if (dateTimePickers.length > 0)
                    {
                        dateTimePickers.attr("data-suppress-focus", "true");
                    }

                    _viewParts.inUseList.append(item);
                }
                else
                {
                    item = _templates.availableItem.clone();
                    item.find(".key").text(key);
                    _viewParts.availableList.append(item);
                }
                skyward.window.notifyDOMLoad(item);

                // Track item viewparts by key
                (_viewParts.items = _viewParts.items || {})[key] = item;

                // Set values and icon
                if (addToInUseList)
                {
                    _internal.setValueOnInUseItem(key, value, displayValue, dataType, isPrompt, required);
                }
                else
                {
                    item.find(".parameterIcon").remove();
                    item.prepend(_internal.getIcon(dataType, isPrompt));
                }
            },
            "remove": function (key)
            {
                _viewParts.items[key].remove();
                delete _viewParts.items[key];
            },
            "select": function (key)
            {
                const input = _viewParts.items[key].addClass("selectedSearchParameter").find("input:visible");
                if (input.closest(".dateTimePickerWrapper").length > 0)
                {
                    input.attr("data-suppress-focus", "true");
                }
                input.focus();
                (_internal.itemIsInUse(_viewParts.items[key]) ? _viewParts.removeButton : _viewParts.addButton).show();
            },
            "unselect": function (key)
            {
                _viewParts.items[key].removeClass("selectedSearchParameter");
                (_internal.itemIsInUse(_viewParts.items[key]) ? _viewParts.removeButton : _viewParts.addButton).hide();
            },
            "change": _internal.setValueOnInUseItem,
            "showDynamicValues": function (searchParameterModel, prompts, environmentValues, enumOptions)
            {
                var key = searchParameterModel.key;
                var dataType = searchParameterModel.dataType;
                var required = searchParameterModel.required;
                var defaultFieldPath = searchParameterModel.defaultFieldPath;

                // This is *not* MVVM - it puts too much responsibility in the view, and there's no model to represent a dynamic value or the collection of DVs.
                // A separate viewModel should be created to handle selecting dynamic values.
                // Then we can use one viewModel-type everywhere dynamic values need to be displayed and chosen.
                var deferred = $.Deferred();
                deferred.done(_events.dynamicValueSelected);

                var searchParameter = _viewParts.items[key];
                var content = _templates.dynamicValueList.clone();

                var lastEnumItem = content.find(".enumValues");
                if (Object.keys(enumOptions).length)
                {
                    var staticValue = content.find(".staticValue");
                    staticValue.hide();
                    $.each(enumOptions, function (displayValue, value)
                    {
                        var nextEnumItem = _templates.dynamicValueItem.clone();
                        nextEnumItem.on("click", function () { deferred.resolve({ item: searchParameter, value: value, displayValue: displayValue }); });
                        nextEnumItem.find(".searchParameterLabel").text(displayValue);
                        nextEnumItem.find(".iconTarget").append(_internal.getIcon(dataType));
                        lastEnumItem = nextEnumItem.insertAfter(lastEnumItem);
                    });
                }
                else
                {
                    lastEnumItem.hide();
                }

                var lastEnvironmentItem = content.find(".environment");
                if (Object.keys(environmentValues).length)
                {
                    $.each(environmentValues, function (displayValue, value)
                    {
                        var nextEnvironmentItem = _templates.dynamicValueItem.clone();
                        nextEnvironmentItem.on("click", function () { deferred.resolve({ item: searchParameter, value: value, displayValue: displayValue }); });
                        nextEnvironmentItem.find(".searchParameterLabel").text(displayValue);
                        nextEnvironmentItem.find(".iconTarget").append(_internal.getIcon(dataType));
                        lastEnvironmentItem = nextEnvironmentItem.insertAfter(lastEnvironmentItem);
                    });
                }
                else
                {
                    _templates.dynamicValueItem.clone()
                        .insertAfter(lastEnvironmentItem)
                        .find(".searchParameterLabel").text("No environment variables are available for this parameter");
                }


                var lastPromptItem = content.find(".prompts");
                $.each(prompts || {}, function ()
                {
                    var prompt = this;
                    var nextPromptItem = _templates.dynamicValueItem.clone();
                    nextPromptItem.on("click", function ()
                    {
                        if (required)
                        {
                            prompt.PresenceType = "Required";
                        }
                        deferred.resolve({ item: searchParameter, value: prompt.bindingString(), displayValue: prompt.Label });
                    });
                    nextPromptItem.find(".searchParameterLabel").text(prompt.Label);
                    nextPromptItem.find(".iconTarget").append(_internal.getIcon(dataType, true));
                    lastPromptItem = nextPromptItem.insertAfter(lastPromptItem);
                });

                content.find(".staticValue").on("click", function ()
                {
                    deferred.resolve({ item: searchParameter, value: "" });
                });

                // This nested-callback madness is exactly the kind of stuff that we'll avoid if we can fully implement MVVM
                content.find(".addPrompt").on("click", function ()
                {
                    const promptInfo = { Label: key, InputType: dataType, FieldPath: defaultFieldPath };
                    const parameter = skyward.reporting.currentReportDefinition.AvailableParameters[key];
                    const promptOptions = { treatPromptAsInUse: true, treatPromptAsInUseRequired: required, tempRelatedSearchParameter: parameter };

                    if (parameter.isList === true)
                    {
                        promptInfo.Type = skyward.reporting.enummaps.PromptTypes.MultipleSelect;
                    }

                    const addPromptView = skyward.reporting.prompts.getPromptDetailsView(promptInfo, promptOptions);

                    addPromptView.then(function (data)
                    {
                        deferred.resolve(data && data.promptModel ? { item: searchParameter, value: data.promptModel.bindingString(), displayValue: data.promptModel.Label } : undefined);
                    });
                });

                var popup = skyward.modalLayer.showInformationDialog("Select A Dynamic Value", content, null, {
                    closeOnClick: true,
                    afterClose: function ()
                    {
                        if (deferred.state() !== "resolved")
                        {
                            deferred.reject();
                        }
                    },
                    warning: true
                });
                deferred.done(function () { if (popup && typeof (popup.close === "function")) { popup.close(); } });
            },
            "Validate": function ()
            {
                return _events.Error();
            }
        };
        return actions;
    });

    skyward.reporting.searchParameters.viewModel = skyward.mvvm.newViewModel(function ()
    {
        var _self = this;
        var _availableModel, _savedModel, _unsavedModel, _viewState;

        var _internal = {
            "loadAvailableItems": function ()
            {
                var parameters = skyward.reporting.currentReportDefinition.AvailableParameters;
                for (var key in parameters)
                {
                    var searchParameter = parameters[key];
                    if (!_unsavedModel.some(function (sp) { return sp.key === key; }))
                    {
                        if (searchParameter.required)
                        {
                            _unsavedModel.add(skyward.mvvm.newModel({ value: "", dataType: searchParameter.dataType, required: searchParameter.required, defaultFieldPath: searchParameter.defaultFieldPath, isList: searchParameter.isList }, { key: key }));
                        }
                        else
                        {
                            _availableModel.add(skyward.mvvm.newModel({ value: "", dataType: searchParameter.dataType, required: searchParameter.required, defaultFieldPath: searchParameter.defaultFieldPath, isList: searchParameter.isList }, { key: key }));
                        }
                    }

                    var searchParametersWithWrongRequired = _unsavedModel.filter(function (sp) { return sp.key === key && sp.required !== searchParameter.required; });

                    $.each(searchParametersWithWrongRequired, function (index, value)
                    {
                        value.required = searchParameter.required;
                    });
                }

                if (_availableModel.length)
                {
                    _viewState.selected = _availableModel.elementAt(0);
                }
                else if (!_unsavedModel.length)
                {
                    _view.nothingToShow();
                }

                // Find and remove invalid parameters
                var invalidSearchParameters = _unsavedModel.findMany(function (sp, existingKeys) { return !existingKeys[sp.key]; }, parameters);
                if (invalidSearchParameters.length)
                {
                    var keys = [];
                    invalidSearchParameters.forEach(function (sp) { _unsavedModel.remove(sp); keys.push(sp.key); });
                    _view.invalidSearchParameters(keys);
                }
            },
            "makeSearchParameterCollection": function (originalItems)
            {
                var _thisCollection;
                var actions = {
                    "inUseToJson": function (parameters)
                    {
                        var result = [];
                        _thisCollection.forEach(function (sp)
                        {
                            if (parameters.hasOwnProperty(sp.key))
                            {
                                var spJson = { key: sp.key + "", value: sp.value + "", required: sp.required, isList: sp.isList };
                                if (sp.dataType !== undefined)
                                {
                                    spJson.dataType = sp.dataType;
                                }

                                result.push(spJson);
                            }
                            else
                            {
                                _thisCollection.remove(sp);
                            }
                        });
                        return result;
                    }
                };
                _thisCollection = skyward.mvvm.newModelCollection(originalItems, { massUpdateInProgress: false }, actions);
                return _thisCollection;
            },
            "makeSearchParameter": function (data)
            {
                let value = data.value ? data.value : data.Value;
                let required = data.required ? data.required : data.Required;
                let dataType = data.dataType ? data.dataType : data.DataType;
                let key = data.key ? data.key : data.Key;
                let displayValue = data.displayValue ? data.displayValue : data.DisplayValue;
                let isList = data.isList ? data.isList : data.IsList;

                if (!dataType.startsWith("String Enum-"))
                {
                    displayValue = skyward.reporting.enummaps.EnvironmentVariableBindingToDisplayValue[value];
                }

                const model = skyward.mvvm.newModel({ value: value, required: required }, { dataType: dataType, key: key });
                model.displayValue = displayValue; // We don't track this value, or it breaks dirty logic
                model.defaultFieldPath = data.defaultFieldPath;
                model.isList = isList;
                return model;
            },
            "cloneSearchParameter": function (sp)
            {
                return skyward.mvvm.newModel({ value: sp.value, displayValue: sp.displayValue, required: sp.required, defaultFieldPath: sp.defaultFieldPath, isList: sp.isList }, { dataType: sp.dataType, key: sp.key });
            },
            "isPrompt": function (value)
            {
                return value.substring(0, 9) === "{_prompt.";
            },
            "updatePromptDisplayValues": function (uniqueId, newDisplayValue)
            {
                var searchString = "{_prompt." + uniqueId + "}";
                var where_ParameterReferencesPrompt = function (sp) { return sp.value === searchString; };
                var update = function () { if (this.displayValue !== newDisplayValue) { this.displayValue = newDisplayValue; } };

                $.each(_savedModel.findMany(where_ParameterReferencesPrompt), update);
                if (_unsavedModel)
                {
                    $.each(_unsavedModel.findMany(where_ParameterReferencesPrompt), update);
                }
            },
            "removePromptReferences": function (uniqueId)
            {
                var searchString = "{_prompt." + uniqueId + "}";
                var where_ParameterReferencesPrompt = function (sp) { return sp.value === searchString; };
                var reset = function () { this.value = ""; this.displayValue = ""; };

                $.each(_savedModel.findMany(where_ParameterReferencesPrompt), reset);
                if (_unsavedModel)
                {
                    $.each(_unsavedModel.findMany(where_ParameterReferencesPrompt), reset);
                }
            },
            "validateValue": function (parameter)
            {
                let value = parameter.value;
                let valid = true;
                let message = "";
                if (!value.startsWith("{_"))
                {
                    if (parameter.isList)
                    {
                        valid = false;
                        message = "This parameter requires a List Type Environment Variable or Prompt."
                    }
                    else if (value === "")
                    {
                        valid = false;
                        message = "A value is required.";
                    }
                    else
                    {
                        switch (parameter.dataType)
                        {
                            case "Number Long":
                                /* Unable to use a value of 9223372036854775807 when the parameter type is Number Long, since we don't support using BigInt yet due to old versions of Safari on older iOS devices.
                                 * To get around this limitation we are masking the search condition value to at most 18 characters instead of 19, which guaranties the input is a valid long and we can skip the range validation.
                                 * See PR 5271305
                                 */
                                valid = skyward.validation.validNumber(value);
                                if (!valid)
                                {
                                    message = `'${value}' is an invalid value for data type Number Long.`;
                                }
                                break;
                            case "Number Int":
                                valid = skyward.validation.validNumber(value) && Number(value) >= -2147483648 && Number(value) <= 2147483647;
                                if (!valid)
                                {
                                    message = `'${value}' is an invalid value for data type Number Int.`;
                                }
                                break;
                            case "Number Short":
                                valid = skyward.validation.validNumber(value) && Number(value) >= -32768 && Number(value) <= 32767;
                                if (!valid)
                                {
                                    message = `'${value}' is an invalid value for data type Number Short.`;
                                }
                                break;
                            case "Number Byte":
                                valid = skyward.validation.validNumber(value) && Number(value) >= 0 && Number(value) <= 255;
                                if (!valid)
                                {
                                    message = `'${value}' is an invalid value for data type Number Byte.`;
                                }
                                break;
                            case "DateTime":
                                let date = skyward.datepicker.parseDateString(value);
                                valid = skyward.time.isDate(date);
                                if (!valid)
                                {
                                    message = `'${value}' is not a valid Date.`;
                                }
                                break;
                        }
                    }
                }

                return { isValid: valid, errorMessage: message };
            }
        };

        var _events = {
            viewState: {
                "selected": function (item, oldItem)
                {
                    if (oldItem)
                    {
                        _view.unselect(oldItem.key);
                    }

                    if (item && !item.required)
                    {
                        _view.select(item.key);
                    }
                }
            },
            model: {
                "contentChanged": function (item) //, announcement)
                // a callback for a contentChanged event can receive the item's announcement as an array in parameter 2, but in this situation we don't care.
                {
                    _view.change(item.key, item.value, item.displayValue, item.dataType, _internal.isPrompt(item.value), item.required);
                },
                "add": function (item) // , length)
                {
                    var addToInUseItems = this === _unsavedModel;
                    _view.add(addToInUseItems, item.key, item.value, item.displayValue, item.dataType, _internal.isPrompt(item.value), item.required);
                },
                "remove": function (item) // , index)
                {
                    _view.remove(item.key);
                }
            },
            view: {
                closed: {
                    "open": function ()
                    {
                        _self.stopObservingEvent(_view, _events.view.closed);
                        _self.observe(_view, _events.view.open);

                        _unsavedModel = _internal.makeSearchParameterCollection(_savedModel);
                        _availableModel = skyward.mvvm.newModelCollection();
                        _viewState = skyward.mvvm.newModel({ selected: null, errors: {} });

                        _self.observe(_unsavedModel, _events.model);
                        _self.observe(_availableModel, _events.model);
                        _self.observe(_viewState, _events.viewState);

                        // clone saved model into unsaved model, which will display each entry in the builder
                        _savedModel.forEach(function (d) { _unsavedModel.add(_internal.cloneSearchParameter(d)); });

                        if (_unsavedModel.length)
                        {
                            _viewState.selected = _unsavedModel.elementAt(0);
                        }

                        _internal.loadAvailableItems();
                    }
                },
                open: {
                    "add": function ()
                    {
                        var item = _viewState.selected;
                        _viewState.selected = null;
                        _availableModel.remove(item);

                        _unsavedModel.add(item);
                        _viewState.selected = item;
                    },
                    "remove": function ()
                    {
                        var item = _viewState.selected;
                        if (!item.required)
                        {
                            _viewState.selected = null;
                            _unsavedModel.remove(item);

                            _availableModel.add(item);
                            _viewState.selected = item;
                            item.value = "";
                            item.displayValue = "";
                        }
                    },
                    "select": function (inUse, index)
                    {
                        _viewState.selected = (inUse ? _unsavedModel : _availableModel).elementAt(index);
                    },
                    "change": function (inUse, index, value, displayValue)
                    {
                        var item = (inUse ? _unsavedModel : _availableModel).elementAt(index);
                        item.displayValue = displayValue;
                        item.value = value;
                        if (_viewState.errors[item.key])
                        {
                            delete _viewState.errors[item.key];
                            _view.Validate();
                        }
                    },
                    "save": function ()
                    {
                        var matchedKeys = [];
                        var added = [];
                        var deleted = [];
                        _viewState.errors = {};

                        _savedModel.massUpdateInProgress = true;

                        // Merge values that were changed into the saved/live model
                        _savedModel.forEach(function (savedItem)
                        {
                            // savedItem.key becomes the second parameter of each delegate call
                            var matchingUnsavedItem = _unsavedModel.find(function (p, k) { return p.key === k; }, savedItem.key);
                            if (matchingUnsavedItem)
                            {
                                let validatedResult = _internal.validateValue(matchingUnsavedItem);
                                if (!validatedResult.isValid)
                                {
                                    _viewState.errors[savedItem.key] = [validatedResult.errorMessage];
                                }
                                else
                                {
                                    savedItem.value = matchingUnsavedItem.value;
                                    savedItem.displayValue = matchingUnsavedItem.displayValue;
                                    savedItem.required = matchingUnsavedItem.required;
                                    savedItem.isList = matchingUnsavedItem.isList;
                                    matchedKeys[savedItem.key] = true;
                                }
                            }
                            else
                            {
                                deleted.push(savedItem);
                            }
                        });
                        // Identify new parameters that were added during this popup session and add them to the saved/live model
                        _unsavedModel.forEach(function (unsavedItem)
                        {
                            if (!matchedKeys[unsavedItem.key])
                            {
                                let validatedResult = _internal.validateValue(unsavedItem);
                                if (!validatedResult.isValid)
                                {
                                    _viewState.errors[unsavedItem.key] = [validatedResult.errorMessage];
                                }
                                else
                                {
                                    added.push(unsavedItem);
                                }
                            }
                        });
                        added.forEach(_savedModel.add);
                        // Remove deleted parameters from saved/live model
                        deleted.forEach(_savedModel.remove);

                        _savedModel.massUpdateInProgress = false;
                    },
                    "close": function ()
                    {
                        _self.stopObservingEverything();
                        _self.observe(_view, _events.view.closed);
                        _self.observe(skyward.reporting.prompts.promptCollection, _events.prompts);
                    },
                    "dynamicValues": function (index)
                    {
                        const searchParameter = _unsavedModel.elementAt(index);

                        const validPrompts = skyward.reporting.prompts.promptCollection.findMany(function (prompt)
                        {
                            const parameter = skyward.reporting.currentReportDefinition.AvailableParameters[searchParameter.key];
                            const promptIsSameInputType = prompt.InputType === searchParameter.dataType;
                            const parameterAcceptsPromptType = parameter.isList === (prompt.Type === skyward.reporting.enummaps.PromptTypes.MultipleSelect);
                            return promptIsSameInputType && parameterAcceptsPromptType;
                        });

                        $.ajax({
                            url: skyward.global.virtualDir + "Reporting/Report/GetParameterOptionsByDataType",
                            type: "POST",
                            dataType: "JSON",
                            data: { dataType: searchParameter.dataType, isList: searchParameter.isList }
                        }).then(function (data)
                        {
                            _view.showDynamicValues(searchParameter, validPrompts, data.environmentValues, data.enumOptions);
                        });
                    }
                }
            },
            prompts: {
                "add": function (promptModel)
                {
                    _internal.updatePromptDisplayValues(promptModel.PromptUniqueId, promptModel.Label);
                },
                "model:Label": function (promptModel)
                {
                    _internal.updatePromptDisplayValues(promptModel.PromptUniqueId, promptModel.Label);
                },
                "delete": function (promptModel)
                {
                    _internal.removePromptReferences(promptModel.PromptUniqueId);
                }
            }
        };

        var exposedActions = {
            "toggleButton": function ()
            {
                $(".jsSearchParameterBuilder").toggle(!jQuery.isEmptyObject(skyward.reporting.currentReportDefinition.AvailableParameters));
            },
            "mergeAdd": function (parameters, parameterToAdd)
            {
                if (parameters && parameterToAdd)
                {
                    if (parameters.hasOwnProperty(parameterToAdd.key))
                    {
                        parameters[parameterToAdd.key].required = parameters[parameterToAdd.key].required || parameterToAdd.required;
                    }
                    else
                    {
                        parameters[parameterToAdd.key] = parameterToAdd;
                    }
                }
            },
            "init": function (savedData)
            {
                // Designer uses inline js to fire "init", and this gets triggered on *save*, not just on full-page load,
                //  so currently we can hit this code unexpectedly, when old listeners are already registered.
                _self.stopObservingEverything();

                var savedModels = [];
                (savedData || {}).forEach(function (data)
                {
                    savedModels.push(_internal.makeSearchParameter(data));
                });

                skyward.reporting.searchParameters.model = _savedModel = _internal.makeSearchParameterCollection(savedModels);

                _view.init();
                _self.observe(_view, _events.view.closed);
                _self.observe(skyward.reporting.prompts.promptCollection, _events.prompts);
                return;
            },
            "getErrors": function ()
            {
                return _viewState.errors;
            }
        };
        return exposedActions;
    });
})(skyward || {}, window.jQuery);

;
(function (skyward, $, undefined)
{
    skyward.reporting = skyward.reporting || {};
    skyward.reporting.variables = skyward.reporting.variables || {};

    // Models
    skyward.reporting.variables.newVariableCollectionModel = function (variableCollectionData, lookupTables, reportCanvas)
    {
        var modelCollection = [];
        if (variableCollectionData)
        {
            variableCollectionData.forEach(function (v) { modelCollection.push(skyward.reporting.variables.newVariableModel(v, lookupTables, reportCanvas)); });
        }

        return skyward.mvvm.newModelCollection(modelCollection, {}, {}, function ()
        {
            var self = this;
            return {
                toJsonObject: function ()
                {
                    var results = [];
                    self.forEach(function (variable)
                    {
                        results.push(variable.toJsonObject());
                    });
                    return results;
                },
                getById: function (id)
                {
                    return self.find(function (variable) { return variable.uniqueId === id; });
                },
                idIsValidForAggregateMath: function (id)
                {
                    var variable = self.getById(id);
                    return variable && variable.isValidForAggregateMath();
                },
                nameExists: function (name, uniqueId)
                {
                    name = (name || "").toLowerCase();
                    var nameExists = false;
                    self.forEach(function (variable)
                    {
                        if (variable.uniqueId !== uniqueId && variable.name.toLowerCase() === name)
                        {
                            nameExists = true;
                            return false;
                        }
                    });
                    return nameExists;
                },
                _variableCollectionModel: "variable collection model"
            };
        });
    };

    skyward.reporting.variables.newVariableModel = function (variableData, lookupTables, reportCanvas)
    {
        var defaultValues = {
            uniqueId: "",
            name: "",
            dataTypeCategoryName: skyward.reporting.DATA_TYPES.STRING,
            defaultValue: ""
        };
        variableData = $.extend(defaultValues, variableData);

        return skyward.mvvm.newModel(variableData, undefined, function ()
        {
            var self = this;
            return {
                toJsonObject: function ()
                {
                    var result = {};
                    for (var key in defaultValues)
                    {
                        result[key] = self[key];
                    }
                    return result;
                },
                isInUse: function ()
                {
                    return self.setBy().length !== 0 || self.requiredBy().length !== 0 || self.resetBy().length !== 0;
                },
                isValidForAggregateMath: function ()
                {
                    return lookupTables.aggregateMathValidCategories.indexOf(self.dataTypeCategoryName) !== -1;
                },
                setBy: function ()
                {
                    return reportCanvas.find(".jsColumn[data-variable-id-to-set=" + self.uniqueId + "]");
                },
                requiredBy: function ()
                {
                    return self.gotBy().add(self.referredToBy());
                },
                gotBy: function ()
                {
                    return reportCanvas.find(".jsColumn[data-variable-id-to-get=" + self.uniqueId + "]");
                },
                referredToBy: function ()
                {
                    var variableColumns = self.gotBy();
                    var VARIABLE_COLUMN = skyward.reporting.COLUMN_TYPES.VARIABLE_COLUMN;
                    var CALCULATED_COLUMN = skyward.reporting.COLUMN_TYPES.CALCULATED_COLUMN;

                    var calculatedColumnUsesVariable = function ()
                    {
                        var columnsVisited = [];
                        var checkColumn = function (column)
                        {
                            var jqThis = $(column);
                            // Eliminate circular references
                            var bindingString = jqThis.attr("data-binding-string");
                            if (columnsVisited.indexOf(bindingString) !== -1)
                            {
                                return;
                            }
                            columnsVisited.push(bindingString);

                            var checkBinding = function (binding)
                            {
                                var variableColumnWithMatchingBinding = $(".jsColumn[data-variable-id-to-get='" + self.uniqueId + "'][data-binding-string='" + binding + "']");
                                if (variableColumnWithMatchingBinding.length)
                                {
                                    return true;
                                }

                                var foundVariableInCalculation = false;
                                var calculatedColumnWithMatchingBinding = $("[data-binding-string='" + binding + "'][data-field-column-type='" + CALCULATED_COLUMN + "']");
                                calculatedColumnWithMatchingBinding.each(function ()
                                {
                                    if (checkColumn(this))
                                    {
                                        foundVariableInCalculation = true;
                                    }
                                });
                                return foundVariableInCalculation;
                            };
                            var calculation = jqThis.data("calculation");
                            return checkBinding(calculation.LeftBinding) || checkBinding(calculation.RightBinding);
                        };

                        return checkColumn(this);
                    };
                    var calculatedColumns = reportCanvas.find("[data-field-column-type='" + CALCULATED_COLUMN + "']").filter(calculatedColumnUsesVariable);

                    return calculatedColumns.add(variableColumns);
                },
                resetBy: function ()
                {
                    return reportCanvas.find(".reportLine[data-variable-ids-to-reset*=" + self.uniqueId + "]");
                },
                getBindingString: function ()
                {
                    return "{_variable." + self.uniqueId + "}";
                },
                _variableModel_originalName: self.name,
                _variableModel_originalId: self.uniqueId
            };
        });
    };

    skyward.reporting.variables.init = function (variableCollectionData, view, canvas)
    {
        var templateContainer = view.find(".js-report-variable-templates").detach();
        var templates = {
            collection: templateContainer.find(".js-collection-template>*").detach(),
            item: {
                variable: templateContainer.find(".js-item-template> .variable").detach(),
                checkBoxVariable: templateContainer.find(".js-item-template> .checkBoxVariable").detach()
            },
            icons: templateContainer.find(".js-icon-template").detach(),
            listTarget: view.find(".js-list").clone()
        };

        var reportCanvas = canvas;
        var lookupTableElement = view.find(".dataTypeLookupTables");
        var lookupTables = JSON.parse(lookupTableElement.val());

        skyward.reporting.variables.collectionModel = skyward.reporting.variables.newVariableCollectionModel(variableCollectionData, lookupTables, reportCanvas);
        skyward.reporting.variables.viewModel = newVariableCollectionViewModel(skyward.reporting.variables.collectionModel, view);

        return {
            collectionModel: skyward.reporting.variables.collectionModel,
            viewModel: skyward.reporting.variables.viewModel
        };

        // View-models
        function newVariableViewModel(model, thisView)
        {
            return skyward.mvvm.newModel({ selected: false, checked: false }, { model: model, view: thisView }, function ()
            {
                var self = this;
                var observer = skyward.mvvm.newObserver();

                var nameControl = self.view.find(".js-name");
                var iconControl = self.view.find(".js-icon");
                var checkBox = self.view.find(".variableSelected");

                // Model -> View
                var modelNameChanged = function (val)
                {
                    nameControl.text(val);
                };
                var modelDataTypeCategoryNameChanged = function (val)
                {
                    iconControl.html(templates.icons.filter("[data-for-data-type-category-name='" + val + "']").children().show().clone());
                };
                // ViewModel -> View
                var selectedChanged = function (val)
                {
                    self.view.toggleClass("selected", val);
                };
                // View -> ViewModel
                var click = function ()
                {
                    self.selected = true;
                };
                var toggleCheck = function (checked)
                {
                    var bool = typeof checked === "boolean";

                    if (bool ? checked : !self.checked)
                    {
                        self.checked = true;
                    }
                    else
                    {
                        self.checked = false;
                    }

                    checkBox.prop("checked", self.checked);
                };

                observer.observe(model, "name", modelNameChanged);
                observer.observe(model, "dataTypeCategoryName", modelDataTypeCategoryNameChanged);
                observer.observe(self, "selected", selectedChanged);
                self.view.on("click", click);
                self.view.on("click", ".variableSelected", toggleCheck);

                modelNameChanged(model.name);
                modelDataTypeCategoryNameChanged(model.dataTypeCategoryName);

                self.view.data({ model: model, viewModel: self });

                var exposed = {
                    destroy: function ()
                    {
                        observer.stopObservingEverything();
                        return self.view.off().remove();
                    },
                    toggleCheck: function (checked)
                    {
                        toggleCheck(checked);
                    },
                    _variableViewModel_OriginalName: self.model.name,
                    _variableViewModel_OriginalId: self.model.uniqueId
                };

                return exposed;
            });
        }

        function newVariableCollectionViewModel(thisCollectionModel, thisView, options)
        {
            return skyward.mvvm.newModelCollection([], { collectionModel: thisCollectionModel, selectedModel: null }, { options: options, view: thisView }, function ()
            {
                var self = this;
                var options = this.options || {};
                var selectedViewModel = null;
                var observer = skyward.mvvm.newObserver();
                var filter = !options.dataTypeCategories ?
                    function () { return true; } : function (v) { return options.dataTypeCategories.indexOf(v.dataTypeCategoryName) !== -1; };

                var itemTemplate = options.useCheckBox === true ? templates.item.checkBoxVariable : templates.item.variable;
                var collectionView = templates.collection.clone();
                self.view.find(".js-list").replaceWith(collectionView);

                // View -> ViewModel
                var addClicked = function ()
                {
                    getNewVariableModel("Add Variable", options.dataTypeCategoryOnAdd)
                        .then(function (newModel)
                        {
                            return editVariable(self.collectionModel, newModel, "Add Variable");
                        })
                        .done(function (newModel)
                        {
                            if (newModel !== null)
                            {
                                self.collectionModel.add(newModel);
                            }
                        });
                };
                var editClicked = function ()
                {
                    editVariable(self.collectionModel, self.selectedModel, null, self.selectedModel.isInUse());
                };
                var deleteClicked = function ()
                {
                    self.collectionModel.remove(self.selectedModel);
                };
                var insertRequested = function (viewModel)
                {
                    self.announce("insertRequested", selectedViewModel.model, selectedViewModel.view);
                };
                const usageLocationsClicked = function ()
                {
                    self.announce("openUsageLocations", selectedViewModel.model);
                };
                // ViewModel -> View
                var selectedModelChanged = function (selectedModel, oldSelectedModel)
                {
                    if (selectedModel === oldSelectedModel)
                    {
                        return;
                    }
                    self.view.find(".js-selectedModel").toggleClass("ui-disabled", !selectedModel);
                    updateVariableUsageLocations();

                    // ViewModel -> ItemViewModels
                    self.isMuted = true;
                    self.forEach(function (itemViewModel)
                    {
                        itemViewModel.selected = itemViewModel.model === selectedModel;
                    });
                    self.isMuted = false;
                };
                // Model -> ViewModel
                var itemAdded = function (model)
                {
                    if (!filter(model))
                    {
                        return;
                    }
                    var itemView = itemTemplate.clone().appendTo(collectionView);

                    var itemViewModel = newVariableViewModel(model, itemView);
                    self.add(itemViewModel);
                    itemViewModel.selected = true;
                    return;
                };
                var itemRemoved = function (removedModel)
                {
                    var viewModel = self.find(function (i) { return i.model === removedModel; });
                    if (!viewModel)
                    {
                        return;
                    }

                    var viewModelIndex = self.indexOf(viewModel);
                    self.remove(viewModel).destroy();

                    if (viewModelIndex < self.length)
                    {
                        self.elementAt(viewModelIndex).selected = true;
                    }
                    else if (self.length !== 0)
                    {
                        self.elementAt(viewModelIndex - 1).selected = true;
                    }
                    else
                    {
                        self.selectedModel = null;
                    }
                };
                // ItemViewModel -> ViewModel
                var itemViewModelSelected = function (changingViewModel)
                {
                    if (changingViewModel.selected)
                    {
                        selectedViewModel = changingViewModel;
                        self.selectedModel = changingViewModel.model;
                    }
                    else
                    {
                        self.selectedModel = null;
                        selectedViewModel = null;
                    }
                };

                const updateVariableUsageLocations = function ()
                {
                    if (self.selectedModel)
                    {
                        const usageLocationsButton = self.view.find(".usage_locations");
                        if (usageLocationsButton.length !== 0)
                        {
                            usageLocationsButton.toggleClass("ui-disabled", !self.selectedModel.isInUse());
                        }
                    }
                };

                // bind up
                self.view.on("click", ".add_variable:not(.ui-disabled)", null, addClicked);
                self.view.on("click", ".edit_variable:not(.ui-disabled)", null, editClicked);
                self.view.on("click", ".delete_variable:not(.ui-disabled)", null, deleteClicked);
                self.view.on("click", ".usage_locations:not(.ui-disabled)", null, usageLocationsClicked);
                self.view.on("dblclick", ".selected", null, insertRequested);
                observer.observe(self, "model:selected", itemViewModelSelected);
                observer.observe(self, "model:dblclick", insertRequested);
                observer.observe(self, "selectedModel", selectedModelChanged);
                observer.observe(self.collectionModel, "add", itemAdded);
                observer.observe(self.collectionModel, "remove", itemRemoved);

                // add items
                self.collectionModel.forEach(itemAdded);

                if (options.additionalEntries)
                {
                    $.each(options.additionalEntries, function (i, v) { itemAdded(v); });
                }
                // select first entry
                if (self.length > 0)
                {
                    self.elementAt(0).selected = true;
                }

                var exposed = {
                    destroy: function ()
                    {
                        self.forEach(function (variableViewModel)
                        {
                            variableViewModel.destroy();
                        });
                        observer.stopObservingEverything();

                        return self.view.off().remove();
                    },
                    observe: observer.observe,
                    getIcon: function (variable)
                    {
                        return templates.icons.filter("[data-for-data-type-category-name='" + variable.dataTypeCategoryName + "']").clone();
                    },
                    selectVariableToSet: function (dataTypeCategoryName, anchorTo, newVariableName, allowAddNewVar = true)
                    {
                        restrictToCategories = lookupTables.categoriesThatCanBeSetByCategory[dataTypeCategoryName];
                        return selectVariableToSet(self.collectionModel, restrictToCategories, dataTypeCategoryName, anchorTo, newVariableName, allowAddNewVar);
                    },
                    selectVariablesToReset: function (variablesToResetElement, variablesIDsToReset, variablesToResetViewModel)
                    {
                        return selectVariablesToReset(self.collectionModel, variablesToResetElement, variablesIDsToReset, variablesToResetViewModel);
                    },
                    getVariableViewModel: function (uniqueID)
                    {
                        var variableViewModule;
                        self.forEach(function (value)
                        {
                            if (value.model.uniqueId === uniqueID)
                            {
                                variableViewModule = value;
                                return false;
                            }
                        });
                        return variableViewModule;
                    },
                    updateVariableUsageLocations: function ()
                    {
                        updateVariableUsageLocations();
                    },
                    _variableCollectionViewModel: options.name || "no name"
                };
                return exposed;
            });
        }

        function selectVariableToSet(collectionModel, restrictToTypes, dataTypeCategoryName, anchorTo, newVariableName, allowAddNewVar = true)
        {
            var waitForSelection = $.Deferred();

            restrictToTypes = restrictToTypes || [];
            restrictToTypes.push("null"); // This prevents filtering out the model for "Do not set a variable."

            var selectorView = $("<div/>").append(templates.listTarget.clone());
            var viewModelOptions = {
                dataTypeCategories: restrictToTypes,
                dataTypeCategoryOnAdd: dataTypeCategoryName,
                additionalEntries: [skyward.reporting.variables.newVariableModel({ name: "Do not set a variable", dataTypeCategoryName: "null", uniqueId: "" }, lookupTables, reportCanvas)],
                name: "Selector"
            };
            var selectorViewModel = newVariableCollectionViewModel(collectionModel, selectorView, viewModelOptions);
            selectorViewModel.view.find(".treebrowserow, .treebrowse").removeClass("treebrowserow treebrowse");
            selectorViewModel.view.on("dblclick", ".selected", null, function () { confirmSelection(); });

            var addingNewVariable = false;
            var addVariableAndSetSelector = function ()
            {
                addingNewVariable = true;
                modalLayer.close();

                getNewVariableModel(newVariableName || "Add Variable", dataTypeCategoryName)
                    .then(function (newModel)
                    {
                        return editVariable(collectionModel, newModel, "Add Variable", false, restrictToTypes);
                    })
                    .done(function (newModel)
                    {
                        if (newModel !== null)
                        {
                            collectionModel.add(newModel);
                            waitForSelection.resolve(newModel);
                        }
                        else
                        {
                            waitForSelection.reject();
                        }
                    });
            };
            var confirmSelection = function ()
            {
                waitForSelection.resolve(selectorViewModel.selectedModel);
                modalLayer.close();
            };
            var layerClosed = function ()
            {
                if (!addingNewVariable && waitForSelection.state() === "pending")
                {
                    waitForSelection.reject();
                }
                selectorViewModel.destroy();
            };

            var addButton = { text: "Add Variable", icon: "AddPlus", click: addVariableAndSetSelector };
            var okButton = { text: "Save", icon: "Save", click: confirmSelection };
            var cancelButton = { text: "Cancel", icon: "Cancel", click: "close" };
            var buttons = [];
            if (allowAddNewVar)
            {
                buttons.push(addButton);
            }
            buttons.push(okButton, cancelButton);
            var options = {
                afterClose: layerClosed,
                closeOnClick: false,
                anchorTo: anchorTo
            };
            var modalLayer = skyward.modalLayer.showDialog("Select a Variable", selectorView, buttons, options);

            return waitForSelection.promise();
        }

        function selectVariablesToReset(collectionModel, element, variablesIDsToReset, variablesToResetViewModel)
        {
            var selectorView = $("<div/>").append(templates.listTarget.clone());
            var viewModelOptions = {
                useCheckBox: true
            };
            if (!variablesToResetViewModel.length)
            {
                variablesToResetViewModel = newVariableCollectionViewModel(collectionModel, selectorView, viewModelOptions);
            }

            collectionModel.forEach(function (value)
            {
                variablesToResetViewModel.getVariableViewModel(value.uniqueId).toggleCheck(false);
            });

            variablesIDsToReset.forEach(function (value)
            {
                variablesToResetViewModel.getVariableViewModel(value).toggleCheck(true);
            });

            element.find(".js-list").replaceWith(variablesToResetViewModel.view);

            return variablesToResetViewModel;
        }

        function loadEditorTemplate()
        {
            return $.when(
                templates.editor ||
                $.ajax({
                    url: skyward.global.virtualDir + "Reporting/Report/GetVariableEditorTemplate/",
                    type: "POST",
                    dataType: "JSON",
                    success: function (data)
                    {
                        templates.editor = $(data.editor)
                    }
                }));
        }

        function getDefaultValueInputForType(defaultValueInputs, dataType)
        {
            return defaultValueInputs.find(`.js-defaultValueInput[data-default-value-data-type='${dataType}']`);
        }

        // Shared functionality
        function getNewVariableModel(name, dataTypeCategoryName)
        {
            var waitForServer = $.Deferred();
            $.ajax(skyward.global.virtualDir + "Reporting/Report/NewVariableId",
                {
                    type: "POST",
                    dataType: "JSON",
                    data: { name: name, dataTypeCategoryName: dataTypeCategoryName },
                    success: function (data)
                    {
                        waitForServer.resolve(skyward.reporting.variables.newVariableModel(data, lookupTables, reportCanvas), "Add Variable");
                    }
                }).fail(waitForServer.reject);
            return waitForServer.promise();
        }

        function editVariable(collectionModel, model, popupTitle, isInUse, restrictToTypes)
        {
            popupTitle = popupTitle || "Edit Variable";
            const waitForEditor = $.Deferred();

            loadEditorTemplate()
                .then(function ()
                {
                    let modalLayer;
                    const editor = templates.editor.clone();
                    const nameInput = editor.find(".js-name");
                    const dataTypeInput = editor.find(".js-dataTypeCategoryName");
                    const defaultValueInputs = editor.find(".js-defaultValueInputs");
                    const dataTypeChangeHandler = function ()
                    {
                        defaultValueInputs.find(".js-defaultValueInput").each(async function ()
                        {
                            const self = $(this);
                            skyward.controls.hide(self, false);
                            // Vue rendered controls cannot be updated until the DOM has loaded them (they are client rendered)
                            await modalLayer?.bodyPromise;
                            skyward.controls.clearValue(self);                            
                        });

                        let defaultValueInput = getDefaultValueInputForType(defaultValueInputs, dataTypeInput.val());
                        skyward.controls.show(defaultValueInput, false);
                        skyward.controls.setValue(defaultValueInput, model.defaultValue);
                    }

                    skyward.window.notifyDOMLoad(editor);

                    nameInput.val(model.name);
                    dataTypeInput.on("change", dataTypeChangeHandler);
                    skyward.controls.setValue(dataTypeInput, model.dataTypeCategoryName);

                    if (isInUse)
                    {
                        dataTypeInput.addClass("ui-disabled").get(0).disabled = true;
                    }
                    if (restrictToTypes)
                    {
                        dataTypeInput.children().filter(function (i, e) { return restrictToTypes.indexOf($(e).val()) === -1; }).remove();
                    }

                    let okClicked = function ()
                    {

                        let name = nameInput.val();
                        let errors = {};

                        if (!Boolean(name))
                        {
                            errors["variableName"] = ["Name is a required field."];
                        }

                        if (collectionModel.nameExists(name, model.uniqueId))
                        {
                            errors["variableName"] = ["This name is already in use."];
                        }

                        if (!$.isEmptyObject(errors))
                        {
                            skyward.validation.displayValidationMessages({ errors: errors }, modalLayer.content, $());
                            return;
                        }
                        else
                        {
                            model.name = name;
                            model.dataTypeCategoryName = dataTypeInput.val();
                            //defaultValue does not need to be encoded currently. It will be encoded before being posted on save.
                            model.defaultValue = skyward.controls.getUnencodedValue(getDefaultValueInputForType(defaultValueInputs, dataTypeInput.val()));
                            waitForEditor.resolve(model);
                        }
                        modalLayer.close();
                    };
                    let layerClosed = function ()
                    {
                        if (waitForEditor.state() === "pending")
                        {
                            waitForEditor.reject();
                        }
                    };
                    let okButton = { text: "Save", "icon": "Save", "click": okClicked };
                    let cancelButton = { text: "Cancel", "icon": "Cancel", "click": "close" };
                    modalLayer = skyward.modalLayer.showDialog(popupTitle, editor, [okButton, cancelButton], { afterClose: layerClosed, closeOnClick: false });
                    modalLayer.bodyPromise.done(function ()
                    {
                        nameInput.focus();
                    });
                });
            return waitForEditor.promise();
        }
    };
}(window.skyward = window.skyward || {}, window.jQuery));;
(
    function (skyward, $)
    {
        "use strict";
        skyward.reporting.treebrowse = skyward.reporting.treebrowse || {};


        skyward.reporting.treebrowse.getTreeBrowse = function (data, calculatedFieldData, valueBox, ajaxURL, options)
        {
            var defaults = {
                title: "Select Field",
                triggerChange: true,
                modalLayerOptions: {}
            };
            options = $.extend({}, defaults, options);

            var treeBrowsePopup;

            var requestFieldColumnPopup = function ()
            {
                data.mode = "report";
                return $.ajax(skyward.global.virtualDir + ajaxURL,
                    {
                        type: "POST",
                        dataType: "HTML",
                        data: data,
                        dataFilter: function (html)
                        {
                            return "<div style='max-height: 500px'>" + html + "</div>";
                        }
                    });
            };

            var saveButtonClicked = function ()
            {
                const selectedData = skyward.treebrowse.getSelectedFieldData(treeBrowsePopup.content);
                if (selectedData)
                {
                    const baseData =
                    {
                        fieldType: selectedData.fieldType,
                        fieldPath: null,
                        dataObjectFullName: selectedData.dataObjectFullName,
                        displayName: selectedData.displayName,
                        isCalculated: selectedData.isCalculated,
                        isOperation: selectedData.isOperation,
                        parameters: selectedData.parameters
                    };
                    if (selectedData.absoluteFieldPath)
                    {
                        setValueControl(valueBox, selectedData.displayPathText, $.extend({ fieldName: selectedData.absoluteFieldPath }, baseData), selectedData.svgClass);
                    }
                    else if (selectedData.fieldName && !selectedData.isCalculatedField)
                    {
                        const correctedFieldName = selectedData.fieldName.substring(selectedData.fieldName.indexOf(".") + 1);

                        setValueControl(valueBox, selectedData.displayPathText, $.extend({ fieldName: correctedFieldName }, baseData), selectedData.svgClass);
                    }
                    else if (selectedData.id)
                    {
                        setValueControl(valueBox, selectedData.displayPathText, $.extend({ calculatedFieldName: selectedData.id }, baseData), selectedData.svgClass);
                    }
                }

                skyward.window.closePopup(treeBrowsePopup, "save");
            };

            var setValueControl = function (valueControl, displayValue, fieldData, svgClass)
            {
                valueControl.setAllDataToNull();
                valueControl.text("");
                valueControl.removeClass("hidden");

                if (fieldData.fieldType && fieldData.fieldType.indexOf("Enum") >= 0)
                {
                    fieldData.enumType = fieldData.fieldType;
                }

                valueControl.data(fieldData);
                const text = $("<span/>").addClass('fieldSelectorText').text(displayValue);

                if (svgClass)
                {
                    const svg = skyward.svg.getSvg(svgClass, "TreeBrowse");
                    const svgHolder = $("<span/>").addClass("svgHolder");
                    svgHolder.html(svg);
                    valueControl.append(svgHolder).append(text);
                }
                else
                {
                    valueControl.text(displayValue);
                }

                if (options.triggerChange)
                {
                    valueControl.trigger("change");
                }
            };

            var treeBrowseChanged = function (event, data)
            {
                var saveButton = treeBrowsePopup.footer.find(".filterSaveButton");
                var saveButtonTextSpan = saveButton.find(".modalContentFooter__buttonText");

                saveButton.data("treeBrowseData", data);

                if (data.isDataField)
                {
                    saveButtonTextSpan.text("Select Field");
                    saveButton.show();
                }
                else if (data.isCalculatedField)
                {
                    saveButtonTextSpan.text("Select Calculated Field");
                    saveButton.show();
                }
                else
                {
                    saveButton.hide();
                }
            };

            var modalLayerPromise = $.Deferred();
            requestFieldColumnPopup().done(function (contents)
            {
                var saveButton = { text: "Select Field", click: saveButtonClicked, icon: "Save", additionalClasses: ["filterSaveButton"] };
                var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };
                var modalLayerOptions = $.extend({ animationDuration: 0, draggable: true, closeOnClick: false }, options.modalLayerOptions);
                var jqContents = $(contents);
                var buttons = [saveButton, cancelButton];

                treeBrowsePopup = skyward.modalLayer.showDialog(options.title, jqContents, buttons, modalLayerOptions);
                treeBrowsePopup.animationPromise.done(function ()
                {
                    treeBrowsePopup.content.on("treeBrowseLevelChanged", treeBrowseChanged).on("treeBrowseRowChange", treeBrowseChanged);
                    treeBrowsePopup.content.on("treeBrowseSave", saveButtonClicked);

                    if (data.includeCalculatedFields)
                    {
                        treeBrowsePopup.content.one("treeBrowseInitialize", function (_event, treeBrowseData)
                        {
                            var validCalculatedFields = data.fieldDataType === undefined ?
                                skyward.reporting.calculatedFields.AllFields() : skyward.reporting.calculatedFields.AllFieldsOfType(data.fieldDataType);
                            skyward.calculatedFieldList.updateCalculatedFieldList(
                                treeBrowseData,
                                Object.values(validCalculatedFields),
                                undefined,
                                calculatedFieldData.calculatedFieldRootModule || data.rootModule,
                                calculatedFieldData.calculatedFieldRootObject || data.rootObject,
                                calculatedFieldData.calculatedFieldRelationshipPath,
                                undefined
                            );
                        });
                    }

                    modalLayerPromise.resolve(treeBrowsePopup);
                });
            });
            return modalLayerPromise.promise();
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        /**
         * @typedef {import("./types/skyward/reporting").PanelData} PanelData
         * @typedef {import("./types/skyward/reporting").ReportFieldProps} ReportFieldProps
         * @typedef {import("./types/skyward/reporting").SelectFieldHandler} SelectFieldHandler
         */

        "use strict";
        skyward.reporting = skyward.reporting || {};

        var _reportDesignerObserver = skyward.mvvm.newObserver(); // This is a temporary implementation of just the observer/observable portion of the new MVVM framework

        const CalculatedFields_Model = skyward.reporting.calculatedFields;

        skyward.reporting.currentReportDefinition = {}; // before long we should make this a model

        /**
         * For requesting fields in use in the report
         */
        skyward.reporting.fields = (function ()
        {
            const exposedMethods =
            {
                buildFieldListByModuleAndObject: function (schemaObject, relationshipPath, removeCalculatedInCSharpFields, removeColumnGroups, convertImages = true)
                {
                    const sections = getSectionsByModuleAndObject(schemaObject, relationshipPath);
                    if (sections.length)
                    {
                        return getUniqueFieldsForSections(sections, removeCalculatedInCSharpFields, removeColumnGroups, convertImages);
                    }
                    return [];
                },
                buildFieldsList: function (filterFields, sectionID, removeCalculatedInCSharpFields, removeColumnGroups, convertImages = true)
                {
                    const section = getSectionElementBySectionID(sectionID);
                    if (section.length)
                    {
                        return getUniqueFields(section, filterFields, removeCalculatedInCSharpFields, removeColumnGroups, convertImages);
                    }
                    return [];
                },
                buildFieldsListOfType: function (fieldDataType, filterFields, sectionID, removeCalculatedInCSharpFields, removeColumnGroups, convertImages = true)
                {
                    const section = getSectionElementBySectionID(sectionID);
                    if (section.length)
                    {
                        let fieldsOfType = getUniqueFields(section, filterFields, removeCalculatedInCSharpFields, removeColumnGroups, convertImages);

                        fieldsOfType = fieldsOfType.filter((field) =>
                        {
                            return dataTypesAreComparable(field.fieldType, fieldDataType);
                        });

                        return fieldsOfType;
                    }
                    return [];
                },
                buildCalculatedFieldsList: function (calculatedFields)
                {
                    let convertedFields = [];

                    calculatedFields.forEach((field) =>
                    {
                        const convertedField =
                        {
                            id: field.id,
                            calculatedFieldName: field.fieldName,
                            isCalculatedField: true,
                            fieldType: field.dataType,
                            displayName: field.fieldName,
                            displayPathText: field.fieldName,
                            svgClass: skyward.reporting.getSvgNameByDataType(field.dataType)
                        };

                        convertedFields.push(convertedField);
                    });

                    return convertedFields
                }
            };

            function getFieldsInSection(section, includeFilters, convertImages)
            {
                return skyward.reporting.getFieldsUsedInSection(section, includeFilters, convertImages);
            }

            function getUniqueFieldsForSections(sections, removeCalculatedInCSharpFields, removeColumnGroups, convertImages)
            {
                let fieldsInSections = [];

                sections.forEach(function (section)
                {
                    const fieldsInSection = getFieldsBySection(section, [], removeCalculatedInCSharpFields, removeColumnGroups, convertImages)
                    fieldsInSections.push(...fieldsInSection);
                });

                return filterOutDuplicateFields(fieldsInSections);
            }

            function getUniqueFields(section, filterFields, removeCalculatedInCSharpFields, removeColumnGroups, convertImages)
            {
                const fieldsInSection = getFieldsBySection(section, filterFields, removeCalculatedInCSharpFields, removeColumnGroups, convertImages);
                return filterOutDuplicateFields(fieldsInSection);
            }

            function getFieldsBySection(section, filterFields, removeCalculatedInCSharpFields, removeColumnGroups, convertImages)
            {
                const includeFilters = filterFields.length == 0;
                const fieldsInSection = [...getFieldsInSection(section, includeFilters, convertImages), ...filterFields];
                let fieldsToReturn = [];

                for (let field of fieldsInSection)
                {
                    // Column Groups have isCalculated set to true so they will also be removed by this check
                    if (removeCalculatedInCSharpFields && field.isCalculated)
                    {
                        continue;
                    }
                    if (removeColumnGroups && field.isColumnGroup)
                    {
                        continue;
                    }
                    fieldsToReturn.push(field);
                }

                return fieldsToReturn;
            }

            function filterOutDuplicateFields(fieldsInSection)
            {
                //filtering out duplicates based on unique absoluteFieldPaths, since it's the property that can be expected to be the same no matter what type of report element the field came from
                //It is expected that column groups will have the absoluteFieldPath set to it's fieldPath before we get here, since it normally won't have an absolute field path
                const fieldKey = 'absoluteFieldPath';
                fieldsInSection = [...new Map(fieldsInSection.map(item => [item[fieldKey], item])).values()];
                return fieldsInSection;
            }

            return exposedMethods;
        })();

        /**
         * Keeps track of the columns the user has currently selected
         */
        const currentSelectedColumns =
        {
            selectedColumnMap: new Map(),
            getColumnID: function (column)
            {
                return column.data("columnId");
            },
            addSelectedClass: function (column)
            {
                column.addClass("ui-selected");
            },
            removeSelectedClass: function (column)
            {
                column.removeClass("ui-selected");
            },
            getFirstSelectedColumn: function ()
            {
                return this.selectedColumnMap.values().next().value;
            },
            getLastSelectedColumn: function ()
            {
                return Array.from(this.getCurrentSelectedColumns()).pop();
            },
            getCurrentSelectedColumns: function ()
            {
                return this.selectedColumnMap.values();
            },
            getRowByFirstSelectedColumn: function ()
            {
                if (this.areColumnsSelected())
                {
                    return this.getFirstSelectedColumn().parent();
                }

                return null;
            },
            getRowByLastSelectedColumnBySectionID: function (sectionID)
            {
                if (this.areColumnsSelected())
                {
                    for (const column of Array.from(this.getCurrentSelectedColumns()).reverse())
                    {
                        const line = column.parent();
                        const section = line.closest(".jsSection");
                        const lineSectionID = section.data("sectionId");

                        if (lineSectionID == sectionID)
                        {
                            return line;
                        }
                    }
                }

                return null;
            },
            toggleColumn: function (column)
            {
                const columnID = this.getColumnID(column);
                if (!this.isColumnSelected(column))
                {
                    this.selectedColumnMap.set(columnID, column);
                    this.addSelectedClass(column);
                }
                else if (this.selectedColumnMap.size > 1) //prevent ctrl click from unselecting when only 1 column
                {
                    this.removeSelectedClass(column);
                    this.selectedColumnMap.delete(columnID);
                    updateColumnIsHiddenConditionFormatting(column);
                }
                this.runActionOnSelected(updateColumnIsHiddenConditionFormatting);
            },
            delete: function (column)
            {
                const columnID = this.getColumnID(column);
                this.selectedColumnMap.delete(columnID);
            },
            clear: function ()
            {
                let columns = Array.from(this.selectedColumnMap.values());
                this.selectedColumnMap.clear();

                for (let column of columns)
                {
                    this.removeSelectedClass(column);
                    updateColumnIsHiddenConditionFormatting(column);
                }
            },
            isColumnSelected: function (column)
            {
                const columnID = this.getColumnID(column);
                return this.selectedColumnMap.has(columnID);
            },
            isSingleColumnSelected: function ()
            {
                return this.selectedColumnMap.size == 1;
            },
            areColumnsSelected: function ()
            {
                return this.selectedColumnMap.size > 0;
            },
            areMultipleColumnsSelected: function ()
            {
                return this.selectedColumnMap.size > 1;
            },
            areColumnsSelectedAllOnOneLine: function ()
            {
                let firstFoundLineID = null;
                for (const column of this.getCurrentSelectedColumns())
                {
                    const lineID = column.parent().data("lineId");
                    if (!firstFoundLineID)
                    {
                        firstFoundLineID = lineID
                    }
                    else if (firstFoundLineID != lineID)
                    {
                        return false;
                    }
                }

                return this.selectedColumnMap.size > 0;
            },
            runActionOnSelected: function (action)
            {
                this.selectedColumnMap.forEach((column) =>
                {
                    action(column);
                });
            }
        };

        //Keyboard controls
        const keyboardCommands = (function ()
        {
            const exposedCommands =
            {
                isMultiSelectKeyPressed: (event) => isActionModifierKeyPressed(event),
                isSmartDragKeyPressed: (event) => isActionModifierKeyPressed(event),
                isSmartResizeKeyPressed: (event) => isActionModifierKeyPressed(event),
                isMoveToLeftColumnPressed: (event) => getEventKeys(event).ARROW_LEFT,
                isMoveToUpColumnPressed: (event) => getEventKeys(event).ARROW_UP,
                isMoveToRightColumnPressed: (event) => getEventKeys(event).ARROW_RIGHT,
                isMoveToDownColumnPressed: (event) => getEventKeys(event).ARROW_DOWN,
                isDeleteColumnPressed: (event) =>
                {
                    const eventKeys = getEventKeys(event);
                    return eventKeys.DELETE || eventKeys.BACKSPACE;
                },
                isColumnKeyPressed: (event) =>
                {
                    const eventKeys = getEventKeys(event);
                    return eventKeys.ARROW_LEFT || eventKeys.ARROW_UP || eventKeys.ARROW_RIGHT || eventKeys.ARROW_DOWN || eventKeys.DELETE || eventKeys.BACKSPACE;
                },
                isDeletePromptPressed: (event) =>
                {
                    const eventKeys = getEventKeys(event);
                    return eventKeys.BACKSPACE || eventKeys.DELETE;
                },
            };

            function isActionModifierKeyPressed(event)
            {
                const eventKeys = getEventKeys(event);
                return eventKeys.CTRL || eventKeys.META;
            }

            function getEventKeys(event)
            {
                return skyward.keys.getKeyNamesFromEvent(event);
            }

            return exposedCommands;
        })();

        const FORMATTER_NAMES = {
                // this is not a complete list, only those we need to reference in javascript
                DEFAULT: "Default",
                COPY_FIELD: "CopyField"
            },
            COLUMN_TYPES = skyward.reporting.COLUMN_TYPES = {
                HEADER_COLUMN: 'Skyward.Business.Reporting.HeaderColumn, Skyward.Business',
                FOOTER_COLUMN: 'Skyward.Business.Reporting.FooterColumn, Skyward.Business',
                AGGREGATE_COLUMN: 'Skyward.Business.Reporting.ReportAggregate, Skyward.Business',
                TEXT_COLUMN: 'Skyward.Business.Reporting.TextColumn, Skyward.Business',
                FORMTEXT_COLUMN: 'Skyward.Business.Reporting.FormTextColumn, Skyward.Business',
                IMAGE_COLUMN: 'Skyward.Business.Reporting.ReportImage, Skyward.Business',
                DATA_COLUMN: 'Skyward.Business.Reporting.DataColumn, Skyward.Business',
                DYNAMIC_IMAGE_COLUMN: 'Skyward.Business.Reporting.DynamicImageColumn, Skyward.Business',
                PAGE_SECTION_COLUMN: 'Skyward.Business.Reporting.PageSectionColumn, Skyward.Business',
                CALCULATED_COLUMN: 'Skyward.Business.Reporting.CalculatedColumn, Skyward.Business',
                GROUP_COLUMN: 'Skyward.Business.Reporting.GroupColumn, Skyward.Business',
                GROUP_COLUMN_HEADER: 'Skyward.Business.Reporting.GroupColumnHeader, Skyward.Business',
                GROUP_COLUMN_AGGREGATE: 'Skyward.Business.Reporting.GroupColumnAggregate, Skyward.Business',
                VARIABLE_COLUMN: 'Skyward.Business.Reporting.VariableColumn, Skyward.Business',
                FUTURE_VALUE_COLUMN: 'Skyward.Business.Reporting.FutureValueColumn, Skyward.Business',
            },
            LINE_TYPES = {
                DATA_LINE: 'Skyward.Business.Reporting.DataLine, Skyward.Business',
                HEADER_LINE: 'Skyward.Business.Reporting.HeaderLine, Skyward.Business',
                FOOTER_LINE: 'Skyward.Business.Reporting.FooterLine, Skyward.Business',
                AGGREGATE_LINE: 'Skyward.Business.Reporting.AggregateLine, Skyward.Business',
                SORT_AGGREGATE_LINE: 'Skyward.Business.Reporting.SortAggregateLine, Skyward.Business',
                SORT_HEADER_LINE: 'Skyward.Business.Reporting.SortHeaderLine, Skyward.Business'
            },
            SECTION_TYPES = {
                MAIN_SECTION: "Skyward.Business.Reporting.ReportSection, Skyward.Business",
                DETAIL_SECTION: "Skyward.Business.Reporting.DetailSection, Skyward.Business",
            },
            ADDITIONAL_TYPES = {
                TREE_BROWSE_FILTER: "Skyward.Web.Areas.Reporting.Controllers.ReportController+ReportingTreeBrowseFilter"
            },
            RESET_ON_TYPES = {
                NEVER_RESET: "_neverReset",
                MAIN_SECTIONS: "_mainSections",
                SECTION: "Section"
            },
            DATA_TYPES = skyward.reporting.DATA_TYPES = {
                NUMBER_DECIMAL: "Number Decimal",
                NUMBER_LONG: "Number Long",
                STRING: "String",
                BOOLEAN: "Boolean",
                DATETIME: "DateTime",
                TIME: "Time",
                TIMESPAN: "TimeSpan",
                GROUP_COLUMN: "Group Column"
            },
            PAGE_SECTION_COLUMN_DISPLAY_TYPES = {
                LABEL: "Label",
                DISPLAY_VALUE: "DisplayValue",
                PROMPT_VALUE: "PromptValue"
            },
            BARCODE_FONT_NAME = "Barcode39",
            HIDDEN_CLASS = "reportDesignerHidden",
            ALWAYS_HIDDEN_CLASS = "reportDesignerAlwaysHidden",
            CONDITIONALLY_HIDDEN_CLASS = "reportDesignerConditionallyHidden",
            ALWAYS_HIDDEN_VALUE = 2,
            CONDITIONALLY_HIDDEN_VALUE = 1,
            NOT_HIDDEN_VALUE = 0,
            MAX_COLUMN_WIDTH = 10000,
            MAX_COLUMN_HEIGHT = 10000,
            DEFAULT_COLUMN_WIDTH = 150,
            DEFAULT_COLUMN_HEIGHT = 18,
            SINGLE_LINE_HEADER_INDEX_BINDING = "{Index}";

        let defaultDataFont = "",
            defaultDataFontSize = "",
            defaultDataForeColor = "#000000",
            defaultDataBackColor = "",
            defaultDataFontBold = "",
            defaultDataFontItalic = "",
            defaultDataFontUnderline = "",
            defaultColumnPadding = "",
            underlineCssClass = "",
            boldCssClass = "",
            italicCssClass = "",
            reportDesignerProperties,
            columnWidth,
            columnHeight,
            lineHeight,
            editorColumnText,
            editorVariableToSet,
            editorMediaId,
            editorUseSystemLogo,
            columnDataPath,
            seekToColumnFieldButton,
            editorAggregateType,
            editorAggregateDelimiter,
            editorAggregateDelimiterContainer,
            pageSectionColumnDisplayTypeFS,
            pageSectionColumnDisplayType,
            pageSectionColumnPromptDisplayType,
            groupColumnSortHeaderTypes,
            positionX,
            positionY,
            editorPrintAtBottomOfPage,
            editorPrintReportFooterOnNewPage,
            editorRepeatLineAfterStart,
            editorRepeatRowOnPageIfDetailsPresent,
            editorRepeatHeaderForEachDataRow,
            editorVariablesToReset,
            editorPageBreakBeforeSectionPrints,
            editorDefaultSubjects,
            isHiddenSelector,
            whenHiddenOption,
            dataFont,
            dataForeColor,
            dataBackgroundColor,
            dataFontSize,
            rotationValue,
            rotationRange,
            dataBold,
            dataItalic,
            dataUnderline,
            dataFormatPreview,
            dataTextFormat,
            formatterControlsData,
            formatterControlsDataMap,
            borderStyle,
            borderTop,
            borderBottom,
            borderLeft,
            borderRight,
            borderWidth,
            borderColor,
            editorTextAlign,
            editorVerticalAlign,
            editorPaddingBottom,
            editorPaddingTop,
            editorPaddingRight,
            editorPaddingLeft,
            editorPrintIfEmpty,
            editorDisplayOnSingleLine,
            singleLineRecordCountFieldSetTemplate,
            editorEmptyLinesToPrint,
            editorColumnFilter,
            editorColumnFilterInput,
            editorColumnFilterLaunchButton,
            editorSectionAndLineDisplayName,
            sectionAndLineFullName,
            resetSectionAndLineDisplayName,
            runningTotal,
            resetOption,
            overlapMode,
            designer,
            changeTracker,
            leftSidePanel,
            usedFieldsMenu,
            allFieldsMenu,
            calculatedFieldMenu,
            aggregateFieldsMenu,
            promptFieldsMenu,
            environmentVariableFieldsMenu,
            variablesMenu,
            specialFieldsMenu,
            xmlExportSettingsMenu,
            csvExportSettingsMenu,
            fixedWidthExportSettingsMenu,
            jsonExportSettingsMenu,
            entireCanvas,
            currentRow,
            enumMaps,
            booleanAggregateOptions = {},
            numericAggregateOptions = {},
            stringAggregateOptions = {},
            dateTimeAggregateOptions = {},
            timeSpanAggregateOptions = {},
            delimitedAggregators = [],
            exportProperties =
            {
                xml:
                {
                    wrapper: null,
                    section:
                    {
                        wrapper: null,
                        nodeName: null
                    },
                    row:
                    {
                        wrapper: null,
                        nodeName: null
                    },
                    column:
                    {
                        wrapper: null,
                        nodeName: null,
                        nodeType: null
                    }
                },
                csv:
                {
                    wrapper: null,
                    delimiter: null,
                    customDelimiter: null,
                    textQualifier: null,
                    includeTextQualifierOnlyWhenRequired: null
                },
                fixedWidth:
                {
                    wrapper: null,
                    column:
                    {
                        wrapper: null,
                        startPosition: null,
                        length: null
                    },
                },
                json:
                {
                    wrapper: null,
                    column:
                    {
                        name: null
                    },
                    section:
                    {
                        name: null
                    }
                }

            };

        skyward.reporting.getSvgNameByDataType = function (dataType)
        {
            var svgName = "CheckBox";

            if (dataType != null)
            {
                if (dataType.startsWith("Number") || dataType == "Long" || dataType == "Int" || dataType == "Short" || dataType == "Byte" || dataType == "Decimal")
                {
                    svgName = "Number";
                }
                else if (dataType.startsWith(DATA_TYPES.STRING))
                {
                    svgName = "TextCharacter";
                }
                else if (dataType == DATA_TYPES.DATETIME)
                {
                    svgName = "Date";
                }
                else if (dataType == DATA_TYPES.TIME)
                {
                    svgName = "Time";
                }
                else if (dataType == DATA_TYPES.TIMESPAN)
                {
                    svgName = "Timespan";
                }
                else if (dataType == "Image")
                {
                    svgName = "InsertImage";
                }
                else if (dataType == DATA_TYPES.GROUP_COLUMN)
                {
                    svgName = "Columns";
                }
            }

            return svgName;
        };

        var getSvgByDataType = function (dataType, svgType)
        {
            return skyward.svg.getSvg(skyward.reporting.getSvgNameByDataType(dataType), svgType || 'TreeBrowse');
        };

        var dataTypesAreComparable = function (leftDataType, rightDataType)
        {
            if (leftDataType === rightDataType)
            {
                return true;
            }
            else if (leftDataType == undefined || rightDataType == undefined)
            {
                return false;
            }
            else if (leftDataType.startsWith("Number") && rightDataType.startsWith("Number"))
            {
                return true;
            }

            return false;
        };

        var processKeyDown = function (e)
        {
            if (!keyboardCommands.isColumnKeyPressed(e))
            {
                return;
            }

            if (!$('.modalLayerContainer').length && $(document.activeElement).hasClass('reportColumn'))
            {
                e.preventDefault();

                let rowColumns;
                let selectedRow;

                if (currentSelectedColumns.areColumnsSelected())
                {
                    selectedRow = currentSelectedColumns.getRowByFirstSelectedColumn();
                    rowColumns = selectedRow.find('.reportColumn');
                }
                else
                {
                    return;
                }

                const allRows = getAllNonPreviewLines().has(".reportColumn");

                if (allRows.find(".reportColumn").length === 0)
                {
                    return;
                }

                let newColumn;
                let newRow;

                const mostRecentSelectedColumn = currentSelectedColumns.getLastSelectedColumn();
                const currentColumnIndex = rowColumns.index(mostRecentSelectedColumn);
                const selectedRowIndex = allRows.length === 0 ? -2 : allRows.index(selectedRow);

                if (keyboardCommands.isDeleteColumnPressed(e))
                {
                    removeColumns(currentSelectedColumns.getCurrentSelectedColumns(), true, true);
                }
                else if (keyboardCommands.isMoveToLeftColumnPressed(e))
                {
                    if (currentColumnIndex > 0)
                    {
                        newColumn = mostRecentSelectedColumn.prev();
                    }
                }
                else if (keyboardCommands.isMoveToRightColumnPressed(e))
                {
                    if (currentColumnIndex !== rowColumns.length - 1)
                    {
                        newColumn = mostRecentSelectedColumn.next();
                    }
                }
                else if (keyboardCommands.isMoveToUpColumnPressed(e))
                {
                    if (selectedRowIndex > 0)
                    {
                        newRow = $(allRows[selectedRowIndex - 1]);
                    }
                }
                else if (keyboardCommands.isMoveToDownColumnPressed(e))
                {
                    if (selectedRowIndex < allRows.length - 1)
                    {
                        newRow = $(allRows[selectedRowIndex + 1]);
                    }
                }

                const clearSelectedColumns = !keyboardCommands.isMultiSelectKeyPressed(e);

                if (newColumn)
                {
                    setSelectedColumn(newColumn, clearSelectedColumns);
                }

                if (newRow)
                {
                    setActiveSection(newRow.closest('.jsSection'));
                    setSelectedRowByRow(newRow);

                    let newRowColumns = newRow.find(".reportColumn");
                    if (newRowColumns.length > 0)
                    {
                        if (newRowColumns.length - 1 < currentColumnIndex)
                        {
                            setSelectedColumn($(newRowColumns[newRowColumns.length - 1]), clearSelectedColumns);
                        }
                        else
                        {
                            setSelectedColumn($(newRowColumns[currentColumnIndex]), clearSelectedColumns);
                        }
                    }
                }
            }
        };

        var labelBuilder = (function ()
        {
            var rootList;
            function initializeLabelBuilder()
            {
                rootList = designer.find(".reportLabels:visible");

                rootList.on("click", "li.dataLineLabel", labelClickToDataLine).on("click", "ul", listClickToSection);
                entireCanvas.on("resize", "div.reportLine", dataLineResizeToLabel).on("expand collapse", "div.jsSection", sectionExpandCollapseToList);
            }

            function getRelatedLabel(sectionOrRow)
            {
                if (sectionOrRow.is(".jsSection"))
                {
                    return sectionOrRow.find(".sectionToolbar").data("relatedLabel");
                }
                return sectionOrRow.data("relatedLabel");
            }

            function setLabelHeight(selectedRow, newHeight)
            {
                getRelatedLabel(selectedRow)?.css("line-height", newHeight + "px").height(newHeight);
            }

            function setRelatedLabel(selectedRow, newLabel)
            {
                getRelatedLabel(selectedRow).find(".labelText").text(newLabel);
            }

            function buildLabelColumns(recalculateAll)
            {
                if (!rootList || !rootList.is(":visible"))
                {
                    initializeLabelBuilder();
                }

                let labelListHeader = rootList.children("li").first();
                if (recalculateAll)
                {
                    designer.find(".collapseSection").addClass("doCollapseSection").removeClass("collapseSection");
                    rootList.html(labelListHeader);
                }

                let sectionsAndDataLinesToProcess = entireCanvas.find("div[data-report-label-text]" + (recalculateAll ? "" : ":not(.labelCreated)"));
                if (sectionsAndDataLinesToProcess.length > 0)
                {
                    let currentList = rootList;
                    let currentSectionContainer = null;
                    let lastLabel = $();
                    sectionsAndDataLinesToProcess.each(function ()
                    {
                        let sectionOrDataLine = $(this);

                        let labelText = sectionOrDataLine.data("reportLabelText");

                        let labelTextContainer = $("<span class='labelText labelMatchParent'></span>").text(labelText);
                        let label = $("<li></li>").append(labelTextContainer);
                        sectionOrDataLine.data("relatedLabel", label);
                        let actualSectionContainer;
                        if (sectionOrDataLine.is(".sectionToolbar"))
                        {
                            let section = sectionOrDataLine;
                            label.addClass("reportSectionLabel");

                            let parentList;
                            actualSectionContainer = section.parent();
                            updateIsHiddenConditionClass(label, getSectionOrRowHiddenConditionType(actualSectionContainer));

                            let isDetailsSection = actualSectionContainer.hasClass("detailsSection");
                            let isMainSection = actualSectionContainer.hasClass("jsMainSection");

                            if (!currentSectionContainer || actualSectionContainer.parent().is(currentSectionContainer))
                            {
                                // Child section (root falls through to here too)
                                parentList = currentList;
                            }
                            else
                            {
                                let actualParentSection = actualSectionContainer.parent().closest(".jsSection");
                                if (actualParentSection.length)
                                {
                                    // We're in an ancestor section. The correct list is stored in the header's data()
                                    parentList = actualParentSection.data("relatedList");
                                }
                                else
                                {
                                    // All details sections completed, back to root.
                                    parentList = rootList;
                                }
                            }

                            // Make a new list for this section
                            let currentListClasses = "reportLabels nested" + ((isDetailsSection || isMainSection) ? " sectionLabels" : "") + (isMainSection ? " mainSectionLabels" : "");
                            currentList = $('<ul class="' + currentListClasses + '"></ul>')
                                .data("relatedSection", section)
                                .appendTo($("<li/>").appendTo(parentList));

                            currentSectionContainer = actualSectionContainer;
                            currentSectionContainer.data("relatedList", currentList);
                        }
                        else
                        {
                            label.addClass("dataLineLabel");
                            let dataLine = sectionOrDataLine;
                            actualSectionContainer = dataLine.closest(".jsSection");
                            updateIsHiddenConditionClass(label, getSectionOrRowHiddenConditionType(dataLine));

                            // DataLines must be placed after at least one section header
                            if (!actualSectionContainer.is(currentSectionContainer))
                            {
                                // Moved out of one or more details-sections. The new parent-section is holding a reference to the related list.
                                currentList = actualSectionContainer.data("relatedList");
                                currentSectionContainer = actualSectionContainer;
                            }
                            label.data("relatedDataLine", dataLine);
                        }

                        // Set label height to match section. Line-height centers the text.
                        let sectionHeight = sectionOrDataLine.outerHeight();
                        label.appendTo(currentList).css("line-height", sectionHeight + "px").height(sectionHeight);

                        let sectionTop = sectionOrDataLine.position().top;
                        let margin = Math.round(sectionTop - label.position().top);
                        lastLabel.css("margin-bottom", margin + "px");
                        lastLabel = label;

                        label.toggleClass("row-selected", sectionOrDataLine.is(".row-selected"));
                    });
                }

                designer.find(".doCollapseSection")
                    .removeClass("doCollapseSection")
                    .addClass("collapseSection")
                    .trigger("collapse");
            }

            function listClickToSection()
            {
                var relatedSection = $(this).data("relatedSection");
                if (relatedSection)
                {
                    relatedSection.click();
                }
                return false;
            }

            function labelClickToDataLine()
            {
                var relatedDataLine = $(this).data("relatedDataLine");
                if (relatedDataLine && typeof relatedDataLine.click === "function")
                {
                    relatedDataLine.click();
                }
                return false;
            }

            function sectionExpandCollapseToList(event)
            {
                $(this).data("relatedList").toggleClass("collapsed", event.type == "collapse");
                return false;
            }

            function dataLineResizeToLabel()
            {
                var dataLine = $(this);
                var height = dataLine.outerHeight() + "px";
                var relatedLabel = dataLine.data("relatedLabel");

                if (!dataLine.is(":visible"))
                {
                    relatedLabel?.css("display", "none");
                }
                else
                {
                    relatedLabel?.css("display", "");
                }

                relatedLabel?.css({ "line-height": height, "height": height });
            }

            return {
                getRelatedLabel: getRelatedLabel,
                setLabelHeight: setLabelHeight,
                setRelatedLabel: setRelatedLabel,
                buildLabelColumns: buildLabelColumns
            };
        })();

        var initCanvas = function (selector)
        {
            $(selector).each(function ()
            {
                if (!designer)
                {
                    skyward.error.registerErrorDataGatherer("reporting", gatherDataForError);
                }
                designer = $(this);
                changeTracker = skyward.changeTracking.getChangeTracker(designer);
                _reportDesignerObserver.stopObservingEverything();
                //@TODO This will only work until the UI framework changes. It needs to be brought back into compliance when time allows.
                designer.closest('.menuContentArea')
                    .find(".tabListContainer").hide()
                    .next().css("left", 0);

                $(".contentArea, .currentRecordContent").css({ "margin-left": "0px" });

                designer.find('.reportPropertiesPanelToggle').on('click', function ()
                {
                    var icon = $(this).find("svg");
                    var newIconName = reportDesignerProperties.toggleClass("collapsed").hasClass("collapsed") ? "ChevronUp" : "ChevronDown";
                    skyward.svg.swapSvg(icon, newIconName, "BrowseLevel");
                    $(window).trigger("resize");
                });

                enumMaps = skyward.reporting.enummaps = JSON.parse(designer.find(".enumMaps").val());

                $.each(skyward.reporting.enummaps.AggregateNamesWithAggregatorAttribute, function (optionName, aggregateAttribute)
                {
                    if (aggregateAttribute.IsBooleanAggregator)
                    {
                        booleanAggregateOptions[optionName] = optionName.toDisplayName();
                    }
                    if (aggregateAttribute.IsDateTimeAggregator)
                    {
                        dateTimeAggregateOptions[optionName] = optionName.toDisplayName();
                    }
                    if (aggregateAttribute.IsNumericAggregator)
                    {
                        numericAggregateOptions[optionName] = optionName.toDisplayName();
                    }
                    if (aggregateAttribute.IsStringAggregator)
                    {
                        stringAggregateOptions[optionName] = optionName.toDisplayName();
                    }
                    if (aggregateAttribute.IsTimeSpanAggregator)
                    {
                        timeSpanAggregateOptions[optionName] = optionName.toDisplayName();
                    }
                    if (aggregateAttribute.IsDelimitedAggregator)
                    {
                        delimitedAggregators.push(optionName);
                    }
                });

                setGlobalSelectors();

                entireCanvas.disableSelection();

                entireCanvas.on("click", ".lineWrapper:not(.jsPrintOnOneLinePreviewLine)", function ()
                {
                    var target = $(this);
                    $(document.activeElement).blur();
                    setActiveSection(target.closest('.jsSection'));
                    setSelectedRowByRow(target);
                    return false;
                });

                entireCanvas.on("click", ".lineWrapper:not(.jsPrintOnOneLinePreviewLine) .jsReportAggregate, .lineWrapper:not(.jsPrintOnOneLinePreviewLine) .jsFieldColumn", function (event)
                {
                    const clearSelectedColumns = !keyboardCommands.isMultiSelectKeyPressed(event);

                    const target = $(this);
                    $(document.activeElement).blur();
                    setActiveSection(target.closest('.jsSection'), clearSelectedColumns);
                    setSelectedRowByColumn(target);
                    setSelectedColumn(target, clearSelectedColumns);
                    return false;
                });

                entireCanvas.on("dblclick", ".jsFieldColumn[data-calculation]", function ()
                {
                    var calculatedColumn = $(this);
                    var calculatedColumnData = calculatedColumn.data();

                    var data =
                    {
                        fieldName: calculatedColumnData.designerText,
                        displayCalculation: calculatedColumnData.displayCalculation,
                        calculation: calculatedColumnData.calculation,
                        calculationJson: calculatedColumnData.calculationJson,
                        columnId: calculatedColumnData.columnId
                    };
                    getCalculatedColumnBuilder(data, calculatedColumn);
                });

                seekToColumnFieldButton.on('click', seekToColumnField);

                // canvas keyboard nav
                $(document).off('keydown', processKeyDown).on('keydown', '.reportDesignerGrid', processKeyDown);

                setPropertiesEventHandlers();

                resetAllStringDataAttributes();

                initLeftSidePanel();

                // Correct differences between JSON.stringify() and the Json provided by the server
                var editorHiddenData = designer.find(".editorHiddenData");
                var originalJson = editorHiddenData.data("original-value");
                editorHiddenData.val(JSON.stringify(originalJson));

                CalculatedFields_Model.Reset(originalJson.CalculatedFields);

                skyward.reporting.searchParameters.viewModel.init(originalJson.SearchParameters);
                _reportDesignerObserver.observe(skyward.reporting.searchParameters.model, function ()
                {
                    if (!this.massUpdateInProgress)
                    {
                        updateHiddenField();
                        skyward.reporting.prompts.populateExtraColumnOptionsWithPrompts(designer.find(".reportDesignerPromptFieldsMenu"));
                    }
                });

                // Variables
                initializeVariables(originalJson.Variables, leftSidePanel.find(".variablesView"), entireCanvas);

                skyward.reporting.prompts.importPrompts(originalJson.Prompts);

                var aggregateCalculationColumns = [];
                getAllSections().each(function ()
                {
                    var section = $(this);
                    var sectionID = section.data("sectionId");

                    getSectionAllAggregateLines(section).each(function ()
                    {
                        var aggregateLine = $(this);
                        var lineID = aggregateLine.data("lineId");

                        getColumnsInLine(aggregateLine).each(function ()
                        {
                            var column = $(this);
                            var columnData = column.data();
                            if (columnData.fieldColumnType == COLUMN_TYPES.CALCULATED_COLUMN)
                            {
                                aggregateCalculationColumns.push({
                                    columnId: columnData.columnId,
                                    name: columnData.designerText,
                                    sectionID: sectionID,
                                    lineID: lineID,
                                    calculation: columnData.calculation
                                });
                            }
                        });
                    });
                });

                skyward.reporting.aggregateCalculationCollection.populate(aggregateCalculationColumns);

                var dirtyOnLoad = editorHiddenData.data("dirtyOnLoad");
                var newValue = buildHiddenFieldJson();
                var originalValue = dirtyOnLoad ? {} : newValue;
                editorHiddenData.data("original-value", originalValue);
                updateDirtyStatus(editorHiddenData, originalValue, newValue);

                //update styling of sections and rows
                for (let reportLine of designer.find(".reportLine"))
                {
                    let row = $(reportLine);
                    applyRowCss(row);

                    for (let column of row.find(".jsColumn"))
                    {
                        applyColumnCss($(column));
                    }
                }

                labelBuilder.buildLabelColumns(false);
                setInitialSelectedRow();

                designer.find('.userConditionValueSelectorButton').on('click', function ()
                {
                    // not supported when multiple columns are selected
                    let section = getCurrentSection();
                    if (section.length > 0)
                    {
                        const sectionData = section.data();
                        let sectionDisplayOnSingleLine = sectionData.displayOnSingleLine;

                        const parentDisplayOnSingleLine = isParentDisplayOnSingleLine(section);

                        let allowCurrentColumnValue = false;
                        let currentColumnFieldType = undefined;
                        if (currentSelectedColumns.areColumnsSelected())
                        {
                            const currentSelectedColumnData = currentSelectedColumns.getFirstSelectedColumn().data();
                            currentColumnFieldType = currentSelectedColumnData.fieldType;
                            allowCurrentColumnValue = currentSelectedColumnData && !currentSelectedColumnData.isFutureValue &&
                                currentSelectedColumnData.allowCurrentValueHiding === true && currentSelectedColumnData.fieldType !== null &&
                                !currentSelectedColumnData.fieldType?.startsWith("Other-") && currentSelectedColumnData.fieldType !== "List";
                        }

                        const line = currentRow || getParentLine(currentSelectedColumns.getFirstSelectedColumn());

                        let isAggregateLine = isAggregateLineType(line.data("lineType"));

                        if (sectionDisplayOnSingleLine)
                        {
                            allowCurrentColumnValue = allowCurrentColumnValue && !parentDisplayOnSingleLine && isAggregateLine;
                        }

                        let allowFieldSelection = !sectionDisplayOnSingleLine && line.data("lineType") === LINE_TYPES.DATA_LINE;

                        let columns = [];
                        if (!parentDisplayOnSingleLine && isAggregateLine)
                        {
                            columns = buildReportColumnCollection(getColumnsInLine(line));
                        }

                        const allPrompts = skyward.reporting.prompts.promptCollection.toJsonObject();

                        const allowOptions =
                        {
                            fieldSelection: allowFieldSelection,
                            currentColumnValue: allowCurrentColumnValue,
                            prompts: true,
                            alwaysHidden: true,
                            detailSectionsHaveAnyRows: false,
                        }

                        let operandButton = $(this);
                        if (operandButton.hasClass("leftOperand"))
                        {
                            if (line.hasClass("jsSortAggregateLine") && getNestedDetailSections(section).length)
                            {
                                const relatedSort = getSortDataByReportSortID(section, line.data("relatedReportSortId"));
                                const sortFieldName = relatedSort.RelativeDataPath?.toLowerCase();
                                const sectionPrimaryKeyFieldName = sectionData.primaryKeyFieldName.toLowerCase();
                                allowOptions.detailSectionsHaveAnyRows = sortFieldName === sectionPrimaryKeyFieldName;
                            }
                            isHiddenSelector.getUserConditionOperandFilterValueSelector(operandButton, allowOptions, columns, allPrompts, null, currentColumnFieldType, true, valueSelectorClickEvents, null, sectionData.sectionId);
                        }
                        else
                        {
                            let leftOperandFieldType = getEditorFieldDataType(isHiddenSelector.elements.left);
                            let allowCurrentColumnValueOnRight = allowCurrentColumnValue && dataTypesAreComparable(leftOperandFieldType, currentColumnFieldType);
                            let leftPromptUniqueID = isHiddenSelector.elements.left.data().promptUniqueId;

                            allowOptions.currentColumnValue = allowCurrentColumnValueOnRight;

                            if (leftOperandFieldType)
                            {
                                isHiddenSelector.getUserConditionOperandFilterValueSelector(operandButton, allowOptions, columns, allPrompts, leftOperandFieldType, currentColumnFieldType, false, valueSelectorClickEvents, leftPromptUniqueID);
                            }
                            else
                            {
                                isHiddenSelector.getUserConditionOperandFilterValueSelector(operandButton, allowOptions, columns, allPrompts, currentColumnFieldType, currentColumnFieldType, false, valueSelectorClickEvents, leftPromptUniqueID);
                            }
                        }
                    }
                });

                skyward.fieldWrapper.alignTitles(leftSidePanel);

                $.each(designer.find(".jsSection:not(.jsHeaderFooterSection)"), function (index, value)
                {
                    var section = $(value);
                    var sectionData = section.data();
                    var pageWidth = skyward.reporting.currentReportDefinition.PrintablePageWidth;
                    var unusableWidth = sectionData.columnWidth === "" ? 0 : (pageWidth - sectionData.columnWidth) * 72;

                    var unusableAreaBox = skyward.reporting.multiColumnSection.generateUnusableAreaBox(unusableWidth);

                    updateUnsableAreaBox(section, unusableAreaBox, sectionData.applyColumnsToDataLinesOnly);
                });
            });
        };

        const resetAllStringDataAttributes = function()
        {
            // reset string data attributes because jquery.data() will try to convert the values into their corresponding JavaScript data types otherwise
            const stringAttributes = ['designer-text', 'display-name', 'field-name', 'display-path', 'absolute-field-path', 'report-label-text', 'default-line-label'];
            const resetStringAttributes = function (obj)
            {
                for (const attr of stringAttributes)
                {
                    let attributeValue = obj.attr(`data-${attr}`);
                    if (attributeValue !== undefined)
                    {
                        obj.data(attr, attributeValue);
                    }
                }
            };
            getAllSections().each(function ()
            {
                const section = $(this);
                resetStringAttributes(section);
                getSectionLines(section).each(function ()
                {
                    const line = $(this);
                    resetStringAttributes(line);
                    getColumnsInLine(line).each(function ()
                    {
                        const column = $(this);
                        resetStringAttributes(column);
                    });
                });
            });
        }

        var seekToColumnField = function ()
        {
            // not supported when multiple columns are selected
            const currentSelectedColumn = currentSelectedColumns.getFirstSelectedColumn();
            const columnData = currentSelectedColumn.data();
            const sectionData = currentSelectedColumn.closest('.jsSection').data();

            var treeBrowse = skyward.treebrowse.getTreeBrowseContainer("reportObjectBrowser");
            var treeBrowseData = treeBrowse.data();

            // a sourceColumnId indicates that this field was added from the aggregate field list
            if (!columnData.sourceColumnId && columnData.absoluteFieldPath)
            {
                $.ajax(
                    {
                        url: skyward.global.virtualDir + "Reporting/Report/GetSeekToFieldData",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            absoluteFieldPath: columnData.absoluteFieldPath,
                            rootModuleName: sectionData.rootModule,
                            rootObjectName: sectionData.rootObject
                        }
                    }).done(function (data)
                    {
                        if (typeof treeBrowseData.replaceTreeBrowseData === 'function')
                        {
                            skyward.collapsePanel.show($('.js-reportDesignerFieldsMenu'));

                            treeBrowseData.replaceTreeBrowseData(data.moduleName, data.objectName, data.positionObjectPath, null,
                                data.objectDisplayName, data.breadCrumbData, sectionData.rootModule, sectionData.rootObject,
                                data.oneToManyPath, false, true).done(function ()
                                {
                                    treeBrowse.find('.parentSectionComboBox option[data-absolute-tree-browse-object-path="' + data.oneToManyPath + '"]').prop('selected', 'selected');
                                    treeBrowseData.selectRecord(columnData.fieldName);
                                });

                        }
                    });
            }
            else if (columnData.sourceColumnId)
            {
                openPanelAndSelectField("aggregate_" + columnData.sourceColumnId);
            }
            else if (columnData.operationId)
            {
                openPanelAndSelectField(columnData.operationId);
            }
        };

        var openPanelAndSelectField = function (fieldKey)
        {
            var treeBrowseData = skyward.treebrowse.getTreeBrowseDataByName("reportObjectBrowser");
            treeBrowseData.selectRecord(fieldKey);
            var selectedRecord = treeBrowseData.selectedRecord;
            skyward.collapsePanel.show(selectedRecord.closest(".collapsePanel"));
            selectedRecord.scrollintoview();
        };

        var updateUnsableAreaBox = function (section, unusableAreaBox, applyColumnsToDataLinesOnly)
        {
            var sectionBody = section.find(".sectionBody:first");
            var lines;
            if (applyColumnsToDataLinesOnly === true || applyColumnsToDataLinesOnly === "true")
            {
                lines = sectionBody.find(".reportLine.jsDataLine");
            }
            else
            {
                lines = sectionBody.find(".reportLine");
            }

            sectionBody.find(".unusableArea").remove();
            lines.prepend(unusableAreaBox);
        };

        var setInitialSelectedRow = function ()
        {
            var mainSection = getAllMainSections().first();

            if (mainSection.length)
            {
                setSelectedRowByRow(getSectionDataLines(mainSection).first());
            }
            else
            {
                setSelectedRowByRow(getPageHeaderLine());
            }
        };

        var setGlobalSelectors = function ()
        {
            //canvas
            entireCanvas = designer.find('.reportDesignerCanvas');

            leftSidePanel = designer.find(".reportDesignerLeftSidePanel");

            // left side panel collapsables
            usedFieldsMenu = leftSidePanel.find('.js-usedFieldsPanel .collapsePanelContents');
            allFieldsMenu = leftSidePanel.find('.js-reportDesignerFieldsMenu .collapsePanelContents');
            calculatedFieldMenu = leftSidePanel.find('.reportDesignerCalculatedFieldsMenu .collapsePanelContents');
            aggregateFieldsMenu = leftSidePanel.find('.reportDesignerAggregateFieldsMenu .collapsePanelContents');
            promptFieldsMenu = leftSidePanel.find('.reportDesignerPromptFieldsMenu .collapsePanelContents');
            environmentVariableFieldsMenu = leftSidePanel.find('.reportDesignerEnvironmentVariableFieldsMenu .collapsePanelContents');
            variablesMenu = leftSidePanel.find('.reportDesignerVariablesMenu .collapsePanelContents');
            specialFieldsMenu = leftSidePanel.find('.reportDesignerSpecialFieldsMenu .collapsePanelContents');
            xmlExportSettingsMenu = leftSidePanel.find('.jsXMLExportProperties .collapsePanelContents');
            csvExportSettingsMenu = leftSidePanel.find('.reportDesignerCSVProperties .collapsePanelContents');
            fixedWidthExportSettingsMenu = leftSidePanel.find('.jsFixedWidthExportProperties .collapsePanelContents');
            jsonExportSettingsMenu = leftSidePanel.find('.jsJSONExportProperties .collapsePanelContents');

            //field properties area
            reportDesignerProperties = designer.find(".reportProperties");

            columnWidth = reportDesignerProperties.find(".columnWidth");
            columnHeight = reportDesignerProperties.find(".columnHeight");
            lineHeight = reportDesignerProperties.find(".lineHeight");
            editorColumnText = reportDesignerProperties.find(".editorColumnText");
            editorVariableToSet = reportDesignerProperties.find(".editorVariableToSet");
            editorMediaId = reportDesignerProperties.find(".editorMediaId");
            editorUseSystemLogo = reportDesignerProperties.find(".editorUseSystemLogo");
            columnDataPath = reportDesignerProperties.find(".columnDataPath");
            seekToColumnFieldButton = reportDesignerProperties.find(".seekToColumnField");
            positionX = reportDesignerProperties.find(".positionX");
            positionY = reportDesignerProperties.find(".positionY");

            editorAggregateType = reportDesignerProperties.find(".editorAggregateTypes");
            editorAggregateDelimiter = reportDesignerProperties.find(".editorAggregateDelimiters");
            editorAggregateDelimiterContainer = editorAggregateDelimiter.parent();

            pageSectionColumnDisplayTypeFS = reportDesignerProperties.find(".pageSectionColumnDisplayTypeFS");
            pageSectionColumnDisplayType = reportDesignerProperties.find(".pageSectionColumnComboBox");
            pageSectionColumnPromptDisplayType = reportDesignerProperties.find(".pageSectionColumnPromptComboBox");

            groupColumnSortHeaderTypes = reportDesignerProperties.find(".editorGroupColumnSortHeaderTypes");

            editorPrintAtBottomOfPage = reportDesignerProperties.find(".editorPrintAtBottomOfPage");
            editorPrintReportFooterOnNewPage = reportDesignerProperties.find(".editorPrintReportFooterOnNewPage");
            editorRepeatLineAfterStart = reportDesignerProperties.find(".editorRepeatLineAfterStart");
            editorRepeatRowOnPageIfDetailsPresent = reportDesignerProperties.find(".editorRepeatRowOnPageIfDetailsPresent");
            editorRepeatHeaderForEachDataRow = reportDesignerProperties.find(".editorRepeatHeaderForEachDataRow");
            editorVariablesToReset = reportDesignerProperties.find(".editorVariablesToReset");
            editorPageBreakBeforeSectionPrints = reportDesignerProperties.find(".editorPageBreakBeforeSectionPrints");

            editorDefaultSubjects = reportDesignerProperties.find(".editorDefaultSubjects");

            //data format panel
            dataFont = reportDesignerProperties.find(".editorFont");
            dataForeColor = reportDesignerProperties.find(".editorForeColor");
            dataBackgroundColor = reportDesignerProperties.find(".editorBackgroundColor");
            dataFontSize = reportDesignerProperties.find(".editorFontSize");
            dataBold = reportDesignerProperties.find(".editorBold");
            dataItalic = reportDesignerProperties.find(".editorItalic");
            dataUnderline = reportDesignerProperties.find(".editorUnderline");
            dataFormatPreview = reportDesignerProperties.find(".reportFormatPreview");

            rotationValue = reportDesignerProperties.find(".rotationValue");
            rotationRange = reportDesignerProperties.find(".rotationRange");

            dataTextFormat = reportDesignerProperties.find(".editorTextFormat");

            formatterControlsData = [];
            formatterControlsDataMap = new Map();

            for (let formatterOption of dataTextFormat.find("option"))
            {
                formatterControlsDataMap.set(formatterOption.value, []);
            }

            reportDesignerProperties.find(".js-formatterInput").each(function ()
            {
                var element = $(this);
                var controlData = element.data();
                if (controlData.formatDataSources !== undefined)
                {
                    let formatterData = {
                        element: element,
                        dataBindings: controlData.formatDataSources || {},
                        defaults: controlData.formatDataDefaults || {}
                    };

                    formatterControlsData.push(formatterData);

                    for (let formatterName of controlData.formatters)
                    {
                        formatterControlsDataMap.get(formatterName).push(formatterData);
                    }
                }
            });

            borderStyle = reportDesignerProperties.find(".borderStyle");
            borderTop = reportDesignerProperties.find(".borderTop");
            borderBottom = reportDesignerProperties.find(".borderBottom");
            borderLeft = reportDesignerProperties.find(".borderLeft");
            borderRight = reportDesignerProperties.find(".borderRight");
            borderWidth = reportDesignerProperties.find(".borderWidth");
            borderColor = reportDesignerProperties.find(".borderColor");
            editorTextAlign = reportDesignerProperties.find(".textAlignmentRadioButtonGroup");
            editorVerticalAlign = reportDesignerProperties.find(".verticalAlignmentRadioButtonGroup");
            editorPaddingBottom = reportDesignerProperties.find(".editorPaddingBottom");
            editorPaddingTop = reportDesignerProperties.find(".editorPaddingTop");
            editorPaddingRight = reportDesignerProperties.find(".editorPaddingRight");
            editorPaddingLeft = reportDesignerProperties.find(".editorPaddingLeft");
            editorPrintIfEmpty = reportDesignerProperties.find(".editorPrintIfEmpty");
            editorDisplayOnSingleLine = reportDesignerProperties.find(".editorDisplayOnSingleLine");
            singleLineRecordCountFieldSetTemplate = reportDesignerProperties.find(".singleLineRecordCountFieldSet.jsTemplate");
            editorSectionAndLineDisplayName = reportDesignerProperties.find(".editorSectionAndLineDisplayName");
            sectionAndLineFullName = reportDesignerProperties.find(".sectionAndLineFullName");
            resetSectionAndLineDisplayName = reportDesignerProperties.find(".resetSectionAndLineDisplayName");
            editorEmptyLinesToPrint = reportDesignerProperties.find(".editorEmptyLinesToPrint");
            editorColumnFilter = reportDesignerProperties.find(".filterContainer");
            editorColumnFilterInput = editorColumnFilter.find(".filterViewValue");
            editorColumnFilterLaunchButton = editorColumnFilter.find(".filterBuilderLaunchButton");
            overlapMode = reportDesignerProperties.find(".editorOverlapMode");
            resetOption = reportDesignerProperties.find(".resetOption");
            runningTotal = reportDesignerProperties.find(".runningTotal");

            const isHiddenWrapper = reportDesignerProperties.find('.jsIsHiddenCondition');
            isHiddenSelector = skyward.reporting.userCondition.init(isHiddenWrapper);
            whenHiddenOption = reportDesignerProperties.find("select[name='whenHiddenOption']");

            exportProperties.xml.wrapper = $(".jsXMLExportProperties");
            exportProperties.xml.includeRootNode = exportProperties.xml.wrapper.find("input[name='includeRootNodeXML']");
            exportProperties.xml.nodeName = exportProperties.xml.wrapper.find("input[name='reportNameXML']");
            exportProperties.xml.section.wrapper = exportProperties.xml.wrapper.find(".jsExportSectionProperties");
            exportProperties.xml.section.nodeName = exportProperties.xml.section.wrapper.find("input[name='sectionNameXML']");
            exportProperties.xml.row.wrapper = exportProperties.xml.wrapper.find(".jsExportRowProperties");
            exportProperties.xml.row.nodeName = exportProperties.xml.row.wrapper.find("input[name='rowNameXML']");
            exportProperties.xml.column.wrapper = exportProperties.xml.wrapper.find(".jsExportColumnProperties");
            exportProperties.xml.column.nodeName = exportProperties.xml.column.wrapper.find("input[name='columnNameXML']");
            exportProperties.xml.column.nodeType = exportProperties.xml.column.wrapper.find(".radioButtonGroup[data-name='columnTypeXML']");

            exportProperties.csv.wrapper = $(".jsCSVExportProperties");
            exportProperties.csv.delimiter = exportProperties.csv.wrapper.find("select[name='delimiterCSV']");
            exportProperties.csv.customDelimiter = exportProperties.csv.wrapper.find("input[name='customDelimiterCSV']");
            exportProperties.csv.textQualifier = exportProperties.csv.wrapper.find("select[name='textQualifierCSV']");
            exportProperties.csv.includeTextQualifierOnlyWhenRequired = exportProperties.csv.wrapper.find("input[name='textQualifierOnlyWhenRequired']");

            exportProperties.fixedWidth.wrapper = $(".jsFixedWidthExportProperties");
            exportProperties.fixedWidth.column.startPosition = exportProperties.fixedWidth.wrapper.find("input[name='columnStartPosition']");
            exportProperties.fixedWidth.column.length = exportProperties.fixedWidth.wrapper.find("input[name='columnTextLength']");

            exportProperties.json.wrapper = $(".jsJSONExportProperties");
            exportProperties.json.column.name = exportProperties.json.wrapper.find("input[name='jsonExportPropertyName']");
            exportProperties.json.section.name = exportProperties.json.wrapper.find("input[name='jsonExportPropertyName']");

            let defaultFormatting = dataFormatPreview.data();

            if (defaultFormatting)
            {
                underlineCssClass = defaultFormatting.cssClassUnderline;
                boldCssClass = defaultFormatting.cssClassBold;
                italicCssClass = defaultFormatting.cssClassItalic;

                defaultDataFont = defaultFormatting.defaultDataFontFamily;
                defaultDataFontSize = defaultFormatting.defaultDataFontSize;
                defaultDataForeColor = defaultFormatting.defaultDataForeColor;
                defaultFormatting.defaultDataBackColor ? defaultDataBackColor = defaultFormatting.defaultDataBackColor : defaultDataBackColor = "";
                defaultDataFontBold = defaultFormatting.defaultDataFontBold;
                defaultDataFontItalic = defaultFormatting.defaultDataFontItalic;
                defaultDataFontUnderline = defaultFormatting.defaultDataFontUnderline;
                defaultColumnPadding = defaultFormatting.defaultColumnPadding;
            }
        };

        var setColumnHeight = function (column, newHeight)
        {
            var columnData = column.data();
            var maxHeight = columnData.maxHeight || MAX_COLUMN_HEIGHT;
            var minHeight = columnData.paddingTop + columnData.paddingBottom;
            var originalHeight = columnData.fieldHeight;

            if (newHeight < minHeight)
            {
                editorPaddingTop.stop(true, true);
                editorPaddingTop.effect("highlight", {}, 3000);
                editorPaddingBottom.stop(true, true);
                editorPaddingBottom.effect("highlight", {}, 3000);
                columnHeight.stop(true, true);
                columnHeight.effect("highlight", {}, 3000);

                newHeight = minHeight;
            }

            if (newHeight > maxHeight)
            {
                newHeight = maxHeight;
            }

            if (originalHeight != newHeight)
            {
                columnData.fieldHeight = newHeight;

                if (columnData.heightMultiplier && columnData.fieldColumnType === COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN)
                {
                    setColumnWidth(column, $.safeRound(newHeight * columnData.heightMultiplier));
                }
            }
        };

        var setColumnWidth = function (column, newWidth)
        {
            var columnData = column.data();
            var maxWidth = columnData.maxWidth || MAX_COLUMN_WIDTH;
            var minWidth = columnData.paddingLeft + columnData.paddingRight;
            var originalWidth = columnData.fieldWidth;

            if (newWidth < minWidth)
            {
                editorPaddingLeft.stop(true, true);
                editorPaddingLeft.effect("highlight", {}, 3000);
                editorPaddingRight.stop(true, true);
                editorPaddingRight.effect("highlight", {}, 3000);
                columnWidth.stop(true, true);
                columnWidth.effect("highlight", {}, 3000);

                newWidth = minWidth;
            }

            if (newWidth > maxWidth)
            {
                newWidth = maxWidth;
            }

            if (originalWidth != newWidth)
            {
                columnData.fieldWidth = newWidth;

                if (columnData.widthMultiplier && columnData.fieldColumnType === COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN)
                {
                    setColumnHeight(column, $.safeRound(newWidth * columnData.widthMultiplier));
                }
            }
        };

        var setRowHeight = function (selectedLine, height)
        {
            var adjustedHeight = Math.max(height, 10);
            selectedLine.data("lineHeight", adjustedHeight);
            labelBuilder.setLabelHeight(selectedLine, adjustedHeight);
        };

        var setPropertiesEventHandlers = function ()
        {
            function applyDataToAllCurrentSelectedColumns(applyData)
            {
                Promise.all(currentSelectedColumns.getCurrentSelectedColumns()
                    .map(c =>
                    {
                        const applyDataResult = applyData(c);
                        if (applyDataResult instanceof Promise)
                        {
                            return applyDataResult.then(() => applyColumnCss(c));
                        }
                        else if (applyDataResult && typeof applyDataResult.promise === 'function')
                        {
                            return applyDataResult.done(() => applyColumnCss(c)).promise();
                        }
                        else
                        {
                            applyColumnCss(c);
                            return Promise.resolve();
                        }
                    })).then(() =>
                    {
                        updateHiddenField();
                        setColumnProperties();
                        skyward.reporting.updateVariableUsageLocations();
                    }).catch(() => { /* ignore cancel click */ });;
            }

            function applyDataToSelectedRow(applyData)
            {
                applyData(currentRow);

                setRowProperties(currentRow);
                updateHiddenField();
                applyRowCss(currentRow);
                skyward.reporting.updateVariableUsageLocations();
            }

            function applyDataToSelectedSection(applyData)
            {
                let section = getCurrentSection();

                applyData(section);

                updateHiddenField();
                setSectionProperties(section);
            }

            function isRowSelected()
            {
                if (currentRow && !currentRow.hasClass("sectionToolbar"))
                {
                    return true;
                }
                return false;
            }

            function isSectionToolbarSelected()
            {
                if (currentRow && currentRow.hasClass("sectionToolbar"))
                {
                    return true;
                }
                return false;
            }

            skyward.reporting.getCopyFieldFormatValueSelector = function ()
            {
                // copy field formatter only supports 1 selected column
                internalGetCopyFieldFormatValueSelector(currentSelectedColumns.getFirstSelectedColumn());
            };

            var internalGetCopyFieldFormatValueSelector = function (currentSelectedColumn)
            {
                var formatterData = currentSelectedColumn.data("formatter");
                var previousFormatterData = formatterData;
                var currentSectionData = getSectionData(getCurrentSection());

                var rootModule;
                var rootObject;
                if ((previousFormatterData || {}).formatterName == FORMATTER_NAMES.COPY_FIELD)
                {
                    // Setup treebrowse for seek-to-field if editing a previously defined CopyField formatter
                    rootModule = previousFormatterData.fieldModule || currentSectionData.baseModule;
                    rootObject = previousFormatterData.fieldObject || currentSectionData.baseObject;
                }
                else
                {
                    rootModule = currentSectionData.baseModule;
                    rootObject = currentSectionData.baseObject;
                }

                var options = {
                    title: "Select Format to Copy",
                    selectItemDoubleClickSelector: ".treebrowserow.reportColumn",
                    treeBrowseOptions: {
                        renderOneToMany: false,
                        allowOneToManyBrowse: false,
                        renderStandardRelationships: true,
                        maxOneToManyNestedLevels: 5,
                        renderOperationFields: true,
                        renderColumnGroups: false,
                        renderProxies: true,
                        mode: "report",
                        seekField: (previousFormatterData || {}).absoluteFieldPath,
                        fieldsOfType: currentSelectedColumn.data("fieldType")
                    }
                };
                selectFieldDialog(null, rootModule, rootObject, options)
                    .done(function (selectedItemData, moduleObjectData)
                    {
                        // Merge Treebrowse-column-data with M/O/F names and formatter-specific data
                        let newFormatterData = $.extend(getFormatterDataDefaults(FORMATTER_NAMES.COPY_FIELD), selectedItemData, moduleObjectData, { fieldDisplayName: selectedItemData.displayName });
                        currentSelectedColumn.data("formatter", newFormatterData);
                        if (isBarcodeFormatter(previousFormatterData))
                        {
                            resetFontProperties(currentSelectedColumn);
                        }
                        applyColumnCss(currentSelectedColumn);
                        updateHiddenField();
                    })
                    .always(function ()
                    {
                        setColumnProperties();
                    });
            };

            resetSectionAndLineDisplayName.on("click", function ()
            {
                var defaultValue;
                if (currentRow.hasClass("sectionToolbar"))
                {
                    defaultValue = currentRow.closest(".jsSection").data().sectionObjectName;
                }
                else if (currentRow.hasClass("sortHeaderLine") || currentRow.hasClass("jsSortAggregateLine"))
                {
                    defaultValue = currentRow.data().defaultLineLabel;
                }
                editorSectionAndLineDisplayName.val(defaultValue);
                editorSectionAndLineDisplayName.change();
            });

            // newchangeevents

            function getIntegerValue(input)
            {
                let value = $.safeRound(input.val()) || 0;
                var min = parseInt(input.prop("min")) || Number.MIN_SAFE_INTEGER;
                var max = parseInt(input.prop("max")) || Number.MAX_SAFE_INTEGER;

                if (value < min)
                {
                    return min;
                }

                if (value > max)
                {
                    return max;
                }

                return value;
            }

            function getTextValue(input)
            {
                let value = input.val();
                if (value)
                {
                    return value.trim();
                }
                return null;
            }

            function getInputValue(input)
            {
                if (input.is(".radioButtonGroup"))
                {
                    return skyward.radioButtonGroup.getValue(input);
                }

                const type = (input.prop("type") || "").toLowerCase();
                switch (type)
                {
                    case "checkbox":
                        return input.prop("checked");
                    case "number":
                        return getIntegerValue(input);
                    case "text":
                        return getTextValue(input);
                }

                return input.val();
            }

            function getInputData(input)
            {
                return input.data();
            }

            function setupColorPreviewEvent(input, { prop })
            {
                input.on("move.spectrum hide.spectrum", function (events, colorParam)
                {
                    const value = colorParam?.toString();

                    if (isRowSelected())
                    {
                        currentRow.data(prop, value);
                        applyRowCss(currentRow);
                    }
                    else if (currentSelectedColumns.areColumnsSelected())
                    {
                        for (const column of currentSelectedColumns.getCurrentSelectedColumns())
                        {
                            column.data(prop, value);
                            applyColumnCss(column);
                        }
                    }
                });
            }

            function setupChangeEvent(input, { prop, getValueOverride, setDataOverride })
            {
                if ((prop && setDataOverride) || (!prop && !setDataOverride))
                {
                    console.error("either prop or setDataOverride must have a value, but not both.");
                }

                function setData(element, value)
                {
                    if (setDataOverride)
                    {
                        return setDataOverride(element, value);
                    }
                    else if (prop)
                    {
                        element.data(prop, value);
                    }
                }

                input.on("change", function ()
                {
                    const value = getValueOverride ? getValueOverride(input) : getInputValue(input);

                    if (isSectionToolbarSelected())
                    {
                        applyDataToSelectedSection(function (section)
                        {
                            setData(section, value);
                        });
                    }
                    else if (isRowSelected())
                    {
                        applyDataToSelectedRow(function (row)
                        {
                            setData(row, value);
                        });
                    }
                    else if (currentSelectedColumns.areColumnsSelected())
                    {
                        applyDataToAllCurrentSelectedColumns(function (column)
                        {
                            return setData(column, value);
                        });
                    }
                });
            }

            reportDesignerProperties.on("change", ".editorSingleLineRecordCount", function ()
            {
                let input = $(this);
                let section = getCurrentSection();

                const value = getInputValue(input);
                const sectionID = input.data("sectionID");

                getSectionElementBySectionID(sectionID).data("singleLineRecordCount", value);

                updateHiddenField();
                setSectionProperties(section);
            });

            function setColumnRotation(column, value)
            {
                column.data("rotation", value);
                initColumnDragging(column);
            }

            function getBoolPromptSetDataFunc(prop)
            {
                return function (row, inputData)
                {
                    const promptUniqueIDProp = prop + "-prompt-unique-id";
                    const promptUniqueIDAttr = "data-" + promptUniqueIDProp;

                    if (inputData.promptUniqueId)
                    {
                        row.data(prop, false);
                        row.data(promptUniqueIDProp, inputData.promptUniqueId)
                            .attr(promptUniqueIDAttr, inputData.promptUniqueId);
                    }
                    else if (typeof inputData.boolvalue == "boolean")
                    {
                        row.data(prop, inputData.boolvalue);
                        row.removeData(promptUniqueIDProp).removeAttr(promptUniqueIDAttr);
                    }
                }
            }

            // start formatter
            dataTextFormat.on("change", function (event)
            {
                let formatterName = dataTextFormat.val();

                if (formatterName === FORMATTER_NAMES.COPY_FIELD)
                {
                    internalGetCopyFieldFormatValueSelector(currentSelectedColumns.getFirstSelectedColumn());
                    event.stopPropagation(); // Wait for user to confirm a field before storing the value;
                    return false;
                }

                applyDataToAllCurrentSelectedColumns(function (column)
                {
                    let oldFormatter = column.data("formatter");
                    let newFormatter = getFormatterDataDefaults(formatterName);

                    if (!newFormatter)
                    {
                        column.removeData("formatter");
                        if (oldFormatter && isBarcodeFormatter(oldFormatter))
                        {
                            resetFontProperties(column);
                        }
                    }
                    else
                    {
                        if (!oldFormatter || oldFormatter.formatterName !== formatterName)
                        {
                            // some columns may already have the formatter, so avoid overriding all their existing settings
                            column.data("formatter", newFormatter);
                            if (isBarcodeFormatter(oldFormatter) && !isBarcodeFormatter(newFormatter))
                            {
                                resetFontProperties(column);
                            }
                        }
                    }

                });

                return true;
            });

            for (let controlData of formatterControlsData)
            {
                controlData.element.on("change", function ()
                {
                    let formatterPropertyValues = getFormatterInputPropertyValues(controlData);

                    applyDataToAllCurrentSelectedColumns(function (column)
                    {
                        let newFormatter = $.extend({}, column.data("formatter"), formatterPropertyValues);

                        column.data("formatter", newFormatter);
                    });
                });
            }

            // end formatter

            //These Export Properties are for the whole report so they don't set any data on the column, row, or section, but still need to updateHiddenField() so the dirty logic is triggered
            exportProperties.csv.delimiter.change(updateHiddenField);
            exportProperties.csv.customDelimiter.change(updateHiddenField);
            exportProperties.csv.textQualifier.change(updateHiddenField);
            exportProperties.csv.includeTextQualifierOnlyWhenRequired.change(updateHiddenField);
            exportProperties.xml.includeRootNode.change(function ()
            {
                const currentValue = skyward.controls.getValue(exportProperties.xml.includeRootNode);
                skyward.controls.toggle(exportProperties.xml.nodeName, currentValue);

                if (currentValue === false)
                {
                    //clearing this input will also trigger updateHiddenField()
                    skyward.controls.clearValue(exportProperties.xml.nodeName);
                }
                else
                {
                    updateHiddenField();
                }
            });
            exportProperties.xml.nodeName.change(updateHiddenField);

            setupChangeEvent(dataFont, { prop: "dataFontFamily" });
            setupChangeEvent(dataFontSize, { prop: "dataFontSize" });
            setupChangeEvent(editorPaddingLeft, { prop: "paddingLeft" });
            setupChangeEvent(editorPaddingRight, { prop: "paddingRight" });
            setupChangeEvent(editorPaddingTop, { prop: "paddingTop" });
            setupChangeEvent(editorPaddingBottom, { prop: "paddingBottom" });
            setupChangeEvent(runningTotal, { prop: "isRunningTotal" });
            setupChangeEvent(groupColumnSortHeaderTypes, { prop: "fieldColumnType" });
            setupChangeEvent(overlapMode, { prop: "overlapMode" });
            setupChangeEvent(dataItalic, { prop: "dataItalic" });
            setupChangeEvent(dataBold, { prop: "dataBold" });
            setupChangeEvent(dataUnderline, { prop: "dataUnderline" });
            setupChangeEvent(dataBackgroundColor, {
                setDataOverride: (element, value) =>
                {
                    element.data("backColor", value);
                    if (isLine(element))
                    {
                        for (let column of element.find(".jsColumn.reportDesignerHidden"))
                        {
                            applyColumnCss($(column));
                        }
                    }
                }
            });
            setupColorPreviewEvent(dataBackgroundColor, { prop: "backColor" });
            setupChangeEvent(dataForeColor, { prop: "dataForeColor" });
            setupColorPreviewEvent(dataForeColor, { prop: "dataForeColor" });
            setupChangeEvent(editorVerticalAlign, { prop: "verticalAlignment" });
            setupChangeEvent(editorTextAlign, { prop: "dataTextAlignment" });
            setupChangeEvent(pageSectionColumnDisplayType, { prop: "displayType" });
            setupChangeEvent(pageSectionColumnPromptDisplayType, { prop: "displayType" });
            setupChangeEvent(positionX, { prop: "positionX" });
            setupChangeEvent(positionY, { prop: "positionY" });
            setupChangeEvent(editorAggregateDelimiter, { prop: "aggregateDelimiter" });
            setupChangeEvent(exportProperties.json.column.name, { prop: "jsonPropertyName" });
            setupChangeEvent(exportProperties.xml.row.nodeName, { prop: "nodeName" });
            setupChangeEvent(exportProperties.xml.column.nodeName, { prop: "nodeName" });
            setupChangeEvent(exportProperties.xml.column.nodeType, { prop: "nodeType" });
            setupChangeEvent(exportProperties.fixedWidth.column.startPosition, { prop: "fixedWidthStartPosition" });
            setupChangeEvent(exportProperties.fixedWidth.column.length, { prop: "fixedWidthLength" });
            setupChangeEvent(borderLeft, { prop: "borderLeft" });
            setupChangeEvent(borderRight, { prop: "borderRight" });
            setupChangeEvent(borderTop, { prop: "borderTop" });
            setupChangeEvent(borderBottom, { prop: "borderBottom" });
            setupChangeEvent(borderWidth, { prop: "borderWidth" });
            setupChangeEvent(borderStyle, { prop: "borderStyle" });
            setupChangeEvent(borderColor, { prop: "borderColor" });
            setupColorPreviewEvent(borderColor, { prop: "borderColor" });
            setupChangeEvent(editorEmptyLinesToPrint, { prop: "emptyLinesToPrint" });
            setupChangeEvent(editorPageBreakBeforeSectionPrints, {
                setDataOverride: (section, value) =>
                {
                    section.data("pageBreakBeforeSection", value);
                    if (!value)
                    {
                        removeInvalidPageNumberColumns();
                    }
                }
            });
            setupChangeEvent(editorPrintIfEmpty, { prop: "printIfEmpty" });
            setupChangeEvent(exportProperties.xml.section.nodeName, { prop: "nodeName" });
            setupChangeEvent(exportProperties.json.section.name, { prop: "jsonPropertyName" });
            setupChangeEvent(editorSectionAndLineDisplayName, {
                setDataOverride: (element, value) =>
                {
                    let selectedRow = element;
                    if (isSection(element))
                    {
                        element.data("displayName", value);
                        selectedRow = getSectionToolbar(element);
                    }

                    selectedRow.data("reportLabelText", value);
                    labelBuilder.setRelatedLabel(selectedRow, value);
                }
            });
            setupChangeEvent(columnHeight, { setDataOverride: setColumnHeight })
            setupChangeEvent(columnWidth, { setDataOverride: setColumnWidth });
            setupChangeEvent(lineHeight, { setDataOverride: setRowHeight });
            setupChangeEvent(editorRepeatHeaderForEachDataRow, { prop: "repeatHeaderForEachDataRow" });
            setupChangeEvent(editorRepeatRowOnPageIfDetailsPresent, { prop: "repeatOnPageIfDetailsPresent" });
            setupChangeEvent(editorPrintAtBottomOfPage, {
                getValueOverride: getInputData,
                setDataOverride: getBoolPromptSetDataFunc("print-at-bottom-of-page")
            });
            setupChangeEvent(editorRepeatLineAfterStart, {
                getValueOverride: getInputData,
                setDataOverride: getBoolPromptSetDataFunc("repeat-line-after-start")
            });
            setupChangeEvent(editorPrintReportFooterOnNewPage, {
                getValueOverride: getInputData,
                setDataOverride: getBoolPromptSetDataFunc("print-report-footer-on-new-page")
            });

            setupChangeEvent(editorColumnText, {
                setDataOverride: (column, designerText) =>
                {
                    let columnData = column.data();
                    if (columnData.fieldColumnType === COLUMN_TYPES.FORMTEXT_COLUMN)
                    {
                        designerText = skyward.reporting.prompts.promptCollection.ConvertFriendlyNamesToPromptBindings(designerText);
                        designerText = CalculatedFields_Model.ConvertFriendlyNamesToBindings(designerText);
                    }

                    const section = column.closest(".jsSection");
                    if (isParentDisplayOnSingleLine(section) && columnData.designerText?.indexOf(SINGLE_LINE_HEADER_INDEX_BINDING) >= 0 && !designerText?.indexOf(SINGLE_LINE_HEADER_INDEX_BINDING) >= 0)
                    {
                        columnData.singleLineIndexRemoved = true;
                    }
                    else
                    {
                        columnData.singleLineIndexRemoved = false;
                    }

                    columnData.designerText = designerText;
                }
            });

            setupChangeEvent(editorDisplayOnSingleLine, {
                setDataOverride: (section, value) =>
                {
                    section.data("displayOnSingleLine", value);
                    for (let detailSection of getNestedDetailSections(section))
                    {
                        $(detailSection).data("displayOnSingleLine", value);
                    }
                }
            });

            setupChangeEvent(isHiddenSelector.elements.wrapper, {
                getValueOverride: () => isHiddenSelector.getUpdatedIsHiddenCondition(),
                setDataOverride: (element, value) =>
                {
                    element.data("isHiddenCondition", value);
                    if (isSection(element) || isLine(element))
                    {
                        applySectionOrRowHiddenCondition(element);
                    }
                }
            });

            setupChangeEvent(whenHiddenOption, { prop: "whenHiddenOption" });

            setupChangeEvent(editorVariablesToReset, {
                getValueOverride: () => skyward.reporting.getVariableIDsToReset(),
                setDataOverride: (row, value) => row.data("variableIdsToReset", value).attr("data-variable-ids-to-reset", JSON.stringify(value))
            });

            setupChangeEvent(resetOption, {
                setDataOverride: (column, value) => column.data("resetOn", value).attr("data-reset-on", value)
            }); // Attribute must also be set for css-search in deleteInvalidPageNumberColumns()

            setupChangeEvent(editorColumnFilterInput, {
                getValueOverride: (input) =>
                {
                    return {
                        filter: input.data("filterCondition"),
                        parameters: input.data("parameters"),
                        filterSchemaFields: input.data("filterSchemaFields")
                    };
                },
                setDataOverride: (column, value) =>
                {
                    column.data("columnFilterJson", value.filter).attr("data-column-filter-json", value.filter);
                    column.data("parameters", value.parameters || []);
                    column.data("filterSchemaFields", value.filterSchemaFields);
                }
            });

            setupChangeEvent(rotationValue, { setDataOverride: setColumnRotation });
            setupChangeEvent(rotationRange, { setDataOverride: setColumnRotation });

            setupChangeEvent(editorMediaId, {
                setDataOverride: (column, value) =>
                {
                    let columnData = column.data();
                    columnData.useSystemLogo = false;
                    columnData.mediaId = value;

                    let url = skyward.global.virtualDir + "SkySys/Media/DownloadReportMedia/" + value;
                    column.find("img").attr('src', url);
                }
            });

            setupChangeEvent(editorUseSystemLogo, {
                setDataOverride: (column, value) =>
                {
                    let columnData = column.data();
                    columnData.useSystemLogo = value;
                    columnData.mediaId = null;
                    let url = value ? skyward.global.virtualDir + "SkySys/Media/DownloadLogo" : null;
                    column.find("img").attr('src', url);
                }
            });

            setupChangeEvent(editorVariableToSet, {
                getValueOverride: (input) => input.data("variableIdToSet"),
                setDataOverride: (column, value) =>
                {
                    if (value != undefined && value !== "")
                    {
                        column.data("variableIdToSet", value).attr("data-variable-id-to-set", value);
                    }
                    else
                    {
                        column.removeData("variableIdToSet").removeAttr("data-variable-id-to-set");
                    }
                }
            });

            setupChangeEvent(editorAggregateType, {
                setDataOverride: (column, aggregateType) =>
                {
                    let columnData = column.data();

                    const previousAggregateType = columnData.aggregateType;
                    let isDelimitedAggregate = delimitedAggregators.indexOf(aggregateType) != -1;
                    let fieldType = skyward.reporting.getAggregateColumnFieldType(columnData.columnFieldType, aggregateType);

                    if (aggregateType != previousAggregateType)
                    {
                        return confirmUpdateAggregateTypeColumn(column)
                            .done((foundNodes) =>
                            {
                                // call back will be called when the user clicks "Yes" or if there are no usages found
                                columnData.aggregateType = aggregateType;
                                columnData.fieldType = fieldType;

                                if (!isDelimitedAggregate)
                                {
                                    column.removeData("aggregateDelimiter");
                                }
                                else if (!columnData.aggregateDelimiter)
                                {
                                    columnData.aggregateDelimiter = editorAggregateDelimiter.data("defaultValue");
                                }

                                column.attr("data-field-type", fieldType); // I'm not sure why we need to set the attr here, but it was happening before

                                for (const relatedColumn of getColumnsBySourceColumnID(columnData.columnId).map((i, e) => $(e)))
                                {
                                    const relatedColumnData = relatedColumn.data();

                                    switch (relatedColumnData.fieldColumnType)
                                    {
                                        case COLUMN_TYPES.AGGREGATE_COLUMN:
                                            relatedColumnData.columnFieldType = fieldType;
                                            break;
                                        case COLUMN_TYPES.FUTURE_VALUE_COLUMN:
                                            relatedColumnData.fieldType = fieldType;
                                            relatedColumnData.designerText = `Future ${getColumnLabelWithPreText(column)}`;
                                            applyColumnCss(relatedColumn);
                                            break;
                                    }
                                }

                                if (foundNodes)
                                {
                                    // null out any hidden conditions using this column
                                    for (const rootNode of foundNodes)
                                    {
                                        for (const node of rootNode.allNodes())
                                        {
                                            if (node instanceof usageLocations.HiddenConditionUsageNode)
                                            {
                                                let element = node.sourceDetail.element;
                                                if (element)
                                                {
                                                    removeHiddenConditionWithColumnID(element, columnData.columnId);
                                                    if (node.sourceDetail.type == usageLocations.SourceTypes.Column)
                                                    {
                                                        updateColumnIsHiddenConditionFormatting(element)
                                                    }
                                                    else if (node.sourceDetail.type == usageLocations.SourceTypes.Line || node.sourceDetail.type == usageLocations.SourceTypes.Section)
                                                    {
                                                        applySectionOrRowHiddenCondition(element);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }).fail(() =>
                            {
                                // undo input change
                                skyward.controls.setValue(editorAggregateType, previousAggregateType, true);
                            });
                    }
                }
            });
        };

        var isBarcodeFormatter = function (formatterData)
        {
            return formatterData && formatterData.formatterName === "Barcode";
        };

        var getFormatterDataDefaults = function (formatterName)
        {
            if (!formatterName || formatterName == FORMATTER_NAMES.DEFAULT || enumMaps.FormatterTypeNames.indexOf(formatterName) === -1)
            {
                return null;
            }

            var results = {
                $type: "Skyward.Business.Reporting.TypeFormatting." + formatterName + "Formatter, Skyward.Business",
                formatterName: formatterName
            };
            $.each(formatterControlsDataMap.get(formatterName), function (i, controlData)
            {
                $.each(controlData.dataBindings, function (propertyName, dataSource)
                {
                    results[propertyName] = (controlData.defaults[formatterName] || {})[propertyName];
                });
            });
            return results;
        };

        var getFormatterInputPropertyValues = function (controlData)
        {
            let element = controlData.element;

            let results = {}; // an object of the properties to set on the formatter

            $.each(controlData.dataBindings, function (propertyName, dataSource)
            {
                switch (dataSource)
                {
                    case "Val":
                        if (element.is("input.checkbox"))
                        {
                            results[propertyName] = element.prop("checked");
                        }
                        else
                        {
                            var value = element.val();

                            if (element.attr("type") == "text")
                            {
                                results[propertyName] = element.val().toString();
                            }
                            else if (element.attr("type") == "number")
                            {
                                value = $.safeRound(value) || 0;
                                var min = parseInt(element.attr("min"));
                                var max = parseInt(element.attr("max"));

                                if (value < min)
                                {
                                    value = min;
                                }
                                else if (value > max)
                                {
                                    value = max;
                                }
                            }
                            else if (skyward.extensions.isNumeric(value))
                            {
                                value = $.safeRound(value);
                            }

                            results[propertyName] = value;
                        }
                        break;
                    case "FieldSelectorText":
                        results[propertyName] = element.find(".fieldSelectorText").text();
                        break;
                    case "Data":
                    case "FieldSelectorIcon":
                        results[propertyName] = element.data(propertyName);
                        break;
                }
            });

            return results;
        };

        //END INIT FUNCTIONS

        var columnResizableOptions =
        {
            minWidth: 5,
            handles: "e, s, se",
            containment: "parent",
            autoHide: true,
            start: function (e, ui)
            {
                const clearSelectedColumns = !keyboardCommands.isMultiSelectKeyPressed(e);
                setSelectedColumn(ui.element, clearSelectedColumns);
            },
            stop: function (e, ui)
            {
                if (ui.size.height !== ui.originalSize.height)
                {
                    setColumnHeight(ui.element, ui.size.height);

                    if (keyboardCommands.isSmartResizeKeyPressed(e))
                    {
                        cloneDataAndCssToRelatedColumns(ui.element, { 'fieldHeight': ui.size.height }, { height: ui.size.height + "px" });
                    }
                }

                if (ui.size.width !== ui.originalSize.width)
                {
                    setColumnWidth(ui.element, ui.size.width);

                    if (keyboardCommands.isSmartResizeKeyPressed(e))
                    {
                        cloneDataAndCssToRelatedColumns(ui.element, { 'fieldWidth': ui.size.width }, { width: ui.size.width + "px" });
                    }
                }

                applyColumnCss(ui.element);
                updateHiddenField();
                setColumnProperties();
            }
        };

        var getNewColumnType = function (line, item, isGroupColumn)
        {
            const lineType = line.data("lineType");
            const itemData = item.data();
            const fieldType = skyward.reporting.reportColumn.getFieldType(itemData);

            if (itemData.isFutureColumn)
            {
                return COLUMN_TYPES.FUTURE_VALUE_COLUMN;
            }

            switch (lineType)
            {
                case LINE_TYPES.DATA_LINE:
                case LINE_TYPES.SORT_HEADER_LINE:
                    if (isGroupColumn)
                    {
                        return COLUMN_TYPES.GROUP_COLUMN;
                    }
                    else if (itemData.pageSectionColumnType)
                    {
                        return COLUMN_TYPES.PAGE_SECTION_COLUMN;
                    }
                    else if (fieldType === "Image")
                    {
                        return COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN;
                    }
                    else
                    {
                        return COLUMN_TYPES.DATA_COLUMN;
                    }
                case LINE_TYPES.FOOTER_LINE:
                    if (itemData.pageSectionColumnType || line.hasClass(".jsHeaderFooter"))
                    {
                        return COLUMN_TYPES.PAGE_SECTION_COLUMN;
                    }
                    else if (itemData.sourceColumnId)
                    {
                        return itemData.columnFieldType == "Image" ? COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN : COLUMN_TYPES.AGGREGATE_COLUMN;
                    }
                    else
                    {
                        return COLUMN_TYPES.FOOTER_COLUMN;
                    }
                case LINE_TYPES.HEADER_LINE:
                    if (line.hasClass('jsHeaderFooter'))
                    {
                        return COLUMN_TYPES.PAGE_SECTION_COLUMN;
                    }
                    else if (isGroupColumn)
                    {
                        return COLUMN_TYPES.GROUP_COLUMN_HEADER;
                    }
                    else if (itemData.pageSectionColumnType)
                    {
                        return COLUMN_TYPES.PAGE_SECTION_COLUMN;
                    }
                    return COLUMN_TYPES.HEADER_COLUMN;
                case LINE_TYPES.AGGREGATE_LINE:
                case LINE_TYPES.SORT_AGGREGATE_LINE:
                    if (itemData.pageSectionColumnType)
                    {
                        return COLUMN_TYPES.PAGE_SECTION_COLUMN;
                    }
                    else if (isGroupColumn)
                    {
                        return COLUMN_TYPES.GROUP_COLUMN_AGGREGATE;
                    }
                    return fieldType === "Image" ? COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN : COLUMN_TYPES.AGGREGATE_COLUMN;
                default:
                    return COLUMN_TYPES.DATA_COLUMN;
            }
        };

        var designerError = function (message)
        {
            skyward.modalLayer.showDialog("Error", message, [{ text: "Close", icon: "Close" }]);
            return;
        };

        /**
         * @param {Object} params
         * @param {Partial<ReportFieldProps>} params.treeBrowseData
         * @param {JQuery} params.currentLine
         * @param {JQuery} params.section
         * @param {{ top: number | null, left: number | null }} params.position
         * @param {boolean} [params.autoCreatedColumn]
         */
        const insertTreeBrowseItem = function (params)
        {
            const currentLine = params.currentLine;
            let treeBrowseItem;

            if (params.treeBrowseData)
            {
                // Ideally, in the future it will be possible to work with treeBrowseData directly,
                // rather than masquerading as a jQuery element.  .data("key") is specific to jQuery
                // and makes this more challenging.
                treeBrowseItem =
                {
                    data: function (key)
                    {
                        if (arguments.length > 0)
                        {
                            console.warn("Please don't rely on this data wrapper!");
                            const camelCaseKey = key.replace(/-[a-z]/g, function (match) { return match[1].toUpperCase(); });
                            return params.treeBrowseData[camelCaseKey];
                        }
                        return params.treeBrowseData;
                    }
                };
            }
            else
            {
                treeBrowseItem = { data: function () { return undefined; } };
            }

            const columnParams = {
                section: params.section,
                newItem: treeBrowseItem,
                reportLine: currentLine,
                position: params.position,
                autoCreatedColumn: params.autoCreatedColumn,
                isDynamicColumn: params.treeBrowseData?.isDynamicColumn || params.treeBrowseData?.isColumnGroup // isDynamicColumn is from tree browse, while isColumnGroup is from field selection panels
            };

            return insertFieldItem(currentLine, columnParams);
        };

        var insertFieldItem = function (currentLine, columnParams)
        {
            const currentSection = getParentSection(currentLine);
            if (currentSection.hasClass('collapseSection'))
            {
                return false;
            }

            const lineData = currentLine.data();
            if (lineData.lineType)
            {
                const newType = getNewColumnType(currentLine, columnParams.newItem, columnParams.isDynamicColumn);

                switch (lineData.lineType)
                {
                    case LINE_TYPES.DATA_LINE:
                        if (columnParams.newItem.data().sourceColumnId)
                        {
                            return designerError("Unable to add aggregate field to data line.");
                        }
                        insertDataColumn(columnParams);
                        break;
                    case LINE_TYPES.HEADER_LINE:
                        columnParams.newItem = createNewColumn({ type: newType, relatedItem: columnParams.newItem, usesSingleLineIndex: isParentDisplayOnSingleLine(columnParams.section) });
                        insertColumnHelperFunction(columnParams);
                        break;
                    case LINE_TYPES.FOOTER_LINE:
                        if (columnParams.isDynamicColumn)
                        {
                            return designerError("Unable to add a column group to a footer line.");
                        }
                        columnParams.newItem = createNewColumn({ type: newType, relatedItem: columnParams.newItem });
                        insertColumnHelperFunction(columnParams);
                        break;
                    case LINE_TYPES.SORT_HEADER_LINE:
                    case LINE_TYPES.AGGREGATE_LINE:
                    case LINE_TYPES.SORT_AGGREGATE_LINE:
                        columnParams.newItem = createNewColumn({ relatedItem: columnParams.newItem, type: newType });
                        if (newType === COLUMN_TYPES.FUTURE_VALUE_COLUMN)
                        {
                            insertColumnHelperFunction(columnParams);
                        }
                        else
                        {
                            insertColumnIntoAggregateLine(columnParams);
                        }
                        break;
                }
                setSelectedColumn(columnParams.newItem, true);
                columnParams.newItem.find('.visualLabel').text(getColumnLabelWithPreText(columnParams.newItem));
                initFieldsUsedInReport(getSectionData(columnParams.section));
                return true;
            }
            return false;
        };

        var insertColumnIntoAggregateLine = function (columnParams)
        {
            const sectionDataLines = getSectionDataLines(columnParams.section);
            const sectionDataLine = sectionDataLines.first();

            const newItemData = columnParams.newItem.data();
            const columnExists = newItemData.sourceColumnId !== undefined ||
                (newItemData.absoluteFieldPath ? 
                    getColumnsInLineByAbsoluteFieldPath($.merge(sectionDataLines, getSectionAllAggregateLines(columnParams.section)), newItemData.absoluteFieldPath).length > 0 :
                    getColumnsInLineByFieldName($.merge(sectionDataLines, getSectionAllAggregateLines(columnParams.section)), newItemData.fieldName).length > 0); //See @NOTE:FIELDNAME

            if (columnExists === false)
            {
                const dataColumnParams = {
                    isDynamicColumn: columnParams.isDynamicColumn,
                    section: columnParams.section,
                    newItem: columnParams.newItem,
                    reportLine: sectionDataLine,
                    position: columnParams.position,
                    autoCreatedColumn: columnParams.autoCreatedColumn
                };

                //insert the datacolumn (which also inserts the header column)
                const position = insertDataColumn(dataColumnParams);
                columnParams.position.left = columnParams.position.left || position.left;
                columnParams.position.top = columnParams.position.top || position.top;
                columnParams.autoCreatedColumn = true;
            }

            //insert the aggregate column
            insertColumnHelperFunction(columnParams);

            toggleAggregateMathButtonState(columnParams.reportLine);
        };

        var insertPromptListItem = function (params)
        {
            var currentLine = params.currentLine;
            var columnParams = {
                section: params.section,
                newItem: params.promptItem,
                reportLine: currentLine,
                position: params.position
            };

            columnParams.newItem = createNewColumn({
                type: COLUMN_TYPES.PAGE_SECTION_COLUMN,
                relatedItem: columnParams.newItem
            });

            insertFieldItem(currentLine, columnParams);
        };

        var getDefaultDraggableOptions = function ()
        {
            return {
                cursorAt: { top: 0, left: 0 },
                delay: 150,
                scope: 'designer',
                helper: function ()
                {
                    const listItem = $(this);
                    const convertedItem = $("<div/>").html(listItem.children().first().html()).data(listItem.data());
                    convertedItem.find('svg').remove();
                    convertedItem.css({ "z-index": 999, display: undefined, "background-color": "white" });
                    convertedItem.width(convertedItem.data('fieldWidth') || DEFAULT_COLUMN_WIDTH);
                    convertedItem.height(DEFAULT_COLUMN_HEIGHT);
                    return convertedItem;
                },
                appendTo: $(document.body),
                grid: [1, 1],
                opacity: 0.8
            };
        };

        //UI UPDATE FUNCTIONS
        var initDesignerUI = function ($section)
        {
            //if no section is passed in, get the currently selected one
            if (typeof $section === "undefined")
            {
                $section = designer.find('.sectionSelected');

                //none selected
                if ($section.length === 0)
                {
                    return;
                }
            }
            else if ($section.length === 0)
            {
                initializeToolbarEvents();
                return;
            }

            var sectionData = getSectionData($section);
            updateDesignerSidebarCalculatedFieldList(sectionData);

            skyward.reporting.prompts.populateExtraColumnOptionsWithPrompts(designer.find(".reportDesignerPromptFieldsMenu"));

            // disable existing ui-droppable
            designer.find('.ui-droppable').each(function ()
            {
                $(this).droppable('disable');
            });

            getAllNonPreviewLines($section).each(function ()
            {
                var currentLine = $(this);

                currentLine.find('.reportColumn').each(function ()
                {
                    initColumnDragging($(this));
                });

                if (currentLine.hasClass('ui-droppable'))
                {
                    currentLine.droppable('enable');
                }
                else
                {
                    currentLine.droppable(
                        {
                            scope: 'designer',
                            accept: function (item)
                            {
                                var section = currentLine.closest(".jsSection");

                                if (!section.hasClass('sectionSelected'))
                                {
                                    return false;
                                }

                                if (item.hasClass("calculatedField"))
                                {
                                    var calculatedField = CalculatedFields_Model.Get(item.data().fieldid);
                                    if (calculatedField == undefined)
                                    {
                                        return false;
                                    }

                                    var currentSectionData = getSectionData(section);
                                    return calculatedField.schemaObject === currentSectionData.rootModule + "." + currentSectionData.rootObject &&
                                        (calculatedField.relationshipPath ?? "") === (currentSectionData.entireRelationshipPath ?? "");
                                }
                                else
                                {
                                    return (item.is(".variable.treebrowserow")) || !item.hasClass('jsColumn');
                                }
                            },
                            drop: function (event, ui)
                            {
                                if (ui.draggable.hasClass("calculatedField"))
                                {
                                    var calculatedFieldID = ui.draggable.data().fieldid;
                                    var calculatedField = CalculatedFields_Model.Get(calculatedFieldID);
                                    skyward.reporting.addCalculatedField(calculatedField, currentLine, {
                                            top: ui.offset.top - currentLine.offset().top,
                                            left: ui.offset.left - currentLine.offset().left
                                        });
                                }
                                else if (ui.draggable.hasClass("variable"))
                                {
                                    const data = ui.draggable.data();
                                    skyward.reporting.insertVariableColumn(data.model, data.view, {
                                            top: ui.offset.top - currentLine.offset().top,
                                            left: ui.offset.left - currentLine.offset().left
                                        }, currentLine);
                                }
                                else
                                {
                                    var currentSection = currentLine.closest(".sectionSelected");
                                    var params = {
                                        currentLine: currentLine,
                                        section: currentSection,
                                        position: {
                                            top: ui.offset.top - currentLine.offset().top,
                                            left: ui.offset.left - currentLine.offset().left
                                        },
                                        autoCreatedColumn: true
                                    };

                                    if (ui.draggable.hasClass("promptItem"))
                                    {
                                        params.promptItem = ui.draggable;
                                        insertPromptListItem(params);
                                    }
                                    else if (ui.draggable.hasClass("fieldSelectionSectionRow"))
                                    {
                                        params.treeBrowseData = ui.draggable.data();
                                        insertTreeBrowseItem(params);
                                    }
                                    else
                                    {
                                        var treeBrowseData = skyward.treebrowse.getTreeBrowseDataByName("reportObjectBrowser");
                                        params.treeBrowseData = treeBrowseData.getFieldData(ui.draggable);
                                        insertTreeBrowseItem(params);
                                    }
                                }
                            },
                            tolerance: "pointer"
                        }).disableSelection();
                }
            });

            // Disable selection on relationships
            designer.find('.selectable.relationship').each(function ()
            {
                var $label = $(this);
                var $span = $label.parent();
                var $li = $span.parent();

                $label.disableSelection();
                $span.disableSelection();
                $li.disableSelection();
            });

            designer.find(".reportDesignerPromptsList").each(function (index, element)
            {
                $(element).find(".jsDraggable").draggable(getDefaultDraggableOptions()).disableSelection();
            });

            var promptList = designer.find(".reportDesignerPromptsList");

            promptList.off("dblclick.insertPromptListItem", ".promptItem").on("dblclick.insertPromptListItem", ".promptItem", function ()
            {
                const row = currentRow || currentSelectedColumns.getRowByFirstSelectedColumn();

                if (row)
                {
                    var promptItem = $(this);
                    var currentSection = row.closest(".sectionSelected");
                    var params = {
                        currentLine: row,
                        section: currentSection,
                        position: { top: null, left: null }
                    };

                    params.promptItem = promptItem;
                    insertPromptListItem(params);
                }
            });

            initLineResizing();
            initColumnWidthSlider($section);

            initializeToolbarEvents();
            initFieldsUsedInReport(sectionData);
        };

        skyward.reporting.onFilterBuilderSave = function (data)
        {
            skyward.reporting.updateHiddenField();
            if (data.conditionChanged)
            {
                skyward.reporting.prompts.populateExtraColumnOptionsWithPrompts($(".reportDesignerPromptFieldsMenu"));
            }
            initFieldsUsedInReport();
        }

        const initFieldsUsedInReport = function (sectionData)
        {
            if (!sectionData)
            {
                const section = getCurrentSection();
                if (section && section.length > 0)
                {
                    sectionData = getSectionData(section);
                }
            }

            if (sectionData)
            {
                const usedFields = skyward.reporting.fields.buildFieldsList([], sectionData.sectionID, false, false, false);

                /** @type {PanelData[]} */
                const panelData = [
                    {
                        selector: ".js-usedFieldsPanel",
                        fields: usedFields,
                        buildFieldPath: true
                    }
                ];

                skyward.fieldselectionpanels.initializePanels(leftSidePanel, panelData, insertFieldsUsedInReportItem, null);
            }

            leftSidePanel.find(".fieldSelectionSectionTable").each(function (index, element)
            {
                $(element).find(".fieldSelectionSectionRow").draggable(
                    $.extend(getDefaultDraggableOptions(),
                        {
                            helper: function ()
                            {
                                const convertedItem = $(this).clone();
                                convertedItem.find('svg,input').remove();
                                convertedItem.text(convertedItem.find('.fieldCell .fieldCellContent').text());
                                convertedItem.css({ "z-index": 999, display: undefined, "background-color": "white" });
                                convertedItem.width(convertedItem.data('fieldWidth') || DEFAULT_COLUMN_WIDTH);
                                convertedItem.height(convertedItem.data('fieldHeight') || DEFAULT_COLUMN_HEIGHT);
                                return convertedItem;
                            },
                            appendTo: ".reportDesignerGrid"
                        })
                ).disableSelection()
            });
        };

        skyward.reporting.openFieldUsageLocationsModal = function (field)
        {
            const section = getCurrentSection();
            const sectionData = getSectionData(section);
            const placesToSearch = usageLocations.fieldPlacesToSearch(field, sectionData.sectionID);

            usageLocations.openModal("field-usages-dialog", placesToSearch.traverse, field.displayPathText);
        }

        /** @type {SelectFieldHandler} */
        const insertFieldsUsedInReportItem = function (event, fieldData)
        {
            const currentSection = designer.find(".sectionSelected");
            const currentLine = getSectionSelectedRow(currentSection);

            insertTreeBrowseItem({
                    treeBrowseData: fieldData,
                    currentLine: currentLine,
                    section: currentSection,
                    position:
                    {
                        top: null,
                        left: null
                    }
                });
        };

        var initColumnDragging = function ($column)
        {
            if ($column.draggable("instance"))
            {
                $column.draggable("destroy"); //remove the draggable if it exists already
            }

            const isRotated = $column.data("rotation") != 0; //used to determine if we should do custom containment which does not work with snapping

            $column.draggable(
                {
                    cursorAt: { left: 0, top: 0 },
                    cursor: "move",
                    containment: isRotated ? "false" : "parent",
                    scroll: true,
                    helper: "original",
                    distance: 5,
                    snap: true,
                    snapMode: "inner",
                    snapTolerance: 10,
                    grid: [1, 1],
                    opacity: 0.8,
                    start: function (event, ui)
                    {
                        ui.helper.css("z-index", 9999);

                        if (isRotated)
                        {
                            let parentRect = this.parentElement.getBoundingClientRect();
                            let rect = this.getBoundingClientRect();
                            // [x,y] position of top left point
                            let xPos = $(ui.helper).data().positionX + parentRect.left;
                            let yPos = $(ui.helper).data().positionY + parentRect.top;
                            ui.helper.bounds =
                            {
                                parentRect: parentRect,
                                leftWidth: xPos - rect.left,
                                rightWidth: rect.right - xPos,
                                topHeight: yPos - rect.top,
                                bottomHeight: rect.bottom - yPos,
                                mouseXOffset: event.pageX - xPos,
                                mouseYOffset: event.pageY - yPos
                            };
                        }
                    },
                    drag: function (event, ui)
                    {
                        if (isRotated)
                        {
                            let parentRect = ui.helper.bounds.parentRect;
                            let bottomMax = parentRect.height - ui.helper.bounds.bottomHeight;
                            let rightMax = parentRect.width - ui.helper.bounds.rightWidth;
                            ui.position.top = Math.min(Math.max(ui.helper.bounds.topHeight, event.pageY - ui.helper.bounds.parentRect.top - ui.helper.bounds.mouseYOffset), bottomMax);
                            ui.position.left = Math.min(Math.max(ui.helper.bounds.leftWidth, event.pageX - ui.helper.bounds.parentRect.left - ui.helper.bounds.mouseXOffset), rightMax);
                        }
                    },
                    stop: function (event, ui)
                    {
                        const clearSelectedColumns = !keyboardCommands.isMultiSelectKeyPressed(event);

                        setSelectedColumn(ui.helper, clearSelectedColumns);
                        const roundedLeft = $.safeRound(ui.position.left);
                        const roundedTop = $.safeRound(ui.position.top);
                        positionX.val(roundedLeft);
                        positionY.val(roundedTop);
                        ui.helper.data('positionX', roundedLeft);
                        ui.helper.data('positionY', roundedTop);
                        ui.helper.css('z-index', "");

                        if (keyboardCommands.isSmartDragKeyPressed(event))
                        {
                            cloneDataAndCssToRelatedColumns(ui.helper, { 'positionX': roundedLeft, 'positionY': roundedTop }, { "top": roundedTop + "px", "left": roundedLeft + "px" });
                        }

                        updateHiddenField();
                    }
                });
        };

        var initLineResizing = function ()
        {
            var resizeLines = designer.find(".lineWrapper:not(.jsPrintOnOneLinePreviewLine)");
            resizeLines.resizable({
                minWidth: 5,
                handles: "s",
                autoHide: false,
                stop: function (e, ui)
                {
                    setRowHeight(ui.element, ui.element.outerHeight());
                    updateHiddenField();
                    if (ui.element.hasClass("row-selected"))
                    {
                        setRowProperties(ui.element);
                    }
                }
            });
        };

        var initColumnWidthSlider = function ($section)
        {
            getSectionAllColumns($section).each(function ()
            {
                var jqThis = $(this);
                jqThis.resizable(columnResizableOptions);
            });
        };

        var initLeftSidePanelResizing = function ()
        {
            leftSidePanel.resizable({
                minWidth: 230,
                handles: "e",
                autoHide: false,
                stop: function (e, ui)
                {
                    ui.element.data("widthOverride", ui.size.width);
                    updateUserSettings();
                }
            });
        };

        const initLeftSidePanelToggling = function ()
        {
            if (leftSidePanel.data('panelInitialized'))
            {
                return;
            }

            leftSidePanel.data('panelInitialized', true);

            const panelStateData = leftSidePanel.data('initPanelState');

            const panelMap = {
                usedFieldsIsOpen: leftSidePanel.find('.js-usedFieldsPanel'),
                allFieldsIsOpen: leftSidePanel.find('.js-reportDesignerFieldsMenu'),
                aggregateFieldsIsOpen: leftSidePanel.find('.reportDesignerAggregateFieldsMenu'),
                calculatedFieldsIsOpen: leftSidePanel.find('.reportDesignerCalculatedFieldsMenu'),
                promptFieldsIsOpen: leftSidePanel.find('.reportDesignerPromptFieldsMenu'),
                environmentVariableFieldsIsOpen: leftSidePanel.find('.reportDesignerEnvironmentVariableFieldsMenu'),
                variablesIsOpen: leftSidePanel.find('.reportDesignerVariablesMenu'),
                specialFieldsIsOpen: leftSidePanel.find('.reportDesignerSpecialFieldsMenu'),
                xmlExportSettingsIsOpen: leftSidePanel.find('.jsXMLExportProperties'),
                csvExportSettingsIsOpen: leftSidePanel.find('.reportDesignerCSVProperties'),
                fixedWidthExportSettingsIsOpen: leftSidePanel.find('.jsFixedWidthExportProperties'),
                jsonExportSettingsIsOpen: leftSidePanel.find('.jsJSONExportProperties')
            };

            const debouncedUpdateUserSettings = skyward.debounce(updateUserSettings, 1000, 1000);

            $.each(panelMap, function (stateKey, $panel)
            {
                const $header = $panel.find('.collapsePanelHeader');
                const $contents = $panel.find('.collapsePanelContents');
                if (panelStateData[stateKey] !== $contents.hasClass('expanded'))
                {
                    skyward.collapsePanel.toggle.apply($header);
                }

                $panel.off('collapsepanel:toggled').on('collapsepanel:toggled', function (e, data)
                {
                    panelStateData[stateKey] = data.expanded;
                    leftSidePanel.data('initPanelState', panelStateData);
                    debouncedUpdateUserSettings();
                });
            });
        };

        var cloneDataAndCssToRelatedColumns = function (sourceColumn, data, css)
        {
            var columnId = sourceColumn.data("dataColumnId");
            if (columnId)
            {
                var relatedHeaderColumn = getSectionHeaderLines(getParentSection(sourceColumn)).find("[data-data-column-id='" + columnId + "']");
                if (relatedHeaderColumn)
                {
                    relatedHeaderColumn.data(data);
                    relatedHeaderColumn.css(css);
                }
            }
        };

        var initLeftSidePanel = function ()
        {
            const $section = designer.find('.sectionSelected');
            initDesignerUI($section);
            initLeftSidePanelResizing();
            initLeftSidePanelToggling();

            const treeGridDiv = leftSidePanel.find(".treebrowse__treeGridDiv");

            if (treeGridDiv.length > 0)
            {
                treeGridDiv.off("treeBrowseLevelChanged").on("treeBrowseLevelChanged", initLeftSidePanel);
                treeGridDiv.off("treeBrowseInitialize").on("treeBrowseInitialize", function (event, treeBrowseData, ajaxSuccessData)
                {
                    hidePageNumberFields(!$section.hasClass("jsHeaderFooterSection"));
                    initDesignerUI($section);

                    treeBrowseData.onRowMounted = function (rowElement)
                    {
                        $(rowElement).draggable($.extend(
                            getDefaultDraggableOptions(),
                            {
                                helper: function ()
                                {
                                    const convertedItem = $(this).clone();
                                    convertedItem.find('svg,input').remove();
                                    convertedItem.css("z-index", 999);
                                    convertedItem.width(convertedItem.data('fieldWidth'));
                                    convertedItem.height(DEFAULT_COLUMN_HEIGHT);
                                    return convertedItem;
                                },
                                appendTo: ".reportDesignerGrid"
                            })
                        ).disableSelection();
                    };
                });
            }

            if (!leftSidePanel.hasClass("expanded"))
            {
                leftSidePanel.find(".ui-resizable-handle").hide();
            }

            leftSidePanel.off('click', '.outlineSelected').on('click', '.outlineSelected', function ()
            {
                leftSidePanel.find('.outlineSelected.selected').removeClass('selected');
                $(this).addClass('selected');
            });

            const panelParts = leftSidePanel.find(".collapsePanel");
            const fieldMenu = panelParts.filter(".js-reportDesignerFieldsMenu");
            fieldMenu.off("treeBrowseSave").on("treeBrowseSave", function (_event, _treeBrowseData, rowData)
            {
                insertSidePanelField(rowData);
            });

            $(".jsDesignerLeftSidePanel .slidingContainerButton").off("click.reportDesigner").on("click.reportDesigner", skyward.debounce(updateUserSettings, 1000, 1000));
        };

        var insertSidePanelField = function (rowData)
        {
            var currentLine = getSectionSelectedRow(designer.find('.sectionSelected'));
            var currentSection = currentLine.closest(".sectionSelected");
            if (rowData.isCalculatedField)
            {
                skyward.reporting.addCalculatedField(rowData.id);
            }
            else
            {
                insertTreeBrowseItem(
                    {
                        treeBrowseData: rowData,
                        currentLine: currentLine,
                        section: currentSection,
                        position:
                        {
                            top: null,
                            left: null
                        }
                    });
            }
        };

        var updateUserSettings = function ()
        {
            $.ajax(
                {
                    url: skyward.global.virtualDir + "Reporting/Report/UpdateUserSettings",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        width: leftSidePanel.data("widthOverride"),
                        visible: leftSidePanel.hasClass("expanded"),
                        usedFieldsIsOpen: usedFieldsMenu.hasClass("expanded"),
                        allFieldsIsOpen: allFieldsMenu.hasClass("expanded"),
                        aggregateFieldsIsOpen: aggregateFieldsMenu.hasClass("expanded"),
                        calculatedFieldsIsOpen: calculatedFieldMenu.hasClass("expanded"),
                        promptFieldsIsOpen: promptFieldsMenu.hasClass("expanded"),
                        environmentVariableFieldsIsOpen: environmentVariableFieldsMenu.hasClass("expanded"),
                        variablesIsOpen: variablesMenu.hasClass("expanded"),
                        specialFieldsMenuIsOpen: specialFieldsMenu.hasClass("expanded"),
                        exportSettingsIsOpen: (xmlExportSettingsMenu.hasClass("expanded") || csvExportSettingsMenu.hasClass("expanded") || fixedWidthExportSettingsMenu.hasClass("expanded") || jsonExportSettingsMenu.hasClass("expanded"))
                    }
                });

            return true;
        };

        var hidePageNumberFields = function (hide)
        {
            //page number fields can lead to off by one errors if the section's data line is on the next page, so don't allow the user to put them in a main or detail section
            //end time is not known until the report is complete, results in errors if not used in a header/footer as well
            var pageNumberFields = designer.find(".reportDesignerSpecialFieldsMenu").find("[data-page-section-column-type='PageNumber'], " +
                "[data-page-section-column-type='PageTotal'], " +
                "[data-page-section-column-type='EndTime']");
            if (hide)
            {
                pageNumberFields.hide();
            }
            else
            {
                pageNumberFields.show();
            }
        };

        var getNewID = function ()
        {
            return Math.floor((Math.random() + 1) * 10000000);
        };

        var cloneColumnTemplateByClass = function (className)
        {
            return $(".columnTemplates").find(`.${className}`).clone().removeClass(className);
        };

        // accepts args = { type: string, text: string (optional), relatedItem: jQuery object, usesSingleLineIndex: boolean }
        var createNewColumn = function (args)
        {
            let newColumn, relatedData, newDataColumnId = getNewID();
            let fieldType;

            switch (args.type)
            {
                case COLUMN_TYPES.DATA_COLUMN:
                case COLUMN_TYPES.GROUP_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsDataColumnTemplate');
                    break;
                case COLUMN_TYPES.TEXT_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsTextColumnTemplate');
                    break;
                case COLUMN_TYPES.FORMTEXT_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsFormTextColumnTemplate');
                    break;
                case COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsDynamicImageColumnTemplate');
                    break;
                case COLUMN_TYPES.IMAGE_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsImageColumnTemplate');
                    break;
                case COLUMN_TYPES.HEADER_COLUMN:
                case COLUMN_TYPES.GROUP_COLUMN_HEADER:
                    newColumn = cloneColumnTemplateByClass('jsHeaderColumnTemplate');
                    fieldType = DATA_TYPES.STRING
                    break;
                case COLUMN_TYPES.FOOTER_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsFooterColumnTemplate');
                    break;
                case COLUMN_TYPES.PAGE_SECTION_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsPageSectionColumnTemplate');
                    break;
                case COLUMN_TYPES.AGGREGATE_COLUMN:
                case COLUMN_TYPES.GROUP_COLUMN_AGGREGATE:
                    newColumn = cloneColumnTemplateByClass('jsReportAggregateColumnTemplate');
                    break;
                case COLUMN_TYPES.CALCULATED_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsCalculatedColumnTemplate');
                    break;
                case COLUMN_TYPES.VARIABLE_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsVariableColumnTemplate');
                    newColumn.data("variableIdToGet", args.variableIdToGet).attr("data-variable-id-to-get", args.variableIdToGet);
                    newColumn.data("fieldName", args.variableBinding);
                    break;
                case COLUMN_TYPES.FUTURE_VALUE_COLUMN:
                    newColumn = cloneColumnTemplateByClass('jsFutureValueColumnTemplate');
                    break;
            }

            if (newColumn)
            {
                newColumn.removeAttr('id');
                newColumn.attr('data-field-column-type', args.type);

                if (args.relatedItem)
                {
                    relatedData = args.relatedItem.data();
                    if (!fieldType)
                    {
                        fieldType = skyward.reporting.reportColumn.getFieldType(relatedData);
                    }
                    if (args.type != COLUMN_TYPES.VARIABLE_COLUMN)
                    {
                        if (!args.text && relatedData.isTreeBrowseRow || args.relatedItem.hasClass('promptItem'))
                        {
                            // calculated fields only have displayPathText
                            relatedData.designerText = relatedData.displayName || relatedData.displayPathText || args.relatedItem.find(".visualLabel").text();
                            relatedData.dataColumnId = newDataColumnId;
                        }

                        if (args.type == COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN)
                        {
                            const maxWidth = relatedData.maxWidth ? relatedData.maxWidth : relatedData.fieldWidth;
                            const maxHeight = relatedData.maxHeight ? relatedData.maxHeight : relatedData.fieldHeight;
                            newColumn.attr('data-max-width', maxWidth);
                            newColumn.attr('data-max-height', maxHeight);
                            newColumn.attr('data-height-multiplier', maxWidth / maxHeight);
                            newColumn.attr('data-width-multiplier', maxHeight / maxWidth);
                        }

                        newColumn.attr('data-data-column-id', relatedData.dataColumnId);
                        newColumn.attr('data-field-name', fieldType == DATA_TYPES.GROUP_COLUMN ? relatedData.fieldPath : relatedData.fieldName);
                        newColumn.attr('data-field-width', relatedData.fieldWidth);
                        newColumn.attr('data-field-height', relatedData.fieldHeight);
                        newColumn.attr('data-is-calculated', relatedData.isCalculated);
                        newColumn.attr('data-is-operation', relatedData.isOperation);

                        if (relatedData.pageSectionColumnType)
                        {
                            newColumn.attr('data-page-section-column-type', relatedData.pageSectionColumnType);
                        }

                        if (relatedData.sourceColumnId)
                        {
                            newColumn.attr('data-source-column-id', relatedData.sourceColumnId);
                        }

                        if (relatedData.operationId)
                        {
                            newColumn.attr('data-operation-id', relatedData.operationId);
                        }

                        newColumn.attr('data-column-field-type', fieldType);
                        newColumn.attr('data-prompt-unique-id', relatedData.promptUniqueId);
                        //not sure if we need these
                        newColumn.attr('data-field-path', relatedData.fieldPath);
                        newColumn.attr('data-display-path', relatedData.displayPathText || relatedData.displayPath);
                        newColumn.attr('data-data-object-full-name', relatedData.dataObjectFullName);
                        newColumn.attr('data-is-dynamic-column', relatedData.isDynamicColumn);

                        if (relatedData.parameters)
                        {
                            newColumn.data("parameters", relatedData.parameters);
                        }

                        if (!relatedData.isDynamicColumn)
                        {
                            //it'd be better if this was handled on the server and the client didn't need to worry about it
                            newColumn.attr('data-absolute-field-path', relatedData.absoluteFieldPath);
                        }
                    }
                    else
                    {
                        newColumn.data("fieldName", "{_variable." + args.variableIdToGet + "}");
                    }

                    const newColumnID = getNewID();
                    newColumn.attr('data-column-id', newColumnID);
                    newColumn.attr('data-field-type', args.dataTypeCategoryName || fieldType);
                    newColumn.attr('data-binding-string', "{_column." + newColumnID + "}");
                }
                else
                {
                    newColumn.attr('data-data-column-id', newDataColumnId);
                    newColumn.attr('data-column-id', newDataColumnId);
                    newColumn.attr('data-binding-string', "{_column." + newDataColumnId + "}");
                }

                if (args.type == COLUMN_TYPES.HEADER_COLUMN || args.type == COLUMN_TYPES.TEXT_COLUMN)
                {
                    if (args.usesSingleLineIndex)
                    {
                        args.text = withSingleLineIndexBinding(args.text ?? relatedData.designerText);
                    }
                }

                // override the text if it is provided
                if (args.text)
                {
                    newColumn.find('.visualLabel').text(args.text);
                    newColumn.data("designerText", args.text);  // we need to set both data and attribute
                    newColumn.attr('data-designer-text', args.text);
                }
                else if (relatedData)
                {
                    newColumn.data("designerText", relatedData.designerText);  // we need to set both data and attribute
                    newColumn.attr('data-designer-text', relatedData.designerText);
                }
            }

            return newColumn;
        };

        // sectionID is required, but the sections object is optional
        // this should eventually go on a report definition model
        var getSectionByIDFromCurrentReportDefinition = function (sectionID, sections)
        {
            sections = sections || skyward.reporting.currentReportDefinition.MainSections;
            for (var i = 0; i < sections.length; i++)
            {
                if (sections[i].SectionID == sectionID)
                {
                    return sections[i];
                }

                var nestedSection = getSectionByIDFromCurrentReportDefinition(sectionID, sections[i].DetailSections);
                if (nestedSection)
                {
                    return nestedSection;
                }
            }

            return undefined;
        };

        var getSectionElementBySectionID = function (sectionID)
        {
            return $(`.jsSection[data-section-id='${sectionID}']`);
        }

        const getSectionElementByColumn = function (column)
        {
            return column.closest(".jsSection");
        };

        // accepts a sectionDefinition from the current report definition
        var removeSection = function (sectionDefinition, removingNestedSection)
        {
            for (let i = 0; i < sectionDefinition.DetailSections.length; i++)
            {
                // remove deepest child sections first
                removeSection(sectionDefinition.DetailSections[i], true);
            }

            const section = getSectionElementBySectionID(sectionDefinition.SectionID);

            getSectionAllColumns(section).each(function (index, e)
            {
                removeRelatedColumns($(e), false);
            });

            if (!areThereMultipleSectionsOnTheSameObject(section))
            {
                getSectionAllCalculatedFieldIDs(section).forEach(function (calculatedFieldID)
                {
                    removeCalculatedFieldBySection(section, calculatedFieldID);
                });
            }

            section.remove();

            if (!removingNestedSection)
            {
                // these things only need to happen once all sections have been removed
                removeInvalidPageNumberColumns(false);
                updateHiddenField();
                labelBuilder.buildLabelColumns(true);
                setActiveSection(entireCanvas.children('.jsSection').first());  // Select report header section
            }

            var mainSections = designer.find('.jsMainSection');
            if (mainSections.length < 2)
            {
                skyward.controls.enable(exportProperties.xml.includeRootNode);
            }

            initFieldsUsedInReport();
            skyward.reporting.updateVariableUsageLocations();
        };

        var initializeToolbarEvents = function ()
        {
            entireCanvas.find(".sectionToolbarRight .button").each(function ()
            {
                var toolbarButton = $(this);
                toolbarButton.attr("title", toolbarButton.attr("alt"));
            });

            entireCanvas.find('.moveSection.down').off('click').on('click', function ()
            {
                var currentSection = $(this).closest('.jsSection');
                var nextSection = currentSection.next('.jsSection');
                if (nextSection.length > 0)
                {
                    currentSection.detach().insertAfter(nextSection);
                    updateUIAfterSectionMove(currentSection, nextSection);
                }
            });

            entireCanvas.find('.moveSection.up').off('click').on('click', function ()
            {
                var currentSection = $(this).closest('.jsSection');
                var prevSection = currentSection.prev('.jsSection');
                if (prevSection.length > 0)
                {
                    currentSection.detach().insertBefore(prevSection);
                    updateUIAfterSectionMove(currentSection, prevSection);
                }
            });

            var updateUIAfterSectionMove = function (currentSection, siblingSection)
            {
                currentSection.data("pageBreakBeforeSection", false);
                siblingSection.data("pageBreakBeforeSection", false);
                removeInvalidPageNumberColumns();
                updateHiddenField();
                labelBuilder.buildLabelColumns(true);
            };

            entireCanvas.find('.sectionToolbar').off('click').on('click', function (event)
            {
                if (event.target != this)
                {
                    //don't do anything if clicking on a button
                    return;
                }

                var sectionToolbar = $(this);
                var section = sectionToolbar.closest('.jsSection');
                setActiveSection(section);
                setSelectedRowByRow(sectionToolbar);
            });

            entireCanvas.find('.toggleButtonSpan').off('click').on('click', function ()
            {
                var span = $(this);
                var toolbar = span.closest('.sectionToolbar');
                var parentSection = toolbar.parent();
                var bothSections = parentSection.add(span);
                var icon = span.find("svg");

                if (span.hasClass('showSection'))
                {
                    skyward.svg.swapSvg(icon, "ChevronDown", "BrowseLevel");
                    bothSections.removeClass('showSection').addClass('collapseSection');
                    parentSection.trigger("collapse");
                }
                else
                {
                    skyward.svg.swapSvg(icon, "ChevronUp", "BrowseLevel");
                    bothSections.removeClass('collapseSection').addClass('showSection');
                    parentSection.trigger("expand");
                }
            });

            entireCanvas.find('.removeSectionUnbound').removeClass('removeSectionUnbound').on('click', function ()
            {
                var button = $(this);
                skyward.modalLayer.confirmDelete("Section").then(function ()
                {
                    var sectionID = button.closest('.jsSection').data('sectionId');
                    var sectionDefinition = getSectionByIDFromCurrentReportDefinition(sectionID);
                    removeSection(sectionDefinition);
                });
            });

            $('.jsPromptEditor').off('click').on('click', skyward.reporting.prompts.promptEditor.open);

            entireCanvas.find('.get_sorts_modal').off('click').on('click', function ()
            {
                const $section = $(this).closest('.jsSection');
                setActiveSection($section);
                if ($section.find(".ui-selected, .row-selected").length <= 0)
                {
                    setSelectedRowByRow(getSectionDataLines($section).first());
                }
                getSorts($section, designer.data("reportType"));
            });

            entireCanvas.find('.get_detail_modal').off('click').on('click', function ()
            {
                var detailButton = $(this);
                var section = detailButton.closest('.jsSection');
                setActiveSection(section);
                getDetail(section, detailButton);
            });

            var addTextFieldOfType = function (toolbarButton, columnType, createTextFieldAction)
            {
                if (!skyward.buttonManager.isElementDisabled(toolbarButton))
                {
                    const currentSection = toolbarButton.closest('.jsSection');
                    const reportLine = getSectionSelectedRow(currentSection);
                    if (!reportLine.hasClass("sectionToolbar"))
                    {
                        const params =
                        {
                            newItem: createNewColumn({ type: columnType }),
                            reportLine: reportLine,
                            section: currentSection,
                            position: { top: null, left: null }
                        };

                        insertColumnHelperFunction(params);
                        createTextFieldAction(reportLine);
                    }
                }
            }

            entireCanvas.find('.add_text_field').off('click').on('click', function ()
            {
                var currentSection = $(this).closest('.jsSection');
                setActiveSection(currentSection);
                addTextFieldOfType($(this), COLUMN_TYPES.TEXT_COLUMN, function (_reportLine)
                {
                    editorColumnText.focus();
                });
            });

            entireCanvas.find('.add_formtext_field').off('click').on('click', function ()
            {
                var currentSection = $(this).closest('.jsSection');
                setActiveSection(currentSection);
                addTextFieldOfType($(this), COLUMN_TYPES.FORMTEXT_COLUMN, function (reportLine)
                {
                    const currentRowData = reportLine.data();
                    const sectionData = getCurrentSection().data();
                    showFormTextModal(currentRowData, sectionData);
                });
            });

            entireCanvas.find('.add_image_field').off('click').on('click', function ()
            {
                var currentSection = $(this).closest('.jsSection');
                setActiveSection(currentSection);
                var reportLine = getSectionSelectedRow(currentSection);
                setSelectedRowByRow(reportLine);
                if (!reportLine.hasClass("sectionToolbar"))
                {
                    // create the data column
                    var params = {
                        newItem: createNewColumn({ type: COLUMN_TYPES.IMAGE_COLUMN }),
                        reportLine: reportLine,
                        section: currentSection,
                        position: { top: null, left: null }
                    };

                    insertColumnHelperFunction(params);
                }
            });

            entireCanvas.find('.add_report_line').off('click').on('click', function ()
            {
                const section = $(this).closest('.jsSection');
                setActiveSection(section);
                const sectionDisplayOnSingleLine = section.data("displayOnSingleLine");
                const parentSectionHasDisplayOnSingleLine = isParentDisplayOnSingleLine(section);
                const reportSorts = section.data("reportSorts");

                $.ajax(
                    {
                        url: skyward.global.virtualDir + "Reporting/Report/GetReportLineOptions/",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            reportSortsJson: JSON.stringify(reportSorts),
                            allowSortHeadersAndSortAggregates: !parentSectionHasDisplayOnSingleLine,
                            allowFooterLines: !parentSectionHasDisplayOnSingleLine
                        },
                        success: showReportLineOptions
                    });

                async function showReportLineOptions(data)
                {
                    // Process HTML through processViewPartHtml to handle any script tags
                    var processedHtml = await skyward.global.processViewPartHtml(data.html);
                    var popupContent = $("<div class='popup addReportLinePopup'/>").append(processedHtml);
                    var okButton = { text: "Save", click: insertAndRefresh, additionalClasses: "okButton", icon: "Save" };
                    var menu = skyward.modalLayer.showDialog("Add Report Line", popupContent, [okButton, { text: "Cancel", icon: "Cancel" }], { width: 650, closeOnClick: false, automationID: "add-line-dialog" });

                    menu.content.on("dblclick", ".reportLineOptions", function ()
                    {
                        menu.footer.find(".okButton").click();
                    });
                    menu.content.on("click", '.reportLineOptions', function ()
                    {
                        $(this).addClass('line-selected')
                            .siblings().removeClass('line-selected');
                    });

                    function insertAndRefresh()
                    {
                        insertLine().then(refresh);

                        function insertLine()
                        {
                            const selectedOption = menu.content.find('.line-selected');
                            const waitForInsert = $.Deferred();

                            if (selectedOption.length != 0)
                            {
                                const selectedOptionData = selectedOption.data();
                                insertSelectedLineOption(selectedOptionData, waitForInsert);
                            }
                            menu.close();
                            return waitForInsert;
                        }

                        function insertSelectedLineOption(selectedOptionData, waitForInsert)
                        {
                            let lineIndex = 1;
                            if (selectedOptionData.lineType == 'DataLine' || selectedOptionData.lineType == 'HeaderLine')
                            {
                                lineIndex = getMaxSectionLineIndex(section) + 1;
                            }
                            else if (selectedOptionData.lineType == 'SortAggregateLine')
                            {
                                lineIndex = getNextSortAggregateLineIndex(section, selectedOptionData.relatedReportSortId) || 1;
                            }
                            else if (selectedOptionData.lineType == 'SortHeaderLine')
                            {
                                lineIndex = getNextSortHeaderLineIndex(section, selectedOptionData.relatedReportSortId) || 1;
                            }
                            else if (selectedOptionData.lineType == 'SectionAggregateLine')
                            {
                                const maxSectionAggregateLineIndex = getMaxSectionAggregateLineIndex(section) || 0;
                                lineIndex = maxSectionAggregateLineIndex + 1;
                            }

                            $.ajax(
                                {
                                    url: skyward.global.virtualDir + "Reporting/Report/GetNewReportLineHTML/",
                                    type: "POST",
                                    dataType: "JSON",
                                    data:
                                    {
                                        reportLineType: selectedOptionData.lineType,
                                        sortFieldName: selectedOptionData.fieldName,
                                        calculatedFieldID: selectedOptionData.operationId,
                                        lineIndex: lineIndex,
                                        displayOnSingleLine: sectionDisplayOnSingleLine,
                                        parentDisplayOnSingleLine: parentSectionHasDisplayOnSingleLine,
                                        sortOrder: selectedOptionData.sortOrder,
                                        relatedReportSortID: selectedOptionData.relatedReportSortId
                                    },
                                    success: function (returnData)
                                    {
                                        const newLine = $(returnData.html);
                                        insertNewLine(section, newLine);
                                        setSelectedRowByRow(newLine);
                                        setActiveSection(section);
                                        if (returnData.additionalLine)
                                        {
                                            insertNewLine(section, $(returnData.additionalLine));
                                        }

                                        waitForInsert.resolve();
                                    }
                                });
                        }

                        function refresh()
                        {
                            updateHiddenField();
                            labelBuilder.buildLabelColumns(true);

                            var sectionData = section.data();
                            var pageWidth = skyward.reporting.currentReportDefinition.PrintablePageWidth;
                            var unusableWidth = sectionData.columnWidth === "" ? 0 : (pageWidth - sectionData.columnWidth) * 72;

                            var unusableAreaBox = skyward.reporting.multiColumnSection.generateUnusableAreaBox(unusableWidth);

                            updateUnsableAreaBox(section, unusableAreaBox, sectionData.applyColumnsToDataLinesOnly);
                        }
                    }
                }
            });

            entireCanvas.find('.remove_report_line').off('click').on('click', function ()
            {
                const section = $(this).closest('.jsSection');
                setActiveSection(section);
                let rowSelected = getSectionSelectedRow(section);

                removeLine(rowSelected);
            });

            entireCanvas.find('.simple_aggregate_math').off('click').on('click', function ()
            {
                var button = $(this);
                if (skyward.buttonManager.isElementDisabled(button))
                {
                    return;
                }

                getCalculatedColumnBuilder({}, button);

            });

            entireCanvas.find('.get_multi_column_modal').off('click').on('click', function ()
            {
                var section = $(this).closest(".jsSection");
                var sectionData = section.data();
                var data =
                {
                    columnWidth: sectionData.columnWidth,
                    columnSpacing: sectionData.columnSpacing,
                    applyColumnsToDataLinesOnly: sectionData.applyColumnsToDataLinesOnly,
                    columnDirection: sectionData.columnDirection,
                    defaultWidth: skyward.reporting.currentReportDefinition.PrintablePageWidth,
                    balanceColumns: sectionData.balanceColumns,
                    currentSectionDisplayOnSingleLine: sectionData.displayOnSingleLine,
                    callBack: function (newData)
                    {
                        var unusableAreaBox = newData.unusableAreaBox;
                        delete newData.unusableAreaBox;
                        updateUnsableAreaBox(section, unusableAreaBox, newData.applyColumnsToDataLinesOnly);

                        $.extend(section.data(), newData);
                        updateHiddenField();
                    }
                };

                skyward.reporting.multiColumnSection.init(data);
            });

            $('.jsAddMainSection').off('click').on('click', function ()
            {
                getMainSection($(this).closest('.jsSection'));
                labelBuilder.buildLabelColumns(true);
            });
        };
        //END UI UPDATE FUNCTIONS

        //FORMATTING & PROPERTIES
        var applyColumnCss = function (item)
        {
            dataFont.find('option').each(function (i, fontOption)
            {
                item.removeClass(fontOption.value);
            });
            item.removeClass(BARCODE_FONT_NAME);

            var itemData = item.data();
            var isMultiline = false;
            var lineHeightByFontFamily = 1;
            var fontSizeAsNumber = parseInt(itemData.dataFontSize.replace("px", ""));

            if (isBarcodeFormatter(itemData.formatter))
            {
                lineHeightByFontFamily = enumMaps.FontFamilyLineHeights[BARCODE_FONT_NAME];
                item.addClass(BARCODE_FONT_NAME);
            }
            else if (itemData.dataFontFamily)
            {
                item.addClass(itemData.dataFontFamily);

                lineHeightByFontFamily = enumMaps.FontFamilyLineHeights[itemData.dataFontFamily];
                isMultiline = itemData.overlapMode == "Expand" || ((itemData.fieldHeight - itemData.paddingTop - itemData.paddingBottom) > fontSizeAsNumber * 2 * lineHeightByFontFamily);
                item.toggleClass("isMultiline", isMultiline);
            }

            item.toggleClass(boldCssClass, itemData.dataBold);
            item.toggleClass(underlineCssClass, itemData.dataUnderline);
            item.toggleClass(italicCssClass, itemData.dataItalic);

            item.css("background-color", itemData.backColor ? itemData.backColor : "transparent");

            let hiddenConditionType = getHiddenConditionType(itemData.isHiddenCondition);

            updateColumnIsHiddenConditionFormatting(item, hiddenConditionType);

            let backgroundColor = itemData.backColor;
            if (!backgroundColor)
            {
                backgroundColor = item.parent('.reportLine').data("backColor");
            }

            if (hiddenConditionType != NOT_HIDDEN_VALUE && backgroundColor)
            {
                setLabelTextBackground(item, backgroundColor);
            }
            else
            {
                removeLabelTextBackground(item);
            }

            item.css({
                "font-size": itemData.dataFontSize,
                "line-height": Math.round(fontSizeAsNumber * lineHeightByFontFamily) + "px",
                "color": itemData.dataForeColor,
                "text-align": (itemData.dataTextAlignment != 'None') ? itemData.dataTextAlignment : 'Left',
                "top": itemData.positionY + "px",
                "left": itemData.positionX + "px",
                "height": itemData.fieldHeight,
                "width": itemData.fieldWidth,
                "padding-left": itemData.paddingLeft + "px",
                "padding-right": itemData.paddingRight + "px",
                "padding-top": itemData.paddingTop + "px",
                "padding-bottom": itemData.paddingBottom + "px",
                "vertical-align": itemData.verticalAlignment != 'None' ? itemData.verticalAlignment : 'Top',
                "transform-origin": "Top Left",
                "transform": "rotate(" + itemData.rotation + "deg)"
            });

            applyBorderCss(item, itemData);

            var itemLabel = item.find('.column_content');
            itemLabel.text(getColumnLabelWithPreText(item));

            if (!isMultiline)
            {
                $.each(itemLabel.text().split("\n"), function (index, value)
                {
                    itemLabel.text(value);
                    return false;
                });
            }
        };

        var updateColumnIsHiddenConditionFormatting = function (column, hiddenConditionType)
        {
            if (hiddenConditionType === undefined)
            {
                hiddenConditionType = getHiddenConditionType(column.data().isHiddenCondition);
            }

            if (currentSelectedColumns.isColumnSelected(column) && currentSelectedColumns.isSingleColumnSelected())
            {
                clearIsHiddenConditionFormatting(column);
            }
            else
            {
                updateIsHiddenConditionClass(column, hiddenConditionType);
            }
        };

        function applyBorderCss(item, itemData)
        {
            if (itemData.borderLeft === true && itemData.borderStyle !== "None")
            {
                item.css("border-left", itemData.borderStyle + " " + itemData.borderWidth + "px " + itemData.borderColor);
            }
            else
            {
                item.css("border-left", "");
            }

            if (itemData.borderRight === true && itemData.borderStyle !== "None")
            {
                item.css("border-right", itemData.borderStyle + " " + itemData.borderWidth + "px " + itemData.borderColor);
            }
            else
            {
                item.css("border-right", "");
            }

            if (itemData.borderTop === true && itemData.borderStyle !== "None")
            {
                item.css("border-top", itemData.borderStyle + " " + itemData.borderWidth + "px " + itemData.borderColor);
            }
            else
            {
                item.css("border-top", "");
            }

            if (itemData.borderBottom === true && itemData.borderStyle !== "None")
            {
                item.css("border-bottom", itemData.borderStyle + " " + itemData.borderWidth + "px " + itemData.borderColor);
            }
            else
            {
                item.css("border-bottom", "");
            }
        }

        var applyRowCss = function (row)
        {
            var rowData = row.data();

            row.css("height", rowData.lineHeight + "px");

            row.css("background-color", rowData.backColor ? rowData.backColor : "transparent");

            applyBorderCss(row, rowData);
        };

        var getSectionOrRowHiddenConditionType = function (sectionOrRow, parentSectionIsHiddenConditionType)
        {
            let conditionType = getHiddenConditionType(sectionOrRow.data().isHiddenCondition);

            if (conditionType === ALWAYS_HIDDEN_VALUE)
            {
                return ALWAYS_HIDDEN_VALUE;
            }

            if (parentSectionIsHiddenConditionType === undefined)
            {
                let parentSection = getParentSection(sectionOrRow);

                parentSectionIsHiddenConditionType = parentSection.length === 0 ? NOT_HIDDEN_VALUE : getSectionOrRowHiddenConditionType(parentSection);
            }

            return Math.max(conditionType, parentSectionIsHiddenConditionType);
        };

        var getParentSectionHiddenConditionType = function (sectionOrRow)
        {
            let parentSection = getParentSection(sectionOrRow);
            if (parentSection.length === 0)
            {
                return NOT_HIDDEN_VALUE;
            }

            let conditionType = getHiddenConditionType(parentSection.data().isHiddenCondition);

            if (conditionType === ALWAYS_HIDDEN_VALUE)
            {
                return ALWAYS_HIDDEN_VALUE;
            }

            return Math.max(conditionType, getParentSectionHiddenConditionType(parentSection));
        };

        var applySectionOrRowHiddenCondition = function (sectionOrRow, parentSectionIsHiddenConditionType)
        {
            let currentSectionIsHiddenConditionType = getSectionOrRowHiddenConditionType(sectionOrRow, parentSectionIsHiddenConditionType);

            updateIsHiddenConditionClass(labelBuilder.getRelatedLabel(sectionOrRow), currentSectionIsHiddenConditionType);

            if (isSection(sectionOrRow))
            {
                for (let row of sectionOrRow.children('.sectionBody').find(".reportLine:not(.jsPrintOnOneLinePreviewLine)"))
                {
                    applySectionOrRowHiddenCondition($(row), currentSectionIsHiddenConditionType);
                }

                for (let detailSection of getDetailSections(sectionOrRow))
                {
                    applySectionOrRowHiddenCondition($(detailSection), currentSectionIsHiddenConditionType);
                }
            }
        };

        var getHiddenConditionType = function (hiddenCondition)
        {
            if (isHiddenSelector.isConditionAlwaysDisplayed(hiddenCondition))
            {
                return NOT_HIDDEN_VALUE;
            }

            if (isHiddenSelector.isConditionAlwaysHidden(hiddenCondition))
            {
                return ALWAYS_HIDDEN_VALUE;
            }

            return CONDITIONALLY_HIDDEN_VALUE;
        };

        var updateIsHiddenConditionClass = function (item, isHiddenConditionType)
        {
            if (!item)
            {
                // the section and row labels can be undefined on initial load
                return;
            }

            clearIsHiddenConditionFormatting(item);

            if (isHiddenConditionType === NOT_HIDDEN_VALUE)
            {
                return;
            }
            item.addClass(HIDDEN_CLASS);
            if (isHiddenConditionType === CONDITIONALLY_HIDDEN_VALUE)
            {
                item.addClass(CONDITIONALLY_HIDDEN_CLASS);
            }
            else if (isHiddenConditionType === ALWAYS_HIDDEN_VALUE)
            {
                item.addClass(ALWAYS_HIDDEN_CLASS);
            }
        };

        var clearIsHiddenConditionFormatting = function (item)
        {
            if (item)
            {
                item.removeClass(ALWAYS_HIDDEN_CLASS);
                item.removeClass(CONDITIONALLY_HIDDEN_CLASS);
                item.removeClass(HIDDEN_CLASS);
            }
        };

        var setDefaultItemFormatting = function (item)
        {
            var parentLine = item.closest('.reportLine');
            if (parentLine.length > 0)
            {
                var cellFormat = JSON.parse(decodeURIComponent(parentLine.data("defaultCellFormatting")));
                applyCellFormatToItem(item, cellFormat);

                var textFormat = JSON.parse(decodeURIComponent(parentLine.data("defaultTextFormatting")));
                applyTextFormatToItem(item, textFormat);

                var borderFormat = JSON.parse(decodeURIComponent(parentLine.data("defaultBorderFormatting")));
                applyBorderFormatToItem(item, borderFormat);
            }
            return item;
        };

        function hideAllProperties()
        {
            reportDesignerProperties.find(".cellProperties, .rowProperties, .sectionProperties, .sortRowProperties, .textProperties, .singleLineHeaderProperties").hide();
        }

        function setSectionProperties(section)
        {
            hideAllProperties();

            var isHeaderFooterSection = section.hasClass("jsHeaderFooterSection");

            if (!isHeaderFooterSection)
            {
                var hasPreviousSibling = section.prev(".jsSection").not(".jsHeaderFooterSection").children(".sectionToolbar").length > 0;

                reportDesignerProperties.find(".sectionProperties").show();
                reportDesignerProperties.find(".sectionWithSiblingProperties").toggle(hasPreviousSibling);
                setSectionPropertiesValues(section);
            }
        }

        var setRowProperties = function (row)
        {
            if (row)
            {
                if (row.hasClass("sectionToolbar"))
                {
                    setSectionProperties(row.parent(".jsSection"));
                }
                else
                {
                    hideAllProperties();

                    var canRepeatAfterStart = false;
                    var isSortHeaderLine = row.hasClass("sortHeaderLine");
                    if (isSortHeaderLine || row.hasClass("jsSortAggregateLine"))
                    {
                        if (isSortHeaderLine)
                        {
                            reportDesignerProperties.find(".sortHeaderRowProperties").show();
                            canRepeatAfterStart = true;
                        }
                        reportDesignerProperties.find(".sortRowProperties").show();
                    }

                    if (row.hasClass("jsDataLine"))
                    {
                        reportDesignerProperties.find(".dataRowProperties").show();
                    }

                    if (row.hasClass("jsHeaderLine"))
                    {
                        reportDesignerProperties.find(".headerRowProperties").show();
                        canRepeatAfterStart = true;
                    }

                    if (row.hasClass("jsFooterLine") || row.hasClass("jsSectionAggregateLine") || row.hasClass("jsSortAggregateLine"))
                    {
                        reportDesignerProperties.find(".endingRowProperties").show();
                    }

                    if (row.hasClass('jsReportFooterLine'))
                    {
                        editorPrintReportFooterOnNewPage.add(editorPrintReportFooterOnNewPage.parent()).show();
                    }

                    reportDesignerProperties.find(".allRowProperties").show();

                    setRowPropertiesValues(row.data(), canRepeatAfterStart);
                }
            }
        };

        //FORMATTING & PROPERTIES
        var setColumnProperties = function ()
        {
            hideAllProperties();

            const identicalColumnData = {};
            const allColumnData = [];
            let selectorToShow = {};
            let anyFutureValue = false;
            for (const column of currentSelectedColumns.getCurrentSelectedColumns())
            {
                const columnData = column.data();
                columnData.lineType = column.parent().data("line-type");

                allColumnData.push(columnData);

                if (columnData.isFutureValue)
                {
                    anyFutureValue = true;
                }

                if (columnData.fieldColumnType === COLUMN_TYPES.AGGREGATE_COLUMN || columnData.fieldColumnType === COLUMN_TYPES.GROUP_COLUMN_AGGREGATE)
                {
                    selectorToShow[".aggregateProperties"] = true;
                }
                else if (columnData.fieldColumnType === COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN)
                {
                    selectorToShow[".dynamicImageProperties"] = true;
                }
                else if (columnData.fieldColumnType === COLUMN_TYPES.IMAGE_COLUMN)
                {
                    selectorToShow[".imageProperties"] = true;
                }
                else if (columnData.fieldColumnType === COLUMN_TYPES.DATA_COLUMN && !columnData.calculation && !columnData.operationId)
                {
                    selectorToShow[".dataProperties"] = true;
                }
                else if (columnData.fieldColumnType === COLUMN_TYPES.VARIABLE_COLUMN)
                {
                    selectorToShow[".variableProperties"] = true;
                }
                else if (columnData.fieldColumnType === COLUMN_TYPES.PAGE_SECTION_COLUMN)
                {
                    selectorToShow[".pageSectionColumnProperties"] = true;
                }
                else if (columnData.fieldColumnType === COLUMN_TYPES.GROUP_COLUMN)
                {
                    if (columnData.lineType === LINE_TYPES.DATA_LINE)
                    {
                        columnData.isFilterableGroupColumn = true;
                        selectorToShow[".groupColumnProperties"] = true;
                    }
                    else if (columnData.lineType === LINE_TYPES.SORT_HEADER_LINE)
                    {
                        selectorToShow[".dataProperties"] = true;
                    }
                }
                else if (columnData.fieldColumnType === COLUMN_TYPES.FUTURE_VALUE_COLUMN)
                {
                    selectorToShow[".futureValueProperties"] = true;
                }
                else if ((columnData.fieldColumnType === COLUMN_TYPES.HEADER_COLUMN || columnData.fieldColumnType === COLUMN_TYPES.TEXT_COLUMN)
                    && isParentDisplayOnSingleLine(column.closest('.jsSection'))
                    && columnData.lineType === LINE_TYPES.HEADER_LINE)
                {
                    selectorToShow[".singleLineHeaderProperties"] = true;
                }
                else
                {
                    selectorToShow[".textProperties"] = true;
                }

                for (let property in columnData)
                {
                    if (identicalColumnData.hasOwnProperty(property))
                    {
                        if (identicalColumnData[property] !== columnData[property])
                        {
                            identicalColumnData[property] = null;
                        }
                    }
                    else if (allColumnData.length === 1)
                    {
                        identicalColumnData[property] = columnData[property];
                    }
                }
            }

            if (allColumnData.length > 1)
            {
                selectorToShow[".multiColumnProperties"] = true;
            }

            reportDesignerProperties.find(Object.keys(selectorToShow).join("")).show();

            if (anyFutureValue)
            {
                editorVariableToSet.closest(".fieldWrapper").hide();
            }

            let hasPromptColumns;
            let allSameColumnType = allColumnData.every(c =>
            {
                let thisIsPromptColumn = isPromptColumn(c);
                if (hasPromptColumns === undefined)
                {
                    hasPromptColumns = thisIsPromptColumn;
                }
                return thisIsPromptColumn == hasPromptColumns;
            });
            if (!allSameColumnType)
            {
                skyward.controls.toggleVisible(pageSectionColumnDisplayTypeFS, false, false);
            }
            else
            {
                skyward.controls.toggleVisible(pageSectionColumnDisplayType, !hasPromptColumns, false);
                skyward.controls.toggleVisible(pageSectionColumnPromptDisplayType, hasPromptColumns, false);
            }

            setColumnExportPropertiesValues(identicalColumnData);
            setAllColumnPropertiesValues(identicalColumnData, allColumnData);
            setFormattingPropertiesValues(identicalColumnData, allColumnData);
        };

        function setColumnExportPropertiesValues(columnData)
        {
            var designerText = columnData.designerText;

            if (columnData.nodeName?.trim().length > 0)
            {
                exportProperties.xml.column.nodeName.val(columnData.nodeName);
            }
            else if (exportProperties.xml.column.nodeName.length > 0)
            {
                columnData.nodeName = designerText;
                exportProperties.xml.column.nodeName.val(designerText);
            }

            if (exportProperties.xml.column.nodeType.length > 0)
            {
                setRadioButtonGroupValue(exportProperties.xml.column.nodeType, columnData.nodeType);
            }

            exportProperties.fixedWidth.column.startPosition.val(columnData.fixedWidthStartPosition ? columnData.fixedWidthStartPosition : null);
            exportProperties.fixedWidth.column.length.val(columnData.fixedWidthLength ? columnData.fixedWidthLength : null);

            if (exportProperties.json.column.name.length > 0)
            {
                if (columnData.jsonPropertyName?.trim().length > 0)
                {
                    exportProperties.json.column.name.val(columnData.jsonPropertyName);
                }
                else
                {
                    columnData.jsonPropertyName = designerText;
                    exportProperties.json.column.name.val(designerText);
                }
            }

        }

        function setAllColumnPropertiesValues(identicalColumnData, allColumnData)
        {
            if (identicalColumnData.fieldColumnType == COLUMN_TYPES.AGGREGATE_COLUMN || identicalColumnData.fieldColumnType == COLUMN_TYPES.GROUP_COLUMN_AGGREGATE)
            {
                setAggregatePropertiesValues(identicalColumnData);
            }
            else
            {
                setColumnPropertiesValues(identicalColumnData, allColumnData);
            }
            positionX.val(identicalColumnData.positionX);
            positionY.val(identicalColumnData.positionY);

            if (identicalColumnData.sourceColumnId)
            {
                const sourceColumn = getColumnByID(identicalColumnData.sourceColumnId);

                if (sourceColumn.length === 1)
                {
                    const sourceLine = sourceColumn.parent();
                    const sourceSection = getSectionByLine(sourceLine);

                    columnDataPath.val(`${sourceSection.data('displayName')} > ${sourceLine.data('reportLabelText')} > ${getColumnLabelWithPreText(sourceColumn)}`);
                }
            }
            else
            {
                columnDataPath.val(identicalColumnData.absoluteFieldPath || identicalColumnData.fieldPath);
            }

            if (allColumnData.length === 1)
            {
                updateGroupColumnFilterLaunchButton(identicalColumnData);

                isHiddenSelector.setIsHiddenCondition(identicalColumnData.isHiddenCondition, "Column", getSvgByDataType, identicalColumnData.columnId, getColumnLabelWithPreTextByColumnID);
                whenHiddenOption.val(identicalColumnData.whenHiddenOption);
                skyward.controls.toggleVisible(whenHiddenOption.parent(), getHiddenConditionType(identicalColumnData.isHiddenCondition) !== NOT_HIDDEN_VALUE, false);

                setColumnVariablePropertiesValues(identicalColumnData.variableIdToSet);
            }
        }

        function setColumnVariablePropertiesValues(idOrModel)
        {
            var variableToSet = (typeof idOrModel === 'string' ? skyward.reporting.variables.collectionModel.getById(idOrModel) : idOrModel) || {};
            editorVariableToSet.text(variableToSet.uniqueId ? variableToSet.name : "[None]");
            editorVariableToSet.data("variableIdToSet", variableToSet.uniqueId || "");
            editorVariableToSet.find(".js-icon").html(skyward.reporting.variables.viewModel.getIcon(variableToSet));
        }

        function setAggregatePropertiesValues(identicalColumnData)
        {
            const columnType = identicalColumnData.columnFieldType;
            editorAggregateType.attr('disabled', !columnType);

            if (!columnType)
            {
                setAggregateTypeOptions({ "": "" });
                editorAggregateType.val("");
                editorAggregateDelimiterContainer.hide();
                return;
            }

            if (columnType.toUpperCase().substring(0, 6) == "NUMBER")
            {
                setAggregateTypeOptions(numericAggregateOptions);
            }
            else if (columnType == DATA_TYPES.DATETIME)
            {
                setAggregateTypeOptions(dateTimeAggregateOptions);
            }
            else if (columnType == DATA_TYPES.BOOLEAN)
            {
                setAggregateTypeOptions(booleanAggregateOptions);
            }
            else if (columnType == DATA_TYPES.TIMESPAN)
            {
                setAggregateTypeOptions(timeSpanAggregateOptions);
            }
            else
            {
                setAggregateTypeOptions(stringAggregateOptions);
            }

            editorAggregateType.val(identicalColumnData.aggregateType || "");

            if (delimitedAggregators.indexOf(identicalColumnData.aggregateType) != -1)
            {
                editorAggregateDelimiter.val(identicalColumnData.aggregateDelimiter || "");
                editorAggregateDelimiterContainer.show();
            }
            else
            {
                editorAggregateDelimiterContainer.hide();
            }

            function setAggregateTypeOptions(optionsData)
            {
                editorAggregateType.empty();
                $.each(optionsData, function (value, label)
                {
                    editorAggregateType.append($("<option></option").val(value).text(label));
                });

                // It is possible that propertyData.aggregate type is invalid (not in optionsData)
                if (identicalColumnData.aggregateType && !optionsData.hasOwnProperty(identicalColumnData.aggregateType))
                {
                    identicalColumnData.aggregateType = Object.keys(optionsData)[0];
                }
            }
        }

        function setColumnPropertiesValues(columnData, allColumnData)
        {
            editorColumnText.off('click'); // remove the onclick for calculated fields

            var isNumericDataField = allColumnData.every(function (data)
            {
                return (data.lineType !== LINE_TYPES.SORT_HEADER_LINE &&
                    data.fieldColumnType === COLUMN_TYPES.DATA_COLUMN &&
                    skyward.reporting.reportColumn.getFieldType(data).toUpperCase().substring(0, 6) == "NUMBER")
            });

            if (isNumericDataField)
            {
                runningTotal.prop('checked', columnData.isRunningTotal);
                runningTotal.parent().show();
            }

            var currentSection = getCurrentSection();
            var sectionData = currentSection.data();
            if ((isNumericDataField && columnData.isRunningTotal) || isPageNumberOrPageTotalColumn(columnData))
            {
                buildResetOnOptions(currentSection, true, columnData);
            }

            // display custom text box for header and custom text fields
            if (columnData.fieldColumnType === COLUMN_TYPES.TEXT_COLUMN ||
                columnData.fieldColumnType === COLUMN_TYPES.HEADER_COLUMN ||
                columnData.fieldColumnType === COLUMN_TYPES.FOOTER_COLUMN)
            {
                editorColumnText.val(columnData.designerText);
            }
            else if (columnData.fieldColumnType === COLUMN_TYPES.FORMTEXT_COLUMN)
            {
                var friendlyText = skyward.reporting.prompts.promptCollection.ConvertPromptBindingsToFriendlyNames(columnData.designerText);
                friendlyText = skyward.reporting.calculatedFields.ConvertBindingsToFriendlyNames(friendlyText);
                editorColumnText.val(friendlyText);

                editorColumnText.on('click', function ()
                {
                    showFormTextModal(columnData.lineType, sectionData);
                });
            }
            else if (columnData.operationId)
            {
                var calculatedField = CalculatedFields_Model.Get(columnData.operationId);
                editorColumnText.val(skyward.reporting.prompts.promptCollection.ConvertPromptBindingsToFriendlyNames(calculatedField.expression));
                editorColumnText.on('click', function ()
                {
                    skyward.reporting.updateCalculatedField(columnData.operationId);
                });
            }
            else if (columnData.calculation)
            {
                editorColumnText.val(columnData.displayCalculation);
                editorColumnText.on('click', function ()
                {
                    var clickedElement = $(this);
                    let newData = getColumnByID(columnData.columnId).data();
                    var data =
                    {
                        fieldName: newData.designerText,
                        displayCalculation: newData.displayCalculation,
                        calculation: newData.calculation,
                        columnId: newData.columnId
                    };
                    getCalculatedColumnBuilder(data, clickedElement);
                });
            }

            editorMediaId.val(columnData.mediaId).parent().toggle(!columnData.useSystemLogo);
            editorUseSystemLogo.prop("checked", columnData.useSystemLogo);

            if (columnData.isDynamicColumn && columnData.lineType == LINE_TYPES.SORT_HEADER_LINE)
            {
                groupColumnSortHeaderTypes.val(columnData.fieldColumnType);
                reportDesignerProperties.find(".sortHeaderGroupColumnCellProperties").show();
            }

            let hasPromptColumns;
            let allSameColumnType = allColumnData.every(c =>
            {
                let thisIsPromptColumn = isPromptColumn(c);
                if (hasPromptColumns === undefined)
                {
                    hasPromptColumns = thisIsPromptColumn;
                }
                return thisIsPromptColumn == hasPromptColumns;
            });
            let relatedDisplayTypeComboBox = allSameColumnType ? (hasPromptColumns ? pageSectionColumnPromptDisplayType : pageSectionColumnDisplayType) : null;
            if (relatedDisplayTypeComboBox)
            {
                if (!columnData.displayType)
                {
                    relatedDisplayTypeComboBox.val(PAGE_SECTION_COLUMN_DISPLAY_TYPES.DISPLAY_VALUE);
                }
                else
                {
                    relatedDisplayTypeComboBox.val(columnData.displayType);
                }
            }

            setPropertiesOnColumnForPrintOnOneLine();
        }

        function showFormTextModal(lineType, sectionData)
        {
            let options =
            {
                prompts: skyward.reporting.prompts.promptCollection,
                calculatedFields: skyward.reporting.calculatedFields,
                aggregateFields: (lineType !== LINE_TYPES.DATA_LINE && lineType !== LINE_TYPES.SORT_HEADER_LINE) ? getCurrentAndDetailSectionsAggregateColumns() : undefined,
                additionalFilterTypeName: ADDITIONAL_TYPES.TREE_BROWSE_FILTER
            };
            let awaitFormTextEditor = skyward.formTextEditor.launch(
                editorColumnText.val(), sectionData.rootModule, sectionData.rootObject, sectionData.entireRelationshipPath || "", options);
            awaitFormTextEditor.done(function (data)
            {
                editorColumnText.val(data);
                editorColumnText.trigger('change');
            });
        }

        function updateGroupColumnFilterLaunchButton(columnData)
        {
            var sectionFilterData = columnData.isFilterableGroupColumn ?
                getCurrentSectionFilterLaunchButton().data() :
                { rootModule: null, rootObject: null, module: null, object: null, relationshipPath: null };

            // if propertyData.columnFilterJson is undefined we need set it to null to clear out any previous value
            var filterCondition = columnData.columnFilterJson ? columnData.columnFilterJson : null;

            editorColumnFilterLaunchButton.data(
                {
                    rootModule: sectionFilterData.rootModule,
                    rootObject: sectionFilterData.rootObject,
                    module: sectionFilterData.module,
                    object: sectionFilterData.object,
                    relationshipPath: sectionFilterData.relationshipPath,
                });
            editorColumnFilterInput.data({ filterCondition: filterCondition });

            if (columnData.isFilterableGroupColumn)
            {
                editorColumnFilterInput.trigger("updateFilterViewerDisplay");
            }
        }

        function setFormattingPropertiesValues(columnData, allColumnData)
        {
            setTextFormattingPropertiesControls(columnData, allColumnData);
            setCellFormattingPropertiesControls(columnData);
            setBorderFormattingPropertiesControls(columnData);
        }

        function columnSupportsFormatter(columnData)
        {
            const fieldColumnType = columnData.fieldColumnType;
            if (fieldColumnType === COLUMN_TYPES.DATA_COLUMN || fieldColumnType === COLUMN_TYPES.AGGREGATE_COLUMN ||
                fieldColumnType === COLUMN_TYPES.VARIABLE_COLUMN || fieldColumnType == COLUMN_TYPES.CALCULATED_COLUMN ||
                fieldColumnType === COLUMN_TYPES.FUTURE_VALUE_COLUMN)
            {
                return true;
            }
            else if (fieldColumnType == COLUMN_TYPES.PAGE_SECTION_COLUMN)
            {
                const prompt = columnData.promptUniqueId ? skyward.reporting.prompts.promptCollection.Get(columnData.promptUniqueId) : undefined;
                if (!prompt || (prompt.InputType !== DATA_TYPES.BOOLEAN && (prompt.Type == enumMaps.PromptTypes["Value"] || prompt.Type == enumMaps.PromptTypes["SingleSelect"])))
                {
                    return true;
                }
            }
            return false;
        }

        function setTextFormattingPropertiesControls(columnData, allColumnData)
        {
            setFontPropertiesValues(columnData, allColumnData);
            columnData.backColor ? dataBackgroundColor.spectrum("set", columnData.backColor) : dataBackgroundColor.spectrum("set", defaultDataBackColor);
            setTextAlignmentPropertiesValues(columnData);
            setVerticalAlignmentPropertiesValues(columnData);

            if (allColumnData.every(columnSupportsFormatter))
            {
                setFormatterControls(allColumnData);
            }

            overlapMode.val(columnData.overlapMode);
        }

        function setFontPropertiesValues(identicalColumnData, allColumnData)
        {
            let anyColumnIsBarcode = allColumnData.some(function (data) { return isBarcodeFormatter(data.formatter) });
            dataFont.attr('disabled', anyColumnIsBarcode);

            let fontFamily = identicalColumnData.dataFontFamily;
            let fontSize = identicalColumnData.dataFontSize;
            let foreColor = allColumnData[0].dataForeColor;
            // the foreground color picker will always have a color selected
            if (!foreColor)
            {
                foreColor = defaultDataForeColor;
            }

            if (allColumnData.length == 1)
            {
                if (!fontFamily)
                {
                    fontFamily = defaultDataFont;
                }

                if (!fontSize)
                {
                    fontSize = defaultDataFontSize;
                }
            }

            dataFont.val(anyColumnIsBarcode ? "" : fontFamily);
            dataFontSize.val(fontSize);
            dataForeColor.data("color", foreColor ?? defaultDataForeColor); // set this on the element so when colorPicker initializes it starts with the correct color.
            dataForeColor.spectrum("set", foreColor);

            dataBold.prop('checked', identicalColumnData.dataBold);
            dataItalic.prop('checked', identicalColumnData.dataItalic);
            dataUnderline.prop('checked', identicalColumnData.dataUnderline);
        }

        function resetFontProperties(column)
        {
            column.data("dataFontFamily", defaultDataFont);
            column.data("dataFontSize", defaultDataFontSize);
            column.data("dataForeColor", defaultDataForeColor);
            column.data("dataBold", defaultDataFontBold);
            column.data("dataItalic", defaultDataFontItalic);
            column.data("dataUnderline", defaultDataFontUnderline);
        }

        function setRadioButtonGroupValue(groupElement, value)
        {
            // we aren't using skyward.radioButtonGroup.setValue because it does not support clearing a radio button group
            var group = skyward.radioButtonGroup.getRadioButtonGroup(groupElement);
            group.valueElement.val(value);

            for (let element of group.radioInputs)
            {
                var radioButton = $(element);
                const currentValue = radioButton.prop("checked");
                const newValue = radioButton.val() == value;
                if (currentValue != newValue)
                {
                    radioButton.prop("checked", newValue);
                }
            }
        }

        function setTextAlignmentPropertiesValues(columnData)
        {
            setRadioButtonGroupValue(editorTextAlign, columnData.dataTextAlignment);
        }

        function setVerticalAlignmentPropertiesValues(columnData)
        {
            setRadioButtonGroupValue(editorVerticalAlign, columnData.verticalAlignment);
        }

        function getFormatterOrNull(formatterData)
        {
            if (!formatterData || enumMaps.FormatterTypeNames.indexOf(formatterData.formatterName || "") == -1)
            {
                return null;
            }

            return formatterData;
        }

        function isParentDisplayOnSingleLine(section) {
            const parentSection = getParentSection(section);
            return parentSection.length ? parentSection.data("displayOnSingleLine") : false;
        }

        function setFormatterControls(allColumnData)
        {
            reportDesignerProperties.find(".formatterFieldSet").hide();
            dataTextFormat.show().parent().show();

            const allColumnDataTypeClasses = new Set(allColumnData.map(function (data)
            {
                if (data.fieldType?.startsWith("String Enum-"))
                {
                    return ".textFormat-StringEnum-";
                }
                else
                {
                    return ".textFormat-" + data.fieldType?.replace(/\s+/g, '') ?? ""; //Remove blank spaces
                }
            }));

            dataTextFormat.find("option").hide();
            const typeClasses = [...allColumnDataTypeClasses].join("");
            dataTextFormat.find("option" + typeClasses).show();

            const allFormatterData = allColumnData.map(function (data) { return getFormatterOrNull(data.formatter) });
            if (allFormatterData.length > 1)
            {
                dataTextFormat.find("option[value='CopyField']").hide();
            }

            var identicalFormatterData = {};

            var first = true;
            for (let formatterData of allFormatterData)
            {
                if (formatterData === null)
                {
                    formatterData = { formatterName: FORMATTER_NAMES.DEFAULT };
                }

                for (let property in formatterData)
                {
                    if (identicalFormatterData.hasOwnProperty(property))
                    {
                        if (identicalFormatterData[property] !== formatterData[property])
                        {
                            identicalFormatterData[property] = null;
                        }
                    }
                    else if (first)
                    {
                        identicalFormatterData[property] = formatterData[property];
                    }
                }
                first = false;
            }

            if (!identicalFormatterData.formatterName)
            {
                dataTextFormat.val("");
                return;
            }

            dataTextFormat.val(identicalFormatterData.formatterName);

            if (identicalFormatterData.formatterName)
            {
                if (identicalFormatterData.formatterName === FORMATTER_NAMES.COPY_FIELD && allFormatterData.length > 1)
                {
                    return;
                }

                for (let controlData of formatterControlsDataMap.get(identicalFormatterData.formatterName))
                {
                    var element = controlData.element;

                    $.each(controlData.dataBindings, function (propertyName, sourceType)
                    {
                        var value = identicalFormatterData[propertyName];
                        if (value === undefined)
                        {
                            value = "";
                        }

                        switch (sourceType)
                        {
                            case "Val":
                                if (element.is("input.checkbox"))
                                {
                                    element.prop("checked", value && value !== "False" ? true : false);
                                }
                                else
                                {
                                    if (element.attr("type") == "text")
                                    {
                                        element.val(value === undefined ? "" : value);
                                    }
                                    else if (skyward.extensions.isNumeric(value))
                                    {
                                        element.val(parseInt(value, 10));
                                    }
                                    else
                                    {
                                        element.val(value === undefined ? "" : value);
                                    }
                                }
                                break;
                            case "FieldSelectorText":
                                element.find(".fieldSelectorText").text(value);
                                break;
                            case "FieldSelectorIcon":
                                var svgHolder = element.find(".svgHolder");
                                $.when(getSvgByDataType(value.split(" ")[0], "TreeBrowse")).done(function (svg)
                                {
                                    svgHolder.html(svg);
                                });
                            // don't break - Field Selector SVG icon is displayed, but the type-string needs to be saved as "Data" too.
                            case "Data":
                                if (value === undefined)
                                {
                                    element.removeData(propertyName);
                                }
                                else
                                {
                                    element.data(propertyName, value);
                                }
                                break;
                        }
                    });
                }
            }

            reportDesignerProperties.find(".fieldSet" + identicalFormatterData.formatterName + "Formatter").show();

        }

        function setCellFormattingPropertiesControls(columnData)
        {
            rotationValue.val(columnData.rotation);
            rotationRange.val(columnData.rotation);
            columnWidth.val(columnData.fieldWidth);
            columnHeight.val(columnData.fieldHeight);
            columnData.paddingTop >= 0 ? editorPaddingTop.val(columnData.paddingTop) : editorPaddingTop.val(defaultColumnPadding);
            columnData.paddingBottom >= 0 ? editorPaddingBottom.val(columnData.paddingBottom) : editorPaddingBottom.val(defaultColumnPadding);
            columnData.paddingLeft >= 0 ? editorPaddingLeft.val(columnData.paddingLeft) : editorPaddingLeft.val(defaultColumnPadding);
            columnData.paddingRight >= 0 ? editorPaddingRight.val(columnData.paddingRight) : editorPaddingRight.val(defaultColumnPadding);
        }

        function setBorderFormattingPropertiesControls(values)
        {
            values.borderStyle ? borderStyle.val(values.borderStyle) : borderStyle.val();
            borderTop.prop('checked', values.borderTop);
            borderBottom.prop('checked', values.borderBottom);
            borderLeft.prop('checked', values.borderLeft);
            borderRight.prop('checked', values.borderRight);
            borderWidth.val(values.borderWidth);

            borderColor.data("color", values.borderColor ?? defaultDataForeColor); // set this on the element so when colorPicker initializes it starts with the correct color.
            values.borderColor ? borderColor.spectrum("set", values.borderColor) : borderColor.spectrum("set", defaultDataForeColor);
        }

        function setRowExportPropertiesValues(rowData)
        {
            if (rowData.nodeName?.trim().length > 0)
            {
                exportProperties.xml.row.nodeName.val(rowData.nodeName);
            }
            else if (exportProperties.xml.row.nodeName.length > 0)
            {
                const rowName = getRowFieldName(rowData) || rowData.defaultLineLabel;
                rowData.nodeName = rowName;
                exportProperties.xml.row.nodeName.val(rowName);
            }
        }

        function setRowPropertiesValues(rowData, canRepeatAfterStart)
        {
            setPrintAtBottomOfPageValue(rowData);

            if (rowData.reportFooterLine)
            {
                setPrintReportFooterOnNewPageValue(rowData);
            }

            if (canRepeatAfterStart)
            {
                setRepeatLineAfterStartValue(rowData);
            }

            isHiddenSelector.setIsHiddenCondition(rowData.isHiddenCondition, "Row", getSvgByDataType, null, getColumnLabelWithPreTextByColumnID);

            lineHeight.val(rowData.lineHeight);

            dataBackgroundColor.data("color", rowData.backColor ?? defaultDataBackColor); // set this on the element so when colorPicker initializes it starts with the correct color.
            rowData.backColor ? dataBackgroundColor.spectrum("set", rowData.backColor) : dataBackgroundColor.spectrum("set", defaultDataBackColor);
            editorRepeatRowOnPageIfDetailsPresent.prop('checked', rowData.repeatOnPageIfDetailsPresent);
            editorRepeatHeaderForEachDataRow.prop('checked', rowData.repeatHeaderForEachDataRow);

            skyward.reporting.selectVariablesToReset(rowData.variableIdsToReset);

            editorSectionAndLineDisplayName.val(rowData.reportLabelText);
            sectionAndLineFullName.siblings(".propertiesLabel").text("Sort Field Path");
            sectionAndLineFullName.val(getRowFieldName(rowData));

            setRowExportPropertiesValues(rowData);

            setBorderFormattingPropertiesControls(rowData);

            setPropertiesOnRowForPrintOnOneLine();
        }

        function setPrintAtBottomOfPageValue(rowData)
        {
            if (rowData.printAtBottomOfPagePromptUniqueId)
            {
                var printAtBottomPrompt = skyward.reporting.prompts.promptCollection.Get(rowData.printAtBottomOfPagePromptUniqueId);
                skyward.filterbuilder.setConditionSpanValue(editorPrintAtBottomOfPage.parent(), printAtBottomPrompt.Label, { promptUniqueId: printAtBottomPrompt.PromptUniqueId }, "DialogPrompt", false);
            }
            else if (rowData.printAtBottomOfPage != undefined)
            {
                skyward.filterbuilder.setConditionSpanValue(editorPrintAtBottomOfPage.parent(),
                    rowData.printAtBottomOfPage.toDisplayString(),
                    { boolvalue: rowData.printAtBottomOfPage },
                    null,
                    false);
            }
        }

        function setPrintReportFooterOnNewPageValue(rowData)
        {
            if (rowData.printReportFooterOnNewPagePromptUniqueId)
            {
                var prompt = skyward.reporting.prompts.promptCollection.Get(rowData.printReportFooterOnNewPagePromptUniqueId);
                skyward.filterbuilder.setConditionSpanValue(editorPrintReportFooterOnNewPage.parent(), prompt.Label, { promptUniqueId: prompt.PromptUniqueId }, "DialogPrompt", false);
            }
            else
            {
                if (rowData.printReportFooterOnNewPage === undefined)
                {
                    rowData.printReportFooterOnNewPage = false;
                }

                skyward.filterbuilder.setConditionSpanValue(editorPrintReportFooterOnNewPage.parent(),
                    rowData.printReportFooterOnNewPage.toDisplayString(),
                    { boolvalue: rowData.printReportFooterOnNewPage },
                    null,
                    false);
            }
        }

        function setRepeatLineAfterStartValue(rowData)
        {
            if (rowData.repeatLineAfterStartPromptUniqueId)
            {
                var repeatLineAfterStartPrompt = skyward.reporting.prompts.promptCollection.Get(rowData.repeatLineAfterStartPromptUniqueId);
                skyward.filterbuilder.setConditionSpanValue(editorRepeatLineAfterStart.parent(), repeatLineAfterStartPrompt.Label, { promptUniqueId: repeatLineAfterStartPrompt.PromptUniqueId }, "DialogPrompt", false);
            }
            else
            {
                skyward.filterbuilder.setConditionSpanValue(editorRepeatLineAfterStart.parent(),
                    rowData.repeatLineAfterStart.toDisplayString(),
                    { boolvalue: rowData.repeatLineAfterStart },
                    null,
                    false);
            }
        }

        function setSectionExportPropertiesValues(sectionData)
        {
            if (sectionData.nodeName?.trim().length > 0)
            {
                exportProperties.xml.section.nodeName.val(sectionData.nodeName);
            }
            else if (exportProperties.xml.section.nodeName.length > 0)
            {
                currentRow.data("nodeName", sectionData.displayName);
                exportProperties.xml.section.nodeName.val(sectionData.displayName);
            }

            if (sectionData.jsonPropertyName?.trim().length > 0)
            {
                exportProperties.json.section.name.val(sectionData.jsonPropertyName);
            }
            else if (exportProperties.json.section.name.length > 0)
            {
                currentRow.data("jsonPropertyName", sectionData.displayName);
                exportProperties.json.section.name.val(sectionData.displayName);
            }
        }

        function setSectionPropertiesValues(section)
        {
            const sectionData = section.data();
            const isDetailSection = section.hasClass("detailsSection");
            editorPageBreakBeforeSectionPrints.prop('checked', sectionData.pageBreakBeforeSection);
            editorPrintIfEmpty.prop('checked', sectionData.printIfEmpty);
            editorSectionAndLineDisplayName.val(sectionData.displayName);
            sectionAndLineFullName.siblings(".propertiesLabel").text(isDetailSection ? "Relationship Path" : "Section Object");
            let sectionAndLineFullNameValue;

            if (isDetailSection)
            {
                sectionAndLineFullNameValue = sectionData.relationshipPath.substring(sectionData.relationshipPath.indexOf(".") + 1);
            }
            else
            {
                sectionAndLineFullNameValue = sectionData.sectionObjectName;
            }

            sectionAndLineFullName.val(sectionAndLineFullNameValue);
            editorEmptyLinesToPrint.val(sectionData.emptyLinesToPrint);

            setPropertiesOnSectionForDefaultSubjects(section);
            setPropertiesOnSectionForPrintOnOneLine(section);
            setSectionExportPropertiesValues(sectionData);

            isHiddenSelector.setIsHiddenCondition(sectionData.isHiddenCondition, "Section", getSvgByDataType, null, null);
        }

        function setPropertiesOnSectionForPrintOnOneLine(section)
        {
            const sectionData = section.data();
            const isDetailSection = section.hasClass("detailsSection");
            skyward.controls.setValue(editorDisplayOnSingleLine, sectionData.displayOnSingleLine, true);

            const parentDisplayOnSingleLine = isParentDisplayOnSingleLine(section);
            const hasDetailSections = section.find(".detailsSection").length > 0;

            skyward.controls.toggle(editorPrintIfEmpty, !(isDetailSection && parentDisplayOnSingleLine));
            skyward.controls.toggle(editorPageBreakBeforeSectionPrints, !(isDetailSection && parentDisplayOnSingleLine));
            skyward.controls.toggle(editorDisplayOnSingleLine, hasDetailSections && !(isDetailSection && parentDisplayOnSingleLine));

            skyward.controls.hide(singleLineRecordCountFieldSetTemplate, false);
            removeSingleLineRecordCountInputs();
            if (sectionData.displayOnSingleLine && !parentDisplayOnSingleLine)
            {
                addSingleLineRecordCountInputs(section);
            }

            reportDesignerProperties.find(".emptyLinesToPrintFieldset").toggle(sectionData.printIfEmpty);
        }

        function setPropertiesOnSectionForDefaultSubjects(section)
        {
            const sectionData = section.data();
            editorDefaultSubjects.find(".js-processing-list-subject").each(function ()
            {
                const subjectElement = $(this);
                const subjectData = subjectElement.data();
                const subjectSkywardID = subjectData.subjectSkywardId;

                let displaySubject = false;
                if (sectionData.defaultProcessingListSubjectSkywardIds)
                {
                    displaySubject = sectionData.defaultProcessingListSubjectSkywardIds.some(skywardID => skywardID.toLowerCase() === subjectSkywardID.toLowerCase());
                }

                skyward.controls.toggleVisible(subjectElement, displaySubject, false);
            });
        }

        function addSingleLineRecordCountInputs(section)
        {
            var detailSections = section.find(".jsSection");
            $.each(detailSections, function (index, detailSection)
            {
                detailSection = $(detailSection);
                var sectionID = detailSection.data("sectionId");
                var sectionName = detailSection.data("displayName");

                var newFieldSet = singleLineRecordCountFieldSetTemplate.clone(true, true);
                newFieldSet.removeClass("jsTemplate");
                newFieldSet.data("sectionID", sectionID);

                var labelElement = newFieldSet.find(".propertiesLabel");
                labelElement.text(labelElement.text().replace("[Object]", sectionName));

                var singleLineRecordCount = detailSection.data("singleLineRecordCount");
                var singleLineRecordCountInput = newFieldSet.find(".editorSingleLineRecordCount");
                singleLineRecordCountInput.val(singleLineRecordCount);
                singleLineRecordCountInput.data("sectionID", sectionID);

                singleLineRecordCountFieldSetTemplate.before(newFieldSet);
                skyward.controls.show(newFieldSet, false);
            });
        }

        function removeSingleLineRecordCountInputs()
        {
            reportDesignerProperties.find(".singleLineRecordCountFieldSet:not(.jsTemplate)").remove();
        }

        function setPropertiesOnRowForPrintOnOneLine()
        {
            let section = getCurrentSection();
            if (section.length > 0)
            {
                let sectionData = section.data();

                const parentDisplayOnSingleLine = isParentDisplayOnSingleLine(section)

                skyward.controls.toggle(editorRepeatRowOnPageIfDetailsPresent, !sectionData.displayOnSingleLine);
                skyward.controls.toggle(editorRepeatHeaderForEachDataRow, !sectionData.displayOnSingleLine);
                editorPrintAtBottomOfPage.closest(".conditionValuesContainer").toggleClass("ui-disabled", parentDisplayOnSingleLine);
                editorRepeatLineAfterStart.closest(".conditionValuesContainer").toggleClass("ui-disabled", parentDisplayOnSingleLine);
            }
        }

        function setPropertiesOnColumnForPrintOnOneLine()
        {
            let section = getCurrentSection();
            if (section.length > 0)
            {
                let displayOnSingleLine = section.data("displayOnSingleLine");

                skyward.controls.toggle(runningTotal, !displayOnSingleLine);
            }
        }

        var buildResetOnOptions = function (section, toggleControlVisibility, columnData)
        {
            const options = {};
            let valueToSelect;
            const isHeaderFooterSection = section.is(".jsHeaderFooterSection");

            resetOption.val("").find('option').remove();
            if (isHeaderFooterSection)
            {
                valueToSelect = columnData ? columnData.resetOn : RESET_ON_TYPES.NEVER_RESET;
                options[RESET_ON_TYPES.NEVER_RESET] = "Never Reset";

                let anyMainSectionHasPageBreak = false;

                designer.find(".jsSection").each(function ()
                {
                    const section = $(this);
                    // page break aggregates
                    const sectionData = getSectionData(section);
                    if (section.hasClass("jsMainSection") && sectionData.pageBreakBeforeSection)
                    {
                        anyMainSectionHasPageBreak = true;
                    }

                    const sorts = getSectionSorts(section);
                    if (sorts)
                    {
                        sorts.forEach(function (sortData)
                        {
                            if (sortData.PageBreak === skyward.reportingSorts.pageBreakOptions.True ||
                                sortData.PageBreak === skyward.reportingSorts.pageBreakOptions.Burst)
                            {
                                options[sortData.FieldName] = "Sort: " + (sortData.RelativeDataPath ?? sortData.FieldName);
                            }
                        });
                    }
                });

                if (anyMainSectionHasPageBreak)
                {
                    options[RESET_ON_TYPES.MAIN_SECTIONS] = "Main Sections with Page Breaks";
                }
            }
            else
            {
                const isResettablePageColumn = isPageNumberOrPageTotalColumn(columnData);
                valueToSelect = (columnData && columnData.resetOn) ? columnData.resetOn : (isResettablePageColumn ? RESET_ON_TYPES.NEVER_RESET : RESET_ON_TYPES.SECTION);

                if (isResettablePageColumn)
                {
                    options[RESET_ON_TYPES.NEVER_RESET] = "Never Reset";
                }
                else
                {
                    options[RESET_ON_TYPES.SECTION] = "Section";
                }

                getSectionSorts(section).forEach(function (sortData)
                {
                    if (columnData.isRunningTotal ||
                        sortData.PageBreak === skyward.reportingSorts.pageBreakOptions.True ||
                        sortData.PageBreak === skyward.reportingSorts.pageBreakOptions.Burst)
                    {
                        const fieldName = sortData.FieldName;
                        const sortDisplayName = sortData.RelativeDataPath ?? sortData.FieldName;
                        options[fieldName] = sortDisplayName;
                    }
                });
            }


            $.each(options, function (value, displayName)
            {
                resetOption.append('<option value="' + value + '">' + displayName + '</option>');
                if (value == valueToSelect)
                {
                    resetOption.val(valueToSelect);
                }
            });

            if (resetOption.val() == "")
            {
                for (let firstOption in options)
                {
                    resetOption.val(firstOption);
                    break;
                }
            }

            if (toggleControlVisibility)
            {
                if (resetOption.children().length === 1 && resetOption.val() === RESET_ON_TYPES.NEVER_RESET)
                {
                    reportDesignerProperties.find(".resetOptionsFieldset").hide();
                }
                else
                {
                    reportDesignerProperties.find(".resetOptionsFieldset").show();
                }
            }
        };

        let isPageNumberOrPageTotalColumn = function (columnData)
        {
            return columnData.fieldColumnType == COLUMN_TYPES.PAGE_SECTION_COLUMN && (columnData.pageSectionColumnType == "PageTotal" || columnData.pageSectionColumnType == "PageNumber");
        }

        let isPromptColumn = function (columnData)
        {
            return columnData.fieldColumnType == COLUMN_TYPES.PAGE_SECTION_COLUMN && columnData.pageSectionColumnType == "PromptValue";
        }

        var isCalculatedFieldUsedInAnyExistFilters = function (calculatedField)
        {
            var sections = getAllSections();

            for (const section of sections)
            {
                var currentFilterData = getSectionFilterObjectAndParameters($(section));
                var filters = currentFilterData ? currentFilterData.filterObject : null;
                if (filters != null)
                {
                    if (filters["@Type"] === skyward.searchCondition.Types.SearchConditionGroup && isCalculatedFieldUsedInExistFilters(calculatedField.id, filters.SearchCondition, false))
                    {
                        return true;
                    }
                    else if (filters["@Type"] === skyward.searchCondition.Types.ExistsSearchCondition && isCalculatedFieldUsedInExistFilters(calculatedField.id, filters.SearchCondition, true))
                    {
                        return true;
                    }
                }
            }

            return false;
        };

        var isCalculatedFieldUsedInExistFilters = function (calculatedFieldName, searchCondition, inExists)
        {
            if (!searchCondition)
            {
                return false;
            }

            var filters = Array.isArray(searchCondition) ? searchCondition : [searchCondition];
            for (const filter of filters)
            {
                if (filter["@Type"] === skyward.searchCondition.Types.SearchConditionGroup && isCalculatedFieldUsedInExistFilters(calculatedFieldName, filter.SearchCondition, inExists))
                {
                    return true;
                }
                else if (filter["@Type"] === skyward.searchCondition.Types.ExistsSearchCondition && isCalculatedFieldUsedInExistFilters(calculatedFieldName, filter.SearchCondition, true))
                {
                    return true;
                }
                else if (filter["@CalculatedFieldName"] === calculatedFieldName && inExists)
                {
                    return true;
                }
            }

            return false;
        };

        var areThereMultipleSectionsOnTheSameObject = function (currentSection)
        {
            let sectionCount = 0;
            const currentSectionData = getSectionData(currentSection);
            const currentModule = currentSectionData.rootModule;
            const currentObject = currentSectionData.rootObject;
            const currentRelationshipPath = currentSectionData.entireRelationshipPath;

            getAllSections().each(function ()
            {
                const section = $(this);
                const sectionData = getSectionData(section);
                if (sectionData.rootModule == currentModule && sectionData.rootObject == currentObject && sectionData.entireRelationshipPath == currentRelationshipPath)
                {
                    sectionCount++;
                }
            });

            return sectionCount > 1;
        };

        skyward.reporting.updateCalculatedField = function (calculatedFieldID)
        {
            var calculatedField = CalculatedFields_Model.Get(calculatedFieldID);
            skyward.calculatedFieldBuilder.launch({
                fieldName: calculatedField.fieldName,
                expression: calculatedField.expression,
                schemaObject: calculatedField.schemaObject,
                id: calculatedField.id,
                relationshipPath: calculatedField.relationshipPath,
                prompts: skyward.reporting.prompts.promptCollection,
                usedInExistsFilter: isCalculatedFieldUsedInAnyExistFilters(calculatedField),
                callback: function (result)
                {
                    CalculatedFields_Model.Set(result);
                    editorColumnText.val(skyward.reporting.prompts.promptCollection.ConvertPromptBindingsToFriendlyNames(result.expression));
                    columnDataPath.val(result.fieldName);
                    //update designer text and related data for json serialization
                    entireCanvas.find('[data-operation-id=' + result.id + ']').each(function ()
                    {
                        const reportElement = $(this);

                        reportElement.data("field-name", result.fieldName);
                        reportElement.attr("data-field-name", result.fieldName); //Update the attribute because automated tests look at this

                        if (reportElement.hasClass("reportColumn"))
                        {
                            reportElement.data("designer-text", result.fieldName); // we need to set both data and attribute
                            reportElement.attr("data-designer-text", result.fieldName); //Update the attribute because automated tests look at this

                            //we don't care about field type or column field type on header column containers
                            if (reportElement.data("field-column-type") !== COLUMN_TYPES.HEADER_COLUMN)
                            {
                                reportElement.data("field-type", result.dataType);

                                if (reportElement.data("column-field-type"))
                                {
                                    reportElement.data("column-field-type", result.dataType);
                                }
                            }

                            const columnLabel = getColumnLabelWithPreText(reportElement);

                            const affectedColumn = reportElement.children(".column_content");
                            if (affectedColumn.length > 0)
                            {
                                affectedColumn.text(columnLabel);
                            }
                        }
                    });

                    designer.find(".jsSection").each(function ()
                    {
                        const section = $(this);

                        const sortIDsUpdated = [];

                        const sectionSorts = getSectionSorts(section);
                        if (sectionSorts)
                        {
                            for (let sort of sectionSorts)
                            {
                                if (sort.CalculatedField && sort.CalculatedField.id == result.id)
                                {
                                    sortIDsUpdated.push(sort.ReportSortID);
                                    sort.FieldName = result.fieldName;
                                    sort.CalculatedField.fieldName = result.fieldName;
                                }
                            }
                            updateSectionSortData(section, sectionSorts);
                        }

                        const sortHeaderLines = getSectionSortHeaderLines(section);
                        for (let sortHeaderLine of sortHeaderLines)
                        {
                            const line = $(sortHeaderLine);
                            const lineData = line.data();

                            if (sortIDsUpdated.includes(lineData.relatedReportSortId))
                            {
                                const lineIndex = lineData.lineIndex;
                                const oldDefaultLabel = lineData.defaultLineLabel;
                                const newDefaultLabel = result.fieldName + " " + lineIndex;

                                line.data("default-line-label", newDefaultLabel);
                                line.attr("data-default-line-label", newDefaultLabel); //Update the attribute because automated tests look at this

                                if (lineData.reportLabelText === oldDefaultLabel)
                                {
                                    line.data("report-label-text", newDefaultLabel);
                                }
                            }
                        }

                        const sortAggregateLines = getSectionSortAggregateLines(section);
                        for (let sortAggregateLine of sortAggregateLines)
                        {
                            const line = $(sortAggregateLine);
                            const lineData = line.data();

                            if (sortIDsUpdated.includes(lineData.relatedReportSortId))
                            {
                                const lineIndex = lineData.lineIndex;
                                const oldDefaultLabel = lineData.defaultLineLabel;
                                const newDefaultLabel = result.fieldName + " " + lineIndex;

                                if (oldDefaultLabel)
                                {
                                    line.data("default-line-label", newDefaultLabel);
                                    line.attr("data-default-line-label", newDefaultLabel); //Update the attribute because automated tests look at this
                                }
                                if (lineData.reportLabelText === oldDefaultLabel)
                                {
                                    line.data("report-label-text", newDefaultLabel);
                                }
                            }
                        }
                    });

                    updateDesignerSidebarCalculatedFieldList(getCurrentSection().data());
                    designer.find(".calculatedField[data-fieldid='" + result.id + "'] .column_content").html(result.fieldName);
                    updateHiddenField();
                    labelBuilder.buildLabelColumns(true);
                }
            });
        };

        //GENERAL HELPERS
        const getSectionData = function ($section)
        {
            const sectionData = $section.data();
            const filterData = getSectionFilterObjectAndParameters($section);
            let section =
            {
                relationshipPath: sectionData.relationshipPath,
                entireRelationshipPath: sectionData.entireRelationshipPath,
                baseObject: sectionData.baseObject,
                baseModule: sectionData.baseModule,
                rootObject: sectionData.rootObject,
                rootModule: sectionData.rootModule,
                sectionObjectName: sectionData.sectionObjectName,
                displayName: sectionData.displayName,
                Filters: filterData && filterData.filterObject ? filterData.filterObject : null,
                FiltersParameters: filterData && filterData.parameters ? filterData.parameters : null,
                sectionID: sectionData.sectionId,
                pageBreakBeforeSection: sectionData.pageBreakBeforeSection,
                parameters: sectionData.parameters,
                promptForSortOrder: sectionData.promptForSortOrder,
                sortPromptLabel: sectionData.sortPromptLabel,
                sortPromptGuid: sectionData.sortPromptGuid,
                printIfEmpty: sectionData.printIfEmpty,
                displayOnSingleLine: sectionData.displayOnSingleLine,
                singleLineRecordCount: $.safeRound(sectionData.singleLineRecordCount),
                emptyLinesToPrint: $.safeRound(sectionData.emptyLinesToPrint),
                nodeName: sectionData.nodeName,
                jsonPropertyName: sectionData.jsonPropertyName,
                isHiddenCondition: sectionData.isHiddenCondition,
                columnWidth: sectionData.columnWidth,
                columnSpacing: sectionData.columnSpacing,
                applyColumnsToDataLinesOnly: sectionData.applyColumnsToDataLinesOnly,
                balanceColumns: sectionData.balanceColumns,
                columnDirection: sectionData.columnDirection,
                reportSorts: sectionData.reportSorts,
                defaultProcessingListSubjectSkywardIDs: sectionData.defaultProcessingListSubjectSkywardIds
            };

            return section;
        };

        const isAggregateLineType = (lineType) => lineType === LINE_TYPES.SORT_AGGREGATE_LINE || lineType === LINE_TYPES.AGGREGATE_LINE;

        const getParentSection = function (sectionOrRow)
        {
            return sectionOrRow.parent().closest(".jsSection");
        };

        const getAllParentSections = (section) => section.parents(".jsSection");

        const getSectionFilterObjectAndParameters = function ($section)
        {
            const filterData = $section.find(".filterViewValue").data();
            let filterObj = filterData ? filterData.filterCondition : {};
            if (typeof (filterObj) === "string")
            {
                if (filterObj === "" || filterObj == "{}")
                {
                    return null;
                }
                filterObj = JSON.parse(filterObj);
            }

            if ($.isEmptyObject(filterObj))
            {
                return null;
            }

            let filterSchemaFields = filterData ? filterData.filterSchemaFields : {};
            if (typeof (filterSchemaFields) === "string")
            {
                filterSchemaFields = JSON.parse(filterSchemaFields);
            }

            return { "filterObject": filterObj, "parameters": filterData.parameters, "filterSchemaFields": filterSchemaFields };
        };

        const getSectionAllAggregateLines = function (section)
        {
            return $.merge(getSectionSortAggregateLines(section), getSectionAggregateLines(section));
        };

        const getSectionSingleLinePreview = function (section)
        {
            return section.find(">.sectionBody>.printOnOneLinePreview");
        };

        const getSectionLines = function (section)
        {
            return section.find('>.sectionBody>.reportLine');
        };

        const getCorrespondingHeaderLine = function (section, dataLine)
        {
            var dataLineIndex = dataLine.data("lineIndex");
            return section.find('>.sectionBody>.jsHeaderLine[data-line-index="' + dataLineIndex + '"]');
        };

        const getSectionHeaderLines = function (section)
        {
            return section.find('>.sectionBody>.jsHeaderLine');
        };

        const getSectionFooterLines = function (section)
        {
            return section.find('>.sectionBody>.jsFooterLine');
        };

        const getSectionDataLines = function (section)
        {
            return section.find('>.sectionBody>.jsDataLine');
        };

        const getMaxSectionLineIndex = function (section)
        {
            return Math.max(getSectionDataLines(section).last().data("lineIndex"), getSectionHeaderLines(section).last().data("lineIndex"));
        };

        const getMaxSectionAggregateLineIndex = function (section)
        {
            return getSectionAggregateLines(section).last().data("lineIndex");
        };

        const getNextSortAggregateLineIndex = function (section, reportSortId)
        {
            const lastSortAggregateLine = getSectionSortAggregateLinesByReportSortID(section, reportSortId).pop();
            if (lastSortAggregateLine)
            {
                const lineIndex = $(lastSortAggregateLine).data("lineIndex");
                return lineIndex + 1;
            }
            return 0;
        };

        const getNextSortHeaderLineIndex = function (section, reportSortId)
        {
            const lastSortHeaderLine = getSectionSortHeaderLinesByReportSortID(section, reportSortId).pop();
            if (lastSortHeaderLine)
            {
                const lineIndex = $(lastSortHeaderLine).data("lineIndex");
                return lineIndex + 1;
            }
            return 0;
        };

        const getSectionSortAggregateLinesByReportSortID = function (section, reportSortId)
        {
            const sortAggregateLines = getSectionSortAggregateLines(section);
            const filteredSortAggregateLines = [];
            if (sortAggregateLines.length > 0)
            {
                for (let sortAggregateLine of sortAggregateLines)
                {
                    const line = $(sortAggregateLine);
                    if (line.data("relatedReportSortId") === reportSortId)
                    {
                        filteredSortAggregateLines.push(sortAggregateLine);
                    }
                }
            }

            return filteredSortAggregateLines;
        }

        const getSectionSortHeaderLinesByReportSortID = function (section, reportSortId)
        {
            const sortHeaderLines = getSectionSortHeaderLines(section);
            const filteredSortHeaderLines = [];
            if (sortHeaderLines.length > 0)
            {
                for (let sortHeaderLine of sortHeaderLines)
                {
                    const line = $(sortHeaderLine);
                    if (line.data("relatedReportSortId") === reportSortId)
                    {
                        filteredSortHeaderLines.push(sortHeaderLine);
                    }
                }
            }

            return filteredSortHeaderLines;
        }

        const getSectionSortAggregateLines = function (section)
        {
            return section.find(">.sectionBody>.jsSortAggregateLine");
        };

        const getSectionSortHeaderLines = function (section)
        {
            return section.find(">.sectionBody>.sortHeaderLine");
        };

        const getSectionAggregateLines = function (section)
        {
            return section.find('>.sectionBody>.jsSectionAggregateLine');
        };

        const getSectionSorts = function (section)
        {
            return section.data("reportSorts");
        };

        var getSectionSortOrderByReportSortID = function (section, reportSortID)
        {
            const allSectionSorts = getSectionSorts(section);
            const sortData = allSectionSorts.find(sort => { return sort.ReportSortID === reportSortID });
            if (sortData)
            {
                return sortData.SortOrder;
            }

            return 0;
        };

        var getSortDataByReportSortID = function (section, reportSortID)
        {
            const allSectionSorts = getSectionSorts(section);
            const sortData = allSectionSorts.find(sort => { return sort.ReportSortID === reportSortID });
            return sortData;
        };

        const getRowFieldName = function (rowData)
        {
            if (rowData.relatedReportSortId)
            {
                const section = getSectionByLine(getLineByID(rowData.lineId));
                const relatedSort = getSortDataByReportSortID(section, rowData.relatedReportSortId);
                return relatedSort.FieldName;
            }

            return rowData.fieldName;
        };

        const getColumnsInLine = function (lines)
        {
            return lines.find('.jsColumn');
        };

        const getColumnsInLineByFieldName = function (lines, fieldName)
        {
            return lines.find('[data-field-name="' + $.escapeSelector(fieldName) + '"]');
        };

        const getColumnsInLineByAbsoluteFieldPath = function (lines, absoluteFieldPath)
        {
            return lines.find('[data-absolute-field-path="' + $.escapeSelector(absoluteFieldPath) + '"]');
        };

        const getSectionAllColumns = function (section)
        {
            return section.find('>.sectionBody>.reportLine:not(.jsPrintOnOneLinePreviewLine)>.jsColumn');
        };

        const getSectionAllCalculatedFieldIDs = function (section)
        {
            const sectionData = section.data();
            const calculatedFieldsForSection = CalculatedFields_Model.AllFieldsOfModuleAndObject(sectionData.rootModule, sectionData.rootObject, sectionData.entireRelationshipPath);

            const calculatedFieldIDsForSection = [];
            $.each(calculatedFieldsForSection, function (key)
            {
                calculatedFieldIDsForSection.push(key);
            });

            return calculatedFieldIDsForSection;
        };

        const getColumnsBySourceColumnID = (columnID) => entireCanvas.find(`[data-source-column-id='${columnID}']`);

        const getColumnByID = (columnID) => entireCanvas.find(`[data-column-id='${columnID}']`);

        const getReportHeaderLine = function ()
        {
            return designer.find('.jsReportHeaderLine');
        };

        const getReportFooterLine = function ()
        {
            return designer.find('.jsReportFooterLine');
        };

        const getPageHeaderLine = function ()
        {
            return designer.find('.jsPageHeaderLine');
        };

        const getPageFooterLine = function ()
        {
            return designer.find('.jsPageFooterLine');
        };

        const getAllHeaderFooterSections = function ()
        {
            return designer.find('.jsHeaderFooterSection');
        };

        const getAllSorts = function ()
        {
            const reportSorts = [];
            designer.find(".jsSection").each(function ()
            {
                const section = $(this);
                const sectionSorts = getSectionSorts(section);
                if (sectionSorts)
                {
                    sectionSorts.forEach(function (sort)
                    {
                        reportSorts.push(sort);
                    });
                }
            });
            return reportSorts;
        };

        const getAllMainSections = function ()
        {
            return designer.find('.jsMainSection');
        };

        const getAllSections = function ()
        {
            return designer.find(".jsSection");
        }

        const getCurrentSection = function ()
        {
            return entireCanvas.find(".sectionSelected");
        };

        const getAllNonPreviewLines = function (section)
        {
            return (section ?? entireCanvas).find(".reportLine:not(.jsPrintOnOneLinePreviewLine)");
        };

        const getSectionNonPreviewLines = function (section)
        {
            return section.children('.sectionBody').find(".reportLine:not(.jsPrintOnOneLinePreviewLine)");
        };

        const getCurrentAndDetailSections = function (section)
        {
            return (section ?? getCurrentSection()).find(".jsSection").addBack();
        };

        const getDetailSections = function (section)
        {
            return section.children(".detailSectionContainer").children(".jsSection");
        };

        const getNestedDetailSections = function (section)
        {
            return section.find(".jsSection");
        };

        const getParentLine = function (column)
        {
            return column.closest(".reportLine");
        };

        const isSection = (element) => element.is(".jsSection");

        const isLine = (element) => element.is(".reportLine");

        const getLineByID = (id) => entireCanvas.find(".reportLine[data-line-id='" + id + "']");

        const getSectionByLine = (line) => line.closest(".jsSection");

        const getSectionToolbar = (section) => section.find(".sectionToolbar").first();

        const getCurrentSectionToolbar = () => getSectionToolbar(getCurrentSection());

        const getCurrentSectionFilterLaunchButton = function ()
        {
            return getCurrentSectionToolbar().find(".filterBuilderLaunchButton");
        };

        const getSectionsByModuleAndObject = function (schemaObject, relationshipPath)
        {
            let matchingSections = [];

            getAllMainSections().each(function (index, sectionElement)
            {
                const section = $(sectionElement);

                if (sectionMatchesSchemaAndPath(section, schemaObject, relationshipPath))
                {
                    matchingSections.push(section);
                }

                const detailSections = getNestedDetailSections(section);

                detailSections.each(function (index, detailSectionElement)
                {
                    const detailSection = $(detailSectionElement);

                    if (sectionMatchesSchemaAndPath(detailSection, schemaObject, relationshipPath))
                    {
                        matchingSections.push(detailSection);
                    }
                })
            });

            return matchingSections;
        };

        function sectionMatchesSchemaAndPath(section, schemaObject, relationshipPath)
        {
            const sectionData = section.data();
            const sectionSchemaObject = `${sectionData.rootModule}.${sectionData.rootObject}`;

            return sectionSchemaObject === schemaObject && (sectionData.entireRelationshipPath ?? "") === (relationshipPath ?? "");
        }

        const insertNewLine = function ($section, html)
        {
            if (html.hasClass('sortHeaderLine'))
            {
                insertSortHeaderLine($section, html);
            }
            else if (html.hasClass('jsHeaderLine'))
            {
                insertHeaderLine($section, html);
            }
            else if (html.hasClass('jsDataLine'))
            {
                insertDataLine($section, html);
            }
            else if (html.hasClass('jsFooterLine'))
            {
                insertFooterLine($section, html);
            }
            else if (html.hasClass('jsSectionAggregateLine'))
            {
                insertSectionAggregateLine($section, html);
            }
            else if (html.hasClass('jsSortAggregateLine'))
            {
                insertSortAggregateLine($section, html);
                setSelectedRow(html);
            }

            initDesignerUI($section);

            updateHiddenField();
        };

        const insertHeaderLine = function ($section, html)
        {
            html.insertAfter(getSectionHeaderLines($section).last());
        };

        const insertDataLine = function ($section, html)
        {
            html.insertAfter(getSectionDataLines($section).last());
        };

        const reInsertSingleLinePreview = function ($section)
        {
            const preview = getSectionSingleLinePreview($section);
            if (preview.length > 0)
            {
                preview.remove();
                preview.insertAfter(getSectionDataLines($section).last());
            }
        };

        const insertSortAggregateLine = function ($section, html)
        {
            const sortAggregateLines = getSectionSortAggregateLines($section);
            const data = html.data();
            const existingSameSortLine = getSortLineForExistingSameSort(sortAggregateLines, data.relatedReportSortId);

            if (existingSameSortLine)
            {
                html.insertAfter(existingSameSortLine);
            }
            else
            {
                const lineSortOrder = getSectionSortOrderByReportSortID($section, data.relatedReportSortId);
                const beforeSortAggregateLine = getSortLineForSortAggregateLine($section, sortAggregateLines, lineSortOrder);
                if (beforeSortAggregateLine)
                {
                    html.insertBefore(beforeSortAggregateLine);
                }
                else
                {
                    const sectionLines = getSectionLines($section);
                    for (let i = sectionLines.length - 1; i >= 0; i--)
                    {
                        const line = $(sectionLines[i]);
                        if (!(line.hasClass("jsFooterLine") || line.hasClass("jsSectionAggregateLine")))
                        {
                            html.insertAfter(line);
                            break;
                        }
                    }
                }
            }

            reInsertSingleLinePreview($section);
        };

        const getSortLineForSortAggregateLine = function (section, sortLines, sortOrder)
        {
            let sortAggregateLine;
            let foundSortOrder = -1;

            for (const line of sortLines)
            {
                const lineData = $(line).data();
                const lineSortOrder = getSectionSortOrderByReportSortID(section, lineData.relatedReportSortId);

                if (sortOrder > lineSortOrder && lineSortOrder > foundSortOrder)
                {
                    foundSortOrder = lineSortOrder;
                    sortAggregateLine = line;
                }
            }

            return sortAggregateLine;
        };

        const getSortLineForExistingSameSort = function (sortLines, relatedReportSortId)
        {
            let existingSameSortLine;
            for (const line of sortLines)
            {
                const lineData = $(line).data();
                if (lineData.relatedReportSortId == relatedReportSortId)
                {
                    existingSameSortLine = line;
                }
            }

            return existingSameSortLine;
        };

        const insertSortHeaderLine = function ($section, html)
        {
            const sortHeaderLines = getSectionSortHeaderLines($section);
            const data = html.data();
            const existingSameSortLine = getSortLineForExistingSameSort(sortHeaderLines, data.relatedReportSortId);

            if (existingSameSortLine)
            {
                html.insertAfter(existingSameSortLine);
            }
            else
            {
                const lineSortOrder = getSectionSortOrderByReportSortID($section, data.relatedReportSortId);
                const beforeSortHeaderLine = getSortLineForSortHeaderLine($section, sortHeaderLines, lineSortOrder);
                if (beforeSortHeaderLine)
                {
                    html.insertBefore(beforeSortHeaderLine);
                }
                else
                {
                    const beforeSortLine = getSectionDataLines($section).first();
                    html.insertBefore(beforeSortLine);
                }
            }
        };

        const getSortLineForSortHeaderLine = function (section, sortLines, sortOrder)
        {
            let sortHeaderLine;
            let foundSortOrder = undefined;

            for (const line of sortLines)
            {
                const lineData = $(line).data();
                const lineSortOrder = getSectionSortOrderByReportSortID(section, lineData.relatedReportSortId);

                if (sortOrder < lineSortOrder && (!foundSortOrder || lineSortOrder < foundSortOrder))
                {
                    foundSortOrder = lineSortOrder;
                    sortHeaderLine = line;
                }
            }

            return sortHeaderLine;
        };

        const updateSortDataSortOrder = function (sortData)
        {
            $.each(sortData, function (i, sort)
            {
                sort.SortOrder = i;
            });

            return sortData;
        };

        const updateSectionSortData = function (section, sortData)
        {
            section.data("reportSorts", sortData);
        };

        const insertSectionAggregateLine = function ($section, html)
        {
            var lastSectionLine = getSectionLines($section).last();
            if (lastSectionLine.hasClass("jsFooterLine"))
            {
                var firstSectionFooter = getSectionFooterLines($section).first();
                html.insertBefore(firstSectionFooter);
            }
            else
            {
                html.insertAfter(lastSectionLine);
            }

            reInsertSingleLinePreview($section);
        };

        const insertFooterLine = function ($section, html)
        {
            html.insertAfter(getSectionLines($section).last());

            reInsertSingleLinePreview($section);
        };

        const getSectionSelectedRow = function ($section)
        {
            let selectedLine = $section.find('.row-selected').not("li");

            if (selectedLine.length == 0)
            {
                // get the parent of the selected column
                const sectionID = $section.data("sectionId");
                selectedLine = currentSelectedColumns.getRowByLastSelectedColumnBySectionID(sectionID);
                if (!selectedLine || selectedLine.length == 0) //get the first data line
                {
                    selectedLine = getSectionDataLines($section).first();
                    if (selectedLine.length == 0)//just get the first reportLine in the section
                    {
                        selectedLine = $section.find(".reportLine").first();
                    }
                }
                selectedLine.add(selectedLine.data("relatedLabel")).addClass('row-selected');
            }
            return selectedLine;
        };

        const positionNewColumn = function (newColumn, reportLine, top, left, autoCreatedColumn)
        {
            var reportLinePosition = reportLine.offset();
            var calculated = { top: 0, left: 0 };
            var newColumnPosition = newColumn.position();
            var COLUMN_PLACEMENT_SPACING = 5;
            var widthNeeded = newColumn.data("fieldWidth") + COLUMN_PLACEMENT_SPACING;
            var newColumnHeight = newColumn.data("fieldHeight");

            if (!newColumnHeight || newColumnHeight <= 0)
            {
                newColumnHeight = DEFAULT_COLUMN_HEIGHT;
            }

            if (top != null && left != null)
            {
                //normal dropped field
                //this method is used when passing in the left from a previous drop, top will be NaN
                if (isNaN(top)) { top = 0; }

                if (!autoCreatedColumn)
                {
                    calculated.top = top - reportLinePosition.top;
                    calculated.left = left - reportLinePosition.left;
                }
                else
                {
                    calculated.top = top;
                    calculated.left = left;
                }
            }
            else if (top == null && left != null)
            {
                //auto added fields - i.e. header, set the top to 0
                calculated.top = newColumnPosition.top;
                calculated.left = left;
            }
            else
            {
                //all others

                var lineWidth = reportLine.width();
                var allColumns = reportLine.find('.jsFieldColumn');

                var findNextOpenPosition = function ()
                {
                    var bottomRightmost = { x: 0, y: 0, columnElement: null };
                    // find bottom rightmost column's corner
                    allColumns.each(function ()
                    {
                        var jqThis = $(this);
                        var thisPosition = jqThis.position();
                        var thisBottom = thisPosition.top + jqThis.outerHeight();
                        var thisRight = thisPosition.left + jqThis.outerWidth();
                        if (thisBottom < bottomRightmost.y)
                        {
                            return;
                        }
                        else
                        {
                            if ((thisBottom == bottomRightmost.y && thisRight > bottomRightmost.x) || thisBottom > bottomRightmost.y)
                            {
                                bottomRightmost.x = thisRight;
                                bottomRightmost.y = thisBottom;
                                bottomRightmost.columnElement = jqThis;
                            }
                            return;
                        }
                    });

                    // if that corner is off the right edge, move down.
                    if (bottomRightmost.x + widthNeeded > lineWidth)
                    {
                        return {
                            top: bottomRightmost.y + COLUMN_PLACEMENT_SPACING,
                            left: 1
                        };
                    }
                    else
                    {
                        return {
                            top: bottomRightmost.y - newColumnHeight,
                            left: bottomRightmost.x > 1 ? bottomRightmost.x + COLUMN_PLACEMENT_SPACING : bottomRightmost.x
                        };
                    }
                };
                calculated = findNextOpenPosition();
            }

            //validate
            if (calculated.top < 0)
            {
                calculated.top = 0;
            }

            if (calculated.left < 0)
            {
                calculated.left = 0;
            }

            calculated.left = $.safeRound(calculated.left);
            calculated.top = $.safeRound(calculated.top);

            //end validate
            newColumn.data('positionY', calculated.top);
            newColumn.data('positionX', calculated.left);

            newColumn.css('left', calculated.left + 'px');
            newColumn.css('top', calculated.top + 'px');
            newColumn.css('position', 'absolute');
            newColumn.css("z-index", "");
            return calculated;
        };

        //accepts params = { newItem: newItem, reportLine: reportLine, section: section, position: { top: top, left: left } }
        const insertColumnHelperFunction = function (params)
        {
            if (params.section?.hasClass('collapseSection'))
            {
                return;
            }
            const newPosition = positionNewColumn(params.newItem, params.reportLine, params.position.top, params.position.left, params.autoCreatedColumn);
            setSelectedRowByRow(params.reportLine);
            (params.newItem).insertBefore(params.reportLine.children('.ui-resizable-handle'));
            setDefaultItemFormatting(params.newItem);
            applyColumnCss(params.newItem);
            initColumnDragging(params.newItem);
            params.newItem.resizable(columnResizableOptions);
            const newItemBottomPosition = params.newItem.position().top + params.newItem.outerHeight();
            if (newItemBottomPosition > currentRow.data("lineHeight"))
            {
                currentRow.data("lineHeight", newItemBottomPosition)
                    ?.css("height", newItemBottomPosition + "px")
                    .trigger('resize');
            }
            updateHiddenField();
            setSelectedColumn(params.newItem, true);
            skyward.reporting.updateVariableUsageLocations();
            return newPosition;
        };

        // accepts params = { newItem: jQuery object, reportLine: jQuery object, isDynamicColumn: bool }
        const insertDataColumn = function (params)
        {
            params.newItem = createNewColumn({
                type: getNewColumnType(params.reportLine, params.newItem, params.isDynamicColumn),
                relatedItem: params.newItem
            });

            // inserts the data column and returns the left position of the new element
            const dataColumnPosition = insertColumnHelperFunction(params);

            const headerLine = getCorrespondingHeaderLine(params.section, params.reportLine);

            if (headerLine.length > 0)
            {
                // make a copy of the params
                const headerParams = {
                    section: params.section,
                    reportLine: headerLine,
                    newItem: createNewColumn({
                        type: getNewColumnType(headerLine, params.newItem, params.isDynamicColumn),
                        relatedItem: params.newItem,
                        usesSingleLineIndex: isParentDisplayOnSingleLine(params.section)
                    }),
                    position: {
                        left: dataColumnPosition.left,
                        top: dataColumnPosition.top
                    },
                    autoCreatedColumn: true
                };

                // inserts the new header column
                insertColumnHelperFunction(headerParams);
            }

            return dataColumnPosition;
        };


        //END SELECTOR HELPERS

        var showXMLColumnProperties = function ()
        {
            exportProperties.xml.wrapper.show();
            exportProperties.xml.section.wrapper.hide();
            exportProperties.xml.row.wrapper.hide();
            exportProperties.xml.column.wrapper.show();
        };

        var showXMLRowProperties = function ()
        {
            exportProperties.xml.wrapper.show();
            exportProperties.xml.section.wrapper.hide();
            exportProperties.xml.row.wrapper.show();
            exportProperties.xml.column.wrapper.hide();
        };

        var showXMLSectionProperties = function ()
        {
            exportProperties.xml.wrapper.show();
            exportProperties.xml.section.wrapper.show();
            exportProperties.xml.row.wrapper.hide();
            exportProperties.xml.column.wrapper.hide();
        };

        skyward.reporting.getFieldsUsedInSection = function (section, includeFilters, convertImages)
        {
            const sectionData = section.data();

            let fieldsInUse = []

            const getFieldsFromHiddenCondition = function (isHiddenCondition)
            {
                const fields = [];
                const leftOperand = isHiddenCondition.LeftOperand;
                const rightOperand = isHiddenCondition.RightOperand;

                if (leftOperand?.FieldPath)
                {
                    const fieldPath = `${sectionData.baseObject}.${leftOperand.FieldPath}`;
                    const absoluteFieldPath = sectionData.entireRelationshipPath ? `${sectionData.entireRelationshipPath}.${leftOperand.FieldPath}` : leftOperand.FieldPath;
                    const field = skyward.reporting.buildUsedInReportField(fieldPath, absoluteFieldPath, leftOperand.DisplayName, leftOperand.FieldDisplayText, leftOperand.DataType, leftOperand.Parameters, leftOperand.FieldPathIsCalculated, leftOperand.FieldPathIsOperation, false, convertImages);
                    fields.push(field);
                }

                if (rightOperand?.FieldPath)
                {
                    const fieldPath = `${sectionData.baseObject}.${rightOperand.FieldPath}`;
                    const absoluteFieldPath = sectionData.entireRelationshipPath ? `${sectionData.entireRelationshipPath}.${rightOperand.FieldPath}` : rightOperand.FieldPath;
                    const field = skyward.reporting.buildUsedInReportField(fieldPath, absoluteFieldPath, rightOperand.DisplayName, rightOperand.FieldDisplayText, rightOperand.DataType, rightOperand.Parameters, rightOperand.FieldPathIsCalculated, rightOperand.FieldPathIsOperation, false, convertImages);
                    fields.push(field);
                }

                return fields;
            }

            const getFieldsFromFilter = function (filterSchemaFields, parameters)
            {
                const fields = [];

                if (filterSchemaFields)
                {
                    filterSchemaFields.forEach(function (schemaField)
                    {
                        const field = skyward.reporting.buildUsedInReportField(schemaField.name, schemaField.fieldPath, schemaField.displayName, schemaField.displayPath, schemaField.type, parameters, false, schemaField.isOperation, false, convertImages);
                        fields.push(field);
                    });
                }

                return fields;
            };

            const columns = getColumnsForLinesInSection(section);
            columns.forEach(function (column)
            {
                const isCalculatedField = column.operationId ?? false;
                const isHeader = column.fieldColumnType === COLUMN_TYPES.HEADER_COLUMN || column.fieldColumnType === COLUMN_TYPES.GROUP_COLUMN_HEADER;
                const isPageSection = column.fieldColumnType === COLUMN_TYPES.PAGE_SECTION_COLUMN;
                const isVariable = column.fieldColumnType === COLUMN_TYPES.VARIABLE_COLUMN;
                const isAggregate = column.fieldColumnType === COLUMN_TYPES.AGGREGATE_COLUMN;

                if (column.fieldName && !isCalculatedField && !isPageSection && !isVariable && !isHeader && !isAggregate)
                {
                    const isColumnGroup = column.fieldColumnType === (COLUMN_TYPES.GROUP_COLUMN || COLUMN_TYPES.GROUP_COLUMN_AGGREGATE);
                    const fieldPath = column.fieldPath ?? column.fieldName;
                    const absoluteFieldPath = column.absoluteFieldPath;
                    const fieldWidth = column.fieldWidth;
                    const fieldHeight = column.fieldHeight;
                    const field = skyward.reporting.buildUsedInReportField(fieldPath, absoluteFieldPath, column.designerText, column.displayPath, column.fieldType, column.parameters, column.isCalculated, column.isOperation, isColumnGroup, convertImages, fieldWidth, fieldHeight);
                    fieldsInUse.push(field);
                }

                if (column.isHiddenCondition)
                {
                    fieldsInUse.push(...getFieldsFromHiddenCondition(column.isHiddenCondition));
                }
            });

            const sectionLines = getSectionLines(section).toArray();
            sectionLines.forEach(function (line)
            {
                const lineData = $(line).data();
                if (lineData.isHiddenCondition)
                {
                    fieldsInUse.push(...getFieldsFromHiddenCondition(lineData.isHiddenCondition));
                }
            });

            const sorts = getSectionSorts(section);
            sorts.forEach(function (sort)
            {
                if (!sort.CalculatedField && sort.FieldName)
                {
                    const absoluteFieldPath = sectionData.entireRelationshipPath ? `${sectionData.entireRelationshipPath}.${sort.RelativeDataPath}` : sort.RelativeDataPath;
                    const field = skyward.reporting.buildUsedInReportField(sort.FieldName, absoluteFieldPath, sort.DisplayName, sort.DisplayPath, sort.DataType, sort.Parameters, false, sort.IsOperation, false, convertImages);
                    fieldsInUse.push(field);
                }
            });

            if (includeFilters)
            {
                const filterData = getSectionFilterObjectAndParameters(section);
                if (filterData && filterData.filterObject)
                {
                    fieldsInUse.push(...getFieldsFromFilter(filterData.filterSchemaFields, filterData.parameters ?? []));
                }
            }

            return fieldsInUse;
        };

        /**
         * Builds an object to represent a field used in the report
         * @param {string} fieldPath - The path to the field starting on the section object it is in
         * @param {string} absoluteFieldPath - The path to the field starting on the root object it is in
         * @param {string} displayName - The display name of the field
         * @param {string} displayPath - The display name of the field
         * @param {string} dataType - The type of the field
         * @param {Array} parameters - Any parameters the field has
         * @param {boolean} isCalculated - If the field is calculated in C#
         * @param {boolean} isOperation - If the field is an operation
         * @param {boolean} isColumnGroup - If the field is a column group
         * @param {boolean} convertImages - If image fields should be treated as numbers
         * @param {number} fieldWidth - The width of the field's column
         * @param {number} fieldHeight - The height of the field's column
         * @returns {ReportFieldProps} Returns field object with data related to it
         */
        skyward.reporting.buildUsedInReportField = function (fieldPath, absoluteFieldPath, displayName, displayPath, dataType, parameters, isCalculated, isOperation, isColumnGroup, convertImages, fieldWidth, fieldHeight)
        {
            // Convert Dynamic Image Columns to be of type long.
            // Do this right away so we get the correct svg class.
            if (convertImages && dataType.toLowerCase() === "image")
            {
                dataType = DATA_TYPES.NUMBER_LONG;
            }

            if (isColumnGroup)
            {
                dataType = DATA_TYPES.GROUP_COLUMN;
                absoluteFieldPath = fieldPath; //columns groups have a undefined absolute field path
            }

            const svgClass = skyward.reporting.getSvgNameByDataType(dataType);
            const displayPathText = displayPath ?? fieldPath.replaceAll(".", " > ");
            const firstDotIndex = fieldPath.indexOf(".");
            const lastDotIndex = fieldPath.lastIndexOf(".");
            const hasDot = firstDotIndex >= 0;
            const fieldName = hasDot ? fieldPath.substring(lastDotIndex + 1) : fieldPath;

            const absoluteFieldPathLastDotIndex = absoluteFieldPath ? absoluteFieldPath.lastIndexOf(".") : -1;
            const realtionshipPath = absoluteFieldPathLastDotIndex > 0 ? absoluteFieldPath.substring(0, absoluteFieldPathLastDotIndex) : "";

            const field =
            {
                absoluteFieldPath: absoluteFieldPath,
                relationshipPath: realtionshipPath,
                displayName: displayName,
                displayPathText: displayPathText,
                fieldName: fieldName,
                fieldPath: fieldPath,
                fieldType: dataType,
                isCalculated: isCalculated,
                isColumnGroup: isColumnGroup,
                isOperation: isOperation,
                isTreeBrowseRow: true,
                parameters: parameters ?? [],
                svgClass: svgClass,
                fieldWidth: fieldWidth,
                fieldHeight: fieldHeight
            };

            return field;
        };

        //SET CURRENTLY SELECTED
        var setSelectedColumn = function (column, clearSelectedColumns)
        {
            exportProperties.xml.wrapper.hide();

            if (column)
            {
                column.focus(); //lets the keydown event work correctly

                if (clearSelectedColumns)
                {
                    currentSelectedColumns.clear();
                }

                currentSelectedColumns.toggleColumn(column);

                $(document).find(".row-selected").removeClass("row-selected");
                currentRow = null;

                setColumnProperties();
            }

            if (!currentSelectedColumns.areMultipleColumnsSelected())
            {
                showXMLColumnProperties();
                exportProperties.fixedWidth.wrapper.show();
                exportProperties.json.wrapper.show();
            }
        };

        const buildAggregateFieldTreeBrowseSection = function (key, title, ul, columns)
        {
            const treeBrowseSection =
            {
                key: key,
                title: title,
                component: "aggregateField",
                container: "#" + ul.addIds().attr("id"),
                rows: columns ?? []
            };

            return treeBrowseSection;
        };

        const getColumnsForDataLinesInSection = function (section)
        {
            const foundColumns = [];
            const fieldIdentifiers = [];

            getSectionDataLines(section).find('.jsColumn').each(function (columnIndex, column)
            {
                const $column = $(column);
                const columnData = $column.data();
                const isDataColumn = columnData.fieldColumnType === COLUMN_TYPES.DATA_COLUMN;
                const isDynamicImageColumn = columnData.fieldColumnType == COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN;

                const fieldIdentifier = columnData.operationId || columnData.absoluteFieldPath;
                if ((isDataColumn || isDynamicImageColumn) && fieldIdentifiers.indexOf(fieldIdentifier) < 0)
                {
                    fieldIdentifiers.push(fieldIdentifier);
                    foundColumns.push(columnData);
                }
            });

            return foundColumns;
        };

        const getColumnsForLinesInSection = function (section)
        {
            const foundColumns = [];

            getSectionLines(section).find('.jsColumn').each(function (columnIndex, column)
            {
                const $column = $(column);
                const columnData = $column.data();

                foundColumns.push(columnData);
            });

            return foundColumns;
        };

        const getColumnsForAggregateLine = function (aggregateLine)
        {
            const foundColumns = [];
            const supportedColumnTypes = [COLUMN_TYPES.AGGREGATE_COLUMN, COLUMN_TYPES.CALCULATED_COLUMN, COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN]

            for (let column of getColumnsInLine(aggregateLine).map((i, c) => $(c)))
            {
                const columnData = column.data();

                if (!columnData.isFutureValue && supportedColumnTypes.includes(columnData.fieldColumnType))
                {
                    foundColumns.push(columnData);
                }
            }

            return foundColumns;
        };

        const getFutureValueSourceColumnInfo = function (aggregateLine)
        {
            const foundColumns = [];
            const supportedColumnTypes = [COLUMN_TYPES.AGGREGATE_COLUMN, COLUMN_TYPES.CALCULATED_COLUMN]

            for (let column of getColumnsInLine(aggregateLine).map((i, c) => $(c)))
            {
                const columnData = column.data();

                if (!columnData.isFutureValue && supportedColumnTypes.includes(columnData.fieldColumnType))
                {
                    // the fieldName or calculated field don't mean anything to us here, so let's not confuse things by having them set
                    const futureColumnData =
                    {
                        columnId: columnData.columnId,
                        designerText: getColumnLabelWithPreText(column),
                        fieldType: columnData.fieldType,
                        fieldWidth: columnData.fieldWidth,
                        fieldHeight: columnData.fieldHeight,
                        isFutureColumn: true
                    };
                    foundColumns.push(futureColumnData);
                }
            }

            return foundColumns;
        };

        const getPossibleSourceAggregateLinesForSection = function (selectedLine, selectedSection, workingSection)
        {
            const selectedLineData = selectedLine.data();

            if (selectedSection.is(workingSection))
            {
                if (selectedLineData.lineType == LINE_TYPES.SORT_AGGREGATE_LINE)
                {
                    const selectedLineSortOrder = getSortDataByReportSortID(selectedSection, selectedLineData.relatedReportSortId).SortOrder;

                    return getSectionSortAggregateLines(workingSection).filter((index, line) =>
                    {
                        const aggregateLineSortOrder = getSortDataByReportSortID(workingSection, $(line).data("relatedReportSortId")).SortOrder;
                        return aggregateLineSortOrder > selectedLineSortOrder;
                    });
                }
                else
                {
                    return getSectionSortAggregateLines(workingSection);
                }
            }
            else
            {
                return getSectionAllAggregateLines(workingSection);
            }
        };

        const replaceAggregateFieldsTreeBrowseSection = function (allColumnInfo)
        {
            const ul = designer.find(".reportDesignerAggregateFieldList");
            const treeBrowseData = skyward.treebrowse.getTreeBrowseDataByName("reportObjectBrowser");
            treeBrowseData.additionalSections = treeBrowseData.additionalSections.filter(function (section)
            {
                return !section.key?.startsWith("aggregate_");
            });

            let treeBrowseSectionIndex = 0;
            for (let sectionInfo of allColumnInfo)
            {
                for (let lineInfo of sectionInfo.lines)
                {
                    let treeBrowseSectionName = sectionInfo.data.displayName;

                    if (lineInfo.label)
                    {
                        treeBrowseSectionName = `${treeBrowseSectionName} (${lineInfo.label})`;
                    }

                    if (lineInfo.columns.length > 0)
                    {
                        treeBrowseSectionIndex++;
                        const treeBrowseSection = buildAggregateFieldTreeBrowseSection(`aggregate_${treeBrowseSectionIndex}`, treeBrowseSectionName, ul, lineInfo.columns);
                        treeBrowseData.additionalSections.push(treeBrowseSection);
                    }
                }
            }
        }

        const getPossibleFutureValueSourceLinesForSection = function (selectedLineData, selectedSection)
        {
            const selectedLineSortOrder = getSortDataByReportSortID(selectedSection, selectedLineData.relatedReportSortId).SortOrder;

            return getSectionAllAggregateLines(selectedSection).filter((index, line) =>
            {
                let lineData = $(line).data();

                if (lineData.lineType === LINE_TYPES.AGGREGATE_LINE)
                {
                    return selectedLineData.lineType === LINE_TYPES.SORT_AGGREGATE_LINE;
                }

                const aggregateLineSortOrder = getSortDataByReportSortID(selectedSection, lineData.relatedReportSortId).SortOrder;

                if (selectedLineData.lineType === LINE_TYPES.SORT_HEADER_LINE)
                {
                    return aggregateLineSortOrder === selectedLineSortOrder;
                }

                return aggregateLineSortOrder < selectedLineSortOrder;
            });
        };

        const getFutureValueColumnDataForSortHeader = function (selectedLine)
        {
            const selectedLineData = selectedLine.data();
            const currentSection = getSectionByLine(selectedLine);
            const sectionData = currentSection.data();

            let sectionInfo = { data: sectionData, lines: [] };
            let allColumnInfo = [sectionInfo];

            for (let aggregateLine of getPossibleFutureValueSourceLinesForSection(selectedLineData, currentSection).map((i, l) => $(l)))
            {
                const aggregateLineData = aggregateLine.data();
                sectionInfo.lines.push({ label: `Future: ${aggregateLineData.reportLabelText}`, columns: getFutureValueSourceColumnInfo(aggregateLine) });
            }

            return allColumnInfo;
        };

        const getAggregateAndFutureColumnDataForAggregateLine = function (selectedLine)
        {
            const selectedLineData = selectedLine.data();
            const currentSection = getSectionByLine(selectedLine);
            let allColumnInfo = [];

            const sections = currentSection.hasClass('jsHeaderFooterSection')
                ? entireCanvas.find(".jsSection:not(.jsHeaderFooterSection)")
                : getCurrentAndDetailSections(currentSection)

            for (let section of sections.map((i, s) => $(s)))
            {
                const sectionData = section.data();

                let sectionInfo = { data: sectionData, lines: [] };
                sectionInfo.lines.push({ columns: getColumnsForDataLinesInSection(section) });

                for (let aggregateLine of getPossibleSourceAggregateLinesForSection(selectedLine, currentSection, section).map((i, l) => $(l)))
                {
                    const aggregateLineData = aggregateLine.data();
                    sectionInfo.lines.push({ label: aggregateLineData.reportLabelText, columns: getColumnsForAggregateLine(aggregateLine) });
                }

                if (selectedLineData.lineType === LINE_TYPES.SORT_AGGREGATE_LINE && section.is(currentSection))
                {
                    for (let aggregateLine of getPossibleFutureValueSourceLinesForSection(selectedLineData, currentSection).map((i, l) => $(l)))
                    {
                        const aggregateLineData = aggregateLine.data();
                        sectionInfo.lines.push({ label: `Future: ${aggregateLineData.reportLabelText}`, columns: getFutureValueSourceColumnInfo(aggregateLine) });
                    }
                }

                allColumnInfo.push(sectionInfo);
            }

            return allColumnInfo;
        };

        var getCurrentAndDetailSectionsAggregateColumns = function ()
        {
            const aggregateColumns = [];

            getSectionSelectedRow(getCurrentSection()).find(".jsReportAggregate").each(function ()
            {
                const aggregateColumnData = $(this).data();
                aggregateColumns.push(
                    {
                        designerText: aggregateColumnData.aggregateType + ": " + aggregateColumnData.designerText,
                        fieldName: aggregateColumnData.bindingString,
                        fieldType: aggregateColumnData.columnFieldType
                    });
            });

            return aggregateColumns;
        };

        var setSelectedRowByRow = function (row, clearSelectedColumns = true)
        {
            setSelectedRow(row);
            if (clearSelectedColumns)
            {
                currentSelectedColumns.clear();
            }
            setRowProperties(row);
        };

        var setSelectedRowByColumn = function (column)
        {
            const row = column.parent();
            setSelectedRow(row);
        };

        var setSelectedRow = function (row)
        {
            if (!row.hasClass("sectionToolbar"))
            {
                showXMLRowProperties();
                exportProperties.fixedWidth.wrapper.hide();
                exportProperties.json.wrapper.hide();
            }

            if (row.is('.sortHeaderLine'))
            {
                designer.find(".reportDesignerAggregateFieldsMenu").show();
                replaceAggregateFieldsTreeBrowseSection(getFutureValueColumnDataForSortHeader(row));
            }
            else if (row.is('.jsSortAggregateLine, .jsSectionAggregateLine, .jsPageFooterLine, .jsReportFooterLine'))
            {
                designer.find(".reportDesignerAggregateFieldsMenu").show();
                replaceAggregateFieldsTreeBrowseSection(getAggregateAndFutureColumnDataForAggregateLine(row));
            }
            else
            {
                designer.find(".reportDesignerAggregateFieldsMenu").hide();
            }

            entireCanvas.find('.row-selected').not("li").each(function ()
            {
                const oldRow = $(this);
                oldRow.add(oldRow.data("relatedLabel")).removeClass('row-selected');
            });
            const section = row.closest(".jsSection");

            const showRemoveReportLineButton = row.hasClass('sectionToolbar') ||
                (row.hasClass('jsDataLine') && getSectionDataLines(section).length < 2) ||
                (row.hasClass('jsHeaderLine') && getSectionHeaderLines(section).length < 2);
            section.find(".remove_report_line").toggleClass("ui-disabled", showRemoveReportLineButton);

            toggleAggregateMathButtonState(row);
            toggleFormTextColumnButtonState(row);

            row.add(row.data("relatedLabel")).addClass('row-selected').focus();
            currentRow = row;
        };

        var setLabelTextBackground = function (element, color)
        {
            let labels = element.find('.labelMatchParent');
            if (labels && labels.length > 0)
            {
                labels.each(function ()
                {
                    $(this).css('background', `linear-gradient(transparent 10%, ${color} 15%, ${color} 85%, transparent 90%)`);
                });
            }
        };

        var removeLabelTextBackground = function (element)
        {
            let labels = element.find('.labelMatchParent');
            if (labels && labels.length > 0)
            {
                labels.each(function ()
                {
                    $(this)[0].style.removeProperty('background');
                });
            }
        };

        var setActiveSection = function ($section, clearSelectedColumns = true)
        {
            if ($section.length == 0 || $section.hasClass('sectionSelected'))
            {
                return;
            }

            // Reselect active section
            designer.find('.sectionSelected').removeClass('sectionSelected');
            $section.addClass('sectionSelected');

            // Reselect active row
            designer.find('.row-selected').removeClass('row-selected');
            Array.from($section.children()).forEach(child =>
            {
                if (child.classList.contains('sectionToolbar'))
                {
                    setSelectedRowByRow($(child), clearSelectedColumns)
                }
            })

            if ($section.hasClass('jsHeaderFooterSection'))
            {
                exportProperties.xml.wrapper.hide();
                exportProperties.json.wrapper.hide();
            }
            else
            {
                showXMLSectionProperties();
                exportProperties.json.wrapper.show();
            }
            exportProperties.fixedWidth.wrapper.hide();

            designer.find('.parentSectionComboBox').remove();

            const parentDisplayOnSingleLine = isParentDisplayOnSingleLine($section);

            const control = "reportObjectBrowser";
            const treeBrowseContainer = skyward.treebrowse.getTreeBrowseContainer(control);
            const treeBrowseData = skyward.treebrowse.getTreeBrowseData(treeBrowseContainer);
            treeBrowseData.renderColumnGroups = !parentDisplayOnSingleLine;
            treeBrowseData.renderRowForImageReferences = !parentDisplayOnSingleLine;

            if ($section.hasClass('jsHeaderFooterSection'))
            {
                designer.find(".hideForHeaderFooterSections").hide();
                const treeBrowseDataPromise = skyward.treebrowse.setBrowseTarget('', '', '', control, "Reporting/Report/ExpandTreeBrowseDesignerSidebar", "Header/Footer", true);

                treeBrowseDataPromise.then(function (data)
                {
                    hidePageNumberFields(false);
                    initDesignerUI($section);
                });
            }
            else
            {
                designer.find(".hideForHeaderFooterSections").show();
                const sectionData = getSectionData($section);
                const absoluteTreeBrowseObjectPath = sectionData.entireRelationshipPath ? sectionData.entireRelationshipPath : "";

                const treeBrowseDataPromise = skyward.treebrowse.setBrowseTarget(sectionData.baseModule, sectionData.baseObject,
                    sectionData.baseObject, control, "Reporting/Report/ExpandTreeBrowseDesignerSidebar", sectionData.sectionObjectName, null,
                    sectionData.rootModule, sectionData.rootObject, absoluteTreeBrowseObjectPath, true);

                treeBrowseDataPromise.then(function (data)
                {
                    hidePageNumberFields(true);
                    initDesignerUI($section);
                });
            }
        };

        var toggleFormTextColumnButtonState = function (line)
        {
            var lineType = line.data("lineType");
            var disabled = lineType === LINE_TYPES.HEADER_LINE || lineType === LINE_TYPES.FOOTER_LINE;

            getCurrentSectionToolbar().find(".add_formtext_field").toggleClass("ui-disabled", disabled);
        };

        var toggleAggregateMathButtonState = function (row)
        {
            var isAggregateLine = (row.hasClass("jsSortAggregateLine") || row.hasClass("jsSectionAggregateLine"));
            var showAggregateSimpleMathButton = isAggregateLine && getAvailableColumnInfoForAggregateCalculations(row).length > 0;

            var aggregateMathButton = getCurrentSectionToolbar().find('.simple_aggregate_math');
            entireCanvas.find('.simple_aggregate_math').toggleClass("ui-disabled", true);
            aggregateMathButton.toggleClass("ui-disabled", !showAggregateSimpleMathButton);
        };
        //END SET CURRENTLY SELECTED

        //BEGIN FILTERS

        function scrapeValueBoxForPromptData(valueBox)
        {
            let result = {};

            if (!valueBox || !valueBox.length)
            {
                return null;
            }

            // FieldPath, InputType, IsValue, Label
            const fieldSelector = valueBox.parentsUntil("div.condition", ".fieldWrapper").children(".filterBuilderFieldSelect");
            if (fieldSelector && fieldSelector.length > 0)
            {
                const fieldSelectorData = fieldSelector.data();

                if (fieldSelectorData.calculatedFieldName)
                {
                    const calculatedField = skyward.reporting.calculatedFields.Get(fieldSelectorData.calculatedFieldName);
                    if (calculatedField)
                    {
                        result.Label = calculatedField.fieldName;
                        result.InputType = calculatedField.dataType;
                    }
                }
                else if (fieldSelectorData.field)
                {
                    // existing field
                    result.FieldPath = fieldSelectorData.rootModule + "." + fieldSelectorData.rootObject + "." + fieldSelectorData.absoluteFieldPath;

                    const conditionTypeSelector = valueBox.parentsUntil("div.condition", ".fieldWrapper").children(".conditionTypesComboBox");
                    if (conditionTypeSelector.val() === "List" || conditionTypeSelector.val() === "NotList")
                    {
                        result.Type = enumMaps.PromptTypes["MultipleSelect"];
                        result.IsValue = false;
                    }
                }
                else // New standard filter
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Reporting/Report/GetNewStandardFilterPrompt",
                        type: "POST",
                        dataType: "JSON",
                        data: {
                            standardFilterId: fieldSelectorData.standardFilterId
                        }
                    });
                }
            }
            else if (valueBox.parent().hasClass("rowProperties"))
            {
                const sectionName = currentRow.closest(".jsSection").find(".sectionToolbar").data("reportLabelText");
                if (valueBox.hasClass("editorPrintAtBottomOfPage"))
                {
                    result.Label = "Print " + sectionName + " " + currentRow.data("reportLabelText") + " at Bottom of Page";
                }
                else if (valueBox.hasClass("editorRepeatLineAfterStart"))
                {
                    result.Label = "Repeat " + sectionName + " " + currentRow.data("reportLabelText") + " after start";
                }
                else if (valueBox.hasClass("editorPrintReportFooterOnNewPage"))
                {
                    result.Label = "Print Report Footer on New Page";
                }
                else
                {
                    result.Label = "Hide " + sectionName + " " + currentRow.data("reportLabelText");
                }

                result.InputType = DATA_TYPES.BOOLEAN;
                result.PresenceType = "Required";
            }
            else if (valueBox.hasClass("pageBreak"))
            {
                let fullSortName = valueBox.closest(".sortItem").find(".fieldNameColumn .friendlyName:first").text();
                let separatorIndex = fullSortName.lastIndexOf(">");
                let sortFieldName = separatorIndex > -1 ? fullSortName.substr(separatorIndex + 2) : fullSortName;
                result.Label = "Page Break on " + sortFieldName + " Change";
                result.InputType = DATA_TYPES.BOOLEAN;
                result.PresenceType = "Required";
            }
            else if (valueBox.hasClass("userConditionValueSelectorDisplay"))
            {
                // not supported by multiple columns
                const promptContainer = valueBox.closest(".promptDetail");
                if (promptContainer && promptContainer.length)
                {
                    result = isHiddenSelector.getPromptDataFromPrompt(valueBox, promptContainer);
                }
                else
                {
                    result = isHiddenSelector.getPromptData(valueBox, currentSelectedColumns.getFirstSelectedColumn(), currentRow, getCurrentSection());
                }
            }

            return result;
        }

        function setNewPromptAsValue(setFilterValue, data, valueBox)
        {
            if (!data || !data.promptModel || !data.promptModel.toJsonObject)
            {
                return;
            }

            const promptData = data.promptModel.toJsonObject();
            const filterValueData = {};
            for (const key in promptData)
            {
                filterValueData[(key.substring(0, 1).toLowerCase() + key.substring(1))] = promptData[key];
            }

            filterValueData.svgClass = promptData.InputType === "standardFilter" ? "DialogPrompt" : skyward.reporting.getSvgNameByDataType(promptData.InputType);
            const valueBoxData = valueBox.data();
            if (valueBoxData.enumType)
            {
                filterValueData.enumType = valueBoxData.enumType;
            }

            setFilterValue(filterValueData);
        }

        function getEditorFieldDataType(input)
        {
            var data = input.data();
            return data.fieldType || data.inputType;
        }

        var valueSelectorClickEvents =
        {
            ".add_report_prompt": function (setFilterValue, valueBox, treatPromptAsInUse)
            {
                var treatAsInUseRequired = valueBox.hasClass("pageBreak") || valueBox.parent().hasClass("rowProperties");
                $.when(scrapeValueBoxForPromptData(valueBox)).then(function (newPrompt)
                {
                    return skyward.reporting.prompts.getPromptDetailsView(newPrompt, { treatPromptAsInUse: treatPromptAsInUse, treatPromptAsInUseRequired: treatAsInUseRequired });
                })
                    .then(function (data) { setNewPromptAsValue(setFilterValue, data, valueBox); });
            },
            ".selectFieldButton": function (setFilterValue, valueBox)
            {
                if (valueBox.hasClass("userConditionValueSelectorDisplay"))
                {
                    var currentSectionData = getSectionData(getCurrentSection());
                    var fieldDataType = !valueBox.hasClass("leftOperand") ? getEditorFieldDataType(isHiddenSelector.elements.left) : undefined;

                    var data =
                    {
                        rootModule: currentSectionData.baseModule,
                        rootObject: currentSectionData.baseObject,
                        seekField: valueBox.data("fieldName"),
                        relationshipPath: "",
                        fieldDataType: fieldDataType,
                        renderOperationFields: true,
                        includeCalculatedFields: true,
                        renderColumnGroups: false,
                        renderProxies: true,
                        renderOneToMany: false,
                        allowOneToManyBrowse: false,
                    };

                    const calculatedFieldData =
                    {
                        calculatedFieldRootModule: currentSectionData.rootModule,
                        calculatedFieldRootObject: currentSectionData.rootObject,
                        calculatedFieldRelationshipPath: currentSectionData.entireRelationshipPath,
                    };

                    skyward.window.closePopup();
                    skyward.reporting.treebrowse.getTreeBrowse(data, calculatedFieldData, valueBox, "Reporting/Report/ReportDesignerBuildTreeBrowse");
                }
                else
                {
                    skyward.filterbuilder.getTreeBrowseForFieldToField(valueBox);
                }
            },
            '.currentColumnValueButton': function (setFilterValue)
            {
                // not supported by multiple selected columns
                setFilterValue(currentSelectedColumns.getFirstSelectedColumn().data());
            }
        };

        skyward.reporting.getStandardFilterValueSelector = function (button, standardFilterId)
        {
            var requestingButton = $(button);
            var valueBox = requestingButton.closest(".conditionValuesContainer").find(".js-conditionValue--active");

            $.ajax({
                url: skyward.global.virtualDir + "Reporting/Report/GetStandardFilterValueSelector",
                type: "POST",
                dataType: "JSON",
                data: {
                    standardFilterId: standardFilterId,
                    currentPrompts: skyward.reporting.prompts.promptCollection.toJsonString()
                },
                success: function (data)
                {
                    skyward.filterbuilder.openValueSelector(data.html, button, valueBox, false, true, valueSelectorClickEvents);
                }
            });
        };

        skyward.reporting.getBooleanFilterValueSelector = function (button, allowFieldSelection, allowCurrentColumnValue)
        {
            var requestingButton = $(button);
            var container = requestingButton.closest(".conditionValuesContainer");
            if (!skyward.buttonManager.isElementDisabled(container))
            {
                var valueBox = requestingButton.closest(".conditionValuesContainer").find(".conditionValue:visible");

                $.ajax({
                    url: skyward.global.virtualDir + "Reporting/Report/GetBooleanValueSelector",
                    type: "POST",
                    dataType: "JSON",
                    data: {
                        currentPromptsJson: skyward.reporting.prompts.promptCollection.toJsonString(),
                        allowFieldSelection: allowFieldSelection,
                        allowCurrentColumnValue: allowCurrentColumnValue
                    },
                    success: function (data)
                    {
                        skyward.filterbuilder.openValueSelector(data.html, button, valueBox, false, true, valueSelectorClickEvents);
                    }
                });
            }
        };

        skyward.reporting.getSortBreakValueSelector = function (button)
        {
            var requestingButton = $(button);
            var container = requestingButton.closest(".conditionValuesContainer");
            if (!skyward.buttonManager.isElementDisabled(container))
            {
                var valueBox = requestingButton.closest(".conditionValuesContainer").find(".conditionValue:visible");

                $.ajax({
                    url: skyward.global.virtualDir + "Reporting/Report/GetSortBreakValueSelector",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        currentPromptsJson: skyward.reporting.prompts.promptCollection.toJsonString(),
                        allowBurst: requestingButton.parents(".sortItem").first().find(".fieldNameColumn").data("allowBurst"),
                    },
                    success: function (data)
                    {
                        skyward.filterbuilder.openValueSelector(data.html, button, valueBox, false, true, valueSelectorClickEvents);
                    }
                });
            }
        };

        skyward.reporting.getFilterValueSelector = function (button, searchField, conditionType, dataModule, dataObject)
        {
            const filterValueSelectorData = skyward.filterbuilder.getFilterValueSelectorData(button, searchField, conditionType, dataModule, dataObject);

            let postData =
            {
                calculatedFieldJson: JSON.stringify(CalculatedFields_Model.Get(searchField)),
                currentPromptsJson: skyward.reporting.prompts.promptCollection.toJsonString()
            };

            $.extend(postData, filterValueSelectorData.postData);

            $.ajax({
                url: skyward.global.virtualDir + "Reporting/Report/GetValueSelector",
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    skyward.filterbuilder.openValueSelector(data.html, button, filterValueSelectorData.valueBox, data.isListOfEnums, true, valueSelectorClickEvents);
                }
            }); // AJAX call
        };

        function disable(jQElements, disabled)
        {
            skyward.controls.toggle(jQElements, !disabled);
        }

        //END FILTERS

        skyward.reporting.saveAndRunReport = function (useLastValues)
        {
            var editReportDefinitionDesigner = $("#editReportDefinitionDesigner");
            editReportDefinitionDesigner.on("DOVSaveComplete.SaveAndRun DOVSaveValidationError.SaveAndRun DOVSaveCanceled.SaveAndRun", function (event)
            {
                if (event.type == "DOVSaveComplete")
                {
                    if (useLastValues)
                    {
                        $('.moreMenuArea .jsRunReportWithLastValues').click();
                    }
                    else
                    {
                        $('.moreMenuArea .jsRunReport').click();
                    }
                }
                editReportDefinitionDesigner.off("DOVSaveComplete.SaveAndRun DOVSaveValidationError.SaveAndRun DOVSaveCanceled.SaveAndRun");
            });

            $("#editReportDefinitionDesigner_save").click();
        };

        const removeLine = function (lineToRemove, updateUI = true)
        {
            if (lineToRemove && !lineToRemove.data("isRemoved"))
            {
                const section = lineToRemove.closest('.jsSection');
                const sectionData = getSectionData(section);
                const numSectionHeaderLines = getSectionHeaderLines(section).length;

                if (lineToRemove.hasClass('sectionToolbar') ||
                    (lineToRemove.hasClass('jsHeaderLine') && numSectionHeaderLines == 1) ||
                    (lineToRemove.hasClass('jsDataLine') && getSectionDataLines(section).length == 1))
                {
                    return;
                }

                for (const column of lineToRemove.find(".reportColumn"))
                {
                    removeColumn($(column), false);
                }

                // isRemoved is for tracking cascading deletes so we do not try to delete something twice
                // The attribute value needs to be set because .remove() deletes any data that jQuery is only holding in memory
                lineToRemove.data("isRemoved", true);
                lineToRemove.attr("data-is-removed", true);
                lineToRemove.remove();

                if (lineToRemove.data("lineType") == LINE_TYPES.DATA_LINE && numSectionHeaderLines > 1)
                {
                    const relatedHeaderLine = getCorrespondingHeaderLine(section, lineToRemove);
                    if (relatedHeaderLine.length > 0)
                    {
                        removeLine(relatedHeaderLine, false);
                    }
                }

                setSelectedRowByRow(getSectionDataLines(section).first());
                lineToRemove.removeData("printAtBottomOfPagePromptUniqueId");
                lineToRemove.removeData("isHiddenPromptUniqueId");

                updateHiddenField();
                labelBuilder.buildLabelColumns(true);

                if (updateUI)
                {
                    initFieldsUsedInReport(sectionData);
                    skyward.reporting.updateVariableUsageLocations();
                }
            }
        }

        const removeColumnByColumnID = function (columnID)
        {
            const column = getColumnByID(columnID);
            removeColumn(column);
        };

        const withSingleLineIndexBinding = function (text)
        {
            return `${text} ${SINGLE_LINE_HEADER_INDEX_BINDING}`;
        }

        skyward.reporting.propertiesInsertHeaderIndex = function ()
        {
            skyward.global.text.insertTextToken(editorColumnText, SINGLE_LINE_HEADER_INDEX_BINDING, false);
        };

        skyward.reporting.propertiesResetHeaderIndex = function ()
        {
            skyward.controls.setValue(editorColumnText, `${skyward.controls.getValue(editorColumnText).replace(/ \{Index\} /g, " ").replace(/\{Index\}/g, "").trim()} ${SINGLE_LINE_HEADER_INDEX_BINDING}`);
        };

        skyward.reporting.propertiesRemoveColumn = function ()
        {
            removeColumns(currentSelectedColumns.getCurrentSelectedColumns(), true, true);
        };

        const removeColumns = function (columns, updateUI = true, requireConfirmDelete = false)
        {
            const columnsToRemove = [...columns];
            for (const column of columnsToRemove)
            {
                removeColumn($(column), false, requireConfirmDelete);
            }
            if (updateUI)
            {
                initFieldsUsedInReport();
                skyward.reporting.updateVariableUsageLocations();
            }
        };

        const removeColumn = function (columnToRemove, updateUI = true, requireConfirmDelete = false)
        {
            if (columnToRemove && !columnToRemove.data("isRemoved"))
            {
                const columnData = columnToRemove.data();

                if (requireConfirmDelete && columnData.fieldColumnType === COLUMN_TYPES.AGGREGATE_COLUMN)
                {
                    confirmRemoveColumn(columnToRemove)
                        .done(() =>
                        {
                            // call back will be called when the user clicks "Yes" or if there are no usages found
                            doRemoveColumnAndRelatedColumns(columnToRemove, updateUI);
                        })
                        .fail(() => { /* ignore cancel click */ });
                }
                else
                {
                    doRemoveColumnAndRelatedColumns(columnToRemove, updateUI);
                }
            }
        };

        const confirmRemoveColumn = function (columnToRemove)
        {
            const placesToSearch = usageLocations.columnPlacesToSearch(columnToRemove.data());
            const message = "This field is currently used as a condition for, or within, other field(s) on the report. Deleting it will break the relationship with the field(s) listed below, which could affect how your report behaves or displays results. Please review the impacted field(s) before proceeding.";
            const confirmButton =
            {
                text: "Yes, Delete"
            };
            const cancelButton =
            {
                text: "No, Cancel"
            };

            return confirmDependentColumn(columnToRemove, placesToSearch, message, confirmButton, cancelButton, true,
                (messageElement, buttons, referenceItems) =>
                {
                    const messageHtml = `${skyward.modalLayer.getReferenceAreaHTML(referenceItems)}` +
                        `<span class="modalContent__deleteHeading">Are you sure you want to delete this column?</span>` +
                        `<div class="modalContent__deleteAdditionalText">${messageElement}</div>`;

                    return skyward.modalLayer.showDialog("CONFIRM DELETE", messageHtml, buttons, { closeOnClick: false, closeOnEscape: false, additionalClasses: "critical", role: "alertdialog" });
                });
        };

        const confirmUpdateAggregateTypeColumn = function (columnToUpdate)
        {
            const placesToSearch = usageLocations.simpleAggregateColumnPlacesToSearch(columnToUpdate);
            const message = "This field is currently used as a condition for, or within, other field(s) on the report. Updating it will break the relationship with the field(s) listed below, which could affect how your report behaves or displays results. Please review the impacted field(s) before proceeding.";
            const confirmButton =
            {
                text: "Yes, Update"
            };
            const cancelButton =
            {
                text: "No, Cancel"
            };

            return confirmDependentColumn(columnToUpdate, placesToSearch, message, confirmButton, cancelButton, false,
                (messageElement, buttons, referenceItems) =>
                {
                    const messageHtml = `${skyward.modalLayer.getReferenceAreaHTML(referenceItems)}` +
                        `<span class="modalContent__deleteHeading">Are you sure you want to update this aggregate type?</span>` +
                        `<div class="modalContent__deleteAdditionalText">${messageElement}</div>`;
                    return skyward.modalLayer.showDialog("Warning", messageHtml, buttons, { closeOnClick: false, closeOnEscape: false, additionalClasses: "warning", role: "alertdialog" });
                });
        };

        const confirmDependentColumn = function (dependentColumn, placesToSearch, message, confirmButtonArg, cancelButtonArg, ignoreIfUsageIsOnlySelf, getModal)
        {
            const waitForConfirmation = $.Deferred();
            const columnData = dependentColumn.data();
            const foundNodes = placesToSearch.traverse();
            if (foundNodes.some(node => node.inUse())
                && (!ignoreIfUsageIsOnlySelf || !usageLocations.usageLocationOnlyIncludesSelf(foundNodes, usageLocations.SourceTypes.Column, columnData.columnId)))
            {
                const usageLocationsElement = usageLocations.buildUsageLocationsElement(foundNodes);

                const messageElement = $("<div/>")
                    .append(`<p>${message}</p>`)
                    .append(usageLocationsElement)
                    .html();

                const line = dependentColumn.closest(".reportLine");
                const lineData = line.data();

                const section = line.closest(".jsSection");
                const sectionData = section.data();

                const confirmButton = $.extend({
                    icon: "CheckmarkConfirm",
                    click: () => waitForConfirmation.resolve(foundNodes),
                    additionalClasses: "confirmDelete_doDelete"
                }, confirmButtonArg);

                const cancelButton = $.extend({
                    icon: "Cancel",
                    click: waitForConfirmation.reject,
                    additionalClasses: "confirmDelete_cancel"
                }, cancelButtonArg);

                const referenceItems = [
                    { label: "Section", data: sectionData.displayName },
                    { label: "Report Line", data: lineData.reportLabelText },
                    { label: "Column", data: columnData.designerText }
                ];

                const dialog = getModal(messageElement, [confirmButton, cancelButton], referenceItems, foundNodes);
                waitForConfirmation.always(dialog.close);
            }
            else
            {
                waitForConfirmation.resolve();
            }
            return waitForConfirmation.promise();
        };

        const doRemoveColumnAndRelatedColumns = function (columnToRemove, updateUI)
        {
            if (currentSelectedColumns.isColumnSelected(columnToRemove))
            {
                const canSelectNewColumn = currentSelectedColumns.isSingleColumnSelected();
                currentSelectedColumns.delete(columnToRemove);

                let newSelectedItem = columnToRemove.next(".selectable");
                if (!newSelectedItem.length)
                {
                    newSelectedItem = columnToRemove.prev(".selectable");
                }

                if (!newSelectedItem.length || !canSelectNewColumn)
                {
                    setSelectedRowByRow(columnToRemove.parent());
                }
                else
                {
                    setSelectedColumn(newSelectedItem, true);
                }
            }

            removeRelatedColumns(columnToRemove, false);

            const columnToRemoveData = columnToRemove.data();
            if (columnToRemoveData.fieldColumnType === COLUMN_TYPES.CALCULATED_COLUMN)
            {
                skyward.reporting.aggregateCalculationCollection.remove(columnToRemoveData.columnId);
            }

            // isRemoved is for tracking cascading deletes so we do not try to delete something twice
            // The attribute value needs to be set because .remove() deletes any data that jQuery is only holding in memory
            columnToRemove.data("isRemoved", true);
            columnToRemove.attr("data-is-removed", true);
            columnToRemove.remove();

            if (currentRow)
            {
                // reselect current row to update any ui after removing related columns/data
                setSelectedRowByRow(currentRow);
            }

            removeInvalidPageNumberColumns(false);

            entireCanvas.focus();
            updateHiddenField();
            if (updateUI)
            {
                const sectionData = getSectionData(currentRow.closest(".jsSection"));
                initFieldsUsedInReport(sectionData);
                skyward.reporting.updateVariableUsageLocations();
            }
        };

        const removeCalculatedFieldBySection = function (section, fieldId)
        {
            const columnsToRemove = $(".jsColumn[data-operation-id='" + fieldId + "']");
            for (const column of columnsToRemove.map((i, c) => $(c)))
            {
                removeColumn(column, false);
            }

            CalculatedFields_Model.Delete(fieldId);
            removeCalculatedFieldLines(fieldId);
            removeIsHiddenConditionsThatUseCalculatedField(fieldId);
            removeCalculatedFieldFilter(fieldId);
            removeCalculatedFieldSorts(fieldId);
            updateHiddenField();
            updateDesignerSidebarCalculatedFieldList(section.data());
        };

        skyward.reporting.removeCalculatedField = function (fieldId)
        {
            removeCalculatedFieldBySection(getCurrentSection(), fieldId);
        };

        const removeCalculatedFieldLines = function (calculatedFieldID)
        {
            for (const section of getAllSections().map((i, s) => $(s)))
            {
                const sectionSorts = getSectionSorts(section);
                if (sectionSorts)
                {
                    const sort = sectionSorts.find(function (sort) { return sort.CalculatedField && sort.CalculatedField.id === calculatedFieldID; });

                    if (sort)
                    {
                        const sortLines = [...getSectionSortHeaderLinesByReportSortID(section, sort.ReportSortID), ...getSectionSortAggregateLinesByReportSortID(section, sort.ReportSortID)];

                        for (const line of sortLines.map((l) => $(l)))
                        {
                            removeLine(line);
                        }
                    }
                }
            }
        }

        var removeIsHiddenConditionsThatUseCalculatedField = function (calculatedFieldID)
        {
            var allColumns = getSectionAllColumns(getCurrentSection());

            for (var i = 0; i < allColumns.length; i++)
            {
                var columnData = $(allColumns[i]).data();
                if (columnData.isHiddenCondition && columnData.isHiddenCondition.LeftOperand.CalculatedFieldGuid === calculatedFieldID)
                {
                    columnData.isHiddenCondition = null;
                }
            }
        };

        // it'd be great to implement GetFromJSON on the SearchCondition model and do something much better here
        const removeCalculatedFieldFilter = function (fieldId)
        {
            const sections = designer.find('.jsSection');
            sections.each(function (index, element)
            {
                const section = $(element);
                if (!section.hasClass('jsHeaderFooterSection'))
                {
                    let filterChanged = false;
                    let filterModel = null;

                    const filterData = getSectionFilterObjectAndParameters(section);
                    const filters = filterData ? filterData.filterObject : null;
                    if (filters != null)
                    {
                        filterModel = skyward.searchCondition.getFromJson(filters);
                        filterModel = filterModel.removeWhen(function (condition)
                        {
                            const conditionValues = condition.get();
                            const foundReference = conditionValues["@CalculatedFieldName"] == fieldId || conditionValues["@RightCalculatedFieldName"] == fieldId;
                            filterChanged = filterChanged || foundReference;
                            return foundReference;
                        });
                    }

                    if (filterChanged)
                    {
                        const popupButton = section.find('.filterBuilderLaunchButton').first();
                        skyward.filterbuilder.updateFilter(popupButton, filterModel);
                    }
                }
            });
        };

        const removeCalculatedFieldSorts = function (fieldId)
        {
            designer.find(".jsSection").each(function ()
            {
                const section = $(this);
                let sectionSorts = getSectionSorts(section);
                if (sectionSorts)
                {
                    let sortRemoved = false;
                    sectionSorts = sectionSorts.filter(function (sort)
                    {
                        if (sort.CalculatedField && sort.CalculatedField.id === fieldId)
                        {
                            sortRemoved = true;
                            return false;
                        }

                        return true;
                    });

                    if (sortRemoved)
                    {
                        sectionSorts = updateSortDataSortOrder(sectionSorts);
                        updateSectionSortData(section, sectionSorts);
                    }
                }
            });
        };

        const removeRelatedColumns = function (columnBeingRemoved, updateUI = true)
        {
            if (columnBeingRemoved && !columnBeingRemoved.data("isRemoved"))
            {
                const columnBeingRemovedSection = columnBeingRemoved.closest(".jsSection");

                const columnBeingRemovedLine = columnBeingRemoved.closest(".reportLine");
                const columnBeingRemovedLineData = columnBeingRemovedLine.data();

                const columnBeingRemovedData = columnBeingRemoved.data();

                const columnsInHeaderFooterSections = getAllHeaderFooterSections().find(`.reportColumn[data-source-column-id='${columnBeingRemovedData.columnId}']`);
                removeColumns(columnsInHeaderFooterSections, false);

                const allSectionsToCheck = [columnBeingRemovedSection, ...getAllParentSections(columnBeingRemovedSection)];

                for (const currentSection of allSectionsToCheck.map((s) => $(s)))
                {
                    const currentSectionIsColumnBeingRemovedSection = currentSection.is(columnBeingRemovedSection);
                    const allLinesToCheck = [...getSectionAllAggregateLines(currentSection), ...getSectionSortHeaderLines(currentSection)];

                    for (const currentLine of allLinesToCheck.map((l) => $(l)))
                    {
                        const allColumnsToCheck = currentLine.find(`.reportColumn[data-source-column-id='${columnBeingRemovedData.columnId}']`);

                        for (const currentColumn of allColumnsToCheck.map((i, c) => $(c)))
                        {
                            const currentColumnData = currentColumn.data();

                            // we don't need to delete columns from the same section if we can generate them in the AggregateColumnMap at runtime
                            if (currentSectionIsColumnBeingRemovedSection &&
                                columnBeingRemovedLineData.lineType == LINE_TYPES.DATA_LINE &&
                                (currentColumnData.absoluteFieldPath || currentColumnData.operationId))
                            {
                                currentColumn.removeData("source-column-id");
                            }
                            else
                            {
                                removeColumn(currentColumn, false);
                            }
                        }

                        if (columnBeingRemovedData.fieldColumnType === COLUMN_TYPES.AGGREGATE_COLUMN)
                        {
                            removeHiddenConditionWithColumnID(currentLine, columnBeingRemovedData.columnId);
                            applySectionOrRowHiddenCondition(currentLine);

                            const allColumns = currentLine.find(".reportColumn").map((_, c) => $(c));
                            for (const currentColumn of allColumns)
                            {
                                removeHiddenConditionWithColumnID(currentColumn, columnBeingRemovedData.columnId);
                                updateColumnIsHiddenConditionFormatting(currentColumn)
                            }
                        }
                    }
                }

                skyward.reporting.aggregateCalculationCollection.deleteColumnsUsingGivenColumnID(columnBeingRemovedData.columnId, removeColumnByColumnID);

                //remove header
                if (columnBeingRemovedLineData.lineType == LINE_TYPES.DATA_LINE)
                {
                    const headerLine = getCorrespondingHeaderLine(columnBeingRemovedSection, columnBeingRemovedLine);
                    const headerColumn = headerLine.find('[data-data-column-id="' + columnBeingRemovedData.dataColumnId + '"]');
                    if (headerColumn.length > 0)
                    {
                        if (currentSelectedColumns.isColumnSelected(headerColumn))
                        {
                            currentSelectedColumns.delete(headerColumn);
                        }
                        removeColumn(headerColumn, false);
                    }
                }

                if (updateUI)
                {
                    initFieldsUsedInReport();
                    skyward.reporting.updateVariableUsageLocations();
                }
            }
        };

        const removeHiddenConditionWithColumnID = function (element, columnId)
        {
            const currentLineHiddenCondition = element.data("is-hidden-condition");

            if (currentLineHiddenCondition && (
                currentLineHiddenCondition.LeftOperand?.ColumnID === columnId ||
                currentLineHiddenCondition.RightOperand?.ColumnID === columnId))
            {
                element.data("is-hidden-condition", null);
            }
        }

        var allowKeepTogetherForSection = function (section)
        {
            let parentSection = getParentSection(section);

            while (parentSection.length == 1)
            {
                const allSectionSorts = getSectionSorts(parentSection);

                if (allSectionSorts.some(s => s.KeepLinesTogether))
                {
                    return false;
                }

                parentSection = getParentSection(parentSection);
            }

            return true;
        };

        // display Sorts popup
        var getSorts = function (section, reportType)
        {
            const dataLines = buildLineCollection(getSectionDataLines(section));
            const sectionData = section.data();
            const allowKeepTogether = allowKeepTogetherForSection(section);

            skyward.reportingSorts.editSorts(dataLines, sectionData, reportType, allowKeepTogether, CalculatedFields_Model.AllFieldsOfModuleAndObject(sectionData.rootModule, sectionData.rootObject, sectionData.entireRelationshipPath))
                .then(insertAddedSorts)
                .then(deleteRemovedSorts)
                .then(reorderSorts)
                .then(updateSectionSorts)
                .always(function ()
                {
                    removeInvalidPageNumberColumns();
                    updateHiddenField();
                    initDesignerUI(section);
                    labelBuilder.buildLabelColumns(true);
                });

            function insertAddedSorts(sortData)
            {
                $.each(sortData.selectedSorts, function (i, sort)
                {
                    if (!sort.existingSort)
                    {
                        if (sort.operationId)
                        {
                            sort.calculatedField = CalculatedFields_Model.Get(sort.operationId);
                        }
                    }
                });

                var sortPrompt = skyward.reporting.prompts.promptCollection.Get(sortData.sortPrompt.promptGuid);

                if (sortPrompt == null)
                {
                    if (sortData.sortPrompt.promptForSortOrder)
                    {
                        sortPrompt = {
                            InUse: true,
                            Label: sortData.sortPrompt.label,
                            PromptUniqueId: sortData.sortPrompt.promptGuid,
                            PromptGuid: sortData.sortPrompt.promptGuid,
                            Type: enumMaps.PromptTypes.ReportSort,
                            InputType: DATA_TYPES.STRING
                        };
                        skyward.reporting.prompts.promptCollection.Set(sortPrompt);
                    }
                }
                else
                {
                    sortPrompt.Label = sortData.sortPrompt.label;
                    skyward.reporting.prompts.promptCollection.Set(sortPrompt);
                }

                var sortPromptedSection = entireCanvas.find("[data-sort-prompt-guid='" + sortData.sortPrompt.promptGuid + "']");
                sortPromptedSection.data("sortPromptLabel", sortData.sortPrompt.label);
                sortPromptedSection.data("promptForSortOrder", sortData.sortPrompt.promptForSortOrder);
                updateHiddenField();

                return $.Deferred().resolve(sortData);
            }

            function deleteRemovedSorts(sortData)
            {
                $.each(sortData.removedSorts, function (i, sort)
                {
                    for (const line of [...getSectionSortHeaderLinesByReportSortID(section, sort.reportSortId), ...getSectionSortAggregateLinesByReportSortID(section, sort.reportSortId)])
                    {
                        removeLine($(line));
                    }
                });
                return $.Deferred().resolve(sortData);
            }

            function reorderSorts(sortData)
            {
                function sortAction(elementA, elementB, desc)
                {
                    const elementAData = $(elementA).data();
                    const elementBData = $(elementB).data();
                    const relatedReportSortIDA = elementAData.relatedReportSortId;
                    const relatedReportSortIDB = elementBData.relatedReportSortId;

                    if (relatedReportSortIDA === relatedReportSortIDB)
                    {
                        const lineIndexA = elementAData.lineIndex;
                        const lineIndexB = elementBData.lineIndex;
                        return -1 * (lineIndexA - lineIndexB);
                    }
                    const sortDataA = sortData.selectedSorts.find(sort => { return sort.reportSortId === relatedReportSortIDA });
                    const sortDataB = sortData.selectedSorts.find(sort => { return sort.reportSortId === relatedReportSortIDB });

                    return (desc ? 1 : -1) * sortDataA.sortOrder - sortDataB.sortOrder;
                };

                const aggregateOrder = $("<div class='temporary floating div never inserted into DOM'/>"); // Great band
                const headerOrder = $("<div class='temporary floating div never inserted into DOM'/>");

                const sorts = sortData.selectedSorts;
                const sectionSortAggregateLinesCollection = buildLineCollection(getSectionSortAggregateLines(section));
                const processedReportSortIDs = new Set();

                sorts.forEach(function (sort, i)
                {
                    const sectionSortAggregateLinesByReportSortID = getSectionSortAggregateLinesByReportSortID(section, sort.reportSortId);

                    if (sort.sortOrder != i && sectionSortAggregateLinesByReportSortID.length > 0)
                    {
                        const relatedSortAggregateLines = buildLineCollection($(sectionSortAggregateLinesByReportSortID));
                        relatedSortAggregateLines.forEach((sortAggregateLine) =>
                        {
                            sortAggregateLine.columns.forEach((column) =>
                            {
                                if (column.isFutureValue === true)
                                {
                                    const sourceColumnId = column.sourceColumnId;
                                    if (!sourceColumnId)
                                    {
                                        return;
                                    }

                                    const sourceLine = sectionSortAggregateLinesCollection.find(line => line.columns.some(column => column.columnId === sourceColumnId));
                                    if (!sourceLine)
                                    {
                                        return;
                                    }

                                    const relatedReportSortId = sourceLine.relatedReportSortId;
                                    if (!relatedReportSortId)
                                    {
                                        return;
                                    }

                                    if (!processedReportSortIDs.has(relatedReportSortId))
                                    {
                                        removeColumnByColumnID(column.columnId);
                                    }
                                }
                            })
                        })
                    }

                    sort.sortOrder = i;

                    if (sectionSortAggregateLinesByReportSortID.length)
                    {
                        $(sectionSortAggregateLinesByReportSortID).appendTo(aggregateOrder);
                    }

                    const sortHeaderLinesForReportSortID = getSectionSortHeaderLinesByReportSortID(section, sort.reportSortId);
                    if (sortHeaderLinesForReportSortID.length)
                    {
                        $(sortHeaderLinesForReportSortID).appendTo(headerOrder);
                    }

                    processedReportSortIDs.add(sort.reportSortId);
                })

                if (aggregateOrder.children().length > 0)
                {
                    const sortAggregateLinesInNewOrder = aggregateOrder.sortChildrenByAction(sortAction, true).children().detach();
                    insertSortAggregateLine(section, sortAggregateLinesInNewOrder);
                }

                if (headerOrder.children().length > 0)
                {
                    const sortHeaderLineinNewOrder = headerOrder.children().detach();
                    sortHeaderLineinNewOrder.insertAfter(getSectionHeaderLines(section).last());
                }

                return $.Deferred().resolve(sortData);
            }

            function updateSectionSorts(sortData)
            {
                const selectedSortsData = [];
                for (const data of sortData.selectedSorts)
                {
                    const calculatedField = CalculatedFields_Model.Get(data.operationId);
                    const sort =
                    {
                        ReportSortID: data.reportSortId,
                        AbsoluteFieldPath: data.absoluteFieldPath,
                        FieldName: data.operationId ? calculatedField.fieldName : data.fieldName,
                        DisplayName: data.displayName,
                        DisplayPath: data.displayPath,
                        Descending: (data.descending === true || data.descending == "True") ? "True" : "False",
                        PageBreak: data.pageBreak,
                        PageBreakPromptUniqueId: data.pageBreakPromptUniqueId,
                        SortOrder: data.sortOrder,
                        FriendlyName: data.friendlyName,
                        RelativeDataPath: data.relativeDataPath,
                        CalculatedField: data.operationId ? calculatedField : null,
                        KeepLinesTogether: data.keepLinesTogether,
                        CreateBookmark: data.createBookmark,
                        DataType: data.dataType,
                        IsOperation: data.isOperation,
                        Parameters: data.Parameters
                    };
                    selectedSortsData.push(sort);
                }
                updateSectionSortData(section, selectedSortsData);
            }
        };
        //END SORTS

        var removeInvalidPageNumberColumns = function (updateUI = true)
        {
            // now that we have currentReportDefinition as an object, we could look at that instead of the dom
            const allSorts = getAllSorts();
            let anyMainSectionHasPageBreak = false;
            getAllMainSections().each(function (i, section)
            {
                if ($(section).data('pageBreakBeforeSection'))
                {
                    anyMainSectionHasPageBreak = true;
                }
            });
            getAllSections().each(function (i, section)
            {
                const $section = $(section);
                const isHeaderFooterSection = $section.is(".jsHeaderFooterSection");
                const sectionSortsMap = {};
                const sectionSorts = getSectionSorts($section);
                if (sectionSorts)
                {
                    sectionSorts.forEach(function (sort)
                    {
                        sectionSortsMap[sort.FieldName] = sort;
                    });
                }
                getSectionAllColumns($section).each(function (j, column)
                {
                    const $column = $(column);
                    const columnData = $column.data();
                    const isResettablePageColumn = isPageNumberOrPageTotalColumn(columnData);
                    if (isResettablePageColumn && columnData.resetOn && columnData.resetOn !== RESET_ON_TYPES.NEVER_RESET)
                    {
                        if (isHeaderFooterSection)
                        {
                            if (columnData.resetOn === RESET_ON_TYPES.MAIN_SECTIONS && !anyMainSectionHasPageBreak)
                            {
                                removeColumn($column, false);
                            }
                            else
                            {
                                let validSortExist = false;
                                allSorts.forEach(function (sort)
                                {
                                    if (sort.FieldName === columnData.resetOn && sort.PageBreak !== skyward.reportingSorts.pageBreakOptions.False)
                                    {
                                        validSortExist = true;
                                        return;
                                    }
                                });
                                if (!validSortExist)
                                {
                                    removeColumn($column, false);
                                }
                            }
                        }
                        else
                        {
                            const existingSort = sectionSortsMap[columnData.resetOn];
                            if (!existingSort || existingSort.PageBreak === skyward.reportingSorts.pageBreakOptions.False)
                            {
                                removeColumn($column, false);
                            }
                        }
                    }
                });
            });

            if (updateUI)
            {
                initFieldsUsedInReport();
            }
        };

        //DETAILS SECTIONS
        var getDetail = function ($section, launchDetailButton)
        {
            const sectionData = getSectionData($section);
            const fullUrl = skyward.global.virtualDir + "Reporting/Report/GetDetail/";
            const rootModule = launchDetailButton.data().rootModule;
            const rootObject = launchDetailButton.data().rootObject;

            $.ajax(fullUrl,
                {
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        module: sectionData.baseModule,
                        obj: sectionData.baseObject,
                        expandUrl: "Reporting/Report/ExpandTreeBrowse",
                    }
                }).done(async function (data)
                {
                    const container = $("<div style='overflow-x: auto; height: 600px; min-width: 400px;'>");
                    const popupContent = $("<div class='popup detailSectionPopUp'/>");
                    container.append(popupContent);

                    // Process HTML through processViewPartHtml to handle any script tags
                    const processedHtml = await skyward.global.processViewPartHtml(data.html);
                    popupContent.append(processedHtml);
                    const treeBrowse = popupContent.find("#detailModalTreeBrowse_main"); // popupContent isn't yet in the DOM, so using skyward.treebrowse.getTreeBrowseContainer won't work
                    treeBrowse.addClass("treeBrowse--flush");

                    const createDetailSection = function ($el, object, module, displayName, fieldPath, entireRelationshipPath, parentDisplayOnSingleLine)
                    {
                        const fullUrl = skyward.global.virtualDir + "Reporting/Report/GetNewDetailsSection";
                        const deferred = $.Deferred();

                        $.ajax(fullUrl,
                            {
                                type: "POST",
                                dataType: "JSON",
                                data:
                                {
                                    baseObject: object,
                                    baseModule: module,
                                    rootModule: rootModule,
                                    rootObject: rootObject,
                                    displayName: displayName,
                                    fieldPath: fieldPath,
                                    entireFieldPath: entireRelationshipPath,
                                    parentDisplayOnSingleLine: parentDisplayOnSingleLine
                                },
                                success: async function (data)
                                {
                                    entireCanvas.find('.sectionSelected').removeClass('sectionSelected');
                                    entireCanvas.find('.row-selected').removeClass('row-selected');

                                    // Process HTML through processViewPartHtml to handle any script tags
                                    const processedHtml = await skyward.global.processViewPartHtml(data.html);
                                    $el.children(".detailSectionContainer").append(processedHtml);
                                    const newSection = designer.find('.sectionSelected');
                                    newSection.data("displayOnSingleLine", sectionData.displayOnSingleLine);

                                    setActiveSection(newSection);
                                    setSelectedRowByRow(newSection.find('div.jsDataLine'));

                                    updateHiddenField();
                                    const newSectionData = getSectionData(newSection);

                                    updateDesignerSidebarCalculatedFieldList(newSectionData);

                                    initializeToolbarEvents();
                                    labelBuilder.buildLabelColumns(true);
                                    skyward.window.notifyDOMLoad(".sectionSelected");
                                    deferred.resolve();
                                }
                            });
                        return deferred;
                    };

                    const getSelectedSectionData = function ()
                    {
                        let data;
                        let displayName;
                        const selectedNode = menu.content.find(".selected");

                        if (selectedNode.hasClass("breadcrumbspan"))
                        {
                            const selected1M = selectedNode.parent();
                            data = selected1M.data("relationshipData");
                            displayName = selected1M.text();
                        }
                        else
                        {
                            data = skyward.treebrowse.getSelectedFieldData(treeBrowse);
                            displayName = data ? data.relationshipName : null;
                        }

                        let selectedSectionData;
                        if (data)
                        {
                            const fieldPath = data.fieldName;
                            const parentSection = designer.find('.sectionSelected');
                            const parentSectionData = getSectionData(parentSection);
                            const dotIndex = data.fieldName.indexOf('.');
                            const secondPartAbsolutePath = dotIndex !== -1 ? fieldPath.substring(dotIndex + 1) : "";
                            const absoluteTreeBrowseObjectPath = !parentSectionData.entireRelationshipPath
                                ? secondPartAbsolutePath
                                : parentSectionData.entireRelationshipPath + '.' + secondPartAbsolutePath;

                            selectedSectionData =
                            {
                                baseModule: data.fieldModule,
                                baseObject: data.fieldObject,
                                fieldPath: data.fieldName,
                                displayName: displayName,
                                absoluteTreeBrowseObjectPath: absoluteTreeBrowseObjectPath,
                                entireRelationshipPath: parentSectionData.entireRelationshipPath,
                                displayOnSingleLine: parentSectionData.displayOnSingleLine,
                                parentSection: parentSection,
                                parentSectionID: parentSectionData.sectionID
                            };
                        }

                        return selectedSectionData;
                    };

                    const insertDetailsSection = function ()
                    {
                        const selectedSectionData = getSelectedSectionData();
                        if (selectedSectionData)
                        {
                            const parentSection = selectedSectionData.parentSection;
                            const object = selectedSectionData.baseObject;
                            const module = selectedSectionData.baseModule;
                            const fieldPath = selectedSectionData.fieldPath;
                            const displayName = selectedSectionData.displayName;
                            const entireRelationshipPath = selectedSectionData.entireRelationshipPath;
                            const displayOnSingleLine = selectedSectionData.displayOnSingleLine;
                            const absoluteTreeBrowseObjectPath = selectedSectionData.absoluteTreeBrowseObjectPath;

                            createDetailSection(parentSection, object, module, displayName, fieldPath, entireRelationshipPath, displayOnSingleLine).then(function ()
                            {
                                const control = "reportObjectBrowser";
                                const treeBrowseContainer = skyward.treebrowse.getTreeBrowseContainer(control);
                                const treeBrowseData = skyward.treebrowse.getTreeBrowseData(treeBrowseContainer);
                                treeBrowseData.renderColumnGroups = !displayOnSingleLine;
                                treeBrowseData.renderRowForImageReferences = !displayOnSingleLine;

                                const treeBrowseDataPromise = skyward.treebrowse.setBrowseTarget(module, object, object, control,
                                    "Reporting/Report/ExpandTreeBrowseDesignerSidebar", displayName, null, rootModule, rootObject,
                                    absoluteTreeBrowseObjectPath, true);
                                treeBrowseDataPromise.then(function (data)
                                {
                                    designer.find(".hideForHeaderFooterSections").show();
                                    hidePageNumberFields(true);
                                    initDesignerUI(designer.find(".sectionSelected"));
                                });
                                menu.close();
                            });
                        }
                        else
                        {
                            menu.close();
                        }
                    };

                    const importDetailsSection = function ()
                    {
                        const selectedSectionData = getSelectedSectionData();

                        if (selectedSectionData)
                        {
                            const reportData = getReportData();
                            const data =
                            {
                                hash: reportData.reportIDHash,
                                reportID: reportData.reportID,
                                reportDefinitionJSON: JSON.stringify(buildHiddenFieldJson()),
                                sectionID: selectedSectionData.parentSectionID,
                                baseModuleName: selectedSectionData.baseModule,
                                baseObjectName: selectedSectionData.baseObject,
                                relationshipPath: selectedSectionData.fieldPath,
                                hasUnsavedChanges: isReportDirty(),
                            };

                            skyward.changeTracking.overrideGlobalDirtyState(false);

                            // If the workflow is canceled clear the dirty status override
                            $(document).one("WorkflowCancelled.Reporting.Report.ImportReportAsNewSection", () =>
                            {
                                skyward.changeTracking.overrideGlobalDirtyState(null);
                            });


                            $.ajax({
                                url: skyward.global.virtualDir + "Reporting/Report/ImportDetailsSection",
                                type: "POST",
                                dataType: "JSON",
                                data: data,
                                success: function (data)
                                {
                                    const workflowData =
                                    {
                                        "Workflow.ReportID": data["ReportID"],
                                        "Workflow.ReportID_SecurityHash": data["ReportIDSecurityHash"],
                                        "Workflow.HasUnsavedChanges": data["HasUnsavedChanges"],
                                        "Workflow.HasUnsavedChanges_SecurityHash": data["HasUnsavedChangesSecurityHash"],
                                        "Workflow.ExistingReportDefinitionJSON": data["ReportDefinitionJSON"],
                                        "Workflow.ExistingReportDefinitionJSON_SecurityHash": data["ReportDefinitionJSONHash"],
                                        "Workflow.ParentSectionID": data["ParentSectionID"],
                                        "Workflow.ParentSectionID_SecurityHash": data["ParentSectionIDSecurityHash"],
                                        "Workflow.BaseModuleName": data["BaseModuleName"],
                                        "Workflow.BaseModuleName_SecurityHash": data["BaseModuleNameSecurityHash"],
                                        "Workflow.BaseObjectName": data["BaseObjectName"],
                                        "Workflow.BaseObjectName_SecurityHash": data["BaseObjectNameSecurityHash"],
                                        "Workflow.SelectedRelationshipPath": data["SelectedRelationshipPath"],
                                        "Workflow.SelectedRelationshipPath_SecurityHash": data["SelectedRelationshipPathSecurityHash"]
                                    };
                                    skyward.window.loadContent("popup", "Workflow", "WorkflowInstance", "Create/Reporting/Report/ImportReportAsNewSection", null, workflowData);
                                }
                            });
                        }
                    };

                    const treeBrowseRowChanged = function (event, data, selectedRowData)
                    {
                        const saveButton = menu.footer.find(".addDetailSaveButton");
                        const importButton = menu.footer.find(".addDetailImportButton");
                        if (selectedRowData)    // Its possible there are no relationships for this data object
                        {
                            const selectedFieldType = selectedRowData.fieldType;

                            if (selectedFieldType == "OneToMany" || data.selectedRecord.hasClass("breadcrumbspan"))
                            {
                                saveButton.show();
                                importButton.show();
                            }
                            else
                            {
                                saveButton.hide();
                                importButton.hide();
                            }
                        }
                    };

                    const options =
                    {
                        automationID: "insert-details-dialog",
                        closeOnClick: false,
                        resizable: false
                    };
                    const okButton =
                    {
                        additionalClasses: "addDetailSaveButton",
                        click: insertDetailsSection,
                        icon: "Save",
                        text: "Save"
                    };
                    const importButton =
                    {
                        additionalClasses: "addDetailImportButton",
                        click: importDetailsSection,
                        icon: "Import",
                        text: "Import",
                    };
                    const cancelButton =
                    {
                        icon: "Cancel",
                        text: "Cancel"
                    };

                    const menu = skyward.modalLayer.showDialog("Insert Details Section", container, [importButton, okButton, cancelButton], options);
                    menu.content.on("treeBrowseRowChange", treeBrowseRowChanged)
                        .on("treeBrowseSave", insertDetailsSection);

                    skyward.window.notifyDOMLoad("#" + popupContent.find(".treeBrowse").attr("id"));
                });
        };
        //END DETAILS SECTIONS

        //MAIN SECTIONS
        let getMainSection = function ()
        {
            let menu = {};

            let insertMainSection = function (html)
            {
                const $newSection = $(html);
                const mainSections = designer.find('.jsMainSection');
                const headerSections = designer.find('.jsSection');
                if (mainSections.length > 0)
                {
                    $newSection.insertAfter(mainSections.last());
                    skyward.controls.setValue(exportProperties.xml.includeRootNode, true);
                    skyward.controls.disable(exportProperties.xml.includeRootNode);
                }
                else if (headerSections.length > 1)
                {
                    // Place under report and page headers
                    $newSection.insertAfter(headerSections[1]);
                }
                else
                {
                    // Exportable reports do not have headers
                    designer.find('.reportDesignerCanvas').append($newSection);
                }

                setActiveSection($newSection);
                setSelectedRowByRow(getSectionDataLines($newSection).first());
                initDesignerUI($newSection);
                initializeToolbarEvents();
                updateHiddenField();
                labelBuilder.buildLabelColumns(true);
                skyward.window.notifyDOMLoad(".jsMainSection.sectionSelected");
            };

            var fullUrl = skyward.global.virtualDir + "Reporting/Report/GetObjectSelector/";

            const importMainSection = function ()
            {
                const reportData = getReportData();

                const data =
                {
                    hash: reportData.reportIDHash,
                    reportID: reportData.reportID,
                    reportDefinitionJSON: JSON.stringify(buildHiddenFieldJson()),
                    hasUnsavedChanges: isReportDirty()
                };

                skyward.changeTracking.overrideGlobalDirtyState(false);

                // If the workflow is canceled clear the dirty status override
                $(document).one("WorkflowCancelled.Reporting.Report.ImportReportAsNewSection", () =>
                {
                    skyward.changeTracking.overrideGlobalDirtyState(null);
                });

                $.ajax({
                    url: skyward.global.virtualDir + "Reporting/Report/ImportMainSection",
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function (data)
                    {
                        const workflowData =
                        {
                            "Workflow.ReportID": data["ReportID"],
                            "Workflow.ReportID_SecurityHash": data["ReportIDSecurityHash"],
                            "Workflow.HasUnsavedChanges": data["HasUnsavedChanges"],
                            "Workflow.HasUnsavedChanges_SecurityHash": data["HasUnsavedChangesSecurityHash"],
                            "Workflow.ExistingReportDefinitionJSON": data["ReportDefinitionJSON"],
                            "Workflow.ExistingReportDefinitionJSON_SecurityHash": data["ReportDefinitionJSONHash"],
                        };

                        skyward.window.loadContent("popup", "Workflow", "WorkflowInstance", "Create/Reporting/Report/ImportReportAsNewSection", null, workflowData);
                    }
                });
            }

            $.ajax(fullUrl,
                {
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {

                    }
                }).done(function (data)
                {
                    var getSection = function ()
                    {
                        return $.ajax({
                            url: skyward.global.virtualDir + "Reporting/Report/GetNewMainSection/",
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                moduleId: skyward.controls.getValue(menu.content.find('#ModuleID')),
                                objectId: skyward.controls.getValue(menu.content.find('#ObjectID'))
                            },
                            success: function (data)
                            {

                                if (!data.success)
                                {
                                    var container = $('.messageBox.content');
                                    skyward.validation.displayValidationMessages(data, container, null);
                                }
                                else
                                {
                                    insertMainSection(data.html);
                                    menu.close();
                                }
                            }
                        });
                    };

                    var okButton = { text: "Save", "click": getSection, "icon": "Save" };

                    const importButton =
                    {
                        additionalClasses: "addMainImportButton",
                        click: importMainSection,
                        icon: "Import",
                        text: "Import",
                    };

                    menu = skyward.modalLayer.showDialog("Add Main Section", data.html, [importButton, okButton, { text: "Cancel", "icon": "Cancel" }], { closeOnClick: false });
                });
        };
        //END MAIN SECTION

        //REPORT SERIALIZATION
        var updateHiddenField = skyward.reporting.updateHiddenField = function ()
        {
            const jsonObj = buildHiddenFieldJson();
            const editorHiddenData = designer.find(".editorHiddenData");
            const oldData = editorHiddenData.data("original-value");

            updateDirtyStatus(editorHiddenData, oldData, jsonObj);
        };

        var updateDirtyStatus = function (editorHiddenData, oldData, newData)
        {
            const reportDesignDirty = !skyward.global.deepEquals(oldData, newData);

            const moreMenu = $(".moreMenuArea");
            const moreMenuButton = moreMenu.find(".moreButton");
            const runReport = moreMenu.find(".jsRunReport");
            const runReportWithLastValues = moreMenu.find(".jsRunReportWithLastValues");
            const saveAndRunReport = moreMenu.find(".jsSaveAndRunReport")
            const saveAndRunReportWithLastValues = moreMenu.find(".jsSaveAndRunReportWithLastValues");
            const publishReport = moreMenu.find(".jsPublishReport");
            const unpublishReport = moreMenu.find(".jsUnpublishReport");
            const previewReport = moreMenu.find(".jsPreview");
            const saveStyle = moreMenu.find(".jsSaveStyle");
            const applyStyle = moreMenu.find(".jsApplyStyle");
            const setDefaultSubjects = moreMenu.find(".jsDefaultSubjects");

            let buttonsToHide = [];
            let buttonsToShow = [];

            if (reportDesignDirty || CalculatedFields_Model.IsDirty())
            {
                if (reportDesignDirty)
                {
                    editorHiddenData.val(JSON.stringify(newData));
                }

                editorHiddenData.change();

                if (designer.find(".jsMainSection").length == 0)
                {
                    buttonsToHide.push(runReport, saveAndRunReport, runReportWithLastValues, saveAndRunReportWithLastValues, publishReport, unpublishReport, setDefaultSubjects, previewReport);
                }
                else
                {
                    // Report has unsaved data
                    skyward.dataobjectviewer.getFieldValues.enableButtons("editReportDefinitionDesigner");
                    changeTracker.overrideDirtyState(true);

                    buttonsToHide.push(applyStyle, saveStyle, publishReport, unpublishReport, runReport, runReportWithLastValues, setDefaultSubjects, previewReport);
                    buttonsToShow.push(saveAndRunReport, saveAndRunReportWithLastValues);
                }
            }
            else
            {
                // Report is unaltered
                skyward.dataobjectviewer.getFieldValues.disableButtons("editReportDefinitionDesigner");
                changeTracker.overrideDirtyState(false);
                changeTracker.clearDirtyList();

                buttonsToHide.push(saveAndRunReport, saveAndRunReportWithLastValues);
                buttonsToShow.push(runReport, runReportWithLastValues, applyStyle, saveStyle, publishReport, unpublishReport, setDefaultSubjects, previewReport);
            }

            for (const button of buttonsToHide)
            {
                button.addClass("ui-hidden").hide();
            }

            for (const button of buttonsToShow)
            {
                button.removeClass("ui-hidden");

                if (!button.hasClass("moreMenuAlwaysHide"))
                {
                    button.css("display", "inline-flex");
                }
            }

            if (moreMenuButton.siblings(".moreMenuHide, .moreMenuAlwaysHide").not(".ui-hidden").length == 0)
            {
                moreMenuButton.addClass("ui-disabled");
            }
            else
            {
                moreMenuButton.removeClass("ui-disabled");
            }
        };

        var buildHiddenFieldJson = skyward.reporting.getDesignerJson = function ()
        {
            const editorHiddenData = designer.find(".editorHiddenData");
            const $mainSection = entireCanvas.find(".jsMainSection");
            let mainSections = [];
            let parameters = {};
            let defaultProcessingListSubjectSkywardIDs = new Set();

            $mainSection.each(function ()
            {
                mainSections.push(buildSectionObject($(this), false, parameters, defaultProcessingListSubjectSkywardIDs));
            });

            let jsonObj = JSON.parse(editorHiddenData.val());

            jsonObj.ReportHeader = buildLineObject(getReportHeaderLine(), { headerType: enumMaps.HeaderTypes.ReportHeader }, parameters);
            jsonObj.PageHeader = buildLineObject(getPageHeaderLine(), { headerType: enumMaps.HeaderTypes.PageHeader }, parameters);
            jsonObj.MainSections = mainSections;
            jsonObj.PageFooter = buildLineObject(getPageFooterLine(), { footerType: enumMaps.FooterTypes.PageFooter }, parameters);
            jsonObj.ReportFooter = buildLineObject(getReportFooterLine(), { footerType: enumMaps.FooterTypes.ReportFooter }, parameters);
            jsonObj.CalculatedFields = CalculatedFields_Model.AllFields();
            jsonObj.Prompts = skyward.reporting.prompts.promptCollection.toJsonObject();
            jsonObj.Variables = skyward.reporting.variables.collectionModel.toJsonObject();

            CalculatedFields_Model.Parameters().forEach(function (parameter)
            {
                skyward.reporting.searchParameters.viewModel.mergeAdd(parameters, parameter);
            });

            jsonObj.SearchParameters = skyward.reporting.searchParameters.model.inUseToJson(parameters);

            const exportFormatting = buildExportFormatting();
            if (!$.isEmptyObject(exportFormatting))
            {
                jsonObj.ExportFormatting = exportFormatting;
            }

            jsonObj.AvailableParameters = parameters;
            jsonObj.DefaultProcessingListSubjectSkywardIDs = Array.from(defaultProcessingListSubjectSkywardIDs);

            // this should be the only place we set currentReportDefinition
            skyward.reporting.currentReportDefinition = jsonObj;
            skyward.reporting.searchParameters.viewModel.toggleButton();

            return jsonObj;
        };

        var buildExportFormatting = function ()
        {
            var exportFormatting = {};
            if (exportProperties.csv.delimiter.length > 0 && exportProperties.csv.textQualifier.length > 0)
            {
                exportFormatting["DelimitedExportFormatting"] =
                {
                    Delimiter: skyward.controls.getValue(exportProperties.csv.delimiter),
                    TextQualifier: skyward.controls.getValue(exportProperties.csv.textQualifier),
                    IncludeTextQualifierOnlyWhenRequired: skyward.controls.getValue(exportProperties.csv.includeTextQualifierOnlyWhenRequired)
                };

                if (exportProperties.csv.customDelimiter.length > 0)
                {
                    exportFormatting["DelimitedExportFormatting"]["CustomDelimiter"] = skyward.controls.getValue(exportProperties.csv.customDelimiter);
                }
            }

            if (exportProperties.xml.includeRootNode.length > 0 || exportProperties.xml.nodeName.length > 0)
            {
                exportFormatting["XMLExportFormatting"] =
                {
                    nodeName: skyward.controls.getValue(exportProperties.xml.nodeName),
                    includeRootNode: skyward.controls.getValue(exportProperties.xml.includeRootNode),
                };
            }

            return exportFormatting;
        };

        var sortRelatedLineDataGatherer = function (line)
        {
            const lineData = line.data();
            const returnData =
            {
                relatedReportSortId: lineData.relatedReportSortId
            };
            return returnData;
        };

        var buildSectionExportPropertiesJSON = function (data)
        {
            var exportFormatting = {};

            if (data.nodeName)
            {
                exportFormatting.xmlExportFormatting = { nodeName: data.nodeName };
            }

            if (data.jsonPropertyName)
            {
                exportFormatting.jsonExportFormatting = { name: data.jsonPropertyName };
            }

            return exportFormatting;
        };

        var buildSectionObject = function ($section, isDetailSection, parameters, defaultProcessingListSubjectSkywardIDs)
        {
            let section = {};

            const sectionData = getSectionData($section);

            if (isDetailSection)
            {
                section.$type = SECTION_TYPES.DETAIL_SECTION;
                const addDetailSectionButtonData = $section.find(".get_detail_modal").data();
                section.RelationshipPath = sectionData.relationshipPath;
                section.EntireRelationshipPath = sectionData.entireRelationshipPath;
                section.RootModule = addDetailSectionButtonData.rootModule;
                section.RootObject = addDetailSectionButtonData.rootObject;
                sectionData.parameters.forEach(function (parameter)
                {
                    skyward.reporting.searchParameters.viewModel.mergeAdd(parameters, parameter);
                });

            }
            else
            {
                section.$type = SECTION_TYPES.MAIN_SECTION;
            }

            section.DetailSections = [];

            $section.children(".detailSectionContainer").children(".jsSection").each(function ()
            {
                section.DetailSections.push(buildSectionObject($(this), true, parameters, defaultProcessingListSubjectSkywardIDs));
            });

            section.SectionID = sectionData.sectionID;
            section.DisplayName = sectionData.displayName;
            section.BaseObject = sectionData.baseObject;
            section.BaseModule = sectionData.baseModule;
            section.SortHeaderLines = buildLineCollection(getSectionSortHeaderLines($section), sortRelatedLineDataGatherer, parameters);
            section.DataLines = buildLineCollection(getSectionDataLines($section), undefined, parameters);
            section.HeaderLines = buildLineCollection(getSectionHeaderLines($section), undefined, parameters);
            section.FooterLines = buildLineCollection(getSectionFooterLines($section), undefined, parameters);
            section.SortAggregateLines = buildLineCollection(getSectionSortAggregateLines($section), sortRelatedLineDataGatherer, parameters);
            section.SectionAggregateLines = buildLineCollection(getSectionAggregateLines($section), undefined, parameters);
            section.PageBreakBeforeSection = sectionData.pageBreakBeforeSection;
            section.ApplyDistrictEntityFilter = $section.find(".filterBuilderLaunchButton").data('applyDistrictEntityFilter');
            section.PromptForSortOrder = sectionData.promptForSortOrder;
            section.SortPromptGuid = sectionData.sortPromptGuid;
            section.SortPromptLabel = sectionData.sortPromptLabel;
            section.PrintIfEmpty = sectionData.printIfEmpty;
            section.displayOnSingleLine = sectionData.displayOnSingleLine;
            section.singleLineRecordCount = sectionData.singleLineRecordCount;
            section.EmptyLinesToPrint = sectionData.emptyLinesToPrint;
            section.IsHiddenCondition = sectionData.isHiddenCondition;
            section.ColumnWidth = sectionData.columnWidth;
            section.ColumnSpacing = sectionData.columnSpacing;
            section.ApplyColumnsToDataLinesOnly = sectionData.applyColumnsToDataLinesOnly;
            section.BalanceColumns = sectionData.balanceColumns;
            section.ColumnDirection = sectionData.columnDirection;
            section.Sorts = sectionData.reportSorts;
            section.DefaultProcessingListSubjectSkywardIDs = sectionData.defaultProcessingListSubjectSkywardIDs;

            const exportFormatting = buildSectionExportPropertiesJSON(sectionData);
            if (!$.isEmptyObject(exportFormatting))
            {
                section.exportFormatting = exportFormatting;
            }

            if (sectionData.Filters != null)
            {
                section.Filters = sectionData.Filters;
            }

            if (sectionData.FiltersParameters)
            {
                sectionData.FiltersParameters.forEach(function (parameter)
                {
                    skyward.reporting.searchParameters.viewModel.mergeAdd(parameters, parameter);
                });
            }

            if (sectionData.defaultProcessingListSubjectSkywardIDs)
            {
                sectionData.defaultProcessingListSubjectSkywardIDs.forEach(skywardID => defaultProcessingListSubjectSkywardIDs.add(skywardID));
            }

            return section;
        };

        var buildLineCollection = function ($reportLines, additionalDataGatherer, parameters)
        {
            /// <summary>Convert an entire section to post-data</summary>
            /// <param name="$reportLines" type="JQuery">The section to convert</param>
            /// <param name="additionalDataGatherer" type="Function">function(line) delegate to add data to individual lines. If passed, this function will be called once per line</param>
            /// <returns type="Object">json object representing a set of report lines</returns>

            additionalDataGatherer = additionalDataGatherer || function () { return {}; };
            var reportLines = [];

            $reportLines.each(function ()
            {
                var jqThis = $(this);
                reportLines.push(buildLineObject(jqThis, additionalDataGatherer(jqThis), parameters));
            });

            return reportLines;
        };

        var buildLineExportPropertiesJSON = function (data)
        {
            var exportFormatting = {};

            if (data.nodeName)
            {
                exportFormatting["xmlExportFormatting"] = { nodeName: data.nodeName };
            }

            return exportFormatting;
        };

        var buildLineObject = function ($reportLine, additionalData, parameters)
        {
            var reportLine = {};
            var canvasColumns = $reportLine.find(".jsColumn");
            var data = $reportLine.data();
            if (!data)
            {
                return;
            }

            reportLine.$type = data.lineType; //$type NEEDS to be the first item in
            reportLine.cellFormat = { height: $.safeRound(data.lineHeight) };
            reportLine.textFormat = { backColor: data.backColor };
            reportLine.columns = buildReportColumnCollection(canvasColumns, parameters);
            reportLine.isHiddenCondition = data.isHiddenCondition;
            reportLine.printAtBottomOfPage = data.printAtBottomOfPage;
            reportLine.printAtBottomOfPagePromptUniqueId = data.printAtBottomOfPagePromptUniqueId;

            if (data.reportFooterLine)
            {
                reportLine.printReportFooterOnNewPagePromptUniqueId = data.printReportFooterOnNewPagePromptUniqueId;
                reportLine.printReportFooterOnNewPage = data.printReportFooterOnNewPage;
            }

            reportLine.repeatOnPageIfDetailsPresent = data.repeatOnPageIfDetailsPresent;
            reportLine.repeatHeaderForEachDataRow = data.repeatHeaderForEachDataRow;
            reportLine.repeatLineAfterStart = data.repeatLineAfterStart;
            reportLine.repeatLineAfterStartPromptUniqueId = data.repeatLineAfterStartPromptUniqueId;
            reportLine.variableIDsToReset = data.variableIdsToReset;
            reportLine.lineID = data.lineId;
            reportLine.lineLabel = data.reportLabelText;
            reportLine.borderFormatting = selectBorderFormattingData(data);
            reportLine.backgroundColorBinding = data.backgroundColorBinding;
            reportLine.borderColorBinding = data.borderColorBinding;

            var exportFormatting = buildLineExportPropertiesJSON(data);
            if (!$.isEmptyObject(exportFormatting))
            {
                reportLine.exportFormatting = exportFormatting;
            }

            if (data.lineIndex)
            {
                reportLine.lineIndex = data.lineIndex;
            }

            if (data.relatedReportSortId)
            {
                reportLine.relatedReportSortId = data.relatedReportSortId;
            }

            if (data.relatedReportSortID)
            {
                reportLine.relatedReportSortID = data.relatedReportSortID;
            }

            $.extend(reportLine, additionalData);

            return reportLine;
        };

        var buildColumnExportPropertiesJSON = function (data)
        {
            var exportFormatting = {};

            if (data.nodeName)
            {
                exportFormatting.xmlExportFormatting = {};
                exportFormatting.xmlExportFormatting.nodeName = data.nodeName;
            }

            if (data.nodeType)
            {
                exportFormatting.xmlExportFormatting = exportFormatting.xmlExportFormatting || {};
                exportFormatting.xmlExportFormatting.nodeType = data.nodeType;
            }

            if (data.fixedWidthStartPosition)
            {
                exportFormatting.fixedWidthExportFormatting = {};
                exportFormatting.fixedWidthExportFormatting.startPosition = data.fixedWidthStartPosition;
            }

            if (data.fixedWidthLength)
            {
                exportFormatting.fixedWidthExportFormatting = exportFormatting.fixedWidthExportFormatting || {};
                exportFormatting.fixedWidthExportFormatting.length = data.fixedWidthLength;
            }

            if (data.jsonPropertyName)
            {
                exportFormatting.jsonExportFormatting = { name: data.jsonPropertyName };
            }

            return exportFormatting;
        };

        var buildReportColumnCollection = function ($reportColumns, parameters)
        {
            const reportColumns = [];
            parameters = parameters || {};

            $reportColumns.each(function ()
            {
                const self = $(this);
                const data = self.data();
                if (!data)
                {
                    return;
                }

                self.attr('tabindex', self.index());

                const reportColumn = {};
                reportColumn.$type = data.fieldColumnType;
                reportColumn.fieldName = data.fieldName;
                reportColumn.isFutureValue = data.isFutureValue;

                if (data.fieldHeaderText != undefined)
                {
                    reportColumn.headerText = data.fieldHeaderText;
                }

                reportColumn.fieldType = skyward.reporting.reportColumn.getFieldType(data);
                if (data.columnFieldType != undefined)
                {
                    reportColumn.columnFieldType = data.columnFieldType;
                }
                if (data.columnFilterJson)
                {
                    reportColumn.columnFilterJson = typeof (data.columnFilterJson) === "object" ? JSON.stringify(data.columnFilterJson) : data.columnFilterJson;
                }
                reportColumn.isCalculated = data.isCalculated;
                reportColumn.isOperation = data.isOperation;
                reportColumn.isHiddenCondition = data.isHiddenCondition;
                if (data.isHiddenPromptUniqueId != undefined)
                {
                    reportColumn.isHiddenPromptUniqueId = data.isHiddenPromptUniqueId;
                }
                reportColumn.whenHiddenOption = data.whenHiddenOption;
                if (data.pageSectionColumnType != null)
                {
                    reportColumn.pageSectionColumnType = data.pageSectionColumnType;
                    reportColumn.promptUniqueId = data.promptUniqueId;
                    reportColumn.displayType = data.displayType;
                }

                const dataFormatting = serializeFormattingAttributes(data);
                reportColumn.textFormat = dataFormatting.textFormat;

                if (enumMaps.FormatterTypeNames.indexOf((data.formatter || {}).formatterName || "") == -1)
                {
                    reportColumn.formatter = getFormatterDataDefaults();
                }
                else
                {
                    reportColumn.formatter = data.formatter;
                }

                reportColumn.borderFormat = dataFormatting.borderFormat;
                reportColumn.cellFormat = dataFormatting.cellFormat;
                reportColumn.designerText = data.designerText;
                if (data.mediaId)
                {
                    reportColumn.mediaId = parseInt(data.mediaId);
                }
                if (data.useSystemLogo != undefined)
                {
                    reportColumn.useSystemLogo = data.useSystemLogo;
                }
                if (data.aggregateType != undefined)
                {
                    reportColumn.aggregateType = data.aggregateType;
                    reportColumn.aggregateDelimiter = data.aggregateDelimiter;
                    reportColumn.aggregateIndex = data.aggregateIndex;
                }

                reportColumn.dataColumnId = data.dataColumnId;
                reportColumn.columnId = data.columnId;
                reportColumn.positionX = $.safeRound(data.positionX);
                reportColumn.positionY = $.safeRound(data.positionY);
                reportColumn.designerText = data.designerText;
                reportColumn.singleLineIndexRemoved = data.singleLineIndexRemoved;
                reportColumn.displayPath = data.displayPath;
                reportColumn.isRunningTotal = data.isRunningTotal;
                reportColumn.resetOn = data.resetOn;
                reportColumn.absoluteFieldPath = data.absoluteFieldPath;
                reportColumn.styleName = data.styleName;
                reportColumn.backgroundColorBinding = data.backgroundColorBinding;
                reportColumn.foregroundColorBinding = data.foregroundColorBinding;
                reportColumn.borderColorBinding = data.borderColorBinding;

                if (data.variableIdToSet != undefined)
                {
                    reportColumn.variableIdToSet = data.variableIdToSet;
                }
                if (data.variableIdToGet != undefined)
                {
                    reportColumn.variableIdToGet = data.variableIdToGet;
                }
                if (data.sourceColumnId != undefined)
                {
                    reportColumn.sourceColumnId = data.sourceColumnId;
                }

                const exportFormatting = buildColumnExportPropertiesJSON(data);
                if (!$.isEmptyObject(exportFormatting))
                {
                    reportColumn.exportFormatting = exportFormatting;
                }

                if (data.calculationJson)
                {
                    reportColumn.calculation = data.calculationJson;
                }

                if (data.operationId)
                {
                    reportColumn.calculatedField = CalculatedFields_Model.Get(data.operationId);
                }

                if (data.fieldColumnType != COLUMN_TYPES.HEADER_COLUMN)
                {
                    data.parameters.forEach(function (parameter)
                    {
                        skyward.reporting.searchParameters.viewModel.mergeAdd(parameters, parameter);
                    });
                }

                reportColumns.push(reportColumn);
            });

            return reportColumns;
        };

        function serializeFormattingAttributes(data)
        {
            return {
                borderFormat: selectBorderFormattingData(data),
                cellFormat: {
                    rotation: $.safeRound(data.rotation),
                    width: $.safeRound(data.fieldWidth),
                    height: $.safeRound(data.fieldHeight),
                    paddingLeft: $.safeRound(data.paddingLeft),
                    paddingRight: $.safeRound(data.paddingRight),
                    paddingTop: $.safeRound(data.paddingTop),
                    paddingBottom: $.safeRound(data.paddingBottom)
                },
                textFormat: {
                    backColor: data.backColor,
                    textAlignment: data.dataTextAlignment,
                    overlapMode: enumMaps.OverlapModes[data.overlapMode],
                    verticalAlignment: data.verticalAlignment,
                    font: {
                        foreColor: data.dataForeColor,
                        bold: data.dataBold,
                        fontFamily: isBarcodeFormatter(data.formatter) ? BARCODE_FONT_NAME : data.dataFontFamily,
                        italic: data.dataItalic,
                        size: data.dataFontSize,
                        underline: data.dataUnderline,
                    }
                }
            };
        }

        var selectBorderFormattingData = function (data)
        {
            var borderFormattingData = {
                borderStyle: data.borderStyle,
                borderWidth: $.safeRound(data.borderWidth),
                borderRight: data.borderRight == true,
                borderLeft: data.borderLeft == true,
                borderTop: data.borderTop == true,
                borderBottom: data.borderBottom == true,
                borderColor: data.borderColor
            };
            return borderFormattingData;
        };
        //END REPORT SERIALIZATION

        var isReportDirty = function ()
        {
            return changeTracker.isDirty(designer);
        }

        var getReportData = function ()
        {
            const data = designer.data();
            const reportData =
            {
                reportID: data.primaryid,
                reportIDHash: data.primaryidhash
            };
            return reportData;
        }

        //accepts: newfield (either the newly created calculated field object, or an existing calculated field id),
        //         targetLine (the reportLine to insert the column into),
        //         position: (the position object, of which the left is used to place the new columns)
        skyward.reporting.addCalculatedField = function (newField, targetLine, position)
        {
            if (newField.id)
            {
                CalculatedFields_Model.Set(newField);
            }
            else
            {
                newField = CalculatedFields_Model.Get(newField);
            }

            const currentSection = entireCanvas.find('.sectionSelected');

            var sectionDataLines = getSectionDataLines(currentSection);

            targetLine = targetLine || currentRow || sectionDataLines.first();

            var dataLine = targetLine.hasClass('jsDataLine') ? targetLine : sectionDataLines.first();

            var dataColumn;

            var addHeaderColumn = false;
            var addDataColumn = false;
            var addAggregateColumn = false;
            var addSortHeaderColumn = false;
            var addFooterColumn = false;
            var currentRowLineType;

            currentRowLineType = targetLine.data().lineType;
            if (currentRowLineType == LINE_TYPES.FOOTER_LINE)
            {
                addFooterColumn = true;
            }
            if (currentRowLineType == LINE_TYPES.HEADER_LINE)
            {
                addHeaderColumn = true;
            }
            else if (currentRowLineType == LINE_TYPES.DATA_LINE)
            {
                addHeaderColumn = true;
                addDataColumn = true;
            }
            else if (currentRowLineType == LINE_TYPES.SORT_HEADER_LINE)
            {
                addSortHeaderColumn = true;
                if (sectionDataLines.find("[data-operation-id='" + newField.id + "']").length <= 0)
                {
                    addHeaderColumn = true;
                    addDataColumn = true;
                }
            }
            else if (isAggregateLineType(currentRowLineType))
            {
                addAggregateColumn = true;
                if (sectionDataLines.find("[data-operation-id='" + newField.id + "']").length <= 0)
                {
                    addHeaderColumn = true;
                    addDataColumn = true;
                }
            }

            var columnData = { 'operation-id': newField.id, 'field-name': newField.fieldName, 'designer-text': newField.fieldName, 'column-field-type': newField.dataType, 'field-type': newField.dataType };
            var columnAttr = { 'data-operation-id': newField.id, 'data-field-name': newField.fieldName, 'data-designer-text': newField.fieldName, 'data-column-field-type': newField.dataType, 'data-field-type': newField.dataType };

            position = position || { top: null, left: null };
            if (addDataColumn)
            {
                dataColumn = createNewColumn({ type: COLUMN_TYPES.DATA_COLUMN, text: newField.fieldName }).data(columnData).attr(columnAttr);

                // create the data column
                var params = {
                    newItem: dataColumn,
                    reportLine: dataLine,
                    section: currentSection,
                    position: position,
                    autoCreatedColumn: true
                };
                position = insertColumnHelperFunction(params);
            }

            if (addHeaderColumn)
            {
                var targetHeaderLine = !addDataColumn ? targetLine : getCorrespondingHeaderLine(currentSection, dataLine);
                if (targetHeaderLine.length > 0)
                {
                    let headerColumn = createNewColumn(
                        {
                            type: COLUMN_TYPES.HEADER_COLUMN,
                            text: newField.fieldName,
                            relatedItem: dataColumn || null,
                            usesSingleLineIndex: isParentDisplayOnSingleLine(currentSection)
                        });
                    position = insertColumnHelperFunction({
                        newItem: headerColumn,
                        reportLine: targetHeaderLine,
                        section: currentSection,
                        position: position,
                        autoCreatedColumn: true
                    });
                }
            }

            if (addFooterColumn)
            {
                var footerColumn = createNewColumn({ type: COLUMN_TYPES.FOOTER_COLUMN, text: newField.fieldName }).data(columnData).attr(columnAttr);
                position = insertColumnHelperFunction({
                    newItem: footerColumn,
                    reportLine: targetLine,
                    section: currentSection,
                    position: position,
                    autoCreatedColumn: true
                });
            }

            if (addAggregateColumn)
            {
                var aggregateColumn = createNewColumn({ type: COLUMN_TYPES.AGGREGATE_COLUMN, text: newField.fieldName, relatedItem: dataColumn || null }).data(columnData).attr(columnAttr);

                insertColumnHelperFunction({
                    newItem: aggregateColumn,
                    reportLine: targetLine,
                    section: currentSection,
                    position: position,
                    autoCreatedColumn: true
                });
            }

            if (addSortHeaderColumn)
            {
                var sortHeaderColumn = createNewColumn({ type: COLUMN_TYPES.DATA_COLUMN, text: newField.fieldName, relatedItem: dataColumn || null }).data(columnData).attr(columnAttr);

                var params = {
                    newItem: sortHeaderColumn,
                    reportLine: targetLine,
                    section: currentSection,
                    position: position,
                    autoCreatedColumn: true
                };
                position = insertColumnHelperFunction(params);
            }

            updateDesignerSidebarCalculatedFieldList(currentSection.data());
            initDesignerUI(currentSection);
        };

        var getAvailableColumnInfoForAggregateCalculations = function (selectedRow, existingAggregateCalculationColumnID)
        {
            var processedSectionNames = {};
            var processedColumnNames = {};

            function getNameIncrement(collection, name)
            {
                let increment = 0;
                if (collection.hasOwnProperty(name))
                {
                    increment = collection[name] + 1;
                }
                collection[name] = increment;
                return increment;
            }

            function getColumnNameIncrement(name)
            {
                return getNameIncrement(processedColumnNames, name);
            }

            function cleanColumnName(name)
            {
                if (name != null)
                {
                    return name.toString().replace(/\.+$/, '');
                }
                return "";
            }

            const selectedSection = getCurrentSection();

            const allSectionInfo = [];

            //Get the columns from the data lines for all sections
            getCurrentAndDetailSections(selectedSection).each(function ()
            {
                const workingSection = $(this);
                const workingSectionData = workingSection.data();

                const workingSectionInfo = getSectionInfo(workingSectionData, getNameIncrement(processedSectionNames, workingSectionData.displayName));

                getSectionDataLines(workingSection).each(function ()
                {
                    processLine(workingSectionInfo.lines, $(this), workingSectionData);
                });

                getPossibleSourceAggregateLinesForSection(selectedRow, selectedSection, workingSection).each(function ()
                {
                    processLine(workingSectionInfo.lines, $(this), workingSectionData);
                });

                if (workingSection.is(selectedSection))
                {
                    processLine(workingSectionInfo.lines, selectedRow, workingSectionData, true);
                }

                if (workingSectionInfo.lines.length > 0)
                {
                    allSectionInfo.push(workingSectionInfo);
                }
            });

            function getSectionInfo(sectionData, nameIncrement)
            {
                const sectionID = sectionData.sectionId;
                let sectionName = sectionData.displayName;

                if (nameIncrement)
                {
                    sectionName += " (" + nameIncrement + ")"
                }

                const sectionInfo =
                {
                    sectionID: sectionID,
                    name: sectionName,
                    lines: []
                };

                return sectionInfo;
            }

            function processLine(lineCollection, line, workingSectionData, isCurrentLine)
            {
                const lineData = line.data();
                const lineInfo =
                {
                    name: lineData.reportLabelText,
                    columns: []
                };

                getColumnsInLine(line).each(function ()
                {
                    processColumn(lineInfo.columns, workingSectionData, lineData, $(this), isCurrentLine ?? false);
                });

                if (lineInfo.columns.length > 0)
                {
                    lineCollection.push(lineInfo);
                }

                return lineInfo;
            }

            function processColumn(columnCollection, sectionData, lineData, column, isOnCurrentLine)
            {
                let columnData = column.data();

                let supportedAggregateColumnTypes = [COLUMN_TYPES.AGGREGATE_COLUMN, COLUMN_TYPES.CALCULATED_COLUMN, COLUMN_TYPES.DATA_COLUMN];
                let supportedCurrentLineColumnTypes = [COLUMN_TYPES.AGGREGATE_COLUMN, COLUMN_TYPES.CALCULATED_COLUMN, COLUMN_TYPES.FUTURE_VALUE_COLUMN, COLUMN_TYPES.VARIABLE_COLUMN, COLUMN_TYPES.TEXT_COLUMN];

                if (!existingAggregateCalculationColumnID || columnData.columnId !== existingAggregateCalculationColumnID)
                {
                    let isValidForAggregateMath = false;

                    let isTextColumn = columnData.fieldColumnType === COLUMN_TYPES.TEXT_COLUMN;
                    let columnDataType = isTextColumn && skyward.extensions.isNumeric(columnData.designerText) ? DATA_TYPES.NUMBER_DECIMAL : skyward.reporting.reportColumn.getFieldType(columnData);

                    if (isOnCurrentLine)
                    {
                        if (supportedCurrentLineColumnTypes.includes(columnData.fieldColumnType))
                        {
                            let columnIsNumeric = columnDataType && columnDataType.startsWith("Number");
                            let columnIsString = columnDataType && columnDataType.startsWith(DATA_TYPES.STRING);

                            isValidForAggregateMath = isTextColumn ? columnIsNumeric : (columnIsNumeric || columnIsString);
                        }
                    }
                    else if (supportedAggregateColumnTypes.includes(columnData.fieldColumnType))
                    {
                        isValidForAggregateMath = !columnData.isFutureValue;
                    }

                    if (isValidForAggregateMath)
                    {
                        let columnName = cleanColumnName(getColumnLabelWithPreText(column));

                        let nameIncrement = getColumnNameIncrement(`${columnName}_${lineData.lineId}_${sectionData.sectionId}`);

                        if (nameIncrement)
                        {
                            columnName += " (" + nameIncrement + ")"
                        }

                        if (!columnDataType)
                        {
                            const exception = new window.SkywardException("Column has undefined data type.", `Column: '${columnName}', Section: '${sectionData.displayName}'`);
                            skyward.error.reportException(exception);
                            return;
                        }

                        let columnInfo =
                        {
                            isOnCurrentLine: isOnCurrentLine,
                            columnID: columnData.columnId,
                            binding: columnData.bindingString,
                            name: columnName,
                            dataType: columnDataType,
                            isFutureValue: columnData.isFutureValue
                        };
                        columnCollection.push(columnInfo);
                    }
                }
            }

            return allSectionInfo;
        };

        var getCalculatedColumnBuilder = function (data, clickedElement)
        {
            if (!clickedElement.hasClass("editorColumnText"))
            {
                const closestSection = clickedElement.closest('.jsSection');
                setActiveSection(closestSection);
            }

            const selectedSection = getCurrentSection();
            const selectedRow = getSectionSelectedRow(selectedSection);
            let existingAggregateCalculationColumnID = data.columnId;
            const allSectionInfo = getAvailableColumnInfoForAggregateCalculations(selectedRow, existingAggregateCalculationColumnID);

            var postedData =
            {
                name: skyward.extensions.encodeHtml(data.fieldName),
                expression: data.calculation,
                allSectionInfo: skyward.extensions.encodeHtml(JSON.stringify(allSectionInfo)),
            };

            var popup;
            var url = skyward.global.virtualDir + "Reporting/Report/GetAggregateCalculationBuilder";
            $.ajax({
                type: "POST",
                dataType: "JSON",
                url: url,
                data: postedData,
                success: function (popupData)
                {
                    var okButton = { text: "Save", click: saveCalculatedColumn, additionalClasses: "okButton", icon: "Save" };
                    var cancelButton = { text: "Cancel", icon: "Cancel" };
                    popup = skyward.modalLayer.showDialog("Aggregate Calculations", popupData.html, [okButton, cancelButton], {
                        closeOnClick: false,
                        automationID: "aggregate-calculation-builder-dialog"
                    });
                    popup.bodyPromise.done(function ()
                    {
                        if (popupData.errors && !jQuery.isEmptyObject(popupData.errors))
                        {
                            skyward.validation.displayValidationMessages({ errors: popupData.errors }, popup.container, $());
                        }
                    });
                }
            });

            var saveCalculatedColumn = function ()
            {
                var currentSection = entireCanvas.find(".sectionSelected");
                var sectionID = currentSection.data("sectionId");

                var aggregateLine = currentRow || getSectionSelectedRow(currentSection);
                var lineID = aggregateLine.data("lineId");

                skyward.reporting.aggregateCalculationBuilder.validateAndGetValues(popup.container, existingAggregateCalculationColumnID, sectionID, lineID, allSectionInfo).then(function (valuesFromPopup)
                {
                    if (valuesFromPopup.isValid)
                    {
                        const name = valuesFromPopup.name;
                        const expression = valuesFromPopup.expression;
                        const displayExpression = valuesFromPopup.displayExpression;
                        const calculationJson = valuesFromPopup.calculationJson;
                        const isFutureValue = valuesFromPopup.isFutureValue;
                        const fieldType = valuesFromPopup.fieldType;

                        var columnData = {
                            displayCalculation: displayExpression,
                            calculation: expression,
                            calculationJson: calculationJson,
                            designerText: name,
                            isFutureValue: isFutureValue,
                            fieldType: fieldType
                        };
                        var columnAttr = {
                            "data-display-calculation": displayExpression,
                            "data-calculation": expression,
                            "data-designer-text": name,
                            "is-future-value": isFutureValue
                        };
                        var calculatedColumn;
                        if (existingAggregateCalculationColumnID)
                        {
                            calculatedColumn = entireCanvas.find("[data-column-id='" + existingAggregateCalculationColumnID + "']");
                            calculatedColumn.find(".column_content").text(name);
                            calculatedColumn.data(columnData).attr(columnAttr);
                        }
                        else
                        {
                            calculatedColumn = createNewColumn({ type: COLUMN_TYPES.CALCULATED_COLUMN, text: name }).data(columnData).attr(columnAttr);
                            existingAggregateCalculationColumnID = calculatedColumn.data().columnId;

                            var params = {
                                newItem: calculatedColumn,
                                reportLine: aggregateLine,
                                section: currentSection,
                                position: { top: null, left: null },
                                autoCreatedColumn: true
                            };
                            insertColumnHelperFunction(params);
                        }

                        skyward.reporting.aggregateCalculationCollection.add(existingAggregateCalculationColumnID, expression, name, sectionID, lineID);
                        updateHiddenField();
                        editorColumnText.val(displayExpression);
                        skyward.reporting.updateVariableUsageLocations();
                        popup.close();
                    }
                });
            };
        };

        var applyCellFormatToItem = function (item, cellFormat)
        {
            var itemData = item.data();
            if (!itemData.fieldWidth)
            {
                item.data('fieldWidth', cellFormat.Width);
            }

            if (!itemData.fieldHeight || itemData.fieldColumnType === COLUMN_TYPES.HEADER_COLUMN)
            {
                item.data('fieldHeight', cellFormat.Height);
            }

            // image and dynamic image columns should not have any padding
            if (itemData.fieldColumnType !== COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN && itemData.fieldColumnType !== COLUMN_TYPES.IMAGE_COLUMN)
            {
                item.data('paddingLeft', cellFormat.PaddingLeft);
                item.data('paddingRight', cellFormat.PaddingRight);
                item.data('paddingTop', cellFormat.PaddingTop);
                item.data('paddingBottom', cellFormat.PaddingBottom);
            }
        };

        var applyBorderFormatToItem = function (item, borderFormat)
        {
            item.data('borderStyle', borderFormat.BorderStyle);
            item.data('borderWidth', borderFormat.BorderWidth);
            item.data('borderRight', borderFormat.BorderRight);
            item.data('borderLeft', borderFormat.BorderLeft);
            item.data('borderTop', borderFormat.BorderTop);
            item.data('borderBottom', borderFormat.BorderBottom);
            item.data('borderColor', borderFormat.BorderColor);
        };

        var applyTextFormatToItem = function (item, textFormat)
        {
            item.data('dataFontFamily', textFormat.Font.FontFamily);
            item.data('dataBold', textFormat.Font.Bold);
            item.data('dataItalic', textFormat.Font.Italic);
            item.data('dataForeColor', textFormat.Font.ForeColor);
            item.data('dataTextFormat', textFormat.TextFormat);
            item.data('dataFontSize', textFormat.Font.Size);
            item.data('dataUnderline', textFormat.Font.Underline);
            item.data('backColor', textFormat.BackColor);
            item.data('verticalAlignment', textFormat.VerticalAlignment);
        };

        var getColumnLabelWithPreTextByColumnID = function (columnID)
        {
            var column = getSectionAllColumns(getCurrentSection()).filter('[data-column-id="' + columnID + '"]');
            return column.length ? getColumnLabelWithPreText(column) : "Column Not Found";
        };

        var getColumnLabelWithPreText = function (column)
        {
            const columnData = column.data();
            if (columnData.fieldColumnType === COLUMN_TYPES.TEXT_COLUMN ||
                columnData.fieldColumnType === COLUMN_TYPES.IMAGE_COLUMN ||
                columnData.fieldColumnType === COLUMN_TYPES.CALCULATED_COLUMN)
            {
                return columnData.designerText;
            }
            else if (columnData.fieldColumnType === COLUMN_TYPES.FORMTEXT_COLUMN)
            {
                let friendlyText = skyward.reporting.prompts.promptCollection.ConvertPromptBindingsToFriendlyNames(columnData.designerText);
                friendlyText = skyward.reporting.calculatedFields.ConvertBindingsToFriendlyNames(friendlyText);
                return friendlyText;
            }

            if (columnData.fieldColumnType == COLUMN_TYPES.VARIABLE_COLUMN)
            {
                const variableToGet = skyward.reporting.variables.collectionModel.getById(columnData.variableIdToGet) || {};
                return "Variable: " + variableToGet.name;
            }

            if (columnData.fieldColumnType == COLUMN_TYPES.FUTURE_VALUE_COLUMN)
            {
                return `Future ${getColumnLabelWithPreText(getColumnByID(columnData.sourceColumnId))}`;
            }

            const line = column.parent();
            const reportRowType = line.data('lineType');
            let preText;
            const isPageSectionColumnLabel = columnData.fieldColumnType == COLUMN_TYPES.PAGE_SECTION_COLUMN && columnData.displayType === PAGE_SECTION_COLUMN_DISPLAY_TYPES.LABEL;

            if (!isPageSectionColumnLabel && !line.hasClass("jsPrintOnOneLinePreviewLine"))
            {
                if (reportRowType === LINE_TYPES.SORT_HEADER_LINE)
                {
                    if (columnData.fieldColumnType == COLUMN_TYPES.GROUP_COLUMN_HEADER)
                    {
                        preText = "Header As Label";
                    }
                    else
                    {
                        preText = "Next Record Value";
                    }
                }
                else if (isAggregateLineType(reportRowType) ||
                    ((columnData.fieldColumnType == COLUMN_TYPES.AGGREGATE_COLUMN || columnData.fieldColumnType == COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN) &&
                        reportRowType === LINE_TYPES.FOOTER_LINE))
                {
                    if (columnData.aggregateType)
                    {
                        preText = columnData.aggregateType.toDisplayName();
                    }
                    else
                    {
                        preText = "Last Record Value";
                    }
                }
                else if (columnData.fieldColumnType == COLUMN_TYPES.PAGE_SECTION_COLUMN)
                {
                    if (!isPromptColumn(columnData))
                    {
                        preText = "Value";
                    }
                    else
                    {
                        preText = columnData.displayType == PAGE_SECTION_COLUMN_DISPLAY_TYPES.PROMPT_VALUE ? "Value" : "Display Value";
                    }
                }
            }

            if (preText)
            {
                return preText + ': ' + columnData.designerText;
            }

            return columnData.designerText;
        };

        function selectFieldDialog(button, moduleName, objectName, options)
        {
            button = $(button);
            if (skyward.buttonManager.isElementDisabled(button))
            {
                return;
            }

            var defaultOptions =
            {
                title: "Field Select",
                isValidSelection: function (selection) { return selection && selection.relationshipType === undefined; },
                treeBrowseOptions: {}
            };
            options = $.extend({}, defaultOptions, options || {});

            var treeBrowseDiv = $();
            var resultsDeferred = $.Deferred();
            $.ajax(skyward.global.virtualDir + "Reporting/Report/GetSelectFieldDialog",
                {
                    type: "POST",
                    dataType: "JSON",
                    data: { moduleName: moduleName, objectName: objectName },
                    success: function (data)
                    {
                        var layerClosed = function (resultData)
                        {
                            // ModalLayer sets resultData differently depending on how it was closed: resultData is false if glass was clicked.
                            // Otherwise, resultData.reasonForClose is an event object when cancel was clicked, or treebrowse data (always includes dataObjectFullName) when Ok was clicked.
                            if (!resultData || (resultData.reasonForClose && !resultData.reasonForClose.dataObjectFullName))
                            {
                                resultsDeferred.reject();
                            }

                            // afterClose was replaced with layerClosed, call it if it was defined.
                            if (options.modalLayerOptions && typeof options.modalLayerOptions.afterClose === "function")
                            {
                                options.modalLayerOptions.afterClose(resultData);
                            }
                        };

                        var saveField = function ()
                        {
                            const itemData = skyward.treebrowse.getSelectedFieldData(treeBrowseDiv);
                            const treeBrowseData = skyward.treebrowse.getTreeBrowseData(treeBrowseDiv);

                            if (!options.isValidSelection(itemData))
                            {
                                dialog.close(false);
                            }

                            dialog.close(itemData);

                            const moduleObjectData =
                            {
                                dataObjectFullName: treeBrowseData.dataObjectFullName,
                                fieldModule: treeBrowseData.rootModule,
                                fieldObject: treeBrowseData.rootObject
                            };
                            resultsDeferred.resolve(itemData, moduleObjectData);
                        };

                        // launch the field select pop-up
                        var modalLayerOptions = $.extend({ anchorTo: button }, options.modalLayerOptions, { afterClose: layerClosed, closeOnClick: false, automationID: "field-select" }); // Always use locally defined afterClose
                        var buttons = [{ text: "Select", icon: "Select", click: saveField }, { text: "Cancel", icon: "Cancel" }];
                        var dialog = skyward.modalLayer.showDialog(options.title, data.html, buttons, modalLayerOptions);

                        dialog.bodyPromise.done(function ()
                        {
                            var cancelButton = dialog.footer.find("button[title='Cancel']");
                            var selectButton = dialog.footer.find("button[title='Select']");
                            selectButton.addClass("ui-disabled");

                            var moduleObjectSelector = dialog.content.find('.moduleObjectSelector');
                            moduleObjectSelector.on('treeBrowseSave', saveField);

                            var moduleCodeEEL = moduleObjectSelector.find('.moduleEEL');
                            moduleCodeEEL.on('change', clearTreeBrowse);

                            var objectCodeEEL = moduleObjectSelector.find('.objectEEL');
                            objectCodeEEL.on('change', function () { clearTreeBrowse(); populateTreeBrowse(); });

                            selectRow(null);
                            if (objectCodeEEL.val())
                            {
                                populateTreeBrowse();
                            }

                            function populateTreeBrowse()
                            {
                                var objValue = objectCodeEEL.val();
                                if (objValue)
                                {
                                    $.ajax(skyward.global.virtualDir + "Reporting/Report/GetSelectFieldList",
                                        {
                                            type: "POST",
                                            dataType: "JSON",
                                            data: $.extend({}, options.treeBrowseOptions,
                                                {
                                                    lookupObject: objValue,
                                                    expandUrl: "Reporting/Report/ExpandTreeBrowse"
                                                }),
                                        })
                                        .then(function (treeBrowseData)
                                        {
                                            skyward.global.processViewPartHtml(treeBrowseData.html)
                                                .then(function (html)
                                                {
                                                    moduleObjectSelector.append(html);
                                                    skyward.window.notifyDOMLoad("#" + dialog.container.attr('id'));
                                                    treeBrowseDiv = moduleObjectSelector.find(".treeBrowse");

                                                    dialog.content.on("treeBrowseRowChange", function (event, treeBrowseData)
                                                    {
                                                        selectRow(treeBrowseData.getSelectedFieldData());
                                                    });
                                                });
                                        });
                                }
                            }

                            function clearTreeBrowse()
                            {
                                // Delete parameters for seek-to-field, which is only valid when popup is first opened.
                                delete options.treeBrowseOptions.fieldModule;
                                delete options.treeBrowseOptions.fieldObject;
                                delete options.treeBrowseOptions.positionObjectPath;
                                delete options.treeBrowseOptions.lookupModule;
                                delete options.treeBrowseOptions.lookupObject;
                                delete options.treeBrowseOptions.seekField;

                                treeBrowseDiv.remove();
                                treeBrowseDiv = $();
                                selectRow(null);
                            }

                            function selectRow(rowData)
                            {
                                if (options.isValidSelection(rowData))
                                {
                                    selectButton.removeClass("ui-disabled");
                                }
                                else
                                {
                                    selectButton.addClass("ui-disabled");
                                    if (selectButton.is(":focus"))
                                    {
                                        cancelButton.focus();
                                    }
                                }
                            }
                        });
                    }
                });

            return resultsDeferred.promise();
        }

        skyward.reporting.prompts = (function ()
        {
            var promptCollection = skyward.mvvm.newModelCollection([], {}, {}, function ()
            {
                var self = this;

                var snapShot = [];

                var pendingPromptUsages = [];
                var pendingRequiredPromptUsages = [];

                function findByUniqueId(prompt, uniqueId) { return prompt.PromptUniqueId == uniqueId; }

                // exposed methods
                var exposedMethods =
                {
                    Get: function (uniqueId)
                    {
                        return self.find(findByUniqueId, uniqueId);
                    },
                    Set: function (promptData)
                    {
                        // This always creates a NEW model - If you pass an existing model into Set(), previously active observers
                        //  will NOT be observing the model that was created in the collection! (ask Matt about being here at 9PM on a Thursday)
                        var promptModel = self.find(findByUniqueId, promptData.PromptUniqueId);

                        if (!promptModel)
                        {
                            promptModel = buildPrompt_Model(promptData);
                            self.add(promptModel);
                        }
                        else
                        {
                            for (var field in promptData)
                            {
                                promptModel[field] = promptData[field];
                            }
                        }
                        self.announce("add", promptModel);
                        return promptModel;
                    },
                    Delete: function (uniqueId)
                    {
                        var deletedPrompt = self.remove(self.Get(uniqueId));
                        if (deletedPrompt)
                        {
                            self.forEach(function (promptModel)
                            {
                                if (deletedPrompt.usesPrompt(promptModel))
                                {
                                    promptModel.refreshInUse();
                                }
                            });

                            self.announce("delete", deletedPrompt);
                        }
                    },
                    toJsonObject: function ()
                    {
                        var allPrompts = [];
                        self.forEach(function (prompt)
                        {
                            allPrompts.push(prompt.toJsonObject());
                        });
                        return allPrompts;
                    },
                    toJsonString: function ()
                    {
                        return skyward.extensions.encodeHtml(JSON.stringify(skyward.reporting.prompts.promptCollection.toJsonObject()));
                    },
                    TakeSnapshot: function ()
                    {
                        snapShot = [];
                        self.toJsonObject().forEach(function (prompt)
                        {
                            snapShot.push($.extend({}, prompt));
                        });
                    },
                    Revert: function ()
                    {
                        snapShot.forEach(function (prompt)
                        {
                            self.Set(prompt);
                        });
                        self.forEach(function (prompt)
                        {
                            if (!snapShot.some(function (snapShotPrompt) { return snapShotPrompt.PromptUniqueId === prompt.PromptUniqueId; }))
                            {
                                self.Delete(prompt.PromptUniqueId);
                            }
                        });
                        snapShot = [];
                    },
                    GetInUsePromptUniqueIds: function ()
                    {
                        var inUsePromptUniqueIds = [].concat(pendingPromptUsages).concat(pendingRequiredPromptUsages);

                        self.forEach(function (prompt)
                        {
                            prompt.refreshInUse();
                            if (prompt.InUse)
                            {
                                inUsePromptUniqueIds.push(prompt.PromptUniqueId);
                            }
                        });

                        return inUsePromptUniqueIds;
                    },
                    RefreshAllPromptsInUse: function ()
                    {
                        self.forEach(function (prompt)
                        {
                            prompt.refreshInUse(self);
                        });

                        self.forEach(function (prompt)
                        {
                            if (prompt.LinkedPromptUniqueId && promptCollection.Get(prompt.LinkedPromptUniqueId).InUse === true)
                            {
                                prompt.InUse = true;
                            }
                        });
                    },
                    AddTemporaryInUseFlag: function (promptModel)
                    {
                        if (pendingPromptUsages.indexOf(promptModel.PromptUniqueId) == -1)
                        {
                            pendingPromptUsages.push(promptModel.PromptUniqueId);
                        }
                        self.RefreshAllPromptsInUse();
                    },
                    AddTemporaryInUseRequiredFlag: function (promptModel)
                    {
                        if (pendingRequiredPromptUsages.indexOf(promptModel.PromptUniqueId) == -1)
                        {
                            pendingRequiredPromptUsages.push(promptModel.PromptUniqueId);
                        }
                        self.RefreshAllPromptsInUse();
                    },
                    RemoveAllTemporaryInUseFlags: function (promptModel)
                    {
                        var index = pendingPromptUsages.indexOf(promptModel.PromptUniqueId);
                        if (index != -1)
                        {
                            pendingPromptUsages.splice(index, 1);
                        }
                        var requiredIndex = pendingRequiredPromptUsages.indexOf(promptModel.PromptUniqueId);
                        if (requiredIndex != -1)
                        {
                            pendingRequiredPromptUsages.splice(requiredIndex, 1);
                        }
                        self.RefreshAllPromptsInUse();
                    },
                    IsFlaggedForUse: function (promptModel)
                    {
                        return pendingPromptUsages.indexOf(promptModel.PromptUniqueId) >= 0;
                    },
                    IsFlaggedForRequiredUse: function (promptModel)
                    {
                        return pendingRequiredPromptUsages.indexOf(promptModel.PromptUniqueId) >= 0;
                    },
                    PromptsIsDirty: function ()
                    {
                        if (snapShot.length === self.toJsonObject().length)
                        {
                            return self.isDirty();
                        }
                        return true;
                    },
                    GetLinkablePrompts: function (promptModel)
                    {
                        var linkablePrompts = [];
                        if (promptModel.InputType !== DATA_TYPES.BOOLEAN && promptModel.Type !== enumMaps.PromptTypes["ReportSort"]
                            && (promptModel.Type === enumMaps.PromptTypes["Value"] || promptModel.Type === enumMaps.PromptTypes["SingleSelect"]))
                        {
                            self.forEach(function (prompt)
                            {
                                if (prompt.InputType === promptModel.InputType
                                    && (prompt.Type === enumMaps.PromptTypes["Value"] || prompt.Type === enumMaps.PromptTypes["SingleSelect"])
                                    && !prompt.LinkedPromptUniqueId
                                    && prompt.PromptUniqueId !== promptModel.PromptUniqueId
                                    && (prompt.IsHiddenCondition == null || prompt.IsHiddenCondition.LeftOperand.PromptUniqueID !== promptModel.PromptUniqueId))
                                {
                                    linkablePrompts.push(prompt);
                                }
                            });
                        }

                        return linkablePrompts;
                    },
                    ///<summary>
                    /// Converts a string containing references to prompt bindings (i.e. {_prompt.GuidGuidGuid})
                    /// into a string containing "friendly prompt-bindings" (i.e. {P:Label}).
                    ///</summary>
                    ///<parameter name="data">the string to convert</parameter>
                    ///<returns>If passed-in data is invalid, an empty string is returned</returns>
                    ConvertPromptBindingsToFriendlyNames: function (data)
                    {
                        if (typeof data !== "string")
                        {
                            return "";
                        }

                        var result = data;
                        skyward.reporting.prompts.promptCollection.forEach(function (prompt)
                        {
                            if (prompt.hasUniqueLabel())
                            {
                                result = result.split(prompt.bindingString()).join("{P:" + prompt.Label + "}");
                            }
                        });
                        return result;
                    },
                    ConvertFriendlyNamesToPromptBindings: function (data)
                    {
                        if (typeof data !== "string")
                        {
                            return "";
                        }

                        var result = data;
                        skyward.reporting.prompts.promptCollection.forEach(function (prompt)
                        {
                            if (prompt.hasUniqueLabel())
                            {
                                result = result.split("{P:" + prompt.Label + "}").join(prompt.bindingString());
                            }
                        });
                        return result;
                    }
                };

                var _observer = skyward.mvvm.newObserver();
                _observer.observe(self, "model:FiltersJson", function (model)
                {
                    self.forEach(function (promptModel)
                    {
                        if (promptModel.PromptUniqueId != model.PromptUniqueId)
                        {
                            promptModel.refreshInUse(self);
                        }
                    });
                });
                _observer.observe(skyward.reporting.searchParameters.model, "model:value", exposedMethods.RefreshAllPromptsInUse);

                return exposedMethods;
            });

            var importPrompts = function (promptsJson)
            {
                $.each(promptsJson, function ()
                {
                    promptCollection.Set(this);
                });

                promptCollection.RefreshAllPromptsInUse();
            };

            var buildPrompt_Model = function (promptData)
            {
                // blank fields allow mvvm to make get/sets for everything, regardless of what is populated in a particular instance.
                var defaultValues = {
                    PromptUniqueId: undefined,
                    PromptGuid: undefined,
                    Label: undefined,
                    Type: enumMaps.PromptTypes.Value,
                    Value: undefined,
                    PrefillPrompt: true,
                    FieldPath: undefined,
                    FiltersJson: undefined,
                    Columns: undefined,
                    Sorts: undefined,
                    PresenceType: "Required",
                    InUse: undefined,
                    Order: (promptCollection ? promptCollection.length : 0),
                    InputType: DATA_TYPES.STRING,
                    DisplayValueOverrides: {},
                    LinkedPromptUniqueId: undefined,
                    LinkedPromptGuid: undefined,
                    Module: undefined,
                    Object: undefined,
                    RelativeFieldPath: undefined,
                    StandardFilterId: undefined,
                    StandardFilterName: undefined,
                    HiddenCondition: undefined,
                    SelectionOptions: buildInitialSelectionOptions()
                };

                // Legacy code contained a misspelling: "DistinctMultiSelect" in some places, "DistinctMultiselect" in others.
                // This keeps the problem from breaking legacy reports after a change to a DMSE:
                if (promptData.DistinctMultiselectEelViews)
                {
                    promptData.Columns = promptData.DistinctMultiselectEelViews;
                    delete promptData.DistinctMultiselectEelViews;
                }
                if (promptData.DistinctMultiselectEelSorts)
                {
                    promptData.Sorts = promptData.DistinctMultiselectEelSorts;
                    delete promptData.DistinctMultiselectEelSorts;
                }


                promptData = $.extend(defaultValues, promptData);

                return skyward.mvvm.newModel(promptData, undefined, function ()
                {
                    var self = this;

                    const placesToSearch = usageLocations.promptPlacesToSearch(this);

                    var snapshot = {};

                    var exposedMethods = {
                        toJsonObject: function ()
                        {
                            var result = {};
                            for (var key in defaultValues)
                            {
                                result[key] = self[key];
                            }
                            return result;
                        },
                        toJsonString: function ()
                        {
                            return skyward.extensions.encodeHtml(JSON.stringify(exposedMethods.toJsonObject()));
                        },
                        takeSnapshot: function ()
                        {
                            snapshot = exposedMethods.toJsonObject();
                        },
                        revert: function ()
                        {
                            for (var prop in snapshot)
                            {
                                self[prop] = snapshot[prop];
                            }
                            snapshot = {};
                        },
                        usesPrompt: function (otherPrompt)
                        {
                            const filterContainsPrompt = (self.FiltersJson || "").indexOf(otherPrompt.PromptUniqueId) >= 0;
                            const hiddenConditionContainsPrompt = self.HiddenCondition != null && self.HiddenCondition.LeftOperand.PromptUniqueID == otherPrompt.PromptUniqueId;
                            return filterContainsPrompt || hiddenConditionContainsPrompt;
                        },
                        isRequired: function (promptsModel)
                        {
                            return this.getUsages(promptsModel, ((node) => node.isRequired())).length > 0 || promptCollection.IsFlaggedForRequiredUse(self);
                        },
                        refreshInUse: function (promptsModel)
                        {
                            self.InUse = this.getUsages(promptsModel).length > 0 || promptCollection.IsFlaggedForUse(self) || promptCollection.IsFlaggedForRequiredUse(self);
                        },
                        getUsages: function (promptsModel, predicate)
                        {
                            placesToSearch.setModel(self);
                            return placesToSearch.traverse(promptsModel || promptCollection, predicate);
                        },
                        bindingString: function ()
                        {
                            return "{_prompt." + self.PromptUniqueId + "}";
                        },
                        getIconType: function ()
                        {
                            return skyward.reporting.getSvgNameByDataType(self.InputType);
                        },
                        hasUniqueLabel: function ()
                        {
                            return !promptCollection.some(function (p)
                            {
                                return p.PromptUniqueId != self.PromptUniqueId && p.Label.trim().toLowerCase() == self.Label.trim().toLowerCase();
                            });
                        },
                        getSelectionOptionDisplayValueByKey: function (key)
                        {
                            const keyComparisonValue = key.toString();
                            for (const option of self.SelectionOptions)
                            {
                                if (option[0] === keyComparisonValue)
                                {
                                    return option[1];
                                }
                            }

                            return undefined;
                        },
                        addTemporaryParameter: function (parameter)
                        {
                            self.tempRelatedSearchParameter = parameter;
                        },
                        removeTemporaryParameter: function ()
                        {
                            self.tempRelatedSearchParameter = undefined;
                        }
                    };

                    return exposedMethods;
                });
            };

            var buildInitialSelectionOptions = function ()
            {
                return [];
            };

            var addPromptEvents = skyward.mvvm.newObservable();
            var getPromptDetailsView = function (promptData, options, existingPromptUniqueId)
            {
                var defaultOptions = {
                    treatPromptAsInUse: false,
                    treatPromptAsInUseRequired: false,
                    tempRelatedSearchParameter: undefined,
                    preserveFocus: true
                };
                options = $.extend(defaultOptions, options);

                var promptModel;
                if (existingPromptUniqueId && existingPromptUniqueId.length)
                {
                    promptModel = promptCollection.Get(existingPromptUniqueId);
                }
                else
                {
                    promptModel = buildPrompt_Model(promptData || {});
                }

                var waitForSave_Deferred = $.Deferred();

                $.ajax(skyward.global.virtualDir + "Reporting/Report/GetPromptDetails",
                    {
                        type: "POST",
                        dataType: "JSON",
                        data: { promptJson: promptModel.toJsonString() },
                        success: function (ajaxResult)
                        {
                            var promptView;

                            for (var field in ajaxResult.model)
                            {
                                promptModel[field] = ajaxResult.model[field];
                            }

                            if (options.treatPromptAsInUseRequired)
                            {
                                promptCollection.AddTemporaryInUseRequiredFlag(promptModel);
                                promptModel.refreshInUse();
                                waitForSave_Deferred.always(function () { promptCollection.RemoveAllTemporaryInUseFlags(promptModel); });
                            }
                            else if (options.treatPromptAsInUse)
                            {
                                promptCollection.AddTemporaryInUseFlag(promptModel);
                                promptModel.refreshInUse();
                                waitForSave_Deferred.always(function () { promptCollection.RemoveAllTemporaryInUseFlags(promptModel); });
                            }

                            if (options.tempRelatedSearchParameter)
                            {
                                promptModel.addTemporaryParameter(options.tempRelatedSearchParameter);
                                waitForSave_Deferred.always(function () { promptModel.removeTemporaryParameter(); });
                            }

                            var promptHtml = $(ajaxResult.html);
                            var deferredBeforeShowContent = $.Deferred();
                            var addPromptDialog = skyward.modalLayer.showDialog("Add Prompt", $("<ul>").append(promptHtml),
                                [
                                    { text: "Save", click: saveClick, icon: "Save" },
                                    { text: "Cancel", icon: "Cancel", click: cancelAndClose }
                                ],
                                {
                                    closeOnClick: false,
                                    afterClose: function ()
                                    {
                                        promptView.dispose();
                                    },
                                    draggable: true,
                                    beforeShowContentPromise: deferredBeforeShowContent.promise(),
                                    automationID: "add-prompt-dialog",
                                    preserveFocus: true
                                });

                            addPromptDialog.bodyPromise.done(function ()
                            {
                                promptModel.takeSnapshot();
                                promptView = initPromptViewModel(addPromptDialog, promptModel);
                                deferredBeforeShowContent.resolve();
                            });

                            var validate = function (errors)
                            {
                                const isEnumPrompt = promptModel.InputType?.startsWith("String Enum") ?? false;
                                const isCustomSingleValuePrompt = promptModel.Type === enumMaps.PromptTypes.CustomSingleSelect;
                                const isSingleSelectPrompt = promptModel.Type === enumMaps.PromptTypes.SingleSelect;
                                const isMultipleSelectPrompt = promptModel.Type === enumMaps.PromptTypes.MultipleSelect

                                if (!promptModel.Label || !promptModel.Label.trim())
                                {
                                    errors["promptLabel"] = ["Label is a required field."];
                                }
                                else if (!promptModel.hasUniqueLabel())
                                {
                                    errors["promptLabel"] = ["Label must be unique."];
                                }

                                if (!isEnumPrompt && !promptModel.FieldPath && (isSingleSelectPrompt || isMultipleSelectPrompt))
                                {
                                    errors["promptField"] = ["Field is a required field for single and multiple select prompts."];
                                }

                                if (promptModel.Type === enumMaps.PromptTypes.UserInstructions && promptModel.Value.trim() === "")
                                {
                                    errors["userInstructions"] = ["Text to Display is a required field for user instructions."];
                                }

                                if (!isEnumPrompt && (isSingleSelectPrompt || isMultipleSelectPrompt) && (!Boolean(promptModel.Columns)))
                                {
                                    errors["Columns"] = ["Fields to display is a required field for single and multiple select prompts."];
                                }

                                if (!isEnumPrompt && isCustomSingleValuePrompt && promptModel.SelectionOptions.length === 0)
                                {
                                    errors["SelectionOptions"] = ["Selection Options is a required field."];
                                }

                                if (!$.isEmptyObject(errors))
                                {
                                    skyward.validation.displayValidationMessages({ errors: errors }, addPromptDialog.content, $());
                                    return false;
                                }
                                return true;
                            };

                            var saveAndClose = function ()
                            {
                                if (promptCollection.Get(promptModel.PromptUniqueId))
                                {
                                    promptCollection.Set(promptModel);
                                }
                                else
                                {
                                    waitForSave_Deferred.resolve({ promptHtml: promptHtml, promptModel: promptModel });
                                    addPromptEvents.announce("newPrompt", { promptHtml: promptHtml, promptModel: promptModel });
                                }
                                addPromptDialog.close();
                                if (options.dialog)
                                {
                                    options.dialog.animateModalContents();
                                }
                            };

                            function saveClick()
                            {
                                $.ajax(skyward.global.virtualDir + "Reporting/Report/ValidatePrompt",
                                    {
                                        type: "POST",
                                        dataType: "JSON",
                                        data:
                                        {
                                            promptJson: promptModel.toJsonString(),
                                            promptCollectionJson: promptCollection.toJsonString()
                                        },
                                        success: function (results)
                                        {
                                            if (validate(results))
                                            {
                                                saveAndClose();
                                            }
                                        }
                                    });
                            }

                            function cancelAndClose()
                            {
                                promptModel.revert();
                                waitForSave_Deferred.reject();
                                addPromptDialog.close();
                            }
                        },
                        error: waitForSave_Deferred.reject
                    });

                waitForSave_Deferred.done(function (data)
                {
                    promptCollection.add(data.promptModel);
                });

                return waitForSave_Deferred;
            };

            var getPromptLinkView = skyward.reporting.linkPrompt = function (selectedPromptUniqueId, promptManager)
            {
                var promptModel = promptCollection.Get(selectedPromptUniqueId);

                $.ajax(skyward.global.virtualDir + "Reporting/Report/GetPromptsLinkView",
                    {
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            promptJson: promptModel.toJsonString(),
                            linkablePromptsJson: skyward.extensions.encodeHtml(JSON.stringify(promptCollection.GetLinkablePrompts(promptModel)))
                        },
                        success: function (ajaxResult)
                        {
                            var promptsLinkView;

                            var promptHtml = $(ajaxResult.html);
                            var linkPromptsDialog = skyward.modalLayer.showDialog("Link Prompts", promptHtml,
                                [
                                    { text: "Save", "click": saveAndClose, "icon": "Check" },
                                    { text: "Cancel", "icon": "Cancel", "click": cancelAndClose }
                                ],
                                {
                                    preserveFocus: true,
                                    closeOnClick: false,
                                    afterClose: function ()
                                    {
                                        promptsLinkView.dispose();
                                    },
                                    draggable: true
                                });

                            linkPromptsDialog.bodyPromise.done(function ()
                            {
                                //this should probably be a different view, but it works for now
                                promptsLinkView = initPromptViewModel(linkPromptsDialog, promptModel);
                            });


                            function saveAndClose()
                            {
                                var highPromptSelect = promptHtml.find('.highPromptValue ');
                                if (highPromptSelect.children().length)
                                {
                                    var linkedPromptUniqueId = highPromptSelect.val();
                                    promptModel.LinkedPromptUniqueId = linkedPromptUniqueId;
                                    promptModel.LinkedPromptGuid = linkedPromptUniqueId;
                                    var linkedPrompt = promptCollection.Get(linkedPromptUniqueId);
                                    linkedPrompt.LinkedPromptUniqueId = promptModel.PromptUniqueId;
                                    linkedPrompt.LinkedPromptGuid = promptModel.PromptUniqueId;
                                    linkedPrompt.HiddenCondition = null;

                                    putPromptsSideBySide(promptModel.PromptUniqueId, linkedPromptUniqueId);
                                    recalculateSortOrder();
                                }

                                linkPromptsDialog.close();

                                const linkButton = promptManager.find(".link_report_prompt");
                                const unlinkButton = promptManager.find(".unlink_report_prompt");

                                linkButton.hide();
                                unlinkButton.show();
                                unlinkButton.focus();
                            }

                            function cancelAndClose()
                            {
                                linkPromptsDialog.close();
                            }

                            function putPromptsSideBySide(lowPromptUniqueId, highPromptUniqueId)
                            {
                                var lowPromptInput = promptManager.find("[data-prompt-unique-id='" + lowPromptUniqueId + "']");
                                var highPromptInput = promptManager.find("[data-prompt-unique-id='" + highPromptUniqueId + "']");

                                highPromptInput.find("svg").remove();
                                highPromptInput.prepend('<span class="decorativeLabel visualLabel linkedPromptSeparator"> - </span>');
                                lowPromptInput.parent().append(highPromptInput);
                            }

                            function recalculateSortOrder()
                            {
                                promptManager.find("li").not(".hidden").find(".promptInput").each(function (index) { promptCollection.Get($(this).data("promptUniqueId")).Order = index; });
                            }
                        }
                    });
            };

            // launches a multi-select enum dialog
            function openMultiSelectEnumDialog(button, promptModel)
            {
                var deferred = $.Deferred();
                var menu;

                // This method is still scraping the DOM. Change it to receive a promptModel instead.
                var okButton = { text: "OK", "icon": "Check", "click": scrapeValuesAndClose };
                var cancelButton = { text: "Cancel", "icon": "Cancel", "click": cancel };
                var buttons = [okButton, cancelButton];
                var options = { closeOnClick: false, anchorTo: button };

                $.ajax(skyward.global.virtualDir + "Reporting/Report/GetMultiSelectEnumPrompt",
                    {
                        type: "POST",
                        data: { promptJson: promptModel.toJsonString() },
                        dataType: "JSON",
                        success: function (data)
                        {
                            menu = skyward.modalLayer.showDialog("Multiple Selection Builder", data.html, buttons, options);

                            $.when(menu).done(function ()
                            {
                                skyward.window.notifyDOMLoad(".enumMultiSelectOptions");
                            });
                        }
                    });

                return deferred;


                function scrapeValuesAndClose()
                {
                    const enumValue = [];

                    menu.content.find(".checkbox:checked").each(function ()
                    {
                        const value = $(this).val();
                        enumValue.push([value, value]);
                    });

                    menu.close();
                    deferred.resolve(enumValue);
                }

                function cancel()
                {
                    deferred.reject();
                    menu.close();
                }
            }

            // launches a custom prompt value dialog
            function openCustomPromptValueDialog(button, promptModel)
            {
                return skyward.customprompts.editCustomPromptValues(button, promptModel);
            }

            var selectPrompt = function (prompt)
            {
                const promptList = prompt.closest(".currentPrompts");
                const selected = promptList.find(".selected");
                selected.removeClass("selected");

                prompt.addClass("selected");

                const promptManager = promptList.closest(".PromptManager");
                const deleteButton = promptManager.find(".delete_report_prompt");
                const usagesButton = promptManager.find(".usage_locations");
                const editButton = promptManager.find(".edit_report_prompt");
                const linkButton = promptManager.find(".link_report_prompt");
                const unlinkButton = promptManager.find(".unlink_report_prompt");
                disable(editButton, false);
                const promptModel = promptCollection.Get(prompt.data().promptUniqueId);
                if (promptModel.InUse || (promptModel.LinkedPromptUniqueId && promptCollection.Get(promptModel.LinkedPromptUniqueId).InUse))
                {
                    disable(deleteButton, true);
                    disable(usagesButton, false);
                }
                else
                {
                    disable(deleteButton, false);
                    disable(usagesButton, true);
                }
                if (promptCollection.GetLinkablePrompts(promptModel).length > 0)
                {
                    if (!promptModel.LinkedPromptUniqueId)
                    {
                        linkButton.show();
                        unlinkButton.hide();
                    }
                    else
                    {
                        linkButton.hide();
                        unlinkButton.show();
                    }
                }
                else
                {
                    if (promptModel.LinkedPromptUniqueId)
                    {
                        linkButton.hide();
                        unlinkButton.show();
                        unlinkButton.focus();
                    }
                    else
                    {
                        linkButton.hide();
                        unlinkButton.hide();
                        editButton.focus();
                    }
                }
            };

            // this method belongs in a view and should notify the view model the prompt has been deleted
            function deletePrompt(deleteButton)
            {
                if (!skyward.buttonManager.isElementDisabled(deleteButton))
                {
                    var promptManager = deleteButton.closest(".PromptManager");
                    var selectedPrompt = promptManager.find(".selected");
                    if (selectedPrompt.length)
                    {

                        var promptUniqueId = selectedPrompt.data().promptUniqueId;
                        if (promptUniqueId.length)
                        {
                            var editButton = promptManager.find(".edit_report_prompt");
                            var linkedPrompt = promptCollection.Get(promptCollection.Get(promptUniqueId).LinkedPromptUniqueId);
                            if (linkedPrompt !== null && linkedPrompt !== undefined)
                            {
                                promptCollection.Delete(linkedPrompt.PromptUniqueId);
                            }
                            promptCollection.Delete(promptUniqueId);
                            selectedPrompt.parent().remove();
                            disable(deleteButton, true);
                            disable(editButton, true);
                        }
                    }
                }
            }

            function deletePromptKey(event, promptEditorDialog)
            {
                const selected = promptEditorDialog.container.find(".selected");
                if (selected.length && keyboardCommands.isDeletePromptPressed(event))
                {
                    const promptManager = selected.closest(".PromptManager");
                    const deleteButton = promptManager.find(".delete_report_prompt");
                    deletePrompt(deleteButton);
                }
            }

            function openUsageLocations(button)
            {
                if (!skyward.buttonManager.isElementDisabled(button))
                {
                    const selectedPrompt = button.parents(".PromptManager").find(".selected");
                    let promptModel;
                    if (selectedPrompt.length)
                    {
                        const promptUniqueId = selectedPrompt.data().promptUniqueId;
                        if (promptUniqueId.length)
                        {
                            promptModel = promptCollection.Get(promptUniqueId);
                        }
                    }

                    if (promptModel)
                    {
                        usageLocations.openModal("prompt-usages-dialog", promptModel.getUsages);
                    }
                }
            }

            function editPrompt(editButton)
            {
                if (!skyward.buttonManager.isElementDisabled(editButton))
                {
                    var selectedPrompt = editButton.parents('.PromptManager').find(".selected");
                    if (selectedPrompt.length)
                    {
                        var promptUniqueId = selectedPrompt.data().promptUniqueId;
                        if (promptUniqueId.length)
                        {
                            getPromptDetailsView(null, null, promptUniqueId);
                        }
                    }
                }
            }

            function linkPrompt(linkButton)
            {
                var promptManager = linkButton.parents('.PromptManager');
                var selectedPrompt = promptManager.find(".selected");
                if (selectedPrompt.length)
                {
                    var promptUniqueId = selectedPrompt.data().promptUniqueId;
                    if (promptUniqueId.length)
                    {
                        getPromptLinkView(promptUniqueId, promptManager);
                    }
                }
            }

            function unlinkPrompt(unlinkButton)
            {
                var promptManager = unlinkButton.parents('.PromptManager');
                var selectedPrompt = promptManager.find(".selected");
                if (selectedPrompt.length)
                {
                    var linkedPrompts = selectedPrompt.parent().find(".promptInput");
                    var lowPromptInput = $(linkedPrompts[0]);
                    var highPromptInput = $(linkedPrompts[1]);

                    highPromptInput.append(lowPromptInput.find("svg").clone());
                    highPromptInput.find(".linkedPromptSeparator").remove();

                    var highPrompListItem = $("<li/>");
                    highPrompListItem.addClass("ui-state-default");
                    highPrompListItem.append(highPromptInput);

                    lowPromptInput.parent().after(highPrompListItem);

                    var lowPrompt = promptCollection.Get(lowPromptInput.data().promptUniqueId);
                    var highPrompt = promptCollection.Get(highPromptInput.data().promptUniqueId);
                    highPrompt.LinkedPromptUniqueId = null;
                    highPrompt.LinkedPromptGuid = null;
                    lowPrompt.LinkedPromptUniqueId = null;
                    lowPrompt.LinkedPromptGuid = null;

                    highPrompt.refreshInUse();
                    lowPrompt.refreshInUse();

                    var linkButton = promptManager.find(".link_report_prompt");
                    linkButton.show();
                    unlinkButton.hide();
                    linkButton.focus();
                }
            }

            var promptEditor = skyward.mvvm.newViewModel(function ()
            {
                var self = this;
                return {
                    open: function ()
                    {
                        var deferred = $.Deferred();
                        var promptEditorDialog;
                        var promptsEditorHtml;
                        var promptsListHtml;
                        $.ajax(skyward.global.virtualDir + "Reporting/Report/GetPrompts",
                            {
                                type: "POST",
                                dataType: "JSON",
                                data: { promptJson: promptCollection.toJsonString() }
                            }).then(runPromptEditor);

                        return deferred;


                        function runPromptEditor(ajaxResult)
                        {
                            promptCollection.RefreshAllPromptsInUse();
                            promptsEditorHtml = $(ajaxResult.html);
                            promptsListHtml = promptsEditorHtml.find("ul").first();
                            var promptManager_View = skyward.mvvm.newView();

                            var buttons = [
                                { text: "Save", click: saveAndClose, icon: "Save" },
                                { text: "Cancel", icon: "Cancel", click: cancelAndClose }
                            ];
                            var options =
                            {
                                closeOnClick: false,
                                draggable: true,
                                afterClose: function ()
                                {
                                    self.stopObservingEverything();
                                    promptManager_View.announce("close");
                                    deferred.resolve();
                                },
                                automationID: "prompts-dialog"
                            };
                            promptEditorDialog = skyward.modalLayer.showDialog("Prompts", promptsEditorHtml, buttons, options);

                            promptEditorDialog.bodyPromise.done(function ()
                            {
                                skyward.window.notifyDOMLoad("#" + promptEditorDialog.container[0].id);

                                promptCollection.TakeSnapshot();

                                self.observe(promptCollection, "model:Label", function (model)
                                {
                                    promptsEditorHtml.find(".promptInput[data-prompt-unique-id='" + model.PromptUniqueId + "']").find(".promptLabelText").text(model.Label);
                                });

                                var setIcon = function (model)
                                {
                                    model.getIconType();
                                    promptsEditorHtml.find(".promptInput[data-prompt-unique-id='" + model.PromptUniqueId + "']")
                                        .find('svg').replaceWith(skyward.svg.getSvg(model.getIconType(), 'TreeBrowse'));
                                };
                                self.observe(promptCollection, "model:Type", setIcon);
                                self.observe(promptCollection, "model:InputType", setIcon);

                                promptsEditorHtml.find(".sortable").sortable({ stop: recalculateSortOrder });
                                promptEditorDialog.container.find(".promptInput").on("click", function () { selectPrompt($(this)); }).on("dblclick", function () { editPrompt($(this)); });
                                promptEditorDialog.container.find(".add_report_prompt").on("click", function () { getPromptDetailsView(null, { dialog: promptEditorDialog }); });
                                promptEditorDialog.container.find(".delete_report_prompt").on("click", function () { deletePrompt($(this)); });
                                promptEditorDialog.container.find(".usage_locations").on("click", function () { openUsageLocations($(this)); });
                                promptEditorDialog.container.find(".edit_report_prompt").on("click", function () { editPrompt($(this)); });
                                promptEditorDialog.container.find(".link_report_prompt").on("click", function () { linkPrompt($(this)); });
                                promptEditorDialog.container.find(".unlink_report_prompt").on("click", function () { unlinkPrompt($(this)); });
                                promptEditorDialog.container.on("keydown", function (e) { deletePromptKey(e, promptEditorDialog) });

                                self.observe(addPromptEvents, "newPrompt", function (data)
                                {
                                    var newPromptListItem = createNewPromptListItem(data.promptModel, promptsListHtml);
                                    promptsListHtml.append(newPromptListItem);
                                    promptCollection.RefreshAllPromptsInUse();
                                });
                            });

                            function createNewPromptListItem(model, promptsList)
                            {
                                var newItem = $(promptsList.find(".hidden").clone()).removeClass('hidden');
                                newItem.find('.extraOptionLabel').text(model.Label);
                                newItem.find('svg').replaceWith(skyward.svg.getSvg(model.getIconType(), 'TreeBrowse'));

                                var promptInput = newItem.find(".promptInput");
                                promptInput.data().promptUniqueId = model.PromptUniqueId;
                                promptInput.attr("data-prompt-unique-id", model.PromptUniqueId);
                                promptInput.on("click", function () { selectPrompt($(this)); });

                                return newItem;
                            }

                            function cancelAndClose()
                            {
                                self.stopObservingEverything(); // Prevent unnecessary callbacks to hide/show delete icon (we're about to close the view)
                                promptCollection.Revert();
                                promptEditorDialog.close();
                            }

                            function saveAndClose()
                            {
                                self.stopObservingEverything();
                                promptManager_View.announce("save");
                                if (promptCollection.PromptsIsDirty())
                                {
                                    updatePromptUsages(designer.find(".reportDesignerPromptFieldsMenu"));
                                    updateHiddenField();
                                    initDesignerUI(entireCanvas.find('.sectionSelected'));
                                }
                                promptEditorDialog.close();
                            }

                            function recalculateSortOrder()
                            {
                                promptsEditorHtml.find("li").not(".hidden").find(".promptInput").each(function (index) { promptCollection.Get($(this).data("promptUniqueId")).Order = index; });
                            }
                        }
                    }
                };
            });

            var updatePromptUsages = function (extraColumnOptions)
            {
                populateExtraColumnOptionsWithPrompts(extraColumnOptions);

                promptCollection.forEach(function (prompt)
                {
                    if (prompt.InUse)
                    {
                        designer.find(".formTextColumn").each(function ()
                        {
                            var column = $(this);
                            column.find(".column_content").text(getColumnLabelWithPreText(column));
                        });

                        designer.find(".jsColumn[data-prompt-unique-id='" + prompt.PromptUniqueId + "']").each(function ()
                        {
                            var column = $(this);
                            column.data("designerText", prompt.Label).attr("data-designer-text", prompt.Label);
                            var displayText = getColumnLabelWithPreText(column);
                            column.find(".column_content").text(displayText);
                        });

                        if (isHiddenSelector.elements.left.is(":visible") && isHiddenSelector.elements.left.data("promptUniqueId") === prompt.PromptUniqueId)
                        {
                            isHiddenSelector.setIsHiddenOperandPrompt(prompt, isHiddenSelector.elements.left);
                        }

                        if (isHiddenSelector.elements.right.is(":visible") && isHiddenSelector.elements.right.data("promptUniqueId") === prompt.PromptUniqueId)
                        {
                            isHiddenSelector.setIsHiddenOperandPrompt(prompt, isHiddenSelector.elements.right);
                        }

                        if (editorPrintAtBottomOfPage.is(":visible") && editorPrintAtBottomOfPage.data().promptUniqueId === prompt.PromptUniqueId)
                        {
                            editorPrintAtBottomOfPage.find("span:last").text(prompt.Label);
                        }

                        if (editorPrintReportFooterOnNewPage.is(":visible") && editorPrintReportFooterOnNewPage.data().promptUniqueId == prompt.PromptUniqueId)
                        {
                            editorPrintReportFooterOnNewPage.find("span:last").text(prompt.Label);
                        }

                        if (editorRepeatLineAfterStart.is("visible") && editorRepeatLineAfterStart.data().promptUniqueId == prompt.PromptUniqueId)
                        {
                            editorRepeatLineAfterStart.find("span:last").text(prompt.Label);
                        }
                    }
                });
            };

            var populateExtraColumnOptionsWithPrompts = function (extraColumnOptions)
            {
                var ul = extraColumnOptions.find(".reportDesignerPromptsList").empty();

                promptCollection.filter(function (prompt) { return (prompt.Type != enumMaps.PromptTypes.UserInstructions && prompt.Type != enumMaps.PromptTypes.SectionHeader); }).forEach(function (prompt)
                {
                    var li = $("<li/>").addClass("promptItem").addClass("jsDraggable").addClass("ui-draggable").attr({
                        "data-prompt-unique-id": prompt.PromptUniqueId,
                        "data-page-section-column-type": "PromptValue",
                        "data-field-name": "{_prompt." + prompt.PromptUniqueId + "}",
                        "data-designer-text": prompt.Label,
                        "data-field-type": prompt.InputType
                    });
                    var span = $("<span/>").addClass("extraOptionSpan").addClass('outlineSelected');
                    var label = $("<span/>").addClass("decorativeLabel visualLabel extraOptionLabel").text(prompt.Label);

                    span.append(label).appendTo(li.appendTo(ul));
                    ul.append(li);
                });
            };

            var getPromptTypeByEnumValue = function (enumValuePosition)
            {
                var keys = Object.keys(enumMaps.PromptTypes);
                for (var i = 0; i < keys.length; i++)
                {
                    if (enumMaps.PromptTypes[keys[i]] === enumValuePosition)
                    {
                        return keys[i];
                    }
                }

                return null;
            };

            function getModuleAndObjectFromFieldPath(fieldPath)
            {
                if (fieldPath)
                {
                    var parts = fieldPath.split('.');

                    if (parts.length > 1)
                    {
                        return {
                            dataModule: parts[0],
                            dataObject: parts[1],
                        };
                    }
                }

                return {};
            }

            function initPromptViewModel(dialog, promptModel)
            {
                var promptHtml = dialog.content;

                promptHtml.data("promptUniqueId", promptModel.PromptUniqueId);

                // where is the view model?
                // See note by "NewViewModel" in skyward.base.mvvm.js - The observer inside this call to newView effectively *makes* this a viewmodel.
                return skyward.mvvm.newView(function ()
                {
                    var _observer = skyward.mvvm.newObserver();
                    var loadingPromptValues = false;

                    // launches the multi-select field picker
                    var getPromptField = function ()
                    {
                        var options = { treeBrowseOptions: { seekField: (promptModel.Columns || "").split(' ')[0], fieldsOfType: promptModel.InUse ? promptModel.InputType : "" } };
                        selectFieldDialog(fieldSelector, promptModel.Module, promptModel.Object, options).done(function (listData, moduleObjectData)
                        {
                            loadingPromptValues = true;
                            const fieldPath = moduleObjectData.fieldModule + '.' + moduleObjectData.fieldObject + '.' + listData.absoluteFieldPath;

                            promptModel.InputType = skyward.reporting.reportColumn.getFieldType(listData);
                            if (promptModel.Type == enumMaps.PromptTypes.SingleSelect || promptModel.Type == enumMaps.PromptTypes.MultipleSelect) // if Prompt Type didn't get forcefully set to something else
                            {
                                promptModel.FieldPath = fieldPath;
                                promptModel.Module = moduleObjectData.fieldModule;
                                promptModel.Object = moduleObjectData.fieldObject;
                                promptModel.RelativeFieldPath = listData.fieldName;
                                promptModel.FiltersJson = "";
                                promptModel.Sorts = "";
                                promptModel.Columns = listData.absoluteFieldPath;
                                promptModel.Value = "";
                                promptModel.SelectionOptions = buildInitialSelectionOptions();
                            }
                            replaceDistinctMultiSelect(fieldPath, null, null, null);
                            loadingPromptValues = false;
                        });
                    };

                    function replaceDistinctMultiSelect(fieldPath, columns, sorts, selectedValues)
                    {
                        if (fieldPath)
                        {
                            const selectedValuesJson = skyward.extensions.encodeHtml(JSON.stringify(selectedValues ?? []));

                            skyward.validation.clearValidationMessages(promptHtml, $());
                            $.ajax(skyward.global.virtualDir + "Reporting/Report/GetNewDistinctMultiSelectFromFieldPath",
                                {
                                    type: "POST",
                                    dataType: "JSON",
                                    data:
                                    {
                                        fieldPath: fieldPath,
                                        columns: columns,
                                        sorts: sorts,
                                        selectedValues: selectedValuesJson
                                    }
                                }).done(function (data)
                                {
                                    if (data.valid)
                                    {
                                        selectionOptionsInput.replaceWith(data.html);

                                        selectionOptionsInput = selectionOptionsFieldSet.find(".selectionDMSE");
                                        skyward.distinctMultiSelectEEL.registerDistinctMultiSelectEEL(selectionOptionsInput);

                                        selectionOptionsBackingData = selectionOptionsInput.find(".dmsBackingData");
                                        selectionOptionsBackingData.on('change', setValueFromSelectionOptionsBackingData);
                                    }
                                    else
                                    {
                                        skyward.validation.displayValidationMessages({ errors: data.errors }, promptHtml, $());
                                    }
                                });
                        }
                    }

                    function joinSelectionOptionsForDisplay(selectionOptions)
                    {
                        let displayValues = [];
                        for (const option of selectionOptions)
                        {
                            displayValues.push(option[1]);
                        }

                        return displayValues.join(";");
                    }

                    var labelInput = promptHtml.find("[data-prompt-unique-id='" + promptModel.PromptUniqueId + "']").addBack("[data-prompt-unique-id='" + promptModel.PromptUniqueId + "']").find('.promptLabelText');
                    const promptTypeInput = promptHtml.find(".promptTypes");
                    const promptTypeComboBoxOptions = promptTypeInput.find(".option");
                    var dataTypeInput = promptHtml.find(".inputTypes");
                    var presenceTypeCombo = promptHtml.find(".presenceTypes");
                    var defaultValueFieldSet = promptHtml.find('.DefaultValueFieldSet');
                    var userInstructionsTextFieldSet = promptHtml.find(".userInstructionsTextFieldSet");

                    var dataTypeFieldSet = dataTypeInput.parent();
                    var presenceTypeFieldSet = presenceTypeCombo.parent();

                    var selectionOptionsFieldSet = promptHtml.find(".fieldSelectionOptions");
                    var selectionOptionsInput = selectionOptionsFieldSet.find(".selectionDMSE");
                    var selectionOptionsBackingData = selectionOptionsInput.find(".dmsBackingData");

                    var enumSelectionOptionsFieldSet = promptHtml.find(".enumSelectionOptions");
                    var enumMultipleSelector = enumSelectionOptionsFieldSet.find(".enumMultipleSelector");
                    var enumSelectionOptionInput = enumSelectionOptionsFieldSet.find(".enumSelectionInput");

                    var customPromptValueSelectionOptionsFieldSet = promptHtml.find(".customPromptValueSelectionOptions");
                    var customPromptValueMultipleSelector = customPromptValueSelectionOptionsFieldSet.find(".customPromptValueMultipleSelector");
                    var customPromptValueSelectionOptionInput = customPromptValueSelectionOptionsFieldSet.find(".customPromptValueSelectionInput");

                    var defaultValueInput = defaultValueFieldSet.find('.defaultValue');

                    const prefillPromptFieldSet = promptHtml.find(".prefillPromptFieldSet");
                    const prefillPromptInput = prefillPromptFieldSet.find(".prefillPrompt");

                    var userInstructionsTextArea = userInstructionsTextFieldSet.find(".userInstructions");

                    var booleanDisplayOverrideValues = promptHtml.find('.BooleanDisplayValues');
                    var booleanDisplayOverrideTrueValue = booleanDisplayOverrideValues.find(".TrueValue");
                    var booleanDisplayOverrideFalseValue = booleanDisplayOverrideValues.find(".FalseValue");
                    var removeEnvironmentVariableButton = promptHtml.find(".removeEnvironmentVariableButton");

                    var fieldSelector = promptHtml.find('.promptBuilderFieldSelect');
                    var fieldPathInput = promptHtml.find(".multiSelectField");
                    var sortDefinitionFieldSet = promptHtml.find(".SortDefinition");
                    var columnDefinitionFieldSet = promptHtml.find(".ColumnDefinition");
                    var editFieldsToDisplay = promptHtml.find(".editFieldsToDisplay");
                    var promptFieldSelectorFieldSet = promptHtml.find(".promptFieldSelector");
                    var selectionFilterFieldSet = promptHtml.find(".selectionFilter");
                    var filterBuilderLaunchButton = promptHtml.find(".filterBuilderLaunchButton");
                    var filterViewValue = promptHtml.find(".filterViewValue");
                    var multiSelectSortsInput = promptHtml.find(".multiSelectSorts");
                    var multiSelectViewsInput = promptHtml.find(".multiSelectViews");

                    const promptIsHiddenSelector = skyward.reporting.userCondition.init(promptHtml.find(".jsIsHiddenCondition"))
                    const hiddenSelectorWarning = promptHtml.find(".jsHiddenSelectorWarning");
                    toggleHiddenSelectorWarning();

                    let isHighLinkedPrompt = false;

                    if (promptModel.LinkedPromptUniqueId)
                    {
                        var linkedPrompt = promptCollection.Get(promptModel.LinkedPromptUniqueId);
                        if (promptModel.Order > linkedPrompt.Order)
                        {
                            isHighLinkedPrompt = true;
                        }
                    }

                    if (isHighLinkedPrompt)
                    {
                        promptIsHiddenSelector.elements.wrapper.hide();
                    }
                    else
                    {
                        promptIsHiddenSelector.elements.wrapper.show();

                        promptIsHiddenSelector.setIsHiddenCondition(promptModel.HiddenCondition, "Prompt", getSvgByDataType, null, null);
                        promptIsHiddenSelector.elements.wrapper.find('.userConditionValueSelectorButton').on('click', function ()
                        {
                            const allPrompts = skyward.reporting.prompts.promptCollection.toJsonObject();
                            const allPromptsExceptCurrent = allPrompts.filter(function (prompt)
                            {
                                return prompt.PromptUniqueId != promptModel.PromptUniqueId;
                            });

                            let operandButton = $(this);
                            if (operandButton.hasClass("leftOperand"))
                            {
                                const allowOptions =
                                {
                                    fieldSelection: false,
                                    currentColumnValue: false,
                                    prompts: true,
                                    alwaysHidden: false,
                                }
                                promptIsHiddenSelector.getUserConditionOperandFilterValueSelector(operandButton, allowOptions, null, allPromptsExceptCurrent, null, null, true, valueSelectorClickEvents);
                            }
                            else
                            {
                                let leftOperandFieldType = getEditorFieldDataType(promptIsHiddenSelector.elements.left);
                                let leftPromptUniqueID = promptIsHiddenSelector.elements.left.data().promptUniqueId;
                                const allowOptions =
                                {
                                    fieldSelection: false,
                                    currentColumnValue: false,
                                    prompts: false,
                                    alwaysHidden: true,
                                }
                                promptIsHiddenSelector.getUserConditionOperandFilterValueSelector(operandButton, allowOptions, null, allPromptsExceptCurrent, leftOperandFieldType, null, false, valueSelectorClickEvents, leftPromptUniqueID);
                            }
                        });

                        promptIsHiddenSelector.elements.wrapper.on("change", setIsHidden);
                        promptIsHiddenSelector.elements.wrapper.on("blur", "input", setIsHidden);

                        function setIsHidden()
                        {
                            promptModel.HiddenCondition = promptIsHiddenSelector.getUpdatedIsHiddenCondition();
                            promptIsHiddenSelector.setIsHiddenCondition(promptModel.HiddenCondition, "Prompt", getSvgByDataType, null, null);
                            toggleHiddenSelectorWarning();
                        }
                    }

                    function toggleHiddenSelectorWarning()
                    {
                        hiddenSelectorWarning.hide();
                        if (promptModel.HiddenCondition != null && !isHiddenSelector.isConditionAlwaysHidden(promptModel.HiddenCondition))
                        {
                            if (promptModel.tempRelatedSearchParameter && promptModel.tempRelatedSearchParameter.required)
                            {
                                hiddenSelectorWarning.show();
                            }
                            else
                            {
                                skyward.reporting.searchParameters.model.forEach(function (searchParameter)
                                {
                                    if (searchParameter.required && searchParameter.value === `{_prompt.${promptModel.PromptGuid}}`)
                                    {
                                        hiddenSelectorWarning.show();
                                    }
                                });
                            }
                        }
                    }

                    function showAllPromptTypeComboBoxOptions()
                    {
                        promptTypeComboBoxOptions.show();
                    }

                    function togglePromptTypeComboBoxOption(promptTypes, toggle)
                    {
                        promptTypeComboBoxOptions.each(function (i)
                        {
                            const option = $(this);
                            if (promptTypes.includes(option.val()))
                            {
                                option.toggle(toggle);
                                return true;
                            }
                        });
                    }

                    fieldSelector.on("click", getPromptField);
                    fieldPathInput.on("click", getPromptField);

                    labelInput.on("change", function ()
                    {
                        promptModel.Label = labelInput.val();
                    });
                    promptTypeInput.on("change", function ()
                    {
                        promptModel.Type = enumMaps.PromptTypes[promptTypeInput.val()];
                    });
                    dataTypeInput.on("change", function ()
                    {
                        promptModel.SelectionOptions = buildInitialSelectionOptions();
                        promptModel.InputType = dataTypeInput.val();
                    });
                    presenceTypeCombo.on("change", function ()
                    {
                        promptModel.PresenceType = presenceTypeCombo.val();
                    });
                    defaultValueInput.add(userInstructionsTextArea).on('change', function ()
                    {
                        promptModel.Value = $(this).val();
                    });
                    prefillPromptInput.on("change", function ()
                    {
                        promptModel.PrefillPrompt = prefillPromptInput.is(":checked");
                    });

                    // To get height, put the text into an offscreen textarea with identical styling (except height: height must be <= 1 x line-height,
                    // because deleting text does not alter scrollHeight) then measure the textarea's scrollHeight.
                    // Until this becomes a framework feature, creating, styling and positioning a resizeHelper is the responsibility of the developer.
                    var calculateTextAreaHeight = function (text, jqResizeHelper)
                    {
                        jqResizeHelper.text(text).show();
                        var height = Math.ceil(jqResizeHelper[0].scrollHeight);
                        jqResizeHelper.hide();
                        return height;
                    };

                    var setValueFromSelectionOptionsBackingData = function ()
                    {
                        const selectedOptionsObject = JSON.parse(selectionOptionsBackingData.val());

                        const selectionOptions = buildInitialSelectionOptions();

                        for (const key of Object.keys(selectedOptionsObject))
                        {
                            selectionOptions.push([key, key]);
                        }

                        promptModel.SelectionOptions = selectionOptions;
                    };

                    selectionOptionsBackingData.on('change', setValueFromSelectionOptionsBackingData);
                    booleanDisplayOverrideTrueValue.on("change", function ()
                    {
                        promptModel.DisplayValueOverrides.true = booleanDisplayOverrideTrueValue.val();
                    });
                    booleanDisplayOverrideFalseValue.on("change", function ()
                    {
                        promptModel.DisplayValueOverrides.false = booleanDisplayOverrideFalseValue.val();
                    });

                    removeEnvironmentVariableButton.on('click', function ()
                    {
                        promptModel.Value = "";
                    });
                    multiSelectViewsInput.on('change', function ()
                    {
                        promptModel.Columns = multiSelectViewsInput.val();
                    });
                    multiSelectSortsInput.on('change', function ()
                    {
                        promptModel.Sorts = multiSelectSortsInput.val();
                    });

                    enumMultipleSelector.on("click", function ()
                    {
                        openMultiSelectEnumDialog(this, promptModel).then(function (value)
                        {
                            promptModel.SelectionOptions = value;
                        });
                    });
                    enumSelectionOptionInput.on("click", function ()
                    {
                        openMultiSelectEnumDialog(enumMultipleSelector, promptModel).then(function (value)
                        {
                            promptModel.SelectionOptions = value;
                        });
                    });

                    customPromptValueMultipleSelector.on("click", function ()
                    {
                        openCustomPromptValueDialog(this, promptModel).then(function (value)
                        {
                            promptModel.SelectionOptions = value;
                        });
                    });
                    customPromptValueSelectionOptionInput.on("click", function ()
                    {
                        openCustomPromptValueDialog(customPromptValueMultipleSelector, promptModel).then(function (value)
                        {
                            promptModel.SelectionOptions = value;
                        });
                    });

                    filterViewValue.on("change", function ()
                    {
                        var filterViewData = filterViewValue.data();
                        if (filterViewData.filterCondition)
                        {
                            promptModel.FiltersJson = JSON.stringify(filterViewData.filterCondition);
                        }
                        else
                        {
                            promptModel.FiltersJson = null;
                        }
                    });
                    editFieldsToDisplay.on("click", function ()
                    {
                        var editFieldsToDisplayData = editFieldsToDisplay.data();
                        var args = {
                            fieldsToDisplayInfo: promptModel.Columns,
                            fieldPath: fieldPathInput.val(),
                            module: editFieldsToDisplayData.module,
                            object: editFieldsToDisplayData.object,
                            callback: function (fieldsToDisplayString) { promptModel.Columns = fieldsToDisplayString; }
                        };
                        skyward.multiselectcolumnbuilder.launch(args);
                    });

                    var anyPropertyChanged = function ()
                    {
                        const isDMSEType = (promptModel.Type == enumMaps.PromptTypes.SingleSelect || promptModel.Type == enumMaps.PromptTypes.MultipleSelect);
                        const hasUniqueId = promptModel.Value && promptModel.Value?.startsWith("{") && promptModel.Value?.endsWith("}");
                        const isEnum = promptModel.InputType?.startsWith("String Enum") ?? false;
                        const isBoolean = promptModel.InputType === DATA_TYPES.BOOLEAN;
                        const isReportSort = promptModel.Type === enumMaps.PromptTypes.ReportSort;
                        const isFreeformText = promptModel.Type == enumMaps.PromptTypes.FreeformText;
                        const isUserInstructions = promptModel.Type == enumMaps.PromptTypes.UserInstructions;
                        const isSectionHeader = promptModel.Type == enumMaps.PromptTypes.SectionHeader;
                        const isStandardFilterPrompt = promptModel.Type == enumMaps.PromptTypes.StandardFilter;
                        const hasFieldPath = Boolean(promptModel.FieldPath);
                        const isCustomPrompt = promptModel.Type == enumMaps.PromptTypes.CustomSingleSelect || promptModel.Type == enumMaps.PromptTypes.CustomMultipleSelect;

                        if (isDMSEType && hasUniqueId)
                        {
                            promptModel.Value = "";
                        }

                        //hide everything
                        enumSelectionOptionsFieldSet.hide();
                        selectionFilterFieldSet.hide();
                        sortDefinitionFieldSet.hide();
                        columnDefinitionFieldSet.hide();
                        defaultValueFieldSet.hide();
                        selectionOptionsFieldSet.hide();
                        promptFieldSelectorFieldSet.hide();
                        booleanDisplayOverrideValues.hide();
                        removeEnvironmentVariableButton.hide();
                        defaultValueInput.hide();
                        userInstructionsTextFieldSet.hide();
                        presenceTypeFieldSet.hide();
                        dataTypeFieldSet.hide();
                        customPromptValueSelectionOptionsFieldSet.hide();
                        prefillPromptFieldSet.hide();

                        if (isEnum)
                        {
                            dataTypeFieldSet.show();
                            enumSelectionOptionsFieldSet.show();
                            prefillPromptFieldSet.show();

                            if (hasFieldPath)
                            {
                                promptFieldSelectorFieldSet.show();
                            }
                        }
                        else if (isDMSEType)
                        {
                            dataTypeFieldSet.show();
                            promptFieldSelectorFieldSet.show();
                            prefillPromptFieldSet.show();

                            if (hasFieldPath)
                            {
                                selectionOptionsFieldSet.show();
                                sortDefinitionFieldSet.show();
                                columnDefinitionFieldSet.show();
                                selectionFilterFieldSet.show();
                            }

                            fieldSelector.add(fieldPathInput);
                        }
                        else if (isUserInstructions)
                        {
                            userInstructionsTextArea.val(promptModel.Value);
                            userInstructionsTextFieldSet.show();
                        }
                        else if (isCustomPrompt)
                        {
                            dataTypeFieldSet.show();
                            customPromptValueSelectionOptionsFieldSet.show();
                            prefillPromptFieldSet.show();
                        }
                        else if (!isStandardFilterPrompt && !isSectionHeader && !isReportSort)
                        {
                            dataTypeFieldSet.show();
                            prefillPromptFieldSet.show();

                            if (isBoolean)
                            {
                                booleanDisplayOverrideValues.show();
                            }

                            if (hasUniqueId)
                            {
                                removeEnvironmentVariableButton.show();
                            }
                            else
                            {
                                defaultValueInput.show();
                            }

                            if (!isFreeformText && !isBoolean && !isReportSort)
                            {
                                defaultValueFieldSet.show();
                            }
                        }

                        disable(dataTypeInput, isStandardFilterPrompt || hasFieldPath || isFreeformText || isEnum || promptModel.InUse || promptModel.LinkedPromptUniqueId || isReportSort);

                        showAllPromptTypeComboBoxOptions();
                        togglePromptTypeComboBoxOption([enumMaps.PromptTypes.StandardFilter, enumMaps.PromptTypes.ReportSort], false);

                        if (isUserInstructions || isSectionHeader)
                        {
                            disable(promptTypeInput, false);
                        }
                        else if (isStandardFilterPrompt || isReportSort || isBoolean || (promptModel.InUse && isFreeformText))
                        {
                            disable(promptTypeInput, true);
                            togglePromptTypeComboBoxOption([enumMaps.PromptTypes.StandardFilter], true);
                        }
                        else if (promptModel.InUse && (promptModel.Type == enumMaps.PromptTypes.MultipleSelect || promptModel.Type == enumMaps.PromptTypes.CustomMultipleSelect))
                        {
                            togglePromptTypeComboBoxOption(Object.values(enumMaps.PromptTypes), false);

                            const promptTypesToShow = isEnum ? [enumMaps.PromptTypes.MultipleSelect] : [enumMaps.PromptTypes.MultipleSelect, enumMaps.PromptTypes.CustomMultipleSelect];

                            togglePromptTypeComboBoxOption(promptTypesToShow, true);
                        }
                        else if (promptModel.InUse)
                        {
                            disable(promptTypeInput, false);
                            const isNotSingleValuePrompt = !(promptModel.Type === enumMaps.PromptTypes.Value || promptModel.Type === enumMaps.PromptTypes.SingleSelect || promptModel.Type === enumMaps.PromptTypes.CustomSingleSelect);
                            togglePromptTypeComboBoxOption([enumMaps.PromptTypes.MultipleSelect, enumMaps.PromptTypes.CustomMultipleSelect, enumMaps.PromptTypes.FreeformText, enumMaps.PromptTypes.UserInstructions, enumMaps.PromptTypes.SectionHeader], isNotSingleValuePrompt);
                        }
                        else
                        {
                            disable(promptTypeInput, false);
                        }

                        if (promptModel.SpecificTypeRequired)
                        {
                            disable(promptTypeInput, true);
                            disable(dataTypeInput, true);
                        }

                        if (!isFreeformText && !isStandardFilterPrompt && !isUserInstructions && !isSectionHeader && !isReportSort)
                        {
                            presenceTypeFieldSet.show();
                        }

                        if (promptModel.isRequired())
                        {
                            disable(presenceTypeCombo, true);

                            if (promptModel.PresenceType !== "Required") // TODO This should not be here, but where does it go? Somewhere in the model? In C#?
                            {
                                promptModel.PresenceType = "Required";
                            }
                        }

                        dialog.animateModalContents();
                    };

                    var propertyChangedEvents = {
                        InputType: function (newval, oldval) // DataType
                        {

                            dataTypeInput.val(newval);

                            if (promptModel.Value !== "" && oldval !== undefined && oldval != newval)
                            {
                                promptModel.Value = "";
                                promptModel.SelectionOptions = buildInitialSelectionOptions();
                            }

                            if (newval && newval.startsWith("String Enum"))
                            {
                                dataTypeInput.val(DATA_TYPES.STRING);

                                if (promptModel.Type === enumMaps.PromptTypes.Value)
                                {
                                    promptModel.Type = enumMaps.PromptTypes.SingleSelect;
                                }
                            }
                            else if (newval === DATA_TYPES.BOOLEAN)
                            {
                                if (promptModel.DisplayValueOverrides === undefined)
                                {
                                    promptModel.DisplayValueOverrides = { "true": "Yes", "false": "No" };
                                }
                            }
                            else if (newval !== undefined)
                            {
                                promptModel.DisplayValueOverrides = {};
                            }

                            if (newval == DATA_TYPES.BOOLEAN)
                            {
                                promptModel.Type = enumMaps.PromptTypes.Value;
                            }
                        },
                        FieldPath: function (newval, oldval)
                        {
                            fieldPathInput.val(newval);

                            if (newval !== oldval)
                            {
                                var oldData = getModuleAndObjectFromFieldPath(oldval);
                                var newData = getModuleAndObjectFromFieldPath(newval);

                                filterBuilderLaunchButton.data('module', newData.dataModule);
                                filterBuilderLaunchButton.data('root-module', newData.dataModule);
                                filterBuilderLaunchButton.data('object', newData.dataObject);
                                filterBuilderLaunchButton.data('root-object', newData.dataObject);

                                editFieldsToDisplay.data('module', newData.dataModule);
                                editFieldsToDisplay.data('object', newData.dataObject);

                                if (!loadingPromptValues)
                                {
                                    if (newData.dataModule !== oldData.dataModule || newData.dataObject !== oldData.dataObject)
                                    {
                                        promptModel.Columns = null;
                                        promptModel.Sorts = null;
                                        promptModel.FiltersJson = "";
                                    }

                                    replaceDistinctMultiSelect(newval, null, null, null);
                                }
                            }
                        },
                        Value: function (newval, oldval)
                        {
                            if (oldval != newval)
                            {
                                const hasUniqueId = newval && newval.startsWith("{") && newval.endsWith("}");

                                selectionOptionsInput.val("");

                                if (!hasUniqueId)
                                {
                                    defaultValueInput.val(newval);
                                }
                            }
                        },
                        PrefillPrompt: function (newval)
                        {
                            prefillPromptInput.prop("checked", newval);
                        },
                        SelectionOptions: function (newval, oldval)
                        {
                            if (oldval != newval)
                            {
                                if (newval.length === 0)
                                {
                                    skyward.controls.setValue(customPromptValueSelectionOptionInput, "", true);
                                    skyward.controls.setValue(enumSelectionOptionInput, "", true);
                                }
                                else if (promptModel.InputType?.startsWith("String Enum"))
                                {
                                    const enumValuesForDisplay = joinSelectionOptionsForDisplay(newval);
                                    skyward.controls.setValue(enumSelectionOptionInput, enumValuesForDisplay, true);
                                }
                                else if (promptModel.Type == enumMaps.PromptTypes.CustomSingleSelect || promptModel.Type == enumMaps.PromptTypes.CustomMultipleSelect)
                                {
                                    const customValuesForDisplay = joinSelectionOptionsForDisplay(newval);
                                    skyward.controls.setValue(customPromptValueSelectionOptionInput, customValuesForDisplay, true);
                                }
                            }
                        },
                        FiltersJson: function (newval)
                        {
                            filterViewValue.data("filterCondition", newval);
                            filterViewValue.trigger("updateFilterViewerDisplay");
                            promptCollection.RefreshAllPromptsInUse();
                        },
                        Label: function (newval)
                        {
                            labelInput.val(newval);
                            var promptedSection = entireCanvas.find("[data-sort-prompt-guid='" + promptModel.PromptGuid + "']");
                            promptedSection.data("sortPromptLabel", promptModel.Label); // This is not mvvm, so when possible it should be made the responsibility of a listener/viewModel for the value selector that needs this data
                        },
                        PresenceType: function (newval)
                        {
                            presenceTypeCombo.val(newval);
                        },
                        Type: function (newval, oldval)
                        {
                            var typeString = getPromptTypeByEnumValue(newval);

                            if (typeString)
                            {
                                promptTypeInput.val(typeString);

                                if (newval == enumMaps.PromptTypes.FreeformText || newval == enumMaps.PromptTypes.UserInstructions || newval == enumMaps.PromptTypes.SectionHeader)
                                {
                                    promptModel.FieldPath = "";
                                    promptModel.InputType = DATA_TYPES.STRING;
                                    promptModel.PresenceType = "OptionalAllValues";
                                }
                                else if ((oldval === enumMaps.PromptTypes.SingleSelect || oldval === enumMaps.PromptTypes.MultipleSelect) &&
                                    (newval !== enumMaps.PromptTypes.SingleSelect && newval !== enumMaps.PromptTypes.MultipleSelect))
                                {
                                    promptModel.Value = "";
                                    promptModel.SelectionOptions = buildInitialSelectionOptions();
                                }
                                else if ((oldval === enumMaps.PromptTypes.CustomSingleSelect || oldval === enumMaps.PromptTypes.CustomMultipleSelect) && newval != oldval)
                                {
                                    promptModel.SelectionOptions = buildInitialSelectionOptions();
                                }
                            }
                        },
                        DisplayValueOverrides: function (newval, oldval)
                        {
                            if (oldval !== newval && !$.isEmptyObject(newval))
                            {
                                booleanDisplayOverrideTrueValue.val(newval.true);
                                booleanDisplayOverrideFalseValue.val(newval.false);
                            }
                        },
                        Columns: function (newval)
                        {
                            multiSelectViewsInput.val(newval);
                            if (!loadingPromptValues && promptModel.FieldPath)
                            {
                                replaceDistinctMultiSelect(promptModel.FieldPath, newval, promptModel.Sorts, promptModel.SelectionOptions);
                            }
                        },
                        Sorts: function (newval)
                        {
                            multiSelectSortsInput.val(newval);
                            if (!loadingPromptValues && promptModel.FieldPath)
                            {
                                replaceDistinctMultiSelect(promptModel.FieldPath, promptModel.Columns, newval, promptModel.SelectionOptions);
                            }
                        }
                    };

                    loadingPromptValues = true;
                    for (var event in propertyChangedEvents) // Trigger each event once to set initial states
                    {
                        propertyChangedEvents[event](promptModel[event]);
                    }
                    loadingPromptValues = false;

                    _observer.observe(promptModel, propertyChangedEvents);
                    _observer.observe(promptModel, skyward.debounce(anyPropertyChanged, 100));

                    anyPropertyChanged();

                    return {
                        dispose: function ()
                        {
                            _observer.stopObservingEverything();
                        }
                    };

                });
            }

            function promptSelectorDialog(launchButton)
            {
                var dialog, display, list, selectPromptButton, addPromptButton, promptType;

                function highlightPrompt()
                {
                    list.find('.selected').removeClass('selected');
                    $(this).addClass('selected');
                }

                function selectPrompt()
                {
                    var selectedPrompt = promptCollection.Get(list.find('.selected').data('promptUniqueId'));

                    if (selectedPrompt)
                    {
                        setSelectedPrompt(selectedPrompt);
                    }

                    close();

                }

                function setSelectedPrompt(selectedPrompt)
                {
                    var svg = skyward.svg.getSvg(selectedPrompt.getIconType(), 'TreeBrowse');
                    display.html(svg).append(document.createTextNode(selectedPrompt.Label));
                    display.data('valueBinding', selectedPrompt.bindingString());
                }

                function buildPromptSelector()
                {
                    var deferred = $.Deferred();

                    list = $('<ul/>').on('dblclick', selectPrompt);
                    var all = [];

                    var first = true;

                    promptCollection.forEach(function (prompt)
                    {
                        if (!promptType || prompt.InputType == promptType)
                        {
                            var promise = skyward.svg.getSvg(prompt.getIconType(), 'TreeBrowse');

                            $.when(promise).done(function (svg)
                            {
                                var span = $('<span/>').data('prompt-unique-id', prompt.PromptUniqueId).addClass('promptInput');
                                span.append(svg).append($('<span/>').text(prompt.Label).addClass('extraOptionLabel'));

                                if (first)
                                {
                                    span.addClass('selected');
                                    first = false;
                                }

                                list.append($('<li/>').append(span.on('click', highlightPrompt)));
                            });

                            all.push(promise);
                        }
                    });

                    $.when.apply($, all).done(function ()
                    {
                        deferred.resolve(list);
                    });

                    return deferred.promise();
                }

                function selectNewPrompt(data)
                {
                    if (data && data.promptModel)
                    {
                        setSelectedPrompt(data.promptModel);
                    }

                    close();
                }

                function launchAddPromptDialog()
                {
                    $.when(skyward.reporting.prompts.getPromptDetailsView({ InputType: promptType }, { treatPromptAsInUse: true })).then(selectNewPrompt);
                }

                function launch(type)
                {
                    promptType = type;
                    display = launchButton.siblings('.userConditionValueSelectorDisplay');

                    selectPromptButton = {
                        text: "Select Prompt",
                        icon: "Check",
                        click: selectPrompt
                    };

                    addPromptButton = {
                        text: "Add Prompt",
                        icon: "AddPlus",
                        click: launchAddPromptDialog
                    };

                    dialog = skyward.modalLayer.showDialog("Select A Prompt", buildPromptSelector, [selectPromptButton, addPromptButton, { text: "Cancel", icon: "Close" }], { closeOnClick: false });
                }

                function close()
                {
                    display.trigger('change');
                    display = null;
                    list = null;
                    selectPromptButton = null;
                    addPromptButton = null;
                    dialog.close();
                    dialog = null;

                }

                return {
                    launch: launch
                };

            }

            return {
                promptCollection: promptCollection,
                importPrompts: importPrompts,
                promptEditor: promptEditor,
                initPromptViewModel: initPromptViewModel,
                getPromptDetailsView: getPromptDetailsView,
                populateExtraColumnOptionsWithPrompts: populateExtraColumnOptionsWithPrompts,
                promptSelectorDialog: promptSelectorDialog
            };
        })();

        const usageLocations = (function ()
        {
            /**
             * @param {string} automationId
             * @param {(model: Object) => UsageNode[]} getUsages A function that is used to iterate over the report, e.g. `PlacesToSearch.traverse`
             * @param {string?} dataPath
             */
            const openModal = function (automationId, getUsages, dataPath = null)
            {
                let usageLocationDialog;

                const buttons = [
                    { text: "Close", icon: "Cancel", click: () => usageLocationDialog.close() }
                ];

                const options =
                {
                    closeOnClick: true,
                    draggable: true,
                    automationID: automationId,
                    preserveFocus: true
                };

                const container = buildUsageLocationsElement(getUsages);

                if (dataPath)
                {
                    const fieldSet = $("<fieldset/>");
                    const label = $("<label/>").text("Data Path ").addClass("title");
                    const textBox = $("<textbox/>", { readonly: "true" }).text(dataPath).addClass("sortInfoPopupLabel ui-disabled");
                    fieldSet.append(label).append(textBox);
                    container.append(fieldSet);
                }

                usageLocationDialog = skyward.modalLayer.showDialog("Usage Locations", container, buttons, options);
                usageLocationDialog.bodyPromise.done(() => skyward.window.notifyDOMLoad(`#${usageLocationDialog.container[0].id}`));
            };

            /**
             * @param {(model: Object) => UsageNode[] | Array} getUsages A function that is used to iterate over the report, e.g. `PlacesToSearch.traverse`
             */
            const buildUsageLocationsElement = function (getUsages)
            {
                const container = $("<div/>").addClass("usageLocationContainer");

                const usages = Array.isArray(getUsages) ? getUsages : getUsages(null);
                for (const node of usages)
                {
                    if (node.inUse())
                    {
                        const innerContainer = $("<div/>");
                        const title = $("<h2/>").text(node.text);
                        innerContainer.append(title);
                        container.append(innerContainer);
                        contentNode(innerContainer, node);
                    }
                }

                return container;
            };

            /**
             * @param {(model: Object) => UsageNode[] | Array} getUsages An array of UsageNodes or a function that is used to retrieve usage nodes, e.g. `PlacesToSearch.traverse`
             */
            const usageLocationOnlyIncludesSelf = function (getUsages, type, id)
            {
                const usages = Array.isArray(getUsages) ? getUsages : getUsages(null);
                for (const node of usages)
                {
                    if (node.inUseFromOtherObjects(type, id))
                    {
                        return false;
                    }
                }
                return true;
            };

            const contentNode = function (container, node)
            {
                const section = $("<ul/>");
                container.append(section);

                for (const childNode of node.children)
                {
                    const item = $("<li/>").addClass("fieldSearchFolder");
                    const svgName = childNode.used ? "ArrowRight" : "OpenFolderAlt";
                    const svg = skyward.svg.getSvg(svgName, "TreeBrowse");
                    item.append(svg);
                    item.append($("<span/>").text(childNode.text));
                    section.append(item);
                    if (childNode.children.length > 0)
                    {
                        contentNode(item, childNode);
                    }
                }
            };

            const SourceTypes =
            {
                Section: "section",
                Line: "line",
                Column: "column",
                CalculatedField: "calculatedField",
                Sort: "sort"
            };

            const SourceDetail = (function ()
            {
                /** @class */
                function SourceDetail(type, id, element)
                {
                    this.type = type;
                    this.id = id;
                    this.element = element;
                }

                SourceDetail.prototype.areEqual = function (type, id)
                {
                    return this.type === type && this.id === id;
                };

                return SourceDetail;
            })();

            const UsageNode = (function ()
            {
                /** @class */
                function UsageNode(text, sourceDetail = null, used = false, required = false)
                {
                    this.text = text;
                    this.sourceDetail = sourceDetail;
                    this.used = used;
                    this.required = required;
                    this.children = [];
                }

                UsageNode.prototype.addChild = function (child)
                {
                    this.children.push(child);
                };

                UsageNode.prototype.inUse = function ()
                {
                    return this.hasNode((node) => node.used);
                };

                UsageNode.prototype.inUseFromOtherObjects = function (type, id)
                {
                    return this.hasNode((node) =>
                    {
                        if (node.used && node.sourceDetail && node.sourceDetail.areEqual(type, id))
                        {
                            return false;
                        }

                        return node.used;
                    });
                };

                UsageNode.prototype.isRequired = function ()
                {
                    return this.hasNode((node) => node.required);
                };

                UsageNode.prototype.hasNode = function (predicate)
                {
                    for (let node of this.allNodes())
                    {
                        if (!predicate || predicate(node))
                        {
                            return true;
                        }
                    }
                    return false;
                };

                UsageNode.prototype.allNodes = function* ()
                {
                    yield this;
                    for (let node of this.children)
                    {
                        yield* node.allNodes();
                    }
                };

                UsageNode.defaultPredicate = function (node)
                {
                    return node.inUse();
                };

                return UsageNode;
            })();

            const HiddenConditionUsageNode = (function ()
            {
                /**
                 * @constructor
                 * @extends UsageNode
                 */
                function HiddenConditionUsageNode(sourceDetail = null, used = true, required = true)
                {
                    UsageNode.call(this, "Hidden condition", sourceDetail, used, required);
                }

                HiddenConditionUsageNode.prototype = Object.create(UsageNode.prototype);
                HiddenConditionUsageNode.prototype.constructor = HiddenConditionUsageNode;

                return HiddenConditionUsageNode;
            })();

            /**
             * Base class for searching a report for the specified identifier.
             */
            const PlacesToSearch = (function ()
            {
                /**
                 * @constructor
                 * @abstract
                 * @param {Object} model
                 * @param {string?} prefix - A prefix to use for the identifier field, e.g. "_prompt", "_column"
                 * @param {string?} filter - A jQuery selector to filter DOM elements. i.e. only show usages in the selected section
                 */
                function PlacesToSearch(model, prefix = null, filter = null)
                {
                    this.model = model;
                    this.prefix = prefix;
                    this.identifierField = null;
                    this.filter = filter;
                    this.usageRoots = {};
                    this.setIdentifierField();
                }

                /** @abstract */
                PlacesToSearch.prototype.setIdentifierField = function () { };

                PlacesToSearch.prototype.traverse = function (promptsModel, predicate = UsageNode.defaultPredicate)
                {
                    const usages = [];
                    for (const usageRoot of Object.values(this.usageRoots))
                    {
                        const usageNode = usageRoot(promptsModel, predicate);
                        if (usageNode instanceof UsageNode && predicate(usageNode))
                        {
                            usages.push(usageNode);
                        }
                    }
                    return usages;
                };

                /** @abstract */
                PlacesToSearch.prototype.traverseSectionAction = function (section, parentNode, predicate) { };

                PlacesToSearch.prototype.traverseSection = function (section, parentNode, predicate)
                {
                    const self = this;
                    const sectionData = getSectionData(section);
                    const sectionNode = new UsageNode(`'${section.data("displayName")}' Section`, new SourceDetail(SourceTypes.Section, sectionData.sectionId, section));

                    if (!this.filter || section.has(this.filter).length > 0)
                    {
                        this.traverseSectionAction(section, sectionNode, predicate);

                        if (this.usedInHiddenCondition(sectionData.isHiddenCondition))
                        {
                            sectionNode.addChild(new HiddenConditionUsageNode(new SourceDetail(SourceTypes.Section, sectionData.sectionId, section)));
                        }

                        this.traverseSorts(section, sectionNode);
                        this.traverseFilter(section, sectionNode, predicate);
                        this.traverseCalculatedFields(section, sectionNode, predicate);
                        this.traverseReportLines(section, sectionNode, predicate);
                    }

                    let detailSections = getDetailSections(section);
                    if (detailSections.length > 0 && this.filter)
                    {
                        detailSections = detailSections.filter((i, s) => $(s).has(this.filter).length > 0);
                    }

                    detailSections.each(function ()
                    {
                        self.traverseSection($(this), sectionNode, predicate);
                    });

                    if (predicate(sectionNode))
                    {
                        parentNode.addChild(sectionNode);
                    }
                };

                /** @abstract */
                PlacesToSearch.prototype.traverseReportLinesAction = function (section, line, parentNode, predicate) { };

                PlacesToSearch.prototype.traverseReportLines = function (section, parentNode, predicate)
                {
                    const self = this;
                    getSectionNonPreviewLines(section).each(function ()
                    {
                        const line = $(this);
                        const lineData = line.data();
                        const lineNode = new UsageNode(`'${lineData.reportLabelText}' Line`, new SourceDetail(SourceTypes.Line, lineData.lineId, line));

                        self.traverseReportLinesAction(section, line, lineNode, predicate);

                        if (self.usedInHiddenCondition(lineData.isHiddenCondition))
                        {
                            lineNode.addChild(new HiddenConditionUsageNode(new SourceDetail(SourceTypes.Line, lineData.lineId, line)));
                        }

                        self.traverseReportColumns(line, lineNode, predicate);
                        if (predicate(lineNode))
                        {
                            parentNode.addChild(lineNode);
                        }
                    });
                };

                /** @abstract */
                PlacesToSearch.prototype.traverseReportColumnsAction = function (line, column, parentNode, predicate) { };

                PlacesToSearch.prototype.traverseReportColumns = function (line, parentNode, predicate)
                {
                    const self = this;
                    line.find(".reportColumn").each(function ()
                    {
                        const column = $(this);
                        const columnData = column.data();
                        const columnNode = new UsageNode(`'${columnData.designerText}' Column`, new SourceDetail(SourceTypes.Column, columnData.columnId, column));
                        const calculatedField = columnData.operationId ? CalculatedFields_Model.Get(columnData.operationId) : null;

                        if (self.usedInHiddenCondition(columnData.isHiddenCondition))
                        {
                            columnNode.addChild(new HiddenConditionUsageNode(new SourceDetail(SourceTypes.Column, columnData.columnId, column)));
                        }

                        if (calculatedField && self.includesBindingString(calculatedField.expression))
                        {
                            columnNode.addChild(new UsageNode("Calculated Field", new SourceDetail(SourceTypes.CalculatedField, calculatedField.id, column), true));
                        }

                        if (columnData.columnFilterJson && self.includesBindingString(columnData.columnFilterJson))
                        {
                            columnNode.addChild(new UsageNode("Group Column Filter", new SourceDetail(SourceTypes.Column, columnData.columnId, column), true));
                        }

                        self.traverseReportColumnsAction(line, column, columnNode, predicate);

                        const fieldsToSearch = [columnData.absoluteFieldPath, columnData.fieldName, columnData.designerText];
                        const isFieldInUse = fieldsToSearch.some(field => self.includesBindingString(field));

                        if (isFieldInUse)
                        {
                            columnNode.used = true;
                        }

                        if (predicate(columnNode))
                        {
                            parentNode.addChild(columnNode);
                        }
                    });
                };

                /** @abstract */
                PlacesToSearch.prototype.traverseSorts = function (section, parentNode) { };

                PlacesToSearch.prototype.traverseFilter = function (section, parentNode, predicate)
                {
                    const filter = section.find(".filterViewValue:first-child");
                    const filterCondition = filter.data("filterCondition");
                    const filterNode = new UsageNode("Filter");

                    this.traverseSearchConditionGroup(filterCondition, filterNode, predicate);

                    if (predicate(filterNode))
                    {
                        parentNode.addChild(filterNode);
                    }
                };

                PlacesToSearch.prototype.traverseSearchConditionGroup = function (condition, parentNode, predicate, parentRelationshipNameDisplay = "")
                {
                    const filterJson = JSON.stringify(condition);
                    let newNode = null;

                    let identifier = this.identifierField.toString();
                    if (parentRelationshipNameDisplay && identifier?.indexOf(parentRelationshipNameDisplay) === 0)
                    {
                        identifier = identifier.substring(parentRelationshipNameDisplay.length + 1);
                    }

                    if (condition
                        && Object.prototype.hasOwnProperty.call(condition, "SearchCondition")
                        && Object.prototype.hasOwnProperty.call(condition, "@Type")
                        && condition["@Type"] === "SearchConditionGroup")
                    {
                        if (Array.isArray(condition.SearchCondition))
                        {
                            for (const innerCondition of condition.SearchCondition)
                            {
                                this.traverseSearchConditionGroup(innerCondition, parentNode, predicate);
                            }
                        }
                        else
                        {
                            this.traverseSearchConditionGroup(condition.SearchCondition, parentNode, predicate);
                        }
                    }
                    else if (condition
                        && Object.prototype.hasOwnProperty.call(condition, "SearchCondition")
                        && Object.prototype.hasOwnProperty.call(condition, "@Type")
                        && condition["@Type"] === "ExistsSearchCondition")
                    {
                        newNode = new UsageNode(`Exists (${condition["@RelationshipNameDisplay"]})`);
                        this.traverseSearchConditionGroup(condition.SearchCondition, newNode, predicate, condition["@RelationshipNameDisplay"]);
                    }
                    else if (this.includesBindingString(filterJson, identifier)
                        || ((!Object.prototype.hasOwnProperty.call(this.model, "InputType")
                            || this.model.InputType === "standardFilter") && this.includesReferenceString(filterJson, identifier)))
                    {
                        const searchCondition = skyward.searchCondition.getFromJson(condition);
                        newNode = new UsageNode(searchCondition.toFriendlyQuery(), undefined, true);
                    }

                    if (newNode && predicate(newNode))
                    {
                        parentNode.addChild(newNode);
                    }
                };

                PlacesToSearch.prototype.traverseCalculatedFields = function (section, parentNode, predicate)
                {
                    const self = this;
                    const calcFieldsNode = new UsageNode("Calculated Fields");

                    getSectionAllCalculatedFieldIDs(section).forEach(function (calculatedFieldID)
                    {
                        const calcField = CalculatedFields_Model.Get(calculatedFieldID);
                        if (calcField && self.includesBindingString(calcField.expression))
                        {
                            calcFieldsNode.addChild(new UsageNode(calcField.fieldName, new SourceDetail(SourceTypes.CalculatedField, calcField.id, section), true, true));
                        }
                    });

                    if (predicate(calcFieldsNode))
                    {
                        parentNode.addChild(calcFieldsNode);
                    }
                };

                /** @abstract */
                PlacesToSearch.prototype.usedInHiddenCondition = function (isHiddenCondition) { return false; };

                PlacesToSearch.prototype.stringMatchesIdentifier = function (stringToSearch, searchForOverride = null)
                {
                    const searchFor = searchForOverride ?? this.identifierField;
                    return !!searchFor && searchFor === stringToSearch;
                };

                /**
                 * Converts the objectToSearch to a string and checks if it includes the formatted string.
                 * @param {object} objectToSearch The object to be stringified and searched.
                 * @param {string?} searchForOverride An optional override for the identifier field to search for. If omitted, the identifierField will be used.
                 * @param {(text: string) => string} formatter A function that formats the identifier field for searching.
                 */
                PlacesToSearch.prototype.includesFormattedString = function (objectToSearch, searchForOverride, formatter)
                {
                    const searchFor = searchForOverride ?? this.identifierField;
                    const stringToSearch = typeof objectToSearch === "string" ? objectToSearch : JSON.stringify(objectToSearch)
                    const formattedSearchFor = formatter(searchFor);
                    return !!searchFor && !!stringToSearch && (stringToSearch.includes(formattedSearchFor) || this.stringMatchesIdentifier(stringToSearch, searchFor));
                };

                PlacesToSearch.prototype.includesBindingString = function (objectToSearch, searchForOverride = null)
                {
                    const prefix = this.prefix ? `${this.prefix}.` : "";
                    return this.includesFormattedString(objectToSearch, searchForOverride, t => `{${prefix}${t}}`);
                };

                PlacesToSearch.prototype.includesReferenceString = function (objectToSearch, searchForOverride = null)
                {
                    return this.includesFormattedString(objectToSearch, searchForOverride, t => `"${t}"`);
                };

                PlacesToSearch.prototype.setModel = function (model)
                {
                    this.model = model;
                    this.setIdentifierField();
                };

                PlacesToSearch.prototype.isInUse = function ()
                {
                    return this.traverse().some(node => node.inUse());
                };

                PlacesToSearch.prototype.getExposedMethods = function ()
                {
                    return {
                        setModel: this.setModel.bind(this),
                        traverse: this.traverse.bind(this),
                        isInUse: this.isInUse.bind(this),
                    };
                };

                return PlacesToSearch;
            })();

            /**
             * Search a report for the specified prompt using PromptUniqueId
             */
            const PromptPlacesToSearch = (function ()
            {
                /**
                 * @constructor
                 * @extends PlacesToSearch
                 */
                function PromptPlacesToSearch(promptModel)
                {
                    PlacesToSearch.call(this, promptModel, "_prompt");
                    this.usageRoots =
                    {
                        sections: this.usageRootSections.bind(this),
                        searchParameters: this.usageRootSearchParameters.bind(this),
                        prompts: this.usageRootPrompts.bind(this)
                    };
                }

                PromptPlacesToSearch.prototype = Object.create(PlacesToSearch.prototype);
                PromptPlacesToSearch.prototype.constructor = PromptPlacesToSearch;

                /** @override */
                PromptPlacesToSearch.prototype.setIdentifierField = function () { this.identifierField = this.model?.PromptUniqueId; };

                PromptPlacesToSearch.prototype.usageRootSections = function (model, predicate)
                {
                    const self = this;
                    const usageNode = new UsageNode("Sections");

                    designer.find(".jsHeaderSection").each(function ()
                    {
                        self.traverseHeaderFooter($(this), usageNode, predicate);
                    });

                    designer.find(".jsMainSection").each(function ()
                    {
                        self.traverseSection($(this), usageNode, predicate);
                    });

                    designer.find(".jsFooterSection").each(function ()
                    {
                        self.traverseHeaderFooter($(this), usageNode, predicate);
                    });

                    return usageNode;
                };

                PromptPlacesToSearch.prototype.usageRootSearchParameters = function (model, predicate)
                {
                    const self = this;
                    const usages = new UsageNode("Search Parameters");
                    skyward.reporting.searchParameters.model.forEach(function (searchParameter)
                    {
                        if (self.includesBindingString(searchParameter.value))
                        {
                            usages.addChild(new UsageNode(searchParameter.key, undefined, true, searchParameter.required));
                        }
                    });
                    return usages;
                };

                PromptPlacesToSearch.prototype.usageRootPrompts = function (model, predicate)
                {
                    const self = this;
                    const usages = new UsageNode("Prompts");
                    if (model)
                    {
                        model.forEach(function (otherPrompt)
                        {
                            if (otherPrompt !== self.model && otherPrompt.usesPrompt(self.model))
                            {
                                usages.addChild(new UsageNode(otherPrompt.Label, undefined, true));
                            }
                        });
                    }
                    return usages;
                };

                /** @override */
                PromptPlacesToSearch.prototype.usedInHiddenCondition = function (isHiddenCondition)
                {
                    return !!isHiddenCondition && (
                        this.stringMatchesIdentifier(isHiddenCondition.LeftOperand?.PromptUniqueID) ||
                        this.stringMatchesIdentifier(isHiddenCondition.RightOperand?.PromptUniqueID));
                };

                PromptPlacesToSearch.prototype.traverseHeaderFooter = function (section, parentNode, predicate)
                {
                    const sectionToolbar = section.children(".sectionToolbar");
                    const sectionName = sectionToolbar.data().reportLabelText;
                    const sectionData = getSectionData(section);
                    const newNode = new UsageNode(sectionName, new SourceDetail(SourceTypes.Section, sectionData.sectionId, section));

                    this.traverseReportLines(section, newNode, predicate);

                    if (predicate(newNode))
                    {
                        parentNode.addChild(newNode);
                    }
                };

                /** @override */
                PromptPlacesToSearch.prototype.traverseSectionAction = function (section, parentNode, predicate)
                {
                    const sectionData = getSectionData(section);

                    if (sectionData && sectionData.promptForSortOrder === true && sectionData.sortPromptGuid === this.model.PromptGuid)
                    {
                        parentNode.addChild(new UsageNode("Sort Order Prompt", new SourceDetail(SourceTypes.Section, sectionData.sectionId, section), true, true));
                    }
                };

                /** @override */
                PromptPlacesToSearch.prototype.traverseReportLinesAction = function (section, line, parentNode, predicate)
                {
                    const lineData = line.data();

                    if (lineData.relatedReportSortId)
                    {
                        const sortData = getSortDataByReportSortID(section, lineData.relatedReportSortId);
                        if (this.stringMatchesIdentifier(sortData.PageBreakPromptUniqueId))
                        {
                            const name = sortData.RelativeDataPath ?? sortData.FieldName;
                            parentNode.addChild(new UsageNode(`Related Sort '${name}' page break condition`, new SourceDetail(SourceTypes.Sort, sortData.ReportSortID, line), true, true));
                        }
                    }

                    if (this.stringMatchesIdentifier(lineData.printAtBottomOfPagePromptUniqueId))
                    {
                        parentNode.addChild(new UsageNode("Print at bottom of page condition", new SourceDetail(SourceTypes.Line, lineData.lineId, line), true, true));
                    }

                    if (this.stringMatchesIdentifier(lineData.printReportFooterOnNewPagePromptUniqueId))
                    {
                        parentNode.addChild(new UsageNode("Print on new page condition", new SourceDetail(SourceTypes.Line, lineData.lineId, line), true, true));
                    }

                    if (this.stringMatchesIdentifier(lineData.repeatLineAfterStartPromptUniqueId))
                    {
                        parentNode.addChild(new UsageNode("Repeat line at top condition", new SourceDetail(SourceTypes.Line, lineData.lineId, line), true, true));
                    }
                };

                /** @override */
                PromptPlacesToSearch.prototype.traverseSorts = function (section, parentNode)
                {
                    for (const sort of getSectionSorts(section))
                    {
                        if (this.stringMatchesIdentifier(sort.PageBreakPromptUniqueId))
                        {
                            const name = sort.DisplayName ?? sort.RelativeDataPath ?? sort.FieldName;
                            parentNode.addChild(new UsageNode(`Sort '${name}' page break condition`, new SourceDetail(SourceTypes.Sort, sort.ReportSortID, section), true));
                        }
                    }
                };

                return PromptPlacesToSearch;
            })();

            /**
             * Search a report for the specified field using AbsoluteFieldPath
             */
            const FieldPlacesToSearch = (function ()
            {
                /**
                 * @constructor
                 * @param {Object} fieldModel - The field model to search for
                 * @param {string} [selectedSectionId] - The ID of the selected section. Only fields in this section will be searched. If omitted, no section filtering is applied.
                 * @extends PlacesToSearch
                 */
                function FieldPlacesToSearch(fieldModel, selectedSectionId = null)
                {
                    PlacesToSearch.call(this, fieldModel, null, selectedSectionId ? `[data-section-id='${selectedSectionId}']` : null);
                    this.usageRoots =
                    {
                        sections: this.usageRootSections.bind(this)
                    };
                }

                FieldPlacesToSearch.prototype = Object.create(PlacesToSearch.prototype);
                FieldPlacesToSearch.prototype.constructor = FieldPlacesToSearch;

                /** @override */
                FieldPlacesToSearch.prototype.setIdentifierField = function () { this.identifierField = this.model?.absoluteFieldPath; };

                FieldPlacesToSearch.prototype.usageRootSections = function (objectModel, predicate)
                {
                    const self = this;
                    const usages = new UsageNode("Sections");

                    let sections = designer.find(".jsMainSection");

                    if (this.filter)
                    {
                        sections = sections.filter((i, s) => $(s).has(this.filter).length > 0);
                    }

                    sections.each(function ()
                    {
                        self.traverseSection($(this), usages, predicate);
                    });

                    return usages;
                };

                /** @override */
                FieldPlacesToSearch.prototype.traverseSorts = function (section, node)
                {
                    for (const sort of getSectionSorts(section))
                    {
                        if (this.stringMatchesIdentifier(sort.AbsoluteFieldPath))
                        {
                            const name = sort.DisplayName ?? sort.RelativeDataPath ?? sort.FieldName;
                            node.addChild(new UsageNode(`Sort '${name}'`, new SourceDetail(SourceTypes.Sort, sort.ReportSortID, section), true));
                        }
                    }
                };

                /** @override */
                FieldPlacesToSearch.prototype.usedInHiddenCondition = function (isHiddenCondition)
                {
                    return !!isHiddenCondition && (
                        this.stringMatchesIdentifier(isHiddenCondition.LeftOperand?.FieldPath) ||
                        this.stringMatchesIdentifier(isHiddenCondition.RightOperand?.FieldPath));
                };

                return FieldPlacesToSearch;
            })();

            /**
             * Search a report for the specified variable using UniqueId
             */
            const VariablePlacesToSearch = (function ()
            {
                /**
                 * @constructor
                 * @extends PlacesToSearch
                 */
                function VariablePlacesToSearch(variableModel)
                {
                    PlacesToSearch.call(this, variableModel, "_variable");
                    this.usageRoots = {
                        sections: this.usageRootSections.bind(this),
                    };
                }

                VariablePlacesToSearch.prototype = Object.create(PlacesToSearch.prototype);
                VariablePlacesToSearch.prototype.constructor = VariablePlacesToSearch;

                /** @override */
                VariablePlacesToSearch.prototype.setIdentifierField = function () { this.identifierField = this.model?.uniqueId; };

                VariablePlacesToSearch.prototype.usageRootSections = function (objectModel, predicate)
                {
                    const self = this;
                    const usages = new UsageNode("Sections");

                    designer.find(".jsMainSection").each(function ()
                    {
                        self.traverseSection($(this), usages, predicate);
                    });

                    return usages;
                };

                VariablePlacesToSearch.prototype.includesVariableString = function (objectToSearch)
                {
                    return this.includesFormattedString(objectToSearch, this.model.name, t => `Variable: ${t}`);
                };

                /** @override */
                VariablePlacesToSearch.prototype.traverseReportLinesAction = function (section, line, parentNode, predicate)
                {
                    const lineData = line.data();

                    if (this.includesReferenceString(lineData.variableIdsToReset))
                    {
                        parentNode.addChild(new UsageNode("Variable to reset", new SourceDetail(SourceTypes.Line, lineData.lineId, line), true));
                    }
                };

                /** @override */
                VariablePlacesToSearch.prototype.traverseReportColumnsAction = function (line, column, parentNode, predicate)
                {
                    const columnData = column.data();

                    if (this.stringMatchesIdentifier(columnData.variableIdToGet))
                    {
                        parentNode.used = true;
                    }

                    if (this.stringMatchesIdentifier(columnData.variableIdToSet))
                    {
                        parentNode.addChild(new UsageNode("Variable to set", new SourceDetail(SourceTypes.Column, columnData.columnId, column), true));
                    }

                    if (this.includesVariableString(columnData.displayCalculation))
                    {
                        parentNode.addChild(new UsageNode("Aggregate calculation", new SourceDetail(SourceTypes.Column, columnData.columnId, column), true));
                    }
                }

                return VariablePlacesToSearch;
            })();

            /**
             * Search a report for the specified column using ColumnId
             */
            const ColumnPlacesToSearch = (function ()
            {
                /**
                 * @constructor
                 * @extends PlacesToSearch
                 */
                function ColumnPlacesToSearch(columnModel)
                {
                    PlacesToSearch.call(this, columnModel, "_column");
                    this.usageRoots =
                    {
                        sections: this.usageRootSections.bind(this),
                    };
                }

                ColumnPlacesToSearch.prototype = Object.create(PlacesToSearch.prototype);
                ColumnPlacesToSearch.prototype.constructor = ColumnPlacesToSearch;

                /** @override */
                ColumnPlacesToSearch.prototype.setIdentifierField = function () { this.identifierField = this.model?.columnId; };

                ColumnPlacesToSearch.prototype.usageRootSections = function (objectModel, predicate)
                {
                    const self = this;
                    const usages = new UsageNode("Sections");

                    designer.find(".jsMainSection").each(function ()
                    {
                        self.traverseSection($(this), usages, predicate);
                    });

                    return usages;
                };

                /** @override */
                ColumnPlacesToSearch.prototype.usedInHiddenCondition = function (isHiddenCondition)
                {
                    return !!isHiddenCondition && (
                        this.stringMatchesIdentifier(isHiddenCondition.LeftOperand?.ColumnID) ||
                        this.stringMatchesIdentifier(isHiddenCondition.RightOperand?.ColumnID));
                };

                return ColumnPlacesToSearch;
            })();

            /**
             * Simple search for aggregate column usages on the same line
             */
            const SimpleAggregateColumnPlacesToSearch = (function ()
            {
                /**
                 * @constructor
                 * @extends PlacesToSearch
                 */
                function SimpleAggregateColumnPlacesToSearch(column)
                {
                    PlacesToSearch.call(this, column, "_column", column);
                    this.usageRoots =
                    {
                        sections: this.usageRootSections.bind(this),
                    };
                }

                SimpleAggregateColumnPlacesToSearch.prototype = Object.create(PlacesToSearch.prototype);
                SimpleAggregateColumnPlacesToSearch.prototype.constructor = SimpleAggregateColumnPlacesToSearch;

                /** @override */
                SimpleAggregateColumnPlacesToSearch.prototype.setIdentifierField = function () { this.identifierField = this.model?.data().columnId; };

                SimpleAggregateColumnPlacesToSearch.prototype.usageRootSections = function (objectModel, predicate)
                {
                    const self = this;
                    const usages = new UsageNode("Sections");

                    designer.find(".jsMainSection").each(function ()
                    {
                        self.traverseSection($(this), usages, predicate);
                    });
                    return usages;
                };

                /** @override */
                SimpleAggregateColumnPlacesToSearch.prototype.traverseFilter = function (section, parentNode, predicate) { };

                /** @override */
                SimpleAggregateColumnPlacesToSearch.prototype.traverseCalculatedFields = function (section, parentNode, predicate) { };

                /** @override */
                SimpleAggregateColumnPlacesToSearch.prototype.usedInHiddenCondition = function (isHiddenCondition)
                {
                    return !!isHiddenCondition && (
                        this.stringMatchesIdentifier(isHiddenCondition.LeftOperand?.ColumnID) ||
                        this.stringMatchesIdentifier(isHiddenCondition.RightOperand?.ColumnID));
                };

                /** @override */
                SimpleAggregateColumnPlacesToSearch.prototype.includesBindingString = function (objectToSearch, searchForOverride = null)
                {
                    return false;
                };

                return SimpleAggregateColumnPlacesToSearch;
            })();

            const promptPlacesToSearch = function (promptModel)
            {
                return new PromptPlacesToSearch(promptModel).getExposedMethods();
            };

            const fieldPlacesToSearch = function (fieldModel, selectedSectionId)
            {
                return new FieldPlacesToSearch(fieldModel, selectedSectionId).getExposedMethods();
            };

            const variablePlacesToSearch = function (variableModel)
            {
                return new VariablePlacesToSearch(variableModel).getExposedMethods();
            };

            const columnPlacesToSearch = function (columnModel)
            {
                return new ColumnPlacesToSearch(columnModel).getExposedMethods();
            };

            const simpleAggregateColumnPlacesToSearch = function (column)
            {
                return new SimpleAggregateColumnPlacesToSearch(column).getExposedMethods();
            };

            return { openModal, buildUsageLocationsElement, usageLocationOnlyIncludesSelf, promptPlacesToSearch, fieldPlacesToSearch, variablePlacesToSearch, columnPlacesToSearch, simpleAggregateColumnPlacesToSearch, SourceTypes, HiddenConditionUsageNode };
        })();

        var initializeVariables = function (variableData, viewTarget, canvas)
        {
            var variables = skyward.reporting.variables.init(variableData, viewTarget, canvas);
            var variablesToReset = {};

            var draggableOptions = {
                cursorAt: { top: 0, left: 0 },
                delay: 150,
                scope: 'designer',
                helper: function ()
                {
                    var item = $(this);
                    return $("<div/>")
                        .css({ "z-index": 999, "display": undefined, "background-color": "white", "border": "2px dotted", "width": "auto", "height": (DEFAULT_COLUMN_HEIGHT + "px") })
                        .data(item.data())
                        .append(item.find(".js-name").clone());
                },
                appendTo: $(document.body),
                grid: [1, 1],
                opacity: 0.8
            };
            var setupReportDesignerForVariables = function ()
            {
                variables.viewModel.view.find(".variable").draggable(draggableOptions);
                // TODO Would be nice to find a clean way to populate this in the viewEngine
                variables.collectionModel.forEach(function (v)
                {
                    var columns = v.gotBy();
                    var labelText = "Variable: " + v.name;
                    columns.data({
                        fieldType: v.dataTypeCategoryName,
                        designerText: labelText,
                    })
                        .attr({
                            "data-field-type": v.dataTypeCategoryName,
                            "data-designer-text": labelText,
                        })
                        .find(".variableLabel").text(labelText);
                });
            };
            var confirmVariableRemoved = function (model)
            {
                if (model.isInUse())
                {
                    var removeReferences = function ()
                    {
                        model.requiredBy().remove();
                        var setBy = model.setBy();
                        setBy.data("variableIdToSet", "");
                        if (setBy.is(".ui-selected"))
                        {
                            setColumnVariablePropertiesValues(); // passing no parameters clears the value
                        }
                        $.each(model.resetBy(), function (i, row)
                        {
                            var variableIds = $(row).data().variableIdsToReset;
                            variableIds.splice(variableIds.indexOf(model.uniqueId), 1);
                        });
                    };
                    var undoRemoval = function ()
                    {
                        variables.collectionModel.add(model);
                    };

                    skyward.modalLayer.confirmDelete("Variable", "This Variable is currently in use.")
                        .done(removeReferences)
                        .fail(undoRemoval)
                        .always(updateHiddenField);
                }
                else
                {
                    updateHiddenField();
                }

                skyward.reporting.updateVariableUsageLocations();
            };
            var variableNameChanged = function (model)
            {
                $.each(model.gotBy(), function ()
                {
                    var jqThis = $(this);
                    jqThis.find('.reportLineLabel').text(getColumnLabelWithPreText(jqThis));
                });
                // setting variables is not supported by multiple selected columns
                if (currentSelectedColumns.areColumnsSelected() && model.uniqueId && currentSelectedColumns.getFirstSelectedColumn().data("variableIdToSet") == model.uniqueId)
                {
                    setColumnVariablePropertiesValues(model);
                }
            };
            var variableViewModelAdded = function (viewModel)
            {
                viewModel.view.draggable(draggableOptions);
            };
            var insertVariableColumn = skyward.reporting.insertVariableColumn = function (model, view, position, insertedLine)
            {
                insertedLine = insertedLine ?? currentRow ?? currentSelectedColumns.getRowByFirstSelectedColumn();
                if (!insertedLine)
                {
                    return;
                }

                insertColumnHelperFunction(
                    {
                        newItem: createNewColumn(
                            {
                                type: COLUMN_TYPES.VARIABLE_COLUMN,
                                relatedItem: view,
                                dataTypeCategoryName: model.dataTypeCategoryName,
                                variableIdToGet: model.uniqueId,
                                variableBinding: model.getBindingString(),
                                text: "Variable: " + model.name
                            }),
                        reportLine: insertedLine,
                        section: (insertedLine).closest(".sectionSelected"),
                        position: position || { top: null, left: null },
                        autoCreatedColumn: true
                    });
            };
            skyward.reporting.selectVariableToSet = function (button)
            {
                // not supported when multiple columns are selected
                const currentSelectedColumn = currentSelectedColumns.getFirstSelectedColumn();
                var data = $(currentSelectedColumn).data();
                var fieldType = skyward.reporting.reportColumn.getFieldType(data)
                    || data.columnFieldType
                    || (variables.collectionModel.getById(data.variableIdToGet) || {}).dataTypeCategoryName
                    || "";

                if (data.fieldColumnType === COLUMN_TYPES.CALCULATED_COLUMN)
                {
                    fieldType = DATA_TYPES.NUMBER_DECIMAL;
                }
                else if (fieldType?.startsWith("Number") && fieldType !== DATA_TYPES.NUMBER_DECIMAL)
                {
                    fieldType = DATA_TYPES.NUMBER_LONG;
                }
                else if (!fieldType)
                {
                    fieldType = DATA_TYPES.STRING;
                }
                let allowAddNewVar = data.fieldColumnType !== COLUMN_TYPES.GROUP_COLUMN && !fieldType?.startsWith("String Enum");
                variables.viewModel.selectVariableToSet(fieldType, button, currentSelectedColumn.text(), allowAddNewVar)
                    .done(function (variableModel)
                    {
                        if (!variableModel)
                        {
                            return;
                        }
                        currentSelectedColumn.data("variableIdToSet", variableModel.uniqueId).attr("data-variable-id-to-set", variableModel.uniqueId);
                        setColumnVariablePropertiesValues(variableModel);
                        editorVariableToSet.trigger('change');
                    });
            };

            skyward.reporting.selectVariablesToReset = function (variableIDsToReset)
            {
                variablesToReset = variables.viewModel.selectVariablesToReset(editorVariablesToReset, variableIDsToReset, variablesToReset);
            };

            skyward.reporting.getVariableIDsToReset = function ()
            {
                var variableIDsToReset = [];
                var selectedVariablesToReset = variablesToReset.filter(function (value) { return value.checked === true; });
                selectedVariablesToReset.forEach(function (value)
                {
                    variableIDsToReset.push(value.model.uniqueId);
                });
                return variableIDsToReset;
            };

            const openVariableUsageLocationsModal = function (model)
            {
                const placesToSearch = usageLocations.variablePlacesToSearch(model);
                usageLocations.openModal("variable-usages-dialog", placesToSearch.traverse);
            };

            skyward.reporting.updateVariableUsageLocations = function ()
            {
                variables.viewModel.updateVariableUsageLocations();
            };

            _reportDesignerObserver.observe(variables.viewModel, "insertRequested", insertVariableColumn);
            _reportDesignerObserver.observe(variables.viewModel, "add", variableViewModelAdded);
            _reportDesignerObserver.observe(variables.collectionModel, "model:name", variableNameChanged);
            _reportDesignerObserver.observe(variables.collectionModel, "add", updateHiddenField);
            _reportDesignerObserver.observe(variables.collectionModel, "remove", confirmVariableRemoved);
            _reportDesignerObserver.observe(variables.collectionModel, "contentChanged", updateHiddenField);
            _reportDesignerObserver.observe(variables.viewModel, "openUsageLocations", openVariableUsageLocationsModal);
            setupReportDesignerForVariables();
        };

        var updateDesignerSidebarCalculatedFieldList = function (sectionData)
        {
            skyward.calculatedFieldList.updateCalculatedFieldList(
                skyward.treebrowse.getTreeBrowseDataByName("reportObjectBrowser"),
                Object.values(CalculatedFields_Model.AllFields()),
                "#" + $(".calculatedFieldListToolbar").next().addIds().attr("id"),
                sectionData.rootModule,
                sectionData.rootObject,
                sectionData.entireRelationshipPath,
                undefined
            );
        };

        function showLegend()
        {
            const info = $.ajax(skyward.global.virtualDir + "Reporting/Report/Legend",
            {
                data:
                {
                    renderType: "contentOnly"
                }
            });
            skyward.modalLayer.showDialog("Legend", info, [skyward.modalLayer.DEFAULT_CLOSE_BUTTON], { anchorTo: this });
        }

        let gatherDataForError = function ()
        {
            return {
                reportDefinition: JSON.stringify(skyward.reporting.getDesignerJson())
            };
        };

        // Event handlers
        let events =
        {
            showLegend,
            initCanvas
        };
        skyward.events.registerEvents("reporting", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        skyward.reporting = skyward.reporting || {};
        skyward.reporting.userCondition = skyward.reporting.userCondition || {};

        //TODO: until PR 5918928 updates to user conditions will also need to consider reportDefinitionViewer\shared.tsx
        skyward.reporting.userCondition.init = function (userConditionWrapper)
        {
            const wrapperElement = userConditionWrapper;

            const leftOperandElement = wrapperElement.find('.userConditionValueSelectorDisplay.leftOperand');
            const rightOperandElement = wrapperElement.find('.userConditionValueSelectorDisplay.rightOperand');

            const booleanConditionElement = wrapperElement.find('.booleanConditionComboBox');
            const conditionElement = wrapperElement.find('.conditionTypeSelector');

            //Public
            function getPromptDataFromPrompt(valueBox, promptContainer)
            {
                const promptLabel = promptContainer.find(".promptLabel");
                let name = promptLabel.val();

                if (!name || !name.length)
                {
                    name = "Prompt";
                }
                return buildPromptData(valueBox, name);
            }

            //Public
            function getPromptData(valueBox, currentColumn, currentRow, currentSection)
            {
                let name;
                if (currentColumn)
                {
                    name = currentColumn.data("designerText");
                }
                else
                {
                    name = currentSection.data("displayName");
                    if (!currentRow.hasClass("sectionToolbar"))
                    {
                        name = name ? name + " " + currentRow.data("reportLabelText") : currentRow.data("reportLabelText");
                    }
                }

                return buildPromptData(valueBox, name);
            }

            function buildPromptData(valueBox, name)
            {
                const result = {};

                result.Label = "Hide " + name;
                if (valueBox.hasClass("rightOperand"))
                {
                    const leftOperandElementData = leftOperandElement.data();
                    result.InputType = leftOperandElementData.fieldType;
                    result.SpecificTypeRequired = true;

                    if (leftOperandElementData.sectionIDHasAnyDetailRows)
                    {
                        result.Label += " When Detail Sections Have Any Rows"
                    }
                }
                else
                {
                    result.InputType = "Boolean";
                }
                result.PresenceType = "Required";

                return result;
            }

            function getRightOperandClassSelectorForType(dataType, isCustomPrompt)
            {
                let classSelector;

                if (isCustomPrompt || dataType === "Prompt" || dataType === "Column" || dataType.startsWith("String Enum"))
                {
                    classSelector = ".userConditionValueSelectorDisplay";
                }
                else if (dataType.startsWith("Number"))
                {
                    if (dataType == "Number Decimal")
                    {
                        classSelector = ".decimalValueSelector";
                    }
                    else
                    {
                        classSelector = ".numericValueSelector";
                    }
                }
                else if (dataType === "Boolean")
                {
                    classSelector = ".booleanValueSelector";
                }
                else if (dataType === "DateTime")
                {
                    classSelector = ".dateValueSelector";
                }
                else if (dataType === "TimeSpan")
                {
                    classSelector = ".timeSpanValueSelector";
                }
                else if (dataType == "Time")
                {
                    classSelector = ".timeValueSelector";
                }
                else if (dataType === "String")
                {
                    classSelector = ".stringValueSelector";
                }
                return classSelector;
            }

            function defaultRightOperandInputIfEmpty(dataType, element)
            {
                if (!skyward.controls.getValue(element))
                {
                    let defaultValue = "";
                    if (dataType.startsWith("Number"))
                    {
                        defaultValue = 0;
                    }
                    else if (dataType === "Boolean")
                    {
                        defaultValue = "True";
                    }
                    skyward.controls.setValue(element, defaultValue, true);
                }
            }

            function getRightOperandInputElementForType(dataType, isCustomPrompt)
            {
                return wrapperElement.find(getRightOperandClassSelectorForType(dataType, isCustomPrompt)).find(".isHiddenValueSelector").addBack(".isHiddenValueSelector");
            }

            function getRightOperandDisplayElementForType(dataType, isCustomPrompt)
            {
                return wrapperElement.find(getRightOperandClassSelectorForType(dataType, isCustomPrompt)).find(".isHiddenValueDisplay").addBack(".isHiddenValueDisplay");
            }

            function showRightOperandInputForType(dataType, isCustomPrompt)
            {
                const rightOperands = wrapperElement.find(".rightOperandOptions");
                rightOperands.each(function ()
                {
                    skyward.controls.show($(this), false);
                });

                const valueSelectors = rightOperands.find(".isHiddenValueDisplay");
                valueSelectors.each(function ()
                {
                    skyward.controls.hide($(this), false);
                });

                skyward.controls.show(getRightOperandDisplayElementForType(dataType, isCustomPrompt), false);
            }

            //Public
            function setIsHiddenCondition(isHiddenCondition, selectedName, getSvgByDataTypeFunction, selectedColumnID, getColumnLabelMethod)
            {
                wrapperElement.find(".selectedName").text(selectedName);
                leftOperandElement.removeData();
                rightOperandElement.removeData();

                if (isHiddenCondition && isHiddenCondition.LeftOperand && isHiddenCondition.RightOperand)
                {
                    const promptLeft = skyward.reporting.prompts.promptCollection.Get(isHiddenCondition.LeftOperand.PromptUniqueID);
                    const calculatedFieldLeft = skyward.reporting.calculatedFields.Get(isHiddenCondition.LeftOperand.CalculatedFieldGuid);
                    const fieldPathLeft = isHiddenCondition.LeftOperand.FieldPath;
                    const boolValueLeft = isHiddenCondition.LeftOperand.Value;
                    const columnIDLeft = isHiddenCondition.LeftOperand.ColumnID;
                    const dataTypeLeft = isHiddenCondition.LeftOperand.DataType;
                    const displayNameLeft = isHiddenCondition.LeftOperand.DisplayName;
                    const isCustomPromptLeft = promptLeft != null && promptLeft.Type === skyward.reporting.enummaps.PromptTypes.CustomSingleSelect;
                    const sectionIDHasAnyDetailRowsLeft = isHiddenCondition.LeftOperand.SectionIDHasAnyDetailRows;
                    const parametersLeft = isHiddenCondition.LeftOperand.Parameters;
                    const isCalculatedLeft = isHiddenCondition.LeftOperand.IsCalculated;
                    const isOperationLeft = isHiddenCondition.LeftOperand.IsOperation;

                    const promptRight = skyward.reporting.prompts.promptCollection.Get(isHiddenCondition.RightOperand.PromptUniqueID);
                    const calculatedFieldRight = skyward.reporting.calculatedFields.Get(isHiddenCondition.RightOperand.CalculatedFieldGuid);
                    const fieldPathRight = isHiddenCondition.RightOperand.FieldPath;
                    const columnIDRight = isHiddenCondition.RightOperand.ColumnID;
                    const dataTypeRight = isHiddenCondition.RightOperand.DataType;
                    const displayNameRight = isHiddenCondition.RightOperand.DisplayName;
                    const parametersRight = isHiddenCondition.RightOperand.Parameters;
                    const isCalculatedRight = isHiddenCondition.RightOperand.IsCalculated;
                    const isOperationRight = isHiddenCondition.RightOperand.IsOperation;

                    leftOperandElement.empty();
                    rightOperandElement.empty();
                    const svgLeft = getSvgByDataTypeFunction(dataTypeLeft, "TreeBrowse");
                    const svgRight = getSvgByDataTypeFunction(dataTypeRight, "TreeBrowse");

                    if (columnIDRight == undefined && promptRight == undefined && fieldPathRight == undefined)
                    {
                        showRightOperandInputForType(dataTypeRight, isCustomPromptLeft);
                    }
                    else if (columnIDRight != undefined || fieldPathRight != undefined)
                    {
                        showRightOperandInputForType("Column", isCustomPromptLeft);
                    }
                    else
                    {
                        showRightOperandInputForType("Prompt", isCustomPromptLeft);
                    }

                    const leftValue =
                    {
                        prompt: promptLeft,
                        calculatedField: calculatedFieldLeft,
                        columnID: columnIDLeft,
                        fieldPath: fieldPathLeft,
                        boolValue: boolValueLeft,
                        sectionIDHasAnyDetailRows: sectionIDHasAnyDetailRowsLeft,
                        displayName: displayNameLeft,
                        dataType: dataTypeLeft,
                        parameters: parametersLeft,
                        isCalculated: isCalculatedLeft,
                        isOperation: isOperationLeft
                    }

                    setOperandValues(selectedColumnID, leftOperandElement, isHiddenCondition.LeftOperand, svgLeft, leftValue, getColumnLabelMethod);

                    leftOperandElement.data("fieldType", dataTypeLeft);

                    const rightValue =
                    {
                        prompt: promptRight,
                        calculatedField: calculatedFieldRight,
                        columnID: columnIDRight,
                        fieldPath: fieldPathRight,
                        boolValue: null,
                        displayName: displayNameRight,
                        dataType: dataTypeRight,
                        parameters: parametersRight,
                        isCalculated: isCalculatedRight,
                        isOperation: isOperationRight
                    }

                    setOperandValues(selectedColumnID, rightOperandElement, isHiddenCondition.RightOperand, svgRight, rightValue, getColumnLabelMethod);

                    rightOperandElement.data("fieldType", dataTypeRight);

                    if (useBooleanConditionElement(dataTypeLeft))
                    {
                        booleanConditionElement.val(isHiddenCondition.Condition);
                    }
                    else
                    {
                        conditionElement.val(isHiddenCondition.Condition);
                    }

                    if (isHiddenCondition.RightOperand.Value != null)
                    {
                        if (isCustomPromptLeft)
                        {
                            const customValue = isHiddenCondition.RightOperand.Value;
                            const customDisplayValue = promptLeft.getSelectionOptionDisplayValueByKey(customValue) ?? customValue;
                            rightOperandElement.data("customValue", customValue);
                            rightOperandElement.data("customDisplayValue", customDisplayValue);
                            rightOperandElement.text(customDisplayValue);
                        }
                        else if (isHiddenCondition.RightOperand.DataType.startsWith("String Enum"))
                        {
                            rightOperandElement.data("enumValue", isHiddenCondition.RightOperand.Value);
                            rightOperandElement.data("enumDisplayValue", isHiddenCondition.RightOperand.EnumDisplayValue);
                            rightOperandElement.text(isHiddenCondition.RightOperand.EnumDisplayValue);
                        }
                        else
                        {
                            const rightOperandSelector = getRightOperandInputElementForType(dataTypeLeft, isCustomPromptLeft);
                            skyward.controls.setValue(rightOperandSelector, isHiddenCondition.RightOperand.Value, true);
                        }
                    }

                    toggleConditionsForType(dataTypeLeft);
                }
                else
                {
                    wrapperElement.find(".rightOperandOptions").hide();

                    leftOperandElement.data("promptUniqueId", null);
                    leftOperandElement.data("calculatedFieldName", null);
                    leftOperandElement.data("fieldName", null);
                    leftOperandElement.data("boolvalue", false);
                    leftOperandElement.text("False");
                    leftOperandElement.data("displayName", null);
                    leftOperandElement.data("dataType", null);
                    leftOperandElement.data("parameters", null);
                    leftOperandElement.data("displayName", null);
                    leftOperandElement.data("isCalculated", null);
                    leftOperandElement.data("isOperation", null);

                    conditionElement.val("EqualTo");
                    booleanConditionElement.val("EqualTo");

                    clearIsHiddenValueSelectors();
                    rightOperandElement.data("promptUniqueId", null);
                    rightOperandElement.data("calculatedFieldName", null);
                    rightOperandElement.data("enumValue", null);
                    rightOperandElement.data("customValue", null);
                    rightOperandElement.data("fieldName", null);
                    rightOperandElement.data("boolvalue", false);
                    rightOperandElement.text("False");
                    rightOperandElement.data("displayName", null);
                    rightOperandElement.data("dataType", null);
                    rightOperandElement.data("parameters", null);
                    rightOperandElement.data("isCalculated", null);
                    rightOperandElement.data("isOperation", null);
                }
            }

            function setOperandValues(selectedColumnID, operandEditor, operand, svg, valueCollection, getColumnLabelMethod)
            {
                if (valueCollection.prompt)
                {
                    setIsHiddenOperandPrompt(valueCollection.prompt, operandEditor);
                }
                else if (valueCollection.calculatedField)
                {
                    operandEditor.html(svg).append(document.createTextNode(valueCollection.calculatedField.fieldName));
                    operandEditor.data("calculatedFieldName", valueCollection.calculatedField.id);
                }
                else if (valueCollection.columnID)
                {
                    let columnLabel = "Current Column Value";
                    if (selectedColumnID != valueCollection.columnID)
                    {
                        columnLabel = getColumnLabelMethod(valueCollection.columnID);
                    }

                    operandEditor.html(document.createTextNode(columnLabel));
                    operandEditor.data("columnId", valueCollection.columnID);
                }
                else if (valueCollection.fieldPath)
                {
                    operandEditor.html(svg).append(document.createTextNode(operand.FieldDisplayText));
                    operandEditor.data("fieldName", valueCollection.fieldPath);
                }
                else if (valueCollection.boolValue != null)
                {
                    wrapperElement.find(".rightOperandOptions").hide();
                    const boolValueString = valueCollection.boolValue.toString().capitalize();

                    operandEditor.html(document.createTextNode(boolValueString));
                    operandEditor.data("boolvalue", valueCollection.boolValue);
                }
                else if (valueCollection.sectionIDHasAnyDetailRows)
                {
                    operandEditor.html(svg).append(document.createTextNode("Detail Sections Have Any Rows"));
                    operandEditor.data("sectionIdHasAnyDetailRows", valueCollection.sectionIDHasAnyDetailRows);
                }

                operandEditor.data("displayName", valueCollection.displayName);
                operandEditor.data("dataType", valueCollection.dataType);
                operandEditor.data("parameters", valueCollection.parameters);
                operandEditor.data("isCalculated", valueCollection.isCalculated);
                operandEditor.data("isOperation", valueCollection.isOperation);
            }

            //Public
            function setIsHiddenOperandPrompt(prompt, operandEditor)
            {
                const svg = skyward.svg.getSvg(prompt.getIconType(), "TreeBrowse");
                operandEditor.html(svg).append(document.createTextNode(prompt.Label));
                operandEditor.data("promptUniqueId", prompt.PromptUniqueId);
            }

            function getAlwaysTrueCondition()
            {
                return {
                    Condition: "EqualTo",
                    LeftOperand: {
                        Value: true,
                        DataType: "Boolean"
                    },
                    RightOperand: {
                        Value: true,
                        DataType: "Boolean"
                    }
                };
            }

            //Public
            function getUpdatedIsHiddenCondition()
            {
                const leftOperandElementData = leftOperandElement.data();
                const rightOperandElementData = rightOperandElement.data();

                const promptUniqueIDLeft = leftOperandElementData.promptUniqueId;
                const calculatedFieldGuidLeft = leftOperandElementData.calculatedFieldName;
                const fieldPathLeft = leftOperandElementData.fieldName;
                const boolValueLeft = leftOperandElementData.boolvalue;
                const columnIDLeft = leftOperandElementData.columnId;
                const promptLeft = skyward.reporting.prompts.promptCollection.Get(promptUniqueIDLeft);
                const isCustomPromptLeft = promptLeft != null && promptLeft.Type === skyward.reporting.enummaps.PromptTypes.CustomSingleSelect;
                const sectionIdHasAnyDetailRowsLeft = leftOperandElementData.sectionIdHasAnyDetailRows;
                const displayNameLeft = leftOperandElementData.displayName;
                const parametersLeft = leftOperandElementData.parameters;
                const isCalculatedLeft = leftOperandElementData.isCalculated;
                const isOperationLeft = leftOperandElementData.isOperation;

                const promptUniqueIDRight = rightOperandElementData.promptUniqueId;
                const calculatedFieldGuidRight = rightOperandElementData.calculatedFieldName;
                const fieldPathRight = rightOperandElementData.fieldName;
                const columnIDRight = rightOperandElementData.columnId;
                const displayNameRight = rightOperandElementData.displayName;
                const parametersRight = rightOperandElementData.parameters;
                const isCalculatedRight = rightOperandElementData.isCalculated;
                const isOperationRight = rightOperandElementData.isOperation;

                if (boolValueLeft === false)
                {
                    return null;
                }

                if (boolValueLeft === true)
                {
                    return getAlwaysTrueCondition();
                }

                let isHiddenCondition =
                {
                    Condition: null,
                    LeftOperand: {},
                    RightOperand: {}
                };

                const leftOperandDataType = leftOperandElement.data("fieldType");
                const leftOperandText = leftOperandElement.text();
                const leftOperandValues =
                {
                    columnID: columnIDLeft,
                    promptUniqueID: promptUniqueIDLeft,
                    calculatedFieldGuid: calculatedFieldGuidLeft,
                    fieldPath: fieldPathLeft,
                    value: null,
                    enumDisplayValue: null,
                    sectionIdHasAnyDetailRows: sectionIdHasAnyDetailRowsLeft,
                    displayName: displayNameLeft,
                    parameters: parametersLeft,
                    isCalculated: isCalculatedLeft,
                    isOperation: isOperationLeft
                };
                const clearHiddenCondtion = updateOperandCondition(isHiddenCondition.LeftOperand, leftOperandDataType, leftOperandText, leftOperandValues);

                if (clearHiddenCondtion)
                {
                    return null;
                }

                const rightOperandText = rightOperandElement.text();

                //skyward.controls.getValue encodes the value and we do not want an encoded value here.
                //The value will be encoded when the definition json gets posted.
                let rightValue = rightOperandElementData.enumValue ??
                    rightOperandElementData.customValue ??
                    skyward.controls.getUnencodedValue(getRightOperandInputElementForType(isHiddenCondition.LeftOperand.DataType, isCustomPromptLeft));

                const rightOperandValues =
                {
                    columnID: columnIDRight,
                    promptUniqueID: promptUniqueIDRight,
                    calculatedFieldGuid: calculatedFieldGuidRight,
                    fieldPath: fieldPathRight,
                    value: rightValue,
                    enumDisplayValue: rightOperandElementData.enumDisplayValue,
                    displayName: displayNameRight,
                    parameters: parametersRight,
                    isCalculated: isCalculatedRight,
                    isOperation: isOperationRight
                };

                updateOperandCondition(isHiddenCondition.RightOperand, isHiddenCondition.LeftOperand.DataType, rightOperandText, rightOperandValues);

                isHiddenCondition.Condition = useBooleanConditionElement(isHiddenCondition.LeftOperand.DataType) ? booleanConditionElement.val() : conditionElement.val();

                return isHiddenCondition;
            }

            function updateOperandCondition(operand, dataType, text, values)
            {
                operand.DataType = dataType;
                operand.DisplayName = values.displayName;
                operand.Parameters = values.parameters ?? [];
                operand.IsCalculated = values.isCalculated ?? false;
                operand.IsOperation = values.isOperation ?? false;

                if (values.columnID)
                {
                    operand.ColumnID = values.columnID;
                }
                else if (values.promptUniqueID)
                {
                    const prompt = skyward.reporting.prompts.promptCollection.Get(values.promptUniqueID);
                    operand.PromptUniqueID = values.promptUniqueID;
                    operand.DataType = prompt.InputType;
                }
                else if (values.calculatedFieldGuid)
                {
                    const calculatedField = skyward.reporting.calculatedFields.Get(values.calculatedFieldGuid);
                    operand.CalculatedFieldGuid = values.calculatedFieldGuid;
                    operand.DataType = calculatedField.dataType;
                }
                else if (values.fieldPath)
                {
                    operand.FieldPath = values.fieldPath;
                    operand.FieldDisplayText = text;
                }
                else if (values.value || (dataType == "String" && values.value === ""))
                {
                    operand.Value = values.value;

                    if (values.enumDisplayValue)
                    {
                        operand.EnumDisplayValue = values.enumDisplayValue;
                    }
                }
                else if (values.sectionIdHasAnyDetailRows)
                {
                    operand.SectionIDHasAnyDetailRows = values.sectionIdHasAnyDetailRows;
                }
                else
                {
                    return true;
                }

                return false;
            }

            function clearIsHiddenValueSelectors()
            {
                wrapperElement.find(".isHiddenValueSelector").each(function ()
                {
                    skyward.controls.setValue($(this), "", true);
                });
                skyward.controls.setValue(wrapperElement.find(".booleanValueSelector"), "True", true);
            }

            function useBooleanConditionElement(dataType)
            {
                return dataType === "Boolean" || dataType.startsWith("String Enum");
            }

            function toggleConditionsForType(dataType)
            {
                if (useBooleanConditionElement(dataType))
                {
                    conditionElement.hide();
                    booleanConditionElement.show();
                }
                else
                {
                    conditionElement.show();
                    booleanConditionElement.hide();
                }
            }

            //Public
            function isConditionAlwaysHidden(isHiddenCondition)
            {
                if (isHiddenCondition == null)
                {
                    return false;
                }
                return isOperandTrue(isHiddenCondition.LeftOperand) && isOperandTrue(isHiddenCondition.RightOperand)
            }

            //Public
            function isConditionAlwaysDisplayed(isHiddenCondition)
            {
                if (isHiddenCondition == null)
                {
                    return true;
                }
                return isOperandFalse(isHiddenCondition.LeftOperand) && isOperandTrue(isHiddenCondition.RightOperand)
            }

            function isOperandTrue(operand)
            {
                if (operand == null)
                {
                    return false;
                }
                return operand.DataType === "Boolean" && String(operand.Value).toLowerCase() === "true";
            }

            function isOperandFalse(operand)
            {
                if (operand == null)
                {
                    return false;
                }
                return operand.DataType === "Boolean" && String(operand.Value).toLowerCase() === "false";
            }

            //Public
            function getUserConditionOperandFilterValueSelector(button, allowOptions, columns, prompts, dataType, columnDataType, useVisibleCondition, valueSelectorClickEvents, leftPromptUniqueID = null, currentSectionID = null)
            {
                const requestingButton = $(button);
                const findConditon = useVisibleCondition ? ".conditionValue:visible" : ".conditionValue";
                const valueBox = requestingButton.closest(".conditionValuesContainer").find(findConditon);

                $.ajax({
                    url: skyward.global.virtualDir + "Reporting/Report/GetUserConditionOperandSelector",
                    type: "POST",
                    dataType: "JSON",
                    data: {
                        currentPromptsJson: skyward.extensions.encodeHtml(JSON.stringify(prompts)),
                        allowPrompts: allowOptions.prompts,
                        allowFieldSelection: allowOptions.fieldSelection,
                        allowCurrentColumnValue: allowOptions.currentColumnValue,
                        columnsJson: JSON.stringify(columns),
                        dataType: dataType,
                        allowAlwaysHidden: allowOptions.alwaysHidden,
                        columnDataType: columnDataType,
                        leftPromptUniqueID: leftPromptUniqueID,
                        allowDetailSectionsHaveAnyRows: allowOptions.detailSectionsHaveAnyRows,
                        currentSectionID: currentSectionID,
                    },
                    success: async function (data)
                    {
                        const processedHtml = await skyward.global.processViewPartHtml(data.html);
                        skyward.filterbuilder.openValueSelector(processedHtml, button, valueBox, false, false, valueSelectorClickEvents);
                    }
                });
            };

            return {
                setIsHiddenCondition: setIsHiddenCondition,
                setIsHiddenOperandPrompt: setIsHiddenOperandPrompt,
                getUpdatedIsHiddenCondition: getUpdatedIsHiddenCondition,
                isConditionAlwaysHidden: isConditionAlwaysHidden,
                isConditionAlwaysDisplayed: isConditionAlwaysDisplayed,
                getPromptData: getPromptData,
                getPromptDataFromPrompt: getPromptDataFromPrompt,
                getUserConditionOperandFilterValueSelector: getUserConditionOperandFilterValueSelector,
                elements: {
                    wrapper: wrapperElement,
                    left: leftOperandElement,
                    right: rightOperandElement,
                    boolCondition: booleanConditionElement,
                    condition: conditionElement
                }
            }
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        skyward.promptsview = skyward.promptsview || {};

        var initParametersPrompt = function (selector)
        {
            const selectorElement = $(selector);

            selectorElement.find(".reportRuntimeUserInstructions, .processRuntimePromptInstructions").each(function ()
            {
                const jqThis = $(this);
                const label = jqThis.prev();
                jqThis.css("margin-left", parseInt(label.css("margin-left")) + label.outerWidth() + "px");
            });

            const inputs = selectorElement.find(".filterValue");

            if (!inputs.length)
            {
                return;
            }

            const allReliantPrompts = [];
            // hasDependentPrompts means "has dependencies". A "dependentPrompt" is a prompt with dependents (aka a prompt with reliant prompts), not a prompt that is a dependent
            inputs.filter(".hasDependentPrompts").each(function ()
            {
                const reliantPrompt =
                {
                    input: $(this),
                    dependencies: []
                };
                reliantPrompt.container = reliantPrompt.input.parent();
                reliantPrompt.disabledMessage = reliantPrompt.container.find(".dmseDisabledMessage");

                reliantPrompt.data = reliantPrompt.input.hasClass("dmsBackingData") ? reliantPrompt.container.data() : reliantPrompt.input.data();

                allReliantPrompts.push(reliantPrompt);
            });

            if (allReliantPrompts.length > 0)
            {
                inputs.each(function ()
                {
                    const prompt =
                    {
                        input: $(this),
                        reliantPrompts: []
                    };
                    if (prompt.input.hasClass("dmsBackingData"))
                    {
                        prompt.data = prompt.input.parent().data();
                    }
                    else if (prompt.input.hasClass("multiSelectBackingData"))
                    {
                        prompt.data = prompt.input.parent(".multipleSelectBox").data();
                    }
                    else
                    {
                        prompt.data = prompt.input.data();
                    }

                    $.each(allReliantPrompts, function (index, reliantPrompt)
                    {
                        const dependencyUniqueIds = reliantPrompt.input.data("dependentPromptUniqueIds"); // DependentPromptUniqueIds are the prompts *on which this prompt depends*, not prompts that *are dependents* of another prompt
                        if (dependencyUniqueIds && dependencyUniqueIds.length > 0 && dependencyUniqueIds.indexOf(prompt.data.promptUniqueId) >= 0)
                        {
                            prompt.reliantPrompts.push(reliantPrompt);
                            reliantPrompt.dependencies.push(prompt); // Catalog all dependencies so we know when it's OK to enable an input
                        }
                    });

                    prompt.friendlyName = prompt.data.promptName;

                    let promptInputs = prompt.input.closest(".fieldWrapper").find(".filterValue");
                    if (promptInputs.length > 1)
                    {
                        let lowLabel = promptInputs.first().data().promptName;
                        prompt.friendlyName = lowLabel + ((lowLabel === prompt.friendlyName) ? " Low" : " High");
                    }

                    if (prompt.reliantPrompts.length > 0)
                    {
                        const updateReliantPrompts = function (clear)
                        {
                            for (let reliantPrompt of prompt.reliantPrompts)
                            {
                                if (clear)
                                {
                                    reliantPrompt.input.trigger("clearAll");
                                }

                                let foundInvalidDependency = false;
                                for (let dependency of reliantPrompt.dependencies)
                                {
                                    let promptValue = skyward.controls.getValue(dependency.input);
                                    if (isPromptValueBlank(promptValue))
                                    {
                                        if (dependency.data.presenceType === "Required" && dependency.input.closest(".promptFieldSet").is(":visible"))
                                        {
                                            foundInvalidDependency = true;
                                            reliantPrompt.container.children().hide();
                                            reliantPrompt.disabledMessage.text("Enter a value for " + dependency.friendlyName).show();
                                            break;
                                        }
                                    }
                                    else if (dependency.data.promptType === "Value" && dependency.data.promptMax !== undefined && dependency.data.promptMin !== undefined)
                                    {
                                        if (dependency.data.fieldType === "Number Long")
                                        {
                                            continue;
                                        }
                                        /* This won't work correctly if dependency.data.fieldType is Number Long, since we don't support using BigInt yet due to old versions of Safari on older iOS devices.
                                         * To get around this limitation we are masking the prompt to at most 18 characters instead of 19, which guaranties the input is a valid long and we can skip this validation.
                                         * See PR 5271305
                                         */

                                        let max = dependency.data.promptMax;
                                        let min = dependency.data.promptMin;

                                        if (promptValue < min || promptValue > max)
                                        {
                                            foundInvalidDependency = true;
                                            reliantPrompt.container.children().hide();
                                            reliantPrompt.disabledMessage.text(dependency.friendlyName + " must be between " + min + " and " + max).show();
                                            break;
                                        }
                                    }
                                }

                                if (!foundInvalidDependency)
                                {
                                    reliantPrompt.container.children().not(".distinctMultiSelectClearButton").show();
                                    reliantPrompt.disabledMessage.hide();
                                }
                            }
                        };

                        let lastEnteredValue = JSON.stringify(skyward.controls.getValue(prompt.input));
                        // For relative & old date pickers 'change' can fire before the value really changes. After the change,
                        // 'dirty' fires for relative dates and 'datePickerChangeComplete' fires for normal dates
                        const changeEvents = prompt.input.hasClass("datepicker") ? "datePickerChangeComplete dirty" : "change";
                        prompt.input.on(changeEvents + " keyup togglePrompt", function ()
                        {
                            const newVal = JSON.stringify(skyward.controls.getValue(prompt.input));

                            updateReliantPrompts(newVal !== lastEnteredValue);
                            lastEnteredValue = JSON.stringify(skyward.controls.getValue(prompt.input));

                        });

                        updateReliantPrompts(false);
                    }
                });
            }

            function isPromptValueBlank(val)
            {
                if ($.isEmptyObject(val))
                {
                    return true;
                }

                if (val)
                {
                    if (val instanceof Date)
                    {
                        return isNaN(val);
                    }

                    return val.toString().trim().length === 0;
                }
                return true;
            }

            const conditionalPromptInfo = new Map();
            const fieldSetByPromptUniqueID = new Map();

            //Loop over the prompt field sets to setup the collections of info we will need later
            const promptContainers = selectorElement.find(".js-promptContainer");

            promptContainers.each(function ()
            {
                const fieldSet = $(this);
                const hiddenCondition = fieldSet.data("hiddenCondition");
                const promptUniqueID = fieldSet.data("promptUniqueId");

                fieldSetByPromptUniqueID.set(promptUniqueID, fieldSet);


                if (hiddenCondition)
                {
                    const watchingPromptUniqueID = hiddenCondition.LeftOperand.PromptUniqueID;

                    if (watchingPromptUniqueID)
                    {
                        if (!conditionalPromptInfo.has(watchingPromptUniqueID))
                        {
                            conditionalPromptInfo.set(watchingPromptUniqueID, []);
                        }
                        conditionalPromptInfo.get(watchingPromptUniqueID).push({
                            promptUniqueID: promptUniqueID,
                            hiddenCondition: hiddenCondition,
                            fieldSet: fieldSet
                        });
                    }
                }
            });

            /**
             * Gets the Prompt inputs ordered starting with the ones that don't have a hidden condition then the ones that look them and so on
             */
            function GetPromptInputsInDependentOrder()
            {
                let fieldsetsInOrder = [];
                const promptUniqueIDsAlreadyOrdered = [];
                let fieldsetsLeftToOrder = [];

                //Get the prompts with no hidden conditions first
                promptContainers.each(function ()
                {
                    const fieldset = $(this);
                    const promptUniqueID = fieldset.data("promptUniqueId");

                    if (conditionalPromptInfo.has(promptUniqueID))
                    {
                        fieldsetsLeftToOrder.push(fieldset);
                    }
                    else
                    {
                        promptUniqueIDsAlreadyOrdered.push(promptUniqueID);
                        fieldsetsInOrder.push(fieldset);
                    }
                });

                let countLastLoop = -1;
                //Keep looping over the prompts left checking to see if the prompt they need has already been processed
                while (fieldsetsLeftToOrder.length > 0)
                {
                    //if we didn't remove any prompts from the ones left then we are in a circular reference so just get out and show all the prompts
                    if (fieldsetsLeftToOrder.length === countLastLoop)
                    {
                        fieldsetsLeftToOrder = [];
                        fieldsetsInOrder = [];
                    }

                    countLastLoop = fieldsetsLeftToOrder.length;
                    const fieldsetsToProcess = [...fieldsetsLeftToOrder];
                    fieldsetsLeftToOrder = [];

                    $(fieldsetsToProcess).each(function ()
                    {
                        const fieldset = $(this);
                        const promptUniqueID = fieldset.data("promptUniqueId");

                        let allDependentsAccountedFor = true;
                        $(conditionalPromptInfo.get(promptUniqueID)).each(function ()
                        {
                            const promptInfo = this;
                            if (!promptUniqueIDsAlreadyOrdered.includes(promptInfo.promptUniqueID))
                            {
                                allDependentsAccountedFor = false;
                            }
                        });

                        if (allDependentsAccountedFor)
                        {
                            promptUniqueIDsAlreadyOrdered.push(promptUniqueID);
                            fieldsetsInOrder.push(fieldset);
                        }
                        else
                        {
                            fieldsetsLeftToOrder.push(fieldset);
                        }
                    });

                }

                let promptsInOrder = [];

                $(fieldsetsInOrder).each(function ()
                {
                    const fieldset = $(this);

                    if (!fieldset.hasClass("standardFilterViewer"))
                    {
                        fieldset.find(".filterValue").each(function ()
                        {
                            promptsInOrder.push($(this));
                        });
                    }
                });

                return promptsInOrder;
            }

            //Loop over all the inputs to set the fields to hidden or shown based on their current values
            const promises = [];
            const inputsInOrder = GetPromptInputsInDependentOrder();
            for (let i = 0; i < inputsInOrder.length; i++)
            {
                const input = inputsInOrder[i];
                const promise = getHiddenConditionEvaluationPromise(input, i);
                if (promise != null)
                {
                    promises.push(promise);
                }
            }
            if (promises.length > 0)
            {
                handleHiddenConditionEvaluationPromises(promises, false);
            }

            for (let input of inputs)
            {
                let $input = $(input);
                // For relative & old date pickers 'change' can fire before the value really changes. After the change,
                // 'dirty' fires for relative dates and 'datePickerChangeComplete' fires for normal dates
                const changeEvents = $input.hasClass("datepicker") ? "datePickerChangeComplete dirty" : "change";

                $input.on(changeEvents, function ()
                {
                    if ($input.closest(".promptFieldSet").is(":visible"))
                    {
                        evaluateHiddenConditions($input);
                    }
                    else
                    {
                        hidePromptsThatWatchThisPrompt($input.data("promptUniqueId"));
                    }
                });
            }

            /**
             * Asks the server to evaluate any hidden conditions that are looking to this prompt input for changes and applies those changes
             * @param {any} input The jQuery Prompt Input that changed
             */
            function evaluateHiddenConditions(input)
            {
                const promise = getHiddenConditionEvaluationPromise(input);
                if (promise != null)
                {
                    handleHiddenConditionEvaluationPromises([promise], true);
                }
            }

            /**
             * Asks the server to evaluate any hidden conditions that are looking to this prompt input for changes
             * @param {any} input The jQuery Prompt Input that changed
             * @param {number} order If multiple changes are being processed the order they should be processed in
             * @returns {Promise} A Promise object for the AJAX request to evaluate the Hidden Condition or null if the input has no prompts looking to it for changes
             */
            function getHiddenConditionEvaluationPromise(input, order = 0)
            {
                const inputData = input.data();
                const promptUniqueID = inputData.promptUniqueId;
                const dataType = inputData.fieldType;

                if (conditionalPromptInfo.has(promptUniqueID))
                {
                    const hiddenConditionInfos = {};
                    let inputValue = skyward.controls.getUnencodedValue(input);

                    $(conditionalPromptInfo.get(promptUniqueID)).each(function ()
                    {
                        const promptInfo = this;

                        hiddenConditionInfos[promptInfo.promptUniqueID] = promptInfo.hiddenCondition;
                    });

                    return askServerToEvaluateHiddenConditions(hiddenConditionInfos, promptUniqueID, inputValue, dataType, order);
                }

                return null;
            }

            /**
             * Sends an AJAX request to evaluate the provides Hidden Conditions
             * @param {Array} hiddenConditionInfos An Array of Hidden Conditions
             * @param {string} promptUniqueID The Prompt Unique ID of the prompt that changed
             * @param {any} value The value of the Prompt Input that changed
             * @param {string} promptDataType The data type of the Prompt Input that changed
             * @param {number} order If multiple changes are being processed the order they should be processed in
             * @returns {Promise} A Promise object for the AJAX request to evaluate the Hidden Condition or null if the input has no prompts looking to it for changes
             */
            function askServerToEvaluateHiddenConditions(hiddenConditionInfos, promptUniqueID, value, promptDataType, order = 0)
            {
                return $.ajax(skyward.global.virtualDir + "Reporting/Report/EvaluateUserConditions",
                    {
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            promptData: skyward.extensions.encodeHtml(JSON.stringify({
                                UserConditionInfos: hiddenConditionInfos,
                                UniqueID: promptUniqueID,
                                BoundValue: value,
                                DataType: promptDataType,
                                Order: order
                            }))
                        }
                    });
            }

            /**
             * Waits for all the AJAX Request Promises to be completed then processes the results in the order they were requested
             * @param {Array} resultPromises An Array of Promises to be completed
             * @param {boolean} checkChildHiddenConditionsOnShow True if when showing a prompt we should then check if its children should be shown
             */
            function handleHiddenConditionEvaluationPromises(resultPromises, checkChildHiddenConditionsOnShow)
            {
                Promise.all(resultPromises)
                    .then(function (resultsCollection)
                    {
                        for (const resultObject of resultsCollection.sort(function (a, b) { return a.order - b.order }))
                        {
                            for (const resultPromptUniqueID in resultObject.results)
                            {
                                const shouldHide = resultObject.results[resultPromptUniqueID];
                                togglePrompt(shouldHide, resultPromptUniqueID, checkChildHiddenConditionsOnShow)
                            }
                        }
                    });
            }

            /**
             * Toggles the prompt with the given prompt unique ID. If the prompt is hidden it will also clear the value and hide any prompts dependent on it.
             * @param {boolean} shouldHide True if the field set will be hidden
             * @param {string} promptUniqueID The prompt unique ID of the prompt to find
             * @param {boolean} checkChildHiddenConditionsOnShow True if when showing this prompt we should then check if its children should be shown
             */
            function togglePrompt(shouldHide, promptUniqueID, checkChildHiddenConditionsOnShow)
            {
                const fieldSet = fieldSetByPromptUniqueID.get(promptUniqueID);
                const isStandardFilter = fieldSet.hasClass("standardFilterViewer");
                fieldSet.toggleClass("doNotPost", shouldHide);

                fieldSet.toggle(!shouldHide);

                fieldSet.find(".filterValue").each((index, e) =>
                {
                    let filterValueElement = $(e);
                    filterValueElement.toggleClass("doNotPost", shouldHide);

                    if (!isStandardFilter)
                    {
                        if (shouldHide)
                        {
                            hidePromptsThatWatchThisPrompt(promptUniqueID);
                        }
                        else if (checkChildHiddenConditionsOnShow)
                        {
                            evaluateHiddenConditions(filterValueElement);
                        }
                    }

                    filterValueElement.trigger("togglePrompt");

                });
            }

            /**
             * Hides any prompt that is watching the Prompt of the provided Prompt Unique ID then recursively calls itself until there are no prompts to hide
             * @param {string} promptUniqueID The Prompt Unique ID of the Prompt that was hidden
             */
            function hidePromptsThatWatchThisPrompt(promptUniqueID)
            {
                if (conditionalPromptInfo.has(promptUniqueID))
                {
                    $(conditionalPromptInfo.get(promptUniqueID)).each(function ()
                    {
                        const promptInfo = this;
                        togglePrompt(true, promptInfo.promptUniqueID, false)
                    });
                }
            }
        };

        skyward.promptsview.setModifiedNotification = function ()
        {
            let collapsePanel = $(this).closest(".collapsePanel");
            let collapsePanelHeaderTextContainer = collapsePanel.find(".collapsePanelHeaderTextContainer").not(".js-ignoreModifiedFilter");

            let onlyInputsWithValueSet = function ()
            {
                let value = skyward.controls.getValue(this);
                return skyward.promptsview.isNonEmptyPromptValue(value);
            };

            if (collapsePanel.find(".filterViewValue, .filterValue, .filterProcessingListValue").filter(onlyInputsWithValueSet).length)
            {
                if (!collapsePanelHeaderTextContainer.find(".hasValues").length)
                {
                    collapsePanelHeaderTextContainer.append($("<span class='hasValues'>(modified)</span>"));
                }
            }
            else
            {
                collapsePanelHeaderTextContainer.find(".hasValues").remove();
            }
        };

        skyward.promptsview.isNonEmptyPromptValue = function (value)
        {
            let result = !(value == null || !value || value == "" || $.isEmptyObject(value)
                || (Array.isArray(value) && (value.length == 0 || (value.length == 1 && value[0] == ""))));

            if (result && value instanceof Date)
            {
                result = !isNaN(value);
            }

            return result;
        };

        skyward.window.registerLoadDOMCallback(initParametersPrompt);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
///<reference path="skyward.ui.reporting.js"/>

(
function (skyward)
{
    skyward.reporting = skyward.reporting || {};

    skyward.reporting.getAggregateColumnFieldType = function (relatedColumnFieldType, aggregateType)
    {
        let fieldType = aggregateTypes[aggregateType] || relatedColumnFieldType;

        if (typeof fieldType === "object")
        {
            return fieldType[relatedColumnFieldType];
        }

        return fieldType;
    };

    skyward.reporting.reportColumn = 
    {
        getFieldType: function (columnData)
        {
            var fieldColumnType = columnData.fieldColumnType;
            var fieldType = columnData.fieldType;
            if (fieldColumnType === skyward.reporting.COLUMN_TYPES.AGGREGATE_COLUMN)
            {
                return skyward.reporting.getAggregateColumnFieldType(columnData.columnFieldType, columnData.aggregateType);
            }
            else if (fieldColumnType === skyward.reporting.COLUMN_TYPES.DYNAMIC_IMAGE_COLUMN || columnData.columnFieldType === "Image")
            {
                fieldType = "Image";
            }
            return fieldType || columnData.columnFieldType;
        }
    };
    
    var string = "String",
        byte = "Number Byte",
        short = "Number Short",
        int = "Number Int",
        long = "Number Long",
        decimal = "Number Decimal",
        dateTime = "DateTime";

    var aggregateTypes = 
    {
        AlphabeticMax: string,
        AlphabeticMin: string,
        Average: decimal,
        ConcatenateAll: string,
        ConcatenateAllExcludeBlanks: string,
        ConcatenateDistinct: string,
        ConcatenateDistinctExcludeBlanks: string,
        Count: int,
        CountFalse: int,
        CountTrue: int,
        DateTimeMax: dateTime,
        DateTimeMin: dateTime,
        DistinctCount: int,
        Median: decimal,
        StandardDeviation: decimal,
        Sum: {
            "Number Short": int,
            "Number Byte": int,
            "Number Int": int,
            "Number Long": long,
            "Number Decimal": decimal
        },//https://msdn.microsoft.com/en-us/library/ms187810.aspx
        Variance: decimal
        //LastNonBlankRecordValue, LastRecordValue, NumericMax, NumericMin //these should fall through to the column's field type
    };

}(window.skyward = window.skyward || {})
);;
/// <reference path="skyward.ui.reporting.js" />
(
    function (skyward, $)
    {
        "use strict";
        skyward.reportingSorts = skyward.reportingSorts || {};
        let sectionDisplayOnSingleLine = false;

        skyward.reportingSorts.pageBreakOptions =
        {
            True: "True",
            False: "False",
            Burst: "Burst"
        }

        skyward.reportingSorts.editSorts = function (dataLines, sectionData, reportType, allowKeepTogether, calculatedFields)
        {
            const deferred = $.Deferred();
            sectionDisplayOnSingleLine = sectionData.displayOnSingleLine;

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Reporting/Report/GetSortEditor",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        reportSorts: skyward.extensions.encodeHtml(JSON.stringify(sectionData.reportSorts)),
                        reportLines: skyward.extensions.encodeHtml(JSON.stringify(dataLines)),
                        prompts: skyward.reporting.prompts.promptCollection.toJsonString(),
                        rootObject: sectionData.rootObject,
                        rootModule: sectionData.rootModule,
                        baseObject: sectionData.baseObject,
                        baseModule: sectionData.baseModule,
                        promptForSortOrder: sectionData.promptForSortOrder,
                        sortPromptGuid: sectionData.sortPromptGuid,
                        sortPromptLabel: skyward.extensions.encodeHtml(sectionData.sortPromptLabel),
                        relationshipPath: sectionData.entireRelationshipPath,
                        reportType: reportType,
                        sectionName: skyward.extensions.encodeHtml(sectionData.displayName),
                        calculatedFieldsJson: JSON.stringify(calculatedFields),
                        allowKeepTogether: allowKeepTogether && !sectionData.displayOnSingleLine
                    }
                }).done(function (data)
                {
                    showPopup(data).done(function (sortData)
                    {
                        deferred.resolve(sortData);
                    });
                });
            return deferred; //Wait for user to finish
        };

        function showPopup(data)
        {
            const html = $(data.html);
            const buttons = [
                { text: "Save", click: confirmEdit, icon: "Save" },
                { text: "Cancel", click: cancelEdit, icon: "Cancel" }
            ];
            const popup = skyward.modalLayer.showDialog("Section Sorts", html, buttons, { closeOnClick: false, draggable: true, automationID: "section-sorts-dialog" });
            const editor = popup.content;
            const editorButtons = {
                moveUp: editor.find('.moveItem.up'),
                moveDown: editor.find('.moveItem.down'),
                add: editor.find('.addItem'),
                remove: editor.find('.removeItem')
            };
            const sortsEditor = editor.find('.reportDefinitionSortsEditor');
            $.when(popup.bodyPromise).then(function ()
            {
                if (data.errors)
                {
                    skyward.validation.displayValidationMessages(data, sortsEditor, null);
                }
            });

            editor.find(".sortItem").on("click", function ()
            {
                const row = $(this);
                const button = row.find(".selectSort");
                selectRow(button);
                setActiveButtonsBasedOnCurrentRow(row);
            });

            const selectedColumns = editor.find(".selectedItemsTable tbody");
            selectedColumns.on('click', '.selectSort', selectItemFromSelectedColumns)
                .on('change', '.pageBreakColumn .pageBreak', togglePageBreak)
                .on('click', '.sortDirectionColumn', toggleDirection)
                .on('click', '.keepTogether', toggleKeepTogether)
                .on('click', '.createBookmark', toggleCreateBookmark)
                .on('click', '.selectSort', removeSelectedItem)
                .on('click', '.sortIconColumn .edit', editFieldNameMode)
                .on('click', '.sortIconColumn .info', getInfoPopup);

            const availableColumns = editor.find(".availableItemsTable tbody");
            availableColumns.on('click', '.selectSort', selectItemFromAvailableColumns)
                .on('click', '.selectSort', addSelectedItem);

            const addPromptForSorts = editor.find(".promptForSortOrder");
            addPromptForSorts.on("change", updatePromptSort);

            editorButtons.add.on('click', addSelectedItem);
            editorButtons.remove.on('click', removeSelectedItem);
            editorButtons.moveUp.on('click', moveSelectedItemUp);
            editorButtons.moveDown.on('click', moveSelectedItemDown);

            const pageBreakContainer = editor.find(".pageBreakColumn .conditionValuesContainer");
            $.each(pageBreakContainer, function (index, container)
            {
                $(container).toggleClass("ui-disabled", sectionDisplayOnSingleLine);
            });

            const waitUntilDoneEditing = $.Deferred().always(function () { popup.close(); });
            return waitUntilDoneEditing;

            // End-of-lifecycle methods
            function cancelEdit()
            {
                waitUntilDoneEditing.reject();
            }

            function confirmEdit()
            {
                skyward.validation.displayValidationMessages(data, sortsEditor, null);

                const sortPromptLabel = editor.find(".sortPromptLabel");
                const sortData =
                {
                    selectedSorts: [],
                    removedSorts: [],
                    sortPrompt:
                    {
                        label: sortPromptLabel.val(),
                        promptGuid: sortPromptLabel.data("sortPromptGuid"),
                        promptForSortOrder: false
                    }
                };

                for (const selectedSort of selectedColumns[0].children)
                {
                    const data = $(selectedSort).data();
                    if (data.hasErrors)
                    {
                        return; // don't allow to save with error sorts
                    }
                    data.friendlyName = selectedSort.dataset.friendlyName; // so jquery doesn't try parsing the name as an object
                    sortData.selectedSorts.push(data);
                }

                availableColumns.children('[data-existing-sort]').each(function ()
                {
                    sortData.removedSorts.push($(this).data());
                });

                if (addPromptForSorts.is(":checked"))
                {
                    sortData.sortPrompt.promptForSortOrder = true;
                }
                waitUntilDoneEditing.resolve(sortData);
            }

            // Interaction methods
            function addSelectedItem()
            {
                if (editorButtons.add.hasClass('ui-disabled'))
                {
                    return;
                }
                const selectedRow = getSelectedRow(editor);
                skyward.svg.swapSvg(selectedRow.find(".addPlus"), "Clear", "BrowseLevel");

                const primaryKeySort = getPrimaryKeyRow(editor);
                if (primaryKeySort.length > 0)
                {
                    selectedRow.insertBefore(primaryKeySort);
                }
                else
                {
                    selectedColumns.append(selectedRow);
                }
                setActiveButtonsBasedOnCurrentRow(selectedRow);
            }

            function removeSelectedItem()
            {
                const selectedRow = getSelectedRow(editor);
                if (editorButtons.remove.hasClass('ui-disabled') || selectedRow.data('isPrimaryKeySort'))
                {
                    return;
                }
                if (selectedRow.data().hasErrors)
                {
                    selectedRow.remove();
                    selectedColumns.trigger('change');
                    const selectedItem = selectRow(selectedColumns.children().first());
                    setActiveButtonsBasedOnCurrentRow(selectedItem);
                    return;
                }

                selectedRow.data("friendlyName", "");
                skyward.svg.swapSvg(selectedRow.find(".clear"), "AddPlus", "BrowseLevel");

                const editFieldTextBox = selectedRow.find(".editField");
                editFieldTextBox.val("");
                selectedRow.find(".fieldNameColumn span").text(editFieldTextBox.attr("placeholder"));
                availableColumns.append(selectedRow);
                setActiveButtons({ add: true });
            }

            function moveSelectedItemUp()
            {
                const selectedRow = getSelectedRow(editor);
                if (editorButtons.moveUp.hasClass('ui-disabled') || selectedRow.data('isPrimaryKeySort'))
                {
                    return;
                }

                const previousRow = selectedRow.prev('.sortItem');
                if (previousRow.length > 0)
                {
                    const isTopItem = previousRow.prev('.sortItem').length === 0;
                    selectedRow.detach().insertBefore(previousRow);
                    setActiveButtons({ remove: true, down: true, up: !isTopItem });
                }
            }

            function moveSelectedItemDown()
            {
                if (editorButtons.moveDown.hasClass('ui-disabled'))
                {
                    return;
                }

                const selectedRow = getSelectedRow(editor);
                const isPrimaryKeySort = selectedRow.data('isPrimaryKeySort');
                const nextRow = selectedRow.next('.sortItem');
                if (nextRow.length > 0 && !nextRow.data('isPrimaryKeySort'))
                {
                    const nextRowNextSortItem = nextRow.next('.sortItem');
                    const isBottomItem = nextRowNextSortItem.length === 0 || nextRowNextSortItem.data('isPrimaryKeySort');
                    selectedRow.detach().insertAfter(nextRow);
                    setActiveButtons({ remove: !isPrimaryKeySort, down: !isBottomItem, up: !isPrimaryKeySort });
                }
            }

            function editFieldNameMode()
            {
                const editButton = $(this);
                const okButton = editButton.siblings(".confirmEdit");
                const cancelButton = editButton.siblings(".cancelEdit");
                const infoButton = editButton.siblings(".info");

                const fieldNameColumn = editButton.parent(".sortIconColumn").siblings(".fieldNameColumn");
                const selectSortButton = fieldNameColumn.find(".selectSort");
                const friendlyNameLabel = fieldNameColumn.find(".friendlyName");
                const fieldNameTextBox = fieldNameColumn.find(".editField");

                const sort = editButton.closest(".sortItem");

                updateEditMode(true);

                okButton.on("click", function ()
                {
                    selectRow(fieldNameTextBox);
                    const friendlyName = fieldNameTextBox.val();
                    if (friendlyName)
                    {
                        const friendlyNameDisplayString = createFriendlyNameDisplay(friendlyName);
                        sort[0].dataset.friendlyName = friendlyNameDisplayString;
                        friendlyNameLabel.text(friendlyNameDisplayString);
                    }
                    else
                    {
                        fieldNameTextBox.val(selectSortButton.find(".textAfter").text());
                    }
                    updateEditMode(false);
                });

                function createFriendlyNameDisplay(friendlyName)
                {
                    const reversedString = friendlyName.split('').reverse();
                    let numCharsSinceLastSpace = 0;
                    const tempStringArray = [];

                    for (let i = 0; i < reversedString.length && tempStringArray.length <= 90; i++)
                    {
                        const character = reversedString[i];
                        if (character === " ")
                        {
                            numCharsSinceLastSpace = 0;
                        }
                        else
                        {
                            numCharsSinceLastSpace++;
                            if (numCharsSinceLastSpace === 30)
                            {
                                tempStringArray.push(" ");
                                numCharsSinceLastSpace = 0;
                            }
                        }
                        tempStringArray.push(character);
                    }

                    return (tempStringArray.length < friendlyName.length ? "..." : "") + tempStringArray.reverse().join("");
                }

                cancelButton.on("click", function ()
                {
                    fieldNameTextBox.val(selectSortButton.find(".textAfter").text());
                    selectRow($(this));
                    updateEditMode(false);
                });

                function updateEditMode(enterEditMode)
                {
                    if (enterEditMode)
                    {
                        setActiveButtons({ add: false, up: false, down: false, remove: false });
                    }
                    else
                    {
                        const selectedRow = getSelectedRow(editor);
                        const previousRow = selectedRow.prev('.sortItem');
                        const nextRow = selectedRow.next('.sortItem');
                        const args = {
                            remove: true,
                            down: nextRow.length > 0,
                            up: previousRow.length > 0
                        };
                        setActiveButtons(args);
                    }


                    editButton.toggleClass("hidden", enterEditMode);
                    infoButton.toggleClass("hidden", enterEditMode);
                    selectSortButton.toggleClass("hidden", enterEditMode);
                    friendlyNameLabel.toggleClass("hidden", enterEditMode);
                    okButton.toggleClass("hidden", !enterEditMode);
                    cancelButton.toggleClass("hidden", !enterEditMode);
                    fieldNameTextBox.toggleClass("hidden", !enterEditMode);
                }
            }

            function getInfoPopup()
            {
                const infoButton = $(this);
                const row = selectRow(infoButton);
                const rowData = row.data();

                const outerDiv = $("<div/>");
                const idGenerator = skyward.extensions.getIdGenerator("popup", "_sortInfoPopupLabel");
                const fieldNameTextBox = buildReadOnlyTextbox("sortInfoPopupLabel", rowData.fieldName, idGenerator);
                const fieldNameFieldset = buildFieldset().append(buildLabel("title", "Field Name ", fieldNameTextBox.attr("id"))).append(fieldNameTextBox);

                outerDiv.append(fieldNameFieldset);

                skyward.modalLayer.showInformationDialog("Sort Information", outerDiv, null, { anchorTo: infoButton });
            }

            function buildFieldset()
            {
                return $("<div class='fieldWrapper' />");
            }

            function buildLabel(className, text, forId)
            {
                return $("<label/>", { for: forId}).text(text).addClass(className);
            }

            function buildReadOnlyTextbox(className, text, idGenerator)
            {
                const textbox = $("<input/>",
                    {
                        id: idGenerator.getNewId(),
                        readonly: "true",
                        type: "text"
                    }).addClass(`${className} ui-disabled`);
                if (text == "")
                {
                    return textbox;
                }
                return textbox.val(text);
            }

            function updatePromptSort()
            {
                const checkBox = $(this);
                if (checkBox.is(":checked"))
                {
                    editor.find(".sortPromptLabelFieldset").removeClass("hidden");
                }
                else
                {
                    editor.find(".sortPromptLabelFieldset").addClass("hidden");
                }
                popup.animateModalContents();
            }

            function toggleDirection()
            {
                const row = getParentRow(this);
                const isDesc = row.find('.desc > input').prop('checked');
                row.data("descending", isDesc);
            }

            function toggleKeepTogether()
            {
                const row = getParentRow(this);
                const keepLinesTogether = row.find('.keepTogether').prop('checked');
                row.data("keepLinesTogether", keepLinesTogether);

                if (keepLinesTogether)
                {
                    editor.find('.keepTogether:checked').not(this).each(function (i, e)
                    {
                        getParentRow(e).data("keepLinesTogether", false);
                        $(e).prop('checked', false);
                    });
                }
            }

            function toggleCreateBookmark()
            {
                const row = getParentRow(this);
                const createBookmark = row.find('.createBookmark').prop('checked');
                row.data("createBookmark", createBookmark);
            }

            function togglePageBreak()
            {
                const pageBreakSpan = $(this);
                const data = pageBreakSpan.data();

                const sortItem = getParentRow(this);

                if (data.promptUniqueId)
                {
                    sortItem.data("pageBreak", skyward.reportingSorts.pageBreakOptions.False);
                    sortItem.data("pageBreakPromptUniqueId", data.promptUniqueId);
                }
                else if (data.enumValue)
                {
                    sortItem.data("pageBreakPromptUniqueId", null);
                    sortItem.data("pageBreak", data.enumValue);
                }
            }

            function selectRow(button)
            {
                const row = getParentRow(button);

                const currentSelectedRow = getSelectedRow(editor);
                if (currentSelectedRow.find(".editField").is(":visible"))
                {
                    return currentSelectedRow;
                }
                currentSelectedRow.removeClass("ui-selected");
                row.addClass("ui-selected").focus();
                editor.find('.selectedColumnDataPath').text(row.attr('data-field-name'));
                editor.find('.selectedColumnDataPathLabel').show();
                popup.animateModalContents();
                return row;
            }

            function selectItemFromAvailableColumns()
            {
                selectRow(this);
                setActiveButtons({ add: true });
            }

            function selectItemFromSelectedColumns()
            {
                const selectedItem = selectRow(this);

                setActiveButtonsBasedOnCurrentRow(selectedItem);
            }

            function setActiveButtonsBasedOnCurrentRow(currentRow)
            {
                const isSelectedTable = currentRow.closest(".selectedItemsTable").length > 0;
                let downButtonActive = false;
                let upButtonActive = false;
                const isPrimaryKeySort = currentRow.data('isPrimaryKeySort');

                if (isSelectedTable)
                {
                    const nextItem = currentRow.next('.sortItem');
                    if (nextItem.length > 0 && !nextItem.data('isPrimaryKeySort'))
                    {
                        downButtonActive = true;
                    }

                    const previousItem = currentRow.prev('.sortItem');
                    if (previousItem.length > 0 && !isPrimaryKeySort)
                    {
                        upButtonActive = true;
                    }
                }

                setActiveButtons({ up: upButtonActive, down: downButtonActive, remove: isSelectedTable && !isPrimaryKeySort, add: !isSelectedTable });
            }

            // accepts args = {add: bool, up: bool, down: bool, remove: bool}
            function setActiveButtons(args)
            {
                editorButtons.remove.toggleClass('ui-disabled', !args.remove);
                editorButtons.add.toggleClass('ui-disabled', !args.add);
                editorButtons.moveUp.toggleClass('ui-disabled', !args.up);
                editorButtons.moveDown.toggleClass('ui-disabled', !args.down);
            }
        }

        function getParentRow(button)
        {
            return $(button).closest('tr');
        }

        function getSelectedRow(editor)
        {
            return editor.find('.ui-selected');
        }

        function getPrimaryKeyRow(editor)
        {
            return editor.find('[data-is-primary-key-sort]');
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.matrix = skyward.tooltip || {};

        var scheduleMatrixModule;
        var scheduleMatrixController;

        var outerMostContainerID = "[id*='studentSchedule-']";
        var studentScheduleViewPart;

        var allScheduleMatrixID = ".studentScheduleMatrix";
        var allStudentScheduleViewParts;

        var bottomTabContainerID = '#bottomTabContainer';
        var bottomTabContainer;
        var bottomTabCourseContainerID = "#bottomTabContainerCourse";
        var bottomTabCourseContainer;
        var rightTabCourseRequestContainerID = "#rightSliderPanel";
        var rightPanelToggleButtonID = "#rightSliderPanelToggleButton";

        // When the "Display Course List on Right" user setting is enabled, the course/section browses are not
        // rendered as the collapsible bottom panels; instead they live inside #rightSliderPanel as extra tabs
        // that this module shows/hides, re-titles, and activates as the user acts (View Course List / Open
        // Period / Replace). coursePanelOnRight branches the state machine onto that path. The two always-present
        // tabs are Student Course List (index 0) and Alternate Requests (index 1); the dynamic browse tabs occupy
        // the fixed indices below and start hidden via rightPanelDynamicTabHiddenClass. NOTE: the alternate count
        // write in updateAlternateRequests targets .tabButton.eq(1), so Alternate Requests must stay at index 1.
        var coursePanelOnRight = false;
        var hideCourseRequests = false;
        var rightPanelDynamicTabHiddenClass = "schedBuilderDynamicTabHidden";
        var rightPanelTabIndex = { courseList: 0, alternates: 1, addByCourse: 2, addBySections: 3, sections: 4 };

        var studentCourseRequestBrowse = 'StudentCourseRequestBrowse';
        var studentCourseAlternateRequest = 'StudentCourseAlternateRequest';
        var studentSectionScheduleListBrowse = 'StudentSections';
        var studentCourseRequestScheduleListBrowse = 'StudentCourseRequests';
        var studentAlternateRequestScheduleListBrowse = 'StudentAlternateRequests';
        var studentCombineRequestScheduleListBrowse = 'StudentCombineRequests';
        var actionMenuID = '#ActionMenu';
        var quickEntryCourseEELID = '#quickEntryCourse';
        var quickEntrySectionEELID = '#quickEntrySection';
        var quickEntryToolbarAddCourseButtonID = "#btnQuickEntryToolbarAddCourse";
        var quickEntryToolbarClearButtonID = "#btnQuickEntryToolbarClear";
        var btnCourseQuickEntryID = "#btnCourseQuickEntry";
        var cmbSpecifiedEntityID = "#cmbSpecifiedEntityID";
        var btnSettingsID = "#btnSettings";
        var btnScheduleBuilderLegendID = "[id$=btnScheduleBuilderLegend]";
        var effectiveDatePickerID = "#effectiveDate";
        var btnViewCourseBrowseID = "#btnViewCourseBrowse";

        var actionsMenu;
        var actionsMenuDeleteButton;
        var actionsMenuEditButton;
        var actionsMenuUnscheduleButton;
        var actionsMenuDropButton;
        var actionsMenuChangeButton;
        var actionsMenuReplaceButton;
        var availableSectionsCancelButton;
        var matrixBodyClickAdded = false;
        var preventDeselectTargetClick = false;
        var preventDeselectBodyClick = false;
        var previouslySelectStudentSectionID = "";

        var availableSectionsBrowse = 'AvailableSectionsBrowse';
        var availableSectionsByRequestsAndOpenPeriodBrowse = 'AvailableSectionsByRequestsAndOpenPeriodBrowse';
        var availableSectionsByOpenPeriodBrowse = 'AvailableSectionsByOpenPeriodBrowse';
        var availableSectionsByChangeSectionBrowse = 'AvailableSectionsByChangeSectionsBrowse';
        var availableSectionsByReplaceSectionBrowse = 'AvailableSectionsByReplaceSectionsBrowse';
        var availableSectionsByOpenSectionsBrowse = 'AvailableSectionsByOpenSectionsBrowse';
        var availableSectionsByOpenSectionsBrowseView = 'AvailableSectionsByOpenSectionsBrowseView';
        var availableCoursesBrowse = 'AvailableCoursesBrowse';
        var availableCoursesBrowseView = 'AvailableCoursesBrowseView';
        var availableSectionsView = 'AvailableSectionsView';

        var AccessMode = $('#accessmode').val();

        var init = function (selector)
        {
            studentScheduleViewPart = $(outerMostContainerID);

            if (!studentScheduleViewPart.length)
            {
                return;
            }

            initScreen(selector);
        };

        var initScreen = function (selector)
        {
            allStudentScheduleViewParts = $(allScheduleMatrixID);
            bottomTabContainer = $(bottomTabContainerID);
            bottomTabCourseContainer = $(bottomTabCourseContainerID);

            var coursePanelOnRightData = $("#studentBoard").data("coursepanelonright");
            coursePanelOnRight = coursePanelOnRightData === true || coursePanelOnRightData === "true";

            var hideCourseRequestsData = $("#studentBoard").data("hidecourserequests");
            hideCourseRequests = hideCourseRequestsData === true || hideCourseRequestsData === "true";

            if (coursePanelOnRight)
            {
                // The dynamic browse tabs (Add By Course / Add By Sections / Available Sections) start hidden via
                // the schedBuilderDynamicTabHidden class. Wire their focus/expand handlers (idempotent). When
                // "Hide Course Requests" is on, also hide the Student Course List and Alternate Requests tab
                // buttons. Then re-assert the hidden state once now, in case slidingContainer's initial expand
                // already ran its .show() over the tab buttons before this handler was bound.
                wireRightPanelDynamicTabs();
                if (hideCourseRequests)
                {
                    hideRightPanelCourseRequestTabs();
                }
                syncRightPanelDynamicTabVisibility();

                var currentRightTab = $(rightTabCourseRequestContainerID).find(".tabStrip .tabButton.current");
                var currentRightTabAction = $("#btnBottomTabContainerCancelAction").data("action");
                var rightPanelActionInProgress = !(currentRightTabAction == undefined || currentRightTabAction == "");

                if (!rightPanelActionInProgress)
                {
                    if (hideCourseRequests)
                    {
                        // The always-present Student Course List / Alternate Requests tabs are hidden, so there is no
                        // resting tab to fall back to. Default the panel to the course/section browse so it isn't an
                        // empty gray panel. In this mode those two browse views populate themselves on render (their
                        // <view> postdata carries the course container server-side), so just REVEAL and activate their
                        // tabs here - issuing another load would race the server-rendered one and can blank it out.
                        // Only do this when the browse isn't already the active tab (a hidden tab or no current tab),
                        // so a board refresh while the user is browsing doesn't reset their place.
                        if (currentRightTab.length === 0 || currentRightTab.hasClass(rightPanelDynamicTabHiddenClass))
                        {
                            showRightPanelTab(rightPanelTabIndex.addByCourse, "Add By Course");
                            showRightPanelTab(rightPanelTabIndex.addBySections, "Add By Sections");
                            activateRightPanelTab(rightPanelTabIndex.addByCourse);
                        }
                    }
                    else if (currentRightTab.length > 0 && currentRightTab.data("index") >= rightPanelTabIndex.addByCourse)
                    {
                        // If PageState from a prior visit persisted one of the dynamic tabs as the selected index (its
                        // contents would render 'current' while its button is hidden), snap back to Student Course
                        // List so the panel never opens showing a browse with no selectable tab.
                        activateRightPanelTab(rightPanelTabIndex.courseList);
                    }
                }
            }
            else
            {
                // Display on Right is off: #rightSliderPanel only renders the two always-present tabs (Student
                // Course List and Alternate Requests). If PageState persisted one of the on-right dynamic tab
                // indexes (addByCourse and beyond) as selected, none of the rendered tab buttons match that index,
                // so no button/content gets the "current" class and the panel opens empty. Default to the first
                // tab in that case so the panel always shows a selectable tab.
                var rightTabButtons = $(rightTabCourseRequestContainerID).find(".tabStrip .tabButton");
                var currentRightTab = $(rightTabCourseRequestContainerID).find(".tabStrip .tabButton.current");
                if (rightTabButtons.length > 0 && currentRightTab.length === 0)
                {
                    activateRightPanelTab(rightPanelTabIndex.courseList);
                }
            }

            scheduleMatrixModule = studentScheduleViewPart.data("schedulematrixmodule");
            scheduleMatrixController = studentScheduleViewPart.data("schedulematrixcontroller");

            studentScheduleViewPart.off('change', '.cbScheduleType', skyward.matrix.scheduleTypeEventHandler);
            studentScheduleViewPart.on('change', '.cbScheduleType', skyward.matrix.scheduleTypeEventHandler);

            studentScheduleViewPart.off('change', '#cbMonthOfYear', skyward.matrix.weeklyScheduleMonthEventHandler);
            studentScheduleViewPart.on('change', '#cbMonthOfYear', skyward.matrix.weeklyScheduleMonthEventHandler);

            studentScheduleViewPart.off('change', '#cbWeekOfYear', skyward.matrix.weeklyScheduleWeekEventHandler);
            studentScheduleViewPart.on('change', '#cbWeekOfYear', skyward.matrix.weeklyScheduleWeekEventHandler);

            $('#cbMonthOfYear').off('change', skyward.matrix.weeklyScheduleMonthEventHandler);
            $('#cbMonthOfYear').on('change', skyward.matrix.weeklyScheduleMonthEventHandler);

            $('#cbWeekOfYear').off('change', skyward.matrix.weeklyScheduleWeekEventHandler);
            $('#cbWeekOfYear').on('change', skyward.matrix.weeklyScheduleWeekEventHandler);

            $('#cbScheduleDateRangeMode').off('change', skyward.matrix.dateRangeMode);
            $('#cbScheduleDateRangeMode').on('change', skyward.matrix.dateRangeMode);

            var body = $("body");
            body.off("browseLoaded." + availableCoursesBrowse).on("browseLoaded." + availableCoursesBrowse, function ()
            {
                $("#" + availableCoursesBrowse + "_seek").focus();
                $("#" + availableCoursesBrowse + "View").data("browseLoaded", true);
            });
            body.off("browseLoaded." + availableSectionsBrowse).on("browseLoaded." + availableSectionsBrowse, function ()
            {
                $("#" + availableSectionsBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsBrowse);
            });
            body.off("browseLoaded." + availableSectionsByRequestsAndOpenPeriodBrowse).on("browseLoaded." + availableSectionsByRequestsAndOpenPeriodBrowse, function ()
            {
                $("#" + availableSectionsByRequestsAndOpenPeriodBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsByRequestsAndOpenPeriodBrowse);
            });
            body.off("browseLoaded." + availableSectionsByOpenPeriodBrowse).on("browseLoaded." + availableSectionsByOpenPeriodBrowse, function ()
            {
                $("#" + availableSectionsByOpenPeriodBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsByOpenPeriodBrowse);
            });
            body.off("browseLoaded." + availableSectionsByChangeSectionBrowse).on("browseLoaded." + availableSectionsByChangeSectionBrowse, function ()
            {
                $("#" + availableSectionsByChangeSectionBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsByChangeSectionBrowse);
            });
            body.off("browseLoaded." + availableSectionsByOpenSectionsBrowse).on("browseLoaded." + availableSectionsByOpenSectionsBrowse, function ()
            {
                $("#" + availableSectionsByOpenSectionsBrowse + "_seek").focus();
                $("#" + availableSectionsByOpenSectionsBrowse + "View").data("browseLoaded", true);
            });
            body.off("browseLoaded." + availableSectionsByReplaceSectionBrowse).on("browseLoaded." + availableSectionsByReplaceSectionBrowse, function ()
            {
                $("#" + availableSectionsByReplaceSectionBrowse + "_seek").focus();
                $("#" + availableSectionsView).data("browseLoaded", availableSectionsByReplaceSectionBrowse);
            });

            //Toolbar button click events
            $(btnViewCourseBrowseID).off('click', skyward.matrix.updateAvailableCoursesPanel).on('click', skyward.matrix.updateAvailableCoursesPanel);
            $(btnCourseQuickEntryID).off('click', toggleQuickEntry).on('click', toggleQuickEntry);

            availableSectionsCancelButton = $('#btnBottomTabContainerCancelAction');
            availableSectionsCancelButton.off('click', cancelActions).on('click', cancelActions);

            //Quick Entry Panel events
            $(quickEntryToolbarAddCourseButtonID).off('click', addFromQuickEntry).on('click', addFromQuickEntry);
            $(quickEntryToolbarClearButtonID).off('click', clearQuickEntry).on('click', clearQuickEntry);
            $(quickEntryCourseEELID + "_value").off('change', updateAddCourseButton).on('change', updateAddCourseButton);

            //Primary Toolbar Button events
            $(btnSettingsID).off('click', showSettingsDialog).on('click', showSettingsDialog);
            $(btnScheduleBuilderLegendID).off('click', buildScheduleBuilderLegendPopup).on('click', buildScheduleBuilderLegendPopup);

            var viewMode = studentScheduleViewPart.data("viewmode");
            if (viewMode === "List" || viewMode === "Builder")
            {
                $(effectiveDatePickerID).off('change', skyward.matrix.effectiveDateChangeEventHandler);
                $(effectiveDatePickerID).on('change', skyward.matrix.effectiveDateChangeEventHandler);
            }
            if (viewMode === "WeeklySchedule" || viewMode === "Requests" || viewMode === "List" || viewMode === "Matrix" || viewMode === "StaffMatrix" || viewMode === "TeacherMatrix")
            {
                $(cmbSpecifiedEntityID).off('change', changeSpecifiedEntityHandler).on('change', changeSpecifiedEntityHandler);
            }

            skyward.matrix.addEventListenerToDataMatrixCards();

            if (selector == actionMenuID)
            {
                actionsMenu = $(actionMenuID);
                actionsMenuDropButton = $("#" + actionsMenu.attr("id") + " #btnDropStudentSectionActionMenu");
                actionsMenuChangeButton = $("#" + actionsMenu.attr("id") + " #btnChangeStudentSectionActionMenu");
                actionsMenuReplaceButton = $("#" + actionsMenu.attr("id") + " #btnReplaceStudentSectionActionMenu");
                actionsMenuDeleteButton = $("#" + actionsMenu.attr("id") + " #btnDeleteStudentSection");
                actionsMenuEditButton = $("#" + actionsMenu.attr("id") + " #btnEditStudentSection");
                actionsMenuUnscheduleButton = $("#" + actionsMenu.attr("id") + " #btnUnscheduleStudentSection");
            }

            if (selector == "#" + studentCourseRequestBrowse)
            {
                setActiveStudentSectionOrRequest("", "");
                var browseSelector = $("#" + studentCourseRequestBrowse);
                browseSelector.off("rowChanged").on("rowChanged", function (event, browse)
                {
                    browseRowChanged(browse);
                });
                // Initial selection
                const browse = skyward.browse.browseList[studentCourseRequestBrowse];
                if (browse)
                {
                    browseRowChanged(browse);
                }
                skyward.browse.registerDeselectPreviousRecordOverrideListener(studentCourseRequestBrowse, deselectPreviousRowOverride);
            }

            if (selector == "#" + availableSectionsView)
            {
                initializeBottomPanel();
                if (availableSectionsCancelButton.data("action") == undefined)
                {
                    availableSectionsCancelButton.data("action", "");
                }
            }

            //The course information may be filled in, so just refresh the buttons to make sure they have the right state
            updateAddCourseButton();
        };

        var initializeBottomPanel = function ()
        {
            var label = bottomTabContainer.find('.firstTab');
            label.addClass("current");

            bottomTabContainer.off("expandEvent", bottomTabBeginExpand).on("expandEvent", bottomTabBeginExpand);
            bottomTabContainer.off("collapseEvent", bottomTabCourseContainerCollapse).on("collapseEvent", bottomTabCourseContainerCollapse);
            bottomTabContainer.off("containerExpanded", bottomTabContainerExpanded).on("containerExpanded", bottomTabContainerExpanded);
            bottomTabContainer.off("containerCollapsed", bottomTabContainerCollapsed).on("containerCollapsed", bottomTabContainerCollapsed);

            bottomTabCourseContainer.off("collapseEvent", bottomTabContainerCollapse).on("collapseEvent", bottomTabContainerCollapse);
            bottomTabCourseContainer.off("containerExpanded", bottomTabCourseContainerExpanded).on("containerExpanded", bottomTabCourseContainerExpanded);

            var tabButtonList = bottomTabContainer.find(".tabStrip .tabButton");
            tabButtonList.each(function ()
            {
                $(this).off("tabClicked", bottomTabContainerTabClicked).on("tabClicked", bottomTabContainerTabClicked);
            });

            tabButtonList = bottomTabCourseContainer.find(".tabStrip .tabButton");
            tabButtonList.each(function ()
            {
                $(this).off("tabClicked", bottomTabCourseContainerTabClicked).on("tabClicked", bottomTabCourseContainerTabClicked);
            });

            bottomTabContainerSetDataProperties(false);
            bottomTabCourseContainerSetDataProperties(false, undefined);
        };

        var browseRowChanged = function (browse)
        {
            if (browse.browseName == studentCourseRequestBrowse)
            {
                deSelectSelectedCards();
                var studentSectionIDs = browse.rowData.map(row => row['StudentSectionID']);
                if (studentSectionIDs.length > 0 && browse.currentRow > -1 && browse.currentRow <= studentSectionIDs.length)
                {
                    selectedCards(studentSectionIDs[browse.currentRow]);
                }
                $(".studentCourseRequest.selectedRow").removeClass("current");
            }
        };

        var addCourseRequest = function (event)
        {
            var button = $(event.currentTarget);
            var courseID = button.data('courseid');
            var courseIDSecurityHash = button.data('courseid_securityhash');
            var entityID = studentScheduleViewPart.data("entityid");
            var entityIDSecurityHash = studentScheduleViewPart.data('entityid_securityhash');
            var studentID = button.data('studentid');
            var studentIDSecurityHash = button.data('studentid_securityhash');
            // Not all places are rendered server-side, with hashable values.  Eg. "Course" selector on quick entry toolbar.
            // At least it does not go into a workflow.  Are unsured ajax requests "better" anyway?
            skyward.matrix.addCourseRequest(courseID, entityID, entityIDSecurityHash, studentID, studentIDSecurityHash, courseIDSecurityHash);
        };

        skyward.matrix.addCourseRequest = function (courseID, entityID, entityIDSecurityHash, studentID, studentIDSecurityHash, courseIDSecurityHash)
        {
            var data = {
                EntityID: entityID,
                EntityID_SecurityHash: entityIDSecurityHash,
                StudentID: studentID,
                StudentID_SecurityHash: studentIDSecurityHash,
                CourseID: courseID
            };

            if (courseIDSecurityHash)
            {
                data["CourseID_SecurityHash"] = courseIDSecurityHash;
            }

            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/AddStudentCourseRequest",
                type: "POST",
                dataType: "JSON",
                data: data,
                success: function (data)
                {
                    if (data.success)
                    {
                        updateStudentRequests(data);
                        skyward.matrix.updateAlternateRequests();
                        if (data.LinkedErrors && $(data.LinkedErrors).length > 0)
                        {
                            var errorList = $("<ul/>");

                            $.each(data.LinkedErrors, function (key, value)
                            {
                                var iconSpan = $("<span/>");
                                var listItem = $("<li class='error-list'/>");
                                var errorMessage = $("<span>" + key + "</span>");
                                listItem.append(iconSpan);
                                listItem.append(errorMessage);
                                errorList.append(listItem);
                                buildMessageBoxErrorList(errorList, value);
                            });

                            var okButton = { text: "OK", "click": skyward.window.closePopup, "icon": "Check" };

                            var text = 'This Course is part of Course Alternate Group:' + data.CourseAlternateGroupDescription +' <br>The following Linked Alternates can not be requested:';
                            var message = $('<span/>')
                                .append($('<span>' + text + '</span>'))
                                .append(errorList);

                            skyward.window.closePopup();
                            skyward.modalLayer.showDialog("Unable to Add Linked Student Alternate Course Requests", message, [okButton]);
                        }
                    }
                    else
                    {
                        var errorList = $("<ul/>");

                        if (data.errors && $(data.errors).length > 0)
                        {
                            buildMessageBoxErrorList(errorList, data.errors);
                        }
                        else
                        {
                            buildMessageBoxErrorList(errorList, { "generic": ["A conflict was encountered."] });
                        }

                        var okButton = { text: "OK", "click": skyward.window.closePopup, "icon": "Check" };

                        var text = 'Unable to Add Student Course Request';
                        var message = $('<span/>')
                            .append($('<span>' + text + '</span>'))
                            .append(errorList);

                        skyward.window.closePopup();
                        skyward.modalLayer.showDialog("Unable to Add Student Course Requests", message, [okButton]);
                    }
                    clearQuickEntry();
                }
            });
        };

        skyward.matrix.updateBoard = function ()
        {
            if (availableSectionsCancelButton && availableSectionsCancelButton.data("action") == "")
            {
                toggleCancelButton(false);
            }

            allStudentScheduleViewParts.each(function ()
            {
                if (!document.contains(this))
                {
                    return; // skip detached elements (e.g., from closed popups)
                }

                var thisItem = $(this);
                var postData =
                {
                    LowDate: thisItem.data('startdate'),
                    HighDate: thisItem.data('enddate'),
                    DisplayScheduleForDateRange: thisItem.data('displayschedulefordaterange'),
                    DisplayWeeklyScheduleFor: thisItem.data('displayweeklyschedulefor'),
                    StudentID: thisItem.data('studentid'),
                    studentid_securityhash: thisItem.data('studentid_securityhash'),
                    ViewMode: thisItem.data('viewmode'),
                    EffectiveDate: thisItem.data('effectivedate'),
                    UniqueID: thisItem.data('uniqueid'),
                    DateRangeMode: thisItem.data('daterangemode'),
                    EntityID: thisItem.data('entityid'),
                    entityid_securityhash: thisItem.data('entityid_securityhash'),
                    SchoolYearID: thisItem.data('schoolyearid'),
                    schoolyearid_securityhash: thisItem.data('schoolyearid_securityhash'),
                    WeeklyScheduleSelectedMonth: thisItem.data('weeklyscheduleselectedmonth'),
                    WeeklyScheduleSelectedWeek: thisItem.data('weeklyscheduleselectedweek')
                };

                var viewmode = thisItem.data('viewmode');
                if (AccessMode == "StudentAccess")
                {
                    viewmode = AccessMode;
                }

                if (viewmode == "StudentInformationPopup")
                {
                    var popupAccessMode = thisItem.parent().find("[name='accessmode']");
                    viewmode += skyward.controls.getValue(popupAccessMode);
                }

                $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateScheduleMatrix" + viewmode,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: postData,
                    success: function (htmlResponse)
                    {
                        var newHtml = $(htmlResponse);
                        var data = newHtml.data();
                        if (data["hasnoactivesections"])
                        {
                            cancelActions();
                            var okButton = { text: "OK", "click": skyward.window.closePopup, "icon": "Check" };
                            var title = 'Unable to Schedule Course';
                            var message = 'There are no active Sections of this Course available; the Student cannot be scheduled at this time.';
                            skyward.modalLayer.showDialog(title, message, [okButton]);
                        }
                        else
                        {
                            if (thisItem)
                            {
                                thisItem.html('');

                                if (newHtml.length > 0 && newHtml.children().length > 0)
                                {
                                    thisItem.append(newHtml.children().addBack("script[type='application/json']"));
                                    skyward.matrix.addEventListenerToDataMatrixCards();
                                }

                                skyward.window.notifyDOMLoad(outerMostContainerID); //added to keep datepicker control visible
                            }
                        }
                    }
                });
            });
        };

        skyward.matrix.updateCredits = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetUpdatedCredits",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    studentid: studentScheduleViewPart.data("studentid"),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    entityID: studentScheduleViewPart.data("entityid"),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    schoolYearID: studentScheduleViewPart.data("schoolyearid"),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash')
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        updateStudentRequests(data);
                    }
                }
            });
        };

        skyward.matrix.updateAlternateRequests = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetUpdatedAlternateRequests",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    studentid: studentScheduleViewPart.data("studentid"),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    entityID: studentScheduleViewPart.data("entityid"),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    schoolYearID: studentScheduleViewPart.data("schoolyearid"),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash')
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        if (data.AlternateRequests != "")
                        {
                            $(rightTabCourseRequestContainerID).find('.tabButton').eq(1).text("Alternate Requests (" + data.AlternateRequests + ")");
                        }
                        updateBrowseByName(studentCourseAlternateRequest, {});
                    }
                }
            });
        };

        skyward.matrix.updateScheduleListCredits = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetUpdatedCreditsTotalScheduleList",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    studentid: studentScheduleViewPart.data("studentid"),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    entityID: studentScheduleViewPart.data("entityid"),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    schoolYearID: studentScheduleViewPart.data("schoolyearid"),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash')
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        if (data.ScheduledCredits != "")
                        {
                            $("#ScheduledCredits").val(data.ScheduledCredits);
                        }
                        if (data.TotalCredits != "")
                        {
                            $("#TotalCredits").val(data.TotalCredits);
                        }
                    }
                }
            });
        };

        skyward.matrix.updateCourseRequestsCredits = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetUpdatedCreditsTotalCourseRequests",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    studentid: studentScheduleViewPart.data("studentid"),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    entityID: studentScheduleViewPart.data("entityid"),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    schoolYearID: studentScheduleViewPart.data("schoolyearid"),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash')
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        if (data.ScheduledCredits != "")
                        {
                            $("#ScheduledCredits").val(data.ScheduledCredits);
                        }
                        if (data.TotalCredits != "")
                        {
                            $("#TotalCredits").val(data.TotalCredits);
                        }
                    }
                }
            });
        };

        skyward.matrix.addStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.studentid": browseMenu.data("workflow.studentid"),
                "Workflow.studentid_securityhash": browseMenu.data("workflow.studentid_securityhash"),
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.schoolyearid": browseMenu.data("workflow.schoolyearid"),
                "Workflow.schoolyearid_securityhash": browseMenu.data("workflow.schoolyearid_securityhash"),
                "Workflow.effectivedate": browseMenu.data("workflow.effectivedate"),
                "Workflow.fromschedulelist": browseMenu.data("workflow.fromschedulelist")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Add", null, data, null);
        };

        skyward.matrix.dropStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var studentSectionID = browseMenu.data("workflow.studentsectionid");
            var effectiveDate = browseMenu.data("workflow.effectivedropdate");
            var browseName = browseMenu.data("workflow.:pagestatemodifycontrol");

            var data =
            {
                "Workflow.StudentSectionID": studentSectionID,
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.EffectiveDropDate": effectiveDate,
                "Workflow.:PageStateModifyControl": browseName
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Drop", null, data, null, skyward.matrix.updateScheduleListCredits);
        };

        skyward.matrix.unscheduleStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.studentsectionid": browseMenu.data("workflow.studentsectionid"),
                "Workflow.studentsectionid_securityhash": browseMenu.data("workflow.studentsectionid_securityhash"),
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.:pagestatemodifycontrol": browseMenu.data("workflow.:pagestatemodifycontrol"),
                "Workflow.:pagestatemodifycontrol_securityhash": browseMenu.data("workflow.:pagestatemodifycontrol_securityhash")
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/UnscheduleStudentSection", null, data, null, skyward.matrix.updateScheduleListStudentRequestsAndCredits);
        };

        skyward.matrix.deleteStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var studentSectionID = browseMenu.data("workflow.studentsectionid");
            var studentSectionID_securityhash = browseMenu.data("workflow.studentsectionid_securityhash");

            var data =
            {
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionID_securityhash,
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.:pagestatemodifycontrol": browseMenu.data("workflow.:pagestatemodifycontrol"),
                "Workflow.:pagestatemodifycontrol_securityhash": browseMenu.data("workflow.:pagestatemodifycontrol_securityhash")
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/DeleteStudentSection", null, data, null, skyward.matrix.updateScheduleListStudentAlternatesAndCredits);
        };

        skyward.matrix.replaceStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var studentSectionID = browseMenu.data("workflow.studentsectionid");
            var studentSectionID_securityhash = browseMenu.data("workflow.studentsectionid_securityhash");
            var effectiveDate = browseMenu.data("workflow.effectivedropdate");
            var browseName = browseMenu.data("workflow.:pagestatemodifycontrol");

            var data =
            {
                "Workflow.StudentSectionID": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionID_securityhash,
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.EffectiveDropDate": effectiveDate,
                "Workflow.:PageStateModifyControl": browseName
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Replace", null, data, null, skyward.matrix.updateScheduleListStudentRequestsAndCredits);
        };

        skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.schoolyearid": browseMenu.data("workflow.schoolyearid"),
                "Workflow.schoolyearid_securityhash": browseMenu.data("workflow.schoolyearid_securityhash"),
                "Workflow.isalternate": browseMenu.data("workflow.isalternate"),
                "Workflow.isalternate_securityhash": browseMenu.data("workflow.isalternate_securityhash"),
                "Workflow.studentid": browseMenu.data("workflow.studentid"),
                "Workflow.studentid_securityhash": browseMenu.data("workflow.studentid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/Add", null, data, null, skyward.matrix.updateScheduleListStudentRequestsAndCredits);
        };

        skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleRequestBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.entityid": browseMenu.data("workflow.entityid"),
                "Workflow.entityid_securityhash": browseMenu.data("workflow.entityid_securityhash"),
                "Workflow.schoolyearid": browseMenu.data("workflow.schoolyearid"),
                "Workflow.schoolyearid_securityhash": browseMenu.data("workflow.schoolyearid_securityhash"),
                "Workflow.isalternate": browseMenu.data("workflow.isalternate"),
                "Workflow.isalternate_securityhash": browseMenu.data("workflow.isalternate_securityhash"),
                "Workflow.studentid": browseMenu.data("workflow.studentid"),
                "Workflow.studentid_securityhash": browseMenu.data("workflow.studentid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/Add", null, data, null, skyward.matrix.updateStudentCourseRequests);
        };

        skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);
            var data =
            {
                "Workflow.entityid": button.data("entityid"),
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": button.data("schoolyearid"),
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.isalternate": button.data("isalternate"),
                "Workflow.isalternate_securityhash": button.data("isalternate_securityhash"),
                "Workflow.studentid": button.data("studentid"),
                "Workflow.studentid_securityhash": button.data("studentid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/Add", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.deleteStudentCourseRequestFromScheduleListBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.studentcourserequestid": browseMenu.data("workflow.studentcourserequestid"),
                "Workflow.studentcourserequestid_securityhash": browseMenu.data("workflow.studentcourserequestid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/DeleteStudentCourseRequest", null, data, null, skyward.matrix.updateScheduleListStudentRequestsAndCredits);
        };

        skyward.matrix.deleteStudentCourseRequestFromCourseRequestBrowseMenu = function ()
        {
            var browseMenu = $(this);
            var data =
            {
                "Workflow.studentcourserequestid": browseMenu.data("workflow.studentcourserequestid"),
                "Workflow.studentcourserequestid_securityhash": browseMenu.data("workflow.studentcourserequestid_securityhash")
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/DeleteStudentCourseRequest", null, data, null, skyward.matrix.updateStudentCourseRequests);
        };

        var changeSpecifiedEntityHandler = function ()
        {
            var entitySelector = $(this)[0];
            var selectedIndex = entitySelector.selectedIndex;
            var selectedEntityID = entitySelector[selectedIndex].value;
            var selectedEntityIDHash;
            var selectentityidthenentityidhash = "";

            allStudentScheduleViewParts.each(function ()
            {
                if (document.contains(this))
                {
                    selectentityidthenentityidhash = $(this).data('selectentityidthenentityidhash');
                }
            });

            if (selectentityidthenentityidhash !== "")
            {
                $.each(selectentityidthenentityidhash, function (index, value)
                {
                    var keyValuePair = value.split("->");
                    var entityID = keyValuePair[0];
                    var entityIDHash = keyValuePair[1];

                    if (entityID === selectedEntityID)
                    {
                        selectedEntityIDHash = entityIDHash;
                    }
                });
            }

            studentScheduleViewPart.data('entityid', selectedEntityID);
            studentScheduleViewPart.data('entityid_securityhash', selectedEntityIDHash);

            if (studentScheduleViewPart.data('viewmode') === "Requests")
            {
                skyward.matrix.updateCourseRequestsCredits();
            }
            if (studentScheduleViewPart.data('viewmode') === "List")
            {
                // Browse refreshes are handled by Browse.BaseDependency now, so we just refresh credits/request counts here
                skyward.matrix.updateScheduleListCredits();
            }
            else
            {
                skyward.matrix.updateBoard();
            }
        };

        skyward.matrix.scheduleTypeEventHandler = function ()
        {
            var selectedFilter = $(this)[0];
            var index = selectedFilter.selectedIndex;
            var filterValues = selectedFilter[index].value;
            var values = filterValues.split('#');
            var lowDate = values[1];
            var highDate = values[2];

            studentScheduleViewPart.data('displayschedulefordaterange', filterValues);
            studentScheduleViewPart.data('startdate', lowDate);
            studentScheduleViewPart.data('enddate', highDate);

            if (studentScheduleViewPart.data('viewmode') === "List")
            {
                var browseId = "StudentSections";
                var browse = getBrowseByName(browseId);
                const requiredData = skyward.browse.getRequiredBrowseData(browse);

                $.ajax(
                    {
                        url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GenerateNewStudentScheduleListRouteHash",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            lowDate: lowDate,
                            highDate: highDate,
                            browsePostData: requiredData.postData,
                            browseQueryParameterData: requiredData.queryParameterData,
                            requestDataHash: requiredData.requestDataHash,
                            dynamicFilterValues: requiredData.dynamicFilterValues,
                            dynamicFilterHashes: requiredData.dynamicFilterHashes,
                            DisplayScheduleForDateRange: filterValues
                        },
                        success: function (data)
                        {
                            browse.dynamicFilterValues.filter = data.Filter;
                            browse.dynamicFilterValues.filter_hash = data.FilterHash;
                            updateBrowseByName(browseId, browse.data);
                        }
                    });
            }
            else
            {
                skyward.matrix.updateBoard();
            }
        };

        skyward.matrix.weeklyScheduleMonthEventHandler = function () {
            var monthSelector = $('#cbMonthOfYear')[0];
            var selectedIndex = monthSelector.selectedIndex;
            var selectedMonthID = monthSelector[selectedIndex].value;

            var defaultWeekOfNewMonth = "";
            var weekOfYearSelector = $('#cbWeekOfYear');
            var currentSelectedWeekValue = weekOfYearSelector.val();
            var isValidWeek = false;

            weekOfYearSelector.find("option").each(function (weekID, weekElement) {
                var weekOfYearSelectorValue = weekElement.value;
                var values = weekOfYearSelectorValue.split('#');
                var monthIdOfWeek = values[0];

                if (monthIdOfWeek == selectedMonthID) {
                    skyward.controls.show(weekElement);

                    if (defaultWeekOfNewMonth === "") {
                        defaultWeekOfNewMonth = weekOfYearSelectorValue;
                    }

                    if (weekOfYearSelectorValue === currentSelectedWeekValue) {
                        isValidWeek = true;
                    }
                }
                else {
                    skyward.controls.hide(weekElement);
                }
            });

            var newSelectedWeek = defaultWeekOfNewMonth;

            if (isValidWeek) {
                newSelectedWeek = currentSelectedWeekValue;
            }

            weekOfYearSelector.val(newSelectedWeek);

            skyward.matrix.weeklyScheduleWeekEventHandler();
        };

        skyward.matrix.weeklyScheduleWeekEventHandler = function ()
        {
            var weekOfYearSelector = $('#cbWeekOfYear')[0];
            var weekSelectedIndex = weekOfYearSelector.selectedIndex;
            var weekOfYearSelectorValue = weekOfYearSelector[weekSelectedIndex].value;
            var values = weekOfYearSelectorValue.split('#');
            var selectedMonthOfYear = values[0];
            var selectedWeekOfYear = values[1];
            var lowDate = values[2];
            var highDate = values[3];

            if (AccessMode == "FamilyAccess" || AccessMode == "StudentAccess")
            {
                var postData = { DisplayWeeklyScheduleFor: weekOfYearSelectorValue };
                $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StudentScheduleDisplay/SaveSelectedWeekOfYearValue" + AccessMode,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        allStudentScheduleViewParts.each(function ()
                        {
                            $(this).data('displayweeklyschedulefor', weekOfYearSelectorValue);
                            $(this).data('startdate', lowDate);
                            $(this).data('enddate', highDate);
                        });

                        skyward.matrix.updateBoard();
                    }
                });
            }
            else
            {
                studentScheduleViewPart.data('displayweeklyschedulefor', weekOfYearSelectorValue);
                studentScheduleViewPart.data('startdate', lowDate);
                studentScheduleViewPart.data('enddate', highDate);

                skyward.matrix.updateBoard();
            }
        };

        skyward.matrix.effectiveDateChangeEventHandler = function ()
        {
            var previousValue = studentScheduleViewPart.data("effectivedate");
            var pickerDateText = this.value.split(" ")[0];
            var pickerDate = skyward.controls.getValue(this); // Without day of week.
            if (previousValue == pickerDateText)
            {
                return;
            }

            if (!skyward.time.isDate(pickerDate))
            {
                showDatePickerError(previousValue, pickerDateText);
                return;
            }
            else
            {
                studentScheduleViewPart.data("effectivedate", pickerDateText);
            }

            switch (studentScheduleViewPart.data('viewmode'))
            {
                case "List":
                    changeBrowseVariables("UpdateSessionVariableScheduleList", pickerDateText);
                    break;
                case "Builder":
                    changeBrowseVariables("UpdateSessionVariableScheduleBuilder", pickerDateText);
                    break;
            }
        };

        var changeBrowseVariables = function (action, effectiveDate)
        {
            if (action)
            {
                $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: { effectiveDate: effectiveDate }
                });
            }
        };

        skyward.matrix.dateRangeMode = function ()
        {
            var dateRangeModeSelector = $('#cbScheduleDateRangeMode')[0];
            var dateRangeModeSelectedIndex = dateRangeModeSelector.selectedIndex;
            var selectedMode = dateRangeModeSelector[dateRangeModeSelectedIndex].value;

            var postData = { DateRangeMode: selectedMode };

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentScheduleDisplay/SetDateRangeMode" + AccessMode,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    allStudentScheduleViewParts.each(function ()
                    {
                        $(this).data('daterangemode', selectedMode);
                    });

                    if (AccessMode == "FamilyAccess" || AccessMode == "StudentAccess")
                    {
                        var monthOfYearLabel = $('#lblMonthOfYear')[0];
                        var monthOfYearSelector = $('#cbMonthOfYear')[0];
                        var weekOfYearLabel = $('#lblWeekOfYear')[0];
                        var weekOfYearSelector = $('#cbWeekOfYear')[0];

                        if (monthOfYearLabel != null && monthOfYearSelector != null && weekOfYearLabel != null && weekOfYearSelector != null)
                        {
                            if (selectedMode == "WeeklySchedule")
                            {
                                monthOfYearLabel.style.display = "";
                                monthOfYearSelector.disabled = false;
                                monthOfYearSelector.style.display = "";
                                weekOfYearLabel.style.display = "";
                                weekOfYearSelector.disabled = false;
                                weekOfYearSelector.style.display = "";
                            }
                            else
                            {
                                monthOfYearLabel.style.display = "none";
                                monthOfYearSelector.style.display = "none";
                                weekOfYearLabel.style.display = "none";
                                weekOfYearSelector.style.display = "none";
                            }
                        }
                    }

                    skyward.matrix.updateBoard();
                }
            });
        };

        var getEffectiveDate = function ()
        {
            return skyward.time.parseDate(studentScheduleViewPart.data("effectivedate"));
        };

        var showDatePickerError = function (originalValue, proposedValue)
        {
            var message = '"' + proposedValue + '" could not be used as a date. The effective date will be changed back to ' + originalValue + '.';
            skyward.modalLayer.showDialog("Invalid Date.", message, undefined, { beforeClose: function () { skyward.controls.setValue($(effectiveDatePickerID), originalValue); } });
        };

        var updateStudentRequests = function (data)
        {
            if (data != null)
            {
                //Update the Credits section
                if (data.ElectiveCredits != "")
                {
                    $("#ElectiveCredits").val(data.ElectiveCredits);
                }

                if (data.RequiredCredits != "")
                {
                    $("#RequiredCredits").val(data.RequiredCredits);
                }

                if (data.TotalCredits != "")
                {
                    $("#TotalCredits").val(data.TotalCredits);
                }

                var browseData = {};
                if (data.StudentCourseRequestID)
                {
                    browseData.seekId = data.StudentCourseRequestID;
                }
                updateBrowseByName(studentCourseRequestBrowse, browseData);
            }
        };

        skyward.matrix.updateScheduleListPieces = function ()
        {
            skyward.matrix.updateScheduleListCredits();
            skyward.matrix.updateScheduleListAllBrowses();
        };

        skyward.matrix.updateScheduleListAllBrowses = function ()
        {
            skyward.matrix.updateScheduleListStudentSections();
            skyward.matrix.updateScheduleListStudentRequestsAndAlternates();
        };

        skyward.matrix.updateScheduleListStudentRequestsAndCredits = function ()
        {
            skyward.matrix.updateScheduleListCredits();
            skyward.matrix.updateScheduleListStudentRequestsAndAlternates();
        };

        skyward.matrix.updateStudentCourseRequests = function ()
        {
            skyward.matrix.updateCourseRequestsCredits();
            updateBrowseByName(studentCombineRequestScheduleListBrowse, {});
        };

        skyward.matrix.updateScheduleListStudentRequestsAndAlternates = function ()
        {
            updateBrowseByName(studentCourseRequestScheduleListBrowse, {});
            skyward.matrix.updateScheduleListAlternateRequests();
        };

        skyward.matrix.updateScheduleListStudentAlternatesAndCredits = function ()
        {
            skyward.matrix.updateScheduleListCredits();
            skyward.matrix.updateScheduleListAlternateRequests();
        };

        skyward.matrix.updateScheduleListAlternateRequests = function ()
        {
            updateBrowseByName(studentAlternateRequestScheduleListBrowse, {});
        };

        skyward.matrix.updateScheduleListStudentSections = function ()
        {
            updateBrowseByName(studentSectionScheduleListBrowse, {});
        };

        skyward.matrix.addStudentSectionFromSectionAddLink = function (event)
        {
            setAvailableSectionInfo(event);
            skyward.matrix.addStudentSectionWorkflow();
            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        var setAvailableSectionInfo = function (event)
        {
            var cellID = event.currentTarget.id;
            var cellDiv;
            if (cellID.indexOf("Add") != -1)
            {
                cellID = cellID.replace("_Add", "");
                cellDiv = $("#" + cellID);
            }
            else
            {
                cellDiv = $(event.currentTarget);
            }

            studentScheduleViewPart.data('availablesectionsectionid', cellDiv.data("sectionid"));
            studentScheduleViewPart.data('availablesectionsectionid_securityhash', cellDiv.data("sectionid_securityhash"));
            studentScheduleViewPart.data('availablesectionstudentsectionsectionid_securityhash', cellDiv.data("studentsectionsectionid_securityhash"));
            studentScheduleViewPart.data('availablesectionstartdate', cellDiv.data("startdate"));
            studentScheduleViewPart.data('availablesectionenddate', cellDiv.data("enddate"));

            studentScheduleViewPart.data("availablesectioncourseinfo",
                {
                    courseCode: cellDiv.data("coursecode"),
                    courseDescription: cellDiv.data("coursedescription"),
                    sectionCode: cellDiv.data("sectioncode")
                });
        };

        var setAvailableSectionInfoFromBrowseMenu = function (sectionID, sectionID_securityhash, startDate, endDate, sectionBrowseName)
        {
            studentScheduleViewPart.data('availablesectionsectionid', sectionID);
            studentScheduleViewPart.data('availablesectionsectionid_securityhash', sectionID_securityhash);
            studentScheduleViewPart.data('availablesectionstudentsectionsectionid_securityhash', sectionID_securityhash);
            studentScheduleViewPart.data('availablesectionstartdate', startDate);
            studentScheduleViewPart.data('availablesectionenddate', endDate);

            var browse = getBrowseByName(sectionBrowseName);

            if (sectionBrowseName && browse)
            {
                var sectionRowIndex = $.inArray(parseInt(sectionID, 10), browse.primaryKeys);

                if (sectionRowIndex !== -1)
                {
                    const sectionRowData = browse.rowData?.[sectionRowIndex];
                    if (sectionRowData && sectionRowData["Course.CourseCode"] && sectionRowData["Course.Description"] && sectionRowData["Code"])
                    {
                        studentScheduleViewPart.data("availablesectioncourseinfo",
                            {
                                courseCode: sectionRowData["Course.CourseCode"],
                                courseDescription: sectionRowData["Course.Description"],
                                sectionCode: sectionRowData["Code"]
                            });
                    }
                }
                else
                {
                    studentScheduleViewPart.data("availablesectioncourseinfo",
                        {
                            courseCode: "",
                            courseDescription: "",
                            sectionCode: ""
                        });
                }
            }
            else
            {
                studentScheduleViewPart.data("availablesectioncourseinfo",
                    {
                        courseCode: "",
                        courseDescription: "",
                        sectionCode: ""
                    });
            }
        };

        skyward.matrix.addStudentSectionFromClassSummary = function ()
        {
            skyward.matrix.addStudentSectionWorkflow();
        };

        var addStudentSectionFromBrowseMenu = function ()
        {
            var data = $(this).data();
            var sectionID = data.sectionid;
            var sectionID_securityhash = data.sectionid_securityhash;
            var startDate = data.startdate;
            var endDate = data.enddate;
            var browseName = data.browsename;

            skyward.matrix.addStudentSectionFromBrowseMenu(sectionID, sectionID_securityhash, startDate, endDate, browseName);
        };

        skyward.matrix.addStudentSectionFromBrowseMenu = function (sectionID, sectionID_securityhash, startDate, endDate, sectionBrowseName)
        {
            setAvailableSectionInfoFromBrowseMenu(sectionID, sectionID_securityhash, startDate, endDate, sectionBrowseName);
            skyward.matrix.addStudentSectionWorkflow();
        };

        skyward.matrix.addStudentSectionWorkflow = function ()
        {
            studentScheduleViewPart.data("selectedStudentSection", studentScheduleViewPart.data("activeStudentSectionCard"));
            setStudentSectionInfo();

            var data =
            {
                "Workflow.effectivedate": studentScheduleViewPart.data("effectivedate"),
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data("entityid_securityhash"),
                "Workflow.schoolyearid": studentScheduleViewPart.data("schoolyearid"),
                "Workflow.schoolyearid_securityhash": studentScheduleViewPart.data("schoolyearid_securityhash"),
                "Workflow.sectionid": studentScheduleViewPart.data('availablesectionsectionid'),
                "Workflow.sectionid_securityhash": studentScheduleViewPart.data('availablesectionsectionid_securityhash'),
                "Workflow.studentid": studentScheduleViewPart.data("studentid"),
                "Workflow.studentid_securityhash": studentScheduleViewPart.data("studentid_securityhash"),
                "Workflow.PageStateModifyControl": ""
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Add", null, data, null);
        };

        skyward.matrix.addStudentSectionWorkflowClosed = function ()
        {
            skyward.matrix.reloadScheduleBuilderMatrixAndRequests();
            if (availableSectionsCancelButton.data("action") == "AddByCourse")
            {
                skyward.matrix.updateAvailableCoursesPanel();
            }
            else
            {
                collapseBottomPanels();
            }
        };

        skyward.matrix.updateAvailableCoursesPanel = function ()
        {
            toggleCancelButton(true, "AddByCourse");

            //if the schedule matrix is in a state with available sections, then it needs to be updated
            var scheduleMatrixCourseID = studentScheduleViewPart.data('courseid');
            if (scheduleMatrixCourseID != "" && scheduleMatrixCourseID != null)
            {
                skyward.matrix.updateBoard();
            }

            if (coursePanelOnRight)
            {
                showRightPanelCourseTabs("Add By Course", "Add By Sections");
                return;
            }

            togglePanelToDisplay(bottomTabCourseContainer);

            setBottomTabCourseContainerCurrentTab();
        };

        var setBottomTabCourseContainerCurrentTab = function ()
        {
            var currentTab = undefined;

            var panelInfo = bottomTabCourseContainer.data("panelinfo");
            if (panelInfo != undefined && panelInfo.currentTab != undefined)
            {
                currentTab = panelInfo.currentTab;
            }

            if (currentTab == undefined)
            {
                bottomTabCourseContainerSetFirstTabCurrent();
                currentTab = bottomTabCourseContainer.find(".tabStrip .tabButton.firstTab");
            }

            // Sets tab text for "View Course List" Action
            $(bottomTabCourseContainerID).find('.tabButton').eq(0).text("Add By Course");
            $(bottomTabCourseContainerID).find('.tabButton').eq(1).text("Add By Sections");

            bottomTabCourseContainerSetDataProperties(true, currentTab);
            bottomTabCourseContainerExpand();
        };

        skyward.matrix.updateBottomTabContainerFromCourseBrowseMenu = function ()
        {
            var data = $(this).data();
            var courseID = data.courseid;
            var courseCode = data.courseCode;
            var courseDescription = data.courseDescription;

            studentScheduleViewPart.data("selectedStudentSection",
                {
                    courseid_securityhash: data.courseid_securityhash
                });
            setStudentSectionInfo();
            skyward.matrix.updateBottomTabContainerFromCourse("AddByCourseShowSections", courseID, courseCode, courseDescription);
        };

        skyward.matrix.updateBottomTabContainerFromRequestBrowseMenu = function ()
        {
            var data = $(this).data();
            var courseID = data.courseid;
            var courseCode = data.courseCode;
            var courseDescription = data.courseDescription;
            var studentCourseRequestID = data.studentcourserequestid;

            var studentSectionID = "";
            var rowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

            if (rowIndex !== -1)
            {
                var browse = getBrowseByName(studentCourseRequestBrowse);
                studentSectionID = browse.rowData[rowIndex]['StudentSectionID'];
            }

            studentScheduleViewPart.data("selectedStudentSection",
                {
                    studentsectionstartdate: "",
                    studentsectionenddate: "",
                    studentsectionid: studentSectionID,
                    studentsectionid_securityhash: "",
                    courseid: courseID,
                    courseid_securityhash: data.courseid_securityhash,
                    courseCode: courseCode,
                    courseDescription: courseDescription,
                    sectionCode: "",
                    sectionid: "",
                    sectionid_securityhash: "",
                    cellid: "",
                    studentsectiontransactionid: "",
                    studentsectiontransactionid_securityhash: "",
                    studentcourserequestid: studentCourseRequestID,
                    studentcourserequestid_securityhash: data.studentcourserequestid_securityhash,
                    countsforviewingentity: "",
                    hasatleastonetransactionnotcounttowardsviewingentity: "",
                    alltransactionscounttowardsviewingentity: "",
                    requestedfromofferingentityandalltransactionscounttowardsviewingentity: "",
                    requestedfromviewingentityandalltransactionscounttowardsviewingentity: "",
                    daterangescounttowardsviewingentity: ""
                });
            setStudentSectionInfo();

            activateSelectedRow(studentCourseRequestBrowse, studentCourseRequestID, studentSectionID);
            skyward.matrix.updateBottomTabContainerFromCourse("ScheduleCourse", courseID, courseCode, courseDescription, studentCourseRequestID);
        };

        skyward.matrix.updateAvailableSectionsOnBoard = function (courseID, studentCourseRequestID, changeSection, sectionID, courseCode, courseDescription)
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateScheduleMatrix" + studentScheduleViewPart.data('viewmode'),
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    StudentID: studentScheduleViewPart.data('studentid'),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    LowDate: studentScheduleViewPart.data('startdate'),
                    HighDate: studentScheduleViewPart.data('enddate'),
                    ViewMode: studentScheduleViewPart.data('viewmode'),
                    DisplayScheduleForDateRange: studentScheduleViewPart.data('displayschedulefordaterange'),
                    DisplayWeeklyScheduleFor: studentScheduleViewPart.data('displayweeklyschedulefor'),
                    CourseID: courseID,
                    courseid_securityhash: studentScheduleViewPart.data('courseid_securityhash'),
                    ShowSections: true,
                    ChangeSection: changeSection,
                    SectionID: sectionID, //only applies to Change Section,
                    sectionid_securityhash: studentScheduleViewPart.data('sectionid_securityhash'),
                    effectivedate: studentScheduleViewPart.data("effectivedate"),
                    EntityID: studentScheduleViewPart.data('entityid'),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    SchoolYearID: studentScheduleViewPart.data('schoolyearid'),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash'),
                    WeeklyScheduleSelectedMonth: studentScheduleViewPart.data('weeklyscheduleselectedmonth'),
                    WeeklyScheduleSelectedWeek: studentScheduleViewPart.data('weeklyscheduleselectedweek')
                },
                success: function (htmlResponse)
                {
                    var newHtml = $(htmlResponse);
                    var data = newHtml.data();
                    if (data["hasnoactivesections"])
                    {
                        cancelActions();
                        var okButton = { text: "OK", "click": skyward.window.closePopup, "icon": "Check" };
                        var title = 'Unable to Schedule Course';
                        var message;
                        if (changeSection)
                        {
                            message = 'There are no other active Sections of this Course available; the Student cannot change sections at this time.';
                        }
                        else
                        {
                            message = 'There are no active Sections of this Course available; the Student cannot be scheduled at this time.';
                        }
                        skyward.modalLayer.showDialog(title, message, [okButton]);
                    }
                    else
                    {
                        studentScheduleViewPart.html('');

                        if (newHtml.length > 0 && newHtml.children().length > 0)
                        {
                            studentScheduleViewPart.append(newHtml.children().addBack("script[type='application/json']"));
                        }

                        var numberAvailableSections = data["numberactivesections"];
                        var numberAvailableSectionsOpen = data["numberactivesectionsopen"];
                        if (numberAvailableSections != null && numberAvailableSections != "undefined" && numberAvailableSectionsOpen != null && numberAvailableSectionsOpen != "undefined")
                        {
                            var closedBrowseTitle = courseCode + " - " + courseDescription + " | " + numberAvailableSections + " Sections, " + numberAvailableSectionsOpen + " Open";
                            if (coursePanelOnRight)
                            {
                                rightPanelTabButton(rightPanelTabIndex.sections).text(closedBrowseTitle);
                            }
                            else
                            {
                                $(bottomTabContainerID).find('.firstTab').text(closedBrowseTitle);
                            }
                        }
                        studentScheduleViewPart.data('courseid', data["courseid"]);

                        selectStudentCourseListRow(studentCourseRequestID);

                        skyward.matrix.addEventListenerToDataMatrixCards();
                        skyward.matrix.addEventListenerToAvailableSectionCards();
                        skyward.window.notifyDOMLoad(outerMostContainerID); //added to keep datepicker control visible
                    }
                }
            });
        };

        skyward.matrix.updateBottomTabContainer = function (browseTitle, data)
        {
            loadBottomTabSectionsContainer(browseTitle, data);
            bottomTabContainerSetDataProperties(true);

            if (coursePanelOnRight)
            {
                // Replace / schedule-a-course sections load into the single Available Sections tab (index sections).
                hideRightPanelDynamicTabs();
                showRightPanelTab(rightPanelTabIndex.sections, browseTitle);
                expandRightPanelIfCollapsed();
                activateRightPanelTab(rightPanelTabIndex.sections);
                return;
            }

            if (availableSectionsCancelButton.data("action") != undefined && availableSectionsCancelButton.data("action") != "ChangeSection" && availableSectionsCancelButton.data("action") != "ScheduleCourse")
            {
                bottomTabContainerExpand();
            }
            else
            {
                bottomTabContainerCollapse();
                togglePanelToDisplay(bottomTabContainer);
            }
        };

        var loadBottomTabSectionsContainer = function (browseTitle, data)
        {
            $(bottomTabContainerID).find('.firstTab').text(browseTitle);
            $("#" + availableSectionsView).data("browseLoaded", "");
            skyward.window.loadContent(availableSectionsView, 'Scheduling', 'StudentSchedule', 'GetAvailableBrowse', null, data, null, null, null, true);
        };

        skyward.matrix.updateBottomTabCourseContainer = function (firstTabBrowseTitle, secondTabBrowseTitle, data)
        {
            loadBottomTabSectionsCourseContainerFirstTab(firstTabBrowseTitle, data);
            loadBottomTabSectionsCourseContainerSecondTab(secondTabBrowseTitle, data);

            if (coursePanelOnRight)
            {
                // Open Period loads into the same two tabs as View Course List (Add By Course / Add By Sections),
                // just with period-specific titles and browse content.
                hideRightPanelDynamicTabs();
                showRightPanelTab(rightPanelTabIndex.addByCourse, firstTabBrowseTitle);
                showRightPanelTab(rightPanelTabIndex.addBySections, secondTabBrowseTitle);
                expandRightPanelIfCollapsed();
                activateRightPanelTab(rightPanelTabIndex.addByCourse);
                return;
            }

            if (availableSectionsCancelButton.data("action") != undefined && availableSectionsCancelButton.data("action") != "ChangeSection" && availableSectionsCancelButton.data("action") != "ScheduleCourse")
            {
                togglePanelToDisplay(bottomTabCourseContainer);
                bottomTabCourseContainerExpand();
            }
            else
            {
                togglePanelToDisplay(bottomTabCourseContainer);
            }
        };

        var loadBottomTabSectionsCourseContainerFirstTab = function (browseTitle, data)
        {
            $(bottomTabCourseContainerID).find('.tabButton').eq(0).text(browseTitle);
            $("#" + availableCoursesBrowseView).data("browseLoaded", "");
            skyward.window.loadContent(availableCoursesBrowseView, 'Scheduling', 'StudentSchedule', 'GetAvailableSectionsByRequestsAndOpenPeriodBrowse', null, data, null, null, null, true);
        };

        var loadBottomTabSectionsCourseContainerSecondTab = function (browseTitle, data)
        {
            $(bottomTabCourseContainerID).find('.tabButton').eq(1).text(browseTitle);
            $("#" + availableSectionsByOpenSectionsBrowseView).data("browseLoaded", "");
            skyward.window.loadContent(availableSectionsByOpenSectionsBrowseView, 'Scheduling', 'StudentSchedule', 'GetAvailableSectionsByOpenPeriodBrowse', null, data, null, null, null, true);
        };

        skyward.matrix.updateBottomTabContainerFromCourse = function (action, courseID, courseCode, courseDescription, studentCourseRequestID, sectionID, changeSection)
        {
            var browseTitle = courseCode + " - " + courseDescription;
            var data = {
                studentid: studentScheduleViewPart.data('studentid'),
                studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                courseid: courseID,
                courseid_securityhash: studentScheduleViewPart.data('courseid_securityhash'),
                ChangeSection: changeSection,
                EffectiveDate: studentScheduleViewPart.data("effectivedate")
            };

            skyward.window.closePopup();
            toggleCancelButton(true, action);

            skyward.matrix.updateBottomTabContainer(browseTitle, data);
            skyward.matrix.updateAvailableSectionsOnBoard(courseID, studentCourseRequestID, changeSection, sectionID, courseCode, courseDescription);
        };

        skyward.matrix.updateAvailableSectionsOnBoardForReplace = function (courseID, studentCourseRequestID)
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateScheduleMatrix" + studentScheduleViewPart.data('viewmode'),
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    StudentID: studentScheduleViewPart.data('studentid'),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    ViewMode: studentScheduleViewPart.data('viewmode'),
                    DisplayScheduleForDateRange: studentScheduleViewPart.data('displayschedulefordaterange'),
                    DisplayWeeklyScheduleFor: studentScheduleViewPart.data('displayweeklyschedulefor'),
                    CourseID: courseID,
                    courseid_securityhash: studentScheduleViewPart.data('courseid_securityhash'),
                    effectivedate: studentScheduleViewPart.data("effectivedate"),
                    EntityID: studentScheduleViewPart.data('entityid'),
                    entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                    SchoolYearID: studentScheduleViewPart.data('schoolyearid'),
                    schoolyearid_securityhash: studentScheduleViewPart.data('schoolyearid_securityhash'),
                    WeeklyScheduleSelectedMonth: studentScheduleViewPart.data('weeklyscheduleselectedmonth'),
                    WeeklyScheduleSelectedWeek: studentScheduleViewPart.data('weeklyscheduleselectedweek')

                },
                success: function (htmlResponse)
                {
                    var newHtml = $(htmlResponse);
                    var data = newHtml.data();
                    if (data["hasnoactivesections"])
                    {
                        cancelActions();
                        var okButton = { text: "OK", "click": skyward.window.closePopup, "icon": "Check" };
                        var title = 'Unable to Schedule Course';
                        var message = 'There are no active Sections of this Course available; the Student cannot be scheduled at this time.';
                        skyward.modalLayer.showDialog(title, message, [okButton]);
                    }
                    else
                    {
                        studentScheduleViewPart.html('');

                        if (newHtml.length > 0 && newHtml.children().length > 0)
                        {
                            studentScheduleViewPart.append(newHtml.children().addBack("script[type='application/json']"));
                        }
                        studentScheduleViewPart.data('courseid', data["courseid"]);

                        selectStudentCourseListRow(studentCourseRequestID);

                        skyward.matrix.addEventListenerToDataMatrixCards();
                        skyward.window.notifyDOMLoad(outerMostContainerID); //added to keep datepicker control visible
                    }
                }
            });
        };

        skyward.matrix.updateBottomTabContainerFromReplace = function (action, courseID, courseIDSecurityHash, courseCode, sectionCode, courseDescription, studentCourseRequestID, sectionID, studentSectionID, studentSectionIDSecurityHash, replaceSection)
        {
            var browseTitle = "Replace " + courseDescription + " " + courseCode + "/" + sectionCode;
            var data = {
                CourseID: courseID,
                courseid_securityhash: courseIDSecurityHash,
                ReplaceSection: replaceSection,
                StudentSectionID: studentSectionID,
                studentsectionid_securityhash: studentSectionIDSecurityHash,
                EffectiveDate: studentScheduleViewPart.data("effectivedate")
            };

            skyward.window.closePopup();
            toggleCancelButton(true, action);

            skyward.matrix.updateBottomTabContainer(browseTitle, data);

            skyward.matrix.updateAvailableSectionsOnBoardForReplace(courseID, studentCourseRequestID);
        };

        skyward.matrix.updateBottomTabCourseContainerFromDisplayPeriod = function (event)
        {
            if (studentScheduleViewPart.data("viewmode") == "Builder")
            {
                var openCell = $(event.currentTarget);

                var courseRequestBrowseTitle = "Requested Courses - " + "Period " + openCell.data("displayperiodcode") + " Sections " + "(" + openCell.data("dayrotationcode") + ")";
                var allCoursesBrowseTitle = "All Courses - " + "Period " + openCell.data("displayperiodcode") + " Sections " + "(" + openCell.data("dayrotationcode") + ")";
                var data = {
                    studentid: studentScheduleViewPart.data('studentid'),
                    studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                    DisplayPeriodID: openCell.data("displayperiodid"),
                    displayperiodid_securityhash: openCell.data("displayperiodid_securityhash"),
                    StartDate: openCell.data("startdate"),
                    EndDate: openCell.data("enddate"),
                    EffectiveDate: studentScheduleViewPart.data("effectivedate")
                };

                var scheduleMatrixCourseID = studentScheduleViewPart.data('courseid');
                if (availableSectionsCancelButton && availableSectionsCancelButton.hasClass("matrixButtonEnable") || scheduleMatrixCourseID != "" || scheduleMatrixCourseID != null)
                {
                    deactivateSelectedRow(false);
                    toggleCancelButton(true, "AddSectionsByOpenPeriod");
                    skyward.matrix.updateBoard();
                }

                skyward.matrix.updateBottomTabCourseContainer(courseRequestBrowseTitle, allCoursesBrowseTitle, data);

                if (!coursePanelOnRight)
                {
                    // Bottom-panel layout: set/expand the current tab. In the right-panel layout
                    // updateBottomTabCourseContainer already showed, expanded, and activated the correct tab.
                    bottomTabCourseContainerSetFirstTabCurrent();
                    var currentTab = bottomTabCourseContainer.find(".tabStrip .tabButton.firstTab");
                    bottomTabCourseContainerSetDataProperties(true, currentTab);
                    bottomTabCourseContainerExpand();
                }
            }
        };

        skyward.matrix.reloadScheduleBuilderMatrixAndRequests = function ()
        {
            cancelActions();
            skyward.matrix.updateBoard();
            skyward.matrix.updateCredits();
            skyward.matrix.updateAlternateRequests();
        };

        var findCurrentTab = function (panelID)
        {
            if (panelID != undefined && panelID != "")
            {
                var currentTab = $(panelID).find('.tabButton.current');

                if (currentTab.length > 0)
                {
                    return currentTab;
                }
            }

            return undefined;
        };

        var findCurrentTabContent = function (currentTabIndex, panelID)
        {
            if (currentTabIndex != undefined && currentTabIndex > -1)
            {
                var tabContents = $(panelID).find('.tabContents');

                if (tabContents.length >= (currentTabIndex + 1))
                {
                    return $(tabContents[currentTabIndex]);
                }
            }

            return undefined;
        };

        var findCurrentTabContentContentContainer = function (tabContent)
        {
            if (tabContent != undefined && tabContent.length > 0)
            {
                var contentContainer = tabContent.children('.contentContainer');

                if (contentContainer.length > 0)
                {
                    return contentContainer;
                }
            }

            return undefined;
        };

        var findContentContainerFromCurrentTab = function (currentTab)
        {
            if (currentTab == undefined || !currentTab.length)
            {
                currentTab = findCurrentTab(bottomTabCourseContainerID);
            }

            if (currentTab == undefined || !currentTab.length || currentTab.data("index") == undefined || isNaN(currentTab.data("index")))
            {
                return { contentContainer: undefined };
            }

            var currentTabIndex = currentTab.data("index");
            var tabContent = findCurrentTabContent(currentTabIndex, bottomTabCourseContainerID);
            if (tabContent == undefined || !(tabContent.length > 0))
            {
                return { contentContainer: undefined };
            }

            var contentContainer = findCurrentTabContentContentContainer(tabContent);
            if (contentContainer == undefined || !(contentContainer.length > 0))
            {
                return { contentContainer: undefined };
            }

            var loadBrowse = false;
            if ((currentTab.data("refreshonclick") != undefined && currentTab.data("refreshonclick") == true) || contentContainer.data("browseLoaded") == undefined || contentContainer.data("browseLoaded") == false)
            {
                loadBrowse = true;
            }

            return { contentContainer: contentContainer, loadBrowse: loadBrowse };
        };

        var bottomTabContainerTabClicked = function ()
        {
            bottomTabContainerExpand();
            bottomTabContainerSearchBoxSetFocus();
        };

        var bottomTabContainerExpand = function ()
        {
            if (bottomTabContainer.hasClass("collapsed"))
            {
                $(bottomTabContainerID + 'ToggleButton').click();
            }
            else
            {
                bottomTabBeginExpand();
            }
        };

        var bottomTabBeginExpand = function ()
        {
            var bottomPanelAction = availableSectionsCancelButton.data("action");
            var displayPanel = bottomTabContainer.data("displayPanel");
            if ((bottomPanelAction != undefined && bottomPanelAction == "AddByCourseShowSections") || (displayPanel != undefined && displayPanel == true))
            {
                togglePanelToDisplay(bottomTabContainer);
                if (bottomTabContainer.hasClass("expanded"))
                {
                    var loadedBrowse = getbottomTabContainerLoadedBrowse();
                    if (loadedBrowse != "")
                    {
                        $("#" + loadedBrowse + "_seek").focus();
                    }
                }
            }
        };

        var bottomTabContainerExpanded = function ()
        {
            // maybe get rid of this
            bottomTabCourseContainerExpand();
            bottomTabContainerSearchBoxSetFocus();
        };

        var bottomTabContainerCollapse = function ()
        {
            if (!bottomTabContainer.hasClass("collapsed"))
            {
                $(bottomTabContainerID + 'ToggleButton').click();
            }
        };

        var bottomTabContainerCollapsed = function ()
        {
            // When there is no active action (including the initial page load) keep BOTH bottom browse panels
            // hidden rather than leaving the Available Sections panel showing as an empty collapsed strip.
            // The panels are revealed only when an action (Replace/Add/View Course List) calls
            // togglePanelToDisplay with the panel to show.
            var bottomPanelAction = availableSectionsCancelButton.data("action");
            if (bottomPanelAction == undefined || bottomPanelAction == "")
            {
                loadBottomTabSectionsContainer("", { CourseID: "-1", EffectiveDate: studentScheduleViewPart.data("effectivedate") });
                togglePanelToDisplay();
            }
        };

        var bottomTabContainerSetDataProperties = function (displayPanel)
        {
            bottomTabContainer.data("displayPanel", displayPanel);
        };

        var bottomTabCourseContainerTabClicked = function ()
        {
            bottomTabCourseContainerSetDataProperties(true, $(this));
            bottomTabCourseContainerExpand();
        };

        var bottomTabCourseContainerExpand = function ()
        {
            if (bottomTabCourseContainer.hasClass("collapsed"))
            {
                $(bottomTabCourseContainerID + 'ToggleButton').click();
            }
            else
            {
                bottomTabCourseContainerBeginExpand();
            }
        };

        var bottomTabCourseContainerBeginExpand = function ()
        {
            var panelInfo = getBottomTabCourseContainerPanelInfo("displayPanelAndcurrentTab");
            var displayPanel = panelInfo.displayPanel;
            var currentTab = panelInfo.currentTab;
            var bottomPanelAction = availableSectionsCancelButton.data("action");

            if (bottomPanelAction != undefined && (bottomPanelAction == "AddByCourse" || bottomPanelAction == "AddSectionsByOpenPeriod") && displayPanel != undefined && displayPanel == true && currentTab != undefined && currentTab.length)
            {
                togglePanelToDisplay(bottomTabCourseContainer);

                if (bottomPanelAction == "AddByCourse")
                {
                    loadCourseTabContainer(currentTab);
                }

                if (bottomTabCourseContainer.hasClass("expanded"))
                {
                    bottomTabCourseContainerResizeAndSearchBoxSetFocus();
                }
            }
        };

        var bottomTabCourseContainerExpanded = function ()
        {
            bottomTabContainerExpand();

            var displayPanel = getBottomTabCourseContainerPanelInfo("currentTab");
            if (displayPanel.currentTab != undefined)
            {
                bottomTabCourseContainerSearchBoxSetFocus(displayPanel.currentTab);
            }
        };

        var bottomTabCourseContainerCollapse = function ()
        {
            if (bottomTabCourseContainer.hasClass("expanded"))
            {
                $(bottomTabCourseContainerID + 'ToggleButton').click();
            }
        };

        var bottomTabCourseContainerSetDataProperties = function (displayPanel, currentTab, forceClear)
        {
            if (currentTab || (forceClear != undefined && forceClear))
            {
                bottomTabCourseContainer.data("panelinfo",
                    {
                        "displayPanel": displayPanel,
                        "currentTab": currentTab
                    });
            }
        };

        // ----- "Display Course List on Right" layout: right-panel dynamic tab helpers -----
        // When coursePanelOnRight is true the course/section browses are tabs inside #rightSliderPanel at the
        // rightPanelTabIndex.* positions. These helpers show/hide, re-title, and activate them; the always-present
        // Student Course List (0) and Alternate Requests (1) tabs are never hidden.

        var rightPanelTabButton = function (index)
        {
            return $(rightTabCourseRequestContainerID).find(".tabStrip .tabButton").eq(index);
        };

        var showRightPanelTab = function (index, title)
        {
            rightPanelTabButton(index).removeClass(rightPanelDynamicTabHiddenClass);
            if (title != undefined)
            {
                rightPanelTabButton(index).text(title);
            }
            syncRightPanelDynamicTabVisibility();
        };

        var hideRightPanelDynamicTabs = function ()
        {
            rightPanelTabButton(rightPanelTabIndex.addByCourse).addClass(rightPanelDynamicTabHiddenClass);
            rightPanelTabButton(rightPanelTabIndex.addBySections).addClass(rightPanelDynamicTabHiddenClass);
            rightPanelTabButton(rightPanelTabIndex.sections).addClass(rightPanelDynamicTabHiddenClass);
            syncRightPanelDynamicTabVisibility();
        };

        var hideRightPanelCourseRequestTabs = function ()
        {
            rightPanelTabButton(rightPanelTabIndex.courseList).addClass(rightPanelDynamicTabHiddenClass);
            rightPanelTabButton(rightPanelTabIndex.alternates).addClass(rightPanelDynamicTabHiddenClass);
            syncRightPanelDynamicTabVisibility();
        };

        // Syncs each dynamic tab button's inline display to its hidden-class state. slidingContainer's expand
        // logic calls jQuery .show() on every tab button (writing an inline display), which would reveal tabs
        // that should stay hidden; re-running this after each show/hide and on the panel's expand event keeps
        // the intended state without needing display:none!important in the stylesheet. Only called while the
        // panel is expanded (never on collapse), so setting a shown tab's display doesn't fight the collapse.
        var syncRightPanelDynamicTabVisibility = function ()
        {
            // Re-assert the hidden state for every tab button carrying the hidden class (the dynamic browse tabs, plus
            // the Student Course List / Alternate Requests tabs when "Hide Course Requests" is on). Buttons without the
            // class get display "" so they render normally.
            $(rightTabCourseRequestContainerID).find(".tabStrip .tabButton").each(function ()
            {
                var tabButton = $(this);
                tabButton.css("display", tabButton.hasClass(rightPanelDynamicTabHiddenClass) ? "none" : "");
            });
        };

        var activateRightPanelTab = function (index)
        {
            // Set the current tab/contents directly (the tabContainer script may not have bound its click handler
            // yet during initial load, so we don't rely on triggering a click) then fire tabClicked so pagestate
            // persists the selected index. These containers use the deprecated "current" class for the active tab.
            var container = $(rightTabCourseRequestContainerID);
            var tabButtons = container.find(".tabStrip .tabButton");
            var tabContents = container.find(".tabContents");
            tabButtons.removeClass("current");
            tabContents.removeClass("current");
            tabButtons.eq(index).addClass("current");
            tabContents.eq(index).addClass("current");
            tabButtons.eq(index).trigger("tabClicked");
        };

        var expandRightPanelIfCollapsed = function ()
        {
            if ($(rightTabCourseRequestContainerID).hasClass("collapsed"))
            {
                $(rightPanelToggleButtonID).click();
            }
        };

        var wireRightPanelDynamicTabs = function ()
        {
            var dynamicTabIndexes = [rightPanelTabIndex.addByCourse, rightPanelTabIndex.addBySections, rightPanelTabIndex.sections];
            for (var i = 0; i < dynamicTabIndexes.length; i++)
            {
                rightPanelTabButton(dynamicTabIndexes[i]).off("tabClicked", rightPanelDynamicTabClicked).on("tabClicked", rightPanelDynamicTabClicked);
            }

            // slidingContainer .show()s all tab buttons when the panel expands; re-assert the hidden tabs right
            // after (expandEvent fires synchronously following that .show(), so there is no visible flicker).
            $(rightTabCourseRequestContainerID).off("expandEvent", syncRightPanelDynamicTabVisibility).on("expandEvent", syncRightPanelDynamicTabVisibility);
        };

        var rightPanelDynamicTabClicked = function ()
        {
            expandRightPanelIfCollapsed();
            var contents = $(rightTabCourseRequestContainerID).find(".tabContents").eq($(this).data("index"));
            var browse = skyward.browse.getInnerBrowse(contents);
            if (browse !== undefined && browse.seek !== undefined)
            {
                browse.seek.focus();
            }
        };

        // Loads the Add By Course + Add By Sections browses into their right-panel tabs (the "View Course List"
        // action, when the course list is on the right). Mirrors the lazy load loadCourseTabContainer does for the
        // bottom panels, but eagerly loads both since there is no per-tab expand event to trigger them here.
        var showRightPanelCourseTabs = function (firstTitle, secondTitle)
        {
            hideRightPanelDynamicTabs();

            var courseData = {
                studentid: studentScheduleViewPart.data('studentid'),
                studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                coursecontainer: availableCoursesBrowseView,
                effectivedate: studentScheduleViewPart.data("effectivedate")
            };
            $("#" + availableCoursesBrowseView).data("browseLoaded", "");
            skyward.window.loadContent(availableCoursesBrowseView, 'Scheduling', 'StudentSchedule', 'Get' + availableCoursesBrowse, null, courseData, null, null, null, true);

            var sectionsData = {
                studentid: studentScheduleViewPart.data('studentid'),
                studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                coursecontainer: availableSectionsByOpenSectionsBrowseView,
                effectivedate: studentScheduleViewPart.data("effectivedate")
            };
            $("#" + availableSectionsByOpenSectionsBrowseView).data("browseLoaded", "");
            skyward.window.loadContent(availableSectionsByOpenSectionsBrowseView, 'Scheduling', 'StudentSchedule', 'Get' + availableSectionsByOpenSectionsBrowse, null, sectionsData, null, null, null, true);

            showRightPanelTab(rightPanelTabIndex.addByCourse, firstTitle);
            showRightPanelTab(rightPanelTabIndex.addBySections, secondTitle);
            expandRightPanelIfCollapsed();
            activateRightPanelTab(rightPanelTabIndex.addByCourse);
        };

        var togglePanelToDisplay = function (panelToDisplay)
        {
            var bottomTabContainers = new Array(bottomTabCourseContainer, bottomTabContainer);

            for (var i = 0; i < bottomTabContainers.length; i++)
            {
                var current = bottomTabContainers[i];
                if (panelToDisplay && panelToDisplay == current)
                {
                    current.removeClass("behind").addClass("front");
                    current.css('display', 'block');
                }
                else
                {
                    current.removeClass("front").addClass("behind");
                    current.css('display', 'none');
                }
            }
        };

        var collapseBottomPanels = function ()
        {
            var action = availableSectionsCancelButton.data("action");
            if (action == "AddByCourseShowSections")
            {
                availableSectionsCancelButton.data("action", "");
                bottomTabContainerSetDataProperties(false);
                skyward.matrix.updateAvailableCoursesPanel();
            }
            else
            {
                toggleCancelButton(false);
                bottomTabContainerSetDataProperties(false);
                bottomTabCourseContainerSetDataProperties(false, undefined, true);
                bottomTabCourseContainerCollapse();

                if (coursePanelOnRight)
                {
                    if (hideCourseRequests)
                    {
                        showRightPanelCourseTabs("Add By Course", "Add By Sections");
                    }
                    else
                    {
                        hideRightPanelDynamicTabs();
                        activateRightPanelTab(rightPanelTabIndex.courseList);
                        expandRightPanelIfCollapsed();
                    }
                }
                else if (bottomTabContainer.hasClass("collapsed"))
                {
                    bottomTabContainerCollapsed();
                }
            }
        };

        //JS Actions for Data Matrix Cards
        skyward.matrix.addEventListenerToDataMatrixCards = function ()
        {
            $('.matrixCell.dataMatrixCell').on("mouseover", toggleSelectStyle).on("mouseout", toggleSelectStyle);
        };

        var toggleSelectStyle = function (event)
        {
            var scheduledCardCell = $(this);

            //find all the cells of this section and highlight it
            $(".matrixCell.dataMatrixCell[data-studentsectionid=" + scheduledCardCell.data("studentsectionid") + "]").each(function ()
            {
                if (event.type == "mouseover")
                {
                    $(this).addClass('hover');
                }
                else
                {
                    $(this).removeClass('hover');
                }
            });
        };

        //JS Actions for Available Section Cards
        skyward.matrix.addEventListenerToAvailableSectionCards = function ()
        {
            $('.matrixCell.availableSection').on("mouseover", skyward.matrix.highlightMatchingSections).on("mouseout", skyward.matrix.highlightMatchingSections);
        };

        skyward.matrix.highlightMatchingSections = function (event)
        {
            var section = '[data-sectionid="' + $(this).data('sectionid') + '"]';
            if (event.type == "mouseover")
            {
                $(section).each(function ()
                {
                    $(this).addClass('hover');
                });
            }
            else
            {
                $(section).each(function ()
                {
                    $(this).removeClass('hover');
                });
            }
        };

        skyward.matrix.openClassSummaryPanel = function (event, action, data, source)
        {
            var promise = buildClassSummaryPanel(action, data);

            var getClassSummaryContent = function ()
            {
                var deferred = $.Deferred();

                $.when(promise).then(function (response)
                {
                    deferred.resolve(response.view);
                });

                return deferred.promise();
            };

            var getClassSummaryButtons = function ()
            {
                var deferred = $.Deferred();

                $.when(promise).then(function (response)
                {
                    if (studentScheduleViewPart.data("viewmode") === "Builder")
                    {
                        var effectiveDate = getEffectiveDate();
                        var selectedSection = $(studentScheduleViewPart).data("selectedStudentSection");
                        if (effectiveDate && selectedSection && selectedSection.studentsectionstartdate && selectedSection.studentsectionenddate)
                        {
                            var startDate = skyward.time.parseDate(selectedSection.studentsectionstartdate);
                            var endDate = skyward.time.parseDate(selectedSection.studentsectionenddate);
                            var isInProgress = effectiveDate >= startDate && effectiveDate <= endDate;
                            var daterangescounttowardsviewingentityValue = selectedSection.daterangescounttowardsviewingentity;

                            var isDroppable = false;
                            if (daterangescounttowardsviewingentityValue !== "")
                            {
                                $.each(daterangescounttowardsviewingentityValue, function (index, value)
                                {
                                    var range = value.replace("{", "").replace("}", "").split("->");
                                    var lowDate = skyward.time.parseDate(range[0]);
                                    var highDate = skyward.time.parseDate(range[1]);

                                    if (isInProgress && effectiveDate >= lowDate && effectiveDate <= highDate)
                                    {
                                        isDroppable = true;
                                    }
                                });
                            }

                            var highestIndex = response.buttons.length - 1;

                            for (var idx = highestIndex; idx >= 0; idx--)
                            {
                                var button = response.buttons[idx];

                                if (button.id === "btnUnscheduleStudentSection" && selectedSection.requestedfromviewingentityandalltransactionscounttowardsviewingentity.toLowerCase() === "false")
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnReplaceStudentSection" && selectedSection.requestedfromofferingentityandalltransactionscounttowardsviewingentity.toLowerCase() === "false")
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnEditStudentSection" && selectedSection.countsforviewingentity.toLowerCase() === "false")
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnDropStudentSection" && !isDroppable)
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnDeleteStudentSection" && selectedSection.alltransactionscounttowardsviewingentity.toLowerCase() === "false")
                                {
                                    response.buttons.splice(idx, 1);
                                }

                                if (button.id === "btnChangeStudentSection" && (effectiveDate > endDate || selectedSection.hasatleastonetransactionnotcounttowardsviewingentity.toLowerCase() === "true"))
                                {
                                    response.buttons.splice(idx, 1);
                                }
                            }
                        }
                    }

                    deferred.resolve(response.buttons);
                });

                return deferred.promise();
            };

            var options =
            {
                draggable: "true",
                width: 890,
                id: "classSummaryModal"
            };

            var getClassAndDescription = function ()
            {
                if ($(studentScheduleViewPart) !== null)
                {
                    if ($(studentScheduleViewPart).data("isscheduleblocker") !== undefined && $(studentScheduleViewPart).data("isscheduleblocker").toLowerCase() === "true")
                    {
                        return "Schedule Blocker Details";
                    }
                    else if (action.indexOf("GetStudentSectionClassSummaryPanel") !== -1 && $(studentScheduleViewPart).data("selectedStudentSection") !== null)
                    {   // Builder, Matrix, etc
                        if ($(studentScheduleViewPart).data("selectedStudentSection").courseDescription !== null)
                        {
                            return $(studentScheduleViewPart).data("selectedStudentSection").courseDescription
                                + ($(studentScheduleViewPart).data("selectedStudentSection").courseCode !== null ? " (" + $(studentScheduleViewPart).data("selectedStudentSection").courseCode + ")" : "")
                                + ($(studentScheduleViewPart).data("selectedStudentSection").sectionCode !== null ? " / " + $(studentScheduleViewPart).data("selectedStudentSection").sectionCode : "");
                        }
                    }
                    else if ($(studentScheduleViewPart).data("availablesectioncourseinfo") !== null)
                    {
                        if ($(studentScheduleViewPart).data("availablesectioncourseinfo").courseDescription !== null)
                        {
                            return $(studentScheduleViewPart).data("availablesectioncourseinfo").courseDescription
                                + ($(studentScheduleViewPart).data("availablesectioncourseinfo").courseCode !== null ? " (" + $(studentScheduleViewPart).data("availablesectioncourseinfo").courseCode + ")" : "")
                                + ($(studentScheduleViewPart).data("availablesectioncourseinfo").sectionCode !== null ? " / " + $(studentScheduleViewPart).data("availablesectioncourseinfo").sectionCode : "");
                        }
                    }
                }

                return undefined;
            };

            var classAndDescription = getClassAndDescription();

            if (source?.length)
            {
                source.attr("aria-expanded", "true");
                options.afterClose = function ()
                {
                    source.attr("aria-expanded", "false");
                };
            }

            skyward.modalLayer.showDialog(classAndDescription === undefined ? "Class Summary" : classAndDescription, getClassSummaryContent, getClassSummaryButtons, options);
        };

        var buildClassSummaryPanel = function (action, data)
        {
            return $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/" + action + "?renderType=contentOnly",
                type: "POST",
                dataType: "JSON",
                data: data
            });
        };

        skyward.matrix.openStudentSectionClassSummaryPanel = function (event)
        {
            // First try to find the nearest Student Schedule, in case there's more than one on screen from a popup or something
            var innerStudentScheduleViewPart = $(event.target).closest(".studentScheduleMatrix");

            // Didn't find anything, fall back to the global Student Schedule variable
            if (innerStudentScheduleViewPart.length === 0)
            {
                innerStudentScheduleViewPart = studentScheduleViewPart;
            }

            //close the actions menu
            if (innerStudentScheduleViewPart.parent().attr('id') != null &&
                innerStudentScheduleViewPart.parent().attr('id').toLowerCase() != 'studentinformationpopuptabpanel' &&
                innerStudentScheduleViewPart.parent().attr('id').toLowerCase().indexOf("studentinformationpopuptabcontainer") === -1)
            {
                skyward.window.closePopup();
            }

            var rawData = innerStudentScheduleViewPart.data();
            // copy data from innerStudentScheduleViewPart, skipping Objects and Arrays
            var data = Object.keys(rawData).reduce(function (result, key)
            {
                if (typeof (rawData[key]) !== "object")
                {
                    result[key] = rawData[key];
                }
                return result;
            }, {});
            // This key is specified manually since the data-attribute does not match what the server is expecting
            data["studentsectiontransaction"] = rawData["studentsectiontransactionid"];

            var viewmode = innerStudentScheduleViewPart.data("viewmode");
            var accessMode = innerStudentScheduleViewPart.parents(".studentInformationPopupTabPanel").find("[id$='accessmode']").val() || $("[id$='accessmode']").val();

            if (accessMode == "StudentAccess")
            {
                viewmode = "StudentAccess";
            }

            if (viewmode == "StudentInformationPopup")
            {
                viewmode = viewmode + accessMode;
            }

            skyward.matrix.openClassSummaryPanel(event, 'GetStudentSectionClassSummaryPanel' + viewmode, data);

            selectStudentCourseListRow(innerStudentScheduleViewPart.data("studentcourserequestid"), innerStudentScheduleViewPart.data("studentsectionid"));
            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        function openStudentSectionClassSummaryPanelFromCard(event)
        {
            // Arena Scheduling drop button on matrix was clicked, stop and let that event fire instead
            if (event.target.className && event.target.className.indexOf && event.target.className.indexOf("js-arenaScheduling-drop") > -1)
            {
                return;
            }

            var selectedStudentSection = setSelectedStudentSectionInfo(event);
            if (selectedStudentSection)
            {
                setStudentSectionInfo();
                skyward.matrix.openStudentSectionClassSummaryPanel(event);
            }
        }

        skyward.matrix.openStudentSectionClassSummaryPanelFromActionsMenu = function (event)
        {
            setStudentSectionInfo();
            skyward.matrix.openStudentSectionClassSummaryPanel(event);
        };

        skyward.matrix.openStudentSectionClassSummaryPanelFromProfilePopupGrades = function (event)
        {
            var source = $(event.target).closest('a');

            var data = {
                studentid: source.data("studentid"),
                studentid_securityhash: source.data("studentid_securityhash"),
                studentsectionid: source.data("studentsectionid"),
                studentsectiontransaction: source.data("studentsectiontransactionid"),
                studentsectiontransactionid_securityhash: source.data("studentsectiontransactionid_securityhash"),
                ViewMode: source.data("viewmode")
            };

            skyward.matrix.openClassSummaryPanel(event, 'GetStudentSectionClassSummaryPanel' + source.data("viewmode"), data, source);

            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        var getStudentCourseRequestRowIndex = function (studentCourseRequestID)
        {
            var courseListRowIndex = -1;

            if (studentCourseRequestID != null && !isNaN(studentCourseRequestID) && studentCourseRequestID != 0 &&
                studentScheduleViewPart.data("viewmode") && studentScheduleViewPart.data("viewmode") == "Builder" &&
                getBrowseByName(studentCourseRequestBrowse))
            {
                courseListRowIndex = getBrowseByName(studentCourseRequestBrowse).rowData.findIndex(row => row['StudentCourseRequestID'] === studentCourseRequestID.toString());
            }

            return courseListRowIndex;
        };

        var selectStudentCourseListRow = function (courseRequestID, studentSectionID)
        {
            var courseListRowIndex = getStudentCourseRequestRowIndex(courseRequestID);

            if (courseListRowIndex != -1)
            {
                var lockedRow = skyward.browse.getCurrentRowElement("locked", studentCourseRequestBrowse, courseListRowIndex);

                if (!lockedRow.hasClass("current"))
                {
                    skyward.browse.setCurrentRecord(studentCourseRequestBrowse, courseListRowIndex);
                }
            }

            deSelectSelectedCards();
            var browse = getBrowseByName(studentCourseRequestBrowse);
            if (courseListRowIndex !== -1 && (!studentSectionID || isNaN(studentSectionID)) && browse)
            {
                studentSectionID = browse.rowData[courseListRowIndex]['StudentSectionID'];
            }

            if (studentSectionID && !isNaN(studentSectionID))
            {
                selectedCards(studentSectionID);
            }
        };

        skyward.matrix.openSectionClassSummaryPanel = function (event, sectionID, changeSection)
        {
            setAvailableSectionInfo(event);

            var data = {
                StudentID: studentScheduleViewPart.data("studentid"),
                studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                SectionID: sectionID,
                sectionid_securityhash: studentScheduleViewPart.data("availablesectionsectionid_securityhash"),
                ViewMode: studentScheduleViewPart.data("viewmode"),
                ChangeSection: changeSection,
                entityID: studentScheduleViewPart.data("entityid"),
                entityid_securityhash: studentScheduleViewPart.data('entityid_securityhash'),
                countsforviewingentity: studentScheduleViewPart.data('countsforviewingentity'),
                hasatleastonetransactionnotcounttowardsviewingentity: studentScheduleViewPart.data('hasatleastonetransactionnotcounttowardsviewingentity'),
                alltransactionscounttowardsviewingentity: studentScheduleViewPart.data('alltransactionscounttowardsviewingentity'),
                requestedfromofferingentityandalltransactionscounttowardsviewingentity: studentScheduleViewPart.data('requestedfromofferingentityandalltransactionscounttowardsviewingentity'),
                requestedfromviewingentityandalltransactionscounttowardsviewingentity: studentScheduleViewPart.data('requestedfromviewingentityandalltransactionscounttowardsviewingentity'),
                daterangescounttowardsviewingentity: studentScheduleViewPart.data('daterangescounttowardsviewingentity')
            };

            skyward.matrix.openClassSummaryPanel(event, 'GetSectionClassSummaryPanel', data);
        };

        var isTrueValue = function (value)
        {
            return value.toLowerCase() === "true";
        };

        var updateActionMenuButtonDisplay = function (button, display)
        {
            if (display)
            {
                button.css({ display: "" });
            }
            else
            {
                button.css({ display: "none" });
            }
        };

        function openActionsPanel(event)
        {
            if (actionsMenu && actionsMenu.length)
            {
                if (actionsMenu.hasClass("hide"))
                {
                    deSelectSelectedCards();

                    var selectedStudentSection = setSelectedStudentSectionInfo(event);

                    var effectiveDate = getEffectiveDate();
                    var startDate = skyward.time.parseDate($(event.currentTarget).data('startdate'));
                    var endDate = skyward.time.parseDate($(event.currentTarget).data('enddate'));
                    var isInProgress = effectiveDate >= startDate && effectiveDate <= endDate;
                    var isBeforeOrIsInProgress = effectiveDate <= endDate;

                    var countsForViewingEntity = isTrueValue($(event.currentTarget).data('countsforviewingentity'));
                    var hasAtleastOneTransactionNotCountTowardsViewingEntity = isTrueValue($(event.currentTarget).data('hasatleastonetransactionnotcounttowardsviewingentity'));
                    var allTransactionsCountTowardsViewingEntity = isTrueValue($(event.currentTarget).data('alltransactionscounttowardsviewingentity'));
                    var requestedFromOfferingEntityAndAlltransactionsCountTowardsViewingEntity = isTrueValue($(event.currentTarget).data('requestedfromofferingentityandalltransactionscounttowardsviewingentity'));
                    var daterangescounttowardsviewingentityValue = $(event.currentTarget).data('daterangescounttowardsviewingentity');
                    var requestedfromviewingentityandalltransactionscounttowardsviewingentity = isTrueValue($(event.currentTarget).data('requestedfromviewingentityandalltransactionscounttowardsviewingentity'));

                    var isDroppable = false;
                    if (daterangescounttowardsviewingentityValue !== "")
                    {
                        $.each(daterangescounttowardsviewingentityValue, function (index, value)
                        {
                            var range = value.replace("{", "").replace("}", "").split("->");
                            var lowDate = skyward.time.parseDate(range[0]);
                            var highDate = skyward.time.parseDate(range[1]);

                            if (isInProgress && effectiveDate >= lowDate && effectiveDate <= highDate)
                            {
                                isDroppable = true;
                            }
                        });
                    }

                    updateActionMenuButtonDisplay(actionsMenuEditButton, countsForViewingEntity);

                    actionsMenuChangeButton.css({ display: (isBeforeOrIsInProgress && !hasAtleastOneTransactionNotCountTowardsViewingEntity) ? "" : "none" });
                    actionsMenuDeleteButton.css({ display: allTransactionsCountTowardsViewingEntity ? "" : "none" });
                    actionsMenuDropButton.css({ display: isDroppable ? "" : "none" });
                    actionsMenuEditButton.css({ display: countsForViewingEntity ? "" : "none" });
                    actionsMenuReplaceButton.css({ display: requestedFromOfferingEntityAndAlltransactionsCountTowardsViewingEntity ? "" : "none" });
                    actionsMenuUnscheduleButton.css({ display: requestedfromviewingentityandalltransactionscounttowardsviewingentity ? "" : "none" });

                    //need an element to be visible to get the height, so temp solution is to show the element behind the elements first
                    actionsMenu.css({ zIndex: -1 }).removeClass("hide").addClass("show");

                    var closeFunction = function ()
                    {
                        actionsMenu.addClass("hide").removeClass("show").css({ zIndex: -1 });
                    };

                    var options =
                    {
                        transparent: true,
                        beforeClose: closeFunction
                    };
                    selectStudentCourseListRow(selectedStudentSection.studentcourserequestid, selectedStudentSection.studentsectionid);
                    skyward.matrix.positionPopup(selectedStudentSection.cellid, actionsMenu, options);
                    event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
                }
            }
        }

        skyward.matrix.unscheduleStudentSectionFromBrowseMenu = function ()
        {
            var browseData = $(this).data();
            var studentSectionID = browseData.studentsectionid;
            var studentSectionID_securityhash = browseData.studentsectionid_securityhash;

            var data =
            {
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionID_securityhash
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/UnscheduleStudentSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.unscheduleStudentSection = function ()
        {
            setStudentSectionInfo();
            var studentSectionID = studentScheduleViewPart.data("studentsectionid");

            var data =
            {
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentScheduleViewPart.data("studentsectionid_securityhash")
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/UnscheduleStudentSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.callIndividualStudentSchedulerFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualStudentScheduler", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.callIndividualStudyHallSchedulerFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualStudyHallScheduler", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.callReactivateStudentScheduleFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/ReactivateStudentSchedule", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.callReactivateStudentScheduleFromScheduleRequests = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/ReactivateStudentSchedule", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.callMassDeleteCourseRequests = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash")
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/MassDeleteCourseRequests", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.callIndividualStudentSchedulerFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualStudentScheduler", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.callIndividualStudyHallSchedulerFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualStudyHallScheduler", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.callReactivateStudentScheduleFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/ReactivateStudentSchedule", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.IndividualAddBySchedulingGroupFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var data =
            {
                "Workflow.entityid": button.data("entityid"),
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": button.data("schoolyearid"),
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": button.data("studentid"),
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualAddBySchedulingGroup", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.IndividualAddBySchedulingGroupFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var data =
            {
                "Workflow.entityid": button.data("entityid"),
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": button.data("schoolyearid"),
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": button.data("studentid"),
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualAddBySchedulingGroup", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.IndividualMassDropOrDeleteStudentScheduleFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualMassDropOrDeleteStudentSchedule", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };


        skyward.matrix.IndividualAddBySchedulingGroupFromScheduleRequests = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualAddBySchedulingGroup", null, data, null, skyward.matrix.updateStudentCourseRequests);
        };
        skyward.matrix.IndividualMassDropOrDeleteStudentScheduleFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualMassDropOrDeleteStudentSchedule", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.IndividualMassUnscheduleStudentSectionsFromScheduleList = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualMassUnscheduleStudentSections", null, data, null, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.IndividualMassUnscheduleStudentSectionsFromScheduleBuilder = function (event)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSchedule/IndividualMassUnscheduleStudentSections", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        var runArenaConvertToRealRecordsIndividual = function (event, onComplete)
        {
            var button = $(event.currentTarget);

            var entityID = button.data("entityid");
            var schoolYearID = button.data("schoolyearid");
            var studentID = button.data("studentid");

            var data =
            {
                "Workflow.entityid": entityID,
                "Workflow.entityid_securityhash": button.data("entityid_securityhash"),
                "Workflow.schoolyearid": schoolYearID,
                "Workflow.schoolyearid_securityhash": button.data("schoolyearid_securityhash"),
                "Workflow.studentid": studentID,
                "Workflow.studentid_securityhash": button.data("studentid_securityhash"),
            };

            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/PendingStudentSection/ConvertToRealRecordsIndividual", null, data, null, onComplete);
        };

        skyward.matrix.ArenaConvertToRealRecordsIndividualFromScheduleList = function (event)
        {
            runArenaConvertToRealRecordsIndividual(event, skyward.matrix.updateScheduleListAllBrowses);
        };

        skyward.matrix.ArenaConvertToRealRecordsIndividualFromScheduleBuilder = function (event)
        {
            runArenaConvertToRealRecordsIndividual(event, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.deleteStudentSection = function ()
        {
            var source = $(this);
            var studentSectionID = source.data("studentsectionid");
            var studentSectionID_securityhash = source.data("studentsectionid_securityhash");

            if (studentSectionID == undefined)
            {
                setStudentSectionInfo();
                studentSectionID = studentScheduleViewPart.data("studentsectionid");
                studentSectionID_securityhash = studentScheduleViewPart.data("studentsectionid_securityhash");
            }

            var data =
            {
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionID_securityhash,
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash')
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/DeleteStudentSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.deleteCourseRequestFromBrowseMenu = function ()
        {
            var data = $(this).data();
            var studentCourseRequestID = data.studentcourserequestid;

            var browseData =
            {
                "Workflow.studentcourserequestid": studentCourseRequestID,
                "Workflow.studentcourserequestid_securityhash": data.studentcourserequestid_securityhash
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/DeleteStudentCourseRequest", null, browseData, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.positionPopup = function (offSetID, element, options)
        {
            var offsetElement = $('#' + offSetID);
            var buttons = BuildActionMenuButtons(element);
            skyward.modalLayer.showMenu(buttons, offsetElement, options);
        };

        var BuildActionMenuButtons = function (element, title = null)
        {
            var buttons = [];
            var resolvedTitle = title ?? element.attr("title") ?? "Student Schedule Actions";

            buttons.push({ type: "title", text: resolvedTitle.toString() });

            element.find('a').each(function ()
            {
                var renderedButton = $(this);
                var svgElement = renderedButton.find('svg');

                var buttonObj =
                {
                    id: renderedButton.attr('id'),
                    click: renderedButton.attr('onclick'),
                    text: renderedButton.text(),
                    icon: svgElement.length > 0 ? svgElement : renderedButton.data('icon'),
                    attributes: {}
                };

                // Copy all data-* attributes so onclick handlers can access them
                $.each(renderedButton[0].attributes, function (i, attr)
                {
                    if (attr.name.startsWith('data-') && attr.name !== 'data-icon')
                    {
                        buttonObj.attributes[attr.name] = attr.value;
                    }
                });

                if (renderedButton.css('display') != 'none')
                {
                    buttons.push(buttonObj);
                }
            });
            return buttons;
        };

        var deSelectSelectedCards = function ()
        {
            var isBuilder = (studentScheduleViewPart.data("viewmode") == "Builder");
            var activeStudentCourseRequestID;

            if (isBuilder)
            {
                activeStudentCourseRequestID = studentScheduleViewPart.data("activeStudentSectionOrRequest")["studentSectionID"];
            }

            if (previouslySelectStudentSectionID != "" && (!isBuilder || (activeStudentCourseRequestID != previouslySelectStudentSectionID)))
            {
                $("div[data-studentsectionid = " + previouslySelectStudentSectionID + "]").removeClass("selected");
                previouslySelectStudentSectionID = "";

                matrixBodyClickAdded = false;
                $("body").off("click", skywardMatrixBodyClick);
            }
        };

        var selectedCards = function (studentSectionID)
        {
            if (studentSectionID && studentSectionID != "")
            {
                var isBuilder = (studentScheduleViewPart.data("viewmode") == "Builder");
                var activeStudentCourseRequestID;

                if (isBuilder)
                {
                    activeStudentCourseRequestID = studentScheduleViewPart.data("activeStudentSectionOrRequest")["studentSectionID"];
                }

                var cellClass = "selected";
                if (isBuilder && activeStudentCourseRequestID != "" && activeStudentCourseRequestID == studentSectionID)
                {
                    cellClass += " active";
                }

                $("div.dataMatrixCell[data-studentsectionid =" + studentSectionID + "], div.dataMatrixCell[data-studentsectionid =" + studentSectionID + "] .matrixCellText").each(function ()
                {
                    $(this).addClass(cellClass);
                });

                previouslySelectStudentSectionID = studentSectionID;

                if (cellClass.indexOf("active") == -1 && !matrixBodyClickAdded)
                {
                    $("body").on("click", skywardMatrixBodyClick);
                    matrixBodyClickAdded = true;
                }
            }
        };

        var skywardMatrixBodyClick = function (event)
        {
            var runDeSelectSelectedCards = true;

            //There are two clicks - row click & body click
            if (preventDeselectTargetClick)
            {
                preventDeselectBodyClick = true;
                preventDeselectTargetClick = false;
            }

            var eventTarget = $(event.target);
            var eventTargetID = eventTarget.attr("id");

            //When clicking on the More Menu options on the Course List and clicking away (closing the glass) without actually selecting an item on the menu, want the selected cards to remain highlighted
            if (eventTargetID != undefined && eventTargetID.toLowerCase().indexOf(studentCourseRequestBrowse.toLowerCase() + "_rowmenu") != -1)
            {
                preventDeselectTargetClick = true;
            }
            else
            {
                eventTarget.parents("div .button").each(function ()
                {
                    if (this.id.toLowerCase().indexOf(studentCourseRequestBrowse.toLowerCase() + "_rowmenu") != -1)
                    {
                        preventDeselectTargetClick = true;
                    }
                });
            }

            //When clicking on the row of the Student Course List, the click event will bubble to the body click event, which will try to undo the selected cards, prevent this from happening
            eventTarget.parents("tr").each(function ()
            {
                if (this.id.toLowerCase().indexOf(studentCourseRequestBrowse.toLowerCase() + "_") != -1)
                {
                    runDeSelectSelectedCards = false;
                }
            });

            //When a glass is present, don't deselect the selected cards
            if ($("div.modalLayerContainer:last").length > 0 && !$('#studentInformationPopupTabPanel').length > 0)
            {
                runDeSelectSelectedCards = false;
            }

            if (preventDeselectBodyClick)
            {
                preventDeselectBodyClick = false;
                runDeSelectSelectedCards = false;
            }

            if (runDeSelectSelectedCards && previouslySelectStudentSectionID != "")
            {
                deSelectSelectedCards();
            }
        };

        skyward.matrix.updateAvailableSectionsFromChangeSection = function ()
        {
            setStudentSectionInfo();
            activateSelectedRow(studentCourseRequestBrowse, studentScheduleViewPart.data("studentcourserequestid"), studentScheduleViewPart.data("studentsectionid"));
            skyward.matrix.updateBottomTabContainerFromCourse(
                "ChangeSection",
                studentScheduleViewPart.data("courseid"),
                getCourseInfo("courseCode"),
                getCourseInfo("courseDescription"),
                studentScheduleViewPart.data("studentcourserequestid"),
                studentScheduleViewPart.data("sectionid"),
                true);
        };

        skyward.matrix.updateAvailableSectionsFromReplaceSection = function ()
        {
            setStudentSectionInfo();
            activateSelectedRow(studentCourseRequestBrowse, studentScheduleViewPart.data("studentcourserequestid"), studentScheduleViewPart.data("studentsectionid"));
            skyward.matrix.updateBottomTabContainerFromReplace(
                "ReplaceSection",
                studentScheduleViewPart.data("courseid"),
                studentScheduleViewPart.data("courseid_securityhash"),
                getCourseInfo("courseCode"),
                getCourseInfo("sectionCode"),
                getCourseInfo("courseDescription"),
                studentScheduleViewPart.data("studentcourserequestid"),
                studentScheduleViewPart.data("sectionid"),
                studentScheduleViewPart.data("studentsectionid"),
                studentScheduleViewPart.data("studentsectionid_securityhash"),
                true);
        };

        var getCourseInfo = function (infoToGet)
        {
            return findCourseInfo(infoToGet, "courseinfo");
        };

        var findCourseInfo = function (infoToGet, dataName)
        {
            var courseinfo = studentScheduleViewPart.data(dataName);

            switch (infoToGet)
            {
                case "courseCode":
                    if (courseinfo.courseCode)
                    {
                        return courseinfo.courseCode;
                    }
                    break;
                case "courseDescription":
                    if (courseinfo.courseDescription)
                    {
                        return courseinfo.courseDescription;
                    }
                    break;
                case "sectionCode":
                    if (courseinfo.sectionCode)
                    {
                        return courseinfo.sectionCode;
                    }
                    break;
                case "courseCodeDescriptionAndSection":
                    if (courseinfo.courseCode && courseinfo.courseDescription)
                    {
                        var courseCodeDescriptionAndSection = courseinfo.courseCode;
                        if (courseinfo.sectionCode && courseinfo.sectionCode != "")
                        {
                            courseCodeDescriptionAndSection += "/" + courseinfo.sectionCode;
                        }
                        courseCodeDescriptionAndSection += " - " + courseinfo.courseDescription;
                        return courseCodeDescriptionAndSection;
                    }
                    break;
                case "sectionOfCourseCodeDescription":
                    if (courseinfo.courseCode && courseinfo.courseDescription && courseinfo.sectionCode)
                    {
                        var sectionOfCourseCodeDescription = courseinfo.sectionCode + " of " + courseinfo.courseCode + " - " + courseinfo.courseDescription;
                        return sectionOfCourseCodeDescription;
                    }
                    break;
            }

            return "";
        };

        skyward.matrix.changeStudentSectionFromClassSummary = function ()
        {
            skyward.matrix.changeStudentSection(true);
        };

        skyward.matrix.changeStudentSectionFromChangeLink = function (event)
        {
            setAvailableSectionInfo(event);
            skyward.matrix.changeStudentSection(false);
            event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
        };

        skyward.matrix.changeStudentSectionFromBrowseMenu = function ()
        {
            var data = $(this).data();
            var sectionID = data.sectionid;
            var sectionID_securityhash = data.studentsectionsectionid_securityhash;
            var startDate = data.startdate;
            var endDate = data.enddate;

            var sectionBrowseName = "";
            if (getBrowseByName("AvailableSectionsByChangeSectionsBrowse"))
            {
                sectionBrowseName = 'AvailableSectionsByChangeSectionsBrowse';
            }

            setAvailableSectionInfoFromBrowseMenu(sectionID, sectionID_securityhash, startDate, endDate, sectionBrowseName);
            skyward.matrix.changeStudentSection(true);
        };

        skyward.matrix.changeStudentSection = function (closePopup)
        {
            var newSectionID = studentScheduleViewPart.data("availablesectionsectionid");
            var newStudentSectionSectionIDSecurityHash = studentScheduleViewPart.data("availablesectionstudentsectionsectionid_securityhash");

            studentScheduleViewPart.data("selectedStudentSection", studentScheduleViewPart.data("activeStudentSectionCard"));
            setStudentSectionInfo();

            var data =
            {
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                "Workflow.StudentSectionID": studentScheduleViewPart.data("studentsectionid"),
                "Workflow.studentsectionid_securityhash": studentScheduleViewPart.data("studentsectionid_securityhash"),
                "Workflow.EffectiveDateParam": studentScheduleViewPart.data("effectivedate"),
                "Workflow.studentsection.sectionid": newSectionID,
                "Workflow.studentsection.sectionid_securityhash": newStudentSectionSectionIDSecurityHash
            };
            if (closePopup)
            {
                skyward.window.closePopup();
            }
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/ChangeSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.changeStudentSectionFromScheduleListBrowseMenu = function ()
        {
            var thisData = $(this).data();
            var data =
            {
                "Workflow.:pagestatemodifycontrol": thisData["workflow.:pagestatemodifycontrol"],
                "Workflow.:pagestatemodifycontrol_securityhash": thisData["workflow.:pagestatemodifycontrol_securityhash"],
                "Workflow.entityid": thisData["workflow.entityid"],
                "Workflow.entityid_securityhash": thisData["workflow.entityid_securityhash"],
                "Workflow.StudentSectionID": thisData["workflow.studentsectionid"],
                "Workflow.studentsectionid_securityhash": thisData["workflow.studentsectionid_securityhash"],
                "Workflow.EffectiveDateParam": thisData["workflow.effectivedateparam"],
                "Workflow.EffectiveDateParam_securityhash": thisData["workflow.effectivedateparam_securityhash"]
            };
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/ChangeSection", null, data, null, skyward.matrix.updateScheduleListPieces);
        };

        var toggleCancelButton = function (enable, action)
        {
            if (action == undefined)
            {
                action = "";
            }

            if (enable)
            {
                availableSectionsCancelButton.data("action", action);
                availableSectionsCancelButton.removeClass("hidden");
            }
            else
            {
                availableSectionsCancelButton.data("action", "");
                availableSectionsCancelButton.addClass("hidden");
            }
        };

        var cancelActions = function ()
        {
            if (availableSectionsCancelButton && !availableSectionsCancelButton.hasClass('hidden'))
            {
                deactivateSelectedRow(false);
                collapseBottomPanels();
                skyward.matrix.updateBoard();
            }
        };

        skyward.matrix.updateAvailableSectionsFromChangeSectionBrowseMenu = function ()
        {
            var data = $(this).data();
            var courseID = data.courseid;
            var courseCode = data.courseCode;
            var courseDescription = data.courseDescription;
            var studentSectionID = data.studentsectionid;
            var sectionCode = data.sectionCode;
            var studentCourseRequestID = data.studentcourserequestid;
            var sectionID = data.sectionid;

            var studentSectionInfo = findStudentSectionInfoForCourseRequest(studentCourseRequestID);

            studentScheduleViewPart.data("selectedStudentSection",
                {
                    studentsectionstartdate: studentSectionInfo.studentsectionstartdate,
                    studentsectionenddate: studentSectionInfo.studentsectionenddate,
                    studentsectionid: studentSectionID,
                    studentsectionid_securityhash: data.studentsectionid_securityhash,
                    courseid: courseID,
                    courseid_securityhash: data.courseid_securityhash,
                    courseCode: courseCode,
                    courseDescription: courseDescription,
                    sectionCode: sectionCode,
                    sectionid: sectionID,
                    sectionid_securityhash: data.sectionid_securityhash,
                    cellid: "",
                    studentsectiontransactionid: "",
                    studentcourserequestid: studentCourseRequestID
                });
            setStudentSectionInfo();

            activateSelectedRow(studentCourseRequestBrowse, studentScheduleViewPart.data("studentcourserequestid"), studentScheduleViewPart.data("studentsectionid"));
            skyward.matrix.updateBottomTabContainerFromCourse(
                "ChangeSection",
                studentScheduleViewPart.data("courseid"),
                getCourseInfo("courseCode"),
                getCourseInfo("courseDescription"),
                studentScheduleViewPart.data("studentcourserequestid"),
                studentScheduleViewPart.data("sectionid"),
                true);
        };

        skyward.matrix.updateAvailableSectionsFromReplaceSectionBrowseMenu = function ()
        {
            var data = $(this).data();
            var courseID = data.courseid;
            var courseCode = data.courseCode;
            var courseDescription = data.courseDescription;
            var studentSectionID = data.originalstudentsectionid;
            var sectionCode = data.sectionCode;
            var studentCourseRequestID = data.studentcourserequestid;
            var sectionID = data.sectionid;

            var studentSectionInfo = findStudentSectionInfoForCourseRequest(studentCourseRequestID);

            studentScheduleViewPart.data("selectedStudentSection",
                {
                    studentsectionstartdate: studentSectionInfo.studentsectionstartdate,
                    studentsectionenddate: studentSectionInfo.studentsectionenddate,
                    studentsectionid: studentSectionID,
                    studentsectionid_securityhash: data.studentsectionid_securityhash,
                    courseid: courseID,
                    courseid_securityhash: data.courseid_securityhash,
                    courseCode: courseCode,
                    courseDescription: courseDescription,
                    sectionCode: sectionCode,
                    sectionid: sectionID,
                    sectionid_securityhash: data.sectionid_securityhash,
                    cellid: "",
                    studentsectiontransactionid: "",
                    studentsectiontransactionid_securityhash: "",
                    studentcourserequestid: studentCourseRequestID,
                    studentcourserequestid_securityhash: data.studentcourserequestid_securityhash
                });
            setStudentSectionInfo();

            checkUserSecurity("replaceSectionFromBrowseMenu");
        };

        var replaceSectionFromBrowseMenu = function (permissions)
        {
            if (permissions.allowUpdate || permissions.allowDelete)
            {
                activateSelectedRow(studentCourseRequestBrowse, studentScheduleViewPart.data("studentcourserequestid"), studentScheduleViewPart.data("studentsectionid"));
                skyward.matrix.updateBottomTabContainerFromReplace(
                    "ReplaceSection",
                    studentScheduleViewPart.data("courseid"),
                    studentScheduleViewPart.data("courseid_securityhash"),
                    getCourseInfo("courseCode"),
                    getCourseInfo("sectionCode"),
                    getCourseInfo("courseDescription"),
                    studentScheduleViewPart.data("studentcourserequestid"),
                    studentScheduleViewPart.data("sectionid"),
                    studentScheduleViewPart.data("studentsectionid"),
                    studentScheduleViewPart.data("studentsectionid_securityhash"),
                    true);
            }
            else
            {
                skyward.modalLayer.showCriticalDialog("Forbidden Access", "You do not have correct permissions to perform this task.");
            }
        };

        var checkUserSecurity = function (action)
        {
            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/CheckUserSecurity",
                type: "POST",
                dataType: "JSON",
                data: {},
                success: function (data)
                {
                    if (data && !$.isEmptyObject(data))
                    {
                        var permissions =
                        {
                            allowRead: data.PermissionRead === 'true',
                            allowCreate: data.PermissionCreate === 'true',
                            allowUpdate: data.PermissionUpdate === 'true',
                            allowDelete: data.PermissionDelete === 'true'
                        };

                        if (action == "dropStudentSectionfromBrowseMenu")
                        {
                            dropStudentSectionfromBrowseMenu(permissions);
                        }
                        else if (action == "replaceSectionFromBrowseMenu")
                        {
                            replaceSectionFromBrowseMenu(permissions);
                        }
                    }
                },
                error: function ()
                {
                    skyward.modalLayer.showCriticalDialog("Error", "Unable to check user security. The action could not be completed.");
                    return false;
                }
            });
        };

        var setSelectedStudentSectionInfo = function (event)
        {
            var cellDiv = $(event.currentTarget);

            if (cellDiv)
            {
                studentScheduleViewPart.data("selectedStudentSection",
                    {
                        studentsectionstartdate: cellDiv.data("startdate"),
                        studentsectionenddate: cellDiv.data("enddate"),
                        calendarday: cellDiv.data("calendarday"),
                        studentsectionid: cellDiv.data("studentsectionid"),
                        studentsectionid_securityhash: cellDiv.data("studentsectionid_securityhash"),
                        courseid: cellDiv.data("courseid"),
                        courseid_securityhash: cellDiv.data("courseid_securityhash"),
                        courseCode: cellDiv.data("coursecode"),
                        courseDescription: cellDiv.data("coursedescription"),
                        sectionCode: cellDiv.data("sectioncode"),
                        sectionid: cellDiv.data("sectionid"),
                        sectionid_securityhash: cellDiv.data("sectionid_securityhash"),
                        cellid: cellDiv.data("cellid"),
                        studentsectiontransactionid: cellDiv.data("studentsectiontransactionid"),
                        studentsectiontransactionid_securityhash: cellDiv.data("studentsectiontransactionid_securityhash"),
                        studentcourserequestid: cellDiv.data("studentcourserequestid"),
                        studentcourserequestid_securityhash: cellDiv.data("studentcourserequestid_securityhash"),
                        meetid: cellDiv.data("meetid"),
                        meetid_securityhash: cellDiv.data("meetid_securityhash"),
                        displayperiodid: cellDiv.data("displayperiodid"),
                        displayperiodid_securityhash: cellDiv.data("displayperiodid_securityhash"),
                        isscheduleblocker: cellDiv.data("isscheduleblocker"),
                        countsforviewingentity: cellDiv.data("countsforviewingentity"),
                        hasatleastonetransactionnotcounttowardsviewingentity: cellDiv.data("hasatleastonetransactionnotcounttowardsviewingentity"),
                        alltransactionscounttowardsviewingentity: cellDiv.data("alltransactionscounttowardsviewingentity"),
                        requestedfromofferingentityandalltransactionscounttowardsviewingentity: cellDiv.data("requestedfromofferingentityandalltransactionscounttowardsviewingentity"),
                        requestedfromviewingentityandalltransactionscounttowardsviewingentity: cellDiv.data("requestedfromviewingentityandalltransactionscounttowardsviewingentity"),
                        daterangescounttowardsviewingentity: cellDiv.data("daterangescounttowardsviewingentity"),
                        scheduledtypecode: cellDiv.data("scheduledtypecode"), // Used by Arena Scheduling
                        scheduledtypecode_securityhash: cellDiv.data("scheduledtypecode_securityhash"), // Used by Arena Scheduling
                    });
            }
            else
            {
                studentScheduleViewPart.data("selectedStudentSection",
                    {
                        studentsectionstartdate: "",
                        studentsectionenddate: "",
                        calendarday: "",
                        studentsectionid: "",
                        studentsectionid_securityhash: "",
                        courseid: "",
                        courseid_securityhash: "",
                        courseCode: "",
                        courseDescription: "",
                        sectionCode: "",
                        sectionid: "",
                        sectionid_securityhash: "",
                        cellid: "",
                        studentsectiontransactionid: "",
                        studentsectiontransactionid_securityhash: "",
                        studentcourserequestid: "",
                        studentcourserequestid_securityhash: "",
                        meetid: "",
                        meetid_securityhash: "",
                        displayperiodid: "",
                        displayperiodid_securityhash: "",
                        isscheduleblocker: "false",
                        countsforviewingentity: "",
                        hasatleastonetransactionnotcounttowardsviewingentity: "",
                        alltransactionscounttowardsviewingentity: "",
                        requestedfromofferingentityandalltransactionscounttowardsviewingentity: "",
                        requestedfromviewingentityandalltransactionscounttowardsviewingentity: "",
                        daterangescounttowardsviewingentity: "",
                        scheduledtypecode: cellDiv.data(""),
                        scheduledtypecode_securityhash: cellDiv.data(""),
                    });
            }

            return studentScheduleViewPart.data("selectedStudentSection");
        };

        var setStudentSectionInfo = function ()
        {
            var selectedStudentSection = studentScheduleViewPart.data("selectedStudentSection");

            if (selectedStudentSection)
            {
                studentScheduleViewPart.data("studentsectionstartdate", selectedStudentSection.studentsectionstartdate);
                studentScheduleViewPart.data("studentsectionenddate", selectedStudentSection.studentsectionenddate);
                studentScheduleViewPart.data("calendarday", selectedStudentSection.calendarday);
                studentScheduleViewPart.data("studentsectionid", selectedStudentSection.studentsectionid);
                studentScheduleViewPart.data("studentsectionid_securityhash", selectedStudentSection.studentsectionid_securityhash);
                studentScheduleViewPart.data("courseid", selectedStudentSection.courseid);
                studentScheduleViewPart.data("courseid_securityhash", selectedStudentSection.courseid_securityhash);
                studentScheduleViewPart.data("courseinfo",
                    {
                        courseCode: selectedStudentSection.courseCode,
                        courseDescription: selectedStudentSection.courseDescription,
                        sectionCode: selectedStudentSection.sectionCode
                    }
                );
                studentScheduleViewPart.data("sectionid", selectedStudentSection.sectionid);
                studentScheduleViewPart.data("sectionid_securityhash", selectedStudentSection.sectionid_securityhash);
                studentScheduleViewPart.data("cellid", selectedStudentSection.cellid);
                studentScheduleViewPart.data("studentsectiontransactionid", selectedStudentSection.studentsectiontransactionid);
                studentScheduleViewPart.data("studentsectiontransactionid_securityhash", selectedStudentSection.studentsectiontransactionid_securityhash);
                studentScheduleViewPart.data("studentcourserequestid", selectedStudentSection.studentcourserequestid);
                studentScheduleViewPart.data("studentcourserequestid_securityhash", selectedStudentSection.studentcourserequestid_securityhash);
                studentScheduleViewPart.data("meetid", selectedStudentSection.meetid);
                studentScheduleViewPart.data("meetid_securityhash", selectedStudentSection.meetid_securityhash);
                studentScheduleViewPart.data("displayperiodid", selectedStudentSection.displayperiodid);
                studentScheduleViewPart.data("displayperiodid_securityhash", selectedStudentSection.displayperiodid_securityhash);
                studentScheduleViewPart.data("isscheduleblocker", selectedStudentSection.isscheduleblocker);
                studentScheduleViewPart.data("countsforviewingentity", selectedStudentSection.countsforviewingentity);
                studentScheduleViewPart.data("hasatleastonetransactionnotcounttowardsviewingentity", selectedStudentSection.hasatleastonetransactionnotcounttowardsviewingentity);
                studentScheduleViewPart.data("alltransactionscounttowardsviewingentity", selectedStudentSection.alltransactionscounttowardsviewingentity);
                studentScheduleViewPart.data("requestedfromofferingentityandalltransactionscounttowardsviewingentity", selectedStudentSection.requestedfromofferingentityandalltransactionscounttowardsviewingentity);
                studentScheduleViewPart.data("requestedfromviewingentityandalltransactionscounttowardsviewingentity", selectedStudentSection.requestedfromviewingentityandalltransactionscounttowardsviewingentity);
                studentScheduleViewPart.data("daterangescounttowardsviewingentity", selectedStudentSection.daterangescounttowardsviewingentity);
                studentScheduleViewPart.data("scheduledtypecode", selectedStudentSection.scheduledtypecode);
                studentScheduleViewPart.data("scheduledtypecode_securityhash", selectedStudentSection.scheduledtypecode_securityhash);
            }
        };

        var getBrowseByName = function (name)
        {
            var browse = skyward.browse.browseList[name];
            if (browse === undefined)
            {
                browse = skyward.browse.browseList["detailsPanel_" + name];
            }
            return browse;
        };

        var updateBrowseByName = function (name, data)
        {
            var browse = skyward.browse.get(name, data);
            if (browse === null)
            {
                browse = skyward.browse.get("detailsPanel_" + name, data);
            }
            return browse;
        };

        var findStudentSectionInfoForCourseRequest = function (studentCourseRequestID)
        {
            //in progress transaction or earliest min date and max date
            var effectiveDate = getEffectiveDate();
            var minStartDate = null;
            var maxStartDate = null;
            var startDate = null;
            var endDate = null;

            $("div.dataMatrixCell[data-studentcourserequestid =" + studentCourseRequestID + "]").each(function ()
            {
                var relatedCell = $(this);
                var cellStartDate = skyward.time.parseDate(relatedCell.data("startdate"));
                var cellEndDate = skyward.time.parseDate(relatedCell.data("enddate"));

                if (cellStartDate <= effectiveDate && cellEndDate >= effectiveDate)
                {
                    startDate = cellStartDate;
                    endDate = cellEndDate;
                }

                if (minStartDate == null)
                {
                    minStartDate = cellStartDate;
                }
                else if (cellStartDate < minStartDate)
                {
                    minStartDate = cellStartDate;
                }

                if (maxStartDate == null)
                {
                    maxStartDate = cellEndDate;
                }
                else if (cellEndDate > maxStartDate)
                {
                    maxStartDate = maxStartDate;
                }
            });

            if (startDate == null)
            {
                startDate = minStartDate;
            }

            if (endDate == null)
            {
                endDate = maxStartDate;
            }

            return { studentsectionstartdate: startDate, studentsectionenddate: endDate };
        };

        skyward.matrix.dropStudentSectionfromBrowseMenu = function ()
        {
            var studentCourseRequestID = $(this).data('studentcourserequestid');
            var studentSectionInfo = findStudentSectionInfoForCourseRequest(studentCourseRequestID);
            var courseListRowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

            if (courseListRowIndex != -1)
            {
                var rowData = getBrowseByName(studentCourseRequestBrowse).rowData;

                studentScheduleViewPart.data("selectedStudentSection",
                    {
                        studentsectionstartdate: studentSectionInfo.studentsectionstartdate,
                        studentsectionenddate: studentSectionInfo.studentsectionenddate,
                        studentsectionid: $(this).data('studentsectionid'),
                        studentsectionid_securityhash: $(this).data('studentsectionid_securityhash'),
                        courseid: "",
                        courseid_securityhash: "",
                        courseCode: rowData[courseListRowIndex]['StudentSection.Section.Course.CourseCode'],
                        courseDescription: rowData[courseListRowIndex]['StudentSection.Section.Course.Description'],
                        sectionCode: rowData[courseListRowIndex]['StudentSection.Section.Code'],
                        sectionid: "",
                        sectionid_securityhash: "",
                        cellid: "",
                        studentsectiontransactionid: "",
                        studentsectiontransactionid_securityhash: "",
                        studentcourserequestid: studentCourseRequestID,
                        studentcourserequestid_securityhash: $(this).data('studentcourserequestid_securityhash'),
                        countsforviewingentity: "",
                        hasatleastonetransactionnotcounttowardsviewingentity: "",
                        alltransactionscounttowardsviewingentity: "",
                        requestedfromofferingentityandalltransactionscounttowardsviewingentity: "",
                        requestedfromviewingentityandalltransactionscounttowardsviewingentity: "",
                        daterangescounttowardsviewingentity: "",
                        scheduledtypecode: "",
                        scheduledtypecode_securityhash: ""
                    });
                setStudentSectionInfo();

                checkUserSecurity("dropStudentSectionfromBrowseMenu");
            }
            else
            {
                skyward.modalLayer.showCriticalDialog("Forbidden Access", "You do not have correct permissions to perform this task.");
            }
        };

        var dropStudentSectionfromBrowseMenu = function (permissions)
        {
            if (permissions.allowUpdate)
            {
                skyward.matrix.dropStudentSectionWorkflow();
            }
            else
            {
                skyward.modalLayer.showCriticalDialog("Forbidden Access", "You do not have correct permissions to perform this task.");
            }
        };

        skyward.matrix.dropStudentSectionfromActionsMenu = function ()
        {
            setStudentSectionInfo();
            skyward.matrix.dropStudentSectionWorkflow();
        };

        skyward.matrix.dropStudentSectionWorkflow = function ()
        {
            if (validateStudentSectionTransactionEndDate("drop"))
            {
                var data =
                {
                    "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                    "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                    "Workflow.StudentSectionID": studentScheduleViewPart.data("studentsectionid"),
                    "Workflow.EffectiveDropDate": studentScheduleViewPart.data("effectivedate")
                };
                skyward.window.closePopup();
                skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Drop", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
            }
        };

        skyward.matrix.replaceStudentSectionWorkflow = function ()
        {
            var browseData = $(this).data();
            var originalStudentSectionID = browseData.studentsectionid;
            var proposedSectionID = browseData.sectionid;

            var data =
            {
                "Workflow.StudentSectionID": originalStudentSectionID,
                "Workflow.studentsectionid_securityhash": browseData.studentsectionid_securityhash,
                "Workflow.StudentSection.SectionID": proposedSectionID,
                "Workflow.studentsection.sectionid_securityhash": browseData.studentsectionsectionid_securityhash,
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash'),
                "Workflow.EffectiveDropDate": studentScheduleViewPart.data("effectivedate"),
                "Workflow.PageStateModifyControl": ""
            };
            skyward.window.closePopup();
            $(".workflowPopup").each(function ()
            {
                var workflowPopupLayer = skyward.modalLayer.getLayerFromElement($(this));
                if (workflowPopupLayer !== undefined)
                {
                    skyward.window.closePopup(workflowPopupLayer);
                }
            });
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/Replace", null, data, null, skyward.matrix.replaceStudentSectionWorkflowClosed);
        };

        skyward.matrix.replaceStudentSectionWorkflowClosed = function ()
        {
            skyward.matrix.reloadScheduleBuilderMatrixAndRequests();
            collapseBottomPanels();
        };

        skyward.matrix.editStudentSection = function ()
        {
            var studentSectionID = $(this).data("studentsectionid");
            var studentSectionIDHash = $(this).data("studentsectionid_securityhash");
            var studentSectionTransactionID = $(this).data("studentsectiontransactionid");
            var studentSectionTransactionIDHash = $(this).data("studentsectiontransactionid_securityhash");
            var effectiveDate = studentScheduleViewPart.data("effectivedate");

            if (studentSectionID == undefined)
            {
                setStudentSectionInfo();
                studentSectionID = studentScheduleViewPart.data("studentsectionid");
                studentSectionIDHash = studentScheduleViewPart.data("studentsectionid_securityhash");
                studentSectionTransactionID = studentScheduleViewPart.data("studentsectiontransactionid");
                studentSectionTransactionIDHash = studentScheduleViewPart.data("studentsectiontransactionid_securityhash");
            }

            var data =
            {
                "Workflow.studentsectionid": studentSectionID,
                "Workflow.studentsectionid_securityhash": studentSectionIDHash,
                "Workflow.studentsectiontransactionid": studentSectionTransactionID,
                "Workflow.studentsectiontransactionid_securityhash": studentSectionTransactionIDHash,
                "Workflow.effectivedate": effectiveDate,
                "Workflow.entityid": studentScheduleViewPart.data("entityid"),
                "Workflow.entityid_securityhash": studentScheduleViewPart.data('entityid_securityhash')
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentSection/EditStudentSection", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        var toggleAlternate = function ()
        {
            var studentCourseRequestID = $(this).data("studentcourserequestid");
            var studentCourseRequestIDHash = $(this).data("studentcourserequestid_securityhash");

            if (studentCourseRequestID == undefined)
            {
                setStudentSectionInfo();
                studentCourseRequestID = studentScheduleViewPart.data("studentcourserequestid");
                studentCourseRequestIDHash = studentScheduleViewPart.data("studentcourserequestid_securityhash");
            }

            var data =
            {
                "Workflow.StudentCourseRequestID": studentCourseRequestID,
                "Workflow.StudentCourseRequestID_securityhash": studentCourseRequestIDHash,
            };
            skyward.window.closePopup();
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Scheduling/StudentCourseRequest/ToggleAlternate", null, data, null, skyward.matrix.reloadScheduleBuilderMatrixAndRequests);
        };

        skyward.matrix.viewSchedule = function (event)
        {
            skyward.window.loadContent('full', 'Scheduling', 'StudentSchedule', 'StudentProfileViewStudentSchedule', studentScheduleViewPart.data('studentid'), getPrintData());
        };

        var getPrintData = function ()
        {
            var rawData = studentScheduleViewPart.data();
            // copy data from studentScheduleViewPart, skipping Objects and Arrays
            var data = Object.keys(rawData).reduce(function (result, key)
            {
                if (typeof (rawData[key]) !== "object")
                {
                    result[key] = rawData[key];
                }
                return result;
            }, {});
            return $.extend({
                // These keys must be specified explicitly since they differ from the data attribute name
                "lowdate": studentScheduleViewPart.data('startdate'),
                "highdate": studentScheduleViewPart.data('enddate')
            }, data);
        };

        skyward.matrix.printSchedule = function (event)
        {
            var url = skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/PrintScheduleMatrix" + studentScheduleViewPart.data("viewmode");
            skyward.printScreen.launchWorkflow(url, getPrintData());
        };

        var validateStudentSectionTransactionEndDate = function (action)
        {
            var startDate = skyward.time.parseDate(studentScheduleViewPart.data("studentsectionstartdate"));
            var endDate = skyward.time.parseDate(studentScheduleViewPart.data("studentsectionenddate"));
            var effectiveDate = getEffectiveDate();

            if (effectiveDate < startDate)
            {
                skyward.modalLayer.showCriticalDialog("Invalid Effective Date",
                    "The End Date for the Student Section to " + action + " must be on or after " +
                    (startDate.getMonth() + 1) + "/" + startDate.getDate() + "/" + startDate.getFullYear() + ".");
                return false;
            }
            else if (effectiveDate > endDate)
            {
                skyward.modalLayer.showCriticalDialog("Invalid Effective Date",
                    "The End Date for the Student Section to " + action + " must be on or before " +
                    (endDate.getMonth() + 1) + "/" + endDate.getDate() + "/" + endDate.getFullYear() + ".");
                return false;
            }

            return true;
        };

        var setActiveStudentSectionOrRequest = function (studentCourseRequestID, studentSectionID)
        {
            studentScheduleViewPart.data("activeStudentSectionCard", studentScheduleViewPart.data("selectedStudentSection"));
            studentScheduleViewPart.data("activeStudentSectionOrRequest", { studentSectionID: studentSectionID, studentCourseRequestID: studentCourseRequestID });
        };

        var activateSelectedRow = function (browseName, studentCourseRequestID, studentSectionID)
        {
            if (browseName == studentCourseRequestBrowse)
            {
                deactivateSelectedRow(true);
                setActiveStudentSectionOrRequest(studentCourseRequestID, studentSectionID);

                var browse = getBrowseByName(browseName);

                if (studentCourseRequestID != "")
                {
                    var activeRowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

                    if (activeRowIndex != -1 && browse)
                    {
                        var lockedRow = skyward.browse.getCurrentRowElement("locked", browse.browseName, activeRowIndex);
                        var unlockedRow = skyward.browse.getCurrentRowElement("unlocked", browse.browseName, activeRowIndex);

                        lockedRow.addClass("studentCourseRequest selectedRow");
                        lockedRow.find("svg.selectedRow").addClass("studentCourseRequest");
                        unlockedRow.addClass("studentCourseRequest selectedRow").removeClass("current");
                        unlockedRow.find("> td").addClass("browseRowCell selectedRow");
                    }
                }
            }
        };

        var deselectPreviousRowOverride = function (browseName)
        {
            if (browseName == studentCourseRequestBrowse)
            {
                var browse = getBrowseByName(browseName);
                var studentCourseRequestID = studentScheduleViewPart.data("activeStudentSectionOrRequest")["studentCourseRequestID"];

                if (studentCourseRequestID != "")
                {
                    var activeRowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

                    if (!(activeRowIndex != -1 && browse && browse.currentRow != activeRowIndex))
                    {
                        return false;
                    }
                }
            }
            return true;
        };

        var deactivateSelectedRow = function (forceDeselect)
        {
            var browse = getBrowseByName(studentCourseRequestBrowse);
            var studentCourseRequestID = studentScheduleViewPart.data("activeStudentSectionOrRequest")["studentCourseRequestID"];

            if (studentCourseRequestID != "" && browse)
            {
                var activeRowIndex = getStudentCourseRequestRowIndex(studentCourseRequestID);

                if (activeRowIndex > -1)
                {
                    var lockedRow = skyward.browse.getCurrentRowElement("locked", browse.browseName, activeRowIndex);
                    var unlockedRow = skyward.browse.getCurrentRowElement("unlocked", browse.browseName, activeRowIndex);

                    if (!forceDeselect)
                    {
                        if (activeRowIndex == browse.currentRow)
                        {
                            lockedRow.removeClass("studentCourseRequest selectedRow");
                            lockedRow.find("svg.selectedRow").removeClass("studentCourseRequest");
                            unlockedRow.removeClass("studentCourseRequest selectedRow").addClass("current");
                            unlockedRow.find("> td").removeClass("browseRowCell selectedRow");
                        }
                        else //This happens when the arrow up/down keys are pressed during active session and the current is no longer the same as the active (selectedRow)
                        {
                            forceDeselect = true;
                        }
                    }

                    if (forceDeselect)
                    {
                        lockedRow.removeClass("studentCourseRequest selectedRow current");
                        lockedRow.find("svg.selectedRow").removeClass("studentCourseRequest");
                        lockedRow.find("> td").removeClass("browseRowCell selectedRow");

                        unlockedRow.removeClass("studentCourseRequest selectedRow current");
                        unlockedRow.find("svg.selectedRow").removeClass("studentCourseRequest");
                        unlockedRow.find("> td").removeClass("browseRowCell selectedRow");
                    }
                }
            }

            studentScheduleViewPart.data("activeStudentSectionCard", "");
            setActiveStudentSectionOrRequest("", "");
        };

        //Quick Entry Panel
        var toggleQuickEntry = function ()
        {
            var scheduleBuilderQuickEntryToolbarVisible;
            var quickEntryToolbar = $('#quickEntryToolbar');
            var contentWrapper = $('#studentScheduleContentWrapper');
            var btnCourseQuickEntry = $(btnCourseQuickEntryID);

            if (quickEntryToolbar.hasClass('hidden') && !contentWrapper.hasClass('quickEntryVisible'))
            {
                //Quick Entry Panel is not visible, so the content wrapper should not be adjusted
                quickEntryToolbar.removeClass('hidden');
                contentWrapper.addClass('quickEntryVisible');
                scheduleBuilderQuickEntryToolbarVisible = true;
                btnCourseQuickEntry.removeClass("collapsed").addClass("expanded");
                $(quickEntryCourseEELID + '_code').focus();
            }
            else
            {
                quickEntryToolbar.addClass('hidden');
                contentWrapper.removeClass('quickEntryVisible');
                scheduleBuilderQuickEntryToolbarVisible = false;
                btnCourseQuickEntry.removeClass("expanded").addClass("collapsed");
            }

            $.ajax({
                url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateQuickEntryToolbarState",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    ScheduleBuilderQuickEntryToolbarVisible: scheduleBuilderQuickEntryToolbarVisible
                }
            });
        };

        var clearQuickEntry = function ()
        {
            var btnQuickEntryToolbarClear = $(quickEntryToolbarClearButtonID);
            if (btnQuickEntryToolbarClear && !btnQuickEntryToolbarClear.hasClass('hidden'))
            {
                var sectionEEL = $(quickEntrySectionEELID);
                if (sectionEEL && sectionEEL.find('.codeEELValue').val() != '')
                {
                    skyward.codeeel.clear($(quickEntrySectionEELID), true);
                }

                var courseEEL = $(quickEntryCourseEELID);
                if (courseEEL && courseEEL.find('.codeEELValue').val() != '')
                {
                    skyward.codeeel.clear($(quickEntryCourseEELID), true);
                    $(quickEntryCourseEELID + '_code').focus();
                }
            }
        };

        var addFromQuickEntry = function ()
        {
            var btnQuickEntryToolbarAddCourse = $(quickEntryToolbarAddCourseButtonID);
            if (btnQuickEntryToolbarAddCourse && !btnQuickEntryToolbarAddCourse.hasClass('hidden'))
            {
                var entityID = studentScheduleViewPart.data("entityid");
                var entityIDSecurityHash = studentScheduleViewPart.data('entityid_securityhash');

                var studentID = btnQuickEntryToolbarAddCourse.data('studentid');
                var studentIDSecurityHash = btnQuickEntryToolbarAddCourse.data('studentid_securityhash');

                var courseEEL = $(quickEntryCourseEELID);
                if (courseEEL)
                {
                    var courseEELValue = courseEEL.find('.codeEELValue').val();
                    if (courseEELValue)
                    {
                        var sectionEEL = $(quickEntrySectionEELID);
                        if (sectionEEL)
                        {
                            var sectionEELValue = sectionEEL.find('.codeEELValue').val();
                            if (sectionEELValue)
                            {
                                //Get the end date from the section that was selected
                                $.ajax({
                                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/GetSectionEndDateForQuickEntryToolbar",
                                    type: "POST",
                                    dataType: "JSON",
                                    data:
                                    {
                                        sectionID: sectionEELValue
                                    },
                                    success: function (data)
                                    {
                                        if (data && !$.isEmptyObject(data))
                                        {
                                            var startDate = studentScheduleViewPart.data("effectivedate");
                                            var sectionID_securityhash = data.sectionid_securityhash;
                                            skyward.matrix.addStudentSectionFromBrowseMenu(sectionEELValue, sectionID_securityhash, startDate, data.EndDate);
                                        }
                                    }
                                });
                            }
                            else
                            {
                                skyward.matrix.addCourseRequest(courseEELValue, entityID, entityIDSecurityHash, studentID, studentIDSecurityHash);
                            }
                        }
                        else
                        {
                            skyward.matrix.addCourseRequest(courseEELValue, entityID, entityIDSecurityHash, studentID, studentIDSecurityHash);
                        }
                    }
                }
                $(quickEntryCourseEELID + '_code').focus();
            }
        };

        var updateAddCourseButton = function ()
        {
            var courseEEL = $(quickEntryCourseEELID + '_value');
            var btnQuickEntryToolbarAddCourse = $(quickEntryToolbarAddCourseButtonID);
            var btnQuickEntryToolbarClear = $(quickEntryToolbarClearButtonID);
            if (courseEEL && courseEEL.val() != undefined && courseEEL.val() == "")
            {
                btnQuickEntryToolbarAddCourse.addClass('hidden');
                btnQuickEntryToolbarClear.addClass('hidden');
            }
            else
            {
                btnQuickEntryToolbarAddCourse.removeClass('hidden');
                btnQuickEntryToolbarClear.removeClass('hidden');
            }
        };

        var buildMessageBoxErrorList = function (errorList, errors)
        {
            $(errors).each(function ()
            {
                for (var key in this)
                {
                    for (var i = 0; i < errors[key].length; i++)
                    {
                        var iconSpan = $('<span/>');
                        $.when(skyward.svg.getSvg('Error', 'Error')).done(function (svg)
                        {
                            iconSpan.append(svg);
                        });
                        var listItem = $("<li class='error-list'/>");
                        var errorMessage = $('<span>' + errors[key][i] + '</span>');
                        listItem.append(iconSpan);
                        listItem.append(errorMessage);
                        errorList.append(listItem);
                    }
                }
            });
        };

        var bottomTabCourseContainerSetFirstTabCurrent = function ()
        {
            var tabButtonList = bottomTabCourseContainer.find(".tabStrip .tabButton");
            var tabContentsList = bottomTabCourseContainer.find(".tabContents");
            tabButtonList.each(function ()
            {
                var tab = $(this);

                if (tab.hasClass("firstTab"))
                {
                    tab.addClass("current");
                    tabContentsList.removeClass("current");
                    $(tabContentsList[tab.data("index")]).addClass("current");
                }
                else
                {
                    tab.removeClass("current");
                }
            });
        };

        var loadCourseTabContainer = function (currentTab)
        {
            var currentTabContent = findContentContainerFromCurrentTab(currentTab);
            if (currentTabContent != undefined)
            {
                var contentContainer = currentTabContent.contentContainer;
                var loadBrowse = currentTabContent.loadBrowse;
                var contentContainerID = contentContainer.attr("id");

                if (contentContainerID != undefined && contentContainerID != "")
                {
                    var browseName = contentContainerID.replace("View", "");

                    if (loadBrowse)
                    {
                        contentContainer.data("browseLoaded", false);

                        var data = {
                            studentid: studentScheduleViewPart.data('studentid'),
                            studentid_securityhash: studentScheduleViewPart.data('studentid_securityhash'),
                            coursecontainer: contentContainerID,
                            effectivedate: studentScheduleViewPart.data("effectivedate"),
                        };
                        skyward.window.loadContent(contentContainerID, 'Scheduling', 'StudentSchedule', 'Get' + browseName, null, data, null, null, null, true);
                    }
                }
            }
        };

        var getBottomTabCourseContainerPanelInfo = function (infoToGet)
        {
            var panelInfo = bottomTabCourseContainer.data("panelinfo");

            if (panelInfo != undefined)
            {
                switch (infoToGet)
                {
                    case "displayPanel":
                        if (panelInfo.displayPanel != undefined)
                        {
                            return { displayPanel: panelInfo.displayPanel };
                        }
                        else
                        {
                            return { displayPanel: false };
                        }
                    case "currentTab":
                        if (panelInfo.currentTab != undefined)
                        {
                            return { currentTab: panelInfo.currentTab };
                        }
                        else
                        {
                            return { currentTab: undefined };
                        }
                    case "displayPanelAndcurrentTab":
                        if (panelInfo.displayPanel != undefined && panelInfo.currentTab != undefined)
                        {
                            return { displayPanel: panelInfo.displayPanel, currentTab: panelInfo.currentTab };
                        }
                        break;
                }
            }

            return { displayPanel: false, currentTab: undefined };
        };

        var bottomTabCourseContainerSearchBoxSetFocus = function (currentTab)
        {
            const currentTabContent = findContentContainerFromCurrentTab(currentTab);
            if (currentTabContent.contentContainer === undefined)
            {
                return;
            }
            const browse = skyward.browse.getInnerBrowse(currentTabContent.contentContainer);
            if (browse !== undefined && browse.seek !== undefined)
            {
                browse.seek.focus();
            };
            return browse;
        };

        var bottomTabCourseContainerResizeAndSearchBoxSetFocus = function (currentTab)
        {
            const browse = bottomTabCourseContainerSearchBoxSetFocus(currentTab);
            if (browse !== undefined)
            {
                skyward.browse.resize(browse.id);
            }
        };

        var getbottomTabContainerLoadedBrowse = function ()
        {
            var loadedBrowse = "";
            var availableSectionViewBrowseLoaded = $("#" + availableSectionsView).data("browseLoaded");
            if (availableSectionViewBrowseLoaded != undefined)
            {
                switch (availableSectionViewBrowseLoaded)
                {
                    case availableSectionsBrowse:
                        loadedBrowse = availableSectionsBrowse;
                        break;
                    case availableSectionsByRequestsAndOpenPeriodBrowse:
                        loadedBrowse = availableSectionsByRequestsAndOpenPeriodBrowse;
                        break;
                    case availableSectionsByOpenPeriodBrowse:
                        loadedBrowse = availableSectionsByOpenPeriodBrowse;
                        break;
                    case availableSectionsByChangeSectionBrowse:
                        loadedBrowse = availableSectionsByChangeSectionBrowse;
                        break;
                    case availableSectionsByReplaceSectionBrowse:
                        loadedBrowse = availableSectionsByReplaceSectionBrowse;
                        break;
                }
            }

            return loadedBrowse;
        };

        var bottomTabContainerSearchBoxSetFocus = function ()
        {
            var loadedBrowse = getbottomTabContainerLoadedBrowse();
            if (loadedBrowse != "")
            {
                skyward.browse.resize(loadedBrowse);
                $("#" + loadedBrowse + "_seek").focus();
            }
        };

        //Schedule Matrix Display Settings
        var showSettingsDialog = function ()
        {
            var selector = $(this);
            var action = selector.data("action");

            var saveSettings = function ()
            {
                const dayRotationDMSE = $('#FilterDayRotationCodes .dmsBackingData');
                const dayRotationCodes = JSON.stringify(skyward.distinctMultiSelectEEL.values.get(dayRotationDMSE));

                //Find the selected schedule card size radio button
                var selectedViewSize = $('#rsScheduleMatrixViewSize_RadioButtonGroup').find('input:checked').val();

                // Find user label configurations, if any
                var serializedScheduledLabelConfiguration = "";
                var userLabelConfigurations = $('.js-ScheduledFieldToDisplay');
                if (userLabelConfigurations.length > 0)
                {
                    var scheduledLabelConfiguration = {};
                    userLabelConfigurations.each(function ()
                    {
                        var optionCombobox = $(this);
                        // substr(9) removes the "Scheduled" string from the front of the id to sanitize it for serialization
                        scheduledLabelConfiguration[optionCombobox.attr('id').substr(9)] = skyward.controls.getValue(optionCombobox);
                    });
                    serializedScheduledLabelConfiguration = JSON.stringify(scheduledLabelConfiguration);
                }

                var viewmode = studentScheduleViewPart.data('viewmode');
                if (AccessMode == "StudentAccess")
                {
                    viewmode = AccessMode;
                }

                var newCoursePanelOnRight = $('#cbCoursePanelOnRight').is(':checked');
                var newHideCourseRequests = newCoursePanelOnRight && $('#cbHideCourseRequests').is(':checked');

                $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateStudentScheduleMatrixViewSize" + viewmode,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        StudentScheduleMatrixViewSize: selectedViewSize,
                        ScheduledFieldsToDisplay: serializedScheduledLabelConfiguration,
                        DayRotationsToDisplay: dayRotationCodes,
                        CoursePanelOnRight: newCoursePanelOnRight ? "True" : "False",
                        HideCourseRequests: newHideCourseRequests ? "True" : "False",
                        HideDroppedCourses: $('#HideDroppedCourses').is(':checked')
                    },
                    success: function ()
                    {
                        skyward.window.closePopup();
                        if (newCoursePanelOnRight !== coursePanelOnRight || newHideCourseRequests !== hideCourseRequests)
                        {
                            // When changing panel placement or the hide-course-requests option, we need a full page
                            // reload because the panel containers, the #studentBoard layout flags, and the Add Course
                            // Request toolbar button aren't re-rendered by updateBoard (it only refreshes the
                            // .studentScheduleMatrix view parts).
                            location.reload();
                        }
                        else
                        {
                            skyward.matrix.updateBoard();
                        }
                    }
                });
            };

            var buildSettingsDialog = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/" + action + "?renderType=contentOnly",
                    type: "POST",
                    dataType: "viewparthtml",
                });
            };

            var options =
            {
                draggable: "true"
            };

            var htmlResponse = buildSettingsDialog();
            htmlResponse.done(function (html)
            {
                var htmlElement = $(html);
                var isFamilyStudentAccess = skyward.controls.getValue(htmlElement.find("#isFamilyStudentAccess"));
                var matrixOrBuilderString = $("#master").attr("data-screen");
                isFamilyStudentAccess = JSON.parse(isFamilyStudentAccess.toLowerCase());
                var headerText = "Schedule Matrix Display Settings";
                if (matrixOrBuilderString == "ScheduleBuilder")
                {
                    headerText = "Student Schedule Builder Display Settings";
                }
                if (isFamilyStudentAccess != null && isFamilyStudentAccess)
                {
                    headerText = "Student Schedule Display Settings";
                }

                const buttons = [
                    { id: 'btnSettingsSave', text: "Save", icon: 'Save', click: saveSettings },
                    { text: "Cancel", icon: 'Cancel', click: 'close' }
                ];

                var dialog = skyward.modalLayer.showDialog(headerText, html, buttons, options);

                dialog.content.find('.js-ResetScheduledFieldsButton').click(function ()
                {
                    var serializedDefaultFieldsElement = dialog.content.find('.js-DefaultScheduledFields');

                    if (serializedDefaultFieldsElement.length === 0 || !serializedDefaultFieldsElement.val())
                    {
                        return;
                    }

                    var defaultFields = JSON.parse(serializedDefaultFieldsElement.val());

                    if ($.isEmptyObject(defaultFields))
                    {
                        return;
                    }

                    dialog.content.find('.js-ScheduledFieldToDisplay').each(function ()
                    {
                        var optionCombobox = $(this);
                        // substr(9) removes the "Scheduled" string from the front of the id to sanitize it for serialization

                        var defaultValueForCombobox = defaultFields[optionCombobox.attr('id').substr(9)];
                        if (!defaultValueForCombobox)
                        {
                            return;
                        }

                        skyward.controls.setValue(optionCombobox, defaultValueForCombobox);
                    });
                });
            });
        };

        var buildScheduleBuilderLegendPopup = function ()
        {
            var clickedElement = $(this);
            var viewmode = studentScheduleViewPart.data("viewmode");
            var accessMode = clickedElement.parents(".studentInformationPopupTabPanel").find("[id$='accessmode']").val() || $("[id$='accessmode']").val();

            if (accessMode == "StudentAccess")
            {
                viewmode = accessMode;
            }

            if (viewmode == "StudentInformationPopup")
            {
                viewmode = viewmode + accessMode;
            }

            clickedElement.off('click', buildScheduleBuilderLegendPopup);

            const legendTitle = studentScheduleViewPart.data("viewmode") == "Builder" ? "Schedule Builder Legend" : "Schedule Matrix Legend";
            skyward.modalLayer.showDialog(legendTitle, buildPopup, { text: "Close", icon: "Close" }, { anchorTo: clickedElement, beforeClose: beforeClose, titleTag: "h1" });

            function buildPopup()
            {
                return $.ajax(
                {
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/BuildScheduleLegendPopup" + viewmode + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                });
            }

            function beforeClose()
            {
                clickedElement.off().on('click', buildScheduleBuilderLegendPopup);
            }
        };

        //Utilities drop down
        var updateStudentScheduleUtilities = function ()
        {
            var clickedElement = $(this);
            var viewmode = studentScheduleViewPart.data("viewmode");

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + scheduleMatrixModule + "/" + scheduleMatrixController + "/UpdateStudentScheduleUtilities" + viewmode + "/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        studentid: clickedElement.data("studentid"),
                        studentidSecurityHash: clickedElement.data("studentid_securityhash"),
                        entityid: clickedElement.data("entityid"),
                        entityidSecurityHash: clickedElement.data("entityid_securityhash"),
                        schoolyearid: clickedElement.data("schoolyearid"),
                        schoolyearidSecurityHash: clickedElement.data("schoolyearid_securityhash")
                    },
                });
            };

            buildPopup().done(function (response)
            {
                var buttonContainer = $(response);
                var menuItemsArray = BuildActionMenuButtons(buttonContainer, 'Utilities');
                skyward.modalLayer.showMenu(menuItemsArray, clickedElement, { useSmallWidth: true});
            });
        };

        //Student/Family Access Printing
        var daterangemode;
        var selectedWeek;
        var weeklyScheduleName = "WeeklySchedule";

        const getStudentAccessFamilyAccessSelectedOptions = function ()
        {
            daterangemode = $("#cbScheduleDateRangeMode").val();
            selectedWeek = (daterangemode === weeklyScheduleName) ? $("#cbWeekOfYear").val() : "";
        };

        skyward.matrix.printAllSchedulesStudentFamilyAccess = function ()
        {
            var masterDiv = $("#master");
            var module = $(masterDiv).data("module");
            var object = $(masterDiv).data("object");
            var portal = $(masterDiv).data("screen");
            getStudentAccessFamilyAccessSelectedOptions();

            var studentEntityYearIDs = [];
            var studentids = [];
            var studentid_securityHashes = [];

            $(".studentScheduleMatrix").each(function ()
            {
                portal = $(this).data('portal');
                studentEntityYearIDs.push($(this).data('uniqueid'));
                studentids.push($(this).data('studentid'));
                studentid_securityHashes.push($(this).data('studentid_securityhash'));
            });

            if (studentEntityYearIDs.length === 0)
            {
                skyward.modalLayer.showDialog("Schedule Not Available to Print", "Scheduling and Grading Information is not available.", { text: "Close", icon: "Close" });
                return;
            }

            skyward.printScreen.launchWorkflow(skyward.global.virtualDir + module + "/" + object + "/PrintAllScheduleMatrices" + portal,
                {
                    studententityyearids: JSON.stringify(studentEntityYearIDs),
                    studentids: JSON.stringify(studentids),
                    studentid_securityHashes: JSON.stringify(studentid_securityHashes),
                    "daterangemode": daterangemode,
                    "displayweeklyschedulefor": selectedWeek
                });
        };

        skyward.matrix.printIndividualScheduleStudentFamilyAccess = function (studentEntityYearID)
        {
            var masterDiv = $("#master");
            var module = $(masterDiv).data("module");
            var object = $(masterDiv).data("object");
            var portal = $(masterDiv).data("screen");
            getStudentAccessFamilyAccessSelectedOptions();

            var scheduleMatrix = $("#studentSchedule-" + studentEntityYearID);

            skyward.printScreen.launchWorkflow(skyward.global.virtualDir + module + "/" + object + "/PrintIndividualScheduleMatrix" + portal,
                {
                    "entityid": $(scheduleMatrix).data('entityid'),
                    "schoolyearid": $(scheduleMatrix).data('schoolyearid'),
                    "schoolyearid_securityhash": $(scheduleMatrix).data("schoolyearid_securityhash"),
                    "studentid": $(scheduleMatrix).data('studentid'),
                    "studentid_securityhash": $(scheduleMatrix).data('studentid_securityhash'),
                    "effectivedate": $(scheduleMatrix).data("effectivedate"),
                    "daterangemode": daterangemode,
                    "displayweeklyschedulefor": selectedWeek
                });
        };

        // Event handlers
        var events =
        {
            "editStudentSection": skyward.matrix.editStudentSection,
            "addCourseRequest": addCourseRequest,
            "addStudentSectionFromBrowseMenu": addStudentSectionFromBrowseMenu,
            "addStudentSectionFromScheduleListBrowseMenu": skyward.matrix.addStudentSectionFromScheduleListBrowseMenu,
            "updateBottomTabContainerFromCourseBrowseMenu": skyward.matrix.updateBottomTabContainerFromCourseBrowseMenu,
            "updateBottomTabContainerFromRequestBrowseMenu": skyward.matrix.updateBottomTabContainerFromRequestBrowseMenu,
            "unscheduleStudentSectionFromBrowseMenu": skyward.matrix.unscheduleStudentSectionFromBrowseMenu,
            "deleteStudentSectionFromBrowseMenu": skyward.matrix.deleteStudentSection,
            "deleteStudentSectionFromScheduleListBrowseMenu": skyward.matrix.deleteStudentSectionFromScheduleListBrowseMenu,
            "changeStudentSectionFromBrowseMenu": skyward.matrix.changeStudentSectionFromBrowseMenu,
            "changeStudentSectionFromScheduleListBrowseMenu": skyward.matrix.changeStudentSectionFromScheduleListBrowseMenu,
            "updateAvailableSectionsFromChangeSectionBrowseMenu": skyward.matrix.updateAvailableSectionsFromChangeSectionBrowseMenu,
            "dropStudentSectionfromBrowseMenu": skyward.matrix.dropStudentSectionfromBrowseMenu,
            "dropStudentSectionFromScheduleListBrowseMenu": skyward.matrix.dropStudentSectionFromScheduleListBrowseMenu,
            "replaceStudentSectionWorkflow": skyward.matrix.replaceStudentSectionWorkflow,
            "updateAvailableSectionsFromReplaceSection": skyward.matrix.updateAvailableSectionsFromReplaceSection,
            "updateAvailableSectionsFromReplaceSectionBrowseMenu": skyward.matrix.updateAvailableSectionsFromReplaceSectionBrowseMenu,
            "deleteCourseRequestFromBrowseMenu": skyward.matrix.deleteCourseRequestFromBrowseMenu,
            "toggleAlternate": toggleAlternate,
            "unscheduleStudentSectionFromScheduleListBrowseMenu": skyward.matrix.unscheduleStudentSectionFromScheduleListBrowseMenu,
            "replaceStudentSectionFromScheduleListBrowseMenu": skyward.matrix.replaceStudentSectionFromScheduleListBrowseMenu,
            "addStudentCourseRequestOrAlternatesFromScheduleListBrowseMenu": skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleListBrowseMenu,
            "addStudentCourseRequestOrAlternatesFromScheduleRequestBrowseMenu": skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleRequestBrowseMenu,
            "deleteStudentCourseRequestFromScheduleListBrowseMenu": skyward.matrix.deleteStudentCourseRequestFromScheduleListBrowseMenu,
            "deleteStudentCourseRequestFromCourseRequestBrowseMenu": skyward.matrix.deleteStudentCourseRequestFromCourseRequestBrowseMenu,
            "callIndividualStudentSchedulerFromScheduleList": skyward.matrix.callIndividualStudentSchedulerFromScheduleList,
            "callIndividualStudyHallSchedulerFromScheduleList": skyward.matrix.callIndividualStudyHallSchedulerFromScheduleList,
            "callReactivateStudentScheduleFromScheduleList": skyward.matrix.callReactivateStudentScheduleFromScheduleList,
            "callReactivateStudentScheduleFromScheduleRequests": skyward.matrix.callReactivateStudentScheduleFromScheduleRequests,
            "callIndividualStudentSchedulerFromScheduleBuilder": skyward.matrix.callIndividualStudentSchedulerFromScheduleBuilder,
            "callIndividualStudyHallSchedulerFromScheduleBuilder": skyward.matrix.callIndividualStudyHallSchedulerFromScheduleBuilder,
            "callReactivateStudentScheduleFromScheduleBuilder": skyward.matrix.callReactivateStudentScheduleFromScheduleBuilder,
            "IndividualAddBySchedulingGroupFromScheduleList": skyward.matrix.IndividualAddBySchedulingGroupFromScheduleList,
            "IndividualAddBySchedulingGroupFromScheduleBuilder": skyward.matrix.IndividualAddBySchedulingGroupFromScheduleBuilder,
            "IndividualAddBySchedulingGroupFromScheduleRequests": skyward.matrix.IndividualAddBySchedulingGroupFromScheduleRequests,
            "IndividualMassDropOrDeleteStudentScheduleFromScheduleList": skyward.matrix.IndividualMassDropOrDeleteStudentScheduleFromScheduleList,
            "IndividualMassDropOrDeleteStudentScheduleFromScheduleBuilder": skyward.matrix.IndividualMassDropOrDeleteStudentScheduleFromScheduleBuilder,
            "IndividualMassUnscheduleStudentSectionsFromScheduleList": skyward.matrix.IndividualMassUnscheduleStudentSectionsFromScheduleList,
            "IndividualMassUnscheduleStudentSectionsFromScheduleBuilder": skyward.matrix.IndividualMassUnscheduleStudentSectionsFromScheduleBuilder,
            "ArenaConvertToRealRecordsIndividualFromScheduleList": skyward.matrix.ArenaConvertToRealRecordsIndividualFromScheduleList,
            "ArenaConvertToRealRecordsIndividualFromScheduleBuilder": skyward.matrix.ArenaConvertToRealRecordsIndividualFromScheduleBuilder,
            "addStudentCourseRequestOrAlternatesFromScheduleBuilder": skyward.matrix.addStudentCourseRequestOrAlternatesFromScheduleBuilder,
            "updateStudentScheduleUtilities": updateStudentScheduleUtilities,
            "printIndividualScheduleStudentFamilyAccess": skyward.matrix.printIndividualScheduleStudentFamilyAccess,
            "printAllSchedulesStudentFamilyAccess": skyward.matrix.printAllSchedulesStudentFamilyAccess,
            openStudentSectionClassSummaryPanelFromCard,
            openActionsPanel
        };
        skyward.events.registerEvents("matrix", events);

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.examples = skyward.examples || {};

        skyward.examples.decimalMin = function (precision, scale)
        {
            return '-' + skyward.examples.decimalMax(precision, scale);
        };

        skyward.examples.decimalMax = function (inPrecision, inScale)
        {
            var precision = parseInt(inPrecision, 10);

            if (isNaN(precision))
            {
                var precisionControl = $(inPrecision);
                if (precisionControl.length > 0)
                {
                    precision = parseInt(skyward.controls.getValue(precisionControl), 10);
                }
            }

            var scale = parseInt(inScale, 10);

            if (isNaN(scale))
            {
                var scaleControl = $(inScale);
                if (scaleControl.length > 0)
                {
                    scale = parseInt(skyward.controls.getValue(scaleControl), 10);
                }
            }

            if (!validDecimalArgs(precision, scale))
            {
                precision = 1;
                scale = 0;
            }

            var example = '';

            for (var i = 0; i < precision - scale; i++)
            {
                example += 9;
            }

            if (scale > 0)
            {
                example += '.';

                for (var j = 0; j < scale; j++)
                {
                    example += 9;
                }
            }

            return formatNumber(example);
        };

        skyward.examples.dateTimeMin = function (precision)
        {
            return '0001-01-01 00:00:00' + addPrecisionDecimals(precision);
        };

        skyward.examples.dateTimeMax = function (input)
        {
            return '9999-12-31 23:59:59' + addPrecisionDecimals(input);
        };

        skyward.examples.timeMin = function (input)
        {
            return '00:00:00' + addPrecisionDecimals(input);
        };

        skyward.examples.timeMax = function (input)
        {
            return '23:59:59' + addPrecisionDecimals(input);
        };

        function validDecimalArgs(precision, scale)
        {
            return (!isNaN(precision) && !isNaN(scale) && precision > 0 && precision < 37 && scale >= 0 && scale <= precision);
        }

        function formatNumber(number)
        {
            if (isNaN(number))
            {
                return '';
            }
            var negative = false;

            if (number < 0)
            {
                negative = true;
                number = (number + '').replace('-', '');
            }

            number = number + '';
            number = number.split('.');

            var placeCount = 1;
            for (var i = number[0].length - 1; i > 0; i--)
            {
                if (placeCount % 3 == 0)
                {
                    number[0] = number[0].substr(0, i) + ',' + number[0].substr(i, number[0].length - i);
                }
                placeCount++;
            }

            number = number.join('.');

            if (negative)
            {
                number = '-' + number;
            }

            return number;
        }

        function addPrecisionDecimals(input)
        {
            var precision = parseInt(input, 10);

            if (isNaN(precision))
            {
                var control = $(input);
                if (control.length > 0)
                {
                    precision = parseInt(skyward.controls.getValue(control), 10);
                }
            }

            if (isNaN(precision) || precision < 0 || precision > 7)
            {
                precision = 1;
            }

            var value = '';
            if (precision > 0)
            {
                value += '.';

                for (var i = 0; i < precision; i++)
                {
                    value += '0';
                }
            }
            return value;
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
skyward.base.registerScript("header", function (skyward, $)
{
    skyward.header = skyward.header || {};

    skyward.header.signOutButtonClick = function ()
    {
        $(this).off("click");
        skyward.window.loadContent("full", "Security", "SignIn", "index", null);
    };

    skyward.header.signInButtonClick = function ()
    {
        $(this).off("click");
        skyward.window.loadContent("full", "Security", "SignIn", "index", null);
    };

    skyward.header.applicantTrackingSignInButtonClick = function ()
    {
        const element = $(this);
        element.off("click");
        window.location.href = element.data("redirect-url");
    };

    skyward.header.showHomeButtons = async function (button)
    {
        const html = await $.ajax(
            {
                url: skyward.global.virtualDir + "Home/Home/GetHomeButtons/",
                type: "POST",
                dataType: "viewparthtml"
            });

        if ($(html).find(`.${classNames.portalHomeButton}`).length < 2)
        {
            skyward.window.checkLoadContent("full", "home", "home", "index");
            return;
        }

        const dialog = skyward.modalLayer.showInformationBubble("Home", html, null, { anchorTo: button, useSmallWidth: true, role: "menu" });

        dialog.content.find(`.${classNames.portalHomeButton}`).on("click", function ()
        {
            dialog.close();
            skyward.window.checkLoadContent("full", "Home", "Home", "PortalIndex", null, { PortalCode: $(this).data().portalcode });
        });
    };

    const classNames =
    {
        displayNone: "displayNone",
        portalHomeButton: "portalHomeButton",
        ribbon: "ribbon",
        ribbonCompressed: "ribbon--compressed"
    };
    Object.freeze(classNames);

    const idNames =
    {
        compressMode: "compressMode",
        externalLinks: "externalLinks",
        importSelector: "importSelector",
        portalButton: "portalButton",
        quickNav: "quickNav",
        reportAndImportSelector: "reportAndImportSelector",
        reportSelector: "reportSelector",
        signOutButton: "signOutButton",
        signInButton: "signInButton",
        applicantTrackingSignInButton: "applicantTrackingSignInButton",
        tileListBrowseLaunch: "tileListBrowseLaunch"
    };
    Object.freeze(idNames);

    const getRibbon = () => $(`.${classNames.ribbon}, .${classNames.ribbonCompressed}`);

    const events =
    {
        init,
        redirectToExternalLink
    };

    return events;

    function init()
    {
        const header = $(this);

        initSignOutButton(header);
        initSignInButton(header);
        initApplicantTrackingSignInButton(header);
        initHomeButton(header);
        initTileListLaunchButton(header);
        initCompressModeButton(header);
        initReportAndImportButtons(header);
        initSkipToMainContent();
    }

    function redirectToExternalLink()
    {
        let url = $(this).data().url;
        if (!url.startsWith("http"))
        {
            url = `//${url}`;
        }
        window.open(url);
    }

    function initSignOutButton(header)
    {
        const signOutButton = header.find(`#${idNames.signOutButton}`);

        if (signOutButton.length)
        {
            signOutButton.one("click", skyward.header.signOutButtonClick);
        }
    }

    function initSignInButton(header)
    {
        const signInButton = header.find(`#${idNames.signInButton}`);

        if (signInButton.length)
        {
            signInButton.one("click", skyward.header.signInButtonClick);
        }
    }

    function initApplicantTrackingSignInButton(header)
    {
        const applicantTrackingSignInButton = header.find(`#${idNames.applicantTrackingSignInButton}`);

        if (applicantTrackingSignInButton.length)
        {
            applicantTrackingSignInButton.one("click", skyward.header.applicantTrackingSignInButtonClick);
        }
    }

    function initHomeButton(header)
    {
        const homeButton = header.find(`#${idNames.portalButton}`);
        homeButton.on("click", skyward.buttonManager.manageButtonClick(function ()
        {
            skyward.header.showHomeButtons($(this));
        }));
    }

    function initTileListLaunchButton(header)
    {
        const tileListLaunchbutton = header.find(`#${idNames.tileListBrowseLaunch}`);

        if (tileListLaunchbutton.length)
        {
            tileListLaunchbutton.one("click", tileListLaunched);
        }

        function tileListLaunched()
        {
            const tileButton = $(this);

            const data = tileButton.data();

            skyward.window.loadContent("full", data.module, data.object, data.screen, null);
        }
    }

    function initCompressModeButton(header)
    {
        const compressModeButton = header.find(`#${idNames.compressMode}`);

        if (compressModeButton.length)
        {
            compressModeButton.one("click", compressButtonClick);
            compressModeButton.debounce("click", saveCompressModeState);
        }

        function compressButtonClick()
        {
            const quickNav = $(`#${idNames.quickNav}`);
            const ribbon = getRibbon();
            const isCompressed = ribbon.hasClass(classNames.ribbonCompressed);

            ribbon.toggleClass(classNames.ribbon, isCompressed);
            ribbon.toggleClass(classNames.ribbonCompressed, !isCompressed);
            quickNav.toggleClass(classNames.displayNone, !isCompressed);
            compressModeButton.attr("aria-checked", isCompressed);
            $(window).trigger("resize");
            compressModeButton.one("click", compressButtonClick);
        }

        function saveCompressModeState()
        {
            const ribbon = getRibbon();
            return $.ajax(
                {
                    url: skyward.global.virtualDir + "Security/Session/UpdateCompressedMode",
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { hideGlass: true },
                    data: { compressedMode: ribbon.hasClass(classNames.ribbonCompressed) }
                });
        }
    }

    function initReportAndImportButtons(header)
    {
        const reportSelectorButton = header.find(`#${idNames.reportSelector}`);
        const importSelectorButton = header.find(`#${idNames.importSelector}`);
        const reportAndImportSelectorButton = header.find(`#${idNames.reportAndImportSelector}`);

        if (reportSelectorButton.length)
        {
            reportSelectorButton.on("click", function () { buildReportAndImportList($(this), true, false); });
        }

        if (importSelectorButton.length)
        {
            importSelectorButton.on("click", function () { buildReportAndImportList($(this), false, true); });
        }

        if (reportAndImportSelectorButton.length)
        {
            reportAndImportSelectorButton.on("click", function () { buildReportAndImportList($(this), true, true); });
        }

        function buildReportAndImportList(button, showReports, showImports)
        {
            const reportsAndImports = { reports: [], imports: [] };
            const ajaxActions = [];
            const buttonData = button.data();
            const title = button[0].textContent;

            if (showReports)
            {
                ajaxActions.push($.ajax(
                    {
                        url: skyward.global.virtualDir + "Reporting/Report/BuildReportList",
                        type: "POST",
                        dataType: "JSON",
                        data: buttonData,
                        success: (data) => reportsAndImports.reports = data.menuItems
                    })
                );
            }

            if (showImports)
            {
                ajaxActions.push($.ajax(
                    {
                        url: skyward.global.virtualDir + "SkySys/Import/BuildImportList",
                        type: "POST",
                        dataType: "JSON",
                        data: buttonData,
                        success: (data) => reportsAndImports.imports = data.menuItems
                    })
                );
            }

            $.whenAll(ajaxActions).done(function ()
            {
                const menuItems = [];
                menuItems.push(reportsAndImports.reports);
                menuItems.push(reportsAndImports.imports);

                const options = { anchorTo: button, allowNoButtons: true, useSmallWidth: true, role: "menu" };
                const popupModalLayer = skyward.modalLayer.showInformationBubble(title, menuItems, null, options);
                popupModalLayer.onScreen = true;
            });
        }
    }

function initSkipToMainContent()
{  
    const skipToMainContent = $('.skipToMainContent');
    skipToMainContent.attr('tabindex', 0);

    const focusMain = () =>
    {
        $(document.body).find('[role=main]').focus();
    };

    skipToMainContent.on("click", focusMain);
    skipToMainContent.on('enter', (event) =>
    {
        focusMain();

        event.preventDefault();
        event.stopPropagation();
    });
  }
});;
(
    function (skyward, $)
    {
        "use strict";

        skyward.autoSaveManagers = skyward.autoSaveManagers || {};

        var defaultUndoManagerSettings =
        {
            execute: function (/* status object */)
            {
                // Called when a new command is executed and added to the undo manager
            },
            undo: function (/* status object */)
            {
                // Called when a command is undone
            },
            redo: function (/* status object */)
            {
                // Called when a command is redone
            },
            reset: function (/* status object */)
            {
                // called when the undo manager's command list is cleared
            }
        };

        var defaultCommand =
        {
            execute: function ()
            {
                // Called whenever a command is executed or on a redo
            },
            undo: function ()
            {
                // Called whenever a command is undone
            }
        };

        // The undo manager handles undo/redo functionality. Commands must be pushed into the manager by calling the execute method
        // and passing in an object that contains execute() and undo() functions.
        skyward.autoSaveManagers.createUndoManager = function (options)
        {
            var undoManager = {};
            var settings = $.extend({}, defaultUndoManagerSettings, options);

            var position = -1;
            var commands = [];

            var getStatus = function ()
            {
                var status =
                {
                    position: position + 1,
                    totalCommands: commands.length,
                    canUndo: undoManager.canUndo(),
                    canRedo: undoManager.canRedo()
                };

                return status;
            };

            undoManager.execute = function (command)
            {
                command = $.extend({}, defaultCommand, command);
                commands.splice(position + 1, Number.MAX_VALUE);
                position++;
                commands.push(command);
                var result = commands[position].execute();
                settings.execute(getStatus());

                return result;
            };

            undoManager.undo = function ()
            {
                var result = null;

                if (undoManager.canUndo())
                {
                    result = commands[position].undo();
                    position--;
                }

                settings.undo(getStatus());
                return result;
            };

            undoManager.redo = function ()
            {
                var result = null;

                if (undoManager.canRedo())
                {
                    position++;
                    result = commands[position].execute();
                }
                
                settings.redo(getStatus());
                return result;
            };

            undoManager.reset = function ()
            {
                position = -1;
                commands = [];
                settings.reset(getStatus());
            };

            undoManager.canUndo = function ()
            {
                return commands.length > 0 && position >= 0;
            };

            undoManager.canRedo = function ()
            {
                return commands.length > 0 && position + 1 < commands.length;
            };

            return undoManager;
        };

        var defaultSaveManagerSettings =
        {
            saveDataUniqueId: "saveManagerId", // The property name for the save manager to see if one piece of data is the same as another
            postDataAttributeName: "saveData", // The property name all the save data will be attached to when posted
            savesStarted: function (/* status object */)
            {
                // Called when a save starts
            },
            update: function (/* status object */)
            {
                // Called when a save is added or completed
            },
            savesCompleted: function (/* status object */)
            {
                // Called when all saves are completed
            }
        };

        // The save manager ensures that new saves updating data with the same saveManagerId wait for existing saves to finish
        // before firing. This is to prevent race conditions since we can't be certain which order the server will handle the
        // AJAX requests. This works with both updating a single piece of data or a batch in an array. Objects being passed in
        // must have a saveManagerId attribute for this to work properly.
        skyward.autoSaveManagers.createSaveManager = function (options)
        {
            var saveManager = {};
            var settings = $.extend({}, defaultSaveManagerSettings, options);

            var saveTracker = (function ()
            {
                var saveTracker = {};

                var saveInProgress = false;
                var queue = [];
                var requestsComplete = 0;

                var reset = function ()
                {
                    saveInProgress = false;
                    queue = [];
                    requestsComplete = 0;
                };

                var getNumberOfCurrentRequests = function ()
                {
                    var count = 0;

                    for (var i = 0; i < queue.length; i++)
                    {
                        if (queue[i].state() == "pending")
                        {
                            count++;
                        }
                    }

                    return count;
                };

                var getStatus = function ()
                {
                    var status =
                    {
                        numberOfCurrentRequests: getNumberOfCurrentRequests(),
                        numberOfCompletedRequests: requestsComplete,
                        numberOfTotalRequests: queue.length
                    };

                    return status;
                };

                saveTracker.add = function (request)
                {
                    if (!saveInProgress)
                    {
                        saveInProgress = true;
                        settings.savesStarted(getStatus());
                    }

                    queue.push(request);

                    request.then(function ()
                    {
                        requestsComplete++;
                        settings.update(getStatus());

                        if (requestsComplete == queue.length)
                        {
                            settings.savesCompleted(getStatus());
                            reset();
                        }
                    });
                };

                return saveTracker;
            })();

            var dataTracker = (function ()
            {
                var dataTracker = {};

                var queue = [];

                dataTracker.remove = function (data, promise)
                {
                    for (var i = 0; i < data.length; i++)
                    {
                        for (var j = queue.length - 1; j > -1; j--)
                        {
                            if (queue[j][settings.saveDataUniqueId] === data[i][settings.saveDataUniqueId] && queue[j].request === promise)
                            {
                                queue.splice(j, 1);
                            }
                        }
                    }
                };

                dataTracker.add = function (data, promise)
                {
                    for (var i = 0; i < data.length; i++)
                    {
                        var queueData = {};
                        queueData[settings.saveDataUniqueId] = data[i][settings.saveDataUniqueId];
                        queueData.request = promise;
                        queue.push(queueData);
                    }
                };

                dataTracker.getQueue = function ()
                {
                    return queue.slice();
                };

                return dataTracker;
            })();

            var findConflictingSavesInProgress = function (data)
            {
                var conflicts = [];
                var dataQueue = dataTracker.getQueue();

                for (var i = 0; i < data.length; i++)
                {
                    for (var j = 0; j < dataQueue.length; j++)
                    {
                        if (dataQueue[j] && dataQueue[j][settings.saveDataUniqueId] === data[i][settings.saveDataUniqueId])
                        {
                            conflicts.push(dataQueue[j].request);
                        }
                    }
                }

                return conflicts;
            };

            var queueSave = function (data, url)
            {
                var deferred = $.Deferred();
                var promise = deferred.promise();
                var waitFor = findConflictingSavesInProgress(data);

                $.when.apply($, waitFor).then(function ()
                {
                    var postData = {};
                    postData[settings.postDataAttributeName] = JSON.stringify(data);

                    $.ajax(
                    {
                        url: skyward.global.virtualDir + url,
                        type: "POST",
                        dataType: "JSON",
                        data: postData,
                        activityIndicator: { silent: true },
                        success: function ()
                        {
                            deferred.resolve.apply(this, arguments);
                            dataTracker.remove(data, promise);
                        }
                    });
                });

                dataTracker.add(data, promise);
                saveTracker.add(promise);

                return promise;
            };

            saveManager.save = function (data, url)
            {
                if (!Array.isArray(data))
                {
                    data = [data];
                }

                return queueSave(data, url);
            };

            return saveManager;
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.gradebook = skyward.gradebook || {};

        var BROWSE_NAME = "Gradebook";
        var EXPANDED_CLASS_NAME = "gradebookContainerExpanded";
        var COLLAPSED_CLASS_NAME = "gradebookContainerCollapsed";
        var CHILDREN_COLLAPSED_CLASS_NAME = "collapseChildRecords";
        var ALERT_HEADER = "Gradebook Alert";
        var PENDING_SCORE = "pendingScore";
        var GRADEBOOK_UPDATE_STATUS_WRAPPER = "GradebookUpdateStatusWrapper";
        var GRADEBOOK_EXPAND_ANIMATION_DURATION = 1000;
        var GRADEBOOK_EXPAND_ANIMATION_SCROLL_THRESHOLD = 200; //Arbitrary number that we can tweak this as we see fit. No need to make them wait a full second to scroll a tiny bit.
        var GRADEBOOK_EXIT_SCORING_MODE = "Exit Scoring Mode";
        var FLASH_COLOR = "#c9f0c9";
        var ON_LOAD_WARNING_SELECTOR = ".js-gradebookBannerWarningOnLoad";
        var TOOLBAR_LEFT_SELECTOR = ".js-gradebookToolbarLeft";
        var GRADE_COLUMN_HIDDEN_SELECTOR = "gradeBucketColumnHidden";
        const PREVENT_CLICK_CLASS_NAME = 'js-preventClick';
        const RESIZE_COLUMN_MIN_WIDTH = 65;
        const RESIZE_COLUMN_MAX_WIDTH = 300;
        const SHOW_INDICATORS_MIN_WIDTH = 131;
        const BORDER_SHADOW_WIDTH = 13;

        // Collapsible column constants. These are currently maintained in several places
        // If updates are made here, make sure those updates are also reflected in:
        // CollapsibleColumnConstants.cs, dailyattendance.js, gradebook.js
        const _collapsibleClassNames =
        {
            AfterBaseLockedColumn: "afterBaseLockedColumn",
            BeforeBaseLockedColumn: "beforeBaseLockedColumn",
            BeforeCollapsibleColumns: "beforeCollapsibleColumns",
            Collapsed: "collapsed",
            CollapsibleBrowseColumn: "collapsibleBrowseColumn",
            Expanded: "expanded",
            HiddenBrowseColumn: "hiddenBrowseColumn",
            LastBefore: "lastBefore"
        };

        var gradebookLoadTimes;

        var init = function (selector)
        {
            if ($(selector).find(".mobileGradebookScoreEntry").length > 0)
            {
                var mobileGradebookScoreEntry = $(selector).find(".mobileGradebookScoreEntry");
                mobileGradebookScoreEntry.on("change", ".NoCount, .IsMissing", updateAssignmentIndicatorsMobile);
                mobileGradebookScoreEntry.on("change", ".Score", updateAssignmentIndicatorsMobile);
                mobileGradebookScoreEntry.on("click", ".attemptCount", function (event, returnData)
                {
                    var data = $(this).data();
                    attemptsPopup(data);
                });
                mobileGradebookScoreEntry.on("gradebookInputCodeEELValid", ".scoreClarifier", updateAssignmentIndicatorsMobile);
                mobileGradebookScoreEntry.on("eelComplete", ".codeEEL, .quickEntryText", updateAssignmentIndicatorsMobile);
                mobileGradebookScoreEntry.on("keyup", ".codeEEL.quickEntryText", function () { markCommentQuickEntryAsValid($(this)) });
                mobileGradebookScoreEntry.on("change", ".codeEELValue", function ()
                {
                    var codeEEL = $(this).parent(".codeEEL");
                    updateAssignmentIndicatorsMobile.apply(codeEEL);
                });
            }

            var gradebookContainer = $(selector + " #" + BROWSE_NAME);

            $(selector).find('#SourceAssignments').on('click', ".checkbox", validateCopyAssignmentCheckbox);

            var pageLoadStopwatch;
            var domInsertStopwatch;

            var gradebookStatsPrePageLoad = function ()
            {
                gradebookLoadTimes = {};
                pageLoadStopwatch = skyward.time.stopwatch();
            };

            var gradebookStatsServerResponsePostLoad = function ()
            {
                gradebookLoadTimes["Server Response"] = pageLoadStopwatch.duration();
            };

            var gradebookStatsDOMInsertionPreLoad = function ()
            {
                domInsertStopwatch = skyward.time.stopwatch();
            };

            var gradebookStatsDOMInsertionPostLoad = function ()
            {
                gradebookLoadTimes["DOM Insertion"] = domInsertStopwatch.duration();
            };

            var gradebookStatsPostPageLoad = function ()
            {
                gradebookLoadTimes["Total"] = pageLoadStopwatch.duration();
            };

            $(selector + " #OODDestinationClosedBuckets").on("eelComplete", ".codeEEL", function ()
            {
                updatePercentFromGradeMarkDefaultPercent($(this), 'StudentGradeBucketPercentScore');
            });

            $(selector + " #OODDestinationPercents").on("eelComplete", ".codeEEL", function ()
            {
                updatePercentFromGradeMarkDefaultPercent($(this), 'StudentStartingPercentScore');
            });

            var placeholderDiv = $(selector).find('#gradebookPlaceholder');

            if (placeholderDiv.length > 0 && gradebookContainer.length == 0)
            {
                placeholderDiv.on('PageLoadingPreLoad', gradebookStatsPrePageLoad);
                placeholderDiv.on('ServerResponsePostLoad', gradebookStatsServerResponsePostLoad);
                placeholderDiv.on('DOMInsertionPreLoad', gradebookStatsDOMInsertionPreLoad);
                placeholderDiv.on('DOMInsertionPostLoad', gradebookStatsDOMInsertionPostLoad);
                placeholderDiv.on('PageLoadingPostLoad', gradebookStatsPostPageLoad);
            }

            if (gradebookContainer.length == 0)
            {
                return;
            }

            var gradebookBrowse = $('#' + BROWSE_NAME);
            var gradebookData = gradebookBrowse.data();
            var gradebookPlaceholder = gradebookBrowse.parent();
            var enabledGradeSheetGradeMarkScoringWidth = '3.1em';
            var disabledGradeSheetGradeMarkScoringWidth = '3.9em';
            gradebookBrowse.off();
            // re-add locked column simulated focus listener
            skyward.browse.bindLockedBodySimulatedFocus(gradebookBrowse);
            var gradebook =
            {
                id: BROWSE_NAME,
                currentRow: 0,
                browse: gradebookBrowse,
                controls: $('#' + BROWSE_NAME + '_controls'),
                unlockedHeader: $('#' + BROWSE_NAME + '_unlockedHeader'),
                lockedHeader: $('#' + BROWSE_NAME + '_lockedHeader'),
                lockedRowHeader: $('#' + BROWSE_NAME + '_lockedHeaderRow'),
                unlockedRowHeader: $('#' + BROWSE_NAME + '_unlockedRowHeader'),
                unlockedRowSpacerHeader: $('#' + BROWSE_NAME + '_unlockedRowSpacerHeader'),
                lockedHeaderSpacerRow: $('#' + BROWSE_NAME + '_lockedHeaderSpacerRow'),
                unlockedAveragesRowHeader: $('#' + BROWSE_NAME + '_unlockedAveragesRowHeader'),
                dataContainer: $('#' + BROWSE_NAME + '_dataContainer'),
                body: $('#' + BROWSE_NAME + '_body'),
                unlockedBody: $('#' + BROWSE_NAME + '_unlockedBody'),
                lockedBody: $('#' + BROWSE_NAME + '_lockedBody'),
                lockedBodyTable: $("#" + BROWSE_NAME + "_lockedBodyTable"),
                header: $('#' + BROWSE_NAME + '_header'),
                headerSpacer: $('#' + BROWSE_NAME + '_headerSpacer'),
                headerSpacerDiv: $('#' + BROWSE_NAME + '_headerSpacerDiv'),
                editButton: $("#UpdateEditMode"),
                massAssign: $('#MassAssignScores'),
                hideDuringEditMode: $('#DisplayTypeButton'),
                editMode: gradebookData.singleassignment == true,
                readOnly: gradebookData.readOnly == 'true',
                colorData: function ()
                {
                    return gradebook.unlockedBody.data().grademarkcolordata;
                },
                reloadGradebook: function (area, controller, action, additionalData)
                {
                    if (gradebook.gradebookFullyLoadedPromise && !gradebook.isGradebookFullyLoaded())
                    {
                        gradebook.gradebookFullyLoadedPromise.reject(new skyward.error.CancellationError("Not fully loaded"));
                    }

                    gradebookStatsPrePageLoad();
                    gradebook.showLoadingIcon();

                    var data = getRequiredGradebookData();

                    if (additionalData)
                    {
                        $.extend(data, additionalData);
                    }

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + area + "/" + controller + "/" + action,
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            activityIndicator: { silent: true },
                            success: function (returnData)
                            {
                                gradebookStatsServerResponsePostLoad();
                                if (returnData.html)
                                {
                                    gradebook.updateGradebookContents(returnData.html);
                                    gradebookStatsPostPageLoad();
                                }
                            }
                        });
                },
                showLoadingIcon: function ()
                {
                    gradebookPlaceholder.get(0).innerHTML = '';
                    var pageLoadingDiv = '<div class="pageLoadingDataContainer" >' + skyward.window.getImageHtml() + '<span class="pageLoadingMessage">Loading Gradebook</span></div>';
                    gradebookPlaceholder.prepend(pageLoadingDiv);
                },
                showLoadingIconInContainer: function (container)
                {
                    var pageLoadingImage = skyward.window.getImage();
                    container.append(pageLoadingImage);
                },
                removeLoadingIconFromContainer: function (container)
                {
                    container.find(".pageLoadingGif").remove();
                },
                updateGradebookContents: function (html)
                {
                    gradebookStatsDOMInsertionPreLoad();
                    gradebookPlaceholder.remove(".pageLoadingGif");
                    gradebookPlaceholder.get(0).innerHTML = html;
                    skyward.window.notifyDOMLoad("#moduleContent");
                    gradebookStatsDOMInsertionPostLoad();
                },
                expandCollapseLockedColumns: function ()
                {
                    var clickedElement = $(this);

                    if (!gradebook.isGradebookFullyLoaded())
                    {
                        gradebook.queueFunctionToCallOnCompletionOfLoad(gradebook.expandCollapseLockedColumns, clickedElement, {});
                        return;
                    }

                    var collapse;
                    var classToLookFor = `.${_collapsibleClassNames.CollapsibleBrowseColumn}`;
                    var iconButtonClicked = clickedElement.hasClass('gradebookLockedIconColumnButton');
                    if (iconButtonClicked)
                    {
                        classToLookFor += '.beforeBaseLockedColumn';
                    }
                    else
                    {
                        classToLookFor += `.${_collapsibleClassNames.AfterBaseLockedColumn}`;
                    }
                    if (gradebookBrowse.find(classToLookFor + `.${_collapsibleClassNames.HiddenBrowseColumn}`).length == 0)
                    {
                        collapse = true;
                        skyward.svg.swapSvg(clickedElement.find("svg"), "ChevronRight", "GradebookHeader");
                        gradebookBrowse.find(classToLookFor).addClass(_collapsibleClassNames.HiddenBrowseColumn);

                        gradebook.updateLockedBodyWidths();
                    }
                    else
                    {
                        collapse = false;
                        skyward.svg.swapSvg(clickedElement.find("svg"), "ChevronLeft", "GradebookHeader");
                        gradebookBrowse.find(classToLookFor).removeClass(_collapsibleClassNames.HiddenBrowseColumn);

                        gradebook.updateLockedBodyWidths();
                    }

                    gradebookBrowse.trigger("Gradebook.UpdateLockedColumnState",
                    {
                        collapse: collapse,
                        fieldToSet: iconButtonClicked ? 'HideLockedIcons' : 'HideLockedColumns'
                    });

                    gradebook.resize();
                },
                updateLockedBodyWidths: function ()
                {
                    var lockedTableWidth = gradebook.lockedBodyTable.width();

                    var boxShadowPadding = 12;
                    $('#' + BROWSE_NAME).find(".lockedBrowseBody_scrollwrapper").width(lockedTableWidth + boxShadowPadding);

                    var hideScrollbarWidth = 100;
                    gradebook.lockedBody.width(lockedTableWidth + hideScrollbarWidth);
                },
                updateTeacherSectionSetting: function (event, extraParameters)
                {
                    var data = gradebookBrowse.data();
                    var action = "UpdateCollapsedLockedColumnState";
                    if (data.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }
                    data.hidden = extraParameters.collapse;
                    data.fieldToSet = extraParameters.fieldToSet
                    $.ajax({
                        activityIndicator: { silent: true },
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        data: data
                    });
                },
                loadGradebookLayers: function (options)
                {
                    var action = "GetGradebookLayers";
                    var data = gradebookBrowse.data();
                    if (data.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }

                    $.each(data.layers, function (k, v)
                    {
                        var layerData =
                        {
                            layer: k,
                            layerPostData: JSON.stringify(v)
                        };

                        $.extend(layerData, data);

                        if (layerData.layer == "UpdateStaffMeet" && (!options || !options.requiresStaffMeetUpdate))
                        {
                            return false;
                        }

                        var ajax = $.ajax(
                            {
                                url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                                type: "POST",
                                dataType: "JSON",
                                data: layerData,
                                activityIndicator: { silent: true },
                                success: function (returnData)
                                {
                                    if (returnData.returnData)
                                    {
                                        gradebook.insertGradebookLayersIntoDOM(returnData.returnData);
                                    }
                                }
                            });
                    });
                },
                insertGradebookLayersIntoDOM: function (returnData)
                {
                    $.each(returnData, function (k, v)
                    {
                        //If more layer types are added make sure that you handle the fact that data might already be on the screen and do not duplicate it
                        if (k == "AssignmentAttendanceIndicator")
                        {
                            var attendanceHeaderCell = gradebookBrowse.find(".todaysAttendance");
                            var attendanceHeaderCellData;

                            if (attendanceHeaderCell.length > 0)
                            {
                                attendanceHeaderCellData = attendanceHeaderCell.data();
                            }

                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, dateList)
                                {
                                    for (var i = 0; i < dateList.length; i++)
                                    {
                                        var assignmentData = dateList[i];
                                        var date = assignmentData.Date;
                                        var showOnGradesheetAssignments = assignmentData.ShowOnGradesheetAssignments;

                                        if (v.PostData.DisplayAssignmentAttendanceIndicator && showOnGradesheetAssignments)
                                        {
                                            //Add indicator to all appropriate student assignment cells
                                            gradebookBrowse.find(".assignmentNameSpan:contains('" + date + "')").each(function ()
                                            {
                                                var assignmentID = $(this).parents(".assignmentHeaderCell").data().assignmentid;

                                                var studentAssignmentCell = getAssignmentCellByField({ studentsectionid: studentSectionID, assignmentid: assignmentID }, "Score");

                                                if (studentAssignmentCell.find('.skipStudentAssignment').length == 0)
                                                {
                                                    var indicatorRow = studentAssignmentCell.find(".assignmentIndicatorButton > .assignmentIndicatorsFirstRow");

                                                    //If the icon has already been added then we don't need to do anything
                                                    var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.AttendanceTypeIndicator));

                                                    if (indicatorRow.find(iconClassSelector).length < 1)
                                                    {
                                                        indicatorRow.append(v.HTMLToInject.AttendanceTypeIndicator);
                                                        indicatorRow.removeClass("hiddenAttendanceType");
                                                        updateStudentAssignmentButtonDisplay(studentAssignmentCell);
                                                    }
                                                }
                                            });
                                        }

                                        //Look for todays attendance column
                                        if (attendanceHeaderCell && attendanceHeaderCell.length > 0)
                                        {

                                            var todaysDate = attendanceHeaderCellData.date;
                                            if (todaysDate == date)
                                            {
                                                var unlockedRow = gradebook.unlockedBody.find("tr[data-student-section-id='" + studentSectionID + "']");
                                                if (unlockedRow.length > 0)
                                                {
                                                    var attendanceColumnDisplay = dateList[i].TypeCode + " - " + dateList[i].ReasonCode;

                                                    var lockedRow = gradebook.lockedBody.find("tr[data-row='" + unlockedRow.data().row + "']");
                                                    var todaysAttendanceCell = lockedRow.find("td[data-column='" + attendanceHeaderCellData.column + "']");
                                                    todaysAttendanceCell.find("div").html(attendanceColumnDisplay);
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        }
                        else if (k == "AssignmentMultipleAttemptsIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, studentAssignmentID)
                                {
                                    if (v.PostData.DisplayAssignmentMultipleAttemptsIndicator)
                                    {
                                        //Add indicator to all appropriate student assignment cells
                                        gradebookBrowse.find("input.hasAttempts[data-studentassignmentid='" + studentAssignmentID + "']").each(function ()
                                        {
                                            var studentAssignmentInput = $(this);
                                            var studentAssignmentCell = studentAssignmentInput.parents('.assignmentCell');
                                            var indicatorRow = studentAssignmentCell.find(".assignmentIndicatorButton > .assignmentIndicatorsFirstRow");

                                            //If the icon has already been added then we don't need to do anything
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.MultipleAttemptsIndicator));

                                            if (indicatorRow.find(iconClassSelector).length < 1)
                                            {
                                                indicatorRow.prepend(v.HTMLToInject.MultipleAttemptsIndicator);
                                                indicatorRow.removeClass("hiddenMultipleAttempts");
                                                updateStudentAssignmentButtonDisplay(studentAssignmentCell);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        else if (k == "StudentGradingPeriodCommentIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, gradingPeriodList)
                                {
                                    for (var i = 0; i < gradingPeriodList.length; i++)
                                    {
                                        var gradingPeriodID = gradingPeriodList[i];

                                        gradebookBrowse.find("tr.gradesheetBrowseRow[data-student-section-id='" + studentSectionID + "'] td.gradeBucketCell[data-grading-period-id='" + gradingPeriodID + "']").each(function ()
                                        {
                                            var cell = $(this);
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.CommentIndicator).find("svg"));

                                            if (cell.find(iconClassSelector).length < 1)
                                            {
                                                cell.find(".studentGradeBucketIndicators").removeClass('hiddenComments').append(v.HTMLToInject.CommentIndicator);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        else if (k == "SubjectGradeBucketCommentIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, calculationGroupSubjectGradeBuckets)
                                {
                                    for (var i = 0; i < calculationGroupSubjectGradeBuckets.length; i++)
                                    {
                                        var calculationGroupSubjectGradeBucketID = calculationGroupSubjectGradeBuckets[i];

                                        gradebookBrowse.find("tr.gradesheetBrowseRow[data-student-section-id='" + studentSectionID + "'] td.subjectCell[data-calculation-group-subject-grade-bucket-id='" + calculationGroupSubjectGradeBucketID + "']").each(function ()
                                        {
                                            var cell = $(this);
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.SubjectCommentIndicator).find("svg"));

                                            if (cell.find(iconClassSelector).length < 1)
                                            {
                                                cell.find(".studentGradeBucketIndicators").removeClass('hiddenComments').append(v.HTMLToInject.SubjectCommentIndicator);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        else if (k == "AcademicStandardGradeBucketCommentIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, calculationGroupAcademicStandardGradeBuckets)
                                {
                                    for (var i = 0; i < calculationGroupAcademicStandardGradeBuckets.length; i++)
                                    {
                                        var calculationGroupAcademicStandardGradeBucketID = calculationGroupAcademicStandardGradeBuckets[i];

                                        gradebookBrowse.find("tr.gradesheetBrowseRow[data-student-section-id='" + studentSectionID + "'] td.academicStandardCell[data-calculation-group-academic-standard-grade-bucket-id='" + calculationGroupAcademicStandardGradeBucketID + "']").each(function ()
                                        {
                                            var cell = $(this);
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.AcademicStandardCommentIndicator).find("svg"));

                                            if (cell.find(iconClassSelector).length < 1)
                                            {
                                                cell.find(".studentGradeBucketIndicators").removeClass('hiddenComments').append(v.HTMLToInject.AcademicStandardCommentIndicator);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        else if (k == "WarningIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, gradingPeriodGradeBucketIDs)
                                {
                                    $.each(gradingPeriodGradeBucketIDs, function (gradingPeriodGradeBucketID, value)
                                    {
                                        gradebookBrowse.find("tr.gradesheetBrowseRow[data-student-section-id='" + studentSectionID + "'] td.gradeBucketCell[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']").each(function ()
                                        {
                                            var cell = $(this);
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.WarningIndicator).find("svg"));

                                            if (cell.find(iconClassSelector).length < 1)
                                            {
                                                if (value === true)
                                                {
                                                    cell.find(".studentGradeBucketIndicators").removeClass('hiddenWarning').append(v.HTMLToInject.WarningIndicator);
                                                }
                                                else
                                                {
                                                    cell.find(".studentGradeBucketIndicators").addClass('hiddenWarning').append(v.HTMLToInject.WarningIndicator);
                                                }
                                            }
                                        });
                                    });
                                });
                            }
                        }
                    });

                    gradebook.resize();
                },
                getSectionData: function (cell)
                {
                    var row = cell.parents("tr").first();
                    var rowData;

                    if (row.parents("div").first().hasClass('lockedBrowseBody'))
                    {
                        var rowNumber = row.data().row;
                        var unlockedRowData = $('#Gradebook_unlockedRow' + rowNumber).data();
                        return { sectionID: unlockedRowData.sectionId, sectionIDHash: unlockedRowData.sectionIdHash };
                    }
                    else
                    {
                        rowData = row.data();
                        return { sectionID: rowData.sectionId, sectionIDHash: rowData.sectionIdHash };
                    }
                },
                getRepresentedAssignmentID: function (assignmentId, sectionId)
                {
                    var headerCell = $("#assignment" + assignmentId + "HeaderCell");
                    var headerCellData = headerCell.data();
                    if (headerCellData && headerCellData.representedAssignmentIds && headerCellData.representedAssignmentIds[sectionId])
                    {
                        return headerCellData.representedAssignmentIds[sectionId];
                    }

                    return null;
                },
                //When we are showing a class group and an assignment is in all sections,
                //we render 1 assignment column that might represent 4 assignments across 4 sections.
                //The gradebook has a 'driver' assignment with a data attribute to show all the assignments it represents.
                //This function takes a passed in assignmentID and checks if its on the gradesheet, and if not, finds the assignment for the driver section that represents it
                getEffectiveAssignmentID: function (assignmentID, studentSectionID, sectionID, gradingPeriodGradeBucketID)
                {
                    var effectiveAssignmentID = assignmentID;

                    var studentAssignmentCell = $("#Gradebook_" + studentSectionID + "_" + assignmentID + "_Score");

                    if (studentAssignmentCell == null || studentAssignmentCell.length == 0)
                    {
                        gradebook.unlockedHeader.find(".assignmentHeaderCell.js_gradingPeriodGradeBucketID" + gradingPeriodGradeBucketID).each(function ()
                        {
                            var assignmentHeaderCell = $(this);
                            var assignmentHeaderCellData = assignmentHeaderCell.data();

                            if (assignmentHeaderCellData && assignmentHeaderCellData.representedAssignmentIds && assignmentHeaderCellData.representedAssignmentIds[sectionID] == assignmentID)
                            {
                                effectiveAssignmentID = assignmentHeaderCellData.assignmentid;
                                studentAssignmentCell = $("#Gradebook_" + studentSectionID + "_" + effectiveAssignmentID + "_Score");
                            }
                        });
                    }

                    return effectiveAssignmentID;

                },
                loadCellContents: function (button, cellData, loadSettings, expandAnimationPromise)
                {
                    var loadContentsPromise = new $.Deferred();

                    button.find("svg").hide();
                    gradebook.showLoadingIconInContainer(button);

                    var action = "FetchGradebookCells";
                    var data = gradebookBrowse.data();
                    if (data.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }

                    var requiredData = getRequiredGradebookData();
                    $.extend(requiredData, data);
                    $.extend(requiredData, cellData);

                    var columnExpanded = button.parents("td");
                    var columnNumberExpanded = columnExpanded.data().column;
                    var nextColumnIndex = (parseInt(columnNumberExpanded) + 1);
                    requiredData.startingColumnIndex = nextColumnIndex;
                    requiredData.hasAdditionalColumnsAfterThis = columnExpanded.next("td").length > 0;

                    var expandedColumnInUnlockedHeaderRow = gradebook.unlockedRowHeader.find("td[data-column='" + columnNumberExpanded + "']");
                    var nextColumnInUnlockedHeaderRow = expandedColumnInUnlockedHeaderRow.nextAll("td:visible").first();

                    if (requiredData['objectType'] == 'Assignment')
                    {
                        $.extend(requiredData, { 'representedAssignmentIds': JSON.stringify(expandedColumnInUnlockedHeaderRow.data('representedAssignmentIds')) });
                    }

                    var cellTypeClass = expandedColumnInUnlockedHeaderRow.hasClass("gradeBucketHeaderCell")
                        ? "gradeBucketHeaderCell"
                        : expandedColumnInUnlockedHeaderRow.hasClass("subjectHeaderColumn")
                            ? "subjectHeaderColumn"
                            : expandedColumnInUnlockedHeaderRow.hasClass("academicStandardHeaderCell")
                                ? "academicStandardHeaderCell"
                                : "assignmentHeaderCell";

                    var columnLevel = expandedColumnInUnlockedHeaderRow.find("div.gradebookTertiaryContainer").last().data("level");

                    if (columnLevel == null)
                    {
                        columnLevel = expandedColumnInUnlockedHeaderRow.find("div.gradebookSecondaryContainer").last().data("level");
                    }

                    requiredData.hasSiblingNextAtLevel = {};
                    requiredData.hasSiblingNextAtLevel[0] = expandedColumnInUnlockedHeaderRow.next("td").data("subjectId") == expandedColumnInUnlockedHeaderRow.data("subjectId"); //has same subject
                    for (var i = 1; i <= columnLevel; i++)
                    {
                        var nextColumnLevel = expandedColumnInUnlockedHeaderRow.next("td." + cellTypeClass).find("div.gradebookTertiaryContainer").last().data("level");
                        if (nextColumnLevel == null)
                        {
                            nextColumnLevel = expandedColumnInUnlockedHeaderRow.find("div.gradebookSecondaryContainer").last().data("level");
                        }
                        if (i < nextColumnLevel)
                        {
                            requiredData.hasSiblingNextAtLevel[i] = true;
                        }
                        else
                        {
                            requiredData.hasSiblingNextAtLevel[i] = false;
                        }
                    }
                    requiredData.hasSiblingNextAtLevel = JSON.stringify(requiredData.hasSiblingNextAtLevel);

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                            type: "POST",
                            dataType: "JSON",
                            data: requiredData,
                            activityIndicator: { silent: true },
                            error: function ()
                            {
                                loadContentsPromise.resolve();
                            },
                            success: async function (returnData)
                            {
                                if (returnData.success == false && returnData.popupHTML)
                                {
                                    checkAjaxResponseForErrors(returnData);
                                    loadContentsPromise.resolve();
                                }
                                else
                                {
                                    var rows = JSON.parse(returnData.jsonGradebookRows);
                                    await Promise.all(rows.map(async rowJSON =>
                                    {
                                        if (rowJSON != null)
                                        {
                                            rowJSON.JSONGradebookColumns = await skyward.global.processViewPartHtml(rowJSON.JSONGradebookColumns);
                                        }
                                    }));
                                    $.when(expandAnimationPromise).done(function ()
                                    {
                                        var promises = [];

                                        $.each(rows, function ()
                                        {
                                            var rowPromise = new $.Deferred();
                                            var rowJSON = this;

                                            var rowElement;
                                            switch (rowJSON.RowType)
                                            {
                                                case 'Header':
                                                    rowElement = gradebook.unlockedRowHeader;
                                                    break;
                                                case 'HeaderSpacer':
                                                    rowElement = gradebook.unlockedRowSpacerHeader;
                                                    break;
                                                case 'Average':
                                                    rowElement = gradebook.unlockedAveragesRowHeader;
                                                    break;
                                                default:
                                                    rowElement = gradebook.unlockedBody.find("tr.gradesheetBrowseRow[data-student-section-id='" + rowJSON.StudentSectionID + "']");
                                            }

                                            if (rowElement.length > 0)
                                            {
                                                var columnToInsertAfter = rowElement.find("td[data-column='" + columnNumberExpanded + "']:not('hidden')");
                                                var offset = rowJSON.ColumnOffset;

                                                $.each($(rowJSON.JSONGradebookColumns), function ()
                                                {
                                                    var gradebookColumn = $(this);

                                                    if (gradebookColumn != null)
                                                    {
                                                        var columnToInsert = gradebookColumn;
                                                        gradebookColumn.find('.studentAssignmentScoreInput').addClass('js-maskInitialized');
                                                        if (loadSettings && loadSettings.defaultCollapsed == true)
                                                        {
                                                            columnToInsert.addClass(COLLAPSED_CLASS_NAME);
                                                        }

                                                        columnToInsert.insertAfter(columnToInsertAfter);
                                                        columnToInsertAfter = columnToInsert;
                                                    }
                                                });

                                                if (columnToInsertAfter.nextAll("td").length > 0)
                                                {
                                                    $.each(columnToInsertAfter.nextAll("td"), function ()
                                                    {
                                                        var affectedColumn = $(this);

                                                        if (affectedColumn && affectedColumn.length > 0)
                                                        {
                                                            var columnNumber = affectedColumn.data().column;

                                                            if (columnNumber)
                                                            {
                                                                var newColumnNumber = parseInt(affectedColumn.data().column) + offset;
                                                                affectedColumn.data("column", newColumnNumber);
                                                                affectedColumn.attr("data-column", newColumnNumber);
                                                            }
                                                        }
                                                    });

                                                    rowPromise.resolve();
                                                }
                                                else
                                                {
                                                    rowPromise.resolve();
                                                }
                                                promises.push(rowPromise);
                                            }
                                        });

                                        if (!loadSettings || !loadSettings.defaultCollapsed)
                                        {
                                            gradebook.expandChildrenCells(loadSettings, button, nextColumnInUnlockedHeaderRow);
                                        }

                                        $.when.apply($, promises).then(function ()
                                        {
                                            gradebook.updateScoringModeControls();
                                            if (gradebook.editMode)
                                            {
                                                var buttonText = gradebook.editButton.find('.textAfter');
                                                enterScoringMode(buttonText);
                                            }

                                            var setFocusOnInput = true;
                                            if (loadSettings != null && loadSettings.setFocusOnInput != null)
                                            {
                                                setFocusOnInput = loadSettings.setFocusOnInput
                                            }
                                            if (setFocusOnInput && gradebook.currentCell && gradebook.currentRow != null)
                                            {
                                                gradebook.updateCurrentCellInRow(columnNumberExpanded);
                                            }
                                            loadContentsPromise.resolve();
                                        });
                                    });
                                }
                            }
                        });

                    return loadContentsPromise.promise();
                },
                resetCellBackgroundColor: function (cell)
                {
                    var cellData = cell.data();

                    if (cellData)
                    {
                        cell.css({ backgroundColor: cellData.backgroundColor, color: cellData.color });
                    }
                },
                hasBackgroundColorOverride: function (cell)
                {
                    return cell.hasClass("updatedWithErrors") || cell.hasClass('hasErrors') || cell.hasClass("gradeBucketGradeChangeNotReviewedOrInProgress") || cell.hasClass("gradeBucketGradeChangeDenied");
                },
                toggleBucketDisplay: function (event)
                {
                    var bucket = $(this);
                    gradebook.toggleChildrenCellDisplay(bucket, { allowDuplicates: false });

                    event.preventDefault();
                    event.stopPropagation();
                },
                toggleSubjectDisplay: function (event)
                {
                    var subjectBucket = $(this);
                    gradebook.toggleChildrenCellDisplay(subjectBucket, { allowDuplicates: false });

                    event.preventDefault();
                    event.stopPropagation();
                },
                toggleAcademicStandardDisplay: function (event)
                {
                    var standardBucket = $(this);
                    gradebook.toggleChildrenCellDisplay(standardBucket, { allowDuplicates: false });
                    event.preventDefault();
                    event.stopPropagation();
                },
                toggleAssignmentDisplay: function (event)
                {
                    var assignmentCell = $(this);
                    gradebook.toggleChildrenCellDisplay(assignmentCell, { allowDuplicates: true });
                    event.preventDefault();
                    event.stopPropagation();
                },
                toggleChildrenCellDisplay: function (button, loadSettings)
                {
                    var toggleDisplayDeferred;

                    if (loadSettings && loadSettings.toggleDisplayDeferred)
                    {
                        toggleDisplayDeferred = loadSettings.toggleDisplayDeferred;
                    }
                    else
                    {
                        toggleDisplayDeferred = new $.Deferred();
                        loadSettings.toggleDisplayDeferred = toggleDisplayDeferred;
                    }

                    if (!gradebook.isGradebookFullyLoaded())
                    {
                        gradebook.queueFunctionToCallOnCompletionOfLoad(gradebook.toggleChildrenCellDisplay, null, { allowDuplicates: loadSettings.allowDuplicates }, [button, loadSettings]);
                        return toggleDisplayDeferred.promise();
                    }

                    gradebook.gradebookFullyLoadedPromise = new $.Deferred();

                    var data = button.data();
                    var collapsed = button.hasClass(COLLAPSED_CLASS_NAME);
                    //update teacher section setting objects
                    var action = "ToggleContainerDisplay";

                    data.collapsed = !collapsed;
                    data.teacherSectionSettingId = gradebookData.teacherSectionSettingId;

                    if (gradebookData.isTeacherTracker.toString().toLowerCase() == "true")
                    {
                        action += "TeacherTracker";
                    }

                    var animationResponseData =
                    {
                        animationPromise: new $.Deferred(),
                        requiresPostLoadScroll: false
                    };

                    if ((loadSettings && loadSettings.animate == false) || data.collapsed)
                    {
                        animationResponseData.animationPromise.resolve();
                    }
                    else
                    {
                        animationResponseData = gradebook.animateColumnExpand(button.parents("td").first(), loadSettings);
                    }

                    var updateDisplaySettingPromise = new $.Deferred();

                    if (data.objectType != 'Assignment')
                    {
                        updateDisplaySettingPromise = $.ajax(
                            {
                                url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                                type: "POST",
                                dataType: "JSON",
                                data: data,
                                activityIndicator: { silent: true },
                                success: function (returnData) {
                                }
                            });
                    }
                    else
                    {
                        updateDisplaySettingPromise.resolve();
                    }

                    $.when(updateDisplaySettingPromise).done(function ()
                        {
                            var myPromise = new $.Deferred();
                            var isLoaded = data.isLoaded; //make sure we set this when we come back with the columns
                            if (!isLoaded)
                            {
                                myPromise = gradebook.loadCellContents(button, data, loadSettings, animationResponseData.animationPromise);
                                button.data().isLoaded = true;
                            }
                            else
                            {
                                $.when(animationResponseData.animationPromise).done(function ()
                                {
                                    myPromise.resolve();
                                });
                            }

                            $.when(myPromise).done(function ()
                            {
                                gradebook.removeLoadingIconFromContainer(button);

                                if (collapsed)
                                {
                                    if (!loadSettings || !loadSettings.defaultCollapsed)
                                    {
                                        button.removeClass(COLLAPSED_CLASS_NAME);
                                        button.addClass(EXPANDED_CLASS_NAME);
                                        skyward.svg.swapSvg(button.find("svg"), "ChevronLeft", "GradebookHeader");
                                    }

                                    if (isLoaded)
                                    {
                                        var expandedColumnInUnlockedHeaderRow = gradebook.unlockedRowHeader.find("td[data-column='" + button.parents("td").data().column + "']");
                                        var nextColumnInUnlockedHeaderRow = expandedColumnInUnlockedHeaderRow.nextAll("td:visible").first();

                                        if (!loadSettings || !loadSettings.defaultCollapsed)
                                        {
                                            gradebook.expandChildrenCells(loadSettings, button, nextColumnInUnlockedHeaderRow);
                                        }
                                    }

                                }
                                else
                                {
                                    button.addClass(COLLAPSED_CLASS_NAME);
                                    button.removeClass(EXPANDED_CLASS_NAME);
                                    skyward.svg.swapSvg(button.find("svg"), "ChevronRight", "GradebookHeader");
                                    gradebook.collapseChildrenCells(button);
                                }

                                button.find("svg").show();

                                if (animationResponseData && animationResponseData.requiresPostLoadScroll)
                                {
                                    gradebook.animateColumnExpand(button.parents("td").first(), loadSettings, true);
                                }

                                gradebook.gradebookFullyLoadedPromise.resolve();
                                toggleDisplayDeferred.resolve();

                                if (!isLoaded)
                                {
                                    //Make sure that if we got new contents to take care of them
                                    gradebook.gradebookLoadComplete(button.parents("td"), true);
                                }
                                else
                                {
                                    //gradebook.gradebookLoadComplete handles resize
                                    gradebook.callQueuedFunctions();
                                    gradebook.resize();
                                }

                            });
                        });

                    return toggleDisplayDeferred.promise();
                },
                collapseChildrenCells: function (button)
                {
                    var data = button.data();
                    var parentContainerID = data.containerId;

                    var td = $("#" + parentContainerID);

                    $("." + parentContainerID).each(function ()
                    {
                        var cell = $(this);
                        var iconRowID = cell[0].id + "_icons";

                        if (cell.hasClass('subjectHeaderCell'))
                        {
                            var subjectButton = $("#" + iconRowID).find(".subjectExpander");
                            if (subjectButton.length > 0)
                            {
                                gradebook.collapseChildrenCells(subjectButton);
                            }
                        }

                        if (cell.hasClass('academicStandardHeaderCell'))
                        {
                            var standardButton = $("#" + iconRowID).find(".academicStandardExpander");
                            if (standardButton.length > 0)
                            {
                                gradebook.collapseChildrenCells(standardButton);
                            }
                        }

                        if (cell.hasClass('assignmentHeaderCell') && !cell.hasClass('advancedAssignmentCell'))
                        {
                            var assignmentButton = $("#assignmentHeaderCell" + cell.data().assignmentid + ".gradebookIconHeaderCell").find(".assignmentExpander");

                            if (assignmentButton.length)
                            {
                                gradebook.collapseChildrenCells(assignmentButton);

                                assignmentButton.addClass(COLLAPSED_CLASS_NAME);
                                assignmentButton.removeClass(EXPANDED_CLASS_NAME);
                                skyward.svg.swapSvg(assignmentButton.find("svg"), "ChevronRight", "GradebookHeader");
                            }
                        }

                        cell.addClass(COLLAPSED_CLASS_NAME);
                        cell.removeClass(EXPANDED_CLASS_NAME);
                    });

                    if (td.hasClass('subjectHeaderCell'))
                    {
                        updateRoundedCornerClassesOnCollapse(td);
                    }
                    else if (td.hasClass('academicStandardHeaderCell'))
                    {
                        var gradebookSecondaryContainer = td.find(".gradebookSecondaryContainer");

                        var nextVisibleTD = td.nextAll("td:visible").first();
                        if (!gradebook.nextCellHasSameParentAsMe(gradebookSecondaryContainer, nextVisibleTD))
                        {
                            updateRoundedCornerClassesOnCollapse(gradebookSecondaryContainer);
                        }

                        gradebookSecondaryContainer.find(".gradebookTertiaryContainer").each(function ()
                        {
                            var tertiaryDiv = $(this);
                            if (!gradebook.nextCellHasSameParentAsMe(tertiaryDiv, nextVisibleTD))
                            {
                                updateRoundedCornerClassesOnCollapse(tertiaryDiv);
                            }
                        });

                        var classes = td.attr("class").split(' ');
                        var childIndentifierClass = null;

                        $.each(classes, function (k, v)
                        {
                            if (v.indexOf("gpgb") == 0)
                            {
                                childIndentifierClass = v;
                            }
                        });

                        if (td.nextAll("." + childIndentifierClass).length < 1)
                        {
                            var nextCellData = td.nextAll("td:visible").first().data();

                            if (!nextCellData || nextCellData.subjectId != td.data().subjectId)
                            {
                                updateRoundedCornerClassesOnCollapse(td);
                            }
                        }
                    }
                    else if (td.hasClass('assignmentHeaderCell'))
                    {
                        td.find(".assignmentHeaderDataContainer").removeClass("advancedAssignmentExpanded");
                        getAverageScoreContent(td.data().assignmentid).attr('colspan', 1);
                        updateAssignmentHeaderCellExpandClasses(td.data().assignmentid, false); //todo: this is too slow for some reason. Fix it
                        setAssignmentHeaderCellToDefaultColors(td.data().assignmentid);
                    }
                },
                expandChildrenCells: function (loadSettings, button, nextVisibleTDBeforeChildLoad, isFromRecursive)
                {
                    isFromRecursive = isFromRecursive ? isFromRecursive : false;

                    var data = button.data();
                    var parentContainerID = data.containerId;
                    var td = $('#' + parentContainerID + ":not(" + gradebook.getClassesToPreventCollapseExpand() + ")");
                    var nextVisibleTD = nextVisibleTDBeforeChildLoad == null ? td.nextAll("td:visible").first() : nextVisibleTDBeforeChildLoad;
                    var nextVisibleTDData = nextVisibleTD ? nextVisibleTD.data() : null;

                    if (td.hasClass('subjectHeaderCell'))
                    {
                        updateRoundedCornerClassesOnExpand(td);
                    }
                    else if (td.hasClass('academicStandardHeaderCell'))
                    {
                        var gradebookSecondaryContainer = td.find(".gradebookSecondaryContainer");

                        gradebookSecondaryContainer.find(".gradebookTertiaryContainer").each(function ()
                        {
                            var tertiaryDiv = $(this);
                            if (!gradebook.nextCellHasSameParentAsMe(tertiaryDiv, nextVisibleTD))
                            {
                                updateRoundedCornerClassesOnExpand(tertiaryDiv);
                            }
                        });

                        if (!gradebook.nextCellHasSameParentAsMe(gradebookSecondaryContainer, nextVisibleTD))
                        {
                            updateRoundedCornerClassesOnExpand(gradebookSecondaryContainer);
                        }

                        if (!nextVisibleTDData || nextVisibleTDData.subjectId != td.data().subjectId)
                        {
                            updateRoundedCornerClassesOnExpand(td);
                        }
                    }
                    else if (td.hasClass('assignmentHeaderCell'))
                    {
                        td.find(".assignmentHeaderDataContainer").addClass("advancedAssignmentExpanded");
                        var advancedAssignmentHeaderCells = $('.advancedAssignmentCell' + td.data().assignmentid + '.assignmentHeaderCell');
                        updateAssignmentHeaderCellExpandClasses(td.data().assignmentid, true);
                        getAverageScoreContent(td.data().assignmentid).attr('colspan', advancedAssignmentHeaderCells.length + 1);
                    }

                    $("." + COLLAPSED_CLASS_NAME + "." + parentContainerID).each(function ()
                    {
                        var cell = $(this);
                        var iconRowID = cell[0].id + "_icons";

                        if (cell.hasClass('subjectHeaderCell'))
                        {
                            var subjectButton = $("#" + iconRowID).find(".subjectExpander");
                            if (subjectButton.length > 0 && subjectButton.hasClass(EXPANDED_CLASS_NAME))
                            {
                                gradebook.expandChildrenCells(loadSettings, subjectButton, null, true);
                            }
                        }

                        if (cell.hasClass('academicStandardHeaderCell'))
                        {
                            var standardButton = $("#" + iconRowID).find(".academicStandardExpander");
                            if (standardButton.length > 0 && standardButton.hasClass(EXPANDED_CLASS_NAME))
                            {
                                gradebook.expandChildrenCells(loadSettings, standardButton, null, true);
                            }
                        }

                        cell.removeClass(COLLAPSED_CLASS_NAME);
                        cell.addClass(EXPANDED_CLASS_NAME);
                    });
                },
                nextCellHasSameParentAsMe: function (divToCheck, nextVisibleTD)
                {
                    var childDiv = divToCheck.find(".gradebookTertiaryContainer").first();
                    var childLevelData = childDiv && childDiv.length ? childDiv.data() : {};

                    var nextTDAtLevelData = nextVisibleTD.find(".gradebookTertiaryContainer[data-level='" + childLevelData.level + "']").data();

                    if (!nextTDAtLevelData || childLevelData.parentAcademicStandardId != nextTDAtLevelData.parentAcademicStandardId)
                    {
                        return false;
                    }

                    return true;
                },
                gradebookFullyLoadedPromise: new $.Deferred(),
                isGradebookFullyLoaded: function ()
                {
                    return gradebook.gradebookFullyLoadedPromise.state() == "resolved";
                },
                functionsToCallOnCompletionOfLoad: [],
                queueFunctionToCallOnCompletionOfLoad: function (func, thisElement, settings, args)
                {
                    var newFuncToTrigger =
                    {
                        key: func.name,
                        func: func,
                        element: thisElement,
                        args: args
                    };

                    var existingFunctionLocation = -1;

                    for (var i = 0; i < gradebook.functionsToCallOnCompletionOfLoad.length; i++)
                    {
                        if (gradebook.functionsToCallOnCompletionOfLoad[i].key === newFuncToTrigger.key)
                        {
                            existingFunctionLocation = i;
                        }
                    }

                    var allowDuplicates = settings && settings.allowDuplicates;
                    if (existingFunctionLocation > -1 && !allowDuplicates)
                    {
                        //We probably don't want to queue up the same function multiple times. If we do we will need to change this...maybe add a param to skip this part and always push
                        //For now I think this should be good
                        gradebook.functionsToCallOnCompletionOfLoad[existingFunctionLocation] = newFuncToTrigger;
                    }
                    else
                    {
                        gradebook.functionsToCallOnCompletionOfLoad.push(newFuncToTrigger);
                    }
                },
                addColumnResizeEvents: function ()
                {
                    var resizeDivs = [];
                    gradebook.browse.find(".tdResizeDiv").each(function ()
                    {
                        var element = $(this);
                        var parentTD = element.parents("td").first();
                        var lockedBrowse = element.parents(".lockedHeader").first().length > 0;
                        var parentData = parentTD.data();
                        var columnIndex = parentData.column;
                        var minWidth = parentData.minWidth;
                        if (minWidth == null)
                        {
                            minWidth = RESIZE_COLUMN_MIN_WIDTH;
                        }
                        var resizable = // See jQuery Resizable API documentation for more info
                        {
                            minWidth: minWidth, //todo elementdata has minWidth then that otherwise resize column
                            maxWidth: RESIZE_COLUMN_MAX_WIDTH,
                            alsoResize: gradebook.getColumnsToResize(columnIndex, lockedBrowse),
                            handles: "e"
                        };

                        if (lockedBrowse) //element.hasClass("locked"))
                        {
                            resizable.resize = function (_event, ui)
                            {
                                gradebook.applyResizeOnResize(columnIndex, ui.size.width, true);
                                _event.stopPropagation();
                            };
                            resizable.stop = function (_event, ui)
                            {
                                gradebook.applyResizeOnResize(columnIndex, ui.size.width, true);
                                gradebook.applyResizeOnStop(columnIndex, ui.size.width, true);
                            };
                        }
                        else
                        {
                            resizable.resize = function (_event, ui)
                            {
                                gradebook.setDisplayStudentGradeBucketIndicators(columnIndex, ui.size.width);
                                gradebook.applyResizeOnResize(columnIndex, ui.size.width, false);
                                _event.stopPropagation();
                                _event.preventDefault();
                            };
                            resizable.stop = function (_event, ui)
                            {
                                gradebook.applyResizeOnResize(columnIndex, ui.size.width, true);
                                gradebook.applyResizeOnStop(columnIndex, ui.size.width, false);
                                parentTD.addClass(PREVENT_CLICK_CLASS_NAME);
                                let removePreventClickClass = function () { $(this).removeClass(PREVENT_CLICK_CLASS_NAME) }.bind(parentTD);
                                setTimeout(() => { removePreventClickClass() }, 200);
                                _event.preventDefault();
                            };
                        }
                        resizeDivs.push({ element: element, resizable: resizable });
                    });

                    for (var index = 0; index < resizeDivs.length; index++)
                    {
                        var item = resizeDivs[index];
                        item.element.resizable(item.resizable);
                    }
                },
                gradebookLoadComplete: function (scope, requiresNotifyDOMLoad, options) //scope will be null on normal gradebook load. On an expand of a column it will be the element that was expanded. No implementation yet but that should probably happen at some point
                {
                    gradebook.setStudents();

                    loadAverages(); //todo: Implement scope someday
                    gradebook.loadGradebookLayers(options); //todo: Implement scope someday

                    if (options && options.requireMissingCountLoad)
                    {
                        loadAssignmentCounts();
                    }

                    gradebook.callQueuedFunctions();

                    if (requiresNotifyDOMLoad)
                    {
                        //Gradebook_controls will need to be called manually
                        skyward.window.notifyDOMLoad("#Gradebook_header");
                        skyward.window.notifyDOMLoad("#Gradebook_body");
                    }

                    //Columns might have been added, re highlight the selected row to get em all
                    if (gradebook.currentRow != null)
                    {
                        var gbData = getRequiredGradebookData();
                        var animateScroll = false;
                        if (gbData.highlightedStudentSectionId != null)
                        {
                            animateScroll = true;
                        }
                        setCurrentRecord(gradebook.currentRow, gradebook.currentCell, animateScroll);
                    }

                    var data = getRequiredGradebookData();

                    //Reset row chunking values to defaults
                    data.currentPage = 0;
                    data.totalRowsRendered = null;
                    data.rowsToFetch = 25;

                    gradebook.addColumnResizeEvents();
                    gradebook.resize();
                },
                callQueuedFunctions: function ()
                {
                    var queue = gradebook.functionsToCallOnCompletionOfLoad;

                    var processNextElementInQueue = function (queue)
                    {
                        var queueElement = queue.shift();

                        $.when(queueElement.func.apply(queueElement.element, queueElement.args)).done(function ()
                        {
                            if (queue.length > 0)
                            {
                                processNextElementInQueue(queue);
                            }
                        });
                    };

                    if (queue.length > 0)
                    {
                        processNextElementInQueue(queue);
                    }

                    gradebook.functionsToCallOnCompletionOfLoad = [];
                },
                fetchGradebookRows: function (currentPage, defaultRowsToFetch)
                {
                    var data = getRequiredGradebookData();

                    var getChunk = function (currentPage, rowsToFetch, totalRowsRendered)
                    {
                        data.rowsToFetch = rowsToFetch;
                        data.currentPage = currentPage;
                        data.totalRowsRendered = totalRowsRendered;

                        var action = "FetchGradebookRows";

                        if (data.isTeacherTracker)
                        {
                            action += "TeacherTracker";
                        }

                        $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                            type: "POST",
                            dataType: "viewparthtml",
                            data: data,
                            activityIndicator: { silent: true },
                            success: function (returnData)
                            {
                                var html = $(returnData);

                                if (html.hasClass("gradebookException"))
                                {
                                    gradebook.displayException(html);
                                    gradebook.gradebookFullyLoadedPromise.resolve();
                                    return gradebook.gradebookFullyLoadedPromise.promise();
                                }

                                var browseHtml = $(html[0]);
                                let relatedHashesScript = null;
                                if ($(html).length >= 2 &&
                                    $(html[1]).attr("id") != null &&
                                    $(html[1]).attr("id").indexOf("relatedHashes_") > -1)
                                {
                                    //RequestDataHashRegistry.ScriptId ever changes to not start with relatedHashes this will need to update.
                                    relatedHashesScript = $(html[1]);
                                }
                                var unlockedRows = browseHtml.find("tr.gradesheetBrowseRow:not(.locked)");
                                var lockedRows = browseHtml.find("tr.gradesheetBrowseRow.locked");

                                for (var i = 0; i < lockedRows.length; i++)
                                {
                                    gradebook.unlockedBody.find("table").append($(unlockedRows[i]));
                                    var lockedRow = $(lockedRows[i]);
                                    gradebook.lockedBody.find("table").append(lockedRow);

                                    if (lockedRow.hasClass("current"))
                                    {
                                        setCurrentRecord(lockedRow.data().row, null, false, true);
                                    }
                                }

                                if (relatedHashesScript != null)
                                {
                                    gradebook.browse.after(relatedHashesScript);
                                }

                                currentPage++;

                                var rowsSkipped = html.data()?.rowsskipped; //TODO: Remove with the stream dream..STREAM DREAM! STREAM DREAM!
                                if (rowsSkipped == null || rowsSkipped == "")
                                {
                                    rowsSkipped = 0;
                                }

                                if (gradebookData.rowsskipped)
                                {
                                    gradebookData.rowsskipped += rowsSkipped;
                                }

                                gradebook.updateScoringModeControls();

                                if (gradebook.editMode)
                                {
                                    var buttonText = gradebook.editButton.find('.textAfter');
                                    enterScoringMode(buttonText);
                                }

                                if ((lockedRows.length + rowsSkipped) < defaultRowsToFetch)
                                {
                                    gradebook.gradebookFullyLoadedPromise.resolve();
                                    return gradebook.gradebookFullyLoadedPromise.promise();
                                }

                                getChunk(currentPage, rowsToFetch, gradebook.lockedBodyTable.find('.browseRow').length);
                            }
                        });
                    };

                    if (!currentPage || currentPage <= 0)
                    {
                        gradebook.lockedBody.empty();
                        gradebook.unlockedBody.empty();
                    }

                    getChunk(currentPage, defaultRowsToFetch, gradebook.lockedBodyTable.find('.browseRow').length);
                },
                displayException: function (html)
                {
                    gradebook.browse.html(html);
                },
                updateScoringModeControls: function ()
                {
                    gradebook.scoringModeControls = gradebook.browse.find(scoringModeControlsSelector);
                    gradebook.gradebookBodyScoringModeControls = gradebook.scoringModeControls.not(scoringModeBodyFilter);
                    gradebook.rowCount = gradebook.unlockedBody.find("table > tbody> tr").length + (gradebookData.rowsskipped == null || gradebookData.rowsskipped == '' ? 0 : gradebookData.rowsskipped);
                    gradebook.studentAssignmentInputs = gradebook.browse.find('.gradebookInput.gradebookScoringModeControl.studentAssignment');
                    gradebook.studentAssignmentGradeMarkInputs = gradebook.browse.find('.gradebookScoringModeControl.studentAssignment.gradeMarkScoring.gradebookInputCodeEEL');
                },
                removeDefaultKeyEvents: function ()
                {
                    gradebook.body.find('.codeEEL').off('keydown');
                },
                displayStudentGroupInfo: function ()
                {
                    var container = $(this);
                    var data = container.data();
                    var html = gradebook.getStudentGroupInfo.apply(container);
                    var anchorTo = container.find(".studentGroupColorStrip").first();

                    if (anchorTo.length == 0)
                    {
                        anchorTo = container;
                    }

                    var options =
                    {
                        anchorTo: anchorTo
                    };

                    var title = data.title
                        ? data.title
                        : "Student Group Filter";

                    skyward.modalLayer.showDialog(title, html, { text: "Close", icon: "Close" }, options);
                },
                getStudentGroupInfo: function ()
                {
                    var container = $(this);

                    var data = container.data();

                    var html = "";

                    var parent;

                    if (container.hasClass("studentGroupColorStrips"))
                    {
                        parent = container;
                    }
                    else
                    {
                        parent = container.parents(".studentGroupColorStrips").first();
                    }

                    parent.find(".studentGroupColorStrip").each(function ()
                    {
                        var strip = $(this);
                        var stripData = strip.data();

                        var studentGroupDiv = "<div class='legendOptions'>";

                        var colorBlockDiv = '<div class="studentGroupColorStrip" style="background-color: ' + stripData.color + '"></div>';
                        var nameSpan = '<span style="padding-left: 5px">' + stripData.name + '</span>';

                        studentGroupDiv += colorBlockDiv;
                        studentGroupDiv += nameSpan;
                        studentGroupDiv += "</div>";

                        html += studentGroupDiv;
                    });

                    return html;

                },
                displayGradebookFilterInfo: function ()
                {
                    var container = $(this);

                    var data = container.data();

                    var hasStudentGroupFilter = data.hasStudentGroupFilter.toString().toLowerCase() == "true";
                    var hasFilteredStudent = data.hasFilteredStudent.toString().toLowerCase() == "true";

                    var html = "";

                    if (hasStudentGroupFilter)
                    {
                        html += gradebook.getStudentGroupInfo.apply(container);
                    }
                    if (hasFilteredStudent)
                    {
                        var studentNameCell = gradebook.lockedBody.find("tr .studentNameContainer.studentNameText, tr .studentNameContainer .studentNameTextAnchor .anchorText");
                        if (studentNameCell && studentNameCell.length > 0)
                        {
                            html += "Currently filtered to '" + studentNameCell.html() + "'.";
                        }
                        else
                        {
                            html += "Currently filtered to a specific student.";
                        }
                    }

                    var title = hasStudentGroupFilter && !hasFilteredStudent
                        ? "Student Group Filter"
                        : "Student Filter";

                    var options =
                    {
                        anchorTo: container
                    };

                    skyward.modalLayer.showDialog(title, html, { text: "Close", icon: "Close" }, options);
                    //if showing student groups, show that here. Also, if showing filtered student show that here as well.
                },
                enterTransferGrades: function ()
                {
                    var button = $(this);
                    var data = button.data();
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/EnterTransferGradesPopup",
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data: data,
                        success: function (returnData)
                        {
                            if (returnData.success == false && returnData.popupHTML)
                            {
                                checkAjaxResponseForErrors(returnData);
                            }
                            else
                            {
                                var buttons = [];
                                buttons.push({
                                    id: "saveStudentGradeBucketIndicatorPopup", text: "Save", click: function ()
                                    {
                                        var hideTransferRunIndicator = skyward.controls.getValue(dialog.content.find(".hideTransferGradeRunCheckbox"));
                                        $.ajax({
                                            url: skyward.global.virtualDir + "Gradebook/Gradebook/SaveStudentGradeBucketIndicators",
                                            type: "POST",
                                            dataType: "JSON",
                                            data:
                                            {
                                                StudentGradeBucketID: data.studentGradeBucketId,
                                                HideTransferIndicator: hideTransferRunIndicator
                                            },
                                            success: function (saveReturnData)
                                            {
                                                if (saveReturnData.success == false && saveReturnData.popupHTML)
                                                {
                                                    checkAjaxResponseForErrors(saveReturnData);
                                                }
                                                else if (hideTransferRunIndicator)
                                                {
                                                    button.find(".scoreDiv").removeClass("displayNone");
                                                    button.removeClass("needsTransferRunProcess");
                                                    button.find(".runTransferProcess").addClass("displayNone");
                                                    button.attr("data-click-action", button.data().originalClickAction);
                                                }
                                            }
                                        });
                                        dialog.close();
                                    }, icon: "Save"
                                });
                                buttons.push({ id: "closeStudentGradeBucketIndicatorPopup", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" });
                                var dialog = skyward.modalLayer.showDialog('Student Grade Information', returnData.htmlValue.Content, buttons, { anchorTo: button });
                            }
                        }
                    });
                },
                markInputScoreAsPending: function (input)
                {
                    if (!input.hasClass(PENDING_SCORE))
                    {
                        input.addClass(PENDING_SCORE);
                    }
                },
                completePendingInputScore: function (input)
                {
                    if (input.hasClass(PENDING_SCORE))
                    {
                        input.removeClass(PENDING_SCORE);
                    }
                },
                clearInputValueFromFailedSave: function (valuesToSaveArray)
                {
                    if (!Array.isArray(valuesToSaveArray))
                    {
                        valuesToSaveArray = [valuesToSaveArray];
                    }

                    $.each(valuesToSaveArray, function (valuesToSave)
                    {
                        var valuesToSave = this;
                        if (valuesToSave && valuesToSave.originalValues && valuesToSave.originalValues.Score)
                        {
                            var input;
                            if (valuesToSave.saveObject == "StudentGradeBucket")
                            {
                                input = $("#SubjectiveStudentGradeBucketGradeMark_" + valuesToSave.studentGradeBucketID);
                            }
                            else if (valuesToSave.saveObject == "StudentGradeBucketSubject")
                            {
                                input = $("#SubjectiveSubjectGradeMark_" + valuesToSave.studentGradeBucketSubjectID);
                            }
                            else if (valuesToSave.saveObject == "StudentGradeBucketAcademicStandard")
                            {
                                input = $("#SubjectiveAcademicStandardGradeMark_" + valuesToSave.studentGradeBucketAcademicStandardID);
                            }
                            if (input && input.length > 0)
                            {
                                skyward.gradebookcodeeel.setValue(input, valuesToSave.originalValues.Score.displayValue, valuesToSave.originalValues.Score.selectedValueID, true);
                                input.data("originalDisplayValue", valuesToSave.originalValues.Score.displayValue);
                                input.data("originalSelectedValueID", valuesToSave.originalValues.Score.selectedValueID);
                                input.data("originalValue", valuesToSave.originalValues.Score.displayValue);
                            }
                        }
                    });
                },
                getAssignmentScoreInput: function (assignmentID, studentSectionID)
                {
                    var input = $(".gradebookScoringModeControl.number.studentAssignment.assignment" + assignmentID + "[data-studentsectionid='" + studentSectionID + "'][data-fieldname='Score']");

                    if (input.length < 1)
                    {
                        input = $(".gradebookScoringModeControl.gradeMarkScoring.studentAssignment.assignment" + assignmentID + "[data-studentsectionid='" + studentSectionID + "'][data-fieldname='Score']");
                    }

                    return input;
                },
                getStudentGradeBucketCell: function (studentGradeBucketID)
                {
                    return gradebook.body.find("td.gradebookCell.gradeBucketCell[data-student-grade-bucket-id='" + studentGradeBucketID + "']");
                },
                updateCurrentCellInRow: function (newColumnNumber)
                {
                    var row = getRowElement("unlocked", gradebook.currentRow);
                    var newCurrentCell = row.find("td.gradebookCell[data-column='" + newColumnNumber + "']");
                    setCurrentCellElement(newCurrentCell);
                },
                getClassesToPreventCollapseExpand: function ()
                {
                    return ".lockedGradingPeriodGradeBucket";
                },
                animateColumnExpand: function (focusElement, loadSettings, forceScroll)
                {
                    var lockedTableElement = gradebook.lockedBodyTable;
                    var elementToScroll = gradebook.unlockedBody;

                    var lockedRight = lockedTableElement ? (lockedTableElement.width() + lockedTableElement.offset().left) : 0;
                    var elementLeft = (focusElement && focusElement.offset()) ? focusElement.offset().left : lockedRight;
                    var elementRight = elementLeft + (focusElement ? focusElement.width() : 0);
                    var amountToScroll = lockedRight - elementLeft;

                    elementToScroll.trigger('mouseover');

                    var animate = loadSettings && loadSettings.animate == false
                        ? false
                        : true;

                    var returnData =
                    {
                        animationPromise: new $.Deferred()
                    };

                    if (amountToScroll)
                    {
                        var animationDuration = 0;
                        if (animate)
                        {
                            animationDuration = GRADEBOOK_EXPAND_ANIMATION_DURATION;
                            if (Math.abs(amountToScroll) < GRADEBOOK_EXPAND_ANIMATION_SCROLL_THRESHOLD)
                            {
                                animationDuration = animationDuration / 2;
                            }
                        }

                        var table = elementToScroll.find("table");

                        var requiresPostLoadScroll = false;
                        if (table && table.length > 0)
                        {
                            var lockedTableLeftPosition = Math.abs(table.position().left);
                            var amountAvailableToScroll = (table.width() - lockedTableLeftPosition) - window.outerWidth;
                            requiresPostLoadScroll = !forceScroll &&
                                amountAvailableToScroll < Math.abs(amountToScroll);
                        }
                        if (!requiresPostLoadScroll)
                        {
                            $.when(elementToScroll.animate({ scrollLeft: "-=" + amountToScroll }, animationDuration)).done(function ()
                            {
                                returnData.animationPromise.resolve();
                            });
                        }
                        else
                        {
                            returnData.animationPromise.resolve();
                        }

                        returnData.requiresPostLoadScroll = requiresPostLoadScroll;
                    }
                    else
                    {
                        returnData.animationPromise.resolve();
                    }

                    return returnData;
                },
                setStudents: function ()
                {
                    gradebook.students = [];
                    gradebook.unlockedBody.find(".browseRow:not(.noRecordsInBrowse)").each(function ()
                    {
                        var row = $(this);
                        var rowData = row.data();

                        var studentNameContainer = row.find(".studentNameContainer");

                        if (studentNameContainer && studentNameContainer.length)
                        {
                            var nameText = studentNameContainer.find(".anchorText").html();
                            if (nameText == null || nameText == "")
                            {
                                nameText = studentNameContainer.html();
                            }

                            gradebook.students.push({ name: nameText, row: rowData.row, studentSectionID: rowData.studentSectionId });
                        }
                    });

                    gradebook.students.sort(function (a, b)
                    {
                        if (a.name.toLowerCase() == b.name.toLowerCase())
                        {
                            return 0;
                        }
                        if (a.name.toLowerCase() > b.name.toLowerCase())
                        {
                            return 1;
                        }
                        else
                        {
                            return -1;
                        }
                    });
                },
                updateBucketNoCountIndicator: function (gradebookCell, gradeMarkNoCount)
                {
                    var studentGradeBucketIndicators = gradebookCell.find(".studentGradeBucketIndicators");
                    if (gradeMarkNoCount == true)
                    {
                        studentGradeBucketIndicators.removeClass('hiddenNoCountBucket');
                    }
                    else
                    {
                        studentGradeBucketIndicators.addClass('hiddenNoCountBucket');
                    }
                },
                markAsMissing: function (studentSectionID, assignmentID, valueOverride)
                {
                    var deferred = $.Deferred();

                    var scoreChangeAdvancedAssignmentColumnHandler = getScoreChangeAdvancedAssignmentColumnHandler(false);

                    $.when(gradebook.getAdvancedColumnCellsByAssignmentID(assignmentID, true, false)).done(function ()
                    {
                        var isMissingField = scoreChangeAdvancedAssignmentColumnHandler.getMissingField(studentSectionID, assignmentID);
                        var isMissing = skyward.controls.getValue(isMissingField);

                        var newMissingValue = !isMissing;

                        if (valueOverride != null)
                        {
                            newMissingValue = valueOverride
                        }
                        scoreChangeAdvancedAssignmentColumnHandler.updateIsMissing(studentSectionID, assignmentID, newMissingValue);

                        gradebook.gradebookCheckboxChange(isMissingField);

                        deferred.resolve();
                    });

                    return deferred.promise();
                },
                markNoCount: function (studentSectionID, assignmentID)
                {
                    var deferred = $.Deferred();

                    var scoreChangeAdvancedAssignmentColumnHandler = getScoreChangeAdvancedAssignmentColumnHandler(false);

                    $.when(gradebook.getAdvancedColumnCellsByAssignmentID(assignmentID, true, false)).done(function ()
                    {
                        var noCountField = scoreChangeAdvancedAssignmentColumnHandler.getNoCountField(studentSectionID, assignmentID);
                        var noCount = skyward.controls.getValue(noCountField);
                        scoreChangeAdvancedAssignmentColumnHandler.updateNoCount(studentSectionID, assignmentID, !noCount);

                        gradebook.gradebookCheckboxChange(noCountField);

                        deferred.resolve();
                    });

                    return deferred.promise();
                },
                markAsZero: function (studentSectionID, assignmentID)
                {
                    var data =
                    {
                        studentsectionid: studentSectionID,
                        assignmentid: assignmentID
                    };
                    var scoreTD = getAssignmentCellByField(data, "Score");
                    var scoreCell = null;

                    if (scoreTD && scoreTD.length > 0)
                    {
                        scoreCell = scoreTD.find(".studentAssignmentScoreInput");
                    }
                    if (scoreCell && scoreCell.length > 0 && (skyward.controls.getValue(scoreCell) != 0 || skyward.controls.getValue(scoreCell) === ''))
                    {
                        scoreCell.val(0.00);
                        scoreCell.trigger("focusout");
                    }
                },
                massUpdateAssignmentsSectionGradeBucket: function ()
                {
                    skyward.window.closePopup();
                    var element = $(this);
                    var data = element.data();
                    var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;

                    var expanderButton = gradebook.browse.find("#gradingPeriodGradeBucket" + gradingPeriodGradeBucketID + "_icons .gradeBucketExpander");
                    var collapsed = expanderButton.hasClass(COLLAPSED_CLASS_NAME);

                    var deferred = $.Deferred();
                    if (collapsed)
                    {

                        deferred = gradebook.toggleChildrenCellDisplay(expanderButton, { allowDuplicates: true, animate: false });
                    }
                    else
                    {
                        deferred.resolve();
                    }
                    $.when(deferred).done(function ()
                    {
                        return $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/GetMassUpdateAssignmentsSectionGradeBucket/" + gradingPeriodGradeBucketID,
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                                isInScoringMode: isInScoringMode()
                            },
                            success: function (returnData)
                            {
                                if (returnData.success == false && returnData.popupHTML)
                                {
                                    checkAjaxResponseForErrors(returnData);
                                }
                                else
                                {
                                    var popupID = "MassAssignScores";
                                    var options =
                                    {
                                        anchorTo: element,
                                        id: popupID
                                    };
                                    var saveButton = { text: "Save", "click": function () { $.when(gradebook.massAssignHelper.applyButtonClick.call($(this))).done(function () { dialog.close(); }); }, "icon": "Save", "data": element.data() };
                                    var dialog = skyward.modalLayer.showDialog("Mass Update Assignments", returnData.htmlValue.Content, [saveButton, { text: "Cancel", icon: "Cancel" }], options)
                                }
                            }
                        });
                    });
                },

                massUpdateAssignmentsStudentGradeBucket: function ()
                {
                    skyward.window.closePopup();
                    var element = $(this);
                    var data = element.data();
                    var studentGradeBucketID = data.studentGradeBucketId;
                    var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;

                    var expanderButton = gradebook.browse.find("#gradingPeriodGradeBucket" + gradingPeriodGradeBucketID + "_icons .gradeBucketExpander");
                    var collapsed = expanderButton.hasClass(COLLAPSED_CLASS_NAME);

                    var deferred = $.Deferred();
                    if (collapsed)
                    {

                        deferred = gradebook.toggleChildrenCellDisplay(expanderButton, { allowDuplicates: true, animate: false });
                    }
                    else
                    {
                        deferred.resolve();
                    }
                    $.when(deferred).done(function ()
                    {
                        return $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/GetMassUpdateAssignmentsStudentGradeBucket/" + studentGradeBucketID,
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                studentGradeBucketID: studentGradeBucketID,
                                isInScoringMode: isInScoringMode()
                            },
                            success: function (returnData)
                            {
                                if (returnData.success == false && returnData.popupHTML)
                                {
                                    checkAjaxResponseForErrors(returnData);
                                }
                                else
                                {
                                    var studentGradeBucketCell = gradebook.unlockedBody.find("td.gradeBucketCell[data-student-grade-bucket-id=" + studentGradeBucketID + "]");
                                    var popupID = "MassAssignScores";
                                    var options =
                                    {
                                        anchorTo: studentGradeBucketCell,
                                        id: popupID
                                    };
                                    var saveButton = { text: "Save", "click": function () { $.when(gradebook.massAssignHelper.applyButtonClick.call($(this))).done(function () { dialog.close(); }); }, "icon": "Save", "data": element.data() };
                                    var dialog = skyward.modalLayer.showDialog("Mass Update Assignments", returnData.htmlValue.Content, [saveButton, { text: "Cancel", icon: "Cancel" }], options);
                                }
                            }
                        });
                    });
                },
                filterToSpecificStudent: function ()
                {
                    var button = $(this);
                    var buttonData = button.data();
                    skyward.window.checkLoadContent('full', 'Gradebook', buttonData.controller, buttonData.screen, buttonData.studentSectionId, getRequiredGradebookData(null, true));
                },
                openSubjectDetails: function ()
                {
                    var button = $(this);
                    var calculationGroupSubjectGradeBucketID = button.data().calculationGroupSubjectGradeBucketId;
                    skyward.window.checkLoadContent('full', 'Gradebook', 'CalculationGroupSubjectGradeBucket', 'Gradebook', calculationGroupSubjectGradeBucketID, getRequiredGradebookData(null, true));
                },
                openAcademicStandardDetails: function ()
                {
                    var button = $(this);
                    var calculationGroupAcademicStandardGradeBucketID = button.data().calculationGroupAcademicStandardGradeBucketId;
                    skyward.window.checkLoadContent('full', 'Gradebook', 'CalculationGroupAcademicStandardGradeBucket', 'Gradebook', calculationGroupAcademicStandardGradeBucketID, getRequiredGradebookData(null, true));
                },
                applyScoreMask: function (input)
                {
                    if (input.data().decimalMask && !input.hasClass("masked"))
                    {
                        skyward.datamask.addDecimalMask(input, input.data().decimalMask.toString());
                    }
                },
                checkRemoveScoreMask: function (input)
                {
                    if (input.data().decimalMask && input.hasClass("masked") && (input.val() == '' || input.val() == '*'))
                    {
                        skyward.datamask.removeMask(input);
                        skyward.controls.setValue(input, '*');
                    }
                },
                getColumnsToResize: function (columnIndex, lockedBrowse)
                {
                    var cells = [];
                    // trying to avoid including the elements that are already being resized by the resize handler, as it can cause things to shift around in weird ways.
                    let selectors =
                        "tr.gradesheetBrowseRow td[data-column='" + columnIndex + "'] div[style*='width'], " +
                        "td[data-column='" + columnIndex + "'] div.locked.tdResizeDiv, " +
                        "tr#Gradebook_unlockedAveragesRowHeader td[data-column='" + columnIndex + "'].headerSpacerCell div, " +
                        "tr#Gradebook_lockedAveragesRowHeader td[data-column='" + columnIndex + "'].headerSpacerCell div";

                    if (lockedBrowse)
                    {
                        selectors = selectors + ", .unlockedHeader td[data-column='" + columnIndex + "'] div[style*='width']";
                    }
                    $.each(gradebook.browse.find(selectors), function ()
                    {
                        cells.push($(this));
                    });
                    return $(cells);
                },
                updateBaseGradebookColumnWidth: function (columnIndex, headerWidth)
                {
                    var headerCell = gradebook.unlockedRowHeader.find(".browseHeaderColumn[data-column='" + columnIndex + "']");
                    var cellData = headerCell.data();
                    var gradebookData = gradebookBrowse.data();
                    var action = "UpdateBaseGradebookColumnWidth";

                    if (gradebookData.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            fieldName: cellData.fieldName,
                            columnIndex: columnIndex,
                            columnWidth: Math.round(headerWidth),
                            teacherSectionSettingId: gradebookData.teacherSectionSettingId
                        }
                    });
                },
                updateGradeBucketColumnWidth: function (columnIndex, headerWidth)
                {
                    var headerCell = gradebook.unlockedRowHeader.find(".browseHeaderColumn[data-column='" + columnIndex + "']");
                    var cellData = headerCell.data();
                    var gradebookData = gradebookBrowse.data();
                    var action = "UpdateGradeBucketColumnWidth";

                    if (gradebookData.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            objectType: cellData.objectType,
                            foreignKey: cellData.foreignKey,
                            width: Math.round(headerWidth),
                            gradingPeriodGradeBucketID: cellData.gradingPeriodGradeBucketId,
                            teacherSectionSettingId: gradebookData.teacherSectionSettingId
                        }
                    });

                },
                setDisplayStudentGradeBucketIndicators: function (headerIndex, columnWidth)
                {
                    if (columnWidth < SHOW_INDICATORS_MIN_WIDTH) //or no score?
                    {
                        gradebook.unlockedBody.find(".gradebookCell[data-column='" + headerIndex + "'] .studentGradeBucketIndicators:not(.displayNone)").addClass('displayNone');
                    }
                    else
                    {
                        gradebook.unlockedBody.find(".gradebookCell[data-column='" + headerIndex + "'] .studentGradeBucketIndicators.displayNone").removeClass('displayNone');
                    }
                },
                applyResizeOnResize: function (headerIndex, columnWidth, locked)
                {
                    // jQuery Resizable doesn't always account for padding in elements being resized in a way that we might expect.
                    // For example, even though we are only changing the width on our columns, something will fire off in the jQuery that wants to recalculate the height,
                    // but it does not take the padding into account when doing so and will shrink inner elements of the resized div. We have to do our own calculation here.
                    // This can almost certainly be improved upon on our part, if we find time to update how our gradebook cells are built and the styles we use.
                    gradebook.getColumnsToResize(headerIndex, locked).each(function ()
                    {
                        // height
                        let current = $(this);
                        current.css("width", columnWidth);
                        let padTop = parseFloat(current.css("padding-top").replace('px', ''));
                        let padBot = parseFloat(current.css("padding-bottom").replace('px', ''));
                        let totalPadding = parseFloat(padTop + padBot);
                        current.css("height", current.height() + totalPadding);
                        if (current.children('.sizeMeUp').length > 0)
                        {
                            current.css("height", current.children().outerHeight());
                        }

                        let resizeWrapper = current.closest('.ui-gradebook-resize-wrapper');
                        if (resizeWrapper.length == 0)
                        {
                            return;
                        }

                        // width
                        let wrapperPadLeft = parseFloat(resizeWrapper.css("padding-left").replace('px', ''));
                        let wrapperPadRight = parseFloat(resizeWrapper.css("padding-right").replace('px', ''));
                        let wrapperWidthPadding = wrapperPadLeft + wrapperPadRight;
                        if (wrapperWidthPadding > 0)
                        {
                            current.css("width", current.width() - wrapperWidthPadding);
                        }

                        let gradebookCell = current.parents(".gradebookCell");
                        if (gradebookCell && gradebookCell.length > 0)
                        {
                            var gbCellData = gradebookCell.data();
                            if (gbCellData.resizeMinWidthSize && gbCellData.resizeMinWidthSize > 0)
                            {
                                gradebook.applyResizeRules(gradebookCell, gbCellData);
                            }
                        }
                    });
                },
                applyResizeRules: function (element, data)
                {
                    if (data.resizeMinWidthType == "Hide" && data.resizeMinWidthSelector)
                    {
                        if (element.width() <= data.resizeMinWidthSize)
                        {
                            element.find(data.resizeMinWidthSelector).hide();
                        }
                        else
                        {
                            element.removeClass("defaultHiddenText");
                            element.find(data.resizeMinWidthSelector).show();
                        }
                    }
                },
                applyResizeOnStop: function (headerIndex, columnWidth, locked)
                {
                    if (headerIndex != null)
                    {
                        var isBaseColumn = false;
                        var browseHeaderColumn = gradebook.unlockedRowHeader.find(".browseHeaderColumn[data-column='" + headerIndex + "']");
                        if (browseHeaderColumn.length && browseHeaderColumn.data().fieldName != null && browseHeaderColumn.data().gradingPeriodGradeBucketId == null)
                        {
                            isBaseColumn = true;
                        }
                        if (isBaseColumn)
                        {
                            gradebook.updateBaseGradebookColumnWidth(headerIndex, columnWidth);
                        }
                        else
                        {
                            gradebook.updateGradeBucketColumnWidth(headerIndex, columnWidth);
                        }

                        if (!locked)
                        {
                            gradebook.setDisplayStudentGradeBucketIndicators(headerIndex, columnWidth);
                        }
                        else
                        {
                            var shadowWidth = BORDER_SHADOW_WIDTH;
                            var total = shadowWidth;
                            $("#" + BROWSE_NAME + " .lockedBrowseBody tr:first-child td").each(function ()
                            {
                                total += $(this).width();
                            });
                            var lockedBrowseBody = $("#" + BROWSE_NAME + " .lockedBrowseBody");
                            var scrollWrapper = lockedBrowseBody.parent();
                            var scrollbarWidth = lockedBrowseBody.width() - scrollWrapper.width();
                            lockedBrowseBody.css("width", total + scrollbarWidth);
                            scrollWrapper.css("width", total);
                        }
                    }

                    resizeGradebook();
                },
                hideColumn: function (columnIndex, updateTeacherSetting, postData)
                {
                    var columns = $("#" + BROWSE_NAME + " td[data-column='" + columnIndex + "']");
                    columns.addClass(GRADE_COLUMN_HIDDEN_SELECTOR);

                    var columnExpanderButton = gradebook.unlockedRowSpacerHeader.find(".gradebookIconHeaderCell[data-column='" + columnIndex + "'] .gradebookHeaderExpandCollapseButton");

                    if (columnExpanderButton != null && columnExpanderButton.length)
                    {
                        var parentContainerID = columnExpanderButton.data().containerId;

                        $(".browseHeaderColumn." + parentContainerID).each(function ()
                        {
                            var column = $(this).data().column;
                            gradebook.hideColumn(column, false);
                        });
                    }
                    gradebook.recalculateColumnStylesOnColumnHidden(columnIndex, columns);

                    if (updateTeacherSetting)
                    {
                        gradebook.updateHiddenGradeBucketColumnSetting(postData);
                    }
                },
                showColumn: function (columnIndex, updateTeacherSetting, postData)
                {
                    var columns = $("#" + BROWSE_NAME + " td[data-column='" + columnIndex + "']");
                    columns.removeClass(GRADE_COLUMN_HIDDEN_SELECTOR);

                    if (updateTeacherSetting)
                    {
                        gradebook.updateHiddenGradeBucketColumnSetting(postData);
                    }
                },
                recalculateColumnStylesOnColumnHidden: function (columnIndex, columns)
                {
                    if (columns.length <= 0)
                    {
                        columns = $("#" + BROWSE_NAME + " td[data-column='" + columnIndex + "']");
                    }

                    var elements = null;
                    var tertiaryContainer = columns.find('.gradebookTertiaryContainer');
                    if (tertiaryContainer.length > 0)
                    {
                        elements = tertiaryContainer;
                    }
                    else
                    {
                        var secondaryContainer = columns.find('.gradebookSecondaryContainer');
                        if (secondaryContainer.length > 0)
                        {
                            elements = secondaryContainer;
                        }
                    }

                    if (elements)
                    {
                        elements.each(function ()
                        {
                            var element = $(this);
                            var td = element.closest('td.gradebookPrimaryContainer');
                            var tdData = td.data();
                            var gradingPeriodGradeBucketID = tdData.gradingPeriodGradeBucketId;

                            if (gradingPeriodGradeBucketID)
                            {
                                var elementData = element.data();
                                var otherUnhiddenElementsWithSameParentElement = null;
                                var parentElement = null;
                                var foreignKey = null;
                                if (elementData.parentAcademicStandardId)
                                {
                                    foreignKey = elementData.parentAcademicStandardId;
                                    parentElement = $('td.academicStandardHeaderCell[data-academic-standard-id="' + elementData.parentAcademicStandardId + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                                    otherUnhiddenElementsWithSameParentElement = $('td.academicStandardHeaderCell[data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]:not(.gradeBucketColumnHidden)[data-column!="' + columnIndex + '"] div[data-parent-academic-standard-id="' + elementData.parentAcademicStandardId + '"], td.assignmentHeaderCell.gpgb' + gradingPeriodGradeBucketID + 'academicStandard' + foreignKey);
                                }
                                else
                                {
                                    if (tdData.subjectId)
                                    {
                                        foreignKey = tdData.subjectId;
                                        parentElement = $('td.subjectHeaderColumn[data-subject-id="' + tdData.subjectId + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                                        otherUnhiddenElementsWithSameParentElement = $('td.academicStandardHeaderCell[data-subject-id="' + tdData.subjectId + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]:not(.gradeBucketColumnHidden)[data-column!="' + columnIndex + '"], td.assignmentHeaderCell.gpgb' + gradingPeriodGradeBucketID + 'subject' + foreignKey);
                                    }
                                }

                                if (otherUnhiddenElementsWithSameParentElement && otherUnhiddenElementsWithSameParentElement.length <= 0 && parentElement)
                                {
                                    parentElement.removeClass('removeSideBorder');
                                    if (td.hasClass('cornerEnd'))
                                    {
                                        parentElement.addClass('cornerEnd').addClass('removeSideBorder').removeClass('stripe');
                                        var childrenToUpdate = parentElement.find('.stripe');
                                        if (childrenToUpdate && childrenToUpdate.length > 0)
                                        {
                                            childrenToUpdate.each(function ()
                                            {
                                                var child = $(this);
                                                child.removeClass('stripe').addClass('cornerEnd').addClass('removeSideBorder');
                                            });
                                        }
                                    }

                                    parentElement.find('div.removeSideBorder').removeClass('removeSideBorder');
                                    parentElement.find('div.expanded').removeClass('expanded').addClass('standAlone');

                                    var expander = $('a.gradebookHeaderExpandCollapseButton[data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"][data-foreign-key="' + foreignKey + '"]');
                                    if (expander)
                                    {
                                        expander.addClass('displayNone');
                                    }
                                }
                            }
                        });
                    }
                },
                updateHiddenGradeBucketColumnSetting: function (postData)
                {
                    var gradebookData = gradebookBrowse.data();
                    var action = "UpdateGradeBucketColumnHidden";

                    if (gradebookData.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }

                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data: postData
                    });
                },
                showHiddenGradeBuckets: function ()
                {
                    var button = $(this);

                    gradebook.hideGradebookOnLoadBanner(button);

                    var gradingPeriodID = button.data().currentGradingPeriodId;
                    $("#" + BROWSE_NAME + " .browseHeaderColumn." + GRADE_COLUMN_HIDDEN_SELECTOR + "[data-grading-period-id='" + gradingPeriodID +"']").each(function ()
                    {
                        var column = $(this);
                        var columnData = column.data();
                        var columnIndex = columnData.column;
                        var hideButton = column.find(".hideGradeBucketColumn");

                        if (hideButton && hideButton.length)
                        {
                            var postData =
                            {
                                hidden: false,
                                gradingPeriodGradeBucketID: columnData.gradingPeriodGradeBucketId,
                                teacherSectionSettingId: gradebookData.teacherSectionSettingId,
                                objectType: hideButton.data().objectType,
                                foreignKey: hideButton.data().foreignKey
                            };

                            gradebook.showColumn(columnIndex, true, postData);
                        }
                    });

                },
                closeHiddenGradeBucketsWarning: function ()
                {
                    var button = $(this);
                    var buttonData = button.data();
                    var gradebookData = gradebookBrowse.data();
                    var action = "DismissHiddenBucketsWarning";

                    if (gradebookData.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }

                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            teacherSectionSettingId: gradebookData.teacherSectionSettingId,
                            gradingPeriodID: buttonData.currentGradingPeriodId,
                        }
                    });
                    gradebook.hideGradebookOnLoadBanner(button);
                },
                hideGradebookOnLoadBanner: function (button)
                {
                    var gradebookOnLoadWarningBanner = button.parents(ON_LOAD_WARNING_SELECTOR).first();
                    if (gradebookOnLoadWarningBanner && gradebookOnLoadWarningBanner.length > 0)
                    {
                        gradebookOnLoadWarningBanner.remove();
                    }
                }
            };
            gradebook.bodyData = gradebook.body.data();

            var updateRoundedCornerClassesOnExpand = function (element)
            {
                if (element.hasClass("standAlone"))
                {
                    element.removeClass("standAlone");
                    element.addClass("expanded");
                }

                if (element.hasClass("cornerEnd"))
                {
                    element.removeClass("cornerEnd");
                    element.addClass("stripe");
                }
            };

            var updateRoundedCornerClassesOnCollapse = function (element)
            {
                if (element.hasClass("expanded"))
                {
                    element.removeClass("expanded");
                    element.addClass("standAlone");
                }

                if (element.hasClass("stripe"))
                {
                    element.removeClass("stripe");
                    element.addClass("cornerEnd");
                }
            };

            var scoringModeControlsSelector = '.gradebookScoringModeControl:not(.scoringModeDoesntAffectState):not(.gradingPeriodCompleted):not(.skipStudentAssignment):not(.hasAttempts):not(.eELInputContainer), #GradebookUndo, #GradebookRedo';
            var scoringModeBodyFilter = '.assignmentSlider, .massAssignOptionButton, #GradebookUndo, #GradebookRedo';

            gradebook.data = gradebook.browse.data();

            gradebook.updateScoringModeControls();

            gradebook.enableControl = function (control)
            {
                control.removeClass('gradebookScoringMode-Off').removeClass("displayNone").addClass('gradebookScoringMode-On');
                control.find(".displayNone").removeClass("displayNone");

                var codeEEL = control.parents('.codeEEL, .gradebookCodeEEL');
                if (codeEEL.length > 0)
                {
                    codeEEL.find(".readonly").removeClass("readonly").addClass('addReadOnlyClassHere');
                    codeEEL.find(".ui-disabled").removeClass("ui-disabled").addClass('addUIDisabledHere');
                    codeEEL.find("[readOnly]").removeAttr("readOnly").addClass('addReadOnlyHere');
                    codeEEL.find("[disabled]").removeAttr("disabled").addClass('addDisabledHere');
                    codeEEL.find(".displayNone").removeClass("displayNone").addClass('addDisplayNoneHere');

                    var parentBox = control.parent('div.eELInputContainer.js-showEELContainer, div.gradebookCodeEEL');
                    if (parentBox.length > 0)
                    {
                        parentBox.removeClass('gradebookScoringMode-Off').addClass('gradebookScoringMode-On');
                    }
                }

                if (control.hasClass('skipStudentAssignment'))
                {
                    gradebook.disableControl(control);
                }
                else if (control.hasClass("gradebookInputCodeEEL"))
                {
                    control.removeAttr("disabled");
                    control.removeAttr("readOnly");
                    var dropDownButton = control.siblings(".gradebookCodeEELButton");
                    if (dropDownButton.length > 0 && dropDownButton.hasClass("displayNone"))
                    {
                        dropDownButton.removeClass("displayNone");
                    }

                    if (!control.hasClass("gradeMarkScoring"))
                    {
                        var wrapper = control.parent();
                        if (wrapper.length > 0 && wrapper.hasClass("displayNone"))
                        {
                            wrapper.removeClass("displayNone");
                        }

                        wrapper.next("span").addClass("displayNone");
                    }
                }
                else if (!control.hasClass('assignmentSlider') && control.attr("id") != "GradebookUndo" && control.attr("id") != "GradebookRedo")
                {
                    skyward.controls.enable(control);
                }
            };

            gradebook.disableControl = function (control)
            {
                control.removeClass('gradebookScoringMode-On').addClass('gradebookScoringMode-Off');

                var codeEEL = control.parents('.codeEEL, .gradebookCodeEEL');
                if (codeEEL.length > 0)
                {
                    codeEEL.find(".addReadOnlyClassHere").removeClass("addReadOnlyClassHere").addClass('readOnly');
                    codeEEL.find(".addUIDisabledHere").removeClass("addUIDisabledHere").addClass('ui-disabled');
                    codeEEL.find(".addReadOnlyHere").removeClass("addReadOnlyHere").attr('readOnly', 'readOnly');
                    codeEEL.find(".addDisabledHere").removeClass("addDisabledHere").attr('disabled', 'disabled');
                    codeEEL.find(".addDisplayNoneHere").removeClass("addDisplayNoneHere").addClass('displayNone');

                    var parentBox = control.parent('div.eELInputContainer.js-showEELContainer, div.gradebookCodeEEL');
                    if (parentBox.length > 0)
                    {
                        parentBox.removeClass('gradebookScoringMode-On').addClass('gradebookScoringMode-Off');
                    }
                }

                if (!control.hasClass('assignmentSlider'))
                {
                    skyward.controls.disable(control);

                    if (control.hasClass("gradebookInputCodeEEL"))
                    {
                        var dropDownButton = control.siblings(".gradebookCodeEELButton");
                        if (dropDownButton.length > 0 && !dropDownButton.hasClass("displayNone"))
                        {
                            dropDownButton.addClass("displayNone");
                        }

                        if (control.hasClass("subjectiveStudentGradeBucket") || control.hasClass("subjectiveStudentGradeBucketSubject") || control.hasClass("subjectiveStudentGradeBucketAcademicStandard"))
                        {
                            var wrapper = control.parent();
                            if (wrapper.length > 0 && !wrapper.hasClass("displayNone"))
                            {
                                wrapper.addClass("displayNone");
                            }

                            wrapper.next("span").removeClass("displayNone");
                        }
                    }

                    if (control.hasClass('checkbox') || control.hasClass('gradebookInputCodeEEL') || control.hasClass('codeEELDescription'))
                    {
                        return;
                    }
                    control.removeAttr('disabled');
                }
            };

            gradebook.browse.on('gradebook.scoringModeControlsChange', function ()
            {
                gradebook.scoringModeControls = gradebook.browse.find(scoringModeControlsSelector);
                gradebook.gradebookBodyScoringModeControls = gradebook.scoringModeControls.not(scoringModeBodyFilter);
                gradebook.scoringModeControls.each(function ()
                {
                    var control = $(this);
                    if (gradebook.editMode)
                    {
                        gradebook.enableControl(control);
                    }
                    else
                    {
                        gradebook.disableControl(control);
                    }
                });
            });

            if ($.isEmptyObject(gradebook.data))
            {
                return;
            }

            var attachListeners = function ()
            {
                window.onresize = resizeGradebook;
                gradebook.controls.find('.assignmentRedirectButton:not(.ui-disabled)').on('click', skyward.gradebook.redirectToAssignment);
                gradebook.controls.find('.assignmentRestoreButton').on('click', skyward.gradebook.redirectToAssignment);

                gradebook.saveManager = createSaveManager(gradebook);

                $("#GradebookUndo").on("click", function ()
                {
                    if (!$(this).hasClass("ui-disabled"))
                    {
                        gradebook.saveManager.undo();
                    }
                });

                $("#GradebookRedo").on("click", function ()
                {
                    if (!$(this).hasClass("ui-disabled"))
                    {
                        gradebook.saveManager.redo();
                    }
                });

                gradebook.browse.on("keyup", ".browseRow .gradebookCell input:text", function (event)
                {
                    var field = $(this);
                    var fieldValue = skyward.controls.getValue(field);
                    var originalValue = getInputOriginalValue(field, true);

                    if (field.hasClass("number"))
                    {
                        fieldValue = parseFloat(fieldValue) || 0;
                        originalValue = parseFloat(originalValue) || 0;
                    }

                    if (fieldValue == originalValue)
                    {
                        gradebook.saveManager.setDirtyState(false);
                        return;
                    }

                    gradebook.saveManager.setDirtyState(true);
                });

                gradebook.browse.on("focusin", ".gradebookInput.gradebookScoringMode-On:text:not(.codeEELCode):not(.gradebookInputCodeEEL)", function ()
                {
                    var input = $(this);

                    gradebook.applyScoreMask(input);

                    var inputData = input.data();
                    if (inputData.fieldname == "Score")
                    {
                        gradebook.markInputScoreAsPending(input);
                    }
                });

                gradebook.browse.on("focusout", ".gradebookInput.gradebookScoringMode-On:text:not(.codeEELCode):not(.gradebookInputCodeEEL)", function ()
                {
                    gradebook.changeStudentAssignmentValue($(this));
                });

                gradebook.changeStudentAssignmentValue = function (input)
                {
                    // changeStudentAssignmentValue can be called asynchronously along with updateEditMode; add the ui-disabled class to the edit button immediately...
                    // ... so that we don't need to wait for it to happen in the save manager later down in this function;
                    // otherwise, it's possible to exit scoring mode before the assignment cell has finished updating
                    gradebook.editButton.addClass('ui-disabled');

                    gradebook.saveManager.setDirtyState(false);

                    var inputData = input.data();

                    if (inputData.fieldname != "Score")
                    {
                        gradebook.saveManager.save({ assignmentId: inputData.assignmentid, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                        gradebook.editButton.removeClass('ui-disabled');
                        return;
                    }

                    var inputValue = input.val();

                    var deferred = $.Deferred();
                    if (inputData.originalAssignmentScore != inputValue && !isNaN(inputValue) && inputValue != "")
                    {
                        gradebook.markInputScoreAsPending(input);
                        deferred = gradebook.updateIsMissingValueAndCheckFailingScoreClarifier(inputData.assignmentid, inputData.studentsectionid, inputValue);
                    }
                    else
                    {
                        deferred.resolve();
                    }

                    $.when(deferred).done(function ()
                    {
                        if (inputValue == "" || inputValue == ".")
                        {
                            gradebook.checkRemoveScoreMask(input);
                        }

                        gradebook.completePendingInputScore(input);
                        input.data('studentAssignmentScore', inputValue);

                        var saveData =
                        {
                            assignmentId: inputData.assignmentid,
                            studentSectionId: inputData.studentsectionid,
                            academicStandardId: inputData.academicStandardId,
                            isAvailable: inputData.isAvailable,
                            sectionId: getSectionIDFromCell(input)
                        };
                        gradebook.saveManager.save(saveData);

                        gradebook.editButton.removeClass('ui-disabled');
                    });
                };

                gradebook.browse.on("click", ".gradebookInputCodeEEL.subjectiveStudentGradeBucket, .gradebookInputCodeEEL.subjectiveStudentGradeBucketSubject, .gradebookInputCodeEEL.subjectiveStudentGradeBucketAcademicStandard", function (event)
                {
                    rowClick.apply($(this).parents("td"));
                    event.preventDefault();
                    event.stopPropagation();
                });

                gradebook.browse.on("keyup", ".codeEEL.quickEntryText", function () { markCommentQuickEntryAsValid($(this)); });
                gradebook.browse.on("eelComplete", ".codeEEL.quickEntryText", quickEntryTextEelComplete);
                gradebook.browse.on("focusout", ".quickEntryText", quickEntryTextEelComplete);

                gradebook.browse.on("focusin", ".gradebookInputCodeEEL.gradeMarkScoring", function (event, returnData)
                {
                    var input = $(this);
                    gradebook.markInputScoreAsPending(input);
                });
                gradebook.browse.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL.gradeMarkScoring", function (event, returnData)
                {
                    var input = $(this);
                    gradeMarkScoringEelComplete(event, returnData, gradebook, input);
                });
                gradebook.browse.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL.scoreClarifier", scoreClarifierEelComplete);

                gradebook.browse.on("gradebookInputCodeEELValid", ".subjectiveStudentGradeBucket", function (event, returnData)
                {
                    var input = $(this);
                    var studentGradeBucketID = input.parents('.gradeBucketCell').data('studentGradeBucketId');
                    var saveData =
                    {
                        isStudentGradeBucket: true,
                        studentGradeBucketID: studentGradeBucketID,
                        studentSectionId: input.parents("tr").first().data().studentSectionId
                    };
                    gradeMarkCodeEELValidHandler(input, saveData, returnData, gradebook);
                });

                gradebook.browse.on("gradebookInputCodeEELValid", ".subjectiveStudentGradeBucketSubject", function (event, returnData)
                {
                    var input = $(this);
                    var studentGradeBucketSubjectID = input.parents('.subjectCell').data('studentGradeBucketSubjectId');
                    var saveData =
                    {
                        isStudentGradeBucketSubject: true,
                        studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                        studentSectionId: input.parents("tr").first().data().studentSectionId
                    };
                    gradeMarkCodeEELValidHandler(input, saveData, returnData, gradebook);
                });

                gradebook.browse.on("gradebookInputCodeEELValid", ".subjectiveStudentGradeBucketAcademicStandard", function (event, returnData)
                {
                    var input = $(this);

                    var studentGradeBucketAcademicStandardID = input.parents('.academicStandardCell').data('studentGradeBucketAcademicStandardId');
                    var saveData =
                    {
                        isStudentGradeBucketAcademicStandard: true,
                        studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                        studentSectionId: input.parents("tr").first().data().studentSectionId
                    };
                    gradeMarkCodeEELValidHandler(input, saveData, returnData, gradebook);
                });

                var gradeMarkCodeEELValidHandler = function (input, saveData, returnData, gradebook)
                {
                    saveData.Score =
                    {
                        displayValue: returnData.matchedValue,
                        selectedValueID: returnData.selectedValueID
                    };

                    if (gradebook != null)
                    {
                        gradebook.saveManager.setDirtyState(false);
                    }

                    removeCellErrorClasses(input.parents("td").first(), "noGradeMarkMatch");

                    var inputValue = returnData.selectedValueID;

                    skyward.gradebookcodeeel.setValue(input, returnData.matchedValue, inputValue, true);

                    gradebook.saveManager.save(saveData);
                };

                gradebook.browse.on("gradebookInputCodeEELInvalid", ".subjectiveStudentGradeBucket, .subjectiveStudentGradeBucketSubject, .subjectiveStudentGradeBucketAcademicStandard, .gradeMarkScoring, .scoreClarifier", function (event, returnData)
                {
                    var input = $(this);
                    gradeMarkScoringEelFailed(event, returnData, input, gradebook);
                });

                gradebook.browse.on("click", ".gradebookCheckbox.mastery", function (event, returnData)
                {
                    var input = $(this);
                    rowClick.apply(input.parents("td"));
                    var mastered = input.is(":checked");
                    var primaryKey = input.attr("id").split("_")[1];

                    var saveData =
                    {
                        isStudentGradeBucketSubject: input.parents("td").first().hasClass("subjectCell"),
                        studentGradeBucketSubjectID: primaryKey,
                        isStudentGradeBucketAcademicStandard: input.parents("td").first().hasClass("academicStandardCell"),
                        studentGradeBucketAcademicStandardID: primaryKey,
                        type: "mastery",
                        studentSectionId: input.parents("tr").first().data().studentSectionId
                    };

                    gradebook.saveManager.save(saveData);
                    event.stopPropagation();
                });

                gradebook.browse.on("click", ".gradebookCheckbox:checkbox:not(.mastery)", function ()
                {
                    gradebook.gradebookCheckboxChange($(this));
                });

                gradebook.gradebookCheckboxChange = function (input)
                {
                    var inputData = input.data() || {};
                    gradebook.saveManager.save({ assignmentId: inputData.assignmentid, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                };

                $('#closeMassAssign').on('click', function ()
                {
                    gradebook.massAssignHelper.collapseMassAssign(true);
                });

                gradebook.massAssignHelper = massAssign(gradebook.body, gradebook.massAssign, "input[type = 'radio'][name = 'massAssignRadiochild']:checked", gradebook.saveManager.save, gradebook.updateIsMissingValueAndCheckFailingScoreClarifier, gradebook);

                var radioButtons = gradebook.massAssign.find(gradebook.massAssignHelper.radioSet);
                radioButtons.change(gradebook.massAssignHelper.inputConfiguration);

                gradebook.editButton.on("click", updateEditMode);
                gradebook.browse.on("click", ".browseDataCell, .gradebookCell", rowClick);
                gradebook.browse.on("click", ".button[data-click-action='informationPopup.show']", function () { rowClick.apply($(this).closest(".browseRowOptions")); });
                gradebook.browse.on("click", ".button[alt='Row Menu']", function () { rowClick.apply($(this).closest(".browseRowOptions")); });

                skyward.browse.addBrowseScrollEvents(gradebook);

                gradebook.resize = resizeGradebook;

                gradebook.body.on("keydown", ".gradebookCell, .editableGradeBucketCell", browseKeyDown);

                gradebook.header.on("keydown", moveBodyOnHeaderTab);
                gradebook.header.on("click", ".assignmentHeaderIndicators", assignmentHeaderIndicatorsPopup);
                gradebook.controls.on("keydown", moveBodyOnHeaderTab);

                gradebook.browse.on("click", ".gradeBucketCell .studentGradeBucketIndicators", studentGradeBucketIndicatorPopup);
                gradebook.browse.on("click", ".subjectCell .studentGradeBucketIndicators", studentGradeBucketSubjectIndicatorPopup);
                gradebook.browse.on("click", ".academicStandardCell .studentGradeBucketIndicators", studentGradeBucketAcademicStandardIndicatorPopup);
                gradebook.browse.on("click", ".needsTransferRunProcess", gradebook.enterTransferGrades);

                gradebook.massAssign.on("keydown", browseKeyDown);

                gradebook.lockedBody.on('click', '.partiallyEnrolledButton', showTermAdjustmentInfo);

                gradebook.lockedBody.on('click', '.newStudentButton:not(.readOnly)', showNewStudentInfo);

                gradebook.lockedBody.on('click', '.alternativeCreditCourseStudent', showAlternativeCreditCourseStudentInfo);

                gradebookBrowse.debounce("Gradebook.UpdateLockedColumnState", gradebook.updateTeacherSectionSetting);

                gradebook.browse.on("click", "a.attemptCount", function (event, returnData)
                {
                    var data = $(this).data();
                    attemptsPopup(data, gradebook);
                });

                gradebook.header.on("click", ".hideGradeBucketColumn", function (event)
                {
                    event.stopPropagation();
                    event.preventDefault();

                    var button = $(this);
                    var cog = gradebook.lockedHeader.find(".gradebookSettingsCog");
                    var cell = button.parents(".browseHeaderColumn").first();
                    var cellData = cell.data();
                    var columnIndex = cellData.column;

                    var gradebookData = gradebook.browse.data();
                    var firstTimeHiding = gradebookData.showGradeBucketColumnHiddenAlert;

                    if (firstTimeHiding && !gradebookData.isTeacherTracker && button.data("objectType") == "GradeBucket")
                    {
                        gradebookData.showGradeBucketColumnHiddenAlert = false;
                        var htmlContent = "<div>You have hidden a grade column. Hidden grade columns can be maintained from the settings cog here.</div>";

                        var options =
                        {
                            anchorTo: cog,
                            id: "HideGradeBucketColumnAlert"
                        };

                        currentHeaderPopupDialog = skyward.modalLayer.showDialog("Hidden Grade Column", htmlContent, [], options);

                        $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/UpdateGradeBucketAlertSetting",
                            type: "POST",
                            dataType: "JSON",
                            activityIndicator: { silent: true },
                            data: {
                            },
                            success: function (response)
                            {

                            }
                        });
                    }

                    var postData =
                    {
                        hidden: true,
                        gradingPeriodGradeBucketID: cellData.gradingPeriodGradeBucketId,
                        teacherSectionSettingId: gradebookData.teacherSectionSettingId,
                        objectType: button.data().objectType,
                        foreignKey: button.data().foreignKey,
                        locked: button.data().locked
                    };
                    gradebook.hideColumn(columnIndex, true, postData);
                });

                addHeaderClickEvents();
            };

            var addHeaderClickEvents = function ()
            {
                var headers = gradebook.unlockedRowSpacerHeader;

                gradebook.header.on('click', ".browseColumnHeaderSort", changeSort);

                gradebook.header.on('click', '.gradeBucketExpander', gradebook.toggleBucketDisplay);
                gradebook.header.on('click', '.subjectExpander', gradebook.toggleSubjectDisplay);
                gradebook.header.on('click', '.academicStandardExpander', gradebook.toggleAcademicStandardDisplay);
                gradebook.header.on('click', '.assignmentExpander', gradebook.toggleAssignmentDisplay);
            };

            var resizeGradebook = function ()
            {
                var browseWidth = gradebook.browse.width();

                gradebook.lockedHeader.height(gradebook.unlockedHeader.height());

                var headerSpacer = 17;
                if (browseWidth > headerSpacer)
                {
                    gradebook.headerSpacer.width(browseWidth - headerSpacer);
                    gradebook.headerSpacerDiv.width(browseWidth - headerSpacer);
                }
                else
                {
                    gradebook.headerSpacer.width(0);
                    gradebook.headerSpacerDiv.width(0);
                }

                var lockedRows = gradebook.lockedBody.find('.browseRow');

                getRowHeights(lockedRows);
                gradebook.updateLockedBodyWidths();
                skyward.browse.resizeLockedBrowseBodyForHorizontalScrollBar(gradebook);
            };

            var getRowHeights = function (rows)
            {
                $.each(rows, function ()
                {
                    var lockedRow = $(this);
                    var rowNumber = lockedRow.data().row;
                    var unlockedRow = $("#Gradebook_unlockedRow" + rowNumber);

                    var lockedRowHeight = lockedRow.height(); //getActualRowHeight(lockedRow);
                    var unlockedRowHeight = unlockedRow.height(); //getActualRowHeight(unlockedRow);

                    if (lockedRowHeight > unlockedRowHeight)
                    {
                        unlockedRow.height(lockedRowHeight);
                        lockedRow.height(lockedRowHeight);
                    }
                    else if (unlockedRowHeight > lockedRowHeight)
                    {
                        lockedRow.height(unlockedRowHeight);
                        unlockedRow.height(unlockedRowHeight);
                    }
                });
            };

            //TODO: Find a way to either do this quicker or not when the gradebook is loading. The loading icon stays too long when this is running on load
            var getActualRowHeight = function (element)
            {
                //This is was put in for IE.  In IE, if a child element is bigger than its parent, its height won't be reflected in the parent element's height.
                //If this is ever broken again, we probably just need this to dig a bit deeper and find the element that is pushing the height up.
                var height = element.outerHeight();
                var children = element.children();
                $.each(children, function ()
                {
                    var child = $(this);
                    if (child.outerHeight() > height)
                    {
                        height = child.outerHeight();
                    }
                });
                return height;
            };

            var rowClick = function ()
            {
                var cell = $(this);

                var data = cell.data();
                if (data == null)
                {
                    return;
                }

                var rowNumber = data.row;
                var columnNumber = data.column;
                if (!cell.hasClass("gradebookCell"))
                {
                    cell = getAssignmentCellForNewRow(rowNumber, columnNumber);
                    if (cell.length)
                    {
                        columnNumber = cell.data("column");
                    }
                }

                changeRow(rowNumber, columnNumber, cell);
            };

            var changeRow = function (rowNumber, columnNumber, browseCell)
            {
                setCurrentRecord(rowNumber, browseCell);
            };

            var changeSort = function ()
            {
                var clickedElement = $(this);
                var browseData = clickedElement.data();
                if (browseData == null)
                {
                    return;
                }

                var gradebookData = gradebookBrowse.data();

                var headers = gradebookBrowse.find(".browseHeader");
                headers.off('click', ".browseColumnHeaderSort", changeSort);

                var additionalData =
                {
                    sortField: browseData.sortField,
                    shift: skyward.keys.globalShiftPressed,
                    seekId: -1
                };

                if (browseData.sortDescending == null)
                {
                    additionalData.descending = false;
                }
                else
                {
                    additionalData.descending = !browseData.sortDescending || browseData.sortDescending === "false" || browseData.sortDescending === "False";
                }

                var action = "ChangeSort";
                if (gradebookData.isTeacherTracker)
                {
                    action += "TeacherTracker";
                }
                gradebook.reloadGradebook('Gradebook', 'Gradebook', action, additionalData);
            };

            var resetGradebookView = function (dialog)
            {
                var gradebookData = gradebookBrowse.data();
                var data = { "sectionID": gradebookData.sectionID };
                var action = "ResetGradesheetView";

                if (gradebookData.isTeacherTracker)
                {
                    action += "TeacherTracker";
                }

                gradebook.reloadGradebook('Gradebook', 'Gradebook', action, data);
                dialog.close();
            };

            var getRequiredGradebookData = function (browseData, removeSelectMode)
            {
                browseData = browseData || {};
                var browse = skyward.browse.browseList[BROWSE_NAME];
                var requiredData = gradebook.browse.data();
                var requiredBrowseData = skyward.browse.getRequiredBrowseData(browse, browseData);

                var gradebookRequiredLoadData = {};

                if (requiredBrowseData && requiredBrowseData.postData)
                {
                    if (JSON.parse(requiredBrowseData.postData).GradebookRequiredData != null)
                    {
                        gradebookRequiredLoadData = JSON.parse(JSON.parse(requiredBrowseData.postData).GradebookRequiredData);
                    }
                }
                requiredData.GradebookRequiredData = JSON.stringify(gradebookRequiredLoadData)

                $.extend(requiredData, requiredBrowseData);

                if (removeSelectMode == true)
                {
                    delete requiredData.selectMode;
                }

                return requiredData;
            };

            var setCurrentRecord = function (rowNumber, browseCell, shift, animate)
            {
                if (rowNumber >= 0 && gradebook.currentRow >= 0)
                {
                    var previousUnlockedRow = getRowElement("unlocked", gradebook.currentRow);
                    var previousLockedRow = getRowElement("locked", gradebook.currentRow);
                    previousLockedRow.removeClass("current");
                    previousUnlockedRow.removeClass("current");

                    gradebook.currentRow = rowNumber;

                    var lockedRow = getRowElement("locked", gradebook.currentRow);
                    var unlockedRow = getRowElement("unlocked", gradebook.currentRow);

                    lockedRow.addClass("current");
                    unlockedRow.addClass("current");

                    setCurrentRecordChildElementClasses(previousUnlockedRow, previousLockedRow, unlockedRow, lockedRow);

                    setCurrentCellElement(browseCell);

                    if (gradebook.unlockedBody.length > 0 && unlockedRow.length > 0)
                    {
                        var bodyTop = gradebook.unlockedBody.scrollTop();
                        var bodyBottom = bodyTop + gradebook.unlockedBody.height();

                        var rowTop = unlockedRow.offset().top - gradebook.unlockedBody.offset().top + bodyTop;
                        var rowBottom = rowTop + unlockedRow.height();

                        if (rowTop < bodyTop)
                        {
                            if (animate)
                            {
                                if (!gradebook.isGradebookFullyLoaded())
                                {
                                    gradebook.queueFunctionToCallOnCompletionOfLoad(scrollToCurrentRow, null, {});
                                    return;
                                }
                            }
                            else
                            {
                                unlockedRow[0].scrollIntoView(true);
                            }
                        }
                        else if (rowBottom > bodyBottom)
                        {
                            if (animate)
                            {
                                if (!gradebook.isGradebookFullyLoaded())
                                {
                                    gradebook.queueFunctionToCallOnCompletionOfLoad(scrollToCurrentRow, null, {});
                                    return;
                                }
                            }
                            else
                            {
                                unlockedRow[0].scrollIntoView(false);
                            }
                        }
                    }

                    scrollSpecificGradebookElementOver(browseCell);
                    updateAdditionalRowColors(previousUnlockedRow, unlockedRow, "subjectCell");
                    updateAdditionalRowColors(previousUnlockedRow, unlockedRow, "academicStandardCell");
                }
            };

            var scrollToCurrentRow = function ()
            {
                var row = getCurrentRow();
                var bodyTop = gradebook.unlockedBody.scrollTop();
                var rowTop = row.offset().top - gradebook.unlockedBody.offset().top + bodyTop;

                gradebook.unlockedBody.animate({ scrollTop: rowTop }, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                gradebook.lockedBody.animate({ scrollTop: rowTop }, GRADEBOOK_EXPAND_ANIMATION_DURATION);
            }

            var setCurrentRecordChildElementClasses = function (previousUnlockedRow, previousLockedRow, unlockedRow, lockedRow)
            {
                previousUnlockedRow.find('svg').removeClass('browseRowContent selectedRow');
                previousLockedRow.find('svg').removeClass('browseRowContent selectedRow');
                unlockedRow.find('svg').addClass('browseRowContent selectedRow');
                lockedRow.find('svg').addClass('browseRowContent selectedRow');
            };


            var scrollSpecificElementOver = function (elementToScroll, lockedTableElement, focusElement, alwaysMoveToLockedBody)
            {
                lockedTableElement = lockedTableElement ? $(lockedTableElement) : lockedTableElement;
                elementToScroll = elementToScroll ? $(elementToScroll) : elementToScroll;
                var lockedRight = lockedTableElement ? (lockedTableElement.width() + lockedTableElement.offset().left) : 0;
                var elementLeft = (focusElement && focusElement.offset()) ? focusElement.offset().left : lockedRight;
                var elementRight = elementLeft + (focusElement ? focusElement.width() : 0);
                var amountToScroll;
                if (elementLeft <= lockedRight || alwaysMoveToLockedBody == true)
                {
                    amountToScroll = lockedRight - elementLeft;
                    elementToScroll.animate({ scrollLeft: "-=" + amountToScroll }, 0);
                }
                else if (elementRight > elementToScroll.width())
                {
                    amountToScroll = elementRight - elementToScroll.width();
                    elementToScroll.animate({ scrollLeft: "+=" + amountToScroll }, 0);
                }
            };

            var scrollSpecificGradebookElementOver = function (focusElement, alwaysMoveToLockedBody)
            {
                if (focusElement == null || focusElement.parents(".lockedBrowseBody").length > 0)
                {
                    return;
                }
                scrollSpecificElementOver(gradebook.unlockedBody, gradebook.lockedBody.children('table'), focusElement, alwaysMoveToLockedBody);
            };

            var scrollElementOver = function (elementToScroll, lockedTableElement, targetElement, shift, focusElementParentSelector, alwaysMoveToLockedBody)
            {
                var focusableElements = $(':focusable:not([tabindex=-1]):not([disabled]):not(:hidden)');
                targetElement = targetElement ? $(targetElement) : focusableElements.filter(':focus');
                var offset = shift == true ? -1 : 1;
                var focusElement = focusableElements[focusableElements.index(targetElement) + offset];
                focusElement = focusElement ? $(focusElement) : focusElement;
                if (focusElementParentSelector)
                {
                    var closestFocusElement = focusElement.closest(focusElementParentSelector);
                    focusElement = closestFocusElement.length > 0 ? closestFocusElement : focusElement;
                }
                scrollSpecificElementOver(elementToScroll, lockedTableElement, focusElement, alwaysMoveToLockedBody);
            };

            var scrollGradebookElementOver = function (targetElement, shift, focusElementParentSelector, alwaysMoveToLockedBody)
            {
                scrollElementOver(gradebook.unlockedBody, gradebook.lockedBody.children('table'), targetElement, shift, focusElementParentSelector, alwaysMoveToLockedBody);
            };

            var setCurrentCellElement = function (newCell)
            {
                addCurrentCellClasses(newCell);
                if (newCell)
                {
                    var input = newCell.find("input");
                    input.focus().select();
                }
            };

            var updateAdditionalRowColors = function (previousUnlockedRow, unlockedRow, classname)
            {
                previousUnlockedRow.find("." + classname).each(function ()
                {
                    var cell = $(this);

                    if (!gradebook.hasBackgroundColorOverride(cell))
                    {
                        gradebook.resetCellBackgroundColor(cell);
                    }
                    else
                    {
                        cell.css({ backgroundColor: '', color: '' });
                    }
                });

                unlockedRow.find("." + classname).each(function ()
                {
                    var cell = $(this);
                    if (!gradebook.hasBackgroundColorOverride(cell))
                    {
                        cell.css({ backgroundColor: 'inherit', color: 'inherit' });
                    }
                });

                previousUnlockedRow.find("." + classname + ".updated").each(function ()
                {
                    var cell = $(this);
                    cell.css({ backgroundColor: '', color: '' });
                });

                unlockedRow.find("." + classname + ".updated").each(function ()
                {
                    var cell = $(this);
                    cell.css({ backgroundColor: '', color: '' });
                });

                unlockedRow.find("." + classname + ".hasErrors").each(function ()
                {
                    var cell = $(this);
                    cell.css({ backgroundColor: '', color: '' });
                });
            };

            var getMassAssignContent = function (assignmentId)
            {
                return $("#assignment" + assignmentId + "_MassAssignContent");
            };

            var getAverageScoreContent = function (assignmentId)
            {
                return $(".assignment" + assignmentId + "AverageHeaderCell");
            };

            var getAssignmentCellForNewRow = function (newRowNumber, newColumnNumber)
            {
                var activeElement = $(document.activeElement);
                if (activeElement.is(":text") || activeElement.is(":checkbox"))
                {
                    var assignmentCell = activeElement.closest(".assignmentCell");
                    if (assignmentCell.length)
                    {
                        var assignmentCellData = assignmentCell.data();

                        if (!$.isEmptyObject(assignmentCellData))
                        {
                            return getAssignmentCellElementByRowColumn(newRowNumber, assignmentCellData.column);
                        }
                    }
                }

                return getAssignmentCellElementByRowColumn(newRowNumber, newColumnNumber);
            };

            var getAssignmentCellElementByRowColumn = function (rowNumber, columnNumber)
            {
                return $("[data-row='" + rowNumber + "'][data-column='" + columnNumber + "']");
            };

            var addCurrentCellClasses = function (newCell)
            {
                if (gradebook.currentCell)
                {
                    gradebook.currentCell.removeClass("linkPanelCell--active");
                }
                if (newCell)
                {
                    newCell.addClass("linkPanelCell--active");
                    gradebook.currentCell = newCell;
                }
            };

            var updateIsMissingValue = function (inputData)
            {
                var isMissingCell = getAssignmentCellByField(inputData, "IsMissing").find('input');
                if (isMissingCell.is(":checked"))
                {
                    skyward.controls.setValue(isMissingCell, false);
                }
            };

            var getRowElement = function (rowType, rowNumber)
            {
                //rowType should be "unlocked" or "locked"
                return $("#" + BROWSE_NAME + "_" + rowType + "Row" + rowNumber);
            };

            var getCurrentRow = function ()
            {
                return gradebook.unlockedBody.find(".browseRow.current");
            };

            var getCurrentRowNumber = function ()
            {
                var currentRow = getCurrentRow();
                var currentRowData = currentRow.data();
                if (currentRowData == null)
                {
                    return null;
                }
                return currentRowData.row;
            };

            var getCurrentCellNumber = function ()
            {
                return $(".linkPanelCell--active").data("column");
            };

            gradebook.updateEditModeNoDialog = function (collapseAdvancedColumns, specificInputToUpdate)
            {
                if (gradebook.editButton.hasClass('ui-disabled'))
                {
                    setTimeout(gradebook.updateEditModeNoDialog, 500, collapseAdvancedColumns, specificInputToUpdate);
                }
                else
                {
                    updateEditMode(collapseAdvancedColumns, specificInputToUpdate);
                }
            };

            var updateEditMode = function (collapseAdvancedColumns, specificInputToUpdate)
            {
                if (gradebook.editButton.hasClass('ui-disabled'))
                {
                    var message = "Assignments are still being saved. Please try again.";
                    var options =
                    {
                        anchorTo: $(this),
                        id: "AssignmentsBeingSavedMessage"
                    };

                    var closeButton = { id: "closeAssignmentsBeingSavedPopup", text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                    var dialog = skyward.modalLayer.showDialog('Assignments Being Saved', message, [closeButton], options);
                    event.stopPropagation();
                    return;
                }

                gradebook.editButton.off("click", updateEditMode);
                gradebook.editButton.addClass('ui-disabled');

                var buttonText = gradebook.editButton.find('.textAfter');

                if (specificInputToUpdate)
                {
                    gradebook.scoringModeControls = $(specificInputToUpdate);
                    gradebook.gradebookBodyScoringModeControls = $(specificInputToUpdate);
                }
                else
                {
                    gradebook.scoringModeControls = gradebook.browse.find(scoringModeControlsSelector);
                    gradebook.gradebookBodyScoringModeControls = gradebook.scoringModeControls.not(scoringModeBodyFilter);
                }

                if (gradebook.editMode)
                {
                    exitScoringMode(buttonText, collapseAdvancedColumns);
                }
                else
                {
                    enterScoringMode(buttonText);
                }

                gradebook.editMode = !gradebook.editMode;
            };

            var exitScoringMode = function (buttonText, collapseAdvancedColumns)
            {
                var allSavesCompletedDeferred = new $.Deferred();
                if (gradebook.saveManager.stillProcessingSaves())
                {
                    var showPopup = true;
                    var stillProcessingPopup = null;
                    var checkStatus = function ()
                    {
                        if (gradebook.saveManager.stillProcessingSaves())
                        {
                            if (showPopup)
                            {
                                //Show it after we have waited once, most of the time this wont take longer than 500ms and the user doesn't need to see it.
                                showPopup = false;
                                stillProcessingPopup = skyward.modalLayer.showDialog("Processing Changes", "<p>Grade changes are still processing.  Scoring Mode will be exited when changes are complete.</p>");
                            }
                            setTimeout(checkStatus, 500);
                        }
                        else
                        {
                            if (stillProcessingPopup != null)
                            {
                                stillProcessingPopup.close();
                            }
                            allSavesCompletedDeferred.resolve();
                        }
                    }

                    setTimeout(checkStatus, 500);
                }
                else
                {
                    allSavesCompletedDeferred.resolve();
                }

                $.when(allSavesCompletedDeferred).done(function ()
                {
                    var animationDeferred = new $.Deferred();
                    gradebook.saveManager.reset();

                    //Need to do this, in some cases it passes this in as an object with values that we don't want
                    collapseAdvancedColumns = collapseAdvancedColumns == false ? false : true;

                    var modifierSelectorToPersistAfterExistingScoringMode = '.gradeBucketGradeChangeNotReviewedOrInProgress';
                    $(".subjectCell.updated:not(" + modifierSelectorToPersistAfterExistingScoringMode + "), .subjectCell.updatedWithErrors:not(" + modifierSelectorToPersistAfterExistingScoringMode + ")").each(function ()
                    {
                        var cell = $(this);
                        gradebook.resetCellBackgroundColor(cell);
                    });

                    $(".academicStandardCell.updated:not(" + modifierSelectorToPersistAfterExistingScoringMode + "), .academicStandardCell.updatedWithErrors:not(" + modifierSelectorToPersistAfterExistingScoringMode + ")").each(function ()
                    {
                        var cell = $(this);
                        gradebook.resetCellBackgroundColor(cell);
                    });

                    $('.gradebookCell.updated').removeClass('updated').data("numberOfUpdates", 0);
                    $('#GradebookErrorStatus').removeClass('errorDuringSave');

                    if (collapseAdvancedColumns == true)
                    {
                        gradebook.browse.find(".massAssignContentCell").attr('colspan', "1");
                        $('.assignmentHeaderCell.activeMassAssign').removeClass('activeMassAssign');

                        gradebook.browse.find(".assignmentExpander.gradebookContainerExpanded").each(function ()
                        {
                            gradebook.toggleChildrenCellDisplay($(this), { allowDuplicates: true, animate: false });
                        });
                    }

                    var overMaxScoreCell = $('.gradebookCell.updatedOverMaxScore');
                    overMaxScoreCell.removeClass('updatedOverMaxScore').data("numberOfUpdates", 0);
                    overMaxScoreCell.each(function ()
                    {
                        var currentOverMaxScoreCell = $(this);
                        var indicatorRow = currentOverMaxScoreCell.find('.assignmentIndicatorsFirstRow');
                        indicatorRow.addClass('hiddenWarning');
                        updateStudentAssignmentButtonDisplay(currentOverMaxScoreCell);
                    });

                    var errorScoreCell = $('.gradebookCell.updatedWithErrors');
                    errorScoreCell.removeClass('updatedWithErrors').data("numberOfUpdates", 0);
                    errorScoreCell.each(function ()
                    {
                        var currentErrorScoreCell = $(this);
                        var indicatorRow = currentErrorScoreCell.find('.assignmentIndicatorsFirstRow');
                        indicatorRow.addClass('hiddenWarning');
                        updateStudentAssignmentButtonDisplay(currentErrorScoreCell);
                    });

                    $.when(gradebook.massAssignHelper.collapseMassAssign(false, null, true)).done(function ()
                    {
                        animationDeferred.resolve();
                    });

                    gradebook.scoringModeControls.each(function ()
                    {
                        const control = $(this);
                        gradebook.disableControl(control);
                        gradebook.checkRemoveScoreMask(control);
                    });

                    gradebook.studentAssignmentInputs.each(function ()
                    {
                        var control = $(this);
                        var controlData = control.data();

                        if (controlData.fieldname == 'Score')
                        {
                            skyward.controls.setValue(control, controlData.displayValue, true);
                        }
                    });

                    gradebook.studentAssignmentGradeMarkInputs.each(function ()
                    {
                        resizeColumnsForGradeMarkScoring($(this), disabledGradeSheetGradeMarkScoringWidth, false);
                    });

                    $.when(animationDeferred).done(function ()
                    {
                        gradebook.editButton.removeClass('ui-disabled');
                        buttonText.text("Enter Scoring Mode");
                        gradebook.editButton.on("click", updateEditMode);
                    });

                    if (gradebook.hideDuringEditMode.length > 0)
                    {
                        gradebook.hideDuringEditMode.show();
                    }
                });
            };

            var enterScoringMode = function (buttonText)
            {
                var wrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);
                var toolBarLeft = wrapper.parents(TOOLBAR_LEFT_SELECTOR).first();
                var gradebookOnLoadWarningBanner = toolBarLeft.find(ON_LOAD_WARNING_SELECTOR);
                if (gradebookOnLoadWarningBanner && gradebookOnLoadWarningBanner.length > 0)
                {
                    gradebookOnLoadWarningBanner.remove();
                }

                gradebook.scoringModeControls.each(function ()
                {
                    const control = $(this);
                    gradebook.enableControl(control);
                });

                gradebook.studentAssignmentInputs.each(function ()
                {
                    var control = $(this);
                    var controlData = control.data();

                    if (controlData.fieldname == 'Score' && !control.hasClass(PENDING_SCORE))
                    {
                        if (controlData.studentAssignmentScore == '')
                        {
                            controlData.studentAssignmentScore = '*';
                        }
                        skyward.controls.setValue(control, controlData.studentAssignmentScore, true);
                        gradebook.checkRemoveScoreMask(control);
                    }
                });

                gradebook.studentAssignmentGradeMarkInputs.each(function ()
                {
                    resizeColumnsForGradeMarkScoring($(this), enabledGradeSheetGradeMarkScoringWidth, true);
                });

                buttonText.text(GRADEBOOK_EXIT_SCORING_MODE);

                gradebook.editButton.removeClass('ui-disabled');
                gradebook.editButton.off("click", updateEditMode).on("click", updateEditMode);

                if (gradebook.hideDuringEditMode.length > 0)
                {
                    gradebook.hideDuringEditMode.hide();
                }
            };

            var getAssignmentCellByField = function (inputData, field)
            {
                return $("#Gradebook_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_" + field);
            };

            var resizeColumnsForGradeMarkScoring = function (control, width, enableGradeMark)
            {
                var controlData = control.data();
                control.width(width);

                if (controlData.secondaryfieldname == 'GradeMarkScore')
                {
                    if (enableGradeMark)
                    {
                        if (!control.hasClass(PENDING_SCORE))
                        {
                            skyward.controls.setValue(control, controlData.enabledGrademarkValue, true);
                        }
                    }
                    else
                    {
                        skyward.controls.setValue(control, controlData.disabledGrademarkValue, true);
                    }
                }
            };

            var moveBodyOnHeaderTab = function (event)
            {
                if (event.keyCode == 9)//tab
                {
                    var headerElementSelector = event.target.closest('.browseHeaderColumn') ? '.browseHeaderColumn' : undefined;
                    scrollGradebookElementOver(event.target, event.shiftKey, headerElementSelector);
                }
            };

            var browseKeyDown = function (event)
            {
                var eventTarget = $(event.target);

                var isGradebookInputCodeEEL = eventTarget.hasClass("gradebookInputCodeEEL");

                var eventTargetIsCommentField = eventTarget.closest(".assignmentCell").hasClass("gradebook_Comments");
                var eventTargetIsCheckboxField = eventTarget.closest(".assignmentCell").hasClass("gradesheetCheckboxColumn");
                var eventTargetIsGradeMarkScoringField = eventTarget.hasClass("gradeMarkScoring");
                var eventTargetIsScoreClarifierField = eventTarget.hasClass("scoreClarifier");
                var popupCount = skyward.window.getCurrentPopupId();
                if (popupCount != -1)
                {
                    return;
                }

                if (event.keyCode == 13 || event.keyCode == 40)//enter or down arrow
                {
                    selectNextVerticalCell(event.target, event.shiftKey);
                    event.preventDefault();
                    event.stopPropagation();
                }
                else if (event.keyCode == 38)//up arrow
                {
                    selectNextVerticalCell(event.target, !event.shiftKey);
                    event.preventDefault();
                    event.stopPropagation();
                }
                else if (event.keyCode == 9)//tab
                {
                    event.preventDefault();
                    selectNextHorizontalCell(event.target, event.shiftKey);
                }
                else if (event.keyCode >= 65 && event.keyCode <= 90)//a-z
                {
                    if (event.ctrlKey)
                    {
                        if ((event.keyCode == 89 && !event.shiftKey) || (event.keyCode == 90 && event.shiftKey))
                        {
                            gradebook.saveManager.redo();
                            event.preventDefault();
                            return;
                        }
                        else if (event.keyCode == 90 || (event.keyCode == 89 && event.shiftKey))
                        {
                            gradebook.saveManager.undo();
                            event.preventDefault();
                            return;
                        }
                    }

                    if (!event.shiftKey && event.altKey)
                    {
                        event.preventDefault();
                        event.stopPropagation();
                        var letter = String.fromCharCode(event.keyCode);
                        selectCorrespondingStudent(letter, event.shiftKey, true);
                        return;
                    }

                    if (eventTarget.hasClass("studentAssignmentScoreInput") || isGradebookInputCodeEEL)
                    {
                        var markAsMissing = event.keyCode == 77 && (!isGradebookInputCodeEEL || (event.ctrlKey));
                        if (markAsMissing) //M
                        {
                            event.preventDefault();
                            event.stopPropagation();
                            var data = eventTarget.data();
                            gradebook.markAsMissing(data.studentsectionid, data.assignmentid);
                            return;
                        }
                        var markAsNoCount = event.keyCode == 69 && (!isGradebookInputCodeEEL || (event.ctrlKey));
                        if (markAsNoCount) //E
                        {
                            event.preventDefault();
                            event.stopPropagation();
                            var data = eventTarget.data();
                            gradebook.markNoCount(data.studentsectionid, data.assignmentid);
                            return;
                        }
                        var markAsZero = event.keyCode == 90 && !isGradebookInputCodeEEL;
                        if (markAsZero) //z
                        {
                            event.preventDefault();
                            event.stopPropagation();
                            var data = eventTarget.data();
                            gradebook.markAsZero(data.studentsectionid, data.assignmentid);
                            return;
                        }
                    }


                }
                else if ((event.keyCode >= 48 && event.keyCode <= 57 && !event.shiftKey) ||
                    (event.keyCode >= 96 && event.keyCode <= 105 && !event.shiftKey) ||
                    event.keyCode == 46 ||
                    event.keyCode == 8 ||
                    (event.keyCode == 190 && !event.shiftKey) ||
                    event.keyCode == 110 ||
                    (event.keyCode == 187 && event.shiftKey) ||
                    (event.keyCode == 49 && event.shiftKey))
                {
                    //48-57: numbers
                    //8: backspace
                    //46: delete
                    //96-105: num lock numbers
                    //190 + 110: decimal point and num lock decimal point
                    //187 + shift  = "+"
                    //49 - !
                }
                else if (eventTargetIsCommentField || eventTargetIsGradeMarkScoringField)
                {
                    //if comment allow all characters
                }
                else if (eventTargetIsCheckboxField && event.keyCode == 32)
                {
                    //Allow space bar for checkboxes
                }
                else if (event.keyCode >= 112 && event.keyCode <= 123)
                {
                    //Allow all Function keys
                }
                else if (event.keyCode == 109 || event.keyCode == 189 || event.keyCode == 173 && eventTarget.attr('id') == 'adjustAllScoresInput')
                {
                    //Allow negative values for Adjust All Scores option within mass assign
                }
                else
                {
                    //event.preventDefault();
                    //event.stopPropagation();
                }
            };

            var selectCorrespondingStudent = function (letter, shift, editMode)
            {
                var studentsWithSameLastInitials = gradebook.students.filter(function (s)
                {
                    if (editMode && gradebook.currentCell != null && gradebook.currentCell.length > 0)
                    {
                        var nextGradebookCell = gradebook.unlockedBody.find("td.gradebookCell[data-row='" + s.row + "'][data-column='" + gradebook.currentCell.data().column + "']");
                        if (nextGradebookCell && nextGradebookCell.length > 0 && nextGradebookCell.find("input:not(:disabled):not([readonly])").length > 0)
                        {
                            return s.name[0] == letter;
                        }
                    }
                    else
                    {
                        return s.name[0] == letter;
                    }
                    return false;
                });

                if (studentsWithSameLastInitials.length > 0)
                {
                    var studentRows = [];
                    for (var i = 0; i < studentsWithSameLastInitials.length; i++)
                    {
                        studentRows.push(studentsWithSameLastInitials[i].row);
                    }

                    var currentRow = getCurrentRow();
                    var currentRowIndex = studentRows.indexOf(currentRow.data("row")); //will return -1 if the current student does not have a last initial of letter

                    //will get the first student w/ that last initial, or if i'm on a student w/ that last initial, will get the row of the next one alphabetically by last name.
                    var nextRowNumber = currentRowIndex + 1 < studentsWithSameLastInitials.length ? studentRows[currentRowIndex + 1] : studentRows[0];

                    var nextCell = $("#" + BROWSE_NAME + "_unlockedRow" + nextRowNumber).find("[data-column='" + getCurrentCellNumber(currentRow) + "']");
                    setCurrentRecord(nextRowNumber, nextCell, shift);
                }
            };

            var selectNextVerticalCell = function (element, shift)
            {
                var td = $(element).closest(".gradebookCell"); //assignmentCell
                if (td.length == 0)
                {
                    return;
                }

                var data = td.data();
                if (data == null)
                {
                    return;
                }

                var newRow;
                var newTdCell;
                var rowCount = 0;
                do
                {
                    if (rowCount > gradebook.rowCount)
                    {
                        return;
                    }

                    if (shift)
                    {
                        newRow = data.row - (rowCount + 1) < 0 ? gradebook.rowCount - 1 : data.row - (rowCount + 1);
                    }
                    else
                    {
                        newRow = data.row + (rowCount + 1) > gradebook.rowCount - 1 ? 0 : data.row + (rowCount + 1);
                    }
                    newTdCell = $("#" + BROWSE_NAME + "_unlockedRow" + newRow).find(".gradebookCell[data-column='" + data.column + "']"); //assignmentCell
                    rowCount++;
                }
                while (newTdCell.find('.gradebookInput, .gradebookCheckbox, .gradebookInputCodeEEL, .codeEELDescription, .attemptCount').length == 0 || newTdCell.find('.gradebookInput, .gradebookCheckbox, .gradebookInputCodeEEL, .codeEELDescription, .attemptCount').is(':disabled,[readonly],.ui-disabled'));

                if ($.contains(newTdCell.get(0), element))
                {
                    $("#UpdateEditMode").focus();
                    return;
                }

                setCurrentRecord(newRow, newTdCell, shift);
            };

            var selectNextHorizontalCell = function (element, shift)
            {
                var currentCellSelector = ".gradebookCell, .editableGradeBucketCell"; //assignmentCell
                var nextCellSelector = ".gradebookCell:visible:not('.gradesheetAttemptsColumn'), .editableGradeBucketCell:visible"; //assignmentCell

                var td = $(element).closest(currentCellSelector);
                if (td.length == 0)
                {
                    return;
                }

                var data = td.data();
                if ($.isEmptyObject(data))
                {
                    return;
                }

                var newTdCell;
                var rowCount = 0;
                do
                {
                    if (rowCount > gradebook.rowCount)
                    {
                        return;
                    }

                    if (shift)
                    {
                        newTdCell = td.prevAll(nextCellSelector).first();
                    }
                    else
                    {
                        newTdCell = td.nextAll(nextCellSelector).first();
                    }

                    if (td.parent().hasClass('locked'))
                    {
                        rowCount--;
                    }

                    if (newTdCell.length == 0)
                    {
                        var newRow;
                        rowCount++;
                        if (shift)
                        {
                            newRow = data.row - rowCount < 0 ? gradebook.rowCount - 1 : data.row - rowCount;
                            newTdCell = $("#" + BROWSE_NAME + "_unlockedRow" + newRow).find(nextCellSelector).last();
                        }
                        else
                        {
                            newRow = data.row + rowCount > gradebook.rowCount - 1 ? 0 : data.row + rowCount;
                            newTdCell = $("#" + BROWSE_NAME + "_unlockedRow" + newRow).find(nextCellSelector).first();
                        }
                    }

                    if (td.parent().hasClass('locked'))
                    {
                        rowCount++;
                    }

                    td = newTdCell;
                }
                while (newTdCell.find('.gradebookInput, .gradebookCheckbox, .gradebookInputCodeEEL, .codeEELDescription, .attemptCount').length == 0 || newTdCell.find('.gradebookInput, .gradebookCheckbox, .gradebookInputCodeEEL, .codeEELDescription, .attemptCount').is(':disabled,[readonly],.ui-disabled'));

                var newTdCellData = newTdCell.data();
                if ($.isEmptyObject(newTdCellData))
                {
                    return;
                }

                if ($.contains(newTdCell.get(0), element))
                {
                    $("#UpdateEditMode").focus();
                    return;
                }

                setCurrentRecord(newTdCellData.row, newTdCell, shift);
            };

            var buildLegendPopup = function ()
            {
                var buildPopup = function ()
                {
                    var action = gradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "BuildColumnLegendPopupTeacherTracker" : "BuildColumnLegendPopup";

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        activityIndicator: { silent: true },
                        type: "POST",
                        dataType: "viewparthtml"
                    });
                };

                var options =
                {
                    draggable: true,
                    width: '940px',
                    anchorTo: $(this)
                };

                skyward.modalLayer.showDialog("Gradesheet Legend", buildPopup, { text: "Close", icon: "Close" }, options);
            };

            var setFocusOnInput = function (currentCellInput)
            {
                if (currentCellInput.length == 0)
                {
                    return;
                }
                currentCellInput.focus();
            };

            gradebook.getAdvancedColumnCellsByAssignmentID = function (assignmentID, defaultCollapsed, setFocusOnInput)
            {
                var assignmentExpandChevronContainer = $("#Gradebook_unlockedRowSpacerHeader").find("#assignmentHeaderCell" + assignmentID);
                var data = assignmentExpandChevronContainer.data();
                var assignmentHeaderCell = $("#assignment" + assignmentID + "HeaderCell");
                $.extend(data, assignmentHeaderCell.data());

                var myPromise = new $.Deferred();

                if ($(".advancedAssignmentCell" + assignmentID + ":not(." + COLLAPSED_CLASS_NAME + ")").length == 0)
                {
                    var assignmentExpander = $("#assignmentHeaderCell" + assignmentID + ".gradebookIconHeaderCell").find(".assignmentExpander");

                    if (assignmentExpander == null || assignmentExpander.length == 0)
                    {
                        myPromise.resolve();
                    }
                    else
                    {
                        var togglePromise = new $.Deferred();

                        if (!defaultCollapsed || $(".assignmentCell.advancedAssignmentCell" + assignmentID).length == 0) //If we have the cells but they are just 'Collapsed' then we don't need to do anything here, no need to add another promise
                        {
                            togglePromise = gradebook.toggleChildrenCellDisplay(assignmentExpander, { allowDuplicates: true, defaultCollapsed: defaultCollapsed, animate: false, setFocusOnInput: setFocusOnInput });
                        }
                        else
                        {
                            togglePromise.resolve();
                        }

                        $.when(togglePromise).done(function ()
                        {
                            myPromise.resolve();
                        });
                    }
                }
                else
                {
                    myPromise.resolve();
                }

                return myPromise.promise();
            };

            gradebook.updateIsMissingValueAndCheckFailingScoreClarifier = function (assignmentID, studentSectionID, scoreEarned, maxScore, percentEarned)
            {
                var deferred = $.Deferred();

                var assignmentHeaderCell = $("#assignment" + assignmentID + "HeaderCell");
                maxScore = maxScore ? maxScore : assignmentHeaderCell.data("maxscore");
                var percentEarnedFloat = getPercentEarned(scoreEarned, maxScore, percentEarned);

                var assignmentInput = gradebook.getAssignmentScoreInput(assignmentID, studentSectionID);
                var isMissingPuck = assignmentInput.parents(".gradebookCell").find(".assignmentIndicators:not(.hiddenMissingScore)").find("svg.missingScore.svg, svg.isMissing");
                var selectedValueID = assignmentInput.data('selectedValueID');

                var scoreChangeAdvancedAssignmentColumnHandler = getScoreChangeAdvancedAssignmentColumnHandler(false);

                if (scoreChangeAdvancedAssignmentColumnHandler.requiresAdvancedAssignmentColumns(percentEarnedFloat, gradebook.bodyData, isMissingPuck.length > 0, selectedValueID))
                {
                    $.when(gradebook.getAdvancedColumnCellsByAssignmentID(assignmentID, true, false)).done(function ()
                    {
                        var inputDataForGetAssignmentCellByField = { studentsectionid: studentSectionID, assignmentid: assignmentID };

                        scoreChangeAdvancedAssignmentColumnHandler.handleAdvancedAssignmentColumnUpdates(percentEarnedFloat, gradebook.bodyData, studentSectionID, assignmentID, isMissingPuck, true, selectedValueID);

                        deferred.resolve();
                    });
                }
                else
                {
                    deferred.resolve();
                }

                return deferred.promise();
            };

            var quickEntryTextEelComplete = function ()
            {
                var quickEnty = $(this);

                if (quickEnty.length < 1)
                {
                    return;
                }
                markCommentQuickEntryAsValid(quickEnty);

                var codeEELDescription = quickEnty.find(".codeEELDescription");

                if (codeEELDescription.length < 1)
                {
                    return;
                }
                gradebook.saveManager.setDirtyState(false);
                var data = codeEELDescription.data();
                gradebook.saveManager.save({ assignmentId: data.assignmentid, studentSectionId: data.studentsectionid, academicStandardId: data.academicStandardId, isAvailable: data.isAvailable, sectionId: getSectionIDFromCell(quickEnty) });
            };

            var scoreClarifierEelComplete = function (event, returnData)
            {
                var input = $(this);

                var inputData = input.data();

                removeCellErrorClasses(input.parents("td").first(), "noMatch");

                gradebook.saveManager.setDirtyState(false);

                var inputValue = returnData.selectedValueID;

                if (inputValue == null)
                {
                    inputValue = "";
                }

                skyward.gradebookcodeeel.setValue(input, returnData.matchedValue, inputValue, true);

                if (returnData.additionalFields && inputValue != "")
                {
                    $.each(returnData.additionalFields, function (key, value)
                    {
                        if ((key === "IsMissing" || key === "NoCount") && !value)
                        {
                            return;
                        }
                        var fieldDiv = getAssignmentCellByField(inputData, key);
                        if (fieldDiv.length && value == 'true')
                        {
                            var specificInput = fieldDiv.find("input");
                            specificInput.prop("checked", value);
                        }
                    });
                }

                var saveData =
                {
                    assignmentId: inputData.assignmentid,
                    studentSectionId: inputData.studentsectionid,
                    studentAssignmentId: inputData.studentassignmentid,
                    isAvailable: inputData.isAvailable,
                    sectionId: getSectionIDFromCell(input),
                    ScoreClarifierID:
                    {
                        displayValue: returnData.matchedValue
                    }
                };
                gradebook.saveManager.save(saveData);
            };

            var updateAssignmentHeaderCellExpandClasses = function (assignmentId, show)
            {
                var stripeClass = "advancedAssignmentStripe";
                var advancedExpandedClass = "advancedAssignmentExpanded";

                var assignmentHeaderCell = $(".browseHeaderColumn.assignmentHeaderCell[data-assignmentid='" + assignmentId + "']:not('.advancedAssignmentCell')");
                var assignmentCellRoundedCorners = assignmentHeaderCell.find(".assignmentCellRoundedCorners:not(.gradebookSecondaryContainer):not(.gradebookTertiaryContainer)");
                var tertiaryColumns = assignmentHeaderCell.find(".assignmentCellRoundedCorners.gradebookTertiaryContainer");
                var assignmentCellSecondaryContainers = assignmentHeaderCell.find(".assignmentCellRoundedCorners.gradebookSecondaryContainer");
                var assignmentHeaderSpacerCells = $(".assignmentHeaderCell[data-assignmentid='" + assignmentId + "']:not('.advancedAssignmentCell'):not('.browseHeaderColumn'), "
                    + ".assignmentHeaderCell.gradebookIconHeaderCell[data-assignmentid='" + assignmentId + "']:not('.advancedAssignmentCell')");

                if (show)
                {
                    if (assignmentHeaderCell.hasClass('lastColumnHideBorder'))
                    {
                        assignmentHeaderCell.removeClass('lastColumnHideBorder');
                        assignmentHeaderCell.addClass('lastColumnHideBorderExpanded');
                    }
                    assignmentHeaderCell.addClass(stripeClass);
                    assignmentCellRoundedCorners.addClass(advancedExpandedClass);
                    assignmentCellSecondaryContainers.addClass(stripeClass);
                    assignmentHeaderSpacerCells.addClass("expanded");

                    $.each(tertiaryColumns, function ()
                    {
                        var column = $(this);
                        if (column.hasClass("cornerEnd"))
                        {
                            column.removeClass("cornerEnd");
                            column.addClass("stripe");
                            column.addClass("cornerEndOnCollapse");
                        }
                    });

                }
                else
                {
                    if (assignmentHeaderCell.hasClass('lastColumnHideBorderExpanded'))
                    {
                        assignmentHeaderCell.addClass('lastColumnHideBorder');
                        assignmentHeaderCell.removeClass('lastColumnHideBorderExpanded');
                    }
                    assignmentHeaderCell.removeClass(stripeClass);
                    assignmentCellRoundedCorners.removeClass(advancedExpandedClass);
                    assignmentCellSecondaryContainers.removeClass(stripeClass);
                    assignmentHeaderSpacerCells.removeClass("expanded");

                    $.each(tertiaryColumns, function ()
                    {
                        var column = $(this);
                        if (column.hasClass("cornerEndOnCollapse"))
                        {
                            column.addClass("cornerEnd");
                            column.removeClass("stripe");
                            column.removeClass("cornerEndOnCollapse");
                        }
                    });
                }
            };

            var setAssignmentHeaderCellToDefaultColors = function (assignmentId)
            {

                var assignmentCell = $('#assignment' + assignmentId + 'HeaderCell');
                setAssignmentCellToColors(assignmentId, assignmentCell.data("defaultBackgroundColor"), assignmentCell.data("defaultTextColor"));
            };

            var setAssignmentCellToColors = function (assignmentId, categoryBackgroundColor, categoryTextColor)
            {

                var assignmentCell = $('#assignment' + assignmentId + 'HeaderCell');
                assignmentCell.css({ 'background-color': categoryBackgroundColor, 'color': categoryTextColor });
                $('.assignmentHeaderCell.advancedAssignmentCell' + assignmentId + ':not(.assignmentInformation)').css({ 'background-color': categoryBackgroundColor, 'color': categoryTextColor });
            };

            var saveUndrop = function (assignmentData)
            {
                var undropButton = $('#saveUndropScore');
                undropButton.off('click');

                gradebook.saveManager.setDirtyState(false);
                gradebook.saveManager.save({ studentAssignmentId: assignmentData.studentassignmentid, IsDropped: false, assignmentId: assignmentData.assignmentid, studentSectionId: assignmentData.studentsectionid, academicStandardId: assignmentData.academicStandardId, isAvailable: assignmentData.isAvailable, sectionId: assignmentData.sectionId });
            };

            var gradingPeriodOptionsPopup = function ()
            {
                var element = $(this);

                if (element.hasClass(PREVENT_CLICK_CLASS_NAME))
                {
                    return;
                }

                if (!gradebook.isGradebookFullyLoaded())
                {
                    gradebook.queueFunctionToCallOnCompletionOfLoad(gradingPeriodOptionsPopup, element, {});
                    return;
                }

                //Because we are potentially queuing this function there is a chance other popup actions got queued and we don't want multiple popups. So whichever was queued last will win
                skyward.window.closePopup();

                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();
                var gradebookData = gradebook.dataContainer.data();

                var data = element.data();
                var gradingPeriodID = data.gradingPeriodId;
                var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                var sectionID = data.sectionId;
                var isLockedGradeBucketColumn = element.parents(".lockedHeader").length > 0;
                var readOnly = $('#' + BROWSE_NAME).data().readOnly.toString().toLowerCase() == 'true';
                var action = localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "GradingPeriodOptionsTeacherTracker" : localGradebookData.classGroupId ? "GradingPeriodOptionsClassGroup" : "GradingPeriodOptions";
                var sectionIDHash = localGradebookData.sectionIdHash;
                var inScoringMode = isInScoringMode();
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        gradingPeriodID: gradingPeriodID,
                        gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                        calculationGroupID: gradebookData.calculationgroupid,
                        districtID: gradebookData.districtid,
                        sectionID: sectionID,
                        readOnly: readOnly,
                        isLockedGradeBucketColumn: isLockedGradeBucketColumn,
                        gradebookType: localGradebookData.gradebookType,
                        assignmentID: localGradebookData.assignmentId, //This will only be set on single assignment score entry
                        sectionIDHash: sectionIDHash,
                        classGroupID: localGradebookData.classGroupId,
                        classGroupIDHash: localGradebookData.classGroupIdHash,
                        filteredStudentSectionId: localGradebookData.filteredStudentSectionId,
                        isInScoringMode: inScoringMode
                    },
                    success: async function (response)
                    {
                        if (response.htmlValue)
                        {
                            //The below commented out code can be used again when we determine what we want to do about disabling/enabling buttons
                            //if (!inScoringMode|| !response.massScoreIsDisabled)
                            //{
                            const htmlContent = $(await skyward.global.processViewPartHtml(response.htmlValue.Content))
                            var hasSubjectsOrStandardsToDisplayBrowse = htmlContent.find(".subjectsToDisplayBrowse").length > 0 || htmlContent.find(".academicStandardsToDisplayBrowse").length > 0;
                            var saveButton = (readOnly || inScoringMode) && !hasSubjectsOrStandardsToDisplayBrowse ? null : { id: "saveGradingPeriodOptions", text: "Save", click: function () { gradingPeriodOptionsSave(gradingPeriodID, sectionID, currentHeaderPopupDialog, isLockedGradeBucketColumn, gradingPeriodGradeBucketID, localGradebookData.isTeacherTracker); }, icon: "Save" };
                            var cancelButton = { id: "cancelGradingPeriodOptions", text: "Cancel", click: function () { currentHeaderPopupDialog.close(); }, icon: "Cancel" };
                            var options =
                            {
                                anchorTo: element,
                                id: "gradingPeriodOptionsPopup"
                            };

                            var buttons = [];

                            if (saveButton != null)
                            {
                                buttons.push(saveButton);
                            }

                            buttons.push(cancelButton);
                            currentHeaderPopupDialog = skyward.modalLayer.showDialog("Grading Period Options", response.htmlValue.Content, buttons, options);
                            //}
                        }
                        return;
                    }
                });
            };

            var gradingPeriodOptionsSave = function (gradingPeriodID, sectionID, dialog, isLockedGradeBucketColumn, gradingPeriodGradeBucketID, isTeacherTracker)
            {
                var currentButton = $("#saveGradingPeriodOptions");
                currentButton.addClass("ui-disabled");
                $.when(gradingPeriodOptionsSaveAjax(gradingPeriodID, sectionID, dialog, isLockedGradeBucketColumn, gradingPeriodGradeBucketID, isTeacherTracker)).done(function ()
                {
                    currentButton.removeClass("ui-disabled");
                });
            };

            var gradingPeriodOptionsSaveAjax = function (gradingPeriodID, sectionID, dialog, isLockedGradeBucketColumn, gradingPeriodGradeBucketID, isTeacherTracker)
            {
                var completedCheckbox = dialog.content.find('#gradingPeriodOptions_Completed');
                var completed = completedCheckbox.is(':checked');
                var calculationGroupGradeBucketIDLocked = skyward.controls.getValue(dialog.content.find('#CalculationGroupGradeBucketIDLocked_value'));

                var subjectsToDisplay = dialog.container.find(".subjectsToDisplayBrowse");
                var academicStandardsToDisplay = dialog.container.find(".academicStandardsToDisplayBrowse");

                var saveAction = "GradingPeriodOptionsSave";
                if (isTeacherTracker.toString().toLowerCase() == "true")
                {
                    saveAction += "TeacherTracker";
                }

                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + saveAction,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        gradingPeriodID: gradingPeriodID,
                        sectionID: sectionID,
                        completed: completed,
                        calculationGroupGradeBucketIDLocked: calculationGroupGradeBucketIDLocked,
                        isLockedGradeBucketColumn: isLockedGradeBucketColumn,
                        gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                        SubjectsToDisplay: subjectsToDisplay.length > 0 ? JSON.stringify(subjectsToDisplay.data("editablebrowsedata")) : null,
                        AcademicStandardsToDisplay: academicStandardsToDisplay.length > 0 ? JSON.stringify(academicStandardsToDisplay.data("editablebrowsedata")) : null,
                        markUnscoredPastDueAssignmentsAsMissing: skyward.controls.getValue(dialog.content.find(".markUnscoredPastDueAssignmentsAsMissing")),
                    },
                    success: function (response)
                    {
                        dialog.close();
                        if (response.success)
                        {
                            if (response.requiresRefresh)
                            {
                                dialog.close();
                                var action = "ReloadGradebook";
                                if (gradebookData.isTeacherTracker)
                                {
                                    action += "TeacherTracker";
                                }
                                gradebook.reloadGradebook('Gradebook', 'Gradebook', action);
                                return;
                            }

                            if (completed)
                            {
                                gradingPeriodOptionsDisableCompleted(gradingPeriodID, gradingPeriodGradeBucketID);
                            }

                            $('#Gradebook').trigger('gradebook.scoringModeControlsChange');
                        }
                    }
                });
            };

            var nonAssignmentMassAssignPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var inScoringModeOnButtonClick = isInScoringMode();
                var postData = $.extend({}, data);

                if (inScoringModeOnButtonClick === false)
                {
                    updateEditMode();
                }

                var popupID = "MassAssignScores";
                var headerText = "Mass Assign Scores";

                if (currentHeaderPopupDialog)
                {
                    currentHeaderPopupDialog.close();
                }

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + data.screen,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: postData
                    });
                };

                var saveButton = {
                    text: "Save", "click": function ()
                    {
                        $.when(gradebook.massAssignHelper.applyButtonClick.call($(this))).done(function (errors)
                        {
                            if (errors && errors.length > 0)
                            {
                                var errorMessage = errors.join("<br />");
                                skyward.modalLayer.showErrorDialog("Mass Assign Scores", errorMessage);
                            }
                            else
                            {
                                dialog.close();
                            }
                        });
                    }, "icon": "Save", "data": data
                };
                var closeButton = { text: "Cancel", "click": function () { dialog.close(); }, "icon": "Cancel" };
                var options =
                {
                    closeOnEscape: false,
                    draggable: true,
                    id: popupID
                };
                var dialog = skyward.modalLayer.showDialog(headerText, buildPopup, [saveButton, closeButton], options);
                dialog.content.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL", gradeMarkScoringEelCompleteMassAssign);
                dialog.content.on("gradebookInputCodeEELInvalid", ".gradebookInputCodeEEL", gradeMarkScoringEelFailed);
                dialog.content.on("keydown", ".gradebookInputCodeEEL", browseKeyDown);

                dialog.modalLayer.options.afterClose = function (result)
                {
                    var wrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);

                    var errorsOnSave = wrapper.hasClass("errorDuringSave") || wrapper.hasClass("studentAssignmentError") || wrapper.hasClass("studentGradeBucketError");
                    if (inScoringModeOnButtonClick === false && !errorsOnSave)
                    {
                        gradebook.updateEditModeNoDialog();
                    }
                };
            };

            var currentHeaderPopupDialog;
            var assignmentHeaderPopup = function ()
            {
                var element = $(this);

                if (!gradebook.isGradebookFullyLoaded())
                {
                    gradebook.queueFunctionToCallOnCompletionOfLoad(assignmentHeaderPopup, element, {});
                    return;
                }

                //Because we are potentially queuing this function there is a chance other popup actions got queued and we don't want multiple popups. So whichever was queued last will win
                skyward.window.closePopup();

                //check if it's scoring mode and pass that
                var data = element.data();
                var postData =
                {
                    allowMassScoreOptions: data.allowmassscoreoptions,
                    assignmentID: data.assignmentid,
                    representedAssignmentIDs: data.representedAssignmentIds,
                    sectionID: data.sectionid,
                    districtID: gradebook.dataContainer.data().districtid,
                    isInScoringMode: isInScoringMode(),
                };
                var controllerAction = "AssignmentHeaderPopup";
                var popupID = "AssignmentHeaderPopup";
                var headerText = "Assignment Options";

                currentHeaderPopupDialog = sharedHeaderPopup(element, postData, controllerAction, popupID, headerText);
            };

            var saveAcademicStandardsToDisplay = function (data, dialog)
            {
                var academicStandardsToDisplay = dialog.container.find(".academicStandardsToDisplayBrowse");

                data.AcademicStandardsToDisplay = academicStandardsToDisplay.length > 0
                    ? JSON.stringify(academicStandardsToDisplay.data("editablebrowsedata"))
                    : null;

                var action = "SaveAcademicStandardsToDisplay";
                if (gradebook.data.isTeacherTracker.toString().toLowerCase() == "true")
                {
                    action += "TeacherTracker";
                }

                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function (response)
                    {
                        dialog.close();
                        if (response.success)
                        {
                            if (response.requiresRefresh)
                            {
                                dialog.close();
                                var action = "ReloadGradebook";
                                if (gradebookData.isTeacherTracker)
                                {
                                    action += "TeacherTracker";
                                }
                                gradebook.reloadGradebook('Gradebook', 'Gradebook', action);
                                return;
                            }
                        }
                    }
                });
            };

            var standardHeaderPopup = function ()
            {
                var element = $(this);

                if (element.hasClass(PREVENT_CLICK_CLASS_NAME))
                {
                    return;
                }

                if (!gradebook.isGradebookFullyLoaded())
                {
                    gradebook.queueFunctionToCallOnCompletionOfLoad(standardHeaderPopup, element, {});
                    return;
                }

                var gradebookData = gradebook.dataContainer.data();
                //Because we are potentially queuing this function there is a chance other popup actions got queued and we don't want multiple popups. So whichever was queued last will win
                skyward.window.closePopup();

                var data = element.data();
                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();

                var postData =
                {
                    calculationGroupAcademicStandardGradeBucketID: data.calculationGroupAcademicStandardGradeBucketId,
                    academicStandardID: data.academicStandardId,
                    districtID: gradebook.dataContainer.data().districtid,
                    gradingPeriodGradeBucketID: data.gradingPeriodGradeBucketId,
                    gradingPeriodID: data.gradingPeriodId,
                    calculationGroupID: data.calculationGroupId,
                    sectionID: data.sectionId,
                    classGroupId: gradebookData.classGroupId,
                    isInScoringMode: isInScoringMode(),
                    filteredStudentSectionId: localGradebookData.filteredStudentSectionId
                };
                var controllerAction = "StandardHeaderPopup";
                var popupID = "StandardHeaderPopup";
                var headerText = "Academic Standard Options";

                currentHeaderPopupDialog = sharedHeaderPopup(element, postData, controllerAction, popupID, headerText);
            };

            var subjectHeaderPopup = function ()
            {
                var element = $(this);

                if (element.hasClass(PREVENT_CLICK_CLASS_NAME))
                {
                    return;
                }

                if (!gradebook.isGradebookFullyLoaded())
                {
                    gradebook.queueFunctionToCallOnCompletionOfLoad(subjectHeaderPopup, element, {});
                    return;
                }

                var gradebookData = gradebook.dataContainer.data();
                //Because we are potentially queuing this function there is a chance other popup actions got queued and we don't want multiple popups. So whichever was queued last will win
                skyward.window.closePopup();

                var data = element.data();
                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();
                var postData =
                {
                    calculationGroupSubjectGradeBucketID: data.calculationGroupSubjectGradeBucketId,
                    gradingPeriodGradeBucketID: data.gradingPeriodGradeBucketId,
                    gradingPeriodID: data.gradingPeriodId,
                    calculationGroupID: data.calculationGroupId,
                    sectionID: data.sectionId,
                    classGroupId: gradebookData.classGroupId,
                    subjectID: data.subjectId,
                    districtID: gradebook.dataContainer.data().districtid,
                    isInScoringMode: isInScoringMode(),
                    filteredStudentSectionId: localGradebookData.filteredStudentSectionId
                };
                var controllerAction = "SubjectHeaderPopup";
                var popupID = "SubjectHeaderPopup";
                var headerText = "Subject Options";

                currentHeaderPopupDialog = sharedHeaderPopup(element, postData, controllerAction, popupID, headerText);
            };

            var sharedHeaderPopup = function (element, data, controllerAction, popupID, headerText)
            {
                if (element.hasClass('gradebookScoringMode-On'))
                {
                    return;
                }

                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();
                var gradebookData = gradebook.dataContainer.data();

                var requiredData = getRequiredGradebookData();
                if (requiredData.GradebookRequiredData)
                {
                    data.GradebookType = JSON.parse(requiredData.GradebookRequiredData).GradebookType;
                }
                var isLockedGradeBucketColumn = element.parents(".lockedHeader").length > 0;
                var readOnly = $('#' + BROWSE_NAME).data().readOnly.toString().toLowerCase() == 'true';

                controllerAction += localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "TeacherTracker" : localGradebookData.classGroupId ? "ClassGroup" : "";
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + controllerAction,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: async function (response)
                    {
                        if (response.htmlValue)
                        {
                            var buttons = [];

                            const responseContent = $(await skyward.global.processViewPartHtml(response.htmlValue.Content))

                            if (responseContent.find("#AcademicStandardsToDisplay").length > 0 || response.requiresSaveButton)
                            {
                                var saveButton = {
                                    text: "Save", click: function ()
                                    {
                                        saveAcademicStandardsToDisplay(data, currentHeaderPopupDialog);
                                    }, icon: "Save"
                                };

                                var cancelButton = { text: "Cancel", click: function () { currentHeaderPopupDialog.close(); }, icon: "Cancel" };

                                buttons.push(saveButton);
                                buttons.push(cancelButton);
                            }

                            var options =
                            {
                                anchorTo: element,
                                id: popupID
                            };
                            currentHeaderPopupDialog = skyward.modalLayer.showDialog(headerText, responseContent, buttons, options);
                            return currentHeaderPopupDialog;
                        }
                        return;
                    }
                });
            };

            var viewGradingScale = function ()
            {
                var button = $(this);

                var buttonData = button.data();
                var action = buttonData.screen;
                var closeButton = { id: "cancelButton", text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: buttonData,
                    });
                };
                var options =
                {
                    anchorTo: button,
                    allowNoButtons: true,
                    draggable: true
                };

                var dialog = skyward.modalLayer.showDialog("Grading Scale", buildPopup, [closeButton], options);
                return dialog;
            };

            var viewStudentGradeContainerAudit = function ()
            {
                var button = $(this);

                var buttonData = button.data();
                var action = "StudentGradeContainerOverrideAudit";
                if (buttonData && buttonData.isTeacherTracker.toString().toLowerCase() == "true")
                {
                    action = action + "TeacherTracker";
                }
                var closeButton = { id: "cancelButton", text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: buttonData,
                    });
                };
                var options =
                {
                    anchorTo: button,
                    allowNoButtons: true,
                    draggable: true
                };

                var dialog = skyward.modalLayer.showDialog("Grade History", buildPopup, [closeButton], options);
                return dialog;
            };


            var gradingPeriodOptionsDisableCompleted = function (gradingPeriodID, gradingPeriodGradeBucketID)
            {
                var elements = $('.gradebookScoringModeControl[data-grading-period-id="' + gradingPeriodID + '"], .gradingPeriodCompletedButton[data-grading-period-id="' + gradingPeriodID + '"], .browseHeaderAssignmentIconContainer[data-grading-period-id="' + gradingPeriodID + '"], .gradeBucketCell[data-grading-period-id="' + gradingPeriodID + '"], .subjectCell[data-grading-period-id="' + gradingPeriodID + '"], .academicStandardCell[data-grading-period-id="' + gradingPeriodID + '"]');

                $.each(elements, function ()
                {
                    var element = $(this);

                    if (element.hasClass("gradeBucketCell") || element.hasClass("subjectCell") || element.hasClass("academicStandardCell"))
                    {
                        element.find(".gradebookInputCodeEEL").addClass('gradingPeriodCompleted scoringModeDoesntAffectState').attr('disabled', 'true').attr('readonly', 'readonly');
                    }

                    element.addClass('gradingPeriodCompleted scoringModeDoesntAffectState');
                    element.attr('readonly', 'readonly');
                    element.attr('disabled', 'true');
                });

            };

            var disableTransferInputs = function (transferAndDoNotPostStudentSectionsThatShouldNotHaveTheirScoringModeClassesRemoved, gradingPeriodID, gradingPeriodGradeBucketID)
            {
                $(transferAndDoNotPostStudentSectionsThatShouldNotHaveTheirScoringModeClassesRemoved).each(function ()
                {
                    currentStudentSection = $(this);
                    var elements = $('.scoringModeDoesntAffectState[data-grading-period-id="' + gradingPeriodID + '"][data-studentsectionid="' + currentStudentSection['0'].StudentSectionID + '"], .codeEELDescription[data-grading-period-id="' + gradingPeriodID + '"]' + "[data-studentsectionid='" + currentStudentSection['0'].StudentSectionID + "']");
                    elements.removeClass('transferOrDoNotPostGradeShouldNotBeActivated').addClass('transferOrDoNotPostGradeShouldNotBeActivated');
                });
            };

            var showNewStudentInfo = function ()
            {
                var button = $(this);
                var data = button.data();
                var isTeacherTracker = gradebookData.isTeacherTracker.toString().toLowerCase() == "true";
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + (isTeacherTracker ? "NewStudentPopupTeacherTracker" : "NewStudentPopup"),
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: data,
                    success: function (htmlData)
                    {
                        if (htmlData.success == false && htmlData.popupHTML)
                        {
                            checkAjaxResponseForErrors(htmlData);
                        }
                        else
                        {
                            checkPopupSaveButton(htmlData, "hideNewStudentIndicator");

                            var options = {};
                            if (!data.clickAction)
                            {
                                options = { anchorTo: button };
                            }

                            var hidePopupButton = { id: "hideNewStudentIndicator", text: "Save", click: function () { hideNewStudentIndicator(data, dialog); }, icon: "Save" };
                            var cancelButton = { id: "cancelNewStudentStartingPercents", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
                            var dialog = skyward.modalLayer.showDialog("New Student", htmlData.htmlValue.Content, [isTeacherTracker ? null : hidePopupButton, cancelButton], options);
                        }
                    }
                });
            };

            var showAlternativeCreditCourseStudentInfo = function ()
            {
                var button = $(this);
                var data = button.data();
                var isTeacherTracker = gradebookData.isTeacherTracker.toString().toLowerCase() == "true";
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + (isTeacherTracker ? "AlternativeCreditCourseInfoTeacherTracker" : "AlternativeCreditCourseInfo"),
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: data,
                    success: function (returnData)
                    {
                        if (returnData.success == false && returnData.popupHTML)
                        {
                            checkAjaxResponseForErrors(returnData);
                        }
                        else
                        {
                            var options = {};
                            if (!data.clickAction)
                            {
                                options = { anchorTo: button };
                            }

                            skyward.modalLayer.showInformationDialog("Alternative Credit Course", returnData.htmlValue.Content, null, options);
                        }
                    }
                });
            };

            var hideNewStudentIndicator = function (data, dialog)
            {
                var hidePopupButton = $('#hideNewStudentIndicator');
                var hideIndicator = dialog.content.find('#hideIndicatorCheckbox').is(':checked');
                hidePopupButton.off('click');

                var ajaxData =
                {
                    studentSectionID: data.studentSectionId,
                    hideNewStudentIcon: hideIndicator
                };

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/HideNewStudentIndicator",
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: ajaxData,
                    success: function (response)
                    {
                        hidePopupButton.on('click', hideNewStudentIndicator);
                        var button = $('#Gradebook_body .newStudentButton[data-student-section-id="' + data.studentSectionId + '"]');
                        var transferButton = $('#Gradebook_body .runTransferProcess[data-student-section-id="' + data.studentSectionId + '"]');
                        if (response.success)
                        {
                            if (hideIndicator)
                            {
                                //button selects for locked and unlocked browse, but we only want to check one of the two in the condition
                                var buttonAtIndexZero = $(button[0]);
                                if (buttonAtIndexZero.siblings(".displayNone").length === buttonAtIndexZero.siblings().length)
                                {
                                    button.parent(".buttonsVisible").removeClass("buttonsVisible");
                                }
                                if (!button.hasClass("displayNone"))
                                {
                                    button.addClass("displayNone");
                                    transferButton.addClass("displayNone");
                                }
                            }
                            if (!hideIndicator)
                            {
                                if ($(button).parent(":not(buttonsVisible)").length > 0)
                                {
                                    button.parent(":not(buttonsVisible)").addClass("buttonsVisible");
                                }
                                if (button.hasClass("displayNone"))
                                {
                                    button.removeClass("displayNone");
                                    transferButton.removeClass("displayNone");
                                }
                            }
                        }
                        dialog.close();
                    }
                });
            };

            var exportBrowse = function ()
            {
                var data = getRequiredGradebookData();
                var gradebookRequiredData = {};
                Object.assign(gradebookRequiredData, data);
                data.GradebookRequiredData = gradebookRequiredData;

                var url = skyward.global.virtualDir + "Gradebook/Gradebook/GetBrowseExport";
                skyward.window.submitForm(url, data, { openNewWindow: false, downloadOnMobile: true });
            };

            var printBlankGradesheet = function ()
            {
                var element = $(this);
                var data = element.data();

                var action = "BlankGradesheetOptionPopup";
                if (data.isTeacherTracker.toString().toLowerCase() == "true")
                {
                    action += "TeacherTracker";
                }
                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true }
                    });
                };

                var createButton = { id: 'blankGradesheetPopupCreate', text: "Print Preview", click: function () { blankGradesheetCreate(dialog); }, icon: "Eye" };
                var exportButton = { id: 'blankGradesheetPopupViewExport', text: "Export Preview", click: function () { blankGradesheetViewExport(dialog); }, icon: "Eye" };
                var closeButton = { id: 'printBlankGradesheetPopupClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var dialog = skyward.modalLayer.showDialog('Print/Export Blank Gradesheet Options', buildPopup, [exportButton, createButton, closeButton]);
            };

            var blankGradesheetCreate = function (dialog)
            {
                var buildGrid = blankGradesheetBuild(dialog, 'CreateBlankGradesheet');
                var downloadButton = { id: 'blankGradesheetPopupPrint', text: "Download", click: function () { blankGradesheetDownload(dialog); gridPopup.close(); }, icon: "Download" };
                var printButton = { id: 'blankGradesheetPopupPrint', text: "Print", click: function () { blankGradesheetPrint(dialog); gridPopup.close(); }, icon: "PrintAvailable" };
                var closeButton = { id: 'blankGradesheetPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Print Blank Gradesheet Options', buildGrid, [printButton, downloadButton, closeButton]);

                gridPopup.container[0].className += " maxWidth90";
            };

            var blankGradesheetViewExport = function (dialog)
            {
                var buildGrid = blankGradesheetBuild(dialog, 'CreateClassRosterExport');

                var exportButton = { id: 'blankGradesheetPopupExport', text: "Export", click: function () { blankGradesheetExport(gridPopup); }, icon: "Excel" };
                var closeButton = { id: 'blankGradesheetPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Blank Gradesheet Export Preview', buildGrid, [exportButton, closeButton]);

                gridPopup.container[0].className += " maxWidth90";
            };

            var blankGradesheetExport = function (popup)
            {
                var browseid = popup.content.find('.browse').attr('id');
                var browse = skyward.browse.browseList[browseid];

                var data = skyward.browse.getRequiredBrowseData(browse, {});
                data.GradebookRequiredData = getRequiredGradebookData();

                var url = skyward.global.virtualDir + "Scheduling/StudentSection/GetBrowseExport";
                skyward.window.submitForm(url, data, { openNewWindow: false, downloadOnMobile: true });
                popup.close();
            };

            var blankGradesheetBuild = function (dialog, action)
            {
                return function ()
                {
                    var data = GetBlankGradesheetData(dialog);
                    data.filteredStudentSectionId = getRequiredGradebookData().filteredStudentSectionId;
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: data
                    });
                };
            };

            var GetBlankGradesheetData = function (dialog)
            {
                //todo: pass in gradebook required data
                var printClassDetails = dialog.content.find('.printClassOptionHeader').is(':checked');
                var showStudentNames = dialog.content.find('.showStudentNames').is(':checked');
                var showStudentNumbers = dialog.content.find('.showStudentNumbers').is(':checked');
                var showStudentGradeLevels = dialog.content.find('.showStudentGradeLevels').is(':checked');
                var showStudentIndicators = dialog.content.find('.showStudentIndicators').is(':checked');
                var numberOfColumns = dialog.content.find('.numberOfColumns').val();
                var columnWidth = dialog.content.find('#columnWidthRadioButtonGroup.radioButtonGroupValue').val();
                var rowHeight = dialog.content.find('#rowHeightRadioButtonGroup.radioButtonGroupValue').val();

                var data = $('.printBlankGradesheetOptionsPopupContent').data();
                var sectionID = data.sectionid.toString();

                var returnData =
                {
                    printClassDetails: printClassDetails,
                    showStudentNames: showStudentNames,
                    showStudentNumbers: showStudentNumbers,
                    showStudentGradeLevels: showStudentGradeLevels,
                    showStudentIndicators: showStudentIndicators,
                    numberOfColumns: numberOfColumns,
                    columnWidth: columnWidth,
                    rowHeight: rowHeight,
                    sectionID: sectionID
                };

                return returnData;
            };

            var blankGradesheetDownload = function (dialog)
            {
                skyward.printScreen.launchWorkflow(skyward.global.virtualDir + 'Gradebook/Gradebook/PrintBlankGradesheet', GetBlankGradesheetData(dialog));

                return true;
            };

            var blankGradesheetPrint = function ()
            {
                var data = document.getElementsByClassName('blankGradesheet')[0].innerHTML;
                var mywindow = window.open('', 'Print Gradesheet');
                mywindow.document.write('<html lang="en-us"><head><title>Blank Gradesheet</title>');
                //Using the browser's print preview requires using a new window. Need to set styles in-line, due to new window not having stylesheet.
                mywindow.document.write('</head><body><style type="text/css">@media all {table > tbody > tr.blankGradeSheetRow_small { height:25px; }');
                mywindow.document.write('table > tbody > tr.blankGradeSheetRow_medium { height:40px; }');
                mywindow.document.write('table > tbody > tr.blankGradeSheetRow_large { height:65px; }');
                mywindow.document.write('table > tbody > tr > td > .cellDiv.small  { width:45px; }');
                mywindow.document.write('table > tbody > tr > td > .cellDiv.medium { width:70px; }');
                mywindow.document.write('table > tbody > tr > td > .cellDiv.large, table > tbody > tr > td > .cellDiv.lockedColumnCellDiv { width:130px; }');
                mywindow.document.write('tr { page-break-inside:avoid;}');
                mywindow.document.write('table, table > tbody > tr > td { border-color:Black; border-style:solid; border-width:1px; border-collapse:collapse; font-size: x-small;}}');
                mywindow.document.write('.fieldWrapper { border-style:none; display:inline-block; }');
                mywindow.document.write('label.title { font-weight:bold; text-align:right; color:#4f4f4d; display:inline-block; vertical-align:top; max-width: 234px; font-size: x-small; }');
                mywindow.document.write('.fieldWrapper .message { display:inline-block; text-align:left; color:#4f4f4d; padding:1px 5px 2px 5px; font-size: x-small;}');
                mywindow.document.write('.boldFont { font-weight:bold;}');
                mywindow.document.write('</style>');
                mywindow.document.write(data);
                mywindow.document.write('</body></html>');

                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10

                setTimeout(() =>
                {
                    mywindow.print();
                    mywindow.close();
                });

                return true;
            };

            var studentSectionNote = function ()
            {
                var button = $(this);
                var data = button.data();
                var title = data.title;
                var requiredData = getRequiredGradebookData();

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/StudentSectionNote/" + (data.isTeacherTracker.toString().toLowerCase() == "true" ? "TeacherTracker" : "") + "GradebookPopup",
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: $.extend(data, requiredData)
                    });
                };
                var options =
                {
                    anchorTo: button
                };
                skyward.modalLayer.showInformationDialog(title, buildPopup, null, options);
            };

            var handlePercentAdjustmentTabbing = function (studentGradeBucketID)
            {
                var percentAdjustmentComment = $("#PercentAdjustmentComment_" + studentGradeBucketID);
                var percentAdjustmentValue = $("#PercentAdjustment_" + studentGradeBucketID);

                if (percentAdjustmentValue.length != 0 && percentAdjustmentComment.length != 0)
                {
                    if (skyward.controls.getValue(percentAdjustmentValue).length == 0)
                    {
                        skyward.controls.setValue(percentAdjustmentComment, "", true);
                        percentAdjustmentComment.attr('readOnly', true);
                        $('#cancelStudentGradeBucketOptions').focus();
                    }
                    else
                    {
                        percentAdjustmentComment.attr('readOnly', false);
                        percentAdjustmentComment.focus();
                    }
                }
            };

            var handleGradeMarkOverrideTabbing = function (studentGradeBucketID)
            {
                var gradeMarkOverrideComment = $("#GradeMarkOverrideComment_" + studentGradeBucketID);
                var gradeMarkOverrideValue = $("#GradeMarkOverride_" + studentGradeBucketID + "_code");

                if (gradeMarkOverrideValue.length != 0 && gradeMarkOverrideComment.length != 0)
                {
                    if (skyward.controls.getValue(gradeMarkOverrideValue).length == 0)
                    {
                        skyward.controls.setValue(gradeMarkOverrideComment, "");
                        gradeMarkOverrideComment.attr('readOnly', true);
                        $('#cancelStudentGradeBucketOptions').focus();
                    }
                    else
                    {
                        gradeMarkOverrideComment.attr('readOnly', false);
                        gradeMarkOverrideComment.focus();
                    }
                }
            };

            var studentGradeBucketOptionsPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var objectID = data.studentGradeBucketId;
                var row = element.parents("tr").first();
                data.studentSectionId = row.data().studentSectionId;
                return studentGradeBucketObjectOptions(false, element, data, objectID, false, false);
            };

            var studentGradeBucketOptionsPopupSelfPacedOnly = function ()
            {
                var element = $(this);
                var data = element.data();
                var objectID = data.studentGradeBucketId;
                return studentGradeBucketObjectOptions(true, element, data, objectID, false, false);
            };

            var studentGradeBucketSubjectOptionsPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var objectID = data.studentGradeBucketSubjectId;
                return studentGradeBucketObjectOptions(false, element, data, objectID, true, false);
            };

            var studentGradeBucketAcademicStandardOptionsPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var objectID = data.studentGradeBucketAcademicStandardId;
                return studentGradeBucketObjectOptions(false, element, data, objectID, false, true);
            };

            var html;
            var gradingScale;
            var isActiveOrUnlocked;

            var studentGradeBucketObjectOptions = function (isSelfPacedOnly, element, data, objectID, isSubject, isAcademicStandard)
            {
                var isInScoringMode = $("#UpdateEditMode").children("span").text() === GRADEBOOK_EXIT_SCORING_MODE || $(".gradebookScoringMode-On").length > 0;

                if (isInScoringMode == true)
                {
                    if (isSubject || isAcademicStandard)
                    {
                        //Potentially implement later if needed
                        return;
                    }
                    return studentGradeBucketOptionsScoringMode(element, data);
                }

                var studentGradeBucketID = data.studentGradeBucketId;
                var gradingPeriodID = data.gradingPeriodId;
                var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                var gradebookData = gradebook.dataContainer.data();
                var sectionID = gradebook.getSectionData(element).sectionID;
                var bucketEnabled = true;

                var gpgbElement = $('.gradeBucketHeaderCell[data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                var gpgbData = gpgbElement.data();
                var bucketDisplayType = gpgbData.bucketDisplayType;
                var bucketSectionIsSelfPacedAndActive = gpgbData.bucketSectionIsSelfPacedAndActive;

                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();
                var objectLabel = "";
                var objectDialogLabel = "";

                var readOnly = localGradebookData.readOnly;
                readOnly = readOnly.toString().toLowerCase() == 'true';
                bucketSectionIsSelfPacedAndActive = bucketSectionIsSelfPacedAndActive.toString().toLowerCase() == 'true';
                if (readOnly)
                {
                    bucketEnabled = false;
                }

                var data =
                {
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    calculationGroupID: gradebookData.calculationgroupid,
                    bucketDisplayType: bucketDisplayType,
                    readOnly: readOnly
                };
                $.extend(data, gradebook.getSectionData(element));

                if (isSubject == true)
                {
                    var calculationGroupSubjectGradeBucketID = element.data('calculationGroupSubjectGradeBucketId');
                    var subjectHeaderElement = $('.subjectHeaderCell[data-calculation-group-subject-grade-bucket-id="' + calculationGroupSubjectGradeBucketID + '"]');

                    if (subjectHeaderElement.length >= 0)
                    {
                        objectDialogLabel = subjectHeaderElement.children('.subjectHeaderTextContainerDiv').text();
                    }

                    objectLabel = "Subject";
                    $.extend(data, { studentGradeBucketSubjectID: objectID });
                }
                else if (isAcademicStandard == true)
                {
                    objectDialogLabel = "Academic Standard";
                    objectLabel = "AcademicStandard";
                    $.extend(data, { studentGradeBucketAcademicStandardID: objectID });
                }

                var deferred = $.Deferred();

                if (isSelfPacedOnly && !(isSubject == true || isAcademicStandard == true))
                {
                    $.when(buildPopup(true, data, localGradebookData, objectLabel)).done(function (responseData)
                    {
                        if (html)
                        {
                            if ((!isActiveOrUnlocked && !bucketSectionIsSelfPacedAndActive) || !bucketEnabled)
                            {
                                bucketEnabled = false;
                            }

                            var dialog = getDialog("Mark a student's grade complete for ", bucketEnabled, objectID, gradingPeriodID, sectionID, bucketDisplayType, element, gpgbData, html, isSubject, isAcademicStandard, objectLabel, objectDialogLabel, bucketSectionIsSelfPacedAndActive, data, responseData);
                            updateAdjustedGrade(dialog, gradingScale);
                        }
                        deferred.resolve();
                    });
                }
                else
                {
                    $.when(buildPopup(false, data, localGradebookData, objectLabel)).done(function (responseData)
                    {
                        if (html)
                        {
                            if ((!isActiveOrUnlocked && !bucketSectionIsSelfPacedAndActive) || !bucketEnabled)
                            {
                                bucketEnabled = false;
                            }
                            var dialog = getDialog("Override or Adjust Student's Grade for ", bucketEnabled, objectID, gradingPeriodID, sectionID, bucketDisplayType, element, gpgbData, html, isSubject, isAcademicStandard, objectLabel, objectDialogLabel, bucketSectionIsSelfPacedAndActive, data, responseData);
                            dialog.content.on("change", "input.percentAdjustmentTextBox", function () { handlePercentAdjustmentTabbing(objectID); });
                            dialog.content.on("input", "input.percentAdjustmentTextBox", function () { updateAdjustedGrade(dialog, gradingScale); });
                            dialog.content.on("eelComplete", ".codeEEL", function ()
                            {
                                handleGradeMarkOverrideTabbing(objectID);
                                updateAdjustedGrade(dialog, gradingScale);
                            });
                            updateAdjustedGrade(dialog, gradingScale);
                        }
                        deferred.resolve();
                    });
                }
                html = null;
                gradingScale = null;
                isActiveOrUnlocked = null;
                return deferred.promise();
            };

            var getDialog = function (message, bucketEnabled, objectID, gradingPeriodID, sectionID, bucketDisplayType, element, gpgbData, html, isSubject, isAcademicStandard, objectLabel, objectDialogLabel, isSelfPacedAndActive, data, ajaxResponseData)
            {
                var saveButton;
                var elementData = element.data();
                var isAvailable = elementData.isAvailable;
                var studentSectionID = element.parents('.gradesheetBrowseRow').data('studentSectionId');
                var academicStandardID = elementData.academicStandardId;
                var subjectID = elementData.subjectId;
                var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketID;
                var studentGradeBucketID = data.studentGradeBucketID;
                var calculationType = $(html).find('.calculationType');

                if (bucketEnabled &&
                    ((isSelfPacedAndActive.toString().toLowerCase() == "true" && (isSubject == false && isAcademicStandard == false)) ||
                        (calculationType.length > 0 && calculationType.val().toLowerCase() != "notgraded")))
                {
                    if (isSubject == true)
                    {
                        saveButton = { id: "saveStudentGradeBucket" + objectLabel + "Options", text: "Save", click: function () { studentGradeBucketSubjectOptionsSave(objectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, subjectID, studentSectionID, gradingPeriodGradeBucketID, element); }, icon: "Save" };
                    }
                    else if (isAcademicStandard == true)
                    {
                        saveButton = { id: "saveStudentGradeBucket" + objectLabel + "Options", text: "Save", click: function () { studentGradeBucketAcademicStandardOptionsSave(objectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, academicStandardID, studentSectionID, gradingPeriodGradeBucketID, element); }, icon: "Save" };
                    }
                    else
                    {
                        saveButton = { id: "saveStudentGradeBucketOptions", text: "Save", click: function () { studentGradeBucketOptionsSave(objectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, gradingPeriodGradeBucketID, studentSectionID, element); }, icon: "Save" };
                    }
                }
                var cancelButton = { id: "cancelStudentGradeBucket" + objectLabel + "Options", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
                var options =
                {
                    anchorTo: element,
                    id: "studentGradeBucket" + objectLabel + "OptionsPopup",
                    width: 650
                };

                var buttons = [];

                if (saveButton)
                {
                    buttons.push(saveButton);
                }
                buttons.push(cancelButton);
                var dialog = skyward.modalLayer.showDialog(message + gpgbData.bucketLabel + " " + objectDialogLabel, html, buttons, options);
                return dialog;
            };

            var buildPopup = function (isSelfPacedOnly, data, localGradebookData, objectLabel)
            {
                var localDeferred = new $.Deferred();
                var action;
                if (isSelfPacedOnly.toString().toLowerCase() == "true")
                {
                    action = localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "StudentGradeBucketOptionsTeacherTrackerSelfPacedOnly" : "StudentGradeBucketOptionsSelfPacedOnly";
                }
                else
                {
                    action = localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "StudentGradeBucket" + objectLabel + "OptionsTeacherTracker" : "StudentGradeBucket" + objectLabel + "Options";
                }
                var ajax = $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    activityIndicator: { silent: true },
                    success: function (response)
                    {
                        if (response != null && response.html != null && response.gradingScaleString != null && response.isActiveOrUnlocked != null)
                        {
                            html = response.html.Content;
                            gradingScale = JSON.parse(response.gradingScaleString);
                            isActiveOrUnlocked = response.isActiveOrUnlocked;
                        }
                        else
                        {
                            checkAjaxResponseForErrors(response);
                        }

                        localDeferred.resolve(response);
                    }
                });

                return localDeferred.promise();
            };

            var IsActiveSelfPacedAndComplete = function (gpgbData, studentGradeBucketID)
            {
                var studentGradeBucket = $('.gradeBucketCell[data-student-grade-bucket-id="' + studentGradeBucketID + '"]');
                var studentGradeBucketData = studentGradeBucket.data();
                if (gpgbData.bucketSectionIsSelfPacedAndActive && studentGradeBucketData.isCompleteByTeacher != null && studentGradeBucketData.isCompleteByTeacher)
                {
                    return true;
                }
                return false;
            };

            var updateAdjustedGrade = function (dialog, gradingScale)
            {
                var percentAdjustmentCommentTextBoxElement = dialog.content.find('.percentAdjustmentCommentTextBox');
                var percentAdjustmentTextBoxElement = dialog.content.find('.percentAdjustmentTextBox');
                var percentAdjustmentTextBox = percentAdjustmentTextBoxElement.val();
                var gradeMarkOverrideEEL = dialog.content.find(".codeEELCode").val();
                var originalGradeLabel = dialog.content.find(".originalGradeMessage");
                var calculatedGradeLabel = dialog.content.find(".calculatedGradeLabel");
                var adjustedGradeLabel = dialog.content.find(".adjustedGradeMessage");
                var hiddenPercentAdjustment = dialog.content.find(".hiddenPercentAdjustment").val();

                var gradeMarkPercentOverride = null;
                var gradeMarkOverrideEELControl = dialog.content.find(".codeEEL");
                var gradeMarkOverridePercentTextbox = dialog.content.find(".gradeMarkOverridePercent");

                var percentAdjustment = null;
                if (percentAdjustmentTextBox || gradeMarkOverrideEEL)
                {
                    percentAdjustment = parseFloat(percentAdjustmentTextBox) || null;

                    var originalPoints = originalGradeLabel.data().originalPoints;
                    var pointsText = originalPoints != null && originalPoints != "" ? originalPoints + " pts" : null;

                    var originalGradePercent = calculatedGradeLabel.length > 0
                        ? parseFloat(calculatedGradeLabel.data().calculatedPercent)
                        : parseFloat(originalGradeLabel.data().originalPercent);

                    if (isNaN(originalGradePercent) && percentAdjustment != null && percentAdjustment >= 0)
                    {
                        originalGradePercent = 0;
                    }

                    var percentToUse = percentAdjustment + originalGradePercent;
                    percentToUse = (percentToUse === null || isNaN(percentToUse) || percentToUse < 0) ? 0 : percentToUse;

                    var adjustedGradePercent = percentToUse.toFixed(2);

                    if (percentAdjustmentTextBox === undefined && hiddenPercentAdjustment !== undefined)
                    {
                        var percentWithAdjustment;
                        if (hiddenPercentAdjustment === "")
                        {
                            adjustedGradePercent = null;
                        }
                        else
                        {
                            percentWithAdjustment = parseFloat(hiddenPercentAdjustment) || 0;
                            percentWithAdjustment = percentWithAdjustment < 0 ? 0 : percentWithAdjustment;
                            adjustedGradePercent = percentWithAdjustment.toFixed(2);
                        }
                    }
                    //EW 3/2/26: Potential future change. If grademarkoverride is changed (or cleared), and new override has no percent, we could recalc original grade so the adjusted grade reflects what happens once the override is gone?
                    //Currently if you have an override with a percent, and you clear it, the adjusted grade might say N/A then on save it will recalculate it back to what it should be.
                    var useGradeMarkPercentOverride = false;
                    var clearPercentAdjustment = false
                    if (gradeMarkOverrideEELControl != null && gradeMarkOverrideEELControl.length > 0)
                    {
                        var additionalFields = gradeMarkOverrideEELControl.data("additionalFields");
                        if (additionalFields != null && additionalFields.UsePercentOverride == true &&
                            additionalFields.PercentOverrideValueApplicableForStudentGrade == true)
                        {
                            useGradeMarkPercentOverride = true;

                            if (additionalFields.OverrideValueToUse != null)
                            {
                                gradeMarkPercentOverride = parseFloat(additionalFields.OverrideValueToUse);
                            }

                            if (additionalFields.ClearPercentAdjustment != null && additionalFields.ClearPercentAdjustment == true)
                            {
                                clearPercentAdjustment = true;
                            }
                            else if (additionalFields.ClearPercentAdjustment == false && percentAdjustment != null)
                            {
                                if (gradeMarkPercentOverride == null)
                                {
                                    gradeMarkPercentOverride = percentAdjustment;
                                }
                                else
                                {
                                    gradeMarkPercentOverride = gradeMarkPercentOverride + percentAdjustment
                                }
                            }
                            if (gradeMarkOverridePercentTextbox != null && gradeMarkOverridePercentTextbox.length > 0)
                            {
                                if (gradeMarkOverridePercentTextbox.data("gradingScaleTypeCode") == "PO")
                                {
                                    pointsText = gradeMarkPercentOverride != null && gradeMarkPercentOverride != "" ? gradeMarkPercentOverride + " pts" : null;
                                }
                                else
                                {
                                    pointsText = null;
                                }
                            }
                            if (gradeMarkPercentOverride != null)
                            {
                                gradeMarkPercentOverride = gradeMarkPercentOverride.toFixed(2);
                            }

                            adjustedGradePercent = gradeMarkPercentOverride; //this needs to happen after. Should this account for individual percent adjustment? Disable that and clear it out?
                        }
                    }
                    if (gradeMarkOverridePercentTextbox != null && gradeMarkOverridePercentTextbox.length > 0)
                    {
                        skyward.controls.setValue(gradeMarkOverridePercentTextbox, gradeMarkPercentOverride);
                        if (useGradeMarkPercentOverride)
                        {
                            gradeMarkOverridePercentTextbox.show();
                        }
                        else
                        {
                            gradeMarkOverridePercentTextbox.hide();
                        }
                    }

                    if (percentAdjustmentTextBoxElement.length > 0)
                    {
                        if (clearPercentAdjustment)
                        {
                            var percentAdjustmentCommentTextBoxElementData = percentAdjustmentCommentTextBoxElement.data();
                            skyward.controls.disable(percentAdjustmentTextBoxElement);
                            skyward.controls.disable(percentAdjustmentCommentTextBoxElement);
                            skyward.controls.setValue(percentAdjustmentTextBoxElement, null);
                            skyward.controls.setValue(percentAdjustmentCommentTextBoxElement, null);
                            percentAdjustmentCommentTextBoxElement.attr("placeholder", percentAdjustmentCommentTextBoxElementData.clearedPlaceholder);
                        }
                        else
                        {
                            var percentAdjustmentTextBoxElementData = percentAdjustmentTextBoxElement.data();
                            var percentAdjustmentCommentTextBoxElementData = percentAdjustmentCommentTextBoxElement.data();
                            var readOnlyPersists = percentAdjustmentTextBoxElementData.readOnlyPersists;
                            if (readOnlyPersists.toString().toLowerCase() == "false")
                            {
                                skyward.controls.enable(percentAdjustmentTextBoxElement);
                                percentAdjustmentCommentTextBoxElement.attr("placeholder", percentAdjustmentCommentTextBoxElementData.defaultPlaceholder);
                            }
                        }
                    }

                    var adjustedGradeMark = gradeMarkOverrideEEL || getGradeMark(gradingScale, adjustedGradePercent);

                    var textToShow;
                    if (isNaN(adjustedGradePercent))
                    {
                        adjustedGradePercent = null;
                    }
                    var percentOrPointsToShow = pointsText == null ? adjustedGradePercent : pointsText;
                    if (!percentOrPointsToShow)
                    {
                        textToShow = adjustedGradeMark;
                    }
                    else
                    {
                        textToShow = adjustedGradeMark + " / " + percentOrPointsToShow;
                    }

                    adjustedGradeLabel.text(textToShow);
                }
                else
                {
                    adjustedGradeLabel.text("N/A");

                    if (gradeMarkOverridePercentTextbox != null && gradeMarkOverridePercentTextbox.length > 0)
                    {
                        skyward.controls.setValue(gradeMarkOverridePercentTextbox, null);
                        gradeMarkOverridePercentTextbox.hide()
                    }

                    if (percentAdjustmentTextBoxElement.length > 0)
                    {
                        var percentAdjustmentTextBoxElementData = percentAdjustmentTextBoxElement.data();
                        var percentAdjustmentCommentTextBoxElementData = percentAdjustmentCommentTextBoxElement.data();
                        var readOnlyPersists = percentAdjustmentTextBoxElementData.readOnlyPersists;
                        if (readOnlyPersists.toString().toLowerCase() == "false")
                        {
                            skyward.controls.enable(percentAdjustmentTextBoxElement);
                            percentAdjustmentCommentTextBoxElement.attr("placeholder", percentAdjustmentCommentTextBoxElementData.defaultPlaceholder);
                        }
                    }
                }
            };

            var getGradeMark = function (gradingScale, updatedPercent)
            {
                if (updatedPercent == null)
                {
                    return "";
                }
                else if (updatedPercent < 0)
                {
                    updatedPercent = 0;
                }

                if (gradingScale.length < 1)
                {
                    return "N/A";
                }
                for (i = 0; i < gradingScale.length; i++)
                {
                    if (updatedPercent >= gradingScale[i].percentLow && updatedPercent <= gradingScale[i].percentHigh)
                    {
                        return gradingScale[i].gradeMarkCode;
                    }
                }
                return gradingScale[0].gradeMarkCode;
            };

            var UpdatePercentAdjustedStudentGradeBuckets = function (affectedStudentGradeBuckets)
            {
                $(affectedStudentGradeBuckets).each(function ()
                {
                    var isGradeModified = true;

                    if (!this.IsGradeMarkOverridden && !this.IsPercentAdjusted)
                    {
                        isGradeModified = false;
                    }

                    var isLessThanMinimumPercent = this.IsLessThanMinimumPercent;

                    updateGradeBucketValueWithPercentAdjustment(this, isGradeModified, isLessThanMinimumPercent);

                    var bucketData = $(this).get(0);
                    var element = $("#Gradebook_" + bucketData.StudentSectionID + "_" + bucketData.GradeBucketID);
                    var colorData = $('#' + BROWSE_NAME + '_unlockedBody').data().grademarkcolordata;
                    updateStudentGradeBucketCellClasses(null, element, bucketData);
                    if (bucketData.IsGradeMarkOverridden)
                    {
                        removeCellErrorClasses(element);
                    }
                    else if (bucketData.HasInvalidGradeMark)
                    {
                        addCellErrorClasses(element);
                    }

                    applyGradeColors("class", bucketData.GradeMarkIDToUse, bucketData.BackingPercent, element, colorData);
                });
            };

            var UpdatePercentAdjustedStudentGradeBucketSubjects = function (affectedStudentGradeBucketSubjects)
            {
                var colorData = $('#' + BROWSE_NAME + '_unlockedBody').data().grademarkcolordata;
                $(affectedStudentGradeBucketSubjects).each(function ()
                {
                    var isGradeModified = true;

                    if (!this.IsGradeMarkOverridden && !this.IsPercentAdjusted)
                    {
                        isGradeModified = false;
                    }
                    var studentGradeBucketSubject = $('td.subjectCell[id^="Gradebook_' + this.StudentSectionID + '_"][id$="_' + this.SubjectID + '"][data-grading-period-grade-bucket-id="' + this.GradingPeriodGradeBucketID + '"]');

                    applyGradeColors("subject", this.GradeMarkIDToUse, this.BackingPercent, studentGradeBucketSubject, colorData);
                    updateGradeBucketSubjectValueWithPercentAdjustment(this, isGradeModified);
                });
            };

            var UpdatePercentAdjustedStudentGradeBucketAcademicStandards = function (affectedStudentGradeBucketAcademicStandards)
            {
                var colorData = $('#' + BROWSE_NAME + '_unlockedBody').data().grademarkcolordata;
                $(affectedStudentGradeBucketAcademicStandards).each(function ()
                {
                    var isGradeModified = true;

                    if (!this.IsGradeMarkOverridden && !this.IsPercentAdjusted)
                    {
                        isGradeModified = false;
                    }
                    var studentGradeBucketAcademicStandard = $('td.academicStandardCell[id^="Gradebook_' + this.StudentSectionID + '_"][id$="_' + this.AcademicStandardID + '"][data-grading-period-grade-bucket-id="' + this.GradingPeriodGradeBucketID + '"]');

                    applyGradeColors("standard", this.GradeMarkIDToUse, this.BackingPercent, studentGradeBucketAcademicStandard, colorData);
                    updateGradeBucketAcademicStandardValueWithPercentAdjustment(this, isGradeModified);
                });
            };

            var updateGradeBucketValueWithPercentAdjustment = function (studentGradeBucket, isGradeModified, isLessThanMinimumPercent)
            {
                var cells = $("td[data-student-grade-bucket-id='" + studentGradeBucket.StudentGradeBucketID + "']");

                cells.each(function ()
                {
                    var cell = $(this);
                    var cellDiv = cell.find("span.gradeBucketScoreSpan > span");
                    if (studentGradeBucket.NewDisplay != null)
                    {
                        cellDiv.html(studentGradeBucket.NewDisplay).removeClass('boldFont');
                        if (isGradeModified || isLessThanMinimumPercent)
                        {
                            cellDiv.addClass('boldFont');
                        }
                    }
                    else
                    {
                        cellDiv.html("");
                    }

                    var infoIcon = cell.find('.studentGradeBucketIsAdminOverrideButton');
                    var studentGradeBucketIndicatorsCell = infoIcon.parents('.studentGradeBucketIndicators');
                    var hasUnscoredFeederBucket = studentGradeBucketHasUnscoredFeederBucket(studentGradeBucket);

                    if (hasUnscoredFeederBucket && studentGradeBucketIndicatorsCell.hasClass('hiddenIsAdminOverride'))
                    {
                        infoIcon.data('hasUnscoredRequiredFeederBucket', 'true');
                        studentGradeBucketIndicatorsCell.removeClass('hiddenIsAdminOverride');
                    }
                    if (!hasUnscoredFeederBucket && !studentGradeBucketIndicatorsCell.hasClass('hiddenIsAdminOverride'))
                    {
                        studentGradeBucketIndicatorsCell.addClass('hiddenIsAdminOverride');
                    }
                });
            };

            var studentGradeBucketHasUnscoredFeederBucket = function (studentGradeBucket)
            {
                return studentGradeBucket.HasUnscoredRequiredFeederBucket && (studentGradeBucket.GradeMarkID == null) && !studentGradeBucket.IsGradeMarkOverridden && !studentGradeBucket.IsPercentAdjusted;
            };

            var updateGradeBucketSubjectValueWithPercentAdjustment = function (studentGradeBucketSubject, isGradeModified)
            {
                var cells = $("td[data-student-grade-bucket-subject-id='" + studentGradeBucketSubject.StudentGradeBucketSubjectID + "']");

                cells.each(function ()
                {
                    var cell = $(this);
                    var cellDiv = cell.find("span.subjectScoreSpan > span");
                    if (!cellDiv.parent().hasClass("mastery"))
                    {
                        cellDiv.html(studentGradeBucketSubject.NewDisplay).removeClass('boldFont');
                        if (isGradeModified)
                        {
                            cellDiv.addClass('boldFont');
                        }
                    }
                    if (studentGradeBucketSubject.IsGradeMarkOverridden)
                    {
                        removeCellErrorClasses(cell);
                    }
                    else if (studentGradeBucketSubject.HasInvalidGradeMark)
                    {
                        addCellErrorClasses(cell);
                    }
                });
            };

            var updateGradeBucketAcademicStandardValueWithPercentAdjustment = function (studentGradeBucketAcademicStandard, isGradeModified)
            {
                var cells = $("td[data-student-grade-bucket-academic-standard-id='" + studentGradeBucketAcademicStandard.StudentGradeBucketAcademicStandardID + "']");

                cells.each(function ()
                {
                    var cell = $(this);
                    var cellDiv = cell.find("span.academicStandardScoreSpan > span");
                    if (!cellDiv.parent().hasClass("mastery"))
                    {
                        cellDiv.html(studentGradeBucketAcademicStandard.NewDisplay).removeClass('boldFont');
                        if (isGradeModified)
                        {
                            cellDiv.addClass('boldFont');
                        }
                    }
                    if (studentGradeBucketAcademicStandard.IsGradeMarkOverridden)
                    {
                        removeCellErrorClasses(cell);
                    }
                    else if (studentGradeBucketAcademicStandard.HasInvalidGradeMark)
                    {
                        addCellErrorClasses(cell);
                    }
                });
            };

            var UpdateStudentAssignmentEntryTextBoxes = function (completeByTeacherStudentGradeBuckets, gradingPeriodID)
            {
                $.each(completeByTeacherStudentGradeBuckets, function (key, value)
                {
                    for (var i = 0; i < value.length; i++)
                    {
                        var sgbCell = gradebook.getStudentGradeBucketCell(value[i]);
                        var sgbData = sgbCell.data();
                        var studentSectionData = sgbCell.parents("tr").first().data();

                        if (key === "No")
                        {
                            var action = "ReloadGradebook";
                            if (gradebookData.isTeacherTracker)
                            {
                                action += "TeacherTracker";
                            }
                            gradebook.reloadGradebook('Gradebook', 'Gradebook', action);
                            return false;
                        }
                        else if (key !== "Yes")
                        {
                            return;
                        }

                        UpdateAssignmentTextBoxes(sgbData.gradingPeriodId, sgbData.gradingPeriodGradeBucketId, sgbData.studentGradeBucketId, studentSectionData.studentSectionId);
                    }
                });
            };

            var UpdateAssignmentTextBoxes = function (gradingPeriodID, gradingPeriodGradeBucketID, studentGradeBucketID, studentSectionID)
            {
                var cells = $(".gradebookScoringModeControl[data-studentsectionid='" + studentSectionID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated), " +
                    ".codeEELDescription[data-studentsectionid='" + studentSectionID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated), " +
                    ".gradeBucketCell[data-student-grade-bucket-id='" + studentGradeBucketID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated), " +
                    ".subjectCell[data-student-grade-bucket-id='" + studentGradeBucketID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated), " +
                    ".academicStandardCell[data-student-grade-bucket-id='" + studentGradeBucketID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated)");

                var validCells = [];
                cells.each(function ()
                {
                    var cell = $(this);
                    var cellData = cell.data();
                    if (cellData.specificGradingPeriodGradeBucketId != null && cellData.specificGradingPeriodGradeBucketId != undefined)
                    {
                        if (cellData.specificGradingPeriodGradeBucketId == gradingPeriodGradeBucketID)
                        {
                            validCells.push(cell);
                        }
                    }
                    else
                    {
                        validCells.push(cell);
                    }
                });
                var disableCell = function (cell)
                {
                    if (!(cell.hasClass("gradebookScoringModeControl")))
                    {
                        cell.addClass("gradebookScoringModeControl");
                    }
                    gradebook.disableControl(cell);
                    gradebook.disableControl(cell.siblings());
                    cell.siblings().attr("disabled", "disabled");
                    cell.addClass("scoringModeDoesntAffectState");
                };
                $.each(validCells, function ()
                {
                    var cell = $(this);
                    if (cell.hasClass("ContainsDisabledSubjectiveCodeEELs"))
                    {
                        disableCell(cell);
                    }
                    cell.parents("td").find(".gradebookScoringModeControl, .gradebookScoringMode-On, .gradebookScoringMode-Off, .hasSubjectiveCodeEEL, .ContainsDisabledSubjectiveCodeEELs").each(function () { disableCell($(this)); });
                    cell.find(".gradebookScoringModeControl, .gradebookScoringMode-On, .gradebookScoringMode-Off, .hasSubjectiveCodeEEL, .ContainsDisabledSubjectiveCodeEELs").each(function () { disableCell($(this)); });
                });
            };

            var studentGradeBucketOptionsSave = function (studentGradeBucketID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, gradingPeriodGradeBucketID, studentSectionID, gradebookCell)
            {
                var gradeMarkIDOverride = dialog.content.find('#GradeMarkOverride_' + studentGradeBucketID + '_value').val();
                var gradeMarkOverrideComment = dialog.content.find('#GradeMarkOverrideComment_' + studentGradeBucketID).val();
                var percentAdjustment = dialog.content.find('#PercentAdjustment_' + studentGradeBucketID).val();
                var percentAdjustmentComment = dialog.content.find('#PercentAdjustmentComment_' + studentGradeBucketID).val();
                var completeByTeacher = dialog.content.find('#CompleteByTeacher_' + studentGradeBucketID);
                var completeByTeacherCode = completeByTeacher.is(':checked') == true ? "Y" : completeByTeacher.length > 0 ? "N" : "D";

                var buttons = $("#studentGradeBucketOptionsPopup").find("button, a");
                var saveButton = $('#saveStudentGradeBucketOptions');
                $.each(buttons, function ()
                {
                    $(this).addClass("ui-disabled");
                });
                saveButton.off("click");

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/StudentGradeBucketOptionsSave",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        studentGradeBucketID: studentGradeBucketID,
                        gradingPeriodID: gradingPeriodID,
                        gradeMarkIDOverride: gradeMarkIDOverride,
                        gradeMarkOverrideComment: gradeMarkOverrideComment,
                        sectionID: sectionID,
                        percentAdjustment: percentAdjustment,
                        percentAdjustmentComment: percentAdjustmentComment,
                        completeByTeacherCode: completeByTeacherCode,
                        isAvailable: isAvailable,
                        gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                        studentSectionID: studentSectionID,
                        preSaveWarningHash: saveButton.data().preSaveWarningHash
                    },
                    success: function (response)
                    {
                        saveButton.data("preSaveWarningHash", response.preSaveWarningHash);

                        saveButton.on("click", function () { studentGradeBucketOptionsSave(studentGradeBucketID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, gradingPeriodGradeBucketID, studentSectionID, gradebookCell); });
                        $.each(buttons, function ()
                        {
                            $(this).removeClass("ui-disabled");
                        });

                        if (response.success)
                        {
                            dialog.close();

                            gradebook.updateBucketNoCountIndicator(gradebookCell, response.gradeMarkNoCount);

                            var saveManager = createSaveManager(gradebook);
                            saveManager.updateAverageValues(response);

                            if (response.affectedStudentGradeBuckets)
                            {
                                UpdatePercentAdjustedStudentGradeBuckets(response.affectedStudentGradeBuckets);
                            }
                            if (response.completeByTeacherStudentGradeBuckets && completeByTeacherCode)
                            {
                                UpdateStudentAssignmentEntryTextBoxes(response.completeByTeacherStudentGradeBuckets, gradingPeriodID);
                            }

                            if (response.completeByTeacherStudentGradeBuckets)
                            {
                                $.each(response.completeByTeacherStudentGradeBuckets, function (k, v)
                                {
                                    for (var i = 0; i < v.length; i++)
                                    {
                                        var sgbCell = gradebook.getStudentGradeBucketCell(v[i]);
                                        var studentGradeBucketIndicators = sgbCell.find(".studentGradeBucketIndicators");

                                        if (k == 'Yes')
                                        {
                                            studentGradeBucketIndicators.removeClass('hiddenIsComplete');
                                        }
                                        else if (!studentGradeBucketIndicators.hasClass('hiddenIsComplete'))
                                        {
                                            studentGradeBucketIndicators.addClass('hiddenIsComplete');
                                        }
                                    }
                                });
                            }
                        }
                        else
                        {
                            checkAjaxResponseForErrors(response);
                            var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                            skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                        }
                    }
                });
            };

            var studentGradeBucketSubjectOptionsSave = function (studentGradeBucketSubjectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, subjectID, studentSectionID, gradingPeriodGradeBucketID, gradebookCell)
            {
                var gradeMarkIDOverride = dialog.content.find('#GradeMarkOverride_' + studentGradeBucketSubjectID + '_value').val();
                var gradeMarkOverrideComment = dialog.content.find('#GradeMarkOverrideComment_' + studentGradeBucketSubjectID).val();
                var percentAdjustment = dialog.content.find('#PercentAdjustment_' + studentGradeBucketSubjectID).val();
                var percentAdjustmentComment = dialog.content.find('#PercentAdjustmentComment_' + studentGradeBucketSubjectID).val();
                var completeByTeacherCode = (dialog.content.find('#CompleteByTeacher_' + studentGradeBucketSubjectID).is(':checked') == true ? "Y" : "N");

                var saveButton = $('#saveStudentGradeBucketSubjectOptions');
                saveButton.off("click");

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/StudentGradeBucketSubjectOptionsSave",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                        gradingPeriodID: gradingPeriodID,
                        gradeMarkIDOverride: gradeMarkIDOverride,
                        gradeMarkOverrideComment: gradeMarkOverrideComment,
                        sectionID: sectionID,
                        percentAdjustment: percentAdjustment,
                        percentAdjustmentComment: percentAdjustmentComment,
                        isAvailable: isAvailable,
                        studentGradeBucketID: studentGradeBucketID,
                        subjectID: subjectID,
                        preSaveWarningHash: saveButton.data().preSaveWarningHash
                    },
                    success: function (response)
                    {
                        saveButton.data("preSaveWarningHash", response.preSaveWarningHash);
                        saveButton.on("click", function () { studentGradeBucketSubjectOptionsSave(studentGradeBucketSubjectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, subjectID, studentSectionID, gradingPeriodGradeBucketID, gradebookCell); });

                        if (response.success)
                        {
                            dialog.close();

                            var saveManager = createSaveManager(gradebook);
                            saveManager.updateAverageValues(response);

                            var studentGradeBucketSubject = $('td.subjectCell[id^="Gradebook_' + studentSectionID + '_"][id$="_' + subjectID + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                            if (gradeMarkIDOverride)
                            {
                                removeCellErrorClasses(studentGradeBucketSubject);
                            }

                            gradebook.updateBucketNoCountIndicator(gradebookCell, response.gradeMarkNoCount);

                            if (response.affectedStudentGradeBuckets)
                            {
                                UpdatePercentAdjustedStudentGradeBuckets(response.affectedStudentGradeBuckets);
                            }
                            if (response.affectedStudentGradeBucketSubjects)
                            {
                                UpdatePercentAdjustedStudentGradeBucketSubjects(response.affectedStudentGradeBucketSubjects, gradingPeriodID);
                            }
                        }
                        else
                        {
                            checkAjaxResponseForErrors(response);
                            var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                            skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                        }
                    }
                });
            };

            var studentGradeBucketAcademicStandardOptionsSave = function (studentGradeBucketAcademicStandardID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, academicStandardID, studentSectionID, gradingPeriodGradeBucketID, gradebookCell)
            {
                var gradeMarkIDOverride = dialog.content.find('#GradeMarkOverride_' + studentGradeBucketAcademicStandardID + '_value').val();
                var gradeMarkOverrideComment = dialog.content.find('#GradeMarkOverrideComment_' + studentGradeBucketAcademicStandardID).val();
                var percentAdjustment = dialog.content.find('#PercentAdjustment_' + studentGradeBucketAcademicStandardID).val();
                var percentAdjustmentComment = dialog.content.find('#PercentAdjustmentComment_' + studentGradeBucketAcademicStandardID).val();
                var completeByTeacherCode = (dialog.content.find('#CompleteByTeacher_' + studentGradeBucketAcademicStandardID).is(':checked') == true ? "Y" : "N");

                var saveButton = $('#saveStudentGradeBucketAcademicStandardOptions');
                saveButton.off("click");

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/StudentGradeBucketAcademicStandardOptionsSave",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                        gradingPeriodID: gradingPeriodID,
                        gradeMarkIDOverride: gradeMarkIDOverride,
                        gradeMarkOverrideComment: gradeMarkOverrideComment,
                        sectionID: sectionID,
                        percentAdjustment: percentAdjustment,
                        percentAdjustmentComment: percentAdjustmentComment,
                        isAvailable: isAvailable,
                        studentGradeBucketID: studentGradeBucketID,
                        academicStandardID: academicStandardID,
                        preSaveWarningHash: saveButton.data().preSaveWarningHash
                    },
                    success: function (response)
                    {
                        saveButton.data("preSaveWarningHash", response.preSaveWarningHash);
                        saveButton.on("click", function () { studentGradeBucketAcademicStandardOptionsSave(studentGradeBucketAcademicStandardID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, academicStandardID, studentSectionID, gradingPeriodGradeBucketID, gradebookCell); });

                        if (response.success)
                        {
                            dialog.close();

                            var saveManager = createSaveManager(gradebook);
                            saveManager.updateAverageValues(response);

                            var studentGradeBucketAcademicStandard = $('td.academicStandardCell[id^="Gradebook_' + studentSectionID + '_"][id$="_' + academicStandardID + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                            if (gradeMarkIDOverride)
                            {
                                removeCellErrorClasses(studentGradeBucketAcademicStandard);
                            }

                            gradebook.updateBucketNoCountIndicator(gradebookCell, response.gradeMarkNoCount);

                            if (response.affectedStudentGradeBuckets)
                            {
                                UpdatePercentAdjustedStudentGradeBuckets(response.affectedStudentGradeBuckets);
                            }
                            if (response.affectedStudentGradeBucketSubjects)
                            {
                                UpdatePercentAdjustedStudentGradeBucketSubjects(response.affectedStudentGradeBucketSubjects, gradingPeriodID);
                            }
                            if (response.affectedStudentGradeBucketAcademicStandards)
                            {
                                UpdatePercentAdjustedStudentGradeBucketAcademicStandards(response.affectedStudentGradeBucketAcademicStandards, gradingPeriodID);
                            }
                            else
                            {
                                var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                                skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                            }
                        }
                        else
                        {
                            checkAjaxResponseForErrors(response);
                            var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                            skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                        }
                    }
                });
            };

            var buildLockedColumnsDisplayPopup = function ()
            {
                var data = gradebookBrowse.data();
                var gradingPeriodIDs = [];
                $.each(gradebook.unlockedRowHeader.find(".gradeBucketHeaderCell"), function ()
                {
                    gradingPeriodIDs.push($(this).data().gradingPeriodId);
                });
                data.gradingPeriodIDs = JSON.stringify(gradingPeriodIDs);
                var action = data.isTeacherTracker ? "BuildLockedColumnsDisplayPopupTeacherTracker" : "BuildLockedColumnsDisplayPopup";
                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/GradebookSettings/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data: data,
                        activityIndicator: { silent: true },
                        success: function (htmlData)
                        {
                            checkPopupSaveButton(htmlData, "saveLockedColumnDisplaySettings");
                        }
                    });
                };

                var save = function (isTeacherTracker)
                {
                    var data =
                    {
                        "DisplayStudentGroups": skyward.controls.getValue($("#DisplayStudentGroups")),
                        "DisplayStudentGradeLevel": skyward.controls.getValue($("#DisplayStudentGradeLevel")),
                        "DisplayStudentNumber": skyward.controls.getValue($("#DisplayStudentNumber")),
                        "DisplayMethodOfInstruction": skyward.controls.getValue($("#DisplayMethodOfInstruction")),
                        "DisplayCourseDescription": skyward.controls.getValue($("#DisplayCourseDescription")),
                        "DisplayAttendance": skyward.controls.getValue($("#DisplayAttendance")),
                        "DisplayMissingAssignment": skyward.controls.getValue($("#DisplayMissingAssignment")),
                        "DisplayUnscoredPastDueAssignments": skyward.controls.getValue($("#DisplayUnscoredPastDueAssignments")),
                        "DisplayIsActive": skyward.controls.getValue($("#DisplayIsActive")),
                        "CalculationGroupGradeBucketIDLocked": skyward.controls.getValue($("#CalculationGroupGradeBucketIDLocked")),
                        "StudentNameDisplayTypeCode": skyward.controls.getValue($("#StudentNameDisplayTypeCode")),
                        "StudentGroupSelect": JSON.stringify(skyward.controls.getValue($("#StudentGroupSelectEEL"))),
                        "HiddenGradeBucketsSelect": JSON.stringify(skyward.controls.getValue($("#HiddenGradeBucketsSelectEEL"))),
                        "DisplayStudentGroupColors": skyward.controls.getValue($("#DisplayStudentGroupColors")),
                        "ShowGradeColors": skyward.controls.getValue($("#ShowGradeColors")),
                    };
                    var action = "SaveLockedColumnDisplaySettings";
                    if (isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }
                    gradebook.reloadGradebook('Gradebook', 'Gradebook', action, data);
                    dialog.close();
                };

                var saveButton = { id: "saveLockedColumnDisplaySettings", text: "Save", click: function () { save(data.isTeacherTracker); }, icon: "Save" };
                var cancelButton = { id: "cancelLockedColumnDisplaySettings", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
                var resetButton = { id: "resetView", text: "Reset to Default Display", click: function () { resetGradebookView(dialog); }, icon: "Update" };
                var options =
                {
                    anchorTo: $(this)
                };
                var dialog = skyward.modalLayer.showDialog("Display Settings", buildPopup, [resetButton, saveButton, cancelButton], options);
            };

            var loadAverages = function ()
            {
                if (gradebook.unlockedAveragesRowHeader.length < 1)
                {
                    return;
                }
                var action = gradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "GetGradebookAveragesTeacherTracker" : "GetGradebookAverages";


                var averageData = {};
                $.extend(averageData, gradebookData);

                averageData.academicStandardIDsDisplayed = {};
                averageData.subjectIDsDisplayed = {};

                gradebook.unlockedHeader.find(".academicStandardHeaderCell").each(function ()
                {
                    var cell = $(this);
                    var cellData = cell.data();

                    if (averageData.academicStandardIDsDisplayed[cellData.gradingPeriodGradeBucketId] == null)
                    {
                        averageData.academicStandardIDsDisplayed[cellData.gradingPeriodGradeBucketId] = [];
                    }

                    averageData.academicStandardIDsDisplayed[cellData.gradingPeriodGradeBucketId].push(cellData.academicStandardId);
                });

                gradebook.unlockedHeader.find(".subjectHeaderColumn").each(function ()
                {
                    var cell = $(this);
                    var cellData = cell.data();

                    if (averageData.subjectIDsDisplayed[cellData.gradingPeriodGradeBucketId] == null)
                    {
                        averageData.subjectIDsDisplayed[cellData.gradingPeriodGradeBucketId] = [];
                    }

                    averageData.subjectIDsDisplayed[cellData.gradingPeriodGradeBucketId].push(cellData.subjectId);
                });

                averageData.academicStandardIDsDisplayed = JSON.stringify(averageData.academicStandardIDsDisplayed);
                averageData.subjectIDsDisplayed = JSON.stringify(averageData.subjectIDsDisplayed);

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: averageData,
                    success: function (response)
                    {
                        updateGradingPeriodGradeBucketAverages(response.gradingPeriodGradeBucketAverages);
                        updateStudentGradeBucketChildRecordAverages(response.studentGradeBucketSubjectAverages, "subjectGradeBucket");
                        updateStudentGradeBucketChildRecordAverages(response.studentGradeBucketAcademicStandardAverages, "academicStandardGradeBucket");
                        updateAssignmentAverages(response.assignmentAverages);
                    }
                });
            };

            var loadAssignmentCounts = function ()
            {
                var showingMissingAssignments = gradebook.lockedHeader.find(".MissingAssignmentCount").length > 0;
                var showingUnscoredPastDueAssignments = gradebook.lockedHeader.find(".UnscoredPastDueAssignmentCount").length > 0;

                if (!showingMissingAssignments && !showingUnscoredPastDueAssignments)
                {
                    return;
                }

                var studentSectionIDs = [];
                $.each(gradebook.students, function ()
                {
                    studentSectionIDs.push($(this).get(0).studentSectionID);
                });

                var action = gradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "GetMissingAssignmentCountsTeacherTracker" : "GetMissingAssignmentCounts";
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data:
                    {
                        sectionID: gradebookData.sectionid,
                        sectionIDHash: gradebookData.sectionIdHash,
                        classGroupID: gradebookData.classGroupId,
                        classGroupIDHash: gradebookData.classGroupIdHash
                    },
                    success: function (returnData)
                    {
                        if (returnData.assignmentCounts)
                        {
                            updateIsMissingCount(returnData.assignmentCounts);
                        }
                    }
                });
            };

            var massAssignScoresPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var inScoringModeOnButtonClick = isInScoringMode();
                var postData =
                {
                    assignmentID: data.assignmentId,
                    districtID: gradebook.dataContainer.data().districtid,
                };

                if (inScoringModeOnButtonClick === false)
                {
                    updateEditMode();
                }

                var advancedAssignmentHeaderCell = $("#assignmentHeaderCell" + data.assignmentId);
                var assignmentHeaderCell = $("#assignment" + data.assignmentId + "HeaderCell");
                if (assignmentHeaderCell.length < 1 || advancedAssignmentHeaderCell.length < 1)
                {
                    return;
                }
                var headerCellData = assignmentHeaderCell.data();
                $.extend(headerCellData, advancedAssignmentHeaderCell.data());
                gradebook.getAdvancedColumnCellsByAssignmentID(data.assignmentId, false);  //populate the advanced cells so that the NoCount/missing/etc work

                var popupID = "MassAssignScores";
                var headerText = "Mass Assign Scores";

                if (currentHeaderPopupDialog)
                {
                    currentHeaderPopupDialog.close();
                }

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + data.screen,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: postData
                    });
                };

                var saveButton = { text: "Save", "click": function () { $.when(gradebook.massAssignHelper.applyButtonClick.call($(this))).done(function () { dialog.close(); }); }, "icon": "Save", "data": data };
                var closeButton = { text: "Cancel", "click": function () { dialog.close(); }, "icon": "Cancel" };
                var options =
                {
                    closeOnEscape: false,
                    draggable: true,
                    id: popupID
                };

                var dialog = skyward.modalLayer.showDialog(headerText, buildPopup, [saveButton, closeButton], options);

                dialog.content.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL", gradeMarkScoringEelCompleteMassAssign);
                dialog.content.on("gradebookInputCodeEELInvalid", ".gradebookInputCodeEEL", gradeMarkScoringEelFailed);
                dialog.content.on("keydown", ".gradebookInputCodeEEL", browseKeyDown);

                dialog.modalLayer.options.afterClose = function (result)
                {
                    var wrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);

                    var errorsOnSave = wrapper.hasClass("errorDuringSave") || wrapper.hasClass("studentAssignmentError") || wrapper.hasClass("studentGradeBucketError");
                    if (inScoringModeOnButtonClick === false && !errorsOnSave)
                    {
                        gradebook.updateEditModeNoDialog();
                    }
                };
            };

            var studentGradeBucketOptionsScoringMode = function (element, data)
            {
                var postData =
                {
                    studentGradeBucketID: data.studentGradeBucketId,
                };

                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/StudentGradeBucketOptionsScoringMode/" + data.studentGradeBucketId,
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: postData,
                    success: function (returnData)
                    {
                        if (returnData.success == false && returnData.popupHTML)
                        {
                            checkAjaxResponseForErrors(returnData);
                        }
                        else if (returnData.htmlValue && returnData.htmlValue.Content)
                        {
                            var options =
                            {
                                anchorTo: element
                            };
                            skyward.modalLayer.showDialog("Student Grade Options", returnData.htmlValue.Content, [], options);
                        }
                    }
                });
            };

            attachListeners();

            resizeGradebook();

            if (gradebookData.singleassignment == true)
            {
                gradebook.browse.find('.gradeMarkScoring').each(function ()
                {
                    var control = $(this);
                    var controlData = control.data();
                    skyward.controls.setValue(control, controlData.enabledGrademarkValue, true);
                    document.getElementById(control.attr('id')).style.width = enabledGradeSheetGradeMarkScoringWidth;
                });

                gradebook.gradebookBodyScoringModeControls.each(function ()
                {
                    $(this).addClass("js-maskInitialized");
                });
            }

            gradebook.currentRow = getCurrentRowNumber();

            var assignmentIndicatorPopup = function ()
            {
                var button = $(this);
                var firstRow;

                if (button.find("svg:visible").length < 1)
                {
                    return;
                }

                button.find('.assignmentIndicators').each(function ()
                {
                    var span = $(this);
                    if (span.hasClass('assignmentIndicatorsFirstRow'))
                    {
                        firstRow = span;
                    }
                });

                var assignmentCell = button.closest('.assignmentCell');
                var inputElement = assignmentCell.find('.gradebookInput');
                var inputElementData = inputElement.data();

                var inputElementGrademarkScoring = assignmentCell.find('.gradeMarkScoring');
                var inputElementDataGrademarkScoring = inputElementGrademarkScoring.data();

                if (inputElementData == null || inputElementData.sectionId == null && inputElementDataGrademarkScoring != null)
                {
                    inputElement = inputElementGrademarkScoring;
                    inputElementData = inputElementDataGrademarkScoring;
                }

                inputElementData.sectionId = gradebook.getSectionData(assignmentCell).sectionID;

                var sectionData = gradebook.getSectionData(inputElement);

                var studentSectionID = inputElementData.studentsectionid;
                var assignmentID = gradebook.getRepresentedAssignmentID(inputElementData.assignmentid, inputElementData.sectionId);
                var score = skyward.controls.getValue(inputElement);
                var sectionID = sectionData.sectionID;
                var sectionIDHash = sectionData.sectionIDHash;
                var showScoreWarning = !firstRow.hasClass('hiddenWarning');
                var popupAction = gradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "AdvancedStudentAssignmentPopupTeacherTracker" : undefined;

                var additionalButtonsFunc = function (html)
                {
                    var undropButton = null;
                    var activeAssignment = $(html).find('.InactiveGradesheetBucket').length == 0;

                    if (activeAssignment && gradebook.editMode && !firstRow.hasClass('hiddenDroppedAssignment'))
                    {
                        var allowUnDrop = button.find("div.noUnDrop").length < 1;

                        if (allowUnDrop)
                        {
                            undropButton = { id: "saveUndropScore", text: "Un-Drop", click: function () { saveUndrop(inputElementData); skyward.modalLayer.closeModalLayer(".modalLayer"); }, icon: "Check" };
                        }
                    }

                    return undropButton ? [undropButton] : [];
                };

                displayAssignmentIndicatorPopup(button, studentSectionID, assignmentID, score, sectionID, sectionIDHash, showScoreWarning, popupAction, additionalButtonsFunc);
            };

            var gradeBucketAcademicStandardPopup = function ()
            {
                var element = $(this);
                var action = gradebookData.isTeacherTracker.toString().toLowerCase() === "true" ? "AcademicStandardDetailsPopupTeacherTracker" : "AcademicStandardDetailsPopup";

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: element.data()
                    });
                };

                var cancelButton = { id: "academicStandardDetailsPopup", text: "Ok", click: function () { dialog.close(); }, icon: "Check" };

                var dialog = skyward.modalLayer.showDialog('Academic Standard Details', buildPopup, [cancelButton],
                    {
                        anchorTo: element,
                        width: 460
                    });
            };

            var studentGradeBucketAcademicStandardSummaryPopup = function ()
            {
                var element = $(this);
                var action = gradebookData.isTeacherTracker.toString().toLowerCase() === "true" ? "StudentGradeBucketAcademicStandardSummaryPopupTeacherTracker" : "StudentGradeBucketAcademicStandardSummaryPopup";
                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: element.data()
                    });
                };

                var closeButton = { id: "academicStandardSummaryDetailsPopupClose", text: "Ok", click: function () { dialog.close(); }, icon: "Check" };

                var dialog = skyward.modalLayer.showDialog('Academic Standard Score Details', buildPopup, [closeButton],
                    {
                        anchorTo: element
                    });
            };

            var selectAcademicStandardsToDisplay = function ()
            {
                var button = $(this);
                var data = button.data();
                var action = "SelectStandardsDisplayBucketSettings";
                var isTeacherTracker = data.isTeacherTracker.toString().toLowerCase() == "true";
                if (isTeacherTracker)
                {
                    action += "TeacherTracker";
                }

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: data
                    });
                };

                var options =
                {
                    draggable: true
                };

                var title = "Select Academic Standards To Display";

                var saveButton =
                {
                    id: "saveDisplayType", text: "Save",
                    click: function ()
                    {

                        var saveButtonDomElement = $("#saveDisplayType");
                        var saveAction = "SelectStandardsDisplayBucketSettingsSave";

                        if (isTeacherTracker)
                        {
                            saveAction += "TeacherTracker";
                        }

                        saveButtonDomElement.off();
                        $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/TeacherSectionStandardsDisplayGradeBucketSetting/" + saveAction,
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                "SelectAcademicStandardsDisplayRepeater": JSON.stringify($("#SelectAcademicStandardsDisplayRepeater").data().savedata),
                                "TeacherSectionSettingID": data.teacherSectionSettingId,
                                "TeacherSectionSettingIDHash": data.teacherSectionSettingIdHash,
                                "SectionID": data.sectionId,
                                "SectionIDHash": data.sectionIdHash
                            },
                            success: function ()
                            {
                                var reloadAction = "ReloadGradebook";

                                if (isTeacherTracker)
                                {
                                    reloadAction += "TeacherTracker";
                                }
                                gradebook.reloadGradebook('Gradebook', 'Gradebook', reloadAction);
                            }
                        });

                        dialog.close();
                    },
                    icon: "Save"
                };

                var cancelButton = { id: "cancelSelect", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };

                var dialog = skyward.modalLayer.showDialog(title, buildPopup, [saveButton, cancelButton], options);

                dialog.content.on("contentLoaded", function ()
                {
                    dialog.content.find('#SelectAcademicStandardsDisplayRepeater').on('change', '.standardsSummarySelectShowBucket', updateStandardsSummaryCheckboxes);
                });

                dialog.content.on('ajaxRepeaterTemplateLoaded', function (event, element)
                {
                    var checkbox = $(element).find('.standardsSummarySelectShowBucket');
                    updateStandardsSummaryCheckboxes(checkbox);
                });
            };

            var updateStandardsSummaryCheckboxes = function (element)
            {
                var parentCheckbox = element.length > 0 ? element : $(this);

                parentCheckbox.parents('.ajaxRepeaterPlaceHolder').find('.academicStandardDisplayCheckbox').each(function ()
                {
                    var checkbox = $(this);
                    if (!parentCheckbox.is(':checked'))
                    {
                        skyward.controls.disable(checkbox);
                    }
                    else
                    {
                        skyward.controls.enable(checkbox);
                    }
                });
            };

            gradebook.removeDefaultKeyEvents();

            //This should always be the last thing in the init. We don't want to resolve gradebookLoadComplete before we have defined all of the functions that might get called
            var rowsSkipped = gradebookData.rowsskipped; //TODO: Remove with the stream dream..STREAM DREAM! STREAM DREAM!
            if (rowsSkipped == null || rowsSkipped == "")
            {
                rowsSkipped = 0;
            }
            if (gradebookData.usingOffset.toString().toLowerCase() == "true" && (gradebook.rowCount + rowsSkipped) >= gradebookData.numberOfRowsToFetch)
            {
                gradebook.fetchGradebookRows(1, gradebookData.numberOfRowsToFetch);

                $.when(gradebook.gradebookFullyLoadedPromise).done(function ()
                {
                    gradebook.gradebookLoadComplete(gradebook.browse, true, { requireMissingCountLoad: true, requiresStaffMeetUpdate: true });
                });
            }
            else
            {
                gradebook.gradebookFullyLoadedPromise.resolve();
                gradebook.gradebookLoadComplete(gradebook.browse, false, { requireMissingCountLoad: true, requiresStaffMeetUpdate: true });
            }

            var initEvents =
            {
                'gradingPeriodOptionsPopup': gradingPeriodOptionsPopup,
                'getBrowseExport': exportBrowse,
                'studentSectionNote': studentSectionNote,
                'studentGradeBucketOptionsPopup': studentGradeBucketOptionsPopup,
                'studentGradeBucketOptionsPopupSelfPacedOnly': studentGradeBucketOptionsPopupSelfPacedOnly,
                'studentGradeBucketSubjectOptionsPopup': studentGradeBucketSubjectOptionsPopup,
                'studentGradeBucketAcademicStandardOptionsPopup': studentGradeBucketAcademicStandardOptionsPopup,
                'expandCollapseLockedColumns': gradebook.expandCollapseLockedColumns,
                'buildLockedColumnsDisplayPopup': buildLockedColumnsDisplayPopup,
                'assignmentIndicatorPopup': assignmentIndicatorPopup,
                'gradeBucketAcademicStandardPopup': gradeBucketAcademicStandardPopup,
                'studentGradeBucketAcademicStandardSummaryPopup': studentGradeBucketAcademicStandardSummaryPopup,
                'printBlankGradesheet': printBlankGradesheet,
                'showNewStudentInfo': showNewStudentInfo,
                'buildLegendPopup': buildLegendPopup,
                'selectAcademicStandardsToDisplay': selectAcademicStandardsToDisplay,
                'subjectHeaderPopup': subjectHeaderPopup,
                'standardHeaderPopup': standardHeaderPopup,
                'assignmentHeaderPopup': assignmentHeaderPopup,
                'massAssignScoresPopup': massAssignScoresPopup,
                'nonAssignmentMassAssignPopup': nonAssignmentMassAssignPopup,
                'viewGradingScale': viewGradingScale,
                'viewStudentGradeContainerAudit': viewStudentGradeContainerAudit,
                'displayStudentGroupInfo': gradebook.displayStudentGroupInfo,
                'displayGradebookFilterInfo': gradebook.displayGradebookFilterInfo,
                'filterToSpecificStudent': gradebook.filterToSpecificStudent,
                'openSubjectDetails': gradebook.openSubjectDetails,
                'openAcademicStandardDetails': gradebook.openAcademicStandardDetails,
                'displayGradebookFilterInfo': gradebook.displayGradebookFilterInfo,
                'massUpdateAssignmentsSectionGradeBucket': gradebook.massUpdateAssignmentsSectionGradeBucket,
                'massUpdateAssignmentsStudentGradeBucket': gradebook.massUpdateAssignmentsStudentGradeBucket,
                'showHiddenGradeBuckets': gradebook.showHiddenGradeBuckets,
                'closeHiddenGradeBucketsWarning': gradebook.closeHiddenGradeBucketsWarning
            };

            //Bootstrap
            skyward.events.registerEvents('gradebook', initEvents);
        };

        var markCommentQuickEntryAsValid = function (quickEnty)
        {
            if (quickEnty.length < 1) {
                return;
            }

            var codeEELDescription = quickEnty.find(".codeEELDescription");
            if (codeEELDescription.length < 1) {
                return;
            }
            var data = codeEELDescription.data();
            data.lastValidatedValue = skyward.controls.getValue(quickEnty); //On gradesheet they dont need to select an existing item, they can type whatever.
        };

        var isInScoringMode = function ()
        {
            var scoringModeControl = $("#UpdateEditMode");
            return (scoringModeControl.children("span").text() === GRADEBOOK_EXIT_SCORING_MODE) || $(".gradebookScoringMode-On").length > 0;
        };

        var updateStudentAssignmentButtonDisplay = function (assignmentScoreCell)
        {
            var button = assignmentScoreCell.find('.assignmentIndicatorButton');
            var firstRow;

            if (button.length == 0)
            {
                return;
            }

            button.find('.assignmentIndicators').each(function ()
            {
                var span = $(this);
                if (span.hasClass('assignmentIndicatorsFirstRow'))
                {
                    firstRow = span;
                }
            });

            if (firstRow.hasClass('hiddenMissingScore') && firstRow.hasClass('hiddenScoreClarifier') && firstRow.hasClass('hiddenNoCount') && firstRow.hasClass('hiddenMultipleAttempts') &&
                firstRow.hasClass('hiddenComment') && firstRow.hasClass('hiddenWarning') && firstRow.hasClass('hiddenDroppedAssignment') && firstRow.hasClass('hiddenTransferGrade') &&
                firstRow.hasClass('hiddenMoreInfo') && firstRow.hasClass('hiddenAttendanceType') && firstRow.hasClass('hiddenHasAttachments') && firstRow.hasClass('hiddenOnlineAssignment') &&
                firstRow.hasClass('hiddenDoNotPostToFASA'))
            {
                button.addClass('displayNone');
            }
            else
            {
                button.removeClass('displayNone');
            }
        };

        var validationErrorDetailsPopup = function ()
        {
            var element = $(this);
            var assignmentsWithErrors = $(".assignmentCell.updatedWithErrors, .assignmentCell.hasErrors");
            var gradeBucketsWithErrors = $(".gradeBucketCell.updatedWithErrors, .gradeBucketCell.hasErrors");
            var subjectsWithErrors = $(".subjectCell.updatedWithErrors, .subjectCell.hasErrors");
            var academicStandardsWithErrors = $(".academicStandardCell.updatedWithErrors, .academicStandardCell.hasErrors");
            var assignmentErrorMessage = "";
            var SGBErrorMessage = "";
            var SGBSubjectErrorMessage = "";
            var SGBAcademicStandardErrorMessage = "";
            var hasAssignmentErrors = false;
            var hasSGBErrors = false;
            var hasSGBSubjectErrors = false;
            var hasSGBAcademicStandardErrors = false;

            var assignmentPromise = function ()
            {
                if (assignmentsWithErrors.length > 0)
                {
                    var errors = {};
                    assignmentsWithErrors.each(function ()
                    {
                        var cell = $(this);

                        var data = cell.data();

                        if (data.errors && !$.isEmptyObject(data.errors))
                        {
                            var idParts = cell.attr("id").split("_");
                            var studentSectionId = idParts[1];
                            var assignmentId = idParts[2];
                            var key = studentSectionId + "_" + assignmentId;
                            errors[key] = data.errors;
                        }
                    });

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/ValidationErrorDetailsPopup/",
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            errors: JSON.stringify(errors)
                        },
                        success: function (data)
                        {
                            assignmentErrorMessage = data.html;
                            hasAssignmentErrors = true;
                        }
                    }).promise();
                }
            };

            var gradeBucketPromise = function ()
            {
                if (gradeBucketsWithErrors.length > 0)
                {
                    var errors = {};
                    gradeBucketsWithErrors.each(function ()
                    {
                        var cell = $(this);
                        var data = cell.data();

                        if (data.errors)
                        {
                            var idParts = cell.attr("id").split("_");
                            var studentSectionId = idParts[1];
                            var studentGradeBucketId = data.studentGradeBucketId;
                            var key = studentSectionId + "_" + studentGradeBucketId;
                            errors[key] =
                            {
                                errors: data.errors,
                                studentGradeBucketId: data.studentGradeBucketId
                            };
                        }
                    });

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/ValidationErrorGradeBucketDetailsPopup/",
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            errors: JSON.stringify(errors)
                        },
                        success: function (data)
                        {
                            SGBErrorMessage = data.html;
                            hasSGBErrors = true;
                        }
                    }).promise();
                }
            };

            var subjectPromise = function ()
            {
                if (subjectsWithErrors.length > 0)
                {
                    var errors = {};
                    subjectsWithErrors.each(function ()
                    {
                        var cell = $(this);
                        var data = cell.data();

                        if (data.errors)
                        {
                            var idParts = cell.attr("id").split("_");
                            var studentSectionId = idParts[1];
                            var studentGradeBucketId = data.studentGradeBucketId;
                            var key = studentSectionId + "_" + studentGradeBucketId;
                            errors[key] =
                            {
                                errors: data.errors,
                                studentGradeBucketSubjectId: data.studentGradeBucketSubjectId
                            };
                        }
                    });

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/ValidationErrorSubjectGradeBucketDetailsPopup/",
                        type: "POST",
                        dataType: "JSON",
                        silent: true,
                        data:
                        {
                            errors: JSON.stringify(errors)
                        },
                        success: function (data)
                        {
                            SGBSubjectErrorMessage = data.html;
                            hasSGBSubjectErrors = true;
                        }
                    }).promise();
                }
            };

            var academicStandardPromise = function ()
            {
                var errors = {};
                if (academicStandardsWithErrors.length > 0)
                {
                    academicStandardsWithErrors.each(function ()
                    {
                        var cell = $(this);
                        var data = cell.data();

                        if (data.errors)
                        {
                            var idParts = cell.attr("id").split("_");
                            var studentSectionId = idParts[1];
                            var studentGradeBucketId = data.studentGradeBucketId;
                            var key = studentSectionId + "_" + studentGradeBucketId;
                            errors[key] =
                            {
                                errors: data.errors,
                                studentGradeBucketAcademicStandardId: data.studentGradeBucketAcademicStandardId
                            };
                        }
                    });

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/ValidationErrorAcademicStandardGradeBucketDetailsPopup/",
                        type: "POST",
                        dataType: "JSON",
                        silent: true,
                        data:
                        {
                            errors: JSON.stringify(errors)
                        },
                        success: function (data)
                        {
                            SGBAcademicStandardErrorMessage = data.html;
                            hasSGBAcademicStandardErrors = true;
                        }
                    }).promise();
                }
            };

            var promise = function ()
            {
                var myDeferred = $.Deferred();

                $.when(assignmentPromise(), gradeBucketPromise(), subjectPromise(), academicStandardPromise()).done(function ()
                {
                    myDeferred.resolve();
                });

                return myDeferred.promise();
            };

            $.when(promise()).done(function ()
            {
                var errorMessage = "";
                if (hasAssignmentErrors && (hasSGBErrors || hasSGBSubjectErrors || hasSGBAcademicStandardErrors))
                {
                    errorMessage = "<h1>Assignments</h1>" + assignmentErrorMessage + "\n\n<h1>Grades</h1>" + SGBErrorMessage + SGBSubjectErrorMessage + SGBAcademicStandardErrorMessage;
                }
                else
                {
                    errorMessage = assignmentErrorMessage + SGBErrorMessage + SGBSubjectErrorMessage + SGBAcademicStandardErrorMessage;
                }
                var popupHeader = hasAssignmentErrors ? (hasSGBErrors || hasSGBSubjectErrors || hasSGBAcademicStandardErrors) ? "Assignment/Grade " : "Assignment " : (hasSGBErrors || hasSGBSubjectErrors || hasSGBAcademicStandardErrors) ? "Grade " : "";
                var cancelButton = { id: "academicStandardDetailsPopup", text: "Ok", click: function () { dialog.close(); }, icon: "Check" };

                var dialog = skyward.modalLayer.showDialog(popupHeader + 'Errors', errorMessage, [cancelButton],
                    {
                        anchorTo: element
                    });
            });
        };

        var createSaveManager = function (gradebook)
        {
            var manager = {};

            // DOM elements
            var undoButton = $("#GradebookUndo");
            var redoButton = $("#GradebookRedo");
            var updateStatusWrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);
            var updateStatusSpan = $("#GradebookUpdateStatus");
            var errorStatusSpan = $("#GradebookErrorStatus");

            //.morebutton is a generic classname, this could be a problem if there are other more buttons on the screen
            var buttonsToDisableDuringSave = $(".gradebook--rightToolbar").find(".button:not(.moreButton, #GradebookLegend, #GradebookUndo, #GradebookRedo, .alwaysDisabled)");

            var updateErrorStatusClass = function (newClass)
            {
                errorStatusSpan.removeClass('errorDuringSave');

                if (newClass)
                {
                    errorStatusSpan.addClass(newClass);
                }
            };

            var updateStatusWrapperClass = function (newClass)
            {
                updateStatusWrapper.removeClass('unsavedChanges processing savesCompleted errorDuringSave');
                if (newClass)
                {
                    updateStatusWrapper.addClass(newClass);
                }

                if ($(".assignmentCell.updatedWithErrors").length || newClass === "errorDuringSave")
                {
                    updateErrorStatusClass('errorDuringSave');
                }
                else
                {
                    updateErrorStatusClass();
                }

                //reflow responsive controls
                $(window).trigger("resize");
            };

            $('body').off("click", "#GradebookErrorStatus.errorDuringSave").on("click", "#GradebookErrorStatus.errorDuringSave", validationErrorDetailsPopup);

            // Status variables
            var lastStatusMessage = "";
            var lastStatusClass = "";
            var unsavedChanges = false;

            // Managers
            var assignmentManager = createAssignmentManager();
            var undoManagerOptions =
            {
                execute: updateUndoButtons,
                undo: updateUndoButtons,
                redo: updateUndoButtons,
                reset: updateUndoButtons
            };
            var undoManager = skyward.autoSaveManagers.createUndoManager(undoManagerOptions);
            var saveManagerOptions =
            {
                postDataAttributeName: "gradesheetUpdateData",
                savesStarted: function ()
                {
                    skyward.changeTracking.overrideGlobalDirtyState(true);
                    buttonsToDisableDuringSave.addClass("ui-disabled");
                    lastStatusMessage = "Processing changes...";
                    lastStatusClass = 'processing';
                    if (!unsavedChanges)
                    {
                        updateStatusSpan.html(lastStatusMessage);
                        updateStatusWrapperClass(lastStatusClass);
                    }
                },
                update: function (status)
                {
                    lastStatusMessage = "Processing record " + status.numberOfCompletedRequests + " of " + status.numberOfTotalRequests + "...";
                    lastStatusClass = 'processing';
                    if (!unsavedChanges)
                    {
                        updateStatusSpan.html(lastStatusMessage);
                        updateStatusWrapperClass(lastStatusClass);
                    }
                },
                savesCompleted: function ()
                {
                    lastStatusMessage = "All successful changes have been saved on " + getCurrentTimeString();
                    lastStatusClass = 'savesCompleted';

                    if (!unsavedChanges)
                    {
                        updateStatusSpan.html(lastStatusMessage);
                        updateStatusWrapperClass(lastStatusClass);
                    }

                    skyward.changeTracking.overrideGlobalDirtyState(false);
                    buttonsToDisableDuringSave.removeClass("ui-disabled");
                }
            };
            var saveManager = skyward.autoSaveManagers.createSaveManager(saveManagerOptions);

            var setUpAllManagers = function (assignmentManager, undoManager, saveManager)
            {
                manager.saveManager = saveManager;
                manager.undoManager = undoManager;
                manager.assignmentManager = assignmentManager;
            };

            setUpAllManagers(assignmentManager, undoManager, saveManager);

            function updateUndoButtons(status)
            {
                if (status.canUndo)
                {
                    undoButton.removeClass("ui-disabled");
                    skyward.controls.enable(undoButton);
                }
                else
                {
                    undoButton.addClass("ui-disabled");
                }

                if (status.canRedo)
                {
                    redoButton.removeClass("ui-disabled");
                    skyward.controls.enable(redoButton);
                }
                else
                {
                    redoButton.addClass("ui-disabled");
                }
            }

            function getCurrentTimeString()
            {
                var format = function (number)
                {
                    var numberString = number.toString();

                    if (numberString.length < 2)
                    {
                        numberString = "0" + numberString;
                    }

                    return numberString;
                };

                var currentdate = skyward.time.now();
                var hours = currentdate.getHours();
                var ampm = "am";
                if (hours >= 12)
                {
                    hours -= 12;
                    ampm = "pm";
                }
                if (hours === 0)
                {
                    hours = 12;
                }
                var datestring = (currentdate.getMonth() + 1) + "/"
                    + currentdate.getDate() + "/"
                    + currentdate.getFullYear() + " at "
                    + hours + ":"
                    + format(currentdate.getMinutes()) + " " + ampm;

                return datestring;
            }

            manager.save = function (saveObjects)
            {
                var valuesToSave = assignmentManager.getChangedValues(saveObjects);

                if (!valuesToSave.length || !gradebook.editMode)
                {
                    return;
                }

                var deferred = $.Deferred();

                // todo This logic can be cleaned up when we send mass assign saves in a single batch again
                var command =
                {
                    execute: function ()
                    {
                        if (valuesToSave.length == 0)
                        {
                            deferred.resolve();
                        }
                        var count = 0;
                        var valuesToSaveLength = valuesToSave.length;
                        for (var i = 0; i < valuesToSave.length; i++)
                        {
                            var data = $.extend({}, valuesToSave[i]);
                            delete data.originalValues;
                            delete data.hasChanges;

                            if (assignmentManager.setValues(data, false) == true)
                            {
                                var encodedData = {};
                                $.each(data, function (key, value)
                                {
                                    if (value != null && typeof value === 'string') //Don't want to try to encode any objects. Numbers will not need this
                                    {
                                        encodedData[key] = skyward.extensions.encodeHtml(value);
                                    }
                                    else
                                    {
                                        encodedData[key] = value;
                                    }
                                });

                                var promise = saveManager.save(encodedData, "Gradebook/Gradebook/UpdateGradeSheetData");
                                $.when(promise).then(function (response)
                                {
                                    setSaveResponseOriginalValues(response, valuesToSave);

                                    if (gradebook)
                                    {
                                        checkAjaxResponseForErrors(response, assignmentManager.handleSaveResponse, [false, response, gradebook, response.objectsToUpdate]);
                                    }
                                    else if (response && response.success == false)
                                    {
                                        skyward.modalLayer.showReloadDialog(ALERT_HEADER, response.popupHTML.Content);
                                    }
                                    else
                                    {
                                        assignmentManager.handleSaveResponse(false, response, gradebook, response.objectsToUpdate);
                                    }
                                    count++;
                                    if (count == valuesToSaveLength)
                                    {
                                        deferred.resolve();
                                    }
                                });
                            }
                        }
                    },
                    undo: function ()
                    {
                        for (var i = 0; i < valuesToSave.length; i++)
                        {
                            var data = $.extend({}, valuesToSave[i], valuesToSave[i].originalValues);
                            delete data.originalValues;
                            delete data.hasChanges;

                            if (assignmentManager.setValues(data, true) == true)
                            {
                                var promise = saveManager.save(data, "Gradebook/Gradebook/UpdateGradeSheetData");
                                $.when(promise).then(function (response)
                                {
                                    setSaveResponseOriginalValues(response, valuesToSave);
                                    assignmentManager.handleSaveResponse(true, response, gradebook, response.objectsToUpdate);
                                });
                            }
                        }
                    }
                };

                undoManager.execute(command);
                return deferred;
            };

            manager.setDirtyState = function (hasUnsavedChanges)
            {
                unsavedChanges = hasUnsavedChanges;

                if (unsavedChanges)
                {
                    updateStatusSpan.html("There are unsaved changes");
                    updateStatusWrapperClass('unsavedChanges');
                }
                else
                {
                    if (updateStatusWrapper.hasClass('errorDuringSave'))
                    {
                        if (updateStatusWrapper.hasClass('studentAssignmentError') || updateStatusWrapper.hasClass('studentGradeBucketError'))
                        {
                            lastStatusMessage = "Error Updating Grades";
                        }
                        lastStatusClass = 'errorDuringSave';
                    }

                    updateStatusSpan.html(lastStatusMessage);
                    updateStatusWrapperClass(lastStatusClass);
                }
            };

            manager.undo = function ()
            {
                undoManager.undo();
            };

            manager.redo = function ()
            {
                undoManager.redo();
            };

            manager.reset = function ()
            {
                updateStatusWrapperClass();
                undoManager.reset();
            };

            manager.updateAverageValues = function (returnData)
            {
                assignmentManager.updateAverageValues(returnData, gradebook);
            };

            manager.stillProcessingSaves = function ()
            {
                return lastStatusClass == 'processing';
            }

            return manager;
        };

        var createAssignmentManager = function ()
        {
            var updateStatusWrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);
            var updateStatusSpan = $("#GradebookUpdateStatus");
            var errorStatusSpan = $("#GradebookErrorStatus");
            var manager = {};

            var updateStatusWrapperClass = function (newClass)
            {
                updateStatusWrapper.removeClass('unsavedChanges processing savesCompleted errorDuringSave');

                if (newClass)
                {
                    updateStatusWrapper.addClass(newClass);
                }
                if (newClass === "errorDuringSave")
                {
                    errorStatusSpan.addClass(newClass);
                }
                else
                {
                    errorStatusSpan.removeClass("errorDuringSave");
                }
            };

            var updateStudentAssignmentReadOnly = function (studentAssignmentData, studentAssignmentElement, gradebook)
            {
                var enabled = true;
                if (studentAssignmentData.isDropped != null)
                {
                    enabled = !studentAssignmentData.isDropped;
                }

                if (enabled == true && studentAssignmentElement.hasClass('hasAttempts'))
                {
                    enabled = false;
                }

                var offClassName = "gradebookScoringMode-Off";
                var onClassName = "gradebookScoringMode-On";
                var scoringModeDoesntAffectStateClassName = "scoringModeDoesntAffectState";

                //Make sure we have the right element because there are 2 in the dom for each student assignment
                if (!studentAssignmentElement.hasClass("gradebookInput") && !studentAssignmentElement.hasClass("gradeMarkScoring"))
                {
                    studentAssignmentElement = studentAssignmentElement.siblings(".gradebookInput");
                }

                if (enabled)
                {
                    studentAssignmentElement.addClass(onClassName);
                    studentAssignmentElement.removeClass(offClassName);
                    studentAssignmentElement.removeClass(scoringModeDoesntAffectStateClassName);
                    gradebook.enableControl(studentAssignmentElement);
                }
                else
                {
                    studentAssignmentElement.removeClass(onClassName);
                    studentAssignmentElement.addClass(offClassName);
                    studentAssignmentElement.addClass(scoringModeDoesntAffectStateClassName);
                    gradebook.disableControl(studentAssignmentElement);
                }
            };

            manager.updateChangedClass = function (element, isUndo, bucketData)
            {
                var inputElement = element;

                var isScore = inputElement.data().fieldname == "Score";
                if (element.is("input"))
                {
                    element = element.closest(".assignmentCell");
                }

                //handle closed grading period grade change classes
                element.removeClass('gradeBucketGradeChangeDenied').removeClass('gradeBucketGradeChangeNotReviewedOrInProgress');

                var updates = element.data("numberOfUpdates") || 0;
                isUndo ? updates-- : updates++;
                element.data("numberOfUpdates", updates);

                if (isScore)
                {
                    if (updates > 0)
                    {
                        updateAssignmentCellClasses(inputElement, element);
                    }
                    else
                    {
                        removeCellErrorClasses(element, "updatedOverMaxScore updated");
                        setWarningIconClass(element, '.assignmentIndicatorsFirstRow', false);
                    }
                }
                else
                {
                    updates > 0 ? removeCellErrorClasses(element.addClass("updated")) : element.removeClass("updated");
                    updateStudentGradeBucketCellClasses(inputElement, element, bucketData);
                }
            };

            var updateAssignmentCellClasses = function (inputElement, element)
            {
                var indicatorSpan = '.assignmentIndicatorsFirstRow';
                var overMaxScore = updateChangedAssignmentCell(inputElement);
                if (overMaxScore)
                {
                    removeCellErrorClasses(element.addClass("updatedOverMaxScore"), "updated");
                    setWarningIconClass(element, indicatorSpan, true);
                }
                else
                {
                    removeCellErrorClasses(element.addClass("updated"), "updatedOverMaxScore");
                    setWarningIconClass(element, indicatorSpan, false);
                }
            };

            var updateChangedAssignmentCell = function (element)
            {
                if (!element.hasClass('gradeMarkScoring') && parseFloat(skyward.controls.getValue(element)) > parseFloat(element.data('maxscore')))
                {
                    return true;
                }
                return false;
            };

            manager.setOriginalStudentAssignmentValues = function (input, value)
            {
                if (input.hasClass("studentAssignment"))
                {
                    input.data("original-assignment-score", value);
                }
            };

            manager.setInputOriginalValue = function (input, value)
            {
                if (input.hasClass("codeEELCode"))
                {
                    input.siblings(".codeEELValue").data("original-value", value);
                }
                else if (input.hasClass("gradebookInputCodeEEL"))
                {
                    skyward.gradebookcodeeel.setOriginalValueData(input, skyward.gradebookcodeeel.getData(input).displayValue, value);
                }
                else
                {
                    input.data("original-value", value);
                    manager.setOriginalStudentAssignmentValues(input, value);
                }
            };

            var getStudentGradeBucketChangedValues = function (studentGradeBucketData, inputParam, studentGradeBucketID)
            {
                var input = inputParam.find(".gradebookInputCodeEEL");
                var studentSectionID = input.parents('.gradesheetBrowseRow').data('studentSectionId');
                var gradingPeriodGradeBucketID = input.parents('.gradeBucketCell').data('gradingPeriodGradeBucketId');

                var saveData =
                {
                    saveManagerId: studentSectionID,
                    isStudentGradeBucket: true,
                    hasChanges: false,
                    studentGradeBucketID: studentGradeBucketID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: input.data().isavailable,
                    studentSectionID: studentSectionID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    saveObject: "StudentGradeBucket",
                    gradeMarkID: skyward.gradebookcodeeel.getData(input).selectedValueID,
                    Score: studentGradeBucketData.Score,
                    originalValues: {}
                };

                setInputData(input, saveData, true);

                return saveData;
            };

            var getStudentGradeBucketSubjectChangedValues = function (studentGradeBucketSubjectData)
            {
                var studentGradeBucketSubjectID = studentGradeBucketSubjectData.studentGradeBucketSubjectID;

                var input = $("#SubjectiveSubjectGradeMark_" + studentGradeBucketSubjectID);

                var inputData = input.data();
                var subjectID = inputData.subjectId;
                var gradingPeriodGradeBucketID = inputData.gradingPeriodGradeBucketId;
                var studentGradeBucketID = inputData.studentGradeBucketId;
                var saveData =
                {
                    saveManagerId: studentGradeBucketSubjectData.studentSectionId,
                    studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                    subjectID: subjectID,
                    gradeMarkID: skyward.gradebookcodeeel.getData(input).selectedValueID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: inputData.isavailable,
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    hasChanges: false,
                    Score: studentGradeBucketSubjectData.Score,
                    saveObject: "StudentGradeBucketSubject",
                    originalValues: {}
                };

                setInputData(input, saveData, true);

                return saveData;
            };

            var getMasteryStudentGradeBucketSubjectChangedValues = function (studentGradeBucketSubjectData)
            {
                var studentGradeBucketSubjectID = studentGradeBucketSubjectData.studentGradeBucketSubjectID;

                var input = $("#MasterySubjectGradeMark_" + studentGradeBucketSubjectID);
                var isMastered = input.is(":checked");

                var inputData = input.data();
                var subjectID = inputData.subjectId;
                var gradingPeriodGradeBucketID = inputData.gradingPeriodGradeBucketId;
                var studentGradeBucketID = inputData.studentGradeBucketId;

                var saveData =
                {
                    saveManagerId: studentGradeBucketSubjectData.studentSectionId,
                    studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                    subjectID: subjectID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: inputData.isavailable,
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    hasChanges: true,
                    isMastered: isMastered,
                    isMastery: true,
                    originalValues:
                    {
                        isMastered: !isMastered
                    },
                    saveObject: "StudentGradeBucketSubject"
                };
                return saveData;
            };

            var getStudentGradeBucketAcademicStandardChangedValues = function (studentGradeBucketAcademicStandardData)
            {
                var studentGradeBucketAcademicStandardID = studentGradeBucketAcademicStandardData.studentGradeBucketAcademicStandardID;

                var input = $("#SubjectiveAcademicStandardGradeMark_" + studentGradeBucketAcademicStandardID);

                var inputData = input.data();
                var academicStandardID = inputData.academicStandardId;
                var studentGradeBucketID = inputData.studentGradeBucketId;
                var gradingPeriodGradeBucketID = inputData.gradingPeriodGradeBucketId;

                var saveData =
                {
                    saveManagerId: studentGradeBucketAcademicStandardData.studentSectionId,
                    studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                    academicStandardID: academicStandardID,
                    gradeMarkID: skyward.gradebookcodeeel.getData(input).selectedValueID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: inputData.isavailable,
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    hasChanges: false,
                    Score: studentGradeBucketAcademicStandardData.Score,
                    saveObject: "StudentGradeBucketAcademicStandard",
                    originalValues: {}
                };

                setInputData(input, saveData, true);

                return saveData;
            };

            var getMasteryStudentGradeBucketAcademicStandardChangedValues = function (studentGradeBucketAcademicStandardData)
            {
                var studentGradeBucketAcademicStandardID = studentGradeBucketAcademicStandardData.studentGradeBucketAcademicStandardID;

                var input = $("#MasteryAcademicStandardGradeMark_" + studentGradeBucketAcademicStandardID);
                var isMastered = input.is(":checked");

                var inputData = input.data();
                var academicStandardID = inputData.academicStandardId;
                var studentGradeBucketID = inputData.studentGradeBucketId;
                var gradingPeriodGradeBucketID = inputData.gradingPeriodGradeBucketId;

                var saveData =
                {
                    saveManagerId: studentGradeBucketAcademicStandardData.studentSectionId,
                    studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                    academicStandardID: academicStandardID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: inputData.isavailable,
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    hasChanges: true,
                    isMastered: isMastered,
                    isMastery: true,
                    originalValues:
                    {
                        isMastered: !isMastered
                    },
                    saveObject: "StudentGradeBucketAcademicStandard"
                };

                return saveData;
            };

            var getAssignmentChangedValues = function (assignment)
            {
                var studentSectionId = assignment.studentSectionId;
                var assignmentId = assignment.assignmentId;
                var academicStandardId = assignment.academicStandardId;
                var isAvailable = assignment.isAvailable;
                var inputs = $("input[data-studentsectionid='" + studentSectionId + "'][data-assignmentid='" + assignmentId + "']");
                var useGradeMarkScoringEEL = inputs.parent().find('.gradeMarkScoring').length > 0;

                assignmentId = getRepresentedAssignmentID(assignmentId, assignment.sectionId);

                if (assignmentId == null)
                {
                    return {};
                }

                var studentAssignmentData =
                {
                    saveManagerId: studentSectionId,
                    id: "Gradebook_" + studentSectionId + "_" + assignmentId,
                    assignmentId: assignmentId,
                    studentSectionId: studentSectionId,
                    academicStandardId: academicStandardId,
                    isAvailable: isAvailable,
                    hasChanges: false,
                    sectionId: assignment.sectionId,
                    saveObject: "StudentAssignment",
                    displayValue: assignment.displayValue,
                    scoreClarifierCode: assignment.displayValue,
                    gradeMarkDisplayValue: assignment.displayValue,
                    originalValues: {},
                    skipUpdateLastScoredTime: assignment.skipUpdateLastScoredTime
                };

                for (var i = 0; i < inputs.length; i++)
                {
                    setInputData($(inputs[i]), studentAssignmentData, useGradeMarkScoringEEL);
                }

                if (assignment.IsDropped != null)
                {
                    studentAssignmentData["IsDropped"] = assignment.IsDropped;
                    studentAssignmentData.originalValues["IsDropped"] = !assignment.IsDropped;
                    studentAssignmentData.hasChanges = true;
                }

                return studentAssignmentData;
            };

            var setInputData = function (input, objectToAddDataTo, useGradeMarkScoringEEL)
            {
                if (!input)
                {
                    return;
                }

                var inputData = input.data();
                var value = getInputValue(input);
                var originalValue = getInputOriginalValue(input);
                var fieldName = inputData.fieldname ? inputData.fieldname : "Score";

                if (value != originalValue && !(originalValue == "*" && value == "" ))
                {
                    if (fieldName === "Score" && value > 0)
                    {
                        var isMissingInput = $("#" + BROWSE_NAME + "_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_IsMissing").find(".checkbox");

                        if (isMissingInput.length > 0)
                        {
                            var isMissingField = "IsMissing";
                            var isMissingValue = getInputValue(isMissingInput);

                            if (isMissingValue === true)
                            {
                                objectToAddDataTo[isMissingField] = false;
                                objectToAddDataTo.originalValues[isMissingField] = isMissingValue;
                                objectToAddDataTo.hasChanges = true;
                            }
                        }
                    }

                    if (!input.hasClass("gradebookInputCodeEEL"))
                    {
                        objectToAddDataTo[fieldName] = value;
                        objectToAddDataTo.originalValues[fieldName] = originalValue;
                    }
                    else
                    {
                        objectToAddDataTo[fieldName] =
                        {
                            displayValue: inputData.displayValue,
                            selectedValueID: value
                        };

                        objectToAddDataTo.originalValues[fieldName] = {};
                        objectToAddDataTo.originalValues[fieldName]["displayValue"] = skyward.gradebookcodeeel.getOriginalValueData(input).originalDisplayValue;
                        objectToAddDataTo.originalValues[fieldName]["selectedValueID"] = skyward.gradebookcodeeel.getOriginalValueData(input).originalSelectedValueID;
                    }
                    objectToAddDataTo.hasChanges = true;
                }
            };

            var setStudentGradeBucketValues = function (studentGradeBucketData, isUndo)
            {
                var valid = true;

                $(".gradeBucketCell[data-student-grade-bucket-id='" + studentGradeBucketData.studentGradeBucketID + "']").each(function ()
                {
                    var input = $(this).find(".gradebookInputCodeEEL");
                    if (!input.is(':disabled') && !input.is('[readonly]'))
                    {
                        skyward.gradebookcodeeel.setValue(input, studentGradeBucketData.Score.displayValue, studentGradeBucketData.Score.selectedValueID, true);
                        manager.setInputOriginalValue(input, getInputValue(input));
                    }
                    else
                    {
                        valid = false;
                    }
                });

                return valid;
            };

            var setStudentGradeBucketSubjectValues = function (studentGradeBucketData, isUndo)
            {
                var valid = true;

                if (studentGradeBucketData.isMastery)
                {
                    var checkbox = $("#MasterySubjectGradeMark_" + studentGradeBucketData.studentGradeBucketSubjectID);
                    if (!checkbox.is(':disabled, [readonly], .ui-disabled'))
                    {
                        skyward.controls.setValue(checkbox, studentGradeBucketData.isMastered);
                    }
                    else
                    {
                        valid = false;
                    }
                }
                else
                {
                    var input = $("#SubjectiveSubjectGradeMark_" + studentGradeBucketData.studentGradeBucketSubjectID);
                    if (!input.is(':disabled') && !input.is('[readonly]'))
                    {
                        skyward.gradebookcodeeel.setValue(input, studentGradeBucketData.Score.displayValue, studentGradeBucketData.Score.selectedValueID, true);
                        manager.setInputOriginalValue(input, getInputValue(input));
                    }
                    else
                    {
                        valid = false;
                    }
                }

                return valid;
            };

            var setStudentGradeBucketAcademicStandardValues = function (studentGradeBucketData, isUndo)
            {
                var valid = true;

                if (studentGradeBucketData.isMastery)
                {
                    var checkbox = $("#MasteryAcademicStandardGradeMark_" + studentGradeBucketData.studentGradeBucketAcademicStandardID);
                    if (!checkbox.is(':disabled, [readonly], .ui-disabled'))
                    {
                        skyward.controls.setValue(checkbox, studentGradeBucketData.isMastered);
                    }
                    else
                    {
                        valid = false;
                    }
                }
                else
                {
                    var input = $("#SubjectiveAcademicStandardGradeMark_" + studentGradeBucketData.studentGradeBucketAcademicStandardID);
                    if (!input.is(':disabled') && !input.is('[readonly]'))
                    {
                        skyward.gradebookcodeeel.setValue(input, studentGradeBucketData.Score.displayValue, studentGradeBucketData.Score.selectedValueID, true);
                        manager.setInputOriginalValue(input, getInputValue(input));
                    }
                    else
                    {
                        valid = false;
                    }
                }

                return valid;
            };

            var setAssignmentValuesFromUpdateGradeSheetDataReturnData = function (studentAssignment)
            {
                var assignment =
                {
                    assignmentId: studentAssignment.assignmentId,
                    studentSectionId: studentAssignment.studentSectionId,
                    ScoreClarifierID: studentAssignment.scoreClarifierId,
                    IsMissing: studentAssignment.isMissing,
                    AttemptCount: studentAssignment.attempts
                };
                return setAssignmentValues(assignment, false);
            };

            var setAssignmentValues = function (assignment, isUndo)
            {
                var valid = true;
                var assignmentId = getDriverAssignmentID(assignment.assignmentId);
                var studentSectionId = assignment.studentSectionId;
                var fields = $("[data-assignmentid='" + assignmentId + "'][data-studentsectionid='" + studentSectionId + "']");

                for (var i = 0; i < fields.length; i++)
                {
                    var input = $(fields[i]);
                    var fieldName = input.data("fieldname");

                    if (!assignment.hasOwnProperty(fieldName))
                    {
                        continue;
                    }

                    if (input.is(':disabled') || input.is('[readonly]'))
                    {
                        valid = false;
                        break;
                    }

                    if (input.hasClass("codeEELCode"))
                    {
                        skyward.controls.setValue(input.parent(), assignment[fieldName]);
                    }
                    else if (fieldName === "ScoreClarifierID")
                    {
                        if (input.hasClass("gradebookInputCodeEEL"))
                        {
                            skyward.gradebookcodeeel.setValue(input, assignment.ScoreClarifierID.displayValue, assignment.ScoreClarifierID.selectedValueID, true);
                        }
                        else
                        {
                            skyward.controls.setValue(input, assignment.scoreClarifierCode);
                        }
                    }
                    else if (input.hasClass("gradebookInputCodeEEL") && input.hasClass("gradeMarkScoring"))
                    {
                        skyward.gradebookcodeeel.setValue(input, assignment.Score.displayValue, assignment.Score.selectedValueID, true);
                    }
                    else
                    {
                        skyward.controls.setValue(input, assignment[fieldName]);
                    }

                    var inputData = input.data();

                    manager.setInputOriginalValue(input, getInputValue(input));
                    updateAssignmentIndicatorSvg(input, "#" + BROWSE_NAME + "_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_" + "Score", "#" + BROWSE_NAME);
                    updateAssignmentIndicatorSvgSecondRow(input, { overrideShow: false }, "#" + BROWSE_NAME + "_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_" + "Score");
                    manager.updateChangedClass(input, isUndo, {});
                }

                return valid;
            };

            var updateStudentAssignmentId = function (studentSectionId, assignmentId, studentAssignmentId)
            {
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_Score input.gradebookInput").data("studentassignmentid", studentAssignmentId);
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_ScoreClarifierID input").data("studentassignmentid", studentAssignmentId);
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_NoCount input").data("studentassignmentid", studentAssignmentId);
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_IsMissing input").data("studentassignmentid", studentAssignmentId);
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_Comments input").data("studentassignmentid", studentAssignmentId);
            };

            var updatePassedStudentAssignmentDisplay = function (affectedStudentAssignment, gradebook, isUndo)
            {
                var studentAssignmentCell = $("#" + BROWSE_NAME + "_" + affectedStudentAssignment.studentSectionId + "_" + affectedStudentAssignment.assignmentId + "_Score");
                var studentAssignmentCellData = studentAssignmentCell.data();

                var studentAssignmentInput = studentAssignmentCell.find("input.studentAssignment");

                var studentAssignmentData = studentAssignmentInput.data();
                if (studentAssignmentData.secondaryfieldname == 'GradeMarkScore')
                {
                    studentAssignmentInput.data('enabledGrademarkValue', affectedStudentAssignment.grademarkvalue);
                    studentAssignmentInput.data('disabledGrademarkValue', affectedStudentAssignment.displayValue);
                }

                studentAssignmentInput.data('displayValue', affectedStudentAssignment.displayValue);
                studentAssignmentInput.data('studentAssignmentScore', affectedStudentAssignment.score);

                var isParent = studentAssignmentData.isParent.toString().toLowerCase() == "true";
                if (isParent && skyward.controls.getValue(studentAssignmentInput) != affectedStudentAssignment.score)
                {
                    if (studentAssignmentData.secondaryfieldname == 'GradeMarkScore')
                    {
                        skyward.controls.setValue(studentAssignmentInput, affectedStudentAssignment.displayValue, true);
                    }
                    else
                    {
                        skyward.controls.setValue(studentAssignmentInput, affectedStudentAssignment.score, true);
                    }

                    manager.updateChangedClass(studentAssignmentInput, isUndo, {});
                }

                if (!isParent)
                {
                    updateStudentAssignmentReadOnly(affectedStudentAssignment, studentAssignmentInput, gradebook);
                }

                if (affectedStudentAssignment.isDropped != null)
                {
                    updateAssignmentIndicatorSvgSecondRow(studentAssignmentInput, { fieldnameOverride: "IsDropped", isDropped: affectedStudentAssignment.isDropped }, "#" + BROWSE_NAME + "_" + studentAssignmentData.studentsectionid + "_" + studentAssignmentData.assignmentid + "_" + "Score");
                }

                if (studentAssignmentData.istransferassignment != null && studentAssignmentData.istransferassignment.toString().toLowerCase() === "true")
                {
                    updateAssignmentIndicatorSvg(studentAssignmentInput, "#" + BROWSE_NAME + "_" + studentAssignmentData.studentsectionid + "_" + studentAssignmentData.assignmentid + "_" + "Score", "#" + BROWSE_NAME, "TransferGrade", shouldShowTransferIcon(affectedStudentAssignment));
                }


                applyGradeColors("assignment", affectedStudentAssignment.GradeMarkID, affectedStudentAssignment.BackingPercent, studentAssignmentCell, gradebook.colorData());

                //Clear any Existing Errors
                studentAssignmentCell.data("errors", {});
                removeCellErrorClasses(studentAssignmentCell);
                checkToggleErrorButton();
            };

            var checkToggleErrorButton = function ()
            {
                var cellsWithError = $('.gradebookCell.updatedWithErrors:not(.noMatch)');
                var errorButton = $('#GradebookErrorStatus');
                if (cellsWithError.length > 0)
                {
                    if (!errorButton.hasClass('errorDuringSave'))
                    {
                        errorButton.addClass('errorDuringSave');
                    }
                }
                else if (errorButton.hasClass('errorDuringSave'))
                {
                    errorButton.removeClass('errorDuringSave');
                }
            };

            var updateFailedStudentAssignmentDisplay = function (studentAssignment)
            {
                var studentAssignmentCell = $("#" + BROWSE_NAME + "_" + studentAssignment.studentSectionId + "_" + studentAssignment.assignmentId + "_Score");
                studentAssignmentCell.removeClass('updated updatedOverMaxScore').addClass('updatedWithErrors');
                studentAssignmentCell.data("errors", studentAssignment.errors);
                var studentAssignmentCellData = studentAssignmentCell.data();
                updateAssignmentIndicatorSvgSecondRow(studentAssignmentCell, { overrideShow: true }, "#" + BROWSE_NAME + "_" + studentAssignmentCellData.studentsectionid + "_" + studentAssignmentCellData.assignmentid + "_" + "Score", "#" + BROWSE_NAME);
            };

            var updateFailedGradeBucketValue = function (cells, errors)
            {
                cells.each(function ()
                {
                    var cell = $(this);
                    if (cell.length < 1)
                    {
                        //If the cell does not exist then the bucket is hidden and we have nothing to update
                        return;
                    }
                    //remove colors if subject/standard...
                    cell.removeClass('updated updatedOverMaxScore').addClass('updatedWithErrors');
                    var errorString = "";
                    for (var error in Object.keys(errors))
                    {
                        var objectValue = Object.values(errors).valueOf(error);
                        if (objectValue != "" && objectValue != null && objectValue != undefined)
                        {
                            errorString += objectValue + ", ";
                        }
                    }

                    cell.css({ backgroundColor: '', color: '' });

                    errorString = errorString.substring(0, errorString.length - 2);
                    cell.data("errors", errors);
                });
            };

            var updateGradeBucketValue = function (isUndo, bucketData, gradebook)
            {
                var cells = $("td[data-student-grade-bucket-id='" + bucketData.StudentGradeBucketID + "']:not(.subjectCell, .academicStandardCell)");
                cells.each(function ()
                {
                    var cell = $(this);
                    if (cell.length < 1)
                    {
                        //If the cell does not exist then the bucket is hidden and we have nothing to update
                        return;
                    }

                    var cellScoreSpan = cell.find('.gradeBucketScoreSpan');

                    var input = cell.find(".subjectiveStudentGradeBucket");
                    if (cellScoreSpan != undefined && input.length > 0)
                    {
                        cell.data("displayValue", bucketData.GradeMarkCode);
                        skyward.gradebookcodeeel.setValue(input, bucketData.GradeMarkCode, bucketData.GradingScaleGroupGradeMarkID, true);
                    }
                    cell.find("span.gradeBucketScoreSpan > span").html(bucketData.Value);

                    applyGradeColors("class", bucketData.GradeMarkIDToUse, bucketData.BackingPercent, cell, gradebook.colorData());
                    manager.updateChangedClass(cell, isUndo, bucketData);

                    //TODO: loop through bucketData.AffectedStudentGradeBucketSubjects and update the appropriate student grade bucket subject cells.
                });

            };

            var updateGradeBucketSubjectValue = function (isUndo, bucketData, gradebook)
            {
                var subjectCells = $("td[data-student-grade-bucket-subject-id='" + bucketData.StudentGradeBucketSubjectID + "']");
                subjectCells.each(function ()
                {
                    var cell = $(this);
                    if (cell.length < 1)
                    {
                        //If the cell does not exist then the bucket is hidden and we have nothing to update
                        return;
                    }

                    var subjectID = cell.data().subjectId;
                    var headerCell = $(".subjectHeaderCell[data-calculation-group-subject-grade-bucket-id=" + cell.data().calculationGroupSubjectGradeBucketId + "]");

                    if (headerCell.length > 0 && headerCell.data() != null && headerCell.data().calculationType == "S")
                    {
                        cell.data("displayValue", bucketData.GradeMarkCode);
                        skyward.gradebookcodeeel.setValue(cell.find(".subjectiveStudentGradeBucketSubject"), bucketData.GradeMarkCode, bucketData.GradingScaleGroupGradeMarkID, true);
                    }

                    applyGradeColors("subject", bucketData.GradeMarkIDToUse, bucketData.BackingPercent, cell, gradebook.colorData());
                    manager.updateCellClassesAndColors("span.subjectScoreSpan > span", bucketData, cell, isUndo);
                });
            };

            var updateGradeBucketAcademicStandardValue = function (isUndo, bucketData, gradebook)
            {
                var academicStandardCells = $("td[data-student-grade-bucket-academic-standard-id='" + bucketData.StudentGradeBucketAcademicStandardID + "']");
                academicStandardCells.each(function ()
                {
                    var cell = $(this);
                    if (cell.length < 1)
                    {
                        //If the cell does not exist then the bucket is hidden and we have nothing to update
                        return;
                    }

                    var academicStandardID = cell.data().academicStandardId;
                    var headerCell = $(".academicStandardHeaderCell[data-calculation-group-academic-standard-grade-bucket-id=" + cell.data().calculationGroupAcademicStandardGradeBucketId + "]");

                    if (headerCell.length > 0 && headerCell.data() != null && headerCell.data().calculationType == "S")
                    {
                        cell.data("displayValue", bucketData.GradeMarkCode);
                        skyward.gradebookcodeeel.setValue(cell.find(".subjectiveStudentGradeBucketAcademicStandard"), bucketData.GradeMarkCode, bucketData.GradingScaleGroupGradeMarkID, true);
                    }

                    manager.updateCellClassesAndColors("span.academicStandardScoreSpan > span", bucketData, cell, isUndo);
                    applyGradeColors("standard", bucketData.GradeMarkIDToUse, bucketData.BackingPercent, cell, gradebook.colorData());

                });
            };

            manager.updateCellClassesAndColors = function (spanSelector, bucketData, cell, isUndo)
            {
                cell.find(spanSelector).html(bucketData.Value);

                if (bucketData.HasClosedGradingPeriodGradeChangeRequestInProgress)
                {
                    if (!cell.hasClass("gradeBucketGradeChangeNotReviewedOrInProgress"))
                    {
                        cell.addClass("gradeBucketGradeChangeNotReviewedOrInProgress");
                    }
                }
                manager.updateChangedClass(cell, isUndo, bucketData);

                if (isUndo == false || cell.hasClass('updated') || cell.hasClass('gradeBucketGradeChangeNotReviewedOrInProgress'))
                {
                    //Since we hard code a color for subjects we need to remove it for updated ones
                    cell.css({ backgroundColor: '', color: '' });
                }
                else
                {
                    var cellData = cell.data();
                    cell.css({ backgroundColor: cellData.backgroundColor, color: cellData.color });
                }
            };

            manager.handleSaveResponse = function (isUndo, returnData, gradebook, valuesToSave)
            {
                if (returnData == null)
                {
                    return;
                }

                if (!returnData.success)
                {
                    if (gradebook)
                    {
                        gradebook.clearInputValueFromFailedSave(valuesToSave);
                    }

                    if (returnData.affectedStudentAssignments.length == 0 && returnData.affectedStudentGradeBuckets.length == 0 && returnData.affectedStudentGradeBucketSubjects.length == 0 && returnData.affectedStudentGradeBucketAcademicStandards.length == 0)
                    {
                        return; //no where to display errors
                    }
                    else
                    {
                        updateStatusWrapperClass('errorDuringSave');
                    }

                    if (returnData.affectedStudentAssignments.length > 0)
                    {
                        //only handle the studentAssignments, StudentGradeBuckets can be added back when we need to get the errors off of them
                        for (var j = 0; j < returnData.createdStudentAssignments.length; j++)
                        {
                            var studentAssignment = returnData.createdStudentAssignments[j];
                            updateFailedStudentAssignmentDisplay(studentAssignment);
                        }

                        for (var h = 0; h < returnData.affectedStudentAssignments.length; h++)
                        {
                            var affectedStudentAssignment = returnData.affectedStudentAssignments[h];
                            updateFailedStudentAssignmentDisplay(affectedStudentAssignment);
                        }
                        updateStatusWrapper.addClass('studentAssignmentError');
                    }

                    if (returnData.affectedStudentGradeBuckets != null)
                    {
                        for (var j in returnData.affectedStudentGradeBuckets)
                        {
                            var studentGradeBucket = returnData.affectedStudentGradeBuckets[j];
                            if (Object.keys(studentGradeBucket.Errors).length > 0)
                            {
                                var cells = $("td[data-student-grade-bucket-id='" + studentGradeBucket.StudentGradeBucketID + "']:not(.subjectCell, .academicStandardCell)");
                                updateFailedGradeBucketValue(cells, studentGradeBucket.Errors);
                            }
                        }
                        updateStatusWrapper.addClass('studentGradeBucketError');
                    }

                    if (returnData.affectedStudentGradeBucketAcademicStandards != null)
                    {
                        for (var j in returnData.affectedStudentGradeBucketAcademicStandards)
                        {
                            var studentGradeBucketAcademicStandard = returnData.affectedStudentGradeBucketAcademicStandards[j];
                            if (Object.keys(studentGradeBucketAcademicStandard.Errors).length > 0)
                            {
                                var cells = $("td[data-student-grade-bucket-academic-standard-id='" + studentGradeBucketAcademicStandard.StudentGradeBucketAcademicStandardID + "']");
                                updateFailedGradeBucketValue(cells, studentGradeBucketAcademicStandard.Errors);
                            }
                        }
                        updateStatusWrapper.addClass('studentGradeBucketError');
                    }

                    if (returnData.affectedStudentGradeBucketSubjects != null)
                    {
                        for (var j in returnData.affectedStudentGradeBucketSubjects)
                        {
                            var studentGradeBucketSubject = returnData.affectedStudentGradeBucketSubjects[j];
                            if (Object.keys(studentGradeBucketSubject.Errors).length > 0)
                            {
                                var cells = $("td[data-student-grade-bucket-subject-id='" + studentGradeBucketSubject.StudentGradeBucketSubjectID + "']");
                                updateFailedGradeBucketValue(cells, studentGradeBucketSubject.Errors);
                            }
                        }
                        updateStatusWrapper.addClass('studentGradeBucketError');
                    }

                    updateStatusSpan.html('Error Updating Grades');
                }
                else
                {
                    for (var i = 0; i < returnData.affectedStudentGradeBuckets.length; i++)
                    {
                        var bucket = returnData.affectedStudentGradeBuckets[i];
                        updateGradeBucketValue(isUndo, bucket, gradebook);
                    }

                    if (returnData.affectedStudentGradeBucketAcademicStandards != undefined)
                    {
                        for (var i = 0; i < returnData.affectedStudentGradeBucketAcademicStandards.length; i++)
                        {
                            var bucket = returnData.affectedStudentGradeBucketAcademicStandards[i];
                            updateGradeBucketAcademicStandardValue(isUndo, bucket, gradebook);
                        }
                    }

                    if (returnData.affectedStudentGradeBucketSubjects != undefined)
                    {
                        for (var i = 0; i < returnData.affectedStudentGradeBucketSubjects.length; i++)
                        {
                            var bucket = returnData.affectedStudentGradeBucketSubjects[i];
                            updateGradeBucketSubjectValue(isUndo, bucket, gradebook);
                        }
                    }

                    for (var j = 0; j < returnData.createdStudentAssignments.length; j++)
                    {
                        var studentAssignment = returnData.createdStudentAssignments[j];
                        var assignmentId = getDriverAssignmentID(studentAssignment.assignmentId);

                        if (assignmentId != null)
                        {
                            studentAssignment.assignmentId = assignmentId;
                            updateStudentAssignmentId(studentAssignment.studentSectionId, studentAssignment.assignmentId, studentAssignment.studentAssignmentId);
                        }
                    }

                    for (var k = 0; k < returnData.affectedStudentAssignments.length; k++)
                    {
                        var affectedStudentAssignment = returnData.affectedStudentAssignments[k];
                        var assignmentId = getDriverAssignmentID(affectedStudentAssignment.assignmentId);

                        if (assignmentId != null)
                        {
                            affectedStudentAssignment.assignmentId = assignmentId;
                            updatePassedStudentAssignmentDisplay(affectedStudentAssignment, gradebook, isUndo);
                        }
                    }

                    updateIsMissingCount(returnData.assignmentCounts);
                    updateAttemptCount(returnData.affectedStudentAssignments, returnData.createdStudentAssignments, isUndo, manager);
                }

                performUpdateAverageValues(returnData, gradebook);
            };

            manager.updateAverageValues = function (returnData, gradebook)
            {
                performUpdateAverageValues(returnData, gradebook);
            };

            var performUpdateAverageValues = function (returnData, gradebook)
            {
                var hasAveragesDisplay = $('#' + BROWSE_NAME + '_body').hasClass("hasAveragesDisplay");
                if (hasAveragesDisplay)
                {
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/GetUpdatedAverages",
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            affectedStudentAssignments: JSON.stringify(returnData.affectedStudentAssignments),
                            affectedStudentGradeBuckets: JSON.stringify(returnData.affectedStudentGradeBuckets),
                            affectedStudentGradeBucketAcademicStandards: JSON.stringify(returnData.affectedStudentGradeBucketAcademicStandards),
                            affectedStudentGradeBucketSubjects: JSON.stringify(returnData.affectedStudentGradeBucketSubjects)
                        },
                        success: function (averageReturnData)
                        {
                            if (averageReturnData.assignmentAverages)
                            {
                                updateAssignmentAverages(averageReturnData.assignmentAverages);
                            }

                            if (averageReturnData.gradingPeriodGradeBucketAverages)
                            {
                                updateGradingPeriodGradeBucketAverages(averageReturnData.gradingPeriodGradeBucketAverages);
                            }

                            if (averageReturnData.studentGradeBucketSubjectAverages)
                            {
                                updateStudentGradeBucketChildRecordAverages(averageReturnData.studentGradeBucketSubjectAverages, "subjectGradeBucket");
                            }

                            if (averageReturnData.studentGradeBucketAcademicStandardAverages)
                            {
                                updateStudentGradeBucketChildRecordAverages(averageReturnData.studentGradeBucketAcademicStandardAverages, "academicStandardGradeBucket");
                            }
                        }
                    });
                }
                gradebook.resize();
            };

            manager.getChangedValues = function (saveObjects)
            {
                if (!Array.isArray(saveObjects))
                {
                    saveObjects = [saveObjects];
                }

                var data = [];
                for (var i = 0; i < saveObjects.length; i++)
                {
                    var affectedData = saveObjects[i];
                    if (affectedData != null)
                    {
                        if (affectedData.isStudentGradeBucket)
                        {
                            $(".gradeBucketCell[data-student-grade-bucket-id='" + affectedData.studentGradeBucketID + "']").each(function ()
                            {
                                var input = $(this);
                                data.push(getStudentGradeBucketChangedValues(affectedData, input, affectedData.studentGradeBucketID));
                            });
                        }
                        else if (affectedData.isStudentGradeBucketSubject)
                        {
                            if (affectedData.type && affectedData.type == "mastery")
                            {
                                data.push(getMasteryStudentGradeBucketSubjectChangedValues(affectedData));
                            }
                            else
                            {
                                data.push(getStudentGradeBucketSubjectChangedValues(affectedData));
                            }
                        }
                        else if (affectedData.isStudentGradeBucketAcademicStandard)
                        {
                            if (affectedData.type && affectedData.type == "mastery")
                            {
                                data.push(getMasteryStudentGradeBucketAcademicStandardChangedValues(affectedData));
                            }
                            else
                            {
                                data.push(getStudentGradeBucketAcademicStandardChangedValues(affectedData));
                            }
                        }
                        else
                        {
                            data.push(getAssignmentChangedValues(affectedData));
                        }
                    }
                }

                return data.filter(function (saveData)
                {
                    return saveData.hasChanges;
                });
            };

            manager.setValues = function (objectsToChange, isUndo)
            {
                var valid = true;

                if (!Array.isArray(objectsToChange))
                {
                    objectsToChange = [objectsToChange];
                }

                for (var i = 0; i < objectsToChange.length; i++)
                {
                    var objectType = objectsToChange[i].saveObject;
                    if (!objectType || objectType === "StudentAssignment")
                    {
                        valid &= setAssignmentValues(objectsToChange[i], isUndo);
                    }
                    else if (objectType === "StudentGradeBucket")
                    {
                        valid &= setStudentGradeBucketValues(objectsToChange[i], isUndo);
                    }
                    else if (objectType === "StudentGradeBucketSubject")
                    {
                        valid &= setStudentGradeBucketSubjectValues(objectsToChange[i], isUndo);
                    }
                    else if (objectType === "StudentGradeBucketAcademicStandard")
                    {
                        valid &= setStudentGradeBucketAcademicStandardValues(objectsToChange[i], isUndo);
                    }
                }

                return valid;
            };

            return manager;
        };

        var applyGradeColors = function (type, gradeMarkID, percent, cell, colorData)
        {
            //var colorData = gradebook.unlockedBody.data().grademarkcolordata;
            var colorToApply = null;
            $.each(colorData, function ()
            {
                var color = $(this)[0];

                var isForType = false;
                switch (type)
                {
                    case "assignment":
                        isForType = color.ApplyToAssignments;
                        break;
                    case "standard":
                        isForType = color.ApplyToAcademicStandardGrades;
                        break;
                    case "subject":
                        isForType = color.ApplyToSubjectGrades;
                        break;
                    case "class":
                        isForType = color.ApplyToClassGrades;
                        break;
                }

                if (isForType)
                {
                    if (color.RangeTypeCode == "GM")
                    {
                        if (gradeMarkID != null && $.inArray(gradeMarkID, color.GradeMarkIDs) > -1)
                        {
                            colorToApply = color.Color;
                            return;
                        }
                    }
                    else
                    {
                        if ((color.PercentHigh == null || color.PercentHigh >= percent) && (color.PercentLow == null || color.PercentLow <= percent))
                        {
                            colorToApply = color.Color;
                            return;
                        }
                    }
                }

            });

            if (colorToApply != null)
            {
                cell.css('box-shadow', '0px 0px 0px 2px ' + colorToApply + ' inset');
            }
            else
            {
                cell.css("box-shadow", 'inherit');
            }
        };

        skyward.gradebook.redirectToSpecificGradeBucketSubject = function ()
        {
            var data = $(this).data();
            var accessmode = $("#accessmode").val();
            var breakdownPage = "GradeBucketSubjectBreakdown";
            redirectToGradeBucketBreakdown(data, accessmode, breakdownPage, data.studentGradeBucketSubjectId);
        };

        skyward.gradebook.redirectToSpecificGradeBucketAcademicStandard = function ()
        {
            var data = $(this).data();
            var accessmode = $("#accessmode").val();
            var breakdownPage = "GradeBucketAcademicStandardBreakdown";
            redirectToGradeBucketBreakdown(data, accessmode, breakdownPage, data.studentGradeBucketAcademicStandardId);
        };

        skyward.gradebook.redirectToSpecificGradeBucket = function ()
        {
            var data = $(this).data();
            var accessmode = $("#accessmode").val();
            var breakdownPage = "GradeBucketBreakdown";
            redirectToGradeBucketBreakdown(data, accessmode, breakdownPage, data.studentGradeBucketId);
        };

        redirectToGradeBucketBreakdown = function (data, accessmode, breakdownScreen, id)
        {
            var module = "Gradebook";
            var object = "ProgressReport";
            var screen = "";

            if (data.isStudentInformationPopup.toLowerCase() === "true")
            {
                screen = breakdownScreen + "StudentInformationPopup" + data.currentPortal;
            }
            else if (accessmode == "StudentAccess" || accessmode == "FamilyAccess" || accessmode == "Grading")
            {
                module = "Grading";
                object = "StudentSection";
                screen = "ProgressReport" + accessmode;
            }
            else
            {
                screen = data.isTeacherTracker.toLowerCase() === "true"
                    ? breakdownScreen + "TeacherTracker"
                    : breakdownScreen;
            }

            skyward.window.loadContent("popout", module, object, screen, id, data);
        };

        skyward.gradebook.redirectToAssignment = function ()
        {
            var button = $(this);
            button.off("click", skyward.gradebook.redirectToAssignment);
            var data = button.data();

            if (!data || !data.assignmentid || (button.hasClass('isTeacherTracker') && !data.sectionid))
            {
                return;
            }
            var classGroupID = data.classGroupId;
            if (classGroupID == null)
            {
                var gradebookbrowse = $("#Gradebook");
                var gradebookbrowseData = gradebookbrowse.data();
                if (gradebookbrowseData)
                {
                    classGroupID = gradebookbrowseData.classGroupId;
                }
            }

            var screen = button.hasClass('isTeacherTracker') ? "DetailsTeacherTracker" : classGroupID != null ? "ClassGroupDetails" : "Details";

            if (!data.tab)
            {
                button.data('tab', 'tabScoreEntry');
            }

            if (button.hasClass('assignmentRedirectButton'))
            {
                var assignmentNavigationDirect = "previous";
                if (button.attr('id') == "nextAssignment" || button.attr('id') == "editAssignment_nextAssignment")
                {
                    assignmentNavigationDirect = "next";
                }
                skyward.window.loadContent("full", "Gradebook", "Gradebook", button.hasClass('isTeacherTracker')
                    ? "AssignmentNavigationTeacherTracker"
                    : "AssignmentNavigation",
                    null,
                    {
                        assignmentNavigate: assignmentNavigationDirect,
                        assignmentID: data.assignmentid,
                        tab: data.tab,
                        screen: screen,
                        sectionID: data.sectionid,
                        classGroupID: classGroupID
                    });
            }
            else if (button.hasClass('assignmentRestoreButton'))
            {
                skyward.window.loadContent("full", "Gradebook", "Assignment", "RestoreAssignment", data.assignmentid);
            }
            else
            {
                skyward.window.loadContent("full", "Gradebook", "Assignment", screen, data.assignmentid, data);
            }
        };

        skyward.gradebook.deleteSectionGradingScaleGroup = function (sectionID, configID)
        {
            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/Section/SectionGradingScaleGroupDelete/" + sectionID,
                type: "POST",
                dataType: "JSON",
                success: function (data)
                {
                    if (data.success)
                    {
                        skyward.window.loadContent("full", "Gradebook", "ConfigEntityGroupYear", "Details", configID, data);
                    }
                    else
                    {
                        $(".error-list").html("<li class='error-list'>" + data.errors + "</li>");
                    }
                }
            });
        };

        var updateIsMissingCount = function (assignmentCounts)
        {
            for (var key in assignmentCounts)
            {
                if (!assignmentCounts.hasOwnProperty(key))
                {
                    continue;
                }

                var missingAssignmentSelector = '.missingAssignmentCountDiv[data-student-section-id="' + key + '"]';
                var unscoredPastDueAssignmentSelector = '.unscoredPastDueAssignmentCountDiv[data-student-section-id="' + key + '"]';

                var missingAssignmentAnchor = $(missingAssignmentSelector).find('a');
                var missingAssignmentTextSpan = missingAssignmentAnchor.find('.anchorText');
                var unscoredPastDueAssignmentAnchor = $(unscoredPastDueAssignmentSelector).find('a');
                var unscoredPastDueAssignmentTextSpan = unscoredPastDueAssignmentAnchor.find('.anchorText');

                var counts = assignmentCounts[key];
                var missingAssignmentCount = counts.missingAssignmentCount;
                var unscoredPastDueAssignmentCount = counts.unscoredPastDueAssignmentCount;

                missingAssignmentTextSpan.html(missingAssignmentCount);
                unscoredPastDueAssignmentTextSpan.html(unscoredPastDueAssignmentCount);

                if (missingAssignmentCount == 0)
                {
                    missingAssignmentAnchor.addClass('hidden');
                }
                else
                {
                    missingAssignmentAnchor.removeClass('hidden');
                }
                if (unscoredPastDueAssignmentCount == 0)
                {
                    unscoredPastDueAssignmentAnchor.addClass('hidden');
                }
                else
                {
                    unscoredPastDueAssignmentAnchor.removeClass('hidden');
                }
            }
        };

        var updateAttemptCount = function (affectedStudentAssignments, createdStudentAssignments, isUndo, manager)
        {
            for (var i = 0; i < affectedStudentAssignments.length; i++)
            {
                performUpdateAttemptCount(affectedStudentAssignments[i]);
            }

            for (var i = 0; i < createdStudentAssignments.length; i++)
            {
                performUpdateAttemptCount(createdStudentAssignments[i]);
            }

            function performUpdateAttemptCount(studentAssignment)
            {
                var attemptCountAnchor = $('.attemptCount[data-studentsectionid="' + studentAssignment.studentSectionId + '"][data-assignmentid="' + studentAssignment.assignmentId + '"]');
                var attemptCountTextSpan = attemptCountAnchor.find('.anchorText');

                if (attemptCountTextSpan.length > 0 && attemptCountTextSpan[0].innerText != studentAssignment.attemptCount)
                {
                    var parentCell = attemptCountAnchor.parents('td.gradesheetAttemptsColumn.assignmentCell');
                    manager.updateChangedClass(parentCell, isUndo, studentAssignment);
                }

                attemptCountTextSpan.html(studentAssignment.attemptCount);

                if (studentAssignment.attemptCount == 0)
                {
                    attemptCountAnchor.addClass('hidden');
                }
                else
                {
                    attemptCountAnchor.removeClass('hidden');
                }
            }
        };

        var completedGradingPeriod = function (event)
        {
            var element = $(this);
            var message = "Grade changes have been marked completed.";
            var options =
            {
                anchorTo: element,
                id: "CompletedGradingPeriodPopup"
            };

            skyward.modalLayer.showInformationDialog('Completed Grading Period', message, null, options);

            event.stopPropagation();
        };

        var unscoredPastDueAssignments = function (event)
        {
            var element = $(this);
            var data = element.data();
            var message = data.message;
            var options =
            {
                anchorTo: element,
                id: "UnscoredPastDueAssignments"
            };

            skyward.modalLayer.showInformationDialog('Unscored Past Due Assignments', message, null, options);

            event.stopPropagation();
        };

        var roundedAdjustedWeightFormula = function (event)
        {
            var button = $(this);
            var options =
            {
                anchorTo: button
            };

            var popupContent = "";

            if (button.data())
            {
                if (button.data("roundbucketpercentforcalculation"))
                {
                    popupContent += '<span class="help" >The percentage used in the adjusted weight formula has been rounded.</span>';
                }
                if (button.data("capweightedcategoriesat100percent"))
                {
                    popupContent += '<span class="help" >The percent earned used in the adjusted weight formula has been capped at 100%.</span>';
                }
            }

            skyward.modalLayer.showInformationDialog('About This Calculation', popupContent, null, options);

            event.stopPropagation();
        };

        var studentGradeBucketIsAdminOverride = function (event)
        {
            var button = $(this);
            var studentGradeBucketID = button.data("studentGradeBucketId") != null ? button.data("studentGradeBucketId") : button.parents('.gradeBucketCell').data('studentGradeBucketId');
            var studentGradeBucketIDHash = button.data("studentGradeBucketIdHash");
            var sectionID = button.data("sectionId") != null ? button.data("sectionId") : $('#Gradebook').data('sectionid');
            var isAdminOverride = button.data("isAdminOverride");
            var hasGradeChangeRequests = button.data("hasGradeChangeRequests");
            var lockedForClassRank = button.data("lockedForClassRank");
            var classRankMessage = button.data("classRankMessage");
            var hasUnscoredRequiredFeederBucket = button.data("hasUnscoredRequiredFeederBucket");
            var isTransferBucket = button.data("isTransferBucket");
            var gradeChangeRequestExists = button.data("gradeChangeRequestExists");
            var portal = button.data("currentPortal");

            event.stopPropagation();
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/Gradebook/IsAdminOverridePopup" + portal,
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data:
                {
                    studentGradeBucketID: studentGradeBucketID,
                    studentGradeBucketIDHash: studentGradeBucketIDHash,
                    sectionID: sectionID,
                    isAdminOverride: isAdminOverride,
                    lockedForClassRank: lockedForClassRank,
                    classRankMessage: classRankMessage,
                    hasUnscoredRequiredFeederBucket: hasUnscoredRequiredFeederBucket,
                    hasGradeChangeRequests: hasGradeChangeRequests,
                    gradeChangeRequestExists: gradeChangeRequestExists,
                    isTransferBucket: isTransferBucket
                },
                success: function (returnData)
                {
                    if (returnData.success == false && returnData.popupHTML)
                    {
                        checkAjaxResponseForErrors(returnData);
                    }
                    else
                    {
                        var options =
                        {
                            anchorTo: button
                        };
                        skyward.modalLayer.showInformationDialog("Student Grade Information", returnData.htmlValue.Content, null, options);
                    }
                }
            });
        };

        var studentGradeBucketHasTransferGrade = function (event)
        {
            var button = $(this);
            var studentGradeBucketID = button.data("studentGradeBucketId") != null ? button.data("studentGradeBucketId") : button.parents('.gradeBucketCell').data('studentGradeBucketId');
            var studentGradeBucketIDHash = button.data("studentGradeBucketIdHash");
            var sectionID = button.data("sectionId") != null ? button.data("sectionId") : $('#Gradebook').data('sectionid');
            var isTransferBucket = button.data("isTransferBucket");
            var portal = button.data("currentPortal");

            event.stopPropagation();
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/Gradebook/HasTransferGradePopup" + portal,
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data:
                {
                    studentGradeBucketID: studentGradeBucketID,
                    studentGradeBucketIDHash: studentGradeBucketIDHash,
                    sectionID: sectionID,
                    isTransferBucket: isTransferBucket
                },
                success: function (returnData)
                {
                    if (returnData.success == false && returnData.popupHTML)
                    {
                        checkAjaxResponseForErrors(returnData);
                    }
                    else
                    {
                        var options =
                        {
                            anchorTo: button
                        };
                        skyward.modalLayer.showInformationDialog("Student Grade Information", returnData.htmlValue.Content, null, options);
                    }
                }
            });
        };

        var gradingPeriodUnlocked = function (event)
        {
            var element = $(this);
            var data = element.data();
            var message = "<div class='gradebookInformationPopup'><div>This Grading Period has been unlocked for grade changes.</div>";
            var title = 'Unlocked Grading Period';
            var options =
            {
                anchorTo: element,
                id: 'UnlockedGradingPeriodPopup'
            };

            if (data.useSnapshotGrade.toLowerCase() == "true" && data.snapshotGradeExtendedEndDate)
            {
                message += "<div class='sectionHeader'><h3 class='sectionHeader__text'>Snapshot Grade Information</h3></div>"
                    + "<div>" + data.gradeBucketLabel + " has a <span class='boldFont'>snapshot</span> grade</div> "
                    + "<div> Snapshot grade for " + data.gradeBucketLabel + (data.isPastTense ? " was" : " will be") + " taken on " + data.snapshotGradeExtendedEndDate + "</div>";
            }
            message += "</div>";

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var showTermAdjustmentInfo = function ()
        {
            var button = $(this);

            var action = $("#" + BROWSE_NAME).data().isTeacherTracker.toString().toLowerCase() == "true" ? "TermAdjustedStudentPopupTeacherTracker" : "TermAdjustedStudentPopup";
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data: button.data(),
                success: function (returnData)
                {
                    if (returnData.success == false && returnData.popupHTML)
                    {
                        checkAjaxResponseForErrors(returnData);
                    }
                    else
                    {
                        var options =
                        {
                            anchorTo: button
                        };
                        skyward.modalLayer.showInformationDialog("Student Enrollment Dates", returnData.htmlValue.Content, null, options);
                    }
                }
            });
        };

        var getAverageDiv = function (avgPercent, avgPoints, usePoints)
        {
            if (usePoints.toString() == true.toString())
            {
                return "<div>Avg:</div>" +
                    "<div class='gradebookAverageScoreDiv'><span class='boldFont'>" + avgPoints.toFixed(2) + " pts</span></div>";
            }
            else if (avgPercent != null && avgPercent != "")
            {
                return "<div>Avg:</div>" +
                    "<div class='gradebookAverageScoreDiv'><span class='boldFont'>" + avgPercent + "%</span></div>";
            }
            else
            {
                return "<div class='gradebookAverageScoreDiv'>Avg: <span class='boldFont'></span></div>";
            }
        };

        var updateGradingPeriodGradeBucketAverages = function (gradingPeriodGradeBucketAverages)
        {
            $.each(gradingPeriodGradeBucketAverages, function (key, value)
            {
                var displayMessage = getAverageDiv(value.AveragePercent, value.AveragePoints, value.UsePoints);

                var className = "gradingPeriodGradeBucket" + key + "AverageHeaderCell";
                $("." + className).each(function ()
                {
                    var div = $(this).find("div").get(0);
                    if (div)
                    {
                        div.innerHTML = displayMessage;
                    }
                });
            });
        };

        var updateStudentGradeBucketChildRecordAverages = function (studentGradeBucketChildRecordAverages, objectType)
        {
            $.each(studentGradeBucketChildRecordAverages, function (gpgbID, innerDictionary)
            {
                $.each(innerDictionary, function (key, value)
                {
                    var displayMessage = getAverageDiv(value.AveragePercent, value.AveragePoints, value.UsePoints);

                    var className = objectType + gpgbID + "-" + key + "AverageHeaderCell";
                    $("." + className).each(function ()
                    {
                        var div = $(this).find("div").get(0);
                        if (div)
                        {
                            div.innerHTML = displayMessage;
                        }
                    });
                });
            });
        };

        var updateAssignmentAverages = function (assignmentAverages)
        {
            $.each(assignmentAverages, function (key, value)
            {
                var percentOrPoints = "";
                if (value.UsePoints.toString() == true.toString())
                {
                    var averagePoints = value.AveragePoints ? value.AveragePoints.toFixed(2) + " pts" : "";
                    percentOrPoints = "<div>Avg: <span class='boldFont'>" + averagePoints + "</span></div>";
                }
                else if (value.AveragePercent != null && value.AveragePercent != "")
                {
                    percentOrPoints = "<div>Avg: <span class='boldFont'>" + value.AveragePercent + "%</span></div>";
                }
                else
                {
                    percentOrPoints = "<div>Avg: <span class='boldFont'></span></div>";
                }

                var displayMessage = percentOrPoints + "<div class='gradebookAverageScoreDiv'>Avg Score: <span class='boldFont'>" + value.AverageScore + "</span></div>";
                var className = "assignment" + key + "AverageHeaderCell";
                var div = $("." + className).find("div").get(0);
                if (div)
                {
                    div.innerHTML = displayMessage;
                }
            });
        };


        var studentGradeBucketIndicatorPopup = function (event)
        {
            getIndicatorPopup(event, $(this), "GetStudentGradeBucketIndicators");
        };

        var studentGradeBucketSubjectIndicatorPopup = function (event)
        {
            getIndicatorPopup(event, $(this), "GetStudentGradeBucketSubjectIndicators");
        };

        var studentGradeBucketAcademicStandardIndicatorPopup = function (event)
        {
            getIndicatorPopup(event, $(this), "GetStudentGradeBucketAcademicStandardIndicators");
        };

        var assignmentHeaderIndicatorsPopup = function (event)
        {
            getIndicatorPopup(event, $(this), "GetAssignmentHeaderIndicators", "Assignment Information", false)
        };

        var getIndicatorPopup = function (event, button, actionPrefix, popupHeader, needAnchor)
        {
            if (button.find("a:visible").length < 1 && needAnchor !== false)
            {
                return;
            }

            event.stopPropagation();

            var cell = button.closest('td');

            var localGradebookBrowse = $('#' + BROWSE_NAME);
            var localGradebookData = localGradebookBrowse.data();

            var data = cell.data();
            data.classGroupID = localGradebookData.classGroupId;

            var studentGroupData = {};
            var studentGroupIndicators = cell.find('.studentGroupColorStrip');
            if (studentGroupIndicators.length > 0) {
                studentGroupIndicators.each(function () {
                    var indicatorData = $(this).data();
                    studentGroupData[indicatorData.name] = indicatorData.color;
                })
            }
            data.studentGroupData = JSON.stringify(studentGroupData);

            var action = localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? actionPrefix + "TeacherTracker" : actionPrefix;

            buildIndicatorPopup(data, action, button, popupHeader);
        };

        var buildIndicatorPopup = function (data, action, anchorTo, popupHeader)
        {
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data: data,
                success: function (returnData)
                {
                    if (returnData.success == false && returnData.popupHTML)
                    {
                        checkAjaxResponseForErrors(returnData);
                    }
                    else
                    {
                        var buttons = [];
                        var closeButton = { id: "closeStudentGradeBucketIndicatorPopup", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
                        if (returnData.requiresSave)
                        {
                            buttons.push({
                                id: "saveStudentGradeBucketIndicatorPopup", text: "Save", click: function ()
                                {
                                    var hideTransferRunIndicator = skyward.controls.getValue(dialog.content.find(".hideTransferGradeRunCheckbox"));
                                    $.ajax({
                                        url: skyward.global.virtualDir + "Gradebook/Gradebook/SaveStudentGradeBucketIndicators",
                                        type: "POST",
                                        dataType: "JSON",
                                        data:
                                        {
                                            StudentGradeBucketID: data.studentGradeBucketId,
                                            HideTransferIndicator: hideTransferRunIndicator
                                        },
                                        success: function (saveReturnData)
                                        {
                                            if (saveReturnData.success == false && saveReturnData.popupHTML)
                                            {
                                                checkAjaxResponseForErrors(saveReturnData);
                                            }
                                            else if (hideTransferRunIndicator)
                                            {
                                                anchorTo.addClass("hiddenTransferGradeRun");
                                            }
                                            else
                                            {
                                                anchorTo.removeClass("hiddenTransferGradeRun");
                                            }
                                        }
                                    });
                                    dialog.close();
                                }, icon: "Save"
                            });
                            closeButton.text = "Cancel";
                            closeButton.icon = "Cancel";
                        }
                        buttons.push(closeButton);

                        var dialog = skyward.modalLayer.showDialog(popupHeader != null ? popupHeader : 'Student Grade Information', returnData.html, buttons, { anchorTo: anchorTo });
                    }
                }
            });
        };

        $('body').on('WorkflowCompleted.Gradebook.StudentSectionNote.Add', function ()
        {
            var gradebook = $('#Gradebook');

            if (gradebook.length == 0)
            {
                return;
            }

            var gradebookData = gradebook.data();
            var sectionID = gradebookData.sectionid;

            $.ajax({
                url: skyward.global.virtualDir + "Gradebook/StudentSectionNote/GetStudentSectionsThatHaveNotes",
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data: gradebookData,
                success: function (data)
                {
                    for (var i = 0; i < data.studentSectionIDs.length; i++)
                    {
                        var studentSectionID = data.studentSectionIDs[i];
                        var noteButtonSelector = '.studentSectionNoteButton[data-student-section-id="' + studentSectionID + '"]';
                        var noteButton = $(noteButtonSelector);
                        noteButton.removeClass('displayNone');
                        noteButton.parent().addClass('buttonsVisible');
                    }
                }
            });
        });

        var initProgressReportSelector = function (selector)
        {
            $(selector).find('#ProgressReportStudentSelector').on('change', function ()
            {
                var eel = $(this);
                var isTeacherTracker = eel.data().isTeacherTracker;
                var id = skyward.controls.getValue(eel);
                skyward.window.checkLoadContent('full', 'Gradebook', 'ProgressReport', isTeacherTracker.toString().toLowerCase() == "true" ? 'TeacherTrackerDetails' : 'Details', id);
            });
        };

        var showGradebookLoadTimes = function ()
        {
            var message = "";
            var browseStats = gradebookLoadTimes;

            if (browseStats == null)
            {
                message = "No browse load times available.";
            }
            else
            {
                var gradebookStatsLabels = Object.keys(browseStats);
                for (var i = 0; i < gradebookStatsLabels.length; i++)
                {
                    var label = gradebookStatsLabels[i];
                    message += label + ": " + gradebookLoadTimes[label] + "ms <br/>";
                }
            }
            skyward.modalLayer.showDialog("Gradebook Load Times", message, [{ text: "OK", "icon": "Check" }]);
        };

        skyward.gradebook.viewStudentSchedule = function (module, object, action)
        {
            var button = $(this);
            var data = button.data();

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + module + '/' + object + '/' + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true },
                    data: data
                });
            };

            var resizeStudentSchedulePopup = function (dialog)
            {
                dialog.animateModalContents();
            };

            var options =
            {
                draggable: true,
                closeOnClick: false,
                closeOnEscape: false
            };
            var title = data.studentName ? data.studentName + " - Schedule With Grades" : "Student Schedule With Grades";
            var dialog = skyward.modalLayer.showInformationDialog(title, buildPopup, [{ text: "Ok", icon: "Check" }], options);
            $(dialog).find('.browseBody').on("browseLoaded", function ()
            {
                resizeStudentSchedulePopup(dialog);
            });

            return dialog;
        };

        var viewStudentSchedule = function ()
        {
            var gradebookbrowse = $("#Gradebook");
            var gradebookbrowseData = gradebookbrowse.data();
            var screen = gradebookbrowseData.isTeacherTracker.toString().toLowerCase() == "true" ? "StudentScheduleWithGradesTeacherTracker" : "StudentScheduleWithGrades";
            skyward.gradebook.viewStudentSchedule.bind(this, "Gradebook", "Gradebook", screen)();
        };

        var copyMatchingTransferAssignments = function ()
        {
            var destinationBrowse = $(this).parents(".transferGradeSplitBrowse").find(".transferAssignmentDestinationBrowse");
            var destinationBrowseData = destinationBrowse.data();
            var postData =
            {
                sourceStudentSectionID: destinationBrowseData.sourceStudentSectionId,
                studentSectionID: destinationBrowseData.studentSectionId
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/Assignment/CopyMatchingTransferAssignments" + destinationBrowseData.portal,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        if (!data.matchingScores || $.isEmptyObject(data.matchingScores))
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Assignments", "<span>There were no valid matching assignments found to copy from.</span>");
                            return;
                        }

                        $.each(data.matchingScores, function (key, value)
                        {
                            var assignmentScoreElement = $("#" + key);

                            if (assignmentScoreElement.length)
                            {
                                var originalValue = skyward.controls.getValue(assignmentScoreElement);

                                if (typeof (originalValue) == "boolean")
                                {
                                    value = (value === true || value === "true" || value === "True");
                                }

                                if (originalValue != value)
                                {
                                    flashUpdateCell(assignmentScoreElement.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                                }
                                skyward.controls.setValue(assignmentScoreElement, value);
                            }
                        });
                    }
                });
        };

        var clearTransferValues = function ()
        {
            var button = $(this);
            var destinationBrowse = button.parents(".transferGradeSplitBrowse").find(".transferDestinationBrowse");

            destinationBrowse.find("input.clearable, .codeEEL.clearable, .eELInputContainer.clearable > input").each(function ()
            {
                var input = $(this);
                var value = skyward.controls.getValue(input);
                skyward.controls.clearValue(input);

                if (value != null && value != "" && value != false)
                {
                    flashUpdateCell(input.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                }
            });
        };

        var flashUpdateCell = function (cell, flashUpdateCellColor, flashUpdateCellDuration)
        {
            if (cell.is(':animated')) {
                return;
            }

            var oldColor = cell.css("background-color");
            cell.css("background-color", flashUpdateCellColor);
            cell.animate({ backgroundColor: oldColor }, { duration: flashUpdateCellDuration });
        };

        var copyMatchingTransferClosedBuckets = function ()
        {
            var destinationBrowse = $(this).parents(".transferGradeSplitBrowse").find(".transferClosedBucketDestinationBrowse");
            var destinationBrowseData = destinationBrowse.data();

            if (destinationBrowseData.sourceClassOod && destinationBrowseData.sourceClassOod.toString().toLowerCase() === "true")
            {
                return copyMatchingOutOfDistrictTransferClosedBuckets.apply($(this));
            }

            var postData =
            {
                sourceStudentSectionID: destinationBrowseData.sourceStudentSectionId,
                studentSectionID: destinationBrowseData.studentSectionId
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/Assignment/CopyMatchingTransferClosedBuckets" + destinationBrowseData.portal,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        if (!data.matchingValues || $.isEmptyObject(data.matchingValues))
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Closed Terms", "<span>There were no valid matching closed terms found to copy from.</span>");
                            return;
                        }

                        var updateCounts = 0;
                        $.each(data.matchingValues, function (key, value)
                        {
                            var closedBucketValueElement = destinationBrowse.find("td input[data-grade-bucket-id='" + key + "']");
                            if (!closedBucketValueElement.length)
                            {
                                closedBucketValueElement = destinationBrowse.find("td input[data-grade-bucket-label='" + value.GradeBucketLabel + "']");
                            }

                            if (closedBucketValueElement.length)
                            {
                                var currentValue = skyward.controls.getValue(closedBucketValueElement);

                                skyward.controls.setValue(closedBucketValueElement, value.PercentWithAdjustment);
                                if (currentValue != value.PercentWithAdjustment)
                                {
                                    flashUpdateCell(closedBucketValueElement.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                                }
                                updateCounts++;
                            }
                        });

                        if (updateCounts < 1)
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Closed Terms", "<span>There were no valid matching closed terms found to copy from.</span>");
                        }
                    }
                });
        };

        var copyMatchingTransferSubjectStandards = function ()
        {
            var destinationBrowse = $(this).parents(".transferGradeSplitBrowse").find(".transferSubjectStandardDestinationBrowse");
            var destinationBrowseData = destinationBrowse.data();

            var postData =
            {
                sourceStudentSectionID: destinationBrowseData.sourceStudentSectionId,
                studentSectionID: destinationBrowseData.studentSectionId,
                gradingPeriodGradeBucketIDs: JSON.stringify(destinationBrowseData.gradingPeriodGradeBucketIds)
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/Assignment/CopyMatchingTransferSubjectStandards" + destinationBrowseData.portal,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data) {
                        if (!data.matchingValues || $.isEmptyObject(data.matchingValues)) {
                            skyward.modalLayer.showInformationDialog("No Matching Grades", "<span>There were no valid matching subject / academic standards found to copy from.</span>");
                            return;
                        }

                        var updateCounts = 0;
                        $.each(data.matchingValues, function (key, value) {
                            var gradeBucketLabel = key;

                            if (value && value != null)
                            {
                                $.each(value, function (typeCode, innerValue)
                                {
                                    $.each(innerValue, function (curriculumElementForeignKey, curriculumElementValue)
                                    {
                                        var newGradingScaleGroupGradeMarkID = curriculumElementValue.Item1;

                                        var masteryElement = destinationBrowse.find("td input:checkbox[data-grade-bucket-label='" + gradeBucketLabel + "'][data-calculation-group-curriculum-element-foreign-key-id='" + curriculumElementForeignKey + "'][data-calculation-group-curriculum-element-type='" + typeCode + "']");
                                        if (masteryElement.length > 0)
                                        {
                                            var newValue = (newGradingScaleGroupGradeMarkID != null && newGradingScaleGroupGradeMarkID != "");

                                            if (newValue || newValue == "true") //If a standard was mastered in the destination but not source, we don't want to clear that out.
                                            {
                                                if (newValue != skyward.controls.getValue(masteryElement))
                                                {
                                                    flashUpdateCell(masteryElement.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                                                }
                                                skyward.controls.setValue(masteryElement, newValue);
                                                updateCounts++;
                                            }
                                        }
                                        else
                                        {
                                            var newGradingScaleGroupGradeMarkID = curriculumElementValue.Item1;
                                            var newGradeMarkCode = curriculumElementValue.Item2;

                                            var destinationElement = destinationBrowse.find("td div[data-grade-bucket-label='" + gradeBucketLabel + "'][data-calculation-group-curriculum-element-foreign-key-id='" + curriculumElementForeignKey + "'][data-calculation-group-curriculum-element-type='" + typeCode + "']");
                                            if (destinationElement.length)
                                            {
                                                var currentValue = skyward.controls.getValue(destinationElement);
                                                if (currentValue == '')
                                                {
                                                    currentValue = null;
                                                }
                                                if (newGradingScaleGroupGradeMarkID != currentValue)
                                                {
                                                    flashUpdateCell(destinationElement.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                                                }
                                                skyward.controls.setValue(destinationElement.find(".codeEELValue"), newGradingScaleGroupGradeMarkID, true);
                                                skyward.controls.setValue(destinationElement.find(".codeEELCode"), newGradeMarkCode, true);
                                                updateCounts++;
                                            }
                                        }
                                    });
                                });
                            }
                        });

                        if (updateCounts < 1) {
                            skyward.modalLayer.showInformationDialog("No Matching Grades", "<span>There were no valid matching subject / academic standards found to copy from.</span>");
                        }
                    }
                });
        };

        var copyMatchingTransferClosedGradeCategories = function ()
        {
            var updateCount = 0;

            $(".destinationClosedBucketCategoriesTemplate").find(".browse").each(function ()
            {
                var browse = $(this);
                var browseData = browse.data();

                browse.find("input.number").each(function ()
                {
                    var destinationCategory = $(this);
                    var destinationCategoryID = destinationCategory.attr("id").split("-")[2];

                    var sourceBucketBrowse = $(".sourceClosedBucketCategoriesTemplate .browse[data-grade-bucket-id='" + browseData.gradeBucketId + "']");

                    if (sourceBucketBrowse.length > 0)
                    {
                        var sourceCategory = sourceBucketBrowse.find("td[data-categoryid='" + destinationCategoryID + "']");

                        if (sourceCategory.length > 0)
                        {
                            var currentValue = skyward.controls.getValue(destinationCategory);
                            var newValue = sourceCategory.find("div").html();
                            if (currentValue != newValue)
                            {
                                flashUpdateCell(destinationCategory.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                            }
                            skyward.controls.setValue(destinationCategory, newValue);
                            updateCount++;
                        }
                    }
                });
            });

            if (updateCount == 0)
            {
                skyward.modalLayer.showInformationDialog("No Matching Categories", "<span>There were no valid matching categories found to copy from.</span>");
            }
        };

        var copyMatchingOutOfDistrictTransferClosedBuckets = function ()
        {
            var destinationBrowse = $(this).parents(".transferGradeSplitBrowse").find(".transferClosedBucketDestinationBrowse");
            var destinationBrowseData = destinationBrowse.data();

            var postData =
            {
                gradingPeriodGradeBucketID: destinationBrowseData.gradingPeriodGradeBucketId,
                sourceStudentSectionID: destinationBrowseData.sourceStudentSectionId,
                studentSectionID: destinationBrowseData.studentSectionId,
                isPartiallyEnrolled: destinationBrowseData.partiallyEnrolled
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/Assignment/CopyMatchingOutOfDistrictTransferClosedBuckets" + destinationBrowseData.portal,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        var matchingCount = 0;
                        if (!data.matchingValues || $.isEmptyObject(data.matchingValues))
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Grades", "<span>There were no valid matching grades found to copy from.</span>");
                            return;
                        }

                        $.each(data.matchingValues, function (key, value)
                        {
                            var closedBucketGradeMarkValueElement = destinationBrowse.find(".codeEEL[data-grade-bucket-id='" + key + "']");
                            var closedBucketPercentValueElement = destinationBrowse.find(".studentGradeBucketPercentScore[data-grade-bucket-id='" + key + "']");

                            if (closedBucketGradeMarkValueElement.length)
                            {
                                matchingCount++;
                                skyward.controls.setValue(closedBucketGradeMarkValueElement, value.Item1);
                                closedBucketGradeMarkValueElement.trigger('eelComplete');
                            }
                            if (closedBucketPercentValueElement.length)
                            {
                                matchingCount++;
                                skyward.controls.setValue(closedBucketPercentValueElement, value.Item2);
                            }
                        });

                        if (matchingCount == 0)
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Grades", "<span>There were no valid matching grades found to copy from.</span>");
                            return;
                        }
                    }
                });
        };

        var updatePercentFromGradeMarkDefaultPercent = function (element, basePercentName)
        {
            var codeEEL = element;
            var codeEELID = codeEEL.attr('id');
            var gradingPeriodGradeBucketID = codeEELID.split('-')[1];
            var percentField = $('#' + basePercentName + '-' + gradingPeriodGradeBucketID);

            var codeEELValue = codeEEL.find(".codeEELValue");
            var codeEELValueData = codeEELValue.data();
            var postData = { "securityHash": codeEELValueData.securityHash };

            return $.ajax(
                {
                    url: skyward.global.virtualDir + codeEELValueData.area + "/" + codeEELValueData.controller + "/codeeel/" + codeEELValue.val(),
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        codeEEL.data("additionalFields", data.additionalFields);

                        if (percentField)
                        {
                            var additionalFields = codeEEL.data('additionalFields');

                            if (additionalFields)
                            {
                                var defaultPercent = additionalFields['DefaultCalculationPercent'];
                                percentField.val(parseFloat(defaultPercent).toFixed(2));
                            }
                            else
                            {
                                skyward.controls.clearValue(percentField);
                            }
                        }
                    }
                });
        };

        var checkPopupSaveButton = function (htmlData, id)
        {
            var hasEditableInput = false;
            if (htmlData)
            {
                $(htmlData).find("input:enabled").each(function ()
                {
                    if ($(this).attr("type") != "hidden")
                    {
                        hasEditableInput = true;
                    }
                });

                if (!hasEditableInput)
                {
                    $("#" + id).addClass("hidden");
                }
            }
        };

        var getUnlockedRowFromCell = function (cell)
        {
            var row = cell.parents("tr").first();

            if (row.parents(".lockedBrowseBody").length > 0)
            {
                row = $("#" + BROWSE_NAME + "_unlockedRow" + row.data().row);
            }
            return row;
        };

        var progressReportSubHeaderPopup = function ()
        {
            var button = $(this);
            var data = button.data();

            var message = '<div>';
            if (data.adminOverrideMessage != "")
            {
                message += addMessageToContent(data.adminOverrideMessage);
            }
            if (data.snapshotGradeMessage != "")
            {
                message += addMessageToContent(data.snapshotGradeMessage);
            }
            if (data.roundedGradeMessage != "")
            {
                message += addMessageToContent(data.roundedGradeMessage);
            }
            if (data.capCalculationMessage != "")
            {
                message += addMessageToContent(data.capCalculationMessage);
            }
            if (data.gradebookLockMessage != "")
            {
                message += addMessageToContent(data.gradebookLockMessage);
            }
            if (data.recalculateGradebookMessage != "")
            {
                message += addMessageToContent(data.recalculateGradebookMessage);
            }
            if (data.grademarkOverrideMessage != "")
            {
                message += addMessageToContent(data.grademarkOverrideMessage);
                if (data.grademarkOverrideComment != "")
                {
                    message += addMessageToContent("Grade mark override comment: ", "progressReportInformationPopupFieldName");
                    message += addMessageToContent(data.grademarkOverrideComment, "");
                }
            }
            if (data.percentAdjustmentMessage != "")
            {
                message += addMessageToContent(data.percentAdjustmentMessage);
                message += addMessageToContent("Percent adjustment comment: ", "progressReportInformationPopupFieldName");
                message += addMessageToContent(data.percentAdjustmentComment, "");
            }
            if (data.gradeChangeDeniedMessage != "")
            {
                message += addMessageToContent(data.gradeChangeDeniedMessage);
            }
            if (data.subjectiveMessage != "")
            {
                message += addMessageToContent(data.subjectiveMessage);
            }
            if (data.notGradedMessage != "")
            {
                message += addMessageToContent(data.notGradedMessage);
            }
            if (data.minimumPercentMessage != "")
            {
                message += addMessageToContent(data.minimumPercentMessage);
            }
            if (data.innerBucketHasGradeChangeMessage && data.innerBucketHasGradeChangeMessage != "")
            {
                message += addMessageToContent(data.innerBucketHasGradeChangeMessage);
            }
            message += '</div>';

            var closeButton = { id: "closeProgressReportInformationPopup", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
            var options =
            {
                anchorTo: button
            };

            var dialog = skyward.modalLayer.showDialog("Student Grade Information", message, [closeButton], options);
        };

        var addMessageToContent = function (messageToAdd, otherClassName)
        {
            var className = typeof otherClassName === "undefined" ? "progressReportInformationPopupSpan" : otherClassName;
            return '<span class="' + className + '"><span>' + messageToAdd + '</span></span>';
        };

        var validateCopyAssignmentCheckbox = function ()
        {
            var input = $(this);
            var inputId = input.attr("id");
            var inputChecked = input.is(":checked");
            var browse = $("#SourceAssignments");
            var id = inputId.split("-")[1] || "";
            var checkboxes;

            switch (inputId.split(/[-_]/)[0])
            {
                case "CopyAssignment":
                    checkboxes = browse.find('[id^="SyncAssignment-' + id + '"]');
                    checkboxes.each(function ()
                    {
                        var checkbox = $(this);
                        skyward.controls.setValue(checkbox, inputChecked);
                    });
                    break;
                case "SyncAssignment":
                    if (inputChecked)
                    {
                        checkboxes = browse.find('[id^="CopyAssignment-' + id + '"]');
                        checkboxes.each(function ()
                        {
                            var checkbox = $(this);
                            skyward.controls.setValue(checkbox, true);
                        });
                    }
                    break;
            }
        };

        var updateClosedGradingPeriodGradeChange = function ()
        {
            var button = $(this);
            var data = button.data();
            var rowNumber = button.parents('.browseRow').find('.browseRowOptions').data('row');
            var postData =
            {
                id: data.id,
                reviewed: data.reviewed
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/ClosedGradingPeriodStudentGradeBucketChange/UpdateClosedGradingPeriodStudentGradeBucketChangeStatus",
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        if (data.Success)
                        {
                            var browseId = 'CGPGCClosedGradingPeriodStudentGradeBucketChanges';
                            var browse = skyward.browse.browseList[browseId];
                            if (browse)
                            {
                                skyward.browse.setCurrentRecord(browseId, rowNumber, { loadRelatedBrowses: false });
                                skyward.browse.setCurrentBrowseName(browseId);
                                skyward.browse.get(browseId, browse.data);
                            }

                            browseId = 'ClosedGradingPeriodStudentGradeBucketChanges';
                            browse = skyward.browse.browseList[browseId];
                            if (browse)
                            {
                                skyward.browse.setCurrentRecord(browseId, rowNumber, { loadRelatedBrowses: false });
                                skyward.browse.setCurrentBrowseName(browseId);
                                skyward.browse.get(browseId, browse.data);
                            }

                            browseId = 'detailsPanel_ClosedGradingPeriodStudentGradeBucketChanges';
                            browse = skyward.browse.browseList[browseId];
                            if (browse)
                            {
                                skyward.browse.setCurrentRecord(browseId, rowNumber, { loadRelatedBrowses: false });
                                skyward.browse.setCurrentBrowseName(browseId);
                                skyward.browse.get(browseId, browse.data);
                            }
                        }
                    }
                });
        };

        var getSectionIDFromCell = function (cell)
        {
            if (cell.parents(".studentAssignmentMobileCard").length > 0)
            {
                return cell.parents(".studentAssignmentMobileCard").data().sectionId;
            }
            var parent = cell.parents("tr").first();
            if (parent != null && parent.length > 0)
            {
                return parent.data().sectionId;
            }
            return null;
        };

        var getRepresentedAssignmentID = function (assignmentId, sectionId)
        {
            var headerCell = $("#assignment" + assignmentId + "HeaderCell");
            var headerCellData = headerCell.data();
            if (headerCellData && headerCellData.representedAssignmentIds && headerCellData.representedAssignmentIds[sectionId])
            {
                return headerCellData.representedAssignmentIds[sectionId];
            }

            return null;
        };

        var getDriverAssignmentID = function (assignmentId)
        {
            if (assignmentId == null)
            {
                return null;
            }

            var driveHeaderCell = $("#assignment" + assignmentId + "HeaderCell");

            if (driveHeaderCell.length == 0)
            {
                driveHeaderCell = $(".syncedAssignment" + assignmentId + "HeaderCell");
            }

            if (driveHeaderCell.length == 0)
            {
                return null;
            }
            return driveHeaderCell.data().assignmentid;
        };

        var resizeLockedBrowseBodyForHorizontalScrollBar = function ()
        {
            skyward.browse.resizeLockedBrowseBodyForHorizontalScrollBar(
                {
                    unlockedBody: $('#' + BROWSE_NAME + '_unlockedBody'),
                    lockedBody: $('#' + BROWSE_NAME + '_lockedBody'),
                });
        };

        var getClassSelectorFromAllClassesOnElement = function (element)
        {
            var classSelector = "";
            var classes = element.attr("class").split(' ');

            $.each(classes, function (k, v)
            {
                if (v != null && v != "" && v != " ")
                {
                    classSelector += "." + v;
                }
            });

            return classSelector;
        };

        var mobileAssignmentHeaderIndicatorsPopup = function ()
        {
            if (!skyward.global.mobileAccess)
            {
                return;
            }

            var button = $(this);
            var indicatorsContainer = button.find(".assignmentHeaderIndicators");

            var data =
            {
                assignmentID: indicatorsContainer.data("assignmentid"),
                isMobile: true
            };

            buildIndicatorPopup(data, "GetAssignmentHeaderIndicators", indicatorsContainer, "Assignment Information");
        };

        var assignmentIndicatorPopup = function ()
        {
            if (!skyward.global.mobileAccess)
            {
                // Currently the assignment indicator popup only works outside of gradebook in mobile
                return;
            }

            var assignmentIndicatorButton = $(this);
            var buttonData = assignmentIndicatorButton.data();

            var showScoreWarning;
            assignmentIndicatorButton.find('.assignmentIndicators').each(function ()
            {
                var span = $(this);
                if (span.hasClass('assignmentIndicatorsFirstRow'))
                {
                    showScoreWarning = !span.hasClass('hiddenWarning');
                }
            });

            var studentAssignmentMobileCard = assignmentIndicatorButton.parents(".studentAssignmentMobileCard");

            var additionalPostData =
            {
                isMissingOverride: skyward.controls.getValue(studentAssignmentMobileCard.find("input.IsMissing")),
                scoreClarifierIDOverride: skyward.controls.getValue(studentAssignmentMobileCard.find("[data-fieldname='ScoreClarifierID']")), //todo: PR 2727610, this will probably change from codeeel to gradebookCodeEEL
                useScoreClarifierOverride: true,
                noCountOverride: skyward.controls.getValue(studentAssignmentMobileCard.find("input.NoCount")),
                commentsOverride: skyward.controls.getValue(studentAssignmentMobileCard.find("[data-fieldname='Comments']")),
                useCommentsOverride: true,
                multipleAttemptsOverride: true
            };

            displayAssignmentIndicatorPopup(assignmentIndicatorButton, buttonData.studentSectionId, buttonData.assignmentId, skyward.controls.getValue(assignmentIndicatorButton.siblings("input.Score")), buttonData.sectionId, buttonData.sectionIdHash, showScoreWarning, null, null, additionalPostData);
        };

        var displayAssignmentIndicatorPopup = function (assignmentIndicatorButton, studentSectionID, assignmentID, score, sectionID, sectionIDHash, showScoreWarning, popupAction, getAdditionalButtons, additionalPostData)
        {
            popupAction = popupAction || "AdvancedStudentAssignmentPopup";

            var data =
            {
                studentSectionID: studentSectionID,
                assignmentID: assignmentID,
                showScoreWarning: showScoreWarning,
                score: score,
                sectionID: sectionID,
                sectionIDHash: sectionIDHash
            };

            if (additionalPostData != null)
            {
                $.extend(data, additionalPostData);
            }

            var buildPopup = function ()
            {
                return $.ajax(
                    {
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + popupAction,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: data
                    });
            };

            $.when(buildPopup()).done(function (html)
            {
                var additionalButtons = typeof getAdditionalButtons === "function" ? getAdditionalButtons(html) : [];
                var cancelButton = { id: "cancelButton", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };

                var dialog = skyward.modalLayer.showDialog('Student Assignment Information', html, additionalButtons.concat([cancelButton]), { anchorTo: assignmentIndicatorButton });
            });
        };

        var massAssignScoresPopupMobile = function ()
        {
            var element = $(this);
            var data = element.data();
            var postData =
            {
                assignmentID: data.assignmentId
            };

            var popupID = "MassAssignScores";
            var headerText = "Mass Assign Scores";

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/MassAssignScores",
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true },
                    data: postData
                });
            };

            var saveFunc = function ()
            {
                //todo: Auto save? Right now its just going to update dom and make the user click save
            };

            var massAssignHelper = massAssign($("#editStudentAssignments"), $('#MassAssignScores'), "[name = 'massAssignRadio']", saveFunc, mobileUpdateIsMissingValueAndCheckFailingScoreClarifier, null, false);

            var saveButton = { text: "Apply", "click": function () { $.when(massAssignHelper.applyButtonClick.call($(this))).done(function () { dialog.close(); }); }, "icon": "Select", "data": data };
            var closeButton = { text: "Cancel", "click": function () { dialog.close(); }, "icon": "Cancel" };
            var options =
            {
                closeOnEscape: false,
                draggable: true,
                id: popupID
            };

            var dialog = skyward.modalLayer.showDialog(headerText, buildPopup, [saveButton, closeButton], options);

            dialog.content.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL", gradeMarkScoringEelCompleteMassAssign);
            dialog.content.on("gradebookInputCodeEELInvalid", ".gradebookInputCodeEEL", gradeMarkScoringEelFailed);
        };

        var gradeMarkScoringEelCompleteMassAssign = function (event, returnData)
        {
            var input = $(this);

            removeCellErrorClasses(input.parents("td").first(), "noMatch");

            var inputValue = returnData.selectedValueID;

            if (inputValue == "" || inputValue == ".")
            {
                returnData.matchedValue = '*';
            }

            skyward.gradebookcodeeel.setValue(input, returnData.matchedValue, inputValue, true);
        };

        var gradeMarkScoringEelComplete = function (event, returnData, gradebook, input)
        {
            removeCellErrorClasses(input.parents("td").first(), "noMatch");

            if (gradebook != null)
            {
                gradebook.saveManager.setDirtyState(false);
            }

            var inputData = input.data();

            var backingPercent = returnData.backingPercent;

            var inputValue = returnData.selectedValueID;

            if (inputValue == null)
            {
                inputValue = "";
            }

            if (backingPercent == null)
            {
                backingPercent = "";
            }

            // backingPercent is set for non-subjective grade marks. We still want to be able to update missing assignment/failing status if a subjective grademark is used, so we check inputValue as well.
            var validScoreGivenToAssignment = (!isNaN(backingPercent) && backingPercent !== "") || (!isNaN(inputValue) && inputValue !== "");

            //use deferred since checkFailingScoreClarifier retrieves advanced cells
            var deferred = $.Deferred();    
            if (input.hasClass("gradeMarkScoring") && inputData.originalAssignmentScore != inputValue && validScoreGivenToAssignment) 
            {
                if (gradebook != null)
                {
                    deferred = gradebook.updateIsMissingValueAndCheckFailingScoreClarifier(inputData.assignmentid, inputData.studentsectionid, null, null, backingPercent);
                }
            }
            else
            {
                deferred.resolve();
            }

            $.when(deferred).done(function ()
            {
                if (gradebook != null)
                {
                    gradebook.completePendingInputScore(input);
                }
                skyward.gradebookcodeeel.setValue(input, returnData.matchedValue, inputValue, true);

                var saveData =
                {
                    assignmentId: inputData.assignmentid,
                    studentSectionId: inputData.studentsectionid,
                    academicStandardId: inputData.academicStandardId,
                    isAvailable: inputData.isAvailable,
                    sectionId: getSectionIDFromCell(input),
                    Score:
                    {
                        displayValue: returnData.matchedValue
                    }
                };
                if (gradebook != null)
                {
                    return gradebook.saveManager.save(saveData);
                }
            });
        };

        var gradeMarkScoringEelFailed = function (event, returnData, input, gradebook)
        {
            input = input ? input : $(this);

            if (gradebook != null)
            {
                gradebook.saveManager.setDirtyState(false);
            }

            var mostRecentDisplayValue = skyward.gradebookcodeeel.getData(input).mostRecentEditableDisplayValue;

            if (mostRecentDisplayValue == null)
            {
                if (input.hasClass("gradeMarkScoring"))
                {
                    mostRecentDisplayValue = input.data().enabledGrademarkValue;
                }
                else
                {
                    mostRecentDisplayValue = input.data().originalValue;
                }
            }
            skyward.controls.setValue(input, mostRecentDisplayValue, true);
            input.parents("td").first().addClass("updated updatedWithErrors noMatch").css({ backgroundColor: '', color: '' });
            if (returnData.success == false && returnData.popupHTML)
            {
                checkAjaxResponseForErrors(returnData);
            }
            //Clear out value and then make cell red. returnData.Errors
        };

        var getPercentEarned = function (pointsEarned, maxScore, percentEarned)
        {
            if (percentEarned != null)
            {
                return percentEarned;
            }
            if (pointsEarned != null && maxScore != null && maxScore != 0)
            {
                var pointsEarnedFloat = parseFloat(pointsEarned);
                var maxScoreFloat = parseFloat(maxScore);
                if (pointsEarnedFloat != null && maxScoreFloat != null)
                {
                    return (pointsEarnedFloat / maxScoreFloat) * 100.0;
                }
            }
            else if (maxScore == 0)
            {
                if (pointsEarned > 0)
                {
                    return 100;
                }
                else if (pointsEarned == 0)
                {
                    return 0;
                }
            }

            return null;
        };

        var mobileUpdateIsMissingValueAndCheckFailingScoreClarifier = function (assignmentID, studentSectionID, pointsEarned, maxScore, percentEarned, selectedValueID)
        {
            var input = $(this);
            var inputData = input.data();

            if (maxScore == null)
            {
                maxScore = inputData.maxscore;
            }

            var percentEarnedFloat = getPercentEarned(pointsEarned, maxScore, percentEarned);

            if (percentEarnedFloat == null && (selectedValueID == null || selectedValueID === ''))
            {
                return;
            }

            var dataObjectViewer = input.parents(".mobileGradebookScoreEntry.dataObjectViewer").find(".mobileGradebookScoreEntryDataContainer");
            var dataObjectViewerData = dataObjectViewer.data();

            var assignmentFieldset = input.parents('.fieldWrapper.studentAssignmentScore');
            var isMissingPuck = assignmentFieldset.find(".assignmentIndicatorButton:not(.hiddenMissingScore)").find("svg.missingScore.svg, svg.isMissing");

            var scoreChangeAdvancedAssignmentColumnHandler = getScoreChangeAdvancedAssignmentColumnHandler(true);
            scoreChangeAdvancedAssignmentColumnHandler.handleAdvancedAssignmentColumnUpdates(percentEarnedFloat, dataObjectViewerData, studentSectionID, assignmentID, isMissingPuck, false, selectedValueID);
        };

        var getScoreChangeAdvancedAssignmentColumnHandler = function (isMobile)
        {
            var handler =
            {
                requiresIsMissingUpdate: function (percentEarnedFloat, isCurrentlyMissing, selectedValueID)
                {
                    return (percentEarnedFloat > 0 || selectedValueID != null && selectedValueID !== '') &&
                        isCurrentlyMissing;
                },
                requiresScoreClarifierUpdate: function (percentEarnedFloat, gradebookBodyData, removeFailingScoreClarifier)
                {
                    var useFailingScoreClarifier = gradebookBodyData.usefailingscoreclarifier;
                    if (useFailingScoreClarifier !== true)
                    {
                        return false;
                    }

                    var failingGradeThresholdPercent = gradebookBodyData.failinggradethresholdpercent;

                    if (percentEarnedFloat == null || isNaN(percentEarnedFloat) || failingGradeThresholdPercent == null)
                    {
                        return false;
                    }
                    percentEarnedFloat = parseFloat(percentEarnedFloat) || 0;
                    failingGradeThresholdPercent = parseFloat(failingGradeThresholdPercent) || 0;

                    if (removeFailingScoreClarifier == true)
                    {
                        return percentEarnedFloat >= failingGradeThresholdPercent;
                    }

                    return percentEarnedFloat < failingGradeThresholdPercent;
                },
                requiresAdvancedAssignmentColumns: function (percentEarnedFloat, gradebookBodyData, isCurrentlyMissing, selectedValueID)
                {
                    return handler.requiresScoreClarifierUpdate(percentEarnedFloat, gradebookBodyData) ||
                        handler.requiresScoreClarifierUpdate(percentEarnedFloat, gradebookBodyData, true) ||
                        handler.requiresIsMissingUpdate(percentEarnedFloat, isCurrentlyMissing, selectedValueID);
                },
                updateIsMissing: function (studentSectionID, assignmentID, value, suppressChangeEvents)
                {
                    var isMissingField = handler.getMissingField(studentSectionID, assignmentID);
                    if (isMissingField.length)
                    {
                        if (isMobile == true)
                        {
                            isMissingField.data('original-value', value);
                        }
                        skyward.controls.setValue(isMissingField, value, suppressChangeEvents);
                    }
                },
                updateNoCount: function (studentSectionID, assignmentID, value, suppressChangeEvents)
                {
                    var noCountField = handler.getNoCountField(studentSectionID, assignmentID);
                    if (noCountField.length)
                    {
                        if (isMobile == true)
                        {
                            noCountField.data('original-value', value);
                        }
                        skyward.controls.setValue(noCountField, value, suppressChangeEvents);
                    }
                },
                updateFailingScoreClarifier: function (gradebookBodyData, studentSectionID, assignmentID, suppressChangeEvents, removeFailingScoreClarifier)
                {
                    var scoreClarifierIDFailing = gradebookBodyData.scoreclarifieridfailing;
                    var scoreClarifierFailingIsMissing = gradebookBodyData.scoreclarifierfailingismissing;
                    var scoreClarifierFailingNoCount = gradebookBodyData.scoreclarifierfailingnocount;
                    var scoreClarifierFailingCode = gradebookBodyData.scoreclarifierfailingcode;

                    var scoreClarifierField = $("[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='ScoreClarifierID']");
                    if (scoreClarifierField.length > 0)
                    {
                        if (removeFailingScoreClarifier == true)
                        {
                            var inputToCheckValueOf = scoreClarifierField.find('input.codeEELCode').length > 0 ? scoreClarifierField.find('input.codeEELCode') : scoreClarifierField;
                            if (getInputValue(inputToCheckValueOf) == scoreClarifierIDFailing)
                            {
                                if (isMobile == true)
                                {
                                    scoreClarifierField.data('original-value', '');
                                    var otherInputs = scoreClarifierField.find('input');
                                    otherInputs.data('original-value', '');
                                    skyward.controls.setValue(scoreClarifierField, null, suppressChangeEvents);
                                }
                                else
                                {
                                    skyward.gradebookcodeeel.setValue(scoreClarifierField, null, null, suppressChangeEvents);
                                }
                            }
                            return;
                        }
                        else
                        {
                            if (isMobile == true)
                            {
                                scoreClarifierField.data('original-value', scoreClarifierIDFailing);
                                var otherInputs = scoreClarifierField.find('input');
                                otherInputs.data('original-value', scoreClarifierIDFailing);
                                skyward.controls.setValue(scoreClarifierField, scoreClarifierIDFailing, suppressChangeEvents);
                            }
                            else
                            {
                                skyward.gradebookcodeeel.setValue(scoreClarifierField, scoreClarifierFailingCode, scoreClarifierIDFailing, suppressChangeEvents);
                            }
                        }
                    }

                    if (scoreClarifierFailingIsMissing === true)
                    {
                        var isMissingField = $("input[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='IsMissing']");
                        if (isMissingField.length)
                        {
                            if (isMobile == true)
                            {
                                isMissingField.data('original-value', true);
                            }
                            skyward.controls.setValue(isMissingField, true, suppressChangeEvents);
                        }
                    }

                    if (scoreClarifierFailingNoCount === true)
                    {
                        var noCountField = $("input[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='NoCount']");
                        if (noCountField.length)
                        {
                            if (isMobile == true)
                            {
                                noCountField.data('original-value', true);
                            }
                            skyward.controls.setValue(noCountField, true, suppressChangeEvents);
                        }
                    }
                },
                handleAdvancedAssignmentColumnUpdates: function (percentEarnedFloat, gradebookBodyData, studentSectionID, assignmentID, isMissingPuck, suppressChangeEvents, selectedValueID)
                {
                    if (suppressChangeEvents == null)
                    {
                        suppressChangeEvents = false;
                    }

                    if (handler.requiresIsMissingUpdate(percentEarnedFloat, isMissingPuck.length > 0, selectedValueID))
                    {
                        handler.updateIsMissing(studentSectionID, assignmentID, false, suppressChangeEvents);
                    }

                    if (handler.requiresScoreClarifierUpdate(percentEarnedFloat, gradebookBodyData))
                    {
                        handler.updateFailingScoreClarifier(gradebookBodyData, studentSectionID, assignmentID, suppressChangeEvents, false);
                    }
                    else if (handler.requiresScoreClarifierUpdate(percentEarnedFloat, gradebookBodyData, true))
                    {
                        handler.updateFailingScoreClarifier(gradebookBodyData, studentSectionID, assignmentID, suppressChangeEvents, true);
                    }
                },
                getMissingField: function (studentSectionID, assignmentID)
                {
                    return $("input[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='IsMissing']");
                },
                getNoCountField: function (studentSectionID, assignmentID)
                {
                    return $("input[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='NoCount']"); //todo: verify fieldname
                }
            };

            return handler;
        };

        //contentsToUpdateContainer = gradebook.body
        //massAssignContainer = gradebook.massAssign
        //selectedOptionSelector = massAssign.radioSet + ":checked"
        //saveFunc = gradebook.saveManager.save(assignmentsToUpdate)
        //assignmentPostCheckFunc = gradebook.updateIsMissingValueAndCheckFailingScoreClarifier
        var massAssign = function (contentsToUpdateContainer, massAssignContainer, selectedOptionSelector, saveFunc, assignmentPostCheckFunc, gradebook, suppressChangeEvent)
        {
            if (suppressChangeEvent == null)
            {
                suppressChangeEvent = true;
            }

            var button;
            var data;
            var assignmentId;
            var studentGradeBucketID;
            var subjectID;
            var academicStandardID;
            var gradingPeriodGradeBucketID;
            var massAssign =
            {
                options: {
                    get buttons() { return $('.massAssignOptionButton'); },
                    get maxPointsLabel() { return $('#maxPointsForAssignment'); },
                    get allScoresInput() { return $('#allScoresInput'); },
                    get overwriteScoresCheckbox() { return $('#overwriteScoresCheckbox'); },
                    get overwriteScoresCheckboxCopyFromPreviousBucket() { return $('#overwriteScoresCheckboxCopyFromPreviousBucket'); },
                    get assignmentColumnTabColor() { return $('#columnColorTab'); },
                    get adjustAllScoresInput() { return $('#adjustAllScoresInput'); },
                    get adjustAllScoresCheckbox() { return $('#adjustAllScoresCheckbox'); },
                    get closeButton() { return $('#closeMassAssign'); },
                    get applyButton() { return $('#applyMassAssign'); },
                    get actionButtons() { return $('.massAssignActionButton'); },
                    get optionButtons() { return $('.massAssignOptionButton'); },
                    get massAssignSubjectiveGradeMark() { return $('#MassAssignSubjectiveGradeMark'); },
                    get massAssignMasteryGradeMark() { return $('#MassAssignMasteryGradeMark'); },
                    get massAssignBucketSelector() { return $('#MassAssignBucketSelector'); },
                    get assignAllStudentGradeBucketAcademicStandardScores() { return $('#assignAllStudentGradeBucketAcademicStandardScores'); },
                    get copyFromPreviousStudentGradeBucketAcademicStandardScores() { return $('#copyFromPreviousStudentGradeBucketAcademicStandardScores'); },
                    get assignAllScoresGradeMarkScoringInput() { return $('#AssignAllScoresGradeMarkScoringInput'); },
                    get tableRow() { return $('.massAssignRow'); } // locked and unlocked row
                },
                cleanup: function ()
                {
                    massAssign.options.actionButtons.addClass('visibilityHidden');
                },
                focusAndSelect: function (input)
                {
                    input.focus();
                    //Edge does not allow select() in here we can uncomment when this is fixed
                    //input.select();
                },
                applyButtonClick: function ()
                {
                    var deferred = $.Deferred();
                    massAssignContainer = $('#MassAssignScores');
                    var saveButton = $(this);
                    saveButton.addClass('ui-disabled');

                    var selected = skyward.controls.getValue(massAssignContainer.find(selectedOptionSelector));
                    var returnErrors = null;

                    var unbreakableGlass = skyward.modalLayer.newModalLayer(null, null,
                        {
                            closeOnClick: false,
                            closeOnRecordSelected: false,
                            closeOnEscape: false,
                            transparentGlass: true
                        });
                    if (selected.length > 0)
                    {
                        $.when(actions[selected]($(this))).done(function (assignmentsToUpdate, errors)
                        {
                            if (errors && errors.length > 0)
                            {
                                unbreakableGlass.close();
                                returnErrors = errors;
                                saveButton.removeClass('ui-disabled');
                                deferred.resolve(returnErrors);
                            }
                            else
                            {
                                if (assignmentsToUpdate != null)
                                {
                                    var sectionIDsProcessed = [];
                                    $.each(assignmentsToUpdate, function (k, v)
                                    {
                                        if (!sectionIDsProcessed.includes(v.sectionId))
                                        {
                                            sectionIDsProcessed.push(v.sectionId);
                                            v.skipUpdateLastScoredTime = false;
                                        }
                                        else
                                        {
                                            v.skipUpdateLastScoredTime = true;
                                        }
                                    });
                                }

                                $.when(saveFunc.apply(null, [assignmentsToUpdate])).done(function ()
                                {
                                    deferred.resolve();
                                    unbreakableGlass.close();
                                });
                            }
                        });
                    }
                    else
                    {
                        deferred.resolve();
                        unbreakableGlass.close();
                    }
                    return deferred;
                },
                inputConfiguration: function ()
                {
                    var radioButton = $(this);
                    massAssignContainer.find('input[type=text]').attr('disabled', true);
                    massAssignContainer.find('input[type=checkbox]').addClass("ui-disabled").attr("aria-readonly", "true");

                    if (radioButton.attr('id') == 'assignAllScores-RadioButton')
                    {
                        $('#overwriteScoresCheckbox').removeClass("ui-disabled").removeAttr("aria-readonly");
                        massAssign.options.allScoresInput.attr('disabled', false);
                        massAssign.focusAndSelect(massAssign.options.allScoresInput);
                    }
                    else if (radioButton.attr('id') == 'adjustAllScores-RadioButton')
                    {
                        massAssign.options.adjustAllScoresInput.attr('disabled', false);
                        massAssign.options.adjustAllScoresCheckbox.removeClass("ui-disabled").removeAttr("aria-readonly");
                        massAssign.focusAndSelect(massAssign.options.adjustAllScoresInput);
                    }
                },
                removePreviousMassAssign: function (previousMassAssignActiveCell)
                {
                    var previousMassAssignContent = previousMassAssignActiveCell.find('.massAssign.massAssignContent');
                    previousMassAssignContent.detach();
                    previousMassAssignActiveCell.removeClass('active');

                    gradebook.massAssign.append(previousMassAssignContent);

                    var previousAssignmentID = previousMassAssignActiveCell.data().assignmentid;

                    setAssignmentHeaderCellToDefaultColors(previousAssignmentID);
                },
                collapseMassAssign: function (alwaysCollapse, buttonData, collapseAndExit)
                {
                    massAssign.cleanup();
                    var myDeferred = $.Deferred();
                    var animation;

                    if (collapseAndExit)
                    {
                        animation = runAnimations('expanded', 'collapsed');
                    }
                    else
                    {
                        if (gradebook.body.hasClass('collapsed'))
                        {
                            myDeferred.resolve();
                            return myDeferred.promise();
                        }
                        if (!alwaysCollapse && buttonData.assignmentId != massAssign.options.applyButton.data().assignmentId)
                        {
                            myDeferred.resolve(); // collapse an open assignment region that is not the one that the mass assign is bound to.
                            return myDeferred.promise();
                        }
                        animation = runAnimations('expanded', 'collapsed');
                    }
                    massAssign.options.optionButtons.removeClass('expanded');
                    animation.done(function ()
                    {
                        if (!collapseAndExit)
                        {
                            gradebook.gradebookBodyScoringModeControls.each(function ()
                            {
                                var scoringModeControl = $(this);
                                skyward.controls.enable(scoringModeControl);
                                if (scoringModeControl.hasClass('codeEELCodeButton'))
                                {
                                    scoringModeControl.removeClass("gradebookScoringMode-Off").addClass("gradebookScoringMode-On");
                                }
                            });
                        }
                        myDeferred.resolve();
                    });
                    return myDeferred.promise();
                }
            };

            var enabledControlSelector = ":not(.scoringModeDoesntAffectState):not(.skipStudentAssignment):not(.hasAttempts)";

            var actions =
            {
                assignAllScores: function (button)
                {
                    setActionData(button);

                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    var newAssignedScore = massAssign.options.allScoresInput.val();
                    var assignmentsToUpdate = [];

                    // ToDo: when checkget is updated to allow a null value we will add the ability to save a blank score for all inputs, making them ungraded
                    var deferred = $.Deferred();

                    var count = 0;
                    var desiredCount = inputs.length;
                    if (massAssign.options.overwriteScoresCheckbox.prop('checked'))
                    {
                        inputs.each(function ()
                        {
                            var input = $(this);
                            skyward.controls.setValue(input, newAssignedScore);

                            var value = input.val();
                            var inputData = input.data();

                            var postCheckDeferred = $.Deferred();
                            if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                            {
                                postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, newAssignedScore]);
                            }
                            else
                            {
                                postCheckDeferred.resolve();
                            }
                            $.when(postCheckDeferred).done(function ()
                            {
                                assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });

                                //count++ is fine, javascript has a single thread that processes callbacks in a queue so this increment won't conflict with other calls in this loop
                                count++;
                                if (count == desiredCount)
                                {
                                    deferred.resolve(assignmentsToUpdate);
                                }
                            });
                        });
                    }
                    else
                    {
                        inputs.each(function ()
                        {
                            var input = $(this);
                            var value = input.val();
                            var inputData = input.data();

                            if (isNaN(value) || value == '') // assign new score to unscored, either empty or asterisk
                            {
                                skyward.controls.setValue(input, newAssignedScore);

                                var postCheckDeferred = $.Deferred();
                                if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                                {
                                    postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, newAssignedScore]);
                                }
                                else
                                {
                                    postCheckDeferred.resolve();
                                }

                                $.when(postCheckDeferred).done(function ()
                                {
                                    assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                                    //count++ is fine, javascript has a single thread that processes callbacks in a queue so this increment won't conflict with other calls in this loop
                                    count++;
                                    if (count == desiredCount)
                                    {
                                        deferred.resolve(assignmentsToUpdate);
                                    }
                                });
                            }
                            else
                            {
                                count++;
                            }
                        });

                        //if this is true, then all of the assignments had scores and so we don't need to wait for the inner deferred objects to resolve.
                        if (count == desiredCount)
                        {
                            deferred.resolve(assignmentsToUpdate);
                        }
                    }

                    return deferred;
                },
                adjustAllScores: function (button)
                {
                    setActionData(button);

                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    var adjustAllScoresValue = massAssign.options.adjustAllScoresInput.val();
                    var adjustmentFloat = parseFloat(adjustAllScoresValue) || 0;

                    if (adjustAllScoresValue == 0)
                    {
                        massAssign.options.adjustAllScoresInput.val("0.00");
                        return [];
                    }

                    if (massAssign.options.adjustAllScoresCheckbox.prop('checked') == false)
                    {
                        var unfilteredInputs = inputs;

                        inputs = [];
                        unfilteredInputs.each(function ()
                        {
                            var input = $(this);
                            var value = input.val();
                            if (!isNaN(value) && value != "") // filter out empty scores and asterisks
                            {
                                inputs.push(input);
                            }
                        });
                    }

                    var inputLength = inputs.length;
                    var count = 0;
                    var deferred = $.Deferred();
                    for (var i = 0; i < inputLength; i++)
                    {
                        var input = $(inputs[i]);
                        var currentCellValue = input.val();
                        var inputData = input.data();
                        currentCellValue = parseFloat(currentCellValue) || 0;

                        var adjustedCellValue;
                        if ((currentCellValue + adjustmentFloat) <= 0)  //a score cannot be less than 0
                        {
                            adjustedCellValue = 0.00;
                        }
                        else if ((currentCellValue + adjustmentFloat) > Math.abs(parseFloat(massAssign.options.allScoresInput.data().decimalMask)))
                        {
                            adjustedCellValue = massAssign.options.allScoresInput.data().decimalMask;
                        }
                        else
                        {
                            adjustedCellValue = parseFloat(currentCellValue + adjustmentFloat).toFixed(2);
                        }

                        skyward.controls.setValue(input, adjustedCellValue);

                        var postCheckDeferred = $.Deferred();
                        if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                        {
                            postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, adjustedCellValue]);
                        }
                        else
                        {
                            postCheckDeferred.resolve();
                        }

                        $.when(postCheckDeferred).done(function ()
                        {
                            assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                            count++;
                            if (count == inputLength)
                            {
                                deferred.resolve(assignmentsToUpdate);
                            }
                        });
                    }
                    if (inputLength == 0)
                    {
                        return assignmentsToUpdate;
                    }
                    return deferred;
                },
                removeAllScores: function (button)
                {
                    setActionData(button);
                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    return actions.removeAllScoresShared(inputs);

                },
                removeAllScoresStudentGradeBucket: function (button)
                {
                    setActionData(button);
                    var buttonData = button.data();
                    var inputs = getAssociatedEnabledInputs('tr.gradesheetBrowseRow[data-student-section-id=' + buttonData.studentSectionId + '] .assignmentCell.js_gradingPeriodGradeBucketID' + buttonData.gradingPeriodGradeBucketId + ' .studentAssignment');
                    return actions.removeAllScoresShared(inputs);
                },
                removeAllScoresShared: function (inputs)
                {
                    var assignmentsToUpdate = [];
                    inputs.each(function ()
                    {
                        var input = $(this);
                        var inputData = input.data();

                        var isAssignmentGradeMarkScoring = input.hasClass("gradeMarkScoring") || input.parent().hasClass("gradeMarkScoring");

                        if (isAssignmentGradeMarkScoring)
                        {
                            if (input.hasClass("gradebookInputCodeEEL"))
                            {
                                skyward.gradebookcodeeel.setValue(input, null, null, suppressChangeEvent);
                            }
                            else
                            {
                                skyward.controls.setValue(input, null, null, suppressChangeEvent);
                            }
                        }
                        else
                        {
                            skyward.controls.setValue(input, '*');
                        }
                        assignmentsToUpdate.push({ assignmentId: inputData.assignmentid, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input), isAssignmentGradeMarkScoring: isAssignmentGradeMarkScoring });
                    });

                    return assignmentsToUpdate;
                },
                scoreUnscoredMissingAsZeroSectionGradeBucket: function (button)
                {
                    return actions.scoreUnscoredMissingAsZero(button, "GetUnscoredMissingAssignmentsGradingPeriodGradeBucket");
                },
                scoreUnscoredMissingAsZeroStudentGradeBucket: function (button)
                {
                    return actions.scoreUnscoredMissingAsZero(button, "GetUnscoredMissingAssignments");
                },
                scoreUnscoredMissingAsZero: function (button, action)
                {
                    var deferred = $.Deferred();
                    var assignmentExpansionDeferreds = [];
                    var assignmentsToUpdate = [];
                    var buttonData = button.data();
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        data: buttonData,
                        success: function (response)
                        {
                            if (response.success == false && response.popupHTML)
                            {
                                checkAjaxResponseForErrors(response);
                            }
                            else if (response && response.assignmentIDsBySectionIDByStudentSectionID)
                            {
                                $.each(response.assignmentIDsBySectionIDByStudentSectionID, function (sectionID, assignmentIDsUpdatedByStudentSectionID)
                                {
                                    $.each(assignmentIDsUpdatedByStudentSectionID, function (studentSectionID, assignmentIDs)
                                    {
                                        if (assignmentIDs != null)
                                        {
                                            $.each(assignmentIDs, function (index, assignmentID)
                                            {
                                                var assignmentExpansionDeferred = $.Deferred();
                                                assignmentExpansionDeferreds.push(assignmentExpansionDeferred);

                                                var effectiveAssignmentID = gradebook.getEffectiveAssignmentID(assignmentID, studentSectionID, sectionID, buttonData.gradingPeriodGradeBucketId);
                                                var studentAssignmentCell = $("#Gradebook_" + studentSectionID + "_" + effectiveAssignmentID + "_Score");

                                                $.when(gradebook.getAdvancedColumnCellsByAssignmentID(effectiveAssignmentID, true, false)).done(function ()
                                                {
                                                    var input = studentAssignmentCell.find("input.gradebookInput" + enabledControlSelector);
                                                    var inputData = input.data();

                                                    var postCheckDeferred = $.Deferred();
                                                    if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function" && input && input.length > 0 && !input.hasClass("gradeMarkScoring"))
                                                    {
                                                        postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, 0]);
                                                    }
                                                    else
                                                    {
                                                        postCheckDeferred.resolve();
                                                    }

                                                    $.when(postCheckDeferred).done(function ()
                                                    {
                                                        if (input && input.length > 0 && !input.hasClass("gradeMarkScoring"))
                                                        {
                                                            gradebook.markInputScoreAsPending(input);
                                                            skyward.controls.setValue(input, '0.00');
                                                            assignmentsToUpdate.push({ assignmentId: effectiveAssignmentID, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                                                        }

                                                        assignmentExpansionDeferred.resolve();
                                                    });
                                                });
                                            });
                                        }
                                    });
                                });
                            }
                            $.when.apply($, assignmentExpansionDeferreds).done(function ()
                            {
                                deferred.resolve(assignmentsToUpdate);
                            });
                        }
                    });

                    return deferred.promise();
                },
                markUnscoredPastDueAsMissingStudentGradeBucket: function (button)
                {
                    return actions.updateUnscoredPastDueAssignments(button, "GetUnscoredPastDueAsMissingAssignments", false);
                },
                updateUnscoredPastDueZeroMarkMissingStudentGradeBucket: function (button)
                {
                    return actions.updateUnscoredPastDueAssignments(button, "GetUnscoredPastDueAsMissingAssignments", true);
                },
                markUnscoredPastDueAsMissingSectionGradeBucket: function (button)
                {
                    return actions.updateUnscoredPastDueAssignments(button, "GetUnscoredPastDueAsMissingAssignmentsGradingPeriodGradeBucket", false);
                },
                updateUnscoredPastDueZeroMarkMissingSectionGradeBucket: function (button)
                {
                    return actions.updateUnscoredPastDueAssignments(button, "GetUnscoredPastDueAsMissingAssignmentsGradingPeriodGradeBucket", true);
                },
                updateUnscoredPastDueAssignments: function (button, action, markAsZero)
                {
                    var deferred = $.Deferred();
                    var assignmentExpansionDeferreds = [];
                    var assignmentsToUpdate = [];
                    var buttonData = button.data();
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        data: buttonData,
                        success: function (response)
                        {
                            if (response.success == false && response.popupHTML)
                            {
                                checkAjaxResponseForErrors(response);
                            }
                            else if (response && response.assignmentIDsBySectionIDByStudentSectionID)
                            {
                                $.each(response.assignmentIDsBySectionIDByStudentSectionID, function (sectionID, assignmentIDsUpdatedByStudentSectionID)
                                {
                                    $.each(assignmentIDsUpdatedByStudentSectionID, function (studentSectionID, assignmentIDs)
                                    {
                                        if (assignmentIDs != null)
                                        {
                                            $.each(assignmentIDs, function (index, assignmentID)
                                            {
                                                var effectiveAssignmentID = gradebook.getEffectiveAssignmentID(assignmentID, studentSectionID, sectionID, buttonData.gradingPeriodGradeBucketId);
                                                var studentAssignmentCell = $("#Gradebook_" + studentSectionID + "_" + effectiveAssignmentID + "_Score");

                                                if (studentAssignmentCell.length > 0)
                                                {
                                                    var assignmentExpansionDeferred = $.Deferred();
                                                    assignmentExpansionDeferreds.push(assignmentExpansionDeferred);

                                                    $.when(gradebook.getAdvancedColumnCellsByAssignmentID(effectiveAssignmentID, true, false)).done(function ()
                                                    {
                                                        var checkBox = contentsToUpdateContainer.find('tr.gradesheetBrowseRow[data-student-section-id=' + studentSectionID + '] .IsMissing.assignment' + effectiveAssignmentID + ':not(:checked)' + enabledControlSelector);
                                                        var scoreInput = studentAssignmentCell.find("input.gradebookInput");

                                                        var inputData = checkBox.data();
                                                        skyward.controls.setValue(checkBox, true);

                                                        var postCheckDeferred = $.Deferred();
                                                        if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function" && markAsZero && scoreInput && scoreInput.length > 0 && !scoreInput.hasClass("gradeMarkScoring"))
                                                        {
                                                            postCheckDeferred = assignmentPostCheckFunc.apply(checkBox, [inputData.assignmentid, inputData.studentsectionid, 0]);
                                                        }
                                                        else
                                                        {
                                                            postCheckDeferred.resolve();
                                                        }

                                                        $.when(postCheckDeferred).done(function ()
                                                        {
                                                            if (markAsZero)
                                                            {
                                                                var value = scoreInput.val();
                                                                if (value == "" || isNaN(value))
                                                                {
                                                                    gradebook.markInputScoreAsPending(scoreInput);

                                                                    if (scoreInput && !scoreInput.hasClass("gradeMarkScoring"))
                                                                    {
                                                                        skyward.controls.setValue(scoreInput, '0.00');
                                                                    }
                                                                }
                                                            }

                                                            assignmentsToUpdate.push({ assignmentId: effectiveAssignmentID, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                                                            assignmentExpansionDeferred.resolve();
                                                        });

                                                    });
                                                }
                                            });
                                        }
                                    });
                                });
                            }
                            $.when.apply($, assignmentExpansionDeferreds).done(function ()
                            {
                                deferred.resolve(assignmentsToUpdate);
                            });
                        }
                    });

                    return deferred.promise();
                },
                removeAllMissingStudentGradeBucket: function (button)
                {
                    var deferred = $.Deferred();
                    setActionData(button);
                    var buttonData = button.data();
                    var assignmentExpansionDeferreds = [];
                    var missingSVGs = contentsToUpdateContainer.find('tr.gradesheetBrowseRow[data-student-section-id=' + buttonData.studentSectionId + '] .assignmentCell.js_gradingPeriodGradeBucketID' + buttonData.gradingPeriodGradeBucketId + ' svg.missingScore');
                    var assignmentsToUpdate = [];
                    missingSVGs.each(function ()
                    {
                        var missingSVG = $(this);
                        var scoreCell = missingSVG.parents("td").first();
                        var scoreInput = scoreCell.find("input.gradebookInput");
                        var scoreInputData = scoreInput.data();

                        var assignmentExpansionDeferred = $.Deferred();
                        assignmentExpansionDeferreds.push(assignmentExpansionDeferred);
                        $.when(gradebook.getAdvancedColumnCellsByAssignmentID(scoreInputData.assignmentid, true, false)).done(function (test123)
                        {
                            var checkBox = getAssociatedEnabledInputs('tr.gradesheetBrowseRow[data-student-section-id=' + scoreInputData.studentsectionid + '] .IsMissing.assignment' + scoreInputData.assignmentid + ':checked');

                            if (checkBox.length > 0)
                            {
                                skyward.controls.setValue(checkBox, false);
                                assignmentsToUpdate.push({ assignmentId: scoreInputData.assignmentid, studentSectionId: scoreInputData.studentsectionid, academicStandardId: scoreInputData.academicStandardId, isAvailable: scoreInputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                            }
                            assignmentExpansionDeferred.resolve();

                        });
                    });

                    $.when.apply($, assignmentExpansionDeferreds).done(function ()
                    {
                        deferred.resolve(assignmentsToUpdate);
                    });

                    return deferred.promise();
                },
                setAllToNoCountStudentGradeBucket: function (button)
                {
                    return actions.updateAllNoCountStudentGradeBucket(button, true);
                },
                removeAllNoCountStudentGradeBucket: function (button)
                {
                    return actions.updateAllNoCountStudentGradeBucket(button, false);
                },
                updateAllNoCountStudentGradeBucket: function (button, noCountValue)
                {
                    var deferred = $.Deferred();
                    setActionData(button);
                    var buttonData = button.data();
                    var assignmentExpansionDeferreds = [];
                    var noCountCells;

                    if (noCountValue)
                    {
                        noCountCells = contentsToUpdateContainer.find('tr.gradesheetBrowseRow[data-student-section-id=' + buttonData.studentSectionId + '] .assignmentCell.js_gradingPeriodGradeBucketID' + buttonData.gradingPeriodGradeBucketId + ':not(:has("svg.noCount:visible"))');
                    }
                    else
                    {
                        noCountCells = contentsToUpdateContainer.find('tr.gradesheetBrowseRow[data-student-section-id=' + buttonData.studentSectionId + '] .assignmentCell.js_gradingPeriodGradeBucketID' + buttonData.gradingPeriodGradeBucketId + ':has("svg.noCount")');
                    }
                    var assignmentsToUpdate = [];
                    noCountCells.each(function ()
                    {
                        var scoreCell = $(this);
                        var scoreInput = scoreCell.find("input.gradebookInput");
                        var scoreInputData = scoreInput.data();

                        var assignmentExpansionDeferred = $.Deferred();
                        assignmentExpansionDeferreds.push(assignmentExpansionDeferred);

                        $.when(gradebook.getAdvancedColumnCellsByAssignmentID(scoreInputData.assignmentid, true, false)).done(function ()
                        {
                            var checkedSelector;
                            if (noCountValue == true)
                            {
                                checkedSelector = ':not(:checked)'
                            }
                            else
                            {
                                checkedSelector = ':checked';
                            }
                            var checkBox = getAssociatedEnabledInputs('tr.gradesheetBrowseRow[data-student-section-id=' + scoreInputData.studentsectionid + '] .NoCount.assignment' + scoreInputData.assignmentid + checkedSelector);

                            if (checkBox.length > 0)
                            {
                                skyward.controls.setValue(checkBox, noCountValue);
                                assignmentsToUpdate.push({ assignmentId: scoreInputData.assignmentid, studentSectionId: scoreInputData.studentsectionid, academicStandardId: scoreInputData.academicStandardId, isAvailable: scoreInputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                            }
                            assignmentExpansionDeferred.resolve();
                        });

                    });

                    $.when.apply($, assignmentExpansionDeferreds).done(function ()
                    {
                        deferred.resolve(assignmentsToUpdate);
                    });

                    return deferred.promise();
                },

                setAllToNoCount: function (button)
                {
                    setActionData(button);
                    var checkBoxes = contentsToUpdateContainer.find('.NoCount.assignment' + assignmentId + ':not(:checked)' + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    checkBoxes.each(function ()
                    {
                        var checkBox = $(this);
                        var inputData = checkBox.data();
                        skyward.controls.setValue(checkBox, true);
                        assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                    });

                    return assignmentsToUpdate;
                },
                removeAllNoCount: function (button)
                {
                    setActionData(button);
                    var checkBoxes = contentsToUpdateContainer.find('.NoCount.assignment' + assignmentId + ':checked' + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    checkBoxes.each(function ()
                    {
                        var checkBox = $(this);
                        var inputData = checkBox.data();
                        skyward.controls.setValue(checkBox, false);
                        assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                    });

                    return assignmentsToUpdate;
                },
                removeAllMissing: function (button)
                {
                    setActionData(button);
                    var checkBoxes = contentsToUpdateContainer.find('.IsMissing.assignment' + assignmentId + ':checked' + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    checkBoxes.each(function ()
                    {
                        var checkBox = $(this);
                        var inputData = checkBox.data();
                        skyward.controls.setValue(checkBox, false);
                        assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                    });

                    return assignmentsToUpdate;
                },
                removeAllScoreClarifiers: function (button)
                {
                    setActionData(button);
                    var scoreClarifiers = contentsToUpdateContainer.find('div.scoreClarifier.assignment' + assignmentId + ':not([readonly]):not(.scoringModeDoesntAffectState)');
                    var assignmentsToUpdate = [];
                    scoreClarifiers.each(function ()
                    {
                        var scoreClarifier = $(this);
                        if (scoreClarifier.length)
                        {
                            var eel = scoreClarifier;

                            if (eel.hasClass("gradebookCodeEEL"))
                            {
                                eel = eel.find('.gradebookInputCodeEEL');
                                if (!eel.hasClass('scoringModeDoesntAffectState'))
                                {
                                    skyward.gradebookcodeeel.setValue(eel, null, null, true);
                                    var inputData = eel.data();
                                    assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(scoreClarifier) });
                                }
                            }
                            else if (eel.parent().hasClass('codeEEL'))
                            {
                                eel = scoreClarifier.parent(".codeEEL");
                                if (!eel.hasClass('scoringModeDoesntAffectState'))
                                {
                                    skyward.controls.setValue(eel, null, null, true);
                                    var inputData = eel.find(".codeEELCode").data();
                                    $.extend(inputData, eel.data());
                                    assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(scoreClarifier) });
                                }
                            }
                        }
                    });

                    return assignmentsToUpdate;
                },
                updateZeroMarkMissing: function (button)
                {
                    setActionData(button);
                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    inputs.each(function ()
                    {
                        var input = $(this);
                        var inputData = input.data();
                        var value = input.val();
                        if (value == "" || isNaN(value))
                        {
                            skyward.controls.setValue(input, '0.00');
                            var isMissingCell = contentsToUpdateContainer.find('.IsMissing.assignment' + assignmentId + enabledControlSelector + '[data-studentsectionid=' + inputData.studentsectionid + ']');
                            skyward.controls.setValue(isMissingCell, true);

                            var postCheckDeferred = $.Deferred();
                            if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                            {
                                postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, 0]);
                            }
                            else
                            {
                                postCheckDeferred.resolve();
                            }

                            $.when(postCheckDeferred).done(function ()
                            {
                                assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                            });
                        }
                    });

                    return assignmentsToUpdate;
                },
                gradeMarkScoringMarkUnscoredAsMissing: function (button)
                {
                    setActionData(button);
                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    inputs.each(function ()
                    {
                        var input = $(this);
                        var inputData = $.extend({}, input.data(), input.parent().data());
                        var value = skyward.controls.getValue(input);
                        if (input.hasClass("gradebookInputCodeEEL"))
                        {
                            value = skyward.gradebookcodeeel.getData(input).displayValue;
                        }

                        if (value == null || value == "" || value == "*")
                        {
                            //todo: PR 2727610, make sure we check what the input type is and get value the correct way, either for code eel or gradebook code eel or decimal textbox
                            var isMissingCell = contentsToUpdateContainer.find('.IsMissing.assignment' + assignmentId + enabledControlSelector + '[data-studentsectionid=' + inputData.studentsectionid + ']');
                            skyward.controls.setValue(isMissingCell, true);
                            assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: isMissingCell.data().isAvailable, sectionId: getSectionIDFromCell(input) });
                        }
                    });

                    return assignmentsToUpdate;
                },
                assignAllStudentGradeBucketScores: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                    }

                    var overwriteScores = massAssign.options.overwriteScoresCheckbox.prop('checked');
                    var gradebookcodeeelData = skyward.gradebookcodeeel.getData(massAssign.options.massAssignSubjectiveGradeMark);

                    var gradingScaleGroupID = null;
                    var massAssignSubjectiveGradeMarkData = massAssign.options.massAssignSubjectiveGradeMark.data();

                    if (massAssignSubjectiveGradeMarkData)
                    {
                        gradingScaleGroupID = JSON.parse(massAssignSubjectiveGradeMarkData.postData).gradingscalegroupidmostused;
                    }

                    var eels = $(".subjectiveStudentGradeBucket[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-grading-scale-group-id='" + gradingScaleGroupID + "']");

                    var gradeBuckets = [];
                    var studentGradeBucketIDs = [];

                    eels.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        var value = skyward.controls.getValue(input);

                        var studentGradeBucketID = input.parents('.gradeBucketCell').data('studentGradeBucketId');
                        if (!studentGradeBucketIDs.includes(studentGradeBucketID)
                            && (overwriteScores || !value || value === null || value === "" || value === "*"))
                        {
                            removeCellErrorClasses(input.parents("td").first(), "noMatch");
                            skyward.gradebookcodeeel.setValue(input, gradebookcodeeelData.displayValue, gradebookcodeeelData.selectedValueID, true);

                            studentGradeBucketIDs.push(studentGradeBucketID);
                            gradeBuckets.push(
                                {
                                    isStudentGradeBucket: true,
                                    studentGradeBucketID: studentGradeBucketID,
                                    Score:
                                    {
                                        selectedValueID: gradebookcodeeelData.selectedValueID,
                                        displayValue: gradebookcodeeelData.displayValue
                                    }
                                });
                        }
                    });
                    return gradeBuckets;
                },
                assignAllStudentGradeBucketSubjectMasteryScores: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        subjectID = data.subjectId;
                    }
                    var isMastered = skyward.controls.getValue(massAssign.options.massAssignMasteryGradeMark);

                    var checkboxes = $(".checkbox.mastery.gradebookCheckbox[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-subject-id='" + subjectID + "']");

                    var gradeBuckets = [];
                    checkboxes.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        if (isMastered != skyward.controls.getValue(input))
                        {
                            skyward.controls.setValue(input, isMastered, suppressChangeEvent);
                        }

                        var studentGradeBucketSubjectID = input.parents('.subjectCell').data('studentGradeBucketSubjectId');
                        gradeBuckets.push({ isStudentGradeBucketSubject: true, studentGradeBucketSubjectID: studentGradeBucketSubjectID, type: "mastery" });
                    });
                    return gradeBuckets;
                },
                assignAllStudentGradeBucketSubjectScores: function (callingButton)
                {
                    if (massAssign.options.massAssignMasteryGradeMark.length > 0)
                    {
                        return actions["assignAllStudentGradeBucketSubjectMasteryScores"](callingButton);
                    }
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        subjectID = data.subjectId;
                    }
                    var overwriteScores = massAssign.options.overwriteScoresCheckbox.prop('checked');
                    var gradebookcodeeelData = skyward.gradebookcodeeel.getData(massAssign.options.massAssignSubjectiveGradeMark);

                    var gradingScaleGroupID = null;
                    var massAssignSubjectiveGradeMarkData = massAssign.options.massAssignSubjectiveGradeMark.data();

                    if (massAssignSubjectiveGradeMarkData)
                    {
                        gradingScaleGroupID = JSON.parse(massAssignSubjectiveGradeMarkData.postData).gradingscalegroupidmostused;
                    }

                    var eels = $(".subjectiveStudentGradeBucketSubject[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-subject-id='" + subjectID + "'][data-grading-scale-group-id='" + gradingScaleGroupID + "']");

                    var gradeBuckets = [];
                    eels.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        var value = skyward.controls.getValue(input);

                        if (overwriteScores || !value || value === null || value === "" || value === "*")
                        {
                            skyward.gradebookcodeeel.setValue(input, gradebookcodeeelData.displayValue, gradebookcodeeelData.selectedValueID, true);

                            var studentGradeBucketSubjectID = input.parents('.subjectCell').data('studentGradeBucketSubjectId');
                            gradeBuckets.push(
                                {
                                    isStudentGradeBucketSubject: true,
                                    studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                                    Score:
                                    {
                                        selectedValueID: gradebookcodeeelData.selectedValueID,
                                        displayValue: gradebookcodeeelData.displayValue
                                    },
                                    studentSectionId: input.parents("tr.gradesheetBrowseRow").first().data().studentSectionId,
                                });
                        }
                    });
                    return gradeBuckets;
                },
                assignAllStudentGradeBucketAcademicStandardMasteryScores: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        academicStandardID = data.academicStandardId;
                    }
                    var isMastered = skyward.controls.getValue(massAssign.options.massAssignMasteryGradeMark);

                    var checkboxes = $(".checkbox.mastery.gradebookCheckbox[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-academic-standard-id='" + data.academicStandardId + "']");

                    var gradeBuckets = [];
                    checkboxes.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();

                        if (isMastered != skyward.controls.getValue(input))
                        {
                            skyward.controls.setValue(input, isMastered, suppressChangeEvent);

                            var studentGradeBucketAcademicStandardID = input.parents('.academicStandardCell').data('studentGradeBucketAcademicStandardId');
                            gradeBuckets.push({ isStudentGradeBucketAcademicStandard: true, studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID, type: "mastery" });
                        }
                    });
                    return gradeBuckets;
                },
                assignAllStudentGradeBucketAcademicStandardScores: function (callingButton)
                {
                    if (massAssign.options.massAssignMasteryGradeMark.length > 0)
                    {
                        return actions["assignAllStudentGradeBucketAcademicStandardMasteryScores"](callingButton);
                    }
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        academicStandardID = data.academicStandardId;
                    }
                    var overwriteScores = massAssign.options.overwriteScoresCheckbox.prop('checked');
                    var gradebookcodeeelData = skyward.gradebookcodeeel.getData(massAssign.options.massAssignSubjectiveGradeMark);

                    var gradingScaleGroupID = null;
                    var massAssignSubjectiveGradeMarkData = massAssign.options.massAssignSubjectiveGradeMark.data();

                    if (massAssignSubjectiveGradeMarkData)
                    {
                        gradingScaleGroupID = JSON.parse(massAssignSubjectiveGradeMarkData.postData).gradingscalegroupidmostused;
                    }

                    var eels = $(".subjectiveStudentGradeBucketAcademicStandard[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-academic-standard-id='" + academicStandardID + "'][data-grading-scale-group-id='" + gradingScaleGroupID + "']");

                    var gradeBuckets = [];
                    eels.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        var value = skyward.controls.getValue(input);

                        if (overwriteScores || !value || value === null || value === "" || value === "*")
                        {
                            skyward.gradebookcodeeel.setValue(input, gradebookcodeeelData.displayValue, gradebookcodeeelData.selectedValueID, true);

                            var studentGradeBucketAcademicStandardID = input.parents('.academicStandardCell').data('studentGradeBucketAcademicStandardId');
                            gradeBuckets.push(
                                {
                                    isStudentGradeBucketAcademicStandard: true,
                                    studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                                    studentSectionId: input.parents("tr.gradesheetBrowseRow").first().data().studentSectionId,
                                    Score:
                                    {
                                        selectedValueID: gradebookcodeeelData.selectedValueID,
                                        displayValue: gradebookcodeeelData.displayValue
                                    }
                                });
                        }
                    });
                    return gradeBuckets;
                },
                copyFromPreviousStudentGradeBucketAcademicStandardScores: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        academicStandardID = data.academicStandardId;
                    }

                    var overwriteScores = massAssign.options.overwriteScoresCheckboxCopyFromPreviousBucket.prop('checked');

                    var gradeBuckets = [];
                    var deferred = $.Deferred();
                    var selectedCalculationGroupGradeBucketID = skyward.controls.getValue(massAssign.options.massAssignBucketSelector);

                    if (selectedCalculationGroupGradeBucketID == null || selectedCalculationGroupGradeBucketID === "")
                    {
                        var errors = [];
                        errors.push('A Previous Bucket is required if you choose the "Copy from Previous Bucket" option.');
                        return deferred.resolve(gradeBuckets, errors);
                    }

                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/GetStudentGradeBucketAcademicStandardGrades",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            calculationGroupGradeBucketID: selectedCalculationGroupGradeBucketID,
                            academicStandardID: academicStandardID
                        },
                        success: function (response)
                        {
                            var eels;
                            var checkboxes;

                            eels = $(".subjectiveStudentGradeBucketAcademicStandard[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-academic-standard-id='" + academicStandardID + "']");
                            checkboxes = $(".checkbox.mastery.gradebookCheckbox[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-academic-standard-id='" + data.academicStandardId + "']");

                            if (massAssign.options.massAssignMasteryGradeMark.length > 0)
                            {
                                checkboxes.each(function ()
                                {
                                    var input = $(this);
                                    var data = input.data();
                                    var studentSectionID = input.parents('tr.gradesheetBrowseRow').data('studentSectionId');

                                    var isMastered = null;
                                    $.each(JSON.parse(response.grades), function ()
                                    {
                                        var thisGrade = $(this);

                                        if (thisGrade.length > 0 && thisGrade[0].StudentSectionID == studentSectionID)
                                        {
                                            isMastered = thisGrade[0].GradingScaleGroupGradeMarkID != null;
                                            return;
                                        }
                                    });

                                    if (isMastered != skyward.controls.getValue(input) &&
                                        //Intentionally checking that isMastered equals either true or false here to avoid attempting to set null (which is the default value of isMastered we set above)
                                        (isMastered == true || (overwriteScores == true && isMastered == false)))
                                    {
                                        skyward.controls.setValue(input, isMastered, suppressChangeEvent);

                                        var studentGradeBucketAcademicStandardID = input.parents('.academicStandardCell').data('studentGradeBucketAcademicStandardId');
                                        gradeBuckets.push({ isStudentGradeBucketAcademicStandard: true, studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID, type: "mastery" });
                                    }
                                });
                            }
                            else
                            {
                                eels.each(function ()
                                {
                                    var input = $(this);
                                    var data = input.data();
                                    var value = skyward.controls.getValue(input);

                                    if (overwriteScores == true || !value || value === null || value === "" || value === "*")
                                    {
                                        var studentGradeBucketAcademicStandardID = input.parents('.academicStandardCell').data('studentGradeBucketAcademicStandardId');
                                        var studentSectionID = input.parents('tr.gradesheetBrowseRow').data('studentSectionId');

                                        var grade;
                                        $.each(JSON.parse(response.grades), function ()
                                        {
                                            var thisGrade = $(this);

                                            if (thisGrade.length > 0 && thisGrade[0].StudentSectionID == studentSectionID)
                                            {
                                                grade = thisGrade[0];
                                                return;
                                            }
                                        });

                                        if (grade &&
                                            (overwriteScores == true || grade.GradingScaleGroupGradeMarkID != null))
                                        {
                                            skyward.gradebookcodeeel.setValue(input, grade.GradeMarkCode, grade.GradingScaleGroupGradeMarkID, true);

                                            gradeBuckets.push(
                                            {
                                                isStudentGradeBucketAcademicStandard: true,
                                                studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                                                studentSectionId: input.parents("tr.gradesheetBrowseRow").first().data().studentSectionId,
                                                Score:
                                                {
                                                    selectedValueID: grade.GradingScaleGroupGradeMarkID,
                                                    displayValue: grade.GradeMarkCode
                                                }
                                            });
                                        }
                                    }
                                });
                            }
                            deferred.resolve(gradeBuckets);
                        }
                    });

                    return deferred;
                },
                copyFromPreviousStudentGradeBucketSubjectScores: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        subjectID = data.subjectId;
                    }

                    var overwriteScores = massAssign.options.overwriteScoresCheckboxCopyFromPreviousBucket.prop('checked');

                    var gradeBuckets = [];
                    var deferred = $.Deferred();
                    var selectedCalculationGroupGradeBucketID = skyward.controls.getValue(massAssign.options.massAssignBucketSelector);

                    if (selectedCalculationGroupGradeBucketID == null || selectedCalculationGroupGradeBucketID === "")
                    {
                        var errors = [];
                        errors.push('A Previous Bucket is required if you choose the "Copy from Previous Bucket" option.');
                        return deferred.resolve(gradeBuckets, errors);
                    }

                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/GetStudentGradeBucketSubjectGrades",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            calculationGroupGradeBucketID: selectedCalculationGroupGradeBucketID,
                            subjectID: subjectID
                        },
                        success: function (response)
                        {
                            var eels;
                            var checkboxes;

                            eels = $(".subjectiveStudentGradeBucketSubject[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-subject-id='" + subjectID + "']");
                            checkboxes = $(".checkbox.mastery.gradebookCheckbox[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-subject-id='" + data.subjectId + "']");

                            if (massAssign.options.massAssignMasteryGradeMark.length > 0)
                            {
                                checkboxes.each(function ()
                                {
                                    var input = $(this);
                                    var data = input.data();
                                    var studentSectionID = input.parents('tr.gradesheetBrowseRow').data('studentSectionId');

                                    var isMastered = null;
                                    $.each(JSON.parse(response.grades), function ()
                                    {
                                        var thisGrade = $(this);

                                        if (thisGrade.length > 0 && thisGrade[0].StudentSectionID == studentSectionID)
                                        {
                                            isMastered = thisGrade[0].GradingScaleGroupGradeMarkID != null;
                                            return;
                                        }
                                    });

                                    if (isMastered != skyward.controls.getValue(input) &&
                                        //Intentionally checking that isMastered equals either true or false here to avoid attempting to set null (which is the default value of isMastered we set above)
                                        (isMastered == true || (overwriteScores == true && isMastered == false)))
                                    {
                                        skyward.controls.setValue(input, isMastered, suppressChangeEvent);

                                        var studentGradeBucketSubjectID = input.parents('.subjectCell').data('studentGradeBucketSubjectId');
                                        gradeBuckets.push({ isStudentGradeBucketSubject: true, studentGradeBucketSubjectID: studentGradeBucketSubjectID, type: "mastery" });
                                    }
                                });
                            }
                            else
                            {
                                eels.each(function ()
                                {
                                    var input = $(this);
                                    var data = input.data();
                                    var value = skyward.controls.getValue(input);

                                    if (overwriteScores == true || !value || value === null || value === "" || value === "*")
                                    {
                                        var studentGradeBucketSubjectID = input.parents('.subjectCell').data('studentGradeBucketSubjectId');
                                        var studentSectionID = input.parents('tr.gradesheetBrowseRow').data('studentSectionId');

                                        var grade;
                                        $.each(JSON.parse(response.grades), function ()
                                        {
                                            var thisGrade = $(this);

                                            if (thisGrade.length > 0 && thisGrade[0].StudentSectionID == studentSectionID)
                                            {
                                                grade = thisGrade[0];
                                                return;
                                            }
                                        });

                                        if (grade &&
                                            (overwriteScores == true || grade.GradingScaleGroupGradeMarkID != null))
                                        {
                                            skyward.gradebookcodeeel.setValue(input, grade.GradeMarkCode, grade.GradingScaleGroupGradeMarkID, true);

                                            gradeBuckets.push(
                                            {
                                                isStudentGradeBucketSubject: true,
                                                studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                                                studentSectionId: input.parents("tr.gradesheetBrowseRow").first().data().studentSectionId,
                                                Score:
                                                {
                                                    selectedValueID: grade.GradingScaleGroupGradeMarkID,
                                                    displayValue: grade.GradeMarkCode
                                                }
                                            });
                                        }
                                    }
                                });
                            }
                            deferred.resolve(gradeBuckets);
                        }
                    });

                    return deferred;
                },
                assignAllScoresGradeMarkScoring: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        assignmentID = data.assignmentId;
                        studentSectionID = data.studentSectionId;
                    }
                    var overwriteScores = massAssign.options.overwriteScoresCheckbox.prop('checked');
                    var gradebookcodeeelData = skyward.gradebookcodeeel.getData(massAssign.options.assignAllScoresGradeMarkScoringInput);

                    var gradingScaleGroupID = null;
                    var massAssignGradeMarkScores = massAssign.options.assignAllScoresGradeMarkScoringInput.data();

                    if (massAssignGradeMarkScores)
                    {
                        gradingScaleGroupID = JSON.parse(massAssignGradeMarkScores.postData).gradingscalegroupidmostused;
                    }

                    var eels = $(".gradeMarkScoring[data-assignmentId='" + assignmentID + "'][data-grading-scale-group-id='" + gradingScaleGroupID + "']:not([readonly]):not(.scoringModeDoesntAffectState)");

                    var assignmentsToUpdate = [];
                    var deferred = $.Deferred();
                    var count = 0;
                    var inputCount = eels.length;
                    eels.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        var value = skyward.controls.getValue(input);

                        if (overwriteScores || !value || value === null || value === "" || value == "*")
                        {
                            if (input.parent().hasClass("gradebookCodeEEL"))
                            {
                                skyward.gradebookcodeeel.setValue(input, gradebookcodeeelData.displayValue, gradebookcodeeelData.selectedValueID, true);
                            }
                            else
                            {
                                skyward.controls.setValue(input, gradebookcodeeelData.selectedValueID, suppressChangeEvent);
                            }

                            var postCheckDeferred = $.Deferred();
                            if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                            {
                                postCheckDeferred = assignmentPostCheckFunc.apply(input, [data.assignmentid, data.studentsectionid, gradebookcodeeelData.backingPercent, data.maxScore]);
                            }
                            else
                            {
                                postCheckDeferred.resolve();
                            }
                            $.when(postCheckDeferred).done(function ()
                            {
                                assignmentsToUpdate.push({ isAssignmentGradeMarkScoring: true, assignmentId: data.assignmentid, studentSectionId: data.studentsectionid, academicStandardId: data.academicStandardId, isAvailable: data.isAvailable, sectionId: getSectionIDFromCell(input), displayValue: gradebookcodeeelData.displayValue });

                                //count++ is fine, javascript has a single thread that processes callbacks in a queue so this increment won't conflict with other calls in this loop
                                count++;
                                if (count == inputCount)
                                {
                                    deferred.resolve(assignmentsToUpdate);
                                }
                            });
                        }
                        else
                        {
                            count++;
                            if (count == inputCount)
                            {
                                deferred.resolve(assignmentsToUpdate);
                            }
                        }
                    });

                    if (inputCount == 0)
                    {
                        return assignmentsToUpdate;
                    }
                    return deferred;
                }
            };

            var setActionData = function (callingButton)
            {
                button = callingButton;
                data = button.data();
                if (data != null)
                {
                    assignmentId = data.assignmentId;
                }
            };

            var getAssociatedEnabledInputs = function (studentAssignmentInputSelector)
            {
                return contentsToUpdateContainer.find(studentAssignmentInputSelector + enabledControlSelector);
            };

            var runAnimations = function (removingClass, addingClass)
            {
                var myDeferred = $.Deferred();
                var promises = [];

                var primaryPromise = $('.massAssign').switchClass(removingClass, addingClass, 5).promise();
                promises.push(primaryPromise);

                var secondaryPromise = contentsToUpdateContainer.switchClass(removingClass, addingClass, 5).promise();
                promises.push(secondaryPromise);

                if (removingClass == "collapsed")
                {
                    massAssign.options.tableRow.removeClass(removingClass);
                }

                $.when.apply($, promises).done(function ()
                {
                    if (gradebook)
                    {
                        gradebook.unlockedRowHeader.removeClass(removingClass).addClass(addingClass);
                    }

                    massAssign.options.tableRow.addClass(addingClass);

                    if (gradebook)
                    {
                        gradebook.lockedRowHeader.height(gradebook.unlockedRowHeader.height());

                        gradebook.resize();
                    }
                    myDeferred.resolve();
                });
                return myDeferred.promise(); // return when all animations completed
            };
            return massAssign;
        };

        var getInputValue = function (input)
        {
            var value = "*";

            if (input.hasClass("codeEELCode"))
            {
                value = input.parent().siblings('.codeEELValue').val();
            }
            else if (input.hasClass("gradebookInputCodeEEL"))
            {
                value = skyward.gradebookcodeeel.getData(input).selectedValueID;
            }
            else if (input.is(':checkbox'))
            {
                value = input.is(":checked");
            }
            else if (input.is(':text') || input.hasClass('Score'))
            {
                value = input.val();
            }

            return value;
        };

        var getInputOriginalValue = function (input, retrieveDisplayValue)
        {
            var value;

            if (input.hasClass("codeEELCode"))
            {
                value = input.siblings(".codeEELValue").data("original-value") || "";
            }
            else if (input.hasClass("gradebookInputCodeEEL"))
            {
                if (retrieveDisplayValue == true)
                {
                    value = skyward.gradebookcodeeel.getOriginalValueData(input).originalDisplayValue;
                }
                else
                {
                    value = skyward.gradebookcodeeel.getOriginalValueData(input).originalSelectedValueID;
                }
            }
            else
            {
                if (input.hasClass("studentAssignment"))
                {
                    value = input.data("original-assignment-score");
                }
                else
                {
                    value = input.data("original-value");
                }
            }

            return value;
        };

        var shouldShowTransferIcon = function (affectedStudentAssignment)
        {
            return affectedStudentAssignment.isMissing || affectedStudentAssignment.noCount || affectedStudentAssignment.scoreClarifierId != null ||
                (affectedStudentAssignment.score != null && affectedStudentAssignment.score !== "" && affectedStudentAssignment.score !== "*") ||
                (affectedStudentAssignment.grademarkvalue != null && affectedStudentAssignment.grademarkvalue !== "" && affectedStudentAssignment.grademarkvalue !== "*") ||
                (affectedStudentAssignment.comments != null && affectedStudentAssignment.comments !== "");
        };

        var updateAssignmentIndicatorSvg = function (input, assignmentIndicatorSelector, hiddenSvgContainerSelector, fieldNameOverride, showOverride)
        {
            var inputData = input.data();
            var fieldType = input.attr("type");
            var fieldName = inputData.fieldname;
            if (fieldNameOverride)
            {
                fieldName = fieldNameOverride;
            }

            var show;
            if (showOverride != null)
            {
                show = showOverride;
            }
            else
            {
                if (fieldType == "text" || input.hasClass("Score"))
                {
                    var value = getInputValue(input);
                    show = value != null && value != "";
                }
                else if (fieldType == "checkbox")
                {
                    show = input.is(":checked");
                }
            }

            var classToUpdate;
            switch (fieldName)
            {
                case 'IsMissing':
                    classToUpdate = 'hiddenMissingScore';
                    break;
                case 'ScoreClarifierID':
                    classToUpdate = 'hiddenScoreClarifier';
                    break;
                case 'NoCount':
                    classToUpdate = 'hiddenNoCount';
                    break;
                case 'Comments':
                    classToUpdate = 'hiddenComment';
                    break;
                case 'DroppedAssignment':
                    classToUpdate = 'hiddenDroppedAssignment';
                    break;
                case 'TransferGrade':
                    classToUpdate = 'hiddenTransferGrade';
                    break;
                case 'MoreInfo':
                    classToUpdate = 'hiddenMoreInfo';
                    break;
                default:
                    classToUpdate = '';
                    break;
            }

            if (show)
            {
                var svgName;
                switch (fieldName)
                {
                    case 'IsMissing':
                        svgName = 'MissingScore';
                        break;
                    case 'ScoreClarifierID':
                        svgName = 'ScoreClarifier';
                        break;
                    case 'Comments':
                        svgName = 'Comment';
                        break;
                    case 'Score':
                        svgName = 'Warning';
                        if (parseFloat(inputData.originalAssignmentScore) <= parseFloat(inputData.maxscore))
                        {
                            return;
                        }
                        break;
                    default:
                        svgName = fieldName;
                        break;
                }

                addSVGToStudentAssignment(svgName, classToUpdate, assignmentIndicatorSelector, hiddenSvgContainerSelector);
            }
            else
            {
                removeSVGFromStudentAssignment(assignmentIndicatorSelector, classToUpdate);
            }
        };

        var addSVGToStudentAssignment = function (svgName, classToUpdate, assignmentIndicatorSelector, hiddenSvgContainerSelector)
        {
            var assignmentScoreCell = $(assignmentIndicatorSelector);
            if (assignmentScoreCell.length < 1)
            {
                return;
            }

            var assignmentIndicatorDiv = assignmentScoreCell.find('.assignmentIndicators');
            if (assignmentIndicatorDiv.length < 1)
            {
                return;
            }

            if (svgName == null)
            {
                return;
            }
            var safeSvgName = svgName.charAt(0).toLowerCase() + svgName.slice(1);

            if (assignmentIndicatorDiv.find("svg." + safeSvgName).length == 0)
            {
                var clone = $(hiddenSvgContainerSelector).find(".svg." + safeSvgName).first().clone();
                clone.removeClass("svgHidden");
                clone.appendTo(assignmentScoreCell.find(".assignmentIndicators.hidden" + svgName));
            }
            assignmentIndicatorDiv.removeClass(classToUpdate);
            updateStudentAssignmentButtonDisplay(assignmentScoreCell);
        };

        var removeSVGFromStudentAssignment = function (assignmentIndicatorSelector, classToUpdate)
        {
            var assignmentScoreCell = $(assignmentIndicatorSelector);
            if (assignmentScoreCell.length < 1)
            {
                return;
            }

            var assignmentIndicatorDiv = assignmentScoreCell.find('.assignmentIndicators');
            if (assignmentIndicatorDiv.length < 1)
            {
                return;
            }

            assignmentIndicatorDiv.addClass(classToUpdate);
            updateStudentAssignmentButtonDisplay(assignmentScoreCell);
        };

        var updateAssignmentIndicatorSvgSecondRow = function (input, options, assignmentIndicatorSelector)
        {
            options = options || {};

            var inputData = input.data();

            var assignmentScoreCell = $(assignmentIndicatorSelector);

            if (assignmentScoreCell.length < 1)
            {
                return;
            }

            var assignmentIndicatorSpan = assignmentScoreCell.find('.assignmentIndicatorsFirstRow');
            if (assignmentIndicatorSpan.length < 1)
            {
                return;
            }

            var fieldName = options.fieldnameOverride == null ? input.fieldname : options.fieldnameOverride;

            var classToUpdate;
            var show;
            switch (fieldName)
            {
                case 'Score':
                    classToUpdate = 'hiddenWarning';
                    show = parseFloat(inputData.originalAssignmentScore) > parseFloat(inputData.maxscore);
                    break;
                case 'IsDropped':
                    classToUpdate = 'hiddenDroppedAssignment';
                    show = options.isDropped;
                    break;
                default:
                    return;
            }

            if (options.overrideShow)
            {
                input.find('.assignmentIndicatorsFirstRow').addClass(classToUpdate);
            }

            if (show)
            {
                assignmentIndicatorSpan.removeClass(classToUpdate);
            }
            else
            {
                assignmentIndicatorSpan.addClass(classToUpdate);
            }

            updateStudentAssignmentButtonDisplay(assignmentScoreCell);
        };

        var updateAssignmentIndicatorsMobile = function ()
        {
            var assignmentManager = createAssignmentManager();

            var updateSvgsForInput = function (inputToUpdateSVGFor, fieldname)
            {
                assignmentManager.setOriginalStudentAssignmentValues(inputToUpdateSVGFor, getInputValue(inputToUpdateSVGFor));
                updateAssignmentIndicatorSvg(inputToUpdateSVGFor, inputToUpdateSVGFor.parents(".studentAssignmentMobileCard").find(".assignmentIndicatorButton").parent(), inputToUpdateSVGFor.parents(".dataObjectViewer"));
                updateAssignmentIndicatorSvgSecondRow(inputToUpdateSVGFor, { fieldnameOverride: fieldname, overrideShow: false }, inputToUpdateSVGFor.parents(".studentAssignmentMobileCard").find(".assignmentIndicatorButton").parent());
                assignmentManager.updateChangedClass(inputToUpdateSVGFor, false, {});
            };

            var input = $(this);

            var inputData = input.data();
            if (input.hasClass("quickEntryText"))
            {
                input = input.find("input.codeEELDescription");
                input.data("fieldname", inputData.fieldname);
            }
            else if (input.hasClass("Score"))
            {
                var maxScore = inputData.maxscore;

                mobileUpdateIsMissingValueAndCheckFailingScoreClarifier.apply(input, [inputData.assignmentid, inputData.studentsectionid, skyward.controls.getValue(input), maxScore, null]);
            }
            else if (input.hasClass("codeEEL"))
            {
                input = input.find("input.codeEELCode:not(.mobile-eel-placeholder)");
                input.data("fieldname", inputData.fieldname);

                var codeEEL = input.parents('div.codeEEL'); //todo: make gradebook codeeel after PR 2727610
                var codeEELData = codeEEL.data();
                var codeEELValue = skyward.controls.getValue(codeEEL);

                if (codeEELData.additionalFields && codeEELValue != "") //todo: make gradebook codeeel after PR 2727610
                {
                    if (codeEELData.fieldname == "Score")
                    {
                        mobileUpdateIsMissingValueAndCheckFailingScoreClarifier.apply(codeEEL, [codeEELData.assignmentid, codeEELData.studentsectionid, null, inputData.maxScore, codeEELData.additionalFields.DefaultCalculationPercent, codeEELValue]);
                    }
                    else
                    {
                        $.each(codeEELData.additionalFields, function (key, value)
                        {
                            if ((key === "IsMissing" || key === "NoCount") && !value)
                            {
                                return;
                            }
                            var inputToUpdate = codeEEL.parent().find("input[data-fieldname=" + key + "]");

                            if (inputToUpdate.length)
                            {
                                inputToUpdate.prop("checked", value);
                                updateSvgsForInput(inputToUpdate, key);
                            }
                        });
                    }
                }
            }

            updateSvgsForInput(input, inputData.fieldname);
        };

        var attemptsPopup = function (data, gradebook)
        {
            var isMobile = !gradebook;
            data.specificassignmentid = getRepresentedAssignmentID(data.assignmentid, data.sectionid);
            var saveButton =
            {
                text: "Save",
                "click": function ()
                {
                    var deferred = new $.Deferred;
                    var valuesToSave = [];
                    var counter = 0;

                    var popup = $(this).parents('.messageBox.skywardContentPanel');
                    var rows = popup.find('tr.childrecordquickentryrow:not(".removedElement")');
                    rows.each(function ()
                    {
                        var currentRow = $(this);

                        var valueToSaveForRow = [];
                        currentRow.find('td input:not(".codeEELValue")').each(function ()
                        {
                            var input = $(this)[0];
                            if (input.value != "" && input.value != null)
                            {
                                if (input.id.includes('GradeMarkID'))
                                {
                                    if ($(input).data('selectedValueID') != null && $(input).data('selectedValueID') != "")
                                    {
                                        valueToSaveForRow.push({ id: input.id, value: $(input).data('selectedValueID') });
                                    }
                                }
                                else if (input.id.includes('IsUsed'))
                                {
                                    valueToSaveForRow.push({ id: input.id, value: $(input).is(':checked') });
                                }
                                else
                                {
                                    valueToSaveForRow.push({ id: input.id, value: input.value });
                                }
                            }
                        });

                        if (valueToSaveForRow.length > 1 || (valueToSaveForRow.length == 1 && valueToSaveForRow[0].id.includes('IsUsed') && valueToSaveForRow[0].value == true))
                        {
                            valuesToSave.push(valueToSaveForRow);
                        }

                        if (++counter >= rows.length)
                        {
                            deferred.resolve();
                        }
                    });
                    $.when(deferred).done(function ()
                    {
                        $.ajax(
                            {
                                url: skyward.global.virtualDir + "Gradebook/StudentAssignment/StudentAssignmentAttemptPopupSave",
                                type: "POST",
                                dataType: "JSON",
                                data:
                                {
                                    valuesToSave: JSON.stringify(valuesToSave),
                                    studentSectionID: data.studentsectionid,
                                    assignmentID: data.specificassignmentid ? data.specificassignmentid : data.assignmentid,
                                    warninghash: popup.data('warninghash')
                                },
                                success: function (returnData)
                                {
                                    if (returnData.success == true)
                                    {
                                        var input = $('input.studentAssignment[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"], div.studentAssignment[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"]');
                                        var inputData = input.data();

                                        var inputCodeEEL = input.find('input.codeEELCode');
                                        if (inputCodeEEL.length > 0)
                                        {
                                            input = inputCodeEEL;
                                        }

                                        var inputHadMultipleAttempts = input.hasClass('hasAttempts');
                                        input.removeClass('hasAttempts');

                                        var label = $('a.attemptCount[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"] span.anchorText');
                                        if (returnData.totalAttemptCount > 0)
                                        {
                                            label.text(returnData.totalAttemptCount);
                                        }
                                        else if ((input.val() != null && input.val() != '' && input.val() != '*') || returnData.UpdatedScore != null || returnData.UpdatedGradeMark != null)
                                        {
                                            label.text(1);
                                        }

                                        var handleCodeEELInputs = function (input, idToSet, valueToSet)
                                        {
                                            var codeEEL = input.parents('.gradebookCodeEEL, .codeEEL');
                                            if (isMobile)
                                            {
                                                skyward.controls.setValue(input, valueToSet, true);
                                                var otherInput = codeEEL.find('input.codeEELValue');
                                                skyward.controls.setValue(otherInput, idToSet, true);
                                            }
                                            else
                                            {
                                                //Don't want to perform the normal save because we don't want undo/redo to be affected.
                                                skyward.controls.setValue(input, valueToSet, true);
                                                skyward.gradebookcodeeel.handleChangeNoSave(codeEEL, idToSet);
                                            }
                                        };

                                        if (returnData.UpdatedGradeMark != null && returnData.UpdatedGradingScaleGroupGradeMarkID != null)
                                        {
                                            handleCodeEELInputs(input, returnData.UpdatedGradingScaleGroupGradeMarkID, returnData.UpdatedGradeMark);
                                        }
                                        else if (returnData.UpdatedScore != null)
                                        {
                                            if (isMobile)
                                            {
                                                skyward.controls.setValue(input, returnData.UpdatedScore, true);
                                            }
                                            else
                                            {
                                                skyward.controls.setValue(input, returnData.UpdatedScore);
                                            }
                                        }
                                        else
                                        {
                                            skyward.controls.setValue(input, '');
                                        }

                                        var inputValue = input.val();

                                        var deferred = $.Deferred();
                                        if (inputData.displayValue != inputValue && !isNaN(returnData.UpdatedScore) && inputValue != "")
                                        {
                                            if (!isMobile)
                                            {
                                                deferred = gradebook.updateIsMissingValueAndCheckFailingScoreClarifier(data.assignmentid, data.studentsectionid, returnData.UpdatedScore);
                                            }
                                            else
                                            {
                                                deferred = mobileUpdateIsMissingValueAndCheckFailingScoreClarifier.apply(input, [data.assignmentid, data.studentsectionid, returnData.UpdatedScore, inputData.maxScore]);
                                            }
                                        }
                                        else
                                        {
                                            deferred.resolve();
                                        }

                                        $.when(deferred).done(function ()
                                        {
                                            if (inputValue == "" || inputValue == ".")
                                            {
                                                skyward.controls.setValue(input, '*');
                                            }

                                            input.data('studentAssignmentScore', inputValue);
                                            input.data('displayValue', inputValue);

                                            var unbreakableGlass = skyward.modalLayer.newModalLayer(null, null,
                                                {
                                                    closeOnClick: false,
                                                    closeOnRecordSelected: false,
                                                    closeOnEscape: false,
                                                    transparentGlass: true
                                                });

                                            var advancedAssignmentInputs = $('input.scoreClarifier[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"], input.checkbox[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"]');

                                            var inScoringMode = isInScoringMode();
                                            if (inScoringMode == false && !isMobile)
                                            {
                                                gradebook.updateEditModeNoDialog(true, input);
                                                gradebook.enableControl(advancedAssignmentInputs);
                                            }
                                            else if (inputHadMultipleAttempts == true && !isMobile)
                                            {
                                                gradebook.enableControl(input);
                                            }

                                            var saveData =
                                            {
                                                assignmentId: data.assignmentid,
                                                studentSectionId: data.studentsectionid,
                                                studentAssignmentId: inputData.studentassignmentid,
                                                isAvailable: inputData.isAvailable,
                                                sectionId: getSectionIDFromCell(input),
                                                Score: inputValue,
                                                displayValue: inputValue
                                            };

                                            var performGradesheetUpdateAndSave = function (gradebook, saveData)
                                            {
                                                var deferred = new $.Deferred();

                                                var valueToSave = gradebook.saveManager.assignmentManager.getChangedValues(saveData);
                                                if (valueToSave.length > 0)
                                                {
                                                    var data = $.extend({}, valueToSave[0]);
                                                    delete data.originalValues;
                                                    delete data.hasChanges;

                                                    data.ForceRecalculation = true;
                                                    data.SkipGradesheetResultValueChangeCheck = true;

                                                    var promise = gradebook.saveManager.saveManager.save(data, "Gradebook/Gradebook/UpdateGradeSheetData");
                                                    gradebook.saveManager.assignmentManager.setValues(data, false);
                                                    $.when(promise).then(function (response)
                                                    {
                                                        setSaveResponseOriginalValues(response, valueToSave);
                                                        if (gradebook)
                                                        {
                                                            checkAjaxResponseForErrors(response, gradebook.saveManager.assignmentManager.handleSaveResponse, [false, response, gradebook, response.objectsToUpdate]);
                                                        }
                                                        else if (response && response.success == false)
                                                        {
                                                            skyward.modalLayer.showReloadDialog(ALERT_HEADER, response.popupHTML.Content);
                                                        }
                                                        else
                                                        {
                                                            gradebook.saveManager.assignmentManager.handleSaveResponse(false, response, gradebook, response.objectsToUpdate);
                                                        }
                                                        deferred.resolve();
                                                    });
                                                }
                                                else
                                                {
                                                    deferred.resolve();
                                                }

                                                return deferred;
                                            };

                                            var svgName = 'MultipleAttempts';
                                            var classToUpdate = 'hiddenMultipleAttempts';

                                            if (!isMobile)
                                            {
                                                $.when(performGradesheetUpdateAndSave(gradebook, saveData)).done(function ()
                                                {
                                                    if (inScoringMode == false)
                                                    {
                                                        gradebook.updateEditModeNoDialog(false, input);
                                                        gradebook.disableControl(advancedAssignmentInputs);
                                                    }
                                                    var assignmentIndicatorSelector = "#" + BROWSE_NAME + "_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_" + "Score";
                                                    var hiddenSvgContainerSelector = "#" + BROWSE_NAME;

                                                    if (returnData.totalAttemptCount > 1)
                                                    {
                                                        input.addClass('hasAttempts');
                                                        gradebook.disableControl(input);
                                                        addSVGToStudentAssignment(svgName, classToUpdate, assignmentIndicatorSelector, hiddenSvgContainerSelector);
                                                    }
                                                    else
                                                    {
                                                        if (isInScoringMode == true)
                                                        {
                                                            gradebook.enableControl(input);
                                                        }
                                                        removeSVGFromStudentAssignment(assignmentIndicatorSelector, classToUpdate);
                                                    }
                                                    unbreakableGlass.close();
                                                    dialog.close();
                                                });
                                            }
                                            else
                                            {
                                                var assignmentIndicatorSelector = ".fieldWrapper.studentAssignmentScore[data-assignmentid='" + inputData.assignmentid + "'][data-studentsectionid='" + inputData.studentsectionid + "']";
                                                var hiddenSvgContainerSelector = "#editStudentAssignments";
                                                var inputElement = input.length > 0 ? input[0] : null;
                                                if (returnData.totalAttemptCount > 1)
                                                {
                                                    input.addClass('hasAttempts');
                                                    inputElement.disabled = true;
                                                    inputElement.readOnly = true;

                                                    var gradeMarkScoringEEL = input.parents('div.gradeMarkScoring');
                                                    if (gradeMarkScoringEEL.length > 0)
                                                    {
                                                        var button = input.siblings('a');
                                                        if (button.length > 0)
                                                        {
                                                            button.addClass('ui-disabled');
                                                        }

                                                        var innerCodeEELDiv = input.parent();
                                                        if (innerCodeEELDiv.length > 0)
                                                        {
                                                            innerCodeEELDiv.addClass('readonly');
                                                        }
                                                    }

                                                    addSVGToStudentAssignment(svgName, classToUpdate, assignmentIndicatorSelector, hiddenSvgContainerSelector);
                                                }
                                                else
                                                {
                                                    inputElement.disabled = false;
                                                    inputElement.readOnly = false;

                                                    var gradeMarkScoringEEL = input.parents('div.gradeMarkScoring');
                                                    if (gradeMarkScoringEEL.length > 0)
                                                    {
                                                        var button = input.siblings('a');
                                                        if (button.length > 0)
                                                        {
                                                            button.removeClass('ui-disabled');
                                                        }

                                                        var innerCodeEELDiv = input.parent();
                                                        if (innerCodeEELDiv.length > 0)
                                                        {
                                                            innerCodeEELDiv.removeClass('readonly');
                                                        }
                                                    }

                                                    removeSVGFromStudentAssignment(assignmentIndicatorSelector, classToUpdate);
                                                }
                                                unbreakableGlass.close();
                                                dialog.close();
                                            }
                                        });
                                    }
                                    else
                                    {
                                        var baseErrorContainer = dialog.container.find('#CurrentRecordContentBaseError');
                                        skyward.validation.displayValidationMessages(returnData, dialog.container, baseErrorContainer);
                                    }
                                }
                            });
                    });
                },
                "icon": "Save",
                "data": data
            };

            var cancelButton =
            {
                text: "Cancel",
                "click": function () { dialog.close(); },
                "icon": "Cancel"
            };

            var options =
            {
                closeOnEscape: true,
                draggable: false
            };

            var buildPopup = function ()
            {
                var localGradebookData = $('#' + BROWSE_NAME).data();

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + "Gradebook/StudentAssignment/StudentAssignmentAttemptPopup" + (localGradebookData != null && localGradebookData.isTeacherTracker ? "TeacherTracker" : ""),
                        type: "POST",
                        converters:
                        {
                            'HTML updatedHTML': function (returnData)
                            {
                                const html = $(returnData);
                                const attemptNumberLabels = html.find(".attemptNumberLabel");
                                for (let counter = 1; counter <= attemptNumberLabels.length; counter++)
                                {
                                    const currentLabel = attemptNumberLabels[counter - 1];
                                    currentLabel.textContent = counter;
                                }

                                return html.html();
                            }
                        },
                        dataType: "updatedHTML",
                        data: data,
                        success: function (returnData)
                        {
                            if (returnData == null || returnData == "")
                            {
                                dialog.close();
                            }
                            else if (returnData.includes('AttemptsPopupChildRecordQuickEntryIsDisabled') && returnData.split('AttemptsPopupChildRecordQuickEntryIsDisabled')[1].startsWith('="True"'))
                            {
                                dialog.container.find('button[title="Save"]').remove();
                            }
                        }
                    }).promise();
            };

            var dialog = skyward.modalLayer.showDialog('Attempts', buildPopup, [saveButton, cancelButton], options);

            dialog.content.on('change', 'input[id^="DateAttempted-"]', function (event, clearedRow)
            {
                var defaultAttemptType = dialog.content.find('div.childrecordquickentry').data('defaultattempttype');
                if (defaultAttemptType == 'R')
                {
                    SelectAttemptByDateAttempted();
                }
            });

            dialog.content.on('change', 'input[id^="Score-"]', function (event, clearedRow)
            {
                var input = $(this);
                HandleScoreChanged(input);
            });

            dialog.content.on("keyup", ".codeEEL.quickEntryText", function () { markCommentQuickEntryAsValid($(this)) });

            dialog.content.on('childrecordquickentry-row-added', function (event)
            {
                var popup = $(this);
                HandleAttemptCount(popup, null, false);

                var gradeMarkCodeEEL = popup.find('.gradebookInputCodeEEL:last').parents('.gradebookCodeEEL');
                if (gradeMarkCodeEEL.length > 0)
                {
                    skyward.gradebookcodeeel.registerCodeEEL(gradeMarkCodeEEL);
                }

                var checkbox = $("input.checkbox[id^='IsUsed-']:last");
                $("input.masked[id^='Score-']:last").data("originalValue", "");
                checkbox.click();
            });

            dialog.content.on('childrecordquickentry-row-cleared', function (event, clearedRow, isRowBeingRemoved)
            {
                var popup = $(this);
                HandleAttemptCount(popup, clearedRow, isRowBeingRemoved);

                var clearedRowCheckbox = clearedRow.find('input.checkbox[id^="IsUsed-"]');
                if (clearedRowCheckbox.is(':checked'))
                {
                    SelectAttempt(clearedRow, popup);
                }
            });

            dialog.content.on('childrecordquickentry-row-removed', function (event, clearedRow)
            {
                var popup = $(this);
                HandleAttemptCount(popup, clearedRow, true);

                var clearedRowCheckbox = clearedRow.find('input.checkbox[id^="IsUsed-"]');
                if (clearedRowCheckbox.is(':checked'))
                {
                    SelectAttempt(clearedRow, popup);
                }
            });

            dialog.content.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL", function (event, returnData)
            {
                var input = $(this);
                $.when(gradeMarkScoringEelComplete(event, returnData, gradebook, input)).done(function ()
                {
                    HandleScoreChanged(input);
                });
                input.data('selectedValueID', returnData.gradeMarkID);
            });

            dialog.content.on("gradebookInputCodeEELInvalid", ".gradebookInputCodeEEL", gradeMarkScoringEelFailed);

            dialog.content.on("click", "input.checkbox[id^='IsUsed-']", function ()
            {
                var input = $(this);
                var allCheckboxes = $("input.checkbox[id^='IsUsed-']");
                allCheckboxes.each(function ()
                {
                    var checkbox = $(this);
                    if (!checkbox.is(input))
                    {
                        skyward.controls.setValue(checkbox, false);
                    }
                    else
                    {
                        skyward.controls.setValue(checkbox, true);
                    }
                });
            });

            function HandleScoreChanged(input)
            {
                var defaultAttemptType = dialog.content.find('div.childrecordquickentry').data('defaultattempttype');
                var datePicker = input.parents('tr.childrecordquickentryrow').find('input[id^="DateAttempted-"]');
                var pickedDate = datePicker.val();
                if (pickedDate == '' || pickedDate == null)
                {
                    skyward.controls.setValue(datePicker, skyward.time.now());
                }

                var inputValue = input.val();
                if (inputValue == "" || inputValue == ".")
                {
                    skyward.controls.setValue(input, getInputOriginalValue(input), true);
                }

                if (defaultAttemptType == 'S')
                {
                    SelectAttemptByScore();
                }
            }

            function SelectAttempt(clearedRow, popup)
            {
                var defaultAttemptType = popup.find('div.childrecordquickentry').data('defaultattempttype');

                if (defaultAttemptType == 'S')
                {
                    SelectAttemptByScore(clearedRow);
                }
                else if (defaultAttemptType == 'R')
                {
                    SelectAttemptByDateAttempted(clearedRow);
                }
                else
                {
                    var lastRow = $("tr.childrecordquickentryrow:visible:last");
                    var checkbox = lastRow.find("input.checkbox[id^='IsUsed-']:last");
                    if (lastRow.is(clearedRow))
                    {
                        checkbox = lastRow.siblings(':not(".removedElement"):visible').last().find('input.checkbox[id^="IsUsed-"]');
                    }
                    checkbox.click();
                }
            }

            function SelectAttemptByScore(clearedRow)
            {
                var rows = $("tr.childrecordquickentryrow:visible");
                var rowToUse;
                for (var i = 0; i < rows.length; i++)
                {
                    var currentRow = $(rows[i]);

                    if (currentRow.hasClass('removedElement'))
                    {
                        continue;
                    }
                    rowToUse = rowToUse || currentRow;

                    var useGradeMarkScoring = false;

                    var oldTop = rowToUse.find("input[id^='Score-']:last");
                    if (oldTop.length < 1)
                    {
                        oldTop = rowToUse.find('input[id^="GradeMarkID-"]:last');
                        useGradeMarkScoring = true;
                    }

                    var current = currentRow.find("input[id^='Score-']:last");
                    if (current.length < 1)
                    {
                        current = currentRow.find('input[id^="GradeMarkID-"]:last');
                        useGradeMarkScoring = true;
                    }

                    if ((useGradeMarkScoring == false && Number(current.val()) >= Number(oldTop.val()) && !currentRow.is(clearedRow)) ||
                        (useGradeMarkScoring == true && current.val() && current.val() != '' && Number(current.data('backingPercent')) >= Number(oldTop.data('backingPercent'))))
                    {
                        rowToUse = currentRow;
                    }
                }
                var checkbox = rowToUse.find("input.checkbox[id^='IsUsed-']:last");
                checkbox.click();
            }

            function SelectAttemptByDateAttempted(clearedRow)
            {
                var rows = $("tr.childrecordquickentryrow:visible");
                var rowToUse;
                for (var i = 0; i < rows.length; i++)
                {
                    var currentRow = $(rows[i]);
                    rowToUse = rowToUse || currentRow;

                    var current = skyward.time.parseDate(currentRow.find("input[id^='DateAttempted-']:last").val().split(' ')[0]);
                    var oldTop = skyward.time.parseDate(rowToUse.find("input[id^='DateAttempted-']:last").val().split(' ')[0]);
                    if (current instanceof Date && oldTop instanceof Date && current >= oldTop && !currentRow.is(clearedRow))
                    {
                        rowToUse = $(currentRow);
                    }
                }
                var checkbox = rowToUse.find("input.checkbox[id^='IsUsed-']:last");
                checkbox.click();
            }

            function HandleAttemptCount(popup, clearedRow, isRowBeingRemoved)
            {
                var rows = popup.find('tr[id*="-studentassignmentattempt-studentassignmentid-"]:not(".removedElement"):not(":hidden")');
                var counter = 0;

                rows.each(function ()
                {
                    var row = $(this);
                    if (clearedRow && clearedRow.is(row) && isRowBeingRemoved == true)
                    {
                        return;
                    }
                    var attemptCountLabel = row.find('.attemptsPopupAttemptNumber .attemptNumberLabel');
                    attemptCountLabel.text(++counter);
                });
            }
        };

        var setSaveResponseOriginalValues = function (response, valuesToSave)
        {
            if (!response || !response.objectsToUpdate || !valuesToSave)
            {
                return;
            }

            for (var i = 0; i < response.objectsToUpdate.length; i++)
            {
                var updateObject = response.objectsToUpdate[i];

                for (var i = 0; i < valuesToSave.length; i++)
                {
                    if (valuesToSave[i].saveManagerId === updateObject.saveManagerId)
                    {
                        updateObject.originalValues = valuesToSave[i].originalValues;
                        break;
                    }
                }
            }
        };

        var updateStudentGradeBucketCellClasses = function (inputElement, element, bucketData)
        {
            var indicatorSpan = '.studentGradeBucketIndicators';
            var gradeBucketScoreSpan = element.find(".gradeBucketScoreSpan");

            if (bucketData.IsOverMaxExtraCredit)
            {
                gradeBucketScoreSpan.removeClass("updated").addClass("updatedOverMaxExtraCredit");
                element.data("pointsOverMaxExtraCredit", bucketData.PointsOverMaxExtraCredit);
                setWarningIconClass(element, indicatorSpan, true);
            }
            else
            {
                gradeBucketScoreSpan.removeClass('updatedOverMaxExtraCredit').addClass("updated");
                setWarningIconClass(element, indicatorSpan, false);
            }

            if (bucketData.HasClosedGradingPeriodGradeChangeRequestInProgress)
            {
                if (!element.hasClass("gradeBucketGradeChangeNotReviewedOrInProgress"))
                {
                    element.addClass("gradeBucketGradeChangeNotReviewedOrInProgress");
                }
            }
            else if (element.hasClass("gradeBucketGradeChangeNotReviewedOrInProgress"))
            {
                element.removeClass("gradeBucketGradeChangeNotReviewedOrInProgress");
            }

            gradeBucketScoreSpan.removeClass('boldFont');
            if (bucketData.IsGradeModified || bucketData.IsLessThanMinimumPercent)
            {
                gradeBucketScoreSpan.addClass('boldFont');
            }

            HandleTransferBuckets(element, bucketData);

            setInfoIconClass(element, indicatorSpan, bucketData.HasUnscoredRequiredFeederBucket, bucketData.IsAdminOverride);
        };

        var HandleTransferBuckets = function (element, bucketData)
        {
            if (bucketData.IsTransferBucket == true)
            {
                if (element.hasClass('needsTransferRunProcess') && bucketData.GradeMarkID != null)
                {
                    element.find(".scoreDiv").removeClass("displayNone");
                    element.removeClass("needsTransferRunProcess");
                    element.find(".runTransferProcess").addClass("displayNone");
                    element.attr("data-click-action", element.data().originalClickAction);
                }
                else if (!element.hasClass('needsTransferRunProcess') && bucketData.GradeMarkID == null)
                {
                    element.find(".scoreDiv").addClass("displayNone");
                    element.addClass("needsTransferRunProcess");
                    element.find(".runTransferProcess").removeClass("displayNone");
                    element.removeAttr("data-click-action");
                }
            }
        };

        var setInfoIconClass = function (element, span, hasUnscoredRequiredFeederBucket, isAdminOverride)
        {
            var indicatorSpan = element.find(span);

            if (indicatorSpan.length < 1)
            {
                return;
            }
            if (hasUnscoredRequiredFeederBucket || isAdminOverride)
            {
                indicatorSpan.find('.studentGradeBucketIsAdminOverrideButton').data('hasUnscoredRequiredFeederBucket', hasUnscoredRequiredFeederBucket);
                indicatorSpan.removeClass('hiddenIsAdminOverride');
            }
            else
            {
                indicatorSpan.addClass('hiddenIsAdminOverride');
            }
        };

        var setWarningIconClass = function (element, span, show)
        {
            var indicatorSpan = element.find(span);

            if (indicatorSpan.length < 1)
            {
                return;
            }
            show ? indicatorSpan.removeClass('hiddenWarning') : indicatorSpan.addClass('hiddenWarning');
        };

        var removeCellErrorClasses = function (element, additionalClassesToRemove)
        {
            element.removeClass("updatedWithErrors hasErrors");
            if (additionalClassesToRemove)
            {
                element.removeClass(additionalClassesToRemove);
            }
        };

        var checkAjaxResponseForErrors = function (response, callback, callbackParams, thisElement) //callbackParams and thisElement is optional
        {
            if (response && response.success == false && response.popupHTML && response.popupHTML.Content)
            {
                skyward.modalLayer.showReloadDialog(ALERT_HEADER, response.popupHTML.Content);
            }
            else if (callback instanceof Function)
            {
                if (callbackParams == null)
                {
                    callbackParams = [];
                    callbackParams.push(response);
                }
                callback.apply(thisElement, callbackParams);
            }
        }

        var addCellErrorClasses = function (element)
        {
            element.css({ backgroundColor: '', color: '' });
            element.addClass('hasErrors');
        };

        var initMassDeleteTeacherOverridesTempSectionsBrowse = function ()
        {
            var browse = $(this);

            var updateSettingBrowse = function ()
            {
                var currentRow = browse.find(".current");
                var noteColumn = currentRow.find("td[data-note]");
                var value = "";
                if (noteColumn && noteColumn.length > 0)
                {
                    value = noteColumn.data().note;
                }

                var hideAssignmentsBrowse = true;
                var hideGradeBucketsBrowse = true;
                if (value == "Assignment")
                {
                    hideAssignmentsBrowse = false;
                    browse.parents('.threeBrowses').removeClass('threeBrowses').addClass('twoBrowses');
                }
                else if (value == "Grade Bucket")
                {
                    hideGradeBucketsBrowse = false;
                    browse.parents('.twoBrowses').removeClass('twoBrowses').addClass('threeBrowses');
                }

                if (hideAssignmentsBrowse)
                {
                    $("#TempSectionAssignments").hide();
                    $("#TempAssignmentErrors").hide();
                }
                else
                {
                    $("#TempSectionAssignments").show();
                    $("#TempAssignmentErrors").show();

                    $("#TempSectionAssignments").parents('.threeBrowses').removeClass('threeBrowses').addClass('twoBrowses');
                }

                if (hideGradeBucketsBrowse)
                {
                    $("#TempSectionGradeBuckets").hide();
                }
                else
                {
                    $("#TempSectionGradeBuckets").show();

                    $("#TempSectionGradeBuckets").parents('.twoBrowses').removeClass('twoBrowses').addClass('threeBrowses');
                }
            };

            browse.on("rowChanged", function ()
            {
                updateSettingBrowse();
            });

            browse.on("browseLoaded." + browse.attr("id"), function () { updateSettingBrowse(); });
        }

        var events =
        {
            'redirectToSpecificGradeBucket': skyward.gradebook.redirectToSpecificGradeBucket,
            'redirectToSpecificGradeBucketSubject': skyward.gradebook.redirectToSpecificGradeBucketSubject,
            'redirectToSpecificGradeBucketAcademicStandard': skyward.gradebook.redirectToSpecificGradeBucketAcademicStandard,
            'completedGradingPeriod': completedGradingPeriod,
            'gradingPeriodUnlocked': gradingPeriodUnlocked,
            'studentGradeBucketIsAdminOverride': studentGradeBucketIsAdminOverride,
            'studentGradeBucketHasTransferGrade': studentGradeBucketHasTransferGrade,
            'unscoredPastDueAssignments': unscoredPastDueAssignments,
            'roundedAdjustedWeightFormula': roundedAdjustedWeightFormula,
            'showGradebookLoadTimes': showGradebookLoadTimes,
            'viewStudentSchedule': viewStudentSchedule,
            'copyMatchingTransferAssignments': copyMatchingTransferAssignments,
            'clearTransferValues': clearTransferValues,
            'copyMatchingTransferClosedBuckets': copyMatchingTransferClosedBuckets,
            'copyMatchingTransferSubjectStandards': copyMatchingTransferSubjectStandards,
            'copyMatchingOutOfDistrictTransferClosedBuckets': copyMatchingOutOfDistrictTransferClosedBuckets,
            'copyMatchingTransferClosedGradeCategories': copyMatchingTransferClosedGradeCategories,
            'progressReportSubHeaderPopup': progressReportSubHeaderPopup,
            'redirectToAssignment': skyward.gradebook.redirectToAssignment,
            'updateClosedGradingPeriodGradeChange': updateClosedGradingPeriodGradeChange,
            'assignmentIndicatorPopup': assignmentIndicatorPopup,
            'massAssignScoresPopupMobile': massAssignScoresPopupMobile,
            'updateAssignmentIndicatorsMobile': updateAssignmentIndicatorsMobile,
            'mobileAssignmentHeaderIndicatorsPopup': mobileAssignmentHeaderIndicatorsPopup,
            'initMassDeleteTeacherOverridesTempSectionsBrowse': initMassDeleteTeacherOverridesTempSectionsBrowse
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.window.registerLoadDOMCallback(initProgressReportSelector);
        skyward.window.registerLayoutResizeCallback(resizeLockedBrowseBodyForHorizontalScrollBar);
        skyward.events.registerEvents('gradebook', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.benchmarking = skyward.benchmarking || {};

        const benchmarkingActionNames =
        {
            delay: "Delay",
            dismiss: "Dismiss",
        };
        Object.freeze(benchmarkingActionNames);

        function setupTakeSurveyButton()
        {
            const takeSurveyButton = $(this);

            takeSurveyButton.one("workflowEnd", function ()
            {
                const container = takeSurveyButton.closest("#moduleContent");
                showCompleteConfirmation(container);
            });
        }

        function closeClick()
        {
            const closeButton = $(this);
            const container = closeButton.closest("#moduleContent");
            const benchmarkingSurveyId = closeButton.data("benchmarkingSurveyId");

            const dismissMenuItems = [{ type: "title", text: "Dismiss Options" }];

            dismissMenuItems.push(
            {
                text: "Remind Me Later",
                icon: "Time",
                click: callPostponeControllerActionLocal(benchmarkingActionNames.delay, "We will remind you again tomorrow.")
            });

            dismissMenuItems.push(
            {
                text: "Dismiss This Survey",
                icon: "Close",
                click: callPostponeControllerActionLocal(benchmarkingActionNames.dismiss, "Survey Dismissed.")
            });

            skyward.modalLayer.showMenu(dismissMenuItems, closeButton, {});

            function callPostponeControllerActionLocal(action, message)
            {
                return function ()
                {
                    callPostponeControllerAction(action, benchmarkingSurveyId, onPostponeSuccess);
                };

                function onPostponeSuccess(data)
                {
                    if (data.success)
                    {
                        closeButton.hide();

                        const cma = skyward.contentMessageArea.getContentMessageArea(container);
                        cma.setInformationMessage(message);
                        window.setTimeout(function ()
                        {
                            cma.hideInformation(true);
                            window.setTimeout(function ()
                            {
                                movePseudoContentArea(container);
                            }, 400);
                        }, 3000);
                    }
                }
            }
        }

        function callPostponeControllerAction(action, benchmarkingSurveyId, successCallback)
        {
            return $.ajax(skyward.global.virtualDir + "SkySys/BenchmarkingSurvey/" + action,
            {
                type: "POST",
                dataType: "JSON",
                activityIndicator: { hideGlass: true },
                data: { benchmarkingSurveyId: benchmarkingSurveyId },
                success: successCallback
            });
        }

        function showCompleteConfirmation(container)
        {
            const cma = skyward.contentMessageArea.getContentMessageArea(container);
            cma.hideInformation();

            const cmaElement = cma.getContentMessageAreaElement();
            const confirmationMessageElement = cmaElement.find(".cmaConfirmationMessage");

            // TODO: [4230468] This is a hack until the functionality of the CMA is more fleshed out with PR 4230468.
            confirmationMessageElement.removeClass("cmaHidden");
            cmaElement.one("CMAConfirmationHidden", function ()
            {
                confirmationMessageElement.addClass("cmaHidden");
                movePseudoContentArea(container);
            });

            cma.showConfirmation();
        }

        // TODO: Remove pseudoContentArea-benchmarking [4254690]
        function movePseudoContentArea(container)
        {
            const pseudoContentAreaClass = "pseudoContentArea--benchmarking";
            container.find(pseudoContentAreaClass.dot()).removeClass(pseudoContentAreaClass);
        }

        const events =
        {
            "setupTakeSurveyButton": setupTakeSurveyButton,
            "closeClick": closeClick
        };

        skyward.events.registerEvents("benchmarking", events);

        skyward.benchmarking.showWorkflowSurvey = function (benchmarkingData, afterSurveyCallback)
        {
            const buttonText = $("<span>", { addClass: "anchorText textBefore svgGroup fromSVG buttonText", text: "Take Survey" });
            const arrowSvg = skyward.svg.getSvg("ArrowTriangleRight");
            arrowSvg.addClass("svgNoHover svgTextBefore buttonSvg svgGroup svgContentMessageArea");

            const buttonTextElement = $("<p>", { addClass: "button cmaMessage__button svgAnchor", id: "modalTakeSurveyButton" });
            buttonTextElement.attr("href", "javascript: void (0)");
            buttonTextElement.append(buttonText);
            buttonTextElement.append(arrowSvg);

            const button = $("<div>");
            button.css({ "padding-top": "15px", "margin-left": "-1rem" });
            button.append(buttonTextElement).click(function () { launchSurveyWorkflow(); });

            const text = benchmarkingData.MessageOverride || `Let Skyward know how your experience was using the "${benchmarkingData.WorkflowDescription}" workflow.`;
            const messageText = $("<p>", { text: text });

            const messageDiv = $("<div>");
            messageDiv.append(messageText);
            messageDiv.append(button);

            const contents = messageDiv;
            const closeButton = {
                text: "Dismiss Survey",
                click: function () { postponeSurveyLocal(benchmarkingActionNames.dismiss); },
                icon: "Close"
            };
            const delayButton = {
                text: "Remind Me Later",
                click: function () { postponeSurveyLocal(benchmarkingActionNames.delay); },
                icon: "Time"
            };

            const dialog = skyward.modalLayer.showDialog("Skyward Feedback Survey", contents, [delayButton, closeButton], { closeOnClick: false, closeOnEscape: false });

            function postponeSurveyLocal(action)
            {
                dialog.close();
                callPostponeControllerAction(action, benchmarkingData.BenchmarkingSurveyID, null);
                afterSurveyCallback();
            }

            function launchSurveyWorkflow()
            {
                const workflowSurveyComplete = "WorkflowCompleted.SkySys.BenchmarkingSurveyInstance.TakeSurvey";
                const workflowSurveyCancelled = "WorkflowCancelled.SkySys.BenchmarkingSurveyInstance.TakeSurvey";

                const currentUserID = benchmarkingData.CurrentUserID;
                const benchmarkingSurveyID_securityhash = benchmarkingData.BenchmarkingSurveyID_securityhash;
                const benchmarkingSurveyID = benchmarkingData.BenchmarkingSurveyID;
                const userIDOwner_securityhash = benchmarkingData.UserIDOwner_securityhash;

                const doc = $(document);
                doc.one(workflowSurveyComplete, onSurveyFinish)
                doc.one(workflowSurveyCancelled, onSurveyFinish);

                skyward.window.checkLoadContent("popup", "Workflow", "WorkflowInstance", "Create/SkySys/BenchmarkingSurveyInstance/TakeSurvey", null,
                {
                    "Workflow.BenchmarkingSurveyInstance.BenchmarkingSurveyID": benchmarkingSurveyID,
                    "Workflow.BenchmarkingSurveyInstance.UserIDOwner": currentUserID,
                    "Workflow.BenchmarkingSurveyInstance.BenchmarkingSurveyID_securityhash": benchmarkingSurveyID_securityhash,
                    "Workflow.BenchmarkingSurveyInstance.UserIDOwner_securityhash": userIDOwner_securityhash
                }, null, null, null, false, null, null, null);

                function onSurveyFinish()
                {
                    doc.off(workflowSurveyComplete);
                    doc.off(workflowSurveyCancelled);

                    afterSurveyCallback();
                }
            }
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path=skyward.ui.userpreference.js"/>
/// <reference path="skyward.ui.modallayer.js"/>
(
    function (skyward, $, undefined)
    {
        skyward.headerMenus = skyward.headerMenus || {};

        function myAccountPopupBuilder()
        {
            var button = $(this);
            var data = button.data();

            var menuItems = [{ type: "title", text: "My Options" }];

            if (data.changeMyPasswordIconCode)
            {
                menuItems.push(getMenuItem("Change Password",
                {
                    icon: data.changeMyPasswordIconCode,
                    target: "popup",
                    click: buildLoadContentClickFunction("popup", "Workflow", "WorkflowInstance", "Create/Security/User/ChangeMyPassword",
                        {
                            data:
                                {
                                    "Workflow.UserID": data.changeMyPasswordUserId,
                                    "Workflow.UserID_securityhash": data.changeMyPasswordUserId_securityhash
                                }
                        })
                }));
            }

            if (data.changeUsernameIconCode)
            {
                menuItems.push(getMenuItem("Change Username",
                {
                    icon: data.changeMyPasswordIconCode,
                    target: "popup",
                    click: buildLoadContentClickFunction("popup", "Workflow", "WorkflowInstance", "Create/Security/User/ChangeUsername",
                        {
                            data:
                                {
                                    "Workflow.UserID": data.changeUsernameUserId,
                                    "Workflow.UserID_securityhash": data.changeUsernameUserId_securityhash
                                }
                        })
                }));
            }

            if (data.impersonateUser)
            {
                menuItems.push(getMenuItem("Impersonate User",
                {
                    icon: data.impersonateUserIconCode,
                    click: buildLoadContentClickFunction("full", "Security", "User", "ImpersonateUser", { data: { "tab": data.impersonateUserTab } })
                }));
            }
            else if (data.stopUserImpersonation)
            {
                menuItems.push(getMenuItem("Stop User Impersonation",
                {
                    icon: data.stopUserImpersonationIconCode,
                    target: "popout",
                    click: buildLoadContentClickFunction("full", "Security", "User", "StopImpersonation")
                }));
            }

            // Once Facebook and Google logins are fixed, uncomment this:
            //if (data.linkedAccounts)
            //{
            //    menuItems.push(getMenuItem("Linked Accounts",
            //    {
            //        icon: data.linkedAccountsIconCode,
            //        click: buildLoadContentClickFunction("full", "Security", "User", "LinkedAccounts")
            //    }));
            //}

            if (data.themeSelectorIconCode && (!skyward.global.isIosApp && !skyward.global.isAndroidApp))
            {
                menuItems.push(getMenuItem("Themes",
                    {
                        icon: data.themeSelectorIconCode,
                        id: "themeSelector",
                        click: async function () { await skyward.themeSelector.build(this); },
                        role: "button",
                        hasPopup: "dialog",
                }));
            }

            if (data.userPreferencesIconCode && (!skyward.global.isIosApp && !skyward.global.isAndroidApp))
            {
                menuItems.push(getMenuItem("User Preferences",
                {
                    icon: data.userPreferencesIconCode,
                    id: data.userPreferencesPrimaryKeyValue,
                    click: buildLoadContentClickFunction("full", "Security", "UserPreference", "Details", { id: data.userPreferencesPrimaryKeyValue })
                }));
            }

            if ((skyward.global.isInHouse && skyward.global.isRealSuperUser) || skyward.global.isRealSupportAccount)
            {
                menuItems.push(getMenuItem("Support Tools",
                {
                    icon: "Build",
                    id: "supportTools",
                    click: function () { skyward.support.build(); },
                    role: "button",
                    hasPopup: "dialog"
                }));
            }

            skyward.modalLayer.showMenu(menuItems, "#" + button.attr('id'), {});
        }

        function knowledgeHubPopupBuilder()
        {
            var button = $(this);
            var data = button.data();

            var menuItems = [{ type: "title", text: "Knowledge Hub Options" }];

            if (data.showCommunity)
            {
                menuItems.push(getMenuItem("Community",
                {
                    icon: data.communityIconCode,
                    click: function ()
                    {
                        window.open(data.communityHref, "_blank");
                    }
                }));
            }

            menuItems.push(getMenuItem("Help Center",
            {
                icon: data.helpCenterIconCode,
                click: function ()
                {
                    window.open(data.helpCenterHref, "_blank");
                }
            }));

            if (data.showProductIdeas)
            {
                menuItems.push(getMenuItem("Product Ideas",
                {
                    icon: data.productIdeasIconCode,
                    click: function ()
                    {
                        window.open(data.productIdeasHref, "_blank");
                    }
                }));
            }

            if (data.showPdc)
            {
                menuItems.push(getMenuItem("Professional Development Center",
                {
                    icon: data.pdcIconCode,
                    click: function ()
                    {
                        window.open(data.pdcHref, "_blank");
                    }
                }));
            }

            if (data.showMyHubAccount) {
                menuItems.push(getMenuItem("My Hub Account",
                    {
                        icon: data.myHubAccountIconCode,
                        click: function () {
                            window.open(data.myHubAccountHref, "_blank");
                        }
                    }));
            }

            if (data.showRemoteAssistance) {
                menuItems.push(getMenuItem("Remote Assistance",
                    {
                        icon: data.remoteAssistanceIconCode,
                        id: "remoteAssistance",
                        click: function () {
                            window.open(data.remoteAssistanceHref, "_blank");
                        }
                    }));
            }

            menuItems.push(getMenuItem("About",
                {
                    icon: data.aboutPopupIconCode,
                    id: "about",
                    hasPopup: "dialog",
                    click: function () { skyward.aboutPopup.buildAboutPopup(); }
            }));

            skyward.modalLayer.showMenu(menuItems, "#" + button.attr('id'), {});
        }

        function getMenuItem(text, options)
        {
            var defaultSettings =
            {
                type: "item",
                id: null,
                click: null,
                target: "full",
                data: null,
                icon: null
            };

            var menuItem = $.extend({}, defaultSettings, options);
            menuItem.text = text;

            return menuItem;

        }

        function buildLoadContentClickFunction(target, module, object, screen, options)
        {
            var defaultSettings =
            {
                data: null,
                id: null,
            };
            var settings = $.extend({}, defaultSettings, options);
            return function ()
            {
                skyward.window.loadContent(target, module, object, screen, settings.id, settings.data);
            };
        }

        var init = function ()
        {
            var clickEvent = "click";
            // .off().on() is used because currently on workflow load loadDOM is called back twice with the selector to the entire workflow
            // without .off().on(), we would be adding the function twice
            $("#myAccountButton").off(clickEvent, myAccountPopupBuilder).on(clickEvent, myAccountPopupBuilder);
            $("#knowledgeHubButton").off(clickEvent, knowledgeHubPopupBuilder).on(clickEvent, knowledgeHubPopupBuilder);
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        var offset = .01;
        var defaultValue = '0.00';
        var disabledValue = '';

        var defaultAllowSubjectiveSelector = "[id*='AllowSubjective']";

        // Selectors used in most Grading Scale Group Browses
        var percentLowSelector = "[id*='PercentLow']";
        var percentHighSelector = "[id*='PercentHigh']";
        var defaultCalculationPercentSelector = "[id*='DefaultCalculationPercent']";

        // Selectors used in Grading Scale Group Browses using Points
        var lowValueSelector = "[id*='ValueLow']";
        var highValueSelector = "[id*='ValueHigh']";
        var defaultCalculationValueSelector = "[id*='DefaultCalculationValue']";

        // Selectors used in Standards Grading Scale Group Browses
        var pointsLowSelector = "[id*='Low']";
        var pointsHighSelector = "[id*='High']";
        var defaultCalculationValueSelector = "[id*='DefaultCalculationValue']";
        var colorPrefix = "#Color-";

        var gradingScaleBrowses = {};

        var processGradeMarkBrowse = function (browse, isStandardsGradingScaleGroup, isPointsBasedGradingScaleGroup, isPaging)
        {
            var browseID = browse.attr('id');
            var lowSelector = isStandardsGradingScaleGroup ? pointsLowSelector : isPointsBasedGradingScaleGroup ? lowValueSelector : percentLowSelector;
            var highSelector = isStandardsGradingScaleGroup ? pointsHighSelector : isPointsBasedGradingScaleGroup ? highValueSelector : percentHighSelector;
            var defaultCalculationSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? defaultCalculationValueSelector : defaultCalculationPercentSelector;

            var highInputSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? '.highgradingscale' : '.highgradingscalepercents';
            var lowInputSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? '.lowgradingscale' : '.lowgradingscalepercents';
            var defaultCalculationInputSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? '.defaultcalculationvaluegradingscale' : '.defaultcalculationpercentgradingscalepercents';
            var selectSelector = isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup ? '.selectpointsgradingscalegroupgrademarks' : '.selectgradingscalegroupgrademarks';

            if (!gradingScaleBrowses.hasOwnProperty(browseID) || !isPaging)
            {
                gradingScaleBrowses[browseID] =
                {
                    gradeMarks: {},
                    maxRow: function()
                    {
                        var max = 0;

                        for (var prop in gradingScaleBrowses[browseID].gradeMarks)
                        {
                            if (!gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(prop))
                            {
                                continue;
                            }

                            var numericValue = parseInt(prop);

                            if (numericValue > max)
                            {
                                max = numericValue;
                            }
                        }

                        return max;
                    }
                };
            }

            var getHighElement = function (row)
            {
                var highElements = browse.find(highSelector);
                return highElements.filter("[id$='High-" + row + "']").add(highElements.filter("[id$='High-" + row + "-Workflow']"));
            };

            var getLowElement = function (row)
            {
                var lowElements = browse.find(lowSelector);
                return lowElements.filter("[id$='Low-" + row + "']").add(lowElements.filter("[id$='Low-" + row + "-Workflow']"));
            };

            var getDefaultCalculationElement = function (row)
            {
                var defaultCalculationElements = browse.find(defaultCalculationSelector);
                return defaultCalculationElements.filter("[id*='DefaultCalculation'][id$='-" + row + "']").add(defaultCalculationElements.filter("[id*='DefaultCalculation'][id$='-" + row + "-Workflow']"));
            };

            var getAllowSubjectiveElement = function (row)
            {
                var suffix = isPointsBasedGradingScaleGroup ? "Points" : "Percent";
                var allowSubjectiveElements = browse.find(defaultAllowSubjectiveSelector);
                return allowSubjectiveElements.filter("[id$='AllowSubjective-" + row + "']").add(allowSubjectiveElements.filter("[id$='AllowSubjective-" + row + "-Workflow-" + suffix +"']"));
            }

            var getOffsetValue = function (value, isAdd)
            {
                var offsetValue;

                if (isAdd)
                {
                    offsetValue = (Math.round(value * 100) + Math.round(offset * 100)) / 100;
                }
                else
                {
                    offsetValue = (Math.round(value * 100) - Math.round(offset * 100)) / 100;
                }

                if (isNaN(offsetValue))
                {
                    return undefined;
                }

                return offsetValue;
            };

            var setDefaultCalculationValue = function (row, element)
            {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), true);

                row = parseInt(row);

                if (offsetValue == undefined)
                {
                    return;
                }

                if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row))
                {
                    var defaultCalculationInput = getDefaultCalculationElement(row);
                    var lowInput = getLowElement(row);
                    var highInput = getHighElement(row);

                    if (defaultCalculationInput.length > 0)
                    {
                        var updateCalculationInputFromLow = parseFloat(skyward.controls.getValue(lowInput)) > parseFloat(skyward.controls.getValue(defaultCalculationInput));
                        var updateCalculationInputFromHigh = parseFloat(skyward.controls.getValue(highInput)) < parseFloat(skyward.controls.getValue(defaultCalculationInput));

                        if ((lowInput.length > 0 && updateCalculationInputFromLow) || (highInput.length > 0 && updateCalculationInputFromHigh))
                        {
                            skyward.controls.setValue(defaultCalculationInput, value);
                            processGradeMark(row, undefined, undefined, defaultCalculationInput, true);
                        }

                        if (lowInput.length > 0 && parseFloat(value) <= parseFloat(skyward.controls.getValue(lowInput)))
                        {
                            skyward.controls.setValue(lowInput, value);
                            processGradeMark(row, undefined, lowInput, undefined, true);

                            setRangeValues(row, lowInput, true);
                            setPreviousOrNextDefaultCalculationValue(row, lowInput, false);
                            return;
                        }

                        if (highInput.length > 0 && parseFloat(value) >= parseFloat(skyward.controls.getValue(highInput)))
                        {
                            skyward.controls.setValue(highInput, value);
                            processGradeMark(row, highInput, undefined, undefined, true);

                            setRangeValues(row, highInput, false);
                            setPreviousOrNextDefaultCalculationValue(row, highInput, true);
                            return;
                        }
                    }

                    gradingScaleBrowses[browseID].gradeMarks[row].defaultCalculationValue = offsetValue;
                    gradingScaleBrowses[browseID].gradeMarks[row].defaultCalculationNeedsUpdating = true;
                    return;
                }
            };

            var setPreviousLowValue = function (row, element)
            {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), true);

                row = parseInt(row);

                if (offsetValue == undefined)
                {
                    return;
                }

                for (var i = row - 1; i > 0; i--)
                {
                    if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(i))
                    {
                        var lowInput = getLowElement(i);

                        if (lowInput.length > 0)
                        {
                            skyward.controls.setValue(lowInput, offsetValue);
                            processGradeMark(i, undefined, lowInput, undefined, true);
                        }
                        else
                        {
                            gradingScaleBrowses[browseID].gradeMarks[i].lowValue = offsetValue;
                            gradingScaleBrowses[browseID].gradeMarks[i].lowNeedsUpdating = true;
                        }
                        return;
                    }
                }
            };

            var setNextHighValue = function (row, element)
            {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), false);

                row = parseInt(row);

                if (offsetValue == undefined)
                {
                    return;
                }

                for (var i = row + 1; i <= gradingScaleBrowses[browseID].maxRow(); i++)
                {
                    if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(i))
                    {
                        var highInput = getHighElement(i);

                        if (highInput.length > 0)
                        {
                            skyward.controls.setValue(highInput, offsetValue);
                            processGradeMark(i, highInput, undefined, undefined, true);
                        }
                        else
                        {
                            gradingScaleBrowses[browseID].gradeMarks[i].highValue = offsetValue;
                            gradingScaleBrowses[browseID].gradeMarks[i].highNeedsUpdating = true;
                        }
                        return;
                    }
                }
            };

            var setRangeValues = function (row, element, isAdd) {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), isAdd);

                row = parseInt(row);

                if (offsetValue == undefined) {
                    return;
                }

                if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row)) {
                    var rangeInput = isAdd ? getHighElement(row) : getLowElement(row);
                    var rangeValue = parseFloat(skyward.controls.getValue(rangeInput));

                    var updateRangePercent = (isAdd && rangeValue <= value) || (!isAdd && rangeValue >= value);

                    if (rangeInput.length > 0 && updateRangePercent) {
                        skyward.controls.setValue(rangeInput, offsetValue);
                        isAdd ? processGradeMark(row, rangeInput, undefined, undefined, true) : processGradeMark(row, undefined, rangeInput, undefined, true);
                    }

                    isAdd ? setNextHighValue(row, element) : setPreviousLowValue(row, element);
                }
            };

            var setPreviousOrNextDefaultCalculationValue = function (row, element, isAdd) {
                var value = skyward.controls.getValue(element);
                var offsetValue = getOffsetValue(parseFloat(value), isAdd);

                row = parseInt(row);

                if (offsetValue == undefined) {
                    return;
                }

                for (var i = isAdd ? row - 1 : row + 1; (i > 0 && isAdd) || (i <= gradingScaleBrowses[browseID].maxRow() && !isAdd); isAdd ? i-- : i++) {
                    if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(i))
                    {
                        var defaultCalculationInput = getDefaultCalculationElement(i);
                        var defaultCalculationValue = parseFloat(skyward.controls.getValue(defaultCalculationInput));

                        var updateDefaultPercent = (isAdd && defaultCalculationValue <= value) || (!isAdd && defaultCalculationValue >= value);

                        if (defaultCalculationInput.length > 0 && updateDefaultPercent)
                        {
                            skyward.controls.setValue(defaultCalculationInput, offsetValue);
                            processGradeMark(i, undefined, undefined, defaultCalculationInput, true);

                            return;
                        }
                    }
                }
            };

            var processGradeMark = function (row, highInput, lowInput, defaultCalculationInput, isChecked)
            {
                if (!isChecked)
                {
                    if (gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row))
                    {
                        delete gradingScaleBrowses[browseID].gradeMarks[row];
                    }
                    return;
                }

                if (!gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row))
                {
                    gradingScaleBrowses[browseID].gradeMarks[row] = {};
                }

                var highValue = skyward.controls.getValue(highInput);
                var lowValue = skyward.controls.getValue(lowInput);
                var defaultCalculationValue = skyward.controls.getValue(defaultCalculationInput);

                if (!isNaN(highValue))
                {
                    gradingScaleBrowses[browseID].gradeMarks[row].highValue = highValue;
                }
                if (!isNaN(lowValue))
                {
                    gradingScaleBrowses[browseID].gradeMarks[row].lowValue = lowValue;
                }
                if (!isNaN(defaultCalculationValue)) {
                    gradingScaleBrowses[browseID].gradeMarks[row].defaultCalculationValue = defaultCalculationValue;
                }
            };

            var resetFields = function (element)
            {
                var row = element.data().row;

                var highInput = getHighElement(row);
                var lowInput = getLowElement(row);
                var defaultCalculationInput = getDefaultCalculationElement(row);
                var allowSubjectiveInput = getAllowSubjectiveElement(row);
                var isChecked = element.is(':checked');

                if (isChecked)
                {
                    skyward.controls.setValue(highInput, defaultValue);
                    skyward.controls.setValue(lowInput, defaultValue);
                    skyward.controls.setValue(defaultCalculationInput, defaultValue);
                }
                else
                {
                    skyward.controls.setValue(highInput, disabledValue);
                    skyward.controls.setValue(lowInput, disabledValue);
                    skyward.controls.setValue(defaultCalculationInput, disabledValue);
                    skyward.controls.setValue(allowSubjectiveInput, disabledValue);
                }

                if (isStandardsGradingScaleGroup || isPointsBasedGradingScaleGroup)
                {
                    var colorField = browse.find(colorPrefix + row);
                    if (isChecked)
                    {
                        colorField.spectrum('set', '#63BE7B'); // Default to green
                        colorField.change();
                    }
                    else
                    {
                        colorField.spectrum('set', '');
                        colorField.change();
                    }
                }

                processGradeMark(row, highInput, lowInput, defaultCalculationInput, isChecked);
            };

            var resetFieldsForSubjective = function (element) {
                var row = element.data().row;

                var highInput = getHighElement(row);
                var lowInput = getLowElement(row);
                var defaultCalculationInput = getDefaultCalculationElement(row);
                var allowSubjectiveInput = getAllowSubjectiveElement(row);
                var isChecked = element.is(':checked');
                var allowEmptyBox = allowSubjectiveInput.is(":checked");

                var highInputValue = skyward.controls.getValue(highInput);
                var lowInputValue = skyward.controls.getValue(lowInput);
                var defaultCalculationInputValue = skyward.controls.getValue(defaultCalculationInput);

                if (isChecked)
                {
                    var valueToSet = allowEmptyBox ? '' : defaultValue;

                    if (highInputValue == null || highInputValue == '' || highInputValue == defaultValue)
                    {
                        skyward.controls.setValue(highInput, valueToSet);
                    }

                    if (lowInputValue == null || lowInputValue == '' || (lowInputValue == defaultValue && highInputValue == defaultValue && defaultCalculationInputValue == defaultValue))
                    {
                        skyward.controls.setValue(lowInput, valueToSet);
                    }

                    if (defaultCalculationInputValue == null || defaultCalculationInputValue == '' || (defaultCalculationInputValue == defaultValue && highInputValue == defaultValue && lowInputValue == defaultValue))
                    {
                        skyward.controls.setValue(defaultCalculationInput, valueToSet);
                    }
                }
                else
                {
                    if (highInputValue == null || highInputValue == '')
                    {
                        skyward.controls.setValue(highInput, defaultValue);
                    }

                    if (lowInputValue == null || lowInputValue == '')
                    {
                        skyward.controls.setValue(lowInput, defaultValue);
                    }

                    if (defaultCalculationInputValue == null || defaultCalculationInputValue == '')
                    {
                        skyward.controls.setValue(defaultCalculationInput, defaultValue);
                    }
                }
            };

            var processHighInputBlur = function (event)
            {
                var elementID = event.target.id;
                var element = browse.find('#' + elementID);
                var numericValue = parseFloat(skyward.controls.getValue(element));

                if (numericValue == 0 || element.is('[readonly]'))
                {
                    return;
                }

                var idParts = elementID.split('-');
                var row = idParts[1];
                processGradeMark(row, element, undefined, undefined, true);
                setRangeValues(row, element, false);
                setDefaultCalculationValue(row, element);

                var rowElement = element.parents("tr").first();
                var allowSubjectiveElement = rowElement.find(defaultAllowSubjectiveSelector).first();
                if (allowSubjectiveElement && allowSubjectiveElement.is(":checked") && !isNaN(numericValue))
                {
                    defaultInputValueIfNotSet(rowElement, lowInputSelector, defaultValue);
                    defaultInputValueIfNotSet(rowElement, defaultCalculationInputSelector, defaultValue);
                }
            };

            var processLowInputBlur = function (event)
            {
                var elementID = event.target.id;
                var element = browse.find('#' + elementID);
                var numericValue = parseFloat(skyward.controls.getValue(element));

                if (numericValue == 0 || element.is('[readonly]'))
                {
                    return;
                }

                var idParts = elementID.split('-');
                var row = idParts[1];
                processGradeMark(row, undefined, element, undefined, true);
                setRangeValues(row, element, true);
                setDefaultCalculationValue(row, element);

                var rowElement = element.parents("tr").first();
                var allowSubjectiveElement = rowElement.find(defaultAllowSubjectiveSelector).first();
                if (allowSubjectiveElement && allowSubjectiveElement.is(":checked") && !isNaN(numericValue))
                {
                    defaultInputValueIfNotSet(rowElement, highInputSelector, defaultValue);
                    defaultInputValueIfNotSet(rowElement, defaultCalculationInputSelector, defaultValue);
                }
            };

            var defaultInputValueIfNotSet = function (rowElement, affectedElementSelector, defaultValue)
            {
                var elementValue = skyward.controls.getValue(rowElement.find(affectedElementSelector));
                if (elementValue == null || elementValue == "")
                {
                    skyward.controls.setValue(rowElement.find(affectedElementSelector), defaultValue);
                }
            };

            var processDefaultCalculationInputBlur = function (event)
            {
                var elementID = event.target.id;
                var element = browse.find('#' + elementID);
                var numericValue = parseFloat(skyward.controls.getValue(element));

                if (numericValue == 0 || element.is('[readonly]'))
                {
                    return;
                }

                var idParts = elementID.split('-');
                var row = idParts[1];
                processGradeMark(row, undefined, undefined, element, true);
                setDefaultCalculationValue(row, element);
            };

            browse.on('change', selectSelector, function () { resetFields($(this)); });
            browse.on('change', ".selectgradingscalegroupgrademarkallowsubjective", function () { resetFieldsForSubjective($(this)); });
            browse.on('blur', highInputSelector, processHighInputBlur);
            browse.on('blur', lowInputSelector, processLowInputBlur);
            browse.on('blur', defaultCalculationInputSelector, processDefaultCalculationInputBlur);

            browse.find(highInputSelector).each(function ()
            {
                var highInput = $(this);

                var idParts = highInput.attr('id').split('-');
                var row = idParts[1];

                var lowInput = getLowElement(row);
                var defaultCalculationInput = getDefaultCalculationElement(row);

                if (!gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(row))
                {
                    var value = skyward.controls.getValue(highInput);
                    var validValue = !isNaN(value) && value != '' && !highInput.is('[readonly]') && !lowInput.is('[readonly]') && !defaultCalculationInput.is('[readonly]');
                    processGradeMark(row, highInput, lowInput, defaultCalculationInput, validValue);
                }
            });

            for (var key in gradingScaleBrowses[browseID].gradeMarks)
            {
                if (!gradingScaleBrowses[browseID].gradeMarks.hasOwnProperty(key))
                {
                    continue;
                }

                var gradeMark = gradingScaleBrowses[browseID].gradeMarks[key];

                if (gradeMark.hasOwnProperty('highNeedsUpdating') && gradeMark.highNeedsUpdating)
                {
                    var highElement = getHighElement(key);
                    skyward.controls.setValue(highElement, gradeMark.highValue);
                    gradeMark.highNeedsUpdating = false;
                }

                if (gradeMark.hasOwnProperty('lowNeedsUpdating') && gradeMark.lowNeedsUpdating)
                {
                    var lowElement = getLowElement(key);
                    skyward.controls.setValue(lowElement, gradeMark.lowValue);
                    gradeMark.lowNeedsUpdating = false;
                }

                if (gradeMark.hasOwnProperty('defaultCalculationNeedsUpdating') && gradeMark.defaultCalculationNeedsUpdating)
                {
                    var defaultCalculationElement = getDefaultCalculationElement(key);
                    skyward.controls.setValue(defaultCalculationElement, gradeMark.defaultCalculationValue);
                    gradeMark.lowNeedsUpdating = false;
                }
            }
        };



        var init = function (selector)
        {
            var element = $(selector);
            var isPaging = element.hasClass('editablebrowse');

            var percentLow = element.find(percentLowSelector);
            var pointsLow = element.find(pointsLowSelector);
            var lowValue = element.find(lowValueSelector);

            var isStandardsGradingScaleGroup = false;
            var isPointsBasedGradingScaleGroup = false;

            var browse = undefined;
            if (pointsLow.length > 0)
            {
                browse = pointsLow.closest('.editablebrowse');
                isPointsBasedGradingScaleGroup = false;
                isStandardsGradingScaleGroup = true;
            }
            if (percentLow.length > 0)
            {
                browse = percentLow.closest('.editablebrowse');
                isPointsBasedGradingScaleGroup = false;
                isStandardsGradingScaleGroup = false;
            }

            if (browse && browse.length == 1)
            {
                processGradeMarkBrowse(browse, isStandardsGradingScaleGroup, isPointsBasedGradingScaleGroup, isPaging);
            }

            if (lowValue.length > 0)
            {
                browse = lowValue.closest('.editablebrowse');
                isStandardsGradingScaleGroup = false;
                isPointsBasedGradingScaleGroup = true;
                if (browse && browse.length == 1)
                {
                    processGradeMarkBrowse(browse, isStandardsGradingScaleGroup, isPointsBasedGradingScaleGroup, isPaging);
                }
            }

            var updateGradingScalePreviewWorkflow = function ()
            {
                var postData = {};
                var element = $(this);

                postData["GradingScaleGroupID"] = $(element.children()[0]).val();

                $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/GradingScaleGroup/UpdateGradingScalePreviewWorkflow",
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        var previewDiv = $("[id*=GradingScaleGroupPreviewWorkflow]");
                        var divHtml = data.Update["GradingScaleGroupPreviewWorkflow"];
                        previewDiv.html(divHtml);
                    }
                });
            }
            var updateGradingScalePreview = function ()
            {
                var postData = {};
                var element = $(this);

                postData["GradingScaleGroupID"] = $(element.children()[0]).val();

                $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/GradingScaleGroup/UpdateGradingScalePreviewDetails",
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: async function (data)
                    {
                        var previewDiv = $("[id*=GradingScaleGroupPreview]");
                        var divHtml = data.Update["GradingScaleGroupPreview"];
                        await previewDiv.viewpartHtml(divHtml);
                    }
                });
            }

            var gradingScalePreviewDiv = $(".gradingScaleGroupEELWithPreview .codeEEL");
            gradingScalePreviewDiv.off("eelComplete");
            gradingScalePreviewDiv.on("eelComplete", updateGradingScalePreview);

            gradingScalePreviewDiv = $(".gradingScaleGroupEELWithPreview_Workflow .codeEEL");
            gradingScalePreviewDiv.off("eelComplete");
            gradingScalePreviewDiv.on("eelComplete", updateGradingScalePreviewWorkflow);
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.gradebooksettings = skyward.gradebooksettings || {};

        var init = function (selector)
        {
            $(selector + " #EditSectionGradeBucketDetails").on("DOVSaveValidationError", function ()
            {
                var browse = $("#EditSectionGradeBucketDetails").find(".editablebrowse:not(.hidden, .browse--displayNone)");

                if (!browse.hasClass('errorExpanded'))
                {
                    browse.addClass('errorExpanded');
                    browse.css('margin-top', '+=30px');
                }
            });

            $(selector + " #EditSectionGradeBucketDetails").on("change", ".js-CalcTypeComboBox", function ()
            {
                var calcTypeElement = $(this);
                changeCalculationType(calcTypeElement, "SectionGradeBucket");
            });

            $(selector + " #editCalculationGroupGradeBucket").on("change", ".js-CalcTypeComboBox", function ()
            {
                var calcTypeElement = $(this);
                changeCalculationType(calcTypeElement, "CalculationGroupGradeBucket");
            });

            $(selector + " #editStudentCalculationGroupGradeBucket").on("change", ".js-CalcTypeComboBox", function ()
            {
                var calcTypeElement = $(this);
                changeCalculationType(calcTypeElement, "StudentCalculationGroupGradeBucket");
            });

            $(selector + " #editCalculationGroupSubjectGradeBucket").on("change", ".js-CalcTypeComboBox", function ()
            {
                var calcTypeElement = $(this);
                changeCalculationType(calcTypeElement, "CalculationGroupSubjectGradeBucket");
            });

            $(selector + " #editCalculationGroupAcademicStandardGradeBucket").on("change", ".js-CalcTypeComboBox", function ()
            {
                var calcTypeElement = $(this);
                changeCalculationType(calcTypeElement, "CalculationGroupAcademicStandardGradeBucket");
            });

            $(selector + " .cumulativeAssignmentScoresExamWeightingBrowse").on("change", "input.checkbox", function ()
            {
                var checkbox = $(this);
                updateCumulativeAssignmentScoreWeightings(checkbox.parents(".browse").first());
            });

            $(selector + " .cumulativeAssignmentScoresExamWeightingBrowse").on("keyup", "input.cumulativeGradeWeightingPercent[data-type-code!='CU']", function ()
            {
                var input = $(this);
                var browse = input.parents(".browse").first();

                updateCumulativeAssignmentScoreWeightings(browse);
            });

            $(selector).find(".checkbox.academicStandardToDisplay").on("change", updateAcademicStandardsToDisplay);

            var changeCalculationType = function (calcTypeElement, controller)
            {
                var isTeacherSide = (controller.indexOf("SectionGradeBucket") > -1) ? true : false;

                var dov = calcTypeElement.parents(".dataObjectViewer");

                var value = skyward.controls.getValue(calcTypeElement);

                var buildBrowse = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/" + controller + "/BuildCalculationTypeBrowse",
                        type: "POST",
                        dataType: "viewpartHtml",
                        data:
                        {
                            calculationTypeCode: value,
                            calculationGroupGradeBucketID: skyward.controls.getValue(dov.find(".calculationGroupGradeBucketIDHidden")),
                            sectionGradeBucketID: skyward.controls.getValue(dov.find(".sectionGradeBucketIDHidden")),
                            StudentCalculationGroupGradeBucketID: skyward.controls.getValue(dov.find(".studentCalculationGroupGradeBucketIDHidden")),
                            renderInDetailsPanel: calcTypeElement.parents(".detailsPanel").length > 0,
                            isAdminDetails: skyward.controls.getValue(dov.find(".isAdminDetails")),
                            isTeacherTracker: skyward.controls.getValue(dov.find(".isTeacherTracker"))
                        },
                        success: function (returnData)
                        {
                            dov.append(returnData);
                            skyward.window.notifyDOMLoad("#" + dov.attr("id"));
                        }
                    });
                };

                var categoriesBrowseElement = dov.find(".browse.categoriesBrowse");
                var gradeWeightsBrowseElement = dov.find(".browse.gradeBucketWeightsBrowse");
                var subjectWeightsBrowseElement = dov.find(".browse.subjectWeightingBrowse");
                var academicStandardWeightsBrowseElement = dov.find(".browse.academicStandardWeightingBrowse");
                var cumulativeAssignmentScoreExamGradeWeightsBrowseElement = dov.find(".browse.cumulativeAssignmentScoresExamWeightingBrowse");

                var browseToShow;

                if (value == "A" || value == "C" || value == "S" || value == "N" || value == "E" || value == "V")
                {
                    if (isTeacherSide || value == "C")
                    {
                        browseToShow = categoriesBrowseElement;
                    }
                }
                else if (value == "T" || value == "G")
                {
                    browseToShow = gradeWeightsBrowseElement;
                }
                else if (value == "B")
                {
                    browseToShow = subjectWeightsBrowseElement;
                }
                else if (value == "D")
                {
                    browseToShow = academicStandardWeightsBrowseElement;
                }
                else if (value == "U")
                {
                    browseToShow = cumulativeAssignmentScoreExamGradeWeightsBrowseElement;
                }

                hideSettingsBrowse(categoriesBrowseElement);
                hideSettingsBrowse(gradeWeightsBrowseElement);
                hideSettingsBrowse(subjectWeightsBrowseElement);
                hideSettingsBrowse(academicStandardWeightsBrowseElement);
                hideSettingsBrowse(cumulativeAssignmentScoreExamGradeWeightsBrowseElement);

                if (browseToShow && browseToShow.length)
                {
                    showSettingsBrowse(browseToShow);
                    var browseToReload = browseToShow.attr("id");
                    var browseData = {};

                    skyward.browse.get(browseToReload, browseData, { "calculationTypeCode": value });
                    if (value == "U")
                    {
                        initCumulativeWeightingBrowse.apply(browseToReload);
                    }

                }
                else if (isTeacherSide || (value != "A" && value != "S" && value != "N")) //No browse for total points/subjective/not graded admin side
                {
                    buildBrowse();
                }
            };

            $(selector + " #EditSubjectsToDisplay, " + selector + " #EditAcademicStandardsToDisplay").on("change", ".subjectStandardDisplayCodeEelFilter", function ()
            {
                var codeEEL = $(this);
                var dov = codeEEL.parents(".dataObjectViewer").first();
                var calculationGroupGradeBucketID = skyward.controls.getValue(codeEEL);

                dov.find(".subjectsAcademicStandardsToDisplayContainer").addClass("displayNone");
                dov.find(".subjectsAcademicStandardsToDisplay-" + calculationGroupGradeBucketID).removeClass("displayNone");

                var isTeacherTracker = codeEEL.parent().data().teacherTracker == "true";
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/GradebookSettings/UpdateTeacherAccessSubjectStandardSelectedBucket" + (isTeacherTracker ? "TeacherTracker" : ""),
                    type: "POST",
                    data:
                    {
                        SelectedBucket: skyward.controls.getValue(codeEEL),
                        SectionLengthID: codeEEL.parent().data().sectionLengthId
                    }
                });
            });

            var displayGradingScaleLegend = function ()
            {
                var accessmode = $("#accessmode").val();
                var button = $(this);
                var buttonData = button.data();
                var action;

                var isStudentInformationPopup = button.data().isStudentInformationPopup;
                var objectLabel = "";

                if (buttonData && buttonData.objectLabel != null)
                {
                    objectLabel = buttonData.objectLabel.toString();
                    action = "StudentGradeBucket" + objectLabel + "GradingScale";
                    if (buttonData.isTeacherTracker.toString().toLowerCase() == "true")
                    {
                        action += "TeacherTracker";
                    }
                    else if (isStudentInformationPopup != null && isStudentInformationPopup.toString().toLowerCase() == "true")
                    {
                        action += "StudentInformationPopup" + buttonData.currentPortal.toString();
                    }
                }
                else
                {
                    if (buttonData.isTeacherTracker.toString().toLowerCase() == "true")
                    {
                        action = "GetGradingScaleBrowseTeacherTracker";
                    }
                    else if (isStudentInformationPopup != null && isStudentInformationPopup.toString().toLowerCase() == "true")
                    {
                        action = "GetGradingScaleBrowseStudentInformationPopup" + buttonData.currentPortal.toString();
                    }
                    else
                    {
                        action = "GetGradingScaleBrowse";
                    }
                }

                skyward.modalLayer.showDialog("Grading Scale", function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/ProgressReport/" + action + (accessmode != null ? accessmode : ""),
                        type: "POST",
                        data: button.data()
                    });
                }, null, { height: "80%", anchorTo: button });
            };

            var displayGradeMarkOverrideLegend = function ()
            {
                skyward.modalLayer.showDialog("Grade Mark Override Legend", function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/GetGradeMarkOverrideBrowse",
                        type: "POST"
                    });
                });
            };

            // Event handlers
            var events =
            {
                "displayGradingScaleLegend": displayGradingScaleLegend,
                "displayGradeMarkOverrideLegend": displayGradeMarkOverrideLegend
            };
            skyward.events.registerEvents("gradebookSettings", events);

            $(selector).find('.gradingPeriodBrowse').on('click', "tr input.checkbox", validateShowCheckbox);
            $(selector).find('.gradingPeriodBrowse').on('click', "tr input.SelectAllCheckBoxControl", validateShowAllCheckbox);

            $(selector).find('.gradingPeriodGradeBucketBrowse').on('click', "tr input.checkbox", validateShowCheckbox);

            $(selector).find('.gradebook_LockedAssignmentInfoButton, .gradebook_LockedGradeBucketInfoButton').off("click", showLockedAssignmentInfo).on('click', showLockedAssignmentInfo);
            $(selector).find('.gradebook_ExtensionAssignmentInfoButton, .gradebook_ExtensionGradeBucketInfoButton').off("click", showExtensionAssignmentInfo).on('click', showExtensionAssignmentInfo);
            $(selector).find('.gradebook_UnlockedAssignmentInfoButton, .gradebook_UnlockedGradeBucketInfoButton').off("click", showUnlockedAssignmentInfo).on('click', showUnlockedAssignmentInfo);

            $(selector).find('.selectAllStudentGradingScaleGroupStudentSections').on('change', selectAllStudentGradingScaleGroup);
            $(selector).find(".cloneGradebook.button").on("click", function ()
            {
                var button = $(this);
                var buttonData = button.data();
                var postData = {};
                postData["Workflow.SectionID"] = buttonData.sectionId;
                postData["Workflow.SectionID_securityhash"] = buttonData.sectionId_securityhash;
                postData["Workflow.StaffID"] = buttonData.staffId;
                postData["Workflow.StaffID_securityhash"] = buttonData.staffId_securityhash;
                postData["Workflow.EntityID"] = buttonData.entityId;
                postData["Workflow.EntityID_securityhash"] = buttonData.entityId_securityhash;
                postData["Workflow.SchoolYearID"] = buttonData.schoolYearId;
                postData["Workflow.SchoolYearID_securityhash"] = buttonData.schoolYearId_securityhash;
                postData["Workflow.RedirectURL"] = buttonData.redirectUrl;

                if (skyward.changeTracking.isDirty())
                {
                    showUnsavedDataMessage();
                }
                else
                {
                    skyward.window.loadContent("popup", "Workflow", "WorkflowInstance", "Create/Gradebook/SectionGradeBucket/CloneGradebook", null, postData);
                }
            });
        };

        var initDefaultValues = function (selector)
        {
            $(selector).find('.sectionGradeBucketContainer, .workflowEditSectionCategoriesWeighting, .workflowEditSectionGradeBucketWeighting, .gradingPeriodGradeBucketBrowse').each(function ()
            {
                var wrapper = $(this);

                wrapper.find('.weightPercent').blur(function ()
                {
                    setNullsToZero($(this));
                });

                wrapper.find('.checkbox').change(function ()
                {
                    var checkbox = $(this);
                    var checkboxId = checkbox.attr("id");
                    var browseRow = checkbox.closest('.browseRow');

                    if (checkboxId.split("-")[0] == "UseMaxExtraCredit")
                    {
                        var maxExtraCredit = browseRow.find('#MaxExtraCredit-' + checkboxId.split("-")[1]);
                        if (checkbox.is(':checked'))
                        {
                            setNullsToZero(maxExtraCredit);
                            skyward.controls.enable(maxExtraCredit);

                            if (checkbox.hasClass('ui-disabled'))
                            {
                                skyward.controls.disable(maxExtraCredit);
                            }
                        }
                        else
                        {
                            skyward.controls.setValue(maxExtraCredit, '');
                            skyward.controls.disable(maxExtraCredit);
                        }
                    }
                    else
                    {
                        var weightPercent = browseRow.find('.weightPercent');
                        if (checkbox.is(':checked'))
                        {
                            setNullsToZero(weightPercent);
                        }
                        else
                        {
                            skyward.controls.setValue(weightPercent, '');
                        }
                    }
                });

                wrapper.find('.checkbox').change();

                function setNullsToZero(element)
                {
                    if (element.val() == '')
                    {
                        skyward.controls.setValue(element, '0.00');
                    }
                }
            });
        };

        var validateShowCheckbox = function ()
        {
            var input = $(this);
            var inputId = input.attr("id");
            var inputChecked = input.is(":checked");
            var row = input.closest("tr");

            switch (inputId.split("-")[0].toLowerCase())
            {
                case "showassignments":
                    if (inputChecked)   //if checked, check the Show Grade Buckets checkbox for the same grading period
                    {
                        skyward.controls.setValue(row.find('#ShowGradeBuckets-' + inputId.split("-")[1]), inputChecked);
                    }
                    break;
                case "showgradebuckets":
                    if (!inputChecked)  //if unchecked, uncheck the Show Assignments/Academic Standards/Subjects checkboxes for the same grading period
                    {
                        skyward.controls.setValue(row.find('#ShowAssignments-' + inputId.split("-")[1]), inputChecked);
                        skyward.controls.setValue(row.find('#ShowSubjects-' + inputId.split("-")[1]), inputChecked);
                        skyward.controls.setValue(row.find('#ShowAcademicStandards-' + inputId.split("-")[1]), inputChecked);
                    }
                    break;
                case "usemaxextracredit":
                    var maxExtraCreditTextBox = row.find('#MaxExtraCredit-' + inputId.split("-")[1]);
                    if (inputChecked)   //if checked, enable the Max Extra Credit textbox for the same grading period grade bucket
                    {
                        skyward.controls.enable(maxExtraCreditTextBox);
                        skyward.controls.setValue(maxExtraCreditTextBox, '0.00');
                    }
                    else //else disable
                    {
                        skyward.controls.disable(maxExtraCreditTextBox);
                        skyward.controls.setValue(maxExtraCreditTextBox, '');
                    }
                    break;
            }
        };

        var validateShowAllCheckbox = function ()
        {
            var input = $(this);
            var inputId = input.attr("id");
            var inputChecked = input.is(":checked");
            var browse = $("#editGradesheetDisplaySettings_GradeBucketsAssignmentsToDisplay");
            var checkboxes;

            switch (inputId.split("_")[0].toLowerCase())
            {
                case "showassignments":
                    if (inputChecked)   //if checked, check the Show Grade Buckets checkboxes for all the grading periods
                    {
                        checkboxes = browse.find("tr input.selectAllShowGradeBuckets:not([disabled],.ui-disabled)");
                        checkboxes.each(function ()
                        {
                            var checkbox = $(this);
                            if (checkbox.attr("id").split("-")[0].toLowerCase() == "showgradebuckets")
                            {
                                skyward.controls.setValue(checkbox, true);
                            }
                        });
                    }
                    break;
                case "showgradebuckets":
                    if (!inputChecked)
                    {
                        checkboxes = browse.find("tr input.selectAllShowAssignments:not([disabled],.ui-disabled)");
                        checkboxes.each(function ()
                        {
                            var checkbox = $(this);
                            if (checkbox.attr("id").split("-")[0].toLowerCase() == "showassignments")
                            {
                                skyward.controls.setValue(checkbox, false);
                            }
                        });
                    }
                    break;
            }
        };

        var changeCalculationType = function (calcTypeElement, controller, sectionLengthsToShow)
        {
            var isTeacherSide = (controller.indexOf("SectionGradeBucket") > -1) ? true : false;

            var dov = calcTypeElement.parents(".dataObjectViewer");

            var value = skyward.controls.getValue(calcTypeElement);

            var categoriesBrowseElement = hideSettingsBrowse(dov.find(".browse.categoriesBrowse"));
            var gradeWeightsBrowseElement = hideSettingsBrowse(dov.find(".browse.gradeBucketWeightsBrowse"), sectionLengthsToShow);
            var subjectWeightsBrowseElement = hideSettingsBrowse(dov.find(".browse.subjectWeightingBrowse"));
            var academicStandardWeightsBrowseElement = hideSettingsBrowse(dov.find(".browse.academicStandardWeightingBrowse"));
            var cumulativeAssignmentScoreExamGradeWeightsBrowseElement = hideSettingsBrowse(dov.find(".browse.cumulativeAssignmentScoresExamWeightingBrowse"));

            var browseToShow;

            if (value == "A" || value == "C" || value == "S" || value == "N" || value == "E" || value == "V")
            {
                if (isTeacherSide || value == "C")
                {
                    browseToShow = categoriesBrowseElement;
                }
            }
            else if (isGradeWeighted(value))
            {
                browseToShow = gradeWeightsBrowseElement;
            }
            else if (value == "B")
            {
                browseToShow = subjectWeightsBrowseElement;
            }
            else if (value == "D")
            {
                browseToShow = academicStandardWeightsBrowseElement;
            }
            else if (value == "U")
            {
                browseToShow = cumulativeAssignmentScoreExamGradeWeightsBrowseElement;
            }

            if (browseToShow && browseToShow.length)
            {
                showSettingsBrowse(browseToShow);
                var browseToReload = browseToShow.attr("id");
                var browseData = {};

                skyward.browse.get(browseToReload, browseData, { "calculationTypeCode": value });
                if (value == "U")
                {
                    initCumulativeWeightingBrowse.apply(browseToReload);
                }

            }
            else if (isTeacherSide || (isWeightedType(value))) //No browse for total points/subjective/not graded admin side
            {
                buildBrowseForElement(controller, value, calcTypeElement, dov, sectionLengthsToShow);
            }
        };

        var isWeightedType = function (calculationTypeCode)
        {
            return calculationTypeCode == 'T' || calculationTypeCode == 'G' || calculationTypeCode == 'C' || calculationTypeCode == 'B' || calculationTypeCode == 'D' || calculationTypeCode == 'U';
        }

        var isGradeWeighted = function (calculationTypeCode)
        {
            if (calculationTypeCode == 'T' || calculationTypeCode == 'G')
            {
                return true;
            }
            return false;
        }

        var hideSettingsBrowse = function (browse, sectionLengthsToShow)
        {
            if (browse)
            {
                if (sectionLengthsToShow != null)
                {
                    browse.remove();
                    return null;
                }
                else if (!browse.hasClass("browse--displayNone"))
                {
                    browse.addClass("browse--displayNone");
                }
            }
            return browse;
        };

        var buildBrowseForElement = function (controller, calculationType, calcTypeElement, dov, sectionLengthsToShow)
        {
            var renderInDetailsPanel = calcTypeElement.parents(".detailsPanel").length > 0;
            var calculationGroupGradeBucketID = skyward.controls.getValue(dov.find(".calculationGroupGradeBucketIDHidden"));
            var sectionGradeBucketID = skyward.controls.getValue(dov.find(".sectionGradeBucketIDHidden"));
            var isAdminDetails = skyward.controls.getValue(dov.find(".isAdminDetails"));
            var isTeacherTracker = skyward.controls.getValue(dov.find(".isTeacherTracker"));
            return buildBrowse(controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, $(this).parents('.workflow').length > 0, sectionLengthsToShow, dov);
        };

        var buildBrowse = function (controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, isCalcSetupWorkflow, sectionLengthsToShow, locationToAppendBrowse)
        {
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/" + controller + "/BuildCalculationTypeBrowse",
                type: "POST",
                dataType: "viewpartHtml",
                data:
                {
                    calculationTypeCode: calculationType,
                    calculationGroupGradeBucketID: calculationGroupGradeBucketID,
                    sectionGradeBucketID: sectionGradeBucketID,
                    renderInDetailsPanel: renderInDetailsPanel,
                    isAdminDetails: isAdminDetails,
                    isTeacherTracker: isTeacherTracker,
                    isCalcSetupWorkflow: isCalcSetupWorkflow,
                    sectionLengthsToShow: JSON.stringify(sectionLengthsToShow)
                },
                success: function (returnData)
                {
                    locationToAppendBrowse.append(returnData);
                    skyward.window.notifyDOMLoad("#" + locationToAppendBrowse.attr("id"));
                }
            });
        };

        var showSettingsBrowse = function (browse)
        {
            if (browse && browse.hasClass("browse--displayNone"))
            {
                browse.removeClass("browse--displayNone");
            }
        };

        var refreshSettingsBrowse = function (browse, controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, isCalcSetupWorkflow, sectionLengthsToShow)
        {
            var locationToAppendBrowse = browse.parent();
            hideSettingsBrowse(browse, sectionLengthsToShow);
            buildBrowse(controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, isCalcSetupWorkflow, sectionLengthsToShow, locationToAppendBrowse);
        }

        var selectAllStudentGradingScaleGroup = function ()
        {
            var input = $(this);
            var row = input.closest("tr");
            skyward.controls.setValue(row.find('.valuecheckbox:not([disabled],.ui-disabled)').not(".selectAllStudentGradingScaleGroupStudentSections"), input.is(":checked"));
        };

        var overrideCheckLoadContent = function (selector)
        {
            // On the SettingsGradingSectionScaleGroupGradeMarks screen, we want to first do a dirty check
            // since the workflow is modifying the same data as the details
            if ($(selector).find("#SettingsGradingSectionScaleGroupGradeMarks").length)
            {
                var defaultCheckLoadContent = skyward.window.checkLoadContent;

                skyward.window.checkLoadContent = function ()
                {
                    var parameters = arguments;

                    skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
                    {
                        if (wasDirty)
                        {
                            skyward.window.setSkipUnloadCheck(true);
                        }
                        defaultCheckLoadContent.apply(null, parameters);
                    });
                };
            }

            var selectAllStudentGradingScaleGroupStudentSectionsCheckBoxes = $(selector).find(".selectAllStudentGradingScaleGroupStudentSections");

            selectAllStudentGradingScaleGroupStudentSectionsCheckBoxes.each(function ()
            {
                var checkbox = $(this);
                var row = checkbox.closest("tr");
                if (row.find('.valuecheckbox:not(.ui-disabled)').not(".selectAllStudentGradingScaleGroupStudentSections").length == 0)
                {
                    skyward.controls.toggle(checkbox, false);
                }
            });
        };

        var showLockedAssignmentInfo = function (e)
        {
            var button = $(this);
            var data = button.data();

            if (!data || !data.gradingPeriodStartDate || !data.gradingPeriodEndDate || !data.gradeBucketLabel)
            {
                return;
            }

            var options =
            {
                anchorTo: button
            };
            skyward.modalLayer.showInformationDialog(data.gradeBucketLabel + " Closed", "<span>" + data.gradeBucketLabel + " is now <span class='boldFont'>closed</span> (" + data.gradingPeriodStartDate + " - " + data.gradingPeriodEndDate + ")</span>", null, options);
            e.stopPropagation();
        };

        var showExtensionAssignmentInfo = function (e)
        {
            var button = $(this);
            var data = button.data();

            if (!data || !data.gradingPeriodStartDate || !data.gradingPeriodEndDate || !data.gradingPeriodExtensionDays || !data.gradeBucketLabel || !data.extendedEndDate)
            {
                return;
            }

            var options =
            {
                anchorTo: button
            };

            var message = "<div class='gradebookInformationPopup'>";

            message += "<div class='sectionHeader'><h3 class='sectionHeader__text'>Extension Information</h3></div>"
                + "<div><span>" + data.gradeBucketLabel + " is now <span class='boldFont'>closed</span> ("
                + data.gradingPeriodStartDate + " - " + data.gradingPeriodEndDate
                + ") </span></div> <div> Posting for " + data.gradeBucketLabel + " has been extended "
                + data.gradingPeriodExtensionDays + " days until " + data.extendedEndDate + (data.extensionEndTime && data.extensionEndTime.toString().length > 0 ? " at " + data.extensionEndTime : "") + " </div>";

            if (data.useSnapshotGrade && data.useSnapshotGrade.toString().toLowerCase() == "true" && data.snapshotGradeExtendedEndDate)
            {
                message += "<div class='sectionHeader'><h3 class='sectionHeader__text'>Snapshot Grade Information</h3></div>"
                    + "<div><span>" + data.gradeBucketLabel + " has a <span class='boldFont'>snapshot</span> grade</span></div> "
                    + "<div> Snapshot grade for " + data.gradeBucketLabel + (data.isPastTense.toLowerCase() == "true" ? " was" : " will be") + " taken on " + data.snapshotGradeExtendedEndDate + "</div>";
            }
            message += "</div>";

            skyward.modalLayer.showInformationDialog(data.gradeBucketLabel + " Additional Information", message, null, options);
            e.stopPropagation();
        };

        var showUnlockedAssignmentInfo = function (e)
        {
            var button = $(this);
            var data = button.data();

            if (!data || !data.gradeBucketLabel)
            {
                return;
            }

            var options =
            {
                anchorTo: button
            };

            var message = "<div class='gradebookInformationPopup'>";

            message += "<div class='sectionHeader'><h3 class='sectionHeader__text'>Unlocked Information</h3></div>"
                + "<div>" + data.gradeBucketLabel + " is now <span class='boldFont'>unlocked</span> for a closed grading period grade change</div>";
            message += "</div>";

            skyward.modalLayer.showInformationDialog(data.gradeBucketLabel + " Additional Information", message, null, options);
            e.stopPropagation();
        };

        var showUnsavedDataMessage = function (onSaveAndContinue)
        {
            var warningMessage = skyward.modalLayer.showDialog(
                "Unsaved Changes",
                'You have unsaved changes on the screen.',
                [{
                    text: "Save & Continue",
                    "icon": "Save",
                    "click": function ()
                    {
                        var dovId = "editSectionGradeBuckets";
                        var dov = $("#" + dovId);
                        var saveButton = $("#" + dovId + "_save");
                        saveButton.click();
                        warningMessage.close(false);

                        if (onSaveAndContinue && typeof (onSaveAndContinue) === "function")
                        {
                            dov.on("DOVSaveComplete", onSaveAndContinue);
                        }
                    }
                },
                {
                    text: "Cancel",
                    "icon": "Cancel",
                    "click": function ()
                    {
                        warningMessage.close(false);
                    }
                }]
            );
        };

        var reloadTemplates = function (dov)
        {
            dov.find(".ajaxRepeaterPlaceHolder").each(function ()
            {
                skyward.ajaxRepeater.load($(this));
            });
        };

        var reorderClassRoster = function ()
        {
            var action = 'TeacherSectionStudentSectionSettingSortable';
            reorderClassRosterShared(action, $(this));
        };

        var reorderClassRosterTeacherTracker = function ()
        {
            var action = 'TeacherSectionStudentSectionSettingSortableTeacherTracker';
            reorderClassRosterShared(action, $(this));
        };

        var reorderClassRosterClassGroup = function ()
        {
            var action = 'TeacherSectionStudentSectionSettingClassGroupSortable';
            reorderClassRosterShared(action, $(this));
        };

        var reorderClassRosterShared = function (action, button)
        {
            var data = button.data();

            var options =
            {
                TeacherSectionSettingID: data.teachersectionsettingid,
                TeacherSectionSettingIDHash: data.teachersectionsettingidhash,
                SortableID: data.sortableid,
                SortableID_SecurityHash: data.sortableidhash
            };
            var sortablePopupFunction = function ()
            {
                skyward.window.loadContent("sortable", "Gradebook", "TeacherSectionStudentSectionSetting", action, null, options);
            };
            skyward.detailsPanel.tryCloseDetailsPanel(function (wasDirty)
            {
                //they clicked the button to continue anyway, so display the popup and let Mr(s). Teacher deal with the consequences
                sortablePopupFunction();
            });
        };

        var updateAcademicStandardsToDisplay = function ()
        {
            var checkbox = $(this);
            var td = checkbox.parents("td").first();
            var browse = td.parents(".editablebrowse").first();

            var uncheckChildren = function (calculationGroupAcademicStandardID)
            {
                browse.find("td.browseDataCell[data-calculation-group-academic-standard-id-parent='" + calculationGroupAcademicStandardID + "']").each(function ()
                {
                    var childTD = $(this);
                    var childData = childTD.data();
                    var childCheckbox = childTD.find(".checkbox");

                    skyward.controls.setValue(childCheckbox, false);
                });
            };

            var checkParents = function (calculationGroupAcademicStandardIDParent)
            {
                browse.find("td.browseDataCell[data-calculation-group-academic-standard-id='" + calculationGroupAcademicStandardIDParent + "']").each(function ()
                {
                    var parentTD = $(this);
                    var parentData = parentTD.data();
                    var parentCheckbox = parentTD.find(".checkbox");

                    skyward.controls.setValue(parentCheckbox, true);
                });
            };


            var data = td.data();

            if (checkbox.is(":checked"))
            {
                //make sure parent is checked
                checkParents(data.calculationGroupAcademicStandardIdParent);
            }
            else
            {
                uncheckChildren(data.calculationGroupAcademicStandardId);
            }
        };
        var initCumulativeWeightingBrowse = function ()
        {
            var browse = $(this);

            browse.find("input.cumulativeGradeWeightingPercent").each(function ()
            {
                var input = $(this);
                if (input.data() && input.data().typeCode == "CU")
                {
                    skyward.controls.disable(input);
                }
            });
            updateCumulativeAssignmentScoreWeightings(browse);
        };

        var updateCumulativeAssignmentScoreWeightings = function (browse)
        {
            var sum = 0;
            browse.find("input.cumulativeGradeWeightingPercent[data-type-code!='CU']").each(function ()
            {
                var input = $(this);
                if (input.data() && input.data().typeCode != "CU")
                {
                    var value = parseFloat(skyward.controls.getValue(input));

                    if (value && value != null)
                    {
                        sum = parseFloat(sum) + value;
                    }
                }
            });

            var cumulativeLeftOverPercent = (100 - sum).toFixed(2);
            if (cumulativeLeftOverPercent < 0)
            {
                cumulativeLeftOverPercent = 0.00;
            }
            var cumulativeWeightField = browse.find("input.cumulativeGradeWeightingPercent[data-type-code='CU']");
            skyward.controls.setValue(cumulativeWeightField, cumulativeLeftOverPercent, false);
        };

        var initTempSectionGradebookSettingsBrowse = function ()
        {
            var browse = $(this);

            var updateSettingBrowse = function ()
            {
                var currentRow = browse.find(".current");
                var settingTypeColumn = currentRow.find("td[data-setting-type]");
                var code = "";
                if (settingTypeColumn && settingTypeColumn.length > 0)
                {
                    code = settingTypeColumn.data().settingType;
                }

                var hideCalcBrowse = true;
                var hideGradingScaleBrowse = true;
                var hideStudentGradingScaleBrowse = true;
                var hideSubjectStandardErorBrowse = true;
                if (code == "GC")
                {
                    hideCalcBrowse = false;
                }
                else if (code == "GS")
                {
                    hideGradingScaleBrowse = false;
                }
                else if (code == "SS")
                {
                    hideStudentGradingScaleBrowse = false;
                }
                else if (code == "AD" || code == "SJ")
                {
                    hideSubjectStandardErorBrowse = false;
                }

                if (hideGradingScaleBrowse)
                {
                    $("#TempSectionGradingScales").hide();
                } else
                {
                    $("#TempSectionGradingScales").show();
                }

                if (hideStudentGradingScaleBrowse)
                {
                    $("#TempStudentGradingScaleGroupStudentSections").hide();
                } else
                {
                    $("#TempStudentGradingScaleGroupStudentSections").show();
                }

                if (hideCalcBrowse)
                {
                    $("#TempSectionGradeBuckets").hide();
                } else
                {
                    $("#TempSectionGradeBuckets").show();
                }

                if (hideSubjectStandardErorBrowse)
                {
                    $("#TempSectionGradebookSettingErrors").hide();
                } else
                {
                    $("#TempSectionGradebookSettingErrors").show();
                }
            };

            browse.on("rowChanged", function ()
            {
                updateSettingBrowse();
            });

            browse.on("browseLoaded." + browse.attr("id"), function () { updateSettingBrowse(); });
        }

        var initPreviousSectionLengths = function ()
        {
            //Dependency clearing logic for the selector eel.  The default dependency clearing logic interfered with the other logic to refresh the browse and would cause browses to duplicate, so we needed to override that here.
            $(this).on("click", function ()
            {
                var checkbox = skyward.controls.getValue($(this));
                if (checkbox == false)
                {
                    //First parent being the fieldset, second parent being the parent element of all of our inputs
                    var dmse = $(this).parents('.gradeWeightingSectionLengthSelectorDiv').last().find('div.previousSectionLengthsSelect input.dmsBackingData');
                    skyward.controls.clearValue(dmse);
                }
            });

            //This triggers when the Previous Section Lengths eel is modified and refreshes the browse with the new buckets based on the selected section lengths.
            $(this).parents('.gradeWeightingSectionLengthSelectorDiv').on("change", "div.previousSectionLengthsSelect input.dmsBackingData", function ()
            {
                //Action only triggers when section lengths are changed.  We disable section lengths on the teacher side, and in teacher tracker/section grade bucket details, so anything section-specific here is irrelevant
                //Also assume the calculation type is Grade Weighting because it has to be in order for the section lengths selector to show up
                var sectionLengthsToShow = skyward.controls.getValue($(this));
                var browse = $(this).parents('.previousSectionLengthsSelect').parents('.gradeWeightingSectionLengthSelectorDiv').parent().find('.gradeBucketWeightsBrowse');
                var controller = "CalculationGroupGradeBucket";
                var calculationType = "G";
                var renderInDetailsPanel = $(this).parents(".detailsPanel").length > 0;
                var calculationGroupGradeBucketID = skyward.controls.getValue($(this).parents('.gradeWeightingSectionLengthSelectorDiv').find('.calculationGroupGradeBucketIDHidden'));
                var sectionGradeBucketID = null;
                var isAdminDetails = false;
                var isTeacherTracker = false;
                refreshSettingsBrowse(browse, controller, calculationType, renderInDetailsPanel, calculationGroupGradeBucketID, sectionGradeBucketID, isAdminDetails, isTeacherTracker, $(this).parents('.workflow').length > 0, sectionLengthsToShow);
            });

            //This triggers when the calc type is changed, but only processes further than the first check if the calc type is grade weighted.  This is clearing the previous section length selected.  Really only relevant if they had previous section lengths selected when they loaded the screen, then changed the calc type to something else, then back to a grade weighted type.  Dependency logic correctly unchecks the Show Previous Section Lengths checkbox, but since the dependency logic for that checkbox only triggers on click, we need additional logic here to clear this selector as well.
            //Previous section lengths value only matters if the calc type is grade weighted, so no need to trigger this logic for other calc types.
            $("#editCalculationGroupGradeBucket").off("change", ".js-CalcTypeComboBox").on("change", ".js-CalcTypeComboBox", function ()
            {
                var selector = $(this);
                var sectionLengthsToShow = null;

                if (isGradeWeighted(skyward.controls.getValue(selector)))
                {
                    var dmse = $('#editCalculationGroupGradeBucket div.previousSectionLengthsSelect input.dmsBackingData');

                    if (dmse != null)
                    {
                        sectionLengthsToShow = skyward.controls.getValue(dmse);

                        if (sectionLengthsToShow != null && Object.keys(sectionLengthsToShow).length > 0)
                        {
                            skyward.controls.clearValue(dmse, true);
                            sectionLengthsToShow = skyward.controls.getValue(dmse);
                        }
                    }
                }

                changeCalculationType(selector, "CalculationGroupGradeBucket", sectionLengthsToShow);
            });
        };

        var events =
        {
            'ReorderClassRoster': reorderClassRoster,
            'ReorderClassRosterTeacherTracker': reorderClassRosterTeacherTracker,
            'ReorderClassRosterClassGroup': reorderClassRosterClassGroup,
            'initCumulativeWeightingBrowse': initCumulativeWeightingBrowse,
            'initTempSectionGradebookSettingsBrowse': initTempSectionGradebookSettingsBrowse,
            'initPreviousSectionLengths': initPreviousSectionLengths
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.window.registerLoadDOMCallback(initDefaultValues);
        skyward.window.registerLoadDOMCallback(overrideCheckLoadContent);
        skyward.events.registerEvents('gradebookSettings', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
/// <reference path="skyward.ui.modallayer.ts" />
/// <reference path="skyward.ui.window.ts"/>
/// <reference path="skyward.ui.calculatedfieldlist.js"/>
/// <reference path="skyward.base.searchCondition.ts"/>
(
    function (skyward, $, undefined)
    {
        skyward.filterbuilder = skyward.filterbuilder || {};

        var init = function (selector)
        {
            const filterBuilderLaunchButton = $(selector + " .filterBuilderLaunchButton");
            if (filterBuilderLaunchButton.length > 0)
            {
                const filterBuilderLaunchButtonData = filterBuilderLaunchButton.data();
                if (filterBuilderLaunchButtonData)
                {
                    if (filterBuilderLaunchButtonData.reparenterInputClass)
                    {
                        setupReparentingOnInputChange(selector, filterBuilderLaunchButtonData.reparenterInputClass);
                    }
                    if (filterBuilderLaunchButtonData.objectCodeEelId && filterBuilderLaunchButtonData.moduleCodeEelId)
                    {
                        setupCodeEELReparenting(selector, filterBuilderLaunchButtonData.objectCodeEelId, filterBuilderLaunchButtonData.moduleCodeEelId);
                    }
                }
            }

            filterBuilderLaunchButton.off("click.filterBuilder").on("click.filterBuilder", skyward.filterbuilder.showFilter);
            $(selector + " .filterBuilderAddGroup, .filterBuilderAddRow").off("click.filterBuilder").on("click.filterBuilder", addPart);
            $(selector + " .filterBuilderFieldSelect").off("click.filterBuilder").on("click.filterBuilder", skyward.filterbuilder.getTreeBrowse);
            $(selector + " .conditionTypesComboBox").off("change.filterBuilder").on("change.filterBuilder", getValueControl);
            $(selector + " .applyDistrictEntityFilter").off("change.filterBuilder").on("change.filterBuilder", updateDistrictEntityFilter);
            $(selector + " .checkbox.schemaObjectFilter").off("change.filterBuilder").on("change.filterBuilder", updateFriendlyQuery);
            $(selector + " .conditionValue").off("keydown.filterBuilder blur.filterBuilder dirty.filterBuilder change.filterBuilder")
                .on("keydown.filterBuilder", function ()
                {
                    $(this).data("promptUniqueId", null).data('environmentVariableBinding', null).data('enumCodeValue', null).prev(".svgHolder").html("");
                })
                .on("blur.filterBuilder dirty.filterBuilder change.filterBuilder", function ()
                {
                    $(this).removeClass("active");
                    updateFriendlyQuery();
                });

            $(selector + " .environmentVariablesContainer:not(.promptBuilder)")
                .siblings(".removeEnvironmentVariableButton").off('click.filterBuilder')
                .on('click.filterBuilder', hideEnvironmentVariables)
                .end()
                .siblings('.addEnvironmentVariableButton').first().off('click.filterBuilder')
                .on('click.filterBuilder', showEnvironmentVariables);

            $(selector + " .conditionGroupTypeRadioButtonGroup").find("input:radio").off("change.filterBuilder")
                .on("change.filterBuilder", function ()
                {
                    const radioButton = $(this);
                    const andOr = radioButton.val();
                    const conditionGroupControlsContainer = radioButton.closest(".conditionGroupControlsContainer");
                    conditionGroupControlsContainer.siblings(".andOrText").html(andOr);
                    conditionGroupControlsContainer.siblings(".condition").find(".andOrText").html(andOr);
                    updateFriendlyQuery();
                });

            $(selector + " .removeFilterBuilderCondition").off("click.filterBuilder")
                .on("click.filterBuilder", function ()
                {
                    removePart($(this).closest(".condition"));
                });

            $(selector + " .removeFilterBuilderGroupCondition").off("click.filterBuilder")
                .on("click.filterBuilder", function ()
                {
                    removePart($(this).closest(".conditionGroup"), true);
                });

            $(selector + " .filterViewerDisplay").off('change.filterBuilder')
                .on('change.filterBuilder', function ()
                {
                    updateFriendlyQuery($(this));
                });

            $(selector + " .filterViewValue").off("change.filterBuilder updateFilterViewerDisplay")
                .on("change.filterBuilder updateFilterViewerDisplay", updateFilterViewerDisplay)
                .each(updateFilterViewerDisplay);

            $(selector + " .js-bindingConditionValue").off('click.filterBuilder')
                .on('click.filterBuilder', function ()
                {
                    hideConditionValueSpan($(this));
                });
        };

        function checkIsReportMode(popupButton)
        {
            return (popupButton.data('mode') || "").toLowerCase() === "report";
        }

        var updateFilterViewerDisplay = function ()
        {
            const filterViewInput = $(this);
            const searchCondition = skyward.searchCondition.getFromJson(filterViewInput.data("filterCondition"), convertBindingsToFriendlyNames);
            const friendlyQuery = searchCondition.toFriendlyQuery();
            filterViewInput.siblings(".filterViewerDisplay").val(friendlyQuery);
        };

        skyward.filterbuilder.updateFilterViewerDisplay = function (filterViewInput)
        {
            updateFilterViewerDisplay.apply(filterViewInput);
        };

        skyward.filterbuilder.getFieldsUsedInFilterBuilder = function (conditionContainer, traverseExists, convertImages = true)
        {
            const searchCondition = extractNewConditionGroup(conditionContainer);
            const searchConditionFieldsData = searchCondition.getFieldsFromCondition(traverseExists);

            let filterFields = [];

            searchConditionFieldsData.forEach(fieldData =>
            {
                if (!fieldData.calculatedFieldName)
                {
                    const field = skyward.reporting.buildUsedInReportField(fieldData.fieldPath, fieldData.fieldName, fieldData.displayName, fieldData.displayPath, fieldData.fieldType, fieldData.parameters, false, fieldData.isOperation, false, convertImages);
                    filterFields.push(field);
                }
            });

            return filterFields;
        }

        var hideConditionValueSpan = function (span)
        {
            var spanData = span.data();

            if ("boolvalue" in spanData || "enumType" in spanData)
            {
                return;
            }
            var input = span.closest(".conditionValuesContainer").find(".js-valueConditionValue");

            span.off('click');
            span.setAllDataToNull();

            if (input.length)
            {
                skyward.controls.show(input, false);
                input.css("display", "");
                input.removeClass("hidden");
                input.addClass("js-conditionValue--active");
                span.addClass("hidden");
                span.removeClass("js-conditionValue--active");

                input.focus();
            }
        };

        var filterBuilderDialogs = skyward.filterbuilder.dialogs = (function ()
        {
            let dialogs = [];
            let self = {};

            self.register = function (dialog)
            {
                dialogs.push(dialog);
            };

            self.getCurrent = function ()
            {
                return dialogs[dialogs.length - 1];
            };

            self.closeCurrent = function ()
            {
                dialogs[dialogs.length - 1].close();
                dialogs.pop();
            };

            return self;
        })();

        var updateFriendlyQuery = function ()
        {
            const dialog = filterBuilderDialogs.getCurrent();

            if (dialog)
            {
                const container = dialog.content.find(".filterBuilder > .conditionsContainer");
                const searchCondition = extractNewConditionGroup(container);
                const schemaObjectFilterConditions = extractSchemaObjectSearchConditions(container);

                if (schemaObjectFilterConditions)
                {
                    // the main search condition will always be an "And" condition so we can add it to it directly
                    searchCondition.addCondition(schemaObjectFilterConditions);
                }

                const districtEntityFilter = extractNewDistrictEntityFilter(dialog.content.find(".districtEntityContainer"));

                if (districtEntityFilter)
                {
                    searchCondition.addCondition(districtEntityFilter);
                }

                const friendlyQueryDiv = dialog.content.find(".currentQuery").find("div");
                friendlyQueryDiv.empty();
                friendlyQueryDiv.html($("<p>").text(skyward.extensions.decodeHtml(searchCondition.toFriendlyQuery())));
            }
        };

        var addPart = function ()
        {
            const button = $(this);
            const buttonData = button.data();

            const builderButtonsDiv = button.parent(".builderButtons");

            const dataObjectFullName = buttonData.dataObjectFullName;

            const renderAndOr = button.hasClass("filterBuilderAddGroup") && builderButtonsDiv.siblings(".condition, .conditionGroup").length > 0;

            const filterBuilderData = button.closest(".filterBuilder").data();
            $.ajax({
                url: skyward.global.virtualDir + buttonData.addparturl,
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    dataObjectFullName: dataObjectFullName,
                    renderAndOr: renderAndOr,
                    andOr: builderButtonsDiv.siblings(".conditionGroupControlsContainer").find("input:checked").val(),
                    mode: buttonData.mode,
                    lookupModule: buttonData.module,
                    lookupObject: buttonData.object,
                    rootModule: buttonData.rootModule,
                    rootObject: buttonData.rootObject,
                    seekField: buttonData.field,
                    relationshipPath: buttonData.relationshipPath,
                    securitymodule: filterBuilderData.securitymodule,
                    securityobject: filterBuilderData.securityobject,
                    securityscreen: filterBuilderData.securityscreen,
                    routehash: filterBuilderData.routehash
                },
                success: function (data)
                {
                    $(data).insertBefore(builderButtonsDiv);
                    updateFriendlyQuery();
                    const currentPopupId = skyward.window.getCurrentPopupId();
                    const selector = ".modalLayerContainer[data-layerid='" + currentPopupId + "'] .filterBuilder";
                    skyward.window.notifyDOMLoad(selector);
                    const layerData = skyward.modalLayer.getLayerFromElement(".modalLayerContainer[data-layerid='" + currentPopupId + "']");
                    if (layerData && layerData.container)
                    {
                        layerData.container.resize();
                    }
                }
            });
        };

        var removePart = function (containerToRemove, isConditionGroup)
        {
            var andOr = containerToRemove.prev(".andOrText");
            if (andOr.length <= 0 && isConditionGroup) //removing the first container
            {
                andOr = containerToRemove.next(".andOrText");
            }
            andOr.remove();
            containerToRemove.remove();
            updateFriendlyQuery();

            var layerData = skyward.modalLayer.getLayerFromElement(".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "']");
            if (layerData && layerData.container)
            {
                layerData.container.resize();
            }
        };

        /* getTreeBrowse and getTreeBrowseForFieldToField supporting functions */

        function fieldColumnPopupMultiPanel(contents, data, events)
        {
            const jqContents = $(contents);

            const standardFilterButton =
            {
                text: "Select Standard Filters",
                click: events.standardFilterButtonClicked,
                icon: "Save",
                additionalClasses: ["standardFilterButton"]
            };
            const saveButton =
            {
                text: "Select Field",
                click: events.saveButtonClicked,
                icon: "Save",
                additionalClasses: ["filterSaveButton"]
            };
            const cancelButton =
            {
                text: "Cancel",
                click: "close",
                icon: "Cancel"
            };

            const options =
            {
                animationDuration: 0,
                draggable: true,
                closeOnClick: false
            };

            const buttons = data.showStandardFilterButton ? [standardFilterButton, saveButton, cancelButton] : [saveButton, cancelButton];

            const browseDialog = skyward.modalLayer.showDialog("Select Filter Field", jqContents, buttons, options);
            skyward.filterbuilder.fieldSelectorDialog = browseDialog;

            const container = filterBuilderDialogs.getCurrent().content.find(".filterBuilder > .conditionsContainer");

            browseDialog.bodyPromise.done(function ()
            {
                initializePanels(container, browseDialog, events, data);
            });

            const fieldSearchInput = browseDialog.content.find(".js-treebrowse__fieldSearchInput");
            const fieldSearchButton = browseDialog.content.find(".js-searchBoxButton");
            fieldSearchInput.on("enter", function ()
            {
                fieldSearchButton.click();
            });
        }

        function initializePanels(container, browseDialog, events, data)
        {
            const filterFields = skyward.filterbuilder.getFieldsUsedInFilterBuilder(container, false);
            let usedfields;
            if (data.fieldDataType)
            {
                usedfields = skyward.reporting.fields.buildFieldsListOfType(data.fieldDataType, filterFields, data.sectionID, true, true);
            }
            else
            {
                usedfields = skyward.reporting.fields.buildFieldsList(filterFields, data.sectionID, true, true);
            }

            let calculatedFields;
            if (data.fieldDataType)
            {
                calculatedFields = Object.values(skyward.reporting.calculatedFields.AllFieldsOfType(data.fieldDataType));
            }
            else
            {
                calculatedFields = Object.values(skyward.reporting.calculatedFields.AllFields());
            }
            const filteredCalculatedFields = skyward.calculatedFieldList.filterCalculatedFieldList(calculatedFields, data.rootModule, data.rootObject, data.relationshipPath, data.rootExistsPath);
            const convertedCalculatedFields = skyward.reporting.fields.buildCalculatedFieldsList(filteredCalculatedFields);

            const panelData =
                [{
                    selector: ".js-usedFieldsPanel",
                    fields: usedfields,
                    buildFieldPath: true
                },
                {
                    selector: ".js-calculatedFieldsPanel",
                    fields: convertedCalculatedFields,
                    buildFieldPath: false
                }];
            skyward.fieldselectionpanels.initializePanels(browseDialog.content, panelData, events.fieldSelected, events.treeBrowseLevelChanged);
        }

        function buildFieldColumnPopupDialog(contents, settings)
        {
            if (!settings.isReportMode)
            {
                settings.buildTreeBrowsePopup(contents);
            }
            else
            {
                const data =
                {
                    fieldDataType: settings.fieldDataType,
                    relationshipPath: settings.fieldSelectorControlData.relationshipPath,
                    rootExistsPath: settings.filterBuilderData.rootExistsPath,
                    dataModule: settings.filterBuilderData.dataModule,
                    dataObject: settings.filterBuilderData.dataObject,
                    rootModule: settings.filterBuilderData.rootModule,
                    rootObject: settings.filterBuilderData.rootObject,
                    sectionID: settings.filterBuilderData.sectionId,
                    seekToField: settings.seekToField,
                    showStandardFilterButton: settings.showStandardFilterButton
                };
                const events =
                {
                    fieldSelected: settings.fieldSelected,
                    standardFilterButtonClicked: settings.standardFilterButtonClicked,
                    saveButtonClicked: settings.saveButtonClicked,
                    treeBrowseLevelChanged: settings.treeBrowseLevelChanged
                };
                fieldColumnPopupMultiPanel(contents, data, events);
            }
        }

        skyward.filterbuilder.getTreeBrowse = function ()
        {
            const fieldSelectorControl = $(this);
            const fieldSelectorControlData = fieldSelectorControl.data();
            const filterBuilderData = fieldSelectorControl.closest(".filterBuilder").data();
            const isReportMode = checkIsReportMode(fieldSelectorControl);

            let currentRelationshipPath = "";

            var fieldColumnPopup = function ()
            {
                return $.ajax(skyward.global.virtualDir + filterBuilderData.buildTreeBrowsePath,
                    {
                        type: "POST",
                        dataType: "HTML",
                        data:
                        {
                            absoluteTreeBrowseObjectPath: fieldSelectorControlData.relationshipPath,
                            seekField: fieldSelectorControlData.absoluteFieldPath,
                            rootModule: filterBuilderData.rootModule,
                            rootObject: filterBuilderData.rootObject,
                            relationshipPath: fieldSelectorControlData.relationshipPath,
                            routehash: filterBuilderData.routehash,
                            securitymodule: filterBuilderData.securitymodule,
                            securityobject: filterBuilderData.securityobject,
                            securityscreen: filterBuilderData.securityscreen,
                            maxOneToManyNestedLevels: 10,
                            mode: fieldSelectorControlData.mode,
                            includeStandardFilterButton: filterBuilderData.includeStandardFilterButton,
                            browseId: filterBuilderData.browseid,
                            renderOneToMany: true, // We always show one to many relationships for the left side field
                            allowOneToManyBrowse: filterBuilderData.allowOneToManyBrowse,
                            renderOperationFields: true,
                            isExistsFilterBuilder: filterBuilderData.isExistsFilterBuilder,
                            isForFieldToField: false,
                            renderCalculatedFieldsPanel: filterBuilderData.includeCalculatedFields,
                            additionalFilterTypeName: filterBuilderData.additionalFilterTypeName
                        },
                        dataFilter: function (html)
                        {
                            return buildFilterBuilderPopupWrapper(filterBuilderData, html);
                        }
                    }
                );
            };

            var standardFilterButtonClicked = function ()
            {
                var jqThis = $(this);
                var standardFilterData = jqThis.data();
                var standardFilterName = standardFilterData.standardFilterName;
                fieldSelectorControl.data({
                    "fieldType": "standardFilter",
                    "standardFilterRelationshipPath": currentRelationshipPath,
                    "standardFilterId": standardFilterData.standardFilterId
                });
                fieldSelectorControl.find("span.anchorText").text(standardFilterName);
                fieldSelectorControl.nextAll(":not(.removeFilterBuilderCondition)").remove();

                var findPromptByStandardFilterId = function (prompt, standardFilterId)
                {
                    return prompt.StandardFilterId === standardFilterId;
                };
                var existingPrompt = skyward.reporting.prompts.promptCollection.find(findPromptByStandardFilterId, standardFilterData.standardFilterId);
                var existingPromptLabel = null;
                var existingPromptId = null;

                if (existingPrompt)
                {
                    existingPromptLabel = existingPrompt.Label;
                    existingPromptId = existingPrompt.PromptUniqueId;
                }

                $.ajax({
                    url: skyward.global.virtualDir + "SkySys/Filter/GetStandardFilterValueControlData",
                    type: "POST",
                    dataType: "JSON",
                    data: {
                        standardFilterId: standardFilterData.standardFilterId,
                        reportPromptId: existingPromptId,
                        reportPromptLabel: existingPromptLabel || standardFilterData.standardFilterName
                    },
                    success: async function (data)
                    {
                        if (data.newPrompt)
                        {
                            data.newPrompt.Order = skyward.reporting.prompts.promptCollection.length + 1;
                            skyward.reporting.prompts.promptCollection.Set(data.newPrompt);
                        }

                        const processedHtml = await skyward.global.processViewPartHtml(data.valueControlHtml);
                        $(processedHtml).insertAfter(fieldSelectorControl);
                        updateFriendlyQuery();
                        var popupId = skyward.window.getCurrentPopupId();
                        $(".modalLayerContainer[data-layerid='" + popupId + "'] .filterBuilder").addClass("layerid" + popupId);
                        var selector = ".layerid" + popupId;
                        skyward.window.notifyDOMLoad(selector);
                    }
                });

                skyward.window.closePopup();
            };

            var saveButtonClicked = function (_event, dialog)
            {
                let rowData;
                if (isReportMode)
                {
                    rowData = skyward.fieldselectionpanels.getSelectedField(dialog.content);
                }
                else
                {
                    rowData = skyward.treebrowse.getSelectedFieldData(dialog.content);
                }

                selectFieldFromRow(rowData);
            };

            var treeBrowseSave = function (_event, _treeBrowseData, rowData)
            {
                selectFieldFromRow(rowData);
            }

            var fieldSelected = function (_event, rowData)
            {
                selectFieldFromRow(rowData);
            }

            var selectFieldFromRow = function (rowData)
            {
                if (rowData)
                {
                    updateFieldSelector(fieldSelectorControl, rowData);
                }

                skyward.window.closePopup();
            };

            var treeBrowseLevelChanged = function (_event, data)
            {
                const saveButtonTextSpan = skyward.filterbuilder.fieldSelectorDialog.footer.find(".filterSaveButton .modalContentFooter__buttonText");
                const saveButton = skyward.filterbuilder.fieldSelectorDialog.footer.find(".filterSaveButton");
                const standardFilterButton = skyward.filterbuilder.fieldSelectorDialog.footer.find(".standardFilterButton");

                const fieldPath = data.getCurrentBreadcrumb().positionObjectPath;
                const indexOfFirstPeriod = fieldPath.indexOf(".");

                if (indexOfFirstPeriod > 0)
                {
                    currentRelationshipPath = fieldPath.substring(indexOfFirstPeriod + 1);
                }
                else
                {
                    currentRelationshipPath = "";
                }

                standardFilterButton.toggle(data.standardFilterName && data.includeStandardFilterButton === true ? true : false).data("standardFilterName", data.standardFilterName).data("standardFilterId", data.standardFilterId).
                    find(".buttonText").text("Select " + data.standardFilterName);

                if (data.isDataField || !data.selectedRecord.length)
                {
                    saveButtonTextSpan.text("Select Field");
                    saveButton.show();
                }
                else if (data.isCalculatedField)
                {
                    saveButtonTextSpan.text("Select Calculated Field");
                    saveButton.show();
                }
                else if (data.selectedRecord.length > 0 && data.getSelectedFieldData().relationshipType === "OneToMany")
                {
                    saveButtonTextSpan.text("Select Exists");
                    saveButton.show();
                }
                else
                {
                    saveButton.hide();
                }
            };

            function fieldColumnPopupTreeBrowse(contents)
            {
                const saveButton =
                {
                    text: "Select Field",
                    "click": saveButtonClicked,
                    "icon": "Save",
                    additionalClasses: ["filterSaveButton"]
                };
                const cancelButton =
                {
                    text: "Cancel",
                    "click": "close",
                    "icon": "Cancel"
                };
                const standardFilterButton =
                {
                    text: "Select Standard Filters",
                    "click": standardFilterButtonClicked,
                    "icon": "Save",
                    additionalClasses: ["standardFilterButton"]
                };

                const options =
                {
                    animationDuration: 0,
                    draggable: true,
                    closeOnClick: false
                };
                const jqContents = $(contents);

                const buttons = [];
                if (filterBuilderData.includeStandardFilterButton)
                {
                    buttons.push(standardFilterButton);
                }
                buttons.push(saveButton, cancelButton);

                const treeBrowseId = jqContents.find(".treeBrowse").data("lookupId");

                const browseDialog = skyward.modalLayer.showDialog("Select Filter Field", jqContents, buttons, options);
                skyward.filterbuilder.fieldSelectorDialog = browseDialog;

                browseDialog.content.on("treeBrowseLevelChanged", treeBrowseLevelChanged).on("treeBrowseRowChange", treeBrowseLevelChanged);
                browseDialog.content.on("treeBrowseSave", treeBrowseSave);
                if (filterBuilderData.includeCalculatedFields)
                {
                    browseDialog.content.one("treeBrowseInitialize", function (_event, treeBrowseData)
                    {
                        skyward.calculatedFieldList.updateCalculatedFieldList(
                            treeBrowseData,
                            Object.values(skyward.reporting.calculatedFields.AllFields()),
                            undefined,
                            fieldSelectorControlData.rootModule,
                            fieldSelectorControlData.rootObject,
                            fieldSelectorControlData.relationshipPath,
                            filterBuilderData.rootExistsPath
                        );
                    });
                }

                browseDialog.bodyPromise.done(function ()
                {
                    browseDialog.content.parent().find(".standardFilterButton").hide();
                });

                const treeBrowseLoaded = $.Deferred();
                browseDialog.content.one("treeBrowseContentLoaded", treeBrowseLoaded.resolve);
                $.whenAll([browseDialog.animationPromise, treeBrowseLoaded]).done(function ()
                {
                    skyward.treebrowse.seekToField(treeBrowseId);
                });
            }

            fieldColumnPopup().done(function (contents)
            {
                const settings =
                {
                    buildTreeBrowsePopup: fieldColumnPopupTreeBrowse,
                    fieldDataType: null,
                    filterBuilderData: filterBuilderData,
                    fieldSelectorControlData: fieldSelectorControlData,
                    isReportMode: isReportMode,
                    saveButtonClicked: saveButtonClicked,
                    fieldSelected: fieldSelected,
                    seekToField: true,
                    showStandardFilterButton: filterBuilderData.includeStandardFilterButton,
                    standardFilterButtonClicked: standardFilterButtonClicked,
                    treeBrowseLevelChanged: treeBrowseLevelChanged
                };
                buildFieldColumnPopupDialog(contents, settings);
            });
        };

        skyward.filterbuilder.getTreeBrowseForFieldToField = function (valueBox)
        {
            const fieldSelectorControl = valueBox.closest(".condition").find(".filterBuilderFieldSelect");
            const fieldSelectorControlData = fieldSelectorControl.data();
            const filterBuilderData = fieldSelectorControl.closest(".filterBuilder").data();
            const conditionValueContainer = valueBox.closest(".conditionValuesContainer");
            const isReportMode = checkIsReportMode(fieldSelectorControl);

            let browseDialog;
            let rootModule;
            let rootObject;
            let relationshipPath;
            let lookupModule;
            let lookupObject;
            let fieldDataType;

            if (fieldSelectorControlData)
            {
                rootModule = filterBuilderData.fieldToFieldRootModule || filterBuilderData.rootModule;
                rootObject = filterBuilderData.fieldToFieldRootObject || filterBuilderData.rootObject;
                relationshipPath = filterBuilderData.fieldToFieldRelationshipPath || filterBuilderData.relationshipPath;
                lookupModule = fieldSelectorControlData.module || rootModule;
                lookupObject = fieldSelectorControlData.object || rootObject;

                if (fieldSelectorControlData.calculatedFieldName)
                {
                    fieldDataType = skyward.reporting.calculatedFields.Get(fieldSelectorControlData.calculatedFieldName).dataType.split(' ')[0];
                }
                else
                {
                    fieldDataType = fieldSelectorControlData.fieldType.split(' ')[0];
                }
            }

            var fieldColumnPopup = function ()
            {
                return $.ajax(skyward.global.virtualDir + filterBuilderData.buildTreeBrowsePath,
                    {
                        type: "POST",
                        dataType: "HTML",
                        data:
                        {
                            lookupModule: lookupModule,
                            lookupObject: lookupObject,
                            rootModule: rootModule,
                            rootObject: rootObject,
                            relationshipPath: relationshipPath,
                            absoluteTreeBrowseObjectPath: relationshipPath,
                            routehash: filterBuilderData.routehash,
                            securitymodule: filterBuilderData.securitymodule,
                            securityobject: filterBuilderData.securityobject,
                            securityscreen: filterBuilderData.securityscreen,
                            mode: fieldSelectorControlData.mode,
                            browseId: filterBuilderData.browseid,
                            renderOneToMany: filterBuilderData.allowOneToManyBrowse,
                            fieldDataType: fieldDataType,
                            allowOneToManyBrowse: filterBuilderData.allowOneToManyBrowse,
                            renderOperationFields: !filterBuilderData.isExistsFilterBuilder,
                            isExistsFilterBuilder: filterBuilderData.isExistsFilterBuilder,
                            isForFieldToField: true,
                            renderCalculatedFieldsPanel: filterBuilderData.includeCalculatedFields,
                        },
                        dataFilter: function (html)
                        {
                            return buildFilterBuilderPopupWrapper(filterBuilderData, html);
                        }
                    });
            };

            var saveButtonClicked = function (_event, dialog)
            {
                let rowData;
                if (isReportMode)
                {
                    rowData = skyward.fieldselectionpanels.getSelectedField(dialog.content);
                }
                else
                {
                    rowData = skyward.treebrowse.getSelectedFieldData(dialog.content);
                }

                selectFieldFromRow(rowData);
            };

            var treeBrowseSave = function (_event, _treeBrowseData, rowData)
            {
                selectFieldFromRow(rowData);
            }

            var fieldSelected = function (_event, rowData)
            {
                selectFieldFromRow(rowData);
            }

            var selectFieldFromRow = function (rowData)
            {
                if (rowData)
                {
                    let fieldData = {};
                    let existPathToUse = null;

                    const allExistPathsToCurrentExist = filterBuilderData.allExistPathsToCurrentExist;
                    if (allExistPathsToCurrentExist && allExistPathsToCurrentExist.length)
                    {
                        //Sort descending by number of relationships
                        allExistPathsToCurrentExist.sort(function (first, second)
                        {
                            const firstLength = first.split(".").length;
                            const secondLength = second.split(".").length;

                            if (firstLength > secondLength)
                            {
                                return -1;
                            }
                            if (firstLength < secondLength)
                            {
                                return 1;
                            }
                            return 0;
                        })

                        if (rowData.absoluteFieldPath)
                        {
                            existPathToUse = allExistPathsToCurrentExist.find(function (existPath) { return rowData.absoluteFieldPath.startsWith(existPath + "."); })
                        }
                    }

                    if (rowData.id)
                    {
                        fieldData =
                        {
                            fieldPath: null,
                            calculatedFieldName: rowData.id,
                            fieldType: rowData.dataType,
                            isCalculatedField: true,
                            isOperation: false,
                            parameters: rowData.parameters
                        };
                    }
                    else if (filterBuilderData.isExistsFilterBuilder === true && existPathToUse)
                    {
                        fieldData =
                        {
                            fieldPath: existPathToUse,
                            fieldName: rowData.absoluteFieldPath.substring(existPathToUse.length + 1),
                            displayName: rowData.displayName,
                            displayPathText: rowData.displayPathText,
                            fieldType: rowData.fieldType,
                            isCalculatedField: false,
                            isOperation: rowData.isOperation,
                            parameters: rowData.parameters,
                            existsPath: existPathToUse,
                            rootModule: filterBuilderData.fieldToFieldRootModule,
                            rootObject: filterBuilderData.fieldToFieldRootObject
                        };
                    }
                    else
                    {
                        fieldData =
                        {
                            fieldPath: rowData.fieldPath,
                            fieldName: rowData.absoluteFieldPath,
                            displayName: rowData.displayName,
                            displayPathText: rowData.displayPathText,
                            fieldType: rowData.fieldType,
                            isCalculatedField: false,
                            isOperation: rowData.isOperation,
                            parameters: rowData.parameters,
                            rootModule: filterBuilderData.fieldToFieldRootModule,
                            rootObject: filterBuilderData.fieldToFieldRootObject
                        };
                    }

                    setConditionSpanValue(conditionValueContainer, rowData.displayPathText, fieldData, rowData.svgClass);
                }

                //There's two popups open at this point so close both
                skyward.window.closePopup();
                skyward.window.closePopup();
            };

            var treeBrowseLevelChanged = function (_event, data)
            {
                const saveButtonTextSpan = skyward.filterbuilder.fieldSelectorDialog.footer.find(".filterSaveButton .modalContentFooter__buttonText");
                const saveButton = skyward.filterbuilder.fieldSelectorDialog.footer.find(".filterSaveButton");

                if (data.isDataField)
                {
                    saveButtonTextSpan.text("Select Field");
                    saveButton.show();
                }
                else if (data.isCalculatedField)
                {
                    saveButtonTextSpan.text("Select Calculated Field");
                    saveButton.show();
                }
                else
                {
                    saveButton.hide();
                }
            };

            function fieldColumnPopupTreeBrowse(contents)
            {
                const saveButton =
                {
                    text: "Select Field",
                    click: saveButtonClicked,
                    icon: "Save",
                    additionalClasses: ["filterSaveButton"]
                };
                const cancelButton =
                {
                    text: "Cancel",
                    click: "close",
                    icon: "Cancel"
                };

                const options =
                {
                    animationDuration: 0,
                    draggable: true,
                    closeOnClick: false
                };
                const jqContents = $(contents);
                const buttons = [saveButton, cancelButton];

                skyward.filterbuilder.fieldSelectorDialog = browseDialog = skyward.modalLayer.showDialog("Select Filter Field", jqContents, buttons, options);

                browseDialog.content.on("treeBrowseLevelChanged", treeBrowseLevelChanged).on("treeBrowseRowChange", treeBrowseLevelChanged);
                browseDialog.content.on("treeBrowseSave", treeBrowseSave);
                if (filterBuilderData.includeCalculatedFields)
                {
                    browseDialog.content.one("treeBrowseInitialize", function (_event, treeBrowseData)
                    {
                        skyward.calculatedFieldList.updateCalculatedFieldList(
                            treeBrowseData,
                            Object.values(skyward.reporting.calculatedFields.AllFieldsOfType(fieldDataType)),
                            undefined,
                            fieldSelectorControlData.rootModule,
                            fieldSelectorControlData.rootObject,
                            fieldSelectorControlData.relationshipPath,
                            filterBuilderData.rootExistsPath
                        );
                    });
                }
            }

            fieldColumnPopup().done(function (contents)
            {
                const settings =
                {
                    buildTreeBrowsePopup: fieldColumnPopupTreeBrowse,
                    fieldDataType: fieldDataType,
                    filterBuilderData: filterBuilderData,
                    fieldSelected: fieldSelected,
                    fieldSelectorControlData: fieldSelectorControlData,
                    isReportMode: isReportMode,
                    saveButtonClicked: saveButtonClicked,
                    seekToField: false,
                    showStandardFilterButton: false,
                    standardFilterClick: undefined,
                    treeBrowseLevelChanged: treeBrowseLevelChanged
                };
                buildFieldColumnPopupDialog(contents, settings);
            });
        };

        var buildFilterBuilderPopupWrapper = function (filterBuilderData, html)
        {
            if (filterBuilderData.wrapperClassName)
            {
                return `<div class='${filterBuilderData.wrapperClassName}'>${html}</div>`;
            }
            else
            {
                return `<div style='max-height: 500px;'>${html}</div>`;
            }
        };

        var setConditionSpanValue = skyward.filterbuilder.setConditionSpanValue = function (conditionValuesContainer, displayValue, data, svgClass, triggerChange)
        {
            var input = conditionValuesContainer.find(".js-valueConditionValue");
            var span = conditionValuesContainer.find(".js-bindingConditionValue");

            triggerChange = (triggerChange == undefined) ? true : triggerChange;

            //reset the span and input
            span.setAllDataToNull();
            span.text("");
            span.removeClass("hidden");
            span.addClass("js-conditionValue--active");
            if (input.length)
            {
                skyward.controls.hide(input, false);
                input.removeClass("js-conditionValue--active");
                skyward.controls.clearValue(input);

                span.on('click', function () { hideConditionValueSpan($(this)); });
            }

            if (data.fieldType && data.fieldType.indexOf("Enum") >= 0)
            {
                data.enumType = data.fieldType;
            }

            span.data(data);
            span.text(displayValue);
            if (svgClass)
            {
                var svg = skyward.svg.getSvg(svgClass, "TreeBrowse");
                var svgHolder = makeSvgHolder();
                svgHolder.html(svg);
                span.prepend(svgHolder);
            }

            if (triggerChange)
            {
                span.trigger("change");
            }

            updateFriendlyQuery();
        };

        function buildFieldSelectorData(rowData)
        {
            let data =
            {
                module: rowData.fieldModule,
                object: rowData.fieldObject,
                field: undefined,
                fieldPath: undefined,
                absoluteFieldPath: undefined,
                fieldType: undefined,
                displayName: rowData.displayName,
                displayPathText: rowData.displayPathText,
                selectedFieldRelationshipPath: undefined,
                calculatedFieldName: undefined,
                isCalculated: false,
                isOperation: rowData.isOperation,
                parameters: rowData.parameters
            };

            if (rowData.isCalculatedField)
            {
                data.calculatedFieldName = rowData.id;
                data.fieldType = rowData.fieldType;
                data.isCalculated = true;
            }
            else if (rowData.isRelationship)
            {
                data.field = rowData.relationshipName;
                data.fieldPath = rowData.relationshipPath,
                data.fieldType = rowData.fieldType;
                data.absoluteFieldPath = rowData.relationshipPath;
                data.selectedFieldRelationshipPath = rowData.relationshipPath ?? "";
            }
            else
            {
                const lasIndexOfDot = rowData.absoluteFieldPath.lastIndexOf('.');
                const fieldName = rowData.absoluteFieldPath.substring(lasIndexOfDot + 1);

                data.field = fieldName;
                data.fieldPath = rowData.fieldName, // {Root Object Name}.{Absolute Field Path}
                data.absoluteFieldPath = rowData.absoluteFieldPath;
                data.fieldType = rowData.format ?? rowData.fieldType,
                data.selectedFieldRelationshipPath = rowData.relationshipPath ?? ""; // Entire relationship path from Root Object to Field
            }

            return data;
        }

        var updateFieldSelector = function (fieldSelectorControl, rowData)
        {
            fieldSelectorControl.data(buildFieldSelectorData(rowData));
            fieldSelectorControl.find("span").html(rowData.displayPathText);
            fieldSelectorControl.removeClass("active");
            fieldSelectorControl.parent().find(".conditionValuesContainer, .conditionRangeValuesWrapper").remove();

            const filterBuilderData = fieldSelectorControl.closest(".filterBuilder").data();

            $.ajax({
                url: skyward.global.virtualDir + "SkySys/Filter/GetConditionTypeComboBox",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    fieldType: rowData.isCalculatedField ? rowData.fieldType : (rowData.format ?? rowData.fieldType),
                    absoluteFieldPath: rowData.absoluteFieldPath,
                    rootModule: filterBuilderData.rootModule,
                    rootObject: filterBuilderData.rootObject,
                    securitymodule: filterBuilderData.securitymodule,
                    securityobject: filterBuilderData.securityobject,
                    securityscreen: filterBuilderData.securityscreen,
                    routehash: filterBuilderData.routehash,
                    includeList: rowData.id == null
                },
                success: function (data)
                {
                    const conditionTypesComboBox = fieldSelectorControl.siblings(".conditionTypesComboBox");
                    const newComboBox = $(data);
                    if (conditionTypesComboBox.length > 0)
                    {
                        conditionTypesComboBox.replaceWith(newComboBox);
                    }
                    else
                    {
                        $(newComboBox).insertAfter(fieldSelectorControl);
                    }
                    updateFriendlyQuery();
                    const selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
                    skyward.window.notifyDOMLoad(selector);
                    if (rowData.triggerType === "exists")
                    {
                        newComboBox.val("Exists");
                        newComboBox.change();
                    }
                    else if (rowData.triggerType === "notExists")
                    {
                        newComboBox.val("NotExists");
                        newComboBox.change();
                    }
                }
            });
        };

        var makeSvgHolder = function ()
        {
            return $("<span/>").addClass("svgHolder");
        };

        var getValueControl = function ()
        {
            const combo = $(this);
            combo.find(".placeholder").remove();
            combo.removeClass("active");

            const filterBuilderData = combo.closest(".filterBuilder").data();

            const conditionType = combo.val();

            const getValueControls = conditionType.indexOf("Null") < 0 && conditionType.indexOf("True") < 0 && conditionType.indexOf("False") < 0;
            if (getValueControls)
            {
                const fieldSelectData = combo.siblings(".filterBuilderFieldSelect").first().data();
                const postdata =
                {
                    conditionType: conditionType,
                    fieldType: fieldSelectData.fieldType,
                    absoluteFieldPath: fieldSelectData.absoluteFieldPath,
                    rootobject: fieldSelectData.rootObject,
                    rootmodule: fieldSelectData.rootModule,
                    routehash: filterBuilderData.routehash,
                    securitymodule: filterBuilderData.securitymodule,
                    securityobject: filterBuilderData.securityobject,
                    securityscreen: filterBuilderData.securityscreen,
                    applyDistrictEntityFilter: filterBuilderData.applyDistrictEntityFilter,
                    fieldToFieldRootModule: filterBuilderData.fieldToFieldRootModule,
                    fieldToFieldRootObject: filterBuilderData.fieldToFieldRootObject,
                    fieldToFieldRelationshipPath: filterBuilderData.fieldToFieldRelationshipPath,
                    rootExistsPath: filterBuilderData.rootExistsPath,
                    allExistPathsToCurrentExist: JSON.stringify(filterBuilderData.allExistPathsToCurrentExist),
                    districtVariables: JSON.stringify(filterBuilderData.districtVariables),
                    applyFiscalYearOrSchoolYearFilterToValueControl: filterBuilderData.applyFiscalYearOrSchoolYearFilterToValueControl,
                    saveEnvironmentVariablesAsBindings: filterBuilderData.saveEnvironmentVariablesAsBindings,
                    includeStandardFilterButton: filterBuilderData.includeStandardFilterButton,
                    includeCalculatedFields: filterBuilderData.includeCalculatedFields,
                    calculatedFields: JSON.stringify(skyward.reporting.calculatedFields.Get(fieldSelectData.calculatedFieldName)),
                    importID: filterBuilderData.importId,
                    sectionID: filterBuilderData.sectionId
                };

                $.ajax({
                    url: skyward.global.virtualDir + filterBuilderData.getValueControlAction,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: postdata,
                    success: function (data)
                    {
                        const valueDiv = $(data);
                        combo.parent().find(".conditionValuesContainer").remove();
                        combo.parent().find(".conditionRangeValuesWrapper").remove();
                        valueDiv.insertAfter(combo);
                        const selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
                        skyward.window.notifyDOMLoad(selector);
                        valueDiv.find(".addEnvironmentVariableButton").each(function ()
                        {
                            const environmentVariableLauncher = $(this);
                            environmentVariableLauncher.on("click", showEnvironmentVariables);
                        });
                    }
                });
            }
            else
            {
                combo.parent().find(".conditionValuesContainer").remove();
                combo.parent().find(".conditionRangeValuesWrapper").remove();
            }
            updateFriendlyQuery();
        };

        var updateDistrictEntityFilter = function ()
        {
            var checkbox = $(this);
            var isChecked = checkbox.is(":checked");
            skyward.filterbuilder.originalPopupButton.data("applyDistrictEntityFilter", isChecked);
            checkbox.closest(".fieldWrapper").siblings(".hideWhenUnchecked").toggle(isChecked);
            updateFriendlyQuery();
        };

        var getEnvironmentVariableElements = function (button)
        {
            var result =
            {
                shown: button.parent().find(".environmentVariablesContainer, .environmentVariablesContainer .environmentVariablesCombo, .removeEnvironmentVariableButton"),
                // TODO: Remove datepicker-trigger & datepicker-wrapper in PR 6145635
                hidden: button.parent().find("js-valueConditionValue, .datepicker-trigger, .datepicker-wrapper, sky-datepicker, .addEnvironmentVariableButton")
            };
            return result;
        };

        var hideEnvironmentVariables = function ()
        {
            var elements = getEnvironmentVariableElements($(this));
            elements.shown.addClass("hidden");
            elements.hidden.removeClass("hidden");
            var selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
            skyward.window.notifyDOMLoad(selector);
        };

        var showEnvironmentVariables = function ()
        {
            var elements = getEnvironmentVariableElements($(this));
            elements.hidden.addClass("hidden");
            elements.shown.removeClass("hidden");
            var selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
            skyward.window.notifyDOMLoad(selector);
        };

        var getFilterBuilderFromServer = function (removeInvalidFields, popupButton)
        {
            if (popupButton.hasClass("ui-disabled"))
            {
                return;
            }

            const popupButtonData = popupButton.data();
            const filterValueInput = popupButton.siblings(".filterViewValue");
            const filterCondition = filterValueInput.data("filterCondition");
            const isReportMode = checkIsReportMode(popupButton);
            const includeCalculatedFields = isReportMode && popupButtonData.includeCalculatedFields;

            let allExistPathsToCurrentExist = [];
            if (popupButtonData.allExistPathsToCurrentExist && popupButtonData.allExistPathsToCurrentExist.length)
            {
                // copy array to prevent updating popupButtonData when allExistPathsToCurrentExist is updated
                allExistPathsToCurrentExist = Array.from(popupButtonData.allExistPathsToCurrentExist);
            }
            if (popupButtonData.rootExistsPath)
            {
                allExistPathsToCurrentExist.push(popupButtonData.rootExistsPath);
            }

            let postData =
            {
                importID: popupButtonData.importId,
                sectionID: popupButtonData.sectionId,
                lookupModule: popupButtonData.module,
                lookupObject: popupButtonData.object,
                rootModule: popupButtonData.rootModule,
                rootObject: popupButtonData.rootObject,
                relationshipPath: popupButtonData.relationshipPath,
                filterCondition: skyward.extensions.encodeHtml(typeof filterCondition === "object" ? JSON.stringify(filterCondition) : filterCondition),
                routeHash: popupButtonData.routehash,
                includeStandardFilterButton: popupButtonData.includeStandardFilterButton,
                securitymodule: popupButtonData.securitymodule,
                securityobject: popupButtonData.securityobject,
                securityscreen: popupButtonData.securityscreen,
                removeInvalidFields: removeInvalidFields,
                browseId: popupButtonData.browseId,
                applyDistrictEntityFilter: popupButtonData.applyDistrictEntityFilter,
                allowOneToManyBrowse: popupButtonData.allowOneToManyBrowse,
                fieldToFieldRootModule: popupButtonData.fieldToFieldRootModule,
                fieldToFieldRootObject: popupButtonData.fieldToFieldRootObject,
                fieldToFieldRelationshipPath: popupButtonData.fieldToFieldRelationshipPath,
                rootExistsPath: popupButtonData.rootExistsPath,
                allExistPathsToCurrentExist: JSON.stringify(allExistPathsToCurrentExist),
                isExistsFilterBuilder: popupButtonData.isExistsFilterBuilder,
                districtVariables: JSON.stringify(popupButtonData.districtVariables),
                applyFiscalYearOrSchoolYearFilterToValueControl: popupButtonData.applyFiscalYearOrSchoolYearFilterToValueControl,
                saveEnvironmentVariablesAsBindings: popupButtonData.saveEnvironmentVariablesAsBindings,
                includeCalculatedFields: includeCalculatedFields,
            };

            if (isReportMode)
            {
                if (includeCalculatedFields)
                {
                    postData.calculatedFields = JSON.stringify(skyward.reporting.calculatedFields.AllFields());
                }
                postData.reportPrompts = skyward.reporting.prompts.promptCollection.toJsonString();
            }

            $.ajax({
                url: skyward.global.virtualDir + popupButtonData.actionPath,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    const modalTitle = "Filter Builder";
                    const dialog = skyward.modalLayer.showDialog(modalTitle, data.html, getFilterBuilderButtons(data.invalidFields, popupButton), { width: (skyward.window.clientWidth * .95), draggable: true, closeOnClick: false });
                    $.when(dialog.bodyPromise).then(function ()
                    {
                        const selector = ".modalLayerContainer[data-layerid='" + skyward.window.getCurrentPopupId() + "'] .filterBuilder";
                        skyward.window.notifyDOMLoad(selector);
                        dialog.animateModalContents();
                        filterBuilderDialogs.register(dialog);
                        updateFriendlyQuery();
                    });
                    if (skyward.filterbuilder.originalPopupButton == popupButton)
                    {
                        dialog.modalLayer.beforeClose = function (layer, reason)
                        {
                            if (reason !== "removeInvalidFields")
                            {
                                skyward.filterbuilder.originalPopupButton = null;
                            }
                        };
                    }
                    return data;
                }
            });
        };

        var getFilterBuilderButtons = function (invalidFields, popupButton)
        {
            let buttons = [];

            if (!invalidFields)
            {
                buttons.push({
                    text: "Save",
                    icon: "Save",
                    "click": function ()
                    {
                        const button = $(this);
                        if (!button.hasClass("ui-disabled"))
                        {
                            const searchCondition = buildNewSearchCondition();

                            const validationMessage = searchCondition.getValidationMessage();
                            if (validationMessage)
                            {
                                skyward.modalLayer.showDialog("Invalid Filter", validationMessage, [{ text: "Close", icon: "Close" }]);
                            }
                            else
                            {
                                updateFilter(popupButton, searchCondition, $(this));
                            }
                        }
                    }
                });
            }
            else
            {
                buttons.push({
                    text: "Remove Invalid Fields",
                    icon: "Delete",
                    "click": function (e, dialog)
                    {
                        filterBuilderDialogs.closeCurrent();
                        getFilterBuilderFromServer(true, popupButton);
                    }
                });
            }

            buttons.push({ text: "Cancel", icon: "Cancel", click: filterBuilderDialogs.closeCurrent });
            return buttons;
        };

        skyward.filterbuilder.showFilter = function (event)
        {
            const popupButton = $(event.target);
            if (!skyward.filterbuilder.originalPopupButton)
            {
                skyward.filterbuilder.originalPopupButton = popupButton;
            }

            getFilterBuilderFromServer(false, popupButton);
        };

        skyward.filterbuilder.updateFilter = function (popupButton, newSearchCondition)
        {
            updateFilter(popupButton, newSearchCondition);
        };

        function updateFilter(popupButton, newSearchCondition, clickedSaveButton)
        {
            var filterBuilderDialog = filterBuilderDialogs.getCurrent();
            var popupButtonData = popupButton.data();
            var filterValueInput = popupButton.siblings(".filterViewValue");
            var oldSearchCondition = filterValueInput.data("filterCondition");
            var oldSearchConditionJSON = oldSearchCondition ? skyward.extensions.encodeHtml(typeof oldSearchCondition === "object" ? JSON.stringify(oldSearchCondition) : oldSearchCondition) : "";
            var newSearchConditionJSON = newSearchCondition ? newSearchCondition.toJSON() : "null";

            var filterBuilderData = popupButtonData;

            if (clickedSaveButton)
            {
                clickedSaveButton.addClass("ui-disabled");
                filterBuilderData = filterBuilderDialog.content.find(".filterBuilder").data();
            }

            if (popupButtonData.isExistsFilterBuilder)
            {
                updateFilterSucess({
                    conditionChanged: newSearchConditionJSON !== oldSearchConditionJSON,
                    filterCondition: newSearchConditionJSON

                }, popupButton, clickedSaveButton);
            }
            else
            {
                $.ajax({
                    url: skyward.global.virtualDir + "SkySys/Filter/GetSearchConditionXml",
                    type: "POST",
                    datatype: "JSON",
                    data:
                    {
                        newFilterCondition: newSearchConditionJSON,
                        oldFilterCondition: oldSearchConditionJSON,
                        routehash: filterBuilderData.routehash,
                        securitymodule: filterBuilderData.securitymodule,
                        securityobject: filterBuilderData.securityobject,
                        securityscreen: filterBuilderData.securityscreen,
                        districtVariables: JSON.stringify(filterBuilderData.districtVariables),
                        saveEnvironmentVariablesAsBindings: filterBuilderData.saveEnvironmentVariablesAsBindings
                    },
                    success: function (data)
                    {
                        updateFilterSucess(data, popupButton, clickedSaveButton);
                    },
                    error: function ()
                    {
                        if (clickedSaveButton)
                        {
                            clickedSaveButton.removeClass("ui-disabled");
                        }
                    }
                });
            }
        }

        function updateFilterSucess(data, popupButton, clickedSaveButton)
        {
            const filterBuilderDialog = filterBuilderDialogs.getCurrent();
            const filterValueInput = popupButton.siblings(".filterViewValue");
            const isReportMode = checkIsReportMode(popupButton);
            let filterCondition = null;

            if (clickedSaveButton)
            {
                filterBuilderDialogs.closeCurrent();
            }
            if (data.conditionChanged)
            {
                if (data.filterCondition)
                {
                    filterCondition = JSON.parse(data.filterCondition);
                }

                if (data.parameters)
                {
                    filterValueInput.data("parameters", data.parameters);
                }

                if (data.filterSchemaFields)
                {
                    filterValueInput.data("filterSchemaFields", data.filterSchemaFields);
                }

                filterValueInput.data("filterCondition", filterCondition);

                if (!filterCondition)
                {
                    popupButton.removeClass("hasFilterCondition").addClass("noFilterCondition");
                }
                else
                {
                    popupButton.removeClass("noFilterCondition").addClass("hasFilterCondition");
                }

                const searchCondition = skyward.searchCondition.getFromJson(data.filterCondition, convertBindingsToFriendlyNames);
                const friendlyQuery = searchCondition.toFriendlyQuery();

                if (clickedSaveButton) //this was an exists condition filter builder, it's filter viewer needs to be updated, and the subsequent filter builder needs to update.
                {
                    popupButton.siblings(".filterViewerDisplay").val(friendlyQuery).trigger('change');
                }
                else if (filterBuilderDialog) //the section filter was modified, the current filter builders' friendly query needs to be updated
                {
                    filterBuilderDialog.content.find(".currentQuery div").html(friendlyQuery);
                }

                const hidden = popupButton.siblings(".filterViewValue");

                hidden.attr("value", data.searchConditionXml?.toString() ?? "");

                //The Prompt Details Dialog relies on the hidden input triggering a change when the filter changes.
                //It then looks to the JSON to get the new filter so it doesn't matter if we have XML or not.
                hidden.change();
            }

            if (isReportMode && clickedSaveButton)
            {
                skyward.reporting.onFilterBuilderSave(data);
            }
        }

        var extractNewCondition = function (conditionContainer)
        {
            const condition = new skyward.searchCondition.SearchCondition();

            const conditionComboBox = conditionContainer.find(".conditionTypesComboBox");
            const operandInputs = conditionContainer.find(".js-conditionValue--active");
            const fieldSelector = conditionContainer.find(".filterBuilderFieldSelect");
            const conditionComboBoxData = conditionComboBox.data();
            const fieldSelectorData = fieldSelector.data();

            const isRestricted = fieldSelectorData.isRestricted;
            if (isRestricted)
            {
                condition.IsRestricted = isRestricted;
            }

            let type = skyward.searchCondition.getSearchConditionTypeByFieldType(fieldSelectorData.fieldType);

            if (type === skyward.searchCondition.Types.TypedStandardFilterSearchCondition)
            {
                condition.setType(type);
                condition.set({
                    DataObjectType: fieldSelectorData.dataObjectFullName,
                    RelationshipPath: fieldSelectorData.standardFilterRelationshipPath,
                    DisplayName: fieldSelector.find("span").text(),
                    SkywardID: fieldSelectorData.standardFilterId,
                    PromptUniqueId: operandInputs.data("promptUniqueId")
                });

                return condition;
            }

            if (!conditionComboBoxData)
            {
                return null;
            }

            if (conditionComboBoxData.interfaceName)
            {
                condition.setType(skyward.searchCondition.Types.SchemaObjectFilterSearchCondition);
                condition.set({
                    DataObjectType: fieldSelectorData.dataObjectFullName,
                    RelationshipPath: fieldSelectorData.relationshipPath,
                    InterfaceName: conditionComboBoxData.interfaceName,
                    DisplayName: conditionComboBoxData.displayName
                });
                return condition;
            }

            const fieldName = fieldSelectorData.absoluteFieldPath;
            const fieldPath = fieldSelectorData.fieldPath;
            const fieldType = fieldSelectorData.fieldType;
            const displayName = fieldSelectorData.displayName;
            const displayPath = fieldSelectorData.displayPathText;
            const isOperation = fieldSelectorData.isOperation;
            const conditionType = conditionComboBox.val();

            let isRange = false;
            let lowOperandInput = null;
            let lowOperandInputData = null;
            let highOperandInput = null;

            if (operandInputs.length >= 1)
            {
                lowOperandInput = operandInputs.first();
                lowOperandInputData = lowOperandInput.data();

                if (lowOperandInputData.fieldName || lowOperandInputData.calculatedFieldName)
                {
                    type = skyward.searchCondition.Types.FieldToFieldSearchCondition;
                }
                else if (operandInputs.length === 1 && lowOperandInputData.fieldType && lowOperandInputData.fieldType !== fieldSelectorData.fieldType)
                {
                    type = skyward.searchCondition.getSearchConditionTypeByFieldType(lowOperandInputData.fieldType);
                }
            }

            if (operandInputs.length === 2)
            {
                isRange = true;
                highOperandInput = operandInputs.last();
            }

            condition.setType(type);

            condition.set({
                DataObjectType: fieldSelectorData.dataObjectFullName,
                ConditionType: conditionType,
                CalculatedFieldName: fieldSelectorData.calculatedFieldName,
                Parameters: fieldSelectorData.parameters
            });

            if (type === skyward.searchCondition.Types.FieldToFieldSearchCondition)
            {
                condition.set({ LeftFieldName: fieldName, LeftFieldPath: fieldPath, LeftFieldNameDisplay: displayName, LeftFieldPathDisplay: displayPath, LeftFieldType: fieldType, LeftFieldIsOperation: isOperation });

                if (fieldSelectorData.fieldType.toLowerCase() === skyward.searchCondition.FieldTypes.Time)
                {
                    condition.set({ FieldConversionComparisonType: "Time" });
                }
                else if (fieldSelectorData.fieldType.toLowerCase() === skyward.searchCondition.FieldTypes.DateTime)
                {
                    condition.set({ FieldConversionComparisonType: "Date" });
                }
            }
            else if (type === skyward.searchCondition.Types.ExistsSearchCondition)
            {
                condition.set({ RelationshipName: fieldName });
            }
            else
            {
                condition.set({ FieldName: fieldName, FieldPath: fieldPath, FieldNameDisplay: displayName, FieldPathDisplay: displayPath, FieldType: fieldType, FieldIsOperation: isOperation });
            }

            if (type === skyward.searchCondition.Types.DateTimeSearchCondition && fieldSelectorData.fieldType.toLowerCase() === skyward.searchCondition.FieldTypes.Time)
            {
                condition.set({ ComparisonType: "CompareTimeOnly" });
            }
            else if (type === skyward.searchCondition.Types.DateTimeSearchCondition)
            {
                condition.set({ ComparisonType: "CompareDateOnly" });
            }

            if (lowOperandInput)
            {
                let lowOperandData;

                if (conditionType.indexOf("Exists") >= 0)
                {
                    lowOperandData = getExistsOperandData(lowOperandInput);
                }
                else if (conditionType.indexOf("List") >= 0)
                {
                    lowOperandData = getListOperandData(lowOperandInput);
                }
                else
                {
                    lowOperandData = getOperandData(lowOperandInput, isRange ? "Low" : "Value");
                }

                if (lowOperandData)
                {
                    condition.set(lowOperandData);
                }
            }

            if (highOperandInput)
            {
                const highOperandData = getOperandData(highOperandInput, "High");
                if (highOperandData)
                {
                    condition.set({ HighType: highOperandData.fieldType });
                    condition.set(highOperandData);
                }
            }

            return condition;
        };

        var getExistsOperandData = function (operandInput)
        {
            var operandData = {};
            var existsFilterLaunchButton = operandInput.find('.filterBuilderLaunchButton');

            var filterValueInput = existsFilterLaunchButton.siblings(".filterViewValue");
            var existsCondition = filterValueInput.data("filterCondition");

            if (existsCondition && typeof (existsCondition) === "object")
            {
                operandData.Condition = existsCondition;
            }
            else
            {
                return null;
            }

            return operandData;
        };

        var getListOperandData = function (operandElement)
        {
            const operandData = {};
            const operandElementData = operandElement.data();
            if (operandElementData.promptUniqueId)
            {
                operandData.ListBinding = "{_prompt." + operandElementData.promptUniqueId + "}";
                return operandData;
            }

            if (operandElementData.environmentVariableBinding)
            {
                operandData.ListBinding = operandElementData.environmentVariableBinding;
                return operandData;
            }

            operandData.List = { Value: [] };

            if (operandElement.hasClass("distinctMultiSelectEEL"))
            {
                const backingData = operandElement.children(".dmsBackingData");
                const values = skyward.controls.getValue(backingData);

                $.each(values, function (key, value)
                {
                    //using key for values such as datetime where the value we push to the list needs to be in a specific format
                    const trimmedKeyValue = key.trim();
                    if (trimmedKeyValue.length)
                    {
                        operandData.List.Value.push(trimmedKeyValue);
                    }
                });

            }
            else // Enum lists are unique in that they have no backing input - their data is stored in span.data("List")
            {
                // Note the change from lowercase to caps. jQuery.data() always makes first letter lowercase, but the property name in C# is "List"
                operandData.List.Value = Array.isArray((operandElementData.list || {}).Value) ? operandElementData.list.Value : [];
            }

            return operandData;
        };

        var getOperandData = function (operandInput, valueKey)
        {
            let operandData = {};
            const operandInputData = operandInput.data();

            if (operandInput.hasClass("enumOptions"))
            {
                operandData.Value = operandInputData.environmentVariableBinding || operandInputData.promptUniqueId || skyward.controls.getValueToString(operandInput);
                return operandData;
            }

            if (operandInputData.enumCodeValue)
            {
                operandData.Value = operandInputData.enumCodeValue;
                return operandData;
            }

            if (operandInputData.enumValue)
            {
                // fall back to enumValue for those enums with empty string codes
                operandData.Value = operandInputData.enumValue;
                return operandData;
            }

            if (typeof operandInputData.boolvalue === "boolean")
            {
                operandData.Value = operandInputData.boolvalue;
                return operandData;
            }

            if (operandInputData.environmentVariableBinding)
            {
                operandData[valueKey + "Binding"] = operandInputData.environmentVariableBinding;
                return operandData;
            }

            if (operandInputData.promptUniqueId)
            {
                operandData[valueKey + "Binding"] = "{_prompt." + operandInputData.promptUniqueId + "}";
                return operandData;
            }

            if (operandInputData.fieldName)
            {
                operandData.RightFieldName = operandInputData.fieldName;
                operandData.RightFieldPath = operandInputData.fieldPath;
                operandData.RightFieldPathDisplay = operandInputData.displayPathText;
                operandData.RightFieldNameDisplay = operandInputData.displayName;
                operandData.RightFieldType = operandInputData.fieldType;
                operandData.RightFieldIsOperation = operandInputData.isOperation;
                operandData.RightFieldExistsPath = operandInputData.existsPath;
                if (operandInputData.rootModule && operandInputData.rootObject)
                {
                    if (operandData.RightFieldExistsPath)
                    {
                        operandData.RightFieldExistsBaseType = operandInputData.rootModule + '.' + operandInputData.rootObject;
                    }
                    else
                    {
                        operandData.RightFieldBaseType = operandInputData.rootModule + '.' + operandInputData.rootObject;
                    }
                }
                return operandData;
            }

            if (operandInputData.calculatedFieldName)
            {
                operandData.RightCalculatedFieldName = operandInputData.calculatedFieldName;
                return operandData;
            }

            if (operandInputData.binding)
            {
                operandData[valueKey + "Binding"] = operandInputData.binding;
                return operandData;
            }

            operandData[valueKey] = skyward.controls.getValueToString(operandInput);

            return operandData;
        };

        var extractSchemaObjectSearchConditions = function (container)
        {
            var conditionGroup = new skyward.searchCondition.SearchConditionGroup();
            conditionGroup.set({ ConditionGroupType: "And" });
            conditionGroup.ConvertBindingToDisplayName = convertBindingsToFriendlyNames; // This is copied to all child condition so it only needs to be set here

            var hasSchemaObjectSearchConditions = false;
            container.children(".schemaObjectFilter:has(.checkbox:checked)").each(function ()
            {
                var conditionContainer = $(this).find(".condition");
                var condition = extractNewCondition(conditionContainer);

                if (condition)
                {
                    conditionGroup.addCondition(condition);
                    hasSchemaObjectSearchConditions = true;
                }
            });

            if (hasSchemaObjectSearchConditions)
            {
                return conditionGroup;
            }

            return null;
        };

        // this is only used to extract the condition to display the friendly query, it is not saved with the condition
        // if district entity filters ever contain groups, this won't work (along with many other things)
        var extractNewDistrictEntityFilter = function (container)
        {
            if (container.length === 0 || !container.is(":visible"))
            {
                return null;
            }

            if (!container.find(".applyDistrictEntityFilter").is(":checked"))
            {
                return null;
            }

            var conditionGroup = new skyward.searchCondition.SearchConditionGroup();
            conditionGroup.ConvertBindingToDisplayName = convertBindingsToFriendlyNames; // This is copied to and child condition so it only needs to be set here
            conditionGroup.set({ ConditionGroupType: "And" });

            container.children(".condition").each(function ()
            {
                var childConditionContainer = $(this);

                var condition = new skyward.searchCondition.SearchCondition();
                let conditionType = childConditionContainer.find(".windowSearchConditionConditionType").val();

                condition.set({ ConditionType: conditionType });

                let fieldName = childConditionContainer.find(".windowSearchConditionFieldName").data("fieldName");
                let operandInput = childConditionContainer.find(".js-conditionValue--active");

                if (conditionType == "Exists")
                {
                    condition.set({ RelationshipName: fieldName });
                    condition.set(getExistsOperandData(operandInput));
                }
                else
                {
                    condition.set({
                        FieldName: fieldName,
                        ValueBinding: operandInput.data("environmentVariableBinding")
                    });
                }

                conditionGroup.addCondition(condition);
            });

            return conditionGroup;
        };

        var extractNewConditionGroup = function (container)
        {
            let conditionGroup = new skyward.searchCondition.SearchConditionGroup();
            conditionGroup.set({ ConditionGroupType: container.children(".conditionGroupControlsContainer").find("input:radio:checked").val() || "And" });
            conditionGroup.ConvertBindingToDisplayName = convertBindingsToFriendlyNames; // This is copied to and child condition so it only needs to be set here

            const children = Array.from(container.children(".condition, .conditionGroup"));
            const conditionCount = children.filter(el => el.classList.contains("condition")).length;
            const conditionGroupCount = children.filter(el => el.classList.contains("conditionGroup")).length;

            for (let i = 0; i < children.length; i++)
            {
                const childConditionContainer = $(children[i]);
                if (childConditionContainer.hasClass("condition"))
                {
                    const childCondition = extractNewCondition(childConditionContainer);
                    if (childCondition)
                    {
                        if (conditionCount === 1 && conditionGroupCount === 0)
                        {
                            // just return the condition itself instead of as a conditionGroup
                            return childCondition;
                        }
                        conditionGroup.addCondition(childCondition);
                    }
                }
                else
                {
                    const childCondition = extractNewConditionGroup(childConditionContainer);
                    if (childCondition)
                    {
                        conditionGroup.addCondition(childCondition);
                    }
                }
            }
            return conditionGroup;
        };

        var buildNewSearchCondition = skyward.filterbuilder.buildNewSearchCondition = function ()
        {
            const container = filterBuilderDialogs.getCurrent().content.find(".filterBuilder > .conditionsContainer");

            const searchCondition = extractNewConditionGroup(container);
            const schemaObjectFilterConditions = extractSchemaObjectSearchConditions(container);

            if (schemaObjectFilterConditions)
            {
                // the main search condition will always be an "And" condition so we can add it to it directly
                searchCondition.addCondition(schemaObjectFilterConditions);
            }

            return searchCondition;
        };

        var reparentFilterBuilder = function (filterViewerContainer, selectedValueInput, resetFilterBuilder)
        {
            if (resetFilterBuilder && (selectedValueInput.is('[disabled],[readonly],.ui-disabled') || selectedValueInput.parent().is('[disabled],[readonly],.ui-disabled')))
            {
                return;
            }

            var module = selectedValueInput.data("filterbuilder-module");
            var object = selectedValueInput.data("filterbuilder-object");

            if (module && object)
            {
                if (resetFilterBuilder === true)
                {
                    var filterViewValue = filterViewerContainer.find('.filterViewValue');
                    filterViewValue.val("");
                    filterViewValue.data("filterCondition", {});
                    filterViewValue.change();
                }

                var button = filterViewerContainer.find(".filterBuilderLaunchButton");

                button.data("module", module);
                button.data("object", object);
                button.data("rootModule", module);
                button.data("rootObject", object);
            }
        };

        var reparentFilterBuilderFromCodeEEL = function (filterContainer, moduleNameInput, objectNameInput, clearValue)
        {
            var module = moduleNameInput.val();
            var object = objectNameInput.val();

            if (clearValue)
            {
                var filterViewValue = filterContainer.find('.filterViewValue');
                filterViewValue.val("");
                filterViewValue.data("filterCondition", {});
                filterViewValue.change();
            }

            var launchButton = filterContainer.find(".filterBuilderLaunchButton");

            launchButton.data("module", module);
            launchButton.data("object", object);
            launchButton.data("rootModule", module);
            launchButton.data("rootObject", object);
        };

        var setupCodeEELReparenting = function (selector, objectCodeEELID, moduleCodeEELID)
        {
            var objectCodeEEL = $('#' + objectCodeEELID);
            var moduleCodeEEL = $('#' + moduleCodeEELID);
            var filterContainer = $(selector + " .filterContainer");

            if (objectCodeEEL.length === 1 && moduleCodeEEL.length === 1)
            {
                var moduleNameInput = moduleCodeEEL.find('.codeEELCode');
                var objectNameInput = objectCodeEEL.find('.codeEELCode');

                reparentFilterBuilderFromCodeEEL(filterContainer, moduleNameInput, objectNameInput, false);

                var onChangeAction = function ()
                {
                    reparentFilterBuilderFromCodeEEL(filterContainer, moduleNameInput, objectNameInput, true);
                };

                objectCodeEEL.on('eelComplete', onChangeAction);
                moduleCodeEEL.on('eelComplete', onChangeAction);
            }
        };

        var setupReparentingOnInputChange = function (selector, reparenterInputClass)
        {
            var reparenterInput = $(selector + " ." + reparenterInputClass);
            var getSelectedValueFunction;
            var changeEvent;

            if (reparenterInput.hasClass("radioButtonGroup"))
            {
                getSelectedValueFunction = function (parentInput)
                {
                    return parentInput.find("input:checked").parent();
                };
                changeEvent = "click";
            }
            else if (reparenterInput.hasClass("comboBoxSet"))
            {
                getSelectedValueFunction = function (parentInput)
                {
                    return parentInput.find("option:selected");
                };
                changeEvent = "change";
            }

            if (getSelectedValueFunction && changeEvent)
            {
                reparentFilterBuilder($(selector + " .filterContainer"), getSelectedValueFunction(reparenterInput), false);
                reparenterInput.on(changeEvent, function ()
                {
                    reparentFilterBuilder($(selector + " .filterContainer"), getSelectedValueFunction($(this)), true);
                });
            }
        };

        skyward.filterbuilder.getFilterValueSelectorData = function (button, searchField, conditionType, dataModule, dataObject)
        {
            var conditionValuesContainer = $(button).closest(".conditionValuesContainer");
            var input = conditionValuesContainer.find("input");
            var valueBox = conditionValuesContainer.find(".js-conditionValue--active");
            var valueBoxData = valueBox.data();

            var result =
            {
                postData:
                {
                    moduleName: dataModule,
                    objectName: dataObject,
                    fieldName: searchField,
                    conditionType: conditionType,
                    selectedValues: valueBoxData.list ? valueBoxData.list.Value : [],
                    inputName: input.attr('name')
                },
                valueBox: valueBox
            };

            return result;
        };

        skyward.filterbuilder.getFilterValueSelector = function (button, searchField, conditionType, dataModule, dataObject)
        {
            var filterValueSelectorData = skyward.filterbuilder.getFilterValueSelectorData(button, searchField, conditionType, dataModule, dataObject);

            $.ajax({
                url: skyward.global.virtualDir + "SkySys/Filter/GetValueSelector",
                type: "POST",
                dataType: "JSON",
                data: filterValueSelectorData.postData,
                success: function (data)
                {
                    skyward.filterbuilder.openValueSelector(data.html, button, filterValueSelectorData.valueBox, data.isListOfEnums);
                }

            });
        };

        skyward.filterbuilder.openValueSelector = function (html, button, valueBox, isListOfEnums, treatPromptAsInUse, clickEvents)
        {
            if (treatPromptAsInUse === undefined)
            {
                treatPromptAsInUse = true;
            }
            var valueBoxData = valueBox.data();
            var conditionValueContainer = valueBox.closest('.conditionValuesContainer');

            conditionValueContainer.find('input').on('workflowEnd', function (e, data)
            {
                setFilterValue({ binding: data.additionalValues.FilterValueBinding, name: data.additionalValues.FilterValueName });
            });

            var dropdown = $(html);
            var menu;
            var dialogOptions =
            {
                closeOnClick: true,
                closeOnEscape: true,
                closeOnGlassClick: true,
                anchorTo: button,
                beforeClose: dropdown.remove
            };

            if (isListOfEnums)
            {
                var buttons = [
                    {
                        text: "Save",
                        click: function ()
                        {
                            setFilterValue(getSelectedItems());
                            menu.close();
                        },
                        icon: "Save"
                    },
                    {
                        text: "Cancel",
                        click: function ()
                        {
                            menu.close();
                        },
                        icon: "Cancel"
                    }
                ];

                menu = skyward.modalLayer.showDialog("Select Values", dropdown, buttons, dialogOptions);
                menu.animationPromise.then(menu.animateModalContents());
                menu.content.find('.prompt.filterValue').each(function ()
                {
                    var filterValue = $(this);
                    filterValue.on('click', function () { setFilterValue($.extend({ enumType: valueBoxData.enumType }, filterValue.data()), filterValue); });
                });
            }
            else
            {
                menu = skyward.modalLayer.showDialog("Select a Value", dropdown, [], dialogOptions);
                menu.content.find('.filterValue').each(function ()
                {
                    var filterValue = $(this);
                    filterValue.on('click', function () { setFilterValue(filterValue.data(), filterValue); });
                });
            }

            menu.content.find('.addFilterValue').on('click', function ()
            {
                menu.close();
            });

            $.each(clickEvents, function (key, value)
            {
                menu.content.find(key).on('click', function () { value(setFilterValue, valueBox, treatPromptAsInUse); });
            });

            skyward.window.notifyDOMLoad(".filterValue");

            function setFilterValue(filterValueData, clickedInput)
            {
                if (filterValueData)
                {
                    let displayValue = null;
                    let svg = null;

                    if (typeof filterValueData.boolvalue === "boolean")
                    {
                        displayValue = filterValueData.boolvalue.toDisplayString();
                    }
                    else if (filterValueData.enumDisplayValue)
                    {
                        displayValue = filterValueData.enumDisplayValue;
                    }
                    else if (filterValueData.columnId)
                    {
                        displayValue = filterValueData.columnDescription || "Current Column Value";
                    }
                    else if (filterValueData.promptUniqueId)
                    {
                        displayValue = filterValueData.label || filterValueData.promptName;
                        svg = filterValueData.svgClass;
                    }
                    else if (filterValueData.binding)
                    {
                        displayValue = filterValueData.name;
                    }
                    else if (filterValueData.customValue)
                    {
                        displayValue = filterValueData.customDisplayValue;
                    }
                    else if (filterValueData.environmentVariableName)
                    {
                        displayValue = filterValueData.environmentVariableName;
                        svg = filterValueData.svgClass;
                    }
                    else if (clickedInput && clickedInput.length > 0)
                    {
                        displayValue = clickedInput.text();
                    }

                    skyward.filterbuilder.setConditionSpanValue(conditionValueContainer, displayValue, filterValueData, svg, true);
                }
                menu.close();
            }

            function getSelectedItems()
            {
                var filterValueData = $.extend({}, dropdown.find(".filterValue").first().data());
                filterValueData.enumDisplayValue = "";
                var selectedValues = [];

                dropdown.find("input:checked").each(function ()
                {
                    var selectedValueData = $(this).closest(".filterValue").data();
                    selectedValues.push(selectedValueData.enumCodeValue);
                    filterValueData.enumDisplayValue += (filterValueData.enumDisplayValue.length ? ", " : "") + (selectedValueData.enumDisplayValue || selectedValueData.enumValue);
                });

                filterValueData.list = { Value: selectedValues };

                return filterValueData;
            }
        };

        skyward.filterbuilder.selectField = function (controlIDToUpdate, data)
        {
            const allFieldsPanelTreeBrowse = $(`#${controlIDToUpdate}`);

            const firstDotIndex = data.fieldPath.indexOf(".");
            const hasDot = firstDotIndex >= 0;
            const absoluteFieldPath = hasDot ? data.fieldPath.substring(firstDotIndex + 1) : data.fieldPath;

            const searchData =
            {
                calculatedFieldName: undefined,
                fieldName: data.fieldName,
                fieldPath: data.fieldPath,
                fieldModule: data.moduleName,
                fieldObject: data.objectName,
                absoluteFieldPath: absoluteFieldPath,
                relationshipPath: data.fieldPathToParent,
                displayName: data.displayName,
                displayPathText: data.displayPathText,
                fieldType: data.fieldType,
                svgClass: data.svgClass,
                parameters: data.parameters ?? [],
                isCalculated: data.isCalculated,
                isOperation: data.isOperation
            };

            allFieldsPanelTreeBrowse.trigger("searchFieldSelected", [searchData]);
            skyward.window.closePopup();
        };

        // ToDo - Eventually this should be information that is passed into FilterBuilder from reporting instead of living here
        function convertBindingsToFriendlyNames(text)
        {
            if (text)
            {
                if (skyward.reporting.prompts?.promptCollection?.ConvertPromptBindingsToFriendlyNames)
                {
                    text = skyward.reporting.prompts.promptCollection.ConvertPromptBindingsToFriendlyNames(text);
                }

                if (skyward.reporting.calculatedFields?.ConvertBindingsToFriendlyNames)
                {
                    text = skyward.reporting.calculatedFields.ConvertBindingsToFriendlyNames(text);
                }
            }

            return text;
        }

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.gradebookassignment = skyward.gradebook || {};

        var DEFAULT_PARENT_ASSIGNMENT_DISPLAY = true;
        var DISPLAY_PARENT_ASSIGNMENT_FS_SELECTOR = ".showParentAssignmentFS";
        var DISPLAY_PARENT_ASSIGNMENT_CB_SELECTOR = ".showParentAssignmentCheckbox";
        var SUBJECT_STANDARD_CRQE_TABLE_SELECTOR = ".subjectStandardQuickEntry .childrecordquickentrytable";

        var init = function (selector)
        {
            // SubmissionStatus codes
            const reopenedCode = "RO";
            const reopenedNewAttemptCode = "RA";
            const inProgressCode = "IP";
            const submittedCode = "SU";
            const expiredCode = "EX";

            $(selector).find(".sectionsToAssignToBrowse.handleScreenUpdates").each(function ()
            {
                var browse = $(this);
                var container = browse.parent();

                var currentAssignmentData =
                {
                    categoryID: null,
                    academicStandardIDs: null,
                    scaleMaxScore: null,
                    dueDate: null,
                    validSectionIDs: null,
                    updateRequest: null,
                    subjectIDs: null,
                    studentGroupIDs: null,
                    tierOneAcademicStandardIDs: null,
                    isOnlineAssignment: false
                };

                var setupData = function ()
                {
                    var browseBody = browse.find(".browseBody");
                    var browseBodyData = browseBody.data();
                    if (!browseBodyData)
                    {
                        return;
                    }

                    //Either we are in a workflow where we have a dueDate and CategoryID on the screen and we need to use those dynamic values
                    //or we are in the assignment details where we don't have a dueDate or categoryID on the screen and we know those values
                    if (browseBodyData.assignmentDueDate)
                    {
                        currentAssignmentData.dueDate = new Date(browseBodyData.assignmentDueDate);
                    }
                    else
                    {
                        var dueDateElement = $("[name='Assignment.DueDate']");
                        dueDateElement.on("change", updateDueDate);
                        currentAssignmentData.dueDate = skyward.controls.getValue(dueDateElement);
                    }

                    if (browseBodyData.assignmentCategoryId)
                    {
                        currentAssignmentData.categoryID = browseBodyData.assignmentCategoryId;
                    }
                    else
                    {
                        var categoryElement = $("[name='Assignment.CategoryID']");
                        categoryElement.on("change", updateCategory);
                        currentAssignmentData.categoryID = skyward.controls.getValue(categoryElement);
                    }


                    var onlineAssignmentElement = $("[name='Assignment.IsOnlineAssignment']");
                    onlineAssignmentElement.on("change", updateIsOnlineAssignment);
                    currentAssignmentData.categoryID = skyward.controls.getValue(categoryElement);

                    if (container.find("input.dmsBackingData[name='StudentGroupSelectEEL']").length > 0)
                    {
                        currentAssignmentData.studentGroupIDs = getStudentGroupIDs(container.find("input.dmsBackingData[name='StudentGroupSelectEEL']"));
                    }
                };

                var updateDueDate = function ()
                {
                    currentAssignmentData.dueDate = skyward.controls.getValue($(this));
                    updateValidSections();
                };

                var updateCategory = function ()
                {
                    currentAssignmentData.categoryID = skyward.controls.getValue($(this));
                    updateValidSections();
                };

                var updateIsOnlineAssignment = function ()
                {
                    currentAssignmentData.isOnlineAssignment = skyward.controls.getValue($(this));
                    updateValidSections();
                };

                var getUpdatedSubjectIDs = function ()
                {
                    var subjectIDs = [];
                    container.find(".AssignmentSubjectIDEEL").each(function ()
                    {
                        var value = skyward.controls.getValue($(this));

                        if (value != null && value != "")
                        {
                            subjectIDs.push(value);
                        }
                    });

                    return subjectIDs;
                };

                var updateSubjects = function ()
                {
                    var subjectIDs = getUpdatedSubjectIDs();

                    if (currentAssignmentData.subjectIDs != subjectIDs)
                    {
                        currentAssignmentData.subjectIDs = subjectIDs;
                        updateValidSections();
                    }
                };

                var getUpdatedAssignmentAcademicStandardTierOneIDs = function ()
                {
                    var tierOneIDs = [];
                    container.find(".AssignmentAcademicStandardIDEELTierOne").each(function ()
                    {
                        var value = skyward.controls.getValue($(this));

                        if (value != null && value != "")
                        {
                            tierOneIDs.push(value);
                        }
                    });

                    return tierOneIDs;
                };

                var updateAssignmentAcademicStandardTierOnes = function ()
                {
                    var tierOneIDs = getUpdatedAssignmentAcademicStandardTierOneIDs();

                    if (JSON.stringify(currentAssignmentData.tierOneAcademicStandardIDs) != JSON.stringify(tierOneIDs))
                    {
                        currentAssignmentData.tierOneAcademicStandardIDs = tierOneIDs;
                        updateValidSections();
                    }
                };

                var getUpdatedAcademicStandardIDs = function ()
                {
                    var academicStandardIDs = [];
                    container.find(".AssignmentAcademicStandardIDEEL").each(function ()
                    {
                        var value = skyward.controls.getValue($(this));
                        if (value != null && value != "")
                        {
                            academicStandardIDs.push(value);
                        }
                    });

                    return academicStandardIDs;
                };

                var updateAcademicStandards = function ()
                {
                    var academicStandardIDs = getUpdatedAcademicStandardIDs();

                    if (currentAssignmentData.academicStandardIDs != academicStandardIDs)
                    {
                        currentAssignmentData.academicStandardIDs = academicStandardIDs;

                        updateValidSections();
                    }
                };

                var getStudentGroupIDs = function (input)
                {
                    var data = skyward.controls.getValue(input);

                    var studentGroupIDs = [];
                    $.each(data, function (k, v)
                    {
                        studentGroupIDs.push(k);
                    });

                    return studentGroupIDs;
                };

                var updateStudentGroups = function ()
                {
                    var studentGroupIDs = getStudentGroupIDs($(this));

                    if (currentAssignmentData.studentGroupIDs != studentGroupIDs)
                    {
                        currentAssignmentData.studentGroupIDs = studentGroupIDs;

                        updateValidSections();
                    }
                };

                var updateValidSections = function ()
                {
                    if (currentAssignmentData.updateRequest != null)
                    {
                        currentAssignmentData.updateRequest.abort();
                    }
                    currentAssignmentData.updateRequest = setValidSections();
                };

                var setValidSections = function ()
                {
                    var dueDateString = ((currentAssignmentData.dueDate.getMonth() + 1) + "/" +
                        currentAssignmentData.dueDate.getDate() + "/" +
                        currentAssignmentData.dueDate.getFullYear());

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/GetValidSectionsForClassSync/",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            dueDate: dueDateString,
                            selectedCategoryID: currentAssignmentData.categoryID,
                            selectedSubjectIDs: JSON.stringify(currentAssignmentData.subjectIDs),
                            selectedAcademicStandardIDs: JSON.stringify(currentAssignmentData.academicStandardIDs),
                            selectedStudentGroupIDs: JSON.stringify(currentAssignmentData.studentGroupIDs),
                            sectionIDs: getAllSectionIDs(browse),
                            isOnlineAssignment: currentAssignmentData.isOnlineAssignment
                        },
                        success: function (data)
                        {
                            if (data.validSectionIDs)
                            {
                                currentAssignmentData.validSectionIDs = data.validSectionIDs;
                                updateRowState();
                            }
                        }
                    });
                };

                var validDueDate = function (rowData)
                {
                    var startDate = new Date(rowData.sectionStartDate);
                    var endDate = new Date(rowData.sectionEndDate);

                    if (!currentAssignmentData.dueDate.isValidDate())
                    {
                        return false;
                    }

                    if (currentAssignmentData.dueDate < startDate || currentAssignmentData.dueDate > endDate)
                    {
                        return false;
                    }

                    return true;
                };

                var validCategory = function (row)
                {
                    var currentSectionID = getRowSectionID(row);

                    if (currentAssignmentData.validSectionIDs == null)
                    {
                        return false;
                    }

                    if (currentAssignmentData.validSectionIDs.indexOf(currentSectionID) > -1)
                    {
                        return true;
                    }

                    return false;
                };

                var updateRowState = function ()
                {
                    var hasDisabledRows = false;

                    browse.find("tr:not(.unlockedHeaderTableRow)").each(function ()
                    {
                        var row = $(this);
                        var rowData = row.data();

                        if (!$.isEmptyObject(rowData))
                        {
                            if (validDueDate(rowData) && validCategory(row))
                            {
                                skyward.editableBrowse.enableRow(row);
                            }
                            else
                            {
                                skyward.editableBrowse.disableRow(row);
                                hasDisabledRows = true;
                            }
                        }
                    });

                    var contentMessageArea = skyward.contentMessageArea.getContentMessageArea(browse);
                    if (contentMessageArea !== null)
                    {
                        if (hasDisabledRows)
                        {
                            contentMessageArea.showInformation();
                        }
                        else
                        {
                            contentMessageArea.hideInformation();
                        }
                    }
                };

                setupData();

                container.on("eelComplete", ".AssignmentSubjectIDEEL", updateSubjects);
                container.on("eelComplete", ".AssignmentAcademicStandardIDEEL:not(.AssignmentAcademicStandardIDEELTierOne)", updateAcademicStandards);
                container.on("eelComplete", ".AssignmentAcademicStandardIDEELTierOne", updateAssignmentAcademicStandardTierOnes);

                container.on("change", ".studentGroupSelectEEL .dmsBackingData", updateStudentGroups);

                container.on('childrecordquickentry-row-removed-completely', function ()
                {
                    currentAssignmentData.academicStandardIDs = getUpdatedAcademicStandardIDs();
                    currentAssignmentData.subjectIDs = getUpdatedSubjectIDs();
                    currentAssignmentData.tierOneAcademicStandardIDs = getUpdatedAssignmentAcademicStandardTierOneIDs();
                    updateValidSections();
                });

                updateAcademicStandards();
                updateSubjects();
                updateAssignmentAcademicStandardTierOnes();

            });

            var getAssignmentChildRecordQuickEntryRowCount = function (selector, isRowBeingClearedAndRemoved)
            {
                var rows = $(selector + ' ' + SUBJECT_STANDARD_CRQE_TABLE_SELECTOR + ' tbody tr:visible');
                var rowCount = Number(rows.length) - 1;
                if (isRowBeingClearedAndRemoved == true)
                {
                    //This event gets triggered before the row actually gets removed, so we should subtract 2 from the total
                    rowCount--;
                }
                return rowCount;
            };

            var SetTwoFixedDecimalsPlacesOnValue = function (value)
            {
                var valueToUse = !isNaN(value) ? value : '';
                return isNaN(parseFloat(valueToUse.toString()).toFixed(2)) ? '' : parseFloat(valueToUse.toString()).toFixed(2);
            };

            var visibleRowCount = 0;
            //Update the Max Score fields in the child record quick entry
            var updateChildren = $(selector).find('input.AssignmentChildMaxScore:visible').each(function ()
            {
                var current = $(this);
                visibleRowCount++;
                if (!current.hasClass('childrecordquickentryaddviewpart'))
                {
                    current.prop('disabled', false);
                    current.removeClass('originallyDisabled');
                    if (visibleRowCount == 1)
                    {
                        $('.disabledMaxScoreToBeEnabledIfOtherNonAddedRowsExist').each(function ()
                        {
                            var topOne = $(this);
                            topOne.prop('disabled', false);
                            topOne.removeClass('disabledMaxScoreToBeEnabledIfOtherNonAddedRowsExist');
                        });
                    }
                }
                else if (visibleRowCount > 1)
                {
                    current.prop('disabled', false);
                    current.removeClass('originallyDisabled');
                }
                else
                {
                    current.addClass('disabledMaxScoreToBeEnabledIfOtherNonAddedRowsExist');
                }
                if (current.is(':disabled,[readonly],.ui-disabled'))
                {
                    current.addClass('originallyDisabled');
                }
            });

            var changeMaxScore = function (subjectStandardQuickEntry)
            {
                var container = subjectStandardQuickEntry.parents(".workflowContent, .dataObjectViewer").first();
                var assignmentMaxScore = container.find('.js-assignment-overallMaxScore');
                const assignmentMaxScoreData = assignmentMaxScore.data();

                var defaultMaxScore = assignmentMaxScoreData ? assignmentMaxScoreData.defaultMaxScore : 0;
                var currentMaxScore = assignmentMaxScore.val();
                var assignmentMaxScoreToUse = 0;
                var sumChildAssignmentScores = 0;
                var childAssignmentCount = 0;

                // Get sum and count of child assignment scores.
                subjectStandardQuickEntry.find('input.AssignmentChildMaxScore:visible:not([style*="display: none"]):not(.doNotPost):not(.js-excludeFromMaxScoreCalc)').each(function ()
                {
                    var childScore = $(this).val();
                    if (isNaN(childScore) || childScore < 0 || childScore.length === 0)
                    {
                        childAssignmentCount++;
                        return;
                    }
                    sumChildAssignmentScores += Number(childScore);
                    childAssignmentCount++;
                });

                // Priority of score to use for parent assignment: Sum Of Child Assignments, Current Assignment Max Score, Default Assignment Score
                // There are cases where a child row is removed from the DOM before we get to the sum+count logic above leaving us with a count of 1. We still want to use this sum value in that case.
                // In other cases where the row being removed still remains in the DOM, the logic above should not be including that value in the sum.
                if (!isNaN(sumChildAssignmentScores) && childAssignmentCount > 0)
                {
                    assignmentMaxScoreToUse = sumChildAssignmentScores;
                }
                else
                {
                    assignmentMaxScoreToUse = !isNaN(currentMaxScore) && currentMaxScore.length > 0 ? currentMaxScore
                        : !isNaN(defaultMaxScore) ? defaultMaxScore
                            : '';
                }

                skyward.controls.setValue(assignmentMaxScore, SetTwoFixedDecimalsPlacesOnValue(assignmentMaxScoreToUse));
            };

            var getSubjectStandardQuickEntryFromSelector = function (selector)
            {
                var subjectStandardQuickEntry = null;
                if ($(selector).hasClass(".subjectStandardQuickEntry"))
                {
                    subjectStandardQuickEntry = $(selector);
                }
                else
                {
                    subjectStandardQuickEntry = $(selector).find(".subjectStandardQuickEntry");
                }

                return subjectStandardQuickEntry;
            }

            var checkHideSubjectStandardMaxScore = function (quickEntry, row, isRowBeingRemoved, isRowBeingCleared)
            {
                const hideMaxScore = skyward.controls.getValue($("input[name='HideMaxScore']")) === "True";
                if (hideMaxScore || (quickEntry.length > 0 && getAssignmentChildRecordQuickEntryRowCount(selector, (isRowBeingRemoved && isRowBeingCleared)) <= 1))
                {
                    quickEntry.find(".maxScoreHeader").hide();
                    quickEntry.find(".AssignmentChildMaxScore").hide();
                    $(selector + ' input.js-assignment-overallMaxScore').prop('disabled', false);
                }

                if (isRowBeingRemoved && row != null)
                {
                    //Obviously don't want to do this on new rows, only on existing rows
                    if (row[0].id.startsWith('childrecordquickentrychildadd-assignment-assignmentidparent-') == false)
                    {
                        //This is so that we still know when there is dirty data on the screen, even after the row is removed
                        var hiddenID = 'RemovedRow-' + row[0].id;
                        if (quickEntry.length > 0 && row.length > 0 && $('#' + hiddenID).length == 0)
                        {
                            quickEntry.append('<hidden id="' + hiddenID + '" data-dirty="true"/>');
                        }
                    }
                    row.remove();
                }

                if (isRowBeingCleared || isRowBeingRemoved)
                {
                    quickEntry.trigger('childrecordquickentry-row-removed-completely');
                }
            };

            var showSubjectStandardMaxScore = function (quickEntry)
            {
                quickEntry.find(".AssignmentChildMaxScore").show();
                quickEntry.find(".maxScoreHeader").show();
                $(selector + ' input.js-assignment-overallMaxScore').prop('disabled', true);
            };

            var updateVisibleSubjectStandardRowCount = function (crqe)
            {
                if (crqe != null && crqe.length > 0)
                {
                    var rowCount = crqe.find("tr.childrecordquickentryrow:visible").length;
                    var container = crqe.parents(".skywardContentPanel").first();

                    var visibleSubjectStandardRowCount = container.find(".visibleSubjectStandardRowCount");
                    skyward.controls.setValue(visibleSubjectStandardRowCount, rowCount);

                    if (rowCount > 1)
                    {
                        skyward.controls.show(container.find(DISPLAY_PARENT_ASSIGNMENT_FS_SELECTOR));

                    }
                    else
                    {
                        skyward.controls.hide(container.find(DISPLAY_PARENT_ASSIGNMENT_FS_SELECTOR));
                        skyward.controls.setValue(container.find(DISPLAY_PARENT_ASSIGNMENT_CB_SELECTOR), DEFAULT_PARENT_ASSIGNMENT_DISPLAY);
                    }
                }
                else
                {
                    skyward.controls.hide($(DISPLAY_PARENT_ASSIGNMENT_FS_SELECTOR));
                    skyward.controls.setValue($(DISPLAY_PARENT_ASSIGNMENT_CB_SELECTOR), DEFAULT_PARENT_ASSIGNMENT_DISPLAY);
                }
            }

            var setUpAssignmentWorkflowEvents = async function ()
            {
                //Handle Subject IDs on EEL
                $(selector + ' div.codeEEL.AssignmentSubjectIDEEL, ' + selector + ' div.codeEEL.AssignmentAcademicStandardIDEELTierOne').on('eelComplete', async function (event)
                {
                    var target = $(event.target);
                    var action = 'HandleSubjectIDChangeWorkflow';
                    var data = (await skyward.ajax.getAllInputElements($('.workflowContent'))) || [];
                    if (data.IsCustomName === undefined)
                    {
                        action = 'HandleSubjectIDChange';
                        data = await skyward.ajax.getAllInputElements($('.contentArea'));
                    }
                    data.ChildSelectorLevel = target[0].id.split("-").slice(-1)[0];

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            success: function (returnData)
                            {
                                var parentSelector = "SubjectsAndStandardsQuickEntryFS";
                                var parent = target.parents('#' + parentSelector);
                                parentSelector = parent.length > 0 ? parentSelector : 'editAssignment_' + parentSelector;
                                parent = parent.length > 0 ? parent : target.parents('#' + parentSelector);
                                skyward.ajax.handleResponse(returnData, parentSelector, false, parent);
                            }
                        });
                });


                //Handle Standard IDs on EEL
                $(selector + ' div.codeEEL.AssignmentAcademicStandardIDEEL').on('eelComplete', async function (event)
                {
                    var target = $(event.target);
                    var action = 'HandleAcademicStandardIDChangeWorkflow';
                    var data = {};
                    if ($(".workflowContent").length > 0)
                    {
                        data = await skyward.ajax.getAllInputElements($('.workflowContent'));
                        isWorkflow = true;
                    }
                    else
                    {
                        data = await skyward.ajax.getAllInputElements($('.contentArea'));
                        action = 'HandleAcademicStandardIDChange';
                    }
                    data.ChildSelectorLevel = target[0].id.split("-").slice(-1)[0];
                    data.hasMultipleStandardsOnScreen = target.parents("tr").siblings(".childrecordquickentryrow:visible").length > 0;
                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            success: function (returnData)
                            {
                                var parentSelector = "SubjectsAndStandardsQuickEntryFS";
                                var parent = target.parents('#' + parentSelector);
                                parentSelector = parent.length > 0 ? parentSelector : 'editAssignment_' + parentSelector;
                                parent = parent.length > 0 ? parent : target.parents('#' + parentSelector);
                                skyward.ajax.handleResponse(returnData, parentSelector, false, parent);
                            }
                        });
                });

                checkHideSubjectStandardMaxScore(getSubjectStandardQuickEntryFromSelector(selector), null, false, false);

                var getSelectorElementToUse = function (selectorToUse)
                {
                    var selectorElement = $(selectorToUse).closest(SUBJECT_STANDARD_CRQE_TABLE_SELECTOR);

                    if (selectorElement.length <= 0)
                    {
                        selectorElement = $(selectorToUse + ' ' + SUBJECT_STANDARD_CRQE_TABLE_SELECTOR);
                    }

                    return selectorElement;
                };

                const setUpAcademicStandardEvents = function (selectorToUse)
                {
                    const selectorElement = getSelectorElementToUse(selectorToUse).find("div.codeEEL.AssignmentAcademicStandardIDEEL");

                    //Need to override the events for my codeEELs so that it will perform my event first
                    selectorElement.off("click.gradebookAssignment keydown.gradebookAssignment keyup.gradebookAssignment input.gradebookAssignment");

                    //Handle Standard IDs on EEL Search (for details)
                    //Remove events from specific elements here too, because this is more specific
                    selectorElement.find("a").on("click.gradebookAssignment", function (event)
                    {
                        showEELPopup(event);
                    });

                    selectorElement.on("keydown.gradebookAssignment", function (event)
                    {
                        const key = event.code.toLowerCase();
                        if (key === "enter" || key === "arrowdown")
                        {
                            showEELPopup(event);
                        }
                    });

                    selectorElement.on(skyward.global.isAndroidApp ? "keyup.gradebookAssignment" : "input.gradebookAssignment", function (event)
                    {
                        showEELPopup(event);
                    });

                    const showEELPopup = function (event)
                    {
                        const standardEELPopup = $('div[id^="AcademicStandardID-"][id$="_description_popup"], div[id^="WorkflowAcademicStandardID-"][id$="_description_popup"]');
                        if (standardEELPopup.length <= 0)
                        {
                            performHandleStandardIDsOnEELSearch(event);
                        }
                    };
                };

                setUpAcademicStandardEvents(selector);

                const performHandleStandardIDsOnEELSearch = async function (event)
                {
                    let target = $(event.target);
                    if (!target.hasClass("codeEELDescription"))
                    {
                        target = target.parents("div.AssignmentAcademicStandardIDEEL").find("input.eELInputContainer__textBox");
                    }

                    const isWorkflowAlias = $(".workflowContent").length > 0;

                    const data = await skyward.ajax.getAllInputElements($(isWorkflowAlias ? ".workflowContent" : ".contentArea"));
                    data.ChildSelectorLevel = target.parents("div.codeEEL.AssignmentAcademicStandardIDEEL, div.codeEEL.AssignmentAcademicStandardIDEELTierOne")[0].id.split("-").slice(-1)[0];
                    data.seekText = skyward.controls.getValue(target);

                    $.ajax(
                    {
                        url: skyward.global.virtualDir + "Gradebook/Assignment/HandleSubjectIDChange" + (isWorkflowAlias == true ? "Workflow" : ""),
                        type: "POST",
                        dataType: "JSON",
                        data: data,
                        success: function (returnData)
                        {
                            let parentSelector = "SubjectsAndStandardsQuickEntryFS";
                            let parent = target.parents(`#${parentSelector}`);
                            parentSelector = parent.length > 0 ? parentSelector : `editAssignment_${parentSelector}`;
                            parent = parent.length > 0 ? parent : target.parents(`#${parentSelector}`);
                            skyward.ajax.handleResponse(returnData, parentSelector, false, parent);
                        }
                    });
                };

                //Add button clicked
                $(selector).find('.subjectStandardQuickEntry div.childrecordquickentryadddiv').on('childrecordquickentry-row-added', 'a.save.js-childrecordquickentry', function ()
                {
                    var rowCount = getAssignmentChildRecordQuickEntryRowCount(selector, false);
                    const hideMaxScore = skyward.controls.getValue($("input[name='HideMaxScore']")) === "True";

                    if (!hideMaxScore)
                    {
                        if (rowCount > 1)
                        {
                            var assignmentMaxScore = $(selector + ' input.js-assignment-overallMaxScore');
                            assignmentMaxScore.prop('disabled', true);

                            showSubjectStandardMaxScore($(this).parents(".subjectStandardQuickEntry"));
                        }

                        if (rowCount == 2)
                        {
                            var assignmentMaxScore = $('input.js-assignment-overallMaxScore');
                            var firstRowMaxScore = $('.AssignmentChildMaxScore:visible:first');
                            var firstRowStandard = $('.AssignmentAcademicStandardIDEEL:visible:first');
                            var valueToAssign = parseFloat(assignmentMaxScore.val());
                            skyward.controls.setValue(firstRowMaxScore, SetTwoFixedDecimalsPlacesOnValue(valueToAssign), true);
                            if (firstRowStandard.length > 0)
                            {
                                firstRowStandard.trigger('eelComplete');
                            }
                        }
                    }

                    updateVisibleSubjectStandardRowCount($(this).parents(".subjectStandardQuickEntry"));
                });

                //Clear button clicked
                $(selector).find('.subjectStandardQuickEntry tr.js-childrecordquickentrychild .childrecordquickentryclearbuttoncell, .subjectStandardQuickEntry tr.js-childrecordquickentrychildadd .childrecordquickentryclearbuttoncell').on('childrecordquickentry-row-cleared', function (event, clearedRow, isRowBeingRemoved)
                {
                    if (getAssignmentChildRecordQuickEntryRowCount(selector, isRowBeingRemoved) <= 1)
                    {
                        var assignmentMaxScore = $(selector + ' input.js-assignment-overallMaxScore:not(".originallyDisabled")');
                        assignmentMaxScore.prop('disabled', false);
                    }

                    //This little bit of jank is allowing us to get the correct max score after clearing the row since it hasn't been hidden in the DOM at this point.
                    var childAssignmentScoreInput = clearedRow.find('input.AssignmentChildMaxScore');
                    childAssignmentScoreInput.addClass('js-excludeFromMaxScoreCalc');
                    changeMaxScore(subjectStandardQuickEntry);
                    childAssignmentScoreInput.removeClass('js-excludeFromMaxScoreCalc');

                    checkHideSubjectStandardMaxScore($(this).parents(".subjectStandardQuickEntry"), clearedRow, isRowBeingRemoved, true);
                    updateVisibleSubjectStandardRowCount($(selector + " .subjectStandardQuickEntry"));
                });

                //Remove button clicked
                $(selector).find('.subjectStandardQuickEntry tr.js-childrecordquickentrychild .js-childRecordQuickEntryClearRow').on('childrecordquickentry-row-removed', function (event)
                {
                    var targetRow = $(this).parents("tr").first();
                    var subjectStandardQuickEntry = targetRow.parents(".subjectStandardQuickEntry");
                    targetRow.remove();
                    changeMaxScore(subjectStandardQuickEntry);
                    checkHideSubjectStandardMaxScore(subjectStandardQuickEntry, targetRow, true, false);
                    updateVisibleSubjectStandardRowCount(subjectStandardQuickEntry);
                });

                $(selector).find('input.AssignmentChildMaxScore:not(.doNotPost)').on('change', function ()
                {
                    var childMaxScore = $(this);
                    var subjectStandardQuickEntry = childMaxScore.parents(".subjectStandardQuickEntry").first();
                    changeMaxScore(subjectStandardQuickEntry);
                    event.stopPropagation();
                    event.preventDefault();
                });

                //Handle Change Event for Overall Assignment Max Score
                $(selector).find('input.js-assignment-overallMaxScore').on('change', function (event)
                {
                    var amountToAssign = 0;
                    var assignmentMaxScoreValue = $(event.target).val();
                    if (!isNaN(assignmentMaxScoreValue) && assignmentMaxScoreValue > 0)
                    {
                        amountToAssign = assignmentMaxScoreValue;
                    }
                    if (getAssignmentChildRecordQuickEntryRowCount(selector, false) <= 1)
                    {
                        $(selector).find('input.AssignmentChildMaxScore:not(.doNotPost)').each(function ()
                        {
                            var current = $(this);
                            skyward.controls.setValue(current, SetTwoFixedDecimalsPlacesOnValue(amountToAssign), true);
                        });
                    }
                });

                $.when(updateChildren).done(function ()
                {
                    if (visibleRowCount > 1)
                    {
                        $('input.js-assignment-overallMaxScore').prop('disabled', true);
                    }
                });

                $(selector).find('#AssignmentIsOnlineAssignment, input.isOnlineAssignment').each(function ()
                {
                    var current = $(this);
                    if (current.is(':disabled,[readonly],.ui-disabled'))
                    {
                        current.addClass('originallyDisabled');
                    }
                });
            };

            setUpAssignmentWorkflowEvents();

            if ($(selector).find(".assignmentContent").length > 0)
            {
                var subjectStandardQuickEntry;

                if ($(selector).parents(".subjectStandardQuickEntry").length > 0)
                {
                    subjectStandardQuickEntry = $(selector).parents(".subjectStandardQuickEntry").first();
                }
                else
                {
                    subjectStandardQuickEntry = $(selector).find(".subjectStandardQuickEntry");
                }
                updateVisibleSubjectStandardRowCount(subjectStandardQuickEntry, selector);
            }

            $(selector).find('.gradebookSyncedObjectCustomDelete').click(function ()
            {
                var deleteButton = $(this);
                var deleteButtonData = deleteButton.data();
                var urlReferrer = deleteButtonData.urlReferrer;
                var idsToDelete = [];

                if (skyward.browse.browseList.hasOwnProperty(deleteButtonData.browseName))
                {
                    var linkedObjectsToDeleteBrowse = skyward.browse.browseList[deleteButtonData.browseName].browse;
                    var browseData = linkedObjectsToDeleteBrowse.data();
                    var editableBrowseData = browseData ? browseData.editablebrowsedata : [];
                    for (var i = 0; i < editableBrowseData.length; i++)
                    {
                        var data = editableBrowseData[i];

                        if (data.value == true)
                        {
                            var rowData = $(`#${data.name}`).data();
                            if (rowData !== undefined)
                            {
                                idsToDelete.push(rowData[deleteButtonData.foreignKeyField]);
                            }
                        }
                    }
                }

                var data =
                {
                    IdsToDelete: JSON.stringify(idsToDelete),
                    deleteForAllSynced: deleteButtonData.deleteForAllSynced,
                    UrlReferrer: urlReferrer
                };
                skyward.window.loadContent("full", "Gradebook", deleteButtonData.deleteController, "CompleteDelete", deleteButton.data().primaryKeyValue, data);
            });

            $(selector).find('#editAssignment_AssignedDate').on('change', function ()
            {
                updateDueDate($(this), false);
            });
            $(selector).find("[name='Assignment.AssignedDate']").on('change', function ()
            {
                updateDueDate($(this), true);
            });
            $(selector).find(".assignmentDetails.isOnlineAssignment").on('change', function ()
            {
                updateOnlineAssignments(selector, $(this));
            });

            $(selector).find("#editStudentAssignment").on("change", ".onlineAssignmentManualScore", function ()
            {
                var textbox = $(this);
                if (!textbox.is(':disabled') && !textbox.is('[readonly]'))
                {
                    var assignmentQuestionID = textbox.data().assignmentQuestionId;

                    var dov = textbox.parents(".dataObjectViewer");
                    var scoreField = dov.find(".onlineAssignmentTotalScore");
                    if (textbox.data().organizerType == "AS")
                    {
                        //Need to sum up each individual onlineAssignmentSubTotalScore first based on onlineAssignmentManualScore_academicStandardID
                        //then we can sum the subtotatls

                        updateQuestionContainerSubtotal(textbox);

                        //if this question exists elsewhere, update that one as well.
                        dov.find(".assignmentQuestion_" + assignmentQuestionID).each(function ()
                        {
                            var duplicateQuestion = $(this);

                            var textBoxValue = skyward.controls.getValue(textbox);
                            if (textBoxValue)
                            {
                                textBoxValue = parseFloat(textBoxValue).toFixed(2);
                            }
                            skyward.controls.setValue(duplicateQuestion, textBoxValue, true);
                            updateQuestionContainerSubtotal(duplicateQuestion);
                        });


                        updateAssignmentTotal(scoreField);
                    }
                    else if ((!scoreField.is(':disabled,[readonly],.ui-disabled')) ||
                             (scoreField.data().isParentAssignment.toString().toLowerCase() == "true" && scoreField.data().persistReadOnly.toString().toLowerCase() == "false"))
                    {
                        var total = null;
                        dov.find(".onlineAssignmentManualScore:visible").each(function ()
                        {
                            var innerTextbox = $(this);
                            var value = skyward.controls.getValue(innerTextbox);
                            if (value)
                            {
                                if (total == null)
                                {
                                    total = 0.00;
                                }
                                var multiplier = 1;

                                if (innerTextbox.data().multiplier != null)
                                {
                                    multiplier = parseFloat(innerTextbox.data().multiplier);
                                }
                                total += parseFloat(value) * multiplier;
                            }
                        });

                        if (total)
                        {
                            total = total.toFixed(2);
                        }
                        skyward.controls.setValue(scoreField, total);
                    }
                }
            });

            $(selector).find(".onlineAssignmentSubTotalScore").on("change", function ()
            {
                updateAssignmentTotal($(this));
            });

            var updateQuestionContainerSubtotal = function (textbox)
            {
                var subtotal = null;
                var dov = textbox.parents(".dataObjectViewer");
                dov.find(".onlineAssignmentManualScore." + textbox.data().identifierSuffix + ":visible").each(function ()
                {
                    var value = skyward.controls.getValue($(this));
                    if (value)
                    {
                        if (subtotal == null)
                        {
                            subtotal = 0.00;
                        }
                        subtotal += parseFloat(value);
                    }
                });
                if (subtotal)
                {
                    subtotal = subtotal.toFixed(2);
                }

                var standardScoreField = dov.find("#ByAcademicStandard_AcademicStandardScore_" + textbox.data().identifierSuffix + ".onlineAssignmentSubTotalScore");
                skyward.controls.setValue(standardScoreField, subtotal);
            };

            var updateAssignmentTotal = function (textbox)
            {
                var dov = textbox.parents(".dataObjectViewer");
                var scoreField = dov.find(".onlineAssignmentTotalScore");

                var total = 0.00;
                dov.find(".onlineAssignmentSubTotalScore").each(function ()
                {
                    var value = skyward.controls.getValue($(this));
                    if (value)
                    {
                        total += parseFloat(value);
                    }
                });

                total = total.toFixed(2);
                skyward.controls.setValue(scoreField, total);

            };

            $(selector).find('.contentArea').on('fileAdded', function (event, data)
            {
                updateCurrentAddedMedia($(this), data);
            });

            $(selector).find('#SelectAssignmentsToAdd, #SelectStudentGroupAssignmentsToRemove').on('change', '.syncAssignmentCheckBox ', function (event)
            {
                var checkbox = $(this);
                var data = checkbox.data();

                var isSynced = data.issynced.toString().toLowerCase();

                if (isSynced == "false" && checkbox.is(":checked"))
                {
                    skyward.controls.setValue(checkbox, false);
                    setTimeout(function ()
                    {
                        skyward.controls.disable(checkbox);
                    }, 20);
                }
            });

            var printStudentAssignment = function ()
            {
                var element = $(this);
                var data = element.data();
                var action = "PrintStudentAssignmentOptionsPopup";

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data:
                        {
                            assignmentID: data.assignmentid,
                            staffID: data.staffID
                        }
                    });
                };

                var createButton = { id: 'studentAssignmentPrintoutPopupCreate', text: "Print Preview", click: function () { studentAssignmentPrintoutPopupCreate(dialog); }, icon: "Eye" };
                var closeButton = { id: 'studentAssignmentPrintoutPopupClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var dialog = skyward.modalLayer.showDialog('Print Student Assignment', buildPopup, [createButton, closeButton]);
            };

            var studentAssignmentPrintoutPopupCreate = function (dialog)
            {
                var parameters = studentAssignmentPrintoutPopupParameters(dialog);
                var buildHTML = studentAssignmentPrintoutPopupBuild('BuildStudentAssignmentPrintout', parameters);

                var printButton = { id: 'studentAssignmentPrintoutPopupPrint', text: "Print", click: function () { studentAssignmentAnswerKeySharedPrintoutPopupPrint('Print Student Assignment', 'BuildStudentAssignmentPrintoutPdf', parameters); }, icon: "PrintAvailable" };
                var closeButton = { id: 'studentAssignmentPrintoutPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Print Student Assignment', buildHTML, [printButton, closeButton], { width: "75%", additionalClasses: "studentAssignmentModal" });
                gridPopup.content.addClass('studentAssignmentPrintoutModalContent');
            };

            var studentAssignmentPrintoutPopupParameters = function (dialog)
            {
                var printClassDetails = dialog.content.find('.printClassOptionHeader').is(':checked');
                var leaveRoomForStudentName = dialog.content.find('.leaveRoomForStudentName').is(':checked');

                var data = $('.printStudentAssignmentPopupContent').data();
                var sectionID = data.sectionid.toString();
                var assignmentID = data.assignmentid.toString();

                var parameters =
                {
                    printClassDetails: printClassDetails,
                    leaveRoomForStudentName: leaveRoomForStudentName,
                    assignmentID: assignmentID,
                    sectionID: sectionID
                };
                return parameters;
            };

            var studentAssignmentPrintoutPopupBuild = function (action, data)
            {
                var buildHTML = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data: data
                    });
                };
                return buildHTML;
            };

            var printAnswerKey = function ()
            {
                var element = $(this);
                var data = element.data();
                var action = "PrintAnswerKeyOptionsPopup";

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data:
                        {
                            assignmentID: data.assignmentid,
                            staffID: data.staffID
                        }
                    });
                };

                var createButton = { id: 'answerKeyPrintoutPopupCreate', text: "Print Preview", click: function () { answerKeyPrintoutPopupCreate(dialog); }, icon: "Eye" };
                var closeButton = { id: 'answerKeyPrintoutPopupClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var dialog = skyward.modalLayer.showDialog('Print Answer Key', buildPopup, [createButton, closeButton]);
            };

            skyward.gradebookassignment.updateSubmissionStatuses = function (value)
            {
                var comboBoxes = $(".updatedSubmissionStatusComboBoxRow");

                comboBoxes.each(function ()
                {
                    var comboBox = $(this);
                    if (comboBox.find('option[value="' + value + '"]').length > 0)
                    {
                        skyward.controls.setValue(comboBox, value);
                    }
                });
            };

            skyward.gradebookassignment.updateSubmissionStatusRow = function (control)
            {
                var comboBox = $(control);
                var parentBrowse = comboBox.parents("#MassUpdateStudentAssignmentSubmissionStatusEntry");
                var checkboxFieldSet = parentBrowse.siblings("#fsClearQuestionScores");
                var studentAssignmentID = comboBox.data('student-assignment-id');

                var showClearScoreCheckbox = false;

                var newStatus = skyward.controls.getValue(comboBox);
                var additionalMinutesInput = parentBrowse.find('#AdditionalMinutes-' + studentAssignmentID);
                updateAdditionalMinutesTextBox(additionalMinutesInput, newStatus);

                var originalValue = comboBox.data('original-value');
                if (originalValue !== newStatus &&
                    (newStatus === reopenedCode ||
                        newStatus === reopenedNewAttemptCode ||
                        newStatus === inProgressCode))
                {
                    showClearScoreCheckbox = true;
                }

                skyward.controls.toggleVisible(checkboxFieldSet, showClearScoreCheckbox, true);
            };

            function updateSingleStudentAssignmentComboBoxInit()
            {
                var statusComboBox = $(this);
                var parent = statusComboBox.parents('.workflowContent').first();
                var data = parent.find('.js-CurrentStatusComboBox').first().data();
                var additionalMinutesTextBox = parent.find('.js-AdditionalMinutesTextBox').first();

                if (data['isTimed'] === "True")
                {
                    var currentStatusCode = data['currentStatusCode'];
                    skyward.controls.setValue(statusComboBox, currentStatusCode);
                    setAdditionalMinutesTextBoxReadOnly(additionalMinutesTextBox, currentStatusCode);
                }

                statusComboBox.on('change', updateSingleSubmissionStatus);
            }

            function updateSingleSubmissionStatus()
            {
                var statusComboBox = $(this);
                var parent = statusComboBox.parents('.workflowContent').first();
                var additionalMinutesTextBox = parent.find('.js-AdditionalMinutesTextBox').first();

                if (additionalMinutesTextBox.length > 0)
                {
                    var newStatus = skyward.controls.getValue(statusComboBox);
                    updateAdditionalMinutesTextBox(additionalMinutesTextBox, newStatus);
                }
            }

            function updateAdditionalMinutesTextBox(additionalMinutesTextBox, newStatus)
            {
                setAdditionalMinutesTextBoxReadOnly(additionalMinutesTextBox, newStatus);
                setAdditionalMinutesTextBoxValue(additionalMinutesTextBox, newStatus);
            }

            function setAdditionalMinutesTextBoxReadOnly(additionalMinutesTextBox, status)
            {
                if (status === submittedCode ||
                    status === expiredCode)
                {
                    additionalMinutesTextBox.prop('readonly', true);
                    skyward.controls.setValue(additionalMinutesTextBox, '');
                    return;
                }
                else
                {
                    additionalMinutesTextBox.prop('readonly', false);
                }
            }

            function setAdditionalMinutesTextBoxValue(additionalMinutesTextBox, newStatus)
            {
                var currentAdditionalMinutesVal = (skyward.controls.getValue(additionalMinutesTextBox) || '').trim();

                if (currentAdditionalMinutesVal == '' &&
                    (newStatus === reopenedCode || newStatus === reopenedNewAttemptCode)) {
                    defaultMinutesAllowed = additionalMinutesTextBox.data('default-minutes');
                    skyward.controls.setValue(additionalMinutesTextBox, defaultMinutesAllowed);
                }
            }

            function clearAdditionalMinutesColumn() {
                var columns = $(".additionalMinutesTextbox");

                $.each(columns, function () {
                    skyward.controls.setValue($(this), '');
                });
            };

            function massUpdateMinutesAllowed() {
                var button = $(this);
                var columns = $(".additionalMinutesTextbox:not([readonly])");
                var value = skyward.controls.getValue(button.siblings("#minutesAllowedHeaderTextBox"));

                $.each(columns, function () {
                    var additionalMinutesTextBox = $(this);

                    if (!additionalMinutesTextBox.is(":disabled,[readonly],.ui-disabled")) {
                        skyward.controls.setValue(additionalMinutesTextBox, value);
                    }
                });
            };

            var answerKeyPrintoutPopupCreate = function (dialog)
            {
                var parameters = answerKeyPrintoutPopupParameters(dialog);
                var buildHTML = answerKeyPrintoutPopupBuild('BuildAnswerKeyPrintout', parameters);

                var printButton = { id: 'answerKeyPrintoutPopupPrint', text: "Print", click: function () { studentAssignmentAnswerKeySharedPrintoutPopupPrint('Print Answer Key', 'BuildAnswerKeyPrintoutPdf', parameters); }, icon: "PrintAvailable" };
                var closeButton = { id: 'answerKeyPrintoutPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Print Answer Key', buildHTML, [printButton, closeButton], { width: "75%", additionalClasses: "answerKeyModal" });
                gridPopup.content.addClass('answerKeyPrintoutModalContent');
            };

            var answerKeyPrintoutPopupParameters = function (dialog)
            {
                var dialogOptionValues = getPrintDialogOptionValues(dialog);

                var data = $('.printStudentAssignmentPopupContent').data();
                var sectionID = data.sectionid.toString();
                var assignmentID = data.assignmentid.toString();
                var data =
                {
                    printClassDetails: dialogOptionValues.printClassDetails,
                    showQuestionInstructions: dialogOptionValues.showQuestionInstructions,
                    showQuestionImages: dialogOptionValues.showQuestionImages,
                    leaveRoomForStudentName: dialogOptionValues.leaveRoomForStudentName,
                    assignmentID: assignmentID,
                    sectionID: sectionID
                };
                return data;
            };

            var answerKeyPrintoutPopupBuild = function (action, data)
            {

                var buildHTML = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data: data
                    });
                };
                return buildHTML;
            };

            var printOnlineStudentAssignment = function () {
                var element = $(this);
                var data = element.data();
                var popupAction = data.popupaction;

                var popupData =
                {
                     assignmentID: data.assignmentid,
                     isMultiPrint: data.ismultiprint
                }

                if (data.studentsectionid != null) {
                    popupData.studentSectionID = data.studentsectionid
                }

                var buildPopup = function () {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Assignment/" + popupAction,
                        type: "POST",
                        dataType: "viewparthtml",
                        data: popupData
                    });
                };

                var createButton = { id: 'onlineStudentAssignmentPrintoutPopupCreate', text: "Print Preview", click: function () { studentOnlineAssignmentPrintoutPopupCreate(dialog); }, icon: "Eye" };
                var closeButton = { id: 'onlineAssignmentPrintoutPopupClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var popupHeader = 'Print Student Assignment';

                if (popupData.isMultiPrint == true)
                {
                    popupHeader += 's';
                }

                var dialog = skyward.modalLayer.showDialog(popupHeader, buildPopup, [createButton, closeButton]);
            };

            var onlineStudentAssignmentPrintoutPopupParameters = function (dialog) {
                var dialogOptionValues = getPrintDialogOptionValues(dialog);

                var data = $('.printStudentAssignmentPopupContent').data();
                var sectionID = data.sectionid.toString();
                var assignmentID = data.assignmentid.toString();
                var isMultiPrint = data.ismultiprint.toString();

                var parameters =
                {
                    printClassDetails: dialogOptionValues.printClassDetails,
                    showQuestionInstructions: dialogOptionValues.showQuestionInstructions,
                    showQuestionImages: dialogOptionValues.showQuestionImages,
                    leaveRoomForStudentName: dialogOptionValues.leaveRoomForStudentName,
                    notStarted: dialogOptionValues.notStarted,
                    inProgress: dialogOptionValues.inProgress,
                    reopened: dialogOptionValues.reopened,
                    reopenedAsNewAttempt: dialogOptionValues.reopenedAsNewAttempt,
                    expired: dialogOptionValues.expired,
                    submitted: dialogOptionValues.submitted,
                    scored: dialogOptionValues.scored,
                    studentNameDisplayTypeCode: dialogOptionValues.studentNameDisplayTypeCode,
                    assignmentID: assignmentID,
                    sectionID: sectionID,
                    isMultiPrint: isMultiPrint,
                    isMultiPrint: isMultiPrint
                };

                if (data.studentsectionid != null) {
                    parameters.studentSectionID = data.studentsectionid.toString();
                }

                selectedStudentsEEL = dialog.content.find('#ContingentStudentAssignmentsEEL')[0];
                if (selectedStudentsEEL != null) {
                    parameters.selectedStudents = selectedStudentsEEL.value
                }

                return parameters;
            };

            var getPrintDialogOptionValues = function (dialog)
            {
                var printClassDetails = dialog.content.find('.printClassOptionHeader').is(':checked');
                var showQuestionInstructions = dialog.content.find('.showQuestionInstructions').is(':checked');
                var showQuestionImages = dialog.content.find('.showQuestionImages').is(':checked');
                var leaveRoomForStudentNameCheckbox = dialog.content.find('.leaveRoomForNotes');
                var leaveRoomForStudentName = true;

                if (leaveRoomForStudentNameCheckbox.length)
                {
                    leaveRoomForStudentName = leaveRoomForStudentNameCheckbox.is(':checked')
                }

                var notStarted = dialog.content.find('.NotStarted').length == 0 || dialog.content.find('.NotStarted').is(':checked');
                var inProgress = dialog.content.find('.InProgress').length == 0 || dialog.content.find('.InProgress').is(':checked');
                var reopened = dialog.content.find('.Reopened').length == 0 || dialog.content.find('.Reopened').is(':checked');
                var reopenedAsNewAttempt = dialog.content.find('.ReopenedAsNewAttempt').length == 0 || dialog.content.find('.ReopenedAsNewAttempt').is(':checked');
                var expired = dialog.content.find('.Expired').length == 0 || dialog.content.find('.Expired').is(':checked');
                var submitted = dialog.content.find('.Submitted').length == 0 || dialog.content.find('.Submitted').is(':checked');
                var scored = dialog.content.find('.Scored').length == 0 || dialog.content.find('.Scored').is(':checked');

                var studentNameDisplayTypeCode = dialog.content.find('#StudentNameDisplayTypeCode').val();

                var dialogOptionValues =
                {
                    printClassDetails: printClassDetails,
                    showQuestionInstructions: showQuestionInstructions,
                    showQuestionImages: showQuestionImages,
                    leaveRoomForStudentName: leaveRoomForStudentName,
                    notStarted: notStarted,
                    inProgress: inProgress,
                    reopened: reopened,
                    reopenedAsNewAttempt: reopenedAsNewAttempt,
                    expired: expired,
                    submitted: submitted,
                    scored: scored,
                    studentNameDisplayTypeCode: studentNameDisplayTypeCode
                }

                return dialogOptionValues;
            }

            var studentOnlineAssignmentPrintoutPopupCreate = function (dialog) {
                var parameters = onlineStudentAssignmentPrintoutPopupParameters(dialog);
                var buildHTML = studentAssignmentPrintoutPopupBuild('BuildOnlineStudentAssignmentPrintout', parameters);

                var popupHeaderPostfix = '';

                if (parameters.isMultiPrint == 'True')
                {
                    popupHeaderPostfix = 's';
                }

                var printButton = { id: 'studentAssignmentPrintoutPopupPrint', text: "Print", click: function () { studentAssignmentAnswerKeySharedPrintoutPopupPrint('Print Student Assignment' + popupHeaderPostfix, 'BuildOnlineStudentAssignmentPrintoutPdf', parameters); }, icon: "PrintAvailable" };
                var closeButton = { id: 'studentAssignmentPrintoutPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Print Student Assignment' + popupHeaderPostfix, buildHTML, [printButton, closeButton], { width: "75%", additionalClasses: "studentAssignmentModal" });
                gridPopup.content.addClass('studentAssignmentPrintoutModalContent');
            };

            var studentAssignmentAnswerKeySharedPrintoutPopupPrint = function (title, action, data)
            {
                var url = skyward.global.virtualDir + "Gradebook/Assignment/" + action;
                skyward.printScreen.launchWorkflow(url, data);
                return true;
            };

            skyward.gradebookassignment.addStudentQuestionComment = function (button)
            {
                button = $(button);
                var commentID = button.data("commenttextareaid");
                var studentQuestionID = button.data("studentquestionid");
                var hasCommentID = button.data("hascommentid");
                skyward.gradebookassignment.toggleStudentQuestionComment(commentID, studentQuestionID, hasCommentID, true);
            };

            skyward.gradebookassignment.clearStudentQuestionComment = function (button)
            {
                button = $(button);
                var commentID = button.data("commenttextareaid");
                var studentQuestionID = button.data("studentquestionid");
                var hasCommentID = button.data("hascommentid");
                skyward.gradebookassignment.toggleStudentQuestionComment(commentID, studentQuestionID, hasCommentID, false);
            };

            skyward.gradebookassignment.toggleStudentQuestionComment = function (commentID, studentQuestionID, hasCommentID, show)
            {
                if (commentID == null || commentID === '' ||
                    studentQuestionID == null || studentQuestionID === '' ||
                    hasCommentID == null || hasCommentID === '')
                {
                    return;
                }

                var commentBox = $("#" + commentID);

                if (commentBox.length > 0)
                {
                    const focusDelay = 250;
                    const buttonIDPrefix = "StudentQuestionCommentButton";
                    const clearPostFix = "Clear-";
                    const addPostFix = "Add-";
                    var buttonToHideID = buttonIDPrefix + (show ? addPostFix : clearPostFix) + studentQuestionID;
                    var buttonToShowID = buttonIDPrefix + (show ? clearPostFix : addPostFix) + studentQuestionID;

                    skyward.controls.show($("#" + buttonToShowID), false);
                    skyward.controls.hide($("#" + buttonToHideID), false);
                    if (show)
                    {
                        skyward.controls.show(commentBox);
                        setTimeout(function ()
                        {
                            commentBox.focus();
                        }, focusDelay);
                    }
                    else
                    {
                        skyward.controls.setValue(commentBox, null);
                        skyward.controls.hide(commentBox);

                        var helpLabel = $("#" + commentID + "-Help");
                        if (helpLabel.length && helpLabel.children().length > 0)
                        {
                            helpLabel.children().remove();
                        }
                    }

                    var hasComment = $("#" + hasCommentID);
                    if (hasComment.length)
                    {
                        skyward.controls.setValue(hasComment, show.toString());
                    }
                }
            };

            $(selector).find('.AssignmentTemplateFilter').on('change', function (event)
            {
                var data = $(this).data();
                var parentContainerData = $(this).parents("div.assignmentTemplateFiltersContainer").first().data();

                updateTemplateFilterTeacherSetting = $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/AssignmentTemplate/UpdateTemplateFilterTeacherSetting",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        selectedFilterObjectIDs: $(this).find('#' + data.hiddenBackingDataId).val(),
                        filterObject: data.filterobject,
                        controller: parentContainerData.controller
                    },
                    activityIndicator: { silent: true }
                });
            });

            var initEvents =
            {
                'printOnlineStudentAssignment': printOnlineStudentAssignment,
                'printStudentAssignment': printStudentAssignment,
                'printAnswerKey': printAnswerKey,
                'massUpdateMinutesAllowed': massUpdateMinutesAllowed,
                'clearAdditionalMinutesColumn': clearAdditionalMinutesColumn,
                'updateSingleStudentAssignmentComboBoxInit': updateSingleStudentAssignmentComboBoxInit
            };

            skyward.events.registerEvents('gradebookassignment', initEvents);
        };

        var getAllSectionIDs = function (browse)
        {
            var sectionIDs = [];

            browse.find(".browseBody").find("tr:not('.unlockedHeaderTableRow')").each(function ()
            {
                var sectionID = getRowSectionID($(this));
                sectionIDs.push(sectionID);
            });

            return JSON.stringify(sectionIDs);
        };

        var getRowSectionID = function (row)
        {
            return parseInt(row.find("input.checkbox").attr("id").split("-")[1]);
        };

        var updateOnlineAssignments = function (selector, checkbox)
        {
            var dueDateField = $(selector).find(".assignmentDetails.dueDate");
            var assignedDateField = $(selector).find(".assignmentDetails.assignedDate");
            var startTimeField = $(selector).find(".assignmentDetails.startTime");
            var startTimeTimeField = $(selector).find(".assignmentDetails.startTimeTime");
            var endTimeField = $(selector).find(".assignmentDetails.endTime");
            var endTimeTimeField = $(selector).find(".assignmentDetails.endTimeTime");

            if (checkbox.get(0).checked)
            {
                startTimeField.val(assignedDateField.val());
                startTimeTimeField.val("12:00 AM");
                endTimeField.val(dueDateField.val());
                endTimeTimeField.val("12:00 AM");
            }
            else
            {
                startTimeField.val('');
                startTimeTimeField.val('');
                endTimeField.val('');
                endTimeTimeField.val('');
            }
        };

        var updateDueDate = function (assignedDateInput, isWorkflow)
        {
            var dueDateField;
            var assignedDateValue = assignedDateInput.val();

            if (isWorkflow)
            {
                dueDateField = $("[name='Assignment.DueDate']");
            }
            else
            {
                dueDateField = $('#editAssignment_DueDate');
            }
            var dueDate = skyward.time.parseDate(dueDateField.val().split(' ')[0]);
            var assignedDate = skyward.time.parseDate(assignedDateValue.split(' ')[0]);

            if (assignedDate.isValidDate() && dueDate.isValidDate() && assignedDate > dueDate)
            {
                dueDateField[0].value = assignedDateValue;
                dueDateField.trigger('change');
            }
        };
        var updateCurrentAddedMedia = function (contentArea, scopingVariables)
        {
            var imageID = '#QuestionAnswerMediaElement';
            if (scopingVariables.length >1)
            {
                imageID += scopingVariables[1];
            }
            var image = $(imageID);

            if(image && image.length >0)
            {
                image.remove();
            }

        };

        var invalidWeightPopup = function ()
        {
            var button = $(this);
            var data = button.data();
            var content = "Assignment weights must be a whole number when calculating into a decaying average score.<br/>This assignment weight is currently rounding to the nearest whole number when calculating into a decaying average score.<br/><br/><div>The rounded weight will be <span class='boldFont'>" + data.roundedWeight + "</span></div>";
            var options =
            {
                anchorTo: button
            };

            skyward.modalLayer.showInformationDialog("Invalid Weight", content, null, options);
        };

        var initUseGradeMarkScoring = function ()
        {
            var checkbox = $(this);
            var data = checkbox.data();

            if (data && data.changeGradeMarkScoring && data.changeGradeMarkScoring != null && data.changeGradeMarkScoring != "")
            {
                skyward.controls.setValue(checkbox, data.changeGradeMarkScoring);
            }
        };

        var initCheckGradeColor = function ()
        {
            var input = $(this);
            var inputData = input.data();

            if (inputData.gradeColor != null && inputData.gradeColor != "")
            {
                input.css("border-color", inputData.gradeColor);
                input.css("border-style", "solid");
                input.css("border-width", "2px");
            }
        };

        var dropLowScoreAssignmentFilter = function ()
        {
            var categoryToIncludeSelector = '.categoryToInclude';
            var categoryToExcludeSelector = '.categoryToExclude';
            var academicStandardToIncludeSelector = '.academicStandardToInclude';
            var subjectToIncludeSelector = '.subjectToInclude';
            var browse = $(this).find(".assignmentToExcludeBrowse");
            var container = browse.parents(".workflowPopup").first();
            var dropLowScoreCategoryToIncludeChange = function ()
            {
                updateIDsToInclude(categoryToIncludeSelector, "#CategoriesToIncludeBackingData");
                skyward.controls.setValue(container.find("#CategoriesToExcludeBackingData"), null);
                skyward.controls.setValue(container.find("#AcademicStandardsToIncludeBackingData"), null);
                skyward.controls.setValue(container.find("#SubjectsToIncludeBackingData"), null);
            };

            var dropLowScoreAcademicStandardToIncludeChange = function ()
            {
                skyward.controls.setValue(container.find("#CategoriesToIncludeBackingData"), skyward.controls.getValue($("#ValidCategoryIDsForBucket")));
                updateIDsToInclude(academicStandardToIncludeSelector, "#AcademicStandardsToIncludeBackingData");
            };

            var dropLowScoreSubjectToIncludeChange = function ()
            {
                skyward.controls.setValue(container.find("#CategoriesToIncludeBackingData"), skyward.controls.getValue($("#ValidCategoryIDsForBucket")));
                updateIDsToInclude(subjectToIncludeSelector, "#SubjectsToIncludeBackingData");
            };

            var updateIDsToInclude = function (eelSelector, backingDataSelector)
            {
                var idsToInclude = [];

                container.find(eelSelector).each(function ()
                {
                    var codeEEL = $(this);
                    var id = skyward.controls.getValue(codeEEL);

                    if (id != null && id != '')
                    {
                        idsToInclude.push(id);
                    }
                });
                updateDropLowScoreAssignmentBrowseToDefaultChecked();
                skyward.controls.setValue(container.find(backingDataSelector), JSON.stringify(idsToInclude));
            };

            var dropLowScoreCategoryToExcludeChange = function ()
            {
                var categoriesToExclude = [];
                container.find(categoryToExcludeSelector).each(function ()
                {
                    var categoryCodeEEL = $(this);
                    var categoryID = skyward.controls.getValue(categoryCodeEEL);

                    if (categoryID != null && categoryID != '')
                    {
                        categoriesToExclude.push(categoryID);
                    }
                });

                updateDropLowScoreAssignmentBrowseToDefaultChecked();
                skyward.controls.setValue(container.find("#CategoriesToIncludeBackingData"), skyward.controls.getValue($("#ValidCategoryIDsForBucket")));
                skyward.controls.setValue(container.find("#CategoriesToExcludeBackingData"), JSON.stringify(categoriesToExclude));
                skyward.controls.setValue(container.find("#AcademicStandardsToIncludeBackingData"), null);
                skyward.controls.setValue(container.find("#SubjectsToIncludeBackingData"), null);
            };

            var updateDropLowScoreAssignmentBrowseToDefaultChecked = function ()
            {
                //DefaultChecked gets cleared on reload when we update filter so we need to set our originalDefaultChecked to true.
                skyward.browse.browseList["SelectAssignments"].originalDefaultChecked = true
            };

            var crqeRowRemoved = function ()
            {
                if ($(this).parents(".childrecordquickentry").find(".categoryToExclude").length > 0)
                {
                    dropLowScoreCategoryToExcludeChange();
                }
                else if ($(this).parents(".childrecordquickentry").find(".categoryToInclude").length > 0)
                {
                    dropLowScoreCategoryToIncludeChange();
                }
                else if ($(this).parents(".childrecordquickentry").find(".academicStandardToInclude").length > 0)
                {
                    dropLowScoreAcademicStandardToIncludeChange();
                }
                else if ($(this).parents(".childrecordquickentry").find(".subjectToInclude").length > 0)
                {
                    dropLowScoreAcademicStandardToIncludeChange();
                }
            }

            container.on("eelComplete", categoryToIncludeSelector, dropLowScoreCategoryToIncludeChange);
            container.on("eelComplete", categoryToExcludeSelector, dropLowScoreCategoryToExcludeChange);
            container.on("eelComplete", academicStandardToIncludeSelector, dropLowScoreAcademicStandardToIncludeChange);
            container.on("eelComplete", subjectToIncludeSelector, dropLowScoreSubjectToIncludeChange);

            container.on("childrecordquickentry-row-removed", ".childrecordquickentryclearbuttoncell", function (event, clearedRow, isRowBeingRemoved)
            {
                crqeRowRemoved.apply($(this));
            });
            container.on("childrecordquickentry-row-cleared", ".childrecordquickentryclearbuttoncell", function (event, clearedRow, isRowBeingRemoved)
            {
                crqeRowRemoved.apply($(this));
            });

            container.find(".js-dropType").on("change", function ()
            {
                var radioGroup = $(this);
                if (skyward.controls.getValue(radioGroup).toString().toLowerCase() == "true") //By Category
                {
                    dropLowScoreCategoryToIncludeChange();
                }
                else
                {

                    dropLowScoreCategoryToExcludeChange();
                }
            });

            container.find(".js-dropType").trigger("change");

            var selectAssignmentsBrowseLoaded = function ()
            {
                browse.off("browseLoaded.SelectAssignments", selectAssignmentsBrowseLoaded); 

                var calculationTypeCode = skyward.controls.getValue(container.find("#EffectiveCalculationTypeCode"));

                if (calculationTypeCode == "D")
                {
                    dropLowScoreAcademicStandardToIncludeChange();
                }
                else if (calculationTypeCode == "B")
                {
                    dropLowScoreSubjectToIncludeChange();
                }
                else
                {
                    if (container.find(".js-dropType").length > 0 &&
                        skyward.controls.getValue(container.find(".js-dropType")).toString().toLowerCase() != "true") //From All Assignments
                    {
                        dropLowScoreCategoryToExcludeChange();
                    }
                    else
                    {
                        dropLowScoreCategoryToIncludeChange();
                    }
                }
            };

            browse.on("browseLoaded.SelectAssignments", selectAssignmentsBrowseLoaded);
        };

        var events =
        {
            'invalidWeight': invalidWeightPopup,
            'initUseGradeMarkScoring': initUseGradeMarkScoring,
            'initCheckGradeColor': initCheckGradeColor,
            'dropLowScoreAssignmentFilter': dropLowScoreAssignmentFilter
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('gradebookassignment', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;

(
    function (skyward, $, undefined)
    {
        skyward.gradebookquestion = skyward.gradebookquestion || {};

        var init = function (selector)
        {
            var templateFilterDMSE = $(selector + " .AssignmentTemplateFilter");
            if (templateFilterDMSE.length > 0)
            {
                templateFilterDMSE.on("modalClosed", function ()
                {
                    var browse = $(selector + " .FilterableTeacherTemplateBrowse");
                    skyward.browse.tryRefreshDetailsPanel(browse.attr("id"));
                });
            }

            var matchingAnswersContainer = $(selector + " .matchingAnswersContainer");

            if (matchingAnswersContainer.length > 0)
            {
                matchingAnswersContainer.on("change", ".matchingAnswerChoiceAnswers", onChoiceAnswerChange);

                $(selector + " .matchingAnswerChoicesContainer").on("change", ".matchingAnswerChoice", onChoiceTextChange);

                matchingAnswersContainer.on("change", ".matchingAnswerMatch ", onMatchTextChange);

                matchingAnswersContainer.on("embeddedImagedLoaded", ".fileUploadElement", embeddedImageChange);

                matchingAnswersContainer.on("change", ".matchingAnswerHiddenImage", embeddedImageChange);

                matchingAnswersContainer.on("openedAdvancedEditor", ".advancedTextArea", function ()
                {
                    var parentContainer = $(this);
                    parentContainer.siblings(".editorSpacer").first().removeClass("displayInlineBlock");

                });

                matchingAnswersContainer.on("closedAdvancedEditor", ".advancedTextArea", function ()
                {
                    var parentContainer = $(this);
                    parentContainer.siblings(".editorSpacer").first().addClass("displayInlineBlock");
                });

                matchingAnswersContainer.find("img.questionAnswerMedia").each(function ()
                {
                    var img = $(this);
                    img.on("load", function () { repositionLines(matchingAnswersContainer); });

                });

                var ro = new ResizeObserver(function()
                {
                    matchingAnswersContainer.each(function ()
                    {
                        repositionLines($(this));
                    });
                });
                matchingAnswersContainer.find(".matchingAnswerMatchesContainer").each(function ()
                {
                    ro.observe($(this)[0]);
                })
                matchingAnswersContainer.find(".matchingAnswerChoicesContainer").each(function ()
                {
                    ro.observe($(this)[0]);
                })

                matchingAnswersContainer.each(function ()
                {
                    repositionLines($(this));
                });
            }

            var imageClick = function ()
            {
                var image = $(this);
                var src = image.prop("src");
                var fullsizeImage = "<img src='" + src + "'/>";

                var img = new Image();
                img.onload = function ()
                {
                    var popupWidthPercent = .9;
                    var popupPadding = 35;
                    var maxWidth = ($(document).width() * popupWidthPercent) - popupPadding;

                    if (this.width > maxWidth)
                    {
                        this.width = maxWidth
                    };

                    var options =
                    {
                        draggable: true,
                    };
                    var layer = skyward.modalLayer.showDialog("Image", img, [{ text: "Close", "icon": "Close" }], options);
                }
                img.src = src;
            }
            matchingAnswersContainer.on('click', 'img', imageClick);
            $(selector + " .onlineAssignmentImageContainer, " + selector + " .studentAssignmentDetailsStudentAnswerSpan").on("click", "img", imageClick);
        };

        var getBackingData = function (backingDataElement)
        {
            var dataString = skyward.controls.getValue(backingDataElement);
            var data;

            if (dataString == "")
            {
                //Initialize for child record gen
                data = JSON.parse(skyward.controls.getOriginalValue(backingDataElement));
            }
            else
            {
                var elem = document.createElement('textarea');
                elem.innerHTML = dataString;
                var decoded = elem.value;
                data = JSON.parse(decoded);
            }

            return data;
        };

        var onChoiceAnswerChange = function ()
        {
            var selectInput = $(this);

            if (!selectInput.hasClass("matchingAnswerChoiceAnswersStudentSide"))
            {
                var identifier = getIdentifier(selectInput.parent(), false);
                var answerIdentifier = getAnswerIdentifierFromChoiceSelection(selectInput);
                var backingDataElement = selectInput.parents(".matchingAnswersContainer").find(".matchingBackingData");
                var backingData = getBackingData(backingDataElement);

                var selectedMatch = getMatch(backingData, answerIdentifier);
                var choice = getChoice(backingData, identifier);

                //choice can be null if this is triggered by the clear button (on the first question within the add question workflow)
                if (choice === null)
                {
                    return;
                }

                choice.AnswerText = selectedMatch == null ? null : selectedMatch.Text;
                choice.AnswerIdentifier = selectedMatch == null ? null : selectedMatch.Identifier;

                skyward.controls.setValue(backingDataElement, JSON.stringify(backingData));
            }

            repositionLine(selectInput.parents(".matchingAnswerChoiceContainer").first());
            var matchingAnswersContainer = selectInput.parents(".matchingAnswersContainer").first();
            repositionLines(matchingAnswersContainer);
            removeBordersForUnusedMatches(selectInput.parents(".matchingAnswersContainer"));
        };

        var onChoiceTextChange = function () {
            var textbox = $(this);
            var backingData = getBackingData(textbox.parents(".matchingAnswersContainer").find(".matchingBackingData"));
            var identifier = getIdentifier(textbox.parents(".matchingAnswerChoiceContainer").first(), false);
            var choice = getChoice(backingData, identifier);
            choice.Choice = textbox.val();
            choice.DisplayMode = skyward.controls.getValue(textbox.parents(".matchingAdvancedTextArea").find(".advancedTextAreaDisplayMode"));
            skyward.controls.setValue(textbox.parents(".matchingAnswersContainer").find(".matchingBackingData"), JSON.stringify(backingData));
        };

        var onMatchTextChange = function () {
            var textbox = $(this);
            var backingData = getBackingData(textbox.parents(".matchingAnswersContainer").find(".matchingBackingData"));
            var identifier = getIdentifier(textbox.parents(".matchingAnswerMatchContainer").first(), true);
            var match = getMatch(backingData, identifier);

            //match can be null if this is triggered by the clear button (on the first question within the add question workflow)
            if (match === null)
            {
                return;
            }

            match.Text = textbox.val();
            match.DisplayMode = skyward.controls.getValue(textbox.parents(".matchingAdvancedTextArea").find(".advancedTextAreaDisplayMode"));

            var choices = getChoicesForMatch(backingData, match)
            for (var i = 0; i < choices.length; i++)
            {
                var choice = choices[i];
                choice.AnswerText = match.Text;
            }
            skyward.controls.setValue(textbox.parents(".matchingAnswersContainer").find(".matchingBackingData"), JSON.stringify(backingData));
        };

        var embeddedImageChange = function ()
        {
            var element = $(this);
            var matchingAnswersContainer = element.parents(".matchingAnswersContainer").first();
            repositionLines(matchingAnswersContainer);
        };

        var repositionLines = function (matchingAnswersContainer)
        {
            var middleDiv = matchingAnswersContainer.find(".middleDiv");
            var middleDivWidth = middleDiv.width() + 2; // Account for margin removal
            middleDiv.empty();
            matchingAnswersContainer.find(".matchingAnswerChoiceContainer:not(.template)").each(function ()
            {
                var matchingAnswerChoiceContainer = $(this);
                middleDiv.append(addLine(matchingAnswerChoiceContainer, middleDivWidth, matchingAnswersContainer.height()));

                repositionLine(matchingAnswerChoiceContainer);
            });
        };

        var addLine = function (choiceDiv, width, height)
        {
            var number = choiceDiv.prevAll(".matchingAnswerChoiceContainer").length + 1;
            var lineSvg = '<svg class="matchingChoiceSvg" style="width: ' + width + 'px; height: ' + height + 'px">';
            lineSvg += '<line class="hidden matchingChoiceLine' + number + '"></line></svg>';

            return $(lineSvg);
        };

        var getMatchingLineAdjustments = function (choiceDiv)
        {
            var choiceInput = choiceDiv.find(".matchingAnswerChoice").first();

            if (choiceInput.length < 1)
            {
                choiceInput = choiceDiv.find(".matchingAnswerChoiceAnswers").first()
            }

            if (choiceInput.length < 1)
            {
                return 0;
            }

            var choiceInputMiddleHeight = choiceInput.outerHeight(true) / 2;
            var adjustedHeightPosition = choiceInputMiddleHeight;

            return adjustedHeightPosition;
        };

        var setLineCoordinates = function (choiceDiv, line, middleDiv, choicePosition, matchPosition)
        {
            var adjustedHeightPosition = getMatchingLineAdjustments(choiceDiv);
            var divMarginTop = 0;
            var leftMargin = 0;
            if (choiceDiv.parents(".dataObjectViewer").length > 0)
            {
                divMarginTop = 25;
            }

            var fieldsetPadding = 20;

            if (choiceDiv.parents(".fieldWrapper").length > 0)
            {
                divMarginTop += fieldsetPadding;
            }

            if (choiceDiv.children("img.questionAnswerMedia").length)
            {
                leftMargin += choiceDiv.children("img.questionAnswerMedia")[0].height / 2
            }
            else if (choiceDiv.find("img.embeddedImageDisplay").length)
            {
                leftMargin += choiceDiv.find("img.embeddedImageDisplay").parent().height() / 2
            }

            // Without a margin on lines the start and end of the lines are floating instead of connecting to the question box
            // Moving the x coordinates of the lines to the left and right by 1px places the lines inside of the box lines
            var x1 = -1;
            var y1 = choicePosition == null ? 0 : (choicePosition.top + adjustedHeightPosition + divMarginTop + leftMargin);
            var x2 = middleDiv.width() + 1;
            var y2 = matchPosition == null ? 0 : (matchPosition.top + divMarginTop);

            line.attr('x1', x1).attr('y1', y1).attr('x2', x2).attr('y2', y2);
        }

        var getColor = function (matchNumber, choiceDiv)
        {
            var answerSVG = choiceDiv.children('svg');
            if (answerSVG.length > 0)
            {
                if (answerSVG.hasClass('onlineAssignmentCorrectAnswerCheckmark'))
                {
                    return '#CAF0CA';
                }
                else if (answerSVG.hasClass('onlineAssignmentWrongAnswerCheckmark'))
                {
                    return '#FDABAD';
                }
            }
            else
            {
                switch (matchNumber)
                {
                    case 1:
                        return '#AEC6CF';
                    case 2:
                        return '#04b5f7';
                    case 3:
                        return '#8902f7';
                    case 4:
                        return '#FFB347';
                    case 5:
                        return '#B19CD9';
                    case 6:
                        return '#836953';
                    case 7:
                        return '#CFCFC4';
                    case 8:
                        return '#CB99C9';
                    case 9:
                        return '#966FD6';
                    case 10:
                        return '#375bdd';
                    case 11:
                        return '#d35400';
                    case 12:
                        return '#1abc9c';
                    case 12:
                        return '#3498db';
                    case 13:
                        return '#8e44ad';
                    case 14:
                        return '#e67e22';
                    case 15:
                        return '#16a085';
                    case 16:
                        return '#95a5a6';
                    case 17:
                        return '#f1c40f';
                    case 18:
                        return '#2980b9';
                    case 19:
                        return '#2c3e50';
                    case 20:
                        return '#004225';
                    case 21:
                        return '#FFC1CC';
                    case 22:
                        return '#F7E7CE';
                    case 23:
                        return '#B2EC5D';
                    case 24:
                        return '#FF7F50';
                    case 25:
                        return '#8B008B';
                    case 26:
                        return '#FCF75E';
                    default:
                        return 'black';
                }
            }
        };

        var setMatchingBorder = function (div, color) {
            div.css({
                "border-color": color,
                "border-width": "2px",
                "border-style": "solid"
            });
        };

        var repositionLine = function (choiceDiv)
        {
            var matchingAnswersContainer = choiceDiv.parents(".matchingAnswersContainer").first();
            var middleDiv = matchingAnswersContainer.find(".middleDiv");
            var choiceNumber = choiceDiv.prevAll(".matchingAnswerChoiceContainer").length + 1;

            var choicePosition = choiceDiv.position();

            var selectedAnswerLetter = skyward.controls.getValue(choiceDiv.find(".matchingAnswerChoiceAnswers"));
            var answerLabel = matchingAnswersContainer.find(".matchingAnswerMatchLabel:contains('" + selectedAnswerLetter + "')");
            var matchDiv = answerLabel.parents(".matchingAnswerMatchContainer").first();
            var matchNumber = matchDiv.prevAll(".matchingAnswerMatchContainer").length + 1;
            var matchPosition = matchDiv.position();
            if (matchPosition != null)
            {
                matchPosition.top += matchDiv.height() / 2;
            }

            var line = middleDiv.find(".matchingChoiceLine" + choiceNumber);

            if (selectedAnswerLetter != null && selectedAnswerLetter != "" && selectedAnswerLetter != " ")
            {
                var color = getColor(matchNumber, choiceDiv);

                if (line.hasClass("hidden"))
                {
                    line.removeClass("hidden");
                }

                line.attr('stroke', color);

                setLineCoordinates(choiceDiv, line, middleDiv, choicePosition, matchPosition);

                setMatchingBorder(choiceDiv, color);
                setMatchingBorder(matchDiv, color);
            }
            else
            {
                if (!line.hasClass("hidden"))
                {
                    line.addClass("hidden");
                }

                choiceDiv.css('border', '');
            }
        };

        var removeBordersForUnusedMatches = function (matchingAnswersContainer)
        {
            matchingAnswersContainer.find(".matchingAnswerMatchContainer").each(function ()
            {
                var matchingAnswerMatchContainer = $(this);
                var letter = matchingAnswerMatchContainer.find(".matchingAnswerMatchLabel").html()[0];

                var hasChoicePointingToMatch = false;
                matchingAnswersContainer.find(".matchingAnswerChoiceAnswers").each(function()
                {
                    if (skyward.controls.getValue($(this)) == letter)
                    {
                        hasChoicePointingToMatch = true;
                    }
                });

                if (!hasChoicePointingToMatch)
                {
                    matchingAnswerMatchContainer.css('border', '');
                }
            });
        };

        var addChoice = function ()
        {
            var container = $(this).parents(".matchingAnswersContainer");
            addItem(false, container);
            handleComboBoxes(container);
            repositionLines(container);
        };

        var addMatch = function ()
        {
            var addButton = $(this);
            var container = addButton.parents(".matchingAnswersContainer");
            addItem(true, container, addButton);
            handleComboBoxes(container);
            repositionLines(container);
        };

        var addItem = function (isMatch, container, addButton)
        {
            var itemContainerName = isMatch ? ".matchingAnswerMatchesContainer" : ".matchingAnswerChoicesContainer";
            var specificContainerName = isMatch ? ".matchingAnswerMatchContainer" : ".matchingAnswerChoiceContainer";
            var labelName = isMatch ? ".matchingAnswerMatchLabel" : ".matchingAnswerChoiceLabel";
            var textBoxName = isMatch ? ".matchingAnswerMatch" : ".matchingAnswerChoice";

            var itemContainers = container.find(itemContainerName);
            var items = itemContainers.children(specificContainerName);
            if (isMatch && items.length >= 25)
            {
                addButton.addClass('ui-disabled');
                if (isMatch && items.length > 25)
                {
                    return;
                }
            }

            var template = container.find(itemContainerName).parents("div.matchingContainerDiv").first().find(".template");
            var newItem = template.clone(true);
            newItem.removeClass("template");
            newItem.removeClass("hidden");
            var label = newItem.find(labelName);
            var textBox = newItem.children(textBoxName);
            var identifier = parseInt(getIdentifier(items.last(), isMatch)) + 1;

            if (isMatch)
            {
                var letter = String.fromCharCode(64 + identifier);
                label.text(letter + ".");
            }
            else
            {
                label.text(identifier + ".");
                var selectInput = newItem.children(".matchingAnswerChoiceAnswers");
                skyward.controls.setValue(selectInput, " ");
            }

            updateImageElementIDs(newItem, identifier);

            skyward.controls.setValue(textBox, "");
            newItem.appendTo(itemContainers);
            textBox.focus();
            var backingData = getBackingData(container.find(".matchingBackingData"));

            if (isMatch) {
                backingData.Matches.push(
                    {
                        Identifier: identifier,
                        QuestionAnswerID: null,
                        Text: null
                    })
            }
            else {
                backingData.Choices.push(
                    {
                        Identifier: identifier,
                        Choice: null,
                        AnswerText: null,
                        AnswerIdentifier: null,
                        QuestionAnswerID: null
                    })
            }

            skyward.controls.setValue(container.find(".matchingBackingData"), JSON.stringify(backingData));
            skyward.window.notifyDOMLoad('#' + container.attr("id"));
        }

        var updateImageElementIDs = function (element, newID)
        {
            var imageUploadClassName = ".hasIdentifierToIncrement";
            var imageElements = element.find(imageUploadClassName);
            var imageElementChildren = imageElements.find('*');
            var updateElement = function (element, attributeName)
            {
                var childId = $(element).attr(attributeName);

                if (childId)
                {
                    var childIdParts = childId.split('-');
                    var updatedId;

                    if (childIdParts.length >= 2)
                    {
                        childIdParts[childIdParts.length - 2] = newID;
                        updatedId = childIdParts.join('-');
                        $(element).attr(attributeName, updatedId);
                    }
                }
            };
            var updateElementAttributes = function ()
            {
                updateElement($(this), 'id');
                updateElement($(this), 'name');
                updateElement($(this), 'data-value-input-id');
            };

            imageElements.each(updateElementAttributes);
            imageElementChildren.each(updateElementAttributes);
        }

        var clearMatchingMatch = function ()
        {
            var currentMatchingMatch = $(this).parents(".matchingAnswerMatchContainer");
            $(this).parents(".matchingContainerDiv").find(".matchingAddItem").removeClass('ui-disabled');
            clearMatchingItem(currentMatchingMatch, true);
        };

        var clearMatchingChoice = function ()
        {
            var currentMatchingChoice = $(this).parents(".matchingAnswerChoiceContainer");
            var container = currentMatchingChoice.parents(".matchingAnswersContainer").first();

            clearMatchingItem(currentMatchingChoice, false);
            repositionLines(container);
            removeBordersForUnusedMatches(container);
        };

        var clearMatchingItem = function (current, isMatch)
        {
            var classSelector = isMatch ? ".matchingAnswerMatch" : ".matchingAnswerChoice";
            var singleContainer = classSelector + "Container";
            var multipleContainer = isMatch ? classSelector + "esContainer" : classSelector + "sContainer"
            var fileNumberElement = current.find("input[id*='fNumber']");
            var fileListElement = current.find(".onlineAssignmentQuestionAnswerFileList");

            if (current.parents(multipleContainer).find(singleContainer).length < 2)
            {
                var matchTextBox = current.children(classSelector);
                skyward.controls.setValue(matchTextBox, "");

                //clear image fields
                current.find("img").remove();
                if (fileNumberElement[0].value)
                {
                    //it has a value which means something has been uploaded, so use the framework for removing it
                    var clearButton = fileListElement.find("a[id*='Delete']")[0];

                    if (clearButton)
                    {
                        clearButton.click();
                    }
                }
                else
                {
                    //set the fileNumber to 0 so that the save action deletes it.
                    fileNumberElement[0].value = "0";
                    fileNumberElement.trigger('change');
                }
            }
            else
            {
                var parent = current.parents(multipleContainer);
                current.remove();
                var selections = parent.children(singleContainer);
                var counter = 1
                selections.each(function ()
                {
                    var currentSelection = $(this);
                    var label = isMatch ? currentSelection.find(".matchingAnswerMatchLabel") : currentSelection.find(".matchingAnswerChoiceLabel");
                    var letter = String.fromCharCode(64 + counter);
                    if (isMatch)
                    {
                        label.text(letter + ".");
                    }
                    else
                    {
                        label.text(counter + ".");
                    }
                    updateImageElementIDs(currentSelection, counter);
                    counter++;
                });

                var identifier = getIdentifier(current, isMatch);

                if (isMatch)
                {
                    clearOutAffectedChoices(parent.parents(".matchingAnswersContainer"), identifier);
                    handleComboBoxes(parent.parents(".matchingAnswersContainer"));
                }

                //delete the uploaded file if it exists.
                if (fileNumberElement[0].value && fileNumberElement[0].value != "0")
                {
                    fileListElement.find("a[id*='Delete']")[0].click();
                }

                //If we are clearing something that has a QuestionAnswerID
                //then we need to know to delete something?
                //Or maybe whenever we save we always get all existing, if questionanswerID
                //isnt in dom at all then delete it (either in choice or match)

                removeItemFromBackingData(parent, identifier, isMatch);
            }
        }

        var getIdentifier = function (element, isMatch) {

            var label;
            var value;
            if (isMatch)
            {
                label = element.find(".matchingAnswerMatchLabel");
                value = label.html();

                if (value)
                {
                    var letter = value.substring(0, value.length - 1);
                    return letter.charCodeAt() - 64;
                }

                return -1;
            }

            label = element.find(".matchingAnswerChoiceLabel");
            value = label.html();
            var number = value.substring(0, value.length - 1);
            return number;
        };

        var getMatch = function (backingData, identifier)
        {
            var selectedMatch = null;
            $.each(backingData.Matches, function (k, match) {
                if (match.Identifier == identifier)
                {
                    selectedMatch = match;
                }
            });

            return selectedMatch;
        };

        var getChoice = function (backingData, identifier)
        {
            var selectedChoice = null;
            $.each(backingData.Choices, function (k, choice) {
                if (choice.Identifier == identifier)
                {
                    selectedChoice = choice;
                }
            });

            return selectedChoice;
        };

        var getChoicesForMatch = function (backingData, match) {
            var choices = [];
            $.each(backingData.Choices, function (k, choice) {
                if (choice.AnswerIdentifier == match.Identifier) {
                    choices.push(choice);
                }
            });

            return choices;
        };

        var getAnswerIdentifierFromChoiceSelection = function (selectInput)
        {
            var letter = skyward.controls.getValue(selectInput);

            if (letter == " ")
            {
                return -1;
            }
            var answerLabel = selectInput.parents(".matchingAnswersContainer").find(".matchingAnswerMatchLabel:contains('" + letter + "')");

            return getIdentifier(answerLabel.parents(".matchingAnswerMatchContainer"), true);
        };

        var removeItemFromBackingData = function(container, indentifier, isMatch)
        {
            var backingDataElement = container.parents(".matchingAnswersContainer").find(".matchingBackingData");
            var backingData = getBackingData(backingDataElement);
            var id = indentifier;
            if (isMatch) {

                var tmpMatches = backingData.Matches;
                backingData.Matches = [];

                $.each(tmpMatches, function (k, match) {
                    var choices = getChoicesForMatch(backingData, match)

                    if (match.Identifier == id) {
                        //find any choices that had this picked and clear
                        for (var i = 0; i < choices.length; i++) {
                            var choice = choices[i];
                            choice.AnswerText = null;
                            choice.AnswerIdentifier = null;
                        }
                    }
                    else
                    {
                        if (parseInt(match.Identifier) > parseInt(id)) {
                            //find any choices that had this picked and clear
                            match.Identifier = backingData.Matches.length + 1;

                            for (var i = 0; i < choices.length; i++) {
                                var choice = choices[i];
                                choice.AnswerIdentifier = match.Identifier;
                            }
                        }

                        backingData.Matches.push(match);
                    }
                });
            }
            else {
                var tmpChoices = backingData.Choices;
                backingData.Choices = [];

                var counter = 1;
                $.each(tmpChoices, function (k, choice) {
                    if (choice.Identifier != id) {
                        backingData.Choices.push(choice);
                        choice.Identifier = counter;
                        counter++;
                    }
                });
            }

            skyward.controls.setValue(backingDataElement, JSON.stringify(backingData));
        }

        var clearOutAffectedChoices = function (container, identifier)
        {
            var letter = String.fromCharCode(64 + identifier);
            var comboboxes = container.find(".matchingAnswerChoiceAnswers");
            comboboxes.each(function ()
            {
                var comboBox = $(this);
                var selectedValue = comboBox.find(":selected").text();
                if (selectedValue >= letter)
                {
                    skyward.controls.setValue(comboBox, " ");
                }
            });
        };

        var handleComboBoxes = function (container)
        {
            var matches = container.find(".matchingAnswerMatchContainer:not(.template)");
            var comboboxes = container.find(".matchingAnswerChoiceAnswers");
            comboboxes.each(function ()
            {
                currentComboBox = $(this);
                var selectedValue = currentComboBox.find(":selected").text();
                var template = currentComboBox.children().last().clone();
                currentComboBox.children().remove();

                var currentTemplate = template.clone();
                currentTemplate.attr("value", " ");
                currentTemplate.text(" ");
                currentTemplate.appendTo(currentComboBox);
                matches.each(function ()
                {
                    var match = $(this);
                    var letter = match.find(".matchingAnswerMatchLabel");
                    currentTemplate = template.clone();
                    var text = letter.text().slice(0, 1);

                    currentTemplate.attr("value", text);
                    currentTemplate.text(text);
                    currentTemplate.appendTo(currentComboBox);
                });
                var options = currentComboBox.children();
                options.each(function ()
                {
                    currentOption = $(this);
                    currentOption.removeAttr('selected');
                    if(currentOption.text() == selectedValue)
                    {
                        currentOption.attr('selected', 'selected');
                    }
                });
            });
        }

        var resizeMatchingAnswerContainer = function ()
        {
            $(".matchingAnswersContainer").each(function ()
            {
                repositionLines($(this))
            });
        };

        var loadHTMLViewer = function ()
        {
            var htmlViewerElement = $(this);
            var data = htmlViewerElement.data();

            var isLoading = htmlViewerElement && htmlViewerElement.get(0) && htmlViewerElement.get(0).contentDocument.readyState == "loading";
            var isComplete = htmlViewerElement && htmlViewerElement.get(0) &&
                (htmlViewerElement.get(0).contentDocument.readyState == "complete" || htmlViewerElement.get(0).contentDocument.readyState == "interactive");

            htmlViewerElement.hide();

            var internalOnLoad = function ()
            {
                var htmlViewer = htmlViewerElement.get(0);

                if (htmlViewer.contentWindow == null || htmlViewer.contentWindow.document == null || htmlViewer.contentWindow.document.body == null)
                {
                    setTimeout(function ()
                    {
                        internalOnLoad();
                    }, 50);
                }
                else
                {
                    htmlViewer.contentWindow.document.body.style.background = 'none';
                    if (data.minWidth)
                    {
                        htmlViewer.contentWindow.document.body.style.minWidth = data.minWidth;
                    }
                    if (data.maxWidth)
                    {
                        htmlViewer.contentWindow.document.body.style.maxWidth = data.maxWidth
                    }
                    htmlViewerElement.off('load');
                    htmlViewerElement.show();
                    htmlViewer.height = htmlViewer.contentWindow.document.body.clientHeight + 40; //htmlViewerElement.contents().height();

                    var maxWidthNumber;
                    if (data.maxWidth && data.maxWidth.indexOf("px") > -1)
                    {
                        maxWidthNumber = data.maxWidth.substring(0, data.maxWidth.indexOf("px"));
                    }
                    var minWidthNumber;
                    if (data.minWidth && data.minWidth.indexOf("px") > -1)
                    {
                        minWidthNumber = data.minWidth.substring(0, data.minWidth.indexOf("px"));
                    }
                    if (maxWidthNumber < htmlViewerElement.contents().width() + htmlViewer.contentWindow.document.body.scrollWidth)
                    {
                        htmlViewer.width = maxWidthNumber;
                    }
                    else if (minWidthNumber && minWidthNumber > htmlViewerElement.contents().width() + htmlViewer.contentWindow.document.body.scrollWidth)
                    {
                        htmlViewer.width = minWidthNumber;
                    }
                    else
                    {
                        var addScrollWidth = htmlViewerElement.parents(".matchingAnswerChoiceContainer").length < 1 &&
                            htmlViewerElement.parents(".matchingAnswerMatchContainer").length < 1 &&
                            htmlViewerElement.parents(".onlineAssignmentQuickEntryMinWidthMC").length < 1 &&
                            htmlViewerElement.parents(".instructionsAdvancedTextArea").length < 1;

                        var scrollWidth = htmlViewer.contentWindow.document.body.scrollWidth;
                        if (!addScrollWidth)
                        {
                            scrollWidth = 0;
                        }
                        htmlViewer.width = htmlViewerElement.contents().width() + scrollWidth;
                    }
                }

            };
            if (isLoading)
            {
                htmlViewerElement.on("load", function ()
                {
                    internalOnLoad();
                });


            }
            else if (isComplete)
            {
                setTimeout(function ()
                {
                    internalOnLoad();
                }, 50);
            }

        };

        var previewQuestion = function ()
        {
            var button = $(this);
            var data = button.data();
            var controller = data.controller;

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/" + controller + "/PreviewQuestion",
                    activityIndicator: { silent: true },
                    type: "POST",
                    dataType: "viewparthtml",
                    data: data
                });
            };

            var options =
            {
                draggable: true,
                closeOnEscape: true,
                id: 'PreviewQuestion',
                additionalClasses: 'previewQuestion'
            };

            var dialog = skyward.modalLayer.showDialog("Preview Question", buildPopup, { text: "Close", icon: "Close", click: function () {  dialog.close(); } }, options);
            dialog.modalLayer.uniqueId = 0;
        };


        var events =
        {
            'addChoice': addChoice,
            'addMatch' :addMatch,
            'clearMatchingChoice': clearMatchingChoice,
            'clearMatchingMatch': clearMatchingMatch,
            'loadHTMLViewer': loadHTMLViewer,
            'previewQuestion': previewQuestion
        };
        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.window.registerLayoutResizeCallback(resizeMatchingAnswerContainer);
        skyward.events.registerEvents('gradebookquestion', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.printreceipt = skyward.printreceipt || {};

        var printPaymentBundleReceiptFromList = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'PaymentBundle', 'DisplayReceiptFromList', $(this).data('id'));
        };

        var printPaymentBundleReceiptForReceiptPrinterFromList = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'PaymentBundle', 'DisplayReceiptPrinterReceiptFromList', $(this).data('id'));
        };

        var printPaymentReceiptFromList = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptFromList', $(this).data('paymentId'));
        };

        var printPaymentReceiptForReceiptPrinterFromList = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptPrinterReceiptFromList', $(this).data('paymentId'));
        };

        var printPaymentReceiptFromStudentProfile = function ()
        {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptFromStudentProfile', $(this).data('paymentId'));
        };

        var printPaymentReceiptFromStudentAccess = function () {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptFromStudentAccess', $(this).data('paymentId'));
        };

        var printPaymentReceiptFromFamilyAccess = function () {
            skyward.window.loadContent('popout', 'FeeManagement', 'Payment', 'DisplayReceiptFromFamilyAccess', $(this).data('paymentId'));
        };

        // Event handlers
        var events =
        {
            "printPaymentBundleReceiptFromList": printPaymentBundleReceiptFromList,
            "printPaymentBundleReceiptForReceiptPrinterFromList": printPaymentBundleReceiptForReceiptPrinterFromList,
            "printPaymentReceiptFromList": printPaymentReceiptFromList,
            "printPaymentReceiptForReceiptPrinterFromList": printPaymentReceiptForReceiptPrinterFromList,
            "printPaymentReceiptFromStudentProfile": printPaymentReceiptFromStudentProfile,
            "printPaymentReceiptFromStudentAccess": printPaymentReceiptFromStudentAccess,
            "printPaymentReceiptFromFamilyAccess": printPaymentReceiptFromFamilyAccess
        };
        skyward.events.registerEvents("printreceipt", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.foodservice = skyward.foodservice || {};

        var customerPINvalue;
        var nameID;
        var effectiveTime;

        var init = function (selector)
        {
            var itemPriceItemLimit = $(selector).find(".itemPriceItemLimit");
            if (itemPriceItemLimit.length !== 0)
            {
                itemPriceItemLimit.on('focusout', skyward.foodservice.enforceAdditionalPurchaseAmount);
                $.each(itemPriceItemLimit, function () {
                    skyward.foodservice.enforceAdditionalPurchaseAmount.bind(this)();
                });
            }

            $('input[name*="StopAdditionalPurchases"]').each(function ()
            {
                $(this).on("click", skyward.foodservice.enforceAdditionalPurchaseAmount);
            });

            var updateCustomerCategoryDefaults = $(selector).find(".updateCustomerCategoryDefaults");
            if (updateCustomerCategoryDefaults.length !== 0)
            {
                nameID = null;
                effectiveTime = null;

                var districtID = $(selector).find("[name=Customer_DistrictID]");
                var isWorkflow = $(selector).find("[name=Customer_IsWorkflow]");

                updateCustomerCategoryDefaults.off('change.foodservice');
                $.each(updateCustomerCategoryDefaults, function ()
                {
                    var control = $(this);
                    if (control.is('sky-datepicker'))
                    {
                        effectiveTime = skyward.controls.getValue(control);
                    }
                    control.on('change.foodservice', function () { skyward.foodservice.updateCustomerCategoryDefaults.bind(this, selector, districtID.val(), isWorkflow.val())(); });
                });

                var generatePINButton = $(selector).find("#GenerateCustomerPINButton");
                if (generatePINButton.length === 0)
                {
                    generatePINButton = $(selector).find("#editCustomer_GenerateCustomerPINButton");
                    nameID = $(selector).find("[name=Customer_NameID]").val();
                }

                if (generatePINButton.length !== 0)
                {
                    generatePINButton.off('click.foodservice');
                    generatePINButton.on('click.foodservice', function () { skyward.foodservice.generateCustomerPIN.bind(this, selector, districtID.val(), isWorkflow.val())(); });
                }
            }
        };

        skyward.foodservice.generateCustomerPIN = function (selector, districtID, isWorkflow)
        {
            var url;
            if (isWorkflow === 'true')
            {
                url = 'GenerateNewCustomerPINAdd';
            }
            else
            {
                url = 'GenerateNewCustomerPINDetails';
            }

            updateDefaults(selector, districtID, isWorkflow, url, false);
        };

        skyward.foodservice.updateCustomerCategoryDefaults = function (selector, districtID, isWorkflow)
        {
            var thisControl = $(this);
            if (thisControl && (thisControl[0].name === "Customer.NameID" || thisControl[0].name === "Payor.NameID"))
            {
                nameID = skyward.controls.getValue(thisControl);
            }
            else
            {
                effectiveTime = skyward.controls.getValue(thisControl);
            }

            var customerPIN = $(selector).find("[id=CustomerPIN]");
            if (customerPIN !== undefined)
            {
                customerPINvalue = skyward.controls.getValue(customerPIN);
            }

            if (nameID && effectiveTime && Object.prototype.toString.call(effectiveTime) === "[object Date]" && !isNaN(effectiveTime.getTime()))
            {
                updateDefaults(selector, districtID, isWorkflow, 'UpdateCustomerCategoryDefaults', true);
            }
        };

        var updateDefaults = function (selector, districtID, isWorkflow, url, generatePIN, previousData)
        {
            $.ajax({
                url: skyward.global.virtualDir + "FoodService/Customer/" + url,
                type: 'POST',
                dataType: 'JSON',
                cache: false,
                data:
                {
                    Customer_NameID: nameID,
                    Customer_DistrictID: districtID,
                    Customer_EffectiveTime: effectiveTime ? skyward.time.formatServerDate(effectiveTime, false) : "",
                    Customer_IsWorkflow: isWorkflow,
                    Customer_PIN: customerPINvalue
                },
                success: function (data)
                {
                    if (generatePIN && !data.warnings["CustomerCategory.EffectiveTime"])
                    {
                        var url;
                        if (isWorkflow === 'true')
                        {
                            url = 'GenerateNewCustomerPINAdd';
                        }
                        else
                        {
                            url = 'GenerateNewCustomerPINDetails';
                        }

                        updateDefaults(selector, districtID, isWorkflow, url, false, data);
                    }
                    else
                    {
                        var container = $(selector);
                        var baseErrorContainer = container.find("#baseWorkflowErrorContainer");
                        if (previousData)
                        {
                            $.extend(true, previousData, data);
                            data = previousData;
                        }
                        skyward.ajax.handleResponse(data, "", false, skyward.window.getClosestContentPanel(container));
                        skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                    }
                }
            });
        };

        skyward.foodservice.enforceAdditionalPurchaseAmount = function ()
        {
            var thisControl = $(this);
            var controlName = thisControl.attr('name');
            var controlPrefix = '';
            var itemLimitOverride = undefined;

            if (controlName == 'ItemLimitAdd' || controlName.split('.').length > 1) // Need to prefix for ItemPrice Update workflow
            {
                itemLimitOverride = "#ItemLimitAdd";

                if (controlName.split('.').length > 1)
                {
                    controlPrefix = controlName.split('.')[0];
                }
                else
                {
                    controlPrefix = "ItemPrice";
                }
            }

            var parentBrowse = thisControl.parents("#itemPriceContainer"); //Complete Pricing Workflow
            if (parentBrowse[0] === undefined)
            {
                parentBrowse = thisControl.parents("#editItem_itemPriceContainer"); //Item Details + Winkel
            }
            if (parentBrowse[0] === undefined)
            {
                parentBrowse = thisControl.parents("#editItemPrice_itemPriceContainer"); //ItemPrice Details
                controlPrefix = "editItemPrice_";
            }

            var controlID = controlName.split("-")[1];
            var isBrws = controlID !== undefined && controlID.length > 1;
            if (parentBrowse[0] !== undefined)
            {
                var itemPriceItemLimitField = "#ItemLimit";
                if (isBrws)
                {
                    itemPriceItemLimitField = '#ItemLimit-' + controlID;
                }
                else
                {
                    if (itemLimitOverride !== undefined)
                    {
                        itemPriceItemLimitField = itemLimitOverride;
                    }
                    else
                    {
                        itemPriceItemLimitField = '#' + controlPrefix + 'ItemLimit';
                    }
                }
                var stopAdditionalChkField = isBrws ? '#StopAdditionalPurchases-' + controlID : '#' + controlPrefix + 'StopAdditionalPurchases';
                var additionalPurchaseNbrField = isBrws ? '#AdditionalPurchaseAmount-' + controlID : '#' + controlPrefix + 'AdditionalPurchaseAmount';

                var itemPriceItemLimit = parentBrowse.find(itemPriceItemLimitField);
                var stopAdditionalChk = parentBrowse.find(stopAdditionalChkField);
                var additionalPurchaseNbr = parentBrowse.find(additionalPurchaseNbrField);

                var arrAllow = [];
                var arrDisab = [];
                var thisDiv = isBrws ? '' : parentBrowse.find('#' + controlPrefix + 'divAdditionalPurchases');
                var thisRow = isBrws ? '' : parentBrowse.find('#' + controlPrefix + 'rowAdditionalAmount');

                if (additionalPurchaseNbr[0] !== undefined && stopAdditionalChk[0] !== undefined)
                {
                    if (skyward.controls.getValue(itemPriceItemLimit) !== "" && skyward.controls.getValue(itemPriceItemLimit) !== "0" && skyward.controls.getValue(itemPriceItemLimit) !== "00" && skyward.controls.getValue(itemPriceItemLimit) !== "000")
                    {
                        arrAllow.push((isBrws ? stopAdditionalChk : thisDiv));
                        if (skyward.controls.getValue(stopAdditionalChk))
                        {
                            arrDisab.push((isBrws ? additionalPurchaseNbr : thisRow));
                            skyward.controls.setValue(additionalPurchaseNbr, null);
                        }
                        else
                        {
                            arrAllow.push((isBrws ? additionalPurchaseNbr : thisRow));
                        }
                    }
                    else
                    {
                        arrDisab.push((isBrws ? stopAdditionalChk : thisDiv));
                        arrDisab.push((isBrws ? additionalPurchaseNbr : thisRow));
                        skyward.controls.clearValue(stopAdditionalChk, false);
                        skyward.controls.setValue(additionalPurchaseNbr, null);
                    }

                    for (var i = 0; i < arrAllow.length; i++)
                    {
                        if (isBrws)
                        {
                            if (itemPriceItemLimit[0] !== undefined && (!(itemPriceItemLimit.attr("readonly") || itemPriceItemLimit.attr("disabled"))))
                            {
                                arrAllow[i].removeAttr("disabled readonly");
                            }
                        }
                        else
                        {
                            arrAllow[i].show();
                        }
                    }

                    for (var i = 0; i < arrDisab.length; i++)
                    {
                        if (isBrws)
                        {
                            arrDisab[i].attr({ "disabled": "disabled", "readonly": "readonly" });
                        }
                        else
                        {
                            arrDisab[i].hide();
                        }
                    }
                }
            }
        };

        skyward.foodservice.downloadSkySerial = function () {
            var MaC = navigator.userAgent.toLowerCase();
            var Win = ((MaC.indexOf("win") != -1) || (MaC.indexOf("16bit") != -1));
            MaC = (MaC.indexOf('mac') != -1);

            if (Win)
                window.open('https://www.skyward.com/files/SkyTerm/SkySerial v3 Workstation Install.exe', '_blank');
            if (MaC)
                message('There is no SkySerial application available for your operating system at this time.');
        };

        function initmonthlyreimbursementmonthdetailsschoolfilterclickevent(context)
        {
            $("#SchoolIDFilter_description").parent().click(function()
            {
                $(".detailsPreviewButton").click();
            });
        }

        function initmonthlyreimbursementmonthdetailsgradereferencefilterclickevent(context)
        {
            $("#GradeReferenceIDFilter_description").parent().click(function ()
            {
                $(".detailsPreviewButton").click();
            });
        }

        var events =
        {
            "downloadSkySerial": skyward.foodservice.downloadSkySerial,
            "initmonthlyreimbursementmonthdetailsschoolfilterclickevent": initmonthlyreimbursementmonthdetailsschoolfilterclickevent,
            "initmonthlyreimbursementmonthdetailsgradereferencefilterclickevent": initmonthlyreimbursementmonthdetailsgradereferencefilterclickevent
        };
        skyward.events.registerEvents("foodservice", events);

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.grading = skyward.grading || {};

        var init = function (selector)
        {
            $(selector).find('.childrecordquickentryaddviewpart.honorrollmethodisactivecheckbox').click(function ()
            {
                skyward.grading.honorRollMethodDefaultValueFunction($(this));
            });

            $(selector).find('[id^="editGradeBucketFlagDetails_UseEarnedOverride-"]').off('click', skyward.grading.UseEarnedOverrideSetReadOnly).on('click', skyward.grading.UseEarnedOverrideSetReadOnly);
            $(selector).find('[id^="editGradeBucketFlagDetails_UseEarnedOverride-"]').each(skyward.grading.UseEarnedOverrideSetReadOnly);
            $(selector).find('#StudentGradeBucketsDOV_btnStudentGradeBucketStatusLegend').off('click', displayStudentGradeBucketStatusLegend).on('click', displayStudentGradeBucketStatusLegend);

            var retainOnChange = function ()
            {
                skyward.grading.retainChanged($(this));
            };
            var retainCheckbox = $(selector).find('.retainCheckBox');
            retainCheckbox.on('change', retainOnChange);
            var retainValue = skyward.controls.getValue(retainCheckbox);
            if (!retainValue)
            {
                $(selector).find('.retainTextBox').attr('readonly', 'readonly');
            }

            $(selector).find('.CourseGPAMethodGradeReferenceOverrideUseOverride').each(function () {
                var useOverrideCheckbox = $(this);
                var checkboxID = useOverrideCheckbox.attr('id').split('-')[1];
                useOverrideCheckbox.off('click', function () { skyward.grading.setCourseGPAMethodGradeReferenceOverride(useOverrideCheckbox, checkboxID); }).on('click', function () { skyward.grading.setCourseGPAMethodGradeReferenceOverride(useOverrideCheckbox, checkboxID); });
            });

            $(selector).find('.CourseEarnedCreditsMethodGradeReferenceOverrideUseOverride').each(function () {
                var useOverrideCheckbox = $(this);
                var checkboxID = useOverrideCheckbox.attr('id').split('-')[1];
                useOverrideCheckbox.off('click', function () { skyward.grading.setCourseEarnedCreditsMethodGradeReferenceOverride(useOverrideCheckbox, checkboxID); }).on('click', function () { skyward.grading.setCourseEarnedCreditsMethodGradeReferenceOverride(useOverrideCheckbox, checkboxID); });
            });

            $(selector).find('.js-GradeBucketFlagDetailGPAMethodUseOverride').each(function ()
            {
                var useOverrideCheckbox = $(this);
                var checkboxID = useOverrideCheckbox.attr('id').split('-')[1];
                useOverrideCheckbox.off('click', function () { skyward.grading.setGradeBucketFlagDetailGPAMethodUseOverride(useOverrideCheckbox, checkboxID); }).on('click', function () { skyward.grading.setGradeBucketFlagDetailGPAMethodUseOverride(useOverrideCheckbox, checkboxID); });
            });

            $(selector).find('#editCourseGPAMethod_UseOverride').off('click', function () { skyward.grading.courseoverridevaluefunction('editCourseGPAMethod_GPACredit', 'editCourseGPAMethod_UseOverride'); }).on('click', function () { skyward.grading.coursegpamethodvaluefunction('editCourseGPAMethod_GPACredit', 'editCourseGPAMethod_UseOverride'); });

            if ($(selector).find("#RankUtility_SelectFiltersTask").length)
            {
                $(selector).find("input[name = 'RunOptionchild']").on("change", function () { rankSetGPACalculationMethodForNewRun(this); });
            }

            if ($(selector).find("#HonorRollUtility_SelectFiltersTask").length)
            {
                $(selector).find("input[name = 'RunOptionchild']").on("change", function () { honorRollSetGPACalculationMethodForNewRun(this); });
                $(selector).find("textarea[id = 'HonorRollRunLevelParameterDescriptions']").attr('readonly', 'readonly');
            }

            $(selector).find("select.honorRollInclusionTypeClassname").on("change", function ()
            {
                honorRollSetDependentVisibility(this);
            });

            if ($(selector).find("select.honorRollInclusionTypeClassname").length)
            {
                honorRollSetDependentVisibility($(selector).find("select.honorRollInclusionTypeClassname"));
            }

            if ($(selector).find("#SelectedGradesUtilityDiv").length)
            {
                var selectedGradesParent = $(selector).find("#SelectedGradesUtilityDiv");
                SelectedGradesSetDependencies(selectedGradesParent);
                $(selector).find('.SelectedGradesDependentParent').on('change', function ()
                {
                    SelectedGradesSetDependencies(selectedGradesParent);
                });
            }

            if ($(selector).find("#GradeReportTemplateTestTypeWorkflowDiv").length)
            {
                $(selector).find(".gradeReportTemplateTestTypeSelect").on("change", function ()
                {
                    GradeReportTemplateTestTypeChange($(this).parents('#GradeReportTemplateTestTypeWorkflowDiv'), true);
                });

                $(selector).find(".gradeReportTemplateTestVersionSelect").on("change", function ()
                {
                    GradeReportTemplateTestTypeChange($(this).parents('#GradeReportTemplateTestTypeWorkflowDiv'), true);
                });
            }
            if ($(selector).find("#editGradeReportTemplateTestType_GradeReportTemplateTestTypeDetailsDiv").length)
            {
                $(selector).find(".gradeReportTemplateTestTypeSelect").on("change", function ()
                {
                    GradeReportTemplateTestTypeChange($(this).parents('#editGradeReportTemplateTestType_GradeReportTemplateTestTypeDetailsDiv'));
                });

                $(selector).find(".gradeReportTemplateTestVersionSelect").on("change", function ()
                {
                    GradeReportTemplateTestTypeChange($(this).parents('#editGradeReportTemplateTestType_GradeReportTemplateTestTypeDetailsDiv'));
                });
            }

            //Add Out of District Transfer Course
            $(selector).find('.transferCourseUpdatesGradeMarkInformation').parent().on('codeEELValuesUpdated', updateTransferCourseGradeMarkData);
            $(selector).find('.transferCourseUpdateCompetionDate').on('change', updateTransferCourseCompletionDate);
            $(selector).find('.TransferCourseGradeBucketFlag').parent().on('change', updateTransferCourseGradeBucketFlagData);
            $(selector).find('#TransferCourseCreditOverride').on('change', resetTransferCourseCreditOverride);
            $(selector).find('#PointSetAndCreditOverride').on('change', resetTransferCourseGPACreditOverride);
            $(selector).find('#CourseEarnedPercentOverride').on('change', resetTransferCoursePercentOverride);
            $(selector).find('#CourseGPAPercentOverride').on('change', resetTransferCourseGPAPercentOverride);
            $(selector).find('#TransferCourseEarnedCreditsTextBox').on('change', updateEarnedCreditPopupCalculation);
            $(selector).find('.TransferCourseEarnedPercentOverrideBox').on('change', updateEarnedCreditPopupCalculation);
            $(selector).find('#TransferCourseGPAPopupPossibleCreditBox').on('change', updateGPACreditPopupCalculation);
            $(selector).find('#TransferCourseGPAPopupPointSetID').on('change', updateGPACreditPopupCalculation);
            $(selector).find('.TransferCourseGPAPercentOverrideBox').on('change', updateGPACreditPopupCalculation);
            $(selector).find('#ChangeSectionToOutOfDistrictTransferCourse').on('click', makeOutOfDistrictTransferCoursePopup);

            if ($(selector).find('.fileNameFormatContainer').length)
            {
                rebuildFileNameOutput($(selector).find('.fileNameFormatContainer'));
            };

            $(selector).find('.fileNameFormatContainer').on('childrecordquickentry-row-added', function (event, row)
            {
                var fileNameFormatContainer = row.parents(".fileNameFormatContainer").first();
                var fieldCount = skyward.controls.getValue(fileNameFormatContainer.find(".fileNameFormatFieldCount"));

                if (fieldCount != fileNameFormatContainer.find("tr.childrecordquickentryrow").length)
                {
                    return;
                }

                var backingDataField = fileNameFormatContainer.find(".fileNameFormatOutputBackingData");
                var backingDataJSONDerulo = backingDataField.length &&
                    backingDataField.val() != null &&
                    backingDataField.val() != ""
                    ? JSON.parse(backingDataField.val())
                    : {};
                var childRecordQuickEntry = fileNameFormatContainer.find(".fileNameFormatQuickEntry");

                $.each(backingDataJSONDerulo, function (k, v)
                {
                    var field = childRecordQuickEntry.find("#" + k);
                    if (field.length)
                    {
                        skyward.controls.setValue(field, v.optionValue)
                        if (v.customTextValue)
                        {
                            var customTextHelp = field.parents("tr").first().find(".customTextFieldset input.customText");
                            skyward.controls.setValue(customTextHelp, v.customTextValue);
                        }
                        if (v.dateValue)
                        {
                            var datepicker = field.parents("tr").first().find(".datePickerFieldset sky-datepicker");
                            var parts = v.dateValue.split("-");
                            if (parts.length == 3)
                            {
                                var d = new Date(parts[0], parts[1] - 1, parts[2]);
                                skyward.controls.setValue(datepicker, d);
                            }
                        }
                    }
                });

                //Once we have initialized it lets clear our initial backing data so it doesn't try and mess with anything
                skyward.controls.setValue(backingDataField, "");
            });

            $(selector).find('.fileNameFormatContainer').on('childrecordquickentry-row-cleared', '.childrecordquickentryclearbuttoncell', function (event, row, isRowBeingRemoved)
            {
                if (isRowBeingRemoved)
                {
                    row.addClass("skip");
                }
                rebuildFileNameOutput($(this).parents(".fileNameFormatContainer"));
            });
            $(selector).find('.fileNameFormatDelimiterType').on('change', function ()
            {
                var container = $(this).parents(".fileNameFormatContainer");
                rebuildFileNameOutput(container);
            });

            $(selector).find('.fileNameFormatContainer').on('change', '.fileNameFormatEntryOption', function ()
            {
                var select = $(this);
                var customTextHelp = select.parents("tr").first().find(".customTextFieldset");
                var datePickerFieldset = select.parents("tr").first().find(".datePickerFieldset");

                if (skyward.controls.getValue(select) == "CU")
                {
                    if (customTextHelp.hasClass("hidden"))
                    {
                        customTextHelp.removeClass("hidden");
                    }
                }
                else
                {
                    if (!customTextHelp.hasClass("hidden"))
                    {
                        customTextHelp.addClass("hidden");
                    }
                }

                if (skyward.controls.getValue(select) == "DA")
                {
                    if (datePickerFieldset.hasClass("hidden"))
                    {
                        datePickerFieldset.removeClass("hidden");
                    }

                    var datepicker = datePickerFieldset.find("sky-datepicker");
                    const datePickerValue = skyward.controls.getValue(datepicker);
                    if (!datePickerValue || !datePickerValue.isValidDate())
                    {
                        skyward.controls.setValue(datepicker, new Date())
                    }
                }
                else
                {
                    if (!datePickerFieldset.hasClass("hidden"))
                    {
                        datePickerFieldset.addClass("hidden");
                    }
                }

                rebuildFileNameOutput(select.parents(".fileNameFormatContainer"));
            });

            $(selector).find('.fileNameFormatContainer').on('change', '.customText, sky-datepicker', function ()
            {
                var select = $(this);
                rebuildFileNameOutput(select.parents(".fileNameFormatContainer"));
            });
        };

        var SelectedGradesSetDependencies = function (parentDiv)
        {
            var parentContainer = $(parentDiv);

            var courseSelection = parentContainer.find(".SelectedGradesDependentParent.CourseFilterOption");
            var entityCheckbox = parentContainer.find(".SelectedGradesDependentParent.AdditionalEntities");
            var cecsExists = skyward.controls.getValue(parentContainer.find("#CECSExistsValue"));
            var courseFilterCode = parentContainer.find("#fsCourseFilterCode");
            var specificCourses = parentContainer.find("#fsSpecificCourses");
            var additionalEntitiesCheckboxFieldset = parentContainer.find("#fsAdditionalEntities");
            var additionalEntitiesDiv = parentContainer.find("#divAdditionalEntities");

            var courseSelectionValue = skyward.controls.getValue(courseSelection);
            if (courseSelectionValue == "IC")
            {
                courseFilterCode.hide();
                specificCourses.show();
            }
            else
            {
                courseFilterCode.show();
                specificCourses.hide();
            }

            if (cecsExists == "True")
            {
                var entityCheckboxValue = skyward.controls.getValue(entityCheckbox);
                if (entityCheckboxValue)
                {
                    additionalEntitiesDiv.show();
                    var specificCoursesCECS = parentContainer.find("#fsSpecificCoursesCECS");
                    if (courseSelectionValue == "IC")
                    {
                        specificCoursesCECS.show();
                    }
                    else
                    {
                        specificCoursesCECS.hide();
                    }
                }
            }
            else
            {
                additionalEntitiesCheckboxFieldset.hide();
                additionalEntitiesDiv.hide();
            }
        }

        var GradeReportTemplateTestTypeChange = function (parentDiv, isWorkflow)
        {
            var parentContainer = $(parentDiv);
            var testTypeValue = skyward.controls.getValue(parentContainer.find(".gradeReportTemplateTestTypeSelect"));
            var testVersionValue = skyward.controls.getValue(parentContainer.find(".gradeReportTemplateTestVersionSelect"));

            var dataParams =
            {
                newTestTypeCode: testTypeValue,
                newTestVersionCode: testVersionValue
            };

            var urlString = "UpdateTestColumnViewPartsDetails";
            if (isWorkflow)
            {
                urlString = "UpdateTestColumnViewPartsWorkflow";
            }
            else
            {
                dataParams.gradeReportTemplateTestTypeID = skyward.controls.getValue(parentContainer.find("#editGradeReportTemplateTestType_GradeReportTemplateTestTypeIDInput"));
            }

            $.ajax
            ({
                url: skyward.global.virtualDir + "Grading/GradereportTemplateTestType/" + urlString,
                type: "POST",
                dataType: "JSON",
                data: dataParams,
                success: async function (parseData)
                {
                    var updateHTML = parseData.Success;
                    if (updateHTML === true)
                    {
                        await parentContainer.find('#TestColumnViewPartContainer').viewpartHtml(parseData.ViewPartHTML);
                        skyward.window.notifyResize();
                        skyward.window.notifyDOMLoad("#TestColumnViewPartContainer");
                    }
                }
            });
        };

        const initGradeReportHeaderFields = function ()
        {
            this.find('.GradeReportHeaderRow').each(function ()
            {
                GradeReportSetHeaderDependencies(this);
            });

            this.find('select.GradeReportFieldSelectComboBox').on('change', function ()
            {
                GradeReportSetHeaderDependencies($(this).parents('.GradeReportHeaderRow'));
            });
            this.find('select.GradeReportColumnCountComboBox').on('change', function ()
            {
                GradeReportSetHeaderDependencies($(this).parents('.GradeReportHeaderRow'));
            });
        };

        const initStudentSectionLinkFormat = function ()
        {
            const container = skyward.window.getClosestContentPanel(this);

            const formatBox = this;
            const radioButton = container.find(".js-studentsectionlinking__studentsectionlinkoptioncode");
            const courseType = container.find(".js-studentsectionlinking__usestudentsectionlinkcoursetype");
            const transcriptArea = container.find(".js-studentsectionlinking__usestudentsectionlinktranscriptarea");

            generateStudentSectionLinkFormatSample(formatBox, radioButton, courseType, transcriptArea);

            radioButton.add(courseType).add(transcriptArea)
                .on("change", function ()
                {
                    generateStudentSectionLinkFormatSample(formatBox, radioButton, courseType, transcriptArea);
                });
        };

        var GradeReportSetHeaderDependencies = function (rowDiv)
        {
            var rowContainer = $(rowDiv);
            const row = rowContainer.data("row");

            const columnCount = skyward.controls.getValue(rowContainer.find(`.GradeReportColumnCountComboBox[data-row="${row}"]`));
            const firstComboBoxValue = skyward.controls.getValue(rowContainer.find(".GradeReportFieldSelectComboBox[data-column=\"1\"]"));
            const secondComboBoxValue = skyward.controls.getValue(rowContainer.find(".GradeReportFieldSelectComboBox[data-column=\"2\"]"));

            const rankMethodRowContainer = rowContainer.siblings(`.GradeReportRankMethodRow[data-row="${row}"]`);
            var dummyRankMethodDiv = rankMethodRowContainer.children(".GradeReportRankMethodContainer[data-column=\"dummy\"]");
            var firstRankMethodContainer = rankMethodRowContainer.children(".GradeReportRankMethodContainer[data-column=\"1\"]");
            var secondRankMethodContainer = rankMethodRowContainer.children(".GradeReportRankMethodContainer[data-column=\"2\"]");

            var gPAMethodRowContainer = rowContainer.siblings(`.GradeReportGPAMethodRow[data-row="${row}"]`);
            var dummyGPAMethodDiv = gPAMethodRowContainer.children(".GradeReportGPAMethodContainer[data-column=\"dummy\"]");
            var firstGPAMethodContainer = gPAMethodRowContainer.children(".GradeReportGPAMethodContainer[data-column=\"1\"]");
            var secondGPAMethodContainer = gPAMethodRowContainer.children(".GradeReportGPAMethodContainer[data-column=\"2\"]");

            var gPABucketRowContainer = rowContainer.siblings(`.GradeReportGPABucketRow[data-row="${row}"]`);
            var dummyGPABucketDiv = gPABucketRowContainer.children(".GradeReportGPABucketContainer[data-column=\"dummy\"]");
            var firstGPABucketContainer = gPABucketRowContainer.find(".GradeReportGPABucketContainer[data-column=\"1\"]");
            var secondGPABucketContainer = gPABucketRowContainer.find(".GradeReportGPABucketContainer[data-column=\"2\"]");

            var firstGPABucketCodeelCode = gPABucketRowContainer.find(".GradeReportHeaderGPABucketCodeel[data-column=\"1\"]");
            var secondGPABucketCodeelCode = gPABucketRowContainer.find(".GradeReportHeaderGPABucketCodeel[data-column=\"2\"]");

            var honorRollCodeEELContainer = rowContainer.siblings(`.HonorRollRunRow[data-row="${row}"]`);
            var dummyHonorRollRunCodeelCode = honorRollCodeEELContainer.children(".HonorRollRunContainer[data-column=\"dummy\"]");
            var firstHonorRollCodeelCode = honorRollCodeEELContainer.find(".HonorRollRunContainer[data-column=\"1\"]");
            var secondHonorRollCodeelCode = honorRollCodeEELContainer.find(".HonorRollRunContainer[data-column=\"2\"]");

            function isGPAField(field) {
                var gPAFields = { GP:true, GF:true, GB:true }
                return gPAFields.hasOwnProperty(field);
            }

            function isRankField(field)
            {
                var rankFields = { RK: true, RN: true, RP: true }
                return rankFields.hasOwnProperty(field);
            }

            function isHonorRollField(field)
            {
                var honorRollFields = { HR: true }
                return honorRollFields.hasOwnProperty(field);
            }

            if (columnCount == 2)
            {
                // Rank
                if (isRankField(firstComboBoxValue) && isRankField(secondComboBoxValue))
                {
                    rankMethodRowContainer.show();
                    dummyRankMethodDiv.hide();
                    secondRankMethodContainer.show();
                    firstRankMethodContainer.show();
                }
                else if (isRankField(firstComboBoxValue) && !isRankField(secondComboBoxValue))
                {
                    rankMethodRowContainer.show();
                    dummyRankMethodDiv.hide();
                    secondRankMethodContainer.hide();
                    firstRankMethodContainer.show();
                }
                else if (!isRankField(firstComboBoxValue) && isRankField(secondComboBoxValue))
                {
                    rankMethodRowContainer.show();
                    dummyRankMethodDiv.show();
                    secondRankMethodContainer.show();
                    firstRankMethodContainer.hide();
                }
                else
                {
                    rankMethodRowContainer.hide();
                    dummyRankMethodDiv.hide();
                    secondRankMethodContainer.hide();
                    firstRankMethodContainer.hide();
                }

                //GPA
                if (isGPAField(firstComboBoxValue) && isGPAField(secondComboBoxValue))
                {
                    gPAMethodRowContainer.show();
                    dummyGPAMethodDiv.hide();
                    secondGPAMethodContainer.show();
                    firstGPAMethodContainer.show();

                    gPABucketRowContainer.show();
                    dummyGPABucketDiv.hide();
                    secondGPABucketContainer.show();
                    firstGPABucketContainer.show();
                }
                else if (isGPAField(firstComboBoxValue) && !isGPAField(secondComboBoxValue))
                {
                    gPAMethodRowContainer.show();
                    dummyGPAMethodDiv.hide();
                    secondGPAMethodContainer.hide();
                    firstGPAMethodContainer.show();

                    gPABucketRowContainer.show();
                    dummyGPABucketDiv.hide();
                    secondGPABucketContainer.hide();
                    firstGPABucketContainer.show();
                }
                else if (!isGPAField(firstComboBoxValue) && isGPAField(secondComboBoxValue))
                {
                    gPAMethodRowContainer.show();
                    dummyGPAMethodDiv.show();
                    secondGPAMethodContainer.show();
                    firstGPAMethodContainer.hide();

                    gPABucketRowContainer.show();
                    dummyGPABucketDiv.show();
                    secondGPABucketContainer.show();
                    firstGPABucketContainer.hide();
                }
                else
                {
                    gPAMethodRowContainer.hide();
                    dummyGPAMethodDiv.hide();
                    secondGPAMethodContainer.hide();
                    firstGPAMethodContainer.hide();

                    gPABucketRowContainer.hide();
                    dummyGPABucketDiv.hide();
                    secondGPABucketContainer.hide();
                    firstGPABucketContainer.hide();
                }

                //HonorRoll
                if (isHonorRollField(firstComboBoxValue) && isHonorRollField(secondComboBoxValue))
                {
                    honorRollCodeEELContainer.show();
                    dummyHonorRollRunCodeelCode.hide();
                    firstHonorRollCodeelCode.show();
                    secondHonorRollCodeelCode.show();
                }
                else if (isHonorRollField(firstComboBoxValue) && !isHonorRollField(secondComboBoxValue))
                {
                    honorRollCodeEELContainer.show();
                    dummyHonorRollRunCodeelCode.hide();
                    firstHonorRollCodeelCode.show();
                    secondHonorRollCodeelCode.hide();
                }
                else if (!isHonorRollField(firstComboBoxValue) && isHonorRollField(secondComboBoxValue))
                {
                    honorRollCodeEELContainer.show();
                    dummyHonorRollRunCodeelCode.show();
                    firstHonorRollCodeelCode.hide();
                    secondHonorRollCodeelCode.show();
                }
                else
                {
                    honorRollCodeEELContainer.hide();
                    dummyHonorRollRunCodeelCode.hide();
                    firstHonorRollCodeelCode.hide();
                    secondHonorRollCodeelCode.hide();
                }


            }
            else if (columnCount == 1)
            {
                dummyRankMethodDiv.hide();
                secondRankMethodContainer.hide();

                if (isRankField(firstComboBoxValue)) {
                    rankMethodRowContainer.show();
                    firstRankMethodContainer.show();
                }
                else
                {
                    rankMethodRowContainer.hide();
                }

                dummyGPAMethodDiv.hide();
                secondGPAMethodContainer.hide();

                dummyGPABucketDiv.hide();
                secondGPABucketContainer.hide();

                if (isGPAField(firstComboBoxValue))
                {
                    gPAMethodRowContainer.show();
                    firstGPAMethodContainer.show();

                    gPABucketRowContainer.show();
                    firstGPABucketContainer.show();
                }
                else
                {
                    gPAMethodRowContainer.hide();
                    gPABucketRowContainer.hide();
                }

                dummyRankMethodDiv.hide();
                secondHonorRollCodeelCode.hide();

                if (isHonorRollField(firstComboBoxValue))
                {
                    honorRollCodeEELContainer.show();
                    firstHonorRollCodeelCode.show();
                }
                else
                {
                    honorRollCodeEELContainer.hide();
                    firstHonorRollCodeelCode.hide();
                }
            }
        }

        var honorRollSetDependentVisibility = function (combobox)
        {
            var comboboxVar = $(combobox);
            var inclusionType = skyward.controls.getValue(comboboxVar);
            var allowExceptions = skyward.controls.getValue(comboboxVar.parent().find('input.honorRollAllowExceptionCheckbox'));

            if (inclusionType == 'I')
            {
                comboboxVar.parent().find('.fieldWrapper.fsAllowExceptionClassname').show();
                if (allowExceptions)
                {
                    comboboxVar.parent().find('.fieldWrapper.fsGradeMarkExceptionsClassname').show();
                }
            }
            else
            {
                comboboxVar.parent().find('.fieldWrapper.fsAllowExceptionClassname').hide();
                comboboxVar.parent().find('.fieldWrapper.fsGradeMarkExceptionsClassname').hide();
            }
        }

        var rankSetGPACalculationMethodForNewRun = function(radioButton)
        {
            var value = skyward.controls.getValue($(radioButton));
            var gpaCalculationControl = $("#CurrentCalculation")
            var gpaCalculationValue = skyward.controls.getValue(gpaCalculationControl);
            if (value == "N" && gpaCalculationValue == "P")
            {
                skyward.controls.setValue(gpaCalculationControl, "M");
            }
        }

        var honorRollSetGPACalculationMethodForNewRun = function(radioButton)
        {
            var value = skyward.controls.getValue($(radioButton));
            var gpaCalculationControl = $("#CalculationCode")
            var gpaCalculationValue = skyward.controls.getValue(gpaCalculationControl);
            if (value == "N" && gpaCalculationValue == "P")
            {
                skyward.controls.setValue(gpaCalculationControl, "O");
            }
        }

        var generateStudentSectionLinkFormatSample = function (formatBox, radioButton, courseType, transcriptArea)
        {
            var value = skyward.controls.getValue(radioButton);

            var formatString = "School Year, ";
            switch (value)
            {
                case "S":
                    formatString += "Service (District Level)";
                    break;
                case "CU":
                    formatString += "Curriculum (District Level)";
                    break;
                case "CO":
                    formatString += "Course (Entity Level)";
                    break;
            }

            if (courseType.is(":checked"))
            {
                formatString += ", Course Type";
            }

            if (transcriptArea.is(":checked")) {
                formatString += ", Transcript Area";
            }

            skyward.controls.setValue(formatBox, formatString);
        };

        skyward.grading.setCourseGPAMethodGradeReferenceOverride = function (useOverrideCheckbox, checkboxID)
        {
            var useOverrideCheckboxID = 'GradeReferenceOverrideUseOverride-' + checkboxID;
            skyward.grading.courseoverridevaluefunction('GPACredits-' + checkboxID, useOverrideCheckboxID);
            skyward.grading.setoverridepointsetentity('PointSetEntityID-' + checkboxID, useOverrideCheckboxID);
        };

        skyward.grading.setCourseEarnedCreditsMethodGradeReferenceOverride = function (useOverrideCheckbox, checkboxID)
        {
            var useOverrideCheckboxID = 'GradeReferenceOverrideUseOverride-' + checkboxID;
            skyward.grading.courseoverridevaluefunction('EarnedCredits-' + checkboxID, useOverrideCheckboxID);
        };

        skyward.grading.setGradeBucketFlagDetailGPAMethodUseOverride = function (useOverrideCheckbox, checkboxID)
        {
            var useOverrideCheckboxID = 'UseOverride-' + checkboxID;
            var checkbox = $('#' + useOverrideCheckboxID);
            var control = $('#' + 'GPAPoints-' + checkboxID);
            if (checkbox.length == 0)
            {
                return;
            }

            var useOverride = checkbox.is(':checked');

            if (control.length > 0)
            {
                if (useOverride == true)
                {
                    var originalValue = skyward.controls.getOriginalValue(control);
                    if (originalValue != '')
                    {
                        skyward.controls.setValue(control, originalValue);
                    }
                    else
                    {
                        skyward.controls.setValue(control, '0.00000');
                    }
                }
                else
                {
                    skyward.controls.setValue(control, '');
                }
            }
        };

        skyward.grading.setoverridepointsetentity = function (codeeelID, checkboxID)
        {
            var useOverrideCheckbox = $('#' + checkboxID);
            var overridePointSetEntity = $('#' + codeeelID);
            if (useOverrideCheckbox && useOverrideCheckbox.is(':checked'))
            {
                if (skyward.controls.getValue(overridePointSetEntity) == '')
                {
                    var pointSetEntityValue = skyward.controls.getValue($('#editCourseGPAMethod_PointSetEntityID_value'));

                    skyward.controls.setValue(overridePointSetEntity, pointSetEntityValue);
                }
            }
            else
            {
                skyward.controls.setValue(overridePointSetEntity, '');
            }
        };

        skyward.grading.courseoverridevaluefunction = function (controlID, id) {
            var checkbox = $('#' + id);
            var control = $('#' + controlID);
            if (checkbox.length == 0) {
                return;
            }

            var useOverride = checkbox.is(':checked');

            if (control.length > 0) {
                if (useOverride == true) {
                    var originalValue = skyward.controls.getOriginalValue(control);
                    if (originalValue != '')
                    {
                        skyward.controls.setValue(control, originalValue);
                    }
                    else
                    {
                        skyward.controls.setValue(control, '0.000');
                    }
                }
                else
                {
                    skyward.controls.setValue(control, '');
                }
            }
        };

        skyward.grading.honorRollMethodDefaultValueFunction = function (element)
        {
            var checkboxId = element.attr('id');
            if (skyward.controls.getValue(element) == true)
            {
                var idParts = checkboxId.split('-');
                var hidden = $('#editHonorRollMethod_gpaHighDefaultValue');

                var gpaLow = $('#GPALow-add-' + idParts[2]);
                if (skyward.controls.getValue(gpaLow) == '')
                {
                    skyward.controls.setValue(gpaLow, 0);
                }

                var gpaHigh = $('#GPAHigh-add-' + idParts[2]);
                if (skyward.controls.getValue(gpaHigh) == '')
                {
                    skyward.controls.setValue(gpaHigh, skyward.controls.getValue(hidden));
                }
            }
        };

        skyward.grading.retainChanged = function (checkbox)
        {
            var retainTextBox = $('.retainTextBox');
            var days = skyward.controls.getValue(retainTextBox);
            var checked = skyward.controls.getValue(checkbox);
            if (days == '') {
                days = skyward.controls.getOriginalValue(retainTextBox);
            }

            if (!checked) {
                retainTextBox.attr('readonly', 'readonly');
                skyward.controls.setValue(retainTextBox, null);
            }
            else {
                retainTextBox.removeAttr('readonly');
                skyward.controls.setValue(retainTextBox, days);
            }
        };

        skyward.grading.UseEarnedOverrideSetReadOnly = function () {
            var useEarnedOverride = $(this);
            var isUseEarnedOverrideValue = $(this).is(':checked');
            var isUseEarnedOverrideDisabled = $(this).is(':disabled,.ui-disabled');
            var gradeBucketFlagDetailID = useEarnedOverride.attr("id").split("-")[1];
            var useInEarned = $("#editGradeBucketFlagDetails_UseInEarned-" + gradeBucketFlagDetailID);
            var useInEarnedValue = useInEarned.is(':checked');
            var useInFailed = $("#editGradeBucketFlagDetails_UseInFailed-" + gradeBucketFlagDetailID);
            var useInFailedValue = useInFailed.is(':checked');

            if (!isUseEarnedOverrideDisabled)
            {
                if (!isUseEarnedOverrideValue)
                {
                    if (useInEarnedValue)
                    {
                        skyward.controls.setValue(useInEarned, false);
                    }
                    else if (useInFailedValue)
                    {
                        skyward.controls.setValue(useInFailed, false);
                    }

                    skyward.controls.disable(useInFailed);
                    skyward.controls.disable(useInEarned);
                }
                else
                {
                    if (useInEarnedValue)
                    {
                        skyward.controls.disable(useInFailed);
                    }
                    else if (useInFailedValue)
                    {
                        skyward.controls.disable(useInEarned);
                    }
                    else
                    {
                        skyward.controls.enable(useInEarned);
                        skyward.controls.enable(useInFailed);
                    }
                }
            }
        };

        skyward.grading.redirectToLockedByGradebookInformationPopup = function ()
        {
            var button = $(this);
            var buttonData = button.data();
            var entityID = buttonData.entityid;
            var schoolYearID = buttonData.schoolyearid;
            var entityIDHash = buttonData.entityIdHash;
            var schoolYearIDHash = buttonData.schoolyearIdHash;

            var accessMode = $('#accessmode').val();

            var buildPopup = function () {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentGradeBucket/GetLockedByGradebookInformationPopup" + accessMode,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        entityID: entityID,
                        schoolYearID: schoolYearID,
                        entityIDHash: entityIDHash,
                        schoolYearIDHash: schoolYearIDHash
                    }
                });
            };

            var options =
            {
                anchorTo: button
            };
            skyward.modalLayer.showDialog("Grade Information", buildPopup, { text: "Ok", icon: "Check" }, options);

            event.stopPropagation();
        };

        var displayStudentGradeBucketStatusLegend = function () {
            var button = $(this);

            var buildPopup = function () {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentGradeBucket/GetStudentGradeBucketStatusLegend/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { }
                });
            };

            var beforeClose = function () {
                button.off().on('click', displayStudentGradeBucketStatusLegend);
            };

            button.off('click', displayStudentGradeBucketStatusLegend);

            skyward.modalLayer.showDialog("Grade Bucket Status Legend", buildPopup, { text: "Close", icon: "Close" }, { anchorTo: button, beforeClose: beforeClose });
        };

        var displayStudentGradeBucketStatusPopup = function ()
        {
            var button = $(this);
            var StudentGradeBucketID = button.data().id;

            var buildPopup = function () {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentGradeBucket/GetStudentGradeBucketStatusPopup/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { StudentGradeBucketID: JSON.stringify(StudentGradeBucketID) }
                });
            };

            skyward.modalLayer.showDialog("Grade Bucket Status", buildPopup, { text: "Close", icon: "Close" }, { anchorTo: button });
        };

        var displayStudentSectionTypePopup = function ()
        {
            var button = $(this);
            var studentSectionType = button.data().type;

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/GetStudentSectionTypePopup/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { StudentSectionType: studentSectionType }
                });
            };

            skyward.modalLayer.showDialog("Student Section Type", buildPopup, { text: "Close", icon: "Close" }, { anchorTo: button });
        };

        var getTransferAlternativeAjaxSuffix = function (element)
        {
            var studentSectionTypeOverrideElement = element.parents('.skywardContentPanel').find('#StudentSectionTypeOverrideCode');
            var studentSectionTypeOverrideCode = skyward.controls.getValue(studentSectionTypeOverrideElement);
            var suffix = "";

            if (studentSectionTypeOverrideCode === 'A')
            {
                suffix = "Alt";
            }

            return suffix;
        };

        skyward.grading.transferCourseEarnedCreditsPopup = function ()
        {
            var element = $(this);
            var transferCourseID = element.data('transfercourseid');
            var courseEarnedCreditsMethodID = element.data('courseearnedcreditsmethodid');
            var transferCourseData = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
            var suffix = getTransferAlternativeAjaxSuffix(element);

            var saveSettings = function ()
            {
                transferCourseData = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
                var button = $(this);
                var parentWrapper = button.parents('.skywardContentPanel').find('.transferCourseEarnedCreditPopup');
                var useCourseCreditOverride = skyward.controls.getValue(parentWrapper.find('#TransferCourseCreditOverride'));
                var courseCredits = 0;
                if (useCourseCreditOverride === true)
                {
                    courseCredits = skyward.controls.getValue(parentWrapper.find('#TransferCourseEarnedCreditsTextBox'));
                }
                var usePercentOverride = skyward.controls.getValue(parentWrapper.find('#CourseEarnedPercentOverride'));
                var percentOverrides = new Array();
                if (usePercentOverride === true)
                {
                    parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
                    {
                        var textBox = $(this);
                        var value = skyward.controls.getValue(textBox);
                        var gradeBucketID = textBox.data('gradebucketid');
                        var overrideObject = { gradebucketid: gradeBucketID, value: value };
                        percentOverrides.push(overrideObject);
                    });
                }

                $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/SaveTransferCourseEarnedCreditPopup" + suffix,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        transferCourseID: transferCourseID,
                        useCourseCreditOverride: useCourseCreditOverride,
                        courseCredits: courseCredits,
                        usePercentOverride: usePercentOverride,
                        percentOverrides : JSON.stringify(percentOverrides),
                        transferCourseData: transferCourseData,
                        courseEarnedCreditsMethodID: courseEarnedCreditsMethodID
                    },
                    success: function (data)
                    {
                        if (data.ValidPercents === false)
                        {
                            setTransferCoursePercentErrors(parentWrapper);
                        }
                        else
                        {
                            skyward.controls.setValue("#TransferCourseData-" + transferCourseID, data.Update);
                            updateTransferCourseWindowCreditEarningBuckets(JSON.parse(data.Update));
                            //calcTransferCoursesGrandTotals(button);
                            skyward.window.closePopup();
                        }
                    }
                });
            };

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/GetTransferCourseEarnedCreditsPopup" + suffix,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        transferCourseID: transferCourseID,
                        transferCourseData: transferCourseData,
                        courseEarnedCreditsMethodID: courseEarnedCreditsMethodID
                    }
                });
            };

            var options =
            {
                draggable: true,
                closeOnClick: false,
                closeOnEscape: false
            };

            var htmlResponse = buildPopup();
            htmlResponse.done(function (html)
            {
                skyward.modalLayer.showDialog("Earned Credits", html, [{ id: 'btnSettingsSave', text: 'Done', icon: 'Check', click: saveSettings }, { text: 'Cancel', icon: 'Cancel', click: 'close' }], options);
            });
        };

        skyward.grading.transferCourseGPAPopup = function ()
        {
            var element = $(this);
            var transferCourseID = element.data('transfercourseid');

            var transferCourseData = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
            var courseGPAMethodID = element.data('coursegpamethodid');
            var suffix = getTransferAlternativeAjaxSuffix(element);

            var saveSettings = function ()
            {
                transferCourseData = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
                var button = $(this);
                var parentWrapper = button.parents('.skywardContentPanel').find('.transferCourseGPAPopup');
                var useCourseCreditOverride = skyward.controls.getValue(parentWrapper.find('#PointSetAndCreditOverride'));
                var courseCredits = 0;
                var pointSetID = null;
                if (useCourseCreditOverride === true)
                {
                    courseCredits = skyward.controls.getValue(parentWrapper.find('#TransferCourseGPAPopupPossibleCreditBox'));
                    pointSetID = skyward.controls.getValue(parentWrapper.find('#TransferCourseGPAPopupPointSetID'));
                }
                var usePercentOverride = skyward.controls.getValue(parentWrapper.find('#CourseGPAPercentOverride'));
                var percentOverrides = new Array();
                if (usePercentOverride === true)
                {
                    parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
                    {
                        var textBox = $(this);
                        var value = skyward.controls.getValue(textBox);
                        var gradeBucketID = textBox.data('gradebucketid');
                        var overrideObject = { gradebucketid: gradeBucketID, value: value };
                        percentOverrides.push(overrideObject);
                    });
                }

                $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/SaveTransferCourseGPACreditPopup" + suffix,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        transferCourseID: transferCourseID,
                        useCourseCreditOverride: useCourseCreditOverride,
                        courseCredits: courseCredits,
                        pointSetID: pointSetID,
                        usePercentOverride: usePercentOverride,
                        percentOverrides: JSON.stringify(percentOverrides),
                        transferCourseData: transferCourseData,
                        courseGPAMethodID: courseGPAMethodID
                    },
                    success: function (data)
                    {
                        if (data.ValidPercents === false)
                        {
                            setTransferCoursePercentErrors(parentWrapper);
                        }
                        else
                        {
                            skyward.controls.setValue("#TransferCourseData-" + transferCourseID, data.Update);
                            updateTransferCourseWindowCreditEarningBuckets(JSON.parse(data.Update));
                            skyward.window.closePopup();
                        }
                    }
                });
            };

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Grading/StudentSection/GetTransferCourseGPAPopup" + suffix,
                    type: "POST",
                    dataType: "viewpartHtml",
                    data:
                    {
                        transferCourseID: transferCourseID,
                        transferCourseData: transferCourseData,
                        courseGPAMethodID: courseGPAMethodID
                    }
                });
            };

            var options =
            {
                draggable: true,
                closeOnClick: false,
                closeOnEscape: false
            };

            var htmlResponse = buildPopup();
            htmlResponse.done(function (html)
            {
                skyward.modalLayer.showDialog("GPA Totals", html, [{ id: 'btnSettingsSave', text: 'Done', icon: 'Check', click: saveSettings }, { text: 'Cancel', icon: 'Cancel', click: 'close' }], options);
            });
        };

        var setTransferCoursePercentErrors = function (parentWrapper)
        {
            var errorData = { errors: {} };
            var popUpErrors = parentWrapper.find('#popUpErrors');
            parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
            {
                var item = $(this);
                errorData.errors[item.data("validate-control-for")] = ["Total Percent must equal 0 or 100."];
            });
            skyward.validation.displayValidationMessages(errorData, parentWrapper, popUpErrors, null, null);
        };

        var updateTransferCourseGradeBucketFlagData = function ()
        {
            var element = $(this);
            var cleanID = element.attr('id').split('_')[0];
            var idParts = cleanID.split('-');
            var transferCourseID = idParts[1];
            var gradeBucketID = idParts[2];

            var dataElement = $('#TransferCourseData-' + transferCourseID);
            var transferCourseData = skyward.controls.getValue(dataElement);
            var data = JSON.parse(skyward.controls.getValue(dataElement));
            var backingData = skyward.controls.getValue(element.find('.dmsBackingData'));
            var suffix = getTransferAlternativeAjaxSuffix(element);

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/SetTransferCourseGradeBucketFlags" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseID: transferCourseID,
                    gradeBucketID: gradeBucketID,
                    transferCourseData: transferCourseData,
                    gradeBucketFlags: JSON.stringify(backingData)
                },
                success: function (returnData)
                {
                    skyward.controls.setValue("#TransferCourseData-" + transferCourseID, returnData.Update);
                    setEarnedCreditColumn(returnData, transferCourseID, data.EntityID, data.SchoolYearID);
                    setGPAColumn(returnData, transferCourseID, data.EntityID, data.SchoolYearID);
                }
            });
        }

        var updateTransferCourseGradeMarkData = function ()
        {
            var element = $(this);
            var cleanID = element.attr('id').split('_')[0];
            var idParts = cleanID.split('-');
            var transferCourseID = idParts[1];
            var gradeBucketID = idParts[2];

            var dataElement = $('#TransferCourseData-' + transferCourseID);
            var transferCourseData = skyward.controls.getValue(dataElement);
            var data = JSON.parse(skyward.controls.getValue(dataElement));
            var gradeMarkID = skyward.controls.getValue(element);
            var suffix = getTransferAlternativeAjaxSuffix(element);

            skyward.controls.setValue(dataElement, JSON.stringify(data));

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/SetTransferCourseGradeMarks" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseID: transferCourseID,
                    gradeBucketID: gradeBucketID,
                    transferCourseData: transferCourseData,
                    gradeMarkID: gradeMarkID
                },
                success: function (returnData)
                {
                    skyward.controls.setValue("#TransferCourseData-" + transferCourseID, returnData.Update);
                    setEarnedCreditColumn(returnData, transferCourseID, data.EntityID, data.SchoolYearID);
                    setGPAColumn(returnData, transferCourseID, data.EntityID, data.SchoolYearID);
                }
            });
        }

        var updateTransferCourseCompletionDate = function () {
            var element = $(this);
            var cleanID = element.attr('id').split('_')[0];
            var idParts = cleanID.split('-');
            var transferCourseID = idParts[1];
            var gradeBucketID = idParts[2];

            var dataElement = $('#TransferCourseData-' + transferCourseID);
            var transferCourseData = skyward.controls.getValue(dataElement);
            var data = JSON.parse(transferCourseData);
            var suffix = getTransferAlternativeAjaxSuffix(element);

            var overrideCompletionDate = skyward.controls.getValue($("#creditEarningDateOverride-" + transferCourseID + "-" + gradeBucketID));
            const completionDateElement = $("#creditEarningDate-" + transferCourseID + "-" + gradeBucketID);
            const completionDate = skyward.time.formatServerDate(skyward.controls.getValue(completionDateElement), false);

            skyward.controls.setValue(dataElement, JSON.stringify(data));

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/SetTransferCourseCompletionDates" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseID: transferCourseID,
                    gradeBucketID: gradeBucketID,
                    transferCourseData: transferCourseData,
                    overrideCompletionDate: overrideCompletionDate,
                    completionDate: completionDate
                },
                success: function (returnData) {
                    skyward.controls.setValue("#TransferCourseData-" + transferCourseID, returnData.Update);
                }
            });
        }

        var setEarnedCreditColumn = function (data, transferCourseID, entityID, schoolYearID)
        {
            var parseData = JSON.parse(data.Update);
            for (var i = 0; i < parseData.TransferCourseEarnedCreditsMethods.length; i++)
            {
                var courseEarnedCreditsMethod = parseData.TransferCourseEarnedCreditsMethods[i];
                $("#EarnedCreditsLink-" + transferCourseID + "-" + courseEarnedCreditsMethod.CourseEarnedCreditsMethodID).find('span').html(formatCredits(courseEarnedCreditsMethod.TotalEarnedCredits));
                $("#FailedCreditsLink-" + transferCourseID + "-" + courseEarnedCreditsMethod.CourseEarnedCreditsMethodID).find('span').html(formatCredits(courseEarnedCreditsMethod.TotalFailedCredits));
            }


            //$("#EarnedCreditLink-" + transferCourseID).find('span').html(formatCredits(earnedCredits));
            //$("#FailedCreditLink-" + transferCourseID).find('span').html(formatCredits(failedCredits));

            //var totalEarned = 0;
            //var totalFailed = 0;

            //var groupWrapper = buttonElement.parents('#creditEarningGroupRowWapper-' + entityID + '-' + schoolYearID);

            //groupWrapper.find("a[id^='EarnedCreditLink']").each(function ()
            //{
            //    var link = $(this);
            //    var value = parseFloat(link.find('span').html());
            //    totalEarned += value
            //});

            //groupWrapper.find("a[id^='FailedCreditLink']").each(function ()
            //{
            //    var link = $(this);
            //    var value = parseFloat(link.find('span').html());
            //    totalFailed += value
            //});

            //$("#GroupEarnedCreditTotal-" + entityID + "-" + schoolYearID).html(formatCredits(totalEarned));
            //$("#GroupFailedCreditTotal-" + entityID + "-" + schoolYearID).html(formatCredits(totalFailed));
            //calcTransferCoursesGrandTotals(buttonElement);
        }

        var setGPAColumn = function (data, transferCourseID, entityID, schoolYearID)
        {
            var parseData = JSON.parse(data.Update);
            for (var i = 0; i < parseData.TransferCourseGPAMethods.length; i++)
            {
                var courseGPAMethod = parseData.TransferCourseGPAMethods[i];
                $("#GPACreditLink-" + transferCourseID + "-" + courseGPAMethod.CourseGPAMethodID).find('span').html(formatCredits(courseGPAMethod.TotalCredits));
                $("#GPAPointsLink-" + transferCourseID + "-" + courseGPAMethod.CourseGPAMethodID).find('span').html(formatCredits(courseGPAMethod.TotalPoints));
                $("#GPAAddOnPointsLink-" + transferCourseID + "-" + courseGPAMethod.CourseGPAMethodID).find('span').html(formatCredits(courseGPAMethod.TotalAddOnPoints));
            }
        }

        var formatCredits = function (value)
        {
            var decimalMask = "9999.99";
            var masks = decimalMask.toString().split('.');
            var precision = masks.length > 1 ? masks[1].length : 0;

            var valueParts = value.toString().split('.');
            value = valueParts[0];
            if (precision > 0)
            {
                var afterDecimal = valueParts.length > 1 ? valueParts[1] : '';
                value += '.' + afterDecimal;
                for (var i = 0, len = precision - afterDecimal.length; i < len; i++)
                {
                    value += '0';
                }
            }
            return value;
        }

        var resetTransferCourseCreditOverride = function ()
        {
            var element = $(this);
            var overrideValue = skyward.controls.getValue(element);
            if (overrideValue === false)
            {
                var parentWrapper = element.parents('.transferCourseEarnedCreditPopup');

                var creditBox = parentWrapper.find('#TransferCourseEarnedCreditsTextBox');
                var baseValue = creditBox.data('basevalue');

                skyward.controls.setValue(creditBox, baseValue);
            }
        }

        var resetTransferCourseGPACreditOverride = function ()
        {
            var element = $(this);
            var overrideValue = skyward.controls.getValue(element);
            if (overrideValue === false)
            {
                var parentWrapper = element.parents('.transferCourseGPAPopup');

                var pointSet = parentWrapper.find('#TransferCourseGPAPopupPointSetID');
                var baseValue = pointSet.data('basevalue');
                skyward.controls.setValue(pointSet, baseValue);

                var gpaCredits = parentWrapper.find('#TransferCourseGPAPopupPossibleCreditBox');
                var baseValue = gpaCredits.data('basevalue');
                skyward.controls.setValue(gpaCredits, baseValue);
            }
        }

        var resetTransferCoursePercentOverride = function ()
        {
            var element = $(this);
            var overrideValue = skyward.controls.getValue(element);
            if (overrideValue === false)
            {
                var parentWrapper = element.parents('.transferCourseEarnedCreditPopup');
                var percentBoxes = parentWrapper.find('.TransferCoursePercentOverrideBox');
                percentBoxes.each(function ()
                {
                    var textBox = $(this);
                    var baseValue = textBox.data('basevalue');
                    skyward.controls.setValue(textBox, baseValue, true);
                });
                updateEarnedCreditPopupCalculation.call(element);
            }
        }

        var resetTransferCourseGPAPercentOverride = function ()
        {
            var element = $(this);
            var overrideValue = skyward.controls.getValue(element);
            if (overrideValue === false)
            {
                var parentWrapper = element.parents('.transferCourseGPAPopup');
                var percentBoxes = parentWrapper.find('.TransferCoursePercentOverrideBox');
                percentBoxes.each(function ()
                {
                    var textBox = $(this);
                    var baseValue = textBox.data('basevalue');
                    skyward.controls.setValue(textBox, baseValue);
                });
            }
        }

        var updateEarnedCreditPopupCalculation = function ()
        {
            var element = $(this);
            var parentWrapper = element.parents(".transferCourseEarnedCreditPopup");
            var transferCourseID = parentWrapper.data("transfercourseid");
            var courseEarnedCreditsMethodID = parentWrapper.data("courseearnedcreditsmethodid");
            var suffix = getTransferAlternativeAjaxSuffix(element);

            var transferCourseData = skyward.controls.getValue(parentWrapper.find(".transferCourseData"));
            var credits = skyward.controls.getValue(parentWrapper.find('#TransferCourseEarnedCreditsTextBox'));
            var creditOverride = skyward.controls.getValue(parentWrapper.find('#TransferCourseCreditOverride'));
            var percentOverride = skyward.controls.getValue(parentWrapper.find('#CourseEarnedPercentOverride'));
            var percents = {};
            parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
            {
                var percentBox = $(this);
                var gradeBucketID = percentBox.data('gradebucketid');
                var percent = skyward.controls.getValue(percentBox);
                if (percent == null || percent == undefined)
                {
                    percent == 0;
                }
                percents[gradeBucketID] = percent;
            });

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/TransferCourseEarnedCreditPopupRecalc" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseData: transferCourseData,
                    transferCourseID: transferCourseID,
                    credits: credits,
                    creditOverride: creditOverride,
                    percentOverride: percentOverride,
                    percents: JSON.stringify(percents),
                    courseEarnedCreditsMethodID: courseEarnedCreditsMethodID
                },
                success: async function (returnData)
                {
                    var updateHTML = returnData.Success;
                    if (updateHTML === true)
                    {
                        await parentWrapper.find('#creditWrapper').viewpartHtml(returnData.CreditsHTML);
                        skyward.window.notifyResize();
                    }
                }
            });
        }

        var updateGPACreditPopupCalculation = function ()
        {
            var element = $(this);
            var parentWrapper = element.parents(".transferCourseGPAPopup");
            var transferCourseID = parentWrapper.data("transfercourseid");
            var courseGPAMethodID = parentWrapper.data("coursegpamethodid");
            var suffix = getTransferAlternativeAjaxSuffix(element);

            var transferCourseData = skyward.controls.getValue("#TransferCourseData-" + transferCourseID);
            var credits = skyward.controls.getValue(parentWrapper.find('#TransferCourseGPAPopupPossibleCreditBox'));
            var pointSetID = skyward.controls.getValue(parentWrapper.find('#TransferCourseGPAPopupPointSetID'));
            var creditOverride = skyward.controls.getValue(parentWrapper.find('#PointSetAndCreditOverride'));
            var percentOverride = skyward.controls.getValue(parentWrapper.find('#CourseGPAPercentOverride'));
            var percents = {};
            parentWrapper.find('.TransferCoursePercentOverrideBox').each(function ()
            {
                var percentBox = $(this);
                var gradeBucketID = percentBox.data('gradebucketid');
                var percent = skyward.controls.getValue(percentBox);
                if (percent == null || percent == undefined)
                {
                    percent == 0;
                }
                percents[gradeBucketID] = percent;
            });

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/TransferCourseGPACreditPopupRecalc" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseData: transferCourseData,
                    transferCourseID: transferCourseID,
                    credits: credits,
                    creditOverride: creditOverride,
                    pointSetID: pointSetID,
                    percentOverride: percentOverride,
                    percents: JSON.stringify(percents),
                    courseGPAMethodID: courseGPAMethodID
                },
                success: async function (returnData)
                {
                    skyward.controls.setValue("#TransferCourseData-" + transferCourseID, returnData.Update);
                    var updateHTML = returnData.Success;
                    if (updateHTML === true)
                    {
                        await parentWrapper.find('#creditWrapper').viewpartHtml(returnData.CreditsHTML);
                        skyward.window.notifyResize();
                    }
                }
            });
        }

        var updateTransferCourseWindowCreditEarningBuckets = function (updateData)
        {
            var transferCourseWrapper = $('.transferCourseGradeWrapper');
            var creditEarningGroup = transferCourseWrapper.find('#creditEarningGroupRowWapper-' + updateData.EntityID + '-' + updateData.SchoolYearID);
            var earnedCreditsGroup = transferCourseWrapper.find('#earnedCreditsGroupWrapper-' + updateData.EntityID + '-' + updateData.SchoolYearID);
            var gpaGroup = transferCourseWrapper.find('#gPAGroupWapper-' + updateData.EntityID + '-' + updateData.SchoolYearID);
            var nonEarningGroup = transferCourseWrapper.find('#nonEarningGroupWapper-' + updateData.EntityID + '-' + updateData.SchoolYearID);
            regenerateTransferCourseScreen(creditEarningGroup, earnedCreditsGroup, gpaGroup, nonEarningGroup);
        };

        var regenerateTransferCourseScreen = function (creditEarningWrapper, earnedCreditsWrapper, gpaGroup, nonEarningGroup)
        {
            var transferCourses = {};
            //get transfercourses in this group
            earnedCreditsWrapper.find('[id^=earnedCreditsTransferCourseID]').each(function ()
            {
                var transferCourseID = $(this).attr('id').split('-')[1];
                transferCourses[transferCourseID] = skyward.controls.getValue('#TransferCourseData-' + transferCourseID);
            });
            var suffix = getTransferAlternativeAjaxSuffix(earnedCreditsWrapper);

            $.ajax({
                url: skyward.global.virtualDir + "Grading/StudentSection/TransferCourseRegenerateGradingScreen" + suffix,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    transferCourseDatas: JSON.stringify(transferCourses)
                },
                success: async function (returnData)
                {
                    const [creditEarningGroupHTML, earnedCreditsGroupHTML, gPAGroupHTML, nonEarningGroupHTML] = await Promise.all([
                        skyward.global.processViewPartHtml(returnData.CreditEarningGroupHTML),
                        skyward.global.processViewPartHtml(returnData.EarnedCreditsGroupHTML),
                        skyward.global.processViewPartHtml(returnData.GPAGroupHTML),
                        skyward.global.processViewPartHtml(returnData.NonEarningGroupHTML),
                    ])

                    creditEarningWrapper.html(creditEarningGroupHTML);

                    $(creditEarningWrapper).find('.codeEEL').each(function ()
                    {
                        skyward.codeeel.registerCodeEEL($(this));
                    });
                    $(creditEarningWrapper).find('.distinctMultiSelectEEL').each(function ()
                    {
                        skyward.distinctMultiSelectEEL.registerDistinctMultiSelectEEL($(this))
                    });

                    $(creditEarningWrapper).find('.transferCourseUpdatesGradeMarkInformation').parent().off('codeEELValuesUpdated', updateTransferCourseGradeMarkData).on('codeEELValuesUpdated', updateTransferCourseGradeMarkData);
                    $(creditEarningWrapper).find('.TransferCourseGradeBucketFlag').parent().off('change', updateTransferCourseGradeBucketFlagData).on('change', updateTransferCourseGradeBucketFlagData);

                    earnedCreditsWrapper.html(earnedCreditsGroupHTML);
                    gpaGroup.html(gPAGroupHTML);
                    nonEarningGroup.html(nonEarningGroupHTML);

                    $(nonEarningGroup).find('.codeEEL').each(function ()
                    {
                        skyward.codeeel.registerCodeEEL($(this));
                    });
                    $(nonEarningGroup).find('.distinctMultiSelectEEL').each(function ()
                    {
                        skyward.distinctMultiSelectEEL.registerDistinctMultiSelectEEL($(this))
                    });
                    $(nonEarningGroup).find('.transferCourseUpdatesGradeMarkInformation').parent().off('codeEELValuesUpdated', updateTransferCourseGradeMarkData).on('codeEELValuesUpdated', updateTransferCourseGradeMarkData);
                    $(nonEarningGroup).find('.TransferCourseGradeBucketFlag').parent().off('change', updateTransferCourseGradeBucketFlagData).on('change', updateTransferCourseGradeBucketFlagData);
                    //calcTransferCoursesGrandTotals(creditEarningWrapper);
                }
            });
        }

        //var calcTransferCoursesGrandTotals = function (element)
        //{
        //    var parent = element.parents('.transferCourseGradeWrapper')
        //    var creditEarning = parent.find('.creditEarningGroup');
        //    var earnedCredits = creditEarning.find('[id^="GroupEarnedCreditTotal"]');
        //    var failedCredits = creditEarning.find('[id^="GroupFailedCreditTotal"]');
        //    var earnedTotal = 0;
        //    var failedTotal = 0;

        //    earnedCredits.each(function ()
        //    {
        //        var credit = $(this);
        //        earnedTotal += parseFloat(credit.html());
        //    });
        //    failedCredits.each(function ()
        //    {
        //        var credit = $(this);
        //        failedTotal += parseFloat(credit.html());
        //    });

        //    parent.find('#EarnedGrandTotal').html(formatCredits(earnedTotal));
        //    parent.find('#FailedGrandTotal').html(formatCredits(failedTotal));
        //}

        var makeOutOfDistrictTransferCoursePopup = function ()
        {
            var button = $(this);

            var options =
            {
                draggable: true,
                closeOnClick: false,
                closeOnEscape: false,
                additionalClasses: 'warningPopupDialog'
            };

            var saveSettings = function()
            {
                var data =
                {
                    "Workflow.StudentSectionID": button.data('studentsectionid'),
                    "Workflow.StudentSectionID_securityhash": button.data('studentsectionidhash')
                };
                skyward.window.checkLoadContent("popup", "Workflow", "WorkflowInstance", "Create/Grading/StudentSection/ChangeSectionToOutOfDistrictTransferCourse", null, data);
            };

            var studentName = button.data('studentname');
            var html = "<div class = 'warningPopupDialogTitle'><span>Are You Sure?</span></div><div class = 'warningPopupDialogMessage'><span>";
            var iconspan = $('<span/>');
            $.when(skyward.svg.getSvg('Warning', 'Warning')).done(function (svg)
            {
                iconspan.append(svg);
            });
            html += iconspan.html();
            html += "Changing " + studentName + "'s section to an out of district transfer course will remove them from the teacher's gradebook. This will also set all grade buckets to complete which could affect GPA and Earned Credits.</span></div>"
            skyward.modalLayer.showDialog("", html, [{ id: 'btnGoBack', icon: null, text: 'No, Go Back', additionalClasses: "warningPopupDialogNo", click: 'close' }, { id: 'btnYes', icon: null, text: 'Yes, Change Section', additionalClasses: "warningPopupDialogYes", click: saveSettings }], options);
        }

        var rebuildFileNameOutput = function (fileNameFormatContainer)
        {
            var childRecordGenerator = fileNameFormatContainer.find(".fileNameFormatQuickEntry");
            var fileNameFormatDelimiterType = fileNameFormatContainer.find(".fileNameFormatDelimiterType").first();
            var outputTextbox = fileNameFormatContainer.find(".fileNameFormatOutput");
            var currentOutputText = skyward.controls.getValue(outputTextbox);
            var delimiter = getFileTypeDelimiterValue(fileNameFormatDelimiterType);
            var currentOutputTextParts = delimiter != null && delimiter != "" ? currentOutputText.split(delimiter) : [currentOutputText];
            var outputText = "";
            var count = 0;
            childRecordGenerator.find(".fileNameFormatEntryOption").each(function ()
            {
                var option = $(this);
                var row = option.parents("tr");

                var processOption = row == null || row.length == 0 || !row.hasClass("skip");
                if (processOption)
                {
                    var optionValue;
                    if (option.hasClass("useComboBoxOptionDisplayText"))
                    {
                        if (option.get(0).selectedIndex > -1)
                        {
                            optionValue = "[" + option.get(0).options[option.get(0).selectedIndex].text + "]";

                            if (optionValue == "[Date]")
                            {
                                const datepicker = option.parents("tr").first().find(".datePickerFieldset sky-datepicker");
                                const datePickerValue = skyward.controls.getValue(datepicker);
                                optionValue = datePickerValue == null || (datePickerValue instanceof Date && !datePickerValue.isValidDate())
                                    ? ""
                                    : datePickerValue.toISOString().split('T')[0];
                            }
                            else if (optionValue == "[Custom Text]")
                            {
                                var customTextHelp = option.parents("tr").first().find(".customTextFieldset input.customText");
                                optionValue = skyward.controls.getValue(customTextHelp);
                            }
                        }
                    }
                    else
                    {
                        optionValue = "[" +skyward.controls.getValue(option) + "]";
                    }

                    if (optionValue)
                    {
                        if (outputText != "")
                        {
                            outputText += getFileTypeDelimiterValue(fileNameFormatDelimiterType);
                        }
                        outputText += optionValue;
                    }
                }

                count++;
            });

            skyward.controls.setValue(outputTextbox, outputText);
        };

        var getFileTypeDelimiterValue = function (fileNameFormatDelimiterType)
        {
            if (fileNameFormatDelimiterType.get(0).selectedIndex > -1)
            {
                var delimterString = fileNameFormatDelimiterType.get(0).options[fileNameFormatDelimiterType.get(0).selectedIndex].text;
                if (delimterString == "Space")
                {
                    delimterString = " ";
                }
                return delimterString;
            }
            return "";
        }

        // Event handlers
        var events =
        {
            "displayStudentGradeBucketStatusPopup": displayStudentGradeBucketStatusPopup,
            "displayStudentSectionTypePopup": displayStudentSectionTypePopup,
            "redirectToLockedByGradebookInformationPopup": skyward.grading.redirectToLockedByGradebookInformationPopup,
            "transferCourseEarnedCreditsPopup": skyward.grading.transferCourseEarnedCreditsPopup,
            "transferCourseGPAPopup": skyward.grading.transferCourseGPAPopup,
            initGradeReportHeaderFields,
            initStudentSectionLinkFormat,
        };
        skyward.events.registerEvents("Grading", events);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.childrecordquickentry = skyward.childrecordquickentry || {};
        var processedIds = [];

        var init = function (selector)
        {
            var element = $(selector);

            if (element.is(".childrecordquickentryrow"))
            {
                initCRQE(element);
            }
            else
            {
                element.find(".childrecordquickentry").each(function ()
                {
                    var crqe = $(this);

                    // don't initialize nested CRQEs, they are already initialized by their parent
                    if (crqe.parents(".childrecordquickentry").length === 0)
                    {
                        initCRQE(crqe);
                    }
                });
            }
        };

        var initCRQE = function (container)
        {
            processedIds = [];

            skyward.childrecordquickentry.setQuickEntryNumbersAndLetters = function (container)
            {
                var recursiveGetStringFromInt = function (count)
                {
                    if (count < 26)
                    {
                        return String.fromCharCode(65 + count);
                    }
                    else
                    {
                        return recursiveGetStringFromInt(Math.floor(count / 26) - 1) + recursiveGetStringFromInt(count % 26);
                    }
                };

                /**
                 * Returns an Excel styled index (1>A, 2>B, ..., 25>Y, 26>Z, 27>AA, 28>AB)
                 * @param {Number} count 1-based index
                 * @returns {string} Returns an Excel styled index (1>A, 2>B, ..., 25>Y, 26>Z, 27>AA, 28>AB)
                 */
                var getStringFromInt = function (count)
                {
                    return recursiveGetStringFromInt(count - 1);
                };

                container.find('.getChildRecordQuickEntryNumber').each(function ()
                {
                    var numberElement = $(this);
                    var tr = numberElement.closest('tr');
                    var myRow = tr.index();
                    numberElement.html(myRow);
                });

                container.find('.getChildRecordQuickEntryTextAndNumber').each(function ()
                {
                    var numberElement = $(this);
                    var tr = numberElement.closest('tr');
                    var myRow = tr.index();
                    var header = numberElement.find('.sectionHeader__text, .legendHeader');
                    var valueToSet = header.length > 0 ? header : numberElement;
                    valueToSet.text(valueToSet.text().split(' ')[0] + ' ' + myRow);
                });

                container.find('tr:not(.js_hideEmptyRowWithAddButton) .getChildRecordQuickEntryLetter').each(function ()
                {
                    var numberElement = $(this);
                    var tr = numberElement.closest('tr:not(.js_hideEmptyRowWithAddButton)');
                    var myRow = tr.index('#' + container.attr("id") + ' tr:not(.js_hideEmptyRowWithAddButton)');
                    numberElement.html(getStringFromInt(parseInt(myRow)));
                });
            };

            skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(container);

            var elementTypesToInitialize = ['label', 'fieldset', 'div', 'span', 'a', ':input'];

            // Update nested repeaters that start on the page
            container.find(' tr.childrecordquickentryrow tr.childrecordquickentryrow').each(function ()
            {
                var myElement = $(this);
                var isProcessed = processedIds.includes(myElement.attr('id'));
                var contentDiv = myElement.parents('.childrecordquickentry').eq(0).not(".disablenestedrepeaterrename");

                if (!isProcessed && contentDiv.length > 0)
                {
                    var counter = getUniqueRowID(container);

                    initializeChildRecordIDs(myElement, counter);
                    initializeElementsAndData(myElement, counter, container, null /*row*/, contentDiv.hasClass('preserveprefilledvalues'));
                    skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(container);
                    skyward.window.notifyDOMLoad("#" + contentDiv.attr('id'));
                }
            });

            // template creation
            container.find('.usequickentrytemplate').not('.doNotPost').each(function ()
            {
                var initialRow = $(this);
                initialRow.find('#ui-datepicker-div').remove(); //before cloning remove the Jquery datepicker div so the clone doesn't clone into it
                var tempObject = initialRow.clone(true, true);

                if (tempObject.length)
                {
                    var codeEELsToClear = [];

                    // pop the counter off of the template
                    var tempObjectIdParts = tempObject.attr('id').split('-');
                    if (skyward.extensions.isNumeric(tempObjectIdParts[tempObjectIdParts.length - 1]))
                    {
                        tempObjectIdParts.pop();
                    }

                    tempObject.attr('id', tempObjectIdParts.join('-') + '-Template');
                    tempObject.addClass('doNotPost');

                    // append "-Template" onto child elements' ids and names
                    tempObject.find("[id],[name]").each(function ()
                    {
                        var element = $(this);
                        var elementId;
                        var elementName;

                        if (!element.is(elementTypesToInitialize.join(',')))
                        {
                            return;
                        }

                        // pop the counter off of the element id/name
                        if (element.attr('id'))
                        {
                            var elementIdParts = element.attr('id').split('-');
                            var idCounterWithPostFix = elementIdParts[elementIdParts.length - 1];

                            var idCounter = idCounterWithPostFix;
                            var idPostFix = '';

                            if (idCounterWithPostFix.indexOf('_') > -1)
                            {
                                idCounter = idCounterWithPostFix.substring(0, idCounterWithPostFix.indexOf('_'));
                                idPostFix = idCounterWithPostFix.substring(idCounterWithPostFix.indexOf('_'));
                            }

                            if (skyward.extensions.isNumeric(idCounter))
                            {
                                elementIdParts.pop();
                                elementId = elementIdParts.join('-') + '-Template';

                                if (idPostFix)
                                {
                                    elementId += idPostFix;
                                }

                                // Update labels pointing at this control
                                const currentId = element.attr('id');

                                tempObject.find(`[for='${currentId}']`).attr('for', elementId);
                                tempObject.find(`[aria-labelledby='${currentId}']`).attr('aria-labelledby', elementId);
                                tempObject.find(`[aria-describedby='${currentId}']`).attr('aria-describedby', elementId);

                                const elementRequestDataHashSrc = element.data().requestDataHashSrc;
                                // Elements that should be ignored when initializing request data hashes
                                const isIgnoredElement = element.is(".tileViewEEL_search");
                                if (elementRequestDataHashSrc && !isIgnoredElement)
                                {
                                    const prefix = initialRow.getPrefix();
                                    const hashKey = element.data().requestDataHashKey ?? element.getIdAndPrefix(prefix).id;
                                    const requestDataHashes = skyward.requestDataHash.getRequestDataHashes(elementRequestDataHashSrc);
                                    const requestDataHash = skyward.requestDataHash.getRequestDataHash(elementRequestDataHashSrc, hashKey);
                                    if (requestDataHash)
                                    {
                                        const newTrueId = elementId.replace(prefix, '');
                                        requestDataHashes[newTrueId] = $.extend(true, {}, requestDataHash);
                                    }
                                }

                                element.attr('id', elementId);
                            }
                        }

                        if (element.attr('name'))
                        {
                            var elementNameParts = element.attr('name').split('-');

                            var nameCounterWithPostFix = elementNameParts[elementNameParts.length - 1];

                            // radio button names will have 'child' appended to the counter with no '_' separator
                            var counterPostFix = element.is(':radio') ? 'child' : '_';

                            var nameCounter = nameCounterWithPostFix;
                            var namePostFix = '';

                            if (nameCounterWithPostFix.indexOf(counterPostFix) > -1)
                            {
                                nameCounter = nameCounterWithPostFix.substring(0, nameCounterWithPostFix.indexOf(counterPostFix));
                                namePostFix = nameCounterWithPostFix.substring(nameCounterWithPostFix.indexOf(counterPostFix));
                            }

                            if (skyward.extensions.isNumeric(nameCounter))
                            {
                                elementNameParts.pop();
                                elementName = elementNameParts.join('-') + '-Template';

                                if (namePostFix)
                                {
                                    elementName += namePostFix;
                                }

                                element.data("original-name", element.data("original-name") ?? elementName);
                                element.attr('name', elementName);
                            }
                        }

                        var clonevalue = getDataClonevalue(element);
                        var takeDefaultValue = getDataTakeDefaultValue(element);

                        element.addClass('doNotPost');

                        if (elementId || elementName)
                        {
                            // CodeEELs are cleared seperately
                            if (element.is('.codeEELCode,.codeEELDescription,.codeEELValue,.tileViewEEL_search,.tileViewEEL_value') && element.parent().length)
                            {
                                codeEELsToClear.push(element.parent());
                            }
                            // Clear any prefilled value for the template
                            else if (!element.is('label') && takeDefaultValue != true)
                            {
                                let valueToSet;
                                if (element.is(".datePicker,sky-datepicker"))
                                {
                                    const datePicker = element.closest("sky-datepicker");
                                    valueToSet = clonevalue ? datePicker.data('original-value') : null
                                    datePicker.val(valueToSet);
                                }
                                else
                                {
                                    valueToSet = clonevalue ? element.data('original-value') : null
                                    skyward.controls.setValue(element, valueToSet, true);
                                }
                            }
                        }
                    });

                    $(codeEELsToClear).each(function ()
                    {
                        skyward.codeeel.clear($(this), false);
                    });

                    // We want load-actions to only apply on copies of the template
                    // not the template itself.
                    skyward.events.removeLoadActionClass(tempObject);

                    tempObject.css("display", "none");

                    // Only append template once per unique id
                    var existingTemplate = container.find("#" + tempObject.attr("id"));
                    if (!(existingTemplate.length > 0))
                    {
                        tempObject.appendTo(container);
                    }
                }
            });

            container.find('td.childrecordquickentryclearbuttoncell').each(function ()
            {
                var clearButton = $(this);

                var clearRowFields = function (preserveParent, parent)
                {
                    var childInputElements = parent.find(':input, textarea, select, textarea, select, .file').filter(':visible');
                    var inputElements = $.makeArray(childInputElements);

                    // clear EEL elements hidden values
                    parent.find('[data-action="codeEEL"], [data-action="tileViewEEL"]').each(function ()
                    {
                        var element = $(this);
                        skyward.controls.setValue(element, '');

                        // Trigger any attached onchange event
                        element.change();
                    });

                    //clear distinctMultiSelectEEL elements
                    parent.find('.distinctMultiSelectEEL').each(function ()
                    {
                        var element = $(this);
                        skyward.distinctMultiSelectEEL.values.clear(element);
                        skyward.distinctMultiSelectEEL.registerDistinctMultiSelectEEL(element);
                    });

                    // list to store 'dirty' input fields
                    var dirtyList = [];

                    // find the controls that have triggered a 'dirty' condition.
                    if (inputElements.length > 0)
                    {
                        for (var child in inputElements)
                        {
                            var input = inputElements[child];
                            var test = input.getAttribute('data-dirty');

                            if (test != null && test)
                            {
                                dirtyList.push(input);
                            }

                            var jQueryInput = $(input);
                            if (jQueryInput.hasClass('file'))
                            {
                                var deleteButton = jQueryInput.find('a[id*="Delete"]');
                                if (deleteButton && deleteButton != null)
                                {
                                    deleteButton.trigger('click');
                                }
                            }
                        }
                    }

                    // selected dirty inputs
                    var selectedDirtyList = [];

                    // 'select' the inputs
                    for (var inputs in dirtyList)
                    {
                        var inputsToAdd = $(dirtyList[inputs]);
                        selectedDirtyList.push(inputsToAdd);
                    }

                    // clear the fields
                    if (preserveParent)
                    {
                        parent.find(':input:not([type=radio], [type=checkbox]), textarea, select').filter(':visible').each(function ()
                        {
                            const element = $(this);
                            if (element.is("select"))
                            {
                                // Set it to the default selected field, or 0 if there is no default
                                var defaultSelectedIndex = 0;
                                Array.from(this.options).forEach((option) => {
                                    if (option.defaultSelected === true)
                                    {
                                        defaultSelectedIndex = option.index;
                                    }
                                })
                                skyward.controls.setValue(element, this.options[defaultSelectedIndex].value);
                            }
                            else
                            {
                                skyward.controls.setValue(element, null);
                            }
                        });
                    }

                    parent.find('input:checked').filter(':visible').each(function ()
                    {
                        var inputCheckbox = $(this);
                        var radioButtonGroup = inputCheckbox.parents('.radioButtonGroup');
                        if (radioButtonGroup.length)
                        {
                            if (!inputCheckbox[0].defaultChecked)
                            {
                                skyward.controls.setValue(inputCheckbox, false, true);
                                radioButtonGroup.find('input').not(':checked').each(function ()
                                {
                                    if (this.defaultChecked)
                                    {
                                        var uncheckedRadioButton = $(this);
                                        skyward.radioButtonGroup.setValue(uncheckedRadioButton, uncheckedRadioButton.val());
                                    }
                                });
                            }
                        }
                        else
                        {
                            skyward.controls.setValue(inputCheckbox, false, true);
                        }

                        if (inputCheckbox.hasClass('AddressFlag'))
                        {
                            skyward.childrecordquickentry.addressFlagCheck(inputCheckbox, true);
                        }
                    });

                    // remove the found items from the dirty list in changetracking.js
                    if (selectedDirtyList.length > 0)
                    {
                        skyward.changeTracking.removeFromDirtyList(selectedDirtyList);
                    }

                    //trigger changetracking dirty condition from an existing field
                    var dataObjectViewer = container.find('div.contentArea div.currentRecordContent.dataObjectViewer');
                    var inputToTrigger = dataObjectViewer.find(':input, textarea').eq(0);
                    inputToTrigger.change();
                };

                var clearRow = function ()
                {
                    var button = $(this);
                    var parent = button.parent('tr.childrecordquickentryrow');
                    if (parent.next().is(".childRecordTemplateRow"))
                    {
                        parent = parent.add(parent.next());
                    }
                    var parentSplit = parent.attr('id').split('-');
                    var isRowBeingRemoved = parentSplit[parentSplit.length - 1] !== '1';
                    if (!isRowBeingRemoved || parent.parents('.childrecordquickentrytable').first().find('.newchildrecordquickentryrow-1').first().attr('id') == parent.attr('id'))
                    {
                        clearRowFields.call(button, true, parent);
                        isRowBeingRemoved = false;
                    }
                    else //clear and remove table row
                    {
                        parent.fadeOut(500, 'linear', function ()
                        {
                            parent.css('display', 'none');
                            clearRowFields.call(button, false, parent);

                            var siblingRow = parent.prev('tr');
                            if (!siblingRow.length)
                            {
                                siblingRow = parent.next('tr');
                            }

                            // Necessary for row removal event listeners
                            const elementBeingRemoved = parent.find('.js-childrecordquickentryremove');
                            skyward.controls.setValue(elementBeingRemoved, "true");
                            button.trigger('childrecordquickentry-row-removed', [parent]);

                            parent.remove();
                            maxNumberAdded(siblingRow);
                            skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(siblingRow.closest(".childrecordquickentry"));
                        });
                    }
                    button.trigger('childrecordquickentry-row-cleared', [parent, isRowBeingRemoved]);
                };
                clearButton.off("click").on('click', clearRow);

                if (skyward.global.mobileAccess)
                {
                    setupButtonToBeResponsiveOnMobile(clearButton);
                }
            });

            container.find(' .js-childRecordQuickEntryClearRow').each(function ()
            {
                var removeButton = $(this);

                var removeRow = function ()
                {
                    var row = removeButton.closest('tr');
                    row.addClass("removedElement");

                    row.fadeOut(500, 'linear', function ()
                    {
                        row.css('display', 'none');
                    });

                    var elementBeingRemoved = row.find('.js-childRecordQuickEntryRowValues');
                    skyward.controls.setValue(elementBeingRemoved, "true");
                    removeButton.trigger('childrecordquickentry-row-removed', [row]);
                    maxNumberAdded(row);
                    var triggerEvent = 'childrecordquickentryremoverowajaxevent-' + elementBeingRemoved.attr('id');
                    removeButton.trigger(triggerEvent);
                };

                removeButton.off("click").on('click', removeRow);

                if (skyward.global.mobileAccess)
                {
                    setupButtonToBeResponsiveOnMobile(removeButton.closest(".childrecordquickentryremovebuttoncell"));
                }
            });

            container.find('input.AddressFlag').each(function ()
            {
                var element = $(this);
                var value = skyward.controls.getValue(element);
                if (value)
                {
                    skyward.controls.disable(element);
                }
                skyward.childrecordquickentry.addressFlagCheck(element, false);
            });

            container.find('input.AddressExistingRecordsNotReadOnly').each(function ()
            {
                skyward.controls.enable(this);
            });

            container.find('div.childrecordquickentryadddiv a').each(function ()
            {
                var addButton = $(this);

                if (addButton.length === 0)
                {
                    return;
                }

                var generateNewRow = function (button, prefixOverride = null)
                {
                    var { id: buttonId, prefix: dovPrefix } = button.getIdAndPrefix(prefixOverride);
                    var allButtonIdParts = buttonId.split('-');
                    var buttonIdParts = allButtonIdParts.slice(-4); //we never use the first id part so get rid of it
                    var addButtonIndex = buttonIdParts.indexOf("childrecordquickentryaddbutton");
                    var nestedRepeater = button.closest('.childrecordquickentryadddiv').prev('.childrecordquickentrytable');
                    var prefixedRowId = `${dovPrefix}childrecordquickentrychildadd-${buttonIdParts[addButtonIndex + 1]}-${buttonIdParts[addButtonIndex + 2]}-`;
                    // First childrecordquickentry ancestor - never grandparent
                    var mainDiv = button.parents('.childrecordquickentry').eq(0);

                    // find the highest row count
                    var legendContentDiv = button.parent('div').parent('div');
                    var previousRowID = initializeCounter(legendContentDiv, prefixedRowId);

                    var row;
                    if (nestedRepeater.length)
                    {
                        row = nestedRepeater.find('#' + prefixedRowId + previousRowID);
                    }
                    else
                    {
                        row = mainDiv.find('#' + prefixedRowId + previousRowID);
                    }

                    row.find('#ui-datepicker-div').remove(); //before cloning remove the Jquery datepicker div so the clone doesn't clone into it

                    // Clone the row including all data and bound events. This will also carry over any structure such as the number of nested CRQE rows.
                    var newRow = row.clone(true, true);
                    var container = getTopCRQEContainerFromElement(addButton);
                    var newRowID = getUniqueRowID(container);
                    newRow.attr('id', prefixedRowId + newRowID);
                    if (newRow.hasClass("js_hideEmptyRowWithAddButton"))
                    {
                        newRow.removeClass("js_hideEmptyRowWithAddButton");
                    }

                    var newTemplateRow = null;
                    if (row.next().is(".childRecordTemplateRow"))
                    {
                        newTemplateRow = row.next().clone(true, true);
                    }

                    var rowParentRows = row.parents('tr.childrecordquickentryrow');

                    var tempObj;
                    if (row.hasClass('usequickentrytemplate'))
                    {
                        var template = container.find(`#${dovPrefix}childrecordquickentrychildadd-${buttonIdParts[1]}-${buttonIdParts[2]}-Template`);
                        template.find('#ui-datepicker-div').remove();

                        //removes the ui part of the color picker that will get regenerated by the control
                        template.find('.sp-replacer').remove();
                        template.find('.colorPicker').each(function ()
                        {
                            var data = $(this).data();

                            if (Object.hasOwn(data, 'spectrum.id'))
                            {
                                data['spectrum.id'] = prefixedRowId + newRowID;
                            }
                        });

                        tempObj = template.clone(true, true);
                        var tempid = tempObj.attr('id').replace('-Template', '-' + newRowID);

                        tempObj.attr('id', tempid);

                        // Remove template's "display:none" and "doNotPost"
                        tempObj.css({ "display": "" });
                        tempObj.removeClass('doNotPost');

                        tempObj.find("[id],[name]").each(function ()
                        {
                            $(this).removeClass('doNotPost');
                        });

                        row = template;
                        newRow = tempObj;
                    }

                    newRow.find(".error-control, .error-text, .warning-control").removeClass("error-control error-text warning-control");
                    newRow.find(".help").html("");
                    newRow.find('.file').remove();

                    //Check if this is a triple nested add
                    if (button.attr('data-is-parent-of-triple') === 'true')
                    {
                        newRow.find(".childrecordquickentryrow").addClass('hidden');
                        //Manually generate a nested record to get a unique id
                        const nestedNewRowButton = newRow.find(`.js-childrecordquickentry[id^='${dovPrefix}childrecordquickentryaddbutton-']`).first();
                        generateNewRow(nestedNewRowButton, dovPrefix);
                        newRow.find(".childrecordquickentryrow.hidden").remove();
                    }
                    else
                    {
                        newRow.find(".childrecordquickentryrow").removeClass('hidden');
                    }

                    var tableSelector = `table#${dovPrefix}childrecordquickentrytable-${buttonIdParts[1]}-${buttonIdParts[2]} > tbody`;
                    var popupSelector = $('.workflowContent');

                    initializeElementsAndData(newRow, newRowID, container, row, false, rowParentRows);
                    if (newTemplateRow !== null)
                    {
                        initializeElementsAndData(newTemplateRow, newRowID, container, row, false, rowParentRows);
                    }

                    newRow.hide();
                    if (nestedRepeater.length)
                    {
                        newRow.appendTo(nestedRepeater);
                        if (newTemplateRow !== null)
                        {
                            newTemplateRow.appendTo(nestedRepeater);
                        }
                    }
                    else
                    {
                        newRow.appendTo(mainDiv.find(tableSelector));
                        if (newTemplateRow !== null)
                        {
                            newTemplateRow.appendTo(mainDiv.find(tableSelector));
                        }
                    }

                    // Toggle the new row to be shown as it should now be initialized
                    newRow.show();

                    skyward.events.applyLoadActionClass(newRow);

                    skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(container);
                    var addButtonHeight = addButton.height();
                    var newRowHeight = newRow.height();

                    skyward.window.notifyDOMLoad('#' + newRow.attr("id"));

                    if (button.data() && button.data('skipFocus') == true)
                    {
                        button.removeData('skipFocus');
                    }
                    else
                    {
                        const focusElement = newRow.find(":focusable").first();
                        if (focusElement.is(".datePicker"))
                        {
                            focusElement.attr("data-suppress-focus", "true");
                        }
                        focusElement.focus();

                        if (popupSelector.length > 0 && (newRow.offset().top + newRowHeight) > (popupSelector.offset().top + (popupSelector.height() - addButtonHeight)))
                        {
                            popupSelector.animate({ scrollTop: (popupSelector.scrollTop() + newRowHeight + addButtonHeight) }, 500);
                        }
                    }

                    if (newRow != null && newRow.length > 0 && newRow[0] != null)
                    {
                        newRow.removeClass('hidden');
                    }

                    button.trigger('childrecordquickentry-row-added', [newRow]);
                    maxNumberAdded(newRow);

                    newRow.find('div.childrecordquickentryadddiv').not(".alreadyGeneratedEmptyRows").each(function ()
                    {
                        var element = $(this);
                        element.addClass('alreadyGeneratedEmptyRows');
                        var extraRows = element.data().emptyRowCount;

                        for (var i = 1; i < extraRows; i++)
                        {
                            element.find('.button').click();
                        }
                    });

                    if (newTemplateRow !== null)
                    {
                        newTemplateRow.find(".DefaultComboBoxSet")
                            .each(function () { skyward.workflowTemplate.defaultComboBoxSetup($(this)); });
                    }
                    newRow.find(".DefaultComboBoxSet")
                        .each(function () { skyward.workflowTemplate.defaultComboBoxSetup($(this)); });
                };

                addButton.off().on('click', function () { generateNewRow($(this)); });
            });

            container.find('table.childrecordquickentrytable').each(function ()
            {
                maxNumberAdded($(this).first('tr.childrecordquickentryrow').not(".removedElement"));
            });

            container.find('div.childrecordquickentryadddiv').not(".alreadyGeneratedEmptyRows").each(function ()
            {
                var element = $(this);
                element.addClass('alreadyGeneratedEmptyRows');
                var extraRows = element.data().emptyRowCount;

                for (var i = 1; i < extraRows; i++)
                {
                    var button = element.find('.button');

                    button.data('skipFocus', true);
                    button.click();
                }
            });

            container.find('input.percentageTextBox').each(function ()
            {
                calculatePercent($(this));
            });
            container.find('input.multiplicationTextBox').each(function ()
            {
                performMultiplication($(this));
            });
            container.find('.js-childrecordquickentryerrorlabel').each(function ()
            {
                var element = $(this);

                var parentChildRecordQuickEntryRow = element.parents('.childrecordquickentryrow');
                if (parentChildRecordQuickEntryRow.length > 0)
                {
                    var elementMessageID = element.attr('data-validate-message-for');
                    var thisIDParts = elementMessageID.split('-');
                    var errorName = thisIDParts[thisIDParts.length - 1];
                    element.attr('data-validate-message-for', parentChildRecordQuickEntryRow.getIdAndPrefix().id + '-' + errorName);
                }
            });
        };

        var getTopCRQEContainerFromElement = function (element)
        {
            return element.parents(".childrecordquickentry").last();
        };

        skyward.childrecordquickentry.addressFlagCheck = function (input, clear)
        {
            var container = input.closest(".childrecordquickentry");
            var flagClicked = input;
            var flagValue = skyward.controls.getValue(flagClicked);
            var id = flagClicked.attr('id').split("-")[0];
            if (flagValue)
            {
                container.find('[id^="' + id + '"]').each(function ()
                {
                    var element = $(this);
                    skyward.controls.setValue(element, false, true);
                    skyward.controls.enable(element);
                });
                skyward.controls.setValue(flagClicked, true, true);
                skyward.controls.disable(flagClicked);
            }
            if (flagValue == "")
            {
                var parentRow;
                var parentTable;
                var firstRow;
                if (clear)
                {
                    parentRow = flagClicked.parent('td').parent('tr');
                    parentTable = parentRow.parent('tbody');
                    firstRow = parentTable.find('.newchildrecordquickentryrow-1').first();
                    var firstRowFlag = firstRow.find('[id^="' + id + '"]');
                    skyward.controls.setValue(firstRowFlag, true, true);
                    skyward.controls.disable(firstRowFlag);
                }
                else
                {
                    parentRow = flagClicked.parent('td').parent('tr');
                    parentTable = parentRow.parent('tbody');
                    firstRow = parentTable.find('.childrecordquickentryrow').first();
                    var firstNewRow = parentTable.find('.newchildrecordquickentryrow-1').first();
                    var rowCount = parentTable.children().length;
                    if (firstNewRow.attr('id') == firstRow.attr('id') && rowCount < 3)
                    {
                        var firstNewRowFlag = firstNewRow.find('[id^="' + id + '"]');
                        skyward.controls.setValue(firstNewRowFlag, true, true);
                        skyward.controls.disable(firstNewRowFlag);
                    }
                }
            }
        };

        var getUniqueRowID = function (container)
        {
            var childRows = container.find(".js-topchildrecordquickentry").find(".js-childrecordquickentrychild,.js-childrecordquickentrychildadd");
            var newRowID = 0;
            for (var i = 0; i < childRows.length; i++)
            {
                var childRowIDParts = childRows[i].id.split('-');
                var childRowID = parseInt(childRowIDParts[childRowIDParts.length - 1]);
                if (!isNaN(childRowID) && childRowID > newRowID)
                {
                    newRowID = childRowID;
                }
            }
            return newRowID + 1;
        };

        var initializeCounter = function (legendContentDiv, prefixedRowId)
        {
            var tbody = legendContentDiv.find('table').find('tbody');

            var tableRows = tbody.find('tr.childrecordquickentryrow.js-childrecordquickentrychildadd[id^="' + prefixedRowId + '"]');
            var nextHighestRowNum = 0;

            for (var i = 0; i < tableRows.length; i++)
            {
                var tableRow = $(tableRows[i]);
                var rowToEvaluate = tableRow.attr("id").split("-");
                var rowNum = rowToEvaluate[rowToEvaluate.length - 1];
                nextHighestRowNum = Math.max(parseInt(rowNum, 10), nextHighestRowNum);
            }

            return nextHighestRowNum;
        };

        var initializeElementsAndData = function (newRow, counter, container, row, preservePrefilledValues, rowParentRows, crqeRecordValues)
        {
            var idPrefix = container.getIdAndPrefix().prefix;
            var elementTypesToInitialize = ['label', '.fieldWrapper', 'div', 'span', 'a', ':input', 'option', '.dateTimePickerWrapper'];
            var dataTypesToCheck = ["validate-message-for", "validate-control-for", "validate-text-for", "dependents", "dynamicfiltervalue"];
            const defaultValueInputsToIgnore = ["codeEELCode", "codeEELDescription", "tileViewEEL_search"];

            var dataElements = [];
            var elementsToInitialize = [];

            // If there are any CodeEELs in the newly cloned row, we need to remove the initialized value EEL data
            newRow.find(".codeEELValue").each(function ()
            {
                $(this).removeData('eel-data');
            });

            newRow.find(getElementAndDataAttributeSelector(elementTypesToInitialize, dataTypesToCheck)).each(function ()
            {
                var element = $(this);
                var index;
                // TODO having two loops is silly, we should just do two separate .find().each() calls
                for (index in dataTypesToCheck)
                {
                    if (element.data(dataTypesToCheck[index]) != undefined)
                    {
                        dataElements.push(this);
                    }
                }

                for (index in elementTypesToInitialize)
                {
                    if (element.is(elementTypesToInitialize[index]))
                    {
                        elementsToInitialize.push(this);
                    }
                }
            });

            var combineElementAndGrandparentIds = function (grandparentIdParts, elementId)
            {
                // First part of dependent ID should be equal if parent ID was already prepended
                if (elementId.indexOf("-add-") >= 0 && grandparentIdParts[0] === "childrecordquickentrychild")
                {
                    // Need to find some way to elimate the duplicated id when the grandparent id is the same as the child (happens only with triple nested)
                    grandparentIdParts[0] = grandparentIdParts[0].concat("add");
                    var newGrandparentId = grandparentIdParts.join("-");
                    // With triple nested the first part of the id of the child record is the same as the grandparent
                    // (I think its being generated like that in crqe.cs somewhere, but this is a workaround for now)
                    if (elementId.length >= newGrandparentId.length && elementId.startsWith(newGrandparentId))
                    {
                        return elementId;
                    }
                }

                elementId = grandparentIdParts.join("-") + '-' + elementId;

                return elementId;
            };

            $.each(dataElements, function ()
            {
                let input = $(this);

                let parentRepeaterRows = input.parents('tr.childrecordquickentryrow');
                const parentRepeater = parentRepeaterRows.first();

                // parentRepeaterRows will only contain grandparent rows when we're adding the outer and nested row at the same time...
                // ...if we're adding a just a nested row then when need to get the old row's parent rows and merge that with the input's parents
                if (rowParentRows)
                {
                    $.merge(parentRepeaterRows, rowParentRows);
                }

                const isNestedRepeaterElement = parentRepeaterRows.length > 1;

                const parentIdParts = isNestedRepeaterElement && parentRepeater.attr('id') ? parentRepeater.attr('id').split('-') : [];
                let parentCounter = null;
                let innerCounter = counter;

                const repeaterGrandparent = parentRepeaterRows.eq(1);
                const { id: grandparentId, prefix: grandparentPrefix } = repeaterGrandparent.getIdAndPrefix(idPrefix);
                const grandparentParts = grandparentId?.split("-") ?? [];

                if (input.hasClass("js-maskInitialized"))
                {
                    input.removeClass("js-maskInitialized");
                }

                if (input.hasClass("masked"))
                {
                    input.removeClass("masked");
                }

                if (isNestedRepeaterElement)
                {
                    // outer (grandparent row) quick entry
                    parentCounter = grandparentParts[grandparentParts.length - 1];
                    // nested (parent row) quick entry
                    innerCounter = parentIdParts[parentIdParts.length - 1];
                }

                for (let index in dataTypesToCheck)
                {
                    if (dataTypesToCheck[index] === "dependents")
                    {
                        const dependentAttribute = input.attr("data-" + dataTypesToCheck[index]);
                        if (dependentAttribute != undefined)
                        {
                            const dependentObject = JSON.parse(dependentAttribute);
                            const dependents = dependentObject.dependents;
                            const isInnerChildRecordQuickEntry = dependentObject.isInnerChildRecordQuickEntry;
                            for (let dependentIndex in dependents)
                            {
                                let dependentId = dependents[dependentIndex].Id;
                                const grandParentIndexes = [];
                                let grandParentIndexCounter = 0;

                                if (dependentId != undefined)
                                {
                                    const dependentIdHasPrefix = dependentId.startsWith(idPrefix);

                                    if (dependentIdHasPrefix)
                                    {
                                        dependentId = dependentId.slice(idPrefix.length);
                                    }

                                    if (isInnerChildRecordQuickEntry && isNestedRepeaterElement)
                                    {
                                        for (var x = 0; x < grandparentParts.length; x++)
                                        {
                                            if (!isNaN(grandparentParts[x]))
                                            {
                                                grandParentIndexes[grandParentIndexCounter] = grandparentParts[x];
                                                grandParentIndexCounter++;
                                            }
                                        }
                                        grandParentIndexCounter = 0;
                                    }

                                    let dependentIdParts = dependentId.split('-');
                                    let dependentIdPartsLength = dependentIdParts.length;
                                    // First part of dependant ID should be equal if parent ID was already prepended
                                    if (isNestedRepeaterElement && dependentIdPartsLength > 0 && grandparentParts.length > 0 && grandparentParts[0] != dependentIdParts[0] && (grandparentParts[0] + "add") != dependentIdParts[0])
                                    {
                                        if (dependentId.indexOf('-add-') >= 0 && grandparentParts[0] === "childrecordquickentrychild")
                                        {
                                            grandparentParts[0] = grandparentParts[0].concat("add");
                                        }

                                        dependentId = grandparentParts.join('-') + '-' + dependentIdParts.join('-');
                                    }

                                    dependentIdParts = dependentId.split('-');
                                    dependentIdPartsLength = dependentIdParts.length;
                                    let updatedDependentId = '';

                                    if (isInnerChildRecordQuickEntry && dependentIdPartsLength > 1)
                                    {
                                        for (var l = 0; l < dependentIdPartsLength - 1; l++)
                                        {
                                            if (isNaN(dependentIdParts[l]))
                                            {
                                                updatedDependentId += dependentIdParts[l] + '-';
                                            }
                                            else
                                            {
                                                updatedDependentId += grandParentIndexes[grandParentIndexCounter] + '-';
                                                grandParentIndexCounter++;
                                            }
                                        }

                                        updatedDependentId += innerCounter;
                                    }
                                    else if (!isInnerChildRecordQuickEntry && dependentIdPartsLength > 1)
                                    {
                                        for (let l = 0; l < dependentIdPartsLength - 1; l++)
                                        {
                                            updatedDependentId += dependentIdParts[l] + '-';
                                        }

                                        updatedDependentId += innerCounter;
                                    }

                                    if (dependentIdHasPrefix)
                                    {
                                        updatedDependentId = `${idPrefix}${updatedDependentId}`;
                                    }

                                    dependents[dependentIndex].Id = updatedDependentId;
                                }
                            }
                            dependentObject.dependents = dependents;

                            input.data(dataTypesToCheck[index], dependentObject);
                            input.attr('data-' + dataTypesToCheck[index], JSON.stringify(dependentObject));
                        }
                    }
                    else
                    {
                        skyward.ajax.unregisterControlAjax(input);

                        let nonDependentDataTypesToCheck = input.data(dataTypesToCheck[index]);

                        if (nonDependentDataTypesToCheck !== null && typeof nonDependentDataTypesToCheck === 'string')
                        {
                            let nonDependentCounter = innerCounter;

                            if (isNestedRepeaterElement && dataTypesToCheck[index] !== 'dynamicfiltervalue' &&
                                nonDependentDataTypesToCheck.split('-').length > 0 && grandparentParts[0] != nonDependentDataTypesToCheck.split('-')[0])
                            {
                                // First part of dependent ID should be equal if parent ID was already prepended, to ensure we have a childrecordquickentrychildadd id on the new row
                                nonDependentDataTypesToCheck = combineElementAndGrandparentIds(grandparentParts, nonDependentDataTypesToCheck);
                            }

                            // Nested repeaters may have dependencies at other levels of nesting and require special handling
                            if (isNestedRepeaterElement && dataTypesToCheck[index] === 'dynamicfiltervalue')
                            {
                                const dependencyParentRow = $('[name="' + nonDependentDataTypesToCheck + '"]').last().parents('tr.childrecordquickentryrow');
                                if (dependencyParentRow.length > 0 && dependencyParentRow.length !== parentRepeaterRows.length)
                                {
                                    // TODO: this assumes that because the dependency element is on a different level it is in the parent repeater
                                    // this works for 1 nested repeater, but will break when the dependency is more than 1 nested repeater up (or down) the hierarchy
                                    nonDependentCounter = parentCounter;
                                }
                                // If the dependency doesn't "exist" yet, assume it's in the parent
                                else if (dependencyParentRow.length === 0)
                                {
                                    nonDependentCounter = parentCounter;
                                }
                            }

                            let dataTypeValue = '';

                            if (input.hasClass('js-childrecordquickentryerrorlabel'))
                            {
                                continue;
                            }
                            //allow for multiple dependents
                            let dynamicfiltervalueParts = null;
                            if (dataTypesToCheck[index] === "dynamicfiltervalue")
                            {
                                dynamicfiltervalueParts = nonDependentDataTypesToCheck.split(',');
                            }

                            if (dynamicfiltervalueParts != null && dynamicfiltervalueParts.length > 1)
                            {
                                for (let i = 0; i < dynamicfiltervalueParts.length; i++)
                                {
                                    if (dataTypeValue != '')
                                    {
                                        dataTypeValue += ',';
                                    }
                                    dataTypeValue += processDataTypeValue(dynamicfiltervalueParts[i], parentIdParts, parentCounter, nonDependentCounter);
                                }
                            }
                            else
                            {
                                dataTypeValue = processDataTypeValue(nonDependentDataTypesToCheck, parentIdParts, parentCounter, nonDependentCounter);
                            }

                            if (dataTypesToCheck[index] === "dynamicfiltervalue")
                            {
                                input.data(dataTypesToCheck[index], dataTypeValue);
                            }

                            input.attr("data-" + dataTypesToCheck[index], dataTypeValue);
                        }
                    }
                }
            });

            $.each(elementsToInitialize, function ()
            {
                var element = $(this);
                var { id: elementId } = element.getIdAndPrefix(idPrefix);
                var parentRepeaterRows = element.parents('tr.childrecordquickentryrow');
                var parentRepeater = parentRepeaterRows.first();

                if (rowParentRows)
                {
                    $.merge(parentRepeaterRows, rowParentRows);
                }

                var isNestedRepeaterElement = parentRepeaterRows.length > 1;
                var parentIdParts = isNestedRepeaterElement && parentRepeater.attr('id') ? parentRepeater.attr('id').split('-') : [];
                var parentCounter = null;
                var innerCounter = counter;

                // true if element has data-clonevalue true or if the code/tile EEL's text-for label has clonevalue true
                var clonevalue = getDataClonevalue(element);

                if (isNestedRepeaterElement)
                {
                    var repeaterGrandparent = parentRepeaterRows.eq(1);
                    var grandparentParts = repeaterGrandparent.attr('id') ? repeaterGrandparent.attr('id').split('-') : [];

                    parentCounter = grandparentParts[grandparentParts.length - 1];
                    innerCounter = parentIdParts[parentIdParts.length - 1];
                }

                var newId = '';
                var oldId = '';
                var newName = '';

                if (elementId != null)
                {
                    var parseIdOrName = function (attribute)
                    {
                        var newValue = '';
                        var idPostfix = '';

                        var repeaterGrandparent = parentRepeater.parents('tr.childrecordquickentryrow').not(".disablenestedrepeaterrename").first();
                        var grandparentParts = repeaterGrandparent.getIdAndPrefix(idPrefix).id?.split('-') ?? null;
                        // First part of attribute ID should be equal if parent ID was already prepended, to ensure we have a childrecordquickentrychildadd id on the new row
                        if (repeaterGrandparent && repeaterGrandparent.attr('id') && grandparentParts && attribute.split('-').length > 0 && grandparentParts[0] != attribute.split('-')[0])
                        {
                            attribute = combineElementAndGrandparentIds(grandparentParts, attribute);
                        }

                        var attributeParts = attribute.split('-');

                        var idLength = attributeParts.length;
                        var postFixedParts = attributeParts[idLength - 1].split('_');
                        var postFixedPartsLength = postFixedParts.length;

                        if (postFixedPartsLength > 1)
                        {
                            for (var j = 1; j < postFixedPartsLength; j++)
                            {
                                idPostfix += '_' + postFixedParts[j];
                            }
                        }

                        if (idLength > 1)
                        {
                            for (var i = 0; i < idLength - 1; i++)
                            {
                                if (parentIdParts && i === parentIdParts.length - 1 && skyward.extensions.isNumeric(parentIdParts[i]))
                                {
                                    newValue = newValue + parentCounter + '-';

                                    if (!skyward.extensions.isNumeric(attributeParts[i]) && attributeParts[i] !== 'Template')
                                    {
                                        newValue = newValue + attributeParts[i] + '-';
                                    }
                                }
                                else
                                {
                                    newValue = newValue + attributeParts[i] + '-';
                                }
                            }
                        }
                        else
                        {
                            newValue = attributeParts[0] + '-';
                        }

                        var newIdValue = newValue + innerCounter;

                        return newIdValue + idPostfix;
                    };

                    oldId = idPrefix + elementId;
                    newId = parseIdOrName(elementId);

                    if (element.attr('name'))
                    {
                        newName = parseIdOrName(element.attr('name'));
                    }
                    else if (element.hasClass("radioButtonGroup"))
                    {
                        // radio button groups utilize a data-name attribute on the container element
                        newName = parseIdOrName(element.data('name'));
                    }

                    const newElementID = idPrefix + newId;

                    newRow.find(`[for='${oldId}']`).attr('for', newElementID);
                    newRow.find(`[aria-labelledby='${oldId}']`).attr('aria-labelledby', newElementID);
                    newRow.find(`[aria-describedby='${oldId}']`).attr('aria-describedby', newElementID);

                    skyward.controls.changeId(element, newElementID, newName);
                }

                var parent = element.parent();
                let valueHasBeenSet = false;
                if (element.hasClass('codeEELValue') || element.hasClass('tileViewEEL_value'))
                {
                    parent.off();
                    element.off();
                    var newParentID = '';
                    var { id: oldParentId } = parent.getIdAndPrefix(idPrefix);
                    var inputIdPartsEELParent = oldParentId.split("-");

                    if (inputIdPartsEELParent.length > 1)
                    {
                        newParentID = inputIdPartsEELParent.slice(0, -1).join("-") + "-";
                    }
                    else
                    {
                        newParentID = inputIdPartsEELParent[0] + '-';
                    }

                    const previousParentID = newParentID + (innerCounter - 1);
                    newParentID = newParentID + innerCounter;

                    const newID = idPrefix + newParentID;

                    newRow.find(`[for='${oldParentId}']`).attr('for', newID);
                    newRow.find(`[aria-labelledby='${oldParentId}']`).attr('aria-labelledby', newID);
                    newRow.find(`[aria-describedby='${oldParentId}']`).attr('aria-describedby', newID);

                    parent.data("original-id", parent.attr("id"));
                    parent.attr('id', newID);
                    if (element.hasClass('codeEELValue'))
                    {
                        parent.data('area', element.data('area'));
                        parent.data('action', element.data('action'));
                        parent.data('controller', element.data('controller'));
                        parent.data('securityHash', element.data('securityHash'));
                        var eelHasPostdata = !$.isEmptyObject(parent.data("postdata"));
                        var eelDynamicHashData = parent.find(".codeEELValue").data("dynamic-filter-hashes");
                        if (eelHasPostdata && eelDynamicHashData?.PageStateModifyControlValue === null && eelDynamicHashData.PageStateModifyControlCode === null && eelDynamicHashData.PageStateModifyControlDescription === null)
                        {
                            // Used in Out of District Transfer Course workflow
                            const dynamicPageStateValues = {
                                PageStateModifyControlValue: idPrefix + newParentID,
                                PageStateModifyControlCode: idPrefix + newParentID + "_code",
                                PageStateModifyControlDescription: idPrefix + newParentID + "_description"
                            };
                            const additionalDynamicFilterValues = $.extend({}, parent.data("additionalDynamicFilterValues"), dynamicPageStateValues);
                            parent.data("additionalDynamicFilterValues", additionalDynamicFilterValues);
                            parent[0].dataset.additionalDynamicFilterValues = JSON.stringify(additionalDynamicFilterValues);
                        }
                        skyward.codeeel.reinitializeCodeEEL(parent);
                    }
                    else
                    {
                        // Handle cloning the request data hash for TileViewEEL on new rows
                        const previousParent = container.find(`#${previousParentID}`);
                        if (previousParent.length > 0)
                        {
                            const searchElement = previousParent.find(".tileViewEEL_search");
                            const valueElement = previousParent.find(".tileViewEEL_value");
                            const elementRequestDataHashSrc = searchElement.data().requestDataHashSrc;
                            const hashKey = valueElement.attr("name");
                            const requestDataHashes = skyward.requestDataHash.getRequestDataHashes(elementRequestDataHashSrc);
                            const requestDataHash = skyward.requestDataHash.getRequestDataHash(elementRequestDataHashSrc, hashKey);
                            if (requestDataHash)
                            {
                                const newValueElement = parent.find(".tileViewEEL_value");
                                const newTrueId = newValueElement.attr("name");
                                requestDataHashes[newTrueId] = $.extend(true, {}, requestDataHash);
                                newValueElement.data("original-name", newTrueId);
                            }
                        }

                        parent.find(".tileViewEEL_search").off();
                        parent.find(".tileViewEEL_searchButton").off();
                        skyward.tileViewEEL.registerTileViewEEL(parent);
                    }

                    if (!preservePrefilledValues)
                    {
                        //TODO: right now I have it so it looks for the label above the code eel to have an attr of
                        //data-clonevalue, will have to fix code eels or think of a better way of doing this
                        if (clonevalue)
                        {
                            // TODO: tileEEL containing div has the same ID as the TileEEL hidden field, this selector always selects the input instead of the div
                            skyward.controls.copyValue($(`[id="${oldId}"]:input`), parent, true);
                        }
                        else
                        {
                            skyward.controls.setValue(parent, null, true);
                        }

                        valueHasBeenSet = true;
                    }

                    skyward.controls.changeId(parent, idPrefix + newParentID);
                }

                if (element.hasClass('dmsBackingData'))
                {
                    parent.off();
                    parent.find('.distinctMultiSelectUserInput').off();
                    element.off();
                    parent.attr('data-hidden-backing-data-id', element.attr('id'));
                    parent.data('hidden-backing-data-id', element.attr('id'));
                    parent.data('selected-item-keys', []);
                    parent.data('dmseInstance', null);

                    parent.removeClass("eventsBound--DMSE");
                    skyward.distinctMultiSelectEEL.registerDistinctMultiSelectEEL(parent);

                    if (!clonevalue && !getDataClonevalue(element.parent()))
                    {
                        skyward.distinctMultiSelectEEL.values.clear(parent);
                    }
                }

                if (element.hasClass('datepicker'))
                {
                    parent.attr('id', 'disciplineDateSpan-' + innerCounter);
                    skyward.datepicker.destroy(element);
                    var calendarButton = parent.children('.datepicker-trigger');
                    calendarButton.attr('id', newId + '-icon');
                    skyward.datepicker.registerDatepicker(element);
                }

                if (!preservePrefilledValues && !valueHasBeenSet && element.is(':input') && !defaultValueInputsToIgnore.some(className => element.hasClass(className)))
                {
                    let defaultValue = clonevalue ? element.attr('data-original-value') : null;

                    if (element.is(":checkbox"))
                    {
                        defaultValue = defaultValue === "true";
                    }
                    else if (element.is(":radio"))
                    {
                        var radioNameOld = element.attr("Name");
                        var lastIndexOfDash = radioNameOld.lastIndexOf('-');
                        var radioName = radioNameOld.substring(0, lastIndexOfDash);

                        element.attr("Name", radioName + "-" + innerCounter);
                        if (element.parents('.radioButtonGroup').eq(0).find('.radioButtonGroupValue').length)
                        {
                            element.attr("Name", element.attr('Name') + 'child');
                        }
                        if (element[0].defaultChecked === true)
                        {
                            defaultValue = element[0].defaultValue;
                        }
                    }

                    if (element.is(".datePicker,.timePicker,.dateTimePicker"))
                    {
                        const control = element.closest(".dateTimePickerWrapper");
                        let originalValue = control.attr('data-original-value')?.substring(0, 10);
                        let defaultValue = clonevalue ? originalValue : null;
                        control.val(defaultValue);
                    }
                    else
                    {
                        skyward.controls.setValue(element, defaultValue, true);
                    }
                    //Setting value clears select inputs out, since they are directly using .val()
                    if (element.is("select"))
                    {
                        $(row).find("select").each(function (currentIndex)
                        {
                            $(this).find("select").eq(currentIndex).val(defaultValue);
                        });
                    }
                }

                // crqeRecordValues is set from ajax, so we expect unprefixed ids
                // technically it checks id.indexOf(value) so we're probably fine either way
                setCRQERecordValues(crqeRecordValues, element, elementId);

                // Default new control
                let elementWithCloneData = element;
                if (element.is(".datePicker,.timePicker,.dateTimePicker"))
                {
                    elementWithCloneData = element.closest(".dateTimePickerWrapper");
                }
                const elementHasCloneValue = elementWithCloneData.attr('data-clonevalue') != null && elementWithCloneData.attr('data-clonevalue').toLowerCase() != "false";

                if (element.is(':input') && elementHasCloneValue)
                {
                    var oldElement = document.getElementById(oldId);
                    if (oldElement !== null)
                    {
                        // TODO: Remove this check after PR 6145635
                        if (element.hasClass('datepicker'))
                        {
                            var valueToSet;
                            if (!oldElement.value || (oldElement.value.length < 10 && !skyward.validation.validDate(oldElement.value.substring(0, 10))))
                            {
                                valueToSet = null;
                            }
                            else if (elementWithCloneData.attr('data-incrementcloneddate') != null && elementWithCloneData.attr('data-incrementcloneddate').toLowerCase() != "false")
                            {
                                const date = skyward.controls.getValue(oldElement);
                                const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                                newDate.setDate(date.getDate() + 1);

                                valueToSet = date;
                            }
                            else
                            {
                                valueToSet = skyward.controls.getValue(oldElement);
                            }
                            skyward.controls.setValue(element, valueToSet, true);
                            skyward.datepicker.setDatePicker(element);
                        }
                        else if (element.hasClass('datePicker'))
                        {
                            let valueToSet;
                            if (!oldElement.value || (oldElement.value.length < 10 && !skyward.validation.validDate(oldElement.value.substring(0, 10))))
                            {
                                valueToSet = null;
                            }
                            else if (elementWithCloneData.attr('data-incrementcloneddate') != null && elementWithCloneData.attr('data-incrementcloneddate').toLowerCase() != "false")
                            {
                                const date = skyward.controls.getValue(oldElement);
                                const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                                newDate.setDate(date.getDate() + 1);

                                valueToSet = newDate;
                            }
                            else
                            {
                                valueToSet = skyward.controls.getValue(oldElement);
                            }
                            elementWithCloneData.val(valueToSet?.toISOString());
                        }
                        else
                        {
                            skyward.controls.setValue(element, skyward.extensions.decodeHtml(skyward.controls.getValue(oldElement)), true);
                        }
                    }
                }

                //Screen specific
                //TODO: See if there is a way we can check what this thing belongs to, and run a custom javascript function from a different file, but genericise it
                if (element.hasClass('honorrollmethodisactivecheckbox '))
                {
                    element.click(function ()
                    {
                        skyward.grading.honorRollMethodDefaultValueFunction($(this));
                    });
                }

                if (element.hasClass('AddressFlag'))
                {
                    var flagOnChange = function ()
                    {
                        skyward.childrecordquickentry.addressFlagCheck($(this), false);
                    };
                    element.on('change', flagOnChange);
                }

                if (element.hasClass('manualEntryCheckbox'))
                {
                    element.attr('data-clonevalue', 'true');
                }

                // Add the control
                var dataObjectViewer = container.find('div.contentArea div.currentRecordContent.dataObjectViewer');
                var dovId = dataObjectViewer.attr('id');

                skyward.dataobjectviewer.addNewControl(dovId, false);
            });
            processedIds.push(newRow.attr('id'));
            skyward.datamask.applyMaskOnContainer(container);
        };

        var processDataTypeValue = function (nonDependentDataTypesToCheck, parentIdParts, parentCounter, nonDependentCounter)
        {
            var dataTypeValue = '';
            var dataTypesForParts = nonDependentDataTypesToCheck.split('-');
            var dataTypesForPartsLength = dataTypesForParts.length;

            if (dataTypesForPartsLength > 1)
            {
                for (var k = 0; k < dataTypesForPartsLength - 1; k++)
                {
                    if (parentIdParts && k === parentIdParts.length - 1 && skyward.extensions.isNumeric(parentIdParts[k]))
                    {
                        dataTypeValue += parentCounter + '-';
                    }
                    else
                    {
                        dataTypeValue += dataTypesForParts[k] + '-';
                    }
                }

                dataTypeValue += nonDependentCounter;
            }
            else if (dataTypesForPartsLength === 1)
            {
                dataTypeValue = dataTypesForParts[0];
            }
            return dataTypeValue;
        };

        var getElementAndDataAttributeSelector = function (elementTypes, dataAttributes)
        {
            var selectorString = elementTypes.join(',');

            if (dataAttributes && dataAttributes.length > 0)
            {
                selectorString += ',';

                selectorString += dataAttributes.reduce(function (previous, current, index, array)
                {
                    return previous + '[data-' + current + ']' + (index === array.length - 1 ? '' : ',');
                }, "");
            }

            return selectorString;
        };

        var fixSuffix = function (childParts, adjustedParentParts)
        {
            var underscoredSuffix = childParts[childParts.length - 1].split('_');
            var updatedParts = childParts;
            updatedParts[updatedParts.length - 1] = adjustedParentParts[adjustedParentParts.length - 1];
            var updatedPart = updatedParts.join('-');
            if (underscoredSuffix.length === 2)
            {
                updatedPart = updatedPart + '_' + underscoredSuffix[1];
            }
            return updatedPart;
        };

        var initializeChildRecordIDs = function (row)
        {
            var elementTypesToInitialize = ['label', 'fieldset', 'div', 'span', 'a', ':input'];
            var parent = row instanceof $ ? row : $(row);
            var { id: parentId, prefix: dovPrefix } = parent.getIdAndPrefix();
            var parentIdParts = parentId?.split('-');

            if (parentId)
            {
                parent.find('tr.childrecordquickentryrow').find(getElementAndDataAttributeSelector(elementTypesToInitialize)).each(function ()
                {
                    var element = $(this);
                    var elementParent = element.parent();

                    var { id: childId } = element.getIdAndPrefix(dovPrefix);
                    var childName = element.attr('name');
                    if (childId)
                    {
                        var childIdParts = childId.split('-');
                        var updatedId;

                        var adjustedParentIdParts = parentIdParts?.slice();
                        // TODO `adjustedParentIdParts[0] === 'childrecordquickentrychild'` should always be true for rows, unless they've already been modified
                        // and this method is only called on rows
                        // if the element is an add button, adjust its prefix so it acts like a top-level add button?
                        if (adjustedParentIdParts[0] === 'childrecordquickentrychild' && childIdParts.length >= 2 && childIdParts[childIdParts.length - 2] === 'add')
                        {
                            adjustedParentIdParts[0] = 'childrecordquickentrychildadd';
                        }
                        var adjustedParentId = adjustedParentIdParts.join('-');

                        if (childIdParts.length >= 4)
                        {
                            updatedId = fixSuffix(childIdParts, adjustedParentIdParts);
                        }
                        else
                        {
                            updatedId = adjustedParentId + '-' + childId;
                        }

                        if (childName)
                        {
                            var childNameParts = childName.split('-');
                            var updatedName;
                            if (childIdParts.length >= 4)
                            {
                                updatedName = fixSuffix(childNameParts, adjustedParentIdParts);
                            }
                            else
                            {
                                updatedName = adjustedParentId + '-' + childName;
                            }

                            var dataAction = element.attr('data-action');

                            if (dataAction && (dataAction === 'codeEEL' || dataAction === 'tileViewEEL'))
                            {
                                elementParent.siblings('span[data-validate-message-for]').each(function ()
                                {
                                    $(this).attr('data-validate-message-for', updatedName);
                                });

                                elementParent.siblings('label[data-validate-text-for]').each(function ()
                                {
                                    $(this).attr('data-validate-text-for', updatedName);
                                });

                                // Update codeEEL Code/Description boxes
                                element.siblings('input[data-validate-control-for]').each(function ()
                                {
                                    $(this).attr('data-validate-control-for', updatedName);
                                });
                            }
                            else
                            {
                                element.siblings('span[data-validate-message-for]').each(function ()
                                {
                                    $(this).attr('data-validate-message-for', updatedName);
                                });

                                element.siblings('label[data-validate-text-for]').each(function ()
                                {
                                    $(this).attr('data-validate-text-for', updatedName);
                                });

                                if (element.attr('data-validate-control-for'))
                                {
                                    element.attr('data-validate-control-for', updatedName.replace('_code', '').replace('_description', ''));
                                }
                            }

                            element.data("original-name", element.data("original-name") ?? updatedName);
                            element.attr('name', updatedName);
                        }

                        element.attr('id', dovPrefix + updatedId);
                    }
                });
            }
        };

        function getDataClonevalue(element)
        {
            let elementToUse = element;
            if (elementToUse.hasClass("codeEELCode") || elementToUse.hasClass("codeEELDescription"))
            {
                elementToUse = element.closest(".codeEEL").find(".codeEELValue");
            }
            const eelLabel = elementToUse.parent().siblings('label[data-validate-text-for]').first();

            // true if element has data-clonevalue true or if the code/tile EEL's text-for label has clonevalue true
            return (elementToUse.attr('data-clonevalue') && elementToUse.attr('data-clonevalue').toLowerCase() === 'true') ||
                ((elementToUse.hasClass('codeEELValue') || elementToUse.hasClass('tileViewEEL_value') || elementToUse.hasClass('dmsBackingData')) &&
                    eelLabel !== elementToUse && eelLabel.length && eelLabel.attr('data-clonevalue') && eelLabel.attr('data-clonevalue').toLowerCase() === "true") ||
                (elementToUse.attr('data-clonevalue') && elementToUse.hasClass('childRecordValueClonable')) ||
                (element.hasClass('datePicker') && getDataClonevalue(element.closest("sky-datepicker"))) ||
                (elementToUse.hasClass('radioButtonGroupValue') && getDataClonevalue(elementToUse.parent()));
        }

        var getDataTakeDefaultValue = function (element)
        {
            var data = element.data();
            return String(data.takedefaultvalue).toLowerCase() === 'true';
        };

        var maxNumberAdded = function (rowPart)
        {
            var table = $(rowPart).closest('table.childrecordquickentrytable');
            var maxNumber = table.attr('data-limitnumberofadds');

            if (maxNumber)
            {
                var counter = $(table).children('tbody').children('tr.childrecordquickentryrow').not(".removedElement").length;
                var addButtonDiv = $(table).siblings('div.childrecordquickentryadddiv');

                if (counter >= maxNumber)
                {
                    addButtonDiv.find('a').addClass("hidden");
                }
                else if (addButtonDiv.find('a.hidden').length)
                {
                    addButtonDiv.find('a.hidden').removeClass("hidden");
                }
            }
        };

        var performMultiplication = function (multiplicationTextBox)
        {
            var multiplierParentFieldName = multiplicationTextBox.attr('data-multiplierparent');
            var multiplierParent = multiplicationTextBox.closest(".fieldWrapper").siblings().children('input[name="' + multiplierParentFieldName + '"]');

            var thisFieldsName = multiplicationTextBox.attr('name').substring(0, multiplicationTextBox.attr('name').indexOf('-'));

            var multiplierChildFieldName = multiplicationTextBox.attr('data-multiplierchild');
            multiplierChildFieldName = multiplicationTextBox.attr('name').replace(thisFieldsName, multiplierChildFieldName);
            var multiplierChild = multiplicationTextBox.parent().siblings().children('[name="' + multiplierChildFieldName + '"]');

            if (!multiplierParent ||
                !multiplierParent.val() ||
                !multiplierChild ||
                !multiplierChild.val())
            {
                return;
            }
            else
            {
                var multiplierChildValue = multiplierChild.val().replace(/[^\d.-]/g, '');
                if (multiplierChildFieldName.includes('Percent'))
                {
                    multiplierChildValue = multiplierChildValue / 100;
                }
                //regex is to strip any special characters (commas, dollar signs, etc.) except periods and dashes
                skyward.controls.setValue(multiplicationTextBox, (multiplierParent.val().replace(/[^\d.-]/g, '') * multiplierChildValue).toFixed(2), true);
            }
        };

        var calculatePercent = function (percentageTextBox)
        {
            var denominatorFieldName = percentageTextBox.attr('data-denominator');
            var denominator = percentageTextBox.closest(".fieldWrapper").siblings().children('input[name="' + denominatorFieldName + '"]');

            var numeratorFieldName = percentageTextBox.attr('data-numerator');
            numeratorFieldName = percentageTextBox.attr('name').replace('Percent', numeratorFieldName);
            var numerator = percentageTextBox.parent().siblings().children('[name="' + numeratorFieldName + '"]');

            if ((!denominator || !denominator.val()) &&
                (!numerator.val() && !numerator))
            {
                skyward.controls.setValue(percentageTextBox, '100.00', true);
            }
            else if (!numerator || !numerator.val() || denominator.val() == 0)
            {
                skyward.controls.setValue(percentageTextBox, "", true);
            }
            else
            {
                //regex is to strip any special characters (commas, dollar signs, etc.) except periods and dashes
                skyward.controls.setValue(percentageTextBox, ((numerator.val().replace(/[^\d.-]/g, '') / denominator.val().replace(/[^\d.-]/g, '')) * 100).toFixed(2), true);
            }
        };

        skyward.childrecordquickentry.SetCRQERecordValues = function (crqeRecord, container, idPrefix)
        {
            var crqeTableId = crqeRecord.CRQETableID.replace("#", "#" + (idPrefix ?? ""));
            var crqeTableIdParts = crqeTableId.split('-');
            var crqeTable = container.find(crqeTableId);
            var nestedRepeater = crqeTable.closest('.childrecordquickentryadddiv').prev('.childrecordquickentrytable');
            var prefixedRowId = `${idPrefix}childrecordquickentrychildadd-${crqeTableIdParts[1]}-${crqeTableIdParts[2]}-`;
            // First childrecordquickentry ancestor - never grandparent
            var mainDiv = crqeTable.parents('.childrecordquickentry').eq(0);

            // find the highest row count
            var legendContentDiv = $(".thinHeaderContainerBorder");
            var previousRowID = initializeCounter(legendContentDiv, prefixedRowId);

            var row;
            if (nestedRepeater.length)
            {
                row = nestedRepeater.find('#' + prefixedRowId + previousRowID);
            }
            else
            {
                row = mainDiv.find('#' + prefixedRowId + previousRowID);
            }
            row.find('#ui-datepicker-div').remove(); //before cloning remove the Jquery datepicker div so the clone doesn't clone into it

            var newRow = row.clone(true, true);
            var newRowID = getUniqueRowID(container);
            newRow.attr('id', prefixedRowId + newRowID);

            var rowParentRows = row.parents('tr.childrecordquickentryrow');

            if (row.hasClass('usequickentrytemplate'))
            {
                var template = container.find('#childrecordquickentrychildadd-' + crqeTableIdParts[1] + '-' + crqeTableIdParts[2] + '-Template');
                template.find('#ui-datepicker-div').remove();

                //removes the ui part of the color picker that will get regenerated by the control
                template.find('.sp-replacer').remove();
                template.find('.colorPicker').each(function ()
                {
                    var data = $(this).data();

                    if (Object.hasOwn(data, 'spectrum.id'))
                    {
                        data['spectrum.id'] = prefixedRowId + newRowID;
                    }
                });

                var tempObj = template.clone(true, true);
                var tempID = tempObj.attr('id').replace('-Template', '-' + newRowID);

                tempObj.attr('id', tempID);

                // Remove template's "display:none" and "doNotPost"
                tempObj.css({ "display": "" });
                tempObj.removeClass('doNotPost');

                tempObj.find("[id],[name]").each(function ()
                {
                    $(this).removeClass('doNotPost');
                });

                row = template;
                newRow = tempObj;
            }

            newRow.find(".error-control, .error-text, .warning-control").removeClass("error-control error-text warning-control");
            newRow.find(".help").html("");
            newRow.find('.file').remove();

            var tableSelector = `table#${idPrefix}childrecordquickentrytable-${crqeTableIdParts[1]}-${crqeTableIdParts[2]} > tbody`;

            initializeElementsAndData(newRow, newRowID, container, row, true, rowParentRows, crqeRecord.Values);

            if (nestedRepeater.length)
            {
                newRow.appendTo(nestedRepeater);
            }
            else
            {
                newRow.appendTo(mainDiv.find(tableSelector));
            }

            skyward.events.applyLoadActionClass(newRow);

            skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(container);

            // TODO (5270635) test
            skyward.window.notifyDOMLoad('#' + newRow.attr("id"));

            $(crqeTableId).trigger('childrecordquickentry-row-added', [newRow]);
            maxNumberAdded(newRow);
        };

        var setCRQERecordValues = function (crqeRecordValues, element, elementId)
        {
            if (crqeRecordValues !== null && (element.is(':input:not(.codeEELCode,.codeEELDescription)') || element.hasClass("codeEEL")))
            {
                var crqeRecordValue = null;
                for (var value in crqeRecordValues)
                {
                    crqeRecordValue = null;
                    if (value.indexOf("_value") !== -1)
                    {
                        if ((element.hasClass("codeEELValue") || element.hasClass("codeEEL")) && elementId.indexOf(value.replace('_value', '')) !== -1)
                        {
                            crqeRecordValue = crqeRecordValues[value];
                            break;
                        }
                    }
                    else if ((elementId !== undefined && elementId !== null && elementId.indexOf(value) !== -1) || element.val() === crqeRecordValues[value])
                    {
                        crqeRecordValue = crqeRecordValues[value];
                        break;
                    }
                }

                if (crqeRecordValue !== null && crqeRecordValue !== undefined)
                {
                    if (element.hasClass("codeEEL"))
                    {
                        skyward.codeeel.setCodeEELValue(element, crqeRecordValue, true);
                    }
                    else if (element.is(":checkbox"))
                    {
                        crqeRecordValue = crqeRecordValue === "true";
                        skyward.controls.setValue(element, crqeRecordValue, true);
                    }
                    else if (element.is(":radio"))
                    {
                        var inputCheckbox = element;
                        var radioButtonGroup = inputCheckbox.parents('.radioButtonGroup');
                        if (radioButtonGroup.length)
                        {
                            if (element.val() === crqeRecordValue)
                            {
                                radioButtonGroup.find('input:checked').each(function (e, ele)
                                {
                                    $(ele).prop('checked', false);
                                });
                                skyward.controls.setValue(element, crqeRecordValue, true);
                            }
                        }
                        else
                        {
                            inputCheckbox.prop('checked', false);
                        }
                    }
                    else
                    {
                        skyward.controls.setValue(element, crqeRecordValue, true);
                    }
                }
            }
        };

        function groupHeaders(crqe)
        {
            const allCRQEs = crqe.find(".childrecordquickentry");
            const headers = crqe.find(":header");

            let scopedHeaders = headers.filter(function ()
            {
                // Check if this header is a descendant of any element in allCRQEs
                return allCRQEs.filter(function ()
                {
                    return $(this).has(this).length > 0;
                }).length === 0;
            });

            const crqeDepth = crqe.parents(".childrecordquickentry").length;
            const workflowOffset = crqe.parents(".workflowPopup").length > 0 ? 1 : 0;
            const baseLineHeaderNumber = 2;
            const depth = crqeDepth + workflowOffset;

            const expectedHeading = "H" + Math.min((Number(depth) + baseLineHeaderNumber), 6); // stop at h6
            scopedHeaders.each(function ()
            {
                const header = $(this);
                // If the header type was specifically specified, respect it.
                if (!header.is("H2"))
                {
                    return;
                }

                if (!header.is(expectedHeading))
                {
                    header.replaceTagNames(expectedHeading);
                }
            });
        }

        function setupButtonToBeResponsiveOnMobile(button)
        {
            skyward.window.registerLayoutResizeCallback(function ()
            {
                resizeResponsiveLegendHeader(button);
            });

            resizeResponsiveLegendHeader(button);
        }

        function resizeResponsiveLegendHeader(buttoncell)
        {
            const container = buttoncell.closest(".childrecordquickentryrow");
            const legendHeader = container.find(".legendHeader");
            if (!legendHeader.length || !buttoncell.length || !legendHeader.is(":visible") || !buttoncell.is(":visible"))
            {
                return;
            }

            const buttonText = buttoncell.find(".buttonText");
            buttonText.show();

            const legendHeaderPosition = legendHeader.position();

            setLegendHeaderMaxWidth();

            if (!isHeaderOverflowing())
            {
                return;
            }

            buttonText.hide();

            setLegendHeaderMaxWidth();

            function isHeaderOverflowing()
            {
                return legendHeader[0].clientWidth < legendHeader[0].scrollWidth;
            }

            function setLegendHeaderMaxWidth()
            {
                const buffer = 15;
                const buttoncellPosition = buttoncell.position();
                legendHeader.css({ maxWidth: `${buttoncellPosition.left - (legendHeaderPosition.left + buffer)}px` });
            }

        }

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        var updateNear = function ()
        {
            var element = $(this);

            $(".NearScreeningDistance").each(function ()
            {
                skyward.controls.setValue($(this), element.val());
            });
        };

        var updateFar = function ()
        {
            var element = $(this);

            $(".FarScreeningDistance").each(function ()
            {
                skyward.controls.setValue($(this), element.val());
            });
        };

        var updatePaFarScreeningDistance = function ()
        {
            var element = $(this);

            $(".FarVisualAcuityLeftEyeDistance").each(function ()
            {
                skyward.controls.setValue($(this), element.val());
            });
        };

        var updatePaNearScreeningDistance = function ()
        {
            var element = $(this);
            
            $(".NearVisualAcuityLeftEyeDistance").each(function ()
            {
                skyward.controls.setValue($(this), element.val());
            });
        };

        var init = function (selector)
        {
            $(selector + ' .FarVisionScreeningDistance').on('change', updateFar);
            $(selector + ' .NearVisionScreeningDistance').on('change', updateNear);
            $(selector + ' .FarVisualAcuityRightEyeDistance').on('change', updatePaFarScreeningDistance);
            $(selector + ' .NearVisualAcuityRightEyeDistance').on('change', updatePaNearScreeningDistance);
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(function (skyward, $, undefined)
{
    "use strict";

    skyward.iconifiedinputs = skyward.iconifiedinputs || {};
    skyward.iconifiedinputs.iconify = initIconifiedInputs;

    skyward.window.registerLoadDOMCallback(function (_selector)
    {
        initIconifiedInputs(this);
    });

    function initIconifiedInputs(element)
    {
        // Find stubbed <input.iconified> and corresponding svgs, wrap them with a button if necessary, and create backing-data and bindings
        $(element).find("input.iconifyme").each(function ()
        {
            var input = $(this);
            var icons = input.next("svg").next("svg").addBack();
            icons = icons.length ? icons : input.next("span").find("svg").next("svg").addBack();

            //Only iconify the input if we found a valid icon
            if (!icons.length)
            {
                return;
            }

            input.hide();

            // Inputs not rendered via viewpart CheckboxButton (i.e. Checkbox) will need to be wrapped in an anchor.
            var button = input.parent('.button.iconifyme');
            if (!button.length)
            {
                var rawButton = document.createElement("a");
                var classes = "button svgAnchor" + (icons.length === 2 ? " dual-icon" : "");
                rawButton.setAttribute("class", classes);
                rawButton.href = "javascript:void(0);";
                rawButton.setAttribute("aria-label", getRelatedLabelText(input));
                rawButton.tabIndex = input[0].tabIndex;
                button = $(rawButton);
                button.insertBefore(input);
                button.append([input, icons]);
            }

            input.removeClass("iconifyme").addClass("iconified");
            button.addClass("iconified-button")
                .toggleClass("checked", input.is(":checked"))
                .on("click", null, { input: input }, buttonClicked);
            
            if (input.hasClass("change-fill-color"))
            {
                input.removeClass("change-fill-color");
                button.addClass("change-fill-color");
            }

            var clickAction = input.attr("data-click-action");
            if (clickAction !== undefined)
            {
                input.removeAttr("data-click-action");
                button.attr("data-click-action", clickAction);
            }

            if (input.is(":disabled,[readonly],.ui-disabled"))
            {
                button.addClass("ui-disabled");
                button.prop("tabindex", "-1");
            }

            input.on("change deselect jschange", null, { button: button, name: input.attr("name") }, inputChanged);
        });
    }

    // Pass button clicks to hidden input element
    function buttonClicked(event)
    {
        var input = event.data.input;
        if (input.is(":disabled,[readonly],.ui-disabled"))
        {
            return;
        }

        if (input.is(":checked"))
        {
            // Cannot uncheck a checked radio by clicking it - must click another member of the RadioSet
            if (input.is("[type='checkbox']"))
            {
                input.prop("checked", false);
                // Here we have to manually trigger 'change' to simulate a "non-programmatic change"
                input.trigger("change");
            }
        }
        else
        {
            input.prop("checked", true);
            input.trigger("change");
        }
    }

    // Update button state, .checked or :not(.checked), when input changes
    // If a radio has just been checked, trigger "deselect" on related radios
    function inputChanged(event)
    {
        var input = $(this);
        if (input.is(":checked"))
        {
            event.data.button.addClass("checked");
            if (input.is("[type='radio']"))
            {
                $('input[name="' + event.data.name + '"]').not(input).trigger('deselect');
            }
        }
        else
        {
            event.data.button.removeClass("checked");
        }
    }

    function getRelatedLabelText(input)
    {
        // Find label text (for anchor alt-text, ADA compliance)
        var labelText = '';
        var controlId = input.attr("id");
        if (controlId)
        {
            var relatedLabel = input.siblings("label[for=" + controlId + "]");
            if (relatedLabel.length)
            {
                labelText = relatedLabel.text();
            }
        }
        return labelText;
    }

}(window.skyward = window.skyward || {}, window.jQuery));
;
/// <reference path="skyward.ui.window.ts" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.svg.ts" />
(
function (skyward, $, undefined)
{
    "use strict";
    skyward.fieldsearch = skyward.fieldsearch || {};
    skyward.fieldsearch.getpopup = function (callback)
    {
        var popup;
        var searchResults = { root: $("<ul/>") };
        var closedFolderSvg = skyward.svg.getSvg("ClosedFolderAlt", "TreeBrowse");
        var openFolderSvg = skyward.svg.getSvg("OpenFolderAlt", "TreeBrowse");

        var searchButton = $(this);
        var searchButtonData = searchButton.data();
        var initialInput = searchButton.closest(".js-treebrowse__fieldSearch")
                .find(".js-treebrowse__fieldSearchInput")
                .val();

        var elementData = new WeakMap();

        $.ajax(skyward.global.virtualDir + "Common/FieldSearcher/GetPopup",
        {
            type: "POST",
            dataType: "viewparthtml",
            data: searchButtonData,
            success: function(data)
            {
                var options = { width: "430px", closeOnClick: false };
                var popupButtons =
                [
                    { text: searchButtonData.saveText, "icon": "Select", additionalClasses: "selectField hidden", "click": selectField },
                    { text: "Close", "click": "close", "icon": "Close" }
                ];
                var selectedField = $();
                popup = skyward.modalLayer.showDialog(searchButtonData.dialogTitle, data, popupButtons, options);

                $.when(popup.bodyPromise).then(function ()
                {
                    var searchText = popup.content.find(".searchText");
                    searchText.focus();
                    searchText.val(initialInput);
                    searchText.on("keypress", function (event)
                    {
                        // enter key
                        if (event.which === 13)
                        {
                            performSearch();
                        }
                    });
                    popup.content.on("click", ".searchButton", null, function () { performSearch(); });
                    popup.content.on("dblclick", ".fieldSearchField", null, function ()
                    {
                        selectField();
                        return false;
                    });

                    var selectFieldButton = popup.container.find(".selectField");

                    var highlightField = function (field)
                    {
                        selectedField.children(".selectionLabel").removeClass("selected");
                        field.children(".selectionLabel").addClass("selected");
                        selectedField = field;
                        selectFieldButton.removeClass("hidden");
                    };

                    var expandCollapseFolder = function ()
                    {
                        var folder = $(this);
                        var svg = folder.children(".selectionLabel").find("svg.svgTreeBrowse");
                        if (folder.hasClass("fieldSearch-collapsed"))
                        {
                            folder.removeClass("fieldSearch-collapsed");
                            svg.replaceWith(openFolderSvg.clone());
                            var data = elementData.get(folder[0]);
                            if (!data.expanded)
                            {
                                searchResults.appendFolderChildren(data, folder[0].querySelector("ul"));
                            }
                        }
                        else
                        {
                            folder.addClass("fieldSearch-collapsed");
                            svg.replaceWith(closedFolderSvg.clone());
                        }

                        return false;
                    };

                    popup.content.on("click", ".fieldSearchField, .fieldSearchOneToMany:not(.noSelect)", null, function ()
                    {
                        highlightField($(this));
                        return false;
                    });

                    popup.content.on("dblclick", ".fieldSearchFolder, .fieldSearchOneToMany", null, expandCollapseFolder);

                    if (typeof initialInput === "string" && initialInput.length > 0)
                    {
                        performSearch();
                    }
                });

                function selectField()
                {
                    const data = $.extend(
                    {
                        moduleName: searchButtonData.startModule,
                        objectName: searchButtonData.startObject
                    },
                    elementData.get(selectedField[0]));

                    // Extract data for breadcrumbs back up to root object.
                    const foldersLeadingUpToRoot = selectedField.parentsUntil(".root").filter("li");
                    const foldersLeadingOutOfRoot = foldersLeadingUpToRoot.get().reverse();
                    const rootData = elementData.get(selectedField.closest(".root")[0]);
                    let positionObjectPath = rootData.fieldPath;
                    let displayPathText = rootData.displayName;

                    const breadcrumbData = [{
                        moduleName: rootData.moduleName,
                        objectName: rootData.objectName,
                        displayName: rootData.displayName,
                        positionObjectPath: rootData.fieldPath,
                        isOneToMany: (rootData.fieldType === "ManyToOne" ? false : true)
                    }];

                    foldersLeadingOutOfRoot.forEach(function (e)
                    {
                        const folderData = elementData.get(e);
                        positionObjectPath = positionObjectPath + "." + folderData.fieldPath;
                        displayPathText = displayPathText + " > " + folderData.displayName;
                        breadcrumbData.push(
                        {
                            moduleName: folderData.moduleName,
                            objectName: folderData.objectName,
                            fieldName: folderData.fieldPath,
                            displayName: folderData.displayName,
                            positionObjectPath: positionObjectPath,
                            isOneToMany: folderData.fieldType === "OneToMany"
                        });
                    });
                    data.breadcrumbData = breadcrumbData;
                    positionObjectPath = positionObjectPath + "." + data.fieldPath;
                    data.fieldPath = positionObjectPath;
                    data.fieldPathToParent = data.fieldPath.substring(0, data.fieldPath.lastIndexOf('.'));
                    data.positionObjectPath = positionObjectPath;
                    // This should be generating the same thing that FieldPresentationData.GetDisplayPathFromRelationshipPath() does
                    data.displayPathText = displayPathText + " > " + data.displayName;

                    popup.close();
                    if (typeof (callback) === "function")
                    {
                        callback(searchButtonData.controlToUpdate, data);
                    }
                }
            }
        });

        var performSearch = function ()
        {
            popup.container.find(".selectField").addClass("hidden");
            const textBox = popup.content.find(".searchText");
            const searchText = textBox.val();

            $.ajax(skyward.global.virtualDir + "Common/FieldSearcher/FindFields",
            {
                type: "POST",
                dataType: "JSON",
                data: $.extend({searchText:searchText}, searchButton.data()),
                success: function (fieldSearchResults)
                {
                    searchResults.root.remove();
                    if (fieldSearchResults === null)
                    {
                        textBox.attr('placeholder', 'No results found').val('');
                    }
                    else
                    {
                        searchResults = buildFieldList(fieldSearchResults);
                        searchResults.root.appendTo(popup.content);
                    }
                    popup.content.css("height", "auto");
                    popup.animateModalContents();
                }
            });
        };

        function buildFieldList(rootFolderData)
        {
            var totalRows = 0;

            // Arbitrary limit: having too many rows visible causes severe rendering delays in the browser
            var closedFolderRowThreshold = 1000;

            var rootFolder = $(buildFolder(rootFolderData));
            rootFolder.addClass("root");
            var root = $("<ul/>").append(rootFolder);

            var result =
            {
                root: root,
                appendFolderChildren: appendFolderChildren
            };
            return result;

            function appendFolderChildren(data, folderContents)
            {
                $.each(data.fields, function (i, fieldData)
                {
                    folderContents.appendChild(buildFieldListItem(fieldData, fieldTemplates));
                });
                totalRows += data.fields.length;
                data.fields = undefined;

                $.each(data.folders, function (i, folderData)
                {
                    var oneToManyListItem = buildFolder(folderData);
                    folderContents.appendChild(oneToManyListItem);
                });
                totalRows += data.folders.length;
                data.folders = undefined;

                $.each(data.oneToManyRelationships, function (i, oneToManyData)
                {
                    var oneToManyListItem = buildOneToMany(oneToManyData);
                    folderContents.appendChild(oneToManyListItem);
                });
                totalRows += data.oneToManyRelationships.length;
                data.oneToManyRelationships = undefined;

                data.expanded = true;
            }

            function buildOneToMany(oneToManyData)
            {
                var template = totalRows < closedFolderRowThreshold ? oneToManyTemplate : closedOneToManyTemplate;
                var oneToManyListItem = buildFolderListItem(oneToManyData, template);
                if (totalRows < closedFolderRowThreshold)
                {
                    appendFolderChildren(oneToManyData, oneToManyListItem.querySelector("ul"));
                }
                return oneToManyListItem;
            }

            function buildFolder(folderData)
            {
                var template = totalRows < closedFolderRowThreshold ? openFolderTemplate : closedFolderTemplate;
                var folderListItem = buildFolderListItem(folderData, template);
                if (totalRows < closedFolderRowThreshold)
                {
                    appendFolderChildren(folderData, folderListItem.querySelector("ul"));
                }
                return folderListItem;
            }

            function buildFolderListItem(folderData, folderTemplate)
            {
                var folderListItem = folderTemplate.cloneNode(true);

                folderListItem.querySelector(".fieldSearchLabel").textContent = folderData.displayName;
                elementData.set(folderListItem, folderData);
                return folderListItem;
            }

            function buildFieldListItem(fieldData, fieldTemplateCache)
            {
                var fieldListItem = fieldTemplateCache(fieldData.svgClass).cloneNode(true);
                var labelText = fieldData.displayName;
                if (fieldData.isCalculated || fieldData.isOperation)
                {
                    labelText += "*";
                }
                fieldListItem.querySelector(".fieldSearchLabel").textContent = labelText;

                elementData.set(fieldListItem, fieldData);
                return fieldListItem;
            }
        }

        var baseFolderTemplate = $(
            "<li class='fieldSearchFolder noSelect' >" +
                "<span class='selectionLabel'>" + 
                    "<span class='fieldSearchLabel noSelect'></span>" +
                "</span>" +
                "<ul />" +
            "</li>");
        var closedFolderTemplate = baseFolderTemplate.clone().addClass("fieldSearch-collapsed");
        closedFolderTemplate.find(".selectionLabel").prepend(closedFolderSvg.clone());
        closedFolderTemplate = closedFolderTemplate[0];
        var openFolderTemplate = baseFolderTemplate;
        openFolderTemplate.find(".selectionLabel").prepend(openFolderSvg.clone());
        openFolderTemplate = openFolderTemplate[0];

        var oneToManyTemplate = $(
            "<li class='fieldSearchOneToMany'>" +
                "<span class='selectionLabel'>" +
                    "<svg />" +
                    "<span class='fieldSearchLabel'></span>" +
                "</span>" +
                "<ul />" +
            "</li>");
        oneToManyTemplate.toggleClass("noSelect", !searchButtonData.allowSelectingOneToMany);
        oneToManyTemplate.find("svg").replaceWith(skyward.svg.getSvg("OneToMany", "TreeBrowse"));
        var closedOneToManyTemplate = oneToManyTemplate.clone().addClass("fieldSearch-collapsed")[0];
        oneToManyTemplate = oneToManyTemplate[0];

        var fieldListItemTemplate = $(
            "<li class='fieldSearchField'>" +
                "<span class='selectionLabel'>" +
                    "<svg />" +
                    "<span class='fieldSearchLabel'></span>" +
                "</span>" +
            "</li>");
        var fieldTemplates = skyward.extensions.createCache(function (svgClass)
        {
            var template = fieldListItemTemplate.clone();
            template.find("svg").replaceWith(skyward.svg.getSvg(svgClass, "TreeBrowse"));
            return template[0];
        });
    };
}(window.skyward = window.skyward || {}, window.jQuery)
);
;
///<reference path="skyward.base.global.ts"/>
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.calculatedFieldBuilder = skyward.calculatedFieldBuilder || {};

        // accepts args = { fieldName: string (optional),
        //                  expression: string(optional),
        //                  module: string(used for rooting the treebrowse),
        //                  object: string(used for rooting the treebrowse),
        //                  relationshipPath: string(used to prepend detail sections field names appropriately),
        //                  prompts: (required) Prompts Model so the cfBuilder can ask it to convert bindings to friendly names, and what prompts to present the user with
        //                  usedInExistsFilter: (required) if the calculated field is used in an exists condition
        //                  callback: function}
        skyward.calculatedFieldBuilder.launch = function (args)
        {
            let calculatedFieldBuilder;
            const promptsModel = args.prompts;
            if (!promptsModel || typeof promptsModel.toJsonObject !== 'function')
            {
                return;
            }
            const promptsJson = promptsModel.toJsonString();

            if (!args.fieldName) { args.fieldName = ''; }
            if (!args.expression) { args.expression = ''; }
            // accepts jsonResult = { html: html }
            var showPopup = function (jsonResult)
            {
                let popup;
                let nameValidationMessage;
                let nameLabel;
                let nameInput;
                let calculationValidationMessage;
                let calculationLabel;
                let calculationInput;

                var onSave = function ()
                {
                    const name = (nameInput.val() || "").trim(" ");
                    const nameIsBlank = !(name.length > 0);
                    const nameHasChanged = (args.fieldName != name);
                    const nameExists = nameHasChanged && skyward.reporting.calculatedFields.NameExists(name);
                    const nameIsNumeric = skyward.extensions.isNumeric(name);
                    const nameIsDangerous = skyward.extensions.containsHtml(name);
                    const nameIsNullLiteral = (name.toLowerCase() === "null");

                    const calculation = promptsModel.ConvertFriendlyNamesToPromptBindings(calculationInput.val());
                    const calculationIsBlank = !(calculation.length > 0);
                    const decodedCalculation = skyward.extensions.decodeHtml(calculation);
                    const calculationIsDangerous = decodedCalculation !== calculation;

                    let nameErrors = [];
                    if (nameIsBlank)
                    {
                        nameErrors.push("Name is a required field.");
                    }
                    if (nameExists)
                    {
                        nameErrors.push("This name is already in use.");
                    }
                    if (nameIsNumeric)
                    {
                        nameErrors.push("Name cannot be a number.");
                    }
                    if (nameIsDangerous)
                    {
                        nameErrors.push("Name contains invalid characters.");
                    }
                    if (nameIsNullLiteral)
                    {
                        nameErrors.push("Name cannot be 'null'.");
                    }

                    let calculationErrors = [];
                    if (calculationIsBlank)
                    {
                        calculationErrors.push("Calculation is a required field");
                    }
                    if (calculationIsDangerous)
                    {
                        calculationErrors.push("Calculation contains invalid characters.");

                        let indexOfFirstInvalidCharacter = 0;
                        while (calculation[indexOfFirstInvalidCharacter] === decodedCalculation[indexOfFirstInvalidCharacter])
                        {
                            indexOfFirstInvalidCharacter++;
                        }

                        if (indexOfFirstInvalidCharacter >= 0)
                        {
                            calculationInput.prop({ selectionStart: indexOfFirstInvalidCharacter, selectionEnd: indexOfFirstInvalidCharacter + 1 });
                        }
                        calculationInput.focus();
                    }

                    let errors = {};
                    const hasNameErrors = nameErrors.length > 0;
                    const hasCalculationErrors = calculationErrors.length > 0;
                    if (hasNameErrors)
                    {
                        errors["CustomFieldName"] = nameErrors;
                    }

                    if (hasCalculationErrors)
                    {
                        errors["CalculationInput"] = calculationErrors;

                    }

                    if (hasNameErrors || hasCalculationErrors)
                    {
                        skyward.validation.displayValidationMessages({ errors: errors }, calculatedFieldBuilder, $());
                        return;
                    }

                    nameInput.removeClass("error-control");
                    nameLabel.removeClass("error-text");
                    nameValidationMessage.hide();

                    calculationInput.removeClass("error-control");
                    calculationLabel.removeClass("error-text");
                    calculationValidationMessage.hide();

                    $.ajax(skyward.global.virtualDir + "Common/CalculatedFieldBuilder/GetOperation",
                        {
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                expression: skyward.extensions.decodeHtml(promptsModel.ConvertFriendlyNamesToPromptBindings(calculationInput.val())),
                                id: args.id,
                                schemaObject: args.schemaObject,
                                relationshipPath: args.relationshipPath,
                                currentPrompts: skyward.reporting.prompts.promptCollection.toJsonString()
                            }
                        }).done(function (data)
                        {
                            if (!data.syntaxError)
                            {
                                data.fieldName = nameInput.val();
                                data.schemaObject = args.schemaObject;
                                data.relationshipPath = args.relationshipPath;
                                data.parameters = JSON.parse(data.parameters);
                                args.callback(data);
                                popup.close();
                            }
                            else
                            {
                                const selectInvalidToken = function ()
                                {
                                    if (data.position != undefined)
                                    {
                                        calculationInput.prop({ selectionStart: data.position, selectionEnd: data.position + data.length });
                                    }
                                    calculationInput.focus();
                                };
                                skyward.modalLayer.showDialog("Syntax Error", data.syntaxError, { text: "Ok", click: "close", icon: "Check" }, { afterClose: selectInvalidToken });
                            }
                        });
                };


                const buttons = [
                    { text: "Save", click: onSave, icon: "Save", additionalClasses: "calculatedFieldBuilderSaveButton" },
                    { text: "Cancel", click: "close", icon: "Cancel" }
                ];
                popup = skyward.modalLayer.showDialog("Calculated Field Builder", jsonResult.html, buttons,
                    {
                        closeOnClick: false,
                        automationID: "calculated-field-dialog",
                        width: "100%"
                    });
                popup.bodyPromise.done(function ()
                {
                    calculatedFieldBuilder = popup.content;
                    nameInput = calculatedFieldBuilder.find(".customFieldName");
                    nameLabel = calculatedFieldBuilder.find(".calculatedFieldNameLabel");
                    nameValidationMessage = calculatedFieldBuilder.find(".calculatedFieldNameMessage");
                    calculationInput = calculatedFieldBuilder.find(".calculatedFieldTextArea");
                    calculationInput.val(promptsModel.ConvertPromptBindingsToFriendlyNames(calculationInput.val()));
                    calculationValidationMessage = calculatedFieldBuilder.find(".calculationValidationMessage");
                    calculationLabel = calculatedFieldBuilder.find(".calculationLabel");

                    calculatedFieldBuilder.find(".operatorButton, .functionButton, .promptButton, .envVarButton").on("dblclick", addOperator);
                    calculatedFieldBuilder.find(".cfbTab").on("click", function ()
                    {
                        const tab = $(this);
                        if (tab.hasClass("active"))
                        {
                            return;
                        }

                        calculatedFieldBuilder.find(".leftTabLabels .cfbTab.active").removeClass("active");
                        calculatedFieldBuilder.find(".leftTabbed:not(.hidden)").addClass("hidden");

                        tab.addClass("active");
                        calculatedFieldBuilder.find("." + tab.data().relatedDiv).removeClass("hidden");
                    });

                    let areafields = skyward.reporting.fields.buildFieldListByModuleAndObject(args.schemaObject, args.relationshipPath, true, true);
                    const panelData =
                        [{
                            selector: ".js-usedFieldsPanel",
                            fields: areafields,
                            buildFieldPath: true
                        }];
                    skyward.fieldselectionpanels.initializePanels(calculatedFieldBuilder, panelData, addFieldFromFieldPanel, null);

                    (nameInput.val() != "" ? calculationInput : nameInput).attr('autofocus', true).focus();
                });
            };

                $.ajax(skyward.global.virtualDir + "Common/CalculatedFieldBuilder/GetPopup",
                    {
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            fieldName: args.fieldName,
                            expression: skyward.extensions.decodeHtml(args.expression),
                            schemaObject: args.schemaObject,
                            relationshipPath: args.relationshipPath,
                            prompts: promptsJson,
                            usedInExistsFilter: args.usedInExistsFilter
                        }
                    }).done(showPopup);

                var addFieldFromFieldPanel = function (event, fieldData)
                {
                    const fullFieldName = fieldData === undefined ? undefined : fieldData.absoluteFieldPath;
                    const calculationInput = calculatedFieldBuilder.find(".calculatedFieldTextArea");
                    skyward.global.text.insertTextToken(calculationInput, "{" + fullFieldName + "}", true);
                };

                var addOperator = function ()
                {
                    const operatorButton = $(this);
                    const calculationInput = calculatedFieldBuilder.find(".calculatedFieldTextArea");
                    skyward.global.text.insertTextToken(calculationInput, promptsModel.ConvertPromptBindingsToFriendlyNames(operatorButton.data().token), true);
                };
            };
        }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.multiselectcolumnbuilder = skyward.multiselectcolumnbuilder || {};

        skyward.multiselectcolumnbuilder.launch = function (args)
        {
            ///<param name="args">{ fieldsToDisplayInfo : string, fieldPath : string, module : string, object : string, callback : function }</param>

            var showPopup = function (jsonResult)
            {
                ///<param name="jsonResult">{ html: html }</param>
                var popup;
                var promptFieldsToDisplay;

                var onSave = function ()
                {
                    var selectedItemStrings = [];
                    selectedItems.children().not(".selectedRowTemplate").each(function ()
                    {
                        var row = $(this);
                        selectedItemStrings.push(ConvertSelectedRowToString(row));
                    });

                    args.callback(selectedItemStrings.join());
                    popup.close();
                };

                var buttons = [{ text: "Save", click: onSave, icon: "Save", additionalClasses: "promptFieldsToDisplaySaveButton" }, { text: "Cancel", click: "close", icon: "Cancel" }];
                popup = skyward.modalLayer.showDialog("Fields To Display", jsonResult.html, buttons, { width: "953px", closeOnClick: false });

                var promptFieldsToDisplay = popup.content;
                var selectedItems = promptFieldsToDisplay.find(".selectedItemsTable tbody");
                var editorButtons = {
                    moveUp: promptFieldsToDisplay.find(".moveItem.up"),
                    moveDown: promptFieldsToDisplay.find(".moveItem.down"),
                    add: promptFieldsToDisplay.find(".addItem"),
                    remove: promptFieldsToDisplay.find(".removeItem")
                };
                var displayRadioButtonGroup = $("#selectedItemsDisplayRadio_RadioButtonGroup");

                displayRadioButtonGroup.on("change", displayChange);

                promptFieldsToDisplay.on("treeBrowseSave", addSelectedItem);
                promptFieldsToDisplay.on("treeBrowseRowChange", clickAvailableItem);
                selectedItems.children().on("click", clickSelectedItem);

                editorButtons.add.on("click", addSelectedItem);
                editorButtons.remove.on("click", removeSelectedItem);
                editorButtons.moveUp.on("click", moveSelectedItemUp);
                editorButtons.moveDown.on("click", moveSelectedItemDown);

                function displayChange()
                {
                    var displayValue = skyward.radioButtonGroup.getValue(displayRadioButtonGroup);
                    var fieldWidth = displayRadioButtonGroup.parents(".selectedItem ").find(".selectedItemsFieldWidth");

                    if (displayValue === "false")
                    {
                        fieldWidth.val("");
                        fieldWidth.prop("disabled", true);
                    }
                    else
                    {
                        fieldWidth.prop("disabled", false);
                        fieldWidth.val(fieldWidth.data().defaultwidth);
                    }
                }

                function clickAvailableItem()
                {
                    clearSelectedFromSelectedItems();

                    toggleButtons();
                }

                function clickSelectedItem()
                {
                    clearSelectedFromSelectedItems();
                    clearSelectedFromAvailableItems();

                    var selectedRow = $(this);
                    selectedRow.addClass("ui-selected");

                    toggleButtons();
                }

                function clearSelectedFromSelectedItems()
                {
                    selectedItems.find(".ui-selected").removeClass("ui-selected");
                }

                function clearSelectedFromAvailableItems()
                {
                    skyward.treebrowse.getTreeBrowseData(promptFieldsToDisplay).selectRecord(null);
                }

                function toggleButtons()
                {
                    var availableItemData = skyward.treebrowse.getSelectedFieldData(promptFieldsToDisplay);
                    var selectedItemsSelected = selectedItems.find(".ui-selected");
                    if (availableItemData)
                    {
                        setActiveButtons({
                            add: !availableItemData.isRelationship && !checkIfSelectedItemAlreadyAdded(selectedItems, availableItemData.absoluteFieldPath),
                            remove: false,
                            moveUp: false,
                            moveDown: false
                        });
                    }
                    else if (selectedItemsSelected.length > 0)
                    {
                        if (selectedItemsSelected.hasClass("distinctFieldRow"))
                        {
                            setActiveButtons({ add: false, remove: false, moveUp: false, moveDown: false });
                        }
                        else
                        {
                            setActiveButtons({
                                add: false,
                                remove: true,
                                moveUp: selectedItemsSelected.prevAll().not(".distinctFieldRow, .selectedRowTemplate").length > 0,
                                moveDown: selectedItemsSelected.next().length > 0
                            });
                        }
                    }
                    else
                    {
                        setActiveButtons({ add: false, remove: false, moveUp: false, moveDown: false });
                    }
                }

                function setActiveButtons(args)
                {
                    ///<param name="args">{add: bool, moveUp: bool, moveDown: bool, remove: bool}</param>

                    editorButtons.remove.toggleClass("ui-disabled", !args.remove);
                    editorButtons.add.toggleClass("ui-disabled", !args.add);
                    editorButtons.moveUp.toggleClass("ui-disabled", !args.moveUp);
                    editorButtons.moveDown.toggleClass("ui-disabled", !args.moveDown);
                }
                function moveSelectedItemUp()
                {
                    if (editorButtons.moveUp.hasClass('ui-disabled'))
                    {
                        return; // Button is disabled
                    }

                    var selectedRow = getSelectedRow(selectedItems);

                    if (selectedRow && selectedRow.length > 0)
                    {
                        var previousRow = selectedRow.prev(".selectedItem");

                        if (selectedRow.prev(".selectedItem").not(".selectedRowTemplate, .distinctFieldRow").length > 0)
                        {
                            selectedRow.detach().insertBefore(previousRow);
                            toggleButtons();
                        }
                    }
                }

                function moveSelectedItemDown()
                {
                    if (editorButtons.moveDown.hasClass('ui-disabled'))
                    {
                        return; // Button is disabled
                    }

                    var selectedRow = getSelectedRow(selectedItems);
                    if (selectedRow && selectedRow.length > 0)
                    {
                        var nextRow = selectedRow.next(".selectedItem");
                        if (nextRow.length > 0)
                        {
                            selectedRow.detach().insertAfter(nextRow);
                            toggleButtons();
                        }
                    }
                }

                function removeSelectedItem()
                {
                    if (editorButtons.remove.hasClass('ui-disabled'))
                    {
                        return; // Button is disabled
                    }

                    var selectedRow = getSelectedRow(selectedItems);
                    if (selectedRow && selectedRow.length > 0)
                    {
                        selectedRow.remove();

                        if (selectedItems.children().not(".selectedRowTemplate").length === 1)
                        {
                            skyward.radioButtonGroup.setValue(displayRadioButtonGroup, "true");
                            skyward.radioButtonGroup.disable(displayRadioButtonGroup);
                        }
                        toggleButtons();
                    }
                }

                function addSelectedItem()
                {
                    if (editorButtons.add.hasClass('ui-disabled'))
                    {
                        return; // Button is disabled
                    }

                    var selectedRowData = skyward.treebrowse.getSelectedFieldData(promptFieldsToDisplay);
                    if (selectedRowData)
                    {
                        if (checkIfSelectedItemAlreadyAdded(selectedItems, selectedRowData.absoluteFieldPath))
                        {
                            return;
                        }

                        if (selectedItems.children().not(".selectedRowTemplate").length === 1)
                        {
                            skyward.radioButtonGroup.enable(displayRadioButtonGroup);
                        }

                        selectedItems.append(createSelectedItemRow(selectedRowData));
                        toggleButtons();
                    }
                }

                function checkIfSelectedItemAlreadyAdded(selectedItems, selectedFieldName)
                {
                    return selectedItems.find(".fieldNameColumn[data-fieldname=\"" + selectedFieldName + "\"]").not(".selectedRowTemplate").length > 0;
                }

                function createSelectedItemRow(availableItemData)
                {
                    var fieldPath = availableItemData.absoluteFieldPath;
                    var displayText = availableItemData.displayPathText;
                    var width = availableItemData.fieldWidth;

                    var newSelectedItem = selectedItems.find(".selectedRowTemplate").clone(true);
                    newSelectedItem.removeClass("selectedRowTemplate");

                    var fieldNameColumn = newSelectedItem.find(".fieldNameColumn");
                    fieldNameColumn.data().fieldname = fieldPath;
                    fieldNameColumn.attr("data-fieldname", fieldPath);

                    newSelectedItem.find(".selectedItemsFieldName .buttonText").text(displayText);

                    newSelectedItem.find(".selectedItemsFieldWidth").val(width);

                    newSelectedItem.show();
                    return newSelectedItem;
                }

                function getSelectedRow(editor)
                {
                    var selectedRow = editor.find(".selected").parent();
                    if (selectedRow.length > 0)
                    {
                        return selectedRow;
                    }
                    else
                    {
                        selectedRow = editor.find(".ui-selected");
                        if (selectedRow.length > 0)
                        {
                            return selectedRow;
                        }
                    }
                    return null;
                }

                function ConvertSelectedRowToString(row)
                {
                    var fieldNameColumn = row.find(".fieldNameColumn");
                    var fieldNameColumnData = fieldNameColumn.data();
                    var widthInput = row.find(".selectedItemsFieldWidth");
                    var widthInputValue = widthInput.val();
                    var displayInput = row.find("#selectedItemsDisplayRadio_RadioButtonGroup");

                    var rowString = fieldNameColumnData.fieldname;

                    if (displayInput.length > 0)
                    {
                        var displayValue = skyward.radioButtonGroup.getValue(displayInput);
                        if (displayValue === "false" || displayValue === "False")
                        {
                            rowString += " hide";
                            return rowString;
                        }
                    }

                    if (widthInputValue.length > 0)
                    {
                        rowString += " " + widthInputValue;
                    }

                    return rowString;
                }
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Reporting/Report/GetMultiSelectColumnBuilder",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        fieldsToDisplayInfo: args.fieldsToDisplayInfo,
                        distinctFieldPath: args.fieldPath,
                        treeBrowseModule: args.module,
                        treeBrowseObject: args.object
                    }
                }).done(showPopup);
        };

    }(window.skyward = window.skyward || {}, window.jQuery));;
(
    function (skyward, $, undefined)
    {
        skyward.scheduling = skyward.scheduling || {};

        var init = function (selector)
        {
            var courseDetails = $(selector).find('#editCourse');
            if (courseDetails && courseDetails[0])
            {
                var isRequiredCheckbox = courseDetails.find('#editCourse_IsRequired');

                if (isRequiredCheckbox && isRequiredCheckbox[0])
                {
                    $(isRequiredCheckbox[0]).off('change', skyward.scheduling.redefaultSchedulingPriority);
                    $(isRequiredCheckbox[0]).on('change', skyward.scheduling.redefaultSchedulingPriority);
                }
            }

            var setPrimaryClicked = function (e)
            {
                $("#SelectSubjects").find($('[id*="SetPrimary-"]')).each(function (index, element)
                {
                    if (e.target !== element && $(element).prop("checked"))
                    {
                        skyward.controls.setValue($(element), false);
                    }
                });
            };

            var selectBoxChanged = function (e)
            {
                var elementName = $(e.target).attr("name");
                var nameSplit = elementName.split("-");
                var nameID = nameSplit[0];
                var elementID = nameSplit[1];

                var primaryElement = $("#SelectSubjects #SetPrimary-" + elementID);
                skyward.controls.toggle(primaryElement, $(e.target).prop("checked"));

                if (!$(e.target).prop("checked") && primaryElement.prop("checked"))
                {
                    $("#SelectSubjects").find($('[id*="SetPrimary-"]')).each(function (index, element)
                    {
                        if (!$(element).prop("checked") && !$(element).hasClass("ui-disabled"))
                        {
                            $(element).click();
                            return false;
                        }
                        if ($(element).prop("checked"))
                        {
                            skyward.controls.setValue($(element), false);
                        }
                    });
                }
            };

            var massUpdateCourseLengthSelectCourseToUpdateEventHandler = function (event)
            {
                var target = event.target;
                if (target && target.id)
                {
                    if (target.id.split("-")[0] === "SelectedTempCourseID")
                    {
                        var tempCourseID = target.id.split("-")[1];
                        var newCourseLengthCodeEELcode = $("#NewCourseLengthIDCodeEEL-" + tempCourseID + "_code");

                        if (newCourseLengthCodeEELcode && newCourseLengthCodeEELcode[0])
                        {
                            if (target.checked)
                            {
                                newCourseLengthCodeEELcode.focus();
                            }
                        }
                    }
                }
            };

            var walkInIgnoredChanged = function (event)
            {
                var target = event.target;
                if (target && target.id)
                {
                    if (target.id === "StudentCourseRequestsToIgnore_CheckAll")
                    {
                        event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
                    }
                    else if (target.id.split("-")[0] === "IgnoredStudentCourseRequest")
                    {
                        var ignoredID = target.id.split("-")[1];
                        var partnerElement = $(this).closest("tr").find("#UnscheduledStudentCourseRequest-" + ignoredID);  //grab sibling

                        if (partnerElement && partnerElement[0])
                        {
                            if (target.checked)
                            {
                                partnerElement.data('checkedBeforeIgnore', skyward.controls.getValue(partnerElement).toString());
                                skyward.controls.disable(partnerElement);
                                skyward.controls.setValue(partnerElement, "true");  //want event to happen so change event skyward.dataobjectviewer.updateCustomSaveData fires
                            }
                            else
                            {
                                skyward.controls.setValue(partnerElement, partnerElement.data('checkedBeforeIgnore')); //want event to happen so change event skyward.dataobjectviewer.updateCustomSaveData fires
                                skyward.controls.enable(partnerElement);
                            }
                        }
                    }
                }
            };

            var estimatedNumberOfSectionsBlurEventHandler = function (event)
            {
                var target = event.target;
                var input = $(this);
                if (target && target.id)
                {
                    if (target.id.split("-")[0] === "EstimatedNumberOfSections")
                    {
                        var tempCourseID = target.id.split("-")[1];
                        var estimatedSections = target.value;
                        var avgPerSectionElement = $(this).closest("tr").find("#EstimatedStudentsPerSection-" + tempCourseID);

                        if (avgPerSectionElement && avgPerSectionElement[0])
                        {
                            var numberOfCourseRequests = $(this).closest("tr").find("#NumberOfCourseRequests-" + tempCourseID);
                            var numberOfCourseRequestsValue = numberOfCourseRequests.val();

                            if (skyward.extensions.isNumeric(target.value) && estimatedSections > 0)
                            {
                                if (skyward.extensions.isNumeric(estimatedSections) && skyward.extensions.isNumeric(numberOfCourseRequestsValue))
                                {
                                    var avgPerSectionValue = parseFloat(numberOfCourseRequestsValue / estimatedSections).toFixed(2);
                                    avgPerSectionElement.val(avgPerSectionValue);
                                }
                            }
                            else
                            {
                                avgPerSectionElement.val(parseFloat(numberOfCourseRequestsValue).toFixed(2));
                                target.value = 1;
                            }
                        }
                    }
                }
            };

            var restoreCheckBoxesChanged = function (event)
            {
                var target = event.target;
                if (target && target.id)
                {
                    if (target.id === "TempStudentCourseRequestToReactivateIDToSchedule_CheckAll")
                    {
                        event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
                        if (target.checked)
                        {
                            skyward.controls.setValue($("#TempStudentCourseRequestToReactivateIDToRequest_CheckAll"), "false");
                        }
                    }
                    else if (target.id === "TempStudentCourseRequestToReactivateIDToRequest_CheckAll")
                    {
                        event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
                        if (target.checked)
                        {
                            skyward.controls.setValue($("#TempStudentCourseRequestToReactivateIDToSchedule_CheckAll"), "false");
                        }
                    }
                    else if (target.checked)
                    {
                        var pieces = target.id.split("-");
                        var rowPK = pieces[1];
                        var partnerElement;

                        if (pieces[0] === "TempStudentCourseRequestToReactivateIDToRequest")
                        {
                            partnerElement = $(this).closest("tr").find("#TempStudentCourseRequestToReactivateIDToSchedule-" + rowPK);
                        }
                        else if (pieces[0] === "TempStudentCourseRequestToReactivateIDToSchedule")
                        {
                            partnerElement = $(this).closest("tr").find("#TempStudentCourseRequestToReactivateIDToRequest-" + rowPK);
                        }

                        if (partnerElement && partnerElement[0])
                        {
                            skyward.controls.setValue(partnerElement, "false");
                        }
                    }
                }
            };

            if ($("#SelectSubjects").find($('[id*="SetPrimary-"]').length > 0))
            {
                $("#SelectSubjects").find($('[id*="SetPrimary-"]')).each(function (index, element)
                {
                    $(element).on("click", setPrimaryClicked);
                });
            }

            if ($("#SelectSubjects").find($('[id*="SelectSubject-"]').length > 0))
            {
                $("#SelectSubjects").find($('[id*="SelectSubject-"]')).each(function (index, element)
                {
                    $(element).on("change", selectBoxChanged);
                });
            }

            var requestRescheduleRestoreBrowse = $(selector).find('#SelectStudentCourseRequestsToReactivate');
            if (requestRescheduleRestoreBrowse && requestRescheduleRestoreBrowse[0])
            {
                requestRescheduleRestoreBrowse.off('change', "input", null, restoreCheckBoxesChanged);
                requestRescheduleRestoreBrowse.on('change', "input", null, restoreCheckBoxesChanged);
            }

            var walkInIgnoreUnscheduleBrowse = $(selector).find('#BrowseStudentCourseRequests');
            if (walkInIgnoreUnscheduleBrowse && walkInIgnoreUnscheduleBrowse[0])
            {
                walkInIgnoreUnscheduleBrowse.off('change', "input", null, walkInIgnoredChanged);
                walkInIgnoreUnscheduleBrowse.on('change', "input", null, walkInIgnoredChanged);
            }

            var updateEstimatedNumberOfSections = $(selector).find('#UpdateEstimatedNumberOfSectionsBrowseTempCourses');
            if (updateEstimatedNumberOfSections && updateEstimatedNumberOfSections[0])
            {
                updateEstimatedNumberOfSections.off('blur', "input", null, estimatedNumberOfSectionsBlurEventHandler);
                updateEstimatedNumberOfSections.on('blur', "input", null, estimatedNumberOfSectionsBlurEventHandler);
            }

            var scrQuickEntryWorkflowQuickEntry = $(selector).find('#SchedulingGroupQuickEntry');
            if (scrQuickEntryWorkflowQuickEntry && scrQuickEntryWorkflowQuickEntry[0])
            {
                quickAddButton = scrQuickEntryWorkflowQuickEntry.find('#SchedulingGroupQuickAddCourses');

                if (quickAddButton && quickAddButton[0])
                {
                    quickAddButton.off('click', skyward.scheduling.quickentryschedulinggroupintoquickentry);

                    var schedulingGroupCodeEel = scrQuickEntryWorkflowQuickEntry.find('#SchedulingGroupID');
                    var quickAddScope = $(selector).find('#StudentCourseRequestQuickEntry');
                    var quickEntryAddAnotherButton = undefined;
                    if (quickAddScope && quickAddScope[0])
                    {
                        quickEntryAddAnotherButton = quickAddScope.find('div.childrecordquickentryadddiv>a');
                    }

                    if (schedulingGroupCodeEel && schedulingGroupCodeEel[0] && quickEntryAddAnotherButton && quickEntryAddAnotherButton[0])
                    {
                        quickAddButton.on('click', { schedulingGroupCodeEel: schedulingGroupCodeEel, quickAddScope: quickAddScope, addAnotherButton: quickEntryAddAnotherButton }, skyward.scheduling.quickentryschedulinggroupintoquickentry);
                    }
                }
            }

            var massUpdateCourseLength = $(selector).find('#MassUpdateCourseLengthTempCoursesBrowse');
            if (massUpdateCourseLength && massUpdateCourseLength[0])
            {
                massUpdateCourseLength.off('change', "input", null, massUpdateCourseLengthSelectCourseToUpdateEventHandler);
                massUpdateCourseLength.on('change', "input", null, massUpdateCourseLengthSelectCourseToUpdateEventHandler);
            }

            var addSubstituteAssignmentDiv = $(selector).find('#AddSubstituteAssignmentDiv');
            if (addSubstituteAssignmentDiv.length > 0)
            {
                var startDate = addSubstituteAssignmentDiv.find('#StartDate');
                var endDate = addSubstituteAssignmentDiv.find('#EndDate');
                var staff = addSubstituteAssignmentDiv.find('#SourceStaffID_value');
                var sections = addSubstituteAssignmentDiv.find('#SelectedSectionIDs');
                var excludeAssignedSections = addSubstituteAssignmentDiv.find('#ExcludeAssignedSections');
                var calendar = addSubstituteAssignmentDiv.find('#CalendarID_value');
                var applyAllButton = addSubstituteAssignmentDiv.find('#btnApplyToUnassignedSections');
                var clearAllButton = addSubstituteAssignmentDiv.find('#btnClearSections');
                startDate.on('change', updateTempSubstituteAssignments);
                endDate.on('change', updateTempSubstituteAssignments);
                staff.on('change', updateTempSubstituteAssignments);
                sections.on('change', updateTempSubstituteAssignments);
                calendar.on('change', updateTempSubstituteAssignments);
                excludeAssignedSections.on('change', updateTempSubstituteAssignments);
                applyAllButton.on('click', applySubstituteSettingsToUnassignedSections);
                clearAllButton.on('click', clearSubstituteSettingsAllSections);
            }

            var massUpdateStaffForMeetsDiv = $(selector).find('#MassUpdateStaffForMeetsDiv');
            if (massUpdateStaffForMeetsDiv.length > 0)
            {
                var massChangeEndDate = massUpdateStaffForMeetsDiv.find('#EndDate');
                // #EndDate is now the sky-datepicker wrapper, not the input; blur doesn't bubble up from the
                // inner input (and wouldn't fire on a calendar pick), so use the wrapper's bubbling change event.
                massChangeEndDate.on('change', massChangeEndDateBlurEvent);
            }
        };

        var massChangeEndDateBlurEvent = function ()
        {
            var massUpdateStaffForMeetsDiv = $(this).parents('#MassUpdateStaffForMeetsDiv');

            var newEndDate = massUpdateStaffForMeetsDiv.find('#EndDate');
            var newEndDateValue = new Date(skyward.controls.getValue(newEndDate));

            if (newEndDateValue && newEndDateValue.isValidDate())
            {
                var newStartDate = massUpdateStaffForMeetsDiv.find('#StartDate');

                var oldStartDate = new Date(skyward.controls.getValue(newStartDate));
                var oldStartDateValue = (oldStartDate.getMonth() + 1).toString().padLeft(2, '0') + '/' + oldStartDate.getDate().toString().padLeft(2, '0') + '/' + oldStartDate.getFullYear();

                var newEndDatePlusOne = new Date(newEndDateValue);
                newEndDatePlusOne.setDate(newEndDatePlusOne.getDate() + 1);

                var newStartDateValue = (newEndDatePlusOne.getMonth() + 1).toString().padLeft(2, '0') + '/' + newEndDatePlusOne.getDate().toString().padLeft(2, '0') + '/' + newEndDatePlusOne.getFullYear();

                if (newStartDateValue !== oldStartDateValue)
                {
                    skyward.controls.setValue(newStartDate, newStartDateValue);
                }
            }
        };

        var updateTempSubstituteAssignments = skyward.debounce(function ()
        {
            var addSubstituteAssignmentDiv = $(this).parents('#AddSubstituteAssignmentDiv');

            var startDate = addSubstituteAssignmentDiv.find('#StartDate');
            var endDate = addSubstituteAssignmentDiv.find('#EndDate');
            var staff = addSubstituteAssignmentDiv.find('#SourceStaffID');
            var calendar = addSubstituteAssignmentDiv.find('#CalendarID');
            var sections = addSubstituteAssignmentDiv.find('#SelectedSectionIDs .dmsBackingData');

            var startDateValue = startDate.val();
            var endDateValue = endDate.val();
            var staffValue = skyward.controls.getValue(staff);
            var calendarValue = skyward.controls.getValue(calendar);
            var sectionValues = JSON.stringify(skyward.controls.getValue(sections));

            if (startDateValue !== null && endDateValue !== null && staffValue !== null && staffValue.length > 0)
            {
                var tempTableGuid = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenTableName'));
                var entityID = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenEntityID'));
                var schoolYearID = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenSchoolYearID'));
                var excludeAssignedSections = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#ExcludeAssignedSections'));

                $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StaffMeet/UpdateTempSubstituteAssignments",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        tempTableName: tempTableGuid,
                        startDate: startDateValue.toString(),
                        endDate: endDateValue.toString(),
                        sourceStaffID: staffValue,
                        entityID: entityID,
                        schoolYearID: schoolYearID,
                        excludeAssignedSections: excludeAssignedSections,
                        calendarID: calendarValue,
                        selectedSectionIDs: sectionValues
                    },
                    success: function (response)
                    {
                        if (response.success)
                        {
                            skyward.browse.get("TempSubstituteAssignments", {});
                        }
                        else
                        {
                            var baseErrorContainer = addSubstituteAssignmentDiv.find('#baseWorkflowErrorContainer');
                            if (!baseErrorContainer.text())
                            {
                                skyward.validation.displayValidationMessages(response, addSubstituteAssignmentDiv, baseErrorContainer, null, null);
                            }
                        }
                    }
                });
            }
        }, 200);

        var applySubstituteSettingsToUnassignedSections = function ()
        {
            var addSubstituteAssignmentDiv = $(this).parents('#AddSubstituteAssignmentDiv');

            var hasGradebookAccess = addSubstituteAssignmentDiv.find('#HasGradebookAccess');
            var hasAttendanceAccess = addSubstituteAssignmentDiv.find('#HasAttendanceAccess');
            var isLongTermSubstitute = addSubstituteAssignmentDiv.find('#IsLongTermSubstitute');
            var hasConferenceAccess = addSubstituteAssignmentDiv.find('#HasConferenceAccess');
            var substituteStaff = addSubstituteAssignmentDiv.find('#SubstituteStaffID');
            var excludeFromStateReporting = addSubstituteAssignmentDiv.find('#ExcludeFromStateReporting');
            var isTSDLExclusion = addSubstituteAssignmentDiv.find('#IsTSDLExclusion');
            var substituteTeacherIndicator = addSubstituteAssignmentDiv.find('#SubstituteStateTeacherIndicatorWAID');
            var isInstructionalStaff = addSubstituteAssignmentDiv.find('#IsSubstituteInstructionalStaff');
            var doNotSendToEdFi = addSubstituteAssignmentDiv.find('#DoNotSendToEdFi');

            var hasGradebookAccessValue = skyward.controls.getValue(hasGradebookAccess);
            var hasAttendanceAccessValue = skyward.controls.getValue(hasAttendanceAccess);
            var isLongTermSubstituteValue = skyward.controls.getValue(isLongTermSubstitute);
            var hasConferenceAccessValue = skyward.controls.getValue(hasConferenceAccess);
            var substituteStaffValue = skyward.controls.getValue(substituteStaff);

            if (doNotSendToEdFi)
            {
                var doNotSentToEdFiValue = skyward.controls.getValue(doNotSendToEdFi);
            }

            if (excludeFromStateReporting)
            {
                var excludeFromStateReportingValue = skyward.controls.getValue(excludeFromStateReporting);
            }

            if (isTSDLExclusion)
            {
                var isTSDLExclusionValue = skyward.controls.getValue(isTSDLExclusion);
            }

            if (substituteTeacherIndicator)
            {
                var substituteIsInstructionalStaffValue = skyward.controls.getValue(isInstructionalStaff);
                if (substituteIsInstructionalStaffValue)
                {
                    var substituteTeacherIndicatorValue = skyward.controls.getValue(substituteTeacherIndicator);
                }
            }

            if (substituteStaffValue !== null && substituteStaffValue.length > 0)
            {
                var tempTableGuid = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenTableName'));
                var entityID = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenEntityID'));
                var schoolYearID = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenSchoolYearID'));

                $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StaffMeet/ApplySubstituteSettingsToUnassignedSections",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        tempTableName: tempTableGuid,
                        substituteStaffID: substituteStaffValue,
                        substituteTeacherIndicatorID: substituteTeacherIndicatorValue,
                        substituteIsInstructionalStaff: substituteIsInstructionalStaffValue,
                        hasGradebookAccess: hasGradebookAccessValue,
                        hasAttendanceAccess: hasAttendanceAccessValue,
                        isLongTermSubstitute: isLongTermSubstituteValue,
                        hasConferenceAccess: hasConferenceAccessValue,
                        excludeFromStateReporting: excludeFromStateReportingValue,
                        isTSDLExclusion: isTSDLExclusionValue,
                        doNotSendToEdFi: doNotSentToEdFiValue,
                        entityID: entityID,
                        schoolYearID: schoolYearID
                    },
                    success: function (response)
                    {
                        if (response.success)
                        {
                            skyward.browse.get("TempSubstituteAssignments", {});
                        }
                        else
                        {
                            var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                            if (!baseErrorContainer.text())
                            {
                                skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                            }
                        }
                    }
                });
            }
        };

        var clearSubstituteSettingsAllSections = function ()
        {
            var addSubstituteAssignmentDiv = $(this).parents('#AddSubstituteAssignmentDiv');
            var tempTableGuid = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenTableName'));

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StaffMeet/ClearSubstituteSettingsAllSections",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    tempTableName: tempTableGuid
                },
                success: function (response)
                {
                    if (response.success)
                    {
                        $(document).one("browseLoaded.TempSubstituteAssignments", cleanUpSubAssignmentsBrowse);
                        skyward.browse.get("TempSubstituteAssignments", {});
                    }
                }
            });
        };

        var cleanUpSubAssignmentsBrowse = function ()
        {
            $("#TempSubstituteAssignments").find($('[id*="SubstituteStaffID-"]')).each(function (index, element)
            {
                if (element.value != "")
                {
                    skyward.controls.setValue($(element), "");
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="HasGradebookAccess-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="HasAttendanceAccess-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="IsLongTermSubstitute-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="HasConferenceAccess-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="IsInstructionalStaff-"]')).each(function (index, element)
            {
                if (element.checked)
                {
                    skyward.controls.setValue($(element), false);
                }
            });
            $("#TempSubstituteAssignments").find($('[id*="StateTeacherIndicatorWAID-"]')).each(function (index, element)
            {
                skyward.controls.clearValue($(element));
            });
        }

        skyward.scheduling.displayStaffMeetAssignmentConflictPopup = function ()
        {
            var button = $(this);
            var tempStaffMeetID = button.data().id;
            var massUpdateStaffForMeetsDiv = $('#MassUpdateStaffForMeetsDiv');
            var tempTableGuid = skyward.controls.getValue(massUpdateStaffForMeetsDiv.find('#HiddenTableName'));

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StaffMeet/DisplayStaffMeetAssignmentConflictInformation/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { TempStaffMeetID: JSON.stringify(tempStaffMeetID), tempTableName: tempTableGuid }
                });
            };

            var popupTitle = "Conflict Information";
            skyward.modalLayer.showDialog(popupTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button });
        };

        skyward.scheduling.displaySubstituteAssignmentConflictPopup = function ()
        {
            var button = $(this);
            var tempSubstituteAssignmentID = button.data().id;
            var addSubstituteAssignmentDiv = $('#AddSubstituteAssignmentDiv');
            var tempTableGuid = skyward.controls.getValue(addSubstituteAssignmentDiv.find('#HiddenTableName'));

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Scheduling/StaffMeet/DisplaySubstituteAssignmentConflictInformation/",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: { TempSubstituteAssignmentID: JSON.stringify(tempSubstituteAssignmentID), tempTableName: tempTableGuid }
                });
            };

            var popupTitle = "Conflict Information";
            skyward.modalLayer.showDialog(popupTitle, buildPopup, { text: "Ok", icon: "Check" }, { anchorTo: button });
        };

        skyward.scheduling.redefaultSchedulingPriority = function ()
        {
            var schedulingPriorityCombobox = $('#editCourse_SchedulingPriorityCode');

            if (schedulingPriorityCombobox)
            {
                if (this.checked)
                {
                    schedulingPriorityCombobox.val(6);
                    schedulingPriorityCombobox.change();
                }
                else
                {
                    schedulingPriorityCombobox.val(3);
                    schedulingPriorityCombobox.change();
                }
            }
        };

        skyward.scheduling.newAnalysisTab = function ()
        {
            skyward.window.loadContent('popout', "Scheduling", "StudentAutoSchedulerRunAnalysis", "Details", skyward.controls.getValue($("#StudentAutoSchedulerRunAnalysisID")));
        };

        skyward.scheduling.quickentryschedulinggroupintoquickentry = function (event)
        {
            var codeEelValue = skyward.controls.getValue(event.data.schedulingGroupCodeEel);
            var quickAddScope = event.data.quickAddScope;
            var quickAddButton = event.data.addAnotherButton;

            if (codeEelValue)
            {
                var url = skyward.global.virtualDir + 'Scheduling/SchedulingGroup/GetCourseIDsForSchedulingGroup/' + codeEelValue;
                $.ajax(
                    {
                        url: url,
                        type: "POST",
                        dataType: "JSON",
                        success: function (data)
                        {
                            $.each(data, function (index, courseID)
                            {
                                var lastQuickEntryRow = getLastSCRQuickEntryTemplateRow(quickAddScope);
                                if (lastQuickEntryRow)
                                {
                                    var courseCodeEel = getSCRCourseCodeEel(lastQuickEntryRow);
                                    if (courseCodeEel)
                                    {
                                        var courseCodeEelValue = skyward.controls.getValue(courseCodeEel);

                                        if (courseCodeEelValue)
                                        {
                                            quickAddButton.click();
                                            skyward.controls.setValue(getSCRCourseCodeEel(getLastSCRQuickEntryTemplateRow(quickAddScope)), courseID);
                                        }
                                        else
                                        {
                                            skyward.controls.setValue(courseCodeEel, courseID);
                                            quickAddButton.click();
                                        }
                                    }
                                }
                            });
                        }
                    });
            }
        };

        var getLastSCRQuickEntryTemplateRow = function (scope)
        {
            return scope.find('tr.childrecordquickentryrow').filter(':last'); // Class of the TR for a given row of the table-based template
        };

        var getSCRCourseCodeEel = function (scope)
        {
            return scope.find('input.coursecodeeel').parent(); // CodeEel within ChildRecordQuickEntry only puts the class names on the input for the Value of the code eel.  We want the containing Div that "is" the code eel...
        };

        var massPrintStudentScheduleStaffSortPeriodPopup = function (event)
        {
            var button = $(this);
            var title = 'More Information';
            var options =
            {
                anchorTo: button,
                id: "MassPrintStudentScheduleStaffSortPeriodPopup"
            };

            var message = '<p><span class="boldFont">Group Schedules by Period</span><br/>' +
                'Select the Display Period used to group the printed schedules. Students sharing the same teacher during this period will be printed together.</p><br/>' +

                '<p><span class="boldFont">Override Schedule Dates For Teacher</span><br/>' +
                'By default, the <span class="boldFont">Schedule Start Date</span>  and <span class="boldFont">Schedule End Date</span> are used to identify the active primary teacher for the designated period. ' +
                'Check this option and use the <span class="boldFont">Start Date Override</span> and <span class="boldFont">End Date Override</span> fields to specify a separate date range for teacher selection. ' +
                'In the event a student has multiple active teachers within this timeframe, the system prioritizes teachers who are currently active, ' +
                'followed by the student\'s most recent class enrollment date, then the teacher\'s most recent assignment date.</p><br/>' +

                '<p class="italicFont">Example: If Display Period 1 is selected, all students sharing the same active teacher during that period for the given dates will have their schedules printed together, sorted alphabetically by student name.</p>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var restrictSchedulingBeyondSectionCapacityInformationPopup = function(event)
        {
            var button = $(this);
            var title = 'Restrict Scheduling Beyond Section Capacity';
            var options =
            {
                anchorTo: button,
                id: "RestrictSchedulingBeyondSectionCapacityInformationPopup"
            };

            var message = '<div class="boldFont">When enabled:</div>' +
                '<div>Only users in the selected security groups who have scheduling permissions can place students into sections that exceed the maximum seat capacity. Super users are not affected by this setting and can always schedule students into sections beyond the maximum seat capacity, regardless of whether they are part of the selected security groups.</div>' +
                '<div class="boldFont" style="margin-top:8px;">When disabled:</div>' +
                '<div>Any user with scheduling permissions can place students into sections that exceed the maximum seat capacity.</div>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var massAutoSchedulerAlternateRequestPopup = function (event)
        {
            var button = $(this);
            var title = 'More Information';
            var options =
            {
                anchorTo: button,
                id: "MassAutoSchedulerAlternateRequestPopup"
            };

            var message = '<div class="boldFont">Do Not Process Alternate Requests</div>' +
                '<div>By selecting this option, the Mass Student Scheduler WILL NOT process the students\' alternate requests\n to fill in any gaps they may have on their schedules.\n\n</div>' +

            '<div class="boldFont">Process Alternates After All Regular Requests</div>' +
            '<div>When this option is selected, the Mass Student Scheduler will process students\' alternate requests after \ncompleting all regular requests for the included students. ' +
            'It processes every student\'s regular course \nrequests, then moves on to alternate requests to fill any remaining gaps. This approach gives students the \nbest chance of ' +
            'getting their preferred courses but may result in more schedules with open periods.\n\n</div>' +

            '<div class="italicFont">Example: Two students have been selected to run in the Mass Student Scheduler with the option to Process \nAlternates After All Regular Requests. The system begins with the ' +
            'first student, processing all his regular \ncourse requests. After completing their requests, it moves on to the second student and processes their regular requests. \nOnce ' +
            'both students\' regular requests are complete, the system then processes their \nalternate requests to fill any remaining gaps.\n\n</div> ' +

            '<div class="boldFont">Process Alternates By Individual Student</div>' +
            '<div>When this option is selected, the Mass Student Scheduler will process each student\'s alternate requests \nimmediately after their regular requests, before moving on to the ' +
            'next student. This approach aims to \ncreate more complete schedules but may increase conflicts for regular course requests for students processed later in the run.\n\n</div> ' +

            '<div class="italicFont">Example: Two students have been selected to run in the Mass Student Scheduler with the option to Process \nAlternates By Individual Student. The system begins with the first student, ' +
            'processing all their regular course \nrequests. After completing their regular requests, the system immediately processes their alternate \nrequests. Once both the first student\'s regular ' +
            'and alternate requests have been processed, the system then moves on \nto the second student, following the same sequence.</div>'



            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var legacyStudentSectionDropStatusInformationPopup = function (event)
        {
            var button = $(this);
            var title = 'Legacy Student Section Drop Status Information';
            var options =
            {
                anchorTo: button,
                id: "LegacyStudentSectionDropStatusInformationPopup"
            };

            var message = '<div class="boldFont">Enabled (Legacy Calculation):</div>' +
                '<div>A Student Section is shown as Dropped if any of its enrollment records has an Early Exit Reason that is marked as a drop, ' +
                'even if a more recent enrollment record does not have a drop reason. This means that once a student is dropped during any part of their enrollment, ' +
                'the Student Section will always display as Dropped.\n\n</div>' +
                '<div class="boldFont">Disabled (Updated Calculation):</div>' +
                '<div>A Student Section is shown as Dropped only when the student\'s most recent enrollment record has an Early Exit Reason that is marked as a drop. ' +
                'This means that if a student is dropped and later re-enrolled in the same section, the Student Section will no longer display as Dropped.</div>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        // Event handlers
        var events =
        {
            "newAnalysisTab": skyward.scheduling.newAnalysisTab,
            "displayStaffMeetAssignmentConflictPopup": skyward.scheduling.displayStaffMeetAssignmentConflictPopup,
            "displaySubstituteAssignmentConflictPopup": skyward.scheduling.displaySubstituteAssignmentConflictPopup,
            "massAutoSchedulerAlternateRequestPopup": massAutoSchedulerAlternateRequestPopup,
            "massPrintStudentScheduleStaffSortPeriodPopup": massPrintStudentScheduleStaffSortPeriodPopup,
            "massChangeEndDateBlurEvent": skyward.scheduling.massChangeEndDateBlurEvent,
            "updateIndividualTempSubstituteAssignment": skyward.scheduling.updateIndividualTempSubstituteAssignment,
            "legacyStudentSectionDropStatusInformationPopup": legacyStudentSectionDropStatusInformationPopup,
            "restrictSchedulingBeyondSectionCapacityInformationPopup": restrictSchedulingBeyondSectionCapacityInformationPopup
        };
        skyward.events.registerEvents("scheduling", events);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
skyward.base.registerScript("calculatedFieldList", function (skyward, $)
{
    skyward.calculatedFieldList = skyward.calculatedFieldList || {};

    var init = function ()
    {
        const calculatedFieldList = $(this);

        const relatedTreeBrowseName = calculatedFieldList.data("relatedTreeBrowse");
        const relatedTreeBrowse = skyward.treebrowse.getTreeBrowseContainer(relatedTreeBrowseName);

        calculatedFieldList.find(".add_calculated_field").on("click", function () { addCalculatedField($(this)); });
        calculatedFieldList.find(".delete_calculated_field").on("click", function () { removeCalculatedField($(this), relatedTreeBrowse); });
        calculatedFieldList.find(".edit_calculated_field").on("click", function () { editCalculatedField($(this), relatedTreeBrowse); });
        relatedTreeBrowse.on("treeBrowseRowChange", function (_treeBrowseData, rowData) { calculatedFieldClicked(rowData, calculatedFieldList); });
    };

    var toggleEditAndDelete = function (calculatedFieldList, enabled)
    {
        calculatedFieldList.find(".delete_calculated_field, .edit_calculated_field").toggleClass("ui-disabled", !enabled);
    };

    var calculatedFieldClicked = function (rowData, calculatedFieldList)
    {
        toggleEditAndDelete(calculatedFieldList, rowData.isCalculatedField);
    };

    var addCalculatedField = function (button)
    {
        const listData = button.closest(".calculatedFieldList").data();

        skyward.calculatedFieldBuilder.launch({
            callback: skyward.reporting.addCalculatedField,
            schemaObject: listData.schemaObject,
            relationshipPath: listData.relationshipPath,
            prompts: skyward.reporting.prompts.promptCollection,
            usedInExistsFilter: false
        });
    };

    var removeCalculatedField = function (button, relatedTreeBrowse)
    {
        if (button.hasClass("ui-disabled"))
        {
            return;
        }

        const selectedItem = skyward.treebrowse.getSelectedFieldData(relatedTreeBrowse);
        if (!selectedItem.isCalculatedField)
        {
            return;
        }

        skyward.reporting.removeCalculatedField(selectedItem.id);
        const calculatedFieldList = button.closest(".calculatedFieldList");
        toggleEditAndDelete(calculatedFieldList, false);
    };

    var editCalculatedField = function (button, relatedTreeBrowse)
    {
        if (button.hasClass("ui-disabled"))
        {
            return;
        }

        const selectedItem = skyward.treebrowse.getSelectedFieldData(relatedTreeBrowse);
        if (!selectedItem || !selectedItem.isCalculatedField)
        {
            return;
        }

        skyward.reporting.updateCalculatedField(selectedItem.id);
    };

    /**
     * @param {object} treeBrowseData The tree browse that hosts the calculated field list
     * @param {CalculatedFieldProps[]} calculatedFields The calculated fields that may be shown.  They will be filtered by module/object/relationshipPath.
     * @param {string | undefined} container Selector for the target element where the calculated field list will be added.  This is
     * required for editable calculated field lists, but can be unset otherwise.
     * @param {any} module The root schema module to filter on and to assign to new calculated fields.
     * @param {any} object The root schema object to filter on and to assign to new calculated fields.
     * @param {any} relationshipPath The relationship path to filter on and to assign to new calculated fields.
     * @param {string | undefined} rootExistsPath The exist relationship path if in an exists
     */
    skyward.calculatedFieldList.updateCalculatedFieldList = function (treeBrowseData, calculatedFields, container, module, object, relationshipPath, rootExistsPath)
    {
        const schemaObject = module + "." + object;
        const relationship = relationshipPath || "";

        const list = $(container).closest(".calculatedFieldList");
        const listData = list.data();
        if (listData !== undefined)
        {
            listData.schemaObject = schemaObject;
            listData.relationshipPath = relationship;
        }

        const filteredFields = filterCalculatedFields(calculatedFields, schemaObject, relationship, rootExistsPath);

        let calculatedFieldTreeBrowseSection = treeBrowseData.additionalSections.find(function (section) { return section.key === "calculatedFields"; });
        if (!calculatedFieldTreeBrowseSection)
        {
            calculatedFieldTreeBrowseSection =
            {
                key: "calculatedFields",
                component: "calculatedField",
                container: container,
                title: container ? undefined : "Calculated Fields",
                rows: []
            };
            treeBrowseData.additionalSections.push(calculatedFieldTreeBrowseSection);
        }
        calculatedFieldTreeBrowseSection.rows = filteredFields;

        if (!treeBrowseData.getSelectedFieldData())
        {
            toggleEditAndDelete(list, false);
        }
    };

    skyward.calculatedFieldList.filterCalculatedFieldList = function (calculatedFields, module, object, relationshipPath, rootExistsPath)
    {
        const schemaObject = module + "." + object;
        const relationship = relationshipPath || "";

        return filterCalculatedFields(calculatedFields, schemaObject, relationship, rootExistsPath);
    };

    function filterCalculatedFields(calculatedFields, schemaObject, relationship, rootExistsPath)
    {
        const filteredFields = calculatedFields.filter(function (field)
        {
            if (rootExistsPath && field.usesParentField)
            {
                return false;
            }

            const fieldRelationshipPath = field.relationshipPath || "";
            return (field.schemaObject === schemaObject && fieldRelationshipPath == relationship) || (fieldRelationshipPath == rootExistsPath);
        });

        filteredFields.sort(function (a, b)
        {
            return a.fieldName.toUpperCase().localeCompare(b.fieldName.toUpperCase());
        });

        return filteredFields;
    }

    return { init: init };
});;
(
    function (skyward, $, undefined)
    {
        skyward.gradebookanalytics = skyward.gradebookanalytics || {};

        var init = function (selector)
        {
            $(selector).find(".categoryWeightInformationButton").on("click", function ()
            {
                var button = $(this);
                var buttonData = button.data();

                var title = buttonData.categoryCode + " Weight Information";
                var message = "<div class='categoryWeightInfoDiv'>Default Category Weight: <span>" + buttonData.defaultCategoryWeight + "</span></div>"
                            + "<div class='categoryWeightInfoDiv'>Adjusted Category Weight: <span>" + buttonData.adjustedCategoryWeight + "</span></div>"
                            + "<div class='categoryWeightInfoDiv'>Percent Earned: <span>" + buttonData.percentEarned + "</span></div>"
                            + "<div class='categoryWeightInfoDiv'>Adjusted Weight Formula: <span>" + buttonData.adjustedWeightFormula + "</span></div>"
                            + "<div class='boldFont'>" + "** Rounded formula may not accurately reflect actual calculation." + "</div>";

                var options =
                {
                    anchorTo: button
                };
                skyward.modalLayer.showInformationDialog(title, message, null, options);
            });

            $(selector).find(".gradeWeightInformationButton").on("click", function ()
            {
                var button = $(this);
                var buttonData = button.data();

                var title = "Grade Information";
                var message = "";

                var roundBucketPercent = buttonData.roundBucketPercent.toString().toLowerCase() == "true";
                var capCategoryAtHundred = buttonData.capCategoryAtHundred.toString().toLowerCase() == "true";
                var useSnapshot = buttonData.useSnapshot.toString().toLowerCase() == "true";

                if (buttonData.isAdminOverride.toString().toLowerCase() == "true")
                {
                    message += "<div class='categoryWeightInfoDiv'><span>This grade has been overridden by administration.  The grade mark has been updated, but the percentage remains unchanged.</span></div>";
                }
                else if (roundBucketPercent || capCategoryAtHundred || useSnapshot)
                {
                    message += roundBucketPercent ? "<div class='categoryWeightInfoDiv'><span>This grade has been rounded.</span></div>" : "";
                    message += capCategoryAtHundred ? "<div class='categoryWeightInfoDiv'><span>The categories weighted toward this grade have been capped at 100%.</span></div>" : "";
                    message += useSnapshot ? "<div class='categoryWeightInfoDiv'><span> This grade is a snapshot from " + buttonData.snapshotDate + "</span></div>" : "";
                }
                else
                {
                    message += "<div class='categoryWeightInfoDiv'>Original Grade: <span>" + buttonData.gradeMarkCode + " / " + buttonData.percent + "</span></div>";
                    message += buttonData.percentAdjustment != "" ? "<div class='categoryWeightInfoDiv'>Percent Adjustment: <span>" + buttonData.percentAdjustment + "</span></div>" : "";
                    message += buttonData.percentAdjustmentComment != "" ? "<div class='categoryWeightInfoDiv'>Percent Adjustment Comment: <span>" + buttonData.percentAdjustmentComment + "</span></div>" : "";
                    message += buttonData.gradeMarkOverrideCode != "" ? "<div class='categoryWeightInfoDiv'>Grade Mark Override: <span>" + buttonData.gradeMarkOverrideCode + "</span></div>" : "";
                    message += buttonData.gradeMarkOverrideComment != "" ? "<div class='categoryWeightInfoDiv'>Grade Mark Override Comment: <span>" + buttonData.gradeMarkOverrideComment + "</span></div>" : "";
                }
                var options =
                {
                    anchorTo: button
                };
                skyward.modalLayer.showInformationDialog(title, message, null, options);
            });

            var analyticsBrowse = $(selector).find(".analyticsBrowse");

            if (analyticsBrowse.length == 0)
            {
                return;
            }

            var getNextDescendingState = function (cell)
            {
                var sortSpanData = cell.find(".browseColumnSortSpan").data();
                var curentSortState = sortSpanData.descending;

                //descending toggle cycle: null -> sort (not descending) -> sort (descending) -> null
                if (curentSortState == null)
                {
                    return  false;
                }
                else if (curentSortState.toString().toLowerCase() == "false")
                {
                    return  true;
                }
                else if (curentSortState.toString().toLowerCase() == "true")
                {
                    return  null;
                }

                return null;
            };

            analyticsBrowse.on("click", ".categoryAverageCell", function ()
            {
                var browseName = "CategoryAnalytics";
                var cell = $(this);
                var cellData = cell.data();
                var browseData = $("#" + browseName).data();
                var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "StudentCategoryBreakdownTeacherTracker" : "StudentCategoryBreakdown";

                skyward.window.loadContent("full", "Grading", "StudentGradeBucket", action, cellData.studentGradeBucketId + "/" + cellData.categoryId);
            });

            analyticsBrowse.on("click", ".categoryAnalyticsBucketHeader", function ()
            {
                var browseName = "CategoryAnalytics";
                var cell = $(this);
                var cellData = cell.data();
                var descending = getNextDescendingState(cell);

                var browseData = $("#" + browseName).data();
                var data =
                {
                    teacherSectionGradeBucketAnalyticsSettingID: cellData.teacherSectionGradeBucketAnalyticsSettingId,
                    categoryID: cellData.categoryId,
                    descending: descending,
                    isTeacherTracker: browseData.isTeacherTracker
                };

                var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "UpdateCategoryAnalyticsSortTeacherTracker" : "UpdateCategoryAnalyticsSort";

                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function ()
                    {
                        var browse = skyward.browse.browseList[browseName];
                        skyward.browse.get(browseName, { seekId: browse.seekid });
                    }
                });
            });

            analyticsBrowse.on("click", ".gradeAnalyticsCell", function ()
            {
                var cell = $(this);
                var cellData = cell.data();
                var browseData = cell.parents(".analyticsBrowse").data();

                skyward.window.loadContent("full", "Grading", "StudentGradeBucket", browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "GradeAnalyticsBreakdownTeacherTracker" : "GradeAnalyticsBreakdown", cellData.studentGradeBucketId);
            });

            analyticsBrowse.on("click", ".gradeAnalyticsBucketHeader", function ()
            {
                var browseName = $(this).parents(".analyticsBrowse").attr("id");
                var cell = $(this);
                var cellData = cell.data();
                var descending = getNextDescendingState(cell);

                var browseData = $("#" + browseName).data();
                var data =
                {
                    calculationGroupGradeBucketId: cellData.calculationGroupGradeBucketId,
                    descending: descending,
                    isTeacherTracker: browseData.isTeacherTracker,
                    browseName: browseName
                };

                var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "UpdateGradeAnalyticsSortTeacherTracker" : "UpdateGradeAnalyticsSort";
                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function ()
                    {
                        var browse = skyward.browse.browseList[browseName];
                        skyward.browse.get(browseName, { seekId: browse.seekid });
                    }
                });
            });

            analyticsBrowse.on("click", ".assignmentAnalyticsBucketHeader", function ()
            {
                var browseName = $(this).parents(".analyticsBrowse").attr("id");
                var cell = $(this).parent("td");
                var cellData = cell.data();
                var descending = getNextDescendingState(cell);

                var browseData = $("#" + browseName).data();
                var data =
                {
                    assignmentId: cellData.assignmentId,
                    descending: descending,
                    isTeacherTracker: browseData.isTeacherTracker,
                    browseName: browseName
                };

                var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "UpdateGradeAnalyticsAssignmentSortTeacherTracker" : "UpdateGradeAnalyticsAssignmentSort";
                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function () {
                        var browse = skyward.browse.browseList[browseName];
                        skyward.browse.get(browseName, { seekId: browse.seekid });
                    }
                });
            });

            analyticsBrowse.on("click", ".browseColumnInfoSpan", function (event)
            {
                var button = $(this);
                var cell = button.closest("td");
                var cellData = cell.data();
                var browseName = button.parents(".analyticsBrowse").attr("id");
                var browseData = $("#" + browseName).data();

                const renderScoreMaxScore = browseData.renderScoreMaxScore;
                const renderWeight = browseData.renderWeight;

                var html = "<div class='.fieldWrapper'><label class='title' for='assignmentDetailsAssignedDateInput'>Assigned Date</label><input id='assignmentDetailsAssignedDateInput' class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.assignedDate + "'/></div>";
                html += "<div class='.fieldWrapper'><label class='title' for='assignmentDetailsDueDateInput'>Due Date</label><input id='assignmentDetailsDueDateInput' class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.dueDate + "'/></div>";
                html += "<div class='.fieldWrapper'><label class='title' for='assignmentDetailsCategoryInput'>Category</label><input id='assignmentDetailsCategoryInput' class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.categoryCode + "'/></div>";
                html += "<div class='.fieldWrapper'><label class='title' for='assignmentDetailsNameInput'>Name</label><input id='assignmentDetailsNameInput' class='assignmentDetailsPopupInput' type='text' readonly='readonly' style='width: 25em;' value='" + cellData.name + "'/></div>";
                html += "<div class='.fieldWrapper'><label class='title' for='assignmentDetailsDescriptionInput'>Description</label><textarea id='assignmentDetailsDescriptionInput' class='assignmentDetailsPopupInput' type='text' readonly='readonly' style='width: 25em;'>" + cellData.description + "</textarea></div>";
                if (renderScoreMaxScore === "True")
                {
                    html += "<div class='.fieldWrapper'><label class='title' for='assignmentDetailsMaxScoreInput'>Max Score</label><input id='assignmentDetailsMaxScoreInput' class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.maxScore + "'/></div>";
                }
                if (renderWeight === "True")
                {
                    html += "<div class='.fieldWrapper'><label class='title' for='assignmentDetailsWeightInput'>Weight</label><input id='assignmentDetailsWeightInput' class='assignmentDetailsPopupInput' type='text' readonly='readonly' value='" + cellData.weight + "'/></div>";
                }

                var createButton = browseData.isTeacherTracker.toString().toLowerCase() == "true" || cellData.hasAssignmentDetailsPermission.toLowerCase() == "false" ? null :
                {
                    text: "Open Assignment Details", click: function ()
                    {
                        skyward.window.loadContent("popout", "Gradebook", "Assignment", browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "DetailsTeacherTracker" : "Details", cellData.assignmentId);
                    }, icon: "RowOpen"
                };

                var closeButton = { text: "Close", click: function () { dialog.close(); }, icon: "Close" };
                var options =
                {
                    anchorTo: button
                };
                var dialog = skyward.modalLayer.showDialog('Assignment Information', html, [createButton, closeButton], options);

                event.preventDefault();
                event.stopPropagation();
            });
        };

        var selectGradeBucketsToDisplay = function ()
        {
            var clickedElement = $(this);
            var browseElement = clickedElement.parents(".browse");
            var browseData = browseElement.data();
            browseData.requestedFromBrowseName = browseElement.attr("id");

            var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "BuildGradeBucketsToDisplayPopupTeacherTracker" : "BuildGradeBucketsToDisplayPopup";

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: browseData,
                    success: function ()
                    {
                        if (browseData.requestedFromBrowseName == "AssignmentAnalytics")
                        {
                            var browseLoadedEvent = "browseLoaded.CalculationGroupGradeBucketsToDisplay";
                            $("body").off(browseLoadedEvent).on(browseLoadedEvent, assignmentAnalyticsPrepGradeBucketSelectionBrowse);
                        }
                    }
                });
            };

            var saveGradeBucketAnalyticsDisplaySettings = function ()
            {
                $(this).off("click", saveGradeBucketAnalyticsDisplaySettings);

                var data =
                {
                    teacherSectionSettingId: browseData.teacherSectionSettingId,
                    sectionId: browseData.sectionId,
                    SectionIDHash: browseData.sectionIdHash,
                    isTeacherTracker: browseData.isTeacherTracker,
                    requestedFromBrowseName: browseData.requestedFromBrowseName
                };

                var cggbToDisplayBrowse = $("#CalculationGroupGradeBucketsToDisplay");
                data.browseSaveData = JSON.stringify(cggbToDisplayBrowse.data().editablebrowsedata);

                var saveAction = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "SaveAnalyticsGradeBucketsToDisplayTeacherTracker" : "SaveAnalyticsGradeBucketsToDisplay";

                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + saveAction,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function (returnData)
                    {
                        $(this).on("click", saveGradeBucketAnalyticsDisplaySettings);

                        if (returnData.success)
                        {
                            dialog.close();
                            var browseElementID = browseElement.attr("id");
                            var browse = skyward.browse.browseList[browseElementID];
                            skyward.browse.get(browseElementID, { seekId: browse.seekid });
                        }
                        else
                        {
                            var container = $('.messageBox.content');
                            var baseErrorContainer = container.find(".contentBaseError");

                            skyward.validation.displayValidationMessages(returnData, container, baseErrorContainer);
                        }
                    }
                });
            };

            var saveButton = { text: "Save", click: saveGradeBucketAnalyticsDisplaySettings, icon: "Save" };
            var cancelButton = { text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };

            var dialog = skyward.modalLayer.showDialog("Grade Columns To Display", buildPopup, [ saveButton, cancelButton ]);
        };

        var selectCategoriesToDisplay = function ()
        {
            var clickedElement = $(this);
            var browseElement = clickedElement.parents(".browse");
            var browseData = browseElement.data();
            browseData.requestedFromBrowseName = browseElement.attr("id");

            var action = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "BuildCategoriesToDisplayPopupTeacherTracker" : "BuildCategoriesToDisplayPopup";

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: browseData
                });
            };

            var saveAnalyticsCategoriesToDisplaySettings = function ()
            {
                $(this).off("click", saveAnalyticsCategoriesToDisplaySettings);

                var data =
                {
                    teacherSectionSettingId: browseData.teacherSectionSettingId,
                    sectionId: browseData.sectionId,
                    sectionIDHash: browseData.sectionIdHash,
                    isTeacherTracker: browseData.isTeacherTracker,
                    requestedFromBrowseName: browseData.requestedFromBrowseName
                };

                var cggbToDisplayBrowse = $("#CategoriesToDisplay");
                data.browseSaveData = JSON.stringify(cggbToDisplayBrowse.data().editablebrowsedata);

                var saveAction = browseData.isTeacherTracker.toString().toLowerCase() == "true" ? "SaveAnalyticsCategoriesToDisplaySettingsTeacherTracker" : "SaveAnalyticsCategoriesToDisplaySettings";

                $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/GradebookAnalytics/" + saveAction,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function (returnData)
                    {
                        $(this).on("click", saveAnalyticsCategoriesToDisplaySettings);

                        if (returnData.success)
                        {
                            dialog.close();
                            var browseElementID = browseElement.attr("id");
                            var browse = skyward.browse.browseList[browseElementID];
                            skyward.browse.get(browseElementID, { seekId: browse.seekid });
                        }
                        else
                        {
                            var container = $('.messageBox.content');
                            var baseErrorContainer = container.find(".contentBaseError");

                            skyward.validation.displayValidationMessages(returnData, container, baseErrorContainer);
                        }
                    }
                });
            };

            var saveButton = { text: "Save", click: saveAnalyticsCategoriesToDisplaySettings, icon: "Save" };
            var cancelButton = { text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };

            var dialog = skyward.modalLayer.showDialog("Categories To Display", buildPopup, [saveButton, cancelButton]);
        };

        var assignmentAnalyticsPrepGradeBucketSelectionBrowse = function ()
        {
            $("#CalculationGroupGradeBucketsToDisplay").find("input:checkbox").each(function ()
            {
                selectGradeBucketsGetInnerCalculationGroupGradeBuckets.apply($(this));
            });

            $("#CalculationGroupGradeBucketsToDisplay").off("change", "input:checkbox", selectGradeBucketsGetInnerCalculationGroupGradeBuckets).on("change", "input:checkbox", selectGradeBucketsGetInnerCalculationGroupGradeBuckets);
        };

        var selectGradeBucketsGetInnerCalculationGroupGradeBuckets = function ()
        {
            var clickedElement = $(this);
            var clickedElementData = clickedElement.data();

            var browseElement = clickedElement.parents(".browse");

            var enableCheckbox = function (innerCheckbox)
            {
                var calculationGroupGradeBucketID = innerCheckbox.attr("id").split("-")[1];

                var disableRequired = false;
                //Foreach checkbox in browse, check if there are any checkboxes with inner grade buckets that match the one passed in. If an inner bucket matches and the checkbox is checked its still required
                browseElement.find("input:checkbox").each(function ()
                {
                    var checkbox = $(this);
                    var checkboxData = checkbox.data();

                    if (checkboxData.innerCalculationGroupGradeBucketIds)
                    {
                        $.each(checkboxData.innerCalculationGroupGradeBucketIds, function (index, value)
                        {
                            if (value == calculationGroupGradeBucketID)
                            {
                                if (checkbox.is(":checked"))
                                {
                                    disableRequired = true;
                                    return;
                                }
                            }
                        });
                    }
                });

                return !disableRequired;
            };

            if (!clickedElementData.innerCalculationGroupGradeBucketIds)
            {
                return;
            }

            $.each(clickedElementData.innerCalculationGroupGradeBucketIds, function (index, value)
            {
                var innerCheckbox = $("#DisplayCalculationGroupGradeBucket-" + value);
                if (!clickedElement.is(":checked") && enableCheckbox(innerCheckbox))
                {
                    skyward.controls.enable(innerCheckbox);
                }
                else
                {
                    skyward.controls.disable(innerCheckbox);
                    skyward.controls.setValue(innerCheckbox, true);
                }
            });
        };

        var assignmentIndicatorPopup = function ()
        {
            var button = $(this);
            var firstRow;
            var browse = button.parents(".analyticsBrowse");

            button.find('.assignmentIndicators').each(function ()
            {
                var span = $(this);
                if (span.hasClass('assignmentIndicatorsFirstRow'))
                {
                    firstRow = span;
                }
            });

            var assignmentCell = button.parents('.assignmentAnalyticsAssignmentCell ');
            var assignmentCellData = assignmentCell.data();

            var data =
            {
                studentSectionID: assignmentCellData.studentsectionid,
                assignmentID: assignmentCellData.assignmentid,
                showScoreWarning: !firstRow.hasClass('hiddenWarning'),
                sectionID: assignmentCellData.sectionid,
                sectionIDHash: assignmentCellData.sectionidhash
            };

            var buildPopup = function ()
            {
                var action = browse.data().isTeacherTracker.toString().toLowerCase() == "true" ? "AdvancedStudentAssignmentPopupTeacherTracker" : "AdvancedStudentAssignmentPopup";
                return $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: data
                });
            };

            $.when(buildPopup()).done(function (html)
            {
                var cancelButton = { id: "cancelAdvancedStudentAssignmentPopup", text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var dialog = skyward.modalLayer.showDialog('Student Assignment Information', html, [cancelButton], { anchorTo: button });
            });
        };

        // Event handlers
        var events =
        {
            "selectCategoriesToDisplay": selectCategoriesToDisplay,
            "selectGradeBucketsToDisplay": selectGradeBucketsToDisplay,
            'assignmentIndicatorPopup': assignmentIndicatorPopup
        };
        skyward.events.registerEvents("gradebookAnalytics", events);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $)
    {
        skyward.stateassignedalternativeid = skyward.stateassignedalternativeid || {};

        skyward.stateassignedalternativeid.getnewstateassignedalternativeid = function () {
            var parentFieldset = skyward.stateassignedalternativeid.getnewstateassignedalternativeid.caller.arguments[0].target.closest(".fieldWrapper");
            var parentDiv = skyward.stateassignedalternativeid.getnewstateassignedalternativeid.caller.arguments[0].target.closest("div");
            var button = $(this);
            button.off();
            $.when(skyward.stateassignedalternativeid.generatestateassignedalternativeid(parentFieldset, parentDiv)).then(function () {
                button.on("click", skyward.stateassignedalternativeid.getnewstateassignedalternativeid);
            });
        };

        skyward.stateassignedalternativeid.generatestateassignedalternativeid = function (parentFieldset, parentDiv) {
            var inputField = $(parentFieldset).find('input.AssignStateAlternativeID');
            var helpLabel = $(parentFieldset).find('label.help');
            var titleLabel = $(parentFieldset).find('label.title');
            var dataSend;
            var dirPath;

            if (inputField.attr('id').indexOf('Student') >= 0)
            {
                dirPath = "Student/Student/";
            }
            else
            {
                var enteredBeginnningRange = skyward.controls.getValue($(parentDiv).find('input#editConfigDistrictGroup_StateAssignedAlternativeIDBeginningRange'));
                var enteredEndingRange = skyward.controls.getValue($(parentDiv).find('input#editConfigDistrictGroup_StateAssignedAlternativeIDEndingRange'));

                dirPath = "StateReporting/ConfigDistrict/";
                dataSend = $.param({ enteredBeginnningRange: enteredBeginnningRange, enteredEndingRange: enteredEndingRange });
            }

            $.ajax({
                url: skyward.global.virtualDir + dirPath + "GenerateNewStateAssignedAlternativeID",
                type: "POST",
                dataType: "JSON",
                data: dataSend,
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                success: async function (data) {
                    if (data.success)
                    {
                        skyward.controls.setValue(inputField, data.update[0]);

                        // Clear error
                        helpLabel.html("");
                        titleLabel.removeClass("error-text");
                        inputField.removeClass("error-control");
                    }
                    else
                    {
                        skyward.controls.setValue(inputField, "");

                        // Show error
                        var iconSpan = $('<span/>');
                        var errorList = $("<ul/>");
                        $.when(skyward.svg.getSvg('Error', 'Error')).done(function (svg) {
                            iconSpan.append(svg);
                        });
                        var listItem = $("<li class='error-list'/>");
                        const processedError = await skyward.global.processViewPartHtml(data.errors['StateAssignedAlternativeID'][0]);
                        let html = processedError;
                        if (typeof processedError !== 'string')
                        {
                            html = processedError.toOuterHtmlString();
                        }
                        var errorMessage = $('<span>' + html + '</span>');
                        listItem.append(iconSpan);
                        listItem.append(errorMessage);
                        errorList.append(listItem);

                        helpLabel.html(errorList);
                        titleLabel.addClass("error-text");
                        inputField.addClass("error-control");
                    }
                }
            });
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined) {
        skyward.studentsectioncalculatecreditscontrols = skyward.studentsectioncalculatecreditscontrols || {};

        var init = function (selector) {
            // UseOverride on change
            var studentSectionCalculateCreditsControlsSelector = $(selector).find('#editStudentSectionCalcCredits');
            var studentSectionCreditsPointsBreakdownSelector = $(selector).find('#editStudentSectionGPACreditsPoints');
            var studentSectionRequiredForGradeSelector = $(selector).find('#editStudentSectionRequiredGradeBuckets');

            if (studentSectionCalculateCreditsControlsSelector.length > 0 || studentSectionCreditsPointsBreakdownSelector.length > 0
                || studentSectionRequiredForGradeSelector.length > 0)
            {
                var useOverrideCalculateSelector = $(selector).find('input[id*="UseOverride"]');

                $(function ()
                {

                    useOverrideCalculateSelector.each(function ()
                    {
                        var useOverrideValue = skyward.controls.getValue(this);
                        var body = $(this).parent('div').parent('div');
                        var textboxinputs = body.find('input[type=text]');
                        var checkboxinputs = body.find('input[type=checkbox][id*="SummaryCheckbox"]');

                        if (textboxinputs.length > 0) {
                            if (useOverrideValue == true) {
                                textboxinputs.attr('readonly', false);
                            }
                            else {
                                textboxinputs.attr('readonly', true);
                            }
                        }

                        if (checkboxinputs.length > 0) {
                            if (useOverrideValue == true) {
                                checkboxinputs.attr('disabled', false);
                            }
                            else {
                                checkboxinputs.attr('disabled', true);
                            }
                        }
                    });
                });

                useOverrideCalculateSelector.on('change', useOverrideOnChange);
            }
        };

        var useOverrideOnChange = function ()
        {
            // screen variables
            var useOverride = $(this);
            var useOverrideValue = skyward.controls.getValue(useOverride);
            var body = useOverride.parent('div').parent('div');
            var textboxinputs = body.find('input[type=text]');
            var checkboxinputs = body.find('input[type=checkbox][id*="SummaryCheckbox"]');

            if (textboxinputs.length > 0) {
                if (useOverrideValue == true) {
                    textboxinputs.attr('readonly', false);
                }
                else {
                    textboxinputs.attr('readonly', true);
                }
            }

            if (checkboxinputs.length > 0) {
                if (useOverrideValue == true)
                {
                    skyward.controls.toggle(checkboxinputs, true);
                }
                else
                {
                    skyward.controls.toggle(checkboxinputs, false);
                }
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.programandrelatedservicetx = skyward.programandrelatedservicetx || {};
     
        var init = function (selector)
        {
            var detailsScreenSelector = $(selector).find("#editProgramAndRelatedServiceTX.currentRecordContent.dataObjectViewer");
            var workflowRelatedServiceCodeEel = $(selector).filter(".workflowContent");
            var selectedCodeEel;
     
            if (detailsScreenSelector.length > 0)
            {
                selectedCodeEel = detailsScreenSelector.find("#editProgramAndRelatedServiceTX_StateProgramAndRelatedServiceTypeCodeTXID");
                skyward.programandrelatedservicetx.showHideFields(false);
            }
            else if (workflowRelatedServiceCodeEel.length > 0)
            {
                selectedCodeEel = workflowRelatedServiceCodeEel.find("#ProgramAndRelatedServiceTXStateProgramAndRelatedServiceTypeCodeTXID");
            }
            else
            {
                return;
            }
     
            var serviceCodeOnChange = function ()
            {
                skyward.programandrelatedservicetx.showHideFields(true);
            };
     
            selectedCodeEel.on("eelComplete", serviceCodeOnChange);
        };
     
        skyward.programandrelatedservicetx.showHideFields = function (clearFields)
        {
            var relatedServiceCodeEelValue;
            
            var interpretingServicesCodeEel;
            var pPCDServiceLocationCodeEel;
            var districtOfRDSPDServicetxtBox;
            var interpretingServicesCodeEelCodeValue;
            var interpretingServicesCodeEelDescriptionValue;
            var interpretingServicesID;
            var pPCDServiceLocationCodeEelCodeValue;
            var pPCDServiceLocationCodeEelDescriptionValue;
            var pPCDServiceLocationID;
            var districtOfRDSPDServiceTextBoxValue;
     
            if ($("#editProgramAndRelatedServiceTX_StateProgramAndRelatedServiceTypeCodeTXID_description").length > 0)
            {
                var detailsEditScreenSelector = '#editProgramAndRelatedServiceTX_';
                relatedServiceCodeEelValue = $(detailsEditScreenSelector + "StateProgramAndRelatedServiceTypeCodeTXID_description").val();
                interpretingServicesCodeEel = $(detailsEditScreenSelector +'fsStateInterpretingServicesTypeCodeTXID');
                pPCDServiceLocationCodeEel = $(detailsEditScreenSelector + 'fsStatePPCDServiceLocationCodeTXID');
                districtOfRDSPDServicetxtBox = $(detailsEditScreenSelector + 'fsDistrictOfRDSPDService');
                interpretingServicesCodeEelCodeValue = $(detailsEditScreenSelector + 'StateInterpretingServicesTypeCodeTXID_code');
                interpretingServicesCodeEelDescriptionValue = $(detailsEditScreenSelector + 'StateInterpretingServicesTypeCodeTXID_description');
                interpretingServicesID = $(detailsEditScreenSelector + 'StateInterpretingServicesTypeCodeTXID_value');
                pPCDServiceLocationCodeEelCodeValue = $(detailsEditScreenSelector + 'StatePPCDServiceLocationCodeTXID_code');
                pPCDServiceLocationCodeEelDescriptionValue = $(detailsEditScreenSelector + 'StatePPCDServiceLocationCodeTXID_description');
                pPCDServiceLocationID = $(detailsEditScreenSelector + 'StatePPCDServiceLocationCodeTXID_value');
                districtOfRDSPDServiceTextBoxValue = $(detailsEditScreenSelector + 'DistrictOfRDSPDService');
            }
            else if ($("#ProgramAndRelatedServiceTXStateProgramAndRelatedServiceTypeCodeTXID_description").length > 0)
            {
                var workflowScreenSelector = '#ProgramAndRelatedServiceTX';
                relatedServiceCodeEelValue = $(workflowScreenSelector + "StateProgramAndRelatedServiceTypeCodeTXID_description").val();
                interpretingServicesCodeEel = $('#fsStateInterpretingServicesTypeCodeTXID');
                pPCDServiceLocationCodeEel = $('#fsStatePPCDServiceLocationCodeTXID');
                districtOfRDSPDServicetxtBox = $('#fsDistrictOfRDSPDService');
                interpretingServicesCodeEelCodeValue = $(workflowScreenSelector + 'StateInterpretingServicesTypeCodeTXID_code');
                interpretingServicesCodeEelDescriptionValue = $(workflowScreenSelector + 'StateInterpretingServicesTypeCodeTXID_description');
                interpretingServicesID = $(workflowScreenSelector + 'StateInterpretingServicesTypeCodeTXID_value');
                pPCDServiceLocationCodeEelCodeValue = $(workflowScreenSelector + 'StatePPCDServiceLocationCodeTXID_code');
                pPCDServiceLocationCodeEelDescriptionValue = $(workflowScreenSelector + 'StatePPCDServiceLocationCodeTXID_description');
                pPCDServiceLocationID = $(workflowScreenSelector + 'StatePPCDServiceLocationCodeTXID_value');
                districtOfRDSPDServiceTextBoxValue = $(workflowScreenSelector + 'DistrictOfRDSPDService');
            }
            else
            {
                return;
            }
     
            if (relatedServiceCodeEelValue.length > 0)
            {
                switch (relatedServiceCodeEelValue.toLowerCase())
                {
                    case "interpreting services":
                        interpretingServicesCodeEel.css('display', 'block');
                        pPCDServiceLocationCodeEel.css('display', 'none');
                        districtOfRDSPDServicetxtBox.css('display', 'none');
                        if (clearFields)
                        {
                            skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                            skyward.controls.setValue(pPCDServiceLocationID, "");
                            skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                        }
                        break;
                    case "early childhood special education":
                        interpretingServicesCodeEel.css('display', 'none');
                        pPCDServiceLocationCodeEel.css('display', 'block');
                        districtOfRDSPDServicetxtBox.css('display', 'none');
                        if (clearFields)
                        {
                            skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                            skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                            skyward.controls.setValue(interpretingServicesID, "");
                            skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                        }
                        break;
                    case "receiving instructional services from rdspd":
                        interpretingServicesCodeEel.css('display', 'none');
                        pPCDServiceLocationCodeEel.css('display', 'none');
                        districtOfRDSPDServicetxtBox.css('display', 'block');
                        if (clearFields)
                        {
                            skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                            skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                            skyward.controls.setValue(interpretingServicesID, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                            skyward.controls.setValue(pPCDServiceLocationID, "");
                        }
                        break;
                    default:
                        interpretingServicesCodeEel.css('display', 'none');
                        pPCDServiceLocationCodeEel.css('display', 'none');
                        districtOfRDSPDServicetxtBox.css('display', 'none');
                        if (clearFields)
                        {
                            skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                            skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                            skyward.controls.setValue(interpretingServicesID, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                            skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                            skyward.controls.setValue(pPCDServiceLocationID, "");
                            skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                        }
                        break;
                }
            }
            else
            {
                skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                skyward.controls.setValue(interpretingServicesID, "");
                skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                skyward.controls.setValue(pPCDServiceLocationID, "");
                skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");

                interpretingServicesCodeEel.css('display', 'none');
                pPCDServiceLocationCodeEel.css('display', 'none');
                districtOfRDSPDServicetxtBox.css('display', 'none');
            }
        };
     
        skyward.window.registerLoadDOMCallback(init);
     
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.events.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.printScreen.ts" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.changetracking.js" />
/// <reference path="skyward.ui.dailyAttendance.js" />
(
    function (skyward, $, undefined)
    {
        skyward.seatingchart = skyward.seatingchart || {};

        var init = function (selector)
        {
            var seatingChartContent = $(selector + " #seatingChartContent");
            if (seatingChartContent.length == 0)
            {
                return;
            }

            if (skyward.seatingchart.saveLayer)
            {
                skyward.seatingchart.saveLayer.close();
            }

            // General function declarations
            var defaultGridLineSizeValueX = 25;
            var defaultGridLineSizeValueY = 25;
            var gridLineSizeValueX;
            var gridLineSizeValueY;
            var snapToGridValue;
            var currentScaleX = 1;
            var currentScaleY = 1;

            var gridCssBuilder = function ()
            {
                canvas.css("background-size", "");
                canvas.css("background-image", "");

                var roomObjects = $(".roomObject");
                if (snapToGridValue)
                {
                    if (roomObjects.data("ui-draggable"))
                    {
                        roomObjects.each(function ()
                        {
                            var currRoomObject = $(this);
                            if (currRoomObject.data("ui-draggable"))
                            {
                                currRoomObject.draggable("option", "snap", "none");
                            };
                        });
                    }

                    var cutoffValueX = (100 / gridLineSizeValueX) * (gridLineSizeValueX - 1);
                    var cutoffValueY = (100 / gridLineSizeValueY) * (gridLineSizeValueY - 1);
                    canvas.css("background-size", gridLineSizeValueX + "px " + gridLineSizeValueY + "px");
                    canvas.css("background-image", "linear-gradient(0deg, transparent " + (cutoffValueX - 1) + "%, rgba(0, 0, 0, .05) " + cutoffValueX + "% ), linear-gradient( 90deg, transparent " + (cutoffValueY - 1) + "%, rgba(0, 0, 0, .05) " + cutoffValueY + "% )");
                    canvas.css("background-color", "#ffffff");
                }
                else
                {
                    if (roomObjects.data("ui-draggable"))
                    {
                        roomObjects.draggable("option", "snap", ".roomObjectPlaced");
                        roomObjects.draggable("option", "snapMode", "outer");
                        roomObjects.draggable("option", "snapTolerance", skyward.seatingchart.gridSnapTolerance);
                    }
                }
            };

            skyward.seatingchart.gridLineSize = function (xValue, yValue)
            {
                // Allow yValue to be optional (defaults to same as xValue)
                yValue = yValue || xValue;
                if (xValue <= 1 || yValue <= 1)
                {
                    snapToGridValue = false;
                }
                gridLineSizeValueX = xValue;
                gridLineSizeValueY = yValue;
                gridCssBuilder();
            };

            skyward.seatingchart.snapToGrid = function (value)
            {
                snapToGridValue = value;
                gridCssBuilder();
            };

            var registerRoomObjectDraggable = function (select, fromToolbox, revertFunction)
            {
                var draggableSettings =
                {
                    scroll: true,
                    helper: fromToolbox ? 'clone' : 'original',
                    start: function ()
                    {
                        if (!fromToolbox)
                        {
                            removeRoomObject.removeClass("removeRoomObjectHidden");
                            enableDiableStudentPopupClick(false);
                        }

                        var currRoomObject = $(this);
                        if (!currRoomObject.hasClass("ui-selected"))
                        {
                            unselectRoomObjects();
                            if (isRoomObjectPlaced(currRoomObject))
                            {
                                selectRoomObjects(currRoomObject);
                            }
                        }

                        getSelectedRoomObjects().each(function ()
                        {
                            var selectedObject = $(this);

                            var roomObjectStudents = selectedObject.find(".roomObjectStudents");
                            if (!isNullOrEmpty(roomObjectStudents) && !roomObjectStudents.hasClass("roomObjectStudentsDragging"))
                            {
                                roomObjectStudents.addClass("roomObjectStudentsDragging");
                            }

                            selectedObject.data("originalleft", parseInt(selectedObject.css("left"), 10));
                            selectedObject.data("originaltop", parseInt(selectedObject.css("top"), 10));
                        });

                    },
                    stop: function ()
                    {
                        if (!fromToolbox)
                        {
                            removeRoomObject.addClass("removeRoomObjectHidden");
                            // if we enable it right away then it will be called after this if they started dragging by the student images div
                            setTimeout(function () { enableDiableStudentPopupClick(true); }, 50);
                        }

                        var resetOpactity = function (roomObject)
                        {
                            var roomObjectStudents = roomObject.find(".roomObjectStudents");
                            if (!isNullOrEmpty(roomObjectStudents) && roomObjectStudents.hasClass("roomObjectStudentsDragging"))
                            {
                                roomObjectStudents.removeClass("roomObjectStudentsDragging");
                            }
                        };

                        resetOpactity($(this));

                        $(".roomObject:not(.ui-draggable-dragging).ui-selected").each(function ()
                        {
                            var selectedObject = $(this);

                            resetOpactity(selectedObject);

                            selectedObject.removeData("originalleft");
                            selectedObject.removeData("originaltop");
                        });
                    },
                    drag: function (event, ui)
                    {
                        var currRoomObject = $(this);

                        var topRemainder = ui.position.top % (snapToGridValue
                            ? gridLineSizeValueY : ui.position.top);

                        var leftMarginAdjustmentPosition = parseInt(currRoomObject.css("marginLeft"), 10) + ui.position.left;
                        var leftRemainder = leftMarginAdjustmentPosition % (snapToGridValue
                            ? gridLineSizeValueX : leftMarginAdjustmentPosition);

                        var leftMarginScrollAdjust = 0;
                        var scrollLeftAdjust = 0;
                        var scrollTopAdjust = 0;
                        if (snapToGridValue && currRoomObject.hasClass("roomObjectList"))
                        {
                            scrollLeftAdjust = canvasScrollContainer.scrollLeft() % gridLineSizeValueX;
                            scrollTopAdjust = canvasScrollContainer.scrollTop() % gridLineSizeValueY;
                            leftMarginScrollAdjust = parseInt(canvasScrollContainer.css("marginLeft"), 10) % gridLineSizeValueX;
                        }

                        var topAjustedPosition = ui.position.top - topRemainder;
                        var leftAjustedPosition = leftMarginAdjustmentPosition - leftRemainder + leftMarginScrollAdjust;

                        ui.position.top = topAjustedPosition - scrollTopAdjust;
                        ui.position.left = leftAjustedPosition - scrollLeftAdjust;

                        var topDifference = ui.position.top - ui.originalPosition.top;
                        var leftDifference = ui.position.left - ui.originalPosition.left;

                        checkExpandCanvas(currRoomObject);

                        $(".roomObject:not(.ui-draggable-dragging).ui-selected").each(function ()
                        {
                            var currentObject = $(this);
                            currentObject.css("left", (currentObject.data("originalleft") + leftDifference) + "px");
                            currentObject.css("top", (currentObject.data("originaltop") + topDifference) + "px");
                            checkExpandCanvas(currentObject);
                        });
                    },
                    revert: revertFunction
                };

                if (!snapToGridValue)
                {
                    draggableSettings.snapTolerance = skyward.seatingchart.gridSnapTolerance;
                    draggableSettings.snapMode = "outer";
                    draggableSettings.snap = ".roomObjectPlaced";
                }

                initDraggable(select, draggableSettings);
            };

            var checkExpandCanvas = function (roomObject)
            {
                var canvasWidth = parseInt(canvas.css("width"), 10);
                var widthEdge = roomObject.position().left + parseInt(roomObject.css("width"), 10) + skyward.seatingchart.canvasEdgeBuffer;
                if (widthEdge > canvasWidth)
                {
                    canvas.css("width", widthEdge + "px");
                }

                var canvasHeight = parseInt(canvas.css("height"), 10);
                var heightEdge = roomObject.position().top + parseInt(roomObject.css("height"), 10) + skyward.seatingchart.canvasEdgeBuffer;
                if (heightEdge > canvasHeight)
                {
                    canvas.css("height", heightEdge + "px");
                }
            };

            var toolboxObjectRevertFunction = function ()
            {
                return function (valid)
                {
                    if (valid)
                    {
                        var roomObject = $(this);
                        var newSeat = roomObject.clone();

                        var draggable = roomObject.data("ui-draggable").helper;
                        var draggablePosition = draggable.position();

                        newSeat.css("top", (draggablePosition.top + canvasScrollContainer.scrollTop()) + "px");

                        var left = parseInt(draggablePosition.left, 10) + parseInt(draggable.css("marginLeft"), 10) + canvasScrollContainer.scrollLeft() - parseInt(canvasScrollContainer.css("marginLeft"), 10) - roomLayoutModeTab.width();
                        if (left < 0)
                        {
                            return true;
                        }

                        newSeat.css("left", left + "px");

                        newSeat.addClass("roomObjectPlaced");
                        newSeat.removeClass("roomObjectList");
                        newSeat.appendTo(canvas);

                        var createAction = createAddAction(newSeat);
                        addUndoAction(createAction);

                        registerRoomObjectDraggable(newSeat, false, canvasObjectRevertFunction(canvas));
                        skyward.seatingchart.dirtyScreen();
                        return false;
                    }
                    else
                    {
                        return true;
                    }
                };
            };

            var canvasObjectRevertFunction = function ()
            {
                return function (valid)
                {
                    var selectedObjects = $(".roomObject.ui-selected");

                    if (isNullOrEmpty(selectedObjects))
                    {
                        return false;
					}

                    var deletedObjects = selectedObjects.filter(".roomObjectDeleted");
                    if (deletedObjects.length != 0)
                    {
                        // objects were dragged to the trash. revert the move so only the delete action is added
                        revertSelectedObjects(selectedObjects);
                        unselectRoomObjects(selectedObjects);
                        return true;
                    }

                    if (valid)
                    {
                        var isValid = true;

                        var roomObjectPositionValid = function (canvasObject)
                        {
                            if (canvasObject.position().left < 0 || canvasObject.position().top < 0)
                            {
                                isValid = false;
                            }
                        };

                        if (isValid)
                        {
                            selectedObjects.each(function ()
                            {
                                roomObjectPositionValid($(this));
                                return isValid;
                            });
                        }

                        if (!isValid)
                        {
                            revertSelectedObjects();
                            return true;
                        }

                        var oldPositions = getRoomObjectPositions(selectedObjects, true);
                        var moveAction = createMoveAction(selectedObjects, oldPositions);
                        addUndoAction(moveAction);

                        skyward.seatingchart.dirtyScreen();
                        return false;
                    }
                    else
                    {
                        revertSelectedObjects();
                        return true;
                    }
                };
            };

            var registerCanvasObjectDroppable = function (select)
            {
                select.droppable(
                    {
                        accept: ".studentImage",
                        hoverClass: "roomObjectHover"
                    });
            };

            var registerStudentDraggable = function (select, revertFunction)
            {
                initDraggable(select,
                    {
                        // this creates a clone of the picture element which will also redownload the picture. not ideal
                        // depending on server speed this downloading is very noticable.
                        // 'helper' can be a function that returns the element to be dragged and in that function we can do
                        // a manual copy like this https://stackoverflow.com/a/39089081
                        helper: 'clone',
                        start: function ()
                        {
                            $(this).css("visibility", "hidden");
                        },
                        drag: function (event, ui)
                        {
                            if (ui.helper.css("cursor") !== "move")
                            {
                                ui.helper.css("cursor", "move");
                            }
                            var templateMargin = parseInt($(this).css("marginLeft"), 10);
                            ui.position.left = ui.position.left + templateMargin;
                        },
                        revert: revertFunction
                    });
            };

            /** Get the actual X value of the RoomObject (without applied scaling) */
            var getRoomObjectX = function (roomObject)
            {
                return Math.floor(parseInt(roomObject.css("left"), 10) / currentScaleX);
            };

            /** Get the actual Y value of the RoomObject (without applied scaling) */
            var getRoomObjectY = function (roomObject)
            {
                return Math.floor(parseInt(roomObject.css("top"), 10) / currentScaleY);
            };

            /** Get the actual width of the RoomObject (without applied scaling) */
            var getRoomObjectWidth = function (roomObject)
            {
                return roomObject.outerWidth(true) / currentScaleX;
            };

            /** Get the actual height of the RoomObject (without applied scaling) */
            var getRoomObjectHeight = function (roomObject)
            {
                return roomObject.outerHeight(true) / currentScaleY;
            };

            var appendStudentToSeat = function (student, seat, skipAutoScale)
            {
                var studentId = student.data("studentid");

                var previousSeat = $(".roomObjectSeat:has([data-studentid='" + studentId + "'])");
                var noOtherStudent = student.siblings("img:not([data-studentid='" + studentId + "'])").length == 0;
                if (previousSeat.length && noOtherStudent)
                {
                    previousSeat.removeClass("roomObjectHasStudent");
                }

                seat.append(student);

                var labelContainer = $('#StudentListLabelContainer_' + studentId);
                if (labelContainer.length)
                {
                    seat.append(labelContainer);
                }

                var indicatorContainer = $('#StudentIndicatorContainer_' + studentId);
                if (indicatorContainer.length)
                {
                    seat.append(indicatorContainer);
                }

                if (!student.hasClass("studentImageSeated"))
                {
                    student.addClass("studentImageSeated");
                    student.removeClass("studentImageList");
                    var container = $("#StudentList_" + studentId);
                    if (container.length && !container.hasClass("studentInSeatingChart"))
                    {
                        container.addClass("studentInSeatingChart");
                        container.removeClass("assignFromStudentList");
                    }
                }

                if (!seat.hasClass("roomObjectHasStudent"))
                {
                    seat.addClass("roomObjectHasStudent");
                }

                student.css("visibility", "");

                if (skipAutoScale != true)
                {
                    autoScale();
				}

                checkUnassignedStudents();
            };

            var appendStudentToList = function (student)
            {
                var studentId = student.data("studentid");
                var container = $("#StudentList_" + studentId);
                if (container.length)
                {
                    container.removeClass("studentInSeatingChart");
                }
                else // Removing a student who is no longer in class
                {
                    container = $('<div/>');
                    container.attr('id', "#StudentList_" + studentId);
                    container.css('display', 'none');
                    $('#StudentList_body').append(container);
                }

                var previousSeat = $(".roomObjectSeat:has([data-studentid='" + studentId + "'])");
                var noOtherStudent = student.siblings("img:not([data-studentid='" + studentId + "'])").length == 0;
                if (previousSeat.length && noOtherStudent)
                {
                    previousSeat.removeClass("roomObjectHasStudent");
                }

                container.append(student);
                student.css("visibility", "");

                var labelContainer = $('#StudentListLabelContainer_' + studentId);
                if (labelContainer.length)
                {
                    container.append(labelContainer);
                }

                var indicatorContainer = $('#StudentIndicatorContainer_' + studentId);
                if (indicatorContainer.length)
                {
                    container.append(indicatorContainer);
                }

                student.addClass("studentImageList");
                student.removeClass("studentImageSeated");

                autoScale();

                checkUnassignedStudents();
            };

            var studentRevertFunction = function ()
            {
                return function (valid)
                {
                    var student = $(this);
                    var revert = false;

                    if (valid)
                    {
                        var studentId = student.data("studentid");
                        var location = $(valid);

                        if (location.hasClass("roomObjectSeat"))
                        {
                            var action;

                            if (location.has('.studentImageSeated:not([data-studentid="' + studentId + '"])').length)
                            {
                                var otherStudent = location.find(".studentImageSeated");

                                if (student.hasClass("studentImageSeated"))
                                {
                                    // swapping student seats
                                    var currStudentDesk = $(".roomObjectPlaced").has(student);

                                    appendStudentToSeat(student, location, true);
                                    appendStudentToSeat(otherStudent, currStudentDesk, true);
                                    autoScale();

                                    action = createSwapAssignAction(student, location, otherStudent, currStudentDesk);
                                }
                                else
                                {
                                    // assigned from list to an assigned seat
                                    appendStudentToList(otherStudent);
                                    appendStudentToSeat(student, location);

                                    action = createAssignAction(student, location, otherStudent);
                                }
                            }
                            else
                            {
                                var currStudentDesk = $(".roomObjectPlaced").has(student);
                                var studentNotAlreadyAssigned = location.find('.studentImageSeated[data-studentid="' + studentId + '"]').length == 0;
                                // dragging to an empty seat or one the student is already in
                                appendStudentToSeat(student, location);
                                if (studentNotAlreadyAssigned)
                                {
                                    if (currStudentDesk.length > 0)
                                    {
                                        action = createMoveAssignAction(student, location, currStudentDesk);
                                    }
                                    else
                                    {
                                        action = createAssignAction(student, location, currStudentDesk);
                                    }
                                }
                            }
                            if (action)
                            {
                                addUndoAction(action);
                            }
                        }
                        else
                        {
                            appendStudentToList(student);
                        }
                    }
                    else
                    {
                        setTimeout(function () { student.css("visibility", ""); }, skyward.seatingchart.durationForRevert);
                        revert = true;
                    }

                    if (revert == false)
                    {
                        skyward.seatingchart.dirtyScreen();
					}

                    return revert;
                };
            };

            var initDraggable = function (select, config)
            {
                config.appendTo = config.appendTo || skyward.seatingchart.draggingAppendTo;
                config.revertDuration = config.revertDuration || skyward.seatingchart.durationForRevert;
                var origStartEvent = config.start;
                config.start = function (event, ui)
                {
                    if (origStartEvent)
                    {
                        //Need to set the proper context for the method call
                        origStartEvent.call(this, event, ui);
                    }
                    // This is to fix the position the draggable object reverts to
                    ui.originalPosition.left += parseInt($(this).css("marginLeft"), 10);
                };
                config.distance = skyward.seatingchart.distanceBeforeDragging;

                select.draggable(config);
            };

            var freezeCanvas = function ()
            {
                removeRoomObjectDraggableEvents($(".roomObject"));
                removeStudentDraggableEvents($(".studentImage"));

                removeSelectable();

                skyward.seatingchart.saveLayer = skyward.modalLayer.newModalLayer(null, null, {
                    closeOnClick: false,
                    closeOnRecordSelected: false,
                    closeOnEscape: false
                });
            };

            var unFreezeCanvas = function ()
            {
                if (roomLayoutModeTab && roomLayoutModeTab.hasClass("current"))
                {
                    roomLayoutModeTab.trigger("tabClicked");
                }
                else if (studentModeTab && studentModeTab.hasClass("current"))
                {
                    studentModeTab.trigger("tabClicked");
                }

                if (skyward.seatingchart.saveLayer)
                {
                    skyward.seatingchart.saveLayer.close();
                }
            };

            var roomLayoutSave = function ()
            {
                var roomLayoutData = [];

                var hasDeletes = false;
                var roomObjects = $(".roomObjectPlaced, .roomObjectDeleted");
                roomObjects.each(function ()
                {
                    var roomObject = $(this);

                    var roomLayoutObjectId = roomObject.data("roomlayoutobjectid");
                    var roomObjectId = roomObject.data("roomobjectid");
                    var xLocation = getRoomObjectX(roomObject);
                    var yLocation = getRoomObjectY(roomObject);
                    var rotation = 0;
                    var isDelete = roomObject.hasClass("roomObjectDeleted");
                    if (isDelete && !hasDeletes)
                    {
                        hasDeletes = true;
					}

                    roomLayoutData.push(
                        {
                            roomLayoutObjectId: roomLayoutObjectId,
                            roomObjectId: roomObjectId,
                            xLocation: xLocation,
                            yLocation: yLocation,
                            rotation: rotation,
                            isDelete: isDelete
                        });
                });

                if (hasDeletes && hasPendingDeletesThatHaveStudents)
                {
                    showWarningBanner(moduleContent);
                    return;
                }
                else
                {
                    hideWarningBanner(moduleContent);
				}

                freezeCanvas();

                //Need to modify this to send the DisplayPeriodID, RoomID, and StaffID
                var roomLayoutSaveData =
                {
                    RoomLayoutObjectData: JSON.stringify(roomLayoutData),
                    RoomLayoutID: roomLayoutId
                };

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/RoomLayout/SaveRoomLayout/',
                        type: "POST",
                        dataType: "JSON",
                        data: roomLayoutSaveData,
                        error: function ()
                        {
                            skyward.seatingchart.saveLayer.close();
                            saveSeatingChartButton.on('click', seatingChartSaveButton);
                            unFreezeCanvas();
                        },
                        success: function (response)
                        {
                            if (!response.success)
                            {
                                skyward.seatingchart.saveLayer.close();
                                showErrorDialog("There was an error saving the Room Layout", response.Errors);
                                unFreezeCanvas();
                            }
                            else
                            {
                                saveSeatingChartButton.hide();
                                cancelSeatingChartButton.hide();
                                $.when(showSaveBanner(getCMAContainer()).done(function ()
                                {
                                    skyward.changeTracking.overrideGlobalDirtyState(false);
                                    skyward.window.reloadScreen();
                                }));
                            }
                        }
                    });
            };

            var seatingChartSave = function ()
            {
                var roomLayoutData = [];
                var seatingChartSeatData = [];

                var roomObjects = $(".roomObjectPlaced, .roomObjectDeleted");
                roomObjects.each(function ()
                {
                    var roomObject = $(this);

                    var roomLayoutObjectId = roomObject.data("roomlayoutobjectid");
                    var roomObjectId = roomObject.data("roomobjectid");
                    var xLocation = getRoomObjectX(roomObject);
                    var yLocation = getRoomObjectY(roomObject);
                    var rotation = 0;
                    var isDelete = roomObject.hasClass("roomObjectDeleted");
                    var studentId = null;

                    var student = roomObject.find(".studentImage");
                    if (student.length)
                    {
                        studentId = student.data("studentid");
                        seatingChartSeatData.push(
                            {
                                seatingChartSeatid: student.data("seatingchartseatid"),
                                originalRoomLayoutObjectId: student.data("originalroomlayoutobjectid"),
                                roomLayoutObjectId: roomLayoutObjectId,
                                studentId: studentId
                            });
                    }

                    roomLayoutData.push(
                        {
                            roomLayoutObjectId: roomLayoutObjectId,
                            roomObjectId: roomObjectId,
                            xLocation: xLocation,
                            yLocation: yLocation,
                            rotation: rotation,
                            isDelete: isDelete,
                            studentId: studentId
                        });
                });

                var studentListStudents = $(".studentImageList[data-seatingchartseatid]");
                studentListStudents.each(function ()
                {
                    var student = $(this);
                    var studentId = student.data("studentid");
                    var studentSeatingChartSeatId = student.data("seatingchartseatid");
                    if (studentSeatingChartSeatId)
                    {
                        seatingChartSeatData.push(
                            {
                                seatingChartSeatid: studentSeatingChartSeatId,
                                roomLayoutObjectId: null,
                                studentId: studentId
                            });
                    }
                });

                removeErrorBorder(getRoomObjects());

                freezeCanvas();

                //Need to modify this to send the DisplayPeriodID, RoomID, and StaffID
                var seatingChartSaveData =
                {
                    RoomLayoutObjectData: JSON.stringify(roomLayoutData),
                    SeatingChartSeatData: JSON.stringify(seatingChartSeatData),
                    DisplayPeriodID: displayPeriodId,
                    RoomID: roomId,
                    MeetID: meetId,
                    SeatingChartID: seatingChartId
                };

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/' + (saveObject ? saveObject : "SeatingChart") + '/SaveSeatingChart/',
                        type: "POST",
                        dataType: "JSON",
                        data: seatingChartSaveData,
                        error: function ()
                        {
                            skyward.seatingchart.saveLayer.close();
                            saveSeatingChartButton.on('click', seatingChartSaveButton);
                            unFreezeCanvas();
                        },
                        success: function (response)
                        {
                            if (!response.success)
                            {
                                skyward.seatingchart.saveLayer.close();
                                showErrorDialog("There was an error saving the Seating Chart", response.ErrorsHTML);
                                selectErroredRoomObjects(response.Errors);
                                unFreezeCanvas();
                            }
                            else
                            {
                                saveSeatingChartButton.hide();
                                cancelSeatingChartButton.hide();
                                $.when(showSaveBanner(getCMAContainer()).done(function ()
                                {
                                    skyward.changeTracking.overrideGlobalDirtyState(false);
                                    skyward.window.reloadScreen();
                                }));
                            }
                        }
                    });
            };

            var selectErroredRoomObjects = function (errors)
            {
                removeErrorBorder(getRoomObjects());

                if (errors == null || errors.length == 0)
                {
                    return;
                }

                $.each(errors, function (fieldName, errors)
                {
                    if (fieldName)
                    {
                        var parts = fieldName.split("-");
                        if (parts.length >= 2 && parts[0] === "RoomLayoutObject" && parts[1])
                        {
                            var roomLayoutObjectID = parts[1];
                            var roomLayoutObject = getCanvasObjectsFromSelector(".roomObjectPlaced[data-roomlayoutobjectid='" + roomLayoutObjectID + "']");
                            if (!isNullOrEmpty(roomLayoutObject) && !roomLayoutObject.hasClass("roomObjectError"))
                            {
                                roomLayoutObject.addClass("roomObjectError")
                            }
                        }
                    }
                });
            };

            var isGeneralTabActive = function ()
            {
                return $("#tabGeneral.current").length > 0;
            };

            var isPopupActive = function ()
            {
                return $(".popup").length > 0;
            };

            var getCMAContainer = function ()
            {
                if (isInDetailsPanel)
                {
                    return seatingChartContentArea.parents(".contentArea");
                }
                else
                {
                    return moduleContent;
				}
            };

            var showSaveBanner = function (container)
            {
                var deferred = new $.Deferred();
                var cmaObject = getCMAObject(container);

                $('.contentMessageArea:not(#RoomLayoutObjectStudentsCMA)').on('SaveAnimationRedirect', function ()
                {
                    deferred.resolve();
                });

                cmaObject.setConfirmationMessage(skyward.contentMessageArea.getDefaultConfirmationMessage());
                cmaObject.showConfirmation();

                return deferred.promise();
            };

            var showWarningBanner = function (container)
            {
                hasPendingDeletesThatHaveStudents = false;

                var cmaObject = getCMAObject(container);
                cmaObject.setValidationCount(0, 1);
                cmaObject.showValidation();
            };

            var hideWarningBanner = function (container)
            {
                var cmaObject = getCMAObject(container);
                cmaObject.resetValidation();
            };

            var getCMAObject = function (container)
            {
                var cmaObject = skyward.contentMessageArea.getContentMessageArea(container);

                if (cmaObject == null)
                {
                    cmaObject = skyward.contentMessageArea.getContentMessageArea(container.parent());
                }

                if (cmaObject == null)
                {
                    cmaObject = skyward.contentMessageArea.getContentMessageArea($(".contentArea"));
                }

                return cmaObject;
            };

            var seatingChartSaveButton = function ()
            {
                saveSeatingChartButton.off();
                $.when(saveObject == 'RoomLayout' ? roomLayoutSave() : seatingChartSave()).then(function ()
                {
                    saveSeatingChartButton.on("click", seatingChartSaveButton);
                });
            };

            var seatingChartCancel = function ()
            {
                freezeCanvas();
                skyward.changeTracking.overrideGlobalDirtyState(false);
                skyward.window.reloadScreen();
            };

            var seatingChartAddSeat = function ()
            {
                if (saveSeatingChartButton.is(":hidden"))
                {
                    var html = (displayMaxSeats ? "<span class='reference-slats static' style='width: 202px; max-width: 210px; margin: 0px; margin-left: 7px; text-align: center;'>" +
                        "<span class='slatLabel'>Maximum Number of Seats</span>" +
                        "<span class='slatData'>" + maxSeats + "</span></span>" : "") +
                        "<div class='fieldWrapper AddSeatFieldset'>" +
                        "<label class='title' data-validate-text-for='NumberOfRows'>Number of Rows: </label>" +
                        "<input id='NumberOfRows' class='text AddSeatTextbox' data-decimal-mask='99' data-validate-control-for='NumberOfRows'></input>" +
                        "</div>" +
                        "<fieldWrapper class='fieldWrapper AddSeatFieldset'>" +
                        "<label class='title' data-validate-text-for='NumberOfColumns'>Number of Seats Per Row: </label>" +
                        "<input id='NumberOfColumns' class='text AddSeatTextbox' data-decimal-mask='99' data-validate-control-for='NumberOfColumns'></input>" +
                        "</div>";

                    html.prepen
                    showMessageBoxAddSeat(html);
                }
                else
                {
                    showUnsavedChangesDialog($(this));
                }
            };

            var showMessageBoxAddSeat = function (html)
            {
                var messageBox;
                var saveButton = { text: "Save", "click": saveSeats, "icon": "Save" };
                var cancelButton = { text: "Cancel", "click": function () { messageBox.close(); }, "icon": "Cancel" };
                skyward.window.closePopup();
                messageBox = skyward.modalLayer.showDialog("Add Seats", html, [saveButton, cancelButton]);
                messageBox.container.css("min-width", "0px");
            };

            var saveSeats = function ()
            {
                var button = $(this);
                button.off('click');
                var baseStartingValue = 50;
                var rows = $('#NumberOfRows').val();
                var columns = $('#NumberOfColumns').val();

                var startingNumberColumn = 0;
                var startingNumberRow = 0;

                var roomObjects = $(".roomObjectPlaced");
                roomObjects.each(function ()
                {
                    var roomObject = $(this);

                    // The values we save must be transformed back to actual rather than scaled values
                    var xLocation = getRoomObjectX(roomObject);
                    var width = parseInt(roomObject.css("width"), 10);

                    var rowNumber = xLocation + width;
                    if (rowNumber > startingNumberRow)
                    {
                        startingNumberRow = rowNumber;
                    }

                    var yLocation = getRoomObjectY(roomObject);

                    if (startingNumberColumn == 0 || yLocation < startingNumberColumn)
                    {
                        startingNumberColumn = yLocation;
                    }
                });

                if (startingNumberColumn == 0)
                {
                    startingNumberColumn = baseStartingValue;
                }
                startingNumberRow += baseStartingValue;

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/RoomLayout/AddSeatingChartSeats/',
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            NumberOfRows: JSON.stringify(rows),
                            NumberOfColumns: JSON.stringify(columns),
                            RoomID: roomId,
                            RoomLayoutID: roomLayoutId,
                            StartingNumberColumn: startingNumberColumn,
                            StartingNumberRow: startingNumberRow,
                            SeatingChartId: seatingChartId
                        },
                        success: function (response)
                        {
                            if (!response.success)
                            {
                                button.on('click', saveSeats);
                                showErrorDialog("There was an error saving the Seating Chart", response.Errors);
                            }
                            else
                            {
                                skyward.window.setSkipUnloadCheck(true);
                                skyward.window.reloadScreen();
                            }
                        },
                        error: function ()
                        {
                            // skyward exception dialog is shown
                            button.on('click', saveSeats);
                        }
                    });
            };

            var seatingChartAssignStudents = function ()
            {
                if (saveSeatingChartButton.is(":hidden"))
                {
                    showMessageBoxAddStudents();
                }
                else
                {
                    showUnsavedChangesDialog($(this));
                }
            };

            var showUnsavedChangesDialog = function (button)
            {
                var message = "There are unsaved changes on the seating chart.  Please save or cancel before continuing.";
                var options =
                {
                    anchorTo: button,
                    id: "UnsavedSeatingChart",

                };
                var closeButton = { id: "closeUnsavedSeatingChartPopup", text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var dialog = skyward.modalLayer.showDialog('Unsaved Changes', message, [closeButton], options);
                event.stopPropagation();
                return;
            }

            var showErrorDialog = function (message, errorMessageContent)
            {
                var errorContentHtml = message + "<br><br>" + errorMessageContent.Content;

                skyward.modalLayer.showCriticalDialog("Error", errorContentHtml);
            };

            var showMessageBoxAddStudents = function ()
            {
                let buildPopup = function ()
                {
                    return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/SeatingChart/BuildAssignSeatingChartSeatsPopup/',
                        type: "POST",
                        dataType: "viewparthtml",
                        data:
                        {
                            SeatingChartId: seatingChartId
                        }
                    });
                }

                var messageBox;
                var saveButton = { text: "Save", "click": assignStudents, "icon": "Save" };
                var cancelButton = { text: "Cancel", "click": function () { messageBox.close(); }, "icon": "Cancel" };
                skyward.window.closePopup();
                messageBox = skyward.modalLayer.showDialog("Auto Assign Seats", buildPopup, [saveButton, cancelButton]);
            };

            var assignStudents = function ()
            {
                var button = $(this);
                button.off('click');
                var radioGroupValue = $('#AssignStudents').val();
                var ascendingOrderGroupValue = $('#AscendingOrder').val();
                var roomLayoutData = [];
                var seatingChartSeatData = [];

                removeErrorBorder(getRoomObjects());

                var roomObjects = $(".roomObjectPlaced.roomObjectSeat, .roomObjectDeleted.roomObjectSeat");
                roomObjects.each(function ()
                {
                    var roomObject = $(this);

                    var roomLayoutObjectId = roomObject.data("roomlayoutobjectid");
                    var roomObjectId = roomObject.data("roomobjectid");
                    var xLocation = getRoomObjectX(roomObject);
                    var yLocation = getRoomObjectY(roomObject);
                    var rotation = 0;
                    var isDelete = roomObject.hasClass("roomObjectDeleted");
                    var studentId = null;

                    var student = roomObject.find(".studentImage");
                    if (student.length)
                    {
                        studentId = student.data("studentid");
                        seatingChartSeatData.push(
                            {
                                seatingChartSeatid: student.data("seatingchartseatid"),
                                roomLayoutObjectId: roomLayoutObjectId,
                                studentId: studentId
                            });
                    }

                    roomLayoutData.push(
                        {
                            roomLayoutObjectId: roomLayoutObjectId,
                            roomObjectId: roomObjectId,
                            xLocation: xLocation,
                            yLocation: yLocation,
                            rotation: rotation,
                            isDelete: isDelete,
                            studentId: studentId
                        });
                });

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/SeatingChart/AssignSeatingChartSeats/',
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            RadioGroupValue: radioGroupValue,
                            AscendingOrderGroupValue: ascendingOrderGroupValue,
                            RoomLayoutObjectData: JSON.stringify(roomLayoutData),
                            SeatingChartSeatData: JSON.stringify(seatingChartSeatData),
                            RoomID: roomId,
                            SeatingChartId: seatingChartId
                        },
                        success: function (response)
                        {
                            if (!response.success)
                            {
                                button.on('click', assignStudents);
                                showErrorDialog("There was an error saving the Seating Chart", response.ErrorsHTML);
                                selectErroredRoomObjects(response.Errors);
                            }
                            else
                            {
                                skyward.window.loadContent('full', 'Attendance', 'SeatingChart', 'Details', seatingChartId, { tab: "tabGeneral", "RoomID": roomId, "screenObject": "SeatingChart" });
                                skyward.window.setSkipUnloadCheck(true);
                            }
                        },
                        error: function ()
                        {
                            // skyward exception dialog is shown
                            button.on('click', assignStudents);
                        }
                    });
            };

            var seatingChartGridCheckbox = function ()
            {
                if (this.checked)
                {
                    skyward.seatingchart.snapToGrid(true);
                    gridIncreaseButton.css("display", "");
                    gridDecreaseButton.css("display", "");
                }
                else
                {
                    skyward.seatingchart.snapToGrid(false);
                    gridIncreaseButton.css("display", "none");
                    gridDecreaseButton.css("display", "none");
                }
            };

            var seatingChartGridIncrease = function ()
            {
                if (gridLineSizeValueX < skyward.seatingchart.gridLineMaxSize && gridLineSizeValueY < skyward.seatingchart.gridLineMaxSize)
                {
                    skyward.seatingchart.gridLineSize(gridLineSizeValueX * 2, gridLineSizeValueY * 2);
                }
            };

            var seatingChartGridDecrease = function ()
            {
                if (gridLineSizeValueX > skyward.seatingchart.gridLineResizeStep && gridLineSizeValueY > skyward.seatingchart.gridLineResizeStep)
                {
                    skyward.seatingchart.gridLineSize(gridLineSizeValueX / 2, gridLineSizeValueY / 2);
                }
            };

            var selectNewSeatingChart = function ()
            {
                var seatingChartData = $("#seatingChartData");
                var displayPeriodId = seatingChartData.data("displayperiodid");
                var roomId = seatingChartData.data("roomid");
                var seatingChartAction = "select";

                var selectSeatingChartsSaveData =
                {
                    DisplayPeriodID: displayPeriodId,
                    RoomID: roomId,
                    MeetID: meetId,
                    CurrentSeatingChartID: seatingChartId
                };

                var buildSelectNewSeatingChartPopup = function ()
                {
                    var seatingChartDescription = $("#seatingChartDescription").val();
                    selectSeatingChartsSaveData.Description = seatingChartDescription;

                    return $.ajax({
                        url: skyward.global.virtualDir + 'Attendance/SeatingChartMeet/SelectSeatingChartPopup/',
                        type: "POST",
                        dataType: "viewparthtml",
                        data: selectSeatingChartsSaveData
                    });
                };

                var saveButton =
                {
                    id: "saveNewSeatingChart",
                    text: "Save",
                    click: function ()
                    {
                        var seatingChartID = skyward.controls.getValue(dialog.content.find('#SelectSeatingChartEEL'));
                        var seatingChartNameSaveData =
                        {
                            SeatingChartAction: seatingChartAction,
                            SeatingChartID: seatingChartID,
                            DisplayPeriodId: displayPeriodId,
                            RoomID: roomId
                        };

                        return $.ajax(
                            {
                                url: skyward.global.virtualDir + 'Attendance/SeatingChartMeet/SelectSeatingChart/',
                                type: "POST",
                                dataType: "JSON",
                                data: seatingChartNameSaveData,
                                success: function (response)
                                {
                                    if (!response.success)
                                    {
                                        var container = $('.messageBox.content');
                                        var baseErrorContainer = container.find("#SelectSeatingChartError");

                                        skyward.validation.displayValidationMessages(response, container, baseErrorContainer);
                                    }
                                    else
                                    {
                                        location.reload();
                                        dialog.close();
                                    }
                                }
                            });
                    },
                    icon: "Save"
                };
                var cancelButton =
                {
                    id: "cancelNewSeatingChart",
                    text: "Cancel",
                    click: function ()
                    {
                        dialog.close();
                    },
                    icon: "Cancel"
                };
                var options =
                {
                    width: 550
                };
                var dialog = skyward.modalLayer.showDialog("Select Seating Chart", buildSelectNewSeatingChartPopup, [saveButton, cancelButton], options);
            };

            var attachListeners = function ()
            {
                $(window).resize(canvasResize);

                saveSeatingChartButton.off().on("click", seatingChartSaveButton);
                cancelSeatingChartButton.off().on("click", seatingChartCancel);
                addSeatSeatingChartButton.off().on("click", seatingChartAddSeat);

                if (isSeatingChartDetails && getRoomObjects().length == 0 && assignStudentsSeatingChartButton.length > 0)
                {
                    skyward.controls.disable(assignStudentsSeatingChartButton);
                }
                else
                {
                    assignStudentsSeatingChartButton.off().on("click", seatingChartAssignStudents);
				}

                gridEnableCheckbox.change(seatingChartGridCheckbox);
                // Ensure the initial visibility of the grid is correct
                seatingChartGridCheckbox.call(gridEnableCheckbox[0] /* seatingChartGridCheckbox expects "this" to be a DOMElement, not $ */);

                gridIncreaseButton.off().on("click", seatingChartGridIncrease);
                gridDecreaseButton.off().on("click", seatingChartGridDecrease);

                selectNewSeatingChartButton.off().on("click", selectNewSeatingChart);

                if (displayIndicators && displayIndicators.length > 0)
                {
                    displayIndicators.change(toggleIndicators);
                }

                if (isRoomLayoutDetails)
                {
                    enableDiableStudentPopupClick(true);
                    $(window).on("keydown", roomLayoutKeyDown);
                }

                if (isRoomLayoutDetails || isSeatingChartDetails)
                {
                    canvas.mouseup(canvasClicked);

                    undoButton.click(undo);
                    redoButton.click(redo);

                    $(window).keyup(function ()
                    {
                        pressedKey = null;
                    });
                }

                if (isSeatingChartDetails)
                {
                    $(window).keydown(seatingChartKeyDown);
                    $(".roomObjectPlaced").hover(roomObjectMouseEnter, roomObjectMouseLeave);
                    checkUnassignedStudents();

                    $(window).contextmenu(canvasContextMenu);
                }

                if (isSeatingChartDetails || isDailyAttendance)
                {
                    attachStudentInfoClick(seatingChartContent);
                }


            };

            var enableDiableStudentPopupClick = function (enable)
            {
                if (enable)
                {
                    seatingChartContent.find(".roomObjectStudents").on("click", roomLayoutDetailsStudentsClick);
                }
                else
				{
                    seatingChartContent.find(".roomObjectStudents").off("click");
				}
            };

            var setScale = function (scaleX, scaleY)
            {
                $(selector + ' .roomObjectPlaced').each(function ()
                {
                    var objectToScale = $(this);
                    var newTop = Math.round((getRoomObjectY(objectToScale) * scaleY));
                    var newLeft = Math.round((getRoomObjectX(objectToScale) * scaleX));

                    this.style.width = (getRoomObjectWidth(objectToScale) * scaleX) + 'px';
                    this.style.height = (getRoomObjectHeight(objectToScale) * scaleY) + 'px';
                    this.style.left = newLeft + 'px';
                    this.style.top = newTop + 'px';
                });

                // The canvas also needs to be resized to ensure all the scaled desks fit on it
                canvasResize();
                // Grid must be reset and adjusted for the new scale values
                skyward.seatingchart.gridLineSize(defaultGridLineSizeValueX * scaleX, defaultGridLineSizeValueY * scaleY);

                // This happens last, as getRoomObjectX/Y depend currentScaleX/Y not being updated to newly passed in values
                currentScaleX = scaleX;
                currentScaleY = scaleY;
            };

            var autoScale = function ()
            {
                // measure every desk
                var placedDesks = $(selector + ' .roomObjectPlaced.roomObjectSeat');

                // No need to scale if there's nothing to scale
                if (placedDesks.length === 0)
                {
                    return;
                }

                var measureSelector = '.studentIndicatorContainer,.visualLabel,.seatingChartAttendanceDropdownContainer,.seatingChartAttendanceRadioButtonContainer';
                var maxTotalHeight = 0;

                // Assumes every student desk is the same height
                var studentDeskHeight = getRoomObjectHeight(placedDesks.eq(0));

                placedDesks.each(function ()
                {
                    var totalHeight = 0;
                    $(this).find(measureSelector).not(".roomObjectOfficeLabel,.radioButton.vertical").each(function ()
                    {
                        var toMeasure = $(this);
                        totalHeight += toMeasure.outerHeight(true);
                    });

                    if (totalHeight > maxTotalHeight)
                    {
                        maxTotalHeight = totalHeight;
                    }
                });

                var calculatedScaleFactor = maxTotalHeight / studentDeskHeight;
                // Currently, only scale up from original values, never down (downscaling not needed to fit indicators)
                if (calculatedScaleFactor < 1)
                {
                    calculatedScaleFactor = 1;
                }
                setScale(1, calculatedScaleFactor);
            };

            skyward.seatingchart.dirtyScreen = function ()
            {
                skyward.seatingchart.setDirtyState(true);
            };

            skyward.seatingchart.setDirtyState = function (isDirty)
            {
                if (isDirty)
                {
                    if (saveSeatingChartButton.is(":hidden"))
                    {
                        saveSeatingChartButton.show();
                    }
                    if (cancelSeatingChartButton.is(":hidden"))
                    {
                        cancelSeatingChartButton.show();
                    }
                }
                else
                {
                    if (!saveSeatingChartButton.is(":hidden"))
                    {
                        saveSeatingChartButton.hide();
                    }
                    if (!cancelSeatingChartButton.is(":hidden"))
                    {
                        cancelSeatingChartButton.hide();
                    }
                }
                skyward.changeTracking.overrideGlobalDirtyState(isDirty);
            };

            var removeStudentDraggableEvents = function (studentImages)
            {
                if (studentImages.data("ui-draggable"))
                {
                    studentImages.each(function ()
                    {
                        var currStudentImage = $(this);
                        if (currStudentImage.data("ui-draggable"))
                        {
                            currStudentImage.draggable("destroy");
                        }
                    });
                }
            };

            var removeRoomObjectDraggableEvents = function (roomObjects)
            {
                if (roomObjects.data("ui-draggable"))
                {
                    roomObjects.each(function ()
                    {
                        var currRoomObject = $(this);
                        if (currRoomObject.data("ui-draggable"))
                        {
                            currRoomObject.draggable("destroy");
                        }
                    });
                }
            };

            var removeSelectable = function ()
            {
                if (canvas.data("ui-selectable"))
                {
                    canvas.selectable("destroy");
                    $(".ui-selectee").removeClass("ui-selectee");
                    $(".ui-selected").removeClass("ui-selected");
                    $(".ui-selecting").removeClass("ui-selecting");

                    var selectBox = $(".ui-selectable-helper");
                    if (selectBox.length)
                    {
                        selectBox.remove();
                    }
                }
            };

            var canvasResize = function ()
            {
                var canvasWidth = 0;
                var canvasHeight = 0;

                $(".roomObjectPlaced").each(function ()
                {
                    var currRoomObject = $(this);
                    var widthEdge = parseInt(currRoomObject.css("left"), 10) + parseInt(currRoomObject.css("width"), 10);

                    if (widthEdge > canvasWidth)
                    {
                        canvasWidth = widthEdge;
                    }

                    var heightEdge = parseInt(currRoomObject.css("top"), 10) + parseInt(currRoomObject.css("height"), 10);
                    if (heightEdge > canvasHeight)
                    {
                        canvasHeight = heightEdge;
                    }
                });

                var seatingChartContent = $("#seatingChartContent");

                if (seatingChartContent.length && moduleContent.length)
                {
                    var containerWidth = parseInt(canvasScrollContainer.css("width"), 10);
                    // Need to get the height relative to moduleContent because on save or cancel reload, it does not size correctly
                    var containerHeight = parseInt(moduleContent.css("height"), 10) - seatingChartContent.position().top;

                    if (canvasWidth < containerWidth)
                    {
                        canvasWidth = containerWidth;
                    }
                    if (canvasHeight < containerHeight)
                    {
                        canvasHeight = containerHeight;
                    }

                    canvas.css("width", (canvasWidth + skyward.seatingchart.canvasEdgeBuffer) + "px");
                    canvas.css("height", (canvasHeight + skyward.seatingchart.canvasEdgeBuffer) + "px");
                }
            };

            var toggleIndicators = function ()
            {
                var showIndicators = this.checked;
                var data =
                {
                    displayIndicators: showIndicators,
                    staffMeetSettingID: $(this).data("staffmeetsettingid")
                };

                $.ajax({
                    activityIndicator: { silent: true },
                    url: skyward.global.virtualDir + 'Attendance/SeatingChart/ToggleIndicators/',
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                });

                // we can still perform the toggle regardless if the staff meet setting ajax succeeded.
                var seatingChartContent = $(this).parents(skyward.seatingchart.seatingChartContentSelector);
                setIndicatorVisibility(showIndicators, seatingChartContent);
            };

            var setIndicatorVisibility = function (show, seatingChartContent)
            {
                seatingChartContent.find(".studentIndicatorContainer").each(function ()
                {
                    if (show)
                    {
                        $(this).removeClass("displayNone");
                    }
                    else
                    {
                        $(this).addClass("displayNone");
                    }
                })

                seatingChartContent.find(".studentNameLabel").each(function ()
                {
                    var studentLabel = $(this);
                    if (!isNullOrEmpty(studentLabel) && studentLabel.data("hasactivecriticalalert") === "True")
                    {
                        if (show)
                        {
                            studentLabel.addClass("hasActiveCriticalAlert");
                        }
                        else
                        {
                            studentLabel.removeClass("hasActiveCriticalAlert");
                        }
                    }
                });

            };

            var deleteKeyName = 'delete';
            var arrowLeft = 'arrowleft';
            var arrowRight = 'arrowright';
            var arrowUp = 'arrowup';
            var arrowDown = 'arrowdown';
            var copyKey = 'keyc';
            var cutKey = 'keyx';
            var pasteKey = 'keyv';
            var selectAllKey = 'keya';
            var undoKey = 'keyz';
            var redoKey = 'keyy';

            var controlLeft = 'controlleft';
            var controlRight = 'controlright';
            var pressedKey = null;

            var copiedRoomObjects = [];

            var undoStack = [];
            var redoStack = [];

            var createAction = 'create';
            var moveAssignAction = 'moveAssign';
            var swapAssignAction = 'swapAssign';
            var moveAction = 'move';
            var deleteAction = 'delete';
            var assignAction = 'assign';
            var unassignAction = 'unassign';

            var leftClick = 1;
            var rightClick = 3;

            var hasPendingDeletesThatHaveStudents = false;

            var roomLayoutKeyDown = function (event)
            {
                var keyName = event.code ? event.code.toLowerCase() : undefined;
                if (!isGeneralTabActive() || isPopupActive() || !keyName || !beginKeyDown(keyName))
                {
                    return;
                }

                if (event.ctrlKey)
                {
                    switch (keyName)
                    {
                        case cutKey:
                            cutSelectedRoomObjects();
                            break;
                        case copyKey:
                            copySelectedRoomObjects();
                            break;
                        case pasteKey:
                            pasteRoomObjects();
                            break;
                        case selectAllKey:
                            selectAllRoomObjects();
                            break;
                        case undoKey:
                            undo();
                            break;
                        case redoKey:
                            redo();
                            break;
                        default:
                            break;
                    }
                }
                else
                {
                    switch (keyName)
                    {
                        case deleteKeyName:
                            deleteSelectedRoomObjects(true);
                            break;
                        case arrowLeft:
                        case arrowRight:
                        case arrowUp:
                        case arrowDown:
                            arrowKeyMoveRoomObjects(keyName);
                            break;
                        default:
                            break;
                    }
                }
            };

            var seatingChartKeyDown = function (event)
            {
                var keyName = event.code.toLowerCase();
                if (!isGeneralTabActive() || isPopupActive() || !beginKeyDown(keyName))
                {
                    return;
                }

                if (event.ctrlKey)
                {
                    switch (keyName)
                    {
                        case undoKey:
                            undo();
                            break;
                        case redoKey:
                            redo();
                            break;
                        default:
                            break;
                    }
                }
            };

            var beginKeyDown = function (keyName)
            {
                preventKeyDefault(keyName, event.ctrlKey);
                if (pressedKey != null && pressedKey === keyName)
                {
                    return false;
                }

                // dont count the control keys as pressing a button
                if (keyName != controlLeft && keyName != controlRight)
                {
                    pressedKey = keyName;
                }

                return true;
            }

            var addUndoAction = function (undoAction)
            {
                redoStack.length = 0;

                undoStack.push(undoAction);

                setUndoRedoButton();
            }

            var setUndoRedoButton = function ()
            {
                var enableDisable = function (button, stack)
                {
                    if (!isNullOrEmpty(button))
                    {
                        if (stack.length > 0)
                        {
                            skyward.controls.enable(button);
                        }
                        else
                        {
                            skyward.controls.disable(button);
                        }
                    }
                };

                enableDisable(undoButton, undoStack);
                enableDisable(redoButton, redoStack);
            };

            var undo = function ()
            {
                if (undoStack.length == 0)
                {
                    return;
                }

                var action = undoStack.pop();
                var redoAction = switchAction(action);
                executeUndoRedoAction(action);
                redoStack.push(redoAction);

                if (undoStack.length == 0)
                {
                    skyward.seatingchart.setDirtyState(false);
				}

                setUndoRedoButton();
            };

            var redo = function ()
            {
                if (redoStack.length == 0)
                {
                    return;
                }

                var action = redoStack.pop();
                var undoAction = switchAction(action);
                executeUndoRedoAction(action);
                undoStack.push(undoAction);

                skyward.seatingchart.dirtyScreen();

                setUndoRedoButton();
            };

            var createMoveAction = function (roomObjects, oldPositions)
            {
                var newAction =
                {
                    action: moveAction,
                    data:
                    {
                        roomObjects: roomObjects,
                        oldPositions: oldPositions
                    }
                };

                return newAction;
            };

            var createUnassignAction = function (student, roomObject)
            {
                var newAction =
                {
                    action: unassignAction,
                    data:
                    {
                        student: student,
                        roomObject: roomObject,
                    }
                };

                return newAction;
            };

            var createSwapAssignAction = function (student, roomObject, otherStudent, otherRoomObject)
            {
                var newAction =
                {
                    action: swapAssignAction,
                    data:
                    {
                        student: student,
                        roomObject: roomObject,
                        otherStudent: otherStudent,
                        otherRoomObject: otherRoomObject
                    }
                };

                return newAction;
            };

            var createMoveAssignAction = function (student, roomObject, oldRoomObject)
            {
                var newAction =
                {
                    action: moveAssignAction,
                    data:
                    {
                        student: student,
                        roomObject: roomObject,
                        oldRoomObject: oldRoomObject,
                    }
                };

                return newAction;
            };

            var createAssignAction = function (student, roomObject, otherStudent)
            {
                var newAction =
                {
                    action: assignAction,
                    data:
                    {
                        student: student,
                        roomObject: roomObject,
                        otherStudent: otherStudent
                    }
                };

                return newAction;
            };

            var createAddAction = function (roomObjects)
            {
                var newAction =
                {
                    action: createAction,
                    data:
                    {
                        roomObjects: roomObjects,
                    }
                };

                return newAction;
            };

            var createDeleteAction = function (roomObjects)
            {
                var newAction =
                {
                    action: deleteAction,
                    data:
                    {
                        roomObjects: roomObjects,
                    }
                };

                return newAction;
            };

            var switchAction = function (undoRedoAction)
            {
                if (!undoRedoAction || !undoRedoAction.action || !undoRedoAction.data)
                {
                    return;
                }

                var action = undoRedoAction.action;
                var data = undoRedoAction.data;

                switch (action)
                {
                    case moveAction:
                        data =
                        {
                            oldPositions: getRoomObjectPositions(data.roomObjects),
                            roomObjects: data.roomObjects
                        };
                        break;
                    case deleteAction:
                        action = createAction;
                        break;
                    case createAction:
                        action = deleteAction;
                        break;
                    case moveAssignAction:
                        data =
                        {
                            student: data.student,
                            roomObject: data.oldRoomObject,
                            oldRoomObject: data.roomObject,
                        };
                        break;
                    case swapAssignAction:
                        data =
                        {
                            student: data.student,
                            roomObject: data.otherRoomObject,
                            otherStudent: data.otherStudent,
                            otherRoomObject: data.roomObject
                        };
                        break;
                    case assignAction:
                        if (!isNullOrEmpty(data.otherStudent))
                        {
                            data =
                            {
                                student: data.otherStudent,
                                roomObject: data.roomObject,
                                otherStudent: data.student
                            };
                        }
                        else
                        {
                            action = unassignAction;
						}
                        break;
                    case unassignAction:
                        action = assignAction;
                        break;
                    default:
                        break;
                }

                var newAction =
                {
                    action: action,
                    data: data
                }

                return newAction;
            };

            var executeUndoRedoAction = function (undoRedoAction)
            {
                if (!undoRedoAction || !undoRedoAction.action || !undoRedoAction.data)
                {
                    return;
                }

                var action = undoRedoAction.action;
                var data = undoRedoAction.data;

                switch (action)
                {
                    case moveAction:
                        $.each(data.oldPositions, function (index, oldPosition)
                        {
                            var roomObject = oldPosition.roomObject;
                            roomObject.css("left", oldPosition.xLocation + "px");
                            roomObject.css("top", oldPosition.yLocation + "px");
                        });
                        break;
                    case deleteAction:
                        $.each(data.roomObjects, function (index, roomObjectValue)
                        {
                            var roomObject = $(roomObjectValue);
                            restoreRoomObject(roomObject);
                        });
                        checkForDeletedRoomLayoutStudents();
                        break;
                    case createAction:
                        $.each(data.roomObjects, function (index, roomObjectValue)
                        {
                            var roomObject = $(roomObjectValue);
                            roomObject.addClass("roomObjectDeleted");
                            roomObject.removeClass("roomObjectPlaced");
                        });
                        checkForDeletedRoomLayoutStudents();
                        break;
                    case moveAssignAction:
                        appendStudentToSeat(data.student, data.oldRoomObject);
                        break;
                    case swapAssignAction:
                        appendStudentToSeat(data.student, data.otherRoomObject, true);
                        appendStudentToSeat(data.otherStudent, data.roomObject, true);
                        autoScale();
                        break;
                    case assignAction:
                        if (isNullOrEmpty(data.otherStudent))
                        {
                            // then it was assigned from the list to replace a student
                            appendStudentToList(data.student);
                        }
                        else
                        {
                            // swap students on seat
                            appendStudentToList(data.student);
                            appendStudentToSeat(data.otherStudent, data.roomObject);
                        }
                        break;
                    case unassignAction:
                        appendStudentToSeat(data.student, data.roomObject);
                        break;
                    default:
                        break;
                }
            };

            var preventKeyDefault = function (keyName, ctrlKey)
            {
                switch (keyName)
                {
                    case deleteKeyName:
                    // prevent the arrow keys from scrolling
                    case arrowLeft:
                    case arrowRight:
                    case arrowUp:
                    case arrowDown:
                        event.preventDefault();
                        break;
                    case undoKey:
                    case redoKey:
                    case pasteKey:
                    case copyKey:
                    case selectAllKey:
                        if (ctrlKey)
                        {
                            event.preventDefault();
                        }
                        break;
                    default:
                        break;
                }
            };

            var arrowKeyMoveRoomObjects = function (keyName)
            {
                var selectedRoomObjects = getSelectedRoomObjects()

                if (!selectedRoomObjects || selectedRoomObjects.length == 0)
                {
                    return;
                }

                var moveX = 0;
                var moveY = 0;
                switch (keyName)
                {
                    case arrowLeft:
                        moveX = -gridLineSizeValueX;
                        break;
                    case arrowRight:
                        moveX = gridLineSizeValueX;
                        break;
                    case arrowUp:
                        moveY = -gridLineSizeValueY;
                        break;
                    case arrowDown:
                        moveY = gridLineSizeValueY;
                        break;
                    default:
                        break;
                }

                var oldPositions = getRoomObjectPositions(selectedRoomObjects);
                var moveAction = createMoveAction(selectedRoomObjects, oldPositions);
                addUndoAction(moveAction);

                var roomObjectsBounds = moveRoomObjects(selectedRoomObjects, moveX, moveY);

                arrowKeyAutoScroll(keyName, roomObjectsBounds);
            };

            var moveRoomObjects = function (roomObjects, moveX, moveY)
            {
                var lowestPoint = 0;
                var highestPoint = Number.MAX_VALUE;
                var rightMostPoint = 0;
                var leftMostPoint = Number.MAX_VALUE;

                var newPositions = [];
                var edgeReached = false;

                roomObjects.each(function ()
                {
                    var roomObject = $(this);
                    var newPoint = getSnapToGridPoint(parseInt(roomObject.css("left").replace("px", "")) + moveX, parseInt(roomObject.css("top").replace("px", "")) + moveY)

                    if (newPoint.xLocation + roomObject.width() > rightMostPoint)
                    {
                        rightMostPoint = newPoint.xLocation + roomObject.width();
                    }

                    if (newPoint.xLocation < leftMostPoint)
                    {
                        leftMostPoint = newPoint.xLocation;
                    }

                    if (newPoint.yLocation < highestPoint)
                    {
                        highestPoint = newPoint.yLocation;
                    }

                    if (newPoint.yLocation + roomObject.height() > lowestPoint)
                    {
                        lowestPoint = newPoint.yLocation + roomObject.height();
                    }

                    if (leftMostPoint < 0 || highestPoint < 0)
                    {
                        edgeReached = true;
                        return false;
                    }

                    newPositions.push(
                        {
                            roomObject: roomObject,
                            newXLocation: newPoint.xLocation,
                            newYLocation: newPoint.yLocation
                        })
                });

                if (!edgeReached)
                {
                    skyward.seatingchart.dirtyScreen();

                    $.each(newPositions, function (index, newPosition)
                    {
                        var roomObject = newPosition.roomObject;
                        roomObject.css("left", newPosition.newXLocation + "px");
                        roomObject.css("top", newPosition.newYLocation + "px");

                        checkExpandCanvas(roomObject);
                    })
                }

                var roomObjectsBounds =
                {
                    lowestPoint: lowestPoint,
                    highestPoint: highestPoint,
                    rightMostPoint: rightMostPoint,
                    leftMostPoint: leftMostPoint
                };

                return roomObjectsBounds;
            };

            var getRoomObjectPositions = function (roomObjects, getOriginalPositions)
            {
                if (!roomObjects || roomObjects.length == 0)
                {
                    return new Array();
                }

                var locations = [];

                $.each(roomObjects, function (index, roomObjectValue)
                {
                    var roomObject = $(roomObjectValue);
                    var xLocation;
                    var yLocation;

                    if (getOriginalPositions)
                    {
                        xLocation = parseInt(roomObject.data("originalleft"));
                        yLocation = parseInt(roomObject.data("originaltop"));
                    }
                    else
                    {
                        xLocation = parseInt(roomObject.css("left").replace("px", ""));
                        yLocation = parseInt(roomObject.css("top").replace("px", ""));
                    }
                    locations.push({
                        roomObject: roomObject,
                        xLocation: xLocation,
                        yLocation: yLocation
                    });
                });

                return locations;
            };

            var arrowKeyAutoScroll = function (keyName, roomObjectBounds)
            {
                var adjustedTop = canvasScrollContainer.scrollTop();
                var adjustedLeft = canvasScrollContainer.scrollLeft();
                var adjustedRight = adjustedLeft + canvasScrollContainer[0].clientWidth;
                var adjustedBottom = adjustedTop + canvasScrollContainer[0].clientHeight;
                var edgeBuffer = gridLineSizeValueX * skyward.seatingchart.arrowBufferCells;

                if (keyName === arrowRight && roomObjectBounds.rightMostPoint > adjustedRight - edgeBuffer)
                {
                    canvasScrollContainer.animate({ scrollLeft: adjustedLeft + edgeBuffer }, skyward.seatingchart.arrowScrollSpeed);
                }

                if (keyName === arrowLeft && adjustedLeft > 0 && roomObjectBounds.leftMostPoint < (adjustedLeft + edgeBuffer))
                {
                    canvasScrollContainer.animate({ scrollLeft: adjustedLeft - edgeBuffer }, skyward.seatingchart.arrowScrollSpeed);
                }

                if (keyName === arrowUp && adjustedTop > 0 && roomObjectBounds.highestPoint < adjustedTop + edgeBuffer)
                {
                    canvasScrollContainer.animate({ scrollTop: adjustedTop - edgeBuffer }, skyward.seatingchart.arrowScrollSpeed);
                }

                if (keyName === arrowDown && roomObjectBounds.lowestPoint > adjustedBottom - edgeBuffer)
                {
                    canvasScrollContainer.animate({ scrollTop: adjustedTop + edgeBuffer }, skyward.seatingchart.arrowScrollSpeed);
                }
            };

            var selectAllRoomObjects = function ()
            {
                selectRoomObjects(getRoomObjects());
            };

            var revertSelectedObjects = function (selectedObjects)
            {
                selectedObjects = selectedObjects || getSelectedRoomObjects();
                selectedObjects.each(function ()
                {
                    var currObject = $(this);
                    currObject.animate({
                        left: currObject.data("originalleft") + "px",
                        top: currObject.data("originaltop") + "px",
                    }, skyward.seatingchart.durationForRevert);
                });
            };

            var checkForDeletedRoomLayoutStudents = function ()
            {
                var deletedRoomObjects = $(".roomObjectDeleted:has(.roomObjectStudents)");

                hasPendingDeletesThatHaveStudents = !isNullOrEmpty(deletedRoomObjects);

                if (!hasPendingDeletesThatHaveStudents)
                {
                    hideWarningBanner(moduleContent);
				}
            };

            var deleteSelectedRoomObjects = function (clearSelection)
            {
                var selectedRoomObjects = getSelectedRoomObjects()

                if (!selectedRoomObjects || selectedRoomObjects.length == 0)
                {
                    return;
                }

                selectedRoomObjects.each(function ()
                {
                    var roomObject = $(this);

                    roomObject.addClass("roomObjectDeleted");
                    roomObject.removeClass("roomObjectPlaced");

                    if (clearSelection != null && clearSelection == true)
                    {
                        unselectRoomObject(roomObject);
					}
                });

                checkForDeletedRoomLayoutStudents();

                var deleteAction = createDeleteAction(selectedRoomObjects);
                addUndoAction(deleteAction);

                skyward.seatingchart.dirtyScreen();
            }

            var cutSelectedRoomObjects = function ()
            {
                var selectedRoomObjects = getSelectedRoomObjects()

                if (!selectedRoomObjects || selectedRoomObjects.length == 0)
                {
                    return;
                }

                copySelectedRoomObjects(true);

                deleteSelectedRoomObjects(true);

                unselectRoomObjects();
            };

            var copySelectedRoomObjects = function (clone)
            {
                var selectedRoomObjects = getSelectedRoomObjects()

                if (!selectedRoomObjects || selectedRoomObjects.length == 0)
                {
                    return;
                }

                copiedRoomObjects.length = 0;

                selectedRoomObjects.each(function ()
                {
                    if (clone !== true)
                    {
                        copiedRoomObjects.push($(this));
                    }
                    else
                    {
                        var newRoomObject = $(this);
                        newRoomObject.addClass("cutRoomObject");
                        copiedRoomObjects.push(newRoomObject);
					}
                });
            };

            var pasteRoomObjects = function ()
            {
                if (copiedRoomObjects == null || copiedRoomObjects.length == 0)
                {
                    return;
                }

                var newRoomObjects = [];

                $.each(copiedRoomObjects, function ()
                {
                    var roomObject = $(this);
                    var newRoomObject;
                    var isCut = roomObject.hasClass("cutRoomObject");

                    if (roomObject.parents().has(canvas).length > 0)
                    {
                        if (isCut)
                        {
                            newRoomObject = roomObject;
                        }
                        else
                        {
                            newRoomObject = cloneRoomObject(roomObject, true);
                            var pastePoint = getSnapToGridPoint((roomObject.position().left + roomObject.width() + (gridLineSizeValueX * skyward.seatingchart.pasteOffsetCells)),
                                (roomObject.position().top + roomObject.height() + (gridLineSizeValueY * skyward.seatingchart.pasteOffsetCells)));

                            newRoomObject.css("top", pastePoint.yLocation + "px");
                            newRoomObject.css("left", pastePoint.xLocation + "px");
						}
                    }
                    else
                    {
                        newRoomObject = roomObject;
					}

                    if (!isCut)
                    {
                        newRoomObject.removeAttr("data-roomlayoutobjectid");
                        newRoomObject.appendTo(canvas);

                        registerRoomObjectDraggable(newRoomObject, false, canvasObjectRevertFunction(canvas));
                        checkExpandCanvas(newRoomObject);
                    }
                    else
                    {
                        newRoomObject.removeClass("cutRoomObject");
                        restoreRoomObject(newRoomObject);
					}

                    newRoomObjects.push(newRoomObject);
                });

                skyward.seatingchart.dirtyScreen();

                var creatAction = createAddAction(newRoomObjects);
                addUndoAction(creatAction);

                unselectRoomObjects();
                selectRoomObjects(newRoomObjects);

                copySelectedRoomObjects();
            };

            var restoreRoomObject = function (roomObject)
            {
                if (isNullOrEmpty(roomObject))
                {
                    return;
                }

                roomObject.removeClass("roomObjectDeleted");
                roomObject.addClass("roomObjectPlaced");
            };

            var cloneRoomObject = function (roomObject, removeRoomObjectStudents)
            {
                if (isNullOrEmpty(roomObject))
                {
                    return null;
                }

                var newRoomObject = roomObject.clone();

                if (removeRoomObjectStudents === true)
                {
                    newRoomObject.find(".roomObjectStudents").remove();
                }

                return newRoomObject;
            };

            var canvasContextMenu = function (event)
            {
                if (event.ctrlKey)
                {
                    // for devs to show the context menu
                    return true;
                }

                var clickedElement = $(event.target);

                if (!clickedElement || clickedElement.length == 0)
                {
                    return true;
                }

                if (isRoomObjectPlaced(clickedElement) || clickedElement[0] == canvas[0])
                {
                    event.preventDefault();
                    return false;
                }
            };

            var getSnapToGridPoint = function (x, y)
            {
                var point =
                {
                    xLocation: Math.round(x / gridLineSizeValueX) * gridLineSizeValueX,
                    yLocation: Math.round(y / gridLineSizeValueY) * gridLineSizeValueY
                };

                return point;
            };

            var isRoomObjectPlaced = function (roomObject)
            {
                if (roomObject && roomObject.length > 0)
                {
                    return roomObject.hasClass("roomObjectPlaced");
                }
                else
                {
                    return false;
                }
            };

            var canvasClicked = function (event)
            {
                var clickedElement = $(event.target);

                if (!clickedElement || clickedElement.length == 0)
                {
                    return;
                }

                if (isRoomLayoutDetails && !isDragging())
                {
                    if (event.ctrlKey && isRoomObjectPlaced(clickedElement))
                    {
                        if (isRoomObjectSelected(clickedElement))
                        {
                            unselectRoomObject(clickedElement);
                        }
                        else
                        {
                            selectRoomObjects({ clickedElement });
                        }
                    }
                    else
                    {
                        if (getSelectedRoomObjects().length > 1 || !isRoomObjectSelected(clickedElement))
                        {
                            unselectRoomObjects();
                            if (isRoomObjectPlaced(clickedElement))
                            {
                                selectRoomObjects(clickedElement);
                            }
                        }
                    }
                }
                else if (isSeatingChartDetails)
                {
                    if (event.which == leftClick && isRoomObjectPlaced(clickedElement) && !roomObjectHasStudent(clickedElement))
                    {
                        var firstUnassignedStudent = getFirstStudentInList();

                        if (firstUnassignedStudent && firstUnassignedStudent.length)
                        {
                            var student = firstUnassignedStudent.find(".studentImage");
                            appendStudentToSeat(student, clickedElement);

                            var assignAction = createAssignAction(student, clickedElement);
                            addUndoAction(assignAction);

                            skyward.seatingchart.dirtyScreen();
                        }
                    }
                    else if (event.which == rightClick && (clickedElement.hasClass("roomObjectHasStudent") || clickedElement.parents(".roomObjectHasStudent").length > 0) && !event.ctrlKey)
                    {
                        if (!clickedElement.hasClass("roomObjectHasStudent"))
                        {
                            clickedElement = clickedElement.parents(".roomObjectHasStudent");
                        }

                        var student = clickedElement.find(".studentImageSeated");

                        event.preventDefault();

                        if (student && student.length > 0)
                        {
                            appendStudentToList(student);

                            var unassignAction = createUnassignAction(student, clickedElement);
                            addUndoAction(unassignAction);

                            skyward.seatingchart.dirtyScreen();

                            findNextStudentForSeat(clickedElement);
                        }
                    }
                }
            };

            var checkUnassignedStudents = function ()
            {
                var firstUnassignedStudent = getFirstStudentInList();
                var hasUnassignedStudents = (firstUnassignedStudent && firstUnassignedStudent.length) == true;
                var emptySeats = canvas.find(".roomObjectPlaced:not(.roomObjectHasStudent)");

                emptySeats.each(function ()
                {
                    var emptySeat = $(this);
                    emptySeat.css("cursor", hasUnassignedStudents ? "" : "default");
                });
            };

            var roomObjectMouseEnter = function (event)
            {
                findNextStudentForSeat($(event.target));
            };

            var findNextStudentForSeat = function (roomObject)
            {
                if (!isRoomObjectPlaced(roomObject))
                {
                    return;
                }

                var firstUnassignedStudent = getFirstStudentInList();

                if (firstUnassignedStudent && firstUnassignedStudent.length)
                {
                    if (!roomObjectHasStudent(roomObject))
                    {
                        firstUnassignedStudent.addClass("assignFromStudentList");
                    }
                    else
                    {
                        // this can happen if desks are very close together
                        firstUnassignedStudent.removeClass("assignFromStudentList");
                    }
                }
            };

            var roomObjectMouseLeave = function (event)
            {
                var selectedStudents = studentList.find(".assignFromStudentList");

                selectedStudents.each(function ()
                {
                    var student = $(this);
                    student.removeClass("assignFromStudentList");
                });
            };

            var getFirstStudentInList = function ()
            {
                return studentList.find('.studentListContainer:not(.studentInSeatingChart)').first();
            };

            var roomObjectHasStudent = function (roomObject)
            {
                if (!roomObject || roomObject.length == 0)
                {
                    return false;
                }

                return roomObject.hasClass("roomObjectHasStudent");
            };

            var unselectRoomObjects = function (roomObjects)
            {
                roomObjects = roomObjects || getSelectedRoomObjects();
                roomObjects.each(function ()
                {
                    unselectRoomObject($(this));
                });
            };

            var unselectRoomObject = function (roomObject)
            {
                roomObject.removeClass("ui-selected");
            };

            var isRoomObjectSelected = function (roomObject)
            {
                if (!roomObject || roomObject.length == 0)
                {
                    return false;
                }

                return roomObject.hasClass("ui-selected");
            };

            var isDragging = function ()
            {
                return seatingChartContent.find(".ui-draggable-dragging").length > 0;
            };

            var selectRoomObjects = function (roomObjects)
            {
                if (roomObjects == null || roomObjects.length == 0)
                {
                    return;
                }

                removeErrorBorder(roomObjects);

                $.each(roomObjects, function (key, roomObjectValue)
                {
                    var roomObject = $(roomObjectValue);

                    if (!roomObject.hasClass("ui-selected"))
                    {
                        roomObject.addClass("ui-selected");
                    }
                });
            };

            var removeErrorBorder = function (roomObjects)
            {
                if (roomObjects == null || roomObjects.length == 0)
                {
                    return;
                }

                $.each(roomObjects, function (key, roomObjectValue)
                {
                    var roomObject = $(roomObjectValue);

                    if (roomObject.hasClass("roomObjectError"))
                    {
                        roomObject.removeClass("roomObjectError");
                    }
                });
            };

            var getSelectedRoomObjects = function ()
            {
                return canvas.find(".roomObject.ui-selected:not(.roomObjectDeleted)");
            };

            var getRoomObjects = function ()
            {
                return canvas.find(".roomObjectPlaced:not(.roomObjectDeleted)");
            };

            var getCanvasObjectsFromSelector = function (selector)
            {
                return canvas.find(selector);
            }

            // Beginning Initialization Logic
            // General Variables
            var moduleContent = $("#moduleContent");
            var canvas = $("#roomCanvas");
            var undoButton = $("#SeatingChartUndo");
            var redoButton = $("#SeatingChartRedo");
            var canvasScrollContainer = $("#roomCanvasScrollContainer");
            var removeRoomObject = $("#removeRoomObject");
            var roomLayoutModeTab = $("#roomLayoutMode");
            var studentModeTab = $("#studentMode");
            var seatingChartData = $("#seatingChartData");
            var displayPeriodId = seatingChartData.data("displayperiodid");
            var seatingChartId = seatingChartData.data("seatingchartid");
            var roomId = seatingChartData.data("roomid");
            var roomLayoutId = seatingChartData.data("roomlayoutid");
            var saveObject = seatingChartData.data('saveobject');
            var isSeatingChartDetails = saveObject == "SeatingChart";
            var isRoomLayoutDetails = saveObject === "RoomLayout";
            var isDailyAttendance = saveObject === "DailyAttendanceBySeatingChart";
            var displayMaxSeats = isRoomLayoutDetails ? seatingChartData.data("displaymaxseats") === "True" : false;
            var maxSeats = isRoomLayoutDetails ? seatingChartData.data("maxseats") : "";
            var meetId = null;
            var studentList = $("#StudentList_body");

            if (seatingChartData.data("meetid"))
            {
                meetId = seatingChartData.data("meetid");
            }

            // Settings
            skyward.seatingchart.snapToGrid(true);
            skyward.seatingchart.gridLineSize(defaultGridLineSizeValueX, defaultGridLineSizeValueY);
            skyward.seatingchart.gridLineMaxSize = 50;
            skyward.seatingchart.gridLineResizeStep = 5;
            skyward.seatingchart.gridSnapTolerance = 10;
            skyward.seatingchart.canvasEdgeBuffer = 300; // The edge buffer is primarily to account for space lost when minimizing the Edit tabs
            skyward.seatingchart.durationForRevert = 200;
            skyward.seatingchart.distanceBeforeDragging = 10;
            skyward.seatingchart.draggingAppendTo = '#seatingChartContent';
            skyward.seatingchart.seatingChartContentSelector = '.contentArea,.skywardContentPanel';
            skyward.seatingchart.arrowScrollSpeed = 50;
            skyward.seatingchart.arrowBufferCells = 3;
            skyward.seatingchart.pasteOffsetCells = 2;

            // Screen Elements
            var seatingChartContentArea = $('#seatingChartContent');
            var saveSeatingChartButton = $("#SeatingChartSave");
            var cancelSeatingChartButton = $("#SeatingChartCancel");
            var addSeatSeatingChartButton = $("#SeatingChartAddSeats");
            var assignStudentsSeatingChartButton = $("#SeatingChartAssignStudents");
            var displayIndicators = $("#DisplayIndicators");
            var isInDetailsPanel = $(".contentArea,.skywardContentPanel").parents("#detailsPanel").length > 0;

            var gridEnableCheckbox = $("#enableGrid");
            var gridIncreaseButton = $("#GridIncrease");
            var gridDecreaseButton = $("#GridDecrease");
            var selectNewSeatingChartButton = $("#SelectNewSeatingChart");

            if (selectNewSeatingChartButton.length === 0)
            {
                skyward.seatingchart.displayPrintScreenElements(true, true);
            }

            saveSeatingChartButton.hide();
            cancelSeatingChartButton.hide();

            // DailyAttendance by SeatingChart
            // Initialize attendance colorables
            $(selector + ' .seatingChartAttendanceColorable').each(function ()
            {
                var coloredBackground = $(this);
                var updateThisColor = function ()
                {
                    skyward.dailyAttendance.updateColorable(coloredBackground, function (colorable)
                    {
                        var control = colorable.find(".seatingChartAttendanceDropdown");
                        var selectedOption;
                        if (control.length == 0)
                        {
                            control = colorable.find(".seatingChartAttendanceRadioButtonGroup");
                            var value = skyward.controls.getValue(control);
                            if (value == null || value.length == 0)
                            {
                                value = "present";
                            }
                            selectedOption = control.find("label[id^='" + value + "'].radioButton")
                        }
                        else
                        {
                            selectedOption = control.find('option:selected');
                        }

                        var teacherEntryId = selectedOption.data('teacherentryid');

                        return seatingChartData.data('teacherentrycolor' + teacherEntryId);
                    });
                };

                updateThisColor();
                coloredBackground.find('.seatingChartAttendanceDropdown,.seatingChartAttendanceRadioButtonGroup').change(updateThisColor);
            });

            if (roomLayoutModeTab)
            {
                roomLayoutModeTab.on("tabClicked", function ()
                {
                    var studentImages = $(".studentImage");
                    removeStudentDraggableEvents(studentImages);

                    registerRoomObjectDraggable($(".roomObjectList"), true, toolboxObjectRevertFunction());
                    registerRoomObjectDraggable($(".roomObjectPlaced"), false, canvasObjectRevertFunction());

                    studentImages.removeClass("seatingChartModeActive");
                    $(".roomObject").addClass("seatingChartModeActive");

                    canvas.selectable({ distance: 30 });
                });
            }

            if (studentModeTab)
            {
                studentModeTab.on("tabClicked", function ()
                {
                    var roomObjects = $(".roomObject");
                    removeRoomObjectDraggableEvents(roomObjects);

                    $(".roomObjectSeat").each(function ()
                    {
                        var roomObjectSeat = $(this);
                        if (!roomObjectSeat.data("ui-droppable"))
                        {
                            registerCanvasObjectDroppable(roomObjectSeat);
                        }
                    });

                    var studentImages = $(".studentImage");
                    registerStudentDraggable(studentImages, studentRevertFunction());

                    studentImages.addClass("seatingChartModeActive");
                    roomObjects.removeClass("seatingChartModeActive");

                    removeSelectable();
                });
            }

            unFreezeCanvas();

            canvasScrollContainer.droppable(
                {
                    accept: ".roomObject"
                });

            $("#StudentList_body").droppable(
                {
                    accept: ".studentImageSeated",
                    drop: function (event, ui)
                    {
                        var student = ui.draggable;
                        var roomObject = $(".roomObjectPlaced").has(student);
                        var unassignAction = createUnassignAction(student, roomObject);
                        addUndoAction(unassignAction);
					}
                });

            removeRoomObject.droppable(
                {
                    accept: ".roomObjectPlaced",
                    hoverClass: "removeRoomObjectHover",
                    drop: function (event, ui)
                    {
                        var selectedRoomObjects = getSelectedRoomObjects();
                        deleteSelectedRoomObjects(true);
                        revertSelectedObjects(selectedRoomObjects);
                        removeRoomObject.addClass("removeRoomObjectHidden");
                    }
                });

            canvasResize();

            attachListeners();

            // Autoscale desks initially to make sure contents fit on desk
            autoScale();
        };

        var meetBrowseLoaded = function ()
        {
            var codeEEL = $(this);
            var codeEELData = codeEEL.data();

            if (codeEELData)
            {
                codeEEL.on("change", function ()
                {
                    var backingData = $(this).find(".dmsBackingData");
                    var meetsJson = JSON.stringify(skyward.controls.getValue(backingData));
                    var byPeriod = $(this).attr('id').startsWith("ByPeriod");
                    var seatingChartType = byPeriod ? "P" : "C";

                    var postData =
                    {
                        SeatingChartType: seatingChartType
                    };

                    if (byPeriod)
                    {
                        postData.ByPeriodMeetEEL = meetsJson;
                    }
                    else
                    {
                        postData.ByClassMeetEEL = meetsJson;
					}

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Attendance/SeatingChart/MeetsChanged",
                            type: "POST",
                            dataType: "JSON",
                            data: postData,
                            activityIndicator: { silent: true },
                            success: function (data)
                            {
                                var anchorID = byPeriod ? "ByPeriodStudentCount" : "ByClassStudentCount";
                                var anchor = $("#" + anchorID);
                                anchor.text(data.Update[anchorID]);
                            }
                        });
                });
            }
        };

        skyward.seatingchart.openStudentPopupAddWorkFlow = function ()
        {
            var seatingChartType = $("#SeatingChartType").val();
            var meetsEEL = seatingChartType === "P" ? "#ByPeriodMeetEEL" : "#ByClassMeetEEL";

            openRoomObjectStudentPopup($(meetsEEL), "SeatingChartStudentsPopupAddWorkflow")
        };

        var roomLayoutDetailsStudentsClick = function ()
        {
            openRoomObjectStudentPopup($(this), "SeatingChartStudentsPopup");
        };

        var openRoomObjectStudentPopup = function (dataObject, action)
        {
            var data;
            var anchor;
            var afterClose;
            var modalTitle;
            if (action === "SeatingChartStudentsPopup")
            {
                modalTitle = "Students Using This Seat";
                var roomObject = dataObject.parents(".roomObjectPlaced");
                anchor = roomObject;

                if (isNullOrEmpty(roomObject))
                {
                    return;
                }
                roomObject.addClass("roomObjectHover");

                var studentSections = JSON.stringify(dataObject.data("studentsections"));
                var roomLayoutObjectID = roomObject.data("roomlayoutobjectid");
                data =
                {
                    StudentSections: studentSections,
                    RoomLayoutObjectID: roomLayoutObjectID
                };

                afterClose = function ()
                {
                    roomObject.removeClass("roomObjectHover");
                }
            }
            else if (action === "SeatingChartStudentsPopupAddWorkflow")
            {
                modalTitle = "Students";

                var backingData = dataObject.find(".dmsBackingData");
                var meetsJson = JSON.stringify(skyward.controls.getValue(backingData));

                data =
                {
                    meetIDs: meetsJson
                };
            }

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Attendance/SeatingChart/" + action,
                    type: "POST",
                    data: data,
                    dataType: "viewparthtml",
                    activityIndicator: { silent: false }
                });
            };

            var closeButton = { id: 'printClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

            var dialog = skyward.modalLayer.showDialog(modalTitle, buildPopup, [closeButton],
                {
                    draggable: true,
                    anchorTo: anchor,
                    afterClose: afterClose
                });

            $.when(dialog.bodyPromise).done(function ()
            {
                attachStudentInfoClick(dialog.content);
            });
        };

        var isNullOrEmpty = function (jObject)
        {
            return jObject == null || jObject.length == 0;
        };

        var attachStudentInfoClick = function (parent)
        {
            var studentInfoParts = parent.find(".studentImage.studentImageHasAccess,.studentInformationIndicator");
            studentInfoParts.off("click", studentInformationPopupClicked);
            studentInfoParts.on("click", studentInformationPopupClicked);
        }

        var studentInformationPopupClicked = function ()
        {
            var seatingChartContent = $(this).parents(skyward.seatingchart.seatingChartContentSelector);
            var hiddenStudentInfoButton = seatingChartContent.find("#HiddenStudentInfoButton_" + $(this).data('studentid'));
            var studentInfoParts = seatingChartContent.find(".studentImage.studentImageHasAccess");
            var studentIds = [];
            for (var i = 0; i < studentInfoParts.length; i++ )
            {
                studentIds.push(studentInfoParts[i].getAttribute("data-studentid"));
            }
            hiddenStudentInfoButton.data("student-ids", JSON.stringify(studentIds));
            hiddenStudentInfoButton.data("alternative-selected-target-id", $(this).data('studentid'));
            hiddenStudentInfoButton.data("does-not-require-browse", "true");
            hiddenStudentInfoButton.data("custom-student-seek-type", "SeatingChart");
            if (hiddenStudentInfoButton && hiddenStudentInfoButton.length > 0)
            {
                hiddenStudentInfoButton[0].click();
            }
        };

        skyward.seatingchart.openDailyAttendanceSettings = function ()
        {
            var staffMeetSettingID = $("#DailyAttendanceSettings").data("staffmeetsettingid");
            skyward.window.loadContent("full", "Attendance", "StaffMeetSetting", "DailyAttendanceBySeatingChartSettings", staffMeetSettingID);
		}

        skyward.seatingchart.displayPrintScreenElements = function (showElements, showMoreButton)
        {
            var printInfoLine = $(".PrintInfoLine");
            var teacherLabel = $("#TeacherLabel");
            var teacherText = $("#TeacherText");
            var sectionsLabel = $("#SectionsLabel");
            var sectionsText = $("#SectionsText");
            var periodText = $("#periodText");
            var periodLabel = $("#periodLabel");
            var roomText = $("#RoomText");
            var roomLabel = $("#RoomLabel");
            var roomLayoutLabel = $("#RoomLayoutLabel");
            var roomLayoutText = $("#RoomLayoutDescription");
            var seatingChartDescriptionText = $("#seatingChartDescription");
            var seatingChartDescriptionLabel = $("#seatingChartDescriptionLabel");
            var moreMenuSeatingChartButtons = $("#moreMenuSeatingChartButtons");

            if (showElements)
            {
                printInfoLine.css("display", "block");
                teacherLabel.css("display", "inline");
                teacherText.css("display", "inline");
                sectionsLabel.css("display", "inline");
                sectionsText.css("display", "inline");
                periodLabel.css("display", "inline");
                periodText.css("display", "inline");
                roomText.css("display", "inline");
                roomLabel.css("display", "inline");
                roomLayoutLabel.css("display", "inline");
                roomLayoutText.css("display", "inline");
                seatingChartDescriptionText.css("display", "inline");
                seatingChartDescriptionLabel.css("display", "inline");
            }
            else
            {
                sectionsLabel.css("display", "none");
                sectionsText.css("display", "none");
                roomText.css("display", "none");
                roomLabel.css("display", "none");
                roomLayoutLabel.css("display", "none");
                roomLayoutText.css("display", "none");
                seatingChartDescriptionText.css("display", "none");
                seatingChartDescriptionLabel.css("display", "none");
            }
            if (showMoreButton)
            {
                moreMenuSeatingChartButtons.css("display", "inline");
            }
            else
            {
                moreMenuSeatingChartButtons.css("display", "none");
            }
        };

        var printSeatingChart = function ()
        {
            printOptionsPopup('SeatingChart', 'PrintSeatingChart');
        };

        var printRoomLayout = function ()
        {
            printOptionsPopup('RoomLayout', 'PrintRoomLayout');
        };

        var printOptionsPopup = function (controller, printAction)
        {
            var action = "PrintOptionsPopup";
            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Attendance/" + controller + "/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true }
                });
            };

            var printButton = { id: 'print', text: "Print", click: function () { print(controller, printAction, dialog); dialog.close(); }, icon: "PrintAvailable" };
            var closeButton = { id: 'printClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

            var dialog = skyward.modalLayer.showDialog('Print Options', buildPopup, [printButton, closeButton]);
        };

        var print = function (controller, printAction, dialog)
        {
            var seatingChartData = $("#seatingChartData").data();
            seatingChartData.PrintFromBrowse = false;
            seatingChartData.Orientation = dialog.content.find('#orientationRadioButtonGroup.radioButtonGroupValue').val();
            seatingChartData.PortraitSize = dialog.content.find('#portraitSizeRadioButtonGroup.radioButtonGroupValue').val();

            var url = skyward.global.virtualDir + 'Attendance/' + controller + '/' + printAction;
            skyward.printScreen.launchWorkflow(url, seatingChartData);
        };

        var printFromBrowse = function ()
        {
            var button = $(this);
            var buttonData = button.data();
            var url = skyward.global.virtualDir + 'Attendance/' + buttonData.controller + '/' + buttonData.screen + '/';
            $.ajax({
                activityIndicator: { silent: true },
                url: url,
                type: "POST",
                dataType: "JSON",
                data: buttonData,
            });

            skyward.printScreen.launchWorkflow(url, buttonData);
        }

        var cloneSeatingChart = function ()
        {
            clone("SeatingChart", $(this).data());
        };

        var cloneRoomLayout = function ()
        {
            clone("RoomLayout", $(this).data());
        };

        var clone = function (cloneObjectName, workflowData)
        {
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Attendance/" + cloneObjectName + "/Clone", null, workflowData, null);
		}

        var seatingChartLegend = function ()
        {
            var saveObject = $("#seatingChartData").data("saveobject");
            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Attendance/" + saveObject + "/BuildLegend",
                    activityIndicator: { silent: true },
                    type: "POST",
                    dataType: "viewparthtml"
                });
            };

            var options =
            {
                draggable: true,
                anchorTo: $(this)
            };

            var modal = skyward.modalLayer.showDialog((saveObject === "SeatingChart" ? "Seating Chart" : "Room Layout") + " Legend", buildPopup, { text: "Close", icon: "Close" }, options);
            modal.container.css("min-width", "200px");
        };

        skyward.window.registerLoadDOMCallback(init);

        skyward.events.registerEvents("seatingchart",
        {
            "showLegend" : seatingChartLegend,
            "print": printSeatingChart,
            "clone": cloneSeatingChart,
            "printRoomLayout": printRoomLayout,
            "cloneRoomLayout": cloneRoomLayout,
            "meetBrowseLoaded": meetBrowseLoaded,
            "printFromBrowse": printFromBrowse
        });

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.timetrackingchangestatus = skyward.timetrackingchangestatus || {};
        var dialog;
        var init = function (selector)
        {
            $(selector).on('click', '.js-timeTrackingChangeStatus', function (_event)
            {
                var element = $(this);
                skyward.timetrackingchangestatus.changestatus(element, selector);
            });

            $(selector).on('click', '.js-changeStatusTimeTransactionDate', function (_event)
            {
                var element = $(this);
                updateTimeTransactionDate(selector, element);
            });

            $(selector).find('#TimeTransactionDate').on('change', function (_event)
            {
                reloadPage(selector);
            });

            $(selector).on('click', '.button.changeStatusEditTimeTransaction', function (event)
            {
                show(event, selector);
            });

            $(selector).on('click', '.button.changeStatusAddTimeTransaction', function (_event) {
                appendTimeTransactionRow(selector);
            });
        };

        var createJobsPopup = function(data)
        {
            var popup = function ()
            {
                return $.ajax(
                {
                    url: skyward.global.virtualDir + "TimeTracking/Employee/SelectJobs" + '?renderType=contentOnly',
                    data: data,
                    type: 'POST',
                    dataType: 'HTML'
                });
            };

            return popup;
        };

        var selectjob = function()
        {
            var element = $(this);
            
            skyward.buttonManager.setClass(".button");
            var data = element.data();
            var assignmentpaytypeid = element.data("selectedassignmentpaytypeid");
            data._controlAjaxFiredFrom = $("#SelectJobsStatusCode").val();
            setStatus(assignmentpaytypeid, data, element, "#lblErrorMessageChangeJobs");
        }

        skyward.timetrackingchangestatus.changestatus = function (element, selector)
        {
            if (skyward.buttonManager.isElementDisabled(element))
            {
                return;
            }

            skyward.ajax.getAllInputElements(selector).then(data =>
            {
                data._controlAjaxFiredFrom = element.data("changestatusbuttonname");

                if (element.data("changestatusbuttonwillselectjob"))
                {
                    data.SelectJobsStatusCode = element.data('changestatusbuttonselectjobscode');
                    var showJobs = createJobsPopup(data);
                    dialog = skyward.modalLayer.showDialog("Select Job", showJobs, [{ text: "Close", icon: "Close" }],
                        {
                            allowNoButtons: true,
                            draggable: true,
                            id: "TimeTransactionsSelectJobPopupModal",
                            dynamicDialogContentSelector: '#ChangeStatusSelectJobs'
                        });

                }
                else
                {
                    var assignmentPayTypeID = element.data("assignmentpaytypeid") != undefined ? element.data("assignmentpaytypeid") : $("#AssignmentPayTypeID").val();
                    setStatus(assignmentPayTypeID, data, selector);
                }
            });
        };

        var setStatus = function (assignmentPayTypeID, data, selector, errorLabelLocationOverride) {
            var container = $("#changeTimeTrackingStatusQuickEntry");
            data.EmployeeID = $("#EmployeeID").val();
            data.AssignmentPayTypeID = assignmentPayTypeID;
            data.preSaveWarningHash = container.data('preSaveWarningHash') || "";

            var labelLocation = errorLabelLocationOverride || "#lblErrorMessage";
            var promise = $.ajax(
            {
                url: skyward.global.virtualDir + "TimeTracking/Employee/UpdateStatus",
                type: "POST",
                dataType: "JSON",
                data: data
            });
            
           
            promise.done(function (data)
            {                
                if (!data.success)
                {
                    data.preSaveWarningHash = data.preSaveWarningHash;
                    skyward.validation.displayValidationMessages(data, container, $(labelLocation));
                    skyward.buttonManager.setClass(".button", false);
                }
                else
                {
                    reloadPage(selector);
                }
            });
        }

        var updateTimeTransactionDate = function (selector, element)
        {
            if (skyward.buttonManager.isElementDisabled(element))
            {
                return;
            }
            skyward.buttonManager.setClass(".toolbarControls__button--wrapText.changeStatusTimeTransactionDate");
            var data = {};
            data._controlAjaxFiredFrom = element.data("changestatusbuttonname");
            data._controlAjaxFiredFrom == 'PreviousDay' ? updateDate(selector, -1) : updateDate(selector, 1);
        };

        var updateDate = function (selector, increment)
        {
            var timeTransactionDate = $("#TimeTransactionDate");
            var date = skyward.controls.getValue(timeTransactionDate);
            date.setDate(date.getDate() + increment);
            skyward.controls.setValue(timeTransactionDate, date);
            reloadPage(selector);
        };

        function reloadPage(selector)
        {
            const timeTransactionDate = selector != null ? skyward.controls.getValue($(selector).find('#TimeTransactionDate')) : skyward.controls.getValue($('#TimeTransactionDate'));
            const districtID = selector != null ? $(selector).find('#DistrictID').val() : $('#DistrictID').val();

            skyward.window.loadContent("full", "TimeTracking", "Employee", "ChangeStatus", districtID, { timetransactiondate: timeTransactionDate ? skyward.time.formatServerDate(timeTransactionDate, false) : null });
        }

        var createNewPopup = function (data) {
            return $.ajax(
            {
                url: skyward.global.virtualDir + "TimeTracking/Employee/ShowTimeTransactions" + '?renderType=contentOnly',
                data: data,
                type: 'POST',
                dataType: 'HTML'
            });
        };

        var show = function (event, selector)
        {
            var dataPromise = skyward.ajax.getAllInputElements(selector);
            var showTimeTransactions = dataPromise.then(data => createNewPopup(data));

            var saveButton = { text: "Save", click: saveData, icon: "Save" };

            dialog = skyward.modalLayer.showDialog("Time Transactions", showTimeTransactions, [{ text: "Close", icon: "Close" }, saveButton],
            {
                allowNoButtons: true,
                draggable: true,
                id: 'TimeTransactionsPopupModal'
            });

            function saveData()
            {
                skyward.ajax.getAllInputElements(selector).then(postedData =>
                {
                    var container = $(selector).find("#changeStatusTimeTransactionContent");
                    postedData['preSaveWarningHash'] = container.data('preSaveWarningHash') || "";
                    var promise = $.ajax(
                        {
                            url: skyward.global.virtualDir + "TimeTracking/Employee/SaveTimeTransactions",
                            type: "post",
                            dataType: "json",
                            data: postedData
                        });

                    promise.done(function (promiseData)
                    {
                        if (!promiseData.success)
                        {
                            skyward.validation.displayValidationMessages(promiseData, container, $(selector).find("#lblTimeTransactionsErrorMessage"));
                            postedData['preSaveWarningHash'] = promiseData.preSaveWarningHash;
                        }
                        else
                        {
                            reloadPage(selector);
                        }
                    });
                });
            }
        };

        var appendTimeTransactionRow = function (selector)
        {
            var element = $(selector).find(".button.changeStatusAddTimeTransaction");
            if (!skyward.buttonManager.isElementDisabled(element))
            {
                skyward.buttonManager.setClass(".button.changeStatusAddTimeTransaction");

                var pendingPostData = skyward.ajax.getAllInputElements(selector);
                pendingPostData.then((postData) =>
                {
                    return $.ajax(
                        {
                            url: skyward.global.virtualDir + "TimeTracking/Employee/AppendTimeTransactionRow",
                            data: postData,
                            type: 'POST',
                            dataType: 'json',
                            success: function (successData)
                            {
                                $.when(skyward.global.processViewPartHtml(successData.Content)).then(function (html) {
                                    var browseTable = $(selector).find("#ChangeStatusTimeTransactionsEdit");
                                    var browseBody = browseTable.find(".unlockedBrowseTableBody");
                                    if (skyward.global.mobileAccess)
                                    {
                                        var content = skyward.browse.prepMobileBrowseData($(html)[0].outerHTML);
                                        var contentItems = Array.isArray(content) ? content : [content];
                                        contentItems.push(html[1]);
                                        browseBody.append(contentItems);
                                        skyward.browse.applyMobileLockedColumn(browseTable, browseTable.find('.browseBody'), browseBody);
                                    }
                                    else
                                    {
                                        browseBody.append(html);
                                    }
                                    skyward.window.notifyDOMLoad(successData.Id);
                                    dialog.animateModalContents();
                                    skyward.buttonManager.setClickInProgress(false)
                                });
                            }
                        });
                })
            }
        };

        var removerow = function ()
        {
            var data = $(this).data();
            $("#" + data.formname).remove();
            dialog.animateModalContents();
        };

        var events =
        {
            'removerow': removerow,
            "selectjob": selectjob
        };

        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('timetrackingchangestatus', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        "use strict";

        skyward.performanceTesting = skyward.performanceTesting || {};

        var networkSpeedTestOptions =
        {
            testDuration: 60000,
            maxTestRuns: 500,
            maxTimeToWaitForAjaxToEnd: 30000,
            progressUpdateInterval: 1000
        };

        // Errors don't decrement $.active. This variable keeps track of the number of
        // AJAX requests that error out, so we can tell if any are currently running.
        var errors = 0;
        
        var init = function ()
        {
            var button = $("#bandwidthPerformance");
            if (!button.get(0))
            {
                return;
            }

            $(document).ajaxError(function () { errors++; });

            button.one("click", skyward.performanceTesting.testNetworkSpeed);
        };

        skyward.performanceTesting.testNetworkSpeed = function (options)
        {
            var button = $(this);
            var progressBar = $("#bandwidthPerformanceProgress");
            var progressLabel = $("#bandwidthPerformanceProgressLabel");
            var testResultLabel = $("#bandwidthPerformanceResult");
            var bandwidthPerformanceTest = createBandwidthPerformanceTest();

            skyward.controls.disable(button);
            progressBar.removeAttr("value");
            progressLabel.html("Waiting...");
            testResultLabel.val("N/A");

            bandwidthPerformanceTest.testNetworkSpeed(options).progress(function (percentComplete)
            {
                progressBar.attr("value", percentComplete);
                progressLabel.html(percentComplete + "%");

            }).done(function (result)
            {
                testResultLabel.val(result + " MB/sec");
                button.one("click", skyward.performanceTesting.testNetworkSpeed);
                skyward.controls.enable(button);
            });
        };

        var createBandwidthPerformanceTest = function ()
        {
            var bandwidthPerformanceTest = {};

            bandwidthPerformanceTest.testNetworkSpeed = function (options)
            {
                var settings = $.extend({}, networkSpeedTestOptions, options);
                return performTests(settings);
            };
            
            function performTests(settings)
            {
                var deferred = $.Deferred();
                var finishTest = function ()
                {
                    deferred.notify(100);
                    deferred.resolve(testResults.getNetworkSpeed());
                };
                
                $.when(allAjaxRequestsComplete(settings.maxTimeToWaitForAjaxToEnd)).then(function ()
                {
                    var timeUp = false;
                    
                    clearResourceTimings();
                    
                    // Set up maximum time for tests to run
                    var testProgress = 0;
                    $.wait(settings.testDuration, settings.progressUpdateInterval).progress(function ()
                    {
                        testProgress += settings.progressUpdateInterval;
                        deferred.notify(((testProgress / settings.testDuration) * 100).toFixed(0));
                    }).done(function ()
                    {
                        timeUp = true;
                        finishTest();
                    });

                    // Chain the tests to run one after another
                    chainFunctions(performTestRun, function (iteration, fileSize, duration)
                    {
                        if (timeUp)
                        {
                            return false;
                        }

                        testResults.addTestRun(fileSize, duration);

                        if (iteration + 1 >= settings.maxTestRuns)
                        {
                            finishTest();
                            return false;
                        }

                        if (iteration % 100 == 0)
                        {
                            // By default the buffer should hold at least 150 entries,
                            // but clear more often to be safe
                            clearResourceTimings();
                        }

                        return true;
                    });
                });

                return deferred.promise();
            };

            function chainFunctions(functionToCall, functionToCallHandler)
            {
                (function step(iteration)
                {
                    functionToCall().then(function ()
                    {
                        Array.prototype.unshift.call(arguments, iteration);
                        if (functionToCallHandler.apply(this, arguments))
                        {
                            step(iteration + 1);
                        }
                    });
                })(0);
            }

            function performTestRun()
            {
                var deferred = $.Deferred();
                var stopwatch;
                var TEST_FILE_SIZE = 15492421;

                $.ajax(
                {
                    url: getImageSource(),
                    type: "get",
                    cache: false,
                    beforeSend: function ()
                    {
                        stopwatch = skyward.time.stopwatch();
                    },
                    success: function ()
                    {
                        var duration = stopwatch.duration();

                        // Use resource timing for browsers that support it, since it's more accurate
                        if (window.performance && window.performance.getEntriesByName)
                        {
                            var result = window.performance.getEntriesByName(window.location.origin + this.url)[0];
                            if (result)
                            {
                                duration = result.responseEnd - result.responseStart;
                            }
                        }

                        deferred.resolve(TEST_FILE_SIZE, duration);
                    }
                });

                return deferred.promise();
            };

            function clearResourceTimings()
            {
                // Periodically clear the cache since it'll stop filling once it hits the max.
                // If we ever start using resource timing elsewhere, we'll probably need
                // to listen for the onresourcetimingbufferfull event and handle things appropriately.

                if (window.performance && window.performance.clearResourceTimings)
                {
                    window.performance.clearResourceTimings();
                }
                else if (window.performance && window.performance.webkitClearResourceTimings)
                {
                    // Handle Webkit prefixing
                    window.performance.webkitClearResourceTimings();
                }
            };
            
            function allAjaxRequestsComplete(maxWaitTime)
            {
                var deferred = $.Deferred();
                var getConcurrentAjaxRequestCount = function ()
                {
                    // $.active is changed to $.ajax.active in future versions of jQuery
                    return $.active - errors;
                };

                if (getConcurrentAjaxRequestCount() === 0)
                {
                    return deferred.resolve().promise();
                }

                var ajaxCompleteHandler = function ()
                {
                    if (getConcurrentAjaxRequestCount() - 1 <= 0)
                    {
                        deferred.resolve();
                    }
                };

                deferred.done(function ()
                {
                    $(document).off("ajaxComplete", ajaxCompleteHandler);
                });

                $(document).on("ajaxComplete", ajaxCompleteHandler);
                $.wait(maxWaitTime).then(deferred.resolve);

                return deferred.promise();
            };

            function getImageSource()
            {
                return skyward.global.virtualDir + "content/15meg.png";
            }

            var testResults = (function ()
            {
                var testResults = {};
                var totalFileSize = 0;
                var totalDuration = 0;
                var count = 0;
                var BYTES_IN_MEGABYTE = 1048576;
                var SECONDS_IN_MILLISECOND = 1000;

                testResults.addTestRun = function (fileSize, duration)
                {
                    totalFileSize += parseFloat(fileSize);
                    totalDuration += parseFloat(duration);
                    count++;
                };

                testResults.getNetworkSpeed = function ()
                {
                    if (totalFileSize == 0 || totalDuration == 0)
                    {
                        return -1;
                    }

                    var megabytes = totalFileSize / BYTES_IN_MEGABYTE;
                    var seconds = totalDuration / SECONDS_IN_MILLISECOND;
                    var speed = (megabytes / seconds).toFixed(2);

                    return speed;
                };

                return testResults;
            })();

            return bandwidthPerformanceTest;
        };
        
        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.staffresponsibilitytx = skyward.staffresponsibilitytx || {};

        var init = function (selector)
        {
            var detailsScreenSelector = $(selector).find("#editStaffResponsibilityTX.currentRecordContent.dataObjectViewer");
            var workflowScreenSelector = $(selector).filter(".workflowContent");
            var entityCodeEel;
            var roleCodeEel;
            var stateServiceIDCodeEel;
            var localServiceIDCodeEel;
            var courseCodeEel;
            var sectionCodeEel;
            var populationServedCodeEel;
            var uniqueSectionRadioButtonGroup;
            var numberOfStudentsTextBox;
            var pageSelector;
            var isDetails;

            if (detailsScreenSelector.length > 0)
            {
                entityCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_EntityID");
                roleCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_StateRoleTXID");
                stateServiceIDCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_StateServiceIDTXID");
                localServiceIDCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_LocalServiceIDTXID");
                courseCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_CourseID");
                sectionCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_SectionID");
                populationServedCodeEel = detailsScreenSelector.find("#editStaffResponsibilityTX_StatePopulationServedTXID");
                uniqueSectionRadioButtonGroup = detailsScreenSelector.find("#editStaffResponsibilityTX_UniqueSectionCodeOptionSelected_RadioButtonGroup");
                numberOfStudentsTextBox = detailsScreenSelector.find("#editStaffResponsibilityTX_NumberOfStudentsInClass");
                isDetails = true;
                pageSelector = "#editStaffResponsibilityTX_";
            }
            else if (workflowScreenSelector.length > 0)
            {
                entityCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXEntityID");
                roleCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXStateRoleTXID");
                stateServiceIDCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXStateServiceIDTXID");
                localServiceIDCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXLocalServiceIDTXID");
                courseCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXCourseID");
                sectionCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXSectionID");
                populationServedCodeEel = workflowScreenSelector.find("#StaffResponsibilityTXStatePopulationServedTXID");
                uniqueSectionRadioButtonGroup = workflowScreenSelector.find("#UniqueSectionCodeOptionSelected");
                numberOfStudentsTextBox = workflowScreenSelector.find("#StaffResponsibilityTXNumberOfStudentsInClass");
                isDetails = false;
                pageSelector = "#StaffResponsibilityTX";
            }
            else
            {
                return;
            }

            var entityCodeEelOnChange = function ()
            {
                skyward.staffresponsibilitytx.handleEntityChange(pageSelector, isDetails);
            };
            entityCodeEel.on("change", entityCodeEelOnChange);

            var roleCodeEelOnChange = function ()
            {
                skyward.staffresponsibilitytx.handleRoleChange(true);
            };
            roleCodeEel.on("eelComplete", roleCodeEelOnChange);

            var uniqueSectionCodeChange = function ()
            {
                skyward.staffresponsibilitytx.handleUniqueSectionCodeSelection(pageSelector, false, isDetails);
            };
            uniqueSectionRadioButtonGroup.on("change", uniqueSectionCodeChange);

            if (isDetails)
            {
                skyward.staffresponsibilitytx.handleUniqueSectionCodeSelection(pageSelector, true, isDetails);
            }

            var courseCodeEelComplete = function ()
            {
                skyward.staffresponsibilitytx.handleCourseEelComplete(pageSelector, isDetails);
            };
            courseCodeEel.on("eelComplete", courseCodeEelComplete);

            var sectionCodeEelComplete = function ()
            {
                skyward.staffresponsibilitytx.handleSectionEelComplete(pageSelector, isDetails);
            };
            sectionCodeEel.on("eelComplete", sectionCodeEelComplete);

            var populationServedCodeEelComplete = function ()
            {
                skyward.staffresponsibilitytx.handlePopulationServedEelComplete(pageSelector, isDetails);
            };
            populationServedCodeEel.on("eelComplete", populationServedCodeEelComplete);

            var stateServiceIDCodeEelComplete = function () {
                skyward.staffresponsibilitytx.handleStateServiceIDEelComplete(pageSelector, isDetails);
            };
            stateServiceIDCodeEel.on("eelComplete", stateServiceIDCodeEelComplete);

            var localServiceIDCodeEelComplete = function () {
                skyward.staffresponsibilitytx.handleLocalServiceIDEelComplete(pageSelector, isDetails);
            };
            localServiceIDCodeEel.on("eelComplete", localServiceIDCodeEelComplete);

            var numberOfStudentsChange = function () {
                skyward.staffresponsibilitytx.handleNumberOfStudentsChange(pageSelector, isDetails);
            };
            numberOfStudentsTextBox.on("change", numberOfStudentsChange);
        };

        skyward.staffresponsibilitytx.handleEntityChange = function (pageSelector, isDetails)
        {
            var staffRoleCodeEelValue = $(pageSelector + "StateRoleTXID_code").val();;

            var uniqueSectionRadioButtonGroup = isDetails ? $(pageSelector + "UniqueSectionCodeOptionSelected") : $("#UniqueSectionCodeOptionSelected");

            if (staffRoleCodeEelValue == "002" || staffRoleCodeEelValue == "007" || staffRoleCodeEelValue == "015" || staffRoleCodeEelValue === "016" || staffRoleCodeEelValue === "017" ||
                staffRoleCodeEelValue === "018" || staffRoleCodeEelValue === "021" || staffRoleCodeEelValue === "026" || staffRoleCodeEelValue === "032" || staffRoleCodeEelValue === "033" ||
                staffRoleCodeEelValue === "036" || staffRoleCodeEelValue === "047" || staffRoleCodeEelValue === "087") 
            {
                uniqueSectionRadioButtonGroup.change();
            }
        };

        skyward.staffresponsibilitytx.handleUniqueSectionCodeSelection = function (pageSelector, isOnLoad, isDetails)
        {
            var uniqueSectionCode = $(pageSelector + "UniqueSectionCode");

            var entityEelID = $(pageSelector + "EntityID_value");

            var courseID = $(pageSelector + "CourseID");
            var courseEelCode = $(pageSelector + "CourseID_code");
            var courseEelDescription = $(pageSelector + "CourseID_description");
            var courseEelID = $(pageSelector + "CourseID_value");

            var sectionID = $(pageSelector + "SectionID");
            var sectionEelCode = $(pageSelector + "SectionID_code");
            var sectionEelDescription = $(pageSelector + "SectionID_description");
            var sectionEelID = $(pageSelector + "SectionID_value");

            var selectEntityLabel = isDetails ? $(pageSelector + "selectEntity") : $("#selectEntity");
            var uniqueSectionRadioButtonGroup = isDetails ? $(pageSelector + "UniqueSectionCodeOptionSelected") : $("#UniqueSectionCodeOptionSelected");
            var selectSectionLabel = isDetails ? $(pageSelector + "selectSection") : $("#selectSection");
            var courseCodeEel = isDetails ? $(pageSelector + "fsCourseID") : $("#fsCourseID");
            var sectionCodeEel = isDetails ? $(pageSelector + "fsSectionID") : $("#fsSectionID");
            var selectCourseLabel = isDetails ? $(pageSelector + "selectCourse") : $("#selectCourse");

            if (!isOnLoad)
            {
                uniqueSectionCode.val("");

                courseEelCode.val("");
                courseEelDescription.val("");
                courseEelID.val("");

                sectionEelCode.val("");
                sectionEelDescription.val("");
                sectionEelID.val("");
            }

            if (uniqueSectionRadioButtonGroup.val() == "UniqueSectionCodeBasedOnSelection")
            {
                if (isOnLoad)
                {
                    selectSectionLabel.hide();
                    uniqueSectionCode.show();
                    sectionID.show();
                    selectCourseLabel.hide();
                }
                else
                {
                    selectSectionLabel.show();
                    uniqueSectionCode.hide();
                    sectionID.hide();
                    selectCourseLabel.show();
                }

                uniqueSectionCode.attr("readOnly", true);
                courseCodeEel.show();
                sectionCodeEel.show();

                if (entityEelID.val() != "")
                {
                    courseID.show();
                    selectEntityLabel.hide();
                }
                else
                {
                    courseID.hide();
                    selectEntityLabel.show();
                }
            }
            else
            {
                selectSectionLabel.hide();
                uniqueSectionCode.show();
                courseCodeEel.hide();
                sectionCodeEel.hide();
            }
        };

        skyward.staffresponsibilitytx.handleCourseEelComplete = function (pageSelector, isDetails)
        {
            var uniqueSectionRadioButtonGroup = isDetails ? $(pageSelector + "UniqueSectionCodeOptionSelected") : $("#UniqueSectionCodeOptionSelected");
            var courseEelID = $(pageSelector + "CourseID_value");

            var sectionID = $(pageSelector + "SectionID");
            var sectionEelCode = $(pageSelector + "SectionID_code");
            var sectionEelDescription = $(pageSelector + "SectionID_description");
            var sectionEelID = $(pageSelector + "SectionID_value");
            var selectCourseLabel = isDetails ? $(pageSelector + "selectCourse") : $("#selectCourse");

            var selectSectionLabel = isDetails ? $(pageSelector + "selectSection") : $("#selectSection");
            var uniqueSectionCode = $(pageSelector + "UniqueSectionCode");

            if (uniqueSectionRadioButtonGroup.val() == "UniqueSectionCodeBasedOnSelection")
            {
                if (courseEelID.val() == "")
                {
                    selectCourseLabel.show();
                    sectionID.hide();
                }
                else
                {
                    selectCourseLabel.hide();
                    sectionID.show();
                }

                sectionEelCode.val("");
                sectionEelDescription.val("");
                sectionEelID.val("");

                selectSectionLabel.show();
                uniqueSectionCode.hide();
                uniqueSectionCode.val("");
            }
            else
            {
                selectSectionLabel.hide();
            }
        };

        skyward.staffresponsibilitytx.handleSectionEelComplete = function (pageSelector, isDetails)
        {
            var uniqueSectionRadioButtonGroup = isDetails ? $(pageSelector + "UniqueSectionCodeOptionSelected") : $("#UniqueSectionCodeOptionSelected");
            var sectionEelID = $(pageSelector + "SectionID_value");
            var selectSectionLabel = isDetails ? $(pageSelector + "selectSection") : $("#selectSection");
            var uniqueSectionCode = $(pageSelector + "UniqueSectionCode");

            if (uniqueSectionRadioButtonGroup.val() == "UniqueSectionCodeBasedOnSelection")
            {
                if (sectionEelID.val() == "")
                {
                    selectSectionLabel.show();
                    uniqueSectionCode.hide();
                    uniqueSectionCode.val("");
                }
                else
                {
                    selectSectionLabel.hide();
                    uniqueSectionCode.show();
                }
            }
            else
            {
                selectSectionLabel.hide();
            }
        };

        skyward.staffresponsibilitytx.handlePopulationServedEelComplete = function (pageSelector, isDetails)
        {
            var roleCodeEelValue = $(pageSelector + "StateRoleTXID_code").val();
            var populationServedCodeEelValue = $(pageSelector + "StatePopulationServedTXID_code").val();

            var gradeLevelCodeEel = isDetails ? $(pageSelector + 'fsGradeLevelID') : $("#fsGradeLevelID");
            var gradeLevelCodeEelCodeValue = $(pageSelector + 'StateGradeLevelTXID_code');
            var gradeLevelCodeEelDescriptionValue = $(pageSelector + 'StateGradeLevelTXID_description');
            var gradeLevelCodeEelID = $(pageSelector + 'StateGradeLevelTXID_value');

            var sPEDStudentAgeRangeCodeEel = isDetails ? $(pageSelector + 'fsEdFiTXSPEDStudentAgeRangeDescriptor') : $("#fsEdFiTXSPEDStudentAgeRangeDescriptor");
            var sPEDStudentAgeRangeeCodeEelCodeValue = $(pageSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_code');
            var sPEDStudentAgeRangeCodeEelDescriptionValue = $(pageSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_description');
            var sPEDStudentAgeRangeCodeEelID = $(pageSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_value');

            if ((roleCodeEelValue === "033" || roleCodeEelValue === "047" || roleCodeEelValue === "087") && populationServedCodeEelValue === "06")
            {
                gradeLevelCodeEel.show();
                sPEDStudentAgeRangeCodeEel.show();
            }
            else
            {
                gradeLevelCodeEel.hide();
                gradeLevelCodeEelCodeValue.val("");
                gradeLevelCodeEelDescriptionValue.val("");
                gradeLevelCodeEelID.val("");

                sPEDStudentAgeRangeCodeEel.hide();
                sPEDStudentAgeRangeeCodeEelCodeValue.val("");
                sPEDStudentAgeRangeCodeEelDescriptionValue.val("");
                sPEDStudentAgeRangeCodeEelID.val("");
            }
        };

        skyward.staffresponsibilitytx.handleRoleChange = function (clearFields)
        {
            var staffRoleCodeEelValue;
            var staffPopulationServedCodeEelValue;

            var courseCodeEel;
            var courseEelCodeValue;
            var courseEelDescriptionValue;
            var courseEelID;

            var sectionCodeEel;
            var sectionEelCodeValue;
            var sectionEelDescriptionValue;
            var sectionEelID;

            var classTypeCodeEel;
            var classTypeCodeEelCodeValue;
            var classTypeCodeEelDescriptionValue;
            var classTypeCodeEelID;

            var sPEDStudentAgeRangeCodeEel;
            var sPEDStudentAgeRangeeCodeEelCodeValue;
            var sPEDStudentAgeRangeCodeEelDescriptionValue;
            var sPEDStudentAgeRangeCodeEelID;

            var gradeLevelCodeEel;
            var gradeLevelCodeEelCodeValue;
            var gradeLevelCodeEelDescriptionValue;
            var gradeLevelCodeEelID;

            var additionalDaysProgramTeacherIndicator
            var additionalDaysProgramTeacherIndicatorValue

            var uniqueSectionCodeRadioSet;
            var uniqueSectionCodeSelectCourseRadioButton;

            var classIDNumber;
            var classIDNumberValue;

            var monthlyMinutes;
            var monthlyMinutesValue;

            var numberOfStudents;
            var numberOfStudentsValue;

            var isWorkflow;
            var staffRoleCodeEeLIsDirty;

            if ($("#editStaffResponsibilityTX_StateRoleTXID_code").length > 0)
            {
                var detailsEditScreenSelector = '#editStaffResponsibilityTX_';
                isWorkflow = false;

                staffRoleCodeEelValue = $(detailsEditScreenSelector + "StateRoleTXID_code").val();
                staffRoleCodeEeLIsDirty = $(detailsEditScreenSelector + "StateRoleTXID_value").attr("data-dirty");

                courseCodeEel = $(detailsEditScreenSelector + 'fsCourseID');
                courseEelCodeValue = $(detailsEditScreenSelector + 'CourseID_code');
                courseEelDescriptionValue = $(detailsEditScreenSelector + 'CourseID_description');
                courseEelID = $(detailsEditScreenSelector + 'CourseID_value');

                sectionCodeEel = $(detailsEditScreenSelector + 'fsSectionID');
                sectionEelCodeValue = $(detailsEditScreenSelector + 'SectionID_code');
                sectionEelDescriptionValue = $(detailsEditScreenSelector + 'SectionID_description');
                sectionEelID = $(detailsEditScreenSelector + 'SectionID_value');

                classTypeCodeEel = $(detailsEditScreenSelector + 'fsClassTypeID');
                classTypeCodeEelCodeValue = $(detailsEditScreenSelector + 'StateClassTypeTXID_code');
                classTypeCodeEelDescriptionValue = $(detailsEditScreenSelector + 'StateClassTypeTXID_description');
                classTypeCodeEelID = $(detailsEditScreenSelector + 'StateClassTypeTXID_value');

                sPEDStudentAgeRangeCodeEel = $(detailsEditScreenSelector + 'fsEdFiTXSPEDStudentAgeRangeDescriptor');
                sPEDStudentAgeRangeeCodeEelCodeValue = $(detailsEditScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_code');
                sPEDStudentAgeRangeCodeEelDescriptionValue = $(detailsEditScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_description');
                sPEDStudentAgeRangeCodeEelID = $(detailsEditScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_value');

                staffPopulationServedCodeEelValue = $(detailsEditScreenSelector + "StatePopulationServedTXID_code").val();

                gradeLevelCodeEel = $(detailsEditScreenSelector + 'fsGradeLevelID');
                gradeLevelCodeEelCodeValue = $(detailsEditScreenSelector + 'StateGradeLevelTXID_code');
                gradeLevelCodeEelDescriptionValue = $(detailsEditScreenSelector + 'StateGradeLevelTXID_description');
                gradeLevelCodeEelID = $(detailsEditScreenSelector + 'StateGradeLevelTXID_value');

                additionalDaysProgramTeacherIndicator = $(detailsEditScreenSelector + 'fsAdditionalDaysProgramTeacherIndicator');
                additionalDaysProgramTeacherIndicatorValue = $(detailsEditScreenSelector + 'AdditionalDaysProgramTeacherIndicator');

                uniqueSectionCodeRadioSet = $(detailsEditScreenSelector + 'fsUniqueSectionCodeSelector');
                uniqueSectionCodeSelectCourseRadioButton = $(detailsEditScreenSelector + 'UniqueSectionCodeOptionSelected');

                classIDNumber = $(detailsEditScreenSelector + 'fsUniqueSectionCode');
                classIDNumberValue = $(detailsEditScreenSelector + 'UniqueSectionCode');

                monthlyMinutes = $(detailsEditScreenSelector + 'fsMonthlyMinutes');
                monthlyMinutesValue = $(detailsEditScreenSelector + 'MonthlyMinutes');

                numberOfStudents = $(detailsEditScreenSelector + 'fsNumberStudentsInClass');
                numberOfStudentsValue = $(detailsEditScreenSelector + 'NumberOfStudentsInClass');
            }
            else if ($("#StaffResponsibilityTXStateRoleTXID_code").length > 0)
            {
                var workflowScreenSelector = '#StaffResponsibilityTX';
                isWorkflow = true;

                staffRoleCodeEelValue = $(workflowScreenSelector + "StateRoleTXID_code").val();
                staffRoleCodeEeLIsDirty = true;

                courseCodeEel = $('#fsCourseID');
                courseEelCodeValue = $(workflowScreenSelector + 'CourseID_code');
                courseEelDescriptionValue = $(workflowScreenSelector + 'CourseID_description');
                courseEelID = $(workflowScreenSelector + 'CourseID_value');

                sectionCodeEel = $('#fsSectionID');
                sectionEelCodeValue = $(workflowScreenSelector + 'SectionID_code');
                sectionEelDescriptionValue = $(workflowScreenSelector + 'SectionID_description');
                sectionEelID = $(workflowScreenSelector + 'SectionID_value');

                classTypeCodeEel = $('#fsClassTypeID');
                classTypeCodeEelCodeValue = $(workflowScreenSelector + 'StateClassTypeTXID_code');
                classTypeCodeEelDescriptionValue = $(workflowScreenSelector + 'StateClassTypeTXID_description');
                classTypeCodeEelID = $(workflowScreenSelector + 'StateClassTypeTXID_value');

                sPEDStudentAgeRangeCodeEel = $('#fsEdFiTXSPEDStudentAgeRangeDescriptor');
                sPEDStudentAgeRangeeCodeEelCodeValue = $(workflowScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_code');
                sPEDStudentAgeRangeCodeEelDescriptionValue = $(workflowScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_description');
                sPEDStudentAgeRangeCodeEelID = $(workflowScreenSelector + 'EdFiTXSPEDStudentAgeRangeDescriptorID_value');

                staffPopulationServedCodeEelValue = $(workflowScreenSelector + "StatePopulationServedTXID_code").val();

                gradeLevelCodeEel = $('#fsGradeLevelID');
                gradeLevelCodeEelCodeValue = $(workflowScreenSelector + 'StateGradeLevelTXID_code');
                gradeLevelCodeEelDescriptionValue = $(workflowScreenSelector + 'StateGradeLevelTXID_description');
                gradeLevelCodeEelID = $(workflowScreenSelector + 'StateGradeLevelTXID_value');

                additionalDaysProgramTeacherIndicator = $('#fsAdditionalDaysProgramTeacherIndicator');
                additionalDaysProgramTeacherIndicatorValue = $(workflowScreenSelector + 'AdditionalDaysProgramTeacherIndicator');

                uniqueSectionCodeRadioSet = $('#fsUniqueSectionCodeSelector');
                uniqueSectionCodeSelectCourseRadioButton = $('#UniqueSectionCodeOptionSelected');

                classIDNumber = $('#fsUniqueSectionCode');
                classIDNumberValue = $(workflowScreenSelector + 'UniqueSectionCode');

                monthlyMinutes = $('#fsMonthlyMinutes');
                monthlyMinutesValue = $(workflowScreenSelector + 'MonthlyMinutes');

                numberOfStudents = $('#fsNumberStudentsInClass');
                numberOfStudentsValue = $(workflowScreenSelector + 'NumberOfStudentsInClass');
            }
            else
            {
                return;
            }

            if (staffRoleCodeEelValue.length > 0 && staffRoleCodeEeLIsDirty != undefined && staffRoleCodeEeLIsDirty)
            {
                skyward.staffresponsibilitytx.SetServiceID(staffRoleCodeEelValue, isWorkflow);

                if (staffRoleCodeEelValue === "002" || staffRoleCodeEelValue === "007" || staffRoleCodeEelValue === "015" || staffRoleCodeEelValue === "016" || staffRoleCodeEelValue === "017" ||
                    staffRoleCodeEelValue === "018" || staffRoleCodeEelValue === "021" || staffRoleCodeEelValue === "026" || staffRoleCodeEelValue === "032" || staffRoleCodeEelValue === "033" ||
                    staffRoleCodeEelValue === "036" || staffRoleCodeEelValue === "047" || staffRoleCodeEelValue === "087")
                {
                    classTypeCodeEel.css('display', 'block');
                    courseCodeEel.css('display', 'block');
                    sectionCodeEel.css('display', 'block');
                    uniqueSectionCodeRadioSet.css('display', 'block');
                    classIDNumber.css('display', 'block');
                    monthlyMinutes.css('display', 'block');
                    numberOfStudents.css('display', 'block');

                    uniqueSectionCodeSelectCourseRadioButton.change();
                }
                else
                {
                    classTypeCodeEel.css('display', 'none');
                    courseCodeEel.css('display', 'none');
                    sectionCodeEel.css('display', 'none');
                    uniqueSectionCodeRadioSet.css('display', 'none');
                    classIDNumber.css('display', 'none');
                    numberOfStudents.css('display', 'none');

                    if (staffRoleCodeEelValue === "008")
                    {
                        monthlyMinutes.css('display', 'block');
                    }
                    else
                    {
                        monthlyMinutes.css('display', 'none');
                    }
                }

                if ((staffRoleCodeEelValue === "033" || staffRoleCodeEelValue === "047" || staffRoleCodeEelValue === "087") && staffPopulationServedCodeEelValue === "06")
                {
                    gradeLevelCodeEel.css('display', 'block');
                    sPEDStudentAgeRangeCodeEel.css('display', 'block');
                }
                else
                {
                    gradeLevelCodeEel.css('display', 'none');
                    sPEDStudentAgeRangeCodeEel.css('display', 'none');
                }

                if (staffRoleCodeEelValue === "047" || staffRoleCodeEelValue === "087")
                {
                    additionalDaysProgramTeacherIndicator.css('display', 'block');
                }
                else
                {
                    additionalDaysProgramTeacherIndicator.css('display', 'none');
                }

                if (clearFields)
                {
                    skyward.controls.setValue(classTypeCodeEelCodeValue, "");
                    skyward.controls.setValue(classTypeCodeEelDescriptionValue, "");
                    skyward.controls.setValue(classTypeCodeEelID, "");

                    skyward.controls.setValue(sPEDStudentAgeRangeeCodeEelCodeValue, "");
                    skyward.controls.setValue(sPEDStudentAgeRangeCodeEelDescriptionValue, "");
                    skyward.controls.setValue(sPEDStudentAgeRangeCodeEelID, "");

                    skyward.controls.setValue(courseEelCodeValue, "");
                    skyward.controls.setValue(courseEelDescriptionValue, "");
                    skyward.controls.setValue(courseEelID, "");

                    skyward.controls.setValue(sectionEelCodeValue, "");
                    skyward.controls.setValue(sectionEelDescriptionValue, "");
                    skyward.controls.setValue(sectionEelID, "");

                    skyward.controls.setValue(classIDNumberValue, "");

                    skyward.controls.setValue(gradeLevelCodeEelCodeValue, "");
                    skyward.controls.setValue(gradeLevelCodeEelDescriptionValue, "");
                    skyward.controls.setValue(gradeLevelCodeEelID, "");

                    skyward.controls.setValue(additionalDaysProgramTeacherIndicatorValue, false);

                    skyward.controls.setValue(monthlyMinutesValue, 0);

                    skyward.controls.setValue(numberOfStudentsValue, 0);
                }
            }
        };

        skyward.staffresponsibilitytx.SetServiceID = function (role, isWorkflow)
        {
            var screen;
            if (isWorkflow)
            {
                screen = 'Workflow';
            }
            else
            {
                screen = 'Details';
            }

            $.ajax({
                url: skyward.global.virtualDir + 'Demographics/StaffResponsibilityTX/SetServiceIDOn' + screen,
                type: "POST",
                dataType: "JSON",
                data: { Role: role },
                success: function (data)
                {
                    if (data && data.success)
                    {
                        if (isWorkflow)
                        {
                            skyward.controls.setValue($("#StaffResponsibilityTXStateServiceIDTXID"), data.serviceID);
                            skyward.controls.setValue($("#StaffResponsibilityTXStateServiceIDTXID_value"), data.serviceID);
                            skyward.controls.setValue($("#StaffResponsibilityTXStateServiceIDTXID_code"), data.serviceCode);
                            skyward.controls.setValue($("#StaffResponsibilityTXStateServiceIDTXID_description"), data.serviceDescription);
                            $("#ServiceIDSelected_1").prop("checked", true);
                            $("#ServiceIDSelected_1").change();
                        }
                        else
                        {
                            skyward.controls.setValue($("#editStaffResponsibilityTX_StateServiceIDTXID"), data.serviceID);
                            skyward.controls.setValue($("#editStaffResponsibilityTX_StateServiceIDTXID_value"), data.serviceID);
                            skyward.controls.setValue($("#editStaffResponsibilityTX_StateServiceIDTXID_code"), data.serviceCode);
                            skyward.controls.setValue($("#editStaffResponsibilityTX_StateServiceIDTXID_description"), data.serviceDescription);
                            $("#editStaffResponsibilityTX_ServiceIDSelected_1").prop("checked", true);
                            $("#editStaffResponsibilityTX_ServiceIDSelected_1").change();
                        }
                    }
                }
            });
        };

        skyward.staffresponsibilitytx.handleStateServiceIDEelComplete = function (pageSelector, isDetails) {
            skyward.staffresponsibilitytx.SetNumberDaysMinutesTaught(pageSelector, isDetails, true);
        }

        skyward.staffresponsibilitytx.handleLocalServiceIDEelComplete = function (pageSelector, isDetails) {
            skyward.staffresponsibilitytx.SetNumberDaysMinutesTaught(pageSelector, isDetails, false);
        }

        skyward.staffresponsibilitytx.handleNumberOfStudentsChange = function (pageSelector, isDetails) {
            var isStateServiceID;

            var localServiceIDRadioButton = isDetails ? $(pageSelector + "ServiceIDSelected") : $("#ServiceIDSelected");
            isStateServiceID = localServiceIDRadioButton.val() === "StateServiceIDTX"; // LocalServiceID

            skyward.staffresponsibilitytx.SetNumberDaysMinutesTaught(pageSelector, isDetails, isStateServiceID);
        }

        skyward.staffresponsibilitytx.SetNumberDaysMinutesTaught = function (pageSelector, isDetails, isStateServiceID) {
            var serviceIDValue;

            if (isStateServiceID) {
                serviceIDValue = $(pageSelector + 'StateServiceIDTXID_code').val();
            }
            else {
                serviceIDValue = $(pageSelector + 'LocalServiceIDTXID_code').val();
            }

            var numberOfStudentsInClassValue = $(pageSelector + 'NumberOfStudentsInClass').val();
            var divNumberDaysMinutesTaught = isDetails ? $(pageSelector + 'divNumberDaysMinutesTaught') : $("#divNumberDaysMinutesTaught");

            if (numberOfStudentsInClassValue > 0 &&
                   (serviceIDValue === "02530002" || serviceIDValue === "02530003" || serviceIDValue === "02530004" || serviceIDValue === "02530005" || serviceIDValue === "02530006" || serviceIDValue === "02530007" || serviceIDValue === "02530008" ||
                    serviceIDValue === "02850000" || serviceIDValue === "03823000" || serviceIDValue === "PES00052" || serviceIDValue === "PES00053" || serviceIDValue === "PES00054" || serviceIDValue === "PES00055" || serviceIDValue === "82210XXX" ||
                    serviceIDValue === "82931XXX" || serviceIDValue === "83210XXX" || serviceIDValue === "84200XXX")) {
                divNumberDaysMinutesTaught.show();
            }
            else {
                divNumberDaysMinutesTaught.hide();

                for (var i = 1; i <= 4; i++) {
                    if (isDetails) {
                        $(pageSelector + 'NumberDaysTaughtWeek' + i).val("");
                        $(pageSelector + 'NumberMinutesTaughtWeek' + i).val("");
                    }
                    else {
                        $('#NumberDaysTaughtWeek' + i).val("");
                        $('#NumberMinutesTaughtWeek' + i).val("");
                    }
                }
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.disciplinequickentry = skyward.disciplinequickentry || {};

        skyward.disciplinequickentry.addNewChildRecordRow = function (input)
        {
            var jqInput = $(input);
            if (jqInput.hasClass('InvolvementQuickEntryAddButton')) {
                var involvementTableRow = jqInput.siblings('.CollapsibleChildRecordQuickEntry');
                involvementTableRow.css("display", "");
                var involvementRow = involvementTableRow.find(".childrecordquickentry").find(".childrecordquickentryrow:visible").last();
                if (involvementRow.length)
                {
                    skyward.window.notifyDOMLoad(involvementRow.attr("id"));
                }
            }
            if (jqInput.hasClass('WeaponQuickEntryAddButton'))
            {
                var weaponTableRow = jqInput.siblings('.CollapsibleChildRecordQuickEntry');
                weaponTableRow.css("display", "");
                var weaponRow = weaponTableRow.find(".childrecordquickentry").find(".childrecordquickentryrow:visible").last();
                if (weaponRow.length)
                {
                    skyward.window.notifyDOMLoad(weaponRow.attr("id"));
                }
            }
            else if (jqInput.hasClass('DrugQuickEntryAddButton'))
            {
                var drugTableRow = jqInput.siblings('.CollapsibleChildRecordQuickEntry');
                drugTableRow.css("display", "");
                var drugRow = drugTableRow.find(".childrecordquickentry").find(".childrecordquickentryrow:visible").last();
                if (drugRow.length)
                {
                    skyward.window.notifyDOMLoad(drugRow.attr("id"));
                }
            }
            else if (jqInput.hasClass('ActionQuickEntryAddButton'))
            {
                var table = jqInput.closest("tr.childrecordquickentryrow");
                var actionTableRow = jqInput.siblings('.CollapsibleChildRecordQuickEntry');
                actionTableRow.css("display", "");
                table.find('.actioncount').val('1');

                setActionCodeEELDependency(actionTableRow);
                setFollowUpDistintMultiSelectDependency(actionTableRow);

                var actionIDForAjax = actionTableRow.find("[name*='ActionID']").attr('name');
                var actionValueForAjax = actionTableRow.find("[name*='ActionID']").attr('value');

                var ajaxData = {
                    _controlAjaxFiredFrom: actionIDForAjax
                }
                ajaxData[actionIDForAjax] = actionValueForAjax;

                var actionRow = table.find(".actionQuickEntry").find(".childrecordquickentryrow:visible").last();
                if (actionRow.length)
                {
                    $.when(skyward.window.notifyDOMLoad(actionRow.attr("id"))).then(
                        $.ajax(
                            {
                                url: skyward.global.virtualDir + "Discipline/Incident/QuickEntryAjaxAdministrative",
                                type: "POST",
                                dataType: "JSON",
                                data: ajaxData,
                                success: function (data)
                                {
                                    skyward.ajax.handleResponse(data, "", false, $(actionRow.attr("id")).closest('.skywardContentPanel'));
                                }
                            }));
                }
            }
            skyward.window.notifyResize();
            jqInput.css("display", "none");
        };

        var init = function (selector)
        {
            // Discipline list dynamic Discipline Officer filtering
            if ($(selector + ' #DisciplineListIncidentBrowse').length > 0)
            {
                var browseName = skyward.browse.getCurrentBrowseName();
                var browse = skyward.browse.browseList[browseName];
                if (!browse)
                {
                    return;
                }
                const browseInitialFilter = browse.data.filter;
                const browseInitialRequestDataHash = browse.requestDataHash;

                var disciplineOfficerEEL = $('#DisciplineListStaffIDDisciplineOfficer_value');
                disciplineOfficerEEL.parent().on("eelComplete", function ()
                {
                    var tileViewEEL = $(this).parent().find('.tileViewEEL');
                    generateIncidentFilter(tileViewEEL);

                    updateIncidentListSelectedDisciplineOfficerUserSetting(skyward.controls.getValue(tileViewEEL));
                });

                disciplineOfficerEEL.on('change', function ()
                {
                    var tileViewEEL = $(this);
                    var value = skyward.controls.getValue(tileViewEEL);
                    if (value === '')
                    {
                        generateIncidentFilter(tileViewEEL.parent('.tileViewEEL'));
                        updateIncidentListSelectedDisciplineOfficerUserSetting(value);
                    }
                });

                var generateIncidentFilter = function (tileViewEEL)
                {
                    if (!tileViewEEL || !tileViewEEL.hasClass('tileViewEEL'))
                    {
                        return;
                    }

                    const browseRequiredData = skyward.browse.getRequiredBrowseData(browse);
                    const postData = browseRequiredData.postData;

                    $.ajax(
                    {
                        url: skyward.global.virtualDir + "Discipline/Incident/GenerateIncidentFilter",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            DisciplineListStaffIDDisciplineOfficer: skyward.controls.getValue(tileViewEEL),
                            postData,
                        },
                        success: function (data)
                        {
                            browse.dynamicFilterValues.filter = data.SearchCondition;
                            browse.dynamicFilterValues.filter_hash = data.SearchConditionHash;
                            skyward.browse.get(browseName, {});
                        }
                    });
                };

                var updateIncidentListSelectedDisciplineOfficerUserSetting = function (staffID)
                {
                    $.ajax(
                    {
                        url: skyward.global.virtualDir + "Discipline/Incident/UpdateDisciplineOfficerStaffIDUserSetting",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            DisciplineOfficerStaffIDSelected: staffID
                        }
                    });
                };
            }

            if ($("#editIncidentOffenseName_StudentNameFilter_RadioButtonGroup").length > 0)
            {
                var studentNameFilter = $("#editIncidentOffenseName_StudentNameFilter_RadioButtonGroup");
                studentNameFilter.off('change');
                studentNameFilter.on('change', '.radioButtonContent', function ()
                {
                    var studentNameFilter = $(this);
                    var nameTypeStudentContainer = $('#editIncidentOffenseName_StudentSelection');
                    if (nameTypeStudentContainer.length == 0)
                    {
                        return;
                    }
                    var filterAjaxAction = nameTypeStudentContainer.find("#editIncidentOffenseName_StudentFilterAjaxAction");

                    var searchBox = nameTypeStudentContainer.find(".tileViewEEL_search");
                    var searchBoxData = searchBox.data();

                    var data = { "studentNameFilter": studentNameFilter.val() };
                    $.extend(data, searchBoxData);

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Discipline/IncidentOffenseName/" + filterAjaxAction.val(),
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            success: function (data) {
                                searchBoxData.filter = JSON.parse(data.Filter);
                                searchBoxData.securityHash = data.NewHash;
                            }
                        });
                });
            }
            var incidentQuickEntryPrimaryOffenseChange = function ()
            {
                var codeEEL = $(this);
                var value = skyward.controls.getValue(codeEEL);
                var screenContainer = codeEEL.parents(".workflowPopup").first();

                screenContainer.find(".incidentQuickEntryPrimaryOffenseForInvolvedPerson").each(function ()
                {
                    updateReadOnlyPrimaryOffenseForInvolvedPerson($(this), value);
                });

                //Remove the offense we just set as primary from any existing secondary offense
                screenContainer.find(".incidentQuickEntrySecondaryOffenses").each(function ()
                {
                    var element = $(this);
                    if (element.attr("id").includes("-Template"))
                    {
                        return;
                    }

                    var backingDataElement = element.find(".dmsBackingData");
                    var secondaryOffenses = skyward.controls.getValue(backingDataElement);

                    if (secondaryOffenses)
                    {
                        $.each(secondaryOffenses, function (k, v)
                        {
                            if (k == value)
                            {
                                delete secondaryOffenses[k];
                                return false;
                            }
                        });
                    }

                    skyward.controls.setValue(backingDataElement, secondaryOffenses);
                    updateValidOffensesForAction(element);
                });
            };

            if ($(selector + ' .incidentQuickEntryPrimaryOffense').length > 0)
            {
                $(".incidentQuickEntryPrimaryOffense").on("eelComplete", incidentQuickEntryPrimaryOffenseChange);

                // We need to initialize the dependencies of the actionQuickEntry rows so that the dynamicfiltervalue collection is updated with the proper ids on the template row
                const actionQuickEntry = $(".actionQuickEntry");
                if (actionQuickEntry.length > 0)
                {
                    const actionTableRow = actionQuickEntry.find(".childrecordquickentryrow");

                    if (actionTableRow.length > 0)
                    {
                        setActionCodeEELDependency(actionTableRow);
                        setFollowUpDistintMultiSelectDependency(actionTableRow);
                    }
                }

                $(selector).on("childrecordquickentry-row-added", function ()
                {
                    var actionQuickEntry = $(event.target).parents(".actionQuickEntry");
                    if (actionQuickEntry.length < 1)
                    {
                        return;
                    }

                    var actionTableRow = actionQuickEntry.find(".childrecordquickentryrow:visible").last();

                    if (actionTableRow && actionTableRow.length)
                    {
                        setActionCodeEELDependency(actionTableRow);
                        setFollowUpDistintMultiSelectDependency(actionTableRow);
                        updateValidOffensesForAction(actionTableRow.children().first());

                        // Trigger a change to fire the ajax action for the intervention checkbox when adding a new action
                        actionQuickEntry.find(".isInterventionCheckbox:last").trigger("change");
                    }
                });

                $(selector).on("childrecordquickentry-row-added", ".childrecordquickentry.incidentQuickEntry", function ()
                {
                    //if its a nested crqe skip out.
                    if (event && event.target && $(event.target).parents(".incidentQuickEntryCollapsibleQuickEntry").first().length > 0)
                    {
                        return;
                    }

                    var quickEntry = $(this);
                    setTimeout(function () //Have to wait for the row added animation to be done...
                    {
                        var quickEntries = quickEntry.find("tbody > tr.incidentQuickEntryRow.childrecordquickentryrow:visible");
                        var addedRow = quickEntries.last();
                        var rowNumber = quickEntries.length;
                        var excludeOffense = addedRow.find(".excludePrimaryOffense");
                        var checked = skyward.controls.getValue(excludeOffense);

                        if (!checked)
                        {
                            var primaryOffenseValue = skyward.controls.getValue(quickEntryGetPrimaryOffense(addedRow));
                            updateReadOnlyPrimaryOffenseForInvolvedPerson(addedRow.find(".incidentQuickEntryPrimaryOffenseForInvolvedPerson"), primaryOffenseValue);
                        }

                        var screenContainer = addedRow.parents(".workflowPopup").first();
                        var defaultOffenseValueFromPreviousPerson = skyward.controls.getValue(screenContainer.find("#DefaultOffenseValueFromPreviousPerson"));

                        if (defaultOffenseValueFromPreviousPerson.toLowerCase() == "true")
                        {
                            var previousRow = addedRow.prev(":visible");
                            cloneValuesFromPreviousRow(addedRow, previousRow);
                        }

                        var actionTableRow = addedRow.find('.actionQuickEntry').last().find(".childrecordquickentryrow").last();

                        if (actionTableRow && actionTableRow.length)
                        {
                            setActionCodeEELDependency(actionTableRow);
                            setFollowUpDistintMultiSelectDependency(actionTableRow);
                            updateValidOffensesForAction(addedRow.children().first());
                        }

                        const rowSuffix = `-add-${rowNumber}`;
                        initAllegationFieldsEvents(rowSuffix);
                        updateAllegationCheckbox(rowSuffix);
                    }, 250);
                });

                $(selector).on("change", ".incidentQuickEntrySecondaryOffenses", function ()
                {
                    var codeEEL = $(this);

                    updateValidOffensesForAction(codeEEL);
                });

                $(selector + " .childrecordquickentryrow").each(function ()
                {
                    var row = $(this);
                    updateValidOffensesForAction(row.find(".incidentQuickEntryPrimaryOffenseForInvolvedPerson"));

                    //trigger an ajax action to default everything
                    row.find("[data-ajaxaction]").each(function ()
                    {
                        $(this).change();
                    });

                    excludePrimaryOffense.apply(row.find(".excludePrimaryOffense"));
                });

                // Add change events to allegation fields + run the update to hide / show the isAllegation checkbox on load
                const firstRowSuffix = "-add-1";
                initAllegationFieldsEvents(firstRowSuffix);
                updateAllegationCheckbox(firstRowSuffix);
            }

            setPennsylvaniaFieldsVisability(selector);
        };

        /**
         * This function adds the 'change' events to the controls that determine
         * the visibility of the isAllegation checkbox and StaffAllegationFields.
         *
         * @param {string} rowSuffix - Specifies the row of the current QuickEntry
         */
        var initAllegationFieldsEvents = function (rowSuffix)
        {
            const incidentTypeData = { rowSuffix: rowSuffix, allegationFieldsCB : updateAllegationFieldsForAllRows }
            const allegationCheckboxData = { rowSuffix : rowSuffix, allegationFieldsCB : updateAllegationCheckbox }
            const staffAllegationFieldsData = { rowSuffix : rowSuffix, allegationFieldsCB : updateStaffAllegationFields }

            $("#IncidentTypeCode").off("change", updateAllegationFields).on("change", incidentTypeData, updateAllegationFields);
            $(`#IncidentOffenseNameInvolvementTypeCode${rowSuffix}`).off("change", updateAllegationFields).on("change", allegationCheckboxData, updateAllegationFields);
            $(`#IncidentOffenseNameIsAllegation${rowSuffix}`).off("change", updateAllegationFields).on("change", staffAllegationFieldsData, updateAllegationFields);
            $(`#IncidentOffenseNameIncidentOffenseNameTypeCode${rowSuffix}`).off("change", updateAllegationFields).on("change", staffAllegationFieldsData, updateAllegationFields);
        }

        /**
         * This function gets the data passed from the change event
         * and executes the callback to update the necessary allegation fields
         *
         * @param event
         */
        var updateAllegationFields = function (event)
        {
            const rowSuffix = event.data.rowSuffix;
            const allegationFieldsCB = event.data.allegationFieldsCB;

            if (rowSuffix !== undefined && allegationFieldsCB !== undefined)
            {
                allegationFieldsCB(rowSuffix);
            }
        }

        /**
         * This function calls the controller action to
         * determine if we should hide the isAllegation checkbox
         * 
         * @param {string} rowSuffix - Specifies the row of the current QuickEntry
         */
        var updateAllegationCheckbox = function (rowSuffix)
        {
            const portalForAjax = skyward.controls.getValue($("#PortalForAjax"));
            const postData =
            {
                "Incident.TypeCode": skyward.controls.getValue($("#IncidentTypeCode")),
                "IncidentOffenseName.IsAllegation": skyward.controls.getValue($(`#IncidentOffenseNameIsAllegation${rowSuffix}`)),
                "IncidentOffenseName.InvolvementTypeCode": skyward.controls.getValue($(`#IncidentOffenseNameInvolvementTypeCode${rowSuffix}`))
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + `Discipline/IncidentOffenseName/QuickEntry${portalForAjax}AllegationCheckboxWorkflowAjax`,
                    type: "POST", 
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        updateData(data, rowSuffix);
                        updateStaffAllegationFields(rowSuffix, data.Update);
                    }
                });
        }

        /**
         * This function calls the controller action to
         * determine if we should hide the StaffAllegationFields
         * 
         * @param {string} rowSuffix - Specifies the row of the current QuickEntry
         * @param {object | undefined} updatedData - Contains data retrieved in updateAllegationCheckbox's ajax call
         */
        var updateStaffAllegationFields = function (rowSuffix, updatedData)
        {
            const portalForAjax = skyward.controls.getValue($("#PortalForAjax"));
            const postData =
            {
                "IncidentOffenseName.IsAllegation": updatedData !== undefined ?
                    updatedData["IncidentOffenseName.IsAllegation"] : skyward.controls.getValue($(`#IncidentOffenseNameIsAllegation${rowSuffix}`)),
                "IncidentOffenseName.IncidentOffenseNameTypeCode" : skyward.controls.getValue($(`#IncidentOffenseNameIncidentOffenseNameTypeCode${rowSuffix}`))
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + `Discipline/IncidentOffenseName/QuickEntry${portalForAjax}StaffAllegationFieldsWorkflowAjax`,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        updateData(data, rowSuffix);
                    }
                });
        }

        /**
         * This function calls the controller action to
         * determine if we should hide the isAllegation checkbox 
         * for each Involved person row in the quick entry
         * 
         * @param {string} rowSuffix - Specifies the row of the last QuickEntry
         */
        var updateAllegationFieldsForAllRows = function (rowSuffix)
        {
            const match = rowSuffix.match(/-add-(\d+)/);
            if (match)
            {
                const rows = parseInt(match[1], 10);
                for (let row = 1; row <= rows; row++)
                {
                    updateAllegationCheckbox(`-add-${row}`);
                }
            }
        }

        /**
         * Iterate through the Update, and Hidden dictionaries and
         * update their corresponding controls' values + visibility
         * 
         * @param {object} data - Contains Update, and Hidden dictionaries retrieved in ajax call
         * @param {string} rowSuffix - Specifies the row of the current QuickEntry
         */
        var updateData = function (data, rowSuffix)
        {
            const processDictionary = function (dict, callback)
            {
                if (dict !== undefined)
                {
                    for (const selector in dict)
                    {
                        if (dict.hasOwnProperty(selector))
                        {
                            callback(`#${selector.replace(".", "")}${rowSuffix}`, dict[selector]);
                        }
                    }
                }
            }

            if (data !== undefined)
            {
                processDictionary(data.Update, (selector, value) => skyward.controls.setValue(selector, value, true));
                processDictionary(data.Hidden, (selector, hide) => skyward.controls.toggleVisible(selector, !Boolean(hide)));
            }
        }

        var cloneValuesFromPreviousRow = function (addedRow, previousRow)
        {
            cloneFieldFromPreviousRow(addedRow, previousRow, ".incidentQuickEntrySecondaryOffenses > .dmsBackingData");
        };

        var cloneFieldFromPreviousRow = function (addedRow, previousRow, fieldSelector)
        {
            var previousField = previousRow.find(fieldSelector);
            var addedField = addedRow.find(fieldSelector);

            if (addedField.length > 0 && previousField.length > 0)
            {
                skyward.controls.setValue(addedField, skyward.controls.getValue(previousField));
            }
        };

        var updateReadOnlyPrimaryOffenseForInvolvedPerson = function (codeEELForPerson, newPrimaryOffenseValue)
        {
            skyward.controls.setValue(codeEELForPerson, newPrimaryOffenseValue, true);
        };

        var excludePrimaryOffense = function ()
        {
            var checkbox = $(this);
            var row = checkbox.parents(".childrecordquickentryrow").first();
            var checked = skyward.controls.getValue(checkbox);

            var readOnlyPrimaryOffense = checkbox.parents(".childrecordquickentryrow").first().find(".incidentQuickEntryPrimaryOffenseForInvolvedPerson");

            if (checked)
            {
                skyward.controls.setValue(readOnlyPrimaryOffense, null);
            }
            else
            {
                skyward.controls.setValue(readOnlyPrimaryOffense, skyward.controls.getValue(quickEntryGetPrimaryOffense(checkbox)));
            }
            updateValidOffensesForAction(checkbox);
            row.find(".incidentQuickEntrySecondaryOffenses > .dmsBackingData").change();
        };

        var updateValidOffensesForAction = function (element)
        {
            var row = element.parents(".childrecordquickentryrow").first();

            var selectedOffenseIDs = getSelectedOffenseIDs(row);

            skyward.controls.setValue(row.find(".selectedOffensesForInvolvedPerson"), JSON.stringify(selectedOffenseIDs));
            if (selectedOffenseIDs.length > 0)
            {
                defaultOffenseForAction(row, selectedOffenseIDs);
            }
        };

        var getSelectedOffenseIDs = function (row)
        {
            var primaryOffenseCodeEEL = quickEntryGetPrimaryOffense(row);
            var excludePrimary = skyward.controls.getValue(row.find(".excludePrimaryOffense"));

            var selectedOffenseIDs = [];
            if (!excludePrimary)
            {
                var primaryOffenseID = skyward.controls.getValue(primaryOffenseCodeEEL);
                if (primaryOffenseID)
                {
                    selectedOffenseIDs.push(primaryOffenseID);
                }
            }

            var secondaryOffensesBackingDataElement = row.find(".incidentQuickEntrySecondaryOffenses > .dmsBackingData");
            var secondaryOffenses = skyward.controls.getValue(secondaryOffensesBackingDataElement);
            if (secondaryOffenses)
            {
                $.each(secondaryOffenses, function (k, v)
                {
                    if (k != null && k != "")
                    {
                        selectedOffenseIDs.push(k);
                    }
                });
            }

            return selectedOffenseIDs;
        };

        var defaultOffenseForAction = function (row, selectedOffenseIDs)
        {
            var actionOffenseCodeEELs = row.find(".incidentQuickEntryOffenseIDForAction");
            $.each(actionOffenseCodeEELs, function ()
            {
                var element = $(this);
                var value = skyward.controls.getValue(element);
                if (!value || !selectedOffenseIDs.indexOf(value) > -1)
                {
                    skyward.controls.setValue(element, selectedOffenseIDs[0]);
                }
            });
        };

        var quickEntryGetPrimaryOffense = function (element)
        {
            var screenContainer = element.parents(".workflowPopup").first();
            return screenContainer.find(".incidentQuickEntryPrimaryOffense");
        };

        var setActionCodeEELDependency = function (actionTableRow)
        {
            var actionCodeEELInputs = actionTableRow.find(".js-setActionCodeEELDependency");
            $.each(actionCodeEELInputs, function ()
            {
                var actionCodeEEL = $(this).find(".eELInputContainer__textBox").first();
                if (actionCodeEEL)
                {
                    var fieldname = "IncidentOffenseNameActionActionID";

                    var actionCodeEELID = actionCodeEEL.attr("id");
                    var actionCodeEELPrefix = actionCodeEELID.split(fieldname)[0];
                    var actionCodeEelDynamicFilter = actionCodeEEL.data().dynamicfiltervalue;

                    var actionRepeaterNumberForIncident = actionCodeEEL.parents(".codeEEL").attr("id").split(fieldname)[1];
                    if (actionRepeaterNumberForIncident != actionCodeEelDynamicFilter.split("IncidentOffenseNameAction.OffenseIDForAction")[1])
                    {
                        actionCodeEelDynamicFilter = "IncidentOffenseNameAction.OffenseIDForAction" + actionRepeaterNumberForIncident;
                    }

                    if (actionCodeEelDynamicFilter.indexOf(actionCodeEELPrefix) < 0)
                    {
                        actionCodeEelDynamicFilter = actionCodeEELPrefix + actionCodeEelDynamicFilter;
                        actionCodeEEL.data("dynamicfiltervalue", actionCodeEelDynamicFilter);
                    }
                }
            });
        }

        var setFollowUpDistintMultiSelectDependency = function (actionTableRow)
        {
            var followUpEEL = actionTableRow.find(".js-setFollowUpDistintMultiSelectDependency");
            var followUpEELID = followUpEEL.attr("id");

            if (followUpEELID)
            {
                var fieldName = "IncidentOffenseNameActionAdditionalFollowUpTypesMultiSelect";
                var followUpEELPrefix = followUpEELID.split(fieldName)[0];
                var followUpEELRepeaterNumber = followUpEELID.split(fieldName)[1];
                var followUpEELDynamicFilter = followUpEEL.data().dynamicfiltervalue.split(",")[0];  // Ignore the EdFiApplicationID dependency

                if (followUpEELRepeaterNumber != followUpEELDynamicFilter.split("IncidentOffenseNameAction.DescriptorCodeIDPrimaryFollowUpType")[1])
                {
                    followUpEELDynamicFilter = "IncidentOffenseNameAction.DescriptorCodeIDPrimaryFollowUpType" + followUpEELRepeaterNumber;
                }

                if (followUpEELDynamicFilter.indexOf(followUpEELPrefix) < 0)
                {
                    followUpEELDynamicFilter = followUpEELPrefix + followUpEELDynamicFilter;
                }

                followUpEELDynamicFilter = followUpEELDynamicFilter + ",EdFiApplicationID";
                followUpEEL.data("dynamicfiltervalue", followUpEELDynamicFilter);
                skyward.distinctMultiSelectEEL.registerDistinctMultiSelectEEL(followUpEEL);
            }
        };

        var applyPartialDayDuration = function ()
        {
            $(this).on('input change', function (e)
            {
                var actionDateFieldsParent = $(this).parents('.actionDateFields');
                var hiddenCheckbox = actionDateFieldsParent.find('.hiddenApplyPartialToServeOnStartDate');
                var durationTypeLabel = actionDateFieldsParent.find('.durationTypeLabel')

                var val = $(this).val();
                var valAsInt = parseInt(val) || 0;
                var hideCheckbox = !val || valAsInt == val || valAsInt < 1 || durationTypeLabel.text() == 'Hours';

                skyward.controls.setValue(hiddenCheckbox, hideCheckbox);
            });
        }

        var setPennsylvaniaStateReportingFields = function ()
        {
            $("#IncidentTypeCode")
                .off("change.pa")
                .on("change.pa", updatePARequiredAsterisk);
        }

        function updatePARequiredAsterisk()
        {
            var code = skyward.controls.getValue($("#IncidentTypeCode"));
            var isRequired = (code === "I");

            toggleLabelAsterisk(
                "IncidentPropertyDescription",
                isRequired
            );
        }

        function toggleLabelAsterisk(id, show)
        {
            var $label = $(document.getElementById(id)?.labels?.[0]);

            var propertyDescriptionAsterisk = $label.find("span.requiredAsterisk");

            if (show)
            {
                propertyDescriptionAsterisk.show();
            }
            else
            {
                propertyDescriptionAsterisk.hide();
            }
        }

        var setPennsylvaniaFieldsVisability = function (selector, incidentTypeCodeID)
        {
            const setStateOffenderTypePA = () =>
            {
                if (skyward.controls.getValue(incidentTypeCodeID) == "")
                {
                    incidentTypeCodeID = $(selector).parents().find(".incidentTypeCode");
                }

                let incidentTypeCode = skyward.controls.getValue(incidentTypeCodeID);

                if (incidentTypeCode != null) // This should only happen while the page is loading
                {
                    for (var j = 0; j < involvedPersonTypeIDs.length; ++j)
                    {
                        let suffix = '-';
                        if (typeof involvedPersonTypeIDs[j].id === 'string')
                        {
                            suffix = suffix.concat(involvedPersonTypeIDs[j].id.split('-').at(-1));
                        }
                        else
                        {
                            continue;
                        }
                        // Get variables to determine visibility
                        let currentInvolvementTypeCodeID = involvementTypeCodeIDs.filter((div) => div.id.endsWith(suffix));
                        let currentInvolvedPersonTypeID = involvedPersonTypeIDs.filter((div) => div.id.endsWith(suffix));
                        let involvementTypeCode = skyward.controls.getValue(currentInvolvementTypeCodeID);
                        let involvedPersonTypeCode = skyward.controls.getValue(currentInvolvedPersonTypeID);

                        // Get variables to show/hide
                        let currentStateOffenderTypePAID = stateOffenderTypePAIDs.filter((div) => div.id.endsWith(suffix));
                        let currentPAVictimFieldsID = paVictimFieldsIDs.filter((div) => div.id.endsWith(suffix));
                        let currentPAOffenderAndVictimFieldsID = paOffenderAndVictimFieldsIDs.filter((div) => div.id.endsWith(suffix));
                        let currentPAOffenderFieldsNonFreeformID = paOffenderFieldsNonFreeformIDs.filter((div) => div.id.endsWith(suffix));
                        let currentPAOffenderFieldsSectionHeaderID = paOffenderFieldsSectionHeaderIDs.filter((div) => div.id.endsWith(suffix));
                        let currentFreeformOtherNameFieldsID = freeformOtherNameFieldsIDs.filter((div) => div.id.endsWith(suffix));
                        let currentFreeformOtherNameFieldsVictimAndOffenderID = freeformOtherNameFieldsVictimAndOffenderIDs.filter((div) => div.id.endsWith(suffix));

                        if (involvementTypeCode == 'O' && incidentTypeCode == 'I')
                        {
                            if (involvedPersonTypeCode == 'FRE' || involvedPersonTypeCode == 'OTH')
                            {
                                $(currentPAOffenderFieldsSectionHeaderID).show();
                                $(currentFreeformOtherNameFieldsID).show();
                                $(currentFreeformOtherNameFieldsVictimAndOffenderID).show();
                            }
                            else
                            {
                                $(currentPAOffenderFieldsSectionHeaderID).hide();
                                $(currentFreeformOtherNameFieldsID).hide();
                                $(currentFreeformOtherNameFieldsVictimAndOffenderID).hide();
                            }
                        }
                        else if (involvementTypeCode == 'V' && (involvedPersonTypeCode == 'OTH' || involvedPersonTypeCode == 'FRE') && incidentTypeCode == 'I')
                        {
                            $(currentFreeformOtherNameFieldsVictimAndOffenderID).show();
                            $(currentFreeformOtherNameFieldsID).hide();
                            $(currentPAOffenderFieldsSectionHeaderID).hide();
                        }
                        else
                        {
                            $(currentFreeformOtherNameFieldsID).hide();
                            $(currentPAOffenderFieldsSectionHeaderID).hide();
                            $(currentFreeformOtherNameFieldsVictimAndOffenderID).hide();
                        }

                        if (incidentTypeCode == 'I')
                        {
                            if (involvementTypeCode == 'O')
                            {
                                $(currentPAOffenderFieldsSectionHeaderID).show();
                                $(currentPAOffenderAndVictimFieldsID).show();
                                $(currentStateOffenderTypePAID).show();
                                $(currentPAOffenderFieldsNonFreeformID).show();
                                $(currentPAVictimFieldsID).hide();
                            }
                            else if (involvementTypeCode == 'V')
                            {
                                $(currentPAOffenderAndVictimFieldsID).show();
                                $(currentPAVictimFieldsID).show();
                                $(currentPAOffenderFieldsNonFreeformID).hide();
                                $(currentStateOffenderTypePAID).hide();
                            }
                            else
                            {
                                $(currentPAOffenderAndVictimFieldsID).hide();
                                $(currentPAVictimFieldsID).hide();
                                $(currentStateOffenderTypePAID).hide();
                                $(currentPAOffenderFieldsNonFreeformID).hide();
                            }
                        }
                        else
                        {
                            $(currentStateOffenderTypePAID).hide();
                            $(currentPAVictimFieldsID).hide();
                            $(currentPAOffenderAndVictimFieldsID).hide();
                            $(currentPAOffenderFieldsNonFreeformID).hide();
                        }
                    }
                }
            }

            // Variables to watch for change
            var incidentTypeCodeID = $(selector).find(".incidentTypeCode")
            var involvementTypeCodeIDs = [...document.querySelectorAll('[id*="IncidentOffenseNameInvolvementTypeCode-"]')];
            var involvedPersonTypeIDs = [...document.querySelectorAll('[id*="IncidentOffenseNameIncidentOffenseNameTypeCode-"]')];

            // Divs to show/hide
            var stateOffenderTypePAIDs = [...document.querySelectorAll('[id*="fsStateOffenderTypePA-"]')];
            var paVictimFieldsIDs = [...document.querySelectorAll('[id*="fsPAVictimFields-"]')];
            var paOffenderAndVictimFieldsIDs = [...document.querySelectorAll('[id*="fsPAOffenderAndVictimFields-"]')];
            var paOffenderFieldsNonFreeformIDs = [...document.querySelectorAll('[id*="fsPAOffenderFieldsNonFreeform-"]')];
            var paOffenderFieldsSectionHeaderIDs = [...document.querySelectorAll('[id*="fsPAOffenderFieldsSectionHeader-"]')];
            var freeformOtherNameFieldsIDs = [...document.querySelectorAll('[id*="fsFreeformOtherNameFields-"]')];
            var freeformOtherNameFieldsVictimAndOffenderIDs = [...document.querySelectorAll('[id*="fsFreeformOtherNameFieldsVictimAndOffender-"]')];

            // Attach event handlers
            $(incidentTypeCodeID).on('change', () => setStateOffenderTypePA());
            for (var i = 0; i < involvementTypeCodeIDs.length; i++)
            {
                $(involvementTypeCodeIDs[i]).on('change', () => setStateOffenderTypePA());
                $(involvedPersonTypeIDs[i]).on('change', () => setStateOffenderTypePA());
            }

            // Run each time a new person is added to the incident
            setStateOffenderTypePA();
        }

        var initStudentIndicatorDisplay = function ()
        {
            var studentindicatorbutton = $(this);
            var incidentQuickEntryIndicators = studentindicatorbutton.parents(".incidentQuickEntryIndicators").first();
            skyward.controls.hide(incidentQuickEntryIndicators.parent());
            var removeDuplicates = function (indicatorParent)
            {
                if (indicatorParent.find(".incidentQuickEntryIndicators").length > 1)
                {
                    indicatorParent.find(".incidentQuickEntryIndicators").first().remove();
                    removeDuplicates(indicatorParent);
                }
                else
                {
                    skyward.controls.show(indicatorParent);
                }
            };
            setTimeout(
                function () 
                {
                    removeDuplicates(incidentQuickEntryIndicators.parent());
                }, 10); //Account for ajax being processed at exact same time.
        };

        var events =
        {
            'excludePrimaryOffense': excludePrimaryOffense,
            'applyPartialDayDuration': applyPartialDayDuration,
            'setPennsylvaniaFieldsVisability': setPennsylvaniaFieldsVisability,
            'setPennsylvaniaStateReportingFields': setPennsylvaniaStateReportingFields,
            'initStudentIndicatorDisplay': initStudentIndicatorDisplay,
        };

        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('disciplineQuickEntry', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.disciplinepartialday = skyward.disciplinepartialday || {};

        var init = function (selector)
        {
            var getDataForAjax = function (input)
            {
                if (input instanceof $ === false)
                {
                    input = $(input);
                }

                var calendarid = null;
                var dayrotation = null;
                var incidentoffensenameactiondetailid = null;
                var inputId = input.attr('id');

                if (inputId)
                {
                    if (inputId.indexOf('hiddencalendarid') > -1)
                    {
                        calendarid = input.val();
                    }
                    else if (inputId.indexOf('hiddendayrotation') > -1)
                    {
                        dayrotation = input.val();
                    }
                    else if (inputId.indexOf('hiddenincidentoffensenameactiondetailid') > -1)
                    {
                        incidentoffensenameactiondetailid = input.val();
                    }

                    if (dayrotation === null)
                    {
                        dayrotation = input.siblings('[id*="hiddendayrotation"]:eq(0)').val();
                    }
                    if (calendarid === null)
                    {
                        calendarid = input.siblings('[id*="hiddencalendarid"]:eq(0)').val();
                    }
                    if (incidentoffensenameactiondetailid === null)
                    {
                        incidentoffensenameactiondetailid = input.siblings('[id*="hiddenincidentoffensenameactiondetailid"]:eq(0)').val();
                    }
                }

                return {
                    calendarid: calendarid,
                    dayrotation: dayrotation,
                    incidentoffensenameactiondetailid: incidentoffensenameactiondetailid
                };
            };

            var onChangeCallback = function ()
            {
                var element = $(this);
                var postData = getDataForAjax(element);
                
                var viewpartContainer = element.parent();
                var table = viewpartContainer.children('table:eq(0)'); // Find existing table
                table.children().remove(); // remove existing table contents

                var myViewpartId = viewpartContainer.attr('id');

                // Nested id/name prefix/postfix from parent and grandparent repeaters
                var ancestorRepeaters = viewpartContainer.parents('tr.childrecordquickentryrow');
                var parentRepeaterId = ancestorRepeaters.eq(0).attr('id');
                var parentRepeaterIdPostfix = parentRepeaterId ? parentRepeaterId.substr(parentRepeaterId.lastIndexOf('-') + 1) : null;
                var nestedRepeaterIdPrefix = ancestorRepeaters.eq(1).attr('id');

                var loading = viewpartContainer.find('.disciplinepartialdayLoadingGif');
                loading.css('display', '');

                var message = viewpartContainer.children('label[id*="partialdaymessage"]:eq(0)');
                var portalForAjax = $("#PortalForAjax").val() || 'Administrative';

                if (myViewpartId)
                {
                    $.ajax({
                        url: skyward.global.virtualDir + 'Discipline/IncidentOffenseNameActionDetail/UpdatePartialDayViewpart' + portalForAjax,
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            calendarid: postData.calendarid,
                            incidentoffensenameactiondetailid: postData.incidentoffensenameactiondetailid,
                            dayrotation: postData.dayrotation
                        },
                        success: async function (data)
                        {
                            table.children().remove(); // remove existing table contents

                            if (data && data.viewparts)
                            {
                                const processedViewparts = await skyward.global.processViewPartHtml(data.viewparts);

                                updateIdsAndNamesInRepeater(processedViewparts, parentRepeaterIdPostfix, nestedRepeaterIdPrefix);

                                // Append all the newly rendered table's child content to the existing table
                                table.append($(processedViewparts).children());

                                // Hide the message label
                                message.css('display', 'none');

                                skyward.window.notifyDOMLoad(viewpartContainer.attr('id'));
                            }
                            else
                            {
                                // Show the message label
                                message.css('display', '');
                            }
                        },
                        complete: function ()
                        {
                            loading.css('display', 'none');
                        }
                    });
                }
            };

            var updateIdsAndNamesInRepeater = function (parsedHTML, parentRepeaterIdPostfix, nestedRepeaterIdPrefix)
            {
                // update ids and names if in a repeater
                if (parentRepeaterIdPostfix)
                {
                    $(parsedHTML).find('[id], [name], :input').each(function ()
                    {
                        var element = $(this);
                        var myId = element.attr('id');
                        var myName = element.attr('name');

                        if (myId)
                        {
                            myId = myId + '-add-' + parentRepeaterIdPostfix;
                        }

                        if (myName)
                        {
                            myName = myName + '-add-' + parentRepeaterIdPostfix;
                        }

                        if (myId || myName)
                        {
                            skyward.controls.changeId(element, myId, myName);
                        }
                    });
                }

                // update ids and names if in a nested repeater
                if (nestedRepeaterIdPrefix)
                {
                    $(parsedHTML).find('[id], [name], :input').each(function ()
                    {
                        var element = $(this);
                        var myId = element.attr('id');
                        var myName = element.attr('name');

                        if (myId)
                        {
                            myId = nestedRepeaterIdPrefix + '-' + myId;
                        }

                        if (myName)
                        {
                            myName = nestedRepeaterIdPrefix + '-' + myName;
                        }

                        if (myId || myName)
                        {
                            skyward.controls.changeId(element, myId, myName);
                        }
                    });
                }
            };

            var toggleMessageVisibility = function (partialDayViewpart, table)
            {
                var partialDayMessage = partialDayViewpart.children('label[id*="partialdaymessage"]:eq(0)');
                if (table.children().length === 0)
                {
                    partialDayMessage.css('display', '');
                }
                else
                {
                    partialDayMessage.css('display', 'none');
                }
            };

            $(selector + ' .disciplinepartialday').each(function ()
            {
                var partialDayViewpart = $(this);
                var validateControlFor = partialDayViewpart.attr('data-validate-control-for');
                var table = partialDayViewpart.children('table:eq(0)');
                if (validateControlFor && table.length > 0)
                {
                    table.attr('data-validate-control-for', validateControlFor);
                    partialDayViewpart.removeAttr('data-validate-control-for');
                }

                var hiddenInput = partialDayViewpart.children('input[id*="hiddencalendarid"],input[id*="hiddendayrotation"],input[id*="hiddenincidentoffensenameactiondetailid"]');
                hiddenInput.off('change').debounce('change', onChangeCallback);

                // Create Loading gif for when viewpart updates
                if (partialDayViewpart.find('.disciplinepartialdayLoadingGif').length === 0)
                {
                    var loading = skyward.window.getImage();
                    loading.removeClass('pageLoadingGif');
                    loading.addClass('disciplinepartialdayLoadingGif');
                    loading.css('display', 'none');
                    partialDayViewpart.append(loading);
                }
                
                toggleMessageVisibility(partialDayViewpart, table);
            });
        };

        skyward.disciplinepartialday.PartialDaySelectAll = function (checkbox)
        {
            var isChecked = checkbox.checked;
            var table = $(checkbox).closest('table');

            table.find('.checkbox:not(.SelectAllCheckbox)').each(function ()
            {
                skyward.controls.changeCheckBoxWithSelectAll($(this), isChecked);
            });
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.demographics = skyward.demographics || {};

        var init = function ()
        {
            var nameMergeScreen = this.find("#NameMergeNameSelect");
            if (nameMergeScreen.length !== 0)
            {
                getAndSetNameMergeScreenInfo(nameMergeScreen);
            }
        };

        skyward.window.registerLoadDOMCallback(init);

        var getAndSetNameMergeScreenInfo = function (informationDiv)
        {
            var mergeFromNameID = skyward.controls.getValue('#MergeFromNameID');
            var mergeToNameID = skyward.controls.getValue('#MergeToNameID');
            var checkboxDatas = [];

            if (mergeFromNameID === "" || mergeToNameID === "")
            {
                return;
            }

            var checkboxes = informationDiv.find(':checkbox').each(function ()
            {
                checkboxDatas.push({ checkboxID: this.id, value: skyward.controls.getValue(this) });
            });

            $.when($("#MergeFromNameID_value").change()).done(function ()
            {
                $.each(checkboxDatas, function (i, val)
                {
                    if (val.value)
                    {
                        skyward.controls.setValue($('#' + val.checkboxID), true);
                    }
                });
            });
        };

        skyward.demographics.newEmergencyContactTab = function ()
        {
            var parentBrowse = $(this).parents('#EmergencyContactNameLookupBrowse')[0];
            if (parentBrowse.hasAttribute("data-isstudentec"))
            {
                var isStudentEC = parentBrowse.attributes["data-isstudentec"].value;
                if (isStudentEC == "True")
                {
                    if (parentBrowse.hasAttribute("data-studentid"))
                    {
                        skyward.window.loadContent('popout', "Demographics", "EmergencyContact", "StudentProfile", parentBrowse.attributes["data-studentid"].value);
                    }
                }
                if (isStudentEC == "False")
                {
                    if (parentBrowse.hasAttribute("data-employeeid"))
                    {
                        skyward.window.loadContent('popout', "Employee", "EmergencyContact", "EmployeeProfile", parentBrowse.attributes["data-employeeid"].value);
                    }
                }
            }
        };

        function resetMessage(field, defaultSubject, defaultContent)
        {
            skyward.controls.setValue($('#' + field + 'Subject'), defaultSubject, false);
            skyward.controls.setValue($('#' + field + 'Content'), defaultContent, false);
        };

        //Changes here need to be replicated in Skyward.Business.Demographics.ConfigSystem as well.
        const resetACHAccountModificationMessage = function ()
        {
            skyward.messagecenter.resetTemplate(
                this,
                'ACH Account Modified',
                'An ACH Account linked to {Name.FullNameFL} has been modified. If you were not expecting this change, please reach out to your Human Resources representative.');
        };

        // Event handlers
        var events =
        {
            "newEmergencyContactTab": skyward.demographics.newEmergencyContactTab,
            "updateForIsSingleLegalNameOption": skyward.demographics.updateForIsSingleLegalNameOption,
            resetACHAccountModificationMessage,
        };
        skyward.events.registerEvents("demographics", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.family = skyward.family || {};

        skyward.family.newFamilyTab = function ()
        {
            var parentBrowse = $(this).parents('#StudentGuardianNameLookupBrowse')[0];
            if (parentBrowse.hasAttribute("data-studentid"))
            {
                skyward.window.loadContent('popout', "Family", "StudentFamily", "StudentProfile", parentBrowse.attributes["data-studentid"].value);
            }
        };

        skyward.family.newSiblingStudentProfileTab = function ()
        {
            var sourceButton = $(this);
            var studentID = sourceButton.data('studentid');
            var schoolYearID = sourceButton.data('schoolyearid');
            var entityID = sourceButton.data('entityid');

            var target = skyward.global.mobileAccess ? 'full' : 'popout'; // 'popout' in mobile opens in a modal
            var data = { StudentID: studentID, SchoolYearID: schoolYearID, EntityID: entityID };

            skyward.window.loadContent(target, "Student", "Student", "SwitchEntityForSiblingProfile", undefined, data);
        };

        var checkForDirtySkylertCredentials = function (event) {
            var field = $(event.target);
            var originalValue = skyward.controls.getOriginalValue(field);
            var value = field.val();
            var fieldDirty = value !== originalValue;

            var isDirty = skyward.changeTracking.isDirty($(".js-triggerSkylertWorkflowHide").not(field).parent());
            setSkylertTestConnectionHidden(isDirty || fieldDirty);

        }

        var setSkylertTestConnectionHidden = function (hasPendingChanges) {
            $(".js-hideOnPendingChanges").each(function () {
                this.style.display = hasPendingChanges ? "none" : "";
            });
        }

        skyward.family.skylertClearNamePhone = function (event) {
            var source = $(event.target).closest('a');
            var textboxID = source.data('id');
            var sequenceNumber = source.data('sequencenumber');
            var districtID = source.data('districtid');

            var selectAllCheckboxes = $(event.target).parents('.browseBody').find('[id ^="SelectAll-NamePhone-JobType-"][id $="-' + sequenceNumber + '"][type="checkbox"]:not(.ui-disabled)');
            var checkboxes = $(event.target).parents('.browseBody').find('[id ^="NamePhone-JobType-"][data-sequencenumber="' + sequenceNumber + '"][data-districtid="' + districtID + '"][type="checkbox"]:not(.ui-disabled)');
            var phoneTextBox = $(event.target).parents('.browseBody').find('#PhoneNumber-' + textboxID);
            var phoneTypeInput = $(event.target).parents('.browseBody').find("[name='PhoneType-" + textboxID + "']");

            skyward.controls.setValue(selectAllCheckboxes, "false", false);
            skyward.controls.setValue(checkboxes, "false", false);
            if (!phoneTextBox.is('[readonly]'))
            {
                skyward.controls.setValue(phoneTextBox, "", false);
            }
            skyward.codeeel.clear(phoneTypeInput.closest(".codeEEL"), true);
        }

        skyward.family.skylertClearNameEmail = function (event) {
            var source = $(event.target).closest('a');
            var textboxID = source.data('id');
            var sequenceNumber = source.data('sequencenumber');
            var districtID = source.data('districtid');

            var selectAllCheckboxes = $(event.target).parents('.browseBody').find('[id ^="SelectAll-NameEmail-JobType-"][id $="-' + sequenceNumber + '"][type="checkbox"]:not(.ui-disabled)');
            var checkboxes = $(event.target).parents('.browseBody').find('[id ^="NameEmail-JobType-"][data-sequencenumber="' + sequenceNumber + '"][data-districtid="' + districtID + '"][type="checkbox"]:not(.ui-disabled)');
            var emailTextBox = $(event.target).parents('.browseBody').find('#EmailAddress-' + textboxID);
            var emailTypeInput = $(event.target).parents('.browseBody').find("[name='EmailType-" + textboxID + "']");

            skyward.controls.setValue(selectAllCheckboxes, "false", false);
            skyward.controls.setValue(checkboxes, "false", false);
            if (!emailTextBox.is('[readonly]'))
            {
                skyward.controls.setValue(emailTextBox, "", false);
            }
            skyward.codeeel.clear(emailTypeInput.closest(".codeEEL"), true);
        }

        skyward.family.skylertClearSchoolMessenger = function (event) {
            var source = $(event.target).closest('a');
            var id = source.data('id');
            var textBox = $(event.target).parents('.browseBody').find('[id ^="SchoolMessenger"][id $="-' + id + '"][type !="checkbox"]');
            var checkboxes = $(event.target).parents('.browseBody').find('[id ^="SchoolMessenger"][id $="-' + id + '"][type="checkbox"]:not(.ui-disabled)');
            skyward.controls.setValue(checkboxes, false, false);
            skyward.controls.setValue(textBox, "", false);
        }

        var familySystemConfigEnableActiveStudentEnrollmentPopup = function (event) {
            var button = $(this);
            var title = 'Setting Information';
            var options =
            {
                anchorTo: button,
                id: "FamilySystemConfigEnableActiveStudentEnrollmentPopup"
            };

            var message = '<span>Enabling this option will allow active Students to be selected from the Existing Students drop down when approving a New Student Enrollment Online Form.<span>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        // Event handlers
        var events =
        {
            "newFamilyTab": skyward.family.newFamilyTab,
            "newSiblingStudentProfileTab": skyward.family.newSiblingStudentProfileTab,
            "skylertClearNamePhone": skyward.family.skylertClearNamePhone,
            "skylertClearNameEmail": skyward.family.skylertClearNameEmail,
            "familySystemConfigEnableActiveStudentEnrollmentPopup": familySystemConfigEnableActiveStudentEnrollmentPopup
        };
        skyward.events.registerEvents("family", events);

        var init = function (selector)
        {
            var studentGuardianAddWorkflowRepeater = $(selector).find("#StudentGuardianAddWorkflowRepeater");
            if (studentGuardianAddWorkflowRepeater.length !== 0)
            {
                studentGuardianAddWorkflowRepeater.trigger("onload");
            }

            var skylertConnectionFields = $(selector).find(".js-triggerSkylertWorkflowHide");
            if (skylertConnectionFields.length !== 0) {
                skylertConnectionFields.off('keyup').on('keyup', checkForDirtySkylertCredentials);
            }

        }

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.onlineform = skyward.onlineform || {};
        const inited = skyward.events.getCallbackStore();
        skyward.onlineform.inited = skyward.events.getCallbackStoreFacadeCollection({ inited }).inited;

        var init = function (selector)
        {
            return initInternal.call(this, selector).then(() => inited.dispatchCallbacks.call(this, selector));
        };

        var initInternal = async function (selector)
        {
            const selectorElement = $(selector);
            skyward.electronicSignature.registerElectronicSignatureAgreeCheckboxEvent(selectorElement.find(".electronicSignatureAgreeCheckbox"));

            var stepStatusSection = selectorElement.find('.onlineFormReviewHeading.js-scrollTo');
            if (stepStatusSection.length)
            {
                stepStatusSection[0].scrollIntoView();
            }

            // TODO (3902178 - Make Online Forms Mobile Friendly) double check if this is needed
            selectorElement.find(' .printOnlineFormAdminReviewButton').on('click', function () { print($(this), $(".onlineFormAdminReview")); });

            selectorElement.find('.onlineFormContent.js-printOnlineFormHtmlElement').on('click', function () { printHtmlElement($(this)); });

            selectorElement.find('.onlineFormContent.js-printOnlineFormMergeMarkupElement').on('click', function () { printHtmlElement($(this)); });

            selectorElement.find('.onlineForm_DeleteOnlineFormButton').on("click", deleteOnlineForm);

            selectorElement.find('.js-ElementQuickEntry').not('.onlineFormElementEventsBound').each(function ()
            {
                var elementRepeaterParent = $(this);

                elementRepeaterParent.on('childrecordquickentry-row-added', function (_, newRow)
                {
                    rowAddedUpdateOrder(newRow);
                });

                elementRepeaterParent.on('childrecordquickentry-row-cleared', function (_, clearedRow, isRowBeingRemoved)
                {
                    rowClearedUpdateElementOrder(clearedRow, isRowBeingRemoved, elementRepeaterParent);

                    if (!isRowBeingRemoved)
                    {
                        clearedRow.find('[data-default-state]:input', '[data-default-checkbox-state]:input:checkbox').each(function ()
                        {
                            var defaultState = $(this);
                            skyward.controls.setValue(defaultState, defaultState.data('defaultState'));
                        });
                    }
                });

                elementRepeaterParent.addClass('onlineFormElementEventsBound');
            });

            var iFrames = $(selector + ' .onlineForm.iFrame');

            var embeddedLinkContainer = selectorElement.find(".onlineForm.embeddedLinkContainer");
            if (embeddedLinkContainer.length > 0)
            {
                iFrames.each(function ()
                {
                    setupEmbeddedLink($(this));
                });
            }

            var htmlContainers = $(selector + " .onlineForm.htmlContainer");
            await $.whenAllSettled(htmlContainers.toArray().map(async function (elem)
            {
                var htmlContainer = $(elem);
                var iFrame = htmlContainer.find('.onlineForm.iFrame');

                if (iFrame.hasClass('skipIFrameSrcInit'))
                {
                    return;
                }

                await setupHtmlIFrame(htmlContainer, iFrame);
            }))
                .catch(() => { });

            const nonIgnoredIFrames = iFrames.filter(':not(.js-ignoreIFrameContents)').toArray();
            // Hidden iframes mostly don't perform layout, so setupIFrame can only calculate the correct
            // height for the visible ones.
            await $.whenAllSettled(nonIgnoredIFrames
                .map(function (iframe)
                {
                    return setupIFrame($(iframe));
                }))
                .catch(() => { });

            // mass print takes care of resizing iframes itself
            if (!matchMedia("print"))
            {
                skyward.window.registerLayoutResizeCallback(function ()
                {
                    iFrames.filter(':not(.js-ignoreIFrameContents)').add(htmlContainers.find('.onlineForm.iFrame')).each(function ()
                    {
                        skyward.onlineform.setupIframeHeight($(this), "resize");
                    });
                });
            }

            var mergeMarkupContainers = selectorElement.find('.onlineForm.mergeMarkupContainer');
            mergeMarkupContainers.each(function ()
            {
                setupMergeMarkup($(this));
            });

            selectorElement.find('.raceEthnicityVerification').change(function (e)
            {
                var raceEthnicity = $(this);

                var hiddenValue = raceEthnicity.find('.raceEthnicityVerificationHiddenValue');
                var values = {};
                raceEthnicity.find(':input, .languageOptionTypeCode').not(hiddenValue).each(function ()
                {
                    var input = $(this);
                    var parsedControl = getNameOrId(input).split('_')[0];
                    if (parsedControl.length)
                    {
                        values[parsedControl] = skyward.controls.getValue(input);
                    }
                });
                hiddenValue.val(JSON.stringify(values));
            });

            selectorElement.find('.codeEEL > .onlineFormAdminReviewControlHighlight').each(function ()
            {
                $(this).closest('.codeEEL').addClass('onlineFormAdminReviewControlHighlight');
            });

            selectorElement.find('.stepRow').each(function ()
            {
                var stepRow = $(this);

                if (!stepRow.length)
                {
                    return;
                }

                var currentValues = stepRow.find('.onlineFormCurrentValue .onlineFormAdminReviewElement');
                var updatedValues = stepRow.find('.onlineFormUpdatedValue .onlineFormAdminReviewElement');
                if (currentValues.length && updatedValues.length)
                {
                    updatedValues.each(function (index)
                    {
                        var updatedValue = $(this);
                        var currentValue = currentValues.eq(index);
                        if (currentValue.length)
                        {
                            var updatedValueHeight = updatedValue.height();
                            var currentValueHeight = currentValue.height();
                            if (updatedValueHeight < currentValueHeight)
                            {
                                updatedValue.css('min-height', currentValueHeight);
                            }
                            else if (updatedValueHeight > currentValueHeight)
                            {
                                currentValue.css('min-height', updatedValueHeight);
                            }
                        }
                    });
                }
            });

            $(selector + ' #AttachmentLocationSelectEEL').change(function ()
            {
                const selectedAttachmentLocationValue = $(this).get(0).value;
                var selectedAttachmentLocationDatas = selectedAttachmentLocationValue ? selectedAttachmentLocationValue.split(',') : [];
                var hideStudentGeneralAttachmentLocationDetails = true;
                var $studentGeneralAttachmentLocationDetailsDiv = $("#StudentGeneralAttachmentLocationDetailsDiv");
                if ($studentGeneralAttachmentLocationDetailsDiv.length == 0)
                {
                    $studentGeneralAttachmentLocationDetailsDiv = $("#editAttachmentType_StudentGeneralAttachmentLocationDetailsDiv");
                }

                for (var i = 0; i < selectedAttachmentLocationDatas.length; i++)
                {
                    var selectedAttachmentLocationCode = selectedAttachmentLocationDatas[i].split(':')[1];
                    if (selectedAttachmentLocationCode == "\"STU-GEN\"" || selectedAttachmentLocationCode == "\"STU-GEN\"}")
                    {
                        skyward.controls.show($studentGeneralAttachmentLocationDetailsDiv);
                        hideStudentGeneralAttachmentLocationDetails = false;
                        break;
                    }
                }

                if (hideStudentGeneralAttachmentLocationDetails)
                {
                    skyward.controls.hide($studentGeneralAttachmentLocationDetailsDiv);
                }
            });

            skyward.changeTracking.setUpChangeTracking(selector + " .onlineFormArea");

            selectorElement.find('.js-allowLanguageUpdateCheckbox').on("change", allowLanguageUpdateCheckboxChange);

            selectorElement.find('.js-approvalNeededRadioButton').change(approvalNeededRadioButtonChange);

            selectorElement.find('.js-approvalOptionRadioButtonGroup').on("change", approvalOptionRadioButtonGroupChange);

            selectorElement.find('.js-elementTypeComboBox').change(elementTypeComboBoxChange);

            selectorElement.find('.js-fieldGroupTypeComboBox').change(fieldGroupTypeComboBoxChange);

            selectorElement.find('.js-portalTypeComboBox').on("change", function (_event)
            {
                updateAllowMultipleFormsPerUserVisibility(selectorElement);
            });

            selectorElement.on("change", '.js-limitUsersToOneFormOfThisTypePerYearCheckbox', function (_event)
            {
                updateAllowMultipleFormsPerUserVisibility(selectorElement);
            });

            selectorElement.find('.js-includeInProcessManager').on("change", function (_event)
            {
                updateAllowMultipleFormsPerUserVisibility(selectorElement);
            });

            selectorElement.find('.js-editOnlineForm').on('ajaxcomplete', function ()
            {
                updateAllowMultipleFormsPerUserVisibility(selectorElement);
            });

            updateAllowMultipleFormsPerUserVisibility(selectorElement);

            setStepFilterModifiedNotification(selectorElement, ".js-stepFilterViewerPromptPanel", ".filterValue");
            setStepFilterModifiedNotification(selectorElement, ".js-stepFilterViewerAdvancedFilterPanel", ".filterViewValue");
        };

        var elementOrderLabelPrefix = 'Element Order: ';

        var getElementOrderLabelPrefix = function (elementOrderLabelText)
        {
            // takes all all text from the string until it finds digits at the end of the string (ignoring trailing spaces at the end).
            var match = /^(.*?)(\d+)\s*$/.exec(elementOrderLabelText || '');
            return match ? match[1] : elementOrderLabelPrefix;
        };

        var parseElementOrderFromLabelText = function (elementOrderLabelText)
        {
            var match = /(\d+)\s*$/.exec(elementOrderLabelText || '');
            return match ? parseInt(match[1], 10) : NaN;
        };

        function rowAddedUpdateOrder(newRow)
        {
            const newRowElementOrderLabel = newRow.find('.elementOrderLabel');
            const previousLabelText = newRow.prevAll('.childrecordquickentryrow').first().find('.elementOrderLabel').text();
            const previousElementOrderValue = parseElementOrderFromLabelText(previousLabelText);
            if (previousElementOrderValue)
            {
                const prefix = getElementOrderLabelPrefix(previousLabelText);
                newRowElementOrderLabel.text(prefix + (previousElementOrderValue + 1));
            }
        }

        var rowClearedUpdateElementOrder = function (clearedRow, isRowBeingRemoved)
        {
            if (isRowBeingRemoved)
            {
                var elementOrder = parseElementOrderFromLabelText(clearedRow.find('.elementOrderLabel').text());
                if (!elementOrder)
                {
                    return;
                }

                clearedRow.nextAll('.childrecordquickentryrow').each(function ()
                {
                    var elementOrderLabel = $(this).find('.elementOrderLabel');
                    if (elementOrderLabel.length)
                    {
                        var prefix = getElementOrderLabelPrefix(elementOrderLabel.text());
                        elementOrderLabel.text(prefix + elementOrder);
                        elementOrder++;
                    }
                });
            }
        };

        skyward.onlineform.processManagerUpdateLinkActionWithPrimaryKey = function (clickedElement)
        {
            var onlineFormStatusID = $(clickedElement).val();

            var button = $(clickedElement.parentElement.parentElement).find(".processTaskElementInstance__actionButton")
            button.off("click");
            button.prop("onclick", null);
            button.on("click", function ()
            {
                if ($(this).hasClass('ui-disabled'))
                {
                    return false;
                }
                skyward.window.loadContent('popout', 'OnlineForm', 'OnlineFormStatus', 'Details', onlineFormStatusID, {}
                    , null, null, null, false, null, null, null, null, null, null);
            });
        }

        skyward.onlineform.createFieldSelector = function (clickedElement)
        {
            if (!(clickedElement instanceof $))
            {
                clickedElement = $(clickedElement);
            }
            var isWorkflow = clickedElement.parents('.workflow').length > 0;
            var module = $('.onlineFormModule').val();
            var object = $('.onlineFormObject').val();

            if (!module || !object)
            {
                return;
            }

            var saveButton = {
                text: "Select Field",
                "click": function ()
                {
                    selectField(clickedElement, fieldSelectModal, isWorkflow, module, object);
                },
                "icon": "Select"
            };
            var cancelButton = { text: "Cancel", "click": "close", "icon": "Cancel" };
            var options =
            {
                anchorTo: clickedElement
            };

            var fieldSelectModal = skyward.modalLayer.showDialog("Select Field", function () { return buildSelectFieldPopup(module, object, isWorkflow, clickedElement); }, [saveButton, cancelButton], options);

            fieldSelectModal.content.on('contentLoaded', function ()
            {
                fieldSelectModal.animateModalContents();
                skyward.window.notifyDOMLoad('.insertColumnTreeBrowse');
            });
            fieldSelectModal.content.on('treeBrowseContentLoaded', function ()
            {
                fieldSelectModal.animateModalContents();
            });
            fieldSelectModal.content.on('treeBrowseSave', function ()
            {
                selectField(clickedElement, fieldSelectModal, isWorkflow, module, object);
            });
        };

        var getRelationshipPathMinusInitialRootObject = function (relationshipPath)
        {
            return relationshipPath.substring(relationshipPath.indexOf('.') + 1);
        };

        var selectField = function (fieldSelectButton, fieldSelectModal, isWorkflow, module, object)
        {
            var listData = skyward.treebrowse.getSelectedFieldData(fieldSelectModal.content);

            if (!listData || !listData.fieldName || !listData.fieldType)
            {
                return;
            }

            var isRelationship = listData.fieldType === 'ManyToOne';

            var fieldNameData = isRelationship
                ? getRelationshipPathMinusInitialRootObject(listData.fieldName)
                : listData.absoluteFieldPath;

            if (!fieldNameData)
            {
                return;
            }

            $.ajax(
                {
                    url: skyward.global.virtualDir + 'OnlineForm/Step/UpdateFieldOptions' + (isWorkflow ? 'Workflow' : 'Details'),
                    type: "POST",
                    data:
                    {
                        moduleName: module,
                        objectName: object,
                        fieldName: fieldNameData,
                        isRelationship: isRelationship
                    },
                    success: function (data)
                    {
                        var fieldSelectContainer = fieldSelectButton.parents('.onlineformelement:eq(0)');
                        var radioButtonGroupValue = fieldSelectContainer.find('.radioButtonGroupValue');
                        var fieldOptions = fieldSelectContainer.find('.fieldOptionsGroup');

                        if (fieldOptions.length)
                        {
                            fieldOptions.find('[value="APPROVAL"]').prop('disabled', !data.ApprovalRequiredEnabled);
                            if (!data.ApprovalRequiredEnabled)
                            {
                                fieldOptions.find('[value="APPROVAL"]').prop('checked', false);
                            }
                            if (data.SelectedValueCode)
                            {
                                skyward.controls.setValue(fieldOptions, data.SelectedValueCode);
                                radioButtonGroupValue.attr('value', data.SelectedValueCode);
                            }

                            updateSelectedField(fieldSelectContainer, listData, data.FieldID, data.GuidPath, isRelationship);
                        }
                    }
                });

            fieldSelectModal.close();
        };

        const updateSelectedField = function (fieldSelectContainer, selectedFieldData, fieldID, guidPath, isRelationship)
        {
            if (fieldSelectContainer.length && selectedFieldData)
            {
                var selectedFieldValue = fieldSelectContainer.find('.elementFieldValue');
                var selectedGUIDFieldPathValue = fieldSelectContainer.find('.elementGUIDFieldPathValue');
                const fieldDisplayNameTextArea = fieldSelectContainer.find('.elementFieldDisplayName');
                var selectedFieldID = fieldSelectContainer.find('.elementFieldID');
                var selectedFieldPath = fieldSelectContainer.find('.elementFieldPath');
                const labelTextBox = fieldSelectContainer.find('.js-elementLabelTextBox');
                var selectedFieldIsRelationship = fieldSelectContainer.find('.elementFieldIsRelationship');

                var relationshipPathMinusRootObject = isRelationship
                    ? getRelationshipPathMinusInitialRootObject(selectedFieldData.fieldName)
                    : null;

                skyward.controls.setValue(selectedFieldValue, isRelationship ? relationshipPathMinusRootObject : selectedFieldData.absoluteFieldPath);
                skyward.controls.setValue(selectedGUIDFieldPathValue, guidPath);
                skyward.controls.setValue(fieldDisplayNameTextArea, selectedFieldData.fieldPath.replaceAll(".", " > "));
                skyward.controls.setValue(selectedFieldID, fieldID);
                skyward.controls.setValue(selectedFieldPath, selectedFieldData.fieldName);
                skyward.controls.setValue(selectedFieldIsRelationship, Boolean(isRelationship));
                selectedFieldID.attr('value', fieldID);

                const newLabel = selectedFieldData.displayPathText.split(" > ").pop();

                skyward.controls.setValue(labelTextBox, newLabel);
                labelTextBox.attr('value', newLabel);
            }
        };

        const buildSelectFieldPopup = function (dataModule, dataObject, isWorkflow, fieldSelectButton)
        {
            let fieldSelectContainer = fieldSelectButton.parents('.onlineformelement:eq(0)');
            let selectedFieldPathContainer = fieldSelectContainer.find('.elementFieldPath');
            let selectedFieldPath = skyward.controls.getValue(selectedFieldPathContainer);
            let selectedFieldContainer = fieldSelectContainer.find('.elementFieldValue');
            let selectedField = skyward.controls.getValue(selectedFieldContainer);

            if (!selectedField)
            {
                let selectedFieldIndex = selectedFieldPath.lastIndexOf('.');
                selectedField = selectedFieldPath.substring(selectedFieldIndex + 1);
            }

            return $.ajax(
                {
                    url: skyward.global.virtualDir + "OnlineForm/Step/BuildTreeBrowse" + (isWorkflow ? 'Workflow' : 'Details'),
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        lookupModule: dataModule,
                        lookupObject: dataObject,
                        seekField: selectedField,
                        seekFieldPath: selectedFieldPath,
                    }
                });
        };

        const deleteOnlineForm = function ()
        {
            const button = $(this);
            const onlineFormName = button.data('onlineformname');
            const onlineFormStartDate = button.data('onlineformstartdate');
            const onlineFormStatusID = button.data('onlineformstatusid');
            const portalName = button.data('portalname');
            const redirectArea = button.data('redirectarea');
            const redirectController = button.data('redirectcontroller');
            const redirectAction = button.data('redirectaction');
            const detailText = "This In-Progress Online Form will be deleted. You can start a new " + onlineFormName + " form through the Dashboard.";
            const referenceItems =
                [
                    { label: "Form Name", data: onlineFormName },
                    { label: "This Form Started On", data: onlineFormStartDate }
                ];

            window.skyward.modalLayer.confirmDelete("In-Progress Online Form", detailText, { referenceItems }).then(function ()
            {
                return $.ajax(
                    {
                        url: `${skyward.global.virtualDir}OnlineForm/OnlineFormStatus/${portalName}DeleteOnlineFormStatus/${onlineFormStatusID}`,
                        type: "POST"
                    })
            }).then(function ()
            {
                skyward.window.setSkipUnloadCheck(true);
                skyward.window.loadContent("full", redirectArea, redirectController, redirectAction);
            });
        };

        const printStepStatus = function ()
        {
            print($(this), $("#onlineForm_stepStatus"));
        };

        const print = function (button, container)
        {
            if (button.hasClass('ui-disabled'))
            {
                return;
            }
            const data = button.data();
            const url = skyward.global.virtualDir + "OnlineForm/" + data.url;
            skyward.htmlGatherer.getValues(container).catch((crossDomainException) => { }).then(values =>
            {
                const postData = { printValues: skyward.extensions.encodeHtml(JSON.stringify(values)) };
                $.extend(postData, data, { url: null });
                skyward.printScreen.launchWorkflow(url, postData);
            });
        };

        const printHtmlElement = function (button)
        {
            if (button.hasClass("ui-disabled"))
            {
                return;
            }
            const data = button.data();
            data.title = $('title').text();

            const url = skyward.global.virtualDir + 'OnlineForm/Element/' + data.screen + '/' + data.elementid;
            skyward.printScreen.launchWorkflow(url, data);
        };

        const externalLinkRedirect = function ()
        {
            const url = $(this).data().url;

            try
            {
                if (url.toUpperCase().indexOf("HTTP") == 0)
                {
                    window.open(url);
                }
                else
                {
                    window.open("//" + url);
                }
            }
            catch (error)
            {
                skyward.modalLayer.showCriticalDialog("Error", `<span class='boldFont'>Could not navigate to ${url}.</span>\n\n` + "Please try again later. If the error persists contact your school district.");
                console.error(error);
            }
        };

        const setupIFrame = async function (iFrame)
        {
            if (iFrame.data('finished-setup'))
            {
                return;
            }
            iFrame.data('finished-setup', true);

            await waitForIFrameReady(iFrame).catch((crossDomainException) => { });
            await performSetup();

            async function performSetup()
            {
                removeBackgroundImage();
                await setupElements();

                if (iFrame.hasClass('htmlContentElement') || iFrame.hasClass('onlineFormsHtmlViewer'))
                {
                    await setupChangeTracking(iFrame);
                    await skyward.onlineform.setupIframeHeight(iFrame, "setup");
                }
            }

            function removeBackgroundImage()
            {
                iFrame.removeClass('loading');
            }

            function setupElements()
            {
                if (!iFrame.hasClass("htmlContentElement"))
                {
                    return Promise.resolve();
                }

                return skyward.iframeListener.setupElements(iFrame).catch((crossDomainException) => { });
            }

            function setupChangeTracking(iFrame)
            {
                return skyward.iframeListener.setupChangeTracking(iFrame, (dirty) =>
                {
                    iFrame.attr('data-dirty', dirty);
                });
            }

            function waitForIFrameReady(iFrame)
            {
                return skyward.iframeListener.ready(iFrame);
            }
        };

        skyward.onlineform.setupIframeHeight = async function (iFrame, reason)
        {
            // try-catch handles any failed attempts of setting the IFrame height. Ex: cross domain issues.
            try
            {
                var scrollParent = iFrame.scrollParent();
                var originalParentOverflowY = scrollParent.is(document)
                    ? undefined
                    : scrollParent.css("overflow-y");

                // can't adjust css of document
                if (!scrollParent.is(document))
                {
                    scrollParent.css('overflow-y', 'scroll');
                }

                await skyward.iframeListener.setDocumentOverflow(iFrame, "hidden");

                //reset the height on the iFrame
                iFrame.height("auto");

                const elementContainer = iFrame.closest(".js-elementContainer");
                const startedVisible = elementContainer.is(":visible");
                if (!startedVisible) //the height calculation below won't work properly on hidden elements, but shown elements otherwise not rendered will still properly compute their height.
                {
                    elementContainer.addClass("elementContainer--technicallyVisibleButNotVisible");
                    elementContainer.show();
                }

                const height = await skyward.iframeListener.getHeight(iFrame);

                elementContainer.removeClass("elementContainer--technicallyVisibleButNotVisible");
                if (!startedVisible)
                {
                    elementContainer.hide();
                }

                iFrame.height(height + skyward.window.scrollbarHeight);

                if (!scrollParent.is(document))
                {
                    scrollParent.css('overflow-y', originalParentOverflowY);
                }

                // force text to reflow without the scrollbar before restoring it - otherwise it may use the old layout, which could wrap earlier and
                // require a scrollbar
                await new Promise(resolve =>
                {
                    requestAnimationFrame(async function ()
                    {
                        await skyward.iframeListener.setDocumentOverflow(iFrame, "");
                        resolve();
                    });
                });

                // iFrame.height("auto") can cause eels to not display correctly when selected if the step it's on is large, this sets the scroll bar back to where it was when the eel opened.
                var scrollBarArea = $('.onlineForm.pseudoContentArea');
                if (scrollBarArea.length)
                {
                    var scrollTopOriginalValue = scrollBarArea[0].scrollTop;
                    scrollBarArea.scrollTop(scrollTopOriginalValue);
                }
            }
            catch (e)
            {
                console.log("Unable to set up IFrame height", e);
            }
        };

        var setupHtmlIFrame = async function (htmlContainer, iFrame)
        {
            var data;

            var htmlSelector = htmlContainer.find('.radioButtonGroup.onlineForm.htmlSelector');
            if (htmlSelector.length)
            {
                var selectedInput = htmlSelector.find('input:checked');

                data = htmlSelector.data();
                data.key = selectedInput.val();

                htmlSelector.find('.htmlSelectorOption input').change(async function ()
                {
                    var input = $(this);

                    data.elementstatusid = null;
                    data.key = input.val();
                    data.hash = input.data().hash;

                    await changeIFrameHtmlSrc(iFrame, data);
                    await skyward.onlineform.setupIframeHeight(iFrame, "changesrc");
                });
            }
            else
            {
                data = iFrame.data();
            }

            await changeIFrameHtmlSrc(iFrame, data);
            await skyward.onlineform.setupIframeHeight(iFrame, "changesrc");
        };

        var setupMergeMarkup = function (mergeMarkupContainer)
        {
            var selectorRadioButtonGroup = mergeMarkupContainer.find('.mergeMarkupSelector');
            if (!selectorRadioButtonGroup.length)
            {
                return;
            }

            var oldValue = skyward.controls.getValue(selectorRadioButtonGroup);

            selectorRadioButtonGroup.on("change", "input", function ()
            {
                var newValue = skyward.controls.getValue(selectorRadioButtonGroup);

                var oldFrame = mergeMarkupContainer.find("iframe[data-version='" + oldValue + "']");
                var newFrame = mergeMarkupContainer.find("iframe[data-version='" + newValue + "']");

                oldFrame.addClass("js-ignoreIFrameContents").hide();
                newFrame.removeClass("js-ignoreIFrameContents").show();
                setupIFrame(newFrame);

                oldValue = newValue;
            });
        };

        var setupEmbeddedLink = function (iFrame)
        {
            iFrame.closest('.onlineForm.stepStatusContent.details').addClass('outerIFrameContainer');
        };

        var changeIFrameHtmlSrc = function (iFrame, data)
        {
            const { id, hash, action } = data.elementstatusid
                ? { id: data.elementstatusid, hash: data.elementstatushash, action: data.elementstatusaction }
                : { id: data.elementid, hash: data.elementhash, action: data.elementaction }

            var newSrc = `${skyward.global.virtualDir}OnlineForm/Element/${action}/${id}?key=${data.key}&hash=${hash}`;

            const promise = new Promise((resolve, reject) =>
            {
                iFrame.one("load", resolve);
                iFrame.one("error", reject);

                iFrame.attr("src", newSrc);
            });
            iFrame.data("loadPromise", promise);
            return promise;
        };

        skyward.onlineform.raceEthnicityGetValue = function (raceEthnicity)
        {
            raceEthnicity = raceEthnicity instanceof $ ? raceEthnicity : $(raceEthnicity);
            return raceEthnicity.find('.raceEthnicityVerificationHiddenValue').val();
        };

        skyward.onlineform.nseChangeBirthDate = function (onlineFormStatusID, onlineFormID, entityID, nameID)
        {
            const warningDescription = "Changing the birth date will recalculate the student's grade, causing the form to reset.";

            showNSERestartOnlineFormStatusWarning(onlineFormStatusID, onlineFormID, entityID, nameID, "change the birth date", warningDescription);
        };

        skyward.onlineform.nseChangeGrade = function (onlineFormStatusID, onlineFormID, entityID, nameID)
        {
            const warningDescription = "Changing the Grade will cause the form to reset.";

            showNSERestartOnlineFormStatusWarning(onlineFormStatusID, onlineFormID, entityID, nameID, "change the Grade", warningDescription);
        };

        const showNSERestartOnlineFormStatusWarning = function (onlineFormStatusID, onlineFormID, entityID, nameID, warningAction, warningDescription)
        {
            const redirectToNSERestartOnlineFormStatus = function ()
            {
                const dataParams = {
                    EntityID: entityID,
                    NameID: nameID,
                    OnlineFormID: onlineFormID
                };

                skyward.window.loadContent("full", "OnlineForm", "OnlineFormStatus", "NSERestartOnlineFormStatus", onlineFormStatusID, dataParams);
            };

            const fullWarningDescription = `${warningDescription}\n\nYour progress will be lost, and then the form will restart.`;

            skyward.modalLayer.showWarningDialog(warningAction, fullWarningDescription, { onConfirm: redirectToNSERestartOnlineFormStatus });
        };

        skyward.onlineform.redirectToPreviewCreate = function (event, buttonData, previewCreateActionPrefix)
        {
            const currentEvent = $(event.currentTarget);
            const onlineFormID = currentEvent.data("online-form-id");
            const stepID = currentEvent.data("step-id");

            let workflowContent = $(".workflowContent");
            var promise = $.ajax(skyward.global.virtualDir + "workflow/TaskInstance/commit",
                {
                    type: "POST",
                    dataType: "json",
                    data: skyward.workflow.getScreenValues(workflowContent.eq(0), null),
                    activityIndicator: { isWorkflowAjaxRequest: true }
                });

            promise.then(function (data)
            {
                if (data.workflowStatus === "F")
                {
                    // Invalid
                    var baseWarningError = $(".workflow").find("#baseWorkflowErrorContainer");
                    skyward.validation.displayValidationMessages(data, workflowContent, baseWarningError);
                }
                else
                {
                    buttonData["IsFromStartPreviewWorkflow"] = true;
                    buttonData["StepID"] = stepID;

                    skyward.window.loadContent("popout", "OnlineForm", "OnlineForm", `${previewCreateActionPrefix}PreviewCreate`, onlineFormID, buttonData, null, null, null, "false", null, null, null, null, null, null);
                    skyward.workflow.closeWorkflowPopup();
                }
            });
        };

        skyward.onlineform.redirectToNewStudentEnrollmentPreviewCreate = function (event)
        {
            let buttonData = {
                "BirthDate": $('.js-nsePopupBirthDateAgeTextBox')?.val(),
                "GradeReferenceID": skyward.controls.getValue($('.js-nsePopupGradeReferenceComboBox')),
                "NameID": $(event.currentTarget).data("online-form-name-id"),
                "OnlineFormEntityID": skyward.controls.getValue($('.js-nsePopupOnlineFormEntityCodeEEL'))
            };

            skyward.onlineform.redirectToPreviewCreate(event, buttonData, "NewStudentEnrollment");
        };

        var redirectToNonNewStudentEnrollmentPreviewCreate = function (event, buttonData, previewCreateActionPrefix)
        {
            buttonData["OnlineFormEntityID"] = $(event.currentTarget).data("online-form-entity-id");

            skyward.onlineform.redirectToPreviewCreate(event, buttonData, previewCreateActionPrefix);
        };

        skyward.onlineform.redirectToEmployeePreviewCreate = function (event)
        {
            redirectToNonNewStudentEnrollmentPreviewCreate(event, { "EmployeeID": skyward.controls.getValue($("#EmployeeID_value")) }, "Employee");
        };

        skyward.onlineform.redirectToFamilyPreviewCreate = function (event)
        {
            redirectToNonNewStudentEnrollmentPreviewCreate(event, { "StudentID": skyward.controls.getValue($("#StudentID_value")), "StudentFamilyID": skyward.controls.getValue($("#StudentFamilyID_value")) }, "Family");
        };

        skyward.onlineform.redirectToStudentPreviewCreate = function (event)
        {
            redirectToNonNewStudentEnrollmentPreviewCreate(event, { "StudentID": skyward.controls.getValue($("#StudentID_value")) }, "Student");
        };

        skyward.onlineform.redirectToTeacherPreviewCreate = function (event)
        {
            let buttonData =
            {
                "DisplayPeriodID": skyward.controls.getValue($('#OnlineFormStatusDisplayPeriodID_value')),
                "SectionID": skyward.controls.getValue($('#OnlineFormStatusSectionID_value')),
                "StaffID": skyward.controls.getValue($("#StaffID_value"))
            };

            redirectToNonNewStudentEnrollmentPreviewCreate(event, buttonData, "Teacher");
        };

        skyward.onlineform.redirectToUserPreviewCreate = function (event)
        {
            redirectToNonNewStudentEnrollmentPreviewCreate(event, { "UserID": skyward.controls.getValue($("#UserID_value")) }, "User");
        };

        const allowLanguageUpdateCheckboxChange = function ()
        {
            const allowLanguageUpdateCheckbox = $(this);

            if (skyward.controls.getValue(allowLanguageUpdateCheckbox))
            {
                const onlineFormElement = closestOnlineFormElement(allowLanguageUpdateCheckbox);

                if (onlineFormElementIsApprovalNeeded(onlineFormElement))
                {
                    setCodeListRequiredCheckboxValue(onlineFormElement, true);
                }
            }
        };

        const approvalOptionRadioButtonGroupChange = function ()
        {
            const radioButtonGroup = $(this);
            const onlineFormElement = closestOnlineFormElement(radioButtonGroup);

            if (skyward.controls.getValue(onlineFormElement.find(".js-elementTypeComboBox")) === "K")
            {
                const isApprovalNeeded = skyward.controls.getValue(radioButtonGroup) === "APPROVAL";

                skyward.controls.toggleVisible(onlineFormElement.find(".js-codeListRequiredFieldSet"), isApprovalNeeded);

                const requiredElementCheckbox = findCodeListRequiredCheckbox(onlineFormElement);

                if (isApprovalNeeded)
                {
                    let enableRequiredElementCheckbox = true;

                    if (onlineFormElementCodeListIsLanguage(onlineFormElement) && onlineFormElementAllowLanguageUpdate(onlineFormElement))
                    {
                        skyward.controls.setValue(requiredElementCheckbox, true);

                        enableRequiredElementCheckbox = false;
                    }

                    skyward.controls.toggle(requiredElementCheckbox, enableRequiredElementCheckbox);
                }
                else
                {
                    skyward.controls.setValue(requiredElementCheckbox, false);
                }
            }
        };

        const approvalNeededRadioButtonChange = function (event)
        {
            if ($(event.target).prop("checked"))
            {
                const approvalNeededRadioButton = $(this);
                const onlineFormElement = closestOnlineFormElement(approvalNeededRadioButton);

                if (fieldGroupTypeRequiresApprovalOnChange(onlineFormElement.find(".js-fieldGroupTypeComboBox")))
                {
                    showRequireApprovalOnChange(onlineFormElement);
                }
            }
        };

        const elementTypeComboBoxChange = function (_event)
        {
            const elementTypeComboBox = $(this);

            if (skyward.controls.getValue(elementTypeComboBox) === "K")
            {
                const onlineFormElement = closestOnlineFormElement(elementTypeComboBox);
                let isRequired = onlineFormElementCodeListIsLanguage(onlineFormElement) && onlineFormElementIsApprovalNeeded(onlineFormElement) && onlineFormElementAllowLanguageUpdate(onlineFormElement);

                setCodeListRequiredCheckboxValue(onlineFormElement, isRequired);
            }
        }

        const fieldGroupTypeComboBoxChange = function (_event)
        {
            const fieldGroupTypeComboBox = $(this);

            if (fieldGroupTypeRequiresApprovalOnChange(fieldGroupTypeComboBox) && elementIsApprovalNeeded(fieldGroupTypeComboBox))
            {
                showRequireApprovalOnChange(closestOnlineFormElement(fieldGroupTypeComboBox));
            }
        };

        const updateAllowMultipleFormsPerUserVisibility = function (selectorElement)
        {
            const isNewStudentEnrollmentPortal = skyward.controls.getValue(selectorElement.find(".js-portalTypeComboBox")) === "NewStudentEnrollment";
            const isLimitedToOnePerYear = skyward.controls.getValue(selectorElement.find(".js-limitUsersToOneFormOfThisTypePerYearCheckbox"));
            const isIncludedInProcessManager = skyward.controls.getValue(selectorElement.find(".js-includeInProcessManager"));

            skyward.controls.toggleVisible(selectorElement.find(".js-allowMultipleFormsPerUserContainer"), !isNewStudentEnrollmentPortal && !isLimitedToOnePerYear && !isIncludedInProcessManager);
        };

        const fieldGroupTypeRequiresApprovalOnChange = function (fieldGroupComboBox)
        {
            return fieldGroupComboBox.find("option:selected").hasClass("js-requireApprovalOnChangeFieldGroupType");
        };

        const elementIsApprovalNeeded = function (viewPart)
        {
            return skyward.controls.getValue(closestOnlineFormElement(viewPart).find(".js-approvalOptionRadioButtonGroup")) === "APPROVAL";
        };

        const showRequireApprovalOnChange = function (onlineFormElement)
        {
            skyward.controls.toggleVisible(onlineFormElement.find(".js-fsRequireApprovalOnChange"), true);
        }

        const onlineFormElementAllowLanguageUpdate = function (onlineFormElement)
        {
            const allowLanguageUpdateCheckbox = onlineFormElement.find(".js-allowLanguageUpdateCheckbox");

            return !allowLanguageUpdateCheckbox.length || skyward.controls.getValue(allowLanguageUpdateCheckbox);
        };

        const onlineFormElementCodeListIsLanguage = function (onlineFormElement)
        {
            return skyward.controls.getValue(onlineFormElement.find(".js-codeListTypeComboBox")) === "Student.Student.NativeLanguage";
        };

        const onlineFormElementIsApprovalNeeded = function (onlineFormElement)
        {
            return skyward.controls.getValue(onlineFormElement.find(".js-approvalOptionRadioButtonGroup")) === "APPROVAL";
        };

        const findCodeListRequiredCheckbox = function (onlineFormElement)
        {
            return onlineFormElement.find(".js-codeListRequiredCheckbox");
        };

        const setCodeListRequiredCheckboxValue = function (onlineFormElement, value)
        {
            skyward.controls.setValue(findCodeListRequiredCheckbox(onlineFormElement), value);
        };

        const closestOnlineFormElement = function (viewPart)
        {
            return viewPart.closest('.onlineformelement');
        };

        var sendContactMessage = function (modal, buttonData)
        {
            buttonData.contactEmail = modal.content.findPrefixed('#ContactDistrictEmailText').val();
            buttonData.contactMessage = modal.content.findPrefixed('#ContactDistrictMessageText').val();
            return $.ajax({
                url: skyward.global.virtualDir + buttonData.action,
                data: buttonData,
                success: function (data)
                {
                    if (data.success)
                    {
                        modal.close();
                        skyward.modalLayer.showDialog("Message Sent", "Thank you, your message has been sent.", [{ text: 'Done', icon: 'Check', click: 'close' }]);

                    }
                    else
                    {
                        var baseErrorContainer = modal.content.find('#CurrentRecordContentBaseError');
                        skyward.validation.displayValidationMessages(data, modal.container, baseErrorContainer);
                    }
                }
            });
        };

        var showContact = function ()
        {
            var buttonData = $(this).data();

            var sendButton = { text: "Send", click: function () { sendContactMessage(modal, buttonData); }, icon: "Email" };
            var closeButton = { text: "Close", click: function () { modal.close(); }, icon: "Close" };
            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + buttonData.popupaction,
                    type: "POST",
                    dataType: "viewparthtml"
                });
            };

            var modal = skyward.modalLayer.showDialog("Contact District", buildPopup, [sendButton, closeButton]);
        };

        var showTeacherOnlineForms = function ()
        {
            if ($(event.target).hasClass("tileBrowseIgnoreTileClick"))
            {
                return;
            }
            var tileContainer = $(this);

            var data = tileContainer.data();
            var selectedTileClass = "selectedOnlineFormTile";
            var browseName = tileContainer.closest(".browse").attr("id");

            tileContainer.siblings().removeClass(selectedTileClass);
            tileContainer.addClass(selectedTileClass);
            skyward.browse.setCurrentBrowseName(browseName);
            var detailsPanelOptions =
            {
                panelWidth: data.panelwidth,
                useCloseButton: true,
                additionalData:
                {
                    opener: tileContainer
                }
            };
            skyward.detailsPanel.openDetailsPanel(data.module, data.object, data.screen, data.primarykey, data, detailsPanelOptions);
        };

        const buildOnlineFormStatusLegendPopup = function ()
        {
            const buildPopup = function ()
            {
                return $.ajax({
                    url: `${skyward.global.virtualDir}OnlineForm/OnlineFormStatus/BuildLegendPopup`,
                    type: "POST",
                    dataType: "viewparthtml"
                });
            };

            const options =
            {
                anchorTo: $(this)
            };

            skyward.modalLayer.showDialog("Legend", buildPopup, { text: "Close", icon: "Close" }, options);
        };

        const buildSurveyPreviewPopup = function ()
        {
            const buildPopup = function (onlineFormSurveyID)
            {
                return $.ajax({
                    url: `${skyward.global.virtualDir}OnlineForm/OnlineFormSurvey/StartPreview`,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        OnlineFormSurveyID: onlineFormSurveyID
                    }
                });
            };
            const onlineFormSurveyID = $(this).data("onlineformsurveyid");
            skyward.modalLayer.showDialog("Survey Preview", buildPopup(onlineFormSurveyID), { text: "Close", icon: "Close" });
        };

        const setStepFilterModifiedNotification = function (selectorElement, panelClass, filterValueClass)
        {
            const panel = selectorElement.find(panelClass);

            if (panel.length)
            {
                panel.on("change dirty", filterValueClass, null, skyward.promptsview.setModifiedNotification);
                panel.each(skyward.promptsview.setModifiedNotification);
            }
        };

        function getNameOrId(element)
        {
            return element.attr("name") || element.getIdAndPrefix().id || "";
        }

        const events =
        {
            'redirectToExternalLink': externalLinkRedirect,
            'contactUs': showContact,
            'showteacheronlineforms': showTeacherOnlineForms,
            printStepStatus,
            buildOnlineFormStatusLegendPopup,
            buildSurveyPreviewPopup
        };

        skyward.events.registerEvents('onlineform', events);

        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.staarfieldoverride = skyward.staarfieldoverride || {};
        
        var init = function (selector)
        {
            "use strict";
            var staarFieldOverrideWorkflowSelector, staarFieldOverrideDetailsSelector, recordTypeComboBox, eocTestVersion,
                workflowPrefix, eocPaperMultiselect, eocOnlineMultiselect, testSubjectEel, testVersionCombobox, starrSubmissionEel;

            staarFieldOverrideWorkflowSelector = $(selector).filter(".workflowContent");
            staarFieldOverrideDetailsSelector = $(selector).find("#editSTAARFieldOverrideTX");

            if (staarFieldOverrideWorkflowSelector.length > 0)
            {
                workflowPrefix = "STAARFieldOverrideTX.";
            }
            else if (staarFieldOverrideDetailsSelector.length > 0)
            {
                workflowPrefix = "";
            }
            else
            {
                return;
            }

            recordTypeComboBox = $('select[name="' + workflowPrefix + 'RecordTypeCode"]');
            skyward.staarfieldoverride.updateUIForRecordType(recordTypeComboBox, workflowPrefix);

            recordTypeComboBox.change(function ()
            {
                skyward.staarfieldoverride.updateUIForRecordType(recordTypeComboBox, workflowPrefix);
            });

            eocPaperMultiselect = $(".EndOfCourseCodesMultiSelectPaper");
            eocOnlineMultiselect = $(".EndOfCourseCodesMultiSelectOnline");
            eocTestVersion = $(".EndOfCourseCodesMultiSelectTestVersionEOC");

            if (eocPaperMultiselect && eocOnlineMultiselect)
            {
                eocPaperMultiselect.change(function ()
                {
                    skyward.staarfieldoverride.checkForDuplicateMultiselectItem(eocPaperMultiselect, eocOnlineMultiselect, true);
                });
                eocOnlineMultiselect.change(function ()
                {
                    skyward.staarfieldoverride.checkForDuplicateMultiselectItem(eocPaperMultiselect, eocOnlineMultiselect, false);
                });
            }

            testSubjectEel = $('input[name="' + workflowPrefix + 'StateSTAARTestSubjectTypeTXID"]');
            
            starrSubmissionEel = $('input[name="' + workflowPrefix + 'StateSTAARSubmissionTXID"]');
            starrSubmissionEel.change(function ()
            {
                skyward.staarfieldoverride.removeAllMultiselectItems(eocPaperMultiselect);
                skyward.staarfieldoverride.removeAllMultiselectItems(eocOnlineMultiselect);
                skyward.staarfieldoverride.removeAllMultiselectItems(eocTestVersion);
            });
        };
        
        skyward.staarfieldoverride.updateUIForRecordType = function (recordTypeComboBox, workflowPrefix)
        {
            var recordType, eocPaperMultiselect, eocOnlineMultiselect, eocTestVersion;

            recordType = recordTypeComboBox.find('option:selected').val();

            if (!recordType)
            {
                return;
            }

            if (workflowPrefix)
            {
                eocPaperMultiselect = $(".EndOfCourseCodesMultiSelectPaper");
                eocOnlineMultiselect = $(".EndOfCourseCodesMultiSelectOnline");
                eocTestVersion = $(".EndOfCourseCodesMultiSelectTestVersionEOC");
            }

            removeEOCCodeSelectionSection();

            function removeEOCCodeSelectionSection()
            {
                if (eocPaperMultiselect)
                {
                    skyward.staarfieldoverride.removeAllMultiselectItems(eocPaperMultiselect);
                }

                if (eocOnlineMultiselect)
                {
                    skyward.staarfieldoverride.removeAllMultiselectItems(eocOnlineMultiselect);
                }

                if (eocTestVersion)
                {
                    skyward.staarfieldoverride.removeAllMultiselectItems(eocOnlineMultiselect);
                }
            }
        };

        skyward.staarfieldoverride.checkForDuplicateMultiselectItem = function (eocPaperMultiselect, eocOnlineMultiselect, hasPaperChanged)
        {
            var paperNodes, onlineNodes;
            paperNodes = eocPaperMultiselect.find(".selectedItems ").find(".selectedItem ").prevAll(':not(.dummyTile)');
            onlineNodes = eocOnlineMultiselect.find(".selectedItems ").find(".selectedItem ").prevAll(':not(.dummyTile)');

            for (var i = 0; i < paperNodes.length; i++)
            {
                for (var j = 0; j < onlineNodes.length; j++)
                {
                    if ($(paperNodes[i]).attr("data-targetid") == $(onlineNodes[j]).attr("data-targetid"))
                    {
                        if (hasPaperChanged)
                        {
                            $(onlineNodes[j]).find(".selectedItem__removeIcon").click();
                            return;
                        }
                        else
                        {
                            $(paperNodes[i]).find(".selectedItem__removeIcon").click();
                            return;
                        }
                    }
                }
            }
        };

        skyward.staarfieldoverride.removeAllMultiselectItems = function (multiselectElement)
        {
            var selectNodes = multiselectElement.find(".selectedItems ").find(".selectedItem ").prevAll(':not(.dummyTile)');
            for (var i = 0; i < selectNodes.length; i++)
            {
                $(selectNodes[i]).find("selectedItem__removeIcon").click();
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.courserequest = skyward.courserequest || {};

        var availableCoursesContains = '#AvailableCoursesContains';
        var maximumCredits = '.js-onlineRequestsMaximumCredits';
        var maximumAlternateCredits = '.js-onlineRequestsMaximumAlternateCredits';
        var maximumCourseRequests = '.js-onlineRequestsMaximumCourseRequests';
        var maximumAlternateCourseRequests = '.js-onlineRequestsMaximumAlternateCourseRequests';
        var totalEarnedCredits = '.js-onlineRequestsTotalEarnedCredits';
        var totalAlternateEarnedCredits = '.js-onlineRequestsTotalAlternateEarnedCredits';
        var totalRequests = '.js-onlineRequestsTotalRequests';
        var totalAlternateRequests = '.js-onlineRequestsTotalAlternateRequests';

        var availableCoursesBrowseName = 'AvailabilityListCourses';
        var selectedCoursesBrowseName = 'StudentCourseRequestsSelected';
        var alternateCourseBrowseName = 'AlternateStudentCourseRequestsSelected';
        var courseRequestContentAreaName = 'CourseRequestContentArea';
        var alternateReorderName = "AlternateReorder";

        var courseIDName = "CourseID";
        var courseCodeName = "CourseCode";
        var courseDescriptionName = "Description";
        var courseCodeDescriptionName = "CodeDescription";
        var studentCourseRequestIDName = "StudentCourseRequestID";
        var requestSourceCodeName = "RequestSourceCode";
        var requestStatusCodeName = "RequestStatusCode";
        var rankName = "AlternateRank";

        var isAlternateTabName = "Alternates";

        var linkedAlternatesName = "LinkedAlternates";
        var initialLinkedAlternatesName = "InitialLinkedAlternates";
        var linkedAlternatesUpdatedName = "LinkedAlternatesUpdated";

        //static should not change once it is set
        var accessMode;
        var entityID;
        var schoolYearID;
        var studentID;
        var entityID_securityhash;
        var schoolYearID_securityhash;
        var studentID_securityhash;
        var availabilityFilterCourseStudentID;
        var availabilityFilterCourseStudentID_securityhash;
        var initialAlternateStudentCourseRequestRank = "";
        var useCourseRequestCountMaximum;
        var useCreditsMaximum;

        //course request lists
        var alternateStudentCourseRequestIDsToRemove = "";
        var alternateStudentCourseRequestIDsToRemoveSecurityHash = "";
        var alternateCourseIDsToAdd = "";
        var alternateCourseIDsToAddSecurityHash = "";
        var alternatesRank = "";

        var studentCourseRequestIDsToRemove = "";
        var studentCourseRequestIDsToRemoveSecurityHash = "";
        var courseIDsToAdd = "";
        var courseIDsToAddSecurityHash = "";

        var isAlternateMode = false;
        var requestContentMessageArea;
        var myRequestsPopupRequestContentMessageArea;
        var submitButton;
        var cancelButton;
        var reorderButton;
        var availableCoursesElement;
        var selectedCoursesElement;
        var alternateCourseElement;

        var previousContainsString = '';

        var reorderElement;
        var reorderColumnWidths = [40, 150, 85, 150]; //as specified in StudentCourseRequestController.GetSortable(), but with Code and
        //Description swapped to match the order they appear in Online Requests browses, plus Alternate For (linked course)

        var init = function (selector)
        {
            if (selector == "#" + selectedCoursesBrowseName)
            {
                selectedCoursesElement = $(selector);
                skyward.courserequest.initializeOnlineCourseRequest();
            }

            if (selector == "#" + availableCoursesBrowseName)
            {
                availableCoursesElement = $(selector);
                skyward.courserequest.initializeOnlineCourseRequest();
            }

            if (selector == "#" + alternateCourseBrowseName)
            {
                alternateCourseElement = $(selector);
                skyward.courserequest.initializeOnlineCourseRequest();
            }

            if (selector == "#" + alternateReorderName)
            {
                reorderElement = $(selector);
            }
        };

        var browseInitialLoad = true;
        var browseRowChanged = function (browse)
        {
            if (!browse || !browse.body || !browse.body.find)
            {
                return;
            }
            browse.body.find(".browseRow.current .button").focus();
        };

        //initialization functions
        var initBrowseSearchControls = function ()
        {
            $("#SearchDiv").find('.courseRequestBrowseSearch').each(function ()
            {
                var browseSearch = $(this);
                var browseSearchBox = browseSearch.children('.courseRequestSearchTextbox');

                browseSearchBox.focus(function ()
                {
                    browseSearch.addClass('simulateFocus');
                });

                browseSearch.focusout(function ()
                {
                    browseSearch.removeClass('simulateFocus');
                });
            });
        };

        var initTabButtonHandlers = function ()
        {
            $("#RequestedCourseWrapper").on("tabClicked", ".js-tabbedContainerButton", tabClickHandler);
        };

        var generateCourseFilter = function ()
        {
            skyward.courserequest.generateCourseFilter();
        };

        var mainSelectedBrowseUpdated = function ()
        {
            var mainSelectedBrowseClassName = "mainSelectedBrowse";
            if (alternateCourseElement)
            {
                alternateCourseElement.addClass(mainSelectedBrowseClassName);
            }

            if (selectedCoursesElement)
            {
                selectedCoursesElement.addClass(mainSelectedBrowseClassName);
            }

            if (availableCoursesElement)
            {
                availableCoursesElement.addClass(mainSelectedBrowseClassName);
            }
        };

        var initializationComplete = false;
        skyward.courserequest.initializeOnlineCourseRequest = function ()
        {
            if (initializationComplete)
            {
                return;
            }

            initializationComplete = true;
            initializeMode();

            skyward.browse.eventCallbacks.updateActiveBrowseClasses.registerCallback(mainSelectedBrowseUpdated);

            var body = $("body");
            body.off("browseLoaded." + selectedCoursesBrowseName).on("browseLoaded." + selectedCoursesBrowseName, function ()
            {
                mainSelectedBrowseUpdated();
            });
            body.off("browseLoaded." + availableCoursesBrowseName).on("browseLoaded." + availableCoursesBrowseName, function ()
            {
                mainSelectedBrowseUpdated();
            });
            body.off("browseLoaded." + alternateCourseBrowseName).on("browseLoaded." + alternateCourseBrowseName, function ()
            {
                mainSelectedBrowseUpdated();
            });

            submitButton = $('.js-onlineRequestsSubmit,.js-onlineRequestsSubmitAndReview');
            cancelButton = $('.js-onlineRequestsCancel');

            $("#" + selectedCoursesBrowseName).off("rowChanged").on("rowChanged", function (event, browse)
            {
                browseRowChanged(browse);
            });

            $("#" + availableCoursesBrowseName).off("rowChanged").on("rowChanged", function (event, browse)
            {
                browseRowChanged(browse);
            });

            $("#" + alternateCourseBrowseName).off("rowChanged").on("rowChanged", function (event, browse)
            {
                browseRowChanged(browse);
            });

            skyward.courserequest.setStaticVariables();
            initBrowseSearchControls();
            initTabButtonHandlers();
            requestContentMessageArea = skyward.courserequest.getContentMessageArea($(".js-courserequestcontentmessageareawrapper"));
            myRequestsPopupRequestContentMessageArea = skyward.courserequest.getContentMessageArea($(".js-myrequestspopupcourserequestcontentmessageareawrapper").parent());

            skyward.courserequest.hookupButtonEvents();
            showHideToolBarButtons();
            refreshSelectedBrowseTotals();
            $('.courseRequestSearchTextbox').keydown(skyward.debounce(generateCourseFilter, 600));
            if (!skyward.global.mobileAccess)
            {
                searchFocusAndSelectText();
            }
        };

        var searchFocusAndSelectText = function ()
        {
            $(availableCoursesContains).focus().select();
        };

        var initializeMode = function ()
        {
            reorderButton = $('#ReorderAlternates');
            isAlternateMode = $(".tabbedContent__tabButton-current:contains('" + isAlternateTabName + "')").length > 0;
        };

        skyward.courserequest.hookupButtonEvents = function ()
        {
            $("body").off('click', skyward.courserequest.submitCourseRequest).on('click', ".js-onlineRequestsSubmit", null, skyward.courserequest.submitCourseRequest);
            cancelButton.off('click', skyward.courserequest.cancel).on('click', skyward.courserequest.cancel);
            reorderButton.off('click', skyward.courserequest.reorder).on('click', skyward.courserequest.reorder);
            $("body").off("click", requestCourseRowButtonClick).on("click", ".js-requestCourseAddButton", null, requestCourseRowButtonClick);
            $("body").off("click", removeRequestedCourseRowButtonClick).on("click", ".js-requestCourseRemoveButton", null, removeRequestedCourseRowButtonClick);
            $("body").off("click", showPrimaryAlternatePopupButtonClick).on("click", ".js-requestCoursePrimaryAlternatePopup", null, showPrimaryAlternatePopupButtonClick);
            $("body").off("click", showAlternateInfoPopupButtonClick).on("click", ".js-requestCourseAlternateInfoButton", null, showAlternateInfoPopupButtonClick);
            $("#" + courseRequestContentAreaName).off("click", showMyRequestsButtonClick).on("click", ".js-onlineRequestsViewMyRequests", null, showMyRequestsButtonClick);
            $("#" + courseRequestContentAreaName).off("click", submitAndReviewButtonClick).on("click", ".js-onlineRequestsSubmitAndReview", null, submitAndReviewButtonClick);

            // Attach onchange event to CourseAlt EEL elements
            initCourseAltEELChangeHandlers();
        };

        skyward.courserequest.setStaticVariables = function ()
        {
            var courseRequestContainer = $("#" + courseRequestContentAreaName);
            entityID = courseRequestContainer.data('entityid');
            studentID = courseRequestContainer.data('studentid');
            schoolYearID = courseRequestContainer.data('schoolyearid');
            accessMode = courseRequestContainer.data('accessmode');
            entityID_securityhash = courseRequestContainer.data('entityid_securityhash');
            schoolYearID_securityhash = courseRequestContainer.data('schoolyearid_securityhash');
            studentID_securityhash = courseRequestContainer.data('studentid_securityhash');
            availabilityFilterCourseStudentID = courseRequestContainer.data('availabilityfiltercoursestudentid');
            availabilityFilterCourseStudentID_securityhash = courseRequestContainer.data('availabilityfiltercoursestudentid_securityhash');
            updateInitialAlternateRank(JSON.stringify(courseRequestContainer.data('initial-alternate-rank')));
        };

        //button functions
        var requestCourse = function (courseID, courseIDSecurityHash)
        {
            resetMessages();

            var linkedAlternates = getLinkedAlternates();

            if (isNaN(courseID) || courseID == null)
            {
                skyward.courserequest.showError("Please select an Available Course to Add");
                return;
            }

            var maximumCreditsValue = isAlternateMode ? getRequestOrCreditsValue(maximumAlternateCredits) : getRequestOrCreditsValue(maximumCredits);
            var maximumRequestsValue = isAlternateMode ? getRequestOrCreditsValue(maximumAlternateCourseRequests) : getRequestOrCreditsValue(maximumCourseRequests);

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/RequestCourse" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    CourseID: courseID,
                    CourseID_SecurityHash: courseIDSecurityHash,
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove,
                    StudentCourseRequestIDsToRemoveSecurityHash: studentCourseRequestIDsToRemoveSecurityHash,
                    CourseIDsToAdd: courseIDsToAdd,
                    CourseIDsToAddSecurityHash: courseIDsToAddSecurityHash,
                    AlternateStudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove,
                    AlternateStudentCourseRequestIDsToRemoveSecurityHash: alternateStudentCourseRequestIDsToRemoveSecurityHash,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    AlternateCourseIDsToAddSecurityHash: alternateCourseIDsToAddSecurityHash,
                    MaximumCredits: maximumCreditsValue,
                    MaximumCourseRequests: maximumRequestsValue,
                    UseCreditsMaximum: useCreditsMaximum,
                    UseCourseRequestCountMaximum: useCourseRequestCountMaximum,
                    IsAlternateMode: isAlternateMode,
                    AlternatesRank: alternatesRank,
                    LinkedAlternates: linkedAlternates
                },
                success: function (data)
                {
                    postRequestRemoveCourse("RequestCourse", data, courseID, isAlternateMode);
                }
            });
        };

        function getDataFromRow(button)
        {
            const rowId = button.parents("td").data("row");
            const browseName = button.parents(".browse").attr("id");
            const browse = skyward.browse.browseList[browseName];

            if (!browse || rowId === undefined)
            {
                return {};
            }

            const data = 
            {
                CourseID: browse.rowData[rowId]["CourseID"],
                CourseIDSecurityHash: browse.rowData[rowId]["CourseIDSecurityHash"]
            };

            if (browse.rowData[rowId][studentCourseRequestIDName] && browse.rowData[rowId]["StudentCourseRequestIDSecurityHash"])
            {
                const studentCourseRequestID = browse.rowData[rowId][studentCourseRequestIDName];

                if (studentCourseRequestID !== undefined)
                {
                    data.StudentCourseRequestID = studentCourseRequestID;
                    data.StudentCourseRequestIDSecurityHash = browse.rowData[rowId]["StudentCourseRequestIDSecurityHash"];
                }
            }

            setPropertyIfRowDataPresent(requestStatusCodeName, "RequestStatus");
            setPropertyIfRowDataPresent(requestSourceCodeName, "RequestSource");

            setPropertyIfRowDataPresent("CodeDescription", "CodeDescription");
            setPropertyIfRowDataPresent("CourseCode", "CourseCode");
            setPropertyIfRowDataPresent("Description", "Description");
            setPropertyIfRowDataPresent("EarnedCredits", "EarnedCredits");
            setPropertyIfRowDataPresent("Subject.Description", "Subject");
            setPropertyIfRowDataPresent("CourseIDAlternateFor", "CourseIDAlternateFor");
            setPropertyIfRowDataPresent("StudentCourseRequestID", "StudentCourseRequestID");
            setPropertyIfRowDataPresent("IsReadOnly", "IsReadOnly");
            if (browse.rowData[rowId]["IsAlternate"])
            {
                data["IsAlternate"] = (browse.rowData[rowId]["IsAlternate"] || "").toLowerCase() === "true";
            }

            return data;

            function setPropertyIfRowDataPresent(rowDataName, propertyToSet)
            {
                if (browse.rowData[rowId][rowDataName])
                {
                    data[propertyToSet] = browse.rowData[rowId][rowDataName];
                }
            }
        }

        var requestCourseRowButtonClick = function ()
        {
            var button = $(this);
            if (!button)
            {
                return;
            }
            var rowData = getDataFromRow(button);
            requestCourse(rowData.CourseID, rowData.CourseIDSecurityHash);
        };

        var postRequestRemoveCourse = function (action, data, courseID, isAlternateMode)
        {
            if (data.warningmessage != "" && data.warningmessage != null && data.warningmessage != "undefined")
            {
                skyward.courserequest.showWarning(data.warningmessage);
            }

            if (data.errormessage != "" && data.errormessage != null && data.errormessage != "undefined")
            {
                skyward.courserequest.showError(data.errormessage);
                return;
            }

            updateStudentCourseRequestIDsToRemoveList(data);
            updateCourseIDsToAddList(data);

            if (data.totalearnedcredits != "")
            {
                setRequestOrCreditsText(totalEarnedCredits, data.totalearnedcredits);
            }

            if (data.totalrequests != "")
            {
                setRequestOrCreditsText(totalRequests, data.totalrequests);
            }

            if (data.totalalternateearnedcredits != "") {
                setRequestOrCreditsText(totalAlternateEarnedCredits, data.totalalternateearnedcredits);
            }

            if (data.totalalternaterequests != "") {
                setRequestOrCreditsText(totalAlternateRequests, data.totalalternaterequests);
            }

            updateRequestCountsInTabs(data.totalrequests, data.totalalternaterequests);

            const selectedBrowse = skyward.browse.browseList[selectedCoursesBrowseName];
            const selectedBrowseData = selectedBrowse.data;
            // Alternate browse might not be displayed depending on configuration
            const alternateBrowse = skyward.browse.browseList[alternateCourseBrowseName];
            const alternateBrowseData = alternateBrowse
                ? alternateBrowse.data
                : null;

            if (action == "RequestCourse")
            {
                const seekInfo = { seekId: courseID };
                if (isAlternateMode)
                {
                    skyward.browsePreferences.setPreferences(alternateBrowse, seekInfo);
                }
                else
                {
                    skyward.browsePreferences.setPreferences(selectedBrowse, seekInfo);
                }
            }
            else if (data.hasOwnProperty('linkedAlternates'))
            {
                skyward.controls.setValue($('#' + linkedAlternatesName), data.linkedAlternates);
                resetLinkedAlternatesUpdated();
            }

            updateAlternateRank(data.alternatesRank);

            var infoMessageToShow = "";
            if (data.informationmessage != "" && data.informationmessage != null && data.informationmessage != "undefined")
            {
                infoMessageToShow = data.informationmessage;
            }

            var linkedAlternates = getLinkedAlternates();
            var browsePromises = [];

            // These Browses only get passed StudentCourseRequestIDsToRemove and not AlternateStudentCourseRequestIDsToRemove
            // because each browse only shows one type of request.
            if (isAlternateMode) {
                var alternatePromise = skyward.browse.get(alternateCourseBrowseName, alternateBrowseData, {
                    CourseIDsToAdd: courseIDsToAdd, 
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd, 
                    StudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove, 
                    AlternatesRank: alternatesRank,
                    LinkedAlternates: linkedAlternates,
                });
                browsePromises.push(alternatePromise);
            }
            else 
            {
                var mainPromise = skyward.browse.get(selectedCoursesBrowseName, selectedBrowseData, {
                    CourseIDsToAdd: courseIDsToAdd, 
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd, 
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove, 
                    AlternatesRank: alternatesRank,
                    LinkedAlternates: linkedAlternates,
                });

                browsePromises.push(mainPromise);

                if (skyward.browse.browseList[alternateCourseBrowseName]) {
                    // On mobile, both browses display and get refreshed at once.
                    // So alternates browse needs to use the combined list of IDs to remove in Order for the filter on Linked Primary to work
                    var altPromise = skyward.browse.get(alternateCourseBrowseName, alternateBrowseData, {
                        CourseIDsToAdd: courseIDsToAdd, 
                        AlternateCourseIDsToAdd: alternateCourseIDsToAdd, 
                        StudentCourseRequestIDsToRemove: combineStringifiedArrays(studentCourseRequestIDsToRemove, alternateStudentCourseRequestIDsToRemove),
                        AlternatesRank: alternatesRank,
                        LinkedAlternates: linkedAlternates,
                    });
                    browsePromises.push(altPromise);
                }
            }

            $.whenAll(browsePromises).done(function() {
                showHideToolBarButtons();
                
                if (infoMessageToShow !== "") {
                    skyward.courserequest.showInformation(infoMessageToShow);
                }

                if (skyward.global.mobileAccess) {
                    skyward.courserequest.generateCourseFilter(true);
                }
            });
        };

        var removeRequestedCourse = function (courseID, courseIDSecurityHash, requestID, requestIDSecurityHash, requestSource, requestStatus, codeDescription)
        {
            resetMessages();
            var browse = isAlternateMode ? skyward.browse.browseList[alternateCourseBrowseName] : skyward.browse.browseList[selectedCoursesBrowseName];

            if (isNaN(courseID) || courseID == null)
            {
                skyward.courserequest.showError("Please select a Selected Course to Remove");
                return;
            }

            if (IsScheduled(requestStatus))
            {
                skyward.courserequest.showError("The course " + (codeDescription || getSelectedBrowseRowData(browse, courseCodeDescriptionName)) + " has already been scheduled and cannot be removed");
                return;
            }

            if (IsAddedByOffice(requestSource) || IsAddedByImport(requestSource) || IsAddedByMassProcess(requestSource) || IsAddedByRecommendation(requestSource))
            {
                skyward.courserequest.showError("The request for course " + (codeDescription || getSelectedBrowseRowData(browse, courseCodeDescriptionName)) + " was added by the office and cannot be removed");
                return;
            }

            if (isAlternateMode)
            {
                var alternateRank = getSelectedBrowseRowData(browse, rankName);
            }

            var maximumCreditsValue = isAlternateMode ? skyward.controls.getValue($(maximumAlternateCredits)) : skyward.controls.getValue($(maximumCredits));
            var linkedAlternates = getLinkedAlternates();

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/RemoveRequestedCourse" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    CourseID: courseID,
                    CourseID_SecurityHash: courseIDSecurityHash,
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove,
                    StudentCourseRequestIDsToRemoveSecurityHash: studentCourseRequestIDsToRemoveSecurityHash,
                    CourseIDsToAdd: courseIDsToAdd,
                    CourseIDsToAddSecurityHash: courseIDsToAddSecurityHash,
                    AlternateStudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove,
                    AlternateStudentCourseRequestIDsToRemoveSecurityHash: alternateStudentCourseRequestIDsToRemoveSecurityHash,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    AlternateCourseIDsToAddSecurityHash: alternateCourseIDsToAddSecurityHash,
                    StudentCourseRequestID: requestID,
                    StudentCourseRequestID_SecurityHash: requestIDSecurityHash,
                    MaximumCredits: maximumCreditsValue,
                    IsAlternateMode: isAlternateMode,
                    AlternatesRank: alternatesRank,
                    RankToRemove: alternateRank,
                    LinkedAlternates: linkedAlternates
                },
                success: function (data)
                {
                    postRequestRemoveCourse("RemoveRequestedCourse", data, null, isAlternateMode);
                }
            });
        };

        var removeRequestedCourseRowButtonClick = function ()
        {
            var button = $(this);
            if (!button)
            {
                return;
            }
            var rowData = getDataFromRow(button);

            if (skyward.global.mobileAccess)
            {
                isAlternateMode = rowData.IsAlternate || false;
            }

            removeRequestedCourse(rowData.CourseID, rowData.CourseIDSecurityHash, rowData.StudentCourseRequestID,
                rowData.StudentCourseRequestIDSecurityHash, rowData.RequestSource, rowData.RequestStatus, rowData.CodeDescription);
        };

        var showPrimaryAlternatePopup = function (courseID, courseIDSecurityHash, courseCodeDescription, earnedCredits, subject)
        {
            var contents = $(".js-onlineRequestsPrimaryAlternatePopupContents").children().clone(false);

            skyward.controls.setValue(contents.find(".js-onlineRequestsPopupCourseCodeDescription"), courseCodeDescription);
            skyward.controls.setValue(contents.find(".js-onlineRequestsPopupCourseEarnedCredits"), earnedCredits);
            skyward.controls.setValue(contents.find(".js-onlineRequestsPopupSubject"), subject);
            contents.find(".js-onlineRequestsAddPrimary").click(function ()
            {
                isAlternateMode = false;
                requestCourse(courseID, courseIDSecurityHash);
                dialog.close();
            });
            contents.find(".js-onlineRequestsAddAlternate").click(function ()
            {
                isAlternateMode = true;
                requestCourse(courseID, courseIDSecurityHash);
                dialog.close();
            });

            var dialog = skyward.modalLayer.showDialog("Add Course Request", contents, [{ text: "Close", icon: "Close", click: "close" }]);
        };

        var showAlternatePopup = function (courseID, courseIDSecurityHash, studentCourseRequestID, studentCourseRequestIDSecurityHash, courseDescription, courseCode, earnedCredits, subject, courseIDAlternateFor)
        {
            var contents = $(".js-onlineRequestsAlternatePopupContents").children().clone(false);

            skyward.controls.setValue(contents.find(".js-onlineRequestsPopupCourseDescription"), courseDescription);
            skyward.controls.setValue(contents.find(".js-onlineRequestsPopupCourseCode"), courseCode);
            skyward.controls.setValue(contents.find(".js-onlineRequestsPopupCourseEarnedCredits"), earnedCredits);
            skyward.controls.setValue(contents.find(".js-onlineRequestsPopupSubject"), subject);

            var deferredBeforeShowContent = $.Deferred();

            var beforeCloseCallback = function () {
                if (!skyward.browse.browseList[alternateCourseBrowseName])
                {
                    return;
                }

                // on close, refresh the alternate browse to re-render RowData using the updated CoursesToAdd/LinkedAlternates
                var linkedAlternates = getLinkedAlternates();

                skyward.browse.get(
                    alternateCourseBrowseName,
                    skyward.browse.browseList[alternateCourseBrowseName].data,
                    {
                        CourseIDsToAdd: courseIDsToAdd,
                        AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                        StudentCourseRequestIDsToRemove: combineStringifiedArrays(studentCourseRequestIDsToRemove, alternateStudentCourseRequestIDsToRemove),
                        AlternatesRank: alternatesRank,
                        LinkedAlternates: linkedAlternates
                    });
            };

            var dialog = skyward.modalLayer.showDialog("Alternate Course Details", contents, [{ text: "Close", icon: "Close", click: "close" }], {

                beforeClose: beforeCloseCallback,
                beforeShowContentPromise: deferredBeforeShowContent
            });

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/GetAlternateInfoPopupEEL" + accessMode,
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    CourseID: courseID,
                    CourseID_SecurityHash: courseIDSecurityHash,
                    CourseIDAlternateFor: courseIDAlternateFor,
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,
                    StudentCourseRequestID: studentCourseRequestID,
                    StudentCourseRequestID_SecurityHash: studentCourseRequestIDSecurityHash,
                    CourseIDsToAdd: courseIDsToAdd,
                    CourseIDsToAddSecurityHash: courseIDsToAddSecurityHash,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    AlternateCourseIDsToAddSecurityHash: alternateCourseIDsToAddSecurityHash,
                    LinkedAlternates: getLinkedAlternates(),
                },
                success: function (html)
                {
                    var codeEELContainer = dialog.content.find(".js-onlineRequestsAlternatePopupEELContainer");
                    codeEELContainer.html(html);
                    dialog.container.css("height", "85%");
                    dialog.content.css("height", "100%");
                    dialog.content.css("max-height", "92%");
                    initCourseAltEELChangeHandlers();
                    deferredBeforeShowContent.resolve();
                }
            });
        };

        var showPrimaryAlternatePopupButtonClick = function ()
        {
            var button = $(this);
            if (!button)
            {
                return;
            }
            var rowData = getDataFromRow(button);
            return showPrimaryAlternatePopup(rowData.CourseID, rowData.CourseIDSecurityHash, rowData.CodeDescription, rowData.EarnedCredits,
                rowData.Subject);
        };

        var showAlternateInfoPopupButtonClick = function ()
        {
            var button = $(this);
            if (!button)
            {
                return;
            }
            var rowData = getDataFromRow(button);
            return showAlternatePopup(rowData.CourseID, rowData.CourseIDSecurityHash, rowData.StudentCourseRequestID, rowData.StudentCourseRequestIDSecurityHash, rowData.Description, rowData.CourseCode, rowData.EarnedCredits,
                rowData.Subject, rowData.CourseIDAlternateFor);
        };

        var showMyRequestsPopup = function () {
            var hiddenContentContainer = $(".js-myRequestsContent");
            var contents = hiddenContentContainer.children();

            var linkedAlternates = getLinkedAlternates();

            var selectedCoursesPromise = skyward.browse.get(
                selectedCoursesBrowseName,
                skyward.browse.browseList[selectedCoursesBrowseName].data,
                {
                    CourseIDsToAdd: courseIDsToAdd,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove,
                    AlternatesRank: alternatesRank,
                    LinkedAlternates: linkedAlternates
                }
            );

            var alternateCoursesPromise = skyward.browse.get(
                alternateCourseBrowseName,
                skyward.browse.browseList[alternateCourseBrowseName].data,
                {
                    CourseIDsToAdd: courseIDsToAdd,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    StudentCourseRequestIDsToRemove: combineStringifiedArrays(studentCourseRequestIDsToRemove, alternateStudentCourseRequestIDsToRemove),
                    AlternatesRank: alternatesRank,
                    LinkedAlternates: linkedAlternates
                }
            );

            var beforeCloseCallback = function () {
                resetMessages();
                hiddenContentContainer.append(contents); // Move contents back to hidden container
            };

            var deferredBeforeShowContent = $.Deferred();

            $.whenAll([selectedCoursesPromise, alternateCoursesPromise]).then(function () {
                dialog.container.css("height", "95%");
                dialog.content.css("height", "100%");
                dialog.content.css("max-height", "92%");
                deferredBeforeShowContent.resolve();
            });

            var dialog = skyward.modalLayer.showDialog("My Requests", contents, [{ text: "Close", icon: "Close", click: "close" }], {
                beforeClose: beforeCloseCallback,
                beforeShowContentPromise: deferredBeforeShowContent
            });
        };


        var showMyRequestsButtonClick = function ()
        {
            resetMessages();
            showMyRequestsPopup();
        };

        var submitAndReviewButtonClick = function ()
        {
            showMyRequestsButtonClick();
            skyward.courserequest.submitCourseRequest();
        };

        // In skyward.courserequest.submitCourseRequest, ensure LinkedAlternates is sent in the AJAX data
        skyward.courserequest.submitCourseRequest = function ()
        {
            resetMessages();

            var linkedAlternates = getLinkedAlternates();

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/SubmitRequestedCourse" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,
                    StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove,
                    StudentCourseRequestIDsToRemoveSecurityHash: studentCourseRequestIDsToRemoveSecurityHash,
                    CourseIDsToAdd: courseIDsToAdd,
                    CourseIDsToAddSecurityHash: courseIDsToAddSecurityHash,
                    AlternateStudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove,
                    AlternateStudentCourseRequestIDsToRemoveSecurityHash: alternateStudentCourseRequestIDsToRemoveSecurityHash,
                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    AlternateCourseIDsToAddSecurityHash: alternateCourseIDsToAddSecurityHash,
                    AlternatesRank: alternatesRank,
                    LinkedAlternates: linkedAlternates
                },
                success: function (data)
                {
                    if (data.errormessage != "" && data.errormessage != null && data.errormessage != "undefined")
                    {
                        skyward.courserequest.showError(data.errormessage);
                        return;
                    }

                    skyward.courserequest.showConfirmation("The student course request changes have been successfully saved.");

                    updateInitialAlternateRank(data.alternatesRank);
                    clearStudentCourseRequestIDsToRemoveList();
                    clearCourseIDsToAddList();
                    
                    if (data.linkedAlternates) {
                        $('#' + linkedAlternatesName).val(data.linkedAlternates);
                    }
                    setInitialLinkedAlternates(data);
                    resetLinkedAlternatesUpdated();
                    showHideToolBarButtons();

                    skyward.browse.get(selectedCoursesBrowseName, skyward.browse.browseList[selectedCoursesBrowseName].data, { CourseIDsToAdd: courseIDsToAdd, AlternateCourseIDsToAdd: alternateCourseIDsToAdd, StudentCourseRequestIDsToRemove: studentCourseRequestIDsToRemove, AlternatesRank: alternatesRank, LinkedAlternates: linkedAlternates });
                    if (skyward.browse.browseList[alternateCourseBrowseName])
                    {
                        skyward.browse.get(alternateCourseBrowseName, skyward.browse.browseList[alternateCourseBrowseName].data, { CourseIDsToAdd: courseIDsToAdd, AlternateCourseIDsToAdd: alternateCourseIDsToAdd, StudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove, AlternatesRank: alternatesRank, LinkedAlternates: linkedAlternates });
                    }
                    refreshSelectedBrowseTotals();
                }
            });
        };

        skyward.courserequest.cancel = function ()
        {
            resetMessages();
            clearStudentCourseRequestIDsToRemoveList();
            clearCourseIDsToAddList();
            skyward.browse.get(selectedCoursesBrowseName, skyward.browse.browseList[selectedCoursesBrowseName].data);
            if (skyward.browse.browseList[alternateCourseBrowseName])
            {
                skyward.browse.get(alternateCourseBrowseName, skyward.browse.browseList[alternateCourseBrowseName].data);
            }
            refreshSelectedBrowseTotals();
            resetAlternateRange(initialAlternateStudentCourseRequestRank);
            resetLinkedAlternates();
            resetLinkedAlternatesUpdated();
            showHideToolBarButtons();
        };

        skyward.courserequest.reorder = function ()
        {
            var browse = skyward.browse.browseList[alternateCourseBrowseName];
            var table = reorderElement.find(".sortableWrapper table");
            table.empty();

            var arrowColumnWidth = 150;

            if (skyward.global.mobileAccess)
            {
                arrowColumnWidth = 90;
            }

            var tbody = $("<tbody class='ui-sortable' />");

            var tHeader = $("<tr class='sortableHeaderRow'>");
            tHeader.append("<td class='sortableTableColumnHeader' style='width: " + arrowColumnWidth + "px; '></td><td class='sortableTableColumnHeader'><div class='sortableEllipsizingText' style='width: 40px; '>Rank</div></td><td class='sortableTableColumnHeader'><div class='sortableEllipsizingText' style='width: 150px;'>Course Description</div></td><td class='sortableTableColumnHeader'><div class='sortableEllipsizingText' style='width: 85px; '>Course Code</div></td><td class='sortableTableColumnHeader'><div class='sortableEllipsizingText' style='width: 150px;'>Alternate For</div></td></tr>");
            tbody.append(tHeader);

            var arrowButtonsHTML = "<td style='width:" + arrowColumnWidth + "px; height:33px;'>" +
                "<a class='button sortableUp js-sortableUp' preserveAspectRatio='xMidYMid meet' focusable='false' tabindex='-1'>" +
                "<svg class='buttonSvg svg arrowUp svgGroup svgSortable' preserveAspectRatio='xMidYMid meet' focusable='false' tabindex='-1'>" +
                `<use href='#svg-ArrowUp'></use></svg></a>` +
                "<a class='button sortableDown js-sortableDown svgAnchor' alt='Move Down' href='javascript:void(0)' tabindex='0'>" +
                "<svg class='buttonSvg svg arrowDown svgGroup svgSortable' preserveAspectRatio='xMidYMid meet' focusable='false' tabindex='-1'>" +
                `<use href='#svg-ArrowDown'></use></svg></a ></td > `;

            var selectedCourseDescriptionMap = (function ()
            {
                var map = {};
                var selectedBrowse = skyward.browse.browseList[selectedCoursesBrowseName];
                if (selectedBrowse && selectedBrowse.rowData)
                {
                    for (var i = 0; i < selectedBrowse.rowData.length; i++)
                    {
                        var rowData = selectedBrowse.rowData[i];
                        map[String(rowData[courseIDName])] = (rowData[courseDescriptionName] || "").trim();
                    }
                }
                return map;
            }());

            var getCourseDescriptionFromSelectedCourse = function (courseID)
            {
                if (courseID === null || courseID === undefined || courseID === "")
                {
                    return "";
                }
                return selectedCourseDescriptionMap[String(courseID)] || "";
            };

            var linkedAlternates = (function ()
            {
                var raw = getLinkedAlternates();
                if (raw !== null && raw !== undefined && raw !== "" && raw !== "undefined")
                {
                    try
                    {
                        var parsed = JSON.parse(raw);
                        return (parsed && typeof parsed === "object") ? parsed : {};
                    }
                    catch (e)
                    {
                        var details = "Raw LinkedAlternates: " + raw + "\n\n" + (e && (e.stack || e.message) ? (e.stack || e.message) : String(e));
                        skyward.error.reportException(new window.SkywardException("Unable to parse LinkedAlternates JSON.", details));
                    }
                }
                return {};
            }());

            var getMobileAlternateForCourseID = function (alternateRowData)
            {
                if (!alternateRowData)
                {
                    return null;
                }

                var studentCourseRequestID = alternateRowData[studentCourseRequestIDName];
                if (studentCourseRequestID !== null && studentCourseRequestID !== undefined && studentCourseRequestID !== "" &&
                    Object.prototype.hasOwnProperty.call(linkedAlternates, studentCourseRequestID))
                {
                    return linkedAlternates[studentCourseRequestID];
                }

                return alternateRowData.CourseIDAlternateFor;
            };

            // Returns the description text from a .courserequestlinkedprimaryeel element.
            // CodeEEL.cs renders the description input with class "codeEELDescription".
            var getCourseDescriptionFromAlternateForEEL = function (alternateForEEL, alternateRowData)
            {
                if (skyward.global.mobileAccess)
                {
                    var mobileCourseDescription = getCourseDescriptionFromSelectedCourse(getMobileAlternateForCourseID(alternateRowData));
                    if (mobileCourseDescription)
                    {
                        return mobileCourseDescription;
                    }
                }

                if (!alternateForEEL || !alternateForEEL.length)
                {
                    return "";
                }
                var selectedValueDisplayInput = alternateForEEL.find(".codeEELSelectedValueDisplayField").first();
                if (selectedValueDisplayInput && selectedValueDisplayInput.length)
                {
                    var selectedValueDisplay = (selectedValueDisplayInput.val() || "").trim();
                    if (selectedValueDisplay)
                    {
                        return selectedValueDisplay;
                    }
                }
                var descInput = alternateForEEL.find(".codeEELDescription").first();
                if (descInput && descInput.length)
                {
                    return (descInput.val() || "").trim();
                }
                return "";
            };

            var browseContainer = $("#" + alternateCourseBrowseName);
            var allAlternateForEELs = browseContainer.find(".courserequestlinkedprimaryeel");
            var counter = 1;
            for (var idx = 0; idx < browse.rowData.length; idx++)
            {
                var courseID = browse.rowData[idx][courseIDName];
                var studentCourseRequestID = browse.rowData[idx][studentCourseRequestIDName];
                var courseCode = browse.rowData[idx][courseCodeName];
                var description = browse.rowData[idx][courseDescriptionName];
                var rowEvenOdd = (counter) % 2 == 0 ? "even" : "odd";

                var rowID = courseID + "-";
                if (studentCourseRequestID.indexOf("-") == -1)
                {
                    rowID += studentCourseRequestID;
                }

                var row = $("<tr class='sortableRow " + rowEvenOdd + "' data-id='" + rowID + "'/>");

                var alternateForEEL = allAlternateForEELs.eq(idx);
                var alternateForEELCourseDescription = getCourseDescriptionFromAlternateForEEL(alternateForEEL, browse.rowData[idx]);

                row.append($(arrowButtonsHTML));
                row.append($("<td class='sortColumn browseDataCell'><div style='width:" + reorderColumnWidths[0] + "px;' class='sortableEllipsizingText'>" + counter++ + "</div></td>"));
                row.append($("<td class='browseDataCell'><div style='width:" + reorderColumnWidths[1] + "px;' class='sortableEllipsizingText'>" + description + "</div></td>"));
                row.append($("<td class='browseDataCell'><div style='width:" + reorderColumnWidths[2] + "px;' class='sortableEllipsizingText'>" + courseCode + "</div></td>"));
                row.append($("<td class='browseDataCell' />").append($("<div style='width:" + reorderColumnWidths[3] + "px;' class='sortableEllipsizingText' />").text(alternateForEELCourseDescription)));
                tbody.append(row);
            }

            table.append(tbody);

            skyward.sortable.initialize(reorderElement.html(), "Scheduling", "StudentCourseRequest", {}, skyward.courserequest.saveOrder);
        };

        skyward.courserequest.saveOrder = function (messageBox)
        {
            var list = [];
            $sortable = messageBox.content.find(".sortable").first();
            $sortable.find("tbody tr").each(function (index, element)
            {
                var id = $(element).data('id');
                list.push($(element).data('id'));
            });

            messageBox.close();

            if (list.length > 0)
            {
                updateAlternateRank(JSON.stringify(list));
                skyward.browse.get(alternateCourseBrowseName, skyward.browse.browseList[alternateCourseBrowseName].data, { CourseIDsToAdd: courseIDsToAdd, AlternateCourseIDsToAdd: alternateCourseIDsToAdd, StudentCourseRequestIDsToRemove: alternateStudentCourseRequestIDsToRemove, AlternatesRank: alternatesRank, LinkedAlternates: getLinkedAlternates() });
                showHideToolBarButtons();
            }
        };

        var updateAlternateRank = function (ranks)
        {
            resetAlternateRange(ranks);
        };

        var updateInitialAlternateRank = function (newRank)
        {
            initialAlternateStudentCourseRequestRank = newRank;
            resetAlternateRange(initialAlternateStudentCourseRequestRank);
        };

        var resetAlternateRange = function (ranks)
        {
            alternatesRank = ranks;
        };

        var refreshSelectedBrowseTotals = function ()
        {
            displayHighestMaximumCredits();
            updateTotalEarnedCreditsAndCounts();
        };

        var setRequestOrCreditsText = function (selector, valueToSet)
        {
            var control = $(selector);
            if (control.is(":input"))
            {
                skyward.controls.setValue(control, valueToSet);
            }
            else
            {
                control.text(valueToSet);
            }
        };

        var updateRequestCountsInTabs = function (totalRequests, totalAlternateRequests)
        {
            if (totalRequests !== undefined)
            {
                var myRequestsTab = $('.js-onlineRequestsTotalRequests').closest('#RequestedCourseWrapper').find('.js-tabbedContainerButton:contains(My Requests)');
                if (myRequestsTab && myRequestsTab.length)
                {
                    myRequestsTab.text("My Requests (" + totalRequests + ")");
                }
            }

            if (totalAlternateRequests !== undefined)
            {
                var alternatesTab = $('.js-onlineRequestsTotalRequests').closest('#RequestedCourseWrapper').find('.js-tabbedContainerButton:contains(Alternates)');

                if (alternatesTab && alternatesTab.length)
                {
                    alternatesTab.text("Alternates (" + totalAlternateRequests + ")");
                }
            }
        };

        var getRequestOrCreditsValue = function (selector)
        {
            var control = $(selector).eq(0);
            if (control.is(":input"))
            {
                return skyward.controls.getValue(control);
            }
            else
            {
                return control.text();
            }
        }

        var displayHighestMaximumCredits = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/GetHighestMaximumCreditValues" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    StudentID: studentID,
                    EntityID: entityID,
                    SchoolYearID: schoolYearID,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        useCreditsMaximum = data.UseCreditsMaximum;
                        useCourseRequestCountMaximum = data.UseCourseRequestCountMaximum;

                        if (data.UseCreditsMaximum)
                        {
                            if (data.MaximumCredits != "")
                            {
                                setRequestOrCreditsText(maximumCredits, data.MaximumCredits);
                            }
                            if (data.MaximumAlternateCredits != "")
                            {
                                setRequestOrCreditsText(maximumAlternateCredits, data.MaximumAlternateCredits);
                            }
                        }
                        else
                        {
                            $(maximumCredits).parent().hide();
                            $(maximumAlternateCredits).parent().hide();
                        }

                        if (data.UseCourseRequestCountMaximum)
                        {
                            if (data.MaximumCourseRequests != "")
                            {
                                setRequestOrCreditsText(maximumCourseRequests, data.MaximumCourseRequests);
                            }
                            if (data.MaximumAlternateCourseRequests != "")
                            {
                                setRequestOrCreditsText(maximumAlternateCourseRequests, data.MaximumAlternateCourseRequests);
                            }
                        }
                        else
                        {
                            $(maximumCourseRequests).parent().hide();
                            $(maximumAlternateCourseRequests).parent().hide();
                        }
                    }
                }
            });
        };

        var updateTotalEarnedCreditsAndCounts = function ()
        {
            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/GetTotalEarnedCredits" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    StudentID: studentID,
                    EntityID: entityID,
                    SchoolYearID: schoolYearID
                },
                success: function (data)
                {
                    if (data.success)
                    {
                        if (data.TotalEarnedCredits != "")
                        {
                            setRequestOrCreditsText(totalEarnedCredits, data.TotalEarnedCredits);
                        }

                        if (data.TotalAlternateEarnedCredits != "")
                        {
                            setRequestOrCreditsText(totalAlternateEarnedCredits, data.TotalAlternateEarnedCredits);
                        }

                        if (data.TotalRequests != "")
                        {
                            setRequestOrCreditsText(totalRequests, data.TotalRequests);
                        }

                        if (data.TotalAlternateRequests != "")
                        {
                            setRequestOrCreditsText(totalAlternateRequests, data.TotalAlternateRequests);
                        }

                        updateRequestCountsInTabs(data.TotalRequests, data.TotalAlternateRequests);
                    }
                }
            });
        };

        var normalizeAlternateRank = function (rank) {
            if (rank === "" || rank === null || rank === undefined || rank === "undefined" || rank === "[]") {
                return "";
            }
            return rank;
        };

        var showHideToolBarButtons = function ()
        {
            var dirtyClassName = "dirty";
            var changeClassName = "change ";

            if ((courseIDsToAdd != "" && courseIDsToAdd != null && courseIDsToAdd != "undefined") ||
                (studentCourseRequestIDsToRemove != "" && studentCourseRequestIDsToRemove != null && studentCourseRequestIDsToRemove != "undefined") ||
                (alternateCourseIDsToAdd != "" && alternateCourseIDsToAdd != null && alternateCourseIDsToAdd != "undefined") ||
                (alternateStudentCourseRequestIDsToRemove != "" && alternateStudentCourseRequestIDsToRemove != null && alternateStudentCourseRequestIDsToRemove != "undefined") ||
                (alternatesRank != initialAlternateStudentCourseRequestRank && normalizeAlternateRank(alternatesRank) !== normalizeAlternateRank(initialAlternateStudentCourseRequestRank)) ||
                linkedAlternatesChanged())
            {
                updateSubmitButtonDisplay(changeClassName, dirtyClassName);
                updateCancelButtonDisplay(changeClassName, dirtyClassName);
                skyward.changeTracking.overrideGlobalDirtyState(true);
            }
            else
            {
                updateSubmitButtonDisplay(dirtyClassName, changeClassName);
                updateCancelButtonDisplay(dirtyClassName, changeClassName);
                skyward.changeTracking.overrideGlobalDirtyState(false);
            }

            if (!skyward.global.mobileAccess)
            {
                searchFocusAndSelectText();
            }
        };

        var updateSubmitButtonDisplay = function (removeClass, addClass)
        {
            submitButton.removeClass(removeClass);
            submitButton.addClass(addClass);
        };

        var updateCancelButtonDisplay = function (removeClass, addClass)
        {
            cancelButton.removeClass(removeClass);
            cancelButton.addClass(addClass);
        };

        //helper functions
        var clearStudentCourseRequestIDsToRemoveList = function ()
        {
            studentCourseRequestIDsToRemove = "";
            studentCourseRequestIDsToRemoveSecurityHash = "";
            alternateStudentCourseRequestIDsToRemove = "";
            alternateStudentCourseRequestIDsToRemoveSecurityHash = "";
        };

        var clearCourseIDsToAddList = function ()
        {
            courseIDsToAdd = "";
            courseIDsToAddSecurityHash = "";
            alternateCourseIDsToAdd = "";
            alternateCourseIDsToAddSecurityHash = "";
        };

        var updateStudentCourseRequestIDsToRemoveList = function (data)
        {
            var hasStudentCourseRequestIDsToRemove = data.hasOwnProperty("studentCourseRequestIDsToRemove");
            var hasAlternateStudentCourseRequestIDsToRemove = data.hasOwnProperty("alternateStudentCourseRequestIDsToRemove");

            if (!hasStudentCourseRequestIDsToRemove && !hasAlternateStudentCourseRequestIDsToRemove)
            {
                clearStudentCourseRequestIDsToRemoveList();
            }

            if (hasStudentCourseRequestIDsToRemove)
            {
                studentCourseRequestIDsToRemove = data.studentCourseRequestIDsToRemove
                studentCourseRequestIDsToRemoveSecurityHash = data.studentCourseRequestIDsToRemoveSecurityHash;
            }

            if (hasAlternateStudentCourseRequestIDsToRemove)
            {
                alternateStudentCourseRequestIDsToRemove = data.alternateStudentCourseRequestIDsToRemove;
                alternateStudentCourseRequestIDsToRemoveSecurityHash = data.alternateStudentCourseRequestIDsToRemoveSecurityHash;
            }
        };

        var updateCourseIDsToAddList = function (data)
        {
            var hasCourseIDsToAdd = data.hasOwnProperty("courseIDsToAdd");
            var hasAlternateCourseIDsToAdd = data.hasOwnProperty("alternateCourseIDsToAdd");

            if (!hasCourseIDsToAdd && !hasAlternateCourseIDsToAdd)
            {
                clearCourseIDsToAddList();
            }

            if (hasCourseIDsToAdd)
            {
                courseIDsToAdd = data.courseIDsToAdd
                courseIDsToAddSecurityHash = data.courseIDsToAddSecurityHash;
            }

            if (hasAlternateCourseIDsToAdd)
            {
                alternateCourseIDsToAdd = data.alternateCourseIDsToAdd;
                alternateCourseIDsToAddSecurityHash = data.alternateCourseIDsToAddSecurityHash;
            }
        };

        var getSelectedBrowseRowPrimaryKey = function (browse)
        {
            if (browse.currentRow == undefined && browse.currentRow == null)
            {
                return null;
            }

            return browse.primaryKeys[browse.currentRow];
        };

        function getSelectedBrowseRowData(browse, key)
        {
            if (browse.currentRow == undefined && browse.currentRow == null)
            {
                return null;
            }

            return browse.rowData[browse.currentRow][key];
        }

        var IsAddedByOffice = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "o")
            {
                return true;
            }

            return false;
        };

        var IsAddedByRecommendation = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "r")
            {
                return true;
            }

            return false;
        };

        var IsAddedByImport = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "i")
            {
                return true;
            }

            return false;
        };

        var IsAddedByMassProcess = function (requestSource)
        {
            if (requestSource == null || requestSource == "undefined")
            {
                return false;
            }

            if (requestSource.toLowerCase() === "m")
            {
                return true;
            }

            return false;
        };

        var IsScheduled = function (requestStatus)
        {
            if (requestStatus == null || requestStatus == "undefined")
            {
                return false;
            }

            if (requestStatus.toLowerCase() === "s")
            {
                return true;
            }

            return false;
        };

        skyward.courserequest.generateCourseFilter = function (forceRefresh)
        {
            var availableCoursesContainsValue = $(availableCoursesContains);

            var containsValue = skyward.controls.getValue(availableCoursesContainsValue);

            if (containsValue != previousContainsString || forceRefresh)
            {
                if (containsValue != previousContainsString)
                {
                    previousContainsString = containsValue;
                }

                var postData = { CourseCodeContains: containsValue, DescriptionContains: containsValue, SubjectDescriptionContains: containsValue };

                if (skyward.global.mobileAccess)
                {
                    $.extend(postData, {
                        CourseIDsToAdd: JSON.stringify(JSON.parse(courseIDsToAdd || "[]")),
                        AlternateCourseIDsToAdd: JSON.stringify(JSON.parse(alternateCourseIDsToAdd || "[]")),
                        StudentCourseRequestIDsToRemove: combineStringifiedArrays(studentCourseRequestIDsToRemove, alternateStudentCourseRequestIDsToRemove),
                        AlternatesRank: alternatesRank
                    });
                }

                skyward.browse.get(availableCoursesBrowseName, skyward.browse.browseList[availableCoursesBrowseName].data, postData);
            }
        };

        var combineStringifiedArrays = function (array1, array2)
        {
            if (array1 === null || array1 === undefined || array1 === "")
            {
                array1 = "[]";
            }

            if (array2 === null || array2 === undefined || array2 === "")
            {
                array2 = "[]";
            }

            var parsed1 = JSON.parse(array1);
            var parsed2 = JSON.parse(array2);

            return JSON.stringify(parsed1.concat(parsed2));
        };

        var tabClickHandler = function (event)
        {
            if (event.target.firstChild.data && event.target.firstChild.data.indexOf(isAlternateTabName) !== -1)
            {
                isAlternateMode = true;
            }
            else
            {
                isAlternateMode = false;
            }
        };

        //Content Message Area -- cloned like code from skyward.ui.contentMessageArea.ts
        skyward.courserequest.showConfirmation = function (message)
        {
            requestContentMessageArea.setConfirmationMessage(message);
            requestContentMessageArea.showConfirmation();
            myRequestsPopupRequestContentMessageArea.setConfirmationMessage(message);
            myRequestsPopupRequestContentMessageArea.showConfirmation();
        };

        skyward.courserequest.showInformation = function (message)
        {
            requestContentMessageArea.setInformationMessage(message);
            requestContentMessageArea.showInformation();
            myRequestsPopupRequestContentMessageArea.setInformationMessage(message);
            myRequestsPopupRequestContentMessageArea.showInformation();
        };

        skyward.courserequest.showError = function (message)
        {
            requestContentMessageArea.setErrorMessage(message);
            requestContentMessageArea.showError();
            myRequestsPopupRequestContentMessageArea.setErrorMessage(message);
            myRequestsPopupRequestContentMessageArea.showError();
        };

        skyward.courserequest.showWarning = function (message)
        {
            requestContentMessageArea.setWarningMessage(message);
            requestContentMessageArea.showWarning();
            myRequestsPopupRequestContentMessageArea.setWarningMessage(message);
            myRequestsPopupRequestContentMessageArea.showWarning();
        };

        var resetMessages = function ()
        {
            requestContentMessageArea.resetMessageContent(true, true, true);
            myRequestsPopupRequestContentMessageArea.resetMessageContent(true, true, true);
        };

        var contentMessageAreas = {};
        var currentContentMessageAreaKey = 0;

        skyward.courserequest.getContentMessageArea = function (container)
        {
            if (!container || !container.data())
            {
                return getStubbedContentMessageAreaObject();
            }

            var contentMessageAreaKey = container.data().contentMessageAreaKey;

            if (contentMessageAreaKey != undefined && contentMessageAreas.hasOwnProperty(contentMessageAreaKey))
            {
                return contentMessageAreas[contentMessageAreaKey];
            }

            var contentMessageArea = container.find('.contentMessageArea').first();

            if (contentMessageArea && contentMessageArea.length > 0)
            {
                var cmaObject = getContentMessageAreaObject(contentMessageArea);
                contentMessageAreas[currentContentMessageAreaKey] = cmaObject;
                container.data('content-message-area-key', currentContentMessageAreaKey);
                currentContentMessageAreaKey++;
                return cmaObject;
            }
            else
            {
                return null;
            }
        };

        /**
         * Returns an minimal object that mimics the structure of those returned by getContentMessageAreaObject
         */
        var getStubbedContentMessageAreaObject = function ()
        {
            var contentMessageAreaObject = {};
            contentMessageAreaObject.getContentMessageAreaElement = function ()
            {
                return $("<div>");
            };

            contentMessageAreaObject.resetConfirmation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetError = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetInformation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetWarning = function ()
            {
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.resetMessageContent = function ()
            {
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.setInformationMessage = function () { };
            contentMessageAreaObject.setConfirmationMessage = function () { };
            contentMessageAreaObject.setErrorMessage = function () { };
            contentMessageAreaObject.setWarningMessage = function () { };

            contentMessageAreaObject.showConfirmation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showError = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showInformation = function ()
            {
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showWarning = function ()
            {
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.height = function ()
            {
                return 0;
            };

            return contentMessageAreaObject;
        };

        var getContentMessageAreaObject = function (contentMessageAreaElement)
        {
            var contentMessageAreaObject = {};

            var contentMessageArea = contentMessageAreaElement;
            var errorMessage = getMessageObject(contentMessageArea, '.cmaErrorMessage');
            var warningMessage = getMessageObject(contentMessageArea, '.cmaWarningMessage');
            var confirmationMessage = getConfirmationMessageObject(contentMessageArea, '.cmaConfirmationMessage');
            var informationMessage = getMessageObject(contentMessageArea, '.cmaInformationMessage');

            contentMessageAreaObject.getContentMessageAreaElement = function ()
            {
                return contentMessageArea;
            };

            contentMessageAreaObject.resetConfirmation = function ()
            {
                confirmationMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetError = function ()
            {
                errorMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetInformation = function ()
            {
                informationMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.resetWarning = function ()
            {
                warningMessage.reset();
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.resetMessageContent = function (isResetError, isResetWarning, isResetInformation)
            {
                if (isResetError)
                {
                    errorMessage.reset();
                }
                if (isResetWarning)
                {
                    warningMessage.reset();
                }
                if (isResetInformation)
                {
                    informationMessage.reset();
                }
                contentMessageArea.hide();
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.setInformationMessage = function (message)
            {
                informationMessage.setMessage(message);
                informationMessage.show();
            };
            contentMessageAreaObject.setConfirmationMessage = function (message)
            {
                confirmationMessage.setMessage(message);
                confirmationMessage.show();
            };
            contentMessageAreaObject.setErrorMessage = function (message)
            {
                errorMessage.setMessage(message);
                errorMessage.show();
            };
            contentMessageAreaObject.setWarningMessage = function (message)
            {
                warningMessage.setMessage(message);
                warningMessage.show();
            };

            contentMessageAreaObject.showConfirmation = function ()
            {
                if (confirmationMessage.hasValue)
                {
                    confirmationMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showError = function ()
            {
                if (errorMessage.hasValue)
                {
                    errorMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showInformation = function ()
            {
                if (informationMessage.hasValue)
                {
                    informationMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };
            contentMessageAreaObject.showWarning = function ()
            {
                if (warningMessage.hasValue)
                {
                    warningMessage.show();
                }

                contentMessageArea.show();
                return contentMessageAreaObject;
            };

            contentMessageAreaObject.height = function ()
            {
                return contentMessageArea.outerHeight(true);
            };

            return contentMessageAreaObject;
        };

        var getConfirmationMessageObject = function (contentMessageArea, className)
        {
            var messageObject = getBaseMessage();
            var messageElement = contentMessageArea.find(className);

            if (messageElement.length == 0)
            {
                // Try to fallback to message object higher up the DOM hierarchy
                messageElement = contentMessageArea.parent().find(className);

                if (messageElement.length == 0)
                {
                    return messageObject;
                }
            }

            messageElement.data('content-message-area-key', currentContentMessageAreaKey);
            messageObject.message = messageElement;
            var messageContainer = messageElement.find('.cmaMessage');
            messageObject.hasValue = messageElement.hasClass('cmaHasValue');

            messageObject = setConfirmationMessageFunctions(messageObject, messageContainer);

            messageObject.message.off('click');

            return messageObject;
        };

        var setConfirmationMessageFunctions = function (object, container)
        {
            var base =
            {
                makeHidden: object.makeHidden,
                show: object.show,
                hide: object.hide,
                isVisible: object.isVisible
            };

            object.hide = function ()
            {
                object.message.animate({ 'opacity': 0 },
                    {
                        complete: function ()
                        {
                            base.hide();
                        }
                    });
                return object;
            };
            object.show = function ()
            {
                base.show();
                object.message.animate({ 'opacity': 1 },
                    {
                        complete: function ()
                        {
                            window.setTimeout(function ()
                            {
                                object.reset();
                                container.trigger("SaveAnimationRedirect");
                            }, 3000);
                        }
                    });
                return object;
            };
            object.reset = function ()
            {
                object.hide();
                container.html('');
                object.message.removeClass('cmaHasValue');
                object.hasValue = false;
                return object;
            };
            object.setMessage = function (message)
            {
                var cmaMessage = container.find(".cmaMessageText");
                if (cmaMessage.length > 0)
                {
                    cmaMessage.text(message);
                }
                else
                {
                    container.text(message);
                }
                object.message.addClass('cmaHasValue');
                object.hasValue = true;
                return object;
            };

            return object;
        };

        var getMessageObject = function (contentMessageArea, className)
        {
            var messageObject = getBaseMessage();
            var messageElement = contentMessageArea.find(className);

            if (messageElement.length == 0)
            {
                return messageObject;
            }

            messageElement.data('content-message-area-key', currentContentMessageAreaKey);
            messageObject.message = messageElement;
            var messageContainer = messageElement.find('.cmaMessage');
            messageObject.hasValue = messageElement.hasClass('cmaHasValue');
            messageObject = setErrorWarningInformationFunction(messageObject, messageContainer);
            return messageObject;
        };

        var setErrorWarningInformationFunction = function (object, container)
        {
            object.reset = function ()
            {
                object.hide();
                container.html('');
                object.message.removeClass('cmaHasValue');
                object.hasValue = false;
                return object;
            };
            object.setMessage = function (message)
            {
                container.text(message);
                object.message.addClass('cmaHasValue');
                object.hasValue = true;
                return object;
            };

            setAdditionalInformationBubbleClick(object);
            return object;
        };

        var setAdditionalInformationBubbleClick = function (messageObject)
        {
            messageObject.message.off('click').click(function ()
            {
                var dialog = skyward.modalLayer.showDialog('Additional Information', messageObject.message.find('.cmaMessage').text(), [{ text: 'Close', icon: 'Close' }],
                    {
                        anchorTo: messageObject.message.find('.svg')
                    });
            });
        };

        var getBaseMessage = function ()
        {
            var baseMessage = {};

            baseMessage.message = undefined;

            baseMessage.show = function ()
            {
                if (baseMessage.message)
                {
                    baseMessage.message.removeClass('cmaHidden');
                }
                return baseMessage;
            };

            baseMessage.hide = function ()
            {
                if (baseMessage.message)
                {
                    baseMessage.message.addClass('cmaHidden');
                }
                return baseMessage;
            };

            baseMessage.reset = function ()
            {
                return baseMessage.hide();
            };

            return baseMessage;
        };

        skyward.courserequest.showLegend = function (button)
        {
            skyward.modalLayer.showDialog("Course Requests Legend", $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/OnlineRequestsGetLegend",
                type: "GET",
                dataType: "viewparthtml"
            }), [{ text: "Close", icon: "Close", click: "close" }], { anchorTo: $(button) });
        };

        function getLinkedAlternates()
        {
            return skyward.controls.getValue($('#' + linkedAlternatesName));
        }

        function getInitialLinkedAlternates()
        {
            return skyward.controls.getValue($('#' + initialLinkedAlternatesName));
        }

        function setInitialLinkedAlternates (data)
        {
            var valueToSet;
            if (data && data.linkedAlternates)
            {
                valueToSet = data.linkedAlternates;
            }
            else
            {
                valueToSet = getLinkedAlternates()
            }
            skyward.controls.setValue($('#' + initialLinkedAlternatesName), valueToSet);
        }

        function resetLinkedAlternates()
        {
            skyward.controls.setValue($('#' + linkedAlternatesName), getInitialLinkedAlternates());
        }

        function linkedAlternatesChanged()
        {
            const linkedAlternatesUpdated = skyward.controls.getValue($('#' + linkedAlternatesUpdatedName));
            if (!linkedAlternatesUpdated || linkedAlternatesUpdated.length === 0 || linkedAlternatesUpdated === "undefined" || linkedAlternatesUpdated == 'false')
            {
                return false;
            }
            return true;
        }

        function resetLinkedAlternatesUpdated()
        {
            skyward.controls.setValue($('#' + linkedAlternatesUpdatedName), false);
        }

        function initCourseAltEELChangeHandlers()
        {
            // Bind to both the browse-specific selector and a global id-based selector.
            // This covers mobile where the CourseAlt EEL may be rendered outside of the browse container.
            var courseAltSelector = "#" + alternateCourseBrowseName + " [id^='CourseAltID-'] .codeEELValue, [id^='CourseAltID-'] .codeEELValue";
            $("body").off("change", courseAltSelector)
                .on("change", courseAltSelector, courseAltEELChange);
        };

        function courseAltEELChange()
        {
            var triggeringControl = $(this);
            var eel = triggeringControl.closest('.codeEEL')
            const courseID = skyward.controls.getValue(triggeringControl);
            var alternateID = eel.data('courseid');
            var studentCourseRequestID = eel.data("studentcourserequestid");
            // Prefer rowData lookup over DOM data-* (mobile may not have it)
            var rowId = triggeringControl.closest("td").data("row");
            var browse = skyward.browse.browseList[alternateCourseBrowseName];

            if (browse && browse.rowData && rowId !== undefined && browse.rowData[rowId] && browse.rowData[rowId][studentCourseRequestIDName] !== undefined) {
                studentCourseRequestID = browse.rowData[rowId][studentCourseRequestIDName];
            }
            var linkedAlternates = getLinkedAlternates();
            var initialLinkedAlternates = getInitialLinkedAlternates();

            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/StudentCourseRequest/UpdateAlternateEEL" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    EntityID: entityID,
                    EntityID_SecurityHash: entityID_securityhash,
                    SchoolYearID: schoolYearID,
                    SchoolYearID_SecurityHash: schoolYearID_securityhash,
                    StudentID: studentID,
                    StudentID_SecurityHash: studentID_securityhash,
                    AvailabilityFilterCourseStudentID: availabilityFilterCourseStudentID,
                    AvailabilityFilterCourseStudentID_SecurityHash: availabilityFilterCourseStudentID_securityhash,

                    CourseID: courseID,
                    AlternateID: alternateID,
                    StudentCourseRequestID: studentCourseRequestID,

                    LinkedAlternates: linkedAlternates,
                    InitialLinkedAlternates: initialLinkedAlternates,

                    AlternateCourseIDsToAdd: alternateCourseIDsToAdd,
                    AlternateCourseIDsToAddSecurityHash: alternateCourseIDsToAddSecurityHash
                },
                success: function (data) {
                    if (data.errormessage != "" && data.errormessage != null && data.errormessage != "undefined") {
                        skyward.courserequest.showError(data.errormessage);
                        return;
                    }
                    skyward.controls.setValue($('#' + linkedAlternatesName), data.linkedAlternates);
                    skyward.controls.setValue($('#' + linkedAlternatesUpdatedName), data.linkedAlternatesUpdated);

                    updateCourseIDsToAddList(data);
                    showHideToolBarButtons();
                }
            });
        }

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.onlineformelement = skyward.onlineformelement || {};

        var cancelEvent = function (e)
        {
            if (e.stopPropagation)
            {
                e.stopPropagation();
            }
            else
            {
                e.cancelBubble = true;
            }
        };

        var init = function (selector)
        {
            var elementID;
            var stepStatusID;
            var emergencyContactHash;
            var userCurrentPortal;

            $(selector + ' .onlineformelementquickentry').not('.onlineformelementeventsbound').each(function ()
            {
                var elementRepeaterParent = $(this);

                if (elementRepeaterParent.hasClass('js-onlineFormOrderedChildRecordQuickEntry'))
                {
                    let rowRemovedUpdateDeleteId;
                    let rowAddedUpdateAddId;
                    let isEmergencyContact = false;

                    if (elementRepeaterParent.hasClass('newstudentenrollmentphonerepeater'))
                    {
                        rowRemovedUpdateDeleteId = 'DeletePhone';
                        rowAddedUpdateAddId = 'AddPhone';

                        addRowAddedUpdateIDsListener(elementRepeaterParent, '.newStudentEnrollmentPhoneData');
                    }
                    else if (elementRepeaterParent.hasClass('newstudentenrollmentemailrepeater'))
                    {
                        rowRemovedUpdateDeleteId = 'DeleteEmail';
                        rowAddedUpdateAddId = 'AddEmail';

                        addRowAddedUpdateIDsListener(elementRepeaterParent, '.newStudentEnrollmentEmailData');
                    }
                    else if (elementRepeaterParent.hasClass('newstudentenrollmentguardianrepeater'))
                    {
                        rowRemovedUpdateDeleteId = 'DeleteGuardian';
                        rowAddedUpdateAddId = 'AddGuardian';
                    }
                    else
                    {
                        rowRemovedUpdateDeleteId = 'DeleteEmergencyContact';
                        rowAddedUpdateAddId = 'AddEmergencyContact';
                        isEmergencyContact = true;
                    }

                    elementRepeaterParent.on('childrecordquickentry-row-added', function (e, newRow)
                    {
                        rowAddedUpdateOrder(newRow, rowAddedUpdateAddId, isEmergencyContact);
                        cancelEvent(e);
                    });

                    elementRepeaterParent.on('childrecordquickentry-row-removed', function (e, removedRow)
                    {
                        rowRemovedUpdateElementOrder(removedRow, rowRemovedUpdateDeleteId, isEmergencyContact);
                        cancelEvent(e);
                    });

                    elementRepeaterParent.on('childrecordquickentry-row-cleared', function (e, clearedRow, isRowBeingRemoved)
                    {
                        if (isRowBeingRemoved)
                        {
                            updateNextRows(clearedRow, isEmergencyContact);
                        }

                        cancelEvent(e);
                    });
                }

                elementRepeaterParent.addClass('onlineformelementeventsbound');

                elementRepeaterParent.find('.deletedphone,.deletedemail,.deletedguardian').each(function ()
                {
                    var tableRow = $(this).closest('.childrecordquickentryrow');
                    tableRow.hide();
                });
            });

            $(selector).find('.js-ElementFieldGroupTypeCode').change(function ()
            {
                var elementRepeaterParent = $(this).parents('.childrecordquickentryrow').eq(0);
                // clear out serialized overrides on field group change
                skyward.controls.setValue(elementRepeaterParent.find('.js-ElementSerializedLabelOverrides'), '');
                // reset button text on field group change if needed
                elementRepeaterParent.find('[data-click-action="onlineFormElement.openLabelOverrides"] > .buttonText').text(function (i, currText)
                {
                    if (currText && currText.indexOf('(Modified)') > -1)
                    {
                        return currText.substring(0, currText.indexOf('(Modified)')).trim();
                    }
                    return currText;
                });
            });

            var newDependentEnrollmentChange = function ()
            {
                var employeePlanEnrollmentFieldGroup = $(this).parents('.employeePlanEnrollmentFieldGroup');
                var newDependentEnrollmentCheckboxes = employeePlanEnrollmentFieldGroup.find("[id^='NewDependentEnrollment-']");
                var maximumDependentCountHidden = employeePlanEnrollmentFieldGroup.find("[id^='MaximumDependentCount-']");
                var maximumDependentCount = skyward.controls.getValue(maximumDependentCountHidden);

                var totalDependentsEnrolled = 0;
                $.each(newDependentEnrollmentCheckboxes, function (_index, newDependentEnrollmentCheckbox)
                {
                    if (skyward.controls.getValue(newDependentEnrollmentCheckbox))
                    {
                        totalDependentsEnrolled++;
                    }
                });

                var shouldGoToReadOnly = maximumDependentCount ? totalDependentsEnrolled >= maximumDependentCount : false;

                $.each(newDependentEnrollmentCheckboxes, function (_index, newDependentEnrollmentCheckbox)
                {
                    var isNewDependentEnrollmentCheckboxSelected = skyward.controls.getValue(newDependentEnrollmentCheckbox);

                    if (isNewDependentEnrollmentCheckboxSelected)
                    {
                        // If this condition is true this newDependentEnrollmentCheckbox is already selected and editable. We do not want to prevent them from deselecting the checkbox so there is no need to change anything.
                        return;
                    }

                    var isDependentEligibleForNewEnrollmentHiddenID = newDependentEnrollmentCheckbox
                        .getAttribute("id")
                        .replace("NewDependentEnrollment-", "IsDependentEligibleForNewEnrollment-");
                    var isDependentEligibleForNewEnrollmentHidden = $('#' + isDependentEligibleForNewEnrollmentHiddenID);
                    var isDependentEligibleForNewEnrollment = skyward.controls.getValue(isDependentEligibleForNewEnrollmentHidden);

                    if (!isDependentEligibleForNewEnrollment)
                    {
                        // If the new dependent enrollment is ineligible it will always be hidden and readonly so there is no need to change anything.
                        return;
                    }

                    if (shouldGoToReadOnly)
                    {
                        skyward.controls.disable(newDependentEnrollmentCheckbox);
                    }
                    else
                    {
                        skyward.controls.enable(newDependentEnrollmentCheckbox);
                    }
                });
            }

            $(selector).find("[id^='NewDependentEnrollment-']").on("change", newDependentEnrollmentChange);

            function addRowAddedUpdateIDsListener(elementRepeaterParent, dataClass)
            {
                elementRepeaterParent.on('childrecordquickentry-row-added', function (e, newRow)
                {
                    // Update IDs to be the correct format for our repeaters within the Guardian repeater
                    var previousRowInputId = newRow.prev('.childrecordquickentryrow').find('[id]:input:visible:eq(0)').attr('id');
                    if (previousRowInputId)
                    {
                        var parentOnScreenId = previousRowInputId.split('-')[3];
                        // Find any previous row data control to get correct ParentOnScreenID
                        newRow.find(dataClass + ',[data-validate-message-for],[data-validate-text-for]').each(function ()
                        {
                            var dataInput = $(this);
                            var dataInputId = dataInput.attr('data-validate-message-for') || dataInput.attr('data-validate-text-for') || dataInput.attr('id');
                            if (dataInputId)
                            {
                                var dataInputIdParts = dataInputId.replace(/childrecordquickentrychild(add)*-familyguardian-familyid(second)*-[0-9]+-/g, '').split('-');
                                dataInputIdParts[3] = parentOnScreenId;
                                var newId = dataInputIdParts.join('-');
                                if (dataInput.attr('id'))
                                {
                                    skyward.controls.changeId(dataInput, newId, newId);
                                }
                                if (dataInput.attr('data-validate-control-for'))
                                {
                                    dataInput.attr('data-validate-control-for', newId);
                                }
                                if (dataInput.attr('data-validate-message-for'))
                                {
                                    dataInput.attr('data-validate-message-for', newId);
                                }
                                if (dataInput.attr('data-validate-text-for'))
                                {
                                    dataInput.attr('data-validate-text-for', newId);
                                }
                            }
                        });
                    }

                    cancelEvent(e);
                });
            };
        };

        var parseElementOrderFromLabelText = function (elementOrderText)
        {
            var order = parseInt(elementOrderText, 10);
            if (!order && order !== 0)
            {
                order = 1;
            }
            return order
        };

        var rowAddedUpdateOrder = function (newRow, addId, isEmergencyContact)
        {
            var newRowelementOrderText = newRow.find('.elementOrderText:eq(0)');
            var hiddenAdd = newRow.find('[id^="' + addId + '-"]');
            skyward.controls.setValue(hiddenAdd, "true");

            var previousElementOrderValue = parseElementOrderFromLabelText(newRow.prev('.childrecordquickentryrow').find('.elementOrderText:eq(0)').val());
            if (previousElementOrderValue || previousElementOrderValue == 0)
            {
                skyward.controls.setValue(newRowelementOrderText, previousElementOrderValue + 1);
            }

            updateRowHeaderLabel(newRow, newRowelementOrderText, isEmergencyContact);
        };

        var rowRemovedUpdateElementOrder = function (removedRow, deleteId, isEmergencyContact)
        {
            var elementBeingRemoved = removedRow.find(`[id^="${removedRow.getPrefix()}${deleteId}"]`);
            skyward.controls.setValue(elementBeingRemoved, "true");

            updateNextRows(removedRow, isEmergencyContact);
        };

        var updateNextRows = function (clearedRow, isEmergencyContact)
        {
            var elementOrder = parseElementOrderFromLabelText(clearedRow.find('.elementOrderText').val());
            if (!elementOrder)
            {
                return;
            }

            clearedRow.nextAll('.childrecordquickentryrow').not('.removedElement').each(function ()
            {
                var nextRow = $(this);
                // TODO: will need to update this slightly for nested repeaters - make sure the .removedElement is truly in the removed repeater and not a nested repeater
                if (!nextRow.find('.removedElement').length)
                {
                    var elementOrderText = nextRow.find('.elementOrderText');
                    if (elementOrderText.length)
                    {
                        skyward.controls.setValue(elementOrderText, elementOrder);
                        elementOrder++;
                    }
                    updateRowHeaderLabel(nextRow, elementOrderText, isEmergencyContact);
                }
            });
        };

        var updateRowHeaderLabel = function (crqeRow, elementOrderText, isEmergencyContact)
        {
            var getElementOrderText = function ()
            {
                var orderText = crqeRow.find('.elementOrderText:eq(0)');
                if (orderText.length)
                {
                    return orderText;
                }
                return crqeRow.find('.elementOrderTextReadonly:eq(0)');
            };

            elementOrderText = elementOrderText || getElementOrderText();

            var elementOrderTextValue = elementOrderText.val();
            if (elementOrderTextValue)
            {
                const crqeRowOrderText = (elementOrderText.data('orderheadertext') || 'Emergency Contact #') + elementOrderTextValue;

                crqeRow.find('.legendHeader:eq(0)').text(crqeRowOrderText);

                if (isEmergencyContact)
                {
                    crqeRow.find('.emergencyContactPhoneSectionHeader:eq(0)').text(crqeRowOrderText + " Phones");
                    crqeRow.find('.emergencyContactEmailSectionHeader:eq(0)').text(crqeRowOrderText + " Emails");
                    crqeRow.find('.emergencyContactVehicleSectionHeader:eq(0)').text(crqeRowOrderText + " Vehicle");
                }
            }
        };

        var openLabelOverrides = function ()
        {
            var button = $(this);
            var buttonIdParts = button.attr('id').split('-');
            var isExisting = button.attr('id').indexOf('existing') > -1;
            var isWorkflow = button.attr('id').indexOf('workflow') > -1;
            var elementOrRowId = buttonIdParts[buttonIdParts.length - 1];
            var onlineFormElementContainer = button.parents('.onlineformelement:eq(0)');
            var fieldGroupTypeCode =
                skyward.controls.getValue(onlineFormElementContainer.find('.js-ElementFieldGroupTypeCode'));
            var onlineFormID = skyward.controls.getValue(onlineFormElementContainer.find('.js-OnlineFormID'));
            var currentSerializedOverrides = onlineFormElementContainer.find('.js-ElementSerializedLabelOverrides');

            if (!elementOrRowId || !fieldGroupTypeCode)
            {
                return;
            }

            var buildModalBody = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "OnlineForm/Element/LabelOverridesScreen",
                    dataType: "viewparthtml",
                    type: "POST",
                    data: {
                        ElementOrRowId: elementOrRowId,
                        FieldGroupTypeCode: fieldGroupTypeCode,
                        // getValue handles escaping characters in the JSON, like single-quotes
                        SerializedLabelOverrides: skyward.controls.getValue(currentSerializedOverrides)
                    }
                });
            };

            var gatherOverridesOnScreen = function ()
            {
                var postData = {};
                dialog.content.find("[name]").each(function ()
                {
                    postData[$(this).attr("name")] = $(this).encodedVal();
                });
                return postData;
            };

            var gatherElementDataOnScreen = function ()
            {
                var elementData = {};
                onlineFormElementContainer.find("[id]:visible").each(function ()
                {
                    elementData[$(this).attr("id")] = skyward.controls.getValue($(this));
                });
                return elementData;
            };

            var previewButtonClick = function ()
            {
                var postData = gatherOverridesOnScreen();
                postData["FieldGroupTypeCode"] = fieldGroupTypeCode;
                postData["OnlineFormID"] = onlineFormID;
                postData["SerializedElementData"] = JSON.stringify(gatherElementDataOnScreen());

                var buildPreviewModalBody = function ()
                {
                    var previewScreenUrl = skyward.global.virtualDir + "OnlineForm/Element/PreviewLabelOverridesScreen";
                    if (isWorkflow)
                    {
                        previewScreenUrl += "Workflow";
                    }

                    if (isExisting && elementOrRowId)
                    {
                        previewScreenUrl += "/" + elementOrRowId;
                    }
                    return $.ajax({
                        url: previewScreenUrl,
                        dataType: "viewparthtml",
                        type: "POST",
                        data: postData
                    });
                };

                var previewButtons = [
                    { text: "Close", click: function () { innerDialog.close(); }, icon: "Close" }
                ];

                var innerDialog = skyward.modalLayer.showDialog("Preview Label Overrides", buildPreviewModalBody, previewButtons);
            };

            var buttons = [
                {
                    text: "Preview",
                    click: previewButtonClick,
                    icon: "Eye"
                },
                {
                    text: "Save", click: function ()
                    {
                        var postData = gatherOverridesOnScreen();

                        $.ajax({
                            url: skyward.global.virtualDir + "OnlineForm/Element/SerializeLabelOverridesScreen",
                            dataType: "JSON",
                            type: "POST",
                            data: postData,
                            success: function (data)
                            {
                                if (data.errors)
                                {
                                    skyward.validation.displayValidationMessages(data, dialog.content, $("<div/>"));
                                    return;
                                }

                                var newValue = JSON.stringify(data);
                                if (newValue !== currentSerializedOverrides.val())
                                {
                                    skyward.controls.setValue(currentSerializedOverrides, newValue);
                                    button.find('.buttonText').text(function (index, currentText)
                                    {
                                        var textToAppend = " (Modified)";
                                        if (currentText.indexOf(textToAppend) === -1)
                                        {
                                            return currentText + textToAppend;
                                        }
                                        return currentText;
                                    });
                                }
                                dialog.close();
                            }
                        });
                    },
                    icon: "Save"
                },
                { text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" }
            ];

            var dialog = skyward.modalLayer.showDialog("Element Label Overrides", buildModalBody, buttons);
        };

        var events = {
            "openLabelOverrides": openLabelOverrides
        };

        skyward.events.registerEvents("onlineFormElement", events);

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(function (skyward, $, undefined)
{
    skyward.massaddspecialprogramstx = skyward.massaddspecialprogramstx || {};

    var massAddSpecialProgramsTXWorkflowSelector, atRisk, campIDOfAcct, campIDOfRes, cte, crisis, dyslexia, earlyReading, fosterCare, giftedTalented, graduationProgramEndorsement, homeboundhospital, homeless,
        immigrant, lep, migrant, militaryConnectedStudent, pregnancyEducationParenting, pregRelService, preK, ssiProRet, includeExclude, stuAttr, workflowInstanceId;

    var init = function (selector)
    {
        "use strict";
        
        massAddSpecialProgramsTXWorkflowSelector = $(selector).find("#SpecialProgramsContainer");
        if (massAddSpecialProgramsTXWorkflowSelector.length > 0)
        {
            workflowInstanceId = $('.workflow.skywardContentPanel').data('workflow-instance-id');
            //Individual Special Program Wrapper functions
            $(function ()
            {
                $("input, textarea").on('errorChange', function ()
                {
                    if ($(this).hasClass('error-control'))
                    {
                        if (!$(this).closest('.specialProgramContainer').hasClass('error-control'))
                        {
                            $(this).closest('.specialProgramContainer').toggleClass('error-control');
                        }
                    }
                    else
                    {
                        if (($(this).closest('.specialProgramContainer').find('.error-control')[0] === undefined))
                        {
                            if ($(this).closest('.specialProgramContainer').hasClass('error-control'))
                            {
                                $(this).closest('.specialProgramContainer').removeClass('error-control');
                            }
                        }
                    }
                });
            });

            registerContainers();
        }
        else
        {
            return;
        }
    };

    var registerContainers = function ()
    {
        var allSpecialPrograms = $('.specialProgramContainer');
        for (var i = 0; i < allSpecialPrograms.length; i++)
        {
            var specialProgram = $(allSpecialPrograms[i]);
            specialProgram.checkBox = specialProgram.find('input.specialProgramCheckBox:checkbox');
            if (specialProgram.find('.specialProgramButtonDiv'))
            {
                specialProgram.fieldsContainer = specialProgram.find('.fieldWrapper');
                specialProgram.buttonDiv = specialProgram.find('.specialProgramButtonDiv');
                specialProgram.expandButton = specialProgram.find('#expandButton');
                specialProgram.collapseButton = specialProgram.find('#collapseButton');
                specialProgram.checkBox.change(function ()
                {
                    skyward.massaddspecialprogramstx.isProgramChecked();
                });
                specialProgram.buttonDiv.click(function ()
                {
                    skyward.massaddspecialprogramstx.expandCollapse();
                });
            }
        }
    };

    skyward.massaddspecialprogramstx.isProgramChecked = function ()
    {
        var target = $(event.target);
        var isChecked = target.prop('checked');
        var wrapper = target.closest('.specialProgramContainer').find('.fieldWrapper.specialProgramsFields');

        if (isChecked) 
        {
            var expandButton = target.closest('#expandButton');
            var collapseButton = $(expandButton).siblings('#collapseButton');
            wrapper.show();
            wrapper.removeClass("collapsed");
            wrapper.addClass("expanded");
            expandButton.hide();
            collapseButton.show();
        }
        else 
        {
            var collapseButton = target.closest('#collapseButton');
            var expandButton = $(collapseButton).siblings('#expandButton');
            wrapper.find('input, textarea').each(function ()
            {
                skyward.controls.setValue($(this), '');
            });
            wrapper.hide();
            wrapper.removeClass("expanded");
            wrapper.closest('.specialProgramContainer').removeClass("specialProgramError");
            wrapper.addClass("collapsed");
            expandButton.show();
            collapseButton.hide();
        }
    };

    skyward.massaddspecialprogramstx.expandCollapse = function ()
    {
        var target = $(event.target);
        var wrapper = target.closest('.specialProgramContainer').find('.fieldWrapper.specialProgramsFields');
        var isHidden = wrapper.hasClass('collapsed');


        if (isHidden)
        {
            var expandButton = target.closest('#expandButton');
            var collapseButton = $(expandButton).siblings('#collapseButton');
            wrapper.show();
            wrapper.removeClass("collapsed");
            wrapper.addClass("expanded");
            expandButton.hide();
            collapseButton.show();
        }
        else
        {
            var collapseButton = target.closest('#collapseButton');
            var expandButton = $(collapseButton).siblings('#expandButton');
            wrapper.hide();
            wrapper.removeClass("expanded");
            wrapper.addClass("collapsed");
            expandButton.show();
            collapseButton.hide();
        }
    };

    skyward.massaddspecialprogramstx.parseXML = function ()
    {
        var xmlDoc = document.implementation.createDocument("http://www.w3.org/1999/xhtml", "SpecialProgramParameters", null);
        var specialProgramParametersXML = xmlDoc.createElement("SpecialProgramParameters");
        var parseSectionXML = function (specialProgram)
        {
            if (specialProgram.find('.checkbox') && specialProgram.find('.checkbox').prop('checked'))
            {
                var specialProgramNode = xmlDoc.createElement(specialProgram[0].id.replace('Container', ''));
                $(specialProgram).find("input:not(.distinctMultiSelectUserInput), textarea, select").each(function ()
                {
                    var fieldValue, fieldNameNode, fieldValueNode;
                    var field = $(this);
                    var fieldID = field.prop('id');

                    if (field.is(':checkbox'))
                    {
                        fieldValue = field.prop('checked');
                        fieldNameNode = xmlDoc.createElement(fieldID);
                        fieldValueNode = xmlDoc.createTextNode(fieldValue);
                        fieldNameNode.appendChild(fieldValueNode);
                        specialProgramNode.appendChild(fieldNameNode);
                    }
                    else if (field.hasClass('dmsBackingData'))
                    {
                        fieldValue = skyward.distinctMultiSelectEEL.values.get(field);
                        fieldNameNode = xmlDoc.createElement(fieldID);

                        for (var key in fieldValue)
                        {
                            if (fieldValue.hasOwnProperty(key))
                            {
                                var selectedNode = xmlDoc.createElement('DMSSelectedNode');
                                fieldValueNode = xmlDoc.createTextNode(key);
                                selectedNode.appendChild(fieldValueNode);
                                fieldNameNode.appendChild(selectedNode);
                            }
                        }
                        specialProgramNode.appendChild(fieldNameNode);
                    }
                    else if (field.hasClass('comboBoxSet'))
                    {
                        fieldValue = field.val();
                        fieldNameNode = xmlDoc.createElement(fieldID);
                        fieldValueNode = xmlDoc.createTextNode(fieldValue);
                        fieldNameNode.appendChild(fieldValueNode);
                        specialProgramNode.appendChild(fieldNameNode);
                    }
                    else
                    {
                        fieldValue = field.prop('value');
                        if (fieldID.indexOf('_code') < 0 && fieldID.indexOf('_description') < 0)
                        {
                            if (fieldID.indexOf('_value') > -1)
                            {
                                fieldID.replace('_value', '');
                            }

                            fieldNameNode = xmlDoc.createElement(fieldID);
                            fieldValueNode = xmlDoc.createTextNode(fieldValue);
                            fieldNameNode.appendChild(fieldValueNode);
                            specialProgramNode.appendChild(fieldNameNode);
                        }
                    }
                });
                specialProgramParametersXML.appendChild(specialProgramNode);
            }
        };

        var parseSingleElementXML = function(specialProgram)
        {
            if (specialProgram.find('.checkbox') && specialProgram.find('.checkbox').prop('checked'))
            {
                var specialProgramNode = xmlDoc.createElement(specialProgram[0].id.replace('Container', ''));
                specialProgramParametersXML.appendChild(specialProgramNode);
            }
        };
       
        var allSpecialPrograms = $('.specialProgramContainer');
        for (var i = 0; i < allSpecialPrograms.length; i++)
        {
            var specialProgram = $(allSpecialPrograms[i]);
            if (specialProgram.find('.specialProgramButtonDiv'))
            {
                parseSectionXML(specialProgram);
            }
            else
            {
                parseSingleElementXML(specialProgram);
            }
        }

        $.ajax(
        {
            url: skyward.global.virtualDir + 'SpecialPrograms/TempMassCreateEndSpecialProgramTX/ValidateXML',
            type: "POST",
            datatype: "JSON",
            data:
            {
                workflowInstanceId: workflowInstanceId,
                SpecialProgramsXML: encodeURIComponent((new XMLSerializer()).serializeToString(specialProgramParametersXML))
            },
            success: function (data)
            {
                if (data.success)
                {
                    skyward.buttonManager.manageButtonClick(skyward.workflow.customButtonAction('customNext'));
                }
                else
                {
                    if (!$.isEmptyObject(data.errors))
                    {
                        var container = $('#SpecialProgramsContainer');
                        var baseErrorContainer = container.find(".contentMessageArea");

                        skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                    }
                }

                //Because of custom javascript need to handle the ajax update
                var updates = data.Update || {};

                for (field in updates)
                {
                    var nameElement = $("[name='" + field + "']");
                    skyward.controls.setValue(nameElement, updates[field]);
                }
            }
        });
    };

    //Bootstrap
    skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
skyward.base.registerScript('entrywithdrawalspecialprogram', function (skyward, $)
{
    "use strict";
    function initEntryWithdrawalSpecialProgramScript()
    {
        //Individual Special Program Wrapper functions
        $(function ()
        {
            $("input, textarea, div.eELInputContainer").on('errorChange', function ()
            {
                if ($(this).hasClass('error-control'))
                {
                    if (!$(this).closest('.specialProgramContainer').hasClass('error-control'))
                    {
                        $(this).closest('.specialProgramContainer').toggleClass('error-control');
                    }
                }
                else
                {
                    if (($(this).closest('.specialProgramContainer').find('.error-control')[0] === undefined))
                    {
                        if ($(this).closest('.specialProgramContainer').hasClass('error-control'))
                        {
                            $(this).closest('.specialProgramContainer').removeClass('error-control');
                        }
                    }
                }
            });
        });

        $(".specialProgramContainer").each(function ()
        {
            var programContainer = { container: this }
            registerContainerParts(programContainer)
        });

        var programAndRelatedServiceTXIDs = $("#ProgramAndRelatedServiceTXIDs");
        if (programAndRelatedServiceTXIDs.length > 0)
        {
            var programAndRelatedServiceTXIDArray = programAndRelatedServiceTXIDs.val().split(',');
            for (var i = 0; i < programAndRelatedServiceTXIDArray.length; i++)
            {
                var stateProgramAndRelatedServiceTypetest = $("#ProgramAndRelatedServiceTXStateProgramAndRelatedServiceTypeCodeTXID" + programAndRelatedServiceTXIDArray[i]);
                if (stateProgramAndRelatedServiceTypetest.length > 0)
                {
                    programandrelatedservicechange(programAndRelatedServiceTXIDArray[i]);

                    var stateProgramAndRelatedServiceOnChange = function ()
                    {
                        programandrelatedservicechange(programAndRelatedServiceTXIDArray[i]);
                    };

                    stateProgramAndRelatedServiceTypetest.on("eelComplete", stateProgramAndRelatedServiceOnChange);
                }
            }
        }
    }

    var registerContainerParts = function (specialProgram)
    {
        specialProgram.fieldsContainer = $(specialProgram.container).find('.fieldWrapper');
        specialProgram.expandButton = $(specialProgram.container).find('#expandButton');
        specialProgram.collapseButton = $(specialProgram.container).find('#collapseButton');

        specialProgram.expandButton.click(function ()
        {
            expandCollapse(specialProgram.fieldsContainer, specialProgram.expandButton, specialProgram.collapseButton);
        });
        specialProgram.collapseButton.click(function ()
        {
            expandCollapse(specialProgram.fieldsContainer, specialProgram.expandButton, specialProgram.collapseButton);
        });
    };

    var expandCollapse = function (specialProgramsContainer, expandButton, collapseButton)
    {
        var wrapper = specialProgramsContainer;
        var isHidden = specialProgramsContainer.hasClass('collapsed');

        if (isHidden)
        {
            wrapper.show();
            wrapper.removeClass("collapsed");
            wrapper.addClass("expanded");
            expandButton.hide();
            collapseButton.show();
        }
        else
        {
            wrapper.hide();
            wrapper.removeClass("expanded");
            wrapper.addClass("collapsed");
            expandButton.show();
            collapseButton.hide();
        }
    };

    var programandrelatedservicechange = function (programAndRelatedServiceTXID)
    {
        var stateProgramAndRelatedServiceType;

        if (programAndRelatedServiceTXID !== undefined)
        {
            stateProgramAndRelatedServiceType = $("#ProgramAndRelatedServiceTXStateProgramAndRelatedServiceTypeCodeTXID" + programAndRelatedServiceTXID + "_description").val();
        }
        else
        {
            var attrName = document.activeElement.name;

            if (attrName !== undefined && attrName.length > 0)
            {
                var nameSplit = attrName.split('.');
                if (nameSplit !== undefined && nameSplit.length > 0)
                {
                    var programAndRelatedServiceWithAppendedDescription = nameSplit[2];
                    stateProgramAndRelatedServiceType = $("#ProgramAndRelatedServiceTXStateProgramAndRelatedServiceTypeCodeTXID" + programAndRelatedServiceWithAppendedDescription).val();

                    if (programAndRelatedServiceWithAppendedDescription.length > 0)
                    {
                        programAndRelatedServiceTXID = programAndRelatedServiceWithAppendedDescription.split('_')[0];
                    }
                }
            }
        }

        var interpretingServicesFieldSet = $("#fsStateInterpretingServicesTypeCodeTXID" + programAndRelatedServiceTXID);
        var pPCDServiceLocationFieldSet = $("#fsStatePPCDServiceLocationCodeTXID" + programAndRelatedServiceTXID);
        var districtOfRDSPDServiceFieldSet = $("#fsDistrictOfRDSPDService" + programAndRelatedServiceTXID);
        var interpretingServicesCodeEelCodeValue = $("#ProgramAndRelatedServiceTXStateInterpretingServicesTypeCodeTXID" + programAndRelatedServiceTXID + "_code");
        var interpretingServicesCodeEelDescriptionValue = $("#ProgramAndRelatedServiceTXStateInterpretingServicesTypeCodeTXID" + programAndRelatedServiceTXID + "_description");
        var interpretingServicesID = $("#ProgramAndRelatedServiceTXStateInterpretingServicesTypeCodeTXID" + programAndRelatedServiceTXID + "_value");
        var pPCDServiceLocationCodeEelCodeValue = $("#ProgramAndRelatedServiceTXStatePPCDServiceLocationCodeTXID" + programAndRelatedServiceTXID + "_code");
        var pPCDServiceLocationCodeEelDescriptionValue = $("#ProgramAndRelatedServiceTXStatePPCDServiceLocationCodeTXID" + programAndRelatedServiceTXID + "_description");
        var pPCDServiceLocationID = $("#ProgramAndRelatedServiceTXStatePPCDServiceLocationCodeTXID" + programAndRelatedServiceTXID + "_value");
        var districtOfRDSPDServiceTextBoxValue = $("#ProgramAndRelatedServiceTXDistrictOfRDSPDService" + programAndRelatedServiceTXID);

        if (stateProgramAndRelatedServiceType.length > 0)
        {
            switch (stateProgramAndRelatedServiceType.toLowerCase())
            {
                case "interpreting services":
                    interpretingServicesFieldSet.show();
                    pPCDServiceLocationFieldSet.hide();
                    districtOfRDSPDServiceFieldSet.hide();
                    skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                    skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                    skyward.controls.setValue(pPCDServiceLocationID, "");
                    skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                    break;
                case "early childhood special education":
                    interpretingServicesFieldSet.hide();
                    pPCDServiceLocationFieldSet.show();
                    districtOfRDSPDServiceFieldSet.hide();
                    skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                    skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                    skyward.controls.setValue(interpretingServicesID, "");
                    skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                    break;
                case "receiving instructional services from rdspd":
                    interpretingServicesFieldSet.hide();
                    pPCDServiceLocationFieldSet.hide();
                    districtOfRDSPDServiceFieldSet.show();
                    skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                    skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                    skyward.controls.setValue(pPCDServiceLocationID, "");
                    skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                    skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                    skyward.controls.setValue(interpretingServicesID, "");
                    break;
                default:
                    interpretingServicesFieldSet.hide();
                    pPCDServiceLocationFieldSet.hide();
                    districtOfRDSPDServiceFieldSet.hide();
                    skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
                    skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
                    skyward.controls.setValue(pPCDServiceLocationID, "");
                    skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
                    skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
                    skyward.controls.setValue(interpretingServicesID, "");
                    skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
                    break;
            }
        }
        else
        {
            interpretingServicesFieldSet.hide();
            pPCDServiceLocationFieldSet.hide();
            districtOfRDSPDServiceFieldSet.hide();
            skyward.controls.setValue(pPCDServiceLocationCodeEelCodeValue, "");
            skyward.controls.setValue(pPCDServiceLocationCodeEelDescriptionValue, "");
            skyward.controls.setValue(pPCDServiceLocationID, "");
            skyward.controls.setValue(interpretingServicesCodeEelCodeValue, "");
            skyward.controls.setValue(interpretingServicesCodeEelDescriptionValue, "");
            skyward.controls.setValue(interpretingServicesID, "");
            skyward.controls.setValue(districtOfRDSPDServiceTextBoxValue, "");
        }
    };

    var events =
    {
        "initEntryWithdrawalSpecialProgramScript": initEntryWithdrawalSpecialProgramScript
    };

    return events;
});
//# sourceURL=skyward.ui.entrywithdrawalspecialprogram.js
;
(
    function (skyward, $, undefined)
    {
        skyward.academicStandardMaintenance = skyward.academicStandardMaintenance || {};
        var BROWSE_NAME = "AcademicStandardMaintenance";
        var DOV_NAME = "MaintainAcademicStandardsDOV";
        var GRADEBOOK_PATH = "Gradebook/CalculationGroup";
        var CURRICULUM_PATH = "Curriculum/Curriculum";
        var DETAILS_BROWSE_NAME = "detailsPanel_" + BROWSE_NAME;
        var READONLY_BROWSE_NAME = "AcademicStandardMaintenanceReadOnly";
        var DETAILS_READONLY_BROWSE_NAME = "detailsPanel_" + READONLY_BROWSE_NAME;
        var init = function (selector)
        {
            var academicStandardMaintenanceContainer = $(selector).find(".academicStandardMaintenance");
            if (academicStandardMaintenanceContainer.length == 0)
            {
                return;
            }

            var isInDetailsPanel = academicStandardMaintenanceContainer.attr("id").indexOf("detailsPanel_") > -1;

            var updateMaintenanceBrowseAjaxRequest = null;

            var sharedUpdateAcademicStandardMaintenanceBrowse = function (data, url, browseParentSelector, browseSelector, browseName)
            {
                $(".academicStandardAtLevelFilter").each(function ()
                {
                    var academicStandardAtLevelFilter = $(this);
                    data[academicStandardAtLevelFilter.attr("id")] = academicStandardAtLevelFilter.find(".dmsBackingData").val()
                });

                updateMaintenanceBrowseAjaxRequest = $.ajax({
                    url: url,
                    type: "POST",
                    dataType: "viewparthtml",
                    data: data,
                    activityIndicator: { silent: true },
                    success: function (browse)
                    {
                        var browseParentDiv = $(browseParentSelector)
                        var browseID = browseParentDiv.attr('id');

                        if (browseParentDiv.parents("#detailsPanel").length > 0)
                        {
                            browse = $(browse);
                            browse.find(`#${browseName}`).addBack(`#${browseName}`).attr("id", `detailsPanel_${browseName}`);
                        }
                        browseParentDiv.html(browse);
                        skyward.window.notifyDOMLoad('#' + browseID);
                        updateMaintenanceBrowseAjaxRequest = null;
                    }
                });            
                return updateMaintenanceBrowseAjaxRequest;
            };

            var readOnlyBrowseElement = skyward.browse.browseList[READONLY_BROWSE_NAME] !== undefined ? skyward.browse.browseList[READONLY_BROWSE_NAME] : skyward.browse.browseList[DETAILS_READONLY_BROWSE_NAME];

            if (readOnlyBrowseElement)
            {
                var preUpdateReadOnlyMaintenanceBrowse = function ()
                {
                    if (updateMaintenanceBrowseAjaxRequest)
                    {
                        updateMaintenanceBrowseAjaxRequest.abort();
                    }

                    var data = {
                        pageModule: readOnlyBrowseElement.pageModule,
                        pageObject: readOnlyBrowseElement.pageObject,
                        pageScreen: readOnlyBrowseElement.pageScreen,
                        taskName: readOnlyBrowseElement.taskName,
                        academicSetID: $('#AcademicStandardSetFilter').val(),
                        academicSubjectIDs: $('#AcademicStandardSubjectFilterData').val(),
                        academicGradeRangeIDs: $('#AcademicStandardGradeRangeFilterData').val(),
                        renderInDetailsPanel: isInDetailsPanel
                    };
                    
                    var url = skyward.global.virtualDir + readOnlyBrowseElement.pageModule + "/" + readOnlyBrowseElement.pageObject + "/UpdateAcademicStandardMaintenanceReadOnlyBrowse";
                    var browseParentSelector = '#' + (isInDetailsPanel ? DETAILS_READONLY_BROWSE_NAME : READONLY_BROWSE_NAME);
                    var browseSelector = '.browse';

                    sharedUpdateAcademicStandardMaintenanceBrowse(data, url, browseParentSelector, browseSelector, READONLY_BROWSE_NAME);
                };

                $(selector).find('.academicStandardMaintenanceFilterDiv').debounce('change', '.academicMaintenanceFilter > .dmsBackingData', preUpdateReadOnlyMaintenanceBrowse);
            }

            var maintainAcademicStandardsDOV = $(selector).find("#" + DOV_NAME);
            if (maintainAcademicStandardsDOV.length == 0)
            {
                return;
            }

            maintainAcademicStandardsDOV.data().selectAllWithChildrenIds = {};
            maintainAcademicStandardsDOV.data().deselectAllWithChildrenIds = {};
            maintainAcademicStandardsDOV.data().childAcademicStandardIDsToExcludeFromSelectAll = [];
            maintainAcademicStandardsDOV.data().selectedStandardIDs = [];

            var selectWithChildrenHandler =
            {
                checkChildStandardsAtLevel: function (academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                {
                    var academicStandardCheckboxTableCell = maintainAcademicStandardsDOV.find("td[data-academic-standard-id='" + academicStandardIDAtLevel + "']");
                    if (academicStandardCheckboxTableCell.length > 0)
                    {
                        var fullKey = academicStandardCheckboxTableCell.data().fullKey;
                        var childStandards = selectWithChildrenHandler.findChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel);
                        selectWithChildrenHandler.applySelectAllClassToCheckboxes(childStandards.add(academicStandardCheckboxTableCell));
                        selectWithChildrenHandler.checkChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude);
                    }
                },
                checkChildStandardsByParentFullKey: function (fullKey, academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                {
                    selectWithChildrenHandler.selectIndividualStandard(academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey);
                    var childStandards = selectWithChildrenHandler.findChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel);

                    $.each(childStandards, function ()
                    {
                        var childStandardTD = $(this);
                        var childAcademicStandardID = childStandardTD.data().academicStandardId;
                        selectWithChildrenHandler.selectIndividualStandard(childAcademicStandardID, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey);
                    });
                },
                findChildStandardsByParentFullKey: function(fullKey, academicStandardIDAtLevel)
                {
                    return maintainAcademicStandardsDOV.find("td[data-full-key^='" + fullKey + "']:not([data-academic-standard-id='" + academicStandardIDAtLevel + "'])");
                },
                applySelectAllClassToCheckboxes: function(childStandards)
                {
                    $.each(childStandards, function ()
                    {
                        var childStandardTD = $(this);
                        childStandardTD.find('input[type="checkbox"]').addClass('isFromSelectAll');
                    });
                },
                selectIndividualStandard: function (academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey)
                {
                    selectWithChildrenHandler.removeStandardFromDeselectAllList(academicStandardIDAtLevel);

                    if (!skipRemoveIndividualExclude)
                    {
                        selectWithChildrenHandler.removeIndividualExcludeStandard(academicStandardIDAtLevel);
                    }

                    if ($.inArray(academicStandardIDAtLevel, academicStandardIDsToExclude) == -1)
                    {
                        var academicStandardCheckboxAtLevel = maintainAcademicStandardsDOV.find("td[data-academic-standard-id='" + academicStandardIDAtLevel + "'] input.checkbox");
                        if (academicStandardCheckboxAtLevel.length > 0)
                        {
                            skyward.controls.setValue(academicStandardCheckboxAtLevel, true);
                            selectWithChildrenHandler.toggleChildrenIcon(academicStandardCheckboxAtLevel);
                        }

                        var selectAllWithChildrenIds = maintainAcademicStandardsDOV.data().selectAllWithChildrenIds;
                        if (fullKey && (!academicStandardIDsToExclude || $.inArray(academicStandardIDAtLevel, academicStandardIDsToExclude) == -1) &&
                            $.inArray(academicStandardIDAtLevel, selectAllWithChildrenIds) == -1)
                        {
                            selectAllWithChildrenIds[academicStandardIDAtLevel] = fullKey;
                            selectWithChildrenHandler.updateSelectAllWithChildrenIdsValue(selectAllWithChildrenIds);
                        }
                    }
                },
                uncheckChildStandardsAtLevel: function (academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                {
                    var academicStandardCheckboxTableCell = maintainAcademicStandardsDOV.find("td[data-academic-standard-id='" + academicStandardIDAtLevel + "']");
                    if (academicStandardCheckboxTableCell)
                    {
                        var fullKey = academicStandardCheckboxTableCell.data().fullKey;
                        var childStandards = selectWithChildrenHandler.findChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel);
                        selectWithChildrenHandler.applySelectAllClassToCheckboxes(childStandards.add(academicStandardCheckboxTableCell));
                        selectWithChildrenHandler.uncheckChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                    }
                },
                uncheckChildStandardsByParentFullKey: function (fullKey, academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude)
                {
                    selectWithChildrenHandler.deselectIndividualStandard(academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey);
                    var childStandards = selectWithChildrenHandler.findChildStandardsByParentFullKey(fullKey, academicStandardIDAtLevel);

                    $.each(childStandards, function ()
                    {
                        var childStandardTD = $(this);
                        var childAcademicStandardID = childStandardTD.data().academicStandardId;
                        selectWithChildrenHandler.deselectIndividualStandard(childAcademicStandardID, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey);
                    });
                },
                deselectIndividualStandard: function (academicStandardIDAtLevel, academicStandardIDsToExclude, skipRemoveIndividualExclude, fullKey)
                {
                    selectWithChildrenHandler.removeStandardFromSelectAllList(academicStandardIDAtLevel);

                    if (!skipRemoveIndividualExclude)
                    {
                        selectWithChildrenHandler.removeIndividualExcludeStandard(academicStandardIDAtLevel);
                    }

                    var academicStandardCheckboxAtLevel = maintainAcademicStandardsDOV.find("td[data-academic-standard-id='" + academicStandardIDAtLevel + "'] input.checkbox");
                    if (academicStandardCheckboxAtLevel.length > 0)
                    {
                        skyward.controls.setValue(academicStandardCheckboxAtLevel, false);
                        selectWithChildrenHandler.toggleChildrenIcon(academicStandardCheckboxAtLevel);
                    }

                    var deselectAllWithChildrenIds = maintainAcademicStandardsDOV.data().deselectAllWithChildrenIds;
                    if (fullKey && (!academicStandardIDsToExclude || $.inArray(academicStandardIDAtLevel, academicStandardIDsToExclude) == -1))
                    {
                        if ($.inArray(academicStandardIDAtLevel, deselectAllWithChildrenIds) == -1)
                        {
                            deselectAllWithChildrenIds[academicStandardIDAtLevel] = fullKey;
                            selectWithChildrenHandler.updateDeSelectAllWithChildrenIdsValue(deselectAllWithChildrenIds);
                        }
                    }
                },
                defaultRequiredChildAcademicStandards: function ()
                {
                    var dovData = maintainAcademicStandardsDOV.data();
                    var selectAllList = dovData.selectAllWithChildrenIds;
                    var deselectAllList = dovData.deselectAllWithChildrenIds;

                    var dirtyInputsToSkipSelectAllLogic = dovData.childAcademicStandardIDsToExcludeFromSelectAll;

                    if (selectAllList)
                    {
                        for (var standardID in selectAllList)
                        {
                            var fullKey = selectAllList[standardID];
                            selectWithChildrenHandler.checkChildStandardsByParentFullKey(fullKey, standardID, dirtyInputsToSkipSelectAllLogic, true);
                        }
                    }

                    if (deselectAllList)
                    {
                        for (var standardID in deselectAllList)
                        {
                            var fullKey = deselectAllList[standardID];
                            selectWithChildrenHandler.uncheckChildStandardsByParentFullKey(fullKey, standardID, dirtyInputsToSkipSelectAllLogic, true);
                        }
                    }
                },
                defaultSelectedStandards: function ()
                {
                    var dovData = maintainAcademicStandardsDOV.data();
                    selectedStandardIDs = dovData.selectedStandardIDs;
                    if (selectedStandardIDs && selectedStandardIDs.length > 0)
                    {
                        for (var i = 0; i < selectedStandardIDs.length; i++)
                        {
                            selectWithChildrenHandler.selectIndividualStandard(selectedStandardIDs[i], dovData.childAcademicStandardIDsToExcludeFromSelectAll, true);
                        }
                    }
                },
                //returns whether or not it was successful
                toggleChildrenIcon: function (academicStandardCheckboxAtLevel)
                {
                    var cell = academicStandardCheckboxAtLevel.parents("td");

                    var selectChildrenCell = maintainAcademicStandardsDOV.find("td[data-select-all-with-children-academic-standard-id='" + cell.data().academicStandardId + "']");

                    var isCurrentlyChecked = academicStandardCheckboxAtLevel.is(":checked");
                    if (!selectChildrenCell.hasClass("deselect") && isCurrentlyChecked)
                    {
                        if (!selectChildrenCell.find(".svg.deselectAcademicStandardWithChildren").length && selectChildrenCell.find(".svg.selectAcademicStandardWithChildren").length > 0)
                        {
                            //Only copy icon if there is a select icon, if there isn't a select icon then its the lowest level and there shouldn't be an icon
                            selectWithChildrenHandler.copyDeselectIconToCell(selectChildrenCell);
                        }

                        selectChildrenCell.find(".svg.selectAcademicStandardWithChildren").hide();
                        selectChildrenCell.find(".svg.deselectAcademicStandardWithChildren").show();
                        selectChildrenCell.addClass("deselect");
                    }
                    else if (!isCurrentlyChecked)
                    {
                        selectChildrenCell.find(".svg.selectAcademicStandardWithChildren").show();
                        selectChildrenCell.find(".svg.deselectAcademicStandardWithChildren").hide();
                        selectChildrenCell.removeClass("deselect");
                    }
                    else
                    {
                        return false;
                    }

                    return true;
                },
                updateChildAcademicStandardIDsToExcludeFromSelectAllValue: function (childAcademicStandardIDsToExcludeFromSelectAll)
                {
                    $("#MaintainAcademicStandardsDOV_ChildAcademicStandardIDsToExcludeFromSelectAll").val(JSON.stringify(childAcademicStandardIDsToExcludeFromSelectAll));
                },
                updateSelectAllWithChildrenIdsValue: function (selectAllWithChildrenIds)
                {
                    $("#MaintainAcademicStandardsDOV_SelectAllWithChildrenIds").val(JSON.stringify(selectAllWithChildrenIds));
                },
                updateDeSelectAllWithChildrenIdsValue: function (deselectAllWithChildrenIds)
                {
                    $("#MaintainAcademicStandardsDOV_DeSelectAllWithChildrenIds").val(JSON.stringify(deselectAllWithChildrenIds));
                },
                updateAllSelectedIdsValue: function (deselectAllWithChildrenIds)
                {
                    $("#MaintainAcademicStandardsDOV_AllSelectedIds").val(JSON.stringify(deselectAllWithChildrenIds));
                },
                removeIndividualExcludeStandard: function (academicStandardID)
                {
                    var childAcademicStandardIDsToExcludeFromSelectAll = maintainAcademicStandardsDOV.data().childAcademicStandardIDsToExcludeFromSelectAll;

                    var index = childAcademicStandardIDsToExcludeFromSelectAll.indexOf(academicStandardID);

                    if (index > -1)
                    {
                        childAcademicStandardIDsToExcludeFromSelectAll.splice(index, 1);
                    }

                    selectWithChildrenHandler.updateChildAcademicStandardIDsToExcludeFromSelectAllValue(childAcademicStandardIDsToExcludeFromSelectAll);
                },
                addIndividualExcludeStandard: function (academicStandardID)
                {
                    var childAcademicStandardIDsToExcludeFromSelectAll = maintainAcademicStandardsDOV.data().childAcademicStandardIDsToExcludeFromSelectAll;

                    var index = childAcademicStandardIDsToExcludeFromSelectAll.indexOf(academicStandardID);

                    if (!(index > -1))
                    {
                        childAcademicStandardIDsToExcludeFromSelectAll.push(academicStandardID);
                        selectWithChildrenHandler.updateChildAcademicStandardIDsToExcludeFromSelectAllValue(childAcademicStandardIDsToExcludeFromSelectAll)
                    }
                },
                removeStandardFromDeselectAllList: function (academicStandardID)
                {
                    var deselectAllWithChildrenIds = maintainAcademicStandardsDOV.data().deselectAllWithChildrenIds;

                    delete deselectAllWithChildrenIds[academicStandardID];

                    selectWithChildrenHandler.updateDeSelectAllWithChildrenIdsValue(deselectAllWithChildrenIds);
                },
                removeStandardFromSelectAllList: function (academicStandardID)
                {
                    var selectAllWithChildrenIds = maintainAcademicStandardsDOV.data().selectAllWithChildrenIds;

                    delete selectAllWithChildrenIds[academicStandardID];

                    selectWithChildrenHandler.updateSelectAllWithChildrenIdsValue(selectAllWithChildrenIds);
                },
                removeStandardFromSelectedIDsList: function (academicStandardID)
                {
                    var selectedIDs = maintainAcademicStandardsDOV.data().selectedStandardIDs;

                    var index = selectedIDs.indexOf(academicStandardID);

                    if (index > -1)
                    {
                        selectedIDs.splice(index, 1);
                    }

                    selectWithChildrenHandler.removeStandardFromSelectAllList(academicStandardID);
                    selectWithChildrenHandler.updateAllSelectedIdsValue(selectedIDs);
                },
                addStandardToSelectedIDsList: function (academicStandardID)
                {
                    var selectedIDs = maintainAcademicStandardsDOV.data().selectedStandardIDs;

                    var index = selectedIDs.indexOf(academicStandardID);

                    if (!(index > -1))
                    {
                        selectedIDs.push(academicStandardID);
                        selectWithChildrenHandler.updateAllSelectedIdsValue(selectedIDs)
                    }
                },
                copyDeselectIconToCell: function (td)
                {
                    var deselectIcon = skyward.svg.getSvg("Reselect");
                    deselectIcon.addClass("deselectAcademicStandardWithChildren svg");
                    deselectIcon.removeClass("svgHidden");
                    deselectIcon.appendTo(td.find("div"));
                },
                setup: function()
                {
                    $("body").off("browseLoaded." + BROWSE_NAME).on("browseLoaded." + BROWSE_NAME, function ()
                    {
                        selectWithChildrenHandler.defaultRequiredChildAcademicStandards();
                        selectWithChildrenHandler.defaultSelectedStandards();
                    });

                    maintainAcademicStandardsDOV.on("click", "td[data-select-all-with-children='true']:not(.deselect)", function ()
                    {
                        var td = $(this);

                        if (td.find("svg:not(.svgHidden)").length < 1)
                        {
                            return;
                        }
                        var tdData = td.data();
                        var academicStandardID = tdData.selectAllWithChildrenAcademicStandardId;

                        selectWithChildrenHandler.checkChildStandardsAtLevel(academicStandardID, tdData.childAcademicStandardIDsToExcludeFromSelectAll);
                    });

                    maintainAcademicStandardsDOV.on("click", "td[data-select-all-with-children='true'].deselect", function ()
                    {
                        var td = $(this);

                        if (td.find("svg:not(.svgHidden)").length < 1)
                        {
                            return;
                        }
                        var tdData = td.data();
                        var academicStandardID = tdData.selectAllWithChildrenAcademicStandardId;

                        selectWithChildrenHandler.uncheckChildStandardsAtLevel(academicStandardID, tdData.childAcademicStandardIDsToExcludeFromSelectAll);
                    });

                    maintainAcademicStandardsDOV.on("change", ".selectAcademicStandard", function (event)
                    {
                        var checkbox = $(this);
                        var td = checkbox.parents("td").first();
                        var standardID = td.data().academicStandardId;
                        if (standardID && checkbox[0].checked)
                        {
                            selectWithChildrenHandler.addStandardToSelectedIDsList(standardID);
                        }
                        else
                        {
                            selectWithChildrenHandler.removeStandardFromSelectedIDsList(standardID);
                        }

                        if (checkbox.hasClass('isFromSelectAll'))
                        {
                            //this means it was triggered from the mass select with children. 
                            //we only want to keep track of individual ones
                            checkbox.removeClass('isFromSelectAll');
                            event.stopPropagation();
                            event.preventDefault();
                            return;
                        }
                        if (standardID && !checkbox[0].checked)
                        {
                            selectWithChildrenHandler.addIndividualExcludeStandard(standardID);
                        }
                        else
                        {
                            selectWithChildrenHandler.removeIndividualExcludeStandard(standardID);
                        }
                    });
                }
            };

            selectWithChildrenHandler.setup();

            var changeAcademicStandardFilters = function ()
            {
                var browseName = $(this).parents('#' + DOV_NAME).find('.editablebrowse').attr('id');
                if (browseName.length == null)
                {
                    return;
                }
                clearAcademicStandardFilters();
                reloadLevelSpecificAcademicStandardFilters();
            };

            var clearAcademicStandardFilters = function ()
            {
                $('.academicMaintenanceFilter:not(#AcademicStandardSetFilter)').each(function ()
                {
                    var filter = $(this);
                    filter.trigger('clearAll');
                });
            };

            var reloadLevelSpecificAcademicStandardFilters = function () {
                $.ajax({
                    url: skyward.global.virtualDir + ((skyward.browse.browseList[BROWSE_NAME].data.CalculationGroupID !== undefined) ? GRADEBOOK_PATH : CURRICULUM_PATH) + "/GetAcademicStandardFiltersForEachLevel",
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true },
                    data: 
                    {
                        academicSetID: $('#AcademicStandardSetFilter').val()
                    },
                    success: function (html)
                    {
                        $(".academicStandardFilterAtLevelFieldset").each(function ()
                        {
                            var filterAtLevel = $(this);
                            filterAtLevel.remove();
                        });

                        $(".academicStandardMaintenanceFilterDiv").append(html);
                        skyward.window.notifyDOMLoad(".academicStandardMaintenanceFilterDiv");
                    }
                });
            };
            
            var preUpdateAcademicStandardMaintenanceBrowse = function ()
            {
                if (updateMaintenanceBrowseAjaxRequest)
                {
                    updateMaintenanceBrowseAjaxRequest.abort();
                }
                
                updateAcademicStandardMaintenanceBrowse();
                
            };

            var updateAcademicStandardMaintenanceBrowse = function ()
            {
                var browseElement = skyward.browse.browseList[BROWSE_NAME] !== undefined ? skyward.browse.browseList[BROWSE_NAME] : skyward.browse.browseList["detailsPanel_" + BROWSE_NAME];
                var browseData = $("#" + BROWSE_NAME).data();
                var includeExistingRecords = true;
                if (browseData && browseData.includeExistingRecords != null)
                {
                    includeExistingRecords = browseData.includeExistingRecords;
                }
                var data = {
                    pageModule: browseElement.pageModule,
                    pageObject: browseElement.pageObject,
                    pageScreen: browseElement.pageScreen,
                    taskName: browseElement.taskName,
                    curriculumID: browseElement.data.CurriculumID,
                    calculationGroupID: browseElement.data.CalculationGroupID,
                    academicSetIDs: $('#AcademicStandardSetFilter').val(),
                    academicSubjectIDs: $('#AcademicStandardSubjectFilterData').val(),
                    academicGradeRangeIDs: $('#AcademicStandardGradeRangeFilterData').val(),
                    includeExistingRecords: includeExistingRecords,
                    renderInDetailsPanel: isInDetailsPanel
                };

                var url = skyward.global.virtualDir + ((browseElement.data.CalculationGroupID !== undefined) ? GRADEBOOK_PATH : CURRICULUM_PATH) + "/UpdateAcademicStandardMaintenanceBrowse";
                var browseParentSelector = (browseElement.data.CalculationGroupID !== undefined) ? '#' + BROWSE_NAME + 'Div' : '#' + BROWSE_NAME + 'Div';
                var browseSelector = '.editablebrowse';

                return sharedUpdateAcademicStandardMaintenanceBrowse(data, url, browseParentSelector, browseSelector, BROWSE_NAME);
            }

            $(selector).find('#AcademicStandardSetFilter').on('change', changeAcademicStandardFilters);
            $(selector).find('.academicStandardMaintenanceFilterDiv').debounce('change', '.academicMaintenanceFilter > .dmsBackingData', preUpdateAcademicStandardMaintenanceBrowse);
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.massassignschedulingteams = skyward.massassignschedulingteams || {};

        var browseName = 'TempSchedulingTeamGradeReference';
        var isOverrideFieldName = "IsOverride";
        var overrideByFieldName = "OverrideBy";
        var toBeAssignedCountInputIDPrefix = "OverrideTotalToBeAssignedCount";
        var toBeAssignedPercentInputIDPrefix = "OverrideTotalToBeAssignedPercent";
        var toBeAssignedCode = "* Totals";
        var unassignedCode = "* Unassigned";

        var overrideCheckbox;
        var overrideByRadioSet;
        var overrideByValue;
        var isOverride = false;

        var totalObject;
        var unassignedObject;
        var teamObjects = new Array();
        var teamObjectIndexByTeamIDIndex = new Array();

        var totalStudentsToProcess = 0;
        var totalStudentsNeedToBeAssigned = 0;

        var columnOrder =
        {
            code: 0,
            descripiton: 1,
            maxcount: 2,
            currentcount: 3,
            totaltobeassigned: 4,
            totaltobeassignedpercent: 5,
            overridetotaltobeassigned: 6,
            overridetotaltobeassignedpercent: 7,
            totalstudents: 8
        };

        var init = function (selector) { totalObject = undefined; unassignedObject = undefined; teamObjects = new Array(); overrideCheckbox = undefined; overrideByRadioSet = undefined; };

        skyward.massassignschedulingteams.overrideEventHandler = function ()
        {
            if (overrideCheckbox == undefined)
            {
                overrideCheckbox = $("#" + isOverrideFieldName);
                totalStudentsToProcess = getBaseTenIntValue($("#TotalNumberOfStudentsSelected").val());
                totalStudentsNeedToBeAssigned = getBaseTenIntValue($("#TotalStudentsNeedToBeAssigned").val());
            }

            if (overrideCheckbox.prop('checked'))
            {
                isOverride = true;
                getInputElements();
                getOverrideRadioSet();
                if (overrideByRadioSet != undefined)
                {
                    skyward.controls.enable(overrideByRadioSet)
                }
                getOverrideByValueAndToggleInputEditable();
            }
            else
            {
                if (overrideByRadioSet != undefined)
                {
                    skyward.controls.disable(overrideByRadioSet)
                }
                isOverride = false;
                overrideByValue = "";
                toggleInputEditable();
            }
        };

        skyward.massassignschedulingteams.countBlurEventHandler = function(event)
        {
            var input = $(this);
            var id = getTeamID(input.attr("id"));
            var index = teamObjectIndexByTeamIDIndex[id];

            var newValue = 0;

            if (skyward.extensions.isNumeric(input.val()))
            {
                newValue = getBaseTenIntValue(input.val());
            }
            else //user didn't enter a value, set it to 0
            {
                teamObjects[index].countInput.val(newValue);
            }

            var oldValue = teamObjects[index].previousMaxToBeAssignedOverrideValue;;

            if (newValue == oldValue)
            {
                return;
            }

            //recalculate the team percentage
            var newPercentValue = checkTotalsForPercentAdjustment(index, getNewPercent(newValue));
            teamObjects[index].percentInput.val(newPercentValue);

            //update the team counts
            var newTotal = teamObjects[index].currentCount + newValue;
            teamObjects[index].totalStudentDiv.text(newTotal);
            teamObjects[index].previousMaxToBeAssignedOverrideValue = newValue;
            teamObjects[index].previousMaxToBeAssignedOverridePercentValue = newPercentValue;

            updateUnassignedAndTotal();
        }

        skyward.massassignschedulingteams.percentBlurEventHandler = function (event)
        {
            var input = $(this);
            var id = getTeamID(input.attr("id"));
            var index = teamObjectIndexByTeamIDIndex[id];

            var newValue = 0;
            if (skyward.extensions.isNumeric(input.val()))
            {
                newValue = getBaseTenIntValue(input.val());
            }

            //format the value
            teamObjects[index].percentInput.val(newValue);

            var oldValue = teamObjects[index].previousMaxToBeAssignedOverridePercentValue;
            if (newValue == oldValue)
            {
                return;
            }

            //recalculate the team count
            var newCountValue = checkTotalsForCountAdjustment(index, Math.round(totalStudentsNeedToBeAssigned * (newValue / 100)));
            teamObjects[index].countInput.val(newCountValue);
            teamObjects[index].countInput.trigger("change");

            //update the team counts
            var newTotal = teamObjects[index].currentCount + newCountValue;
            teamObjects[index].totalStudentDiv.text(newTotal);
            teamObjects[index].previousMaxToBeAssignedOverrideValue = newCountValue;
            teamObjects[index].previousMaxToBeAssignedOverridePercentValue = newValue;

            updateUnassignedAndTotal();
        }

        skyward.massassignschedulingteams.overrideByChangeEventHandler = function(event)
        {
            if (!isOverride)
            {
                return;
            }

            getOverrideByValueAndToggleInputEditable();
        }

        var checkTotalsForCountAdjustment = function(index, count)
        {
            var countSum = 0;
            var percentSum = 0;

            jQuery.each(teamObjects, function (i, team)
            {
                if (i == index)
                {
                    countSum += count;
                }
                else
                {
                    countSum += getBaseTenIntValue(team.countInput.val());
                }
                percentSum += Math.round(team.percentInput.val());
            })

            if (percentSum == 100)
            {
                if (countSum < totalStudentsNeedToBeAssigned)
                {
                    return count + (totalStudentsNeedToBeAssigned - countSum);
                }
                else
                {
                    return count - (countSum - totalStudentsNeedToBeAssigned);
                }
            }

            return count;
        }

        var checkTotalsForPercentAdjustment = function(index, percent)
        {
            var countSum = 0;
            var percentSum = 0;

            jQuery.each(teamObjects, function (i, team)
            {
                if (i == index)
                {
                    percentSum += percent;
                }
                else
                {
                    percentSum += Math.round(team.percentInput.val());
                }

                countSum += getBaseTenIntValue(team.countInput.val())
            })

            if (percentSum == 100 && countSum != totalStudentsNeedToBeAssigned)
            {
                if (countSum < totalStudentsNeedToBeAssigned)
                {
                    return percent - Math.round(countSum / totalStudentsNeedToBeAssigned);
                }
                else
                {
                    return percent + Math.round(countSum / totalStudentsNeedToBeAssigned);
                }
            }

            return percent;
        }

        var updateUnassignedAndTotal = function()
        {
            var countSum = 0;
            var percentSum = 0;
            var totalStudents = 0;

            jQuery.each(teamObjects, function (i, team)
            {
                countSum += getBaseTenIntValue(team.countInput.val());
                percentSum += Math.round(team.percentInput.val());
                totalStudents += getBaseTenIntValue(team.totalStudentDiv.text());
            })

            var newUnassignedCount = 0;
            var newUnassignedCountPercent = 0;
            var accumulatedPercentSum = percentSum;

            if (unassignedObject != undefined)
            {
                var tempUnassignCount = totalStudentsNeedToBeAssigned - countSum;
                if (tempUnassignCount > 0)
                {
                    newUnassignedCount = totalStudentsNeedToBeAssigned - countSum;
                }
                var newUnassignedCountPercent = getNewPercent(newUnassignedCount);
                var tempUnassignCountPct = newUnassignedCountPercent;

                var tempSum = accumulatedPercentSum + tempUnassignCountPct;
                if (tempSum != 100)
                {
                    if (tempSum < 100)
                    {
                        newUnassignedCountPercent = tempUnassignCountPct + (100 - tempSum);
                    }
                    else
                    {
                        newUnassignedCountPercent = tempUnassignCountPct - (tempSum - 100)
                    }

                    if (newUnassignedCountPercent < 0)
                    {
                        newUnassignedCountPercent = 0;
                    }
                }

                unassignedObject.countInput.val(newUnassignedCount);
                unassignedObject.percentInput.val(newUnassignedCountPercent);
                unassignedObject.totalStudentDiv.text(newUnassignedCount);
                unassignedObject.previousMaxToBeAssignedOverrideValue = newUnassignedCount;
                unassignedObject.previousMaxToBeAssignedOverridePercentValue = newUnassignedCountPercent;
            }

            var accummulatedPercentSum = percentSum + newUnassignedCountPercent;
            var accummulatedCountSum = countSum + newUnassignedCount;

            totalObject.countInput.val(accummulatedCountSum);
            totalObject.percentInput.val(accummulatedPercentSum);
            totalObject.totalStudentDiv.text(totalStudents);
            totalObject.previousMaxToBeAssignedOverrideValue = accummulatedCountSum;
            totalObject.previousMaxToBeAssignedOverridePercentValue = accummulatedPercentSum;
        }

        var getNewPercent = function (newCount)
        {
            if (totalStudentsNeedToBeAssigned > 0)
            {
                return Math.round((newCount / totalStudentsNeedToBeAssigned) * 100);
            }

            return 0;
        }

        var getBaseTenIntValue = function(value)
        {
            return parseInt(value, 10);
        }

        var getTeamID = function (inputID)
        {
            return inputID.split("-")[1];
        }

        var getOverrideByValueAndToggleInputEditable = function()
        {
            overrideByValue = skyward.controls.getValue(overrideByRadioSet);
            toggleInputEditable();
        }

        var toggleInputEditable = function ()
        {
            var initializeValues = false;
            jQuery.each(teamObjects, function(i, team)
            {
                if (isOverride && overrideByValue.toLowerCase() == "c")
                {
                    initializeValues = true;
                    skyward.controls.enable(team.countInput);
                    skyward.controls.disable(team.percentInput);
                }
                else if (isOverride && overrideByValue.toLowerCase() == "p")
                {
                    initializeValues = true;
                    skyward.controls.enable(team.percentInput);
                    skyward.controls.disable(team.countInput);
                }
                else
                {
                    skyward.controls.disable(team.countInput);
                    skyward.controls.disable(team.percentInput);
                }

                if (initializeValues)
                {
                    team.countInput.val(team.previousMaxToBeAssignedOverrideValue);
                    team.countInput.trigger("change");
                    team.percentInput.val(team.previousMaxToBeAssignedOverridePercentValue);
                }
                else
                {
                    team.countInput.val("");
                    team.percentInput.val("");
                    team.totalStudentDiv.text(team.totalStudentOriginalValue);
                }
            })

            if (initializeValues)
            {
                totalObject.countInput.val(totalObject.previousMaxToBeAssignedOverrideValue);
                totalObject.percentInput.val(totalObject.previousMaxToBeAssignedOverridePercentValue);

                unassignedObject.countInput.val(unassignedObject.previousMaxToBeAssignedOverrideValue);
                unassignedObject.percentInput.val(unassignedObject.previousMaxToBeAssignedOverridePercentValue);
            }
            else
            {
                totalObject.countInput.val("");
                totalObject.percentInput.val("");
                totalObject.totalStudentDiv.text(totalObject.totalStudentOriginalValue);

                unassignedObject.countInput.val("");
                unassignedObject.percentInput.val("");
                unassignedObject.totalStudentDiv.text(unassignedObject.totalStudentOriginalValue);
            }
        }

        var getOverrideRadioSet = function ()
        {
            if (overrideByRadioSet == undefined)
            {
                overrideByRadioSet = $("#" + overrideByFieldName);
                if (overrideByRadioSet.length)
                {
                    var name = overrideByRadioSet.attr("id");
                    var radioButtonSelector = 'input:radio[name="' + name + 'child"]';
                    var radioButtons = $(radioButtonSelector);
                    radioButtons.change(skyward.massassignschedulingteams.overrideByChangeEventHandler);
                }
            }
        };

        var getInputElements = function ()
        {
            if (totalObject == undefined)
            {
                $(":input[id^='" + toBeAssignedCountInputIDPrefix + "']").each(function()
                {
                    var countInput = $(this);
                    var id = countInput.attr('id');
                    var code;
                    var percentInput;
                    var maxCount = 0;
                    var currentCount = 0;
                    var totalToBeAssigned = 0;
                    var totalToBeAssignedPercent = 0.0;
                    var totalStudentDiv;

                    var isTotal = false;
                    var isUnassigned = false;
                    var isTeam = false;

                    var countInputTD = countInput.closest('td');
                    var parentTR = countInputTD.parent();

                    parentTR.children().each(function()
                    {
                        var child = $(this);

                        if (!child.is(countInputTD))
                        {
                            var column = getBaseTenIntValue(child.data("column"));

                            child.children().each(function ()
                            {
                                if ($(this).is('div'))
                                {
                                    var div = $(this);

                                    switch (column)
                                    {
                                        case columnOrder.code:
                                        {
                                            code = div.text();

                                            if (div.text() == toBeAssignedCode)
                                            {
                                                isTotal = true;
                                            }
                                            else if (div.text() == unassignedCode)
                                            {
                                                isUnassigned = true;
                                            }
                                            else
                                            {
                                                isTeam = true;
                                            }
                                            break;
                                        }
                                        case columnOrder.maxcount:
                                        {
                                            maxCount = div.text();
                                            break;
                                        }
                                        case columnOrder.currentcount:
                                        {
                                            currentCount = div.text();
                                            break;
                                        }
                                        case columnOrder.totaltobeassigned:
                                        {
                                            totalToBeAssigned = div.text();
                                            break;
                                        }
                                        case columnOrder.totaltobeassignedpercent:
                                        {
                                            totalToBeAssignedPercent = div.text();
                                            break;
                                        }
                                        case columnOrder.overridetotaltobeassignedpercent:
                                        {
                                            div.children().each(function ()
                                            {
                                                if ($(this).is("input[type='text']"))
                                                {
                                                    percentInput = $(this)
                                                }
                                            });
                                            break;
                                        }
                                        case columnOrder.totalstudents:
                                        {
                                            totalStudentDiv = div;
                                            break;
                                        }
                                    }
                                }
                            })
                        }
                    })

                    var object = createTotalObject(id, code, maxCount, currentCount, totalToBeAssigned, totalToBeAssignedPercent, countInput, percentInput, totalStudentDiv, isTeam);

                    if (isTotal)
                    {
                        totalObject = object
                    }
                    else if (isUnassigned)
                    {
                        unassignedObject = object;
                    }
                    else
                    {
                        teamObjectIndexByTeamIDIndex[getTeamID(id)] = teamObjects.push(object) - 1;
                    }
                });
            }
        };

        var createTotalObject = function (id, code, maxCount, currentCount, totalToBeAssigned, totalToBeAssignedPercent, countInput, percentInput, totalStudentDiv, isTeam)
        {
            var maxToBeAssignedOverrideValue = 0;
            var maxToBeAssignedOverridePercentValue = 0;

            maxCount = getBaseTenIntValue(maxCount);
            currentCount = getBaseTenIntValue(currentCount);

            if (isTeam)
            {
                countInput.off("blur", skyward.massassignschedulingteams.countBlurEventHandler).on("blur", skyward.massassignschedulingteams.countBlurEventHandler);
                percentInput.off("blur", skyward.massassignschedulingteams.percentBlurEventHandler).on("blur", skyward.massassignschedulingteams.percentBlurEventHandler);

                maxToBeAssignedOverrideValue = maxCount - currentCount;

                if (totalStudentsNeedToBeAssigned > 0)
                {
                    tempMaxPercent = maxToBeAssignedOverrideValue / totalStudentsNeedToBeAssigned;
                    if (tempMaxPercent > 1)
                    {
                        maxToBeAssignedOverridePercentValue = 1;
                    }
                    else
                    {
                        maxToBeAssignedOverridePercentValue = tempMaxPercent;
                    }
                }
            }

            return {
                id: id,
                code: code,
                maxCount: maxCount,
                currentCount: currentCount,
                countInput: countInput,
                percentInput: percentInput,
                totalStudentDiv: totalStudentDiv,
                totalStudentOriginalValue: totalStudentDiv.text(),
                maxToBeAssignedOverrideValue: getBaseTenIntValue(maxToBeAssignedOverrideValue),
                previousMaxToBeAssignedOverrideValue: getBaseTenIntValue(totalToBeAssigned),
                maxToBeAssignedOverridePercentValue: maxToBeAssignedOverridePercentValue,
                previousMaxToBeAssignedOverridePercentValue: totalToBeAssignedPercent
            };
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
(
    function (skyward, $)
    {
        skyward.journalentryselector = skyward.journalentryselector || {};

        skyward.journalentryselector.resetwaitingmessage = function ()
        {
            var waitingMessageSubject = $('#editJournalEntryRequest_JournalEntryRequestWaitingMessageSubject');
            var waitingMessageContent = $('#editJournalEntryRequest_JournalEntryRequestWaitingMessageContent');
            var defaultWaitingMessageSubject = 'Journal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} is waiting for your approval';
            var defaultWaitingMessageContent = '{User.Name.FirstName},\n\nJournal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} of batch {TaskInstance.JournalEntryApproval.JournalEntry.Batch} is waiting for your approval at {TaskInstance.JournalEntryApproval.LevelDescription}.';

            skyward.controls.setValue(waitingMessageSubject, defaultWaitingMessageSubject, false);
            skyward.controls.setValue(waitingMessageContent, defaultWaitingMessageContent, false);
        }

        skyward.journalentryselector.resetapprovedmessage = function ()
        {
            var approvedMessageSubject = $('#editJournalEntryRequest_JournalEntryRequestApprovedMessageSubject');
            var approvedMessageContent = $('#editJournalEntryRequest_JournalEntryRequestApprovedMessageContent');
            var defaultApprovedMessageSubject = 'Journal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} has been approved';
            var defaultApprovedMessageContent = '{JournalEntry.UserCreatedBy.Name.FirstName},\n\nJournal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} of batch {TaskInstance.JournalEntryApproval.JournalEntry.Batch} has been approved at {TaskInstance.JournalEntryApproval.LevelDescription}.';

            skyward.controls.setValue(approvedMessageSubject, defaultApprovedMessageSubject, false);
            skyward.controls.setValue(approvedMessageContent, defaultApprovedMessageContent, false);
        }

        skyward.journalentryselector.resetdeniedmessage = function ()
        {
            var deniedMessageSubject = $('#editJournalEntryRequest_JournalEntryRequestDeniedMessageSubject');
            var deniedMessageContent = $('#editJournalEntryRequest_JournalEntryRequestDeniedMessageContent');
            var defaultDeniedMessageSubject = 'Journal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} has been denied';
            var defaultDeniedMessageContent = '{JournalEntry.UserCreatedBy.Name.FirstName},\n\nJournal entry request {TaskInstance.JournalEntryApproval.JournalEntry.Description} of batch {TaskInstance.JournalEntryApproval.JournalEntry.Batch} has been denied at {TaskInstance.JournalEntryApproval.LevelDescription}.\n\nDenial Reason: {Comment}';

            skyward.controls.setValue(deniedMessageSubject, defaultDeniedMessageSubject, false);
            skyward.controls.setValue(deniedMessageContent, defaultDeniedMessageContent, false);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.staarfieldoverride = skyward.staarfieldoverride || {};
        
        var init = function (selector)
        {
            "use strict";
            var pageCheck = $(selector).find("#7EF25DAF-6A67-481C-A68A-A900380F62FA");

            if (!pageCheck.length > 0)
            {
                return;
            }
            GetTrexStudentDetails();
            $(".NextPrevClick").click(function () { GetNextPrevTrexStudentDetails(); });
        };

        function GetTrexStudentDetails()
        {
            $(document).on("mousedown", ".templatedResult", function (event)
            {
                GoToDetails($(this).find("#StudentID").attr("value"));
            });
        }

        function GetNextPrevTrexStudentDetails()
        {
            GoToDetails($(event.currentTarget).data("studentid"));
        }

        function GoToDetails(id)
        {
            var postData = { "id": id };

            $.ajax(
            {
                url: skyward.global.virtualDir + "StateReportingTX/TRExExport/GetDetailScreen/",
                type: "POST",
                data: postData,
                success: function (data) {
                    skyward.window.loadContent('full', 'StateReportingTX', 'TRExExport', 'Details', data.TRExStudentID);
                }
            });
        }
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.base.time.js" />
/// <reference path="skyward.ui.clock.ts" />
(
    function (skyward, $)
    {
        "use strict";
        skyward.workflow = skyward.workflow || {};
        skyward.workflow.visualization = skyward.workflow.visualization || {};

        var highlightPadding = 20;
        var highlightTextOffset =
        {
            x: -10,
            y: -5
        };
        var arrowSize = 7;
        var nodeSize = 120;
        var nodePadding = 3;
        var visualizationWorker;
        var workerReady = true;

        var cacheLineHeight = function ()
        {
            var cached;
            return function (elem)
            {
                if (cached === undefined)
                {
                    cached = parseInt(window.getComputedStyle(elem).lineHeight, 10);
                }
                return cached;
            };
        };
        var cachedTitleHeight = cacheLineHeight();
        var cachedLabelHeight = cacheLineHeight();

        var createSvgElement = function (tagName, props)
        {
            var elem = document.createElementNS("http://www.w3.org/2000/svg", tagName);
            if (props !== undefined)
            {
                var keys = Object.keys(props);
                // jQuery's .attr() method can't be used for this because it transforms everything to
                // lowercase, but SVG attributes are case-sensitive.
                for (var i = 0; i < keys.length; i++)
                {
                    elem.setAttribute(keys[i], props[keys[i]]);
                }
            }
            return $(elem);
        };

        var appendSvg = function (container, tagName, props)
        {
            return createSvgElement(tagName, props).appendTo(container);
        };

        var appendUse = function (container, href, props)
        {
            var use = appendSvg(container, "use", props);
            use[0].setAttribute("href", href);
            return use;
        };

        var setTranslation = function (elem, x, y)
        {
            return $(elem).attr("transform", "translate(" + x + "," + y + ")");
        };

        var setGradient = function (defs, id, statuses, attrs)
        {
            var gradient = appendSvg(defs, "linearGradient", attrs);
            gradient.attr("id", id);

            if (statuses.length === 1)
            {
                appendSvg(gradient, "stop",
                {
                    "class": "taskHighlightColor " + statuses[0]
                });
                return;
            }

            // fade between solid colors -- inset each solid region so that the transitions take up 10% total
            var transitionSize = 0.10;
            var halfTransition = transitionSize / 2 / (statuses.length - 1);
            statuses.forEach(function (status, idx)
            {
                // solid color start
                appendSvg(gradient, "stop",
                {
                    "offset": (idx / statuses.length + halfTransition) * 100 + "%",
                    "class": "taskHighlightColor " + status
                });

                // solid color end
                appendSvg(gradient, "stop",
                {
                    "offset": ((idx + 1) / statuses.length - halfTransition) * 100 + "%",
                    "class": "taskHighlightColor " + status
                });
            });
        };

        var drawHighlight = function (svgParts, elem, highlightElem, node, statuses, text, time)
        {
            var id = "node_" + node.id + "_highlight";
            var gradientId = id + "_gradient";
            var rectId = id + "_rect";
            setGradient(svgParts.defs, gradientId, statuses,
            {
                "gradientUnits": "objectBoundingBox"
            });
            highlightElem.attr("id", id);

            var highlightRect = createSvgElement("rect",
            {
                "id": rectId,
                "x": -highlightPadding,
                "y": -highlightPadding,
                "width": node.width + highlightPadding * 2,
                "height": node.height + highlightPadding * 2,
                "ry": 3,
                "rx": 3
            });

            var clipPath = appendSvg(svgParts.defs, "clipPath").attr("id", id + "_clip");
            appendUse(clipPath, "#" + rectId);

            var statusText = createSvgElement("text",
            {
                "class": "taskHighlightText",
                "x": highlightTextOffset.x,
                "y": highlightTextOffset.y,
                "clip-path": "url(#" + id + "_clip)",
            })
            .text(text);

            var timeText = createSvgElement("text",
            {
                "class": "taskHighlightText",
                "x": highlightTextOffset.x,
                "y": node.height + highlightPadding + highlightTextOffset.y,
                "clip-path": "url(#" + id + "_clip)"
            })
            .text(time);

            highlightElem.append(highlightRect);
            elem.append(statusText.add(timeText));
            appendUse(svgParts.highlightDisplay, "#" + id,
            {
                "fill": "url(#" + gradientId + ")"
            });
            appendUse(svgParts.highlightMask, "#" + id,
            {
                "fill": "black"
            });
        };

        var highlightNode = function (svgParts, elem, highlightElem, node)
        {
            if (node.statuses.length > 0)
            {
                var timeString = "";
                if (node.statusTime !== undefined)
                {
                    var showDate = false;
                    var now = skyward.time.now();

                    var statusTime = new Date(skyward.time.parseISODate(node.statusTime));

                    if (now.getDate() !== statusTime.getDate())
                    {
                        showDate = true;
                        timeString += (statusTime.getMonth() + 1) + "/" + statusTime.getDate();
                        if (now.getFullYear() !== statusTime.getFullYear())
                        {
                            timeString += "/" + statusTime.getFullYear();
                        }
                        timeString += " ";
                    }

                    timeString += skyward.clock.formatTime(statusTime, { useSeconds: true });

                    var lastStatus = node.statuses[node.statuses.length - 1];
                    var timePrefix;
                    if (lastStatus === "InProgress" || lastStatus === "Waiting")
                    {
                        timePrefix = "since";
                    }
                    else
                    {
                        timePrefix = showDate ? "on" : "at";
                    }
                    timeString = timePrefix + " " + timeString;
                }

                drawHighlight(svgParts, elem, highlightElem, node, node.statuses, node.statusMessage, timeString);
            }
        };

        var wrapText = function (elem, str, widthFn, lineHeight)
        {
            var childSpans = document.createDocumentFragment();
            var appendNewSpan = function (line, lastLine)
            {
                // TSpan coordinates correspond to the text baseline.*  Offsetting the first element by lineHeight lets us treat
                // y-coordinates uniformly as the top of the element.  Unfortunately, any extra line-spacing will also be added.
                // * "Alignment-baseline" and "dominant-baseline" can override this, but support for them is limited.
                return appendSvg(childSpans, "tspan", {
                    "x": 0,
                    "dy": (line - lastLine) * lineHeight
                })[0];
            };

            var spacesOrEndSearch = /\s+|$/g;
            elem.textContent = str;

            var getNextWordLength = function (spanStart)
            {
                var nextMatch = spacesOrEndSearch.exec(str);
                var spaces = nextMatch !== null ? nextMatch[0].length : 0;
                var wordEnd = spacesOrEndSearch.lastIndex - spaces;
                return elem.getSubStringLength(spanStart, wordEnd - spanStart);
            };
            var getFittingChars = function (maxWidth, spanStart)
            {
                spacesOrEndSearch.lastIndex = spanStart;
                var lastGoodChar = spanStart;
                while (lastGoodChar < str.length && getNextWordLength(spanStart) <= maxWidth)
                {
                    lastGoodChar = spacesOrEndSearch.lastIndex;
                }
                if (spanStart !== lastGoodChar)
                {
                    return lastGoodChar;
                }
                while ((lastGoodChar + 1) < str.length &&
                    elem.getSubStringLength(spanStart, lastGoodChar + 1 - spanStart) <= maxWidth)
                {
                    lastGoodChar += 1;
                }
                return lastGoodChar;
            };

            var spanStart = 0;
            var line = -1;
            var lastLine = -1;
            var success = true;
            while (spanStart < str.length)
            {
                line += 1;
                var maxWidth = widthFn(line);
                if (isNaN(maxWidth))
                {
                    success = false;
                    break;
                }
                var spanEnd = getFittingChars(maxWidth, spanStart);
                if (spanStart === spanEnd)
                {
                    continue;
                }

                var currentSpan = appendNewSpan(line, lastLine);
                currentSpan.textContent = str.slice(spanStart, spanEnd);
                spanStart = spanEnd;
                lastLine = line;
            }
            return {
                spans: childSpans,
                success: success
            };
        };

        var wrapTitleText = function (titleElem, node, nodeInfo)
        {
            var lineHeight = cachedTitleHeight(titleElem);

            var words = node.title.trim();
            if (words.length === 0)
            {
                return nodeInfo.minHeight(0) || 0;
            }
            titleElem.textContent = words;
            var neededWidth = titleElem.getSubStringLength(0, words.split(" ")[0].length);
            var minHeight = Math.max(nodeInfo.minHeight(neededWidth) || 0, nodePadding);
            var startY = Math.ceil(minHeight);
            setTranslation(titleElem, node.width / 2, startY);

            var lineWidth = function (line)
            {
                var y = startY + lineHeight * line;
                return y <= node.height ? Math.min(nodeInfo.width(y), nodeInfo.width(y + lineHeight)) : undefined;
            };

            var wrapResult = wrapText(titleElem, words, lineWidth, lineHeight);
            var height = startY + wrapResult.spans.childNodes.length * lineHeight;
            titleElem.textContent = "";
            titleElem.appendChild(wrapResult.spans);
            return height;
        };

        var wrapLabelText = function (labelElem, text, bounds, nodeInfo)
        {
            labelElem.textContent = text;
            var requiredWidth = labelElem.getComputedTextLength();
            var lineHeight = cachedLabelHeight(labelElem);

            var getCenteredLineWidths = function (y, lines)
            {
                var startY = y - (lines * lineHeight) / 2;
                var widths = [];
                for (var i = 0; i < lines; i++)
                {
                    widths[i] = Math.min(nodeInfo.width(i * lineHeight + startY), nodeInfo.width(i * lineHeight + startY + lineHeight));
                }
                return {
                    widths: widths,
                    startY: startY
                };
            };

            var words = text.trim();
            if (words.length === 0)
            {
                return true;
            }

            var maxLines = bounds.maxHeight / lineHeight;
            if (maxLines < 1)
            {
                return false;
            }
            var wrapResult;
            for (var i = 1; i < maxLines; i++)
            {
                var lineWidth = getCenteredLineWidths(bounds.centerY, i);

                var totalWidth = lineWidth.widths.reduce(function (accum, line) { return accum + (line || 0); }, 0);
                if (totalWidth >= requiredWidth)
                {
                    wrapResult = wrapText(labelElem, words, function (line) { return lineWidth.widths[line]; }, lineHeight);
                    if (wrapResult.success)
                    {
                        labelElem.textContent = "";
                        labelElem.appendChild(wrapResult.spans);
                        setTranslation(labelElem, bounds.centerX, lineWidth.startY);
                        return true;
                    }
                }
            }

            wrapResult = wrapText(labelElem, words, function (line) { return lineWidth.widths[line]; }, lineHeight);
            labelElem.textContent = "";
            var lastElem = $(wrapResult.spans).children().last();
            lastElem.text(lastElem.text().slice(0, -3) + "...");
            setTranslation(labelElem, bounds.centerX, lineWidth.startY);
            labelElem.appendChild(wrapResult.spans);
            return false;
        };

        var wrapLabels = function (labels, node, nodeInfo, startY)
        {
            // Try to center solitary labels, so long as they don't overlap the title
            if (node.labels.length === 1)
            {
                var bounds = {
                    maxHeight: (node.height / 2 - startY) * 2,
                    centerX: node.width / 2,
                    centerY: node.height / 2
                };
                if (wrapLabelText(labels[0], node.labels[0], bounds, nodeInfo))
                {
                    return;
                }
                $(labels[0]).empty();
            }
            // Evenly distribute the available space among all labels
            var labelHeight = (node.height - startY) / node.labels.length;
            node.labels.forEach(function (text, i)
            {
                var bounds = {
                    centerX: node.width / 2,
                    centerY: labelHeight * (i + 0.5) + startY,
                    maxHeight: labelHeight
                };
                wrapLabelText(labels[i], text, bounds, nodeInfo);
            });
        };

        var getNodeInfo = function (node)
        {
            var centerY = node.height / 2;
            var innerSize = centerY - nodePadding;

            if (node.type === "InteractiveTask" || node.type === "BackgroundTask")
            {
                return {
                    minHeight: function ()
                    {
                        return 0;
                    },
                    width: function (y)
                    {
                        return y < innerSize * 2 ? innerSize * 2 : undefined;
                    },
                    createBackground: function ()
                    {
                        return createSvgElement("rect",
                        {
                            "x": 0,
                            "y": 0,
                            "width": node.width,
                            "height": node.height,
                            "ry": 3,
                            "rx": 3,
                        });
                    }
                };
            }
            if (node.type === "Start" || node.type === "End")
            {
                return {
                    minHeight: function (width)
                    {
                        width = width / 2;
                        if (width < innerSize)
                        {
                            var yOffset = Math.sqrt(innerSize * innerSize - width * width);
                            return centerY - yOffset;
                        }
                    },
                    width: function (y)
                    {
                        var height = centerY - y;
                        return height <= innerSize ? Math.sqrt(innerSize * innerSize - height * height) * 2 : undefined;
                    },
                    createBackground: function ()
                    {
                        return createSvgElement("ellipse",
                        {
                            "rx": node.width / 2,
                            "ry": node.height / 2,
                            "cx": node.width / 2,
                            "cy": node.height / 2,
                        });
                    }
                };
            }
            if (node.type === "Condition")
            {
                return {
                    width: function (y)
                    {
                        var height = Math.abs(centerY - y);
                        return height < innerSize ? (innerSize - height) * 2 : undefined;
                    },
                    createBackground: function ()
                    {
                        var start = { x: 0, y: 0 };
                        var center = { x: node.width / 2, y: node.height / 2 };
                        var end = { x: node.width, y: node.height };
                        var points = [
                            [start.x, center.y],
                            [center.x, end.y],
                            [end.x, center.y],
                            [center.x, start.y]
                        ];
                        return createSvgElement("polygon",
                        {
                            "points": points.map(function (point) { return point.join(","); }).join(" "),
                        });
                    }
                };
            }
            else
            {
                throw new Error("unknown node type " + node.type);
            }
        };

        var renderNodes = function (svgParts, nodes)
        {
            nodes.forEach(function (node)
            {
                var elem = appendSvg(svgParts.nodes, "g", { "class": "taskNode" });
                var highlightElem = appendSvg(svgParts.highlightDefs, "g");

                var nodeInfo = getNodeInfo(node);

                var lowercaseType = node.type[0].toLowerCase() + node.type.slice(1);
                var textClass = lowercaseType + "Text";

                nodeInfo.createBackground().addClass(lowercaseType + "Background").appendTo(elem);
                var titleHeight = 0;

                if (node.title !== undefined)
                {
                    var titleElem = appendSvg(elem, "text",
                    {
                        "text-anchor": "middle",
                        "class": "taskTitle " + textClass
                    })[0];
                    titleHeight = wrapTitleText(titleElem, node, nodeInfo);
                }

                var labels = [];
                for (var i = 0; i < node.labels.length; i++)
                {
                    labels[i] = appendSvg(elem, "text", {
                        "text-anchor": "middle",
                        "class": textClass
                    })[0];
                }

                wrapLabels(labels, node, nodeInfo, titleHeight);

                highlightNode(svgParts, elem, highlightElem, node);
            });
        };

        var formatLinePath = function (points)
        {
            return points.reduce(function (accum, point, pos)
            {
                accum += pos === 0 ? "M " : "L ";
                accum += point.x + "," + point.y + " ";
                return accum;
            }, "");
        };

        var drawConnectionHighlight = function (svg, defs, edge)
        {
            var gradientId = "edge_" + edge.id + "_highlight_gradient";
            setGradient(defs, gradientId, edge.statuses, {
                "gradientUnits": "userSpaceOnUse", // required for horizontal highlight paths to display: http://stackoverflow.com/a/21639059
                "x1": edge.points[0].x,
                "y1": edge.points[0].y,
                "x2": edge.points[edge.points.length - 1].x,
                "y2": edge.points[edge.points.length - 1].y,
            });

            var pathDefinition = formatLinePath(edge.points);
            appendSvg(svg, "path",
            {
                "stroke": "url(#" + gradientId + ")",
                "d": pathDefinition,
                "mask": "url(#connectionMask)",
                "class": "taskConnectionHighlight"
            });
        };

        var drawConnection = function (edgeDefs, edgeDisplay, defs, edge)
        {
            var group = appendSvg(edgeDisplay, "g");

            if (edge.statuses.length > 0)
            {
                drawConnectionHighlight(group, defs, edge);
            }

            var points = edge.points.slice();
            var secondlast = points[points.length - 2];
            var last = points[points.length - 1];
            var angle = Math.atan2(last.y - secondlast.y, last.x - secondlast.x);
            last.x = last.x - arrowSize * Math.cos(angle);
            last.y = last.y - arrowSize * Math.sin(angle);

            var pathDefinition = formatLinePath(points);

            appendSvg(edgeDefs, "path",
            {
                "d": pathDefinition,
                "marker-end": "url(#arrowhead)",
                id: edge.id
            });
            return appendUse(group, "#" + edge.id);
        };

        // http://pomax.github.io/bezierinfo/#intersections
        var linesIntersect = function (line1, offset1, line2, offset2)
        {
            var x1 = line1[offset1].x, x2 = line1[offset1 + 1].x, x3 = line2[offset2].x, x4 = line2[offset2 + 1].x;
            var y1 = line1[offset1].y, y2 = line1[offset1 + 1].y, y3 = line2[offset2].y, y4 = line2[offset2 + 1].y;
            var d = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
            if (d === 0)
            {
                return false;
            }
            var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4);
            var ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4);
            var x = nx / d;
            var y = ny / d;
            return x >= Math.min(x1, x2) && x >= Math.min(x3, x4) && x <= Math.max(x1, x2) && x <= Math.max(x3, x4) &&
                   y >= Math.min(y1, y2) && y >= Math.min(y3, y4) && y <= Math.max(y1, y2) && y <= Math.max(y3, y4);
        };
        
        var anySegmentsIntersect = function (line1, line2)
        {
            for (var belowLine = 0; belowLine < line1.length - 1; belowLine++)
            {
                for (var aboveLine = 0; aboveLine < line2.length - 1; aboveLine++)
                {
                    if (linesIntersect(line1, belowLine, line2, aboveLine))
                    {
                        return true;
                    }
                }
            }
            return false;
        };

        var addEdgeMask = function (edges, edgeIdx, line, defs)
        {
            var edge = edges[edgeIdx];
            var mask = [];
            for (var above = edgeIdx + 1; above < edges.length && edges[above].bounds.minX <= edge.bounds.maxX; above++)
            {
                var aboveEdge = edges[above];
                // Masks are surprisingly expensive, enough so that we don't want to render them unless absolutely necessary.
                if (edge.bounds.intersects(aboveEdge.bounds) && anySegmentsIntersect(edge.points, aboveEdge.points))
                {
                    mask.push(above);
                }
            }
            if (mask.length > 0)
            {
                var maskId = edge.id + "_overlapMask";
                var maskElem = appendSvg(defs, "mask", {
                    "id": maskId,
                    "maskUnits": "userSpaceOnUse",
                    "class": "connectionOverlap"
                });
                appendSvg(maskElem, "rect",
                {
                    "x": 0,
                    "y": 0,
                    "width": "100%",
                    "height": "100%",
                    "fill": "white",
                    "stroke": "none"
                });
                for (var i = 0; i < mask.length; i++)
                {
                    appendUse(maskElem, "#" + edges[mask[i]].id);
                }
                line.attr("mask", "url(#" + maskId + ")");
            }
        };

        var BoundingBox = function (points)
        {
            this.minX = points[0].x;
            this.maxX = points[0].x;
            this.minY = points[0].y;
            this.maxY = points[0].y;
            for (var i = 1; i < points.length; i++)
            {
                this.minX = Math.min(this.minX, points[i].x);
                this.maxX = Math.max(this.maxX, points[i].x);
                this.minY = Math.min(this.minY, points[i].y);
                this.maxY = Math.max(this.maxY, points[i].y);
            }
        };

        BoundingBox.prototype.intersects = function (other)
        {
            return this.maxX >= other.minX && this.minX <= other.maxX &&
                   this.maxY >= other.minY && this.minY <= other.maxY;
        };

        var drawConnections = function (edgeDefs, edgeDisplay, defs, edges)
        {
            edges.forEach(function (edge)
            {
                edge.bounds = new BoundingBox(edge.points);
            });
            edges.sort(function (a, b) { return a.bounds.minX - b.bounds.minX; });

            edges.forEach(function (edge, idx)
            {
                var lineUse = drawConnection(edgeDefs, edgeDisplay, defs, edge);
                addEdgeMask(edges, idx, lineUse, defs);
            });
        };

        var setupSvg = function (body)
        {
            var svg = createSvgElement("svg")
            .addClass("workflowVisualization svgNoHover")
            .appendTo(body);

            var defXml =
                "<defs xmlns='http://www.w3.org/2000/svg'>" +
                    "<marker id='arrowhead' " +
                        "class='taskConnectionArrow' " +
                        "orient='auto' " +
                        "stroke='none' " + // only needed for IE 11
                        "viewBox='-0.5 -0.5 1 1' " +
                        "markerWidth='" + arrowSize + "' markerHeight='" + arrowSize + "'>" +
                            "<path d='M -0.4,-0.32 L -0.2,0 -0.4,0.32 0.4,0' />" +
                    "</marker>" +
                    "<mask id='connectionMask' maskUnits='userSpaceOnUse'>" +
                        "<rect x='0' y='0' width='100%' height='100%' fill='white' />" +
                    "</mask>" +
                "</defs>";
            svg.append(new DOMParser().parseFromString(defXml, "text/xml").documentElement);

            return svg;
        };

        var renderGraph = function (body, workflowId, nodes, edges)
        {
            nodes.forEach(function (node)
            {
                node.width = nodeSize;
                node.height = nodeSize;
            });

            // set up display area
            var svg = setupSvg(body);
            skyward.workflow.visualization.area = svg;

            var defs = svg.children("defs");
            var nodeHighlightCanvas = appendSvg(defs, "g", { "id": "nodeHighlights" });
            var nodeHighlightDisplay = appendSvg(svg, "g", { "class": "taskHighlightDisplay" });
            var edgeCanvas = appendSvg(defs, "g");
            var edgeDisplay = appendSvg(svg, "g", { "class": "taskConnections" });
            var nodeCanvas = appendSvg(svg, "g");

            var sendToWorker = function ()
            {
                workerReady = false;
                visualizationWorker.postMessage(
                {
                    options:
                    {
                        intCoordinates: true,
                        "de.cau.cs.kieler.klay.layered.feedBackEdges": true,
                        "de.cau.cs.kieler.klay.layered.mergeEdges": false
                    },
                    graph:
                    {
                        id: workflowId,
                        properties:
                        {
                            spacing: 50,
                            edgeRouting: "POLYLINE"
                        },
                        children: nodes.map(function (node)
                        {
                            return {
                                "id": node.id,
                                "width": node.width,
                                "height": node.height
                            };
                        }),
                        edges: edges.map(function (edge)
                        {
                            return {
                                "id": edge.id,
                                "source": edge.from,
                                "target": edge.to
                            };
                        })
                    }
                });
            };

            if (visualizationWorker === undefined)
            {
                visualizationWorker = new Worker(skyward.global.virtualDir + "Scripts/klay.js");
            }
            visualizationWorker.onmessage = function (e)
            {
                workerReady = true;
                var result = e.data;
                if (result.stacktrace !== undefined)
                {
                    throw $.extend(new Error("Graph layout worker threw an error: " + result.message), { details: result });
                }
                if (result.id !== workflowId)
                {
                    sendToWorker();
                    return;
                }

                skyward.workflow.visualization.graph = result;
                svg.height(result.height);
                svg.width(result.width);

                result.children.forEach(function (graphNode, idx)
                {
                    var elem = $(nodeCanvas.children()[idx]);
                    var highlightElem = $(nodeHighlightCanvas.children()[idx]);
                    setTranslation(elem, graphNode.x, graphNode.y);
                    setTranslation(highlightElem, graphNode.x, graphNode.y);
                });
                result.edges.forEach(function (graphEdge, idx)
                {
                    edges[idx].points = [graphEdge.sourcePoint].concat(graphEdge.bendPoints || []).concat(graphEdge.targetPoint);
                });
                drawConnections(edgeCanvas, edgeDisplay, defs, edges);
                // force Chrome to redraw the <use> elements referencing highlights
                nodeHighlightCanvas.children("[id]").each(function ()
                {
                    this.setAttribute("color", this.getAttribute("color") || "");
                });
                body.removeClass('loading');
                svg.show();
            };
            if (workerReady)
            {
                sendToWorker();
            }

            var svgParts =
            {
                nodes: nodeCanvas,
                highlightDefs: nodeHighlightCanvas,
                highlightMask: defs.find("#connectionMask"),
                highlightDisplay: nodeHighlightDisplay,
                defs: defs
            };
            renderNodes(svgParts, nodes);
            svg.hide();
        };

        skyward.workflow.visualization.display = function (workflow, area)
        {
            skyward.workflow.visualization.workflowdata = workflow;
            skyward.workflow.visualization.redraw = function ()
            {
                area.children().remove();
                var workflow = skyward.workflow.visualization.workflowdata;
                renderGraph(area, workflow.id.toString(), workflow.nodes, workflow.edges);
            };
            skyward.workflow.visualization.redraw();
        };

        skyward.window.registerLoadDOMCallback(function (selector)
        {
            $(selector + " .workflowVisualizationContainer").each(function ()
            {
                var $this = $(this);
                var graph = $this.data("graph");
                skyward.workflow.visualization.display(graph, $this);
            });
        });

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
function (skyward, $, undefined)
{
    "use strict";
    skyward.crossReferenceTableEditor = skyward.crossReferenceTableEditor || {};

    skyward.crossReferenceTableEditor.launch = function (args)
    {
        const showPopup = function (jsonResult)
        {
            const columnParser = JSON.parse(args.columnParser);

            const buttons = [
                { text: "Save", click: onSave, icon: "Save", additionalClasses: "crossReferenceTableEditorSaveButton" },
                { text: "Cancel", click: "close", icon: "Cancel" }
            ];

            const popup = skyward.modalLayer.showDialog("Cross Reference Table", jsonResult.html, buttons);
            const crossReferenceTableEditor = popup.content;

            const addButton = crossReferenceTableEditor.find(".addCrossReferenceRow");
            addButton.on("click", addNewCrossReference);

            const deleteRowButton = crossReferenceTableEditor.find(".deleteRow");
            deleteRowButton.on("click", deleteRow);

            const errorContainer = crossReferenceTableEditor.find(".currentRecordContentBaseError");
            const valueIfNotFoundComboBox = crossReferenceTableEditor.find(".crossReferenceValueIfNotFound");

            const templateRow = crossReferenceTableEditor.find(".crossReferenceRowTemplate");
            skyward.events.removeLoadActionClass(templateRow);

            function onSave()
            {
                skyward.validation.clearValidationMessages(crossReferenceTableEditor, errorContainer);

                const crossReferences = getCrossReferences();

                $.ajax({
                    type: "POST",
                    dataType: "JSON",
                    url: skyward.global.virtualDir + "SkySys/Import/ValidateCrossReferenceTable",
                    data: {
                        crossReferencesJson: JSON.stringify(crossReferences),
                        columnParserType: columnParser.Type
                    },
                    success: function (res)
                    {
                        if (res.success)
                        {
                            args.callback(buildCrossReferenceObject(crossReferences));
                            popup.close();
                        }
                        else
                        {
                            skyward.validation.displayValidationMessages({ errors: res.errors }, crossReferenceTableEditor, errorContainer);
                        }
                    }
                });
            };

            function getCrossReferences()
            {
                const crossReference = [];
                crossReferenceTableEditor.find(".crossReferenceRow").not(".crossReferenceRowTemplate").each(function ()
                {
                    const row = $(this);
                    const inputValue = row.find(".crossReferenceInputText").val();
                    const outputValue = row.find(".crossReferenceOutputText").val();

                    if (inputValue || outputValue)
                    {
                        crossReference.push({ Key: inputValue, Value: outputValue });
                    }
                });

                return crossReference;
            }

            function buildCrossReferenceObject(crossReference)
            {
                if ($.isEmptyObject(crossReference))
                {
                    delete columnParser["LookupTable"];
                }
                else
                {
                    columnParser["LookupTable"] = crossReference;
                    columnParser["ValueIfNotFoundOption"] = valueIfNotFoundComboBox.find(".option:selected").val();
                }

                return columnParser;
            }

            function addNewCrossReference()
            {
                const rowCount = templateRow.parent().children().length - 1;
                const newRow = templateRow.clone(true).removeClass("crossReferenceRowTemplate").show();

                newRow.find(".crossReferenceInputText, .crossReferenceOutputText").each(function ()
                {
                    const element = $(this);

                    const currentId = element.prop("id");
                    const newId = `${currentId}-${rowCount}`;
                    element.prop("id", newId);
                    element.attr("data-validate-control-for", newId);

                    const errorLabel = element.siblings();
                    errorLabel.attr("data-validate-message-for", newId);
                });

                templateRow.parent().append(newRow);
                popup.animateModalContents();

                skyward.events.applyLoadActionClass(newRow);
                skyward.window.notifyDOMLoad(newRow);
            }
            
            function deleteRow()
            {
                const row = $(this).parents(".crossReferenceRow");
                row.remove();
                popup.animateModalContents();
            }
        };

        $.ajax(
        {
            url: skyward.global.virtualDir + "SkySys/Import/GetCrossReferenceTableEditor",
            type: "POST",
            dataType: "JSON",
            data: {
                columnParser: args.columnParser
            }
        }).done(showPopup);
    };

}(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.ui.modallayer.js" />
(
    function (skyward, $, undefined) {
        "use strict";
        skyward.importingapproval = skyward.importingapproval || {};

        skyward.importingapproval.getConsentForRunImport = function ()
        {
            var buttonData = $(this).data();
            getRunImportConsent(buttonData.importid, buttonData.importid_securityhash);
        };

        skyward.importingapproval.detailsGetConsentForRunImport = function (importid, securityHash)
        {
            getRunImportConsent(importid, securityHash);
        };

        var getRunImportConsent = function (importID, securityHash)
        {
            makeAjaxCall("Skysys/UserImportApproval/GetConsentForRunImport", importID, securityHash);
        };

        skyward.importingapproval.getConsentForScheduledImport = function ()
        {
            var buttonData = $(this).data();
            makeAjaxCall("Skysys/UserImportApproval/GetConsentForScheduledImport", buttonData.importid, buttonData.importid_securityhash);
        };

        skyward.importingapproval.getConsentForDesignerDetails = function ()
        {
            var button = $(this);
            var buttonData = button.data();
            var rowNumber = button.closest(".browseRowOptions").data("row");

            makeAjaxCall("Skysys/UserImportApproval/GetConsentForDesignerDetails", buttonData.importid, buttonData.importid_securityhash, null, rowNumber);
        };

        skyward.importingapproval.getConsentForAddImport = function ()
        {
            makeAjaxCall("Skysys/UserImportApproval/GetConsentForAddImport");
        };

        var consentAndRedirect = function ()
        {
            var buttonData = $(this).data();
            makeAjaxCall("SkySys/UserImportApproval/ApproveAndRedirect", buttonData.importid, buttonData.securityHash, buttonData.redirectAction);
        };

        var makeAjaxCall = function (url, importId, securityHash, redirectAction, rowNumber)
        {
            var postData =
            {
                importID: importId,
                securityHash: securityHash,
                redirectAction: redirectAction
            };

            $.ajax({
                url: skyward.global.virtualDir + url,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    handleAjaxResponse(data, importId, securityHash, rowNumber);
                }
            });
        };

        var handleAjaxResponse = function (data, importId, securityHash, rowNumber)
        {
            if (data.html)
            {
                var consentButton =
                {
                    text: "I Consent", click: consentAndRedirect, icon: "Check",
                    data:
                    {
                        "importid": importId,
                        "redirectAction": data.redirectAction,
                        "rowNumber": rowNumber,
                        "securityHash": securityHash
                    }
                };
                var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };
                skyward.modalLayer.showCriticalDialog("IMPORT DESIGNER AGREEMENT", data.html, [consentButton, cancelButton], { width: 600, automationID: "import-consent-dialog" });
            }
            else
            {
                switch(data.redirectAction)
                {
                    case "RunImport":
                        skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/SkySys/Import/RunImport', null, data.workflowData, null, null, null, false, null, null, null);
                        break;
                    case "DesignerDetails":
                        skyward.browse.primaryButtonClick('browse', rowNumber, 'full', 'SkySys', 'Import', 'DesignerDetails', importId, null, null, null, false);
                        break;
                    case "AddImport":
                        skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/SkySys/Import/Add', null, null, null, null, null, false, null, null, null);
                        break;
                    case "CreateScheduledImport":
                        skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/SkySys/ScheduledImport/Add', null, data.workflowData, null, null, null, false, null, null, null);
                        break;
                }
            }
        };

        var events =
        {
            'getConsentForRunImport': skyward.importingapproval.getConsentForRunImport,
            'getConsentForDesignerDetails': skyward.importingapproval.getConsentForDesignerDetails,
            'getConsentForAddImport': skyward.importingapproval.getConsentForAddImport,
            'getConsentForScheduledImport': skyward.importingapproval.getConsentForScheduledImport
        };

        skyward.events.registerEvents('importingapproval', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        "use strict";
        var init = function (selector)
        {
            var jqSelector = $(selector);
            var startDate = jqSelector.find("#UpdateMultipleActionDetailStatusesStartDate #StartDate");
            var endDate = jqSelector.find("#UpdateMultipleActionDetailStatusesEndDate #EndDate");

            startDate.blur(function () { changeEndDate(startDate, endDate); });
            endDate.blur(function () { changeStartDate(startDate, endDate); });
        };

        var changeEndDate = function (startDate, endDate)
        {
            var startDateValue = skyward.controls.getValue(startDate);
            var endDateValue = skyward.controls.getValue(endDate);

            if (startDateValue > endDateValue)
            {
                skyward.controls.setValue(endDate, startDateValue);
            }
        };

        var changeStartDate = function (startDate, endDate)
        {
            var startDateValue = skyward.controls.getValue(startDate);
            var endDateValue = skyward.controls.getValue(endDate);

            if (endDateValue < startDateValue)
            {
                skyward.controls.setValue(startDate, endDateValue);
            }
        };

        // Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function ($)
    {
    $.skyserial = {
        bound: {
            read: [],
            readHandle: []
        },
        defaults: {
            host: "https://localhost:3001",
            portName: "COM1",
            baudRate: 9600,
            dataBits: 8, /* Options: 4, 5, 6, 7, 8 */
            parity: "None", /* Options: None, Odd, Even, Mark, Space */
            stopBits: "One" /* Options: None, One, Two, OnePointFive */
        },
        /* Description:
        *  attach a continous handler to one of the $.skyserial methods
        * Options: 
        *  method:   the $.skyserial method ('read' is the only option at this time)
        *  options:  map of data that will be passed to $.skyserial method
        *  callback: function to execute each time the method responds
        */
        bind: function (method, options, callback) 
        {
            function bindRead(method, options, callback, handle) 
            {
                const index = $.inArray(callback, $.skyserial.bound.read);

                if (index != -1 && $.skyserial.bound.readHandle[index] == handle) 
                {
                    $.skyserial.read(options, function (response) 
                    {
                        if (response.status !== 504 && response.status !== 404) 
                        {
                            callback(response);
                        }

                        setTimeout(function ()
                        {
                            bindRead(method, options, callback, handle);
                        }, response.status == 200 || response.status == 504 ? 0 : 8000);
                    });
                }
            }

            if (method == "read")
            {
                var index = $.inArray(callback, $.skyserial.bound.read);

                if (index == -1) {
                    var handle = 1;
                    $.skyserial.bound.read.push(callback);
                    $.skyserial.bound.readHandle.push(handle);
                    bindRead(method, options, callback, handle);
                }
                else {
                    var handle = $.skyserial.bound.readHandle[index];
                    bindRead(method, options, callback, handle);
                }
            }
        },
        /* Description:
        *  detach a continous handler to one of the $.skyserial methods
        * Options: 
        *  method:   the $.skyserial method ('read' is the only option at this time)
        *  callback: function that is to be no longer executed (optional, if not supplied all are removed)
        */
        unbind: function (method, callback) {
            if (method == "read") {
                if (callback) {
                    var index = $.inArray(callback, $.skyserial.bound.read);
                    if (index != -1) {
                        $.skyserial.bound.readHandle[index]++;
                    }                    
                }
                else {
                    $.skyserial.bound.readHandle.each(function (index) {
                        $.skyserial.bound.readHandle[index]++;
                    });
                }
            }
        },
        /* Description:
        *  reads bytes from the serial port, callback is optional
        * Options: 
        *  host:     see $.skyserial.defaults.host
        *  portName: see $.skyserial.defaults.portName
        *  baudRate: see $.skyserial.defaults.baudRate
        *  dataBits: see $.skyserial.defaults.dataBits
        *  parity:   see $.skyserial.defaults.parity
        *  stopBits: see $.skyserial.defaults.stopBits
        */
        read: function (options, callback) 
        {
            const settings = $.extend({}, $.skyserial.defaults, options);

            $.ajax(
            {
                url: settings.host + "/read",
                data: settings,
                dataType: "jsonp",
                /* jQuery 4 only uses the script tag transport when no headers are set, and a global prefilter always sets them */
                scriptAttrs: {},
                activityIndicator: { silent: true },
                success: function (data, _jqXHR, _textStatus) 
                {
                    if (callback) 
                    {
                        callback(data);
                    }
                },
                error: function (error) 
                {
                    if (callback) 
                    {
                        callback(
                        {
                            status: error.status,
                            message: "Unable to connect to SkySerial."
                        });
                    }
                }
            });
        },
        /* Description:
        *  write an array of bytes to the serial port, callback is optional
        * Options: 
        *  host:     see $.skyserial.defaults.host
        *  portName: see $.skyserial.defaults.portName
        *  baudRate: see $.skyserial.defaults.baudRate
        *  dataBits: see $.skyserial.defaults.dataBits
        *  parity:   see $.skyserial.defaults.parity
        *  stopBits: see $.skyserial.defaults.stopBits
        *  bytes:    byte array to be written to the serial port
        */
        write: function (options, callback) {
            var settings = $.extend({}, $.skyserial.defaults, options);

            $.ajax({
                url: settings.host + "/write",
                data: settings,
                traditional: true,
                timeout: 8000,
                /* jQuery 4 only uses the script tag transport when no headers are set, and a global prefilter always sets them */
                scriptAttrs: {},
                dataType: "jsonp",
                success: function (data, jqXHR, textStatus) {
                    if (callback) {
                        callback(data);
                    }
                },
                error: function () {
                    if (callback) {
                        callback({
                            status: 404,
                            message: "Unable to connect to SkySerial. Please check to ensure you have SkySerial installed and running in your Windows system task tray."
                        });
                    }
                }
            });
        },
        /* Description:
        *  check on the status of the service without reading or writing to serial port, callback is optional
        * Options: 
        *  host:     see $.skyserial.defaults.host
        *  portName: see $.skyserial.defaults.portName
        *  baudRate: see $.skyserial.defaults.baudRate
        *  dataBits: see $.skyserial.defaults.dataBits
        *  parity:   see $.skyserial.defaults.parity
        *  stopBits: see $.skyserial.defaults.stopBits
        */
        status: function (options, callback) {
            var settings = $.extend({}, $.skyserial.defaults, options);
            $.ajax({
                url: settings.host + "/status",
                data: settings,
                dataType: "jsonp",
                /* jQuery 4 only uses the script tag transport when no headers are set, and a global prefilter always sets them */
                scriptAttrs: {},
                timeout: 8000,
                success: function (data, jqXHR, textStatus) {
                    if (callback) {
                        callback(data);
                    }
                },
                error: function () {
                    if (callback) {
                        callback({
                            status: 404,
                            message: "Unable to connect to SkySerial. Please check to ensure you have SkySerial installed and running in your Windows system task tray."
                        });
                    }
                }
            });
        }
    };
})(jQuery);;
(
    function (skyward, $, undefined)
    {
        skyward.massapprovebrowse = skyward.massapprovebrowse || {};

        var toggleApprove = function ()
        {
            skyward.buttonManager.setClickInProgress(true);
            var element = $(this);
            var data = element.data();
            var button = $('#massApproveButtonApprove' + data.taskinstanceid);
            var svgText = $('#massApproveContainerApprove' + data.taskinstanceid + " .buttonText");
            if (button.hasClass('massApproveBrowseApprovedRecord'))
            {
                removeButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approve');
                var approveAllButton = $('#massApproveBrowseApproveAllButton');
                var approveAllSvgText = $('#massApproveBrowseContainerApproveAll .buttonText');
                removeButtonClass(approveAllButton, approveAllSvgText, 'massApproveBrowseApprovedRecord', 'Approve All');
                updateCustomSaveData(getEditableBrowseData(), data);
            }
            else
            {
                addButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approved');
                var denyButton = $('#massApproveButtonDeny' + data.taskinstanceid);
                var denySvgText = $('#massApproveContainerDeny' + data.taskinstanceid + " .buttonText");
                removeButtonClass(denyButton, denySvgText, 'massApproveBrowseDeniedRecord', 'Deny');

                updateCustomSaveData(getEditableBrowseData(), data, 'true');
            }
        };

        var toggleDeny = function ()
        {
            skyward.buttonManager.setClickInProgress(true);
            var element = $(this);
            var data = element.data();
            var button = $('#massApproveButtonDeny' + data.taskinstanceid);
            var svgText = $('#massApproveContainerDeny' + data.taskinstanceid + " .buttonText");
            if (button.hasClass('massApproveBrowseDeniedRecord'))
            {
                removeButtonClass(button, svgText, 'massApproveBrowseDeniedRecord', 'Deny');
                updateCustomSaveData(getEditableBrowseData(), data);
            }
            else
            {
                addButtonClass(button, svgText, 'massApproveBrowseDeniedRecord', 'Denied');
                var approveButton = $('#massApproveButtonApprove' + data.taskinstanceid);
                var approveSvgText = $('#massApproveContainerApprove' + data.taskinstanceid + " .buttonText");
                removeButtonClass(approveButton, approveSvgText, 'massApproveBrowseApprovedRecord', 'Approve');

                var approveAllButton = $('#massApproveBrowseApproveAllButton');
                var approveAllSvgText = $('#massApproveBrowseContainerApproveAll .buttonText');
                removeButtonClass(approveAllButton, approveAllSvgText, 'massApproveBrowseApprovedRecord', 'Approve All');
                updateCustomSaveData(getEditableBrowseData(), data, 'false');
            }
        };

        var approveAll = function ()
        {
            skyward.buttonManager.setClickInProgress(true);
            var button = $('#massApproveBrowseApproveAllButton');
            var svgText = $('#massApproveBrowseContainerApproveAll .buttonText');

            var browseName = skyward.browse.getCurrentBrowseName();
            var domBrowse = $('#' + browseName);
            var browse = skyward.browse.browseList[browseName];
            var browseData = skyward.browse.getRequiredBrowseData(browse, browse.data || domBrowse.data());
            var url = skyward.global.virtualDir + browse.routeModule + "/" + browse.routeObject + '/ApproveAll';

            if (button.hasClass('massApproveBrowseApprovedRecord'))
            {
                $('.massApproveBrowseRowButtonDiv').each(function ()
                {
                    var element = $(this);
                    var data = element.data();
                    var button = $('#massApproveButtonApprove' + data.taskinstanceid);
                    var svgText = $('#massApproveContainerApprove' + data.taskinstanceid + " .buttonText");
                    removeButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approve');
                });
                removeButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approve All');

                return $.ajax(
                    {
                        url: url,
                        type: "POST",
                        dataType: "JSON",
                        complete: function () { skyward.buttonManager.setClickInProgress(false) },
                        success : function(data)
                        {
                            var editableBrowseData = domBrowse.data().editablebrowsedata || [];

                            $.each(data.ApprovedRecords, function ()
                            {
                                //updating to not be selected as approved or denied
                                updateCustomSaveData(editableBrowseData, this, null);
                            });
                        },
                        data: browseData
                    });
            }
            else
            {
                $('.massApproveBrowseRowButtonDiv').each(function ()
                {
                    var element = $(this);
                    var data = element.data();

                    var button = $('#massApproveButtonApprove' + data.taskinstanceid);
                    var svgText = $('#massApproveContainerApprove' + data.taskinstanceid + " .buttonText");
                    addButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approved');

                    var denyButton = $('#massApproveButtonDeny' + data.taskinstanceid);
                    var denySvgText = $('#massApproveContainerDeny' + data.taskinstanceid + " .buttonText");
                    removeButtonClass(denyButton, denySvgText, 'massApproveBrowseDeniedRecord', 'Deny');
                });
                addButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'All Approved');
                return $.ajax(
                {
                    url: url,
                    type: "POST",
                    dataType: "JSON",
                    complete: function () { skyward.buttonManager.setClickInProgress(false) },
                    success: function (data)
                    {
                        var editableBrowseData = domBrowse.data().editablebrowsedata || [];

                        $.each(data.ApprovedRecords, function () {
                            //update to be selected as Approved
                            updateCustomSaveData(editableBrowseData, this, true);
                        });
                    },
                    data: browseData
                });
            }
        };

        var getEditableBrowseData = function()
        {
            var browseName = skyward.browse.getCurrentBrowseName();
            var domBrowse = $('#' + browseName);
            return domBrowse.data().editablebrowsedata || [];
        }

        var updateCustomSaveData = function(editableBrowseData, data, value)
        {
            var currentInput = { saveJson: true, name: 'taskinstance-' + data.taskinstanceid, value: value };
            if (Object.hasOwn(data, 'approvalobjectid')) // old approval workflows don't use an approvalobjectid
            {
                currentInput.data = { approvalobjectid: data.approvalobjectid };
            }
            skyward.dataobjectviewer.updateCustomSaveData(currentInput, editableBrowseData, true);
        }

        var removeButtonClass = function (button, svgText, classname, text)
        {
            if (button.hasClass(classname))
            {
                button.removeClass(classname);
                svgText.text(text);
                svgText.removeClass(classname + 'Text');
            }
        };

        var addButtonClass = function (button, svgText, classname, text)
        {
            button.addClass(classname);
            svgText.text(text);
            svgText.addClass(classname + 'Text');
        };

        var events =
        {
            'toggleApprove': toggleApprove,
            'toggleDeny': toggleDeny,
            'approveAll': approveAll
        };

        skyward.events.registerEvents('massapprovebrowse', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.dynamicnavigator = skyward.dynamicnavigator || {};
        
        var init = function (selector)
        {
            $(selector + " .dynamicNavigatorWrapper").each(function()
            {
                var navigator = $(this);
                navigator.on("click", ".dynamicNavigatorStepButton:not(.active)", skyward.dynamicnavigator.navigatorStepButtonClick);
                navigator.on("click", ".dynamicNavigatorNextButton", skyward.dynamicnavigator.navigatorNextButtonClick);
                navigator.on("click", ".dynamicNavigatorPreviousButton", skyward.dynamicnavigator.navigatorPreviousButtonClick);
                
                skyward.dynamicnavigator.navigatorStepButtonClick.apply(navigator.find(".dynamicNavigatorStepButton.active"));

                skyward.changeTracking.setUpChangeTracking("#" + navigator.attr("id"));

                resize();
            });
        };

        var processNavigationButtons = function (currentButton)
        {
            var navigator = currentButton.parents(".dynamicNavigatorWrapper");

            var buttonData = currentButton.data();

            if (buttonData.hideNavigationButtons && buttonData.hideNavigationButtons.toString().toLowerCase() == "true")
            {
                navigator.find(".dynamicNavigatorPreviousButton").hide();
                navigator.find(".dynamicNavigatorNextButton").hide();
            }
            else
            {
                if (currentButton.parents(".stepNavigator").first().prev().length < 1)
                {
                    navigator.find(".dynamicNavigatorPreviousButton").hide();
                }
                else
                {
                    navigator.find(".dynamicNavigatorPreviousButton").show();
                }

                if (currentButton.parents(".stepNavigator").first().next().length < 1)
                {
                    navigator.find(".dynamicNavigatorNextButton").hide();
                }
                else
                {
                    navigator.find(".dynamicNavigatorNextButton").show();
                }
            }
        };

        var processCustomButtons = function (currentButton)
        {
            var navigator = currentButton.parents(".dynamicNavigatorWrapper");

            var buttonData = currentButton.data();

            if (!buttonData || !buttonData.customButtons)
            {
                return;
            }

            var customButtonsPlaceHolder = navigator.find(".dynamicNavigatorCustomButtonsPlaceHolder");

            //TODO: Reevaluate button bindings?
            //I think we will need to at some point
            customButtonsPlaceHolder.empty();
            $.each(buttonData.customButtons, function (k, v)
            {
                customButtonsPlaceHolder.append(v);
            });
        };

        skyward.dynamicnavigator.saveContent = function (currentButton)
        {
            var container = currentButton.parents(".dynamicNavigatorWrapper");
            var buttonData = currentButton.data();
            var dynamicNavigatorContent = container.find(".dynamicNavigatorContent");

            var url = skyward.global.virtualDir + buttonData.area + "/" + buttonData.controller + "/" + buttonData.saveAction + "/" + buttonData.id + "/";
            var values = getFieldValues(dynamicNavigatorContent);

            var deferredClick = $.Deferred();

            if (!buttonData.saveAction || !buttonData.saveAction != "")
            {
                skyward.changeTracking.clearDirtyList(container.attr("id"));
                deferredClick.resolve();
            }
            else
            {
                var ajax = $.ajax({
                    url: url,
                    type: "POST",
                    success: async function (data)
                    {
                        skyward.changeTracking.clearDirtyList(container.attr("id"));
                        if (data)
                        {
                            if (data.classNamesToRemove)
                            {
                                $.each(data.classNamesToRemove, function(k, v)
                                {
                                    if (currentButton.hasClass(v))
                                    {
                                        currentButton.removeClass(v);
                                    }
                                });
                            }
                            if (data.classNamesToAdd)
                            {
                                $.each(data.classNamesToAdd, function (k, v)
                                {
                                    if (!currentButton.hasClass(v))
                                    {
                                        currentButton.addClass(v);
                                    }
                                });
                            }

                            if (data.newStatus)
                            {
                                await currentButton.find(".dynamicNavigatorStepStatus").viewpartHtml(data.newStatus);
                            }

                            if (data.updatedResumeNumber)
                            {
                                container.data("updatedResumeNumber", data.updatedResumeNumber);
                            }

                            if (data.redirectURL && data.redirectURL != null)
                            {
                                container.data("redirectURL", data.redirectURL);
                                var redirectURLArray = data.redirectURL.split("/");
                                $.when(skyward.window.loadContent("full", redirectURLArray[0], redirectURLArray[1], redirectURLArray[2], redirectURLArray.length > 3 ? redirectURLArray[3] : null)).done(function()
                                {
                                    deferredClick.resolve();
                                });
                            }
                            else
                            {
                                deferredClick.resolve();
                            }
                        }
                    },
                    error: function ()
                    {
                        deferredClick.resolve();
                    },
                    data: values
                });

                return ajax;
            }
            //todo: handle validation at some point
        };

        var getFieldValues = function (container)
        {
            var values = {};
            container.find("[name]").not(".doNotPost").each(function ()
            {
                var field = $(this);

                var name = field.attr("name");

                if (name == "")
                {
                    return;
                }

                if (field.is("sky-datepicker") && !field.hasClass("filterValue"))
                {
                    // For some reason, details save requires the date in this format
                    values[name] = field.encodedVal();
                }
                else
                {
                    var value = skyward.controls.getValue(field);
                    values[name] = (typeof value == "object") ? JSON.stringify(value) : value;
                }
            });

            container.find(".editablebrowse").each(function ()
            {
                var browse = $(this);
                var name = browse.attr("id");

                values[name] = JSON.stringify(browse.data("editablebrowsedata"));
            });

            container.find(".repeater").each(function ()
            {
                var repeater = $(this);
                var name = repeater.attr("id");

                values[name] = JSON.stringify(repeater.data("savedata"));
            });

            return values;
        };

        skyward.dynamicnavigator.navigatorStepButtonClick = function ()
        {
            var promise = new $.Deferred();

            var button = $(this);

            setTimeout(function ()
            {
                var buttonPadding = 20;
                var buttonLocation = button.offset().left - buttonPadding;
                var scroller = button.parents(".dynamicNavigator").find(".horizontalScroller");
                $(scroller).stop();
                scroller.animate({ scrollLeft: "+=" + buttonLocation }, 800);
            }, 100);

            var buttonData = button.data();
            var navigator = button.parents(".dynamicNavigatorWrapper").first();
            var contentDiv = navigator.find(".dynamicNavigatorContent");
            var currentActiveButton = navigator.find(".dynamicNavigatorStepButton.active");

            $.when(skyward.dynamicnavigator.saveContent(currentActiveButton)).done(function ()
            {
                contentDiv.empty();

                if (navigator.data().redirectURL)
                {
                    promise.resolve();
                    return promise.promise();
                }
                navigator.find(".dynamicNavigatorStepButton.active").removeClass("active");
                button.addClass("active");

                $.when(skyward.window.loadContent(contentDiv.attr("id"), buttonData.area, buttonData.controller, buttonData.action, buttonData.id, buttonData.postData)).done(function()
                {
                    skyward.fieldWrapper.alignTitles("#" + contentDiv.attr("id"));
                    promise.resolve();
                });

                processCustomButtons(button);
                processNavigationButtons(button)
            });

            button.trigger('dynamicNavigatorButtonClick');

            return promise.promise();
        };

        skyward.dynamicnavigator.navigatorNextButtonClick = function ()
        {
            var nextButton = $(this);
            var currentStepButton = nextButton.parents(".dynamicNavigatorWrapper").find(".dynamicNavigatorStepButton.active");
            navigatorNavigationButtonClick(nextButton, "next");
        };

        skyward.dynamicnavigator.navigatorPreviousButtonClick = function ()
        {
            var previousButton = $(this);
            var currentStepButton = previousButton.parents(".dynamicNavigatorWrapper").find(".dynamicNavigatorStepButton.active");
            navigatorNavigationButtonClick(previousButton, "previous");
        };

        var navigatorNavigationButtonClick = function(button, direction)
        {
            var currentStepButton = button.parents(".dynamicNavigatorWrapper").find(".dynamicNavigatorStepButton.active");
            var newStepDiv;
            if (direction == "next")
            {
                newStepDiv = currentStepButton.parents(".stepNavigator").first().next();
            }
            else
            {
                newStepDiv = currentStepButton.parents(".stepNavigator").first().prev();
            }
            newStepDiv.find(".dynamicNavigatorStepButton").click();
        }

        var start = function ()
        {
            skyward.dynamicnavigator.navigatorNextButtonClick.apply($(this));
        };

        var saveAndCompleteLater = function ()
        {
            var savebutton = $(this);
            var saveButtonData = savebutton.data();

            var navigator = savebutton.parents(".dynamicNavigatorWrapper").first();
            var currentActiveButton = navigator.find(".dynamicNavigatorStepButton.active");

            $.when(skyward.dynamicnavigator.saveContent(currentActiveButton)).done(function ()
            {
                if (saveButtonData && saveButtonData.redirectArea && saveButtonData.redirectController && saveButtonData.redirectAction)
                {
                    skyward.window.loadContent("full", saveButtonData.redirectArea, saveButtonData.redirectController, saveButtonData.redirectAction);
                }
            });
        };

        var resume = function () {
            var resumeButton = $(this);
            var resumeButtonData = resumeButton.data();
            var navigator = resumeButton.parents(".dynamicNavigatorWrapper");
            var navigatorData = navigator.data();

            var stepToResumeTo;
            if (navigatorData && navigatorData.updatedResumeNumber)
            {
                stepToResumeTo = $(navigator.find(".step")[navigatorData.updatedResumeNumber]).find(".dynamicNavigatorStepButton");
            }
            else if (!resumeButtonData || !resumeButtonData.resumeNumber)
            {
                stepToResumeTo = $(navigator.find(".step").last()).find(".dynamicNavigatorStepButton");
            }
            else
            {
                stepToResumeTo = $(navigator.find(".step")[resumeButtonData.resumeNumber]).find(".dynamicNavigatorStepButton");
            }

            skyward.dynamicnavigator.navigatorStepButtonClick.apply(stepToResumeTo);
        };

        var submit = function () {
            var button = $(this);
            var buttonData = button.data();

            if (!buttonData.submitArea || !buttonData.submitController || !buttonData.submitAction)
            {
                return;
            }

            var message = "Once you submit, you will not be able to return and make changes.";

            message += '<div class="dynamicNavigatorSubmitPopupDiv">';
            message +=
               '<a class="button chromeless roundedTwoColor secondary floatLeft noHover" data-click-action="dynamicnavigator.submitGoBack"><span class="anchorText buttonText">No, Go Back</span></a>';

            message +=
                '<a class="button chromeless roundedTwoColor primary floatRight noHover" data-click-action="dynamicnavigator.submitCommit"><span class="anchorText buttonText">Yes, Submit</span></a>';
            message += "</div>";

            var options =
            {
                id: "submitPopup",
                additionalDialogClass: "eeee",
                class: "sdf"
            };

            //TODO: come back and see if we can use more framework modal stuff
            var goBackButton = {
                id: "goBackButton", text: "No, Go Back", click: function () { dialog.close(); },
                additionalClasses: "roundedTwoColor primary right button"
            };
            //var submitButton = {
            //    id: "submitButton", text: "Yes, Submit", click: function () { dialog.close(); doSubmit(); },
            //    additionalClasses: "roundedTwoColor primary right button"
            //};
            
            //var dialog = skyward.modalLayer.showDialog('Are you sure?', message, [goBackButton, submitButton], options);

            var dialog = skyward.modalLayer.showInformationBubble('Are you sure?', message, [goBackButton], options);
        };

        var submitGoBack = function()
        {
            //TODO: come back and see if we can use more framework modal stuff
            var button = $(this);
            var modalLayerContainer = button.parents(".modalLayerContainer");
            modalLayerContainer.remove();
        };

        var submitCommit = function()
        {
            //TODO: come back and see if we can use more framework modal stuff
            var submitButton = $(".dynamicNavigatorButton.dynamicNavigatorSubmit");
            var buttonData = submitButton.data();

            if (!buttonData.submitArea || !buttonData.submitController || !buttonData.submitAction) {
                return;
            }
            skyward.window.loadContent("full", buttonData.submitArea, buttonData.submitController, buttonData.submitAction, buttonData.submitId, buttonData.postData);
        };

        var resize = function () {

            $(".dynamicNavigatorWrapper").each(function ()
            {
                var wrapper = $(this);
                var navigatorHeight = wrapper.find(".dynamicNavigator").outerHeight(true);
                wrapper.find(".dynamicNavigatorBody").css("top", navigatorHeight + "px");
            });
        };

        var events =
        {
            'start': start,
            'saveAndCompleteLater': saveAndCompleteLater,
            'resume': resume,
            'submit': submit,
            'submitGoBack': submitGoBack,
            'submitCommit': submitCommit
        };

        skyward.window.registerLayoutResizeCallback(resize);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('dynamicnavigator', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(function (skyward, $, undefined)
{
    skyward.massmovesectionstotargetcourse = skyward.massmovesectionstotargetcourse || {};

    "use strict";

    var init = function (selector)
    {
        var massMoveSectionsToTargetCourseCodeeel = $(selector).find("#MassMoveTargetCourseID");
        if (massMoveSectionsToTargetCourseCodeeel.length > 0)
        {
            $(massMoveSectionsToTargetCourseCodeeel).on("change", setCourseLengthFilterOnBrowse);
        }
        else
        {
            return;
        }
    };

    var setCourseLengthFilterOnBrowse = function ()
    {
        var browse = skyward.browse.browseList["SectionsToMove"];
        var courseID = skyward.controls.getValue($("#MassMoveTargetCourseID"));

        $.ajax(
            {
                url: skyward.global.virtualDir + "Scheduling/Section/SetFiltersOnSectionBrowse",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    CourseID: courseID
                },
                success: function (data)
                {
                    browse.dynamicFilterValues.filter = data.SearchCondition;
                    browse.dynamicFilterValues.filter_hash = data.SearchConditionHash;
                    skyward.browse.get("SectionsToMove", {});
                }
            });
    };

    //Bootstrap
    skyward.window.registerLoadDOMCallback(init);

}(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.massupdatecoursemaster = skyward.massupdatecoursemaster || {};

        "use strict";

        var meetDisplayPeriodCheckbox = "#SelectedField-MeetMeetDisplayPeriods";
        var meetDisplayPeriodDistinctMultiSelectEEL = "#Update-MeetMeetDisplayPeriods";
        var displayPeriodRotationCheckbox = "#SelectedField-MeetDisplayPeriodRotationID";
        var displayPeriodRotationSelectEEL = "#Update-MeetDisplayPeriodRotationID";

        var init = function (selector)
        {
            //Dependency logic does not trigger the checkbox change events automatically
            var massUpdateMeetDisplayPeriodDistinctMultiSelectEEL = $(selector).find(meetDisplayPeriodDistinctMultiSelectEEL);
            if (massUpdateMeetDisplayPeriodDistinctMultiSelectEEL)
            {
                massUpdateMeetDisplayPeriodDistinctMultiSelectEEL.on('change', skyward.massupdatecoursemaster.meetDisplayPeriodSelectEELCheckboxEventHandler);
            }

            var massUpdateMeetDisplayPeriodRotationSelectEEL = $(selector).find(displayPeriodRotationSelectEEL);
            if (massUpdateMeetDisplayPeriodRotationSelectEEL)
            {
                massUpdateMeetDisplayPeriodRotationSelectEEL.on('change', skyward.massupdatecoursemaster.displayPeriodRotationCheckboxEventHandler);
            }
        };

        skyward.massupdatecoursemaster.triggerChangeToUnrelatedButDependentCheckbox = function (currentCheckboxName, relatedCheckboxName)
        {
            var currentCheckbox = $(currentCheckboxName);
            var relatedCheckbox = $(relatedCheckboxName);

            if (currentCheckbox.prop('checked'))
            {
                if (currentCheckbox.hasClass('ui-disabled'))
                {
                    skyward.controls.enable(currentCheckbox);
                }
                skyward.controls.setValue(relatedCheckbox, "false");
                skyward.controls.disable(relatedCheckbox);
            }
            else
            {
                skyward.controls.enable(relatedCheckbox);
            }
        };

        skyward.massupdatecoursemaster.displayPeriodRotationCheckboxEventHandler = function ()
        {
            skyward.massupdatecoursemaster.triggerChangeToUnrelatedButDependentCheckbox(displayPeriodRotationCheckbox, meetDisplayPeriodCheckbox);
        };

        skyward.massupdatecoursemaster.meetDisplayPeriodSelectEELCheckboxEventHandler = function ()
        {
            skyward.massupdatecoursemaster.triggerChangeToUnrelatedButDependentCheckbox(meetDisplayPeriodCheckbox, displayPeriodRotationCheckbox);
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.successed = skyward.successed || {};
        
        var init = function (selector)
        {
            "use strict";

            var pageCheck = $(selector).find("#EC307842-96B3-49AC-A1A8-3338540F5D86");

            if (pageCheck.length > 0)
            {
                var handleImportTypeCodeChange = function ()
                {
                    var specialEdRadioButton = $("#ImportTypeCode_1");
                    var fileSelect = $("#fileSelect");
                    var chooseFileRadioButton;

                    if (specialEdRadioButton.is(":checked"))
                    {
                        chooseFileRadioButton = $("#FilePathOptionSpecial_1");
                    }
                    else
                    {
                        chooseFileRadioButton = $("#FilePathOptionRestraint_1");
                    }

                    if (chooseFileRadioButton.is(":checked"))
                    {
                        fileSelect.show();
                    }
                    else
                    {
                        fileSelect.hide();
                    }
                }

                var importTypeCode = $(selector).find("#ImportTypeCode");

                var importTypeCodeChange = function ()
                {
                    handleImportTypeCodeChange();
                }

                importTypeCode.on("change", importTypeCodeChange);
            }
        }
        
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        var PermissionState =
        {
            FALSE: 0,
            PARTIAL: 1,
            TRUE: 2
        };

        var MenuSecurityItem = function ()
        {
            this.Initialize();
        };
        MenuSecurityItem.prototype = new skyward.observable.Observable();
        MenuSecurityItem.prototype._name = "";
        MenuSecurityItem.prototype.Name = function (value, eventToken)
        {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._name)
                {
                    notify = true;
                }
                this._name = value;
                if (notify)
                {
                    this.notify("Name", eventToken);
                }
            }
            return this._name;
        }
        MenuSecurityItem.prototype._canAllowRead = false;
        MenuSecurityItem.prototype.CanAllowRead = function (value, eventToken)
        {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowRead)
                {
                    notify = true;
                }
                this._canAllowRead = value;
                if (notify)
                {
                    this.notify("CanAllowRead", eventToken);
                }
            }
            return this._canAllowRead;
        }
        MenuSecurityItem.prototype._read = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateRead = function (value)
        {
            if (value == PermissionState.FALSE)
            {
                this.Update(value);
                this.Create(value);
                this.Delete(value);
                this.Delete(value);
                this.MassUpdate(value);
                this.MassCreate(value);
                this.MassDelete(value);
            }
        };
        MenuSecurityItem.prototype.Read = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null)
            {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._read)
                {
                    notify = true;
                }
                this._read = value;
                if (propogate)
                {
                    this.propogateRead(value);
                }
                if (notify)
                {
                    this.notify("Read", eventToken);
                }

            }
            return this.CanAllowRead() ? this._read : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype._canAllowUpdate = false;
        MenuSecurityItem.prototype.CanAllowUpdate = function (value, eventToken)
        {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null)
            {
                var notify = false;
                if (value != this._canAllowUpdate)
                {
                    notify = true;
                }
                this._canAllowUpdate = value;
                if (notify) {
                    this.notify("CanAllowUpdate", eventToken);
                }
            }
            return this._canAllowUpdate;
        }
        MenuSecurityItem.prototype._update = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateUpdate = function (value)
        {
            if (value == PermissionState.TRUE)
            {
                this.Read(value);
            }
        };
        MenuSecurityItem.prototype.Update = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null)
            {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._update)
                {
                    notify = true;
                }
                this._update = value;

                if (propogate)
                {
                    this.propogateUpdate(value);
                }
                if (notify)
                {
                    this.notify("Update", eventToken);
                }

            }
            return this.CanAllowUpdate() ? this._update : PermissionState.FALSE;
        }

        MenuSecurityItem.prototype._canAllowCreate = false;
        MenuSecurityItem.prototype.CanAllowCreate = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowCreate) {
                    notify = true;
                }
                this._canAllowCreate = value;
                if (notify) {
                    this.notify("CanAllowCreate", eventToken);
                }
            }
            return this._canAllowCreate;
        }
        MenuSecurityItem.prototype._create = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateCreate = function (value) {
            if (value == PermissionState.TRUE) {
                this.Update(value);
            }
        }
        MenuSecurityItem.prototype.Create = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._create) {
                    notify = true;
                }
                this._create = value;

                if (propogate)
                    this.propogateCreate(value);

                if (notify) {
                    this.notify("Create", eventToken);
                }

            }
            return this.CanAllowCreate() ? this._create : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype._canAllowDelete = false;
        MenuSecurityItem.prototype.CanAllowDelete = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowDelete) {
                    notify = true;
                }
                this._canAllowDelete = value;
                if (notify) {
                    this.notify("CanAllowDelete", eventToken);
                }
            }
            return this._canAllowDelete;
        }
        MenuSecurityItem.prototype._delete = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateDelete = function (value) {
            if (value == PermissionState.TRUE) {
                this.Create(value);
            }
        };
        MenuSecurityItem.prototype.Delete = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._delete) {
                    notify = true;
                }
                this._delete = value;


                if (propogate)
                    this.propogateDelete(value);

                if (notify) {
                    this.notify("Delete", eventToken);
                }

            }
            return this.CanAllowDelete() ? this._delete : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype._canAllowMassUpdate = false;
        MenuSecurityItem.prototype.CanAllowMassUpdate = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowMassUpdate) {
                    notify = true;
                }
                this._canAllowMassUpdate = value;
                if (notify) {
                    this.notify("CanAllowMassUpdate", eventToken);
                }
            }
            return this._canAllowMassUpdate;
        }
        MenuSecurityItem.prototype._massUpdate = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateMassUpdate = function (value) {
            if (value == PermissionState.TRUE) {
                this.Delete(value);
            }
        };
        MenuSecurityItem.prototype.MassUpdate = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._massUpdate) {
                    notify = true;
                }
                this._massUpdate = value;

                if (propogate)
                    this.propogateMassUpdate(value);
                if (notify) {
                    this.notify("MassUpdate", eventToken);
                }

            }
            return this.CanAllowMassUpdate() ? this._massUpdate : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype._canAllowMassCreate = false;
        MenuSecurityItem.prototype.CanAllowMassCreate = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowMassCreate) {
                    notify = true;
                }
                this._canAllowMassCreate = value;
                if (notify) {
                    this.notify("CanAllowMassCreate", eventToken);
                }
            }
            return this._canAllowMassCreate;
        }
        MenuSecurityItem.prototype._massCreate = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateMassCreate = function (value) {
            if (value == PermissionState.TRUE) {
                this.MassUpdate(value);
            }
        };
        MenuSecurityItem.prototype.MassCreate = function (value, eventToken, propogate) {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._massCreate) {
                    notify = true;
                }
                this._massCreate = value;


                if (propogate)
                    this.propogateMassCreate(value);

                if (notify) {
                    this.notify("MassCreate", eventToken);
                }

            }
            return this.CanAllowMassCreate() ? this._massCreate : PermissionState.FALSE;
        }
        
        MenuSecurityItem.prototype._canAllowMassDelete = false;
        MenuSecurityItem.prototype.CanAllowMassDelete = function (value, eventToken) {
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null) {
                var notify = false;
                if (value != this._canAllowMassDelete) {
                    notify = true;
                }
                this._canAllowMassDelete = value;
                if (notify) {
                    this.notify("CanAllowMassDelete", eventToken);
                }
            }
            return this._canAllowMassDelete;
        }
        MenuSecurityItem.prototype._massDelete = PermissionState.FALSE;
        MenuSecurityItem.prototype.propogateMassDelete = function (value) {
            if (value == PermissionState.TRUE) {
                this.MassCreate(value);
            }
        };
        MenuSecurityItem.prototype.MassDelete = function (value, eventToken, propogate)
        {
            if (propogate === undefined) propogate = true;
            eventToken = eventToken || new skyward.observable.Event();
            if (value != null)
            {
                var notify = false;
                if (!this.eventProcessed(eventToken) && value != this._massDelete)
                {
                    notify = true;
                }
                this._massDelete = value;

                if (propogate)
                {
                    this.propogateMassDelete(value);
                }
                if (notify)
                {
                    this.notify("MassDelete", eventToken);
                }

            }
            return this.CanAllowMassDelete() ? this._massDelete : PermissionState.FALSE;
        }
        MenuSecurityItem.prototype.grantsAnyPermission = function ()
        {
            return this.MassDelete() ||
                this.MassCreate() ||
                this.MassUpdate() ||
                this.Delete() ||
                this.Update() ||
                this.Create() ||
                this.Read();
        }


        var MenuSecurityItemGroup = function ()
        {
            this.Initialize();
            this.members = [];
        };
        MenuSecurityItemGroup.prototype = new MenuSecurityItem();
        MenuSecurityItemGroup.prototype.members = [];
        MenuSecurityItemGroup.prototype.UpdateMemberEvent = function (property, member, eventToken)
        {
            var that = this;
            var CreateUpdateMethod = function (property, propertyMethod)
            {
                return function (eventToken)
                {
                    if (!member.eventProcessed(eventToken))
                    {
                        if (property() == PermissionState.FALSE)
                        {
                            propertyMethod(PermissionState.FALSE, eventToken);
                        }
                        else if (property() == PermissionState.TRUE)
                        {
                            propertyMethod(PermissionState.TRUE, eventToken);
                        }
                    }
                }
            };
            switch (property)
            {
                case "Read":
                    return CreateUpdateMethod(function() { return that.Read();}, function (value, eventToken) { return member.Read(value, eventToken, false); });
                case "Update":
                    return CreateUpdateMethod(function () { return that.Update(); }, function (value, eventToken) { return member.Update(value, eventToken, false); });
                case "Create":
                    return CreateUpdateMethod(function () { return that.Create(); }, function (value, eventToken) { return member.Create(value, eventToken, false); });
                case "Delete":
                    return CreateUpdateMethod(function () { return that.Delete(); }, function (value, eventToken) { return member.Delete(value, eventToken, false); });
                case "MassUpdate":
                    return CreateUpdateMethod(function () { return that.MassUpdate(); }, function (value, eventToken) { return member.MassUpdate(value, eventToken, false); });
                case "MassCreate":
                    return CreateUpdateMethod(function () { return that.MassCreate(); }, function (value, eventToken) { return member.MassCreate(value, eventToken, false); });
                case "MassDelete":
                    return CreateUpdateMethod(function () { return that.MassDelete(); }, function (value, eventToken) { return member.MassDelete(value, eventToken, false); });
            }
        }
        MenuSecurityItemGroup.prototype.ApplyRecalculation = function (allTrue, allFalse, propertyApplicator)
        {
            if (allTrue)
            {
                propertyApplicator(PermissionState.TRUE);
            }
            else if (allFalse)
            {
                propertyApplicator(PermissionState.FALSE);
            }
            else
            {
                propertyApplicator(PermissionState.PARTIAL);
            }
        };
        MenuSecurityItemGroup.prototype.GetCollectiveValues = function (members, operation) {
            var total = 0;
            for (var i = 0; i < this.members.length; i++) {
                
                total += operation(this.members[i]);
            }
            return total;
        }
        MenuSecurityItemGroup.prototype.GetNumberOfApplicableMembers = function (members, operation) {
            var total = 0;
            for (var i = 0; i < members.length; i++) {
                total += operation(this.members[i]);
            }
            return total;
        }
        MenuSecurityItemGroup.prototype.RecalculateRead = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowRead(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.CanAllowRead() * member.Read(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) {  that.Read(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateUpdate = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowUpdate(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.CanAllowUpdate() * member.Update(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.Update(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateCreate = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowCreate(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.CanAllowCreate() * member.Create(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.Create(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateDelete = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowDelete(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.Delete(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.Delete(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateMassUpdate = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowMassUpdate(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.MassUpdate(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.MassUpdate(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateMassCreate = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowMassCreate(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.MassCreate(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.MassCreate(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.RecalculateMassDelete = function (eventToken) {
            var that = this;
            var applicableMembers = this.GetNumberOfApplicableMembers(this.members, function (member) { return member.CanAllowMassDelete(); });
            var total = this.GetCollectiveValues(this.members, function (member) { return member.MassDelete(); });
            this.ApplyRecalculation(total === applicableMembers * PermissionState.TRUE, total === 0, function (value) { that.MassDelete(value, eventToken, false) });
        };
        MenuSecurityItemGroup.prototype.AddMember = function (member) {
            var that = this;
            this.members.push(member);

            var DoBinding = function (memberCanAllow, myCanAllowFunction, recalculateFunction, propertyName) {
                if (memberCanAllow) {
                    myCanAllowFunction(true);
                }

                that.observers[propertyName] = that.observers[propertyName] || [];
                member.observers[propertyName] = member.observers[propertyName] || [];
                that.observers[propertyName].push(that.UpdateMemberEvent(propertyName, member));

                member.observers[propertyName].push(function (eventToken) {
                    if (!that.eventProcessed(eventToken)) {
                        recalculateFunction(eventToken);
                    }
                });
            }

            DoBinding(member.CanAllowRead(), function (value) { return that.CanAllowRead(value); }, function (eventToken) { that.RecalculateRead(eventToken); }, "Read");
            DoBinding(member.CanAllowUpdate(), function (value) { return that.CanAllowUpdate(value); }, function (eventToken) { that.RecalculateUpdate(eventToken); }, "Update");
            DoBinding(member.CanAllowCreate(), function (value) { return that.CanAllowCreate(value); }, function (eventToken) { that.RecalculateCreate(eventToken); }, "Create");
            DoBinding(member.CanAllowDelete(), function (value) { return that.CanAllowDelete(value); }, function (eventToken) { that.RecalculateDelete(eventToken); }, "Delete");
            DoBinding(member.CanAllowMassUpdate(), function (value) { return that.CanAllowMassUpdate(value); }, function (eventToken) { that.RecalculateMassUpdate(eventToken); }, "MassUpdate");
            DoBinding(member.CanAllowMassCreate(), function (value) { return that.CanAllowMassCreate(value); }, function (eventToken) { that.RecalculateMassCreate(eventToken); }, "MassCreate");
            DoBinding(member.CanAllowMassDelete(), function (value) { return that.CanAllowMassDelete(value); }, function (eventToken) { that.RecalculateMassDelete(eventToken); }, "MassDelete");

            this.RecalculateRead(new skyward.observable.Event());
            this.RecalculateUpdate(new skyward.observable.Event());
            this.RecalculateCreate(new skyward.observable.Event());
            this.RecalculateDelete(new skyward.observable.Event());
            this.RecalculateMassUpdate(new skyward.observable.Event());
            this.RecalculateMassCreate(new skyward.observable.Event());
            this.RecalculateMassDelete(new skyward.observable.Event());
        };

        var MenuSecurityViewFactory = function () { };

        var setCheckboxNamesForPost = function (view, menuSecurityID)
        {
            // TODO only set the name on checkboxes that are CanAllow == true.
            var checkboxes = view.find("input.checkbox[data-permission]");
            checkboxes.each(function () {
                var nameValue = "menusecurityitem-" + menuSecurityID + "-" + $(this).attr("data-permission");
                $(this).attr("name", nameValue);
            });
        }

        MenuSecurityViewFactory.prototype.CreateView = function (menuSecurityItemModel, customDisplayFunction, customValueChangedFunction)
        {
            customDisplayFunction = customDisplayFunction || function (view, menuSecurityItemModel)
            {
                var label = view.find(".menuSecurityLabel")[0];
                $(label).text(menuSecurityItemModel.Name());
            };

            var GetMenuSecurityView = function ()
            {
                var result = $("tr.menuSecurityTemplate").first().clone();
                result.removeClass("menuSecurityTemplate");
                return result;
            };

            var SetCheckedStatus = function (checkbox, value)
            {
                checkbox.prop('checked', value);
                checkbox.prop('indeterminate', value == PermissionState.PARTIAL);
            };

            var ToggleModuleSecurityAccessIcon = function (view, model)
            {
                var icon = view.find(".menuSecurityModuleSecurityAccess")
                if (model.grantsAnyPermission() && !icon.hasClass("menuSecurityTemplate"))
                {
                    icon.addClass("granted");
                }
                else
                {
                    icon.removeClass("granted");
                }
            };

            var view = GetMenuSecurityView();

            var bindCheckbox = function (permissionString, canAllowFunction, permissionFunction)
            {
                if (!canAllowFunction())
                {
                    view.find("input.checkbox[data-permission='" + permissionString.toLowerCase() + "']").first().remove();
                }
                else
                {
                    var ucb = view.find("input.checkbox[data-permission='" + permissionString.toLowerCase() + "']").first();
                    SetCheckedStatus(ucb, permissionFunction());

                    // Create the model when the view changes.
                    ucb.change(function (event)
                    {
                        if (this.classList.contains("ui-disabled"))
                        {
                            event.preventDefault();
                            return;
                        }
                        
                        // This is because on IE/Edge, change() happens before click() and the change tracking won't know that the screen is dirty yet.
                        // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6274500/
                        skyward.changeTracking.getChangeTracker(this).overrideDirtyState(true);
                        
                    });
                    ucb.click(function (event)
                    {
                        if (this.classList.contains("ui-disabled"))
                        {
                            event.preventDefault();
                            return;
                        }

                        skyward.changeTracking.getChangeTracker(this).overrideDirtyState(true);
                        var event = new skyward.observable.Event();
                        permissionFunction(ucb.prop("checked") ? PermissionState.TRUE : PermissionState.FALSE, event);
                        ucb.data("events", ucb.data("events") + "," + event.EventID);
                        
                    });
                    
                    // Create the view when the model changes.
                    menuSecurityItemModel.observers[permissionString] = menuSecurityItemModel.observers[permissionString] || [];
                    menuSecurityItemModel.observers[permissionString].push(function (eventToken)
                    {
                        var eventHandled = false;
                        if (ucb.data("events") !== "")
                        {
                            var handledEvents = ucb.data("events").split(",");
                            if (handledEvents.includes(eventToken.EventID))
                            {
                                eventHandled = true;
                            }
                        }

                        if (!eventHandled)
                        {
                            SetCheckedStatus(ucb, permissionFunction());
                            ucb.data("events", ucb.data("events") + "," + eventToken.EventID);

                            ToggleModuleSecurityAccessIcon(view, menuSecurityItemModel);
                            if (customValueChangedFunction)
                            {
                                customValueChangedFunction();
                            }
                        }
                    });
                }
            }
            bindCheckbox('Read', function () { return menuSecurityItemModel.CanAllowRead(); }, function (value, eventToken) { return menuSecurityItemModel.Read(value, eventToken); });
            bindCheckbox('Update', function () { return menuSecurityItemModel.CanAllowUpdate(); }, function (value, eventToken) { return menuSecurityItemModel.Update(value, eventToken); });
            bindCheckbox('Create', function () { return menuSecurityItemModel.CanAllowCreate(); }, function (value, eventToken) { return menuSecurityItemModel.Create(value, eventToken); });
            bindCheckbox('Delete', function () { return menuSecurityItemModel.CanAllowDelete(); }, function (value, eventToken) { return menuSecurityItemModel.Delete(value, eventToken); });
            bindCheckbox('MassUpdate', function () { return menuSecurityItemModel.CanAllowMassUpdate(); }, function (value, eventToken) { return menuSecurityItemModel.MassUpdate(value, eventToken); });
            bindCheckbox('MassCreate', function () { return menuSecurityItemModel.CanAllowMassCreate(); }, function (value, eventToken) { return menuSecurityItemModel.MassCreate(value, eventToken); });
            bindCheckbox('MassDelete', function () { return menuSecurityItemModel.CanAllowMassDelete(); }, function (value, eventToken) { return menuSecurityItemModel.MassDelete(value, eventToken); });
            
            if (!(menuSecurityItemModel instanceof MenuSecurityItemGroup))
            {
                setCheckboxNamesForPost(view, menuSecurityItemModel.MenuSecurityItemID);
            }

            customDisplayFunction(view, menuSecurityItemModel);

            view.attr("data-name", menuSecurityItemModel.Name());
            view.attr("data-menuscreenid", menuSecurityItemModel.MenuScreenID);
            ToggleModuleSecurityAccessIcon(view, menuSecurityItemModel);
            return view;
        };

        skyward.menusecurity = skyward.menusecurity || {};
        skyward.menusecurity.MenuSecurityItem = MenuSecurityItem;
        skyward.menusecurity.MenuSecurityItemGroup = MenuSecurityItemGroup;
        skyward.menusecurity.MenuSecurityViewFactory = MenuSecurityViewFactory;

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        var factory = new skyward.menusecurity.MenuSecurityViewFactory();

        // TODO make all of this stuff unique to the control instead of assuming there's only one on the screen.
        skyward.menusecuritylayout = skyward.menusecuritylayout || {};
        skyward.menusecuritylayout.loadPortal = function (portalCode) { };

        var deserializeJsonValues = function (jsonObject, target, ignoredProperties)
        {
            for (var key in jsonObject)
            {
                if (!ignoredProperties.includes(key))
                {
                    if (typeof target[key] === "function")
                    {
                        target[key](jsonObject[key], null, false);
                    }
                    else
                    {
                        target[key] = jsonObject[key];
                    }
                }
            }
        }

        var getMenuSecurityItems = function (itemsListJson)
        {
            var result = [];
            for (var item in itemsListJson)
            {
                if (itemsListJson[item].Name.toUpperCase() === "FEATURES" || itemsListJson[item].Name.toUpperCase() === "REPORTS")
                {
                    itemsListJson[item]["Column"] = 0;
                }
                else
                {
                    itemsListJson[item]["Column"] = 1;
                }

                if (itemsListJson[item].Type == "Group")
                {
                    var msig = new skyward.menusecurity.MenuSecurityItemGroup();
                    var ignoredProperties = ["Type", "Items"];
                    deserializeJsonValues(itemsListJson[item], msig, ignoredProperties);

                    var itemsJson = itemsListJson[item].Items;
                    var items = getMenuSecurityItems(itemsJson);
                    for (var j in items)
                    {
                        msig.AddMember(items[j]);
                    }
                    result.push(msig);
                }
                else if (itemsListJson[item].Type == "SecurityItem")
                {
                    var msi = new skyward.menusecurity.MenuSecurityItem();
                    var ignoredProperties = ["Type"];

                    deserializeJsonValues(itemsListJson[item], msi, ignoredProperties);
                    result.push(msi);
                }
            }
            return result;
        }

        var getMenuSecurityItemTree = function (jsonData)
        {
            var results = [];
            for (var module in jsonData.Modules)
            {
                var item = new skyward.menusecurity.MenuSecurityItemGroup();
                var ignoredProperties = ["Type", "Categories"];
                deserializeJsonValues(jsonData.Modules[module], item, ignoredProperties);

                var items = getMenuSecurityItems(jsonData.Modules[module].Categories);
                for (var j in items)
                {
                    item.AddMember(items[j]);
                }
                results.push(item);
            }
            return results;
        }

        var toggleSecurityGrantedIcon = function (portalCode, markLoaded)
        {
            if (markLoaded)
            {
                $(".menuSecurityPortalButton[data-portal='" + portalCode + "']").addClass("loaded");
            }

            var accessIcon = $("a[data-portal='" + portalCode + "'] svg.menuSecurityPortalButtonSecurityAccess");
            if ($(".menuSecurityGrid[data-portal='" + portalCode + "'] .menuSecurityModuleSecurityAccess.granted").length > 0)
            {
                accessIcon.addClass("granted");
            }
            else
            {
                accessIcon.removeClass("granted");
            }
        }

        // Creates the views for the modules on the left side.
        var populateModuleList = function (moduleContainerSelector, moduleTableContainerSelector, menuSecurityItemTree, portalCode)
        {
            var generateModuleClickEvent = function (portalCode, moduleName)
            {
                return function ()
                {
                    skyward.menusecuritylayout.displayItemsForModule(portalCode, moduleName);
                }
            }

            var table = $(moduleTableContainerSelector)[0];


            for (var i in menuSecurityItemTree)
            {
                var row = factory.CreateView(menuSecurityItemTree[i], function (view, model)
                {
                    view.addClass("moduleRow");
                    var label = view.find(".menuSecurityLabel")[0];
                    $(label).text(model.Name());
                    $(label).addClass("menuSecurityModuleText");
                    var svg = view.find("svg.menuModuleSvg.menuSecurityTemplate ");
                    svg.removeClass("menuSecurityTemplate");
                    svg.find("use").attr("href", "#svg-" + model.ImageCode);

                    var securityIndicator = view.find("svg.menuSecurityModuleSecurityAccess.menuSecurityTemplate");
                    securityIndicator.removeClass("menuSecurityTemplate");

                    var newAnchor = "<a class='menuSecurityModuleLabel' href='javascript:void(0)'></a>";
                    securityIndicator.before(newAnchor);
                    view.find("td.menuSecurityGridLabel a").append(svg, label);

                    // If the module panel is collapsed, make sure these load up as collapsed as well.
                    if ($(moduleContainerSelector).hasClass("moduleCollapsed"))
                    {
                        view.find("td.menuSecurityGridPermission").addClass("menuSecurityModuleItemCellCollapsed");
                    }

                }, function ()
                {
                    toggleSecurityGrantedIcon(portalCode);
                });
                row.click(generateModuleClickEvent(portalCode, menuSecurityItemTree[i].Name()));
                $(table).append(row);
                getAlternatingRows($(table));
            }
        }

        var markUnloadedPortalsAsHavingSecurity = function (items)
        {
            for (var i in items)
            {
                $(".menuSecurityPortalButton[data-portal='" + items[i] + "']:not(.loaded) .menuSecurityPortalButtonSecurityAccess").addClass("granted");
            }
        }

        var deserializePortal = function (jsonData)
        {
            var generateModuleGrid = function (portalCode)
            {
                var result = $(".menuSecurityGridTemplate").first().clone(); // Could be more specific.
                result.removeClass("menuSecurityGridTemplate");
                result.addClass("menuSecurityLayoutInactive");
                result.attr("data-portal", portalCode);
                return result;
            }

            var portalCode = jsonData.Portal;
            var loadedPortals = $(".menuSecurityPortalButton.loaded").map(function () { return $(this).attr("data-portal"); }).get();

            if (!loadedPortals.includes(portalCode))
            {
                loadedPortals.push(portalCode);
                var allGrantedPortals = jsonData.AllPortalsForRole;
                var containerTable = generateModuleGrid(jsonData.Portal);
                $("div.menuContainer div.moduleContainer div.menuSecurityItemGridContainer").append(containerTable);

                var modelTree = getMenuSecurityItemTree(jsonData);
                populateModuleList("div.moduleContainer div.menuSecurityItemBody", "div.moduleContainer table.menuSecurityGrid[data-portal='" + portalCode + "']", modelTree, portalCode);

                // Generate all of the views for the categories and their items.
                for (var i in modelTree)
                {
                    createItemLayoutForModule(portalCode, modelTree[i]);
                }

                skyward.menusecuritylayout.displayModulesForPortal(portalCode);

                toggleSecurityGrantedIcon(portalCode, true);
                markUnloadedPortalsAsHavingSecurity(allGrantedPortals);
            }
        }

        var hideAllMenuSecurityLocationContainers = function ()
        {
            var allMenuSecurityLocationContainers = $("div.menuContainer div.menuSecurityCategoryContainer table.menuSecurityGrid");
            allMenuSecurityLocationContainers.each(function () { $(this).addClass("menuSecurityLayoutInactive") });
            return allMenuSecurityLocationContainers;
        }

        skyward.menusecuritylayout.displayModulesForPortal = function (portalCode, roleID)
        {
            $(".menuSecurityPortalButton").removeClass("menuSecurityPortalButtonSelected");
            $(".menuSecurityPortalButton[data-portal='" + portalCode + "']").addClass("menuSecurityPortalButtonSelected");

            // TODO add selector for the layout control's ID.
            // Locate and hide all existing module divs.
            var allModuleGrids = $("div.moduleContainer table.menuSecurityGrid"); // TODO this is a weird selector.
            allModuleGrids.each(function () { $(this).addClass("menuSecurityLayoutInactive") });

            hideAllMenuSecurityLocationContainers();

            // if the one for the portal we want doesn't exist yet, load it.
            var existingModuleContainer = allModuleGrids.filter(function () { return $(this).data("portal") == portalCode; });
            if (existingModuleContainer.length > 0)
            {
                $(existingModuleContainer[0]).removeClass("menuSecurityLayoutInactive");

                var moduleViews = $(existingModuleContainer[0]).find("tr[data-name]");

                // Auto-select the top module.
                if (moduleViews.length > 0)
                {
                    skyward.menusecuritylayout.displayItemsForModule(portalCode, $(moduleViews[0]).attr("data-name"));
                }
            }
            else if (roleID != undefined)
            {
                // Load the portal.
                retrieveMenuSecurityItemsForPortal(portalCode, roleID); // TODO hardcoded roleid.
            }

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Security/Role/UpdateMenuSecurityPagestate",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        PortalCode: portalCode
                    }
                });
        }

        var collapseItem = function (tableElement, parentViewName, parentViewMenuScreenID, topLevelParentViewName, expandButton, collapseButton, itemtype)
        {
            var expandedChildren = $(tableElement).find("tr[data-toplevelparentview='" + topLevelParentViewName + "'][data-parentview='" + parentViewName + "'][data-parentviewmenuscreenid='" + parentViewMenuScreenID + "'][data-parenttype='" + itemtype + "']");
            expandedChildren.addClass("menuSecurityItemCollapsed");
            expandButton.addClass("buttonSvg");
            expandButton.removeClass("svgHidden");
            collapseButton.removeClass("buttonSvg");
            collapseButton.addClass("svgHidden");

            expandedChildren.each(function () 
            {
                var expandedChild = $(this);
                collapseItem(tableElement, expandedChild.attr("data-name"), expandedChild.attr("data-menuscreenid"), parentViewName, expandedChild.find("svg.menuSecurityItemExpand"), expandedChild.find("svg.menuSecurityItemCollapse"), expandedChild.attr("itemType")); 
            });
        }

        var getChildToggleFunction = function (collapsed, tableElement, parentViewName, parentViewMenuScreenID, topLevelParentViewName, layer)
        {
            return function (view, model)
            {
                view.find("td").addClass("menuSecurityCategoryGridCell");

                var label = view.find(".menuSecurityLabel")[0];  
                $(label).text(model.Name());
                $(label).addClass("menuSecurityLayer" + layer + "Label");
                var itemtype = "layer" + layer;
                view.attr("itemType", itemtype);
                if (collapsed)
                {
                    view.addClass("menuSecurityItemCollapsed");
                }

                if (model instanceof skyward.menusecurity.MenuSecurityItemGroup)
                {
                    var toggleButton = $(view).find("a.menuSecurityItemToggleChildren");
                    toggleButton.removeClass("menuSecurityTemplate");
                    toggleButton.click(function ()
                    {
                        var children = $(tableElement).find("tr.menuSecurityItemCollapsed[data-toplevelparentview='" + topLevelParentViewName + "'][data-parentview='" + parentViewName + "'][data-parentviewmenuscreenid='" + parentViewMenuScreenID + "'][data-parenttype='" + itemtype + "']");
                        var collapsed = children.length > 0;
                        var expandButton = $(view).find("svg.menuSecurityItemExpand");
                        var collapseButton = $(view).find("svg.menuSecurityItemCollapse");

                        // Toggle children.
                        if (collapsed)
                        {
                            children.removeClass("menuSecurityItemCollapsed");
                            expandButton.removeClass("buttonSvg");
                            expandButton.addClass("svgHidden");
                            collapseButton.addClass("buttonSvg");
                            collapseButton.removeClass("svgHidden");
                            if (layer == 1)
                            {
                                $(view).find("td.menuSecurityGridLabel").removeClass("childrenNotExpanded");
                                $(view).find("td.menuSecurityGridLabel").addClass("childrenExpanded");
                            }
                        }
                        else
                        {
                            collapseItem(tableElement, parentViewName, parentViewMenuScreenID, topLevelParentViewName, expandButton, collapseButton, itemtype);
                            $(view).find("td.menuSecurityGridLabel").addClass("childrenNotExpanded");
                            $(view).find("td.menuSecurityGridLabel").removeClass("childrenExpanded");
                        }

                        getAlternatingRows(tableElement);
                    });
                }
            }
        }

        // Profile sub-tabs.
        var populateThirdLayerItems = function (tableElement, profileTabRoot)
        {
            var results = [];
            for (var i in profileTabRoot.members)
            {
                var row = factory.CreateView(profileTabRoot.members[i], function (view, model)
                {
                    view.attr("itemType", "layer3");
                    var label = view.find(".menuSecurityLabel")[0];
                    $(label).text(model.Name());
                    $(label).addClass("menuSecurityLayer3Label");
                    view.addClass("menuSecurityItemCollapsed");
                    view.find("td").addClass("menuSecurityCategoryGridCell");
                    $(view).find("td.menuSecurityGridLabel").addClass("menuSecurityProfileTabItem");

                    if (i == profileTabRoot.members.length - 1)
                    {
                        $(view).find("td.menuSecurityGridLabel").addClass("menuSecurityProfileTabItemLast");
                    }

                });
                results.push(row);
            }
            return results;
        }

        // Profile categories
        var populateSecondLayerItems = function (tableElement, profileRoot)
        {
            var results = [];
            for (var i in profileRoot.members)
            {
                var currentMember = profileRoot.members[i];

                var childRows = populateThirdLayerItems(tableElement, currentMember);
                for (var j in childRows)
                {
                    childRows[j].attr("data-toplevelparentview", profileRoot.Name());
                    childRows[j].attr("data-parentview", currentMember.Name());
                    childRows[j].attr("data-parentviewmenuscreenid", currentMember.MenuScreenID);
                    childRows[j].attr("data-parenttype", "layer2");
                }
                var childToggleFunction = getChildToggleFunction(true, tableElement, currentMember.Name(), currentMember.MenuScreenID, profileRoot.Name(), 2);
                var row = factory.CreateView(currentMember,
                    function (view, model)
                    {
                        childToggleFunction(view, model);
                        $(view).find("td.menuSecurityGridLabel").addClass("menuSecurityProfileTabGroup");
                    });

                results.push(row);
                for (var j in childRows)
                {
                    results.push(childRows[j]);
                }
            }
            return results;
        }

        // Profile or items
        var populateFirstLayerItems = function (tableElement, categoryRoot, column)
        {
            for (var i in categoryRoot.members)
            {
                var currentMember = categoryRoot.members[i];

                var childRows = populateSecondLayerItems(tableElement, currentMember);
                for (var j in childRows)
                {
                    if (!childRows[j].attr("data-parentview"))
                    {
                        childRows[j].attr("data-toplevelparentview", categoryRoot.Name());
                        childRows[j].attr("data-parentview", currentMember.Name());
                        childRows[j].attr("data-parentviewmenuscreenid", currentMember.MenuScreenID);
                        childRows[j].attr("data-parenttype", "layer1");
                    }
                }

                var childToggleFunction = getChildToggleFunction(false, tableElement, currentMember.Name(), currentMember.MenuScreenID, categoryRoot.Name(), 1);

                var row = factory.CreateView(currentMember,
                    function (view, model)
                    {
                        childToggleFunction(view, model);
                        $(view).find("td.menuSecurityGridLabel").addClass("menuSecurityProfile");
                        $(view).find("td.menuSecurityGridLabel").addClass("childrenNotExpanded");
                        $(view).find("td.menuSecurityGridLabel").addClass("column" + column);
                    });

                $(tableElement).append(row);
                for (var j in childRows)
                {
                    $(tableElement).append(childRows[j]);
                }
            }
        }

        var getAlternatingRows = function (table)
        {
            var rows = table.find("tr");
            var alternator = false;

            rows.each(function ()
            {
                $(this).removeClass("permissionRow0");
                $(this).find("td.menuSecurityGridPermission").each(function () { $(this).removeClass("permissionCell0") });
                $(this).removeClass("permissionRow1");
                $(this).find("td.menuSecurityGridPermission").each(function () { $(this).removeClass("permissionCell1") });

            });

            rows.each(function ()
            {
                if (!$(this).hasClass("menuSecurityItemCollapsed"))
                {
                    if ($(this).attr("itemType") == "category")
                    {
                        alternator = false;
                    }
                    else
                    {
                        alternator = !alternator;
                        $(this).addClass(alternator ? "permissionRow0" : "permissionRow1");
                        $(this).find("td.menuSecurityGridPermission").each(function () { $(this).addClass(alternator ? "permissionCell0" : "permissionCell1") });
                    }
                }
            });
        }

        var populateItemLayoutForModule = function (table0, table1, moduleRoot)
        {
            var tables = [table0, table1];
            for (var i in moduleRoot.members)
            {
                var row = factory.CreateView(moduleRoot.members[i], function (view, model)
                {
                    view.find("td").addClass("menuSecurityCategoryCell");
                    var label = view.find(".menuSecurityLabel")[0];
                    $(label).text(model.Name());
                    view.attr("itemType", "category");
                    $(label).addClass("menuSecurityCategoryLabel");

                });
                var table = tables[moduleRoot.members[i].Column];
                $(table).append(row);
                if (moduleRoot.members[i].members.length > 0)
                {
                    populateFirstLayerItems(table, moduleRoot.members[i], moduleRoot.members[i].Column);
                    getAlternatingRows(table);
                }
            }
        }

        var createItemLayoutForModule = function (portalCode, moduleRoot)
        {
            var table0 = $("table.menuSecurityGridTemplate").first().clone();
            table0.removeClass("menuSecurityGridTemplate");
            table0.attr("data-module", moduleRoot.Name());
            table0.attr("data-portal", portalCode);
            table0.insertBefore($("div.menuSecurityCategoryContainer0 .menuSecurityFillerContainer "));

            var table1 = $("table.menuSecurityGridTemplate").first().clone();
            table1.removeClass("menuSecurityGridTemplate");
            table1.attr("data-module", moduleRoot.Name());
            table1.attr("data-portal", portalCode);
            table1.insertBefore($("div.menuSecurityCategoryContainer1 .menuSecurityFillerContainer"));

            populateItemLayoutForModule(table0, table1, moduleRoot);
        }

        skyward.menusecuritylayout.displayItemsForModule = function (portalCode, moduleName)
        {
            var allMenuSecurityLocationContainers = hideAllMenuSecurityLocationContainers();

            $(".menuSecurityGrid[data-portal='" + portalCode + "'] tr.moduleRow td.menuSecurityGridLabel").removeClass("moduleLabelSelected");
            $(".menuSecurityGrid[data-portal='" + portalCode + "'] tr.moduleRow td.menuSecurityGridLabel div.MenuSecurityItemNameContainer").removeClass("menuSecurityItemModuleSelected");
            $(".menuSecurityGrid[data-portal='" + portalCode + "'] tr.moduleRow[data-name='" + moduleName + "'] td.menuSecurityGridLabel").addClass("moduleLabelSelected");
            $(".menuSecurityGrid[data-portal='" + portalCode + "'] tr.moduleRow[data-name='" + moduleName + "'] td.menuSecurityGridLabel div.MenuSecurityItemNameContainer").addClass("menuSecurityItemModuleSelected");

            var existingLocationContainer = allMenuSecurityLocationContainers.filter(function () { return $(this).attr("data-module") == moduleName && $(this).attr("data-portal") == portalCode; });
            existingLocationContainer.removeClass("menuSecurityLayoutInactive");
        }

        var retrieveMenuSecurityItemsForPortal = function (portalCode, roleID)
        {
            $.ajax(
                {
                    url: skyward.global.virtualDir + "Security/RoleMenuSecurityItem/GetMenuSecurityItems",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        PortalCode: portalCode,
                        RoleID: roleID
                    },
                    success: function (data) 
                    {
                        deserializePortal(data);
                    }
                    // TODO error:
                });
        }

        var toggleCollapsedFeaturesContainer = function (tableContainer, clss, targetClass)
        {
            return tableContainer.addClass(targetClass).removeClass(clss);
        }

        // Collapse/Expand the module container, but leave the labels for the module so you can see what's selected.
        var toggleCollapsedModuleContainer = function (container, tableContainer, collapse)
        {
            var tds = container.find("td.menuSecurityGridPermission");
            if (collapse)
            {
                container.find("td.menuSecurityGridPermission").addClass("menuSecurityModuleItemCellCollapsed");
                $(tableContainer).addClass("moduleCollapsed");
            }
            else
            {
                container.find("td.menuSecurityGridPermission.menuSecurityModuleItemCellCollapsed").removeClass("menuSecurityModuleItemCellCollapsed");
                $(tableContainer).removeClass("moduleCollapsed");
            }
            return container;
        }

        var initializeCollapsePanel = function (selector)
        {
            $(selector + " .menuSecurityItemContainer").each(function ()
            {
                var button = $(this).find(".toggleMenuSecurityGrid");
                var tableContainer = $(this).find(".menuSecurityItemBody");

                var expandMethod;
                var collapseMethod;

                var collapsingModuleContainer = $(this).hasClass("moduleContainer")
                if (collapsingModuleContainer)
                {
                    var container = $(this);
                    expandMethod = function () { return toggleCollapsedModuleContainer(container, tableContainer).promise(); };
                    collapseMethod = function () { return toggleCollapsedModuleContainer(container, tableContainer, true).promise(); };
                }
                else
                {
                    expandMethod = function () { return toggleCollapsedFeaturesContainer(tableContainer, "collapsed", "expanded").promise(); };
                    collapseMethod = function () { return toggleCollapsedFeaturesContainer(tableContainer, "expanded", "collapsed").promise(); };
                }

                $(button).click(function ()
                {
                    var expanded = !collapsingModuleContainer ? tableContainer.hasClass("expanded") : tableContainer.find("td.menuSecurityGridPermission.menuSecurityModuleItemCellCollapsed").length == 0;
                    if (expanded)
                    {
                        collapseMethod().done(
                            function () 
                            {
                                button.find("use").attr("href", "#svg-ChevronRight");
                            });
                    }
                    else 
                    {
                        expandMethod().done(
                            function () 
                            {
                                button.find("use").attr("href", "#svg-ChevronLeft");
                            });
                    }

                });
            });
        }

        var init = function (selector)
        {
            // TODO make this work if it's run multiple times.
            var initializeLayout = function (id)
            {
                var roleID = $(selector + " #" + id).attr("data-roleid");
                var initialPortalCode = $(selector + " .initialPortalCode").val();

                skyward.menusecuritylayout.displayModulesForPortal(initialPortalCode, roleID);
            }

            $(selector + " div.menuSecurityLayout").each(function ()
            {
                var roleID = $(this).attr("data-roleid");
                var portalButtons = $(this).find("a.menuSecurityPortalButton");

                portalButtons.each(function ()
                {
                    $(this).click(function ()
                    {
                        skyward.menusecuritylayout.displayModulesForPortal($(this).attr("data-portal"), roleID);
                    });
                });

                initializeLayout(this.id);
            });

            initializeCollapsePanel(selector);
        }

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.teacheraccess = skyward.teacheraccess || {};

        var teacherAccessTileFilter = "#TeacherAccessTileFilter";
        var teacherAccessGrouping = "#TeacherAccessGrouping";
        var teacherAccessDailyAttendanceOptions = "#TeacherAccessDailyAttendanceOptions";
        var attendanceModeSelector = "#AttendanceModeSelector";

        var init = function (selector)
        {
            skyward.teacheraccess.enableControls(selector); 
        };

        skyward.teacheraccess.teacherAccessSectionsRadioSetChange = function (event)
        {
            var data = event.data; 
            skyward.teacheraccess.disableControls(data.selector);

            var postData = {};
            postData[data.id] = skyward.controls.getValue($(this));
            var actionArea = $(this).parents().data().area;
            var actionController = $(this).parents().data().controller;

            skyward.teacheraccess.fireTeacherAccessSettingsChangeAjax(data.actionMethod, postData, actionArea, actionController, data.selector);
        };

        skyward.teacheraccess.teacherAccessAttendanceModeChange = function ()
        {
            var idValue = $(this).val();
            var actionArea = $(this).data().area;
            var actionController = $(this).data().controller;

            skyward.teacheraccess.fireTeacherAccessSettingsChangeAjax("SetAttendanceMode", { "AttendanceModeSelector": idValue }, actionArea, actionController);
        };

        skyward.teacheraccess.disableControls = function (selector)
        {
            selector = selector || 'html';

            var teacherAccess = $(selector);
            teacherAccess.find(teacherAccessTileFilter).off('change', skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(teacherAccessGrouping).off('change', skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(teacherAccessDailyAttendanceOptions).off('change', skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(attendanceModeSelector).off('change', skyward.teacheraccess.teacherAccessAttendanceModeChange);
        };

        skyward.teacheraccess.enableControls = function (selector)
        {
            selector = selector || 'html';

            var teacherAccess = $(selector);
            teacherAccess.find(teacherAccessTileFilter).on('change', { id: "TeacherAccessTileFilter", actionMethod: "SetTeacherAccessTileFilter", selector: selector }, skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(teacherAccessGrouping).on('change', { id: "TeacherAccessGrouping", actionMethod: "SetTeacherAccessGrouping", selector: selector }, skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(teacherAccessDailyAttendanceOptions).on('change', { id: "TeacherAccessDailyAttendanceOptions", actionMethod: "SetTodayOrPreviousWeekGrouping", selector: selector },
                skyward.teacheraccess.teacherAccessSectionsRadioSetChange);
            teacherAccess.find(attendanceModeSelector).on('change', skyward.teacheraccess.teacherAccessAttendanceModeChange);
        };

        skyward.teacheraccess.fireTeacherAccessSettingsChangeAjax = function (actionMethod, postData, actionArea, actionController, selector)
        {        
            $.ajax(
                {
                    url: skyward.global.virtualDir + actionArea + "/" + actionController + "/" + actionMethod,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data)
                {
                    location.reload(true);
                },
                error: function ()
                {
                    skyward.teacheraccess.enableControls(selector);
                }
            });
        };

        var staffClassSettingPopup = function ()
        {
            var button = $(this).find(".staffClassSettingsButton");
            var data = button.data();

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Staff/StaffClassSetting/StaffClassSettingPopup",
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true },
                    data: data
                });
            };

            var buttons = [];
            buttons.push({
                id: "saveStaffClassSettingPopup", text: "Save", click: function ()
                {
                    var nickname = skyward.controls.getValue(dialog.content.find("#ClassNickname"));
                    var additionalSaveData = {};

                    if (dialog.content.find("#HideIndividualSectionsOnClassList").length > 0)
                    {
                        additionalSaveData.hideIndividualSectionsOnClassList = skyward.controls.getValue(dialog.content.find("#HideIndividualSectionsOnClassList"));
                    }
                    updateStaffSettings(button, nickname, additionalSaveData);
                    dialog.close();
                }, icon: "Save"
            });
            buttons.push({ id: "closeStudentGradeBucketIndicatorPopup", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" });

            var dialog = skyward.modalLayer.showDialog('Class Settings', buildPopup(), buttons, { anchorTo: button });

        };

        var updateStaffSettings = function(button, nickname, additionalSaveData)
        {
            var data = button.data();
            var saveData = $.extend({}, data, additionalSaveData);
            saveData.classNickname = nickname;
            var browse = button.parents(".browse");

            $.ajax({
                url: skyward.global.virtualDir + "Staff/StaffClassSetting/SaveStaffClassSetting",
                type: "POST",
                dataType: "JSON",
                data: saveData,
                success: async function (saveReturnData)
                {
                    if (saveReturnData.requiresRefresh)
                    {
                        location.reload();
                    }
                    else
                    {
                        var settingsButtonWrapper = button.parent("div");
                        var header = settingsButtonWrapper.siblings(".browseTileHeaderField");
                        var originalValue = header.html();
                        if (originalValue != saveReturnData.newDisplayValue)
                        {
                            await header.viewpartHtml(saveReturnData.newDisplayValue);
                            flashUpdateCell(header, FLASH_COLOR, FLASH_ANIMATION_DURATION);

                            var textBox = header.siblings(".staffNicknameTextBox").first();
                            textBox.data("originalValue", saveReturnData.newDisplayValue);
                            skyward.controls.setValue(textBox, saveReturnData.newDisplayValue);
                            settingsButtonWrapper.parents(".staffNicknameHeaderField").first().addClass("hasNickname");

                            if (data.groupByTypeCode == "S")
                            {
                                browse.find(".classGroup .browseTileBodyFieldValue[data-section-id='" + data.foreignKeyId +"']").each(async function ()
                                {
                                    var classGroupBrowseTileBodyFieldValue = $(this);
                                    var newText = classGroupBrowseTileBodyFieldValue.text().replace(originalValue, saveReturnData.newDisplayValue);
                                    await classGroupBrowseTileBodyFieldValue.viewpartHtml(newText);
                                    flashUpdateCell(classGroupBrowseTileBodyFieldValue, FLASH_COLOR, FLASH_ANIMATION_DURATION);

                                });
                            }
                        }
                    }
                }
            });
        };

        var FLASH_COLOR = "#c9f0c9";
        var FLASH_ANIMATION_DURATION = 1000;
        var flashUpdateCell = function (cell, flashUpdateCellColor, flashUpdateCellDuration)
        {
            if (cell.is(':animated')) {
                return;
            }

            var oldColor = cell.css("background-color");
            cell.css("background-color", flashUpdateCellColor);
            cell.animate({ backgroundColor: oldColor }, { duration: flashUpdateCellDuration });
        };

        var massEditStaffClassNickname = function ()
        {
            var button = $(this);
            var browse = button.parents(".browse").first();
            var textBoxes = browse.find(".staffNicknameTextBox");
            button.hide();
            browse.find(".massSaveNickname").show();
            browse.find(".massCancelNickname").show();

            skyward.changeTracking.setUpChangeTracking(browse);
            $.each(textBoxes, function()
            {
                var textBox = $(this);
                textBox.on('click', function (event)
                {
                    $(this).select();
                });
                textBox.show();
                textBox.siblings().hide();
            });
        };

        var massSaveStaffClassNickname = function ()
        {
            var button = $(this);
            var browse = button.parents(".browse").first();
            var textBoxes = browse.find(".staffNicknameTextBox");
            button.hide();
            browse.find(".massEditNickname").show();
            browse.find(".massCancelNickname").hide();
            browse.find(".classGroupPopupButtonWrapper").show();
            $.each(textBoxes, function()
            {
                var textBox = $(this);
                var settingsButton = textBox.siblings(".staffClassSettingsButtonWrapper").first().find(".staffClassSettingsButton");
                var nickname = skyward.controls.getValue(textBox);
                var additionalSaveData = {}
                if (browse.find(".classGroupPopupButtonWrapper").length > 0)
                {
                    additionalSaveData.fromMassEditClassNicknames = true;
                }

                if (nickname != textBox.data("originalValue"))
                {
                    updateStaffSettings(settingsButton, nickname, additionalSaveData);
                }
                textBox.hide();
                textBox.siblings(".staffClassSettingsButtonWrapper, .browseTileHeaderField").show();
                skyward.tileBrowse.setupClickEvent(textBox.parents(".browseTileContainer").first());
            });
            skyward.changeTracking.clearDirtyList(browse.attr("id"));  
        };

        var massCancelStaffClassNickname = function ()
        {
            var button = $(this);
            var browse = button.parents(".browse").first();
            var textBoxes = browse.find(".staffNicknameTextBox");
            
            button.hide();
            browse.find(".massEditNickname").show();
            browse.find(".massSaveNickname").hide();
            browse.find(".classGroupPopupButtonWrapper").show();
            $.each(textBoxes, function()
            {
                var textBox = $(this);
                var nickname = skyward.controls.getValue(textBox);

                if (nickname != textBox.data("originalValue"))
                {
                    skyward.controls.setValue(textBox, textBox.data("originalValue"));
                }
                textBox.hide();
                textBox.siblings(".staffClassSettingsButtonWrapper, .browseTileHeaderField").show();
                skyward.tileBrowse.setupClickEvent(textBox.parents(".browseTileContainer").first());

            });
            skyward.changeTracking.clearDirtyList(browse.attr("id"));
        };

        var classGroupInfoPopup = function ()
        {

            var dialog = skyward.modalLayer.showDialog('Class Group Information', "<div>Class group is hiding individual sections from class list</div>", [], { anchorTo: $(this) });
        };

        var events =
        {
            'StaffClassSettingPopup': staffClassSettingPopup,
            'massEditStaffClassNickname': massEditStaffClassNickname,
            'massSaveStaffClassNickname': massSaveStaffClassNickname,
            'massCancelStaffClassNickname': massCancelStaffClassNickname,
            'classGroupInfoPopup': classGroupInfoPopup, 
        };

        // TODO: When this call is converted to being ViewPart specific, add skyward.ui.tileBrowse.ts as a dependency and remove both files from the bundle
        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('teacheraccess', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.statecoursedesignatorwa = skyward.statecoursedesignatorwa || {};

        var init = function (selector)
        {
            var curricYearDetailsScreenSelector = $(selector).find("#editCurriculumYear.currentRecordContent.dataObjectViewer");
            var courseDetailsScreenSelector = $(selector).find("#editCourse.currentRecordContent.dataObjectViewer");
            var studentSectionDetailsScreenSelector = $(selector).find("#StudentSectionWADOV.currentRecordContent.dataObjectViewer");
            var workflowScreenSelector = $(selector).filter(".workflowContent");

            var stateCourseDesignatorSelectEEL;
            var isDetails;
            var pageSelector;
            var controlAppend = "";
            var useControlAppendForSettingValues = false;
            var numericYearFieldName;

            var stateAdvancedPlacementFieldName = "StateAdvancedPlacementCodeWAID";
            var stateInternationalBaccalaureateFieldName = "StateInternationalBaccalaureateCodeWAID";
            var stateCambridgeInternationalFieldName = "StateCambridgeInternationalCodeWAID";
            var vocationalTypeCodeComboBox;

            var stateCourseDesignatorOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
            };

            var vocationalTypeCodeOnChange = function ()
            {
                skyward.statecoursedesignatorwa.vocationalTypeCodeOnChange(curricYearDetailsScreenSelector, pageSelector, isDetails, vocationalTypeCodeComboBox, false);
            };

            if (curricYearDetailsScreenSelector.length > 0)
            {
                stateCourseDesignatorSelectEEL = curricYearDetailsScreenSelector.find("#editCurriculumYear_StateCourseDesignatorsWASelectEEL");
                if (stateCourseDesignatorSelectEEL.length > 0)
                {
                    isDetails = true;
                    pageSelector = "#editCurriculumYear_";
                    numericYearFieldName = "NumericYear";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }

                vocationalTypeCodeComboBox = curricYearDetailsScreenSelector.find('#editCurriculumYear_VocationalTypeCode');
                if (vocationalTypeCodeComboBox.length > 0)
                {
                    isDetails = true;
                    pageSelector = "#editCurriculumYear_";
                    skyward.statecoursedesignatorwa.vocationalTypeCodeOnChange(curricYearDetailsScreenSelector, pageSelector, isDetails, vocationalTypeCodeComboBox, true);
                    vocationalTypeCodeComboBox.on("change", vocationalTypeCodeOnChange);
                }
            }
            else if (courseDetailsScreenSelector.length > 0)
            {
                stateCourseDesignatorSelectEEL = courseDetailsScreenSelector.find("#editCourse_StateCourseDesignatorsWASelectEEL");
                if (stateCourseDesignatorSelectEEL.length > 0)
                {
                    isDetails = true;
                    pageSelector = "#editCourse_";
                    numericYearFieldName = "NumericSchoolYearFilter";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }
            }
            else if (studentSectionDetailsScreenSelector.length > 0)
            {
                stateCourseDesignatorSelectEEL = studentSectionDetailsScreenSelector.find("#StudentSectionWADOV_StateCourseDesignatorsWASelectEEL");
                if (stateCourseDesignatorSelectEEL.length > 0)
                {
                    isDetails = true;
                    pageSelector = "#StudentSectionWADOV_";
                    stateAdvancedPlacementFieldName = "StateAdvancedPlacementCodeWAIDOverride";
                    stateInternationalBaccalaureateFieldName = "StateInternationalBaccalaureateCodeWAIDOverride";
                    stateCambridgeInternationalFieldName = "StateCambridgeInternationalCodeWAIDOverride";
                    numericYearFieldName = "SchoolYearNumericYear";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }
            }
            else if (workflowScreenSelector.length > 0)
            {
                isDetails = false;

                if (workflowScreenSelector.find("#D6992DF2-7D2C-4F99-9931-4774941AC99B").length > 0)
                {
                    // Curriculum workflow
                    pageSelector = "#CurriculumYearWA";
                    controlAppend = "CurriculumYearWA";
                    stateCourseDesignatorSelectEEL = workflowScreenSelector.find("#StateCourseDesignatorsWASelectEEL");
                    numericYearFieldName = "NumericYear";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }
                else if (workflowScreenSelector.find("#E4AA0295-910D-498C-B97B-B9AA39185FD0").length > 0)
                {
                    // Curriculum Year workflow
                    pageSelector = "#CurriculumYear";
                    stateCourseDesignatorSelectEEL = workflowScreenSelector.find("#StateCourseDesignatorsWASelectEEL");
                    numericYearFieldName = "NumericYear";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                    vocationalTypeCodeComboBox = workflowScreenSelector.find(pageSelector + "VocationalTypeCode");

                    if (vocationalTypeCodeComboBox.length > 0)
                    {
                        skyward.statecoursedesignatorwa.vocationalTypeCodeOnChange(workflowScreenSelector, pageSelector, isDetails, vocationalTypeCodeComboBox);
                        vocationalTypeCodeComboBox.on("change", vocationalTypeCodeOnChange);
                    }
                }
                else if (workflowScreenSelector.find("#3F20F9EE-7217-4C32-8215-7262E58C91ED").length > 0)
                {
                    // Course workflow
                    pageSelector = "#Course";
                    controlAppend = "Course";
                    stateCourseDesignatorSelectEEL = workflowScreenSelector.find("#StateCourseDesignatorsWASelectEEL");
                    numericYearFieldName = "NumericSchoolYearFilter";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);
                }
                else if (workflowScreenSelector.find('#2004CB53-23B1-40C3-B63C-92889D29112A').length > 0)
                {
                    // Transfer Course workflow
                    var ChildRecordQuickEntryStateCourseDesignatorOnChange = function ()
                    {
                        skyward.statecoursedesignatorwa.childRecordQuickEntryStateCourseDesignatorOnChange(this);
                    };

                    var stateCourseDesignatorSelectEELs = workflowScreenSelector.find(".statecoursedesignatormultiselecteel");
                    if (stateCourseDesignatorSelectEELs.length)
                    {
                        stateCourseDesignatorSelectEELs.each(function ()
                        {
                            skyward.statecoursedesignatorwa.childRecordQuickEntryStateCourseDesignatorOnChange($(this));
                            $(this).on("change", ChildRecordQuickEntryStateCourseDesignatorOnChange);
                        });
                    }

                    // place event on StateALECourseTypeWA to hide/show state online codes
                    var stateALECourseTypeWACodeEELValues = workflowScreenSelector.find(".statealecoursetypewacodeeel");
                    if (stateALECourseTypeWACodeEELValues.length > 0)
                    {
                        var stateCourseDesignators = workflowScreenSelector.find(".statecoursedesignatormultiselecteel");
                        stateALECourseTypeWACodeEELValues.each(function ()
                        {
                            var control = $(this);
                            var stateALECourseTypeWACodeEEL = control.parent();
                            skyward.statecoursedesignatorwa.stateALECourseTypeWAOnChange(stateALECourseTypeWACodeEEL, stateCourseDesignators);

                            var stateALECourseTypeWAOnChange = function ()
                            {
                                skyward.statecoursedesignatorwa.stateALECourseTypeWAOnChange(stateALECourseTypeWACodeEEL, stateCourseDesignators);
                            };
                            stateALECourseTypeWACodeEEL.on("codeEELValuesUpdated", stateALECourseTypeWAOnChange);

                            // place event on the change of the _value so when this value is cleared from dependecies the stateALECourseTypeWAOnChange is ran again to hide the labels
                            control.on("change", stateALECourseTypeWAOnChange);
                        });
                    }

                    // place event on UseStateCIPOverride to hide/show state industry certification
                    var useStateCIPWAIDOverrideValue = workflowScreenSelector.find(".usestatecipoverridecheckbox");
                    if (useStateCIPWAIDOverrideValue.length > 0)
                    {
                        useStateCIPWAIDOverrideValue.each(function ()
                        {
                            var control = $(this);
                            var useStateCIPWAIDOverride = control.parent();
                            skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(useStateCIPWAIDOverride);

                            var stateCIPOverrideOnChange = function ()
                            {
                                skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(useStateCIPWAIDOverride);
                            };
                            useStateCIPWAIDOverride.on("click", stateCIPOverrideOnChange);

                            control.on("change", stateCIPOverrideOnChange);
                        });
                    }

                    // place event on StateCIPOverrideEEL to hide/show state industry certification
                    var stateCIPWAIDOverrideCodeEELValues = workflowScreenSelector.find(".statecipoverridecodeeel");
                    if (stateCIPWAIDOverrideCodeEELValues.length > 0)
                    {
                        stateCIPWAIDOverrideCodeEELValues.each(function ()
                        {
                            var control = $(this);
                            var stateCIPWAIDOverrideCodeEEL = control.parent();
                            skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(stateCIPWAIDOverrideCodeEEL);

                            var stateCIPOverrideOnChange = function ()
                            {
                                skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(stateCIPWAIDOverrideCodeEEL);
                            };
                            stateCIPWAIDOverrideCodeEEL.on("codeEELValuesUpdated", stateCIPOverrideOnChange);

                            control.on("change", stateCIPOverrideOnChange);
                        });
                    }

                    // place event on StateCTECourseEquivalency to hide/show StateCTEEquivaencyCodeWA's label, added child sections is covered in stateCourseDesignatorChildRecordSectionAdd function
                    var stateCTECourseEquivalencyWACodeEELValues = workflowScreenSelector.find(".statectecourseequivalencycodeeel");
                    if (stateCTECourseEquivalencyWACodeEELValues.length > 0)
                    {
                        stateCTECourseEquivalencyWACodeEELValues.each(function ()
                        {
                            var control = $(this);
                            var stateCTECourseEquivalencyWACodeEEL = control.parent();
                            skyward.statecoursedesignatorwa.stateCTECourseEquivalencyWAOnChange(stateCTECourseEquivalencyWACodeEEL);

                            var stateCTECourseEquivalencyWAOnChange = function ()
                            {
                                skyward.statecoursedesignatorwa.stateCTECourseEquivalencyWAOnChange(stateCTECourseEquivalencyWACodeEEL);
                            };
                            stateCTECourseEquivalencyWACodeEEL.on("codeEELValuesUpdated", stateCTECourseEquivalencyWAOnChange);

                            // place event on the change of the _value of cte course equivalency so when this value is cleared from dependecies the stateCTECourseEquivalencyWACodeOnChange is ran again to hide the field
                            control.on("change", stateCTECourseEquivalencyWAOnChange);
                        });
                    }

                    // place event on child record add button to run this again when a new child section is made
                    var childRecordAddButton = workflowScreenSelector.find("#childrecordquickentryaddbutton-studentsection-studentid-1");
                    var stateCourseDesignatorChildRecordSectionAdd = function ()
                    {
                        skyward.statecoursedesignatorwa.stateCourseDesignatorChildRecordSectionAdd(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, controlAppend, useControlAppendForSettingValues);
                    };
                    childRecordAddButton.on("click", stateCourseDesignatorChildRecordSectionAdd);
                }
                else if (workflowScreenSelector.find('#1376135B-4FCE-4D83-B56F-E6767BBEEB58').length > 0)
                {
                    // Mass Change Course Master Workflow
                    pageSelector = "#MassUpdateCourseMaster";
                    controlAppend = "";
                    stateAdvancedPlacementFieldName = "Update-CourseWAStateAdvancedPlacementCodeWAID";
                    stateInternationalBaccalaureateFieldName = "Update-CourseWAStateInternationalBaccalaureateCodeWAID";
                    stateCambridgeInternationalFieldName = "Update-CourseWAStateCambridgeInternationalCodeWAID";
                    stateCourseDesignatorSelectEEL = workflowScreenSelector.find("#Update-CourseStateCourseDesignatorsWASelectEEL");
                    numericYearFieldName = "NumericYearForFilter";
                    skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
                    stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);

                    var stateALECourseTypeWACodeEEL = workflowScreenSelector.find("#Update-SectionWAStateALECourseTypeWAID");
                    var stateALECourseTypeWAOnChange = function ()
                    {
                        skyward.statecoursedesignatorwa.stateALECourseTypeWAOnChange(stateALECourseTypeWACodeEEL, stateCourseDesignatorSelectEEL);
                    };
                    stateALECourseTypeWACodeEEL.on("change", stateALECourseTypeWAOnChange);

                    var stateSequenceFieldset = $("#fsStateSequenceWAID");
                    if (stateSequenceFieldset.length > 0)
                    {
                        stateSequenceFieldset.hide()
                    }
                    
                    var sequenceGroupWAEEL = workflowScreenSelector.find("#Update-CourseWASequenceGroupWAID");
                    var sequenceGroupWAOnChange = function ()
                    {
                        skyward.statecoursedesignatorwa.sequenceGroupWAOnChange(sequenceGroupWAEEL);
                    };
                    sequenceGroupWAEEL.on("change", sequenceGroupWAOnChange);
                }
            }
        };

        skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange = function (pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName)
        {
            var numericYear = isDetails ? $(pageSelector + numericYearFieldName).val() : $("#" + numericYearFieldName).val();
            var selectedStateCourseDesignators = stateCourseDesignatorSelectEEL.children('input').attr("value");
            var selectedDesignatorIDList;

            var stateAPCheckbox = $("#SelectedField-CourseWAStateAdvancedPlacementCodeWAID");
            var stateIBCheckbox = $("#SelectedField-CourseWAStateInternationalBaccalaureateCodeWAID");
            var stateCICheckbox = $("#SelectedField-CourseWAStateCambridgeInternationalCodeWAID");

            if (selectedStateCourseDesignators !== "" && selectedStateCourseDesignators !== undefined)
            {
                selectedDesignatorIDList = Object.keys(JSON.parse(selectedStateCourseDesignators));
            }

            var stateDesignatorCodeAPID = isDetails ? $(pageSelector + "StateDesignatorCodeAPID").data('original-value') : $("#StateDesignatorCodeAPID" + controlAppend).data('original-value');
            var stateDesignatorCodeIBID = isDetails ? $(pageSelector + "StateDesignatorCodeIBID").data('original-value') : $("#StateDesignatorCodeIBID" + controlAppend).data('original-value');
            var stateDesignatorCodeCIID = isDetails ? $(pageSelector + "StateDesignatorCodeCIID").data('original-value') : $("#StateDesignatorCodeCIID" + controlAppend).data('original-value');
            var stateDesignatorCodeOID = isDetails ? $(pageSelector + "StateDesignatorCodeOID").data('original-value') : $("#StateDesignatorCodeOID" + controlAppend).data('original-value');
            var stateDesignatorCodeCID = isDetails ? $(pageSelector + "StateDesignatorCodeCID").data('original-value') : $("#StateDesignatorCodeCID" + controlAppend).data('original-value');
            var stateDesignatorCodeTID = isDetails ? $(pageSelector + "StateDesignatorCodeTID").data('original-value') : $("#StateDesignatorCodeTID" + controlAppend).data('original-value');

            var stateAPFieldset;
            var stateIBFieldset;
            var stateCIFieldset;

            var hEISelected = numericYear >= 2027 && stateDesignatorCodeCID !== undefined && ($.inArray(stateDesignatorCodeCID.toString(), selectedDesignatorIDList) !== -1 || $.inArray(stateDesignatorCodeTID.toString(), selectedDesignatorIDList) !== -1);

            if (hEISelected)
            {
                stateHEIFieldset = isDetails ? $(pageSelector + "fsStateHigherEducationInstitutionWAID") : $("#fsStateHigherEducationInstitutionWAID" + controlAppend);
                stateHEIFieldset.show();
            }
            else
            {
                var stateHEIFieldset = isDetails ? $(pageSelector + "fsStateHigherEducationInstitutionWAID") : $("#fsStateHigherEducationInstitutionWAID" + controlAppend);
                stateHEIFieldset.hide();
                var setValuePrefix = isDetails ? pageSelector : "#";
                skyward.controls.setValue(setValuePrefix + "StateHigherEducationInstitutionWASelectEEL" + (useControlAppendForSettingValues ? controlAppend : ""), null);
            }

            if (selectedDesignatorIDList !== undefined && selectedDesignatorIDList.length === 0 || !stateDesignatorCodeAPID || !stateDesignatorCodeIBID || (numericYear >= 2027 && stateDesignatorCodeCIID !== undefined && !stateDesignatorCodeCIID))
            {
                ResetAPFields(stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetIBFields(stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetCIFields(stateCambridgeInternationalFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetOnlineFields(isDetails, pageSelector, controlAppend);

                return;
            }

            var aPSelected = $.inArray(stateDesignatorCodeAPID.toString(), selectedDesignatorIDList) !== -1;
            var iBSelected = $.inArray(stateDesignatorCodeIBID.toString(), selectedDesignatorIDList) !== -1;
            var cISelected = numericYear >= 2027 && stateDesignatorCodeCIID !== undefined && $.inArray(stateDesignatorCodeCIID.toString(), selectedDesignatorIDList) !== -1;
            var oSelected = stateDesignatorCodeOID !== undefined && $.inArray(stateDesignatorCodeOID.toString(), selectedDesignatorIDList) !== -1;

            StateOnlineCodesActions(isDetails, pageSelector, controlAppend, oSelected);

            var moreThanOneSelected = [aPSelected, iBSelected, cISelected].reduce((count, value) => count + Number(value), 0) > 1;
            if (moreThanOneSelected)
            {
                ResetAPFields(stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetIBFields(stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetCIFields(stateCambridgeInternationalFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);

                return;
            }

            if (aPSelected)
            {
                ResetIBFields(stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetCIFields(stateCambridgeInternationalFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                stateAPFieldset = isDetails ? $(pageSelector + "fsStateAdvancedPlacementCodeWAID") : $("#fsStateAdvancedPlacementCodeWAID" + controlAppend);
                stateAPFieldset.show();

                if (stateAPCheckbox.length > 0)
                {
                    skyward.controls.setValue(stateAPCheckbox, "true");
                }

                return;
            }

            if (iBSelected)
            {
                ResetAPFields(stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetCIFields(stateCambridgeInternationalFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                stateIBFieldset = isDetails ? $(pageSelector + "fsStateInternationalBaccalaureateCodeWAID") : $("#fsStateInternationalBaccalaureateCodeWAID" + controlAppend);
                stateIBFieldset.show();

                if (stateIBCheckbox.length > 0)
                {
                    skyward.controls.setValue(stateIBCheckbox, "true");
                }

                return;
            }

            if (cISelected)
            {
                ResetAPFields(stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                ResetIBFields(stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
                stateCIFieldset = isDetails ? $(pageSelector + "fsStateCambridgeInternationalCodeWAID") : $("#fsStateCambridgeInternationalCodeWAID" + controlAppend);
                stateCIFieldset.show();

                if (stateCICheckbox.length > 0)
                {
                    skyward.controls.setValue(stateCICheckbox, "true");
                }

                return;
            }

            ResetAPFields(stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
            ResetIBFields(stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);
            ResetCIFields(stateCambridgeInternationalFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues);

            return;
        };

        var StateOnlineCodesActions = function (isDetails, pageSelector, controlAppend, oSelected)
        {
            var numericYear = isDetails ? $(pageSelector + "SchoolYearNumericYear").data('original-value') : $("#NumericYearForFilter" + controlAppend).data('original-value');
            var stateOnlneProgramCheckbox = $("#SelectedField-SectionWAStateOnlineProgramWAID");
            var stateOnlineProviderCheckbox = $("#SelectedField-SectionWAStateOnlineProviderWAID");
            var stateALECourseTypeWACodeValue = isDetails ? $(pageSelector + "StateALECourseTypeWAIDOverride_code").val() : $("#StateALECourseTypeWAID" + controlAppend + "_code").val();

            if (stateOnlineProviderCheckbox.length > 0 && stateOnlneProgramCheckbox.length > 0 && oSelected)
            {
                skyward.controls.setValue(stateOnlneProgramCheckbox, "true");
                skyward.controls.setValue(stateOnlineProviderCheckbox, "true");
            }
            else if (numericYear > 2019 && (stateALECourseTypeWACodeValue === "O"))
            {
                var stateOnlineProgramFieldSet = isDetails ? $(pageSelector + "fsOnlineProgramOverride") : $("#StateOnlineProgramWA" + controlAppend);
                var stateOnlineProviderFieldSet = isDetails ? $(pageSelector + "fsOnlineProviderOverride") : $("#StateOnlineProviderWA" + controlAppend);

                var programCheckbox = isDetails ? stateOnlineProgramFieldSet.parent().parent().find(pageSelector + "UseStateOnlineProgramOverride") : $("#UseStateOnlineProgramOverride" + controlAppend);
                var providerCheckbox = isDetails ? stateOnlineProviderFieldSet.parent().parent().find(pageSelector + "UseStateOnlineProviderOverride") : $("#UseStateOnlineProviderOverride" + controlAppend);

                if (skyward.controls.getValue(programCheckbox) === false)
                {
                    skyward.controls.setValue(programCheckbox, "true");
                }

                if (skyward.controls.getValue(providerCheckbox) === false)
                {
                    skyward.controls.setValue(providerCheckbox, "true");
                }

                var stateOnlineProgramRequired = isDetails ? stateOnlineProgramFieldSet.find(pageSelector + "RequiredOnlineProgramLabel") : $("#RequiredOnlineProgramLabel" + controlAppend);
                var stateOnlineProgramNonRequired = isDetails ? stateOnlineProgramFieldSet.find(pageSelector + "NotRequiredOnlineProgramLabel") : $("#NotRequiredOnlineProgramLabel" + controlAppend);
                stateOnlineProgramRequired.show();
                stateOnlineProgramNonRequired.hide();

                var stateOnlineProviderRequired = isDetails ? stateOnlineProviderFieldSet.find(pageSelector + "RequiredOnlineProviderLabel") : $("#RequiredOnlineProviderLabel" + controlAppend);
                var stateOnlineProviderNonRequired = isDetails ? stateOnlineProviderFieldSet.find(pageSelector + "NotRequiredOnlineProviderLabel") : $("#NotRequiredOnlineProviderLabel" + controlAppend);
                stateOnlineProviderRequired.show();
                stateOnlineProviderNonRequired.hide();
            }
            else
            {
                ResetOnlineFields(isDetails, pageSelector, controlAppend);
            }
        };

        skyward.statecoursedesignatorwa.childRecordQuickEntryStateCourseDesignatorOnChange = function (stateCourseDesignatorSelectEEL)
        {
            var select = $(stateCourseDesignatorSelectEEL);
            var controlID = select.attr("Id").split("-").pop();
            var controlAppend = "-add-" + controlID;
            var useControlAppendForSettingValues = true;

            var stateAdvancedPlacementFieldName = "StateAdvancedPlacementCodeWAID";
            var stateInternationalBaccalaureateFieldName = "StateInternationalBaccalaureateCodeWAID";
            var stateCambridgeInternationalFieldName = "StateCambridgeInternationalCodeWAID";
            var isDetails = false;
            var pageSelector = "#";
            var numericYearFieldName = "NumericYearForFilter" + controlAppend;

            skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, select, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
        }

        skyward.statecoursedesignatorwa.stateCourseDesignatorChildRecordSectionAdd = function (pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues)
        {
            var newSectionID = $("table").find("tr").last().attr("Id")?.split("-").pop() ?? "";
            controlAppend = "-add-" + newSectionID;
            stateCourseDesignatorSelectEEL = $("table").find("#StateCourseDesignatorsWASelectEEL" + controlAppend);
            var numericYearFieldName = "NumericYearForFilter" + controlAppend;
            skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);

            var stateCourseDesignatorOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCourseDesignatorOnChange(pageSelector, isDetails, stateCourseDesignatorSelectEEL, stateAdvancedPlacementFieldName, stateInternationalBaccalaureateFieldName, stateCambridgeInternationalFieldName, controlAppend, useControlAppendForSettingValues, numericYearFieldName);
            };
            stateCourseDesignatorSelectEEL.on("change", stateCourseDesignatorOnChange);

            var stateCTECourseEquivalencyWACodeEEL = $("table").find("#StateCTECourseEquivalencyWAID" + controlAppend);
            var stateCTECourseEquivalencyWAOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCTECourseEquivalencyWAOnChange(stateCTECourseEquivalencyWACodeEEL);
            };
            stateCTECourseEquivalencyWACodeEEL.on("codeEELValuesUpdated", stateCTECourseEquivalencyWAOnChange);

            var stateCTECourseEquivalencyWACodeEELValue = stateCTECourseEquivalencyWACodeEEL.first("input");
            stateCTECourseEquivalencyWACodeEELValue.on("change", stateCTECourseEquivalencyWAOnChange)

            var useStateCIPOverride = $("table").find("#UseStateCIPOverride" + controlAppend)
            var stateCIPOverrideOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(useStateCIPOverride);
            };
            useStateCIPOverride.on("click", stateCIPOverrideOnChange);

            var stateCIPWAIDOverrideCodeEEL = $("table").find("#StateCIPWAID" + controlAppend)
            var stateCIPOverrideOnChange = function ()
            {
                skyward.statecoursedesignatorwa.stateCIPOverrideOnChange(stateCIPWAIDOverrideCodeEEL);
            };
            stateCIPWAIDOverrideCodeEEL.on("codeEELValuesUpdated", stateCIPOverrideOnChange);

            var stateCIPWAIDOverrideCodeEELValue = stateCIPWAIDOverrideCodeEEL.first("input");
            stateCIPWAIDOverrideCodeEELValue.on("change", stateCIPOverrideOnChange)
        };

        skyward.statecoursedesignatorwa.stateCTECourseEquivalencyWAOnChange = function (stateCTECourseEquivalencyWACodeEEL)
        {
            var sectionDiv = stateCTECourseEquivalencyWACodeEEL.parent().parent();
            var controlID = stateCTECourseEquivalencyWACodeEEL.attr("Id").split("-").pop();
            controlID = "-add-" + controlID;
            var numericYear = $('#NumericYearForFilter' + controlID).val();

            var stateCTEEquivalencyWAFieldSet = sectionDiv.find("#StateCTEEquivalencyCodeWA" + controlID);

            var stateCTECourseEquivalencyWACodeValue = sectionDiv.find("#StateCTECourseEquivalencyWAID" + controlID + "_code").val();
            var stateCTECourseEquivalencyWACheckBoxValue = skyward.controls.getValue(sectionDiv.find("#UseStateCTECourseEquivalencyWAOverride" + controlID));

            if (stateCTECourseEquivalencyWACheckBoxValue === true && (stateCTECourseEquivalencyWACodeValue === "A" || stateCTECourseEquivalencyWACodeValue === "B") && numericYear >= 2018)
            {
                stateCTEEquivalencyWAFieldSet.show();
            }
            else
            {
                stateCTEEquivalencyWAFieldSet.hide();
                skyward.controls.setValue("#StateCTEEquivalencyCodeWAID" + controlID, null);
            }
        };

        skyward.statecoursedesignatorwa.stateALECourseTypeWAOnChange = function (stateALECourseTypeWACodeEEL, stateCourseDesignatorSelectEEL)
        {
            var numericYear = $('#NumericYearForFilter' + controlID).val();
            var stateOnlneProgramCheckbox = $("#SelectedField-SectionWAStateOnlineProgramWAID");
            var stateOnlineProviderCheckbox = $("#SelectedField-SectionWAStateOnlineProviderWAID");

            if (stateOnlineProviderCheckbox.length > 0 && stateOnlneProgramCheckbox.length > 0)
            {
                skyward.controls.setValue(stateOnlneProgramCheckbox, "true");
                skyward.controls.setValue(stateOnlineProviderCheckbox, "true");
            }
            else if (numericYear > 2019)
            {
                var sectionDiv = stateALECourseTypeWACodeEEL.parent().parent();
                var controlID = stateALECourseTypeWACodeEEL.attr("Id").split("-").pop();
                controlID = "-add-" + controlID;

                var selectedStateCourseDesignators = stateCourseDesignatorSelectEEL.children('input').attr("value");
                var selectedDesignatorIDList;
                if (selectedStateCourseDesignators !== "" && selectedStateCourseDesignators !== undefined)
                {
                    selectedDesignatorIDList = Object.keys(JSON.parse(selectedStateCourseDesignators));
                }

                var stateDesignatorCodeOID = $("#StateDesignatorCodeOID" + controlID).data('original-value');
                var oSelected = $.inArray(stateDesignatorCodeOID.toString(), selectedDesignatorIDList) !== -1;

                var programCheckbox = sectionDiv.find("#UseStateOnlineProgramOverride" + controlID);
                var stateOnlineProgramRequired = sectionDiv.find("#RequiredOnlineProgramLabel" + controlID);
                var stateOnlineProgramNonRequired = sectionDiv.find("#NotRequiredOnlineProgramLabel" + controlID);

                var providerCheckbox = sectionDiv.find("#UseStateOnlineProviderOverride" + controlID);
                var stateOnlineProviderRequired = sectionDiv.find("#RequiredOnlineProviderLabel" + controlID);
                var stateOnlineProviderNonRequired = sectionDiv.find("#NotRequiredOnlineProviderLabel" + controlID);

                var stateALECourseTypeWACodeValue = sectionDiv.find("#StateALECourseTypeWAID" + controlID + "_code").val();
                var stateALECourseTypeWACheckBoxValue = skyward.controls.getValue(sectionDiv.find("#UseStateALECourseTypeWAOverride" + controlID));

                if ((stateALECourseTypeWACheckBoxValue === true && stateALECourseTypeWACodeValue === "O") || oSelected)
                {
                    skyward.controls.setValue(programCheckbox, "true");
                    skyward.controls.setValue(providerCheckbox, "true");

                    stateOnlineProgramRequired.show();
                    stateOnlineProgramNonRequired.hide();

                    stateOnlineProviderRequired.show();
                    stateOnlineProviderNonRequired.hide();
                }
                else
                {
                    stateOnlineProgramRequired.hide();
                    stateOnlineProgramNonRequired.show();

                    stateOnlineProviderRequired.hide();
                    stateOnlineProviderNonRequired.show();
                }
            }

            return;
        };

        skyward.statecoursedesignatorwa.sequenceGroupWAOnChange = function (sequenceGroupWAEEL)
        {
            var numericYear = $("#NumericYearForFilter").data('original-value');
            if (numericYear > 2021)
            {
                var stateSequenceCheckbox = $("#SelectedField-CourseWAStateSequenceWAID");
                var stateSequenceFieldset = $("#fsStateSequenceWAID");
                var sequenceGroupWAValue = skyward.controls.getValue(sequenceGroupWAEEL);

                if (sequenceGroupWAValue !== "" && sequenceGroupWAValue !== undefined)
                {
                    if (stateSequenceCheckbox.length > 0)
                    {
                        skyward.controls.setValue(stateSequenceCheckbox, "true");
                    }

                    stateSequenceFieldset.show();
                }
                else
                {
                    stateSequenceFieldset.hide();
                    var sectionDiv = sequenceGroupWAEEL.parent().parent();
                    var stateSequenceWAEEL = sectionDiv.find("#Update-CourseWAStateSequenceWAID")
                    skyward.controls.setValue(stateSequenceWAEEL, null);

                    if (stateSequenceCheckbox.length > 0)
                    {
                        skyward.controls.setValue(stateSequenceCheckbox, "false");
                    }
                }
            }

            return;
        };

        var ResetAPFields = function (stateAdvancedPlacementFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues)
        {
            var stateAPFieldset = isDetails ? $(pageSelector + "fsStateAdvancedPlacementCodeWAID") : $("#fsStateAdvancedPlacementCodeWAID" + controlAppend);
            stateAPFieldset.hide();
            skyward.controls.setValue(pageSelector + stateAdvancedPlacementFieldName + (useControlAppendForSettingValues ? controlAppend : ""), null);

            var stateAPCheckbox = $("#SelectedField-CourseWAStateAdvancedPlacementCodeWAID");
            if (stateAPCheckbox.length > 0)
            {
                skyward.controls.setValue(stateAPCheckbox, "false");
            }
        };

        var ResetIBFields = function (stateInternationalBaccalaureateFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues)
        {
            var stateIBFieldset = isDetails ? $(pageSelector + "fsStateInternationalBaccalaureateCodeWAID") : $("#fsStateInternationalBaccalaureateCodeWAID" + controlAppend);
            stateIBFieldset.hide();
            skyward.controls.setValue(pageSelector + stateInternationalBaccalaureateFieldName + (useControlAppendForSettingValues ? controlAppend : ""), null);

            var stateIBCheckbox = $("#SelectedField-CourseWAStateInternationalBaccalaureateCodeWAID");
            if (stateIBCheckbox.length > 0)
            {
                skyward.controls.setValue(stateIBCheckbox, "false");
            }
        };

        var ResetCIFields = function (stateCambridgeInternationalFieldName, isDetails, pageSelector, controlAppend, useControlAppendForSettingValues)
        {
            var stateCIFieldset = isDetails ? $(pageSelector + "fsStateCambridgeInternationalCodeWAID") : $("#fsStateCambridgeInternationalCodeWAID" + controlAppend);
            stateCIFieldset.hide();
            skyward.controls.setValue(pageSelector + stateCambridgeInternationalFieldName + (useControlAppendForSettingValues ? controlAppend : ""), null);

            var stateCICheckbox = $("#SelectedField-CourseWAStateCambridgeInternationalCodeWAID");
            if (stateCICheckbox.length > 0)
            {
                skyward.controls.setValue(stateCICheckbox, "false");
            }
        };

        var ResetOnlineFields = function (isDetails, pageSelector, controlAppend)
        {
            var stateALECourseTypeWACodeValue = isDetails ? $(pageSelector + "StateALECourseTypeWAIDOverride_code").val() : $("#StateALECourseTypeWAID" + controlAppend + "_code").val();
            if (stateALECourseTypeWACodeValue !== undefined && stateALECourseTypeWACodeValue !== "O")
            {
                var stateOnlineProgramFieldSet = isDetails ? $(pageSelector + "fsOnlineProgramOverride") : $("#StateOnlineProgramWA" + controlAppend);
                var stateOnlineProviderFieldSet = isDetails ? $(pageSelector + "fsOnlineProviderOverride") : $("#StateOnlineProviderWA" + controlAppend);
                var stateOnlineProgramFieldName = isDetails ? "StateOnlineProgramWAIDOverride" : "StateOnlineProgramWAID";
                var stateOnlineProviderFieldName = isDetails ? "StateOnlineProviderWAIDOverride" : "StateOnlineProviderWAID";

                var stateOnlineProgramRequired = isDetails ? stateOnlineProgramFieldSet.find(pageSelector + "RequiredOnlineProgramLabel") : $("#RequiredOnlineProgramLabel" + controlAppend);
                var stateOnlineProgramNonRequired = isDetails ? stateOnlineProgramFieldSet.find(pageSelector + "NotRequiredOnlineProgramLabel") : $("#NotRequiredOnlineProgramLabel" + controlAppend);
                stateOnlineProgramRequired.hide();
                stateOnlineProgramNonRequired.show();

                var stateOnlineProviderRequired = isDetails ? stateOnlineProviderFieldSet.find(pageSelector + "RequiredOnlineProviderLabel") : $("#RequiredOnlineProviderLabel" + controlAppend);
                var stateOnlineProviderNonRequired = isDetails ? stateOnlineProviderFieldSet.find(pageSelector + "NotRequiredOnlineProviderLabel") : $("#NotRequiredOnlineProviderLabel" + controlAppend);
                stateOnlineProviderRequired.hide();
                stateOnlineProviderNonRequired.show();

                var programCheckbox = isDetails ? stateOnlineProgramFieldSet.parent().parent().find(pageSelector + "UseStateOnlineProgramOverride") : $("#UseStateOnlineProgramOverride" + controlAppend);
                var providerCheckbox = isDetails ? stateOnlineProviderFieldSet.parent().parent().find(pageSelector + "UseStateOnlineProviderOverride") : $("#UseStateOnlineProviderOverride" + controlAppend);

                if (skyward.controls.getValue(programCheckbox) === false)
                {
                    skyward.controls.setValue(pageSelector + stateOnlineProgramFieldName + controlAppend, null);
                }

                if (skyward.controls.getValue(providerCheckbox) === false)
                {
                    skyward.controls.setValue(pageSelector + stateOnlineProviderFieldName + controlAppend, null);
                }

                var stateOnlneProgramCheckbox = $("#SelectedField-SectionWAStateOnlineProgramWAID");
                var stateOnlineProviderCheckbox = $("#SelectedField-SectionWAStateOnlineProviderWAID");
                if (stateOnlineProviderCheckbox.length > 0 && stateOnlneProgramCheckbox.length > 0)
                {
                    skyward.controls.setValue(stateOnlneProgramCheckbox, "false");
                    skyward.controls.setValue(stateOnlineProviderCheckbox, "false");
                }
            }
        };

        skyward.statecoursedesignatorwa.vocationalTypeCodeOnChange = function (screenSelector, pageSelector, isDetails, vocationalTypeCodeComboBox, runOnLoad)
        {
            var stateCIPNonRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'StateCIPWAIDLabelNonRequired') : $(pageSelector + 'StateCIPWAIDLabelNonRequired');
            var stateCIPRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'StateCIPWAIDLabelRequired') : $(pageSelector + 'StateCIPWAIDLabelRequired');
            var numericYear = isDetails ? screenSelector.find(pageSelector + 'NumericYear').val() : $('#NumericYear').val();
            var vocationalTypeCodeNotRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'VocationalTypeCodeNotRequired') : $('#VocationalTypeCodeNotRequired');
            var vocationalTypeCodeRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'VocationalTypeCodeRequired') : $('#VocationalTypeCodeRequired');

            if (stateCIPNonRequiredLabel.length > 0 && stateCIPRequiredLabel.length > 0)
            {
                if (vocationalTypeCodeComboBox.val() === "B")
                {
                    stateCIPNonRequiredLabel.show();
                    stateCIPRequiredLabel.hide();

                    var stateCIPWACodeEel = pageSelector + "StateCIPWAID";

                    if (!runOnLoad)
                    {
                        skyward.controls.setValue(stateCIPWACodeEel, null);

                        skyward.controls.setValue('#SelectedStateCertificationWAEELDictionary', null);
                        var industryRecognizedCertificationsFieldSet = isDetails ? pageSelector + 'fsIndustryRecognizedCertifications' : 'fsIndustryRecognizedCertifications'
                        skyward.controls.hide(industryRecognizedCertificationsFieldSet);

                        skyward.controls.setValue('#SelectedWorkBasedLearningActivityWAEELDictionary', null);
                        var stateWorkBasedLearningActivitesWAFieldSet = isDetails ? pageSelector + 'fsStateWorkBasedLearningActivitesWA' : 'fsStateWorkBasedLearningActivitesWA'
                        skyward.controls.hide(stateWorkBasedLearningActivitesWAFieldSet);
                    }

                    var stateCTECourseEquivalencyNotRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'NotRequiredCTECourse') : $('#NotRequiredCTECourse');
                    var stateCTECourseEquivalencyRequiredLabel = isDetails ? screenSelector.find(pageSelector + 'RequiredCTECourse') : $('#RequiredCTECourse');

                    if (stateCTECourseEquivalencyNotRequiredLabel.length > 0 && stateCTECourseEquivalencyRequiredLabel.length > 0)
                    {
                        if ($(stateCIPWACodeEel + '_value').val() === "")
                        {
                            stateCTECourseEquivalencyNotRequiredLabel.show();
                            stateCTECourseEquivalencyRequiredLabel.hide();
                        }
                        else
                        {
                            stateCTECourseEquivalencyNotRequiredLabel.hide();
                            stateCTECourseEquivalencyRequiredLabel.show();
                        }
                    }

                    if (vocationalTypeCodeNotRequiredLabel.length > 0 && vocationalTypeCodeRequiredLabel.length > 0)
                    {
                        if ($(stateCIPWACodeEel + '_value').val() === "" || numericYear < 2018)
                        {
                            vocationalTypeCodeNotRequiredLabel.show();
                            vocationalTypeCodeRequiredLabel.hide();
                        }
                        else
                        {
                            vocationalTypeCodeNotRequiredLabel.hide();
                            vocationalTypeCodeRequiredLabel.show();
                        }
                    }
                }
                else
                {
                    if (numericYear < 2018)
                    {
                        vocationalTypeCodeNotRequiredLabel.show();
                        vocationalTypeCodeRequiredLabel.hide();
                    }
                    stateCIPNonRequiredLabel.hide();
                    stateCIPRequiredLabel.show();
                }
            }
        };

        skyward.statecoursedesignatorwa.stateCIPOverrideOnChange = function (controlFiredFrom)
        {
            var sectionDiv = controlFiredFrom.parent().parent();
            var controlID = controlFiredFrom.attr("Id").split("-").pop();
            controlID = "-add-" + controlID;
            var numericYear = $('#NumericYearForFilter' + controlID).val();

            var parentStateCIPValue = skyward.controls.getValue(sectionDiv.find("#StateCIPWADesc" + controlID));
            var overrideStateCIPValue = skyward.controls.getValue(sectionDiv.find("#StateCIPWAID" + controlID + "_code"));
            var useOverrideStateCIP = skyward.controls.getValue(sectionDiv.find("#UseStateCIPOverride" + controlID));

            if (numericYear > 2020)
            {
                if (useOverrideStateCIP && overrideStateCIPValue !== "")
                {
                    skyward.controls.show("#fsIndustryRecognizedCertifications" + controlID)
                }
                else if (!useOverrideStateCIP && parentStateCIPValue !== "")
                {
                    skyward.controls.show("#fsIndustryRecognizedCertifications" + controlID)
                }
                else
                {
                    skyward.controls.hide("#fsIndustryRecognizedCertifications" + controlID)
                    skyward.controls.setValue("#SelectedStateCertificationWAEELDictionary" + controlID, null)
                }
            }
            else
            {
                skyward.controls.hide("#fsIndustryRecognizedCertifications" + controlID)
                skyward.controls.setValue("#SelectedStateCertificationWAEELDictionary" + controlID, null)
            }

            if (numericYear >= 2022)
            {
                if (useOverrideStateCIP && overrideStateCIPValue !== "")
                {
                    skyward.controls.show("#fsStateWorkBasedLearningActivitesWA" + controlID);
                }
                else if (!useOverrideStateCIP && parentStateCIPValue !== "")
                {
                    skyward.controls.show("#fsStateWorkBasedLearningActivitesWA" + controlID);
                }
                else
                {
                    skyward.controls.hide("#fsStateWorkBasedLearningActivitesWA" + controlID);
                    skyward.controls.setValue("#SelectedWorkBasedLearningActivityWAEELDictionary" + controlID, null);
                }
            }
            else
            {
                skyward.controls.hide("#fsStateWorkBasedLearningActivitesWA" + controlID);
                skyward.controls.setValue("#SelectedWorkBasedLearningActivityWAEELDictionary" + controlID, null);
            }

            return;
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
(
    function (skyward, $, undefined)
    {
        skyward.userstudenttilesetting = skyward.userstudenttilesetting || {};

        var init = function (selector)
        {
            // Initialize UserStudentTileSetting editable browses
            if ($(selector).find('.widgetisenabledcheckbox').length > 0)
            {
                var element = $(selector).find('.widgetisenabledcheckbox');
                element.on('click', skyward.userstudenttilesetting.saveUserStudentTileSettings);
            }
        };

        skyward.userstudenttilesetting.saveUserStudentTileSettings = function ()
        {
            var isEnabledCheckbox = $(this);

            var accessMode = $('#accessmode').val();

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Family/UserStudentTileSetting/SaveUserStudentTileSetting" + accessMode,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        userStudentTileSettingID: isEnabledCheckbox.attr('id').split('-')[1],
                        enabled: isEnabledCheckbox[0].checked
                    },
                    success: function (returnData)
                    {
                        if (!returnData.success)
                        {
                            isEnabledCheckbox[0].checked = !isEnabledCheckbox[0].checked
                        }
                    }
                });
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.easyiep = skyward.easyiep || {};

        var init = function (selector)
        {
            "use strict";

            var pageCheck;

            pageCheck = $(selector).find("#b7bc399a-e0e8-4bc5-ad28-f123b973dd13");

            if (pageCheck.length > 0) {
                var importTypeCode = $(selector).find("#ImportTypeCode");

                var importTypeCodeChange = function ()
                {
                    skyward.easyiep.handleImportTypeCodeChange();
                }

                importTypeCode.on("change", importTypeCodeChange);
            }
            else {
                return;
            }
        }

        skyward.easyiep.handleImportTypeCodeChange = function ()
        {
            var specialEdRadioButton = $("#ImportTypeCode_RadioButtonGroup input[type='radio'][value='SE']");
            var fileSelect = $("#fileSelect");
            var chooseFileRadioButton;

            if (specialEdRadioButton.is(":checked")) {
                chooseFileRadioButton = $("#FilePathOptionSpecial_RadioButtonGroup input[type='radio'][value='C']");
            }
            else {
                chooseFileRadioButton = $("#FilePathOption504_RadioButtonGroup input[type='radio'][value='C']");
            }

            if (chooseFileRadioButton.is(":checked")) {
                fileSelect.show();
            }
            else {
                fileSelect.hide();
            }
        }

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.gradebookcodeeel = skyward.gradebookcodeeel || {};

        const requestHandler = skyward.extensions.getSingleRequestHandler();

        const idGenerator = skyward.extensions.getIdGenerator("popup", "_gradebookCodeEelBrowse");

        var init = function (selector)
        {
            $(selector).find(".gradebookCodeEEL:not(.eventsBound)").each(function ()
            {
                skyward.gradebookcodeeel.registerCodeEEL($(this));
            });

            $(selector).find(".gradebookCodeEEL").off("change").on("change", function () { skyward.gradebookcodeeel.handleChange($(this)); });
        };

        skyward.gradebookcodeeel.handleChange = function (gradebookCodeEEL, selectedValueID)
        {
            var area = "Gradebook";
            var controller = "Gradebook";
            var action = "ValidateGradebookCodeEEL";

            var input = gradebookCodeEEL.find(".gradebookInputCodeEEL");

            var setBackingPercent = function (input, returnData)
            {
                if (returnData.backingPercent != null)
                {
                    input.data("backingPercent", returnData.backingPercent);
                }
            };

            var data = skyward.gradebookcodeeel.handleChangeNoSave(gradebookCodeEEL, selectedValueID);

            return $.ajax(
            {
                url: skyward.global.virtualDir + area + "/" + controller + "/" + action,
                type: "POST",
                dataType: "JSON",
                data: data,
                activityIndicator: { silent: data.silentAjax },
                success: function (returnData)
                {
                    if (returnData.hasMatch)
                    {
                        setBackingPercent(input, returnData);
                        input.trigger("gradebookInputCodeEELValid", [returnData]);
                    }
                    else
                    {
                        input.trigger("gradebookInputCodeEELInvalid", [returnData]);
                    }

                    var modalLayers = skyward.modalLayer.getOpenModalLayers();
                    if (modalLayers && modalLayers.length > 0)
                    {
                        for (var i = 0; i < modalLayers.length; i++)
                        {
                            var modalLayer = $(modalLayers[i]);

                            if (modalLayer.find('div.gradebookCodeEELPopup').length > 0)
                            {
                                skyward.modalLayer.closeModalLayer(modalLayer);
                            }
                        }
                    }
                }
            });
        };

        skyward.gradebookcodeeel.handleChangeNoSave = function (gradebookCodeEEL, selectedValueID)
        {
            var input = gradebookCodeEEL.find(".gradebookInputCodeEEL");

            var data = input.data();

            var wrapperData = gradebookCodeEEL.data();
            delete wrapperData.selectedValueID;
            data.postData = JSON.stringify(wrapperData);
            data.selectedValueID = selectedValueID;

            data.value = skyward.controls.getValue(input);
            return data;
        };

        skyward.gradebookcodeeel.setValue = function (input, displayValue, selectedValueID, suppressChangeEvents)
        {
            if ((displayValue == null || displayValue == "") && !input.hasClass('scoreClarifier'))
            {
                displayValue = "*";
            }

            input.data("displayValue", displayValue);
            input.data("selectedValueID", selectedValueID);
            input.data("mostRecentEditableDisplayValue", displayValue);

            skyward.controls.setValue(input, displayValue, suppressChangeEvents);
        };

        skyward.gradebookcodeeel.getData = function (input)
        {
            var inputData = input.data();

            if (inputData.selectedValueID == null)
            {
                inputData.selectedValueID = null;
            }

            var returnData =
            {
                displayValue: inputData.displayValue,
                selectedValueID: inputData.selectedValueID,
                mostRecentEditableDisplayValue: inputData.mostRecentEditableDisplayValue,
                backingPercent: inputData.backingPercent
            };

            return returnData;
        };

        skyward.gradebookcodeeel.setOriginalValueData = function (input, displayValue, selectedValueID)
        {
            input.data("originalValue", displayValue);
            input.data("originalDisplayValue", displayValue);
            input.data("originalSelectedValueID", selectedValueID);
        };

        skyward.gradebookcodeeel.getOriginalValueData = function (input)
        {
            var inputData = input.data();

            if (inputData.originalSelectedValueID == null)
            {
                inputData.originalSelectedValueID = "";
            }

            var returnData =
            {
                originalDisplayValue: inputData.originalDisplayValue,
                originalSelectedValueID: inputData.originalSelectedValueID
            };
            return returnData;
        };

        skyward.gradebookcodeeel.registerCodeEEL = function (codeEEL)
        {
            let lastValue; // stores the last searched value to prevent unnecessary searches
            let selectedValue = null;
            const eelData =
            {
                codeEEL: codeEEL,
                eelTextBox: codeEEL.find(".gradebookInputCodeEEL"),
                dropDownArrow: codeEEL.find(".gradebookCodeEELButton"),
                layer: null
            };
            eelData.eelTextBoxData = eelData.eelTextBox.data();
            if (codeEEL.length > 0)
            {
                var wrapperData = codeEEL.data();
                eelData.eelTextBoxData.postData = JSON.stringify(wrapperData);
            }

            var getBrowsePostData = function (textBox)
            {
                var postData = {};

                postData.filter = JSON.stringify(eelData.filter);
                postData.isGradebookCodeEEL = "true";
                $.extend(postData, eelData.eelTextBoxData);

                if (!textBox.data("dynamicfiltervalue"))
                {
                    return $.extend({}, eelData.postData, postData);
                }

                var filterPostData = {};
                var dependentFields = textBox.data("dynamicfilterfield").split(',');
                var dependentValues = textBox.data("dynamicfiltervalue").split(',');
                var dependentAttributes = textBox.data("dynamicfilterattribute").split(',');

                for (var i = 0; i < dependentFields.length; i++)
                {
                    var dependentElement = $('[name="' + dependentValues[i] + '"]');
                    if (dependentElement.length === 0)
                    {
                        dependentElement = $('#' + dependentValues[i] + ' .dmsBackingData');
                    }

                    var dependentStringArray = dependentAttributes[i].split("-");
                    if (dependentStringArray.length >= 3 && dependentStringArray[2].length > 0)
                    {
                        var finalDependentString = dependentStringArray[1] + dependentStringArray[2].charAt(0).toUpperCase() + dependentStringArray[2].slice(1);

                        if (typeof dependentElement.data(finalDependentString) !== 'undefined')
                        {
                            postData[dependentFields[i]] = dependentElement.data(finalDependentString);
                        }
                    }
                    else
                    {
                        postData[dependentFields[i]] = skyward.controls.getValue(dependentElement);
                    }
                }

                var dependentBrowsePostData = {};
                for (var key in eelData.postData)
                {
                    var fieldName = key.substring(key.lastIndexOf('.') + 1);

                    if (filterPostData[fieldName] && filterPostData[fieldName] != eelData.postData[key])
                    {
                        dependentBrowsePostData[key] = filterPostData[fieldName];
                    }
                    else
                    {
                        dependentBrowsePostData[key] = eelData.postData[key];
                    }
                }

                return $.extend({}, dependentBrowsePostData, filterPostData, postData);
            };

            const closeOpenEelBrowse = function (browseId, textbox)
            {
                eelData.layer = null;
                lastValue = null;
                requestHandler.closeOpenRequest();
                textbox.focus();
                delete skyward.browse.browseList[browseId];
                skyward.browse.openBrowses.splice(skyward.browse.openBrowses.indexOf(browseId), 1);
            };

            const handleTabPress = function (_browseId, _textbox)
            {
                skyward.browse.handlePopupBrowseTabPress();
            };

            const createModalLayer = function (browseId, textbox)
            {
                var textBoxId = codeEEL.attr("id");
                var popupContent = $("<div>", { "class": "popup gradebookCodeEELPopup", id: textBoxId + "_popup" });
                popupContent.append($("<div>", { id: browseId, "class": "browse" }));

                skyward.browse.eventCallbacks.recordSelectionMade.registerCallback(selectionMadeHandler);

                var beforeClose = function (layer, reason)
                {
                    if (reason == "glassClick" || reason == "escape")
                    {
                        return;
                    }

                    var selectedValueID = selectedValue;
                    if (selectedValueID == null)
                    {
                        selectedValueID = "";
                    }

                    var input = codeEEL.find(".gradebookInputCodeEEL");

                    if (selectedValueID != skyward.gradebookcodeeel.getData(input).selectedValueID)
                    {
                        skyward.gradebookcodeeel.handleChange.apply(codeEEL, [codeEEL, selectedValueID]);
                    }

                    skyward.browse.eventCallbacks.recordSelectionMade.deregisterCallback(selectionMadeHandler);

                    closeOpenEelBrowse(browseId, textbox);
                };

                var bindings =
                [
                    {
                        onEvents: "keydown",
                        bindTo: codeEEL,
                        runFunction: function (event)
                        {
                            if (event.keyCode && event.keyCode == 9)
                            {
                                handleTabPress(browseId, $(this));
                                event.preventDefault();
                            }
                        }
                    },
                    {
                        onEvents: "input",
                        bindTo: codeEEL,
                        runFunction: skyward.debounce(filterInputEvents(inputEvent))
                    }
                ];

                skyward.modalLayer.showCodeEELDialog(popupContent, textbox, codeEEL, beforeClose, eelData, bindings);

                function selectionMadeHandler(eventData)
                {
                    if (eventData.browseId === browseId)
                    {
                        selectedValue = eventData.selectedId;
                    }
                }
            };

            var addToBrowseList = function (browseId, textbox)
            {
                var data = textbox.data();
                skyward.browse.browseList[browseId] =
                {
                    id: browseId,
                    pageModule: data.pageModule,
                    pageObject: data.pageObject,
                    pageScreen: "codeBrowse",
                    browseType: "Default",

                    routeModule: data.pageModule,
                    routeObject: data.pageObject,
                    browseName: "browse",

                    dataModule: data.pageModule, //TODO: PR 4339258 update to use actual dataModule instead of pageModule
                    dataObject: data.pageObject, //TODO: PR 4339258 update to use actual dataObject instead of pageObject

                    selectMode: true,
                    refreshTimeout: -1,
                    data: getBrowsePostData(textbox),
                    keyEventsEnabled: true,
                    renderViewButton: true,
                    renderFilterButton: false,
                    renderQuickFilter: false,
                    disableBrowseSort: true,
                    hideOptionsButton: true,
                    preventColumnResize: true,
                    hideMoreMenuArea: true,
                    queryParameterData: eelData.codeEELQueryParameterData,
                    routeHash: eelData.eelTextBoxData.routeHash
                };

                skyward.browse.openBrowses.push(browseId);
            };

            var inputEvent = function ()
            {
                var textbox = $(this);

                if (lastValue != null && textbox.val().toLowerCase() === lastValue.toLowerCase())
                {
                    return;
                }

                if (eelData.layer == null || eelData.layer.onscreen == false)
                {
                    showPopup(textbox);
                }

                doSearch(textbox.val());
                lastValue = textbox.val();
                selectedValue = null;
            };

            var previousValues = {};

            // filter input events for IE 10 & 11
            var filterInputEvents = function (inputHandler, one)
            {
                var filteredFunction = function (event)
                {
                    var input = $(this).find('.gradebookInputCodeEEL');
                    input = input && input.length > 0 ? input[0] : this;
                    if (event.type !== "input")
                    {
                        inputHandler.apply(input, arguments);
                    }

                    if (!previousValues.hasOwnProperty(input))
                    {
                        previousValues[input] = input.defaultValue;
                    }

                    var newValue = $(input).val();

                    if (newValue != previousValues[input])
                    {
                        inputHandler.apply(input, arguments);
                        previousValues[input] = newValue;
                    }
                    else if (one)
                    {
                        // re-attach event
                        addInitialInputEvent();
                    }
                };

                // Use the same guid, so the event can removed with .off()
                filteredFunction.guid = inputHandler.guid || (inputHandler.guid = jQuery.guid++);

                return filteredFunction;
            };

            var showPopup = function (input)
            {
                const browseId = idGenerator.getNewId();
                addToBrowseList(browseId, input);
                createModalLayer(browseId, input);
            };

            var doSearch = function (searchText)
            {
                const browse = skyward.browse.getInnerBrowse(eelData.layer.container);
                if (browse === undefined)
                {
                    return;
                }
                const browseId = browse.id;
                if (!searchText)
                {
                    eelData.eelTextBoxData.seekId = eelData.eelTextBox.data().selectedValueID;
                }
                else
                {
                    eelData.eelTextBoxData.seekId = null;
                }

                requestHandler.request = skyward.browse.performGradebookCodeEELSearch(browseId, eelData.eelTextBoxData, searchText);
                $.when(requestHandler.request).done(function (data)
                {
                    handleGradebookCodeEELFailure(data);
                });
            };

            eelData.dropDownArrow.off('click').on("click", function (event)
            {
                const arrow = $(this);
                if (arrow.hasClass("ui-disabled"))
                {
                    return;
                }

                // Set the selected id to the hidden value on load in case an id is already selected
                selectedValue = eelData.eelTextBox.data().selectedValueID;
                var input = arrow.siblings(".gradebookInputCodeEEL");
                if (eelData.layer == null || eelData.layer.onscreen == false)
                {
                    showPopup(input);
                    doSearch();
                }
                else
                {
                    eelData.layer.close('glassClick');
                }
                event.preventDefault();
                event.stopPropagation();
            });

            codeEEL.addClass("eventsBound");
        };

        var handleGradebookCodeEELFailure = function (data)
        {
            if (data && data.success == false && data.popupHTML && data.popupHTML.Content)
            {
                skyward.modalLayer.showReloadDialog("Gradebook Alert", data.popupHTML.Content);
            }
        }

        var events =
        {

        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('gradebookcodeeel', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
///<reference path="skyward.base.global.js"/>
(
function (skyward, $, undefined) {
    "use strict";
    skyward.formTextEditor = skyward.formTextEditor || {};

    skyward.formTextEditor.launch = function (originalValue, module, object, relationshipPath, options) {
        /// <summary>
        /// Launch a form-text editor.
        /// </summary>
        /// <param name="originalValue" type="string">The form-text to display in the editor on startup.</param>
        /// <param name="module" type="string">The starting module for the 'fields' treebrowse<br/>Note: module, object, and relationshipPath also filter calculated fields list.</param>
        /// <param name="object" type="string">The starting object for the 'fields' treebrowse<br/>Note: module, object, and relationshipPath also filter calculated fields list.</param>
        /// <param name="relationshipPath" type="string">The path to prepend to fieldnames selected from the treebrowse.<br/>Note: module, object, and relationshipPath also filter calculated fields list.</param>
        /// <param name="options" type="object">An object containing any of the following parameters: <br/>
        ///     prompts: (PromptsModel) prompts model to include in the prompts-list.<br/>note: Prompts list will be hidden if no value is provided<br/>
        ///     calculatedFields: (CalculatedFields_Model) calculated fields to include in the calculated fields list.<br/>note: List will be hidden if no value is provided<br/>
        /// </param>
        /// <returns>A promise which is either resolved with (data: friendlyValue }) if the popup is saved, or rejected if the popup is cancelled.</returns>
        /// <remarks>Prompt and Calculated Field bindings are returned in *friendly name* format and must be converted by the calling code before unbinding can occur</remarks>
        var deferred = $.Deferred();
        relationshipPath = relationshipPath || "";
        var calculatedFields = (options.calculatedFields) ? JSON.stringify(options.calculatedFields.AllFields()) : null;
        var prompts = (options.prompts) ? options.prompts.toJsonString() : null;
        var aggregateFields = options.aggregateFields ? JSON.stringify(options.aggregateFields) : null;

        var showPopup = function (jsonResult) {
            var popup;
            var textArea;
            var tabs;
            var activeTab = $();
            var fieldContainers = $();

            // Create a friendly-name converter delegate based on whether or not we were provided prompts and/or calculated fields
            var doNothing = function (s) { return s; };
            var convertPromptsToFriendlyNames = (typeof options.prompts.ConvertPromptBindingsToFriendlyNames === "function") ? options.prompts.ConvertPromptBindingsToFriendlyNames : doNothing;
            var convertCalculatedFieldsToFriendlyNames = (typeof options.calculatedFields.ConvertBindingsToFriendlyNames === 'function') ? options.calculatedFields.ConvertBindingsToFriendlyNames : doNothing;
            var convertToFriendlyNames = function (s) { return convertCalculatedFieldsToFriendlyNames(convertPromptsToFriendlyNames(s)); };

            var saveAndClose = function () {
                var result = textArea.val();
                popup.close();
                deferred.resolve(result);
            };
            var cancelAndClose = function () {
                popup.close();
                deferred.reject();
            }

            var selectActiveTab = function (event) {
                var tab = $(this);
                if (!tab.is(activeTab)) {
                    activeTab.removeClass("active").data('jqRelatedElements').addClass("hidden");
                    tab.addClass("active").data('jqRelatedElements').removeClass("hidden");
                    activeTab = tab;
                }
                event.stopPropagation;
                return false;
            }

            var insertField = function (fieldName) {
                skyward.global.text.insertTextToken(textArea, convertToFriendlyNames("{" + fieldName + "}"));
            }
            var insertCustomField = function () {
                insertField($(this).data('fieldBinding'));
            }
            var insertTreeBrowseField = function (event, _treeBrowseData, selectedRecordData) {
                var fullFieldName = selectedRecordData.absoluteFieldPath;
                insertField(fullFieldName);
                event.stopPropagation();
                return false;
            }


            var buttons = [
                { text: "Save", click: saveAndClose, icon: "Save" },
                { text: "Cancel", click: cancelAndClose, icon: "Cancel" }
            ];
            popup = skyward.modalLayer.showDialog("Form Text Editor", jsonResult.html, buttons, { width: "953px", closeOnClick: false, automationID: "form-text-dialog" });
            popup.bodyPromise.done(function () {
                textArea = popup.content.find(".fteTextArea");
                textArea.val(originalValue).focus();

                tabs = popup.content.find(".fteTab");
                tabs.each(function getFieldContainers() {
                    var data = $(this).data();
                    data.jqRelatedElements = popup.content.find(data.relatedElements);
                    fieldContainers = fieldContainers.add(data.jqRelatedElements);
                });

                activeTab = tabs.filter(".active");
                tabs.on("click", selectActiveTab);

                fieldContainers.on('dblclick', '.fteField', insertCustomField);
                popup.content.on("treeBrowseSave", insertTreeBrowseField);
            });
        };

        $.ajax(skyward.global.virtualDir + "Common/FormTextEditor/GetPopup",
        {
            type: "POST",
            dataType: "JSON",
            data: {
                module: module,
                obj: object,
                relationshipPath: relationshipPath,
                prompts: prompts,
                calculatedFields: calculatedFields,
                aggregateFields: aggregateFields,
                additionalFilterTypeName: options.additionalFilterTypeName
            }
        }).done(showPopup);

        return deferred;
    }
}(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        'use strict'; 

        var init = function (selector)
        {
            $(selector + ' .js-getTestDetails').on('change', triggerTestDetails);
            $(selector + ' .js-calculateIsPassingScore').on('change', function ()
            {
                var fieldPrefix = skyward.controls.getValue('#TableNameHidden');
                var scoreFieldName = skyward.controls.getValue('#ScoreFieldNameHidden');
                var isPassingScoreFieldName = skyward.controls.getValue('#IsPassingScoreFieldNameHidden');
                var scoreValue = skyward.controls.getValue('#' + fieldPrefix + '_' + scoreFieldName);
                var passingScoreValue = skyward.controls.getValue('#PassingScoreHidden');

                skyward.controls.setValue('#' + fieldPrefix + '_' + isPassingScoreFieldName, parseInt(scoreValue) >= parseInt(passingScoreValue));
            });

            if ($(selector).find("#TestControls").length)
            {
                $(selector).find("select.TestSelectClassname").on("change", function () { testControlChanged(); });
                $(selector).find("select.TestVersionSelectClassname").on("change", function () { testVersionControlChanged(); });
            }
        };

        var triggerTestDetails = function ()
        {
            var testVersionID = skyward.controls.getValue($('#StudentTestTestVersionID'));

            $.ajax
                ({
                    url: skyward.global.virtualDir + 'Assessment/StudentTest/TestDetailsWorkflow',
                    type: 'POST',
                    dataType: 'HTML',
                    data: { selectedTestVersion: testVersionID },
                    success: function (returnData)
                    {
                        var parseData = JSON.parse(returnData);
                        if (parseData.Success)
                        {
                            $('#TestDetailsDiv').html(parseData.ViewPartHtml);
                            skyward.window.notifyResize();
                            skyward.window.notifyDOMLoad('#TestDetailsDiv');
                        }
                    }
                });
        };

        var testControlChanged = function ()
        {
            var testSelectControlValue = skyward.controls.getValue($("select.TestSelectClassname"));
            var testVersionSelectControl = $("select.TestVersionSelectClassname");
            var sectionID = skyward.controls.getValue($("#SectionID"));
            var jsonDict = JSON.parse(skyward.controls.getValue($("#TestDict")));

            if (testSelectControlValue in jsonDict)
            {
                var test = jsonDict[testSelectControlValue];

                var newSelectedTestVersionID = "";

                var versionKeys = Object.keys(test.TestVersions);
                var orderedVersionKeys = Object.keys(test.TestVersionsByDisplayOrder);

                if (versionKeys.length > 0 && orderedVersionKeys.length > 0)
                {
                    newSelectedTestVersionID = test.TestVersionsByDisplayOrder[orderedVersionKeys.length];

                    testVersionSelectControl.empty();

                    for (var key in test.TestVersionsByDisplayOrder)
                    {
                        var realKey = test.TestVersionsByDisplayOrder[key];
                        testVersionSelectControl.append($('<option></option>').attr("value", realKey).attr("classname", "option ").text(test.TestVersions[realKey]));
                    }
                    skyward.controls.setValue(testVersionSelectControl, newSelectedTestVersionID);

                    RebuildStudentTestBrowse(sectionID, testSelectControlValue, newSelectedTestVersionID);
                }
            }
        }

        var testVersionControlChanged = function ()
        {
            var testSelectControlValue = skyward.controls.getValue($("select.TestSelectClassname"));
            var testVersionSelectControlValue = skyward.controls.getValue($("select.TestVersionSelectClassname"));
            var sectionID = skyward.controls.getValue($("#SectionID"));

            RebuildStudentTestBrowse(sectionID, testSelectControlValue, testVersionSelectControlValue);
        }

        var RebuildStudentTestBrowse = function (sectionID, selectedTestID, selectedTestVersionID)
        {
            var dataParams =
            {
                sectionID: sectionID,
                selectedTestID: selectedTestID,
                selectedTestVersionID: selectedTestVersionID
            };

            $.ajax
                ({
                    url: skyward.global.virtualDir + "Assessment/StudentTestBySection/RebuildStudentTestBrowse",
                    type: "POST",
                    dataType: "JSON",
                    data: dataParams,
                    success: async function (returnData) {
                        var updateHTML = returnData.Success;
                        if (updateHTML === true)
                        {
                            await $('#StudentTestsWrapperDiv').viewpartHtml(returnData.ViewPartHTML);
                            skyward.window.notifyResize();
                            skyward.window.notifyDOMLoad("#StudentTestsWrapperDiv");
                        }
                    }
                });
        }        

        function calculateReadingBeginningLevelTotal(context)
        {
            var readingBeginningLevelFields = ['ReadingBeginningLevelCategory1', 'ReadingBeginningLevelCategory2or3'];
            calculateReadingLevelTotal(context, 'ReadingBeginningLevelTotal', readingBeginningLevelFields);
        }

        function calculateReadingIntermediateLevelTotal(context)
        {
            var readingIntermediateLevelFields = ['ReadingIntermediateLevelCategory1', 'ReadingIntermediateLevelCategory2', 'ReadingIntermediateLevelCategory3'];
            calculateReadingLevelTotal(context, 'ReadingIntermediateLevelTotal', readingIntermediateLevelFields);
        }

        function calculateReadingAdvancedLevelTotal(context)
        {
            var readingAdvancedLevelFields = ['ReadingAdvancedLevelCategory1', 'ReadingAdvancedLevelCategory2', 'ReadingAdvancedLevelCategory3'];
            calculateReadingLevelTotal(context, 'ReadingAdvancedLevelTotal', readingAdvancedLevelFields);
        }

        function calculateReadingLevelTotal(context, totalField, readingLevelFields)
        {
            var readingLevelTotalID = context.find('#' + totalField);
            context.find('.js-Calculate' + totalField).on('change', function () { updateReadingLevelTotal(readingLevelTotalID, readingLevelFields); });
        }

        function updateReadingLevelTotal(totalField, fields)
        {
            var total = 0;

            fields.forEach(function (field)
            {
                var fieldValue = Number(skyward.controls.getValue($('#' + field)));
                if (fieldValue != null)
                {
                    total += fieldValue;
                }
            });

            skyward.controls.setValue(totalField, total);

            return total;
        }

        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('studenttest',
        {
            'calculateReadingBeginningLevelTotal': calculateReadingBeginningLevelTotal,
            'calculateReadingIntermediateLevelTotal': calculateReadingIntermediateLevelTotal,
            'calculateReadingAdvancedLevelTotal': calculateReadingAdvancedLevelTotal
        });
    }(window.skyward = window.skyward || {}, window.jQuery)
);
(
    function (skyward, $, undefined)
    {
        skyward.user = skyward.user || {};

        var massUpdateFamilyAccessUserProcessOptionInformationPopup = function (event)
        {
            var button = $(this);
            var title = 'Process Options Information';
            var options =
                {
                    anchorTo: button,
                    id: "MassUpdateFamilyAccessUserProcessOptionInformationPopup"
                };

            var message = '<span class="boldFont">Process All Guardians:</span><span> Will give the guardian access to all the students for which they are a guardian.\n\n</span>';
            message += '<span class="boldFont">Process Selected Guardians:</span><span> If a guardian has multiple students they will be listed for each student on the selection screen.\n\n</span>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var massUpdateFamilyAccessUserOptionInformationPopup = function (event)
        {
            var button = $(this);
            var title = 'Process Options Information';
            var options =
                {
                    anchorTo: button,
                    id: "MassUpdateFamilyAccessUserOptionInformationPopup"
                };

            var message = '<span class="boldFont">Give Family Access Security to Guardians with \"Family Access\" Checked:</span><span> All selected guardians will now have access to Family Access.  This is done by making the selected guardians secured users and adding them to the Family Access security group*.\n\</span>';
            message += '<span class="boldFont">This option will only affect guardians who already have the Family Access Flag checked.\n\n</span>';
            message += '<span class="boldFont">Check \"Family Access\" for Guardians and Give Family Access Security:</span><span> All selected guardians will now have access to Family Access.  This is done by making the selected guardians secured users, adding them to the Family Access security group and checking the Family Access flag for the selected student(s)*.\n\n</span>';
            message += '<span class="boldFont">Remove Family Access Security and uncheck \"Family Access\" for Guardians:</span><span> All selected guardians will no longer have access to Family Access for any of their students. This is done by removing them from the Family Access Security Group and unchecking the Family Access flag.\nThe guardian will still be a User but will not have access to Family Access.\n\n</span>';
            message += '<span class="boldFont">Verify and Update Family Access Security:</span><span> All selected guardians will be updated to have the correct Family Access setup.  This is done in the following ways:\n1) Adds guardians flagged for Family Access to the correct security groups based on your current security setup*.\n2) If the guardian is currently not flagged as Allow Family Access for a student, it will remove the Family Access security groups from their security.  They will also be removed as a security user if the user now has no security groups.\n\n</span>';
            message += '<span class="boldFont">Resend Family Access Email:</span><span> Use this option to resend the Family Access Email to guardians that are setup to have access to Family Access and have an email entered in the system.\nThis option does no setup of guardians, it simply sends the email to those that are already setup.\n\n</span>';
            message += '<span class="boldFont">Add New Student Enrollment Security:</span><span> All selected guardians will now have access to New Student Enrollment. This is done by making the selected guardians secured users and adding them to the New Student Enrollment security group.\n\n</span>';
            message += '<span class="boldFont">Remove New Student Enrollment Security:</span><span> All selected guardians will no longer have access to New Student Enrollment. This is done by removing them from the New Student Enrollment security group.\nThe guardian will still be a User but will not have access to New Student Enrollment.\n\n</span>';

            message += '<span class="boldFont">*: If the Send Family Access Email option is selected, an email will be sent to each selected guardian assuming they have an email address and are a member of the Family Access security group.\nIf you ran an option that adds them to this security group, they will also get the email.</span>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var massUpdateActivityAccessUserOptionInformationPopup = function (event)
        {
            var button = $(this);
            var title = 'Process Options Information';
            var options =
                {
                    anchorTo: button,
                    id: "MassUpdateActivityAccessUserOptionInformationPopup"
                };

            var message = '<span class="boldFont">Give Activity Access Security to Activity Personnel with \"Activity Access\" Checked:</span><span> All selected personnel will now have access to Activity Access.  This is done by making the selected personnel secured users and adding them to the Activity Access security group*.\n\</span>';
            message += '<span class="boldFont">This option will only affect personnel who already have the Activity Access Flag checked.\n\n</span>';
            message += '<span class="boldFont">Check \"Activity Access\" for Activity Personnel and Give Activity Access Security:</span><span> All selected personnel will now have access to Activity Access.  This is done by making the selected personnel secured users, adding them to the Activity Access security group and checking the Activity Access flag for the selected activities*.\n\n</span>';
            message += '<span class="boldFont">Remove Activity Access Security and uncheck \"Activity Access\" for Activity Personnel:</span><span> All selected personnel will no longer have access to Activity Access for any of their students. This is done by removing them from the Activity Access Security Group and unchecking the Activity Access flag.\nThe personnel will still be a User but will not have access to Activity Access.\n\n</span>';
            message += '<span class="boldFont">Verify and Update Activity Access Security:</span><span> All selected personnel will be updated to have the correct Activity Access setup.  This is done in the following ways:\n1) Adds personnel flagged for Activity Access to the correct security groups based on your current security setup*.\n2) If the Activity Personnel is currently not flagged as Allow Activity Access for a student, it will remove the Activity Access security groups from their security.  They will also be removed as a security user if the user now has no security groups.\n\n</span>';
            message += '<span class="boldFont">Resend Activity Access Email:</span><span> Use this option to resend the Activity Access Email to personnel that are setup to have access to Activity Access and have an email entered in the system.\nThis option does no setup of personnel, it simply sends the email to those that are already setup.\n\n</span>';

            message += '<span class="boldFont">*: If the Send Activity Access Email option is selected, an email will be sent to each selected Activity Personnel assuming they have an email address and are a member of the Activity Access security group.\nIf you ran an option that adds them to this security group, they will also get the email.</span>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var massUpdateStudentAccessUserOptionInformationPopup = function (event)
        {
            var button = $(this);
            var title = 'Process Options Information';
            var options =
                {
                    anchorTo: button,
                    id: "MassUpdateStudentAccessUserOptionInformationPopup"
                };

            var message = '<span class="boldFont">Give Student Access Security to Students with \"Student Access\" Checked:</span><span> All selected students will now have access to Student Access.  This is done by making the selected students secured users and adding them to the Student Access security group*. This will also reactivate any inactive student users.\n\</span>';
            message += '<span class="boldFont">This option will only affect students who already have the Student Access Flag checked.\n\n</span>';
            message += '<span class="boldFont">Check \"Student Access\" for Students and Give Student Access Security:</span><span> All selected students will now have access to Student Access.  This is done by making the selected students secured users, adding them to the Student Access security group and checking the Student Access flag.\n\n</span>';
            message += '<span class="boldFont">Remove Student Access:</span><span> All selected Students will no longer have access to Student Access. This is done by unchecking the Student Access flag on the Student Profile General Tab. The Student will still be a user and will be in the Student Access Security Group but will not have access to Student Access.\n\n</span>';
            message += '<span class="boldFont">Verify and Update Student Access Security:</span><span> All selected students will be updated to have the correct Student Access setup.  This is done in the following ways:\n1) Adds students flagged for Student Access to the correct security groups based on your current security setup*.\n2) If the student is currently not flagged as Allow Student Access, it will remove the Student Access security groups from their security.  They will also be removed as a security user if the user now has no security groups.\n\n</span>';
            message += '<span class="boldFont">Resend Student Access Email:</span><span> Use this option to resend the Student Access Email to students that are setup to have access to Student Access and have an email entered in the system.\nThis option does no setup of students, it simply sends the email to those that are already setup.\n\n</span>';
            message += '<span class="boldFont">Generate Access Code:</span><span>Any students whose user record has a blank Access Code will have a new code randomly generated.  The length of the code is specified in the Security System Configuration.</span>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var districtYearConfigurationDetailsLimitStudentApplicationSubmissionsPopup = function (event)
        {
            var button = $(this);
            var title = 'Setting Information';
            var options =
            {
                anchorTo: button,
                id: "DistrictYearConfigurationDetailsLimitStudentApplicationSubmissionsPopup"
            };

            var message = '<span>Enabling this option will prevent the submission of a Student Application for an existing Student while they have an active enrollment and approved application for the same Entity and School Year.</span>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var massImportAttachmentTemplateDuplicateInformationPopup = function (event)
        {
            var button = $(this);
            var title = 'More Information';
            var options =
            {
                anchorTo: button,
                id: "MassImportAttachmentTemplateDuplicateInformationPopup"
            };

            var message = '<span class="boldFont">Keep Duplicate and Original File:\n</span><span>Import the new file and keep both the original and duplicate files.\n\n</span>';
            message += '<span class="boldFont">Overwrite Original File:\n</span><span>Replace the original file with the new one.\n\n</span>';
            message += '<span class="boldFont">Do Not Import Duplicate File:\n</span><span>Skip importing the new file if a duplicate exists.\n\n</span>';

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var events =
        {
            'massUpdateFamilyAccessUserProcessOptionInformationPopup': massUpdateFamilyAccessUserProcessOptionInformationPopup,
            'massUpdateFamilyAccessUserOptionInformationPopup': massUpdateFamilyAccessUserOptionInformationPopup,
            'massUpdateStudentAccessUserOptionInformationPopup': massUpdateStudentAccessUserOptionInformationPopup,
            'massUpdateActivityAccessUserOptionInformationPopup': massUpdateActivityAccessUserOptionInformationPopup,
            'districtYearConfigurationDetailsLimitStudentApplicationSubmissionsPopup': districtYearConfigurationDetailsLimitStudentApplicationSubmissionsPopup,
            'massImportAttachmentTemplateDuplicateInformationPopup': massImportAttachmentTemplateDuplicateInformationPopup,
        };

        // Bootstrap
        skyward.events.registerEvents('user', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined)
    {
        skyward.yearend = skyward.yearend || {};

        var studentYearEndProcessSummaryID = "StudentYearEndProcessSummary";
        var processSummaryContainerTargetID = "ProcessSummaryContainerTarget";
        var processSummaryContainerTarget;
        var targetSchoolYearComboBoxID = "TargetSchoolYearID";

        var init = function (selector)
        {
            var studentYearEndProcessSummaryDiv = $("#" + studentYearEndProcessSummaryID);
            if (!studentYearEndProcessSummaryDiv.length)
            {
                return;
            }

            processSummaryContainerTarget = $("#" + processSummaryContainerTargetID);
            $("#" + targetSchoolYearComboBoxID).off("change", targetSchoolYearChanged).on("change", targetSchoolYearChanged);
        };

        var targetSchoolYearChanged = function ()
        {
            console.log("change fired");
            var selectedValue = skyward.controls.getValue($(this));
            console.log("selectedValue: " + selectedValue);

            $.ajax({
                url: skyward.global.virtualDir + "YearEnd/StudentYearEnd/TargetSchoolYearChange?renderType=contentOnly",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    targetschoolyearid: skyward.controls.getValue($(this))
                },
                success: function (data)
                {
                    processSummaryContainerTarget.html(data);
                }
            });
        };

        skyward.yearend.yearEndMassRunUtilityCheckBoxClick = function (event)
        {
            CheckDependents($(event.target), false)
        };

        skyward.yearend.yearEndMassRunUtilityCheckBoxHover = function (event)
        {
            HoverDependents(event, $(event.target), false)
        };

        HoverDependents = function (event, parentElement)
        {
            var dependentsArray = parentElement.data("dependents").split(',');

            parentElement.closest("div").find(".checkbox:not([id^='ProcessesCheckboxGroup'][id$='_selectAll']):not(#" + parentElement.prop("id") + ")").each(function (index, element)
            {
                var otherDependentsArray = $(element).data("dependents").split(',');

                for (var i = 0; i < otherDependentsArray.length; i++)
                {
                    if (otherDependentsArray[i] != "" && otherDependentsArray[i] != null && $.inArray(otherDependentsArray[i], dependentsArray) != -1
                        && otherDependentsArray[i] != $(element).attr("id") && $(element).prop("checked"))
                    {
                        dependentsArray = $.grep(dependentsArray, function (value)
                        {
                            return value != otherDependentsArray[i];
                        });
                    }
                }
            });

            var selectAll = parentElement.closest("div").find("[id^='ProcessesCheckboxGroup'][id$='_selectAll']");
            for (var i = 0; i < dependentsArray.length; i++)
            {
                if (dependentsArray[i] != "" && dependentsArray[i] != null && dependentsArray[i] != parentElement.prop("id"))
                {
                    checkbox = $("#" + dependentsArray[i]);
                    var $overlay = $("<div class='massRunYearEndCheckboxOverlay'>")
                    $overlay.css({
                        height: checkbox.outerHeight(true),
                    })
                    if (!checkbox.parent().find('.massRunYearEndCheckboxOverlay').length)
                    {
                        checkbox.closest('td').css({position: "relative"})
                        checkbox.css({ position: "relative" })
                        checkbox.parent().prepend($("#YearEndDependencyIcon").clone()); // order matters for css rule, overlay must be before / prepended after 
                        checkbox.parent().prepend($overlay);
                    }
                    checkbox.parent().find('.massRunYearEndCheckboxOverlay').toggleClass("yearEndDependencyHovering", event.type === "mouseover" && checkbox.is(':not(:checked)'));
                    if (checkbox.closest('div').find("[id^='ProcessesCheckboxGroup'][id$='_selectAll']").get(0) === selectAll.get(0))
                    {
                        HoverDependents(event, checkbox);
                    }
                }
            }
        }

        CheckDependents = function (parentElement, uncheckDependents)
        {
            var dependentsArray = parentElement.data("dependents").split(',');

            parentElement.closest('div').find(".checkbox:not([id^='ProcessesCheckboxGroup'][id$='_selectAll']):not(#" + parentElement.prop("id") + ")").each(function (index, element)
            {
                var otherDependentsArray = $(element).data("dependents").split(',');

                for (var i = 0; i < otherDependentsArray.length; i++)
                {
                    //ignore black dependents, dependents not in the original dependent list, and self dependencies.
                    if (otherDependentsArray[i] != "" && otherDependentsArray[i] != null && $.inArray(otherDependentsArray[i], dependentsArray) != -1
                        && otherDependentsArray[i] != $(element).attr("id"))
                    {
                        if ($(element).prop("checked") /*&& !$(element).attr("disabled")*/)
                        {
                            dependentsArray = $.grep(dependentsArray, function (value)
                            {
                                return value != otherDependentsArray[i];
                            });
                        }
                    }
                }
            });

            var selectAll = parentElement.closest('div').find("[id^='ProcessesCheckboxGroup'][id$='_selectAll']");
            for (var i = 0; i < dependentsArray.length; i++)
            {
                if (dependentsArray[i] != "" && dependentsArray[i] != null && dependentsArray[i] != parentElement.prop("id"))
                {
                    if (parentElement.prop("checked"))
                    {
                        skyward.controls.toggle($("#" + dependentsArray[i]), false);
                        $("#" + dependentsArray[i]).prop("checked", true);
                        $("#" + dependentsArray[i]).trigger("change");
                    }
                    else
                    {
                        skyward.controls.toggle($("#" + dependentsArray[i]), true);
                        if (uncheckDependents && $("#" + dependentsArray[i]).closest('div').find("[id^='ProcessesCheckboxGroup'][id$='_selectAll']").get(0) === selectAll.get(0))
                        {
                            $("#" + dependentsArray[i]).prop("checked", false);
                            CheckDependents($("#" + dependentsArray[i]), true);
                        }
                    }
                }
            }

            var uncheckedExist = false;
            var checkedExist = false;
            parentElement.closest('div').find(".checkbox:not([id^='ProcessesCheckboxGroup'][id$='_selectAll'])").each(function (index, element)
            {
                if (!$(element).prop("checked"))
                {
                    uncheckedExist = true;
                }
                else
                {
                    checkedExist = true;
                }
            });

            if (uncheckedExist && !checkedExist)
            {
                selectAll.prop("checked", false);
                selectAll.prop("indeterminate", false);
            }
            else if (!uncheckedExist && checkedExist)
            {
                selectAll.prop("checked", true);
                selectAll.prop("indeterminate", false);
            }

            if (uncheckedExist && checkedExist)
            {
                selectAll.prop("checked", true);
                selectAll.prop("indeterminate", true);
            }
        }

        skyward.yearend.yearEndmassRunSelectAll = function (event)
        {
            $(event.target).prop("indeterminate", false);
            var dependentsArray = $(event.target).data("dependents").dependents;
            var isChecked = $(event.target).prop("checked");
            for (var i = 0; i < dependentsArray.length; i++)
            {
                var dependentID = dependentsArray[i].Id;
                if (dependentID != "" && dependentID != null && !$("#" + dependentID).attr("aria-readonly"))
                {
                    if (isChecked)
                    {
                        $("#" + dependentID).prop("checked", true);
                        $("#" + dependentID).trigger("change");
                    }
                    else                
                    {
                        $("#" + dependentID).prop("checked", false);
                        CheckDependents($("#" + dependentID), true);
                        skyward.controls.toggle($("#" + dependentID), true);
                    }
                }
            }
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
/// <reference path="skyward.ui.fieldWrapper.ts"/>
/// <reference path="skyward.ui.modallayer.js"/>

(
    function (skyward, $, undefined)
    {
        "use strict";

        let blankValues = [undefined, null, ""];

        var init = function (selector)
        {
            $(selector).find(".promptTemplateSelector").each(function () { promptTemplateSelector().init($(this)); });
        };

        const promptElementsSelector = '.filterValue, .filterProcessingListValue, .CrystalReportParameterInput';

        function promptTemplateSelector()
        {
            let promptTemplateContainer;
            let promptElements;

            let reportId;
            let runUnpublishedVersion;
            let urlBase;

            let promptTemplateDetailsPopup;

            let codeEEL;

            let undoButton;
            let saveEditableFields;
            let saveButton;
            let saveAsNewButton;
            let allButtons;

            function init(promptTemplateSelector)
            {
                promptTemplateContainer = promptTemplateSelector.closest(".workflowContent");
                findAllPromptElements();

                const selectorData = promptTemplateSelector.data();
                urlBase = skyward.global.virtualDir + selectorData.area + '/' + selectorData.controller + '/';
                reportId = selectorData.reportId;
                runUnpublishedVersion = selectorData.runUnpublishedVersion;

                promptTemplateDetailsPopup = promptTemplateContainer.find('template.promptTemplateDetailsPopup');

                codeEEL = promptTemplateSelector.find(".promptTemplateCodeEEL.codeEELValue");
                codeEEL.on("change", loadPromptTemplate);

                undoButton = promptTemplateSelector.find(".promptTemplateUndoButton");
                undoButton.on("click", loadPromptTemplate);

                saveEditableFields = buildEditableFieldsHashDictionary(promptTemplateContainer.find(".SavePromptTemplateSecuredFields"));
                saveButton = promptTemplateSelector.find(".promptTemplateSaveButton");
                saveButton.on('click', save);

                saveAsNewButton = promptTemplateSelector.find(".promptTemplateSaveAsNewButton");
                saveAsNewButton.on('click', saveAsNew);

                allButtons = $(saveAsNewButton).add(saveButton).add(undoButton);

                promptTemplateContainer.on('change dirty update', promptElementsSelector, updateDirtyStatus);

                updateDirtyStatus();
            }

            function findAllPromptElements()
            {
                promptElements = promptTemplateContainer.find(promptElementsSelector);
            }

            // Functions
            function loadPromptTemplate(e)
            {
                if (codeEEL.val() !== "")
                {
                    skyward.workflow.customButtonAction("loadPromptTemplate");
                }
            }

            function buildEditableFieldsHashDictionary(el)
            {
                let editableFields = {};
                if (el.val())
                {
                    editableFields[el.data('hash')] = el.val();
                }
                return editableFields;
            }

            function save()
            {
                if (codeEEL.val())
                {
                    $.ajax({
                        url: urlBase + "UpdateValues",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            id: codeEEL.val(),
                            warninghash: "",
                            editableFields: saveEditableFields,
                            promptValuesJson: JSON.stringify(getPromptBoundValuesDictionary()),
                            reportId: reportId,
                            runUnpublishedVersion: runUnpublishedVersion
                        },
                        success: function (data)
                        {
                            if (data.success)
                            {
                                loadPromptTemplate();
                            }
                            else
                            {
                                skyward.validation.displayValidationMessages({ errors: data.errors }, promptTemplateContainer, $());
                            }
                        }
                    });
                }
            }

            function saveAsNew()
            {
                let dialog;
                let buttons = [{ text: "Save", icon: "Save", click: function () { doSaveAsNew().then(dialog.close); } }, { text: "Cancel", icon: "Cancel" }];
                dialog = skyward.modalLayer.showDialog("New Prompt Template", saveAsNewPromptTemplateDialog(), buttons, { anchorTo: saveAsNewButton, closeOnClick: false });

                let nameInput;
                let descriptionInput;

                dialog.bodyPromise.then(function ()
                {
                    nameInput = dialog.content.find(".saveAsNewPromptName");
                    descriptionInput = dialog.content.find(".saveAsNewPromptDescription");

                    descriptionInput.on('focus', function copyNameToDescription()
                    {
                        const description = descriptionInput.val();
                        if (description === null || description === "")
                        {
                            skyward.controls.setValue(descriptionInput, nameInput.val());
                        }
                    });

                    nameInput.focus();
                });

                function doSaveAsNew()
                {
                    const deferred = $.Deferred();

                    const name = skyward.controls.getValue(nameInput);
                    const description = skyward.controls.getValue(descriptionInput);

                    $.ajax({
                        url: urlBase + "SaveAsNew",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            warninghash: "",
                            reportId: reportId,
                            id: null,
                            name: name,
                            description: description,
                            promptValuesJson: JSON.stringify(getPromptBoundValuesDictionary()),
                            runUnpublishedVersion: runUnpublishedVersion
                        },
                        success: function (data)
                        {
                            const container = dialog.content;
                            const baseErrorContainer = container.find(".js-promptTemplateErrorMessageContainer");
                            skyward.validation.clearValidationMessages(container, baseErrorContainer);

                            if (data.success)
                            {
                                codeEEL.val(data.id);
                                loadPromptTemplate();
                                deferred.resolve();
                            }
                            else
                            {
                                skyward.validation.displayValidationMessages({ errors: data.errors }, container, baseErrorContainer);
                                deferred.reject();
                            }
                        },
                        error: deferred.reject
                    });

                    return deferred;
                }
            }

            function saveAsNewPromptTemplateDialog()
            {
                const temporaryContainer = $('<div/>', { class: "js-fieldset" }).css({ display: "hidden", position: "absolute", bottom: "0px" }).appendTo(document.body);

                const content = $(promptTemplateDetailsPopup.html());
                content.appendTo(temporaryContainer);

                skyward.fieldWrapper.alignTitles(temporaryContainer);

                content.detach();

                temporaryContainer.remove();

                return content;
            }

            function updateDirtyStatus()
            {
                findAllPromptElements();
                allButtons.hide();

                const isDirty = skyward.changeTracking.isDirty(promptTemplateContainer) || promptElements.add(".CrystalReportParameterFS .multiSelectBackingData").is("[data-dirty='true']");
                const isNotBlank = atLeastOnePromptIsFilledIn();
                if (isDirty && codeEEL.val())
                {
                    if (isNotBlank)
                    {
                        saveButton.show();
                    }
                    undoButton.show();
                }

                if (isNotBlank)
                {
                    saveAsNewButton.show();
                }
            }

            function atLeastOnePromptIsFilledIn()
            {
                var typeSpecificTests =
                {
                    isBlankDuration: function (promptElement, promptElementData, value)
                    {
                        return promptElement.is(".durationpicker") && (promptElement[0].defaultValue === "0:00:00" && promptElement.val() === "0:00:00");
                    },
                    isUnchangedSortOrder: function (promptElement, promptElementData, value)
                    {
                        return promptElement.hasClass("listSortOrder") && promptElement.attr("data-original-value") === promptElement.val();
                    },
                    isBlankBoolean: function (promptElement, promptElementData, value)
                    {
                        return promptElementData.fieldType === "Boolean" && Array.isArray(value) && value[0] === promptElementData.originalValue;
                    }
                };

                let foundValue = false;
                $.each(promptElements, function ()
                {
                    const promptElement = $(this);
                    const promptElementData = promptElement.data();
                    const value = getPromptValue(promptElement);

                    if (value !== null)
                    {
                        // Confirm this value isn't actually a blank value that's just encoded in a weird way.
                        let valueIsActuallyBlankValue = false;
                        $.each(typeSpecificTests, function (testName, test)
                        {
                            if (test(promptElement, promptElementData, value))
                            {
                                valueIsActuallyBlankValue = true;
                                return false; // break $.each
                            }
                        });

                        if (!valueIsActuallyBlankValue)
                        {
                            foundValue = true;
                            return false; // break $.each
                        }
                    }
                });
                return foundValue;
            }

            function getPromptBoundValuesDictionary()
            {
                findAllPromptElements();
                const promptBoundValues = {};
                $.each(promptElements, function ()
                {
                    const jqThis = $(this);
                    const key = jqThis.data("promptUniqueId");
                    const value = getPromptValue(jqThis);
                    if (value !== null)
                    {
                        promptBoundValues[key] = value;
                    }
                });
                return promptBoundValues;
            }

            function getPromptValue(prompt)
            {
                let value = skyward.controls.getValue(prompt);

                // Crystal multiselects return an Array
                if (value instanceof Array)
                {
                    if (value.find(function (v) { return !blankValues.includes(v); }) === undefined)
                    {
                        return null;
                    }

                    return value;
                }

                if (value instanceof Date)
                {
                    if (!skyward.time.isDate(value))
                    {
                        return null;
                    }
                    value = skyward.time.formatServerDate(value);
                }

                if (value instanceof Object)
                {
                    return Object.entries(value);
                }
                else if (!blankValues.includes(value))
                {
                    // Values that are returned as simple values
                    return [[value, value]];
                }

                return null;
            }

            return { init: init };
        }

        skyward.window.registerLoadDOMCallback(init);
    })(skyward || {}, window.jQuery);

;
/// <reference path="skyward.base.js"/>
/// <reference path="skyward.ui.controls.ts"/>
skyward.base.registerScript('specialeducationmi', function (skyward, $)
{
    "use strict";

    function initEarlyChildhoodAssessment(context)
    {
        var register = function (prefix)
        {
            var showHideOtherToolComments = function ()
            {
                var fieldset = $(prefix + 'OtherToolComment');

                if ($(prefix + 'DescriptorCodeIDAssessmentTool_code').val() === '18')
                {
                    skyward.controls.show(fieldset.closest('.fieldWrapper'));
                }
                else
                {
                    skyward.controls.hide(fieldset.closest('.fieldWrapper'));
                    skyward.controls.clearValue(fieldset);
                }
            };

            showHideOtherToolComments();
            $(prefix + 'DescriptorCodeIDAssessmentTool').on('eelComplete', showHideOtherToolComments);
        }

        register('#EarlyChildhoodAssessmentMI');
        register('#editEarlyChildhoodAssessmentMI_');
    }

    function initEvaluation(context)
    {
        var register = function (prefix)
        {
            var exitDateFieldSet = $(prefix + 'ExitDate');
            var updateEndDate = function ()
            {
                var endDateFieldSet = $(prefix + 'EndDate');
                var exitDateValue = skyward.controls.getValue(exitDateFieldSet);
                skyward.controls.setValue(endDateFieldSet, exitDateValue);
            };

            exitDateFieldSet.on('change', updateEndDate);
        };

        register('#EvaluationMI');
        register('#editEvaluationMI_');
    }

    function initTotalInstructionalMinutes(context)
    {
        var totalInstructionalMinutes = function ()
        {
            var instructionalHoursValue = $('.js-InstructionalHours').val();
            var instructionalMinutesValue = $('.js-InstructionalMinutes').val();

            skyward.controls.setValue('.js-InstructionalTotal', (instructionalHoursValue ? instructionalHoursValue : 0) * 60 + parseInt(instructionalMinutesValue ? instructionalMinutesValue : 0));
        };

        $('.js-InstructionalHours').on('change', totalInstructionalMinutes);
        $('.js-InstructionalMinutes').on('change', totalInstructionalMinutes);
    }

    function initServiceTimeCalculation(context)
    {
        var directTimeCalculation = function ()
        {
            //scope to the containing div to handle multiple instances of the field group on one screen
            var directTimeHours = $(this).parent().find('.js-directHours').val();
            var directTimeMinutes = $(this).parent().find('.js-directMinutes').val();

            skyward.controls.setValue($(this).parent().find('.js-directTotal'), (directTimeHours ? directTimeHours : 0) * 60 + parseInt(directTimeMinutes ? directTimeMinutes : 0));
        };

        var indirectTimeCalculation = function ()
        {
            var indirectTimeHours = $(this).parent().find('.js-indirectHours').val();
            var indirectTimeMinutes = $(this).parent().find('.js-indirectMinutes').val();

            skyward.controls.setValue($(this).parent().find('.js-indirectTotal'), (indirectTimeHours ? indirectTimeHours : 0) * 60 + parseInt(indirectTimeMinutes ? indirectTimeMinutes : 0));
        };

        $('.js-directHours').on('change', directTimeCalculation);
        $('.js-directMinutes').on('change', directTimeCalculation);
        $('.js-indirectHours').on('change', indirectTimeCalculation);
        $('.js-indirectMinutes').on('change', indirectTimeCalculation);
    }

    var events =
    {
        "initEarlyChildhoodAssessment": initEarlyChildhoodAssessment,
        "initEvaluation": initEvaluation,
        "initTotalInstructionalMinutes": initTotalInstructionalMinutes,
        "initServiceTimeCalculation": initServiceTimeCalculation,
    };

    return events;
});
//# sourceURL=skyward.ui.specialeducationmi.js;
/// <reference path='skyward.ui.controls.js'/>
(
    function(skyward, $, undefined)
    {
        "use strict";
        skyward.specialeducationwi = skyward.specialeducationwi || {};

        var init = function (selector)
        {
            var endDate = $(selector).find(".IEPServiceWIEndDate");
            var exitReasonCodeEELFieldSet = $(selector).find(".SpecialEducationWIStateExitSpecialEducationReason");

            if (endDate.length < 1)
            {
                return;
            }

            var endDateOnChange = function ()
            {
                skyward.specialeducationwi.endDateOnChange(endDate, exitReasonCodeEELFieldSet);
            };

            skyward.specialeducationwi.endDateOnChange(endDate, exitReasonCodeEELFieldSet);
            endDate.on("change", endDateOnChange);
        };

        skyward.specialeducationwi.endDateOnChange = function (endDate, exitReasonCodeEELFieldSet)
        {
            const endDateValue = skyward.controls.getValue(endDate);
            if (endDateValue && endDateValue.isValidDate())
            {
                exitReasonCodeEELFieldSet.show();
            }
            else
            {
                var screenSelector = $("#IEPServiceWIStateExitSpecialEducationReasonWIID_description").length > 0 ? '#IEPServiceWI' : '#editIEPServiceWI_';
                var exitReasonCodeEELCodeValue = $(screenSelector + 'StateExitSpecialEducationReasonWIID_code');
                var exitReasonCodeEELDescriptionValue = $(screenSelector + 'StateExitSpecialEducationReasonWIID_description');
                var exitReasonID = $(screenSelector + 'StateExitSpecialEducationReasonWIID_value');

                exitReasonCodeEELFieldSet.hide();
                skyward.controls.setValue(exitReasonCodeEELCodeValue, "");
                skyward.controls.setValue(exitReasonCodeEELDescriptionValue, "");
                skyward.controls.setValue(exitReasonID, "");
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $)
    {
        skyward.warehouserequestapprovalmessage = skyward.warehouserequestapprovalmessage || {};

        skyward.warehouserequestapprovalmessage.resetawaitingapprovalmessagetemplate = function ()
        {
            var subject = $('#editWarehouseRequestApprovalMessages_WarehouseRequestWaitingMessageSubject');
            var content = $('#editWarehouseRequestApprovalMessages_WarehouseRequestWaitingMessageContent');
            var defaultSubject = 'Warehouse Request {TaskInstance.ApprovalTaskPresenter.WarehouseRequest.WarehouseRequestNumber} Is Awaiting Your Approval';
            var defaultContent = '{User.Name.FirstName},\n\nWarehouse Request {TaskInstance.ApprovalTaskPresenter.WarehouseRequest.WarehouseRequestNumber} for {TaskInstance.ApprovalTaskPresenter.WarehouseRequest.NameRequestedFor.FullNameFML} is awaiting your approval.';

            skyward.controls.setValue(subject, defaultSubject, false);
            skyward.controls.setValue(content, defaultContent, false);
        }

        skyward.warehouserequestapprovalmessage.resetapprovedmessagetemplate = function ()
        {
            var subject = $('#editWarehouseRequestApprovalMessages_WarehouseRequestApprovedMessageSubject');
            var content = $('#editWarehouseRequestApprovalMessages_WarehouseRequestApprovedMessageContent');
            var defaultSubject = 'Warehouse Request {WarehouseRequest.WarehouseRequestNumber} Has Been Approved';
            var defaultContent = '{WarehouseRequest.UserCreatedBy.Name.FirstName},\n\nWarehouse Request {WarehouseRequest.WarehouseRequestNumber} has been approved at Level {LevelDescription} by {UserApprover.Name.FullNameFML}.';

            skyward.controls.setValue(subject, defaultSubject, false);
            skyward.controls.setValue(content, defaultContent, false);
        }

        skyward.warehouserequestapprovalmessage.resetdeniedmessagetemplate = function ()
        {
            var subject = $('#editWarehouseRequestApprovalMessages_WarehouseRequestDeniedMessageSubject');
            var content = $('#editWarehouseRequestApprovalMessages_WarehouseRequestDeniedMessageContent');
            var defaultSubject = 'Warehouse Request {WarehouseRequest.WarehouseRequestNumber} Has Been Denied';
            var defaultContent = '{WarehouseRequest.UserCreatedBy.Name.FirstName},\n\nWarehouse Request {WarehouseRequest.WarehouseRequestNumber} has been denied at Level {LevelDescription} by {UserApprover.Name.FullNameFML}.\n\nDenial Reason: {Comment}';

            skyward.controls.setValue(subject, defaultSubject, false);
            skyward.controls.setValue(content, defaultContent, false);
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.treebrowse.js" />
(
    function (skyward, $, undefined) {
        var minimumContent = 50;
        var maxContentHeight = 125;
        var maxContentHeightPX = maxContentHeight + 'px';
        var insertColumnDiv = [];
        var treeGridDiv = [];
        var maxWindowHeight = $(window).height() * .8;

        skyward.authenticationmethod = skyward.authenticationmethod || {};

        var defaultSettings =
            {
                title: "Insert Field",
                onFieldSelect: function () { },
                onCancel: function () { }
            };

        var init = function (selector) { };

        skyward.authenticationmethod.popInsertNameIdentifierSkywardField = function (button) {
            var container = $(button).parents(".authenticationMethodWrapper");
            var dataModule = "Security";
            var dataObject = "User";
            var clickedElement = $(this);

            var options =
                {
                    anchorTo: clickedElement,
                    beforeClose: preCloseInsertColumnMenu,
                    onFieldSelect: function (field) { insertField(container, field); }
                };

            skyward.authenticationmethod.openSelectFieldDialog(dataModule, dataObject, options);
        };

        var preCloseInsertColumnMenu = function () {
            insertColumnDiv = [];
            treeGridDiv = [];
        };

        var insertField = function (container, field) {
            var controlToUpdate = container.find(".NameIdentifierSkywardField");
            document.getElementById("NameIdentifierSkywardFieldFriendlyName").value = "";
            skyward.global.text.insertTextToken(controlToUpdate, field, true);
        };

        skyward.authenticationmethod.openSelectFieldDialog = function (module, object, options) {
            var settings = $.extend({}, defaultSettings, options);
            var selectFieldDialog;

            var onSaveClick = function () {
                var field = getFieldFromTree(selectFieldDialog, settings);
                selectFieldDialog.close();
                settings.onFieldSelect(field);
            };
            var onCancelClick = function () {
                selectFieldDialog.close();
                settings.onCancel();
            };

            var saveButton = { text: "Save", "click": onSaveClick, "icon": "Save" };
            var cancelButton = { text: "Cancel", "click": onCancelClick, "icon": "Cancel" };

            selectFieldDialog = skyward.modalLayer.showDialog(settings.title, function () { return buildTreePopup(module, object, settings); }, [saveButton, cancelButton], settings);
            selectFieldDialog.content.on("treeBrowseSave", onSaveClick);
        };

        var buildTreePopup = function (module, object, options) {
            return $.ajax({
                url: skyward.global.virtualDir + "Security/User/BuildTreeBrowseForAuthMethodAdd/",
                type: "POST",
                dataType: "viewparthtml",
                data:
                    {
                        module: module,
                        object: object
                    }
            });
        };

        var getFieldFromTree = function (modalLayer, options) {
            var fieldData = skyward.treebrowse.getSelectedFieldData(modalLayer.content);

            if (!fieldData || !fieldData.fieldName || !fieldData.fieldType || fieldData.fieldType.toString() === "ManyToOne") {
                return "";
            }

            var fieldPath = fieldData.fieldName;
            if (fieldPath.startsWith("User.")) {
                fieldPath = fieldPath.slice(5);
            }

            return fieldPath;

        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
$(function ()
{
    "use strict";
    // The native dropdown control on MacOS doesn't support padding, and so browsers on that platform, including Safari
    // and Chrome, don't respect padding styles.  Work around this by setting margins to include what the padding should be,
    // in order to preserve alignment.
    // This should be kept in sync with FormPartial.cs.
    var select = $("<select>", { "css": { paddingTop: "100px", display: "none" } });
    select.appendTo(document.body);
    if (parseInt(select.css("paddingTop")) !== 100)
    {
        var rule =
            "select" +
            "{" +
                "margin-top: 7px;" +
                "margin-bottom: 7px;" +
            "}";
        $("<style>", { text: rule }).appendTo(document.head);
    }
});;
(
    function (skyward, $, undefined)
    {
        skyward.studentguardian = skyward.studentguardian || {};

        skyward.studentguardian.addNameAddress = function ()
        {
            var nameID = $("#NameIDHidden").val();
            var nameIDForReference = $("#NameIDForReferenceHidden").val();
            var addressID = $("#AddressIDHidden").val();
            var districtID = $("#DistrictIDHidden").val();
            var schoolYearID = $("#SchoolYearIDHidden").val();
            var entityID = $("#EntityIDHidden").val();
            var displayAddressRangeDefaultsWarning = true;

            $.ajax({
                url: skyward.global.virtualDir + "Family/StudentGuardian/RetreiveDataForAddMeetAddress",
                type: "POST",
                dataType: "json",
                data:
                {
                    addressID: addressID,
                    nameID: nameID,
                    nameIDForReference: nameIDForReference,
                    districtID: districtID,
                    schoolyearid: schoolYearID,
                    entityid: entityID,
                    displayAddressRangeDefaultsWarning: displayAddressRangeDefaultsWarning
                },
                success: function (data)
                {
                    var workflowData =
                    {
                        "Workflow.AddressID": data["AddressID"],
                        "Workflow.AddressID_SecurityHash": data["AddressIDSecurityHash"],
                        "Workflow.NameID": data["NameID"],
                        "Workflow.NameID_SecurityHash": data["NameIDSecurityHash"],
                        "Workflow.NameIDForReference": data["NameIDForReference"],
                        "Workflow.NameIDForReference_SecurityHash": data["NameIDForReferenceSecurityHash"],
                        "Workflow.DistrictID": data["DistrictID"],
                        "Workflow.DistrictID_SecurityHash": data["DistrictIDSecurityHash"],
                        "Workflow.SchoolYearID": data["SchoolYearID"],
                        "Workflow.SchoolYearID_SecurityHash": data["SchoolYearIDSecurityHash"],
                        "Workflow.EntityID": data["EntityID"],
                        "Workflow.EntityID_SecurityHash": data["EntityIDSecurityHash"],
                        "Workflow.DisplayAddressRangeDefaultsWarning": data["DisplayAddressRangeDefaultsWarning"],
                        "Workflow.DisplayAddressRangeDefaultsWarning_SecurityHash": data["DisplayAddressRangeDefaultsWarningSecurityHash"]
                    };

                    skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Demographics/NameAddress/Add", null, workflowData, null, skyward.studentguardian.refreshAddressQuickEntry);
                }
            });
        };

        skyward.studentguardian.refreshAddressQuickEntry = function()
        {
            return $.ajax({
                url: skyward.global.virtualDir + "Family/StudentGuardian/GetAddressChildRecordQuickEntry/",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    displayaddressnameID: $("#NameIDHidden").val()
                },
                success: function (data)
                {
                    $("#AddressViewQuickEntryBorder").html(data);
                    //Controller setting all checkboxes to disabled, this fixes that
                    $("#AddressViewQuickEntryBorder").find("input").each(function (index, element)
                    {
                        $(element).prop('disabled', $(element).prop("checked"));
                    });
                }
            });
        };

        // Event handlers
        var events =
        {
            "addNameAddress": skyward.studentguardian.addNameAddress
        };
        skyward.events.registerEvents("studentguardian", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        skyward.studentapplication = skyward.studentapplication || {};
        "use strict";

        var init = function (selector)
        {
            $(selector + ' .studentapplicationtablerow').each(function ()
            {
                var stepRow = $(this);

                if (!stepRow.length)
                {
                    return;
                }

                var currentValues = stepRow.find('.studentApplicationCurrentValue');
                var updatedValues = stepRow.find('.studentApplicationUpdatedValue');
                if (currentValues.length && updatedValues.length)
                {
                    updatedValues.each(function (index)
                    {
                        var updatedValue = $(this);
                        var currentValue = currentValues.eq(index);
                        if (currentValue.length)
                        {
                            var updatedValueHeight = updatedValue.height();
                            var currentValueHeight = currentValue.height();
                            if (updatedValueHeight < currentValueHeight)
                            {
                                updatedValue.css('min-height', currentValueHeight);
                                updatedValue.css('top', currentValue.top());
                            }
                            else if (updatedValueHeight > currentValueHeight)
                            {
                                currentValue.css('min-height', updatedValueHeight);
                                currentValue.css('top', updatedValue.top());
                            }
                        }
                    });
                }
            });
        }

        skyward.studentapplication.approveStudentApplicationClick = function (approveFormButton)
        {
            approveFormButton = approveFormButton instanceof $ ? approveFormButton : $(approveFormButton);

            if (approveFormButton.hasClass('ui-disabled'))
            {
                return false;
            }

            var container = approveFormButton.parents('.contentArea');
            var dovSaveButton = container.find('.button.save');
            var dovCancelButton = container.find('.button.cancel');
            var saveCompleteCallback = function (e)
            {
                container.off('DOVSaveComplete DOVSaveValidationError', saveCompleteCallback);
                // Only run the approval process if it was the SaveComplete event that triggered the callback
                if (e.type === 'DOVSaveComplete')
                {
                    skyward.window.loadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Enrollment/StudentApplication/Approve', null,
                    {
                        'Workflow.StudentApplicationID': $('#editStudentApplication_StudentApplicationStudentApplicationID').val(),
                        'Workflow.StudentApplicationID_securityhash': approveFormButton.data('studentapplicationid-securityhash')
                    });
                }
            };

            // Always save the screen
            dovSaveButton.addClass('dirty'); // Need to make DOV think we're dirty so it actually saves
            dovCancelButton.addClass('dirty'); // For consistency, dirty Cancel so it shows too
            saveStudentApplication(dovSaveButton, { "IsApproval": true });
            container.on('DOVSaveComplete DOVSaveValidationError', saveCompleteCallback);
        };

        var saveStudentApplication = function (button, postData)
        {
            var data = button.data();
            data.dataObjectViewerContainerId = 'editStudentApplication';
            data.id = $('#editStudentApplication_StudentApplicationStudentApplicationID').val();
            data.module = "Enrollment";
            data.object = 'StudentApplication';
            data.screen = "Details";
            data.tab = "General";
            data.saveAction = 'StudentApplicationSave';
            completeSaveStudentApplication(postData, button, data, saveStudentApplication);
        };

        var completeSaveStudentApplication = function (postData, button, data, clickFunc)
        {
            button.off('click.save');
            $.when(skyward.dataobjectviewer.save(data.dataObjectViewerContainerId, data.module, data.object, data.screen, data.id, null, data.saveAction, false, data.tab, false, false, postData)).done(function ()
            {
                button.on('click.save', function () { clickFunc(button, postData); });
            });
        };

        // Event handlers
        var events =
        {
            "approveStudentApplicationClick": skyward.studentapplication.approveStudentApplicationClick
        };
        skyward.events.registerEvents("studentapplication", events);
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.controls.js" />
/// <reference path="skyward.ui.modallayer.js" />
(
    function (skyward, $, undefined)
    {
        skyward.mtss = skyward.mtss || {};

        var filterData =
        {
            CheckpointDate: null,
            SelectedStudents: null,
            SelectedStrategies: null,
            ShowAllRecords: false,
            Portal: ""
        };
        var dmseIsOpen = false;

        var init = function (selector)
        {
            // Stop init if not on the quick entry.
            if ($(selector).find('.checkpointDateSelector').length == 0 && $(selector).find('.ruleTypeSelector').length == 0)
            {
                return;
            }

            // Initialize Date selector trigger
            if ($(selector).find('.checkpointDateSelector').length > 0)
            {
                var element = $(selector).find(".checkpointDateSelector");
                filterData.CheckpointDate = element[0].value.split(' ')[0];
                element.on('change', skyward.mtss.filterDate);
            }

            // Initialize Set All Combo box trigger
            if ($(selector).find('.setAllCheckpointComboBox').length > 0)
            {
                var element = $(selector).find(".setAllCheckpointComboBox");
                element.on('change', skyward.mtss.updateAllComboBoxes);
            }

            // Intitialize Student DMSE trigger
            if ($(selector).find('.checkpointStudentSelector').length > 0)
            {
                var element = $(selector).find('.checkpointStudentSelector');
                filterData.SelectedStudents = element.find(".dmsBackingData").val();
                element.on('change', skyward.mtss.filterStudents);
            }

            // Intitialize Strategy DMSE trigger
            if ($(selector).find('.checkpointStrategySelector').length > 0)
            {
                var element = $(selector).find(".checkpointStrategySelector");
                filterData.SelectedStrategies = element.find(".dmsBackingData").val();
                element.on('change', skyward.mtss.filterStrategies);
            }

            // Intitialize Show All trigger
            if ($(selector).find('.showAllRecords').length > 0)
            {
                var element = $(selector).find(".showAllRecords");
                filterData.ShowAllRecords = element.is(':checked');
                element.on('change', skyward.mtss.filterShowAll);
            }
            if ($(selector).find("#editInterventionPlanMeeting").length > 0) 
            {
                var data = $(selector).find("#editInterventionPlanMeeting").data();
                filterData.Portal = data.portal;
            }
        };

        skyward.mtss.updateAllComboBoxes = function ()
        {
            var comboxBoxAll = $(this);
            var value = comboxBoxAll.val();                                       
            $('[id$="-RecordCode"]').each(function ()
            {
                var checkbox = $(this);
                checkbox.val(value);
                checkbox.change();
            });
        };

        skyward.mtss.filterDate = function ()
        {
            var datePicker = $(this);
            filterData.CheckpointDate = datePicker[0].value.split(' ')[0];
            filterData.SelectedStrategies = null;
            filterData.SelectedStudents = null;

            updateContent();
        };

        skyward.mtss.filterShowAll = function ()
        {
            var checkbox = $(this);
            filterData.ShowAllRecords = checkbox.is(':checked');
            if (!filterData.ShowAllRecords)
            {
                filterData.SelectedStrategies = null;
                filterData.SelectedStudents = null;
            }
            updateContent();
        };

        skyward.mtss.filterStudents = function ()
        {
            var dsme = $(this).find(".dmsBackingData");
            filterData.SelectedStudents = dsme.val();
            updateContent();
        };

        skyward.mtss.filterStrategies = function ()
        {
            var dsme = $(this).find(".dmsBackingData");
            filterData.SelectedStrategies = dsme.val();         
            updateContent();
        };

        skyward.mtss.loadUserChartSettings = function ()
        {
            var buildPopup = function ()
            {
                var button = $('#btnInterventionPlanStrategyUserSettings');
                var accessMode = "";
                if ($("#accessmode").length > 0)
                {
                    accessMode = $("#accessmode").val();
                } 
                var action = "GetUserChartSettings" + accessMode;
                var data = button.data();
                var popupData =
                {
                    interventionplanstrategyid: data.interventionplanstrategyid,
                    interventionplanid: data.interventionplanid,
                    interventionplanstrategyidhash: data.interventionplanstrategyidhash,
                    interventionplanidhash: data.interventionplanidhash
                };

                return $.ajax({
                    url: skyward.global.virtualDir + "MTSS/InterventionPlanStrategyUserSetting/" + action,
                    activityIndicator: { silent: true },
                    type: "POST",
                    dataType: "viewparthtml",
                    data: popupData
                });
            };

            var options =
            {
                draggable: true,
                width: '940px'
            };

            var saveSettingsButton = { id: "saveSettings", text: "Save", click: function () { studentInterventionPlanUserSettingSave(dialog) }, icon: "Save" };
            var cancelButton = { id: "cancelButton", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
            var dialog = skyward.modalLayer.showDialog("Settings", buildPopup, [saveSettingsButton, cancelButton], options);
        };

        var studentInterventionPlanUserSettingSave = function (dialog)
        {
            var interventionPlanStrategyUserSetting = dialog.content.find("#interventionPlanStrategyUserSettingPopup");
            var interventionPlanStrategyUserSettingID = interventionPlanStrategyUserSetting.data().interventionplanstrategyusersettingid;
            var accessMode = "";
            if ($("#accessmode").length > 0)
            {
                accessMode = $("#accessmode").val();
            }            

            var chartTypeCodeValue = "";
            var headerLabelValue = "";
            var xAxisLabelValue = "";
            var yAxisLabelValue = "";
            var startDateValue = null;
            var endDateValue = null;
            var includeInNotificationsValue = null;
            var showStartingLineValue = null;
            var showTrendLineValue = null;
            var showTargetLineValue = null;
            var displayDataPointValuesOnChartValue = null;

            var chartTypeCode = dialog.content.find("#ChartTypeCode");
            var headerLabel = dialog.content.find("#HeaderLabel");
            var xAxisLabel = dialog.content.find("#XAxisLabel");
            var yAxisLabel = dialog.content.find("#YAxisLabel");
            var startDate = dialog.content.find("#StartDate");
            var endDate = dialog.content.find("#EndDate");
            var includeInNotifications = dialog.content.find("#IncludeInNotifications");
            var showTrendLine = dialog.content.find("#ShowTrendLine");
            var showStartingLine = dialog.content.find("#ShowStartingLine");
            var showTargetLine = dialog.content.find("#ShowTargetLine");
            var displayDataPointValuesOnChart = dialog.content.find("#DisplayDataPointValuesOnChart");

            if (chartTypeCode.length > 0)
            {
                chartTypeCodeValue = chartTypeCode[0].value;
            }
            if (headerLabel.length > 0)
            {
                headerLabelValue = headerLabel[0].value;
            }
            if (xAxisLabel.length > 0)
            {
                xAxisLabelValue = xAxisLabel[0].value;
            }
            if (yAxisLabel.length > 0)
            {
                yAxisLabelValue = yAxisLabel[0].value;
            }

            if (startDate.length > 0)
            {
                startDateValue = startDate[0].value;
            }
            if (endDate.length > 0)
            {
                endDateValue = endDate[0].value;
            }

            if (includeInNotifications.length > 0)
            {
                includeInNotificationsValue = includeInNotifications[0].checked;
            }

            if (showTrendLine.length > 0)
            {
                showTrendLineValue = showTrendLine[0].checked;
            }

            if (showStartingLine.length > 0)
            {
                showStartingLineValue = showStartingLine[0].checked;
            }

            if (showTargetLine.length > 0)
            {
                showTargetLineValue = showTargetLine[0].checked;
            }

            if (displayDataPointValuesOnChart.length > 0)
            {
                displayDataPointValuesOnChartValue = displayDataPointValuesOnChart[0].checked;
            }


            $.ajax({
                url: skyward.global.virtualDir + "MTSS/InterventionPlanStrategyUserSetting/StudentInterventionPlanUserSettingSave" + accessMode,
                type: "POST",
                dataType: "JSON",
                data:
                {
                    interventionPlanStrategyUserSettingID: interventionPlanStrategyUserSettingID,
                    chartTypeCode: chartTypeCodeValue,
                    headerLabel: headerLabelValue,
                    xAxisLabel: xAxisLabelValue,
                    yAxisLabel: yAxisLabelValue,
                    startDate: startDateValue,
                    endDate: endDateValue,
                    includeInNotifications: includeInNotificationsValue,
                    showTrendLine: showTrendLineValue,
                    showStartingLine: showStartingLineValue,
                    showTargetLine: showTargetLineValue,
                    displayDataPointValuesOnChart: displayDataPointValuesOnChartValue,
                },
                success: function (response)
                {
                    if (response.success == true)
                    {
                        location.reload();
                    }
                    else
                    {
                        var baseErrorContainer = dialog.container.find('#InterventionPlanStrategyUserSettingBaseErrorContainer');
                        skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                    }
                }
            });
        };

        var updateContent = function ()
        {
            var modals = skyward.modalLayer.getOpenModalLayers();
            var action = 'CheckpointQuickEntry' + filterData.Portal;
            const openLayer = modals.last().data("layer");
            if (!dmseIsOpen && openLayer)
            {
                dmseIsOpen = true;
                const origAfterClose = openLayer.options.afterClose;
                openLayer.options.afterClose = function () {
                    if (typeof origAfterClose === "function") {
                        origAfterClose();
                    }
                    dmseIsOpen = false;
                    skyward.window.loadContent("moduleContent", "MTSS", "InterventionPlanStrategy", action, null, filterData);
                };                
            }
            else if (!openLayer)
            {
                skyward.window.loadContent("moduleContent", "MTSS", "InterventionPlanStrategy", action, null, filterData);
            }
        };

        ////Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.controls.js" />
/// <reference path="skyward.ui.modallayer.js" />
(
    function (skyward, $, undefined)
    {
        skyward.thresholds = skyward.thresholds || {};

        var init = function (selector)
        {
            // Initialize Rule Type Combobox
            if ($(selector).find(".ruleTypeSelector").length > 0)
            {
                var element = $(selector).find(".ruleTypeSelector");
                element.each(handleRuleTypeChange.bind(element, selector));
                element.change(handleRuleTypeChange.bind(element, selector));
            }
            // Initialize Test Version Field Selector
            if ($(selector).find('[id*="AssessmentTestVersionFieldID-add"][id$="_value"]').length > 0)
            {
                var element = $(selector).find('[id*="AssessmentTestVersionFieldID-add"][id$="_value"]');
                element.off("change", changeAssessmentTestField).on("change", changeAssessmentTestField);
                element.trigger("change")
            }

            if ($(selector).find('[id*="editThresholdRuleGroup_AssessmentTestVersionFieldID"][id$="_value"]').length > 0)
            {
                var element = $(selector).find('[id*="editThresholdRuleGroup_AssessmentTestVersionFieldID"][id$="_value"]');
                element.off("change", changeAssessmentTestField).on("change", changeAssessmentTestField);
            }

            if ($(selector).find('[id*="TempThresholdRuleGroup-"][id*="AssessmentTestVersionFieldID-"][id$="_value"]').length > 0)
            {
                var element = $(selector).find('[id*="TempThresholdRuleGroup-"][id*="AssessmentTestVersionFieldID-"][id$="_value"]');
                element.off("change", changeAssessmentTestField).on("change", changeAssessmentTestField);
            }

            if ($(selector).find('.js-ThresholdTestVersionID').length > 0)
            {
                var element = $(selector).find('.js-ThresholdTestVersionID');
                element.change(clearAssessmentCRQE);
            }

            if ($(selector).find('.js-updateConditionValueOnOperationChange').length > 0)
            {
                var element = $(selector).find('.js-updateConditionValueOnOperationChange');
                element.change(handleConditionChange);
            }

            if ($(selector).find('.js-useForMTSSCheckbox').length > 0)
            {
                var element = $(selector).find(".js-useForMTSSCheckbox");
                element.each(handleUseForMTSSChange);
                element.change(handleUseForMTSSChange);
            }

            if ($(selector).find('.js-tempThresholdName').length > 0)
            {
                var element = $(selector).find(".js-tempThresholdName");
                element.change(handleTempThresholdRuleGroupNameChange);
            }

            if ($(selector).find('.js-skipEntityYearConditionCheckbox').length > 0)
            {
                var element = $(selector).find(".js-skipEntityYearConditionCheckbox");
                var ruleTypeElement = $(selector).find(".ruleTypeSelector");
                // handleRuleTypeChange assumes "this" is the ruleTypeSelector
                element.each(handleRuleTypeChange.bind(ruleTypeElement, selector));
                processSkipEntitySchoolYearDependents(selector, skyward.controls.getValue(element), skyward.controls.getValue(ruleTypeElement), true);
                element.change(function ()
                {
                    handleRuleTypeChange.call(ruleTypeElement, selector);
                    processSkipEntitySchoolYearDependents(selector, skyward.controls.getValue($(this)), skyward.controls.getValue(ruleTypeElement));
                });
                // also set up another change event on RuleType so that control visibility always stays up-to-date
                ruleTypeElement.change(function ()
                {
                    processSkipEntitySchoolYearDependents(selector, skyward.controls.getValue(element), skyward.controls.getValue($(this)));
                });
            }

            if ($(selector).find(".js-otherEntityIDs").length > 0)
            {
                $(selector).find(".js-otherEntityIDs").change(function ()
                {
                    skyward.controls.clearValue($(".js-clearOnEntityChange", selector));
                });
            }

            if ($(selector).find(".js-otherSchoolYearIDs").length > 0)
            {
                $(selector).find(".js-otherSchoolYearIDs").change(function ()
                {
                    skyward.controls.clearValue($(".js-clearOnSchoolYearChange", selector));
                });
            }

            var useForCheckboxGroup = $(selector).find(".js-thresholdGroupUseFor");
            if (useForCheckboxGroup.length > 0)
            {
                useForCheckboxGroup.debounce("change", function ()
                {
                    processUseForDependents(selector, $(this));
                }, 10);
                processUseForDependents(selector, useForCheckboxGroup, true);
            }

            if ($(selector).find(".js-tempThresholdRuleGroupID").length > 0)
            {
                $(selector).find(".js-tempThresholdRuleGroupID").on("eelComplete", ".codeEEL", handleTempThresholdRuleGroupChange);
                $(selector).find(".js-tempThresholdRuleGroupID .codeEEL").each(handleTempThresholdRuleGroupChange);
            }

            if (!$(".js-ThresholdGroupSkywardID").val())
            {
                // RuleTypes that require "Number of Occurrences = 1" helper
                $(selector).find(".js-thresholdRuleGroupID").on("eelComplete", ".codeEEL", handleReadonlyRuleTypes);
                // This ensures any of the readonly rules are made readonly and "Number of Occurences = 1" at page load
                // At page load, the .codeEELCode textbox has data-additional-fields, not the .codeEEL container
                $(selector).find(".js-thresholdRuleGroupID .codeEELCode").each(handleReadonlyRuleTypes);
            }
        };

        var clearAssessmentCRQE = function () {
            var viewer = $(this).parents('[id*="RuleConditionsDiv"]');
            var ruleConditionQuickEntryfs = viewer.find('[id*="TestVersionFieldCRQE"].childrecordquickentry');
            ruleConditionQuickEntryfs.find(".childrecordquickentryclearbuttoncell, .childrecordquickentryremovebuttoncell").each(function () { $(this).find('.button').click(); });
        }

        var handleConditionChange = function (selector)
        {
            var operationTypeInput = $(this);
            var prefix = operationTypeInput.attr('id').substring(0, operationTypeInput.attr('id').lastIndexOf("-"));
            var ruleConditionsSelector = '#' + prefix + '-Value';
            var ruleConditionValue = null;
            var skywardID = null;
            var thresholdConditionID = null;

            if ($(ruleConditionsSelector)[0])
            {
                var backingDataInput = $(ruleConditionsSelector + 'Input');
                var newOperationType = operationTypeInput.val();
                if (backingDataInput.length > 0)
                {
                    // The MultipleSelectBox wrapper has no value of its own; its selections live on the backing data.
                    // Only carry them over when the new operation type (List/Not List) also renders a MultipleSelectBox.
                    if (newOperationType === 'L' || newOperationType === 'NL')
                    {
                        ruleConditionValue = JSON.stringify(skyward.controls.getValue(backingDataInput));
                    }
                }
                else
                {
                    ruleConditionValue = $(ruleConditionsSelector).val();
                }

                skywardID = $(ruleConditionsSelector).data('skywardid');
                thresholdConditionID = $(ruleConditionsSelector).data('thresholdconditionid');
            }

            $.ajax({
                url: skyward.global.virtualDir + "Student/ThresholdRuleGroup/UpdateRuleOnUpdateOperationType",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    operationTypeInput: operationTypeInput.val(),
                    prefix: prefix,
                    conditionValue: ruleConditionValue,
                    conditionSkywardID: skywardID,
                    conditionThresholdConditionID: thresholdConditionID
                },
                success: function (data)
                {
                    if ($(ruleConditionsSelector)[0])
                    {
                        // List/Not List render a MultipleSelectBox whose backing data (id ending in "Input") holds a JSON array;
                        // the other operation types render a single-value control. Only carry the original value over when the
                        // old and new controls store their values the same way, otherwise change tracking breaks on the mismatch.
                        var hadBackingDataInput = $(ruleConditionsSelector + 'Input').length > 0;
                        var originalValueAttr = $(ruleConditionsSelector).attr('data-original-value') ?? $(ruleConditionsSelector + 'Input').attr('data-original-value');
                        $(ruleConditionsSelector).replaceWith(data);

                        var hasBackingDataInput = $(ruleConditionsSelector + 'Input').length > 0;
                        var valueControl = hasBackingDataInput ? $(ruleConditionsSelector + 'Input') : $(ruleConditionsSelector);

                        if (hadBackingDataInput === hasBackingDataInput)
                        {
                            valueControl.attr('data-original-value', originalValueAttr);
                        }

                        valueControl.trigger('change');

                        skyward.window.notifyDOMLoad(ruleConditionsSelector);
                    }
                }
            });
        };

        var handleTempThresholdRuleGroupChange = function ()
        {
            var thisEEL = $(this);
            var closestTableRow = thisEEL.closest('tr');
            var tableRowID = closestTableRow.first().attr('id');
            var trgCollapseRowID = tableRowID + '-ThresholdRuleGroupCollapsePanelRow';
            var trgCollapseRowSelector = '#' + trgCollapseRowID;

            var tempThresholdRuleGroupID = skyward.controls.getValue($(this));
            var htmlToAdd = 'See Threshold Rule Group Details for ID: ' + tempThresholdRuleGroupID;

            var getCollapsePanelHtml = function ()
            {
                return new Promise(function (resolve)
                {
                    $.ajax({
                        url: skyward.global.virtualDir + "Student/TempThresholdRuleGroup/GetTempThresholdRuleGroupCollapsePanel",
                        type: "POST",
                        dataType: "viewparthtml",
                        data: {
                            districtID: $('#DistrictID').val(),
                            tempThresholdRuleGroupID: tempThresholdRuleGroupID,
                            tempThresholdRuleGroupTableName: $(thisEEL).data('tempTableName')
                        },
                        success: function (data)
                        {
                            resolve(data);
                        },
                        error: function ()
                        {
                            resolve(htmlToAdd); // fallback to default
                        }
                    });
                });
            };

            var shouldAjax = $('.js-tempThresholdRuleGroupID .codeEEL')
                .filter(function () { return skyward.controls.getValue($(this)) == tempThresholdRuleGroupID })
                .first().attr('id') == $(this).attr('id');

            if (shouldAjax)
            {
                getCollapsePanelHtml().then(function (resultHtml)
                {
                    htmlToAdd = resultHtml;
                    if (!closestTableRow.siblings(trgCollapseRowSelector)[0])
                    {
                        closestTableRow.after(`<tr id="${trgCollapseRowID}"><td colspan="4">${htmlToAdd}</td></tr>`);
                    } else
                    {
                        var relatedRow = closestTableRow.siblings(trgCollapseRowSelector).find('td')
                        // in future if we allow for changing Threshold Rule Group, we may want to preserve values in collapse panel if another ThresholdRule is using it.
                        relatedRow.html(htmlToAdd);
                        skyward.window.notifyDOMLoad(trgCollapseRowSelector);
                    }
                });
            } else
            {
                if (!closestTableRow.siblings(trgCollapseRowSelector)[0])
                {
                    closestTableRow.after(`<tr id="${trgCollapseRowID}"><td colspan="4">${htmlToAdd}</td></tr>`);
                } else
                {
                    var relatedRow = closestTableRow.siblings(trgCollapseRowSelector).find('td')
                    // in future if we allow for changing Threshold Rule Group, we may want to preserve values in collapse panel if another ThresholdRule is using it.
                    relatedRow.html(htmlToAdd);
                    skyward.window.notifyDOMLoad(trgCollapseRowSelector);
                }
            }
        }

        var handleRuleTypeChange = function (selector)
        {
            var ruleTypeInput = $(this);
            changeRuleType(ruleTypeInput, selector, false);
        };

        var changeRuleType = function (ruleTypeInput, selector)
        {
            var editThresholdRuleGroupSelector = '#editThresholdRuleGroup';
            var primaryKey;
            var tempThresholdRuleGroupID;
            var tempThresholdRuleGroupTableName;
            if (ruleTypeInput[0].id.startsWith('editThresholdRuleGroup') && $(editThresholdRuleGroupSelector).length > 0)
            {
                primaryKey = $(editThresholdRuleGroupSelector).data('primaryid');
            }
            else if (selector.endsWith('-ThresholdRuleGroupCollapsePanelRow'))
            {
                var tempEEL = $(selector.slice(0, -'-ThresholdRuleGroupCollapsePanelRow'.length)).find('.js-tempThresholdRuleGroupID .codeEEL')
                tempThresholdRuleGroupID = skyward.controls.getValue(tempEEL);
                tempThresholdRuleGroupTableName = tempEEL.data('tempTableName');
            }

            $.ajax({
                url: skyward.global.virtualDir + "Student/ThresholdRuleGroup/GetAllRuleConditionsForType",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {                        
                    ruleTypeCode: ruleTypeInput.val(),
                    primaryKey: primaryKey,
                    tempThresholdRuleGroupID: tempThresholdRuleGroupID,
                    tempThresholdRuleGroupTableName: tempThresholdRuleGroupTableName,
                    entityID: $("input[name='EntityID']", selector).val() ?? $("input[name^='EntityID_TTRG']", selector).val(),
                    schoolYearID: $("input[name='SchoolYearID']", selector).val() ?? $("input[name^='SchoolYearID_TTRG']", selector).val(),
                    skipEntitySchoolYearFilter: $(".js-skipEntityYearConditionCheckbox", selector).prop("checked"),
                    otherEntityIDs: skyward.controls.getValue($(".js-otherEntityIDs", selector)),
                    otherSchoolYearIDs: skyward.controls.getValue($(".js-otherSchoolYearIDs", selector)),
                    otherEntityIDsControl: $(".js-otherEntityIDs", selector).attr("name"),
                    otherSchoolYearIDsControl: $(".js-otherSchoolYearIDs", selector).attr("name")
                },
                success: function (data)
                {
                    var ruleConditionsSelector = '#' + ruleTypeInput.parent().siblings('.ruleConditions')[0].id;
                    if ($(ruleConditionsSelector, selector)[0])
                    {
                        $(ruleConditionsSelector, selector).html(data);
                        skyward.window.notifyDOMLoad(ruleConditionsSelector);
                    }
                }
            });
        };                

        async function changeAssessmentTestField()
        {
            const testVersionFieldInput = $(this);
            const primaryKey = testVersionFieldInput.val();
            const id = testVersionFieldInput[0].id;
            let keyPrefix = '';
            if (id.startsWith('TempThresholdRuleGroup'))
            {
                keyPrefix = id.substring(0, id.indexOf('_') + 1);
            }
            const truncatedID = id.substring(keyPrefix.length);
            const idEnding = truncatedID.substring(truncatedID.indexOf("-"), truncatedID.lastIndexOf("_value"));
            const isDetails = id.includes('edit');
            const valueData = await $.ajax({
                url: `${skyward.global.virtualDir}Student/ThresholdRuleGroup/UpdateAssessmentValueViewPart`,
                type: "POST",
                dataType: "viewparthtml",
                data:
                {                        
                    testVersionFieldID: primaryKey,
                    keyPrefix: keyPrefix,
                    keyEnding: idEnding,
                    isDetails: isDetails,
                }
            });

            const valueContainer = testVersionFieldInput.closest(".childrecordquickentryrow").find('.js-TestVersionFieldValueOuterDiv');
            await valueContainer.viewpartHtml(valueData);
            skyward.window.notifyDOMLoad(valueContainer);

            const operationData = await $.ajax({
                url: `${skyward.global.virtualDir}Student/ThresholdRuleGroup/UpdateAssessmentOperation`,
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    testVersionFieldID: primaryKey,
                    keyPrefix: keyPrefix,
                    keyEnding: idEnding,
                    isDetails: isDetails,
                }
            });

            const operationContainer = testVersionFieldInput.closest(".childrecordquickentryrow").find('.js-TestVersionFieldOperationOuterDiv');
            await operationContainer.viewpartHtml(operationData);
            skyward.window.notifyDOMLoad(operationContainer);
        }

        var handleTempThresholdRuleGroupNameChange = function ()
        {
            var nameField = $(this);

            var tempID = nameField.attr("id").slice((nameField.attr("id").indexOf('_')) + 1)

            if (tempID)
            {
                var eelInputs = $(`.js-tempThresholdRuleGroupID .codeEELValue[value=${tempID}]`);

                eelInputs.each(function ()
                {
                    $(this).first().parent().find('.codeEELCode').val(nameField.val())
                })
            }
        };

        var handleUseForMTSSChange = function ()
        {
            var useForMTSSCheckbox = $(this);

            if (useForMTSSCheckbox[0].checked)
            {
                $('.fsTier').show();
            }
            else
            {
                $('.fsTier').hide();
                $('.fsTier').find('.js-TierEEL').each(function ()
                {
                    skyward.controls.clearValue(this.parentElement);
                })
            }
        };

        /**
         * Used to handle visibility and clearing for dependents that are shared between multiple Use For options.
         * Otherwise, when unchecking an option individually, the framework dependent logic won't do what
         * we want because it will go to inverse a visible=true dependent when unchecking a checkbox even if another
         * checkbox in the group is checked and has the same visible=true dependent.
         */
        var processUseForDependents = function (selector, useForCheckboxGroup, isPageLoad)
        {
            var studentIndicatorFieldset = $(selector).find(".js-fsShowStudentIndicator");
            var studentIndicatorCheckbox = $(selector).find(".js-showStudentIndicator");
            var gradeLevelFieldset = $(selector).find(".js-fsGradeLevels");
            var gradeLevelDMSE = $(selector).find(".js-gradeLevels");

            var selectedOptions = {};
            useForCheckboxGroup.find(".checkbox").each(function ()
            {
                var checkboxName = $(this).attr("name");
                if (checkboxName.includes("selectAll"))
                {
                    return;
                }

                // Grab the last part of the dotted path (for workflows)
                var dotParts = checkboxName.split(".");
                if (dotParts.length > 1)
                {
                    checkboxName = dotParts[dotParts.length - 1];
                }

                selectedOptions[checkboxName] = skyward.controls.getValue($(this));
            });

            var useForAthleticEligibility = selectedOptions["UseForAthleticEligibility"];
            var useForAcademicEligibility = selectedOptions["UseForAcademicEligibility"];
            var useForMTSS = selectedOptions["UseForMTSS"];
            var useForScheduling = selectedOptions["UseForScheduling"];

            if (useForAthleticEligibility || useForAcademicEligibility || useForMTSS || useForScheduling)
            {
                skyward.controls.show(studentIndicatorFieldset);
            }
            else
            {
                skyward.controls.hide(studentIndicatorFieldset);

                if (!isPageLoad)
                {
                    skyward.controls.clearValue(studentIndicatorCheckbox);
                }
            }

            if (useForAthleticEligibility || useForAcademicEligibility || useForMTSS)
            {
                skyward.controls.show(gradeLevelFieldset);
            }
            else
            {
                skyward.controls.hide(gradeLevelFieldset);

                if (!isPageLoad)
                {
                    skyward.distinctMultiSelectEEL.values.clear(gradeLevelDMSE);
                }
            }
        };

        var processSkipEntitySchoolYearDependents = function (selector, skipEntitySchoolYearSelector, selectedRuleTypeCode, isInitialPageLoad)
        {
            var isEntitySpecific = true;
            var showSchoolSelector = true;

            // Check for all codes that filter by DistrictID instead of EntityID
            if (selectedRuleTypeCode == "GP") // GPA
            {
                isEntitySpecific = false;
            }
            if (selectedRuleTypeCode == "OF")
            {
                showSchoolSelector = false;
            }

            if (skipEntitySchoolYearSelector && isEntitySpecific)
            {
                skyward.controls.show($(".js-entitiesSelect", selector));
            }
            else
            {
                skyward.controls.hide($(".js-entitiesSelect", selector));
            }

            if (skipEntitySchoolYearSelector && showSchoolSelector)
            {
                skyward.controls.show($(".js-schoolYearsSelect", selector));
            }
            else
            {
                skyward.controls.hide($(".js-schoolYearsSelect", selector));
            }

            if (isInitialPageLoad)
            {
                return;
            }

            skyward.controls.clearValue($(".js-otherEntityIDs,.js-otherSchoolYearIDs", selector));
        };

        var handleReadonlyRuleTypes = function ()
        {
            var numberOfOccurences = $(this).parents(".js-thresholdRuleGroupID").siblings(".js-numberOfOccurrences").find(".number");
            if (numberOfOccurences.length === 0)
            {
                return;
            }

            var operationTypeCode = $(this).parents(".js-thresholdRuleGroupID").siblings(".js-operationTypeCode").find(".comboBoxSet");
            if (operationTypeCode.length === 0)
            {
                return;
            }

            var ruleTypesToForceReadonly = ["SD", "SP"];

            var additionalFieldsData = $(this).data("additionalFields");
            if (!additionalFieldsData || !additionalFieldsData["RuleTypeCode"] ||
                !ruleTypesToForceReadonly.includes(additionalFieldsData["RuleTypeCode"]))
            {
                skyward.controls.enable(numberOfOccurences);
                skyward.controls.enable(operationTypeCode);
                return;
            }

            skyward.controls.setValue(numberOfOccurences, 1);
            skyward.controls.disable(numberOfOccurences);
            skyward.controls.setValue(operationTypeCode, "GTOE");
            skyward.controls.disable(operationTypeCode);
        };

        ////Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.controls.ts" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.base.js" />
(
    function (skyward, $, undefined)
    {
        skyward.transportation = skyward.transportation || {};

        var filterData =
        {
            BusID: null,
            BusRouteID: null,
        };

        var init = function (selector)
        {            
            if ($(selector).find("#SelectedImportFileType").length > 0)
            {
                var element = $(selector).find("#SelectedImportFileType");
                element.on('change', openTransportationFileLayoutPopup);
            }

            // Stop init if not on the student bus stop list.
            if ($(selector).find('.busSelector').length == 0)
            {
                return;
            }

            // Intitialize Bus Selector trigger
            if ($(selector).find('.busSelector').length > 0)
            {
                var element = $(selector).find(".busSelector");
                element.on('change', skyward.transportation.filterBus);
            }

            // Intitialize Route Selector trigger
            if ($(selector).find('.busRouteSelector').length > 0)
            {
                var element = $(selector).find(".busRouteSelector");
                element.on('change', skyward.transportation.filterRoute);
            }
        };

        skyward.transportation.filterBus = function ()
        {
            var busEEL = $(this);            
            filterData.BusID = busEEL.val();
            filterData.BusRouteID = null;
            filterData.PortalCode = busEEL.parents('div .block').find('#portalCode').val();
            updateContent();
        };

        skyward.transportation.filterRoute = function ()
        {
            var routeEEL = $(this);
            filterData.BusRouteID = routeEEL.val();
            filterData.PortalCode = routeEEL.parents('div .block').find('#portalCode').val();
            updateContent();
        };

        var updateContent = function ()
        {
            var action = "List";
            if (filterData.PortalCode == "TeacherAccess")
            {
                action = "TeacherAccessList";
            }
            skyward.window.loadContent("moduleContent", "Transportation", "StudentBusStop", action, null, filterData);
        };

        var openTransportationFileLayoutPopup = function (event)
        {
            var button = $(this);
            var data = button.data();
            var module = data.module;
            var controller = data.object;
            var action = data.action;
            var title = data.title;
            var fieldset = $(this).closest(".js-layoutImportType");
            var importType = skyward.controls.getValue(fieldset.find("#SelectedImportFileType"));
            buildTransportationFileLayoutPanelAjax(module, controller, action, {
                importType: importType,
            }, button);
        };

        var updateTransportationLayoutInformation = function (html, button)
        {
            var fieldset = button.parents(".js-layoutImportType");
            var layoutFieldset = fieldset.siblings(".js-fileLayoutFieldset");
            var container = layoutFieldset.find(".js-fileLayout");
            container.html(html);
        };

        var buildTransportationFileLayoutPanelAjax = function (module, controller, action, data, button)
        {

            $.ajax(
                {
                    url: skyward.global.virtualDir + module + "/" + controller + "/" + action + "?renderType=contentOnly",
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: async function (returnData)
                    {
                        if (returnData.html)
                        {
                            const processedHtml = await skyward.global.processViewPartHtml(returnData.html);
                            updateTransportationLayoutInformation(processedHtml, button);
                        }
                    }
                });
        };

        var CRQE_ROW_SELECTOR = '.childrecordquickentryrow:not(.removedElement)';
        var COLUMN_NUMBER_SELECTOR = '.comboBoxSet.ColumnNumber';

        var initChildRecordQuickEntry = function ()
        {
            var crqe = $(this);
            crqe.on('childrecordquickentry-row-added', function (event, row)
            {
                setNextColumnNumber(crqe, row);
            });
        };

        var setNextColumnNumber = function (crqe, row)
        {
            var highest = 0;
            crqe.find(COLUMN_NUMBER_SELECTOR).each(function ()
            {
                var columnNumberElement = $(this);
                var value = parseInt(skyward.controls.getValue(columnNumberElement));
                if (value > highest)
                {
                    highest = value;
                }
            });

            highest = parseInt(highest) + 1;
            var specificRowColumnNumberElement = row.find(COLUMN_NUMBER_SELECTOR);
            skyward.controls.setValue(specificRowColumnNumberElement, highest);
        };

        var events =
        {
            "initChildRecordQuickEntry": initChildRecordQuickEntry
        };

        skyward.events.registerEvents("transportation", events);

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
(
    function (skyward, $, undefined)
    {
        skyward.stateassessmentsloginbutton = skyward.stateassessmentsloginbutton || {};

        var init = function (selector)
        {
            // Initialize Texas Assessments Login Form
            if ($(selector).find('.stateassessmentsloginbutton').length > 0)
            {
                var element = $(selector).find('.stateassessmentsloginbutton');
                element.on('click', logRedirect);
            }
        };

        var logRedirect = async function (e)
        {
            var loginButton = $(this);

            var accessMode = $('#accessmode').val();
            await $.ajax({
                url: skyward.global.virtualDir + 'Student/Student/LogStateAssessmentsLogin' + accessMode,
                type: 'POST',
                dataType: 'JSON',
                data:
                {
                    studentID: loginButton[0].getAttribute('data-id'),
                    studentidhash: loginButton[0].getAttribute('data-studentidhash'),
                }
            });

            var url = loginButton.attr('data-formaction');

            var formData =
            {
                accesscode: loginButton.attr('data-accesscode'),
                dateofbirth: loginButton.attr('data-dateofbirth'),
                name: loginButton.attr('data-name')
            };

            if (skyward.global.mobileAccess === true) {
                await navigateToExternalUrlRequestOnMobile(url, formData);
            } else {
                var form = skyward.global.createHiddenInputForm(url, formData, true, true);
                skyward.global.submitAndRemoveHiddenInputForm(form);
            }
        };

        async function navigateToExternalUrlRequestOnMobile(url, formData)
        {
            const externalUrlRequestGuid = await $.ajax({
                url: skyward.global.virtualDir + 'SkySys/ExternalUrlRequest/CreateExternalUrlRequest',
                type: 'POST',
                dataType: 'text',
                data:
                {
                    TargetUrl: url,
                    PostData: JSON.stringify(formData)
                }
            });

            const openUrl = skyward.global.virtualDir + 'SkySys/ExternalUrlRequest/HandleExternalUrlRequest?externalUrlRequestGuid=' + encodeURIComponent(externalUrlRequestGuid);
            window.open(openUrl, '_blank');
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.form = skyward.form || {};

        skyward.form.updateTextAreaSizes = function ()
        {
            updateTextAreaRestrictions($('.js-PreventNewLine'));
            skyward.form.updateTextAreaExpandSize($('.js-AutoExpand'));
        };


        const updateTextAreaRestrictions = function (textAreas)
        {
            textAreas.each(function (e)
            {
                e.bind('keypress', function (e)
                {
                    if ((e.keyCode || e.which) == 13)
                    {
                        e.preventDefault();
                        return false;
                    }
                });
            });
        };

        skyward.form.updateTextAreaExpandSize = function (textAreas)
        {
            textAreas.each(function (e)
            {
                const textArea = $(this);

                function updateTextAreaHeight()
                {
                    var placeholderText = textArea.attr('placeholder');
                    textArea.attr('placeholder', '');
                    textArea.height("");
                    textArea.height(textArea.prop('scrollHeight') + "px");
                    textArea.attr('placeholder', placeholderText);

                }
                updateTextAreaHeight();
            });
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined) {
        skyward.form = skyward.form || {};

        skyward.form.initInIframe = function ()
        {
            const fieldElements = $('[id^="SkywardFieldInput-"]');
            fieldElements.not(".codeEEL")
                .off("change", updateAllSkywardFieldInput)
                .on("change", updateAllSkywardFieldInput);

            $("body").on("click", ".js-formInputIcon", function (e) {
                var container = $(this);
                if (container.closest('.jsFormFieldWrapper').find('.jsFieldPopup').length > 0) {

                    var field = container.closest('.jsFormFieldWrapper').find('.jsFieldPopup');
                    if (field.attr('readonly') !== 'readonly') {
                        mapUserFormRelationship(container.closest('.jsFormFieldWrapper'));
                    }
                }
            });

            $("body").on("click", ".jsFormFieldWrapper", function (e) {
                var container = $(this);
                if (container.find('.jsFieldPopup').length > 0) {
                    var field = container.closest('.jsFormFieldWrapper').find('.jsFieldPopup');

                    if (field.attr('readonly') == 'readonly' || (field.find('.eELInputContainer__textBox.ui-disabled').length > 0)) {

                        mapUserFormRelationship(container);
                    }
                }
            });

            fieldElements.filter("input:radio").on("click", function ()
            {
                if ($(this).length == 0 || $(this).attr('id') == 'undefined' || $(this).attr('id').split('--').length < 2)
                {
                    return;
                }

                var skywardID = $(this).attr('id').split('--')[1];
                var relationshipIdentifierGuid = $(this).attr('id').split('--')[2];
                var relationshipNumber = $(this).attr('id').split('--')[3];
                var formFieldIdentifier = skywardID + '--' + relationshipIdentifierGuid + '--' + relationshipNumber;
                var blankElement = $('[id=SkywardFieldInput--' + formFieldIdentifier + '--BlankValue]');
                var groupElement = $('[id*="' + formFieldIdentifier + '--RadioButtonGroup"]');
                var formViewer = $(this).closest("#ContentDiv");
                if (blankElement.length == 0 || groupElement.length == 0)
                {
                    return;
                }

                var inputValue = $(this).val();
                var originalValue = groupElement.attr('data-original-value');

                if (inputValue === groupElement.val())
                {
                    $(this).prop("checked", false);
                    blankElement.prop("checked", true);

                    groupElement.val(blankElement.val());

                    if (originalValue == "")
                    {
                        groupElement.attr('data-dirty', false);
                        updateSkywardIDTracker(formViewer, false, formFieldIdentifier);
                    }
                    else
                    {
                        groupElement.attr('data-dirty', true);
                        updateSkywardIDTracker(formViewer, true, formFieldIdentifier);
                    }

                    if (blankElement.val() != inputValue)
                    {
                        blankElement.click();
                    }
                }
                else
                {
                    groupElement.val(inputValue);

                    if (inputValue == originalValue && inputValue != blankElement.val())
                    {
                        groupElement.attr('data-dirty', false);
                        updateSkywardIDTracker(formViewer, false, formFieldIdentifier);
                    }
                    else
                    {
                        groupElement.attr('data-dirty', true);
                        updateSkywardIDTracker(formViewer, true, formFieldIdentifier);
                    }
                }
            });

            var textAreaExpand = $('.js-AutoExpand');
            if (textAreaExpand.length > 0)
            {
                skyward.form.updateTextAreaExpandSize(textAreaExpand);
            }

            fieldElements.filter(".codeEEL")
                .each(replaceRelationshipDisplay)
                .on('eelComplete', replaceRelationshipDisplay);
        };

        var init = function ()
        {
            var iFrames = this.find('.FormViewerIFrame').not(".js-ignoreIFrameContents");
            // Hidden iframes mostly don't perform layout, so setupIFrame can only calculate the correct
            // height for the visible ones.
            iFrames.each(function ()
            {
                setupIFrame($(this));
            });
        };
        var setupIFrame = async function (iFrame)
        {
            if (iFrame.data('finished-setup')) {
                return;
            }
            iFrame.data('finished-setup', true);

            try
            {
                await skyward.iframeListener.waitForLoadedAndNonEmpty(iFrame[0]);
            }
            catch { }

            // remove background image
            iFrame.removeClass('loading');

            if (iFrame.hasClass('htmlViewer')) {
                await skyward.iframeListener.setupChangeTracking(iFrame, function (dirty)
                {
                    iFrame.attr("data-dirty", dirty);
                    iFrame.trigger("notifyDirty");

                });
                skyward.iframeListener.initForm(iFrame);

                var formViewerIFrame = $('.FormViewerIFrame').get(0);
                if (formViewerIFrame)
                {
                    var contentArea = $('.FormViewerIFrame').closest('.contentArea').get(0);
                    var dov = $('.FormViewerIFrame').closest('.dataObjectViewer').get(0);

                    if (contentArea && dov)
                    {
                        $('.contentArea').css('position', 'relative');
                        $('.dataObjectViewer').css('position', 'relative');
                        window.addEventListener("resize", resize);
                        resize();
                        function resize() {
                            contentArea = $('.FormViewerIFrame').closest('.contentArea').get(0);
                            dov = $('.FormViewerIFrame').closest('.dataObjectViewer').get(0);

                            if (contentArea && dov)
                            {
                                $('.FormViewerIFrame').parent().height(contentArea.scrollHeight - dov.offsetTop - formViewerIFrame.offsetTop);
                            }
                        }

                        $($('.FormViewerIFrame').contents().find('body')).on("click", ".jsFormFieldWrapper", function (e) {
                            var container = $(this);
                            
                            if (container.find('.jsSignaturePopup').length > 0) {
                                var field = container.closest('.jsFormFieldWrapper').find('.jsSignaturePopup');

                                if (field.attr('readonly') == 'readonly'
                                    || (field.find('.eELInputContainer__textBox.ui-disabled').length > 0)) {

                                    signaturePopup(container);
                                }
                            }
                        });


                    }
                }
            }
        };

        var signaturePopup = function (containerOuter) {
            var container = containerOuter.closest('.jsFormFieldWrapper').find('.jsSignaturePopup').data();
            var signatureWorkflowModule = container.signmodule;
            var signatureWorkflowObject = container.signobject;
            var signatureWorkflowScreen = container.signscreen;

            var data =
            {
                "Workflow.FormSignature.UserFormID": container.userformid,
                "Workflow.FormSignature.UserFormID_securityhash": container.userformidhash,

                "UserFormID": container.userformid,
                "UserFormID_securityhash": container.userformidhash,

                "Workflow.ChangeStatus": container.changestatus,
                "Workflow.ChangeStatus_securityhash": container.changestatushash,

                "Workflow.CurrentUserID": container.currentuserid,
                "Workflow.CurrentUserID_securityhash": container.currentuseridhash,
                
                
            };

            skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', "Create/" + signatureWorkflowModule + "/" + signatureWorkflowObject + "/" + signatureWorkflowScreen, null, data, null, null, null, false, null, null, null);
        }

        var replaceRelationshipDisplay = function () {
            var codeEEL = $(this);

            var skywardFieldInput = $(this);
            var id = skywardFieldInput[0].id;
            var skywardFieldGuid = id.split('--')[1];
            var relationshipNumber = id.split('--')[3];
            var codeEELValue = skyward.controls.getValue(codeEEL);

            $.ajax({
                url: skyward.global.virtualDir + "Form/FormField/ReplaceRelationshipDisplay",
                type: "POST",
                dataType: "JSON",
                data:
                {
                    uniqueID: skywardFieldGuid,
                    foreignKey: codeEELValue,
                    relationshipNumber: relationshipNumber,
                    formVersionID: $('.formViewerFormVersionID').val()
                },
                success: function (response) {
                    if (response.updateDisplay === true) {
                        codeEEL.find('.codeEELDescription').val(response.displayValue);
                    }
                }
            });
        }

        var updateAllSkywardFieldInput = function (input) {
            var skywardFieldInput = $(this);
            var id = skywardFieldInput[0].id;
            var skywardFieldGuid = id.split('--')[1];
            var relationshipIdentifierGuid = id.split('--')[2];
            var relationshipNumber = id.split('--')[3];
            var formFieldIdentifier = 'SkywardFieldInput--' + skywardFieldGuid + '--' + relationshipIdentifierGuid + '--' + relationshipNumber
            var formViewer = skywardFieldInput.closest("#ContentDiv");
            if (skywardFieldInput.is("select")) {
                var value = skywardFieldInput.find(":selected").val();
                var options = formViewer.find('[id="' + formFieldIdentifier + '"] option[value="' + value + '"]');
                options.prop('selected', true);

                var originalValue = skywardFieldInput.attr('data-original-value');
                var isDirty = String(originalValue).toLowerCase() != String(value).toLowerCase();
                updateSkywardIDTracker(formViewer, isDirty, formFieldIdentifier)
            }
            else if (skywardFieldInput.is('input:checkbox')) {
                var value = skywardFieldInput.is(':checked');
                var inputs = formViewer.find('[id="' + formFieldIdentifier + '"]');
                inputs.prop('checked', value);

                var originalValue = skywardFieldInput.attr('data-original-value');
                var isDirty = String(originalValue).toLowerCase() != String(value).toLowerCase();
                updateSkywardIDTracker(formViewer, isDirty, formFieldIdentifier)
            }

            else if (skywardFieldInput.find('input:radio').length > 0 || skywardFieldInput.is('input:radio')) {
                //This case is here to prevent the default logic from saving the values set in the click function
            }
            else if (
                skywardFieldInput.find('[id="SkywardFieldInput--' + skywardFieldGuid + '-file' + '"]').length > 0 ||
                skywardFieldInput.attr("id").startsWith('SkywardFieldInput--' + skywardFieldGuid + '-----fileUpload') || 
                skywardFieldInput.hasClass('fileUploadElement')
            )
            {
                //no relationships for file upload
                //This case is here to prevent the default logic from saving the values set in the click function
                var image = formViewer.find('[id="SkywardFieldInput--' + skywardFieldGuid + '-image"]');
                $(image).remove();
                var imageIdentifier = 'SkywardFieldInput--' + skywardFieldGuid + '----';
                updateSkywardIDTracker(formViewer, true, imageIdentifier)
            }
            else {
                var value = skywardFieldInput.val();
                var inputs = null;
                if (skywardFieldInput.hasClass('basicEditor')) {
                    formFieldIdentifier = formFieldIdentifier.split('?')[0];
                    inputs = formViewer.find('[id="' + formFieldIdentifier + '"]');
                    $.merge(inputs, formViewer.find('[id^="' + formFieldIdentifier + '?"]'));
                }
                else {
                    inputs = formViewer.find('[id="' + formFieldIdentifier + '"]');
                }
                inputs.val(value);
                inputs.trigger('updateEditor');
                inputs.trigger('textAreaResize');
                var originalValue = skywardFieldInput.attr('data-original-value');
                if (originalValue !== undefined)
                {
                    var isDirty = originalValue != value;
                    skywardFieldInput.attr("data-dirty", originalValue != value);
                    updateSkywardIDTracker(formViewer, isDirty, formFieldIdentifier)
                }
            }
        };

        function updateSkywardIDTracker(formViewer, isDirty, formFieldIdentifier) {
            var hiddenList = formViewer.find('#DirtySkywardFieldIDs');
            var hiddenValueString = hiddenList.val();
            var skywardIDList = JSON.parse(hiddenValueString);

            if (isDirty) {
                var index = skywardIDList.indexOf(formFieldIdentifier);
                if (index < 0) {
                    skywardIDList.push(formFieldIdentifier);
                }
            }
            else {
                var index = skywardIDList.indexOf(formFieldIdentifier);
                if (index > -1) {
                    skywardIDList.splice(index, 1);
                }
            }
            hiddenList.val(JSON.stringify(skywardIDList));
        }

        // Calls the ajax action to update tempformrole access checkboxes so they are set if another form is added
        function createSecurityUpdateHandler(isAllUpdate) {
            return function (_event) {
                var elem = $(this);
                var container = elem.closest(".js-panelSelection");
                var url = "";
                if (isAllUpdate) {
                    url = "Form/TempFormRole/UpdateAllSecurityAction";
                }
                else {
                    url = "Form/TempFormRole/UpdateSecurityAction";;
                }
                var data = $(this).data();
                data = $.extend({}, data, { checked: elem.is(":checked") });
                var clickedBrowse = skyward.browse.getContainingBrowse(elem);
                if (!clickedBrowse) {
                    return;
                }
                var selectedRow = elem.closest(".browseRowOptions").data("row");
                skyward.browse.setCurrentRecord(clickedBrowse.browseName, selectedRow);

                data.browseSearchCondition = clickedBrowse.browseSearchCondition;
                data.browseSearchConditionHash = clickedBrowse.browseSearchConditionHash;
                data.userSearchCondition = clickedBrowse.userSearchCondition;
                data.userSearchConditionHash = clickedBrowse.userSearchConditionHash;

                $.ajax(
                    {
                        type: "POST",
                        dataType: "JSON",
                        url: skyward.global.virtualDir + url,
                        data: $.extend({}, data, clickedBrowse.data),
                        success: function (response) {
                            if (response.result) {
                                // Refresh the right browse
                                var rightBrowse = skyward.browse.getContainingBrowse(container.find(".browse.js-panelSelection__right"));
                                if (!rightBrowse) {
                                    return;
                                }
                                /*Change the "0" to "rightBrowse.currentRow" to alter the functionality to have the record after the record added be selected
                                instead of the top record be selected. This will remove the functionality of keeping the current page the closest to the 
                                same that we can. Check with Leah before you change this.*/
                                var rightBrowseCurrentID = skyward.browse.getCurrentRowElement("unlocked", rightBrowse.browseName, 0).data("targetid");
                                var browseGetData =
                                {
                                    seekId: rightBrowseCurrentID
                                };

                                skyward.browse.get(rightBrowse.id, browseGetData);
                            }
                            else {
                                skyward.modalLayer.showDialog("Error", response.errors, [{ text: "Close", icon: "Close" }]);
                            }
                        }
                    });
            };
        }

        function showTreeBrowse() {
            var elem = $(this);
            var lookupModule = elem.data("lookupModule");
            var lookupObject = elem.data("lookupObject");
            var lookupHash = elem.data("lookupHash");
            var relationshipActionUrl = elem.data("relationshipActionUrl");

            var relationshipPathId = "FormFieldVersionFieldPath";
            var relationshipPathControl = $("#" + relationshipPathId);
            var seekPathValue = skyward.controls.getValue(relationshipPathControl);

            var saveButton =
            {
                text: "Select Relationship",
                click: function (event, dialog)
                {
                    var relationshipData = skyward.treebrowse.getSelectedFieldData(dialog.content.find(".treeBrowseContainer"));
                    var relationshipName = relationshipData.fieldName;
                    skyward.controls.setValue(relationshipPathControl, relationshipName || "");
                    dialog.close();
                },
                "icon": "Select",
                additionalClasses: ["saveButton"]
            };
            var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };

            var treeBrowse = function ()
            {
                return $.ajax(
                {
                    url: skyward.global.virtualDir + relationshipActionUrl,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        lookupModule: lookupModule,
                        lookupObject: lookupObject,
                        lookupHash: lookupHash,
                        isOneToManySelect: true,
                        pathToRelationship: seekPathValue,
                        seekField: seekPathValue
                    }
                }).done(function (data)
                {
                    var treeBrowseRowChanged = function (event, treeBrowseData, rowData)
                    {
                        var saveButton = menu.footer.find(".saveButton");
                        saveButton.toggle(rowData?.fieldType == "OneToMany");
                    };
                    menu.content.on("treeBrowseRowChange", treeBrowseRowChanged);
                });
            };

            var menu = skyward.modalLayer.showDialog("Select Relationship", treeBrowse, [saveButton, cancelButton],
            {
                anchorTo: elem
            });
        }

        function chooseExistingRelationship()
        {
            var elem = $(this);
            var formID = elem.data("formId")
            var formVersionID = elem.data("formVersionId")
            var formFieldVersionIDRelationship = elem.data("formFieldVersionIdRelationship")

            var okButton =
            {
                text: "Select Relationship",
                click: function (event, dialog)
                {
                    var selectedFormFieldID = skyward.controls.getValue($('#FormFieldID'))
                    skyward.controls.setValue($('#FormFieldIDOverride'), selectedFormFieldID);
                    dialog.close();
                },
                "icon": "Select",
                additionalClasses: ["saveButton"]
            };
            var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };

            skyward.modalLayer.showDialog(
                "Choose Existing Relationship",
                function ()
                {
                    return $.ajax(
                        {
                            type: "POST",
                            url: skyward.global.virtualDir + "Form" + '/' + "FormFieldVersion" + '/' + "ChooseExistingRelationship",
                            data:
                            {
                                renderType: "ContentOnly",
                                formVersionID: formVersionID,
                                formFieldVersionIDRelationship: formFieldVersionIDRelationship,
                                formID: formID,
                                formFieldID: skyward.controls.getValue($('#FormFieldIDOverride'))
                            }
                        });
                },
                [okButton, cancelButton],
            );
        }

        const buildSpecificationsLegendPopup = function () {
            buildPopup("BuildSpecificationsLegendPopup");
        };

        const buildLegendPopup = function () {
            buildPopup("BuildLegendPopup");
        };

        const buildPopup = function (action) {
            const buildPopup = function () {
                return $.ajax({
                    url: `${skyward.global.virtualDir}Form/FormVersion/${action}`,
                    type: "POST",
                    dataType: "viewparthtml"
                });
            };

            const options =
            {
                anchorTo: $(this)
            };

            skyward.modalLayer.showDialog("Legend", buildPopup, { text: "Close", icon: "Close" }, options);
        };

        /* 
            Map Relationships Popup Logic
        */
        function mapUserFormRelationship(wrapper) {
            var skywardFieldInput = wrapper.find('.jsFieldPopup');

            var id = skywardFieldInput.attr('id');
            var skywardFieldGuid = id.split('--')[1];
            var relationshipIdentifierGuid = id.split('--')[2];
            var relationshipNumber = id.split('--')[3];
            var formFieldIdentifier = 'SkywardFieldInput--' + skywardFieldGuid + '--' + relationshipIdentifierGuid + '--' + relationshipNumber
            var formViewer = skywardFieldInput.closest("#ContentDiv");
            var userFormID = $('.formViewerUserFormID').val();
            var allowMap = false;
            if (skywardFieldInput.attr('data-allow-map')) {
                allowMap = skywardFieldInput.attr('data-allow-map') == "true";
            };

            var data =
            {
                FormFieldSkywardID: skywardFieldGuid,
                RelationshipUniqueID: relationshipIdentifierGuid,
                RelationshipNumber: relationshipNumber,
                UserFormID: userFormID,
                AllowMap: allowMap
            };

            var portal = '';
            if (skywardFieldInput.attr('data-portal'))
            {
                portal = skywardFieldInput.attr('data-portal');
            }                ;
            var buildPopup = function () {
                var values = $.extend({}, {}, data);

                var updates = $('[id^="SkywardFieldRelInput--"]');
                $.each(updates, function (i, item) {
                    data[item.id] = item.value;
                });
                return $.ajax({
                    url: skyward.global.virtualDir + "Form/UserForm/MapRelationship" + portal + "?renderType=contentOnly",
                    type: "POST",
                    dataType: "viewparthtml",
                    data: data
                });
            };

            $.when(buildPopup()).done(function (html) {
                var closeButton = { id: "closeButton", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
                var saveButton = null;
                if (allowMap) {
                    saveButton = {
                        id: "saveUserFormRelationship", text: "Set Relationship", click: saveData, icon: "FieldRelationship", data: data
                    };
                }
                    var options =
                    {
                        anchorTo: wrapper[0],
                        id: skywardFieldInput.attr('id') + "_Popout",
                        draggable: false,
                        initialFocusElement: skywardFieldInput,
                        additionalClasses: 'formFieldIndexModal'
                    };
                var dialog = skyward.modalLayer.showDialog('Field Details', html, [saveButton, closeButton], options);

                function saveData() {
                    if (!allowMap) {
                        dialog.close();
                        return;
                    }
                    skyward.dataobjectviewer.getFieldValues.getFieldValues(dialog.content).then(fieldValues => {
                        var values = $.extend({}, data, fieldValues);
                        values['warninghash'] = dialog.content.data("warninghash") || "";
                        values['preSaveWarningHash'] = dialog.content.data("preSaveWarningHash") || "";
                        values['editableFields'] = skyward.controls.getEditableFields(dialog.content);
                        return $.ajax({
                            url: skyward.global.virtualDir + "Form/UserForm/SubmitSetRelationship" + portal,
                            type: "POST",
                            dataType: "JSON",
                            data: values,
                            success: function (response)
                            {
                                UpdateRelationships(formViewer, response);
                                dialog.close();
                            }
                        });
                        
                    });                    
                }
            });
        }
        
        function UpdateRelationships(formViewer, responseData) {
            if (responseData && responseData.RelationshipUpdates) {
                for (index in responseData.RelationshipUpdates) {
                    var rel = responseData.RelationshipUpdates[index];
                    var foreignKey = rel.ForeignKey,
                        identifier = rel.Identifier;
                    var inputs = $('#' + identifier);
                    var originalValue;
                    if (inputs.length > 0) {
                        originalValue = inputs.attr('data-original-value');
                    }
                    skyward.controls.setValue(inputs, foreignKey);

                    var isDirty = String(originalValue).toLowerCase() != String(foreignKey).toLowerCase();

                    updateSkywardIDTracker(formViewer, isDirty, identifier)
                }
            }
            if (responseData && responseData.FieldUpdates) {
                for (index in responseData.FieldUpdates) {
                    var field = responseData.FieldUpdates[index];
                    var fieldValue = field.FieldValue,
                        identifier = field.Identifier,
                        isEditable = field.IsEditable;
                    var originalValue; 
                    var inputs = $('[id="' + identifier + '"]');
                    if ($(inputs).is('select'))
                    {
                        $(inputs).removeAttr('readonly');
                    }
                    if (inputs.length > 0) {
                        originalValue = inputs.attr('data-original-value');
                    }
                    var originalReadonly = inputs.attr('data-original-readonly');
                    if (isEditable && !originalReadonly) {
                        if (inputs.hasClass('codeEEL'))
                        {
                            skyward.controls.enable(inputs.find('.codeEELValue'));
                            inputs.removeClass('jsFieldPopup');
                        }
                        else
                        {
                            skyward.controls.enable(inputs);
                        }
                    }
                    skyward.controls.setValue(inputs, fieldValue);
                    if (!isEditable && !originalReadonly) 
                    {
                        if (inputs.hasClass('codeEEL'))
                        {
                            skyward.controls.disable(inputs.find('.codeEELValue'));
                            inputs.addClass('jsFieldPopup');
                        }
                        else
                        {
                            skyward.controls.disable(inputs);
                        }
                    }
                    var isDirty = String(originalValue).toLowerCase() != String(fieldValue).toLowerCase();

                    updateSkywardIDTracker(formViewer, isDirty, identifier)
                }
            }
        }
        /*
            End Map Relationships Popup Logic
        */

        ////Bootstrap
        var events =
        {
            "updateFormSecurity": createSecurityUpdateHandler(false),
            "updateAllFormSecurity": createSecurityUpdateHandler(true),
            "showTreeBrowse": showTreeBrowse,
            "chooseExistingRelationship": chooseExistingRelationship,
            buildLegendPopup,
            buildSpecificationsLegendPopup,
        };
        skyward.events.registerEvents("form", events);
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);;
(
    function (skyward, $, undefined) {
        skyward.userform = skyward.userform || {};

        var init = function (selector)
        {
            let outerFormContainer = document.getElementById('FormViewerBody');
            if (outerFormContainer){
                let wrapper = document.getElementById('formViewerSizeContainer');
                if (wrapper) {
                    window.addEventListener("resize", resize);
                    resize();
                    function resize(){
                        let maxWidth  = outerFormContainer.clientWidth,
                        maxHeight = outerFormContainer.clientHeight;

                        let scale = 1.0,
                        width = wrapper.clientWidth;
                        scale = (maxWidth/width);

                        if (scale > 1.0){
                            scale = 1.0;
                        }
                        outerFormContainer.style.transform = 'scale(' + scale + ')';
                    }
                }
            }
        };

        var specificationPopup = function ()
        {
            var button = $(this);
            var options =
            {
                anchorTo: button,
                id: button.attr('id'),
                draggable: false,
                initialFocusElement: button
            };

            if (button.find("div:not(.linkTypeDivOverlay)").html() == "")
            {
                return;
            }

            var toggleRequiredStyle = function (required) {
                if (required) {
                    button.addClass('required');
                }
                else {
                    button.removeClass('required');
                }
            }

            var action = "GetFormFieldSpecification?renderType=contentOnly";
            var formVersionID = button.data().formVersionId;
            var userFormVersionID = button.data().userFormVersionId;
            var allowEdit = (button.data().allowEdit.toLowerCase() === "true");

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Form/FormField/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    data:
                    {
                        FormFieldSkywardID: button.data().formFieldId,
                        FormVersionID: formVersionID,
                        UserFormVersionID: userFormVersionID,
                        RadioValue: button.data().radioValue,
                        RelationshipUniqueID: button.data().relationshipUniqueId,
                        RelationshipNumber: button.data().relationshipNumber,
                        SignatureNameID: button.data().signatureNameId,
                        AllowEdit: allowEdit,
                    }
                });
            };

            $.when(buildPopup()).done(function (html)
            {
                const buttons = [
                    { id: "closeButton", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" }
                ];

                if (allowEdit) {
                    buttons.push({ id: "saveFormFieldVersion", text: "Save", click: saveData, icon: "Save", data: button.data() });
                }

                var dialog = skyward.modalLayer.showDialog('Form Field Details', html, buttons, options);

                function saveData() {
                    var selector = "#formFieldVersionPopupContent";
                    var container = $(selector);
                    var action = skyward.controls.getValue(container.find("#SpecificationPopupSaveAction"));

                    $.ajax({
                        url: skyward.global.virtualDir + "Form/FormFieldVersion/" + action,
                        type: "POST",
                        dataType: "JSON",
                        data: {
                            FormFieldVersionID: skyward.controls.getValue(container.find("#FormFieldVersionID")),
                            UserFormFieldVersionID: skyward.controls.getValue(container.find("#UserFormFieldVersionID")),
                            EditableInActivityAccess: skyward.controls.getValue(container.find("#EditableInActivityAccess")),
                            EditableInAdministrativeAccess: skyward.controls.getValue(container.find("#EditableInAdministrativeAccess")),
                            EditableInEmployeeAccess: skyward.controls.getValue(container.find("#EditableInEmployeeAccess")),
                            EditableInFamilyAccess: skyward.controls.getValue(container.find("#EditableInFamilyAccess")),
                            EditableInNewStudentEnrollment: skyward.controls.getValue(container.find("#EditableInNewStudentEnrollment")),
                            EditableInStudentAccess: skyward.controls.getValue(container.find("#EditableInStudentAccess")),
                            EditableInStudentServices: skyward.controls.getValue(container.find("#EditableInStudentServices")),
                            EditableInTeacherAccess: skyward.controls.getValue(container.find("#EditableInTeacherAccess")),
                            IsRequired: skyward.controls.getValue(container.find("#IsRequired")),
                            AutoFillGuardianSignature: skyward.controls.getValue(container.find("#AutoFillGuardianSignature")),
                            DefaultValue: skyward.controls.getValue(container.find("#DefaultValue")),
                        },
                        success: function (response)
                        {
                            toggleRequiredStyle(skyward.controls.getValue(container.find("#IsRequired")));
                            dialog.close();
                        }
                    });
                }

            });
        };

        ////Bootstrap
        var events =
        {
            "specificationPopup": specificationPopup
        };
        skyward.events.registerEvents("userform", events);
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
(
    function (skyward, $, undefined) 
    {
        "use strict";

        skyward.workflowProcess = skyward.workflowProcess || {};

        var waiting = async function (statusData, button, event)
        {
            if (statusData.synchronousLockWaiting)
            {
                var cancelButton = { id: "cancelButton", text: "Cancel", click: "close", icon: "Cancel" };

                if (waitingBox == null) 
                {
                    waitingBox = skyward.modalLayer.showProcessingDialog(
                        "Processing Request",
                        statusData.message,
                        [cancelButton],
                        {
                            closeOnClick: true,
                            closeOnEscape: true,
                            afterClose: function ()
                            {
                                waitingBox = null;
                                nextPopupID = null;

                                $.ajax(skyward.global.virtualDir + "Workflow/SynchronousLock/Clear/" + statusData.synchronousLockID,
                                {
                                    type: "POST",
                                    success: function (data)
                                    {
                                        skyward.window.closePopup();
                                    }
                                });

                                if (requestHandle) 
                                {
                                    clearTimeout(requestHandle);
                                    requestHandle = null;
                                }

                                $(document.body).removeClass("cursor-progress");
                            },
                            width: "550px"
                        });
                }
                else 
                {
                    await waitingBox.content.viewpartHtml(statusData.message);
                }

                requestHandle = setTimeout(function () 
                {
                    runTask(event, button);
                }, 5000);
            }
        }

        var runTask = function (event, button)
        {
            if (button == null || button.data === undefined) 
            {
                button = $(this);
            }

            var id = button.data().processstepinstanceid;
            $.ajax(skyward.global.virtualDir + "ProcessManagement/ProcessStepInstance/StartProcessStepInstance/" + id,
                {
                    type: "POST",
                    dataType: "JSON",
                    success: function (data)
                    {
                        if (data.success)
                        {
                            displayNextTask(data.taskInstanceID);
                        }
                        else if (data.synchronousLockWaiting) 
                        {
                            waiting(data, button, event);
                        }
                        else 
                        {
                            skyward.modalLayer.showErrorDialog("Unable to start task", data.errorMessage);
                        }                        
                    }
                });

            event.stopPropagation();
        };

        var startProcess = function (event) 
        {
            var button = $(this);

            var id = button.data().processid;
            $.ajax(skyward.global.virtualDir + "ProcessManagement/Process/StartProcess/" + id,
                {
                    type: "POST",
                    dataType: "JSON",
                    success: function (data)
                    {
                        if (data.success)
                        {
                            skyward.taskstatus.beginAsyncStatusReport(data.workflowInstanceID, endWorkflow, function (data) { displayNextTask(data.taskInstanceId); }, null);
                        }
                        else
                        {
                            skyward.modalLayer.showErrorDialog("Unable to start process", data.errorMessage);
                        }
                    }
                });

            event.stopPropagation();
        };

        var endWorkflow = function () { skyward.workflow.closeWorkflowPopup(); };

        var requestHandle;
        var waitingBox;
        var nextPopupID;

        var displayNextTask = function (taskInstanceID)
        {
            if (nextPopupID == null)
            {
                nextPopupID = "popup" + skyward.window.getNextPopupId();
            }

            return skyward.window.loadContent("popup", "workflow", "taskinstance", "currentinstance", taskInstanceID, undefined, undefined, undefined);
        };

        var events =
        {
            "runTask": runTask,
            "startProcess": startProcess
        };

        skyward.events.registerEvents("workflowprocess", events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
;
skyward.base.registerScript("parametermapper", function (skyward, $)
{
    "use strict";
    skyward.parametermapper = skyward.parametermapper || {};

    var initParameterMappers = function (selector)
    {
        const jQSelector = $(selector);
        jQSelector.find('.parametermapperworkflowversionhidden').each(function ()
        {
            const hidden = $(this);
            hidden.off("change", skyward.parametermapper.workflowVersionChanged);
            hidden.on("change", skyward.parametermapper.workflowVersionChanged);

            const parameterMapper = hidden.siblings(".parametermapper");
            togglePromptInstructions(parameterMapper);
        });

        if (jQSelector.hasClass("parametermapper"))
        {
            togglePromptInstructions(jQSelector);
        }
    };

    var getDetailLineValue = function (fieldSetWrapper)
    {
        fieldSetWrapper = fieldSetWrapper instanceof $ ? fieldSetWrapper : $(fieldSetWrapper);
        var input = fieldSetWrapper.find('.parametermapper-input');
        var data =
        {
            rowID: fieldSetWrapper.attr("id"),
            inputID: input.attr("id"),
            parameterName: input.data('parametermapperInputParameterName'),
            boundValue: input.data('parametermapperInputBackingValue'),
            displayValue: skyward.controls.getValue(input),
        };

        return data;
    }

    var setDetailLineValue = function (data)
    {
        var rowID = data.rowID;
        var inputID = data.inputID;
        var boundValue = data.boundValue;
        var displayValue = data.displayValue;

        var control;
        if (inputID !== undefined)
        {
            control = $('#' + inputID);
        }
        else if (rowID !== undefined)
        {
            control = $('#' + rowID).find('.parameter-mapper-input');
        }

        if (control)
        {
            control.data('parametermapperInputBackingValue', boundValue);
            skyward.controls.setValue(control, displayValue);
        }
    }

    skyward.parametermapper.getValue = function (parameterMapper)
    {
        parameterMapper = parameterMapper instanceof $ ? parameterMapper : $(parameterMapper);

        var detailData = [];
        var detailWrappers = parameterMapper.find('.parametermapperdetail');
        if (detailWrappers)
        {
            detailWrappers.each(function () { detailData.push(getDetailLineValue(this)); })
        }

        var fullData =
        {
            parameterbucketid: parameterMapper.data('parameterbucketid'),
            processversionid: parameterMapper.data('processversionid'),
            workflowversionid: parameterMapper.data('workflowversionid'),
            subjecttypecode: parameterMapper.data('subjecttypecode'),
            mappings: detailData
        }

        return JSON.stringify(fullData);
    }

    skyward.parametermapper.setValue = function (jsonString)
    {
        // Parse- and iterate calling setDetailLineValue
    }

    skyward.parametermapper.addPrompt = async function ()
    {
        const button = $(this);
        const data = button.data();

        const prompt = await skyward.promptBuilder.buildPopup(data.isrequired,
            data.datatypecode,
            data.inputtype,
            data.promptguid,
            data.parameterdisplayname,
            data.schemafielduniqueid,
            data.schemaobjectuniqueid,
            data.schemamodule,
            data.schemaobject,
            data.schemafield,);
        if (prompt)
        {
            savePrompt(prompt, data, button);
        }
    }

    const savePrompt = function (prompt, data, button)
    {
        const parameterInput = $("#" + data.inputid);
        const promptsHiddenBackingData = parameterInput.parents(".skywardContentPanel").find(".prompts");
        const promptsArray = promptsHiddenBackingData.val() !== '' ? JSON.parse(promptsHiddenBackingData.val()) : [];
        if (prompt.filterJson)
        {
            prompt.filterJson = window.skyward.extensions.encodeHtml(prompt.filterJson);
        }
        promptsArray.push(prompt);
        promptsHiddenBackingData.val(JSON.stringify(promptsArray));

        setDetailLineValue({
            inputID: data.inputid,
            boundValue: "{_prompt." + prompt.promptGuid + "}",
            displayValue: prompt.displayName
        });
        skyward.modalLayer.getLayerFromElement(button).close();
        togglePromptInstructions(parameterInput.parents(".parametermapper"));
    }

    const togglePromptInstructions = function (parametermapper)
    {
        const parametermapperValueJson = skyward.parametermapper.getValue(parametermapper);
        const parameterMapperValue = JSON.parse(parametermapperValueJson);
        let hasPrompts = parameterMapperValue.mappings.some(function (parameterMapping)
        {
            const boundValue = parameterMapping.boundValue;
            return typeof (boundValue) === 'string' && boundValue.toLowerCase().startsWith('{_prompt.');
        });

        parametermapper.siblings(".promptInstructions").css("display", hasPrompts ? "block" : "none");
    }

    var shouldHideSubjectBindings = function(parameterMapperPart)
    {
        var taskElementContainer = parameterMapperPart.closest("tr");
        var hideSubjectBindings = parameterMapperPart.data().checkForSubject;
        if (hideSubjectBindings)
        {
            var atLeastOneTaskElementBeforeMe = false;
            taskElementContainer.prevAll("tr:visible").each(function ()
            {
                atLeastOneTaskElementBeforeMe = true;
                var previousTaskElementType = skyward.controls.getValue($(this).find(".cboTypeCode"));
                if (previousTaskElementType === 'S')
                {
                    hideSubjectBindings = false;
                    return false;
                }
            });

            hideSubjectBindings = atLeastOneTaskElementBeforeMe ? hideSubjectBindings : true;
        }
        return hideSubjectBindings;

    }

    skyward.parametermapper.workflowVersionChanged = function ()
    {
        var workflowVersionHidden = $(this);
        var workflowVersionValue = skyward.controls.getValue(workflowVersionHidden);
        var hiddenDataz = workflowVersionHidden.data();
        var sourceId = workflowVersionHidden.attr("id");
        var parameterMapperId = sourceId.replace(hiddenDataz.originalId, hiddenDataz.originalIdParameterMapper);
        var jqParameterMapperDiv = $("#" + parameterMapperId);
        var parameterMapperDiv = jqParameterMapperDiv[0];
        parameterMapperDiv.innerHTML = "";
        var existingValue = skyward.controls.getValue(parameterMapperDiv);
              
        var hideSubjectBindings = shouldHideSubjectBindings(workflowVersionHidden);

        $.ajax(skyward.global.virtualDir + hiddenDataz.changedArea + "/" + hiddenDataz.changedController + "/" + hiddenDataz.changedAction,
            {
                type: "POST",
                dataType: "JSON",
                data: {
                    workflowVersionId: workflowVersionValue,
                    targetId: parameterMapperId,
                    parameterMapperId: existingValue,
                    originalParameterMapperId: hiddenDataz.originalIdParameterMapper,
                    hideSubjectBindings: hideSubjectBindings,
                    processVersionID: hiddenDataz.processversionid,
                    processVersionIDToEdit: hiddenDataz.processversionidtoedit,
                    processVersionIDToClone: hiddenDataz.processversionidtoclone
                },
                success: async function (data)
                {
                    if (data.success)
                    {
                        var targetId = "#" + data.controlKey;
                        var targetDiv = $(targetId)[0];
                        const processedHtml = await skyward.global.processViewPartHtml(data.innerHtml);
                        targetDiv.innerHTML = processedHtml;
                        $(targetDiv).data('workflowversionid', data.workflowVersionId);
                        skyward.window.notifyDOMLoad(targetId);
                    }
                    else
                    {
                        skyward.modalLayer.showErrorDialog("Failed to update WorkflowVersionID", data.errorMessage);
                    }
                }
            });
    };

    skyward.parametermapper.selectParameter = function (button)
    {
        var jqButton = $(button);
        var data = jqButton.data();
        var parameterName = data.parametername;
        var workflowVersionID = data.workflowversionid;
        var hideSubjectBindings = data.subjecttypecode ? shouldHideSubjectBindings(jqButton) : true;
        var subjectTypeCode = hideSubjectBindings ? '' : data.subjecttypecode;
        var inputForResult = jqButton.parent().children(".parametermapper-input");
        var idOfInputForResult = inputForResult.attr("id");
        var buildPopup = function ()
        {
            return $.ajax(
                {
                    url: skyward.global.virtualDir + 'Workflow/ParameterMapping/SelectParameterDialog',
                    id: 'SelectParameterDialog',
                    type: 'POST',
                    dataType: 'HTML',
                    data:
                    {
                        parameterName: parameterName,
                        inputId: idOfInputForResult,
                        workflowVersionID: workflowVersionID,
                        subjectTypeCode: subjectTypeCode,
                        processVersionID: data.processversionid,
                        processVersionIDToClone: data.processversionidtoclone,
                        processVersionIDToEdit: data.processversionidtoedit,
                        optional: data.optional,
                        unsavedPrompts: jqButton.parents(".skywardContentPanel").find(".prompts").val(),
                    }
                });
        };
        skyward.modalLayer.showDialog("Select a Parameter Value", buildPopup, [close]);
    };

    skyward.parametermapper.clearParameter = function (button)
    {
        var inputForResult = $(button).parent().children(".parametermapper-input");
        var idOfInputForResult = inputForResult.attr("id");

        setDetailLineValue({
            inputID: idOfInputForResult,
            boundValue: "",
            displayValue: ""
        });
    };

    skyward.parametermapper.boundValue = function (button)
    {
        var data = $(button).data();

        setDetailLineValue({
            inputID: data.inputid,
            boundValue: data.binding,
            displayValue: data.friendlyname
        })
        skyward.modalLayer.getLayerFromElement($(button)).close();
        togglePromptInstructions($("#" + data.inputid).parents(".parametermapper"));
    };

    skyward.parametermapper.specificValue = function (button)
    {
        var data = $(button).data();
        var parameterName = data.parametername;
        var workflowVersionID = data.workflowversionid;

        var buildPopup = function ()
        {
            return $.ajax(
                {
                    url: skyward.global.virtualDir + 'Workflow/ParameterMapping/SpecificValueDialog',
                    id: 'SpecificValueDialog',
                    type: 'POST',
                    dataType: 'HTML',
                    data:
                    {
                        parameterName: parameterName,
                        workflowVersionID: workflowVersionID,
                    }
                });
        };
        var saveButton = {
            id: "saveButton", text: "Save", click: function ()
            {
                var control = dialog.container.find(".js-actualSpecificValue");

                setDetailLineValue(
                    {
                        inputID: data.inputid,
                        boundValue: skyward.controls.getValue(control),
                        displayValue: getSpecificValueFriendlyName(control)
                    });

                dialog.close();
                skyward.modalLayer.getLayerFromElement($(button)).close();
                togglePromptInstructions($("#" + data.inputid).parents(".parametermapper"));
            }, icon: "Save"
        };
        var cancelButton = { id: "cancelButton", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
        var dialog = skyward.modalLayer.showDialog("Enter Variable", buildPopup, [saveButton, cancelButton]);
        window.dialog = dialog;
    };

    var getSpecificValueFriendlyName = function (control)
    {
        if (control.is('.codeEELValue'))
        {
            var description = control.parent().find('.codeEELDescription').val();
            if (description !== undefined && description !== "")
            {
                return description;
            }
            var code = control.parent().find('.codeEELCode').val();
            if (code !== undefined && code !== "")
            {
                return code;
            }
            return null;
        }
        if (control.is('.comboBoxSet'))
        {
            var text = control.find(":selected").text();
            if (text !== undefined)
            {
                return text;
            }
            return null;
        }
        if (control.is('.tileViewEEL'))
        {
            var text = control.find(".tileViewEEL_search").val()
            if (text !== undefined)
            {
                return text;
            }
            return null;
        }

        if (control.is(".checkbox"))
        {
            return control.is(":checked") ? "True" : "False";
        }

        if (control.is("sky-datepicker,.datePicker"))
        {
            const date = skyward.controls.getValue(control);
            return date.toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: '2-digit'
            });
        }

        return skyward.extensions.decodeHtml(skyward.controls.getValue(control));
    }

    skyward.window.registerLoadDOMCallback(initParameterMappers);
    return {
        addPrompt : skyward.parametermapper.addPrompt
    };
});;
/// <reference path="skyward.ui.modallayer.js" />
(
    function (skyward, $, undefined) {
        "use strict";
        skyward.securityrolecloneapproval = skyward.securityrolecloneapproval || {};

        skyward.securityrolecloneapproval.detailsGetConsentForSecurityRoleClone = function (cloneroleid, securityHash) {
            makeAjaxCall("Security/SecurityRoleCloneApproval/GetConsentForSecurityRoleClone", cloneroleid, securityHash)
        };

        skyward.securityrolecloneapproval.getConsentForSecurityRoleClone = function () {
            var buttonData = $(this).data();
            makeAjaxCall("Security/SecurityRoleCloneApproval/GetConsentForSecurityRoleClone", buttonData.cloneroleid, buttonData.cloneroleid_securityhash);
        };

        var consentAndRedirect = function () {
            var buttonData = $(this).data();
            makeAjaxCall("Security/SecurityRoleCloneApproval/ApproveAndRedirect", buttonData.cloneRoleID, buttonData.securityHash, buttonData.redirectAction);
        };

        var makeAjaxCall = function (url, roleID, securityHash, redirectAction) {
            var postData =
            {
                cloneRoleID: roleID,
                securityHash: securityHash,
                redirectAction: redirectAction
            };

            $.ajax({
                url: skyward.global.virtualDir + url,
                type: "POST",
                dataType: "JSON",
                data: postData,
                success: function (data) {
                    handleAjaxResponse(data, roleID, securityHash);
                }
            });
        };

        var handleAjaxResponse = function (data, roleID, securityHash) {
            if (data.requiresApproval) {
                var consentButton =
                {
                    text: "I Consent", click: consentAndRedirect, icon: "Check",
                    data:
                    {
                        "cloneRoleID": roleID,
                        "redirectAction": data.redirectAction,
                        "securityHash": securityHash
                    }
                };
                var cancelButton = { text: "Cancel", click: "close", icon: "Cancel" };
                skyward.modalLayer.showCriticalDialog("SECURITY ROLE CLONE AGREEMENT", data.html, [consentButton, cancelButton], { width: 600, automationID: "securityroleclone-consent-dialog" });
            }
            else {
                skyward.window.checkLoadContent('popup', 'Workflow', 'WorkflowInstance', 'Create/Security/Role/Clone', null, data.workflowData, null, null, null, false, null, null, null);
                }
        };

        var events =
        {
            'getConsentForSecurityRoleClone': skyward.securityrolecloneapproval.getConsentForSecurityRoleClone,
        };

        skyward.events.registerEvents('securityrolecloneapproval', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);;
skyward.base.registerScript("studentonlineassignment", function (skyward, $) {

    function studentTimerInit() {
        var selector = $(this);
        const timerData = {};
        var assignmentTimerInterval;
        var dynamicNavigator = getDynamicNavigator(selector);

        var data = selector.data();
        timerData.StudentAssignmentID = data.studentassignmentid;
        timerData.StudentAssignmentIDHash = data.studentassignmentidhash;
        timerData.InProgress = data.inprogress != "False";
        timerData.DisplayingRedBanner = dynamicNavigator.find('.cmaMessageArea').hasClass('cmaErrorMessage');

        if (dynamicNavigator.length > 0) {
            dynamicNavigator.on('dynamicNavigatorButtonClick', '.dynamicNavigatorStepButton', checkSetTimer);

            var cmaMessageArea = dynamicNavigator.find('.cmaMessageArea');
            setTimerStyles.apply(cmaMessageArea);

            if (timerData.InProgress)
            {
                checkAssignmentEndTime();
            }
            else
            {
                // If displaying from instructions screen and the assignment hasn't started yet.
                cmaMessageArea.addClass('cmaWarningMessage');
            }
        }

        function checkSetTimer()
        {
            if (timerData.InProgress !== true)
            {
                startTimer.apply($(this));
            }
            
            checkAssignmentEndTime();
            
        };

        function startTimer()
        {
            var selector = $(this);
            var dynamicNavigator = getDynamicNavigator(selector);

            if (dynamicNavigator.length > 0)
            {
                var timerElement = dynamicNavigator.find('.js-studentAssignmentTimer').first();

                setTimerStatus(timerElement, true);
            }
        }

        var setTimerStatus = function (timerElement, inProgress)
        {
            timerElement.data('inprogress', inProgress);
            timerData.InProgress = inProgress
        }

        function checkAssignmentEndTime() {
           
            let studentAssignmentID = timerData.StudentAssignmentID;
            if (studentAssignmentID != null) {
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/StudentQuestion/GetStudentAssignmentEndTime",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        studentAssignmentID: studentAssignmentID,
                        studentAssignmentIDHash: timerData.StudentAssignmentIDHash
                    },
                    success: function (data) {
                        if (data.endTime) {
                            var endTime = new Date(data.endTime);

                            if (endTime <= skyward.time.now()) {
                                clearInterval(assignmentTimerInterval);
                                handleTimerExpiration();
                            }
                            else {
                                clearInterval(assignmentTimerInterval); // Needs to be cleared since we'll hit this everytime a question loads when stepping through the navigator.
                                updateAssignmentTimer(endTime);
                                assignmentTimerInterval = setInterval(updateAssignmentTimer, 1000, endTime, studentAssignmentID)
                            }
                        }
                    }
                });
            }
        };

        function updateAssignmentTimer(endTime) {
            var currentTime = skyward.time.now();
            const timeDefault = '00';
            const timeRemainingToStartShowingRedBanner = 301000; // in ms
            var hours = timeDefault;
            var minutes = timeDefault;
            var seconds = timeDefault;

            var timeRemaining = endTime - currentTime;
            if (!isNaN(timeRemaining) && timeRemaining >= 0) {
                var hours = getFormattedNumberForTime(Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
                var minutes = getFormattedNumberForTime(Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60)));
                var seconds = getFormattedNumberForTime(Math.floor((timeRemaining % (1000 * 60)) / 1000));
            }

            if (timeRemaining <= 0 || isNaN(timeRemaining)) {
                clearInterval(assignmentTimerInterval);
                handleTimerExpiration();
            }

            if (!timerData.DisplayingRedBanner && timeRemaining > 0 && timeRemaining < timeRemainingToStartShowingRedBanner)
            {
                setRedBannerOnTimer();
                clearInterval(assignmentTimerInterval);
                checkAssignmentEndTime();
            }

            $('.dynamicNavigatorWrapper').find('.cmaMessageText').text('Time Remaining: ' + hours + ':' + minutes + ':' + seconds);
        };

        function getFormattedNumberForTime (num) {
            return num.toLocaleString('en-US', { minimumIntegerDigits: 2 });
        }

        function handleTimerExpiration() {

            let data = getQuestionValues();
            data.studentAssignmentID = timerData.StudentAssignmentID;
            data.studentAssignmentIDHash = timerData.StudentAssignmentIDHash;

            var studentQuestionWrapper = dynamicNavigator.find('.QuestionDisplayableWrapper').first();
            data.studentQuestionID = studentQuestionWrapper.data('student-question-id');
            data.studentQuestionIDHash = studentQuestionWrapper.data('student-question-id-hash');

            $.ajax({
                url: skyward.global.virtualDir + "Gradebook/StudentQuestion/TimedStudentAssignmentExpired",
                type: "POST",
                dataType: "JSON",
                data: data
            }).always(function () {
                skyward.changeTracking.clearDirtyList();
                skyward.window.loadContent("full", "Gradebook", "StudentQuestion", "TimedStudentAssignmentExpiredRedirect", data.studentAssignmentID);
            });
        }

        function setTimerStyles() {
            var selector = $(this);
            selector.off(); // prevent popup
            selector.removeClass('pointer');
            selector.children().removeClass('pointer'); // remove mouse hover style
        }

        function setRedBannerOnTimer()
        {
            var cmaMessageArea = dynamicNavigator.find('.cmaMessageArea');
            cmaMessageArea.removeClass('cmaWarningMessage');
            cmaMessageArea.addClass('cmaErrorMessage');
            timerData.DisplayingRedBanner = true;
        }

        function getQuestionValues() {
            var values = {};

            dynamicNavigator.find("[name]").not(".doNotPost").each(function () {
                var field = $(this);

                var name = field.attr("name");

                if (name == "") {
                    return;
                }
                var value = skyward.controls.getValue(field);
                values[name] = (typeof value == "object") ? JSON.stringify(value) : value;
            });

            return values;
        }
    };

 
    function getDynamicNavigator(selector) {
        return $(selector).parents('.js-studentAssignmentNavigator').first();
    }

    var events =
    {
        "studentTimerInit": studentTimerInit
    };

    return events;
});;
skyward.base.registerScript('timeoff', function (skyward, $)
{
    skyward.timeoff = skyward.timeoff || {};

    //Changes here need to be replicated in Skyward.Business.TimeOff.ConfigDistrict as well.
    const resetWaitingMessage = function ()
    {
        skyward.messagecenter.resetTemplate(
            this,
            'Time Off Request for {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.Assignment.Employee.FullNameFML}',
            '{User.Name.FirstName},\n\nTime off transaction request {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.EmployeeTimeOffType.TimeOffType.Code} for {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.Assignment.Employee.FullNameFML} is waiting for your approval.\n\nName: {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.Assignment.Employee.FullNameFML}\nPosition: {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.Assignment.Position.PositionType.Code}\nAssignment(s): {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.Assignment.Position.PositionDistributionsAssignmentTypeCodes}\nBuilding(s): {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.Assignment.Position.PositionDistributionsBuildingCodes}\nHours Per Day: {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.FormattedSecondsPerDay}\nHours Requested: {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.FormattedTransactionSeconds}\nDays Requested: {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.ForEntryTransactionDays}\nTime Off Type: {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.EmployeeTimeOffType.TimeOffType.Code}\nDate: {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.StartDate}\nDescription: {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.Description}');
    };

    //Changes here need to be replicated in Skyward.Business.TimeOff.ConfigDistrict as well.
    const resetDeletedMessage = function ()
    {
        skyward.messagecenter.resetTemplate(
            this,
            'Time Off Request Deleted for {TimeOffTransaction.Assignment.Employee.FullNameFML}',
            '{Approver.Name.FirstName},\n\nTime off transaction request {TimeOffTransaction.EmployeeTimeOffType.TimeOffType.Code} for {TimeOffTransaction.Assignment.Employee.FullNameFML} has been deleted.\n\nName: {TimeOffTransaction.Assignment.Employee.FullNameFML}\nPosition: {TimeOffTransaction.Assignment.Position.PositionType.Code}\nAssignment(s): {TimeOffTransaction.Assignment.Position.PositionDistributionsAssignmentTypeCodes}\nBuilding(s): {TimeOffTransaction.Assignment.Position.PositionDistributionsBuildingCodes}\nHours Per Day: {TimeOffTransaction.FormattedSecondsPerDay}\nHours Requested: {TimeOffTransaction.FormattedTransactionSeconds}\nDays Requested: {TimeOffTransaction.ForEntryTransactionDays}\nTime Off Type: {TimeOffTransaction.EmployeeTimeOffType.TimeOffType.Code}\nDate: {TimeOffTransaction.StartDate}\nDescription: {TimeOffTransaction.Description}');
    };

    //Changes here need to be replicated in Skyward.Business.TimeOff.ConfigDistrict as well.
    const resetApprovedMessage = function ()
    {
        skyward.messagecenter.resetTemplate(
            this,
            'Your Time Off Transaction Request Has Been Approved',
            '{TimeOffTransaction.Assignment.Employee.Name.FirstName},\n\nYour time off transaction request {TimeOffTransaction.EmployeeTimeOffType.TimeOffType.Code} has been approved by {Approver.Name.FullNameFML}.\n\nName: {TimeOffTransaction.Assignment.Employee.FullNameFML}\nPosition: {TimeOffTransaction.Assignment.Position.PositionType.Code}\nAssignment(s): {TimeOffTransaction.Assignment.Position.PositionDistributionsAssignmentTypeCodes}\nBuilding(s): {TimeOffTransaction.Assignment.Position.PositionDistributionsBuildingCodes}\nHours Per Day: {TimeOffTransaction.FormattedSecondsPerDay}\nHours Requested: {TimeOffTransaction.FormattedTransactionSeconds}\nDays Requested: {TimeOffTransaction.ForEntryTransactionDays}\nTime Off Type: {TimeOffTransaction.EmployeeTimeOffType.TimeOffType.Code}\nDate: {TimeOffTransaction.StartDate}\nDescription: {TimeOffTransaction.Description}');
    };

    //Changes here need to be replicated in Skyward.Business.TimeOff.ConfigDistrict as well.
    const resetDeniedMessage = function ()
    {
        skyward.messagecenter.resetTemplate(
            this,
            'Your Time Off Transaction Request Has Been Denied',
            '{TimeOffTransaction.Assignment.Employee.Name.FirstName},\n\nYour time off transaction request {TimeOffTransaction.EmployeeTimeOffType.TimeOffType.Code} has been denied by {Approver.Name.FullNameFML}. {Comment}.\n\nName: {TimeOffTransaction.Assignment.Employee.FullNameFML}\nPosition: {TimeOffTransaction.Assignment.Position.PositionType.Code}\nAssignment(s): {TimeOffTransaction.Assignment.Position.PositionDistributionsAssignmentTypeCodes}\nBuilding(s): {TimeOffTransaction.Assignment.Position.PositionDistributionsBuildingCodes}\nHours Per Day: {TimeOffTransaction.FormattedSecondsPerDay}\nHours Requested: {TimeOffTransaction.FormattedTransactionSeconds}\nDays Requested: {TimeOffTransaction.ForEntryTransactionDays}\nTime Off Type: {TimeOffTransaction.EmployeeTimeOffType.TimeOffType.Code}\nDate: {TimeOffTransaction.StartDate}\nDescription: {TimeOffTransaction.Description}');
    };

    //Changes here need to be replicated in Skyward.Business.TimeOff.ConfigDistrict as well.
    const resetAdditionalEmployeeApprovedMessage = function ()
    {
        skyward.messagecenter.resetTemplate(
            this,
            '{TimeOffTransaction.Assignment.Employee.Name.FirstName}\'s Time Off Transaction Request Has Been Approved',
            '{TimeOffTransaction.Assignment.Employee.Name.FirstName}\'s time off transaction request {TimeOffTransaction.EmployeeTimeOffType.TimeOffType.Code} has been approved by {Approver.Name.FullNameFML}.\n\nName: {TimeOffTransaction.Assignment.Employee.FullNameFML}\nPosition: {TimeOffTransaction.Assignment.Position.PositionType.Code}\nAssignment(s): {TimeOffTransaction.Assignment.Position.PositionDistributionsAssignmentTypeCodes}\nBuilding(s): {TimeOffTransaction.Assignment.Position.PositionDistributionsBuildingCodes}\nHours Per Day: {TimeOffTransaction.FormattedSecondsPerDay}\nHours Requested: {TimeOffTransaction.FormattedTransactionSeconds}\nDays Requested: {TimeOffTransaction.ForEntryTransactionDays}\nTime Off Type: {TimeOffTransaction.EmployeeTimeOffType.TimeOffType.Code}\nDate: {TimeOffTransaction.StartDate}\nDescription: {TimeOffTransaction.Description}');
    };

    //Changes here need to be replicated in Skyward.Business.TimeOff.ConfigDistrict as well.
    const resetAdditionalEmployeeDeniedMessage = function ()
    {
        skyward.messagecenter.resetTemplate(
            this,
            '{TimeOffTransaction.Assignment.Employee.Name.FirstName}\'s Time Off Transaction Request Has Been Denied',
            '{TimeOffTransaction.Assignment.Employee.Name.FirstName}\'s time off transaction request {TimeOffTransaction.EmployeeTimeOffType.TimeOffType.Code} has been denied by {Approver.Name.FullNameFML}. {Comment}.\n\nName: {TimeOffTransaction.Assignment.Employee.FullNameFML}\nPosition: {TimeOffTransaction.Assignment.Position.PositionType.Code}\nAssignment(s): {TimeOffTransaction.Assignment.Position.PositionDistributionsAssignmentTypeCodes}\nBuilding(s): {TimeOffTransaction.Assignment.Position.PositionDistributionsBuildingCodes}\nHours Per Day: {TimeOffTransaction.FormattedSecondsPerDay}\nHours Requested: {TimeOffTransaction.FormattedTransactionSeconds}\nDays Requested: {TimeOffTransaction.ForEntryTransactionDays}\nTime Off Type: {TimeOffTransaction.EmployeeTimeOffType.TimeOffType.Code}\nDate: {TimeOffTransaction.StartDate}\nDescription: {TimeOffTransaction.Description}');
    };

    //Changes here need to be replicated in Skyward.Business.TimeOff.ConfigDistrict as well.
    const resetAdditionalEmployeeSubmittedMessage = function ()
    {
        skyward.messagecenter.resetTemplate(
            this,
            '{TimeOffTransaction.Assignment.Employee.Name.FirstName}\'s Time Off Transaction Request Has Been Submitted',
            '{TimeOffTransaction.Assignment.Employee.Name.FirstName}\'s time off transaction request {TimeOffTransaction.EmployeeTimeOffType.TimeOffType.Code} has been Submitted. {Comment}.\n\nName: {TimeOffTransaction.Assignment.Employee.FullNameFML}\nPosition: {TimeOffTransaction.Assignment.Position.PositionType.Code}\nAssignment(s): {TimeOffTransaction.Assignment.Position.PositionDistributionsAssignmentTypeCodes}\nBuilding(s): {TimeOffTransaction.Assignment.Position.PositionDistributionsBuildingCodes}\nHours Per Day: {TimeOffTransaction.FormattedSecondsPerDay}\nHours Requested: {TimeOffTransaction.FormattedTransactionSeconds}\nDays Requested: {TimeOffTransaction.ForEntryTransactionDays}\nTime Off Type: {TimeOffTransaction.EmployeeTimeOffType.TimeOffType.Code}\nDate: {TimeOffTransaction.StartDate}\nDescription: {TimeOffTransaction.Description}');
    };

    //Changes here need to be replicated in Skyward.Business.TimeOff.ConfigDistrict as well.
    const resetTimeOffApprovalReminderMessage = function ()
    {
        skyward.messagecenter.resetTemplate(
            this,
            'Time Off Request awaiting your Approval for {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.Assignment.Employee.FullNameFML}',
            'You have a Time Off Request for {TaskInstance.ApprovalTaskPresenter.TimeOffTransaction.Assignment.Employee.FullNameFML} that needs to be Approved or Denied.')
    };

    const events =
    {
        resetWaitingMessage,
        resetDeletedMessage,
        resetApprovedMessage,
        resetDeniedMessage,
        resetAdditionalEmployeeApprovedMessage,
        resetAdditionalEmployeeDeniedMessage,
        resetAdditionalEmployeeSubmittedMessage,
        resetTimeOffApprovalReminderMessage,
    };
    return events;
});
